import _objectSpread from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _possibleConstructorReturn from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _defineProperty from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck2 from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass2 from "/builds/wmo/data-assistant-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var _FN, _TO_LINEAR, _FROM_LINEAR;

import React, { useRef, useEffect, useContext, useCallback, useState } from 'react';
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
}
/** @deprecated */


function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
}
/**
 * @license
 * Copyright 2010-2022 Three.js Authors
 * SPDX-License-Identifier: MIT
 */


var REVISION = '140';
var MOUSE = {
  LEFT: 0,
  MIDDLE: 1,
  RIGHT: 2,
  ROTATE: 0,
  DOLLY: 1,
  PAN: 2
};
var TOUCH = {
  ROTATE: 0,
  PAN: 1,
  DOLLY_PAN: 2,
  DOLLY_ROTATE: 3
};
var CullFaceNone = 0;
var CullFaceBack = 1;
var CullFaceFront = 2;
var PCFShadowMap = 1;
var PCFSoftShadowMap = 2;
var VSMShadowMap = 3;
var FrontSide = 0;
var BackSide = 1;
var DoubleSide = 2;
var FlatShading = 1;
var NoBlending = 0;
var NormalBlending = 1;
var AdditiveBlending = 2;
var SubtractiveBlending = 3;
var MultiplyBlending = 4;
var CustomBlending = 5;
var AddEquation = 100;
var SubtractEquation = 101;
var ReverseSubtractEquation = 102;
var MinEquation = 103;
var MaxEquation = 104;
var ZeroFactor = 200;
var OneFactor = 201;
var SrcColorFactor = 202;
var OneMinusSrcColorFactor = 203;
var SrcAlphaFactor = 204;
var OneMinusSrcAlphaFactor = 205;
var DstAlphaFactor = 206;
var OneMinusDstAlphaFactor = 207;
var DstColorFactor = 208;
var OneMinusDstColorFactor = 209;
var SrcAlphaSaturateFactor = 210;
var NeverDepth = 0;
var AlwaysDepth = 1;
var LessDepth = 2;
var LessEqualDepth = 3;
var EqualDepth = 4;
var GreaterEqualDepth = 5;
var GreaterDepth = 6;
var NotEqualDepth = 7;
var MultiplyOperation = 0;
var MixOperation = 1;
var AddOperation = 2;
var NoToneMapping = 0;
var LinearToneMapping = 1;
var ReinhardToneMapping = 2;
var CineonToneMapping = 3;
var ACESFilmicToneMapping = 4;
var CustomToneMapping = 5;
var UVMapping = 300;
var CubeReflectionMapping = 301;
var CubeRefractionMapping = 302;
var EquirectangularReflectionMapping = 303;
var EquirectangularRefractionMapping = 304;
var CubeUVReflectionMapping = 306;
var RepeatWrapping = 1000;
var ClampToEdgeWrapping = 1001;
var MirroredRepeatWrapping = 1002;
var NearestFilter = 1003;
var NearestMipmapNearestFilter = 1004;
var NearestMipmapLinearFilter = 1005;
var LinearFilter = 1006;
var LinearMipmapNearestFilter = 1007;
var LinearMipmapLinearFilter = 1008;
var UnsignedByteType = 1009;
var ByteType = 1010;
var ShortType = 1011;
var UnsignedShortType = 1012;
var IntType = 1013;
var UnsignedIntType = 1014;
var FloatType = 1015;
var HalfFloatType = 1016;
var UnsignedShort4444Type = 1017;
var UnsignedShort5551Type = 1018;
var UnsignedInt248Type = 1020;
var AlphaFormat = 1021;
var RGBFormat = 1022;
var RGBAFormat = 1023;
var LuminanceFormat = 1024;
var LuminanceAlphaFormat = 1025;
var DepthFormat = 1026;
var DepthStencilFormat = 1027;
var RedFormat = 1028;
var RedIntegerFormat = 1029;
var RGFormat = 1030;
var RGIntegerFormat = 1031;
var RGBAIntegerFormat = 1033;
var RGB_S3TC_DXT1_Format = 33776;
var RGBA_S3TC_DXT1_Format = 33777;
var RGBA_S3TC_DXT3_Format = 33778;
var RGBA_S3TC_DXT5_Format = 33779;
var RGB_PVRTC_4BPPV1_Format = 35840;
var RGB_PVRTC_2BPPV1_Format = 35841;
var RGBA_PVRTC_4BPPV1_Format = 35842;
var RGBA_PVRTC_2BPPV1_Format = 35843;
var RGB_ETC1_Format = 36196;
var RGB_ETC2_Format = 37492;
var RGBA_ETC2_EAC_Format = 37496;
var RGBA_ASTC_4x4_Format = 37808;
var RGBA_ASTC_5x4_Format = 37809;
var RGBA_ASTC_5x5_Format = 37810;
var RGBA_ASTC_6x5_Format = 37811;
var RGBA_ASTC_6x6_Format = 37812;
var RGBA_ASTC_8x5_Format = 37813;
var RGBA_ASTC_8x6_Format = 37814;
var RGBA_ASTC_8x8_Format = 37815;
var RGBA_ASTC_10x5_Format = 37816;
var RGBA_ASTC_10x6_Format = 37817;
var RGBA_ASTC_10x8_Format = 37818;
var RGBA_ASTC_10x10_Format = 37819;
var RGBA_ASTC_12x10_Format = 37820;
var RGBA_ASTC_12x12_Format = 37821;
var RGBA_BPTC_Format = 36492;
var TrianglesDrawMode = 0;
var LinearEncoding = 3000;
var sRGBEncoding = 3001;
var BasicDepthPacking = 3200;
var RGBADepthPacking = 3201;
var TangentSpaceNormalMap = 0;
var ObjectSpaceNormalMap = 1;
var SRGBColorSpace = 'srgb';
var LinearSRGBColorSpace = 'srgb-linear';
var KeepStencilOp = 7680;
var AlwaysStencilFunc = 519;
var StaticDrawUsage = 35044;
var DynamicDrawUsage = 35048;
var GLSL3 = '300 es';
var _SRGBAFormat = 1035; // fallback for WebGL 1

/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */

var EventDispatcher = /*#__PURE__*/function () {
  function EventDispatcher() {
    _classCallCheck2(this, EventDispatcher);
  }

  _createClass2(EventDispatcher, [{
    key: "addEventListener",
    value: function addEventListener(type, listener) {
      if (this._listeners === undefined) this._listeners = {};
      var listeners = this._listeners;

      if (listeners[type] === undefined) {
        listeners[type] = [];
      }

      if (listeners[type].indexOf(listener) === -1) {
        listeners[type].push(listener);
      }
    }
  }, {
    key: "hasEventListener",
    value: function hasEventListener(type, listener) {
      if (this._listeners === undefined) return false;
      var listeners = this._listeners;
      return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener) {
      if (this._listeners === undefined) return;
      var listeners = this._listeners;
      var listenerArray = listeners[type];

      if (listenerArray !== undefined) {
        var _index2 = listenerArray.indexOf(listener);

        if (_index2 !== -1) {
          listenerArray.splice(_index2, 1);
        }
      }
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      if (this._listeners === undefined) return;
      var listeners = this._listeners;
      var listenerArray = listeners[event.type];

      if (listenerArray !== undefined) {
        event.target = this; // Make a copy, in case listeners are removed while iterating.

        var array = listenerArray.slice(0);

        for (var i = 0, l = array.length; i < l; i++) {
          array[i].call(this, event);
        }

        event.target = null;
      }
    }
  }]);

  return EventDispatcher;
}();

var _lut = [];

for (var i = 0; i < 256; i++) {
  _lut[i] = (i < 16 ? '0' : '') + i.toString(16);
}

var _seed = 1234567;
var DEG2RAD = Math.PI / 180;
var RAD2DEG = 180 / Math.PI; // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136

function generateUUID() {
  var d0 = Math.random() * 0xffffffff | 0;
  var d1 = Math.random() * 0xffffffff | 0;
  var d2 = Math.random() * 0xffffffff | 0;
  var d3 = Math.random() * 0xffffffff | 0;
  var uuid = _lut[d0 & 0xff] + _lut[d0 >> 8 & 0xff] + _lut[d0 >> 16 & 0xff] + _lut[d0 >> 24 & 0xff] + '-' + _lut[d1 & 0xff] + _lut[d1 >> 8 & 0xff] + '-' + _lut[d1 >> 16 & 0x0f | 0x40] + _lut[d1 >> 24 & 0xff] + '-' + _lut[d2 & 0x3f | 0x80] + _lut[d2 >> 8 & 0xff] + '-' + _lut[d2 >> 16 & 0xff] + _lut[d2 >> 24 & 0xff] + _lut[d3 & 0xff] + _lut[d3 >> 8 & 0xff] + _lut[d3 >> 16 & 0xff] + _lut[d3 >> 24 & 0xff]; // .toLowerCase() here flattens concatenated strings to save heap memory space.

  return uuid.toLowerCase();
}

function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
} // compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation


function euclideanModulo(n, m) {
  return (n % m + m) % m;
} // Linear mapping from range <a1, a2> to range <b1, b2>


function mapLinear(x, a1, a2, b1, b2) {
  return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
} // https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/


function inverseLerp(x, y, value) {
  if (x !== y) {
    return (value - x) / (y - x);
  } else {
    return 0;
  }
} // https://en.wikipedia.org/wiki/Linear_interpolation


function lerp(x, y, t) {
  return (1 - t) * x + t * y;
} // http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/


function damp(x, y, lambda, dt) {
  return lerp(x, y, 1 - Math.exp(-lambda * dt));
} // https://www.desmos.com/calculator/vcsjnyz7x4


function pingpong(x) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return length - Math.abs(euclideanModulo(x, length * 2) - length);
} // http://en.wikipedia.org/wiki/Smoothstep


function smoothstep(x, min, max) {
  if (x <= min) return 0;
  if (x >= max) return 1;
  x = (x - min) / (max - min);
  return x * x * (3 - 2 * x);
}

function smootherstep(x, min, max) {
  if (x <= min) return 0;
  if (x >= max) return 1;
  x = (x - min) / (max - min);
  return x * x * x * (x * (x * 6 - 15) + 10);
} // Random integer from <low, high> interval


function randInt(low, high) {
  return low + Math.floor(Math.random() * (high - low + 1));
} // Random float from <low, high> interval


function randFloat(low, high) {
  return low + Math.random() * (high - low);
} // Random float from <-range/2, range/2> interval


function randFloatSpread(range) {
  return range * (0.5 - Math.random());
} // Deterministic pseudo-random float in the interval [ 0, 1 ]


function seededRandom(s) {
  if (s !== undefined) _seed = s; // Mulberry32 generator

  var t = _seed += 0x6D2B79F5;
  t = Math.imul(t ^ t >>> 15, t | 1);
  t ^= t + Math.imul(t ^ t >>> 7, t | 61);
  return ((t ^ t >>> 14) >>> 0) / 4294967296;
}

function degToRad(degrees) {
  return degrees * DEG2RAD;
}

function radToDeg(radians) {
  return radians * RAD2DEG;
}

function isPowerOfTwo(value) {
  return (value & value - 1) === 0 && value !== 0;
}

function ceilPowerOfTwo(value) {
  return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}

function floorPowerOfTwo(value) {
  return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}

function setQuaternionFromProperEuler(q, a, b, c, order) {
  // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
  // rotations are applied to the axes in the order specified by 'order'
  // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
  // angles are in radians
  var cos = Math.cos;
  var sin = Math.sin;
  var c2 = cos(b / 2);
  var s2 = sin(b / 2);
  var c13 = cos((a + c) / 2);
  var s13 = sin((a + c) / 2);
  var c1_3 = cos((a - c) / 2);
  var s1_3 = sin((a - c) / 2);
  var c3_1 = cos((c - a) / 2);
  var s3_1 = sin((c - a) / 2);

  switch (order) {
    case 'XYX':
      q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
      break;

    case 'YZY':
      q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
      break;

    case 'ZXZ':
      q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
      break;

    case 'XZX':
      q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
      break;

    case 'YXY':
      q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
      break;

    case 'ZYZ':
      q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
      break;

    default:
      console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
  }
}

function denormalize$1(value, array) {
  switch (array.constructor) {
    case Float32Array:
      return value;

    case Uint16Array:
      return value / 65535.0;

    case Uint8Array:
      return value / 255.0;

    case Int16Array:
      return Math.max(value / 32767.0, -1.0);

    case Int8Array:
      return Math.max(value / 127.0, -1.0);

    default:
      throw new Error('Invalid component type.');
  }
}

function normalize(value, array) {
  switch (array.constructor) {
    case Float32Array:
      return value;

    case Uint16Array:
      return Math.round(value * 65535.0);

    case Uint8Array:
      return Math.round(value * 255.0);

    case Int16Array:
      return Math.round(value * 32767.0);

    case Int8Array:
      return Math.round(value * 127.0);

    default:
      throw new Error('Invalid component type.');
  }
}

var MathUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DEG2RAD: DEG2RAD,
  RAD2DEG: RAD2DEG,
  generateUUID: generateUUID,
  clamp: clamp,
  euclideanModulo: euclideanModulo,
  mapLinear: mapLinear,
  inverseLerp: inverseLerp,
  lerp: lerp,
  damp: damp,
  pingpong: pingpong,
  smoothstep: smoothstep,
  smootherstep: smootherstep,
  randInt: randInt,
  randFloat: randFloat,
  randFloatSpread: randFloatSpread,
  seededRandom: seededRandom,
  degToRad: degToRad,
  radToDeg: radToDeg,
  isPowerOfTwo: isPowerOfTwo,
  ceilPowerOfTwo: ceilPowerOfTwo,
  floorPowerOfTwo: floorPowerOfTwo,
  setQuaternionFromProperEuler: setQuaternionFromProperEuler,
  normalize: normalize,
  denormalize: denormalize$1
});

var Vector2 = /*#__PURE__*/function (_Symbol$iterator) {
  function Vector2() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck2(this, Vector2);

    this.x = x;
    this.y = y;
  }

  _createClass2(Vector2, [{
    key: "width",
    get: function get() {
      return this.x;
    },
    set: function set(value) {
      this.x = value;
    }
  }, {
    key: "height",
    get: function get() {
      return this.y;
    },
    set: function set(value) {
      this.y = value;
    }
  }, {
    key: "set",
    value: function set(x, y) {
      this.x = x;
      this.y = y;
      return this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(scalar) {
      this.x = scalar;
      this.y = scalar;
      return this;
    }
  }, {
    key: "setX",
    value: function setX(x) {
      this.x = x;
      return this;
    }
  }, {
    key: "setY",
    value: function setY(y) {
      this.y = y;
      return this;
    }
  }, {
    key: "setComponent",
    value: function setComponent(index, value) {
      switch (index) {
        case 0:
          this.x = value;
          break;

        case 1:
          this.y = value;
          break;

        default:
          throw new Error('index is out of range: ' + index);
      }

      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(index) {
      switch (index) {
        case 0:
          return this.x;

        case 1:
          return this.y;

        default:
          throw new Error('index is out of range: ' + index);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.x, this.y);
    }
  }, {
    key: "copy",
    value: function copy(v) {
      this.x = v.x;
      this.y = v.y;
      return this;
    }
  }, {
    key: "add",
    value: function add(v, w) {
      if (w !== undefined) {
        console.warn('THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
        return this.addVectors(v, w);
      }

      this.x += v.x;
      this.y += v.y;
      return this;
    }
  }, {
    key: "addScalar",
    value: function addScalar(s) {
      this.x += s;
      this.y += s;
      return this;
    }
  }, {
    key: "addVectors",
    value: function addVectors(a, b) {
      this.x = a.x + b.x;
      this.y = a.y + b.y;
      return this;
    }
  }, {
    key: "addScaledVector",
    value: function addScaledVector(v, s) {
      this.x += v.x * s;
      this.y += v.y * s;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(v, w) {
      if (w !== undefined) {
        console.warn('THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
        return this.subVectors(v, w);
      }

      this.x -= v.x;
      this.y -= v.y;
      return this;
    }
  }, {
    key: "subScalar",
    value: function subScalar(s) {
      this.x -= s;
      this.y -= s;
      return this;
    }
  }, {
    key: "subVectors",
    value: function subVectors(a, b) {
      this.x = a.x - b.x;
      this.y = a.y - b.y;
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(v) {
      this.x *= v.x;
      this.y *= v.y;
      return this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(scalar) {
      this.x *= scalar;
      this.y *= scalar;
      return this;
    }
  }, {
    key: "divide",
    value: function divide(v) {
      this.x /= v.x;
      this.y /= v.y;
      return this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(scalar) {
      return this.multiplyScalar(1 / scalar);
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(m) {
      var x = this.x,
          y = this.y;
      var e = m.elements;
      this.x = e[0] * x + e[3] * y + e[6];
      this.y = e[1] * x + e[4] * y + e[7];
      return this;
    }
  }, {
    key: "min",
    value: function min(v) {
      this.x = Math.min(this.x, v.x);
      this.y = Math.min(this.y, v.y);
      return this;
    }
  }, {
    key: "max",
    value: function max(v) {
      this.x = Math.max(this.x, v.x);
      this.y = Math.max(this.y, v.y);
      return this;
    }
  }, {
    key: "clamp",
    value: function clamp(min, max) {
      // assumes min < max, componentwise
      this.x = Math.max(min.x, Math.min(max.x, this.x));
      this.y = Math.max(min.y, Math.min(max.y, this.y));
      return this;
    }
  }, {
    key: "clampScalar",
    value: function clampScalar(minVal, maxVal) {
      this.x = Math.max(minVal, Math.min(maxVal, this.x));
      this.y = Math.max(minVal, Math.min(maxVal, this.y));
      return this;
    }
  }, {
    key: "clampLength",
    value: function clampLength(min, max) {
      var length = this.length();
      return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
  }, {
    key: "floor",
    value: function floor() {
      this.x = Math.floor(this.x);
      this.y = Math.floor(this.y);
      return this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      this.x = Math.ceil(this.x);
      this.y = Math.ceil(this.y);
      return this;
    }
  }, {
    key: "round",
    value: function round() {
      this.x = Math.round(this.x);
      this.y = Math.round(this.y);
      return this;
    }
  }, {
    key: "roundToZero",
    value: function roundToZero() {
      this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
      this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
      return this;
    }
  }, {
    key: "negate",
    value: function negate() {
      this.x = -this.x;
      this.y = -this.y;
      return this;
    }
  }, {
    key: "dot",
    value: function dot(v) {
      return this.x * v.x + this.y * v.y;
    }
  }, {
    key: "cross",
    value: function cross(v) {
      return this.x * v.y - this.y * v.x;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this.x * this.x + this.y * this.y;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y);
    }
  }, {
    key: "manhattanLength",
    value: function manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.divideScalar(this.length() || 1);
    }
  }, {
    key: "angle",
    value: function angle() {
      // computes the angle in radians with respect to the positive x-axis
      var angle = Math.atan2(-this.y, -this.x) + Math.PI;
      return angle;
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(v) {
      return Math.sqrt(this.distanceToSquared(v));
    }
  }, {
    key: "distanceToSquared",
    value: function distanceToSquared(v) {
      var dx = this.x - v.x,
          dy = this.y - v.y;
      return dx * dx + dy * dy;
    }
  }, {
    key: "manhattanDistanceTo",
    value: function manhattanDistanceTo(v) {
      return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
  }, {
    key: "setLength",
    value: function setLength(length) {
      return this.normalize().multiplyScalar(length);
    }
  }, {
    key: "lerp",
    value: function lerp(v, alpha) {
      this.x += (v.x - this.x) * alpha;
      this.y += (v.y - this.y) * alpha;
      return this;
    }
  }, {
    key: "lerpVectors",
    value: function lerpVectors(v1, v2, alpha) {
      this.x = v1.x + (v2.x - v1.x) * alpha;
      this.y = v1.y + (v2.y - v1.y) * alpha;
      return this;
    }
  }, {
    key: "equals",
    value: function equals(v) {
      return v.x === this.x && v.y === this.y;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.x = array[offset];
      this.y = array[offset + 1];
      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      array[offset] = this.x;
      array[offset + 1] = this.y;
      return array;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(attribute, index, offset) {
      if (offset !== undefined) {
        console.warn('THREE.Vector2: offset has been removed from .fromBufferAttribute().');
      }

      this.x = attribute.getX(index);
      this.y = attribute.getY(index);
      return this;
    }
  }, {
    key: "rotateAround",
    value: function rotateAround(center, angle) {
      var c = Math.cos(angle),
          s = Math.sin(angle);
      var x = this.x - center.x;
      var y = this.y - center.y;
      this.x = x * c - y * s + center.x;
      this.y = x * s + y * c + center.y;
      return this;
    }
  }, {
    key: "random",
    value: function random() {
      this.x = Math.random();
      this.y = Math.random();
      return this;
    }
  }, {
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.x;

            case 2:
              _context2.next = 4;
              return this.y;

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Vector2;
}(Symbol.iterator);

Vector2.prototype.isVector2 = true;

var Matrix3 = /*#__PURE__*/function () {
  function Matrix3() {
    _classCallCheck2(this, Matrix3);

    this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1];

    if (arguments.length > 0) {
      console.error('THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.');
    }
  }

  _createClass2(Matrix3, [{
    key: "set",
    value: function set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
      var te = this.elements;
      te[0] = n11;
      te[1] = n21;
      te[2] = n31;
      te[3] = n12;
      te[4] = n22;
      te[5] = n32;
      te[6] = n13;
      te[7] = n23;
      te[8] = n33;
      return this;
    }
  }, {
    key: "identity",
    value: function identity() {
      this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(m) {
      var te = this.elements;
      var me = m.elements;
      te[0] = me[0];
      te[1] = me[1];
      te[2] = me[2];
      te[3] = me[3];
      te[4] = me[4];
      te[5] = me[5];
      te[6] = me[6];
      te[7] = me[7];
      te[8] = me[8];
      return this;
    }
  }, {
    key: "extractBasis",
    value: function extractBasis(xAxis, yAxis, zAxis) {
      xAxis.setFromMatrix3Column(this, 0);
      yAxis.setFromMatrix3Column(this, 1);
      zAxis.setFromMatrix3Column(this, 2);
      return this;
    }
  }, {
    key: "setFromMatrix4",
    value: function setFromMatrix4(m) {
      var me = m.elements;
      this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(m) {
      return this.multiplyMatrices(this, m);
    }
  }, {
    key: "premultiply",
    value: function premultiply(m) {
      return this.multiplyMatrices(m, this);
    }
  }, {
    key: "multiplyMatrices",
    value: function multiplyMatrices(a, b) {
      var ae = a.elements;
      var be = b.elements;
      var te = this.elements;
      var a11 = ae[0],
          a12 = ae[3],
          a13 = ae[6];
      var a21 = ae[1],
          a22 = ae[4],
          a23 = ae[7];
      var a31 = ae[2],
          a32 = ae[5],
          a33 = ae[8];
      var b11 = be[0],
          b12 = be[3],
          b13 = be[6];
      var b21 = be[1],
          b22 = be[4],
          b23 = be[7];
      var b31 = be[2],
          b32 = be[5],
          b33 = be[8];
      te[0] = a11 * b11 + a12 * b21 + a13 * b31;
      te[3] = a11 * b12 + a12 * b22 + a13 * b32;
      te[6] = a11 * b13 + a12 * b23 + a13 * b33;
      te[1] = a21 * b11 + a22 * b21 + a23 * b31;
      te[4] = a21 * b12 + a22 * b22 + a23 * b32;
      te[7] = a21 * b13 + a22 * b23 + a23 * b33;
      te[2] = a31 * b11 + a32 * b21 + a33 * b31;
      te[5] = a31 * b12 + a32 * b22 + a33 * b32;
      te[8] = a31 * b13 + a32 * b23 + a33 * b33;
      return this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(s) {
      var te = this.elements;
      te[0] *= s;
      te[3] *= s;
      te[6] *= s;
      te[1] *= s;
      te[4] *= s;
      te[7] *= s;
      te[2] *= s;
      te[5] *= s;
      te[8] *= s;
      return this;
    }
  }, {
    key: "determinant",
    value: function determinant() {
      var te = this.elements;
      var a = te[0],
          b = te[1],
          c = te[2],
          d = te[3],
          e = te[4],
          f = te[5],
          g = te[6],
          h = te[7],
          i = te[8];
      return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
  }, {
    key: "invert",
    value: function invert() {
      var te = this.elements,
          n11 = te[0],
          n21 = te[1],
          n31 = te[2],
          n12 = te[3],
          n22 = te[4],
          n32 = te[5],
          n13 = te[6],
          n23 = te[7],
          n33 = te[8],
          t11 = n33 * n22 - n32 * n23,
          t12 = n32 * n13 - n33 * n12,
          t13 = n23 * n12 - n22 * n13,
          det = n11 * t11 + n21 * t12 + n31 * t13;
      if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
      var detInv = 1 / det;
      te[0] = t11 * detInv;
      te[1] = (n31 * n23 - n33 * n21) * detInv;
      te[2] = (n32 * n21 - n31 * n22) * detInv;
      te[3] = t12 * detInv;
      te[4] = (n33 * n11 - n31 * n13) * detInv;
      te[5] = (n31 * n12 - n32 * n11) * detInv;
      te[6] = t13 * detInv;
      te[7] = (n21 * n13 - n23 * n11) * detInv;
      te[8] = (n22 * n11 - n21 * n12) * detInv;
      return this;
    }
  }, {
    key: "transpose",
    value: function transpose() {
      var tmp;
      var m = this.elements;
      tmp = m[1];
      m[1] = m[3];
      m[3] = tmp;
      tmp = m[2];
      m[2] = m[6];
      m[6] = tmp;
      tmp = m[5];
      m[5] = m[7];
      m[7] = tmp;
      return this;
    }
  }, {
    key: "getNormalMatrix",
    value: function getNormalMatrix(matrix4) {
      return this.setFromMatrix4(matrix4).invert().transpose();
    }
  }, {
    key: "transposeIntoArray",
    value: function transposeIntoArray(r) {
      var m = this.elements;
      r[0] = m[0];
      r[1] = m[3];
      r[2] = m[6];
      r[3] = m[1];
      r[4] = m[4];
      r[5] = m[7];
      r[6] = m[2];
      r[7] = m[5];
      r[8] = m[8];
      return this;
    }
  }, {
    key: "setUvTransform",
    value: function setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
      var c = Math.cos(rotation);
      var s = Math.sin(rotation);
      this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
      return this;
    }
  }, {
    key: "scale",
    value: function scale(sx, sy) {
      var te = this.elements;
      te[0] *= sx;
      te[3] *= sx;
      te[6] *= sx;
      te[1] *= sy;
      te[4] *= sy;
      te[7] *= sy;
      return this;
    }
  }, {
    key: "rotate",
    value: function rotate(theta) {
      var c = Math.cos(theta);
      var s = Math.sin(theta);
      var te = this.elements;
      var a11 = te[0],
          a12 = te[3],
          a13 = te[6];
      var a21 = te[1],
          a22 = te[4],
          a23 = te[7];
      te[0] = c * a11 + s * a21;
      te[3] = c * a12 + s * a22;
      te[6] = c * a13 + s * a23;
      te[1] = -s * a11 + c * a21;
      te[4] = -s * a12 + c * a22;
      te[7] = -s * a13 + c * a23;
      return this;
    }
  }, {
    key: "translate",
    value: function translate(tx, ty) {
      var te = this.elements;
      te[0] += tx * te[2];
      te[3] += tx * te[5];
      te[6] += tx * te[8];
      te[1] += ty * te[2];
      te[4] += ty * te[5];
      te[7] += ty * te[8];
      return this;
    }
  }, {
    key: "equals",
    value: function equals(matrix) {
      var te = this.elements;
      var me = matrix.elements;

      for (var _i5 = 0; _i5 < 9; _i5++) {
        if (te[_i5] !== me[_i5]) return false;
      }

      return true;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      for (var _i6 = 0; _i6 < 9; _i6++) {
        this.elements[_i6] = array[_i6 + offset];
      }

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var te = this.elements;
      array[offset] = te[0];
      array[offset + 1] = te[1];
      array[offset + 2] = te[2];
      array[offset + 3] = te[3];
      array[offset + 4] = te[4];
      array[offset + 5] = te[5];
      array[offset + 6] = te[6];
      array[offset + 7] = te[7];
      array[offset + 8] = te[8];
      return array;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().fromArray(this.elements);
    }
  }]);

  return Matrix3;
}();

Matrix3.prototype.isMatrix3 = true;

function arrayNeedsUint32(array) {
  // assumes larger values usually on last
  for (var _i7 = array.length - 1; _i7 >= 0; --_i7) {
    if (array[_i7] > 65535) return true;
  }

  return false;
}

function createElementNS(name) {
  return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}

function SRGBToLinear(c) {
  return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}

function LinearToSRGB(c) {
  return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
} // JavaScript RGB-to-RGB transforms, defined as
// FN[InputColorSpace][OutputColorSpace] callback functions.


var FN = (_FN = {}, _defineProperty(_FN, SRGBColorSpace, _defineProperty({}, LinearSRGBColorSpace, SRGBToLinear)), _defineProperty(_FN, LinearSRGBColorSpace, _defineProperty({}, SRGBColorSpace, LinearToSRGB)), _FN);
var ColorManagement = {
  legacyMode: true,

  get workingColorSpace() {
    return LinearSRGBColorSpace;
  },

  set workingColorSpace(colorSpace) {
    console.warn('THREE.ColorManagement: .workingColorSpace is readonly.');
  },

  convert: function convert(color, sourceColorSpace, targetColorSpace) {
    if (this.legacyMode || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) {
      return color;
    }

    if (FN[sourceColorSpace] && FN[sourceColorSpace][targetColorSpace] !== undefined) {
      var fn = FN[sourceColorSpace][targetColorSpace];
      color.r = fn(color.r);
      color.g = fn(color.g);
      color.b = fn(color.b);
      return color;
    }

    throw new Error('Unsupported color space conversion.');
  },
  fromWorkingColorSpace: function fromWorkingColorSpace(color, targetColorSpace) {
    return this.convert(color, this.workingColorSpace, targetColorSpace);
  },
  toWorkingColorSpace: function toWorkingColorSpace(color, sourceColorSpace) {
    return this.convert(color, sourceColorSpace, this.workingColorSpace);
  }
};
var _colorKeywords = {
  'aliceblue': 0xF0F8FF,
  'antiquewhite': 0xFAEBD7,
  'aqua': 0x00FFFF,
  'aquamarine': 0x7FFFD4,
  'azure': 0xF0FFFF,
  'beige': 0xF5F5DC,
  'bisque': 0xFFE4C4,
  'black': 0x000000,
  'blanchedalmond': 0xFFEBCD,
  'blue': 0x0000FF,
  'blueviolet': 0x8A2BE2,
  'brown': 0xA52A2A,
  'burlywood': 0xDEB887,
  'cadetblue': 0x5F9EA0,
  'chartreuse': 0x7FFF00,
  'chocolate': 0xD2691E,
  'coral': 0xFF7F50,
  'cornflowerblue': 0x6495ED,
  'cornsilk': 0xFFF8DC,
  'crimson': 0xDC143C,
  'cyan': 0x00FFFF,
  'darkblue': 0x00008B,
  'darkcyan': 0x008B8B,
  'darkgoldenrod': 0xB8860B,
  'darkgray': 0xA9A9A9,
  'darkgreen': 0x006400,
  'darkgrey': 0xA9A9A9,
  'darkkhaki': 0xBDB76B,
  'darkmagenta': 0x8B008B,
  'darkolivegreen': 0x556B2F,
  'darkorange': 0xFF8C00,
  'darkorchid': 0x9932CC,
  'darkred': 0x8B0000,
  'darksalmon': 0xE9967A,
  'darkseagreen': 0x8FBC8F,
  'darkslateblue': 0x483D8B,
  'darkslategray': 0x2F4F4F,
  'darkslategrey': 0x2F4F4F,
  'darkturquoise': 0x00CED1,
  'darkviolet': 0x9400D3,
  'deeppink': 0xFF1493,
  'deepskyblue': 0x00BFFF,
  'dimgray': 0x696969,
  'dimgrey': 0x696969,
  'dodgerblue': 0x1E90FF,
  'firebrick': 0xB22222,
  'floralwhite': 0xFFFAF0,
  'forestgreen': 0x228B22,
  'fuchsia': 0xFF00FF,
  'gainsboro': 0xDCDCDC,
  'ghostwhite': 0xF8F8FF,
  'gold': 0xFFD700,
  'goldenrod': 0xDAA520,
  'gray': 0x808080,
  'green': 0x008000,
  'greenyellow': 0xADFF2F,
  'grey': 0x808080,
  'honeydew': 0xF0FFF0,
  'hotpink': 0xFF69B4,
  'indianred': 0xCD5C5C,
  'indigo': 0x4B0082,
  'ivory': 0xFFFFF0,
  'khaki': 0xF0E68C,
  'lavender': 0xE6E6FA,
  'lavenderblush': 0xFFF0F5,
  'lawngreen': 0x7CFC00,
  'lemonchiffon': 0xFFFACD,
  'lightblue': 0xADD8E6,
  'lightcoral': 0xF08080,
  'lightcyan': 0xE0FFFF,
  'lightgoldenrodyellow': 0xFAFAD2,
  'lightgray': 0xD3D3D3,
  'lightgreen': 0x90EE90,
  'lightgrey': 0xD3D3D3,
  'lightpink': 0xFFB6C1,
  'lightsalmon': 0xFFA07A,
  'lightseagreen': 0x20B2AA,
  'lightskyblue': 0x87CEFA,
  'lightslategray': 0x778899,
  'lightslategrey': 0x778899,
  'lightsteelblue': 0xB0C4DE,
  'lightyellow': 0xFFFFE0,
  'lime': 0x00FF00,
  'limegreen': 0x32CD32,
  'linen': 0xFAF0E6,
  'magenta': 0xFF00FF,
  'maroon': 0x800000,
  'mediumaquamarine': 0x66CDAA,
  'mediumblue': 0x0000CD,
  'mediumorchid': 0xBA55D3,
  'mediumpurple': 0x9370DB,
  'mediumseagreen': 0x3CB371,
  'mediumslateblue': 0x7B68EE,
  'mediumspringgreen': 0x00FA9A,
  'mediumturquoise': 0x48D1CC,
  'mediumvioletred': 0xC71585,
  'midnightblue': 0x191970,
  'mintcream': 0xF5FFFA,
  'mistyrose': 0xFFE4E1,
  'moccasin': 0xFFE4B5,
  'navajowhite': 0xFFDEAD,
  'navy': 0x000080,
  'oldlace': 0xFDF5E6,
  'olive': 0x808000,
  'olivedrab': 0x6B8E23,
  'orange': 0xFFA500,
  'orangered': 0xFF4500,
  'orchid': 0xDA70D6,
  'palegoldenrod': 0xEEE8AA,
  'palegreen': 0x98FB98,
  'paleturquoise': 0xAFEEEE,
  'palevioletred': 0xDB7093,
  'papayawhip': 0xFFEFD5,
  'peachpuff': 0xFFDAB9,
  'peru': 0xCD853F,
  'pink': 0xFFC0CB,
  'plum': 0xDDA0DD,
  'powderblue': 0xB0E0E6,
  'purple': 0x800080,
  'rebeccapurple': 0x663399,
  'red': 0xFF0000,
  'rosybrown': 0xBC8F8F,
  'royalblue': 0x4169E1,
  'saddlebrown': 0x8B4513,
  'salmon': 0xFA8072,
  'sandybrown': 0xF4A460,
  'seagreen': 0x2E8B57,
  'seashell': 0xFFF5EE,
  'sienna': 0xA0522D,
  'silver': 0xC0C0C0,
  'skyblue': 0x87CEEB,
  'slateblue': 0x6A5ACD,
  'slategray': 0x708090,
  'slategrey': 0x708090,
  'snow': 0xFFFAFA,
  'springgreen': 0x00FF7F,
  'steelblue': 0x4682B4,
  'tan': 0xD2B48C,
  'teal': 0x008080,
  'thistle': 0xD8BFD8,
  'tomato': 0xFF6347,
  'turquoise': 0x40E0D0,
  'violet': 0xEE82EE,
  'wheat': 0xF5DEB3,
  'white': 0xFFFFFF,
  'whitesmoke': 0xF5F5F5,
  'yellow': 0xFFFF00,
  'yellowgreen': 0x9ACD32
};
var _rgb = {
  r: 0,
  g: 0,
  b: 0
};
var _hslA = {
  h: 0,
  s: 0,
  l: 0
};
var _hslB = {
  h: 0,
  s: 0,
  l: 0
};

function hue2rgb(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
  return p;
}

function toComponents(source, target) {
  target.r = source.r;
  target.g = source.g;
  target.b = source.b;
  return target;
}

var Color = /*#__PURE__*/function (_Symbol$iterator2) {
  function Color(r, g, b) {
    _classCallCheck2(this, Color);

    if (g === undefined && b === undefined) {
      // r is THREE.Color, hex or string
      return this.set(r);
    }

    return this.setRGB(r, g, b);
  }

  _createClass2(Color, [{
    key: "set",
    value: function set(value) {
      if (value && value.isColor) {
        this.copy(value);
      } else if (typeof value === 'number') {
        this.setHex(value);
      } else if (typeof value === 'string') {
        this.setStyle(value);
      }

      return this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(scalar) {
      this.r = scalar;
      this.g = scalar;
      this.b = scalar;
      return this;
    }
  }, {
    key: "setHex",
    value: function setHex(hex) {
      var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SRGBColorSpace;
      hex = Math.floor(hex);
      this.r = (hex >> 16 & 255) / 255;
      this.g = (hex >> 8 & 255) / 255;
      this.b = (hex & 255) / 255;
      ColorManagement.toWorkingColorSpace(this, colorSpace);
      return this;
    }
  }, {
    key: "setRGB",
    value: function setRGB(r, g, b) {
      var colorSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : LinearSRGBColorSpace;
      this.r = r;
      this.g = g;
      this.b = b;
      ColorManagement.toWorkingColorSpace(this, colorSpace);
      return this;
    }
  }, {
    key: "setHSL",
    value: function setHSL(h, s, l) {
      var colorSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : LinearSRGBColorSpace;
      // h,s,l ranges are in 0.0 - 1.0
      h = euclideanModulo(h, 1);
      s = clamp(s, 0, 1);
      l = clamp(l, 0, 1);

      if (s === 0) {
        this.r = this.g = this.b = l;
      } else {
        var p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
        var q = 2 * l - p;
        this.r = hue2rgb(q, p, h + 1 / 3);
        this.g = hue2rgb(q, p, h);
        this.b = hue2rgb(q, p, h - 1 / 3);
      }

      ColorManagement.toWorkingColorSpace(this, colorSpace);
      return this;
    }
  }, {
    key: "setStyle",
    value: function setStyle(style) {
      var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SRGBColorSpace;

      function handleAlpha(string) {
        if (string === undefined) return;

        if (parseFloat(string) < 1) {
          console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
      }

      var m;

      if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
        // rgb / hsl
        var color;
        var name = m[1];
        var components = m[2];

        switch (name) {
          case 'rgb':
          case 'rgba':
            if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
              // rgb(255,0,0) rgba(255,0,0,0.5)
              this.r = Math.min(255, parseInt(color[1], 10)) / 255;
              this.g = Math.min(255, parseInt(color[2], 10)) / 255;
              this.b = Math.min(255, parseInt(color[3], 10)) / 255;
              ColorManagement.toWorkingColorSpace(this, colorSpace);
              handleAlpha(color[4]);
              return this;
            }

            if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
              // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
              this.r = Math.min(100, parseInt(color[1], 10)) / 100;
              this.g = Math.min(100, parseInt(color[2], 10)) / 100;
              this.b = Math.min(100, parseInt(color[3], 10)) / 100;
              ColorManagement.toWorkingColorSpace(this, colorSpace);
              handleAlpha(color[4]);
              return this;
            }

            break;

          case 'hsl':
          case 'hsla':
            if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
              // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
              var h = parseFloat(color[1]) / 360;
              var s = parseInt(color[2], 10) / 100;
              var l = parseInt(color[3], 10) / 100;
              handleAlpha(color[4]);
              return this.setHSL(h, s, l, colorSpace);
            }

            break;
        }
      } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
        // hex color
        var hex = m[1];
        var size = hex.length;

        if (size === 3) {
          // #ff0
          this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
          this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
          this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
          ColorManagement.toWorkingColorSpace(this, colorSpace);
          return this;
        } else if (size === 6) {
          // #ff0000
          this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
          this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
          this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
          ColorManagement.toWorkingColorSpace(this, colorSpace);
          return this;
        }
      }

      if (style && style.length > 0) {
        return this.setColorName(style, colorSpace);
      }

      return this;
    }
  }, {
    key: "setColorName",
    value: function setColorName(style) {
      var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SRGBColorSpace;

      // color keywords
      var hex = _colorKeywords[style.toLowerCase()];

      if (hex !== undefined) {
        // red
        this.setHex(hex, colorSpace);
      } else {
        // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
      }

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.r, this.g, this.b);
    }
  }, {
    key: "copy",
    value: function copy(color) {
      this.r = color.r;
      this.g = color.g;
      this.b = color.b;
      return this;
    }
  }, {
    key: "copySRGBToLinear",
    value: function copySRGBToLinear(color) {
      this.r = SRGBToLinear(color.r);
      this.g = SRGBToLinear(color.g);
      this.b = SRGBToLinear(color.b);
      return this;
    }
  }, {
    key: "copyLinearToSRGB",
    value: function copyLinearToSRGB(color) {
      this.r = LinearToSRGB(color.r);
      this.g = LinearToSRGB(color.g);
      this.b = LinearToSRGB(color.b);
      return this;
    }
  }, {
    key: "convertSRGBToLinear",
    value: function convertSRGBToLinear() {
      this.copySRGBToLinear(this);
      return this;
    }
  }, {
    key: "convertLinearToSRGB",
    value: function convertLinearToSRGB() {
      this.copyLinearToSRGB(this);
      return this;
    }
  }, {
    key: "getHex",
    value: function getHex() {
      var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SRGBColorSpace;
      ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb), colorSpace);
      return clamp(_rgb.r * 255, 0, 255) << 16 ^ clamp(_rgb.g * 255, 0, 255) << 8 ^ clamp(_rgb.b * 255, 0, 255) << 0;
    }
  }, {
    key: "getHexString",
    value: function getHexString() {
      var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SRGBColorSpace;
      return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
  }, {
    key: "getHSL",
    value: function getHSL(target) {
      var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LinearSRGBColorSpace;
      // h,s,l ranges are in 0.0 - 1.0
      ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb), colorSpace);
      var r = _rgb.r,
          g = _rgb.g,
          b = _rgb.b;
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var hue, saturation;
      var lightness = (min + max) / 2.0;

      if (min === max) {
        hue = 0;
        saturation = 0;
      } else {
        var delta = max - min;
        saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);

        switch (max) {
          case r:
            hue = (g - b) / delta + (g < b ? 6 : 0);
            break;

          case g:
            hue = (b - r) / delta + 2;
            break;

          case b:
            hue = (r - g) / delta + 4;
            break;
        }

        hue /= 6;
      }

      target.h = hue;
      target.s = saturation;
      target.l = lightness;
      return target;
    }
  }, {
    key: "getRGB",
    value: function getRGB(target) {
      var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LinearSRGBColorSpace;
      ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb), colorSpace);
      target.r = _rgb.r;
      target.g = _rgb.g;
      target.b = _rgb.b;
      return target;
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SRGBColorSpace;
      ColorManagement.fromWorkingColorSpace(toComponents(this, _rgb), colorSpace);

      if (colorSpace !== SRGBColorSpace) {
        // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return "color(".concat(colorSpace, " ").concat(_rgb.r, " ").concat(_rgb.g, " ").concat(_rgb.b, ")");
      }

      return "rgb(".concat(_rgb.r * 255 | 0, ",").concat(_rgb.g * 255 | 0, ",").concat(_rgb.b * 255 | 0, ")");
    }
  }, {
    key: "offsetHSL",
    value: function offsetHSL(h, s, l) {
      this.getHSL(_hslA);
      _hslA.h += h;
      _hslA.s += s;
      _hslA.l += l;
      this.setHSL(_hslA.h, _hslA.s, _hslA.l);
      return this;
    }
  }, {
    key: "add",
    value: function add(color) {
      this.r += color.r;
      this.g += color.g;
      this.b += color.b;
      return this;
    }
  }, {
    key: "addColors",
    value: function addColors(color1, color2) {
      this.r = color1.r + color2.r;
      this.g = color1.g + color2.g;
      this.b = color1.b + color2.b;
      return this;
    }
  }, {
    key: "addScalar",
    value: function addScalar(s) {
      this.r += s;
      this.g += s;
      this.b += s;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(color) {
      this.r = Math.max(0, this.r - color.r);
      this.g = Math.max(0, this.g - color.g);
      this.b = Math.max(0, this.b - color.b);
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(color) {
      this.r *= color.r;
      this.g *= color.g;
      this.b *= color.b;
      return this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(s) {
      this.r *= s;
      this.g *= s;
      this.b *= s;
      return this;
    }
  }, {
    key: "lerp",
    value: function lerp(color, alpha) {
      this.r += (color.r - this.r) * alpha;
      this.g += (color.g - this.g) * alpha;
      this.b += (color.b - this.b) * alpha;
      return this;
    }
  }, {
    key: "lerpColors",
    value: function lerpColors(color1, color2, alpha) {
      this.r = color1.r + (color2.r - color1.r) * alpha;
      this.g = color1.g + (color2.g - color1.g) * alpha;
      this.b = color1.b + (color2.b - color1.b) * alpha;
      return this;
    }
  }, {
    key: "lerpHSL",
    value: function lerpHSL(color, alpha) {
      this.getHSL(_hslA);
      color.getHSL(_hslB);
      var h = lerp(_hslA.h, _hslB.h, alpha);
      var s = lerp(_hslA.s, _hslB.s, alpha);
      var l = lerp(_hslA.l, _hslB.l, alpha);
      this.setHSL(h, s, l);
      return this;
    }
  }, {
    key: "equals",
    value: function equals(c) {
      return c.r === this.r && c.g === this.g && c.b === this.b;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.r = array[offset];
      this.g = array[offset + 1];
      this.b = array[offset + 2];
      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      array[offset] = this.r;
      array[offset + 1] = this.g;
      array[offset + 2] = this.b;
      return array;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(attribute, index) {
      this.r = attribute.getX(index);
      this.g = attribute.getY(index);
      this.b = attribute.getZ(index);

      if (attribute.normalized === true) {
        // assuming Uint8Array
        this.r /= 255;
        this.g /= 255;
        this.b /= 255;
      }

      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.getHex();
    }
  }, {
    key: _Symbol$iterator2,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.r;

            case 2:
              _context3.next = 4;
              return this.g;

            case 4:
              _context3.next = 6;
              return this.b;

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Color;
}(Symbol.iterator);

Color.NAMES = _colorKeywords;
Color.prototype.isColor = true;
Color.prototype.r = 1;
Color.prototype.g = 1;
Color.prototype.b = 1;

var _canvas;

var ImageUtils = /*#__PURE__*/function () {
  function ImageUtils() {
    _classCallCheck2(this, ImageUtils);
  }

  _createClass2(ImageUtils, null, [{
    key: "getDataURL",
    value: function getDataURL(image) {
      if (/^data:/i.test(image.src)) {
        return image.src;
      }

      if (typeof HTMLCanvasElement == 'undefined') {
        return image.src;
      }

      var canvas;

      if (image instanceof HTMLCanvasElement) {
        canvas = image;
      } else {
        if (_canvas === undefined) _canvas = createElementNS('canvas');
        _canvas.width = image.width;
        _canvas.height = image.height;

        var context = _canvas.getContext('2d');

        if (image instanceof ImageData) {
          context.putImageData(image, 0, 0);
        } else {
          context.drawImage(image, 0, 0, image.width, image.height);
        }

        canvas = _canvas;
      }

      if (canvas.width > 2048 || canvas.height > 2048) {
        console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
        return canvas.toDataURL('image/jpeg', 0.6);
      } else {
        return canvas.toDataURL('image/png');
      }
    }
  }, {
    key: "sRGBToLinear",
    value: function sRGBToLinear(image) {
      if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
        var canvas = createElementNS('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        var imageData = context.getImageData(0, 0, image.width, image.height);
        var data = imageData.data;

        for (var _i8 = 0; _i8 < data.length; _i8++) {
          data[_i8] = SRGBToLinear(data[_i8] / 255) * 255;
        }

        context.putImageData(imageData, 0, 0);
        return canvas;
      } else if (image.data) {
        var _data = image.data.slice(0);

        for (var _i9 = 0; _i9 < _data.length; _i9++) {
          if (_data instanceof Uint8Array || _data instanceof Uint8ClampedArray) {
            _data[_i9] = Math.floor(SRGBToLinear(_data[_i9] / 255) * 255);
          } else {
            // assuming float
            _data[_i9] = SRGBToLinear(_data[_i9]);
          }
        }

        return {
          data: _data,
          width: image.width,
          height: image.height
        };
      } else {
        console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
        return image;
      }
    }
  }]);

  return ImageUtils;
}();

var Source = /*#__PURE__*/function () {
  function Source() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck2(this, Source);

    this.uuid = generateUUID();
    this.data = data;
    this.version = 0;
  }

  _createClass2(Source, [{
    key: "needsUpdate",
    set: function set(value) {
      if (value === true) this.version++;
    }
  }, {
    key: "toJSON",
    value: function toJSON(meta) {
      var isRootObject = meta === undefined || typeof meta === 'string';

      if (!isRootObject && meta.images[this.uuid] !== undefined) {
        return meta.images[this.uuid];
      }

      var output = {
        uuid: this.uuid,
        url: ''
      };
      var data = this.data;

      if (data !== null) {
        var _url;

        if (Array.isArray(data)) {
          // cube texture
          _url = [];

          for (var _i10 = 0, l = data.length; _i10 < l; _i10++) {
            if (data[_i10].isDataTexture) {
              _url.push(serializeImage(data[_i10].image));
            } else {
              _url.push(serializeImage(data[_i10]));
            }
          }
        } else {
          // texture
          _url = serializeImage(data);
        }

        output.url = _url;
      }

      if (!isRootObject) {
        meta.images[this.uuid] = output;
      }

      return output;
    }
  }]);

  return Source;
}();

function serializeImage(image) {
  if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
    // default images
    return ImageUtils.getDataURL(image);
  } else {
    if (image.data) {
      // images of DataTexture
      return {
        data: Array.prototype.slice.call(image.data),
        width: image.width,
        height: image.height,
        type: image.data.constructor.name
      };
    } else {
      console.warn('THREE.Texture: Unable to serialize Texture.');
      return {};
    }
  }
}

Source.prototype.isSource = true;
var textureId = 0;

var Texture = /*#__PURE__*/function (_EventDispatcher) {
  _inherits(Texture, _EventDispatcher);

  var _super2 = _createSuper(Texture);

  function Texture() {
    var _this2;

    var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Texture.DEFAULT_IMAGE;
    var mapping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Texture.DEFAULT_MAPPING;
    var wrapS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ClampToEdgeWrapping;
    var wrapT = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ClampToEdgeWrapping;
    var magFilter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : LinearFilter;
    var minFilter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : LinearMipmapLinearFilter;
    var format = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : RGBAFormat;
    var type = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : UnsignedByteType;
    var anisotropy = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1;
    var encoding = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : LinearEncoding;

    _classCallCheck2(this, Texture);

    _this2 = _super2.call(this);
    Object.defineProperty(_assertThisInitialized(_this2), 'id', {
      value: textureId++
    });
    _this2.uuid = generateUUID();
    _this2.name = '';
    _this2.source = new Source(image);
    _this2.mipmaps = [];
    _this2.mapping = mapping;
    _this2.wrapS = wrapS;
    _this2.wrapT = wrapT;
    _this2.magFilter = magFilter;
    _this2.minFilter = minFilter;
    _this2.anisotropy = anisotropy;
    _this2.format = format;
    _this2.internalFormat = null;
    _this2.type = type;
    _this2.offset = new Vector2(0, 0);
    _this2.repeat = new Vector2(1, 1);
    _this2.center = new Vector2(0, 0);
    _this2.rotation = 0;
    _this2.matrixAutoUpdate = true;
    _this2.matrix = new Matrix3();
    _this2.generateMipmaps = true;
    _this2.premultiplyAlpha = false;
    _this2.flipY = true;
    _this2.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
    // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
    //
    // Also changing the encoding after already used by a Material will not automatically make the Material
    // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.

    _this2.encoding = encoding;
    _this2.userData = {};
    _this2.version = 0;
    _this2.onUpdate = null;
    _this2.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not

    _this2.needsPMREMUpdate = false; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)

    return _this2;
  }

  _createClass2(Texture, [{
    key: "image",
    get: function get() {
      return this.source.data;
    },
    set: function set(value) {
      this.source.data = value;
    }
  }, {
    key: "updateMatrix",
    value: function updateMatrix() {
      this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      this.name = source.name;
      this.source = source.source;
      this.mipmaps = source.mipmaps.slice(0);
      this.mapping = source.mapping;
      this.wrapS = source.wrapS;
      this.wrapT = source.wrapT;
      this.magFilter = source.magFilter;
      this.minFilter = source.minFilter;
      this.anisotropy = source.anisotropy;
      this.format = source.format;
      this.internalFormat = source.internalFormat;
      this.type = source.type;
      this.offset.copy(source.offset);
      this.repeat.copy(source.repeat);
      this.center.copy(source.center);
      this.rotation = source.rotation;
      this.matrixAutoUpdate = source.matrixAutoUpdate;
      this.matrix.copy(source.matrix);
      this.generateMipmaps = source.generateMipmaps;
      this.premultiplyAlpha = source.premultiplyAlpha;
      this.flipY = source.flipY;
      this.unpackAlignment = source.unpackAlignment;
      this.encoding = source.encoding;
      this.userData = JSON.parse(JSON.stringify(source.userData));
      this.needsUpdate = true;
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(meta) {
      var isRootObject = meta === undefined || typeof meta === 'string';

      if (!isRootObject && meta.textures[this.uuid] !== undefined) {
        return meta.textures[this.uuid];
      }

      var output = {
        metadata: {
          version: 4.5,
          type: 'Texture',
          generator: 'Texture.toJSON'
        },
        uuid: this.uuid,
        name: this.name,
        image: this.source.toJSON(meta).uuid,
        mapping: this.mapping,
        repeat: [this.repeat.x, this.repeat.y],
        offset: [this.offset.x, this.offset.y],
        center: [this.center.x, this.center.y],
        rotation: this.rotation,
        wrap: [this.wrapS, this.wrapT],
        format: this.format,
        type: this.type,
        encoding: this.encoding,
        minFilter: this.minFilter,
        magFilter: this.magFilter,
        anisotropy: this.anisotropy,
        flipY: this.flipY,
        premultiplyAlpha: this.premultiplyAlpha,
        unpackAlignment: this.unpackAlignment
      };
      if (JSON.stringify(this.userData) !== '{}') output.userData = this.userData;

      if (!isRootObject) {
        meta.textures[this.uuid] = output;
      }

      return output;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: 'dispose'
      });
    }
  }, {
    key: "transformUv",
    value: function transformUv(uv) {
      if (this.mapping !== UVMapping) return uv;
      uv.applyMatrix3(this.matrix);

      if (uv.x < 0 || uv.x > 1) {
        switch (this.wrapS) {
          case RepeatWrapping:
            uv.x = uv.x - Math.floor(uv.x);
            break;

          case ClampToEdgeWrapping:
            uv.x = uv.x < 0 ? 0 : 1;
            break;

          case MirroredRepeatWrapping:
            if (Math.abs(Math.floor(uv.x) % 2) === 1) {
              uv.x = Math.ceil(uv.x) - uv.x;
            } else {
              uv.x = uv.x - Math.floor(uv.x);
            }

            break;
        }
      }

      if (uv.y < 0 || uv.y > 1) {
        switch (this.wrapT) {
          case RepeatWrapping:
            uv.y = uv.y - Math.floor(uv.y);
            break;

          case ClampToEdgeWrapping:
            uv.y = uv.y < 0 ? 0 : 1;
            break;

          case MirroredRepeatWrapping:
            if (Math.abs(Math.floor(uv.y) % 2) === 1) {
              uv.y = Math.ceil(uv.y) - uv.y;
            } else {
              uv.y = uv.y - Math.floor(uv.y);
            }

            break;
        }
      }

      if (this.flipY) {
        uv.y = 1 - uv.y;
      }

      return uv;
    }
  }, {
    key: "needsUpdate",
    set: function set(value) {
      if (value === true) {
        this.version++;
        this.source.needsUpdate = true;
      }
    }
  }]);

  return Texture;
}(EventDispatcher);

Texture.DEFAULT_IMAGE = null;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.prototype.isTexture = true;

var Vector4 = /*#__PURE__*/function (_Symbol$iterator3) {
  function Vector4() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var w = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck2(this, Vector4);

    this.x = x;
    this.y = y;
    this.z = z;
    this.w = w;
  }

  _createClass2(Vector4, [{
    key: "width",
    get: function get() {
      return this.z;
    },
    set: function set(value) {
      this.z = value;
    }
  }, {
    key: "height",
    get: function get() {
      return this.w;
    },
    set: function set(value) {
      this.w = value;
    }
  }, {
    key: "set",
    value: function set(x, y, z, w) {
      this.x = x;
      this.y = y;
      this.z = z;
      this.w = w;
      return this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(scalar) {
      this.x = scalar;
      this.y = scalar;
      this.z = scalar;
      this.w = scalar;
      return this;
    }
  }, {
    key: "setX",
    value: function setX(x) {
      this.x = x;
      return this;
    }
  }, {
    key: "setY",
    value: function setY(y) {
      this.y = y;
      return this;
    }
  }, {
    key: "setZ",
    value: function setZ(z) {
      this.z = z;
      return this;
    }
  }, {
    key: "setW",
    value: function setW(w) {
      this.w = w;
      return this;
    }
  }, {
    key: "setComponent",
    value: function setComponent(index, value) {
      switch (index) {
        case 0:
          this.x = value;
          break;

        case 1:
          this.y = value;
          break;

        case 2:
          this.z = value;
          break;

        case 3:
          this.w = value;
          break;

        default:
          throw new Error('index is out of range: ' + index);
      }

      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(index) {
      switch (index) {
        case 0:
          return this.x;

        case 1:
          return this.y;

        case 2:
          return this.z;

        case 3:
          return this.w;

        default:
          throw new Error('index is out of range: ' + index);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.x, this.y, this.z, this.w);
    }
  }, {
    key: "copy",
    value: function copy(v) {
      this.x = v.x;
      this.y = v.y;
      this.z = v.z;
      this.w = v.w !== undefined ? v.w : 1;
      return this;
    }
  }, {
    key: "add",
    value: function add(v, w) {
      if (w !== undefined) {
        console.warn('THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
        return this.addVectors(v, w);
      }

      this.x += v.x;
      this.y += v.y;
      this.z += v.z;
      this.w += v.w;
      return this;
    }
  }, {
    key: "addScalar",
    value: function addScalar(s) {
      this.x += s;
      this.y += s;
      this.z += s;
      this.w += s;
      return this;
    }
  }, {
    key: "addVectors",
    value: function addVectors(a, b) {
      this.x = a.x + b.x;
      this.y = a.y + b.y;
      this.z = a.z + b.z;
      this.w = a.w + b.w;
      return this;
    }
  }, {
    key: "addScaledVector",
    value: function addScaledVector(v, s) {
      this.x += v.x * s;
      this.y += v.y * s;
      this.z += v.z * s;
      this.w += v.w * s;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(v, w) {
      if (w !== undefined) {
        console.warn('THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
        return this.subVectors(v, w);
      }

      this.x -= v.x;
      this.y -= v.y;
      this.z -= v.z;
      this.w -= v.w;
      return this;
    }
  }, {
    key: "subScalar",
    value: function subScalar(s) {
      this.x -= s;
      this.y -= s;
      this.z -= s;
      this.w -= s;
      return this;
    }
  }, {
    key: "subVectors",
    value: function subVectors(a, b) {
      this.x = a.x - b.x;
      this.y = a.y - b.y;
      this.z = a.z - b.z;
      this.w = a.w - b.w;
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(v) {
      this.x *= v.x;
      this.y *= v.y;
      this.z *= v.z;
      this.w *= v.w;
      return this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(scalar) {
      this.x *= scalar;
      this.y *= scalar;
      this.z *= scalar;
      this.w *= scalar;
      return this;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(m) {
      var x = this.x,
          y = this.y,
          z = this.z,
          w = this.w;
      var e = m.elements;
      this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
      this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
      this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
      this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
      return this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(scalar) {
      return this.multiplyScalar(1 / scalar);
    }
  }, {
    key: "setAxisAngleFromQuaternion",
    value: function setAxisAngleFromQuaternion(q) {
      // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
      // q is assumed to be normalized
      this.w = 2 * Math.acos(q.w);
      var s = Math.sqrt(1 - q.w * q.w);

      if (s < 0.0001) {
        this.x = 1;
        this.y = 0;
        this.z = 0;
      } else {
        this.x = q.x / s;
        this.y = q.y / s;
        this.z = q.z / s;
      }

      return this;
    }
  }, {
    key: "setAxisAngleFromRotationMatrix",
    value: function setAxisAngleFromRotationMatrix(m) {
      // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
      // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
      var angle, x, y, z; // variables for result

      var epsilon = 0.01,
          // margin to allow for rounding errors
      epsilon2 = 0.1,
          // margin to distinguish between 0 and 180 degrees
      te = m.elements,
          m11 = te[0],
          m12 = te[4],
          m13 = te[8],
          m21 = te[1],
          m22 = te[5],
          m23 = te[9],
          m31 = te[2],
          m32 = te[6],
          m33 = te[10];

      if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
        // singularity found
        // first check for identity matrix which must have +1 for all terms
        // in leading diagonal and zero in other terms
        if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
          // this singularity is identity matrix so angle = 0
          this.set(1, 0, 0, 0);
          return this; // zero angle, arbitrary axis
        } // otherwise this singularity is angle = 180


        angle = Math.PI;
        var xx = (m11 + 1) / 2;
        var yy = (m22 + 1) / 2;
        var zz = (m33 + 1) / 2;
        var xy = (m12 + m21) / 4;
        var xz = (m13 + m31) / 4;
        var yz = (m23 + m32) / 4;

        if (xx > yy && xx > zz) {
          // m11 is the largest diagonal term
          if (xx < epsilon) {
            x = 0;
            y = 0.707106781;
            z = 0.707106781;
          } else {
            x = Math.sqrt(xx);
            y = xy / x;
            z = xz / x;
          }
        } else if (yy > zz) {
          // m22 is the largest diagonal term
          if (yy < epsilon) {
            x = 0.707106781;
            y = 0;
            z = 0.707106781;
          } else {
            y = Math.sqrt(yy);
            x = xy / y;
            z = yz / y;
          }
        } else {
          // m33 is the largest diagonal term so base result on this
          if (zz < epsilon) {
            x = 0.707106781;
            y = 0.707106781;
            z = 0;
          } else {
            z = Math.sqrt(zz);
            x = xz / z;
            y = yz / z;
          }
        }

        this.set(x, y, z, angle);
        return this; // return 180 deg rotation
      } // as we have reached here there are no singularities so we can handle normally


      var s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize

      if (Math.abs(s) < 0.001) s = 1; // prevent divide by zero, should not happen if matrix is orthogonal and should be
      // caught by singularity test above, but I've left it in just in case

      this.x = (m32 - m23) / s;
      this.y = (m13 - m31) / s;
      this.z = (m21 - m12) / s;
      this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
      return this;
    }
  }, {
    key: "min",
    value: function min(v) {
      this.x = Math.min(this.x, v.x);
      this.y = Math.min(this.y, v.y);
      this.z = Math.min(this.z, v.z);
      this.w = Math.min(this.w, v.w);
      return this;
    }
  }, {
    key: "max",
    value: function max(v) {
      this.x = Math.max(this.x, v.x);
      this.y = Math.max(this.y, v.y);
      this.z = Math.max(this.z, v.z);
      this.w = Math.max(this.w, v.w);
      return this;
    }
  }, {
    key: "clamp",
    value: function clamp(min, max) {
      // assumes min < max, componentwise
      this.x = Math.max(min.x, Math.min(max.x, this.x));
      this.y = Math.max(min.y, Math.min(max.y, this.y));
      this.z = Math.max(min.z, Math.min(max.z, this.z));
      this.w = Math.max(min.w, Math.min(max.w, this.w));
      return this;
    }
  }, {
    key: "clampScalar",
    value: function clampScalar(minVal, maxVal) {
      this.x = Math.max(minVal, Math.min(maxVal, this.x));
      this.y = Math.max(minVal, Math.min(maxVal, this.y));
      this.z = Math.max(minVal, Math.min(maxVal, this.z));
      this.w = Math.max(minVal, Math.min(maxVal, this.w));
      return this;
    }
  }, {
    key: "clampLength",
    value: function clampLength(min, max) {
      var length = this.length();
      return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
  }, {
    key: "floor",
    value: function floor() {
      this.x = Math.floor(this.x);
      this.y = Math.floor(this.y);
      this.z = Math.floor(this.z);
      this.w = Math.floor(this.w);
      return this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      this.x = Math.ceil(this.x);
      this.y = Math.ceil(this.y);
      this.z = Math.ceil(this.z);
      this.w = Math.ceil(this.w);
      return this;
    }
  }, {
    key: "round",
    value: function round() {
      this.x = Math.round(this.x);
      this.y = Math.round(this.y);
      this.z = Math.round(this.z);
      this.w = Math.round(this.w);
      return this;
    }
  }, {
    key: "roundToZero",
    value: function roundToZero() {
      this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
      this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
      this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
      this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
      return this;
    }
  }, {
    key: "negate",
    value: function negate() {
      this.x = -this.x;
      this.y = -this.y;
      this.z = -this.z;
      this.w = -this.w;
      return this;
    }
  }, {
    key: "dot",
    value: function dot(v) {
      return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
  }, {
    key: "manhattanLength",
    value: function manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.divideScalar(this.length() || 1);
    }
  }, {
    key: "setLength",
    value: function setLength(length) {
      return this.normalize().multiplyScalar(length);
    }
  }, {
    key: "lerp",
    value: function lerp(v, alpha) {
      this.x += (v.x - this.x) * alpha;
      this.y += (v.y - this.y) * alpha;
      this.z += (v.z - this.z) * alpha;
      this.w += (v.w - this.w) * alpha;
      return this;
    }
  }, {
    key: "lerpVectors",
    value: function lerpVectors(v1, v2, alpha) {
      this.x = v1.x + (v2.x - v1.x) * alpha;
      this.y = v1.y + (v2.y - v1.y) * alpha;
      this.z = v1.z + (v2.z - v1.z) * alpha;
      this.w = v1.w + (v2.w - v1.w) * alpha;
      return this;
    }
  }, {
    key: "equals",
    value: function equals(v) {
      return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.x = array[offset];
      this.y = array[offset + 1];
      this.z = array[offset + 2];
      this.w = array[offset + 3];
      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      array[offset] = this.x;
      array[offset + 1] = this.y;
      array[offset + 2] = this.z;
      array[offset + 3] = this.w;
      return array;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(attribute, index, offset) {
      if (offset !== undefined) {
        console.warn('THREE.Vector4: offset has been removed from .fromBufferAttribute().');
      }

      this.x = attribute.getX(index);
      this.y = attribute.getY(index);
      this.z = attribute.getZ(index);
      this.w = attribute.getW(index);
      return this;
    }
  }, {
    key: "random",
    value: function random() {
      this.x = Math.random();
      this.y = Math.random();
      this.z = Math.random();
      this.w = Math.random();
      return this;
    }
  }, {
    key: _Symbol$iterator3,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.x;

            case 2:
              _context4.next = 4;
              return this.y;

            case 4:
              _context4.next = 6;
              return this.z;

            case 6:
              _context4.next = 8;
              return this.w;

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Vector4;
}(Symbol.iterator);

Vector4.prototype.isVector4 = true;
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/

var WebGLRenderTarget = /*#__PURE__*/function (_EventDispatcher2) {
  _inherits(WebGLRenderTarget, _EventDispatcher2);

  var _super3 = _createSuper(WebGLRenderTarget);

  function WebGLRenderTarget(width, height) {
    var _this3;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck2(this, WebGLRenderTarget);

    _this3 = _super3.call(this);
    _this3.width = width;
    _this3.height = height;
    _this3.depth = 1;
    _this3.scissor = new Vector4(0, 0, width, height);
    _this3.scissorTest = false;
    _this3.viewport = new Vector4(0, 0, width, height);
    var image = {
      width: width,
      height: height,
      depth: 1
    };
    _this3.texture = new Texture(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
    _this3.texture.isRenderTargetTexture = true;
    _this3.texture.flipY = false;
    _this3.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
    _this3.texture.internalFormat = options.internalFormat !== undefined ? options.internalFormat : null;
    _this3.texture.minFilter = options.minFilter !== undefined ? options.minFilter : LinearFilter;
    _this3.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
    _this3.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
    _this3.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
    _this3.samples = options.samples !== undefined ? options.samples : 0;
    return _this3;
  }

  _createClass2(WebGLRenderTarget, [{
    key: "setSize",
    value: function setSize(width, height) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      if (this.width !== width || this.height !== height || this.depth !== depth) {
        this.width = width;
        this.height = height;
        this.depth = depth;
        this.texture.image.width = width;
        this.texture.image.height = height;
        this.texture.image.depth = depth;
        this.dispose();
      }

      this.viewport.set(0, 0, width, height);
      this.scissor.set(0, 0, width, height);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      this.width = source.width;
      this.height = source.height;
      this.depth = source.depth;
      this.viewport.copy(source.viewport);
      this.texture = source.texture.clone();
      this.texture.isRenderTargetTexture = true; // ensure image object is not shared, see #20328

      var image = Object.assign({}, source.texture.image);
      this.texture.source = new Source(image);
      this.depthBuffer = source.depthBuffer;
      this.stencilBuffer = source.stencilBuffer;
      if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
      this.samples = source.samples;
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: 'dispose'
      });
    }
  }]);

  return WebGLRenderTarget;
}(EventDispatcher);

WebGLRenderTarget.prototype.isWebGLRenderTarget = true;

var DataArrayTexture = /*#__PURE__*/function (_Texture) {
  _inherits(DataArrayTexture, _Texture);

  var _super4 = _createSuper(DataArrayTexture);

  function DataArrayTexture() {
    var _this4;

    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var depth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck2(this, DataArrayTexture);

    _this4 = _super4.call(this, null);
    _this4.image = {
      data: data,
      width: width,
      height: height,
      depth: depth
    };
    _this4.magFilter = NearestFilter;
    _this4.minFilter = NearestFilter;
    _this4.wrapR = ClampToEdgeWrapping;
    _this4.generateMipmaps = false;
    _this4.flipY = false;
    _this4.unpackAlignment = 1;
    return _this4;
  }

  return DataArrayTexture;
}(Texture);

DataArrayTexture.prototype.isDataArrayTexture = true;

var Data3DTexture = /*#__PURE__*/function (_Texture2) {
  _inherits(Data3DTexture, _Texture2);

  var _super5 = _createSuper(Data3DTexture);

  function Data3DTexture() {
    var _this5;

    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var depth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck2(this, Data3DTexture);

    // We're going to add .setXXX() methods for setting properties later.
    // Users can still set in DataTexture3D directly.
    //
    //	const texture = new THREE.DataTexture3D( data, width, height, depth );
    // 	texture.anisotropy = 16;
    //
    // See #14839
    _this5 = _super5.call(this, null);
    _this5.image = {
      data: data,
      width: width,
      height: height,
      depth: depth
    };
    _this5.magFilter = NearestFilter;
    _this5.minFilter = NearestFilter;
    _this5.wrapR = ClampToEdgeWrapping;
    _this5.generateMipmaps = false;
    _this5.flipY = false;
    _this5.unpackAlignment = 1;
    return _this5;
  }

  return Data3DTexture;
}(Texture);

Data3DTexture.prototype.isData3DTexture = true;

var Quaternion = /*#__PURE__*/function (_Symbol$iterator4) {
  function Quaternion() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var w = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck2(this, Quaternion);

    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
  }

  _createClass2(Quaternion, [{
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      this._x = value;

      this._onChangeCallback();
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      this._y = value;

      this._onChangeCallback();
    }
  }, {
    key: "z",
    get: function get() {
      return this._z;
    },
    set: function set(value) {
      this._z = value;

      this._onChangeCallback();
    }
  }, {
    key: "w",
    get: function get() {
      return this._w;
    },
    set: function set(value) {
      this._w = value;

      this._onChangeCallback();
    }
  }, {
    key: "set",
    value: function set(x, y, z, w) {
      this._x = x;
      this._y = y;
      this._z = z;
      this._w = w;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this._x, this._y, this._z, this._w);
    }
  }, {
    key: "copy",
    value: function copy(quaternion) {
      this._x = quaternion.x;
      this._y = quaternion.y;
      this._z = quaternion.z;
      this._w = quaternion.w;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "setFromEuler",
    value: function setFromEuler(euler, update) {
      if (!(euler && euler.isEuler)) {
        throw new Error('THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.');
      }

      var x = euler._x,
          y = euler._y,
          z = euler._z,
          order = euler._order; // http://www.mathworks.com/matlabcentral/fileexchange/
      // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
      //	content/SpinCalc.m

      var cos = Math.cos;
      var sin = Math.sin;
      var c1 = cos(x / 2);
      var c2 = cos(y / 2);
      var c3 = cos(z / 2);
      var s1 = sin(x / 2);
      var s2 = sin(y / 2);
      var s3 = sin(z / 2);

      switch (order) {
        case 'XYZ':
          this._x = s1 * c2 * c3 + c1 * s2 * s3;
          this._y = c1 * s2 * c3 - s1 * c2 * s3;
          this._z = c1 * c2 * s3 + s1 * s2 * c3;
          this._w = c1 * c2 * c3 - s1 * s2 * s3;
          break;

        case 'YXZ':
          this._x = s1 * c2 * c3 + c1 * s2 * s3;
          this._y = c1 * s2 * c3 - s1 * c2 * s3;
          this._z = c1 * c2 * s3 - s1 * s2 * c3;
          this._w = c1 * c2 * c3 + s1 * s2 * s3;
          break;

        case 'ZXY':
          this._x = s1 * c2 * c3 - c1 * s2 * s3;
          this._y = c1 * s2 * c3 + s1 * c2 * s3;
          this._z = c1 * c2 * s3 + s1 * s2 * c3;
          this._w = c1 * c2 * c3 - s1 * s2 * s3;
          break;

        case 'ZYX':
          this._x = s1 * c2 * c3 - c1 * s2 * s3;
          this._y = c1 * s2 * c3 + s1 * c2 * s3;
          this._z = c1 * c2 * s3 - s1 * s2 * c3;
          this._w = c1 * c2 * c3 + s1 * s2 * s3;
          break;

        case 'YZX':
          this._x = s1 * c2 * c3 + c1 * s2 * s3;
          this._y = c1 * s2 * c3 + s1 * c2 * s3;
          this._z = c1 * c2 * s3 - s1 * s2 * c3;
          this._w = c1 * c2 * c3 - s1 * s2 * s3;
          break;

        case 'XZY':
          this._x = s1 * c2 * c3 - c1 * s2 * s3;
          this._y = c1 * s2 * c3 - s1 * c2 * s3;
          this._z = c1 * c2 * s3 + s1 * s2 * c3;
          this._w = c1 * c2 * c3 + s1 * s2 * s3;
          break;

        default:
          console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
      }

      if (update !== false) this._onChangeCallback();
      return this;
    }
  }, {
    key: "setFromAxisAngle",
    value: function setFromAxisAngle(axis, angle) {
      // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
      // assumes axis is normalized
      var halfAngle = angle / 2,
          s = Math.sin(halfAngle);
      this._x = axis.x * s;
      this._y = axis.y * s;
      this._z = axis.z * s;
      this._w = Math.cos(halfAngle);

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "setFromRotationMatrix",
    value: function setFromRotationMatrix(m) {
      // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
      // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
      var te = m.elements,
          m11 = te[0],
          m12 = te[4],
          m13 = te[8],
          m21 = te[1],
          m22 = te[5],
          m23 = te[9],
          m31 = te[2],
          m32 = te[6],
          m33 = te[10],
          trace = m11 + m22 + m33;

      if (trace > 0) {
        var s = 0.5 / Math.sqrt(trace + 1.0);
        this._w = 0.25 / s;
        this._x = (m32 - m23) * s;
        this._y = (m13 - m31) * s;
        this._z = (m21 - m12) * s;
      } else if (m11 > m22 && m11 > m33) {
        var _s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);

        this._w = (m32 - m23) / _s;
        this._x = 0.25 * _s;
        this._y = (m12 + m21) / _s;
        this._z = (m13 + m31) / _s;
      } else if (m22 > m33) {
        var _s2 = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);

        this._w = (m13 - m31) / _s2;
        this._x = (m12 + m21) / _s2;
        this._y = 0.25 * _s2;
        this._z = (m23 + m32) / _s2;
      } else {
        var _s3 = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);

        this._w = (m21 - m12) / _s3;
        this._x = (m13 + m31) / _s3;
        this._y = (m23 + m32) / _s3;
        this._z = 0.25 * _s3;
      }

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "setFromUnitVectors",
    value: function setFromUnitVectors(vFrom, vTo) {
      // assumes direction vectors vFrom and vTo are normalized
      var r = vFrom.dot(vTo) + 1;

      if (r < Number.EPSILON) {
        // vFrom and vTo point in opposite directions
        r = 0;

        if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
          this._x = -vFrom.y;
          this._y = vFrom.x;
          this._z = 0;
          this._w = r;
        } else {
          this._x = 0;
          this._y = -vFrom.z;
          this._z = vFrom.y;
          this._w = r;
        }
      } else {
        // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
        this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
        this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
        this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
        this._w = r;
      }

      return this.normalize();
    }
  }, {
    key: "angleTo",
    value: function angleTo(q) {
      return 2 * Math.acos(Math.abs(clamp(this.dot(q), -1, 1)));
    }
  }, {
    key: "rotateTowards",
    value: function rotateTowards(q, step) {
      var angle = this.angleTo(q);
      if (angle === 0) return this;
      var t = Math.min(1, step / angle);
      this.slerp(q, t);
      return this;
    }
  }, {
    key: "identity",
    value: function identity() {
      return this.set(0, 0, 0, 1);
    }
  }, {
    key: "invert",
    value: function invert() {
      // quaternion is assumed to have unit length
      return this.conjugate();
    }
  }, {
    key: "conjugate",
    value: function conjugate() {
      this._x *= -1;
      this._y *= -1;
      this._z *= -1;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "dot",
    value: function dot(v) {
      return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      var l = this.length();

      if (l === 0) {
        this._x = 0;
        this._y = 0;
        this._z = 0;
        this._w = 1;
      } else {
        l = 1 / l;
        this._x = this._x * l;
        this._y = this._y * l;
        this._z = this._z * l;
        this._w = this._w * l;
      }

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(q, p) {
      if (p !== undefined) {
        console.warn('THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.');
        return this.multiplyQuaternions(q, p);
      }

      return this.multiplyQuaternions(this, q);
    }
  }, {
    key: "premultiply",
    value: function premultiply(q) {
      return this.multiplyQuaternions(q, this);
    }
  }, {
    key: "multiplyQuaternions",
    value: function multiplyQuaternions(a, b) {
      // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
      var qax = a._x,
          qay = a._y,
          qaz = a._z,
          qaw = a._w;
      var qbx = b._x,
          qby = b._y,
          qbz = b._z,
          qbw = b._w;
      this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
      this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
      this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
      this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "slerp",
    value: function slerp(qb, t) {
      if (t === 0) return this;
      if (t === 1) return this.copy(qb);
      var x = this._x,
          y = this._y,
          z = this._z,
          w = this._w; // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

      var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

      if (cosHalfTheta < 0) {
        this._w = -qb._w;
        this._x = -qb._x;
        this._y = -qb._y;
        this._z = -qb._z;
        cosHalfTheta = -cosHalfTheta;
      } else {
        this.copy(qb);
      }

      if (cosHalfTheta >= 1.0) {
        this._w = w;
        this._x = x;
        this._y = y;
        this._z = z;
        return this;
      }

      var sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;

      if (sqrSinHalfTheta <= Number.EPSILON) {
        var s = 1 - t;
        this._w = s * w + t * this._w;
        this._x = s * x + t * this._x;
        this._y = s * y + t * this._y;
        this._z = s * z + t * this._z;
        this.normalize();

        this._onChangeCallback();

        return this;
      }

      var sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
      var halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
      var ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta,
          ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
      this._w = w * ratioA + this._w * ratioB;
      this._x = x * ratioA + this._x * ratioB;
      this._y = y * ratioA + this._y * ratioB;
      this._z = z * ratioA + this._z * ratioB;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "slerpQuaternions",
    value: function slerpQuaternions(qa, qb, t) {
      return this.copy(qa).slerp(qb, t);
    }
  }, {
    key: "random",
    value: function random() {
      // Derived from http://planning.cs.uiuc.edu/node198.html
      // Note, this source uses w, x, y, z ordering,
      // so we swap the order below.
      var u1 = Math.random();
      var sqrt1u1 = Math.sqrt(1 - u1);
      var sqrtu1 = Math.sqrt(u1);
      var u2 = 2 * Math.PI * Math.random();
      var u3 = 2 * Math.PI * Math.random();
      return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
  }, {
    key: "equals",
    value: function equals(quaternion) {
      return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this._x = array[offset];
      this._y = array[offset + 1];
      this._z = array[offset + 2];
      this._w = array[offset + 3];

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      array[offset] = this._x;
      array[offset + 1] = this._y;
      array[offset + 2] = this._z;
      array[offset + 3] = this._w;
      return array;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(attribute, index) {
      this._x = attribute.getX(index);
      this._y = attribute.getY(index);
      this._z = attribute.getZ(index);
      this._w = attribute.getW(index);
      return this;
    }
  }, {
    key: "_onChange",
    value: function _onChange(callback) {
      this._onChangeCallback = callback;
      return this;
    }
  }, {
    key: "_onChangeCallback",
    value: function _onChangeCallback() {}
  }, {
    key: _Symbol$iterator4,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this._x;

            case 2:
              _context5.next = 4;
              return this._y;

            case 4:
              _context5.next = 6;
              return this._z;

            case 6:
              _context5.next = 8;
              return this._w;

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, value, this);
    })
  }], [{
    key: "slerp",
    value: function slerp(qa, qb, qm, t) {
      console.warn('THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead.');
      return qm.slerpQuaternions(qa, qb, t);
    }
  }, {
    key: "slerpFlat",
    value: function slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
      // fuzz-free, array-based Quaternion SLERP operation
      var x0 = src0[srcOffset0 + 0],
          y0 = src0[srcOffset0 + 1],
          z0 = src0[srcOffset0 + 2],
          w0 = src0[srcOffset0 + 3];
      var x1 = src1[srcOffset1 + 0],
          y1 = src1[srcOffset1 + 1],
          z1 = src1[srcOffset1 + 2],
          w1 = src1[srcOffset1 + 3];

      if (t === 0) {
        dst[dstOffset + 0] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
        return;
      }

      if (t === 1) {
        dst[dstOffset + 0] = x1;
        dst[dstOffset + 1] = y1;
        dst[dstOffset + 2] = z1;
        dst[dstOffset + 3] = w1;
        return;
      }

      if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
        var s = 1 - t;
        var cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,
            dir = cos >= 0 ? 1 : -1,
            sqrSin = 1 - cos * cos; // Skip the Slerp for tiny steps to avoid numeric problems:

        if (sqrSin > Number.EPSILON) {
          var sin = Math.sqrt(sqrSin),
              len = Math.atan2(sin, cos * dir);
          s = Math.sin(s * len) / sin;
          t = Math.sin(t * len) / sin;
        }

        var tDir = t * dir;
        x0 = x0 * s + x1 * tDir;
        y0 = y0 * s + y1 * tDir;
        z0 = z0 * s + z1 * tDir;
        w0 = w0 * s + w1 * tDir; // Normalize in case we just did a lerp:

        if (s === 1 - t) {
          var f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
          x0 *= f;
          y0 *= f;
          z0 *= f;
          w0 *= f;
        }
      }

      dst[dstOffset] = x0;
      dst[dstOffset + 1] = y0;
      dst[dstOffset + 2] = z0;
      dst[dstOffset + 3] = w0;
    }
  }, {
    key: "multiplyQuaternionsFlat",
    value: function multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
      var x0 = src0[srcOffset0];
      var y0 = src0[srcOffset0 + 1];
      var z0 = src0[srcOffset0 + 2];
      var w0 = src0[srcOffset0 + 3];
      var x1 = src1[srcOffset1];
      var y1 = src1[srcOffset1 + 1];
      var z1 = src1[srcOffset1 + 2];
      var w1 = src1[srcOffset1 + 3];
      dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
      dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
      dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
      dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
      return dst;
    }
  }]);

  return Quaternion;
}(Symbol.iterator);

Quaternion.prototype.isQuaternion = true;

var Vector3 = /*#__PURE__*/function (_Symbol$iterator5) {
  function Vector3() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck2(this, Vector3);

    this.x = x;
    this.y = y;
    this.z = z;
  }

  _createClass2(Vector3, [{
    key: "set",
    value: function set(x, y, z) {
      if (z === undefined) z = this.z; // sprite.scale.set(x,y)

      this.x = x;
      this.y = y;
      this.z = z;
      return this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(scalar) {
      this.x = scalar;
      this.y = scalar;
      this.z = scalar;
      return this;
    }
  }, {
    key: "setX",
    value: function setX(x) {
      this.x = x;
      return this;
    }
  }, {
    key: "setY",
    value: function setY(y) {
      this.y = y;
      return this;
    }
  }, {
    key: "setZ",
    value: function setZ(z) {
      this.z = z;
      return this;
    }
  }, {
    key: "setComponent",
    value: function setComponent(index, value) {
      switch (index) {
        case 0:
          this.x = value;
          break;

        case 1:
          this.y = value;
          break;

        case 2:
          this.z = value;
          break;

        default:
          throw new Error('index is out of range: ' + index);
      }

      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(index) {
      switch (index) {
        case 0:
          return this.x;

        case 1:
          return this.y;

        case 2:
          return this.z;

        default:
          throw new Error('index is out of range: ' + index);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.x, this.y, this.z);
    }
  }, {
    key: "copy",
    value: function copy(v) {
      this.x = v.x;
      this.y = v.y;
      this.z = v.z;
      return this;
    }
  }, {
    key: "add",
    value: function add(v, w) {
      if (w !== undefined) {
        console.warn('THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
        return this.addVectors(v, w);
      }

      this.x += v.x;
      this.y += v.y;
      this.z += v.z;
      return this;
    }
  }, {
    key: "addScalar",
    value: function addScalar(s) {
      this.x += s;
      this.y += s;
      this.z += s;
      return this;
    }
  }, {
    key: "addVectors",
    value: function addVectors(a, b) {
      this.x = a.x + b.x;
      this.y = a.y + b.y;
      this.z = a.z + b.z;
      return this;
    }
  }, {
    key: "addScaledVector",
    value: function addScaledVector(v, s) {
      this.x += v.x * s;
      this.y += v.y * s;
      this.z += v.z * s;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(v, w) {
      if (w !== undefined) {
        console.warn('THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
        return this.subVectors(v, w);
      }

      this.x -= v.x;
      this.y -= v.y;
      this.z -= v.z;
      return this;
    }
  }, {
    key: "subScalar",
    value: function subScalar(s) {
      this.x -= s;
      this.y -= s;
      this.z -= s;
      return this;
    }
  }, {
    key: "subVectors",
    value: function subVectors(a, b) {
      this.x = a.x - b.x;
      this.y = a.y - b.y;
      this.z = a.z - b.z;
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(v, w) {
      if (w !== undefined) {
        console.warn('THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.');
        return this.multiplyVectors(v, w);
      }

      this.x *= v.x;
      this.y *= v.y;
      this.z *= v.z;
      return this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(scalar) {
      this.x *= scalar;
      this.y *= scalar;
      this.z *= scalar;
      return this;
    }
  }, {
    key: "multiplyVectors",
    value: function multiplyVectors(a, b) {
      this.x = a.x * b.x;
      this.y = a.y * b.y;
      this.z = a.z * b.z;
      return this;
    }
  }, {
    key: "applyEuler",
    value: function applyEuler(euler) {
      if (!(euler && euler.isEuler)) {
        console.error('THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.');
      }

      return this.applyQuaternion(_quaternion$4.setFromEuler(euler));
    }
  }, {
    key: "applyAxisAngle",
    value: function applyAxisAngle(axis, angle) {
      return this.applyQuaternion(_quaternion$4.setFromAxisAngle(axis, angle));
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(m) {
      var x = this.x,
          y = this.y,
          z = this.z;
      var e = m.elements;
      this.x = e[0] * x + e[3] * y + e[6] * z;
      this.y = e[1] * x + e[4] * y + e[7] * z;
      this.z = e[2] * x + e[5] * y + e[8] * z;
      return this;
    }
  }, {
    key: "applyNormalMatrix",
    value: function applyNormalMatrix(m) {
      return this.applyMatrix3(m).normalize();
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(m) {
      var x = this.x,
          y = this.y,
          z = this.z;
      var e = m.elements;
      var w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
      this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
      this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
      this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
      return this;
    }
  }, {
    key: "applyQuaternion",
    value: function applyQuaternion(q) {
      var x = this.x,
          y = this.y,
          z = this.z;
      var qx = q.x,
          qy = q.y,
          qz = q.z,
          qw = q.w; // calculate quat * vector

      var ix = qw * x + qy * z - qz * y;
      var iy = qw * y + qz * x - qx * z;
      var iz = qw * z + qx * y - qy * x;
      var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat

      this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
      this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
      this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
      return this;
    }
  }, {
    key: "project",
    value: function project(camera) {
      return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
  }, {
    key: "unproject",
    value: function unproject(camera) {
      return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
  }, {
    key: "transformDirection",
    value: function transformDirection(m) {
      // input: THREE.Matrix4 affine matrix
      // vector interpreted as a direction
      var x = this.x,
          y = this.y,
          z = this.z;
      var e = m.elements;
      this.x = e[0] * x + e[4] * y + e[8] * z;
      this.y = e[1] * x + e[5] * y + e[9] * z;
      this.z = e[2] * x + e[6] * y + e[10] * z;
      return this.normalize();
    }
  }, {
    key: "divide",
    value: function divide(v) {
      this.x /= v.x;
      this.y /= v.y;
      this.z /= v.z;
      return this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(scalar) {
      return this.multiplyScalar(1 / scalar);
    }
  }, {
    key: "min",
    value: function min(v) {
      this.x = Math.min(this.x, v.x);
      this.y = Math.min(this.y, v.y);
      this.z = Math.min(this.z, v.z);
      return this;
    }
  }, {
    key: "max",
    value: function max(v) {
      this.x = Math.max(this.x, v.x);
      this.y = Math.max(this.y, v.y);
      this.z = Math.max(this.z, v.z);
      return this;
    }
  }, {
    key: "clamp",
    value: function clamp(min, max) {
      // assumes min < max, componentwise
      this.x = Math.max(min.x, Math.min(max.x, this.x));
      this.y = Math.max(min.y, Math.min(max.y, this.y));
      this.z = Math.max(min.z, Math.min(max.z, this.z));
      return this;
    }
  }, {
    key: "clampScalar",
    value: function clampScalar(minVal, maxVal) {
      this.x = Math.max(minVal, Math.min(maxVal, this.x));
      this.y = Math.max(minVal, Math.min(maxVal, this.y));
      this.z = Math.max(minVal, Math.min(maxVal, this.z));
      return this;
    }
  }, {
    key: "clampLength",
    value: function clampLength(min, max) {
      var length = this.length();
      return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
  }, {
    key: "floor",
    value: function floor() {
      this.x = Math.floor(this.x);
      this.y = Math.floor(this.y);
      this.z = Math.floor(this.z);
      return this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      this.x = Math.ceil(this.x);
      this.y = Math.ceil(this.y);
      this.z = Math.ceil(this.z);
      return this;
    }
  }, {
    key: "round",
    value: function round() {
      this.x = Math.round(this.x);
      this.y = Math.round(this.y);
      this.z = Math.round(this.z);
      return this;
    }
  }, {
    key: "roundToZero",
    value: function roundToZero() {
      this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
      this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
      this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
      return this;
    }
  }, {
    key: "negate",
    value: function negate() {
      this.x = -this.x;
      this.y = -this.y;
      this.z = -this.z;
      return this;
    }
  }, {
    key: "dot",
    value: function dot(v) {
      return this.x * v.x + this.y * v.y + this.z * v.z;
    } // TODO lengthSquared?

  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
  }, {
    key: "manhattanLength",
    value: function manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.divideScalar(this.length() || 1);
    }
  }, {
    key: "setLength",
    value: function setLength(length) {
      return this.normalize().multiplyScalar(length);
    }
  }, {
    key: "lerp",
    value: function lerp(v, alpha) {
      this.x += (v.x - this.x) * alpha;
      this.y += (v.y - this.y) * alpha;
      this.z += (v.z - this.z) * alpha;
      return this;
    }
  }, {
    key: "lerpVectors",
    value: function lerpVectors(v1, v2, alpha) {
      this.x = v1.x + (v2.x - v1.x) * alpha;
      this.y = v1.y + (v2.y - v1.y) * alpha;
      this.z = v1.z + (v2.z - v1.z) * alpha;
      return this;
    }
  }, {
    key: "cross",
    value: function cross(v, w) {
      if (w !== undefined) {
        console.warn('THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.');
        return this.crossVectors(v, w);
      }

      return this.crossVectors(this, v);
    }
  }, {
    key: "crossVectors",
    value: function crossVectors(a, b) {
      var ax = a.x,
          ay = a.y,
          az = a.z;
      var bx = b.x,
          by = b.y,
          bz = b.z;
      this.x = ay * bz - az * by;
      this.y = az * bx - ax * bz;
      this.z = ax * by - ay * bx;
      return this;
    }
  }, {
    key: "projectOnVector",
    value: function projectOnVector(v) {
      var denominator = v.lengthSq();
      if (denominator === 0) return this.set(0, 0, 0);
      var scalar = v.dot(this) / denominator;
      return this.copy(v).multiplyScalar(scalar);
    }
  }, {
    key: "projectOnPlane",
    value: function projectOnPlane(planeNormal) {
      _vector$c.copy(this).projectOnVector(planeNormal);

      return this.sub(_vector$c);
    }
  }, {
    key: "reflect",
    value: function reflect(normal) {
      // reflect incident vector off plane orthogonal to normal
      // normal is assumed to have unit length
      return this.sub(_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
  }, {
    key: "angleTo",
    value: function angleTo(v) {
      var denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
      if (denominator === 0) return Math.PI / 2;
      var theta = this.dot(v) / denominator; // clamp, to handle numerical problems

      return Math.acos(clamp(theta, -1, 1));
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(v) {
      return Math.sqrt(this.distanceToSquared(v));
    }
  }, {
    key: "distanceToSquared",
    value: function distanceToSquared(v) {
      var dx = this.x - v.x,
          dy = this.y - v.y,
          dz = this.z - v.z;
      return dx * dx + dy * dy + dz * dz;
    }
  }, {
    key: "manhattanDistanceTo",
    value: function manhattanDistanceTo(v) {
      return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
  }, {
    key: "setFromSpherical",
    value: function setFromSpherical(s) {
      return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
  }, {
    key: "setFromSphericalCoords",
    value: function setFromSphericalCoords(radius, phi, theta) {
      var sinPhiRadius = Math.sin(phi) * radius;
      this.x = sinPhiRadius * Math.sin(theta);
      this.y = Math.cos(phi) * radius;
      this.z = sinPhiRadius * Math.cos(theta);
      return this;
    }
  }, {
    key: "setFromCylindrical",
    value: function setFromCylindrical(c) {
      return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
  }, {
    key: "setFromCylindricalCoords",
    value: function setFromCylindricalCoords(radius, theta, y) {
      this.x = radius * Math.sin(theta);
      this.y = y;
      this.z = radius * Math.cos(theta);
      return this;
    }
  }, {
    key: "setFromMatrixPosition",
    value: function setFromMatrixPosition(m) {
      var e = m.elements;
      this.x = e[12];
      this.y = e[13];
      this.z = e[14];
      return this;
    }
  }, {
    key: "setFromMatrixScale",
    value: function setFromMatrixScale(m) {
      var sx = this.setFromMatrixColumn(m, 0).length();
      var sy = this.setFromMatrixColumn(m, 1).length();
      var sz = this.setFromMatrixColumn(m, 2).length();
      this.x = sx;
      this.y = sy;
      this.z = sz;
      return this;
    }
  }, {
    key: "setFromMatrixColumn",
    value: function setFromMatrixColumn(m, index) {
      return this.fromArray(m.elements, index * 4);
    }
  }, {
    key: "setFromMatrix3Column",
    value: function setFromMatrix3Column(m, index) {
      return this.fromArray(m.elements, index * 3);
    }
  }, {
    key: "setFromEuler",
    value: function setFromEuler(e) {
      this.x = e._x;
      this.y = e._y;
      this.z = e._z;
      return this;
    }
  }, {
    key: "equals",
    value: function equals(v) {
      return v.x === this.x && v.y === this.y && v.z === this.z;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.x = array[offset];
      this.y = array[offset + 1];
      this.z = array[offset + 2];
      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      array[offset] = this.x;
      array[offset + 1] = this.y;
      array[offset + 2] = this.z;
      return array;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(attribute, index, offset) {
      if (offset !== undefined) {
        console.warn('THREE.Vector3: offset has been removed from .fromBufferAttribute().');
      }

      this.x = attribute.getX(index);
      this.y = attribute.getY(index);
      this.z = attribute.getZ(index);
      return this;
    }
  }, {
    key: "random",
    value: function random() {
      this.x = Math.random();
      this.y = Math.random();
      this.z = Math.random();
      return this;
    }
  }, {
    key: "randomDirection",
    value: function randomDirection() {
      // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
      var u = (Math.random() - 0.5) * 2;
      var t = Math.random() * Math.PI * 2;
      var f = Math.sqrt(1 - Math.pow(u, 2));
      this.x = f * Math.cos(t);
      this.y = f * Math.sin(t);
      this.z = u;
      return this;
    }
  }, {
    key: _Symbol$iterator5,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.x;

            case 2:
              _context6.next = 4;
              return this.y;

            case 4:
              _context6.next = 6;
              return this.z;

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Vector3;
}(Symbol.iterator);

Vector3.prototype.isVector3 = true;

var _vector$c = /*@__PURE__*/new Vector3();

var _quaternion$4 = /*@__PURE__*/new Quaternion();

var Box3 = /*#__PURE__*/function () {
  function Box3() {
    var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3(+Infinity, +Infinity, +Infinity);
    var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3(-Infinity, -Infinity, -Infinity);

    _classCallCheck2(this, Box3);

    this.min = min;
    this.max = max;
  }

  _createClass2(Box3, [{
    key: "set",
    value: function set(min, max) {
      this.min.copy(min);
      this.max.copy(max);
      return this;
    }
  }, {
    key: "setFromArray",
    value: function setFromArray(array) {
      var minX = +Infinity;
      var minY = +Infinity;
      var minZ = +Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;
      var maxZ = -Infinity;

      for (var _i11 = 0, l = array.length; _i11 < l; _i11 += 3) {
        var x = array[_i11];
        var y = array[_i11 + 1];
        var z = array[_i11 + 2];
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (z < minZ) minZ = z;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        if (z > maxZ) maxZ = z;
      }

      this.min.set(minX, minY, minZ);
      this.max.set(maxX, maxY, maxZ);
      return this;
    }
  }, {
    key: "setFromBufferAttribute",
    value: function setFromBufferAttribute(attribute) {
      var minX = +Infinity;
      var minY = +Infinity;
      var minZ = +Infinity;
      var maxX = -Infinity;
      var maxY = -Infinity;
      var maxZ = -Infinity;

      for (var _i12 = 0, l = attribute.count; _i12 < l; _i12++) {
        var x = attribute.getX(_i12);
        var y = attribute.getY(_i12);
        var z = attribute.getZ(_i12);
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (z < minZ) minZ = z;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
        if (z > maxZ) maxZ = z;
      }

      this.min.set(minX, minY, minZ);
      this.max.set(maxX, maxY, maxZ);
      return this;
    }
  }, {
    key: "setFromPoints",
    value: function setFromPoints(points) {
      this.makeEmpty();

      for (var _i13 = 0, il = points.length; _i13 < il; _i13++) {
        this.expandByPoint(points[_i13]);
      }

      return this;
    }
  }, {
    key: "setFromCenterAndSize",
    value: function setFromCenterAndSize(center, size) {
      var halfSize = _vector$b.copy(size).multiplyScalar(0.5);

      this.min.copy(center).sub(halfSize);
      this.max.copy(center).add(halfSize);
      return this;
    }
  }, {
    key: "setFromObject",
    value: function setFromObject(object) {
      var precise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.makeEmpty();
      return this.expandByObject(object, precise);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(box) {
      this.min.copy(box.min);
      this.max.copy(box.max);
      return this;
    }
  }, {
    key: "makeEmpty",
    value: function makeEmpty() {
      this.min.x = this.min.y = this.min.z = +Infinity;
      this.max.x = this.max.y = this.max.z = -Infinity;
      return this;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
      return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
  }, {
    key: "getCenter",
    value: function getCenter(target) {
      return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
  }, {
    key: "getSize",
    value: function getSize(target) {
      return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
  }, {
    key: "expandByPoint",
    value: function expandByPoint(point) {
      this.min.min(point);
      this.max.max(point);
      return this;
    }
  }, {
    key: "expandByVector",
    value: function expandByVector(vector) {
      this.min.sub(vector);
      this.max.add(vector);
      return this;
    }
  }, {
    key: "expandByScalar",
    value: function expandByScalar(scalar) {
      this.min.addScalar(-scalar);
      this.max.addScalar(scalar);
      return this;
    }
  }, {
    key: "expandByObject",
    value: function expandByObject(object) {
      var precise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // Computes the world-axis-aligned bounding box of an object (including its children),
      // accounting for both the object's, and children's, world transforms
      object.updateWorldMatrix(false, false);
      var geometry = object.geometry;

      if (geometry !== undefined) {
        if (precise && geometry.attributes != undefined && geometry.attributes.position !== undefined) {
          var position = geometry.attributes.position;

          for (var _i14 = 0, l = position.count; _i14 < l; _i14++) {
            _vector$b.fromBufferAttribute(position, _i14).applyMatrix4(object.matrixWorld);

            this.expandByPoint(_vector$b);
          }
        } else {
          if (geometry.boundingBox === null) {
            geometry.computeBoundingBox();
          }

          _box$3.copy(geometry.boundingBox);

          _box$3.applyMatrix4(object.matrixWorld);

          this.union(_box$3);
        }
      }

      var children = object.children;

      for (var _i15 = 0, _l = children.length; _i15 < _l; _i15++) {
        this.expandByObject(children[_i15], precise);
      }

      return this;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(point) {
      return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
  }, {
    key: "containsBox",
    value: function containsBox(box) {
      return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
  }, {
    key: "getParameter",
    value: function getParameter(point, target) {
      // This can potentially have a divide by zero if the box
      // has a size dimension of 0.
      return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(box) {
      // using 6 splitting planes to rule out intersections.
      return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(sphere) {
      // Find the point on the AABB closest to the sphere center.
      this.clampPoint(sphere.center, _vector$b); // If that point is inside the sphere, the AABB and sphere intersect.

      return _vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
  }, {
    key: "intersectsPlane",
    value: function intersectsPlane(plane) {
      // We compute the minimum and maximum dot product values. If those values
      // are on the same side (back or front) of the plane, then there is no intersection.
      var min, max;

      if (plane.normal.x > 0) {
        min = plane.normal.x * this.min.x;
        max = plane.normal.x * this.max.x;
      } else {
        min = plane.normal.x * this.max.x;
        max = plane.normal.x * this.min.x;
      }

      if (plane.normal.y > 0) {
        min += plane.normal.y * this.min.y;
        max += plane.normal.y * this.max.y;
      } else {
        min += plane.normal.y * this.max.y;
        max += plane.normal.y * this.min.y;
      }

      if (plane.normal.z > 0) {
        min += plane.normal.z * this.min.z;
        max += plane.normal.z * this.max.z;
      } else {
        min += plane.normal.z * this.max.z;
        max += plane.normal.z * this.min.z;
      }

      return min <= -plane.constant && max >= -plane.constant;
    }
  }, {
    key: "intersectsTriangle",
    value: function intersectsTriangle(triangle) {
      if (this.isEmpty()) {
        return false;
      } // compute box center and extents


      this.getCenter(_center);

      _extents.subVectors(this.max, _center); // translate triangle to aabb origin


      _v0$2.subVectors(triangle.a, _center);

      _v1$7.subVectors(triangle.b, _center);

      _v2$3.subVectors(triangle.c, _center); // compute edge vectors for triangle


      _f0.subVectors(_v1$7, _v0$2);

      _f1.subVectors(_v2$3, _v1$7);

      _f2.subVectors(_v0$2, _v2$3); // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
      // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
      // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)


      var axes = [0, -_f0.z, _f0.y, 0, -_f1.z, _f1.y, 0, -_f2.z, _f2.y, _f0.z, 0, -_f0.x, _f1.z, 0, -_f1.x, _f2.z, 0, -_f2.x, -_f0.y, _f0.x, 0, -_f1.y, _f1.x, 0, -_f2.y, _f2.x, 0];

      if (!satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents)) {
        return false;
      } // test 3 face normals from the aabb


      axes = [1, 0, 0, 0, 1, 0, 0, 0, 1];

      if (!satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents)) {
        return false;
      } // finally testing the face normal of the triangle
      // use already existing triangle edge vectors here


      _triangleNormal.crossVectors(_f0, _f1);

      axes = [_triangleNormal.x, _triangleNormal.y, _triangleNormal.z];
      return satForAxes(axes, _v0$2, _v1$7, _v2$3, _extents);
    }
  }, {
    key: "clampPoint",
    value: function clampPoint(point, target) {
      return target.copy(point).clamp(this.min, this.max);
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(point) {
      var clampedPoint = _vector$b.copy(point).clamp(this.min, this.max);

      return clampedPoint.sub(point).length();
    }
  }, {
    key: "getBoundingSphere",
    value: function getBoundingSphere(target) {
      this.getCenter(target.center);
      target.radius = this.getSize(_vector$b).length() * 0.5;
      return target;
    }
  }, {
    key: "intersect",
    value: function intersect(box) {
      this.min.max(box.min);
      this.max.min(box.max); // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.

      if (this.isEmpty()) this.makeEmpty();
      return this;
    }
  }, {
    key: "union",
    value: function union(box) {
      this.min.min(box.min);
      this.max.max(box.max);
      return this;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(matrix) {
      // transform of empty box is an empty box.
      if (this.isEmpty()) return this; // NOTE: I am using a binary pattern to specify all 2^3 combinations below

      _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000


      _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001


      _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010


      _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011


      _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100


      _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101


      _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110


      _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111


      this.setFromPoints(_points);
      return this;
    }
  }, {
    key: "translate",
    value: function translate(offset) {
      this.min.add(offset);
      this.max.add(offset);
      return this;
    }
  }, {
    key: "equals",
    value: function equals(box) {
      return box.min.equals(this.min) && box.max.equals(this.max);
    }
  }]);

  return Box3;
}();

Box3.prototype.isBox3 = true;
var _points = [/*@__PURE__*/new Vector3(), /*@__PURE__*/new Vector3(), /*@__PURE__*/new Vector3(), /*@__PURE__*/new Vector3(), /*@__PURE__*/new Vector3(), /*@__PURE__*/new Vector3(), /*@__PURE__*/new Vector3(), /*@__PURE__*/new Vector3()];

var _vector$b = /*@__PURE__*/new Vector3();

var _box$3 = /*@__PURE__*/new Box3(); // triangle centered vertices


var _v0$2 = /*@__PURE__*/new Vector3();

var _v1$7 = /*@__PURE__*/new Vector3();

var _v2$3 = /*@__PURE__*/new Vector3(); // triangle edge vectors


var _f0 = /*@__PURE__*/new Vector3();

var _f1 = /*@__PURE__*/new Vector3();

var _f2 = /*@__PURE__*/new Vector3();

var _center = /*@__PURE__*/new Vector3();

var _extents = /*@__PURE__*/new Vector3();

var _triangleNormal = /*@__PURE__*/new Vector3();

var _testAxis = /*@__PURE__*/new Vector3();

function satForAxes(axes, v0, v1, v2, extents) {
  for (var _i16 = 0, j = axes.length - 3; _i16 <= j; _i16 += 3) {
    _testAxis.fromArray(axes, _i16); // project the aabb onto the separating axis


    var r = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z); // project all 3 vertices of the triangle onto the separating axis

    var p0 = v0.dot(_testAxis);
    var p1 = v1.dot(_testAxis);
    var p2 = v2.dot(_testAxis); // actual test, basically see if either of the most extreme of the triangle points intersects r

    if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) {
      // points of the projected triangle are outside the projected half-length of the aabb
      // the axis is separating and we can exit
      return false;
    }
  }

  return true;
}

var _box$2 = /*@__PURE__*/new Box3();

var _v1$6 = /*@__PURE__*/new Vector3();

var _toFarthestPoint = /*@__PURE__*/new Vector3();

var _toPoint = /*@__PURE__*/new Vector3();

var Sphere = /*#__PURE__*/function () {
  function Sphere() {
    var center = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
    var radius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

    _classCallCheck2(this, Sphere);

    this.center = center;
    this.radius = radius;
  }

  _createClass2(Sphere, [{
    key: "set",
    value: function set(center, radius) {
      this.center.copy(center);
      this.radius = radius;
      return this;
    }
  }, {
    key: "setFromPoints",
    value: function setFromPoints(points, optionalCenter) {
      var center = this.center;

      if (optionalCenter !== undefined) {
        center.copy(optionalCenter);
      } else {
        _box$2.setFromPoints(points).getCenter(center);
      }

      var maxRadiusSq = 0;

      for (var _i17 = 0, il = points.length; _i17 < il; _i17++) {
        maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[_i17]));
      }

      this.radius = Math.sqrt(maxRadiusSq);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(sphere) {
      this.center.copy(sphere.center);
      this.radius = sphere.radius;
      return this;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this.radius < 0;
    }
  }, {
    key: "makeEmpty",
    value: function makeEmpty() {
      this.center.set(0, 0, 0);
      this.radius = -1;
      return this;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(point) {
      return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(point) {
      return point.distanceTo(this.center) - this.radius;
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(sphere) {
      var radiusSum = this.radius + sphere.radius;
      return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(box) {
      return box.intersectsSphere(this);
    }
  }, {
    key: "intersectsPlane",
    value: function intersectsPlane(plane) {
      return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
  }, {
    key: "clampPoint",
    value: function clampPoint(point, target) {
      var deltaLengthSq = this.center.distanceToSquared(point);
      target.copy(point);

      if (deltaLengthSq > this.radius * this.radius) {
        target.sub(this.center).normalize();
        target.multiplyScalar(this.radius).add(this.center);
      }

      return target;
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox(target) {
      if (this.isEmpty()) {
        // Empty sphere produces empty bounding box
        target.makeEmpty();
        return target;
      }

      target.set(this.center, this.center);
      target.expandByScalar(this.radius);
      return target;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(matrix) {
      this.center.applyMatrix4(matrix);
      this.radius = this.radius * matrix.getMaxScaleOnAxis();
      return this;
    }
  }, {
    key: "translate",
    value: function translate(offset) {
      this.center.add(offset);
      return this;
    }
  }, {
    key: "expandByPoint",
    value: function expandByPoint(point) {
      // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L649-L671
      _toPoint.subVectors(point, this.center);

      var lengthSq = _toPoint.lengthSq();

      if (lengthSq > this.radius * this.radius) {
        var _length = Math.sqrt(lengthSq);

        var missingRadiusHalf = (_length - this.radius) * 0.5; // Nudge this sphere towards the target point. Add half the missing distance to radius,
        // and the other half to position. This gives a tighter enclosure, instead of if
        // the whole missing distance were just added to radius.

        this.center.add(_toPoint.multiplyScalar(missingRadiusHalf / _length));
        this.radius += missingRadiusHalf;
      }

      return this;
    }
  }, {
    key: "union",
    value: function union(sphere) {
      // from https://github.com/juj/MathGeoLib/blob/2940b99b99cfe575dd45103ef20f4019dee15b54/src/Geometry/Sphere.cpp#L759-L769
      // To enclose another sphere into this sphere, we only need to enclose two points:
      // 1) Enclose the farthest point on the other sphere into this sphere.
      // 2) Enclose the opposite point of the farthest point into this sphere.
      if (this.center.equals(sphere.center) === true) {
        _toFarthestPoint.set(0, 0, 1).multiplyScalar(sphere.radius);
      } else {
        _toFarthestPoint.subVectors(sphere.center, this.center).normalize().multiplyScalar(sphere.radius);
      }

      this.expandByPoint(_v1$6.copy(sphere.center).add(_toFarthestPoint));
      this.expandByPoint(_v1$6.copy(sphere.center).sub(_toFarthestPoint));
      return this;
    }
  }, {
    key: "equals",
    value: function equals(sphere) {
      return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Sphere;
}();

var _vector$a = /*@__PURE__*/new Vector3();

var _segCenter = /*@__PURE__*/new Vector3();

var _segDir = /*@__PURE__*/new Vector3();

var _diff = /*@__PURE__*/new Vector3();

var _edge1 = /*@__PURE__*/new Vector3();

var _edge2 = /*@__PURE__*/new Vector3();

var _normal$1 = /*@__PURE__*/new Vector3();

var Ray = /*#__PURE__*/function () {
  function Ray() {
    var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3(0, 0, -1);

    _classCallCheck2(this, Ray);

    this.origin = origin;
    this.direction = direction;
  }

  _createClass2(Ray, [{
    key: "set",
    value: function set(origin, direction) {
      this.origin.copy(origin);
      this.direction.copy(direction);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(ray) {
      this.origin.copy(ray.origin);
      this.direction.copy(ray.direction);
      return this;
    }
  }, {
    key: "at",
    value: function at(t, target) {
      return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
  }, {
    key: "lookAt",
    value: function lookAt(v) {
      this.direction.copy(v).sub(this.origin).normalize();
      return this;
    }
  }, {
    key: "recast",
    value: function recast(t) {
      this.origin.copy(this.at(t, _vector$a));
      return this;
    }
  }, {
    key: "closestPointToPoint",
    value: function closestPointToPoint(point, target) {
      target.subVectors(point, this.origin);
      var directionDistance = target.dot(this.direction);

      if (directionDistance < 0) {
        return target.copy(this.origin);
      }

      return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(point) {
      return Math.sqrt(this.distanceSqToPoint(point));
    }
  }, {
    key: "distanceSqToPoint",
    value: function distanceSqToPoint(point) {
      var directionDistance = _vector$a.subVectors(point, this.origin).dot(this.direction); // point behind the ray


      if (directionDistance < 0) {
        return this.origin.distanceToSquared(point);
      }

      _vector$a.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);

      return _vector$a.distanceToSquared(point);
    }
  }, {
    key: "distanceSqToSegment",
    value: function distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
      // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
      // It returns the min distance between the ray and the segment
      // defined by v0 and v1
      // It can also set two optional targets :
      // - The closest point on the ray
      // - The closest point on the segment
      _segCenter.copy(v0).add(v1).multiplyScalar(0.5);

      _segDir.copy(v1).sub(v0).normalize();

      _diff.copy(this.origin).sub(_segCenter);

      var segExtent = v0.distanceTo(v1) * 0.5;
      var a01 = -this.direction.dot(_segDir);

      var b0 = _diff.dot(this.direction);

      var b1 = -_diff.dot(_segDir);

      var c = _diff.lengthSq();

      var det = Math.abs(1 - a01 * a01);
      var s0, s1, sqrDist, extDet;

      if (det > 0) {
        // The ray and segment are not parallel.
        s0 = a01 * b1 - b0;
        s1 = a01 * b0 - b1;
        extDet = segExtent * det;

        if (s0 >= 0) {
          if (s1 >= -extDet) {
            if (s1 <= extDet) {
              // region 0
              // Minimum at interior points of ray and segment.
              var invDet = 1 / det;
              s0 *= invDet;
              s1 *= invDet;
              sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
            } else {
              // region 1
              s1 = segExtent;
              s0 = Math.max(0, -(a01 * s1 + b0));
              sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
            }
          } else {
            // region 5
            s1 = -segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
          }
        } else {
          if (s1 <= -extDet) {
            // region 4
            s0 = Math.max(0, -(-a01 * segExtent + b0));
            s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
          } else if (s1 <= extDet) {
            // region 3
            s0 = 0;
            s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
            sqrDist = s1 * (s1 + 2 * b1) + c;
          } else {
            // region 2
            s0 = Math.max(0, -(a01 * segExtent + b0));
            s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
          }
        }
      } else {
        // Ray and segment are parallel.
        s1 = a01 > 0 ? -segExtent : segExtent;
        s0 = Math.max(0, -(a01 * s1 + b0));
        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
      }

      if (optionalPointOnRay) {
        optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
      }

      if (optionalPointOnSegment) {
        optionalPointOnSegment.copy(_segDir).multiplyScalar(s1).add(_segCenter);
      }

      return sqrDist;
    }
  }, {
    key: "intersectSphere",
    value: function intersectSphere(sphere, target) {
      _vector$a.subVectors(sphere.center, this.origin);

      var tca = _vector$a.dot(this.direction);

      var d2 = _vector$a.dot(_vector$a) - tca * tca;
      var radius2 = sphere.radius * sphere.radius;
      if (d2 > radius2) return null;
      var thc = Math.sqrt(radius2 - d2); // t0 = first intersect point - entrance on front of sphere

      var t0 = tca - thc; // t1 = second intersect point - exit point on back of sphere

      var t1 = tca + thc; // test to see if both t0 and t1 are behind the ray - if so, return null

      if (t0 < 0 && t1 < 0) return null; // test to see if t0 is behind the ray:
      // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
      // in order to always return an intersect point that is in front of the ray.

      if (t0 < 0) return this.at(t1, target); // else t0 is in front of the ray, so return the first collision point scaled by t0

      return this.at(t0, target);
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(sphere) {
      return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
  }, {
    key: "distanceToPlane",
    value: function distanceToPlane(plane) {
      var denominator = plane.normal.dot(this.direction);

      if (denominator === 0) {
        // line is coplanar, return origin
        if (plane.distanceToPoint(this.origin) === 0) {
          return 0;
        } // Null is preferable to undefined since undefined means.... it is undefined


        return null;
      }

      var t = -(this.origin.dot(plane.normal) + plane.constant) / denominator; // Return if the ray never intersects the plane

      return t >= 0 ? t : null;
    }
  }, {
    key: "intersectPlane",
    value: function intersectPlane(plane, target) {
      var t = this.distanceToPlane(plane);

      if (t === null) {
        return null;
      }

      return this.at(t, target);
    }
  }, {
    key: "intersectsPlane",
    value: function intersectsPlane(plane) {
      // check if the ray lies on the plane first
      var distToPoint = plane.distanceToPoint(this.origin);

      if (distToPoint === 0) {
        return true;
      }

      var denominator = plane.normal.dot(this.direction);

      if (denominator * distToPoint < 0) {
        return true;
      } // ray origin is behind the plane (and is pointing behind it)


      return false;
    }
  }, {
    key: "intersectBox",
    value: function intersectBox(box, target) {
      var tmin, tmax, tymin, tymax, tzmin, tzmax;
      var invdirx = 1 / this.direction.x,
          invdiry = 1 / this.direction.y,
          invdirz = 1 / this.direction.z;
      var origin = this.origin;

      if (invdirx >= 0) {
        tmin = (box.min.x - origin.x) * invdirx;
        tmax = (box.max.x - origin.x) * invdirx;
      } else {
        tmin = (box.max.x - origin.x) * invdirx;
        tmax = (box.min.x - origin.x) * invdirx;
      }

      if (invdiry >= 0) {
        tymin = (box.min.y - origin.y) * invdiry;
        tymax = (box.max.y - origin.y) * invdiry;
      } else {
        tymin = (box.max.y - origin.y) * invdiry;
        tymax = (box.min.y - origin.y) * invdiry;
      }

      if (tmin > tymax || tymin > tmax) return null; // These lines also handle the case where tmin or tmax is NaN
      // (result of 0 * Infinity). x !== x returns true if x is NaN

      if (tymin > tmin || tmin !== tmin) tmin = tymin;
      if (tymax < tmax || tmax !== tmax) tmax = tymax;

      if (invdirz >= 0) {
        tzmin = (box.min.z - origin.z) * invdirz;
        tzmax = (box.max.z - origin.z) * invdirz;
      } else {
        tzmin = (box.max.z - origin.z) * invdirz;
        tzmax = (box.min.z - origin.z) * invdirz;
      }

      if (tmin > tzmax || tzmin > tmax) return null;
      if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
      if (tzmax < tmax || tmax !== tmax) tmax = tzmax; //return point closest to the ray (positive side)

      if (tmax < 0) return null;
      return this.at(tmin >= 0 ? tmin : tmax, target);
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(box) {
      return this.intersectBox(box, _vector$a) !== null;
    }
  }, {
    key: "intersectTriangle",
    value: function intersectTriangle(a, b, c, backfaceCulling, target) {
      // Compute the offset origin, edges, and normal.
      // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
      _edge1.subVectors(b, a);

      _edge2.subVectors(c, a);

      _normal$1.crossVectors(_edge1, _edge2); // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
      // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
      //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
      //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
      //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)


      var DdN = this.direction.dot(_normal$1);
      var sign;

      if (DdN > 0) {
        if (backfaceCulling) return null;
        sign = 1;
      } else if (DdN < 0) {
        sign = -1;
        DdN = -DdN;
      } else {
        return null;
      }

      _diff.subVectors(this.origin, a);

      var DdQxE2 = sign * this.direction.dot(_edge2.crossVectors(_diff, _edge2)); // b1 < 0, no intersection

      if (DdQxE2 < 0) {
        return null;
      }

      var DdE1xQ = sign * this.direction.dot(_edge1.cross(_diff)); // b2 < 0, no intersection

      if (DdE1xQ < 0) {
        return null;
      } // b1+b2 > 1, no intersection


      if (DdQxE2 + DdE1xQ > DdN) {
        return null;
      } // Line intersects triangle, check if ray does.


      var QdN = -sign * _diff.dot(_normal$1); // t < 0, no intersection


      if (QdN < 0) {
        return null;
      } // Ray intersects triangle.


      return this.at(QdN / DdN, target);
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(matrix4) {
      this.origin.applyMatrix4(matrix4);
      this.direction.transformDirection(matrix4);
      return this;
    }
  }, {
    key: "equals",
    value: function equals(ray) {
      return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Ray;
}();

var Matrix4 = /*#__PURE__*/function () {
  function Matrix4() {
    _classCallCheck2(this, Matrix4);

    this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];

    if (arguments.length > 0) {
      console.error('THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.');
    }
  }

  _createClass2(Matrix4, [{
    key: "set",
    value: function set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
      var te = this.elements;
      te[0] = n11;
      te[4] = n12;
      te[8] = n13;
      te[12] = n14;
      te[1] = n21;
      te[5] = n22;
      te[9] = n23;
      te[13] = n24;
      te[2] = n31;
      te[6] = n32;
      te[10] = n33;
      te[14] = n34;
      te[3] = n41;
      te[7] = n42;
      te[11] = n43;
      te[15] = n44;
      return this;
    }
  }, {
    key: "identity",
    value: function identity() {
      this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Matrix4().fromArray(this.elements);
    }
  }, {
    key: "copy",
    value: function copy(m) {
      var te = this.elements;
      var me = m.elements;
      te[0] = me[0];
      te[1] = me[1];
      te[2] = me[2];
      te[3] = me[3];
      te[4] = me[4];
      te[5] = me[5];
      te[6] = me[6];
      te[7] = me[7];
      te[8] = me[8];
      te[9] = me[9];
      te[10] = me[10];
      te[11] = me[11];
      te[12] = me[12];
      te[13] = me[13];
      te[14] = me[14];
      te[15] = me[15];
      return this;
    }
  }, {
    key: "copyPosition",
    value: function copyPosition(m) {
      var te = this.elements,
          me = m.elements;
      te[12] = me[12];
      te[13] = me[13];
      te[14] = me[14];
      return this;
    }
  }, {
    key: "setFromMatrix3",
    value: function setFromMatrix3(m) {
      var me = m.elements;
      this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "extractBasis",
    value: function extractBasis(xAxis, yAxis, zAxis) {
      xAxis.setFromMatrixColumn(this, 0);
      yAxis.setFromMatrixColumn(this, 1);
      zAxis.setFromMatrixColumn(this, 2);
      return this;
    }
  }, {
    key: "makeBasis",
    value: function makeBasis(xAxis, yAxis, zAxis) {
      this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "extractRotation",
    value: function extractRotation(m) {
      // this method does not support reflection matrices
      var te = this.elements;
      var me = m.elements;

      var scaleX = 1 / _v1$5.setFromMatrixColumn(m, 0).length();

      var scaleY = 1 / _v1$5.setFromMatrixColumn(m, 1).length();

      var scaleZ = 1 / _v1$5.setFromMatrixColumn(m, 2).length();

      te[0] = me[0] * scaleX;
      te[1] = me[1] * scaleX;
      te[2] = me[2] * scaleX;
      te[3] = 0;
      te[4] = me[4] * scaleY;
      te[5] = me[5] * scaleY;
      te[6] = me[6] * scaleY;
      te[7] = 0;
      te[8] = me[8] * scaleZ;
      te[9] = me[9] * scaleZ;
      te[10] = me[10] * scaleZ;
      te[11] = 0;
      te[12] = 0;
      te[13] = 0;
      te[14] = 0;
      te[15] = 1;
      return this;
    }
  }, {
    key: "makeRotationFromEuler",
    value: function makeRotationFromEuler(euler) {
      if (!(euler && euler.isEuler)) {
        console.error('THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.');
      }

      var te = this.elements;
      var x = euler.x,
          y = euler.y,
          z = euler.z;
      var a = Math.cos(x),
          b = Math.sin(x);
      var c = Math.cos(y),
          d = Math.sin(y);
      var e = Math.cos(z),
          f = Math.sin(z);

      if (euler.order === 'XYZ') {
        var ae = a * e,
            af = a * f,
            be = b * e,
            bf = b * f;
        te[0] = c * e;
        te[4] = -c * f;
        te[8] = d;
        te[1] = af + be * d;
        te[5] = ae - bf * d;
        te[9] = -b * c;
        te[2] = bf - ae * d;
        te[6] = be + af * d;
        te[10] = a * c;
      } else if (euler.order === 'YXZ') {
        var ce = c * e,
            cf = c * f,
            de = d * e,
            df = d * f;
        te[0] = ce + df * b;
        te[4] = de * b - cf;
        te[8] = a * d;
        te[1] = a * f;
        te[5] = a * e;
        te[9] = -b;
        te[2] = cf * b - de;
        te[6] = df + ce * b;
        te[10] = a * c;
      } else if (euler.order === 'ZXY') {
        var _ce = c * e,
            _cf = c * f,
            _de = d * e,
            _df = d * f;

        te[0] = _ce - _df * b;
        te[4] = -a * f;
        te[8] = _de + _cf * b;
        te[1] = _cf + _de * b;
        te[5] = a * e;
        te[9] = _df - _ce * b;
        te[2] = -a * d;
        te[6] = b;
        te[10] = a * c;
      } else if (euler.order === 'ZYX') {
        var _ae = a * e,
            _af = a * f,
            _be = b * e,
            _bf = b * f;

        te[0] = c * e;
        te[4] = _be * d - _af;
        te[8] = _ae * d + _bf;
        te[1] = c * f;
        te[5] = _bf * d + _ae;
        te[9] = _af * d - _be;
        te[2] = -d;
        te[6] = b * c;
        te[10] = a * c;
      } else if (euler.order === 'YZX') {
        var ac = a * c,
            ad = a * d,
            bc = b * c,
            bd = b * d;
        te[0] = c * e;
        te[4] = bd - ac * f;
        te[8] = bc * f + ad;
        te[1] = f;
        te[5] = a * e;
        te[9] = -b * e;
        te[2] = -d * e;
        te[6] = ad * f + bc;
        te[10] = ac - bd * f;
      } else if (euler.order === 'XZY') {
        var _ac = a * c,
            _ad = a * d,
            _bc = b * c,
            _bd = b * d;

        te[0] = c * e;
        te[4] = -f;
        te[8] = d * e;
        te[1] = _ac * f + _bd;
        te[5] = a * e;
        te[9] = _ad * f - _bc;
        te[2] = _bc * f - _ad;
        te[6] = b * e;
        te[10] = _bd * f + _ac;
      } // bottom row


      te[3] = 0;
      te[7] = 0;
      te[11] = 0; // last column

      te[12] = 0;
      te[13] = 0;
      te[14] = 0;
      te[15] = 1;
      return this;
    }
  }, {
    key: "makeRotationFromQuaternion",
    value: function makeRotationFromQuaternion(q) {
      return this.compose(_zero, q, _one);
    }
  }, {
    key: "lookAt",
    value: function lookAt(eye, target, up) {
      var te = this.elements;

      _z.subVectors(eye, target);

      if (_z.lengthSq() === 0) {
        // eye and target are in the same position
        _z.z = 1;
      }

      _z.normalize();

      _x.crossVectors(up, _z);

      if (_x.lengthSq() === 0) {
        // up and z are parallel
        if (Math.abs(up.z) === 1) {
          _z.x += 0.0001;
        } else {
          _z.z += 0.0001;
        }

        _z.normalize();

        _x.crossVectors(up, _z);
      }

      _x.normalize();

      _y.crossVectors(_z, _x);

      te[0] = _x.x;
      te[4] = _y.x;
      te[8] = _z.x;
      te[1] = _x.y;
      te[5] = _y.y;
      te[9] = _z.y;
      te[2] = _x.z;
      te[6] = _y.z;
      te[10] = _z.z;
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(m, n) {
      if (n !== undefined) {
        console.warn('THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.');
        return this.multiplyMatrices(m, n);
      }

      return this.multiplyMatrices(this, m);
    }
  }, {
    key: "premultiply",
    value: function premultiply(m) {
      return this.multiplyMatrices(m, this);
    }
  }, {
    key: "multiplyMatrices",
    value: function multiplyMatrices(a, b) {
      var ae = a.elements;
      var be = b.elements;
      var te = this.elements;
      var a11 = ae[0],
          a12 = ae[4],
          a13 = ae[8],
          a14 = ae[12];
      var a21 = ae[1],
          a22 = ae[5],
          a23 = ae[9],
          a24 = ae[13];
      var a31 = ae[2],
          a32 = ae[6],
          a33 = ae[10],
          a34 = ae[14];
      var a41 = ae[3],
          a42 = ae[7],
          a43 = ae[11],
          a44 = ae[15];
      var b11 = be[0],
          b12 = be[4],
          b13 = be[8],
          b14 = be[12];
      var b21 = be[1],
          b22 = be[5],
          b23 = be[9],
          b24 = be[13];
      var b31 = be[2],
          b32 = be[6],
          b33 = be[10],
          b34 = be[14];
      var b41 = be[3],
          b42 = be[7],
          b43 = be[11],
          b44 = be[15];
      te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
      te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
      te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
      te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
      te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
      te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
      te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
      te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
      te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
      te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
      te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
      te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
      te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
      te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
      te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
      te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
      return this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(s) {
      var te = this.elements;
      te[0] *= s;
      te[4] *= s;
      te[8] *= s;
      te[12] *= s;
      te[1] *= s;
      te[5] *= s;
      te[9] *= s;
      te[13] *= s;
      te[2] *= s;
      te[6] *= s;
      te[10] *= s;
      te[14] *= s;
      te[3] *= s;
      te[7] *= s;
      te[11] *= s;
      te[15] *= s;
      return this;
    }
  }, {
    key: "determinant",
    value: function determinant() {
      var te = this.elements;
      var n11 = te[0],
          n12 = te[4],
          n13 = te[8],
          n14 = te[12];
      var n21 = te[1],
          n22 = te[5],
          n23 = te[9],
          n24 = te[13];
      var n31 = te[2],
          n32 = te[6],
          n33 = te[10],
          n34 = te[14];
      var n41 = te[3],
          n42 = te[7],
          n43 = te[11],
          n44 = te[15]; //TODO: make this more efficient
      //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )

      return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
  }, {
    key: "transpose",
    value: function transpose() {
      var te = this.elements;
      var tmp;
      tmp = te[1];
      te[1] = te[4];
      te[4] = tmp;
      tmp = te[2];
      te[2] = te[8];
      te[8] = tmp;
      tmp = te[6];
      te[6] = te[9];
      te[9] = tmp;
      tmp = te[3];
      te[3] = te[12];
      te[12] = tmp;
      tmp = te[7];
      te[7] = te[13];
      te[13] = tmp;
      tmp = te[11];
      te[11] = te[14];
      te[14] = tmp;
      return this;
    }
  }, {
    key: "setPosition",
    value: function setPosition(x, y, z) {
      var te = this.elements;

      if (x.isVector3) {
        te[12] = x.x;
        te[13] = x.y;
        te[14] = x.z;
      } else {
        te[12] = x;
        te[13] = y;
        te[14] = z;
      }

      return this;
    }
  }, {
    key: "invert",
    value: function invert() {
      // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
      var te = this.elements,
          n11 = te[0],
          n21 = te[1],
          n31 = te[2],
          n41 = te[3],
          n12 = te[4],
          n22 = te[5],
          n32 = te[6],
          n42 = te[7],
          n13 = te[8],
          n23 = te[9],
          n33 = te[10],
          n43 = te[11],
          n14 = te[12],
          n24 = te[13],
          n34 = te[14],
          n44 = te[15],
          t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
          t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
          t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
          t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
      var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
      if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
      var detInv = 1 / det;
      te[0] = t11 * detInv;
      te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
      te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
      te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
      te[4] = t12 * detInv;
      te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
      te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
      te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
      te[8] = t13 * detInv;
      te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
      te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
      te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
      te[12] = t14 * detInv;
      te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
      te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
      te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
      return this;
    }
  }, {
    key: "scale",
    value: function scale(v) {
      var te = this.elements;
      var x = v.x,
          y = v.y,
          z = v.z;
      te[0] *= x;
      te[4] *= y;
      te[8] *= z;
      te[1] *= x;
      te[5] *= y;
      te[9] *= z;
      te[2] *= x;
      te[6] *= y;
      te[10] *= z;
      te[3] *= x;
      te[7] *= y;
      te[11] *= z;
      return this;
    }
  }, {
    key: "getMaxScaleOnAxis",
    value: function getMaxScaleOnAxis() {
      var te = this.elements;
      var scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
      var scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
      var scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
      return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
  }, {
    key: "makeTranslation",
    value: function makeTranslation(x, y, z) {
      this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "makeRotationX",
    value: function makeRotationX(theta) {
      var c = Math.cos(theta),
          s = Math.sin(theta);
      this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "makeRotationY",
    value: function makeRotationY(theta) {
      var c = Math.cos(theta),
          s = Math.sin(theta);
      this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "makeRotationZ",
    value: function makeRotationZ(theta) {
      var c = Math.cos(theta),
          s = Math.sin(theta);
      this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "makeRotationAxis",
    value: function makeRotationAxis(axis, angle) {
      // Based on http://www.gamedev.net/reference/articles/article1199.asp
      var c = Math.cos(angle);
      var s = Math.sin(angle);
      var t = 1 - c;
      var x = axis.x,
          y = axis.y,
          z = axis.z;
      var tx = t * x,
          ty = t * y;
      this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "makeScale",
    value: function makeScale(x, y, z) {
      this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "makeShear",
    value: function makeShear(xy, xz, yx, yz, zx, zy) {
      this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "compose",
    value: function compose(position, quaternion, scale) {
      var te = this.elements;
      var x = quaternion._x,
          y = quaternion._y,
          z = quaternion._z,
          w = quaternion._w;
      var x2 = x + x,
          y2 = y + y,
          z2 = z + z;
      var xx = x * x2,
          xy = x * y2,
          xz = x * z2;
      var yy = y * y2,
          yz = y * z2,
          zz = z * z2;
      var wx = w * x2,
          wy = w * y2,
          wz = w * z2;
      var sx = scale.x,
          sy = scale.y,
          sz = scale.z;
      te[0] = (1 - (yy + zz)) * sx;
      te[1] = (xy + wz) * sx;
      te[2] = (xz - wy) * sx;
      te[3] = 0;
      te[4] = (xy - wz) * sy;
      te[5] = (1 - (xx + zz)) * sy;
      te[6] = (yz + wx) * sy;
      te[7] = 0;
      te[8] = (xz + wy) * sz;
      te[9] = (yz - wx) * sz;
      te[10] = (1 - (xx + yy)) * sz;
      te[11] = 0;
      te[12] = position.x;
      te[13] = position.y;
      te[14] = position.z;
      te[15] = 1;
      return this;
    }
  }, {
    key: "decompose",
    value: function decompose(position, quaternion, scale) {
      var te = this.elements;

      var sx = _v1$5.set(te[0], te[1], te[2]).length();

      var sy = _v1$5.set(te[4], te[5], te[6]).length();

      var sz = _v1$5.set(te[8], te[9], te[10]).length(); // if determine is negative, we need to invert one scale


      var det = this.determinant();
      if (det < 0) sx = -sx;
      position.x = te[12];
      position.y = te[13];
      position.z = te[14]; // scale the rotation part

      _m1$2.copy(this);

      var invSX = 1 / sx;
      var invSY = 1 / sy;
      var invSZ = 1 / sz;
      _m1$2.elements[0] *= invSX;
      _m1$2.elements[1] *= invSX;
      _m1$2.elements[2] *= invSX;
      _m1$2.elements[4] *= invSY;
      _m1$2.elements[5] *= invSY;
      _m1$2.elements[6] *= invSY;
      _m1$2.elements[8] *= invSZ;
      _m1$2.elements[9] *= invSZ;
      _m1$2.elements[10] *= invSZ;
      quaternion.setFromRotationMatrix(_m1$2);
      scale.x = sx;
      scale.y = sy;
      scale.z = sz;
      return this;
    }
  }, {
    key: "makePerspective",
    value: function makePerspective(left, right, top, bottom, near, far) {
      if (far === undefined) {
        console.warn('THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.');
      }

      var te = this.elements;
      var x = 2 * near / (right - left);
      var y = 2 * near / (top - bottom);
      var a = (right + left) / (right - left);
      var b = (top + bottom) / (top - bottom);
      var c = -(far + near) / (far - near);
      var d = -2 * far * near / (far - near);
      te[0] = x;
      te[4] = 0;
      te[8] = a;
      te[12] = 0;
      te[1] = 0;
      te[5] = y;
      te[9] = b;
      te[13] = 0;
      te[2] = 0;
      te[6] = 0;
      te[10] = c;
      te[14] = d;
      te[3] = 0;
      te[7] = 0;
      te[11] = -1;
      te[15] = 0;
      return this;
    }
  }, {
    key: "makeOrthographic",
    value: function makeOrthographic(left, right, top, bottom, near, far) {
      var te = this.elements;
      var w = 1.0 / (right - left);
      var h = 1.0 / (top - bottom);
      var p = 1.0 / (far - near);
      var x = (right + left) * w;
      var y = (top + bottom) * h;
      var z = (far + near) * p;
      te[0] = 2 * w;
      te[4] = 0;
      te[8] = 0;
      te[12] = -x;
      te[1] = 0;
      te[5] = 2 * h;
      te[9] = 0;
      te[13] = -y;
      te[2] = 0;
      te[6] = 0;
      te[10] = -2 * p;
      te[14] = -z;
      te[3] = 0;
      te[7] = 0;
      te[11] = 0;
      te[15] = 1;
      return this;
    }
  }, {
    key: "equals",
    value: function equals(matrix) {
      var te = this.elements;
      var me = matrix.elements;

      for (var _i18 = 0; _i18 < 16; _i18++) {
        if (te[_i18] !== me[_i18]) return false;
      }

      return true;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      for (var _i19 = 0; _i19 < 16; _i19++) {
        this.elements[_i19] = array[_i19 + offset];
      }

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var te = this.elements;
      array[offset] = te[0];
      array[offset + 1] = te[1];
      array[offset + 2] = te[2];
      array[offset + 3] = te[3];
      array[offset + 4] = te[4];
      array[offset + 5] = te[5];
      array[offset + 6] = te[6];
      array[offset + 7] = te[7];
      array[offset + 8] = te[8];
      array[offset + 9] = te[9];
      array[offset + 10] = te[10];
      array[offset + 11] = te[11];
      array[offset + 12] = te[12];
      array[offset + 13] = te[13];
      array[offset + 14] = te[14];
      array[offset + 15] = te[15];
      return array;
    }
  }]);

  return Matrix4;
}();

Matrix4.prototype.isMatrix4 = true;

var _v1$5 = /*@__PURE__*/new Vector3();

var _m1$2 = /*@__PURE__*/new Matrix4();

var _zero = /*@__PURE__*/new Vector3(0, 0, 0);

var _one = /*@__PURE__*/new Vector3(1, 1, 1);

var _x = /*@__PURE__*/new Vector3();

var _y = /*@__PURE__*/new Vector3();

var _z = /*@__PURE__*/new Vector3();

var _matrix$1 = /*@__PURE__*/new Matrix4();

var _quaternion$3 = /*@__PURE__*/new Quaternion();

var Euler = /*#__PURE__*/function (_Symbol$iterator6) {
  function Euler() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Euler.DefaultOrder;

    _classCallCheck2(this, Euler);

    this._x = x;
    this._y = y;
    this._z = z;
    this._order = order;
  }

  _createClass2(Euler, [{
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      this._x = value;

      this._onChangeCallback();
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      this._y = value;

      this._onChangeCallback();
    }
  }, {
    key: "z",
    get: function get() {
      return this._z;
    },
    set: function set(value) {
      this._z = value;

      this._onChangeCallback();
    }
  }, {
    key: "order",
    get: function get() {
      return this._order;
    },
    set: function set(value) {
      this._order = value;

      this._onChangeCallback();
    }
  }, {
    key: "set",
    value: function set(x, y, z) {
      var order = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this._order;
      this._x = x;
      this._y = y;
      this._z = z;
      this._order = order;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this._x, this._y, this._z, this._order);
    }
  }, {
    key: "copy",
    value: function copy(euler) {
      this._x = euler._x;
      this._y = euler._y;
      this._z = euler._z;
      this._order = euler._order;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "setFromRotationMatrix",
    value: function setFromRotationMatrix(m) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;
      var update = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
      var te = m.elements;
      var m11 = te[0],
          m12 = te[4],
          m13 = te[8];
      var m21 = te[1],
          m22 = te[5],
          m23 = te[9];
      var m31 = te[2],
          m32 = te[6],
          m33 = te[10];

      switch (order) {
        case 'XYZ':
          this._y = Math.asin(clamp(m13, -1, 1));

          if (Math.abs(m13) < 0.9999999) {
            this._x = Math.atan2(-m23, m33);
            this._z = Math.atan2(-m12, m11);
          } else {
            this._x = Math.atan2(m32, m22);
            this._z = 0;
          }

          break;

        case 'YXZ':
          this._x = Math.asin(-clamp(m23, -1, 1));

          if (Math.abs(m23) < 0.9999999) {
            this._y = Math.atan2(m13, m33);
            this._z = Math.atan2(m21, m22);
          } else {
            this._y = Math.atan2(-m31, m11);
            this._z = 0;
          }

          break;

        case 'ZXY':
          this._x = Math.asin(clamp(m32, -1, 1));

          if (Math.abs(m32) < 0.9999999) {
            this._y = Math.atan2(-m31, m33);
            this._z = Math.atan2(-m12, m22);
          } else {
            this._y = 0;
            this._z = Math.atan2(m21, m11);
          }

          break;

        case 'ZYX':
          this._y = Math.asin(-clamp(m31, -1, 1));

          if (Math.abs(m31) < 0.9999999) {
            this._x = Math.atan2(m32, m33);
            this._z = Math.atan2(m21, m11);
          } else {
            this._x = 0;
            this._z = Math.atan2(-m12, m22);
          }

          break;

        case 'YZX':
          this._z = Math.asin(clamp(m21, -1, 1));

          if (Math.abs(m21) < 0.9999999) {
            this._x = Math.atan2(-m23, m22);
            this._y = Math.atan2(-m31, m11);
          } else {
            this._x = 0;
            this._y = Math.atan2(m13, m33);
          }

          break;

        case 'XZY':
          this._z = Math.asin(-clamp(m12, -1, 1));

          if (Math.abs(m12) < 0.9999999) {
            this._x = Math.atan2(m32, m22);
            this._y = Math.atan2(m13, m11);
          } else {
            this._x = Math.atan2(-m23, m33);
            this._y = 0;
          }

          break;

        default:
          console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
      }

      this._order = order;
      if (update === true) this._onChangeCallback();
      return this;
    }
  }, {
    key: "setFromQuaternion",
    value: function setFromQuaternion(q, order, update) {
      _matrix$1.makeRotationFromQuaternion(q);

      return this.setFromRotationMatrix(_matrix$1, order, update);
    }
  }, {
    key: "setFromVector3",
    value: function setFromVector3(v) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._order;
      return this.set(v.x, v.y, v.z, order);
    }
  }, {
    key: "reorder",
    value: function reorder(newOrder) {
      // WARNING: this discards revolution information -bhouston
      _quaternion$3.setFromEuler(this);

      return this.setFromQuaternion(_quaternion$3, newOrder);
    }
  }, {
    key: "equals",
    value: function equals(euler) {
      return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      this._x = array[0];
      this._y = array[1];
      this._z = array[2];
      if (array[3] !== undefined) this._order = array[3];

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      array[offset] = this._x;
      array[offset + 1] = this._y;
      array[offset + 2] = this._z;
      array[offset + 3] = this._order;
      return array;
    }
  }, {
    key: "_onChange",
    value: function _onChange(callback) {
      this._onChangeCallback = callback;
      return this;
    }
  }, {
    key: "_onChangeCallback",
    value: function _onChangeCallback() {}
  }, {
    key: _Symbol$iterator6,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this._x;

            case 2:
              _context7.next = 4;
              return this._y;

            case 4:
              _context7.next = 6;
              return this._z;

            case 6:
              _context7.next = 8;
              return this._order;

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Euler;
}(Symbol.iterator);

Euler.prototype.isEuler = true;
Euler.DefaultOrder = 'XYZ';
Euler.RotationOrders = ['XYZ', 'YZX', 'ZXY', 'XZY', 'YXZ', 'ZYX'];

var Layers = /*#__PURE__*/function () {
  function Layers() {
    _classCallCheck2(this, Layers);

    this.mask = 1 | 0;
  }

  _createClass2(Layers, [{
    key: "set",
    value: function set(channel) {
      this.mask = (1 << channel | 0) >>> 0;
    }
  }, {
    key: "enable",
    value: function enable(channel) {
      this.mask |= 1 << channel | 0;
    }
  }, {
    key: "enableAll",
    value: function enableAll() {
      this.mask = 0xffffffff | 0;
    }
  }, {
    key: "toggle",
    value: function toggle(channel) {
      this.mask ^= 1 << channel | 0;
    }
  }, {
    key: "disable",
    value: function disable(channel) {
      this.mask &= ~(1 << channel | 0);
    }
  }, {
    key: "disableAll",
    value: function disableAll() {
      this.mask = 0;
    }
  }, {
    key: "test",
    value: function test(layers) {
      return (this.mask & layers.mask) !== 0;
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(channel) {
      return (this.mask & (1 << channel | 0)) !== 0;
    }
  }]);

  return Layers;
}();

var _object3DId = 0;

var _v1$4 = /*@__PURE__*/new Vector3();

var _q1 = /*@__PURE__*/new Quaternion();

var _m1$1 = /*@__PURE__*/new Matrix4();

var _target = /*@__PURE__*/new Vector3();

var _position$3 = /*@__PURE__*/new Vector3();

var _scale$2 = /*@__PURE__*/new Vector3();

var _quaternion$2 = /*@__PURE__*/new Quaternion();

var _xAxis = /*@__PURE__*/new Vector3(1, 0, 0);

var _yAxis = /*@__PURE__*/new Vector3(0, 1, 0);

var _zAxis = /*@__PURE__*/new Vector3(0, 0, 1);

var _addedEvent = {
  type: 'added'
};
var _removedEvent = {
  type: 'removed'
};

var Object3D = /*#__PURE__*/function (_EventDispatcher3) {
  _inherits(Object3D, _EventDispatcher3);

  var _super6 = _createSuper(Object3D);

  function Object3D() {
    var _this6;

    _classCallCheck2(this, Object3D);

    _this6 = _super6.call(this);
    Object.defineProperty(_assertThisInitialized(_this6), 'id', {
      value: _object3DId++
    });
    _this6.uuid = generateUUID();
    _this6.name = '';
    _this6.type = 'Object3D';
    _this6.parent = null;
    _this6.children = [];
    _this6.up = Object3D.DefaultUp.clone();
    var position = new Vector3();
    var rotation = new Euler();
    var quaternion = new Quaternion();
    var scale = new Vector3(1, 1, 1);

    function onRotationChange() {
      quaternion.setFromEuler(rotation, false);
    }

    function onQuaternionChange() {
      rotation.setFromQuaternion(quaternion, undefined, false);
    }

    rotation._onChange(onRotationChange);

    quaternion._onChange(onQuaternionChange);

    Object.defineProperties(_assertThisInitialized(_this6), {
      position: {
        configurable: true,
        enumerable: true,
        value: position
      },
      rotation: {
        configurable: true,
        enumerable: true,
        value: rotation
      },
      quaternion: {
        configurable: true,
        enumerable: true,
        value: quaternion
      },
      scale: {
        configurable: true,
        enumerable: true,
        value: scale
      },
      modelViewMatrix: {
        value: new Matrix4()
      },
      normalMatrix: {
        value: new Matrix3()
      }
    });
    _this6.matrix = new Matrix4();
    _this6.matrixWorld = new Matrix4();
    _this6.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
    _this6.matrixWorldNeedsUpdate = false;
    _this6.layers = new Layers();
    _this6.visible = true;
    _this6.castShadow = false;
    _this6.receiveShadow = false;
    _this6.frustumCulled = true;
    _this6.renderOrder = 0;
    _this6.animations = [];
    _this6.userData = {};
    return _this6;
  }

  _createClass2(Object3D, [{
    key: "onBeforeRender",
    value: function
      /* renderer, scene, camera, geometry, material, group */
    onBeforeRender() {}
  }, {
    key: "onAfterRender",
    value: function
      /* renderer, scene, camera, geometry, material, group */
    onAfterRender() {}
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(matrix) {
      if (this.matrixAutoUpdate) this.updateMatrix();
      this.matrix.premultiply(matrix);
      this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
  }, {
    key: "applyQuaternion",
    value: function applyQuaternion(q) {
      this.quaternion.premultiply(q);
      return this;
    }
  }, {
    key: "setRotationFromAxisAngle",
    value: function setRotationFromAxisAngle(axis, angle) {
      // assumes axis is normalized
      this.quaternion.setFromAxisAngle(axis, angle);
    }
  }, {
    key: "setRotationFromEuler",
    value: function setRotationFromEuler(euler) {
      this.quaternion.setFromEuler(euler, true);
    }
  }, {
    key: "setRotationFromMatrix",
    value: function setRotationFromMatrix(m) {
      // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
      this.quaternion.setFromRotationMatrix(m);
    }
  }, {
    key: "setRotationFromQuaternion",
    value: function setRotationFromQuaternion(q) {
      // assumes q is normalized
      this.quaternion.copy(q);
    }
  }, {
    key: "rotateOnAxis",
    value: function rotateOnAxis(axis, angle) {
      // rotate object on axis in object space
      // axis is assumed to be normalized
      _q1.setFromAxisAngle(axis, angle);

      this.quaternion.multiply(_q1);
      return this;
    }
  }, {
    key: "rotateOnWorldAxis",
    value: function rotateOnWorldAxis(axis, angle) {
      // rotate object on axis in world space
      // axis is assumed to be normalized
      // method assumes no rotated parent
      _q1.setFromAxisAngle(axis, angle);

      this.quaternion.premultiply(_q1);
      return this;
    }
  }, {
    key: "rotateX",
    value: function rotateX(angle) {
      return this.rotateOnAxis(_xAxis, angle);
    }
  }, {
    key: "rotateY",
    value: function rotateY(angle) {
      return this.rotateOnAxis(_yAxis, angle);
    }
  }, {
    key: "rotateZ",
    value: function rotateZ(angle) {
      return this.rotateOnAxis(_zAxis, angle);
    }
  }, {
    key: "translateOnAxis",
    value: function translateOnAxis(axis, distance) {
      // translate object by distance along axis in object space
      // axis is assumed to be normalized
      _v1$4.copy(axis).applyQuaternion(this.quaternion);

      this.position.add(_v1$4.multiplyScalar(distance));
      return this;
    }
  }, {
    key: "translateX",
    value: function translateX(distance) {
      return this.translateOnAxis(_xAxis, distance);
    }
  }, {
    key: "translateY",
    value: function translateY(distance) {
      return this.translateOnAxis(_yAxis, distance);
    }
  }, {
    key: "translateZ",
    value: function translateZ(distance) {
      return this.translateOnAxis(_zAxis, distance);
    }
  }, {
    key: "localToWorld",
    value: function localToWorld(vector) {
      return vector.applyMatrix4(this.matrixWorld);
    }
  }, {
    key: "worldToLocal",
    value: function worldToLocal(vector) {
      return vector.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
    }
  }, {
    key: "lookAt",
    value: function lookAt(x, y, z) {
      // This method does not support objects having non-uniformly-scaled parent(s)
      if (x.isVector3) {
        _target.copy(x);
      } else {
        _target.set(x, y, z);
      }

      var parent = this.parent;
      this.updateWorldMatrix(true, false);

      _position$3.setFromMatrixPosition(this.matrixWorld);

      if (this.isCamera || this.isLight) {
        _m1$1.lookAt(_position$3, _target, this.up);
      } else {
        _m1$1.lookAt(_target, _position$3, this.up);
      }

      this.quaternion.setFromRotationMatrix(_m1$1);

      if (parent) {
        _m1$1.extractRotation(parent.matrixWorld);

        _q1.setFromRotationMatrix(_m1$1);

        this.quaternion.premultiply(_q1.invert());
      }
    }
  }, {
    key: "add",
    value: function add(object) {
      if (arguments.length > 1) {
        for (var _i20 = 0; _i20 < arguments.length; _i20++) {
          this.add(arguments[_i20]);
        }

        return this;
      }

      if (object === this) {
        console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
        return this;
      }

      if (object && object.isObject3D) {
        if (object.parent !== null) {
          object.parent.remove(object);
        }

        object.parent = this;
        this.children.push(object);
        object.dispatchEvent(_addedEvent);
      } else {
        console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
      }

      return this;
    }
  }, {
    key: "remove",
    value: function remove(object) {
      if (arguments.length > 1) {
        for (var _i21 = 0; _i21 < arguments.length; _i21++) {
          this.remove(arguments[_i21]);
        }

        return this;
      }

      var index = this.children.indexOf(object);

      if (index !== -1) {
        object.parent = null;
        this.children.splice(index, 1);
        object.dispatchEvent(_removedEvent);
      }

      return this;
    }
  }, {
    key: "removeFromParent",
    value: function removeFromParent() {
      var parent = this.parent;

      if (parent !== null) {
        parent.remove(this);
      }

      return this;
    }
  }, {
    key: "clear",
    value: function clear() {
      for (var _i22 = 0; _i22 < this.children.length; _i22++) {
        var object = this.children[_i22];
        object.parent = null;
        object.dispatchEvent(_removedEvent);
      }

      this.children.length = 0;
      return this;
    }
  }, {
    key: "attach",
    value: function attach(object) {
      // adds object as a child of this, while maintaining the object's world transform
      // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
      this.updateWorldMatrix(true, false);

      _m1$1.copy(this.matrixWorld).invert();

      if (object.parent !== null) {
        object.parent.updateWorldMatrix(true, false);

        _m1$1.multiply(object.parent.matrixWorld);
      }

      object.applyMatrix4(_m1$1);
      this.add(object);
      object.updateWorldMatrix(false, true);
      return this;
    }
  }, {
    key: "getObjectById",
    value: function getObjectById(id) {
      return this.getObjectByProperty('id', id);
    }
  }, {
    key: "getObjectByName",
    value: function getObjectByName(name) {
      return this.getObjectByProperty('name', name);
    }
  }, {
    key: "getObjectByProperty",
    value: function getObjectByProperty(name, value) {
      if (this[name] === value) return this;

      for (var _i23 = 0, l = this.children.length; _i23 < l; _i23++) {
        var child = this.children[_i23];
        var object = child.getObjectByProperty(name, value);

        if (object !== undefined) {
          return object;
        }
      }

      return undefined;
    }
  }, {
    key: "getWorldPosition",
    value: function getWorldPosition(target) {
      this.updateWorldMatrix(true, false);
      return target.setFromMatrixPosition(this.matrixWorld);
    }
  }, {
    key: "getWorldQuaternion",
    value: function getWorldQuaternion(target) {
      this.updateWorldMatrix(true, false);
      this.matrixWorld.decompose(_position$3, target, _scale$2);
      return target;
    }
  }, {
    key: "getWorldScale",
    value: function getWorldScale(target) {
      this.updateWorldMatrix(true, false);
      this.matrixWorld.decompose(_position$3, _quaternion$2, target);
      return target;
    }
  }, {
    key: "getWorldDirection",
    value: function getWorldDirection(target) {
      this.updateWorldMatrix(true, false);
      var e = this.matrixWorld.elements;
      return target.set(e[8], e[9], e[10]).normalize();
    }
  }, {
    key: "raycast",
    value: function
      /* raycaster, intersects */
    raycast() {}
  }, {
    key: "traverse",
    value: function traverse(callback) {
      callback(this);
      var children = this.children;

      for (var _i24 = 0, l = children.length; _i24 < l; _i24++) {
        children[_i24].traverse(callback);
      }
    }
  }, {
    key: "traverseVisible",
    value: function traverseVisible(callback) {
      if (this.visible === false) return;
      callback(this);
      var children = this.children;

      for (var _i25 = 0, l = children.length; _i25 < l; _i25++) {
        children[_i25].traverseVisible(callback);
      }
    }
  }, {
    key: "traverseAncestors",
    value: function traverseAncestors(callback) {
      var parent = this.parent;

      if (parent !== null) {
        callback(parent);
        parent.traverseAncestors(callback);
      }
    }
  }, {
    key: "updateMatrix",
    value: function updateMatrix() {
      this.matrix.compose(this.position, this.quaternion, this.scale);
      this.matrixWorldNeedsUpdate = true;
    }
  }, {
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(force) {
      if (this.matrixAutoUpdate) this.updateMatrix();

      if (this.matrixWorldNeedsUpdate || force) {
        if (this.parent === null) {
          this.matrixWorld.copy(this.matrix);
        } else {
          this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }

        this.matrixWorldNeedsUpdate = false;
        force = true;
      } // update children


      var children = this.children;

      for (var _i26 = 0, l = children.length; _i26 < l; _i26++) {
        children[_i26].updateMatrixWorld(force);
      }
    }
  }, {
    key: "updateWorldMatrix",
    value: function updateWorldMatrix(updateParents, updateChildren) {
      var parent = this.parent;

      if (updateParents === true && parent !== null) {
        parent.updateWorldMatrix(true, false);
      }

      if (this.matrixAutoUpdate) this.updateMatrix();

      if (this.parent === null) {
        this.matrixWorld.copy(this.matrix);
      } else {
        this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
      } // update children


      if (updateChildren === true) {
        var children = this.children;

        for (var _i27 = 0, l = children.length; _i27 < l; _i27++) {
          children[_i27].updateWorldMatrix(false, true);
        }
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON(meta) {
      // meta is a string when called from JSON.stringify
      var isRootObject = meta === undefined || typeof meta === 'string';
      var output = {}; // meta is a hash used to collect geometries, materials.
      // not providing it implies that this is the root object
      // being serialized.

      if (isRootObject) {
        // initialize meta obj
        meta = {
          geometries: {},
          materials: {},
          textures: {},
          images: {},
          shapes: {},
          skeletons: {},
          animations: {},
          nodes: {}
        };
        output.metadata = {
          version: 4.5,
          type: 'Object',
          generator: 'Object3D.toJSON'
        };
      } // standard Object3D serialization


      var object = {};
      object.uuid = this.uuid;
      object.type = this.type;
      if (this.name !== '') object.name = this.name;
      if (this.castShadow === true) object.castShadow = true;
      if (this.receiveShadow === true) object.receiveShadow = true;
      if (this.visible === false) object.visible = false;
      if (this.frustumCulled === false) object.frustumCulled = false;
      if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
      if (JSON.stringify(this.userData) !== '{}') object.userData = this.userData;
      object.layers = this.layers.mask;
      object.matrix = this.matrix.toArray();
      if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false; // object specific properties

      if (this.isInstancedMesh) {
        object.type = 'InstancedMesh';
        object.count = this.count;
        object.instanceMatrix = this.instanceMatrix.toJSON();
        if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
      } //


      function serialize(library, element) {
        if (library[element.uuid] === undefined) {
          library[element.uuid] = element.toJSON(meta);
        }

        return element.uuid;
      }

      if (this.isScene) {
        if (this.background) {
          if (this.background.isColor) {
            object.background = this.background.toJSON();
          } else if (this.background.isTexture) {
            object.background = this.background.toJSON(meta).uuid;
          }
        }

        if (this.environment && this.environment.isTexture) {
          object.environment = this.environment.toJSON(meta).uuid;
        }
      } else if (this.isMesh || this.isLine || this.isPoints) {
        object.geometry = serialize(meta.geometries, this.geometry);
        var parameters = this.geometry.parameters;

        if (parameters !== undefined && parameters.shapes !== undefined) {
          var shapes = parameters.shapes;

          if (Array.isArray(shapes)) {
            for (var _i28 = 0, l = shapes.length; _i28 < l; _i28++) {
              var shape = shapes[_i28];
              serialize(meta.shapes, shape);
            }
          } else {
            serialize(meta.shapes, shapes);
          }
        }
      }

      if (this.isSkinnedMesh) {
        object.bindMode = this.bindMode;
        object.bindMatrix = this.bindMatrix.toArray();

        if (this.skeleton !== undefined) {
          serialize(meta.skeletons, this.skeleton);
          object.skeleton = this.skeleton.uuid;
        }
      }

      if (this.material !== undefined) {
        if (Array.isArray(this.material)) {
          var uuids = [];

          for (var _i29 = 0, _l2 = this.material.length; _i29 < _l2; _i29++) {
            uuids.push(serialize(meta.materials, this.material[_i29]));
          }

          object.material = uuids;
        } else {
          object.material = serialize(meta.materials, this.material);
        }
      } //


      if (this.children.length > 0) {
        object.children = [];

        for (var _i30 = 0; _i30 < this.children.length; _i30++) {
          object.children.push(this.children[_i30].toJSON(meta).object);
        }
      } //


      if (this.animations.length > 0) {
        object.animations = [];

        for (var _i31 = 0; _i31 < this.animations.length; _i31++) {
          var animation = this.animations[_i31];
          object.animations.push(serialize(meta.animations, animation));
        }
      }

      if (isRootObject) {
        var geometries = extractFromCache(meta.geometries);
        var materials = extractFromCache(meta.materials);
        var textures = extractFromCache(meta.textures);
        var images = extractFromCache(meta.images);

        var _shapes = extractFromCache(meta.shapes);

        var skeletons = extractFromCache(meta.skeletons);
        var animations = extractFromCache(meta.animations);
        var nodes = extractFromCache(meta.nodes);
        if (geometries.length > 0) output.geometries = geometries;
        if (materials.length > 0) output.materials = materials;
        if (textures.length > 0) output.textures = textures;
        if (images.length > 0) output.images = images;
        if (_shapes.length > 0) output.shapes = _shapes;
        if (skeletons.length > 0) output.skeletons = skeletons;
        if (animations.length > 0) output.animations = animations;
        if (nodes.length > 0) output.nodes = nodes;
      }

      output.object = object;
      return output; // extract data from the cache hash
      // remove metadata on each item
      // and return as array

      function extractFromCache(cache) {
        var values = [];

        for (var key in cache) {
          var data = cache[key];
          delete data.metadata;
          values.push(data);
        }

        return values;
      }
    }
  }, {
    key: "clone",
    value: function clone(recursive) {
      return new this.constructor().copy(this, recursive);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.name = source.name;
      this.up.copy(source.up);
      this.position.copy(source.position);
      this.rotation.order = source.rotation.order;
      this.quaternion.copy(source.quaternion);
      this.scale.copy(source.scale);
      this.matrix.copy(source.matrix);
      this.matrixWorld.copy(source.matrixWorld);
      this.matrixAutoUpdate = source.matrixAutoUpdate;
      this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
      this.layers.mask = source.layers.mask;
      this.visible = source.visible;
      this.castShadow = source.castShadow;
      this.receiveShadow = source.receiveShadow;
      this.frustumCulled = source.frustumCulled;
      this.renderOrder = source.renderOrder;
      this.userData = JSON.parse(JSON.stringify(source.userData));

      if (recursive === true) {
        for (var _i32 = 0; _i32 < source.children.length; _i32++) {
          var child = source.children[_i32];
          this.add(child.clone());
        }
      }

      return this;
    }
  }]);

  return Object3D;
}(EventDispatcher);

Object3D.DefaultUp = new Vector3(0, 1, 0);
Object3D.DefaultMatrixAutoUpdate = true;
Object3D.prototype.isObject3D = true;

var _v0$1 = /*@__PURE__*/new Vector3();

var _v1$3 = /*@__PURE__*/new Vector3();

var _v2$2 = /*@__PURE__*/new Vector3();

var _v3$1 = /*@__PURE__*/new Vector3();

var _vab = /*@__PURE__*/new Vector3();

var _vac = /*@__PURE__*/new Vector3();

var _vbc = /*@__PURE__*/new Vector3();

var _vap = /*@__PURE__*/new Vector3();

var _vbp = /*@__PURE__*/new Vector3();

var _vcp = /*@__PURE__*/new Vector3();

var Triangle = /*#__PURE__*/function () {
  function Triangle() {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
    var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
    var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Vector3();

    _classCallCheck2(this, Triangle);

    this.a = a;
    this.b = b;
    this.c = c;
  }

  _createClass2(Triangle, [{
    key: "set",
    value: function set(a, b, c) {
      this.a.copy(a);
      this.b.copy(b);
      this.c.copy(c);
      return this;
    }
  }, {
    key: "setFromPointsAndIndices",
    value: function setFromPointsAndIndices(points, i0, i1, i2) {
      this.a.copy(points[i0]);
      this.b.copy(points[i1]);
      this.c.copy(points[i2]);
      return this;
    }
  }, {
    key: "setFromAttributeAndIndices",
    value: function setFromAttributeAndIndices(attribute, i0, i1, i2) {
      this.a.fromBufferAttribute(attribute, i0);
      this.b.fromBufferAttribute(attribute, i1);
      this.c.fromBufferAttribute(attribute, i2);
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(triangle) {
      this.a.copy(triangle.a);
      this.b.copy(triangle.b);
      this.c.copy(triangle.c);
      return this;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      _v0$1.subVectors(this.c, this.b);

      _v1$3.subVectors(this.a, this.b);

      return _v0$1.cross(_v1$3).length() * 0.5;
    }
  }, {
    key: "getMidpoint",
    value: function getMidpoint(target) {
      return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
  }, {
    key: "getNormal",
    value: function getNormal(target) {
      return Triangle.getNormal(this.a, this.b, this.c, target);
    }
  }, {
    key: "getPlane",
    value: function getPlane(target) {
      return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
  }, {
    key: "getBarycoord",
    value: function getBarycoord(point, target) {
      return Triangle.getBarycoord(point, this.a, this.b, this.c, target);
    }
  }, {
    key: "getUV",
    value: function getUV(point, uv1, uv2, uv3, target) {
      return Triangle.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(point) {
      return Triangle.containsPoint(point, this.a, this.b, this.c);
    }
  }, {
    key: "isFrontFacing",
    value: function isFrontFacing(direction) {
      return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(box) {
      return box.intersectsTriangle(this);
    }
  }, {
    key: "closestPointToPoint",
    value: function closestPointToPoint(p, target) {
      var a = this.a,
          b = this.b,
          c = this.c;
      var v, w; // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
      // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
      // under the accompanying license; see chapter 5.1.5 for detailed explanation.
      // basically, we're distinguishing which of the voronoi regions of the triangle
      // the point lies in with the minimum amount of redundant computation.

      _vab.subVectors(b, a);

      _vac.subVectors(c, a);

      _vap.subVectors(p, a);

      var d1 = _vab.dot(_vap);

      var d2 = _vac.dot(_vap);

      if (d1 <= 0 && d2 <= 0) {
        // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
      }

      _vbp.subVectors(p, b);

      var d3 = _vab.dot(_vbp);

      var d4 = _vac.dot(_vbp);

      if (d3 >= 0 && d4 <= d3) {
        // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
      }

      var vc = d1 * d4 - d3 * d2;

      if (vc <= 0 && d1 >= 0 && d3 <= 0) {
        v = d1 / (d1 - d3); // edge region of AB; barycentric coords (1-v, v, 0)

        return target.copy(a).addScaledVector(_vab, v);
      }

      _vcp.subVectors(p, c);

      var d5 = _vab.dot(_vcp);

      var d6 = _vac.dot(_vcp);

      if (d6 >= 0 && d5 <= d6) {
        // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
      }

      var vb = d5 * d2 - d1 * d6;

      if (vb <= 0 && d2 >= 0 && d6 <= 0) {
        w = d2 / (d2 - d6); // edge region of AC; barycentric coords (1-w, 0, w)

        return target.copy(a).addScaledVector(_vac, w);
      }

      var va = d3 * d6 - d5 * d4;

      if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
        _vbc.subVectors(c, b);

        w = (d4 - d3) / (d4 - d3 + (d5 - d6)); // edge region of BC; barycentric coords (0, 1-w, w)

        return target.copy(b).addScaledVector(_vbc, w); // edge region of BC
      } // face region


      var denom = 1 / (va + vb + vc); // u = va * denom

      v = vb * denom;
      w = vc * denom;
      return target.copy(a).addScaledVector(_vab, v).addScaledVector(_vac, w);
    }
  }, {
    key: "equals",
    value: function equals(triangle) {
      return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
  }], [{
    key: "getNormal",
    value: function getNormal(a, b, c, target) {
      target.subVectors(c, b);

      _v0$1.subVectors(a, b);

      target.cross(_v0$1);
      var targetLengthSq = target.lengthSq();

      if (targetLengthSq > 0) {
        return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
      }

      return target.set(0, 0, 0);
    } // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html

  }, {
    key: "getBarycoord",
    value: function getBarycoord(point, a, b, c, target) {
      _v0$1.subVectors(c, a);

      _v1$3.subVectors(b, a);

      _v2$2.subVectors(point, a);

      var dot00 = _v0$1.dot(_v0$1);

      var dot01 = _v0$1.dot(_v1$3);

      var dot02 = _v0$1.dot(_v2$2);

      var dot11 = _v1$3.dot(_v1$3);

      var dot12 = _v1$3.dot(_v2$2);

      var denom = dot00 * dot11 - dot01 * dot01; // collinear or singular triangle

      if (denom === 0) {
        // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
      }

      var invDenom = 1 / denom;
      var u = (dot11 * dot02 - dot01 * dot12) * invDenom;
      var v = (dot00 * dot12 - dot01 * dot02) * invDenom; // barycentric coordinates must always sum to 1

      return target.set(1 - u - v, v, u);
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(point, a, b, c) {
      this.getBarycoord(point, a, b, c, _v3$1);
      return _v3$1.x >= 0 && _v3$1.y >= 0 && _v3$1.x + _v3$1.y <= 1;
    }
  }, {
    key: "getUV",
    value: function getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
      this.getBarycoord(point, p1, p2, p3, _v3$1);
      target.set(0, 0);
      target.addScaledVector(uv1, _v3$1.x);
      target.addScaledVector(uv2, _v3$1.y);
      target.addScaledVector(uv3, _v3$1.z);
      return target;
    }
  }, {
    key: "isFrontFacing",
    value: function isFrontFacing(a, b, c, direction) {
      _v0$1.subVectors(c, b);

      _v1$3.subVectors(a, b); // strictly front facing


      return _v0$1.cross(_v1$3).dot(direction) < 0 ? true : false;
    }
  }]);

  return Triangle;
}();

var materialId = 0;

var Material = /*#__PURE__*/function (_EventDispatcher4) {
  _inherits(Material, _EventDispatcher4);

  var _super7 = _createSuper(Material);

  function Material() {
    var _this7;

    _classCallCheck2(this, Material);

    _this7 = _super7.call(this);
    Object.defineProperty(_assertThisInitialized(_this7), 'id', {
      value: materialId++
    });
    _this7.uuid = generateUUID();
    _this7.name = '';
    _this7.type = 'Material';
    _this7.blending = NormalBlending;
    _this7.side = FrontSide;
    _this7.vertexColors = false;
    _this7.opacity = 1;
    _this7.transparent = false;
    _this7.blendSrc = SrcAlphaFactor;
    _this7.blendDst = OneMinusSrcAlphaFactor;
    _this7.blendEquation = AddEquation;
    _this7.blendSrcAlpha = null;
    _this7.blendDstAlpha = null;
    _this7.blendEquationAlpha = null;
    _this7.depthFunc = LessEqualDepth;
    _this7.depthTest = true;
    _this7.depthWrite = true;
    _this7.stencilWriteMask = 0xff;
    _this7.stencilFunc = AlwaysStencilFunc;
    _this7.stencilRef = 0;
    _this7.stencilFuncMask = 0xff;
    _this7.stencilFail = KeepStencilOp;
    _this7.stencilZFail = KeepStencilOp;
    _this7.stencilZPass = KeepStencilOp;
    _this7.stencilWrite = false;
    _this7.clippingPlanes = null;
    _this7.clipIntersection = false;
    _this7.clipShadows = false;
    _this7.shadowSide = null;
    _this7.colorWrite = true;
    _this7.precision = null; // override the renderer's default precision for this material

    _this7.polygonOffset = false;
    _this7.polygonOffsetFactor = 0;
    _this7.polygonOffsetUnits = 0;
    _this7.dithering = false;
    _this7.alphaToCoverage = false;
    _this7.premultipliedAlpha = false;
    _this7.visible = true;
    _this7.toneMapped = true;
    _this7.userData = {};
    _this7.version = 0;
    _this7._alphaTest = 0;
    return _this7;
  }

  _createClass2(Material, [{
    key: "alphaTest",
    get: function get() {
      return this._alphaTest;
    },
    set: function set(value) {
      if (this._alphaTest > 0 !== value > 0) {
        this.version++;
      }

      this._alphaTest = value;
    }
  }, {
    key: "onBuild",
    value: function
      /* shaderobject, renderer */
    onBuild() {}
  }, {
    key: "onBeforeRender",
    value: function
      /* renderer, scene, camera, geometry, object, group */
    onBeforeRender() {}
  }, {
    key: "onBeforeCompile",
    value: function
      /* shaderobject, renderer */
    onBeforeCompile() {}
  }, {
    key: "customProgramCacheKey",
    value: function customProgramCacheKey() {
      return this.onBeforeCompile.toString();
    }
  }, {
    key: "setValues",
    value: function setValues(values) {
      if (values === undefined) return;

      for (var key in values) {
        var newValue = values[key];

        if (newValue === undefined) {
          console.warn('THREE.Material: \'' + key + '\' parameter is undefined.');
          continue;
        } // for backward compatibility if shading is set in the constructor


        if (key === 'shading') {
          console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
          this.flatShading = newValue === FlatShading ? true : false;
          continue;
        }

        var currentValue = this[key];

        if (currentValue === undefined) {
          console.warn('THREE.' + this.type + ': \'' + key + '\' is not a property of this material.');
          continue;
        }

        if (currentValue && currentValue.isColor) {
          currentValue.set(newValue);
        } else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) {
          currentValue.copy(newValue);
        } else {
          this[key] = newValue;
        }
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON(meta) {
      var isRootObject = meta === undefined || typeof meta === 'string';

      if (isRootObject) {
        meta = {
          textures: {},
          images: {}
        };
      }

      var data = {
        metadata: {
          version: 4.5,
          type: 'Material',
          generator: 'Material.toJSON'
        }
      }; // standard Material serialization

      data.uuid = this.uuid;
      data.type = this.type;
      if (this.name !== '') data.name = this.name;
      if (this.color && this.color.isColor) data.color = this.color.getHex();
      if (this.roughness !== undefined) data.roughness = this.roughness;
      if (this.metalness !== undefined) data.metalness = this.metalness;
      if (this.sheen !== undefined) data.sheen = this.sheen;
      if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
      if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
      if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
      if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
      if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
      if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
      if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
      if (this.shininess !== undefined) data.shininess = this.shininess;
      if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
      if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;

      if (this.clearcoatMap && this.clearcoatMap.isTexture) {
        data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
      }

      if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) {
        data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
      }

      if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
        data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
        data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
      }

      if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
      if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
      if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;

      if (this.lightMap && this.lightMap.isTexture) {
        data.lightMap = this.lightMap.toJSON(meta).uuid;
        data.lightMapIntensity = this.lightMapIntensity;
      }

      if (this.aoMap && this.aoMap.isTexture) {
        data.aoMap = this.aoMap.toJSON(meta).uuid;
        data.aoMapIntensity = this.aoMapIntensity;
      }

      if (this.bumpMap && this.bumpMap.isTexture) {
        data.bumpMap = this.bumpMap.toJSON(meta).uuid;
        data.bumpScale = this.bumpScale;
      }

      if (this.normalMap && this.normalMap.isTexture) {
        data.normalMap = this.normalMap.toJSON(meta).uuid;
        data.normalMapType = this.normalMapType;
        data.normalScale = this.normalScale.toArray();
      }

      if (this.displacementMap && this.displacementMap.isTexture) {
        data.displacementMap = this.displacementMap.toJSON(meta).uuid;
        data.displacementScale = this.displacementScale;
        data.displacementBias = this.displacementBias;
      }

      if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
      if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
      if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
      if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
      if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
      if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;

      if (this.envMap && this.envMap.isTexture) {
        data.envMap = this.envMap.toJSON(meta).uuid;
        if (this.combine !== undefined) data.combine = this.combine;
      }

      if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
      if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
      if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;

      if (this.gradientMap && this.gradientMap.isTexture) {
        data.gradientMap = this.gradientMap.toJSON(meta).uuid;
      }

      if (this.transmission !== undefined) data.transmission = this.transmission;
      if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
      if (this.thickness !== undefined) data.thickness = this.thickness;
      if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
      if (this.attenuationDistance !== undefined) data.attenuationDistance = this.attenuationDistance;
      if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
      if (this.size !== undefined) data.size = this.size;
      if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
      if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
      if (this.blending !== NormalBlending) data.blending = this.blending;
      if (this.side !== FrontSide) data.side = this.side;
      if (this.vertexColors) data.vertexColors = true;
      if (this.opacity < 1) data.opacity = this.opacity;
      if (this.transparent === true) data.transparent = this.transparent;
      data.depthFunc = this.depthFunc;
      data.depthTest = this.depthTest;
      data.depthWrite = this.depthWrite;
      data.colorWrite = this.colorWrite;
      data.stencilWrite = this.stencilWrite;
      data.stencilWriteMask = this.stencilWriteMask;
      data.stencilFunc = this.stencilFunc;
      data.stencilRef = this.stencilRef;
      data.stencilFuncMask = this.stencilFuncMask;
      data.stencilFail = this.stencilFail;
      data.stencilZFail = this.stencilZFail;
      data.stencilZPass = this.stencilZPass; // rotation (SpriteMaterial)

      if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
      if (this.polygonOffset === true) data.polygonOffset = true;
      if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
      if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
      if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
      if (this.dashSize !== undefined) data.dashSize = this.dashSize;
      if (this.gapSize !== undefined) data.gapSize = this.gapSize;
      if (this.scale !== undefined) data.scale = this.scale;
      if (this.dithering === true) data.dithering = true;
      if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
      if (this.alphaToCoverage === true) data.alphaToCoverage = this.alphaToCoverage;
      if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
      if (this.wireframe === true) data.wireframe = this.wireframe;
      if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
      if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
      if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
      if (this.flatShading === true) data.flatShading = this.flatShading;
      if (this.visible === false) data.visible = false;
      if (this.toneMapped === false) data.toneMapped = false;
      if (this.fog === false) data.fog = false;
      if (JSON.stringify(this.userData) !== '{}') data.userData = this.userData; // TODO: Copied from Object3D.toJSON

      function extractFromCache(cache) {
        var values = [];

        for (var key in cache) {
          var _data2 = cache[key];
          delete _data2.metadata;
          values.push(_data2);
        }

        return values;
      }

      if (isRootObject) {
        var textures = extractFromCache(meta.textures);
        var images = extractFromCache(meta.images);
        if (textures.length > 0) data.textures = textures;
        if (images.length > 0) data.images = images;
      }

      return data;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      this.name = source.name;
      this.blending = source.blending;
      this.side = source.side;
      this.vertexColors = source.vertexColors;
      this.opacity = source.opacity;
      this.transparent = source.transparent;
      this.blendSrc = source.blendSrc;
      this.blendDst = source.blendDst;
      this.blendEquation = source.blendEquation;
      this.blendSrcAlpha = source.blendSrcAlpha;
      this.blendDstAlpha = source.blendDstAlpha;
      this.blendEquationAlpha = source.blendEquationAlpha;
      this.depthFunc = source.depthFunc;
      this.depthTest = source.depthTest;
      this.depthWrite = source.depthWrite;
      this.stencilWriteMask = source.stencilWriteMask;
      this.stencilFunc = source.stencilFunc;
      this.stencilRef = source.stencilRef;
      this.stencilFuncMask = source.stencilFuncMask;
      this.stencilFail = source.stencilFail;
      this.stencilZFail = source.stencilZFail;
      this.stencilZPass = source.stencilZPass;
      this.stencilWrite = source.stencilWrite;
      var srcPlanes = source.clippingPlanes;
      var dstPlanes = null;

      if (srcPlanes !== null) {
        var n = srcPlanes.length;
        dstPlanes = new Array(n);

        for (var _i33 = 0; _i33 !== n; ++_i33) {
          dstPlanes[_i33] = srcPlanes[_i33].clone();
        }
      }

      this.clippingPlanes = dstPlanes;
      this.clipIntersection = source.clipIntersection;
      this.clipShadows = source.clipShadows;
      this.shadowSide = source.shadowSide;
      this.colorWrite = source.colorWrite;
      this.precision = source.precision;
      this.polygonOffset = source.polygonOffset;
      this.polygonOffsetFactor = source.polygonOffsetFactor;
      this.polygonOffsetUnits = source.polygonOffsetUnits;
      this.dithering = source.dithering;
      this.alphaTest = source.alphaTest;
      this.alphaToCoverage = source.alphaToCoverage;
      this.premultipliedAlpha = source.premultipliedAlpha;
      this.visible = source.visible;
      this.toneMapped = source.toneMapped;
      this.userData = JSON.parse(JSON.stringify(source.userData));
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: 'dispose'
      });
    }
  }, {
    key: "needsUpdate",
    set: function set(value) {
      if (value === true) this.version++;
    }
  }]);

  return Material;
}(EventDispatcher);

Material.prototype.isMaterial = true;

Material.fromType = function
  /*type*/
() {
  // TODO: Behavior added in Materials.js
  return null;
};

var MeshBasicMaterial = /*#__PURE__*/function (_Material) {
  _inherits(MeshBasicMaterial, _Material);

  var _super8 = _createSuper(MeshBasicMaterial);

  function MeshBasicMaterial(parameters) {
    var _this8;

    _classCallCheck2(this, MeshBasicMaterial);

    _this8 = _super8.call(this);
    _this8.type = 'MeshBasicMaterial';
    _this8.color = new Color(0xffffff); // emissive

    _this8.map = null;
    _this8.lightMap = null;
    _this8.lightMapIntensity = 1.0;
    _this8.aoMap = null;
    _this8.aoMapIntensity = 1.0;
    _this8.specularMap = null;
    _this8.alphaMap = null;
    _this8.envMap = null;
    _this8.combine = MultiplyOperation;
    _this8.reflectivity = 1;
    _this8.refractionRatio = 0.98;
    _this8.wireframe = false;
    _this8.wireframeLinewidth = 1;
    _this8.wireframeLinecap = 'round';
    _this8.wireframeLinejoin = 'round';
    _this8.fog = true;

    _this8.setValues(parameters);

    return _this8;
  }

  _createClass2(MeshBasicMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(MeshBasicMaterial.prototype), "copy", this).call(this, source);

      this.color.copy(source.color);
      this.map = source.map;
      this.lightMap = source.lightMap;
      this.lightMapIntensity = source.lightMapIntensity;
      this.aoMap = source.aoMap;
      this.aoMapIntensity = source.aoMapIntensity;
      this.specularMap = source.specularMap;
      this.alphaMap = source.alphaMap;
      this.envMap = source.envMap;
      this.combine = source.combine;
      this.reflectivity = source.reflectivity;
      this.refractionRatio = source.refractionRatio;
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      this.wireframeLinecap = source.wireframeLinecap;
      this.wireframeLinejoin = source.wireframeLinejoin;
      this.fog = source.fog;
      return this;
    }
  }]);

  return MeshBasicMaterial;
}(Material);

MeshBasicMaterial.prototype.isMeshBasicMaterial = true;

var _vector$9 = /*@__PURE__*/new Vector3();

var _vector2$1 = /*@__PURE__*/new Vector2();

var BufferAttribute = /*#__PURE__*/function () {
  function BufferAttribute(array, itemSize, normalized) {
    _classCallCheck2(this, BufferAttribute);

    if (Array.isArray(array)) {
      throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
    }

    this.name = '';
    this.array = array;
    this.itemSize = itemSize;
    this.count = array !== undefined ? array.length / itemSize : 0;
    this.normalized = normalized === true;
    this.usage = StaticDrawUsage;
    this.updateRange = {
      offset: 0,
      count: -1
    };
    this.version = 0;
  }

  _createClass2(BufferAttribute, [{
    key: "onUploadCallback",
    value: function onUploadCallback() {}
  }, {
    key: "needsUpdate",
    set: function set(value) {
      if (value === true) this.version++;
    }
  }, {
    key: "setUsage",
    value: function setUsage(value) {
      this.usage = value;
      return this;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      this.name = source.name;
      this.array = new source.array.constructor(source.array);
      this.itemSize = source.itemSize;
      this.count = source.count;
      this.normalized = source.normalized;
      this.usage = source.usage;
      return this;
    }
  }, {
    key: "copyAt",
    value: function copyAt(index1, attribute, index2) {
      index1 *= this.itemSize;
      index2 *= attribute.itemSize;

      for (var _i34 = 0, l = this.itemSize; _i34 < l; _i34++) {
        this.array[index1 + _i34] = attribute.array[index2 + _i34];
      }

      return this;
    }
  }, {
    key: "copyArray",
    value: function copyArray(array) {
      this.array.set(array);
      return this;
    }
  }, {
    key: "copyColorsArray",
    value: function copyColorsArray(colors) {
      var array = this.array;
      var offset = 0;

      for (var _i35 = 0, l = colors.length; _i35 < l; _i35++) {
        var color = colors[_i35];

        if (color === undefined) {
          console.warn('THREE.BufferAttribute.copyColorsArray(): color is undefined', _i35);
          color = new Color();
        }

        array[offset++] = color.r;
        array[offset++] = color.g;
        array[offset++] = color.b;
      }

      return this;
    }
  }, {
    key: "copyVector2sArray",
    value: function copyVector2sArray(vectors) {
      var array = this.array;
      var offset = 0;

      for (var _i36 = 0, l = vectors.length; _i36 < l; _i36++) {
        var vector = vectors[_i36];

        if (vector === undefined) {
          console.warn('THREE.BufferAttribute.copyVector2sArray(): vector is undefined', _i36);
          vector = new Vector2();
        }

        array[offset++] = vector.x;
        array[offset++] = vector.y;
      }

      return this;
    }
  }, {
    key: "copyVector3sArray",
    value: function copyVector3sArray(vectors) {
      var array = this.array;
      var offset = 0;

      for (var _i37 = 0, l = vectors.length; _i37 < l; _i37++) {
        var vector = vectors[_i37];

        if (vector === undefined) {
          console.warn('THREE.BufferAttribute.copyVector3sArray(): vector is undefined', _i37);
          vector = new Vector3();
        }

        array[offset++] = vector.x;
        array[offset++] = vector.y;
        array[offset++] = vector.z;
      }

      return this;
    }
  }, {
    key: "copyVector4sArray",
    value: function copyVector4sArray(vectors) {
      var array = this.array;
      var offset = 0;

      for (var _i38 = 0, l = vectors.length; _i38 < l; _i38++) {
        var vector = vectors[_i38];

        if (vector === undefined) {
          console.warn('THREE.BufferAttribute.copyVector4sArray(): vector is undefined', _i38);
          vector = new Vector4();
        }

        array[offset++] = vector.x;
        array[offset++] = vector.y;
        array[offset++] = vector.z;
        array[offset++] = vector.w;
      }

      return this;
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(m) {
      if (this.itemSize === 2) {
        for (var _i39 = 0, l = this.count; _i39 < l; _i39++) {
          _vector2$1.fromBufferAttribute(this, _i39);

          _vector2$1.applyMatrix3(m);

          this.setXY(_i39, _vector2$1.x, _vector2$1.y);
        }
      } else if (this.itemSize === 3) {
        for (var _i40 = 0, _l3 = this.count; _i40 < _l3; _i40++) {
          _vector$9.fromBufferAttribute(this, _i40);

          _vector$9.applyMatrix3(m);

          this.setXYZ(_i40, _vector$9.x, _vector$9.y, _vector$9.z);
        }
      }

      return this;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(m) {
      for (var _i41 = 0, l = this.count; _i41 < l; _i41++) {
        _vector$9.fromBufferAttribute(this, _i41);

        _vector$9.applyMatrix4(m);

        this.setXYZ(_i41, _vector$9.x, _vector$9.y, _vector$9.z);
      }

      return this;
    }
  }, {
    key: "applyNormalMatrix",
    value: function applyNormalMatrix(m) {
      for (var _i42 = 0, l = this.count; _i42 < l; _i42++) {
        _vector$9.fromBufferAttribute(this, _i42);

        _vector$9.applyNormalMatrix(m);

        this.setXYZ(_i42, _vector$9.x, _vector$9.y, _vector$9.z);
      }

      return this;
    }
  }, {
    key: "transformDirection",
    value: function transformDirection(m) {
      for (var _i43 = 0, l = this.count; _i43 < l; _i43++) {
        _vector$9.fromBufferAttribute(this, _i43);

        _vector$9.transformDirection(m);

        this.setXYZ(_i43, _vector$9.x, _vector$9.y, _vector$9.z);
      }

      return this;
    }
  }, {
    key: "set",
    value: function set(value) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.array.set(value, offset);
      return this;
    }
  }, {
    key: "getX",
    value: function getX(index) {
      return this.array[index * this.itemSize];
    }
  }, {
    key: "setX",
    value: function setX(index, x) {
      this.array[index * this.itemSize] = x;
      return this;
    }
  }, {
    key: "getY",
    value: function getY(index) {
      return this.array[index * this.itemSize + 1];
    }
  }, {
    key: "setY",
    value: function setY(index, y) {
      this.array[index * this.itemSize + 1] = y;
      return this;
    }
  }, {
    key: "getZ",
    value: function getZ(index) {
      return this.array[index * this.itemSize + 2];
    }
  }, {
    key: "setZ",
    value: function setZ(index, z) {
      this.array[index * this.itemSize + 2] = z;
      return this;
    }
  }, {
    key: "getW",
    value: function getW(index) {
      return this.array[index * this.itemSize + 3];
    }
  }, {
    key: "setW",
    value: function setW(index, w) {
      this.array[index * this.itemSize + 3] = w;
      return this;
    }
  }, {
    key: "setXY",
    value: function setXY(index, x, y) {
      index *= this.itemSize;
      this.array[index + 0] = x;
      this.array[index + 1] = y;
      return this;
    }
  }, {
    key: "setXYZ",
    value: function setXYZ(index, x, y, z) {
      index *= this.itemSize;
      this.array[index + 0] = x;
      this.array[index + 1] = y;
      this.array[index + 2] = z;
      return this;
    }
  }, {
    key: "setXYZW",
    value: function setXYZW(index, x, y, z, w) {
      index *= this.itemSize;
      this.array[index + 0] = x;
      this.array[index + 1] = y;
      this.array[index + 2] = z;
      this.array[index + 3] = w;
      return this;
    }
  }, {
    key: "onUpload",
    value: function onUpload(callback) {
      this.onUploadCallback = callback;
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.array, this.itemSize).copy(this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: Array.prototype.slice.call(this.array),
        normalized: this.normalized
      };
      if (this.name !== '') data.name = this.name;
      if (this.usage !== StaticDrawUsage) data.usage = this.usage;
      if (this.updateRange.offset !== 0 || this.updateRange.count !== -1) data.updateRange = this.updateRange;
      return data;
    }
  }]);

  return BufferAttribute;
}();

BufferAttribute.prototype.isBufferAttribute = true;

var Uint16BufferAttribute = /*#__PURE__*/function (_BufferAttribute) {
  _inherits(Uint16BufferAttribute, _BufferAttribute);

  var _super9 = _createSuper(Uint16BufferAttribute);

  function Uint16BufferAttribute(array, itemSize, normalized) {
    _classCallCheck2(this, Uint16BufferAttribute);

    return _super9.call(this, new Uint16Array(array), itemSize, normalized);
  }

  return Uint16BufferAttribute;
}(BufferAttribute);

var Uint32BufferAttribute = /*#__PURE__*/function (_BufferAttribute2) {
  _inherits(Uint32BufferAttribute, _BufferAttribute2);

  var _super10 = _createSuper(Uint32BufferAttribute);

  function Uint32BufferAttribute(array, itemSize, normalized) {
    _classCallCheck2(this, Uint32BufferAttribute);

    return _super10.call(this, new Uint32Array(array), itemSize, normalized);
  }

  return Uint32BufferAttribute;
}(BufferAttribute);

var Float32BufferAttribute = /*#__PURE__*/function (_BufferAttribute3) {
  _inherits(Float32BufferAttribute, _BufferAttribute3);

  var _super11 = _createSuper(Float32BufferAttribute);

  function Float32BufferAttribute(array, itemSize, normalized) {
    _classCallCheck2(this, Float32BufferAttribute);

    return _super11.call(this, new Float32Array(array), itemSize, normalized);
  }

  return Float32BufferAttribute;
}(BufferAttribute);

var _id$1 = 0;

var _m1 = /*@__PURE__*/new Matrix4();

var _obj = /*@__PURE__*/new Object3D();

var _offset = /*@__PURE__*/new Vector3();

var _box$1 = /*@__PURE__*/new Box3();

var _boxMorphTargets = /*@__PURE__*/new Box3();

var _vector$8 = /*@__PURE__*/new Vector3();

var BufferGeometry = /*#__PURE__*/function (_EventDispatcher5) {
  _inherits(BufferGeometry, _EventDispatcher5);

  var _super12 = _createSuper(BufferGeometry);

  function BufferGeometry() {
    var _this9;

    _classCallCheck2(this, BufferGeometry);

    _this9 = _super12.call(this);
    Object.defineProperty(_assertThisInitialized(_this9), 'id', {
      value: _id$1++
    });
    _this9.uuid = generateUUID();
    _this9.name = '';
    _this9.type = 'BufferGeometry';
    _this9.index = null;
    _this9.attributes = {};
    _this9.morphAttributes = {};
    _this9.morphTargetsRelative = false;
    _this9.groups = [];
    _this9.boundingBox = null;
    _this9.boundingSphere = null;
    _this9.drawRange = {
      start: 0,
      count: Infinity
    };
    _this9.userData = {};
    return _this9;
  }

  _createClass2(BufferGeometry, [{
    key: "getIndex",
    value: function getIndex() {
      return this.index;
    }
  }, {
    key: "setIndex",
    value: function setIndex(index) {
      if (Array.isArray(index)) {
        this.index = new (arrayNeedsUint32(index) ? Uint32BufferAttribute : Uint16BufferAttribute)(index, 1);
      } else {
        this.index = index;
      }

      return this;
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(name) {
      return this.attributes[name];
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(name, attribute) {
      this.attributes[name] = attribute;
      return this;
    }
  }, {
    key: "deleteAttribute",
    value: function deleteAttribute(name) {
      delete this.attributes[name];
      return this;
    }
  }, {
    key: "hasAttribute",
    value: function hasAttribute(name) {
      return this.attributes[name] !== undefined;
    }
  }, {
    key: "addGroup",
    value: function addGroup(start, count) {
      var materialIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      this.groups.push({
        start: start,
        count: count,
        materialIndex: materialIndex
      });
    }
  }, {
    key: "clearGroups",
    value: function clearGroups() {
      this.groups = [];
    }
  }, {
    key: "setDrawRange",
    value: function setDrawRange(start, count) {
      this.drawRange.start = start;
      this.drawRange.count = count;
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(matrix) {
      var position = this.attributes.position;

      if (position !== undefined) {
        position.applyMatrix4(matrix);
        position.needsUpdate = true;
      }

      var normal = this.attributes.normal;

      if (normal !== undefined) {
        var normalMatrix = new Matrix3().getNormalMatrix(matrix);
        normal.applyNormalMatrix(normalMatrix);
        normal.needsUpdate = true;
      }

      var tangent = this.attributes.tangent;

      if (tangent !== undefined) {
        tangent.transformDirection(matrix);
        tangent.needsUpdate = true;
      }

      if (this.boundingBox !== null) {
        this.computeBoundingBox();
      }

      if (this.boundingSphere !== null) {
        this.computeBoundingSphere();
      }

      return this;
    }
  }, {
    key: "applyQuaternion",
    value: function applyQuaternion(q) {
      _m1.makeRotationFromQuaternion(q);

      this.applyMatrix4(_m1);
      return this;
    }
  }, {
    key: "rotateX",
    value: function rotateX(angle) {
      // rotate geometry around world x-axis
      _m1.makeRotationX(angle);

      this.applyMatrix4(_m1);
      return this;
    }
  }, {
    key: "rotateY",
    value: function rotateY(angle) {
      // rotate geometry around world y-axis
      _m1.makeRotationY(angle);

      this.applyMatrix4(_m1);
      return this;
    }
  }, {
    key: "rotateZ",
    value: function rotateZ(angle) {
      // rotate geometry around world z-axis
      _m1.makeRotationZ(angle);

      this.applyMatrix4(_m1);
      return this;
    }
  }, {
    key: "translate",
    value: function translate(x, y, z) {
      // translate geometry
      _m1.makeTranslation(x, y, z);

      this.applyMatrix4(_m1);
      return this;
    }
  }, {
    key: "scale",
    value: function scale(x, y, z) {
      // scale geometry
      _m1.makeScale(x, y, z);

      this.applyMatrix4(_m1);
      return this;
    }
  }, {
    key: "lookAt",
    value: function lookAt(vector) {
      _obj.lookAt(vector);

      _obj.updateMatrix();

      this.applyMatrix4(_obj.matrix);
      return this;
    }
  }, {
    key: "center",
    value: function center() {
      this.computeBoundingBox();
      this.boundingBox.getCenter(_offset).negate();
      this.translate(_offset.x, _offset.y, _offset.z);
      return this;
    }
  }, {
    key: "setFromPoints",
    value: function setFromPoints(points) {
      var position = [];

      for (var _i44 = 0, l = points.length; _i44 < l; _i44++) {
        var point = points[_i44];
        position.push(point.x, point.y, point.z || 0);
      }

      this.setAttribute('position', new Float32BufferAttribute(position, 3));
      return this;
    }
  }, {
    key: "computeBoundingBox",
    value: function computeBoundingBox() {
      if (this.boundingBox === null) {
        this.boundingBox = new Box3();
      }

      var position = this.attributes.position;
      var morphAttributesPosition = this.morphAttributes.position;

      if (position && position.isGLBufferAttribute) {
        console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
        this.boundingBox.set(new Vector3(-Infinity, -Infinity, -Infinity), new Vector3(+Infinity, +Infinity, +Infinity));
        return;
      }

      if (position !== undefined) {
        this.boundingBox.setFromBufferAttribute(position); // process morph attributes if present

        if (morphAttributesPosition) {
          for (var _i45 = 0, il = morphAttributesPosition.length; _i45 < il; _i45++) {
            var morphAttribute = morphAttributesPosition[_i45];

            _box$1.setFromBufferAttribute(morphAttribute);

            if (this.morphTargetsRelative) {
              _vector$8.addVectors(this.boundingBox.min, _box$1.min);

              this.boundingBox.expandByPoint(_vector$8);

              _vector$8.addVectors(this.boundingBox.max, _box$1.max);

              this.boundingBox.expandByPoint(_vector$8);
            } else {
              this.boundingBox.expandByPoint(_box$1.min);
              this.boundingBox.expandByPoint(_box$1.max);
            }
          }
        }
      } else {
        this.boundingBox.makeEmpty();
      }

      if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) {
        console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
      }
    }
  }, {
    key: "computeBoundingSphere",
    value: function computeBoundingSphere() {
      if (this.boundingSphere === null) {
        this.boundingSphere = new Sphere();
      }

      var position = this.attributes.position;
      var morphAttributesPosition = this.morphAttributes.position;

      if (position && position.isGLBufferAttribute) {
        console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
        this.boundingSphere.set(new Vector3(), Infinity);
        return;
      }

      if (position) {
        // first, find the center of the bounding sphere
        var center = this.boundingSphere.center;

        _box$1.setFromBufferAttribute(position); // process morph attributes if present


        if (morphAttributesPosition) {
          for (var _i46 = 0, il = morphAttributesPosition.length; _i46 < il; _i46++) {
            var morphAttribute = morphAttributesPosition[_i46];

            _boxMorphTargets.setFromBufferAttribute(morphAttribute);

            if (this.morphTargetsRelative) {
              _vector$8.addVectors(_box$1.min, _boxMorphTargets.min);

              _box$1.expandByPoint(_vector$8);

              _vector$8.addVectors(_box$1.max, _boxMorphTargets.max);

              _box$1.expandByPoint(_vector$8);
            } else {
              _box$1.expandByPoint(_boxMorphTargets.min);

              _box$1.expandByPoint(_boxMorphTargets.max);
            }
          }
        }

        _box$1.getCenter(center); // second, try to find a boundingSphere with a radius smaller than the
        // boundingSphere of the boundingBox: sqrt(3) smaller in the best case


        var maxRadiusSq = 0;

        for (var _i47 = 0, _il = position.count; _i47 < _il; _i47++) {
          _vector$8.fromBufferAttribute(position, _i47);

          maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
        } // process morph attributes if present


        if (morphAttributesPosition) {
          for (var _i48 = 0, _il2 = morphAttributesPosition.length; _i48 < _il2; _i48++) {
            var _morphAttribute = morphAttributesPosition[_i48];
            var morphTargetsRelative = this.morphTargetsRelative;

            for (var j = 0, jl = _morphAttribute.count; j < jl; j++) {
              _vector$8.fromBufferAttribute(_morphAttribute, j);

              if (morphTargetsRelative) {
                _offset.fromBufferAttribute(position, j);

                _vector$8.add(_offset);
              }

              maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
            }
          }
        }

        this.boundingSphere.radius = Math.sqrt(maxRadiusSq);

        if (isNaN(this.boundingSphere.radius)) {
          console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
      }
    }
  }, {
    key: "computeTangents",
    value: function computeTangents() {
      var index = this.index;
      var attributes = this.attributes; // based on http://www.terathon.com/code/tangent.html
      // (per vertex tangents)

      if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
        console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
        return;
      }

      var indices = index.array;
      var positions = attributes.position.array;
      var normals = attributes.normal.array;
      var uvs = attributes.uv.array;
      var nVertices = positions.length / 3;

      if (this.hasAttribute('tangent') === false) {
        this.setAttribute('tangent', new BufferAttribute(new Float32Array(4 * nVertices), 4));
      }

      var tangents = this.getAttribute('tangent').array;
      var tan1 = [],
          tan2 = [];

      for (var _i49 = 0; _i49 < nVertices; _i49++) {
        tan1[_i49] = new Vector3();
        tan2[_i49] = new Vector3();
      }

      var vA = new Vector3(),
          vB = new Vector3(),
          vC = new Vector3(),
          uvA = new Vector2(),
          uvB = new Vector2(),
          uvC = new Vector2(),
          sdir = new Vector3(),
          tdir = new Vector3();

      function handleTriangle(a, b, c) {
        vA.fromArray(positions, a * 3);
        vB.fromArray(positions, b * 3);
        vC.fromArray(positions, c * 3);
        uvA.fromArray(uvs, a * 2);
        uvB.fromArray(uvs, b * 2);
        uvC.fromArray(uvs, c * 2);
        vB.sub(vA);
        vC.sub(vA);
        uvB.sub(uvA);
        uvC.sub(uvA);
        var r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y); // silently ignore degenerate uv triangles having coincident or colinear vertices

        if (!isFinite(r)) return;
        sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
        tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
        tan1[a].add(sdir);
        tan1[b].add(sdir);
        tan1[c].add(sdir);
        tan2[a].add(tdir);
        tan2[b].add(tdir);
        tan2[c].add(tdir);
      }

      var groups = this.groups;

      if (groups.length === 0) {
        groups = [{
          start: 0,
          count: indices.length
        }];
      }

      for (var _i50 = 0, il = groups.length; _i50 < il; ++_i50) {
        var group = groups[_i50];
        var start = group.start;
        var count = group.count;

        for (var j = start, jl = start + count; j < jl; j += 3) {
          handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
      }

      var tmp = new Vector3(),
          tmp2 = new Vector3();
      var n = new Vector3(),
          n2 = new Vector3();

      function handleVertex(v) {
        n.fromArray(normals, v * 3);
        n2.copy(n);
        var t = tan1[v]; // Gram-Schmidt orthogonalize

        tmp.copy(t);
        tmp.sub(n.multiplyScalar(n.dot(t))).normalize(); // Calculate handedness

        tmp2.crossVectors(n2, t);
        var test = tmp2.dot(tan2[v]);
        var w = test < 0.0 ? -1.0 : 1.0;
        tangents[v * 4] = tmp.x;
        tangents[v * 4 + 1] = tmp.y;
        tangents[v * 4 + 2] = tmp.z;
        tangents[v * 4 + 3] = w;
      }

      for (var _i51 = 0, _il3 = groups.length; _i51 < _il3; ++_i51) {
        var _group = groups[_i51];
        var _start2 = _group.start;
        var _count = _group.count;

        for (var _j2 = _start2, _jl = _start2 + _count; _j2 < _jl; _j2 += 3) {
          handleVertex(indices[_j2 + 0]);
          handleVertex(indices[_j2 + 1]);
          handleVertex(indices[_j2 + 2]);
        }
      }
    }
  }, {
    key: "computeVertexNormals",
    value: function computeVertexNormals() {
      var index = this.index;
      var positionAttribute = this.getAttribute('position');

      if (positionAttribute !== undefined) {
        var normalAttribute = this.getAttribute('normal');

        if (normalAttribute === undefined) {
          normalAttribute = new BufferAttribute(new Float32Array(positionAttribute.count * 3), 3);
          this.setAttribute('normal', normalAttribute);
        } else {
          // reset existing normals to zero
          for (var _i52 = 0, il = normalAttribute.count; _i52 < il; _i52++) {
            normalAttribute.setXYZ(_i52, 0, 0, 0);
          }
        }

        var pA = new Vector3(),
            pB = new Vector3(),
            pC = new Vector3();
        var nA = new Vector3(),
            nB = new Vector3(),
            nC = new Vector3();
        var cb = new Vector3(),
            ab = new Vector3(); // indexed elements

        if (index) {
          for (var _i53 = 0, _il4 = index.count; _i53 < _il4; _i53 += 3) {
            var vA = index.getX(_i53 + 0);
            var vB = index.getX(_i53 + 1);
            var vC = index.getX(_i53 + 2);
            pA.fromBufferAttribute(positionAttribute, vA);
            pB.fromBufferAttribute(positionAttribute, vB);
            pC.fromBufferAttribute(positionAttribute, vC);
            cb.subVectors(pC, pB);
            ab.subVectors(pA, pB);
            cb.cross(ab);
            nA.fromBufferAttribute(normalAttribute, vA);
            nB.fromBufferAttribute(normalAttribute, vB);
            nC.fromBufferAttribute(normalAttribute, vC);
            nA.add(cb);
            nB.add(cb);
            nC.add(cb);
            normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
            normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
            normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
          }
        } else {
          // non-indexed elements (unconnected triangle soup)
          for (var _i54 = 0, _il5 = positionAttribute.count; _i54 < _il5; _i54 += 3) {
            pA.fromBufferAttribute(positionAttribute, _i54 + 0);
            pB.fromBufferAttribute(positionAttribute, _i54 + 1);
            pC.fromBufferAttribute(positionAttribute, _i54 + 2);
            cb.subVectors(pC, pB);
            ab.subVectors(pA, pB);
            cb.cross(ab);
            normalAttribute.setXYZ(_i54 + 0, cb.x, cb.y, cb.z);
            normalAttribute.setXYZ(_i54 + 1, cb.x, cb.y, cb.z);
            normalAttribute.setXYZ(_i54 + 2, cb.x, cb.y, cb.z);
          }
        }

        this.normalizeNormals();
        normalAttribute.needsUpdate = true;
      }
    }
  }, {
    key: "merge",
    value: function merge(geometry, offset) {
      if (!(geometry && geometry.isBufferGeometry)) {
        console.error('THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry);
        return;
      }

      if (offset === undefined) {
        offset = 0;
        console.warn('THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. ' + 'Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge.');
      }

      var attributes = this.attributes;

      for (var key in attributes) {
        if (geometry.attributes[key] === undefined) continue;
        var attribute1 = attributes[key];
        var attributeArray1 = attribute1.array;
        var attribute2 = geometry.attributes[key];
        var attributeArray2 = attribute2.array;
        var attributeOffset = attribute2.itemSize * offset;

        var _length2 = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);

        for (var _i55 = 0, j = attributeOffset; _i55 < _length2; _i55++, j++) {
          attributeArray1[j] = attributeArray2[_i55];
        }
      }

      return this;
    }
  }, {
    key: "normalizeNormals",
    value: function normalizeNormals() {
      var normals = this.attributes.normal;

      for (var _i56 = 0, il = normals.count; _i56 < il; _i56++) {
        _vector$8.fromBufferAttribute(normals, _i56);

        _vector$8.normalize();

        normals.setXYZ(_i56, _vector$8.x, _vector$8.y, _vector$8.z);
      }
    }
  }, {
    key: "toNonIndexed",
    value: function toNonIndexed() {
      function convertBufferAttribute(attribute, indices) {
        var array = attribute.array;
        var itemSize = attribute.itemSize;
        var normalized = attribute.normalized;
        var array2 = new array.constructor(indices.length * itemSize);
        var index = 0,
            index2 = 0;

        for (var _i57 = 0, l = indices.length; _i57 < l; _i57++) {
          if (attribute.isInterleavedBufferAttribute) {
            index = indices[_i57] * attribute.data.stride + attribute.offset;
          } else {
            index = indices[_i57] * itemSize;
          }

          for (var j = 0; j < itemSize; j++) {
            array2[index2++] = array[index++];
          }
        }

        return new BufferAttribute(array2, itemSize, normalized);
      } //


      if (this.index === null) {
        console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
        return this;
      }

      var geometry2 = new BufferGeometry();
      var indices = this.index.array;
      var attributes = this.attributes; // attributes

      for (var name in attributes) {
        var attribute = attributes[name];
        var newAttribute = convertBufferAttribute(attribute, indices);
        geometry2.setAttribute(name, newAttribute);
      } // morph attributes


      var morphAttributes = this.morphAttributes;

      for (var _name in morphAttributes) {
        var morphArray = [];
        var morphAttribute = morphAttributes[_name]; // morphAttribute: array of Float32BufferAttributes

        for (var _i58 = 0, il = morphAttribute.length; _i58 < il; _i58++) {
          var _attribute = morphAttribute[_i58];

          var _newAttribute = convertBufferAttribute(_attribute, indices);

          morphArray.push(_newAttribute);
        }

        geometry2.morphAttributes[_name] = morphArray;
      }

      geometry2.morphTargetsRelative = this.morphTargetsRelative; // groups

      var groups = this.groups;

      for (var _i59 = 0, l = groups.length; _i59 < l; _i59++) {
        var group = groups[_i59];
        geometry2.addGroup(group.start, group.count, group.materialIndex);
      }

      return geometry2;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = {
        metadata: {
          version: 4.5,
          type: 'BufferGeometry',
          generator: 'BufferGeometry.toJSON'
        }
      }; // standard BufferGeometry serialization

      data.uuid = this.uuid;
      data.type = this.type;
      if (this.name !== '') data.name = this.name;
      if (Object.keys(this.userData).length > 0) data.userData = this.userData;

      if (this.parameters !== undefined) {
        var parameters = this.parameters;

        for (var key in parameters) {
          if (parameters[key] !== undefined) data[key] = parameters[key];
        }

        return data;
      } // for simplicity the code assumes attributes are not shared across geometries, see #15811


      data.data = {
        attributes: {}
      };
      var index = this.index;

      if (index !== null) {
        data.data.index = {
          type: index.array.constructor.name,
          array: Array.prototype.slice.call(index.array)
        };
      }

      var attributes = this.attributes;

      for (var _key5 in attributes) {
        var attribute = attributes[_key5];
        data.data.attributes[_key5] = attribute.toJSON(data.data);
      }

      var morphAttributes = {};
      var hasMorphAttributes = false;

      for (var _key6 in this.morphAttributes) {
        var attributeArray = this.morphAttributes[_key6];
        var array = [];

        for (var _i60 = 0, il = attributeArray.length; _i60 < il; _i60++) {
          var _attribute2 = attributeArray[_i60];
          array.push(_attribute2.toJSON(data.data));
        }

        if (array.length > 0) {
          morphAttributes[_key6] = array;
          hasMorphAttributes = true;
        }
      }

      if (hasMorphAttributes) {
        data.data.morphAttributes = morphAttributes;
        data.data.morphTargetsRelative = this.morphTargetsRelative;
      }

      var groups = this.groups;

      if (groups.length > 0) {
        data.data.groups = JSON.parse(JSON.stringify(groups));
      }

      var boundingSphere = this.boundingSphere;

      if (boundingSphere !== null) {
        data.data.boundingSphere = {
          center: boundingSphere.center.toArray(),
          radius: boundingSphere.radius
        };
      }

      return data;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      // reset
      this.index = null;
      this.attributes = {};
      this.morphAttributes = {};
      this.groups = [];
      this.boundingBox = null;
      this.boundingSphere = null; // used for storing cloned, shared data

      var data = {}; // name

      this.name = source.name; // index

      var index = source.index;

      if (index !== null) {
        this.setIndex(index.clone(data));
      } // attributes


      var attributes = source.attributes;

      for (var name in attributes) {
        var attribute = attributes[name];
        this.setAttribute(name, attribute.clone(data));
      } // morph attributes


      var morphAttributes = source.morphAttributes;

      for (var _name2 in morphAttributes) {
        var array = [];
        var morphAttribute = morphAttributes[_name2]; // morphAttribute: array of Float32BufferAttributes

        for (var _i61 = 0, l = morphAttribute.length; _i61 < l; _i61++) {
          array.push(morphAttribute[_i61].clone(data));
        }

        this.morphAttributes[_name2] = array;
      }

      this.morphTargetsRelative = source.morphTargetsRelative; // groups

      var groups = source.groups;

      for (var _i62 = 0, _l4 = groups.length; _i62 < _l4; _i62++) {
        var group = groups[_i62];
        this.addGroup(group.start, group.count, group.materialIndex);
      } // bounding box


      var boundingBox = source.boundingBox;

      if (boundingBox !== null) {
        this.boundingBox = boundingBox.clone();
      } // bounding sphere


      var boundingSphere = source.boundingSphere;

      if (boundingSphere !== null) {
        this.boundingSphere = boundingSphere.clone();
      } // draw range


      this.drawRange.start = source.drawRange.start;
      this.drawRange.count = source.drawRange.count; // user data

      this.userData = source.userData; // geometry generator parameters

      if (source.parameters !== undefined) this.parameters = Object.assign({}, source.parameters);
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: 'dispose'
      });
    }
  }]);

  return BufferGeometry;
}(EventDispatcher);

BufferGeometry.prototype.isBufferGeometry = true;

var _inverseMatrix$2 = /*@__PURE__*/new Matrix4();

var _ray$2 = /*@__PURE__*/new Ray();

var _sphere$3 = /*@__PURE__*/new Sphere();

var _vA$1 = /*@__PURE__*/new Vector3();

var _vB$1 = /*@__PURE__*/new Vector3();

var _vC$1 = /*@__PURE__*/new Vector3();

var _tempA = /*@__PURE__*/new Vector3();

var _tempB = /*@__PURE__*/new Vector3();

var _tempC = /*@__PURE__*/new Vector3();

var _morphA = /*@__PURE__*/new Vector3();

var _morphB = /*@__PURE__*/new Vector3();

var _morphC = /*@__PURE__*/new Vector3();

var _uvA$1 = /*@__PURE__*/new Vector2();

var _uvB$1 = /*@__PURE__*/new Vector2();

var _uvC$1 = /*@__PURE__*/new Vector2();

var _intersectionPoint = /*@__PURE__*/new Vector3();

var _intersectionPointWorld = /*@__PURE__*/new Vector3();

var Mesh = /*#__PURE__*/function (_Object3D) {
  _inherits(Mesh, _Object3D);

  var _super13 = _createSuper(Mesh);

  function Mesh() {
    var _this10;

    var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new BufferGeometry();
    var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new MeshBasicMaterial();

    _classCallCheck2(this, Mesh);

    _this10 = _super13.call(this);
    _this10.type = 'Mesh';
    _this10.geometry = geometry;
    _this10.material = material;

    _this10.updateMorphTargets();

    return _this10;
  }

  _createClass2(Mesh, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(Mesh.prototype), "copy", this).call(this, source);

      if (source.morphTargetInfluences !== undefined) {
        this.morphTargetInfluences = source.morphTargetInfluences.slice();
      }

      if (source.morphTargetDictionary !== undefined) {
        this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
      }

      this.material = source.material;
      this.geometry = source.geometry;
      return this;
    }
  }, {
    key: "updateMorphTargets",
    value: function updateMorphTargets() {
      var geometry = this.geometry;

      if (geometry.isBufferGeometry) {
        var morphAttributes = geometry.morphAttributes;
        var keys = Object.keys(morphAttributes);

        if (keys.length > 0) {
          var morphAttribute = morphAttributes[keys[0]];

          if (morphAttribute !== undefined) {
            this.morphTargetInfluences = [];
            this.morphTargetDictionary = {};

            for (var m = 0, ml = morphAttribute.length; m < ml; m++) {
              var name = morphAttribute[m].name || String(m);
              this.morphTargetInfluences.push(0);
              this.morphTargetDictionary[name] = m;
            }
          }
        }
      } else {
        var morphTargets = geometry.morphTargets;

        if (morphTargets !== undefined && morphTargets.length > 0) {
          console.error('THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
      }
    }
  }, {
    key: "raycast",
    value: function raycast(raycaster, intersects) {
      var geometry = this.geometry;
      var material = this.material;
      var matrixWorld = this.matrixWorld;
      if (material === undefined) return; // Checking boundingSphere distance to ray

      if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

      _sphere$3.copy(geometry.boundingSphere);

      _sphere$3.applyMatrix4(matrixWorld);

      if (raycaster.ray.intersectsSphere(_sphere$3) === false) return; //

      _inverseMatrix$2.copy(matrixWorld).invert();

      _ray$2.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2); // Check boundingBox before continuing


      if (geometry.boundingBox !== null) {
        if (_ray$2.intersectsBox(geometry.boundingBox) === false) return;
      }

      var intersection;

      if (geometry.isBufferGeometry) {
        var _index3 = geometry.index;
        var position = geometry.attributes.position;
        var morphPosition = geometry.morphAttributes.position;
        var morphTargetsRelative = geometry.morphTargetsRelative;
        var uv = geometry.attributes.uv;
        var uv2 = geometry.attributes.uv2;
        var groups = geometry.groups;
        var drawRange = geometry.drawRange;

        if (_index3 !== null) {
          // indexed buffer geometry
          if (Array.isArray(material)) {
            for (var _i63 = 0, il = groups.length; _i63 < il; _i63++) {
              var group = groups[_i63];
              var groupMaterial = material[group.materialIndex];
              var start = Math.max(group.start, drawRange.start);
              var end = Math.min(_index3.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));

              for (var j = start, jl = end; j < jl; j += 3) {
                var a = _index3.getX(j);

                var b = _index3.getX(j + 1);

                var c = _index3.getX(j + 2);

                intersection = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);

                if (intersection) {
                  intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics

                  intersection.face.materialIndex = group.materialIndex;
                  intersects.push(intersection);
                }
              }
            }
          } else {
            var _start3 = Math.max(0, drawRange.start);

            var _end2 = Math.min(_index3.count, drawRange.start + drawRange.count);

            for (var _i64 = _start3, _il6 = _end2; _i64 < _il6; _i64 += 3) {
              var _a2 = _index3.getX(_i64);

              var _b2 = _index3.getX(_i64 + 1);

              var _c2 = _index3.getX(_i64 + 2);

              intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, _a2, _b2, _c2);

              if (intersection) {
                intersection.faceIndex = Math.floor(_i64 / 3); // triangle number in indexed buffer semantics

                intersects.push(intersection);
              }
            }
          }
        } else if (position !== undefined) {
          // non-indexed buffer geometry
          if (Array.isArray(material)) {
            for (var _i65 = 0, _il7 = groups.length; _i65 < _il7; _i65++) {
              var _group2 = groups[_i65];
              var _groupMaterial = material[_group2.materialIndex];

              var _start4 = Math.max(_group2.start, drawRange.start);

              var _end3 = Math.min(position.count, Math.min(_group2.start + _group2.count, drawRange.start + drawRange.count));

              for (var _j3 = _start4, _jl2 = _end3; _j3 < _jl2; _j3 += 3) {
                var _a3 = _j3;

                var _b3 = _j3 + 1;

                var _c3 = _j3 + 2;

                intersection = checkBufferGeometryIntersection(this, _groupMaterial, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, _a3, _b3, _c3);

                if (intersection) {
                  intersection.faceIndex = Math.floor(_j3 / 3); // triangle number in non-indexed buffer semantics

                  intersection.face.materialIndex = _group2.materialIndex;
                  intersects.push(intersection);
                }
              }
            }
          } else {
            var _start5 = Math.max(0, drawRange.start);

            var _end4 = Math.min(position.count, drawRange.start + drawRange.count);

            for (var _i66 = _start5, _il8 = _end4; _i66 < _il8; _i66 += 3) {
              var _a4 = _i66;

              var _b4 = _i66 + 1;

              var _c4 = _i66 + 2;

              intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray$2, position, morphPosition, morphTargetsRelative, uv, uv2, _a4, _b4, _c4);

              if (intersection) {
                intersection.faceIndex = Math.floor(_i66 / 3); // triangle number in non-indexed buffer semantics

                intersects.push(intersection);
              }
            }
          }
        }
      } else if (geometry.isGeometry) {
        console.error('THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
      }
    }
  }]);

  return Mesh;
}(Object3D);

Mesh.prototype.isMesh = true;

function checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
  var intersect;

  if (material.side === BackSide) {
    intersect = ray.intersectTriangle(pC, pB, pA, true, point);
  } else {
    intersect = ray.intersectTriangle(pA, pB, pC, material.side !== DoubleSide, point);
  }

  if (intersect === null) return null;

  _intersectionPointWorld.copy(point);

  _intersectionPointWorld.applyMatrix4(object.matrixWorld);

  var distance = raycaster.ray.origin.distanceTo(_intersectionPointWorld);
  if (distance < raycaster.near || distance > raycaster.far) return null;
  return {
    distance: distance,
    point: _intersectionPointWorld.clone(),
    object: object
  };
}

function checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
  _vA$1.fromBufferAttribute(position, a);

  _vB$1.fromBufferAttribute(position, b);

  _vC$1.fromBufferAttribute(position, c);

  var morphInfluences = object.morphTargetInfluences;

  if (morphPosition && morphInfluences) {
    _morphA.set(0, 0, 0);

    _morphB.set(0, 0, 0);

    _morphC.set(0, 0, 0);

    for (var _i67 = 0, il = morphPosition.length; _i67 < il; _i67++) {
      var influence = morphInfluences[_i67];
      var morphAttribute = morphPosition[_i67];
      if (influence === 0) continue;

      _tempA.fromBufferAttribute(morphAttribute, a);

      _tempB.fromBufferAttribute(morphAttribute, b);

      _tempC.fromBufferAttribute(morphAttribute, c);

      if (morphTargetsRelative) {
        _morphA.addScaledVector(_tempA, influence);

        _morphB.addScaledVector(_tempB, influence);

        _morphC.addScaledVector(_tempC, influence);
      } else {
        _morphA.addScaledVector(_tempA.sub(_vA$1), influence);

        _morphB.addScaledVector(_tempB.sub(_vB$1), influence);

        _morphC.addScaledVector(_tempC.sub(_vC$1), influence);
      }
    }

    _vA$1.add(_morphA);

    _vB$1.add(_morphB);

    _vC$1.add(_morphC);
  }

  if (object.isSkinnedMesh) {
    object.boneTransform(a, _vA$1);
    object.boneTransform(b, _vB$1);
    object.boneTransform(c, _vC$1);
  }

  var intersection = checkIntersection(object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint);

  if (intersection) {
    if (uv) {
      _uvA$1.fromBufferAttribute(uv, a);

      _uvB$1.fromBufferAttribute(uv, b);

      _uvC$1.fromBufferAttribute(uv, c);

      intersection.uv = Triangle.getUV(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2());
    }

    if (uv2) {
      _uvA$1.fromBufferAttribute(uv2, a);

      _uvB$1.fromBufferAttribute(uv2, b);

      _uvC$1.fromBufferAttribute(uv2, c);

      intersection.uv2 = Triangle.getUV(_intersectionPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2());
    }

    var face = {
      a: a,
      b: b,
      c: c,
      normal: new Vector3(),
      materialIndex: 0
    };
    Triangle.getNormal(_vA$1, _vB$1, _vC$1, face.normal);
    intersection.face = face;
  }

  return intersection;
}

var BoxGeometry = /*#__PURE__*/function (_BufferGeometry) {
  _inherits(BoxGeometry, _BufferGeometry);

  var _super14 = _createSuper(BoxGeometry);

  function BoxGeometry() {
    var _this11;

    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var widthSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var heightSegments = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var depthSegments = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;

    _classCallCheck2(this, BoxGeometry);

    _this11 = _super14.call(this);
    _this11.type = 'BoxGeometry';
    _this11.parameters = {
      width: width,
      height: height,
      depth: depth,
      widthSegments: widthSegments,
      heightSegments: heightSegments,
      depthSegments: depthSegments
    };

    var scope = _assertThisInitialized(_this11); // segments


    widthSegments = Math.floor(widthSegments);
    heightSegments = Math.floor(heightSegments);
    depthSegments = Math.floor(depthSegments); // buffers

    var indices = [];
    var vertices = [];
    var normals = [];
    var uvs = []; // helper variables

    var numberOfVertices = 0;
    var groupStart = 0; // build each side of the box geometry

    buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px

    buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx

    buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py

    buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny

    buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz

    buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
    // build geometry

    _this11.setIndex(indices);

    _this11.setAttribute('position', new Float32BufferAttribute(vertices, 3));

    _this11.setAttribute('normal', new Float32BufferAttribute(normals, 3));

    _this11.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

    function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
      var segmentWidth = width / gridX;
      var segmentHeight = height / gridY;
      var widthHalf = width / 2;
      var heightHalf = height / 2;
      var depthHalf = depth / 2;
      var gridX1 = gridX + 1;
      var gridY1 = gridY + 1;
      var vertexCounter = 0;
      var groupCount = 0;
      var vector = new Vector3(); // generate vertices, normals and uvs

      for (var iy = 0; iy < gridY1; iy++) {
        var y = iy * segmentHeight - heightHalf;

        for (var ix = 0; ix < gridX1; ix++) {
          var x = ix * segmentWidth - widthHalf; // set values to correct vector component

          vector[u] = x * udir;
          vector[v] = y * vdir;
          vector[w] = depthHalf; // now apply vector to vertex buffer

          vertices.push(vector.x, vector.y, vector.z); // set values to correct vector component

          vector[u] = 0;
          vector[v] = 0;
          vector[w] = depth > 0 ? 1 : -1; // now apply vector to normal buffer

          normals.push(vector.x, vector.y, vector.z); // uvs

          uvs.push(ix / gridX);
          uvs.push(1 - iy / gridY); // counters

          vertexCounter += 1;
        }
      } // indices
      // 1. you need three indices to draw a single face
      // 2. a single segment consists of two faces
      // 3. so we need to generate six (2*3) indices per segment


      for (var _iy = 0; _iy < gridY; _iy++) {
        for (var _ix = 0; _ix < gridX; _ix++) {
          var a = numberOfVertices + _ix + gridX1 * _iy;
          var b = numberOfVertices + _ix + gridX1 * (_iy + 1);
          var c = numberOfVertices + (_ix + 1) + gridX1 * (_iy + 1);
          var d = numberOfVertices + (_ix + 1) + gridX1 * _iy; // faces

          indices.push(a, b, d);
          indices.push(b, c, d); // increase counter

          groupCount += 6;
        }
      } // add a group to the geometry. this will ensure multi material support


      scope.addGroup(groupStart, groupCount, materialIndex); // calculate new start value for groups

      groupStart += groupCount; // update total number of vertices

      numberOfVertices += vertexCounter;
    }

    return _this11;
  }

  _createClass2(BoxGeometry, null, [{
    key: "fromJSON",
    value: function fromJSON(data) {
      return new BoxGeometry(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
  }]);

  return BoxGeometry;
}(BufferGeometry);
/**
 * Uniform Utilities
 */


function cloneUniforms(src) {
  var dst = {};

  for (var u in src) {
    dst[u] = {};

    for (var p in src[u]) {
      var property = src[u][p];

      if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
        dst[u][p] = property.clone();
      } else if (Array.isArray(property)) {
        dst[u][p] = property.slice();
      } else {
        dst[u][p] = property;
      }
    }
  }

  return dst;
}

function mergeUniforms(uniforms) {
  var merged = {};

  for (var u = 0; u < uniforms.length; u++) {
    var _tmp2 = cloneUniforms(uniforms[u]);

    for (var p in _tmp2) {
      merged[p] = _tmp2[p];
    }
  }

  return merged;
} // Legacy


var UniformsUtils = {
  clone: cloneUniforms,
  merge: mergeUniforms
};
var default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";

var ShaderMaterial = /*#__PURE__*/function (_Material2) {
  _inherits(ShaderMaterial, _Material2);

  var _super15 = _createSuper(ShaderMaterial);

  function ShaderMaterial(parameters) {
    var _this12;

    _classCallCheck2(this, ShaderMaterial);

    _this12 = _super15.call(this);
    _this12.type = 'ShaderMaterial';
    _this12.defines = {};
    _this12.uniforms = {};
    _this12.vertexShader = default_vertex;
    _this12.fragmentShader = default_fragment;
    _this12.linewidth = 1;
    _this12.wireframe = false;
    _this12.wireframeLinewidth = 1;
    _this12.fog = false; // set to use scene fog

    _this12.lights = false; // set to use scene lights

    _this12.clipping = false; // set to use user-defined clipping planes

    _this12.extensions = {
      derivatives: false,
      // set to use derivatives
      fragDepth: false,
      // set to use fragment depth values
      drawBuffers: false,
      // set to use draw buffers
      shaderTextureLOD: false // set to use shader texture LOD

    }; // When rendered geometry doesn't include these attributes but the material does,
    // use these default values in WebGL. This avoids errors when buffer data is missing.

    _this12.defaultAttributeValues = {
      'color': [1, 1, 1],
      'uv': [0, 0],
      'uv2': [0, 0]
    };
    _this12.index0AttributeName = undefined;
    _this12.uniformsNeedUpdate = false;
    _this12.glslVersion = null;

    if (parameters !== undefined) {
      if (parameters.attributes !== undefined) {
        console.error('THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.');
      }

      _this12.setValues(parameters);
    }

    return _this12;
  }

  _createClass2(ShaderMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(ShaderMaterial.prototype), "copy", this).call(this, source);

      this.fragmentShader = source.fragmentShader;
      this.vertexShader = source.vertexShader;
      this.uniforms = cloneUniforms(source.uniforms);
      this.defines = Object.assign({}, source.defines);
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      this.fog = source.fog;
      this.lights = source.lights;
      this.clipping = source.clipping;
      this.extensions = Object.assign({}, source.extensions);
      this.glslVersion = source.glslVersion;
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(meta) {
      var data = _get(_getPrototypeOf(ShaderMaterial.prototype), "toJSON", this).call(this, meta);

      data.glslVersion = this.glslVersion;
      data.uniforms = {};

      for (var name in this.uniforms) {
        var uniform = this.uniforms[name];
        var _value = uniform.value;

        if (_value && _value.isTexture) {
          data.uniforms[name] = {
            type: 't',
            value: _value.toJSON(meta).uuid
          };
        } else if (_value && _value.isColor) {
          data.uniforms[name] = {
            type: 'c',
            value: _value.getHex()
          };
        } else if (_value && _value.isVector2) {
          data.uniforms[name] = {
            type: 'v2',
            value: _value.toArray()
          };
        } else if (_value && _value.isVector3) {
          data.uniforms[name] = {
            type: 'v3',
            value: _value.toArray()
          };
        } else if (_value && _value.isVector4) {
          data.uniforms[name] = {
            type: 'v4',
            value: _value.toArray()
          };
        } else if (_value && _value.isMatrix3) {
          data.uniforms[name] = {
            type: 'm3',
            value: _value.toArray()
          };
        } else if (_value && _value.isMatrix4) {
          data.uniforms[name] = {
            type: 'm4',
            value: _value.toArray()
          };
        } else {
          data.uniforms[name] = {
            value: _value
          }; // note: the array variants v2v, v3v, v4v, m4v and tv are not supported so far
        }
      }

      if (Object.keys(this.defines).length > 0) data.defines = this.defines;
      data.vertexShader = this.vertexShader;
      data.fragmentShader = this.fragmentShader;
      var extensions = {};

      for (var key in this.extensions) {
        if (this.extensions[key] === true) extensions[key] = true;
      }

      if (Object.keys(extensions).length > 0) data.extensions = extensions;
      return data;
    }
  }]);

  return ShaderMaterial;
}(Material);

ShaderMaterial.prototype.isShaderMaterial = true;

var Camera = /*#__PURE__*/function (_Object3D2) {
  _inherits(Camera, _Object3D2);

  var _super16 = _createSuper(Camera);

  function Camera() {
    var _this13;

    _classCallCheck2(this, Camera);

    _this13 = _super16.call(this);
    _this13.type = 'Camera';
    _this13.matrixWorldInverse = new Matrix4();
    _this13.projectionMatrix = new Matrix4();
    _this13.projectionMatrixInverse = new Matrix4();
    return _this13;
  }

  _createClass2(Camera, [{
    key: "copy",
    value: function copy(source, recursive) {
      _get(_getPrototypeOf(Camera.prototype), "copy", this).call(this, source, recursive);

      this.matrixWorldInverse.copy(source.matrixWorldInverse);
      this.projectionMatrix.copy(source.projectionMatrix);
      this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
      return this;
    }
  }, {
    key: "getWorldDirection",
    value: function getWorldDirection(target) {
      this.updateWorldMatrix(true, false);
      var e = this.matrixWorld.elements;
      return target.set(-e[8], -e[9], -e[10]).normalize();
    }
  }, {
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(force) {
      _get(_getPrototypeOf(Camera.prototype), "updateMatrixWorld", this).call(this, force);

      this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
  }, {
    key: "updateWorldMatrix",
    value: function updateWorldMatrix(updateParents, updateChildren) {
      _get(_getPrototypeOf(Camera.prototype), "updateWorldMatrix", this).call(this, updateParents, updateChildren);

      this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Camera;
}(Object3D);

Camera.prototype.isCamera = true;

var PerspectiveCamera = /*#__PURE__*/function (_Camera) {
  _inherits(PerspectiveCamera, _Camera);

  var _super17 = _createSuper(PerspectiveCamera);

  function PerspectiveCamera() {
    var _this14;

    var fov = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
    var aspect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var near = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.1;
    var far = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2000;

    _classCallCheck2(this, PerspectiveCamera);

    _this14 = _super17.call(this);
    _this14.type = 'PerspectiveCamera';
    _this14.fov = fov;
    _this14.zoom = 1;
    _this14.near = near;
    _this14.far = far;
    _this14.focus = 10;
    _this14.aspect = aspect;
    _this14.view = null;
    _this14.filmGauge = 35; // width of the film (default in millimeters)

    _this14.filmOffset = 0; // horizontal film offset (same unit as gauge)

    _this14.updateProjectionMatrix();

    return _this14;
  }

  _createClass2(PerspectiveCamera, [{
    key: "copy",
    value: function copy(source, recursive) {
      _get(_getPrototypeOf(PerspectiveCamera.prototype), "copy", this).call(this, source, recursive);

      this.fov = source.fov;
      this.zoom = source.zoom;
      this.near = source.near;
      this.far = source.far;
      this.focus = source.focus;
      this.aspect = source.aspect;
      this.view = source.view === null ? null : Object.assign({}, source.view);
      this.filmGauge = source.filmGauge;
      this.filmOffset = source.filmOffset;
      return this;
    }
    /**
     * Sets the FOV by focal length in respect to the current .filmGauge.
     *
     * The default film gauge is 35, so that the focal length can be specified for
     * a 35mm (full frame) camera.
     *
     * Values for focal length and film gauge must have the same unit.
     */

  }, {
    key: "setFocalLength",
    value: function setFocalLength(focalLength) {
      /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */
      var vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
      this.fov = RAD2DEG * 2 * Math.atan(vExtentSlope);
      this.updateProjectionMatrix();
    }
    /**
     * Calculates the focal length from the current .fov and .filmGauge.
     */

  }, {
    key: "getFocalLength",
    value: function getFocalLength() {
      var vExtentSlope = Math.tan(DEG2RAD * 0.5 * this.fov);
      return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
  }, {
    key: "getEffectiveFOV",
    value: function getEffectiveFOV() {
      return RAD2DEG * 2 * Math.atan(Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
  }, {
    key: "getFilmWidth",
    value: function getFilmWidth() {
      // film not completely covered in portrait format (aspect < 1)
      return this.filmGauge * Math.min(this.aspect, 1);
    }
  }, {
    key: "getFilmHeight",
    value: function getFilmHeight() {
      // film not completely covered in landscape format (aspect > 1)
      return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
     * Sets an offset in a larger frustum. This is useful for multi-window or
     * multi-monitor/multi-machine setups.
     *
     * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
     * the monitors are in grid like this
     *
     *   +---+---+---+
     *   | A | B | C |
     *   +---+---+---+
     *   | D | E | F |
     *   +---+---+---+
     *
     * then for each monitor you would call it like this
     *
     *   const w = 1920;
     *   const h = 1080;
     *   const fullWidth = w * 3;
     *   const fullHeight = h * 2;
     *
     *   --A--
     *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
     *   --B--
     *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
     *   --C--
     *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
     *   --D--
     *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
     *   --E--
     *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
     *   --F--
     *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
     *
     *   Note there is no reason monitors have to be the same size or in a grid.
     */

  }, {
    key: "setViewOffset",
    value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
      this.aspect = fullWidth / fullHeight;

      if (this.view === null) {
        this.view = {
          enabled: true,
          fullWidth: 1,
          fullHeight: 1,
          offsetX: 0,
          offsetY: 0,
          width: 1,
          height: 1
        };
      }

      this.view.enabled = true;
      this.view.fullWidth = fullWidth;
      this.view.fullHeight = fullHeight;
      this.view.offsetX = x;
      this.view.offsetY = y;
      this.view.width = width;
      this.view.height = height;
      this.updateProjectionMatrix();
    }
  }, {
    key: "clearViewOffset",
    value: function clearViewOffset() {
      if (this.view !== null) {
        this.view.enabled = false;
      }

      this.updateProjectionMatrix();
    }
  }, {
    key: "updateProjectionMatrix",
    value: function updateProjectionMatrix() {
      var near = this.near;
      var top = near * Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom;
      var height = 2 * top;
      var width = this.aspect * height;
      var left = -0.5 * width;
      var view = this.view;

      if (this.view !== null && this.view.enabled) {
        var fullWidth = view.fullWidth,
            fullHeight = view.fullHeight;
        left += view.offsetX * width / fullWidth;
        top -= view.offsetY * height / fullHeight;
        width *= view.width / fullWidth;
        height *= view.height / fullHeight;
      }

      var skew = this.filmOffset;
      if (skew !== 0) left += near * skew / this.getFilmWidth();
      this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
      this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
  }, {
    key: "toJSON",
    value: function toJSON(meta) {
      var data = _get(_getPrototypeOf(PerspectiveCamera.prototype), "toJSON", this).call(this, meta);

      data.object.fov = this.fov;
      data.object.zoom = this.zoom;
      data.object.near = this.near;
      data.object.far = this.far;
      data.object.focus = this.focus;
      data.object.aspect = this.aspect;
      if (this.view !== null) data.object.view = Object.assign({}, this.view);
      data.object.filmGauge = this.filmGauge;
      data.object.filmOffset = this.filmOffset;
      return data;
    }
  }]);

  return PerspectiveCamera;
}(Camera);

PerspectiveCamera.prototype.isPerspectiveCamera = true;
var fov = 90,
    aspect = 1;

var CubeCamera = /*#__PURE__*/function (_Object3D3) {
  _inherits(CubeCamera, _Object3D3);

  var _super18 = _createSuper(CubeCamera);

  function CubeCamera(near, far, renderTarget) {
    var _this15;

    _classCallCheck2(this, CubeCamera);

    _this15 = _super18.call(this);
    _this15.type = 'CubeCamera';

    if (renderTarget.isWebGLCubeRenderTarget !== true) {
      console.error('THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.');
      return _possibleConstructorReturn(_this15);
    }

    _this15.renderTarget = renderTarget;
    var cameraPX = new PerspectiveCamera(fov, aspect, near, far);
    cameraPX.layers = _this15.layers;
    cameraPX.up.set(0, -1, 0);
    cameraPX.lookAt(new Vector3(1, 0, 0));

    _this15.add(cameraPX);

    var cameraNX = new PerspectiveCamera(fov, aspect, near, far);
    cameraNX.layers = _this15.layers;
    cameraNX.up.set(0, -1, 0);
    cameraNX.lookAt(new Vector3(-1, 0, 0));

    _this15.add(cameraNX);

    var cameraPY = new PerspectiveCamera(fov, aspect, near, far);
    cameraPY.layers = _this15.layers;
    cameraPY.up.set(0, 0, 1);
    cameraPY.lookAt(new Vector3(0, 1, 0));

    _this15.add(cameraPY);

    var cameraNY = new PerspectiveCamera(fov, aspect, near, far);
    cameraNY.layers = _this15.layers;
    cameraNY.up.set(0, 0, -1);
    cameraNY.lookAt(new Vector3(0, -1, 0));

    _this15.add(cameraNY);

    var cameraPZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraPZ.layers = _this15.layers;
    cameraPZ.up.set(0, -1, 0);
    cameraPZ.lookAt(new Vector3(0, 0, 1));

    _this15.add(cameraPZ);

    var cameraNZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraNZ.layers = _this15.layers;
    cameraNZ.up.set(0, -1, 0);
    cameraNZ.lookAt(new Vector3(0, 0, -1));

    _this15.add(cameraNZ);

    return _this15;
  }

  _createClass2(CubeCamera, [{
    key: "update",
    value: function update(renderer, scene) {
      if (this.parent === null) this.updateMatrixWorld();
      var renderTarget = this.renderTarget;

      var _this$children = _slicedToArray(this.children, 6),
          cameraPX = _this$children[0],
          cameraNX = _this$children[1],
          cameraPY = _this$children[2],
          cameraNY = _this$children[3],
          cameraPZ = _this$children[4],
          cameraNZ = _this$children[5];

      var currentRenderTarget = renderer.getRenderTarget();
      var currentToneMapping = renderer.toneMapping;
      var currentXrEnabled = renderer.xr.enabled;
      renderer.toneMapping = NoToneMapping;
      renderer.xr.enabled = false;
      var generateMipmaps = renderTarget.texture.generateMipmaps;
      renderTarget.texture.generateMipmaps = false;
      renderer.setRenderTarget(renderTarget, 0);
      renderer.render(scene, cameraPX);
      renderer.setRenderTarget(renderTarget, 1);
      renderer.render(scene, cameraNX);
      renderer.setRenderTarget(renderTarget, 2);
      renderer.render(scene, cameraPY);
      renderer.setRenderTarget(renderTarget, 3);
      renderer.render(scene, cameraNY);
      renderer.setRenderTarget(renderTarget, 4);
      renderer.render(scene, cameraPZ);
      renderTarget.texture.generateMipmaps = generateMipmaps;
      renderer.setRenderTarget(renderTarget, 5);
      renderer.render(scene, cameraNZ);
      renderer.setRenderTarget(currentRenderTarget);
      renderer.toneMapping = currentToneMapping;
      renderer.xr.enabled = currentXrEnabled;
      renderTarget.texture.needsPMREMUpdate = true;
    }
  }]);

  return CubeCamera;
}(Object3D);

var CubeTexture = /*#__PURE__*/function (_Texture3) {
  _inherits(CubeTexture, _Texture3);

  var _super19 = _createSuper(CubeTexture);

  function CubeTexture(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) {
    var _this16;

    _classCallCheck2(this, CubeTexture);

    images = images !== undefined ? images : [];
    mapping = mapping !== undefined ? mapping : CubeReflectionMapping;
    _this16 = _super19.call(this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    _this16.flipY = false;
    return _this16;
  }

  _createClass2(CubeTexture, [{
    key: "images",
    get: function get() {
      return this.image;
    },
    set: function set(value) {
      this.image = value;
    }
  }]);

  return CubeTexture;
}(Texture);

CubeTexture.prototype.isCubeTexture = true;

var WebGLCubeRenderTarget = /*#__PURE__*/function (_WebGLRenderTarget) {
  _inherits(WebGLCubeRenderTarget, _WebGLRenderTarget);

  var _super20 = _createSuper(WebGLCubeRenderTarget);

  function WebGLCubeRenderTarget(size) {
    var _this17;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck2(this, WebGLCubeRenderTarget);

    _this17 = _super20.call(this, size, size, options);
    var image = {
      width: size,
      height: size,
      depth: 1
    };
    var images = [image, image, image, image, image, image];
    _this17.texture = new CubeTexture(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding); // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
    // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
    // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
    // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
    // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
    // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).

    _this17.texture.isRenderTargetTexture = true;
    _this17.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
    _this17.texture.minFilter = options.minFilter !== undefined ? options.minFilter : LinearFilter;
    return _this17;
  }

  _createClass2(WebGLCubeRenderTarget, [{
    key: "fromEquirectangularTexture",
    value: function fromEquirectangularTexture(renderer, texture) {
      this.texture.type = texture.type;
      this.texture.encoding = texture.encoding;
      this.texture.generateMipmaps = texture.generateMipmaps;
      this.texture.minFilter = texture.minFilter;
      this.texture.magFilter = texture.magFilter;
      var shader = {
        uniforms: {
          tEquirect: {
            value: null
          }
        },
        vertexShader:
        /* glsl */
        "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
        fragmentShader:
        /* glsl */
        "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t"
      };
      var geometry = new BoxGeometry(5, 5, 5);
      var material = new ShaderMaterial({
        name: 'CubemapFromEquirect',
        uniforms: cloneUniforms(shader.uniforms),
        vertexShader: shader.vertexShader,
        fragmentShader: shader.fragmentShader,
        side: BackSide,
        blending: NoBlending
      });
      material.uniforms.tEquirect.value = texture;
      var mesh = new Mesh(geometry, material);
      var currentMinFilter = texture.minFilter; // Avoid blurred poles

      if (texture.minFilter === LinearMipmapLinearFilter) texture.minFilter = LinearFilter;
      var camera = new CubeCamera(1, 10, this);
      camera.update(renderer, mesh);
      texture.minFilter = currentMinFilter;
      mesh.geometry.dispose();
      mesh.material.dispose();
      return this;
    }
  }, {
    key: "clear",
    value: function clear(renderer, color, depth, stencil) {
      var currentRenderTarget = renderer.getRenderTarget();

      for (var _i68 = 0; _i68 < 6; _i68++) {
        renderer.setRenderTarget(this, _i68);
        renderer.clear(color, depth, stencil);
      }

      renderer.setRenderTarget(currentRenderTarget);
    }
  }]);

  return WebGLCubeRenderTarget;
}(WebGLRenderTarget);

WebGLCubeRenderTarget.prototype.isWebGLCubeRenderTarget = true;

var _vector1 = /*@__PURE__*/new Vector3();

var _vector2 = /*@__PURE__*/new Vector3();

var _normalMatrix = /*@__PURE__*/new Matrix3();

var Plane = /*#__PURE__*/function () {
  function Plane() {
    var normal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3(1, 0, 0);
    var constant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck2(this, Plane);

    // normal is assumed to be normalized
    this.normal = normal;
    this.constant = constant;
  }

  _createClass2(Plane, [{
    key: "set",
    value: function set(normal, constant) {
      this.normal.copy(normal);
      this.constant = constant;
      return this;
    }
  }, {
    key: "setComponents",
    value: function setComponents(x, y, z, w) {
      this.normal.set(x, y, z);
      this.constant = w;
      return this;
    }
  }, {
    key: "setFromNormalAndCoplanarPoint",
    value: function setFromNormalAndCoplanarPoint(normal, point) {
      this.normal.copy(normal);
      this.constant = -point.dot(this.normal);
      return this;
    }
  }, {
    key: "setFromCoplanarPoints",
    value: function setFromCoplanarPoints(a, b, c) {
      var normal = _vector1.subVectors(c, b).cross(_vector2.subVectors(a, b)).normalize(); // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?


      this.setFromNormalAndCoplanarPoint(normal, a);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(plane) {
      this.normal.copy(plane.normal);
      this.constant = plane.constant;
      return this;
    }
  }, {
    key: "normalize",
    value: function normalize() {
      // Note: will lead to a divide by zero if the plane is invalid.
      var inverseNormalLength = 1.0 / this.normal.length();
      this.normal.multiplyScalar(inverseNormalLength);
      this.constant *= inverseNormalLength;
      return this;
    }
  }, {
    key: "negate",
    value: function negate() {
      this.constant *= -1;
      this.normal.negate();
      return this;
    }
  }, {
    key: "distanceToPoint",
    value: function distanceToPoint(point) {
      return this.normal.dot(point) + this.constant;
    }
  }, {
    key: "distanceToSphere",
    value: function distanceToSphere(sphere) {
      return this.distanceToPoint(sphere.center) - sphere.radius;
    }
  }, {
    key: "projectPoint",
    value: function projectPoint(point, target) {
      return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
    }
  }, {
    key: "intersectLine",
    value: function intersectLine(line, target) {
      var direction = line.delta(_vector1);
      var denominator = this.normal.dot(direction);

      if (denominator === 0) {
        // line is coplanar, return origin
        if (this.distanceToPoint(line.start) === 0) {
          return target.copy(line.start);
        } // Unsure if this is the correct method to handle this case.


        return null;
      }

      var t = -(line.start.dot(this.normal) + this.constant) / denominator;

      if (t < 0 || t > 1) {
        return null;
      }

      return target.copy(direction).multiplyScalar(t).add(line.start);
    }
  }, {
    key: "intersectsLine",
    value: function intersectsLine(line) {
      // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
      var startSign = this.distanceToPoint(line.start);
      var endSign = this.distanceToPoint(line.end);
      return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(box) {
      return box.intersectsPlane(this);
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(sphere) {
      return sphere.intersectsPlane(this);
    }
  }, {
    key: "coplanarPoint",
    value: function coplanarPoint(target) {
      return target.copy(this.normal).multiplyScalar(-this.constant);
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(matrix, optionalNormalMatrix) {
      var normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix);

      var referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix);
      var normal = this.normal.applyMatrix3(normalMatrix).normalize();
      this.constant = -referencePoint.dot(normal);
      return this;
    }
  }, {
    key: "translate",
    value: function translate(offset) {
      this.constant -= offset.dot(this.normal);
      return this;
    }
  }, {
    key: "equals",
    value: function equals(plane) {
      return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Plane;
}();

Plane.prototype.isPlane = true;

var _sphere$2 = /*@__PURE__*/new Sphere();

var _vector$7 = /*@__PURE__*/new Vector3();

var Frustum = /*#__PURE__*/function () {
  function Frustum() {
    var p0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Plane();
    var p1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Plane();
    var p2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Plane();
    var p3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Plane();
    var p4 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Plane();
    var p5 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new Plane();

    _classCallCheck2(this, Frustum);

    this.planes = [p0, p1, p2, p3, p4, p5];
  }

  _createClass2(Frustum, [{
    key: "set",
    value: function set(p0, p1, p2, p3, p4, p5) {
      var planes = this.planes;
      planes[0].copy(p0);
      planes[1].copy(p1);
      planes[2].copy(p2);
      planes[3].copy(p3);
      planes[4].copy(p4);
      planes[5].copy(p5);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(frustum) {
      var planes = this.planes;

      for (var _i69 = 0; _i69 < 6; _i69++) {
        planes[_i69].copy(frustum.planes[_i69]);
      }

      return this;
    }
  }, {
    key: "setFromProjectionMatrix",
    value: function setFromProjectionMatrix(m) {
      var planes = this.planes;
      var me = m.elements;
      var me0 = me[0],
          me1 = me[1],
          me2 = me[2],
          me3 = me[3];
      var me4 = me[4],
          me5 = me[5],
          me6 = me[6],
          me7 = me[7];
      var me8 = me[8],
          me9 = me[9],
          me10 = me[10],
          me11 = me[11];
      var me12 = me[12],
          me13 = me[13],
          me14 = me[14],
          me15 = me[15];
      planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
      planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
      planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
      planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
      planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
      planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
      return this;
    }
  }, {
    key: "intersectsObject",
    value: function intersectsObject(object) {
      var geometry = object.geometry;
      if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

      _sphere$2.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);

      return this.intersectsSphere(_sphere$2);
    }
  }, {
    key: "intersectsSprite",
    value: function intersectsSprite(sprite) {
      _sphere$2.center.set(0, 0, 0);

      _sphere$2.radius = 0.7071067811865476;

      _sphere$2.applyMatrix4(sprite.matrixWorld);

      return this.intersectsSphere(_sphere$2);
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(sphere) {
      var planes = this.planes;
      var center = sphere.center;
      var negRadius = -sphere.radius;

      for (var _i70 = 0; _i70 < 6; _i70++) {
        var distance = planes[_i70].distanceToPoint(center);

        if (distance < negRadius) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "intersectsBox",
    value: function intersectsBox(box) {
      var planes = this.planes;

      for (var _i71 = 0; _i71 < 6; _i71++) {
        var plane = planes[_i71]; // corner at max distance

        _vector$7.x = plane.normal.x > 0 ? box.max.x : box.min.x;
        _vector$7.y = plane.normal.y > 0 ? box.max.y : box.min.y;
        _vector$7.z = plane.normal.z > 0 ? box.max.z : box.min.z;

        if (plane.distanceToPoint(_vector$7) < 0) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(point) {
      var planes = this.planes;

      for (var _i72 = 0; _i72 < 6; _i72++) {
        if (planes[_i72].distanceToPoint(point) < 0) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Frustum;
}();

function WebGLAnimation() {
  var context = null;
  var isAnimating = false;
  var animationLoop = null;
  var requestId = null;

  function onAnimationFrame(time, frame) {
    animationLoop(time, frame);
    requestId = context.requestAnimationFrame(onAnimationFrame);
  }

  return {
    start: function start() {
      if (isAnimating === true) return;
      if (animationLoop === null) return;
      requestId = context.requestAnimationFrame(onAnimationFrame);
      isAnimating = true;
    },
    stop: function stop() {
      context.cancelAnimationFrame(requestId);
      isAnimating = false;
    },
    setAnimationLoop: function setAnimationLoop(callback) {
      animationLoop = callback;
    },
    setContext: function setContext(value) {
      context = value;
    }
  };
}

function WebGLAttributes(gl, capabilities) {
  var isWebGL2 = capabilities.isWebGL2;
  var buffers = new WeakMap();

  function createBuffer(attribute, bufferType) {
    var array = attribute.array;
    var usage = attribute.usage;
    var buffer = gl.createBuffer();
    gl.bindBuffer(bufferType, buffer);
    gl.bufferData(bufferType, array, usage);
    attribute.onUploadCallback();
    var type;

    if (array instanceof Float32Array) {
      type = 5126;
    } else if (array instanceof Uint16Array) {
      if (attribute.isFloat16BufferAttribute) {
        if (isWebGL2) {
          type = 5131;
        } else {
          throw new Error('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
        }
      } else {
        type = 5123;
      }
    } else if (array instanceof Int16Array) {
      type = 5122;
    } else if (array instanceof Uint32Array) {
      type = 5125;
    } else if (array instanceof Int32Array) {
      type = 5124;
    } else if (array instanceof Int8Array) {
      type = 5120;
    } else if (array instanceof Uint8Array) {
      type = 5121;
    } else if (array instanceof Uint8ClampedArray) {
      type = 5121;
    } else {
      throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
    }

    return {
      buffer: buffer,
      type: type,
      bytesPerElement: array.BYTES_PER_ELEMENT,
      version: attribute.version
    };
  }

  function updateBuffer(buffer, attribute, bufferType) {
    var array = attribute.array;
    var updateRange = attribute.updateRange;
    gl.bindBuffer(bufferType, buffer);

    if (updateRange.count === -1) {
      // Not using update ranges
      gl.bufferSubData(bufferType, 0, array);
    } else {
      if (isWebGL2) {
        gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
      } else {
        gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
      }

      updateRange.count = -1; // reset range
    }
  } //


  function get(attribute) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    return buffers.get(attribute);
  }

  function remove(attribute) {
    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    var data = buffers.get(attribute);

    if (data) {
      gl.deleteBuffer(data.buffer);
      buffers.delete(attribute);
    }
  }

  function update(attribute, bufferType) {
    if (attribute.isGLBufferAttribute) {
      var cached = buffers.get(attribute);

      if (!cached || cached.version < attribute.version) {
        buffers.set(attribute, {
          buffer: attribute.buffer,
          type: attribute.type,
          bytesPerElement: attribute.elementSize,
          version: attribute.version
        });
      }

      return;
    }

    if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
    var data = buffers.get(attribute);

    if (data === undefined) {
      buffers.set(attribute, createBuffer(attribute, bufferType));
    } else if (data.version < attribute.version) {
      updateBuffer(data.buffer, attribute, bufferType);
      data.version = attribute.version;
    }
  }

  return {
    get: get,
    remove: remove,
    update: update
  };
}

var PlaneGeometry = /*#__PURE__*/function (_BufferGeometry2) {
  _inherits(PlaneGeometry, _BufferGeometry2);

  var _super21 = _createSuper(PlaneGeometry);

  function PlaneGeometry() {
    var _this18;

    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var widthSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var heightSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck2(this, PlaneGeometry);

    _this18 = _super21.call(this);
    _this18.type = 'PlaneGeometry';
    _this18.parameters = {
      width: width,
      height: height,
      widthSegments: widthSegments,
      heightSegments: heightSegments
    };
    var width_half = width / 2;
    var height_half = height / 2;
    var gridX = Math.floor(widthSegments);
    var gridY = Math.floor(heightSegments);
    var gridX1 = gridX + 1;
    var gridY1 = gridY + 1;
    var segment_width = width / gridX;
    var segment_height = height / gridY; //

    var indices = [];
    var vertices = [];
    var normals = [];
    var uvs = [];

    for (var iy = 0; iy < gridY1; iy++) {
      var y = iy * segment_height - height_half;

      for (var ix = 0; ix < gridX1; ix++) {
        var x = ix * segment_width - width_half;
        vertices.push(x, -y, 0);
        normals.push(0, 0, 1);
        uvs.push(ix / gridX);
        uvs.push(1 - iy / gridY);
      }
    }

    for (var _iy2 = 0; _iy2 < gridY; _iy2++) {
      for (var _ix2 = 0; _ix2 < gridX; _ix2++) {
        var a = _ix2 + gridX1 * _iy2;
        var b = _ix2 + gridX1 * (_iy2 + 1);
        var c = _ix2 + 1 + gridX1 * (_iy2 + 1);
        var d = _ix2 + 1 + gridX1 * _iy2;
        indices.push(a, b, d);
        indices.push(b, c, d);
      }
    }

    _this18.setIndex(indices);

    _this18.setAttribute('position', new Float32BufferAttribute(vertices, 3));

    _this18.setAttribute('normal', new Float32BufferAttribute(normals, 3));

    _this18.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

    return _this18;
  }

  _createClass2(PlaneGeometry, null, [{
    key: "fromJSON",
    value: function fromJSON(data) {
      return new PlaneGeometry(data.width, data.height, data.widthSegments, data.heightSegments);
    }
  }]);

  return PlaneGeometry;
}(BufferGeometry);

var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var alphatest_fragment = "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif";
var alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var begin_vertex = "vec3 transformed = vec3( position );";
var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var bsdfs = "vec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif";
var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}";
var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var encodings_pars_fragment = "vec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}";
var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointLightInfo( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotLightInfo( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalLightInfo( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( - dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif";
var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#else\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n#endif";
var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)";
var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)";
var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\t#ifdef SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULARINTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;\n\t\t#endif\n\t\t#ifdef USE_SPECULARCOLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vUv ).rgb;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;\n\t#endif\n#endif";
var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\tvec3 FssEss = specularColor * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry.normal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
var map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var morphcolor_vertex = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif";
var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif";
var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif";
var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * faceDirection;\n\t\t\tbitangent = bitangent * faceDirection;\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;";
var normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );\n\t\treturn normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );\n\t}\n#endif";
var clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif";
var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );\n\t#endif\n#endif";
var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif";
var output_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif";
var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tuniform int boneTextureSize;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tfloat j = i * 4.0;\n\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\ty = dy * ( y + 0.5 );\n\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\treturn bone;\n\t}\n#endif";
var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var transmission_fragment = "#ifdef USE_TRANSMISSION\n\tfloat transmissionAlpha = 1.0;\n\tfloat transmissionFactor = transmission;\n\tfloat thicknessFactor = thickness;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\ttransmissionFactor *= texture2D( transmissionMap, vUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tthicknessFactor *= texture2D( thicknessMap, vUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmission = getIBLVolumeRefraction(\n\t\tn, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,\n\t\tattenuationColor, attenuationDistance );\n\ttotalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );\n\ttransmissionAlpha = mix( transmissionAlpha, transmission.a, transmissionFactor );\n#endif";
var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\t#ifdef texture2DLodEXT\n\t\t\treturn texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#else\n\t\t\treturn texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );\n\t\t#endif\n\t}\n\tvec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( attenuationDistance == 0.0 ) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n\t}\n#endif";
var uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif";
var uv_pars_vertex = "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif";
var uv_vertex = "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";
var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif";
var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
var vertex$g = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
var fragment$g = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tgl_FragColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tgl_FragColor = vec4( mix( pow( gl_FragColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), gl_FragColor.rgb * 0.0773993808, vec3( lessThanEqual( gl_FragColor.rgb, vec3( 0.04045 ) ) ) ), gl_FragColor.w );\n\t#endif\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
var fragment$f = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var vertex$e = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
var fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
var vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
var fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
var vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
var fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var vertex$a = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
var fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$9 = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var fragment$9 = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
var fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
var fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
var vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
var fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULARINTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n\t#ifdef USE_SPECULARCOLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEENCOLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEENROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
var fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var vertex$2 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var ShaderChunk = {
  alphamap_fragment: alphamap_fragment,
  alphamap_pars_fragment: alphamap_pars_fragment,
  alphatest_fragment: alphatest_fragment,
  alphatest_pars_fragment: alphatest_pars_fragment,
  aomap_fragment: aomap_fragment,
  aomap_pars_fragment: aomap_pars_fragment,
  begin_vertex: begin_vertex,
  beginnormal_vertex: beginnormal_vertex,
  bsdfs: bsdfs,
  bumpmap_pars_fragment: bumpmap_pars_fragment,
  clipping_planes_fragment: clipping_planes_fragment,
  clipping_planes_pars_fragment: clipping_planes_pars_fragment,
  clipping_planes_pars_vertex: clipping_planes_pars_vertex,
  clipping_planes_vertex: clipping_planes_vertex,
  color_fragment: color_fragment,
  color_pars_fragment: color_pars_fragment,
  color_pars_vertex: color_pars_vertex,
  color_vertex: color_vertex,
  common: common,
  cube_uv_reflection_fragment: cube_uv_reflection_fragment,
  defaultnormal_vertex: defaultnormal_vertex,
  displacementmap_pars_vertex: displacementmap_pars_vertex,
  displacementmap_vertex: displacementmap_vertex,
  emissivemap_fragment: emissivemap_fragment,
  emissivemap_pars_fragment: emissivemap_pars_fragment,
  encodings_fragment: encodings_fragment,
  encodings_pars_fragment: encodings_pars_fragment,
  envmap_fragment: envmap_fragment,
  envmap_common_pars_fragment: envmap_common_pars_fragment,
  envmap_pars_fragment: envmap_pars_fragment,
  envmap_pars_vertex: envmap_pars_vertex,
  envmap_physical_pars_fragment: envmap_physical_pars_fragment,
  envmap_vertex: envmap_vertex,
  fog_vertex: fog_vertex,
  fog_pars_vertex: fog_pars_vertex,
  fog_fragment: fog_fragment,
  fog_pars_fragment: fog_pars_fragment,
  gradientmap_pars_fragment: gradientmap_pars_fragment,
  lightmap_fragment: lightmap_fragment,
  lightmap_pars_fragment: lightmap_pars_fragment,
  lights_lambert_vertex: lights_lambert_vertex,
  lights_pars_begin: lights_pars_begin,
  lights_toon_fragment: lights_toon_fragment,
  lights_toon_pars_fragment: lights_toon_pars_fragment,
  lights_phong_fragment: lights_phong_fragment,
  lights_phong_pars_fragment: lights_phong_pars_fragment,
  lights_physical_fragment: lights_physical_fragment,
  lights_physical_pars_fragment: lights_physical_pars_fragment,
  lights_fragment_begin: lights_fragment_begin,
  lights_fragment_maps: lights_fragment_maps,
  lights_fragment_end: lights_fragment_end,
  logdepthbuf_fragment: logdepthbuf_fragment,
  logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
  logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
  logdepthbuf_vertex: logdepthbuf_vertex,
  map_fragment: map_fragment,
  map_pars_fragment: map_pars_fragment,
  map_particle_fragment: map_particle_fragment,
  map_particle_pars_fragment: map_particle_pars_fragment,
  metalnessmap_fragment: metalnessmap_fragment,
  metalnessmap_pars_fragment: metalnessmap_pars_fragment,
  morphcolor_vertex: morphcolor_vertex,
  morphnormal_vertex: morphnormal_vertex,
  morphtarget_pars_vertex: morphtarget_pars_vertex,
  morphtarget_vertex: morphtarget_vertex,
  normal_fragment_begin: normal_fragment_begin,
  normal_fragment_maps: normal_fragment_maps,
  normal_pars_fragment: normal_pars_fragment,
  normal_pars_vertex: normal_pars_vertex,
  normal_vertex: normal_vertex,
  normalmap_pars_fragment: normalmap_pars_fragment,
  clearcoat_normal_fragment_begin: clearcoat_normal_fragment_begin,
  clearcoat_normal_fragment_maps: clearcoat_normal_fragment_maps,
  clearcoat_pars_fragment: clearcoat_pars_fragment,
  output_fragment: output_fragment,
  packing: packing,
  premultiplied_alpha_fragment: premultiplied_alpha_fragment,
  project_vertex: project_vertex,
  dithering_fragment: dithering_fragment,
  dithering_pars_fragment: dithering_pars_fragment,
  roughnessmap_fragment: roughnessmap_fragment,
  roughnessmap_pars_fragment: roughnessmap_pars_fragment,
  shadowmap_pars_fragment: shadowmap_pars_fragment,
  shadowmap_pars_vertex: shadowmap_pars_vertex,
  shadowmap_vertex: shadowmap_vertex,
  shadowmask_pars_fragment: shadowmask_pars_fragment,
  skinbase_vertex: skinbase_vertex,
  skinning_pars_vertex: skinning_pars_vertex,
  skinning_vertex: skinning_vertex,
  skinnormal_vertex: skinnormal_vertex,
  specularmap_fragment: specularmap_fragment,
  specularmap_pars_fragment: specularmap_pars_fragment,
  tonemapping_fragment: tonemapping_fragment,
  tonemapping_pars_fragment: tonemapping_pars_fragment,
  transmission_fragment: transmission_fragment,
  transmission_pars_fragment: transmission_pars_fragment,
  uv_pars_fragment: uv_pars_fragment,
  uv_pars_vertex: uv_pars_vertex,
  uv_vertex: uv_vertex,
  uv2_pars_fragment: uv2_pars_fragment,
  uv2_pars_vertex: uv2_pars_vertex,
  uv2_vertex: uv2_vertex,
  worldpos_vertex: worldpos_vertex,
  background_vert: vertex$g,
  background_frag: fragment$g,
  cube_vert: vertex$f,
  cube_frag: fragment$f,
  depth_vert: vertex$e,
  depth_frag: fragment$e,
  distanceRGBA_vert: vertex$d,
  distanceRGBA_frag: fragment$d,
  equirect_vert: vertex$c,
  equirect_frag: fragment$c,
  linedashed_vert: vertex$b,
  linedashed_frag: fragment$b,
  meshbasic_vert: vertex$a,
  meshbasic_frag: fragment$a,
  meshlambert_vert: vertex$9,
  meshlambert_frag: fragment$9,
  meshmatcap_vert: vertex$8,
  meshmatcap_frag: fragment$8,
  meshnormal_vert: vertex$7,
  meshnormal_frag: fragment$7,
  meshphong_vert: vertex$6,
  meshphong_frag: fragment$6,
  meshphysical_vert: vertex$5,
  meshphysical_frag: fragment$5,
  meshtoon_vert: vertex$4,
  meshtoon_frag: fragment$4,
  points_vert: vertex$3,
  points_frag: fragment$3,
  shadow_vert: vertex$2,
  shadow_frag: fragment$2,
  sprite_vert: vertex$1,
  sprite_frag: fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */

var UniformsLib = {
  common: {
    diffuse: {
      value: new Color(0xffffff)
    },
    opacity: {
      value: 1.0
    },
    map: {
      value: null
    },
    uvTransform: {
      value: new Matrix3()
    },
    uv2Transform: {
      value: new Matrix3()
    },
    alphaMap: {
      value: null
    },
    alphaTest: {
      value: 0
    }
  },
  specularmap: {
    specularMap: {
      value: null
    }
  },
  envmap: {
    envMap: {
      value: null
    },
    flipEnvMap: {
      value: -1
    },
    reflectivity: {
      value: 1.0
    },
    // basic, lambert, phong
    ior: {
      value: 1.5
    },
    // physical
    refractionRatio: {
      value: 0.98
    } // basic, lambert, phong

  },
  aomap: {
    aoMap: {
      value: null
    },
    aoMapIntensity: {
      value: 1
    }
  },
  lightmap: {
    lightMap: {
      value: null
    },
    lightMapIntensity: {
      value: 1
    }
  },
  emissivemap: {
    emissiveMap: {
      value: null
    }
  },
  bumpmap: {
    bumpMap: {
      value: null
    },
    bumpScale: {
      value: 1
    }
  },
  normalmap: {
    normalMap: {
      value: null
    },
    normalScale: {
      value: new Vector2(1, 1)
    }
  },
  displacementmap: {
    displacementMap: {
      value: null
    },
    displacementScale: {
      value: 1
    },
    displacementBias: {
      value: 0
    }
  },
  roughnessmap: {
    roughnessMap: {
      value: null
    }
  },
  metalnessmap: {
    metalnessMap: {
      value: null
    }
  },
  gradientmap: {
    gradientMap: {
      value: null
    }
  },
  fog: {
    fogDensity: {
      value: 0.00025
    },
    fogNear: {
      value: 1
    },
    fogFar: {
      value: 2000
    },
    fogColor: {
      value: new Color(0xffffff)
    }
  },
  lights: {
    ambientLightColor: {
      value: []
    },
    lightProbe: {
      value: []
    },
    directionalLights: {
      value: [],
      properties: {
        direction: {},
        color: {}
      }
    },
    directionalLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      }
    },
    directionalShadowMap: {
      value: []
    },
    directionalShadowMatrix: {
      value: []
    },
    spotLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        direction: {},
        distance: {},
        coneCos: {},
        penumbraCos: {},
        decay: {}
      }
    },
    spotLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      }
    },
    spotShadowMap: {
      value: []
    },
    spotShadowMatrix: {
      value: []
    },
    pointLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        decay: {},
        distance: {}
      }
    },
    pointLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {},
        shadowCameraNear: {},
        shadowCameraFar: {}
      }
    },
    pointShadowMap: {
      value: []
    },
    pointShadowMatrix: {
      value: []
    },
    hemisphereLights: {
      value: [],
      properties: {
        direction: {},
        skyColor: {},
        groundColor: {}
      }
    },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        width: {},
        height: {}
      }
    },
    ltc_1: {
      value: null
    },
    ltc_2: {
      value: null
    }
  },
  points: {
    diffuse: {
      value: new Color(0xffffff)
    },
    opacity: {
      value: 1.0
    },
    size: {
      value: 1.0
    },
    scale: {
      value: 1.0
    },
    map: {
      value: null
    },
    alphaMap: {
      value: null
    },
    alphaTest: {
      value: 0
    },
    uvTransform: {
      value: new Matrix3()
    }
  },
  sprite: {
    diffuse: {
      value: new Color(0xffffff)
    },
    opacity: {
      value: 1.0
    },
    center: {
      value: new Vector2(0.5, 0.5)
    },
    rotation: {
      value: 0.0
    },
    map: {
      value: null
    },
    alphaMap: {
      value: null
    },
    alphaTest: {
      value: 0
    },
    uvTransform: {
      value: new Matrix3()
    }
  }
};
var ShaderLib = {
  basic: {
    uniforms: mergeUniforms([UniformsLib.common, UniformsLib.specularmap, UniformsLib.envmap, UniformsLib.aomap, UniformsLib.lightmap, UniformsLib.fog]),
    vertexShader: ShaderChunk.meshbasic_vert,
    fragmentShader: ShaderChunk.meshbasic_frag
  },
  lambert: {
    uniforms: mergeUniforms([UniformsLib.common, UniformsLib.specularmap, UniformsLib.envmap, UniformsLib.aomap, UniformsLib.lightmap, UniformsLib.emissivemap, UniformsLib.fog, UniformsLib.lights, {
      emissive: {
        value: new Color(0x000000)
      }
    }]),
    vertexShader: ShaderChunk.meshlambert_vert,
    fragmentShader: ShaderChunk.meshlambert_frag
  },
  phong: {
    uniforms: mergeUniforms([UniformsLib.common, UniformsLib.specularmap, UniformsLib.envmap, UniformsLib.aomap, UniformsLib.lightmap, UniformsLib.emissivemap, UniformsLib.bumpmap, UniformsLib.normalmap, UniformsLib.displacementmap, UniformsLib.fog, UniformsLib.lights, {
      emissive: {
        value: new Color(0x000000)
      },
      specular: {
        value: new Color(0x111111)
      },
      shininess: {
        value: 30
      }
    }]),
    vertexShader: ShaderChunk.meshphong_vert,
    fragmentShader: ShaderChunk.meshphong_frag
  },
  standard: {
    uniforms: mergeUniforms([UniformsLib.common, UniformsLib.envmap, UniformsLib.aomap, UniformsLib.lightmap, UniformsLib.emissivemap, UniformsLib.bumpmap, UniformsLib.normalmap, UniformsLib.displacementmap, UniformsLib.roughnessmap, UniformsLib.metalnessmap, UniformsLib.fog, UniformsLib.lights, {
      emissive: {
        value: new Color(0x000000)
      },
      roughness: {
        value: 1.0
      },
      metalness: {
        value: 0.0
      },
      envMapIntensity: {
        value: 1
      } // temporary

    }]),
    vertexShader: ShaderChunk.meshphysical_vert,
    fragmentShader: ShaderChunk.meshphysical_frag
  },
  toon: {
    uniforms: mergeUniforms([UniformsLib.common, UniformsLib.aomap, UniformsLib.lightmap, UniformsLib.emissivemap, UniformsLib.bumpmap, UniformsLib.normalmap, UniformsLib.displacementmap, UniformsLib.gradientmap, UniformsLib.fog, UniformsLib.lights, {
      emissive: {
        value: new Color(0x000000)
      }
    }]),
    vertexShader: ShaderChunk.meshtoon_vert,
    fragmentShader: ShaderChunk.meshtoon_frag
  },
  matcap: {
    uniforms: mergeUniforms([UniformsLib.common, UniformsLib.bumpmap, UniformsLib.normalmap, UniformsLib.displacementmap, UniformsLib.fog, {
      matcap: {
        value: null
      }
    }]),
    vertexShader: ShaderChunk.meshmatcap_vert,
    fragmentShader: ShaderChunk.meshmatcap_frag
  },
  points: {
    uniforms: mergeUniforms([UniformsLib.points, UniformsLib.fog]),
    vertexShader: ShaderChunk.points_vert,
    fragmentShader: ShaderChunk.points_frag
  },
  dashed: {
    uniforms: mergeUniforms([UniformsLib.common, UniformsLib.fog, {
      scale: {
        value: 1
      },
      dashSize: {
        value: 1
      },
      totalSize: {
        value: 2
      }
    }]),
    vertexShader: ShaderChunk.linedashed_vert,
    fragmentShader: ShaderChunk.linedashed_frag
  },
  depth: {
    uniforms: mergeUniforms([UniformsLib.common, UniformsLib.displacementmap]),
    vertexShader: ShaderChunk.depth_vert,
    fragmentShader: ShaderChunk.depth_frag
  },
  normal: {
    uniforms: mergeUniforms([UniformsLib.common, UniformsLib.bumpmap, UniformsLib.normalmap, UniformsLib.displacementmap, {
      opacity: {
        value: 1.0
      }
    }]),
    vertexShader: ShaderChunk.meshnormal_vert,
    fragmentShader: ShaderChunk.meshnormal_frag
  },
  sprite: {
    uniforms: mergeUniforms([UniformsLib.sprite, UniformsLib.fog]),
    vertexShader: ShaderChunk.sprite_vert,
    fragmentShader: ShaderChunk.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: {
        value: new Matrix3()
      },
      t2D: {
        value: null
      }
    },
    vertexShader: ShaderChunk.background_vert,
    fragmentShader: ShaderChunk.background_frag
  },

  /* -------------------------------------------------------------------------
  //	Cube map shader
   ------------------------------------------------------------------------- */
  cube: {
    uniforms: mergeUniforms([UniformsLib.envmap, {
      opacity: {
        value: 1.0
      }
    }]),
    vertexShader: ShaderChunk.cube_vert,
    fragmentShader: ShaderChunk.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: {
        value: null
      }
    },
    vertexShader: ShaderChunk.equirect_vert,
    fragmentShader: ShaderChunk.equirect_frag
  },
  distanceRGBA: {
    uniforms: mergeUniforms([UniformsLib.common, UniformsLib.displacementmap, {
      referencePosition: {
        value: new Vector3()
      },
      nearDistance: {
        value: 1
      },
      farDistance: {
        value: 1000
      }
    }]),
    vertexShader: ShaderChunk.distanceRGBA_vert,
    fragmentShader: ShaderChunk.distanceRGBA_frag
  },
  shadow: {
    uniforms: mergeUniforms([UniformsLib.lights, UniformsLib.fog, {
      color: {
        value: new Color(0x00000)
      },
      opacity: {
        value: 1.0
      }
    }]),
    vertexShader: ShaderChunk.shadow_vert,
    fragmentShader: ShaderChunk.shadow_frag
  }
};
ShaderLib.physical = {
  uniforms: mergeUniforms([ShaderLib.standard.uniforms, {
    clearcoat: {
      value: 0
    },
    clearcoatMap: {
      value: null
    },
    clearcoatRoughness: {
      value: 0
    },
    clearcoatRoughnessMap: {
      value: null
    },
    clearcoatNormalScale: {
      value: new Vector2(1, 1)
    },
    clearcoatNormalMap: {
      value: null
    },
    sheen: {
      value: 0
    },
    sheenColor: {
      value: new Color(0x000000)
    },
    sheenColorMap: {
      value: null
    },
    sheenRoughness: {
      value: 1
    },
    sheenRoughnessMap: {
      value: null
    },
    transmission: {
      value: 0
    },
    transmissionMap: {
      value: null
    },
    transmissionSamplerSize: {
      value: new Vector2()
    },
    transmissionSamplerMap: {
      value: null
    },
    thickness: {
      value: 0
    },
    thicknessMap: {
      value: null
    },
    attenuationDistance: {
      value: 0
    },
    attenuationColor: {
      value: new Color(0x000000)
    },
    specularIntensity: {
      value: 1
    },
    specularIntensityMap: {
      value: null
    },
    specularColor: {
      value: new Color(1, 1, 1)
    },
    specularColorMap: {
      value: null
    }
  }]),
  vertexShader: ShaderChunk.meshphysical_vert,
  fragmentShader: ShaderChunk.meshphysical_frag
};

function WebGLBackground(renderer, cubemaps, state, objects, alpha, premultipliedAlpha) {
  var clearColor = new Color(0x000000);
  var clearAlpha = alpha === true ? 0 : 1;
  var planeMesh;
  var boxMesh;
  var currentBackground = null;
  var currentBackgroundVersion = 0;
  var currentTonemapping = null;

  function render(renderList, scene) {
    var forceClear = false;
    var background = scene.isScene === true ? scene.background : null;

    if (background && background.isTexture) {
      background = cubemaps.get(background);
    } // Ignore background in AR
    // TODO: Reconsider this.


    var xr = renderer.xr;
    var session = xr.getSession && xr.getSession();

    if (session && session.environmentBlendMode === 'additive') {
      background = null;
    }

    if (background === null) {
      setClear(clearColor, clearAlpha);
    } else if (background && background.isColor) {
      setClear(background, 1);
      forceClear = true;
    }

    if (renderer.autoClear || forceClear) {
      renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
    }

    if (background && (background.isCubeTexture || background.mapping === CubeUVReflectionMapping)) {
      if (boxMesh === undefined) {
        boxMesh = new Mesh(new BoxGeometry(1, 1, 1), new ShaderMaterial({
          name: 'BackgroundCubeMaterial',
          uniforms: cloneUniforms(ShaderLib.cube.uniforms),
          vertexShader: ShaderLib.cube.vertexShader,
          fragmentShader: ShaderLib.cube.fragmentShader,
          side: BackSide,
          depthTest: false,
          depthWrite: false,
          fog: false
        }));
        boxMesh.geometry.deleteAttribute('normal');
        boxMesh.geometry.deleteAttribute('uv');

        boxMesh.onBeforeRender = function (renderer, scene, camera) {
          this.matrixWorld.copyPosition(camera.matrixWorld);
        }; // enable code injection for non-built-in material


        Object.defineProperty(boxMesh.material, 'envMap', {
          get: function get() {
            return this.uniforms.envMap.value;
          }
        });
        objects.update(boxMesh);
      }

      boxMesh.material.uniforms.envMap.value = background;
      boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;

      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        boxMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }

      boxMesh.layers.enableAll(); // push to the pre-sorted opaque render list

      renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
    } else if (background && background.isTexture) {
      if (planeMesh === undefined) {
        planeMesh = new Mesh(new PlaneGeometry(2, 2), new ShaderMaterial({
          name: 'BackgroundMaterial',
          uniforms: cloneUniforms(ShaderLib.background.uniforms),
          vertexShader: ShaderLib.background.vertexShader,
          fragmentShader: ShaderLib.background.fragmentShader,
          side: FrontSide,
          depthTest: false,
          depthWrite: false,
          fog: false
        }));
        planeMesh.geometry.deleteAttribute('normal'); // enable code injection for non-built-in material

        Object.defineProperty(planeMesh.material, 'map', {
          get: function get() {
            return this.uniforms.t2D.value;
          }
        });
        objects.update(planeMesh);
      }

      planeMesh.material.uniforms.t2D.value = background;

      if (background.matrixAutoUpdate === true) {
        background.updateMatrix();
      }

      planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);

      if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
        planeMesh.material.needsUpdate = true;
        currentBackground = background;
        currentBackgroundVersion = background.version;
        currentTonemapping = renderer.toneMapping;
      }

      planeMesh.layers.enableAll(); // push to the pre-sorted opaque render list

      renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
    }
  }

  function setClear(color, alpha) {
    state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
  }

  return {
    getClearColor: function getClearColor() {
      return clearColor;
    },
    setClearColor: function setClearColor(color) {
      var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      clearColor.set(color);
      clearAlpha = alpha;
      setClear(clearColor, clearAlpha);
    },
    getClearAlpha: function getClearAlpha() {
      return clearAlpha;
    },
    setClearAlpha: function setClearAlpha(alpha) {
      clearAlpha = alpha;
      setClear(clearColor, clearAlpha);
    },
    render: render
  };
}

function WebGLBindingStates(gl, extensions, attributes, capabilities) {
  var maxVertexAttributes = gl.getParameter(34921);
  var extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
  var vaoAvailable = capabilities.isWebGL2 || extension !== null;
  var bindingStates = {};
  var defaultState = createBindingState(null);
  var currentState = defaultState;
  var forceUpdate = false;

  function setup(object, material, program, geometry, index) {
    var updateBuffers = false;

    if (vaoAvailable) {
      var state = getBindingState(geometry, program, material);

      if (currentState !== state) {
        currentState = state;
        bindVertexArrayObject(currentState.object);
      }

      updateBuffers = needsUpdate(object, geometry, program, index);
      if (updateBuffers) saveCache(object, geometry, program, index);
    } else {
      var wireframe = material.wireframe === true;

      if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
        currentState.geometry = geometry.id;
        currentState.program = program.id;
        currentState.wireframe = wireframe;
        updateBuffers = true;
      }
    }

    if (index !== null) {
      attributes.update(index, 34963);
    }

    if (updateBuffers || forceUpdate) {
      forceUpdate = false;
      setupVertexAttributes(object, material, program, geometry);

      if (index !== null) {
        gl.bindBuffer(34963, attributes.get(index).buffer);
      }
    }
  }

  function createVertexArrayObject() {
    if (capabilities.isWebGL2) return gl.createVertexArray();
    return extension.createVertexArrayOES();
  }

  function bindVertexArrayObject(vao) {
    if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
    return extension.bindVertexArrayOES(vao);
  }

  function deleteVertexArrayObject(vao) {
    if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
    return extension.deleteVertexArrayOES(vao);
  }

  function getBindingState(geometry, program, material) {
    var wireframe = material.wireframe === true;
    var programMap = bindingStates[geometry.id];

    if (programMap === undefined) {
      programMap = {};
      bindingStates[geometry.id] = programMap;
    }

    var stateMap = programMap[program.id];

    if (stateMap === undefined) {
      stateMap = {};
      programMap[program.id] = stateMap;
    }

    var state = stateMap[wireframe];

    if (state === undefined) {
      state = createBindingState(createVertexArrayObject());
      stateMap[wireframe] = state;
    }

    return state;
  }

  function createBindingState(vao) {
    var newAttributes = [];
    var enabledAttributes = [];
    var attributeDivisors = [];

    for (var _i73 = 0; _i73 < maxVertexAttributes; _i73++) {
      newAttributes[_i73] = 0;
      enabledAttributes[_i73] = 0;
      attributeDivisors[_i73] = 0;
    }

    return {
      // for backward compatibility on non-VAO support browser
      geometry: null,
      program: null,
      wireframe: false,
      newAttributes: newAttributes,
      enabledAttributes: enabledAttributes,
      attributeDivisors: attributeDivisors,
      object: vao,
      attributes: {},
      index: null
    };
  }

  function needsUpdate(object, geometry, program, index) {
    var cachedAttributes = currentState.attributes;
    var geometryAttributes = geometry.attributes;
    var attributesNum = 0;
    var programAttributes = program.getAttributes();

    for (var name in programAttributes) {
      var programAttribute = programAttributes[name];

      if (programAttribute.location >= 0) {
        var cachedAttribute = cachedAttributes[name];
        var geometryAttribute = geometryAttributes[name];

        if (geometryAttribute === undefined) {
          if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
          if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
        }

        if (cachedAttribute === undefined) return true;
        if (cachedAttribute.attribute !== geometryAttribute) return true;
        if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
        attributesNum++;
      }
    }

    if (currentState.attributesNum !== attributesNum) return true;
    if (currentState.index !== index) return true;
    return false;
  }

  function saveCache(object, geometry, program, index) {
    var cache = {};
    var attributes = geometry.attributes;
    var attributesNum = 0;
    var programAttributes = program.getAttributes();

    for (var name in programAttributes) {
      var programAttribute = programAttributes[name];

      if (programAttribute.location >= 0) {
        var attribute = attributes[name];

        if (attribute === undefined) {
          if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
          if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
        }

        var data = {};
        data.attribute = attribute;

        if (attribute && attribute.data) {
          data.data = attribute.data;
        }

        cache[name] = data;
        attributesNum++;
      }
    }

    currentState.attributes = cache;
    currentState.attributesNum = attributesNum;
    currentState.index = index;
  }

  function initAttributes() {
    var newAttributes = currentState.newAttributes;

    for (var _i74 = 0, il = newAttributes.length; _i74 < il; _i74++) {
      newAttributes[_i74] = 0;
    }
  }

  function enableAttribute(attribute) {
    enableAttributeAndDivisor(attribute, 0);
  }

  function enableAttributeAndDivisor(attribute, meshPerAttribute) {
    var newAttributes = currentState.newAttributes;
    var enabledAttributes = currentState.enabledAttributes;
    var attributeDivisors = currentState.attributeDivisors;
    newAttributes[attribute] = 1;

    if (enabledAttributes[attribute] === 0) {
      gl.enableVertexAttribArray(attribute);
      enabledAttributes[attribute] = 1;
    }

    if (attributeDivisors[attribute] !== meshPerAttribute) {
      var _extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');

      _extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);

      attributeDivisors[attribute] = meshPerAttribute;
    }
  }

  function disableUnusedAttributes() {
    var newAttributes = currentState.newAttributes;
    var enabledAttributes = currentState.enabledAttributes;

    for (var _i75 = 0, il = enabledAttributes.length; _i75 < il; _i75++) {
      if (enabledAttributes[_i75] !== newAttributes[_i75]) {
        gl.disableVertexAttribArray(_i75);
        enabledAttributes[_i75] = 0;
      }
    }
  }

  function vertexAttribPointer(index, size, type, normalized, stride, offset) {
    if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) {
      gl.vertexAttribIPointer(index, size, type, stride, offset);
    } else {
      gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
  }

  function setupVertexAttributes(object, material, program, geometry) {
    if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
      if (extensions.get('ANGLE_instanced_arrays') === null) return;
    }

    initAttributes();
    var geometryAttributes = geometry.attributes;
    var programAttributes = program.getAttributes();
    var materialDefaultAttributeValues = material.defaultAttributeValues;

    for (var name in programAttributes) {
      var programAttribute = programAttributes[name];

      if (programAttribute.location >= 0) {
        var geometryAttribute = geometryAttributes[name];

        if (geometryAttribute === undefined) {
          if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
          if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
        }

        if (geometryAttribute !== undefined) {
          var normalized = geometryAttribute.normalized;
          var size = geometryAttribute.itemSize;
          var attribute = attributes.get(geometryAttribute); // TODO Attribute may not be available on context restore

          if (attribute === undefined) continue;
          var buffer = attribute.buffer;
          var type = attribute.type;
          var bytesPerElement = attribute.bytesPerElement;

          if (geometryAttribute.isInterleavedBufferAttribute) {
            var data = geometryAttribute.data;
            var stride = data.stride;
            var offset = geometryAttribute.offset;

            if (data.isInstancedInterleavedBuffer) {
              for (var _i76 = 0; _i76 < programAttribute.locationSize; _i76++) {
                enableAttributeAndDivisor(programAttribute.location + _i76, data.meshPerAttribute);
              }

              if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) {
                geometry._maxInstanceCount = data.meshPerAttribute * data.count;
              }
            } else {
              for (var _i77 = 0; _i77 < programAttribute.locationSize; _i77++) {
                enableAttribute(programAttribute.location + _i77);
              }
            }

            gl.bindBuffer(34962, buffer);

            for (var _i78 = 0; _i78 < programAttribute.locationSize; _i78++) {
              vertexAttribPointer(programAttribute.location + _i78, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * _i78) * bytesPerElement);
            }
          } else {
            if (geometryAttribute.isInstancedBufferAttribute) {
              for (var _i79 = 0; _i79 < programAttribute.locationSize; _i79++) {
                enableAttributeAndDivisor(programAttribute.location + _i79, geometryAttribute.meshPerAttribute);
              }

              if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) {
                geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
              }
            } else {
              for (var _i80 = 0; _i80 < programAttribute.locationSize; _i80++) {
                enableAttribute(programAttribute.location + _i80);
              }
            }

            gl.bindBuffer(34962, buffer);

            for (var _i81 = 0; _i81 < programAttribute.locationSize; _i81++) {
              vertexAttribPointer(programAttribute.location + _i81, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * _i81 * bytesPerElement);
            }
          }
        } else if (materialDefaultAttributeValues !== undefined) {
          var _value2 = materialDefaultAttributeValues[name];

          if (_value2 !== undefined) {
            switch (_value2.length) {
              case 2:
                gl.vertexAttrib2fv(programAttribute.location, _value2);
                break;

              case 3:
                gl.vertexAttrib3fv(programAttribute.location, _value2);
                break;

              case 4:
                gl.vertexAttrib4fv(programAttribute.location, _value2);
                break;

              default:
                gl.vertexAttrib1fv(programAttribute.location, _value2);
            }
          }
        }
      }
    }

    disableUnusedAttributes();
  }

  function dispose() {
    reset();

    for (var geometryId in bindingStates) {
      var programMap = bindingStates[geometryId];

      for (var programId in programMap) {
        var stateMap = programMap[programId];

        for (var wireframe in stateMap) {
          deleteVertexArrayObject(stateMap[wireframe].object);
          delete stateMap[wireframe];
        }

        delete programMap[programId];
      }

      delete bindingStates[geometryId];
    }
  }

  function releaseStatesOfGeometry(geometry) {
    if (bindingStates[geometry.id] === undefined) return;
    var programMap = bindingStates[geometry.id];

    for (var programId in programMap) {
      var stateMap = programMap[programId];

      for (var wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }

      delete programMap[programId];
    }

    delete bindingStates[geometry.id];
  }

  function releaseStatesOfProgram(program) {
    for (var geometryId in bindingStates) {
      var programMap = bindingStates[geometryId];
      if (programMap[program.id] === undefined) continue;
      var stateMap = programMap[program.id];

      for (var wireframe in stateMap) {
        deleteVertexArrayObject(stateMap[wireframe].object);
        delete stateMap[wireframe];
      }

      delete programMap[program.id];
    }
  }

  function reset() {
    resetDefaultState();
    forceUpdate = true;
    if (currentState === defaultState) return;
    currentState = defaultState;
    bindVertexArrayObject(currentState.object);
  } // for backward-compatibility


  function resetDefaultState() {
    defaultState.geometry = null;
    defaultState.program = null;
    defaultState.wireframe = false;
  }

  return {
    setup: setup,
    reset: reset,
    resetDefaultState: resetDefaultState,
    dispose: dispose,
    releaseStatesOfGeometry: releaseStatesOfGeometry,
    releaseStatesOfProgram: releaseStatesOfProgram,
    initAttributes: initAttributes,
    enableAttribute: enableAttribute,
    disableUnusedAttributes: disableUnusedAttributes
  };
}

function WebGLBufferRenderer(gl, extensions, info, capabilities) {
  var isWebGL2 = capabilities.isWebGL2;
  var mode;

  function setMode(value) {
    mode = value;
  }

  function render(start, count) {
    gl.drawArrays(mode, start, count);
    info.update(count, mode, 1);
  }

  function renderInstances(start, count, primcount) {
    if (primcount === 0) return;
    var extension, methodName;

    if (isWebGL2) {
      extension = gl;
      methodName = 'drawArraysInstanced';
    } else {
      extension = extensions.get('ANGLE_instanced_arrays');
      methodName = 'drawArraysInstancedANGLE';

      if (extension === null) {
        console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
        return;
      }
    }

    extension[methodName](mode, start, count, primcount);
    info.update(count, mode, primcount);
  } //


  this.setMode = setMode;
  this.render = render;
  this.renderInstances = renderInstances;
}

function WebGLCapabilities(gl, extensions, parameters) {
  var maxAnisotropy;

  function getMaxAnisotropy() {
    if (maxAnisotropy !== undefined) return maxAnisotropy;

    if (extensions.has('EXT_texture_filter_anisotropic') === true) {
      var extension = extensions.get('EXT_texture_filter_anisotropic');
      maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else {
      maxAnisotropy = 0;
    }

    return maxAnisotropy;
  }

  function getMaxPrecision(precision) {
    if (precision === 'highp') {
      if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) {
        return 'highp';
      }

      precision = 'mediump';
    }

    if (precision === 'mediump') {
      if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) {
        return 'mediump';
      }
    }

    return 'lowp';
  }

  var isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== 'undefined' && gl instanceof WebGL2ComputeRenderingContext;
  var precision = parameters.precision !== undefined ? parameters.precision : 'highp';
  var maxPrecision = getMaxPrecision(precision);

  if (maxPrecision !== precision) {
    console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
    precision = maxPrecision;
  }

  var drawBuffers = isWebGL2 || extensions.has('WEBGL_draw_buffers');
  var logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
  var maxTextures = gl.getParameter(34930);
  var maxVertexTextures = gl.getParameter(35660);
  var maxTextureSize = gl.getParameter(3379);
  var maxCubemapSize = gl.getParameter(34076);
  var maxAttributes = gl.getParameter(34921);
  var maxVertexUniforms = gl.getParameter(36347);
  var maxVaryings = gl.getParameter(36348);
  var maxFragmentUniforms = gl.getParameter(36349);
  var vertexTextures = maxVertexTextures > 0;
  var floatFragmentTextures = isWebGL2 || extensions.has('OES_texture_float');
  var floatVertexTextures = vertexTextures && floatFragmentTextures;
  var maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
  return {
    isWebGL2: isWebGL2,
    drawBuffers: drawBuffers,
    getMaxAnisotropy: getMaxAnisotropy,
    getMaxPrecision: getMaxPrecision,
    precision: precision,
    logarithmicDepthBuffer: logarithmicDepthBuffer,
    maxTextures: maxTextures,
    maxVertexTextures: maxVertexTextures,
    maxTextureSize: maxTextureSize,
    maxCubemapSize: maxCubemapSize,
    maxAttributes: maxAttributes,
    maxVertexUniforms: maxVertexUniforms,
    maxVaryings: maxVaryings,
    maxFragmentUniforms: maxFragmentUniforms,
    vertexTextures: vertexTextures,
    floatFragmentTextures: floatFragmentTextures,
    floatVertexTextures: floatVertexTextures,
    maxSamples: maxSamples
  };
}

function WebGLClipping(properties) {
  var scope = this;
  var globalState = null,
      numGlobalPlanes = 0,
      localClippingEnabled = false,
      renderingShadows = false;
  var plane = new Plane(),
      viewNormalMatrix = new Matrix3(),
      uniform = {
    value: null,
    needsUpdate: false
  };
  this.uniform = uniform;
  this.numPlanes = 0;
  this.numIntersection = 0;

  this.init = function (planes, enableLocalClipping, camera) {
    var enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
    // run another frame in order to reset the state:
    numGlobalPlanes !== 0 || localClippingEnabled;
    localClippingEnabled = enableLocalClipping;
    globalState = projectPlanes(planes, camera, 0);
    numGlobalPlanes = planes.length;
    return enabled;
  };

  this.beginShadows = function () {
    renderingShadows = true;
    projectPlanes(null);
  };

  this.endShadows = function () {
    renderingShadows = false;
    resetGlobalState();
  };

  this.setState = function (material, camera, useCache) {
    var planes = material.clippingPlanes,
        clipIntersection = material.clipIntersection,
        clipShadows = material.clipShadows;
    var materialProperties = properties.get(material);

    if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
      // there's no local clipping
      if (renderingShadows) {
        // there's no global clipping
        projectPlanes(null);
      } else {
        resetGlobalState();
      }
    } else {
      var nGlobal = renderingShadows ? 0 : numGlobalPlanes,
          lGlobal = nGlobal * 4;
      var dstArray = materialProperties.clippingState || null;
      uniform.value = dstArray; // ensure unique state

      dstArray = projectPlanes(planes, camera, lGlobal, useCache);

      for (var _i82 = 0; _i82 !== lGlobal; ++_i82) {
        dstArray[_i82] = globalState[_i82];
      }

      materialProperties.clippingState = dstArray;
      this.numIntersection = clipIntersection ? this.numPlanes : 0;
      this.numPlanes += nGlobal;
    }
  };

  function resetGlobalState() {
    if (uniform.value !== globalState) {
      uniform.value = globalState;
      uniform.needsUpdate = numGlobalPlanes > 0;
    }

    scope.numPlanes = numGlobalPlanes;
    scope.numIntersection = 0;
  }

  function projectPlanes(planes, camera, dstOffset, skipTransform) {
    var nPlanes = planes !== null ? planes.length : 0;
    var dstArray = null;

    if (nPlanes !== 0) {
      dstArray = uniform.value;

      if (skipTransform !== true || dstArray === null) {
        var flatSize = dstOffset + nPlanes * 4,
            viewMatrix = camera.matrixWorldInverse;
        viewNormalMatrix.getNormalMatrix(viewMatrix);

        if (dstArray === null || dstArray.length < flatSize) {
          dstArray = new Float32Array(flatSize);
        }

        for (var _i83 = 0, i4 = dstOffset; _i83 !== nPlanes; ++_i83, i4 += 4) {
          plane.copy(planes[_i83]).applyMatrix4(viewMatrix, viewNormalMatrix);
          plane.normal.toArray(dstArray, i4);
          dstArray[i4 + 3] = plane.constant;
        }
      }

      uniform.value = dstArray;
      uniform.needsUpdate = true;
    }

    scope.numPlanes = nPlanes;
    scope.numIntersection = 0;
    return dstArray;
  }
}

function WebGLCubeMaps(renderer) {
  var cubemaps = new WeakMap();

  function mapTextureMapping(texture, mapping) {
    if (mapping === EquirectangularReflectionMapping) {
      texture.mapping = CubeReflectionMapping;
    } else if (mapping === EquirectangularRefractionMapping) {
      texture.mapping = CubeRefractionMapping;
    }

    return texture;
  }

  function get(texture) {
    if (texture && texture.isTexture && texture.isRenderTargetTexture === false) {
      var mapping = texture.mapping;

      if (mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping) {
        if (cubemaps.has(texture)) {
          var cubemap = cubemaps.get(texture).texture;
          return mapTextureMapping(cubemap, texture.mapping);
        } else {
          var image = texture.image;

          if (image && image.height > 0) {
            var renderTarget = new WebGLCubeRenderTarget(image.height / 2);
            renderTarget.fromEquirectangularTexture(renderer, texture);
            cubemaps.set(texture, renderTarget);
            texture.addEventListener('dispose', onTextureDispose);
            return mapTextureMapping(renderTarget.texture, texture.mapping);
          } else {
            // image not yet ready. try the conversion next frame
            return null;
          }
        }
      }
    }

    return texture;
  }

  function onTextureDispose(event) {
    var texture = event.target;
    texture.removeEventListener('dispose', onTextureDispose);
    var cubemap = cubemaps.get(texture);

    if (cubemap !== undefined) {
      cubemaps.delete(texture);
      cubemap.dispose();
    }
  }

  function dispose() {
    cubemaps = new WeakMap();
  }

  return {
    get: get,
    dispose: dispose
  };
}

var OrthographicCamera = /*#__PURE__*/function (_Camera2) {
  _inherits(OrthographicCamera, _Camera2);

  var _super22 = _createSuper(OrthographicCamera);

  function OrthographicCamera() {
    var _this19;

    var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var top = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var bottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
    var near = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.1;
    var far = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2000;

    _classCallCheck2(this, OrthographicCamera);

    _this19 = _super22.call(this);
    _this19.type = 'OrthographicCamera';
    _this19.zoom = 1;
    _this19.view = null;
    _this19.left = left;
    _this19.right = right;
    _this19.top = top;
    _this19.bottom = bottom;
    _this19.near = near;
    _this19.far = far;

    _this19.updateProjectionMatrix();

    return _this19;
  }

  _createClass2(OrthographicCamera, [{
    key: "copy",
    value: function copy(source, recursive) {
      _get(_getPrototypeOf(OrthographicCamera.prototype), "copy", this).call(this, source, recursive);

      this.left = source.left;
      this.right = source.right;
      this.top = source.top;
      this.bottom = source.bottom;
      this.near = source.near;
      this.far = source.far;
      this.zoom = source.zoom;
      this.view = source.view === null ? null : Object.assign({}, source.view);
      return this;
    }
  }, {
    key: "setViewOffset",
    value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
      if (this.view === null) {
        this.view = {
          enabled: true,
          fullWidth: 1,
          fullHeight: 1,
          offsetX: 0,
          offsetY: 0,
          width: 1,
          height: 1
        };
      }

      this.view.enabled = true;
      this.view.fullWidth = fullWidth;
      this.view.fullHeight = fullHeight;
      this.view.offsetX = x;
      this.view.offsetY = y;
      this.view.width = width;
      this.view.height = height;
      this.updateProjectionMatrix();
    }
  }, {
    key: "clearViewOffset",
    value: function clearViewOffset() {
      if (this.view !== null) {
        this.view.enabled = false;
      }

      this.updateProjectionMatrix();
    }
  }, {
    key: "updateProjectionMatrix",
    value: function updateProjectionMatrix() {
      var dx = (this.right - this.left) / (2 * this.zoom);
      var dy = (this.top - this.bottom) / (2 * this.zoom);
      var cx = (this.right + this.left) / 2;
      var cy = (this.top + this.bottom) / 2;
      var left = cx - dx;
      var right = cx + dx;
      var top = cy + dy;
      var bottom = cy - dy;

      if (this.view !== null && this.view.enabled) {
        var scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
        var scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
        left += scaleW * this.view.offsetX;
        right = left + scaleW * this.view.width;
        top -= scaleH * this.view.offsetY;
        bottom = top - scaleH * this.view.height;
      }

      this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
      this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
  }, {
    key: "toJSON",
    value: function toJSON(meta) {
      var data = _get(_getPrototypeOf(OrthographicCamera.prototype), "toJSON", this).call(this, meta);

      data.object.zoom = this.zoom;
      data.object.left = this.left;
      data.object.right = this.right;
      data.object.top = this.top;
      data.object.bottom = this.bottom;
      data.object.near = this.near;
      data.object.far = this.far;
      if (this.view !== null) data.object.view = Object.assign({}, this.view);
      return data;
    }
  }]);

  return OrthographicCamera;
}(Camera);

OrthographicCamera.prototype.isOrthographicCamera = true;
var LOD_MIN = 4; // The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.

var EXTRA_LOD_SIGMA = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582]; // The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.

var MAX_SAMPLES = 20;

var _flatCamera = /*@__PURE__*/new OrthographicCamera();

var _clearColor = /*@__PURE__*/new Color();

var _oldTarget = null; // Golden Ratio

var PHI = (1 + Math.sqrt(5)) / 2;
var INV_PHI = 1 / PHI; // Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.

var _axisDirections = [/*@__PURE__*/new Vector3(1, 1, 1), /*@__PURE__*/new Vector3(-1, 1, 1), /*@__PURE__*/new Vector3(1, 1, -1), /*@__PURE__*/new Vector3(-1, 1, -1), /*@__PURE__*/new Vector3(0, PHI, INV_PHI), /*@__PURE__*/new Vector3(0, PHI, -INV_PHI), /*@__PURE__*/new Vector3(INV_PHI, 0, PHI), /*@__PURE__*/new Vector3(-INV_PHI, 0, PHI), /*@__PURE__*/new Vector3(PHI, INV_PHI, 0), /*@__PURE__*/new Vector3(-PHI, INV_PHI, 0)];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/

var PMREMGenerator = /*#__PURE__*/function () {
  function PMREMGenerator(renderer) {
    _classCallCheck2(this, PMREMGenerator);

    this._renderer = renderer;
    this._pingPongRenderTarget = null;
    this._lodMax = 0;
    this._cubeSize = 0;
    this._lodPlanes = [];
    this._sizeLods = [];
    this._sigmas = [];
    this._blurMaterial = null;
    this._cubemapMaterial = null;
    this._equirectMaterial = null;

    this._compileMaterial(this._blurMaterial);
  }
  /**
   * Generates a PMREM from a supplied Scene, which can be faster than using an
   * image if networking bandwidth is low. Optional sigma specifies a blur radius
   * in radians to be applied to the scene before PMREM generation. Optional near
   * and far planes ensure the scene is rendered in its entirety (the cubeCamera
   * is placed at the origin).
   */


  _createClass2(PMREMGenerator, [{
    key: "fromScene",
    value: function fromScene(scene) {
      var sigma = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var near = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.1;
      var far = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 100;
      _oldTarget = this._renderer.getRenderTarget();

      this._setSize(256);

      var cubeUVRenderTarget = this._allocateTargets();

      cubeUVRenderTarget.depthBuffer = true;

      this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);

      if (sigma > 0) {
        this._blur(cubeUVRenderTarget, 0, 0, sigma);
      }

      this._applyPMREM(cubeUVRenderTarget);

      this._cleanup(cubeUVRenderTarget);

      return cubeUVRenderTarget;
    }
    /**
     * Generates a PMREM from an equirectangular texture, which can be either LDR
     * or HDR. The ideal input image size is 1k (1024 x 512),
     * as this matches best with the 256 x 256 cubemap output.
     */

  }, {
    key: "fromEquirectangular",
    value: function fromEquirectangular(equirectangular) {
      var renderTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this._fromTexture(equirectangular, renderTarget);
    }
    /**
     * Generates a PMREM from an cubemap texture, which can be either LDR
     * or HDR. The ideal input cube size is 256 x 256,
     * as this matches best with the 256 x 256 cubemap output.
     */

  }, {
    key: "fromCubemap",
    value: function fromCubemap(cubemap) {
      var renderTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this._fromTexture(cubemap, renderTarget);
    }
    /**
     * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
     * your texture's network fetch for increased concurrency.
     */

  }, {
    key: "compileCubemapShader",
    value: function compileCubemapShader() {
      if (this._cubemapMaterial === null) {
        this._cubemapMaterial = _getCubemapMaterial();

        this._compileMaterial(this._cubemapMaterial);
      }
    }
    /**
     * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
     * your texture's network fetch for increased concurrency.
     */

  }, {
    key: "compileEquirectangularShader",
    value: function compileEquirectangularShader() {
      if (this._equirectMaterial === null) {
        this._equirectMaterial = _getEquirectMaterial();

        this._compileMaterial(this._equirectMaterial);
      }
    }
    /**
     * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
     * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
     * one of them will cause any others to also become unusable.
     */

  }, {
    key: "dispose",
    value: function dispose() {
      this._dispose();

      if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
      if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    } // private interface

  }, {
    key: "_setSize",
    value: function _setSize(cubeSize) {
      this._lodMax = Math.floor(Math.log2(cubeSize));
      this._cubeSize = Math.pow(2, this._lodMax);
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      if (this._blurMaterial !== null) this._blurMaterial.dispose();
      if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();

      for (var _i84 = 0; _i84 < this._lodPlanes.length; _i84++) {
        this._lodPlanes[_i84].dispose();
      }
    }
  }, {
    key: "_cleanup",
    value: function _cleanup(outputTarget) {
      this._renderer.setRenderTarget(_oldTarget);

      outputTarget.scissorTest = false;

      _setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
  }, {
    key: "_fromTexture",
    value: function _fromTexture(texture, renderTarget) {
      if (texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping) {
        this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
      } else {
        // Equirectangular
        this._setSize(texture.image.width / 4);
      }

      _oldTarget = this._renderer.getRenderTarget();

      var cubeUVRenderTarget = renderTarget || this._allocateTargets();

      this._textureToCubeUV(texture, cubeUVRenderTarget);

      this._applyPMREM(cubeUVRenderTarget);

      this._cleanup(cubeUVRenderTarget);

      return cubeUVRenderTarget;
    }
  }, {
    key: "_allocateTargets",
    value: function _allocateTargets() {
      var width = 3 * Math.max(this._cubeSize, 16 * 7);
      var height = 4 * this._cubeSize;
      var params = {
        magFilter: LinearFilter,
        minFilter: LinearFilter,
        generateMipmaps: false,
        type: HalfFloatType,
        format: RGBAFormat,
        encoding: LinearEncoding,
        depthBuffer: false
      };

      var cubeUVRenderTarget = _createRenderTarget(width, height, params);

      if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width) {
        if (this._pingPongRenderTarget !== null) {
          this._dispose();
        }

        this._pingPongRenderTarget = _createRenderTarget(width, height, params);
        var _lodMax = this._lodMax;

        var _createPlanes2 = _createPlanes(_lodMax);

        this._sizeLods = _createPlanes2.sizeLods;
        this._lodPlanes = _createPlanes2.lodPlanes;
        this._sigmas = _createPlanes2.sigmas;
        this._blurMaterial = _getBlurShader(_lodMax, width, height);
      }

      return cubeUVRenderTarget;
    }
  }, {
    key: "_compileMaterial",
    value: function _compileMaterial(material) {
      var tmpMesh = new Mesh(this._lodPlanes[0], material);

      this._renderer.compile(tmpMesh, _flatCamera);
    }
  }, {
    key: "_sceneToCubeUV",
    value: function _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
      var fov = 90;
      var aspect = 1;
      var cubeCamera = new PerspectiveCamera(fov, aspect, near, far);
      var upSign = [1, -1, 1, 1, 1, 1];
      var forwardSign = [1, 1, 1, -1, -1, -1];
      var renderer = this._renderer;
      var originalAutoClear = renderer.autoClear;
      var toneMapping = renderer.toneMapping;
      renderer.getClearColor(_clearColor);
      renderer.toneMapping = NoToneMapping;
      renderer.autoClear = false;
      var backgroundMaterial = new MeshBasicMaterial({
        name: 'PMREM.Background',
        side: BackSide,
        depthWrite: false,
        depthTest: false
      });
      var backgroundBox = new Mesh(new BoxGeometry(), backgroundMaterial);
      var useSolidColor = false;
      var background = scene.background;

      if (background) {
        if (background.isColor) {
          backgroundMaterial.color.copy(background);
          scene.background = null;
          useSolidColor = true;
        }
      } else {
        backgroundMaterial.color.copy(_clearColor);
        useSolidColor = true;
      }

      for (var _i85 = 0; _i85 < 6; _i85++) {
        var col = _i85 % 3;

        if (col === 0) {
          cubeCamera.up.set(0, upSign[_i85], 0);
          cubeCamera.lookAt(forwardSign[_i85], 0, 0);
        } else if (col === 1) {
          cubeCamera.up.set(0, 0, upSign[_i85]);
          cubeCamera.lookAt(0, forwardSign[_i85], 0);
        } else {
          cubeCamera.up.set(0, upSign[_i85], 0);
          cubeCamera.lookAt(0, 0, forwardSign[_i85]);
        }

        var size = this._cubeSize;

        _setViewport(cubeUVRenderTarget, col * size, _i85 > 2 ? size : 0, size, size);

        renderer.setRenderTarget(cubeUVRenderTarget);

        if (useSolidColor) {
          renderer.render(backgroundBox, cubeCamera);
        }

        renderer.render(scene, cubeCamera);
      }

      backgroundBox.geometry.dispose();
      backgroundBox.material.dispose();
      renderer.toneMapping = toneMapping;
      renderer.autoClear = originalAutoClear;
      scene.background = background;
    }
  }, {
    key: "_textureToCubeUV",
    value: function _textureToCubeUV(texture, cubeUVRenderTarget) {
      var renderer = this._renderer;
      var isCubeTexture = texture.mapping === CubeReflectionMapping || texture.mapping === CubeRefractionMapping;

      if (isCubeTexture) {
        if (this._cubemapMaterial === null) {
          this._cubemapMaterial = _getCubemapMaterial();
        }

        this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
      } else {
        if (this._equirectMaterial === null) {
          this._equirectMaterial = _getEquirectMaterial();
        }
      }

      var material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
      var mesh = new Mesh(this._lodPlanes[0], material);
      var uniforms = material.uniforms;
      uniforms['envMap'].value = texture;
      var size = this._cubeSize;

      _setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);

      renderer.setRenderTarget(cubeUVRenderTarget);
      renderer.render(mesh, _flatCamera);
    }
  }, {
    key: "_applyPMREM",
    value: function _applyPMREM(cubeUVRenderTarget) {
      var renderer = this._renderer;
      var autoClear = renderer.autoClear;
      renderer.autoClear = false;

      for (var _i86 = 1; _i86 < this._lodPlanes.length; _i86++) {
        var sigma = Math.sqrt(this._sigmas[_i86] * this._sigmas[_i86] - this._sigmas[_i86 - 1] * this._sigmas[_i86 - 1]);
        var poleAxis = _axisDirections[(_i86 - 1) % _axisDirections.length];

        this._blur(cubeUVRenderTarget, _i86 - 1, _i86, sigma, poleAxis);
      }

      renderer.autoClear = autoClear;
    }
    /**
     * This is a two-pass Gaussian blur for a cubemap. Normally this is done
     * vertically and horizontally, but this breaks down on a cube. Here we apply
     * the blur latitudinally (around the poles), and then longitudinally (towards
     * the poles) to approximate the orthogonally-separable blur. It is least
     * accurate at the poles, but still does a decent job.
     */

  }, {
    key: "_blur",
    value: function _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
      var pingPongRenderTarget = this._pingPongRenderTarget;

      this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);

      this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
  }, {
    key: "_halfBlur",
    value: function _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
      var renderer = this._renderer;
      var blurMaterial = this._blurMaterial;

      if (direction !== 'latitudinal' && direction !== 'longitudinal') {
        console.error('blur direction must be either latitudinal or longitudinal!');
      } // Number of standard deviations at which to cut off the discrete approximation.


      var STANDARD_DEVIATIONS = 3;
      var blurMesh = new Mesh(this._lodPlanes[lodOut], blurMaterial);
      var blurUniforms = blurMaterial.uniforms;
      var pixels = this._sizeLods[lodIn] - 1;
      var radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES - 1);
      var sigmaPixels = sigmaRadians / radiansPerPixel;
      var samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES;

      if (samples > MAX_SAMPLES) {
        console.warn("sigmaRadians, ".concat(sigmaRadians, ", is too large and will clip, as it requested ").concat(samples, " samples when the maximum is set to ").concat(MAX_SAMPLES));
      }

      var weights = [];
      var sum = 0;

      for (var _i87 = 0; _i87 < MAX_SAMPLES; ++_i87) {
        var _x2 = _i87 / sigmaPixels;

        var weight = Math.exp(-_x2 * _x2 / 2);
        weights.push(weight);

        if (_i87 === 0) {
          sum += weight;
        } else if (_i87 < samples) {
          sum += 2 * weight;
        }
      }

      for (var _i88 = 0; _i88 < weights.length; _i88++) {
        weights[_i88] = weights[_i88] / sum;
      }

      blurUniforms['envMap'].value = targetIn.texture;
      blurUniforms['samples'].value = samples;
      blurUniforms['weights'].value = weights;
      blurUniforms['latitudinal'].value = direction === 'latitudinal';

      if (poleAxis) {
        blurUniforms['poleAxis'].value = poleAxis;
      }

      var _lodMax = this._lodMax;
      blurUniforms['dTheta'].value = radiansPerPixel;
      blurUniforms['mipInt'].value = _lodMax - lodIn;
      var outputSize = this._sizeLods[lodOut];
      var x = 3 * outputSize * (lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0);
      var y = 4 * (this._cubeSize - outputSize);

      _setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);

      renderer.setRenderTarget(targetOut);
      renderer.render(blurMesh, _flatCamera);
    }
  }]);

  return PMREMGenerator;
}();

function _createPlanes(lodMax) {
  var lodPlanes = [];
  var sizeLods = [];
  var sigmas = [];
  var lod = lodMax;
  var totalLods = lodMax - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;

  for (var _i89 = 0; _i89 < totalLods; _i89++) {
    var sizeLod = Math.pow(2, lod);
    sizeLods.push(sizeLod);
    var sigma = 1.0 / sizeLod;

    if (_i89 > lodMax - LOD_MIN) {
      sigma = EXTRA_LOD_SIGMA[_i89 - lodMax + LOD_MIN - 1];
    } else if (_i89 === 0) {
      sigma = 0;
    }

    sigmas.push(sigma);
    var texelSize = 1.0 / (sizeLod - 2);
    var min = -texelSize;
    var max = 1 + texelSize;
    var uv1 = [min, min, max, min, max, max, min, min, max, max, min, max];
    var cubeFaces = 6;
    var vertices = 6;
    var positionSize = 3;
    var uvSize = 2;
    var faceIndexSize = 1;
    var position = new Float32Array(positionSize * vertices * cubeFaces);
    var uv = new Float32Array(uvSize * vertices * cubeFaces);
    var faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);

    for (var face = 0; face < cubeFaces; face++) {
      var x = face % 3 * 2 / 3 - 1;
      var y = face > 2 ? 0 : -1;
      var coordinates = [x, y, 0, x + 2 / 3, y, 0, x + 2 / 3, y + 1, 0, x, y, 0, x + 2 / 3, y + 1, 0, x, y + 1, 0];
      position.set(coordinates, positionSize * vertices * face);
      uv.set(uv1, uvSize * vertices * face);
      var fill = [face, face, face, face, face, face];
      faceIndex.set(fill, faceIndexSize * vertices * face);
    }

    var planes = new BufferGeometry();
    planes.setAttribute('position', new BufferAttribute(position, positionSize));
    planes.setAttribute('uv', new BufferAttribute(uv, uvSize));
    planes.setAttribute('faceIndex', new BufferAttribute(faceIndex, faceIndexSize));
    lodPlanes.push(planes);

    if (lod > LOD_MIN) {
      lod--;
    }
  }

  return {
    lodPlanes: lodPlanes,
    sizeLods: sizeLods,
    sigmas: sigmas
  };
}

function _createRenderTarget(width, height, params) {
  var cubeUVRenderTarget = new WebGLRenderTarget(width, height, params);
  cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
  cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
  cubeUVRenderTarget.scissorTest = true;
  return cubeUVRenderTarget;
}

function _setViewport(target, x, y, width, height) {
  target.viewport.set(x, y, width, height);
  target.scissor.set(x, y, width, height);
}

function _getBlurShader(lodMax, width, height) {
  var weights = new Float32Array(MAX_SAMPLES);
  var poleAxis = new Vector3(0, 1, 0);
  var shaderMaterial = new ShaderMaterial({
    name: 'SphericalGaussianBlur',
    defines: {
      'n': MAX_SAMPLES,
      'CUBEUV_TEXEL_WIDTH': 1.0 / width,
      'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
      'CUBEUV_MAX_MIP': "".concat(lodMax, ".0")
    },
    uniforms: {
      'envMap': {
        value: null
      },
      'samples': {
        value: 1
      },
      'weights': {
        value: weights
      },
      'latitudinal': {
        value: false
      },
      'dTheta': {
        value: 0
      },
      'mipInt': {
        value: 0
      },
      'poleAxis': {
        value: poleAxis
      }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader:
    /* glsl */
    "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t",
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
  return shaderMaterial;
}

function _getEquirectMaterial() {
  return new ShaderMaterial({
    name: 'EquirectangularToCubeUV',
    uniforms: {
      'envMap': {
        value: null
      }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader:
    /* glsl */
    "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t",
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
}

function _getCubemapMaterial() {
  return new ShaderMaterial({
    name: 'CubemapToCubeUV',
    uniforms: {
      'envMap': {
        value: null
      },
      'flipEnvMap': {
        value: -1
      }
    },
    vertexShader: _getCommonVertexShader(),
    fragmentShader:
    /* glsl */
    "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t",
    blending: NoBlending,
    depthTest: false,
    depthWrite: false
  });
}

function _getCommonVertexShader() {
  return (
    /* glsl */
    "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t"
  );
}

function WebGLCubeUVMaps(renderer) {
  var cubeUVmaps = new WeakMap();
  var pmremGenerator = null;

  function get(texture) {
    if (texture && texture.isTexture) {
      var mapping = texture.mapping;
      var isEquirectMap = mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping;
      var isCubeMap = mapping === CubeReflectionMapping || mapping === CubeRefractionMapping; // equirect/cube map to cubeUV conversion

      if (isEquirectMap || isCubeMap) {
        if (texture.isRenderTargetTexture && texture.needsPMREMUpdate === true) {
          texture.needsPMREMUpdate = false;
          var renderTarget = cubeUVmaps.get(texture);
          if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);
          renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
          cubeUVmaps.set(texture, renderTarget);
          return renderTarget.texture;
        } else {
          if (cubeUVmaps.has(texture)) {
            return cubeUVmaps.get(texture).texture;
          } else {
            var image = texture.image;

            if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
              if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);

              var _renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);

              cubeUVmaps.set(texture, _renderTarget);
              texture.addEventListener('dispose', onTextureDispose);
              return _renderTarget.texture;
            } else {
              // image not yet ready. try the conversion next frame
              return null;
            }
          }
        }
      }
    }

    return texture;
  }

  function isCubeTextureComplete(image) {
    var count = 0;
    var length = 6;

    for (var _i90 = 0; _i90 < length; _i90++) {
      if (image[_i90] !== undefined) count++;
    }

    return count === length;
  }

  function onTextureDispose(event) {
    var texture = event.target;
    texture.removeEventListener('dispose', onTextureDispose);
    var cubemapUV = cubeUVmaps.get(texture);

    if (cubemapUV !== undefined) {
      cubeUVmaps.delete(texture);
      cubemapUV.dispose();
    }
  }

  function dispose() {
    cubeUVmaps = new WeakMap();

    if (pmremGenerator !== null) {
      pmremGenerator.dispose();
      pmremGenerator = null;
    }
  }

  return {
    get: get,
    dispose: dispose
  };
}

function WebGLExtensions(gl) {
  var extensions = {};

  function getExtension(name) {
    if (extensions[name] !== undefined) {
      return extensions[name];
    }

    var extension;

    switch (name) {
      case 'WEBGL_depth_texture':
        extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
        break;

      case 'EXT_texture_filter_anisotropic':
        extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
        break;

      case 'WEBGL_compressed_texture_s3tc':
        extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
        break;

      case 'WEBGL_compressed_texture_pvrtc':
        extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
        break;

      default:
        extension = gl.getExtension(name);
    }

    extensions[name] = extension;
    return extension;
  }

  return {
    has: function has(name) {
      return getExtension(name) !== null;
    },
    init: function init(capabilities) {
      if (capabilities.isWebGL2) {
        getExtension('EXT_color_buffer_float');
      } else {
        getExtension('WEBGL_depth_texture');
        getExtension('OES_texture_float');
        getExtension('OES_texture_half_float');
        getExtension('OES_texture_half_float_linear');
        getExtension('OES_standard_derivatives');
        getExtension('OES_element_index_uint');
        getExtension('OES_vertex_array_object');
        getExtension('ANGLE_instanced_arrays');
      }

      getExtension('OES_texture_float_linear');
      getExtension('EXT_color_buffer_half_float');
      getExtension('WEBGL_multisampled_render_to_texture');
    },
    get: function get(name) {
      var extension = getExtension(name);

      if (extension === null) {
        console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
      }

      return extension;
    }
  };
}

function WebGLGeometries(gl, attributes, info, bindingStates) {
  var geometries = {};
  var wireframeAttributes = new WeakMap();

  function onGeometryDispose(event) {
    var geometry = event.target;

    if (geometry.index !== null) {
      attributes.remove(geometry.index);
    }

    for (var name in geometry.attributes) {
      attributes.remove(geometry.attributes[name]);
    }

    geometry.removeEventListener('dispose', onGeometryDispose);
    delete geometries[geometry.id];
    var attribute = wireframeAttributes.get(geometry);

    if (attribute) {
      attributes.remove(attribute);
      wireframeAttributes.delete(geometry);
    }

    bindingStates.releaseStatesOfGeometry(geometry);

    if (geometry.isInstancedBufferGeometry === true) {
      delete geometry._maxInstanceCount;
    } //


    info.memory.geometries--;
  }

  function get(object, geometry) {
    if (geometries[geometry.id] === true) return geometry;
    geometry.addEventListener('dispose', onGeometryDispose);
    geometries[geometry.id] = true;
    info.memory.geometries++;
    return geometry;
  }

  function update(geometry) {
    var geometryAttributes = geometry.attributes; // Updating index buffer in VAO now. See WebGLBindingStates.

    for (var name in geometryAttributes) {
      attributes.update(geometryAttributes[name], 34962);
    } // morph targets


    var morphAttributes = geometry.morphAttributes;

    for (var _name3 in morphAttributes) {
      var array = morphAttributes[_name3];

      for (var _i91 = 0, l = array.length; _i91 < l; _i91++) {
        attributes.update(array[_i91], 34962);
      }
    }
  }

  function updateWireframeAttribute(geometry) {
    var indices = [];
    var geometryIndex = geometry.index;
    var geometryPosition = geometry.attributes.position;
    var version = 0;

    if (geometryIndex !== null) {
      var array = geometryIndex.array;
      version = geometryIndex.version;

      for (var _i92 = 0, l = array.length; _i92 < l; _i92 += 3) {
        var a = array[_i92 + 0];
        var b = array[_i92 + 1];
        var c = array[_i92 + 2];
        indices.push(a, b, b, c, c, a);
      }
    } else {
      var _array = geometryPosition.array;
      version = geometryPosition.version;

      for (var _i93 = 0, _l5 = _array.length / 3 - 1; _i93 < _l5; _i93 += 3) {
        var _a5 = _i93 + 0;

        var _b5 = _i93 + 1;

        var _c5 = _i93 + 2;

        indices.push(_a5, _b5, _b5, _c5, _c5, _a5);
      }
    }

    var attribute = new (arrayNeedsUint32(indices) ? Uint32BufferAttribute : Uint16BufferAttribute)(indices, 1);
    attribute.version = version; // Updating index buffer in VAO now. See WebGLBindingStates
    //

    var previousAttribute = wireframeAttributes.get(geometry);
    if (previousAttribute) attributes.remove(previousAttribute); //

    wireframeAttributes.set(geometry, attribute);
  }

  function getWireframeAttribute(geometry) {
    var currentAttribute = wireframeAttributes.get(geometry);

    if (currentAttribute) {
      var geometryIndex = geometry.index;

      if (geometryIndex !== null) {
        // if the attribute is obsolete, create a new one
        if (currentAttribute.version < geometryIndex.version) {
          updateWireframeAttribute(geometry);
        }
      }
    } else {
      updateWireframeAttribute(geometry);
    }

    return wireframeAttributes.get(geometry);
  }

  return {
    get: get,
    update: update,
    getWireframeAttribute: getWireframeAttribute
  };
}

function WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
  var isWebGL2 = capabilities.isWebGL2;
  var mode;

  function setMode(value) {
    mode = value;
  }

  var type, bytesPerElement;

  function setIndex(value) {
    type = value.type;
    bytesPerElement = value.bytesPerElement;
  }

  function render(start, count) {
    gl.drawElements(mode, count, type, start * bytesPerElement);
    info.update(count, mode, 1);
  }

  function renderInstances(start, count, primcount) {
    if (primcount === 0) return;
    var extension, methodName;

    if (isWebGL2) {
      extension = gl;
      methodName = 'drawElementsInstanced';
    } else {
      extension = extensions.get('ANGLE_instanced_arrays');
      methodName = 'drawElementsInstancedANGLE';

      if (extension === null) {
        console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
        return;
      }
    }

    extension[methodName](mode, count, type, start * bytesPerElement, primcount);
    info.update(count, mode, primcount);
  } //


  this.setMode = setMode;
  this.setIndex = setIndex;
  this.render = render;
  this.renderInstances = renderInstances;
}

function WebGLInfo(gl) {
  var memory = {
    geometries: 0,
    textures: 0
  };
  var render = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };

  function update(count, mode, instanceCount) {
    render.calls++;

    switch (mode) {
      case 4:
        render.triangles += instanceCount * (count / 3);
        break;

      case 1:
        render.lines += instanceCount * (count / 2);
        break;

      case 3:
        render.lines += instanceCount * (count - 1);
        break;

      case 2:
        render.lines += instanceCount * count;
        break;

      case 0:
        render.points += instanceCount * count;
        break;

      default:
        console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
        break;
    }
  }

  function reset() {
    render.frame++;
    render.calls = 0;
    render.triangles = 0;
    render.points = 0;
    render.lines = 0;
  }

  return {
    memory: memory,
    render: render,
    programs: null,
    autoReset: true,
    reset: reset,
    update: update
  };
}

function numericalSort(a, b) {
  return a[0] - b[0];
}

function absNumericalSort(a, b) {
  return Math.abs(b[1]) - Math.abs(a[1]);
}

function denormalize(morph, attribute) {
  var denominator = 1;
  var array = attribute.isInterleavedBufferAttribute ? attribute.data.array : attribute.array;
  if (array instanceof Int8Array) denominator = 127;else if (array instanceof Int16Array) denominator = 32767;else if (array instanceof Int32Array) denominator = 2147483647;else console.error('THREE.WebGLMorphtargets: Unsupported morph attribute data type: ', array);
  morph.divideScalar(denominator);
}

function WebGLMorphtargets(gl, capabilities, textures) {
  var influencesList = {};
  var morphInfluences = new Float32Array(8);
  var morphTextures = new WeakMap();
  var morph = new Vector4();
  var workInfluences = [];

  for (var _i94 = 0; _i94 < 8; _i94++) {
    workInfluences[_i94] = [_i94, 0];
  }

  function update(object, geometry, material, program) {
    var objectInfluences = object.morphTargetInfluences;

    if (capabilities.isWebGL2 === true) {
      // instead of using attributes, the WebGL 2 code path encodes morph targets
      // into an array of data textures. Each layer represents a single morph target.
      var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
      var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
      var entry = morphTextures.get(geometry);

      if (entry === undefined || entry.count !== morphTargetsCount) {
        if (entry !== undefined) entry.texture.dispose();
        var hasMorphPosition = geometry.morphAttributes.position !== undefined;
        var hasMorphNormals = geometry.morphAttributes.normal !== undefined;
        var hasMorphColors = geometry.morphAttributes.color !== undefined;
        var morphTargets = geometry.morphAttributes.position || [];
        var morphNormals = geometry.morphAttributes.normal || [];
        var morphColors = geometry.morphAttributes.color || [];
        var vertexDataCount = 0;
        if (hasMorphPosition === true) vertexDataCount = 1;
        if (hasMorphNormals === true) vertexDataCount = 2;
        if (hasMorphColors === true) vertexDataCount = 3;
        var width = geometry.attributes.position.count * vertexDataCount;
        var height = 1;

        if (width > capabilities.maxTextureSize) {
          height = Math.ceil(width / capabilities.maxTextureSize);
          width = capabilities.maxTextureSize;
        }

        var buffer = new Float32Array(width * height * 4 * morphTargetsCount);
        var texture = new DataArrayTexture(buffer, width, height, morphTargetsCount);
        texture.type = FloatType;
        texture.needsUpdate = true; // fill buffer

        var vertexDataStride = vertexDataCount * 4;

        for (var _i95 = 0; _i95 < morphTargetsCount; _i95++) {
          var morphTarget = morphTargets[_i95];
          var morphNormal = morphNormals[_i95];
          var morphColor = morphColors[_i95];
          var offset = width * height * 4 * _i95;

          for (var j = 0; j < morphTarget.count; j++) {
            var stride = j * vertexDataStride;

            if (hasMorphPosition === true) {
              morph.fromBufferAttribute(morphTarget, j);
              if (morphTarget.normalized === true) denormalize(morph, morphTarget);
              buffer[offset + stride + 0] = morph.x;
              buffer[offset + stride + 1] = morph.y;
              buffer[offset + stride + 2] = morph.z;
              buffer[offset + stride + 3] = 0;
            }

            if (hasMorphNormals === true) {
              morph.fromBufferAttribute(morphNormal, j);
              if (morphNormal.normalized === true) denormalize(morph, morphNormal);
              buffer[offset + stride + 4] = morph.x;
              buffer[offset + stride + 5] = morph.y;
              buffer[offset + stride + 6] = morph.z;
              buffer[offset + stride + 7] = 0;
            }

            if (hasMorphColors === true) {
              morph.fromBufferAttribute(morphColor, j);
              if (morphColor.normalized === true) denormalize(morph, morphColor);
              buffer[offset + stride + 8] = morph.x;
              buffer[offset + stride + 9] = morph.y;
              buffer[offset + stride + 10] = morph.z;
              buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
            }
          }
        }

        entry = {
          count: morphTargetsCount,
          texture: texture,
          size: new Vector2(width, height)
        };
        morphTextures.set(geometry, entry);

        function disposeTexture() {
          texture.dispose();
          morphTextures.delete(geometry);
          geometry.removeEventListener('dispose', disposeTexture);
        }

        geometry.addEventListener('dispose', disposeTexture);
      } //


      var morphInfluencesSum = 0;

      for (var _i96 = 0; _i96 < objectInfluences.length; _i96++) {
        morphInfluencesSum += objectInfluences[_i96];
      }

      var morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
      program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
      program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
      program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
      program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    } else {
      // When object doesn't have morph target influences defined, we treat it as a 0-length array
      // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
      var _length3 = objectInfluences === undefined ? 0 : objectInfluences.length;

      var influences = influencesList[geometry.id];

      if (influences === undefined || influences.length !== _length3) {
        // initialise list
        influences = [];

        for (var _i97 = 0; _i97 < _length3; _i97++) {
          influences[_i97] = [_i97, 0];
        }

        influencesList[geometry.id] = influences;
      } // Collect influences


      for (var _i98 = 0; _i98 < _length3; _i98++) {
        var influence = influences[_i98];
        influence[0] = _i98;
        influence[1] = objectInfluences[_i98];
      }

      influences.sort(absNumericalSort);

      for (var _i99 = 0; _i99 < 8; _i99++) {
        if (_i99 < _length3 && influences[_i99][1]) {
          workInfluences[_i99][0] = influences[_i99][0];
          workInfluences[_i99][1] = influences[_i99][1];
        } else {
          workInfluences[_i99][0] = Number.MAX_SAFE_INTEGER;
          workInfluences[_i99][1] = 0;
        }
      }

      workInfluences.sort(numericalSort);
      var _morphTargets = geometry.morphAttributes.position;
      var _morphNormals = geometry.morphAttributes.normal;
      var _morphInfluencesSum = 0;

      for (var _i100 = 0; _i100 < 8; _i100++) {
        var _influence = workInfluences[_i100];
        var _index4 = _influence[0];
        var _value3 = _influence[1];

        if (_index4 !== Number.MAX_SAFE_INTEGER && _value3) {
          if (_morphTargets && geometry.getAttribute('morphTarget' + _i100) !== _morphTargets[_index4]) {
            geometry.setAttribute('morphTarget' + _i100, _morphTargets[_index4]);
          }

          if (_morphNormals && geometry.getAttribute('morphNormal' + _i100) !== _morphNormals[_index4]) {
            geometry.setAttribute('morphNormal' + _i100, _morphNormals[_index4]);
          }

          morphInfluences[_i100] = _value3;
          _morphInfluencesSum += _value3;
        } else {
          if (_morphTargets && geometry.hasAttribute('morphTarget' + _i100) === true) {
            geometry.deleteAttribute('morphTarget' + _i100);
          }

          if (_morphNormals && geometry.hasAttribute('morphNormal' + _i100) === true) {
            geometry.deleteAttribute('morphNormal' + _i100);
          }

          morphInfluences[_i100] = 0;
        }
      } // GLSL shader uses formula baseinfluence * base + sum(target * influence)
      // This allows us to switch between absolute morphs and relative morphs without changing shader code
      // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)


      var _morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - _morphInfluencesSum;

      program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', _morphBaseInfluence);
      program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
    }
  }

  return {
    update: update
  };
}

function WebGLObjects(gl, geometries, attributes, info) {
  var updateMap = new WeakMap();

  function update(object) {
    var frame = info.render.frame;
    var geometry = object.geometry;
    var buffergeometry = geometries.get(object, geometry); // Update once per frame

    if (updateMap.get(buffergeometry) !== frame) {
      geometries.update(buffergeometry);
      updateMap.set(buffergeometry, frame);
    }

    if (object.isInstancedMesh) {
      if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) {
        object.addEventListener('dispose', onInstancedMeshDispose);
      }

      attributes.update(object.instanceMatrix, 34962);

      if (object.instanceColor !== null) {
        attributes.update(object.instanceColor, 34962);
      }
    }

    return buffergeometry;
  }

  function dispose() {
    updateMap = new WeakMap();
  }

  function onInstancedMeshDispose(event) {
    var instancedMesh = event.target;
    instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
    attributes.remove(instancedMesh.instanceMatrix);
    if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
  }

  return {
    update: update,
    dispose: dispose
  };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */


var emptyTexture = new Texture();
var emptyArrayTexture = new DataArrayTexture();
var empty3dTexture = new Data3DTexture();
var emptyCubeTexture = new CubeTexture(); // --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)

var arrayCacheF32 = [];
var arrayCacheI32 = []; // Float32Array caches used for uploading Matrix uniforms

var mat4array = new Float32Array(16);
var mat3array = new Float32Array(9);
var mat2array = new Float32Array(4); // Flattening for arrays of vectors and matrices

function flatten(array, nBlocks, blockSize) {
  var firstElem = array[0];
  if (firstElem <= 0 || firstElem > 0) return array; // unoptimized: ! isNaN( firstElem )
  // see http://jacksondunstan.com/articles/983

  var n = nBlocks * blockSize;
  var r = arrayCacheF32[n];

  if (r === undefined) {
    r = new Float32Array(n);
    arrayCacheF32[n] = r;
  }

  if (nBlocks !== 0) {
    firstElem.toArray(r, 0);

    for (var _i101 = 1, offset = 0; _i101 !== nBlocks; ++_i101) {
      offset += blockSize;

      array[_i101].toArray(r, offset);
    }
  }

  return r;
}

function arraysEqual(a, b) {
  if (a.length !== b.length) return false;

  for (var _i102 = 0, l = a.length; _i102 < l; _i102++) {
    if (a[_i102] !== b[_i102]) return false;
  }

  return true;
}

function copyArray(a, b) {
  for (var _i103 = 0, l = b.length; _i103 < l; _i103++) {
    a[_i103] = b[_i103];
  }
} // Texture unit allocation


function allocTexUnits(textures, n) {
  var r = arrayCacheI32[n];

  if (r === undefined) {
    r = new Int32Array(n);
    arrayCacheI32[n] = r;
  }

  for (var _i104 = 0; _i104 !== n; ++_i104) {
    r[_i104] = textures.allocateTextureUnit();
  }

  return r;
} // --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar


function setValueV1f(gl, v) {
  var cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1f(this.addr, v);
  cache[0] = v;
} // Single float vector (from flat array or THREE.VectorN)


function setValueV2f(gl, v) {
  var cache = this.cache;

  if (v.x !== undefined) {
    if (cache[0] !== v.x || cache[1] !== v.y) {
      gl.uniform2f(this.addr, v.x, v.y);
      cache[0] = v.x;
      cache[1] = v.y;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform2fv(this.addr, v);
    copyArray(cache, v);
  }
}

function setValueV3f(gl, v) {
  var cache = this.cache;

  if (v.x !== undefined) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
      gl.uniform3f(this.addr, v.x, v.y, v.z);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
    }
  } else if (v.r !== undefined) {
    if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
      gl.uniform3f(this.addr, v.r, v.g, v.b);
      cache[0] = v.r;
      cache[1] = v.g;
      cache[2] = v.b;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform3fv(this.addr, v);
    copyArray(cache, v);
  }
}

function setValueV4f(gl, v) {
  var cache = this.cache;

  if (v.x !== undefined) {
    if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
      gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
      cache[0] = v.x;
      cache[1] = v.y;
      cache[2] = v.z;
      cache[3] = v.w;
    }
  } else {
    if (arraysEqual(cache, v)) return;
    gl.uniform4fv(this.addr, v);
    copyArray(cache, v);
  }
} // Single matrix (from flat array or THREE.MatrixN)


function setValueM2(gl, v) {
  var cache = this.cache;
  var elements = v.elements;

  if (elements === undefined) {
    if (arraysEqual(cache, v)) return;
    gl.uniformMatrix2fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat2array.set(elements);
    gl.uniformMatrix2fv(this.addr, false, mat2array);
    copyArray(cache, elements);
  }
}

function setValueM3(gl, v) {
  var cache = this.cache;
  var elements = v.elements;

  if (elements === undefined) {
    if (arraysEqual(cache, v)) return;
    gl.uniformMatrix3fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat3array.set(elements);
    gl.uniformMatrix3fv(this.addr, false, mat3array);
    copyArray(cache, elements);
  }
}

function setValueM4(gl, v) {
  var cache = this.cache;
  var elements = v.elements;

  if (elements === undefined) {
    if (arraysEqual(cache, v)) return;
    gl.uniformMatrix4fv(this.addr, false, v);
    copyArray(cache, v);
  } else {
    if (arraysEqual(cache, elements)) return;
    mat4array.set(elements);
    gl.uniformMatrix4fv(this.addr, false, mat4array);
    copyArray(cache, elements);
  }
} // Single integer / boolean


function setValueV1i(gl, v) {
  var cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1i(this.addr, v);
  cache[0] = v;
} // Single integer / boolean vector (from flat array)


function setValueV2i(gl, v) {
  var cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform2iv(this.addr, v);
  copyArray(cache, v);
}

function setValueV3i(gl, v) {
  var cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform3iv(this.addr, v);
  copyArray(cache, v);
}

function setValueV4i(gl, v) {
  var cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform4iv(this.addr, v);
  copyArray(cache, v);
} // Single unsigned integer


function setValueV1ui(gl, v) {
  var cache = this.cache;
  if (cache[0] === v) return;
  gl.uniform1ui(this.addr, v);
  cache[0] = v;
} // Single unsigned integer vector (from flat array)


function setValueV2ui(gl, v) {
  var cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform2uiv(this.addr, v);
  copyArray(cache, v);
}

function setValueV3ui(gl, v) {
  var cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform3uiv(this.addr, v);
  copyArray(cache, v);
}

function setValueV4ui(gl, v) {
  var cache = this.cache;
  if (arraysEqual(cache, v)) return;
  gl.uniform4uiv(this.addr, v);
  copyArray(cache, v);
} // Single texture (2D / Cube)


function setValueT1(gl, v, textures) {
  var cache = this.cache;
  var unit = textures.allocateTextureUnit();

  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }

  textures.setTexture2D(v || emptyTexture, unit);
}

function setValueT3D1(gl, v, textures) {
  var cache = this.cache;
  var unit = textures.allocateTextureUnit();

  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }

  textures.setTexture3D(v || empty3dTexture, unit);
}

function setValueT6(gl, v, textures) {
  var cache = this.cache;
  var unit = textures.allocateTextureUnit();

  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }

  textures.setTextureCube(v || emptyCubeTexture, unit);
}

function setValueT2DArray1(gl, v, textures) {
  var cache = this.cache;
  var unit = textures.allocateTextureUnit();

  if (cache[0] !== unit) {
    gl.uniform1i(this.addr, unit);
    cache[0] = unit;
  }

  textures.setTexture2DArray(v || emptyArrayTexture, unit);
} // Helper to pick the right setter for the singular case


function getSingularSetter(type) {
  switch (type) {
    case 0x1406:
      return setValueV1f;
    // FLOAT

    case 0x8b50:
      return setValueV2f;
    // _VEC2

    case 0x8b51:
      return setValueV3f;
    // _VEC3

    case 0x8b52:
      return setValueV4f;
    // _VEC4

    case 0x8b5a:
      return setValueM2;
    // _MAT2

    case 0x8b5b:
      return setValueM3;
    // _MAT3

    case 0x8b5c:
      return setValueM4;
    // _MAT4

    case 0x1404:
    case 0x8b56:
      return setValueV1i;
    // INT, BOOL

    case 0x8b53:
    case 0x8b57:
      return setValueV2i;
    // _VEC2

    case 0x8b54:
    case 0x8b58:
      return setValueV3i;
    // _VEC3

    case 0x8b55:
    case 0x8b59:
      return setValueV4i;
    // _VEC4

    case 0x1405:
      return setValueV1ui;
    // UINT

    case 0x8dc6:
      return setValueV2ui;
    // _VEC2

    case 0x8dc7:
      return setValueV3ui;
    // _VEC3

    case 0x8dc8:
      return setValueV4ui;
    // _VEC4

    case 0x8b5e: // SAMPLER_2D

    case 0x8d66: // SAMPLER_EXTERNAL_OES

    case 0x8dca: // INT_SAMPLER_2D

    case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D

    case 0x8b62:
      // SAMPLER_2D_SHADOW
      return setValueT1;

    case 0x8b5f: // SAMPLER_3D

    case 0x8dcb: // INT_SAMPLER_3D

    case 0x8dd3:
      // UNSIGNED_INT_SAMPLER_3D
      return setValueT3D1;

    case 0x8b60: // SAMPLER_CUBE

    case 0x8dcc: // INT_SAMPLER_CUBE

    case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE

    case 0x8dc5:
      // SAMPLER_CUBE_SHADOW
      return setValueT6;

    case 0x8dc1: // SAMPLER_2D_ARRAY

    case 0x8dcf: // INT_SAMPLER_2D_ARRAY

    case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY

    case 0x8dc4:
      // SAMPLER_2D_ARRAY_SHADOW
      return setValueT2DArray1;
  }
} // Array of scalars


function setValueV1fArray(gl, v) {
  gl.uniform1fv(this.addr, v);
} // Array of vectors (from flat array or array of THREE.VectorN)


function setValueV2fArray(gl, v) {
  var data = flatten(v, this.size, 2);
  gl.uniform2fv(this.addr, data);
}

function setValueV3fArray(gl, v) {
  var data = flatten(v, this.size, 3);
  gl.uniform3fv(this.addr, data);
}

function setValueV4fArray(gl, v) {
  var data = flatten(v, this.size, 4);
  gl.uniform4fv(this.addr, data);
} // Array of matrices (from flat array or array of THREE.MatrixN)


function setValueM2Array(gl, v) {
  var data = flatten(v, this.size, 4);
  gl.uniformMatrix2fv(this.addr, false, data);
}

function setValueM3Array(gl, v) {
  var data = flatten(v, this.size, 9);
  gl.uniformMatrix3fv(this.addr, false, data);
}

function setValueM4Array(gl, v) {
  var data = flatten(v, this.size, 16);
  gl.uniformMatrix4fv(this.addr, false, data);
} // Array of integer / boolean


function setValueV1iArray(gl, v) {
  gl.uniform1iv(this.addr, v);
} // Array of integer / boolean vectors (from flat array)


function setValueV2iArray(gl, v) {
  gl.uniform2iv(this.addr, v);
}

function setValueV3iArray(gl, v) {
  gl.uniform3iv(this.addr, v);
}

function setValueV4iArray(gl, v) {
  gl.uniform4iv(this.addr, v);
} // Array of unsigned integer


function setValueV1uiArray(gl, v) {
  gl.uniform1uiv(this.addr, v);
} // Array of unsigned integer vectors (from flat array)


function setValueV2uiArray(gl, v) {
  gl.uniform2uiv(this.addr, v);
}

function setValueV3uiArray(gl, v) {
  gl.uniform3uiv(this.addr, v);
}

function setValueV4uiArray(gl, v) {
  gl.uniform4uiv(this.addr, v);
} // Array of textures (2D / 3D / Cube / 2DArray)


function setValueT1Array(gl, v, textures) {
  var n = v.length;
  var units = allocTexUnits(textures, n);
  gl.uniform1iv(this.addr, units);

  for (var _i105 = 0; _i105 !== n; ++_i105) {
    textures.setTexture2D(v[_i105] || emptyTexture, units[_i105]);
  }
}

function setValueT3DArray(gl, v, textures) {
  var n = v.length;
  var units = allocTexUnits(textures, n);
  gl.uniform1iv(this.addr, units);

  for (var _i106 = 0; _i106 !== n; ++_i106) {
    textures.setTexture3D(v[_i106] || empty3dTexture, units[_i106]);
  }
}

function setValueT6Array(gl, v, textures) {
  var n = v.length;
  var units = allocTexUnits(textures, n);
  gl.uniform1iv(this.addr, units);

  for (var _i107 = 0; _i107 !== n; ++_i107) {
    textures.setTextureCube(v[_i107] || emptyCubeTexture, units[_i107]);
  }
}

function setValueT2DArrayArray(gl, v, textures) {
  var n = v.length;
  var units = allocTexUnits(textures, n);
  gl.uniform1iv(this.addr, units);

  for (var _i108 = 0; _i108 !== n; ++_i108) {
    textures.setTexture2DArray(v[_i108] || emptyArrayTexture, units[_i108]);
  }
} // Helper to pick the right setter for a pure (bottom-level) array


function getPureArraySetter(type) {
  switch (type) {
    case 0x1406:
      return setValueV1fArray;
    // FLOAT

    case 0x8b50:
      return setValueV2fArray;
    // _VEC2

    case 0x8b51:
      return setValueV3fArray;
    // _VEC3

    case 0x8b52:
      return setValueV4fArray;
    // _VEC4

    case 0x8b5a:
      return setValueM2Array;
    // _MAT2

    case 0x8b5b:
      return setValueM3Array;
    // _MAT3

    case 0x8b5c:
      return setValueM4Array;
    // _MAT4

    case 0x1404:
    case 0x8b56:
      return setValueV1iArray;
    // INT, BOOL

    case 0x8b53:
    case 0x8b57:
      return setValueV2iArray;
    // _VEC2

    case 0x8b54:
    case 0x8b58:
      return setValueV3iArray;
    // _VEC3

    case 0x8b55:
    case 0x8b59:
      return setValueV4iArray;
    // _VEC4

    case 0x1405:
      return setValueV1uiArray;
    // UINT

    case 0x8dc6:
      return setValueV2uiArray;
    // _VEC2

    case 0x8dc7:
      return setValueV3uiArray;
    // _VEC3

    case 0x8dc8:
      return setValueV4uiArray;
    // _VEC4

    case 0x8b5e: // SAMPLER_2D

    case 0x8d66: // SAMPLER_EXTERNAL_OES

    case 0x8dca: // INT_SAMPLER_2D

    case 0x8dd2: // UNSIGNED_INT_SAMPLER_2D

    case 0x8b62:
      // SAMPLER_2D_SHADOW
      return setValueT1Array;

    case 0x8b5f: // SAMPLER_3D

    case 0x8dcb: // INT_SAMPLER_3D

    case 0x8dd3:
      // UNSIGNED_INT_SAMPLER_3D
      return setValueT3DArray;

    case 0x8b60: // SAMPLER_CUBE

    case 0x8dcc: // INT_SAMPLER_CUBE

    case 0x8dd4: // UNSIGNED_INT_SAMPLER_CUBE

    case 0x8dc5:
      // SAMPLER_CUBE_SHADOW
      return setValueT6Array;

    case 0x8dc1: // SAMPLER_2D_ARRAY

    case 0x8dcf: // INT_SAMPLER_2D_ARRAY

    case 0x8dd7: // UNSIGNED_INT_SAMPLER_2D_ARRAY

    case 0x8dc4:
      // SAMPLER_2D_ARRAY_SHADOW
      return setValueT2DArrayArray;
  }
} // --- Uniform Classes ---


function SingleUniform(id, activeInfo, addr) {
  this.id = id;
  this.addr = addr;
  this.cache = [];
  this.setValue = getSingularSetter(activeInfo.type); // this.path = activeInfo.name; // DEBUG
}

function PureArrayUniform(id, activeInfo, addr) {
  this.id = id;
  this.addr = addr;
  this.cache = [];
  this.size = activeInfo.size;
  this.setValue = getPureArraySetter(activeInfo.type); // this.path = activeInfo.name; // DEBUG
}

function StructuredUniform(id) {
  this.id = id;
  this.seq = [];
  this.map = {};
}

StructuredUniform.prototype.setValue = function (gl, value, textures) {
  var seq = this.seq;

  for (var _i109 = 0, n = seq.length; _i109 !== n; ++_i109) {
    var u = seq[_i109];
    u.setValue(gl, value[u.id], textures);
  }
}; // --- Top-level ---
// Parser - builds up the property tree from the path strings


var RePathPart = /(\w+)(\])?(\[|\.)?/g; // extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.

function addUniform(container, uniformObject) {
  container.seq.push(uniformObject);
  container.map[uniformObject.id] = uniformObject;
}

function parseUniform(activeInfo, addr, container) {
  var path = activeInfo.name,
      pathLength = path.length; // reset RegExp object, because of the early exit of a previous run

  RePathPart.lastIndex = 0;

  while (true) {
    var match = RePathPart.exec(path),
        matchEnd = RePathPart.lastIndex;
    var id = match[1];
    var idIsIndex = match[2] === ']',
        subscript = match[3];
    if (idIsIndex) id = id | 0; // convert to integer

    if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
      // bare name or "pure" bottom-level array "[0]" suffix
      addUniform(container, subscript === undefined ? new SingleUniform(id, activeInfo, addr) : new PureArrayUniform(id, activeInfo, addr));
      break;
    } else {
      // step into inner node / create it in case it doesn't exist
      var map = container.map;
      var next = map[id];

      if (next === undefined) {
        next = new StructuredUniform(id);
        addUniform(container, next);
      }

      container = next;
    }
  }
} // Root Container


function WebGLUniforms(gl, program) {
  this.seq = [];
  this.map = {};
  var n = gl.getProgramParameter(program, 35718);

  for (var _i110 = 0; _i110 < n; ++_i110) {
    var info = gl.getActiveUniform(program, _i110),
        addr = gl.getUniformLocation(program, info.name);
    parseUniform(info, addr, this);
  }
}

WebGLUniforms.prototype.setValue = function (gl, name, value, textures) {
  var u = this.map[name];
  if (u !== undefined) u.setValue(gl, value, textures);
};

WebGLUniforms.prototype.setOptional = function (gl, object, name) {
  var v = object[name];
  if (v !== undefined) this.setValue(gl, name, v);
}; // Static interface


WebGLUniforms.upload = function (gl, seq, values, textures) {
  for (var _i111 = 0, n = seq.length; _i111 !== n; ++_i111) {
    var u = seq[_i111],
        v = values[u.id];

    if (v.needsUpdate !== false) {
      // note: always updating when .needsUpdate is undefined
      u.setValue(gl, v.value, textures);
    }
  }
};

WebGLUniforms.seqWithValue = function (seq, values) {
  var r = [];

  for (var _i112 = 0, n = seq.length; _i112 !== n; ++_i112) {
    var u = seq[_i112];
    if (u.id in values) r.push(u);
  }

  return r;
};

function WebGLShader(gl, type, string) {
  var shader = gl.createShader(type);
  gl.shaderSource(shader, string);
  gl.compileShader(shader);
  return shader;
}

var programIdCount = 0;

function handleSource(string, errorLine) {
  var lines = string.split('\n');
  var lines2 = [];
  var from = Math.max(errorLine - 6, 0);
  var to = Math.min(errorLine + 6, lines.length);

  for (var _i113 = from; _i113 < to; _i113++) {
    lines2.push(_i113 + 1 + ': ' + lines[_i113]);
  }

  return lines2.join('\n');
}

function getEncodingComponents(encoding) {
  switch (encoding) {
    case LinearEncoding:
      return ['Linear', '( value )'];

    case sRGBEncoding:
      return ['sRGB', '( value )'];

    default:
      console.warn('THREE.WebGLProgram: Unsupported encoding:', encoding);
      return ['Linear', '( value )'];
  }
}

function getShaderErrors(gl, shader, type) {
  var status = gl.getShaderParameter(shader, 35713);
  var errors = gl.getShaderInfoLog(shader).trim();
  if (status && errors === '') return '';
  var errorMatches = /ERROR: 0:(\d+)/.exec(errors);

  if (errorMatches) {
    // --enable-privileged-webgl-extension
    // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
    var errorLine = parseInt(errorMatches[0]);
    return type.toUpperCase() + '\n\n' + errors + '\n\n' + handleSource(gl.getShaderSource(shader), errorLine);
  } else {
    return errors;
  }
}

function getTexelEncodingFunction(functionName, encoding) {
  var components = getEncodingComponents(encoding);
  return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[0] + components[1] + '; }';
}

function getToneMappingFunction(functionName, toneMapping) {
  var toneMappingName;

  switch (toneMapping) {
    case LinearToneMapping:
      toneMappingName = 'Linear';
      break;

    case ReinhardToneMapping:
      toneMappingName = 'Reinhard';
      break;

    case CineonToneMapping:
      toneMappingName = 'OptimizedCineon';
      break;

    case ACESFilmicToneMapping:
      toneMappingName = 'ACESFilmic';
      break;

    case CustomToneMapping:
      toneMappingName = 'Custom';
      break;

    default:
      console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
      toneMappingName = 'Linear';
  }

  return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}

function generateExtensions(parameters) {
  var chunks = [parameters.extensionDerivatives || !!parameters.envMapCubeUVHeight || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '', (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '', parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '', (parameters.extensionShaderTextureLOD || parameters.envMap || parameters.transmission) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''];
  return chunks.filter(filterEmptyLine).join('\n');
}

function generateDefines(defines) {
  var chunks = [];

  for (var name in defines) {
    var _value4 = defines[name];
    if (_value4 === false) continue;
    chunks.push('#define ' + name + ' ' + _value4);
  }

  return chunks.join('\n');
}

function fetchAttributeLocations(gl, program) {
  var attributes = {};
  var n = gl.getProgramParameter(program, 35721);

  for (var _i114 = 0; _i114 < n; _i114++) {
    var info = gl.getActiveAttrib(program, _i114);
    var name = info.name;
    var locationSize = 1;
    if (info.type === 35674) locationSize = 2;
    if (info.type === 35675) locationSize = 3;
    if (info.type === 35676) locationSize = 4; // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );

    attributes[name] = {
      type: info.type,
      location: gl.getAttribLocation(program, name),
      locationSize: locationSize
    };
  }

  return attributes;
}

function filterEmptyLine(string) {
  return string !== '';
}

function replaceLightNums(string, parameters) {
  return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}

function replaceClippingPlaneNums(string, parameters) {
  return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
} // Resolve Includes


var includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;

function resolveIncludes(string) {
  return string.replace(includePattern, includeReplacer);
}

function includeReplacer(match, include) {
  var string = ShaderChunk[include];

  if (string === undefined) {
    throw new Error('Can not resolve #include <' + include + '>');
  }

  return resolveIncludes(string);
} // Unroll Loops


var deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
var unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;

function unrollLoops(string) {
  return string.replace(unrollLoopPattern, loopReplacer).replace(deprecatedUnrollLoopPattern, deprecatedLoopReplacer);
}

function deprecatedLoopReplacer(match, start, end, snippet) {
  console.warn('WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.');
  return loopReplacer(match, start, end, snippet);
}

function loopReplacer(match, start, end, snippet) {
  var string = '';

  for (var _i115 = parseInt(start); _i115 < parseInt(end); _i115++) {
    string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + _i115 + ' ]').replace(/UNROLLED_LOOP_INDEX/g, _i115);
  }

  return string;
} //


function generatePrecision(parameters) {
  var precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';

  if (parameters.precision === 'highp') {
    precisionstring += '\n#define HIGH_PRECISION';
  } else if (parameters.precision === 'mediump') {
    precisionstring += '\n#define MEDIUM_PRECISION';
  } else if (parameters.precision === 'lowp') {
    precisionstring += '\n#define LOW_PRECISION';
  }

  return precisionstring;
}

function generateShadowMapTypeDefine(parameters) {
  var shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';

  if (parameters.shadowMapType === PCFShadowMap) {
    shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
  } else if (parameters.shadowMapType === PCFSoftShadowMap) {
    shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
  } else if (parameters.shadowMapType === VSMShadowMap) {
    shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
  }

  return shadowMapTypeDefine;
}

function generateEnvMapTypeDefine(parameters) {
  var envMapTypeDefine = 'ENVMAP_TYPE_CUBE';

  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeReflectionMapping:
      case CubeRefractionMapping:
        envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
        break;

      case CubeUVReflectionMapping:
        envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
        break;
    }
  }

  return envMapTypeDefine;
}

function generateEnvMapModeDefine(parameters) {
  var envMapModeDefine = 'ENVMAP_MODE_REFLECTION';

  if (parameters.envMap) {
    switch (parameters.envMapMode) {
      case CubeRefractionMapping:
        envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
        break;
    }
  }

  return envMapModeDefine;
}

function generateEnvMapBlendingDefine(parameters) {
  var envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';

  if (parameters.envMap) {
    switch (parameters.combine) {
      case MultiplyOperation:
        envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
        break;

      case MixOperation:
        envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
        break;

      case AddOperation:
        envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
        break;
    }
  }

  return envMapBlendingDefine;
}

function generateCubeUVSize(parameters) {
  var imageHeight = parameters.envMapCubeUVHeight;
  if (imageHeight === null) return null;
  var maxMip = Math.log2(imageHeight) - 2;
  var texelHeight = 1.0 / imageHeight;
  var texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 7 * 16));
  return {
    texelWidth: texelWidth,
    texelHeight: texelHeight,
    maxMip: maxMip
  };
}

function WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
  // TODO Send this event to Three.js DevTools
  // console.log( 'WebGLProgram', cacheKey );
  var gl = renderer.getContext();
  var defines = parameters.defines;
  var vertexShader = parameters.vertexShader;
  var fragmentShader = parameters.fragmentShader;
  var shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
  var envMapTypeDefine = generateEnvMapTypeDefine(parameters);
  var envMapModeDefine = generateEnvMapModeDefine(parameters);
  var envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
  var envMapCubeUVSize = generateCubeUVSize(parameters);
  var customExtensions = parameters.isWebGL2 ? '' : generateExtensions(parameters);
  var customDefines = generateDefines(defines);
  var program = gl.createProgram();
  var prefixVertex, prefixFragment;
  var versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';

  if (parameters.isRawShaderMaterial) {
    prefixVertex = [customDefines].filter(filterEmptyLine).join('\n');

    if (prefixVertex.length > 0) {
      prefixVertex += '\n';
    }

    prefixFragment = [customExtensions, customDefines].filter(filterEmptyLine).join('\n');

    if (prefixFragment.length > 0) {
      prefixFragment += '\n';
    }
  } else {
    prefixVertex = [generatePrecision(parameters), '#define SHADER_NAME ' + parameters.shaderName, customDefines, parameters.instancing ? '#define USE_INSTANCING' : '', parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '', parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '', parameters.useFog && parameters.fog ? '#define USE_FOG' : '', parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '', parameters.map ? '#define USE_MAP' : '', parameters.envMap ? '#define USE_ENVMAP' : '', parameters.envMap ? '#define ' + envMapModeDefine : '', parameters.lightMap ? '#define USE_LIGHTMAP' : '', parameters.aoMap ? '#define USE_AOMAP' : '', parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '', parameters.bumpMap ? '#define USE_BUMPMAP' : '', parameters.normalMap ? '#define USE_NORMALMAP' : '', parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '', parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '', parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '', parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '', parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '', parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '', parameters.specularMap ? '#define USE_SPECULARMAP' : '', parameters.specularIntensityMap ? '#define USE_SPECULARINTENSITYMAP' : '', parameters.specularColorMap ? '#define USE_SPECULARCOLORMAP' : '', parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '', parameters.metalnessMap ? '#define USE_METALNESSMAP' : '', parameters.alphaMap ? '#define USE_ALPHAMAP' : '', parameters.transmission ? '#define USE_TRANSMISSION' : '', parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '', parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '', parameters.sheenColorMap ? '#define USE_SHEENCOLORMAP' : '', parameters.sheenRoughnessMap ? '#define USE_SHEENROUGHNESSMAP' : '', parameters.vertexTangents ? '#define USE_TANGENT' : '', parameters.vertexColors ? '#define USE_COLOR' : '', parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '', parameters.vertexUvs ? '#define USE_UV' : '', parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '', parameters.flatShading ? '#define FLAT_SHADED' : '', parameters.skinning ? '#define USE_SKINNING' : '', parameters.morphTargets ? '#define USE_MORPHTARGETS' : '', parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '', parameters.morphColors && parameters.isWebGL2 ? '#define USE_MORPHCOLORS' : '', parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE' : '', parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '', parameters.morphTargetsCount > 0 && parameters.isWebGL2 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '', parameters.doubleSided ? '#define DOUBLE_SIDED' : '', parameters.flipSided ? '#define FLIP_SIDED' : '', parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '', parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '', parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '', parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '', parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '', 'uniform mat4 modelMatrix;', 'uniform mat4 modelViewMatrix;', 'uniform mat4 projectionMatrix;', 'uniform mat4 viewMatrix;', 'uniform mat3 normalMatrix;', 'uniform vec3 cameraPosition;', 'uniform bool isOrthographic;', '#ifdef USE_INSTANCING', '	attribute mat4 instanceMatrix;', '#endif', '#ifdef USE_INSTANCING_COLOR', '	attribute vec3 instanceColor;', '#endif', 'attribute vec3 position;', 'attribute vec3 normal;', 'attribute vec2 uv;', '#ifdef USE_TANGENT', '	attribute vec4 tangent;', '#endif', '#if defined( USE_COLOR_ALPHA )', '	attribute vec4 color;', '#elif defined( USE_COLOR )', '	attribute vec3 color;', '#endif', '#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )', '	attribute vec3 morphTarget0;', '	attribute vec3 morphTarget1;', '	attribute vec3 morphTarget2;', '	attribute vec3 morphTarget3;', '	#ifdef USE_MORPHNORMALS', '		attribute vec3 morphNormal0;', '		attribute vec3 morphNormal1;', '		attribute vec3 morphNormal2;', '		attribute vec3 morphNormal3;', '	#else', '		attribute vec3 morphTarget4;', '		attribute vec3 morphTarget5;', '		attribute vec3 morphTarget6;', '		attribute vec3 morphTarget7;', '	#endif', '#endif', '#ifdef USE_SKINNING', '	attribute vec4 skinIndex;', '	attribute vec4 skinWeight;', '#endif', '\n'].filter(filterEmptyLine).join('\n');
    prefixFragment = [customExtensions, generatePrecision(parameters), '#define SHADER_NAME ' + parameters.shaderName, customDefines, parameters.useFog && parameters.fog ? '#define USE_FOG' : '', parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '', parameters.map ? '#define USE_MAP' : '', parameters.matcap ? '#define USE_MATCAP' : '', parameters.envMap ? '#define USE_ENVMAP' : '', parameters.envMap ? '#define ' + envMapTypeDefine : '', parameters.envMap ? '#define ' + envMapModeDefine : '', parameters.envMap ? '#define ' + envMapBlendingDefine : '', envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '', envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '', envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '', parameters.lightMap ? '#define USE_LIGHTMAP' : '', parameters.aoMap ? '#define USE_AOMAP' : '', parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '', parameters.bumpMap ? '#define USE_BUMPMAP' : '', parameters.normalMap ? '#define USE_NORMALMAP' : '', parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '', parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '', parameters.clearcoat ? '#define USE_CLEARCOAT' : '', parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '', parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '', parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '', parameters.specularMap ? '#define USE_SPECULARMAP' : '', parameters.specularIntensityMap ? '#define USE_SPECULARINTENSITYMAP' : '', parameters.specularColorMap ? '#define USE_SPECULARCOLORMAP' : '', parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '', parameters.metalnessMap ? '#define USE_METALNESSMAP' : '', parameters.alphaMap ? '#define USE_ALPHAMAP' : '', parameters.alphaTest ? '#define USE_ALPHATEST' : '', parameters.sheen ? '#define USE_SHEEN' : '', parameters.sheenColorMap ? '#define USE_SHEENCOLORMAP' : '', parameters.sheenRoughnessMap ? '#define USE_SHEENROUGHNESSMAP' : '', parameters.transmission ? '#define USE_TRANSMISSION' : '', parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '', parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '', parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '', parameters.vertexTangents ? '#define USE_TANGENT' : '', parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '', parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '', parameters.vertexUvs ? '#define USE_UV' : '', parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '', parameters.gradientMap ? '#define USE_GRADIENTMAP' : '', parameters.flatShading ? '#define FLAT_SHADED' : '', parameters.doubleSided ? '#define DOUBLE_SIDED' : '', parameters.flipSided ? '#define FLIP_SIDED' : '', parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '', parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '', parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '', parameters.physicallyCorrectLights ? '#define PHYSICALLY_CORRECT_LIGHTS' : '', parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '', parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '', 'uniform mat4 viewMatrix;', 'uniform vec3 cameraPosition;', 'uniform bool isOrthographic;', parameters.toneMapping !== NoToneMapping ? '#define TONE_MAPPING' : '', parameters.toneMapping !== NoToneMapping ? ShaderChunk['tonemapping_pars_fragment'] : '', // this code is required here because it is used by the toneMapping() function defined below
    parameters.toneMapping !== NoToneMapping ? getToneMappingFunction('toneMapping', parameters.toneMapping) : '', parameters.dithering ? '#define DITHERING' : '', parameters.opaque ? '#define OPAQUE' : '', ShaderChunk['encodings_pars_fragment'], // this code is required here because it is used by the various encoding/decoding function defined below
    getTexelEncodingFunction('linearToOutputTexel', parameters.outputEncoding), parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '', '\n'].filter(filterEmptyLine).join('\n');
  }

  vertexShader = resolveIncludes(vertexShader);
  vertexShader = replaceLightNums(vertexShader, parameters);
  vertexShader = replaceClippingPlaneNums(vertexShader, parameters);
  fragmentShader = resolveIncludes(fragmentShader);
  fragmentShader = replaceLightNums(fragmentShader, parameters);
  fragmentShader = replaceClippingPlaneNums(fragmentShader, parameters);
  vertexShader = unrollLoops(vertexShader);
  fragmentShader = unrollLoops(fragmentShader);

  if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
    // GLSL 3.0 conversion for built-in materials and ShaderMaterial
    versionString = '#version 300 es\n';
    prefixVertex = ['precision mediump sampler2DArray;', '#define attribute in', '#define varying out', '#define texture2D texture'].join('\n') + '\n' + prefixVertex;
    prefixFragment = ['#define varying in', parameters.glslVersion === GLSL3 ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;', parameters.glslVersion === GLSL3 ? '' : '#define gl_FragColor pc_fragColor', '#define gl_FragDepthEXT gl_FragDepth', '#define texture2D texture', '#define textureCube texture', '#define texture2DProj textureProj', '#define texture2DLodEXT textureLod', '#define texture2DProjLodEXT textureProjLod', '#define textureCubeLodEXT textureLod', '#define texture2DGradEXT textureGrad', '#define texture2DProjGradEXT textureProjGrad', '#define textureCubeGradEXT textureGrad'].join('\n') + '\n' + prefixFragment;
  }

  var vertexGlsl = versionString + prefixVertex + vertexShader;
  var fragmentGlsl = versionString + prefixFragment + fragmentShader; // console.log( '*VERTEX*', vertexGlsl );
  // console.log( '*FRAGMENT*', fragmentGlsl );

  var glVertexShader = WebGLShader(gl, 35633, vertexGlsl);
  var glFragmentShader = WebGLShader(gl, 35632, fragmentGlsl);
  gl.attachShader(program, glVertexShader);
  gl.attachShader(program, glFragmentShader); // Force a particular attribute to index 0.

  if (parameters.index0AttributeName !== undefined) {
    gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
  } else if (parameters.morphTargets === true) {
    // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
  }

  gl.linkProgram(program); // check for link errors

  if (renderer.debug.checkShaderErrors) {
    var programLog = gl.getProgramInfoLog(program).trim();
    var vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
    var fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
    var runnable = true;
    var haveDiagnostics = true;

    if (gl.getProgramParameter(program, 35714) === false) {
      runnable = false;
      var vertexErrors = getShaderErrors(gl, glVertexShader, 'vertex');
      var fragmentErrors = getShaderErrors(gl, glFragmentShader, 'fragment');
      console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, 35715) + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
    } else if (programLog !== '') {
      console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
    } else if (vertexLog === '' || fragmentLog === '') {
      haveDiagnostics = false;
    }

    if (haveDiagnostics) {
      this.diagnostics = {
        runnable: runnable,
        programLog: programLog,
        vertexShader: {
          log: vertexLog,
          prefix: prefixVertex
        },
        fragmentShader: {
          log: fragmentLog,
          prefix: prefixFragment
        }
      };
    }
  } // Clean up
  // Crashes in iOS9 and iOS10. #18402
  // gl.detachShader( program, glVertexShader );
  // gl.detachShader( program, glFragmentShader );


  gl.deleteShader(glVertexShader);
  gl.deleteShader(glFragmentShader); // set up caching for uniform locations

  var cachedUniforms;

  this.getUniforms = function () {
    if (cachedUniforms === undefined) {
      cachedUniforms = new WebGLUniforms(gl, program);
    }

    return cachedUniforms;
  }; // set up caching for attribute locations


  var cachedAttributes;

  this.getAttributes = function () {
    if (cachedAttributes === undefined) {
      cachedAttributes = fetchAttributeLocations(gl, program);
    }

    return cachedAttributes;
  }; // free resource


  this.destroy = function () {
    bindingStates.releaseStatesOfProgram(this);
    gl.deleteProgram(program);
    this.program = undefined;
  }; //


  this.name = parameters.shaderName;
  this.id = programIdCount++;
  this.cacheKey = cacheKey;
  this.usedTimes = 1;
  this.program = program;
  this.vertexShader = glVertexShader;
  this.fragmentShader = glFragmentShader;
  return this;
}

var _id = 0;

var WebGLShaderCache = /*#__PURE__*/function () {
  function WebGLShaderCache() {
    _classCallCheck2(this, WebGLShaderCache);

    this.shaderCache = new Map();
    this.materialCache = new Map();
  }

  _createClass2(WebGLShaderCache, [{
    key: "update",
    value: function update(material) {
      var vertexShader = material.vertexShader;
      var fragmentShader = material.fragmentShader;

      var vertexShaderStage = this._getShaderStage(vertexShader);

      var fragmentShaderStage = this._getShaderStage(fragmentShader);

      var materialShaders = this._getShaderCacheForMaterial(material);

      if (materialShaders.has(vertexShaderStage) === false) {
        materialShaders.add(vertexShaderStage);
        vertexShaderStage.usedTimes++;
      }

      if (materialShaders.has(fragmentShaderStage) === false) {
        materialShaders.add(fragmentShaderStage);
        fragmentShaderStage.usedTimes++;
      }

      return this;
    }
  }, {
    key: "remove",
    value: function remove(material) {
      var materialShaders = this.materialCache.get(material);

      var _iterator = _createForOfIteratorHelper(materialShaders),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var shaderStage = _step.value;
          shaderStage.usedTimes--;
          if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.materialCache.delete(material);
      return this;
    }
  }, {
    key: "getVertexShaderID",
    value: function getVertexShaderID(material) {
      return this._getShaderStage(material.vertexShader).id;
    }
  }, {
    key: "getFragmentShaderID",
    value: function getFragmentShaderID(material) {
      return this._getShaderStage(material.fragmentShader).id;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.shaderCache.clear();
      this.materialCache.clear();
    }
  }, {
    key: "_getShaderCacheForMaterial",
    value: function _getShaderCacheForMaterial(material) {
      var cache = this.materialCache;

      if (cache.has(material) === false) {
        cache.set(material, new Set());
      }

      return cache.get(material);
    }
  }, {
    key: "_getShaderStage",
    value: function _getShaderStage(code) {
      var cache = this.shaderCache;

      if (cache.has(code) === false) {
        var stage = new WebGLShaderStage(code);
        cache.set(code, stage);
      }

      return cache.get(code);
    }
  }]);

  return WebGLShaderCache;
}();

var WebGLShaderStage = function WebGLShaderStage(code) {
  _classCallCheck2(this, WebGLShaderStage);

  this.id = _id++;
  this.code = code;
  this.usedTimes = 0;
};

function WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
  var _programLayers = new Layers();

  var _customShaders = new WebGLShaderCache();

  var programs = [];
  var isWebGL2 = capabilities.isWebGL2;
  var logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
  var vertexTextures = capabilities.vertexTextures;
  var precision = capabilities.precision;
  var shaderIDs = {
    MeshDepthMaterial: 'depth',
    MeshDistanceMaterial: 'distanceRGBA',
    MeshNormalMaterial: 'normal',
    MeshBasicMaterial: 'basic',
    MeshLambertMaterial: 'lambert',
    MeshPhongMaterial: 'phong',
    MeshToonMaterial: 'toon',
    MeshStandardMaterial: 'physical',
    MeshPhysicalMaterial: 'physical',
    MeshMatcapMaterial: 'matcap',
    LineBasicMaterial: 'basic',
    LineDashedMaterial: 'dashed',
    PointsMaterial: 'points',
    ShadowMaterial: 'shadow',
    SpriteMaterial: 'sprite'
  };

  function getParameters(material, lights, shadows, scene, object) {
    var fog = scene.fog;
    var geometry = object.geometry;
    var environment = material.isMeshStandardMaterial ? scene.environment : null;
    var envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
    var envMapCubeUVHeight = !!envMap && envMap.mapping === CubeUVReflectionMapping ? envMap.image.height : null;
    var shaderID = shaderIDs[material.type]; // heuristics to create shader parameters according to lights in the scene
    // (not to blow over maxLights budget)

    if (material.precision !== null) {
      precision = capabilities.getMaxPrecision(material.precision);

      if (precision !== material.precision) {
        console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
      }
    } //


    var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
    var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
    var morphTextureStride = 0;
    if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
    if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
    if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3; //

    var vertexShader, fragmentShader;
    var customVertexShaderID, customFragmentShaderID;

    if (shaderID) {
      var shader = ShaderLib[shaderID];
      vertexShader = shader.vertexShader;
      fragmentShader = shader.fragmentShader;
    } else {
      vertexShader = material.vertexShader;
      fragmentShader = material.fragmentShader;

      _customShaders.update(material);

      customVertexShaderID = _customShaders.getVertexShaderID(material);
      customFragmentShaderID = _customShaders.getFragmentShaderID(material);
    }

    var currentRenderTarget = renderer.getRenderTarget();
    var useAlphaTest = material.alphaTest > 0;
    var useClearcoat = material.clearcoat > 0;
    var parameters = {
      isWebGL2: isWebGL2,
      shaderID: shaderID,
      shaderName: material.type,
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      defines: material.defines,
      customVertexShaderID: customVertexShaderID,
      customFragmentShaderID: customFragmentShaderID,
      isRawShaderMaterial: material.isRawShaderMaterial === true,
      glslVersion: material.glslVersion,
      precision: precision,
      instancing: object.isInstancedMesh === true,
      instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
      supportsVertexTextures: vertexTextures,
      outputEncoding: currentRenderTarget === null ? renderer.outputEncoding : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.encoding : LinearEncoding,
      map: !!material.map,
      matcap: !!material.matcap,
      envMap: !!envMap,
      envMapMode: envMap && envMap.mapping,
      envMapCubeUVHeight: envMapCubeUVHeight,
      lightMap: !!material.lightMap,
      aoMap: !!material.aoMap,
      emissiveMap: !!material.emissiveMap,
      bumpMap: !!material.bumpMap,
      normalMap: !!material.normalMap,
      objectSpaceNormalMap: material.normalMapType === ObjectSpaceNormalMap,
      tangentSpaceNormalMap: material.normalMapType === TangentSpaceNormalMap,
      decodeVideoTexture: !!material.map && material.map.isVideoTexture === true && material.map.encoding === sRGBEncoding,
      clearcoat: useClearcoat,
      clearcoatMap: useClearcoat && !!material.clearcoatMap,
      clearcoatRoughnessMap: useClearcoat && !!material.clearcoatRoughnessMap,
      clearcoatNormalMap: useClearcoat && !!material.clearcoatNormalMap,
      displacementMap: !!material.displacementMap,
      roughnessMap: !!material.roughnessMap,
      metalnessMap: !!material.metalnessMap,
      specularMap: !!material.specularMap,
      specularIntensityMap: !!material.specularIntensityMap,
      specularColorMap: !!material.specularColorMap,
      opaque: material.transparent === false && material.blending === NormalBlending,
      alphaMap: !!material.alphaMap,
      alphaTest: useAlphaTest,
      gradientMap: !!material.gradientMap,
      sheen: material.sheen > 0,
      sheenColorMap: !!material.sheenColorMap,
      sheenRoughnessMap: !!material.sheenRoughnessMap,
      transmission: material.transmission > 0,
      transmissionMap: !!material.transmissionMap,
      thicknessMap: !!material.thicknessMap,
      combine: material.combine,
      vertexTangents: !!material.normalMap && !!geometry.attributes.tangent,
      vertexColors: material.vertexColors,
      vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
      vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.displacementMap || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || !!material.sheenColorMap || !!material.sheenRoughnessMap,
      uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || material.transmission > 0 || !!material.transmissionMap || !!material.thicknessMap || !!material.specularIntensityMap || !!material.specularColorMap || material.sheen > 0 || !!material.sheenColorMap || !!material.sheenRoughnessMap) && !!material.displacementMap,
      fog: !!fog,
      useFog: material.fog === true,
      fogExp2: fog && fog.isFogExp2,
      flatShading: !!material.flatShading,
      sizeAttenuation: material.sizeAttenuation,
      logarithmicDepthBuffer: logarithmicDepthBuffer,
      skinning: object.isSkinnedMesh === true,
      morphTargets: geometry.morphAttributes.position !== undefined,
      morphNormals: geometry.morphAttributes.normal !== undefined,
      morphColors: geometry.morphAttributes.color !== undefined,
      morphTargetsCount: morphTargetsCount,
      morphTextureStride: morphTextureStride,
      numDirLights: lights.directional.length,
      numPointLights: lights.point.length,
      numSpotLights: lights.spot.length,
      numRectAreaLights: lights.rectArea.length,
      numHemiLights: lights.hemi.length,
      numDirLightShadows: lights.directionalShadowMap.length,
      numPointLightShadows: lights.pointShadowMap.length,
      numSpotLightShadows: lights.spotShadowMap.length,
      numClippingPlanes: clipping.numPlanes,
      numClipIntersection: clipping.numIntersection,
      dithering: material.dithering,
      shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
      shadowMapType: renderer.shadowMap.type,
      toneMapping: material.toneMapped ? renderer.toneMapping : NoToneMapping,
      physicallyCorrectLights: renderer.physicallyCorrectLights,
      premultipliedAlpha: material.premultipliedAlpha,
      doubleSided: material.side === DoubleSide,
      flipSided: material.side === BackSide,
      useDepthPacking: !!material.depthPacking,
      depthPacking: material.depthPacking || 0,
      index0AttributeName: material.index0AttributeName,
      extensionDerivatives: material.extensions && material.extensions.derivatives,
      extensionFragDepth: material.extensions && material.extensions.fragDepth,
      extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
      extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
      rendererExtensionFragDepth: isWebGL2 || extensions.has('EXT_frag_depth'),
      rendererExtensionDrawBuffers: isWebGL2 || extensions.has('WEBGL_draw_buffers'),
      rendererExtensionShaderTextureLod: isWebGL2 || extensions.has('EXT_shader_texture_lod'),
      customProgramCacheKey: material.customProgramCacheKey()
    };
    return parameters;
  }

  function getProgramCacheKey(parameters) {
    var array = [];

    if (parameters.shaderID) {
      array.push(parameters.shaderID);
    } else {
      array.push(parameters.customVertexShaderID);
      array.push(parameters.customFragmentShaderID);
    }

    if (parameters.defines !== undefined) {
      for (var name in parameters.defines) {
        array.push(name);
        array.push(parameters.defines[name]);
      }
    }

    if (parameters.isRawShaderMaterial === false) {
      getProgramCacheKeyParameters(array, parameters);
      getProgramCacheKeyBooleans(array, parameters);
      array.push(renderer.outputEncoding);
    }

    array.push(parameters.customProgramCacheKey);
    return array.join();
  }

  function getProgramCacheKeyParameters(array, parameters) {
    array.push(parameters.precision);
    array.push(parameters.outputEncoding);
    array.push(parameters.envMapMode);
    array.push(parameters.envMapCubeUVHeight);
    array.push(parameters.combine);
    array.push(parameters.vertexUvs);
    array.push(parameters.fogExp2);
    array.push(parameters.sizeAttenuation);
    array.push(parameters.morphTargetsCount);
    array.push(parameters.morphAttributeCount);
    array.push(parameters.numDirLights);
    array.push(parameters.numPointLights);
    array.push(parameters.numSpotLights);
    array.push(parameters.numHemiLights);
    array.push(parameters.numRectAreaLights);
    array.push(parameters.numDirLightShadows);
    array.push(parameters.numPointLightShadows);
    array.push(parameters.numSpotLightShadows);
    array.push(parameters.shadowMapType);
    array.push(parameters.toneMapping);
    array.push(parameters.numClippingPlanes);
    array.push(parameters.numClipIntersection);
    array.push(parameters.depthPacking);
  }

  function getProgramCacheKeyBooleans(array, parameters) {
    _programLayers.disableAll();

    if (parameters.isWebGL2) _programLayers.enable(0);
    if (parameters.supportsVertexTextures) _programLayers.enable(1);
    if (parameters.instancing) _programLayers.enable(2);
    if (parameters.instancingColor) _programLayers.enable(3);
    if (parameters.map) _programLayers.enable(4);
    if (parameters.matcap) _programLayers.enable(5);
    if (parameters.envMap) _programLayers.enable(6);
    if (parameters.lightMap) _programLayers.enable(7);
    if (parameters.aoMap) _programLayers.enable(8);
    if (parameters.emissiveMap) _programLayers.enable(9);
    if (parameters.bumpMap) _programLayers.enable(10);
    if (parameters.normalMap) _programLayers.enable(11);
    if (parameters.objectSpaceNormalMap) _programLayers.enable(12);
    if (parameters.tangentSpaceNormalMap) _programLayers.enable(13);
    if (parameters.clearcoat) _programLayers.enable(14);
    if (parameters.clearcoatMap) _programLayers.enable(15);
    if (parameters.clearcoatRoughnessMap) _programLayers.enable(16);
    if (parameters.clearcoatNormalMap) _programLayers.enable(17);
    if (parameters.displacementMap) _programLayers.enable(18);
    if (parameters.specularMap) _programLayers.enable(19);
    if (parameters.roughnessMap) _programLayers.enable(20);
    if (parameters.metalnessMap) _programLayers.enable(21);
    if (parameters.gradientMap) _programLayers.enable(22);
    if (parameters.alphaMap) _programLayers.enable(23);
    if (parameters.alphaTest) _programLayers.enable(24);
    if (parameters.vertexColors) _programLayers.enable(25);
    if (parameters.vertexAlphas) _programLayers.enable(26);
    if (parameters.vertexUvs) _programLayers.enable(27);
    if (parameters.vertexTangents) _programLayers.enable(28);
    if (parameters.uvsVertexOnly) _programLayers.enable(29);
    if (parameters.fog) _programLayers.enable(30);
    array.push(_programLayers.mask);

    _programLayers.disableAll();

    if (parameters.useFog) _programLayers.enable(0);
    if (parameters.flatShading) _programLayers.enable(1);
    if (parameters.logarithmicDepthBuffer) _programLayers.enable(2);
    if (parameters.skinning) _programLayers.enable(3);
    if (parameters.morphTargets) _programLayers.enable(4);
    if (parameters.morphNormals) _programLayers.enable(5);
    if (parameters.morphColors) _programLayers.enable(6);
    if (parameters.premultipliedAlpha) _programLayers.enable(7);
    if (parameters.shadowMapEnabled) _programLayers.enable(8);
    if (parameters.physicallyCorrectLights) _programLayers.enable(9);
    if (parameters.doubleSided) _programLayers.enable(10);
    if (parameters.flipSided) _programLayers.enable(11);
    if (parameters.useDepthPacking) _programLayers.enable(12);
    if (parameters.dithering) _programLayers.enable(13);
    if (parameters.specularIntensityMap) _programLayers.enable(14);
    if (parameters.specularColorMap) _programLayers.enable(15);
    if (parameters.transmission) _programLayers.enable(16);
    if (parameters.transmissionMap) _programLayers.enable(17);
    if (parameters.thicknessMap) _programLayers.enable(18);
    if (parameters.sheen) _programLayers.enable(19);
    if (parameters.sheenColorMap) _programLayers.enable(20);
    if (parameters.sheenRoughnessMap) _programLayers.enable(21);
    if (parameters.decodeVideoTexture) _programLayers.enable(22);
    if (parameters.opaque) _programLayers.enable(23);
    array.push(_programLayers.mask);
  }

  function getUniforms(material) {
    var shaderID = shaderIDs[material.type];
    var uniforms;

    if (shaderID) {
      var shader = ShaderLib[shaderID];
      uniforms = UniformsUtils.clone(shader.uniforms);
    } else {
      uniforms = material.uniforms;
    }

    return uniforms;
  }

  function acquireProgram(parameters, cacheKey) {
    var program; // Check if code has been already compiled

    for (var p = 0, pl = programs.length; p < pl; p++) {
      var preexistingProgram = programs[p];

      if (preexistingProgram.cacheKey === cacheKey) {
        program = preexistingProgram;
        ++program.usedTimes;
        break;
      }
    }

    if (program === undefined) {
      program = new WebGLProgram(renderer, cacheKey, parameters, bindingStates);
      programs.push(program);
    }

    return program;
  }

  function releaseProgram(program) {
    if (--program.usedTimes === 0) {
      // Remove from unordered set
      var _i116 = programs.indexOf(program);

      programs[_i116] = programs[programs.length - 1];
      programs.pop(); // Free WebGL resources

      program.destroy();
    }
  }

  function releaseShaderCache(material) {
    _customShaders.remove(material);
  }

  function dispose() {
    _customShaders.dispose();
  }

  return {
    getParameters: getParameters,
    getProgramCacheKey: getProgramCacheKey,
    getUniforms: getUniforms,
    acquireProgram: acquireProgram,
    releaseProgram: releaseProgram,
    releaseShaderCache: releaseShaderCache,
    // Exposed for resource monitoring & error feedback via renderer.info:
    programs: programs,
    dispose: dispose
  };
}

function WebGLProperties() {
  var properties = new WeakMap();

  function get(object) {
    var map = properties.get(object);

    if (map === undefined) {
      map = {};
      properties.set(object, map);
    }

    return map;
  }

  function remove(object) {
    properties.delete(object);
  }

  function update(object, key, value) {
    properties.get(object)[key] = value;
  }

  function dispose() {
    properties = new WeakMap();
  }

  return {
    get: get,
    remove: remove,
    update: update,
    dispose: dispose
  };
}

function painterSortStable(a, b) {
  if (a.groupOrder !== b.groupOrder) {
    return a.groupOrder - b.groupOrder;
  } else if (a.renderOrder !== b.renderOrder) {
    return a.renderOrder - b.renderOrder;
  } else if (a.material.id !== b.material.id) {
    return a.material.id - b.material.id;
  } else if (a.z !== b.z) {
    return a.z - b.z;
  } else {
    return a.id - b.id;
  }
}

function reversePainterSortStable(a, b) {
  if (a.groupOrder !== b.groupOrder) {
    return a.groupOrder - b.groupOrder;
  } else if (a.renderOrder !== b.renderOrder) {
    return a.renderOrder - b.renderOrder;
  } else if (a.z !== b.z) {
    return b.z - a.z;
  } else {
    return a.id - b.id;
  }
}

function WebGLRenderList() {
  var renderItems = [];
  var renderItemsIndex = 0;
  var opaque = [];
  var transmissive = [];
  var transparent = [];

  function init() {
    renderItemsIndex = 0;
    opaque.length = 0;
    transmissive.length = 0;
    transparent.length = 0;
  }

  function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
    var renderItem = renderItems[renderItemsIndex];

    if (renderItem === undefined) {
      renderItem = {
        id: object.id,
        object: object,
        geometry: geometry,
        material: material,
        groupOrder: groupOrder,
        renderOrder: object.renderOrder,
        z: z,
        group: group
      };
      renderItems[renderItemsIndex] = renderItem;
    } else {
      renderItem.id = object.id;
      renderItem.object = object;
      renderItem.geometry = geometry;
      renderItem.material = material;
      renderItem.groupOrder = groupOrder;
      renderItem.renderOrder = object.renderOrder;
      renderItem.z = z;
      renderItem.group = group;
    }

    renderItemsIndex++;
    return renderItem;
  }

  function push(object, geometry, material, groupOrder, z, group) {
    var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);

    if (material.transmission > 0.0) {
      transmissive.push(renderItem);
    } else if (material.transparent === true) {
      transparent.push(renderItem);
    } else {
      opaque.push(renderItem);
    }
  }

  function unshift(object, geometry, material, groupOrder, z, group) {
    var renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);

    if (material.transmission > 0.0) {
      transmissive.unshift(renderItem);
    } else if (material.transparent === true) {
      transparent.unshift(renderItem);
    } else {
      opaque.unshift(renderItem);
    }
  }

  function sort(customOpaqueSort, customTransparentSort) {
    if (opaque.length > 1) opaque.sort(customOpaqueSort || painterSortStable);
    if (transmissive.length > 1) transmissive.sort(customTransparentSort || reversePainterSortStable);
    if (transparent.length > 1) transparent.sort(customTransparentSort || reversePainterSortStable);
  }

  function finish() {
    // Clear references from inactive renderItems in the list
    for (var _i117 = renderItemsIndex, il = renderItems.length; _i117 < il; _i117++) {
      var renderItem = renderItems[_i117];
      if (renderItem.id === null) break;
      renderItem.id = null;
      renderItem.object = null;
      renderItem.geometry = null;
      renderItem.material = null;
      renderItem.group = null;
    }
  }

  return {
    opaque: opaque,
    transmissive: transmissive,
    transparent: transparent,
    init: init,
    push: push,
    unshift: unshift,
    finish: finish,
    sort: sort
  };
}

function WebGLRenderLists() {
  var lists = new WeakMap();

  function get(scene, renderCallDepth) {
    var list;

    if (lists.has(scene) === false) {
      list = new WebGLRenderList();
      lists.set(scene, [list]);
    } else {
      if (renderCallDepth >= lists.get(scene).length) {
        list = new WebGLRenderList();
        lists.get(scene).push(list);
      } else {
        list = lists.get(scene)[renderCallDepth];
      }
    }

    return list;
  }

  function dispose() {
    lists = new WeakMap();
  }

  return {
    get: get,
    dispose: dispose
  };
}

function UniformsCache() {
  var lights = {};
  return {
    get: function get(light) {
      if (lights[light.id] !== undefined) {
        return lights[light.id];
      }

      var uniforms;

      switch (light.type) {
        case 'DirectionalLight':
          uniforms = {
            direction: new Vector3(),
            color: new Color()
          };
          break;

        case 'SpotLight':
          uniforms = {
            position: new Vector3(),
            direction: new Vector3(),
            color: new Color(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;

        case 'PointLight':
          uniforms = {
            position: new Vector3(),
            color: new Color(),
            distance: 0,
            decay: 0
          };
          break;

        case 'HemisphereLight':
          uniforms = {
            direction: new Vector3(),
            skyColor: new Color(),
            groundColor: new Color()
          };
          break;

        case 'RectAreaLight':
          uniforms = {
            color: new Color(),
            position: new Vector3(),
            halfWidth: new Vector3(),
            halfHeight: new Vector3()
          };
          break;
      }

      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}

function ShadowUniformsCache() {
  var lights = {};
  return {
    get: function get(light) {
      if (lights[light.id] !== undefined) {
        return lights[light.id];
      }

      var uniforms;

      switch (light.type) {
        case 'DirectionalLight':
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2()
          };
          break;

        case 'SpotLight':
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2()
          };
          break;

        case 'PointLight':
          uniforms = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Vector2(),
            shadowCameraNear: 1,
            shadowCameraFar: 1000
          };
          break;
        // TODO (abelnation): set RectAreaLight shadow uniforms
      }

      lights[light.id] = uniforms;
      return uniforms;
    }
  };
}

var nextVersion = 0;

function shadowCastingLightsFirst(lightA, lightB) {
  return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}

function WebGLLights(extensions, capabilities) {
  var cache = new UniformsCache();
  var shadowCache = ShadowUniformsCache();
  var state = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotShadow: [],
    spotShadowMap: [],
    spotShadowMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: []
  };

  for (var _i118 = 0; _i118 < 9; _i118++) {
    state.probe.push(new Vector3());
  }

  var vector3 = new Vector3();
  var matrix4 = new Matrix4();
  var matrix42 = new Matrix4();

  function setup(lights, physicallyCorrectLights) {
    var r = 0,
        g = 0,
        b = 0;

    for (var _i119 = 0; _i119 < 9; _i119++) {
      state.probe[_i119].set(0, 0, 0);
    }

    var directionalLength = 0;
    var pointLength = 0;
    var spotLength = 0;
    var rectAreaLength = 0;
    var hemiLength = 0;
    var numDirectionalShadows = 0;
    var numPointShadows = 0;
    var numSpotShadows = 0;
    lights.sort(shadowCastingLightsFirst); // artist-friendly light intensity scaling factor

    var scaleFactor = physicallyCorrectLights !== true ? Math.PI : 1;

    for (var _i120 = 0, l = lights.length; _i120 < l; _i120++) {
      var light = lights[_i120];
      var color = light.color;
      var intensity = light.intensity;
      var distance = light.distance;
      var shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;

      if (light.isAmbientLight) {
        r += color.r * intensity * scaleFactor;
        g += color.g * intensity * scaleFactor;
        b += color.b * intensity * scaleFactor;
      } else if (light.isLightProbe) {
        for (var j = 0; j < 9; j++) {
          state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
        }
      } else if (light.isDirectionalLight) {
        var uniforms = cache.get(light);
        uniforms.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);

        if (light.castShadow) {
          var shadow = light.shadow;
          var shadowUniforms = shadowCache.get(light);
          shadowUniforms.shadowBias = shadow.bias;
          shadowUniforms.shadowNormalBias = shadow.normalBias;
          shadowUniforms.shadowRadius = shadow.radius;
          shadowUniforms.shadowMapSize = shadow.mapSize;
          state.directionalShadow[directionalLength] = shadowUniforms;
          state.directionalShadowMap[directionalLength] = shadowMap;
          state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
          numDirectionalShadows++;
        }

        state.directional[directionalLength] = uniforms;
        directionalLength++;
      } else if (light.isSpotLight) {
        var _uniforms = cache.get(light);

        _uniforms.position.setFromMatrixPosition(light.matrixWorld);

        _uniforms.color.copy(color).multiplyScalar(intensity * scaleFactor);

        _uniforms.distance = distance;
        _uniforms.coneCos = Math.cos(light.angle);
        _uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
        _uniforms.decay = light.decay;

        if (light.castShadow) {
          var _shadow = light.shadow;

          var _shadowUniforms = shadowCache.get(light);

          _shadowUniforms.shadowBias = _shadow.bias;
          _shadowUniforms.shadowNormalBias = _shadow.normalBias;
          _shadowUniforms.shadowRadius = _shadow.radius;
          _shadowUniforms.shadowMapSize = _shadow.mapSize;
          state.spotShadow[spotLength] = _shadowUniforms;
          state.spotShadowMap[spotLength] = shadowMap;
          state.spotShadowMatrix[spotLength] = light.shadow.matrix;
          numSpotShadows++;
        }

        state.spot[spotLength] = _uniforms;
        spotLength++;
      } else if (light.isRectAreaLight) {
        var _uniforms2 = cache.get(light); // (a) intensity is the total visible light emitted
        //uniforms.color.copy( color ).multiplyScalar( intensity / ( light.width * light.height * Math.PI ) );
        // (b) intensity is the brightness of the light


        _uniforms2.color.copy(color).multiplyScalar(intensity);

        _uniforms2.halfWidth.set(light.width * 0.5, 0.0, 0.0);

        _uniforms2.halfHeight.set(0.0, light.height * 0.5, 0.0);

        state.rectArea[rectAreaLength] = _uniforms2;
        rectAreaLength++;
      } else if (light.isPointLight) {
        var _uniforms3 = cache.get(light);

        _uniforms3.color.copy(light.color).multiplyScalar(light.intensity * scaleFactor);

        _uniforms3.distance = light.distance;
        _uniforms3.decay = light.decay;

        if (light.castShadow) {
          var _shadow2 = light.shadow;

          var _shadowUniforms2 = shadowCache.get(light);

          _shadowUniforms2.shadowBias = _shadow2.bias;
          _shadowUniforms2.shadowNormalBias = _shadow2.normalBias;
          _shadowUniforms2.shadowRadius = _shadow2.radius;
          _shadowUniforms2.shadowMapSize = _shadow2.mapSize;
          _shadowUniforms2.shadowCameraNear = _shadow2.camera.near;
          _shadowUniforms2.shadowCameraFar = _shadow2.camera.far;
          state.pointShadow[pointLength] = _shadowUniforms2;
          state.pointShadowMap[pointLength] = shadowMap;
          state.pointShadowMatrix[pointLength] = light.shadow.matrix;
          numPointShadows++;
        }

        state.point[pointLength] = _uniforms3;
        pointLength++;
      } else if (light.isHemisphereLight) {
        var _uniforms4 = cache.get(light);

        _uniforms4.skyColor.copy(light.color).multiplyScalar(intensity * scaleFactor);

        _uniforms4.groundColor.copy(light.groundColor).multiplyScalar(intensity * scaleFactor);

        state.hemi[hemiLength] = _uniforms4;
        hemiLength++;
      }
    }

    if (rectAreaLength > 0) {
      if (capabilities.isWebGL2) {
        // WebGL 2
        state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
        state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
      } else {
        // WebGL 1
        if (extensions.has('OES_texture_float_linear') === true) {
          state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
          state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
        } else if (extensions.has('OES_texture_half_float_linear') === true) {
          state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
          state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;
        } else {
          console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
        }
      }
    }

    state.ambient[0] = r;
    state.ambient[1] = g;
    state.ambient[2] = b;
    var hash = state.hash;

    if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
      state.directional.length = directionalLength;
      state.spot.length = spotLength;
      state.rectArea.length = rectAreaLength;
      state.point.length = pointLength;
      state.hemi.length = hemiLength;
      state.directionalShadow.length = numDirectionalShadows;
      state.directionalShadowMap.length = numDirectionalShadows;
      state.pointShadow.length = numPointShadows;
      state.pointShadowMap.length = numPointShadows;
      state.spotShadow.length = numSpotShadows;
      state.spotShadowMap.length = numSpotShadows;
      state.directionalShadowMatrix.length = numDirectionalShadows;
      state.pointShadowMatrix.length = numPointShadows;
      state.spotShadowMatrix.length = numSpotShadows;
      hash.directionalLength = directionalLength;
      hash.pointLength = pointLength;
      hash.spotLength = spotLength;
      hash.rectAreaLength = rectAreaLength;
      hash.hemiLength = hemiLength;
      hash.numDirectionalShadows = numDirectionalShadows;
      hash.numPointShadows = numPointShadows;
      hash.numSpotShadows = numSpotShadows;
      state.version = nextVersion++;
    }
  }

  function setupView(lights, camera) {
    var directionalLength = 0;
    var pointLength = 0;
    var spotLength = 0;
    var rectAreaLength = 0;
    var hemiLength = 0;
    var viewMatrix = camera.matrixWorldInverse;

    for (var _i121 = 0, l = lights.length; _i121 < l; _i121++) {
      var light = lights[_i121];

      if (light.isDirectionalLight) {
        var uniforms = state.directional[directionalLength];
        uniforms.direction.setFromMatrixPosition(light.matrixWorld);
        vector3.setFromMatrixPosition(light.target.matrixWorld);
        uniforms.direction.sub(vector3);
        uniforms.direction.transformDirection(viewMatrix);
        directionalLength++;
      } else if (light.isSpotLight) {
        var _uniforms5 = state.spot[spotLength];

        _uniforms5.position.setFromMatrixPosition(light.matrixWorld);

        _uniforms5.position.applyMatrix4(viewMatrix);

        _uniforms5.direction.setFromMatrixPosition(light.matrixWorld);

        vector3.setFromMatrixPosition(light.target.matrixWorld);

        _uniforms5.direction.sub(vector3);

        _uniforms5.direction.transformDirection(viewMatrix);

        spotLength++;
      } else if (light.isRectAreaLight) {
        var _uniforms6 = state.rectArea[rectAreaLength];

        _uniforms6.position.setFromMatrixPosition(light.matrixWorld);

        _uniforms6.position.applyMatrix4(viewMatrix); // extract local rotation of light to derive width/height half vectors


        matrix42.identity();
        matrix4.copy(light.matrixWorld);
        matrix4.premultiply(viewMatrix);
        matrix42.extractRotation(matrix4);

        _uniforms6.halfWidth.set(light.width * 0.5, 0.0, 0.0);

        _uniforms6.halfHeight.set(0.0, light.height * 0.5, 0.0);

        _uniforms6.halfWidth.applyMatrix4(matrix42);

        _uniforms6.halfHeight.applyMatrix4(matrix42);

        rectAreaLength++;
      } else if (light.isPointLight) {
        var _uniforms7 = state.point[pointLength];

        _uniforms7.position.setFromMatrixPosition(light.matrixWorld);

        _uniforms7.position.applyMatrix4(viewMatrix);

        pointLength++;
      } else if (light.isHemisphereLight) {
        var _uniforms8 = state.hemi[hemiLength];

        _uniforms8.direction.setFromMatrixPosition(light.matrixWorld);

        _uniforms8.direction.transformDirection(viewMatrix);

        hemiLength++;
      }
    }
  }

  return {
    setup: setup,
    setupView: setupView,
    state: state
  };
}

function WebGLRenderState(extensions, capabilities) {
  var lights = new WebGLLights(extensions, capabilities);
  var lightsArray = [];
  var shadowsArray = [];

  function init() {
    lightsArray.length = 0;
    shadowsArray.length = 0;
  }

  function pushLight(light) {
    lightsArray.push(light);
  }

  function pushShadow(shadowLight) {
    shadowsArray.push(shadowLight);
  }

  function setupLights(physicallyCorrectLights) {
    lights.setup(lightsArray, physicallyCorrectLights);
  }

  function setupLightsView(camera) {
    lights.setupView(lightsArray, camera);
  }

  var state = {
    lightsArray: lightsArray,
    shadowsArray: shadowsArray,
    lights: lights
  };
  return {
    init: init,
    state: state,
    setupLights: setupLights,
    setupLightsView: setupLightsView,
    pushLight: pushLight,
    pushShadow: pushShadow
  };
}

function WebGLRenderStates(extensions, capabilities) {
  var renderStates = new WeakMap();

  function get(scene) {
    var renderCallDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var renderState;

    if (renderStates.has(scene) === false) {
      renderState = new WebGLRenderState(extensions, capabilities);
      renderStates.set(scene, [renderState]);
    } else {
      if (renderCallDepth >= renderStates.get(scene).length) {
        renderState = new WebGLRenderState(extensions, capabilities);
        renderStates.get(scene).push(renderState);
      } else {
        renderState = renderStates.get(scene)[renderCallDepth];
      }
    }

    return renderState;
  }

  function dispose() {
    renderStates = new WeakMap();
  }

  return {
    get: get,
    dispose: dispose
  };
}

var MeshDepthMaterial = /*#__PURE__*/function (_Material3) {
  _inherits(MeshDepthMaterial, _Material3);

  var _super23 = _createSuper(MeshDepthMaterial);

  function MeshDepthMaterial(parameters) {
    var _this20;

    _classCallCheck2(this, MeshDepthMaterial);

    _this20 = _super23.call(this);
    _this20.type = 'MeshDepthMaterial';
    _this20.depthPacking = BasicDepthPacking;
    _this20.map = null;
    _this20.alphaMap = null;
    _this20.displacementMap = null;
    _this20.displacementScale = 1;
    _this20.displacementBias = 0;
    _this20.wireframe = false;
    _this20.wireframeLinewidth = 1;

    _this20.setValues(parameters);

    return _this20;
  }

  _createClass2(MeshDepthMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(MeshDepthMaterial.prototype), "copy", this).call(this, source);

      this.depthPacking = source.depthPacking;
      this.map = source.map;
      this.alphaMap = source.alphaMap;
      this.displacementMap = source.displacementMap;
      this.displacementScale = source.displacementScale;
      this.displacementBias = source.displacementBias;
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      return this;
    }
  }]);

  return MeshDepthMaterial;
}(Material);

MeshDepthMaterial.prototype.isMeshDepthMaterial = true;

var MeshDistanceMaterial = /*#__PURE__*/function (_Material4) {
  _inherits(MeshDistanceMaterial, _Material4);

  var _super24 = _createSuper(MeshDistanceMaterial);

  function MeshDistanceMaterial(parameters) {
    var _this21;

    _classCallCheck2(this, MeshDistanceMaterial);

    _this21 = _super24.call(this);
    _this21.type = 'MeshDistanceMaterial';
    _this21.referencePosition = new Vector3();
    _this21.nearDistance = 1;
    _this21.farDistance = 1000;
    _this21.map = null;
    _this21.alphaMap = null;
    _this21.displacementMap = null;
    _this21.displacementScale = 1;
    _this21.displacementBias = 0;

    _this21.setValues(parameters);

    return _this21;
  }

  _createClass2(MeshDistanceMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(MeshDistanceMaterial.prototype), "copy", this).call(this, source);

      this.referencePosition.copy(source.referencePosition);
      this.nearDistance = source.nearDistance;
      this.farDistance = source.farDistance;
      this.map = source.map;
      this.alphaMap = source.alphaMap;
      this.displacementMap = source.displacementMap;
      this.displacementScale = source.displacementScale;
      this.displacementBias = source.displacementBias;
      return this;
    }
  }]);

  return MeshDistanceMaterial;
}(Material);

MeshDistanceMaterial.prototype.isMeshDistanceMaterial = true;
var vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
var fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";

function WebGLShadowMap(_renderer, _objects, _capabilities) {
  var _frustum = new Frustum();

  var _shadowMapSize = new Vector2(),
      _viewportSize = new Vector2(),
      _viewport = new Vector4(),
      _depthMaterial = new MeshDepthMaterial({
    depthPacking: RGBADepthPacking
  }),
      _distanceMaterial = new MeshDistanceMaterial(),
      _materialCache = {},
      _maxTextureSize = _capabilities.maxTextureSize;

  var shadowSide = {
    0: BackSide,
    1: FrontSide,
    2: DoubleSide
  };
  var shadowMaterialVertical = new ShaderMaterial({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: {
        value: null
      },
      resolution: {
        value: new Vector2()
      },
      radius: {
        value: 4.0
      }
    },
    vertexShader: vertex,
    fragmentShader: fragment
  });
  var shadowMaterialHorizontal = shadowMaterialVertical.clone();
  shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
  var fullScreenTri = new BufferGeometry();
  fullScreenTri.setAttribute('position', new BufferAttribute(new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]), 3));
  var fullScreenMesh = new Mesh(fullScreenTri, shadowMaterialVertical);
  var scope = this;
  this.enabled = false;
  this.autoUpdate = true;
  this.needsUpdate = false;
  this.type = PCFShadowMap;

  this.render = function (lights, scene, camera) {
    if (scope.enabled === false) return;
    if (scope.autoUpdate === false && scope.needsUpdate === false) return;
    if (lights.length === 0) return;

    var currentRenderTarget = _renderer.getRenderTarget();

    var activeCubeFace = _renderer.getActiveCubeFace();

    var activeMipmapLevel = _renderer.getActiveMipmapLevel();

    var _state = _renderer.state; // Set GL state for depth map.

    _state.setBlending(NoBlending);

    _state.buffers.color.setClear(1, 1, 1, 1);

    _state.buffers.depth.setTest(true);

    _state.setScissorTest(false); // render depth map


    for (var _i122 = 0, il = lights.length; _i122 < il; _i122++) {
      var light = lights[_i122];
      var shadow = light.shadow;

      if (shadow === undefined) {
        console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
        continue;
      }

      if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;

      _shadowMapSize.copy(shadow.mapSize);

      var shadowFrameExtents = shadow.getFrameExtents();

      _shadowMapSize.multiply(shadowFrameExtents);

      _viewportSize.copy(shadow.mapSize);

      if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
        if (_shadowMapSize.x > _maxTextureSize) {
          _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
          _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
          shadow.mapSize.x = _viewportSize.x;
        }

        if (_shadowMapSize.y > _maxTextureSize) {
          _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
          _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
          shadow.mapSize.y = _viewportSize.y;
        }
      }

      if (shadow.map === null && !shadow.isPointLightShadow && this.type === VSMShadowMap) {
        shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y);
        shadow.map.texture.name = light.name + '.shadowMap';
        shadow.mapPass = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y);
        shadow.camera.updateProjectionMatrix();
      }

      if (shadow.map === null) {
        var pars = {
          minFilter: NearestFilter,
          magFilter: NearestFilter,
          format: RGBAFormat
        };
        shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
        shadow.map.texture.name = light.name + '.shadowMap';
        shadow.camera.updateProjectionMatrix();
      }

      _renderer.setRenderTarget(shadow.map);

      _renderer.clear();

      var viewportCount = shadow.getViewportCount();

      for (var vp = 0; vp < viewportCount; vp++) {
        var viewport = shadow.getViewport(vp);

        _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);

        _state.viewport(_viewport);

        shadow.updateMatrices(light, vp);
        _frustum = shadow.getFrustum();
        renderObject(scene, camera, shadow.camera, light, this.type);
      } // do blur pass for VSM


      if (!shadow.isPointLightShadow && this.type === VSMShadowMap) {
        VSMPass(shadow, camera);
      }

      shadow.needsUpdate = false;
    }

    scope.needsUpdate = false;

    _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
  };

  function VSMPass(shadow, camera) {
    var geometry = _objects.update(fullScreenMesh);

    if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
      shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
      shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
      shadowMaterialVertical.needsUpdate = true;
      shadowMaterialHorizontal.needsUpdate = true;
    } // vertical pass


    shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
    shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialVertical.uniforms.radius.value = shadow.radius;

    _renderer.setRenderTarget(shadow.mapPass);

    _renderer.clear();

    _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null); // horizontal pass


    shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
    shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
    shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;

    _renderer.setRenderTarget(shadow.map);

    _renderer.clear();

    _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
  }

  function getDepthMaterial(object, material, light, shadowCameraNear, shadowCameraFar, type) {
    var result = null;
    var customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;

    if (customMaterial !== undefined) {
      result = customMaterial;
    } else {
      result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
    }

    if (_renderer.localClippingEnabled && material.clipShadows === true && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0) {
      // in this case we need a unique material instance reflecting the
      // appropriate state
      var keyA = result.uuid,
          keyB = material.uuid;
      var materialsForVariant = _materialCache[keyA];

      if (materialsForVariant === undefined) {
        materialsForVariant = {};
        _materialCache[keyA] = materialsForVariant;
      }

      var cachedMaterial = materialsForVariant[keyB];

      if (cachedMaterial === undefined) {
        cachedMaterial = result.clone();
        materialsForVariant[keyB] = cachedMaterial;
      }

      result = cachedMaterial;
    }

    result.visible = material.visible;
    result.wireframe = material.wireframe;

    if (type === VSMShadowMap) {
      result.side = material.shadowSide !== null ? material.shadowSide : material.side;
    } else {
      result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
    }

    result.alphaMap = material.alphaMap;
    result.alphaTest = material.alphaTest;
    result.clipShadows = material.clipShadows;
    result.clippingPlanes = material.clippingPlanes;
    result.clipIntersection = material.clipIntersection;
    result.displacementMap = material.displacementMap;
    result.displacementScale = material.displacementScale;
    result.displacementBias = material.displacementBias;
    result.wireframeLinewidth = material.wireframeLinewidth;
    result.linewidth = material.linewidth;

    if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
      result.referencePosition.setFromMatrixPosition(light.matrixWorld);
      result.nearDistance = shadowCameraNear;
      result.farDistance = shadowCameraFar;
    }

    return result;
  }

  function renderObject(object, camera, shadowCamera, light, type) {
    if (object.visible === false) return;
    var visible = object.layers.test(camera.layers);

    if (visible && (object.isMesh || object.isLine || object.isPoints)) {
      if ((object.castShadow || object.receiveShadow && type === VSMShadowMap) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
        object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);

        var geometry = _objects.update(object);

        var material = object.material;

        if (Array.isArray(material)) {
          var groups = geometry.groups;

          for (var k = 0, kl = groups.length; k < kl; k++) {
            var group = groups[k];
            var groupMaterial = material[group.materialIndex];

            if (groupMaterial && groupMaterial.visible) {
              var depthMaterial = getDepthMaterial(object, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);

              _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
            }
          }
        } else if (material.visible) {
          var _depthMaterial2 = getDepthMaterial(object, material, light, shadowCamera.near, shadowCamera.far, type);

          _renderer.renderBufferDirect(shadowCamera, null, geometry, _depthMaterial2, object, null);
        }
      }
    }

    var children = object.children;

    for (var _i123 = 0, l = children.length; _i123 < l; _i123++) {
      renderObject(children[_i123], camera, shadowCamera, light, type);
    }
  }
}

function WebGLState(gl, extensions, capabilities) {
  var _equationToGL, _factorToGL;

  var isWebGL2 = capabilities.isWebGL2;

  function ColorBuffer() {
    var locked = false;
    var color = new Vector4();
    var currentColorMask = null;
    var currentColorClear = new Vector4(0, 0, 0, 0);
    return {
      setMask: function setMask(colorMask) {
        if (currentColorMask !== colorMask && !locked) {
          gl.colorMask(colorMask, colorMask, colorMask, colorMask);
          currentColorMask = colorMask;
        }
      },
      setLocked: function setLocked(lock) {
        locked = lock;
      },
      setClear: function setClear(r, g, b, a, premultipliedAlpha) {
        if (premultipliedAlpha === true) {
          r *= a;
          g *= a;
          b *= a;
        }

        color.set(r, g, b, a);

        if (currentColorClear.equals(color) === false) {
          gl.clearColor(r, g, b, a);
          currentColorClear.copy(color);
        }
      },
      reset: function reset() {
        locked = false;
        currentColorMask = null;
        currentColorClear.set(-1, 0, 0, 0); // set to invalid state
      }
    };
  }

  function DepthBuffer() {
    var locked = false;
    var currentDepthMask = null;
    var currentDepthFunc = null;
    var currentDepthClear = null;
    return {
      setTest: function setTest(depthTest) {
        if (depthTest) {
          enable(2929);
        } else {
          disable(2929);
        }
      },
      setMask: function setMask(depthMask) {
        if (currentDepthMask !== depthMask && !locked) {
          gl.depthMask(depthMask);
          currentDepthMask = depthMask;
        }
      },
      setFunc: function setFunc(depthFunc) {
        if (currentDepthFunc !== depthFunc) {
          if (depthFunc) {
            switch (depthFunc) {
              case NeverDepth:
                gl.depthFunc(512);
                break;

              case AlwaysDepth:
                gl.depthFunc(519);
                break;

              case LessDepth:
                gl.depthFunc(513);
                break;

              case LessEqualDepth:
                gl.depthFunc(515);
                break;

              case EqualDepth:
                gl.depthFunc(514);
                break;

              case GreaterEqualDepth:
                gl.depthFunc(518);
                break;

              case GreaterDepth:
                gl.depthFunc(516);
                break;

              case NotEqualDepth:
                gl.depthFunc(517);
                break;

              default:
                gl.depthFunc(515);
            }
          } else {
            gl.depthFunc(515);
          }

          currentDepthFunc = depthFunc;
        }
      },
      setLocked: function setLocked(lock) {
        locked = lock;
      },
      setClear: function setClear(depth) {
        if (currentDepthClear !== depth) {
          gl.clearDepth(depth);
          currentDepthClear = depth;
        }
      },
      reset: function reset() {
        locked = false;
        currentDepthMask = null;
        currentDepthFunc = null;
        currentDepthClear = null;
      }
    };
  }

  function StencilBuffer() {
    var locked = false;
    var currentStencilMask = null;
    var currentStencilFunc = null;
    var currentStencilRef = null;
    var currentStencilFuncMask = null;
    var currentStencilFail = null;
    var currentStencilZFail = null;
    var currentStencilZPass = null;
    var currentStencilClear = null;
    return {
      setTest: function setTest(stencilTest) {
        if (!locked) {
          if (stencilTest) {
            enable(2960);
          } else {
            disable(2960);
          }
        }
      },
      setMask: function setMask(stencilMask) {
        if (currentStencilMask !== stencilMask && !locked) {
          gl.stencilMask(stencilMask);
          currentStencilMask = stencilMask;
        }
      },
      setFunc: function setFunc(stencilFunc, stencilRef, stencilMask) {
        if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
          gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
          currentStencilFunc = stencilFunc;
          currentStencilRef = stencilRef;
          currentStencilFuncMask = stencilMask;
        }
      },
      setOp: function setOp(stencilFail, stencilZFail, stencilZPass) {
        if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
          gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
          currentStencilFail = stencilFail;
          currentStencilZFail = stencilZFail;
          currentStencilZPass = stencilZPass;
        }
      },
      setLocked: function setLocked(lock) {
        locked = lock;
      },
      setClear: function setClear(stencil) {
        if (currentStencilClear !== stencil) {
          gl.clearStencil(stencil);
          currentStencilClear = stencil;
        }
      },
      reset: function reset() {
        locked = false;
        currentStencilMask = null;
        currentStencilFunc = null;
        currentStencilRef = null;
        currentStencilFuncMask = null;
        currentStencilFail = null;
        currentStencilZFail = null;
        currentStencilZPass = null;
        currentStencilClear = null;
      }
    };
  } //


  var colorBuffer = new ColorBuffer();
  var depthBuffer = new DepthBuffer();
  var stencilBuffer = new StencilBuffer();
  var enabledCapabilities = {};
  var currentBoundFramebuffers = {};
  var currentDrawbuffers = new WeakMap();
  var defaultDrawbuffers = [];
  var currentProgram = null;
  var currentBlendingEnabled = false;
  var currentBlending = null;
  var currentBlendEquation = null;
  var currentBlendSrc = null;
  var currentBlendDst = null;
  var currentBlendEquationAlpha = null;
  var currentBlendSrcAlpha = null;
  var currentBlendDstAlpha = null;
  var currentPremultipledAlpha = false;
  var currentFlipSided = null;
  var currentCullFace = null;
  var currentLineWidth = null;
  var currentPolygonOffsetFactor = null;
  var currentPolygonOffsetUnits = null;
  var maxTextures = gl.getParameter(35661);
  var lineWidthAvailable = false;
  var version = 0;
  var glVersion = gl.getParameter(7938);

  if (glVersion.indexOf('WebGL') !== -1) {
    version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version >= 1.0;
  } else if (glVersion.indexOf('OpenGL ES') !== -1) {
    version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
    lineWidthAvailable = version >= 2.0;
  }

  var currentTextureSlot = null;
  var currentBoundTextures = {};
  var scissorParam = gl.getParameter(3088);
  var viewportParam = gl.getParameter(2978);
  var currentScissor = new Vector4().fromArray(scissorParam);
  var currentViewport = new Vector4().fromArray(viewportParam);

  function createTexture(type, target, count) {
    var data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.

    var texture = gl.createTexture();
    gl.bindTexture(type, texture);
    gl.texParameteri(type, 10241, 9728);
    gl.texParameteri(type, 10240, 9728);

    for (var _i124 = 0; _i124 < count; _i124++) {
      gl.texImage2D(target + _i124, 0, 6408, 1, 1, 0, 6408, 5121, data);
    }

    return texture;
  }

  var emptyTextures = {};
  emptyTextures[3553] = createTexture(3553, 3553, 1);
  emptyTextures[34067] = createTexture(34067, 34069, 6); // init

  colorBuffer.setClear(0, 0, 0, 1);
  depthBuffer.setClear(1);
  stencilBuffer.setClear(0);
  enable(2929);
  depthBuffer.setFunc(LessEqualDepth);
  setFlipSided(false);
  setCullFace(CullFaceBack);
  enable(2884);
  setBlending(NoBlending); //

  function enable(id) {
    if (enabledCapabilities[id] !== true) {
      gl.enable(id);
      enabledCapabilities[id] = true;
    }
  }

  function disable(id) {
    if (enabledCapabilities[id] !== false) {
      gl.disable(id);
      enabledCapabilities[id] = false;
    }
  }

  function bindFramebuffer(target, framebuffer) {
    if (currentBoundFramebuffers[target] !== framebuffer) {
      gl.bindFramebuffer(target, framebuffer);
      currentBoundFramebuffers[target] = framebuffer;

      if (isWebGL2) {
        // 36009 is equivalent to 36160
        if (target === 36009) {
          currentBoundFramebuffers[36160] = framebuffer;
        }

        if (target === 36160) {
          currentBoundFramebuffers[36009] = framebuffer;
        }
      }

      return true;
    }

    return false;
  }

  function drawBuffers(renderTarget, framebuffer) {
    var drawBuffers = defaultDrawbuffers;
    var needsUpdate = false;

    if (renderTarget) {
      drawBuffers = currentDrawbuffers.get(framebuffer);

      if (drawBuffers === undefined) {
        drawBuffers = [];
        currentDrawbuffers.set(framebuffer, drawBuffers);
      }

      if (renderTarget.isWebGLMultipleRenderTargets) {
        var textures = renderTarget.texture;

        if (drawBuffers.length !== textures.length || drawBuffers[0] !== 36064) {
          for (var _i125 = 0, il = textures.length; _i125 < il; _i125++) {
            drawBuffers[_i125] = 36064 + _i125;
          }

          drawBuffers.length = textures.length;
          needsUpdate = true;
        }
      } else {
        if (drawBuffers[0] !== 36064) {
          drawBuffers[0] = 36064;
          needsUpdate = true;
        }
      }
    } else {
      if (drawBuffers[0] !== 1029) {
        drawBuffers[0] = 1029;
        needsUpdate = true;
      }
    }

    if (needsUpdate) {
      if (capabilities.isWebGL2) {
        gl.drawBuffers(drawBuffers);
      } else {
        extensions.get('WEBGL_draw_buffers').drawBuffersWEBGL(drawBuffers);
      }
    }
  }

  function useProgram(program) {
    if (currentProgram !== program) {
      gl.useProgram(program);
      currentProgram = program;
      return true;
    }

    return false;
  }

  var equationToGL = (_equationToGL = {}, _defineProperty(_equationToGL, AddEquation, 32774), _defineProperty(_equationToGL, SubtractEquation, 32778), _defineProperty(_equationToGL, ReverseSubtractEquation, 32779), _equationToGL);

  if (isWebGL2) {
    equationToGL[MinEquation] = 32775;
    equationToGL[MaxEquation] = 32776;
  } else {
    var extension = extensions.get('EXT_blend_minmax');

    if (extension !== null) {
      equationToGL[MinEquation] = extension.MIN_EXT;
      equationToGL[MaxEquation] = extension.MAX_EXT;
    }
  }

  var factorToGL = (_factorToGL = {}, _defineProperty(_factorToGL, ZeroFactor, 0), _defineProperty(_factorToGL, OneFactor, 1), _defineProperty(_factorToGL, SrcColorFactor, 768), _defineProperty(_factorToGL, SrcAlphaFactor, 770), _defineProperty(_factorToGL, SrcAlphaSaturateFactor, 776), _defineProperty(_factorToGL, DstColorFactor, 774), _defineProperty(_factorToGL, DstAlphaFactor, 772), _defineProperty(_factorToGL, OneMinusSrcColorFactor, 769), _defineProperty(_factorToGL, OneMinusSrcAlphaFactor, 771), _defineProperty(_factorToGL, OneMinusDstColorFactor, 775), _defineProperty(_factorToGL, OneMinusDstAlphaFactor, 773), _factorToGL);

  function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
    if (blending === NoBlending) {
      if (currentBlendingEnabled === true) {
        disable(3042);
        currentBlendingEnabled = false;
      }

      return;
    }

    if (currentBlendingEnabled === false) {
      enable(3042);
      currentBlendingEnabled = true;
    }

    if (blending !== CustomBlending) {
      if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
        if (currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation) {
          gl.blendEquation(32774);
          currentBlendEquation = AddEquation;
          currentBlendEquationAlpha = AddEquation;
        }

        if (premultipliedAlpha) {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(1, 771, 1, 771);
              break;

            case AdditiveBlending:
              gl.blendFunc(1, 1);
              break;

            case SubtractiveBlending:
              gl.blendFuncSeparate(0, 769, 0, 1);
              break;

            case MultiplyBlending:
              gl.blendFuncSeparate(0, 768, 0, 770);
              break;

            default:
              console.error('THREE.WebGLState: Invalid blending: ', blending);
              break;
          }
        } else {
          switch (blending) {
            case NormalBlending:
              gl.blendFuncSeparate(770, 771, 1, 771);
              break;

            case AdditiveBlending:
              gl.blendFunc(770, 1);
              break;

            case SubtractiveBlending:
              gl.blendFuncSeparate(0, 769, 0, 1);
              break;

            case MultiplyBlending:
              gl.blendFunc(0, 768);
              break;

            default:
              console.error('THREE.WebGLState: Invalid blending: ', blending);
              break;
          }
        }

        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlending = blending;
        currentPremultipledAlpha = premultipliedAlpha;
      }

      return;
    } // custom blending


    blendEquationAlpha = blendEquationAlpha || blendEquation;
    blendSrcAlpha = blendSrcAlpha || blendSrc;
    blendDstAlpha = blendDstAlpha || blendDst;

    if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
      gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
      currentBlendEquation = blendEquation;
      currentBlendEquationAlpha = blendEquationAlpha;
    }

    if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
      gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
      currentBlendSrc = blendSrc;
      currentBlendDst = blendDst;
      currentBlendSrcAlpha = blendSrcAlpha;
      currentBlendDstAlpha = blendDstAlpha;
    }

    currentBlending = blending;
    currentPremultipledAlpha = null;
  }

  function setMaterial(material, frontFaceCW) {
    material.side === DoubleSide ? disable(2884) : enable(2884);
    var flipSided = material.side === BackSide;
    if (frontFaceCW) flipSided = !flipSided;
    setFlipSided(flipSided);
    material.blending === NormalBlending && material.transparent === false ? setBlending(NoBlending) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
    depthBuffer.setFunc(material.depthFunc);
    depthBuffer.setTest(material.depthTest);
    depthBuffer.setMask(material.depthWrite);
    colorBuffer.setMask(material.colorWrite);
    var stencilWrite = material.stencilWrite;
    stencilBuffer.setTest(stencilWrite);

    if (stencilWrite) {
      stencilBuffer.setMask(material.stencilWriteMask);
      stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
      stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
    }

    setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
    material.alphaToCoverage === true ? enable(32926) : disable(32926);
  } //


  function setFlipSided(flipSided) {
    if (currentFlipSided !== flipSided) {
      if (flipSided) {
        gl.frontFace(2304);
      } else {
        gl.frontFace(2305);
      }

      currentFlipSided = flipSided;
    }
  }

  function setCullFace(cullFace) {
    if (cullFace !== CullFaceNone) {
      enable(2884);

      if (cullFace !== currentCullFace) {
        if (cullFace === CullFaceBack) {
          gl.cullFace(1029);
        } else if (cullFace === CullFaceFront) {
          gl.cullFace(1028);
        } else {
          gl.cullFace(1032);
        }
      }
    } else {
      disable(2884);
    }

    currentCullFace = cullFace;
  }

  function setLineWidth(width) {
    if (width !== currentLineWidth) {
      if (lineWidthAvailable) gl.lineWidth(width);
      currentLineWidth = width;
    }
  }

  function setPolygonOffset(polygonOffset, factor, units) {
    if (polygonOffset) {
      enable(32823);

      if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
        gl.polygonOffset(factor, units);
        currentPolygonOffsetFactor = factor;
        currentPolygonOffsetUnits = units;
      }
    } else {
      disable(32823);
    }
  }

  function setScissorTest(scissorTest) {
    if (scissorTest) {
      enable(3089);
    } else {
      disable(3089);
    }
  } // texture


  function activeTexture(webglSlot) {
    if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;

    if (currentTextureSlot !== webglSlot) {
      gl.activeTexture(webglSlot);
      currentTextureSlot = webglSlot;
    }
  }

  function bindTexture(webglType, webglTexture) {
    if (currentTextureSlot === null) {
      activeTexture();
    }

    var boundTexture = currentBoundTextures[currentTextureSlot];

    if (boundTexture === undefined) {
      boundTexture = {
        type: undefined,
        texture: undefined
      };
      currentBoundTextures[currentTextureSlot] = boundTexture;
    }

    if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
      gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
      boundTexture.type = webglType;
      boundTexture.texture = webglTexture;
    }
  }

  function unbindTexture() {
    var boundTexture = currentBoundTextures[currentTextureSlot];

    if (boundTexture !== undefined && boundTexture.type !== undefined) {
      gl.bindTexture(boundTexture.type, null);
      boundTexture.type = undefined;
      boundTexture.texture = undefined;
    }
  }

  function compressedTexImage2D() {
    try {
      gl.compressedTexImage2D.apply(gl, arguments);
    } catch (error) {
      console.error('THREE.WebGLState:', error);
    }
  }

  function texSubImage2D() {
    try {
      gl.texSubImage2D.apply(gl, arguments);
    } catch (error) {
      console.error('THREE.WebGLState:', error);
    }
  }

  function texSubImage3D() {
    try {
      gl.texSubImage3D.apply(gl, arguments);
    } catch (error) {
      console.error('THREE.WebGLState:', error);
    }
  }

  function compressedTexSubImage2D() {
    try {
      gl.compressedTexSubImage2D.apply(gl, arguments);
    } catch (error) {
      console.error('THREE.WebGLState:', error);
    }
  }

  function texStorage2D() {
    try {
      gl.texStorage2D.apply(gl, arguments);
    } catch (error) {
      console.error('THREE.WebGLState:', error);
    }
  }

  function texStorage3D() {
    try {
      gl.texStorage3D.apply(gl, arguments);
    } catch (error) {
      console.error('THREE.WebGLState:', error);
    }
  }

  function texImage2D() {
    try {
      gl.texImage2D.apply(gl, arguments);
    } catch (error) {
      console.error('THREE.WebGLState:', error);
    }
  }

  function texImage3D() {
    try {
      gl.texImage3D.apply(gl, arguments);
    } catch (error) {
      console.error('THREE.WebGLState:', error);
    }
  } //


  function scissor(scissor) {
    if (currentScissor.equals(scissor) === false) {
      gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
      currentScissor.copy(scissor);
    }
  }

  function viewport(viewport) {
    if (currentViewport.equals(viewport) === false) {
      gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
      currentViewport.copy(viewport);
    }
  } //


  function reset() {
    // reset state
    gl.disable(3042);
    gl.disable(2884);
    gl.disable(2929);
    gl.disable(32823);
    gl.disable(3089);
    gl.disable(2960);
    gl.disable(32926);
    gl.blendEquation(32774);
    gl.blendFunc(1, 0);
    gl.blendFuncSeparate(1, 0, 1, 0);
    gl.colorMask(true, true, true, true);
    gl.clearColor(0, 0, 0, 0);
    gl.depthMask(true);
    gl.depthFunc(513);
    gl.clearDepth(1);
    gl.stencilMask(0xffffffff);
    gl.stencilFunc(519, 0, 0xffffffff);
    gl.stencilOp(7680, 7680, 7680);
    gl.clearStencil(0);
    gl.cullFace(1029);
    gl.frontFace(2305);
    gl.polygonOffset(0, 0);
    gl.activeTexture(33984);
    gl.bindFramebuffer(36160, null);

    if (isWebGL2 === true) {
      gl.bindFramebuffer(36009, null);
      gl.bindFramebuffer(36008, null);
    }

    gl.useProgram(null);
    gl.lineWidth(1);
    gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
    gl.viewport(0, 0, gl.canvas.width, gl.canvas.height); // reset internals

    enabledCapabilities = {};
    currentTextureSlot = null;
    currentBoundTextures = {};
    currentBoundFramebuffers = {};
    currentDrawbuffers = new WeakMap();
    defaultDrawbuffers = [];
    currentProgram = null;
    currentBlendingEnabled = false;
    currentBlending = null;
    currentBlendEquation = null;
    currentBlendSrc = null;
    currentBlendDst = null;
    currentBlendEquationAlpha = null;
    currentBlendSrcAlpha = null;
    currentBlendDstAlpha = null;
    currentPremultipledAlpha = false;
    currentFlipSided = null;
    currentCullFace = null;
    currentLineWidth = null;
    currentPolygonOffsetFactor = null;
    currentPolygonOffsetUnits = null;
    currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
    currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
    colorBuffer.reset();
    depthBuffer.reset();
    stencilBuffer.reset();
  }

  return {
    buffers: {
      color: colorBuffer,
      depth: depthBuffer,
      stencil: stencilBuffer
    },
    enable: enable,
    disable: disable,
    bindFramebuffer: bindFramebuffer,
    drawBuffers: drawBuffers,
    useProgram: useProgram,
    setBlending: setBlending,
    setMaterial: setMaterial,
    setFlipSided: setFlipSided,
    setCullFace: setCullFace,
    setLineWidth: setLineWidth,
    setPolygonOffset: setPolygonOffset,
    setScissorTest: setScissorTest,
    activeTexture: activeTexture,
    bindTexture: bindTexture,
    unbindTexture: unbindTexture,
    compressedTexImage2D: compressedTexImage2D,
    texImage2D: texImage2D,
    texImage3D: texImage3D,
    texStorage2D: texStorage2D,
    texStorage3D: texStorage3D,
    texSubImage2D: texSubImage2D,
    texSubImage3D: texSubImage3D,
    compressedTexSubImage2D: compressedTexSubImage2D,
    scissor: scissor,
    viewport: viewport,
    reset: reset
  };
}

function WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
  var _wrappingToGL, _filterToGL;

  var isWebGL2 = capabilities.isWebGL2;
  var maxTextures = capabilities.maxTextures;
  var maxCubemapSize = capabilities.maxCubemapSize;
  var maxTextureSize = capabilities.maxTextureSize;
  var maxSamples = capabilities.maxSamples;
  var multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
  var supportsInvalidateFramebuffer = /OculusBrowser/g.test(navigator.userAgent);

  var _videoTextures = new WeakMap();

  var _canvas;

  var _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
  // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
  // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
  // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).


  var useOffscreenCanvas = false;

  try {
    useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' // eslint-disable-next-line compat/compat
    && new OffscreenCanvas(1, 1).getContext('2d') !== null;
  } catch (err) {// Ignore any errors
  }

  function createCanvas(width, height) {
    // Use OffscreenCanvas when available. Specially needed in web workers
    return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
    new OffscreenCanvas(width, height) : createElementNS('canvas');
  }

  function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
    var scale = 1; // handle case if texture exceeds max size

    if (image.width > maxSize || image.height > maxSize) {
      scale = maxSize / Math.max(image.width, image.height);
    } // only perform resize if necessary


    if (scale < 1 || needsPowerOfTwo === true) {
      // only perform resize for certain image types
      if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
        var floor = needsPowerOfTwo ? floorPowerOfTwo : Math.floor;
        var width = floor(scale * image.width);
        var height = floor(scale * image.height);
        if (_canvas === undefined) _canvas = createCanvas(width, height); // cube textures can't reuse the same canvas

        var canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
        canvas.width = width;
        canvas.height = height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, width, height);
        console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');
        return canvas;
      } else {
        if ('data' in image) {
          console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
        }

        return image;
      }
    }

    return image;
  }

  function isPowerOfTwo$1(image) {
    return isPowerOfTwo(image.width) && isPowerOfTwo(image.height);
  }

  function textureNeedsPowerOfTwo(texture) {
    if (isWebGL2) return false;
    return texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping || texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
  }

  function textureNeedsGenerateMipmaps(texture, supportsMips) {
    return texture.generateMipmaps && supportsMips && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
  }

  function generateMipmap(target) {
    _gl.generateMipmap(target);
  }

  function getInternalFormat(internalFormatName, glFormat, glType, encoding) {
    var isVideoTexture = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    if (isWebGL2 === false) return glFormat;

    if (internalFormatName !== null) {
      if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
      console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
    }

    var internalFormat = glFormat;

    if (glFormat === 6403) {
      if (glType === 5126) internalFormat = 33326;
      if (glType === 5131) internalFormat = 33325;
      if (glType === 5121) internalFormat = 33321;
    }

    if (glFormat === 33319) {
      if (glType === 5126) internalFormat = 33328;
      if (glType === 5131) internalFormat = 33327;
      if (glType === 5121) internalFormat = 33323;
    }

    if (glFormat === 6408) {
      if (glType === 5126) internalFormat = 34836;
      if (glType === 5131) internalFormat = 34842;
      if (glType === 5121) internalFormat = encoding === sRGBEncoding && isVideoTexture === false ? 35907 : 32856;
      if (glType === 32819) internalFormat = 32854;
      if (glType === 32820) internalFormat = 32855;
    }

    if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 33327 || internalFormat === 33328 || internalFormat === 34842 || internalFormat === 34836) {
      extensions.get('EXT_color_buffer_float');
    }

    return internalFormat;
  }

  function getMipLevels(texture, image, supportsMips) {
    if (textureNeedsGenerateMipmaps(texture, supportsMips) === true || texture.isFramebufferTexture && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) {
      return Math.log2(Math.max(image.width, image.height)) + 1;
    } else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) {
      // user-defined mipmaps
      return texture.mipmaps.length;
    } else if (texture.isCompressedTexture && Array.isArray(texture.image)) {
      return image.mipmaps.length;
    } else {
      // texture without mipmaps (only base level)
      return 1;
    }
  } // Fallback filters for non-power-of-2 textures


  function filterFallback(f) {
    if (f === NearestFilter || f === NearestMipmapNearestFilter || f === NearestMipmapLinearFilter) {
      return 9728;
    }

    return 9729;
  } //


  function onTextureDispose(event) {
    var texture = event.target;
    texture.removeEventListener('dispose', onTextureDispose);
    deallocateTexture(texture);

    if (texture.isVideoTexture) {
      _videoTextures.delete(texture);
    }
  }

  function onRenderTargetDispose(event) {
    var renderTarget = event.target;
    renderTarget.removeEventListener('dispose', onRenderTargetDispose);
    deallocateRenderTarget(renderTarget);
  } //


  function deallocateTexture(texture) {
    var textureProperties = properties.get(texture);
    if (textureProperties.__webglInit === undefined) return; // check if it's necessary to remove the WebGLTexture object

    var source = texture.source;

    var webglTextures = _sources.get(source);

    if (webglTextures) {
      var webglTexture = webglTextures[textureProperties.__cacheKey];
      webglTexture.usedTimes--; // the WebGLTexture object is not used anymore, remove it

      if (webglTexture.usedTimes === 0) {
        deleteTexture(texture);
      } // remove the weak map entry if no WebGLTexture uses the source anymore


      if (Object.keys(webglTextures).length === 0) {
        _sources.delete(source);
      }
    }

    properties.remove(texture);
  }

  function deleteTexture(texture) {
    var textureProperties = properties.get(texture);

    _gl.deleteTexture(textureProperties.__webglTexture);

    var source = texture.source;

    var webglTextures = _sources.get(source);

    delete webglTextures[textureProperties.__cacheKey];
    info.memory.textures--;
  }

  function deallocateRenderTarget(renderTarget) {
    var texture = renderTarget.texture;
    var renderTargetProperties = properties.get(renderTarget);
    var textureProperties = properties.get(texture);

    if (textureProperties.__webglTexture !== undefined) {
      _gl.deleteTexture(textureProperties.__webglTexture);

      info.memory.textures--;
    }

    if (renderTarget.depthTexture) {
      renderTarget.depthTexture.dispose();
    }

    if (renderTarget.isWebGLCubeRenderTarget) {
      for (var _i126 = 0; _i126 < 6; _i126++) {
        _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[_i126]);

        if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[_i126]);
      }
    } else {
      _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);

      if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
      if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
      if (renderTargetProperties.__webglColorRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer);
      if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
    }

    if (renderTarget.isWebGLMultipleRenderTargets) {
      for (var _i127 = 0, il = texture.length; _i127 < il; _i127++) {
        var attachmentProperties = properties.get(texture[_i127]);

        if (attachmentProperties.__webglTexture) {
          _gl.deleteTexture(attachmentProperties.__webglTexture);

          info.memory.textures--;
        }

        properties.remove(texture[_i127]);
      }
    }

    properties.remove(texture);
    properties.remove(renderTarget);
  } //


  var textureUnits = 0;

  function resetTextureUnits() {
    textureUnits = 0;
  }

  function allocateTextureUnit() {
    var textureUnit = textureUnits;

    if (textureUnit >= maxTextures) {
      console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
    }

    textureUnits += 1;
    return textureUnit;
  }

  function getTextureCacheKey(texture) {
    var array = [];
    array.push(texture.wrapS);
    array.push(texture.wrapT);
    array.push(texture.magFilter);
    array.push(texture.minFilter);
    array.push(texture.anisotropy);
    array.push(texture.internalFormat);
    array.push(texture.format);
    array.push(texture.type);
    array.push(texture.generateMipmaps);
    array.push(texture.premultiplyAlpha);
    array.push(texture.flipY);
    array.push(texture.unpackAlignment);
    array.push(texture.encoding);
    return array.join();
  } //


  function setTexture2D(texture, slot) {
    var textureProperties = properties.get(texture);
    if (texture.isVideoTexture) updateVideoTexture(texture);

    if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
      var image = texture.image;

      if (image === null) {
        console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
      } else if (image.complete === false) {
        console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
      } else {
        uploadTexture(textureProperties, texture, slot);
        return;
      }
    }

    state.activeTexture(33984 + slot);
    state.bindTexture(3553, textureProperties.__webglTexture);
  }

  function setTexture2DArray(texture, slot) {
    var textureProperties = properties.get(texture);

    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }

    state.activeTexture(33984 + slot);
    state.bindTexture(35866, textureProperties.__webglTexture);
  }

  function setTexture3D(texture, slot) {
    var textureProperties = properties.get(texture);

    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadTexture(textureProperties, texture, slot);
      return;
    }

    state.activeTexture(33984 + slot);
    state.bindTexture(32879, textureProperties.__webglTexture);
  }

  function setTextureCube(texture, slot) {
    var textureProperties = properties.get(texture);

    if (texture.version > 0 && textureProperties.__version !== texture.version) {
      uploadCubeTexture(textureProperties, texture, slot);
      return;
    }

    state.activeTexture(33984 + slot);
    state.bindTexture(34067, textureProperties.__webglTexture);
  }

  var wrappingToGL = (_wrappingToGL = {}, _defineProperty(_wrappingToGL, RepeatWrapping, 10497), _defineProperty(_wrappingToGL, ClampToEdgeWrapping, 33071), _defineProperty(_wrappingToGL, MirroredRepeatWrapping, 33648), _wrappingToGL);
  var filterToGL = (_filterToGL = {}, _defineProperty(_filterToGL, NearestFilter, 9728), _defineProperty(_filterToGL, NearestMipmapNearestFilter, 9984), _defineProperty(_filterToGL, NearestMipmapLinearFilter, 9986), _defineProperty(_filterToGL, LinearFilter, 9729), _defineProperty(_filterToGL, LinearMipmapNearestFilter, 9985), _defineProperty(_filterToGL, LinearMipmapLinearFilter, 9987), _filterToGL);

  function setTextureParameters(textureType, texture, supportsMips) {
    if (supportsMips) {
      _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);

      _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);

      if (textureType === 32879 || textureType === 35866) {
        _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
      }

      _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);

      _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
    } else {
      _gl.texParameteri(textureType, 10242, 33071);

      _gl.texParameteri(textureType, 10243, 33071);

      if (textureType === 32879 || textureType === 35866) {
        _gl.texParameteri(textureType, 32882, 33071);
      }

      if (texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping) {
        console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
      }

      _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));

      _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));

      if (texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) {
        console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
      }
    }

    if (extensions.has('EXT_texture_filter_anisotropic') === true) {
      var extension = extensions.get('EXT_texture_filter_anisotropic');
      if (texture.type === FloatType && extensions.has('OES_texture_float_linear') === false) return; // verify extension for WebGL 1 and WebGL 2

      if (isWebGL2 === false && texture.type === HalfFloatType && extensions.has('OES_texture_half_float_linear') === false) return; // verify extension for WebGL 1 only

      if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
        _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));

        properties.get(texture).__currentAnisotropy = texture.anisotropy;
      }
    }
  }

  function initTexture(textureProperties, texture) {
    var forceUpload = false;

    if (textureProperties.__webglInit === undefined) {
      textureProperties.__webglInit = true;
      texture.addEventListener('dispose', onTextureDispose);
    } // create Source <-> WebGLTextures mapping if necessary


    var source = texture.source;

    var webglTextures = _sources.get(source);

    if (webglTextures === undefined) {
      webglTextures = {};

      _sources.set(source, webglTextures);
    } // check if there is already a WebGLTexture object for the given texture parameters


    var textureCacheKey = getTextureCacheKey(texture);

    if (textureCacheKey !== textureProperties.__cacheKey) {
      // if not, create a new instance of WebGLTexture
      if (webglTextures[textureCacheKey] === undefined) {
        // create new entry
        webglTextures[textureCacheKey] = {
          texture: _gl.createTexture(),
          usedTimes: 0
        };
        info.memory.textures++; // when a new instance of WebGLTexture was created, a texture upload is required
        // even if the image contents are identical

        forceUpload = true;
      }

      webglTextures[textureCacheKey].usedTimes++; // every time the texture cache key changes, it's necessary to check if an instance of
      // WebGLTexture can be deleted in order to avoid a memory leak.

      var webglTexture = webglTextures[textureProperties.__cacheKey];

      if (webglTexture !== undefined) {
        webglTextures[textureProperties.__cacheKey].usedTimes--;

        if (webglTexture.usedTimes === 0) {
          deleteTexture(texture);
        }
      } // store references to cache key and WebGLTexture object


      textureProperties.__cacheKey = textureCacheKey;
      textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
    }

    return forceUpload;
  }

  function uploadTexture(textureProperties, texture, slot) {
    var textureType = 3553;
    if (texture.isDataArrayTexture) textureType = 35866;
    if (texture.isData3DTexture) textureType = 32879;
    var forceUpload = initTexture(textureProperties, texture);
    var source = texture.source;
    state.activeTexture(33984 + slot);
    state.bindTexture(textureType, textureProperties.__webglTexture);

    if (source.version !== source.__currentVersion || forceUpload === true) {
      _gl.pixelStorei(37440, texture.flipY);

      _gl.pixelStorei(37441, texture.premultiplyAlpha);

      _gl.pixelStorei(3317, texture.unpackAlignment);

      _gl.pixelStorei(37443, 0);

      var needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo$1(texture.image) === false;
      var image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
      image = verifyColorSpace(texture, image);
      var supportsMips = isPowerOfTwo$1(image) || isWebGL2,
          glFormat = utils.convert(texture.format, texture.encoding);
      var glType = utils.convert(texture.type),
          glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding, texture.isVideoTexture);
      setTextureParameters(textureType, texture, supportsMips);
      var mipmap;
      var mipmaps = texture.mipmaps;
      var useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
      var allocateMemory = textureProperties.__version === undefined || forceUpload === true;
      var levels = getMipLevels(texture, image, supportsMips);

      if (texture.isDepthTexture) {
        // populate depth texture with dummy data
        glInternalFormat = 6402;

        if (isWebGL2) {
          if (texture.type === FloatType) {
            glInternalFormat = 36012;
          } else if (texture.type === UnsignedIntType) {
            glInternalFormat = 33190;
          } else if (texture.type === UnsignedInt248Type) {
            glInternalFormat = 35056;
          } else {
            glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
          }
        } else {
          if (texture.type === FloatType) {
            console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
          }
        } // validation checks for WebGL 1


        if (texture.format === DepthFormat && glInternalFormat === 6402) {
          // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
          // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
          // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
          if (texture.type !== UnsignedShortType && texture.type !== UnsignedIntType) {
            console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');
            texture.type = UnsignedShortType;
            glType = utils.convert(texture.type);
          }
        }

        if (texture.format === DepthStencilFormat && glInternalFormat === 6402) {
          // Depth stencil textures need the DEPTH_STENCIL internal format
          // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
          glInternalFormat = 34041; // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
          // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
          // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)

          if (texture.type !== UnsignedInt248Type) {
            console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');
            texture.type = UnsignedInt248Type;
            glType = utils.convert(texture.type);
          }
        } //


        if (allocateMemory) {
          if (useTexStorage) {
            state.texStorage2D(3553, 1, glInternalFormat, image.width, image.height);
          } else {
            state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
          }
        }
      } else if (texture.isDataTexture) {
        // use manually created mipmaps if available
        // if there are no manual mipmaps
        // set 0 level mipmap and then use GL to generate other mipmap levels
        if (mipmaps.length > 0 && supportsMips) {
          if (useTexStorage && allocateMemory) {
            state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
          }

          for (var _i128 = 0, il = mipmaps.length; _i128 < il; _i128++) {
            mipmap = mipmaps[_i128];

            if (useTexStorage) {
              state.texSubImage2D(3553, _i128, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
            } else {
              state.texImage2D(3553, _i128, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
          }

          texture.generateMipmaps = false;
        } else {
          if (useTexStorage) {
            if (allocateMemory) {
              state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
            }

            state.texSubImage2D(3553, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
          } else {
            state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
          }
        }
      } else if (texture.isCompressedTexture) {
        if (useTexStorage && allocateMemory) {
          state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
        }

        for (var _i129 = 0, _il9 = mipmaps.length; _i129 < _il9; _i129++) {
          mipmap = mipmaps[_i129];

          if (texture.format !== RGBAFormat) {
            if (glFormat !== null) {
              if (useTexStorage) {
                state.compressedTexSubImage2D(3553, _i129, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
              } else {
                state.compressedTexImage2D(3553, _i129, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
              }
            } else {
              console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
            }
          } else {
            if (useTexStorage) {
              state.texSubImage2D(3553, _i129, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
            } else {
              state.texImage2D(3553, _i129, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
          }
        }
      } else if (texture.isDataArrayTexture) {
        if (useTexStorage) {
          if (allocateMemory) {
            state.texStorage3D(35866, levels, glInternalFormat, image.width, image.height, image.depth);
          }

          state.texSubImage3D(35866, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
        } else {
          state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        }
      } else if (texture.isData3DTexture) {
        if (useTexStorage) {
          if (allocateMemory) {
            state.texStorage3D(32879, levels, glInternalFormat, image.width, image.height, image.depth);
          }

          state.texSubImage3D(32879, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
        } else {
          state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
        }
      } else if (texture.isFramebufferTexture) {
        if (allocateMemory) {
          if (useTexStorage) {
            state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
          } else {
            var width = image.width,
                height = image.height;

            for (var _i130 = 0; _i130 < levels; _i130++) {
              state.texImage2D(3553, _i130, glInternalFormat, width, height, 0, glFormat, glType, null);
              width >>= 1;
              height >>= 1;
            }
          }
        }
      } else {
        // regular Texture (image, video, canvas)
        // use manually created mipmaps if available
        // if there are no manual mipmaps
        // set 0 level mipmap and then use GL to generate other mipmap levels
        if (mipmaps.length > 0 && supportsMips) {
          if (useTexStorage && allocateMemory) {
            state.texStorage2D(3553, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
          }

          for (var _i131 = 0, _il10 = mipmaps.length; _i131 < _il10; _i131++) {
            mipmap = mipmaps[_i131];

            if (useTexStorage) {
              state.texSubImage2D(3553, _i131, 0, 0, glFormat, glType, mipmap);
            } else {
              state.texImage2D(3553, _i131, glInternalFormat, glFormat, glType, mipmap);
            }
          }

          texture.generateMipmaps = false;
        } else {
          if (useTexStorage) {
            if (allocateMemory) {
              state.texStorage2D(3553, levels, glInternalFormat, image.width, image.height);
            }

            state.texSubImage2D(3553, 0, 0, 0, glFormat, glType, image);
          } else {
            state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
          }
        }
      }

      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        generateMipmap(textureType);
      }

      source.__currentVersion = source.version;
      if (texture.onUpdate) texture.onUpdate(texture);
    }

    textureProperties.__version = texture.version;
  }

  function uploadCubeTexture(textureProperties, texture, slot) {
    if (texture.image.length !== 6) return;
    var forceUpload = initTexture(textureProperties, texture);
    var source = texture.source;
    state.activeTexture(33984 + slot);
    state.bindTexture(34067, textureProperties.__webglTexture);

    if (source.version !== source.__currentVersion || forceUpload === true) {
      _gl.pixelStorei(37440, texture.flipY);

      _gl.pixelStorei(37441, texture.premultiplyAlpha);

      _gl.pixelStorei(3317, texture.unpackAlignment);

      _gl.pixelStorei(37443, 0);

      var isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
      var isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
      var cubeImage = [];

      for (var _i132 = 0; _i132 < 6; _i132++) {
        if (!isCompressed && !isDataTexture) {
          cubeImage[_i132] = resizeImage(texture.image[_i132], false, true, maxCubemapSize);
        } else {
          cubeImage[_i132] = isDataTexture ? texture.image[_i132].image : texture.image[_i132];
        }

        cubeImage[_i132] = verifyColorSpace(texture, cubeImage[_i132]);
      }

      var image = cubeImage[0],
          supportsMips = isPowerOfTwo$1(image) || isWebGL2,
          glFormat = utils.convert(texture.format, texture.encoding),
          glType = utils.convert(texture.type),
          glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
      var useTexStorage = isWebGL2 && texture.isVideoTexture !== true;
      var allocateMemory = textureProperties.__version === undefined;
      var levels = getMipLevels(texture, image, supportsMips);
      setTextureParameters(34067, texture, supportsMips);
      var mipmaps;

      if (isCompressed) {
        if (useTexStorage && allocateMemory) {
          state.texStorage2D(34067, levels, glInternalFormat, image.width, image.height);
        }

        for (var _i133 = 0; _i133 < 6; _i133++) {
          mipmaps = cubeImage[_i133].mipmaps;

          for (var j = 0; j < mipmaps.length; j++) {
            var mipmap = mipmaps[j];

            if (texture.format !== RGBAFormat) {
              if (glFormat !== null) {
                if (useTexStorage) {
                  state.compressedTexSubImage2D(34069 + _i133, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                } else {
                  state.compressedTexImage2D(34069 + _i133, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                }
              } else {
                console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
              }
            } else {
              if (useTexStorage) {
                state.texSubImage2D(34069 + _i133, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
              } else {
                state.texImage2D(34069 + _i133, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
              }
            }
          }
        }
      } else {
        mipmaps = texture.mipmaps;

        if (useTexStorage && allocateMemory) {
          // TODO: Uniformly handle mipmap definitions
          // Normal textures and compressed cube textures define base level + mips with their mipmap array
          // Uncompressed cube textures use their mipmap array only for mips (no base level)
          if (mipmaps.length > 0) levels++;
          state.texStorage2D(34067, levels, glInternalFormat, cubeImage[0].width, cubeImage[0].height);
        }

        for (var _i134 = 0; _i134 < 6; _i134++) {
          if (isDataTexture) {
            if (useTexStorage) {
              state.texSubImage2D(34069 + _i134, 0, 0, 0, cubeImage[_i134].width, cubeImage[_i134].height, glFormat, glType, cubeImage[_i134].data);
            } else {
              state.texImage2D(34069 + _i134, 0, glInternalFormat, cubeImage[_i134].width, cubeImage[_i134].height, 0, glFormat, glType, cubeImage[_i134].data);
            }

            for (var _j4 = 0; _j4 < mipmaps.length; _j4++) {
              var _mipmap = mipmaps[_j4];
              var mipmapImage = _mipmap.image[_i134].image;

              if (useTexStorage) {
                state.texSubImage2D(34069 + _i134, _j4 + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
              } else {
                state.texImage2D(34069 + _i134, _j4 + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
              }
            }
          } else {
            if (useTexStorage) {
              state.texSubImage2D(34069 + _i134, 0, 0, 0, glFormat, glType, cubeImage[_i134]);
            } else {
              state.texImage2D(34069 + _i134, 0, glInternalFormat, glFormat, glType, cubeImage[_i134]);
            }

            for (var _j5 = 0; _j5 < mipmaps.length; _j5++) {
              var _mipmap2 = mipmaps[_j5];

              if (useTexStorage) {
                state.texSubImage2D(34069 + _i134, _j5 + 1, 0, 0, glFormat, glType, _mipmap2.image[_i134]);
              } else {
                state.texImage2D(34069 + _i134, _j5 + 1, glInternalFormat, glFormat, glType, _mipmap2.image[_i134]);
              }
            }
          }
        }
      }

      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        // We assume images for cube map have the same size.
        generateMipmap(34067);
      }

      source.__currentVersion = source.version;
      if (texture.onUpdate) texture.onUpdate(texture);
    }

    textureProperties.__version = texture.version;
  } // Render targets
  // Setup storage for target texture and bind it to correct framebuffer


  function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget) {
    var glFormat = utils.convert(texture.format, texture.encoding);
    var glType = utils.convert(texture.type);
    var glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
    var renderTargetProperties = properties.get(renderTarget);

    if (!renderTargetProperties.__hasExternalTextures) {
      if (textureTarget === 32879 || textureTarget === 35866) {
        state.texImage3D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, renderTarget.depth, 0, glFormat, glType, null);
      } else {
        state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
      }
    }

    state.bindFramebuffer(36160, framebuffer);

    if (useMultisampledRTT(renderTarget)) {
      multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0, getRenderTargetSamples(renderTarget));
    } else {
      _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(texture).__webglTexture, 0);
    }

    state.bindFramebuffer(36160, null);
  } // Setup storage for internal depth/stencil buffers and bind to correct framebuffer


  function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
    _gl.bindRenderbuffer(36161, renderbuffer);

    if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
      var glInternalFormat = 33189;

      if (isMultisample || useMultisampledRTT(renderTarget)) {
        var depthTexture = renderTarget.depthTexture;

        if (depthTexture && depthTexture.isDepthTexture) {
          if (depthTexture.type === FloatType) {
            glInternalFormat = 36012;
          } else if (depthTexture.type === UnsignedIntType) {
            glInternalFormat = 33190;
          }
        }

        var samples = getRenderTargetSamples(renderTarget);

        if (useMultisampledRTT(renderTarget)) {
          multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        } else {
          _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
        }
      } else {
        _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
      }

      _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
    } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
      var _samples = getRenderTargetSamples(renderTarget);

      if (isMultisample && useMultisampledRTT(renderTarget) === false) {
        _gl.renderbufferStorageMultisample(36161, _samples, 35056, renderTarget.width, renderTarget.height);
      } else if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, _samples, 35056, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
      }

      _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
    } else {
      // Use the first texture for MRT so far
      var texture = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture[0] : renderTarget.texture;
      var glFormat = utils.convert(texture.format, texture.encoding);
      var glType = utils.convert(texture.type);

      var _glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);

      var _samples2 = getRenderTargetSamples(renderTarget);

      if (isMultisample && useMultisampledRTT(renderTarget) === false) {
        _gl.renderbufferStorageMultisample(36161, _samples2, _glInternalFormat, renderTarget.width, renderTarget.height);
      } else if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.renderbufferStorageMultisampleEXT(36161, _samples2, _glInternalFormat, renderTarget.width, renderTarget.height);
      } else {
        _gl.renderbufferStorage(36161, _glInternalFormat, renderTarget.width, renderTarget.height);
      }
    }

    _gl.bindRenderbuffer(36161, null);
  } // Setup resources for a Depth Texture for a FBO (needs an extension)


  function setupDepthTexture(framebuffer, renderTarget) {
    var isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
    if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
    state.bindFramebuffer(36160, framebuffer);

    if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) {
      throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
    } // upload an empty depth texture with framebuffer size


    if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
      renderTarget.depthTexture.image.width = renderTarget.width;
      renderTarget.depthTexture.image.height = renderTarget.height;
      renderTarget.depthTexture.needsUpdate = true;
    }

    setTexture2D(renderTarget.depthTexture, 0);

    var webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;

    var samples = getRenderTargetSamples(renderTarget);

    if (renderTarget.depthTexture.format === DepthFormat) {
      if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, webglDepthTexture, 0, samples);
      } else {
        _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
      }
    } else if (renderTarget.depthTexture.format === DepthStencilFormat) {
      if (useMultisampledRTT(renderTarget)) {
        multisampledRTTExt.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, webglDepthTexture, 0, samples);
      } else {
        _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
      }
    } else {
      throw new Error('Unknown depthTexture format');
    }
  } // Setup GL resources for a non-texture depth buffer


  function setupDepthRenderbuffer(renderTarget) {
    var renderTargetProperties = properties.get(renderTarget);
    var isCube = renderTarget.isWebGLCubeRenderTarget === true;

    if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
      if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
      setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
    } else {
      if (isCube) {
        renderTargetProperties.__webglDepthbuffer = [];

        for (var _i135 = 0; _i135 < 6; _i135++) {
          state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[_i135]);
          renderTargetProperties.__webglDepthbuffer[_i135] = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[_i135], renderTarget, false);
        }
      } else {
        state.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
        renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
        setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
      }
    }

    state.bindFramebuffer(36160, null);
  } // rebind framebuffer with external textures


  function rebindTextures(renderTarget, colorTexture, depthTexture) {
    var renderTargetProperties = properties.get(renderTarget);

    if (colorTexture !== undefined) {
      setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, 36064, 3553);
    }

    if (depthTexture !== undefined) {
      setupDepthRenderbuffer(renderTarget);
    }
  } // Set up GL resources for the render target


  function setupRenderTarget(renderTarget) {
    var texture = renderTarget.texture;
    var renderTargetProperties = properties.get(renderTarget);
    var textureProperties = properties.get(texture);
    renderTarget.addEventListener('dispose', onRenderTargetDispose);

    if (renderTarget.isWebGLMultipleRenderTargets !== true) {
      if (textureProperties.__webglTexture === undefined) {
        textureProperties.__webglTexture = _gl.createTexture();
      }

      textureProperties.__version = texture.version;
      info.memory.textures++;
    }

    var isCube = renderTarget.isWebGLCubeRenderTarget === true;
    var isMultipleRenderTargets = renderTarget.isWebGLMultipleRenderTargets === true;
    var supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2; // Setup framebuffer

    if (isCube) {
      renderTargetProperties.__webglFramebuffer = [];

      for (var _i136 = 0; _i136 < 6; _i136++) {
        renderTargetProperties.__webglFramebuffer[_i136] = _gl.createFramebuffer();
      }
    } else {
      renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();

      if (isMultipleRenderTargets) {
        if (capabilities.drawBuffers) {
          var textures = renderTarget.texture;

          for (var _i137 = 0, il = textures.length; _i137 < il; _i137++) {
            var attachmentProperties = properties.get(textures[_i137]);

            if (attachmentProperties.__webglTexture === undefined) {
              attachmentProperties.__webglTexture = _gl.createTexture();
              info.memory.textures++;
            }
          }
        } else {
          console.warn('THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.');
        }
      } else if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
        renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
        renderTargetProperties.__webglColorRenderbuffer = _gl.createRenderbuffer();

        _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer);

        var glFormat = utils.convert(texture.format, texture.encoding);
        var glType = utils.convert(texture.type);
        var glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.encoding);
        var samples = getRenderTargetSamples(renderTarget);

        _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);

        state.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);

        _gl.framebufferRenderbuffer(36160, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer);

        _gl.bindRenderbuffer(36161, null);

        if (renderTarget.depthBuffer) {
          renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
          setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
        }

        state.bindFramebuffer(36160, null);
      }
    } // Setup color buffer


    if (isCube) {
      state.bindTexture(34067, textureProperties.__webglTexture);
      setTextureParameters(34067, texture, supportsMips);

      for (var _i138 = 0; _i138 < 6; _i138++) {
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[_i138], renderTarget, texture, 36064, 34069 + _i138);
      }

      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        generateMipmap(34067);
      }

      state.unbindTexture();
    } else if (isMultipleRenderTargets) {
      var _textures = renderTarget.texture;

      for (var _i139 = 0, _il11 = _textures.length; _i139 < _il11; _i139++) {
        var attachment = _textures[_i139];

        var _attachmentProperties = properties.get(attachment);

        state.bindTexture(3553, _attachmentProperties.__webglTexture);
        setTextureParameters(3553, attachment, supportsMips);
        setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, 36064 + _i139, 3553);

        if (textureNeedsGenerateMipmaps(attachment, supportsMips)) {
          generateMipmap(3553);
        }
      }

      state.unbindTexture();
    } else {
      var glTextureType = 3553;

      if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) {
        if (isWebGL2) {
          glTextureType = renderTarget.isWebGL3DRenderTarget ? 32879 : 35866;
        } else {
          console.error('THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.');
        }
      }

      state.bindTexture(glTextureType, textureProperties.__webglTexture);
      setTextureParameters(glTextureType, texture, supportsMips);
      setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, 36064, glTextureType);

      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        generateMipmap(glTextureType);
      }

      state.unbindTexture();
    } // Setup depth and stencil buffers


    if (renderTarget.depthBuffer) {
      setupDepthRenderbuffer(renderTarget);
    }
  }

  function updateRenderTargetMipmap(renderTarget) {
    var supportsMips = isPowerOfTwo$1(renderTarget) || isWebGL2;
    var textures = renderTarget.isWebGLMultipleRenderTargets === true ? renderTarget.texture : [renderTarget.texture];

    for (var _i140 = 0, il = textures.length; _i140 < il; _i140++) {
      var texture = textures[_i140];

      if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
        var target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;

        var webglTexture = properties.get(texture).__webglTexture;

        state.bindTexture(target, webglTexture);
        generateMipmap(target);
        state.unbindTexture();
      }
    }
  }

  function updateMultisampleRenderTarget(renderTarget) {
    if (isWebGL2 && renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
      var width = renderTarget.width;
      var height = renderTarget.height;
      var mask = 16384;
      var invalidationArray = [36064];
      var depthStyle = renderTarget.stencilBuffer ? 33306 : 36096;

      if (renderTarget.depthBuffer) {
        invalidationArray.push(depthStyle);
      }

      var renderTargetProperties = properties.get(renderTarget);
      var ignoreDepthValues = renderTargetProperties.__ignoreDepthValues !== undefined ? renderTargetProperties.__ignoreDepthValues : false;

      if (ignoreDepthValues === false) {
        if (renderTarget.depthBuffer) mask |= 256;
        if (renderTarget.stencilBuffer) mask |= 1024;
      }

      state.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
      state.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);

      if (ignoreDepthValues === true) {
        _gl.invalidateFramebuffer(36008, [depthStyle]);

        _gl.invalidateFramebuffer(36009, [depthStyle]);
      }

      _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);

      if (supportsInvalidateFramebuffer) {
        _gl.invalidateFramebuffer(36008, invalidationArray);
      }

      state.bindFramebuffer(36008, null);
      state.bindFramebuffer(36009, renderTargetProperties.__webglMultisampledFramebuffer);
    }
  }

  function getRenderTargetSamples(renderTarget) {
    return Math.min(maxSamples, renderTarget.samples);
  }

  function useMultisampledRTT(renderTarget) {
    var renderTargetProperties = properties.get(renderTarget);
    return isWebGL2 && renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
  }

  function updateVideoTexture(texture) {
    var frame = info.render.frame; // Check the last frame we updated the VideoTexture

    if (_videoTextures.get(texture) !== frame) {
      _videoTextures.set(texture, frame);

      texture.update();
    }
  }

  function verifyColorSpace(texture, image) {
    var encoding = texture.encoding;
    var format = texture.format;
    var type = texture.type;
    if (texture.isCompressedTexture === true || texture.isVideoTexture === true || texture.format === _SRGBAFormat) return image;

    if (encoding !== LinearEncoding) {
      // sRGB
      if (encoding === sRGBEncoding) {
        if (isWebGL2 === false) {
          // in WebGL 1, try to use EXT_sRGB extension and unsized formats
          if (extensions.has('EXT_sRGB') === true && format === RGBAFormat) {
            texture.format = _SRGBAFormat; // it's not possible to generate mips in WebGL 1 with this extension

            texture.minFilter = LinearFilter;
            texture.generateMipmaps = false;
          } else {
            // slow fallback (CPU decode)
            image = ImageUtils.sRGBToLinear(image);
          }
        } else {
          // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
          if (format !== RGBAFormat || type !== UnsignedByteType) {
            console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
          }
        }
      } else {
        console.error('THREE.WebGLTextures: Unsupported texture encoding:', encoding);
      }
    }

    return image;
  } //


  this.allocateTextureUnit = allocateTextureUnit;
  this.resetTextureUnits = resetTextureUnits;
  this.setTexture2D = setTexture2D;
  this.setTexture2DArray = setTexture2DArray;
  this.setTexture3D = setTexture3D;
  this.setTextureCube = setTextureCube;
  this.rebindTextures = rebindTextures;
  this.setupRenderTarget = setupRenderTarget;
  this.updateRenderTargetMipmap = updateRenderTargetMipmap;
  this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
  this.setupDepthRenderbuffer = setupDepthRenderbuffer;
  this.setupFrameBufferTexture = setupFrameBufferTexture;
  this.useMultisampledRTT = useMultisampledRTT;
}

function WebGLUtils(gl, extensions, capabilities) {
  var isWebGL2 = capabilities.isWebGL2;

  function convert(p) {
    var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var extension;
    if (p === UnsignedByteType) return 5121;
    if (p === UnsignedShort4444Type) return 32819;
    if (p === UnsignedShort5551Type) return 32820;
    if (p === ByteType) return 5120;
    if (p === ShortType) return 5122;
    if (p === UnsignedShortType) return 5123;
    if (p === IntType) return 5124;
    if (p === UnsignedIntType) return 5125;
    if (p === FloatType) return 5126;

    if (p === HalfFloatType) {
      if (isWebGL2) return 5131;
      extension = extensions.get('OES_texture_half_float');

      if (extension !== null) {
        return extension.HALF_FLOAT_OES;
      } else {
        return null;
      }
    }

    if (p === AlphaFormat) return 6406;
    if (p === RGBAFormat) return 6408;
    if (p === LuminanceFormat) return 6409;
    if (p === LuminanceAlphaFormat) return 6410;
    if (p === DepthFormat) return 6402;
    if (p === DepthStencilFormat) return 34041;
    if (p === RedFormat) return 6403;

    if (p === RGBFormat) {
      console.warn('THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228');
      return 6408;
    } // WebGL 1 sRGB fallback


    if (p === _SRGBAFormat) {
      extension = extensions.get('EXT_sRGB');

      if (extension !== null) {
        return extension.SRGB_ALPHA_EXT;
      } else {
        return null;
      }
    } // WebGL2 formats.


    if (p === RedIntegerFormat) return 36244;
    if (p === RGFormat) return 33319;
    if (p === RGIntegerFormat) return 33320;
    if (p === RGBAIntegerFormat) return 36249; // S3TC

    if (p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format || p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format) {
      if (encoding === sRGBEncoding) {
        extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');

        if (extension !== null) {
          if (p === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (p === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (p === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (p === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else {
          return null;
        }
      } else {
        extension = extensions.get('WEBGL_compressed_texture_s3tc');

        if (extension !== null) {
          if (p === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
          if (p === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
          if (p === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
          if (p === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
        } else {
          return null;
        }
      }
    } // PVRTC


    if (p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format || p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format) {
      extension = extensions.get('WEBGL_compressed_texture_pvrtc');

      if (extension !== null) {
        if (p === RGB_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (p === RGB_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (p === RGBA_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (p === RGBA_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else {
        return null;
      }
    } // ETC1


    if (p === RGB_ETC1_Format) {
      extension = extensions.get('WEBGL_compressed_texture_etc1');

      if (extension !== null) {
        return extension.COMPRESSED_RGB_ETC1_WEBGL;
      } else {
        return null;
      }
    } // ETC2


    if (p === RGB_ETC2_Format || p === RGBA_ETC2_EAC_Format) {
      extension = extensions.get('WEBGL_compressed_texture_etc');

      if (extension !== null) {
        if (p === RGB_ETC2_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
        if (p === RGBA_ETC2_EAC_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
      } else {
        return null;
      }
    } // ASTC


    if (p === RGBA_ASTC_4x4_Format || p === RGBA_ASTC_5x4_Format || p === RGBA_ASTC_5x5_Format || p === RGBA_ASTC_6x5_Format || p === RGBA_ASTC_6x6_Format || p === RGBA_ASTC_8x5_Format || p === RGBA_ASTC_8x6_Format || p === RGBA_ASTC_8x8_Format || p === RGBA_ASTC_10x5_Format || p === RGBA_ASTC_10x6_Format || p === RGBA_ASTC_10x8_Format || p === RGBA_ASTC_10x10_Format || p === RGBA_ASTC_12x10_Format || p === RGBA_ASTC_12x12_Format) {
      extension = extensions.get('WEBGL_compressed_texture_astc');

      if (extension !== null) {
        if (p === RGBA_ASTC_4x4_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (p === RGBA_ASTC_5x4_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (p === RGBA_ASTC_5x5_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (p === RGBA_ASTC_6x5_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (p === RGBA_ASTC_6x6_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (p === RGBA_ASTC_8x5_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (p === RGBA_ASTC_8x6_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (p === RGBA_ASTC_8x8_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (p === RGBA_ASTC_10x5_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (p === RGBA_ASTC_10x6_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (p === RGBA_ASTC_10x8_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (p === RGBA_ASTC_10x10_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (p === RGBA_ASTC_12x10_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (p === RGBA_ASTC_12x12_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else {
        return null;
      }
    } // BPTC


    if (p === RGBA_BPTC_Format) {
      extension = extensions.get('EXT_texture_compression_bptc');

      if (extension !== null) {
        if (p === RGBA_BPTC_Format) return encoding === sRGBEncoding ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
      } else {
        return null;
      }
    } //


    if (p === UnsignedInt248Type) {
      if (isWebGL2) return 34042;
      extension = extensions.get('WEBGL_depth_texture');

      if (extension !== null) {
        return extension.UNSIGNED_INT_24_8_WEBGL;
      } else {
        return null;
      }
    } // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)


    return gl[p] !== undefined ? gl[p] : null;
  }

  return {
    convert: convert
  };
}

var ArrayCamera = /*#__PURE__*/function (_PerspectiveCamera) {
  _inherits(ArrayCamera, _PerspectiveCamera);

  var _super25 = _createSuper(ArrayCamera);

  function ArrayCamera() {
    var _this22;

    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck2(this, ArrayCamera);

    _this22 = _super25.call(this);
    _this22.cameras = array;
    return _this22;
  }

  return ArrayCamera;
}(PerspectiveCamera);

ArrayCamera.prototype.isArrayCamera = true;

var Group = /*#__PURE__*/function (_Object3D4) {
  _inherits(Group, _Object3D4);

  var _super26 = _createSuper(Group);

  function Group() {
    var _this23;

    _classCallCheck2(this, Group);

    _this23 = _super26.call(this);
    _this23.type = 'Group';
    return _this23;
  }

  return Group;
}(Object3D);

Group.prototype.isGroup = true;
var _moveEvent = {
  type: 'move'
};

var WebXRController = /*#__PURE__*/function () {
  function WebXRController() {
    _classCallCheck2(this, WebXRController);

    this._targetRay = null;
    this._grip = null;
    this._hand = null;
  }

  _createClass2(WebXRController, [{
    key: "getHandSpace",
    value: function getHandSpace() {
      if (this._hand === null) {
        this._hand = new Group();
        this._hand.matrixAutoUpdate = false;
        this._hand.visible = false;
        this._hand.joints = {};
        this._hand.inputState = {
          pinching: false
        };
      }

      return this._hand;
    }
  }, {
    key: "getTargetRaySpace",
    value: function getTargetRaySpace() {
      if (this._targetRay === null) {
        this._targetRay = new Group();
        this._targetRay.matrixAutoUpdate = false;
        this._targetRay.visible = false;
        this._targetRay.hasLinearVelocity = false;
        this._targetRay.linearVelocity = new Vector3();
        this._targetRay.hasAngularVelocity = false;
        this._targetRay.angularVelocity = new Vector3();
      }

      return this._targetRay;
    }
  }, {
    key: "getGripSpace",
    value: function getGripSpace() {
      if (this._grip === null) {
        this._grip = new Group();
        this._grip.matrixAutoUpdate = false;
        this._grip.visible = false;
        this._grip.hasLinearVelocity = false;
        this._grip.linearVelocity = new Vector3();
        this._grip.hasAngularVelocity = false;
        this._grip.angularVelocity = new Vector3();
      }

      return this._grip;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      if (this._targetRay !== null) {
        this._targetRay.dispatchEvent(event);
      }

      if (this._grip !== null) {
        this._grip.dispatchEvent(event);
      }

      if (this._hand !== null) {
        this._hand.dispatchEvent(event);
      }

      return this;
    }
  }, {
    key: "disconnect",
    value: function disconnect(inputSource) {
      this.dispatchEvent({
        type: 'disconnected',
        data: inputSource
      });

      if (this._targetRay !== null) {
        this._targetRay.visible = false;
      }

      if (this._grip !== null) {
        this._grip.visible = false;
      }

      if (this._hand !== null) {
        this._hand.visible = false;
      }

      return this;
    }
  }, {
    key: "update",
    value: function update(inputSource, frame, referenceSpace) {
      var inputPose = null;
      var gripPose = null;
      var handPose = null;
      var targetRay = this._targetRay;
      var grip = this._grip;
      var hand = this._hand;

      if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
        if (targetRay !== null) {
          inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);

          if (inputPose !== null) {
            targetRay.matrix.fromArray(inputPose.transform.matrix);
            targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);

            if (inputPose.linearVelocity) {
              targetRay.hasLinearVelocity = true;
              targetRay.linearVelocity.copy(inputPose.linearVelocity);
            } else {
              targetRay.hasLinearVelocity = false;
            }

            if (inputPose.angularVelocity) {
              targetRay.hasAngularVelocity = true;
              targetRay.angularVelocity.copy(inputPose.angularVelocity);
            } else {
              targetRay.hasAngularVelocity = false;
            }

            this.dispatchEvent(_moveEvent);
          }
        }

        if (hand && inputSource.hand) {
          handPose = true;

          var _iterator2 = _createForOfIteratorHelper(inputSource.hand.values()),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var inputjoint = _step2.value;
              // Update the joints groups with the XRJoint poses
              var jointPose = frame.getJointPose(inputjoint, referenceSpace);

              if (hand.joints[inputjoint.jointName] === undefined) {
                // The transform of this joint will be updated with the joint pose on each frame
                var _joint = new Group();

                _joint.matrixAutoUpdate = false;
                _joint.visible = false;
                hand.joints[inputjoint.jointName] = _joint; // ??

                hand.add(_joint);
              }

              var joint = hand.joints[inputjoint.jointName];

              if (jointPose !== null) {
                joint.matrix.fromArray(jointPose.transform.matrix);
                joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                joint.jointRadius = jointPose.radius;
              }

              joint.visible = jointPose !== null;
            } // Custom events
            // Check pinchz

          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var indexTip = hand.joints['index-finger-tip'];
          var thumbTip = hand.joints['thumb-tip'];
          var distance = indexTip.position.distanceTo(thumbTip.position);
          var distanceToPinch = 0.02;
          var threshold = 0.005;

          if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
            hand.inputState.pinching = false;
            this.dispatchEvent({
              type: 'pinchend',
              handedness: inputSource.handedness,
              target: this
            });
          } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
            hand.inputState.pinching = true;
            this.dispatchEvent({
              type: 'pinchstart',
              handedness: inputSource.handedness,
              target: this
            });
          }
        } else {
          if (grip !== null && inputSource.gripSpace) {
            gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);

            if (gripPose !== null) {
              grip.matrix.fromArray(gripPose.transform.matrix);
              grip.matrix.decompose(grip.position, grip.rotation, grip.scale);

              if (gripPose.linearVelocity) {
                grip.hasLinearVelocity = true;
                grip.linearVelocity.copy(gripPose.linearVelocity);
              } else {
                grip.hasLinearVelocity = false;
              }

              if (gripPose.angularVelocity) {
                grip.hasAngularVelocity = true;
                grip.angularVelocity.copy(gripPose.angularVelocity);
              } else {
                grip.hasAngularVelocity = false;
              }
            }
          }
        }
      }

      if (targetRay !== null) {
        targetRay.visible = inputPose !== null;
      }

      if (grip !== null) {
        grip.visible = gripPose !== null;
      }

      if (hand !== null) {
        hand.visible = handPose !== null;
      }

      return this;
    }
  }]);

  return WebXRController;
}();

var DepthTexture = /*#__PURE__*/function (_Texture4) {
  _inherits(DepthTexture, _Texture4);

  var _super27 = _createSuper(DepthTexture);

  function DepthTexture(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format) {
    var _this24;

    _classCallCheck2(this, DepthTexture);

    format = format !== undefined ? format : DepthFormat;

    if (format !== DepthFormat && format !== DepthStencilFormat) {
      throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
    }

    if (type === undefined && format === DepthFormat) type = UnsignedShortType;
    if (type === undefined && format === DepthStencilFormat) type = UnsignedInt248Type;
    _this24 = _super27.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    _this24.image = {
      width: width,
      height: height
    };
    _this24.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
    _this24.minFilter = minFilter !== undefined ? minFilter : NearestFilter;
    _this24.flipY = false;
    _this24.generateMipmaps = false;
    return _this24;
  }

  return DepthTexture;
}(Texture);

DepthTexture.prototype.isDepthTexture = true;

var WebXRManager = /*#__PURE__*/function (_EventDispatcher6) {
  _inherits(WebXRManager, _EventDispatcher6);

  var _super28 = _createSuper(WebXRManager);

  function WebXRManager(renderer, gl) {
    var _this25;

    _classCallCheck2(this, WebXRManager);

    _this25 = _super28.call(this);

    var scope = _assertThisInitialized(_this25);

    var session = null;
    var framebufferScaleFactor = 1.0;
    var referenceSpace = null;
    var referenceSpaceType = 'local-floor';
    var customReferenceSpace = null;
    var pose = null;
    var glBinding = null;
    var glProjLayer = null;
    var glBaseLayer = null;
    var xrFrame = null;
    var attributes = gl.getContextAttributes();
    var initialRenderTarget = null;
    var newRenderTarget = null;
    var controllers = [];
    var inputSourcesMap = new Map(); //

    var cameraL = new PerspectiveCamera();
    cameraL.layers.enable(1);
    cameraL.viewport = new Vector4();
    var cameraR = new PerspectiveCamera();
    cameraR.layers.enable(2);
    cameraR.viewport = new Vector4();
    var cameras = [cameraL, cameraR];
    var cameraVR = new ArrayCamera();
    cameraVR.layers.enable(1);
    cameraVR.layers.enable(2);
    var _currentDepthNear = null;
    var _currentDepthFar = null; //

    _this25.cameraAutoUpdate = true;
    _this25.enabled = false;
    _this25.isPresenting = false;

    _this25.getController = function (index) {
      var controller = controllers[index];

      if (controller === undefined) {
        controller = new WebXRController();
        controllers[index] = controller;
      }

      return controller.getTargetRaySpace();
    };

    _this25.getControllerGrip = function (index) {
      var controller = controllers[index];

      if (controller === undefined) {
        controller = new WebXRController();
        controllers[index] = controller;
      }

      return controller.getGripSpace();
    };

    _this25.getHand = function (index) {
      var controller = controllers[index];

      if (controller === undefined) {
        controller = new WebXRController();
        controllers[index] = controller;
      }

      return controller.getHandSpace();
    }; //


    function onSessionEvent(event) {
      var controller = inputSourcesMap.get(event.inputSource);

      if (controller) {
        controller.dispatchEvent({
          type: event.type,
          data: event.inputSource
        });
      }
    }

    function onSessionEnd() {
      inputSourcesMap.forEach(function (controller, inputSource) {
        controller.disconnect(inputSource);
      });
      inputSourcesMap.clear();
      _currentDepthNear = null;
      _currentDepthFar = null; // restore framebuffer/rendering state

      renderer.setRenderTarget(initialRenderTarget);
      glBaseLayer = null;
      glProjLayer = null;
      glBinding = null;
      session = null;
      newRenderTarget = null; //

      animation.stop();
      scope.isPresenting = false;
      scope.dispatchEvent({
        type: 'sessionend'
      });
    }

    _this25.setFramebufferScaleFactor = function (value) {
      framebufferScaleFactor = value;

      if (scope.isPresenting === true) {
        console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
      }
    };

    _this25.setReferenceSpaceType = function (value) {
      referenceSpaceType = value;

      if (scope.isPresenting === true) {
        console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
      }
    };

    _this25.getReferenceSpace = function () {
      return customReferenceSpace || referenceSpace;
    };

    _this25.setReferenceSpace = function (space) {
      customReferenceSpace = space;
    };

    _this25.getBaseLayer = function () {
      return glProjLayer !== null ? glProjLayer : glBaseLayer;
    };

    _this25.getBinding = function () {
      return glBinding;
    };

    _this25.getFrame = function () {
      return xrFrame;
    };

    _this25.getSession = function () {
      return session;
    };

    _this25.setSession = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
        var layerInit, depthFormat, depthType, glDepthFormat, projectionlayerInit, renderTargetProperties;
        return _regeneratorRuntime.wrap(function _callee$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                session = value;

                if (!(session !== null)) {
                  _context8.next = 24;
                  break;
                }

                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);

                if (!(attributes.xrCompatible !== true)) {
                  _context8.next = 14;
                  break;
                }

                _context8.next = 14;
                return gl.makeXRCompatible();

              case 14:
                if (session.renderState.layers === undefined || renderer.capabilities.isWebGL2 === false) {
                  layerInit = {
                    antialias: session.renderState.layers === undefined ? attributes.antialias : true,
                    alpha: attributes.alpha,
                    depth: attributes.depth,
                    stencil: attributes.stencil,
                    framebufferScaleFactor: framebufferScaleFactor
                  };
                  glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                  session.updateRenderState({
                    baseLayer: glBaseLayer
                  });
                  newRenderTarget = new WebGLRenderTarget(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                    format: RGBAFormat,
                    type: UnsignedByteType,
                    encoding: renderer.outputEncoding
                  });
                } else {
                  depthFormat = null;
                  depthType = null;
                  glDepthFormat = null;

                  if (attributes.depth) {
                    glDepthFormat = attributes.stencil ? 35056 : 33190;
                    depthFormat = attributes.stencil ? DepthStencilFormat : DepthFormat;
                    depthType = attributes.stencil ? UnsignedInt248Type : UnsignedShortType;
                  }

                  projectionlayerInit = {
                    colorFormat: renderer.outputEncoding === sRGBEncoding ? 35907 : 32856,
                    depthFormat: glDepthFormat,
                    scaleFactor: framebufferScaleFactor
                  };
                  glBinding = new XRWebGLBinding(session, gl);
                  glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                  session.updateRenderState({
                    layers: [glProjLayer]
                  });
                  newRenderTarget = new WebGLRenderTarget(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                    format: RGBAFormat,
                    type: UnsignedByteType,
                    depthTexture: new DepthTexture(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                    stencilBuffer: attributes.stencil,
                    encoding: renderer.outputEncoding,
                    samples: attributes.antialias ? 4 : 0
                  });
                  renderTargetProperties = renderer.properties.get(newRenderTarget);
                  renderTargetProperties.__ignoreDepthValues = glProjLayer.ignoreDepthValues;
                }

                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                // Set foveation to maximum.

                this.setFoveation(1.0);
                _context8.next = 19;
                return session.requestReferenceSpace(referenceSpaceType);

              case 19:
                referenceSpace = _context8.sent;
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                  type: 'sessionstart'
                });

              case 24:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee, this);
      }));

      return function (_x3) {
        return _ref.apply(this, arguments);
      };
    }();

    function onInputSourcesChange(event) {
      var inputSources = session.inputSources; // Assign controllers to available inputSources

      for (var _i141 = 0; _i141 < inputSources.length; _i141++) {
        var _index5 = inputSources[_i141].handedness === 'right' ? 1 : 0;

        inputSourcesMap.set(inputSources[_i141], controllers[_index5]);
      } // Notify disconnected


      for (var _i142 = 0; _i142 < event.removed.length; _i142++) {
        var inputSource = event.removed[_i142];
        var controller = inputSourcesMap.get(inputSource);

        if (controller) {
          controller.dispatchEvent({
            type: 'disconnected',
            data: inputSource
          });
          inputSourcesMap.delete(inputSource);
        }
      } // Notify connected


      for (var _i143 = 0; _i143 < event.added.length; _i143++) {
        var _inputSource = event.added[_i143];

        var _controller = inputSourcesMap.get(_inputSource);

        if (_controller) {
          _controller.dispatchEvent({
            type: 'connected',
            data: _inputSource
          });
        }
      }
    } //


    var cameraLPos = new Vector3();
    var cameraRPos = new Vector3();
    /**
     * Assumes 2 cameras that are parallel and share an X-axis, and that
     * the cameras' projection and world matrices have already been set.
     * And that near and far planes are identical for both cameras.
     * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
     */

    function setProjectionFromUnion(camera, cameraL, cameraR) {
      cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
      cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
      var ipd = cameraLPos.distanceTo(cameraRPos);
      var projL = cameraL.projectionMatrix.elements;
      var projR = cameraR.projectionMatrix.elements; // VR systems will have identical far and near planes, and
      // most likely identical top and bottom frustum extents.
      // Use the left camera for these values.

      var near = projL[14] / (projL[10] - 1);
      var far = projL[14] / (projL[10] + 1);
      var topFov = (projL[9] + 1) / projL[5];
      var bottomFov = (projL[9] - 1) / projL[5];
      var leftFov = (projL[8] - 1) / projL[0];
      var rightFov = (projR[8] + 1) / projR[0];
      var left = near * leftFov;
      var right = near * rightFov; // Calculate the new camera's position offset from the
      // left camera. xOffset should be roughly half `ipd`.

      var zOffset = ipd / (-leftFov + rightFov);
      var xOffset = zOffset * -leftFov; // TODO: Better way to apply this offset?

      cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
      camera.translateX(xOffset);
      camera.translateZ(zOffset);
      camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
      camera.matrixWorldInverse.copy(camera.matrixWorld).invert(); // Find the union of the frustum values of the cameras and scale
      // the values so that the near plane's position does not change in world space,
      // although must now be relative to the new union camera.

      var near2 = near + zOffset;
      var far2 = far + zOffset;
      var left2 = left - xOffset;
      var right2 = right + (ipd - xOffset);
      var top2 = topFov * far / far2 * near2;
      var bottom2 = bottomFov * far / far2 * near2;
      camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
    }

    function updateCamera(camera, parent) {
      if (parent === null) {
        camera.matrixWorld.copy(camera.matrix);
      } else {
        camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
      }

      camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
    }

    _this25.updateCamera = function (camera) {
      if (session === null) return;
      cameraVR.near = cameraR.near = cameraL.near = camera.near;
      cameraVR.far = cameraR.far = cameraL.far = camera.far;

      if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
        // Note that the new renderState won't apply until the next frame. See #18320
        session.updateRenderState({
          depthNear: cameraVR.near,
          depthFar: cameraVR.far
        });
        _currentDepthNear = cameraVR.near;
        _currentDepthFar = cameraVR.far;
      }

      var parent = camera.parent;
      var cameras = cameraVR.cameras;
      updateCamera(cameraVR, parent);

      for (var _i144 = 0; _i144 < cameras.length; _i144++) {
        updateCamera(cameras[_i144], parent);
      }

      cameraVR.matrixWorld.decompose(cameraVR.position, cameraVR.quaternion, cameraVR.scale); // update user camera and its children

      camera.position.copy(cameraVR.position);
      camera.quaternion.copy(cameraVR.quaternion);
      camera.scale.copy(cameraVR.scale);
      camera.matrix.copy(cameraVR.matrix);
      camera.matrixWorld.copy(cameraVR.matrixWorld);
      var children = camera.children;

      for (var _i145 = 0, l = children.length; _i145 < l; _i145++) {
        children[_i145].updateMatrixWorld(true);
      } // update projection matrix for proper view frustum culling


      if (cameras.length === 2) {
        setProjectionFromUnion(cameraVR, cameraL, cameraR);
      } else {
        // assume single camera setup (AR)
        cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
      }
    };

    _this25.getCamera = function () {
      return cameraVR;
    };

    _this25.getFoveation = function () {
      if (glProjLayer !== null) {
        return glProjLayer.fixedFoveation;
      }

      if (glBaseLayer !== null) {
        return glBaseLayer.fixedFoveation;
      }

      return undefined;
    };

    _this25.setFoveation = function (foveation) {
      // 0 = no foveation = full resolution
      // 1 = maximum foveation = the edges render at lower resolution
      if (glProjLayer !== null) {
        glProjLayer.fixedFoveation = foveation;
      }

      if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) {
        glBaseLayer.fixedFoveation = foveation;
      }
    }; // Animation Loop


    var onAnimationFrameCallback = null;

    function onAnimationFrame(time, frame) {
      pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
      xrFrame = frame;

      if (pose !== null) {
        var views = pose.views;

        if (glBaseLayer !== null) {
          renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
          renderer.setRenderTarget(newRenderTarget);
        }

        var cameraVRNeedsUpdate = false; // check if it's necessary to rebuild cameraVR's camera list

        if (views.length !== cameraVR.cameras.length) {
          cameraVR.cameras.length = 0;
          cameraVRNeedsUpdate = true;
        }

        for (var _i146 = 0; _i146 < views.length; _i146++) {
          var view = views[_i146];
          var viewport = null;

          if (glBaseLayer !== null) {
            viewport = glBaseLayer.getViewport(view);
          } else {
            var glSubImage = glBinding.getViewSubImage(glProjLayer, view);
            viewport = glSubImage.viewport; // For side-by-side projection, we only produce a single texture for both eyes.

            if (_i146 === 0) {
              renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
              renderer.setRenderTarget(newRenderTarget);
            }
          }

          var camera = cameras[_i146];
          camera.matrix.fromArray(view.transform.matrix);
          camera.projectionMatrix.fromArray(view.projectionMatrix);
          camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);

          if (_i146 === 0) {
            cameraVR.matrix.copy(camera.matrix);
          }

          if (cameraVRNeedsUpdate === true) {
            cameraVR.cameras.push(camera);
          }
        }
      } //


      var inputSources = session.inputSources;

      for (var _i147 = 0; _i147 < controllers.length; _i147++) {
        var inputSource = inputSources[_i147];
        var controller = inputSourcesMap.get(inputSource);

        if (controller !== undefined) {
          controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
        }
      }

      if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
      xrFrame = null;
    }

    var animation = new WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);

    _this25.setAnimationLoop = function (callback) {
      onAnimationFrameCallback = callback;
    };

    _this25.dispose = function () {};

    return _this25;
  }

  return WebXRManager;
}(EventDispatcher);

function WebGLMaterials(renderer, properties) {
  function refreshFogUniforms(uniforms, fog) {
    uniforms.fogColor.value.copy(fog.color);

    if (fog.isFog) {
      uniforms.fogNear.value = fog.near;
      uniforms.fogFar.value = fog.far;
    } else if (fog.isFogExp2) {
      uniforms.fogDensity.value = fog.density;
    }
  }

  function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
    if (material.isMeshBasicMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshLambertMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshToonMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsToon(uniforms, material);
    } else if (material.isMeshPhongMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsPhong(uniforms, material);
    } else if (material.isMeshStandardMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsStandard(uniforms, material);

      if (material.isMeshPhysicalMaterial) {
        refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
      }
    } else if (material.isMeshMatcapMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsMatcap(uniforms, material);
    } else if (material.isMeshDepthMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isMeshDistanceMaterial) {
      refreshUniformsCommon(uniforms, material);
      refreshUniformsDistance(uniforms, material);
    } else if (material.isMeshNormalMaterial) {
      refreshUniformsCommon(uniforms, material);
    } else if (material.isLineBasicMaterial) {
      refreshUniformsLine(uniforms, material);

      if (material.isLineDashedMaterial) {
        refreshUniformsDash(uniforms, material);
      }
    } else if (material.isPointsMaterial) {
      refreshUniformsPoints(uniforms, material, pixelRatio, height);
    } else if (material.isSpriteMaterial) {
      refreshUniformsSprites(uniforms, material);
    } else if (material.isShadowMaterial) {
      uniforms.color.value.copy(material.color);
      uniforms.opacity.value = material.opacity;
    } else if (material.isShaderMaterial) {
      material.uniformsNeedUpdate = false; // #15581
    }
  }

  function refreshUniformsCommon(uniforms, material) {
    uniforms.opacity.value = material.opacity;

    if (material.color) {
      uniforms.diffuse.value.copy(material.color);
    }

    if (material.emissive) {
      uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
    }

    if (material.map) {
      uniforms.map.value = material.map;
    }

    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }

    if (material.bumpMap) {
      uniforms.bumpMap.value = material.bumpMap;
      uniforms.bumpScale.value = material.bumpScale;
      if (material.side === BackSide) uniforms.bumpScale.value *= -1;
    }

    if (material.displacementMap) {
      uniforms.displacementMap.value = material.displacementMap;
      uniforms.displacementScale.value = material.displacementScale;
      uniforms.displacementBias.value = material.displacementBias;
    }

    if (material.emissiveMap) {
      uniforms.emissiveMap.value = material.emissiveMap;
    }

    if (material.normalMap) {
      uniforms.normalMap.value = material.normalMap;
      uniforms.normalScale.value.copy(material.normalScale);
      if (material.side === BackSide) uniforms.normalScale.value.negate();
    }

    if (material.specularMap) {
      uniforms.specularMap.value = material.specularMap;
    }

    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    }

    var envMap = properties.get(material).envMap;

    if (envMap) {
      uniforms.envMap.value = envMap;
      uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
      uniforms.reflectivity.value = material.reflectivity;
      uniforms.ior.value = material.ior;
      uniforms.refractionRatio.value = material.refractionRatio;
    }

    if (material.lightMap) {
      uniforms.lightMap.value = material.lightMap; // artist-friendly light intensity scaling factor

      var scaleFactor = renderer.physicallyCorrectLights !== true ? Math.PI : 1;
      uniforms.lightMapIntensity.value = material.lightMapIntensity * scaleFactor;
    }

    if (material.aoMap) {
      uniforms.aoMap.value = material.aoMap;
      uniforms.aoMapIntensity.value = material.aoMapIntensity;
    } // uv repeat and offset setting priorities
    // 1. color map
    // 2. specular map
    // 3. displacementMap map
    // 4. normal map
    // 5. bump map
    // 6. roughnessMap map
    // 7. metalnessMap map
    // 8. alphaMap map
    // 9. emissiveMap map
    // 10. clearcoat map
    // 11. clearcoat normal map
    // 12. clearcoat roughnessMap map
    // 13. specular intensity map
    // 14. specular tint map
    // 15. transmission map
    // 16. thickness map


    var uvScaleMap;

    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.specularMap) {
      uvScaleMap = material.specularMap;
    } else if (material.displacementMap) {
      uvScaleMap = material.displacementMap;
    } else if (material.normalMap) {
      uvScaleMap = material.normalMap;
    } else if (material.bumpMap) {
      uvScaleMap = material.bumpMap;
    } else if (material.roughnessMap) {
      uvScaleMap = material.roughnessMap;
    } else if (material.metalnessMap) {
      uvScaleMap = material.metalnessMap;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    } else if (material.emissiveMap) {
      uvScaleMap = material.emissiveMap;
    } else if (material.clearcoatMap) {
      uvScaleMap = material.clearcoatMap;
    } else if (material.clearcoatNormalMap) {
      uvScaleMap = material.clearcoatNormalMap;
    } else if (material.clearcoatRoughnessMap) {
      uvScaleMap = material.clearcoatRoughnessMap;
    } else if (material.specularIntensityMap) {
      uvScaleMap = material.specularIntensityMap;
    } else if (material.specularColorMap) {
      uvScaleMap = material.specularColorMap;
    } else if (material.transmissionMap) {
      uvScaleMap = material.transmissionMap;
    } else if (material.thicknessMap) {
      uvScaleMap = material.thicknessMap;
    } else if (material.sheenColorMap) {
      uvScaleMap = material.sheenColorMap;
    } else if (material.sheenRoughnessMap) {
      uvScaleMap = material.sheenRoughnessMap;
    }

    if (uvScaleMap !== undefined) {
      // backwards compatibility
      if (uvScaleMap.isWebGLRenderTarget) {
        uvScaleMap = uvScaleMap.texture;
      }

      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }

      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    } // uv repeat and offset setting priorities for uv2
    // 1. ao map
    // 2. light map


    var uv2ScaleMap;

    if (material.aoMap) {
      uv2ScaleMap = material.aoMap;
    } else if (material.lightMap) {
      uv2ScaleMap = material.lightMap;
    }

    if (uv2ScaleMap !== undefined) {
      // backwards compatibility
      if (uv2ScaleMap.isWebGLRenderTarget) {
        uv2ScaleMap = uv2ScaleMap.texture;
      }

      if (uv2ScaleMap.matrixAutoUpdate === true) {
        uv2ScaleMap.updateMatrix();
      }

      uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
    }
  }

  function refreshUniformsLine(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
  }

  function refreshUniformsDash(uniforms, material) {
    uniforms.dashSize.value = material.dashSize;
    uniforms.totalSize.value = material.dashSize + material.gapSize;
    uniforms.scale.value = material.scale;
  }

  function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.size.value = material.size * pixelRatio;
    uniforms.scale.value = height * 0.5;

    if (material.map) {
      uniforms.map.value = material.map;
    }

    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }

    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    } // uv repeat and offset setting priorities
    // 1. color map
    // 2. alpha map


    var uvScaleMap;

    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    }

    if (uvScaleMap !== undefined) {
      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }

      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    }
  }

  function refreshUniformsSprites(uniforms, material) {
    uniforms.diffuse.value.copy(material.color);
    uniforms.opacity.value = material.opacity;
    uniforms.rotation.value = material.rotation;

    if (material.map) {
      uniforms.map.value = material.map;
    }

    if (material.alphaMap) {
      uniforms.alphaMap.value = material.alphaMap;
    }

    if (material.alphaTest > 0) {
      uniforms.alphaTest.value = material.alphaTest;
    } // uv repeat and offset setting priorities
    // 1. color map
    // 2. alpha map


    var uvScaleMap;

    if (material.map) {
      uvScaleMap = material.map;
    } else if (material.alphaMap) {
      uvScaleMap = material.alphaMap;
    }

    if (uvScaleMap !== undefined) {
      if (uvScaleMap.matrixAutoUpdate === true) {
        uvScaleMap.updateMatrix();
      }

      uniforms.uvTransform.value.copy(uvScaleMap.matrix);
    }
  }

  function refreshUniformsPhong(uniforms, material) {
    uniforms.specular.value.copy(material.specular);
    uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
  }

  function refreshUniformsToon(uniforms, material) {
    if (material.gradientMap) {
      uniforms.gradientMap.value = material.gradientMap;
    }
  }

  function refreshUniformsStandard(uniforms, material) {
    uniforms.roughness.value = material.roughness;
    uniforms.metalness.value = material.metalness;

    if (material.roughnessMap) {
      uniforms.roughnessMap.value = material.roughnessMap;
    }

    if (material.metalnessMap) {
      uniforms.metalnessMap.value = material.metalnessMap;
    }

    var envMap = properties.get(material).envMap;

    if (envMap) {
      //uniforms.envMap.value = material.envMap; // part of uniforms common
      uniforms.envMapIntensity.value = material.envMapIntensity;
    }
  }

  function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
    uniforms.ior.value = material.ior; // also part of uniforms common

    if (material.sheen > 0) {
      uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
      uniforms.sheenRoughness.value = material.sheenRoughness;

      if (material.sheenColorMap) {
        uniforms.sheenColorMap.value = material.sheenColorMap;
      }

      if (material.sheenRoughnessMap) {
        uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
      }
    }

    if (material.clearcoat > 0) {
      uniforms.clearcoat.value = material.clearcoat;
      uniforms.clearcoatRoughness.value = material.clearcoatRoughness;

      if (material.clearcoatMap) {
        uniforms.clearcoatMap.value = material.clearcoatMap;
      }

      if (material.clearcoatRoughnessMap) {
        uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
      }

      if (material.clearcoatNormalMap) {
        uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
        uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;

        if (material.side === BackSide) {
          uniforms.clearcoatNormalScale.value.negate();
        }
      }
    }

    if (material.transmission > 0) {
      uniforms.transmission.value = material.transmission;
      uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
      uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);

      if (material.transmissionMap) {
        uniforms.transmissionMap.value = material.transmissionMap;
      }

      uniforms.thickness.value = material.thickness;

      if (material.thicknessMap) {
        uniforms.thicknessMap.value = material.thicknessMap;
      }

      uniforms.attenuationDistance.value = material.attenuationDistance;
      uniforms.attenuationColor.value.copy(material.attenuationColor);
    }

    uniforms.specularIntensity.value = material.specularIntensity;
    uniforms.specularColor.value.copy(material.specularColor);

    if (material.specularIntensityMap) {
      uniforms.specularIntensityMap.value = material.specularIntensityMap;
    }

    if (material.specularColorMap) {
      uniforms.specularColorMap.value = material.specularColorMap;
    }
  }

  function refreshUniformsMatcap(uniforms, material) {
    if (material.matcap) {
      uniforms.matcap.value = material.matcap;
    }
  }

  function refreshUniformsDistance(uniforms, material) {
    uniforms.referencePosition.value.copy(material.referencePosition);
    uniforms.nearDistance.value = material.nearDistance;
    uniforms.farDistance.value = material.farDistance;
  }

  return {
    refreshFogUniforms: refreshFogUniforms,
    refreshMaterialUniforms: refreshMaterialUniforms
  };
}

function createCanvasElement() {
  var canvas = createElementNS('canvas');
  canvas.style.display = 'block';
  return canvas;
}

function WebGLRenderer() {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _canvas = parameters.canvas !== undefined ? parameters.canvas : createCanvasElement(),
      _context = parameters.context !== undefined ? parameters.context : null,
      _depth = parameters.depth !== undefined ? parameters.depth : true,
      _stencil = parameters.stencil !== undefined ? parameters.stencil : true,
      _antialias = parameters.antialias !== undefined ? parameters.antialias : false,
      _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true,
      _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false,
      _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : 'default',
      _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;

  var _alpha;

  if (_context !== null) {
    _alpha = _context.getContextAttributes().alpha;
  } else {
    _alpha = parameters.alpha !== undefined ? parameters.alpha : false;
  }

  var currentRenderList = null;
  var currentRenderState = null; // render() can be called from within a callback triggered by another render.
  // We track this so that the nested render call gets its list and state isolated from the parent render call.

  var renderListStack = [];
  var renderStateStack = []; // public properties

  this.domElement = _canvas; // Debug configuration container

  this.debug = {
    /**
     * Enables error checking and reporting when shader programs are being compiled
     * @type {boolean}
     */
    checkShaderErrors: true
  }; // clearing

  this.autoClear = true;
  this.autoClearColor = true;
  this.autoClearDepth = true;
  this.autoClearStencil = true; // scene graph

  this.sortObjects = true; // user-defined clipping

  this.clippingPlanes = [];
  this.localClippingEnabled = false; // physically based shading

  this.outputEncoding = LinearEncoding; // physical lights

  this.physicallyCorrectLights = false; // tone mapping

  this.toneMapping = NoToneMapping;
  this.toneMappingExposure = 1.0; // internal properties

  var _this = this;

  var _isContextLost = false; // internal state cache

  var _currentActiveCubeFace = 0;
  var _currentActiveMipmapLevel = 0;
  var _currentRenderTarget = null;

  var _currentMaterialId = -1;

  var _currentCamera = null;

  var _currentViewport = new Vector4();

  var _currentScissor = new Vector4();

  var _currentScissorTest = null; //

  var _width = _canvas.width;
  var _height = _canvas.height;
  var _pixelRatio = 1;
  var _opaqueSort = null;
  var _transparentSort = null;

  var _viewport = new Vector4(0, 0, _width, _height);

  var _scissor = new Vector4(0, 0, _width, _height);

  var _scissorTest = false; // frustum

  var _frustum = new Frustum(); // clipping


  var _clippingEnabled = false;
  var _localClippingEnabled = false; // transmission

  var _transmissionRenderTarget = null; // camera matrices cache

  var _projScreenMatrix = new Matrix4();

  var _vector2 = new Vector2();

  var _vector3 = new Vector3();

  var _emptyScene = {
    background: null,
    fog: null,
    environment: null,
    overrideMaterial: null,
    isScene: true
  };

  function getTargetPixelRatio() {
    return _currentRenderTarget === null ? _pixelRatio : 1;
  } // initialize


  var _gl = _context;

  function getContext(contextNames, contextAttributes) {
    for (var _i148 = 0; _i148 < contextNames.length; _i148++) {
      var contextName = contextNames[_i148];

      var context = _canvas.getContext(contextName, contextAttributes);

      if (context !== null) return context;
    }

    return null;
  }

  try {
    var contextAttributes = {
      alpha: true,
      depth: _depth,
      stencil: _stencil,
      antialias: _antialias,
      premultipliedAlpha: _premultipliedAlpha,
      preserveDrawingBuffer: _preserveDrawingBuffer,
      powerPreference: _powerPreference,
      failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
    }; // OffscreenCanvas does not have setAttribute, see #22811

    if ('setAttribute' in _canvas) _canvas.setAttribute('data-engine', "three.js r".concat(REVISION)); // event listeners must be registered before WebGL context is created, see #12753

    _canvas.addEventListener('webglcontextlost', onContextLost, false);

    _canvas.addEventListener('webglcontextrestored', onContextRestore, false);

    if (_gl === null) {
      var contextNames = ['webgl2', 'webgl', 'experimental-webgl'];

      if (_this.isWebGL1Renderer === true) {
        contextNames.shift();
      }

      _gl = getContext(contextNames, contextAttributes);

      if (_gl === null) {
        if (getContext(contextNames)) {
          throw new Error('Error creating WebGL context with your selected attributes.');
        } else {
          throw new Error('Error creating WebGL context.');
        }
      }
    } // Some experimental-webgl implementations do not have getShaderPrecisionFormat


    if (_gl.getShaderPrecisionFormat === undefined) {
      _gl.getShaderPrecisionFormat = function () {
        return {
          'rangeMin': 1,
          'rangeMax': 1,
          'precision': 1
        };
      };
    }
  } catch (error) {
    console.error('THREE.WebGLRenderer: ' + error.message);
    throw error;
  }

  var extensions, capabilities, state, info;
  var properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
  var programCache, materials, renderLists, renderStates, clipping, shadowMap;
  var background, morphtargets, bufferRenderer, indexedBufferRenderer;
  var utils, bindingStates;

  function initGLContext() {
    extensions = new WebGLExtensions(_gl);
    capabilities = new WebGLCapabilities(_gl, extensions, parameters);
    extensions.init(capabilities);
    utils = new WebGLUtils(_gl, extensions, capabilities);
    state = new WebGLState(_gl, extensions, capabilities);
    info = new WebGLInfo(_gl);
    properties = new WebGLProperties();
    textures = new WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
    cubemaps = new WebGLCubeMaps(_this);
    cubeuvmaps = new WebGLCubeUVMaps(_this);
    attributes = new WebGLAttributes(_gl, capabilities);
    bindingStates = new WebGLBindingStates(_gl, extensions, attributes, capabilities);
    geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
    objects = new WebGLObjects(_gl, geometries, attributes, info);
    morphtargets = new WebGLMorphtargets(_gl, capabilities, textures);
    clipping = new WebGLClipping(properties);
    programCache = new WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
    materials = new WebGLMaterials(_this, properties);
    renderLists = new WebGLRenderLists();
    renderStates = new WebGLRenderStates(extensions, capabilities);
    background = new WebGLBackground(_this, cubemaps, state, objects, _alpha, _premultipliedAlpha);
    shadowMap = new WebGLShadowMap(_this, objects, capabilities);
    bufferRenderer = new WebGLBufferRenderer(_gl, extensions, info, capabilities);
    indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
    info.programs = programCache.programs;
    _this.capabilities = capabilities;
    _this.extensions = extensions;
    _this.properties = properties;
    _this.renderLists = renderLists;
    _this.shadowMap = shadowMap;
    _this.state = state;
    _this.info = info;
  }

  initGLContext(); // xr

  var xr = new WebXRManager(_this, _gl);
  this.xr = xr; // API

  this.getContext = function () {
    return _gl;
  };

  this.getContextAttributes = function () {
    return _gl.getContextAttributes();
  };

  this.forceContextLoss = function () {
    var extension = extensions.get('WEBGL_lose_context');
    if (extension) extension.loseContext();
  };

  this.forceContextRestore = function () {
    var extension = extensions.get('WEBGL_lose_context');
    if (extension) extension.restoreContext();
  };

  this.getPixelRatio = function () {
    return _pixelRatio;
  };

  this.setPixelRatio = function (value) {
    if (value === undefined) return;
    _pixelRatio = value;
    this.setSize(_width, _height, false);
  };

  this.getSize = function (target) {
    return target.set(_width, _height);
  };

  this.setSize = function (width, height, updateStyle) {
    if (xr.isPresenting) {
      console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
      return;
    }

    _width = width;
    _height = height;
    _canvas.width = Math.floor(width * _pixelRatio);
    _canvas.height = Math.floor(height * _pixelRatio);

    if (updateStyle !== false) {
      _canvas.style.width = width + 'px';
      _canvas.style.height = height + 'px';
    }

    this.setViewport(0, 0, width, height);
  };

  this.getDrawingBufferSize = function (target) {
    return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
  };

  this.setDrawingBufferSize = function (width, height, pixelRatio) {
    _width = width;
    _height = height;
    _pixelRatio = pixelRatio;
    _canvas.width = Math.floor(width * pixelRatio);
    _canvas.height = Math.floor(height * pixelRatio);
    this.setViewport(0, 0, width, height);
  };

  this.getCurrentViewport = function (target) {
    return target.copy(_currentViewport);
  };

  this.getViewport = function (target) {
    return target.copy(_viewport);
  };

  this.setViewport = function (x, y, width, height) {
    if (x.isVector4) {
      _viewport.set(x.x, x.y, x.z, x.w);
    } else {
      _viewport.set(x, y, width, height);
    }

    state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
  };

  this.getScissor = function (target) {
    return target.copy(_scissor);
  };

  this.setScissor = function (x, y, width, height) {
    if (x.isVector4) {
      _scissor.set(x.x, x.y, x.z, x.w);
    } else {
      _scissor.set(x, y, width, height);
    }

    state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
  };

  this.getScissorTest = function () {
    return _scissorTest;
  };

  this.setScissorTest = function (boolean) {
    state.setScissorTest(_scissorTest = boolean);
  };

  this.setOpaqueSort = function (method) {
    _opaqueSort = method;
  };

  this.setTransparentSort = function (method) {
    _transparentSort = method;
  }; // Clearing


  this.getClearColor = function (target) {
    return target.copy(background.getClearColor());
  };

  this.setClearColor = function () {
    background.setClearColor.apply(background, arguments);
  };

  this.getClearAlpha = function () {
    return background.getClearAlpha();
  };

  this.setClearAlpha = function () {
    background.setClearAlpha.apply(background, arguments);
  };

  this.clear = function () {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var stencil = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var bits = 0;
    if (color) bits |= 16384;
    if (depth) bits |= 256;
    if (stencil) bits |= 1024;

    _gl.clear(bits);
  };

  this.clearColor = function () {
    this.clear(true, false, false);
  };

  this.clearDepth = function () {
    this.clear(false, true, false);
  };

  this.clearStencil = function () {
    this.clear(false, false, true);
  }; //


  this.dispose = function () {
    _canvas.removeEventListener('webglcontextlost', onContextLost, false);

    _canvas.removeEventListener('webglcontextrestored', onContextRestore, false);

    renderLists.dispose();
    renderStates.dispose();
    properties.dispose();
    cubemaps.dispose();
    cubeuvmaps.dispose();
    objects.dispose();
    bindingStates.dispose();
    programCache.dispose();
    xr.dispose();
    xr.removeEventListener('sessionstart', onXRSessionStart);
    xr.removeEventListener('sessionend', onXRSessionEnd);

    if (_transmissionRenderTarget) {
      _transmissionRenderTarget.dispose();

      _transmissionRenderTarget = null;
    }

    animation.stop();
  }; // Events


  function onContextLost(event) {
    event.preventDefault();
    console.log('THREE.WebGLRenderer: Context Lost.');
    _isContextLost = true;
  }

  function
    /* event */
  onContextRestore() {
    console.log('THREE.WebGLRenderer: Context Restored.');
    _isContextLost = false;
    var infoAutoReset = info.autoReset;
    var shadowMapEnabled = shadowMap.enabled;
    var shadowMapAutoUpdate = shadowMap.autoUpdate;
    var shadowMapNeedsUpdate = shadowMap.needsUpdate;
    var shadowMapType = shadowMap.type;
    initGLContext();
    info.autoReset = infoAutoReset;
    shadowMap.enabled = shadowMapEnabled;
    shadowMap.autoUpdate = shadowMapAutoUpdate;
    shadowMap.needsUpdate = shadowMapNeedsUpdate;
    shadowMap.type = shadowMapType;
  }

  function onMaterialDispose(event) {
    var material = event.target;
    material.removeEventListener('dispose', onMaterialDispose);
    deallocateMaterial(material);
  } // Buffer deallocation


  function deallocateMaterial(material) {
    releaseMaterialProgramReferences(material);
    properties.remove(material);
  }

  function releaseMaterialProgramReferences(material) {
    var programs = properties.get(material).programs;

    if (programs !== undefined) {
      programs.forEach(function (program) {
        programCache.releaseProgram(program);
      });

      if (material.isShaderMaterial) {
        programCache.releaseShaderCache(material);
      }
    }
  } // Buffer rendering


  this.renderBufferDirect = function (camera, scene, geometry, material, object, group) {
    if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)

    var frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
    var program = setProgram(camera, scene, geometry, material, object);
    state.setMaterial(material, frontFaceCW); //

    var index = geometry.index;
    var position = geometry.attributes.position; //

    if (index === null) {
      if (position === undefined || position.count === 0) return;
    } else if (index.count === 0) {
      return;
    } //


    var rangeFactor = 1;

    if (material.wireframe === true) {
      index = geometries.getWireframeAttribute(geometry);
      rangeFactor = 2;
    }

    bindingStates.setup(object, material, program, geometry, index);
    var attribute;
    var renderer = bufferRenderer;

    if (index !== null) {
      attribute = attributes.get(index);
      renderer = indexedBufferRenderer;
      renderer.setIndex(attribute);
    } //


    var dataCount = index !== null ? index.count : position.count;
    var rangeStart = geometry.drawRange.start * rangeFactor;
    var rangeCount = geometry.drawRange.count * rangeFactor;
    var groupStart = group !== null ? group.start * rangeFactor : 0;
    var groupCount = group !== null ? group.count * rangeFactor : Infinity;
    var drawStart = Math.max(rangeStart, groupStart);
    var drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
    var drawCount = Math.max(0, drawEnd - drawStart + 1);
    if (drawCount === 0) return; //

    if (object.isMesh) {
      if (material.wireframe === true) {
        state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
        renderer.setMode(1);
      } else {
        renderer.setMode(4);
      }
    } else if (object.isLine) {
      var lineWidth = material.linewidth;
      if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material

      state.setLineWidth(lineWidth * getTargetPixelRatio());

      if (object.isLineSegments) {
        renderer.setMode(1);
      } else if (object.isLineLoop) {
        renderer.setMode(2);
      } else {
        renderer.setMode(3);
      }
    } else if (object.isPoints) {
      renderer.setMode(0);
    } else if (object.isSprite) {
      renderer.setMode(4);
    }

    if (object.isInstancedMesh) {
      renderer.renderInstances(drawStart, drawCount, object.count);
    } else if (geometry.isInstancedBufferGeometry) {
      var instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
      renderer.renderInstances(drawStart, drawCount, instanceCount);
    } else {
      renderer.render(drawStart, drawCount);
    }
  }; // Compile


  this.compile = function (scene, camera) {
    currentRenderState = renderStates.get(scene);
    currentRenderState.init();
    renderStateStack.push(currentRenderState);
    scene.traverseVisible(function (object) {
      if (object.isLight && object.layers.test(camera.layers)) {
        currentRenderState.pushLight(object);

        if (object.castShadow) {
          currentRenderState.pushShadow(object);
        }
      }
    });
    currentRenderState.setupLights(_this.physicallyCorrectLights);
    scene.traverse(function (object) {
      var material = object.material;

      if (material) {
        if (Array.isArray(material)) {
          for (var _i149 = 0; _i149 < material.length; _i149++) {
            var material2 = material[_i149];
            getProgram(material2, scene, object);
          }
        } else {
          getProgram(material, scene, object);
        }
      }
    });
    renderStateStack.pop();
    currentRenderState = null;
  }; // Animation Loop


  var onAnimationFrameCallback = null;

  function onAnimationFrame(time) {
    if (onAnimationFrameCallback) onAnimationFrameCallback(time);
  }

  function onXRSessionStart() {
    animation.stop();
  }

  function onXRSessionEnd() {
    animation.start();
  }

  var animation = new WebGLAnimation();
  animation.setAnimationLoop(onAnimationFrame);
  if (typeof self !== 'undefined') animation.setContext(self);

  this.setAnimationLoop = function (callback) {
    onAnimationFrameCallback = callback;
    xr.setAnimationLoop(callback);
    callback === null ? animation.stop() : animation.start();
  };

  xr.addEventListener('sessionstart', onXRSessionStart);
  xr.addEventListener('sessionend', onXRSessionEnd); // Rendering

  this.render = function (scene, camera) {
    if (camera !== undefined && camera.isCamera !== true) {
      console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
      return;
    }

    if (_isContextLost === true) return; // update scene graph

    if (scene.autoUpdate === true) scene.updateMatrixWorld(); // update camera matrices and frustum

    if (camera.parent === null) camera.updateMatrixWorld();

    if (xr.enabled === true && xr.isPresenting === true) {
      if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
      camera = xr.getCamera(); // use XR camera for rendering
    } //


    if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
    currentRenderState = renderStates.get(scene, renderStateStack.length);
    currentRenderState.init();
    renderStateStack.push(currentRenderState);

    _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);

    _frustum.setFromProjectionMatrix(_projScreenMatrix);

    _localClippingEnabled = this.localClippingEnabled;
    _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
    currentRenderList = renderLists.get(scene, renderListStack.length);
    currentRenderList.init();
    renderListStack.push(currentRenderList);
    projectObject(scene, camera, 0, _this.sortObjects);
    currentRenderList.finish();

    if (_this.sortObjects === true) {
      currentRenderList.sort(_opaqueSort, _transparentSort);
    } //


    if (_clippingEnabled === true) clipping.beginShadows();
    var shadowsArray = currentRenderState.state.shadowsArray;
    shadowMap.render(shadowsArray, scene, camera);
    if (_clippingEnabled === true) clipping.endShadows(); //

    if (this.info.autoReset === true) this.info.reset(); //

    background.render(currentRenderList, scene); // render scene

    currentRenderState.setupLights(_this.physicallyCorrectLights);

    if (camera.isArrayCamera) {
      var cameras = camera.cameras;

      for (var _i150 = 0, l = cameras.length; _i150 < l; _i150++) {
        var camera2 = cameras[_i150];
        renderScene(currentRenderList, scene, camera2, camera2.viewport);
      }
    } else {
      renderScene(currentRenderList, scene, camera);
    } //


    if (_currentRenderTarget !== null) {
      // resolve multisample renderbuffers to a single-sample texture if necessary
      textures.updateMultisampleRenderTarget(_currentRenderTarget); // Generate mipmap if we're using any kind of mipmap filtering

      textures.updateRenderTargetMipmap(_currentRenderTarget);
    } //


    if (scene.isScene === true) scene.onAfterRender(_this, scene, camera); // _gl.finish();

    bindingStates.resetDefaultState();
    _currentMaterialId = -1;
    _currentCamera = null;
    renderStateStack.pop();

    if (renderStateStack.length > 0) {
      currentRenderState = renderStateStack[renderStateStack.length - 1];
    } else {
      currentRenderState = null;
    }

    renderListStack.pop();

    if (renderListStack.length > 0) {
      currentRenderList = renderListStack[renderListStack.length - 1];
    } else {
      currentRenderList = null;
    }
  };

  function projectObject(object, camera, groupOrder, sortObjects) {
    if (object.visible === false) return;
    var visible = object.layers.test(camera.layers);

    if (visible) {
      if (object.isGroup) {
        groupOrder = object.renderOrder;
      } else if (object.isLOD) {
        if (object.autoUpdate === true) object.update(camera);
      } else if (object.isLight) {
        currentRenderState.pushLight(object);

        if (object.castShadow) {
          currentRenderState.pushShadow(object);
        }
      } else if (object.isSprite) {
        if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
          if (sortObjects) {
            _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
          }

          var geometry = objects.update(object);
          var material = object.material;

          if (material.visible) {
            currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
          }
        }
      } else if (object.isMesh || object.isLine || object.isPoints) {
        if (object.isSkinnedMesh) {
          // update skeleton only once in a frame
          if (object.skeleton.frame !== info.render.frame) {
            object.skeleton.update();
            object.skeleton.frame = info.render.frame;
          }
        }

        if (!object.frustumCulled || _frustum.intersectsObject(object)) {
          if (sortObjects) {
            _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
          }

          var _geometry2 = objects.update(object);

          var _material = object.material;

          if (Array.isArray(_material)) {
            var groups = _geometry2.groups;

            for (var _i151 = 0, l = groups.length; _i151 < l; _i151++) {
              var group = groups[_i151];
              var groupMaterial = _material[group.materialIndex];

              if (groupMaterial && groupMaterial.visible) {
                currentRenderList.push(object, _geometry2, groupMaterial, groupOrder, _vector3.z, group);
              }
            }
          } else if (_material.visible) {
            currentRenderList.push(object, _geometry2, _material, groupOrder, _vector3.z, null);
          }
        }
      }
    }

    var children = object.children;

    for (var _i152 = 0, _l6 = children.length; _i152 < _l6; _i152++) {
      projectObject(children[_i152], camera, groupOrder, sortObjects);
    }
  }

  function renderScene(currentRenderList, scene, camera, viewport) {
    var opaqueObjects = currentRenderList.opaque;
    var transmissiveObjects = currentRenderList.transmissive;
    var transparentObjects = currentRenderList.transparent;
    currentRenderState.setupLightsView(camera);
    if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, scene, camera);
    if (viewport) state.viewport(_currentViewport.copy(viewport));
    if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
    if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
    if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera); // Ensure depth buffer writing is enabled so it can be cleared on next render

    state.buffers.depth.setTest(true);
    state.buffers.depth.setMask(true);
    state.buffers.color.setMask(true);
    state.setPolygonOffset(false);
  }

  function renderTransmissionPass(opaqueObjects, scene, camera) {
    var isWebGL2 = capabilities.isWebGL2;

    if (_transmissionRenderTarget === null) {
      _transmissionRenderTarget = new WebGLRenderTarget(1, 1, {
        generateMipmaps: true,
        type: extensions.has('EXT_color_buffer_half_float') ? HalfFloatType : UnsignedByteType,
        minFilter: LinearMipmapLinearFilter,
        samples: isWebGL2 && _antialias === true ? 4 : 0
      });
    }

    _this.getDrawingBufferSize(_vector2);

    if (isWebGL2) {
      _transmissionRenderTarget.setSize(_vector2.x, _vector2.y);
    } else {
      _transmissionRenderTarget.setSize(floorPowerOfTwo(_vector2.x), floorPowerOfTwo(_vector2.y));
    } //


    var currentRenderTarget = _this.getRenderTarget();

    _this.setRenderTarget(_transmissionRenderTarget);

    _this.clear(); // Turn off the features which can affect the frag color for opaque objects pass.
    // Otherwise they are applied twice in opaque objects pass and transmission objects pass.


    var currentToneMapping = _this.toneMapping;
    _this.toneMapping = NoToneMapping;
    renderObjects(opaqueObjects, scene, camera);
    _this.toneMapping = currentToneMapping;
    textures.updateMultisampleRenderTarget(_transmissionRenderTarget);
    textures.updateRenderTargetMipmap(_transmissionRenderTarget);

    _this.setRenderTarget(currentRenderTarget);
  }

  function renderObjects(renderList, scene, camera) {
    var overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;

    for (var _i153 = 0, l = renderList.length; _i153 < l; _i153++) {
      var renderItem = renderList[_i153];
      var object = renderItem.object;
      var geometry = renderItem.geometry;
      var material = overrideMaterial === null ? renderItem.material : overrideMaterial;
      var group = renderItem.group;

      if (object.layers.test(camera.layers)) {
        renderObject(object, scene, camera, geometry, material, group);
      }
    }
  }

  function renderObject(object, scene, camera, geometry, material, group) {
    object.onBeforeRender(_this, scene, camera, geometry, material, group);
    object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
    object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
    material.onBeforeRender(_this, scene, camera, geometry, object, group);

    if (material.transparent === true && material.side === DoubleSide) {
      material.side = BackSide;
      material.needsUpdate = true;

      _this.renderBufferDirect(camera, scene, geometry, material, object, group);

      material.side = FrontSide;
      material.needsUpdate = true;

      _this.renderBufferDirect(camera, scene, geometry, material, object, group);

      material.side = DoubleSide;
    } else {
      _this.renderBufferDirect(camera, scene, geometry, material, object, group);
    }

    object.onAfterRender(_this, scene, camera, geometry, material, group);
  }

  function getProgram(material, scene, object) {
    if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...

    var materialProperties = properties.get(material);
    var lights = currentRenderState.state.lights;
    var shadowsArray = currentRenderState.state.shadowsArray;
    var lightsStateVersion = lights.state.version;
    var parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
    var programCacheKey = programCache.getProgramCacheKey(parameters);
    var programs = materialProperties.programs; // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change

    materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
    materialProperties.fog = scene.fog;
    materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);

    if (programs === undefined) {
      // new material
      material.addEventListener('dispose', onMaterialDispose);
      programs = new Map();
      materialProperties.programs = programs;
    }

    var program = programs.get(programCacheKey);

    if (program !== undefined) {
      // early out if program and light state is identical
      if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
        updateCommonMaterialProperties(material, parameters);
        return program;
      }
    } else {
      parameters.uniforms = programCache.getUniforms(material);
      material.onBuild(object, parameters, _this);
      material.onBeforeCompile(parameters, _this);
      program = programCache.acquireProgram(parameters, programCacheKey);
      programs.set(programCacheKey, program);
      materialProperties.uniforms = parameters.uniforms;
    }

    var uniforms = materialProperties.uniforms;

    if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {
      uniforms.clippingPlanes = clipping.uniform;
    }

    updateCommonMaterialProperties(material, parameters); // store the light setup it was created for

    materialProperties.needsLights = materialNeedsLights(material);
    materialProperties.lightsStateVersion = lightsStateVersion;

    if (materialProperties.needsLights) {
      // wire up the material to this renderer's lighting state
      uniforms.ambientLightColor.value = lights.state.ambient;
      uniforms.lightProbe.value = lights.state.probe;
      uniforms.directionalLights.value = lights.state.directional;
      uniforms.directionalLightShadows.value = lights.state.directionalShadow;
      uniforms.spotLights.value = lights.state.spot;
      uniforms.spotLightShadows.value = lights.state.spotShadow;
      uniforms.rectAreaLights.value = lights.state.rectArea;
      uniforms.ltc_1.value = lights.state.rectAreaLTC1;
      uniforms.ltc_2.value = lights.state.rectAreaLTC2;
      uniforms.pointLights.value = lights.state.point;
      uniforms.pointLightShadows.value = lights.state.pointShadow;
      uniforms.hemisphereLights.value = lights.state.hemi;
      uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
      uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
      uniforms.spotShadowMap.value = lights.state.spotShadowMap;
      uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
      uniforms.pointShadowMap.value = lights.state.pointShadowMap;
      uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix; // TODO (abelnation): add area lights shadow info to uniforms
    }

    var progUniforms = program.getUniforms();
    var uniformsList = WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
    materialProperties.currentProgram = program;
    materialProperties.uniformsList = uniformsList;
    return program;
  }

  function updateCommonMaterialProperties(material, parameters) {
    var materialProperties = properties.get(material);
    materialProperties.outputEncoding = parameters.outputEncoding;
    materialProperties.instancing = parameters.instancing;
    materialProperties.skinning = parameters.skinning;
    materialProperties.morphTargets = parameters.morphTargets;
    materialProperties.morphNormals = parameters.morphNormals;
    materialProperties.morphColors = parameters.morphColors;
    materialProperties.morphTargetsCount = parameters.morphTargetsCount;
    materialProperties.numClippingPlanes = parameters.numClippingPlanes;
    materialProperties.numIntersection = parameters.numClipIntersection;
    materialProperties.vertexAlphas = parameters.vertexAlphas;
    materialProperties.vertexTangents = parameters.vertexTangents;
    materialProperties.toneMapping = parameters.toneMapping;
  }

  function setProgram(camera, scene, geometry, material, object) {
    if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...

    textures.resetTextureUnits();
    var fog = scene.fog;
    var environment = material.isMeshStandardMaterial ? scene.environment : null;
    var encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.encoding : LinearEncoding;
    var envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
    var vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
    var vertexTangents = !!material.normalMap && !!geometry.attributes.tangent;
    var morphTargets = !!geometry.morphAttributes.position;
    var morphNormals = !!geometry.morphAttributes.normal;
    var morphColors = !!geometry.morphAttributes.color;
    var toneMapping = material.toneMapped ? _this.toneMapping : NoToneMapping;
    var morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
    var morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
    var materialProperties = properties.get(material);
    var lights = currentRenderState.state.lights;

    if (_clippingEnabled === true) {
      if (_localClippingEnabled === true || camera !== _currentCamera) {
        var useCache = camera === _currentCamera && material.id === _currentMaterialId; // we might want to call this function with some ClippingGroup
        // object instead of the material, once it becomes feasible
        // (#8465, #8379)

        clipping.setState(material, camera, useCache);
      }
    } //


    var needsProgramChange = false;

    if (material.version === materialProperties.__version) {
      if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) {
        needsProgramChange = true;
      } else if (materialProperties.outputEncoding !== encoding) {
        needsProgramChange = true;
      } else if (object.isInstancedMesh && materialProperties.instancing === false) {
        needsProgramChange = true;
      } else if (!object.isInstancedMesh && materialProperties.instancing === true) {
        needsProgramChange = true;
      } else if (object.isSkinnedMesh && materialProperties.skinning === false) {
        needsProgramChange = true;
      } else if (!object.isSkinnedMesh && materialProperties.skinning === true) {
        needsProgramChange = true;
      } else if (materialProperties.envMap !== envMap) {
        needsProgramChange = true;
      } else if (material.fog === true && materialProperties.fog !== fog) {
        needsProgramChange = true;
      } else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) {
        needsProgramChange = true;
      } else if (materialProperties.vertexAlphas !== vertexAlphas) {
        needsProgramChange = true;
      } else if (materialProperties.vertexTangents !== vertexTangents) {
        needsProgramChange = true;
      } else if (materialProperties.morphTargets !== morphTargets) {
        needsProgramChange = true;
      } else if (materialProperties.morphNormals !== morphNormals) {
        needsProgramChange = true;
      } else if (materialProperties.morphColors !== morphColors) {
        needsProgramChange = true;
      } else if (materialProperties.toneMapping !== toneMapping) {
        needsProgramChange = true;
      } else if (capabilities.isWebGL2 === true && materialProperties.morphTargetsCount !== morphTargetsCount) {
        needsProgramChange = true;
      }
    } else {
      needsProgramChange = true;
      materialProperties.__version = material.version;
    } //


    var program = materialProperties.currentProgram;

    if (needsProgramChange === true) {
      program = getProgram(material, scene, object);
    }

    var refreshProgram = false;
    var refreshMaterial = false;
    var refreshLights = false;
    var p_uniforms = program.getUniforms(),
        m_uniforms = materialProperties.uniforms;

    if (state.useProgram(program.program)) {
      refreshProgram = true;
      refreshMaterial = true;
      refreshLights = true;
    }

    if (material.id !== _currentMaterialId) {
      _currentMaterialId = material.id;
      refreshMaterial = true;
    }

    if (refreshProgram || _currentCamera !== camera) {
      p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);

      if (capabilities.logarithmicDepthBuffer) {
        p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
      }

      if (_currentCamera !== camera) {
        _currentCamera = camera; // lighting uniforms depend on the camera so enforce an update
        // now, in case this material supports lights - or later, when
        // the next material that does gets activated:

        refreshMaterial = true; // set to true on material change

        refreshLights = true; // remains set until update done
      } // load material specific uniforms
      // (shader material also gets them for the sake of genericity)


      if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
        var uCamPos = p_uniforms.map.cameraPosition;

        if (uCamPos !== undefined) {
          uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
        }
      }

      if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) {
        p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
      }

      if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || object.isSkinnedMesh) {
        p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
      }
    } // skinning and morph target uniforms must be set even if material didn't change
    // auto-setting of texture unit for bone and morph texture must go before other textures
    // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures


    if (object.isSkinnedMesh) {
      p_uniforms.setOptional(_gl, object, 'bindMatrix');
      p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
      var skeleton = object.skeleton;

      if (skeleton) {
        if (capabilities.floatVertexTextures) {
          if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
          p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
          p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
        } else {
          console.warn('THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required.');
        }
      }
    }

    var morphAttributes = geometry.morphAttributes;

    if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined && capabilities.isWebGL2 === true) {
      morphtargets.update(object, geometry, material, program);
    }

    if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
      materialProperties.receiveShadow = object.receiveShadow;
      p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
    }

    if (refreshMaterial) {
      p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);

      if (materialProperties.needsLights) {
        // the current material requires lighting info
        // note: all lighting uniforms are always set correctly
        // they simply reference the renderer's state for their
        // values
        //
        // use the current material's .needsUpdate flags to set
        // the GL state when required
        markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
      } // refresh uniforms common to several materials


      if (fog && material.fog === true) {
        materials.refreshFogUniforms(m_uniforms, fog);
      }

      materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, _transmissionRenderTarget);
      WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
    }

    if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
      WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
      material.uniformsNeedUpdate = false;
    }

    if (material.isSpriteMaterial) {
      p_uniforms.setValue(_gl, 'center', object.center);
    } // common matrices


    p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
    p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
    p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
    return program;
  } // If uniforms are marked as clean, they don't need to be loaded to the GPU.


  function markUniformsLightsNeedsUpdate(uniforms, value) {
    uniforms.ambientLightColor.needsUpdate = value;
    uniforms.lightProbe.needsUpdate = value;
    uniforms.directionalLights.needsUpdate = value;
    uniforms.directionalLightShadows.needsUpdate = value;
    uniforms.pointLights.needsUpdate = value;
    uniforms.pointLightShadows.needsUpdate = value;
    uniforms.spotLights.needsUpdate = value;
    uniforms.spotLightShadows.needsUpdate = value;
    uniforms.rectAreaLights.needsUpdate = value;
    uniforms.hemisphereLights.needsUpdate = value;
  }

  function materialNeedsLights(material) {
    return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
  }

  this.getActiveCubeFace = function () {
    return _currentActiveCubeFace;
  };

  this.getActiveMipmapLevel = function () {
    return _currentActiveMipmapLevel;
  };

  this.getRenderTarget = function () {
    return _currentRenderTarget;
  };

  this.setRenderTargetTextures = function (renderTarget, colorTexture, depthTexture) {
    properties.get(renderTarget.texture).__webglTexture = colorTexture;
    properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
    var renderTargetProperties = properties.get(renderTarget);
    renderTargetProperties.__hasExternalTextures = true;

    if (renderTargetProperties.__hasExternalTextures) {
      renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;

      if (!renderTargetProperties.__autoAllocateDepthBuffer) {
        // The multisample_render_to_texture extension doesn't work properly if there
        // are midframe flushes and an external depth buffer. Disable use of the extension.
        if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
          console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
          renderTargetProperties.__useRenderToTexture = false;
        }
      }
    }
  };

  this.setRenderTargetFramebuffer = function (renderTarget, defaultFramebuffer) {
    var renderTargetProperties = properties.get(renderTarget);
    renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
    renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
  };

  this.setRenderTarget = function (renderTarget) {
    var activeCubeFace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var activeMipmapLevel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    _currentRenderTarget = renderTarget;
    _currentActiveCubeFace = activeCubeFace;
    _currentActiveMipmapLevel = activeMipmapLevel;
    var useDefaultFramebuffer = true;

    if (renderTarget) {
      var renderTargetProperties = properties.get(renderTarget);

      if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
        // We need to make sure to rebind the framebuffer.
        state.bindFramebuffer(36160, null);
        useDefaultFramebuffer = false;
      } else if (renderTargetProperties.__webglFramebuffer === undefined) {
        textures.setupRenderTarget(renderTarget);
      } else if (renderTargetProperties.__hasExternalTextures) {
        // Color and depth texture must be rebound in order for the swapchain to update.
        textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
      }
    }

    var framebuffer = null;
    var isCube = false;
    var isRenderTarget3D = false;

    if (renderTarget) {
      var texture = renderTarget.texture;

      if (texture.isData3DTexture || texture.isDataArrayTexture) {
        isRenderTarget3D = true;
      }

      var __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;

      if (renderTarget.isWebGLCubeRenderTarget) {
        framebuffer = __webglFramebuffer[activeCubeFace];
        isCube = true;
      } else if (capabilities.isWebGL2 && renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) {
        framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
      } else {
        framebuffer = __webglFramebuffer;
      }

      _currentViewport.copy(renderTarget.viewport);

      _currentScissor.copy(renderTarget.scissor);

      _currentScissorTest = renderTarget.scissorTest;
    } else {
      _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();

      _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();

      _currentScissorTest = _scissorTest;
    }

    var framebufferBound = state.bindFramebuffer(36160, framebuffer);

    if (framebufferBound && capabilities.drawBuffers && useDefaultFramebuffer) {
      state.drawBuffers(renderTarget, framebuffer);
    }

    state.viewport(_currentViewport);
    state.scissor(_currentScissor);
    state.setScissorTest(_currentScissorTest);

    if (isCube) {
      var textureProperties = properties.get(renderTarget.texture);

      _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
    } else if (isRenderTarget3D) {
      var _textureProperties = properties.get(renderTarget.texture);

      var layer = activeCubeFace || 0;

      _gl.framebufferTextureLayer(36160, 36064, _textureProperties.__webglTexture, activeMipmapLevel || 0, layer);
    }

    _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
  };

  this.readRenderTargetPixels = function (renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
    if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
      console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
      return;
    }

    var framebuffer = properties.get(renderTarget).__webglFramebuffer;

    if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) {
      framebuffer = framebuffer[activeCubeFaceIndex];
    }

    if (framebuffer) {
      state.bindFramebuffer(36160, framebuffer);

      try {
        var texture = renderTarget.texture;
        var textureFormat = texture.format;
        var textureType = texture.type;

        if (textureFormat !== RGBAFormat && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
          console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
          return;
        }

        var halfFloatSupportedByExt = textureType === HalfFloatType && (extensions.has('EXT_color_buffer_half_float') || capabilities.isWebGL2 && extensions.has('EXT_color_buffer_float'));

        if (textureType !== UnsignedByteType && utils.convert(textureType) !== _gl.getParameter(35738) && // Edge and Chrome Mac < 52 (#9513)
        !(textureType === FloatType && (capabilities.isWebGL2 || extensions.has('OES_texture_float') || extensions.has('WEBGL_color_buffer_float'))) && // Chrome Mac >= 52 and Firefox
        !halfFloatSupportedByExt) {
          console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
          return;
        } // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)


        if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
          _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
        }
      } finally {
        // restore framebuffer of current render target if necessary
        var _framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;

        state.bindFramebuffer(36160, _framebuffer);
      }
    }
  };

  this.copyFramebufferToTexture = function (position, texture) {
    var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (texture.isFramebufferTexture !== true) {
      console.error('THREE.WebGLRenderer: copyFramebufferToTexture() can only be used with FramebufferTexture.');
      return;
    }

    var levelScale = Math.pow(2, -level);
    var width = Math.floor(texture.image.width * levelScale);
    var height = Math.floor(texture.image.height * levelScale);
    textures.setTexture2D(texture, 0);

    _gl.copyTexSubImage2D(3553, level, 0, 0, position.x, position.y, width, height);

    state.unbindTexture();
  };

  this.copyTextureToTexture = function (position, srcTexture, dstTexture) {
    var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var width = srcTexture.image.width;
    var height = srcTexture.image.height;
    var glFormat = utils.convert(dstTexture.format);
    var glType = utils.convert(dstTexture.type);
    textures.setTexture2D(dstTexture, 0); // As another texture upload may have changed pixelStorei
    // parameters, make sure they are correct for the dstTexture

    _gl.pixelStorei(37440, dstTexture.flipY);

    _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);

    _gl.pixelStorei(3317, dstTexture.unpackAlignment);

    if (srcTexture.isDataTexture) {
      _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
    } else {
      if (srcTexture.isCompressedTexture) {
        _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
      } else {
        _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
      }
    } // Generate mipmaps only when copying level 0


    if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
    state.unbindTexture();
  };

  this.copyTextureToTexture3D = function (sourceBox, position, srcTexture, dstTexture) {
    var level = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    if (_this.isWebGL1Renderer) {
      console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.');
      return;
    }

    var width = sourceBox.max.x - sourceBox.min.x + 1;
    var height = sourceBox.max.y - sourceBox.min.y + 1;
    var depth = sourceBox.max.z - sourceBox.min.z + 1;
    var glFormat = utils.convert(dstTexture.format);
    var glType = utils.convert(dstTexture.type);
    var glTarget;

    if (dstTexture.isData3DTexture) {
      textures.setTexture3D(dstTexture, 0);
      glTarget = 32879;
    } else if (dstTexture.isDataArrayTexture) {
      textures.setTexture2DArray(dstTexture, 0);
      glTarget = 35866;
    } else {
      console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.');
      return;
    }

    _gl.pixelStorei(37440, dstTexture.flipY);

    _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);

    _gl.pixelStorei(3317, dstTexture.unpackAlignment);

    var unpackRowLen = _gl.getParameter(3314);

    var unpackImageHeight = _gl.getParameter(32878);

    var unpackSkipPixels = _gl.getParameter(3316);

    var unpackSkipRows = _gl.getParameter(3315);

    var unpackSkipImages = _gl.getParameter(32877);

    var image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[0] : srcTexture.image;

    _gl.pixelStorei(3314, image.width);

    _gl.pixelStorei(32878, image.height);

    _gl.pixelStorei(3316, sourceBox.min.x);

    _gl.pixelStorei(3315, sourceBox.min.y);

    _gl.pixelStorei(32877, sourceBox.min.z);

    if (srcTexture.isDataTexture || srcTexture.isData3DTexture) {
      _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image.data);
    } else {
      if (srcTexture.isCompressedTexture) {
        console.warn('THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture.');

        _gl.compressedTexSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, image.data);
      } else {
        _gl.texSubImage3D(glTarget, level, position.x, position.y, position.z, width, height, depth, glFormat, glType, image);
      }
    }

    _gl.pixelStorei(3314, unpackRowLen);

    _gl.pixelStorei(32878, unpackImageHeight);

    _gl.pixelStorei(3316, unpackSkipPixels);

    _gl.pixelStorei(3315, unpackSkipRows);

    _gl.pixelStorei(32877, unpackSkipImages); // Generate mipmaps only when copying level 0


    if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
    state.unbindTexture();
  };

  this.initTexture = function (texture) {
    textures.setTexture2D(texture, 0);
    state.unbindTexture();
  };

  this.resetState = function () {
    _currentActiveCubeFace = 0;
    _currentActiveMipmapLevel = 0;
    _currentRenderTarget = null;
    state.reset();
    bindingStates.reset();
  };

  if (typeof __THREE_DEVTOOLS__ !== 'undefined') {
    __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
      detail: this
    }));
  }
}

WebGLRenderer.prototype.isWebGLRenderer = true;

var WebGL1Renderer = /*#__PURE__*/function (_WebGLRenderer) {
  _inherits(WebGL1Renderer, _WebGLRenderer);

  var _super29 = _createSuper(WebGL1Renderer);

  function WebGL1Renderer() {
    _classCallCheck2(this, WebGL1Renderer);

    return _super29.apply(this, arguments);
  }

  return WebGL1Renderer;
}(WebGLRenderer);

WebGL1Renderer.prototype.isWebGL1Renderer = true;

var Scene = /*#__PURE__*/function (_Object3D5) {
  _inherits(Scene, _Object3D5);

  var _super30 = _createSuper(Scene);

  function Scene() {
    var _this26;

    _classCallCheck2(this, Scene);

    _this26 = _super30.call(this);
    _this26.type = 'Scene';
    _this26.background = null;
    _this26.environment = null;
    _this26.fog = null;
    _this26.overrideMaterial = null;
    _this26.autoUpdate = true; // checked by the renderer

    if (typeof __THREE_DEVTOOLS__ !== 'undefined') {
      __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
        detail: _assertThisInitialized(_this26)
      }));
    }

    return _this26;
  }

  _createClass2(Scene, [{
    key: "copy",
    value: function copy(source, recursive) {
      _get(_getPrototypeOf(Scene.prototype), "copy", this).call(this, source, recursive);

      if (source.background !== null) this.background = source.background.clone();
      if (source.environment !== null) this.environment = source.environment.clone();
      if (source.fog !== null) this.fog = source.fog.clone();
      if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
      this.autoUpdate = source.autoUpdate;
      this.matrixAutoUpdate = source.matrixAutoUpdate;
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(meta) {
      var data = _get(_getPrototypeOf(Scene.prototype), "toJSON", this).call(this, meta);

      if (this.fog !== null) data.object.fog = this.fog.toJSON();
      return data;
    }
  }]);

  return Scene;
}(Object3D);

Scene.prototype.isScene = true;

var SpriteMaterial = /*#__PURE__*/function (_Material5) {
  _inherits(SpriteMaterial, _Material5);

  var _super31 = _createSuper(SpriteMaterial);

  function SpriteMaterial(parameters) {
    var _this27;

    _classCallCheck2(this, SpriteMaterial);

    _this27 = _super31.call(this);
    _this27.type = 'SpriteMaterial';
    _this27.color = new Color(0xffffff);
    _this27.map = null;
    _this27.alphaMap = null;
    _this27.rotation = 0;
    _this27.sizeAttenuation = true;
    _this27.transparent = true;
    _this27.fog = true;

    _this27.setValues(parameters);

    return _this27;
  }

  _createClass2(SpriteMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(SpriteMaterial.prototype), "copy", this).call(this, source);

      this.color.copy(source.color);
      this.map = source.map;
      this.alphaMap = source.alphaMap;
      this.rotation = source.rotation;
      this.sizeAttenuation = source.sizeAttenuation;
      this.fog = source.fog;
      return this;
    }
  }]);

  return SpriteMaterial;
}(Material);

SpriteMaterial.prototype.isSpriteMaterial = true;

var LineBasicMaterial = /*#__PURE__*/function (_Material6) {
  _inherits(LineBasicMaterial, _Material6);

  var _super32 = _createSuper(LineBasicMaterial);

  function LineBasicMaterial(parameters) {
    var _this28;

    _classCallCheck2(this, LineBasicMaterial);

    _this28 = _super32.call(this);
    _this28.type = 'LineBasicMaterial';
    _this28.color = new Color(0xffffff);
    _this28.linewidth = 1;
    _this28.linecap = 'round';
    _this28.linejoin = 'round';
    _this28.fog = true;

    _this28.setValues(parameters);

    return _this28;
  }

  _createClass2(LineBasicMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(LineBasicMaterial.prototype), "copy", this).call(this, source);

      this.color.copy(source.color);
      this.linewidth = source.linewidth;
      this.linecap = source.linecap;
      this.linejoin = source.linejoin;
      this.fog = source.fog;
      return this;
    }
  }]);

  return LineBasicMaterial;
}(Material);

LineBasicMaterial.prototype.isLineBasicMaterial = true;

var _start$1 = /*@__PURE__*/new Vector3();

var _end$1 = /*@__PURE__*/new Vector3();

var _inverseMatrix$1 = /*@__PURE__*/new Matrix4();

var _ray$1 = /*@__PURE__*/new Ray();

var _sphere$1 = /*@__PURE__*/new Sphere();

var Line = /*#__PURE__*/function (_Object3D6) {
  _inherits(Line, _Object3D6);

  var _super33 = _createSuper(Line);

  function Line() {
    var _this29;

    var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new BufferGeometry();
    var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new LineBasicMaterial();

    _classCallCheck2(this, Line);

    _this29 = _super33.call(this);
    _this29.type = 'Line';
    _this29.geometry = geometry;
    _this29.material = material;

    _this29.updateMorphTargets();

    return _this29;
  }

  _createClass2(Line, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(Line.prototype), "copy", this).call(this, source);

      this.material = source.material;
      this.geometry = source.geometry;
      return this;
    }
  }, {
    key: "computeLineDistances",
    value: function computeLineDistances() {
      var geometry = this.geometry;

      if (geometry.isBufferGeometry) {
        // we assume non-indexed geometry
        if (geometry.index === null) {
          var positionAttribute = geometry.attributes.position;
          var lineDistances = [0];

          for (var _i154 = 1, l = positionAttribute.count; _i154 < l; _i154++) {
            _start$1.fromBufferAttribute(positionAttribute, _i154 - 1);

            _end$1.fromBufferAttribute(positionAttribute, _i154);

            lineDistances[_i154] = lineDistances[_i154 - 1];
            lineDistances[_i154] += _start$1.distanceTo(_end$1);
          }

          geometry.setAttribute('lineDistance', new Float32BufferAttribute(lineDistances, 1));
        } else {
          console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        }
      } else if (geometry.isGeometry) {
        console.error('THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
      }

      return this;
    }
  }, {
    key: "raycast",
    value: function raycast(raycaster, intersects) {
      var geometry = this.geometry;
      var matrixWorld = this.matrixWorld;
      var threshold = raycaster.params.Line.threshold;
      var drawRange = geometry.drawRange; // Checking boundingSphere distance to ray

      if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

      _sphere$1.copy(geometry.boundingSphere);

      _sphere$1.applyMatrix4(matrixWorld);

      _sphere$1.radius += threshold;
      if (raycaster.ray.intersectsSphere(_sphere$1) === false) return; //

      _inverseMatrix$1.copy(matrixWorld).invert();

      _ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);

      var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
      var localThresholdSq = localThreshold * localThreshold;
      var vStart = new Vector3();
      var vEnd = new Vector3();
      var interSegment = new Vector3();
      var interRay = new Vector3();
      var step = this.isLineSegments ? 2 : 1;

      if (geometry.isBufferGeometry) {
        var _index6 = geometry.index;
        var attributes = geometry.attributes;
        var positionAttribute = attributes.position;

        if (_index6 !== null) {
          var start = Math.max(0, drawRange.start);
          var end = Math.min(_index6.count, drawRange.start + drawRange.count);

          for (var _i155 = start, l = end - 1; _i155 < l; _i155 += step) {
            var a = _index6.getX(_i155);

            var b = _index6.getX(_i155 + 1);

            vStart.fromBufferAttribute(positionAttribute, a);
            vEnd.fromBufferAttribute(positionAttribute, b);

            var distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);

            if (distSq > localThresholdSq) continue;
            interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation

            var distance = raycaster.ray.origin.distanceTo(interRay);
            if (distance < raycaster.near || distance > raycaster.far) continue;
            intersects.push({
              distance: distance,
              // What do we want? intersection point on the ray or on the segment??
              // point: raycaster.ray.at( distance ),
              point: interSegment.clone().applyMatrix4(this.matrixWorld),
              index: _i155,
              face: null,
              faceIndex: null,
              object: this
            });
          }
        } else {
          var _start6 = Math.max(0, drawRange.start);

          var _end5 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);

          for (var _i156 = _start6, _l7 = _end5 - 1; _i156 < _l7; _i156 += step) {
            vStart.fromBufferAttribute(positionAttribute, _i156);
            vEnd.fromBufferAttribute(positionAttribute, _i156 + 1);

            var _distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);

            if (_distSq > localThresholdSq) continue;
            interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation

            var _distance = raycaster.ray.origin.distanceTo(interRay);

            if (_distance < raycaster.near || _distance > raycaster.far) continue;
            intersects.push({
              distance: _distance,
              // What do we want? intersection point on the ray or on the segment??
              // point: raycaster.ray.at( distance ),
              point: interSegment.clone().applyMatrix4(this.matrixWorld),
              index: _i156,
              face: null,
              faceIndex: null,
              object: this
            });
          }
        }
      } else if (geometry.isGeometry) {
        console.error('THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
      }
    }
  }, {
    key: "updateMorphTargets",
    value: function updateMorphTargets() {
      var geometry = this.geometry;

      if (geometry.isBufferGeometry) {
        var morphAttributes = geometry.morphAttributes;
        var keys = Object.keys(morphAttributes);

        if (keys.length > 0) {
          var morphAttribute = morphAttributes[keys[0]];

          if (morphAttribute !== undefined) {
            this.morphTargetInfluences = [];
            this.morphTargetDictionary = {};

            for (var m = 0, ml = morphAttribute.length; m < ml; m++) {
              var name = morphAttribute[m].name || String(m);
              this.morphTargetInfluences.push(0);
              this.morphTargetDictionary[name] = m;
            }
          }
        }
      } else {
        var morphTargets = geometry.morphTargets;

        if (morphTargets !== undefined && morphTargets.length > 0) {
          console.error('THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
      }
    }
  }]);

  return Line;
}(Object3D);

Line.prototype.isLine = true;

var _start = /*@__PURE__*/new Vector3();

var _end = /*@__PURE__*/new Vector3();

var LineSegments = /*#__PURE__*/function (_Line) {
  _inherits(LineSegments, _Line);

  var _super34 = _createSuper(LineSegments);

  function LineSegments(geometry, material) {
    var _this30;

    _classCallCheck2(this, LineSegments);

    _this30 = _super34.call(this, geometry, material);
    _this30.type = 'LineSegments';
    return _this30;
  }

  _createClass2(LineSegments, [{
    key: "computeLineDistances",
    value: function computeLineDistances() {
      var geometry = this.geometry;

      if (geometry.isBufferGeometry) {
        // we assume non-indexed geometry
        if (geometry.index === null) {
          var positionAttribute = geometry.attributes.position;
          var lineDistances = [];

          for (var _i157 = 0, l = positionAttribute.count; _i157 < l; _i157 += 2) {
            _start.fromBufferAttribute(positionAttribute, _i157);

            _end.fromBufferAttribute(positionAttribute, _i157 + 1);

            lineDistances[_i157] = _i157 === 0 ? 0 : lineDistances[_i157 - 1];
            lineDistances[_i157 + 1] = lineDistances[_i157] + _start.distanceTo(_end);
          }

          geometry.setAttribute('lineDistance', new Float32BufferAttribute(lineDistances, 1));
        } else {
          console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        }
      } else if (geometry.isGeometry) {
        console.error('THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
      }

      return this;
    }
  }]);

  return LineSegments;
}(Line);

LineSegments.prototype.isLineSegments = true;

var PointsMaterial = /*#__PURE__*/function (_Material7) {
  _inherits(PointsMaterial, _Material7);

  var _super35 = _createSuper(PointsMaterial);

  function PointsMaterial(parameters) {
    var _this31;

    _classCallCheck2(this, PointsMaterial);

    _this31 = _super35.call(this);
    _this31.type = 'PointsMaterial';
    _this31.color = new Color(0xffffff);
    _this31.map = null;
    _this31.alphaMap = null;
    _this31.size = 1;
    _this31.sizeAttenuation = true;
    _this31.fog = true;

    _this31.setValues(parameters);

    return _this31;
  }

  _createClass2(PointsMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(PointsMaterial.prototype), "copy", this).call(this, source);

      this.color.copy(source.color);
      this.map = source.map;
      this.alphaMap = source.alphaMap;
      this.size = source.size;
      this.sizeAttenuation = source.sizeAttenuation;
      this.fog = source.fog;
      return this;
    }
  }]);

  return PointsMaterial;
}(Material);

PointsMaterial.prototype.isPointsMaterial = true;

var _inverseMatrix = /*@__PURE__*/new Matrix4();

var _ray = /*@__PURE__*/new Ray();

var _sphere = /*@__PURE__*/new Sphere();

var _position$2 = /*@__PURE__*/new Vector3();

var Points = /*#__PURE__*/function (_Object3D7) {
  _inherits(Points, _Object3D7);

  var _super36 = _createSuper(Points);

  function Points() {
    var _this32;

    var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new BufferGeometry();
    var material = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new PointsMaterial();

    _classCallCheck2(this, Points);

    _this32 = _super36.call(this);
    _this32.type = 'Points';
    _this32.geometry = geometry;
    _this32.material = material;

    _this32.updateMorphTargets();

    return _this32;
  }

  _createClass2(Points, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(Points.prototype), "copy", this).call(this, source);

      this.material = source.material;
      this.geometry = source.geometry;
      return this;
    }
  }, {
    key: "raycast",
    value: function raycast(raycaster, intersects) {
      var geometry = this.geometry;
      var matrixWorld = this.matrixWorld;
      var threshold = raycaster.params.Points.threshold;
      var drawRange = geometry.drawRange; // Checking boundingSphere distance to ray

      if (geometry.boundingSphere === null) geometry.computeBoundingSphere();

      _sphere.copy(geometry.boundingSphere);

      _sphere.applyMatrix4(matrixWorld);

      _sphere.radius += threshold;
      if (raycaster.ray.intersectsSphere(_sphere) === false) return; //

      _inverseMatrix.copy(matrixWorld).invert();

      _ray.copy(raycaster.ray).applyMatrix4(_inverseMatrix);

      var localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
      var localThresholdSq = localThreshold * localThreshold;

      if (geometry.isBufferGeometry) {
        var _index7 = geometry.index;
        var attributes = geometry.attributes;
        var positionAttribute = attributes.position;

        if (_index7 !== null) {
          var start = Math.max(0, drawRange.start);
          var end = Math.min(_index7.count, drawRange.start + drawRange.count);

          for (var _i158 = start, il = end; _i158 < il; _i158++) {
            var a = _index7.getX(_i158);

            _position$2.fromBufferAttribute(positionAttribute, a);

            testPoint(_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
          }
        } else {
          var _start7 = Math.max(0, drawRange.start);

          var _end6 = Math.min(positionAttribute.count, drawRange.start + drawRange.count);

          for (var _i159 = _start7, l = _end6; _i159 < l; _i159++) {
            _position$2.fromBufferAttribute(positionAttribute, _i159);

            testPoint(_position$2, _i159, localThresholdSq, matrixWorld, raycaster, intersects, this);
          }
        }
      } else {
        console.error('THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
      }
    }
  }, {
    key: "updateMorphTargets",
    value: function updateMorphTargets() {
      var geometry = this.geometry;

      if (geometry.isBufferGeometry) {
        var morphAttributes = geometry.morphAttributes;
        var keys = Object.keys(morphAttributes);

        if (keys.length > 0) {
          var morphAttribute = morphAttributes[keys[0]];

          if (morphAttribute !== undefined) {
            this.morphTargetInfluences = [];
            this.morphTargetDictionary = {};

            for (var m = 0, ml = morphAttribute.length; m < ml; m++) {
              var name = morphAttribute[m].name || String(m);
              this.morphTargetInfluences.push(0);
              this.morphTargetDictionary[name] = m;
            }
          }
        }
      } else {
        var morphTargets = geometry.morphTargets;

        if (morphTargets !== undefined && morphTargets.length > 0) {
          console.error('THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
      }
    }
  }]);

  return Points;
}(Object3D);

Points.prototype.isPoints = true;

function testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
  var rayPointDistanceSq = _ray.distanceSqToPoint(point);

  if (rayPointDistanceSq < localThresholdSq) {
    var intersectPoint = new Vector3();

    _ray.closestPointToPoint(point, intersectPoint);

    intersectPoint.applyMatrix4(matrixWorld);
    var distance = raycaster.ray.origin.distanceTo(intersectPoint);
    if (distance < raycaster.near || distance > raycaster.far) return;
    intersects.push({
      distance: distance,
      distanceToRay: Math.sqrt(rayPointDistanceSq),
      point: intersectPoint,
      index: index,
      face: null,
      object: object
    });
  }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/


var Curve = /*#__PURE__*/function () {
  function Curve() {
    _classCallCheck2(this, Curve);

    this.type = 'Curve';
    this.arcLengthDivisions = 200;
  } // Virtual base class method to overwrite and implement in subclasses
  //	- t [0 .. 1]


  _createClass2(Curve, [{
    key: "getPoint",
    value: function
      /* t, optionalTarget */
    getPoint() {
      console.warn('THREE.Curve: .getPoint() not implemented.');
      return null;
    } // Get point at relative position in curve according to arc length
    // - u [0 .. 1]

  }, {
    key: "getPointAt",
    value: function getPointAt(u, optionalTarget) {
      var t = this.getUtoTmapping(u);
      return this.getPoint(t, optionalTarget);
    } // Get sequence of points using getPoint( t )

  }, {
    key: "getPoints",
    value: function getPoints() {
      var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      var points = [];

      for (var d = 0; d <= divisions; d++) {
        points.push(this.getPoint(d / divisions));
      }

      return points;
    } // Get sequence of points using getPointAt( u )

  }, {
    key: "getSpacedPoints",
    value: function getSpacedPoints() {
      var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
      var points = [];

      for (var d = 0; d <= divisions; d++) {
        points.push(this.getPointAt(d / divisions));
      }

      return points;
    } // Get total curve arc length

  }, {
    key: "getLength",
    value: function getLength() {
      var lengths = this.getLengths();
      return lengths[lengths.length - 1];
    } // Get list of cumulative segment lengths

  }, {
    key: "getLengths",
    value: function getLengths() {
      var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.arcLengthDivisions;

      if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) {
        return this.cacheArcLengths;
      }

      this.needsUpdate = false;
      var cache = [];
      var current,
          last = this.getPoint(0);
      var sum = 0;
      cache.push(0);

      for (var p = 1; p <= divisions; p++) {
        current = this.getPoint(p / divisions);
        sum += current.distanceTo(last);
        cache.push(sum);
        last = current;
      }

      this.cacheArcLengths = cache;
      return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
  }, {
    key: "updateArcLengths",
    value: function updateArcLengths() {
      this.needsUpdate = true;
      this.getLengths();
    } // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant

  }, {
    key: "getUtoTmapping",
    value: function getUtoTmapping(u, distance) {
      var arcLengths = this.getLengths();
      var i = 0;
      var il = arcLengths.length;
      var targetArcLength; // The targeted u distance value to get

      if (distance) {
        targetArcLength = distance;
      } else {
        targetArcLength = u * arcLengths[il - 1];
      } // binary search for the index with largest value smaller than target u distance


      var low = 0,
          high = il - 1,
          comparison;

      while (low <= high) {
        i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats

        comparison = arcLengths[i] - targetArcLength;

        if (comparison < 0) {
          low = i + 1;
        } else if (comparison > 0) {
          high = i - 1;
        } else {
          high = i;
          break; // DONE
        }
      }

      i = high;

      if (arcLengths[i] === targetArcLength) {
        return i / (il - 1);
      } // we could get finer grain at lengths, or use simple interpolation between two points


      var lengthBefore = arcLengths[i];
      var lengthAfter = arcLengths[i + 1];
      var segmentLength = lengthAfter - lengthBefore; // determine where we are between the 'before' and 'after' points

      var segmentFraction = (targetArcLength - lengthBefore) / segmentLength; // add that fractional amount to t

      var t = (i + segmentFraction) / (il - 1);
      return t;
    } // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation

  }, {
    key: "getTangent",
    value: function getTangent(t, optionalTarget) {
      var delta = 0.0001;
      var t1 = t - delta;
      var t2 = t + delta; // Capping in case of danger

      if (t1 < 0) t1 = 0;
      if (t2 > 1) t2 = 1;
      var pt1 = this.getPoint(t1);
      var pt2 = this.getPoint(t2);
      var tangent = optionalTarget || (pt1.isVector2 ? new Vector2() : new Vector3());
      tangent.copy(pt2).sub(pt1).normalize();
      return tangent;
    }
  }, {
    key: "getTangentAt",
    value: function getTangentAt(u, optionalTarget) {
      var t = this.getUtoTmapping(u);
      return this.getTangent(t, optionalTarget);
    }
  }, {
    key: "computeFrenetFrames",
    value: function computeFrenetFrames(segments, closed) {
      // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
      var normal = new Vector3();
      var tangents = [];
      var normals = [];
      var binormals = [];
      var vec = new Vector3();
      var mat = new Matrix4(); // compute the tangent vectors for each segment on the curve

      for (var _i160 = 0; _i160 <= segments; _i160++) {
        var u = _i160 / segments;
        tangents[_i160] = this.getTangentAt(u, new Vector3());
      } // select an initial normal vector perpendicular to the first tangent vector,
      // and in the direction of the minimum tangent xyz component


      normals[0] = new Vector3();
      binormals[0] = new Vector3();
      var min = Number.MAX_VALUE;
      var tx = Math.abs(tangents[0].x);
      var ty = Math.abs(tangents[0].y);
      var tz = Math.abs(tangents[0].z);

      if (tx <= min) {
        min = tx;
        normal.set(1, 0, 0);
      }

      if (ty <= min) {
        min = ty;
        normal.set(0, 1, 0);
      }

      if (tz <= min) {
        normal.set(0, 0, 1);
      }

      vec.crossVectors(tangents[0], normal).normalize();
      normals[0].crossVectors(tangents[0], vec);
      binormals[0].crossVectors(tangents[0], normals[0]); // compute the slowly-varying normal and binormal vectors for each segment on the curve

      for (var _i161 = 1; _i161 <= segments; _i161++) {
        normals[_i161] = normals[_i161 - 1].clone();
        binormals[_i161] = binormals[_i161 - 1].clone();
        vec.crossVectors(tangents[_i161 - 1], tangents[_i161]);

        if (vec.length() > Number.EPSILON) {
          vec.normalize();
          var theta = Math.acos(clamp(tangents[_i161 - 1].dot(tangents[_i161]), -1, 1)); // clamp for floating pt errors

          normals[_i161].applyMatrix4(mat.makeRotationAxis(vec, theta));
        }

        binormals[_i161].crossVectors(tangents[_i161], normals[_i161]);
      } // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same


      if (closed === true) {
        var _theta = Math.acos(clamp(normals[0].dot(normals[segments]), -1, 1));

        _theta /= segments;

        if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) {
          _theta = -_theta;
        }

        for (var _i162 = 1; _i162 <= segments; _i162++) {
          // twist a little...
          normals[_i162].applyMatrix4(mat.makeRotationAxis(tangents[_i162], _theta * _i162));

          binormals[_i162].crossVectors(tangents[_i162], normals[_i162]);
        }
      }

      return {
        tangents: tangents,
        normals: normals,
        binormals: binormals
      };
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      this.arcLengthDivisions = source.arcLengthDivisions;
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = {
        metadata: {
          version: 4.5,
          type: 'Curve',
          generator: 'Curve.toJSON'
        }
      };
      data.arcLengthDivisions = this.arcLengthDivisions;
      data.type = this.type;
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      this.arcLengthDivisions = json.arcLengthDivisions;
      return this;
    }
  }]);

  return Curve;
}();

var EllipseCurve = /*#__PURE__*/function (_Curve) {
  _inherits(EllipseCurve, _Curve);

  var _super37 = _createSuper(EllipseCurve);

  function EllipseCurve() {
    var _this33;

    var aX = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var aY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var xRadius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var yRadius = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var aStartAngle = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var aEndAngle = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Math.PI * 2;
    var aClockwise = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var aRotation = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;

    _classCallCheck2(this, EllipseCurve);

    _this33 = _super37.call(this);
    _this33.type = 'EllipseCurve';
    _this33.aX = aX;
    _this33.aY = aY;
    _this33.xRadius = xRadius;
    _this33.yRadius = yRadius;
    _this33.aStartAngle = aStartAngle;
    _this33.aEndAngle = aEndAngle;
    _this33.aClockwise = aClockwise;
    _this33.aRotation = aRotation;
    return _this33;
  }

  _createClass2(EllipseCurve, [{
    key: "getPoint",
    value: function getPoint(t, optionalTarget) {
      var point = optionalTarget || new Vector2();
      var twoPi = Math.PI * 2;
      var deltaAngle = this.aEndAngle - this.aStartAngle;
      var samePoints = Math.abs(deltaAngle) < Number.EPSILON; // ensures that deltaAngle is 0 .. 2 PI

      while (deltaAngle < 0) {
        deltaAngle += twoPi;
      }

      while (deltaAngle > twoPi) {
        deltaAngle -= twoPi;
      }

      if (deltaAngle < Number.EPSILON) {
        if (samePoints) {
          deltaAngle = 0;
        } else {
          deltaAngle = twoPi;
        }
      }

      if (this.aClockwise === true && !samePoints) {
        if (deltaAngle === twoPi) {
          deltaAngle = -twoPi;
        } else {
          deltaAngle = deltaAngle - twoPi;
        }
      }

      var angle = this.aStartAngle + t * deltaAngle;
      var x = this.aX + this.xRadius * Math.cos(angle);
      var y = this.aY + this.yRadius * Math.sin(angle);

      if (this.aRotation !== 0) {
        var cos = Math.cos(this.aRotation);
        var sin = Math.sin(this.aRotation);
        var tx = x - this.aX;
        var ty = y - this.aY; // Rotate the point about the center of the ellipse.

        x = tx * cos - ty * sin + this.aX;
        y = tx * sin + ty * cos + this.aY;
      }

      return point.set(x, y);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(EllipseCurve.prototype), "copy", this).call(this, source);

      this.aX = source.aX;
      this.aY = source.aY;
      this.xRadius = source.xRadius;
      this.yRadius = source.yRadius;
      this.aStartAngle = source.aStartAngle;
      this.aEndAngle = source.aEndAngle;
      this.aClockwise = source.aClockwise;
      this.aRotation = source.aRotation;
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(EllipseCurve.prototype), "toJSON", this).call(this);

      data.aX = this.aX;
      data.aY = this.aY;
      data.xRadius = this.xRadius;
      data.yRadius = this.yRadius;
      data.aStartAngle = this.aStartAngle;
      data.aEndAngle = this.aEndAngle;
      data.aClockwise = this.aClockwise;
      data.aRotation = this.aRotation;
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(EllipseCurve.prototype), "fromJSON", this).call(this, json);

      this.aX = json.aX;
      this.aY = json.aY;
      this.xRadius = json.xRadius;
      this.yRadius = json.yRadius;
      this.aStartAngle = json.aStartAngle;
      this.aEndAngle = json.aEndAngle;
      this.aClockwise = json.aClockwise;
      this.aRotation = json.aRotation;
      return this;
    }
  }]);

  return EllipseCurve;
}(Curve);

EllipseCurve.prototype.isEllipseCurve = true;

var ArcCurve = /*#__PURE__*/function (_EllipseCurve) {
  _inherits(ArcCurve, _EllipseCurve);

  var _super38 = _createSuper(ArcCurve);

  function ArcCurve(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    var _this34;

    _classCallCheck2(this, ArcCurve);

    _this34 = _super38.call(this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    _this34.type = 'ArcCurve';
    return _this34;
  }

  return ArcCurve;
}(EllipseCurve);

ArcCurve.prototype.isArcCurve = true;
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */

/*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/

function CubicPoly() {
  var c0 = 0,
      c1 = 0,
      c2 = 0,
      c3 = 0;
  /*
   * Compute coefficients for a cubic polynomial
   *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
   * such that
   *   p(0) = x0, p(1) = x1
   *  and
   *   p'(0) = t0, p'(1) = t1.
   */

  function init(x0, x1, t0, t1) {
    c0 = x0;
    c1 = t0;
    c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
    c3 = 2 * x0 - 2 * x1 + t0 + t1;
  }

  return {
    initCatmullRom: function initCatmullRom(x0, x1, x2, x3, tension) {
      init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
    },
    initNonuniformCatmullRom: function initNonuniformCatmullRom(x0, x1, x2, x3, dt0, dt1, dt2) {
      // compute tangents when parameterized in [t1,t2]
      var t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
      var t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2; // rescale tangents for parametrization in [0,1]

      t1 *= dt1;
      t2 *= dt1;
      init(x1, x2, t1, t2);
    },
    calc: function calc(t) {
      var t2 = t * t;
      var t3 = t2 * t;
      return c0 + c1 * t + c2 * t2 + c3 * t3;
    }
  };
} //


var tmp = new Vector3();
var px = new CubicPoly(),
    py = new CubicPoly(),
    pz = new CubicPoly();

var CatmullRomCurve3 = /*#__PURE__*/function (_Curve2) {
  _inherits(CatmullRomCurve3, _Curve2);

  var _super39 = _createSuper(CatmullRomCurve3);

  function CatmullRomCurve3() {
    var _this35;

    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var closed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var curveType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'centripetal';
    var tension = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;

    _classCallCheck2(this, CatmullRomCurve3);

    _this35 = _super39.call(this);
    _this35.type = 'CatmullRomCurve3';
    _this35.points = points;
    _this35.closed = closed;
    _this35.curveType = curveType;
    _this35.tension = tension;
    return _this35;
  }

  _createClass2(CatmullRomCurve3, [{
    key: "getPoint",
    value: function getPoint(t) {
      var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
      var point = optionalTarget;
      var points = this.points;
      var l = points.length;
      var p = (l - (this.closed ? 0 : 1)) * t;
      var intPoint = Math.floor(p);
      var weight = p - intPoint;

      if (this.closed) {
        intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
      } else if (weight === 0 && intPoint === l - 1) {
        intPoint = l - 2;
        weight = 1;
      }

      var p0, p3; // 4 points (p1 & p2 defined below)

      if (this.closed || intPoint > 0) {
        p0 = points[(intPoint - 1) % l];
      } else {
        // extrapolate first point
        tmp.subVectors(points[0], points[1]).add(points[0]);
        p0 = tmp;
      }

      var p1 = points[intPoint % l];
      var p2 = points[(intPoint + 1) % l];

      if (this.closed || intPoint + 2 < l) {
        p3 = points[(intPoint + 2) % l];
      } else {
        // extrapolate last point
        tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
        p3 = tmp;
      }

      if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
        // init Centripetal / Chordal Catmull-Rom
        var pow = this.curveType === 'chordal' ? 0.5 : 0.25;
        var dt0 = Math.pow(p0.distanceToSquared(p1), pow);
        var dt1 = Math.pow(p1.distanceToSquared(p2), pow);
        var dt2 = Math.pow(p2.distanceToSquared(p3), pow); // safety check for repeated points

        if (dt1 < 1e-4) dt1 = 1.0;
        if (dt0 < 1e-4) dt0 = dt1;
        if (dt2 < 1e-4) dt2 = dt1;
        px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
        py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
        pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
      } else if (this.curveType === 'catmullrom') {
        px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
        py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
        pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
      }

      point.set(px.calc(weight), py.calc(weight), pz.calc(weight));
      return point;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(CatmullRomCurve3.prototype), "copy", this).call(this, source);

      this.points = [];

      for (var _i163 = 0, l = source.points.length; _i163 < l; _i163++) {
        var point = source.points[_i163];
        this.points.push(point.clone());
      }

      this.closed = source.closed;
      this.curveType = source.curveType;
      this.tension = source.tension;
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(CatmullRomCurve3.prototype), "toJSON", this).call(this);

      data.points = [];

      for (var _i164 = 0, l = this.points.length; _i164 < l; _i164++) {
        var point = this.points[_i164];
        data.points.push(point.toArray());
      }

      data.closed = this.closed;
      data.curveType = this.curveType;
      data.tension = this.tension;
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(CatmullRomCurve3.prototype), "fromJSON", this).call(this, json);

      this.points = [];

      for (var _i165 = 0, l = json.points.length; _i165 < l; _i165++) {
        var point = json.points[_i165];
        this.points.push(new Vector3().fromArray(point));
      }

      this.closed = json.closed;
      this.curveType = json.curveType;
      this.tension = json.tension;
      return this;
    }
  }]);

  return CatmullRomCurve3;
}(Curve);

CatmullRomCurve3.prototype.isCatmullRomCurve3 = true;
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */

function CatmullRom(t, p0, p1, p2, p3) {
  var v0 = (p2 - p0) * 0.5;
  var v1 = (p3 - p1) * 0.5;
  var t2 = t * t;
  var t3 = t * t2;
  return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
} //


function QuadraticBezierP0(t, p) {
  var k = 1 - t;
  return k * k * p;
}

function QuadraticBezierP1(t, p) {
  return 2 * (1 - t) * t * p;
}

function QuadraticBezierP2(t, p) {
  return t * t * p;
}

function QuadraticBezier(t, p0, p1, p2) {
  return QuadraticBezierP0(t, p0) + QuadraticBezierP1(t, p1) + QuadraticBezierP2(t, p2);
} //


function CubicBezierP0(t, p) {
  var k = 1 - t;
  return k * k * k * p;
}

function CubicBezierP1(t, p) {
  var k = 1 - t;
  return 3 * k * k * t * p;
}

function CubicBezierP2(t, p) {
  return 3 * (1 - t) * t * t * p;
}

function CubicBezierP3(t, p) {
  return t * t * t * p;
}

function CubicBezier(t, p0, p1, p2, p3) {
  return CubicBezierP0(t, p0) + CubicBezierP1(t, p1) + CubicBezierP2(t, p2) + CubicBezierP3(t, p3);
}

var CubicBezierCurve = /*#__PURE__*/function (_Curve3) {
  _inherits(CubicBezierCurve, _Curve3);

  var _super40 = _createSuper(CubicBezierCurve);

  function CubicBezierCurve() {
    var _this36;

    var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector2();
    var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();
    var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Vector2();
    var v3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Vector2();

    _classCallCheck2(this, CubicBezierCurve);

    _this36 = _super40.call(this);
    _this36.type = 'CubicBezierCurve';
    _this36.v0 = v0;
    _this36.v1 = v1;
    _this36.v2 = v2;
    _this36.v3 = v3;
    return _this36;
  }

  _createClass2(CubicBezierCurve, [{
    key: "getPoint",
    value: function getPoint(t) {
      var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();
      var point = optionalTarget;
      var v0 = this.v0,
          v1 = this.v1,
          v2 = this.v2,
          v3 = this.v3;
      point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
      return point;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(CubicBezierCurve.prototype), "copy", this).call(this, source);

      this.v0.copy(source.v0);
      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      this.v3.copy(source.v3);
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(CubicBezierCurve.prototype), "toJSON", this).call(this);

      data.v0 = this.v0.toArray();
      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      data.v3 = this.v3.toArray();
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(CubicBezierCurve.prototype), "fromJSON", this).call(this, json);

      this.v0.fromArray(json.v0);
      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      this.v3.fromArray(json.v3);
      return this;
    }
  }]);

  return CubicBezierCurve;
}(Curve);

CubicBezierCurve.prototype.isCubicBezierCurve = true;

var CubicBezierCurve3 = /*#__PURE__*/function (_Curve4) {
  _inherits(CubicBezierCurve3, _Curve4);

  var _super41 = _createSuper(CubicBezierCurve3);

  function CubicBezierCurve3() {
    var _this37;

    var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
    var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
    var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Vector3();
    var v3 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new Vector3();

    _classCallCheck2(this, CubicBezierCurve3);

    _this37 = _super41.call(this);
    _this37.type = 'CubicBezierCurve3';
    _this37.v0 = v0;
    _this37.v1 = v1;
    _this37.v2 = v2;
    _this37.v3 = v3;
    return _this37;
  }

  _createClass2(CubicBezierCurve3, [{
    key: "getPoint",
    value: function getPoint(t) {
      var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
      var point = optionalTarget;
      var v0 = this.v0,
          v1 = this.v1,
          v2 = this.v2,
          v3 = this.v3;
      point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y), CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
      return point;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(CubicBezierCurve3.prototype), "copy", this).call(this, source);

      this.v0.copy(source.v0);
      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      this.v3.copy(source.v3);
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(CubicBezierCurve3.prototype), "toJSON", this).call(this);

      data.v0 = this.v0.toArray();
      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      data.v3 = this.v3.toArray();
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(CubicBezierCurve3.prototype), "fromJSON", this).call(this, json);

      this.v0.fromArray(json.v0);
      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      this.v3.fromArray(json.v3);
      return this;
    }
  }]);

  return CubicBezierCurve3;
}(Curve);

CubicBezierCurve3.prototype.isCubicBezierCurve3 = true;

var LineCurve = /*#__PURE__*/function (_Curve5) {
  _inherits(LineCurve, _Curve5);

  var _super42 = _createSuper(LineCurve);

  function LineCurve() {
    var _this38;

    var v1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector2();
    var v2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();

    _classCallCheck2(this, LineCurve);

    _this38 = _super42.call(this);
    _this38.type = 'LineCurve';
    _this38.v1 = v1;
    _this38.v2 = v2;
    return _this38;
  }

  _createClass2(LineCurve, [{
    key: "getPoint",
    value: function getPoint(t) {
      var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();
      var point = optionalTarget;

      if (t === 1) {
        point.copy(this.v2);
      } else {
        point.copy(this.v2).sub(this.v1);
        point.multiplyScalar(t).add(this.v1);
      }

      return point;
    } // Line curve is linear, so we can overwrite default getPointAt

  }, {
    key: "getPointAt",
    value: function getPointAt(u, optionalTarget) {
      return this.getPoint(u, optionalTarget);
    }
  }, {
    key: "getTangent",
    value: function getTangent(t, optionalTarget) {
      var tangent = optionalTarget || new Vector2();
      tangent.copy(this.v2).sub(this.v1).normalize();
      return tangent;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(LineCurve.prototype), "copy", this).call(this, source);

      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(LineCurve.prototype), "toJSON", this).call(this);

      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(LineCurve.prototype), "fromJSON", this).call(this, json);

      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      return this;
    }
  }]);

  return LineCurve;
}(Curve);

LineCurve.prototype.isLineCurve = true;

var LineCurve3 = /*#__PURE__*/function (_Curve6) {
  _inherits(LineCurve3, _Curve6);

  var _super43 = _createSuper(LineCurve3);

  function LineCurve3() {
    var _this39;

    var v1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
    var v2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();

    _classCallCheck2(this, LineCurve3);

    _this39 = _super43.call(this);
    _this39.type = 'LineCurve3';
    _this39.isLineCurve3 = true;
    _this39.v1 = v1;
    _this39.v2 = v2;
    return _this39;
  }

  _createClass2(LineCurve3, [{
    key: "getPoint",
    value: function getPoint(t) {
      var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
      var point = optionalTarget;

      if (t === 1) {
        point.copy(this.v2);
      } else {
        point.copy(this.v2).sub(this.v1);
        point.multiplyScalar(t).add(this.v1);
      }

      return point;
    } // Line curve is linear, so we can overwrite default getPointAt

  }, {
    key: "getPointAt",
    value: function getPointAt(u, optionalTarget) {
      return this.getPoint(u, optionalTarget);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(LineCurve3.prototype), "copy", this).call(this, source);

      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(LineCurve3.prototype), "toJSON", this).call(this);

      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(LineCurve3.prototype), "fromJSON", this).call(this, json);

      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      return this;
    }
  }]);

  return LineCurve3;
}(Curve);

var QuadraticBezierCurve = /*#__PURE__*/function (_Curve7) {
  _inherits(QuadraticBezierCurve, _Curve7);

  var _super44 = _createSuper(QuadraticBezierCurve);

  function QuadraticBezierCurve() {
    var _this40;

    var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector2();
    var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();
    var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Vector2();

    _classCallCheck2(this, QuadraticBezierCurve);

    _this40 = _super44.call(this);
    _this40.type = 'QuadraticBezierCurve';
    _this40.v0 = v0;
    _this40.v1 = v1;
    _this40.v2 = v2;
    return _this40;
  }

  _createClass2(QuadraticBezierCurve, [{
    key: "getPoint",
    value: function getPoint(t) {
      var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();
      var point = optionalTarget;
      var v0 = this.v0,
          v1 = this.v1,
          v2 = this.v2;
      point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y));
      return point;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(QuadraticBezierCurve.prototype), "copy", this).call(this, source);

      this.v0.copy(source.v0);
      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(QuadraticBezierCurve.prototype), "toJSON", this).call(this);

      data.v0 = this.v0.toArray();
      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(QuadraticBezierCurve.prototype), "fromJSON", this).call(this, json);

      this.v0.fromArray(json.v0);
      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      return this;
    }
  }]);

  return QuadraticBezierCurve;
}(Curve);

QuadraticBezierCurve.prototype.isQuadraticBezierCurve = true;

var QuadraticBezierCurve3 = /*#__PURE__*/function (_Curve8) {
  _inherits(QuadraticBezierCurve3, _Curve8);

  var _super45 = _createSuper(QuadraticBezierCurve3);

  function QuadraticBezierCurve3() {
    var _this41;

    var v0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
    var v1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
    var v2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Vector3();

    _classCallCheck2(this, QuadraticBezierCurve3);

    _this41 = _super45.call(this);
    _this41.type = 'QuadraticBezierCurve3';
    _this41.v0 = v0;
    _this41.v1 = v1;
    _this41.v2 = v2;
    return _this41;
  }

  _createClass2(QuadraticBezierCurve3, [{
    key: "getPoint",
    value: function getPoint(t) {
      var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();
      var point = optionalTarget;
      var v0 = this.v0,
          v1 = this.v1,
          v2 = this.v2;
      point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y), QuadraticBezier(t, v0.z, v1.z, v2.z));
      return point;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(QuadraticBezierCurve3.prototype), "copy", this).call(this, source);

      this.v0.copy(source.v0);
      this.v1.copy(source.v1);
      this.v2.copy(source.v2);
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(QuadraticBezierCurve3.prototype), "toJSON", this).call(this);

      data.v0 = this.v0.toArray();
      data.v1 = this.v1.toArray();
      data.v2 = this.v2.toArray();
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(QuadraticBezierCurve3.prototype), "fromJSON", this).call(this, json);

      this.v0.fromArray(json.v0);
      this.v1.fromArray(json.v1);
      this.v2.fromArray(json.v2);
      return this;
    }
  }]);

  return QuadraticBezierCurve3;
}(Curve);

QuadraticBezierCurve3.prototype.isQuadraticBezierCurve3 = true;

var SplineCurve = /*#__PURE__*/function (_Curve9) {
  _inherits(SplineCurve, _Curve9);

  var _super46 = _createSuper(SplineCurve);

  function SplineCurve() {
    var _this42;

    var points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck2(this, SplineCurve);

    _this42 = _super46.call(this);
    _this42.type = 'SplineCurve';
    _this42.points = points;
    return _this42;
  }

  _createClass2(SplineCurve, [{
    key: "getPoint",
    value: function getPoint(t) {
      var optionalTarget = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector2();
      var point = optionalTarget;
      var points = this.points;
      var p = (points.length - 1) * t;
      var intPoint = Math.floor(p);
      var weight = p - intPoint;
      var p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
      var p1 = points[intPoint];
      var p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
      var p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
      point.set(CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
      return point;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(SplineCurve.prototype), "copy", this).call(this, source);

      this.points = [];

      for (var _i166 = 0, l = source.points.length; _i166 < l; _i166++) {
        var point = source.points[_i166];
        this.points.push(point.clone());
      }

      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(SplineCurve.prototype), "toJSON", this).call(this);

      data.points = [];

      for (var _i167 = 0, l = this.points.length; _i167 < l; _i167++) {
        var point = this.points[_i167];
        data.points.push(point.toArray());
      }

      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(SplineCurve.prototype), "fromJSON", this).call(this, json);

      this.points = [];

      for (var _i168 = 0, l = json.points.length; _i168 < l; _i168++) {
        var point = json.points[_i168];
        this.points.push(new Vector2().fromArray(point));
      }

      return this;
    }
  }]);

  return SplineCurve;
}(Curve);

SplineCurve.prototype.isSplineCurve = true;
var Curves = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ArcCurve: ArcCurve,
  CatmullRomCurve3: CatmullRomCurve3,
  CubicBezierCurve: CubicBezierCurve,
  CubicBezierCurve3: CubicBezierCurve3,
  EllipseCurve: EllipseCurve,
  LineCurve: LineCurve,
  LineCurve3: LineCurve3,
  QuadraticBezierCurve: QuadraticBezierCurve,
  QuadraticBezierCurve3: QuadraticBezierCurve3,
  SplineCurve: SplineCurve
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/

var CurvePath = /*#__PURE__*/function (_Curve10) {
  _inherits(CurvePath, _Curve10);

  var _super47 = _createSuper(CurvePath);

  function CurvePath() {
    var _this43;

    _classCallCheck2(this, CurvePath);

    _this43 = _super47.call(this);
    _this43.type = 'CurvePath';
    _this43.curves = [];
    _this43.autoClose = false; // Automatically closes the path

    return _this43;
  }

  _createClass2(CurvePath, [{
    key: "add",
    value: function add(curve) {
      this.curves.push(curve);
    }
  }, {
    key: "closePath",
    value: function closePath() {
      // Add a line curve if start and end of lines are not connected
      var startPoint = this.curves[0].getPoint(0);
      var endPoint = this.curves[this.curves.length - 1].getPoint(1);

      if (!startPoint.equals(endPoint)) {
        this.curves.push(new LineCurve(endPoint, startPoint));
      }
    } // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')

  }, {
    key: "getPoint",
    value: function getPoint(t, optionalTarget) {
      var d = t * this.getLength();
      var curveLengths = this.getCurveLengths();
      var i = 0; // To think about boundaries points.

      while (i < curveLengths.length) {
        if (curveLengths[i] >= d) {
          var diff = curveLengths[i] - d;
          var curve = this.curves[i];
          var segmentLength = curve.getLength();
          var u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
          return curve.getPointAt(u, optionalTarget);
        }

        i++;
      }

      return null; // loop where sum != 0, sum > d , sum+1 <d
    } // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength

  }, {
    key: "getLength",
    value: function getLength() {
      var lens = this.getCurveLengths();
      return lens[lens.length - 1];
    } // cacheLengths must be recalculated.

  }, {
    key: "updateArcLengths",
    value: function updateArcLengths() {
      this.needsUpdate = true;
      this.cacheLengths = null;
      this.getCurveLengths();
    } // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.

  }, {
    key: "getCurveLengths",
    value: function getCurveLengths() {
      // We use cache values if curves and cache array are same length
      if (this.cacheLengths && this.cacheLengths.length === this.curves.length) {
        return this.cacheLengths;
      } // Get length of sub-curve
      // Push sums into cached array


      var lengths = [];
      var sums = 0;

      for (var _i169 = 0, l = this.curves.length; _i169 < l; _i169++) {
        sums += this.curves[_i169].getLength();
        lengths.push(sums);
      }

      this.cacheLengths = lengths;
      return lengths;
    }
  }, {
    key: "getSpacedPoints",
    value: function getSpacedPoints() {
      var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 40;
      var points = [];

      for (var _i170 = 0; _i170 <= divisions; _i170++) {
        points.push(this.getPoint(_i170 / divisions));
      }

      if (this.autoClose) {
        points.push(points[0]);
      }

      return points;
    }
  }, {
    key: "getPoints",
    value: function getPoints() {
      var divisions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 12;
      var points = [];
      var last;

      for (var _i171 = 0, curves = this.curves; _i171 < curves.length; _i171++) {
        var curve = curves[_i171];
        var resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
        var pts = curve.getPoints(resolution);

        for (var j = 0; j < pts.length; j++) {
          var point = pts[j];
          if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates

          points.push(point);
          last = point;
        }
      }

      if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) {
        points.push(points[0]);
      }

      return points;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(CurvePath.prototype), "copy", this).call(this, source);

      this.curves = [];

      for (var _i172 = 0, l = source.curves.length; _i172 < l; _i172++) {
        var curve = source.curves[_i172];
        this.curves.push(curve.clone());
      }

      this.autoClose = source.autoClose;
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(CurvePath.prototype), "toJSON", this).call(this);

      data.autoClose = this.autoClose;
      data.curves = [];

      for (var _i173 = 0, l = this.curves.length; _i173 < l; _i173++) {
        var curve = this.curves[_i173];
        data.curves.push(curve.toJSON());
      }

      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(CurvePath.prototype), "fromJSON", this).call(this, json);

      this.autoClose = json.autoClose;
      this.curves = [];

      for (var _i174 = 0, l = json.curves.length; _i174 < l; _i174++) {
        var curve = json.curves[_i174];
        this.curves.push(new Curves[curve.type]().fromJSON(curve));
      }

      return this;
    }
  }]);

  return CurvePath;
}(Curve);

var Path = /*#__PURE__*/function (_CurvePath) {
  _inherits(Path, _CurvePath);

  var _super48 = _createSuper(Path);

  function Path(points) {
    var _this44;

    _classCallCheck2(this, Path);

    _this44 = _super48.call(this);
    _this44.type = 'Path';
    _this44.currentPoint = new Vector2();

    if (points) {
      _this44.setFromPoints(points);
    }

    return _this44;
  }

  _createClass2(Path, [{
    key: "setFromPoints",
    value: function setFromPoints(points) {
      this.moveTo(points[0].x, points[0].y);

      for (var _i175 = 1, l = points.length; _i175 < l; _i175++) {
        this.lineTo(points[_i175].x, points[_i175].y);
      }

      return this;
    }
  }, {
    key: "moveTo",
    value: function moveTo(x, y) {
      this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?

      return this;
    }
  }, {
    key: "lineTo",
    value: function lineTo(x, y) {
      var curve = new LineCurve(this.currentPoint.clone(), new Vector2(x, y));
      this.curves.push(curve);
      this.currentPoint.set(x, y);
      return this;
    }
  }, {
    key: "quadraticCurveTo",
    value: function quadraticCurveTo(aCPx, aCPy, aX, aY) {
      var curve = new QuadraticBezierCurve(this.currentPoint.clone(), new Vector2(aCPx, aCPy), new Vector2(aX, aY));
      this.curves.push(curve);
      this.currentPoint.set(aX, aY);
      return this;
    }
  }, {
    key: "bezierCurveTo",
    value: function bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
      var curve = new CubicBezierCurve(this.currentPoint.clone(), new Vector2(aCP1x, aCP1y), new Vector2(aCP2x, aCP2y), new Vector2(aX, aY));
      this.curves.push(curve);
      this.currentPoint.set(aX, aY);
      return this;
    }
  }, {
    key: "splineThru",
    value: function splineThru(pts
    /*Array of Vector*/
    ) {
      var npts = [this.currentPoint.clone()].concat(pts);
      var curve = new SplineCurve(npts);
      this.curves.push(curve);
      this.currentPoint.copy(pts[pts.length - 1]);
      return this;
    }
  }, {
    key: "arc",
    value: function arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
      var x0 = this.currentPoint.x;
      var y0 = this.currentPoint.y;
      this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
      return this;
    }
  }, {
    key: "absarc",
    value: function absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
      this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
      return this;
    }
  }, {
    key: "ellipse",
    value: function ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
      var x0 = this.currentPoint.x;
      var y0 = this.currentPoint.y;
      this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
      return this;
    }
  }, {
    key: "absellipse",
    value: function absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
      var curve = new EllipseCurve(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);

      if (this.curves.length > 0) {
        // if a previous curve is present, attempt to join
        var firstPoint = curve.getPoint(0);

        if (!firstPoint.equals(this.currentPoint)) {
          this.lineTo(firstPoint.x, firstPoint.y);
        }
      }

      this.curves.push(curve);
      var lastPoint = curve.getPoint(1);
      this.currentPoint.copy(lastPoint);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(Path.prototype), "copy", this).call(this, source);

      this.currentPoint.copy(source.currentPoint);
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(Path.prototype), "toJSON", this).call(this);

      data.currentPoint = this.currentPoint.toArray();
      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(Path.prototype), "fromJSON", this).call(this, json);

      this.currentPoint.fromArray(json.currentPoint);
      return this;
    }
  }]);

  return Path;
}(CurvePath);

var CylinderGeometry = /*#__PURE__*/function (_BufferGeometry3) {
  _inherits(CylinderGeometry, _BufferGeometry3);

  var _super49 = _createSuper(CylinderGeometry);

  function CylinderGeometry() {
    var _this45;

    var radiusTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var radiusBottom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var radialSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 8;
    var heightSegments = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var openEnded = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var thetaStart = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    var thetaLength = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : Math.PI * 2;

    _classCallCheck2(this, CylinderGeometry);

    _this45 = _super49.call(this);
    _this45.type = 'CylinderGeometry';
    _this45.parameters = {
      radiusTop: radiusTop,
      radiusBottom: radiusBottom,
      height: height,
      radialSegments: radialSegments,
      heightSegments: heightSegments,
      openEnded: openEnded,
      thetaStart: thetaStart,
      thetaLength: thetaLength
    };

    var scope = _assertThisInitialized(_this45);

    radialSegments = Math.floor(radialSegments);
    heightSegments = Math.floor(heightSegments); // buffers

    var indices = [];
    var vertices = [];
    var normals = [];
    var uvs = []; // helper variables

    var index = 0;
    var indexArray = [];
    var halfHeight = height / 2;
    var groupStart = 0; // generate geometry

    generateTorso();

    if (openEnded === false) {
      if (radiusTop > 0) generateCap(true);
      if (radiusBottom > 0) generateCap(false);
    } // build geometry


    _this45.setIndex(indices);

    _this45.setAttribute('position', new Float32BufferAttribute(vertices, 3));

    _this45.setAttribute('normal', new Float32BufferAttribute(normals, 3));

    _this45.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

    function generateTorso() {
      var normal = new Vector3();
      var vertex = new Vector3();
      var groupCount = 0; // this will be used to calculate the normal

      var slope = (radiusBottom - radiusTop) / height; // generate vertices, normals and uvs

      for (var y = 0; y <= heightSegments; y++) {
        var indexRow = [];
        var v = y / heightSegments; // calculate the radius of the current row

        var radius = v * (radiusBottom - radiusTop) + radiusTop;

        for (var x = 0; x <= radialSegments; x++) {
          var u = x / radialSegments;
          var theta = u * thetaLength + thetaStart;
          var sinTheta = Math.sin(theta);
          var cosTheta = Math.cos(theta); // vertex

          vertex.x = radius * sinTheta;
          vertex.y = -v * height + halfHeight;
          vertex.z = radius * cosTheta;
          vertices.push(vertex.x, vertex.y, vertex.z); // normal

          normal.set(sinTheta, slope, cosTheta).normalize();
          normals.push(normal.x, normal.y, normal.z); // uv

          uvs.push(u, 1 - v); // save index of vertex in respective row

          indexRow.push(index++);
        } // now save vertices of the row in our index array


        indexArray.push(indexRow);
      } // generate indices


      for (var _x4 = 0; _x4 < radialSegments; _x4++) {
        for (var _y2 = 0; _y2 < heightSegments; _y2++) {
          // we use the index array to access the correct indices
          var a = indexArray[_y2][_x4];
          var b = indexArray[_y2 + 1][_x4];
          var c = indexArray[_y2 + 1][_x4 + 1];
          var d = indexArray[_y2][_x4 + 1]; // faces

          indices.push(a, b, d);
          indices.push(b, c, d); // update group counter

          groupCount += 6;
        }
      } // add a group to the geometry. this will ensure multi material support


      scope.addGroup(groupStart, groupCount, 0); // calculate new start value for groups

      groupStart += groupCount;
    }

    function generateCap(top) {
      // save the index of the first center vertex
      var centerIndexStart = index;
      var uv = new Vector2();
      var vertex = new Vector3();
      var groupCount = 0;
      var radius = top === true ? radiusTop : radiusBottom;
      var sign = top === true ? 1 : -1; // first we generate the center vertex data of the cap.
      // because the geometry needs one set of uvs per face,
      // we must generate a center vertex per face/segment

      for (var x = 1; x <= radialSegments; x++) {
        // vertex
        vertices.push(0, halfHeight * sign, 0); // normal

        normals.push(0, sign, 0); // uv

        uvs.push(0.5, 0.5); // increase index

        index++;
      } // save the index of the last center vertex


      var centerIndexEnd = index; // now we generate the surrounding vertices, normals and uvs

      for (var _x5 = 0; _x5 <= radialSegments; _x5++) {
        var u = _x5 / radialSegments;
        var theta = u * thetaLength + thetaStart;
        var cosTheta = Math.cos(theta);
        var sinTheta = Math.sin(theta); // vertex

        vertex.x = radius * sinTheta;
        vertex.y = halfHeight * sign;
        vertex.z = radius * cosTheta;
        vertices.push(vertex.x, vertex.y, vertex.z); // normal

        normals.push(0, sign, 0); // uv

        uv.x = cosTheta * 0.5 + 0.5;
        uv.y = sinTheta * 0.5 * sign + 0.5;
        uvs.push(uv.x, uv.y); // increase index

        index++;
      } // generate indices


      for (var _x6 = 0; _x6 < radialSegments; _x6++) {
        var c = centerIndexStart + _x6;

        var _i176 = centerIndexEnd + _x6;

        if (top === true) {
          // face top
          indices.push(_i176, _i176 + 1, c);
        } else {
          // face bottom
          indices.push(_i176 + 1, _i176, c);
        }

        groupCount += 3;
      } // add a group to the geometry. this will ensure multi material support


      scope.addGroup(groupStart, groupCount, top === true ? 1 : 2); // calculate new start value for groups

      groupStart += groupCount;
    }

    return _this45;
  }

  _createClass2(CylinderGeometry, null, [{
    key: "fromJSON",
    value: function fromJSON(data) {
      return new CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
  }]);

  return CylinderGeometry;
}(BufferGeometry);

var PolyhedronGeometry = /*#__PURE__*/function (_BufferGeometry4) {
  _inherits(PolyhedronGeometry, _BufferGeometry4);

  var _super50 = _createSuper(PolyhedronGeometry);

  function PolyhedronGeometry() {
    var _this46;

    var vertices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var indices = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var detail = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    _classCallCheck2(this, PolyhedronGeometry);

    _this46 = _super50.call(this);
    _this46.type = 'PolyhedronGeometry';
    _this46.parameters = {
      vertices: vertices,
      indices: indices,
      radius: radius,
      detail: detail
    }; // default buffer data

    var vertexBuffer = [];
    var uvBuffer = []; // the subdivision creates the vertex buffer data

    subdivide(detail); // all vertices should lie on a conceptual sphere with a given radius

    applyRadius(radius); // finally, create the uv data

    generateUVs(); // build non-indexed geometry

    _this46.setAttribute('position', new Float32BufferAttribute(vertexBuffer, 3));

    _this46.setAttribute('normal', new Float32BufferAttribute(vertexBuffer.slice(), 3));

    _this46.setAttribute('uv', new Float32BufferAttribute(uvBuffer, 2));

    if (detail === 0) {
      _this46.computeVertexNormals(); // flat normals

    } else {
      _this46.normalizeNormals(); // smooth normals

    } // helper functions


    function subdivide(detail) {
      var a = new Vector3();
      var b = new Vector3();
      var c = new Vector3(); // iterate over all faces and apply a subdivison with the given detail value

      for (var _i177 = 0; _i177 < indices.length; _i177 += 3) {
        // get the vertices of the face
        getVertexByIndex(indices[_i177 + 0], a);
        getVertexByIndex(indices[_i177 + 1], b);
        getVertexByIndex(indices[_i177 + 2], c); // perform subdivision

        subdivideFace(a, b, c, detail);
      }
    }

    function subdivideFace(a, b, c, detail) {
      var cols = detail + 1; // we use this multidimensional array as a data structure for creating the subdivision

      var v = []; // construct all of the vertices for this subdivision

      for (var _i178 = 0; _i178 <= cols; _i178++) {
        v[_i178] = [];
        var aj = a.clone().lerp(c, _i178 / cols);
        var bj = b.clone().lerp(c, _i178 / cols);
        var rows = cols - _i178;

        for (var j = 0; j <= rows; j++) {
          if (j === 0 && _i178 === cols) {
            v[_i178][j] = aj;
          } else {
            v[_i178][j] = aj.clone().lerp(bj, j / rows);
          }
        }
      } // construct all of the faces


      for (var _i179 = 0; _i179 < cols; _i179++) {
        for (var _j6 = 0; _j6 < 2 * (cols - _i179) - 1; _j6++) {
          var k = Math.floor(_j6 / 2);

          if (_j6 % 2 === 0) {
            pushVertex(v[_i179][k + 1]);
            pushVertex(v[_i179 + 1][k]);
            pushVertex(v[_i179][k]);
          } else {
            pushVertex(v[_i179][k + 1]);
            pushVertex(v[_i179 + 1][k + 1]);
            pushVertex(v[_i179 + 1][k]);
          }
        }
      }
    }

    function applyRadius(radius) {
      var vertex = new Vector3(); // iterate over the entire buffer and apply the radius to each vertex

      for (var _i180 = 0; _i180 < vertexBuffer.length; _i180 += 3) {
        vertex.x = vertexBuffer[_i180 + 0];
        vertex.y = vertexBuffer[_i180 + 1];
        vertex.z = vertexBuffer[_i180 + 2];
        vertex.normalize().multiplyScalar(radius);
        vertexBuffer[_i180 + 0] = vertex.x;
        vertexBuffer[_i180 + 1] = vertex.y;
        vertexBuffer[_i180 + 2] = vertex.z;
      }
    }

    function generateUVs() {
      var vertex = new Vector3();

      for (var _i181 = 0; _i181 < vertexBuffer.length; _i181 += 3) {
        vertex.x = vertexBuffer[_i181 + 0];
        vertex.y = vertexBuffer[_i181 + 1];
        vertex.z = vertexBuffer[_i181 + 2];
        var u = azimuth(vertex) / 2 / Math.PI + 0.5;
        var v = inclination(vertex) / Math.PI + 0.5;
        uvBuffer.push(u, 1 - v);
      }

      correctUVs();
      correctSeam();
    }

    function correctSeam() {
      // handle case when face straddles the seam, see #3269
      for (var _i182 = 0; _i182 < uvBuffer.length; _i182 += 6) {
        // uv data of a single face
        var x0 = uvBuffer[_i182 + 0];
        var x1 = uvBuffer[_i182 + 2];
        var x2 = uvBuffer[_i182 + 4];
        var max = Math.max(x0, x1, x2);
        var min = Math.min(x0, x1, x2); // 0.9 is somewhat arbitrary

        if (max > 0.9 && min < 0.1) {
          if (x0 < 0.2) uvBuffer[_i182 + 0] += 1;
          if (x1 < 0.2) uvBuffer[_i182 + 2] += 1;
          if (x2 < 0.2) uvBuffer[_i182 + 4] += 1;
        }
      }
    }

    function pushVertex(vertex) {
      vertexBuffer.push(vertex.x, vertex.y, vertex.z);
    }

    function getVertexByIndex(index, vertex) {
      var stride = index * 3;
      vertex.x = vertices[stride + 0];
      vertex.y = vertices[stride + 1];
      vertex.z = vertices[stride + 2];
    }

    function correctUVs() {
      var a = new Vector3();
      var b = new Vector3();
      var c = new Vector3();
      var centroid = new Vector3();
      var uvA = new Vector2();
      var uvB = new Vector2();
      var uvC = new Vector2();

      for (var _i183 = 0, j = 0; _i183 < vertexBuffer.length; _i183 += 9, j += 6) {
        a.set(vertexBuffer[_i183 + 0], vertexBuffer[_i183 + 1], vertexBuffer[_i183 + 2]);
        b.set(vertexBuffer[_i183 + 3], vertexBuffer[_i183 + 4], vertexBuffer[_i183 + 5]);
        c.set(vertexBuffer[_i183 + 6], vertexBuffer[_i183 + 7], vertexBuffer[_i183 + 8]);
        uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
        uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
        uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
        centroid.copy(a).add(b).add(c).divideScalar(3);
        var azi = azimuth(centroid);
        correctUV(uvA, j + 0, a, azi);
        correctUV(uvB, j + 2, b, azi);
        correctUV(uvC, j + 4, c, azi);
      }
    }

    function correctUV(uv, stride, vector, azimuth) {
      if (azimuth < 0 && uv.x === 1) {
        uvBuffer[stride] = uv.x - 1;
      }

      if (vector.x === 0 && vector.z === 0) {
        uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
      }
    } // Angle around the Y axis, counter-clockwise when looking from above.


    function azimuth(vector) {
      return Math.atan2(vector.z, -vector.x);
    } // Angle above the XZ plane.


    function inclination(vector) {
      return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
    }

    return _this46;
  }

  _createClass2(PolyhedronGeometry, null, [{
    key: "fromJSON",
    value: function fromJSON(data) {
      return new PolyhedronGeometry(data.vertices, data.indices, data.radius, data.details);
    }
  }]);

  return PolyhedronGeometry;
}(BufferGeometry);

var _v0 = new Vector3();

var _v1$1 = new Vector3();

var _normal = new Vector3();

var _triangle = new Triangle();

var EdgesGeometry = /*#__PURE__*/function (_BufferGeometry5) {
  _inherits(EdgesGeometry, _BufferGeometry5);

  var _super51 = _createSuper(EdgesGeometry);

  function EdgesGeometry() {
    var _this47;

    var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var thresholdAngle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck2(this, EdgesGeometry);

    _this47 = _super51.call(this);
    _this47.type = 'EdgesGeometry';
    _this47.parameters = {
      geometry: geometry,
      thresholdAngle: thresholdAngle
    };

    if (geometry !== null) {
      var precisionPoints = 4;
      var precision = Math.pow(10, precisionPoints);
      var thresholdDot = Math.cos(DEG2RAD * thresholdAngle);
      var indexAttr = geometry.getIndex();
      var positionAttr = geometry.getAttribute('position');
      var indexCount = indexAttr ? indexAttr.count : positionAttr.count;
      var indexArr = [0, 0, 0];
      var vertKeys = ['a', 'b', 'c'];
      var hashes = new Array(3);
      var edgeData = {};
      var vertices = [];

      for (var _i184 = 0; _i184 < indexCount; _i184 += 3) {
        if (indexAttr) {
          indexArr[0] = indexAttr.getX(_i184);
          indexArr[1] = indexAttr.getX(_i184 + 1);
          indexArr[2] = indexAttr.getX(_i184 + 2);
        } else {
          indexArr[0] = _i184;
          indexArr[1] = _i184 + 1;
          indexArr[2] = _i184 + 2;
        }

        var a = _triangle.a,
            b = _triangle.b,
            c = _triangle.c;
        a.fromBufferAttribute(positionAttr, indexArr[0]);
        b.fromBufferAttribute(positionAttr, indexArr[1]);
        c.fromBufferAttribute(positionAttr, indexArr[2]);

        _triangle.getNormal(_normal); // create hashes for the edge from the vertices


        hashes[0] = "".concat(Math.round(a.x * precision), ",").concat(Math.round(a.y * precision), ",").concat(Math.round(a.z * precision));
        hashes[1] = "".concat(Math.round(b.x * precision), ",").concat(Math.round(b.y * precision), ",").concat(Math.round(b.z * precision));
        hashes[2] = "".concat(Math.round(c.x * precision), ",").concat(Math.round(c.y * precision), ",").concat(Math.round(c.z * precision)); // skip degenerate triangles

        if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) {
          continue;
        } // iterate over every edge


        for (var j = 0; j < 3; j++) {
          // get the first and next vertex making up the edge
          var jNext = (j + 1) % 3;
          var vecHash0 = hashes[j];
          var vecHash1 = hashes[jNext];
          var v0 = _triangle[vertKeys[j]];
          var v1 = _triangle[vertKeys[jNext]];
          var hash = "".concat(vecHash0, "_").concat(vecHash1);
          var reverseHash = "".concat(vecHash1, "_").concat(vecHash0);

          if (reverseHash in edgeData && edgeData[reverseHash]) {
            // if we found a sibling edge add it into the vertex array if
            // it meets the angle threshold and delete the edge from the map.
            if (_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
              vertices.push(v0.x, v0.y, v0.z);
              vertices.push(v1.x, v1.y, v1.z);
            }

            edgeData[reverseHash] = null;
          } else if (!(hash in edgeData)) {
            // if we've already got an edge here then skip adding a new one
            edgeData[hash] = {
              index0: indexArr[j],
              index1: indexArr[jNext],
              normal: _normal.clone()
            };
          }
        }
      } // iterate over all remaining, unmatched edges and add them to the vertex array


      for (var key in edgeData) {
        if (edgeData[key]) {
          var _edgeData$key = edgeData[key],
              index0 = _edgeData$key.index0,
              index1 = _edgeData$key.index1;

          _v0.fromBufferAttribute(positionAttr, index0);

          _v1$1.fromBufferAttribute(positionAttr, index1);

          vertices.push(_v0.x, _v0.y, _v0.z);
          vertices.push(_v1$1.x, _v1$1.y, _v1$1.z);
        }
      }

      _this47.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    }

    return _this47;
  }

  return EdgesGeometry;
}(BufferGeometry);

var Shape = /*#__PURE__*/function (_Path) {
  _inherits(Shape, _Path);

  var _super52 = _createSuper(Shape);

  function Shape(points) {
    var _this48;

    _classCallCheck2(this, Shape);

    _this48 = _super52.call(this, points);
    _this48.uuid = generateUUID();
    _this48.type = 'Shape';
    _this48.holes = [];
    return _this48;
  }

  _createClass2(Shape, [{
    key: "getPointsHoles",
    value: function getPointsHoles(divisions) {
      var holesPts = [];

      for (var _i185 = 0, l = this.holes.length; _i185 < l; _i185++) {
        holesPts[_i185] = this.holes[_i185].getPoints(divisions);
      }

      return holesPts;
    } // get points of shape and holes (keypoints based on segments parameter)

  }, {
    key: "extractPoints",
    value: function extractPoints(divisions) {
      return {
        shape: this.getPoints(divisions),
        holes: this.getPointsHoles(divisions)
      };
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(Shape.prototype), "copy", this).call(this, source);

      this.holes = [];

      for (var _i186 = 0, l = source.holes.length; _i186 < l; _i186++) {
        var hole = source.holes[_i186];
        this.holes.push(hole.clone());
      }

      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(Shape.prototype), "toJSON", this).call(this);

      data.uuid = this.uuid;
      data.holes = [];

      for (var _i187 = 0, l = this.holes.length; _i187 < l; _i187++) {
        var hole = this.holes[_i187];
        data.holes.push(hole.toJSON());
      }

      return data;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(json) {
      _get(_getPrototypeOf(Shape.prototype), "fromJSON", this).call(this, json);

      this.uuid = json.uuid;
      this.holes = [];

      for (var _i188 = 0, l = json.holes.length; _i188 < l; _i188++) {
        var hole = json.holes[_i188];
        this.holes.push(new Path().fromJSON(hole));
      }

      return this;
    }
  }]);

  return Shape;
}(Path);
/**
 * Port from https://github.com/mapbox/earcut (v2.2.2)
 */


var Earcut = {
  triangulate: function triangulate(data, holeIndices) {
    var dim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var outerNode = linkedList(data, 0, outerLen, dim, true);
    var triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    var minX, minY, maxX, maxY, x, y, invSize;
    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim); // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox

    if (data.length > 80 * dim) {
      minX = maxX = data[0];
      minY = maxY = data[1];

      for (var _i189 = dim; _i189 < outerLen; _i189 += dim) {
        x = data[_i189];
        y = data[_i189 + 1];
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      } // minX, minY and invSize are later used to transform coords into integers for z-order calculation


      invSize = Math.max(maxX - minX, maxY - minY);
      invSize = invSize !== 0 ? 1 / invSize : 0;
    }

    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
    return triangles;
  }
}; // create a circular doubly linked list from polygon points in the specified winding order

function linkedList(data, start, end, dim, clockwise) {
  var i, last;

  if (clockwise === signedArea(data, start, end, dim) > 0) {
    for (i = start; i < end; i += dim) {
      last = insertNode(i, data[i], data[i + 1], last);
    }
  } else {
    for (i = end - dim; i >= start; i -= dim) {
      last = insertNode(i, data[i], data[i + 1], last);
    }
  }

  if (last && equals(last, last.next)) {
    removeNode(last);
    last = last.next;
  }

  return last;
} // eliminate colinear or duplicate points


function filterPoints(start, end) {
  if (!start) return start;
  if (!end) end = start;
  var p = start,
      again;

  do {
    again = false;

    if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
      removeNode(p);
      p = end = p.prev;
      if (p === p.next) break;
      again = true;
    } else {
      p = p.next;
    }
  } while (again || p !== end);

  return end;
} // main ear slicing loop which triangulates a polygon (given as a linked list)


function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
  if (!ear) return; // interlink polygon nodes in z-order

  if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
  var stop = ear,
      prev,
      next; // iterate through ears, slicing them one by one

  while (ear.prev !== ear.next) {
    prev = ear.prev;
    next = ear.next;

    if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
      // cut off the triangle
      triangles.push(prev.i / dim);
      triangles.push(ear.i / dim);
      triangles.push(next.i / dim);
      removeNode(ear); // skipping the next vertex leads to less sliver triangles

      ear = next.next;
      stop = next.next;
      continue;
    }

    ear = next; // if we looped through the whole remaining polygon and can't find any more ears

    if (ear === stop) {
      // try filtering points and slicing again
      if (!pass) {
        earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1); // if this didn't work, try curing all small self-intersections locally
      } else if (pass === 1) {
        ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
        earcutLinked(ear, triangles, dim, minX, minY, invSize, 2); // as a last resort, try splitting the remaining polygon into two
      } else if (pass === 2) {
        splitEarcut(ear, triangles, dim, minX, minY, invSize);
      }

      break;
    }
  }
} // check whether a polygon node forms a valid ear with adjacent nodes


function isEar(ear) {
  var a = ear.prev,
      b = ear,
      c = ear.next;
  if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
  // now make sure we don't have other points inside the potential ear

  var p = ear.next.next;

  while (p !== ear.prev) {
    if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
    p = p.next;
  }

  return true;
}

function isEarHashed(ear, minX, minY, invSize) {
  var a = ear.prev,
      b = ear,
      c = ear.next;
  if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
  // triangle bbox; min & max are calculated like this for speed

  var minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x,
      minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y,
      maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x,
      maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y; // z-order range for the current triangle bbox;

  var minZ = zOrder(minTX, minTY, minX, minY, invSize),
      maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
  var p = ear.prevZ,
      n = ear.nextZ; // look for points inside the triangle in both directions

  while (p && p.z >= minZ && n && n.z <= maxZ) {
    if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
    p = p.prevZ;
    if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
    n = n.nextZ;
  } // look for remaining points in decreasing z-order


  while (p && p.z >= minZ) {
    if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
    p = p.prevZ;
  } // look for remaining points in increasing z-order


  while (n && n.z <= maxZ) {
    if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
    n = n.nextZ;
  }

  return true;
} // go through all polygon nodes and cure small local self-intersections


function cureLocalIntersections(start, triangles, dim) {
  var p = start;

  do {
    var a = p.prev,
        b = p.next.next;

    if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
      triangles.push(a.i / dim);
      triangles.push(p.i / dim);
      triangles.push(b.i / dim); // remove two nodes involved

      removeNode(p);
      removeNode(p.next);
      p = start = b;
    }

    p = p.next;
  } while (p !== start);

  return filterPoints(p);
} // try splitting polygon into two and triangulate them independently


function splitEarcut(start, triangles, dim, minX, minY, invSize) {
  // look for a valid diagonal that divides the polygon into two
  var a = start;

  do {
    var b = a.next.next;

    while (b !== a.prev) {
      if (a.i !== b.i && isValidDiagonal(a, b)) {
        // split the polygon in two by the diagonal
        var c = splitPolygon(a, b); // filter colinear points around the cuts

        a = filterPoints(a, a.next);
        c = filterPoints(c, c.next); // run earcut on each half

        earcutLinked(a, triangles, dim, minX, minY, invSize);
        earcutLinked(c, triangles, dim, minX, minY, invSize);
        return;
      }

      b = b.next;
    }

    a = a.next;
  } while (a !== start);
} // link every hole into the outer loop, producing a single-ring polygon without holes


function eliminateHoles(data, holeIndices, outerNode, dim) {
  var queue = [];
  var i, len, start, end, list;

  for (i = 0, len = holeIndices.length; i < len; i++) {
    start = holeIndices[i] * dim;
    end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
    list = linkedList(data, start, end, dim, false);
    if (list === list.next) list.steiner = true;
    queue.push(getLeftmost(list));
  }

  queue.sort(compareX); // process holes from left to right

  for (i = 0; i < queue.length; i++) {
    eliminateHole(queue[i], outerNode);
    outerNode = filterPoints(outerNode, outerNode.next);
  }

  return outerNode;
}

function compareX(a, b) {
  return a.x - b.x;
} // find a bridge between vertices that connects hole with an outer ring and link it


function eliminateHole(hole, outerNode) {
  outerNode = findHoleBridge(hole, outerNode);

  if (outerNode) {
    var b = splitPolygon(outerNode, hole); // filter collinear points around the cuts

    filterPoints(outerNode, outerNode.next);
    filterPoints(b, b.next);
  }
} // David Eberly's algorithm for finding a bridge between hole and outer polygon


function findHoleBridge(hole, outerNode) {
  var p = outerNode;
  var hx = hole.x;
  var hy = hole.y;
  var qx = -Infinity,
      m; // find a segment intersected by a ray from the hole's leftmost point to the left;
  // segment's endpoint with lesser x will be potential connection point

  do {
    if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
      var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);

      if (x <= hx && x > qx) {
        qx = x;

        if (x === hx) {
          if (hy === p.y) return p;
          if (hy === p.next.y) return p.next;
        }

        m = p.x < p.next.x ? p : p.next;
      }
    }

    p = p.next;
  } while (p !== outerNode);

  if (!m) return null;
  if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
  // look for points inside the triangle of hole point, segment intersection and endpoint;
  // if there are no points found, we have a valid connection;
  // otherwise choose the point of the minimum angle with the ray as connection point

  var stop = m,
      mx = m.x,
      my = m.y;
  var tanMin = Infinity,
      tan;
  p = m;

  do {
    if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
      tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

      if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
        m = p;
        tanMin = tan;
      }
    }

    p = p.next;
  } while (p !== stop);

  return m;
} // whether sector in vertex m contains sector in vertex p in the same coordinates


function sectorContainsSector(m, p) {
  return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
} // interlink polygon nodes in z-order


function indexCurve(start, minX, minY, invSize) {
  var p = start;

  do {
    if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
    p.prevZ = p.prev;
    p.nextZ = p.next;
    p = p.next;
  } while (p !== start);

  p.prevZ.nextZ = null;
  p.prevZ = null;
  sortLinked(p);
} // Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html


function sortLinked(list) {
  var i,
      p,
      q,
      e,
      tail,
      numMerges,
      pSize,
      qSize,
      inSize = 1;

  do {
    p = list;
    list = null;
    tail = null;
    numMerges = 0;

    while (p) {
      numMerges++;
      q = p;
      pSize = 0;

      for (i = 0; i < inSize; i++) {
        pSize++;
        q = q.nextZ;
        if (!q) break;
      }

      qSize = inSize;

      while (pSize > 0 || qSize > 0 && q) {
        if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
          e = p;
          p = p.nextZ;
          pSize--;
        } else {
          e = q;
          q = q.nextZ;
          qSize--;
        }

        if (tail) tail.nextZ = e;else list = e;
        e.prevZ = tail;
        tail = e;
      }

      p = q;
    }

    tail.nextZ = null;
    inSize *= 2;
  } while (numMerges > 1);

  return list;
} // z-order of a point given coords and inverse of the longer side of data bbox


function zOrder(x, y, minX, minY, invSize) {
  // coords are transformed into non-negative 15-bit integer range
  x = 32767 * (x - minX) * invSize;
  y = 32767 * (y - minY) * invSize;
  x = (x | x << 8) & 0x00FF00FF;
  x = (x | x << 4) & 0x0F0F0F0F;
  x = (x | x << 2) & 0x33333333;
  x = (x | x << 1) & 0x55555555;
  y = (y | y << 8) & 0x00FF00FF;
  y = (y | y << 4) & 0x0F0F0F0F;
  y = (y | y << 2) & 0x33333333;
  y = (y | y << 1) & 0x55555555;
  return x | y << 1;
} // find the leftmost node of a polygon ring


function getLeftmost(start) {
  var p = start,
      leftmost = start;

  do {
    if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
    p = p.next;
  } while (p !== start);

  return leftmost;
} // check if a point lies within a convex triangle


function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
  return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
} // check if a diagonal between two polygon nodes is valid (lies in polygon interior)


function isValidDiagonal(a, b) {
  return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && ( // doesn't intersect other edges
  locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && ( // locally visible
  area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
  equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
} // signed area of a triangle


function area(p, q, r) {
  return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
} // check if two points are equal


function equals(p1, p2) {
  return p1.x === p2.x && p1.y === p2.y;
} // check if two segments intersect


function intersects(p1, q1, p2, q2) {
  var o1 = sign(area(p1, q1, p2));
  var o2 = sign(area(p1, q1, q2));
  var o3 = sign(area(p2, q2, p1));
  var o4 = sign(area(p2, q2, q1));
  if (o1 !== o2 && o3 !== o4) return true; // general case

  if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1

  if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1

  if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2

  if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2

  return false;
} // for collinear points p, q, r, check if point q lies on segment pr


function onSegment(p, q, r) {
  return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}

function sign(num) {
  return num > 0 ? 1 : num < 0 ? -1 : 0;
} // check if a polygon diagonal intersects any polygon segments


function intersectsPolygon(a, b) {
  var p = a;

  do {
    if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
    p = p.next;
  } while (p !== a);

  return false;
} // check if a polygon diagonal is locally inside the polygon


function locallyInside(a, b) {
  return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
} // check if the middle point of a polygon diagonal is inside the polygon


function middleInside(a, b) {
  var p = a,
      inside = false;
  var px = (a.x + b.x) / 2,
      py = (a.y + b.y) / 2;

  do {
    if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
    p = p.next;
  } while (p !== a);

  return inside;
} // link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring


function splitPolygon(a, b) {
  var a2 = new Node(a.i, a.x, a.y),
      b2 = new Node(b.i, b.x, b.y),
      an = a.next,
      bp = b.prev;
  a.next = b;
  b.prev = a;
  a2.next = an;
  an.prev = a2;
  b2.next = a2;
  a2.prev = b2;
  bp.next = b2;
  b2.prev = bp;
  return b2;
} // create a node and optionally link it with previous one (in a circular doubly linked list)


function insertNode(i, x, y, last) {
  var p = new Node(i, x, y);

  if (!last) {
    p.prev = p;
    p.next = p;
  } else {
    p.next = last.next;
    p.prev = last;
    last.next.prev = p;
    last.next = p;
  }

  return p;
}

function removeNode(p) {
  p.next.prev = p.prev;
  p.prev.next = p.next;
  if (p.prevZ) p.prevZ.nextZ = p.nextZ;
  if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}

function Node(i, x, y) {
  // vertex index in coordinates array
  this.i = i; // vertex coordinates

  this.x = x;
  this.y = y; // previous and next vertex nodes in a polygon ring

  this.prev = null;
  this.next = null; // z-order curve value

  this.z = null; // previous and next nodes in z-order

  this.prevZ = null;
  this.nextZ = null; // indicates whether this is a steiner point

  this.steiner = false;
}

function signedArea(data, start, end, dim) {
  var sum = 0;

  for (var _i190 = start, j = end - dim; _i190 < end; _i190 += dim) {
    sum += (data[j] - data[_i190]) * (data[_i190 + 1] + data[j + 1]);
    j = _i190;
  }

  return sum;
}

var ShapeUtils = /*#__PURE__*/function () {
  function ShapeUtils() {
    _classCallCheck2(this, ShapeUtils);
  }

  _createClass2(ShapeUtils, null, [{
    key: "area",
    value: // calculate area of the contour polygon
    function area(contour) {
      var n = contour.length;
      var a = 0.0;

      for (var p = n - 1, q = 0; q < n; p = q++) {
        a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
      }

      return a * 0.5;
    }
  }, {
    key: "isClockWise",
    value: function isClockWise(pts) {
      return ShapeUtils.area(pts) < 0;
    }
  }, {
    key: "triangulateShape",
    value: function triangulateShape(contour, holes) {
      var vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]

      var holeIndices = []; // array of hole indices

      var faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]

      removeDupEndPts(contour);
      addContour(vertices, contour); //

      var holeIndex = contour.length;
      holes.forEach(removeDupEndPts);

      for (var _i191 = 0; _i191 < holes.length; _i191++) {
        holeIndices.push(holeIndex);
        holeIndex += holes[_i191].length;
        addContour(vertices, holes[_i191]);
      } //


      var triangles = Earcut.triangulate(vertices, holeIndices); //

      for (var _i192 = 0; _i192 < triangles.length; _i192 += 3) {
        faces.push(triangles.slice(_i192, _i192 + 3));
      }

      return faces;
    }
  }]);

  return ShapeUtils;
}();

function removeDupEndPts(points) {
  var l = points.length;

  if (l > 2 && points[l - 1].equals(points[0])) {
    points.pop();
  }
}

function addContour(vertices, contour) {
  for (var _i193 = 0; _i193 < contour.length; _i193++) {
    vertices.push(contour[_i193].x);
    vertices.push(contour[_i193].y);
  }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */


var ExtrudeGeometry = /*#__PURE__*/function (_BufferGeometry6) {
  _inherits(ExtrudeGeometry, _BufferGeometry6);

  var _super53 = _createSuper(ExtrudeGeometry);

  function ExtrudeGeometry() {
    var _this49;

    var shapes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Shape([new Vector2(0.5, 0.5), new Vector2(-0.5, 0.5), new Vector2(-0.5, -0.5), new Vector2(0.5, -0.5)]);
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck2(this, ExtrudeGeometry);

    _this49 = _super53.call(this);
    _this49.type = 'ExtrudeGeometry';
    _this49.parameters = {
      shapes: shapes,
      options: options
    };
    shapes = Array.isArray(shapes) ? shapes : [shapes];

    var scope = _assertThisInitialized(_this49);

    var verticesArray = [];
    var uvArray = [];

    for (var _i194 = 0, l = shapes.length; _i194 < l; _i194++) {
      var shape = shapes[_i194];
      addShape(shape);
    } // build geometry


    _this49.setAttribute('position', new Float32BufferAttribute(verticesArray, 3));

    _this49.setAttribute('uv', new Float32BufferAttribute(uvArray, 2));

    _this49.computeVertexNormals(); // functions


    function addShape(shape) {
      var placeholder = []; // options

      var curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
      var steps = options.steps !== undefined ? options.steps : 1;
      var depth = options.depth !== undefined ? options.depth : 1;
      var bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
      var bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
      var bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
      var bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
      var bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
      var extrudePath = options.extrudePath;
      var uvgen = options.UVGenerator !== undefined ? options.UVGenerator : WorldUVGenerator; // deprecated options

      if (options.amount !== undefined) {
        console.warn('THREE.ExtrudeBufferGeometry: amount has been renamed to depth.');
        depth = options.amount;
      } //


      var extrudePts,
          extrudeByPath = false;
      var splineTube, binormal, normal, position2;

      if (extrudePath) {
        extrudePts = extrudePath.getSpacedPoints(steps);
        extrudeByPath = true;
        bevelEnabled = false; // bevels not supported for path extrusion
        // SETUP TNB variables
        // TODO1 - have a .isClosed in spline?

        splineTube = extrudePath.computeFrenetFrames(steps, false); // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);

        binormal = new Vector3();
        normal = new Vector3();
        position2 = new Vector3();
      } // Safeguards if bevels are not enabled


      if (!bevelEnabled) {
        bevelSegments = 0;
        bevelThickness = 0;
        bevelSize = 0;
        bevelOffset = 0;
      } // Variables initialization


      var shapePoints = shape.extractPoints(curveSegments);
      var vertices = shapePoints.shape;
      var holes = shapePoints.holes;
      var reverse = !ShapeUtils.isClockWise(vertices);

      if (reverse) {
        vertices = vertices.reverse(); // Maybe we should also check if holes are in the opposite direction, just to be safe ...

        for (var h = 0, hl = holes.length; h < hl; h++) {
          var ahole = holes[h];

          if (ShapeUtils.isClockWise(ahole)) {
            holes[h] = ahole.reverse();
          }
        }
      }

      var faces = ShapeUtils.triangulateShape(vertices, holes);
      /* Vertices */

      var contour = vertices; // vertices has all points but contour has only points of circumference

      for (var _h2 = 0, _hl = holes.length; _h2 < _hl; _h2++) {
        var _ahole = holes[_h2];
        vertices = vertices.concat(_ahole);
      }

      function scalePt2(pt, vec, size) {
        if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
        return vec.clone().multiplyScalar(size).add(pt);
      }

      var vlen = vertices.length,
          flen = faces.length; // Find directions for point movement

      function getBevelVec(inPt, inPrev, inNext) {
        // computes for inPt the corresponding point inPt' on a new contour
        //   shifted by 1 unit (length of normalized vector) to the left
        // if we walk along contour clockwise, this new contour is outside the old one
        //
        // inPt' is the intersection of the two lines parallel to the two
        //  adjacent edges of inPt at a distance of 1 unit on the left side.
        var v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
        // good reading for geometry algorithms (here: line-line intersection)
        // http://geomalgorithms.com/a05-_intersect-1.html

        var v_prev_x = inPt.x - inPrev.x,
            v_prev_y = inPt.y - inPrev.y;
        var v_next_x = inNext.x - inPt.x,
            v_next_y = inNext.y - inPt.y;
        var v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y; // check for collinear edges

        var collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;

        if (Math.abs(collinear0) > Number.EPSILON) {
          // not collinear
          // length of vectors for normalizing
          var v_prev_len = Math.sqrt(v_prev_lensq);
          var v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y); // shift adjacent points by unit vectors to the left

          var ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
          var ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
          var ptNextShift_x = inNext.x - v_next_y / v_next_len;
          var ptNextShift_y = inNext.y + v_next_x / v_next_len; // scaling factor for v_prev to intersection point

          var sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x); // vector from inPt to intersection point

          v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
          v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y; // Don't normalize!, otherwise sharp corners become ugly
          //  but prevent crazy spikes

          var v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;

          if (v_trans_lensq <= 2) {
            return new Vector2(v_trans_x, v_trans_y);
          } else {
            shrink_by = Math.sqrt(v_trans_lensq / 2);
          }
        } else {
          // handle special case of collinear edges
          var direction_eq = false; // assumes: opposite

          if (v_prev_x > Number.EPSILON) {
            if (v_next_x > Number.EPSILON) {
              direction_eq = true;
            }
          } else {
            if (v_prev_x < -Number.EPSILON) {
              if (v_next_x < -Number.EPSILON) {
                direction_eq = true;
              }
            } else {
              if (Math.sign(v_prev_y) === Math.sign(v_next_y)) {
                direction_eq = true;
              }
            }
          }

          if (direction_eq) {
            // console.log("Warning: lines are a straight sequence");
            v_trans_x = -v_prev_y;
            v_trans_y = v_prev_x;
            shrink_by = Math.sqrt(v_prev_lensq);
          } else {
            // console.log("Warning: lines are a straight spike");
            v_trans_x = v_prev_x;
            v_trans_y = v_prev_y;
            shrink_by = Math.sqrt(v_prev_lensq / 2);
          }
        }

        return new Vector2(v_trans_x / shrink_by, v_trans_y / shrink_by);
      }

      var contourMovements = [];

      for (var _i195 = 0, il = contour.length, j = il - 1, k = _i195 + 1; _i195 < il; _i195++, j++, k++) {
        if (j === il) j = 0;
        if (k === il) k = 0; //  (j)---(i)---(k)
        // console.log('i,j,k', i, j , k)

        contourMovements[_i195] = getBevelVec(contour[_i195], contour[j], contour[k]);
      }

      var holesMovements = [];
      var oneHoleMovements,
          verticesMovements = contourMovements.concat();

      for (var _h3 = 0, _hl2 = holes.length; _h3 < _hl2; _h3++) {
        var _ahole2 = holes[_h3];
        oneHoleMovements = [];

        for (var _i196 = 0, _il12 = _ahole2.length, _j7 = _il12 - 1, _k2 = _i196 + 1; _i196 < _il12; _i196++, _j7++, _k2++) {
          if (_j7 === _il12) _j7 = 0;
          if (_k2 === _il12) _k2 = 0; //  (j)---(i)---(k)

          oneHoleMovements[_i196] = getBevelVec(_ahole2[_i196], _ahole2[_j7], _ahole2[_k2]);
        }

        holesMovements.push(oneHoleMovements);
        verticesMovements = verticesMovements.concat(oneHoleMovements);
      } // Loop bevelSegments, 1 for the front, 1 for the back


      for (var b = 0; b < bevelSegments; b++) {
        //for ( b = bevelSegments; b > 0; b -- ) {
        var t = b / bevelSegments;
        var z = bevelThickness * Math.cos(t * Math.PI / 2);

        var _bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset; // contract shape


        for (var _i197 = 0, _il13 = contour.length; _i197 < _il13; _i197++) {
          var vert = scalePt2(contour[_i197], contourMovements[_i197], _bs);
          v(vert.x, vert.y, -z);
        } // expand holes


        for (var _h4 = 0, _hl3 = holes.length; _h4 < _hl3; _h4++) {
          var _ahole3 = holes[_h4];
          oneHoleMovements = holesMovements[_h4];

          for (var _i198 = 0, _il14 = _ahole3.length; _i198 < _il14; _i198++) {
            var _vert = scalePt2(_ahole3[_i198], oneHoleMovements[_i198], _bs);

            v(_vert.x, _vert.y, -z);
          }
        }
      }

      var bs = bevelSize + bevelOffset; // Back facing vertices

      for (var _i199 = 0; _i199 < vlen; _i199++) {
        var _vert2 = bevelEnabled ? scalePt2(vertices[_i199], verticesMovements[_i199], bs) : vertices[_i199];

        if (!extrudeByPath) {
          v(_vert2.x, _vert2.y, 0);
        } else {
          // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
          normal.copy(splineTube.normals[0]).multiplyScalar(_vert2.x);
          binormal.copy(splineTube.binormals[0]).multiplyScalar(_vert2.y);
          position2.copy(extrudePts[0]).add(normal).add(binormal);
          v(position2.x, position2.y, position2.z);
        }
      } // Add stepped vertices...
      // Including front facing vertices


      for (var s = 1; s <= steps; s++) {
        for (var _i200 = 0; _i200 < vlen; _i200++) {
          var _vert3 = bevelEnabled ? scalePt2(vertices[_i200], verticesMovements[_i200], bs) : vertices[_i200];

          if (!extrudeByPath) {
            v(_vert3.x, _vert3.y, depth / steps * s);
          } else {
            // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
            normal.copy(splineTube.normals[s]).multiplyScalar(_vert3.x);
            binormal.copy(splineTube.binormals[s]).multiplyScalar(_vert3.y);
            position2.copy(extrudePts[s]).add(normal).add(binormal);
            v(position2.x, position2.y, position2.z);
          }
        }
      } // Add bevel segments planes
      //for ( b = 1; b <= bevelSegments; b ++ ) {


      for (var _b6 = bevelSegments - 1; _b6 >= 0; _b6--) {
        var _t = _b6 / bevelSegments;

        var _z2 = bevelThickness * Math.cos(_t * Math.PI / 2);

        var _bs2 = bevelSize * Math.sin(_t * Math.PI / 2) + bevelOffset; // contract shape


        for (var _i201 = 0, _il15 = contour.length; _i201 < _il15; _i201++) {
          var _vert4 = scalePt2(contour[_i201], contourMovements[_i201], _bs2);

          v(_vert4.x, _vert4.y, depth + _z2);
        } // expand holes


        for (var _h5 = 0, _hl4 = holes.length; _h5 < _hl4; _h5++) {
          var _ahole4 = holes[_h5];
          oneHoleMovements = holesMovements[_h5];

          for (var _i202 = 0, _il16 = _ahole4.length; _i202 < _il16; _i202++) {
            var _vert5 = scalePt2(_ahole4[_i202], oneHoleMovements[_i202], _bs2);

            if (!extrudeByPath) {
              v(_vert5.x, _vert5.y, depth + _z2);
            } else {
              v(_vert5.x, _vert5.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + _z2);
            }
          }
        }
      }
      /* Faces */
      // Top and bottom faces


      buildLidFaces(); // Sides faces

      buildSideFaces(); /////  Internal functions

      function buildLidFaces() {
        var start = verticesArray.length / 3;

        if (bevelEnabled) {
          var layer = 0; // steps + 1

          var offset = vlen * layer; // Bottom faces

          for (var _i203 = 0; _i203 < flen; _i203++) {
            var face = faces[_i203];
            f3(face[2] + offset, face[1] + offset, face[0] + offset);
          }

          layer = steps + bevelSegments * 2;
          offset = vlen * layer; // Top faces

          for (var _i204 = 0; _i204 < flen; _i204++) {
            var _face = faces[_i204];
            f3(_face[0] + offset, _face[1] + offset, _face[2] + offset);
          }
        } else {
          // Bottom faces
          for (var _i205 = 0; _i205 < flen; _i205++) {
            var _face2 = faces[_i205];
            f3(_face2[2], _face2[1], _face2[0]);
          } // Top faces


          for (var _i206 = 0; _i206 < flen; _i206++) {
            var _face3 = faces[_i206];
            f3(_face3[0] + vlen * steps, _face3[1] + vlen * steps, _face3[2] + vlen * steps);
          }
        }

        scope.addGroup(start, verticesArray.length / 3 - start, 0);
      } // Create faces for the z-sides of the shape


      function buildSideFaces() {
        var start = verticesArray.length / 3;
        var layeroffset = 0;
        sidewalls(contour, layeroffset);
        layeroffset += contour.length;

        for (var _h6 = 0, _hl5 = holes.length; _h6 < _hl5; _h6++) {
          var _ahole5 = holes[_h6];
          sidewalls(_ahole5, layeroffset); //, true

          layeroffset += _ahole5.length;
        }

        scope.addGroup(start, verticesArray.length / 3 - start, 1);
      }

      function sidewalls(contour, layeroffset) {
        var i = contour.length;

        while (--i >= 0) {
          var _j8 = i;

          var _k3 = i - 1;

          if (_k3 < 0) _k3 = contour.length - 1; //console.log('b', i,j, i-1, k,vertices.length);

          for (var _s4 = 0, sl = steps + bevelSegments * 2; _s4 < sl; _s4++) {
            var slen1 = vlen * _s4;
            var slen2 = vlen * (_s4 + 1);

            var a = layeroffset + _j8 + slen1,
                _b7 = layeroffset + _k3 + slen1,
                c = layeroffset + _k3 + slen2,
                d = layeroffset + _j8 + slen2;

            f4(a, _b7, c, d);
          }
        }
      }

      function v(x, y, z) {
        placeholder.push(x);
        placeholder.push(y);
        placeholder.push(z);
      }

      function f3(a, b, c) {
        addVertex(a);
        addVertex(b);
        addVertex(c);
        var nextIndex = verticesArray.length / 3;
        var uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[2]);
      }

      function f4(a, b, c, d) {
        addVertex(a);
        addVertex(b);
        addVertex(d);
        addVertex(b);
        addVertex(c);
        addVertex(d);
        var nextIndex = verticesArray.length / 3;
        var uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
        addUV(uvs[0]);
        addUV(uvs[1]);
        addUV(uvs[3]);
        addUV(uvs[1]);
        addUV(uvs[2]);
        addUV(uvs[3]);
      }

      function addVertex(index) {
        verticesArray.push(placeholder[index * 3 + 0]);
        verticesArray.push(placeholder[index * 3 + 1]);
        verticesArray.push(placeholder[index * 3 + 2]);
      }

      function addUV(vector2) {
        uvArray.push(vector2.x);
        uvArray.push(vector2.y);
      }
    }

    return _this49;
  }

  _createClass2(ExtrudeGeometry, [{
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(ExtrudeGeometry.prototype), "toJSON", this).call(this);

      var shapes = this.parameters.shapes;
      var options = this.parameters.options;
      return toJSON$1(shapes, options, data);
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(data, shapes) {
      var geometryShapes = [];

      for (var j = 0, jl = data.shapes.length; j < jl; j++) {
        var shape = shapes[data.shapes[j]];
        geometryShapes.push(shape);
      }

      var extrudePath = data.options.extrudePath;

      if (extrudePath !== undefined) {
        data.options.extrudePath = new Curves[extrudePath.type]().fromJSON(extrudePath);
      }

      return new ExtrudeGeometry(geometryShapes, data.options);
    }
  }]);

  return ExtrudeGeometry;
}(BufferGeometry);

var WorldUVGenerator = {
  generateTopUV: function generateTopUV(geometry, vertices, indexA, indexB, indexC) {
    var a_x = vertices[indexA * 3];
    var a_y = vertices[indexA * 3 + 1];
    var b_x = vertices[indexB * 3];
    var b_y = vertices[indexB * 3 + 1];
    var c_x = vertices[indexC * 3];
    var c_y = vertices[indexC * 3 + 1];
    return [new Vector2(a_x, a_y), new Vector2(b_x, b_y), new Vector2(c_x, c_y)];
  },
  generateSideWallUV: function generateSideWallUV(geometry, vertices, indexA, indexB, indexC, indexD) {
    var a_x = vertices[indexA * 3];
    var a_y = vertices[indexA * 3 + 1];
    var a_z = vertices[indexA * 3 + 2];
    var b_x = vertices[indexB * 3];
    var b_y = vertices[indexB * 3 + 1];
    var b_z = vertices[indexB * 3 + 2];
    var c_x = vertices[indexC * 3];
    var c_y = vertices[indexC * 3 + 1];
    var c_z = vertices[indexC * 3 + 2];
    var d_x = vertices[indexD * 3];
    var d_y = vertices[indexD * 3 + 1];
    var d_z = vertices[indexD * 3 + 2];

    if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) {
      return [new Vector2(a_x, 1 - a_z), new Vector2(b_x, 1 - b_z), new Vector2(c_x, 1 - c_z), new Vector2(d_x, 1 - d_z)];
    } else {
      return [new Vector2(a_y, 1 - a_z), new Vector2(b_y, 1 - b_z), new Vector2(c_y, 1 - c_z), new Vector2(d_y, 1 - d_z)];
    }
  }
};

function toJSON$1(shapes, options, data) {
  data.shapes = [];

  if (Array.isArray(shapes)) {
    for (var _i207 = 0, l = shapes.length; _i207 < l; _i207++) {
      var shape = shapes[_i207];
      data.shapes.push(shape.uuid);
    }
  } else {
    data.shapes.push(shapes.uuid);
  }

  if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
  return data;
}

var OctahedronGeometry = /*#__PURE__*/function (_PolyhedronGeometry) {
  _inherits(OctahedronGeometry, _PolyhedronGeometry);

  var _super54 = _createSuper(OctahedronGeometry);

  function OctahedronGeometry() {
    var _this50;

    var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var detail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck2(this, OctahedronGeometry);

    var vertices = [1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1];
    var indices = [0, 2, 4, 0, 4, 3, 0, 3, 5, 0, 5, 2, 1, 2, 5, 1, 5, 3, 1, 3, 4, 1, 4, 2];
    _this50 = _super54.call(this, vertices, indices, radius, detail);
    _this50.type = 'OctahedronGeometry';
    _this50.parameters = {
      radius: radius,
      detail: detail
    };
    return _this50;
  }

  _createClass2(OctahedronGeometry, null, [{
    key: "fromJSON",
    value: function fromJSON(data) {
      return new OctahedronGeometry(data.radius, data.detail);
    }
  }]);

  return OctahedronGeometry;
}(PolyhedronGeometry);

var ShapeGeometry = /*#__PURE__*/function (_BufferGeometry7) {
  _inherits(ShapeGeometry, _BufferGeometry7);

  var _super55 = _createSuper(ShapeGeometry);

  function ShapeGeometry() {
    var _this51;

    var shapes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Shape([new Vector2(0, 0.5), new Vector2(-0.5, -0.5), new Vector2(0.5, -0.5)]);
    var curveSegments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

    _classCallCheck2(this, ShapeGeometry);

    _this51 = _super55.call(this);
    _this51.type = 'ShapeGeometry';
    _this51.parameters = {
      shapes: shapes,
      curveSegments: curveSegments
    }; // buffers

    var indices = [];
    var vertices = [];
    var normals = [];
    var uvs = []; // helper variables

    var groupStart = 0;
    var groupCount = 0; // allow single and array values for "shapes" parameter

    if (Array.isArray(shapes) === false) {
      addShape(shapes);
    } else {
      for (var _i208 = 0; _i208 < shapes.length; _i208++) {
        addShape(shapes[_i208]);

        _this51.addGroup(groupStart, groupCount, _i208); // enables MultiMaterial support


        groupStart += groupCount;
        groupCount = 0;
      }
    } // build geometry


    _this51.setIndex(indices);

    _this51.setAttribute('position', new Float32BufferAttribute(vertices, 3));

    _this51.setAttribute('normal', new Float32BufferAttribute(normals, 3));

    _this51.setAttribute('uv', new Float32BufferAttribute(uvs, 2)); // helper functions


    function addShape(shape) {
      var indexOffset = vertices.length / 3;
      var points = shape.extractPoints(curveSegments);
      var shapeVertices = points.shape;
      var shapeHoles = points.holes; // check direction of vertices

      if (ShapeUtils.isClockWise(shapeVertices) === false) {
        shapeVertices = shapeVertices.reverse();
      }

      for (var _i209 = 0, l = shapeHoles.length; _i209 < l; _i209++) {
        var shapeHole = shapeHoles[_i209];

        if (ShapeUtils.isClockWise(shapeHole) === true) {
          shapeHoles[_i209] = shapeHole.reverse();
        }
      }

      var faces = ShapeUtils.triangulateShape(shapeVertices, shapeHoles); // join vertices of inner and outer paths to a single array

      for (var _i210 = 0, _l8 = shapeHoles.length; _i210 < _l8; _i210++) {
        var _shapeHole = shapeHoles[_i210];
        shapeVertices = shapeVertices.concat(_shapeHole);
      } // vertices, normals, uvs


      for (var _i211 = 0, _l9 = shapeVertices.length; _i211 < _l9; _i211++) {
        var _vertex = shapeVertices[_i211];
        vertices.push(_vertex.x, _vertex.y, 0);
        normals.push(0, 0, 1);
        uvs.push(_vertex.x, _vertex.y); // world uvs
      } // incides


      for (var _i212 = 0, _l10 = faces.length; _i212 < _l10; _i212++) {
        var face = faces[_i212];
        var a = face[0] + indexOffset;
        var b = face[1] + indexOffset;
        var c = face[2] + indexOffset;
        indices.push(a, b, c);
        groupCount += 3;
      }
    }

    return _this51;
  }

  _createClass2(ShapeGeometry, [{
    key: "toJSON",
    value: function toJSON() {
      var data = _get(_getPrototypeOf(ShapeGeometry.prototype), "toJSON", this).call(this);

      var shapes = this.parameters.shapes;
      return _toJSON(shapes, data);
    }
  }], [{
    key: "fromJSON",
    value: function fromJSON(data, shapes) {
      var geometryShapes = [];

      for (var j = 0, jl = data.shapes.length; j < jl; j++) {
        var shape = shapes[data.shapes[j]];
        geometryShapes.push(shape);
      }

      return new ShapeGeometry(geometryShapes, data.curveSegments);
    }
  }]);

  return ShapeGeometry;
}(BufferGeometry);

function _toJSON(shapes, data) {
  data.shapes = [];

  if (Array.isArray(shapes)) {
    for (var _i213 = 0, l = shapes.length; _i213 < l; _i213++) {
      var shape = shapes[_i213];
      data.shapes.push(shape.uuid);
    }
  } else {
    data.shapes.push(shapes.uuid);
  }

  return data;
}

var SphereGeometry = /*#__PURE__*/function (_BufferGeometry8) {
  _inherits(SphereGeometry, _BufferGeometry8);

  var _super56 = _createSuper(SphereGeometry);

  function SphereGeometry() {
    var _this52;

    var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var widthSegments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
    var heightSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16;
    var phiStart = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var phiLength = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Math.PI * 2;
    var thetaStart = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var thetaLength = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : Math.PI;

    _classCallCheck2(this, SphereGeometry);

    _this52 = _super56.call(this);
    _this52.type = 'SphereGeometry';
    _this52.parameters = {
      radius: radius,
      widthSegments: widthSegments,
      heightSegments: heightSegments,
      phiStart: phiStart,
      phiLength: phiLength,
      thetaStart: thetaStart,
      thetaLength: thetaLength
    };
    widthSegments = Math.max(3, Math.floor(widthSegments));
    heightSegments = Math.max(2, Math.floor(heightSegments));
    var thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
    var index = 0;
    var grid = [];
    var vertex = new Vector3();
    var normal = new Vector3(); // buffers

    var indices = [];
    var vertices = [];
    var normals = [];
    var uvs = []; // generate vertices, normals and uvs

    for (var iy = 0; iy <= heightSegments; iy++) {
      var verticesRow = [];
      var v = iy / heightSegments; // special case for the poles

      var uOffset = 0;

      if (iy == 0 && thetaStart == 0) {
        uOffset = 0.5 / widthSegments;
      } else if (iy == heightSegments && thetaEnd == Math.PI) {
        uOffset = -0.5 / widthSegments;
      }

      for (var ix = 0; ix <= widthSegments; ix++) {
        var u = ix / widthSegments; // vertex

        vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
        vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
        vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
        vertices.push(vertex.x, vertex.y, vertex.z); // normal

        normal.copy(vertex).normalize();
        normals.push(normal.x, normal.y, normal.z); // uv

        uvs.push(u + uOffset, 1 - v);
        verticesRow.push(index++);
      }

      grid.push(verticesRow);
    } // indices


    for (var _iy3 = 0; _iy3 < heightSegments; _iy3++) {
      for (var _ix3 = 0; _ix3 < widthSegments; _ix3++) {
        var a = grid[_iy3][_ix3 + 1];
        var b = grid[_iy3][_ix3];
        var c = grid[_iy3 + 1][_ix3];
        var d = grid[_iy3 + 1][_ix3 + 1];
        if (_iy3 !== 0 || thetaStart > 0) indices.push(a, b, d);
        if (_iy3 !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
      }
    } // build geometry


    _this52.setIndex(indices);

    _this52.setAttribute('position', new Float32BufferAttribute(vertices, 3));

    _this52.setAttribute('normal', new Float32BufferAttribute(normals, 3));

    _this52.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

    return _this52;
  }

  _createClass2(SphereGeometry, null, [{
    key: "fromJSON",
    value: function fromJSON(data) {
      return new SphereGeometry(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
  }]);

  return SphereGeometry;
}(BufferGeometry);

var TorusGeometry = /*#__PURE__*/function (_BufferGeometry9) {
  _inherits(TorusGeometry, _BufferGeometry9);

  var _super57 = _createSuper(TorusGeometry);

  function TorusGeometry() {
    var _this53;

    var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var tube = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.4;
    var radialSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
    var tubularSegments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 6;
    var arc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Math.PI * 2;

    _classCallCheck2(this, TorusGeometry);

    _this53 = _super57.call(this);
    _this53.type = 'TorusGeometry';
    _this53.parameters = {
      radius: radius,
      tube: tube,
      radialSegments: radialSegments,
      tubularSegments: tubularSegments,
      arc: arc
    };
    radialSegments = Math.floor(radialSegments);
    tubularSegments = Math.floor(tubularSegments); // buffers

    var indices = [];
    var vertices = [];
    var normals = [];
    var uvs = []; // helper variables

    var center = new Vector3();
    var vertex = new Vector3();
    var normal = new Vector3(); // generate vertices, normals and uvs

    for (var j = 0; j <= radialSegments; j++) {
      for (var _i214 = 0; _i214 <= tubularSegments; _i214++) {
        var u = _i214 / tubularSegments * arc;
        var v = j / radialSegments * Math.PI * 2; // vertex

        vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
        vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
        vertex.z = tube * Math.sin(v);
        vertices.push(vertex.x, vertex.y, vertex.z); // normal

        center.x = radius * Math.cos(u);
        center.y = radius * Math.sin(u);
        normal.subVectors(vertex, center).normalize();
        normals.push(normal.x, normal.y, normal.z); // uv

        uvs.push(_i214 / tubularSegments);
        uvs.push(j / radialSegments);
      }
    } // generate indices


    for (var _j9 = 1; _j9 <= radialSegments; _j9++) {
      for (var _i215 = 1; _i215 <= tubularSegments; _i215++) {
        // indices
        var a = (tubularSegments + 1) * _j9 + _i215 - 1;
        var b = (tubularSegments + 1) * (_j9 - 1) + _i215 - 1;
        var c = (tubularSegments + 1) * (_j9 - 1) + _i215;
        var d = (tubularSegments + 1) * _j9 + _i215; // faces

        indices.push(a, b, d);
        indices.push(b, c, d);
      }
    } // build geometry


    _this53.setIndex(indices);

    _this53.setAttribute('position', new Float32BufferAttribute(vertices, 3));

    _this53.setAttribute('normal', new Float32BufferAttribute(normals, 3));

    _this53.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

    return _this53;
  }

  _createClass2(TorusGeometry, null, [{
    key: "fromJSON",
    value: function fromJSON(data) {
      return new TorusGeometry(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
  }]);

  return TorusGeometry;
}(BufferGeometry);

var WireframeGeometry = /*#__PURE__*/function (_BufferGeometry10) {
  _inherits(WireframeGeometry, _BufferGeometry10);

  var _super58 = _createSuper(WireframeGeometry);

  function WireframeGeometry() {
    var _this54;

    var geometry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    _classCallCheck2(this, WireframeGeometry);

    _this54 = _super58.call(this);
    _this54.type = 'WireframeGeometry';
    _this54.parameters = {
      geometry: geometry
    };

    if (geometry !== null) {
      // buffer
      var vertices = [];
      var edges = new Set(); // helper variables

      var start = new Vector3();
      var end = new Vector3();

      if (geometry.index !== null) {
        // indexed BufferGeometry
        var position = geometry.attributes.position;
        var indices = geometry.index;
        var groups = geometry.groups;

        if (groups.length === 0) {
          groups = [{
            start: 0,
            count: indices.count,
            materialIndex: 0
          }];
        } // create a data structure that contains all edges without duplicates


        for (var o = 0, ol = groups.length; o < ol; ++o) {
          var group = groups[o];
          var groupStart = group.start;
          var groupCount = group.count;

          for (var _i216 = groupStart, l = groupStart + groupCount; _i216 < l; _i216 += 3) {
            for (var j = 0; j < 3; j++) {
              var index1 = indices.getX(_i216 + j);
              var index2 = indices.getX(_i216 + (j + 1) % 3);
              start.fromBufferAttribute(position, index1);
              end.fromBufferAttribute(position, index2);

              if (isUniqueEdge(start, end, edges) === true) {
                vertices.push(start.x, start.y, start.z);
                vertices.push(end.x, end.y, end.z);
              }
            }
          }
        }
      } else {
        // non-indexed BufferGeometry
        var _position = geometry.attributes.position;

        for (var _i217 = 0, _l11 = _position.count / 3; _i217 < _l11; _i217++) {
          for (var _j10 = 0; _j10 < 3; _j10++) {
            // three edges per triangle, an edge is represented as (index1, index2)
            // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
            var _index8 = 3 * _i217 + _j10;

            var _index9 = 3 * _i217 + (_j10 + 1) % 3;

            start.fromBufferAttribute(_position, _index8);
            end.fromBufferAttribute(_position, _index9);

            if (isUniqueEdge(start, end, edges) === true) {
              vertices.push(start.x, start.y, start.z);
              vertices.push(end.x, end.y, end.z);
            }
          }
        }
      } // build geometry


      _this54.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    }

    return _this54;
  }

  return WireframeGeometry;
}(BufferGeometry);

function isUniqueEdge(start, end, edges) {
  var hash1 = "".concat(start.x, ",").concat(start.y, ",").concat(start.z, "-").concat(end.x, ",").concat(end.y, ",").concat(end.z);
  var hash2 = "".concat(end.x, ",").concat(end.y, ",").concat(end.z, "-").concat(start.x, ",").concat(start.y, ",").concat(start.z); // coincident edge

  if (edges.has(hash1) === true || edges.has(hash2) === true) {
    return false;
  } else {
    edges.add(hash1);
    edges.add(hash2);
    return true;
  }
}

var ShadowMaterial = /*#__PURE__*/function (_Material8) {
  _inherits(ShadowMaterial, _Material8);

  var _super59 = _createSuper(ShadowMaterial);

  function ShadowMaterial(parameters) {
    var _this55;

    _classCallCheck2(this, ShadowMaterial);

    _this55 = _super59.call(this);
    _this55.type = 'ShadowMaterial';
    _this55.color = new Color(0x000000);
    _this55.transparent = true;
    _this55.fog = true;

    _this55.setValues(parameters);

    return _this55;
  }

  _createClass2(ShadowMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(ShadowMaterial.prototype), "copy", this).call(this, source);

      this.color.copy(source.color);
      this.fog = source.fog;
      return this;
    }
  }]);

  return ShadowMaterial;
}(Material);

ShadowMaterial.prototype.isShadowMaterial = true;

var RawShaderMaterial = /*#__PURE__*/function (_ShaderMaterial) {
  _inherits(RawShaderMaterial, _ShaderMaterial);

  var _super60 = _createSuper(RawShaderMaterial);

  function RawShaderMaterial(parameters) {
    var _this56;

    _classCallCheck2(this, RawShaderMaterial);

    _this56 = _super60.call(this, parameters);
    _this56.type = 'RawShaderMaterial';
    return _this56;
  }

  return RawShaderMaterial;
}(ShaderMaterial);

RawShaderMaterial.prototype.isRawShaderMaterial = true;

var MeshStandardMaterial = /*#__PURE__*/function (_Material9) {
  _inherits(MeshStandardMaterial, _Material9);

  var _super61 = _createSuper(MeshStandardMaterial);

  function MeshStandardMaterial(parameters) {
    var _this57;

    _classCallCheck2(this, MeshStandardMaterial);

    _this57 = _super61.call(this);
    _this57.defines = {
      'STANDARD': ''
    };
    _this57.type = 'MeshStandardMaterial';
    _this57.color = new Color(0xffffff); // diffuse

    _this57.roughness = 1.0;
    _this57.metalness = 0.0;
    _this57.map = null;
    _this57.lightMap = null;
    _this57.lightMapIntensity = 1.0;
    _this57.aoMap = null;
    _this57.aoMapIntensity = 1.0;
    _this57.emissive = new Color(0x000000);
    _this57.emissiveIntensity = 1.0;
    _this57.emissiveMap = null;
    _this57.bumpMap = null;
    _this57.bumpScale = 1;
    _this57.normalMap = null;
    _this57.normalMapType = TangentSpaceNormalMap;
    _this57.normalScale = new Vector2(1, 1);
    _this57.displacementMap = null;
    _this57.displacementScale = 1;
    _this57.displacementBias = 0;
    _this57.roughnessMap = null;
    _this57.metalnessMap = null;
    _this57.alphaMap = null;
    _this57.envMap = null;
    _this57.envMapIntensity = 1.0;
    _this57.wireframe = false;
    _this57.wireframeLinewidth = 1;
    _this57.wireframeLinecap = 'round';
    _this57.wireframeLinejoin = 'round';
    _this57.flatShading = false;
    _this57.fog = true;

    _this57.setValues(parameters);

    return _this57;
  }

  _createClass2(MeshStandardMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(MeshStandardMaterial.prototype), "copy", this).call(this, source);

      this.defines = {
        'STANDARD': ''
      };
      this.color.copy(source.color);
      this.roughness = source.roughness;
      this.metalness = source.metalness;
      this.map = source.map;
      this.lightMap = source.lightMap;
      this.lightMapIntensity = source.lightMapIntensity;
      this.aoMap = source.aoMap;
      this.aoMapIntensity = source.aoMapIntensity;
      this.emissive.copy(source.emissive);
      this.emissiveMap = source.emissiveMap;
      this.emissiveIntensity = source.emissiveIntensity;
      this.bumpMap = source.bumpMap;
      this.bumpScale = source.bumpScale;
      this.normalMap = source.normalMap;
      this.normalMapType = source.normalMapType;
      this.normalScale.copy(source.normalScale);
      this.displacementMap = source.displacementMap;
      this.displacementScale = source.displacementScale;
      this.displacementBias = source.displacementBias;
      this.roughnessMap = source.roughnessMap;
      this.metalnessMap = source.metalnessMap;
      this.alphaMap = source.alphaMap;
      this.envMap = source.envMap;
      this.envMapIntensity = source.envMapIntensity;
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      this.wireframeLinecap = source.wireframeLinecap;
      this.wireframeLinejoin = source.wireframeLinejoin;
      this.flatShading = source.flatShading;
      this.fog = source.fog;
      return this;
    }
  }]);

  return MeshStandardMaterial;
}(Material);

MeshStandardMaterial.prototype.isMeshStandardMaterial = true;

var MeshPhysicalMaterial = /*#__PURE__*/function (_MeshStandardMaterial) {
  _inherits(MeshPhysicalMaterial, _MeshStandardMaterial);

  var _super62 = _createSuper(MeshPhysicalMaterial);

  function MeshPhysicalMaterial(parameters) {
    var _this58;

    _classCallCheck2(this, MeshPhysicalMaterial);

    _this58 = _super62.call(this);
    _this58.defines = {
      'STANDARD': '',
      'PHYSICAL': ''
    };
    _this58.type = 'MeshPhysicalMaterial';
    _this58.clearcoatMap = null;
    _this58.clearcoatRoughness = 0.0;
    _this58.clearcoatRoughnessMap = null;
    _this58.clearcoatNormalScale = new Vector2(1, 1);
    _this58.clearcoatNormalMap = null;
    _this58.ior = 1.5;
    Object.defineProperty(_assertThisInitialized(_this58), 'reflectivity', {
      get: function get() {
        return clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function set(reflectivity) {
        this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
      }
    });
    _this58.sheenColor = new Color(0x000000);
    _this58.sheenColorMap = null;
    _this58.sheenRoughness = 1.0;
    _this58.sheenRoughnessMap = null;
    _this58.transmissionMap = null;
    _this58.thickness = 0;
    _this58.thicknessMap = null;
    _this58.attenuationDistance = 0.0;
    _this58.attenuationColor = new Color(1, 1, 1);
    _this58.specularIntensity = 1.0;
    _this58.specularIntensityMap = null;
    _this58.specularColor = new Color(1, 1, 1);
    _this58.specularColorMap = null;
    _this58._sheen = 0.0;
    _this58._clearcoat = 0;
    _this58._transmission = 0;

    _this58.setValues(parameters);

    return _this58;
  }

  _createClass2(MeshPhysicalMaterial, [{
    key: "sheen",
    get: function get() {
      return this._sheen;
    },
    set: function set(value) {
      if (this._sheen > 0 !== value > 0) {
        this.version++;
      }

      this._sheen = value;
    }
  }, {
    key: "clearcoat",
    get: function get() {
      return this._clearcoat;
    },
    set: function set(value) {
      if (this._clearcoat > 0 !== value > 0) {
        this.version++;
      }

      this._clearcoat = value;
    }
  }, {
    key: "transmission",
    get: function get() {
      return this._transmission;
    },
    set: function set(value) {
      if (this._transmission > 0 !== value > 0) {
        this.version++;
      }

      this._transmission = value;
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(MeshPhysicalMaterial.prototype), "copy", this).call(this, source);

      this.defines = {
        'STANDARD': '',
        'PHYSICAL': ''
      };
      this.clearcoat = source.clearcoat;
      this.clearcoatMap = source.clearcoatMap;
      this.clearcoatRoughness = source.clearcoatRoughness;
      this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
      this.clearcoatNormalMap = source.clearcoatNormalMap;
      this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
      this.ior = source.ior;
      this.sheen = source.sheen;
      this.sheenColor.copy(source.sheenColor);
      this.sheenColorMap = source.sheenColorMap;
      this.sheenRoughness = source.sheenRoughness;
      this.sheenRoughnessMap = source.sheenRoughnessMap;
      this.transmission = source.transmission;
      this.transmissionMap = source.transmissionMap;
      this.thickness = source.thickness;
      this.thicknessMap = source.thicknessMap;
      this.attenuationDistance = source.attenuationDistance;
      this.attenuationColor.copy(source.attenuationColor);
      this.specularIntensity = source.specularIntensity;
      this.specularIntensityMap = source.specularIntensityMap;
      this.specularColor.copy(source.specularColor);
      this.specularColorMap = source.specularColorMap;
      return this;
    }
  }]);

  return MeshPhysicalMaterial;
}(MeshStandardMaterial);

MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;

var MeshPhongMaterial = /*#__PURE__*/function (_Material10) {
  _inherits(MeshPhongMaterial, _Material10);

  var _super63 = _createSuper(MeshPhongMaterial);

  function MeshPhongMaterial(parameters) {
    var _this59;

    _classCallCheck2(this, MeshPhongMaterial);

    _this59 = _super63.call(this);
    _this59.type = 'MeshPhongMaterial';
    _this59.color = new Color(0xffffff); // diffuse

    _this59.specular = new Color(0x111111);
    _this59.shininess = 30;
    _this59.map = null;
    _this59.lightMap = null;
    _this59.lightMapIntensity = 1.0;
    _this59.aoMap = null;
    _this59.aoMapIntensity = 1.0;
    _this59.emissive = new Color(0x000000);
    _this59.emissiveIntensity = 1.0;
    _this59.emissiveMap = null;
    _this59.bumpMap = null;
    _this59.bumpScale = 1;
    _this59.normalMap = null;
    _this59.normalMapType = TangentSpaceNormalMap;
    _this59.normalScale = new Vector2(1, 1);
    _this59.displacementMap = null;
    _this59.displacementScale = 1;
    _this59.displacementBias = 0;
    _this59.specularMap = null;
    _this59.alphaMap = null;
    _this59.envMap = null;
    _this59.combine = MultiplyOperation;
    _this59.reflectivity = 1;
    _this59.refractionRatio = 0.98;
    _this59.wireframe = false;
    _this59.wireframeLinewidth = 1;
    _this59.wireframeLinecap = 'round';
    _this59.wireframeLinejoin = 'round';
    _this59.flatShading = false;
    _this59.fog = true;

    _this59.setValues(parameters);

    return _this59;
  }

  _createClass2(MeshPhongMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(MeshPhongMaterial.prototype), "copy", this).call(this, source);

      this.color.copy(source.color);
      this.specular.copy(source.specular);
      this.shininess = source.shininess;
      this.map = source.map;
      this.lightMap = source.lightMap;
      this.lightMapIntensity = source.lightMapIntensity;
      this.aoMap = source.aoMap;
      this.aoMapIntensity = source.aoMapIntensity;
      this.emissive.copy(source.emissive);
      this.emissiveMap = source.emissiveMap;
      this.emissiveIntensity = source.emissiveIntensity;
      this.bumpMap = source.bumpMap;
      this.bumpScale = source.bumpScale;
      this.normalMap = source.normalMap;
      this.normalMapType = source.normalMapType;
      this.normalScale.copy(source.normalScale);
      this.displacementMap = source.displacementMap;
      this.displacementScale = source.displacementScale;
      this.displacementBias = source.displacementBias;
      this.specularMap = source.specularMap;
      this.alphaMap = source.alphaMap;
      this.envMap = source.envMap;
      this.combine = source.combine;
      this.reflectivity = source.reflectivity;
      this.refractionRatio = source.refractionRatio;
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      this.wireframeLinecap = source.wireframeLinecap;
      this.wireframeLinejoin = source.wireframeLinejoin;
      this.flatShading = source.flatShading;
      this.fog = source.fog;
      return this;
    }
  }]);

  return MeshPhongMaterial;
}(Material);

MeshPhongMaterial.prototype.isMeshPhongMaterial = true;

var MeshToonMaterial = /*#__PURE__*/function (_Material11) {
  _inherits(MeshToonMaterial, _Material11);

  var _super64 = _createSuper(MeshToonMaterial);

  function MeshToonMaterial(parameters) {
    var _this60;

    _classCallCheck2(this, MeshToonMaterial);

    _this60 = _super64.call(this);
    _this60.defines = {
      'TOON': ''
    };
    _this60.type = 'MeshToonMaterial';
    _this60.color = new Color(0xffffff);
    _this60.map = null;
    _this60.gradientMap = null;
    _this60.lightMap = null;
    _this60.lightMapIntensity = 1.0;
    _this60.aoMap = null;
    _this60.aoMapIntensity = 1.0;
    _this60.emissive = new Color(0x000000);
    _this60.emissiveIntensity = 1.0;
    _this60.emissiveMap = null;
    _this60.bumpMap = null;
    _this60.bumpScale = 1;
    _this60.normalMap = null;
    _this60.normalMapType = TangentSpaceNormalMap;
    _this60.normalScale = new Vector2(1, 1);
    _this60.displacementMap = null;
    _this60.displacementScale = 1;
    _this60.displacementBias = 0;
    _this60.alphaMap = null;
    _this60.wireframe = false;
    _this60.wireframeLinewidth = 1;
    _this60.wireframeLinecap = 'round';
    _this60.wireframeLinejoin = 'round';
    _this60.fog = true;

    _this60.setValues(parameters);

    return _this60;
  }

  _createClass2(MeshToonMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(MeshToonMaterial.prototype), "copy", this).call(this, source);

      this.color.copy(source.color);
      this.map = source.map;
      this.gradientMap = source.gradientMap;
      this.lightMap = source.lightMap;
      this.lightMapIntensity = source.lightMapIntensity;
      this.aoMap = source.aoMap;
      this.aoMapIntensity = source.aoMapIntensity;
      this.emissive.copy(source.emissive);
      this.emissiveMap = source.emissiveMap;
      this.emissiveIntensity = source.emissiveIntensity;
      this.bumpMap = source.bumpMap;
      this.bumpScale = source.bumpScale;
      this.normalMap = source.normalMap;
      this.normalMapType = source.normalMapType;
      this.normalScale.copy(source.normalScale);
      this.displacementMap = source.displacementMap;
      this.displacementScale = source.displacementScale;
      this.displacementBias = source.displacementBias;
      this.alphaMap = source.alphaMap;
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      this.wireframeLinecap = source.wireframeLinecap;
      this.wireframeLinejoin = source.wireframeLinejoin;
      this.fog = source.fog;
      return this;
    }
  }]);

  return MeshToonMaterial;
}(Material);

MeshToonMaterial.prototype.isMeshToonMaterial = true;

var MeshNormalMaterial = /*#__PURE__*/function (_Material12) {
  _inherits(MeshNormalMaterial, _Material12);

  var _super65 = _createSuper(MeshNormalMaterial);

  function MeshNormalMaterial(parameters) {
    var _this61;

    _classCallCheck2(this, MeshNormalMaterial);

    _this61 = _super65.call(this);
    _this61.type = 'MeshNormalMaterial';
    _this61.bumpMap = null;
    _this61.bumpScale = 1;
    _this61.normalMap = null;
    _this61.normalMapType = TangentSpaceNormalMap;
    _this61.normalScale = new Vector2(1, 1);
    _this61.displacementMap = null;
    _this61.displacementScale = 1;
    _this61.displacementBias = 0;
    _this61.wireframe = false;
    _this61.wireframeLinewidth = 1;
    _this61.flatShading = false;

    _this61.setValues(parameters);

    return _this61;
  }

  _createClass2(MeshNormalMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(MeshNormalMaterial.prototype), "copy", this).call(this, source);

      this.bumpMap = source.bumpMap;
      this.bumpScale = source.bumpScale;
      this.normalMap = source.normalMap;
      this.normalMapType = source.normalMapType;
      this.normalScale.copy(source.normalScale);
      this.displacementMap = source.displacementMap;
      this.displacementScale = source.displacementScale;
      this.displacementBias = source.displacementBias;
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      this.flatShading = source.flatShading;
      return this;
    }
  }]);

  return MeshNormalMaterial;
}(Material);

MeshNormalMaterial.prototype.isMeshNormalMaterial = true;

var MeshLambertMaterial = /*#__PURE__*/function (_Material13) {
  _inherits(MeshLambertMaterial, _Material13);

  var _super66 = _createSuper(MeshLambertMaterial);

  function MeshLambertMaterial(parameters) {
    var _this62;

    _classCallCheck2(this, MeshLambertMaterial);

    _this62 = _super66.call(this);
    _this62.type = 'MeshLambertMaterial';
    _this62.color = new Color(0xffffff); // diffuse

    _this62.map = null;
    _this62.lightMap = null;
    _this62.lightMapIntensity = 1.0;
    _this62.aoMap = null;
    _this62.aoMapIntensity = 1.0;
    _this62.emissive = new Color(0x000000);
    _this62.emissiveIntensity = 1.0;
    _this62.emissiveMap = null;
    _this62.specularMap = null;
    _this62.alphaMap = null;
    _this62.envMap = null;
    _this62.combine = MultiplyOperation;
    _this62.reflectivity = 1;
    _this62.refractionRatio = 0.98;
    _this62.wireframe = false;
    _this62.wireframeLinewidth = 1;
    _this62.wireframeLinecap = 'round';
    _this62.wireframeLinejoin = 'round';
    _this62.fog = true;

    _this62.setValues(parameters);

    return _this62;
  }

  _createClass2(MeshLambertMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(MeshLambertMaterial.prototype), "copy", this).call(this, source);

      this.color.copy(source.color);
      this.map = source.map;
      this.lightMap = source.lightMap;
      this.lightMapIntensity = source.lightMapIntensity;
      this.aoMap = source.aoMap;
      this.aoMapIntensity = source.aoMapIntensity;
      this.emissive.copy(source.emissive);
      this.emissiveMap = source.emissiveMap;
      this.emissiveIntensity = source.emissiveIntensity;
      this.specularMap = source.specularMap;
      this.alphaMap = source.alphaMap;
      this.envMap = source.envMap;
      this.combine = source.combine;
      this.reflectivity = source.reflectivity;
      this.refractionRatio = source.refractionRatio;
      this.wireframe = source.wireframe;
      this.wireframeLinewidth = source.wireframeLinewidth;
      this.wireframeLinecap = source.wireframeLinecap;
      this.wireframeLinejoin = source.wireframeLinejoin;
      this.fog = source.fog;
      return this;
    }
  }]);

  return MeshLambertMaterial;
}(Material);

MeshLambertMaterial.prototype.isMeshLambertMaterial = true;

var MeshMatcapMaterial = /*#__PURE__*/function (_Material14) {
  _inherits(MeshMatcapMaterial, _Material14);

  var _super67 = _createSuper(MeshMatcapMaterial);

  function MeshMatcapMaterial(parameters) {
    var _this63;

    _classCallCheck2(this, MeshMatcapMaterial);

    _this63 = _super67.call(this);
    _this63.defines = {
      'MATCAP': ''
    };
    _this63.type = 'MeshMatcapMaterial';
    _this63.color = new Color(0xffffff); // diffuse

    _this63.matcap = null;
    _this63.map = null;
    _this63.bumpMap = null;
    _this63.bumpScale = 1;
    _this63.normalMap = null;
    _this63.normalMapType = TangentSpaceNormalMap;
    _this63.normalScale = new Vector2(1, 1);
    _this63.displacementMap = null;
    _this63.displacementScale = 1;
    _this63.displacementBias = 0;
    _this63.alphaMap = null;
    _this63.flatShading = false;
    _this63.fog = true;

    _this63.setValues(parameters);

    return _this63;
  }

  _createClass2(MeshMatcapMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(MeshMatcapMaterial.prototype), "copy", this).call(this, source);

      this.defines = {
        'MATCAP': ''
      };
      this.color.copy(source.color);
      this.matcap = source.matcap;
      this.map = source.map;
      this.bumpMap = source.bumpMap;
      this.bumpScale = source.bumpScale;
      this.normalMap = source.normalMap;
      this.normalMapType = source.normalMapType;
      this.normalScale.copy(source.normalScale);
      this.displacementMap = source.displacementMap;
      this.displacementScale = source.displacementScale;
      this.displacementBias = source.displacementBias;
      this.alphaMap = source.alphaMap;
      this.flatShading = source.flatShading;
      this.fog = source.fog;
      return this;
    }
  }]);

  return MeshMatcapMaterial;
}(Material);

MeshMatcapMaterial.prototype.isMeshMatcapMaterial = true;

var LineDashedMaterial = /*#__PURE__*/function (_LineBasicMaterial) {
  _inherits(LineDashedMaterial, _LineBasicMaterial);

  var _super68 = _createSuper(LineDashedMaterial);

  function LineDashedMaterial(parameters) {
    var _this64;

    _classCallCheck2(this, LineDashedMaterial);

    _this64 = _super68.call(this);
    _this64.type = 'LineDashedMaterial';
    _this64.scale = 1;
    _this64.dashSize = 3;
    _this64.gapSize = 1;

    _this64.setValues(parameters);

    return _this64;
  }

  _createClass2(LineDashedMaterial, [{
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(LineDashedMaterial.prototype), "copy", this).call(this, source);

      this.scale = source.scale;
      this.dashSize = source.dashSize;
      this.gapSize = source.gapSize;
      return this;
    }
  }]);

  return LineDashedMaterial;
}(LineBasicMaterial);

LineDashedMaterial.prototype.isLineDashedMaterial = true;
var materialLib = {
  ShadowMaterial: ShadowMaterial,
  SpriteMaterial: SpriteMaterial,
  RawShaderMaterial: RawShaderMaterial,
  ShaderMaterial: ShaderMaterial,
  PointsMaterial: PointsMaterial,
  MeshPhysicalMaterial: MeshPhysicalMaterial,
  MeshStandardMaterial: MeshStandardMaterial,
  MeshPhongMaterial: MeshPhongMaterial,
  MeshToonMaterial: MeshToonMaterial,
  MeshNormalMaterial: MeshNormalMaterial,
  MeshLambertMaterial: MeshLambertMaterial,
  MeshDepthMaterial: MeshDepthMaterial,
  MeshDistanceMaterial: MeshDistanceMaterial,
  MeshBasicMaterial: MeshBasicMaterial,
  MeshMatcapMaterial: MeshMatcapMaterial,
  LineDashedMaterial: LineDashedMaterial,
  LineBasicMaterial: LineBasicMaterial,
  Material: Material
};

Material.fromType = function (type) {
  return new materialLib[type]();
};

var Cache = {
  enabled: false,
  files: {},
  add: function add(key, file) {
    if (this.enabled === false) return; // console.log( 'THREE.Cache', 'Adding key:', key );

    this.files[key] = file;
  },
  get: function get(key) {
    if (this.enabled === false) return; // console.log( 'THREE.Cache', 'Checking key:', key );

    return this.files[key];
  },
  remove: function remove(key) {
    delete this.files[key];
  },
  clear: function clear() {
    this.files = {};
  }
};

var LoadingManager = function LoadingManager(onLoad, onProgress, onError) {
  _classCallCheck2(this, LoadingManager);

  var scope = this;
  var isLoading = false;
  var itemsLoaded = 0;
  var itemsTotal = 0;
  var urlModifier = undefined;
  var handlers = []; // Refer to #5689 for the reason why we don't set .onStart
  // in the constructor

  this.onStart = undefined;
  this.onLoad = onLoad;
  this.onProgress = onProgress;
  this.onError = onError;

  this.itemStart = function (url) {
    itemsTotal++;

    if (isLoading === false) {
      if (scope.onStart !== undefined) {
        scope.onStart(url, itemsLoaded, itemsTotal);
      }
    }

    isLoading = true;
  };

  this.itemEnd = function (url) {
    itemsLoaded++;

    if (scope.onProgress !== undefined) {
      scope.onProgress(url, itemsLoaded, itemsTotal);
    }

    if (itemsLoaded === itemsTotal) {
      isLoading = false;

      if (scope.onLoad !== undefined) {
        scope.onLoad();
      }
    }
  };

  this.itemError = function (url) {
    if (scope.onError !== undefined) {
      scope.onError(url);
    }
  };

  this.resolveURL = function (url) {
    if (urlModifier) {
      return urlModifier(url);
    }

    return url;
  };

  this.setURLModifier = function (transform) {
    urlModifier = transform;
    return this;
  };

  this.addHandler = function (regex, loader) {
    handlers.push(regex, loader);
    return this;
  };

  this.removeHandler = function (regex) {
    var index = handlers.indexOf(regex);

    if (index !== -1) {
      handlers.splice(index, 2);
    }

    return this;
  };

  this.getHandler = function (file) {
    for (var _i218 = 0, l = handlers.length; _i218 < l; _i218 += 2) {
      var regex = handlers[_i218];
      var loader = handlers[_i218 + 1];
      if (regex.global) regex.lastIndex = 0; // see #17920

      if (regex.test(file)) {
        return loader;
      }
    }

    return null;
  };
};

var DefaultLoadingManager = new LoadingManager();

var Loader = /*#__PURE__*/function () {
  function Loader(manager) {
    _classCallCheck2(this, Loader);

    this.manager = manager !== undefined ? manager : DefaultLoadingManager;
    this.crossOrigin = 'anonymous';
    this.withCredentials = false;
    this.path = '';
    this.resourcePath = '';
    this.requestHeader = {};
  }

  _createClass2(Loader, [{
    key: "load",
    value: function
      /* url, onLoad, onProgress, onError */
    load() {}
  }, {
    key: "loadAsync",
    value: function loadAsync(url, onProgress) {
      var scope = this;
      return new Promise(function (resolve, reject) {
        scope.load(url, resolve, onProgress, reject);
      });
    }
  }, {
    key: "parse",
    value: function
      /* data */
    parse() {}
  }, {
    key: "setCrossOrigin",
    value: function setCrossOrigin(crossOrigin) {
      this.crossOrigin = crossOrigin;
      return this;
    }
  }, {
    key: "setWithCredentials",
    value: function setWithCredentials(value) {
      this.withCredentials = value;
      return this;
    }
  }, {
    key: "setPath",
    value: function setPath(path) {
      this.path = path;
      return this;
    }
  }, {
    key: "setResourcePath",
    value: function setResourcePath(resourcePath) {
      this.resourcePath = resourcePath;
      return this;
    }
  }, {
    key: "setRequestHeader",
    value: function setRequestHeader(requestHeader) {
      this.requestHeader = requestHeader;
      return this;
    }
  }]);

  return Loader;
}();

var loading = {};

var FileLoader = /*#__PURE__*/function (_Loader) {
  _inherits(FileLoader, _Loader);

  var _super69 = _createSuper(FileLoader);

  function FileLoader(manager) {
    _classCallCheck2(this, FileLoader);

    return _super69.call(this, manager);
  }

  _createClass2(FileLoader, [{
    key: "load",
    value: function load(url, onLoad, onProgress, onError) {
      var _this65 = this;

      if (url === undefined) url = '';
      if (this.path !== undefined) url = this.path + url;
      url = this.manager.resolveURL(url);
      var cached = Cache.get(url);

      if (cached !== undefined) {
        this.manager.itemStart(url);
        setTimeout(function () {
          if (onLoad) onLoad(cached);

          _this65.manager.itemEnd(url);
        }, 0);
        return cached;
      } // Check if request is duplicate


      if (loading[url] !== undefined) {
        loading[url].push({
          onLoad: onLoad,
          onProgress: onProgress,
          onError: onError
        });
        return;
      } // Initialise array for duplicate requests


      loading[url] = [];
      loading[url].push({
        onLoad: onLoad,
        onProgress: onProgress,
        onError: onError
      }); // create request

      var req = new Request(url, {
        headers: new Headers(this.requestHeader),
        credentials: this.withCredentials ? 'include' : 'same-origin' // An abort controller could be added within a future PR

      }); // record states ( avoid data race )

      var mimeType = this.mimeType;
      var responseType = this.responseType; // start the fetch

      fetch(req).then(function (response) {
        if (response.status === 200 || response.status === 0) {
          // Some browsers return HTTP Status 0 when using non-http protocol
          // e.g. 'file://' or 'data://'. Handle as success.
          if (response.status === 0) {
            console.warn('THREE.FileLoader: HTTP Status 0 received.');
          } // Workaround: Checking if response.body === undefined for Alipay browser #23548


          if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) {
            return response;
          }

          var callbacks = loading[url];
          var reader = response.body.getReader();
          var contentLength = response.headers.get('Content-Length');
          var total = contentLength ? parseInt(contentLength) : 0;
          var lengthComputable = total !== 0;
          var loaded = 0; // periodically read data into the new stream tracking while download progress

          var stream = new ReadableStream({
            start: function start(controller) {
              readData();

              function readData() {
                reader.read().then(function (_ref2) {
                  var done = _ref2.done,
                      value = _ref2.value;

                  if (done) {
                    controller.close();
                  } else {
                    loaded += value.byteLength;
                    var event = new ProgressEvent('progress', {
                      lengthComputable: lengthComputable,
                      loaded: loaded,
                      total: total
                    });

                    for (var _i219 = 0, il = callbacks.length; _i219 < il; _i219++) {
                      var callback = callbacks[_i219];
                      if (callback.onProgress) callback.onProgress(event);
                    }

                    controller.enqueue(value);
                    readData();
                  }
                });
              }
            }
          });
          return new Response(stream);
        } else {
          throw Error("fetch for \"".concat(response.url, "\" responded with ").concat(response.status, ": ").concat(response.statusText));
        }
      }).then(function (response) {
        switch (responseType) {
          case 'arraybuffer':
            return response.arrayBuffer();

          case 'blob':
            return response.blob();

          case 'document':
            return response.text().then(function (text) {
              var parser = new DOMParser();
              return parser.parseFromString(text, mimeType);
            });

          case 'json':
            return response.json();

          default:
            if (mimeType === undefined) {
              return response.text();
            } else {
              // sniff encoding
              var re = /charset="?([^;"\s]*)"?/i;
              var exec = re.exec(mimeType);
              var label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
              var decoder = new TextDecoder(label);
              return response.arrayBuffer().then(function (ab) {
                return decoder.decode(ab);
              });
            }

        }
      }).then(function (data) {
        // Add to cache only on HTTP success, so that we do not cache
        // error response bodies as proper responses to requests.
        Cache.add(url, data);
        var callbacks = loading[url];
        delete loading[url];

        for (var _i220 = 0, il = callbacks.length; _i220 < il; _i220++) {
          var callback = callbacks[_i220];
          if (callback.onLoad) callback.onLoad(data);
        }
      }).catch(function (err) {
        // Abort errors and other errors are handled the same
        var callbacks = loading[url];

        if (callbacks === undefined) {
          // When onLoad was called and url was deleted in `loading`
          _this65.manager.itemError(url);

          throw err;
        }

        delete loading[url];

        for (var _i221 = 0, il = callbacks.length; _i221 < il; _i221++) {
          var callback = callbacks[_i221];
          if (callback.onError) callback.onError(err);
        }

        _this65.manager.itemError(url);
      }).finally(function () {
        _this65.manager.itemEnd(url);
      });
      this.manager.itemStart(url);
    }
  }, {
    key: "setResponseType",
    value: function setResponseType(value) {
      this.responseType = value;
      return this;
    }
  }, {
    key: "setMimeType",
    value: function setMimeType(value) {
      this.mimeType = value;
      return this;
    }
  }]);

  return FileLoader;
}(Loader);

var ImageLoader = /*#__PURE__*/function (_Loader2) {
  _inherits(ImageLoader, _Loader2);

  var _super70 = _createSuper(ImageLoader);

  function ImageLoader(manager) {
    _classCallCheck2(this, ImageLoader);

    return _super70.call(this, manager);
  }

  _createClass2(ImageLoader, [{
    key: "load",
    value: function load(url, onLoad, onProgress, onError) {
      if (this.path !== undefined) url = this.path + url;
      url = this.manager.resolveURL(url);
      var scope = this;
      var cached = Cache.get(url);

      if (cached !== undefined) {
        scope.manager.itemStart(url);
        setTimeout(function () {
          if (onLoad) onLoad(cached);
          scope.manager.itemEnd(url);
        }, 0);
        return cached;
      }

      var image = createElementNS('img');

      function onImageLoad() {
        removeEventListeners();
        Cache.add(url, this);
        if (onLoad) onLoad(this);
        scope.manager.itemEnd(url);
      }

      function onImageError(event) {
        removeEventListeners();
        if (onError) onError(event);
        scope.manager.itemError(url);
        scope.manager.itemEnd(url);
      }

      function removeEventListeners() {
        image.removeEventListener('load', onImageLoad, false);
        image.removeEventListener('error', onImageError, false);
      }

      image.addEventListener('load', onImageLoad, false);
      image.addEventListener('error', onImageError, false);

      if (url.slice(0, 5) !== 'data:') {
        if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
      }

      scope.manager.itemStart(url);
      image.src = url;
      return image;
    }
  }]);

  return ImageLoader;
}(Loader);

var CubeTextureLoader = /*#__PURE__*/function (_Loader3) {
  _inherits(CubeTextureLoader, _Loader3);

  var _super71 = _createSuper(CubeTextureLoader);

  function CubeTextureLoader(manager) {
    _classCallCheck2(this, CubeTextureLoader);

    return _super71.call(this, manager);
  }

  _createClass2(CubeTextureLoader, [{
    key: "load",
    value: function load(urls, onLoad, onProgress, onError) {
      var texture = new CubeTexture();
      var loader = new ImageLoader(this.manager);
      loader.setCrossOrigin(this.crossOrigin);
      loader.setPath(this.path);
      var loaded = 0;

      function loadTexture(i) {
        loader.load(urls[i], function (image) {
          texture.images[i] = image;
          loaded++;

          if (loaded === 6) {
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
          }
        }, undefined, onError);
      }

      for (var _i222 = 0; _i222 < urls.length; ++_i222) {
        loadTexture(_i222);
      }

      return texture;
    }
  }]);

  return CubeTextureLoader;
}(Loader);

var TextureLoader = /*#__PURE__*/function (_Loader4) {
  _inherits(TextureLoader, _Loader4);

  var _super72 = _createSuper(TextureLoader);

  function TextureLoader(manager) {
    _classCallCheck2(this, TextureLoader);

    return _super72.call(this, manager);
  }

  _createClass2(TextureLoader, [{
    key: "load",
    value: function load(url, onLoad, onProgress, onError) {
      var texture = new Texture();
      var loader = new ImageLoader(this.manager);
      loader.setCrossOrigin(this.crossOrigin);
      loader.setPath(this.path);
      loader.load(url, function (image) {
        texture.image = image;
        texture.needsUpdate = true;

        if (onLoad !== undefined) {
          onLoad(texture);
        }
      }, onProgress, onError);
      return texture;
    }
  }]);

  return TextureLoader;
}(Loader);

var Light = /*#__PURE__*/function (_Object3D8) {
  _inherits(Light, _Object3D8);

  var _super73 = _createSuper(Light);

  function Light(color) {
    var _this66;

    var intensity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck2(this, Light);

    _this66 = _super73.call(this);
    _this66.type = 'Light';
    _this66.color = new Color(color);
    _this66.intensity = intensity;
    return _this66;
  }

  _createClass2(Light, [{
    key: "dispose",
    value: function dispose() {// Empty here in base class; some subclasses override.
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(Light.prototype), "copy", this).call(this, source);

      this.color.copy(source.color);
      this.intensity = source.intensity;
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON(meta) {
      var data = _get(_getPrototypeOf(Light.prototype), "toJSON", this).call(this, meta);

      data.object.color = this.color.getHex();
      data.object.intensity = this.intensity;
      if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
      if (this.distance !== undefined) data.object.distance = this.distance;
      if (this.angle !== undefined) data.object.angle = this.angle;
      if (this.decay !== undefined) data.object.decay = this.decay;
      if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
      if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
      return data;
    }
  }]);

  return Light;
}(Object3D);

Light.prototype.isLight = true;

var _projScreenMatrix$1 = /*@__PURE__*/new Matrix4();

var _lightPositionWorld$1 = /*@__PURE__*/new Vector3();

var _lookTarget$1 = /*@__PURE__*/new Vector3();

var LightShadow = /*#__PURE__*/function () {
  function LightShadow(camera) {
    _classCallCheck2(this, LightShadow);

    this.camera = camera;
    this.bias = 0;
    this.normalBias = 0;
    this.radius = 1;
    this.blurSamples = 8;
    this.mapSize = new Vector2(512, 512);
    this.map = null;
    this.mapPass = null;
    this.matrix = new Matrix4();
    this.autoUpdate = true;
    this.needsUpdate = false;
    this._frustum = new Frustum();
    this._frameExtents = new Vector2(1, 1);
    this._viewportCount = 1;
    this._viewports = [new Vector4(0, 0, 1, 1)];
  }

  _createClass2(LightShadow, [{
    key: "getViewportCount",
    value: function getViewportCount() {
      return this._viewportCount;
    }
  }, {
    key: "getFrustum",
    value: function getFrustum() {
      return this._frustum;
    }
  }, {
    key: "updateMatrices",
    value: function updateMatrices(light) {
      var shadowCamera = this.camera;
      var shadowMatrix = this.matrix;

      _lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);

      shadowCamera.position.copy(_lightPositionWorld$1);

      _lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);

      shadowCamera.lookAt(_lookTarget$1);
      shadowCamera.updateMatrixWorld();

      _projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);

      this._frustum.setFromProjectionMatrix(_projScreenMatrix$1);

      shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
      shadowMatrix.multiply(shadowCamera.projectionMatrix);
      shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
    }
  }, {
    key: "getViewport",
    value: function getViewport(viewportIndex) {
      return this._viewports[viewportIndex];
    }
  }, {
    key: "getFrameExtents",
    value: function getFrameExtents() {
      return this._frameExtents;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.map) {
        this.map.dispose();
      }

      if (this.mapPass) {
        this.mapPass.dispose();
      }
    }
  }, {
    key: "copy",
    value: function copy(source) {
      this.camera = source.camera.clone();
      this.bias = source.bias;
      this.radius = source.radius;
      this.mapSize.copy(source.mapSize);
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var object = {};
      if (this.bias !== 0) object.bias = this.bias;
      if (this.normalBias !== 0) object.normalBias = this.normalBias;
      if (this.radius !== 1) object.radius = this.radius;
      if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
      object.camera = this.camera.toJSON(false).object;
      delete object.camera.matrix;
      return object;
    }
  }]);

  return LightShadow;
}();

var DirectionalLightShadow = /*#__PURE__*/function (_LightShadow) {
  _inherits(DirectionalLightShadow, _LightShadow);

  var _super74 = _createSuper(DirectionalLightShadow);

  function DirectionalLightShadow() {
    _classCallCheck2(this, DirectionalLightShadow);

    return _super74.call(this, new OrthographicCamera(-5, 5, 5, -5, 0.5, 500));
  }

  return DirectionalLightShadow;
}(LightShadow);

DirectionalLightShadow.prototype.isDirectionalLightShadow = true;

var DirectionalLight = /*#__PURE__*/function (_Light) {
  _inherits(DirectionalLight, _Light);

  var _super75 = _createSuper(DirectionalLight);

  function DirectionalLight(color, intensity) {
    var _this67;

    _classCallCheck2(this, DirectionalLight);

    _this67 = _super75.call(this, color, intensity);
    _this67.type = 'DirectionalLight';

    _this67.position.copy(Object3D.DefaultUp);

    _this67.updateMatrix();

    _this67.target = new Object3D();
    _this67.shadow = new DirectionalLightShadow();
    return _this67;
  }

  _createClass2(DirectionalLight, [{
    key: "dispose",
    value: function dispose() {
      this.shadow.dispose();
    }
  }, {
    key: "copy",
    value: function copy(source) {
      _get(_getPrototypeOf(DirectionalLight.prototype), "copy", this).call(this, source);

      this.target = source.target.clone();
      this.shadow = source.shadow.clone();
      return this;
    }
  }]);

  return DirectionalLight;
}(Light);

DirectionalLight.prototype.isDirectionalLight = true;

var AmbientLight = /*#__PURE__*/function (_Light2) {
  _inherits(AmbientLight, _Light2);

  var _super76 = _createSuper(AmbientLight);

  function AmbientLight(color, intensity) {
    var _this68;

    _classCallCheck2(this, AmbientLight);

    _this68 = _super76.call(this, color, intensity);
    _this68.type = 'AmbientLight';
    return _this68;
  }

  return AmbientLight;
}(Light);

AmbientLight.prototype.isAmbientLight = true;

var LoaderUtils = /*#__PURE__*/function () {
  function LoaderUtils() {
    _classCallCheck2(this, LoaderUtils);
  }

  _createClass2(LoaderUtils, null, [{
    key: "decodeText",
    value: function decodeText(array) {
      if (typeof TextDecoder !== 'undefined') {
        return new TextDecoder().decode(array);
      } // Avoid the String.fromCharCode.apply(null, array) shortcut, which
      // throws a "maximum call stack size exceeded" error for large arrays.


      var s = '';

      for (var _i223 = 0, il = array.length; _i223 < il; _i223++) {
        // Implicitly assumes little-endian.
        s += String.fromCharCode(array[_i223]);
      }

      try {
        // merges multi-byte utf-8 characters.
        return decodeURIComponent(escape(s));
      } catch (e) {
        // see #16358
        return s;
      }
    }
  }, {
    key: "extractUrlBase",
    value: function extractUrlBase(url) {
      var index = url.lastIndexOf('/');
      if (index === -1) return './';
      return url.slice(0, index + 1);
    }
  }, {
    key: "resolveURL",
    value: function resolveURL(url, path) {
      // Invalid URL
      if (typeof url !== 'string' || url === '') return ''; // Host Relative URL

      if (/^https?:\/\//i.test(path) && /^\//.test(url)) {
        path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
      } // Absolute URL http://,https://,//


      if (/^(https?:)?\/\//i.test(url)) return url; // Data URI

      if (/^data:.*,.*$/i.test(url)) return url; // Blob URL

      if (/^blob:.*$/i.test(url)) return url; // Relative URL

      return path + url;
    }
  }]);

  return LoaderUtils;
}();

var Clock = /*#__PURE__*/function () {
  function Clock() {
    var autoStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    _classCallCheck2(this, Clock);

    this.autoStart = autoStart;
    this.startTime = 0;
    this.oldTime = 0;
    this.elapsedTime = 0;
    this.running = false;
  }

  _createClass2(Clock, [{
    key: "start",
    value: function start() {
      this.startTime = now();
      this.oldTime = this.startTime;
      this.elapsedTime = 0;
      this.running = true;
    }
  }, {
    key: "stop",
    value: function stop() {
      this.getElapsedTime();
      this.running = false;
      this.autoStart = false;
    }
  }, {
    key: "getElapsedTime",
    value: function getElapsedTime() {
      this.getDelta();
      return this.elapsedTime;
    }
  }, {
    key: "getDelta",
    value: function getDelta() {
      var diff = 0;

      if (this.autoStart && !this.running) {
        this.start();
        return 0;
      }

      if (this.running) {
        var newTime = now();
        diff = (newTime - this.oldTime) / 1000;
        this.oldTime = newTime;
        this.elapsedTime += diff;
      }

      return diff;
    }
  }]);

  return Clock;
}();

function now() {
  return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
} // Characters [].:/ are reserved for track binding syntax.


var _RESERVED_CHARS_RE = '\\[\\]\\.:\\/'; // Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.

var _wordChar = '[^' + _RESERVED_CHARS_RE + ']';

var _wordCharOrDot = '[^' + _RESERVED_CHARS_RE.replace('\\.', '') + ']'; // Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.


/((?:WC+[\/:])*)/.source.replace('WC', _wordChar); // Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.

/(WCOD+)?/.source.replace('WCOD', _wordCharOrDot); // Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.

/(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', _wordChar); // Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.

/\.(WC+)(?:\[(.+)\])?/.source.replace('WC', _wordChar);

var Raycaster = /*#__PURE__*/function () {
  function Raycaster(origin, direction) {
    var near = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var far = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;

    _classCallCheck2(this, Raycaster);

    this.ray = new Ray(origin, direction); // direction is assumed to be normalized (for accurate distance calculations)

    this.near = near;
    this.far = far;
    this.camera = null;
    this.layers = new Layers();
    this.params = {
      Mesh: {},
      Line: {
        threshold: 1
      },
      LOD: {},
      Points: {
        threshold: 1
      },
      Sprite: {}
    };
  }

  _createClass2(Raycaster, [{
    key: "set",
    value: function set(origin, direction) {
      // direction is assumed to be normalized (for accurate distance calculations)
      this.ray.set(origin, direction);
    }
  }, {
    key: "setFromCamera",
    value: function setFromCamera(coords, camera) {
      if (camera.isPerspectiveCamera) {
        this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
        this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
        this.camera = camera;
      } else if (camera.isOrthographicCamera) {
        this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera

        this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
        this.camera = camera;
      } else {
        console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
      }
    }
  }, {
    key: "intersectObject",
    value: function intersectObject(object) {
      var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var intersects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      _intersectObject(object, this, intersects, recursive);

      intersects.sort(ascSort);
      return intersects;
    }
  }, {
    key: "intersectObjects",
    value: function intersectObjects(objects) {
      var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var intersects = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      for (var _i224 = 0, l = objects.length; _i224 < l; _i224++) {
        _intersectObject(objects[_i224], this, intersects, recursive);
      }

      intersects.sort(ascSort);
      return intersects;
    }
  }]);

  return Raycaster;
}();

function ascSort(a, b) {
  return a.distance - b.distance;
}

function _intersectObject(object, raycaster, intersects, recursive) {
  if (object.layers.test(raycaster.layers)) {
    object.raycast(raycaster, intersects);
  }

  if (recursive === true) {
    var children = object.children;

    for (var _i225 = 0, l = children.length; _i225 < l; _i225++) {
      _intersectObject(children[_i225], raycaster, intersects, true);
    }
  }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */


var Spherical = /*#__PURE__*/function () {
  function Spherical() {
    var radius = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var phi = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var theta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck2(this, Spherical);

    this.radius = radius;
    this.phi = phi; // polar angle

    this.theta = theta; // azimuthal angle

    return this;
  }

  _createClass2(Spherical, [{
    key: "set",
    value: function set(radius, phi, theta) {
      this.radius = radius;
      this.phi = phi;
      this.theta = theta;
      return this;
    }
  }, {
    key: "copy",
    value: function copy(other) {
      this.radius = other.radius;
      this.phi = other.phi;
      this.theta = other.theta;
      return this;
    } // restrict phi to be between EPS and PI-EPS

  }, {
    key: "makeSafe",
    value: function makeSafe() {
      var EPS = 0.000001;
      this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
      return this;
    }
  }, {
    key: "setFromVector3",
    value: function setFromVector3(v) {
      return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
  }, {
    key: "setFromCartesianCoords",
    value: function setFromCartesianCoords(x, y, z) {
      this.radius = Math.sqrt(x * x + y * y + z * z);

      if (this.radius === 0) {
        this.theta = 0;
        this.phi = 0;
      } else {
        this.theta = Math.atan2(x, z);
        this.phi = Math.acos(clamp(y / this.radius, -1, 1));
      }

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Spherical;
}();

var _startP = /*@__PURE__*/new Vector3();

var _startEnd = /*@__PURE__*/new Vector3();

var Line3 = /*#__PURE__*/function () {
  function Line3() {
    var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Vector3();
    var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Vector3();

    _classCallCheck2(this, Line3);

    this.start = start;
    this.end = end;
  }

  _createClass2(Line3, [{
    key: "set",
    value: function set(start, end) {
      this.start.copy(start);
      this.end.copy(end);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(line) {
      this.start.copy(line.start);
      this.end.copy(line.end);
      return this;
    }
  }, {
    key: "getCenter",
    value: function getCenter(target) {
      return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
  }, {
    key: "delta",
    value: function delta(target) {
      return target.subVectors(this.end, this.start);
    }
  }, {
    key: "distanceSq",
    value: function distanceSq() {
      return this.start.distanceToSquared(this.end);
    }
  }, {
    key: "distance",
    value: function distance() {
      return this.start.distanceTo(this.end);
    }
  }, {
    key: "at",
    value: function at(t, target) {
      return this.delta(target).multiplyScalar(t).add(this.start);
    }
  }, {
    key: "closestPointToPointParameter",
    value: function closestPointToPointParameter(point, clampToLine) {
      _startP.subVectors(point, this.start);

      _startEnd.subVectors(this.end, this.start);

      var startEnd2 = _startEnd.dot(_startEnd);

      var startEnd_startP = _startEnd.dot(_startP);

      var t = startEnd_startP / startEnd2;

      if (clampToLine) {
        t = clamp(t, 0, 1);
      }

      return t;
    }
  }, {
    key: "closestPointToPoint",
    value: function closestPointToPoint(point, clampToLine, target) {
      var t = this.closestPointToPointParameter(point, clampToLine);
      return this.delta(target).multiplyScalar(t).add(this.start);
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(matrix) {
      this.start.applyMatrix4(matrix);
      this.end.applyMatrix4(matrix);
      return this;
    }
  }, {
    key: "equals",
    value: function equals(line) {
      return line.start.equals(this.start) && line.end.equals(this.end);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }]);

  return Line3;
}();

var GridHelper = /*#__PURE__*/function (_LineSegments) {
  _inherits(GridHelper, _LineSegments);

  var _super77 = _createSuper(GridHelper);

  function GridHelper() {
    var _this69;

    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    var divisions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
    var color1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0x444444;
    var color2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0x888888;

    _classCallCheck2(this, GridHelper);

    color1 = new Color(color1);
    color2 = new Color(color2);
    var center = divisions / 2;
    var step = size / divisions;
    var halfSize = size / 2;
    var vertices = [],
        colors = [];

    for (var _i226 = 0, j = 0, k = -halfSize; _i226 <= divisions; _i226++, k += step) {
      vertices.push(-halfSize, 0, k, halfSize, 0, k);
      vertices.push(k, 0, -halfSize, k, 0, halfSize);
      var color = _i226 === center ? color1 : color2;
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
      color.toArray(colors, j);
      j += 3;
    }

    var geometry = new BufferGeometry();
    geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
    var material = new LineBasicMaterial({
      vertexColors: true,
      toneMapped: false
    });
    _this69 = _super77.call(this, geometry, material);
    _this69.type = 'GridHelper';
    return _this69;
  }

  return GridHelper;
}(LineSegments);

var AxesHelper = /*#__PURE__*/function (_LineSegments2) {
  _inherits(AxesHelper, _LineSegments2);

  var _super78 = _createSuper(AxesHelper);

  function AxesHelper() {
    var _this70;

    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    _classCallCheck2(this, AxesHelper);

    var vertices = [0, 0, 0, size, 0, 0, 0, 0, 0, 0, size, 0, 0, 0, 0, 0, 0, size];
    var colors = [1, 0, 0, 1, 0.6, 0, 0, 1, 0, 0.6, 1, 0, 0, 0, 1, 0, 0.6, 1];
    var geometry = new BufferGeometry();
    geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
    var material = new LineBasicMaterial({
      vertexColors: true,
      toneMapped: false
    });
    _this70 = _super78.call(this, geometry, material);
    _this70.type = 'AxesHelper';
    return _this70;
  }

  _createClass2(AxesHelper, [{
    key: "setColors",
    value: function setColors(xAxisColor, yAxisColor, zAxisColor) {
      var color = new Color();
      var array = this.geometry.attributes.color.array;
      color.set(xAxisColor);
      color.toArray(array, 0);
      color.toArray(array, 3);
      color.set(yAxisColor);
      color.toArray(array, 6);
      color.toArray(array, 9);
      color.set(zAxisColor);
      color.toArray(array, 12);
      color.toArray(array, 15);
      this.geometry.attributes.color.needsUpdate = true;
      return this;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.geometry.dispose();
      this.material.dispose();
    }
  }]);

  return AxesHelper;
}(LineSegments);

var _baseTable = new Uint32Array(512);

var _shiftTable = new Uint32Array(512);

for (var _i227 = 0; _i227 < 256; ++_i227) {
  var e = _i227 - 127; // very small number (0, -0)

  if (e < -27) {
    _baseTable[_i227] = 0x0000;
    _baseTable[_i227 | 0x100] = 0x8000;
    _shiftTable[_i227] = 24;
    _shiftTable[_i227 | 0x100] = 24; // small number (denorm)
  } else if (e < -14) {
    _baseTable[_i227] = 0x0400 >> -e - 14;
    _baseTable[_i227 | 0x100] = 0x0400 >> -e - 14 | 0x8000;
    _shiftTable[_i227] = -e - 1;
    _shiftTable[_i227 | 0x100] = -e - 1; // normal number
  } else if (e <= 15) {
    _baseTable[_i227] = e + 15 << 10;
    _baseTable[_i227 | 0x100] = e + 15 << 10 | 0x8000;
    _shiftTable[_i227] = 13;
    _shiftTable[_i227 | 0x100] = 13; // large number (Infinity, -Infinity)
  } else if (e < 128) {
    _baseTable[_i227] = 0x7c00;
    _baseTable[_i227 | 0x100] = 0xfc00;
    _shiftTable[_i227] = 24;
    _shiftTable[_i227 | 0x100] = 24; // stay (NaN, Infinity, -Infinity)
  } else {
    _baseTable[_i227] = 0x7c00;
    _baseTable[_i227 | 0x100] = 0xfc00;
    _shiftTable[_i227] = 13;
    _shiftTable[_i227 | 0x100] = 13;
  }
} // float16 to float32 helpers


var _mantissaTable = new Uint32Array(2048);

var _exponentTable = new Uint32Array(64);

var _offsetTable = new Uint32Array(64);

for (var _i228 = 1; _i228 < 1024; ++_i228) {
  var m = _i228 << 13; // zero pad mantissa bits

  var _e2 = 0; // zero exponent
  // normalized

  while ((m & 0x00800000) === 0) {
    m <<= 1;
    _e2 -= 0x00800000; // decrement exponent
  }

  m &= ~0x00800000; // clear leading 1 bit

  _e2 += 0x38800000; // adjust bias

  _mantissaTable[_i228] = m | _e2;
}

for (var _i229 = 1024; _i229 < 2048; ++_i229) {
  _mantissaTable[_i229] = 0x38000000 + (_i229 - 1024 << 13);
}

for (var _i230 = 1; _i230 < 31; ++_i230) {
  _exponentTable[_i230] = _i230 << 23;
}

_exponentTable[31] = 0x47800000;
_exponentTable[32] = 0x80000000;

for (var _i231 = 33; _i231 < 63; ++_i231) {
  _exponentTable[_i231] = 0x80000000 + (_i231 - 32 << 23);
}

_exponentTable[63] = 0xc7800000;

for (var _i232 = 1; _i232 < 64; ++_i232) {
  if (_i232 !== 32) {
    _offsetTable[_i232] = 1024;
  }
}

var VertexColors = 2; //

Curve.create = function (construct, getPoint) {
  console.log('THREE.Curve.create() has been deprecated');
  construct.prototype = Object.create(Curve.prototype);
  construct.prototype.constructor = construct;
  construct.prototype.getPoint = getPoint;
  return construct;
}; //


Path.prototype.fromPoints = function (points) {
  console.warn('THREE.Path: .fromPoints() has been renamed to .setFromPoints().');
  return this.setFromPoints(points);
};

GridHelper.prototype.setColors = function () {
  console.error('THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.');
}; //


Loader.prototype.extractUrlBase = function (url) {
  console.warn('THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.');
  return LoaderUtils.extractUrlBase(url);
};

Loader.Handlers = {
  add: function
    /* regex, loader */
  add() {
    console.error('THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.');
  },
  get: function
    /* file */
  get() {
    console.error('THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.');
  }
}; //

Box3.prototype.center = function (optionalTarget) {
  console.warn('THREE.Box3: .center() has been renamed to .getCenter().');
  return this.getCenter(optionalTarget);
};

Box3.prototype.empty = function () {
  console.warn('THREE.Box3: .empty() has been renamed to .isEmpty().');
  return this.isEmpty();
};

Box3.prototype.isIntersectionBox = function (box) {
  console.warn('THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().');
  return this.intersectsBox(box);
};

Box3.prototype.isIntersectionSphere = function (sphere) {
  console.warn('THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().');
  return this.intersectsSphere(sphere);
};

Box3.prototype.size = function (optionalTarget) {
  console.warn('THREE.Box3: .size() has been renamed to .getSize().');
  return this.getSize(optionalTarget);
}; //


Euler.prototype.toVector3 = function () {
  console.error('THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead');
}; //


Sphere.prototype.empty = function () {
  console.warn('THREE.Sphere: .empty() has been renamed to .isEmpty().');
  return this.isEmpty();
}; //


Frustum.prototype.setFromMatrix = function (m) {
  console.warn('THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().');
  return this.setFromProjectionMatrix(m);
}; //


Line3.prototype.center = function (optionalTarget) {
  console.warn('THREE.Line3: .center() has been renamed to .getCenter().');
  return this.getCenter(optionalTarget);
}; //


Matrix3.prototype.flattenToArrayOffset = function (array, offset) {
  console.warn('THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.');
  return this.toArray(array, offset);
};

Matrix3.prototype.multiplyVector3 = function (vector) {
  console.warn('THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.');
  return vector.applyMatrix3(this);
};

Matrix3.prototype.multiplyVector3Array = function
  /* a */
() {
  console.error('THREE.Matrix3: .multiplyVector3Array() has been removed.');
};

Matrix3.prototype.applyToBufferAttribute = function (attribute) {
  console.warn('THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.');
  return attribute.applyMatrix3(this);
};

Matrix3.prototype.applyToVector3Array = function
  /* array, offset, length */
() {
  console.error('THREE.Matrix3: .applyToVector3Array() has been removed.');
};

Matrix3.prototype.getInverse = function (matrix) {
  console.warn('THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.');
  return this.copy(matrix).invert();
}; //


Matrix4.prototype.extractPosition = function (m) {
  console.warn('THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().');
  return this.copyPosition(m);
};

Matrix4.prototype.flattenToArrayOffset = function (array, offset) {
  console.warn('THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.');
  return this.toArray(array, offset);
};

Matrix4.prototype.getPosition = function () {
  console.warn('THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.');
  return new Vector3().setFromMatrixColumn(this, 3);
};

Matrix4.prototype.setRotationFromQuaternion = function (q) {
  console.warn('THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().');
  return this.makeRotationFromQuaternion(q);
};

Matrix4.prototype.multiplyToArray = function () {
  console.warn('THREE.Matrix4: .multiplyToArray() has been removed.');
};

Matrix4.prototype.multiplyVector3 = function (vector) {
  console.warn('THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.');
  return vector.applyMatrix4(this);
};

Matrix4.prototype.multiplyVector4 = function (vector) {
  console.warn('THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.');
  return vector.applyMatrix4(this);
};

Matrix4.prototype.multiplyVector3Array = function
  /* a */
() {
  console.error('THREE.Matrix4: .multiplyVector3Array() has been removed.');
};

Matrix4.prototype.rotateAxis = function (v) {
  console.warn('THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.');
  v.transformDirection(this);
};

Matrix4.prototype.crossVector = function (vector) {
  console.warn('THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.');
  return vector.applyMatrix4(this);
};

Matrix4.prototype.translate = function () {
  console.error('THREE.Matrix4: .translate() has been removed.');
};

Matrix4.prototype.rotateX = function () {
  console.error('THREE.Matrix4: .rotateX() has been removed.');
};

Matrix4.prototype.rotateY = function () {
  console.error('THREE.Matrix4: .rotateY() has been removed.');
};

Matrix4.prototype.rotateZ = function () {
  console.error('THREE.Matrix4: .rotateZ() has been removed.');
};

Matrix4.prototype.rotateByAxis = function () {
  console.error('THREE.Matrix4: .rotateByAxis() has been removed.');
};

Matrix4.prototype.applyToBufferAttribute = function (attribute) {
  console.warn('THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.');
  return attribute.applyMatrix4(this);
};

Matrix4.prototype.applyToVector3Array = function
  /* array, offset, length */
() {
  console.error('THREE.Matrix4: .applyToVector3Array() has been removed.');
};

Matrix4.prototype.makeFrustum = function (left, right, bottom, top, near, far) {
  console.warn('THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.');
  return this.makePerspective(left, right, top, bottom, near, far);
};

Matrix4.prototype.getInverse = function (matrix) {
  console.warn('THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.');
  return this.copy(matrix).invert();
}; //


Plane.prototype.isIntersectionLine = function (line) {
  console.warn('THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().');
  return this.intersectsLine(line);
}; //


Quaternion.prototype.multiplyVector3 = function (vector) {
  console.warn('THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.');
  return vector.applyQuaternion(this);
};

Quaternion.prototype.inverse = function () {
  console.warn('THREE.Quaternion: .inverse() has been renamed to invert().');
  return this.invert();
}; //


Ray.prototype.isIntersectionBox = function (box) {
  console.warn('THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().');
  return this.intersectsBox(box);
};

Ray.prototype.isIntersectionPlane = function (plane) {
  console.warn('THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().');
  return this.intersectsPlane(plane);
};

Ray.prototype.isIntersectionSphere = function (sphere) {
  console.warn('THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().');
  return this.intersectsSphere(sphere);
}; //


Triangle.prototype.area = function () {
  console.warn('THREE.Triangle: .area() has been renamed to .getArea().');
  return this.getArea();
};

Triangle.prototype.barycoordFromPoint = function (point, target) {
  console.warn('THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().');
  return this.getBarycoord(point, target);
};

Triangle.prototype.midpoint = function (target) {
  console.warn('THREE.Triangle: .midpoint() has been renamed to .getMidpoint().');
  return this.getMidpoint(target);
};

Triangle.prototypenormal = function (target) {
  console.warn('THREE.Triangle: .normal() has been renamed to .getNormal().');
  return this.getNormal(target);
};

Triangle.prototype.plane = function (target) {
  console.warn('THREE.Triangle: .plane() has been renamed to .getPlane().');
  return this.getPlane(target);
};

Triangle.barycoordFromPoint = function (point, a, b, c, target) {
  console.warn('THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().');
  return Triangle.getBarycoord(point, a, b, c, target);
};

Triangle.normal = function (a, b, c, target) {
  console.warn('THREE.Triangle: .normal() has been renamed to .getNormal().');
  return Triangle.getNormal(a, b, c, target);
}; //


Shape.prototype.extractAllPoints = function (divisions) {
  console.warn('THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.');
  return this.extractPoints(divisions);
};

Shape.prototype.extrude = function (options) {
  console.warn('THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.');
  return new ExtrudeGeometry(this, options);
};

Shape.prototype.makeGeometry = function (options) {
  console.warn('THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.');
  return new ShapeGeometry(this, options);
}; //


Vector2.prototype.fromAttribute = function (attribute, index, offset) {
  console.warn('THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().');
  return this.fromBufferAttribute(attribute, index, offset);
};

Vector2.prototype.distanceToManhattan = function (v) {
  console.warn('THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().');
  return this.manhattanDistanceTo(v);
};

Vector2.prototype.lengthManhattan = function () {
  console.warn('THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().');
  return this.manhattanLength();
}; //


Vector3.prototype.setEulerFromRotationMatrix = function () {
  console.error('THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.');
};

Vector3.prototype.setEulerFromQuaternion = function () {
  console.error('THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.');
};

Vector3.prototype.getPositionFromMatrix = function (m) {
  console.warn('THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().');
  return this.setFromMatrixPosition(m);
};

Vector3.prototype.getScaleFromMatrix = function (m) {
  console.warn('THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().');
  return this.setFromMatrixScale(m);
};

Vector3.prototype.getColumnFromMatrix = function (index, matrix) {
  console.warn('THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().');
  return this.setFromMatrixColumn(matrix, index);
};

Vector3.prototype.applyProjection = function (m) {
  console.warn('THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.');
  return this.applyMatrix4(m);
};

Vector3.prototype.fromAttribute = function (attribute, index, offset) {
  console.warn('THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().');
  return this.fromBufferAttribute(attribute, index, offset);
};

Vector3.prototype.distanceToManhattan = function (v) {
  console.warn('THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().');
  return this.manhattanDistanceTo(v);
};

Vector3.prototype.lengthManhattan = function () {
  console.warn('THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().');
  return this.manhattanLength();
}; //


Vector4.prototype.fromAttribute = function (attribute, index, offset) {
  console.warn('THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().');
  return this.fromBufferAttribute(attribute, index, offset);
};

Vector4.prototype.lengthManhattan = function () {
  console.warn('THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().');
  return this.manhattanLength();
}; //


Object3D.prototype.getChildByName = function (name) {
  console.warn('THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().');
  return this.getObjectByName(name);
};

Object3D.prototype.renderDepth = function () {
  console.warn('THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.');
};

Object3D.prototype.translate = function (distance, axis) {
  console.warn('THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.');
  return this.translateOnAxis(axis, distance);
};

Object3D.prototype.getWorldRotation = function () {
  console.error('THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.');
};

Object3D.prototype.applyMatrix = function (matrix) {
  console.warn('THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().');
  return this.applyMatrix4(matrix);
};

Object.defineProperties(Object3D.prototype, {
  eulerOrder: {
    get: function get() {
      console.warn('THREE.Object3D: .eulerOrder is now .rotation.order.');
      return this.rotation.order;
    },
    set: function set(value) {
      console.warn('THREE.Object3D: .eulerOrder is now .rotation.order.');
      this.rotation.order = value;
    }
  },
  useQuaternion: {
    get: function get() {
      console.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');
    },
    set: function set() {
      console.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');
    }
  }
});

Mesh.prototype.setDrawMode = function () {
  console.error('THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.');
};

Object.defineProperties(Mesh.prototype, {
  drawMode: {
    get: function get() {
      console.error('THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.');
      return TrianglesDrawMode;
    },
    set: function set() {
      console.error('THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.');
    }
  }
}); //

PerspectiveCamera.prototype.setLens = function (focalLength, filmGauge) {
  console.warn('THREE.PerspectiveCamera.setLens is deprecated. ' + 'Use .setFocalLength and .filmGauge for a photographic setup.');
  if (filmGauge !== undefined) this.filmGauge = filmGauge;
  this.setFocalLength(focalLength);
}; //


Object.defineProperties(Light.prototype, {
  onlyShadow: {
    set: function set() {
      console.warn('THREE.Light: .onlyShadow has been removed.');
    }
  },
  shadowCameraFov: {
    set: function set(value) {
      console.warn('THREE.Light: .shadowCameraFov is now .shadow.camera.fov.');
      this.shadow.camera.fov = value;
    }
  },
  shadowCameraLeft: {
    set: function set(value) {
      console.warn('THREE.Light: .shadowCameraLeft is now .shadow.camera.left.');
      this.shadow.camera.left = value;
    }
  },
  shadowCameraRight: {
    set: function set(value) {
      console.warn('THREE.Light: .shadowCameraRight is now .shadow.camera.right.');
      this.shadow.camera.right = value;
    }
  },
  shadowCameraTop: {
    set: function set(value) {
      console.warn('THREE.Light: .shadowCameraTop is now .shadow.camera.top.');
      this.shadow.camera.top = value;
    }
  },
  shadowCameraBottom: {
    set: function set(value) {
      console.warn('THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.');
      this.shadow.camera.bottom = value;
    }
  },
  shadowCameraNear: {
    set: function set(value) {
      console.warn('THREE.Light: .shadowCameraNear is now .shadow.camera.near.');
      this.shadow.camera.near = value;
    }
  },
  shadowCameraFar: {
    set: function set(value) {
      console.warn('THREE.Light: .shadowCameraFar is now .shadow.camera.far.');
      this.shadow.camera.far = value;
    }
  },
  shadowCameraVisible: {
    set: function set() {
      console.warn('THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.');
    }
  },
  shadowBias: {
    set: function set(value) {
      console.warn('THREE.Light: .shadowBias is now .shadow.bias.');
      this.shadow.bias = value;
    }
  },
  shadowDarkness: {
    set: function set() {
      console.warn('THREE.Light: .shadowDarkness has been removed.');
    }
  },
  shadowMapWidth: {
    set: function set(value) {
      console.warn('THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.');
      this.shadow.mapSize.width = value;
    }
  },
  shadowMapHeight: {
    set: function set(value) {
      console.warn('THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.');
      this.shadow.mapSize.height = value;
    }
  }
}); //

Object.defineProperties(BufferAttribute.prototype, {
  length: {
    get: function get() {
      console.warn('THREE.BufferAttribute: .length has been deprecated. Use .count instead.');
      return this.array.length;
    }
  },
  dynamic: {
    get: function get() {
      console.warn('THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.');
      return this.usage === DynamicDrawUsage;
    },
    set: function
      /* value */
    set() {
      console.warn('THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.');
      this.setUsage(DynamicDrawUsage);
    }
  }
});

BufferAttribute.prototype.setDynamic = function (value) {
  console.warn('THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.');
  this.setUsage(value === true ? DynamicDrawUsage : StaticDrawUsage);
  return this;
};

BufferAttribute.prototype.copyIndicesArray = function
  /* indices */
() {
  console.error('THREE.BufferAttribute: .copyIndicesArray() has been removed.');
}, BufferAttribute.prototype.setArray = function
  /* array */
() {
  console.error('THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers');
}; //

BufferGeometry.prototype.addIndex = function (index) {
  console.warn('THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().');
  this.setIndex(index);
};

BufferGeometry.prototype.addAttribute = function (name, attribute) {
  console.warn('THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().');

  if (!(attribute && attribute.isBufferAttribute) && !(attribute && attribute.isInterleavedBufferAttribute)) {
    console.warn('THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).');
    return this.setAttribute(name, new BufferAttribute(arguments[1], arguments[2]));
  }

  if (name === 'index') {
    console.warn('THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.');
    this.setIndex(attribute);
    return this;
  }

  return this.setAttribute(name, attribute);
};

BufferGeometry.prototype.addDrawCall = function (start, count, indexOffset) {
  if (indexOffset !== undefined) {
    console.warn('THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.');
  }

  console.warn('THREE.BufferGeometry: .addDrawCall() is now .addGroup().');
  this.addGroup(start, count);
};

BufferGeometry.prototype.clearDrawCalls = function () {
  console.warn('THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().');
  this.clearGroups();
};

BufferGeometry.prototype.computeOffsets = function () {
  console.warn('THREE.BufferGeometry: .computeOffsets() has been removed.');
};

BufferGeometry.prototype.removeAttribute = function (name) {
  console.warn('THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().');
  return this.deleteAttribute(name);
};

BufferGeometry.prototype.applyMatrix = function (matrix) {
  console.warn('THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().');
  return this.applyMatrix4(matrix);
};

Object.defineProperties(BufferGeometry.prototype, {
  drawcalls: {
    get: function get() {
      console.error('THREE.BufferGeometry: .drawcalls has been renamed to .groups.');
      return this.groups;
    }
  },
  offsets: {
    get: function get() {
      console.warn('THREE.BufferGeometry: .offsets has been renamed to .groups.');
      return this.groups;
    }
  }
}); //

ExtrudeGeometry.prototype.getArrays = function () {
  console.error('THREE.ExtrudeGeometry: .getArrays() has been removed.');
};

ExtrudeGeometry.prototype.addShapeList = function () {
  console.error('THREE.ExtrudeGeometry: .addShapeList() has been removed.');
};

ExtrudeGeometry.prototype.addShape = function () {
  console.error('THREE.ExtrudeGeometry: .addShape() has been removed.');
}; //


Scene.prototype.dispose = function () {
  console.error('THREE.Scene: .dispose() has been removed.');
}; //


Object.defineProperties(Material.prototype, {
  wrapAround: {
    get: function get() {
      console.warn('THREE.Material: .wrapAround has been removed.');
    },
    set: function set() {
      console.warn('THREE.Material: .wrapAround has been removed.');
    }
  },
  overdraw: {
    get: function get() {
      console.warn('THREE.Material: .overdraw has been removed.');
    },
    set: function set() {
      console.warn('THREE.Material: .overdraw has been removed.');
    }
  },
  wrapRGB: {
    get: function get() {
      console.warn('THREE.Material: .wrapRGB has been removed.');
      return new Color();
    }
  },
  shading: {
    get: function get() {
      console.error('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
    },
    set: function set(value) {
      console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
      this.flatShading = value === FlatShading;
    }
  },
  stencilMask: {
    get: function get() {
      console.warn('THREE.' + this.type + ': .stencilMask has been removed. Use .stencilFuncMask instead.');
      return this.stencilFuncMask;
    },
    set: function set(value) {
      console.warn('THREE.' + this.type + ': .stencilMask has been removed. Use .stencilFuncMask instead.');
      this.stencilFuncMask = value;
    }
  },
  vertexTangents: {
    get: function get() {
      console.warn('THREE.' + this.type + ': .vertexTangents has been removed.');
    },
    set: function set() {
      console.warn('THREE.' + this.type + ': .vertexTangents has been removed.');
    }
  }
});
Object.defineProperties(ShaderMaterial.prototype, {
  derivatives: {
    get: function get() {
      console.warn('THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.');
      return this.extensions.derivatives;
    },
    set: function set(value) {
      console.warn('THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.');
      this.extensions.derivatives = value;
    }
  }
}); //

WebGLRenderer.prototype.clearTarget = function (renderTarget, color, depth, stencil) {
  console.warn('THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.');
  this.setRenderTarget(renderTarget);
  this.clear(color, depth, stencil);
};

WebGLRenderer.prototype.animate = function (callback) {
  console.warn('THREE.WebGLRenderer: .animate() is now .setAnimationLoop().');
  this.setAnimationLoop(callback);
};

WebGLRenderer.prototype.getCurrentRenderTarget = function () {
  console.warn('THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().');
  return this.getRenderTarget();
};

WebGLRenderer.prototype.getMaxAnisotropy = function () {
  console.warn('THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().');
  return this.capabilities.getMaxAnisotropy();
};

WebGLRenderer.prototype.getPrecision = function () {
  console.warn('THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.');
  return this.capabilities.precision;
};

WebGLRenderer.prototype.resetGLState = function () {
  console.warn('THREE.WebGLRenderer: .resetGLState() is now .state.reset().');
  return this.state.reset();
};

WebGLRenderer.prototype.supportsFloatTextures = function () {
  console.warn('THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).');
  return this.extensions.get('OES_texture_float');
};

WebGLRenderer.prototype.supportsHalfFloatTextures = function () {
  console.warn('THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).');
  return this.extensions.get('OES_texture_half_float');
};

WebGLRenderer.prototype.supportsStandardDerivatives = function () {
  console.warn('THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).');
  return this.extensions.get('OES_standard_derivatives');
};

WebGLRenderer.prototype.supportsCompressedTextureS3TC = function () {
  console.warn('THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).');
  return this.extensions.get('WEBGL_compressed_texture_s3tc');
};

WebGLRenderer.prototype.supportsCompressedTexturePVRTC = function () {
  console.warn('THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).');
  return this.extensions.get('WEBGL_compressed_texture_pvrtc');
};

WebGLRenderer.prototype.supportsBlendMinMax = function () {
  console.warn('THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).');
  return this.extensions.get('EXT_blend_minmax');
};

WebGLRenderer.prototype.supportsVertexTextures = function () {
  console.warn('THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.');
  return this.capabilities.vertexTextures;
};

WebGLRenderer.prototype.supportsInstancedArrays = function () {
  console.warn('THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).');
  return this.extensions.get('ANGLE_instanced_arrays');
};

WebGLRenderer.prototype.enableScissorTest = function (boolean) {
  console.warn('THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().');
  this.setScissorTest(boolean);
};

WebGLRenderer.prototype.initMaterial = function () {
  console.warn('THREE.WebGLRenderer: .initMaterial() has been removed.');
};

WebGLRenderer.prototype.addPrePlugin = function () {
  console.warn('THREE.WebGLRenderer: .addPrePlugin() has been removed.');
};

WebGLRenderer.prototype.addPostPlugin = function () {
  console.warn('THREE.WebGLRenderer: .addPostPlugin() has been removed.');
};

WebGLRenderer.prototype.updateShadowMap = function () {
  console.warn('THREE.WebGLRenderer: .updateShadowMap() has been removed.');
};

WebGLRenderer.prototype.setFaceCulling = function () {
  console.warn('THREE.WebGLRenderer: .setFaceCulling() has been removed.');
};

WebGLRenderer.prototype.allocTextureUnit = function () {
  console.warn('THREE.WebGLRenderer: .allocTextureUnit() has been removed.');
};

WebGLRenderer.prototype.setTexture = function () {
  console.warn('THREE.WebGLRenderer: .setTexture() has been removed.');
};

WebGLRenderer.prototype.setTexture2D = function () {
  console.warn('THREE.WebGLRenderer: .setTexture2D() has been removed.');
};

WebGLRenderer.prototype.setTextureCube = function () {
  console.warn('THREE.WebGLRenderer: .setTextureCube() has been removed.');
};

WebGLRenderer.prototype.getActiveMipMapLevel = function () {
  console.warn('THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().');
  return this.getActiveMipmapLevel();
};

Object.defineProperties(WebGLRenderer.prototype, {
  shadowMapEnabled: {
    get: function get() {
      return this.shadowMap.enabled;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.');
      this.shadowMap.enabled = value;
    }
  },
  shadowMapType: {
    get: function get() {
      return this.shadowMap.type;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.');
      this.shadowMap.type = value;
    }
  },
  shadowMapCullFace: {
    get: function get() {
      console.warn('THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.');
      return undefined;
    },
    set: function
      /* value */
    set() {
      console.warn('THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.');
    }
  },
  context: {
    get: function get() {
      console.warn('THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.');
      return this.getContext();
    }
  },
  vr: {
    get: function get() {
      console.warn('THREE.WebGLRenderer: .vr has been renamed to .xr');
      return this.xr;
    }
  },
  gammaInput: {
    get: function get() {
      console.warn('THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.');
      return false;
    },
    set: function set() {
      console.warn('THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.');
    }
  },
  gammaOutput: {
    get: function get() {
      console.warn('THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.');
      return false;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.');
      this.outputEncoding = value === true ? sRGBEncoding : LinearEncoding;
    }
  },
  toneMappingWhitePoint: {
    get: function get() {
      console.warn('THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.');
      return 1.0;
    },
    set: function set() {
      console.warn('THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.');
    }
  },
  gammaFactor: {
    get: function get() {
      console.warn('THREE.WebGLRenderer: .gammaFactor has been removed.');
      return 2;
    },
    set: function set() {
      console.warn('THREE.WebGLRenderer: .gammaFactor has been removed.');
    }
  }
});
Object.defineProperties(WebGLShadowMap.prototype, {
  cullFace: {
    get: function get() {
      console.warn('THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.');
      return undefined;
    },
    set: function
      /* cullFace */
    set() {
      console.warn('THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.');
    }
  },
  renderReverseSided: {
    get: function get() {
      console.warn('THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.');
      return undefined;
    },
    set: function set() {
      console.warn('THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.');
    }
  },
  renderSingleSided: {
    get: function get() {
      console.warn('THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.');
      return undefined;
    },
    set: function set() {
      console.warn('THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.');
    }
  }
}); //

Object.defineProperties(WebGLRenderTarget.prototype, {
  wrapS: {
    get: function get() {
      console.warn('THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.');
      return this.texture.wrapS;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.');
      this.texture.wrapS = value;
    }
  },
  wrapT: {
    get: function get() {
      console.warn('THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.');
      return this.texture.wrapT;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.');
      this.texture.wrapT = value;
    }
  },
  magFilter: {
    get: function get() {
      console.warn('THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.');
      return this.texture.magFilter;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.');
      this.texture.magFilter = value;
    }
  },
  minFilter: {
    get: function get() {
      console.warn('THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.');
      return this.texture.minFilter;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.');
      this.texture.minFilter = value;
    }
  },
  anisotropy: {
    get: function get() {
      console.warn('THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.');
      return this.texture.anisotropy;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.');
      this.texture.anisotropy = value;
    }
  },
  offset: {
    get: function get() {
      console.warn('THREE.WebGLRenderTarget: .offset is now .texture.offset.');
      return this.texture.offset;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderTarget: .offset is now .texture.offset.');
      this.texture.offset = value;
    }
  },
  repeat: {
    get: function get() {
      console.warn('THREE.WebGLRenderTarget: .repeat is now .texture.repeat.');
      return this.texture.repeat;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderTarget: .repeat is now .texture.repeat.');
      this.texture.repeat = value;
    }
  },
  format: {
    get: function get() {
      console.warn('THREE.WebGLRenderTarget: .format is now .texture.format.');
      return this.texture.format;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderTarget: .format is now .texture.format.');
      this.texture.format = value;
    }
  },
  type: {
    get: function get() {
      console.warn('THREE.WebGLRenderTarget: .type is now .texture.type.');
      return this.texture.type;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderTarget: .type is now .texture.type.');
      this.texture.type = value;
    }
  },
  generateMipmaps: {
    get: function get() {
      console.warn('THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.');
      return this.texture.generateMipmaps;
    },
    set: function set(value) {
      console.warn('THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.');
      this.texture.generateMipmaps = value;
    }
  }
}); //

CubeCamera.prototype.updateCubeMap = function (renderer, scene) {
  console.warn('THREE.CubeCamera: .updateCubeMap() is now .update().');
  return this.update(renderer, scene);
};

CubeCamera.prototype.clear = function (renderer, color, depth, stencil) {
  console.warn('THREE.CubeCamera: .clear() is now .renderTarget.clear().');
  return this.renderTarget.clear(renderer, color, depth, stencil);
};

ImageUtils.crossOrigin = undefined;

ImageUtils.loadTexture = function (url, mapping, onLoad, onError) {
  console.warn('THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.');
  var loader = new TextureLoader();
  loader.setCrossOrigin(this.crossOrigin);
  var texture = loader.load(url, onLoad, undefined, onError);
  if (mapping) texture.mapping = mapping;
  return texture;
};

ImageUtils.loadTextureCube = function (urls, mapping, onLoad, onError) {
  console.warn('THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.');
  var loader = new CubeTextureLoader();
  loader.setCrossOrigin(this.crossOrigin);
  var texture = loader.load(urls, onLoad, undefined, onError);
  if (mapping) texture.mapping = mapping;
  return texture;
};

ImageUtils.loadCompressedTexture = function () {
  console.error('THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.');
};

ImageUtils.loadCompressedTextureCube = function () {
  console.error('THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.');
};

if (typeof __THREE_DEVTOOLS__ !== 'undefined') {
  __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
      revision: REVISION
    }
  }));
}

if (typeof window !== 'undefined') {
  if (window.__THREE__) {
    console.warn('WARNING: Multiple instances of Three.js being imported.');
  } else {
    window.__THREE__ = REVISION;
  }
} // This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move


var _changeEvent = {
  type: 'change'
};
var _startEvent = {
  type: 'start'
};
var _endEvent = {
  type: 'end'
};

var OrbitControls = /*#__PURE__*/function (_EventDispatcher7) {
  _inherits(OrbitControls, _EventDispatcher7);

  var _super79 = _createSuper(OrbitControls);

  function OrbitControls(object, domElement) {
    var _this71;

    _classCallCheck2(this, OrbitControls);

    _this71 = _super79.call(this);
    if (domElement === undefined) console.warn('THREE.OrbitControls: The second parameter "domElement" is now mandatory.');
    if (domElement === document) console.error('THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.');
    _this71.object = object;
    _this71.domElement = domElement;
    _this71.domElement.style.touchAction = 'none'; // disable touch scroll
    // Set to false to disable this control

    _this71.enabled = true; // "target" sets the location of focus, where the object orbits around

    _this71.target = new Vector3(); // How far you can dolly in and out ( PerspectiveCamera only )

    _this71.minDistance = 0;
    _this71.maxDistance = Infinity; // How far you can zoom in and out ( OrthographicCamera only )

    _this71.minZoom = 0;
    _this71.maxZoom = Infinity; // How far you can orbit vertically, upper and lower limits.
    // Range is 0 to Math.PI radians.

    _this71.minPolarAngle = 0; // radians

    _this71.maxPolarAngle = Math.PI; // radians
    // How far you can orbit horizontally, upper and lower limits.
    // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )

    _this71.minAzimuthAngle = -Infinity; // radians

    _this71.maxAzimuthAngle = Infinity; // radians
    // Set to true to enable damping (inertia)
    // If damping is enabled, you must call controls.update() in your animation loop

    _this71.enableDamping = false;
    _this71.dampingFactor = 0.05; // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
    // Set to false to disable zooming

    _this71.enableZoom = true;
    _this71.zoomSpeed = 1.0; // Set to false to disable rotating

    _this71.enableRotate = true;
    _this71.rotateSpeed = 1.0; // Set to false to disable panning

    _this71.enablePan = true;
    _this71.panSpeed = 1.0;
    _this71.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up

    _this71.keyPanSpeed = 7.0; // pixels moved per arrow key push
    // Set to true to automatically rotate around the target
    // If auto-rotate is enabled, you must call controls.update() in your animation loop

    _this71.autoRotate = false;
    _this71.autoRotateSpeed = 2.0; // 30 seconds per orbit when fps is 60
    // The four arrow keys

    _this71.keys = {
      LEFT: 'ArrowLeft',
      UP: 'ArrowUp',
      RIGHT: 'ArrowRight',
      BOTTOM: 'ArrowDown'
    }; // Mouse buttons

    _this71.mouseButtons = {
      LEFT: MOUSE.ROTATE,
      MIDDLE: MOUSE.DOLLY,
      RIGHT: MOUSE.PAN
    }; // Touch fingers

    _this71.touches = {
      ONE: TOUCH.ROTATE,
      TWO: TOUCH.DOLLY_PAN
    }; // for reset

    _this71.target0 = _this71.target.clone();
    _this71.position0 = _this71.object.position.clone();
    _this71.zoom0 = _this71.object.zoom; // the target DOM element for key events

    _this71._domElementKeyEvents = null; //
    // public methods
    //

    _this71.getPolarAngle = function () {
      return spherical.phi;
    };

    _this71.getAzimuthalAngle = function () {
      return spherical.theta;
    };

    _this71.getDistance = function () {
      return this.object.position.distanceTo(this.target);
    };

    _this71.listenToKeyEvents = function (domElement) {
      domElement.addEventListener('keydown', onKeyDown);
      this._domElementKeyEvents = domElement;
    };

    _this71.saveState = function () {
      scope.target0.copy(scope.target);
      scope.position0.copy(scope.object.position);
      scope.zoom0 = scope.object.zoom;
    };

    _this71.reset = function () {
      scope.target.copy(scope.target0);
      scope.object.position.copy(scope.position0);
      scope.object.zoom = scope.zoom0;
      scope.object.updateProjectionMatrix();
      scope.dispatchEvent(_changeEvent);
      scope.update();
      state = STATE.NONE;
    }; // this method is exposed, but perhaps it would be better if we can make it private...


    _this71.update = function () {
      var offset = new Vector3(); // so camera.up is the orbit axis

      var quat = new Quaternion().setFromUnitVectors(object.up, new Vector3(0, 1, 0));
      var quatInverse = quat.clone().invert();
      var lastPosition = new Vector3();
      var lastQuaternion = new Quaternion();
      var twoPI = 2 * Math.PI;
      return function update() {
        var position = scope.object.position;
        offset.copy(position).sub(scope.target); // rotate offset to "y-axis-is-up" space

        offset.applyQuaternion(quat); // angle from z-axis around y-axis

        spherical.setFromVector3(offset);

        if (scope.autoRotate && state === STATE.NONE) {
          rotateLeft(getAutoRotationAngle());
        }

        if (scope.enableDamping) {
          spherical.theta += sphericalDelta.theta * scope.dampingFactor;
          spherical.phi += sphericalDelta.phi * scope.dampingFactor;
        } else {
          spherical.theta += sphericalDelta.theta;
          spherical.phi += sphericalDelta.phi;
        } // restrict theta to be between desired limits


        var min = scope.minAzimuthAngle;
        var max = scope.maxAzimuthAngle;

        if (isFinite(min) && isFinite(max)) {
          if (min < -Math.PI) min += twoPI;else if (min > Math.PI) min -= twoPI;
          if (max < -Math.PI) max += twoPI;else if (max > Math.PI) max -= twoPI;

          if (min <= max) {
            spherical.theta = Math.max(min, Math.min(max, spherical.theta));
          } else {
            spherical.theta = spherical.theta > (min + max) / 2 ? Math.max(min, spherical.theta) : Math.min(max, spherical.theta);
          }
        } // restrict phi to be between desired limits


        spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical.phi));
        spherical.makeSafe();
        spherical.radius *= scale; // restrict radius to be between desired limits

        spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, spherical.radius)); // move target to panned location

        if (scope.enableDamping === true) {
          scope.target.addScaledVector(panOffset, scope.dampingFactor);
        } else {
          scope.target.add(panOffset);
        }

        offset.setFromSpherical(spherical); // rotate offset back to "camera-up-vector-is-up" space

        offset.applyQuaternion(quatInverse);
        position.copy(scope.target).add(offset);
        scope.object.lookAt(scope.target);

        if (scope.enableDamping === true) {
          sphericalDelta.theta *= 1 - scope.dampingFactor;
          sphericalDelta.phi *= 1 - scope.dampingFactor;
          panOffset.multiplyScalar(1 - scope.dampingFactor);
        } else {
          sphericalDelta.set(0, 0, 0);
          panOffset.set(0, 0, 0);
        }

        scale = 1; // update condition is:
        // min(camera displacement, camera rotation in radians)^2 > EPS
        // using small-angle approximation cos(x/2) = 1 - x^2 / 8

        if (zoomChanged || lastPosition.distanceToSquared(scope.object.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {
          scope.dispatchEvent(_changeEvent);
          lastPosition.copy(scope.object.position);
          lastQuaternion.copy(scope.object.quaternion);
          zoomChanged = false;
          return true;
        }

        return false;
      };
    }();

    _this71.dispose = function () {
      scope.domElement.removeEventListener('contextmenu', onContextMenu);
      scope.domElement.removeEventListener('pointerdown', onPointerDown);
      scope.domElement.removeEventListener('pointercancel', onPointerCancel);
      scope.domElement.removeEventListener('wheel', onMouseWheel);
      scope.domElement.removeEventListener('pointermove', onPointerMove);
      scope.domElement.removeEventListener('pointerup', onPointerUp);

      if (scope._domElementKeyEvents !== null) {
        scope._domElementKeyEvents.removeEventListener('keydown', onKeyDown);
      } //scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?

    }; //
    // internals
    //


    var scope = _assertThisInitialized(_this71);

    var STATE = {
      NONE: -1,
      ROTATE: 0,
      DOLLY: 1,
      PAN: 2,
      TOUCH_ROTATE: 3,
      TOUCH_PAN: 4,
      TOUCH_DOLLY_PAN: 5,
      TOUCH_DOLLY_ROTATE: 6
    };
    var state = STATE.NONE;
    var EPS = 0.000001; // current position in spherical coordinates

    var spherical = new Spherical();
    var sphericalDelta = new Spherical();
    var scale = 1;
    var panOffset = new Vector3();
    var zoomChanged = false;
    var rotateStart = new Vector2();
    var rotateEnd = new Vector2();
    var rotateDelta = new Vector2();
    var panStart = new Vector2();
    var panEnd = new Vector2();
    var panDelta = new Vector2();
    var dollyStart = new Vector2();
    var dollyEnd = new Vector2();
    var dollyDelta = new Vector2();
    var pointers = [];
    var pointerPositions = {};

    function getAutoRotationAngle() {
      return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
    }

    function getZoomScale() {
      return Math.pow(0.95, scope.zoomSpeed);
    }

    function rotateLeft(angle) {
      sphericalDelta.theta -= angle;
    }

    function rotateUp(angle) {
      sphericalDelta.phi -= angle;
    }

    var panLeft = function () {
      var v = new Vector3();
      return function panLeft(distance, objectMatrix) {
        v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix

        v.multiplyScalar(-distance);
        panOffset.add(v);
      };
    }();

    var panUp = function () {
      var v = new Vector3();
      return function panUp(distance, objectMatrix) {
        if (scope.screenSpacePanning === true) {
          v.setFromMatrixColumn(objectMatrix, 1);
        } else {
          v.setFromMatrixColumn(objectMatrix, 0);
          v.crossVectors(scope.object.up, v);
        }

        v.multiplyScalar(distance);
        panOffset.add(v);
      };
    }(); // deltaX and deltaY are in pixels; right and down are positive


    var pan = function () {
      var offset = new Vector3();
      return function pan(deltaX, deltaY) {
        var element = scope.domElement;

        if (scope.object.isPerspectiveCamera) {
          // perspective
          var position = scope.object.position;
          offset.copy(position).sub(scope.target);
          var targetDistance = offset.length(); // half of the fov is center to top of screen

          targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180.0); // we use only clientHeight here so aspect ratio does not distort speed

          panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix);
          panUp(2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix);
        } else if (scope.object.isOrthographicCamera) {
          // orthographic
          panLeft(deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth, scope.object.matrix);
          panUp(deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight, scope.object.matrix);
        } else {
          // camera neither orthographic nor perspective
          console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
          scope.enablePan = false;
        }
      };
    }();

    function dollyOut(dollyScale) {
      if (scope.object.isPerspectiveCamera) {
        scale /= dollyScale;
      } else if (scope.object.isOrthographicCamera) {
        scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom * dollyScale));
        scope.object.updateProjectionMatrix();
        zoomChanged = true;
      } else {
        console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
        scope.enableZoom = false;
      }
    }

    function dollyIn(dollyScale) {
      if (scope.object.isPerspectiveCamera) {
        scale *= dollyScale;
      } else if (scope.object.isOrthographicCamera) {
        scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / dollyScale));
        scope.object.updateProjectionMatrix();
        zoomChanged = true;
      } else {
        console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
        scope.enableZoom = false;
      }
    } //
    // event callbacks - update the object state
    //


    function handleMouseDownRotate(event) {
      rotateStart.set(event.clientX, event.clientY);
    }

    function handleMouseDownDolly(event) {
      dollyStart.set(event.clientX, event.clientY);
    }

    function handleMouseDownPan(event) {
      panStart.set(event.clientX, event.clientY);
    }

    function handleMouseMoveRotate(event) {
      rotateEnd.set(event.clientX, event.clientY);
      rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
      var element = scope.domElement;
      rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height

      rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
      rotateStart.copy(rotateEnd);
      scope.update();
    }

    function handleMouseMoveDolly(event) {
      dollyEnd.set(event.clientX, event.clientY);
      dollyDelta.subVectors(dollyEnd, dollyStart);

      if (dollyDelta.y > 0) {
        dollyOut(getZoomScale());
      } else if (dollyDelta.y < 0) {
        dollyIn(getZoomScale());
      }

      dollyStart.copy(dollyEnd);
      scope.update();
    }

    function handleMouseMovePan(event) {
      panEnd.set(event.clientX, event.clientY);
      panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
      pan(panDelta.x, panDelta.y);
      panStart.copy(panEnd);
      scope.update();
    }

    function handleMouseWheel(event) {
      if (event.deltaY < 0) {
        dollyIn(getZoomScale());
      } else if (event.deltaY > 0) {
        dollyOut(getZoomScale());
      }

      scope.update();
    }

    function handleKeyDown(event) {
      var needsUpdate = false;

      switch (event.code) {
        case scope.keys.UP:
          pan(0, scope.keyPanSpeed);
          needsUpdate = true;
          break;

        case scope.keys.BOTTOM:
          pan(0, -scope.keyPanSpeed);
          needsUpdate = true;
          break;

        case scope.keys.LEFT:
          pan(scope.keyPanSpeed, 0);
          needsUpdate = true;
          break;

        case scope.keys.RIGHT:
          pan(-scope.keyPanSpeed, 0);
          needsUpdate = true;
          break;
      }

      if (needsUpdate) {
        // prevent the browser from scrolling on cursor keys
        event.preventDefault();
        scope.update();
      }
    }

    function handleTouchStartRotate() {
      if (pointers.length === 1) {
        rotateStart.set(pointers[0].pageX, pointers[0].pageY);
      } else {
        var x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
        var y = 0.5 * (pointers[0].pageY + pointers[1].pageY);
        rotateStart.set(x, y);
      }
    }

    function handleTouchStartPan() {
      if (pointers.length === 1) {
        panStart.set(pointers[0].pageX, pointers[0].pageY);
      } else {
        var x = 0.5 * (pointers[0].pageX + pointers[1].pageX);
        var y = 0.5 * (pointers[0].pageY + pointers[1].pageY);
        panStart.set(x, y);
      }
    }

    function handleTouchStartDolly() {
      var dx = pointers[0].pageX - pointers[1].pageX;
      var dy = pointers[0].pageY - pointers[1].pageY;
      var distance = Math.sqrt(dx * dx + dy * dy);
      dollyStart.set(0, distance);
    }

    function handleTouchStartDollyPan() {
      if (scope.enableZoom) handleTouchStartDolly();
      if (scope.enablePan) handleTouchStartPan();
    }

    function handleTouchStartDollyRotate() {
      if (scope.enableZoom) handleTouchStartDolly();
      if (scope.enableRotate) handleTouchStartRotate();
    }

    function handleTouchMoveRotate(event) {
      if (pointers.length == 1) {
        rotateEnd.set(event.pageX, event.pageY);
      } else {
        var position = getSecondPointerPosition(event);
        var x = 0.5 * (event.pageX + position.x);
        var y = 0.5 * (event.pageY + position.y);
        rotateEnd.set(x, y);
      }

      rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
      var element = scope.domElement;
      rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height

      rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
      rotateStart.copy(rotateEnd);
    }

    function handleTouchMovePan(event) {
      if (pointers.length === 1) {
        panEnd.set(event.pageX, event.pageY);
      } else {
        var position = getSecondPointerPosition(event);
        var x = 0.5 * (event.pageX + position.x);
        var y = 0.5 * (event.pageY + position.y);
        panEnd.set(x, y);
      }

      panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
      pan(panDelta.x, panDelta.y);
      panStart.copy(panEnd);
    }

    function handleTouchMoveDolly(event) {
      var position = getSecondPointerPosition(event);
      var dx = event.pageX - position.x;
      var dy = event.pageY - position.y;
      var distance = Math.sqrt(dx * dx + dy * dy);
      dollyEnd.set(0, distance);
      dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));
      dollyOut(dollyDelta.y);
      dollyStart.copy(dollyEnd);
    }

    function handleTouchMoveDollyPan(event) {
      if (scope.enableZoom) handleTouchMoveDolly(event);
      if (scope.enablePan) handleTouchMovePan(event);
    }

    function handleTouchMoveDollyRotate(event) {
      if (scope.enableZoom) handleTouchMoveDolly(event);
      if (scope.enableRotate) handleTouchMoveRotate(event);
    } //
    // event handlers - FSM: listen for events and reset state
    //


    function onPointerDown(event) {
      if (scope.enabled === false) return;

      if (pointers.length === 0) {
        scope.domElement.setPointerCapture(event.pointerId);
        scope.domElement.addEventListener('pointermove', onPointerMove);
        scope.domElement.addEventListener('pointerup', onPointerUp);
      } //


      addPointer(event);

      if (event.pointerType === 'touch') {
        onTouchStart(event);
      } else {
        onMouseDown(event);
      }
    }

    function onPointerMove(event) {
      if (scope.enabled === false) return;

      if (event.pointerType === 'touch') {
        onTouchMove(event);
      } else {
        onMouseMove(event);
      }
    }

    function onPointerUp(event) {
      removePointer(event);

      if (pointers.length === 0) {
        scope.domElement.releasePointerCapture(event.pointerId);
        scope.domElement.removeEventListener('pointermove', onPointerMove);
        scope.domElement.removeEventListener('pointerup', onPointerUp);
      }

      scope.dispatchEvent(_endEvent);
      state = STATE.NONE;
    }

    function onPointerCancel(event) {
      removePointer(event);
    }

    function onMouseDown(event) {
      var mouseAction;

      switch (event.button) {
        case 0:
          mouseAction = scope.mouseButtons.LEFT;
          break;

        case 1:
          mouseAction = scope.mouseButtons.MIDDLE;
          break;

        case 2:
          mouseAction = scope.mouseButtons.RIGHT;
          break;

        default:
          mouseAction = -1;
      }

      switch (mouseAction) {
        case MOUSE.DOLLY:
          if (scope.enableZoom === false) return;
          handleMouseDownDolly(event);
          state = STATE.DOLLY;
          break;

        case MOUSE.ROTATE:
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            if (scope.enablePan === false) return;
            handleMouseDownPan(event);
            state = STATE.PAN;
          } else {
            if (scope.enableRotate === false) return;
            handleMouseDownRotate(event);
            state = STATE.ROTATE;
          }

          break;

        case MOUSE.PAN:
          if (event.ctrlKey || event.metaKey || event.shiftKey) {
            if (scope.enableRotate === false) return;
            handleMouseDownRotate(event);
            state = STATE.ROTATE;
          } else {
            if (scope.enablePan === false) return;
            handleMouseDownPan(event);
            state = STATE.PAN;
          }

          break;

        default:
          state = STATE.NONE;
      }

      if (state !== STATE.NONE) {
        scope.dispatchEvent(_startEvent);
      }
    }

    function onMouseMove(event) {
      if (scope.enabled === false) return;

      switch (state) {
        case STATE.ROTATE:
          if (scope.enableRotate === false) return;
          handleMouseMoveRotate(event);
          break;

        case STATE.DOLLY:
          if (scope.enableZoom === false) return;
          handleMouseMoveDolly(event);
          break;

        case STATE.PAN:
          if (scope.enablePan === false) return;
          handleMouseMovePan(event);
          break;
      }
    }

    function onMouseWheel(event) {
      if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE) return;
      event.preventDefault();
      scope.dispatchEvent(_startEvent);
      handleMouseWheel(event);
      scope.dispatchEvent(_endEvent);
    }

    function onKeyDown(event) {
      if (scope.enabled === false || scope.enablePan === false) return;
      handleKeyDown(event);
    }

    function onTouchStart(event) {
      trackPointer(event);

      switch (pointers.length) {
        case 1:
          switch (scope.touches.ONE) {
            case TOUCH.ROTATE:
              if (scope.enableRotate === false) return;
              handleTouchStartRotate();
              state = STATE.TOUCH_ROTATE;
              break;

            case TOUCH.PAN:
              if (scope.enablePan === false) return;
              handleTouchStartPan();
              state = STATE.TOUCH_PAN;
              break;

            default:
              state = STATE.NONE;
          }

          break;

        case 2:
          switch (scope.touches.TWO) {
            case TOUCH.DOLLY_PAN:
              if (scope.enableZoom === false && scope.enablePan === false) return;
              handleTouchStartDollyPan();
              state = STATE.TOUCH_DOLLY_PAN;
              break;

            case TOUCH.DOLLY_ROTATE:
              if (scope.enableZoom === false && scope.enableRotate === false) return;
              handleTouchStartDollyRotate();
              state = STATE.TOUCH_DOLLY_ROTATE;
              break;

            default:
              state = STATE.NONE;
          }

          break;

        default:
          state = STATE.NONE;
      }

      if (state !== STATE.NONE) {
        scope.dispatchEvent(_startEvent);
      }
    }

    function onTouchMove(event) {
      trackPointer(event);

      switch (state) {
        case STATE.TOUCH_ROTATE:
          if (scope.enableRotate === false) return;
          handleTouchMoveRotate(event);
          scope.update();
          break;

        case STATE.TOUCH_PAN:
          if (scope.enablePan === false) return;
          handleTouchMovePan(event);
          scope.update();
          break;

        case STATE.TOUCH_DOLLY_PAN:
          if (scope.enableZoom === false && scope.enablePan === false) return;
          handleTouchMoveDollyPan(event);
          scope.update();
          break;

        case STATE.TOUCH_DOLLY_ROTATE:
          if (scope.enableZoom === false && scope.enableRotate === false) return;
          handleTouchMoveDollyRotate(event);
          scope.update();
          break;

        default:
          state = STATE.NONE;
      }
    }

    function onContextMenu(event) {
      if (scope.enabled === false) return;
      event.preventDefault();
    }

    function addPointer(event) {
      pointers.push(event);
    }

    function removePointer(event) {
      delete pointerPositions[event.pointerId];

      for (var _i233 = 0; _i233 < pointers.length; _i233++) {
        if (pointers[_i233].pointerId == event.pointerId) {
          pointers.splice(_i233, 1);
          return;
        }
      }
    }

    function trackPointer(event) {
      var position = pointerPositions[event.pointerId];

      if (position === undefined) {
        position = new Vector2();
        pointerPositions[event.pointerId] = position;
      }

      position.set(event.pageX, event.pageY);
    }

    function getSecondPointerPosition(event) {
      var pointer = event.pointerId === pointers[0].pointerId ? pointers[1] : pointers[0];
      return pointerPositions[pointer.pointerId];
    } //


    scope.domElement.addEventListener('contextmenu', onContextMenu);
    scope.domElement.addEventListener('pointerdown', onPointerDown);
    scope.domElement.addEventListener('pointercancel', onPointerCancel);
    scope.domElement.addEventListener('wheel', onMouseWheel, {
      passive: false
    }); // force an update at start

    _this71.update();

    return _this71;
  }

  return OrbitControls;
}(EventDispatcher);

var _raycaster = new Raycaster();

var _tempVector = new Vector3();

var _tempVector2 = new Vector3();

var _tempQuaternion = new Quaternion();

var _unit = {
  X: new Vector3(1, 0, 0),
  Y: new Vector3(0, 1, 0),
  Z: new Vector3(0, 0, 1)
};
var _changeEvent$1 = {
  type: 'change'
};
var _mouseDownEvent = {
  type: 'mouseDown'
};
var _mouseUpEvent = {
  type: 'mouseUp',
  mode: null
};
var _objectChangeEvent = {
  type: 'objectChange'
};

var TransformControls = /*#__PURE__*/function (_Object3D9) {
  _inherits(TransformControls, _Object3D9);

  var _super80 = _createSuper(TransformControls);

  function TransformControls(camera, domElement) {
    var _this72;

    _classCallCheck2(this, TransformControls);

    _this72 = _super80.call(this);

    if (domElement === undefined) {
      console.warn('THREE.TransformControls: The second parameter "domElement" is now mandatory.');
      domElement = document;
    }

    _this72.visible = false;
    _this72.domElement = domElement;
    _this72.domElement.style.touchAction = 'none'; // disable touch scroll

    var _gizmo = new TransformControlsGizmo();

    _this72._gizmo = _gizmo;

    _this72.add(_gizmo);

    var _plane = new TransformControlsPlane();

    _this72._plane = _plane;

    _this72.add(_plane);

    var scope = _assertThisInitialized(_this72); // Defined getter, setter and store for a property


    function defineProperty(propName, defaultValue) {
      var propValue = defaultValue;
      Object.defineProperty(scope, propName, {
        get: function get() {
          return propValue !== undefined ? propValue : defaultValue;
        },
        set: function set(value) {
          if (propValue !== value) {
            propValue = value;
            _plane[propName] = value;
            _gizmo[propName] = value;
            scope.dispatchEvent({
              type: propName + '-changed',
              value: value
            });
            scope.dispatchEvent(_changeEvent$1);
          }
        }
      });
      scope[propName] = defaultValue;
      _plane[propName] = defaultValue;
      _gizmo[propName] = defaultValue;
    } // Define properties with getters/setter
    // Setting the defined property will automatically trigger change event
    // Defined properties are passed down to gizmo and plane


    defineProperty('camera', camera);
    defineProperty('object', undefined);
    defineProperty('enabled', true);
    defineProperty('axis', null);
    defineProperty('mode', 'translate');
    defineProperty('translationSnap', null);
    defineProperty('rotationSnap', null);
    defineProperty('scaleSnap', null);
    defineProperty('space', 'world');
    defineProperty('size', 1);
    defineProperty('dragging', false);
    defineProperty('showX', true);
    defineProperty('showY', true);
    defineProperty('showZ', true); // Reusable utility variables

    var worldPosition = new Vector3();
    var worldPositionStart = new Vector3();
    var worldQuaternion = new Quaternion();
    var worldQuaternionStart = new Quaternion();
    var cameraPosition = new Vector3();
    var cameraQuaternion = new Quaternion();
    var pointStart = new Vector3();
    var pointEnd = new Vector3();
    var rotationAxis = new Vector3();
    var rotationAngle = 0;
    var eye = new Vector3(); // TODO: remove properties unused in plane and gizmo

    defineProperty('worldPosition', worldPosition);
    defineProperty('worldPositionStart', worldPositionStart);
    defineProperty('worldQuaternion', worldQuaternion);
    defineProperty('worldQuaternionStart', worldQuaternionStart);
    defineProperty('cameraPosition', cameraPosition);
    defineProperty('cameraQuaternion', cameraQuaternion);
    defineProperty('pointStart', pointStart);
    defineProperty('pointEnd', pointEnd);
    defineProperty('rotationAxis', rotationAxis);
    defineProperty('rotationAngle', rotationAngle);
    defineProperty('eye', eye);
    _this72._offset = new Vector3();
    _this72._startNorm = new Vector3();
    _this72._endNorm = new Vector3();
    _this72._cameraScale = new Vector3();
    _this72._parentPosition = new Vector3();
    _this72._parentQuaternion = new Quaternion();
    _this72._parentQuaternionInv = new Quaternion();
    _this72._parentScale = new Vector3();
    _this72._worldScaleStart = new Vector3();
    _this72._worldQuaternionInv = new Quaternion();
    _this72._worldScale = new Vector3();
    _this72._positionStart = new Vector3();
    _this72._quaternionStart = new Quaternion();
    _this72._scaleStart = new Vector3();
    _this72._getPointer = getPointer.bind(_assertThisInitialized(_this72));
    _this72._onPointerDown = onPointerDown.bind(_assertThisInitialized(_this72));
    _this72._onPointerHover = onPointerHover.bind(_assertThisInitialized(_this72));
    _this72._onPointerMove = onPointerMove.bind(_assertThisInitialized(_this72));
    _this72._onPointerUp = onPointerUp.bind(_assertThisInitialized(_this72));

    _this72.domElement.addEventListener('pointerdown', _this72._onPointerDown);

    _this72.domElement.addEventListener('pointermove', _this72._onPointerHover);

    _this72.domElement.addEventListener('pointerup', _this72._onPointerUp);

    return _this72;
  } // updateMatrixWorld  updates key transformation variables


  _createClass2(TransformControls, [{
    key: "updateMatrixWorld",
    value: function updateMatrixWorld() {
      if (this.object !== undefined) {
        this.object.updateMatrixWorld();

        if (this.object.parent === null) {
          console.error('TransformControls: The attached 3D object must be a part of the scene graph.');
        } else {
          this.object.parent.matrixWorld.decompose(this._parentPosition, this._parentQuaternion, this._parentScale);
        }

        this.object.matrixWorld.decompose(this.worldPosition, this.worldQuaternion, this._worldScale);

        this._parentQuaternionInv.copy(this._parentQuaternion).invert();

        this._worldQuaternionInv.copy(this.worldQuaternion).invert();
      }

      this.camera.updateMatrixWorld();
      this.camera.matrixWorld.decompose(this.cameraPosition, this.cameraQuaternion, this._cameraScale);
      this.eye.copy(this.cameraPosition).sub(this.worldPosition).normalize();

      _get(_getPrototypeOf(TransformControls.prototype), "updateMatrixWorld", this).call(this, this);
    }
  }, {
    key: "pointerHover",
    value: function pointerHover(pointer) {
      if (this.object === undefined || this.dragging === true) return;

      _raycaster.setFromCamera(pointer, this.camera);

      var intersect = intersectObjectWithRay(this._gizmo.picker[this.mode], _raycaster);

      if (intersect) {
        this.axis = intersect.object.name;
      } else {
        this.axis = null;
      }
    }
  }, {
    key: "pointerDown",
    value: function pointerDown(pointer) {
      if (this.object === undefined || this.dragging === true || pointer.button !== 0) return;

      if (this.axis !== null) {
        _raycaster.setFromCamera(pointer, this.camera);

        var planeIntersect = intersectObjectWithRay(this._plane, _raycaster, true);

        if (planeIntersect) {
          this.object.updateMatrixWorld();
          this.object.parent.updateMatrixWorld();

          this._positionStart.copy(this.object.position);

          this._quaternionStart.copy(this.object.quaternion);

          this._scaleStart.copy(this.object.scale);

          this.object.matrixWorld.decompose(this.worldPositionStart, this.worldQuaternionStart, this._worldScaleStart);
          this.pointStart.copy(planeIntersect.point).sub(this.worldPositionStart);
        }

        this.dragging = true;
        _mouseDownEvent.mode = this.mode;
        this.dispatchEvent(_mouseDownEvent);
      }
    }
  }, {
    key: "pointerMove",
    value: function pointerMove(pointer) {
      var axis = this.axis;
      var mode = this.mode;
      var object = this.object;
      var space = this.space;

      if (mode === 'scale') {
        space = 'local';
      } else if (axis === 'E' || axis === 'XYZE' || axis === 'XYZ') {
        space = 'world';
      }

      if (object === undefined || axis === null || this.dragging === false || pointer.button !== -1) return;

      _raycaster.setFromCamera(pointer, this.camera);

      var planeIntersect = intersectObjectWithRay(this._plane, _raycaster, true);
      if (!planeIntersect) return;
      this.pointEnd.copy(planeIntersect.point).sub(this.worldPositionStart);

      if (mode === 'translate') {
        // Apply translate
        this._offset.copy(this.pointEnd).sub(this.pointStart);

        if (space === 'local' && axis !== 'XYZ') {
          this._offset.applyQuaternion(this._worldQuaternionInv);
        }

        if (axis.indexOf('X') === -1) this._offset.x = 0;
        if (axis.indexOf('Y') === -1) this._offset.y = 0;
        if (axis.indexOf('Z') === -1) this._offset.z = 0;

        if (space === 'local' && axis !== 'XYZ') {
          this._offset.applyQuaternion(this._quaternionStart).divide(this._parentScale);
        } else {
          this._offset.applyQuaternion(this._parentQuaternionInv).divide(this._parentScale);
        }

        object.position.copy(this._offset).add(this._positionStart); // Apply translation snap

        if (this.translationSnap) {
          if (space === 'local') {
            object.position.applyQuaternion(_tempQuaternion.copy(this._quaternionStart).invert());

            if (axis.search('X') !== -1) {
              object.position.x = Math.round(object.position.x / this.translationSnap) * this.translationSnap;
            }

            if (axis.search('Y') !== -1) {
              object.position.y = Math.round(object.position.y / this.translationSnap) * this.translationSnap;
            }

            if (axis.search('Z') !== -1) {
              object.position.z = Math.round(object.position.z / this.translationSnap) * this.translationSnap;
            }

            object.position.applyQuaternion(this._quaternionStart);
          }

          if (space === 'world') {
            if (object.parent) {
              object.position.add(_tempVector.setFromMatrixPosition(object.parent.matrixWorld));
            }

            if (axis.search('X') !== -1) {
              object.position.x = Math.round(object.position.x / this.translationSnap) * this.translationSnap;
            }

            if (axis.search('Y') !== -1) {
              object.position.y = Math.round(object.position.y / this.translationSnap) * this.translationSnap;
            }

            if (axis.search('Z') !== -1) {
              object.position.z = Math.round(object.position.z / this.translationSnap) * this.translationSnap;
            }

            if (object.parent) {
              object.position.sub(_tempVector.setFromMatrixPosition(object.parent.matrixWorld));
            }
          }
        }
      } else if (mode === 'scale') {
        if (axis.search('XYZ') !== -1) {
          var d = this.pointEnd.length() / this.pointStart.length();
          if (this.pointEnd.dot(this.pointStart) < 0) d *= -1;

          _tempVector2.set(d, d, d);
        } else {
          _tempVector.copy(this.pointStart);

          _tempVector2.copy(this.pointEnd);

          _tempVector.applyQuaternion(this._worldQuaternionInv);

          _tempVector2.applyQuaternion(this._worldQuaternionInv);

          _tempVector2.divide(_tempVector);

          if (axis.search('X') === -1) {
            _tempVector2.x = 1;
          }

          if (axis.search('Y') === -1) {
            _tempVector2.y = 1;
          }

          if (axis.search('Z') === -1) {
            _tempVector2.z = 1;
          }
        } // Apply scale


        object.scale.copy(this._scaleStart).multiply(_tempVector2);

        if (this.scaleSnap) {
          if (axis.search('X') !== -1) {
            object.scale.x = Math.round(object.scale.x / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
          }

          if (axis.search('Y') !== -1) {
            object.scale.y = Math.round(object.scale.y / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
          }

          if (axis.search('Z') !== -1) {
            object.scale.z = Math.round(object.scale.z / this.scaleSnap) * this.scaleSnap || this.scaleSnap;
          }
        }
      } else if (mode === 'rotate') {
        this._offset.copy(this.pointEnd).sub(this.pointStart);

        var ROTATION_SPEED = 20 / this.worldPosition.distanceTo(_tempVector.setFromMatrixPosition(this.camera.matrixWorld));

        if (axis === 'E') {
          this.rotationAxis.copy(this.eye);
          this.rotationAngle = this.pointEnd.angleTo(this.pointStart);

          this._startNorm.copy(this.pointStart).normalize();

          this._endNorm.copy(this.pointEnd).normalize();

          this.rotationAngle *= this._endNorm.cross(this._startNorm).dot(this.eye) < 0 ? 1 : -1;
        } else if (axis === 'XYZE') {
          this.rotationAxis.copy(this._offset).cross(this.eye).normalize();
          this.rotationAngle = this._offset.dot(_tempVector.copy(this.rotationAxis).cross(this.eye)) * ROTATION_SPEED;
        } else if (axis === 'X' || axis === 'Y' || axis === 'Z') {
          this.rotationAxis.copy(_unit[axis]);

          _tempVector.copy(_unit[axis]);

          if (space === 'local') {
            _tempVector.applyQuaternion(this.worldQuaternion);
          }

          this.rotationAngle = this._offset.dot(_tempVector.cross(this.eye).normalize()) * ROTATION_SPEED;
        } // Apply rotation snap


        if (this.rotationSnap) this.rotationAngle = Math.round(this.rotationAngle / this.rotationSnap) * this.rotationSnap; // Apply rotate

        if (space === 'local' && axis !== 'E' && axis !== 'XYZE') {
          object.quaternion.copy(this._quaternionStart);
          object.quaternion.multiply(_tempQuaternion.setFromAxisAngle(this.rotationAxis, this.rotationAngle)).normalize();
        } else {
          this.rotationAxis.applyQuaternion(this._parentQuaternionInv);
          object.quaternion.copy(_tempQuaternion.setFromAxisAngle(this.rotationAxis, this.rotationAngle));
          object.quaternion.multiply(this._quaternionStart).normalize();
        }
      }

      this.dispatchEvent(_changeEvent$1);
      this.dispatchEvent(_objectChangeEvent);
    }
  }, {
    key: "pointerUp",
    value: function pointerUp(pointer) {
      if (pointer.button !== 0) return;

      if (this.dragging && this.axis !== null) {
        _mouseUpEvent.mode = this.mode;
        this.dispatchEvent(_mouseUpEvent);
      }

      this.dragging = false;
      this.axis = null;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.domElement.removeEventListener('pointerdown', this._onPointerDown);
      this.domElement.removeEventListener('pointermove', this._onPointerHover);
      this.domElement.removeEventListener('pointermove', this._onPointerMove);
      this.domElement.removeEventListener('pointerup', this._onPointerUp);
      this.traverse(function (child) {
        if (child.geometry) child.geometry.dispose();
        if (child.material) child.material.dispose();
      });
    } // Set current object

  }, {
    key: "attach",
    value: function attach(object) {
      this.object = object;
      this.visible = true;
      return this;
    } // Detatch from object

  }, {
    key: "detach",
    value: function detach() {
      this.object = undefined;
      this.visible = false;
      this.axis = null;
      return this;
    }
  }, {
    key: "reset",
    value: function reset() {
      if (!this.enabled) return;

      if (this.dragging) {
        this.object.position.copy(this._positionStart);
        this.object.quaternion.copy(this._quaternionStart);
        this.object.scale.copy(this._scaleStart);
        this.dispatchEvent(_changeEvent$1);
        this.dispatchEvent(_objectChangeEvent);
        this.pointStart.copy(this.pointEnd);
      }
    }
  }, {
    key: "getRaycaster",
    value: function getRaycaster() {
      return _raycaster;
    } // TODO: deprecate

  }, {
    key: "getMode",
    value: function getMode() {
      return this.mode;
    }
  }, {
    key: "setMode",
    value: function setMode(mode) {
      this.mode = mode;
    }
  }, {
    key: "setTranslationSnap",
    value: function setTranslationSnap(translationSnap) {
      this.translationSnap = translationSnap;
    }
  }, {
    key: "setRotationSnap",
    value: function setRotationSnap(rotationSnap) {
      this.rotationSnap = rotationSnap;
    }
  }, {
    key: "setScaleSnap",
    value: function setScaleSnap(scaleSnap) {
      this.scaleSnap = scaleSnap;
    }
  }, {
    key: "setSize",
    value: function setSize(size) {
      this.size = size;
    }
  }, {
    key: "setSpace",
    value: function setSpace(space) {
      this.space = space;
    }
  }, {
    key: "update",
    value: function update() {
      console.warn('THREE.TransformControls: update function has no more functionality and therefore has been deprecated.');
    }
  }]);

  return TransformControls;
}(Object3D);

TransformControls.prototype.isTransformControls = true; // mouse / touch event handlers

function getPointer(event) {
  if (this.domElement.ownerDocument.pointerLockElement) {
    return {
      x: 0,
      y: 0,
      button: event.button
    };
  } else {
    var rect = this.domElement.getBoundingClientRect();
    return {
      x: (event.clientX - rect.left) / rect.width * 2 - 1,
      y: -(event.clientY - rect.top) / rect.height * 2 + 1,
      button: event.button
    };
  }
}

function onPointerHover(event) {
  if (!this.enabled) return;

  switch (event.pointerType) {
    case 'mouse':
    case 'pen':
      this.pointerHover(this._getPointer(event));
      break;
  }
}

function onPointerDown(event) {
  if (!this.enabled) return;

  if (!document.pointerLockElement) {
    this.domElement.setPointerCapture(event.pointerId);
  }

  this.domElement.addEventListener('pointermove', this._onPointerMove);
  this.pointerHover(this._getPointer(event));
  this.pointerDown(this._getPointer(event));
}

function onPointerMove(event) {
  if (!this.enabled) return;
  this.pointerMove(this._getPointer(event));
}

function onPointerUp(event) {
  if (!this.enabled) return;
  this.domElement.releasePointerCapture(event.pointerId);
  this.domElement.removeEventListener('pointermove', this._onPointerMove);
  this.pointerUp(this._getPointer(event));
}

function intersectObjectWithRay(object, raycaster, includeInvisible) {
  var allIntersections = raycaster.intersectObject(object, true);

  for (var _i234 = 0; _i234 < allIntersections.length; _i234++) {
    if (allIntersections[_i234].object.visible || includeInvisible) {
      return allIntersections[_i234];
    }
  }

  return false;
} //
// Reusable utility variables


var _tempEuler = new Euler();

var _alignVector = new Vector3(0, 1, 0);

var _zeroVector = new Vector3(0, 0, 0);

var _lookAtMatrix = new Matrix4();

var _tempQuaternion2 = new Quaternion();

var _identityQuaternion = new Quaternion();

var _dirVector = new Vector3();

var _tempMatrix = new Matrix4();

var _unitX = new Vector3(1, 0, 0);

var _unitY = new Vector3(0, 1, 0);

var _unitZ = new Vector3(0, 0, 1);

var _v1 = new Vector3();

var _v2 = new Vector3();

var _v3 = new Vector3();

var TransformControlsGizmo = /*#__PURE__*/function (_Object3D10) {
  _inherits(TransformControlsGizmo, _Object3D10);

  var _super81 = _createSuper(TransformControlsGizmo);

  function TransformControlsGizmo() {
    var _this73;

    _classCallCheck2(this, TransformControlsGizmo);

    _this73 = _super81.call(this);
    _this73.type = 'TransformControlsGizmo'; // shared materials

    var gizmoMaterial = new MeshBasicMaterial({
      depthTest: false,
      depthWrite: false,
      fog: false,
      toneMapped: false,
      transparent: true
    });
    var gizmoLineMaterial = new LineBasicMaterial({
      depthTest: false,
      depthWrite: false,
      fog: false,
      toneMapped: false,
      transparent: true
    }); // Make unique material for each axis/color

    var matInvisible = gizmoMaterial.clone();
    matInvisible.opacity = 0.15;
    var matHelper = gizmoLineMaterial.clone();
    matHelper.opacity = 0.5;
    var matRed = gizmoMaterial.clone();
    matRed.color.setHex(0xff0000);
    var matGreen = gizmoMaterial.clone();
    matGreen.color.setHex(0x00ff00);
    var matBlue = gizmoMaterial.clone();
    matBlue.color.setHex(0x0000ff);
    var matRedTransparent = gizmoMaterial.clone();
    matRedTransparent.color.setHex(0xff0000);
    matRedTransparent.opacity = 0.5;
    var matGreenTransparent = gizmoMaterial.clone();
    matGreenTransparent.color.setHex(0x00ff00);
    matGreenTransparent.opacity = 0.5;
    var matBlueTransparent = gizmoMaterial.clone();
    matBlueTransparent.color.setHex(0x0000ff);
    matBlueTransparent.opacity = 0.5;
    var matWhiteTransparent = gizmoMaterial.clone();
    matWhiteTransparent.opacity = 0.25;
    var matYellowTransparent = gizmoMaterial.clone();
    matYellowTransparent.color.setHex(0xffff00);
    matYellowTransparent.opacity = 0.25;
    var matYellow = gizmoMaterial.clone();
    matYellow.color.setHex(0xffff00);
    var matGray = gizmoMaterial.clone();
    matGray.color.setHex(0x787878); // reusable geometry

    var arrowGeometry = new CylinderGeometry(0, 0.04, 0.1, 12);
    arrowGeometry.translate(0, 0.05, 0);
    var scaleHandleGeometry = new BoxGeometry(0.08, 0.08, 0.08);
    scaleHandleGeometry.translate(0, 0.04, 0);
    var lineGeometry = new BufferGeometry();
    lineGeometry.setAttribute('position', new Float32BufferAttribute([0, 0, 0, 1, 0, 0], 3));
    var lineGeometry2 = new CylinderGeometry(0.0075, 0.0075, 0.5, 3);
    lineGeometry2.translate(0, 0.25, 0);

    function CircleGeometry(radius, arc) {
      var geometry = new TorusGeometry(radius, 0.0075, 3, 64, arc * Math.PI * 2);
      geometry.rotateY(Math.PI / 2);
      geometry.rotateX(Math.PI / 2);
      return geometry;
    } // Special geometry for transform helper. If scaled with position vector it spans from [0,0,0] to position


    function TranslateHelperGeometry() {
      var geometry = new BufferGeometry();
      geometry.setAttribute('position', new Float32BufferAttribute([0, 0, 0, 1, 1, 1], 3));
      return geometry;
    } // Gizmo definitions - custom hierarchy definitions for setupGizmo() function


    var gizmoTranslate = {
      X: [[new Mesh(arrowGeometry, matRed), [0.5, 0, 0], [0, 0, -Math.PI / 2]], [new Mesh(arrowGeometry, matRed), [-0.5, 0, 0], [0, 0, Math.PI / 2]], [new Mesh(lineGeometry2, matRed), [0, 0, 0], [0, 0, -Math.PI / 2]]],
      Y: [[new Mesh(arrowGeometry, matGreen), [0, 0.5, 0]], [new Mesh(arrowGeometry, matGreen), [0, -0.5, 0], [Math.PI, 0, 0]], [new Mesh(lineGeometry2, matGreen)]],
      Z: [[new Mesh(arrowGeometry, matBlue), [0, 0, 0.5], [Math.PI / 2, 0, 0]], [new Mesh(arrowGeometry, matBlue), [0, 0, -0.5], [-Math.PI / 2, 0, 0]], [new Mesh(lineGeometry2, matBlue), null, [Math.PI / 2, 0, 0]]],
      XYZ: [[new Mesh(new OctahedronGeometry(0.1, 0), matWhiteTransparent.clone()), [0, 0, 0]]],
      XY: [[new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matBlueTransparent.clone()), [0.15, 0.15, 0]]],
      YZ: [[new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matRedTransparent.clone()), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]],
      XZ: [[new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matGreenTransparent.clone()), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]]
    };
    var pickerTranslate = {
      X: [[new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0.3, 0, 0], [0, 0, -Math.PI / 2]], [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [-0.3, 0, 0], [0, 0, Math.PI / 2]]],
      Y: [[new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0.3, 0]], [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, -0.3, 0], [0, 0, Math.PI]]],
      Z: [[new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0, 0.3], [Math.PI / 2, 0, 0]], [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0, -0.3], [-Math.PI / 2, 0, 0]]],
      XYZ: [[new Mesh(new OctahedronGeometry(0.2, 0), matInvisible)]],
      XY: [[new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0.15, 0.15, 0]]],
      YZ: [[new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]],
      XZ: [[new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]]
    };
    var helperTranslate = {
      START: [[new Mesh(new OctahedronGeometry(0.01, 2), matHelper), null, null, null, 'helper']],
      END: [[new Mesh(new OctahedronGeometry(0.01, 2), matHelper), null, null, null, 'helper']],
      DELTA: [[new Line(TranslateHelperGeometry(), matHelper), null, null, null, 'helper']],
      X: [[new Line(lineGeometry, matHelper.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], 'helper']],
      Y: [[new Line(lineGeometry, matHelper.clone()), [0, -1e3, 0], [0, 0, Math.PI / 2], [1e6, 1, 1], 'helper']],
      Z: [[new Line(lineGeometry, matHelper.clone()), [0, 0, -1e3], [0, -Math.PI / 2, 0], [1e6, 1, 1], 'helper']]
    };
    var gizmoRotate = {
      XYZE: [[new Mesh(CircleGeometry(0.5, 1), matGray), null, [0, Math.PI / 2, 0]]],
      X: [[new Mesh(CircleGeometry(0.5, 0.5), matRed)]],
      Y: [[new Mesh(CircleGeometry(0.5, 0.5), matGreen), null, [0, 0, -Math.PI / 2]]],
      Z: [[new Mesh(CircleGeometry(0.5, 0.5), matBlue), null, [0, Math.PI / 2, 0]]],
      E: [[new Mesh(CircleGeometry(0.75, 1), matYellowTransparent), null, [0, Math.PI / 2, 0]]]
    };
    var helperRotate = {
      AXIS: [[new Line(lineGeometry, matHelper.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], 'helper']]
    };
    var pickerRotate = {
      XYZE: [[new Mesh(new SphereGeometry(0.25, 10, 8), matInvisible)]],
      X: [[new Mesh(new TorusGeometry(0.5, 0.1, 4, 24), matInvisible), [0, 0, 0], [0, -Math.PI / 2, -Math.PI / 2]]],
      Y: [[new Mesh(new TorusGeometry(0.5, 0.1, 4, 24), matInvisible), [0, 0, 0], [Math.PI / 2, 0, 0]]],
      Z: [[new Mesh(new TorusGeometry(0.5, 0.1, 4, 24), matInvisible), [0, 0, 0], [0, 0, -Math.PI / 2]]],
      E: [[new Mesh(new TorusGeometry(0.75, 0.1, 2, 24), matInvisible)]]
    };
    var gizmoScale = {
      X: [[new Mesh(scaleHandleGeometry, matRed), [0.5, 0, 0], [0, 0, -Math.PI / 2]], [new Mesh(lineGeometry2, matRed), [0, 0, 0], [0, 0, -Math.PI / 2]], [new Mesh(scaleHandleGeometry, matRed), [-0.5, 0, 0], [0, 0, Math.PI / 2]]],
      Y: [[new Mesh(scaleHandleGeometry, matGreen), [0, 0.5, 0]], [new Mesh(lineGeometry2, matGreen)], [new Mesh(scaleHandleGeometry, matGreen), [0, -0.5, 0], [0, 0, Math.PI]]],
      Z: [[new Mesh(scaleHandleGeometry, matBlue), [0, 0, 0.5], [Math.PI / 2, 0, 0]], [new Mesh(lineGeometry2, matBlue), [0, 0, 0], [Math.PI / 2, 0, 0]], [new Mesh(scaleHandleGeometry, matBlue), [0, 0, -0.5], [-Math.PI / 2, 0, 0]]],
      XY: [[new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matBlueTransparent), [0.15, 0.15, 0]]],
      YZ: [[new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matRedTransparent), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]],
      XZ: [[new Mesh(new BoxGeometry(0.15, 0.15, 0.01), matGreenTransparent), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]],
      XYZ: [[new Mesh(new BoxGeometry(0.1, 0.1, 0.1), matWhiteTransparent.clone())]]
    };
    var pickerScale = {
      X: [[new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0.3, 0, 0], [0, 0, -Math.PI / 2]], [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [-0.3, 0, 0], [0, 0, Math.PI / 2]]],
      Y: [[new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0.3, 0]], [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, -0.3, 0], [0, 0, Math.PI]]],
      Z: [[new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0, 0.3], [Math.PI / 2, 0, 0]], [new Mesh(new CylinderGeometry(0.2, 0, 0.6, 4), matInvisible), [0, 0, -0.3], [-Math.PI / 2, 0, 0]]],
      XY: [[new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0.15, 0.15, 0]]],
      YZ: [[new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0, 0.15, 0.15], [0, Math.PI / 2, 0]]],
      XZ: [[new Mesh(new BoxGeometry(0.2, 0.2, 0.01), matInvisible), [0.15, 0, 0.15], [-Math.PI / 2, 0, 0]]],
      XYZ: [[new Mesh(new BoxGeometry(0.2, 0.2, 0.2), matInvisible), [0, 0, 0]]]
    };
    var helperScale = {
      X: [[new Line(lineGeometry, matHelper.clone()), [-1e3, 0, 0], null, [1e6, 1, 1], 'helper']],
      Y: [[new Line(lineGeometry, matHelper.clone()), [0, -1e3, 0], [0, 0, Math.PI / 2], [1e6, 1, 1], 'helper']],
      Z: [[new Line(lineGeometry, matHelper.clone()), [0, 0, -1e3], [0, -Math.PI / 2, 0], [1e6, 1, 1], 'helper']]
    }; // Creates an Object3D with gizmos described in custom hierarchy definition.

    function setupGizmo(gizmoMap) {
      var gizmo = new Object3D();

      for (var name in gizmoMap) {
        for (var _i235 = gizmoMap[name].length; _i235--;) {
          var object = gizmoMap[name][_i235][0].clone();

          var position = gizmoMap[name][_i235][1];
          var rotation = gizmoMap[name][_i235][2];
          var scale = gizmoMap[name][_i235][3];
          var tag = gizmoMap[name][_i235][4]; // name and tag properties are essential for picking and updating logic.

          object.name = name;
          object.tag = tag;

          if (position) {
            object.position.set(position[0], position[1], position[2]);
          }

          if (rotation) {
            object.rotation.set(rotation[0], rotation[1], rotation[2]);
          }

          if (scale) {
            object.scale.set(scale[0], scale[1], scale[2]);
          }

          object.updateMatrix();
          var tempGeometry = object.geometry.clone();
          tempGeometry.applyMatrix4(object.matrix);
          object.geometry = tempGeometry;
          object.renderOrder = Infinity;
          object.position.set(0, 0, 0);
          object.rotation.set(0, 0, 0);
          object.scale.set(1, 1, 1);
          gizmo.add(object);
        }
      }

      return gizmo;
    } // Gizmo creation


    _this73.gizmo = {};
    _this73.picker = {};
    _this73.helper = {};

    _this73.add(_this73.gizmo['translate'] = setupGizmo(gizmoTranslate));

    _this73.add(_this73.gizmo['rotate'] = setupGizmo(gizmoRotate));

    _this73.add(_this73.gizmo['scale'] = setupGizmo(gizmoScale));

    _this73.add(_this73.picker['translate'] = setupGizmo(pickerTranslate));

    _this73.add(_this73.picker['rotate'] = setupGizmo(pickerRotate));

    _this73.add(_this73.picker['scale'] = setupGizmo(pickerScale));

    _this73.add(_this73.helper['translate'] = setupGizmo(helperTranslate));

    _this73.add(_this73.helper['rotate'] = setupGizmo(helperRotate));

    _this73.add(_this73.helper['scale'] = setupGizmo(helperScale)); // Pickers should be hidden always


    _this73.picker['translate'].visible = false;
    _this73.picker['rotate'].visible = false;
    _this73.picker['scale'].visible = false;
    return _this73;
  } // updateMatrixWorld will update transformations and appearance of individual handles


  _createClass2(TransformControlsGizmo, [{
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(force) {
      var _this74 = this;

      var space = this.mode === 'scale' ? 'local' : this.space; // scale always oriented to local rotation

      var quaternion = space === 'local' ? this.worldQuaternion : _identityQuaternion; // Show only gizmos for current transform mode

      this.gizmo['translate'].visible = this.mode === 'translate';
      this.gizmo['rotate'].visible = this.mode === 'rotate';
      this.gizmo['scale'].visible = this.mode === 'scale';
      this.helper['translate'].visible = this.mode === 'translate';
      this.helper['rotate'].visible = this.mode === 'rotate';
      this.helper['scale'].visible = this.mode === 'scale';
      var handles = [];
      handles = handles.concat(this.picker[this.mode].children);
      handles = handles.concat(this.gizmo[this.mode].children);
      handles = handles.concat(this.helper[this.mode].children);

      var _loop = function _loop(_i236) {
        var handle = handles[_i236]; // hide aligned to camera

        handle.visible = true;
        handle.rotation.set(0, 0, 0);
        handle.position.copy(_this74.worldPosition);
        var factor = void 0;

        if (_this74.camera.isOrthographicCamera) {
          factor = (_this74.camera.top - _this74.camera.bottom) / _this74.camera.zoom;
        } else {
          factor = _this74.worldPosition.distanceTo(_this74.cameraPosition) * Math.min(1.9 * Math.tan(Math.PI * _this74.camera.fov / 360) / _this74.camera.zoom, 7);
        }

        handle.scale.set(1, 1, 1).multiplyScalar(factor * _this74.size / 4); // TODO: simplify helpers and consider decoupling from gizmo

        if (handle.tag === 'helper') {
          handle.visible = false;

          if (handle.name === 'AXIS') {
            handle.position.copy(_this74.worldPositionStart);
            handle.visible = !!_this74.axis;

            if (_this74.axis === 'X') {
              _tempQuaternion.setFromEuler(_tempEuler.set(0, 0, 0));

              handle.quaternion.copy(quaternion).multiply(_tempQuaternion);

              if (Math.abs(_alignVector.copy(_unitX).applyQuaternion(quaternion).dot(_this74.eye)) > 0.9) {
                handle.visible = false;
              }
            }

            if (_this74.axis === 'Y') {
              _tempQuaternion.setFromEuler(_tempEuler.set(0, 0, Math.PI / 2));

              handle.quaternion.copy(quaternion).multiply(_tempQuaternion);

              if (Math.abs(_alignVector.copy(_unitY).applyQuaternion(quaternion).dot(_this74.eye)) > 0.9) {
                handle.visible = false;
              }
            }

            if (_this74.axis === 'Z') {
              _tempQuaternion.setFromEuler(_tempEuler.set(0, Math.PI / 2, 0));

              handle.quaternion.copy(quaternion).multiply(_tempQuaternion);

              if (Math.abs(_alignVector.copy(_unitZ).applyQuaternion(quaternion).dot(_this74.eye)) > 0.9) {
                handle.visible = false;
              }
            }

            if (_this74.axis === 'XYZE') {
              _tempQuaternion.setFromEuler(_tempEuler.set(0, Math.PI / 2, 0));

              _alignVector.copy(_this74.rotationAxis);

              handle.quaternion.setFromRotationMatrix(_lookAtMatrix.lookAt(_zeroVector, _alignVector, _unitY));
              handle.quaternion.multiply(_tempQuaternion);
              handle.visible = _this74.dragging;
            }

            if (_this74.axis === 'E') {
              handle.visible = false;
            }
          } else if (handle.name === 'START') {
            handle.position.copy(_this74.worldPositionStart);
            handle.visible = _this74.dragging;
          } else if (handle.name === 'END') {
            handle.position.copy(_this74.worldPosition);
            handle.visible = _this74.dragging;
          } else if (handle.name === 'DELTA') {
            handle.position.copy(_this74.worldPositionStart);
            handle.quaternion.copy(_this74.worldQuaternionStart);

            _tempVector.set(1e-10, 1e-10, 1e-10).add(_this74.worldPositionStart).sub(_this74.worldPosition).multiplyScalar(-1);

            _tempVector.applyQuaternion(_this74.worldQuaternionStart.clone().invert());

            handle.scale.copy(_tempVector);
            handle.visible = _this74.dragging;
          } else {
            handle.quaternion.copy(quaternion);

            if (_this74.dragging) {
              handle.position.copy(_this74.worldPositionStart);
            } else {
              handle.position.copy(_this74.worldPosition);
            }

            if (_this74.axis) {
              handle.visible = _this74.axis.search(handle.name) !== -1;
            }
          } // If updating helper, skip rest of the loop


          return "continue";
        } // Align handles to current local or world rotation


        handle.quaternion.copy(quaternion);

        if (_this74.mode === 'translate' || _this74.mode === 'scale') {
          // Hide translate and scale axis facing the camera
          var AXIS_HIDE_TRESHOLD = 0.99;
          var PLANE_HIDE_TRESHOLD = 0.2;

          if (handle.name === 'X') {
            if (Math.abs(_alignVector.copy(_unitX).applyQuaternion(quaternion).dot(_this74.eye)) > AXIS_HIDE_TRESHOLD) {
              handle.scale.set(1e-10, 1e-10, 1e-10);
              handle.visible = false;
            }
          }

          if (handle.name === 'Y') {
            if (Math.abs(_alignVector.copy(_unitY).applyQuaternion(quaternion).dot(_this74.eye)) > AXIS_HIDE_TRESHOLD) {
              handle.scale.set(1e-10, 1e-10, 1e-10);
              handle.visible = false;
            }
          }

          if (handle.name === 'Z') {
            if (Math.abs(_alignVector.copy(_unitZ).applyQuaternion(quaternion).dot(_this74.eye)) > AXIS_HIDE_TRESHOLD) {
              handle.scale.set(1e-10, 1e-10, 1e-10);
              handle.visible = false;
            }
          }

          if (handle.name === 'XY') {
            if (Math.abs(_alignVector.copy(_unitZ).applyQuaternion(quaternion).dot(_this74.eye)) < PLANE_HIDE_TRESHOLD) {
              handle.scale.set(1e-10, 1e-10, 1e-10);
              handle.visible = false;
            }
          }

          if (handle.name === 'YZ') {
            if (Math.abs(_alignVector.copy(_unitX).applyQuaternion(quaternion).dot(_this74.eye)) < PLANE_HIDE_TRESHOLD) {
              handle.scale.set(1e-10, 1e-10, 1e-10);
              handle.visible = false;
            }
          }

          if (handle.name === 'XZ') {
            if (Math.abs(_alignVector.copy(_unitY).applyQuaternion(quaternion).dot(_this74.eye)) < PLANE_HIDE_TRESHOLD) {
              handle.scale.set(1e-10, 1e-10, 1e-10);
              handle.visible = false;
            }
          }
        } else if (_this74.mode === 'rotate') {
          // Align handles to current local or world rotation
          _tempQuaternion2.copy(quaternion);

          _alignVector.copy(_this74.eye).applyQuaternion(_tempQuaternion.copy(quaternion).invert());

          if (handle.name.search('E') !== -1) {
            handle.quaternion.setFromRotationMatrix(_lookAtMatrix.lookAt(_this74.eye, _zeroVector, _unitY));
          }

          if (handle.name === 'X') {
            _tempQuaternion.setFromAxisAngle(_unitX, Math.atan2(-_alignVector.y, _alignVector.z));

            _tempQuaternion.multiplyQuaternions(_tempQuaternion2, _tempQuaternion);

            handle.quaternion.copy(_tempQuaternion);
          }

          if (handle.name === 'Y') {
            _tempQuaternion.setFromAxisAngle(_unitY, Math.atan2(_alignVector.x, _alignVector.z));

            _tempQuaternion.multiplyQuaternions(_tempQuaternion2, _tempQuaternion);

            handle.quaternion.copy(_tempQuaternion);
          }

          if (handle.name === 'Z') {
            _tempQuaternion.setFromAxisAngle(_unitZ, Math.atan2(_alignVector.y, _alignVector.x));

            _tempQuaternion.multiplyQuaternions(_tempQuaternion2, _tempQuaternion);

            handle.quaternion.copy(_tempQuaternion);
          }
        } // Hide disabled axes


        handle.visible = handle.visible && (handle.name.indexOf('X') === -1 || _this74.showX);
        handle.visible = handle.visible && (handle.name.indexOf('Y') === -1 || _this74.showY);
        handle.visible = handle.visible && (handle.name.indexOf('Z') === -1 || _this74.showZ);
        handle.visible = handle.visible && (handle.name.indexOf('E') === -1 || _this74.showX && _this74.showY && _this74.showZ); // highlight selected axis

        handle.material._color = handle.material._color || handle.material.color.clone();
        handle.material._opacity = handle.material._opacity || handle.material.opacity;
        handle.material.color.copy(handle.material._color);
        handle.material.opacity = handle.material._opacity;

        if (_this74.enabled && _this74.axis) {
          if (handle.name === _this74.axis) {
            handle.material.color.setHex(0xffff00);
            handle.material.opacity = 1.0;
          } else if (_this74.axis.split('').some(function (a) {
            return handle.name === a;
          })) {
            handle.material.color.setHex(0xffff00);
            handle.material.opacity = 1.0;
          }
        }
      };

      for (var _i236 = 0; _i236 < handles.length; _i236++) {
        var _ret = _loop(_i236);

        if (_ret === "continue") continue;
      }

      _get(_getPrototypeOf(TransformControlsGizmo.prototype), "updateMatrixWorld", this).call(this, force);
    }
  }]);

  return TransformControlsGizmo;
}(Object3D);

TransformControlsGizmo.prototype.isTransformControlsGizmo = true; //

var TransformControlsPlane = /*#__PURE__*/function (_Mesh) {
  _inherits(TransformControlsPlane, _Mesh);

  var _super82 = _createSuper(TransformControlsPlane);

  function TransformControlsPlane() {
    var _this75;

    _classCallCheck2(this, TransformControlsPlane);

    _this75 = _super82.call(this, new PlaneGeometry(100000, 100000, 2, 2), new MeshBasicMaterial({
      visible: false,
      wireframe: true,
      side: DoubleSide,
      transparent: true,
      opacity: 0.1,
      toneMapped: false
    }));
    _this75.type = 'TransformControlsPlane';
    return _this75;
  }

  _createClass2(TransformControlsPlane, [{
    key: "updateMatrixWorld",
    value: function updateMatrixWorld(force) {
      var space = this.space;
      this.position.copy(this.worldPosition);
      if (this.mode === 'scale') space = 'local'; // scale always oriented to local rotation

      _v1.copy(_unitX).applyQuaternion(space === 'local' ? this.worldQuaternion : _identityQuaternion);

      _v2.copy(_unitY).applyQuaternion(space === 'local' ? this.worldQuaternion : _identityQuaternion);

      _v3.copy(_unitZ).applyQuaternion(space === 'local' ? this.worldQuaternion : _identityQuaternion); // Align the plane for current transform mode, axis and space.


      _alignVector.copy(_v2);

      switch (this.mode) {
        case 'translate':
        case 'scale':
          switch (this.axis) {
            case 'X':
              _alignVector.copy(this.eye).cross(_v1);

              _dirVector.copy(_v1).cross(_alignVector);

              break;

            case 'Y':
              _alignVector.copy(this.eye).cross(_v2);

              _dirVector.copy(_v2).cross(_alignVector);

              break;

            case 'Z':
              _alignVector.copy(this.eye).cross(_v3);

              _dirVector.copy(_v3).cross(_alignVector);

              break;

            case 'XY':
              _dirVector.copy(_v3);

              break;

            case 'YZ':
              _dirVector.copy(_v1);

              break;

            case 'XZ':
              _alignVector.copy(_v3);

              _dirVector.copy(_v2);

              break;

            case 'XYZ':
            case 'E':
              _dirVector.set(0, 0, 0);

              break;
          }

          break;

        case 'rotate':
        default:
          // special case for rotate
          _dirVector.set(0, 0, 0);

      }

      if (_dirVector.length() === 0) {
        // If in rotate mode, make the plane parallel to camera
        this.quaternion.copy(this.cameraQuaternion);
      } else {
        _tempMatrix.lookAt(_tempVector.set(0, 0, 0), _dirVector, _alignVector);

        this.quaternion.setFromRotationMatrix(_tempMatrix);
      }

      _get(_getPrototypeOf(TransformControlsPlane.prototype), "updateMatrixWorld", this).call(this, force);
    }
  }]);

  return TransformControlsPlane;
}(Mesh);

TransformControlsPlane.prototype.isTransformControlsPlane = true;
/**
 * Full-screen textured quad shader
 */

var CopyShader = {
  uniforms: {
    'tDiffuse': {
      value: null
    },
    'opacity': {
      value: 1.0
    }
  },
  vertexShader:
  /* glsl */
  "\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tvUv = uv;\n\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\n\t\t}",
  fragmentShader:
  /* glsl */
  "\n\n\t\tuniform float opacity;\n\n\t\tuniform sampler2D tDiffuse;\n\n\t\tvarying vec2 vUv;\n\n\t\tvoid main() {\n\n\t\t\tgl_FragColor = texture2D( tDiffuse, vUv );\n\t\t\tgl_FragColor.a *= opacity;\n\n\n\t\t}"
};

var Pass = /*#__PURE__*/function () {
  function Pass() {
    _classCallCheck2(this, Pass);

    // if set to true, the pass is processed by the composer
    this.enabled = true; // if set to true, the pass indicates to swap read and write buffer after rendering

    this.needsSwap = true; // if set to true, the pass clears its buffer before rendering

    this.clear = false; // if set to true, the result of the pass is rendered to screen. This is set automatically by EffectComposer.

    this.renderToScreen = false;
  }

  _createClass2(Pass, [{
    key: "setSize",
    value: function
      /* width, height */
    setSize() {}
  }, {
    key: "render",
    value: function
      /* renderer, writeBuffer, readBuffer, deltaTime, maskActive */
    render() {
      console.error('THREE.Pass: .render() must be implemented in derived pass.');
    }
  }]);

  return Pass;
}(); // Helper for passes that need to fill the viewport with a single quad.


var _camera = new OrthographicCamera(-1, 1, 1, -1, 0, 1); // https://github.com/mrdoob/three.js/pull/21358


var _geometry = new BufferGeometry();

_geometry.setAttribute('position', new Float32BufferAttribute([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3));

_geometry.setAttribute('uv', new Float32BufferAttribute([0, 2, 0, 0, 2, 0], 2));

var FullScreenQuad = /*#__PURE__*/function () {
  function FullScreenQuad(material) {
    _classCallCheck2(this, FullScreenQuad);

    this._mesh = new Mesh(_geometry, material);
  }

  _createClass2(FullScreenQuad, [{
    key: "dispose",
    value: function dispose() {
      this._mesh.geometry.dispose();
    }
  }, {
    key: "render",
    value: function render(renderer) {
      renderer.render(this._mesh, _camera);
    }
  }, {
    key: "material",
    get: function get() {
      return this._mesh.material;
    },
    set: function set(value) {
      this._mesh.material = value;
    }
  }]);

  return FullScreenQuad;
}();

var ShaderPass = /*#__PURE__*/function (_Pass) {
  _inherits(ShaderPass, _Pass);

  var _super83 = _createSuper(ShaderPass);

  function ShaderPass(shader, textureID) {
    var _this76;

    _classCallCheck2(this, ShaderPass);

    _this76 = _super83.call(this);
    _this76.textureID = textureID !== undefined ? textureID : 'tDiffuse';

    if (shader instanceof ShaderMaterial) {
      _this76.uniforms = shader.uniforms;
      _this76.material = shader;
    } else if (shader) {
      _this76.uniforms = UniformsUtils.clone(shader.uniforms);
      _this76.material = new ShaderMaterial({
        defines: Object.assign({}, shader.defines),
        uniforms: _this76.uniforms,
        vertexShader: shader.vertexShader,
        fragmentShader: shader.fragmentShader
      });
    }

    _this76.fsQuad = new FullScreenQuad(_this76.material);
    return _this76;
  }

  _createClass2(ShaderPass, [{
    key: "render",
    value: function render(renderer, writeBuffer, readBuffer
    /*, deltaTime, maskActive */
    ) {
      if (this.uniforms[this.textureID]) {
        this.uniforms[this.textureID].value = readBuffer.texture;
      }

      this.fsQuad.material = this.material;

      if (this.renderToScreen) {
        renderer.setRenderTarget(null);
        this.fsQuad.render(renderer);
      } else {
        renderer.setRenderTarget(writeBuffer); // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600

        if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        this.fsQuad.render(renderer);
      }
    }
  }]);

  return ShaderPass;
}(Pass);

var MaskPass = /*#__PURE__*/function (_Pass2) {
  _inherits(MaskPass, _Pass2);

  var _super84 = _createSuper(MaskPass);

  function MaskPass(scene, camera) {
    var _this77;

    _classCallCheck2(this, MaskPass);

    _this77 = _super84.call(this);
    _this77.scene = scene;
    _this77.camera = camera;
    _this77.clear = true;
    _this77.needsSwap = false;
    _this77.inverse = false;
    return _this77;
  }

  _createClass2(MaskPass, [{
    key: "render",
    value: function render(renderer, writeBuffer, readBuffer
    /*, deltaTime, maskActive */
    ) {
      var context = renderer.getContext();
      var state = renderer.state; // don't update color or depth

      state.buffers.color.setMask(false);
      state.buffers.depth.setMask(false); // lock buffers

      state.buffers.color.setLocked(true);
      state.buffers.depth.setLocked(true); // set up stencil

      var writeValue, clearValue;

      if (this.inverse) {
        writeValue = 0;
        clearValue = 1;
      } else {
        writeValue = 1;
        clearValue = 0;
      }

      state.buffers.stencil.setTest(true);
      state.buffers.stencil.setOp(context.REPLACE, context.REPLACE, context.REPLACE);
      state.buffers.stencil.setFunc(context.ALWAYS, writeValue, 0xffffffff);
      state.buffers.stencil.setClear(clearValue);
      state.buffers.stencil.setLocked(true); // draw into the stencil buffer

      renderer.setRenderTarget(readBuffer);
      if (this.clear) renderer.clear();
      renderer.render(this.scene, this.camera);
      renderer.setRenderTarget(writeBuffer);
      if (this.clear) renderer.clear();
      renderer.render(this.scene, this.camera); // unlock color and depth buffer for subsequent rendering

      state.buffers.color.setLocked(false);
      state.buffers.depth.setLocked(false); // only render where stencil is set to 1

      state.buffers.stencil.setLocked(false);
      state.buffers.stencil.setFunc(context.EQUAL, 1, 0xffffffff); // draw if == 1

      state.buffers.stencil.setOp(context.KEEP, context.KEEP, context.KEEP);
      state.buffers.stencil.setLocked(true);
    }
  }]);

  return MaskPass;
}(Pass);

var ClearMaskPass = /*#__PURE__*/function (_Pass3) {
  _inherits(ClearMaskPass, _Pass3);

  var _super85 = _createSuper(ClearMaskPass);

  function ClearMaskPass() {
    var _this78;

    _classCallCheck2(this, ClearMaskPass);

    _this78 = _super85.call(this);
    _this78.needsSwap = false;
    return _this78;
  }

  _createClass2(ClearMaskPass, [{
    key: "render",
    value: function render(renderer
    /*, writeBuffer, readBuffer, deltaTime, maskActive */
    ) {
      renderer.state.buffers.stencil.setLocked(false);
      renderer.state.buffers.stencil.setTest(false);
    }
  }]);

  return ClearMaskPass;
}(Pass);

var EffectComposer = /*#__PURE__*/function () {
  function EffectComposer(renderer, renderTarget) {
    _classCallCheck2(this, EffectComposer);

    this.renderer = renderer;

    if (renderTarget === undefined) {
      var size = renderer.getSize(new Vector2());
      this._pixelRatio = renderer.getPixelRatio();
      this._width = size.width;
      this._height = size.height;
      renderTarget = new WebGLRenderTarget(this._width * this._pixelRatio, this._height * this._pixelRatio);
      renderTarget.texture.name = 'EffectComposer.rt1';
    } else {
      this._pixelRatio = 1;
      this._width = renderTarget.width;
      this._height = renderTarget.height;
    }

    this.renderTarget1 = renderTarget;
    this.renderTarget2 = renderTarget.clone();
    this.renderTarget2.texture.name = 'EffectComposer.rt2';
    this.writeBuffer = this.renderTarget1;
    this.readBuffer = this.renderTarget2;
    this.renderToScreen = true;
    this.passes = []; // dependencies

    if (CopyShader === undefined) {
      console.error('THREE.EffectComposer relies on CopyShader');
    }

    if (ShaderPass === undefined) {
      console.error('THREE.EffectComposer relies on ShaderPass');
    }

    this.copyPass = new ShaderPass(CopyShader);
    this.clock = new Clock();
  }

  _createClass2(EffectComposer, [{
    key: "swapBuffers",
    value: function swapBuffers() {
      var tmp = this.readBuffer;
      this.readBuffer = this.writeBuffer;
      this.writeBuffer = tmp;
    }
  }, {
    key: "addPass",
    value: function addPass(pass) {
      this.passes.push(pass);
      pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
  }, {
    key: "insertPass",
    value: function insertPass(pass, index) {
      this.passes.splice(index, 0, pass);
      pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
  }, {
    key: "removePass",
    value: function removePass(pass) {
      var index = this.passes.indexOf(pass);

      if (index !== -1) {
        this.passes.splice(index, 1);
      }
    }
  }, {
    key: "isLastEnabledPass",
    value: function isLastEnabledPass(passIndex) {
      for (var _i237 = passIndex + 1; _i237 < this.passes.length; _i237++) {
        if (this.passes[_i237].enabled) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "render",
    value: function render(deltaTime) {
      // deltaTime value is in seconds
      if (deltaTime === undefined) {
        deltaTime = this.clock.getDelta();
      }

      var currentRenderTarget = this.renderer.getRenderTarget();
      var maskActive = false;

      for (var _i238 = 0, il = this.passes.length; _i238 < il; _i238++) {
        var pass = this.passes[_i238];
        if (pass.enabled === false) continue;
        pass.renderToScreen = this.renderToScreen && this.isLastEnabledPass(_i238);
        pass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime, maskActive);

        if (pass.needsSwap) {
          if (maskActive) {
            var context = this.renderer.getContext();
            var stencil = this.renderer.state.buffers.stencil; //context.stencilFunc( context.NOTEQUAL, 1, 0xffffffff );

            stencil.setFunc(context.NOTEQUAL, 1, 0xffffffff);
            this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime); //context.stencilFunc( context.EQUAL, 1, 0xffffffff );

            stencil.setFunc(context.EQUAL, 1, 0xffffffff);
          }

          this.swapBuffers();
        }

        if (MaskPass !== undefined) {
          if (pass instanceof MaskPass) {
            maskActive = true;
          } else if (pass instanceof ClearMaskPass) {
            maskActive = false;
          }
        }
      }

      this.renderer.setRenderTarget(currentRenderTarget);
    }
  }, {
    key: "reset",
    value: function reset(renderTarget) {
      if (renderTarget === undefined) {
        var size = this.renderer.getSize(new Vector2());
        this._pixelRatio = this.renderer.getPixelRatio();
        this._width = size.width;
        this._height = size.height;
        renderTarget = this.renderTarget1.clone();
        renderTarget.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
      }

      this.renderTarget1.dispose();
      this.renderTarget2.dispose();
      this.renderTarget1 = renderTarget;
      this.renderTarget2 = renderTarget.clone();
      this.writeBuffer = this.renderTarget1;
      this.readBuffer = this.renderTarget2;
    }
  }, {
    key: "setSize",
    value: function setSize(width, height) {
      this._width = width;
      this._height = height;
      var effectiveWidth = this._width * this._pixelRatio;
      var effectiveHeight = this._height * this._pixelRatio;
      this.renderTarget1.setSize(effectiveWidth, effectiveHeight);
      this.renderTarget2.setSize(effectiveWidth, effectiveHeight);

      for (var _i239 = 0; _i239 < this.passes.length; _i239++) {
        this.passes[_i239].setSize(effectiveWidth, effectiveHeight);
      }
    }
  }, {
    key: "setPixelRatio",
    value: function setPixelRatio(pixelRatio) {
      this._pixelRatio = pixelRatio;
      this.setSize(this._width, this._height);
    }
  }]);

  return EffectComposer;
}(); // Helper for passes that need to fill the viewport with a single quad.


new OrthographicCamera(-1, 1, 1, -1, 0, 1); // https://github.com/mrdoob/three.js/pull/21358

var _geometry$1 = new BufferGeometry();

_geometry$1.setAttribute('position', new Float32BufferAttribute([-1, 3, 0, -1, -1, 0, 3, -1, 0], 3));

_geometry$1.setAttribute('uv', new Float32BufferAttribute([0, 2, 0, 0, 2, 0], 2));

var OutlinePass = /*#__PURE__*/function (_Pass4) {
  _inherits(OutlinePass, _Pass4);

  var _super86 = _createSuper(OutlinePass);

  function OutlinePass(resolution, scene, camera, selectedObjects) {
    var _this79;

    _classCallCheck2(this, OutlinePass);

    _this79 = _super86.call(this);
    _this79.renderScene = scene;
    _this79.renderCamera = camera;
    _this79.selectedObjects = selectedObjects !== undefined ? selectedObjects : [];
    _this79.visibleEdgeColor = new Color(1, 1, 1);
    _this79.hiddenEdgeColor = new Color(0.1, 0.04, 0.02);
    _this79.edgeGlow = 0.0;
    _this79.usePatternTexture = false;
    _this79.edgeThickness = 1.0;
    _this79.edgeStrength = 3.0;
    _this79.downSampleRatio = 2;
    _this79.pulsePeriod = 0;
    _this79._visibilityCache = new Map();
    _this79.resolution = resolution !== undefined ? new Vector2(resolution.x, resolution.y) : new Vector2(256, 256);
    var resx = Math.round(_this79.resolution.x / _this79.downSampleRatio);
    var resy = Math.round(_this79.resolution.y / _this79.downSampleRatio);
    _this79.renderTargetMaskBuffer = new WebGLRenderTarget(_this79.resolution.x, _this79.resolution.y);
    _this79.renderTargetMaskBuffer.texture.name = 'OutlinePass.mask';
    _this79.renderTargetMaskBuffer.texture.generateMipmaps = false;
    _this79.depthMaterial = new MeshDepthMaterial();
    _this79.depthMaterial.side = DoubleSide;
    _this79.depthMaterial.depthPacking = RGBADepthPacking;
    _this79.depthMaterial.blending = NoBlending;
    _this79.prepareMaskMaterial = _this79.getPrepareMaskMaterial();
    _this79.prepareMaskMaterial.side = DoubleSide;
    _this79.prepareMaskMaterial.fragmentShader = replaceDepthToViewZ(_this79.prepareMaskMaterial.fragmentShader, _this79.renderCamera);
    _this79.renderTargetDepthBuffer = new WebGLRenderTarget(_this79.resolution.x, _this79.resolution.y);
    _this79.renderTargetDepthBuffer.texture.name = 'OutlinePass.depth';
    _this79.renderTargetDepthBuffer.texture.generateMipmaps = false;
    _this79.renderTargetMaskDownSampleBuffer = new WebGLRenderTarget(resx, resy);
    _this79.renderTargetMaskDownSampleBuffer.texture.name = 'OutlinePass.depthDownSample';
    _this79.renderTargetMaskDownSampleBuffer.texture.generateMipmaps = false;
    _this79.renderTargetBlurBuffer1 = new WebGLRenderTarget(resx, resy);
    _this79.renderTargetBlurBuffer1.texture.name = 'OutlinePass.blur1';
    _this79.renderTargetBlurBuffer1.texture.generateMipmaps = false;
    _this79.renderTargetBlurBuffer2 = new WebGLRenderTarget(Math.round(resx / 2), Math.round(resy / 2));
    _this79.renderTargetBlurBuffer2.texture.name = 'OutlinePass.blur2';
    _this79.renderTargetBlurBuffer2.texture.generateMipmaps = false;
    _this79.edgeDetectionMaterial = _this79.getEdgeDetectionMaterial();
    _this79.renderTargetEdgeBuffer1 = new WebGLRenderTarget(resx, resy);
    _this79.renderTargetEdgeBuffer1.texture.name = 'OutlinePass.edge1';
    _this79.renderTargetEdgeBuffer1.texture.generateMipmaps = false;
    _this79.renderTargetEdgeBuffer2 = new WebGLRenderTarget(Math.round(resx / 2), Math.round(resy / 2));
    _this79.renderTargetEdgeBuffer2.texture.name = 'OutlinePass.edge2';
    _this79.renderTargetEdgeBuffer2.texture.generateMipmaps = false;
    var MAX_EDGE_THICKNESS = 4;
    var MAX_EDGE_GLOW = 4;
    _this79.separableBlurMaterial1 = _this79.getSeperableBlurMaterial(MAX_EDGE_THICKNESS);

    _this79.separableBlurMaterial1.uniforms['texSize'].value.set(resx, resy);

    _this79.separableBlurMaterial1.uniforms['kernelRadius'].value = 1;
    _this79.separableBlurMaterial2 = _this79.getSeperableBlurMaterial(MAX_EDGE_GLOW);

    _this79.separableBlurMaterial2.uniforms['texSize'].value.set(Math.round(resx / 2), Math.round(resy / 2));

    _this79.separableBlurMaterial2.uniforms['kernelRadius'].value = MAX_EDGE_GLOW; // Overlay material

    _this79.overlayMaterial = _this79.getOverlayMaterial(); // copy material

    if (CopyShader === undefined) console.error('THREE.OutlinePass relies on CopyShader');
    var copyShader = CopyShader;
    _this79.copyUniforms = UniformsUtils.clone(copyShader.uniforms);
    _this79.copyUniforms['opacity'].value = 1.0;
    _this79.materialCopy = new ShaderMaterial({
      uniforms: _this79.copyUniforms,
      vertexShader: copyShader.vertexShader,
      fragmentShader: copyShader.fragmentShader,
      blending: NoBlending,
      depthTest: false,
      depthWrite: false,
      transparent: true
    });
    _this79.enabled = true;
    _this79.needsSwap = false;
    _this79._oldClearColor = new Color();
    _this79.oldClearAlpha = 1;
    _this79.fsQuad = new FullScreenQuad(null);
    _this79.tempPulseColor1 = new Color();
    _this79.tempPulseColor2 = new Color();
    _this79.textureMatrix = new Matrix4();

    function replaceDepthToViewZ(string, camera) {
      var type = camera.isPerspectiveCamera ? 'perspective' : 'orthographic';
      return string.replace(/DEPTH_TO_VIEW_Z/g, type + 'DepthToViewZ');
    }

    return _this79;
  }

  _createClass2(OutlinePass, [{
    key: "dispose",
    value: function dispose() {
      this.renderTargetMaskBuffer.dispose();
      this.renderTargetDepthBuffer.dispose();
      this.renderTargetMaskDownSampleBuffer.dispose();
      this.renderTargetBlurBuffer1.dispose();
      this.renderTargetBlurBuffer2.dispose();
      this.renderTargetEdgeBuffer1.dispose();
      this.renderTargetEdgeBuffer2.dispose();
    }
  }, {
    key: "setSize",
    value: function setSize(width, height) {
      this.renderTargetMaskBuffer.setSize(width, height);
      this.renderTargetDepthBuffer.setSize(width, height);
      var resx = Math.round(width / this.downSampleRatio);
      var resy = Math.round(height / this.downSampleRatio);
      this.renderTargetMaskDownSampleBuffer.setSize(resx, resy);
      this.renderTargetBlurBuffer1.setSize(resx, resy);
      this.renderTargetEdgeBuffer1.setSize(resx, resy);
      this.separableBlurMaterial1.uniforms['texSize'].value.set(resx, resy);
      resx = Math.round(resx / 2);
      resy = Math.round(resy / 2);
      this.renderTargetBlurBuffer2.setSize(resx, resy);
      this.renderTargetEdgeBuffer2.setSize(resx, resy);
      this.separableBlurMaterial2.uniforms['texSize'].value.set(resx, resy);
    }
  }, {
    key: "changeVisibilityOfSelectedObjects",
    value: function changeVisibilityOfSelectedObjects(bVisible) {
      var cache = this._visibilityCache;

      function gatherSelectedMeshesCallBack(object) {
        if (object.isMesh) {
          if (bVisible === true) {
            object.visible = cache.get(object);
          } else {
            cache.set(object, object.visible);
            object.visible = bVisible;
          }
        }
      }

      for (var _i240 = 0; _i240 < this.selectedObjects.length; _i240++) {
        var selectedObject = this.selectedObjects[_i240];
        selectedObject.traverse(gatherSelectedMeshesCallBack);
      }
    }
  }, {
    key: "changeVisibilityOfNonSelectedObjects",
    value: function changeVisibilityOfNonSelectedObjects(bVisible) {
      var cache = this._visibilityCache;
      var selectedMeshes = [];

      function gatherSelectedMeshesCallBack(object) {
        if (object.isMesh) selectedMeshes.push(object);
      }

      for (var _i241 = 0; _i241 < this.selectedObjects.length; _i241++) {
        var selectedObject = this.selectedObjects[_i241];
        selectedObject.traverse(gatherSelectedMeshesCallBack);
      }

      function VisibilityChangeCallBack(object) {
        if (object.isMesh || object.isSprite) {
          // only meshes and sprites are supported by OutlinePass
          var bFound = false;

          for (var _i242 = 0; _i242 < selectedMeshes.length; _i242++) {
            var selectedObjectId = selectedMeshes[_i242].id;

            if (selectedObjectId === object.id) {
              bFound = true;
              break;
            }
          }

          if (bFound === false) {
            var visibility = object.visible;

            if (bVisible === false || cache.get(object) === true) {
              object.visible = bVisible;
            }

            cache.set(object, visibility);
          }
        } else if (object.isPoints || object.isLine) {
          // the visibilty of points and lines is always set to false in order to
          // not affect the outline computation
          if (bVisible === true) {
            object.visible = cache.get(object); // restore
          } else {
            cache.set(object, object.visible);
            object.visible = bVisible;
          }
        }
      }

      this.renderScene.traverse(VisibilityChangeCallBack);
    }
  }, {
    key: "updateTextureMatrix",
    value: function updateTextureMatrix() {
      this.textureMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
      this.textureMatrix.multiply(this.renderCamera.projectionMatrix);
      this.textureMatrix.multiply(this.renderCamera.matrixWorldInverse);
    }
  }, {
    key: "render",
    value: function render(renderer, writeBuffer, readBuffer, deltaTime, maskActive) {
      if (this.selectedObjects.length > 0) {
        renderer.getClearColor(this._oldClearColor);
        this.oldClearAlpha = renderer.getClearAlpha();
        var oldAutoClear = renderer.autoClear;
        renderer.autoClear = false;
        if (maskActive) renderer.state.buffers.stencil.setTest(false);
        renderer.setClearColor(0xffffff, 1); // Make selected objects invisible

        this.changeVisibilityOfSelectedObjects(false);
        var currentBackground = this.renderScene.background;
        this.renderScene.background = null; // 1. Draw Non Selected objects in the depth buffer

        this.renderScene.overrideMaterial = this.depthMaterial;
        renderer.setRenderTarget(this.renderTargetDepthBuffer);
        renderer.clear();
        renderer.render(this.renderScene, this.renderCamera); // Make selected objects visible

        this.changeVisibilityOfSelectedObjects(true);

        this._visibilityCache.clear(); // Update Texture Matrix for Depth compare


        this.updateTextureMatrix(); // Make non selected objects invisible, and draw only the selected objects, by comparing the depth buffer of non selected objects

        this.changeVisibilityOfNonSelectedObjects(false);
        this.renderScene.overrideMaterial = this.prepareMaskMaterial;
        this.prepareMaskMaterial.uniforms['cameraNearFar'].value.set(this.renderCamera.near, this.renderCamera.far);
        this.prepareMaskMaterial.uniforms['depthTexture'].value = this.renderTargetDepthBuffer.texture;
        this.prepareMaskMaterial.uniforms['textureMatrix'].value = this.textureMatrix;
        renderer.setRenderTarget(this.renderTargetMaskBuffer);
        renderer.clear();
        renderer.render(this.renderScene, this.renderCamera);
        this.renderScene.overrideMaterial = null;
        this.changeVisibilityOfNonSelectedObjects(true);

        this._visibilityCache.clear();

        this.renderScene.background = currentBackground; // 2. Downsample to Half resolution

        this.fsQuad.material = this.materialCopy;
        this.copyUniforms['tDiffuse'].value = this.renderTargetMaskBuffer.texture;
        renderer.setRenderTarget(this.renderTargetMaskDownSampleBuffer);
        renderer.clear();
        this.fsQuad.render(renderer);
        this.tempPulseColor1.copy(this.visibleEdgeColor);
        this.tempPulseColor2.copy(this.hiddenEdgeColor);

        if (this.pulsePeriod > 0) {
          var scalar = (1 + 0.25) / 2 + Math.cos(performance.now() * 0.01 / this.pulsePeriod) * (1.0 - 0.25) / 2;
          this.tempPulseColor1.multiplyScalar(scalar);
          this.tempPulseColor2.multiplyScalar(scalar);
        } // 3. Apply Edge Detection Pass


        this.fsQuad.material = this.edgeDetectionMaterial;
        this.edgeDetectionMaterial.uniforms['maskTexture'].value = this.renderTargetMaskDownSampleBuffer.texture;
        this.edgeDetectionMaterial.uniforms['texSize'].value.set(this.renderTargetMaskDownSampleBuffer.width, this.renderTargetMaskDownSampleBuffer.height);
        this.edgeDetectionMaterial.uniforms['visibleEdgeColor'].value = this.tempPulseColor1;
        this.edgeDetectionMaterial.uniforms['hiddenEdgeColor'].value = this.tempPulseColor2;
        renderer.setRenderTarget(this.renderTargetEdgeBuffer1);
        renderer.clear();
        this.fsQuad.render(renderer); // 4. Apply Blur on Half res

        this.fsQuad.material = this.separableBlurMaterial1;
        this.separableBlurMaterial1.uniforms['colorTexture'].value = this.renderTargetEdgeBuffer1.texture;
        this.separableBlurMaterial1.uniforms['direction'].value = OutlinePass.BlurDirectionX;
        this.separableBlurMaterial1.uniforms['kernelRadius'].value = this.edgeThickness;
        renderer.setRenderTarget(this.renderTargetBlurBuffer1);
        renderer.clear();
        this.fsQuad.render(renderer);
        this.separableBlurMaterial1.uniforms['colorTexture'].value = this.renderTargetBlurBuffer1.texture;
        this.separableBlurMaterial1.uniforms['direction'].value = OutlinePass.BlurDirectionY;
        renderer.setRenderTarget(this.renderTargetEdgeBuffer1);
        renderer.clear();
        this.fsQuad.render(renderer); // Apply Blur on quarter res

        this.fsQuad.material = this.separableBlurMaterial2;
        this.separableBlurMaterial2.uniforms['colorTexture'].value = this.renderTargetEdgeBuffer1.texture;
        this.separableBlurMaterial2.uniforms['direction'].value = OutlinePass.BlurDirectionX;
        renderer.setRenderTarget(this.renderTargetBlurBuffer2);
        renderer.clear();
        this.fsQuad.render(renderer);
        this.separableBlurMaterial2.uniforms['colorTexture'].value = this.renderTargetBlurBuffer2.texture;
        this.separableBlurMaterial2.uniforms['direction'].value = OutlinePass.BlurDirectionY;
        renderer.setRenderTarget(this.renderTargetEdgeBuffer2);
        renderer.clear();
        this.fsQuad.render(renderer); // Blend it additively over the input texture

        this.fsQuad.material = this.overlayMaterial;
        this.overlayMaterial.uniforms['maskTexture'].value = this.renderTargetMaskBuffer.texture;
        this.overlayMaterial.uniforms['edgeTexture1'].value = this.renderTargetEdgeBuffer1.texture;
        this.overlayMaterial.uniforms['edgeTexture2'].value = this.renderTargetEdgeBuffer2.texture;
        this.overlayMaterial.uniforms['patternTexture'].value = this.patternTexture;
        this.overlayMaterial.uniforms['edgeStrength'].value = this.edgeStrength;
        this.overlayMaterial.uniforms['edgeGlow'].value = this.edgeGlow;
        this.overlayMaterial.uniforms['usePatternTexture'].value = this.usePatternTexture;
        if (maskActive) renderer.state.buffers.stencil.setTest(true);
        renderer.setRenderTarget(readBuffer);
        this.fsQuad.render(renderer);
        renderer.setClearColor(this._oldClearColor, this.oldClearAlpha);
        renderer.autoClear = oldAutoClear;
      }

      if (this.renderToScreen) {
        this.fsQuad.material = this.materialCopy;
        this.copyUniforms['tDiffuse'].value = readBuffer.texture;
        renderer.setRenderTarget(null);
        this.fsQuad.render(renderer);
      }
    }
  }, {
    key: "getPrepareMaskMaterial",
    value: function getPrepareMaskMaterial() {
      return new ShaderMaterial({
        uniforms: {
          'depthTexture': {
            value: null
          },
          'cameraNearFar': {
            value: new Vector2(0.5, 0.5)
          },
          'textureMatrix': {
            value: null
          }
        },
        vertexShader: "#include <morphtarget_pars_vertex>\n\t\t\t\t#include <skinning_pars_vertex>\n\n\t\t\t\tvarying vec4 projTexCoord;\n\t\t\t\tvarying vec4 vPosition;\n\t\t\t\tuniform mat4 textureMatrix;\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\t#include <skinbase_vertex>\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <morphtarget_vertex>\n\t\t\t\t\t#include <skinning_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t\tvPosition = mvPosition;\n\t\t\t\t\tvec4 worldPosition = modelMatrix * vec4( transformed, 1.0 );\n\t\t\t\t\tprojTexCoord = textureMatrix * worldPosition;\n\n\t\t\t\t}",
        fragmentShader: "#include <packing>\n\t\t\t\tvarying vec4 vPosition;\n\t\t\t\tvarying vec4 projTexCoord;\n\t\t\t\tuniform sampler2D depthTexture;\n\t\t\t\tuniform vec2 cameraNearFar;\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tfloat depth = unpackRGBAToDepth(texture2DProj( depthTexture, projTexCoord ));\n\t\t\t\t\tfloat viewZ = - DEPTH_TO_VIEW_Z( depth, cameraNearFar.x, cameraNearFar.y );\n\t\t\t\t\tfloat depthTest = (-vPosition.z > viewZ) ? 1.0 : 0.0;\n\t\t\t\t\tgl_FragColor = vec4(0.0, depthTest, 1.0, 1.0);\n\n\t\t\t\t}"
      });
    }
  }, {
    key: "getEdgeDetectionMaterial",
    value: function getEdgeDetectionMaterial() {
      return new ShaderMaterial({
        uniforms: {
          'maskTexture': {
            value: null
          },
          'texSize': {
            value: new Vector2(0.5, 0.5)
          },
          'visibleEdgeColor': {
            value: new Vector3(1.0, 1.0, 1.0)
          },
          'hiddenEdgeColor': {
            value: new Vector3(1.0, 1.0, 1.0)
          }
        },
        vertexShader: "varying vec2 vUv;\n\n\t\t\t\tvoid main() {\n\t\t\t\t\tvUv = uv;\n\t\t\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\t\t\t\t}",
        fragmentShader: "varying vec2 vUv;\n\n\t\t\t\tuniform sampler2D maskTexture;\n\t\t\t\tuniform vec2 texSize;\n\t\t\t\tuniform vec3 visibleEdgeColor;\n\t\t\t\tuniform vec3 hiddenEdgeColor;\n\n\t\t\t\tvoid main() {\n\t\t\t\t\tvec2 invSize = 1.0 / texSize;\n\t\t\t\t\tvec4 uvOffset = vec4(1.0, 0.0, 0.0, 1.0) * vec4(invSize, invSize);\n\t\t\t\t\tvec4 c1 = texture2D( maskTexture, vUv + uvOffset.xy);\n\t\t\t\t\tvec4 c2 = texture2D( maskTexture, vUv - uvOffset.xy);\n\t\t\t\t\tvec4 c3 = texture2D( maskTexture, vUv + uvOffset.yw);\n\t\t\t\t\tvec4 c4 = texture2D( maskTexture, vUv - uvOffset.yw);\n\t\t\t\t\tfloat diff1 = (c1.r - c2.r)*0.5;\n\t\t\t\t\tfloat diff2 = (c3.r - c4.r)*0.5;\n\t\t\t\t\tfloat d = length( vec2(diff1, diff2) );\n\t\t\t\t\tfloat a1 = min(c1.g, c2.g);\n\t\t\t\t\tfloat a2 = min(c3.g, c4.g);\n\t\t\t\t\tfloat visibilityFactor = min(a1, a2);\n\t\t\t\t\tvec3 edgeColor = 1.0 - visibilityFactor > 0.001 ? visibleEdgeColor : hiddenEdgeColor;\n\t\t\t\t\tgl_FragColor = vec4(edgeColor, 1.0) * vec4(d);\n\t\t\t\t}"
      });
    }
  }, {
    key: "getSeperableBlurMaterial",
    value: function getSeperableBlurMaterial(maxRadius) {
      return new ShaderMaterial({
        defines: {
          'MAX_RADIUS': maxRadius
        },
        uniforms: {
          'colorTexture': {
            value: null
          },
          'texSize': {
            value: new Vector2(0.5, 0.5)
          },
          'direction': {
            value: new Vector2(0.5, 0.5)
          },
          'kernelRadius': {
            value: 1.0
          }
        },
        vertexShader: "varying vec2 vUv;\n\n\t\t\t\tvoid main() {\n\t\t\t\t\tvUv = uv;\n\t\t\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\t\t\t\t}",
        fragmentShader: "#include <common>\n\t\t\t\tvarying vec2 vUv;\n\t\t\t\tuniform sampler2D colorTexture;\n\t\t\t\tuniform vec2 texSize;\n\t\t\t\tuniform vec2 direction;\n\t\t\t\tuniform float kernelRadius;\n\n\t\t\t\tfloat gaussianPdf(in float x, in float sigma) {\n\t\t\t\t\treturn 0.39894 * exp( -0.5 * x * x/( sigma * sigma))/sigma;\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\t\t\t\t\tvec2 invSize = 1.0 / texSize;\n\t\t\t\t\tfloat weightSum = gaussianPdf(0.0, kernelRadius);\n\t\t\t\t\tvec4 diffuseSum = texture2D( colorTexture, vUv) * weightSum;\n\t\t\t\t\tvec2 delta = direction * invSize * kernelRadius/float(MAX_RADIUS);\n\t\t\t\t\tvec2 uvOffset = delta;\n\t\t\t\t\tfor( int i = 1; i <= MAX_RADIUS; i ++ ) {\n\t\t\t\t\t\tfloat w = gaussianPdf(uvOffset.x, kernelRadius);\n\t\t\t\t\t\tvec4 sample1 = texture2D( colorTexture, vUv + uvOffset);\n\t\t\t\t\t\tvec4 sample2 = texture2D( colorTexture, vUv - uvOffset);\n\t\t\t\t\t\tdiffuseSum += ((sample1 + sample2) * w);\n\t\t\t\t\t\tweightSum += (2.0 * w);\n\t\t\t\t\t\tuvOffset += delta;\n\t\t\t\t\t}\n\t\t\t\t\tgl_FragColor = diffuseSum/weightSum;\n\t\t\t\t}"
      });
    }
  }, {
    key: "getOverlayMaterial",
    value: function getOverlayMaterial() {
      return new ShaderMaterial({
        uniforms: {
          'maskTexture': {
            value: null
          },
          'edgeTexture1': {
            value: null
          },
          'edgeTexture2': {
            value: null
          },
          'patternTexture': {
            value: null
          },
          'edgeStrength': {
            value: 1.0
          },
          'edgeGlow': {
            value: 1.0
          },
          'usePatternTexture': {
            value: 0.0
          }
        },
        vertexShader: "varying vec2 vUv;\n\n\t\t\t\tvoid main() {\n\t\t\t\t\tvUv = uv;\n\t\t\t\t\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\t\t\t\t}",
        fragmentShader: "varying vec2 vUv;\n\n\t\t\t\tuniform sampler2D maskTexture;\n\t\t\t\tuniform sampler2D edgeTexture1;\n\t\t\t\tuniform sampler2D edgeTexture2;\n\t\t\t\tuniform sampler2D patternTexture;\n\t\t\t\tuniform float edgeStrength;\n\t\t\t\tuniform float edgeGlow;\n\t\t\t\tuniform bool usePatternTexture;\n\n\t\t\t\tvoid main() {\n\t\t\t\t\tvec4 edgeValue1 = texture2D(edgeTexture1, vUv);\n\t\t\t\t\tvec4 edgeValue2 = texture2D(edgeTexture2, vUv);\n\t\t\t\t\tvec4 maskColor = texture2D(maskTexture, vUv);\n\t\t\t\t\tvec4 patternColor = texture2D(patternTexture, 6.0 * vUv);\n\t\t\t\t\tfloat visibilityFactor = 1.0 - maskColor.g > 0.0 ? 1.0 : 0.5;\n\t\t\t\t\tvec4 edgeValue = edgeValue1 + edgeValue2 * edgeGlow;\n\t\t\t\t\tvec4 finalColor = edgeStrength * maskColor.r * edgeValue;\n\t\t\t\t\tif(usePatternTexture)\n\t\t\t\t\t\tfinalColor += + visibilityFactor * (1.0 - maskColor.r) * (1.0 - patternColor.r);\n\t\t\t\t\tgl_FragColor = finalColor;\n\t\t\t\t}",
        blending: AdditiveBlending,
        depthTest: false,
        depthWrite: false,
        transparent: true
      });
    }
  }]);

  return OutlinePass;
}(Pass);

OutlinePass.BlurDirectionX = new Vector2(1.0, 0.0);
OutlinePass.BlurDirectionY = new Vector2(0.0, 1.0);

var RenderPass = /*#__PURE__*/function (_Pass5) {
  _inherits(RenderPass, _Pass5);

  var _super87 = _createSuper(RenderPass);

  function RenderPass(scene, camera, overrideMaterial, clearColor, clearAlpha) {
    var _this80;

    _classCallCheck2(this, RenderPass);

    _this80 = _super87.call(this);
    _this80.scene = scene;
    _this80.camera = camera;
    _this80.overrideMaterial = overrideMaterial;
    _this80.clearColor = clearColor;
    _this80.clearAlpha = clearAlpha !== undefined ? clearAlpha : 0;
    _this80.clear = true;
    _this80.clearDepth = false;
    _this80.needsSwap = false;
    _this80._oldClearColor = new Color();
    return _this80;
  }

  _createClass2(RenderPass, [{
    key: "render",
    value: function render(renderer, writeBuffer, readBuffer
    /*, deltaTime, maskActive */
    ) {
      var oldAutoClear = renderer.autoClear;
      renderer.autoClear = false;
      var oldClearAlpha, oldOverrideMaterial;

      if (this.overrideMaterial !== undefined) {
        oldOverrideMaterial = this.scene.overrideMaterial;
        this.scene.overrideMaterial = this.overrideMaterial;
      }

      if (this.clearColor) {
        renderer.getClearColor(this._oldClearColor);
        oldClearAlpha = renderer.getClearAlpha();
        renderer.setClearColor(this.clearColor, this.clearAlpha);
      }

      if (this.clearDepth) {
        renderer.clearDepth();
      }

      renderer.setRenderTarget(this.renderToScreen ? null : readBuffer); // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600

      if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
      renderer.render(this.scene, this.camera);

      if (this.clearColor) {
        renderer.setClearColor(this._oldClearColor, oldClearAlpha);
      }

      if (this.overrideMaterial !== undefined) {
        this.scene.overrideMaterial = oldOverrideMaterial;
      }

      renderer.autoClear = oldAutoClear;
    }
  }]);

  return RenderPass;
}(Pass);

var _m1$3 = new Matrix4();

var _obj$1 = new Object3D();

var _offset$1 = new Vector3();

var Geometry = /*#__PURE__*/function (_EventDispatcher8) {
  _inherits(Geometry, _EventDispatcher8);

  var _super88 = _createSuper(Geometry);

  function Geometry() {
    var _this81;

    _classCallCheck2(this, Geometry);

    _this81 = _super88.call(this);
    _this81.uuid = MathUtils.generateUUID();
    _this81.name = '';
    _this81.type = 'Geometry';
    _this81.vertices = [];
    _this81.colors = [];
    _this81.faces = [];
    _this81.faceVertexUvs = [[]];
    _this81.morphTargets = [];
    _this81.morphNormals = [];
    _this81.skinWeights = [];
    _this81.skinIndices = [];
    _this81.lineDistances = [];
    _this81.boundingBox = null;
    _this81.boundingSphere = null; // update flags

    _this81.elementsNeedUpdate = false;
    _this81.verticesNeedUpdate = false;
    _this81.uvsNeedUpdate = false;
    _this81.normalsNeedUpdate = false;
    _this81.colorsNeedUpdate = false;
    _this81.lineDistancesNeedUpdate = false;
    _this81.groupsNeedUpdate = false;
    return _this81;
  }

  _createClass2(Geometry, [{
    key: "applyMatrix4",
    value: function applyMatrix4(matrix) {
      var normalMatrix = new Matrix3().getNormalMatrix(matrix);

      for (var _i243 = 0, il = this.vertices.length; _i243 < il; _i243++) {
        var _vertex2 = this.vertices[_i243];

        _vertex2.applyMatrix4(matrix);
      }

      for (var _i244 = 0, _il17 = this.faces.length; _i244 < _il17; _i244++) {
        var face = this.faces[_i244];
        face.normal.applyMatrix3(normalMatrix).normalize();

        for (var j = 0, jl = face.vertexNormals.length; j < jl; j++) {
          face.vertexNormals[j].applyMatrix3(normalMatrix).normalize();
        }
      }

      if (this.boundingBox !== null) {
        this.computeBoundingBox();
      }

      if (this.boundingSphere !== null) {
        this.computeBoundingSphere();
      }

      this.verticesNeedUpdate = true;
      this.normalsNeedUpdate = true;
      return this;
    }
  }, {
    key: "rotateX",
    value: function rotateX(angle) {
      // rotate geometry around world x-axis
      _m1$3.makeRotationX(angle);

      this.applyMatrix4(_m1$3);
      return this;
    }
  }, {
    key: "rotateY",
    value: function rotateY(angle) {
      // rotate geometry around world y-axis
      _m1$3.makeRotationY(angle);

      this.applyMatrix4(_m1$3);
      return this;
    }
  }, {
    key: "rotateZ",
    value: function rotateZ(angle) {
      // rotate geometry around world z-axis
      _m1$3.makeRotationZ(angle);

      this.applyMatrix4(_m1$3);
      return this;
    }
  }, {
    key: "translate",
    value: function translate(x, y, z) {
      // translate geometry
      _m1$3.makeTranslation(x, y, z);

      this.applyMatrix4(_m1$3);
      return this;
    }
  }, {
    key: "scale",
    value: function scale(x, y, z) {
      // scale geometry
      _m1$3.makeScale(x, y, z);

      this.applyMatrix4(_m1$3);
      return this;
    }
  }, {
    key: "lookAt",
    value: function lookAt(vector) {
      _obj$1.lookAt(vector);

      _obj$1.updateMatrix();

      this.applyMatrix4(_obj$1.matrix);
      return this;
    }
  }, {
    key: "fromBufferGeometry",
    value: function fromBufferGeometry(geometry) {
      var scope = this;
      var index = geometry.index !== null ? geometry.index : undefined;
      var attributes = geometry.attributes;

      if (attributes.position === undefined) {
        console.error('THREE.Geometry.fromBufferGeometry(): Position attribute required for conversion.');
        return this;
      }

      var position = attributes.position;
      var normal = attributes.normal;
      var color = attributes.color;
      var uv = attributes.uv;
      var uv2 = attributes.uv2;
      if (uv2 !== undefined) this.faceVertexUvs[1] = [];

      for (var _i245 = 0; _i245 < position.count; _i245++) {
        scope.vertices.push(new Vector3().fromBufferAttribute(position, _i245));

        if (color !== undefined) {
          scope.colors.push(new Color().fromBufferAttribute(color, _i245));
        }
      }

      function addFace(a, b, c, materialIndex) {
        var vertexColors = color === undefined ? [] : [scope.colors[a].clone(), scope.colors[b].clone(), scope.colors[c].clone()];
        var vertexNormals = normal === undefined ? [] : [new Vector3().fromBufferAttribute(normal, a), new Vector3().fromBufferAttribute(normal, b), new Vector3().fromBufferAttribute(normal, c)];
        var face = new Face3(a, b, c, vertexNormals, vertexColors, materialIndex);
        scope.faces.push(face);

        if (uv !== undefined) {
          scope.faceVertexUvs[0].push([new Vector2().fromBufferAttribute(uv, a), new Vector2().fromBufferAttribute(uv, b), new Vector2().fromBufferAttribute(uv, c)]);
        }

        if (uv2 !== undefined) {
          scope.faceVertexUvs[1].push([new Vector2().fromBufferAttribute(uv2, a), new Vector2().fromBufferAttribute(uv2, b), new Vector2().fromBufferAttribute(uv2, c)]);
        }
      }

      var groups = geometry.groups;

      if (groups.length > 0) {
        for (var _i246 = 0; _i246 < groups.length; _i246++) {
          var group = groups[_i246];
          var start = group.start;
          var count = group.count;

          for (var j = start, jl = start + count; j < jl; j += 3) {
            if (index !== undefined) {
              addFace(index.getX(j), index.getX(j + 1), index.getX(j + 2), group.materialIndex);
            } else {
              addFace(j, j + 1, j + 2, group.materialIndex);
            }
          }
        }
      } else {
        if (index !== undefined) {
          for (var _i247 = 0; _i247 < index.count; _i247 += 3) {
            addFace(index.getX(_i247), index.getX(_i247 + 1), index.getX(_i247 + 2));
          }
        } else {
          for (var _i248 = 0; _i248 < position.count; _i248 += 3) {
            addFace(_i248, _i248 + 1, _i248 + 2);
          }
        }
      }

      this.computeFaceNormals();

      if (geometry.boundingBox !== null) {
        this.boundingBox = geometry.boundingBox.clone();
      }

      if (geometry.boundingSphere !== null) {
        this.boundingSphere = geometry.boundingSphere.clone();
      }

      return this;
    }
  }, {
    key: "center",
    value: function center() {
      this.computeBoundingBox();
      this.boundingBox.getCenter(_offset$1).negate();
      this.translate(_offset$1.x, _offset$1.y, _offset$1.z);
      return this;
    }
  }, {
    key: "normalize",
    value: function normalize() {
      this.computeBoundingSphere();
      var center = this.boundingSphere.center;
      var radius = this.boundingSphere.radius;
      var s = radius === 0 ? 1 : 1.0 / radius;
      var matrix = new Matrix4();
      matrix.set(s, 0, 0, -s * center.x, 0, s, 0, -s * center.y, 0, 0, s, -s * center.z, 0, 0, 0, 1);
      this.applyMatrix4(matrix);
      return this;
    }
  }, {
    key: "computeFaceNormals",
    value: function computeFaceNormals() {
      var cb = new Vector3(),
          ab = new Vector3();

      for (var f = 0, fl = this.faces.length; f < fl; f++) {
        var face = this.faces[f];
        var vA = this.vertices[face.a];
        var vB = this.vertices[face.b];
        var vC = this.vertices[face.c];
        cb.subVectors(vC, vB);
        ab.subVectors(vA, vB);
        cb.cross(ab);
        cb.normalize();
        face.normal.copy(cb);
      }
    }
  }, {
    key: "computeVertexNormals",
    value: function computeVertexNormals() {
      var areaWeighted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var vertices = new Array(this.vertices.length);

      for (var v = 0, vl = this.vertices.length; v < vl; v++) {
        vertices[v] = new Vector3();
      }

      if (areaWeighted) {
        // vertex normals weighted by triangle areas
        // http://www.iquilezles.org/www/articles/normals/normals.htm
        var cb = new Vector3(),
            ab = new Vector3();

        for (var f = 0, fl = this.faces.length; f < fl; f++) {
          var face = this.faces[f];
          var vA = this.vertices[face.a];
          var vB = this.vertices[face.b];
          var vC = this.vertices[face.c];
          cb.subVectors(vC, vB);
          ab.subVectors(vA, vB);
          cb.cross(ab);
          vertices[face.a].add(cb);
          vertices[face.b].add(cb);
          vertices[face.c].add(cb);
        }
      } else {
        this.computeFaceNormals();

        for (var _f3 = 0, _fl = this.faces.length; _f3 < _fl; _f3++) {
          var _face4 = this.faces[_f3];

          vertices[_face4.a].add(_face4.normal);

          vertices[_face4.b].add(_face4.normal);

          vertices[_face4.c].add(_face4.normal);
        }
      }

      for (var _v = 0, _vl = this.vertices.length; _v < _vl; _v++) {
        vertices[_v].normalize();
      }

      for (var _f4 = 0, _fl2 = this.faces.length; _f4 < _fl2; _f4++) {
        var _face5 = this.faces[_f4];
        var vertexNormals = _face5.vertexNormals;

        if (vertexNormals.length === 3) {
          vertexNormals[0].copy(vertices[_face5.a]);
          vertexNormals[1].copy(vertices[_face5.b]);
          vertexNormals[2].copy(vertices[_face5.c]);
        } else {
          vertexNormals[0] = vertices[_face5.a].clone();
          vertexNormals[1] = vertices[_face5.b].clone();
          vertexNormals[2] = vertices[_face5.c].clone();
        }
      }

      if (this.faces.length > 0) {
        this.normalsNeedUpdate = true;
      }
    }
  }, {
    key: "computeFlatVertexNormals",
    value: function computeFlatVertexNormals() {
      this.computeFaceNormals();

      for (var f = 0, fl = this.faces.length; f < fl; f++) {
        var face = this.faces[f];
        var vertexNormals = face.vertexNormals;

        if (vertexNormals.length === 3) {
          vertexNormals[0].copy(face.normal);
          vertexNormals[1].copy(face.normal);
          vertexNormals[2].copy(face.normal);
        } else {
          vertexNormals[0] = face.normal.clone();
          vertexNormals[1] = face.normal.clone();
          vertexNormals[2] = face.normal.clone();
        }
      }

      if (this.faces.length > 0) {
        this.normalsNeedUpdate = true;
      }
    }
  }, {
    key: "computeMorphNormals",
    value: function computeMorphNormals() {
      // save original normals
      // - create temp variables on first access
      //   otherwise just copy (for faster repeated calls)
      for (var f = 0, fl = this.faces.length; f < fl; f++) {
        var face = this.faces[f];

        if (!face.__originalFaceNormal) {
          face.__originalFaceNormal = face.normal.clone();
        } else {
          face.__originalFaceNormal.copy(face.normal);
        }

        if (!face.__originalVertexNormals) face.__originalVertexNormals = [];

        for (var _i249 = 0, il = face.vertexNormals.length; _i249 < il; _i249++) {
          if (!face.__originalVertexNormals[_i249]) {
            face.__originalVertexNormals[_i249] = face.vertexNormals[_i249].clone();
          } else {
            face.__originalVertexNormals[_i249].copy(face.vertexNormals[_i249]);
          }
        }
      } // use temp geometry to compute face and vertex normals for each morph


      var tmpGeo = new Geometry();
      tmpGeo.faces = this.faces;

      for (var _i250 = 0, _il18 = this.morphTargets.length; _i250 < _il18; _i250++) {
        // create on first access
        if (!this.morphNormals[_i250]) {
          this.morphNormals[_i250] = {};
          this.morphNormals[_i250].faceNormals = [];
          this.morphNormals[_i250].vertexNormals = [];
          var dstNormalsFace = this.morphNormals[_i250].faceNormals;
          var dstNormalsVertex = this.morphNormals[_i250].vertexNormals;

          for (var _f5 = 0, _fl3 = this.faces.length; _f5 < _fl3; _f5++) {
            var faceNormal = new Vector3();
            var vertexNormals = {
              a: new Vector3(),
              b: new Vector3(),
              c: new Vector3()
            };
            dstNormalsFace.push(faceNormal);
            dstNormalsVertex.push(vertexNormals);
          }
        }

        var morphNormals = this.morphNormals[_i250]; // set vertices to morph target

        tmpGeo.vertices = this.morphTargets[_i250].vertices; // compute morph normals

        tmpGeo.computeFaceNormals();
        tmpGeo.computeVertexNormals(); // store morph normals

        for (var _f6 = 0, _fl4 = this.faces.length; _f6 < _fl4; _f6++) {
          var _face6 = this.faces[_f6];
          var _faceNormal = morphNormals.faceNormals[_f6];
          var _vertexNormals = morphNormals.vertexNormals[_f6];

          _faceNormal.copy(_face6.normal);

          _vertexNormals.a.copy(_face6.vertexNormals[0]);

          _vertexNormals.b.copy(_face6.vertexNormals[1]);

          _vertexNormals.c.copy(_face6.vertexNormals[2]);
        }
      } // restore original normals


      for (var _f7 = 0, _fl5 = this.faces.length; _f7 < _fl5; _f7++) {
        var _face7 = this.faces[_f7];
        _face7.normal = _face7.__originalFaceNormal;
        _face7.vertexNormals = _face7.__originalVertexNormals;
      }
    }
  }, {
    key: "computeBoundingBox",
    value: function computeBoundingBox() {
      if (this.boundingBox === null) {
        this.boundingBox = new Box3();
      }

      this.boundingBox.setFromPoints(this.vertices);
    }
  }, {
    key: "computeBoundingSphere",
    value: function computeBoundingSphere() {
      if (this.boundingSphere === null) {
        this.boundingSphere = new Sphere();
      }

      this.boundingSphere.setFromPoints(this.vertices);
    }
  }, {
    key: "merge",
    value: function merge(geometry, matrix) {
      var materialIndexOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (!(geometry && geometry.isGeometry)) {
        console.error('THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.', geometry);
        return;
      }

      var normalMatrix;
      var vertexOffset = this.vertices.length,
          vertices1 = this.vertices,
          vertices2 = geometry.vertices,
          faces1 = this.faces,
          faces2 = geometry.faces,
          colors1 = this.colors,
          colors2 = geometry.colors;

      if (matrix !== undefined) {
        normalMatrix = new Matrix3().getNormalMatrix(matrix);
      } // vertices


      for (var _i251 = 0, il = vertices2.length; _i251 < il; _i251++) {
        var _vertex3 = vertices2[_i251];

        var vertexCopy = _vertex3.clone();

        if (matrix !== undefined) vertexCopy.applyMatrix4(matrix);
        vertices1.push(vertexCopy);
      } // colors


      for (var _i252 = 0, _il19 = colors2.length; _i252 < _il19; _i252++) {
        colors1.push(colors2[_i252].clone());
      } // faces


      for (var _i253 = 0, _il20 = faces2.length; _i253 < _il20; _i253++) {
        var face = faces2[_i253];
        var normal = void 0,
            color = void 0;
        var faceVertexNormals = face.vertexNormals,
            faceVertexColors = face.vertexColors;
        var faceCopy = new Face3(face.a + vertexOffset, face.b + vertexOffset, face.c + vertexOffset);
        faceCopy.normal.copy(face.normal);

        if (normalMatrix !== undefined) {
          faceCopy.normal.applyMatrix3(normalMatrix).normalize();
        }

        for (var j = 0, jl = faceVertexNormals.length; j < jl; j++) {
          normal = faceVertexNormals[j].clone();

          if (normalMatrix !== undefined) {
            normal.applyMatrix3(normalMatrix).normalize();
          }

          faceCopy.vertexNormals.push(normal);
        }

        faceCopy.color.copy(face.color);

        for (var _j11 = 0, _jl3 = faceVertexColors.length; _j11 < _jl3; _j11++) {
          color = faceVertexColors[_j11];
          faceCopy.vertexColors.push(color.clone());
        }

        faceCopy.materialIndex = face.materialIndex + materialIndexOffset;
        faces1.push(faceCopy);
      } // uvs


      for (var _i254 = 0, _il21 = geometry.faceVertexUvs.length; _i254 < _il21; _i254++) {
        var faceVertexUvs2 = geometry.faceVertexUvs[_i254];
        if (this.faceVertexUvs[_i254] === undefined) this.faceVertexUvs[_i254] = [];

        for (var _j12 = 0, _jl4 = faceVertexUvs2.length; _j12 < _jl4; _j12++) {
          var uvs2 = faceVertexUvs2[_j12],
              uvsCopy = [];

          for (var k = 0, kl = uvs2.length; k < kl; k++) {
            uvsCopy.push(uvs2[k].clone());
          }

          this.faceVertexUvs[_i254].push(uvsCopy);
        }
      }
    }
  }, {
    key: "mergeMesh",
    value: function mergeMesh(mesh) {
      if (!(mesh && mesh.isMesh)) {
        console.error('THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.', mesh);
        return;
      }

      if (mesh.matrixAutoUpdate) mesh.updateMatrix();
      this.merge(mesh.geometry, mesh.matrix);
    }
    /*
     * Checks for duplicate vertices with hashmap.
     * Duplicated vertices are removed
     * and faces' vertices are updated.
     */

  }, {
    key: "mergeVertices",
    value: function mergeVertices() {
      var precisionPoints = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
      var verticesMap = {}; // Hashmap for looking up vertices by position coordinates (and making sure they are unique)

      var unique = [],
          changes = [];
      var precision = Math.pow(10, precisionPoints);

      for (var _i255 = 0, il = this.vertices.length; _i255 < il; _i255++) {
        var v = this.vertices[_i255];
        var key = Math.round(v.x * precision) + '_' + Math.round(v.y * precision) + '_' + Math.round(v.z * precision);

        if (verticesMap[key] === undefined) {
          verticesMap[key] = _i255;
          unique.push(this.vertices[_i255]);
          changes[_i255] = unique.length - 1;
        } else {
          //console.log('Duplicate vertex found. ', i, ' could be using ', verticesMap[key]);
          changes[_i255] = changes[verticesMap[key]];
        }
      } // if faces are completely degenerate after merging vertices, we
      // have to remove them from the geometry.


      var faceIndicesToRemove = [];

      for (var _i256 = 0, _il22 = this.faces.length; _i256 < _il22; _i256++) {
        var face = this.faces[_i256];
        face.a = changes[face.a];
        face.b = changes[face.b];
        face.c = changes[face.c];
        var indices = [face.a, face.b, face.c]; // if any duplicate vertices are found in a Face3
        // we have to remove the face as nothing can be saved

        for (var n = 0; n < 3; n++) {
          if (indices[n] === indices[(n + 1) % 3]) {
            faceIndicesToRemove.push(_i256);
            break;
          }
        }
      }

      for (var _i257 = faceIndicesToRemove.length - 1; _i257 >= 0; _i257--) {
        var idx = faceIndicesToRemove[_i257];
        this.faces.splice(idx, 1);

        for (var j = 0, jl = this.faceVertexUvs.length; j < jl; j++) {
          this.faceVertexUvs[j].splice(idx, 1);
        }
      } // Use unique set of vertices


      var diff = this.vertices.length - unique.length;
      this.vertices = unique;
      return diff;
    }
  }, {
    key: "setFromPoints",
    value: function setFromPoints(points) {
      this.vertices = [];

      for (var _i258 = 0, l = points.length; _i258 < l; _i258++) {
        var point = points[_i258];
        this.vertices.push(new Vector3(point.x, point.y, point.z || 0));
      }

      return this;
    }
  }, {
    key: "sortFacesByMaterialIndex",
    value: function sortFacesByMaterialIndex() {
      var faces = this.faces;
      var length = faces.length; // tag faces

      for (var _i259 = 0; _i259 < length; _i259++) {
        faces[_i259]._id = _i259;
      } // sort faces


      function materialIndexSort(a, b) {
        return a.materialIndex - b.materialIndex;
      }

      faces.sort(materialIndexSort); // sort uvs

      var uvs1 = this.faceVertexUvs[0];
      var uvs2 = this.faceVertexUvs[1];
      var newUvs1, newUvs2;
      if (uvs1 && uvs1.length === length) newUvs1 = [];
      if (uvs2 && uvs2.length === length) newUvs2 = [];

      for (var _i260 = 0; _i260 < length; _i260++) {
        var id = faces[_i260]._id;
        if (newUvs1) newUvs1.push(uvs1[id]);
        if (newUvs2) newUvs2.push(uvs2[id]);
      }

      if (newUvs1) this.faceVertexUvs[0] = newUvs1;
      if (newUvs2) this.faceVertexUvs[1] = newUvs2;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var data = {
        metadata: {
          version: 4.5,
          type: 'Geometry',
          generator: 'Geometry.toJSON'
        }
      }; // standard Geometry serialization

      data.uuid = this.uuid;
      data.type = this.type;
      if (this.name !== '') data.name = this.name;

      if (this.parameters !== undefined) {
        var parameters = this.parameters;

        for (var key in parameters) {
          if (parameters[key] !== undefined) data[key] = parameters[key];
        }

        return data;
      }

      var vertices = [];

      for (var _i261 = 0; _i261 < this.vertices.length; _i261++) {
        var _vertex4 = this.vertices[_i261];
        vertices.push(_vertex4.x, _vertex4.y, _vertex4.z);
      }

      var faces = [];
      var normals = [];
      var normalsHash = {};
      var colors = [];
      var colorsHash = {};
      var uvs = [];
      var uvsHash = {};

      for (var _i262 = 0; _i262 < this.faces.length; _i262++) {
        var face = this.faces[_i262];
        var hasMaterial = true;
        var hasFaceUv = false; // deprecated

        var hasFaceVertexUv = this.faceVertexUvs[0][_i262] !== undefined;
        var hasFaceNormal = face.normal.length() > 0;
        var hasFaceVertexNormal = face.vertexNormals.length > 0;
        var hasFaceColor = face.color.r !== 1 || face.color.g !== 1 || face.color.b !== 1;
        var hasFaceVertexColor = face.vertexColors.length > 0;
        var faceType = 0;
        faceType = setBit(faceType, 0, 0); // isQuad

        faceType = setBit(faceType, 1, hasMaterial);
        faceType = setBit(faceType, 2, hasFaceUv);
        faceType = setBit(faceType, 3, hasFaceVertexUv);
        faceType = setBit(faceType, 4, hasFaceNormal);
        faceType = setBit(faceType, 5, hasFaceVertexNormal);
        faceType = setBit(faceType, 6, hasFaceColor);
        faceType = setBit(faceType, 7, hasFaceVertexColor);
        faces.push(faceType);
        faces.push(face.a, face.b, face.c);
        faces.push(face.materialIndex);

        if (hasFaceVertexUv) {
          var faceVertexUvs = this.faceVertexUvs[0][_i262];
          faces.push(getUvIndex(faceVertexUvs[0]), getUvIndex(faceVertexUvs[1]), getUvIndex(faceVertexUvs[2]));
        }

        if (hasFaceNormal) {
          faces.push(getNormalIndex(face.normal));
        }

        if (hasFaceVertexNormal) {
          var vertexNormals = face.vertexNormals;
          faces.push(getNormalIndex(vertexNormals[0]), getNormalIndex(vertexNormals[1]), getNormalIndex(vertexNormals[2]));
        }

        if (hasFaceColor) {
          faces.push(getColorIndex(face.color));
        }

        if (hasFaceVertexColor) {
          var vertexColors = face.vertexColors;
          faces.push(getColorIndex(vertexColors[0]), getColorIndex(vertexColors[1]), getColorIndex(vertexColors[2]));
        }
      }

      function setBit(value, position, enabled) {
        return enabled ? value | 1 << position : value & ~(1 << position);
      }

      function getNormalIndex(normal) {
        var hash = normal.x.toString() + normal.y.toString() + normal.z.toString();

        if (normalsHash[hash] !== undefined) {
          return normalsHash[hash];
        }

        normalsHash[hash] = normals.length / 3;
        normals.push(normal.x, normal.y, normal.z);
        return normalsHash[hash];
      }

      function getColorIndex(color) {
        var hash = color.r.toString() + color.g.toString() + color.b.toString();

        if (colorsHash[hash] !== undefined) {
          return colorsHash[hash];
        }

        colorsHash[hash] = colors.length;
        colors.push(color.getHex());
        return colorsHash[hash];
      }

      function getUvIndex(uv) {
        var hash = uv.x.toString() + uv.y.toString();

        if (uvsHash[hash] !== undefined) {
          return uvsHash[hash];
        }

        uvsHash[hash] = uvs.length / 2;
        uvs.push(uv.x, uv.y);
        return uvsHash[hash];
      }

      data.data = {};
      data.data.vertices = vertices;
      data.data.normals = normals;
      if (colors.length > 0) data.data.colors = colors;
      if (uvs.length > 0) data.data.uvs = [uvs]; // temporal backward compatibility

      data.data.faces = faces;
      return data;
    }
  }, {
    key: "clone",
    value: function clone() {
      /*
       // Handle primitives
      	 const parameters = this.parameters;
      	 if ( parameters !== undefined ) {
      	 const values = [];
      	 for ( const key in parameters ) {
      	 values.push( parameters[ key ] );
      	 }
      	 const geometry = Object.create( this.constructor.prototype );
       this.constructor.apply( geometry, values );
       return geometry;
      	 }
      	 return new this.constructor().copy( this );
       */
      return new Geometry().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      // reset
      this.vertices = [];
      this.colors = [];
      this.faces = [];
      this.faceVertexUvs = [[]];
      this.morphTargets = [];
      this.morphNormals = [];
      this.skinWeights = [];
      this.skinIndices = [];
      this.lineDistances = [];
      this.boundingBox = null;
      this.boundingSphere = null; // name

      this.name = source.name; // vertices

      var vertices = source.vertices;

      for (var _i263 = 0, il = vertices.length; _i263 < il; _i263++) {
        this.vertices.push(vertices[_i263].clone());
      } // colors


      var colors = source.colors;

      for (var _i264 = 0, _il23 = colors.length; _i264 < _il23; _i264++) {
        this.colors.push(colors[_i264].clone());
      } // faces


      var faces = source.faces;

      for (var _i265 = 0, _il24 = faces.length; _i265 < _il24; _i265++) {
        this.faces.push(faces[_i265].clone());
      } // face vertex uvs


      for (var _i266 = 0, _il25 = source.faceVertexUvs.length; _i266 < _il25; _i266++) {
        var faceVertexUvs = source.faceVertexUvs[_i266];

        if (this.faceVertexUvs[_i266] === undefined) {
          this.faceVertexUvs[_i266] = [];
        }

        for (var j = 0, jl = faceVertexUvs.length; j < jl; j++) {
          var uvs = faceVertexUvs[j],
              uvsCopy = [];

          for (var k = 0, kl = uvs.length; k < kl; k++) {
            var uv = uvs[k];
            uvsCopy.push(uv.clone());
          }

          this.faceVertexUvs[_i266].push(uvsCopy);
        }
      } // morph targets


      var morphTargets = source.morphTargets;

      for (var _i267 = 0, _il26 = morphTargets.length; _i267 < _il26; _i267++) {
        var morphTarget = {};
        morphTarget.name = morphTargets[_i267].name; // vertices

        if (morphTargets[_i267].vertices !== undefined) {
          morphTarget.vertices = [];

          for (var _j13 = 0, _jl5 = morphTargets[_i267].vertices.length; _j13 < _jl5; _j13++) {
            morphTarget.vertices.push(morphTargets[_i267].vertices[_j13].clone());
          }
        } // normals


        if (morphTargets[_i267].normals !== undefined) {
          morphTarget.normals = [];

          for (var _j14 = 0, _jl6 = morphTargets[_i267].normals.length; _j14 < _jl6; _j14++) {
            morphTarget.normals.push(morphTargets[_i267].normals[_j14].clone());
          }
        }

        this.morphTargets.push(morphTarget);
      } // morph normals


      var morphNormals = source.morphNormals;

      for (var _i268 = 0, _il27 = morphNormals.length; _i268 < _il27; _i268++) {
        var morphNormal = {}; // vertex normals

        if (morphNormals[_i268].vertexNormals !== undefined) {
          morphNormal.vertexNormals = [];

          for (var _j15 = 0, _jl7 = morphNormals[_i268].vertexNormals.length; _j15 < _jl7; _j15++) {
            var srcVertexNormal = morphNormals[_i268].vertexNormals[_j15];
            var destVertexNormal = {};
            destVertexNormal.a = srcVertexNormal.a.clone();
            destVertexNormal.b = srcVertexNormal.b.clone();
            destVertexNormal.c = srcVertexNormal.c.clone();
            morphNormal.vertexNormals.push(destVertexNormal);
          }
        } // face normals


        if (morphNormals[_i268].faceNormals !== undefined) {
          morphNormal.faceNormals = [];

          for (var _j16 = 0, _jl8 = morphNormals[_i268].faceNormals.length; _j16 < _jl8; _j16++) {
            morphNormal.faceNormals.push(morphNormals[_i268].faceNormals[_j16].clone());
          }
        }

        this.morphNormals.push(morphNormal);
      } // skin weights


      var skinWeights = source.skinWeights;

      for (var _i269 = 0, _il28 = skinWeights.length; _i269 < _il28; _i269++) {
        this.skinWeights.push(skinWeights[_i269].clone());
      } // skin indices


      var skinIndices = source.skinIndices;

      for (var _i270 = 0, _il29 = skinIndices.length; _i270 < _il29; _i270++) {
        this.skinIndices.push(skinIndices[_i270].clone());
      } // line distances


      var lineDistances = source.lineDistances;

      for (var _i271 = 0, _il30 = lineDistances.length; _i271 < _il30; _i271++) {
        this.lineDistances.push(lineDistances[_i271]);
      } // bounding box


      var boundingBox = source.boundingBox;

      if (boundingBox !== null) {
        this.boundingBox = boundingBox.clone();
      } // bounding sphere


      var boundingSphere = source.boundingSphere;

      if (boundingSphere !== null) {
        this.boundingSphere = boundingSphere.clone();
      } // update flags


      this.elementsNeedUpdate = source.elementsNeedUpdate;
      this.verticesNeedUpdate = source.verticesNeedUpdate;
      this.uvsNeedUpdate = source.uvsNeedUpdate;
      this.normalsNeedUpdate = source.normalsNeedUpdate;
      this.colorsNeedUpdate = source.colorsNeedUpdate;
      this.lineDistancesNeedUpdate = source.lineDistancesNeedUpdate;
      this.groupsNeedUpdate = source.groupsNeedUpdate;
      return this;
    }
  }, {
    key: "toBufferGeometry",
    value: function toBufferGeometry() {
      var geometry = new DirectGeometry().fromGeometry(this);
      var buffergeometry = new BufferGeometry();
      var positions = new Float32Array(geometry.vertices.length * 3);
      buffergeometry.setAttribute('position', new BufferAttribute(positions, 3).copyVector3sArray(geometry.vertices));

      if (geometry.normals.length > 0) {
        var normals = new Float32Array(geometry.normals.length * 3);
        buffergeometry.setAttribute('normal', new BufferAttribute(normals, 3).copyVector3sArray(geometry.normals));
      }

      if (geometry.colors.length > 0) {
        var colors = new Float32Array(geometry.colors.length * 3);
        buffergeometry.setAttribute('color', new BufferAttribute(colors, 3).copyColorsArray(geometry.colors));
      }

      if (geometry.uvs.length > 0) {
        var uvs = new Float32Array(geometry.uvs.length * 2);
        buffergeometry.setAttribute('uv', new BufferAttribute(uvs, 2).copyVector2sArray(geometry.uvs));
      }

      if (geometry.uvs2.length > 0) {
        var uvs2 = new Float32Array(geometry.uvs2.length * 2);
        buffergeometry.setAttribute('uv2', new BufferAttribute(uvs2, 2).copyVector2sArray(geometry.uvs2));
      } // groups


      buffergeometry.groups = geometry.groups; // morphs

      for (var name in geometry.morphTargets) {
        var array = [];
        var morphTargets = geometry.morphTargets[name];

        for (var _i272 = 0, l = morphTargets.length; _i272 < l; _i272++) {
          var morphTarget = morphTargets[_i272];
          var attribute = new Float32BufferAttribute(morphTarget.data.length * 3, 3);
          attribute.name = morphTarget.name;
          array.push(attribute.copyVector3sArray(morphTarget.data));
        }

        buffergeometry.morphAttributes[name] = array;
      } // skinning


      if (geometry.skinIndices.length > 0) {
        var skinIndices = new Float32BufferAttribute(geometry.skinIndices.length * 4, 4);
        buffergeometry.setAttribute('skinIndex', skinIndices.copyVector4sArray(geometry.skinIndices));
      }

      if (geometry.skinWeights.length > 0) {
        var skinWeights = new Float32BufferAttribute(geometry.skinWeights.length * 4, 4);
        buffergeometry.setAttribute('skinWeight', skinWeights.copyVector4sArray(geometry.skinWeights));
      } //


      if (geometry.boundingSphere !== null) {
        buffergeometry.boundingSphere = geometry.boundingSphere.clone();
      }

      if (geometry.boundingBox !== null) {
        buffergeometry.boundingBox = geometry.boundingBox.clone();
      }

      return buffergeometry;
    }
  }, {
    key: "computeTangents",
    value: function computeTangents() {
      console.error('THREE.Geometry: .computeTangents() has been removed.');
    }
  }, {
    key: "computeLineDistances",
    value: function computeLineDistances() {
      console.error('THREE.Geometry: .computeLineDistances() has been removed. Use THREE.Line.computeLineDistances() instead.');
    }
  }, {
    key: "applyMatrix",
    value: function applyMatrix(matrix) {
      console.warn('THREE.Geometry: .applyMatrix() has been renamed to .applyMatrix4().');
      return this.applyMatrix4(matrix);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.dispatchEvent({
        type: 'dispose'
      });
    }
  }], [{
    key: "createBufferGeometryFromObject",
    value: function createBufferGeometryFromObject(object) {
      var buffergeometry = new BufferGeometry();
      var geometry = object.geometry;

      if (object.isPoints || object.isLine) {
        var positions = new Float32BufferAttribute(geometry.vertices.length * 3, 3);
        var colors = new Float32BufferAttribute(geometry.colors.length * 3, 3);
        buffergeometry.setAttribute('position', positions.copyVector3sArray(geometry.vertices));
        buffergeometry.setAttribute('color', colors.copyColorsArray(geometry.colors));

        if (geometry.lineDistances && geometry.lineDistances.length === geometry.vertices.length) {
          var lineDistances = new Float32BufferAttribute(geometry.lineDistances.length, 1);
          buffergeometry.setAttribute('lineDistance', lineDistances.copyArray(geometry.lineDistances));
        }

        if (geometry.boundingSphere !== null) {
          buffergeometry.boundingSphere = geometry.boundingSphere.clone();
        }

        if (geometry.boundingBox !== null) {
          buffergeometry.boundingBox = geometry.boundingBox.clone();
        }
      } else if (object.isMesh) {
        buffergeometry = geometry.toBufferGeometry();
      }

      return buffergeometry;
    }
  }]);

  return Geometry;
}(EventDispatcher);

Geometry.prototype.isGeometry = true;

var DirectGeometry = /*#__PURE__*/function () {
  function DirectGeometry() {
    _classCallCheck2(this, DirectGeometry);

    this.vertices = [];
    this.normals = [];
    this.colors = [];
    this.uvs = [];
    this.uvs2 = [];
    this.groups = [];
    this.morphTargets = {};
    this.skinWeights = [];
    this.skinIndices = []; // this.lineDistances = [];

    this.boundingBox = null;
    this.boundingSphere = null; // update flags

    this.verticesNeedUpdate = false;
    this.normalsNeedUpdate = false;
    this.colorsNeedUpdate = false;
    this.uvsNeedUpdate = false;
    this.groupsNeedUpdate = false;
  }

  _createClass2(DirectGeometry, [{
    key: "computeGroups",
    value: function computeGroups(geometry) {
      var groups = [];
      var group, i;
      var materialIndex = undefined;
      var faces = geometry.faces;

      for (i = 0; i < faces.length; i++) {
        var face = faces[i]; // materials

        if (face.materialIndex !== materialIndex) {
          materialIndex = face.materialIndex;

          if (group !== undefined) {
            group.count = i * 3 - group.start;
            groups.push(group);
          }

          group = {
            start: i * 3,
            materialIndex: materialIndex
          };
        }
      }

      if (group !== undefined) {
        group.count = i * 3 - group.start;
        groups.push(group);
      }

      this.groups = groups;
    }
  }, {
    key: "fromGeometry",
    value: function fromGeometry(geometry) {
      var faces = geometry.faces;
      var vertices = geometry.vertices;
      var faceVertexUvs = geometry.faceVertexUvs;
      var hasFaceVertexUv = faceVertexUvs[0] && faceVertexUvs[0].length > 0;
      var hasFaceVertexUv2 = faceVertexUvs[1] && faceVertexUvs[1].length > 0; // morphs

      var morphTargets = geometry.morphTargets;
      var morphTargetsLength = morphTargets.length;
      var morphTargetsPosition;

      if (morphTargetsLength > 0) {
        morphTargetsPosition = [];

        for (var _i273 = 0; _i273 < morphTargetsLength; _i273++) {
          morphTargetsPosition[_i273] = {
            name: morphTargets[_i273].name,
            data: []
          };
        }

        this.morphTargets.position = morphTargetsPosition;
      }

      var morphNormals = geometry.morphNormals;
      var morphNormalsLength = morphNormals.length;
      var morphTargetsNormal;

      if (morphNormalsLength > 0) {
        morphTargetsNormal = [];

        for (var _i274 = 0; _i274 < morphNormalsLength; _i274++) {
          morphTargetsNormal[_i274] = {
            name: morphNormals[_i274].name,
            data: []
          };
        }

        this.morphTargets.normal = morphTargetsNormal;
      } // skins


      var skinIndices = geometry.skinIndices;
      var skinWeights = geometry.skinWeights;
      var hasSkinIndices = skinIndices.length === vertices.length;
      var hasSkinWeights = skinWeights.length === vertices.length; //

      if (vertices.length > 0 && faces.length === 0) {
        console.error('THREE.DirectGeometry: Faceless geometries are not supported.');
      }

      for (var _i275 = 0; _i275 < faces.length; _i275++) {
        var face = faces[_i275];
        this.vertices.push(vertices[face.a], vertices[face.b], vertices[face.c]);
        var vertexNormals = face.vertexNormals;

        if (vertexNormals.length === 3) {
          this.normals.push(vertexNormals[0], vertexNormals[1], vertexNormals[2]);
        } else {
          var normal = face.normal;
          this.normals.push(normal, normal, normal);
        }

        var vertexColors = face.vertexColors;

        if (vertexColors.length === 3) {
          this.colors.push(vertexColors[0], vertexColors[1], vertexColors[2]);
        } else {
          var color = face.color;
          this.colors.push(color, color, color);
        }

        if (hasFaceVertexUv === true) {
          var vertexUvs = faceVertexUvs[0][_i275];

          if (vertexUvs !== undefined) {
            this.uvs.push(vertexUvs[0], vertexUvs[1], vertexUvs[2]);
          } else {
            console.warn('THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ', _i275);
            this.uvs.push(new Vector2(), new Vector2(), new Vector2());
          }
        }

        if (hasFaceVertexUv2 === true) {
          var _vertexUvs = faceVertexUvs[1][_i275];

          if (_vertexUvs !== undefined) {
            this.uvs2.push(_vertexUvs[0], _vertexUvs[1], _vertexUvs[2]);
          } else {
            console.warn('THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ', _i275);
            this.uvs2.push(new Vector2(), new Vector2(), new Vector2());
          }
        } // morphs


        for (var j = 0; j < morphTargetsLength; j++) {
          var morphTarget = morphTargets[j].vertices;
          morphTargetsPosition[j].data.push(morphTarget[face.a], morphTarget[face.b], morphTarget[face.c]);
        }

        for (var _j17 = 0; _j17 < morphNormalsLength; _j17++) {
          var morphNormal = morphNormals[_j17].vertexNormals[_i275];

          morphTargetsNormal[_j17].data.push(morphNormal.a, morphNormal.b, morphNormal.c);
        } // skins


        if (hasSkinIndices) {
          this.skinIndices.push(skinIndices[face.a], skinIndices[face.b], skinIndices[face.c]);
        }

        if (hasSkinWeights) {
          this.skinWeights.push(skinWeights[face.a], skinWeights[face.b], skinWeights[face.c]);
        }
      }

      this.computeGroups(geometry);
      this.verticesNeedUpdate = geometry.verticesNeedUpdate;
      this.normalsNeedUpdate = geometry.normalsNeedUpdate;
      this.colorsNeedUpdate = geometry.colorsNeedUpdate;
      this.uvsNeedUpdate = geometry.uvsNeedUpdate;
      this.groupsNeedUpdate = geometry.groupsNeedUpdate;

      if (geometry.boundingSphere !== null) {
        this.boundingSphere = geometry.boundingSphere.clone();
      }

      if (geometry.boundingBox !== null) {
        this.boundingBox = geometry.boundingBox.clone();
      }

      return this;
    }
  }]);

  return DirectGeometry;
}();

var Face3 = /*#__PURE__*/function () {
  function Face3(a, b, c, normal, color) {
    var materialIndex = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

    _classCallCheck2(this, Face3);

    this.a = a;
    this.b = b;
    this.c = c;
    this.normal = normal && normal.isVector3 ? normal : new Vector3();
    this.vertexNormals = Array.isArray(normal) ? normal : [];
    this.color = color && color.isColor ? color : new Color();
    this.vertexColors = Array.isArray(color) ? color : [];
    this.materialIndex = materialIndex;
  }

  _createClass2(Face3, [{
    key: "clone",
    value: function clone() {
      return new this.constructor().copy(this);
    }
  }, {
    key: "copy",
    value: function copy(source) {
      this.a = source.a;
      this.b = source.b;
      this.c = source.c;
      this.normal.copy(source.normal);
      this.color.copy(source.color);
      this.materialIndex = source.materialIndex;

      for (var _i276 = 0, il = source.vertexNormals.length; _i276 < il; _i276++) {
        this.vertexNormals[_i276] = source.vertexNormals[_i276].clone();
      }

      for (var _i277 = 0, _il31 = source.vertexColors.length; _i277 < _il31; _i277++) {
        this.vertexColors[_i277] = source.vertexColors[_i277].clone();
      }

      return this;
    }
  }]);

  return Face3;
}();
/* eslint-disable */
// ## License
//
// Copyright (c) 2011 Evan Wallace (http://madebyevan.com/), under the MIT license.
// THREE.js rework by thrax
// # class CSG
// Holds a binary space partition tree representing a 3D solid. Two solids can
// be combined using the `union()`, `subtract()`, and `intersect()` methods.


var CSG = /*#__PURE__*/function () {
  function CSG() {
    _classCallCheck2(this, CSG);

    this.polygons = [];
  }

  _createClass2(CSG, [{
    key: "toMesh",
    value: function toMesh(arg0, matrix, material) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "fromMesh",
    value: function fromMesh(meshA) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "clone",
    value: function clone() {
      var csg = new CSG();
      csg.polygons = this.polygons.map(function (p) {
        return p.clone();
      });
      return csg;
    }
  }, {
    key: "toPolygons",
    value: function toPolygons() {
      return this.polygons;
    }
  }, {
    key: "union",
    value: function union(csg) {
      var a = new Node$1(this.clone().polygons);
      var b = new Node$1(csg.clone().polygons);
      a.clipTo(b);
      b.clipTo(a);
      b.invert();
      b.clipTo(a);
      b.invert();
      a.build(b.allPolygons());
      return CSG.fromPolygons(a.allPolygons());
    }
  }, {
    key: "subtract",
    value: function subtract(csg) {
      var a = new Node$1(this.clone().polygons);
      var b = new Node$1(csg.clone().polygons);
      a.invert();
      a.clipTo(b);
      b.clipTo(a);
      b.invert();
      b.clipTo(a);
      b.invert();
      a.build(b.allPolygons());
      a.invert();
      return CSG.fromPolygons(a.allPolygons());
    }
  }, {
    key: "intersect",
    value: function intersect(csg) {
      var a = new Node$1(this.clone().polygons);
      var b = new Node$1(csg.clone().polygons);
      a.invert();
      b.clipTo(a);
      b.invert();
      a.clipTo(b);
      b.clipTo(a);
      a.build(b.allPolygons());
      a.invert();
      return CSG.fromPolygons(a.allPolygons());
    } // Return a new CSG solid with solid and empty space switched. This solid is
    // not modified.

  }, {
    key: "inverse",
    value: function inverse() {
      var csg = this.clone();
      csg.polygons.forEach(function (p) {
        return p.flip();
      });
      return csg;
    }
  }]);

  return CSG;
}();

CSG.fromMesh = undefined;
CSG.toMesh = undefined; // Construct a CSG solid from a list of `Polygon` instances.

CSG.fromPolygons = function (polygons) {
  var csg = new CSG();
  csg.polygons = polygons;
  return csg;
}; // # class Vector
// Represents a 3D vector.
//
// Example usage:
//
//     new CSG.Vector(1, 2, 3);


var Vector = /*#__PURE__*/function () {
  function Vector() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck2(this, Vector);

    this.x = x;
    this.y = y;
    this.z = z;
  }

  _createClass2(Vector, [{
    key: "copy",
    value: function copy(v) {
      this.x = v.x;
      this.y = v.y;
      this.z = v.z;
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Vector(this.x, this.y, this.z);
    }
  }, {
    key: "negate",
    value: function negate() {
      this.x *= -1;
      this.y *= -1;
      this.z *= -1;
      return this;
    }
  }, {
    key: "add",
    value: function add(a) {
      this.x += a.x;
      this.y += a.y;
      this.z += a.z;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(a) {
      this.x -= a.x;
      this.y -= a.y;
      this.z -= a.z;
      return this;
    }
  }, {
    key: "times",
    value: function times(a) {
      this.x *= a;
      this.y *= a;
      this.z *= a;
      return this;
    }
  }, {
    key: "dividedBy",
    value: function dividedBy(a) {
      this.x /= a;
      this.y /= a;
      this.z /= a;
      return this;
    }
  }, {
    key: "lerp",
    value: function lerp(a, t) {
      return this.add(tv0.copy(a).sub(this).times(t));
    }
  }, {
    key: "unit",
    value: function unit() {
      return this.dividedBy(this.length());
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2) + Math.pow(this.z, 2));
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.unit();
    }
  }, {
    key: "cross",
    value: function cross(b) {
      /* let a = this; */
      var ax = this.x,
          ay = this.y,
          az = this.z;
      var bx = b.x,
          by = b.y,
          bz = b.z;
      this.x = ay * bz - az * by;
      this.y = az * bx - ax * bz;
      this.z = ax * by - ay * bx;
      return this;
    }
  }, {
    key: "dot",
    value: function dot(b) {
      return this.x * b.x + this.y * b.y + this.z * b.z;
    }
  }]);

  return Vector;
}(); //Temporaries used to avoid internal allocation..


var tv0 = new Vector();
var tv1 = new Vector(); // # class Vertex
// Represents a vertex of a polygon. Use your own vertex class instead of this
// one to provide additional features like texture coordinates and vertex
// colors. Custom vertex classes need to provide a `pos` property and `clone()`,
// `flip()`, and `interpolate()` methods that behave analogous to the ones
// defined by `CSG.Vertex`. This class provides `normal` so convenience
// functions like `CSG.sphere()` can return a smooth vertex normal, but `normal`
// is not used anywhere else.

var Vertex = /*#__PURE__*/function () {
  function Vertex(pos, normal, uv, color) {
    _classCallCheck2(this, Vertex);

    this.pos = new Vector().copy(pos);
    this.normal = new Vector().copy(normal);
    this.uv = new Vector().copy(uv);
    this.uv.z = 0;
    color && (this.color = new Vector().copy(color));
  }

  _createClass2(Vertex, [{
    key: "clone",
    value: function clone() {
      return new Vertex(this.pos, this.normal, this.uv, this.color);
    } // Invert all orientation-specific data (e.g. vertex normal). Called when the
    // orientation of a polygon is flipped.

  }, {
    key: "flip",
    value: function flip() {
      this.normal.negate();
    } // Create a new vertex between this vertex and `other` by linearly
    // interpolating all properties using a parameter of `t`. Subclasses should
    // override this to interpolate additional properties.

  }, {
    key: "interpolate",
    value: function interpolate(other, t) {
      return new Vertex(this.pos.clone().lerp(other.pos, t), this.normal.clone().lerp(other.normal, t), this.uv.clone().lerp(other.uv, t), this.color && other.color && this.color.clone().lerp(other.color, t));
    }
  }]);

  return Vertex;
}(); // # class Plane
// Represents a plane in 3D space.


var Plane$1 = /*#__PURE__*/function () {
  function Plane$1(normal, w) {
    _classCallCheck2(this, Plane$1);

    this.normal = normal;
    this.w = w;
  }

  _createClass2(Plane$1, [{
    key: "clone",
    value: function clone() {
      return new Plane$1(this.normal.clone(), this.w);
    }
  }, {
    key: "flip",
    value: function flip() {
      this.normal.negate();
      this.w = -this.w;
    } // Split `polygon` by this plane if needed, then put the polygon or polygon
    // fragments in the appropriate lists. Coplanar polygons go into either
    // `coplanarFront` or `coplanarBack` depending on their orientation with
    // respect to this plane. Polygons in front or in back of this plane go into
    // either `front` or `back`.

  }, {
    key: "splitPolygon",
    value: function splitPolygon(polygon, coplanarFront, coplanarBack, front, back) {
      var COPLANAR = 0;
      var FRONT = 1;
      var BACK = 2;
      var SPANNING = 3; // Classify each point as well as the entire polygon into one of the above
      // four classes.

      var polygonType = 0;
      var types = [];

      for (var _i278 = 0; _i278 < polygon.vertices.length; _i278++) {
        var t = this.normal.dot(polygon.vertices[_i278].pos) - this.w;
        var type = t < -Plane$1.EPSILON ? BACK : t > Plane$1.EPSILON ? FRONT : COPLANAR;
        polygonType |= type;
        types.push(type);
      } // Put the polygon in the correct list, splitting it when necessary.


      switch (polygonType) {
        case COPLANAR:
          (this.normal.dot(polygon.plane.normal) > 0 ? coplanarFront : coplanarBack).push(polygon);
          break;

        case FRONT:
          front.push(polygon);
          break;

        case BACK:
          back.push(polygon);
          break;

        case SPANNING:
          {
            var f = [],
                b = [];

            for (var _i279 = 0; _i279 < polygon.vertices.length; _i279++) {
              var j = (_i279 + 1) % polygon.vertices.length;
              var ti = types[_i279],
                  tj = types[j];
              var vi = polygon.vertices[_i279],
                  vj = polygon.vertices[j];
              if (ti != BACK) f.push(vi);
              if (ti != FRONT) b.push(ti != BACK ? vi.clone() : vi);

              if ((ti | tj) == SPANNING) {
                var _t2 = (this.w - this.normal.dot(vi.pos)) / this.normal.dot(tv0.copy(vj.pos).sub(vi.pos));

                var v = vi.interpolate(vj, _t2);
                f.push(v);
                b.push(v.clone());
              }
            }

            if (f.length >= 3) front.push(new Polygon(f, polygon.shared));
            if (b.length >= 3) back.push(new Polygon(b, polygon.shared));
            break;
          }
      }
    }
  }]);

  return Plane$1;
}(); // `Plane.EPSILON` is the tolerance used by `splitPolygon()` to decide if a
// point is on the plane.


Plane$1.EPSILON = 1e-5;

Plane$1.fromPoints = function (a, b, c) {
  var n = tv0.copy(b).sub(a).cross(tv1.copy(c).sub(a)).normalize();
  return new Plane$1(n.clone(), n.dot(a));
}; // # class Polygon
// Represents a convex polygon. The vertices used to initialize a polygon must
// be coplanar and form a convex loop. They do not have to be `Vertex`
// instances but they must behave similarly (duck typing can be used for
// customization).
//
// Each convex polygon has a `shared` property, which is shared between all
// polygons that are clones of each other or were split from the same polygon.
// This can be used to define per-polygon properties (such as surface color).


var Polygon = /*#__PURE__*/function () {
  function Polygon(vertices, shared) {
    _classCallCheck2(this, Polygon);

    this.vertices = vertices;
    this.shared = shared;
    this.plane = Plane$1.fromPoints(vertices[0].pos, vertices[1].pos, vertices[2].pos);
  }

  _createClass2(Polygon, [{
    key: "clone",
    value: function clone() {
      return new Polygon(this.vertices.map(function (v) {
        return v.clone();
      }), this.shared);
    }
  }, {
    key: "flip",
    value: function flip() {
      this.vertices.reverse().map(function (v) {
        return v.flip();
      });
      this.plane.flip();
    }
  }]);

  return Polygon;
}(); // # class Node
// Holds a node in a BSP tree. A BSP tree is built from a collection of polygons
// by picking a polygon to split along. That polygon (and all other coplanar
// polygons) are added directly to that node and the other polygons are added to
// the front and/or back subtrees. This is not a leafy BSP tree since there is
// no distinction between internal and leaf nodes.


var Node$1 = /*#__PURE__*/function () {
  function Node$1(polygons) {
    _classCallCheck2(this, Node$1);

    this.plane = null;
    this.front = null;
    this.back = null;
    this.polygons = [];
    if (polygons) this.build(polygons);
  }

  _createClass2(Node$1, [{
    key: "clone",
    value: function clone() {
      var node = new Node$1();
      node.plane = this.plane && this.plane.clone();
      node.front = this.front && this.front.clone();
      node.back = this.back && this.back.clone();
      node.polygons = this.polygons.map(function (p) {
        return p.clone();
      });
      return node;
    } // Convert solid space to empty space and empty space to solid space.

  }, {
    key: "invert",
    value: function invert() {
      for (var _i280 = 0; _i280 < this.polygons.length; _i280++) {
        this.polygons[_i280].flip();
      }

      this.plane && this.plane.flip();
      this.front && this.front.invert();
      this.back && this.back.invert();
      var temp = this.front;
      this.front = this.back;
      this.back = temp;
    } // Recursively remove all polygons in `polygons` that are inside this BSP
    // tree.

  }, {
    key: "clipPolygons",
    value: function clipPolygons(polygons) {
      if (!this.plane) return polygons.slice();
      var front = [],
          back = [];

      for (var _i281 = 0; _i281 < polygons.length; _i281++) {
        this.plane.splitPolygon(polygons[_i281], front, back, front, back);
      }

      if (this.front) front = this.front.clipPolygons(front);
      if (this.back) back = this.back.clipPolygons(back);else back = [];
      return front.concat(back);
    } // Remove all polygons in this BSP tree that are inside the other BSP tree
    // `bsp`.

  }, {
    key: "clipTo",
    value: function clipTo(bsp) {
      this.polygons = bsp.clipPolygons(this.polygons);
      if (this.front) this.front.clipTo(bsp);
      if (this.back) this.back.clipTo(bsp);
    } // Return a list of all polygons in this BSP tree.

  }, {
    key: "allPolygons",
    value: function allPolygons() {
      var polygons = this.polygons.slice();
      if (this.front) polygons = polygons.concat(this.front.allPolygons());
      if (this.back) polygons = polygons.concat(this.back.allPolygons());
      return polygons;
    } // Build a BSP tree out of `polygons`. When called on an existing tree, the
    // new polygons are filtered down to the bottom of the tree and become new
    // nodes there. Each set of polygons is partitioned using the first polygon
    // (no heuristic is used to pick a good split).

  }, {
    key: "build",
    value: function build(polygons) {
      if (!polygons.length) return;
      if (!this.plane) this.plane = polygons[0].plane.clone();
      var front = [],
          back = [];

      for (var _i282 = 0; _i282 < polygons.length; _i282++) {
        this.plane.splitPolygon(polygons[_i282], this.polygons, this.polygons, front, back);
      }

      if (front.length) {
        if (!this.front) this.front = new Node$1();
        this.front.build(front);
      }

      if (back.length) {
        if (!this.back) this.back = new Node$1();
        this.back.build(back);
      }
    }
  }]);

  return Node$1;
}();

CSG.fromJSON = function (json) {
  return CSG.fromPolygons(json.polygons.map(function (p) {
    return new Polygon(p.vertices.map(function (v) {
      return new Vertex(v.pos, v.normal, v.uv);
    }), p.shared);
  }));
}; // Return a new CSG solid representing space in either this solid or in the
// solid `csg`. Neither this solid nor the solid `csg` are modified.
//
//     A.union(B)
//
//     +-------+            +-------+
//     |       |            |       |
//     |   A   |            |       |
//     |    +--+----+   =   |       +----+
//     +----+--+    |       +----+       |
//          |   B   |            |       |
//          |       |            |       |
//          +-------+            +-------+
//
// Return a new CSG solid representing space in this solid but not in the
// solid `csg`. Neither this solid nor the solid `csg` are modified.
//
//     A.subtract(B)
//
//     +-------+            +-------+
//     |       |            |       |
//     |   A   |            |       |
//     |    +--+----+   =   |    +--+
//     +----+--+    |       +----+
//          |   B   |
//          |       |
//          +-------+
//
// Return a new CSG solid representing space both this solid and in the
// solid `csg`. Neither this solid nor the solid `csg` are modified.
//
//     A.intersect(B)
//
//     +-------+
//     |       |
//     |   A   |
//     |    +--+----+   =   +--+
//     +----+--+    |       +--+
//          |   B   |
//          |       |
//          +-------+
//

/* eslint-disable */
//import {Geometry} from "../three.js-dev/examples/jsm/deprecated/Geometry.js";


CSG.fromGeometry = function (geom, objectIndex) {
  //   if (geom.isBufferGeometry)
  //        geom = new Geometry().fromBufferGeometry(geom)
  var polys = [];

  if (geom.isGeometry) {
    var fs = geom.faces;
    var vs = geom.vertices;
    var fm = ['a', 'b', 'c'];

    for (var _i283 = 0; _i283 < fs.length; _i283++) {
      var f = fs[_i283];
      var vertices = [];

      for (var j = 0; j < 3; j++) {
        vertices.push(new Vertex(vs[f[fm[j]]], f.vertexNormals[j], geom.faceVertexUvs[0][_i283][j]));
      }

      polys.push(new Polygon(vertices, objectIndex));
    }
  } else if (geom.isBufferGeometry) {
    var posattr = geom.attributes.position;
    var normalattr = geom.attributes.normal;
    var uvattr = geom.attributes.uv;
    var colorattr = geom.attributes.color;

    var _index10;

    if (geom.index) _index10 = geom.index.array;else {
      _index10 = new Array(posattr.array.length / posattr.itemSize | 0);

      for (var _i284 = 0; _i284 < _index10.length; _i284++) {
        _index10[_i284] = _i284;
      }
    }
    var triCount = _index10.length / 3 | 0;
    polys = new Array(triCount);

    for (var _i285 = 0, pli = 0, l = _index10.length; _i285 < l; _i285 += 3, pli++) {
      var _vertices = new Array(3);

      for (var _j18 = 0; _j18 < 3; _j18++) {
        var vi = _index10[_i285 + _j18];
        var vp = vi * 3;
        var vt = vi * 2;
        var x = posattr.array[vp];
        var y = posattr.array[vp + 1];
        var z = posattr.array[vp + 2];
        var nx = normalattr.array[vp];
        var ny = normalattr.array[vp + 1];
        var nz = normalattr.array[vp + 2];
        var u = uvattr.array[vt];
        var v = uvattr.array[vt + 1];
        _vertices[_j18] = new Vertex({
          x: x,
          y: y,
          z: z
        }, {
          x: nx,
          y: ny,
          z: nz
        }, {
          x: u,
          y: v,
          z: 0
        }, colorattr && {
          x: colorattr.array[vt],
          y: colorattr.array[vt + 1],
          z: colorattr.array[vt + 2]
        });
      }

      polys[pli] = new Polygon(_vertices, objectIndex);
    }
  } else console.error('Unsupported CSG input type:' + geom.type);

  return CSG.fromPolygons(polys);
};

var ttvv0 = new Vector3();
var tmpm3 = new Matrix3();

CSG.fromMesh = function (mesh, objectIndex) {
  var csg = CSG.fromGeometry(mesh.geometry, objectIndex);
  tmpm3.getNormalMatrix(mesh.matrix);

  for (var _i286 = 0; _i286 < csg.polygons.length; _i286++) {
    var p = csg.polygons[_i286];

    for (var j = 0; j < p.vertices.length; j++) {
      var v = p.vertices[j];
      v.pos.copy(ttvv0.copy(v.pos).applyMatrix4(mesh.matrix));
      v.normal.copy(ttvv0.copy(v.normal).applyMatrix3(tmpm3));
    }
  }

  return csg;
};

var nbuf3 = function nbuf3(ct) {
  return {
    top: 0,
    array: new Float32Array(ct),
    write: function write(v) {
      this.array[this.top++] = v.x;
      this.array[this.top++] = v.y;
      this.array[this.top++] = v.z;
    }
  };
};

var nbuf2 = function nbuf2(ct) {
  return {
    top: 0,
    array: new Float32Array(ct),
    write: function write(v) {
      this.array[this.top++] = v.x;
      this.array[this.top++] = v.y;
    }
  };
};

CSG.toMesh = function (csg, toMatrix, toMaterial) {
  var ps = csg.polygons;
  var geom;
  {
    //BufferGeometry path
    var triCount = 0;
    ps.forEach(function (p) {
      return triCount += p.vertices.length - 2;
    });
    geom = new BufferGeometry();
    var vertices = nbuf3(triCount * 3 * 3);
    var normals = nbuf3(triCount * 3 * 3);
    var uvs = nbuf2(triCount * 2 * 3);
    var colors;
    var grps = [];
    ps.forEach(function (p) {
      var pvs = p.vertices;
      var pvlen = pvs.length;

      if (p.shared !== undefined) {
        if (!grps[p.shared]) grps[p.shared] = [];
      }

      if (pvlen && pvs[0].color !== undefined) {
        if (!colors) colors = nbuf3(triCount * 3 * 3);
      }

      for (var j = 3; j <= pvlen; j++) {
        p.shared !== undefined && grps[p.shared].push(vertices.top / 3, vertices.top / 3 + 1, vertices.top / 3 + 2);
        vertices.write(pvs[0].pos);
        vertices.write(pvs[j - 2].pos);
        vertices.write(pvs[j - 1].pos);
        normals.write(pvs[0].normal);
        normals.write(pvs[j - 2].normal);
        normals.write(pvs[j - 1].normal);
        uvs.write(pvs[0].uv);
        uvs.write(pvs[j - 2].uv);
        uvs.write(pvs[j - 1].uv);
        colors && (colors.write(pvs[0].color) || colors.write(pvs[j - 2].color) || colors.write(pvs[j - 1].color));
      }
    });
    geom.setAttribute('position', new BufferAttribute(vertices.array, 3));
    geom.setAttribute('normal', new BufferAttribute(normals.array, 3));
    geom.setAttribute('uv', new BufferAttribute(uvs.array, 2));
    colors && geom.setAttribute('color', new BufferAttribute(colors.array, 3));

    if (grps.length) {
      var _index11 = [];
      var gbase = 0;

      for (var gi = 0; gi < grps.length; gi++) {
        geom.addGroup(gbase, grps[gi].length, gi);
        gbase += grps[gi].length;
        _index11 = _index11.concat(grps[gi]);
      }

      geom.setIndex(_index11);
    }
  }
  var inv = new Matrix4().copy(toMatrix).invert();
  geom.applyMatrix4(inv);
  geom.computeBoundingSphere();
  geom.computeBoundingBox();
  var m = new Mesh(geom, toMaterial);
  m.matrix.copy(toMatrix);
  m.matrix.decompose(m.position, m.quaternion, m.scale);
  m.rotation.setFromQuaternion(m.quaternion);
  m.updateMatrixWorld();
  m.castShadow = m.receiveShadow = true;
  return m;
};

var UnitSizeInM = 1;
/**
 *
 * @param garbageCollector
 * @param shape
 * @param height
 * @param material
 * @param castShadow
 * @returns
 */

function MeshFromShape(garbageCollector, shape, height, material, castShadow) {
  if (height === void 0) {
    height = null;
  }

  if (material === void 0) {
    material = null;
  }

  if (castShadow === void 0) {
    castShadow = null;
  }

  if (!material) material = garbageCollector.Instantiate(new MeshLambertMaterial()); // if (!material) material = Instantiate(new THREE.MeshBasicMaterial({ vertexColors: true}));

  if (!height) height = 1;
  var extrudeSettings = {
    depth: height,
    bevelEnabled: false
  };
  var geometry = garbageCollector.Instantiate(new ExtrudeGeometry(shape, extrudeSettings));
  var mesh = new Mesh(geometry, material); // calculate bounds(-plotCenter) to set height

  new Box3().setFromObject(mesh).getCenter(mesh.position).multiplyScalar(-1);
  mesh.position.set(0, 0, 0);
  mesh.translateZ(height * 0.5);
  mesh.receiveShadow = true;
  mesh.castShadow = castShadow; // needs to be disabled on certain meshes with certain materials to prevent them from shadowing themselves

  return mesh;
} // Calculates the signed volume of a tetrahedon with the points vertex0, vertex1, vertex2 and (0,0,0)

/**
 *
 * @param vertex0
 * @param vertex1
 * @param vertex2
 * @returns
 */


function GetTetrahedonVolume(vertex0, vertex1, vertex2) {
  return vertex0.dot(vertex1.cross(vertex2)) / 6.0; // Math! https://en.wikipedia.org/wiki/Tetrahedron#Volume
}
/**
 *
 * @param Geometry
 * @returns
 */


function getVolume(Geometry) {
  console.warn('Warning, using deprecated getVolume function, careful with inaccuracies'); // get Volume can be inaccurate when the faces arent indexed

  var Volume = -1;

  if (!Geometry.isBufferGeometry) {
    //THREE.js version <= v124 (due to THREE.Geometry deprecation)
    // geometry triangle index
    for (var i = 0; i < Geometry.faces.length; i++) {
      var vertex0 = Geometry.vertices[Geometry.faces[i].a];
      var vertex1 = Geometry.vertices[Geometry.faces[i].b];
      var vertex2 = Geometry.vertices[Geometry.faces[i].c]; // Add volumes of all signed tetrahedra formed by the polygons with (0,0,0)

      Volume += GetTetrahedonVolume(vertex0.clone(), // needs to clone, otherwise we modify original vertices!
      vertex1.clone(), vertex2.clone());
    }
  } //THREE.js version >= v125 (due to THREE.Geometry deprecation)
  else {
    var isIndexed = Geometry.index !== null;
    var position = Geometry.attributes.position;
    var vertex0 = new Vector3(),
        vertex1 = new Vector3(),
        vertex2 = new Vector3();

    if (!isIndexed) {
      //warning, non indexed volumes are inaccurate/wrong!
      var faces = position.count / 3;

      for (var i = 0; i < faces; i++) {
        vertex0.fromBufferAttribute(position, i * 3 + 0);
        vertex1.fromBufferAttribute(position, i * 3 + 1);
        vertex2.fromBufferAttribute(position, i * 3 + 2);
        Volume += GetTetrahedonVolume(vertex0, vertex1, vertex2);
      }
    } else {
      var index = Geometry.index;
      var faces = index.count / 3;

      for (var i = 0; i < faces; i++) {
        vertex0.fromBufferAttribute(position, index.array[i * 3 + 0]);
        vertex1.fromBufferAttribute(position, index.array[i * 3 + 1]);
        vertex2.fromBufferAttribute(position, index.array[i * 3 + 2]);
        Volume += GetTetrahedonVolume(vertex0, vertex1, vertex2);
      }
    }
  }

  return Volume;
}
/**
 *
 * @param Geometry
 * @returns
 */


function getArea(Geometry$1) {
  if (Geometry$1.isBufferGeometry) {
    //THREE.js version <= v124 (due to THREE.Geometry deprecation)
    var bufferGeometry = Geometry$1;
    Geometry$1 = new Geometry();
    Geometry$1.fromBufferGeometry(bufferGeometry);
  } // geometry triangle index


  var bottomfaces = [];

  for (var i = 0; i < Geometry$1.faces.length; i++) {
    var nor = Geometry$1.faces[i].normal;
    var down = new Vector3(0, 0, -1);
    var isDown = Math.abs(nor.x - down.x) < Number.EPSILON && Math.abs(nor.y - down.y) < Number.EPSILON && Math.abs(nor.z - down.z) < Number.EPSILON;
    if (isDown) bottomfaces.push(Geometry$1.faces[i]);
  }

  var area = 0;

  for (var u = 0; u < bottomfaces.length; u++) {
    var vertex0 = Geometry$1.vertices[bottomfaces[u].a];
    var vertex1 = Geometry$1.vertices[bottomfaces[u].b];
    var vertex2 = Geometry$1.vertices[bottomfaces[u].c];
    var tri = new Triangle(vertex0, vertex1, vertex2);
    area += tri.getArea();
  }

  return area;
}
/**
 *
 * @param level
 * @returns
 */


function CalculateLevelSizes(level) {
  if (level.mesh === undefined) return;
  var area = getArea(level.mesh.geometry);
  var volume = area * level.height;
  level.volume = volume;
  level.area = area;
}
/**
 *
 * @param meshA
 * @param meshB
 * @returns
 */


function meshBoolean(meshA, meshB) {
  //subtracts meshB from meshA (taking their position into account), returning a result mesh with the material and position of meshA
  // make sure meshes are updated
  meshA.updateMatrix();
  meshB.updateMatrix();
  var bspA = CSG.fromMesh(meshA);
  var bspB = CSG.fromMesh(meshB); // subtract

  var meshResult = CSG.toMesh(bspA.subtract(bspB), meshA.matrix, meshA.material); // return result

  return meshResult;
}

function meshUnion(meshA, meshB) {
  // make sure meshes are updated
  meshA.updateMatrix();
  meshB.updateMatrix();
  var bspA = CSG.fromMesh(meshA);
  var bspB = CSG.fromMesh(meshB); // unite

  var meshResult = CSG.toMesh(bspA.union(bspB), meshA.matrix, meshA.material); // return result

  return meshResult;
}
/**
 *
 * @param garbageCollector
 * @param UnitSizeInM
 * @param scene
 * @param level
 * @param material
 * @param height
 * @returns
 */


function InstantiateLevel(garbageCollector, UnitSizeInM, scene, level, material, height) {
  if (material === void 0) {
    material = null;
  }

  if (height === void 0) {
    height = null;
  }

  if (!height) height = level.height;
  var outerShape = level.shapes[0];
  if (outerShape === undefined) return null; //console.log('Instantiate ', level);

  var outer = MeshFromShape(garbageCollector, level.shapes[0], height * UnitSizeInM, material, true);

  for (var i = 1; i < level.shapes.length; i++) {
    outer = meshUnion(outer, MeshFromShape(garbageCollector, level.shapes[i], height * UnitSizeInM, material, true));
  }

  if (level.subShapes && level.subShapes.length > 0) {
    var inner = MeshFromShape(garbageCollector, level.subShapes[0], height * UnitSizeInM, material, true);

    for (var i = 1; i < level.subShapes.length; i++) {
      inner = meshUnion(inner, MeshFromShape(garbageCollector, level.subShapes[i], height * UnitSizeInM, material, true));
    }

    outer = meshBoolean(outer, inner);
  }

  level.mesh = outer;
  scene.add(outer);
  return outer;
}
/**
 *
 * @param guiSettings
 * @param subBuildings
 * @param scene
 * @param garbageCollector
 * @param buildingSettings
 * @param transformControl
 * @param transformControlEnabled
 * @param transformControlObj
 * @param controls
 */


function InstantiateSubBuildings(guiSettings, subBuildings, scene, garbageCollector, transformControl, transformControlEnabled, transformControlObj, boundingBox) {
  var e_1, _a;

  var heightMul = guiSettings.Explode ? 1.01 * 2 : 1; //for debugging

  var ZFightOffset = 0.02; // to avoid Z-Fighting with the plot

  for (var i = 0; i < subBuildings.length; i++) {
    // Instantiate plot subBuilding
    if (subBuildings[i].name === 'plot') {
      var value = subBuildings[i].levelMap.get('0');
      console.log(value);
      if (value.needsUpdate === false) continue; // plot material

      var propmat = garbageCollector.Instantiate(new MeshLambertMaterial({
        opacity: 1,
        transparent: false,
        color: 0x83b09b
      })); // plot extrusion to cut at angle (50 units up and down each)
      // Temp disabled
      // const meshToCut = InstantiateLevel(garbageCollector, UnitSizeInM, scene, value, propmat, 30);

      var meshToCut = InstantiateLevel(garbageCollector, UnitSizeInM, scene, value, propmat, 0.01); // scene.remove(meshToCut);
      // calculate center of the plot at height 0 (the pivot for the rotation)

      var plotCenter = new Vector3();
      new Box3().setFromObject(meshToCut).getCenter(plotCenter);
      meshToCut.translateZ(-plotCenter.z);
      plotCenter.z = 0; // instantiate controls

      if (transformControlObj === undefined) {
        var geometry = new BoxGeometry(1, 1, 1);
        var material = new MeshLambertMaterial({
          transparent: true,
          opacity: 1
        });
        transformControlObj = new Mesh(geometry, material);
        transformControlObj.position.set(plotCenter.x, plotCenter.y, plotCenter.z);

        if (transformControlEnabled) {
          scene.add(transformControlObj);
          transformControl.attach(transformControlObj);
          scene.add(transformControl);
        }
      } else {
        if (transformControlEnabled) {
          scene.add(transformControlObj);
          transformControl.attach(transformControlObj);
          scene.add(transformControl);
        } else {
          scene.remove(transformControl);
          transformControl.current.detach();
          scene.remove(transformControlObj);
        }
      } // the scale of the cutting meshes needs to be fairly large, as when they are rotated they will otherwise miss parts of the meshToCut


      var cuttingScale = 5; // Create Euler Rotation

      var eule = transformControlObj.rotation;
      if (eule.x > Math.PI / 6) eule.x = Math.PI / 6;
      if (eule.x < -Math.PI / 6) eule.x = -Math.PI / 6;
      if (eule.y > Math.PI / 6) eule.y = Math.PI / 6;
      if (eule.y < -Math.PI / 6) eule.y = -Math.PI / 6;
      if (eule.z > Math.PI / 6) eule.z = Math.PI / 6;
      if (eule.z < -Math.PI / 6) eule.z = -Math.PI / 6; // reverse pos is the opposite of the plot center position, but scaled in the same way as the cutting meshes are

      var reversePos = new Vector3(-plotCenter.x * cuttingScale, -plotCenter.y * cuttingScale, -plotCenter.z);
      reversePos = reversePos.applyEuler(eule);
      reversePos = reversePos.add(plotCenter); // top cutting mesh

      var topCutMesh = MeshFromShape(garbageCollector, value.shapes[0], 100, propmat);
      topCutMesh.scale.set(cuttingScale, cuttingScale, 1);
      topCutMesh.position.set(reversePos.x, reversePos.y, reversePos.z);
      topCutMesh.setRotationFromEuler(eule); // bottom cutting mesh

      var bottomCutMesh = MeshFromShape(garbageCollector, value.shapes[0], 100, propmat);
      bottomCutMesh.scale.set(cuttingScale, cuttingScale, 1);
      bottomCutMesh.position.set(reversePos.x, reversePos.y, reversePos.z);
      bottomCutMesh.setRotationFromEuler(eule);
      bottomCutMesh.translateZ(-100.1); // calculate final result
      // let finalmesh = meshBoolean(meshToCut, topCutMesh);
      // finalmesh = meshBoolean(finalmesh, bottomCutMesh);
      // Temp Disabled
      // scene.add(finalmesh);
      // Center Camera on plot
      // const controlTarget = new THREE.Vector3();
      // new THREE.Box3().setFromObject(meshToCut).getCenter(controlTarget);
      // controls.current.target.set(controlTarget.x, controlTarget.y, 0);
      // contextObject.orthoCamera.position.set(controlTarget.x, controlTarget.y, 5);
      // contextObject.orthoCamera.lookAt(controlTarget.x, controlTarget.y, 0);
      // Calculate Area
      // const calcMesh = MeshFromShape(garbageCollector, value.shapes[0], 1, propmat);
      // value.area = getArea(calcMesh.geometry);
      // value.area = Math.abs(THREE.ShapeUtils.area(value.shapes[0].extractPoints(0).shape));

      value.needsUpdate = false;
      meshToCut.castShadow = false;
      meshToCut.receiveShadow = true;
      value.mesh = meshToCut; // value.mesh = finalmesh;

      CalculateLevelSizes(value);
      continue;
    } // skipping all this if the subbuilding is the plot //////////////////////////
    // building materials


    var color = new Color(0xffffff);
    /* color.setHex(Math.random() * 0xffffff); */

    var buildmat = garbageCollector.Instantiate(new MeshLambertMaterial({
      opacity: 0.8,
      transparent: true,
      color: color
    }));

    try {
      // Instantiate all levels of all subbuildings
      for (var _b = (e_1 = void 0, __values(subBuildings[i].levelMap.keys())), _c = _b.next(); !_c.done; _c = _b.next()) {
        var key = _c.value;
        var mesh = void 0;
        var value = subBuildings[i].levelMap.get(key);
        var index = parseInt(key);

        if (index >= 0) {
          // ground level and higher
          if (value.mesh === undefined) mesh = InstantiateLevel(garbageCollector, UnitSizeInM, scene, value, buildmat);else if (value.needsUpdate) {
            scene.remove(value.mesh);
            mesh = InstantiateLevel(garbageCollector, UnitSizeInM, scene, value);
          } else mesh = value.mesh;
          if (mesh === null) continue;
          mesh.position.set(0, 0, 0);
          mesh.translateZ(subBuildings[i].referenceZeroHeight);

          for (var u = 0; u < index; u++ // translateZ by the height value of all levels below to the ground
          ) {
            mesh.translateZ(ZFightOffset);
            mesh.translateZ(subBuildings[i].levelMap.get(u.toString()).height * UnitSizeInM * heightMul);
          }
        } else if (index < 0) {
          // underground levels
          var undergroundMat = new MeshLambertMaterial({
            color: 0x969696
          });
          if (value.mesh === undefined) mesh = InstantiateLevel(garbageCollector, UnitSizeInM, scene, value, undergroundMat);else if (value.needsUpdate) {
            scene.remove(value.mesh);
            mesh = InstantiateLevel(garbageCollector, UnitSizeInM, scene, value, undergroundMat);
          } else mesh = value.mesh;
          if (mesh === null) continue;
          mesh.position.set(0, 0, 0);
          mesh.translateZ(subBuildings[i].referenceZeroHeight);

          for (var u = -1; u >= index; u-- // translateZ by the height value of all levels above to the ground
          ) {
            mesh.translateZ(-ZFightOffset);
            mesh.translateZ(-subBuildings[i].levelMap.get(u.toString()).height * UnitSizeInM * heightMul);
          }
        } // Create outline if enabled


        if (guiSettings.Outlines) {
          if (value.outlineMesh === undefined) {
            var edges = garbageCollector.Instantiate(new EdgesGeometry(mesh.geometry));
            var line = new LineSegments(edges, garbageCollector.Instantiate(new LineBasicMaterial({
              color: guiSettings.OutlineColor
            })));
            scene.add(line);
            line.position.set(mesh.position.x, mesh.position.y, mesh.position.z); //loadedAssetGroups.push(line);

            value.outlineMesh = line;
          } else if (value.needsUpdate) {
            scene.remove(value.outlineMesh); //loadedAssetGroups.splice(loadedAssetGroups.indexOf(value.outlineMesh));

            var edges = garbageCollector.Instantiate(new EdgesGeometry(mesh.geometry));
            var line = new LineSegments(edges, garbageCollector.Instantiate(new LineBasicMaterial({
              color: guiSettings.OutlineColor
            })));
            scene.add(line);
            line.position.set(mesh.position.x, mesh.position.y, mesh.position.z); //loadedAssetGroups.push(line);

            value.outlineMesh = line;
          } else {
            value.outlineMesh.position.set(mesh.position.x, mesh.position.y, mesh.position.z);
          }
        } else {
          if (value.outlineMesh !== undefined) {
            scene.remove(value.outlineMesh); //loadedAssetGroups.splice(loadedAssetGroups.indexOf(value.outlineMesh));

            value.outlineMesh = undefined;
          }
        }

        value.needsUpdate = false; // update bounding box

        boundingBox.expandByObject(mesh);
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }

  return transformControlObj;
}

function checkIntersections(pos, currentCamera, scene) {
  var ray = new Raycaster();
  ray.setFromCamera(pos, currentCamera);
  var intersects = ray.intersectObjects(scene.children);
  var list = [];

  if (intersects.length > 0) {
    list.push(intersects[0].object);
  }

  console.log('interectionlist: ', list);
  return list;
}

function GetSubBuildingByName(subBuildings, name) {
  var returnedValue;

  for (var index = 0; index < subBuildings.length; index++) {
    if (subBuildings[index].name === name) returnedValue = subBuildings[index];
  }

  return returnedValue;
}

function CalculateSA(subBuildings) {
  var resultArea = 0;
  var plotSB = GetSubBuildingByName(subBuildings, 'plot');

  if (plotSB) {
    var levelMap = plotSB.levelMap.get('0');
    if (levelMap != undefined) resultArea = levelMap.area;
  }

  return resultArea;
} //*********************************************************************************** */


function CalculateESA(subBuildings) {
  var resultArea = 0;
  var subBuildingArea = 0;
  subBuildings.forEach(function (subBuilding) {
    var levelMap = subBuilding.levelMap.get('0');
    if (subBuilding.name !== 'plot' && levelMap !== undefined) subBuildingArea += levelMap.area;
  });
  var plotSB = GetSubBuildingByName(subBuildings, 'plot');

  if (plotSB) {
    var levelMap = plotSB.levelMap.get('0');

    if (levelMap != undefined) {
      console.log('ESA plotarea', levelMap.area);
      resultArea = levelMap.area - subBuildingArea;
      if (resultArea < 0) resultArea = 0;
      if (resultArea > levelMap.area) resultArea = levelMap.area;
    }
  }

  console.log('ESA subBuildingArea', subBuildingArea);
  console.log('ESA resultarea', resultArea);
  return resultArea;
} //*********************************************************************************** */


function CalculateFA(subBuildings) {
  var FA = 0;
  subBuildings.forEach(function (subBuilding) {
    var e_1, _a;

    if (subBuilding.name !== 'plot') {
      try {
        for (var _b = __values(subBuilding.levelMap), _c = _b.next(); !_c.done; _c = _b.next()) {
          var _d = __read(_c.value, 2),
              value = _d[1];

          FA += value.area;
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    }
  });
  return FA;
} //*********************************************************************************** */


function CalculateBV(subBuildings) {
  //roof not counted
  var BV = 0;
  subBuildings.forEach(function (subBuilding) {
    var e_2, _a;

    if (subBuilding.name !== 'plot') {
      try {
        for (var _b = __values(subBuilding.levelMap), _c = _b.next(); !_c.done; _c = _b.next()) {
          var _d = __read(_c.value, 2),
              value = _d[1];

          BV += value.volume;
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    }
  });
  return BV;
} //*********************************************************************************** */


function CalculateFGA(garbageCollector, subBuildings) {
  var FGA = 0;
  subBuildings.forEach(function (subBuilding) {
    var e_3, _a;

    if (subBuilding.name != 'plot') {
      var _loop_1 = function _loop_1(value) {
        if (value === undefined) return "continue";
        var geo = new Geometry();

        if (value.mesh !== undefined) {
          // annoying buffergeometry needs to converted!
          geo = new Geometry();
          geo = garbageCollector.Instantiate(new Geometry().fromBufferGeometry(value.mesh.geometry));
          geo.faces.forEach(function (face) {
            var norm = face.normal.clone().multiplyScalar(100).round().multiplyScalar(0.01); //round to two decimals

            if (norm.dot(new Vector3(0, 0, 1)) == 0) {
              var t = new Triangle(geo.vertices[face.a], geo.vertices[face.b], geo.vertices[face.c]);
              FGA += t.getArea();
            }
          });
        }
      };

      try {
        for (var _b = __values(subBuilding.levelMap), _c = _b.next(); !_c.done; _c = _b.next()) {
          var _d = __read(_c.value, 2),
              value = _d[1];

          _loop_1(value);
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
    }
  });
  subBuildings.forEach(function (subBuilding) {
    var e_4, _a;

    if (subBuilding.name != 'plot') {
      var _loop_2 = function _loop_2(key, value) {
        if (+key < 1 || value === undefined) return "continue"; ///////////////////////////////// GET COMBINED MESH OF LOWER LEVEL (Same function as InstantiateLevel)

        var lowerLevel = subBuilding.levelMap.get(String(+key - 1));
        var mat = new MeshBasicMaterial({
          color: new Color(0, 1, 0)
        });
        if (lowerLevel.shapes === undefined || lowerLevel.shapes.length < 1) return "continue";
        var outer = MeshFromShape(garbageCollector, lowerLevel.shapes[0], 20, mat, true);

        for (var i = 1; i < lowerLevel.shapes.length; i++) {
          outer = meshUnion(outer, MeshFromShape(garbageCollector, lowerLevel.shapes[i], 20, mat, true));
        }

        if (lowerLevel.subShapes && lowerLevel.subShapes.length > 0) {
          var inner = MeshFromShape(garbageCollector, lowerLevel.subShapes[0], 20, mat, true);

          for (var i = 1; i < lowerLevel.subShapes.length; i++) {
            inner = meshUnion(inner, MeshFromShape(garbageCollector, lowerLevel.subShapes[i], 20, mat, true));
          }

          outer = meshBoolean(outer, inner);
        } ////////////////////////////////
        // const res = GeoHandler.meshBoolean(mesh, GeoHandler.MeshFromShape(subBuilding.levelMap.get(String(+key - 1)).shape, 20, new THREE.MeshBasicMaterial({ color: new THREE.Color(0, 1, 0) })));


        if (value.mesh !== undefined) {
          var res = meshBoolean(value.mesh, outer);
          var geo_1 = garbageCollector.Instantiate(new Geometry().fromBufferGeometry(res.geometry));
          geo_1.computeFaceNormals();
          geo_1.faces.forEach(function (face) {
            var norm = face.normal.clone().multiplyScalar(100).round().multiplyScalar(0.01); //round to two decimals

            if (norm.equals(new Vector3(0, 0, -1))) {
              var t = new Triangle(geo_1.vertices[face.a], geo_1.vertices[face.b], geo_1.vertices[face.c]);
              FGA += t.getArea();
            }
          });
        }
      };

      try {
        for (var _b = __values(subBuilding.levelMap), _c = _b.next(); !_c.done; _c = _b.next()) {
          var _d = __read(_c.value, 2),
              key = _d[0],
              value = _d[1];

          _loop_2(key, value);
        }
      } catch (e_4_1) {
        e_4 = {
          error: e_4_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_4) throw e_4.error;
        }
      }
    }
  });
  return FGA;
} //*********************************************************************************** */


function CalculateBRA(garbageCollector, subBuildings) {
  var e_5, _a;

  var BRA = 0; //#region oldImplementation
  // subBuildings.forEach((subBuilding: SubBuilding) => {
  //     if (subBuilding.name !== 'plot') {
  //         for (const [key, value] of subBuilding.levelMap) {
  //             if (subBuilding.levelMap.get(key + 1) !== undefined) {
  //                 ///////////////////////////////// GET COMBINED MESH OF HIGHER LEVEL (Same function as InstantiateLevel)
  //                 const higherlevel = subBuilding.levelMap.get(key + 1);
  //                 const mat = new THREE.MeshBasicMaterial({ color: new THREE.Color(0, 1, 0) });
  //                 if (higherlevel.shapes === undefined || higherlevel.shapes.length < 1) continue;
  //                 let outer = GeoHandler.MeshFromShape(garbageCollector, higherlevel.shapes[0], 20, mat, true);
  //                 for (let i = 1; i < higherlevel.shapes.length; i++) {
  //                     outer = GeoHandler.meshUnion(
  //                         outer,
  //                         GeoHandler.MeshFromShape(garbageCollector, higherlevel.shapes[i], 20, mat, true)
  //                     );
  //                 }
  //                 if (higherlevel.subShapes && higherlevel.subShapes.length > 0) {
  //                     let inner = GeoHandler.MeshFromShape(garbageCollector, higherlevel.subShapes[0], 20, mat, true);
  //                     for (let i = 1; i < higherlevel.subShapes.length; i++) {
  //                         inner = GeoHandler.meshUnion(
  //                             inner,
  //                             GeoHandler.MeshFromShape(garbageCollector, higherlevel.subShapes[i], 20, mat, true)
  //                         );
  //                     }
  //                     outer = GeoHandler.meshBoolean(outer, inner);
  //                 }
  //                 ////////////////////////////////
  //                 const res: any = GeoHandler.meshBoolean(value.mesh, outer);
  //                 const geo = garbageCollector.Instantiate(new THREE.Geometry().fromBufferGeometry(res.geometry));
  //                 geo.computeFaceNormals();
  //                 geo.faces.forEach((face: THREE.Face3) => {
  //                     const norm = face.normal.clone().multiplyScalar(100).round().multiplyScalar(0.01); //round to two decimals
  //                     if (norm.dot(new THREE.Vector3(0, 0, 1)) != 0 && norm.z > 0) {
  //                         const t = new THREE.Triangle(
  //                             geo.vertices[face.a],
  //                             geo.vertices[face.b],
  //                             geo.vertices[face.c]
  //                         );
  //                         BRA += t.getArea();
  //                         console.log('BRATest', BRA);
  //                     }
  //                 });
  //             } else if (subBuilding.hasRoof && subBuilding.roofMesh !== undefined) {
  //                 let geo = new THREE.Geometry();
  //                 if (value.mesh !== undefined) {
  //                     if (value.mesh.geometry.type == 'BufferGeometry') {
  //                         // annoying buffergeometry needs to converted!
  //                         geo = new THREE.Geometry();
  //                         geo = garbageCollector.Instantiate(
  //                             new THREE.Geometry().fromBufferGeometry(value.mesh.geometry as BufferGeometry)
  //                         );
  //                     } else geo = value.mesh.geometry as Geometry;
  //                     geo.computeFaceNormals();
  //                     geo.faces.forEach((face: THREE.Face3) => {
  //                         const norm = face.normal.clone().multiplyScalar(100).round().multiplyScalar(0.01); //round to two decimals
  //                         if (norm.dot(new THREE.Vector3(0, 0, 1)) != 0 && norm.z > 0) {
  //                             const t = new THREE.Triangle(
  //                                 geo.vertices[face.a],
  //                                 geo.vertices[face.b],
  //                                 geo.vertices[face.c]
  //                             );
  //                             BRA += t.getArea();
  //                             console.log('BRATest', BRA);
  //                         }
  //                     });
  //                 }
  //             } else {
  //                 let geo = new THREE.Geometry();
  //                 if (value.mesh !== undefined) {
  //                     if (value.mesh.geometry.type == 'BufferGeometry') {
  //                         // annoying buffergeometry needs to converted!
  //                         geo = new THREE.Geometry();
  //                         geo = garbageCollector.Instantiate(
  //                             new THREE.Geometry().fromBufferGeometry(value.mesh.geometry as BufferGeometry)
  //                         );
  //                     } else geo = value.mesh.geometry as Geometry;
  //                     geo.computeFaceNormals();
  //                     geo.faces.forEach((face: THREE.Face3) => {
  //                         const norm = face.normal.clone().multiplyScalar(100).round().multiplyScalar(0.01); //round to two decimals
  //                         if (norm.dot(new THREE.Vector3(0, 0, 1)) != 0 && norm.z > 0) {
  //                             const t = new THREE.Triangle(
  //                                 geo.vertices[face.a],
  //                                 geo.vertices[face.b],
  //                                 geo.vertices[face.c]
  //                             );
  //                             BRA += t.getArea();
  //                             console.log('BRATest', BRA);
  //                         }
  //                     });
  //                 }
  //             }
  //         }
  //     }
  // });
  //#endregion
  // BUILDING

  for (var i = 0; i < subBuildings.length; i++) {
    if (subBuildings[i].name == 'plot') continue;
    console.log('BRA Building', subBuildings[i]); // FLOORS

    var reverseLevels = [];

    try {
      for (var _b = (e_5 = void 0, __values(subBuildings[i].levelMap)), _c = _b.next(); !_c.done; _c = _b.next()) {
        var _d = __read(_c.value, 2),
            key = _d[0],
            value = _d[1];

        value.floorNumber = Number(key);
        reverseLevels.push(value);
      }
    } catch (e_5_1) {
      e_5 = {
        error: e_5_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_5) throw e_5.error;
      }
    }

    console.log('BRA reverselevels', reverseLevels);

    if (reverseLevels[0] && !reverseLevels[0].needsUpdate) {
      BRA += reverseLevels[0].area;
      console.log('adding to BRA for Level', reverseLevels[0].floorNumber, reverseLevels[0].area);
    }

    var _loop_3 = function _loop_3(u) {
      if (!reverseLevels[u] || reverseLevels[u].needsUpdate) return "continue";

      if (!reverseLevels[u - 1] || reverseLevels[u - 1].needsUpdate) {
        BRA += reverseLevels[u].area;
        console.log('adding to BRA for Level', reverseLevels[u].floorNumber, reverseLevels[u].area);
        return "continue";
      }

      var higherLevelmesh = reverseLevels[u - 1].mesh;
      var subtractMesh = higherLevelmesh.clone();
      subtractMesh.scale.set(1, 1, 100);
      subtractMesh.position.set(subtractMesh.position.x, subtractMesh.position.y, reverseLevels[u].mesh.position.z);
      var diffMesh = meshBoolean(reverseLevels[u].mesh, subtractMesh);
      var geoArea = 0;
      var geo = garbageCollector.Instantiate(new Geometry().fromBufferGeometry(diffMesh.geometry));
      geo.computeFaceNormals();
      geo.faces.forEach(function (face) {
        var norm = face.normal.clone().multiplyScalar(100).round().multiplyScalar(0.01); //round to two decimals

        if (norm.dot(new Vector3(0, 0, 1)) != 0 && norm.z > 0) {
          var t = new Triangle(geo.vertices[face.a], geo.vertices[face.b], geo.vertices[face.c]);
          geoArea += t.getArea();
        }
      });
      console.log('adding to BRA for Level', reverseLevels[u].floorNumber, geoArea);
      BRA += geoArea;
    };

    for (var u = 1; u < reverseLevels.length; u++) {
      _loop_3(u);
    }
  }

  console.log('BRA', BRA);
  return BRA;
}

function CalculateLevelSizes$1(level) {
  if (level.mesh === undefined) return;
  level.area = 0;
  level.volume = 0;
  level.area = getArea(level.mesh.geometry);
  level.volume = level.area * level.height;
}

var Level =
/** @class */
function () {
  function Level(shapes, height, subShapes) {
    if (height === void 0) {
      height = null;
    }

    if (subShapes === void 0) {
      subShapes = null;
    }

    this.shapes = shapes; // reference to (outer) shape created from the dxf input data. which shape is set here is currently determined by a Id in the input json.

    this.height = 1;

    if (height) {
      this.height = height; // start value should read from the json
    }

    this.subShapes = []; // reference to (inner) shapes created from the dxf input data. which shapes are set here is currently determined by a Id in the input json. these shapes will be subtracted from the outer shape to create the final mesh.

    if (subShapes) this.subShapes = subShapes;
    this.needsUpdate = true;
    this.mesh = undefined; // reference to a instantiated mesh created from the shapes

    this.outlineMesh = undefined; // reference to a instantiated mesh created from the shapes

    this.volume = -1; // calculated volume of the level

    this.area = -1; // calculated area of the entire level
  }

  return Level;
}();

var SubBuilding =
/** @class */
function () {
  function SubBuilding(name, referenceZeroHeight, levelMap, hasRoof) {
    this.name = name;
    this.referenceZeroHeight = referenceZeroHeight;
    this.levelMap = levelMap; // map of all levels of the building where the key is the level as an integer (e.g. -1, 0, 1, 2, etc...)

    this.hasRoof = hasRoof; // wether to add a roof on top of the highest level

    this.roofMesh = undefined;
  }

  return SubBuilding;
}();
/**
 *
 */


function CreateBuildingDataStructure(planData, drawingData, generatedData, garbageCollector) {
  // Cleanup existing data.
  generatedData.subBuildings = []; // The plot is a seperate data point in the json, but we treat it as a subbuilding to reuse more code
  // though in turn the plot subuilding has to be exlicitly ignored in some cases

  if (planData !== undefined && planData.contours && planData.contours.length > 0) {
    // create SubBuilding object with empty map
    var plotSubBuilding = new SubBuilding('plot', 0, new Map(), false); // define Levels (plot only has one level) shape and height from json data

    console.log('Before ContourSort: ', planData.contours);
    planData.contours.forEach(function (element) {
      console.log('ContourSort areas: ', drawingData.drawingContours[parseInt(element)].id, drawingData.drawingContours[parseInt(element)].area);
    });
    planData.contours.sort(function (a, b) {
      return drawingData.drawingContours[parseInt(b)].area - drawingData.drawingContours[parseInt(a)].area;
    });
    console.log('After ContourSort: ', planData.contours); // check for inner shapes

    var innerContours = [];
    var outerContours = [];

    for (var i = 0; i < planData.contours.length; i++) {
      var c_id = planData.contours[i];

      if (c_id) {
        var thisMesh = MeshFromShape(garbageCollector, drawingData.drawingContours[parseInt(c_id)].shape);

        for (var u = 0; u < planData.contours.length; u++) {
          var o_id = planData.contours[u];

          if (c_id != o_id) {
            if (o_id) {
              var otherMesh = MeshFromShape(garbageCollector, drawingData.drawingContours[parseInt(o_id)].shape);
              var res = meshBoolean(thisMesh, otherMesh);

              if (getVolume(res.geometry) == -1 && !innerContours.includes(c_id)) {
                innerContours.push(c_id);
              }
            }
          }
        }
      }
    }

    for (var i = 0; i < planData.contours.length; i++) {
      if (!innerContours.includes(planData.contours[i])) {
        outerContours.push(planData.contours[i]);
      }
    }

    var outerShapes = [];

    for (var i = 0; i < outerContours.length; i++) {
      outerShapes.push(drawingData.drawingContours[parseInt(outerContours[i])].shape);
    }

    var innerShapes = [];

    for (var i = 0; i < innerContours.length; i++) {
      innerShapes.push(drawingData.drawingContours[parseInt(innerContours[i])].shape);
    } // define rest of the leveldata (outer shape and height) from json data


    var level = new Level(outerShapes, 0.01, innerShapes); // for compatibility with THREE.CSG, the plot cant be a plane, instead its just a extrusion with height 0.01
    // set level 0 of the plot subbuilding to the created level

    plotSubBuilding.levelMap.set('0', level); // add plot subbuilding to the subbuildings array

    generatedData.subBuildings.push(plotSubBuilding);
  } // Create all other subuildings from json data


  if (planData !== undefined && planData.buildings) {
    planData.buildings.forEach(function (building) {
      // create SubBuilding object with empty map
      var subBuilding = new SubBuilding(building.name, building.referenceZeroHeight, new Map(), false);
      building.floors.forEach(function (floor) {
        // console.log('CHECKING FLOOR', floor);
        // json floorNumbers are always positive, only underground floors have their type set to UNDER_GROUND,
        // which we have to change to a negative integer to use the floorNumber as key for the map that saves our levels in each subbuilding
        var signedFloorNumber = 0;

        if (floor.floorType === 'ABOVE_GROUND' || floor.floorType === 'GROUND') {
          signedFloorNumber = Number(floor.floorNumber);
        } else {
          signedFloorNumber = -Number(floor.floorNumber);
        } // check for inner shapes


        var innerContours = [];
        var outerContours = [];

        for (var i = 0; i < floor.contours.length; i++) {
          var c_id = floor.contours[i];

          if (c_id) {
            var thisMesh = MeshFromShape(garbageCollector, drawingData.drawingContours[parseInt(c_id)].shape);

            for (var u = 0; u < floor.contours.length; u++) {
              var o_id = floor.contours[u];

              if (c_id != o_id) {
                if (o_id) {
                  var otherMesh = MeshFromShape(garbageCollector, drawingData.drawingContours[parseInt(o_id)].shape);
                  var res = meshBoolean(thisMesh, otherMesh);

                  if (getVolume(res.geometry) == -1 && !innerContours.includes(c_id)) {
                    innerContours.push(c_id);
                  }
                }
              }
            }
          }
        }

        for (var i = 0; i < floor.contours.length; i++) {
          if (!innerContours.includes(floor.contours[i])) {
            outerContours.push(floor.contours[i]);
          }
        }

        var outerShapes = [];

        for (var i = 0; i < outerContours.length; i++) {
          outerShapes.push(drawingData.drawingContours[parseInt(outerContours[i])].shape);
        }

        var innerShapes = [];

        for (var i = 0; i < innerContours.length; i++) {
          innerShapes.push(drawingData.drawingContours[parseInt(innerContours[i])].shape);
        } // define rest of the leveldata (outer shape and height) from json data


        var level = new Level(outerShapes, Number(floor.height), innerShapes);
        if (floor.id != undefined) level.id = floor.id; // set level with its floorNumber as integer as key of the map

        subBuilding.levelMap.set(signedFloorNumber.toString(), level);
      }); // add to the subbuildings array

      generatedData.subBuildings.push(subBuilding);
    });
  }
}
/**
 *
 */


function UpdateDataRepresentation2(planData, generatedData, garbageCollector) {
  if (generatedData !== undefined) {
    generatedData.floorAreas = []; //iterate through json

    planData.buildings.forEach(function (dataBuilding) {
      var loadedBuilding = GetSubBuildingByName(generatedData.subBuildings, dataBuilding.name);
      dataBuilding.floors.forEach(function (dataFloor) {
        var signedFloorNumber = 0;

        if (dataFloor.floorType !== 'UNDER_GROUND') {
          signedFloorNumber = Number(dataFloor.floorNumber);
        } else {
          signedFloorNumber = -Number(dataFloor.floorNumber);
        }

        var loadedFloor = loadedBuilding.levelMap.get(signedFloorNumber.toString()); // Push floor areas for callback.

        generatedData.floorAreas.push({
          floorId: dataFloor.id,
          area: loadedFloor.area
        });
        dataFloor.height = loadedFloor.height;
      });
    });
    console.log(garbageCollector); // get quantity calculations

    generatedData.quantities.forEach(function (element) {
      switch (element.name) {
        case 'SA':
          element.value = CalculateSA(generatedData.subBuildings);
          break;

        case 'FA':
          element.value = CalculateFA(generatedData.subBuildings);
          break;

        case 'BV':
          element.value = CalculateBV(generatedData.subBuildings);
          break;

        case 'FGA':
          element.value = CalculateFGA(garbageCollector, generatedData.subBuildings);
          break;

        case 'FGMA':
          // in case of shape models identical to FGA
          element.value = CalculateFGA(garbageCollector, generatedData.subBuildings);
          break;

        case 'BRA':
          element.value = CalculateBRA(garbageCollector, generatedData.subBuildings);
          break;

        case 'ESA':
          element.value = CalculateESA(generatedData.subBuildings);
          break;
      }
    });
  }
}
/**
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  height: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float>, // how far from text outline (including bevelOffset) is bevel
 *  bevelOffset: <float> // how far from text outline does bevel start
 * }
 */


var TextGeometry = /*#__PURE__*/function (_ExtrudeGeometry) {
  _inherits(TextGeometry, _ExtrudeGeometry);

  var _super89 = _createSuper(TextGeometry);

  function TextGeometry(text) {
    var _this82;

    var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck2(this, TextGeometry);

    var font = parameters.font;

    if (font === undefined) {
      _this82 = _super89.call(this); // generate default extrude geometry
    } else {
      var shapes = font.generateShapes(text, parameters.size); // translate parameters to ExtrudeGeometry API

      parameters.depth = parameters.height !== undefined ? parameters.height : 50; // defaults

      if (parameters.bevelThickness === undefined) parameters.bevelThickness = 10;
      if (parameters.bevelSize === undefined) parameters.bevelSize = 8;
      if (parameters.bevelEnabled === undefined) parameters.bevelEnabled = false;
      _this82 = _super89.call(this, shapes, parameters);
    }

    _this82.type = 'TextGeometry';
    return _possibleConstructorReturn(_this82);
  }

  return TextGeometry;
}(ExtrudeGeometry);

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}
/* eslint-disable */


createCommonjsModule(function (module, exports) {
  /*
   *  base64.js
   *
   *  Licensed under the BSD 3-Clause License.
   *    http://opensource.org/licenses/BSD-3-Clause
   *
   *  References:
   *    http://en.wikipedia.org/wiki/Base64
   */
  (function (global, factory) {
    module.exports = factory(global);
  })(typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal, function (global) {
    // existing version for noConflict()
    global = global || {};
    var _Base64 = global.Base64;
    var version = '2.6.4'; // constants

    var b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

    var b64tab = function (bin) {
      var t = {};

      for (var i = 0, l = bin.length; i < l; i++) {
        t[bin.charAt(i)] = i;
      }

      return t;
    }(b64chars);

    var fromCharCode = String.fromCharCode; // encoder stuff

    var cb_utob = function cb_utob(c) {
      if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
      } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xd800) * 0x400 + (c.charCodeAt(1) - 0xdc00);
        return fromCharCode(0xf0 | cc >>> 18 & 0x07) + fromCharCode(0x80 | cc >>> 12 & 0x3f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
      }
    };

    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;

    var utob = function utob(u) {
      return u.replace(re_utob, cb_utob);
    };

    var cb_encode = function cb_encode(ccc) {
      var padlen = [0, 2, 1][ccc.length % 3],
          ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0),
          chars = [b64chars.charAt(ord >>> 18), b64chars.charAt(ord >>> 12 & 63), padlen >= 2 ? '=' : b64chars.charAt(ord >>> 6 & 63), padlen >= 1 ? '=' : b64chars.charAt(ord & 63)];
      return chars.join('');
    };

    var btoa = global.btoa && typeof global.btoa == 'function' ? function (b) {
      return global.btoa(b);
    } : function (b) {
      if (b.match(/[^\x00-\xFF]/)) throw new RangeError('The string contains invalid characters.');
      return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };

    var _encode = function _encode(u) {
      return btoa(utob(String(u)));
    };

    var mkUriSafe = function mkUriSafe(b64) {
      return b64.replace(/[+\/]/g, function (m0) {
        return m0 == '+' ? '-' : '_';
      }).replace(/=/g, '');
    };

    var encode = function encode(u, urisafe) {
      return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
    };

    var encodeURI = function encodeURI(u) {
      return encode(u, true);
    };

    var fromUint8Array;
    if (global.Uint8Array) fromUint8Array = function fromUint8Array(a, urisafe) {
      // return btoa(fromCharCode.apply(null, a));
      var b64 = '';

      for (var i = 0, l = a.length; i < l; i += 3) {
        var a0 = a[i],
            a1 = a[i + 1],
            a2 = a[i + 2];
        var ord = a0 << 16 | a1 << 8 | a2;
        b64 += b64chars.charAt(ord >>> 18) + b64chars.charAt(ord >>> 12 & 63) + (typeof a1 != 'undefined' ? b64chars.charAt(ord >>> 6 & 63) : '=') + (typeof a2 != 'undefined' ? b64chars.charAt(ord & 63) : '=');
      }

      return urisafe ? mkUriSafe(b64) : b64;
    }; // decoder stuff

    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;

    var cb_btou = function cb_btou(cccc) {
      switch (cccc.length) {
        case 4:
          var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3),
              offset = cp - 0x10000;
          return fromCharCode((offset >>> 10) + 0xd800) + fromCharCode((offset & 0x3ff) + 0xdc00);

        case 3:
          return fromCharCode((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));

        default:
          return fromCharCode((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
      }
    };

    var btou = function btou(b) {
      return b.replace(re_btou, cb_btou);
    };

    var cb_decode = function cb_decode(cccc) {
      var len = cccc.length,
          padlen = len % 4,
          n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0) | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0) | (len > 2 ? b64tab[cccc.charAt(2)] << 6 : 0) | (len > 3 ? b64tab[cccc.charAt(3)] : 0),
          chars = [fromCharCode(n >>> 16), fromCharCode(n >>> 8 & 0xff), fromCharCode(n & 0xff)];
      chars.length -= [0, 0, 2, 1][padlen];
      return chars.join('');
    };

    var _atob = global.atob && typeof global.atob == 'function' ? function (a) {
      return global.atob(a);
    } : function (a) {
      return a.replace(/\S{1,4}/g, cb_decode);
    };

    var atob = function atob(a) {
      return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ''));
    };

    var _decode = function _decode(a) {
      return btou(_atob(a));
    };

    var _fromURI = function _fromURI(a) {
      return String(a).replace(/[-_]/g, function (m0) {
        return m0 == '-' ? '+' : '/';
      }).replace(/[^A-Za-z0-9\+\/]/g, '');
    };

    var decode = function decode(a) {
      return _decode(_fromURI(a));
    };

    var toUint8Array;
    if (global.Uint8Array) toUint8Array = function toUint8Array(a) {
      return Uint8Array.from(atob(_fromURI(a)), function (c) {
        return c.charCodeAt(0);
      });
    };

    var noConflict = function noConflict() {
      var Base64 = global.Base64;
      global.Base64 = _Base64;
      return Base64;
    }; // export Base64


    global.Base64 = {
      VERSION: version,
      atob: atob,
      btoa: btoa,
      fromBase64: decode,
      toBase64: encode,
      utob: utob,
      encode: encode,
      encodeURI: encodeURI,
      btou: btou,
      decode: decode,
      noConflict: noConflict,
      fromUint8Array: fromUint8Array,
      toUint8Array: toUint8Array
    }; // if ES5 is available, make Base64.extendString() available

    if (typeof Object.defineProperty === 'function') {
      var noEnum = function noEnum(v) {
        return {
          value: v,
          enumerable: false,
          writable: true,
          configurable: true
        };
      };

      global.Base64.extendString = function () {
        Object.defineProperty(String.prototype, 'fromBase64', noEnum(function () {
          return decode(this);
        }));
        Object.defineProperty(String.prototype, 'toBase64', noEnum(function (urisafe) {
          return encode(this, urisafe);
        }));
        Object.defineProperty(String.prototype, 'toBase64URI', noEnum(function () {
          return encode(this, true);
        }));
      };
    } //
    // export Base64 to the namespace
    //


    if (global['Meteor']) {
      // Meteor.js
      Base64 = global.Base64;
    } // module.exports and AMD are mutually exclusive.
    // module.exports has precedence.


    if (module.exports) {
      module.exports.Base64 = global.Base64;
    } // that's it!


    return {
      Base64: global.Base64
    };
  });
});
/* eslint-disable */

var dxfParser = createCommonjsModule(function (module, exports) {
  !function (e, a) {
    module.exports = a();
  }('undefined' != typeof self ? self : commonjsGlobal, function () {
    return function (e) {
      var a = {};

      function t(r) {
        if (a[r]) return a[r].exports;
        var n = a[r] = {
          i: r,
          l: !1,
          exports: {}
        };
        return e[r].call(n.exports, n, n.exports, t), n.l = !0, n.exports;
      }

      return t.m = e, t.c = a, t.d = function (e, a, r) {
        t.o(e, a) || Object.defineProperty(e, a, {
          enumerable: !0,
          get: r
        });
      }, t.r = function (e) {
        'undefined' != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: 'Module'
        }), Object.defineProperty(e, '__esModule', {
          value: !0
        });
      }, t.t = function (e, a) {
        if (1 & a && (e = t(e)), 8 & a) return e;
        if (4 & a && 'object' == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (t.r(r), Object.defineProperty(r, 'default', {
          enumerable: !0,
          value: e
        }), 2 & a && 'string' != typeof e) for (var n in e) {
          t.d(r, n, function (a) {
            return e[a];
          }.bind(null, n));
        }
        return r;
      }, t.n = function (e) {
        var a = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return t.d(a, 'a', a), a;
      }, t.o = function (e, a) {
        return Object.prototype.hasOwnProperty.call(e, a);
      }, t.p = '', t(t.s = 1);
    }([function (e, a, t) {
      var r, n;
      !function (o, c) {
        void 0 === (n = 'function' == typeof (r = function r() {
          var e = function e() {},
              a = 'undefined',
              t = ['trace', 'debug', 'info', 'warn', 'error'];

          function r(e, a) {
            var t = e[a];
            if ('function' == typeof t.bind) return t.bind(e);

            try {
              return Function.prototype.bind.call(t, e);
            } catch (a) {
              return function () {
                return Function.prototype.apply.apply(t, [e, arguments]);
              };
            }
          }

          function n(a, r) {
            for (var n = 0; n < t.length; n++) {
              var o = t[n];
              this[o] = n < a ? e : this.methodFactory(o, a, r);
            }

            this.log = this.debug;
          }

          function o(t, o, c) {
            return function (t) {
              'debug' === t && (t = 'log');
              return typeof console !== a && (void 0 !== console[t] ? r(console, t) : void 0 !== console.log ? r(console, 'log') : e);
            }(t) || function (e, t, r) {
              return function () {
                typeof console !== a && (n.call(this, t, r), this[e].apply(this, arguments));
              };
            }.apply(this, arguments);
          }

          function c(e, r, c) {
            var i,
                u = this,
                s = 'loglevel';

            function l() {
              var e;

              if (typeof window !== a) {
                try {
                  e = window.localStorage[s];
                } catch (e) {}

                if (typeof e === a) try {
                  var t = window.document.cookie,
                      r = t.indexOf(encodeURIComponent(s) + '=');
                  -1 !== r && (e = /^([^;]+)/.exec(t.slice(r))[1]);
                } catch (e) {}
                return void 0 === u.levels[e] && (e = void 0), e;
              }
            }

            e && (s += ':' + e), u.name = e, u.levels = {
              TRACE: 0,
              DEBUG: 1,
              INFO: 2,
              WARN: 3,
              ERROR: 4,
              SILENT: 5
            }, u.methodFactory = c || o, u.getLevel = function () {
              return i;
            }, u.setLevel = function (r, o) {
              if ('string' == typeof r && void 0 !== u.levels[r.toUpperCase()] && (r = u.levels[r.toUpperCase()]), !('number' == typeof r && r >= 0 && r <= u.levels.SILENT)) throw 'log.setLevel() called with invalid level: ' + r;
              if (i = r, !1 !== o && function (e) {
                var r = (t[e] || 'silent').toUpperCase();
                if (typeof window === a) return;

                try {
                  return void (window.localStorage[s] = r);
                } catch (e) {}

                try {
                  window.document.cookie = encodeURIComponent(s) + '=' + r + ';';
                } catch (e) {}
              }(r), n.call(u, r, e), typeof console === a && r < u.levels.SILENT) return 'No console available for logging';
            }, u.setDefaultLevel = function (e) {
              l() || u.setLevel(e, !1);
            }, u.enableAll = function (e) {
              u.setLevel(u.levels.TRACE, e);
            }, u.disableAll = function (e) {
              u.setLevel(u.levels.SILENT, e);
            };
            var v = l();
            null == v && (v = null == r ? 'WARN' : r), u.setLevel(v, !1);
          }

          var i = new c(),
              u = {};

          i.getLogger = function (e) {
            if ('string' != typeof e || '' === e) throw new TypeError('You must supply a name when creating a logger.');
            var a = u[e];
            return a || (a = u[e] = new c(e, i.getLevel(), i.methodFactory)), a;
          };

          var s = typeof window !== a ? window.log : void 0;
          return i.noConflict = function () {
            return typeof window !== a && window.log === i && (window.log = s), i;
          }, i.getLoggers = function () {
            return u;
          }, i;
        }) ? r.call(a, t, a, e) : r) || (e.exports = n);
      }();
    }, function (e, a, t) {
      function r(e) {
        this._pointer = 0, this._data = e, this._eof = !1;
      }

      function n(e, a) {
        return e <= 9 ? a : e >= 10 && e <= 59 ? parseFloat(a) : e >= 60 && e <= 99 ? parseInt(a) : e >= 100 && e <= 109 ? a : e >= 110 && e <= 149 ? parseFloat(a) : e >= 160 && e <= 179 ? parseInt(a) : e >= 210 && e <= 239 ? parseFloat(a) : e >= 270 && e <= 289 ? parseInt(a) : e >= 290 && e <= 299 ? function (e) {
          if ('0' === e) return !1;
          if ('1' === e) return !0;
          throw TypeError("String '" + e + "' cannot be cast to Boolean type");
        }(a) : e >= 300 && e <= 369 ? a : e >= 370 && e <= 389 ? parseInt(a) : e >= 390 && e <= 399 ? a : e >= 400 && e <= 409 ? parseInt(a) : e >= 410 && e <= 419 ? a : e >= 420 && e <= 429 ? parseInt(a) : e >= 430 && e <= 439 ? a : e >= 440 && e <= 459 ? parseInt(a) : e >= 460 && e <= 469 ? parseFloat(a) : e >= 470 && e <= 481 ? a : 999 === e ? a : e >= 1e3 && e <= 1009 ? a : e >= 1010 && e <= 1059 ? parseFloat(a) : e >= 1060 && e <= 1071 ? parseInt(a) : (console.log('WARNING: Group code does not have a defined type: %j', {
          code: e,
          value: a
        }), a);
      }

      t.r(a), r.prototype.next = function () {
        var e;
        if (!this.hasNext()) throw this._eof ? new Error("Cannot call 'next' after EOF group has been read") : new Error('Unexpected end of input: EOF group not read before end of file. Ended on code ' + this._data[this._pointer]);
        return e = {
          code: parseInt(this._data[this._pointer])
        }, this._pointer++, e.value = n(e.code, this._data[this._pointer].trim()), this._pointer++, 0 === e.code && 'EOF' === e.value && (this._eof = !0), this.lastReadGroup = e, e;
      }, r.prototype.peek = function () {
        if (!this.hasNext()) throw this._eof ? new Error("Cannot call 'next' after EOF group has been read") : new Error('Unexpected end of input: EOF group not read before end of file. Ended on code ' + this._data[this._pointer]);
        var e = {
          code: parseInt(this._data[this._pointer])
        };
        return e.value = n(e.code, this._data[this._pointer + 1].trim()), e;
      }, r.prototype.rewind = function (e) {
        e = e || 1, this._pointer = this._pointer - 2 * e;
      }, r.prototype.hasNext = function () {
        return !this._eof && !(this._pointer > this._data.length - 2);
      }, r.prototype.isEOF = function () {
        return this._eof;
      };
      var o = [0, 16711680, 16776960, 65280, 65535, 255, 16711935, 16777215, 8421504, 12632256, 16711680, 16744319, 13369344, 13395558, 10027008, 10046540, 8323072, 8339263, 4980736, 4990502, 16727808, 16752511, 13382400, 13401958, 10036736, 10051404, 8331008, 8343359, 4985600, 4992806, 16744192, 16760703, 13395456, 13408614, 10046464, 10056268, 8339200, 8347455, 4990464, 4995366, 16760576, 16768895, 13408512, 13415014, 10056192, 10061132, 8347392, 8351551, 4995328, 4997670, 16776960, 16777087, 13421568, 13421670, 10000384, 10000460, 8355584, 8355647, 5000192, 5000230, 12582656, 14679935, 10079232, 11717734, 7510016, 8755276, 6258432, 7307071, 3755008, 4344870, 8388352, 12582783, 6736896, 10079334, 5019648, 7510092, 4161280, 6258495, 2509824, 3755046, 4194048, 10485631, 3394560, 8375398, 2529280, 6264908, 2064128, 5209919, 1264640, 3099686, 65280, 8388479, 52224, 6736998, 38912, 5019724, 32512, 4161343, 19456, 2509862, 65343, 8388511, 52275, 6737023, 38950, 5019743, 32543, 4161359, 19475, 2509871, 65407, 8388543, 52326, 6737049, 38988, 5019762, 32575, 4161375, 19494, 2509881, 65471, 8388575, 52377, 6737074, 39026, 5019781, 32607, 4161391, 19513, 2509890, 65535, 8388607, 52428, 6737100, 39064, 5019800, 32639, 4161407, 19532, 2509900, 49151, 8380415, 39372, 6730444, 29336, 5014936, 24447, 4157311, 14668, 2507340, 32767, 8372223, 26316, 6724044, 19608, 5010072, 16255, 4153215, 9804, 2505036, 16383, 8364031, 13260, 6717388, 9880, 5005208, 8063, 4149119, 4940, 2502476, 255, 8355839, 204, 6710988, 152, 5000344, 127, 4145023, 76, 2500172, 4129023, 10452991, 3342540, 8349388, 2490520, 6245528, 2031743, 5193599, 1245260, 3089996, 8323327, 12550143, 6684876, 10053324, 4980888, 7490712, 4128895, 6242175, 2490444, 3745356, 12517631, 14647295, 10027212, 11691724, 7471256, 8735896, 6226047, 7290751, 3735628, 4335180, 16711935, 16744447, 13369548, 13395660, 9961624, 9981080, 8323199, 8339327, 4980812, 4990540, 16711871, 16744415, 13369497, 13395634, 9961586, 9981061, 8323167, 8339311, 4980793, 4990530, 16711807, 16744383, 13369446, 13395609, 9961548, 9981042, 8323135, 8339295, 4980774, 4990521, 16711743, 16744351, 13369395, 13395583, 9961510, 9981023, 8323103, 8339279, 4980755, 4990511, 3355443, 5987163, 8684676, 11382189, 14079702, 16777215];

      function c(e) {
        var a = {};
        e.rewind();
        var t = e.next(),
            r = t.code;
        if (a.x = t.value, r += 10, (t = e.next()).code != r) throw new Error('Expected code for point value to be ' + r + ' but got ' + t.code + '.');
        return a.y = t.value, r += 10, (t = e.next()).code != r ? (e.rewind(), a) : (a.z = t.value, a);
      }

      function i(e, a) {
        switch (a.code) {
          case 0:
            e.type = a.value;
            break;

          case 5:
            e.handle = a.value;
            break;

          case 6:
            e.lineType = a.value;
            break;

          case 8:
            e.layer = a.value;
            break;

          case 48:
            e.lineTypeScale = a.value;
            break;

          case 60:
            e.visible = 0 === a.value;
            break;

          case 62:
            e.colorIndex = a.value, e.color = (t = Math.abs(a.value), o[t]);
            break;

          case 67:
            e.inPaperSpace = 0 !== a.value;
            break;

          case 100:
            break;

          case 330:
            e.ownerHandle = a.value;
            break;

          case 347:
            e.materialObjectHandle = a.value;
            break;

          case 370:
            e.lineweight = a.value;
            break;

          case 420:
            e.color = a.value;
            break;

          case 1e3:
            e.extendedData = e.extendedData || {}, e.extendedData.customStrings = e.extendedData.customStrings || [], e.extendedData.customStrings.push(a.value);
            break;

          case 1001:
            e.extendedData = e.extendedData || {}, e.extendedData.applicationName = a.value;
            break;

          default:
            return !1;
        }

        var t;
        return !0;
      }

      function u() {}

      function s(e, a) {
        var t,
            r = [],
            n = !1,
            o = !1;

        for (t = 0; t <= 4; t++) {
          for (var c = {}; 'EOF' !== a && 0 !== a.code && !o;) {
            switch (a.code) {
              case 10:
              case 11:
              case 12:
              case 13:
                if (n) {
                  o = !0;
                  continue;
                }

                c.x = a.value, n = !0;
                break;

              case 20:
              case 21:
              case 22:
              case 23:
                c.y = a.value;
                break;

              case 30:
              case 31:
              case 32:
              case 33:
                c.z = a.value;
                break;

              default:
                return r;
            }

            a = e.next();
          }

          r.push(c), n = !1, o = !1;
        }

        return e.rewind(), r;
      }

      function l() {}

      function v() {}

      function d() {}

      function b() {}

      function p() {}

      function f() {}

      function k() {}

      function y() {}

      function x(e, a) {
        if (!e || e <= 0) throw Error('n must be greater than 0 verticies');
        var t,
            r = [],
            n = !1,
            o = !1,
            c = a.lastReadGroup;

        for (t = 0; t < e; t++) {
          for (var i = {}; 'EOF' !== c && 0 !== c.code && !o;) {
            switch (c.code) {
              case 10:
                if (n) {
                  o = !0;
                  continue;
                }

                i.x = c.value, n = !0;
                break;

              case 20:
                i.y = c.value;
                break;

              case 30:
                i.z = c.value;
                break;

              case 40:
                i.startWidth = c.value;
                break;

              case 41:
                i.endWidth = c.value;
                break;

              case 42:
                0 != c.value && (i.bulge = c.value);
                break;

              default:
                return n && r.push(i), a.rewind(), r;
            }

            c = a.next();
          }

          r.push(i), n = !1, o = !1;
        }

        return a.rewind(), r;
      }

      function h() {}

      function g() {}

      function E() {}

      function w() {}

      function m(e, a) {
        var t = {
          type: a.value
        };

        for (a = e.next(); 'EOF' != a && 0 != a.code;) {
          i(t, a), a = e.next();
        }

        return t;
      }

      function P() {}

      function F() {}

      function O() {}

      u.ForEntityName = '3DFACE', u.prototype.parseEntity = function (e, a) {
        var t = {
          type: a.value,
          vertices: []
        };

        for (a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 70:
              t.shape = 1 == (1 & a.value), t.hasContinuousLinetypePattern = 128 == (128 & a.value);
              break;

            case 10:
              t.vertices = s(e, a), a = e.lastReadGroup;
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, l.ForEntityName = 'ARC', l.prototype.parseEntity = function (e, a) {
        var t;

        for (t = {
          type: a.value
        }, a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 10:
              t.center = c(e);
              break;

            case 40:
              t.radius = a.value;
              break;

            case 50:
              t.startAngle = Math.PI / 180 * a.value;
              break;

            case 51:
              t.endAngle = Math.PI / 180 * a.value, t.angleLength = t.endAngle - t.startAngle;
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, v.ForEntityName = 'ATTDEF', v.prototype.parseEntity = function (e, a) {
        var t = {
          type: a.value,
          scale: 1,
          textStyle: 'STANDARD'
        };

        for (a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 1:
              t.text = a.value;
              break;

            case 2:
              t.tag = a.value;
              break;

            case 3:
              t.prompt = a.value;
              break;

            case 7:
              t.textStyle = a.value;
              break;

            case 10:
              t.startPoint = c(e);
              break;

            case 11:
              t.endPoint = c(e);
              break;

            case 39:
              t.thickness = a.value;
              break;

            case 40:
              t.textHeight = a.value;
              break;

            case 41:
              t.scale = a.value;
              break;

            case 50:
              t.rotation = a.value;
              break;

            case 51:
              t.obliqueAngle = a.value;
              break;

            case 70:
              t.invisible = !!(1 & a.value), t.constant = !!(2 & a.value), t.verificationRequired = !!(4 & a.value), t.preset = !!(8 & a.value);
              break;

            case 71:
              t.backwards = !!(2 & a.value), t.mirrored = !!(4 & a.value);
              break;

            case 72:
              t.horizontalJustification = a.value;
              break;

            case 73:
              t.fieldLength = a.value;
              break;

            case 74:
              t.verticalJustification = a.value;
              break;

            case 100:
              break;

            case 210:
              t.extrusionDirectionX = a.value;
              break;

            case 220:
              t.extrusionDirectionY = a.value;
              break;

            case 230:
              t.extrusionDirectionZ = a.value;
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, d.ForEntityName = 'CIRCLE', d.prototype.parseEntity = function (e, a) {
        var t, r;

        for (t = {
          type: a.value
        }, a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 10:
              t.center = c(e);
              break;

            case 40:
              t.radius = a.value;
              break;

            case 50:
              t.startAngle = Math.PI / 180 * a.value;
              break;

            case 51:
              (r = Math.PI / 180 * a.value) < t.startAngle ? t.angleLength = r + 2 * Math.PI - t.startAngle : t.angleLength = r - t.startAngle, t.endAngle = r;
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, b.ForEntityName = 'DIMENSION', b.prototype.parseEntity = function (e, a) {
        var t;

        for (t = {
          type: a.value
        }, a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 2:
              t.block = a.value;
              break;

            case 10:
              t.anchorPoint = c(e);
              break;

            case 11:
              t.middleOfText = c(e);
              break;

            case 12:
              t.insertionPoint = c(e);
              break;

            case 13:
              t.linearOrAngularPoint1 = c(e);
              break;

            case 14:
              t.linearOrAngularPoint2 = c(e);
              break;

            case 15:
              t.diameterOrRadiusPoint = c(e);
              break;

            case 16:
              t.arcPoint = c(e);
              break;

            case 70:
              t.dimensionType = a.value;
              break;

            case 71:
              t.attachmentPoint = a.value;
              break;

            case 42:
              t.actualMeasurement = a.value;
              break;

            case 1:
              t.text = a.value;
              break;

            case 50:
              t.angle = a.value;
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, p.ForEntityName = 'ELLIPSE', p.prototype.parseEntity = function (e, a) {
        var t;

        for (t = {
          type: a.value
        }, a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 10:
              t.center = c(e);
              break;

            case 11:
              t.majorAxisEndPoint = c(e);
              break;

            case 40:
              t.axisRatio = a.value;
              break;

            case 41:
              t.startAngle = a.value;
              break;

            case 42:
              t.endAngle = a.value;
              break;

            case 2:
              t.name = a.value;
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, f.ForEntityName = 'INSERT', f.prototype.parseEntity = function (e, a) {
        var t;

        for (t = {
          type: a.value
        }, a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 2:
              t.name = a.value;
              break;

            case 41:
              t.xScale = a.value;
              break;

            case 42:
              t.yScale = a.value;
              break;

            case 43:
              t.zScale = a.value;
              break;

            case 10:
              t.position = c(e);
              break;

            case 50:
              t.rotation = a.value;
              break;

            case 70:
              t.columnCount = a.value;
              break;

            case 71:
              t.rowCount = a.value;
              break;

            case 44:
              t.columnSpacing = a.value;
              break;

            case 45:
              t.rowSpacing = a.value;
              break;

            case 210:
              t.extrusionDirection = c(e);
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, k.ForEntityName = 'LINE', k.prototype.parseEntity = function (e, a) {
        var t = {
          type: a.value,
          vertices: []
        };

        for (a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 10:
              t.vertices.unshift(c(e));
              break;

            case 11:
              t.vertices.push(c(e));
              break;

            case 210:
              t.extrusionDirection = c(e);
              break;

            case 100:
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, y.ForEntityName = 'LWPOLYLINE', y.prototype.parseEntity = function (e, a) {
        var t = {
          type: a.value,
          vertices: []
        },
            r = 0;

        for (a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 38:
              t.elevation = a.value;
              break;

            case 39:
              t.depth = a.value;
              break;

            case 70:
              t.shape = 1 == (1 & a.value), t.hasContinuousLinetypePattern = 128 == (128 & a.value);
              break;

            case 90:
              r = a.value;
              break;

            case 10:
              t.vertices = x(r, e);
              break;

            case 43:
              0 !== a.value && (t.width = a.value);
              break;

            case 210:
              t.extrusionDirectionX = a.value;
              break;

            case 220:
              t.extrusionDirectionY = a.value;
              break;

            case 230:
              t.extrusionDirectionZ = a.value;
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, h.ForEntityName = 'MTEXT', h.prototype.parseEntity = function (e, a) {
        var t = {
          type: a.value
        };

        for (a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 3:
            case 1:
              t.text ? t.text += a.value : t.text = a.value;
              break;

            case 10:
              t.position = c(e);
              break;

            case 40:
              t.height = a.value;
              break;

            case 41:
              t.width = a.value;
              break;

            case 50:
              t.rotation = a.value;
              break;

            case 71:
              t.attachmentPoint = a.value;
              break;

            case 72:
              t.drawingDirection = a.value;
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, g.ForEntityName = 'POINT', g.prototype.parseEntity = function (e, a) {
        var t;

        for (t = {
          type: a.value
        }, a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 10:
              t.position = c(e);
              break;

            case 39:
              t.thickness = a.value;
              break;

            case 210:
              t.extrusionDirection = c(e);
              break;

            case 100:
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, E.ForEntityName = 'VERTEX', E.prototype.parseEntity = function (e, a) {
        var t = {
          type: a.value
        };

        for (a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 10:
              t.x = a.value;
              break;

            case 20:
              t.y = a.value;
              break;

            case 30:
              t.z = a.value;
              break;

            case 40:
            case 41:
              break;

            case 42:
              0 != a.value && (t.bulge = a.value);
              break;

            case 70:
              t.curveFittingVertex = 0 != (1 & a.value), t.curveFitTangent = 0 != (2 & a.value), t.splineVertex = 0 != (8 & a.value), t.splineControlPoint = 0 != (16 & a.value), t.threeDPolylineVertex = 0 != (32 & a.value), t.threeDPolylineMesh = 0 != (64 & a.value), t.polyfaceMeshVertex = 0 != (128 & a.value);
              break;

            case 50:
              break;

            case 71:
              t.faceA = a.value;
              break;

            case 72:
              t.faceB = a.value;
              break;

            case 73:
              t.faceC = a.value;
              break;

            case 74:
              t.faceD = a.value;
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, w.ForEntityName = 'POLYLINE', w.prototype.parseEntity = function (e, a) {
        var t = {
          type: a.value,
          vertices: []
        };

        for (a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 10:
            case 20:
            case 30:
              break;

            case 39:
              t.thickness = a.value;
              break;

            case 40:
            case 41:
              break;

            case 70:
              t.shape = 0 != (1 & a.value), t.includesCurveFitVertices = 0 != (2 & a.value), t.includesSplineFitVertices = 0 != (4 & a.value), t.is3dPolyline = 0 != (8 & a.value), t.is3dPolygonMesh = 0 != (16 & a.value), t.is3dPolygonMeshClosed = 0 != (32 & a.value), t.isPolyfaceMesh = 0 != (64 & a.value), t.hasContinuousLinetypePattern = 0 != (128 & a.value);
              break;

            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
              break;

            case 210:
              t.extrusionDirection = c(e);
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t.vertices = function (e, a) {
          var t = new E(),
              r = [];

          for (; !e.isEOF();) {
            if (0 === a.code) if ('VERTEX' === a.value) r.push(t.parseEntity(e, a)), a = e.lastReadGroup;else if ('SEQEND' === a.value) {
              m(e, a);
              break;
            }
          }

          return r;
        }(e, a), t;
      }, P.ForEntityName = 'SOLID', P.prototype.parseEntity = function (e, a) {
        var t;

        for ((t = {
          type: a.value
        }).points = [], a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 10:
              t.points[0] = c(e);
              break;

            case 11:
              t.points[1] = c(e);
              break;

            case 12:
              t.points[2] = c(e);
              break;

            case 13:
              t.points[3] = c(e);
              break;

            case 210:
              t.extrusionDirection = c(e);
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, F.ForEntityName = 'SPLINE', F.prototype.parseEntity = function (e, a) {
        var t;

        for (t = {
          type: a.value
        }, a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 10:
              t.controlPoints || (t.controlPoints = []), t.controlPoints.push(c(e));
              break;

            case 11:
              t.fitPoints || (t.fitPoints = []), t.fitPoints.push(c(e));
              break;

            case 12:
              t.startTangent = c(e);
              break;

            case 13:
              t.endTangent = c(e);
              break;

            case 40:
              t.knotValues || (t.knotValues = []), t.knotValues.push(a.value);
              break;

            case 70:
              0 != (1 & a.value) && (t.closed = !0), 0 != (2 & a.value) && (t.periodic = !0), 0 != (4 & a.value) && (t.rational = !0), 0 != (8 & a.value) && (t.planar = !0), 0 != (16 & a.value) && (t.planar = !0, t.linear = !0);
              break;

            case 71:
              t.degreeOfSplineCurve = a.value;
              break;

            case 72:
              t.numberOfKnots = a.value;
              break;

            case 73:
              t.numberOfControlPoints = a.value;
              break;

            case 74:
              t.numberOfFitPoints = a.value;
              break;

            case 210:
              t.normalVector = c(e);
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      }, O.ForEntityName = 'TEXT', O.prototype.parseEntity = function (e, a) {
        var t;

        for (t = {
          type: a.value
        }, a = e.next(); 'EOF' !== a && 0 !== a.code;) {
          switch (a.code) {
            case 10:
              t.startPoint = c(e);
              break;

            case 11:
              t.endPoint = c(e);
              break;

            case 40:
              t.textHeight = a.value;
              break;

            case 41:
              t.xScale = a.value;
              break;

            case 50:
              t.rotation = a.value;
              break;

            case 1:
              t.text = a.value;
              break;

            case 72:
              t.halign = a.value;
              break;

            case 73:
              t.valign = a.value;
              break;

            default:
              i(t, a);
          }

          a = e.next();
        }

        return t;
      };
      var N = t(0),
          T = t.n(N);

      function S() {
        var e;
        this._entityHandlers = {}, (e = this).registerEntityHandler(u), e.registerEntityHandler(l), e.registerEntityHandler(v), e.registerEntityHandler(d), e.registerEntityHandler(b), e.registerEntityHandler(p), e.registerEntityHandler(f), e.registerEntityHandler(k), e.registerEntityHandler(y), e.registerEntityHandler(h), e.registerEntityHandler(g), e.registerEntityHandler(w), e.registerEntityHandler(P), e.registerEntityHandler(F), e.registerEntityHandler(O);
      }

      function L(e) {
        T.a.debug('unhandled group ' + D(e));
      }

      function D(e) {
        return e.code + ':' + e.value;
      }

      T.a.setLevel('error'), S.prototype.parse = function (e, a) {
        throw new Error('read() not implemented. Use readSync()');
      }, S.prototype.registerEntityHandler = function (e) {
        var a = new e();
        this._entityHandlers[e.ForEntityName] = a;
      }, S.prototype.parseSync = function (e) {
        return 'string' == typeof e ? this._parse(e) : (console.error('Cannot read dxf source of type `' + typeof e), null);
      }, S.prototype.parseStream = function (e, a) {
        var t = '',
            r = this;
        e.on('data', function (e) {
          t += e;
        }), e.on('end', function () {
          try {
            var e = r._parse(t);
          } catch (e) {
            return a(e);
          }

          a(null, e);
        }), e.on('error', function (e) {
          a(e);
        });
      }, S.prototype._parse = function (e) {
        var a,
            t,
            n = {},
            c = 0,
            i = e.split(/\r\n|\r|\n/g);
        if (!(a = new r(i)).hasNext()) throw Error('Empty file');

        var u = this,
            s = function s(e, a) {
          return t.code === e && t.value === a;
        },
            l = function l() {
          var e = null,
              r = null,
              n = {};

          for (t = a.next();;) {
            if (s(0, 'ENDSEC')) {
              e && (n[e] = r);
              break;
            }

            9 === t.code ? (e && (n[e] = r), e = t.value) : 10 === t.code ? r = {
              x: t.value
            } : 20 === t.code ? r.y = t.value : 30 === t.code ? r.z = t.value : r = t.value, t = a.next();
          }

          return t = a.next(), n;
        },
            v = function v() {
          var e,
              r = {};

          for (t = a.next(); 'EOF' !== t.value && !s(0, 'ENDSEC');) {
            s(0, 'BLOCK') ? (T.a.debug('block {'), e = d(), T.a.debug('}'), x(e), e.name ? r[e.name] = e : T.a.error('block with handle "' + e.handle + '" is missing a name.')) : (L(t), t = a.next());
          }

          return r;
        },
            d = function d() {
          var e = {};

          for (t = a.next(); 'EOF' !== t.value;) {
            switch (t.code) {
              case 1:
                e.xrefPath = t.value, t = a.next();
                break;

              case 2:
                e.name = t.value, t = a.next();
                break;

              case 3:
                e.name2 = t.value, t = a.next();
                break;

              case 5:
                e.handle = t.value, t = a.next();
                break;

              case 8:
                e.layer = t.value, t = a.next();
                break;

              case 10:
                e.position = y(), t = a.next();
                break;

              case 67:
                e.paperSpace = !(!t.value || 1 != t.value), t = a.next();
                break;

              case 70:
                0 != t.value && (e.type = t.value), t = a.next();
                break;

              case 100:
                t = a.next();
                break;

              case 330:
                e.ownerHandle = t.value, t = a.next();
                break;

              case 0:
                if ('ENDBLK' == t.value) break;
                e.entities = k(!0);
                break;

              default:
                L(t), t = a.next();
            }

            if (s(0, 'ENDBLK')) {
              t = a.next();
              break;
            }
          }

          return e;
        },
            b = function b() {
          var e = {};

          for (t = a.next(); 'EOF' !== t.value && !s(0, 'ENDSEC');) {
            s(0, 'TABLE') ? (t = a.next(), f[t.value] ? (T.a.debug(t.value + ' Table {'), e[f[t.value].tableName] = p(), T.a.debug('}')) : T.a.debug('Unhandled Table ' + t.value)) : t = a.next();
          }

          return t = a.next(), e;
        };

        var p = function p() {
          var e,
              r = f[t.value],
              n = {},
              o = 0;

          for (t = a.next(); !s(0, 'ENDTAB');) {
            switch (t.code) {
              case 5:
                n.handle = t.value, t = a.next();
                break;

              case 330:
                n.ownerHandle = t.value, t = a.next();
                break;

              case 100:
                'AcDbSymbolTable' === t.value ? t = a.next() : (L(t), t = a.next());
                break;

              case 70:
                o = t.value, t = a.next();
                break;

              case 0:
                t.value === r.dxfSymbolName ? n[r.tableRecordsProperty] = r.parseTableRecords() : (L(t), t = a.next());
                break;

              default:
                L(t), t = a.next();
            }
          }

          var c = n[r.tableRecordsProperty];
          return c && (c.constructor === Array ? e = c.length : 'object' == typeof c && (e = Object.keys(c).length), o !== e && T.a.warn('Parsed ' + e + ' ' + r.dxfSymbolName + "'s but expected " + o)), t = a.next(), n;
        },
            f = {
          VPORT: {
            tableRecordsProperty: 'viewPorts',
            tableName: 'viewPort',
            dxfSymbolName: 'VPORT',
            parseTableRecords: function parseTableRecords() {
              var e = [],
                  r = {};

              for (T.a.debug('ViewPort {'), t = a.next(); !s(0, 'ENDTAB');) {
                switch (t.code) {
                  case 2:
                    r.name = t.value, t = a.next();
                    break;

                  case 10:
                    r.lowerLeftCorner = y(), t = a.next();
                    break;

                  case 11:
                    r.upperRightCorner = y(), t = a.next();
                    break;

                  case 12:
                    r.center = y(), t = a.next();
                    break;

                  case 13:
                    r.snapBasePoint = y(), t = a.next();
                    break;

                  case 14:
                    r.snapSpacing = y(), t = a.next();
                    break;

                  case 15:
                    r.gridSpacing = y(), t = a.next();
                    break;

                  case 16:
                    r.viewDirectionFromTarget = y(), t = a.next();
                    break;

                  case 17:
                    r.viewTarget = y(), t = a.next();
                    break;

                  case 42:
                    r.lensLength = t.value, t = a.next();
                    break;

                  case 43:
                    r.frontClippingPlane = t.value, t = a.next();
                    break;

                  case 44:
                    r.backClippingPlane = t.value, t = a.next();
                    break;

                  case 45:
                    r.viewHeight = t.value, t = a.next();
                    break;

                  case 50:
                    r.snapRotationAngle = t.value, t = a.next();
                    break;

                  case 51:
                    r.viewTwistAngle = t.value, t = a.next();
                    break;

                  case 79:
                    r.orthographicType = t.value, t = a.next();
                    break;

                  case 110:
                    r.ucsOrigin = y(), t = a.next();
                    break;

                  case 111:
                    r.ucsXAxis = y(), t = a.next();
                    break;

                  case 112:
                    r.ucsYAxis = y(), t = a.next();
                    break;

                  case 110:
                    r.ucsOrigin = y(), t = a.next();
                    break;

                  case 281:
                    r.renderMode = t.value, t = a.next();
                    break;

                  case 281:
                    r.defaultLightingType = t.value, t = a.next();
                    break;

                  case 292:
                    r.defaultLightingOn = t.value, t = a.next();
                    break;

                  case 330:
                    r.ownerHandle = t.value, t = a.next();
                    break;

                  case 63:
                  case 421:
                  case 431:
                    r.ambientColor = t.value, t = a.next();
                    break;

                  case 0:
                    'VPORT' === t.value && (T.a.debug('}'), e.push(r), T.a.debug('ViewPort {'), r = {}, t = a.next());
                    break;

                  default:
                    L(t), t = a.next();
                }
              }

              return T.a.debug('}'), e.push(r), e;
            }
          },
          LTYPE: {
            tableRecordsProperty: 'lineTypes',
            tableName: 'lineType',
            dxfSymbolName: 'LTYPE',
            parseTableRecords: function parseTableRecords() {
              var e,
                  r,
                  n = {},
                  o = {};

              for (T.a.debug('LType {'), t = a.next(); !s(0, 'ENDTAB');) {
                switch (t.code) {
                  case 2:
                    o.name = t.value, e = t.value, t = a.next();
                    break;

                  case 3:
                    o.description = t.value, t = a.next();
                    break;

                  case 73:
                    (r = t.value) > 0 && (o.pattern = []), t = a.next();
                    break;

                  case 40:
                    o.patternLength = t.value, t = a.next();
                    break;

                  case 49:
                    o.pattern.push(t.value), t = a.next();
                    break;

                  case 0:
                    T.a.debug('}'), r > 0 && r !== o.pattern.length && T.a.warn('lengths do not match on LTYPE pattern'), n[e] = o, o = {}, T.a.debug('LType {'), t = a.next();
                    break;

                  default:
                    t = a.next();
                }
              }

              return T.a.debug('}'), n[e] = o, n;
            }
          },
          LAYER: {
            tableRecordsProperty: 'layers',
            tableName: 'layer',
            dxfSymbolName: 'LAYER',
            parseTableRecords: function parseTableRecords() {
              var e,
                  r,
                  n = {},
                  c = {};

              for (T.a.debug('Layer {'), t = a.next(); !s(0, 'ENDTAB');) {
                switch (t.code) {
                  case 2:
                    c.name = t.value, e = t.value, t = a.next();
                    break;

                  case 62:
                    c.visible = t.value >= 0, c.colorIndex = Math.abs(t.value), c.color = (r = c.colorIndex, o[r]), t = a.next();
                    break;

                  case 70:
                    c.frozen = 0 != (1 & t.value) || 0 != (2 & t.value), t = a.next();
                    break;

                  case 0:
                    'LAYER' === t.value && (T.a.debug('}'), n[e] = c, T.a.debug('Layer {'), c = {}, e = void 0, t = a.next());
                    break;

                  default:
                    L(t), t = a.next();
                }
              }

              return T.a.debug('}'), n[e] = c, n;
            }
          }
        },
            k = function k(e) {
          var r = [],
              n = e ? 'ENDBLK' : 'ENDSEC';

          for (e || (t = a.next());;) {
            if (0 === t.code) {
              if (t.value === n) break;
              var o,
                  c = u._entityHandlers[t.value];

              if (null == c) {
                T.a.warn('Unhandled entity ' + t.value), t = a.next();
                continue;
              }

              T.a.debug(t.value + ' {'), o = c.parseEntity(a, t), t = a.lastReadGroup, T.a.debug('}'), x(o), r.push(o);
            } else t = a.next();
          }

          return 'ENDSEC' == n && (t = a.next()), r;
        },
            y = function y() {
          var e = {},
              r = t.code;
          if (e.x = t.value, r += 10, (t = a.next()).code != r) throw new Error('Expected code for point value to be ' + r + ' but got ' + t.code + '.');
          return e.y = t.value, r += 10, (t = a.next()).code != r ? (a.rewind(), e) : (e.z = t.value, e);
        },
            x = function x(e) {
          if (!e) throw new TypeError('entity cannot be undefined or null');
          e.handle || (e.handle = c++);
        };

        return function () {
          for (t = a.next(); !a.isEOF();) {
            if (0 === t.code && 'SECTION' === t.value) {
              if (2 !== (t = a.next()).code) {
                console.error('Unexpected code %s after 0:SECTION', D(t)), t = a.next();
                continue;
              }

              'HEADER' === t.value ? (T.a.debug('> HEADER'), n.header = l(), T.a.debug('<')) : 'BLOCKS' === t.value ? (T.a.debug('> BLOCKS'), n.blocks = v(), T.a.debug('<')) : 'ENTITIES' === t.value ? (T.a.debug('> ENTITIES'), n.entities = k(!1), T.a.debug('<')) : 'TABLES' === t.value ? (T.a.debug('> TABLES'), n.tables = b(), T.a.debug('<')) : 'EOF' === t.value ? T.a.debug('EOF') : T.a.warn("Skipping section '%s'", t.value);
            } else t = a.next();
          }
        }(), n;
      };
      a.default = S;
    }]).default;
  });
});
var DxfParser = /*@__PURE__*/getDefaultExportFromCjs(dxfParser);
/* eslint-disable */

function decodeDataUri(uri) {
  if (uri) {
    var mime = uri.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);

    if (mime && mime.length > 0) {
      var type = mime[1];
      var data = uri.replace('data:' + type + ';', '').split(',');

      if (data && data.length === 2 && data[0] === 'base64') {
        var byteString = data[1];
        return Base64.decode(byteString);
      }
    }
  }

  return null;
}
/**
 * Returns the angle in radians of the vector (p1,p2). In other words, imagine
 * putting the base of the vector at coordinates (0,0) and finding the angle
 * from vector (1,0) to (p1,p2).
 * @param  {Object} p1 start point of the vector
 * @param  {Object} p2 end point of the vector
 * @return {Number} the angle
 */


function angle2(p1, p2) {
  var v1 = new Vector2(p1.x, p1.y);
  var v2 = new Vector2(p2.x, p2.y);
  v2.sub(v1); // sets v2 to be our chord

  v2.normalize();
  if (v2.y < 0) return -Math.acos(v2.x);
  return Math.acos(v2.x);
}

function polar(point, distance, angle) {
  var result = {};
  result.x = point.x + distance * Math.cos(angle);
  result.y = point.y + distance * Math.sin(angle);
  return result;
}
/**
 * Calculates points for a curve between two points
 * @param startPoint - the starting point of the curve
 * @param endPoint - the ending point of the curve
 * @param bulge - a value indicating how much to curve
 * @param segments - number of segments between the two given points
 */


function BulgeGeometry(startPoint, endPoint, bulge, segments) {
  var vertex, i, center, p0, p1, angle, radius, startAngle, thetaAngle;
  Geometry.call(this);
  this.startPoint = p0 = startPoint ? new Vector2(startPoint.x, startPoint.y) : new Vector2(0, 0);
  this.endPoint = p1 = endPoint ? new Vector2(endPoint.x, endPoint.y) : new Vector2(1, 0);
  this.bulge = bulge = bulge || 1;
  angle = 4 * Math.atan(bulge);
  radius = p0.distanceTo(p1) / 2 / Math.sin(angle / 2);
  center = polar(startPoint, radius, angle2(p0, p1) + (Math.PI / 2 - angle / 2));
  this.segments = segments = segments || Math.max(Math.abs(Math.ceil(angle / (Math.PI / 18))), 6); // By default want a segment roughly every 10 degrees

  startAngle = angle2(center, p0);
  thetaAngle = angle / segments;
  this.vertices.push(new Vector3(p0.x, p0.y, 0));

  for (i = 1; i <= segments - 1; i++) {
    vertex = polar(center, Math.abs(radius), startAngle + thetaAngle * i);
    this.vertices.push(new Vector3(vertex.x, vertex.y, 0));
  }
}

BulgeGeometry.prototype = Object.create(Geometry.prototype);
/**
 * THREE.Loader implementation for DXF files
 *
 * @param {*} manager THREE.LoadingManager
 *
 * @see https://threejs.org/docs/#api/en/loaders/Loader
 * @author Sourabh Soni / https://www.prolincur.com
 */
// export const DXFLoader = function (manager) {
//     THREE.Loader.call(this, manager);
//     this.font = null;
// };

var DXFLoader = /*#__PURE__*/function (_Loader5) {
  _inherits(DXFLoader, _Loader5);

  var _super90 = _createSuper(DXFLoader);

  function DXFLoader(manager) {
    _classCallCheck2(this, DXFLoader);

    return _super90.call(this, manager); // this.font = null;
  }

  _createClass2(DXFLoader, [{
    key: "setFont",
    value: function setFont(font) {
      this.font = font;
      return this;
    }
  }, {
    key: "load",
    value: function load(url, onLoad, onProgress, onError) {
      var scope = this;
      var loader = new FileLoader(scope.manager);
      loader.setPath(scope.path); // Test if it is a data-uri

      var text = decodeDataUri(url);

      if (text) {
        scope.loadString(text, onLoad, onError);
      } else {
        loader.load(url, function (text) {
          scope.loadString(text, onLoad, onError);
        }, onProgress, onError);
      }
    }
  }, {
    key: "loadString",
    value: function loadString(text, onLoad, onError) {
      var scope = this;

      try {
        onLoad(scope.parse(text));
      } catch (error) {
        if (onError) {
          onError(error);
        } else {
          console.error(error);
        }

        scope.manager.itemError(url);
      }
    }
  }, {
    key: "parse",
    value: function parse(text) {
      var parser = new DxfParser();
      var dxf = parser.parseSync(text);
      return this.loadEntities(dxf, this.font);
    }
    /**
     *
     * @param {Object} buffer - the dxf file content
     * @param {Object} font - a font loaded with THREE.FontLoader
     * @constructor
     */

  }, {
    key: "loadEntities",
    value: function loadEntities(data, font) {
      createLineTypeShaders(data);
      var entities = []; // Create entities from dxf object (data)

      var i, entity, obj;

      for (i = 0; i < data.entities.length; i++) {
        entity = data.entities[i];
        obj = drawEntity(entity, data);

        if (obj) {
          entities.push(obj);
        }

        obj = null;
      }

      return {
        entities: entities,
        dxf: data
      };

      function drawEntity(entity, data) {
        var mesh;

        if (entity.type === 'CIRCLE' || entity.type === 'ARC') {
          mesh = drawArc(entity, data);
        } else if (entity.type === 'LWPOLYLINE' || entity.type === 'LINE' || entity.type === 'POLYLINE') {
          mesh = drawLine(entity, data);
        } else if (entity.type === 'TEXT') {
          mesh = drawText(entity, data);
        } else if (entity.type === 'SOLID') {
          mesh = drawSolid(entity, data);
        } else if (entity.type === 'POINT') {
          mesh = drawPoint(entity, data);
        } else if (entity.type === 'INSERT') {
          mesh = drawBlock(entity, data);
        } else if (entity.type === 'SPLINE') {
          mesh = drawSpline(entity, data);
        } else if (entity.type === 'MTEXT') {
          mesh = drawMtext(entity, data);
        } else if (entity.type === 'ELLIPSE') {
          mesh = drawEllipse(entity, data);
        } else if (entity.type === 'DIMENSION') {
          var dimTypeEnum = entity.dimensionType & 7;

          if (dimTypeEnum === 0) {
            mesh = drawDimension(entity, data);
          } else {
            console.log('Unsupported Dimension type: ' + dimTypeEnum);
          }
        } else if (entity.type === '3DFACE') {
          console.log('Unsupported Entity Type: ' + entity.type, entity);
        } else {
          console.log('Unsupported Entity Type: ' + entity.type);
        }

        return mesh;
      }

      function drawEllipse(entity, data) {
        var color = getColor(entity, data);
        var xrad = Math.sqrt(Math.pow(entity.majorAxisEndPoint.x, 2) + Math.pow(entity.majorAxisEndPoint.y, 2));
        var yrad = xrad * entity.axisRatio;
        var rotation = Math.atan2(entity.majorAxisEndPoint.y, entity.majorAxisEndPoint.x);
        var curve = new EllipseCurve(entity.center.x, entity.center.y, xrad, yrad, entity.startAngle, entity.endAngle, false, // Always counterclockwise
        rotation);
        var points = curve.getPoints(50);
        var geometry = new BufferGeometry().setFromPoints(points);
        var material = new LineBasicMaterial({
          linewidth: 1,
          color: color
        }); // Create the final object to add to the scene

        var ellipse = new Line(geometry, material);
        return ellipse;
      }

      function drawMtext(entity, data) {
        var color = getColor(entity, data);

        if (!font) {
          return console.log('font parameter not set. Ignoring text entity.');
        }

        var geometry = new TextGeometry(entity.text, {
          font: font,
          size: entity.height * (4 / 5),
          height: 1
        });
        var material = new MeshBasicMaterial({
          color: color
        });
        var text = new Mesh(geometry, material); // Measure what we rendered.

        var measure = new Box3();
        measure.setFromObject(text);
        var textWidth = measure.max.x - measure.min.x; // If the text ends up being wider than the box, it's supposed
        // to be multiline. Doing that in threeJS is overkill.

        if (textWidth > entity.width) {
          console.log("Can't render this multipline MTEXT entity, sorry.", entity);
          return undefined;
        }

        text.position.z = 0;

        switch (entity.attachmentPoint) {
          case 1:
            // Top Left
            text.position.x = entity.position.x;
            text.position.y = entity.position.y - entity.height;
            break;

          case 2:
            // Top Center
            text.position.x = entity.position.x - textWidth / 2;
            text.position.y = entity.position.y - entity.height;
            break;

          case 3:
            // Top Right
            text.position.x = entity.position.x - textWidth;
            text.position.y = entity.position.y - entity.height;
            break;

          case 4:
            // Middle Left
            text.position.x = entity.position.x;
            text.position.y = entity.position.y - entity.height / 2;
            break;

          case 5:
            // Middle Center
            text.position.x = entity.position.x - textWidth / 2;
            text.position.y = entity.position.y - entity.height / 2;
            break;

          case 6:
            // Middle Right
            text.position.x = entity.position.x - textWidth;
            text.position.y = entity.position.y - entity.height / 2;
            break;

          case 7:
            // Bottom Left
            text.position.x = entity.position.x;
            text.position.y = entity.position.y;
            break;

          case 8:
            // Bottom Center
            text.position.x = entity.position.x - textWidth / 2;
            text.position.y = entity.position.y;
            break;

          case 9:
            // Bottom Right
            text.position.x = entity.position.x - textWidth;
            text.position.y = entity.position.y;
            break;

          default:
            return undefined;
        }

        return text;
      }

      function drawSpline(entity, data) {
        var color = getColor(entity, data);
        var points = entity.controlPoints.map(function (vec) {
          return new Vector2(vec.x, vec.y);
        });
        var interpolatedPoints = [];
        var curve;

        if (entity.degreeOfSplineCurve === 2 || entity.degreeOfSplineCurve === 3) {
          var i = 0;

          for (i = 0; i + 2 < points.length; i = i + 2) {
            if (entity.degreeOfSplineCurve === 2) {
              curve = new QuadraticBezierCurve(points[i], points[i + 1], points[i + 2]);
            } else {
              curve = new QuadraticBezierCurve3(points[i], points[i + 1], points[i + 2]);
            }

            interpolatedPoints.push.apply(interpolatedPoints, curve.getPoints(50));
          }

          if (i < points.length) {
            curve = new QuadraticBezierCurve3(points[i], points[i + 1], points[i + 1]);
            interpolatedPoints.push.apply(interpolatedPoints, curve.getPoints(50));
          }
        } else {
          curve = new SplineCurve(points);
          interpolatedPoints = curve.getPoints(100);
        }

        var geometry = new BufferGeometry().setFromPoints(interpolatedPoints);
        var material = new LineBasicMaterial({
          linewidth: 1,
          color: color
        });
        var splineObject = new Line(geometry, material);
        return splineObject;
      }

      function drawLine(entity, data) {
        var geometry = new Geometry();
        var color = getColor(entity, data);
        var material;
        var lineType;
        var vertex;
        var startPoint;
        var endPoint;
        var bulgeGeometry;
        var bulge;
        var i;
        var line;
        if (!entity.vertices) return console.log('entity missing vertices.'); // create geometry

        for (i = 0; i < entity.vertices.length; i++) {
          if (entity.vertices[i].bulge) {
            bulge = entity.vertices[i].bulge;
            startPoint = entity.vertices[i];
            endPoint = i + 1 < entity.vertices.length ? entity.vertices[i + 1] : geometry.vertices[0];
            bulgeGeometry = new BulgeGeometry(startPoint, endPoint, bulge);
            geometry.vertices.push.apply(geometry.vertices, bulgeGeometry.vertices);
          } else {
            vertex = entity.vertices[i];
            geometry.vertices.push(new Vector3(vertex.x, vertex.y, 0));
          }
        }

        if (entity.shape) geometry.vertices.push(geometry.vertices[0]); // set material

        if (entity.lineType) {
          lineType = data.tables.lineType.lineTypes[entity.lineType];
        }

        if (lineType && lineType.pattern && lineType.pattern.length !== 0) {
          material = new LineDashedMaterial({
            color: color,
            gapSize: 4,
            dashSize: 4
          });
        } else {
          material = new LineBasicMaterial({
            linewidth: 1,
            color: color
          });
        } // if(lineType && lineType.pattern && lineType.pattern.length !== 0) {
        //           geometry.computeLineDistances();
        //           // Ugly hack to add diffuse to this. Maybe copy the uniforms object so we
        //           // don't add diffuse to a material.
        //           lineType.material.uniforms.diffuse = { type: 'c', value: new THREE.Color(color) };
        // 	material = new THREE.ShaderMaterial({
        // 		uniforms: lineType.material.uniforms,
        // 		vertexShader: lineType.material.vertexShader,
        // 		fragmentShader: lineType.material.fragmentShader
        // 	});
        // }else {
        // 	material = new THREE.LineBasicMaterial({ linewidth: 1, color: color });
        // }


        line = new Line(geometry, material);
        return line;
      }

      function drawArc(entity, data) {
        var startAngle, endAngle;

        if (entity.type === 'CIRCLE') {
          startAngle = entity.startAngle || 0;
          endAngle = startAngle + 2 * Math.PI;
        } else {
          startAngle = entity.startAngle;
          endAngle = entity.endAngle;
        }

        var curve = new ArcCurve(0, 0, entity.radius, startAngle, endAngle);
        var points = curve.getPoints(32);
        var geometry = new BufferGeometry().setFromPoints(points);
        var material = new LineBasicMaterial({
          color: getColor(entity, data)
        });
        var arc = new Line(geometry, material);
        arc.position.x = entity.center.x;
        arc.position.y = entity.center.y;
        arc.position.z = entity.center.z;
        return arc;
      }

      function drawSolid(entity, data) {
        var material;
        var verts;
        var geometry = new Geometry();
        verts = geometry.vertices;
        verts.push(new Vector3(entity.points[0].x, entity.points[0].y, entity.points[0].z));
        verts.push(new Vector3(entity.points[1].x, entity.points[1].y, entity.points[1].z));
        verts.push(new Vector3(entity.points[2].x, entity.points[2].y, entity.points[2].z));
        verts.push(new Vector3(entity.points[3].x, entity.points[3].y, entity.points[3].z)); // Calculate which direction the points are facing (clockwise or counter-clockwise)

        var vector1 = new Vector3();
        var vector2 = new Vector3();
        vector1.subVectors(verts[1], verts[0]);
        vector2.subVectors(verts[2], verts[0]);
        vector1.cross(vector2); // If z < 0 then we must draw these in reverse order

        if (vector1.z < 0) {
          geometry.faces.push(new DEPRECATED_THREE.Face3(2, 1, 0));
          geometry.faces.push(new DEPRECATED_THREE.Face3(2, 3, 1));
        } else {
          geometry.faces.push(new DEPRECATED_THREE.Face3(0, 1, 2));
          geometry.faces.push(new DEPRECATED_THREE.Face3(1, 3, 2));
        }

        material = new MeshBasicMaterial({
          color: getColor(entity, data)
        });
        return new Mesh(geometry, material);
      }

      function drawText(entity, data) {
        var geometry, material, text;
        if (!font) return console.warn('Text is not supported without a Three.js font loaded with THREE.FontLoader! Load a font of your choice and pass this into the constructor. See the sample for this repository or Three.js examples at http://threejs.org/examples/?q=text#webgl_geometry_text for more details.');
        geometry = new TextGeometry(entity.text, {
          font: font,
          height: 0,
          size: entity.textHeight || 12
        });

        if (entity.rotation) {
          var zRotation = entity.rotation * Math.PI / 180;
          geometry.rotateZ(zRotation);
        }

        material = new MeshBasicMaterial({
          color: getColor(entity, data)
        });
        text = new Mesh(geometry, material);
        text.position.x = entity.startPoint.x;
        text.position.y = entity.startPoint.y;
        text.position.z = entity.startPoint.z;
        return text;
      }

      function drawPoint(entity, data) {
        var geometry, material, point;
        geometry = new Geometry();
        geometry.vertices.push(new Vector3(entity.position.x, entity.position.y, entity.position.z)); // TODO: could be more efficient. PointCloud per layer?

        var numPoints = 1;
        var color = getColor(entity, data);
        var colors = new Float32Array(numPoints * 3);
        colors[0] = color.r;
        colors[1] = color.g;
        colors[2] = color.b;
        geometry.colors = colors;
        geometry.computeBoundingBox();
        material = new PointsMaterial({
          size: 0.05,
          vertexColors: VertexColors
        });
        point = new Points(geometry, material);
        entities.push(point);
      }

      function drawDimension(entity, data) {
        var block = data.blocks[entity.block];
        if (!block || !block.entities) return null;
        var group = new Object3D(); // if(entity.anchorPoint) {
        //     group.position.x = entity.anchorPoint.x;
        //     group.position.y = entity.anchorPoint.y;
        //     group.position.z = entity.anchorPoint.z;
        // }

        for (var i = 0; i < block.entities.length; i++) {
          var childEntity = drawEntity(block.entities[i], data);
          if (childEntity) group.add(childEntity);
        }

        return group;
      }

      function drawBlock(entity, data) {
        var block = data.blocks[entity.name];
        if (!block.entities) return null;
        var group = new Object3D();
        if (entity.xScale) group.scale.x = entity.xScale;
        if (entity.yScale) group.scale.y = entity.yScale;

        if (entity.rotation) {
          group.rotation.z = entity.rotation * Math.PI / 180;
        }

        if (entity.position) {
          group.position.x = entity.position.x;
          group.position.y = entity.position.y;
          group.position.z = entity.position.z;
        }

        for (var i = 0; i < block.entities.length; i++) {
          var childEntity = drawEntity(block.entities[i], data);
          if (childEntity) group.add(childEntity);
        }

        return group;
      }

      function getColor(entity, data) {
        var color = 0x000000; // default

        if (entity.color) color = entity.color;else if (data.tables && data.tables.layer && data.tables.layer.layers[entity.layer]) color = data.tables.layer.layers[entity.layer].color;

        if (color == null || color === 0xffffff) {
          color = 0x000000;
        }

        return color;
      }

      function createLineTypeShaders(data) {
        var ltype, type;
        if (!data.tables || !data.tables.lineType) return;
        var ltypes = data.tables.lineType.lineTypes;

        for (type in ltypes) {
          ltype = ltypes[type];
          if (!ltype.pattern) continue;
          ltype.material = createDashedLineShader(ltype.pattern);
        }
      }

      function createDashedLineShader(pattern) {
        var i;
        var dashedLineShader = {};
        var totalLength = 0.0;

        for (i = 0; i < pattern.length; i++) {
          totalLength += Math.abs(pattern[i]);
        }

        dashedLineShader.uniforms = UniformsUtils.merge([UniformsLib.common, UniformsLib.fog, {
          pattern: {
            type: 'fv1',
            value: pattern
          },
          patternLength: {
            type: 'f',
            value: totalLength
          }
        }]);
        dashedLineShader.vertexShader = ['attribute float lineDistance;', 'varying float vLineDistance;', ShaderChunk.color_pars_vertex, 'void main() {', ShaderChunk.color_vertex, 'vLineDistance = lineDistance;', 'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );', '}'].join('\n');
        dashedLineShader.fragmentShader = ['uniform vec3 diffuse;', 'uniform float opacity;', 'uniform float pattern[' + pattern.length + '];', 'uniform float patternLength;', 'varying float vLineDistance;', ShaderChunk.color_pars_fragment, ShaderChunk.fog_pars_fragment, 'void main() {', 'float pos = mod(vLineDistance, patternLength);', 'for ( int i = 0; i < ' + pattern.length + '; i++ ) {', 'pos = pos - abs(pattern[i]);', 'if( pos < 0.0 ) {', 'if( pattern[i] > 0.0 ) {', 'gl_FragColor = vec4(1.0, 0.0, 0.0, opacity );', 'break;', '}', 'discard;', '}', '}', ShaderChunk.color_fragment, ShaderChunk.fog_fragment, '}'].join('\n');
        return dashedLineShader;
      }
    }
  }]);

  return DXFLoader;
}(Loader);

var GarbageCollector =
/** @class */
function () {
  function GarbageCollector() {
    this.resources = new Set();
  }

  GarbageCollector.prototype.Instantiate = function (resource) {
    if (resource.dispose) {
      this.resources.add(resource);
    }

    return resource;
  };

  GarbageCollector.prototype.untrack = function (resource) {
    this.resources.delete(resource);
  };

  GarbageCollector.prototype.dispose = function () {
    var e_1, _a;

    try {
      for (var _b = __values(this.resources), _c = _b.next(); !_c.done; _c = _b.next()) {
        var resource = _c.value;
        resource.dispose();
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    this.resources.clear();
  };

  return GarbageCollector;
}();

var MaterialType;

(function (MaterialType) {
  MaterialType[MaterialType["Highlight"] = 0] = "Highlight";
  MaterialType[MaterialType["Standard"] = 1] = "Standard";
})(MaterialType || (MaterialType = {}));

var ContextObject =
/** @class */
function () {
  function ContextObject() {
    Object3D.DefaultUp = new Vector3(0, 0, 1);
    this.scene = new Scene();
    this.renderer = new WebGL1Renderer();
    this.amb_light = new AmbientLight(0xffffff, 0.4);
    this.dir_light = new DirectionalLight(0xffffff, 0.6);
    this.dir_light2 = new DirectionalLight(0xffffff, 0.2);
    this.dxfLoader = new DXFLoader();
    this.garbageCollector = new GarbageCollector();
    this.highlightColor = new Color(0x003566);
    this.standardColor = new Color(0xffffff);
    this.highlightMaterial = new MeshLambertMaterial({
      opacity: 0.8,
      transparent: true,
      color: this.highlightColor
    });
    this.standardMaterial = new MeshLambertMaterial({
      opacity: 1,
      transparent: false,
      color: this.standardColor
    });
    this.guiSettings = {
      BackgroundColor: [193, 208, 200],
      Outlines: false,
      OutlineColor: '#000000',
      Explode: false
    };
    this.lightdistance = 20;
    this.shadowSize = 50;
    this.dataPath = './data/RG_POC_Data.json';
    this.transformControlEnabled = false;
    this.mouse = new Vector2();
    this.parentElement = {
      domElement: null,
      dimensions: null
    };
    var dimensions = this.updateParentDimensions();
    console.log(dimensions);

    if (dimensions !== undefined) {
      this.perspCamera = new PerspectiveCamera(45, dimensions.width / dimensions.height, 0.1, 10000);
      this.orthoCamera = new OrthographicCamera(-30 * dimensions.width / dimensions.height, 30 * dimensions.width / dimensions.height, 30, -30, 0.1, 10000);
    } // Set initial Value for Camera after creating both camera types.


    this.currentCamera = this.orthoCamera;
  }

  ContextObject.prototype.updateParentDimensions = function () {
    var div_dev = document.getElementById('root');
    var div_prod = document.getElementsByClassName('building-plan-wrapper')[0];

    if (div_prod !== undefined && div_prod != null) {
      this.parentElement.domElement = div_prod;
    } else {
      this.parentElement.domElement = div_dev;
    }

    if (this.parentElement.domElement !== undefined && this.parentElement.domElement !== null) {
      this.parentElement.dimensions = this.parentElement.domElement.getBoundingClientRect();
    }

    return this.parentElement.dimensions;
  };
  /**
   * init3JS - Scene Setup
   */


  ContextObject.prototype.init3JS = function (scene, currentCamera, controls, transformControl, composer, renderPass) {
    var _a; //Renderer


    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = PCFSoftShadowMap;
    this.renderer.setSize(this.parentElement.dimensions.width, this.parentElement.dimensions.height);
    (_a = this.parentElement.domElement) === null || _a === void 0 ? void 0 : _a.appendChild(this.renderer.domElement); // Scene

    scene.background = new Color(this.guiSettings.BackgroundColor[0] / 255, this.guiSettings.BackgroundColor[1] / 255, this.guiSettings.BackgroundColor[2] / 255); // Camera

    currentCamera.position.set(75, 0, 50);
    this.perspCamera.position.set(75, 0, 50);
    this.orthoCamera.position.set(75, 0, 50); // Controls

    controls.current.minDistance = 5;
    controls.current.maxDistance = 10000;
    controls.current.enablePan = true;
    controls.current.enableDamping = true;
    controls.current.dampingFactor = 1;
    controls.current.minPolarAngle = 0;
    controls.current.maxPolarAngle = 1.5;
    controls.current.enablePan = false;
    transformControl.current.setMode('rotate');
    transformControl.current.setSize(2); // Light

    scene.add(this.amb_light);
    this.dir_light.position.set(20, 40, 60);
    this.dir_light.castShadow = true;
    this.dir_light.shadow.mapSize.width = 1024;
    this.dir_light.shadow.mapSize.height = 1024;
    this.dir_light.shadow.camera.far = this.shadowSize * 2;
    scene.add(this.dir_light);
    scene.add(this.dir_light.target);
    this.dir_light.target.updateMatrixWorld();
    this.dir_light2.position.set(-20, -40, 60);
    scene.add(this.dir_light2);
    scene.add(this.dir_light2.target);
    this.dir_light2.target.updateMatrixWorld(); // Render Passes

    composer.addPass(renderPass.current);
  };

  return ContextObject;
}();

var DrawingContour =
/** @class */
function () {
  function DrawingContour(index, shape, mesh_id, line_geometry_id, area) {
    this.id = index.toString();
    this.index = index;
    this.shape = shape;
    this.mesh_id = mesh_id;
    this.line_geometry_id = line_geometry_id;
    this.area = area;
  }

  return DrawingContour;
}();

var DrawingData =
/** @class */
function () {
  function DrawingData(drawingContours, box) {
    this.contourLookup = {};
    this.drawingContours = drawingContours;
    this.selectedObjects = [];
    this.contourLookup = this.createLookup(drawingContours);
    this.boundingBox = box;
  }

  DrawingData.prototype.createLookup = function (drawingContours) {
    var contourLookup = {};
    drawingContours.forEach(function (c) {
      contourLookup[c.index] = c;
    });
    return contourLookup;
  };

  return DrawingData;
}();

var GeneratedData =
/** @class */
function () {
  function GeneratedData(quantities) {
    this.subBuildings = [];
    this.quantities = quantities;
    this.floorAreas = [];
  }

  return GeneratedData;
}();

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".building-plan {\n  width: 100%;\n  height: 100%;\n}";
styleInject(css_248z);

var BuildingPlanDxf = function BuildingPlanDxf(_a) {
  var step = _a.step,
      planFile = _a.planFile,
      planData = _a.planData,
      viewOptions = _a.viewOptions,
      onPlanLoaded = _a.onPlanLoaded
  /* , onModelItemEvent */
  ,
      onCalculated = _a.onCalculated;
  /**************************************************************************** */

  /** VARIABLES */

  /**************************************************************************** */
  // Storage

  var drawingData = useRef(null);
  var generatedData = useRef(null);
  var contextObject = useRef(null);
  var controls = useRef(null);
  var transformControl = useRef(null);
  var composer = useRef(null);
  var renderPass = useRef(null);
  var outlinePass = useRef(null);
  var file = planFile;
  var filePath = planFile === null || planFile === void 0 ? void 0 : planFile.src; // Mutable Data Object

  var transformControlObj,
      isUpdating = false; // prevents multiple updates happeing at the same time

  /**************************************************************************** */

  /** SCENE SETUP */

  /**************************************************************************** */

  /**
   *
   */

  function initListeners() {
    transformControl.current.addEventListener('dragging-changed', function (event) {
      controls.current.enabled = !event.value; //disable currentCamera turning with mouse when using transform controls
    }); // Currently unused, to control terrain inclination.

    /* transformControl.current.addEventListener('change', function () {
        if (transformControlObj !== undefined) {
            transformControlObj.rotateZ(transformControlObj.rotation.z);
            const building = SceneHelpers.GetSubBuildingByName(generatedData.current.subBuildings, 'plot');
            if (building.levelMap != undefined) {
                building.levelMap.get('0').needsUpdate = true;
            }
            RebuildGeometry();
        }
    }); */

    window.addEventListener('resize', onWindowResize);
    document.body.addEventListener('mousemove', onDocumentMouseMove, false);
    document.body.addEventListener('pointerdown', onDocumentMouseDown, false);
    document.body.addEventListener('keydown', onDocumentKeyDown, false);
  }
  /**
   * initWizard
   */


  function initWizard() {
    // Loads the json and then the dxf file
    cleanupScene(contextObject.current.scene);

    var onLoad = function onLoad(data) {
      if (data && data.entities) {
        var drawingContours_1 = [];
        var objectGroup_1 = new Group();
        data.entities.forEach(function (ent) {
          objectGroup_1.add(ent);
        }); // Bounding box of all shapes

        var boundingBox_1 = new Box3();
        var contour_geo_1 = [];
        var count_1 = 0;
        objectGroup_1.traverse(function (child) {
          if (child.geometry) {
            // create THREE shapes from Line vertex data of the dxf
            var verts = child.geometry.vertices;
            var shapeVerts = [];
            var size_1 = planData != undefined && planData.scaleFactor ? planData.scaleFactor : 1;

            for (var index = 0; index < verts.length; index++) {
              var element = verts[index];
              shapeVerts.push(new Vector2(element.x * size_1, element.y * size_1));
            }

            var shape = new Shape(shapeVerts);
            var level = new Level([shape], 0.01);
            var mesh = InstantiateLevel(contextObject.current.garbageCollector, 1, contextObject.current.scene, level, new MeshBasicMaterial({
              transparent: true,
              opacity: 0,
              color: 0x00ffff
            })); // expand box by new shape

            boundingBox_1.expandByObject(mesh); // mesh.translateZ(0.1);

            mesh.visible = true;
            mesh.name = 'shapeMesh';
            mesh.castShadow = false;
            mesh.receiveShadow = false;
            var edges = new EdgesGeometry(mesh.geometry);
            var line = new LineSegments(edges, new LineBasicMaterial({
              color: contextObject.current.guiSettings.OutlineColor
            }));
            var geometry = new Group();
            geometry.add(line);
            contextObject.current.scene.add(geometry);
            var drawingContour = new DrawingContour(count_1, shape, mesh.id, geometry.id, Math.abs(ShapeUtils.area(shapeVerts))); // Store Contour ID for callback to Host Component.

            contour_geo_1.push(drawingContour);
            drawingContours_1.push(drawingContour);
            count_1++;
          }
        }); // get center voa bounding box

        var center = new Vector3();
        boundingBox_1.getCenter(center);
        var size = new Vector3();
        boundingBox_1.getSize(size);
        controls.current.target.set(center.x, center.y, 0);
        contextObject.current.orthoCamera.position.set(center.x, center.y - 0.01, 10);
        contextObject.current.orthoCamera.lookAt(center.x, center.y, 0);
        contextObject.current.orthoCamera.left = -size.x * contextObject.current.parentElement.dimensions.width / contextObject.current.parentElement.dimensions.height;
        contextObject.current.orthoCamera.right = size.x * contextObject.current.parentElement.dimensions.width / contextObject.current.parentElement.dimensions.height;
        contextObject.current.orthoCamera.top = size.y;
        contextObject.current.orthoCamera.bottom = -size.y;
        contextObject.current.orthoCamera.updateProjectionMatrix(); // DEBUG draw bounding box
        // const boxHelper = new THREE.Box3Helper(boundingBox, new THREE.Color(0xff0000));
        // contextObject.current.scene.add(boxHelper);

        var newLightPos = center.clone();
        newLightPos.add(new Vector3(20, 40, 60));
        contextObject.current.dir_light.position.copy(newLightPos);
        contextObject.current.dir_light.updateMatrixWorld();
        contextObject.current.dir_light.target.position.copy(center);
        contextObject.current.dir_light.target.updateMatrixWorld();
        contextObject.current.dir_light.shadow.camera.left = -size.x * 0.75;
        contextObject.current.dir_light.shadow.camera.right = size.x * 0.75;
        contextObject.current.dir_light.shadow.camera.top = size.y * 2;
        contextObject.current.dir_light.shadow.camera.bottom = -size.y * 0.5; // DEBUG shadow box
        // const helper = new THREE.CameraHelper(contextObject.current.dir_light.shadow.camera);
        // contextObject.current.scene.add(helper);
        // Store Data in Ref Objects

        drawingData.current = new DrawingData(drawingContours_1, boundingBox_1);
        generatedData.current = new GeneratedData([{
          name: 'SA',
          value: 0
        }, {
          name: 'FA',
          value: 0
        }, {
          name: 'BV',
          value: 0
        }, {
          name: 'FGA',
          value: 0
        }, {
          name: 'FGMA',
          value: 0
        }, {
          name: 'BRA',
          value: 0
        }, {
          name: 'ESA',
          value: 0
        }]); // Pass PlanModel to Host Component.

        console.log('onPlanLoaded sent data: ', contour_geo_1);
        onPlanLoaded({
          contours: contour_geo_1,
          messages: [
            /* {
                type: 'info',
                message: 'All good.',
            }, */
          ]
        });
      }
    };

    var onError = function onError(error) {
      console.log(error);
    };

    var onProgress = function onProgress(xhr) {
      console.log('DXFLoader: ' + xhr.loaded / xhr.total * 100 + '% loaded');
    };

    console.log('Loading DXF File: ', file.name);
    contextObject.current.dxfLoader.load(filePath, onLoad, onProgress, onError);
  }

  function cleanupScene(scene) {
    for (var i = scene.children.length - 1; i >= 0; i--) {
      var obj = scene.children[i];
      if (obj.isObject3D && !obj.type.toLowerCase().includes('light')) scene.remove(obj);
    }
  }

  function cleanupGeneratedGeometry(scene) {
    for (var i = scene.children.length - 1; i >= 0; i--) {
      var obj = scene.children[i];

      if (obj.isObject3D && obj.visible == true && obj.type === 'Mesh' && obj.name != 'shapeMesh') {
        scene.remove(obj);
      }
    }
  }
  /**
   *
   * @returns
   */


  function RebuildGeometry() {
    var e_1, _a;

    if (isUpdating) return;
    isUpdating = true; // Remove all instantiated objects

    cleanupGeneratedGeometry(contextObject.current.scene);
    transformControlObj = InstantiateSubBuildings(contextObject.current.guiSettings, generatedData.current.subBuildings, contextObject.current.scene, contextObject.current.garbageCollector, transformControl, contextObject.current.transformControlEnabled, transformControlObj, drawingData.current.boundingBox // controls,
    // contextObject.current
    ); // Set Camera
    // get center voa bounding box

    var center = new Vector3();
    drawingData.current.boundingBox.getCenter(center);
    contextObject.current.orthoCamera.position.set(center.x, center.y - 0.01, drawingData.current.boundingBox.max.z + 2);
    contextObject.current.orthoCamera.updateProjectionMatrix(); // calculate areas and Volumes

    for (var i = 0; i < generatedData.current.subBuildings.length; i++) {
      if (generatedData.current.subBuildings[i].name === 'plot') continue;

      try {
        for (var _b = (e_1 = void 0, __values(generatedData.current.subBuildings[i].levelMap)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var _d = __read(_c.value, 2),
              value = _d[1];

          CalculateLevelSizes$1(value);
        }
      } catch (e_1_1) {
        e_1 = {
          error: e_1_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_1) throw e_1.error;
        }
      }
    } // update areas and Volumes in GUI Data and JSON


    UpdateDataRepresentation2(planData, generatedData.current, contextObject.current.garbageCollector); // Pass PlanModel to Host Component.

    onCalculated({
      quantities: generatedData.current.quantities,
      floorAreas: generatedData.current.floorAreas,
      messages: [
        /* {
            type: 'info',
            message: 'All good.',
        }, */
      ]
    }); //console.log('sent updated calculations: ', generatedData.current);

    isUpdating = false;
  }
  /**
   * *********************************************************************************************
   * REACT
   * *********************************************************************************************
   */

  /**
   *
   * @param drawingData
   * @returns
   */


  function deselectObjects(drawingData) {
    if (drawingData === null || drawingData === undefined) return;
    /*drawingData.selectedObjects.forEach((mesh: THREE.Mesh) => {
        //setMeshColor(mesh, MaterialType.Standard);
        const e = contextObject.current.scene.getObjectById(mesh);
        if (e) {
            e.visible = false;
        }
    });*/

    drawingData.selectedObjects = [];
    composer.current.removePass(outlinePass.current);
    composer.current.insertPass(outlinePass.current, 1);
  }

  function addElementToSelectionPass(element) {
    drawingData.current.selectedObjects.push(element);
    outlinePass.current.selectedObjects = drawingData.current.selectedObjects;
    composer.current.removePass(outlinePass.current);
    composer.current.insertPass(outlinePass.current, 1);
  }
  /* function setMeshColor(mesh:THREE.Mesh, type: MaterialType) {
      if (mesh) {
          if( type === MaterialType.Standard) {
              mesh.material = contextObject.current.standardMaterial;
          } else {
              mesh.material = contextObject.current.highlightMaterial;
          }
      }
  } */

  /**
   *
   * @param drawingData
   * @param elementId
   */


  function highlightObject(drawingData, elementId, highlightType, itemType) {
    console.log(highlightType + " ID: ", elementId, "ItemType: " + itemType, "SelectedItems: " + drawingData.selectedObjects.length);

    if (highlightType === 'hover') {
      if (itemType === 'contour') {
        var de = drawingData.drawingContours[parseInt(elementId)];
        var e = contextObject.current.scene.getObjectById(de.mesh_id);

        if (de !== undefined && e !== undefined) {
          console.log('e', e);
          e.visible = true; // e.position.set(e.position.x,e.position.y,contextObject.current.orthoCamera.position.z - 1);

          addElementToSelectionPass(e);
        }
      } else if (itemType === 'floor') {
        console.log('Floor!');
        console.log('Floor ID: ', elementId);
        var mesh = findFloorMeshWithGuid(elementId);

        if (mesh != null) {
          addElementToSelectionPass(mesh); //setMeshColor(mesh, MaterialType.Highlight);
        }
      } else if (itemType === 'building') {
        console.log('Building!');
        console.log('Building ID: ', elementId);
      } else {
        console.log('unkonwn ItemType!');
      }
    } else if (highlightType === 'select') {
      if (itemType === 'contour') {
        var de = drawingData.drawingContours[parseInt(elementId)];
        var e = contextObject.current.scene.getObjectById(de.line_geometry_id);

        if (de !== undefined && e !== undefined) {
          console.log('e', e);
          e.visible = true;
        }
      } else if (itemType === 'floor') {
        console.log('Floor!');
        console.log('Floor ID: ', elementId);
      } else if (itemType === 'building') {
        console.log('Building!');
        console.log('Building ID: ', elementId);
      } else {
        console.log('unkonwn ItemType!');
      }
    }
  } // - On Startup


  useEffect(function () {
    contextObject.current = new ContextObject();
    transformControl.current = new TransformControls(contextObject.current.perspCamera, contextObject.current.renderer.domElement);
    composer.current = new EffectComposer(contextObject.current.renderer);
    renderPass.current = new RenderPass(contextObject.current.scene, contextObject.current.currentCamera);
    outlinePass.current = new OutlinePass(new Vector2(contextObject.current.parentElement.dimensions.width, contextObject.current.parentElement.dimensions.height), contextObject.current.scene, contextObject.current.currentCamera);
    outlinePass.current.visibleEdgeColor = new Color(0xff5500);
    outlinePass.current.hiddenEdgeColor = new Color(0xff5500);
    outlinePass.current.edgeStrength = 3;
    outlinePass.current.edgeGlow = 1;
    outlinePass.current.edgeThickness = 1.5;
  }, []); // - On Plan Reload

  useEffect(function () {
    // Report Change from Parent Component.
    //console.log('planFile.src has changed, new value: ', planFile.src.length);
    controls.current = new OrbitControls(contextObject.current.currentCamera, contextObject.current.renderer.domElement);
    contextObject.current.updateParentDimensions();
    contextObject.current.init3JS(contextObject.current.scene, contextObject.current.currentCamera, controls, transformControl, composer.current, renderPass);
    contextObject.current.renderer.setSize(contextObject.current.parentElement.dimensions.width, contextObject.current.parentElement.dimensions.height);
    composer.current.setSize(contextObject.current.parentElement.dimensions.width, contextObject.current.parentElement.dimensions.height);
    composer.current.addPass(outlinePass.current);
    initListeners();
    initWizard();
  }, [planFile.src]); // Custom Update

  /*  useEffect( () => {
      // Report Change from Parent Component.
      console.log('contextObject.current.currentCameraType has changed, new value: ', contextObject.current.currentCameraType);
      setVisibilities(step);
  }, [contextObject.current?.currentCameraType]); */
  // Camera Type has changed.

  /* useEffect(() => {
      // Report Change from Parent Component.
      console.log('viewOptions.cameraMode has changed, new value: ', viewOptions.cameraMode);
      setVisibilities(step, viewOptions.cameraMode);
  }, [viewOptions.cameraMode]); */
  // Step has changed.

  useEffect(function () {
    // Report Change from Parent Component.
    console.log('step has changed, new value: ', step);
    console.log('or');
    console.log('viewOptions.cameraMode has changed, new value: ', viewOptions.cameraMode);
    setVisibilities(step, viewOptions.cameraMode);
  }, [step, viewOptions.cameraMode]); // List Events from UI

  useEffect(function () {
    // Report Change from Parent Component.
    console.log('viewOptions.highlights has changed, new value: ', viewOptions.highlights);
    if (viewOptions.highlights == undefined) return;
    deselectObjects(drawingData.current);
    viewOptions.highlights.forEach(function (highlight) {
      if (highlight != null) highlightObject(drawingData.current, highlight.itemId, highlight.eventType, highlight.itemType);
    });
  }, [viewOptions.highlights]); // Events from Focus

  /* useEffect(() => {
      // Report Change from Parent Component.
      if (viewOptions.focus != undefined) {
          const currentfocus: any = viewOptions.focus;
          console.log('viewOptions.focus has changed, new value: ', currentfocus);
           if (currentfocus.floorId != undefined) {
              generatedData.current.subBuildings.forEach((building: SubBuilding) => {
                  for (const [, value] of building.levelMap) {
                      console.log('viewOptions.focus comparing', currentfocus.floorId, 'with', value.id);
                      console.log('viewOptions.focus level', value);
                       if (currentfocus.floorId == value.id) {
                          console.log('viewOptions.focuscomparison true!');
                          value.mesh.visible = true;
                      }
                      else
                          value.mesh.visible = false;
                   }
              });
          }
          else {
              console.log('viewOptions.focus no floor focus, making all visible');
              generatedData.current.subBuildings.forEach((building: SubBuilding) => {
                  for (const [, value] of building.levelMap) {
                      value.mesh.visible = true;
                  }
              });
          }
      }
  }, [(viewOptions.focus as any)]); */
  // Plan Data Changes

  useEffect(function () {
    // Report Change from Parent Component.
    console.log('planData has changed, new value: ', planData);

    if (planData && planData.scaleFactor) {
      var res = function res() {
        return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , initWizard()];

              case 1:
                _a.sent();

                return [2
                /*return*/
                ];
            }
          });
        });
      };

      console.log(res);
    } // Build Floors and structure


    if (planData && planData.contours && planData.contours.length > 0) {
      var res = function res() {
        return __awaiter(void 0, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4
                /*yield*/
                , initWizard()];

              case 1:
                _a.sent();

                return [2
                /*return*/
                ];
            }
          });
        });
      };

      console.log(res);
      console.log('planData: ', planData);
      CreateBuildingDataStructure(planData, drawingData.current, generatedData.current, contextObject.current.garbageCollector);
      RebuildGeometry();
      setVisibilities(step, viewOptions.cameraMode);
    } //console.log(contextObject.current.garbageCollector.resources.size);

  }, [planData]);
  useEffect(function () {
    var animate = function animate() {
      // Update Animations
      setTimeout(function () {
        animate();
      }, 1000 / 25); // Update Controls

      controls.current.update(); // Update Renderer

      composer.current.render();
    };

    animate();
  }, []); // - Beim ändern von Data Aufgerufen (Internal)

  /* useEffect(() => {
      if (contextObject.current.scene) {
          let animation = -1;
          const animate = function () {
              // Update Animations
              setTimeout(function () {
                  animation = requestAnimationFrame(animate);
              }, 1000 / 30);
               // Update Controls
              controls.current.update();
              // Update Renderer
              composer.current.render();
          };
           animate();
           // Cleanup Function from Loop
          return () => {
              cancelAnimationFrame(animation);
          };
      }
  }, [contextObject.current?.scene]); */

  /**************************************************************************** */

  /** SCENE CONTROLLING */

  /**************************************************************************** */

  function toggleCameraType(type) {
    if (type === 'orthographic') {
      console.log('Switching to orthographic Camera'); // ****************************************
      // DEBUG -> disable controls!!!

      controls.current.enabled = true; //false;
      // ****************************************

      contextObject.current.currentCamera = contextObject.current.orthoCamera;
      /* contextObject.current.currentCameraType = 'orthographic'; */

      SetActiveLight(false);
    } else {
      console.log('Switching to Perspective Camera');
      controls.current.enabled = true;
      contextObject.current.currentCamera = contextObject.current.perspCamera;
      /* contextObject.current.currentCameraType = 'perspective'; */

      if (contextObject.current.currentCamera) {
        controls.current.object = contextObject.current.currentCamera;
        transformControl.current.camera = contextObject.current.currentCamera;
        contextObject.current.currentCamera.lookAt(controls.current.target.x, controls.current.target.y, controls.current.target.z);
      }

      SetActiveLight(true);
    }

    if (contextObject.current.currentCamera) {
      outlinePass.current.renderCamera = contextObject.current.currentCamera;
      composer.current.removePass(renderPass.current);
      renderPass.current = new RenderPass(contextObject.current.scene, contextObject.current.currentCamera);
      composer.current.addPass(renderPass.current);
      onWindowResize();
    }
  }

  function findFloorMeshWithGuid(guid) {
    var result = null;
    generatedData.current.subBuildings.forEach(function (building) {
      var e_2, _a;

      try {
        for (var _b = __values(building.levelMap), _c = _b.next(); !_c.done; _c = _b.next()) {
          var _d = __read(_c.value, 2),
              value = _d[1]; //console.log('viewOptions.focus comparing', guid, 'with', value.id);


          if (guid == value.id) {
            //console.log('viewOptions.focus comparison true!');
            result = value.mesh;
          }
        }
      } catch (e_2_1) {
        e_2 = {
          error: e_2_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_2) throw e_2.error;
        }
      }
    });
    return result;
  }

  function toggleGeometryVisibility(visible, floorId) {
    var e_3, _a;

    for (var i = 1; i < generatedData.current.subBuildings.length; i++) {
      try {
        for (var _b = (e_3 = void 0, __values(generatedData.current.subBuildings[i].levelMap)), _c = _b.next(); !_c.done; _c = _b.next()) {
          var _d = __read(_c.value, 2),
              value = _d[1];

          if (value.mesh !== undefined) {
            if (visible) {
              if (floorId) {
                if (floorId === value.id) {
                  value.mesh.visible = true;
                } else {
                  value.mesh.visible = false;
                }
              } else {
                value.mesh.visible = true;
              } //value.mesh.visible = true;

            } else {
              value.mesh.visible = false;
            }
          }
        }
      } catch (e_3_1) {
        e_3 = {
          error: e_3_1
        };
      } finally {
        try {
          if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
          if (e_3) throw e_3.error;
        }
      }
    }
  }

  function setVisibilities(step, cameraType) {
    switch (step) {
      case 'setScaleFactor':
        {
          // Only Polylines, Ortho Camera.
          console.log('step: setScaleFactor');
          toggleGeometryVisibility(false);
          togglePlotVisibility(false);
          toggleCameraType('orthographic');
          break;
        }

      case 'selectContour':
        {
          // Only Polylines, Ortho Camera.
          console.log('step: selectContour');
          toggleGeometryVisibility(false);
          togglePlotVisibility(true);
          toggleCameraType('orthographic');
          break;
        }

      case 'defineStructure':
        {
          // 3d, Perspective Camera.
          console.log('step: defineStructure');

          if (cameraType === 'perspective') {
            toggleGeometryVisibility(true);
            togglePlotVisibility(true);
            toggleCameraType('perspective');
          } else {
            if (viewOptions.focus != undefined) {
              toggleGeometryVisibility(true, viewOptions.focus.itemId);
            } else {
              toggleGeometryVisibility(true);
            }

            togglePlotVisibility(false);
            toggleCameraType('orthographic');
          }

          break;
        }

      case 'showResults':
        {
          // 3d, Perspective Camera.
          console.log('step: showResults');
          toggleGeometryVisibility(true);
          togglePlotVisibility(true);
          toggleCameraType('perspective'); // highlightObject(drawingData.current, '1', 'hover', 'contour');

          break;
        }
    }
  }

  function togglePlotVisibility(visible) {
    var building = GetSubBuildingByName(generatedData.current.subBuildings, 'plot');

    if (building !== undefined) {
      var levelMap = building.levelMap.get('0');

      if (levelMap.mesh !== undefined) {
        if (visible) {
          levelMap.mesh.visible = true;
        } else {
          levelMap.mesh.visible = false;
        }
      }
    }
  }

  function SetActiveLight(active) {
    contextObject.current.dir_light.castShadow = active;
    contextObject.current.dir_light.castShadow = false;
  }
  /**
   *
   */


  function onWindowResize() {
    contextObject.current.updateParentDimensions();
    contextObject.current.perspCamera.aspect = contextObject.current.parentElement.dimensions.width / contextObject.current.parentElement.dimensions.height;
    contextObject.current.perspCamera.updateProjectionMatrix(); // get center voa bounding box

    var center = new Vector3();
    drawingData.current.boundingBox.getCenter(center);
    var size = new Vector3();
    drawingData.current.boundingBox.getSize(size);
    contextObject.current.orthoCamera.left = -size.x * contextObject.current.parentElement.dimensions.width / contextObject.current.parentElement.dimensions.height;
    contextObject.current.orthoCamera.right = size.x * contextObject.current.parentElement.dimensions.width / contextObject.current.parentElement.dimensions.height;
    contextObject.current.orthoCamera.top = size.y;
    contextObject.current.orthoCamera.bottom = -size.y;
    contextObject.current.orthoCamera.updateProjectionMatrix(); // contextObject.current.orthoCamera.left =
    //     (-30 * contextObject.current.parentElement.dimensions.width) /
    //     contextObject.current.parentElement.dimensions.height;
    // contextObject.current.orthoCamera.right =
    //     (30 * contextObject.current.parentElement.dimensions.width) /
    //     contextObject.current.parentElement.dimensions.height;
    // contextObject.current.orthoCamera.top = 30;
    // contextObject.current.orthoCamera.bottom = -30;
    // contextObject.current.orthoCamera.updateProjectionMatrix();

    contextObject.current.renderer.setSize(contextObject.current.parentElement.dimensions.width, contextObject.current.parentElement.dimensions.height);
    composer.current.setSize(contextObject.current.parentElement.dimensions.width, contextObject.current.parentElement.dimensions.height);
  }
  /**
   *
   */


  function onDocumentMouseMove(event) {
    event.preventDefault();
    contextObject.current.mouse.x = (event.clientX - contextObject.current.parentElement.dimensions.x) / contextObject.current.parentElement.dimensions.width * 2 - 1;
    contextObject.current.mouse.y = -((event.clientY - contextObject.current.parentElement.dimensions.y) / contextObject.current.parentElement.dimensions.height) * 2 + 1;
  }
  /**
   *
   */


  function onDocumentMouseDown() {
    if (drawingData.current) {
      drawingData.current.selectedObjects = checkIntersections(contextObject.current.mouse, contextObject.current.currentCamera, contextObject.current.scene);
    }
  }

  function onDocumentKeyDown(event) {
    var keyCode = event.which;

    if (keyCode === 13) {
      console.log('Subbuildings: ', generatedData.current.subBuildings);
    }
  }

  return React.createElement("div", {
    id: "building-plan",
    className: "building-plan"
  });
};

BuildingPlanDxf.displayName = 'BuildingPlanDxf';
var DEFAULT_CONTEXT = {
  isDebugMode: false,
  isVerbose: false
};
var IfcComponentContext = React.createContext(DEFAULT_CONTEXT);
/**
 * In the IFC file, a primitive might be associated to a CRB code.
 * This code can be provided in German, French or Italian
 */

var CRB_CODE;

(function (CRB_CODE) {
  CRB_CODE[CRB_CODE["GF"] = 0] = "GF";
  CRB_CODE[CRB_CODE["SP"] = 1] = "SP";
  CRB_CODE[CRB_CODE["GSF"] = 2] = "GSF";
  CRB_CODE[CRB_CODE["ST"] = 3] = "ST";
  CRB_CODE[CRB_CODE["SF"] = 4] = "SF";
  CRB_CODE[CRB_CODE["UUF"] = 5] = "UUF";
  CRB_CODE[CRB_CODE["SAN"] = 6] = "SAN";
  CRB_CODE[CRB_CODE["SLEN"] = 7] = "SLEN";
  CRB_CODE[CRB_CODE["BUF"] = 8] = "BUF";
  CRB_CODE[CRB_CODE["SAA"] = 9] = "SAA";
  CRB_CODE[CRB_CODE["SLES"] = 10] = "SLES";
  CRB_CODE[CRB_CODE["NGF"] = 11] = "NGF";
  CRB_CODE[CRB_CODE["SN"] = 12] = "SN";
  CRB_CODE[CRB_CODE["NF"] = 13] = "NF";
  CRB_CODE[CRB_CODE["SU"] = 14] = "SU";
  CRB_CODE[CRB_CODE["HNF"] = 15] = "HNF";
  CRB_CODE[CRB_CODE["SUP"] = 16] = "SUP";
  CRB_CODE[CRB_CODE["NNF"] = 17] = "NNF";
  CRB_CODE[CRB_CODE["SUS"] = 18] = "SUS";
  CRB_CODE[CRB_CODE["VF"] = 19] = "VF";
  CRB_CODE[CRB_CODE["SD"] = 20] = "SD";
  CRB_CODE[CRB_CODE["SCIR"] = 21] = "SCIR";
  CRB_CODE[CRB_CODE["FF"] = 22] = "FF";
  CRB_CODE[CRB_CODE["SI"] = 23] = "SI";
  CRB_CODE[CRB_CODE["MUAH"] = 24] = "MUAH";
  CRB_CODE[CRB_CODE["AGF"] = 25] = "AGF";
  CRB_CODE[CRB_CODE["SEP"] = 26] = "SEP";
  CRB_CODE[CRB_CODE["SPE"] = 27] = "SPE";
  CRB_CODE[CRB_CODE["ANGF"] = 28] = "ANGF";
  CRB_CODE[CRB_CODE["SNE"] = 29] = "SNE";
  CRB_CODE[CRB_CODE["SEN"] = 30] = "SEN";
  CRB_CODE[CRB_CODE["ANF"] = 31] = "ANF";
  CRB_CODE[CRB_CODE["SUE"] = 32] = "SUE";
  CRB_CODE[CRB_CODE["SEU"] = 33] = "SEU";
  CRB_CODE[CRB_CODE["AVF"] = 34] = "AVF";
  CRB_CODE[CRB_CODE["SCIRE"] = 35] = "SCIRE";
  CRB_CODE[CRB_CODE["SED"] = 36] = "SED";
  CRB_CODE[CRB_CODE["AFF"] = 37] = "AFF";
  CRB_CODE[CRB_CODE["SIE"] = 38] = "SIE";
  CRB_CODE[CRB_CODE["SEI"] = 39] = "SEI";
  CRB_CODE[CRB_CODE["FV"] = 40] = "FV";
  CRB_CODE[CRB_CODE["VI"] = 41] = "VI";
  CRB_CODE[CRB_CODE["X"] = 42] = "X";
  CRB_CODE[CRB_CODE["FSN"] = 43] = "FSN";
  CRB_CODE[CRB_CODE["SUR"] = 44] = "SUR";
  CRB_CODE[CRB_CODE["UFSN"] = 45] = "UFSN";
  CRB_CODE[CRB_CODE["SAUE"] = 46] = "SAUE";
  CRB_CODE[CRB_CODE["SLEUR"] = 47] = "SLEUR";
  CRB_CODE[CRB_CODE["IFSN"] = 48] = "IFSN";
  CRB_CODE[CRB_CODE["SIUE"] = 49] = "SIUE";
  CRB_CODE[CRB_CODE["SIUR"] = 50] = "SIUR";
  CRB_CODE[CRB_CODE["AFSN"] = 51] = "AFSN";
  CRB_CODE[CRB_CODE["SEUE"] = 52] = "SEUE";
  CRB_CODE[CRB_CODE["SEUR"] = 53] = "SEUR";
  CRB_CODE[CRB_CODE["FGN"] = 54] = "FGN";
  CRB_CODE[CRB_CODE["SUC"] = 55] = "SUC";
  CRB_CODE[CRB_CODE["UFGN"] = 56] = "UFGN";
  CRB_CODE[CRB_CODE["SAUC"] = 57] = "SAUC";
  CRB_CODE[CRB_CODE["SLEUC"] = 58] = "SLEUC";
  CRB_CODE[CRB_CODE["IFGN"] = 59] = "IFGN";
  CRB_CODE[CRB_CODE["SIUC"] = 60] = "SIUC";
  CRB_CODE[CRB_CODE["AFGN"] = 61] = "AFGN";
  CRB_CODE[CRB_CODE["SEUC"] = 62] = "SEUC";
})(CRB_CODE || (CRB_CODE = {}));
/**
 * In order to simplify the classification of the primitives we only use CRB codes in German.
 * So we map, the translations of each code to the German translation
 */


var CRB_CODE_DE;

(function (CRB_CODE_DE) {
  CRB_CODE_DE[CRB_CODE_DE["GF"] = 0] = "GF";
  CRB_CODE_DE[CRB_CODE_DE["GSF"] = 1] = "GSF";
  CRB_CODE_DE[CRB_CODE_DE["UUF"] = 2] = "UUF";
  CRB_CODE_DE[CRB_CODE_DE["BUF"] = 3] = "BUF";
  CRB_CODE_DE[CRB_CODE_DE["NGF"] = 4] = "NGF";
  CRB_CODE_DE[CRB_CODE_DE["NF"] = 5] = "NF";
  CRB_CODE_DE[CRB_CODE_DE["HNF"] = 6] = "HNF";
  CRB_CODE_DE[CRB_CODE_DE["NNF"] = 7] = "NNF";
  CRB_CODE_DE[CRB_CODE_DE["VF"] = 8] = "VF";
  CRB_CODE_DE[CRB_CODE_DE["FF"] = 9] = "FF";
  CRB_CODE_DE[CRB_CODE_DE["MUAH"] = 10] = "MUAH";
  CRB_CODE_DE[CRB_CODE_DE["AGF"] = 11] = "AGF";
  CRB_CODE_DE[CRB_CODE_DE["ANGF"] = 12] = "ANGF";
  CRB_CODE_DE[CRB_CODE_DE["ANF"] = 13] = "ANF";
  CRB_CODE_DE[CRB_CODE_DE["AVF"] = 14] = "AVF";
  CRB_CODE_DE[CRB_CODE_DE["AFF"] = 15] = "AFF";
  CRB_CODE_DE[CRB_CODE_DE["FV"] = 16] = "FV";
  CRB_CODE_DE[CRB_CODE_DE["X"] = 17] = "X";
  CRB_CODE_DE[CRB_CODE_DE["FSN"] = 18] = "FSN";
  CRB_CODE_DE[CRB_CODE_DE["UFSN"] = 19] = "UFSN";
  CRB_CODE_DE[CRB_CODE_DE["IFSN"] = 20] = "IFSN";
  CRB_CODE_DE[CRB_CODE_DE["AFSN"] = 21] = "AFSN";
  CRB_CODE_DE[CRB_CODE_DE["FGN"] = 22] = "FGN";
  CRB_CODE_DE[CRB_CODE_DE["UFGN"] = 23] = "UFGN";
  CRB_CODE_DE[CRB_CODE_DE["IFGN"] = 24] = "IFGN";
  CRB_CODE_DE[CRB_CODE_DE["AFGN"] = 25] = "AFGN";
})(CRB_CODE_DE || (CRB_CODE_DE = {}));
/**
 * Primitives are grouped into classes, based on their CRB code
 */


var CRB_CLASS;

(function (CRB_CLASS) {
  CRB_CLASS[CRB_CLASS["GRUNDSTUCK"] = 0] = "GRUNDSTUCK";
  CRB_CLASS[CRB_CLASS["GESCHOSSE"] = 1] = "GESCHOSSE";
  CRB_CLASS[CRB_CLASS["INNENRAUME"] = 2] = "INNENRAUME";
  CRB_CLASS[CRB_CLASS["AUSSENFLACHEN"] = 3] = "AUSSENFLACHEN";
  CRB_CLASS[CRB_CLASS["VOLUMEN"] = 4] = "VOLUMEN";
  CRB_CLASS[CRB_CLASS["SONDERNUTZUNG"] = 5] = "SONDERNUTZUNG";
})(CRB_CLASS || (CRB_CLASS = {}));

var GRUNDSTUCK_CLASS = {
  name: 'Grundstück',
  codes: [{
    de: CRB_CODE_DE.GSF,
    fr: CRB_CODE.ST,
    it: CRB_CODE.SF
  }, {
    de: CRB_CODE_DE.UUF,
    fr: CRB_CODE.SAN,
    it: CRB_CODE.SLEN
  }, {
    de: CRB_CODE_DE.BUF,
    fr: CRB_CODE.SAA,
    it: CRB_CODE.SLES
  }],
  class: CRB_CLASS.GRUNDSTUCK
};
var GESCHOSSE_CLASS = {
  name: 'Geschosse',
  codes: [{
    de: CRB_CODE_DE.GF,
    fr: CRB_CODE.SP,
    it: CRB_CODE.SP
  }],
  class: CRB_CLASS.GESCHOSSE
};
var INNENRAUME_CLASS = {
  name: 'Innenräumen',
  codes: [{
    de: CRB_CODE_DE.NGF,
    fr: CRB_CODE.SN,
    it: CRB_CODE.SN
  }, {
    de: CRB_CODE_DE.NF,
    fr: CRB_CODE.SU,
    it: CRB_CODE.SU
  }, {
    de: CRB_CODE_DE.HNF,
    fr: CRB_CODE.SUP,
    it: CRB_CODE.SUP
  }, {
    de: CRB_CODE_DE.NNF,
    fr: CRB_CODE.SUS,
    it: CRB_CODE.SUS
  }, {
    de: CRB_CODE_DE.VF,
    fr: CRB_CODE.SD,
    it: CRB_CODE.SCIR
  }, {
    de: CRB_CODE_DE.FF,
    fr: CRB_CODE.SI,
    it: CRB_CODE.SI
  }, {
    de: CRB_CODE_DE.MUAH,
    fr: CRB_CODE.MUAH,
    it: CRB_CODE.MUAH
  }, {
    de: CRB_CODE_DE.FV,
    fr: CRB_CODE.VI,
    it: CRB_CODE.VI
  }],
  class: CRB_CLASS.INNENRAUME
};
var AUSSENFLACHEN_CLASS = {
  name: 'Aussenflächen',
  codes: [{
    de: CRB_CODE_DE.AGF,
    fr: CRB_CODE.SEP,
    it: CRB_CODE.SPE
  }, {
    de: CRB_CODE_DE.ANGF,
    fr: CRB_CODE.SEN,
    it: CRB_CODE.SNE
  }, {
    de: CRB_CODE_DE.ANF,
    fr: CRB_CODE.SEU,
    it: CRB_CODE.SUE
  }, {
    de: CRB_CODE_DE.AVF,
    fr: CRB_CODE.SED,
    it: CRB_CODE.SCIRE
  }, {
    de: CRB_CODE_DE.AFF,
    fr: CRB_CODE.SEI,
    it: CRB_CODE.SIE
  }],
  class: CRB_CLASS.AUSSENFLACHEN
};
var VOLUMEN_CLASS = {
  name: 'Volumen',
  codes: [{
    de: CRB_CODE_DE.X,
    fr: CRB_CODE.X,
    it: CRB_CODE.X
  }],
  class: CRB_CLASS.VOLUMEN
};
var SONDERNUTZUNG_CLASS = {
  name: 'Sondernutzung',
  codes: [{
    de: CRB_CODE_DE.FSN,
    fr: CRB_CODE.SUE,
    it: CRB_CODE.SUR
  }, {
    de: CRB_CODE_DE.UFSN,
    fr: CRB_CODE.SAUE,
    it: CRB_CODE.SLEUR
  }, {
    de: CRB_CODE_DE.IFSN,
    fr: CRB_CODE.SIUE,
    it: CRB_CODE.SIUR
  }, {
    de: CRB_CODE_DE.AFSN,
    fr: CRB_CODE.SEUE,
    it: CRB_CODE.SEUR
  }, {
    de: CRB_CODE_DE.FGN,
    fr: CRB_CODE.SUC,
    it: CRB_CODE.SUC
  }, {
    de: CRB_CODE_DE.UFGN,
    fr: CRB_CODE.SAUC,
    it: CRB_CODE.SLEUC
  }, {
    de: CRB_CODE_DE.IFGN,
    fr: CRB_CODE.SIUC,
    it: CRB_CODE.SIUC
  }, {
    de: CRB_CODE_DE.AFGN,
    fr: CRB_CODE.SEUC,
    it: CRB_CODE.SEUC
  }],
  class: CRB_CLASS.SONDERNUTZUNG
};
var DEFAULT_CRB_CODE = CRB_CODE_DE.GF;
var DEFAULT_CRB_CLASS = GESCHOSSE_CLASS;
/**
 * Maps of CRB codes found in IFC file (in any language) to the German translation of that CRB code.
 * The German CRB code will then be used to classify the primitive.
 */

var CRB_DE_CODE_BY_CODES = new Map([[CRB_CODE.GF, CRB_CODE_DE.GF], [CRB_CODE.SP, CRB_CODE_DE.GF], [CRB_CODE.GSF, CRB_CODE_DE.GSF], [CRB_CODE.ST, CRB_CODE_DE.GSF], [CRB_CODE.SF, CRB_CODE_DE.GSF], [CRB_CODE.UUF, CRB_CODE_DE.UUF], [CRB_CODE.SAN, CRB_CODE_DE.UUF], [CRB_CODE.SLEN, CRB_CODE_DE.UUF], [CRB_CODE.BUF, CRB_CODE_DE.BUF], [CRB_CODE.SAA, CRB_CODE_DE.BUF], [CRB_CODE.SLES, CRB_CODE_DE.BUF], [CRB_CODE.NGF, CRB_CODE_DE.NGF], [CRB_CODE.SN, CRB_CODE_DE.NGF], [CRB_CODE.NF, CRB_CODE_DE.NF], [CRB_CODE.SU, CRB_CODE_DE.NF], [CRB_CODE.HNF, CRB_CODE_DE.HNF], [CRB_CODE.SUP, CRB_CODE_DE.HNF], [CRB_CODE.NNF, CRB_CODE_DE.NNF], [CRB_CODE.SUS, CRB_CODE_DE.NNF], [CRB_CODE.VF, CRB_CODE_DE.VF], [CRB_CODE.SD, CRB_CODE_DE.VF], [CRB_CODE.SCIR, CRB_CODE_DE.VF], [CRB_CODE.FF, CRB_CODE_DE.FF], [CRB_CODE.SI, CRB_CODE_DE.FF], [CRB_CODE.MUAH, CRB_CODE_DE.MUAH], [CRB_CODE.AGF, CRB_CODE_DE.AGF], [CRB_CODE.SEP, CRB_CODE_DE.AGF], [CRB_CODE.SPE, CRB_CODE_DE.AGF], [CRB_CODE.ANGF, CRB_CODE_DE.ANGF], [CRB_CODE.SEN, CRB_CODE_DE.ANGF], [CRB_CODE.SNE, CRB_CODE_DE.ANGF], [CRB_CODE.ANF, CRB_CODE_DE.ANF], [CRB_CODE.SEU, CRB_CODE_DE.ANF], [CRB_CODE.SUE, CRB_CODE_DE.ANF], [CRB_CODE.AVF, CRB_CODE_DE.AVF], [CRB_CODE.SED, CRB_CODE_DE.AVF], [CRB_CODE.SCIRE, CRB_CODE_DE.AVF], [CRB_CODE.AFF, CRB_CODE_DE.AFF], [CRB_CODE.SEI, CRB_CODE_DE.AFF], [CRB_CODE.SIE, CRB_CODE_DE.AFF], [CRB_CODE.FV, CRB_CODE_DE.FV], [CRB_CODE.VI, CRB_CODE_DE.FV], [CRB_CODE.X, CRB_CODE_DE.X], [CRB_CODE.FSN, CRB_CODE_DE.FSN], [CRB_CODE.SUE, CRB_CODE_DE.FSN], [CRB_CODE.SUR, CRB_CODE_DE.FSN], [CRB_CODE.UFSN, CRB_CODE_DE.UFSN], [CRB_CODE.SAUE, CRB_CODE_DE.UFSN], [CRB_CODE.SLEUR, CRB_CODE_DE.UFSN], [CRB_CODE.IFSN, CRB_CODE_DE.IFSN], [CRB_CODE.SIUE, CRB_CODE_DE.IFSN], [CRB_CODE.SIUR, CRB_CODE_DE.IFSN], [CRB_CODE.AFSN, CRB_CODE_DE.AFSN], [CRB_CODE.SEUE, CRB_CODE_DE.AFSN], [CRB_CODE.SEUR, CRB_CODE_DE.AFSN], [CRB_CODE.FGN, CRB_CODE_DE.FGN], [CRB_CODE.SUC, CRB_CODE_DE.FGN], [CRB_CODE.UFGN, CRB_CODE_DE.UFGN], [CRB_CODE.SAUC, CRB_CODE_DE.UFGN], [CRB_CODE.SLEUC, CRB_CODE_DE.UFGN], [CRB_CODE.IFGN, CRB_CODE_DE.IFGN], [CRB_CODE.SIUC, CRB_CODE_DE.IFGN], [CRB_CODE.AFGN, CRB_CODE_DE.AFGN], [CRB_CODE.SEUC, CRB_CODE_DE.AFGN]]);
/**
 * Map of CRB code (in German) to its CRB class object.
 * By means of this map, a primitive can be associated to a CRB class,
 * thus achieving a classification of the primitives based on their CRB code.
 */

var CRB_CLASSES_BY_DE_CODES = new Map([[CRB_CODE_DE.GF, GESCHOSSE_CLASS], [CRB_CODE_DE.GSF, GRUNDSTUCK_CLASS], [CRB_CODE_DE.UUF, GRUNDSTUCK_CLASS], [CRB_CODE_DE.BUF, GRUNDSTUCK_CLASS], [CRB_CODE_DE.NGF, INNENRAUME_CLASS], [CRB_CODE_DE.NF, INNENRAUME_CLASS], [CRB_CODE_DE.HNF, INNENRAUME_CLASS], [CRB_CODE_DE.NNF, INNENRAUME_CLASS], [CRB_CODE_DE.VF, INNENRAUME_CLASS], [CRB_CODE_DE.FF, INNENRAUME_CLASS], [CRB_CODE_DE.MUAH, INNENRAUME_CLASS], [CRB_CODE_DE.FV, INNENRAUME_CLASS], [CRB_CODE_DE.AGF, AUSSENFLACHEN_CLASS], [CRB_CODE_DE.ANGF, AUSSENFLACHEN_CLASS], [CRB_CODE_DE.ANF, AUSSENFLACHEN_CLASS], [CRB_CODE_DE.AVF, AUSSENFLACHEN_CLASS], [CRB_CODE_DE.AFF, AUSSENFLACHEN_CLASS], [CRB_CODE_DE.X, VOLUMEN_CLASS], [CRB_CODE_DE.FSN, SONDERNUTZUNG_CLASS], [CRB_CODE_DE.UFSN, SONDERNUTZUNG_CLASS], [CRB_CODE_DE.IFSN, SONDERNUTZUNG_CLASS], [CRB_CODE_DE.AFSN, SONDERNUTZUNG_CLASS], [CRB_CODE_DE.FGN, SONDERNUTZUNG_CLASS], [CRB_CODE_DE.UFGN, SONDERNUTZUNG_CLASS], [CRB_CODE_DE.IFGN, SONDERNUTZUNG_CLASS], [CRB_CODE_DE.AFGN, SONDERNUTZUNG_CLASS]]);

var getCodeAsString = function getCodeAsString(code) {
  return CRB_CODE[code];
};

var getDeCodeAsString = function getDeCodeAsString(code) {
  return CRB_CODE_DE[code];
};

var getClassAsString = function getClassAsString(classCode) {
  return CRB_CLASS[classCode];
};

var TOGGLE_TERRAIN_LABEL = '1';
var TOGGLE_BUILDING_FOOTPRINT_LABEL = '1.1';
var TOGGLE_GESCHOSSE_LABEL = '2';
var TOGGLE_INNENRAUME_LABEL = '2.1';
var TOGGLE_AUSSENFLACHEN_LABEL = '3';
var TOGGLE_VOLUMEN_LABEL = '6';
var TOGGLE_SONDERNUTZUNG_LABEL = '4';
var MENU_BUTTON_ID = 'ifc-menu-button';
var ColorPalette = {
  GREEN: 0x74ad00,
  PURPLE: 0x8304ad,
  ORANGE: 0xf9932c,
  BLUE: 0x530cfa,
  TERRAIN: 0x88b7a1,
  GESCHOSSE: 0xffffff,
  INNENRAUME: 0xffffff,
  AUSSENFLACHEN: 0xbfbfbf,
  VOLUMEN: 0xbfbfbf,
  SONDERNUTZUNG: 0xce7e00,
  BACKGROUND: 0xc1d0c8,
  BUILDING_FOOTPRINT: 0x5d7d6e,
  CONTOUR_LINE: 0xc4c4c4
};
var IFC_CANVAS_ID = 'ifcCanvas';
var DEBUG_MODEL_ID_PREFIX = 'debug-';
var BUILDING_MODEL_ID_PREFIX = 'building-';
var PRIMITIVES_ID_PREFIX = 'primitive-';
var HELPER_PRIMITIVES_ID_PREFIX = 'helper-';
var GROUP_ID_PREFIX = 'group-';
var GROUP_ID_BUILDING_FOOTPRINT = 'BUILDING_FOOTPRINT';
var TERRAIN_SURFACE_MATERIAL = new MeshBasicMaterial({
  color: ColorPalette.TERRAIN,
  transparent: true,
  opacity: 0.8
});
var BUILDING_FOOTPRINT_MATERIAL = new MeshBasicMaterial({
  color: ColorPalette.BUILDING_FOOTPRINT,
  transparent: true,
  opacity: 1
});
var PARAMETER_NAME_KEY = 'Name';
var PARAMETER_NOMINAL_VALUE_KEY = 'NominalValue';
/**
 * Users can provide custom parameters (i.e. consisting of name and value) as property.
 * If we are interested in retrieving the parameter-value from the properties
 * we have to first find where (i.e. a which key) the parameter-name is stored (as value).
 * Once we have that, we can use the same property-key-root to retrieve
 * the parameter-value (stored as nominal-value property)
 *
 * @param properties
 * @param parameter
 */

var getPropertyValueByParameter = function getPropertyValueByParameter(properties, parameter) {
  var parameterValue = '';

  var allProperties = _assign(_assign(_assign({}, properties.itemProps), properties.propSets), properties.typeProps); // Retrieve property-key storing parameter-name value


  var parameterNamePropertyKeyFilterResult = Object.keys(allProperties).filter(function (key) {
    return String(allProperties[key]).includes(parameter.name);
  });

  if (parameterNamePropertyKeyFilterResult.length > 0) {
    var parameterNamePropertyKey = parameterNamePropertyKeyFilterResult[0];
    var commonKeyRootSplitResult = parameterNamePropertyKey.split(PARAMETER_NAME_KEY); // Retrieve nominal-value storing the parameter-value

    if (commonKeyRootSplitResult.length > 0) {
      var commonKeyRoot_1 = commonKeyRootSplitResult[0];
      var parameterValuePropertyKeyFilterResult = Object.keys(allProperties).filter(function (key) {
        return key.includes(commonKeyRoot_1) && key.includes(PARAMETER_NOMINAL_VALUE_KEY);
      });

      if (parameterValuePropertyKeyFilterResult.length > 0) {
        var parameterValuePropertyKey = parameterValuePropertyKeyFilterResult[0];
        parameterValue = String(allProperties[parameterValuePropertyKey]);
      }
    }
  }

  return parameterValue;
};
/**
 * @license
 * Copyright 2010-2023 Three.js Authors
 * SPDX-License-Identifier: MIT
 */


var REVISION$1 = '152';
var SRGBColorSpace$1 = 'srgb';
var LinearSRGBColorSpace$1 = 'srgb-linear';
var DisplayP3ColorSpace = 'display-p3';

function clamp$1(value, min, max) {
  return Math.max(min, Math.min(max, value));
} // compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation


function euclideanModulo$1(n, m) {
  return (n % m + m) % m;
} // https://en.wikipedia.org/wiki/Linear_interpolation


function lerp$1(x, y, t) {
  return (1 - t) * x + t * y;
}

var Vector2$1 = /*#__PURE__*/function (_Symbol$iterator7) {
  function Vector2$1() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck2(this, Vector2$1);

    Vector2$1.prototype.isVector2 = true;
    this.x = x;
    this.y = y;
  }

  _createClass2(Vector2$1, [{
    key: "width",
    get: function get() {
      return this.x;
    },
    set: function set(value) {
      this.x = value;
    }
  }, {
    key: "height",
    get: function get() {
      return this.y;
    },
    set: function set(value) {
      this.y = value;
    }
  }, {
    key: "set",
    value: function set(x, y) {
      this.x = x;
      this.y = y;
      return this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(scalar) {
      this.x = scalar;
      this.y = scalar;
      return this;
    }
  }, {
    key: "setX",
    value: function setX(x) {
      this.x = x;
      return this;
    }
  }, {
    key: "setY",
    value: function setY(y) {
      this.y = y;
      return this;
    }
  }, {
    key: "setComponent",
    value: function setComponent(index, value) {
      switch (index) {
        case 0:
          this.x = value;
          break;

        case 1:
          this.y = value;
          break;

        default:
          throw new Error('index is out of range: ' + index);
      }

      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(index) {
      switch (index) {
        case 0:
          return this.x;

        case 1:
          return this.y;

        default:
          throw new Error('index is out of range: ' + index);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.x, this.y);
    }
  }, {
    key: "copy",
    value: function copy(v) {
      this.x = v.x;
      this.y = v.y;
      return this;
    }
  }, {
    key: "add",
    value: function add(v) {
      this.x += v.x;
      this.y += v.y;
      return this;
    }
  }, {
    key: "addScalar",
    value: function addScalar(s) {
      this.x += s;
      this.y += s;
      return this;
    }
  }, {
    key: "addVectors",
    value: function addVectors(a, b) {
      this.x = a.x + b.x;
      this.y = a.y + b.y;
      return this;
    }
  }, {
    key: "addScaledVector",
    value: function addScaledVector(v, s) {
      this.x += v.x * s;
      this.y += v.y * s;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(v) {
      this.x -= v.x;
      this.y -= v.y;
      return this;
    }
  }, {
    key: "subScalar",
    value: function subScalar(s) {
      this.x -= s;
      this.y -= s;
      return this;
    }
  }, {
    key: "subVectors",
    value: function subVectors(a, b) {
      this.x = a.x - b.x;
      this.y = a.y - b.y;
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(v) {
      this.x *= v.x;
      this.y *= v.y;
      return this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(scalar) {
      this.x *= scalar;
      this.y *= scalar;
      return this;
    }
  }, {
    key: "divide",
    value: function divide(v) {
      this.x /= v.x;
      this.y /= v.y;
      return this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(scalar) {
      return this.multiplyScalar(1 / scalar);
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(m) {
      var x = this.x,
          y = this.y;
      var e = m.elements;
      this.x = e[0] * x + e[3] * y + e[6];
      this.y = e[1] * x + e[4] * y + e[7];
      return this;
    }
  }, {
    key: "min",
    value: function min(v) {
      this.x = Math.min(this.x, v.x);
      this.y = Math.min(this.y, v.y);
      return this;
    }
  }, {
    key: "max",
    value: function max(v) {
      this.x = Math.max(this.x, v.x);
      this.y = Math.max(this.y, v.y);
      return this;
    }
  }, {
    key: "clamp",
    value: function clamp(min, max) {
      // assumes min < max, componentwise
      this.x = Math.max(min.x, Math.min(max.x, this.x));
      this.y = Math.max(min.y, Math.min(max.y, this.y));
      return this;
    }
  }, {
    key: "clampScalar",
    value: function clampScalar(minVal, maxVal) {
      this.x = Math.max(minVal, Math.min(maxVal, this.x));
      this.y = Math.max(minVal, Math.min(maxVal, this.y));
      return this;
    }
  }, {
    key: "clampLength",
    value: function clampLength(min, max) {
      var length = this.length();
      return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
  }, {
    key: "floor",
    value: function floor() {
      this.x = Math.floor(this.x);
      this.y = Math.floor(this.y);
      return this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      this.x = Math.ceil(this.x);
      this.y = Math.ceil(this.y);
      return this;
    }
  }, {
    key: "round",
    value: function round() {
      this.x = Math.round(this.x);
      this.y = Math.round(this.y);
      return this;
    }
  }, {
    key: "roundToZero",
    value: function roundToZero() {
      this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
      this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
      return this;
    }
  }, {
    key: "negate",
    value: function negate() {
      this.x = -this.x;
      this.y = -this.y;
      return this;
    }
  }, {
    key: "dot",
    value: function dot(v) {
      return this.x * v.x + this.y * v.y;
    }
  }, {
    key: "cross",
    value: function cross(v) {
      return this.x * v.y - this.y * v.x;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this.x * this.x + this.y * this.y;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y);
    }
  }, {
    key: "manhattanLength",
    value: function manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.divideScalar(this.length() || 1);
    }
  }, {
    key: "angle",
    value: function angle() {
      // computes the angle in radians with respect to the positive x-axis
      var angle = Math.atan2(-this.y, -this.x) + Math.PI;
      return angle;
    }
  }, {
    key: "angleTo",
    value: function angleTo(v) {
      var denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
      if (denominator === 0) return Math.PI / 2;
      var theta = this.dot(v) / denominator; // clamp, to handle numerical problems

      return Math.acos(clamp$1(theta, -1, 1));
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(v) {
      return Math.sqrt(this.distanceToSquared(v));
    }
  }, {
    key: "distanceToSquared",
    value: function distanceToSquared(v) {
      var dx = this.x - v.x,
          dy = this.y - v.y;
      return dx * dx + dy * dy;
    }
  }, {
    key: "manhattanDistanceTo",
    value: function manhattanDistanceTo(v) {
      return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
  }, {
    key: "setLength",
    value: function setLength(length) {
      return this.normalize().multiplyScalar(length);
    }
  }, {
    key: "lerp",
    value: function lerp(v, alpha) {
      this.x += (v.x - this.x) * alpha;
      this.y += (v.y - this.y) * alpha;
      return this;
    }
  }, {
    key: "lerpVectors",
    value: function lerpVectors(v1, v2, alpha) {
      this.x = v1.x + (v2.x - v1.x) * alpha;
      this.y = v1.y + (v2.y - v1.y) * alpha;
      return this;
    }
  }, {
    key: "equals",
    value: function equals(v) {
      return v.x === this.x && v.y === this.y;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.x = array[offset];
      this.y = array[offset + 1];
      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      array[offset] = this.x;
      array[offset + 1] = this.y;
      return array;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(attribute, index) {
      this.x = attribute.getX(index);
      this.y = attribute.getY(index);
      return this;
    }
  }, {
    key: "rotateAround",
    value: function rotateAround(center, angle) {
      var c = Math.cos(angle),
          s = Math.sin(angle);
      var x = this.x - center.x;
      var y = this.y - center.y;
      this.x = x * c - y * s + center.x;
      this.y = x * s + y * c + center.y;
      return this;
    }
  }, {
    key: "random",
    value: function random() {
      this.x = Math.random();
      this.y = Math.random();
      return this;
    }
  }, {
    key: _Symbol$iterator7,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.x;

            case 2:
              _context9.next = 4;
              return this.y;

            case 4:
            case "end":
              return _context9.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Vector2$1;
}(Symbol.iterator);

var Matrix3$1 = /*#__PURE__*/function () {
  function Matrix3$1() {
    _classCallCheck2(this, Matrix3$1);

    Matrix3$1.prototype.isMatrix3 = true;
    this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1];
  }

  _createClass2(Matrix3$1, [{
    key: "set",
    value: function set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
      var te = this.elements;
      te[0] = n11;
      te[1] = n21;
      te[2] = n31;
      te[3] = n12;
      te[4] = n22;
      te[5] = n32;
      te[6] = n13;
      te[7] = n23;
      te[8] = n33;
      return this;
    }
  }, {
    key: "identity",
    value: function identity() {
      this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "copy",
    value: function copy(m) {
      var te = this.elements;
      var me = m.elements;
      te[0] = me[0];
      te[1] = me[1];
      te[2] = me[2];
      te[3] = me[3];
      te[4] = me[4];
      te[5] = me[5];
      te[6] = me[6];
      te[7] = me[7];
      te[8] = me[8];
      return this;
    }
  }, {
    key: "extractBasis",
    value: function extractBasis(xAxis, yAxis, zAxis) {
      xAxis.setFromMatrix3Column(this, 0);
      yAxis.setFromMatrix3Column(this, 1);
      zAxis.setFromMatrix3Column(this, 2);
      return this;
    }
  }, {
    key: "setFromMatrix4",
    value: function setFromMatrix4(m) {
      var me = m.elements;
      this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(m) {
      return this.multiplyMatrices(this, m);
    }
  }, {
    key: "premultiply",
    value: function premultiply(m) {
      return this.multiplyMatrices(m, this);
    }
  }, {
    key: "multiplyMatrices",
    value: function multiplyMatrices(a, b) {
      var ae = a.elements;
      var be = b.elements;
      var te = this.elements;
      var a11 = ae[0],
          a12 = ae[3],
          a13 = ae[6];
      var a21 = ae[1],
          a22 = ae[4],
          a23 = ae[7];
      var a31 = ae[2],
          a32 = ae[5],
          a33 = ae[8];
      var b11 = be[0],
          b12 = be[3],
          b13 = be[6];
      var b21 = be[1],
          b22 = be[4],
          b23 = be[7];
      var b31 = be[2],
          b32 = be[5],
          b33 = be[8];
      te[0] = a11 * b11 + a12 * b21 + a13 * b31;
      te[3] = a11 * b12 + a12 * b22 + a13 * b32;
      te[6] = a11 * b13 + a12 * b23 + a13 * b33;
      te[1] = a21 * b11 + a22 * b21 + a23 * b31;
      te[4] = a21 * b12 + a22 * b22 + a23 * b32;
      te[7] = a21 * b13 + a22 * b23 + a23 * b33;
      te[2] = a31 * b11 + a32 * b21 + a33 * b31;
      te[5] = a31 * b12 + a32 * b22 + a33 * b32;
      te[8] = a31 * b13 + a32 * b23 + a33 * b33;
      return this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(s) {
      var te = this.elements;
      te[0] *= s;
      te[3] *= s;
      te[6] *= s;
      te[1] *= s;
      te[4] *= s;
      te[7] *= s;
      te[2] *= s;
      te[5] *= s;
      te[8] *= s;
      return this;
    }
  }, {
    key: "determinant",
    value: function determinant() {
      var te = this.elements;
      var a = te[0],
          b = te[1],
          c = te[2],
          d = te[3],
          e = te[4],
          f = te[5],
          g = te[6],
          h = te[7],
          i = te[8];
      return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
  }, {
    key: "invert",
    value: function invert() {
      var te = this.elements,
          n11 = te[0],
          n21 = te[1],
          n31 = te[2],
          n12 = te[3],
          n22 = te[4],
          n32 = te[5],
          n13 = te[6],
          n23 = te[7],
          n33 = te[8],
          t11 = n33 * n22 - n32 * n23,
          t12 = n32 * n13 - n33 * n12,
          t13 = n23 * n12 - n22 * n13,
          det = n11 * t11 + n21 * t12 + n31 * t13;
      if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
      var detInv = 1 / det;
      te[0] = t11 * detInv;
      te[1] = (n31 * n23 - n33 * n21) * detInv;
      te[2] = (n32 * n21 - n31 * n22) * detInv;
      te[3] = t12 * detInv;
      te[4] = (n33 * n11 - n31 * n13) * detInv;
      te[5] = (n31 * n12 - n32 * n11) * detInv;
      te[6] = t13 * detInv;
      te[7] = (n21 * n13 - n23 * n11) * detInv;
      te[8] = (n22 * n11 - n21 * n12) * detInv;
      return this;
    }
  }, {
    key: "transpose",
    value: function transpose() {
      var tmp;
      var m = this.elements;
      tmp = m[1];
      m[1] = m[3];
      m[3] = tmp;
      tmp = m[2];
      m[2] = m[6];
      m[6] = tmp;
      tmp = m[5];
      m[5] = m[7];
      m[7] = tmp;
      return this;
    }
  }, {
    key: "getNormalMatrix",
    value: function getNormalMatrix(matrix4) {
      return this.setFromMatrix4(matrix4).invert().transpose();
    }
  }, {
    key: "transposeIntoArray",
    value: function transposeIntoArray(r) {
      var m = this.elements;
      r[0] = m[0];
      r[1] = m[3];
      r[2] = m[6];
      r[3] = m[1];
      r[4] = m[4];
      r[5] = m[7];
      r[6] = m[2];
      r[7] = m[5];
      r[8] = m[8];
      return this;
    }
  }, {
    key: "setUvTransform",
    value: function setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
      var c = Math.cos(rotation);
      var s = Math.sin(rotation);
      this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
      return this;
    } //

  }, {
    key: "scale",
    value: function scale(sx, sy) {
      this.premultiply(_m3.makeScale(sx, sy));
      return this;
    }
  }, {
    key: "rotate",
    value: function rotate(theta) {
      this.premultiply(_m3.makeRotation(-theta));
      return this;
    }
  }, {
    key: "translate",
    value: function translate(tx, ty) {
      this.premultiply(_m3.makeTranslation(tx, ty));
      return this;
    } // for 2D Transforms

  }, {
    key: "makeTranslation",
    value: function makeTranslation(x, y) {
      this.set(1, 0, x, 0, 1, y, 0, 0, 1);
      return this;
    }
  }, {
    key: "makeRotation",
    value: function makeRotation(theta) {
      // counterclockwise
      var c = Math.cos(theta);
      var s = Math.sin(theta);
      this.set(c, -s, 0, s, c, 0, 0, 0, 1);
      return this;
    }
  }, {
    key: "makeScale",
    value: function makeScale(x, y) {
      this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
      return this;
    } //

  }, {
    key: "equals",
    value: function equals(matrix) {
      var te = this.elements;
      var me = matrix.elements;

      for (var _i287 = 0; _i287 < 9; _i287++) {
        if (te[_i287] !== me[_i287]) return false;
      }

      return true;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      for (var _i288 = 0; _i288 < 9; _i288++) {
        this.elements[_i288] = array[_i288 + offset];
      }

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var te = this.elements;
      array[offset] = te[0];
      array[offset + 1] = te[1];
      array[offset + 2] = te[2];
      array[offset + 3] = te[3];
      array[offset + 4] = te[4];
      array[offset + 5] = te[5];
      array[offset + 6] = te[6];
      array[offset + 7] = te[7];
      array[offset + 8] = te[8];
      return array;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor().fromArray(this.elements);
    }
  }]);

  return Matrix3$1;
}();

var _m3 = /*@__PURE__*/new Matrix3$1();

function SRGBToLinear$1(c) {
  return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}

function LinearToSRGB$1(c) {
  return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
/**
 * Matrices converting P3 <-> Rec. 709 primaries, without gamut mapping
 * or clipping. Based on W3C specifications for sRGB and Display P3,
 * and ICC specifications for the D50 connection space. Values in/out
 * are _linear_ sRGB and _linear_ Display P3.
 *
 * Note that both sRGB and Display P3 use the sRGB transfer functions.
 *
 * Reference:
 * - http://www.russellcottrell.com/photo/matrixCalculator.htm
 */


var LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = /*@__PURE__*/new Matrix3$1().fromArray([0.8224621, 0.0331941, 0.0170827, 0.1775380, 0.9668058, 0.0723974, -0.0000001, 0.0000001, 0.9105199]);
var LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = /*@__PURE__*/new Matrix3$1().fromArray([1.2249401, -0.0420569, -0.0196376, -0.2249404, 1.0420571, -0.0786361, 0.0000001, 0.0000000, 1.0982735]);

function DisplayP3ToLinearSRGB(color) {
  // Display P3 uses the sRGB transfer functions
  return color.convertSRGBToLinear().applyMatrix3(LINEAR_DISPLAY_P3_TO_LINEAR_SRGB);
}

function LinearSRGBToDisplayP3(color) {
  // Display P3 uses the sRGB transfer functions
  return color.applyMatrix3(LINEAR_SRGB_TO_LINEAR_DISPLAY_P3).convertLinearToSRGB();
} // Conversions from <source> to Linear-sRGB reference space.


var TO_LINEAR = (_TO_LINEAR = {}, _defineProperty(_TO_LINEAR, LinearSRGBColorSpace$1, function (color) {
  return color;
}), _defineProperty(_TO_LINEAR, SRGBColorSpace$1, function (color) {
  return color.convertSRGBToLinear();
}), _defineProperty(_TO_LINEAR, DisplayP3ColorSpace, DisplayP3ToLinearSRGB), _TO_LINEAR); // Conversions to <target> from Linear-sRGB reference space.

var FROM_LINEAR = (_FROM_LINEAR = {}, _defineProperty(_FROM_LINEAR, LinearSRGBColorSpace$1, function (color) {
  return color;
}), _defineProperty(_FROM_LINEAR, SRGBColorSpace$1, function (color) {
  return color.convertLinearToSRGB();
}), _defineProperty(_FROM_LINEAR, DisplayP3ColorSpace, LinearSRGBToDisplayP3), _FROM_LINEAR);
var ColorManagement$1 = {
  enabled: true,

  get legacyMode() {
    console.warn('THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.');
    return !this.enabled;
  },

  set legacyMode(legacyMode) {
    console.warn('THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150.');
    this.enabled = !legacyMode;
  },

  get workingColorSpace() {
    return LinearSRGBColorSpace$1;
  },

  set workingColorSpace(colorSpace) {
    console.warn('THREE.ColorManagement: .workingColorSpace is readonly.');
  },

  convert: function convert(color, sourceColorSpace, targetColorSpace) {
    if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) {
      return color;
    }

    var sourceToLinear = TO_LINEAR[sourceColorSpace];
    var targetFromLinear = FROM_LINEAR[targetColorSpace];

    if (sourceToLinear === undefined || targetFromLinear === undefined) {
      throw new Error("Unsupported color space conversion, \"".concat(sourceColorSpace, "\" to \"").concat(targetColorSpace, "\"."));
    }

    return targetFromLinear(sourceToLinear(color));
  },
  fromWorkingColorSpace: function fromWorkingColorSpace(color, targetColorSpace) {
    return this.convert(color, this.workingColorSpace, targetColorSpace);
  },
  toWorkingColorSpace: function toWorkingColorSpace(color, sourceColorSpace) {
    return this.convert(color, sourceColorSpace, this.workingColorSpace);
  }
};

var Quaternion$1 = /*#__PURE__*/function (_Symbol$iterator8) {
  function Quaternion$1() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var w = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck2(this, Quaternion$1);

    this.isQuaternion = true;
    this._x = x;
    this._y = y;
    this._z = z;
    this._w = w;
  }

  _createClass2(Quaternion$1, [{
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(value) {
      this._x = value;

      this._onChangeCallback();
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(value) {
      this._y = value;

      this._onChangeCallback();
    }
  }, {
    key: "z",
    get: function get() {
      return this._z;
    },
    set: function set(value) {
      this._z = value;

      this._onChangeCallback();
    }
  }, {
    key: "w",
    get: function get() {
      return this._w;
    },
    set: function set(value) {
      this._w = value;

      this._onChangeCallback();
    }
  }, {
    key: "set",
    value: function set(x, y, z, w) {
      this._x = x;
      this._y = y;
      this._z = z;
      this._w = w;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this._x, this._y, this._z, this._w);
    }
  }, {
    key: "copy",
    value: function copy(quaternion) {
      this._x = quaternion.x;
      this._y = quaternion.y;
      this._z = quaternion.z;
      this._w = quaternion.w;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "setFromEuler",
    value: function setFromEuler(euler, update) {
      var x = euler._x,
          y = euler._y,
          z = euler._z,
          order = euler._order; // http://www.mathworks.com/matlabcentral/fileexchange/
      // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
      //	content/SpinCalc.m

      var cos = Math.cos;
      var sin = Math.sin;
      var c1 = cos(x / 2);
      var c2 = cos(y / 2);
      var c3 = cos(z / 2);
      var s1 = sin(x / 2);
      var s2 = sin(y / 2);
      var s3 = sin(z / 2);

      switch (order) {
        case 'XYZ':
          this._x = s1 * c2 * c3 + c1 * s2 * s3;
          this._y = c1 * s2 * c3 - s1 * c2 * s3;
          this._z = c1 * c2 * s3 + s1 * s2 * c3;
          this._w = c1 * c2 * c3 - s1 * s2 * s3;
          break;

        case 'YXZ':
          this._x = s1 * c2 * c3 + c1 * s2 * s3;
          this._y = c1 * s2 * c3 - s1 * c2 * s3;
          this._z = c1 * c2 * s3 - s1 * s2 * c3;
          this._w = c1 * c2 * c3 + s1 * s2 * s3;
          break;

        case 'ZXY':
          this._x = s1 * c2 * c3 - c1 * s2 * s3;
          this._y = c1 * s2 * c3 + s1 * c2 * s3;
          this._z = c1 * c2 * s3 + s1 * s2 * c3;
          this._w = c1 * c2 * c3 - s1 * s2 * s3;
          break;

        case 'ZYX':
          this._x = s1 * c2 * c3 - c1 * s2 * s3;
          this._y = c1 * s2 * c3 + s1 * c2 * s3;
          this._z = c1 * c2 * s3 - s1 * s2 * c3;
          this._w = c1 * c2 * c3 + s1 * s2 * s3;
          break;

        case 'YZX':
          this._x = s1 * c2 * c3 + c1 * s2 * s3;
          this._y = c1 * s2 * c3 + s1 * c2 * s3;
          this._z = c1 * c2 * s3 - s1 * s2 * c3;
          this._w = c1 * c2 * c3 - s1 * s2 * s3;
          break;

        case 'XZY':
          this._x = s1 * c2 * c3 - c1 * s2 * s3;
          this._y = c1 * s2 * c3 - s1 * c2 * s3;
          this._z = c1 * c2 * s3 + s1 * s2 * c3;
          this._w = c1 * c2 * c3 + s1 * s2 * s3;
          break;

        default:
          console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
      }

      if (update !== false) this._onChangeCallback();
      return this;
    }
  }, {
    key: "setFromAxisAngle",
    value: function setFromAxisAngle(axis, angle) {
      // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
      // assumes axis is normalized
      var halfAngle = angle / 2,
          s = Math.sin(halfAngle);
      this._x = axis.x * s;
      this._y = axis.y * s;
      this._z = axis.z * s;
      this._w = Math.cos(halfAngle);

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "setFromRotationMatrix",
    value: function setFromRotationMatrix(m) {
      // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
      // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
      var te = m.elements,
          m11 = te[0],
          m12 = te[4],
          m13 = te[8],
          m21 = te[1],
          m22 = te[5],
          m23 = te[9],
          m31 = te[2],
          m32 = te[6],
          m33 = te[10],
          trace = m11 + m22 + m33;

      if (trace > 0) {
        var s = 0.5 / Math.sqrt(trace + 1.0);
        this._w = 0.25 / s;
        this._x = (m32 - m23) * s;
        this._y = (m13 - m31) * s;
        this._z = (m21 - m12) * s;
      } else if (m11 > m22 && m11 > m33) {
        var _s5 = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);

        this._w = (m32 - m23) / _s5;
        this._x = 0.25 * _s5;
        this._y = (m12 + m21) / _s5;
        this._z = (m13 + m31) / _s5;
      } else if (m22 > m33) {
        var _s6 = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);

        this._w = (m13 - m31) / _s6;
        this._x = (m12 + m21) / _s6;
        this._y = 0.25 * _s6;
        this._z = (m23 + m32) / _s6;
      } else {
        var _s7 = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);

        this._w = (m21 - m12) / _s7;
        this._x = (m13 + m31) / _s7;
        this._y = (m23 + m32) / _s7;
        this._z = 0.25 * _s7;
      }

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "setFromUnitVectors",
    value: function setFromUnitVectors(vFrom, vTo) {
      // assumes direction vectors vFrom and vTo are normalized
      var r = vFrom.dot(vTo) + 1;

      if (r < Number.EPSILON) {
        // vFrom and vTo point in opposite directions
        r = 0;

        if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
          this._x = -vFrom.y;
          this._y = vFrom.x;
          this._z = 0;
          this._w = r;
        } else {
          this._x = 0;
          this._y = -vFrom.z;
          this._z = vFrom.y;
          this._w = r;
        }
      } else {
        // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
        this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
        this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
        this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
        this._w = r;
      }

      return this.normalize();
    }
  }, {
    key: "angleTo",
    value: function angleTo(q) {
      return 2 * Math.acos(Math.abs(clamp$1(this.dot(q), -1, 1)));
    }
  }, {
    key: "rotateTowards",
    value: function rotateTowards(q, step) {
      var angle = this.angleTo(q);
      if (angle === 0) return this;
      var t = Math.min(1, step / angle);
      this.slerp(q, t);
      return this;
    }
  }, {
    key: "identity",
    value: function identity() {
      return this.set(0, 0, 0, 1);
    }
  }, {
    key: "invert",
    value: function invert() {
      // quaternion is assumed to have unit length
      return this.conjugate();
    }
  }, {
    key: "conjugate",
    value: function conjugate() {
      this._x *= -1;
      this._y *= -1;
      this._z *= -1;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "dot",
    value: function dot(v) {
      return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      var l = this.length();

      if (l === 0) {
        this._x = 0;
        this._y = 0;
        this._z = 0;
        this._w = 1;
      } else {
        l = 1 / l;
        this._x = this._x * l;
        this._y = this._y * l;
        this._z = this._z * l;
        this._w = this._w * l;
      }

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(q) {
      return this.multiplyQuaternions(this, q);
    }
  }, {
    key: "premultiply",
    value: function premultiply(q) {
      return this.multiplyQuaternions(q, this);
    }
  }, {
    key: "multiplyQuaternions",
    value: function multiplyQuaternions(a, b) {
      // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
      var qax = a._x,
          qay = a._y,
          qaz = a._z,
          qaw = a._w;
      var qbx = b._x,
          qby = b._y,
          qbz = b._z,
          qbw = b._w;
      this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
      this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
      this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
      this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "slerp",
    value: function slerp(qb, t) {
      if (t === 0) return this;
      if (t === 1) return this.copy(qb);
      var x = this._x,
          y = this._y,
          z = this._z,
          w = this._w; // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/

      var cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;

      if (cosHalfTheta < 0) {
        this._w = -qb._w;
        this._x = -qb._x;
        this._y = -qb._y;
        this._z = -qb._z;
        cosHalfTheta = -cosHalfTheta;
      } else {
        this.copy(qb);
      }

      if (cosHalfTheta >= 1.0) {
        this._w = w;
        this._x = x;
        this._y = y;
        this._z = z;
        return this;
      }

      var sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;

      if (sqrSinHalfTheta <= Number.EPSILON) {
        var s = 1 - t;
        this._w = s * w + t * this._w;
        this._x = s * x + t * this._x;
        this._y = s * y + t * this._y;
        this._z = s * z + t * this._z;
        this.normalize();

        this._onChangeCallback();

        return this;
      }

      var sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
      var halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
      var ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta,
          ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
      this._w = w * ratioA + this._w * ratioB;
      this._x = x * ratioA + this._x * ratioB;
      this._y = y * ratioA + this._y * ratioB;
      this._z = z * ratioA + this._z * ratioB;

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "slerpQuaternions",
    value: function slerpQuaternions(qa, qb, t) {
      return this.copy(qa).slerp(qb, t);
    }
  }, {
    key: "random",
    value: function random() {
      // Derived from http://planning.cs.uiuc.edu/node198.html
      // Note, this source uses w, x, y, z ordering,
      // so we swap the order below.
      var u1 = Math.random();
      var sqrt1u1 = Math.sqrt(1 - u1);
      var sqrtu1 = Math.sqrt(u1);
      var u2 = 2 * Math.PI * Math.random();
      var u3 = 2 * Math.PI * Math.random();
      return this.set(sqrt1u1 * Math.cos(u2), sqrtu1 * Math.sin(u3), sqrtu1 * Math.cos(u3), sqrt1u1 * Math.sin(u2));
    }
  }, {
    key: "equals",
    value: function equals(quaternion) {
      return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this._x = array[offset];
      this._y = array[offset + 1];
      this._z = array[offset + 2];
      this._w = array[offset + 3];

      this._onChangeCallback();

      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      array[offset] = this._x;
      array[offset + 1] = this._y;
      array[offset + 2] = this._z;
      array[offset + 3] = this._w;
      return array;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(attribute, index) {
      this._x = attribute.getX(index);
      this._y = attribute.getY(index);
      this._z = attribute.getZ(index);
      this._w = attribute.getW(index);
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.toArray();
    }
  }, {
    key: "_onChange",
    value: function _onChange(callback) {
      this._onChangeCallback = callback;
      return this;
    }
  }, {
    key: "_onChangeCallback",
    value: function _onChangeCallback() {}
  }, {
    key: _Symbol$iterator8,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this._x;

            case 2:
              _context10.next = 4;
              return this._y;

            case 4:
              _context10.next = 6;
              return this._z;

            case 6:
              _context10.next = 8;
              return this._w;

            case 8:
            case "end":
              return _context10.stop();
          }
        }
      }, value, this);
    })
  }], [{
    key: "slerpFlat",
    value: function slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
      // fuzz-free, array-based Quaternion SLERP operation
      var x0 = src0[srcOffset0 + 0],
          y0 = src0[srcOffset0 + 1],
          z0 = src0[srcOffset0 + 2],
          w0 = src0[srcOffset0 + 3];
      var x1 = src1[srcOffset1 + 0],
          y1 = src1[srcOffset1 + 1],
          z1 = src1[srcOffset1 + 2],
          w1 = src1[srcOffset1 + 3];

      if (t === 0) {
        dst[dstOffset + 0] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
        return;
      }

      if (t === 1) {
        dst[dstOffset + 0] = x1;
        dst[dstOffset + 1] = y1;
        dst[dstOffset + 2] = z1;
        dst[dstOffset + 3] = w1;
        return;
      }

      if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
        var s = 1 - t;
        var cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1,
            dir = cos >= 0 ? 1 : -1,
            sqrSin = 1 - cos * cos; // Skip the Slerp for tiny steps to avoid numeric problems:

        if (sqrSin > Number.EPSILON) {
          var sin = Math.sqrt(sqrSin),
              len = Math.atan2(sin, cos * dir);
          s = Math.sin(s * len) / sin;
          t = Math.sin(t * len) / sin;
        }

        var tDir = t * dir;
        x0 = x0 * s + x1 * tDir;
        y0 = y0 * s + y1 * tDir;
        z0 = z0 * s + z1 * tDir;
        w0 = w0 * s + w1 * tDir; // Normalize in case we just did a lerp:

        if (s === 1 - t) {
          var f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
          x0 *= f;
          y0 *= f;
          z0 *= f;
          w0 *= f;
        }
      }

      dst[dstOffset] = x0;
      dst[dstOffset + 1] = y0;
      dst[dstOffset + 2] = z0;
      dst[dstOffset + 3] = w0;
    }
  }, {
    key: "multiplyQuaternionsFlat",
    value: function multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
      var x0 = src0[srcOffset0];
      var y0 = src0[srcOffset0 + 1];
      var z0 = src0[srcOffset0 + 2];
      var w0 = src0[srcOffset0 + 3];
      var x1 = src1[srcOffset1];
      var y1 = src1[srcOffset1 + 1];
      var z1 = src1[srcOffset1 + 2];
      var w1 = src1[srcOffset1 + 3];
      dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
      dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
      dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
      dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
      return dst;
    }
  }]);

  return Quaternion$1;
}(Symbol.iterator);

var Vector3$1 = /*#__PURE__*/function (_Symbol$iterator9) {
  function Vector3$1() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck2(this, Vector3$1);

    Vector3$1.prototype.isVector3 = true;
    this.x = x;
    this.y = y;
    this.z = z;
  }

  _createClass2(Vector3$1, [{
    key: "set",
    value: function set(x, y, z) {
      if (z === undefined) z = this.z; // sprite.scale.set(x,y)

      this.x = x;
      this.y = y;
      this.z = z;
      return this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(scalar) {
      this.x = scalar;
      this.y = scalar;
      this.z = scalar;
      return this;
    }
  }, {
    key: "setX",
    value: function setX(x) {
      this.x = x;
      return this;
    }
  }, {
    key: "setY",
    value: function setY(y) {
      this.y = y;
      return this;
    }
  }, {
    key: "setZ",
    value: function setZ(z) {
      this.z = z;
      return this;
    }
  }, {
    key: "setComponent",
    value: function setComponent(index, value) {
      switch (index) {
        case 0:
          this.x = value;
          break;

        case 1:
          this.y = value;
          break;

        case 2:
          this.z = value;
          break;

        default:
          throw new Error('index is out of range: ' + index);
      }

      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent(index) {
      switch (index) {
        case 0:
          return this.x;

        case 1:
          return this.y;

        case 2:
          return this.z;

        default:
          throw new Error('index is out of range: ' + index);
      }
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.x, this.y, this.z);
    }
  }, {
    key: "copy",
    value: function copy(v) {
      this.x = v.x;
      this.y = v.y;
      this.z = v.z;
      return this;
    }
  }, {
    key: "add",
    value: function add(v) {
      this.x += v.x;
      this.y += v.y;
      this.z += v.z;
      return this;
    }
  }, {
    key: "addScalar",
    value: function addScalar(s) {
      this.x += s;
      this.y += s;
      this.z += s;
      return this;
    }
  }, {
    key: "addVectors",
    value: function addVectors(a, b) {
      this.x = a.x + b.x;
      this.y = a.y + b.y;
      this.z = a.z + b.z;
      return this;
    }
  }, {
    key: "addScaledVector",
    value: function addScaledVector(v, s) {
      this.x += v.x * s;
      this.y += v.y * s;
      this.z += v.z * s;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(v) {
      this.x -= v.x;
      this.y -= v.y;
      this.z -= v.z;
      return this;
    }
  }, {
    key: "subScalar",
    value: function subScalar(s) {
      this.x -= s;
      this.y -= s;
      this.z -= s;
      return this;
    }
  }, {
    key: "subVectors",
    value: function subVectors(a, b) {
      this.x = a.x - b.x;
      this.y = a.y - b.y;
      this.z = a.z - b.z;
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(v) {
      this.x *= v.x;
      this.y *= v.y;
      this.z *= v.z;
      return this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(scalar) {
      this.x *= scalar;
      this.y *= scalar;
      this.z *= scalar;
      return this;
    }
  }, {
    key: "multiplyVectors",
    value: function multiplyVectors(a, b) {
      this.x = a.x * b.x;
      this.y = a.y * b.y;
      this.z = a.z * b.z;
      return this;
    }
  }, {
    key: "applyEuler",
    value: function applyEuler(euler) {
      return this.applyQuaternion(_quaternion$4$1.setFromEuler(euler));
    }
  }, {
    key: "applyAxisAngle",
    value: function applyAxisAngle(axis, angle) {
      return this.applyQuaternion(_quaternion$4$1.setFromAxisAngle(axis, angle));
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(m) {
      var x = this.x,
          y = this.y,
          z = this.z;
      var e = m.elements;
      this.x = e[0] * x + e[3] * y + e[6] * z;
      this.y = e[1] * x + e[4] * y + e[7] * z;
      this.z = e[2] * x + e[5] * y + e[8] * z;
      return this;
    }
  }, {
    key: "applyNormalMatrix",
    value: function applyNormalMatrix(m) {
      return this.applyMatrix3(m).normalize();
    }
  }, {
    key: "applyMatrix4",
    value: function applyMatrix4(m) {
      var x = this.x,
          y = this.y,
          z = this.z;
      var e = m.elements;
      var w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
      this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
      this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
      this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
      return this;
    }
  }, {
    key: "applyQuaternion",
    value: function applyQuaternion(q) {
      var x = this.x,
          y = this.y,
          z = this.z;
      var qx = q.x,
          qy = q.y,
          qz = q.z,
          qw = q.w; // calculate quat * vector

      var ix = qw * x + qy * z - qz * y;
      var iy = qw * y + qz * x - qx * z;
      var iz = qw * z + qx * y - qy * x;
      var iw = -qx * x - qy * y - qz * z; // calculate result * inverse quat

      this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
      this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
      this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
      return this;
    }
  }, {
    key: "project",
    value: function project(camera) {
      return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
  }, {
    key: "unproject",
    value: function unproject(camera) {
      return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
  }, {
    key: "transformDirection",
    value: function transformDirection(m) {
      // input: THREE.Matrix4 affine matrix
      // vector interpreted as a direction
      var x = this.x,
          y = this.y,
          z = this.z;
      var e = m.elements;
      this.x = e[0] * x + e[4] * y + e[8] * z;
      this.y = e[1] * x + e[5] * y + e[9] * z;
      this.z = e[2] * x + e[6] * y + e[10] * z;
      return this.normalize();
    }
  }, {
    key: "divide",
    value: function divide(v) {
      this.x /= v.x;
      this.y /= v.y;
      this.z /= v.z;
      return this;
    }
  }, {
    key: "divideScalar",
    value: function divideScalar(scalar) {
      return this.multiplyScalar(1 / scalar);
    }
  }, {
    key: "min",
    value: function min(v) {
      this.x = Math.min(this.x, v.x);
      this.y = Math.min(this.y, v.y);
      this.z = Math.min(this.z, v.z);
      return this;
    }
  }, {
    key: "max",
    value: function max(v) {
      this.x = Math.max(this.x, v.x);
      this.y = Math.max(this.y, v.y);
      this.z = Math.max(this.z, v.z);
      return this;
    }
  }, {
    key: "clamp",
    value: function clamp(min, max) {
      // assumes min < max, componentwise
      this.x = Math.max(min.x, Math.min(max.x, this.x));
      this.y = Math.max(min.y, Math.min(max.y, this.y));
      this.z = Math.max(min.z, Math.min(max.z, this.z));
      return this;
    }
  }, {
    key: "clampScalar",
    value: function clampScalar(minVal, maxVal) {
      this.x = Math.max(minVal, Math.min(maxVal, this.x));
      this.y = Math.max(minVal, Math.min(maxVal, this.y));
      this.z = Math.max(minVal, Math.min(maxVal, this.z));
      return this;
    }
  }, {
    key: "clampLength",
    value: function clampLength(min, max) {
      var length = this.length();
      return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
  }, {
    key: "floor",
    value: function floor() {
      this.x = Math.floor(this.x);
      this.y = Math.floor(this.y);
      this.z = Math.floor(this.z);
      return this;
    }
  }, {
    key: "ceil",
    value: function ceil() {
      this.x = Math.ceil(this.x);
      this.y = Math.ceil(this.y);
      this.z = Math.ceil(this.z);
      return this;
    }
  }, {
    key: "round",
    value: function round() {
      this.x = Math.round(this.x);
      this.y = Math.round(this.y);
      this.z = Math.round(this.z);
      return this;
    }
  }, {
    key: "roundToZero",
    value: function roundToZero() {
      this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
      this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
      this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
      return this;
    }
  }, {
    key: "negate",
    value: function negate() {
      this.x = -this.x;
      this.y = -this.y;
      this.z = -this.z;
      return this;
    }
  }, {
    key: "dot",
    value: function dot(v) {
      return this.x * v.x + this.y * v.y + this.z * v.z;
    } // TODO lengthSquared?

  }, {
    key: "lengthSq",
    value: function lengthSq() {
      return this.x * this.x + this.y * this.y + this.z * this.z;
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
  }, {
    key: "manhattanLength",
    value: function manhattanLength() {
      return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.divideScalar(this.length() || 1);
    }
  }, {
    key: "setLength",
    value: function setLength(length) {
      return this.normalize().multiplyScalar(length);
    }
  }, {
    key: "lerp",
    value: function lerp(v, alpha) {
      this.x += (v.x - this.x) * alpha;
      this.y += (v.y - this.y) * alpha;
      this.z += (v.z - this.z) * alpha;
      return this;
    }
  }, {
    key: "lerpVectors",
    value: function lerpVectors(v1, v2, alpha) {
      this.x = v1.x + (v2.x - v1.x) * alpha;
      this.y = v1.y + (v2.y - v1.y) * alpha;
      this.z = v1.z + (v2.z - v1.z) * alpha;
      return this;
    }
  }, {
    key: "cross",
    value: function cross(v) {
      return this.crossVectors(this, v);
    }
  }, {
    key: "crossVectors",
    value: function crossVectors(a, b) {
      var ax = a.x,
          ay = a.y,
          az = a.z;
      var bx = b.x,
          by = b.y,
          bz = b.z;
      this.x = ay * bz - az * by;
      this.y = az * bx - ax * bz;
      this.z = ax * by - ay * bx;
      return this;
    }
  }, {
    key: "projectOnVector",
    value: function projectOnVector(v) {
      var denominator = v.lengthSq();
      if (denominator === 0) return this.set(0, 0, 0);
      var scalar = v.dot(this) / denominator;
      return this.copy(v).multiplyScalar(scalar);
    }
  }, {
    key: "projectOnPlane",
    value: function projectOnPlane(planeNormal) {
      _vector$b$1.copy(this).projectOnVector(planeNormal);

      return this.sub(_vector$b$1);
    }
  }, {
    key: "reflect",
    value: function reflect(normal) {
      // reflect incident vector off plane orthogonal to normal
      // normal is assumed to have unit length
      return this.sub(_vector$b$1.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
  }, {
    key: "angleTo",
    value: function angleTo(v) {
      var denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
      if (denominator === 0) return Math.PI / 2;
      var theta = this.dot(v) / denominator; // clamp, to handle numerical problems

      return Math.acos(clamp$1(theta, -1, 1));
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(v) {
      return Math.sqrt(this.distanceToSquared(v));
    }
  }, {
    key: "distanceToSquared",
    value: function distanceToSquared(v) {
      var dx = this.x - v.x,
          dy = this.y - v.y,
          dz = this.z - v.z;
      return dx * dx + dy * dy + dz * dz;
    }
  }, {
    key: "manhattanDistanceTo",
    value: function manhattanDistanceTo(v) {
      return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
  }, {
    key: "setFromSpherical",
    value: function setFromSpherical(s) {
      return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
  }, {
    key: "setFromSphericalCoords",
    value: function setFromSphericalCoords(radius, phi, theta) {
      var sinPhiRadius = Math.sin(phi) * radius;
      this.x = sinPhiRadius * Math.sin(theta);
      this.y = Math.cos(phi) * radius;
      this.z = sinPhiRadius * Math.cos(theta);
      return this;
    }
  }, {
    key: "setFromCylindrical",
    value: function setFromCylindrical(c) {
      return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
  }, {
    key: "setFromCylindricalCoords",
    value: function setFromCylindricalCoords(radius, theta, y) {
      this.x = radius * Math.sin(theta);
      this.y = y;
      this.z = radius * Math.cos(theta);
      return this;
    }
  }, {
    key: "setFromMatrixPosition",
    value: function setFromMatrixPosition(m) {
      var e = m.elements;
      this.x = e[12];
      this.y = e[13];
      this.z = e[14];
      return this;
    }
  }, {
    key: "setFromMatrixScale",
    value: function setFromMatrixScale(m) {
      var sx = this.setFromMatrixColumn(m, 0).length();
      var sy = this.setFromMatrixColumn(m, 1).length();
      var sz = this.setFromMatrixColumn(m, 2).length();
      this.x = sx;
      this.y = sy;
      this.z = sz;
      return this;
    }
  }, {
    key: "setFromMatrixColumn",
    value: function setFromMatrixColumn(m, index) {
      return this.fromArray(m.elements, index * 4);
    }
  }, {
    key: "setFromMatrix3Column",
    value: function setFromMatrix3Column(m, index) {
      return this.fromArray(m.elements, index * 3);
    }
  }, {
    key: "setFromEuler",
    value: function setFromEuler(e) {
      this.x = e._x;
      this.y = e._y;
      this.z = e._z;
      return this;
    }
  }, {
    key: "setFromColor",
    value: function setFromColor(c) {
      this.x = c.r;
      this.y = c.g;
      this.z = c.b;
      return this;
    }
  }, {
    key: "equals",
    value: function equals(v) {
      return v.x === this.x && v.y === this.y && v.z === this.z;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.x = array[offset];
      this.y = array[offset + 1];
      this.z = array[offset + 2];
      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      array[offset] = this.x;
      array[offset + 1] = this.y;
      array[offset + 2] = this.z;
      return array;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(attribute, index) {
      this.x = attribute.getX(index);
      this.y = attribute.getY(index);
      this.z = attribute.getZ(index);
      return this;
    }
  }, {
    key: "random",
    value: function random() {
      this.x = Math.random();
      this.y = Math.random();
      this.z = Math.random();
      return this;
    }
  }, {
    key: "randomDirection",
    value: function randomDirection() {
      // Derived from https://mathworld.wolfram.com/SpherePointPicking.html
      var u = (Math.random() - 0.5) * 2;
      var t = Math.random() * Math.PI * 2;
      var f = Math.sqrt(1 - Math.pow(u, 2));
      this.x = f * Math.cos(t);
      this.y = f * Math.sin(t);
      this.z = u;
      return this;
    }
  }, {
    key: _Symbol$iterator9,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.x;

            case 2:
              _context11.next = 4;
              return this.y;

            case 4:
              _context11.next = 6;
              return this.z;

            case 6:
            case "end":
              return _context11.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Vector3$1;
}(Symbol.iterator);

var _vector$b$1 = /*@__PURE__*/new Vector3$1();

var _quaternion$4$1 = /*@__PURE__*/new Quaternion$1();

var _colorKeywords$1 = {
  'aliceblue': 0xF0F8FF,
  'antiquewhite': 0xFAEBD7,
  'aqua': 0x00FFFF,
  'aquamarine': 0x7FFFD4,
  'azure': 0xF0FFFF,
  'beige': 0xF5F5DC,
  'bisque': 0xFFE4C4,
  'black': 0x000000,
  'blanchedalmond': 0xFFEBCD,
  'blue': 0x0000FF,
  'blueviolet': 0x8A2BE2,
  'brown': 0xA52A2A,
  'burlywood': 0xDEB887,
  'cadetblue': 0x5F9EA0,
  'chartreuse': 0x7FFF00,
  'chocolate': 0xD2691E,
  'coral': 0xFF7F50,
  'cornflowerblue': 0x6495ED,
  'cornsilk': 0xFFF8DC,
  'crimson': 0xDC143C,
  'cyan': 0x00FFFF,
  'darkblue': 0x00008B,
  'darkcyan': 0x008B8B,
  'darkgoldenrod': 0xB8860B,
  'darkgray': 0xA9A9A9,
  'darkgreen': 0x006400,
  'darkgrey': 0xA9A9A9,
  'darkkhaki': 0xBDB76B,
  'darkmagenta': 0x8B008B,
  'darkolivegreen': 0x556B2F,
  'darkorange': 0xFF8C00,
  'darkorchid': 0x9932CC,
  'darkred': 0x8B0000,
  'darksalmon': 0xE9967A,
  'darkseagreen': 0x8FBC8F,
  'darkslateblue': 0x483D8B,
  'darkslategray': 0x2F4F4F,
  'darkslategrey': 0x2F4F4F,
  'darkturquoise': 0x00CED1,
  'darkviolet': 0x9400D3,
  'deeppink': 0xFF1493,
  'deepskyblue': 0x00BFFF,
  'dimgray': 0x696969,
  'dimgrey': 0x696969,
  'dodgerblue': 0x1E90FF,
  'firebrick': 0xB22222,
  'floralwhite': 0xFFFAF0,
  'forestgreen': 0x228B22,
  'fuchsia': 0xFF00FF,
  'gainsboro': 0xDCDCDC,
  'ghostwhite': 0xF8F8FF,
  'gold': 0xFFD700,
  'goldenrod': 0xDAA520,
  'gray': 0x808080,
  'green': 0x008000,
  'greenyellow': 0xADFF2F,
  'grey': 0x808080,
  'honeydew': 0xF0FFF0,
  'hotpink': 0xFF69B4,
  'indianred': 0xCD5C5C,
  'indigo': 0x4B0082,
  'ivory': 0xFFFFF0,
  'khaki': 0xF0E68C,
  'lavender': 0xE6E6FA,
  'lavenderblush': 0xFFF0F5,
  'lawngreen': 0x7CFC00,
  'lemonchiffon': 0xFFFACD,
  'lightblue': 0xADD8E6,
  'lightcoral': 0xF08080,
  'lightcyan': 0xE0FFFF,
  'lightgoldenrodyellow': 0xFAFAD2,
  'lightgray': 0xD3D3D3,
  'lightgreen': 0x90EE90,
  'lightgrey': 0xD3D3D3,
  'lightpink': 0xFFB6C1,
  'lightsalmon': 0xFFA07A,
  'lightseagreen': 0x20B2AA,
  'lightskyblue': 0x87CEFA,
  'lightslategray': 0x778899,
  'lightslategrey': 0x778899,
  'lightsteelblue': 0xB0C4DE,
  'lightyellow': 0xFFFFE0,
  'lime': 0x00FF00,
  'limegreen': 0x32CD32,
  'linen': 0xFAF0E6,
  'magenta': 0xFF00FF,
  'maroon': 0x800000,
  'mediumaquamarine': 0x66CDAA,
  'mediumblue': 0x0000CD,
  'mediumorchid': 0xBA55D3,
  'mediumpurple': 0x9370DB,
  'mediumseagreen': 0x3CB371,
  'mediumslateblue': 0x7B68EE,
  'mediumspringgreen': 0x00FA9A,
  'mediumturquoise': 0x48D1CC,
  'mediumvioletred': 0xC71585,
  'midnightblue': 0x191970,
  'mintcream': 0xF5FFFA,
  'mistyrose': 0xFFE4E1,
  'moccasin': 0xFFE4B5,
  'navajowhite': 0xFFDEAD,
  'navy': 0x000080,
  'oldlace': 0xFDF5E6,
  'olive': 0x808000,
  'olivedrab': 0x6B8E23,
  'orange': 0xFFA500,
  'orangered': 0xFF4500,
  'orchid': 0xDA70D6,
  'palegoldenrod': 0xEEE8AA,
  'palegreen': 0x98FB98,
  'paleturquoise': 0xAFEEEE,
  'palevioletred': 0xDB7093,
  'papayawhip': 0xFFEFD5,
  'peachpuff': 0xFFDAB9,
  'peru': 0xCD853F,
  'pink': 0xFFC0CB,
  'plum': 0xDDA0DD,
  'powderblue': 0xB0E0E6,
  'purple': 0x800080,
  'rebeccapurple': 0x663399,
  'red': 0xFF0000,
  'rosybrown': 0xBC8F8F,
  'royalblue': 0x4169E1,
  'saddlebrown': 0x8B4513,
  'salmon': 0xFA8072,
  'sandybrown': 0xF4A460,
  'seagreen': 0x2E8B57,
  'seashell': 0xFFF5EE,
  'sienna': 0xA0522D,
  'silver': 0xC0C0C0,
  'skyblue': 0x87CEEB,
  'slateblue': 0x6A5ACD,
  'slategray': 0x708090,
  'slategrey': 0x708090,
  'snow': 0xFFFAFA,
  'springgreen': 0x00FF7F,
  'steelblue': 0x4682B4,
  'tan': 0xD2B48C,
  'teal': 0x008080,
  'thistle': 0xD8BFD8,
  'tomato': 0xFF6347,
  'turquoise': 0x40E0D0,
  'violet': 0xEE82EE,
  'wheat': 0xF5DEB3,
  'white': 0xFFFFFF,
  'whitesmoke': 0xF5F5F5,
  'yellow': 0xFFFF00,
  'yellowgreen': 0x9ACD32
};
var _hslA$1 = {
  h: 0,
  s: 0,
  l: 0
};
var _hslB$1 = {
  h: 0,
  s: 0,
  l: 0
};

function hue2rgb$1(p, q, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;
  if (t < 1 / 6) return p + (q - p) * 6 * t;
  if (t < 1 / 2) return q;
  if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
  return p;
}

var Color$1 = /*#__PURE__*/function (_Symbol$iterator10) {
  function Color$1(r, g, b) {
    _classCallCheck2(this, Color$1);

    this.isColor = true;
    this.r = 1;
    this.g = 1;
    this.b = 1;

    if (g === undefined && b === undefined) {
      // r is THREE.Color, hex or string
      return this.set(r);
    }

    return this.setRGB(r, g, b);
  }

  _createClass2(Color$1, [{
    key: "set",
    value: function set(value) {
      if (value && value.isColor) {
        this.copy(value);
      } else if (typeof value === 'number') {
        this.setHex(value);
      } else if (typeof value === 'string') {
        this.setStyle(value);
      }

      return this;
    }
  }, {
    key: "setScalar",
    value: function setScalar(scalar) {
      this.r = scalar;
      this.g = scalar;
      this.b = scalar;
      return this;
    }
  }, {
    key: "setHex",
    value: function setHex(hex) {
      var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SRGBColorSpace$1;
      hex = Math.floor(hex);
      this.r = (hex >> 16 & 255) / 255;
      this.g = (hex >> 8 & 255) / 255;
      this.b = (hex & 255) / 255;
      ColorManagement$1.toWorkingColorSpace(this, colorSpace);
      return this;
    }
  }, {
    key: "setRGB",
    value: function setRGB(r, g, b) {
      var colorSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ColorManagement$1.workingColorSpace;
      this.r = r;
      this.g = g;
      this.b = b;
      ColorManagement$1.toWorkingColorSpace(this, colorSpace);
      return this;
    }
  }, {
    key: "setHSL",
    value: function setHSL(h, s, l) {
      var colorSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ColorManagement$1.workingColorSpace;
      // h,s,l ranges are in 0.0 - 1.0
      h = euclideanModulo$1(h, 1);
      s = clamp$1(s, 0, 1);
      l = clamp$1(l, 0, 1);

      if (s === 0) {
        this.r = this.g = this.b = l;
      } else {
        var p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
        var q = 2 * l - p;
        this.r = hue2rgb$1(q, p, h + 1 / 3);
        this.g = hue2rgb$1(q, p, h);
        this.b = hue2rgb$1(q, p, h - 1 / 3);
      }

      ColorManagement$1.toWorkingColorSpace(this, colorSpace);
      return this;
    }
  }, {
    key: "setStyle",
    value: function setStyle(style) {
      var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SRGBColorSpace$1;

      function handleAlpha(string) {
        if (string === undefined) return;

        if (parseFloat(string) < 1) {
          console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
      }

      var m;

      if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
        // rgb / hsl
        var color;
        var name = m[1];
        var components = m[2];

        switch (name) {
          case 'rgb':
          case 'rgba':
            if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
              // rgb(255,0,0) rgba(255,0,0,0.5)
              handleAlpha(color[4]);
              return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
            }

            if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
              // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
              handleAlpha(color[4]);
              return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
            }

            break;

          case 'hsl':
          case 'hsla':
            if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
              // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
              handleAlpha(color[4]);
              return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
            }

            break;

          default:
            console.warn('THREE.Color: Unknown color model ' + style);
        }
      } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
        // hex color
        var hex = m[1];
        var size = hex.length;

        if (size === 3) {
          // #ff0
          return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
        } else if (size === 6) {
          // #ff0000
          return this.setHex(parseInt(hex, 16), colorSpace);
        } else {
          console.warn('THREE.Color: Invalid hex color ' + style);
        }
      } else if (style && style.length > 0) {
        return this.setColorName(style, colorSpace);
      }

      return this;
    }
  }, {
    key: "setColorName",
    value: function setColorName(style) {
      var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SRGBColorSpace$1;

      // color keywords
      var hex = _colorKeywords$1[style.toLowerCase()];

      if (hex !== undefined) {
        // red
        this.setHex(hex, colorSpace);
      } else {
        // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
      }

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new this.constructor(this.r, this.g, this.b);
    }
  }, {
    key: "copy",
    value: function copy(color) {
      this.r = color.r;
      this.g = color.g;
      this.b = color.b;
      return this;
    }
  }, {
    key: "copySRGBToLinear",
    value: function copySRGBToLinear(color) {
      this.r = SRGBToLinear$1(color.r);
      this.g = SRGBToLinear$1(color.g);
      this.b = SRGBToLinear$1(color.b);
      return this;
    }
  }, {
    key: "copyLinearToSRGB",
    value: function copyLinearToSRGB(color) {
      this.r = LinearToSRGB$1(color.r);
      this.g = LinearToSRGB$1(color.g);
      this.b = LinearToSRGB$1(color.b);
      return this;
    }
  }, {
    key: "convertSRGBToLinear",
    value: function convertSRGBToLinear() {
      this.copySRGBToLinear(this);
      return this;
    }
  }, {
    key: "convertLinearToSRGB",
    value: function convertLinearToSRGB() {
      this.copyLinearToSRGB(this);
      return this;
    }
  }, {
    key: "getHex",
    value: function getHex() {
      var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SRGBColorSpace$1;
      ColorManagement$1.fromWorkingColorSpace(_color.copy(this), colorSpace);
      return Math.round(clamp$1(_color.r * 255, 0, 255)) * 65536 + Math.round(clamp$1(_color.g * 255, 0, 255)) * 256 + Math.round(clamp$1(_color.b * 255, 0, 255));
    }
  }, {
    key: "getHexString",
    value: function getHexString() {
      var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SRGBColorSpace$1;
      return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
  }, {
    key: "getHSL",
    value: function getHSL(target) {
      var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ColorManagement$1.workingColorSpace;
      // h,s,l ranges are in 0.0 - 1.0
      ColorManagement$1.fromWorkingColorSpace(_color.copy(this), colorSpace);
      var r = _color.r,
          g = _color.g,
          b = _color.b;
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var hue, saturation;
      var lightness = (min + max) / 2.0;

      if (min === max) {
        hue = 0;
        saturation = 0;
      } else {
        var delta = max - min;
        saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);

        switch (max) {
          case r:
            hue = (g - b) / delta + (g < b ? 6 : 0);
            break;

          case g:
            hue = (b - r) / delta + 2;
            break;

          case b:
            hue = (r - g) / delta + 4;
            break;
        }

        hue /= 6;
      }

      target.h = hue;
      target.s = saturation;
      target.l = lightness;
      return target;
    }
  }, {
    key: "getRGB",
    value: function getRGB(target) {
      var colorSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ColorManagement$1.workingColorSpace;
      ColorManagement$1.fromWorkingColorSpace(_color.copy(this), colorSpace);
      target.r = _color.r;
      target.g = _color.g;
      target.b = _color.b;
      return target;
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var colorSpace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SRGBColorSpace$1;
      ColorManagement$1.fromWorkingColorSpace(_color.copy(this), colorSpace);
      var r = _color.r,
          g = _color.g,
          b = _color.b;

      if (colorSpace !== SRGBColorSpace$1) {
        // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return "color(".concat(colorSpace, " ").concat(r.toFixed(3), " ").concat(g.toFixed(3), " ").concat(b.toFixed(3), ")");
      }

      return "rgb(".concat(Math.round(r * 255), ",").concat(Math.round(g * 255), ",").concat(Math.round(b * 255), ")");
    }
  }, {
    key: "offsetHSL",
    value: function offsetHSL(h, s, l) {
      this.getHSL(_hslA$1);
      _hslA$1.h += h;
      _hslA$1.s += s;
      _hslA$1.l += l;
      this.setHSL(_hslA$1.h, _hslA$1.s, _hslA$1.l);
      return this;
    }
  }, {
    key: "add",
    value: function add(color) {
      this.r += color.r;
      this.g += color.g;
      this.b += color.b;
      return this;
    }
  }, {
    key: "addColors",
    value: function addColors(color1, color2) {
      this.r = color1.r + color2.r;
      this.g = color1.g + color2.g;
      this.b = color1.b + color2.b;
      return this;
    }
  }, {
    key: "addScalar",
    value: function addScalar(s) {
      this.r += s;
      this.g += s;
      this.b += s;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(color) {
      this.r = Math.max(0, this.r - color.r);
      this.g = Math.max(0, this.g - color.g);
      this.b = Math.max(0, this.b - color.b);
      return this;
    }
  }, {
    key: "multiply",
    value: function multiply(color) {
      this.r *= color.r;
      this.g *= color.g;
      this.b *= color.b;
      return this;
    }
  }, {
    key: "multiplyScalar",
    value: function multiplyScalar(s) {
      this.r *= s;
      this.g *= s;
      this.b *= s;
      return this;
    }
  }, {
    key: "lerp",
    value: function lerp(color, alpha) {
      this.r += (color.r - this.r) * alpha;
      this.g += (color.g - this.g) * alpha;
      this.b += (color.b - this.b) * alpha;
      return this;
    }
  }, {
    key: "lerpColors",
    value: function lerpColors(color1, color2, alpha) {
      this.r = color1.r + (color2.r - color1.r) * alpha;
      this.g = color1.g + (color2.g - color1.g) * alpha;
      this.b = color1.b + (color2.b - color1.b) * alpha;
      return this;
    }
  }, {
    key: "lerpHSL",
    value: function lerpHSL(color, alpha) {
      this.getHSL(_hslA$1);
      color.getHSL(_hslB$1);
      var h = lerp$1(_hslA$1.h, _hslB$1.h, alpha);
      var s = lerp$1(_hslA$1.s, _hslB$1.s, alpha);
      var l = lerp$1(_hslA$1.l, _hslB$1.l, alpha);
      this.setHSL(h, s, l);
      return this;
    }
  }, {
    key: "setFromVector3",
    value: function setFromVector3(v) {
      this.r = v.x;
      this.g = v.y;
      this.b = v.z;
      return this;
    }
  }, {
    key: "applyMatrix3",
    value: function applyMatrix3(m) {
      var r = this.r,
          g = this.g,
          b = this.b;
      var e = m.elements;
      this.r = e[0] * r + e[3] * g + e[6] * b;
      this.g = e[1] * r + e[4] * g + e[7] * b;
      this.b = e[2] * r + e[5] * g + e[8] * b;
      return this;
    }
  }, {
    key: "equals",
    value: function equals(c) {
      return c.r === this.r && c.g === this.g && c.b === this.b;
    }
  }, {
    key: "fromArray",
    value: function fromArray(array) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.r = array[offset];
      this.g = array[offset + 1];
      this.b = array[offset + 2];
      return this;
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      array[offset] = this.r;
      array[offset + 1] = this.g;
      array[offset + 2] = this.b;
      return array;
    }
  }, {
    key: "fromBufferAttribute",
    value: function fromBufferAttribute(attribute, index) {
      this.r = attribute.getX(index);
      this.g = attribute.getY(index);
      this.b = attribute.getZ(index);
      return this;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.getHex();
    }
  }, {
    key: _Symbol$iterator10,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      return _regeneratorRuntime.wrap(function value$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.r;

            case 2:
              _context12.next = 4;
              return this.g;

            case 4:
              _context12.next = 6;
              return this.b;

            case 6:
            case "end":
              return _context12.stop();
          }
        }
      }, value, this);
    })
  }]);

  return Color$1;
}(Symbol.iterator);

var _color = /*@__PURE__*/new Color$1();

Color$1.NAMES = _colorKeywords$1;
/**
 * Uniform Utilities
 */

function cloneUniforms$1(src) {
  var dst = {};

  for (var u in src) {
    dst[u] = {};

    for (var p in src[u]) {
      var property = src[u][p];

      if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
        if (property.isRenderTargetTexture) {
          console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
          dst[u][p] = null;
        } else {
          dst[u][p] = property.clone();
        }
      } else if (Array.isArray(property)) {
        dst[u][p] = property.slice();
      } else {
        dst[u][p] = property;
      }
    }
  }

  return dst;
}

function mergeUniforms$1(uniforms) {
  var merged = {};

  for (var u = 0; u < uniforms.length; u++) {
    var _tmp3 = cloneUniforms$1(uniforms[u]);

    for (var p in _tmp3) {
      merged[p] = _tmp3[p];
    }
  }

  return merged;
}

var alphamap_fragment$1 = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var alphamap_pars_fragment$1 = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var alphatest_fragment$1 = "#ifdef USE_ALPHATEST\n\tif ( diffuseColor.a < alphaTest ) discard;\n#endif";
var alphatest_pars_fragment$1 = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var aomap_fragment$1 = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var aomap_pars_fragment$1 = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var begin_vertex$1 = "vec3 transformed = vec3( position );";
var beginnormal_vertex$1 = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var bsdfs$1 = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\t return vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat R21 = R12;\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var bumpmap_pars_fragment$1 = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = dFdx( surf_pos.xyz );\n\t\tvec3 vSigmaY = dFdy( surf_pos.xyz );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var clipping_planes_fragment$1 = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
var clipping_planes_pars_fragment$1 = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var clipping_planes_pars_vertex$1 = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var clipping_planes_vertex$1 = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var color_fragment$1 = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var color_pars_fragment$1 = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var color_pars_vertex$1 = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var color_vertex$1 = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
var common$1 = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n\treturn dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var cube_uv_reflection_fragment$1 = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_v0 0.339\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_v1 0.276\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_v4 0.046\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_v5 0.016\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_v6 0.0038\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var defaultnormal_vertex$1 = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var displacementmap_pars_vertex$1 = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var displacementmap_vertex$1 = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var emissivemap_fragment$1 = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var emissivemap_pars_fragment$1 = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var encodings_fragment$1 = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var encodings_pars_fragment$1 = "vec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var envmap_fragment$1 = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var envmap_common_pars_fragment$1 = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var envmap_pars_fragment$1 = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var envmap_pars_vertex$1 = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var envmap_vertex$1 = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var fog_vertex$1 = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var fog_pars_vertex$1 = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var fog_fragment$1 = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var fog_pars_fragment$1 = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var gradientmap_pars_fragment$1 = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var lightmap_fragment$1 = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\treflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif";
var lightmap_pars_fragment$1 = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var lights_pars_begin$1 = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\t#if defined ( LEGACY_LIGHTS )\n\t\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\t\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t\t}\n\t\treturn 1.0;\n\t#else\n\t\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\t\tif ( cutoffDistance > 0.0 ) {\n\t\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t\t}\n\t\treturn distanceFalloff;\n\t#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var envmap_physical_pars_fragment$1 = "#if defined( USE_ENVMAP )\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#if defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n#endif";
var lights_toon_fragment$1 = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var lights_toon_pars_fragment$1 = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var lights_phong_fragment$1 = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var lights_phong_pars_fragment$1 = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var lights_physical_fragment$1 = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif";
var lights_physical_pars_fragment$1 = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n};\nvec3 clearcoatSpecular = vec3( 0.0 );\nvec3 sheenSpecular = vec3( 0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecular += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var lights_fragment_begin$1 = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef USE_CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometry.viewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometry, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry.normal );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var lights_fragment_maps$1 = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometry.normal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var lights_fragment_end$1 = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var logdepthbuf_fragment$1 = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var logdepthbuf_pars_fragment$1 = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var logdepthbuf_pars_vertex$1 = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
var logdepthbuf_vertex$1 = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
var map_fragment$1 = "#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, vMapUv );\n#endif";
var map_pars_fragment$1 = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var map_particle_fragment$1 = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var map_particle_pars_fragment$1 = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var metalnessmap_fragment$1 = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var metalnessmap_pars_fragment$1 = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var morphcolor_vertex$1 = "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var morphnormal_vertex$1 = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\t\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\t\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\t\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n\t#endif\n#endif";
var morphtarget_pars_vertex$1 = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t\tuniform sampler2DArray morphTargetsTexture;\n\t\tuniform ivec2 morphTargetsTextureSize;\n\t\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t\t}\n\t#else\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\tuniform float morphTargetInfluences[ 8 ];\n\t\t#else\n\t\t\tuniform float morphTargetInfluences[ 4 ];\n\t\t#endif\n\t#endif\n#endif";
var morphtarget_vertex$1 = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\t#ifdef MORPHTARGETS_TEXTURE\n\t\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t\t}\n\t#else\n\t\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\t\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\t\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\t\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t\t#ifndef USE_MORPHNORMALS\n\t\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t\t#endif\n\t#endif\n#endif";
var normal_fragment_begin$1 = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_NORMALMAP_TANGENTSPACE\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal, vNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 geometryNormal = normal;";
var normal_fragment_maps$1 = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var normal_pars_fragment$1 = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var normal_pars_vertex$1 = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var normal_vertex$1 = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var normalmap_pars_fragment$1 = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var clearcoat_normal_fragment_begin$1 = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif";
var clearcoat_normal_fragment_maps$1 = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var clearcoat_pars_fragment$1 = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var output_fragment$1 = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha + 0.1;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var packing$1 = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n\treturn packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var premultiplied_alpha_fragment$1 = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var project_vertex$1 = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var dithering_fragment$1 = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var dithering_pars_fragment$1 = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var roughnessmap_fragment$1 = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var roughnessmap_pars_fragment$1 = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var shadowmap_pars_fragment$1 = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
var shadowmap_pars_vertex$1 = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var shadowmap_vertex$1 = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var shadowmask_pars_fragment$1 = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var skinbase_vertex$1 = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var skinning_pars_vertex$1 = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tuniform int boneTextureSize;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tfloat j = i * 4.0;\n\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\ty = dy * ( y + 0.5 );\n\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\treturn bone;\n\t}\n#endif";
var skinning_vertex$1 = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var skinnormal_vertex$1 = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var specularmap_fragment$1 = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var specularmap_pars_fragment$1 = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var tonemapping_fragment$1 = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var tonemapping_pars_fragment$1 = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var transmission_fragment$1 = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmission = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmission.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );\n#endif";
var transmission_pars_fragment$1 = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn radiance;\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance * radiance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\trefractionCoords += 1.0;\n\t\trefractionCoords /= 2.0;\n\t\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\tvec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );\n\t}\n#endif";
var uv_pars_fragment$1 = "#ifdef USE_UV\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var uv_pars_vertex$1 = "#ifdef USE_UV\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var uv_vertex$1 = "#ifdef USE_UV\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var worldpos_vertex$1 = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
var vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
var fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var vertex$g$1 = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
var fragment$g$1 = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var vertex$f$1 = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
var fragment$f$1 = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var vertex$e$1 = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
var fragment$e$1 = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
var vertex$d$1 = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
var fragment$d$1 = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
var vertex$c$1 = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
var fragment$c$1 = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var vertex$b$1 = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var fragment$b$1 = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var vertex$a$1 = "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
var fragment$a$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$9$1 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var fragment$9$1 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$8$1 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
var fragment$8$1 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$7$1 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
var fragment$7$1 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
var vertex$6$1 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var fragment$6$1 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$5$1 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
var fragment$5$1 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;\n\t#endif\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$4$1 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var fragment$4$1 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var vertex$3$1 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
var fragment$3$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var vertex$2$1 = "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var fragment$2$1 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var vertex$1$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var fragment$1$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <output_fragment>\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var ShaderChunk$1 = {
  alphamap_fragment: alphamap_fragment$1,
  alphamap_pars_fragment: alphamap_pars_fragment$1,
  alphatest_fragment: alphatest_fragment$1,
  alphatest_pars_fragment: alphatest_pars_fragment$1,
  aomap_fragment: aomap_fragment$1,
  aomap_pars_fragment: aomap_pars_fragment$1,
  begin_vertex: begin_vertex$1,
  beginnormal_vertex: beginnormal_vertex$1,
  bsdfs: bsdfs$1,
  iridescence_fragment: iridescence_fragment,
  bumpmap_pars_fragment: bumpmap_pars_fragment$1,
  clipping_planes_fragment: clipping_planes_fragment$1,
  clipping_planes_pars_fragment: clipping_planes_pars_fragment$1,
  clipping_planes_pars_vertex: clipping_planes_pars_vertex$1,
  clipping_planes_vertex: clipping_planes_vertex$1,
  color_fragment: color_fragment$1,
  color_pars_fragment: color_pars_fragment$1,
  color_pars_vertex: color_pars_vertex$1,
  color_vertex: color_vertex$1,
  common: common$1,
  cube_uv_reflection_fragment: cube_uv_reflection_fragment$1,
  defaultnormal_vertex: defaultnormal_vertex$1,
  displacementmap_pars_vertex: displacementmap_pars_vertex$1,
  displacementmap_vertex: displacementmap_vertex$1,
  emissivemap_fragment: emissivemap_fragment$1,
  emissivemap_pars_fragment: emissivemap_pars_fragment$1,
  encodings_fragment: encodings_fragment$1,
  encodings_pars_fragment: encodings_pars_fragment$1,
  envmap_fragment: envmap_fragment$1,
  envmap_common_pars_fragment: envmap_common_pars_fragment$1,
  envmap_pars_fragment: envmap_pars_fragment$1,
  envmap_pars_vertex: envmap_pars_vertex$1,
  envmap_physical_pars_fragment: envmap_physical_pars_fragment$1,
  envmap_vertex: envmap_vertex$1,
  fog_vertex: fog_vertex$1,
  fog_pars_vertex: fog_pars_vertex$1,
  fog_fragment: fog_fragment$1,
  fog_pars_fragment: fog_pars_fragment$1,
  gradientmap_pars_fragment: gradientmap_pars_fragment$1,
  lightmap_fragment: lightmap_fragment$1,
  lightmap_pars_fragment: lightmap_pars_fragment$1,
  lights_lambert_fragment: lights_lambert_fragment,
  lights_lambert_pars_fragment: lights_lambert_pars_fragment,
  lights_pars_begin: lights_pars_begin$1,
  lights_toon_fragment: lights_toon_fragment$1,
  lights_toon_pars_fragment: lights_toon_pars_fragment$1,
  lights_phong_fragment: lights_phong_fragment$1,
  lights_phong_pars_fragment: lights_phong_pars_fragment$1,
  lights_physical_fragment: lights_physical_fragment$1,
  lights_physical_pars_fragment: lights_physical_pars_fragment$1,
  lights_fragment_begin: lights_fragment_begin$1,
  lights_fragment_maps: lights_fragment_maps$1,
  lights_fragment_end: lights_fragment_end$1,
  logdepthbuf_fragment: logdepthbuf_fragment$1,
  logdepthbuf_pars_fragment: logdepthbuf_pars_fragment$1,
  logdepthbuf_pars_vertex: logdepthbuf_pars_vertex$1,
  logdepthbuf_vertex: logdepthbuf_vertex$1,
  map_fragment: map_fragment$1,
  map_pars_fragment: map_pars_fragment$1,
  map_particle_fragment: map_particle_fragment$1,
  map_particle_pars_fragment: map_particle_pars_fragment$1,
  metalnessmap_fragment: metalnessmap_fragment$1,
  metalnessmap_pars_fragment: metalnessmap_pars_fragment$1,
  morphcolor_vertex: morphcolor_vertex$1,
  morphnormal_vertex: morphnormal_vertex$1,
  morphtarget_pars_vertex: morphtarget_pars_vertex$1,
  morphtarget_vertex: morphtarget_vertex$1,
  normal_fragment_begin: normal_fragment_begin$1,
  normal_fragment_maps: normal_fragment_maps$1,
  normal_pars_fragment: normal_pars_fragment$1,
  normal_pars_vertex: normal_pars_vertex$1,
  normal_vertex: normal_vertex$1,
  normalmap_pars_fragment: normalmap_pars_fragment$1,
  clearcoat_normal_fragment_begin: clearcoat_normal_fragment_begin$1,
  clearcoat_normal_fragment_maps: clearcoat_normal_fragment_maps$1,
  clearcoat_pars_fragment: clearcoat_pars_fragment$1,
  iridescence_pars_fragment: iridescence_pars_fragment,
  output_fragment: output_fragment$1,
  packing: packing$1,
  premultiplied_alpha_fragment: premultiplied_alpha_fragment$1,
  project_vertex: project_vertex$1,
  dithering_fragment: dithering_fragment$1,
  dithering_pars_fragment: dithering_pars_fragment$1,
  roughnessmap_fragment: roughnessmap_fragment$1,
  roughnessmap_pars_fragment: roughnessmap_pars_fragment$1,
  shadowmap_pars_fragment: shadowmap_pars_fragment$1,
  shadowmap_pars_vertex: shadowmap_pars_vertex$1,
  shadowmap_vertex: shadowmap_vertex$1,
  shadowmask_pars_fragment: shadowmask_pars_fragment$1,
  skinbase_vertex: skinbase_vertex$1,
  skinning_pars_vertex: skinning_pars_vertex$1,
  skinning_vertex: skinning_vertex$1,
  skinnormal_vertex: skinnormal_vertex$1,
  specularmap_fragment: specularmap_fragment$1,
  specularmap_pars_fragment: specularmap_pars_fragment$1,
  tonemapping_fragment: tonemapping_fragment$1,
  tonemapping_pars_fragment: tonemapping_pars_fragment$1,
  transmission_fragment: transmission_fragment$1,
  transmission_pars_fragment: transmission_pars_fragment$1,
  uv_pars_fragment: uv_pars_fragment$1,
  uv_pars_vertex: uv_pars_vertex$1,
  uv_vertex: uv_vertex$1,
  worldpos_vertex: worldpos_vertex$1,
  background_vert: vertex$h,
  background_frag: fragment$h,
  backgroundCube_vert: vertex$g$1,
  backgroundCube_frag: fragment$g$1,
  cube_vert: vertex$f$1,
  cube_frag: fragment$f$1,
  depth_vert: vertex$e$1,
  depth_frag: fragment$e$1,
  distanceRGBA_vert: vertex$d$1,
  distanceRGBA_frag: fragment$d$1,
  equirect_vert: vertex$c$1,
  equirect_frag: fragment$c$1,
  linedashed_vert: vertex$b$1,
  linedashed_frag: fragment$b$1,
  meshbasic_vert: vertex$a$1,
  meshbasic_frag: fragment$a$1,
  meshlambert_vert: vertex$9$1,
  meshlambert_frag: fragment$9$1,
  meshmatcap_vert: vertex$8$1,
  meshmatcap_frag: fragment$8$1,
  meshnormal_vert: vertex$7$1,
  meshnormal_frag: fragment$7$1,
  meshphong_vert: vertex$6$1,
  meshphong_frag: fragment$6$1,
  meshphysical_vert: vertex$5$1,
  meshphysical_frag: fragment$5$1,
  meshtoon_vert: vertex$4$1,
  meshtoon_frag: fragment$4$1,
  points_vert: vertex$3$1,
  points_frag: fragment$3$1,
  shadow_vert: vertex$2$1,
  shadow_frag: fragment$2$1,
  sprite_vert: vertex$1$1,
  sprite_frag: fragment$1$1
};
/**
 * Uniforms library for shared webgl shaders
 */

var UniformsLib$1 = {
  common: {
    diffuse: {
      value: /*@__PURE__*/new Color$1(0xffffff)
    },
    opacity: {
      value: 1.0
    },
    map: {
      value: null
    },
    mapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    alphaMap: {
      value: null
    },
    alphaMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    alphaTest: {
      value: 0
    }
  },
  specularmap: {
    specularMap: {
      value: null
    },
    specularMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    }
  },
  envmap: {
    envMap: {
      value: null
    },
    flipEnvMap: {
      value: -1
    },
    reflectivity: {
      value: 1.0
    },
    // basic, lambert, phong
    ior: {
      value: 1.5
    },
    // physical
    refractionRatio: {
      value: 0.98
    } // basic, lambert, phong

  },
  aomap: {
    aoMap: {
      value: null
    },
    aoMapIntensity: {
      value: 1
    },
    aoMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    }
  },
  lightmap: {
    lightMap: {
      value: null
    },
    lightMapIntensity: {
      value: 1
    },
    lightMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    }
  },
  bumpmap: {
    bumpMap: {
      value: null
    },
    bumpMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    bumpScale: {
      value: 1
    }
  },
  normalmap: {
    normalMap: {
      value: null
    },
    normalMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    normalScale: {
      value: /*@__PURE__*/new Vector2$1(1, 1)
    }
  },
  displacementmap: {
    displacementMap: {
      value: null
    },
    displacementMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    displacementScale: {
      value: 1
    },
    displacementBias: {
      value: 0
    }
  },
  emissivemap: {
    emissiveMap: {
      value: null
    },
    emissiveMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    }
  },
  metalnessmap: {
    metalnessMap: {
      value: null
    },
    metalnessMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    }
  },
  roughnessmap: {
    roughnessMap: {
      value: null
    },
    roughnessMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    }
  },
  gradientmap: {
    gradientMap: {
      value: null
    }
  },
  fog: {
    fogDensity: {
      value: 0.00025
    },
    fogNear: {
      value: 1
    },
    fogFar: {
      value: 2000
    },
    fogColor: {
      value: /*@__PURE__*/new Color$1(0xffffff)
    }
  },
  lights: {
    ambientLightColor: {
      value: []
    },
    lightProbe: {
      value: []
    },
    directionalLights: {
      value: [],
      properties: {
        direction: {},
        color: {}
      }
    },
    directionalLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      }
    },
    directionalShadowMap: {
      value: []
    },
    directionalShadowMatrix: {
      value: []
    },
    spotLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        direction: {},
        distance: {},
        coneCos: {},
        penumbraCos: {},
        decay: {}
      }
    },
    spotLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {}
      }
    },
    spotLightMap: {
      value: []
    },
    spotShadowMap: {
      value: []
    },
    spotLightMatrix: {
      value: []
    },
    pointLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        decay: {},
        distance: {}
      }
    },
    pointLightShadows: {
      value: [],
      properties: {
        shadowBias: {},
        shadowNormalBias: {},
        shadowRadius: {},
        shadowMapSize: {},
        shadowCameraNear: {},
        shadowCameraFar: {}
      }
    },
    pointShadowMap: {
      value: []
    },
    pointShadowMatrix: {
      value: []
    },
    hemisphereLights: {
      value: [],
      properties: {
        direction: {},
        skyColor: {},
        groundColor: {}
      }
    },
    // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
    rectAreaLights: {
      value: [],
      properties: {
        color: {},
        position: {},
        width: {},
        height: {}
      }
    },
    ltc_1: {
      value: null
    },
    ltc_2: {
      value: null
    }
  },
  points: {
    diffuse: {
      value: /*@__PURE__*/new Color$1(0xffffff)
    },
    opacity: {
      value: 1.0
    },
    size: {
      value: 1.0
    },
    scale: {
      value: 1.0
    },
    map: {
      value: null
    },
    alphaMap: {
      value: null
    },
    alphaTest: {
      value: 0
    },
    uvTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    }
  },
  sprite: {
    diffuse: {
      value: /*@__PURE__*/new Color$1(0xffffff)
    },
    opacity: {
      value: 1.0
    },
    center: {
      value: /*@__PURE__*/new Vector2$1(0.5, 0.5)
    },
    rotation: {
      value: 0.0
    },
    map: {
      value: null
    },
    mapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    alphaMap: {
      value: null
    },
    alphaTest: {
      value: 0
    }
  }
};
var ShaderLib$1 = {
  basic: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.common, UniformsLib$1.specularmap, UniformsLib$1.envmap, UniformsLib$1.aomap, UniformsLib$1.lightmap, UniformsLib$1.fog]),
    vertexShader: ShaderChunk$1.meshbasic_vert,
    fragmentShader: ShaderChunk$1.meshbasic_frag
  },
  lambert: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.common, UniformsLib$1.specularmap, UniformsLib$1.envmap, UniformsLib$1.aomap, UniformsLib$1.lightmap, UniformsLib$1.emissivemap, UniformsLib$1.bumpmap, UniformsLib$1.normalmap, UniformsLib$1.displacementmap, UniformsLib$1.fog, UniformsLib$1.lights, {
      emissive: {
        value: /*@__PURE__*/new Color$1(0x000000)
      }
    }]),
    vertexShader: ShaderChunk$1.meshlambert_vert,
    fragmentShader: ShaderChunk$1.meshlambert_frag
  },
  phong: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.common, UniformsLib$1.specularmap, UniformsLib$1.envmap, UniformsLib$1.aomap, UniformsLib$1.lightmap, UniformsLib$1.emissivemap, UniformsLib$1.bumpmap, UniformsLib$1.normalmap, UniformsLib$1.displacementmap, UniformsLib$1.fog, UniformsLib$1.lights, {
      emissive: {
        value: /*@__PURE__*/new Color$1(0x000000)
      },
      specular: {
        value: /*@__PURE__*/new Color$1(0x111111)
      },
      shininess: {
        value: 30
      }
    }]),
    vertexShader: ShaderChunk$1.meshphong_vert,
    fragmentShader: ShaderChunk$1.meshphong_frag
  },
  standard: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.common, UniformsLib$1.envmap, UniformsLib$1.aomap, UniformsLib$1.lightmap, UniformsLib$1.emissivemap, UniformsLib$1.bumpmap, UniformsLib$1.normalmap, UniformsLib$1.displacementmap, UniformsLib$1.roughnessmap, UniformsLib$1.metalnessmap, UniformsLib$1.fog, UniformsLib$1.lights, {
      emissive: {
        value: /*@__PURE__*/new Color$1(0x000000)
      },
      roughness: {
        value: 1.0
      },
      metalness: {
        value: 0.0
      },
      envMapIntensity: {
        value: 1
      } // temporary

    }]),
    vertexShader: ShaderChunk$1.meshphysical_vert,
    fragmentShader: ShaderChunk$1.meshphysical_frag
  },
  toon: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.common, UniformsLib$1.aomap, UniformsLib$1.lightmap, UniformsLib$1.emissivemap, UniformsLib$1.bumpmap, UniformsLib$1.normalmap, UniformsLib$1.displacementmap, UniformsLib$1.gradientmap, UniformsLib$1.fog, UniformsLib$1.lights, {
      emissive: {
        value: /*@__PURE__*/new Color$1(0x000000)
      }
    }]),
    vertexShader: ShaderChunk$1.meshtoon_vert,
    fragmentShader: ShaderChunk$1.meshtoon_frag
  },
  matcap: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.common, UniformsLib$1.bumpmap, UniformsLib$1.normalmap, UniformsLib$1.displacementmap, UniformsLib$1.fog, {
      matcap: {
        value: null
      }
    }]),
    vertexShader: ShaderChunk$1.meshmatcap_vert,
    fragmentShader: ShaderChunk$1.meshmatcap_frag
  },
  points: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.points, UniformsLib$1.fog]),
    vertexShader: ShaderChunk$1.points_vert,
    fragmentShader: ShaderChunk$1.points_frag
  },
  dashed: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.common, UniformsLib$1.fog, {
      scale: {
        value: 1
      },
      dashSize: {
        value: 1
      },
      totalSize: {
        value: 2
      }
    }]),
    vertexShader: ShaderChunk$1.linedashed_vert,
    fragmentShader: ShaderChunk$1.linedashed_frag
  },
  depth: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.common, UniformsLib$1.displacementmap]),
    vertexShader: ShaderChunk$1.depth_vert,
    fragmentShader: ShaderChunk$1.depth_frag
  },
  normal: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.common, UniformsLib$1.bumpmap, UniformsLib$1.normalmap, UniformsLib$1.displacementmap, {
      opacity: {
        value: 1.0
      }
    }]),
    vertexShader: ShaderChunk$1.meshnormal_vert,
    fragmentShader: ShaderChunk$1.meshnormal_frag
  },
  sprite: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.sprite, UniformsLib$1.fog]),
    vertexShader: ShaderChunk$1.sprite_vert,
    fragmentShader: ShaderChunk$1.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: {
        value: /*@__PURE__*/new Matrix3$1()
      },
      t2D: {
        value: null
      },
      backgroundIntensity: {
        value: 1
      }
    },
    vertexShader: ShaderChunk$1.background_vert,
    fragmentShader: ShaderChunk$1.background_frag
  },
  backgroundCube: {
    uniforms: {
      envMap: {
        value: null
      },
      flipEnvMap: {
        value: -1
      },
      backgroundBlurriness: {
        value: 0
      },
      backgroundIntensity: {
        value: 1
      }
    },
    vertexShader: ShaderChunk$1.backgroundCube_vert,
    fragmentShader: ShaderChunk$1.backgroundCube_frag
  },
  cube: {
    uniforms: {
      tCube: {
        value: null
      },
      tFlip: {
        value: -1
      },
      opacity: {
        value: 1.0
      }
    },
    vertexShader: ShaderChunk$1.cube_vert,
    fragmentShader: ShaderChunk$1.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: {
        value: null
      }
    },
    vertexShader: ShaderChunk$1.equirect_vert,
    fragmentShader: ShaderChunk$1.equirect_frag
  },
  distanceRGBA: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.common, UniformsLib$1.displacementmap, {
      referencePosition: {
        value: /*@__PURE__*/new Vector3$1()
      },
      nearDistance: {
        value: 1
      },
      farDistance: {
        value: 1000
      }
    }]),
    vertexShader: ShaderChunk$1.distanceRGBA_vert,
    fragmentShader: ShaderChunk$1.distanceRGBA_frag
  },
  shadow: {
    uniforms: /*@__PURE__*/mergeUniforms$1([UniformsLib$1.lights, UniformsLib$1.fog, {
      color: {
        value: /*@__PURE__*/new Color$1(0x00000)
      },
      opacity: {
        value: 1.0
      }
    }]),
    vertexShader: ShaderChunk$1.shadow_vert,
    fragmentShader: ShaderChunk$1.shadow_frag
  }
};
ShaderLib$1.physical = {
  uniforms: /*@__PURE__*/mergeUniforms$1([ShaderLib$1.standard.uniforms, {
    clearcoat: {
      value: 0
    },
    clearcoatMap: {
      value: null
    },
    clearcoatMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    clearcoatNormalMap: {
      value: null
    },
    clearcoatNormalMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    clearcoatNormalScale: {
      value: /*@__PURE__*/new Vector2$1(1, 1)
    },
    clearcoatRoughness: {
      value: 0
    },
    clearcoatRoughnessMap: {
      value: null
    },
    clearcoatRoughnessMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    iridescence: {
      value: 0
    },
    iridescenceMap: {
      value: null
    },
    iridescenceMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    iridescenceIOR: {
      value: 1.3
    },
    iridescenceThicknessMinimum: {
      value: 100
    },
    iridescenceThicknessMaximum: {
      value: 400
    },
    iridescenceThicknessMap: {
      value: null
    },
    iridescenceThicknessMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    sheen: {
      value: 0
    },
    sheenColor: {
      value: /*@__PURE__*/new Color$1(0x000000)
    },
    sheenColorMap: {
      value: null
    },
    sheenColorMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    sheenRoughness: {
      value: 1
    },
    sheenRoughnessMap: {
      value: null
    },
    sheenRoughnessMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    transmission: {
      value: 0
    },
    transmissionMap: {
      value: null
    },
    transmissionMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    transmissionSamplerSize: {
      value: /*@__PURE__*/new Vector2$1()
    },
    transmissionSamplerMap: {
      value: null
    },
    thickness: {
      value: 0
    },
    thicknessMap: {
      value: null
    },
    thicknessMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    attenuationDistance: {
      value: 0
    },
    attenuationColor: {
      value: /*@__PURE__*/new Color$1(0x000000)
    },
    specularColor: {
      value: /*@__PURE__*/new Color$1(1, 1, 1)
    },
    specularColorMap: {
      value: null
    },
    specularColorMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    },
    specularIntensity: {
      value: 1
    },
    specularIntensityMap: {
      value: null
    },
    specularIntensityMapTransform: {
      value: /*@__PURE__*/new Matrix3$1()
    }
  }]),
  vertexShader: ShaderChunk$1.meshphysical_vert,
  fragmentShader: ShaderChunk$1.meshphysical_frag
}; // Characters [].:/ are reserved for track binding syntax.

var _RESERVED_CHARS_RE$1 = '\\[\\]\\.:\\/';
'[^' + _RESERVED_CHARS_RE$1.replace('\\.', '') + ']';

if (typeof __THREE_DEVTOOLS__ !== 'undefined') {
  __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
      revision: REVISION$1
    }
  }));
}

if (typeof window !== 'undefined') {
  if (window.__THREE__) {
    console.warn('WARNING: Multiple instances of Three.js being imported.');
  } else {
    window.__THREE__ = REVISION$1;
  }
}

function calculateVolume(geometry) {
  var volumen = 0;
  var vertices = geometry.attributes.position.array;
  var indices = geometry.index ? geometry.index.array : null;

  function volumenTriangular(p1, p2, p3) {
    var v321 = p3.x * p2.y * p1.z;
    var v231 = p2.x * p3.y * p1.z;
    var v312 = p3.x * p1.y * p2.z;
    var v132 = p2.x * p1.y * p3.z;
    var v213 = p1.x * p3.y * p2.z;
    var v123 = p1.x * p2.y * p3.z;
    return 1.0 / 6.0 * (-v321 + v231 + v312 - v132 - v213 + v123);
  }

  if (!indices) {
    indices = Array.from({
      length: vertices.length / 3
    }, function (_, i) {
      return i;
    });
  }

  for (var _i289 = 0; _i289 < indices.length; _i289 += 3) {
    var a = new Vector3$1().fromArray(vertices, indices[_i289] * 3);
    var b = new Vector3$1().fromArray(vertices, indices[_i289 + 1] * 3);
    var c = new Vector3$1().fromArray(vertices, indices[_i289 + 2] * 3);
    volumen += volumenTriangular(a, b, c);
  }

  return Math.abs(volumen / 1000);
}

var ThreeVolume = calculateVolume;
/**
 * splaytree v3.1.2
 * Fast Splay tree for Node and browser
 *
 * @author Alexander Milevski <info@w8r.name>
 * @license MIT
 * @preserve
 */

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __generator$1(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

var Node$2 =
/** @class */
function () {
  function Node(key, data) {
    this.next = null;
    this.key = key;
    this.data = data;
    this.left = null;
    this.right = null;
  }

  return Node;
}();
/* follows "An implementation of top-down splaying"
 * by D. Sleator <sleator@cs.cmu.edu> March 1992
 */


function DEFAULT_COMPARE(a, b) {
  return a > b ? 1 : a < b ? -1 : 0;
}
/**
 * Simple top down splay, not requiring i to be in the tree t.
 */


function splay(i, t, comparator) {
  var N = new Node$2(null, null);
  var l = N;
  var r = N;

  while (true) {
    var cmp = comparator(i, t.key); //if (i < t.key) {

    if (cmp < 0) {
      if (t.left === null) break; //if (i < t.left.key) {

      if (comparator(i, t.left.key) < 0) {
        var y = t.left;
        /* rotate right */

        t.left = y.right;
        y.right = t;
        t = y;
        if (t.left === null) break;
      }

      r.left = t;
      /* link right */

      r = t;
      t = t.left; //} else if (i > t.key) {
    } else if (cmp > 0) {
      if (t.right === null) break; //if (i > t.right.key) {

      if (comparator(i, t.right.key) > 0) {
        var y = t.right;
        /* rotate left */

        t.right = y.left;
        y.left = t;
        t = y;
        if (t.right === null) break;
      }

      l.right = t;
      /* link left */

      l = t;
      t = t.right;
    } else break;
  }
  /* assemble */


  l.right = t.left;
  r.left = t.right;
  t.left = N.right;
  t.right = N.left;
  return t;
}

function insert(i, data, t, comparator) {
  var node = new Node$2(i, data);

  if (t === null) {
    node.left = node.right = null;
    return node;
  }

  t = splay(i, t, comparator);
  var cmp = comparator(i, t.key);

  if (cmp < 0) {
    node.left = t.left;
    node.right = t;
    t.left = null;
  } else if (cmp >= 0) {
    node.right = t.right;
    node.left = t;
    t.right = null;
  }

  return node;
}

function split(key, v, comparator) {
  var left = null;
  var right = null;

  if (v) {
    v = splay(key, v, comparator);
    var cmp = comparator(v.key, key);

    if (cmp === 0) {
      left = v.left;
      right = v.right;
    } else if (cmp < 0) {
      right = v.right;
      v.right = null;
      left = v;
    } else {
      left = v.left;
      v.left = null;
      right = v;
    }
  }

  return {
    left: left,
    right: right
  };
}

function merge(left, right, comparator) {
  if (right === null) return left;
  if (left === null) return right;
  right = splay(left.key, right, comparator);
  right.left = left;
  return right;
}
/**
 * Prints level of the tree
 */


function printRow(root, prefix, isTail, out, printNode) {
  if (root) {
    out("" + prefix + (isTail ? '└── ' : '├── ') + printNode(root) + "\n");
    var indent = prefix + (isTail ? '    ' : '│   ');
    if (root.left) printRow(root.left, indent, false, out, printNode);
    if (root.right) printRow(root.right, indent, true, out, printNode);
  }
}

var Tree =
/** @class */
function () {
  function Tree(comparator) {
    if (comparator === void 0) {
      comparator = DEFAULT_COMPARE;
    }

    this._root = null;
    this._size = 0;
    this._comparator = comparator;
  }
  /**
   * Inserts a key, allows duplicates
   */


  Tree.prototype.insert = function (key, data) {
    this._size++;
    return this._root = insert(key, data, this._root, this._comparator);
  };
  /**
   * Adds a key, if it is not present in the tree
   */


  Tree.prototype.add = function (key, data) {
    var node = new Node$2(key, data);

    if (this._root === null) {
      node.left = node.right = null;
      this._size++;
      this._root = node;
    }

    var comparator = this._comparator;
    var t = splay(key, this._root, comparator);
    var cmp = comparator(key, t.key);
    if (cmp === 0) this._root = t;else {
      if (cmp < 0) {
        node.left = t.left;
        node.right = t;
        t.left = null;
      } else if (cmp > 0) {
        node.right = t.right;
        node.left = t;
        t.right = null;
      }

      this._size++;
      this._root = node;
    }
    return this._root;
  };
  /**
   * @param  {Key} key
   * @return {Node|null}
   */


  Tree.prototype.remove = function (key) {
    this._root = this._remove(key, this._root, this._comparator);
  };
  /**
   * Deletes i from the tree if it's there
   */


  Tree.prototype._remove = function (i, t, comparator) {
    var x;
    if (t === null) return null;
    t = splay(i, t, comparator);
    var cmp = comparator(i, t.key);

    if (cmp === 0) {
      /* found it */
      if (t.left === null) {
        x = t.right;
      } else {
        x = splay(i, t.left, comparator);
        x.right = t.right;
      }

      this._size--;
      return x;
    }

    return t;
    /* It wasn't there */
  };
  /**
   * Removes and returns the node with smallest key
   */


  Tree.prototype.pop = function () {
    var node = this._root;

    if (node) {
      while (node.left) {
        node = node.left;
      }

      this._root = splay(node.key, this._root, this._comparator);
      this._root = this._remove(node.key, this._root, this._comparator);
      return {
        key: node.key,
        data: node.data
      };
    }

    return null;
  };
  /**
   * Find without splaying
   */


  Tree.prototype.findStatic = function (key) {
    var current = this._root;
    var compare = this._comparator;

    while (current) {
      var cmp = compare(key, current.key);
      if (cmp === 0) return current;else if (cmp < 0) current = current.left;else current = current.right;
    }

    return null;
  };

  Tree.prototype.find = function (key) {
    if (this._root) {
      this._root = splay(key, this._root, this._comparator);
      if (this._comparator(key, this._root.key) !== 0) return null;
    }

    return this._root;
  };

  Tree.prototype.contains = function (key) {
    var current = this._root;
    var compare = this._comparator;

    while (current) {
      var cmp = compare(key, current.key);
      if (cmp === 0) return true;else if (cmp < 0) current = current.left;else current = current.right;
    }

    return false;
  };

  Tree.prototype.forEach = function (visitor, ctx) {
    var current = this._root;
    var Q = [];
    /* Initialize stack s */

    var done = false;

    while (!done) {
      if (current !== null) {
        Q.push(current);
        current = current.left;
      } else {
        if (Q.length !== 0) {
          current = Q.pop();
          visitor.call(ctx, current);
          current = current.right;
        } else done = true;
      }
    }

    return this;
  };
  /**
   * Walk key range from `low` to `high`. Stops if `fn` returns a value.
   */


  Tree.prototype.range = function (low, high, fn, ctx) {
    var Q = [];
    var compare = this._comparator;
    var node = this._root;
    var cmp;

    while (Q.length !== 0 || node) {
      if (node) {
        Q.push(node);
        node = node.left;
      } else {
        node = Q.pop();
        cmp = compare(node.key, high);

        if (cmp > 0) {
          break;
        } else if (compare(node.key, low) >= 0) {
          if (fn.call(ctx, node)) return this; // stop if smth is returned
        }

        node = node.right;
      }
    }

    return this;
  };
  /**
   * Returns array of keys
   */


  Tree.prototype.keys = function () {
    var keys = [];
    this.forEach(function (_a) {
      var key = _a.key;
      return keys.push(key);
    });
    return keys;
  };
  /**
   * Returns array of all the data in the nodes
   */


  Tree.prototype.values = function () {
    var values = [];
    this.forEach(function (_a) {
      var data = _a.data;
      return values.push(data);
    });
    return values;
  };

  Tree.prototype.min = function () {
    if (this._root) return this.minNode(this._root).key;
    return null;
  };

  Tree.prototype.max = function () {
    if (this._root) return this.maxNode(this._root).key;
    return null;
  };

  Tree.prototype.minNode = function (t) {
    if (t === void 0) {
      t = this._root;
    }

    if (t) while (t.left) {
      t = t.left;
    }
    return t;
  };

  Tree.prototype.maxNode = function (t) {
    if (t === void 0) {
      t = this._root;
    }

    if (t) while (t.right) {
      t = t.right;
    }
    return t;
  };
  /**
   * Returns node at given index
   */


  Tree.prototype.at = function (index) {
    var current = this._root;
    var done = false;
    var i = 0;
    var Q = [];

    while (!done) {
      if (current) {
        Q.push(current);
        current = current.left;
      } else {
        if (Q.length > 0) {
          current = Q.pop();
          if (i === index) return current;
          i++;
          current = current.right;
        } else done = true;
      }
    }

    return null;
  };

  Tree.prototype.next = function (d) {
    var root = this._root;
    var successor = null;

    if (d.right) {
      successor = d.right;

      while (successor.left) {
        successor = successor.left;
      }

      return successor;
    }

    var comparator = this._comparator;

    while (root) {
      var cmp = comparator(d.key, root.key);
      if (cmp === 0) break;else if (cmp < 0) {
        successor = root;
        root = root.left;
      } else root = root.right;
    }

    return successor;
  };

  Tree.prototype.prev = function (d) {
    var root = this._root;
    var predecessor = null;

    if (d.left !== null) {
      predecessor = d.left;

      while (predecessor.right) {
        predecessor = predecessor.right;
      }

      return predecessor;
    }

    var comparator = this._comparator;

    while (root) {
      var cmp = comparator(d.key, root.key);
      if (cmp === 0) break;else if (cmp < 0) root = root.left;else {
        predecessor = root;
        root = root.right;
      }
    }

    return predecessor;
  };

  Tree.prototype.clear = function () {
    this._root = null;
    this._size = 0;
    return this;
  };

  Tree.prototype.toList = function () {
    return toList(this._root);
  };
  /**
   * Bulk-load items. Both array have to be same size
   */


  Tree.prototype.load = function (keys, values, presort) {
    if (values === void 0) {
      values = [];
    }

    if (presort === void 0) {
      presort = false;
    }

    var size = keys.length;
    var comparator = this._comparator; // sort if needed

    if (presort) sort(keys, values, 0, size - 1, comparator);

    if (this._root === null) {
      // empty tree
      this._root = loadRecursive(keys, values, 0, size);
      this._size = size;
    } else {
      // that re-builds the whole tree from two in-order traversals
      var mergedList = mergeLists(this.toList(), createList(keys, values), comparator);
      size = this._size + size;
      this._root = sortedListToBST({
        head: mergedList
      }, 0, size);
    }

    return this;
  };

  Tree.prototype.isEmpty = function () {
    return this._root === null;
  };

  Object.defineProperty(Tree.prototype, "size", {
    get: function get() {
      return this._size;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Tree.prototype, "root", {
    get: function get() {
      return this._root;
    },
    enumerable: true,
    configurable: true
  });

  Tree.prototype.toString = function (printNode) {
    if (printNode === void 0) {
      printNode = function printNode(n) {
        return String(n.key);
      };
    }

    var out = [];
    printRow(this._root, '', true, function (v) {
      return out.push(v);
    }, printNode);
    return out.join('');
  };

  Tree.prototype.update = function (key, newKey, newData) {
    var comparator = this._comparator;

    var _a = split(key, this._root, comparator),
        left = _a.left,
        right = _a.right;

    if (comparator(key, newKey) < 0) {
      right = insert(newKey, newData, right, comparator);
    } else {
      left = insert(newKey, newData, left, comparator);
    }

    this._root = merge(left, right, comparator);
  };

  Tree.prototype.split = function (key) {
    return split(key, this._root, this._comparator);
  };

  Tree.prototype[Symbol.iterator] = function () {
    var current, Q, done;
    return __generator$1(this, function (_a) {
      switch (_a.label) {
        case 0:
          current = this._root;
          Q = [];
          done = false;
          _a.label = 1;

        case 1:
          if (!!done) return [3
          /*break*/
          , 6];
          if (!(current !== null)) return [3
          /*break*/
          , 2];
          Q.push(current);
          current = current.left;
          return [3
          /*break*/
          , 5];

        case 2:
          if (!(Q.length !== 0)) return [3
          /*break*/
          , 4];
          current = Q.pop();
          return [4
          /*yield*/
          , current];

        case 3:
          _a.sent();

          current = current.right;
          return [3
          /*break*/
          , 5];

        case 4:
          done = true;
          _a.label = 5;

        case 5:
          return [3
          /*break*/
          , 1];

        case 6:
          return [2
          /*return*/
          ];
      }
    });
  };

  return Tree;
}();

function loadRecursive(keys, values, start, end) {
  var size = end - start;

  if (size > 0) {
    var middle = start + Math.floor(size / 2);
    var key = keys[middle];
    var data = values[middle];
    var node = new Node$2(key, data);
    node.left = loadRecursive(keys, values, start, middle);
    node.right = loadRecursive(keys, values, middle + 1, end);
    return node;
  }

  return null;
}

function createList(keys, values) {
  var head = new Node$2(null, null);
  var p = head;

  for (var i = 0; i < keys.length; i++) {
    p = p.next = new Node$2(keys[i], values[i]);
  }

  p.next = null;
  return head.next;
}

function toList(root) {
  var current = root;
  var Q = [];
  var done = false;
  var head = new Node$2(null, null);
  var p = head;

  while (!done) {
    if (current) {
      Q.push(current);
      current = current.left;
    } else {
      if (Q.length > 0) {
        current = p = p.next = Q.pop();
        current = current.right;
      } else done = true;
    }
  }

  p.next = null; // that'll work even if the tree was empty

  return head.next;
}

function sortedListToBST(list, start, end) {
  var size = end - start;

  if (size > 0) {
    var middle = start + Math.floor(size / 2);
    var left = sortedListToBST(list, start, middle);
    var root = list.head;
    root.left = left;
    list.head = list.head.next;
    root.right = sortedListToBST(list, middle + 1, end);
    return root;
  }

  return null;
}

function mergeLists(l1, l2, compare) {
  var head = new Node$2(null, null); // dummy

  var p = head;
  var p1 = l1;
  var p2 = l2;

  while (p1 !== null && p2 !== null) {
    if (compare(p1.key, p2.key) < 0) {
      p.next = p1;
      p1 = p1.next;
    } else {
      p.next = p2;
      p2 = p2.next;
    }

    p = p.next;
  }

  if (p1 !== null) {
    p.next = p1;
  } else if (p2 !== null) {
    p.next = p2;
  }

  return head.next;
}

function sort(keys, values, left, right, compare) {
  if (left >= right) return;
  var pivot = keys[left + right >> 1];
  var i = left - 1;
  var j = right + 1;

  while (true) {
    do {
      i++;
    } while (compare(keys[i], pivot) < 0);

    do {
      j--;
    } while (compare(keys[j], pivot) > 0);

    if (i >= j) break;
    var tmp = keys[i];
    keys[i] = keys[j];
    keys[j] = tmp;
    tmp = values[i];
    values[i] = values[j];
    values[j] = tmp;
  }

  sort(keys, values, left, j, compare);
  sort(keys, values, j + 1, right, compare);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
/**
 * A bounding box has the format:
 *
 *  { ll: { x: xmin, y: ymin }, ur: { x: xmax, y: ymax } }
 *
 */


var isInBbox = function isInBbox(bbox, point) {
  return bbox.ll.x <= point.x && point.x <= bbox.ur.x && bbox.ll.y <= point.y && point.y <= bbox.ur.y;
};
/* Returns either null, or a bbox (aka an ordered pair of points)
 * If there is only one point of overlap, a bbox with identical points
 * will be returned */


var getBboxOverlap = function getBboxOverlap(b1, b2) {
  // check if the bboxes overlap at all
  if (b2.ur.x < b1.ll.x || b1.ur.x < b2.ll.x || b2.ur.y < b1.ll.y || b1.ur.y < b2.ll.y) return null; // find the middle two X values

  var lowerX = b1.ll.x < b2.ll.x ? b2.ll.x : b1.ll.x;
  var upperX = b1.ur.x < b2.ur.x ? b1.ur.x : b2.ur.x; // find the middle two Y values

  var lowerY = b1.ll.y < b2.ll.y ? b2.ll.y : b1.ll.y;
  var upperY = b1.ur.y < b2.ur.y ? b1.ur.y : b2.ur.y; // put those middle values together to get the overlap

  return {
    ll: {
      x: lowerX,
      y: lowerY
    },
    ur: {
      x: upperX,
      y: upperY
    }
  };
};
/* Javascript doesn't do integer math. Everything is
 * floating point with percision Number.EPSILON.
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/EPSILON
 */


var epsilon = Number.EPSILON; // IE Polyfill

if (epsilon === undefined) epsilon = Math.pow(2, -52);
var EPSILON_SQ = epsilon * epsilon;
/* FLP comparator */

var cmp = function cmp(a, b) {
  // check if they're both 0
  if (-epsilon < a && a < epsilon) {
    if (-epsilon < b && b < epsilon) {
      return 0;
    }
  } // check if they're flp equal


  var ab = a - b;

  if (ab * ab < EPSILON_SQ * a * b) {
    return 0;
  } // normal comparison


  return a < b ? -1 : 1;
};
/**
 * This class rounds incoming values sufficiently so that
 * floating points problems are, for the most part, avoided.
 *
 * Incoming points are have their x & y values tested against
 * all previously seen x & y values. If either is 'too close'
 * to a previously seen value, it's value is 'snapped' to the
 * previously seen value.
 *
 * All points should be rounded by this class before being
 * stored in any data structures in the rest of this algorithm.
 */


var PtRounder = /*#__PURE__*/function () {
  function PtRounder() {
    _classCallCheck(this, PtRounder);

    this.reset();
  }

  _createClass(PtRounder, [{
    key: "reset",
    value: function reset() {
      this.xRounder = new CoordRounder();
      this.yRounder = new CoordRounder();
    }
  }, {
    key: "round",
    value: function round(x, y) {
      return {
        x: this.xRounder.round(x),
        y: this.yRounder.round(y)
      };
    }
  }]);

  return PtRounder;
}();

var CoordRounder = /*#__PURE__*/function () {
  function CoordRounder() {
    _classCallCheck(this, CoordRounder);

    this.tree = new Tree(); // preseed with 0 so we don't end up with values < Number.EPSILON

    this.round(0);
  } // Note: this can rounds input values backwards or forwards.
  //       You might ask, why not restrict this to just rounding
  //       forwards? Wouldn't that allow left endpoints to always
  //       remain left endpoints during splitting (never change to
  //       right). No - it wouldn't, because we snap intersections
  //       to endpoints (to establish independence from the segment
  //       angle for t-intersections).


  _createClass(CoordRounder, [{
    key: "round",
    value: function round(coord) {
      var node = this.tree.add(coord);
      var prevNode = this.tree.prev(node);

      if (prevNode !== null && cmp(node.key, prevNode.key) === 0) {
        this.tree.remove(coord);
        return prevNode.key;
      }

      var nextNode = this.tree.next(node);

      if (nextNode !== null && cmp(node.key, nextNode.key) === 0) {
        this.tree.remove(coord);
        return nextNode.key;
      }

      return coord;
    }
  }]);

  return CoordRounder;
}(); // singleton available by import


var rounder = new PtRounder();
/* Cross Product of two vectors with first point at origin */

var crossProduct = function crossProduct(a, b) {
  return a.x * b.y - a.y * b.x;
};
/* Dot Product of two vectors with first point at origin */


var dotProduct = function dotProduct(a, b) {
  return a.x * b.x + a.y * b.y;
};
/* Comparator for two vectors with same starting point */


var compareVectorAngles = function compareVectorAngles(basePt, endPt1, endPt2) {
  var v1 = {
    x: endPt1.x - basePt.x,
    y: endPt1.y - basePt.y
  };
  var v2 = {
    x: endPt2.x - basePt.x,
    y: endPt2.y - basePt.y
  };
  var kross = crossProduct(v1, v2);
  return cmp(kross, 0);
};

var length = function length(v) {
  return Math.sqrt(dotProduct(v, v));
};
/* Get the sine of the angle from pShared -> pAngle to pShaed -> pBase */


var sineOfAngle = function sineOfAngle(pShared, pBase, pAngle) {
  var vBase = {
    x: pBase.x - pShared.x,
    y: pBase.y - pShared.y
  };
  var vAngle = {
    x: pAngle.x - pShared.x,
    y: pAngle.y - pShared.y
  };
  return crossProduct(vAngle, vBase) / length(vAngle) / length(vBase);
};
/* Get the cosine of the angle from pShared -> pAngle to pShaed -> pBase */


var cosineOfAngle = function cosineOfAngle(pShared, pBase, pAngle) {
  var vBase = {
    x: pBase.x - pShared.x,
    y: pBase.y - pShared.y
  };
  var vAngle = {
    x: pAngle.x - pShared.x,
    y: pAngle.y - pShared.y
  };
  return dotProduct(vAngle, vBase) / length(vAngle) / length(vBase);
};
/* Get the x coordinate where the given line (defined by a point and vector)
 * crosses the horizontal line with the given y coordiante.
 * In the case of parrallel lines (including overlapping ones) returns null. */


var horizontalIntersection = function horizontalIntersection(pt, v, y) {
  if (v.y === 0) return null;
  return {
    x: pt.x + v.x / v.y * (y - pt.y),
    y: y
  };
};
/* Get the y coordinate where the given line (defined by a point and vector)
 * crosses the vertical line with the given x coordiante.
 * In the case of parrallel lines (including overlapping ones) returns null. */


var verticalIntersection = function verticalIntersection(pt, v, x) {
  if (v.x === 0) return null;
  return {
    x: x,
    y: pt.y + v.y / v.x * (x - pt.x)
  };
};
/* Get the intersection of two lines, each defined by a base point and a vector.
 * In the case of parrallel lines (including overlapping ones) returns null. */


var intersection = function intersection(pt1, v1, pt2, v2) {
  // take some shortcuts for vertical and horizontal lines
  // this also ensures we don't calculate an intersection and then discover
  // it's actually outside the bounding box of the line
  if (v1.x === 0) return verticalIntersection(pt2, v2, pt1.x);
  if (v2.x === 0) return verticalIntersection(pt1, v1, pt2.x);
  if (v1.y === 0) return horizontalIntersection(pt2, v2, pt1.y);
  if (v2.y === 0) return horizontalIntersection(pt1, v1, pt2.y); // General case for non-overlapping segments.
  // This algorithm is based on Schneider and Eberly.
  // http://www.cimec.org.ar/~ncalvo/Schneider_Eberly.pdf - pg 244

  var kross = crossProduct(v1, v2);
  if (kross == 0) return null;
  var ve = {
    x: pt2.x - pt1.x,
    y: pt2.y - pt1.y
  };
  var d1 = crossProduct(ve, v1) / kross;
  var d2 = crossProduct(ve, v2) / kross; // take the average of the two calculations to minimize rounding error

  var x1 = pt1.x + d2 * v1.x,
      x2 = pt2.x + d1 * v2.x;
  var y1 = pt1.y + d2 * v1.y,
      y2 = pt2.y + d1 * v2.y;
  var x = (x1 + x2) / 2;
  var y = (y1 + y2) / 2;
  return {
    x: x,
    y: y
  };
};

var SweepEvent = /*#__PURE__*/function () {
  _createClass(SweepEvent, null, [{
    key: "compare",
    // for ordering sweep events in the sweep event queue
    value: function compare(a, b) {
      // favor event with a point that the sweep line hits first
      var ptCmp = SweepEvent.comparePoints(a.point, b.point);
      if (ptCmp !== 0) return ptCmp; // the points are the same, so link them if needed

      if (a.point !== b.point) a.link(b); // favor right events over left

      if (a.isLeft !== b.isLeft) return a.isLeft ? 1 : -1; // we have two matching left or right endpoints
      // ordering of this case is the same as for their segments

      return Segment.compare(a.segment, b.segment);
    } // for ordering points in sweep line order

  }, {
    key: "comparePoints",
    value: function comparePoints(aPt, bPt) {
      if (aPt.x < bPt.x) return -1;
      if (aPt.x > bPt.x) return 1;
      if (aPt.y < bPt.y) return -1;
      if (aPt.y > bPt.y) return 1;
      return 0;
    } // Warning: 'point' input will be modified and re-used (for performance)

  }]);

  function SweepEvent(point, isLeft) {
    _classCallCheck(this, SweepEvent);

    if (point.events === undefined) point.events = [this];else point.events.push(this);
    this.point = point;
    this.isLeft = isLeft; // this.segment, this.otherSE set by factory
  }

  _createClass(SweepEvent, [{
    key: "link",
    value: function link(other) {
      if (other.point === this.point) {
        throw new Error('Tried to link already linked events');
      }

      var otherEvents = other.point.events;

      for (var i = 0, iMax = otherEvents.length; i < iMax; i++) {
        var evt = otherEvents[i];
        this.point.events.push(evt);
        evt.point = this.point;
      }

      this.checkForConsuming();
    }
    /* Do a pass over our linked events and check to see if any pair
     * of segments match, and should be consumed. */

  }, {
    key: "checkForConsuming",
    value: function checkForConsuming() {
      // FIXME: The loops in this method run O(n^2) => no good.
      //        Maintain little ordered sweep event trees?
      //        Can we maintaining an ordering that avoids the need
      //        for the re-sorting with getLeftmostComparator in geom-out?
      // Compare each pair of events to see if other events also match
      var numEvents = this.point.events.length;

      for (var i = 0; i < numEvents; i++) {
        var evt1 = this.point.events[i];
        if (evt1.segment.consumedBy !== undefined) continue;

        for (var j = i + 1; j < numEvents; j++) {
          var evt2 = this.point.events[j];
          if (evt2.consumedBy !== undefined) continue;
          if (evt1.otherSE.point.events !== evt2.otherSE.point.events) continue;
          evt1.segment.consume(evt2.segment);
        }
      }
    }
  }, {
    key: "getAvailableLinkedEvents",
    value: function getAvailableLinkedEvents() {
      // point.events is always of length 2 or greater
      var events = [];

      for (var i = 0, iMax = this.point.events.length; i < iMax; i++) {
        var evt = this.point.events[i];

        if (evt !== this && !evt.segment.ringOut && evt.segment.isInResult()) {
          events.push(evt);
        }
      }

      return events;
    }
    /**
     * Returns a comparator function for sorting linked events that will
     * favor the event that will give us the smallest left-side angle.
     * All ring construction starts as low as possible heading to the right,
     * so by always turning left as sharp as possible we'll get polygons
     * without uncessary loops & holes.
     *
     * The comparator function has a compute cache such that it avoids
     * re-computing already-computed values.
     */

  }, {
    key: "getLeftmostComparator",
    value: function getLeftmostComparator(baseEvent) {
      var _this = this;

      var cache = new Map();

      var fillCache = function fillCache(linkedEvent) {
        var nextEvent = linkedEvent.otherSE;
        cache.set(linkedEvent, {
          sine: sineOfAngle(_this.point, baseEvent.point, nextEvent.point),
          cosine: cosineOfAngle(_this.point, baseEvent.point, nextEvent.point)
        });
      };

      return function (a, b) {
        if (!cache.has(a)) fillCache(a);
        if (!cache.has(b)) fillCache(b);

        var _cache$get = cache.get(a),
            asine = _cache$get.sine,
            acosine = _cache$get.cosine;

        var _cache$get2 = cache.get(b),
            bsine = _cache$get2.sine,
            bcosine = _cache$get2.cosine; // both on or above x-axis


        if (asine >= 0 && bsine >= 0) {
          if (acosine < bcosine) return 1;
          if (acosine > bcosine) return -1;
          return 0;
        } // both below x-axis


        if (asine < 0 && bsine < 0) {
          if (acosine < bcosine) return -1;
          if (acosine > bcosine) return 1;
          return 0;
        } // one above x-axis, one below


        if (bsine < asine) return -1;
        if (bsine > asine) return 1;
        return 0;
      };
    }
  }]);

  return SweepEvent;
}(); // segments and sweep events when all else is identical


var segmentId = 0;

var Segment = /*#__PURE__*/function () {
  _createClass(Segment, null, [{
    key: "compare",

    /* This compare() function is for ordering segments in the sweep
     * line tree, and does so according to the following criteria:
     *
     * Consider the vertical line that lies an infinestimal step to the
     * right of the right-more of the two left endpoints of the input
     * segments. Imagine slowly moving a point up from negative infinity
     * in the increasing y direction. Which of the two segments will that
     * point intersect first? That segment comes 'before' the other one.
     *
     * If neither segment would be intersected by such a line, (if one
     * or more of the segments are vertical) then the line to be considered
     * is directly on the right-more of the two left inputs.
     */
    value: function compare(a, b) {
      var alx = a.leftSE.point.x;
      var blx = b.leftSE.point.x;
      var arx = a.rightSE.point.x;
      var brx = b.rightSE.point.x; // check if they're even in the same vertical plane

      if (brx < alx) return 1;
      if (arx < blx) return -1;
      var aly = a.leftSE.point.y;
      var bly = b.leftSE.point.y;
      var ary = a.rightSE.point.y;
      var bry = b.rightSE.point.y; // is left endpoint of segment B the right-more?

      if (alx < blx) {
        // are the two segments in the same horizontal plane?
        if (bly < aly && bly < ary) return 1;
        if (bly > aly && bly > ary) return -1; // is the B left endpoint colinear to segment A?

        var aCmpBLeft = a.comparePoint(b.leftSE.point);
        if (aCmpBLeft < 0) return 1;
        if (aCmpBLeft > 0) return -1; // is the A right endpoint colinear to segment B ?

        var bCmpARight = b.comparePoint(a.rightSE.point);
        if (bCmpARight !== 0) return bCmpARight; // colinear segments, consider the one with left-more
        // left endpoint to be first (arbitrary?)

        return -1;
      } // is left endpoint of segment A the right-more?


      if (alx > blx) {
        if (aly < bly && aly < bry) return -1;
        if (aly > bly && aly > bry) return 1; // is the A left endpoint colinear to segment B?

        var bCmpALeft = b.comparePoint(a.leftSE.point);
        if (bCmpALeft !== 0) return bCmpALeft; // is the B right endpoint colinear to segment A?

        var aCmpBRight = a.comparePoint(b.rightSE.point);
        if (aCmpBRight < 0) return 1;
        if (aCmpBRight > 0) return -1; // colinear segments, consider the one with left-more
        // left endpoint to be first (arbitrary?)

        return 1;
      } // if we get here, the two left endpoints are in the same
      // vertical plane, ie alx === blx
      // consider the lower left-endpoint to come first


      if (aly < bly) return -1;
      if (aly > bly) return 1; // left endpoints are identical
      // check for colinearity by using the left-more right endpoint
      // is the A right endpoint more left-more?

      if (arx < brx) {
        var _bCmpARight = b.comparePoint(a.rightSE.point);

        if (_bCmpARight !== 0) return _bCmpARight;
      } // is the B right endpoint more left-more?


      if (arx > brx) {
        var _aCmpBRight = a.comparePoint(b.rightSE.point);

        if (_aCmpBRight < 0) return 1;
        if (_aCmpBRight > 0) return -1;
      }

      if (arx !== brx) {
        // are these two [almost] vertical segments with opposite orientation?
        // if so, the one with the lower right endpoint comes first
        var ay = ary - aly;
        var ax = arx - alx;
        var by = bry - bly;
        var bx = brx - blx;
        if (ay > ax && by < bx) return 1;
        if (ay < ax && by > bx) return -1;
      } // we have colinear segments with matching orientation
      // consider the one with more left-more right endpoint to be first


      if (arx > brx) return 1;
      if (arx < brx) return -1; // if we get here, two two right endpoints are in the same
      // vertical plane, ie arx === brx
      // consider the lower right-endpoint to come first

      if (ary < bry) return -1;
      if (ary > bry) return 1; // right endpoints identical as well, so the segments are idential
      // fall back on creation order as consistent tie-breaker

      if (a.id < b.id) return -1;
      if (a.id > b.id) return 1; // identical segment, ie a === b

      return 0;
    }
    /* Warning: a reference to ringWindings input will be stored,
     *  and possibly will be later modified */

  }]);

  function Segment(leftSE, rightSE, rings, windings) {
    _classCallCheck(this, Segment);

    this.id = ++segmentId;
    this.leftSE = leftSE;
    leftSE.segment = this;
    leftSE.otherSE = rightSE;
    this.rightSE = rightSE;
    rightSE.segment = this;
    rightSE.otherSE = leftSE;
    this.rings = rings;
    this.windings = windings; // left unset for performance, set later in algorithm
    // this.ringOut, this.consumedBy, this.prev
  }

  _createClass(Segment, [{
    key: "replaceRightSE",

    /* When a segment is split, the rightSE is replaced with a new sweep event */
    value: function replaceRightSE(newRightSE) {
      this.rightSE = newRightSE;
      this.rightSE.segment = this;
      this.rightSE.otherSE = this.leftSE;
      this.leftSE.otherSE = this.rightSE;
    }
  }, {
    key: "bbox",
    value: function bbox() {
      var y1 = this.leftSE.point.y;
      var y2 = this.rightSE.point.y;
      return {
        ll: {
          x: this.leftSE.point.x,
          y: y1 < y2 ? y1 : y2
        },
        ur: {
          x: this.rightSE.point.x,
          y: y1 > y2 ? y1 : y2
        }
      };
    }
    /* A vector from the left point to the right */

  }, {
    key: "vector",
    value: function vector() {
      return {
        x: this.rightSE.point.x - this.leftSE.point.x,
        y: this.rightSE.point.y - this.leftSE.point.y
      };
    }
  }, {
    key: "isAnEndpoint",
    value: function isAnEndpoint(pt) {
      return pt.x === this.leftSE.point.x && pt.y === this.leftSE.point.y || pt.x === this.rightSE.point.x && pt.y === this.rightSE.point.y;
    }
    /* Compare this segment with a point.
     *
     * A point P is considered to be colinear to a segment if there
     * exists a distance D such that if we travel along the segment
     * from one * endpoint towards the other a distance D, we find
     * ourselves at point P.
     *
     * Return value indicates:
     *
     *   1: point lies above the segment (to the left of vertical)
     *   0: point is colinear to segment
     *  -1: point lies below the segment (to the right of vertical)
     */

  }, {
    key: "comparePoint",
    value: function comparePoint(point) {
      if (this.isAnEndpoint(point)) return 0;
      var lPt = this.leftSE.point;
      var rPt = this.rightSE.point;
      var v = this.vector(); // Exactly vertical segments.

      if (lPt.x === rPt.x) {
        if (point.x === lPt.x) return 0;
        return point.x < lPt.x ? 1 : -1;
      } // Nearly vertical segments with an intersection.
      // Check to see where a point on the line with matching Y coordinate is.


      var yDist = (point.y - lPt.y) / v.y;
      var xFromYDist = lPt.x + yDist * v.x;
      if (point.x === xFromYDist) return 0; // General case.
      // Check to see where a point on the line with matching X coordinate is.

      var xDist = (point.x - lPt.x) / v.x;
      var yFromXDist = lPt.y + xDist * v.y;
      if (point.y === yFromXDist) return 0;
      return point.y < yFromXDist ? -1 : 1;
    }
    /**
     * Given another segment, returns the first non-trivial intersection
     * between the two segments (in terms of sweep line ordering), if it exists.
     *
     * A 'non-trivial' intersection is one that will cause one or both of the
     * segments to be split(). As such, 'trivial' vs. 'non-trivial' intersection:
     *
     *   * endpoint of segA with endpoint of segB --> trivial
     *   * endpoint of segA with point along segB --> non-trivial
     *   * endpoint of segB with point along segA --> non-trivial
     *   * point along segA with point along segB --> non-trivial
     *
     * If no non-trivial intersection exists, return null
     * Else, return null.
     */

  }, {
    key: "getIntersection",
    value: function getIntersection(other) {
      // If bboxes don't overlap, there can't be any intersections
      var tBbox = this.bbox();
      var oBbox = other.bbox();
      var bboxOverlap = getBboxOverlap(tBbox, oBbox);
      if (bboxOverlap === null) return null; // We first check to see if the endpoints can be considered intersections.
      // This will 'snap' intersections to endpoints if possible, and will
      // handle cases of colinearity.

      var tlp = this.leftSE.point;
      var trp = this.rightSE.point;
      var olp = other.leftSE.point;
      var orp = other.rightSE.point; // does each endpoint touch the other segment?
      // note that we restrict the 'touching' definition to only allow segments
      // to touch endpoints that lie forward from where we are in the sweep line pass

      var touchesOtherLSE = isInBbox(tBbox, olp) && this.comparePoint(olp) === 0;
      var touchesThisLSE = isInBbox(oBbox, tlp) && other.comparePoint(tlp) === 0;
      var touchesOtherRSE = isInBbox(tBbox, orp) && this.comparePoint(orp) === 0;
      var touchesThisRSE = isInBbox(oBbox, trp) && other.comparePoint(trp) === 0; // do left endpoints match?

      if (touchesThisLSE && touchesOtherLSE) {
        // these two cases are for colinear segments with matching left
        // endpoints, and one segment being longer than the other
        if (touchesThisRSE && !touchesOtherRSE) return trp;
        if (!touchesThisRSE && touchesOtherRSE) return orp; // either the two segments match exactly (two trival intersections)
        // or just on their left endpoint (one trivial intersection

        return null;
      } // does this left endpoint matches (other doesn't)


      if (touchesThisLSE) {
        // check for segments that just intersect on opposing endpoints
        if (touchesOtherRSE) {
          if (tlp.x === orp.x && tlp.y === orp.y) return null;
        } // t-intersection on left endpoint


        return tlp;
      } // does other left endpoint matches (this doesn't)


      if (touchesOtherLSE) {
        // check for segments that just intersect on opposing endpoints
        if (touchesThisRSE) {
          if (trp.x === olp.x && trp.y === olp.y) return null;
        } // t-intersection on left endpoint


        return olp;
      } // trivial intersection on right endpoints


      if (touchesThisRSE && touchesOtherRSE) return null; // t-intersections on just one right endpoint

      if (touchesThisRSE) return trp;
      if (touchesOtherRSE) return orp; // None of our endpoints intersect. Look for a general intersection between
      // infinite lines laid over the segments

      var pt = intersection(tlp, this.vector(), olp, other.vector()); // are the segments parrallel? Note that if they were colinear with overlap,
      // they would have an endpoint intersection and that case was already handled above

      if (pt === null) return null; // is the intersection found between the lines not on the segments?

      if (!isInBbox(bboxOverlap, pt)) return null; // round the the computed point if needed

      return rounder.round(pt.x, pt.y);
    }
    /**
     * Split the given segment into multiple segments on the given points.
     *  * Each existing segment will retain its leftSE and a new rightSE will be
     *    generated for it.
     *  * A new segment will be generated which will adopt the original segment's
     *    rightSE, and a new leftSE will be generated for it.
     *  * If there are more than two points given to split on, new segments
     *    in the middle will be generated with new leftSE and rightSE's.
     *  * An array of the newly generated SweepEvents will be returned.
     *
     * Warning: input array of points is modified
     */

  }, {
    key: "split",
    value: function split(point) {
      var newEvents = [];
      var alreadyLinked = point.events !== undefined;
      var newLeftSE = new SweepEvent(point, true);
      var newRightSE = new SweepEvent(point, false);
      var oldRightSE = this.rightSE;
      this.replaceRightSE(newRightSE);
      newEvents.push(newRightSE);
      newEvents.push(newLeftSE);
      var newSeg = new Segment(newLeftSE, oldRightSE, this.rings.slice(), this.windings.slice()); // when splitting a nearly vertical downward-facing segment,
      // sometimes one of the resulting new segments is vertical, in which
      // case its left and right events may need to be swapped

      if (SweepEvent.comparePoints(newSeg.leftSE.point, newSeg.rightSE.point) > 0) {
        newSeg.swapEvents();
      }

      if (SweepEvent.comparePoints(this.leftSE.point, this.rightSE.point) > 0) {
        this.swapEvents();
      } // in the point we just used to create new sweep events with was already
      // linked to other events, we need to check if either of the affected
      // segments should be consumed


      if (alreadyLinked) {
        newLeftSE.checkForConsuming();
        newRightSE.checkForConsuming();
      }

      return newEvents;
    }
    /* Swap which event is left and right */

  }, {
    key: "swapEvents",
    value: function swapEvents() {
      var tmpEvt = this.rightSE;
      this.rightSE = this.leftSE;
      this.leftSE = tmpEvt;
      this.leftSE.isLeft = true;
      this.rightSE.isLeft = false;

      for (var i = 0, iMax = this.windings.length; i < iMax; i++) {
        this.windings[i] *= -1;
      }
    }
    /* Consume another segment. We take their rings under our wing
     * and mark them as consumed. Use for perfectly overlapping segments */

  }, {
    key: "consume",
    value: function consume(other) {
      var consumer = this;
      var consumee = other;

      while (consumer.consumedBy) {
        consumer = consumer.consumedBy;
      }

      while (consumee.consumedBy) {
        consumee = consumee.consumedBy;
      }

      var cmp = Segment.compare(consumer, consumee);
      if (cmp === 0) return; // already consumed
      // the winner of the consumption is the earlier segment
      // according to sweep line ordering

      if (cmp > 0) {
        var tmp = consumer;
        consumer = consumee;
        consumee = tmp;
      } // make sure a segment doesn't consume it's prev


      if (consumer.prev === consumee) {
        var _tmp = consumer;
        consumer = consumee;
        consumee = _tmp;
      }

      for (var i = 0, iMax = consumee.rings.length; i < iMax; i++) {
        var ring = consumee.rings[i];
        var winding = consumee.windings[i];
        var index = consumer.rings.indexOf(ring);

        if (index === -1) {
          consumer.rings.push(ring);
          consumer.windings.push(winding);
        } else consumer.windings[index] += winding;
      }

      consumee.rings = null;
      consumee.windings = null;
      consumee.consumedBy = consumer; // mark sweep events consumed as to maintain ordering in sweep event queue

      consumee.leftSE.consumedBy = consumer.leftSE;
      consumee.rightSE.consumedBy = consumer.rightSE;
    }
    /* The first segment previous segment chain that is in the result */

  }, {
    key: "prevInResult",
    value: function prevInResult() {
      if (this._prevInResult !== undefined) return this._prevInResult;
      if (!this.prev) this._prevInResult = null;else if (this.prev.isInResult()) this._prevInResult = this.prev;else this._prevInResult = this.prev.prevInResult();
      return this._prevInResult;
    }
  }, {
    key: "beforeState",
    value: function beforeState() {
      if (this._beforeState !== undefined) return this._beforeState;
      if (!this.prev) this._beforeState = {
        rings: [],
        windings: [],
        multiPolys: []
      };else {
        var seg = this.prev.consumedBy || this.prev;
        this._beforeState = seg.afterState();
      }
      return this._beforeState;
    }
  }, {
    key: "afterState",
    value: function afterState() {
      if (this._afterState !== undefined) return this._afterState;
      var beforeState = this.beforeState();
      this._afterState = {
        rings: beforeState.rings.slice(0),
        windings: beforeState.windings.slice(0),
        multiPolys: []
      };
      var ringsAfter = this._afterState.rings;
      var windingsAfter = this._afterState.windings;
      var mpsAfter = this._afterState.multiPolys; // calculate ringsAfter, windingsAfter

      for (var i = 0, iMax = this.rings.length; i < iMax; i++) {
        var ring = this.rings[i];
        var winding = this.windings[i];
        var index = ringsAfter.indexOf(ring);

        if (index === -1) {
          ringsAfter.push(ring);
          windingsAfter.push(winding);
        } else windingsAfter[index] += winding;
      } // calcualte polysAfter


      var polysAfter = [];
      var polysExclude = [];

      for (var _i = 0, _iMax = ringsAfter.length; _i < _iMax; _i++) {
        if (windingsAfter[_i] === 0) continue; // non-zero rule

        var _ring = ringsAfter[_i];
        var poly = _ring.poly;
        if (polysExclude.indexOf(poly) !== -1) continue;
        if (_ring.isExterior) polysAfter.push(poly);else {
          if (polysExclude.indexOf(poly) === -1) polysExclude.push(poly);

          var _index = polysAfter.indexOf(_ring.poly);

          if (_index !== -1) polysAfter.splice(_index, 1);
        }
      } // calculate multiPolysAfter


      for (var _i2 = 0, _iMax2 = polysAfter.length; _i2 < _iMax2; _i2++) {
        var mp = polysAfter[_i2].multiPoly;
        if (mpsAfter.indexOf(mp) === -1) mpsAfter.push(mp);
      }

      return this._afterState;
    }
    /* Is this segment part of the final result? */

  }, {
    key: "isInResult",
    value: function isInResult() {
      // if we've been consumed, we're not in the result
      if (this.consumedBy) return false;
      if (this._isInResult !== undefined) return this._isInResult;
      var mpsBefore = this.beforeState().multiPolys;
      var mpsAfter = this.afterState().multiPolys;

      switch (operation.type) {
        case 'union':
          {
            // UNION - included iff:
            //  * On one side of us there is 0 poly interiors AND
            //  * On the other side there is 1 or more.
            var noBefores = mpsBefore.length === 0;
            var noAfters = mpsAfter.length === 0;
            this._isInResult = noBefores !== noAfters;
            break;
          }

        case 'intersection':
          {
            // INTERSECTION - included iff:
            //  * on one side of us all multipolys are rep. with poly interiors AND
            //  * on the other side of us, not all multipolys are repsented
            //    with poly interiors
            var least;
            var most;

            if (mpsBefore.length < mpsAfter.length) {
              least = mpsBefore.length;
              most = mpsAfter.length;
            } else {
              least = mpsAfter.length;
              most = mpsBefore.length;
            }

            this._isInResult = most === operation.numMultiPolys && least < most;
            break;
          }

        case 'xor':
          {
            // XOR - included iff:
            //  * the difference between the number of multipolys represented
            //    with poly interiors on our two sides is an odd number
            var diff = Math.abs(mpsBefore.length - mpsAfter.length);
            this._isInResult = diff % 2 === 1;
            break;
          }

        case 'difference':
          {
            // DIFFERENCE included iff:
            //  * on exactly one side, we have just the subject
            var isJustSubject = function isJustSubject(mps) {
              return mps.length === 1 && mps[0].isSubject;
            };

            this._isInResult = isJustSubject(mpsBefore) !== isJustSubject(mpsAfter);
            break;
          }

        default:
          throw new Error("Unrecognized operation type found ".concat(operation.type));
      }

      return this._isInResult;
    }
  }], [{
    key: "fromRing",
    value: function fromRing(pt1, pt2, ring) {
      var leftPt, rightPt, winding; // ordering the two points according to sweep line ordering

      var cmpPts = SweepEvent.comparePoints(pt1, pt2);

      if (cmpPts < 0) {
        leftPt = pt1;
        rightPt = pt2;
        winding = 1;
      } else if (cmpPts > 0) {
        leftPt = pt2;
        rightPt = pt1;
        winding = -1;
      } else throw new Error("Tried to create degenerate segment at [".concat(pt1.x, ", ").concat(pt1.y, "]"));

      var leftSE = new SweepEvent(leftPt, true);
      var rightSE = new SweepEvent(rightPt, false);
      return new Segment(leftSE, rightSE, [ring], [winding]);
    }
  }]);

  return Segment;
}();

var RingIn = /*#__PURE__*/function () {
  function RingIn(geomRing, poly, isExterior) {
    _classCallCheck(this, RingIn);

    if (!Array.isArray(geomRing) || geomRing.length === 0) {
      throw new Error('Input geometry is not a valid Polygon or MultiPolygon');
    }

    this.poly = poly;
    this.isExterior = isExterior;
    this.segments = [];

    if (typeof geomRing[0][0] !== 'number' || typeof geomRing[0][1] !== 'number') {
      throw new Error('Input geometry is not a valid Polygon or MultiPolygon');
    }

    var firstPoint = rounder.round(geomRing[0][0], geomRing[0][1]);
    this.bbox = {
      ll: {
        x: firstPoint.x,
        y: firstPoint.y
      },
      ur: {
        x: firstPoint.x,
        y: firstPoint.y
      }
    };
    var prevPoint = firstPoint;

    for (var i = 1, iMax = geomRing.length; i < iMax; i++) {
      if (typeof geomRing[i][0] !== 'number' || typeof geomRing[i][1] !== 'number') {
        throw new Error('Input geometry is not a valid Polygon or MultiPolygon');
      }

      var point = rounder.round(geomRing[i][0], geomRing[i][1]); // skip repeated points

      if (point.x === prevPoint.x && point.y === prevPoint.y) continue;
      this.segments.push(Segment.fromRing(prevPoint, point, this));
      if (point.x < this.bbox.ll.x) this.bbox.ll.x = point.x;
      if (point.y < this.bbox.ll.y) this.bbox.ll.y = point.y;
      if (point.x > this.bbox.ur.x) this.bbox.ur.x = point.x;
      if (point.y > this.bbox.ur.y) this.bbox.ur.y = point.y;
      prevPoint = point;
    } // add segment from last to first if last is not the same as first


    if (firstPoint.x !== prevPoint.x || firstPoint.y !== prevPoint.y) {
      this.segments.push(Segment.fromRing(prevPoint, firstPoint, this));
    }
  }

  _createClass(RingIn, [{
    key: "getSweepEvents",
    value: function getSweepEvents() {
      var sweepEvents = [];

      for (var i = 0, iMax = this.segments.length; i < iMax; i++) {
        var segment = this.segments[i];
        sweepEvents.push(segment.leftSE);
        sweepEvents.push(segment.rightSE);
      }

      return sweepEvents;
    }
  }]);

  return RingIn;
}();

var PolyIn = /*#__PURE__*/function () {
  function PolyIn(geomPoly, multiPoly) {
    _classCallCheck(this, PolyIn);

    if (!Array.isArray(geomPoly)) {
      throw new Error('Input geometry is not a valid Polygon or MultiPolygon');
    }

    this.exteriorRing = new RingIn(geomPoly[0], this, true); // copy by value

    this.bbox = {
      ll: {
        x: this.exteriorRing.bbox.ll.x,
        y: this.exteriorRing.bbox.ll.y
      },
      ur: {
        x: this.exteriorRing.bbox.ur.x,
        y: this.exteriorRing.bbox.ur.y
      }
    };
    this.interiorRings = [];

    for (var i = 1, iMax = geomPoly.length; i < iMax; i++) {
      var ring = new RingIn(geomPoly[i], this, false);
      if (ring.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = ring.bbox.ll.x;
      if (ring.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = ring.bbox.ll.y;
      if (ring.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = ring.bbox.ur.x;
      if (ring.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = ring.bbox.ur.y;
      this.interiorRings.push(ring);
    }

    this.multiPoly = multiPoly;
  }

  _createClass(PolyIn, [{
    key: "getSweepEvents",
    value: function getSweepEvents() {
      var sweepEvents = this.exteriorRing.getSweepEvents();

      for (var i = 0, iMax = this.interiorRings.length; i < iMax; i++) {
        var ringSweepEvents = this.interiorRings[i].getSweepEvents();

        for (var j = 0, jMax = ringSweepEvents.length; j < jMax; j++) {
          sweepEvents.push(ringSweepEvents[j]);
        }
      }

      return sweepEvents;
    }
  }]);

  return PolyIn;
}();

var MultiPolyIn = /*#__PURE__*/function () {
  function MultiPolyIn(geom, isSubject) {
    _classCallCheck(this, MultiPolyIn);

    if (!Array.isArray(geom)) {
      throw new Error('Input geometry is not a valid Polygon or MultiPolygon');
    }

    try {
      // if the input looks like a polygon, convert it to a multipolygon
      if (typeof geom[0][0][0] === 'number') geom = [geom];
    } catch (ex) {// The input is either malformed or has empty arrays.
      // In either case, it will be handled later on.
    }

    this.polys = [];
    this.bbox = {
      ll: {
        x: Number.POSITIVE_INFINITY,
        y: Number.POSITIVE_INFINITY
      },
      ur: {
        x: Number.NEGATIVE_INFINITY,
        y: Number.NEGATIVE_INFINITY
      }
    };

    for (var i = 0, iMax = geom.length; i < iMax; i++) {
      var poly = new PolyIn(geom[i], this);
      if (poly.bbox.ll.x < this.bbox.ll.x) this.bbox.ll.x = poly.bbox.ll.x;
      if (poly.bbox.ll.y < this.bbox.ll.y) this.bbox.ll.y = poly.bbox.ll.y;
      if (poly.bbox.ur.x > this.bbox.ur.x) this.bbox.ur.x = poly.bbox.ur.x;
      if (poly.bbox.ur.y > this.bbox.ur.y) this.bbox.ur.y = poly.bbox.ur.y;
      this.polys.push(poly);
    }

    this.isSubject = isSubject;
  }

  _createClass(MultiPolyIn, [{
    key: "getSweepEvents",
    value: function getSweepEvents() {
      var sweepEvents = [];

      for (var i = 0, iMax = this.polys.length; i < iMax; i++) {
        var polySweepEvents = this.polys[i].getSweepEvents();

        for (var j = 0, jMax = polySweepEvents.length; j < jMax; j++) {
          sweepEvents.push(polySweepEvents[j]);
        }
      }

      return sweepEvents;
    }
  }]);

  return MultiPolyIn;
}();

var RingOut = /*#__PURE__*/function () {
  _createClass(RingOut, null, [{
    key: "factory",

    /* Given the segments from the sweep line pass, compute & return a series
     * of closed rings from all the segments marked to be part of the result */
    value: function factory(allSegments) {
      var ringsOut = [];

      for (var i = 0, iMax = allSegments.length; i < iMax; i++) {
        var segment = allSegments[i];
        if (!segment.isInResult() || segment.ringOut) continue;
        var prevEvent = null;
        var event = segment.leftSE;
        var nextEvent = segment.rightSE;
        var events = [event];
        var startingPoint = event.point;
        var intersectionLEs = [];
        /* Walk the chain of linked events to form a closed ring */

        while (true) {
          prevEvent = event;
          event = nextEvent;
          events.push(event);
          /* Is the ring complete? */

          if (event.point === startingPoint) break;

          while (true) {
            var availableLEs = event.getAvailableLinkedEvents();
            /* Did we hit a dead end? This shouldn't happen. Indicates some earlier
             * part of the algorithm malfunctioned... please file a bug report. */

            if (availableLEs.length === 0) {
              var firstPt = events[0].point;
              var lastPt = events[events.length - 1].point;
              throw new Error("Unable to complete output ring starting at [".concat(firstPt.x, ",") + " ".concat(firstPt.y, "]. Last matching segment found ends at") + " [".concat(lastPt.x, ", ").concat(lastPt.y, "]."));
            }
            /* Only one way to go, so cotinue on the path */


            if (availableLEs.length === 1) {
              nextEvent = availableLEs[0].otherSE;
              break;
            }
            /* We must have an intersection. Check for a completed loop */


            var indexLE = null;

            for (var j = 0, jMax = intersectionLEs.length; j < jMax; j++) {
              if (intersectionLEs[j].point === event.point) {
                indexLE = j;
                break;
              }
            }
            /* Found a completed loop. Cut that off and make a ring */


            if (indexLE !== null) {
              var intersectionLE = intersectionLEs.splice(indexLE)[0];
              var ringEvents = events.splice(intersectionLE.index);
              ringEvents.unshift(ringEvents[0].otherSE);
              ringsOut.push(new RingOut(ringEvents.reverse()));
              continue;
            }
            /* register the intersection */


            intersectionLEs.push({
              index: events.length,
              point: event.point
            });
            /* Choose the left-most option to continue the walk */

            var comparator = event.getLeftmostComparator(prevEvent);
            nextEvent = availableLEs.sort(comparator)[0].otherSE;
            break;
          }
        }

        ringsOut.push(new RingOut(events));
      }

      return ringsOut;
    }
  }]);

  function RingOut(events) {
    _classCallCheck(this, RingOut);

    this.events = events;

    for (var i = 0, iMax = events.length; i < iMax; i++) {
      events[i].segment.ringOut = this;
    }

    this.poly = null;
  }

  _createClass(RingOut, [{
    key: "getGeom",
    value: function getGeom() {
      // Remove superfluous points (ie extra points along a straight line),
      var prevPt = this.events[0].point;
      var points = [prevPt];

      for (var i = 1, iMax = this.events.length - 1; i < iMax; i++) {
        var _pt = this.events[i].point;
        var _nextPt = this.events[i + 1].point;
        if (compareVectorAngles(_pt, prevPt, _nextPt) === 0) continue;
        points.push(_pt);
        prevPt = _pt;
      } // ring was all (within rounding error of angle calc) colinear points


      if (points.length === 1) return null; // check if the starting point is necessary

      var pt = points[0];
      var nextPt = points[1];
      if (compareVectorAngles(pt, prevPt, nextPt) === 0) points.shift();
      points.push(points[0]);
      var step = this.isExteriorRing() ? 1 : -1;
      var iStart = this.isExteriorRing() ? 0 : points.length - 1;
      var iEnd = this.isExteriorRing() ? points.length : -1;
      var orderedPoints = [];

      for (var _i = iStart; _i != iEnd; _i += step) {
        orderedPoints.push([points[_i].x, points[_i].y]);
      }

      return orderedPoints;
    }
  }, {
    key: "isExteriorRing",
    value: function isExteriorRing() {
      if (this._isExteriorRing === undefined) {
        var enclosing = this.enclosingRing();
        this._isExteriorRing = enclosing ? !enclosing.isExteriorRing() : true;
      }

      return this._isExteriorRing;
    }
  }, {
    key: "enclosingRing",
    value: function enclosingRing() {
      if (this._enclosingRing === undefined) {
        this._enclosingRing = this._calcEnclosingRing();
      }

      return this._enclosingRing;
    }
    /* Returns the ring that encloses this one, if any */

  }, {
    key: "_calcEnclosingRing",
    value: function _calcEnclosingRing() {
      // start with the ealier sweep line event so that the prevSeg
      // chain doesn't lead us inside of a loop of ours
      var leftMostEvt = this.events[0];

      for (var i = 1, iMax = this.events.length; i < iMax; i++) {
        var evt = this.events[i];
        if (SweepEvent.compare(leftMostEvt, evt) > 0) leftMostEvt = evt;
      }

      var prevSeg = leftMostEvt.segment.prevInResult();
      var prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;

      while (true) {
        // no segment found, thus no ring can enclose us
        if (!prevSeg) return null; // no segments below prev segment found, thus the ring of the prev
        // segment must loop back around and enclose us

        if (!prevPrevSeg) return prevSeg.ringOut; // if the two segments are of different rings, the ring of the prev
        // segment must either loop around us or the ring of the prev prev
        // seg, which would make us and the ring of the prev peers

        if (prevPrevSeg.ringOut !== prevSeg.ringOut) {
          if (prevPrevSeg.ringOut.enclosingRing() !== prevSeg.ringOut) {
            return prevSeg.ringOut;
          } else return prevSeg.ringOut.enclosingRing();
        } // two segments are from the same ring, so this was a penisula
        // of that ring. iterate downward, keep searching


        prevSeg = prevPrevSeg.prevInResult();
        prevPrevSeg = prevSeg ? prevSeg.prevInResult() : null;
      }
    }
  }]);

  return RingOut;
}();

var PolyOut = /*#__PURE__*/function () {
  function PolyOut(exteriorRing) {
    _classCallCheck(this, PolyOut);

    this.exteriorRing = exteriorRing;
    exteriorRing.poly = this;
    this.interiorRings = [];
  }

  _createClass(PolyOut, [{
    key: "addInterior",
    value: function addInterior(ring) {
      this.interiorRings.push(ring);
      ring.poly = this;
    }
  }, {
    key: "getGeom",
    value: function getGeom() {
      var geom = [this.exteriorRing.getGeom()]; // exterior ring was all (within rounding error of angle calc) colinear points

      if (geom[0] === null) return null;

      for (var i = 0, iMax = this.interiorRings.length; i < iMax; i++) {
        var ringGeom = this.interiorRings[i].getGeom(); // interior ring was all (within rounding error of angle calc) colinear points

        if (ringGeom === null) continue;
        geom.push(ringGeom);
      }

      return geom;
    }
  }]);

  return PolyOut;
}();

var MultiPolyOut = /*#__PURE__*/function () {
  function MultiPolyOut(rings) {
    _classCallCheck(this, MultiPolyOut);

    this.rings = rings;
    this.polys = this._composePolys(rings);
  }

  _createClass(MultiPolyOut, [{
    key: "getGeom",
    value: function getGeom() {
      var geom = [];

      for (var i = 0, iMax = this.polys.length; i < iMax; i++) {
        var polyGeom = this.polys[i].getGeom(); // exterior ring was all (within rounding error of angle calc) colinear points

        if (polyGeom === null) continue;
        geom.push(polyGeom);
      }

      return geom;
    }
  }, {
    key: "_composePolys",
    value: function _composePolys(rings) {
      var polys = [];

      for (var i = 0, iMax = rings.length; i < iMax; i++) {
        var ring = rings[i];
        if (ring.poly) continue;
        if (ring.isExteriorRing()) polys.push(new PolyOut(ring));else {
          var enclosingRing = ring.enclosingRing();
          if (!enclosingRing.poly) polys.push(new PolyOut(enclosingRing));
          enclosingRing.poly.addInterior(ring);
        }
      }

      return polys;
    }
  }]);

  return MultiPolyOut;
}();
/**
 * NOTE:  We must be careful not to change any segments while
 *        they are in the SplayTree. AFAIK, there's no way to tell
 *        the tree to rebalance itself - thus before splitting
 *        a segment that's in the tree, we remove it from the tree,
 *        do the split, then re-insert it. (Even though splitting a
 *        segment *shouldn't* change its correct position in the
 *        sweep line tree, the reality is because of rounding errors,
 *        it sometimes does.)
 */


var SweepLine = /*#__PURE__*/function () {
  function SweepLine(queue) {
    var comparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Segment.compare;

    _classCallCheck(this, SweepLine);

    this.queue = queue;
    this.tree = new Tree(comparator);
    this.segments = [];
  }

  _createClass(SweepLine, [{
    key: "process",
    value: function process(event) {
      var segment = event.segment;
      var newEvents = []; // if we've already been consumed by another segment,
      // clean up our body parts and get out

      if (event.consumedBy) {
        if (event.isLeft) this.queue.remove(event.otherSE);else this.tree.remove(segment);
        return newEvents;
      }

      var node = event.isLeft ? this.tree.insert(segment) : this.tree.find(segment);
      if (!node) throw new Error("Unable to find segment #".concat(segment.id, " ") + "[".concat(segment.leftSE.point.x, ", ").concat(segment.leftSE.point.y, "] -> ") + "[".concat(segment.rightSE.point.x, ", ").concat(segment.rightSE.point.y, "] ") + 'in SweepLine tree. Please submit a bug report.');
      var prevNode = node;
      var nextNode = node;
      var prevSeg = undefined;
      var nextSeg = undefined; // skip consumed segments still in tree

      while (prevSeg === undefined) {
        prevNode = this.tree.prev(prevNode);
        if (prevNode === null) prevSeg = null;else if (prevNode.key.consumedBy === undefined) prevSeg = prevNode.key;
      } // skip consumed segments still in tree


      while (nextSeg === undefined) {
        nextNode = this.tree.next(nextNode);
        if (nextNode === null) nextSeg = null;else if (nextNode.key.consumedBy === undefined) nextSeg = nextNode.key;
      }

      if (event.isLeft) {
        // Check for intersections against the previous segment in the sweep line
        var prevMySplitter = null;

        if (prevSeg) {
          var prevInter = prevSeg.getIntersection(segment);

          if (prevInter !== null) {
            if (!segment.isAnEndpoint(prevInter)) prevMySplitter = prevInter;

            if (!prevSeg.isAnEndpoint(prevInter)) {
              var newEventsFromSplit = this._splitSafely(prevSeg, prevInter);

              for (var i = 0, iMax = newEventsFromSplit.length; i < iMax; i++) {
                newEvents.push(newEventsFromSplit[i]);
              }
            }
          }
        } // Check for intersections against the next segment in the sweep line


        var nextMySplitter = null;

        if (nextSeg) {
          var nextInter = nextSeg.getIntersection(segment);

          if (nextInter !== null) {
            if (!segment.isAnEndpoint(nextInter)) nextMySplitter = nextInter;

            if (!nextSeg.isAnEndpoint(nextInter)) {
              var _newEventsFromSplit = this._splitSafely(nextSeg, nextInter);

              for (var _i = 0, _iMax = _newEventsFromSplit.length; _i < _iMax; _i++) {
                newEvents.push(_newEventsFromSplit[_i]);
              }
            }
          }
        } // For simplicity, even if we find more than one intersection we only
        // spilt on the 'earliest' (sweep-line style) of the intersections.
        // The other intersection will be handled in a future process().


        if (prevMySplitter !== null || nextMySplitter !== null) {
          var mySplitter = null;
          if (prevMySplitter === null) mySplitter = nextMySplitter;else if (nextMySplitter === null) mySplitter = prevMySplitter;else {
            var cmpSplitters = SweepEvent.comparePoints(prevMySplitter, nextMySplitter);
            mySplitter = cmpSplitters <= 0 ? prevMySplitter : nextMySplitter;
          } // Rounding errors can cause changes in ordering,
          // so remove afected segments and right sweep events before splitting

          this.queue.remove(segment.rightSE);
          newEvents.push(segment.rightSE);

          var _newEventsFromSplit2 = segment.split(mySplitter);

          for (var _i2 = 0, _iMax2 = _newEventsFromSplit2.length; _i2 < _iMax2; _i2++) {
            newEvents.push(_newEventsFromSplit2[_i2]);
          }
        }

        if (newEvents.length > 0) {
          // We found some intersections, so re-do the current event to
          // make sure sweep line ordering is totally consistent for later
          // use with the segment 'prev' pointers
          this.tree.remove(segment);
          newEvents.push(event);
        } else {
          // done with left event
          this.segments.push(segment);
          segment.prev = prevSeg;
        }
      } else {
        // event.isRight
        // since we're about to be removed from the sweep line, check for
        // intersections between our previous and next segments
        if (prevSeg && nextSeg) {
          var inter = prevSeg.getIntersection(nextSeg);

          if (inter !== null) {
            if (!prevSeg.isAnEndpoint(inter)) {
              var _newEventsFromSplit3 = this._splitSafely(prevSeg, inter);

              for (var _i3 = 0, _iMax3 = _newEventsFromSplit3.length; _i3 < _iMax3; _i3++) {
                newEvents.push(_newEventsFromSplit3[_i3]);
              }
            }

            if (!nextSeg.isAnEndpoint(inter)) {
              var _newEventsFromSplit4 = this._splitSafely(nextSeg, inter);

              for (var _i4 = 0, _iMax4 = _newEventsFromSplit4.length; _i4 < _iMax4; _i4++) {
                newEvents.push(_newEventsFromSplit4[_i4]);
              }
            }
          }
        }

        this.tree.remove(segment);
      }

      return newEvents;
    }
    /* Safely split a segment that is currently in the datastructures
     * IE - a segment other than the one that is currently being processed. */

  }, {
    key: "_splitSafely",
    value: function _splitSafely(seg, pt) {
      // Rounding errors can cause changes in ordering,
      // so remove afected segments and right sweep events before splitting
      // removeNode() doesn't work, so have re-find the seg
      // https://github.com/w8r/splay-tree/pull/5
      this.tree.remove(seg);
      var rightSE = seg.rightSE;
      this.queue.remove(rightSE);
      var newEvents = seg.split(pt);
      newEvents.push(rightSE); // splitting can trigger consumption

      if (seg.consumedBy === undefined) this.tree.insert(seg);
      return newEvents;
    }
  }]);

  return SweepLine;
}();

var POLYGON_CLIPPING_MAX_QUEUE_SIZE = typeof process !== 'undefined' && process.env.POLYGON_CLIPPING_MAX_QUEUE_SIZE || 1000000;
var POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS = typeof process !== 'undefined' && process.env.POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS || 1000000;

var Operation = /*#__PURE__*/function () {
  function Operation() {
    _classCallCheck(this, Operation);
  }

  _createClass(Operation, [{
    key: "run",
    value: function run(type, geom, moreGeoms) {
      operation.type = type;
      rounder.reset();
      /* Convert inputs to MultiPoly objects */

      var multipolys = [new MultiPolyIn(geom, true)];

      for (var i = 0, iMax = moreGeoms.length; i < iMax; i++) {
        multipolys.push(new MultiPolyIn(moreGeoms[i], false));
      }

      operation.numMultiPolys = multipolys.length;
      /* BBox optimization for difference operation
       * If the bbox of a multipolygon that's part of the clipping doesn't
       * intersect the bbox of the subject at all, we can just drop that
       * multiploygon. */

      if (operation.type === 'difference') {
        // in place removal
        var subject = multipolys[0];
        var _i = 1;

        while (_i < multipolys.length) {
          if (getBboxOverlap(multipolys[_i].bbox, subject.bbox) !== null) _i++;else multipolys.splice(_i, 1);
        }
      }
      /* BBox optimization for intersection operation
       * If we can find any pair of multipolygons whose bbox does not overlap,
       * then the result will be empty. */


      if (operation.type === 'intersection') {
        // TODO: this is O(n^2) in number of polygons. By sorting the bboxes,
        //       it could be optimized to O(n * ln(n))
        for (var _i2 = 0, _iMax = multipolys.length; _i2 < _iMax; _i2++) {
          var mpA = multipolys[_i2];

          for (var j = _i2 + 1, jMax = multipolys.length; j < jMax; j++) {
            if (getBboxOverlap(mpA.bbox, multipolys[j].bbox) === null) return [];
          }
        }
      }
      /* Put segment endpoints in a priority queue */


      var queue = new Tree(SweepEvent.compare);

      for (var _i3 = 0, _iMax2 = multipolys.length; _i3 < _iMax2; _i3++) {
        var sweepEvents = multipolys[_i3].getSweepEvents();

        for (var _j = 0, _jMax = sweepEvents.length; _j < _jMax; _j++) {
          queue.insert(sweepEvents[_j]);

          if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) {
            // prevents an infinite loop, an otherwise common manifestation of bugs
            throw new Error('Infinite loop when putting segment endpoints in a priority queue ' + '(queue size too big). Please file a bug report.');
          }
        }
      }
      /* Pass the sweep line over those endpoints */


      var sweepLine = new SweepLine(queue);
      var prevQueueSize = queue.size;
      var node = queue.pop();

      while (node) {
        var evt = node.key;

        if (queue.size === prevQueueSize) {
          // prevents an infinite loop, an otherwise common manifestation of bugs
          var seg = evt.segment;
          throw new Error("Unable to pop() ".concat(evt.isLeft ? 'left' : 'right', " SweepEvent ") + "[".concat(evt.point.x, ", ").concat(evt.point.y, "] from segment #").concat(seg.id, " ") + "[".concat(seg.leftSE.point.x, ", ").concat(seg.leftSE.point.y, "] -> ") + "[".concat(seg.rightSE.point.x, ", ").concat(seg.rightSE.point.y, "] from queue. ") + 'Please file a bug report.');
        }

        if (queue.size > POLYGON_CLIPPING_MAX_QUEUE_SIZE) {
          // prevents an infinite loop, an otherwise common manifestation of bugs
          throw new Error('Infinite loop when passing sweep line over endpoints ' + '(queue size too big). Please file a bug report.');
        }

        if (sweepLine.segments.length > POLYGON_CLIPPING_MAX_SWEEPLINE_SEGMENTS) {
          // prevents an infinite loop, an otherwise common manifestation of bugs
          throw new Error('Infinite loop when passing sweep line over endpoints ' + '(too many sweep line segments). Please file a bug report.');
        }

        var newEvents = sweepLine.process(evt);

        for (var _i4 = 0, _iMax3 = newEvents.length; _i4 < _iMax3; _i4++) {
          var _evt = newEvents[_i4];
          if (_evt.consumedBy === undefined) queue.insert(_evt);
        }

        prevQueueSize = queue.size;
        node = queue.pop();
      } // free some memory we don't need anymore


      rounder.reset();
      /* Collect and compile segments we're keeping into a multipolygon */

      var ringsOut = RingOut.factory(sweepLine.segments);
      var result = new MultiPolyOut(ringsOut);
      return result.getGeom();
    }
  }]);

  return Operation;
}(); // singleton available by import


var operation = new Operation();

var union = function union(geom) {
  for (var _len = arguments.length, moreGeoms = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    moreGeoms[_key - 1] = arguments[_key];
  }

  return operation.run('union', geom, moreGeoms);
};

var intersection$1 = function intersection(geom) {
  for (var _len2 = arguments.length, moreGeoms = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    moreGeoms[_key2 - 1] = arguments[_key2];
  }

  return operation.run('intersection', geom, moreGeoms);
};

var xor = function xor(geom) {
  for (var _len3 = arguments.length, moreGeoms = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    moreGeoms[_key3 - 1] = arguments[_key3];
  }

  return operation.run('xor', geom, moreGeoms);
};

var difference = function difference(subjectGeom) {
  for (var _len4 = arguments.length, clippingGeoms = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    clippingGeoms[_key4 - 1] = arguments[_key4];
  }

  return operation.run('difference', subjectGeom, clippingGeoms);
};

var index = {
  union: union,
  intersection: intersection$1,
  xor: xor,
  difference: difference
};

var NBuf3 = /*#__PURE__*/function () {
  function NBuf3(ct) {
    _classCallCheck2(this, NBuf3);

    this.top = 0;
    this.array = new Float32Array(ct);
  }

  _createClass2(NBuf3, [{
    key: "write",
    value: function write(v) {
      this.array[this.top++] = v.x;
      this.array[this.top++] = v.y;
      this.array[this.top++] = v.z;
    }
  }]);

  return NBuf3;
}();

var NBuf2 = /*#__PURE__*/function () {
  function NBuf2(ct) {
    _classCallCheck2(this, NBuf2);

    this.top = 0;
    this.array = new Float32Array(ct);
  }

  _createClass2(NBuf2, [{
    key: "write",
    value: function write(v) {
      this.array[this.top++] = v.x;
      this.array[this.top++] = v.y;
    }
  }]);

  return NBuf2;
}();
/**
 * Holds a node in a BSP tree. A BSP tree is built from a collection of polygons
 * by picking a polygon to split along. That polygon (and all other coplanar
 * polygons) are added directly to that node and the other polygons are added to
 * the front and/or back subtrees. This is not a leafy BSP tree since there is
 * no distinction between internal and leaf nodes.
 */


var Node$3 = /*#__PURE__*/function () {
  function Node$3(polygons) {
    _classCallCheck2(this, Node$3);

    this.plane = null;
    this.front = null;
    this.back = null;
    this.polygons = [];
    if (polygons) this.build(polygons);
  }

  _createClass2(Node$3, [{
    key: "clone",
    value: function clone() {
      var node = new Node$3();
      node.plane = this.plane && this.plane.clone();
      node.front = this.front && this.front.clone();
      node.back = this.back && this.back.clone();
      node.polygons = this.polygons.map(function (p) {
        return p.clone();
      });
      return node;
    } // Convert solid space to empty space and empty space to solid space.

  }, {
    key: "invert",
    value: function invert() {
      for (var _i290 = 0; _i290 < this.polygons.length; _i290++) {
        this.polygons[_i290].flip();
      }

      this.plane && this.plane.flip();
      this.front && this.front.invert();
      this.back && this.back.invert();
      var temp = this.front;
      this.front = this.back;
      this.back = temp;
    } // Recursively remove all polygons in `polygons` that are inside this BSP
    // tree.

  }, {
    key: "clipPolygons",
    value: function clipPolygons(polygons) {
      if (!this.plane) return polygons.slice();
      var front = new Array(),
          back = new Array();

      for (var _i291 = 0; _i291 < polygons.length; _i291++) {
        this.plane.splitPolygon(polygons[_i291], front, back, front, back);
      }

      if (this.front) front = this.front.clipPolygons(front);
      this.back ? back = this.back.clipPolygons(back) : back = [];
      return front.concat(back);
    } // Remove all polygons in this BSP tree that are inside the other BSP tree
    // `bsp`.

  }, {
    key: "clipTo",
    value: function clipTo(bsp) {
      this.polygons = bsp.clipPolygons(this.polygons);
      if (this.front) this.front.clipTo(bsp);
      if (this.back) this.back.clipTo(bsp);
    } // Return a list of all polygons in this BSP tree.

  }, {
    key: "allPolygons",
    value: function allPolygons() {
      var polygons = this.polygons.slice();
      if (this.front) polygons = polygons.concat(this.front.allPolygons());
      if (this.back) polygons = polygons.concat(this.back.allPolygons());
      return polygons;
    } // Build a BSP tree out of `polygons`. When called on an existing tree, the
    // new polygons are filtered down to the bottom of the tree and become new
    // nodes there. Each set of polygons is partitioned using the first polygon
    // (no heuristic is used to pick a good split).

  }, {
    key: "build",
    value: function build(polygons) {
      if (!polygons.length) return;
      if (!this.plane) this.plane = polygons[0].plane.clone();
      var front = [],
          back = [];

      for (var _i292 = 0; _i292 < polygons.length; _i292++) {
        this.plane.splitPolygon(polygons[_i292], this.polygons, this.polygons, front, back);
      }

      if (front.length) {
        if (!this.front) this.front = new Node$3();
        this.front.build(front);
      }

      if (back.length) {
        if (!this.back) this.back = new Node$3();
        this.back.build(back);
      }
    }
  }]);

  return Node$3;
}();
/**
 * Represents a 3D vector.
 */


var Vector$1 = /*#__PURE__*/function () {
  function Vector$1() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck2(this, Vector$1);

    this.x = x;
    this.y = y;
    this.z = z;
  }

  _createClass2(Vector$1, [{
    key: "copy",
    value: function copy(v) {
      this.x = v.x;
      this.y = v.y;
      this.z = v.z;
      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Vector$1(this.x, this.y, this.z);
    }
  }, {
    key: "negate",
    value: function negate() {
      this.x *= -1;
      this.y *= -1;
      this.z *= -1;
      return this;
    }
  }, {
    key: "add",
    value: function add(a) {
      this.x += a.x;
      this.y += a.y;
      this.z += a.z;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(a) {
      this.x -= a.x;
      this.y -= a.y;
      this.z -= a.z;
      return this;
    }
  }, {
    key: "times",
    value: function times(a) {
      this.x *= a;
      this.y *= a;
      this.z *= a;
      return this;
    }
  }, {
    key: "dividedBy",
    value: function dividedBy(a) {
      this.x /= a;
      this.y /= a;
      this.z /= a;
      return this;
    }
  }, {
    key: "lerp",
    value: function lerp(a, t) {
      return this.add(new Vector$1().copy(a).sub(this).times(t));
    }
  }, {
    key: "unit",
    value: function unit() {
      return this.dividedBy(this.length());
    }
  }, {
    key: "length",
    value: function length() {
      return Math.sqrt(Math.pow(this.x, 2) + Math.pow(this.y, 2) + Math.pow(this.z, 2));
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this.unit();
    }
  }, {
    key: "cross",
    value: function cross(b) {
      var a = this.clone();
      var ax = a.x,
          ay = a.y,
          az = a.z;
      var bx = b.x,
          by = b.y,
          bz = b.z;
      this.x = ay * bz - az * by;
      this.y = az * bx - ax * bz;
      this.z = ax * by - ay * bx;
      return this;
    }
  }, {
    key: "dot",
    value: function dot(b) {
      return this.x * b.x + this.y * b.y + this.z * b.z;
    }
  }, {
    key: "toVector3",
    value: function toVector3() {
      return new Vector3(this.x, this.y, this.z);
    }
  }]);

  return Vector$1;
}();
/**
 * Represents a plane in 3D space.
 */


var Plane$2 = /*#__PURE__*/function () {
  function Plane$2(normal, w) {
    _classCallCheck2(this, Plane$2);

    this.normal = normal;
    this.w = w;
    this.normal = normal;
    this.w = w;
  }

  _createClass2(Plane$2, [{
    key: "clone",
    value: function clone() {
      return new Plane$2(this.normal.clone(), this.w);
    }
  }, {
    key: "flip",
    value: function flip() {
      this.normal.negate();
      this.w = -this.w;
    } // Split `polygon` by this plane if needed, then put the polygon or polygon
    // fragments in the appropriate lists. Coplanar polygons go into either
    // `coplanarFront` or `coplanarBack` depending on their orientation with
    // respect to this plane. Polygons in front or in back of this plane go into
    // either `front` or `back`.

  }, {
    key: "splitPolygon",
    value: function splitPolygon(polygon, coplanarFront, coplanarBack, front, back) {
      var COPLANAR = 0;
      var FRONT = 1;
      var BACK = 2;
      var SPANNING = 3; // Classify each point as well as the entire polygon into one of the above
      // four classes.

      var polygonType = 0;
      var types = [];

      for (var _i293 = 0; _i293 < polygon.vertices.length; _i293++) {
        var t = this.normal.dot(polygon.vertices[_i293].pos) - this.w;
        var type = t < -Plane$2.EPSILON ? BACK : t > Plane$2.EPSILON ? FRONT : COPLANAR;
        polygonType |= type;
        types.push(type);
      } // Put the polygon in the correct list, splitting it when necessary.


      switch (polygonType) {
        case COPLANAR:
          (this.normal.dot(polygon.plane.normal) > 0 ? coplanarFront : coplanarBack).push(polygon);
          break;

        case FRONT:
          front.push(polygon);
          break;

        case BACK:
          back.push(polygon);
          break;

        case SPANNING:
          {
            var f = [],
                b = [];

            for (var _i294 = 0; _i294 < polygon.vertices.length; _i294++) {
              var j = (_i294 + 1) % polygon.vertices.length;
              var ti = types[_i294],
                  tj = types[j];
              var vi = polygon.vertices[_i294],
                  vj = polygon.vertices[j];
              if (ti != BACK) f.push(vi);
              if (ti != FRONT) b.push(ti != BACK ? vi.clone() : vi);

              if ((ti | tj) == SPANNING) {
                var _t3 = (this.w - this.normal.dot(vi.pos)) / this.normal.dot(new Vector$1().copy(vj.pos).sub(vi.pos));

                var v = vi.interpolate(vj, _t3);
                f.push(v);
                b.push(v.clone());
              }
            }

            if (f.length >= 3) front.push(new Polygon$1(f, polygon.shared));
            if (b.length >= 3) back.push(new Polygon$1(b, polygon.shared));
            break;
          }
      }
    }
  }], [{
    key: "fromPoints",
    value: function fromPoints(a, b, c) {
      var n = new Vector$1().copy(b).sub(a).cross(new Vector$1().copy(c).sub(a)).normalize();
      return new Plane$2(n.clone(), n.dot(a));
    }
  }]);

  return Plane$2;
}();

Plane$2.EPSILON = 1e-5;
/**
 * Represents a convex polygon. The vertices used to initialize a polygon must
 * be coplanar and form a convex loop. They do not have to be `Vertex`
 * instances but they must behave similarly (duck typing can be used for
 * customization).
 *
 * Each convex polygon has a `shared` property, which is shared between all
 * polygons that are clones of each other or were split from the same polygon.
 * This can be used to define per-polygon properties (such as surface color).
 */

var Polygon$1 = /*#__PURE__*/function () {
  function Polygon$1(vertices, shared) {
    _classCallCheck2(this, Polygon$1);

    this.vertices = vertices;
    this.shared = shared;
    this.plane = Plane$2.fromPoints(vertices[0].pos, vertices[1].pos, vertices[2].pos);
  }

  _createClass2(Polygon$1, [{
    key: "clone",
    value: function clone() {
      return new Polygon$1(this.vertices.map(function (v) {
        return v.clone();
      }), this.shared);
    }
  }, {
    key: "flip",
    value: function flip() {
      this.vertices.reverse().map(function (v) {
        return v.flip();
      });
      this.plane.flip();
    }
  }]);

  return Polygon$1;
}();
/**
 * Represents a vertex of a polygon. Use your own vertex class instead of this
 * one to provide additional features like texture coordinates and vertex
 * colors. Custom vertex classes need to provide a `pos` property and `clone()`,
 * `flip()`, and `interpolate()` methods that behave analogous to the ones
 * defined by `CSG.Vertex`. This class provides `normal` so convenience
 * functions like `CSG.sphere()` can return a smooth vertex normal, but `normal`
 * is not used anywhere else.
 */


var Vertex$1 = /*#__PURE__*/function () {
  function Vertex$1(pos, normal, uv, color) {
    _classCallCheck2(this, Vertex$1);

    this.pos = new Vector$1().copy(pos);
    this.normal = new Vector$1().copy(normal);
    this.uv = new Vector$1().copy(uv);
    this.uv.z = 0;
    color && (this.color = new Vector$1().copy(color));
  }

  _createClass2(Vertex$1, [{
    key: "clone",
    value: function clone() {
      return new Vertex$1(this.pos, this.normal, this.uv, this.color);
    } // Invert all orientation-specific data (e.g. vertex normal). Called when the
    // orientation of a polygon is flipped.

  }, {
    key: "flip",
    value: function flip() {
      this.normal.negate();
    } // Create a new vertex between this vertex and `other` by linearly
    // interpolating all properties using a parameter of `t`. Subclasses should
    // override this to interpolate additional properties.

  }, {
    key: "interpolate",
    value: function interpolate(other, t) {
      return new Vertex$1(this.pos.clone().lerp(other.pos, t), this.normal.clone().lerp(other.normal, t), this.uv.clone().lerp(other.uv, t), this.color && other.color && this.color.clone().lerp(other.color, t));
    }
  }]);

  return Vertex$1;
}();
/**
 * Holds a binary space partition tree representing a 3D solid. Two solids can
 * be combined using the `union()`, `subtract()`, and `intersect()` methods.
 */


var CSG$1 = /*#__PURE__*/function () {
  function CSG$1() {
    _classCallCheck2(this, CSG$1);

    this.polygons = [];
  }

  _createClass2(CSG$1, [{
    key: "clone",
    value: function clone() {
      var csg = new CSG$1();
      csg.polygons = this.polygons.map(function (p) {
        return p.clone();
      }).filter(function (p) {
        return Number.isFinite(p.plane.w);
      });
      return csg;
    }
  }, {
    key: "toPolygons",
    value: function toPolygons() {
      return this.polygons;
    }
  }, {
    key: "union",
    value: function union(csg) {
      var a = new Node$3(this.clone().polygons);
      var b = new Node$3(csg.clone().polygons);
      a.clipTo(b);
      b.clipTo(a);
      b.invert();
      b.clipTo(a);
      b.invert();
      a.build(b.allPolygons());
      return CSG$1.fromPolygons(a.allPolygons());
    }
  }, {
    key: "subtract",
    value: function subtract(csg) {
      var a = new Node$3(this.clone().polygons);
      var b = new Node$3(csg.clone().polygons);
      a.invert();
      a.clipTo(b);
      b.clipTo(a);
      b.invert();
      b.clipTo(a);
      b.invert();
      a.build(b.allPolygons());
      a.invert();
      return CSG$1.fromPolygons(a.allPolygons());
    }
  }, {
    key: "intersect",
    value: function intersect(csg) {
      var a = new Node$3(this.clone().polygons);
      var b = new Node$3(csg.clone().polygons);
      a.invert();
      b.clipTo(a);
      b.invert();
      a.clipTo(b);
      b.clipTo(a);
      a.build(b.allPolygons());
      a.invert();
      return CSG$1.fromPolygons(a.allPolygons());
    } // Return a new CSG solid with solid and empty space switched. This solid is
    // not modified.

  }, {
    key: "inverse",
    value: function inverse() {
      var csg = this.clone();

      var _iterator3 = _createForOfIteratorHelper(csg.polygons),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var p = _step3.value;
          p.flip();
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return csg;
    }
  }, {
    key: "toMesh",
    value: function toMesh(toMatrix, toMaterial) {
      return CSG$1.toMesh(this, toMatrix, toMaterial);
    }
  }, {
    key: "toGeometry",
    value: function toGeometry(toMatrix) {
      return CSG$1.toGeometry(this, toMatrix);
    }
  }], [{
    key: "fromPolygons",
    value: function fromPolygons(polygons) {
      var csg = new CSG$1();
      csg.polygons = polygons;
      return csg;
    }
  }, {
    key: "fromGeometry",
    value: function fromGeometry(geom, objectIndex) {
      var polys = [];
      var posattr = geom.attributes.position;
      var normalattr = geom.attributes.normal;
      var uvattr = geom.attributes.uv;
      var colorattr = geom.attributes.color;
      var grps = geom.groups;
      var index;

      if (geom.index) {
        index = geom.index.array;
      } else {
        index = new Array(posattr.array.length / posattr.itemSize | 0);

        for (var _i295 = 0; _i295 < index.length; _i295++) {
          index[_i295] = _i295;
        }
      }

      var triCount = index.length / 3 | 0;
      polys = new Array(triCount);

      for (var _i296 = 0, pli = 0, l = index.length; _i296 < l; _i296 += 3, pli++) {
        var vertices = new Array(3);

        for (var j = 0; j < 3; j++) {
          var vi = index[_i296 + j];
          var vp = vi * 3;
          var vt = vi * 2;
          var x = posattr.array[vp];
          var y = posattr.array[vp + 1];
          var z = posattr.array[vp + 2];
          var nx = normalattr.array[vp];
          var ny = normalattr.array[vp + 1];
          var nz = normalattr.array[vp + 2];
          var u = uvattr === null || uvattr === void 0 ? void 0 : uvattr.array[vt];
          var v = uvattr === null || uvattr === void 0 ? void 0 : uvattr.array[vt + 1];
          vertices[j] = new Vertex$1(new Vector$1(x, y, z), new Vector$1(nx, ny, nz), new Vector$1(u, v, 0), colorattr && new Vector$1(colorattr.array[vp], colorattr.array[vp + 1], colorattr.array[vp + 2]));
        }

        if (objectIndex === undefined && grps && grps.length > 0) {
          var _iterator4 = _createForOfIteratorHelper(grps),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var grp = _step4.value;

              if (_i296 >= grp.start && _i296 < grp.start + grp.count) {
                polys[pli] = new Polygon$1(vertices, grp.materialIndex);
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        } else {
          polys[pli] = new Polygon$1(vertices, objectIndex);
        }
      }

      return CSG$1.fromPolygons(polys.filter(function (p) {
        return !Number.isNaN(p.plane.normal.x);
      }));
    }
  }, {
    key: "toGeometry",
    value: function toGeometry(csg, toMatrix) {
      var triCount = 0;
      var ps = csg.polygons;

      var _iterator5 = _createForOfIteratorHelper(ps),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var p = _step5.value;
          triCount += p.vertices.length - 2;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      var geom = new BufferGeometry();
      var vertices = new NBuf3(triCount * 3 * 3);
      var normals = new NBuf3(triCount * 3 * 3);
      var uvs = new NBuf2(triCount * 2 * 3);
      var colors;
      var grps = [];
      var dgrp = [];

      var _iterator6 = _createForOfIteratorHelper(ps),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _p = _step6.value;
          var pvs = _p.vertices;
          var pvlen = pvs.length;

          if (_p.shared !== undefined) {
            if (!grps[_p.shared]) grps[_p.shared] = [];
          }

          if (pvlen && pvs[0].color !== undefined) {
            if (!colors) colors = new NBuf3(triCount * 3 * 3);
          }

          for (var j = 3; j <= pvlen; j++) {
            var grp = _p.shared === undefined ? dgrp : grps[_p.shared];
            grp.push(vertices.top / 3, vertices.top / 3 + 1, vertices.top / 3 + 2);
            vertices.write(pvs[0].pos);
            vertices.write(pvs[j - 2].pos);
            vertices.write(pvs[j - 1].pos);
            normals.write(pvs[0].normal);
            normals.write(pvs[j - 2].normal);
            normals.write(pvs[j - 1].normal);

            if (uvs) {
              uvs.write(pvs[0].uv);
              uvs.write(pvs[j - 2].uv);
              uvs.write(pvs[j - 1].uv);
            }

            if (colors) {
              colors.write(pvs[0].color);
              colors.write(pvs[j - 2].color);
              colors.write(pvs[j - 1].color);
            }
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      geom.setAttribute('position', new BufferAttribute(vertices.array, 3));
      geom.setAttribute('normal', new BufferAttribute(normals.array, 3));
      uvs && geom.setAttribute('uv', new BufferAttribute(uvs.array, 2));
      colors && geom.setAttribute('color', new BufferAttribute(colors.array, 3));

      for (var gi = 0; gi < grps.length; gi++) {
        if (grps[gi] === undefined) {
          grps[gi] = [];
        }
      }

      if (grps.length) {
        var _index12 = [];
        var gbase = 0;

        for (var _gi = 0; _gi < grps.length; _gi++) {
          geom.addGroup(gbase, grps[_gi].length, _gi);
          gbase += grps[_gi].length;
          _index12 = _index12.concat(grps[_gi]);
        }

        geom.addGroup(gbase, dgrp.length, grps.length);
        _index12 = _index12.concat(dgrp);
        geom.setIndex(_index12);
      }

      var inv = new Matrix4().copy(toMatrix).invert();
      geom.applyMatrix4(inv);
      geom.computeBoundingSphere();
      geom.computeBoundingBox();
      return geom;
    }
  }, {
    key: "fromMesh",
    value: function fromMesh(mesh, objectIndex) {
      var csg = CSG$1.fromGeometry(mesh.geometry, objectIndex);
      var ttvv0 = new Vector3();
      var tmpm3 = new Matrix3();
      tmpm3.getNormalMatrix(mesh.matrix);

      for (var _i297 = 0; _i297 < csg.polygons.length; _i297++) {
        var p = csg.polygons[_i297];

        for (var j = 0; j < p.vertices.length; j++) {
          var v = p.vertices[j];
          v.pos.copy(ttvv0.copy(v.pos.toVector3()).applyMatrix4(mesh.matrix));
          v.normal.copy(ttvv0.copy(v.normal.toVector3()).applyMatrix3(tmpm3));
        }
      }

      return csg;
    }
  }, {
    key: "toMesh",
    value: function toMesh(csg, toMatrix, toMaterial) {
      var geom = CSG$1.toGeometry(csg, toMatrix);
      var m = new Mesh(geom, toMaterial);
      m.matrix.copy(toMatrix);
      m.matrix.decompose(m.position, m.quaternion, m.scale);
      m.rotation.setFromQuaternion(m.quaternion);
      m.updateMatrixWorld();
      m.castShadow = m.receiveShadow = true;
      return m;
    }
  }, {
    key: "union",
    value: function union(meshA, meshB) {
      var csgA = CSG$1.fromMesh(meshA);
      var csgB = CSG$1.fromMesh(meshB);
      return CSG$1.toMesh(csgA.union(csgB), meshA.matrix, meshA.material);
    }
  }, {
    key: "subtract",
    value: function subtract(meshA, meshB) {
      var csgA = CSG$1.fromMesh(meshA);
      var csgB = CSG$1.fromMesh(meshB);
      return CSG$1.toMesh(csgA.subtract(csgB), meshA.matrix, meshA.material);
    }
  }, {
    key: "intersect",
    value: function intersect(meshA, meshB) {
      var csgA = CSG$1.fromMesh(meshA);
      var csgB = CSG$1.fromMesh(meshB);
      return CSG$1.toMesh(csgA.intersect(csgB), meshA.matrix, meshA.material);
    }
  }]);

  return CSG$1;
}();

var unify = function unify(meshA, meshB) {
  // Ensure matrices of the meshes are updated
  meshA.updateMatrix();
  meshB.updateMatrix();
  return CSG$1.union(meshA, meshB);
};

var subtract = function subtract(meshA, meshB) {
  // Ensure matrices of the meshes are updated
  meshA.updateMatrix();
  meshB.updateMatrix();
  return CSG$1.subtract(meshA, meshB);
};

var intersect = function intersect(meshA, meshB) {
  // Ensure matrices of the meshes are updated
  meshA.updateMatrix();
  meshB.updateMatrix();
  return CSG$1.intersect(meshA, meshB);
};
/**
 * This function performs the union of a list of triangles,
 * producing a polygon as a result.
 * The input triangles are in 3D, meaning that each vertex is
 * in the form [x,y,z]. However, the union is performed on 2D
 * triangles, i.e. in the form [x,y].
 * In this case the triangles must be projected onto the XZ-plane,
 * i.e. the horizontal plane. That's why we extract the x- and
 * z-coordinate from the 3D triangle to convert the 3D triangle
 * to a 2D triangle.
 *
 * @param   triangles The list of 3D triangles to unify
 * @return  The polygon resulting form the union of the input triangles
 */


var unifyTriangles = function unifyTriangles(triangles) {
  try {
    var trianglesUnion_1;
    triangles.forEach(function (t) {
      // Extract x- and z-coordinates for each vertex
      // and format the triangle for 2D polygon operation
      var trianglePolygon = [[[t.a.x, t.a.z], [t.b.x, t.b.z], [t.c.x, t.c.z]]]; // Add the triangle to the union

      if (!trianglesUnion_1) {
        trianglesUnion_1 = trianglePolygon;
      } else {
        trianglesUnion_1 = index.union(trianglesUnion_1, trianglePolygon);
      }
    });
    return trianglesUnion_1;
  } catch (e) {
    throw Error("Could not perform union on " + triangles.length + " triangles: " + e);
  }
};
/**
 * This class provides functions to process, compute or extract geometric features
 */


var GeometryHandler =
/** @class */
function () {
  function GeometryHandler(logFunction) {
    var _this = this;

    this.SCALE_FACTOR = 0.0001;
    this.MINIMUM_FLOOR_INCLINATION_DEG = 135;
    this.MAXIMUM_ROOF_INCLINATION_DEG = 90;
    /**
     * PVG is the helper primitive to represent the terrain.
     * It results from the union of all primitives classified as GRUNDSTUCK.
     *
     * @param data Stores the classified primitives
     */

    this.createPVG = function (data) {
      _this.logFunction('Computing PVG...');

      var unionGrundstuckMeshes = null;
      data.grundstuck.primitives.forEach(function (p) {
        if (unionGrundstuckMeshes === null) {
          unionGrundstuckMeshes = p.mesh.clone();
        } else {
          var result = unify(unionGrundstuckMeshes, p.mesh);
          unionGrundstuckMeshes = result;
        }
      });
      var meshMaterial = new MeshBasicMaterial({
        color: ColorPalette.TERRAIN
      });
      unionGrundstuckMeshes.material = meshMaterial;

      var annotatedPVG = _this.createHelperPrimitive('PVG', unionGrundstuckMeshes);

      return annotatedPVG;
    };
    /**
     * PTS is the helper primitive to represent the terrain surface.
     * It results by subtracting the slightly vertically terrain primitive (PVG)
     * and the original PVG.
     * The resulting primitive (PTS) will be as high as the vertical translation.
     *
     * @param data Stores the helper primitives, including PVG
     */


    this.createPTS = function (data) {
      _this.logFunction('Computing PTS...');

      var PVG = data.helperPrimitives.PVG.mesh; // Duplicate the terrain

      var verticallyTranslatedPVG = PVG.clone(); // Move it up

      verticallyTranslatedPVG.translateY(0.05); // Intersect it with terrain

      var PTS = subtract(verticallyTranslatedPVG, PVG);
      var meshMaterial = new MeshBasicMaterial({
        color: ColorPalette.ORANGE
      });
      PTS.material = meshMaterial;

      var annotatedPTS = _this.createHelperPrimitive('PTS', PTS);

      return annotatedPTS;
    };
    /**
     * BP is the helper primitive to represent the entire building(s).
     * It results from the union of all primitives classified as GESCHOSSE.
     *
     * @param data Stores the classified primitives
     */


    this.createBP = function (data) {
      _this.logFunction('Computing BP...');

      var unionGeschossMeshes = null;
      data.geschosse.primitives.forEach(function (p) {
        if (unionGeschossMeshes === null) {
          unionGeschossMeshes = p.mesh.clone();
        } else {
          var result = unify(unionGeschossMeshes, p.mesh);
          unionGeschossMeshes = result;
        }
      });
      var meshMaterial = new MeshBasicMaterial({
        color: ColorPalette.GESCHOSSE
      });
      unionGeschossMeshes.material = meshMaterial;
      var wireframeGeometry = new WireframeGeometry(unionGeschossMeshes.geometry);
      var wireframeMaterial = new LineBasicMaterial({
        color: 0x0000ff
      });
      var wireframe = new LineSegments(wireframeGeometry, wireframeMaterial);
      unionGeschossMeshes.add(wireframe);

      var annotatedBP = _this.createHelperPrimitive('BP', unionGeschossMeshes);

      return annotatedBP;
    };
    /**
     * PGGF is the helper primitive to represent the footprint of the building(s)
     * It results by intersecting BP with the slightly vertically translated
     * terrain surface (PTS).
     * The resulting primitive (PGGF) will be as high as the vertical translation.
     *
     * @param data Stores the needed helper primitives
     */


    this.createPGGF = function (data) {
      _this.logFunction('Computing PGGF...'); // Duplicate the terrain


      var verticallyTranslatedPTS = data.helperPrimitives.PTS.mesh.clone(); // Move it up 10 cm

      verticallyTranslatedPTS.translateY(0.1); // Intersect the building with shifted terrain surface, resulting section 10cm above the terrain

      var PGGF = intersect(data.helperPrimitives.BP.mesh, verticallyTranslatedPTS);
      var meshMaterial = new MeshBasicMaterial({
        color: ColorPalette.VOLUMEN
      });
      PGGF.material = meshMaterial;
      var wireframeGeometry = new WireframeGeometry(PGGF.geometry);
      var wireframeMaterial = new LineBasicMaterial({
        color: 0x0000ff
      });
      var wireframe = new LineSegments(wireframeGeometry, wireframeMaterial);
      PGGF.add(wireframe);

      var annotatedPGGF = _this.createHelperPrimitive('PGGF', PGGF);

      return annotatedPGGF;
    };
    /**
     * BPU is the helper primitive to represent the underground part of the building(s)
     * It results by intersecting the slightly vertically translated BP with the
     * terrain primitive (PVG).
     *
     * @param data Stores the needed helper primitives
     */


    this.createBPU = function (data) {
      _this.logFunction('Computing BPU...'); // Duplicate the building volume


      var verticallyTranslatedBP = data.helperPrimitives.BP.mesh.clone(); // Move it down

      verticallyTranslatedBP.translateY(-0.05); // Intersect the shifted building with terrain, resulting section 5cm under the terrain

      var BPU = intersect(verticallyTranslatedBP, data.helperPrimitives.PVG.mesh); // section 5cm under the terrain

      var meshMaterial = new MeshBasicMaterial({
        color: ColorPalette.GREEN
      });
      BPU.material = meshMaterial;
      var wireframeGeometry = new WireframeGeometry(BPU.geometry);
      var wireframeMaterial = new LineBasicMaterial({
        color: 0x0000ff
      });
      var wireframe = new LineSegments(wireframeGeometry, wireframeMaterial);
      BPU.add(wireframe);

      var annotatedBPU = _this.createHelperPrimitive('BPU', BPU);

      return annotatedBPU;
    };

    this.createHelperPrimitive = function (id, mesh) {
      var triangles = _this.getTriangles(mesh); // Not all the helper primitives need a real projected area


      var realProjectedArea = -1;

      try {
        realProjectedArea = _this.computeRealProjectedArea(triangles);
      } catch (e) {
        console.warn("Projected area could be calculated for helper primitive " + id + ". Error: ", e);
      }

      var helperPrimitive = {
        id: id,
        mesh: mesh,
        triangles: triangles,
        realProjectedArea: realProjectedArea
      };
      return helperPrimitive;
    };

    this.computeVolume = function (mesh) {
      var geometry = mesh.geometry;
      var CORRECTION_FACTOR = 1000;
      return ThreeVolume(geometry) * CORRECTION_FACTOR;
    };

    this.logFunction = logFunction !== null && logFunction !== void 0 ? logFunction : function (arg) {
      return console.log("" + arg);
    };
  }
  /**
   * This function returns the bounding box BB
   * (https://en.wikipedia.org/wiki/Minimum_bounding_box)
   * of a given mesh
   *
   * @param mesh The input mesh to compute the bounding box
   */


  GeometryHandler.prototype.getMeshBoundingBox = function (mesh) {
    var bb = new Box3();
    mesh.geometry.computeBoundingBox();
    bb.copy(mesh.geometry.boundingBox).applyMatrix4(mesh.matrixWorld);
    return bb;
  };
  /**
   * This function returns the bounding sphere of a given mesh
   *
   * @param mesh The input mesh to compute the bounding sphere
   */


  GeometryHandler.prototype.getMeshBoundingSphere = function (mesh) {
    var bs = new Sphere();
    mesh.geometry.computeBoundingSphere();
    bs.copy(mesh.geometry.boundingSphere).applyMatrix4(mesh.matrixWorld);
    return bs;
  };

  GeometryHandler.prototype.computeExtraGeometry = function (meshes) {
    var _this = this;

    this.logFunction('Compute Extra Geometry');
    var extra = new Map(); // Triangles

    meshes.forEach(function (mesh, key) {
      // Triangles of the primitive mesh
      var triangles = _this.getTriangles(mesh); // Real projected area of the primitive


      var realProjectedArea = _this.computeRealProjectedArea(triangles);

      _this.logFunction(realProjectedArea); // Floor area of the primitive


      var floorArea = _this.computeFloorArea(triangles);

      _this.logFunction(floorArea);

      extra.set(key, {
        triangles: triangles,
        realProjectedArea: realProjectedArea,
        floorArea: floorArea
      });
    });
    return extra;
  };

  GeometryHandler.prototype.getTriangles = function (mesh) {
    this.logFunction('Compute Triangles for given Mesh');
    var geometry = mesh.geometry;
    var positionAttr = geometry.attributes.position;
    var indexAttr = geometry.getIndex();
    var triangles = [];
    var positions = positionAttr.array;
    var indices; // If mesh is not indexed, create one

    if (!indexAttr) {
      var indexAttribute = [];

      for (var q = 0; q < positions.length / 3; q++) {
        indexAttribute.push(q);
      }

      indices = indexAttribute;
    } else {
      indices = indexAttr.array;
    }

    for (var i = 0; i < indices.length; i += 3) {
      var v1 = new Vector3().fromArray(positions, indices[i] * 3);
      var v2 = new Vector3().fromArray(positions, indices[i + 1] * 3);
      var v3 = new Vector3().fromArray(positions, indices[i + 2] * 3);
      var triangle = new Triangle(v1, v2, v3);
      triangles.push(triangle);
    }

    return triangles;
  };

  GeometryHandler.prototype.computeRealProjectedArea = function (triangles) {
    this.logFunction('Computing real projected area'); // Project triangles on horizontal plane (i.e. y = 0)

    var projectedTriangles = this.projectTrianglesHorizontally(triangles); // Merge triangles and compute their total area

    try {
      var triangleUnion = unifyTriangles(projectedTriangles);
      var area = this.computeMultiPolygonArea(triangleUnion);
      return area;
    } catch (e) {
      console.warn('Could not compute triangle union: ', e);
      return 0;
    }
  };

  GeometryHandler.prototype.computeFloorArea = function (triangles) {
    var _this = this;

    this.logFunction('Computing floor area'); // Detect relevant triangles for floor area

    var trianglesWithinMinimumInclination = triangles.filter(function (t) {
      return _this.evaluateTriangleForFloorInclination(t);
    });
    return this.computeTrianglesArea(trianglesWithinMinimumInclination);
  };
  /**
   * Function to compute the area of all triangles classified as roof.
   *
   * @param triangles List of triangles
   */


  GeometryHandler.prototype.computeRoofArea = function (triangles) {
    var _this = this;

    this.logFunction('Computing roof area'); // Detect relevant triangles for roof area

    var trianglesWithinMaximumInclination = triangles.filter(function (t) {
      return _this.evaluateTriangleForRoofInclination(t);
    });
    return this.computeTrianglesArea(trianglesWithinMaximumInclination);
  };

  GeometryHandler.prototype.computeTrianglesArea = function (triangles) {
    var area = 0;
    triangles.forEach(function (t) {
      area += t.getArea();
    });
    return area;
  };
  /**
   * Evaluates the inclination of a triangle by comparing the angle between
   * the triangle's normal (n) and the coordinate system vertical axis (Y).
   * The triangle is evaluated as true, i.e. classified as floor,
   * if this angle is bigger than the minimum inclination specified.
   *
   * @param triangle The triangle to evaluate
   */


  GeometryHandler.prototype.evaluateTriangleForFloorInclination = function (triangle) {
    var n = new Vector3();
    triangle.getNormal(n);
    var verticalAxis = new Vector3(0, 1, 0);
    var angleNYRad = n.angleTo(verticalAxis);
    var angleNY = this.rad2deg(angleNYRad);
    return angleNY >= this.MINIMUM_FLOOR_INCLINATION_DEG;
  };
  /**
   * Evaluates the inclination of a triangle by comparing the angle between
   * the triangle's normal (n) and the coordinate system vertical axis (Y).
   * The triangle is evaluated as true, i.e. classified as roof,
   * if this angle is smaller than the maximum inclination specified.
   *
   * @param triangle The triangle to evaluate
   */


  GeometryHandler.prototype.evaluateTriangleForRoofInclination = function (triangle) {
    var n = new Vector3();
    triangle.getNormal(n);
    var verticalAxis = new Vector3(0, 1, 0);
    var angleNYRad = n.angleTo(verticalAxis);
    var angleNY = this.rad2deg(angleNYRad);
    return angleNY < this.MAXIMUM_ROOF_INCLINATION_DEG;
  };
  /**
   * Converts an angle in radians to degrees
   *
   * @param radAngle The angle in radians
   */


  GeometryHandler.prototype.rad2deg = function (radAngle) {
    return radAngle * (180 / Math.PI);
  };
  /**
   * Projects a list of triangles onto the horizontal plane,
   * i.e. xz-plane, by setting the y-coordinate of each vertex
   * to zero.
   *
   * @param triangles The list of triangles ot project
   */


  GeometryHandler.prototype.projectTrianglesHorizontally = function (triangles) {
    var _this = this;

    this.logFunction("Projecting " + triangles.length + " triangles to XZ (horizontal) plane");
    return triangles.map(function (t) {
      return _this.projectTriangleOnXZPlane(t);
    });
  };

  GeometryHandler.prototype.projectTriangleOnXZPlane = function (triangle) {
    var v0XZ = new Vector3(triangle.a.x, 0, triangle.a.z);
    var v1XZ = new Vector3(triangle.b.x, 0, triangle.b.z);
    var v2XZ = new Vector3(triangle.c.x, 0, triangle.c.z);
    var triangleXZ = new Triangle(v0XZ, v1XZ, v2XZ);
    return triangleXZ;
  };
  /**
   * Creates a THREEjs triangle object from a list of vertices.
   * Each vertex is provided as 3-elements-array.
   *
   * @param geometryElements The list of vertices
   */


  GeometryHandler.prototype.getTriangle = function (geometryElements) {
    var vertices = [];

    for (var i = 0; i < geometryElements.length; i++) {
      var coordinates = geometryElements[i];

      if (coordinates.length === 3) {
        var vertex = new Vector3(coordinates[0], coordinates[1], coordinates[2]);
        vertices.push(vertex);
      } else {
        console.warn('Vertex coordinates to build a triangle must be 3D.');
      }
    }

    if (vertices.length !== 3) {
      console.warn("A triangle must have 3 vertices, found " + vertices.length + " instead.");
      return null;
    }

    var triangle = new Triangle(vertices[0], vertices[1], vertices[2]);
    return triangle;
  };

  GeometryHandler.prototype.computeMultiPolygonArea = function (multiPolygon) {
    if (!multiPolygon) {
      return 0;
    }

    var AAA = 0;

    for (var u = 0; u < multiPolygon.length; u++) {
      for (var v = 0; v < multiPolygon[u].length; v++) {
        AAA = AAA + this.computePolygonArea(multiPolygon[u][v]);
      }
    }

    var area = Math.abs(AAA);
    return area;
  };

  GeometryHandler.prototype.computePolygonArea = function (polygon) {
    var e0 = [0, 0];
    var e1 = [0, 0];
    var area = 0;
    var first = polygon[0];
    var l = polygon.length;

    for (var i = 2; i < l; i++) {
      var p = polygon[i - 1];
      var c = polygon[i];
      e0[0] = first[0] - c[0];
      e0[1] = first[1] - c[1];
      e1[0] = first[0] - p[0];
      e1[1] = first[1] - p[1];
      area += e0[0] * e1[1] - e0[1] * e1[0];
    }

    return area / 2;
  };

  return GeometryHandler;
}();

var calculateHULLE = function calculateHULLE(bp, logFunction) {
  var triangles = bp.triangles;
  var geometryHandler = new GeometryHandler(logFunction);
  var HULLE = geometryHandler.computeTrianglesArea(triangles);
  return Math.round(HULLE);
};

var calculateBODENPLATTE = function calculateBODENPLATTE(bpu, logFunction) {
  var triangles = bpu.triangles;
  var geometryHandler = new GeometryHandler(logFunction);
  var BODENPLATTE = geometryHandler.computeFloorArea(triangles);
  return Math.round(BODENPLATTE);
};

var calculateDACH = function calculateDACH(bp, logFunction) {
  var triangles = bp.triangles;
  var geometryHandler = new GeometryHandler(logFunction);
  var DACH = geometryHandler.computeRoofArea(triangles);
  return Math.round(DACH);
};

var calculateWAND = function calculateWAND(hulle, dach, bodenplatte) {
  return Math.round(hulle - dach - bodenplatte);
};

var DEFAULT_FLOOR_HEIGHT = 3;

var computeFloorHeight = function computeFloorHeight(currentFloor, nextFloor) {
  var currentFloorElevation = currentFloor.elevation;
  var nextFloorElevation = nextFloor.elevation;

  if (currentFloorElevation && nextFloorElevation) {
    var CONVERSION_FACTOR = 1000;
    var height = Math.abs(nextFloorElevation - currentFloorElevation);
    var tmpHeight = height / CONVERSION_FACTOR; // Take measurement unit in consideration

    if (tmpHeight < 0.1) {
      return tmpHeight * CONVERSION_FACTOR;
    } else {
      return tmpHeight;
    }
  }

  return DEFAULT_FLOOR_HEIGHT;
};

var accumulateAreaForFloors = function accumulateAreaForFloors(floors) {
  var totalArea = 0;
  floors.forEach(function (f) {
    totalArea += f.area;
  });
  return totalArea;
};

var calculateGSF = function calculateGSF(pvg) {
  return Math.round(pvg.realProjectedArea);
};

var calculateGGF = function calculateGGF(pggf) {
  return Math.round(pggf.realProjectedArea);
};

var calculateUF = function calculateUF(gsf, ggf, x) {
  return Math.round(gsf - ggf - x);
};

var calculateBUF = function calculateBUF(uf, uufTmp) {
  return uf - uufTmp;
};

var calculateUUFtmp = function calculateUUFtmp(grundstucke) {
  var UUFtmp = 0;
  grundstucke.forEach(function (grundstuck) {
    var crbCode = grundstuck.crbCode;

    if (crbCode === CRB_CODE_DE.UUF) {
      UUFtmp += grundstuck.realProjectedArea;
    }
  });
  return Math.round(UUFtmp);
};

var calculateUUF = function calculateUUF(uf, buf) {
  return uf - buf;
};

var calculateGF = function calculateGF(geschosse) {
  var GF = 0;
  geschosse.forEach(function (geschoss) {
    GF += geschoss.floorArea;
  });
  return Math.round(GF);
};

var calculateGV = function calculateGV(bp) {
  var mesh = bp.mesh;
  var geometryHandler = new GeometryHandler();
  var GV = geometryHandler.computeVolume(mesh);
  return Math.round(GV);
};

var accumulateFloorArea = function accumulateFloorArea(primitives) {
  var totalArea = 0;
  primitives.forEach(function (p) {
    var area = 'floorArea' in p ? p.floorArea : p.geometry.quantities.floorArea;
    totalArea += area;
  });
  return Math.round(totalArea);
};

var accumulateVolume = function accumulateVolume(inneraumen) {
  var totalVolume = 0;
  var geometryHandler = new GeometryHandler();
  inneraumen.forEach(function (innenraum) {
    totalVolume += geometryHandler.computeVolume(innenraum.mesh);
  });
  return Math.round(totalVolume);
};
/**
 * 3.2.7 NGF Nettogeschossfläche
 * Sum of floor area of primitives with code
 * «NGF» and «NF» and «VF» and «FF»
 * and «HNF» and «NNF» and «MUAH»
 *
 * @param ngfTmp    Temporary Nettogeschossfläche, i.e. accumulated floor area of NGF-innenraumen
 * @param nfTmp     Temporary Nutzfläche, i.e. accumulated floor area of NF-innenraumen
 * @param vf
 * @param ff
 * @param hnfTmp    Temporary Hauptnutzfläche, i.e. accumulated floor area of HNF-innenraumen
 * @param nnf
 * @param muah
 */


var calculateNGF = function calculateNGF(ngfTmp, nfTmp, vf, ff, hnfTmp, nnf, muah) {
  return ngfTmp + nfTmp + vf + ff + hnfTmp + nnf + muah;
};
/**
 * 3.2.8 KF Konstruktionsfläche
 * If NGF Nettogeschossfläche > 0
 * Then GF Geschossfläche – NGF Nettogeschossfläche
 * Else No result (0)
 *
 * @param ngf   Nettogeschossfläche
 * @param gf    Geschossfläche
 */


var calculateKF = function calculateKF(ngf, gf) {
  if (ngf > 0) {
    return gf - ngf;
  } else {
    return 0;
  }
};
/**
 * 3.2.9 NF Nutzfläche
 * If no primitive in class «Innenräumen» with code «NF» or «HNF» or «NNF» or «MUAH»
 * Then
 * If no primitive in class «Innenräumen» with code «VF» or «FF»
 *     Then
 *         No result (0)
 *     Else
 *         If no primitive in class «Innenräumen» with code «NGF»
 *             Then
 *                 No result (0)
 *             Else
 * (Sum of floor area of primitives with code NGF) - (sum of floor area or primitives with codes «VF» and «FF»)
 * Else
 * Sum of floor area or primitives with code «NF» and «HNF» and «NNF» and «MUAH»
 *
 * @param nfTmp     Temporary Nutzfläche, i.e. accumulated floor area of NF-innenraumen
 * @param hnfTmp    Temporary Hauptnutzfläche, i.e. accumulated floor area of HNF-innenraumen
 * @param nnf
 * @param muah
 * @param ngf       Nettogeschossfläche
 * @param vf
 * @param ff
 */


var calculateNF = function calculateNF(nfTmp, hnfTmp, nnf, muah, ngf, vf, ff) {
  var NF = nfTmp + hnfTmp + nnf + muah;

  if (NF === 0) {
    NF = ngf - vf - ff;
  }

  return NF;
};
/**
 * 3.2.10 HNF Hauptnutzfläche
 * Sum of floor area of primitives with code
 * «HNF» and «MUAH»
 *
 * @param hnfTmp    Temporary Hauptnutzfläche, i.e. accumulated floor area of HNF-innenraumen
 * @param muah
 */


var calculateHNF = function calculateHNF(hnfTmp, muah) {
  return hnfTmp + muah;
};
/**
 * 3.2.15 NGV Nettogebäudevolumen
 * Sum of volumes of primitives with code
 * «NGF» and «NF» and «VF»
 * and «FF» and «HNF» and «NNF» and «MUAH»
 *
 * @param ngvTmp    Temporary Nettogebäudevolumen, i.e. accumulated volume of NGF-innenraumen
 * @param nvTmp     Temporary Nutzvolumen, i.e. accumulated volume of NF-innenraumen
 * @param vv
 * @param fv
 * @param hnvTmp    Temporary Hauptnutzvolumen, i.e. accumulated volume of HNF-innenraumen
 * @param nnv
 * @param muah
 */


var calculateNGV = function calculateNGV(ngvTmp, nvTmp, vv, fv, hnvTmp, nnv, muahv) {
  return ngvTmp + nvTmp + vv + fv + hnvTmp + nnv + muahv;
};
/**
 * 3.2.16 KV Konstruktionsvolumen
 *  If NGV Nettogebäudevolumen > 0
 *  Then
 *  GV Gebäudevolumen – NGV Nettogebäudevolumen
 *  Else
 *  No result (0)
 *
 * @param ngv   Nettogebäudevolumen
 * @param gv    Gebäudevolumen
 */


var calculateKV = function calculateKV(ngv, gv) {
  if (ngv > 0) {
    return gv - ngv;
  } else {
    return 0;
  }
};
/**
 * 3.2.17 NV Nutzvolumen
 * If no primitive in class «Innenräumen» with code «NF» or «HNF» oder «NNF» or «MUAH»
 * Then
 * If no primitive in class «Innenräumen» wiht code «VF» or «FF»
 *     Then
 *         No result (0)
 *     Else
 *         If no primitive in class «Innenräumen» with code «NGF»
 *             Then
 *                 No result (0)
 *             Else
 * Sum of floor area of primitives with code NGF - Sum of floor area of primitives with code «VF» and «FF»
 * Else
 * Sum of floor area of primitives with code «NF» and «HNF» and «NNF» and «MUAH»
 *
 * @param nvTmp    Temporary Nutzvolumen, i.e. accumulated volume of NF-innenraumen
 * @param hnvTmp   Temporary Hauptnutzvolumen, i.e. accumulated volume of HNF-innenraumen
 * @param nnv
 * @param muahv
 * @param ngv
 * @param vv
 * @param fv
 */


var calculateNV = function calculateNV(nvTmp, hnvTmp, nnv, muahv, ngv, vv, fv) {
  var NV = nvTmp + hnvTmp + nnv + muahv;

  if (NV === 0) {
    NV = ngv - vv - fv;
  }

  return NV;
};
/**
 * 3.2.18 HNV Hauptnutzvolumen
 * Sum of volumes of primitives
 * with code «HNF» and «MUAH»
 *
 * @param hnvTmp    Temporary Hauptnutzvolumen, i.e. accumulated volume of HNF-innenraumen
 * @param muahv
 */


var calculateHNV = function calculateHNV(hnvTmp, muahv) {
  return hnvTmp + muahv;
};
/**
 * 3.2.22 AGF Aussen-Geschossfläche
 * Sum of floor area of primitives with code
 * «AGF» and «ANGF» and «ANF»
 * and «AVF» and «AFF»
 *
 * @param agfTmp    Temporary Aussen-Geschossfläche i.e. accumulated floor area of AGF-innenraumen
 * @param angfTmp   Temporary Aussen-Nettogeschossfläche i.e. accumulated floor area of ANGF-innenraumen
 * @param anf
 * @param avf
 * @param aff
 */


var calculateAGF = function calculateAGF(agfTmp, angfTmp, anf, avf, aff) {
  return agfTmp + angfTmp + anf + avf + aff;
};
/**
 * 3.2.23 ANGF Aussen-Nettogeschossfläche
 * Sum of floor area of primitives with code
 * «ANGF» and «ANF» and «AVF» and «AFF»
 *
 * @param anf
 * @param avf
 * @param aff
 */


var calculateANGF = function calculateANGF(anf, avf, aff) {
  return anf + avf + aff;
};

var calculateX = function calculateX(volumen) {
  var X = 0;
  volumen.forEach(function (volume) {
    var crbCode = volume.crbCode;

    if (crbCode === CRB_CODE_DE.X) {
      X += volume.floorArea;
    }
  });
  return Math.round(X);
};

var CRB_2023_CODE_PREFIX = 'crb_ch_2023_';
var CRB_CODE_PARAMETER_NAME = 'crb_ch_surfacecode';
/**
 * This class has the ultimate goal to analyze the read data
 * and perform the calculation that need to be delivered to
 * the host component.
 * The analysis has three main parts:
 * 1. Primitives classification into main classes (grundstuck,
 * geschosse, innenraumen, aussenflachen and volumen)
 * 2. Generate helper primitives (for terrain, surfaces, building etc.)
 * 3. Perform calculations
 */

var CRBAnalyzer =
/** @class */
function () {
  function CRBAnalyzer(geometryHandler, logFunction) {
    var _this = this;

    this.getAnalyzedData = function () {
      return _this.analyzedData;
    };

    this.getCalculations = function () {
      return _this.calculations;
    };
    /**
     * Core analysis function
     */


    this.analyzeData = function (buildingsModels) {
      buildingsModels.forEach(function (model) {
        _this.logFUnction("Analyzing data of building with ID " + model.id); // 1. CLASSIFICATION


        _this.handleClassification(model); // 2. HELPER GEOMETRIES


        _this.handleHelperPrimitives(); // 3. PERFORM MEASUREMENTS


        _this.handleMeasurements(model);
      });
    };
    /**
     * -- CLASSIFICATION --
     */


    this.handleClassification = function (model) {
      _this.logFUnction('1. Step: Classification');

      var primitives = model.primitives; // Classify primitives by CRB code

      _this.classifyPrimitives(primitives); // Find terrain object


      _this.findTerrain(primitives); // Remove expressID of terrain from floors


      _this.removeTerrainFromFloors(model.floors);
    };

    this.printClassificationArrays = function () {
      _this.logFUnction("GRUNDSTUCK (" + _this.analyzedData.grundstuck.primitives.length + "): [" + _this.analyzedData.grundstuck.primitives.map(function (p) {
        return "\t" + p.expressId + " (" + getDeCodeAsString(p.crbCode) + ")";
      }) + "\t]");

      _this.logFUnction("GESCHOSSE (" + _this.analyzedData.geschosse.primitives.length + "): [" + _this.analyzedData.geschosse.primitives.map(function (p) {
        return "\t" + p.expressId + " (" + getDeCodeAsString(p.crbCode) + ")";
      }) + "\t]");

      _this.logFUnction("INNENRAUME (" + _this.analyzedData.innenraumen.primitives.length + "): [" + _this.analyzedData.innenraumen.primitives.map(function (p) {
        return "\t" + p.expressId + " (" + getDeCodeAsString(p.crbCode) + ")";
      }) + "\t]");

      _this.logFUnction("AUSSENFLACHEN (" + _this.analyzedData.aussenflachen.primitives.length + "): [" + _this.analyzedData.aussenflachen.primitives.map(function (p) {
        return "\t" + p.expressId + " (" + getDeCodeAsString(p.crbCode) + ")";
      }) + "\t]");

      _this.logFUnction("VOLUMEN (" + _this.analyzedData.volumen.primitives.length + "): [" + _this.analyzedData.volumen.primitives.map(function (p) {
        return "\t" + p.expressId + " (" + getDeCodeAsString(p.crbCode) + ")";
      }) + "\t]");

      _this.logFUnction("SONDERNUTZUNG (" + _this.analyzedData.sondernutzung.primitives.length + "): [" + _this.analyzedData.sondernutzung.primitives.map(function (p) {
        return "\t" + p.expressId + " (" + getDeCodeAsString(p.crbCode) + ")";
      }) + "\t]");
    };

    this.isCRBCode = function (propertyValue) {
      return propertyValue.toLowerCase().includes(CRB_2023_CODE_PREFIX);
    };

    this.isValidCRBCode = function (code) {
      return Object.values(CRB_CODE).includes(code.toUpperCase());
    };

    this.classifyPrimitives = function (primitives) {
      _this.logFUnction('Classify primitives');

      primitives.forEach(function (p) {
        _this.logFUnction("Primitive with expID " + p.expressId);

        _this.classifyPrimitive(p);

        _this.logFUnction("... has property code " + getDeCodeAsString(p.crbCode) + " and is classified as " + p.crbClass.name); // Add primitive to classification array


        _this.updateClassificationArray(p);
      });

      _this.printClassificationArrays();
    };
    /**
     * This function classifies the primitive based on the CRB code associated to it.
     * In order to classify the primitive, we first determine the CRB code.
     * The properties can store the CRB code (1) as value of any property-key or (2) as value
     * of a custom parameter, which has CRB_CODE_PARAMETER_NAME as name.
     *  1. Collect all properties' values and search for the first value containing a valid CRB code
     *  2. If no valid CRB code has been found, pick the parameter-value of CRB_CODE_PARAMETER_NAME
     * If no valid CRB code has been found with any of the previous methods,
     * then default classification is assigned to the primitive.
     * The CRB code used for the classification is also stored in the primitive object.
     *
     * @param primitive The primitive object to classify
     */


    this.classifyPrimitive = function (primitive) {
      var props = primitive.properties;
      var ipValues = Object.values(props.itemProps);
      var psValues = Object.values(props.propSets);
      var tpValues = Object.values(props.typeProps);

      var allPropertyValues = __spread(ipValues, psValues, tpValues); // (1) Search for CRB code in any property


      var crbCodeString = '';
      allPropertyValues.filter(function (val) {
        return val && val !== 'undefined';
      }).forEach(function (definedVal) {
        var stringVal = definedVal.toString();

        var isCRBCode = _this.isCRBCode(stringVal);

        if (isCRBCode) {
          crbCodeString = _this.extractCRBCcode(stringVal);
          return;
        }
      }); // (2) CRB code could not be determined so far, pick CRB_CODE_PARAMETER_NAME

      if (crbCodeString == null || !_this.isValidCRBCode(crbCodeString)) {
        console.info("No classification could be found, trying to retrieve " + CRB_CODE_PARAMETER_NAME + " parameter...");
        crbCodeString = getPropertyValueByParameter(props, {
          name: CRB_CODE_PARAMETER_NAME
        });
      } // Assign class to primitive


      var crbCode = CRB_CODE[crbCodeString.toUpperCase()];

      var deCrbCode = _this.getDeCrbCode(crbCode);

      console.info(crbCode == null ? "CRB code could not be found in the properties, using default " + getDeCodeAsString(deCrbCode) : "Found property code " + getCodeAsString(crbCode) + " which correspond to German CRB code " + getDeCodeAsString(deCrbCode));

      var crbClass = _this.classifyByCode(deCrbCode);

      primitive.crbCode = deCrbCode;
      primitive.crbClass = crbClass;
    };

    this.getDeCrbCode = function (code) {
      if (CRB_DE_CODE_BY_CODES.has(code)) {
        return CRB_DE_CODE_BY_CODES.get(code);
      } else {
        console.warn("CRB code " + code + " has no German translation");
        return DEFAULT_CRB_CODE;
      }
    };

    this.classifyByCode = function (code) {
      if (CRB_CLASSES_BY_DE_CODES.has(code)) {
        return CRB_CLASSES_BY_DE_CODES.get(code);
      } else {
        console.warn("CRB code " + code + " has no class associated to it");
        return DEFAULT_CRB_CLASS;
      }
    };
    /**
     * The CRB-code as string is extracted from the property value.
     * Any CRB-code has a common prefix, i.e. CRB_2023_CODE_PREFIX.
     * Removing it returns the CRB-code itself.
     *
     * @param val The property value
     */


    this.extractCRBCcode = function (val) {
      var index = val.toLowerCase().indexOf(CRB_2023_CODE_PREFIX);
      return val.toLowerCase().substr(index + CRB_2023_CODE_PREFIX.length);
    };
    /**
     * Add a primitive to the corresponding classification array
     *
     * @param primitive
     */


    this.updateClassificationArray = function (primitive) {
      var simplePrimitive = {
        expressId: primitive.expressId,
        mesh: primitive.geometry.mesh,
        realProjectedArea: primitive.geometry.quantities.realProjectedArea,
        crbCode: primitive.crbCode,
        crbClass: primitive.crbClass,
        triangles: primitive.geometry.triangles,
        floorArea: primitive.geometry.quantities.floorArea
      };
      var mainClass = primitive.crbClass.class;

      switch (mainClass) {
        case CRB_CLASS.GRUNDSTUCK:
          _this.analyzedData.grundstuck.primitives.push(simplePrimitive);

          return;

        case CRB_CLASS.INNENRAUME:
          _this.analyzedData.innenraumen.primitives.push(simplePrimitive);

          return;

        case CRB_CLASS.AUSSENFLACHEN:
          _this.analyzedData.aussenflachen.primitives.push(simplePrimitive);

          return;

        case CRB_CLASS.VOLUMEN:
          _this.analyzedData.volumen.primitives.push(simplePrimitive);

          return;

        case CRB_CLASS.SONDERNUTZUNG:
          _this.analyzedData.sondernutzung.primitives.push(simplePrimitive);

          return;

        default:
          _this.analyzedData.geschosse.primitives.push(simplePrimitive);

          return;
      }
    };

    this.removeFromClassificationArray = function (primitive) {
      var mainClass = primitive.crbClass.class;

      _this.logFUnction("Removing primitive " + primitive.expressId + " from " + mainClass + " array");

      var simplePrimitiveToRemove;

      switch (mainClass) {
        case CRB_CLASS.GRUNDSTUCK:
          simplePrimitiveToRemove = _this.analyzedData.grundstuck.primitives.filter(function (p) {
            return p.expressId === primitive.expressId;
          })[0];

          _this.removeItemFromArray(_this.analyzedData.grundstuck.primitives, simplePrimitiveToRemove);

          return;

        case CRB_CLASS.INNENRAUME:
          simplePrimitiveToRemove = _this.analyzedData.innenraumen.primitives.filter(function (p) {
            return p.expressId === primitive.expressId;
          })[0];

          _this.removeItemFromArray(_this.analyzedData.innenraumen.primitives, simplePrimitiveToRemove);

          return;

        case CRB_CLASS.AUSSENFLACHEN:
          simplePrimitiveToRemove = _this.analyzedData.aussenflachen.primitives.filter(function (p) {
            return p.expressId === primitive.expressId;
          })[0];

          _this.removeItemFromArray(_this.analyzedData.aussenflachen.primitives, simplePrimitiveToRemove);

          return;

        case CRB_CLASS.VOLUMEN:
          simplePrimitiveToRemove = _this.analyzedData.volumen.primitives.filter(function (p) {
            return p.expressId === primitive.expressId;
          })[0];

          _this.removeItemFromArray(_this.analyzedData.volumen.primitives, simplePrimitiveToRemove);

          return;

        default:
          simplePrimitiveToRemove = _this.analyzedData.geschosse.primitives.filter(function (p) {
            return p.expressId === primitive.expressId;
          })[0];

          _this.removeItemFromArray(_this.analyzedData.geschosse.primitives, simplePrimitiveToRemove);

          return;
      }
    };
    /**
     * Determine the volume which represents the terrain. We have two options:
     * 1. The terrain is already classified thanks to the code in the properties
     * 2. The terrain is not classified with code, so we take the GESCHOSS-primitive with the largest projected area
     *
     @param primitives List of primitives to search for terrain
     */


    this.findTerrain = function (primitives) {
      _this.logFUnction('Finding Terrain...');

      var noTerrainClassification = _this.analyzedData.grundstuck.primitives.length === 0;

      if (noTerrainClassification) {
        _this.findGeschossPrimitiveWithLargestArea(primitives);
      } else {
        _this.logFUnction('Terrain already classified');
      }
    };

    this.findGeschossPrimitiveWithLargestArea = function (primitives) {
      var primitiveWithLargestArea = null;
      var largestArea = -1;
      var geschossPrimitives = primitives.filter(function (p) {
        return p.crbClass.class === CRB_CLASS.GESCHOSSE;
      });
      geschossPrimitives.forEach(function (p) {
        var area = p.geometry.quantities.realProjectedArea;

        if (area > largestArea) {
          primitiveWithLargestArea = p;
          largestArea = area;
        }
      });

      _this.logFUnction("Primitive with expID " + primitiveWithLargestArea.expressId + " has been found to have largest area"); // Re-classify primitive with largest area and update classification arrays


      _this.classifyPrimitiveAsTerrain(primitiveWithLargestArea);
    };
    /**
     * Update the necessary structures, so that the primitive is
     * classified as terrain / GRUNDSTUCK
     *
     * @param primitive Primitive representing the terrain
     */


    this.classifyPrimitiveAsTerrain = function (primitive) {
      _this.logFUnction("Reclassifying primitive " + primitive.expressId + " as terrain..."); // Remove primitive from its current classification array


      _this.removeFromClassificationArray(primitive); // Re-classify as GSF class


      primitive.crbClass = CRB_CLASSES_BY_DE_CODES.get(CRB_CODE_DE.GSF);
      primitive.crbCode = CRB_CODE_DE.GSF; // Add primitive to GRUNDSTUCK array

      _this.updateClassificationArray(primitive);
    };
    /**
     * Once we found the terrain primitive we need to update the floors
     * structure so that the expressIDs of the terrain primitives
     * are not listed as children of any floor object (that's because
     * floors should only contain non-terrain, i.e. building, primitives)
     *
     * @param floors The floors structure of the ifc building model
     */


    this.removeTerrainFromFloors = function (floors) {
      _this.logFUnction('Removing terrain expressIDs from floors...');

      var terrainExpressIDs = _this.analyzedData.grundstuck.primitives.map(function (p) {
        return p.expressId;
      });

      var _loop_1 = function _loop_1() {
        var id = terrainExpressIDs.pop();
        floors.forEach(function (f) {
          if (f.childrenExpressIDs.includes(id)) {
            _this.logFUnction("Removing primitive " + id + " from floor " + f.floorType + f.floorNumber + "...");

            _this.removeItemFromArray(f.childrenExpressIDs, id);
          }
        });
      };

      while (terrainExpressIDs.length > 0) {
        _loop_1();
      }
    };
    /**
     * -- HELPER PRIMITIVES --
     */


    this.handleHelperPrimitives = function () {
      _this.logFUnction('2. Step: Generate Helper Primitives'); // Create the final Primitiv of "Grundstück", i.e. PVG  by unifying all primitives from class "Grundstuck"


      var PVG = _this.geometryHandler.createPVG(_this.analyzedData);

      _this.analyzedData.helperPrimitives.PVG = PVG; // Create the "Surface of Terrain", i.e. PTS

      var PTS = _this.geometryHandler.createPTS(_this.analyzedData);

      _this.analyzedData.helperPrimitives.PTS = PTS; // Create Building Volume, i.e. BP

      var BP = _this.geometryHandler.createBP(_this.analyzedData);

      _this.analyzedData.helperPrimitives.BP = BP; // Create the "Gebäudegrundfläche", i.e. PGGF

      var PGGF = _this.geometryHandler.createPGGF(_this.analyzedData);

      _this.analyzedData.helperPrimitives.PGGF = PGGF; // Create the "Untererdisches teil der Gebäude" - Under the earth part of the Building, i.e. BPU

      var BPU = _this.geometryHandler.createBPU(_this.analyzedData);

      _this.analyzedData.helperPrimitives.BPU = BPU;
    };
    /**
     * -- PERFORM MEASUREMENTS --
     */


    this.handleMeasurements = function (model) {
      _this.logFUnction('3. Step: Perform calculations'); // 3.1. eBKP-H (A und B) Standard


      _this.handleEBKPHMeasurements(); // 3.2. SIA 416 Standard


      _this.handleSIAMeasurements(); // Pack all measurements into calculations object


      _this.updateCalculationsForStandards(); // Perform calculations by floor


      _this.handleFloorMeasurements(model); // Perform calculations by usage


      _this.handleUsageMeasurements(model);
    };

    this.handleEBKPHMeasurements = function () {
      _this.logFUnction('3.1. Step: Perform calculations for eBKP-H (A und B) Standard');

      var _a = _this.analyzedData.helperPrimitives,
          BP = _a.BP,
          BPU = _a.BPU;
      var innenraumen = _this.analyzedData.innenraumen;
      /*
       * Measurements related to Class "Geschosse" using
       * generated helping Primitives (BP, BPU)
       */

      var HULLE = calculateHULLE(BP, _this.logFUnction);
      var BODENPLATTE = calculateBODENPLATTE(BPU, _this.logFUnction);
      var DACH = calculateDACH(BP, _this.logFUnction);
      _this.analyzedData.measurements.ebkph.DACH = DACH;
      var WAND = calculateWAND(HULLE, DACH, BODENPLATTE);
      _this.analyzedData.measurements.ebkph.WAND = WAND;
      /* Measurements for Spaces - Innenraumen, if any.
       * The calculations require no helping primitives since
       * all operations are executed on the original building primitives.
       */

      var muahInnenraumen = innenraumen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.MUAH;
      });
      var MUAH = accumulateFloorArea(muahInnenraumen);
      var MUAHV = accumulateVolume(muahInnenraumen);
      _this.analyzedData.measurements.ebkph.MUAH = MUAH;
      _this.analyzedData.measurements.ebkph.MUAHV = MUAHV;
    };

    this.handleSIAMeasurements = function () {
      _this.logFUnction('3.2. Step: Perform calculations for SIA 416 Standard');

      var _a = _this.analyzedData.helperPrimitives,
          PVG = _a.PVG,
          PGGF = _a.PGGF,
          BP = _a.BP;
      var _b = _this.analyzedData,
          geschosse = _b.geschosse,
          innenraumen = _b.innenraumen,
          aussenflachen = _b.aussenflachen,
          sondernutzung = _b.sondernutzung;
      var _c = _this.analyzedData.measurements.ebkph,
          MUAH = _c.MUAH,
          MUAHV = _c.MUAHV;
      var GSF = calculateGSF(PVG);
      _this.analyzedData.measurements.sia.GSF = GSF;
      var GGF = calculateGGF(PGGF);
      _this.analyzedData.measurements.sia.GGF = GGF;
      var X = calculateX(_this.analyzedData.volumen.primitives);
      _this.analyzedData.measurements.sia.X = X;
      var tmpUUF = calculateUUFtmp(_this.analyzedData.grundstuck.primitives);
      var UF = calculateUF(GSF, GGF, X);
      _this.analyzedData.measurements.sia.UF = UF;
      var BUF = calculateBUF(UF, tmpUUF);
      _this.analyzedData.measurements.sia.BUF = BUF;
      _this.analyzedData.measurements.sia.UUF = calculateUUF(UF, BUF);
      var GF = calculateGF(geschosse.primitives);
      _this.analyzedData.measurements.sia.GF = GF;
      var GV = calculateGV(BP);
      _this.analyzedData.measurements.sia.GV = GV;
      /* Measurements for Intern Spaces (Innenraumen)
       * The calculations require no helping primitives since
       * all operations are executed on the original primitives.
       */

      var ngfInnenraumen = innenraumen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.NGF;
      });
      var tmpNGF = accumulateFloorArea(ngfInnenraumen);
      var tmpNGV = accumulateVolume(ngfInnenraumen);
      var nfInnenraumen = innenraumen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.NF;
      });
      var tmpNF = accumulateFloorArea(nfInnenraumen);
      var tmpNV = accumulateVolume(nfInnenraumen);
      var hnfInnenraumen = innenraumen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.HNF;
      });
      var tmpHNF = accumulateFloorArea(hnfInnenraumen);
      var tmpHNV = accumulateVolume(hnfInnenraumen);
      var nnfInnenraumen = innenraumen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.NNF;
      });
      var NNF = accumulateFloorArea(nnfInnenraumen);
      var NNV = accumulateVolume(nnfInnenraumen);
      var vfInnenraumen = innenraumen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.VF;
      });
      var VF = accumulateFloorArea(vfInnenraumen);
      var VV = accumulateVolume(vfInnenraumen);
      var ffInnenraumen = innenraumen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.FF;
      });
      var FF = accumulateFloorArea(ffInnenraumen);
      var FVtmp = accumulateVolume(ffInnenraumen);
      var fvInnenraumen = innenraumen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.FV;
      });
      var FV = FVtmp + accumulateVolume(fvInnenraumen);
      _this.analyzedData.measurements.sia.NNF = NNF;
      _this.analyzedData.measurements.sia.NNV = NNV;
      _this.analyzedData.measurements.sia.VF = VF;
      _this.analyzedData.measurements.sia.VV = VV;
      _this.analyzedData.measurements.sia.FF = FF;
      _this.analyzedData.measurements.sia.FV = FV;
      var NGF = calculateNGF(tmpNGF, tmpNF, VF, FF, tmpHNF, NNF, MUAH);
      _this.analyzedData.measurements.sia.NGF = NGF;
      _this.analyzedData.measurements.sia.KF = calculateKF(NGF, GF);
      _this.analyzedData.measurements.sia.NF = calculateNF(tmpNF, tmpHNF, NNF, MUAH, NGF, VF, FF);
      _this.analyzedData.measurements.sia.HNF = calculateHNF(tmpHNF, MUAH);
      var NGV = calculateNGV(tmpNGV, tmpNV, VV, FV, tmpHNV, NNV, MUAHV);
      _this.analyzedData.measurements.sia.NGV = NGV;
      _this.analyzedData.measurements.sia.KV = calculateKV(NGV, GV);
      _this.analyzedData.measurements.sia.NV = calculateNV(tmpNV, tmpHNV, NNV, MUAHV, NGV, VV, FV);
      _this.analyzedData.measurements.sia.HNV = calculateHNV(tmpHNV, MUAHV);
      /* Measurements for Exterior Spaces (Aussenflachen)
       * The calculations require no helping primitives since
       * all operations are executed on the original primitives.
       */

      var agfAussenflachen = aussenflachen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.AGF;
      });
      var tmpAGF = accumulateFloorArea(agfAussenflachen);
      var angfAussenflachen = aussenflachen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.ANGF;
      });
      var tmpANGF = accumulateFloorArea(angfAussenflachen);
      var anfAussenflachen = aussenflachen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.ANF;
      });
      var ANF = accumulateFloorArea(anfAussenflachen);
      var avfAussenflachen = aussenflachen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.AVF;
      });
      var AVF = accumulateFloorArea(avfAussenflachen);
      var affAussenflachen = aussenflachen.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.AFF;
      });
      var AFF = accumulateFloorArea(affAussenflachen);
      _this.analyzedData.measurements.sia.ANF = ANF;
      _this.analyzedData.measurements.sia.AVF = AVF;
      _this.analyzedData.measurements.sia.AFF = AFF;
      _this.analyzedData.measurements.sia.AGF = calculateAGF(tmpAGF, tmpANGF, ANF, AVF, AFF);
      _this.analyzedData.measurements.sia.ANGF = calculateANGF(ANF, AVF, AFF);
      /*
       * Measurements for Special usage surfaces (Sondernutzung)
       */

      var fsnSondernutzung = sondernutzung.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.FSN;
      });
      var tmpFSN = accumulateFloorArea(fsnSondernutzung);
      var ufsnSondernutzung = sondernutzung.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.UFSN;
      });
      var UFSN = accumulateFloorArea(ufsnSondernutzung);
      var ifsnSondernutzung = sondernutzung.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.IFSN;
      });
      var IFSN = accumulateFloorArea(ifsnSondernutzung);
      var afsnSondernutzung = sondernutzung.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.AFSN;
      });
      var AFSN = accumulateFloorArea(afsnSondernutzung);
      var fgnSondernutzung = sondernutzung.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.FGN;
      });
      var tmpFGN = accumulateFloorArea(fgnSondernutzung);
      var ufgnSondernutzung = sondernutzung.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.UFGN;
      });
      var UFGN = accumulateFloorArea(ufgnSondernutzung);
      var ifgnSondernutzung = sondernutzung.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.IFGN;
      });
      var IFGN = accumulateFloorArea(ifgnSondernutzung);
      var afgnSondernutzung = sondernutzung.primitives.filter(function (p) {
        return p.crbCode === CRB_CODE_DE.AFGN;
      });
      var AFGN = accumulateFloorArea(afgnSondernutzung);
      var FSN = tmpFSN + UFSN + IFSN + AFSN;
      var FGN = tmpFGN + UFGN + IFGN + AFGN;
      _this.analyzedData.measurements.sia.FSN = FSN;
      _this.analyzedData.measurements.sia.UFSN = UFSN;
      _this.analyzedData.measurements.sia.IFSN = IFSN;
      _this.analyzedData.measurements.sia.AFSN = AFSN;
      _this.analyzedData.measurements.sia.FGN = FGN;
      _this.analyzedData.measurements.sia.UFGN = UFGN;
      _this.analyzedData.measurements.sia.IFGN = IFGN;
      _this.analyzedData.measurements.sia.AFGN = AFGN;
    };
    /**
     * Perform per-floor calculations. For each floor, consider all the
     * primitives belonging to it adn compute:
     * - floor area
     * - height
     *
     * @param model The IFC building model
     */


    this.handleFloorMeasurements = function (model) {
      var _a;

      _this.logFUnction('3.3. Step: Perform calculations by floors');

      var floors = model.floors;
      var primitives = model.primitives;
      var floorCalculations = [];

      if (floors.length === 1) {
        var floor_1 = floors[0];
        var primitivesInFloor = primitives.filter(function (p) {
          return floor_1.childrenExpressIDs.includes(p.expressId);
        }).filter(function (p) {
          var _a;

          return ((_a = p.crbClass) === null || _a === void 0 ? void 0 : _a.class) === CRB_CLASS.GESCHOSSE;
        });
        var floorCalculation = {
          floorType: floor_1.floorType,
          floorNumber: floor_1.floorNumber,
          area: accumulateFloorArea(primitivesInFloor),
          height: Math.abs((_a = floor_1.elevation) !== null && _a !== void 0 ? _a : DEFAULT_FLOOR_HEIGHT)
        };
        floorCalculations.push(floorCalculation);
      } else {
        floors.forEach(function (f, idx) {
          var primitivesInFloor = primitives.filter(function (p) {
            return f.childrenExpressIDs.includes(p.expressId);
          }).filter(function (p) {
            var _a;

            return ((_a = p.crbClass) === null || _a === void 0 ? void 0 : _a.class) === CRB_CLASS.GESCHOSSE;
          }); // Floor Area by floor

          var area = accumulateFloorArea(primitivesInFloor); // Height of each floor

          var nextFloor = floors[idx + 1];
          var isLastFloor = nextFloor === undefined; // use previous floor if current floor is the last one

          var height = isLastFloor ? computeFloorHeight(floors[idx - 1], f) : computeFloorHeight(f, nextFloor);
          var floorCalculation = {
            floorType: f.floorType,
            floorNumber: f.floorNumber,
            area: area,
            height: height
          };
          floorCalculations.push(floorCalculation);
        });
      } // If no floors are provided in the ifc file, set default calculation


      if (floors.length === 0) {
        var floorCalculation = {
          floorType: 'GROUND',
          floorNumber: 0,
          area: _this.analyzedData.measurements.sia.GF,
          height: DEFAULT_FLOOR_HEIGHT
        };
        floorCalculations.push(floorCalculation);
      } // Floor area of underground floors (i.e. GFUT)


      var ugFloors = floorCalculations.filter(function (f) {
        return f.floorType === 'UNDER_GROUND';
      });
      var ugArea = accumulateAreaForFloors(ugFloors);
      _this.calculations.floorsCalculations = floorCalculations;

      _this.calculations.quantities.push({
        name: 'GFUT',
        value: ugArea
      });
    };
    /**
     * Performs the calculations for the usage. For each unique tuple crbCode-usage,
     * we sum the floor area of all primitives belonging to it.
     * Internally we use a map that stores the stringification of an object with
     * the unique combination of crbCode and usage as key and the total floor area
     * as value.
     *
     * @param model The IFC building model
     */


    this.handleUsageMeasurements = function (model) {
      _this.logFUnction('3.4. Step: Perform calculations for usage');

      var usageMap = new Map();
      var primitives = model.primitives;
      /**
       * Iterate over all primitives to determine the
       * crbCode-usage-object key and collect their area
       */

      primitives.forEach(function (p) {
        var _a; // todo rm logs after testing sum calculation


        var usage = (_a = p.properties) === null || _a === void 0 ? void 0 : _a.usage; // console.log(usage);

        if (usage) {
          var crbCode = p.crbCode;
          var key = JSON.stringify({
            crbCode: crbCode,
            usage: usage
          });
          var floorArea = p.geometry.quantities.floorArea; // console.log('id ', p.expressId);
          // console.log('key ', key);

          /**
           * If the key already exists in the map,
           * add primitive's floor area to current value
           */

          if (usageMap.has(key)) {
            var currentArea = usageMap.get(key);
            var newArea = currentArea + floorArea; // console.log('current ', currentArea);
            // console.log('floor ', floorArea);
            // console.log('new ', newArea);

            usageMap.set(key, newArea);
          } else {
            /**
             * If the key does not exist, add a new entry
             * to the map with primitive's floor area as value
             */
            usageMap.set(key, floorArea); // console.log('new entry ', floorArea);
          } // console.log('----');

        }
      }); // console.log(usageMap);

      /**
       * Pack [crbCode, usage, total area] in the calculation to deliver
       */

      usageMap.forEach(function (floorArea, key) {
        // console.log(floorArea);
        // console.log(key);
        // console.log(JSON.parse(key));
        var _a = JSON.parse(key),
            crbCode = _a.crbCode,
            usage = _a.usage;

        var usageEntry = {
          crbCode: getDeCodeAsString(crbCode),
          usage: usage,
          floorArea: floorArea
        }; // console.log(usageEntry);

        _this.calculations.usageCalculations.push(usageEntry);
      }); // console.log(this.calculations.usageCalculations);
    };

    this.updateCalculationsForStandards = function () {
      var _a = _this.analyzedData.measurements.ebkph,
          DACH = _a.DACH,
          WAND = _a.WAND,
          MUAH = _a.MUAH,
          MUAHV = _a.MUAHV;
      var _b = _this.analyzedData.measurements.sia,
          GSF = _b.GSF,
          GGF = _b.GGF,
          UF = _b.UF,
          BUF = _b.BUF,
          UUF = _b.UUF,
          X = _b.X,
          GF = _b.GF,
          GV = _b.GV,
          NGF = _b.NGF,
          NGV = _b.NGV,
          NF = _b.NF,
          NV = _b.NV,
          HNF = _b.HNF,
          HNV = _b.HNV,
          NNF = _b.NNF,
          NNV = _b.NNV,
          VF = _b.VF,
          VV = _b.VV,
          FF = _b.FF,
          FV = _b.FV,
          KF = _b.KF,
          KV = _b.KV,
          AGF = _b.AGF,
          ANGF = _b.ANGF,
          ANF = _b.ANF,
          AVF = _b.AVF,
          AFF = _b.AFF,
          FSN = _b.FSN,
          UFSN = _b.UFSN,
          IFSN = _b.IFSN,
          AFSN = _b.AFSN,
          FGN = _b.FGN,
          UFGN = _b.UFGN,
          IFGN = _b.IFGN,
          AFGN = _b.AFGN; // eBKP-H (A und B) Standard

      _this.calculations.quantities.push({
        name: 'BRA',
        value: DACH
      });

      _this.calculations.quantities.push({
        name: 'BV',
        value: GV
      });

      _this.calculations.quantities.push({
        name: 'ESA',
        value: BUF
      });

      _this.calculations.quantities.push({
        name: 'FA',
        value: GF
      });

      _this.calculations.quantities.push({
        name: 'FGA',
        value: WAND
      });

      _this.calculations.quantities.push({
        name: 'FGMA',
        value: WAND
      });

      _this.calculations.quantities.push({
        name: 'SA',
        value: GSF
      });

      _this.calculations.quantities.push({
        name: 'USA',
        value: NF
      });

      _this.calculations.quantities.push({
        name: 'MUAH',
        value: MUAH
      });

      _this.calculations.quantities.push({
        name: 'MUAHV',
        value: MUAHV
      }); // SIA 416 Standard


      _this.calculations.quantities.push({
        name: 'GSF',
        value: GSF
      });

      _this.calculations.quantities.push({
        name: 'GGF',
        value: GGF
      });

      _this.calculations.quantities.push({
        name: 'UF',
        value: UF
      });

      _this.calculations.quantities.push({
        name: 'BUF',
        value: BUF
      });

      _this.calculations.quantities.push({
        name: 'UUF',
        value: UUF
      });

      _this.calculations.quantities.push({
        name: 'GF',
        value: GF
      });

      _this.calculations.quantities.push({
        name: 'NGF',
        value: NGF
      });

      _this.calculations.quantities.push({
        name: 'NF',
        value: NF
      });

      _this.calculations.quantities.push({
        name: 'HNF',
        value: HNF
      });

      _this.calculations.quantities.push({
        name: 'NNF',
        value: NNF
      });

      _this.calculations.quantities.push({
        name: 'VF',
        value: VF
      });

      _this.calculations.quantities.push({
        name: 'FF',
        value: FF
      });

      _this.calculations.quantities.push({
        name: 'KF',
        value: KF
      });

      _this.calculations.quantities.push({
        name: 'AGF',
        value: AGF
      });

      _this.calculations.quantities.push({
        name: 'ANGF',
        value: ANGF
      });

      _this.calculations.quantities.push({
        name: 'ANF',
        value: ANF
      });

      _this.calculations.quantities.push({
        name: 'AVF',
        value: AVF
      });

      _this.calculations.quantities.push({
        name: 'AFF',
        value: AFF
      });

      _this.calculations.quantities.push({
        name: 'GV SIA 416',
        value: GV
      });

      _this.calculations.quantities.push({
        name: 'NGV',
        value: NGV
      });

      _this.calculations.quantities.push({
        name: 'NV',
        value: NV
      });

      _this.calculations.quantities.push({
        name: 'HNV',
        value: HNV
      });

      _this.calculations.quantities.push({
        name: 'NNV',
        value: NNV
      });

      _this.calculations.quantities.push({
        name: 'VV',
        value: VV
      });

      _this.calculations.quantities.push({
        name: 'FV',
        value: FV
      });

      _this.calculations.quantities.push({
        name: 'KV',
        value: KV
      });

      _this.calculations.quantities.push({
        name: 'X',
        value: X
      });

      _this.calculations.quantities.push({
        name: 'FSN',
        value: FSN
      });

      _this.calculations.quantities.push({
        name: 'UFSN',
        value: UFSN
      });

      _this.calculations.quantities.push({
        name: 'IFSN',
        value: IFSN
      });

      _this.calculations.quantities.push({
        name: 'AFSN',
        value: AFSN
      });

      _this.calculations.quantities.push({
        name: 'FGN',
        value: FGN
      });

      _this.calculations.quantities.push({
        name: 'UFGN',
        value: UFGN
      });

      _this.calculations.quantities.push({
        name: 'IFGN',
        value: IFGN
      });

      _this.calculations.quantities.push({
        name: 'AFGN',
        value: AFGN
      });
    };

    this.printCalculations = function () {
      _this.logFUnction('eBKP-H (A und B) and SIA Measurements');

      _this.calculations.quantities.forEach(function (c) {
        return console.log("\n" + c.name + ":\t" + c.value);
      });
    };

    this.printFloorMeasurements = function () {
      _this.logFUnction('Floor Measurements');

      var floorsCalculations = _this.calculations.floorsCalculations;
      console.log('\nFLOOR\tAREA\tHEIGHT');
      floorsCalculations.forEach(function (fc) {
        console.log("\n" + fc.floorType + fc.floorNumber + "\t" + fc.area + "\t" + fc.height);
      });
    };

    this.printUsageMeasurements = function () {
      var usageCalculations = _this.calculations.usageCalculations;

      if (usageCalculations.length > 0) {
        _this.logFUnction('Usage Measurements');

        console.log('\nCRB-CODE\tUSAGE\tFLOOR AREA');
        usageCalculations.forEach(function (uc) {
          console.log("\n" + uc.crbCode + "\t" + uc.usage + "\t" + uc.floorArea);
        });
      }
    };
    /**
     * UTILS
     */


    this.removeItemFromArray = function (array, itemToRemove) {
      var indexToRemove = array.indexOf(itemToRemove);

      if (indexToRemove > -1) {
        // splice() modifies the array in place and return a new array containing the removed element. So we do not return
        array.splice(indexToRemove, 1);
      }
    };

    this.logFUnction = logFunction !== null && logFunction !== void 0 ? logFunction : function (arg) {
      return console.log("" + arg);
    };
    this.geometryHandler = geometryHandler;
    this.analyzedData = {
      grundstuck: {
        crbClass: GRUNDSTUCK_CLASS,
        primitives: []
      },
      geschosse: {
        crbClass: GESCHOSSE_CLASS,
        primitives: []
      },
      innenraumen: {
        crbClass: INNENRAUME_CLASS,
        primitives: []
      },
      aussenflachen: {
        crbClass: AUSSENFLACHEN_CLASS,
        primitives: []
      },
      volumen: {
        crbClass: VOLUMEN_CLASS,
        primitives: []
      },
      sondernutzung: {
        crbClass: SONDERNUTZUNG_CLASS,
        primitives: []
      },
      helperPrimitives: {},
      measurements: {
        ebkph: {
          DACH: -1,
          WAND: -1,
          MUAH: -1,
          MUAHV: -1
        },
        sia: {
          X: -1,
          GSF: -1,
          GF: -1,
          GGF: -1,
          UF: -1,
          BUF: -1,
          UUF: -1,
          GV: -1,
          NGF: -1,
          NGV: -1,
          NF: -1,
          NV: -1,
          HNF: -1,
          HNV: -1,
          NNF: -1,
          NNV: -1,
          VF: -1,
          VV: -1,
          FF: -1,
          FV: -1,
          KF: -1,
          KV: -1,
          AGF: -1,
          ANGF: -1,
          ANF: -1,
          AVF: -1,
          AFF: -1,
          GFUT: -1,
          FSN: -1,
          UFSN: -1,
          IFSN: -1,
          AFSN: -1,
          FGN: -1,
          UFGN: -1,
          IFGN: -1,
          AFGN: -1
        }
      }
    };
    this.calculations = {
      quantities: [],
      floorsCalculations: [],
      floorAreas: [],
      messages: [],
      usageCalculations: []
    };
  }

  return CRBAnalyzer;
}();
/**
 * Hook which returns a cleanup function, which will automatically be invoked by React
 * when the component is being unmounted. By providing an empty dependency array,
 * we ensure that the effect runs only once during component mounting and
 * the cleanup function is triggered only when the component is being unmounted.
 *
 * @param cleanupFn The cleanup function to be invoked at unmount
 * @param fn Any functionality that might be needed when the useEffect is triggered.
 */


var useCleanupComponent = function useCleanupComponent(cleanupFn, fn) {
  useEffect(function () {
    fn && fn();
    return function () {
      return cleanupFn();
    };
  }, []);
}; // Split strategy constants


var CENTER = 0;
var AVERAGE = 1;
var SAH = 2;
var CONTAINED = 2; // SAH cost constants
// TODO: hone these costs more. The relative difference between them should be the
// difference in measured time to perform a triangle intersection vs traversing
// bounds.

var TRIANGLE_INTERSECT_COST = 1.25;
var TRAVERSAL_COST = 1; // Build constants

var BYTES_PER_NODE = 6 * 4 + 4 + 4;
var IS_LEAFNODE_FLAG = 0xFFFF; // EPSILON for computing floating point error during build
// https://en.wikipedia.org/wiki/Machine_epsilon#Values_for_standard_hardware_floating_point_arithmetics

var FLOAT32_EPSILON = Math.pow(2, -24);

var MeshBVHNode = function MeshBVHNode() {// internal nodes have boundingData, left, right, and splitAxis
  // leaf nodes have offset and count (referring to primitives in the mesh geometry)

  _classCallCheck2(this, MeshBVHNode);
};

function arrayToBox(nodeIndex32, array, target) {
  target.min.x = array[nodeIndex32];
  target.min.y = array[nodeIndex32 + 1];
  target.min.z = array[nodeIndex32 + 2];
  target.max.x = array[nodeIndex32 + 3];
  target.max.y = array[nodeIndex32 + 4];
  target.max.z = array[nodeIndex32 + 5];
  return target;
}

function getLongestEdgeIndex(bounds) {
  var splitDimIdx = -1;
  var splitDist = -Infinity;

  for (var _i298 = 0; _i298 < 3; _i298++) {
    var dist = bounds[_i298 + 3] - bounds[_i298];

    if (dist > splitDist) {
      splitDist = dist;
      splitDimIdx = _i298;
    }
  }

  return splitDimIdx;
} // copies bounds a into bounds b


function copyBounds(source, target) {
  target.set(source);
} // sets bounds target to the union of bounds a and b


function unionBounds(a, b, target) {
  var aVal, bVal;

  for (var d = 0; d < 3; d++) {
    var d3 = d + 3; // set the minimum values

    aVal = a[d];
    bVal = b[d];
    target[d] = aVal < bVal ? aVal : bVal; // set the max values

    aVal = a[d3];
    bVal = b[d3];
    target[d3] = aVal > bVal ? aVal : bVal;
  }
} // expands the given bounds by the provided triangle bounds


function expandByTriangleBounds(startIndex, triangleBounds, bounds) {
  for (var d = 0; d < 3; d++) {
    var tCenter = triangleBounds[startIndex + 2 * d];
    var tHalf = triangleBounds[startIndex + 2 * d + 1];
    var tMin = tCenter - tHalf;
    var tMax = tCenter + tHalf;

    if (tMin < bounds[d]) {
      bounds[d] = tMin;
    }

    if (tMax > bounds[d + 3]) {
      bounds[d + 3] = tMax;
    }
  }
} // compute bounds surface area


function computeSurfaceArea(bounds) {
  var d0 = bounds[3] - bounds[0];
  var d1 = bounds[4] - bounds[1];
  var d2 = bounds[5] - bounds[2];
  return 2 * (d0 * d1 + d1 * d2 + d2 * d0);
}

function ensureIndex(geo, options) {
  if (!geo.index) {
    var vertexCount = geo.attributes.position.count;
    var BufferConstructor = options.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;

    var _index13;

    if (vertexCount > 65535) {
      _index13 = new Uint32Array(new BufferConstructor(4 * vertexCount));
    } else {
      _index13 = new Uint16Array(new BufferConstructor(2 * vertexCount));
    }

    geo.setIndex(new BufferAttribute(_index13, 1));

    for (var _i299 = 0; _i299 < vertexCount; _i299++) {
      _index13[_i299] = _i299;
    }
  }
} // Computes the set of { offset, count } ranges which need independent BVH roots. Each
// region in the geometry index that belongs to a different set of material groups requires
// a separate BVH root, so that triangles indices belonging to one group never get swapped
// with triangle indices belongs to another group. For example, if the groups were like this:
//
// [-------------------------------------------------------------]
// |__________________|
//   g0 = [0, 20]  |______________________||_____________________|
//                      g1 = [16, 40]           g2 = [41, 60]
//
// we would need four BVH roots: [0, 15], [16, 20], [21, 40], [41, 60].


function getRootIndexRanges(geo) {
  if (!geo.groups || !geo.groups.length) {
    return [{
      offset: 0,
      count: geo.index.count / 3
    }];
  }

  var ranges = [];
  var rangeBoundaries = new Set();

  var _iterator7 = _createForOfIteratorHelper(geo.groups),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var group = _step7.value;
      rangeBoundaries.add(group.start);
      rangeBoundaries.add(group.start + group.count);
    } // note that if you don't pass in a comparator, it sorts them lexicographically as strings :-(

  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }

  var sortedBoundaries = Array.from(rangeBoundaries.values()).sort(function (a, b) {
    return a - b;
  });

  for (var _i300 = 0; _i300 < sortedBoundaries.length - 1; _i300++) {
    var start = sortedBoundaries[_i300],
        end = sortedBoundaries[_i300 + 1];
    ranges.push({
      offset: start / 3,
      count: (end - start) / 3
    });
  }

  return ranges;
} // computes the union of the bounds of all of the given triangles and puts the resulting box in target. If
// centroidTarget is provided then a bounding box is computed for the centroids of the triangles, as well.
// These are computed together to avoid redundant accesses to bounds array.


function getBounds(triangleBounds, offset, count, target) {
  var centroidTarget = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var minx = Infinity;
  var miny = Infinity;
  var minz = Infinity;
  var maxx = -Infinity;
  var maxy = -Infinity;
  var maxz = -Infinity;
  var cminx = Infinity;
  var cminy = Infinity;
  var cminz = Infinity;
  var cmaxx = -Infinity;
  var cmaxy = -Infinity;
  var cmaxz = -Infinity;
  var includeCentroid = centroidTarget !== null;

  for (var _i301 = offset * 6, end = (offset + count) * 6; _i301 < end; _i301 += 6) {
    var cx = triangleBounds[_i301 + 0];
    var hx = triangleBounds[_i301 + 1];
    var lx = cx - hx;
    var rx = cx + hx;
    if (lx < minx) minx = lx;
    if (rx > maxx) maxx = rx;
    if (includeCentroid && cx < cminx) cminx = cx;
    if (includeCentroid && cx > cmaxx) cmaxx = cx;
    var cy = triangleBounds[_i301 + 2];
    var hy = triangleBounds[_i301 + 3];
    var ly = cy - hy;
    var ry = cy + hy;
    if (ly < miny) miny = ly;
    if (ry > maxy) maxy = ry;
    if (includeCentroid && cy < cminy) cminy = cy;
    if (includeCentroid && cy > cmaxy) cmaxy = cy;
    var cz = triangleBounds[_i301 + 4];
    var hz = triangleBounds[_i301 + 5];
    var lz = cz - hz;
    var rz = cz + hz;
    if (lz < minz) minz = lz;
    if (rz > maxz) maxz = rz;
    if (includeCentroid && cz < cminz) cminz = cz;
    if (includeCentroid && cz > cmaxz) cmaxz = cz;
  }

  target[0] = minx;
  target[1] = miny;
  target[2] = minz;
  target[3] = maxx;
  target[4] = maxy;
  target[5] = maxz;

  if (includeCentroid) {
    centroidTarget[0] = cminx;
    centroidTarget[1] = cminy;
    centroidTarget[2] = cminz;
    centroidTarget[3] = cmaxx;
    centroidTarget[4] = cmaxy;
    centroidTarget[5] = cmaxz;
  }
} // A stand alone function for retrieving the centroid bounds.


function getCentroidBounds(triangleBounds, offset, count, centroidTarget) {
  var cminx = Infinity;
  var cminy = Infinity;
  var cminz = Infinity;
  var cmaxx = -Infinity;
  var cmaxy = -Infinity;
  var cmaxz = -Infinity;

  for (var _i302 = offset * 6, end = (offset + count) * 6; _i302 < end; _i302 += 6) {
    var cx = triangleBounds[_i302 + 0];
    if (cx < cminx) cminx = cx;
    if (cx > cmaxx) cmaxx = cx;
    var cy = triangleBounds[_i302 + 2];
    if (cy < cminy) cminy = cy;
    if (cy > cmaxy) cmaxy = cy;
    var cz = triangleBounds[_i302 + 4];
    if (cz < cminz) cminz = cz;
    if (cz > cmaxz) cmaxz = cz;
  }

  centroidTarget[0] = cminx;
  centroidTarget[1] = cminy;
  centroidTarget[2] = cminz;
  centroidTarget[3] = cmaxx;
  centroidTarget[4] = cmaxy;
  centroidTarget[5] = cmaxz;
} // reorders `tris` such that for `count` elements after `offset`, elements on the left side of the split
// will be on the left and elements on the right side of the split will be on the right. returns the index
// of the first element on the right side, or offset + count if there are no elements on the right side.


function partition(index, triangleBounds, offset, count, split) {
  var left = offset;
  var right = offset + count - 1;
  var pos = split.pos;
  var axisOffset = split.axis * 2; // hoare partitioning, see e.g. https://en.wikipedia.org/wiki/Quicksort#Hoare_partition_scheme

  while (true) {
    while (left <= right && triangleBounds[left * 6 + axisOffset] < pos) {
      left++;
    } // if a triangle center lies on the partition plane it is considered to be on the right side


    while (left <= right && triangleBounds[right * 6 + axisOffset] >= pos) {
      right--;
    }

    if (left < right) {
      // we need to swap all of the information associated with the triangles at index
      // left and right; that's the verts in the geometry index, the bounds,
      // and perhaps the SAH planes
      for (var _i303 = 0; _i303 < 3; _i303++) {
        var t0 = index[left * 3 + _i303];
        index[left * 3 + _i303] = index[right * 3 + _i303];
        index[right * 3 + _i303] = t0;
        var t1 = triangleBounds[left * 6 + _i303 * 2 + 0];
        triangleBounds[left * 6 + _i303 * 2 + 0] = triangleBounds[right * 6 + _i303 * 2 + 0];
        triangleBounds[right * 6 + _i303 * 2 + 0] = t1;
        var t2 = triangleBounds[left * 6 + _i303 * 2 + 1];
        triangleBounds[left * 6 + _i303 * 2 + 1] = triangleBounds[right * 6 + _i303 * 2 + 1];
        triangleBounds[right * 6 + _i303 * 2 + 1] = t2;
      }

      left++;
      right--;
    } else {
      return left;
    }
  }
}

var BIN_COUNT = 32;

var binsSort = function binsSort(a, b) {
  return a.candidate - b.candidate;
};

var sahBins = new Array(BIN_COUNT).fill().map(function () {
  return {
    count: 0,
    bounds: new Float32Array(6),
    rightCacheBounds: new Float32Array(6),
    leftCacheBounds: new Float32Array(6),
    candidate: 0
  };
});
var leftBounds = new Float32Array(6);

function getOptimalSplit(nodeBoundingData, centroidBoundingData, triangleBounds, offset, count, strategy) {
  var axis = -1;
  var pos = 0; // Center

  if (strategy === CENTER) {
    axis = getLongestEdgeIndex(centroidBoundingData);

    if (axis !== -1) {
      pos = (centroidBoundingData[axis] + centroidBoundingData[axis + 3]) / 2;
    }
  } else if (strategy === AVERAGE) {
    axis = getLongestEdgeIndex(nodeBoundingData);

    if (axis !== -1) {
      pos = getAverage(triangleBounds, offset, count, axis);
    }
  } else if (strategy === SAH) {
    var rootSurfaceArea = computeSurfaceArea(nodeBoundingData);
    var bestCost = TRIANGLE_INTERSECT_COST * count; // iterate over all axes

    var cStart = offset * 6;
    var cEnd = (offset + count) * 6;

    for (var a = 0; a < 3; a++) {
      var axisLeft = centroidBoundingData[a];
      var axisRight = centroidBoundingData[a + 3];
      var axisLength = axisRight - axisLeft;
      var binWidth = axisLength / BIN_COUNT; // If we have fewer triangles than we're planning to split then just check all
      // the triangle positions because it will be faster.

      if (count < BIN_COUNT / 4) {
        // initialize the bin candidates
        var truncatedBins = _toConsumableArray(sahBins);

        truncatedBins.length = count; // set the candidates

        var b = 0;

        for (var c = cStart; c < cEnd; c += 6, b++) {
          var bin = truncatedBins[b];
          bin.candidate = triangleBounds[c + 2 * a];
          bin.count = 0;
          var bounds = bin.bounds,
              leftCacheBounds = bin.leftCacheBounds,
              rightCacheBounds = bin.rightCacheBounds;

          for (var d = 0; d < 3; d++) {
            rightCacheBounds[d] = Infinity;
            rightCacheBounds[d + 3] = -Infinity;
            leftCacheBounds[d] = Infinity;
            leftCacheBounds[d + 3] = -Infinity;
            bounds[d] = Infinity;
            bounds[d + 3] = -Infinity;
          }

          expandByTriangleBounds(c, triangleBounds, bounds);
        }

        truncatedBins.sort(binsSort); // remove redundant splits

        var splitCount = count;

        for (var bi = 0; bi < splitCount; bi++) {
          var _bin = truncatedBins[bi];

          while (bi + 1 < splitCount && truncatedBins[bi + 1].candidate === _bin.candidate) {
            truncatedBins.splice(bi + 1, 1);
            splitCount--;
          }
        } // find the appropriate bin for each triangle and expand the bounds.


        for (var _c6 = cStart; _c6 < cEnd; _c6 += 6) {
          var center = triangleBounds[_c6 + 2 * a];

          for (var _bi = 0; _bi < splitCount; _bi++) {
            var _bin2 = truncatedBins[_bi];

            if (center >= _bin2.candidate) {
              expandByTriangleBounds(_c6, triangleBounds, _bin2.rightCacheBounds);
            } else {
              expandByTriangleBounds(_c6, triangleBounds, _bin2.leftCacheBounds);
              _bin2.count++;
            }
          }
        } // expand all the bounds


        for (var _bi2 = 0; _bi2 < splitCount; _bi2++) {
          var _bin3 = truncatedBins[_bi2];
          var leftCount = _bin3.count;
          var rightCount = count - _bin3.count; // check the cost of this split

          var _leftBounds = _bin3.leftCacheBounds;
          var rightBounds = _bin3.rightCacheBounds;
          var leftProb = 0;

          if (leftCount !== 0) {
            leftProb = computeSurfaceArea(_leftBounds) / rootSurfaceArea;
          }

          var rightProb = 0;

          if (rightCount !== 0) {
            rightProb = computeSurfaceArea(rightBounds) / rootSurfaceArea;
          }

          var cost = TRAVERSAL_COST + TRIANGLE_INTERSECT_COST * (leftProb * leftCount + rightProb * rightCount);

          if (cost < bestCost) {
            axis = a;
            bestCost = cost;
            pos = _bin3.candidate;
          }
        }
      } else {
        // reset the bins
        for (var _i304 = 0; _i304 < BIN_COUNT; _i304++) {
          var _bin4 = sahBins[_i304];
          _bin4.count = 0;
          _bin4.candidate = axisLeft + binWidth + _i304 * binWidth;
          var _bounds = _bin4.bounds;

          for (var _d2 = 0; _d2 < 3; _d2++) {
            _bounds[_d2] = Infinity;
            _bounds[_d2 + 3] = -Infinity;
          }
        } // iterate over all center positions


        for (var _c7 = cStart; _c7 < cEnd; _c7 += 6) {
          var triCenter = triangleBounds[_c7 + 2 * a];
          var relativeCenter = triCenter - axisLeft; // in the partition function if the centroid lies on the split plane then it is
          // considered to be on the right side of the split

          var binIndex = ~~(relativeCenter / binWidth);
          if (binIndex >= BIN_COUNT) binIndex = BIN_COUNT - 1;
          var _bin5 = sahBins[binIndex];
          _bin5.count++;
          expandByTriangleBounds(_c7, triangleBounds, _bin5.bounds);
        } // cache the unioned bounds from right to left so we don't have to regenerate them each time


        var lastBin = sahBins[BIN_COUNT - 1];
        copyBounds(lastBin.bounds, lastBin.rightCacheBounds);

        for (var _i305 = BIN_COUNT - 2; _i305 >= 0; _i305--) {
          var _bin6 = sahBins[_i305];
          var nextBin = sahBins[_i305 + 1];
          unionBounds(_bin6.bounds, nextBin.rightCacheBounds, _bin6.rightCacheBounds);
        }

        var _leftCount = 0;

        for (var _i306 = 0; _i306 < BIN_COUNT - 1; _i306++) {
          var _bin7 = sahBins[_i306];
          var binCount = _bin7.count;
          var _bounds2 = _bin7.bounds;
          var _nextBin = sahBins[_i306 + 1];
          var _rightBounds = _nextBin.rightCacheBounds; // don't do anything with the bounds if the new bounds have no triangles

          if (binCount !== 0) {
            if (_leftCount === 0) {
              copyBounds(_bounds2, leftBounds);
            } else {
              unionBounds(_bounds2, leftBounds, leftBounds);
            }
          }

          _leftCount += binCount; // check the cost of this split

          var _leftProb = 0;
          var _rightProb = 0;

          if (_leftCount !== 0) {
            _leftProb = computeSurfaceArea(leftBounds) / rootSurfaceArea;
          }

          var _rightCount = count - _leftCount;

          if (_rightCount !== 0) {
            _rightProb = computeSurfaceArea(_rightBounds) / rootSurfaceArea;
          }

          var _cost = TRAVERSAL_COST + TRIANGLE_INTERSECT_COST * (_leftProb * _leftCount + _rightProb * _rightCount);

          if (_cost < bestCost) {
            axis = a;
            bestCost = _cost;
            pos = _bin7.candidate;
          }
        }
      }
    }
  } else {
    console.warn("MeshBVH: Invalid build strategy value ".concat(strategy, " used."));
  }

  return {
    axis: axis,
    pos: pos
  };
} // returns the average coordinate on the specified axis of the all the provided triangles


function getAverage(triangleBounds, offset, count, axis) {
  var avg = 0;

  for (var _i307 = offset, end = offset + count; _i307 < end; _i307++) {
    avg += triangleBounds[_i307 * 6 + axis * 2];
  }

  return avg / count;
} // precomputes the bounding box for each triangle; required for quickly calculating tree splits.
// result is an array of size tris.length * 6 where triangle i maps to a
// [x_center, x_delta, y_center, y_delta, z_center, z_delta] tuple starting at index i * 6,
// representing the center and half-extent in each dimension of triangle i


function computeTriangleBounds(geo, fullBounds) {
  var posAttr = geo.attributes.position;
  var index = geo.index.array;
  var triCount = index.length / 3;
  var triangleBounds = new Float32Array(triCount * 6);
  var normalized = posAttr.normalized; // used for non-normalized positions

  var posArr = posAttr.array; // support for an interleaved position buffer

  var bufferOffset = posAttr.offset || 0;
  var stride = 3;

  if (posAttr.isInterleavedBufferAttribute) {
    stride = posAttr.data.stride;
  } // used for normalized positions


  var getters = ['getX', 'getY', 'getZ'];

  for (var tri = 0; tri < triCount; tri++) {
    var tri3 = tri * 3;
    var tri6 = tri * 6;
    var ai = void 0,
        bi = void 0,
        ci = void 0;

    if (normalized) {
      ai = index[tri3 + 0];
      bi = index[tri3 + 1];
      ci = index[tri3 + 2];
    } else {
      ai = index[tri3 + 0] * stride + bufferOffset;
      bi = index[tri3 + 1] * stride + bufferOffset;
      ci = index[tri3 + 2] * stride + bufferOffset;
    }

    for (var el = 0; el < 3; el++) {
      var a = void 0,
          b = void 0,
          c = void 0;

      if (normalized) {
        a = posAttr[getters[el]](ai);
        b = posAttr[getters[el]](bi);
        c = posAttr[getters[el]](ci);
      } else {
        a = posArr[ai + el];
        b = posArr[bi + el];
        c = posArr[ci + el];
      }

      var min = a;
      if (b < min) min = b;
      if (c < min) min = c;
      var max = a;
      if (b > max) max = b;
      if (c > max) max = c; // Increase the bounds size by float32 epsilon to avoid precision errors when
      // converting to 32 bit float. Scale the epsilon by the size of the numbers being
      // worked with.

      var halfExtents = (max - min) / 2;
      var el2 = el * 2;
      triangleBounds[tri6 + el2 + 0] = min + halfExtents;
      triangleBounds[tri6 + el2 + 1] = halfExtents + (Math.abs(min) + halfExtents) * FLOAT32_EPSILON;
      if (min < fullBounds[el]) fullBounds[el] = min;
      if (max > fullBounds[el + 3]) fullBounds[el + 3] = max;
    }
  }

  return triangleBounds;
}

function buildTree(geo, options) {
  function triggerProgress(trianglesProcessed) {
    if (onProgress) {
      onProgress(trianglesProcessed / totalTriangles);
    }
  } // either recursively splits the given node, creating left and right subtrees for it, or makes it a leaf node,
  // recording the offset and count of its triangles and writing them into the reordered geometry index.


  function splitNode(node, offset, count) {
    var centroidBoundingData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var depth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    if (!reachedMaxDepth && depth >= maxDepth) {
      reachedMaxDepth = true;

      if (verbose) {
        console.warn("MeshBVH: Max depth of ".concat(maxDepth, " reached when generating BVH. Consider increasing maxDepth."));
        console.warn(geo);
      }
    } // early out if we've met our capacity


    if (count <= maxLeafTris || depth >= maxDepth) {
      triggerProgress(offset + count);
      node.offset = offset;
      node.count = count;
      return node;
    } // Find where to split the volume


    var split = getOptimalSplit(node.boundingData, centroidBoundingData, triangleBounds, offset, count, strategy);

    if (split.axis === -1) {
      triggerProgress(offset + count);
      node.offset = offset;
      node.count = count;
      return node;
    }

    var splitOffset = partition(indexArray, triangleBounds, offset, count, split); // create the two new child nodes

    if (splitOffset === offset || splitOffset === offset + count) {
      triggerProgress(offset + count);
      node.offset = offset;
      node.count = count;
    } else {
      node.splitAxis = split.axis; // create the left child and compute its bounding box

      var left = new MeshBVHNode();
      var lstart = offset;
      var lcount = splitOffset - offset;
      node.left = left;
      left.boundingData = new Float32Array(6);
      getBounds(triangleBounds, lstart, lcount, left.boundingData, cacheCentroidBoundingData);
      splitNode(left, lstart, lcount, cacheCentroidBoundingData, depth + 1); // repeat for right

      var right = new MeshBVHNode();
      var rstart = splitOffset;
      var rcount = count - lcount;
      node.right = right;
      right.boundingData = new Float32Array(6);
      getBounds(triangleBounds, rstart, rcount, right.boundingData, cacheCentroidBoundingData);
      splitNode(right, rstart, rcount, cacheCentroidBoundingData, depth + 1);
    }

    return node;
  }

  ensureIndex(geo, options); // Compute the full bounds of the geometry at the same time as triangle bounds because
  // we'll need it for the root bounds in the case with no groups and it should be fast here.
  // We can't use the geometrying bounding box if it's available because it may be out of date.

  var fullBounds = new Float32Array(6);
  var cacheCentroidBoundingData = new Float32Array(6);
  var triangleBounds = computeTriangleBounds(geo, fullBounds);
  var indexArray = geo.index.array;
  var maxDepth = options.maxDepth;
  var verbose = options.verbose;
  var maxLeafTris = options.maxLeafTris;
  var strategy = options.strategy;
  var onProgress = options.onProgress;
  var totalTriangles = geo.index.count / 3;
  var reachedMaxDepth = false;
  var roots = [];
  var ranges = getRootIndexRanges(geo);

  if (ranges.length === 1) {
    var range = ranges[0];
    var root = new MeshBVHNode();
    root.boundingData = fullBounds;
    getCentroidBounds(triangleBounds, range.offset, range.count, cacheCentroidBoundingData);
    splitNode(root, range.offset, range.count, cacheCentroidBoundingData);
    roots.push(root);
  } else {
    var _iterator8 = _createForOfIteratorHelper(ranges),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var _range = _step8.value;

        var _root = new MeshBVHNode();

        _root.boundingData = new Float32Array(6);
        getBounds(triangleBounds, _range.offset, _range.count, _root.boundingData, cacheCentroidBoundingData);
        splitNode(_root, _range.offset, _range.count, cacheCentroidBoundingData);
        roots.push(_root);
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }
  }

  return roots;
}

function buildPackedTree(geo, options) {
  // boundingData  				: 6 float32
  // right / offset 				: 1 uint32
  // splitAxis / isLeaf + count 	: 1 uint32 / 2 uint16
  var roots = buildTree(geo, options);
  var float32Array;
  var uint32Array;
  var uint16Array;
  var packedRoots = [];
  var BufferConstructor = options.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;

  for (var _i308 = 0; _i308 < roots.length; _i308++) {
    var root = roots[_i308];
    var nodeCount = countNodes(root);
    var buffer = new BufferConstructor(BYTES_PER_NODE * nodeCount);
    float32Array = new Float32Array(buffer);
    uint32Array = new Uint32Array(buffer);
    uint16Array = new Uint16Array(buffer);
    populateBuffer(0, root);
    packedRoots.push(buffer);
  }

  return packedRoots;

  function countNodes(node) {
    if (node.count) {
      return 1;
    } else {
      return 1 + countNodes(node.left) + countNodes(node.right);
    }
  }

  function populateBuffer(byteOffset, node) {
    var stride4Offset = byteOffset / 4;
    var stride2Offset = byteOffset / 2;
    var isLeaf = !!node.count;
    var boundingData = node.boundingData;

    for (var _i309 = 0; _i309 < 6; _i309++) {
      float32Array[stride4Offset + _i309] = boundingData[_i309];
    }

    if (isLeaf) {
      var offset = node.offset;
      var count = node.count;
      uint32Array[stride4Offset + 6] = offset;
      uint16Array[stride2Offset + 14] = count;
      uint16Array[stride2Offset + 15] = IS_LEAFNODE_FLAG;
      return byteOffset + BYTES_PER_NODE;
    } else {
      var left = node.left;
      var right = node.right;
      var splitAxis = node.splitAxis;
      var nextUnusedPointer;
      nextUnusedPointer = populateBuffer(byteOffset + BYTES_PER_NODE, left);

      if (nextUnusedPointer / 4 > Math.pow(2, 32)) {
        throw new Error('MeshBVH: Cannot store child pointer greater than 32 bits.');
      }

      uint32Array[stride4Offset + 6] = nextUnusedPointer / 4;
      nextUnusedPointer = populateBuffer(nextUnusedPointer, right);
      uint32Array[stride4Offset + 7] = splitAxis;
      return nextUnusedPointer;
    }
  }
}

var SeparatingAxisBounds = /*#__PURE__*/function () {
  function SeparatingAxisBounds() {
    _classCallCheck2(this, SeparatingAxisBounds);

    this.min = Infinity;
    this.max = -Infinity;
  }

  _createClass2(SeparatingAxisBounds, [{
    key: "setFromPointsField",
    value: function setFromPointsField(points, field) {
      var min = Infinity;
      var max = -Infinity;

      for (var _i310 = 0, l = points.length; _i310 < l; _i310++) {
        var p = points[_i310];
        var val = p[field];
        min = val < min ? val : min;
        max = val > max ? val : max;
      }

      this.min = min;
      this.max = max;
    }
  }, {
    key: "setFromPoints",
    value: function setFromPoints(axis, points) {
      var min = Infinity;
      var max = -Infinity;

      for (var _i311 = 0, l = points.length; _i311 < l; _i311++) {
        var p = points[_i311];
        var val = axis.dot(p);
        min = val < min ? val : min;
        max = val > max ? val : max;
      }

      this.min = min;
      this.max = max;
    }
  }, {
    key: "isSeparated",
    value: function isSeparated(other) {
      return this.min > other.max || other.min > this.max;
    }
  }]);

  return SeparatingAxisBounds;
}();

SeparatingAxisBounds.prototype.setFromBox = function () {
  var p = new Vector3();
  return function setFromBox(axis, box) {
    var boxMin = box.min;
    var boxMax = box.max;
    var min = Infinity;
    var max = -Infinity;

    for (var x = 0; x <= 1; x++) {
      for (var y = 0; y <= 1; y++) {
        for (var z = 0; z <= 1; z++) {
          p.x = boxMin.x * x + boxMax.x * (1 - x);
          p.y = boxMin.y * y + boxMax.y * (1 - y);
          p.z = boxMin.z * z + boxMax.z * (1 - z);
          var val = axis.dot(p);
          min = Math.min(val, min);
          max = Math.max(val, max);
        }
      }
    }

    this.min = min;
    this.max = max;
  };
}();

var closestPointLineToLine = function () {
  // https://github.com/juj/MathGeoLib/blob/master/src/Geometry/Line.cpp#L56
  var dir1 = new Vector3();
  var dir2 = new Vector3();
  var v02 = new Vector3();
  return function closestPointLineToLine(l1, l2, result) {
    var v0 = l1.start;
    var v10 = dir1;
    var v2 = l2.start;
    var v32 = dir2;
    v02.subVectors(v0, v2);
    dir1.subVectors(l1.end, l1.start);
    dir2.subVectors(l2.end, l2.start); // float d0232 = v02.Dot(v32);

    var d0232 = v02.dot(v32); // float d3210 = v32.Dot(v10);

    var d3210 = v32.dot(v10); // float d3232 = v32.Dot(v32);

    var d3232 = v32.dot(v32); // float d0210 = v02.Dot(v10);

    var d0210 = v02.dot(v10); // float d1010 = v10.Dot(v10);

    var d1010 = v10.dot(v10); // float denom = d1010*d3232 - d3210*d3210;

    var denom = d1010 * d3232 - d3210 * d3210;
    var d, d2;

    if (denom !== 0) {
      d = (d0232 * d3210 - d0210 * d3232) / denom;
    } else {
      d = 0;
    }

    d2 = (d0232 + d * d3210) / d3232;
    result.x = d;
    result.y = d2;
  };
}();

var closestPointsSegmentToSegment = function () {
  // https://github.com/juj/MathGeoLib/blob/master/src/Geometry/LineSegment.cpp#L187
  var paramResult = new Vector2();
  var temp1 = new Vector3();
  var temp2 = new Vector3();
  return function closestPointsSegmentToSegment(l1, l2, target1, target2) {
    closestPointLineToLine(l1, l2, paramResult);
    var d = paramResult.x;
    var d2 = paramResult.y;

    if (d >= 0 && d <= 1 && d2 >= 0 && d2 <= 1) {
      l1.at(d, target1);
      l2.at(d2, target2);
      return;
    } else if (d >= 0 && d <= 1) {
      // Only d2 is out of bounds.
      if (d2 < 0) {
        l2.at(0, target2);
      } else {
        l2.at(1, target2);
      }

      l1.closestPointToPoint(target2, true, target1);
      return;
    } else if (d2 >= 0 && d2 <= 1) {
      // Only d is out of bounds.
      if (d < 0) {
        l1.at(0, target1);
      } else {
        l1.at(1, target1);
      }

      l2.closestPointToPoint(target1, true, target2);
      return;
    } else {
      // Both u and u2 are out of bounds.
      var p;

      if (d < 0) {
        p = l1.start;
      } else {
        p = l1.end;
      }

      var p2;

      if (d2 < 0) {
        p2 = l2.start;
      } else {
        p2 = l2.end;
      }

      var closestPoint = temp1;
      var closestPoint2 = temp2;
      l1.closestPointToPoint(p2, true, temp1);
      l2.closestPointToPoint(p, true, temp2);

      if (closestPoint.distanceToSquared(p2) <= closestPoint2.distanceToSquared(p)) {
        target1.copy(closestPoint);
        target2.copy(p2);
        return;
      } else {
        target1.copy(p);
        target2.copy(closestPoint2);
        return;
      }
    }
  };
}();

var sphereIntersectTriangle = function () {
  // https://stackoverflow.com/questions/34043955/detect-collision-between-sphere-and-triangle-in-three-js
  var closestPointTemp = new Vector3();
  var projectedPointTemp = new Vector3();
  var planeTemp = new Plane();
  var lineTemp = new Line3();
  return function sphereIntersectTriangle(sphere, triangle) {
    var radius = sphere.radius,
        center = sphere.center;
    var a = triangle.a,
        b = triangle.b,
        c = triangle.c; // phase 1

    lineTemp.start = a;
    lineTemp.end = b;
    var closestPoint1 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
    if (closestPoint1.distanceTo(center) <= radius) return true;
    lineTemp.start = a;
    lineTemp.end = c;
    var closestPoint2 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
    if (closestPoint2.distanceTo(center) <= radius) return true;
    lineTemp.start = b;
    lineTemp.end = c;
    var closestPoint3 = lineTemp.closestPointToPoint(center, true, closestPointTemp);
    if (closestPoint3.distanceTo(center) <= radius) return true; // phase 2

    var plane = triangle.getPlane(planeTemp);
    var dp = Math.abs(plane.distanceToPoint(center));

    if (dp <= radius) {
      var pp = plane.projectPoint(center, projectedPointTemp);
      var cp = triangle.containsPoint(pp);
      if (cp) return true;
    }

    return false;
  };
}();

var DIST_EPSILON = 1e-15;

function isNearZero(value) {
  return Math.abs(value) < DIST_EPSILON;
}

var ExtendedTriangle = /*#__PURE__*/function (_Triangle) {
  _inherits(ExtendedTriangle, _Triangle);

  var _super91 = _createSuper(ExtendedTriangle);

  function ExtendedTriangle() {
    var _this83;

    _classCallCheck2(this, ExtendedTriangle);

    for (var _len5 = arguments.length, args = new Array(_len5), _key7 = 0; _key7 < _len5; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this83 = _super91.call.apply(_super91, [this].concat(args));
    _this83.isExtendedTriangle = true;
    _this83.satAxes = new Array(4).fill().map(function () {
      return new Vector3();
    });
    _this83.satBounds = new Array(4).fill().map(function () {
      return new SeparatingAxisBounds();
    });
    _this83.points = [_this83.a, _this83.b, _this83.c];
    _this83.sphere = new Sphere();
    _this83.plane = new Plane();
    _this83.needsUpdate = true;
    return _this83;
  }

  _createClass2(ExtendedTriangle, [{
    key: "intersectsSphere",
    value: function intersectsSphere(sphere) {
      return sphereIntersectTriangle(sphere, this);
    }
  }, {
    key: "update",
    value: function update() {
      var a = this.a;
      var b = this.b;
      var c = this.c;
      var points = this.points;
      var satAxes = this.satAxes;
      var satBounds = this.satBounds;
      var axis0 = satAxes[0];
      var sab0 = satBounds[0];
      this.getNormal(axis0);
      sab0.setFromPoints(axis0, points);
      var axis1 = satAxes[1];
      var sab1 = satBounds[1];
      axis1.subVectors(a, b);
      sab1.setFromPoints(axis1, points);
      var axis2 = satAxes[2];
      var sab2 = satBounds[2];
      axis2.subVectors(b, c);
      sab2.setFromPoints(axis2, points);
      var axis3 = satAxes[3];
      var sab3 = satBounds[3];
      axis3.subVectors(c, a);
      sab3.setFromPoints(axis3, points);
      this.sphere.setFromPoints(this.points);
      this.plane.setFromNormalAndCoplanarPoint(axis0, a);
      this.needsUpdate = false;
    }
  }]);

  return ExtendedTriangle;
}(Triangle);

ExtendedTriangle.prototype.closestPointToSegment = function () {
  var point1 = new Vector3();
  var point2 = new Vector3();
  var edge = new Line3();
  return function distanceToSegment(segment) {
    var target1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var target2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var start = segment.start,
        end = segment.end;
    var points = this.points;
    var distSq;
    var closestDistanceSq = Infinity; // check the triangle edges

    for (var _i312 = 0; _i312 < 3; _i312++) {
      var nexti = (_i312 + 1) % 3;
      edge.start.copy(points[_i312]);
      edge.end.copy(points[nexti]);
      closestPointsSegmentToSegment(edge, segment, point1, point2);
      distSq = point1.distanceToSquared(point2);

      if (distSq < closestDistanceSq) {
        closestDistanceSq = distSq;
        if (target1) target1.copy(point1);
        if (target2) target2.copy(point2);
      }
    } // check end points


    this.closestPointToPoint(start, point1);
    distSq = start.distanceToSquared(point1);

    if (distSq < closestDistanceSq) {
      closestDistanceSq = distSq;
      if (target1) target1.copy(point1);
      if (target2) target2.copy(start);
    }

    this.closestPointToPoint(end, point1);
    distSq = end.distanceToSquared(point1);

    if (distSq < closestDistanceSq) {
      closestDistanceSq = distSq;
      if (target1) target1.copy(point1);
      if (target2) target2.copy(end);
    }

    return Math.sqrt(closestDistanceSq);
  };
}();

ExtendedTriangle.prototype.intersectsTriangle = function () {
  var saTri2 = new ExtendedTriangle();
  var arr1 = new Array(3);
  var arr2 = new Array(3);
  var cachedSatBounds = new SeparatingAxisBounds();
  var cachedSatBounds2 = new SeparatingAxisBounds();
  var cachedAxis = new Vector3();
  var dir1 = new Vector3();
  var dir2 = new Vector3();
  var tempDir = new Vector3();
  var edge = new Line3();
  var edge1 = new Line3();
  var edge2 = new Line3(); // TODO: If the triangles are coplanar and intersecting the target is nonsensical. It should at least
  // be a line contained by both triangles if not a different special case somehow represented in the return result.

  return function intersectsTriangle(other) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var suppressLog = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (this.needsUpdate) {
      this.update();
    }

    if (!other.isExtendedTriangle) {
      saTri2.copy(other);
      saTri2.update();
      other = saTri2;
    } else if (other.needsUpdate) {
      other.update();
    }

    var plane1 = this.plane;
    var plane2 = other.plane;

    if (Math.abs(plane1.normal.dot(plane2.normal)) > 1.0 - 1e-10) {
      // perform separating axis intersection test only for coplanar triangles
      var satBounds1 = this.satBounds;
      var satAxes1 = this.satAxes;
      arr2[0] = other.a;
      arr2[1] = other.b;
      arr2[2] = other.c;

      for (var _i313 = 0; _i313 < 4; _i313++) {
        var sb = satBounds1[_i313];
        var sa = satAxes1[_i313];
        cachedSatBounds.setFromPoints(sa, arr2);
        if (sb.isSeparated(cachedSatBounds)) return false;
      }

      var satBounds2 = other.satBounds;
      var satAxes2 = other.satAxes;
      arr1[0] = this.a;
      arr1[1] = this.b;
      arr1[2] = this.c;

      for (var _i314 = 0; _i314 < 4; _i314++) {
        var _sb = satBounds2[_i314];
        var _sa = satAxes2[_i314];
        cachedSatBounds.setFromPoints(_sa, arr1);
        if (_sb.isSeparated(cachedSatBounds)) return false;
      } // check crossed axes


      for (var _i315 = 0; _i315 < 4; _i315++) {
        var sa1 = satAxes1[_i315];

        for (var i2 = 0; i2 < 4; i2++) {
          var sa2 = satAxes2[i2];
          cachedAxis.crossVectors(sa1, sa2);
          cachedSatBounds.setFromPoints(cachedAxis, arr1);
          cachedSatBounds2.setFromPoints(cachedAxis, arr2);
          if (cachedSatBounds.isSeparated(cachedSatBounds2)) return false;
        }
      }

      if (target) {
        // TODO find two points that intersect on the edges and make that the result
        if (!suppressLog) {
          console.warn('ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0.');
        }

        target.start.set(0, 0, 0);
        target.end.set(0, 0, 0);
      }

      return true;
    } else {
      // find the edge that intersects the other triangle plane
      var points1 = this.points;
      var found1 = false;
      var count1 = 0;

      for (var _i316 = 0; _i316 < 3; _i316++) {
        var p = points1[_i316];
        var pNext = points1[(_i316 + 1) % 3];
        edge.start.copy(p);
        edge.end.copy(pNext);
        edge.delta(dir1);
        var targetPoint = found1 ? edge1.start : edge1.end;
        var startIntersects = isNearZero(plane2.distanceToPoint(p));

        if (isNearZero(plane2.normal.dot(dir1)) && startIntersects) {
          // if the edge lies on the plane then take the line
          edge1.copy(edge);
          count1 = 2;
          break;
        } // check if the start point is near the plane because "intersectLine" is not robust to that case


        var doesIntersect = plane2.intersectLine(edge, targetPoint) || startIntersects;

        if (doesIntersect && !isNearZero(targetPoint.distanceTo(pNext))) {
          count1++;

          if (found1) {
            break;
          }

          found1 = true;
        }
      }

      if (count1 === 1 && other.containsPoint(edge1.end)) {
        if (target) {
          target.start.copy(edge1.end);
          target.end.copy(edge1.end);
        }

        return true;
      } else if (count1 !== 2) {
        return false;
      } // find the other triangles edge that intersects this plane


      var points2 = other.points;
      var found2 = false;
      var count2 = 0;

      for (var _i317 = 0; _i317 < 3; _i317++) {
        var _p2 = points2[_i317];
        var _pNext = points2[(_i317 + 1) % 3];
        edge.start.copy(_p2);
        edge.end.copy(_pNext);
        edge.delta(dir2);

        var _targetPoint = found2 ? edge2.start : edge2.end;

        var _startIntersects = isNearZero(plane1.distanceToPoint(_p2));

        if (isNearZero(plane1.normal.dot(dir2)) && _startIntersects) {
          // if the edge lies on the plane then take the line
          edge2.copy(edge);
          count2 = 2;
          break;
        } // check if the start point is near the plane because "intersectLine" is not robust to that case


        var _doesIntersect = plane1.intersectLine(edge, _targetPoint) || _startIntersects;

        if (_doesIntersect && !isNearZero(_targetPoint.distanceTo(_pNext))) {
          count2++;

          if (found2) {
            break;
          }

          found2 = true;
        }
      }

      if (count2 === 1 && this.containsPoint(edge2.end)) {
        if (target) {
          target.start.copy(edge2.end);
          target.end.copy(edge2.end);
        }

        return true;
      } else if (count2 !== 2) {
        return false;
      } // find swap the second edge so both lines are running the same direction


      edge1.delta(dir1);
      edge2.delta(dir2);

      if (dir1.dot(dir2) < 0) {
        var _tmp4 = edge2.start;
        edge2.start = edge2.end;
        edge2.end = _tmp4;
      } // check if the edges are overlapping


      var s1 = edge1.start.dot(dir1);
      var e1 = edge1.end.dot(dir1);
      var s2 = edge2.start.dot(dir1);
      var e2 = edge2.end.dot(dir1);
      var separated1 = e1 < s2;
      var separated2 = s1 < e2;

      if (s1 !== e2 && s2 !== e1 && separated1 === separated2) {
        return false;
      } // assign the target output


      if (target) {
        tempDir.subVectors(edge1.start, edge2.start);

        if (tempDir.dot(dir1) > 0) {
          target.start.copy(edge1.start);
        } else {
          target.start.copy(edge2.start);
        }

        tempDir.subVectors(edge1.end, edge2.end);

        if (tempDir.dot(dir1) < 0) {
          target.end.copy(edge1.end);
        } else {
          target.end.copy(edge2.end);
        }
      }

      return true;
    }
  };
}();

ExtendedTriangle.prototype.distanceToPoint = function () {
  var target = new Vector3();
  return function distanceToPoint(point) {
    this.closestPointToPoint(point, target);
    return point.distanceTo(target);
  };
}();

ExtendedTriangle.prototype.distanceToTriangle = function () {
  var point = new Vector3();
  var point2 = new Vector3();
  var cornerFields = ['a', 'b', 'c'];
  var line1 = new Line3();
  var line2 = new Line3();
  return function distanceToTriangle(other) {
    var target1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var target2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var lineTarget = target1 || target2 ? line1 : null;

    if (this.intersectsTriangle(other, lineTarget)) {
      if (target1 || target2) {
        if (target1) lineTarget.getCenter(target1);
        if (target2) lineTarget.getCenter(target2);
      }

      return 0;
    }

    var closestDistanceSq = Infinity; // check all point distances

    for (var _i318 = 0; _i318 < 3; _i318++) {
      var dist = void 0;
      var field = cornerFields[_i318];
      var otherVec = other[field];
      this.closestPointToPoint(otherVec, point);
      dist = otherVec.distanceToSquared(point);

      if (dist < closestDistanceSq) {
        closestDistanceSq = dist;
        if (target1) target1.copy(point);
        if (target2) target2.copy(otherVec);
      }

      var thisVec = this[field];
      other.closestPointToPoint(thisVec, point);
      dist = thisVec.distanceToSquared(point);

      if (dist < closestDistanceSq) {
        closestDistanceSq = dist;
        if (target1) target1.copy(thisVec);
        if (target2) target2.copy(point);
      }
    }

    for (var _i319 = 0; _i319 < 3; _i319++) {
      var f11 = cornerFields[_i319];
      var f12 = cornerFields[(_i319 + 1) % 3];
      line1.set(this[f11], this[f12]);

      for (var i2 = 0; i2 < 3; i2++) {
        var f21 = cornerFields[i2];
        var f22 = cornerFields[(i2 + 1) % 3];
        line2.set(other[f21], other[f22]);
        closestPointsSegmentToSegment(line1, line2, point, point2);

        var _dist = point.distanceToSquared(point2);

        if (_dist < closestDistanceSq) {
          closestDistanceSq = _dist;
          if (target1) target1.copy(point);
          if (target2) target2.copy(point2);
        }
      }
    }

    return Math.sqrt(closestDistanceSq);
  };
}();

var OrientedBox = /*#__PURE__*/function () {
  function OrientedBox(min, max, matrix) {
    _classCallCheck2(this, OrientedBox);

    this.isOrientedBox = true;
    this.min = new Vector3();
    this.max = new Vector3();
    this.matrix = new Matrix4();
    this.invMatrix = new Matrix4();
    this.points = new Array(8).fill().map(function () {
      return new Vector3();
    });
    this.satAxes = new Array(3).fill().map(function () {
      return new Vector3();
    });
    this.satBounds = new Array(3).fill().map(function () {
      return new SeparatingAxisBounds();
    });
    this.alignedSatBounds = new Array(3).fill().map(function () {
      return new SeparatingAxisBounds();
    });
    this.needsUpdate = false;
    if (min) this.min.copy(min);
    if (max) this.max.copy(max);
    if (matrix) this.matrix.copy(matrix);
  }

  _createClass2(OrientedBox, [{
    key: "set",
    value: function set(min, max, matrix) {
      this.min.copy(min);
      this.max.copy(max);
      this.matrix.copy(matrix);
      this.needsUpdate = true;
    }
  }, {
    key: "copy",
    value: function copy(other) {
      this.min.copy(other.min);
      this.max.copy(other.max);
      this.matrix.copy(other.matrix);
      this.needsUpdate = true;
    }
  }]);

  return OrientedBox;
}();

OrientedBox.prototype.update = function () {
  return function update() {
    var matrix = this.matrix;
    var min = this.min;
    var max = this.max;
    var points = this.points;

    for (var x = 0; x <= 1; x++) {
      for (var y = 0; y <= 1; y++) {
        for (var z = 0; z <= 1; z++) {
          var _i320 = (1 << 0) * x | (1 << 1) * y | (1 << 2) * z;

          var v = points[_i320];
          v.x = x ? max.x : min.x;
          v.y = y ? max.y : min.y;
          v.z = z ? max.z : min.z;
          v.applyMatrix4(matrix);
        }
      }
    }

    var satBounds = this.satBounds;
    var satAxes = this.satAxes;
    var minVec = points[0];

    for (var _i321 = 0; _i321 < 3; _i321++) {
      var axis = satAxes[_i321];
      var sb = satBounds[_i321];

      var _index14 = 1 << _i321;

      var pi = points[_index14];
      axis.subVectors(minVec, pi);
      sb.setFromPoints(axis, points);
    }

    var alignedSatBounds = this.alignedSatBounds;
    alignedSatBounds[0].setFromPointsField(points, 'x');
    alignedSatBounds[1].setFromPointsField(points, 'y');
    alignedSatBounds[2].setFromPointsField(points, 'z');
    this.invMatrix.copy(this.matrix).invert();
    this.needsUpdate = false;
  };
}();

OrientedBox.prototype.intersectsBox = function () {
  var aabbBounds = new SeparatingAxisBounds();
  return function intersectsBox(box) {
    // TODO: should this be doing SAT against the AABB?
    if (this.needsUpdate) {
      this.update();
    }

    var min = box.min;
    var max = box.max;
    var satBounds = this.satBounds;
    var satAxes = this.satAxes;
    var alignedSatBounds = this.alignedSatBounds;
    aabbBounds.min = min.x;
    aabbBounds.max = max.x;
    if (alignedSatBounds[0].isSeparated(aabbBounds)) return false;
    aabbBounds.min = min.y;
    aabbBounds.max = max.y;
    if (alignedSatBounds[1].isSeparated(aabbBounds)) return false;
    aabbBounds.min = min.z;
    aabbBounds.max = max.z;
    if (alignedSatBounds[2].isSeparated(aabbBounds)) return false;

    for (var _i322 = 0; _i322 < 3; _i322++) {
      var axis = satAxes[_i322];
      var sb = satBounds[_i322];
      aabbBounds.setFromBox(axis, box);
      if (sb.isSeparated(aabbBounds)) return false;
    }

    return true;
  };
}();

OrientedBox.prototype.intersectsTriangle = function () {
  var saTri = new ExtendedTriangle();
  var pointsArr = new Array(3);
  var cachedSatBounds = new SeparatingAxisBounds();
  var cachedSatBounds2 = new SeparatingAxisBounds();
  var cachedAxis = new Vector3();
  return function intersectsTriangle(triangle) {
    if (this.needsUpdate) {
      this.update();
    }

    if (!triangle.isExtendedTriangle) {
      saTri.copy(triangle);
      saTri.update();
      triangle = saTri;
    } else if (triangle.needsUpdate) {
      triangle.update();
    }

    var satBounds = this.satBounds;
    var satAxes = this.satAxes;
    pointsArr[0] = triangle.a;
    pointsArr[1] = triangle.b;
    pointsArr[2] = triangle.c;

    for (var _i323 = 0; _i323 < 3; _i323++) {
      var sb = satBounds[_i323];
      var sa = satAxes[_i323];
      cachedSatBounds.setFromPoints(sa, pointsArr);
      if (sb.isSeparated(cachedSatBounds)) return false;
    }

    var triSatBounds = triangle.satBounds;
    var triSatAxes = triangle.satAxes;
    var points = this.points;

    for (var _i324 = 0; _i324 < 3; _i324++) {
      var _sb2 = triSatBounds[_i324];
      var _sa2 = triSatAxes[_i324];
      cachedSatBounds.setFromPoints(_sa2, points);
      if (_sb2.isSeparated(cachedSatBounds)) return false;
    } // check crossed axes


    for (var _i325 = 0; _i325 < 3; _i325++) {
      var sa1 = satAxes[_i325];

      for (var i2 = 0; i2 < 4; i2++) {
        var sa2 = triSatAxes[i2];
        cachedAxis.crossVectors(sa1, sa2);
        cachedSatBounds.setFromPoints(cachedAxis, pointsArr);
        cachedSatBounds2.setFromPoints(cachedAxis, points);
        if (cachedSatBounds.isSeparated(cachedSatBounds2)) return false;
      }
    }

    return true;
  };
}();

OrientedBox.prototype.closestPointToPoint = function () {
  return function closestPointToPoint(point, target1) {
    if (this.needsUpdate) {
      this.update();
    }

    target1.copy(point).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix);
    return target1;
  };
}();

OrientedBox.prototype.distanceToPoint = function () {
  var target = new Vector3();
  return function distanceToPoint(point) {
    this.closestPointToPoint(point, target);
    return point.distanceTo(target);
  };
}();

OrientedBox.prototype.distanceToBox = function () {
  var xyzFields = ['x', 'y', 'z'];
  var segments1 = new Array(12).fill().map(function () {
    return new Line3();
  });
  var segments2 = new Array(12).fill().map(function () {
    return new Line3();
  });
  var point1 = new Vector3();
  var point2 = new Vector3(); // early out if we find a value below threshold

  return function distanceToBox(box) {
    var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var target1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var target2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    if (this.needsUpdate) {
      this.update();
    }

    if (this.intersectsBox(box)) {
      if (target1 || target2) {
        box.getCenter(point2);
        this.closestPointToPoint(point2, point1);
        box.closestPointToPoint(point1, point2);
        if (target1) target1.copy(point1);
        if (target2) target2.copy(point2);
      }

      return 0;
    }

    var threshold2 = threshold * threshold;
    var min = box.min;
    var max = box.max;
    var points = this.points; // iterate over every edge and compare distances

    var closestDistanceSq = Infinity; // check over all these points

    for (var _i326 = 0; _i326 < 8; _i326++) {
      var p = points[_i326];
      point2.copy(p).clamp(min, max);
      var dist = p.distanceToSquared(point2);

      if (dist < closestDistanceSq) {
        closestDistanceSq = dist;
        if (target1) target1.copy(p);
        if (target2) target2.copy(point2);
        if (dist < threshold2) return Math.sqrt(dist);
      }
    } // generate and check all line segment distances


    var count = 0;

    for (var _i327 = 0; _i327 < 3; _i327++) {
      for (var i1 = 0; i1 <= 1; i1++) {
        for (var i2 = 0; i2 <= 1; i2++) {
          var nextIndex = (_i327 + 1) % 3;
          var nextIndex2 = (_i327 + 2) % 3; // get obb line segments

          var _index15 = i1 << nextIndex | i2 << nextIndex2;

          var index2 = 1 << _i327 | i1 << nextIndex | i2 << nextIndex2;
          var p1 = points[_index15];
          var p2 = points[index2];
          var line1 = segments1[count];
          line1.set(p1, p2); // get aabb line segments

          var f1 = xyzFields[_i327];
          var f2 = xyzFields[nextIndex];
          var f3 = xyzFields[nextIndex2];
          var line2 = segments2[count];
          var start = line2.start;
          var end = line2.end;
          start[f1] = min[f1];
          start[f2] = i1 ? min[f2] : max[f2];
          start[f3] = i2 ? min[f3] : max[f2];
          end[f1] = max[f1];
          end[f2] = i1 ? min[f2] : max[f2];
          end[f3] = i2 ? min[f3] : max[f2];
          count++;
        }
      }
    } // check all the other boxes point


    for (var x = 0; x <= 1; x++) {
      for (var y = 0; y <= 1; y++) {
        for (var z = 0; z <= 1; z++) {
          point2.x = x ? max.x : min.x;
          point2.y = y ? max.y : min.y;
          point2.z = z ? max.z : min.z;
          this.closestPointToPoint(point2, point1);

          var _dist2 = point2.distanceToSquared(point1);

          if (_dist2 < closestDistanceSq) {
            closestDistanceSq = _dist2;
            if (target1) target1.copy(point1);
            if (target2) target2.copy(point2);
            if (_dist2 < threshold2) return Math.sqrt(_dist2);
          }
        }
      }
    }

    for (var _i328 = 0; _i328 < 12; _i328++) {
      var l1 = segments1[_i328];

      for (var _i329 = 0; _i329 < 12; _i329++) {
        var l2 = segments2[_i329];
        closestPointsSegmentToSegment(l1, l2, point1, point2);

        var _dist3 = point1.distanceToSquared(point2);

        if (_dist3 < closestDistanceSq) {
          closestDistanceSq = _dist3;
          if (target1) target1.copy(point1);
          if (target2) target2.copy(point2);
          if (_dist3 < threshold2) return Math.sqrt(_dist3);
        }
      }
    }

    return Math.sqrt(closestDistanceSq);
  };
}(); // Ripped and modified From THREE.js Mesh raycast
// https://github.com/mrdoob/three.js/blob/0aa87c999fe61e216c1133fba7a95772b503eddf/src/objects/Mesh.js#L115


var _vA = /* @__PURE__ */new Vector3();

var _vB = /* @__PURE__ */new Vector3();

var _vC = /* @__PURE__ */new Vector3();

var _uvA = /* @__PURE__ */new Vector2();

var _uvB = /* @__PURE__ */new Vector2();

var _uvC = /* @__PURE__ */new Vector2();

var _normalA = /* @__PURE__ */new Vector3();

var _normalB = /* @__PURE__ */new Vector3();

var _normalC = /* @__PURE__ */new Vector3();

var _intersectionPoint$1 = /* @__PURE__ */new Vector3();

function checkIntersection$1(ray, pA, pB, pC, point, side) {
  var intersect;

  if (side === BackSide) {
    intersect = ray.intersectTriangle(pC, pB, pA, true, point);
  } else {
    intersect = ray.intersectTriangle(pA, pB, pC, side !== DoubleSide, point);
  }

  if (intersect === null) return null;
  var distance = ray.origin.distanceTo(point);
  return {
    distance: distance,
    point: point.clone()
  };
}

function checkBufferGeometryIntersection$1(ray, position, normal, uv, uv1, a, b, c, side) {
  _vA.fromBufferAttribute(position, a);

  _vB.fromBufferAttribute(position, b);

  _vC.fromBufferAttribute(position, c);

  var intersection = checkIntersection$1(ray, _vA, _vB, _vC, _intersectionPoint$1, side);

  if (intersection) {
    if (uv) {
      _uvA.fromBufferAttribute(uv, a);

      _uvB.fromBufferAttribute(uv, b);

      _uvC.fromBufferAttribute(uv, c);

      intersection.uv = Triangle.getInterpolation(_intersectionPoint$1, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2());
    }

    if (uv1) {
      _uvA.fromBufferAttribute(uv1, a);

      _uvB.fromBufferAttribute(uv1, b);

      _uvC.fromBufferAttribute(uv1, c);

      intersection.uv1 = Triangle.getInterpolation(_intersectionPoint$1, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2());
    }

    if (normal) {
      _normalA.fromBufferAttribute(normal, a);

      _normalB.fromBufferAttribute(normal, b);

      _normalC.fromBufferAttribute(normal, c);

      intersection.normal = Triangle.getInterpolation(_intersectionPoint$1, _vA, _vB, _vC, _normalA, _normalB, _normalC, new Vector3());

      if (intersection.normal.dot(ray.direction) > 0) {
        intersection.normal.multiplyScalar(-1);
      }
    }

    var face = {
      a: a,
      b: b,
      c: c,
      normal: new Vector3(),
      materialIndex: 0
    };
    Triangle.getNormal(_vA, _vB, _vC, face.normal);
    intersection.face = face;
    intersection.faceIndex = a;
  }

  return intersection;
} // https://github.com/mrdoob/three.js/blob/0aa87c999fe61e216c1133fba7a95772b503eddf/src/objects/Mesh.js#L258


function intersectTri(geo, side, ray, tri, intersections) {
  var triOffset = tri * 3;
  var a = geo.index.getX(triOffset);
  var b = geo.index.getX(triOffset + 1);
  var c = geo.index.getX(triOffset + 2);
  var _geo$attributes = geo.attributes,
      position = _geo$attributes.position,
      normal = _geo$attributes.normal,
      uv = _geo$attributes.uv,
      uv1 = _geo$attributes.uv1;
  var intersection = checkBufferGeometryIntersection$1(ray, position, normal, uv, uv1, a, b, c, side);

  if (intersection) {
    intersection.faceIndex = tri;
    if (intersections) intersections.push(intersection);
    return intersection;
  }

  return null;
}

function intersectTris(geo, side, ray, offset, count, intersections) {
  for (var _i330 = offset, end = offset + count; _i330 < end; _i330++) {
    intersectTri(geo, side, ray, _i330, intersections);
  }
}

function intersectClosestTri(geo, side, ray, offset, count) {
  var dist = Infinity;
  var res = null;

  for (var _i331 = offset, end = offset + count; _i331 < end; _i331++) {
    var _intersection = intersectTri(geo, side, ray, _i331);

    if (_intersection && _intersection.distance < dist) {
      res = _intersection;
      dist = _intersection.distance;
    }
  }

  return res;
} // converts the given BVH raycast intersection to align with the three.js raycast
// structure (include object, world space distance and point).


function convertRaycastIntersect(hit, object, raycaster) {
  if (hit === null) {
    return null;
  }

  hit.point.applyMatrix4(object.matrixWorld);
  hit.distance = hit.point.distanceTo(raycaster.ray.origin);
  hit.object = object;

  if (hit.distance < raycaster.near || hit.distance > raycaster.far) {
    return null;
  } else {
    return hit;
  }
} // sets the vertices of triangle `tri` with the 3 vertices after i


function setTriangle(tri, i, index, pos) {
  var ta = tri.a;
  var tb = tri.b;
  var tc = tri.c;
  var i0 = i;
  var i1 = i + 1;
  var i2 = i + 2;

  if (index) {
    i0 = index.getX(i);
    i1 = index.getX(i + 1);
    i2 = index.getX(i + 2);
  }

  ta.x = pos.getX(i0);
  ta.y = pos.getY(i0);
  ta.z = pos.getZ(i0);
  tb.x = pos.getX(i1);
  tb.y = pos.getY(i1);
  tb.z = pos.getZ(i1);
  tc.x = pos.getX(i2);
  tc.y = pos.getY(i2);
  tc.z = pos.getZ(i2);
}

function iterateOverTriangles(offset, count, geometry, intersectsTriangleFunc, contained, depth, triangle) {
  var index = geometry.index;
  var pos = geometry.attributes.position;

  for (var _i332 = offset, l = count + offset; _i332 < l; _i332++) {
    setTriangle(triangle, _i332 * 3, index, pos);
    triangle.needsUpdate = true;

    if (intersectsTriangleFunc(triangle, _i332, contained, depth)) {
      return true;
    }
  }

  return false;
}

var PrimitivePool = /*#__PURE__*/function () {
  function PrimitivePool(getNewPrimitive) {
    _classCallCheck2(this, PrimitivePool);

    this._getNewPrimitive = getNewPrimitive;
    this._primitives = [];
  }

  _createClass2(PrimitivePool, [{
    key: "getPrimitive",
    value: function getPrimitive() {
      var primitives = this._primitives;

      if (primitives.length === 0) {
        return this._getNewPrimitive();
      } else {
        return primitives.pop();
      }
    }
  }, {
    key: "releasePrimitive",
    value: function releasePrimitive(primitive) {
      this._primitives.push(primitive);
    }
  }]);

  return PrimitivePool;
}();

function IS_LEAF(n16, uint16Array) {
  return uint16Array[n16 + 15] === 0xFFFF;
}

function OFFSET(n32, uint32Array) {
  return uint32Array[n32 + 6];
}

function COUNT(n16, uint16Array) {
  return uint16Array[n16 + 14];
}

function LEFT_NODE(n32) {
  return n32 + 8;
}

function RIGHT_NODE(n32, uint32Array) {
  return uint32Array[n32 + 6];
}

function SPLIT_AXIS(n32, uint32Array) {
  return uint32Array[n32 + 7];
}

function BOUNDING_DATA_INDEX(n32) {
  return n32;
}

var boundingBox = new Box3();
var boxIntersection = new Vector3();
var xyzFields = ['x', 'y', 'z'];

function _raycast(nodeIndex32, geometry, side, ray, intersects) {
  var nodeIndex16 = nodeIndex32 * 2,
      float32Array = _float32Array,
      uint16Array = _uint16Array,
      uint32Array = _uint32Array;
  var isLeaf = IS_LEAF(nodeIndex16, uint16Array);

  if (isLeaf) {
    var offset = OFFSET(nodeIndex32, uint32Array);
    var count = COUNT(nodeIndex16, uint16Array);
    intersectTris(geometry, side, ray, offset, count, intersects);
  } else {
    var leftIndex = LEFT_NODE(nodeIndex32);

    if (intersectRay(leftIndex, float32Array, ray, boxIntersection)) {
      _raycast(leftIndex, geometry, side, ray, intersects);
    }

    var rightIndex = RIGHT_NODE(nodeIndex32, uint32Array);

    if (intersectRay(rightIndex, float32Array, ray, boxIntersection)) {
      _raycast(rightIndex, geometry, side, ray, intersects);
    }
  }
}

function _raycastFirst(nodeIndex32, geometry, side, ray) {
  var nodeIndex16 = nodeIndex32 * 2,
      float32Array = _float32Array,
      uint16Array = _uint16Array,
      uint32Array = _uint32Array;
  var isLeaf = IS_LEAF(nodeIndex16, uint16Array);

  if (isLeaf) {
    var offset = OFFSET(nodeIndex32, uint32Array);
    var count = COUNT(nodeIndex16, uint16Array);
    return intersectClosestTri(geometry, side, ray, offset, count);
  } else {
    // consider the position of the split plane with respect to the oncoming ray; whichever direction
    // the ray is coming from, look for an intersection among that side of the tree first
    var splitAxis = SPLIT_AXIS(nodeIndex32, uint32Array);
    var xyzAxis = xyzFields[splitAxis];
    var rayDir = ray.direction[xyzAxis];
    var leftToRight = rayDir >= 0; // c1 is the child to check first

    var c1, c2;

    if (leftToRight) {
      c1 = LEFT_NODE(nodeIndex32);
      c2 = RIGHT_NODE(nodeIndex32, uint32Array);
    } else {
      c1 = RIGHT_NODE(nodeIndex32, uint32Array);
      c2 = LEFT_NODE(nodeIndex32);
    }

    var c1Intersection = intersectRay(c1, float32Array, ray, boxIntersection);
    var c1Result = c1Intersection ? _raycastFirst(c1, geometry, side, ray) : null; // if we got an intersection in the first node and it's closer than the second node's bounding
    // box, we don't need to consider the second node because it couldn't possibly be a better result

    if (c1Result) {
      // check if the point is within the second bounds
      // "point" is in the local frame of the bvh
      var point = c1Result.point[xyzAxis];
      var isOutside = leftToRight ? point <= float32Array[c2 + splitAxis] : // min bounding data
      point >= float32Array[c2 + splitAxis + 3]; // max bounding data

      if (isOutside) {
        return c1Result;
      }
    } // either there was no intersection in the first node, or there could still be a closer
    // intersection in the second, so check the second node and then take the better of the two


    var c2Intersection = intersectRay(c2, float32Array, ray, boxIntersection);
    var c2Result = c2Intersection ? _raycastFirst(c2, geometry, side, ray) : null;

    if (c1Result && c2Result) {
      return c1Result.distance <= c2Result.distance ? c1Result : c2Result;
    } else {
      return c1Result || c2Result || null;
    }
  }
}

var _shapecast = function () {
  var _box1, _box2;

  var boxStack = [];
  var boxPool = new PrimitivePool(function () {
    return new Box3();
  });
  return function shapecast() {
    _box1 = boxPool.getPrimitive();
    _box2 = boxPool.getPrimitive();
    boxStack.push(_box1, _box2);
    var result = shapecastTraverse.apply(void 0, arguments);
    boxPool.releasePrimitive(_box1);
    boxPool.releasePrimitive(_box2);
    boxStack.pop();
    boxStack.pop();
    var length = boxStack.length;

    if (length > 0) {
      _box2 = boxStack[length - 1];
      _box1 = boxStack[length - 2];
    }

    return result;
  };

  function shapecastTraverse(nodeIndex32, geometry, intersectsBoundsFunc, intersectsRangeFunc) {
    var nodeScoreFunc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var nodeIndexByteOffset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var depth = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;

    // Define these inside the function so it has access to the local variables needed
    // when converting to the buffer equivalents
    function getLeftOffset(nodeIndex32) {
      var nodeIndex16 = nodeIndex32 * 2,
          uint16Array = _uint16Array,
          uint32Array = _uint32Array; // traverse until we find a leaf

      while (!IS_LEAF(nodeIndex16, uint16Array)) {
        nodeIndex32 = LEFT_NODE(nodeIndex32);
        nodeIndex16 = nodeIndex32 * 2;
      }

      return OFFSET(nodeIndex32, uint32Array);
    }

    function getRightEndOffset(nodeIndex32) {
      var nodeIndex16 = nodeIndex32 * 2,
          uint16Array = _uint16Array,
          uint32Array = _uint32Array; // traverse until we find a leaf

      while (!IS_LEAF(nodeIndex16, uint16Array)) {
        // adjust offset to point to the right node
        nodeIndex32 = RIGHT_NODE(nodeIndex32, uint32Array);
        nodeIndex16 = nodeIndex32 * 2;
      } // return the end offset of the triangle range


      return OFFSET(nodeIndex32, uint32Array) + COUNT(nodeIndex16, uint16Array);
    }

    var nodeIndex16 = nodeIndex32 * 2,
        float32Array = _float32Array,
        uint16Array = _uint16Array,
        uint32Array = _uint32Array;
    var isLeaf = IS_LEAF(nodeIndex16, uint16Array);

    if (isLeaf) {
      var offset = OFFSET(nodeIndex32, uint32Array);
      var count = COUNT(nodeIndex16, uint16Array);
      arrayToBox(BOUNDING_DATA_INDEX(nodeIndex32), float32Array, _box1);
      return intersectsRangeFunc(offset, count, false, depth, nodeIndexByteOffset + nodeIndex32, _box1);
    } else {
      var left = LEFT_NODE(nodeIndex32);
      var right = RIGHT_NODE(nodeIndex32, uint32Array);
      var c1 = left;
      var c2 = right;
      var score1, score2;
      var box1, box2;

      if (nodeScoreFunc) {
        box1 = _box1;
        box2 = _box2; // bounding data is not offset

        arrayToBox(BOUNDING_DATA_INDEX(c1), float32Array, box1);
        arrayToBox(BOUNDING_DATA_INDEX(c2), float32Array, box2);
        score1 = nodeScoreFunc(box1);
        score2 = nodeScoreFunc(box2);

        if (score2 < score1) {
          c1 = right;
          c2 = left;
          var _temp = score1;
          score1 = score2;
          score2 = _temp;
          box1 = box2; // box2 is always set before use below
        }
      } // Check box 1 intersection


      if (!box1) {
        box1 = _box1;
        arrayToBox(BOUNDING_DATA_INDEX(c1), float32Array, box1);
      }

      var isC1Leaf = IS_LEAF(c1 * 2, uint16Array);
      var c1Intersection = intersectsBoundsFunc(box1, isC1Leaf, score1, depth + 1, nodeIndexByteOffset + c1);
      var c1StopTraversal;

      if (c1Intersection === CONTAINED) {
        var _offset2 = getLeftOffset(c1);

        var end = getRightEndOffset(c1);

        var _count2 = end - _offset2;

        c1StopTraversal = intersectsRangeFunc(_offset2, _count2, true, depth + 1, nodeIndexByteOffset + c1, box1);
      } else {
        c1StopTraversal = c1Intersection && shapecastTraverse(c1, geometry, intersectsBoundsFunc, intersectsRangeFunc, nodeScoreFunc, nodeIndexByteOffset, depth + 1);
      }

      if (c1StopTraversal) return true; // Check box 2 intersection
      // cached box2 will have been overwritten by previous traversal

      box2 = _box2;
      arrayToBox(BOUNDING_DATA_INDEX(c2), float32Array, box2);
      var isC2Leaf = IS_LEAF(c2 * 2, uint16Array);
      var c2Intersection = intersectsBoundsFunc(box2, isC2Leaf, score2, depth + 1, nodeIndexByteOffset + c2);
      var c2StopTraversal;

      if (c2Intersection === CONTAINED) {
        var _offset3 = getLeftOffset(c2);

        var _end7 = getRightEndOffset(c2);

        var _count3 = _end7 - _offset3;

        c2StopTraversal = intersectsRangeFunc(_offset3, _count3, true, depth + 1, nodeIndexByteOffset + c2, box2);
      } else {
        c2StopTraversal = c2Intersection && shapecastTraverse(c2, geometry, intersectsBoundsFunc, intersectsRangeFunc, nodeScoreFunc, nodeIndexByteOffset, depth + 1);
      }

      if (c2StopTraversal) return true;
      return false;
    }
  }
}();

var _intersectsGeometry = function () {
  var triangle = new ExtendedTriangle();
  var triangle2 = new ExtendedTriangle();
  var invertedMat = new Matrix4();
  var obb = new OrientedBox();
  var obb2 = new OrientedBox();
  return function intersectsGeometry(nodeIndex32, geometry, otherGeometry, geometryToBvh) {
    var cachedObb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var nodeIndex16 = nodeIndex32 * 2,
        float32Array = _float32Array,
        uint16Array = _uint16Array,
        uint32Array = _uint32Array;

    if (cachedObb === null) {
      if (!otherGeometry.boundingBox) {
        otherGeometry.computeBoundingBox();
      }

      obb.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
      cachedObb = obb;
    }

    var isLeaf = IS_LEAF(nodeIndex16, uint16Array);

    if (isLeaf) {
      var thisGeometry = geometry;
      var thisIndex = thisGeometry.index;
      var thisPos = thisGeometry.attributes.position;
      var _index16 = otherGeometry.index;
      var pos = otherGeometry.attributes.position;
      var offset = OFFSET(nodeIndex32, uint32Array);
      var count = COUNT(nodeIndex16, uint16Array); // get the inverse of the geometry matrix so we can transform our triangles into the
      // geometry space we're trying to test. We assume there are fewer triangles being checked
      // here.

      invertedMat.copy(geometryToBvh).invert();

      if (otherGeometry.boundsTree) {
        arrayToBox(BOUNDING_DATA_INDEX(nodeIndex32), float32Array, obb2);
        obb2.matrix.copy(invertedMat);
        obb2.needsUpdate = true;
        var res = otherGeometry.boundsTree.shapecast({
          intersectsBounds: function intersectsBounds(box) {
            return obb2.intersectsBox(box);
          },
          intersectsTriangle: function intersectsTriangle(tri) {
            tri.a.applyMatrix4(geometryToBvh);
            tri.b.applyMatrix4(geometryToBvh);
            tri.c.applyMatrix4(geometryToBvh);
            tri.needsUpdate = true;

            for (var _i333 = offset * 3, l = (count + offset) * 3; _i333 < l; _i333 += 3) {
              // this triangle needs to be transformed into the current BVH coordinate frame
              setTriangle(triangle2, _i333, thisIndex, thisPos);
              triangle2.needsUpdate = true;

              if (tri.intersectsTriangle(triangle2)) {
                return true;
              }
            }

            return false;
          }
        });
        return res;
      } else {
        for (var _i334 = offset * 3, l = count + offset * 3; _i334 < l; _i334 += 3) {
          // this triangle needs to be transformed into the current BVH coordinate frame
          setTriangle(triangle, _i334, thisIndex, thisPos);
          triangle.a.applyMatrix4(invertedMat);
          triangle.b.applyMatrix4(invertedMat);
          triangle.c.applyMatrix4(invertedMat);
          triangle.needsUpdate = true;

          for (var i2 = 0, l2 = _index16.count; i2 < l2; i2 += 3) {
            setTriangle(triangle2, i2, _index16, pos);
            triangle2.needsUpdate = true;

            if (triangle.intersectsTriangle(triangle2)) {
              return true;
            }
          }
        }
      }
    } else {
      var left = nodeIndex32 + 8;
      var right = uint32Array[nodeIndex32 + 6];
      arrayToBox(BOUNDING_DATA_INDEX(left), float32Array, boundingBox);
      var leftIntersection = cachedObb.intersectsBox(boundingBox) && intersectsGeometry(left, geometry, otherGeometry, geometryToBvh, cachedObb);
      if (leftIntersection) return true;
      arrayToBox(BOUNDING_DATA_INDEX(right), float32Array, boundingBox);
      var rightIntersection = cachedObb.intersectsBox(boundingBox) && intersectsGeometry(right, geometry, otherGeometry, geometryToBvh, cachedObb);
      if (rightIntersection) return true;
      return false;
    }
  };
}();

function intersectRay(nodeIndex32, array, ray, target) {
  arrayToBox(nodeIndex32, array, boundingBox);
  return ray.intersectBox(boundingBox, target);
}

var bufferStack = [];

var _prevBuffer;

var _float32Array;

var _uint16Array;

var _uint32Array;

function setBuffer(buffer) {
  if (_prevBuffer) {
    bufferStack.push(_prevBuffer);
  }

  _prevBuffer = buffer;
  _float32Array = new Float32Array(buffer);
  _uint16Array = new Uint16Array(buffer);
  _uint32Array = new Uint32Array(buffer);
}

function clearBuffer() {
  _prevBuffer = null;
  _float32Array = null;
  _uint16Array = null;
  _uint32Array = null;

  if (bufferStack.length) {
    setBuffer(bufferStack.pop());
  }
}

var SKIP_GENERATION = Symbol('skip tree generation');
var aabb = /* @__PURE__ */new Box3();
var aabb2 = /* @__PURE__ */new Box3();
var tempMatrix = /* @__PURE__ */new Matrix4();
var obb = /* @__PURE__ */new OrientedBox();
var obb2 = /* @__PURE__ */new OrientedBox();
var temp = /* @__PURE__ */new Vector3();
var temp1 = /* @__PURE__ */new Vector3();
var temp2 = /* @__PURE__ */new Vector3();
var temp3 = /* @__PURE__ */new Vector3();
var temp4 = /* @__PURE__ */new Vector3();
var tempBox = /* @__PURE__ */new Box3();
var trianglePool = /* @__PURE__ */new PrimitivePool(function () {
  return new ExtendedTriangle();
});

var MeshBVH = /*#__PURE__*/function () {
  function MeshBVH(geometry) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck2(this, MeshBVH);

    if (!geometry.isBufferGeometry) {
      throw new Error('MeshBVH: Only BufferGeometries are supported.');
    } else if (geometry.index && geometry.index.isInterleavedBufferAttribute) {
      throw new Error('MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.');
    } // default options


    options = Object.assign(_defineProperty({
      strategy: CENTER,
      maxDepth: 40,
      maxLeafTris: 10,
      verbose: true,
      useSharedArrayBuffer: false,
      setBoundingBox: true,
      onProgress: null
    }, SKIP_GENERATION, false), options);

    if (options.useSharedArrayBuffer && typeof SharedArrayBuffer === 'undefined') {
      throw new Error('MeshBVH: SharedArrayBuffer is not available.');
    }

    this._roots = null;

    if (!options[SKIP_GENERATION]) {
      this._roots = buildPackedTree(geometry, options);

      if (!geometry.boundingBox && options.setBoundingBox) {
        geometry.boundingBox = this.getBoundingBox(new Box3());
      }
    } // retain references to the geometry so we can use them it without having to
    // take a geometry reference in every function.


    this.geometry = geometry;
  }

  _createClass2(MeshBVH, [{
    key: "refit",
    value: function refit() {
      var nodeIndices = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (nodeIndices && Array.isArray(nodeIndices)) {
        nodeIndices = new Set(nodeIndices);
      }

      var geometry = this.geometry;
      var indexArr = geometry.index.array;
      var posAttr = geometry.attributes.position;
      var buffer, uint32Array, uint16Array, float32Array;
      var byteOffset = 0;
      var roots = this._roots;

      for (var _i335 = 0, l = roots.length; _i335 < l; _i335++) {
        buffer = roots[_i335];
        uint32Array = new Uint32Array(buffer);
        uint16Array = new Uint16Array(buffer);
        float32Array = new Float32Array(buffer);

        _traverse(0, byteOffset);

        byteOffset += buffer.byteLength;
      }

      function _traverse(node32Index, byteOffset) {
        var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var node16Index = node32Index * 2;
        var isLeaf = uint16Array[node16Index + 15] === IS_LEAFNODE_FLAG;

        if (isLeaf) {
          var offset = uint32Array[node32Index + 6];
          var count = uint16Array[node16Index + 14];
          var minx = Infinity;
          var miny = Infinity;
          var minz = Infinity;
          var maxx = -Infinity;
          var maxy = -Infinity;
          var maxz = -Infinity;

          for (var _i336 = 3 * offset, _l12 = 3 * (offset + count); _i336 < _l12; _i336++) {
            var _index17 = indexArr[_i336];
            var x = posAttr.getX(_index17);
            var y = posAttr.getY(_index17);
            var z = posAttr.getZ(_index17);
            if (x < minx) minx = x;
            if (x > maxx) maxx = x;
            if (y < miny) miny = y;
            if (y > maxy) maxy = y;
            if (z < minz) minz = z;
            if (z > maxz) maxz = z;
          }

          if (float32Array[node32Index + 0] !== minx || float32Array[node32Index + 1] !== miny || float32Array[node32Index + 2] !== minz || float32Array[node32Index + 3] !== maxx || float32Array[node32Index + 4] !== maxy || float32Array[node32Index + 5] !== maxz) {
            float32Array[node32Index + 0] = minx;
            float32Array[node32Index + 1] = miny;
            float32Array[node32Index + 2] = minz;
            float32Array[node32Index + 3] = maxx;
            float32Array[node32Index + 4] = maxy;
            float32Array[node32Index + 5] = maxz;
            return true;
          } else {
            return false;
          }
        } else {
          var left = node32Index + 8;
          var right = uint32Array[node32Index + 6]; // the identifying node indices provided by the shapecast function include offsets of all
          // root buffers to guarantee they're unique between roots so offset left and right indices here.

          var offsetLeft = left + byteOffset;
          var offsetRight = right + byteOffset;
          var forceChildren = force;
          var includesLeft = false;
          var includesRight = false;

          if (nodeIndices) {
            // if we see that neither the left or right child are included in the set that need to be updated
            // then we assume that all children need to be updated.
            if (!forceChildren) {
              includesLeft = nodeIndices.has(offsetLeft);
              includesRight = nodeIndices.has(offsetRight);
              forceChildren = !includesLeft && !includesRight;
            }
          } else {
            includesLeft = true;
            includesRight = true;
          }

          var traverseLeft = forceChildren || includesLeft;
          var traverseRight = forceChildren || includesRight;
          var leftChange = false;

          if (traverseLeft) {
            leftChange = _traverse(left, byteOffset, forceChildren);
          }

          var rightChange = false;

          if (traverseRight) {
            rightChange = _traverse(right, byteOffset, forceChildren);
          }

          var didChange = leftChange || rightChange;

          if (didChange) {
            for (var _i337 = 0; _i337 < 3; _i337++) {
              var lefti = left + _i337;
              var righti = right + _i337;
              var minLeftValue = float32Array[lefti];
              var maxLeftValue = float32Array[lefti + 3];
              var minRightValue = float32Array[righti];
              var maxRightValue = float32Array[righti + 3];
              float32Array[node32Index + _i337] = minLeftValue < minRightValue ? minLeftValue : minRightValue;
              float32Array[node32Index + _i337 + 3] = maxLeftValue > maxRightValue ? maxLeftValue : maxRightValue;
            }
          }

          return didChange;
        }
      }
    }
  }, {
    key: "traverse",
    value: function traverse(callback) {
      var rootIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var buffer = this._roots[rootIndex];
      var uint32Array = new Uint32Array(buffer);
      var uint16Array = new Uint16Array(buffer);

      _traverse(0);

      function _traverse(node32Index) {
        var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var node16Index = node32Index * 2;
        var isLeaf = uint16Array[node16Index + 15] === IS_LEAFNODE_FLAG;

        if (isLeaf) {
          var offset = uint32Array[node32Index + 6];
          var count = uint16Array[node16Index + 14];
          callback(depth, isLeaf, new Float32Array(buffer, node32Index * 4, 6), offset, count);
        } else {
          // TODO: use node functions here
          var left = node32Index + BYTES_PER_NODE / 4;
          var right = uint32Array[node32Index + 6];
          var splitAxis = uint32Array[node32Index + 7];
          var stopTraversal = callback(depth, isLeaf, new Float32Array(buffer, node32Index * 4, 6), splitAxis);

          if (!stopTraversal) {
            _traverse(left, depth + 1);

            _traverse(right, depth + 1);
          }
        }
      }
    }
    /* Core Cast Functions */

  }, {
    key: "raycast",
    value: function raycast(ray) {
      var materialOrSide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FrontSide;
      var roots = this._roots;
      var geometry = this.geometry;
      var intersects = [];
      var isMaterial = materialOrSide.isMaterial;
      var isArrayMaterial = Array.isArray(materialOrSide);
      var groups = geometry.groups;
      var side = isMaterial ? materialOrSide.side : materialOrSide;

      for (var _i338 = 0, l = roots.length; _i338 < l; _i338++) {
        var materialSide = isArrayMaterial ? materialOrSide[groups[_i338].materialIndex].side : side;
        var startCount = intersects.length;
        setBuffer(roots[_i338]);

        _raycast(0, geometry, materialSide, ray, intersects);

        clearBuffer();

        if (isArrayMaterial) {
          var materialIndex = groups[_i338].materialIndex;

          for (var j = startCount, jl = intersects.length; j < jl; j++) {
            intersects[j].face.materialIndex = materialIndex;
          }
        }
      }

      return intersects;
    }
  }, {
    key: "raycastFirst",
    value: function raycastFirst(ray) {
      var materialOrSide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FrontSide;
      var roots = this._roots;
      var geometry = this.geometry;
      var isMaterial = materialOrSide.isMaterial;
      var isArrayMaterial = Array.isArray(materialOrSide);
      var closestResult = null;
      var groups = geometry.groups;
      var side = isMaterial ? materialOrSide.side : materialOrSide;

      for (var _i339 = 0, l = roots.length; _i339 < l; _i339++) {
        var materialSide = isArrayMaterial ? materialOrSide[groups[_i339].materialIndex].side : side;
        setBuffer(roots[_i339]);

        var result = _raycastFirst(0, geometry, materialSide, ray);

        clearBuffer();

        if (result != null && (closestResult == null || result.distance < closestResult.distance)) {
          closestResult = result;

          if (isArrayMaterial) {
            result.face.materialIndex = groups[_i339].materialIndex;
          }
        }
      }

      return closestResult;
    }
  }, {
    key: "intersectsGeometry",
    value: function intersectsGeometry(otherGeometry, geomToMesh) {
      var geometry = this.geometry;
      var result = false;

      var _iterator9 = _createForOfIteratorHelper(this._roots),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var root = _step9.value;
          setBuffer(root);
          result = _intersectsGeometry(0, geometry, otherGeometry, geomToMesh);
          clearBuffer();

          if (result) {
            break;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      return result;
    }
  }, {
    key: "shapecast",
    value: function shapecast(callbacks, _intersectsTriangleFunc, _orderNodesFunc) {
      var geometry = this.geometry;

      if (callbacks instanceof Function) {
        if (_intersectsTriangleFunc) {
          // Support the previous function signature that provided three sequential index buffer
          // indices here.
          var originalTriangleFunc = _intersectsTriangleFunc;

          _intersectsTriangleFunc = function _intersectsTriangleFunc(tri, index, contained, depth) {
            var i3 = index * 3;
            return originalTriangleFunc(tri, i3, i3 + 1, i3 + 2, contained, depth);
          };
        }

        callbacks = {
          boundsTraverseOrder: _orderNodesFunc,
          intersectsBounds: callbacks,
          intersectsTriangle: _intersectsTriangleFunc,
          intersectsRange: null
        };
        console.warn('MeshBVH: Shapecast function signature has changed and now takes an object of callbacks as a second argument. See docs for new signature.');
      }

      var triangle = trianglePool.getPrimitive();
      var _callbacks = callbacks,
          boundsTraverseOrder = _callbacks.boundsTraverseOrder,
          intersectsBounds = _callbacks.intersectsBounds,
          intersectsRange = _callbacks.intersectsRange,
          intersectsTriangle = _callbacks.intersectsTriangle;

      if (intersectsRange && intersectsTriangle) {
        var originalIntersectsRange = intersectsRange;

        intersectsRange = function intersectsRange(offset, count, contained, depth, nodeIndex) {
          if (!originalIntersectsRange(offset, count, contained, depth, nodeIndex)) {
            return iterateOverTriangles(offset, count, geometry, intersectsTriangle, contained, depth, triangle);
          }

          return true;
        };
      } else if (!intersectsRange) {
        if (intersectsTriangle) {
          intersectsRange = function intersectsRange(offset, count, contained, depth) {
            return iterateOverTriangles(offset, count, geometry, intersectsTriangle, contained, depth, triangle);
          };
        } else {
          intersectsRange = function intersectsRange(offset, count, contained) {
            return contained;
          };
        }
      }

      var result = false;
      var byteOffset = 0;

      var _iterator10 = _createForOfIteratorHelper(this._roots),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var root = _step10.value;
          setBuffer(root);
          result = _shapecast(0, geometry, intersectsBounds, intersectsRange, boundsTraverseOrder, byteOffset);
          clearBuffer();

          if (result) {
            break;
          }

          byteOffset += root.byteLength;
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      trianglePool.releasePrimitive(triangle);
      return result;
    }
  }, {
    key: "bvhcast",
    value: function bvhcast(otherBvh, matrixToLocal, callbacks) {
      // BVHCast function for intersecting two BVHs against each other. Ultimately just uses two recursive shapecast calls rather
      // than an approach that walks down the tree (see bvhcast.js file for more info).
      var intersectsRanges = callbacks.intersectsRanges,
          intersectsTriangles = callbacks.intersectsTriangles;
      var indexAttr = this.geometry.index;
      var positionAttr = this.geometry.attributes.position;
      var otherIndexAttr = otherBvh.geometry.index;
      var otherPositionAttr = otherBvh.geometry.attributes.position;
      tempMatrix.copy(matrixToLocal).invert();
      var triangle = trianglePool.getPrimitive();
      var triangle2 = trianglePool.getPrimitive();

      if (intersectsTriangles) {
        function iterateOverDoubleTriangles(offset1, count1, offset2, count2, depth1, index1, depth2, index2) {
          for (var i2 = offset2, l2 = offset2 + count2; i2 < l2; i2++) {
            setTriangle(triangle2, i2 * 3, otherIndexAttr, otherPositionAttr);
            triangle2.a.applyMatrix4(matrixToLocal);
            triangle2.b.applyMatrix4(matrixToLocal);
            triangle2.c.applyMatrix4(matrixToLocal);
            triangle2.needsUpdate = true;

            for (var i1 = offset1, l1 = offset1 + count1; i1 < l1; i1++) {
              setTriangle(triangle, i1 * 3, indexAttr, positionAttr);
              triangle.needsUpdate = true;

              if (intersectsTriangles(triangle, triangle2, i1, i2, depth1, index1, depth2, index2)) {
                return true;
              }
            }
          }

          return false;
        }

        if (intersectsRanges) {
          var originalIntersectsRanges = intersectsRanges;

          intersectsRanges = function intersectsRanges(offset1, count1, offset2, count2, depth1, index1, depth2, index2) {
            if (!originalIntersectsRanges(offset1, count1, offset2, count2, depth1, index1, depth2, index2)) {
              return iterateOverDoubleTriangles(offset1, count1, offset2, count2, depth1, index1, depth2, index2);
            }

            return true;
          };
        } else {
          intersectsRanges = iterateOverDoubleTriangles;
        }
      }

      otherBvh.getBoundingBox(aabb2);
      aabb2.applyMatrix4(matrixToLocal);
      var result = this.shapecast({
        intersectsBounds: function intersectsBounds(box) {
          return aabb2.intersectsBox(box);
        },
        intersectsRange: function intersectsRange(offset1, count1, contained, depth1, nodeIndex1, box) {
          aabb.copy(box);
          aabb.applyMatrix4(tempMatrix);
          return otherBvh.shapecast({
            intersectsBounds: function intersectsBounds(box) {
              return aabb.intersectsBox(box);
            },
            intersectsRange: function intersectsRange(offset2, count2, contained, depth2, nodeIndex2) {
              return intersectsRanges(offset1, count1, offset2, count2, depth1, nodeIndex1, depth2, nodeIndex2);
            }
          });
        }
      });
      trianglePool.releasePrimitive(triangle);
      trianglePool.releasePrimitive(triangle2);
      return result;
    }
    /* Derived Cast Functions */

  }, {
    key: "intersectsBox",
    value: function intersectsBox(box, boxToMesh) {
      obb.set(box.min, box.max, boxToMesh);
      obb.needsUpdate = true;
      return this.shapecast({
        intersectsBounds: function intersectsBounds(box) {
          return obb.intersectsBox(box);
        },
        intersectsTriangle: function intersectsTriangle(tri) {
          return obb.intersectsTriangle(tri);
        }
      });
    }
  }, {
    key: "intersectsSphere",
    value: function intersectsSphere(sphere) {
      return this.shapecast({
        intersectsBounds: function intersectsBounds(box) {
          return sphere.intersectsBox(box);
        },
        intersectsTriangle: function intersectsTriangle(tri) {
          return tri.intersectsSphere(sphere);
        }
      });
    }
  }, {
    key: "closestPointToGeometry",
    value: function closestPointToGeometry(otherGeometry, geometryToBvh) {
      var target1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var target2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var minThreshold = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var maxThreshold = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Infinity;

      if (!otherGeometry.boundingBox) {
        otherGeometry.computeBoundingBox();
      }

      obb.set(otherGeometry.boundingBox.min, otherGeometry.boundingBox.max, geometryToBvh);
      obb.needsUpdate = true;
      var geometry = this.geometry;
      var pos = geometry.attributes.position;
      var index = geometry.index;
      var otherPos = otherGeometry.attributes.position;
      var otherIndex = otherGeometry.index;
      var triangle = trianglePool.getPrimitive();
      var triangle2 = trianglePool.getPrimitive();
      var tempTarget1 = temp1;
      var tempTargetDest1 = temp2;
      var tempTarget2 = null;
      var tempTargetDest2 = null;

      if (target2) {
        tempTarget2 = temp3;
        tempTargetDest2 = temp4;
      }

      var closestDistance = Infinity;
      var closestDistanceTriIndex = null;
      var closestDistanceOtherTriIndex = null;
      tempMatrix.copy(geometryToBvh).invert();
      obb2.matrix.copy(tempMatrix);
      this.shapecast({
        boundsTraverseOrder: function boundsTraverseOrder(box) {
          return obb.distanceToBox(box);
        },
        intersectsBounds: function intersectsBounds(box, isLeaf, score) {
          if (score < closestDistance && score < maxThreshold) {
            // if we know the triangles of this bounds will be intersected next then
            // save the bounds to use during triangle checks.
            if (isLeaf) {
              obb2.min.copy(box.min);
              obb2.max.copy(box.max);
              obb2.needsUpdate = true;
            }

            return true;
          }

          return false;
        },
        intersectsRange: function intersectsRange(offset, count) {
          if (otherGeometry.boundsTree) {
            // if the other geometry has a bvh then use the accelerated path where we use shapecast to find
            // the closest bounds in the other geometry to check.
            return otherGeometry.boundsTree.shapecast({
              boundsTraverseOrder: function boundsTraverseOrder(box) {
                return obb2.distanceToBox(box);
              },
              intersectsBounds: function intersectsBounds(box, isLeaf, score) {
                return score < closestDistance && score < maxThreshold;
              },
              intersectsRange: function intersectsRange(otherOffset, otherCount) {
                for (var i2 = otherOffset * 3, l2 = (otherOffset + otherCount) * 3; i2 < l2; i2 += 3) {
                  setTriangle(triangle2, i2, otherIndex, otherPos);
                  triangle2.a.applyMatrix4(geometryToBvh);
                  triangle2.b.applyMatrix4(geometryToBvh);
                  triangle2.c.applyMatrix4(geometryToBvh);
                  triangle2.needsUpdate = true;

                  for (var _i340 = offset * 3, l = (offset + count) * 3; _i340 < l; _i340 += 3) {
                    setTriangle(triangle, _i340, index, pos);
                    triangle.needsUpdate = true;
                    var dist = triangle.distanceToTriangle(triangle2, tempTarget1, tempTarget2);

                    if (dist < closestDistance) {
                      tempTargetDest1.copy(tempTarget1);

                      if (tempTargetDest2) {
                        tempTargetDest2.copy(tempTarget2);
                      }

                      closestDistance = dist;
                      closestDistanceTriIndex = _i340 / 3;
                      closestDistanceOtherTriIndex = i2 / 3;
                    } // stop traversal if we find a point that's under the given threshold


                    if (dist < minThreshold) {
                      return true;
                    }
                  }
                }
              }
            });
          } else {
            // If no bounds tree then we'll just check every triangle.
            var triCount = otherIndex ? otherIndex.count : otherPos.count;

            for (var i2 = 0, l2 = triCount; i2 < l2; i2 += 3) {
              setTriangle(triangle2, i2, otherIndex, otherPos);
              triangle2.a.applyMatrix4(geometryToBvh);
              triangle2.b.applyMatrix4(geometryToBvh);
              triangle2.c.applyMatrix4(geometryToBvh);
              triangle2.needsUpdate = true;

              for (var _i341 = offset * 3, l = (offset + count) * 3; _i341 < l; _i341 += 3) {
                setTriangle(triangle, _i341, index, pos);
                triangle.needsUpdate = true;
                var dist = triangle.distanceToTriangle(triangle2, tempTarget1, tempTarget2);

                if (dist < closestDistance) {
                  tempTargetDest1.copy(tempTarget1);

                  if (tempTargetDest2) {
                    tempTargetDest2.copy(tempTarget2);
                  }

                  closestDistance = dist;
                  closestDistanceTriIndex = _i341 / 3;
                  closestDistanceOtherTriIndex = i2 / 3;
                } // stop traversal if we find a point that's under the given threshold


                if (dist < minThreshold) {
                  return true;
                }
              }
            }
          }
        }
      });
      trianglePool.releasePrimitive(triangle);
      trianglePool.releasePrimitive(triangle2);
      if (closestDistance === Infinity) return null;
      if (!target1.point) target1.point = tempTargetDest1.clone();else target1.point.copy(tempTargetDest1);
      target1.distance = closestDistance, target1.faceIndex = closestDistanceTriIndex;

      if (target2) {
        if (!target2.point) target2.point = tempTargetDest2.clone();else target2.point.copy(tempTargetDest2);
        target2.point.applyMatrix4(tempMatrix);
        tempTargetDest1.applyMatrix4(tempMatrix);
        target2.distance = tempTargetDest1.sub(target2.point).length();
        target2.faceIndex = closestDistanceOtherTriIndex;
      }

      return target1;
    }
  }, {
    key: "closestPointToPoint",
    value: function closestPointToPoint(point) {
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var minThreshold = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var maxThreshold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Infinity;
      // early out if under minThreshold
      // skip checking if over maxThreshold
      // set minThreshold = maxThreshold to quickly check if a point is within a threshold
      // returns Infinity if no value found
      var minThresholdSq = minThreshold * minThreshold;
      var maxThresholdSq = maxThreshold * maxThreshold;
      var closestDistanceSq = Infinity;
      var closestDistanceTriIndex = null;
      this.shapecast({
        boundsTraverseOrder: function boundsTraverseOrder(box) {
          temp.copy(point).clamp(box.min, box.max);
          return temp.distanceToSquared(point);
        },
        intersectsBounds: function intersectsBounds(box, isLeaf, score) {
          return score < closestDistanceSq && score < maxThresholdSq;
        },
        intersectsTriangle: function intersectsTriangle(tri, triIndex) {
          tri.closestPointToPoint(point, temp);
          var distSq = point.distanceToSquared(temp);

          if (distSq < closestDistanceSq) {
            temp1.copy(temp);
            closestDistanceSq = distSq;
            closestDistanceTriIndex = triIndex;
          }

          if (distSq < minThresholdSq) {
            return true;
          } else {
            return false;
          }
        }
      });
      if (closestDistanceSq === Infinity) return null;
      var closestDistance = Math.sqrt(closestDistanceSq);
      if (!target.point) target.point = temp1.clone();else target.point.copy(temp1);
      target.distance = closestDistance, target.faceIndex = closestDistanceTriIndex;
      return target;
    }
  }, {
    key: "getBoundingBox",
    value: function getBoundingBox(target) {
      target.makeEmpty();
      var roots = this._roots;
      roots.forEach(function (buffer) {
        arrayToBox(0, new Float32Array(buffer), tempBox);
        target.union(tempBox);
      });
      return target;
    }
  }], [{
    key: "serialize",
    value: function serialize(bvh) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (options.isBufferGeometry) {
        console.warn('MeshBVH.serialize: The arguments for the function have changed. See documentation for new signature.');
        return MeshBVH.serialize(arguments[0], {
          cloneBuffers: arguments[2] === undefined ? true : arguments[2]
        });
      }

      options = _objectSpread({
        cloneBuffers: true
      }, options);
      var geometry = bvh.geometry;
      var rootData = bvh._roots;
      var indexAttribute = geometry.getIndex();
      var result;

      if (options.cloneBuffers) {
        result = {
          roots: rootData.map(function (root) {
            return root.slice();
          }),
          index: indexAttribute.array.slice()
        };
      } else {
        result = {
          roots: rootData,
          index: indexAttribute.array
        };
      }

      return result;
    }
  }, {
    key: "deserialize",
    value: function deserialize(data, geometry) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (typeof options === 'boolean') {
        console.warn('MeshBVH.deserialize: The arguments for the function have changed. See documentation for new signature.');
        return MeshBVH.deserialize(arguments[0], arguments[1], {
          setIndex: arguments[2] === undefined ? true : arguments[2]
        });
      }

      options = _objectSpread({
        setIndex: true
      }, options);
      var index = data.index,
          roots = data.roots;
      var bvh = new MeshBVH(geometry, _objectSpread(_objectSpread({}, options), {}, _defineProperty({}, SKIP_GENERATION, true)));
      bvh._roots = roots;

      if (options.setIndex) {
        var indexAttribute = geometry.getIndex();

        if (indexAttribute === null) {
          var newIndex = new BufferAttribute(data.index, 1, false);
          geometry.setIndex(newIndex);
        } else if (indexAttribute.array !== index) {
          indexAttribute.array.set(index);
          indexAttribute.needsUpdate = true;
        }
      }

      return bvh;
    }
  }]);

  return MeshBVH;
}();

var ray = /* @__PURE__ */new Ray();
var tmpInverseMatrix = /* @__PURE__ */new Matrix4();
var origMeshRaycastFunc = Mesh.prototype.raycast;

function acceleratedRaycast(raycaster, intersects) {
  if (this.geometry.boundsTree) {
    if (this.material === undefined) return;
    tmpInverseMatrix.copy(this.matrixWorld).invert();
    ray.copy(raycaster.ray).applyMatrix4(tmpInverseMatrix);
    var bvh = this.geometry.boundsTree;

    if (raycaster.firstHitOnly === true) {
      var hit = convertRaycastIntersect(bvh.raycastFirst(ray, this.material), this, raycaster);

      if (hit) {
        intersects.push(hit);
      }
    } else {
      var hits = bvh.raycast(ray, this.material);

      for (var _i342 = 0, l = hits.length; _i342 < l; _i342++) {
        var _hit = convertRaycastIntersect(hits[_i342], this, raycaster);

        if (_hit) {
          intersects.push(_hit);
        }
      }
    }
  } else {
    origMeshRaycastFunc.call(this, raycaster, intersects);
  }
}

function computeBoundsTree(options) {
  this.boundsTree = new MeshBVH(this, options);
  return this.boundsTree;
}

function disposeBoundsTree() {
  this.boundsTree = null;
}

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator11 = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step11;

    try {
      for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
        var prop = _step11.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator11.e(err);
    } finally {
      _iterator11.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var __require = /* @__PURE__ */function (x) {
  return typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
    get: function get(a, b) {
      return (typeof require !== "undefined" ? require : a)[b];
    }
  }) : x;
}(function (x) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw new Error('Dynamic require of "' + x + '" is not supported');
});

var __commonJS = function __commonJS(cb, mod) {
  return function __require2() {
    return mod || (0, cb[Object.keys(cb)[0]])((mod = {
      exports: {}
    }).exports, mod), mod.exports;
  };
};

var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };

    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };

    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };

    step((generator = generator.apply(__this, __arguments)).next());
  });
}; // (disabled):crypto


var require_crypto = __commonJS({
  "(disabled):crypto": function disabledCrypto() {}
}); // dist/web-ifc-mt.js


var require_web_ifc_mt = __commonJS({
  "dist/web-ifc-mt.js": function distWebIfcMtJs(exports, module) {
    var WebIFCWasm2 = function () {
      var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : void 0;

      if (typeof __filename !== "undefined") _scriptDir = _scriptDir || __filename;
      return function () {
        var WebIFCWasm3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        function GROWABLE_HEAP_I8() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }

          return HEAP8;
        }

        function GROWABLE_HEAP_U8() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }

          return HEAPU8;
        }

        function GROWABLE_HEAP_I16() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }

          return HEAP16;
        }

        function GROWABLE_HEAP_U16() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }

          return HEAPU16;
        }

        function GROWABLE_HEAP_I32() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }

          return HEAP32;
        }

        function GROWABLE_HEAP_U32() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }

          return HEAPU32;
        }

        function GROWABLE_HEAP_F32() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }

          return HEAPF32;
        }

        function GROWABLE_HEAP_F64() {
          if (wasmMemory.buffer != HEAP8.buffer) {
            updateMemoryViews();
          }

          return HEAPF64;
        }

        var Module = typeof WebIFCWasm3 != "undefined" ? WebIFCWasm3 : {};
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise(function (resolve, reject) {
          readyPromiseResolve = resolve;
          readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var thisProgram = "./this.program";

        var quit_ = function quit_(status, toThrow) {
          throw toThrow;
        };

        var ENVIRONMENT_IS_WEB = typeof window == "object";
        var ENVIRONMENT_IS_WORKER = typeof importScripts == "function";
        var ENVIRONMENT_IS_NODE = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string";
        var ENVIRONMENT_IS_PTHREAD = Module["ENVIRONMENT_IS_PTHREAD"] || false;
        var scriptDirectory = "";

        function locateFile(path) {
          if (Module["locateFile"]) {
            return Module["locateFile"](path, scriptDirectory);
          }

          return scriptDirectory + path;
        }

        var read_, readAsync, readBinary;

        function logExceptionOnExit(e) {
          if (e instanceof ExitStatus) return;
          var toLog = e;
          err("exiting due to exception: " + toLog);
        }

        if (ENVIRONMENT_IS_NODE) {
          var fs = __require("fs");

          var nodePath = __require("path");

          if (ENVIRONMENT_IS_WORKER) {
            scriptDirectory = nodePath.dirname(scriptDirectory) + "/";
          } else {
            scriptDirectory = __dirname + "/";
          }

          read_ = function read_(filename, binary) {
            filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
            return fs.readFileSync(filename, binary ? void 0 : "utf8");
          };

          readBinary = function readBinary(filename) {
            var ret = read_(filename, true);

            if (!ret.buffer) {
              ret = new Uint8Array(ret);
            }

            return ret;
          };

          readAsync = function readAsync(filename, onload, onerror) {
            filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
            fs.readFile(filename, function (err2, data) {
              if (err2) onerror(err2);else onload(data.buffer);
            });
          };

          if (process["argv"].length > 1) {
            thisProgram = process["argv"][1].replace(/\\/g, "/");
          }

          process["argv"].slice(2);
          process["on"]("uncaughtException", function (ex) {
            if (!(ex instanceof ExitStatus)) {
              throw ex;
            }
          });
          var nodeMajor = process.version.match(/^v(\d+)\./)[1];

          if (nodeMajor < 15) {
            process["on"]("unhandledRejection", function (reason) {
              throw reason;
            });
          }

          quit_ = function quit_(status, toThrow) {
            if (keepRuntimeAlive()) {
              process["exitCode"] = status;
              throw toThrow;
            }

            logExceptionOnExit(toThrow);
            process["exit"](status);
          };

          Module["inspect"] = function () {
            return "[Emscripten Module object]";
          };

          var nodeWorkerThreads;

          try {
            nodeWorkerThreads = __require("worker_threads");
          } catch (e) {
            console.error('The "worker_threads" module is not supported in this node.js build - perhaps a newer version is needed?');
            throw e;
          }

          global.Worker = nodeWorkerThreads.Worker;
        } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
          if (ENVIRONMENT_IS_WORKER) {
            scriptDirectory = self.location.href;
          } else if (typeof document != "undefined" && document.currentScript) {
            scriptDirectory = document.currentScript.src;
          }

          if (_scriptDir) {
            scriptDirectory = _scriptDir;
          }

          if (scriptDirectory.indexOf("blob:") !== 0) {
            scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
          } else {
            scriptDirectory = "";
          }

          if (!ENVIRONMENT_IS_NODE) {
            read_ = function read_(url) {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, false);
              xhr.send(null);
              return xhr.responseText;
            };

            if (ENVIRONMENT_IS_WORKER) {
              readBinary = function readBinary(url) {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
              };
            }

            readAsync = function readAsync(url, onload, onerror) {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.responseType = "arraybuffer";

              xhr.onload = function () {
                if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                  onload(xhr.response);
                  return;
                }

                onerror();
              };

              xhr.onerror = onerror;
              xhr.send(null);
            };
          }
        } else ;

        if (ENVIRONMENT_IS_NODE) {
          if (typeof performance == "undefined") {
            global.performance = __require("perf_hooks").performance;
          }
        }

        var defaultPrint = console.log.bind(console);
        var defaultPrintErr = console.warn.bind(console);

        if (ENVIRONMENT_IS_NODE) {
          defaultPrint = function defaultPrint(str) {
            return fs.writeSync(1, str + "\n");
          };

          defaultPrintErr = function defaultPrintErr(str) {
            return fs.writeSync(2, str + "\n");
          };
        }

        var out = Module["print"] || defaultPrint;
        var err = Module["printErr"] || defaultPrintErr;
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) quit_ = Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        var noExitRuntime = Module["noExitRuntime"] || true;

        if (typeof WebAssembly != "object") {
          abort("no native wasm support detected");
        }

        var wasmMemory;
        var wasmModule;
        var ABORT = false;
        var EXITSTATUS;

        function assert(condition, text) {
          if (!condition) {
            abort(text);
          }
        }

        var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0;

        function UTF8ArrayToString(heapOrArray, idx, maxBytesToRead) {
          idx >>>= 0;
          var endIdx = idx + maxBytesToRead;
          var endPtr = idx;

          while (heapOrArray[endPtr] && !(endPtr >= endIdx)) {
            ++endPtr;
          }

          if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
            return UTF8Decoder.decode(heapOrArray.buffer instanceof SharedArrayBuffer ? heapOrArray.slice(idx, endPtr) : heapOrArray.subarray(idx, endPtr));
          }

          var str = "";

          while (idx < endPtr) {
            var u0 = heapOrArray[idx++];

            if (!(u0 & 128)) {
              str += String.fromCharCode(u0);
              continue;
            }

            var u1 = heapOrArray[idx++] & 63;

            if ((u0 & 224) == 192) {
              str += String.fromCharCode((u0 & 31) << 6 | u1);
              continue;
            }

            var u2 = heapOrArray[idx++] & 63;

            if ((u0 & 240) == 224) {
              u0 = (u0 & 15) << 12 | u1 << 6 | u2;
            } else {
              u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
            }

            if (u0 < 65536) {
              str += String.fromCharCode(u0);
            } else {
              var ch = u0 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            }
          }

          return str;
        }

        function UTF8ToString(ptr, maxBytesToRead) {
          ptr >>>= 0;
          return ptr ? UTF8ArrayToString(GROWABLE_HEAP_U8(), ptr, maxBytesToRead) : "";
        }

        function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
          outIdx >>>= 0;
          if (!(maxBytesToWrite > 0)) return 0;
          var startIdx = outIdx;
          var endIdx = outIdx + maxBytesToWrite - 1;

          for (var i = 0; i < str.length; ++i) {
            var u = str.charCodeAt(i);

            if (u >= 55296 && u <= 57343) {
              var u1 = str.charCodeAt(++i);
              u = 65536 + ((u & 1023) << 10) | u1 & 1023;
            }

            if (u <= 127) {
              if (outIdx >= endIdx) break;
              heap[outIdx++ >>> 0] = u;
            } else if (u <= 2047) {
              if (outIdx + 1 >= endIdx) break;
              heap[outIdx++ >>> 0] = 192 | u >> 6;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else if (u <= 65535) {
              if (outIdx + 2 >= endIdx) break;
              heap[outIdx++ >>> 0] = 224 | u >> 12;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else {
              if (outIdx + 3 >= endIdx) break;
              heap[outIdx++ >>> 0] = 240 | u >> 18;
              heap[outIdx++ >>> 0] = 128 | u >> 12 & 63;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            }
          }

          heap[outIdx >>> 0] = 0;
          return outIdx - startIdx;
        }

        function stringToUTF8(str, outPtr, maxBytesToWrite) {
          return stringToUTF8Array(str, GROWABLE_HEAP_U8(), outPtr, maxBytesToWrite);
        }

        function lengthBytesUTF8(str) {
          var len = 0;

          for (var i = 0; i < str.length; ++i) {
            var c = str.charCodeAt(i);

            if (c <= 127) {
              len++;
            } else if (c <= 2047) {
              len += 2;
            } else if (c >= 55296 && c <= 57343) {
              len += 4;
              ++i;
            } else {
              len += 3;
            }
          }

          return len;
        }

        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;

        function updateMemoryViews() {
          var b = wasmMemory.buffer;
          Module["HEAP8"] = HEAP8 = new Int8Array(b);
          Module["HEAP16"] = HEAP16 = new Int16Array(b);
          Module["HEAP32"] = HEAP32 = new Int32Array(b);
          Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
          Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
          Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
          Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
          Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }

        var INITIAL_MEMORY = Module["INITIAL_MEMORY"] || 16777216;
        assert(INITIAL_MEMORY >= 5242880, "INITIAL_MEMORY should be larger than STACK_SIZE, was " + INITIAL_MEMORY + "! (STACK_SIZE=" + 5242880 + ")");

        if (ENVIRONMENT_IS_PTHREAD) {
          wasmMemory = Module["wasmMemory"];
        } else {
          if (Module["wasmMemory"]) {
            wasmMemory = Module["wasmMemory"];
          } else {
            wasmMemory = new WebAssembly.Memory({
              "initial": INITIAL_MEMORY / 65536,
              "maximum": 4294967296 / 65536,
              "shared": true
            });

            if (!(wasmMemory.buffer instanceof SharedArrayBuffer)) {
              err("requested a shared WebAssembly.Memory but the returned buffer is not a SharedArrayBuffer, indicating that while the browser has SharedArrayBuffer it does not have WebAssembly threads support - you may need to set a flag");

              if (ENVIRONMENT_IS_NODE) {
                err("(on node you may need: --experimental-wasm-threads --experimental-wasm-bulk-memory and/or recent version)");
              }

              throw Error("bad memory");
            }
          }
        }

        updateMemoryViews();
        INITIAL_MEMORY = wasmMemory.buffer.byteLength;
        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATPOSTRUN__ = [];

        function keepRuntimeAlive() {
          return noExitRuntime;
        }

        function preRun() {
          if (Module["preRun"]) {
            if (typeof Module["preRun"] == "function") Module["preRun"] = [Module["preRun"]];

            while (Module["preRun"].length) {
              addOnPreRun(Module["preRun"].shift());
            }
          }

          callRuntimeCallbacks(__ATPRERUN__);
        }

        function initRuntime() {
          if (ENVIRONMENT_IS_PTHREAD) return;
          if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
          FS.ignorePermissions = false;
          TTY.init();
          callRuntimeCallbacks(__ATINIT__);
        }

        function postRun() {
          if (ENVIRONMENT_IS_PTHREAD) return;

          if (Module["postRun"]) {
            if (typeof Module["postRun"] == "function") Module["postRun"] = [Module["postRun"]];

            while (Module["postRun"].length) {
              addOnPostRun(Module["postRun"].shift());
            }
          }

          callRuntimeCallbacks(__ATPOSTRUN__);
        }

        function addOnPreRun(cb) {
          __ATPRERUN__.unshift(cb);
        }

        function addOnInit(cb) {
          __ATINIT__.unshift(cb);
        }

        function addOnPostRun(cb) {
          __ATPOSTRUN__.unshift(cb);
        }

        var runDependencies = 0;
        var dependenciesFulfilled = null;

        function getUniqueRunDependency(id) {
          return id;
        }

        function addRunDependency(id) {
          runDependencies++;

          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }
        }

        function removeRunDependency(id) {
          runDependencies--;

          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }

          if (runDependencies == 0) {
            if (dependenciesFulfilled) {
              var callback = dependenciesFulfilled;
              dependenciesFulfilled = null;
              callback();
            }
          }
        }

        function abort(what) {
          if (Module["onAbort"]) {
            Module["onAbort"](what);
          }

          what = "Aborted(" + what + ")";
          err(what);
          ABORT = true;
          EXITSTATUS = 1;
          what += ". Build with -sASSERTIONS for more info.";
          var e = new WebAssembly.RuntimeError(what);
          readyPromiseReject(e);
          throw e;
        }

        var dataURIPrefix = "data:application/octet-stream;base64,";

        function isDataURI(filename) {
          return filename.startsWith(dataURIPrefix);
        }

        function isFileURI(filename) {
          return filename.startsWith("file://");
        }

        var wasmBinaryFile;
        wasmBinaryFile = "web-ifc-mt.wasm";

        if (!isDataURI(wasmBinaryFile)) {
          wasmBinaryFile = locateFile(wasmBinaryFile);
        }

        function getBinary(file) {
          try {
            if (file == wasmBinaryFile && wasmBinary) {
              return new Uint8Array(wasmBinary);
            }

            if (readBinary) {
              return readBinary(file);
            }

            throw "both async and sync fetching of the wasm failed";
          } catch (err2) {
            abort(err2);
          }
        }

        function getBinaryPromise() {
          if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
            if (typeof fetch == "function" && !isFileURI(wasmBinaryFile)) {
              return fetch(wasmBinaryFile, {
                credentials: "same-origin"
              }).then(function (response) {
                if (!response["ok"]) {
                  throw "failed to load wasm binary file at '" + wasmBinaryFile + "'";
                }

                return response["arrayBuffer"]();
              }).catch(function () {
                return getBinary(wasmBinaryFile);
              });
            } else {
              if (readAsync) {
                return new Promise(function (resolve, reject) {
                  readAsync(wasmBinaryFile, function (response) {
                    resolve(new Uint8Array(response));
                  }, reject);
                });
              }
            }
          }

          return Promise.resolve().then(function () {
            return getBinary(wasmBinaryFile);
          });
        }

        function createWasm() {
          var info = {
            "a": wasmImports
          };

          function receiveInstance(instance, module2) {
            var exports3 = instance.exports;
            Module["asm"] = exports3;
            registerTLSInit(Module["asm"]["ma"]);
            wasmTable = Module["asm"]["ka"];
            addOnInit(Module["asm"]["ja"]);
            wasmModule = module2;
            PThread.loadWasmModuleToAllWorkers(function () {
              return removeRunDependency();
            });
          }

          addRunDependency();

          function receiveInstantiationResult(result) {
            receiveInstance(result["instance"], result["module"]);
          }

          function instantiateArrayBuffer(receiver) {
            return getBinaryPromise().then(function (binary) {
              return WebAssembly.instantiate(binary, info);
            }).then(function (instance) {
              return instance;
            }).then(receiver, function (reason) {
              err("failed to asynchronously prepare wasm: " + reason);
              abort(reason);
            });
          }

          function instantiateAsync() {
            if (!wasmBinary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(wasmBinaryFile) && !isFileURI(wasmBinaryFile) && !ENVIRONMENT_IS_NODE && typeof fetch == "function") {
              return fetch(wasmBinaryFile, {
                credentials: "same-origin"
              }).then(function (response) {
                var result = WebAssembly.instantiateStreaming(response, info);
                return result.then(receiveInstantiationResult, function (reason) {
                  err("wasm streaming compile failed: " + reason);
                  err("falling back to ArrayBuffer instantiation");
                  return instantiateArrayBuffer(receiveInstantiationResult);
                });
              });
            } else {
              return instantiateArrayBuffer(receiveInstantiationResult);
            }
          }

          if (Module["instantiateWasm"]) {
            try {
              var exports2 = Module["instantiateWasm"](info, receiveInstance);
              return exports2;
            } catch (e) {
              err("Module.instantiateWasm callback failed with error: " + e);
              readyPromiseReject(e);
            }
          }

          instantiateAsync().catch(readyPromiseReject);
          return {};
        }

        var tempDouble;
        var tempI64;

        function ExitStatus(status) {
          this.name = "ExitStatus";
          this.message = "Program terminated with exit(" + status + ")";
          this.status = status;
        }

        function killThread(pthread_ptr) {
          var worker = PThread.pthreads[pthread_ptr];
          delete PThread.pthreads[pthread_ptr];
          worker.terminate();

          _emscripten_thread_free_data(pthread_ptr);

          PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1);
          worker.pthread_ptr = 0;
        }

        function cancelThread(pthread_ptr) {
          var worker = PThread.pthreads[pthread_ptr];
          worker.postMessage({
            "cmd": "cancel"
          });
        }

        function cleanupThread(pthread_ptr) {
          var worker = PThread.pthreads[pthread_ptr];
          assert(worker);
          PThread.returnWorkerToPool(worker);
        }

        function spawnThread(threadParams) {
          var worker = PThread.getNewWorker();

          if (!worker) {
            return 6;
          }

          PThread.runningWorkers.push(worker);
          PThread.pthreads[threadParams.pthread_ptr] = worker;
          worker.pthread_ptr = threadParams.pthread_ptr;
          var msg = {
            "cmd": "run",
            "start_routine": threadParams.startRoutine,
            "arg": threadParams.arg,
            "pthread_ptr": threadParams.pthread_ptr
          };

          if (ENVIRONMENT_IS_NODE) {
            worker.ref();
          }

          worker.postMessage(msg, threadParams.transferList);
          return 0;
        }

        var PATH = {
          isAbs: function isAbs(path) {
            return path.charAt(0) === "/";
          },
          splitPath: function splitPath(filename) {
            var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
            return splitPathRe.exec(filename).slice(1);
          },
          normalizeArray: function normalizeArray(parts, allowAboveRoot) {
            var up = 0;

            for (var i = parts.length - 1; i >= 0; i--) {
              var last = parts[i];

              if (last === ".") {
                parts.splice(i, 1);
              } else if (last === "..") {
                parts.splice(i, 1);
                up++;
              } else if (up) {
                parts.splice(i, 1);
                up--;
              }
            }

            if (allowAboveRoot) {
              for (; up; up--) {
                parts.unshift("..");
              }
            }

            return parts;
          },
          normalize: function normalize(path) {
            var isAbsolute = PATH.isAbs(path),
                trailingSlash = path.substr(-1) === "/";
            path = PATH.normalizeArray(path.split("/").filter(function (p) {
              return !!p;
            }), !isAbsolute).join("/");

            if (!path && !isAbsolute) {
              path = ".";
            }

            if (path && trailingSlash) {
              path += "/";
            }

            return (isAbsolute ? "/" : "") + path;
          },
          dirname: function dirname(path) {
            var result = PATH.splitPath(path),
                root = result[0],
                dir = result[1];

            if (!root && !dir) {
              return ".";
            }

            if (dir) {
              dir = dir.substr(0, dir.length - 1);
            }

            return root + dir;
          },
          basename: function basename(path) {
            if (path === "/") return "/";
            path = PATH.normalize(path);
            path = path.replace(/\/$/, "");
            var lastSlash = path.lastIndexOf("/");
            if (lastSlash === -1) return path;
            return path.substr(lastSlash + 1);
          },
          join: function join() {
            var paths = Array.prototype.slice.call(arguments);
            return PATH.normalize(paths.join("/"));
          },
          join2: function join2(l, r) {
            return PATH.normalize(l + "/" + r);
          }
        };

        function getRandomDevice() {
          if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
            var randomBuffer = new Uint8Array(1);
            return function () {
              crypto.getRandomValues(randomBuffer);
              return randomBuffer[0];
            };
          } else if (ENVIRONMENT_IS_NODE) {
            try {
              var crypto_module = require_crypto();
              return function () {
                return crypto_module["randomBytes"](1)[0];
              };
            } catch (e) {}
          }

          return function () {
            return abort("randomDevice");
          };
        }

        var PATH_FS = {
          resolve: function resolve() {
            var resolvedPath = "",
                resolvedAbsolute = false;

            for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
              var path = i >= 0 ? arguments[i] : FS.cwd();

              if (typeof path != "string") {
                throw new TypeError("Arguments to path.resolve must be strings");
              } else if (!path) {
                return "";
              }

              resolvedPath = path + "/" + resolvedPath;
              resolvedAbsolute = PATH.isAbs(path);
            }

            resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter(function (p) {
              return !!p;
            }), !resolvedAbsolute).join("/");
            return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
          },
          relative: function relative(from, to) {
            from = PATH_FS.resolve(from).substr(1);
            to = PATH_FS.resolve(to).substr(1);

            function trim(arr) {
              var start = 0;

              for (; start < arr.length; start++) {
                if (arr[start] !== "") break;
              }

              var end = arr.length - 1;

              for (; end >= 0; end--) {
                if (arr[end] !== "") break;
              }

              if (start > end) return [];
              return arr.slice(start, end - start + 1);
            }

            var fromParts = trim(from.split("/"));
            var toParts = trim(to.split("/"));
            var length = Math.min(fromParts.length, toParts.length);
            var samePartsLength = length;

            for (var i = 0; i < length; i++) {
              if (fromParts[i] !== toParts[i]) {
                samePartsLength = i;
                break;
              }
            }

            var outputParts = [];

            for (var i = samePartsLength; i < fromParts.length; i++) {
              outputParts.push("..");
            }

            outputParts = outputParts.concat(toParts.slice(samePartsLength));
            return outputParts.join("/");
          }
        };

        function intArrayFromString(stringy, dontAddNull, length) {
          var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
          var u8array = new Array(len);
          var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
          if (dontAddNull) u8array.length = numBytesWritten;
          return u8array;
        }

        var TTY = {
          ttys: [],
          init: function init() {},
          shutdown: function shutdown() {},
          register: function register(dev, ops) {
            TTY.ttys[dev] = {
              input: [],
              output: [],
              ops: ops
            };
            FS.registerDevice(dev, TTY.stream_ops);
          },
          stream_ops: {
            open: function open(stream) {
              var tty = TTY.ttys[stream.node.rdev];

              if (!tty) {
                throw new FS.ErrnoError(43);
              }

              stream.tty = tty;
              stream.seekable = false;
            },
            close: function close(stream) {
              stream.tty.ops.fsync(stream.tty);
            },
            fsync: function fsync(stream) {
              stream.tty.ops.fsync(stream.tty);
            },
            read: function read(stream, buffer, offset, length, pos) {
              if (!stream.tty || !stream.tty.ops.get_char) {
                throw new FS.ErrnoError(60);
              }

              var bytesRead = 0;

              for (var i = 0; i < length; i++) {
                var result;

                try {
                  result = stream.tty.ops.get_char(stream.tty);
                } catch (e) {
                  throw new FS.ErrnoError(29);
                }

                if (result === void 0 && bytesRead === 0) {
                  throw new FS.ErrnoError(6);
                }

                if (result === null || result === void 0) break;
                bytesRead++;
                buffer[offset + i] = result;
              }

              if (bytesRead) {
                stream.node.timestamp = Date.now();
              }

              return bytesRead;
            },
            write: function write(stream, buffer, offset, length, pos) {
              if (!stream.tty || !stream.tty.ops.put_char) {
                throw new FS.ErrnoError(60);
              }

              try {
                for (var i = 0; i < length; i++) {
                  stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
                }
              } catch (e) {
                throw new FS.ErrnoError(29);
              }

              if (length) {
                stream.node.timestamp = Date.now();
              }

              return i;
            }
          },
          default_tty_ops: {
            get_char: function get_char(tty) {
              if (!tty.input.length) {
                var result = null;

                if (ENVIRONMENT_IS_NODE) {
                  var BUFSIZE = 256;
                  var buf = Buffer.alloc(BUFSIZE);
                  var bytesRead = 0;

                  try {
                    bytesRead = fs.readSync(process.stdin.fd, buf, 0, BUFSIZE, -1);
                  } catch (e) {
                    if (e.toString().includes("EOF")) bytesRead = 0;else throw e;
                  }

                  if (bytesRead > 0) {
                    result = buf.slice(0, bytesRead).toString("utf-8");
                  } else {
                    result = null;
                  }
                } else if (typeof window != "undefined" && typeof window.prompt == "function") {
                  result = window.prompt("Input: ");

                  if (result !== null) {
                    result += "\n";
                  }
                } else if (typeof readline == "function") {
                  result = readline();

                  if (result !== null) {
                    result += "\n";
                  }
                }

                if (!result) {
                  return null;
                }

                tty.input = intArrayFromString(result, true);
              }

              return tty.input.shift();
            },
            put_char: function put_char(tty, val) {
              if (val === null || val === 10) {
                out(UTF8ArrayToString(tty.output, 0));
                tty.output = [];
              } else {
                if (val != 0) tty.output.push(val);
              }
            },
            fsync: function fsync(tty) {
              if (tty.output && tty.output.length > 0) {
                out(UTF8ArrayToString(tty.output, 0));
                tty.output = [];
              }
            }
          },
          default_tty1_ops: {
            put_char: function put_char(tty, val) {
              if (val === null || val === 10) {
                err(UTF8ArrayToString(tty.output, 0));
                tty.output = [];
              } else {
                if (val != 0) tty.output.push(val);
              }
            },
            fsync: function fsync(tty) {
              if (tty.output && tty.output.length > 0) {
                err(UTF8ArrayToString(tty.output, 0));
                tty.output = [];
              }
            }
          }
        };

        function mmapAlloc(size) {
          abort();
        }

        var MEMFS = {
          ops_table: null,
          mount: function mount(_mount) {
            return MEMFS.createNode(null, "/", 16384 | 511, 0);
          },
          createNode: function createNode(parent, name, mode, dev) {
            if (FS.isBlkdev(mode) || FS.isFIFO(mode)) {
              throw new FS.ErrnoError(63);
            }

            if (!MEMFS.ops_table) {
              MEMFS.ops_table = {
                dir: {
                  node: {
                    getattr: MEMFS.node_ops.getattr,
                    setattr: MEMFS.node_ops.setattr,
                    lookup: MEMFS.node_ops.lookup,
                    mknod: MEMFS.node_ops.mknod,
                    rename: MEMFS.node_ops.rename,
                    unlink: MEMFS.node_ops.unlink,
                    rmdir: MEMFS.node_ops.rmdir,
                    readdir: MEMFS.node_ops.readdir,
                    symlink: MEMFS.node_ops.symlink
                  },
                  stream: {
                    llseek: MEMFS.stream_ops.llseek
                  }
                },
                file: {
                  node: {
                    getattr: MEMFS.node_ops.getattr,
                    setattr: MEMFS.node_ops.setattr
                  },
                  stream: {
                    llseek: MEMFS.stream_ops.llseek,
                    read: MEMFS.stream_ops.read,
                    write: MEMFS.stream_ops.write,
                    allocate: MEMFS.stream_ops.allocate,
                    mmap: MEMFS.stream_ops.mmap,
                    msync: MEMFS.stream_ops.msync
                  }
                },
                link: {
                  node: {
                    getattr: MEMFS.node_ops.getattr,
                    setattr: MEMFS.node_ops.setattr,
                    readlink: MEMFS.node_ops.readlink
                  },
                  stream: {}
                },
                chrdev: {
                  node: {
                    getattr: MEMFS.node_ops.getattr,
                    setattr: MEMFS.node_ops.setattr
                  },
                  stream: FS.chrdev_stream_ops
                }
              };
            }

            var node = FS.createNode(parent, name, mode, dev);

            if (FS.isDir(node.mode)) {
              node.node_ops = MEMFS.ops_table.dir.node;
              node.stream_ops = MEMFS.ops_table.dir.stream;
              node.contents = {};
            } else if (FS.isFile(node.mode)) {
              node.node_ops = MEMFS.ops_table.file.node;
              node.stream_ops = MEMFS.ops_table.file.stream;
              node.usedBytes = 0;
              node.contents = null;
            } else if (FS.isLink(node.mode)) {
              node.node_ops = MEMFS.ops_table.link.node;
              node.stream_ops = MEMFS.ops_table.link.stream;
            } else if (FS.isChrdev(node.mode)) {
              node.node_ops = MEMFS.ops_table.chrdev.node;
              node.stream_ops = MEMFS.ops_table.chrdev.stream;
            }

            node.timestamp = Date.now();

            if (parent) {
              parent.contents[name] = node;
              parent.timestamp = node.timestamp;
            }

            return node;
          },
          getFileDataAsTypedArray: function getFileDataAsTypedArray(node) {
            if (!node.contents) return new Uint8Array(0);
            if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
            return new Uint8Array(node.contents);
          },
          expandFileStorage: function expandFileStorage(node, newCapacity) {
            newCapacity >>>= 0;
            var prevCapacity = node.contents ? node.contents.length : 0;
            if (prevCapacity >= newCapacity) return;
            var CAPACITY_DOUBLING_MAX = 1024 * 1024;
            newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
            if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
            var oldContents = node.contents;
            node.contents = new Uint8Array(newCapacity);
            if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
          },
          resizeFileStorage: function resizeFileStorage(node, newSize) {
            newSize >>>= 0;
            if (node.usedBytes == newSize) return;

            if (newSize == 0) {
              node.contents = null;
              node.usedBytes = 0;
            } else {
              var oldContents = node.contents;
              node.contents = new Uint8Array(newSize);

              if (oldContents) {
                node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
              }

              node.usedBytes = newSize;
            }
          },
          node_ops: {
            getattr: function getattr(node) {
              var attr = {};
              attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
              attr.ino = node.id;
              attr.mode = node.mode;
              attr.nlink = 1;
              attr.uid = 0;
              attr.gid = 0;
              attr.rdev = node.rdev;

              if (FS.isDir(node.mode)) {
                attr.size = 4096;
              } else if (FS.isFile(node.mode)) {
                attr.size = node.usedBytes;
              } else if (FS.isLink(node.mode)) {
                attr.size = node.link.length;
              } else {
                attr.size = 0;
              }

              attr.atime = new Date(node.timestamp);
              attr.mtime = new Date(node.timestamp);
              attr.ctime = new Date(node.timestamp);
              attr.blksize = 4096;
              attr.blocks = Math.ceil(attr.size / attr.blksize);
              return attr;
            },
            setattr: function setattr(node, attr) {
              if (attr.mode !== void 0) {
                node.mode = attr.mode;
              }

              if (attr.timestamp !== void 0) {
                node.timestamp = attr.timestamp;
              }

              if (attr.size !== void 0) {
                MEMFS.resizeFileStorage(node, attr.size);
              }
            },
            lookup: function lookup(parent, name) {
              throw FS.genericErrors[44];
            },
            mknod: function mknod(parent, name, mode, dev) {
              return MEMFS.createNode(parent, name, mode, dev);
            },
            rename: function rename(old_node, new_dir, new_name) {
              if (FS.isDir(old_node.mode)) {
                var new_node;

                try {
                  new_node = FS.lookupNode(new_dir, new_name);
                } catch (e) {}

                if (new_node) {
                  for (var i in new_node.contents) {
                    throw new FS.ErrnoError(55);
                  }
                }
              }

              delete old_node.parent.contents[old_node.name];
              old_node.parent.timestamp = Date.now();
              old_node.name = new_name;
              new_dir.contents[new_name] = old_node;
              new_dir.timestamp = old_node.parent.timestamp;
              old_node.parent = new_dir;
            },
            unlink: function unlink(parent, name) {
              delete parent.contents[name];
              parent.timestamp = Date.now();
            },
            rmdir: function rmdir(parent, name) {
              var node = FS.lookupNode(parent, name);

              for (var i in node.contents) {
                throw new FS.ErrnoError(55);
              }

              delete parent.contents[name];
              parent.timestamp = Date.now();
            },
            readdir: function readdir(node) {
              var entries = [".", ".."];

              for (var key in node.contents) {
                if (!node.contents.hasOwnProperty(key)) {
                  continue;
                }

                entries.push(key);
              }

              return entries;
            },
            symlink: function symlink(parent, newname, oldpath) {
              var node = MEMFS.createNode(parent, newname, 511 | 40960, 0);
              node.link = oldpath;
              return node;
            },
            readlink: function readlink(node) {
              if (!FS.isLink(node.mode)) {
                throw new FS.ErrnoError(28);
              }

              return node.link;
            }
          },
          stream_ops: {
            read: function read(stream, buffer, offset, length, position) {
              var contents = stream.node.contents;
              if (position >= stream.node.usedBytes) return 0;
              var size = Math.min(stream.node.usedBytes - position, length);

              if (size > 8 && contents.subarray) {
                buffer.set(contents.subarray(position, position + size), offset);
              } else {
                for (var i = 0; i < size; i++) {
                  buffer[offset + i] = contents[position + i];
                }
              }

              return size;
            },
            write: function write(stream, buffer, offset, length, position, canOwn) {
              if (buffer.buffer === GROWABLE_HEAP_I8().buffer) {
                canOwn = false;
              }

              if (!length) return 0;
              var node = stream.node;
              node.timestamp = Date.now();

              if (buffer.subarray && (!node.contents || node.contents.subarray)) {
                if (canOwn) {
                  node.contents = buffer.subarray(offset, offset + length);
                  node.usedBytes = length;
                  return length;
                } else if (node.usedBytes === 0 && position === 0) {
                  node.contents = buffer.slice(offset, offset + length);
                  node.usedBytes = length;
                  return length;
                } else if (position + length <= node.usedBytes) {
                  node.contents.set(buffer.subarray(offset, offset + length), position);
                  return length;
                }
              }

              MEMFS.expandFileStorage(node, position + length);

              if (node.contents.subarray && buffer.subarray) {
                node.contents.set(buffer.subarray(offset, offset + length), position);
              } else {
                for (var i = 0; i < length; i++) {
                  node.contents[position + i] = buffer[offset + i];
                }
              }

              node.usedBytes = Math.max(node.usedBytes, position + length);
              return length;
            },
            llseek: function llseek(stream, offset, whence) {
              var position = offset;

              if (whence === 1) {
                position += stream.position;
              } else if (whence === 2) {
                if (FS.isFile(stream.node.mode)) {
                  position += stream.node.usedBytes;
                }
              }

              if (position < 0) {
                throw new FS.ErrnoError(28);
              }

              return position;
            },
            allocate: function allocate(stream, offset, length) {
              MEMFS.expandFileStorage(stream.node, offset + length);
              stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
            },
            mmap: function mmap(stream, length, position, prot, flags) {
              if (!FS.isFile(stream.node.mode)) {
                throw new FS.ErrnoError(43);
              }

              var ptr;
              var allocated;
              var contents = stream.node.contents;

              if (!(flags & 2) && contents.buffer === GROWABLE_HEAP_I8().buffer) {
                allocated = false;
                ptr = contents.byteOffset;
              } else {
                if (position > 0 || position + length < contents.length) {
                  if (contents.subarray) {
                    contents = contents.subarray(position, position + length);
                  } else {
                    contents = Array.prototype.slice.call(contents, position, position + length);
                  }
                }

                allocated = true;
                ptr = mmapAlloc();

                if (!ptr) {
                  throw new FS.ErrnoError(48);
                }

                ptr >>>= 0;
                GROWABLE_HEAP_I8().set(contents, ptr >>> 0);
              }

              return {
                ptr: ptr,
                allocated: allocated
              };
            },
            msync: function msync(stream, buffer, offset, length, mmapFlags) {
              MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
              return 0;
            }
          }
        };

        function asyncLoad(url, onload, onerror, noRunDep) {
          var dep = !noRunDep ? getUniqueRunDependency("al " + url) : "";
          readAsync(url, function (arrayBuffer) {
            assert(arrayBuffer, 'Loading data file "' + url + '" failed (no arrayBuffer).');
            onload(new Uint8Array(arrayBuffer));
            if (dep) removeRunDependency();
          }, function (event) {
            if (onerror) {
              onerror();
            } else {
              throw 'Loading data file "' + url + '" failed.';
            }
          });
          if (dep) addRunDependency();
        }

        var FS = {
          root: null,
          mounts: [],
          devices: {},
          streams: [],
          nextInode: 1,
          nameTable: null,
          currentPath: "/",
          initialized: false,
          ignorePermissions: true,
          ErrnoError: null,
          genericErrors: {},
          filesystems: null,
          syncFSRequests: 0,
          lookupPath: function lookupPath(path) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            path = PATH_FS.resolve(path);
            if (!path) return {
              path: "",
              node: null
            };
            var defaults = {
              follow_mount: true,
              recurse_count: 0
            };
            opts = Object.assign(defaults, opts);

            if (opts.recurse_count > 8) {
              throw new FS.ErrnoError(32);
            }

            var parts = path.split("/").filter(function (p) {
              return !!p;
            });
            var current = FS.root;
            var current_path = "/";

            for (var i = 0; i < parts.length; i++) {
              var islast = i === parts.length - 1;

              if (islast && opts.parent) {
                break;
              }

              current = FS.lookupNode(current, parts[i]);
              current_path = PATH.join2(current_path, parts[i]);

              if (FS.isMountpoint(current)) {
                if (!islast || islast && opts.follow_mount) {
                  current = current.mounted.root;
                }
              }

              if (!islast || opts.follow) {
                var count = 0;

                while (FS.isLink(current.mode)) {
                  var link = FS.readlink(current_path);
                  current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                  var lookup = FS.lookupPath(current_path, {
                    recurse_count: opts.recurse_count + 1
                  });
                  current = lookup.node;

                  if (count++ > 40) {
                    throw new FS.ErrnoError(32);
                  }
                }
              }
            }

            return {
              path: current_path,
              node: current
            };
          },
          getPath: function getPath(node) {
            var path;

            while (true) {
              if (FS.isRoot(node)) {
                var mount = node.mount.mountpoint;
                if (!path) return mount;
                return mount[mount.length - 1] !== "/" ? mount + "/" + path : mount + path;
              }

              path = path ? node.name + "/" + path : node.name;
              node = node.parent;
            }
          },
          hashName: function hashName(parentid, name) {
            var hash = 0;

            for (var i = 0; i < name.length; i++) {
              hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
            }

            return (parentid + hash >>> 0) % FS.nameTable.length;
          },
          hashAddNode: function hashAddNode(node) {
            var hash = FS.hashName(node.parent.id, node.name);
            node.name_next = FS.nameTable[hash];
            FS.nameTable[hash] = node;
          },
          hashRemoveNode: function hashRemoveNode(node) {
            var hash = FS.hashName(node.parent.id, node.name);

            if (FS.nameTable[hash] === node) {
              FS.nameTable[hash] = node.name_next;
            } else {
              var current = FS.nameTable[hash];

              while (current) {
                if (current.name_next === node) {
                  current.name_next = node.name_next;
                  break;
                }

                current = current.name_next;
              }
            }
          },
          lookupNode: function lookupNode(parent, name) {
            var errCode = FS.mayLookup(parent);

            if (errCode) {
              throw new FS.ErrnoError(errCode, parent);
            }

            var hash = FS.hashName(parent.id, name);

            for (var node = FS.nameTable[hash]; node; node = node.name_next) {
              var nodeName = node.name;

              if (node.parent.id === parent.id && nodeName === name) {
                return node;
              }
            }

            return FS.lookup(parent, name);
          },
          createNode: function createNode(parent, name, mode, rdev) {
            var node = new FS.FSNode(parent, name, mode, rdev);
            FS.hashAddNode(node);
            return node;
          },
          destroyNode: function destroyNode(node) {
            FS.hashRemoveNode(node);
          },
          isRoot: function isRoot(node) {
            return node === node.parent;
          },
          isMountpoint: function isMountpoint(node) {
            return !!node.mounted;
          },
          isFile: function isFile(mode) {
            return (mode & 61440) === 32768;
          },
          isDir: function isDir(mode) {
            return (mode & 61440) === 16384;
          },
          isLink: function isLink(mode) {
            return (mode & 61440) === 40960;
          },
          isChrdev: function isChrdev(mode) {
            return (mode & 61440) === 8192;
          },
          isBlkdev: function isBlkdev(mode) {
            return (mode & 61440) === 24576;
          },
          isFIFO: function isFIFO(mode) {
            return (mode & 61440) === 4096;
          },
          isSocket: function isSocket(mode) {
            return (mode & 49152) === 49152;
          },
          flagModes: {
            "r": 0,
            "r+": 2,
            "w": 577,
            "w+": 578,
            "a": 1089,
            "a+": 1090
          },
          modeStringToFlags: function modeStringToFlags(str) {
            var flags = FS.flagModes[str];

            if (typeof flags == "undefined") {
              throw new Error("Unknown file open mode: " + str);
            }

            return flags;
          },
          flagsToPermissionString: function flagsToPermissionString(flag) {
            var perms = ["r", "w", "rw"][flag & 3];

            if (flag & 512) {
              perms += "w";
            }

            return perms;
          },
          nodePermissions: function nodePermissions(node, perms) {
            if (FS.ignorePermissions) {
              return 0;
            }

            if (perms.includes("r") && !(node.mode & 292)) {
              return 2;
            } else if (perms.includes("w") && !(node.mode & 146)) {
              return 2;
            } else if (perms.includes("x") && !(node.mode & 73)) {
              return 2;
            }

            return 0;
          },
          mayLookup: function mayLookup(dir) {
            var errCode = FS.nodePermissions(dir, "x");
            if (errCode) return errCode;
            if (!dir.node_ops.lookup) return 2;
            return 0;
          },
          mayCreate: function mayCreate(dir, name) {
            try {
              var node = FS.lookupNode(dir, name);
              return 20;
            } catch (e) {}

            return FS.nodePermissions(dir, "wx");
          },
          mayDelete: function mayDelete(dir, name, isdir) {
            var node;

            try {
              node = FS.lookupNode(dir, name);
            } catch (e) {
              return e.errno;
            }

            var errCode = FS.nodePermissions(dir, "wx");

            if (errCode) {
              return errCode;
            }

            if (isdir) {
              if (!FS.isDir(node.mode)) {
                return 54;
              }

              if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) {
                return 10;
              }
            } else {
              if (FS.isDir(node.mode)) {
                return 31;
              }
            }

            return 0;
          },
          mayOpen: function mayOpen(node, flags) {
            if (!node) {
              return 44;
            }

            if (FS.isLink(node.mode)) {
              return 32;
            } else if (FS.isDir(node.mode)) {
              if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) {
                return 31;
              }
            }

            return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
          },
          MAX_OPEN_FDS: 4096,
          nextfd: function nextfd() {
            var fd_start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var fd_end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FS.MAX_OPEN_FDS;

            for (var fd = fd_start; fd <= fd_end; fd++) {
              if (!FS.streams[fd]) {
                return fd;
              }
            }

            throw new FS.ErrnoError(33);
          },
          getStream: function getStream(fd) {
            return FS.streams[fd];
          },
          createStream: function createStream(stream, fd_start, fd_end) {
            if (!FS.FSStream) {
              FS.FSStream = function () {
                this.shared = {};
              };

              FS.FSStream.prototype = {};
              Object.defineProperties(FS.FSStream.prototype, {
                object: {
                  get: function get() {
                    return this.node;
                  },
                  set: function set(val) {
                    this.node = val;
                  }
                },
                isRead: {
                  get: function get() {
                    return (this.flags & 2097155) !== 1;
                  }
                },
                isWrite: {
                  get: function get() {
                    return (this.flags & 2097155) !== 0;
                  }
                },
                isAppend: {
                  get: function get() {
                    return this.flags & 1024;
                  }
                },
                flags: {
                  get: function get() {
                    return this.shared.flags;
                  },
                  set: function set(val) {
                    this.shared.flags = val;
                  }
                },
                position: {
                  get: function get() {
                    return this.shared.position;
                  },
                  set: function set(val) {
                    this.shared.position = val;
                  }
                }
              });
            }

            stream = Object.assign(new FS.FSStream(), stream);
            var fd = FS.nextfd(fd_start, fd_end);
            stream.fd = fd;
            FS.streams[fd] = stream;
            return stream;
          },
          closeStream: function closeStream(fd) {
            FS.streams[fd] = null;
          },
          chrdev_stream_ops: {
            open: function open(stream) {
              var device = FS.getDevice(stream.node.rdev);
              stream.stream_ops = device.stream_ops;

              if (stream.stream_ops.open) {
                stream.stream_ops.open(stream);
              }
            },
            llseek: function llseek() {
              throw new FS.ErrnoError(70);
            }
          },
          major: function major(dev) {
            return dev >> 8;
          },
          minor: function minor(dev) {
            return dev & 255;
          },
          makedev: function makedev(ma, mi) {
            return ma << 8 | mi;
          },
          registerDevice: function registerDevice(dev, ops) {
            FS.devices[dev] = {
              stream_ops: ops
            };
          },
          getDevice: function getDevice(dev) {
            return FS.devices[dev];
          },
          getMounts: function getMounts(mount) {
            var mounts = [];
            var check = [mount];

            while (check.length) {
              var m = check.pop();
              mounts.push(m);
              check.push.apply(check, m.mounts);
            }

            return mounts;
          },
          syncfs: function syncfs(populate, callback) {
            if (typeof populate == "function") {
              callback = populate;
              populate = false;
            }

            FS.syncFSRequests++;

            if (FS.syncFSRequests > 1) {
              err("warning: " + FS.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
            }

            var mounts = FS.getMounts(FS.root.mount);
            var completed = 0;

            function doCallback(errCode) {
              FS.syncFSRequests--;
              return callback(errCode);
            }

            function done(errCode) {
              if (errCode) {
                if (!done.errored) {
                  done.errored = true;
                  return doCallback(errCode);
                }

                return;
              }

              if (++completed >= mounts.length) {
                doCallback(null);
              }
            }

            mounts.forEach(function (mount) {
              if (!mount.type.syncfs) {
                return done(null);
              }

              mount.type.syncfs(mount, populate, done);
            });
          },
          mount: function mount(type, opts, mountpoint) {
            var root = mountpoint === "/";
            var pseudo = !mountpoint;
            var node;

            if (root && FS.root) {
              throw new FS.ErrnoError(10);
            } else if (!root && !pseudo) {
              var lookup = FS.lookupPath(mountpoint, {
                follow_mount: false
              });
              mountpoint = lookup.path;
              node = lookup.node;

              if (FS.isMountpoint(node)) {
                throw new FS.ErrnoError(10);
              }

              if (!FS.isDir(node.mode)) {
                throw new FS.ErrnoError(54);
              }
            }

            var mount = {
              type: type,
              opts: opts,
              mountpoint: mountpoint,
              mounts: []
            };
            var mountRoot = type.mount(mount);
            mountRoot.mount = mount;
            mount.root = mountRoot;

            if (root) {
              FS.root = mountRoot;
            } else if (node) {
              node.mounted = mount;

              if (node.mount) {
                node.mount.mounts.push(mount);
              }
            }

            return mountRoot;
          },
          unmount: function unmount(mountpoint) {
            var lookup = FS.lookupPath(mountpoint, {
              follow_mount: false
            });

            if (!FS.isMountpoint(lookup.node)) {
              throw new FS.ErrnoError(28);
            }

            var node = lookup.node;
            var mount = node.mounted;
            var mounts = FS.getMounts(mount);
            Object.keys(FS.nameTable).forEach(function (hash) {
              var current = FS.nameTable[hash];

              while (current) {
                var next = current.name_next;

                if (mounts.includes(current.mount)) {
                  FS.destroyNode(current);
                }

                current = next;
              }
            });
            node.mounted = null;
            var idx = node.mount.mounts.indexOf(mount);
            node.mount.mounts.splice(idx, 1);
          },
          lookup: function lookup(parent, name) {
            return parent.node_ops.lookup(parent, name);
          },
          mknod: function mknod(path, mode, dev) {
            var lookup = FS.lookupPath(path, {
              parent: true
            });
            var parent = lookup.node;
            var name = PATH.basename(path);

            if (!name || name === "." || name === "..") {
              throw new FS.ErrnoError(28);
            }

            var errCode = FS.mayCreate(parent, name);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            if (!parent.node_ops.mknod) {
              throw new FS.ErrnoError(63);
            }

            return parent.node_ops.mknod(parent, name, mode, dev);
          },
          create: function create(path, mode) {
            mode = mode !== void 0 ? mode : 438;
            mode &= 4095;
            mode |= 32768;
            return FS.mknod(path, mode, 0);
          },
          mkdir: function mkdir(path, mode) {
            mode = mode !== void 0 ? mode : 511;
            mode &= 511 | 512;
            mode |= 16384;
            return FS.mknod(path, mode, 0);
          },
          mkdirTree: function mkdirTree(path, mode) {
            var dirs = path.split("/");
            var d = "";

            for (var i = 0; i < dirs.length; ++i) {
              if (!dirs[i]) continue;
              d += "/" + dirs[i];

              try {
                FS.mkdir(d, mode);
              } catch (e) {
                if (e.errno != 20) throw e;
              }
            }
          },
          mkdev: function mkdev(path, mode, dev) {
            if (typeof dev == "undefined") {
              dev = mode;
              mode = 438;
            }

            mode |= 8192;
            return FS.mknod(path, mode, dev);
          },
          symlink: function symlink(oldpath, newpath) {
            if (!PATH_FS.resolve(oldpath)) {
              throw new FS.ErrnoError(44);
            }

            var lookup = FS.lookupPath(newpath, {
              parent: true
            });
            var parent = lookup.node;

            if (!parent) {
              throw new FS.ErrnoError(44);
            }

            var newname = PATH.basename(newpath);
            var errCode = FS.mayCreate(parent, newname);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            if (!parent.node_ops.symlink) {
              throw new FS.ErrnoError(63);
            }

            return parent.node_ops.symlink(parent, newname, oldpath);
          },
          rename: function rename(old_path, new_path) {
            var old_dirname = PATH.dirname(old_path);
            var new_dirname = PATH.dirname(new_path);
            var old_name = PATH.basename(old_path);
            var new_name = PATH.basename(new_path);
            var lookup, old_dir, new_dir;
            lookup = FS.lookupPath(old_path, {
              parent: true
            });
            old_dir = lookup.node;
            lookup = FS.lookupPath(new_path, {
              parent: true
            });
            new_dir = lookup.node;
            if (!old_dir || !new_dir) throw new FS.ErrnoError(44);

            if (old_dir.mount !== new_dir.mount) {
              throw new FS.ErrnoError(75);
            }

            var old_node = FS.lookupNode(old_dir, old_name);
            var relative = PATH_FS.relative(old_path, new_dirname);

            if (relative.charAt(0) !== ".") {
              throw new FS.ErrnoError(28);
            }

            relative = PATH_FS.relative(new_path, old_dirname);

            if (relative.charAt(0) !== ".") {
              throw new FS.ErrnoError(55);
            }

            var new_node;

            try {
              new_node = FS.lookupNode(new_dir, new_name);
            } catch (e) {}

            if (old_node === new_node) {
              return;
            }

            var isdir = FS.isDir(old_node.mode);
            var errCode = FS.mayDelete(old_dir, old_name, isdir);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            if (!old_dir.node_ops.rename) {
              throw new FS.ErrnoError(63);
            }

            if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) {
              throw new FS.ErrnoError(10);
            }

            if (new_dir !== old_dir) {
              errCode = FS.nodePermissions(old_dir, "w");

              if (errCode) {
                throw new FS.ErrnoError(errCode);
              }
            }

            FS.hashRemoveNode(old_node);

            try {
              old_dir.node_ops.rename(old_node, new_dir, new_name);
            } catch (e) {
              throw e;
            } finally {
              FS.hashAddNode(old_node);
            }
          },
          rmdir: function rmdir(path) {
            var lookup = FS.lookupPath(path, {
              parent: true
            });
            var parent = lookup.node;
            var name = PATH.basename(path);
            var node = FS.lookupNode(parent, name);
            var errCode = FS.mayDelete(parent, name, true);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            if (!parent.node_ops.rmdir) {
              throw new FS.ErrnoError(63);
            }

            if (FS.isMountpoint(node)) {
              throw new FS.ErrnoError(10);
            }

            parent.node_ops.rmdir(parent, name);
            FS.destroyNode(node);
          },
          readdir: function readdir(path) {
            var lookup = FS.lookupPath(path, {
              follow: true
            });
            var node = lookup.node;

            if (!node.node_ops.readdir) {
              throw new FS.ErrnoError(54);
            }

            return node.node_ops.readdir(node);
          },
          unlink: function unlink(path) {
            var lookup = FS.lookupPath(path, {
              parent: true
            });
            var parent = lookup.node;

            if (!parent) {
              throw new FS.ErrnoError(44);
            }

            var name = PATH.basename(path);
            var node = FS.lookupNode(parent, name);
            var errCode = FS.mayDelete(parent, name, false);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            if (!parent.node_ops.unlink) {
              throw new FS.ErrnoError(63);
            }

            if (FS.isMountpoint(node)) {
              throw new FS.ErrnoError(10);
            }

            parent.node_ops.unlink(parent, name);
            FS.destroyNode(node);
          },
          readlink: function readlink(path) {
            var lookup = FS.lookupPath(path);
            var link = lookup.node;

            if (!link) {
              throw new FS.ErrnoError(44);
            }

            if (!link.node_ops.readlink) {
              throw new FS.ErrnoError(28);
            }

            return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
          },
          stat: function stat(path, dontFollow) {
            var lookup = FS.lookupPath(path, {
              follow: !dontFollow
            });
            var node = lookup.node;

            if (!node) {
              throw new FS.ErrnoError(44);
            }

            if (!node.node_ops.getattr) {
              throw new FS.ErrnoError(63);
            }

            return node.node_ops.getattr(node);
          },
          lstat: function lstat(path) {
            return FS.stat(path, true);
          },
          chmod: function chmod(path, mode, dontFollow) {
            var node;

            if (typeof path == "string") {
              var lookup = FS.lookupPath(path, {
                follow: !dontFollow
              });
              node = lookup.node;
            } else {
              node = path;
            }

            if (!node.node_ops.setattr) {
              throw new FS.ErrnoError(63);
            }

            node.node_ops.setattr(node, {
              mode: mode & 4095 | node.mode & ~4095,
              timestamp: Date.now()
            });
          },
          lchmod: function lchmod(path, mode) {
            FS.chmod(path, mode, true);
          },
          fchmod: function fchmod(fd, mode) {
            var stream = FS.getStream(fd);

            if (!stream) {
              throw new FS.ErrnoError(8);
            }

            FS.chmod(stream.node, mode);
          },
          chown: function chown(path, uid, gid, dontFollow) {
            var node;

            if (typeof path == "string") {
              var lookup = FS.lookupPath(path, {
                follow: !dontFollow
              });
              node = lookup.node;
            } else {
              node = path;
            }

            if (!node.node_ops.setattr) {
              throw new FS.ErrnoError(63);
            }

            node.node_ops.setattr(node, {
              timestamp: Date.now()
            });
          },
          lchown: function lchown(path, uid, gid) {
            FS.chown(path, uid, gid, true);
          },
          fchown: function fchown(fd, uid, gid) {
            var stream = FS.getStream(fd);

            if (!stream) {
              throw new FS.ErrnoError(8);
            }

            FS.chown(stream.node, uid, gid);
          },
          truncate: function truncate(path, len) {
            if (len < 0) {
              throw new FS.ErrnoError(28);
            }

            var node;

            if (typeof path == "string") {
              var lookup = FS.lookupPath(path, {
                follow: true
              });
              node = lookup.node;
            } else {
              node = path;
            }

            if (!node.node_ops.setattr) {
              throw new FS.ErrnoError(63);
            }

            if (FS.isDir(node.mode)) {
              throw new FS.ErrnoError(31);
            }

            if (!FS.isFile(node.mode)) {
              throw new FS.ErrnoError(28);
            }

            var errCode = FS.nodePermissions(node, "w");

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            node.node_ops.setattr(node, {
              size: len,
              timestamp: Date.now()
            });
          },
          ftruncate: function ftruncate(fd, len) {
            var stream = FS.getStream(fd);

            if (!stream) {
              throw new FS.ErrnoError(8);
            }

            if ((stream.flags & 2097155) === 0) {
              throw new FS.ErrnoError(28);
            }

            FS.truncate(stream.node, len);
          },
          utime: function utime(path, atime, mtime) {
            var lookup = FS.lookupPath(path, {
              follow: true
            });
            var node = lookup.node;
            node.node_ops.setattr(node, {
              timestamp: Math.max(atime, mtime)
            });
          },
          open: function open(path, flags, mode) {
            if (path === "") {
              throw new FS.ErrnoError(44);
            }

            flags = typeof flags == "string" ? FS.modeStringToFlags(flags) : flags;
            mode = typeof mode == "undefined" ? 438 : mode;

            if (flags & 64) {
              mode = mode & 4095 | 32768;
            } else {
              mode = 0;
            }

            var node;

            if (typeof path == "object") {
              node = path;
            } else {
              path = PATH.normalize(path);

              try {
                var lookup = FS.lookupPath(path, {
                  follow: !(flags & 131072)
                });
                node = lookup.node;
              } catch (e) {}
            }

            var created = false;

            if (flags & 64) {
              if (node) {
                if (flags & 128) {
                  throw new FS.ErrnoError(20);
                }
              } else {
                node = FS.mknod(path, mode, 0);
                created = true;
              }
            }

            if (!node) {
              throw new FS.ErrnoError(44);
            }

            if (FS.isChrdev(node.mode)) {
              flags &= ~512;
            }

            if (flags & 65536 && !FS.isDir(node.mode)) {
              throw new FS.ErrnoError(54);
            }

            if (!created) {
              var errCode = FS.mayOpen(node, flags);

              if (errCode) {
                throw new FS.ErrnoError(errCode);
              }
            }

            if (flags & 512 && !created) {
              FS.truncate(node, 0);
            }

            flags &= ~(128 | 512 | 131072);
            var stream = FS.createStream({
              node: node,
              path: FS.getPath(node),
              flags: flags,
              seekable: true,
              position: 0,
              stream_ops: node.stream_ops,
              ungotten: [],
              error: false
            });

            if (stream.stream_ops.open) {
              stream.stream_ops.open(stream);
            }

            if (Module["logReadFiles"] && !(flags & 1)) {
              if (!FS.readFiles) FS.readFiles = {};

              if (!(path in FS.readFiles)) {
                FS.readFiles[path] = 1;
              }
            }

            return stream;
          },
          close: function close(stream) {
            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }

            if (stream.getdents) stream.getdents = null;

            try {
              if (stream.stream_ops.close) {
                stream.stream_ops.close(stream);
              }
            } catch (e) {
              throw e;
            } finally {
              FS.closeStream(stream.fd);
            }

            stream.fd = null;
          },
          isClosed: function isClosed(stream) {
            return stream.fd === null;
          },
          llseek: function llseek(stream, offset, whence) {
            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }

            if (!stream.seekable || !stream.stream_ops.llseek) {
              throw new FS.ErrnoError(70);
            }

            if (whence != 0 && whence != 1 && whence != 2) {
              throw new FS.ErrnoError(28);
            }

            stream.position = stream.stream_ops.llseek(stream, offset, whence);
            stream.ungotten = [];
            return stream.position;
          },
          read: function read(stream, buffer, offset, length, position) {
            offset >>>= 0;

            if (length < 0 || position < 0) {
              throw new FS.ErrnoError(28);
            }

            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }

            if ((stream.flags & 2097155) === 1) {
              throw new FS.ErrnoError(8);
            }

            if (FS.isDir(stream.node.mode)) {
              throw new FS.ErrnoError(31);
            }

            if (!stream.stream_ops.read) {
              throw new FS.ErrnoError(28);
            }

            var seeking = typeof position != "undefined";

            if (!seeking) {
              position = stream.position;
            } else if (!stream.seekable) {
              throw new FS.ErrnoError(70);
            }

            var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
            if (!seeking) stream.position += bytesRead;
            return bytesRead;
          },
          write: function write(stream, buffer, offset, length, position, canOwn) {
            offset >>>= 0;

            if (length < 0 || position < 0) {
              throw new FS.ErrnoError(28);
            }

            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }

            if ((stream.flags & 2097155) === 0) {
              throw new FS.ErrnoError(8);
            }

            if (FS.isDir(stream.node.mode)) {
              throw new FS.ErrnoError(31);
            }

            if (!stream.stream_ops.write) {
              throw new FS.ErrnoError(28);
            }

            if (stream.seekable && stream.flags & 1024) {
              FS.llseek(stream, 0, 2);
            }

            var seeking = typeof position != "undefined";

            if (!seeking) {
              position = stream.position;
            } else if (!stream.seekable) {
              throw new FS.ErrnoError(70);
            }

            var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
            if (!seeking) stream.position += bytesWritten;
            return bytesWritten;
          },
          allocate: function allocate(stream, offset, length) {
            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }

            if (offset < 0 || length <= 0) {
              throw new FS.ErrnoError(28);
            }

            if ((stream.flags & 2097155) === 0) {
              throw new FS.ErrnoError(8);
            }

            if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) {
              throw new FS.ErrnoError(43);
            }

            if (!stream.stream_ops.allocate) {
              throw new FS.ErrnoError(138);
            }

            stream.stream_ops.allocate(stream, offset, length);
          },
          mmap: function mmap(stream, length, position, prot, flags) {
            if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) {
              throw new FS.ErrnoError(2);
            }

            if ((stream.flags & 2097155) === 1) {
              throw new FS.ErrnoError(2);
            }

            if (!stream.stream_ops.mmap) {
              throw new FS.ErrnoError(43);
            }

            return stream.stream_ops.mmap(stream, length, position, prot, flags);
          },
          msync: function msync(stream, buffer, offset, length, mmapFlags) {
            offset >>>= 0;

            if (!stream.stream_ops.msync) {
              return 0;
            }

            return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
          },
          munmap: function munmap(stream) {
            return 0;
          },
          ioctl: function ioctl(stream, cmd, arg) {
            if (!stream.stream_ops.ioctl) {
              throw new FS.ErrnoError(59);
            }

            return stream.stream_ops.ioctl(stream, cmd, arg);
          },
          readFile: function readFile(path) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            opts.flags = opts.flags || 0;
            opts.encoding = opts.encoding || "binary";

            if (opts.encoding !== "utf8" && opts.encoding !== "binary") {
              throw new Error('Invalid encoding type "' + opts.encoding + '"');
            }

            var ret;
            var stream = FS.open(path, opts.flags);
            var stat = FS.stat(path);
            var length = stat.size;
            var buf = new Uint8Array(length);
            FS.read(stream, buf, 0, length, 0);

            if (opts.encoding === "utf8") {
              ret = UTF8ArrayToString(buf, 0);
            } else if (opts.encoding === "binary") {
              ret = buf;
            }

            FS.close(stream);
            return ret;
          },
          writeFile: function writeFile(path, data) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            opts.flags = opts.flags || 577;
            var stream = FS.open(path, opts.flags, opts.mode);

            if (typeof data == "string") {
              var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
              var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
              FS.write(stream, buf, 0, actualNumBytes, void 0, opts.canOwn);
            } else if (ArrayBuffer.isView(data)) {
              FS.write(stream, data, 0, data.byteLength, void 0, opts.canOwn);
            } else {
              throw new Error("Unsupported data type");
            }

            FS.close(stream);
          },
          cwd: function cwd() {
            return FS.currentPath;
          },
          chdir: function chdir(path) {
            var lookup = FS.lookupPath(path, {
              follow: true
            });

            if (lookup.node === null) {
              throw new FS.ErrnoError(44);
            }

            if (!FS.isDir(lookup.node.mode)) {
              throw new FS.ErrnoError(54);
            }

            var errCode = FS.nodePermissions(lookup.node, "x");

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            FS.currentPath = lookup.path;
          },
          createDefaultDirectories: function createDefaultDirectories() {
            FS.mkdir("/tmp");
            FS.mkdir("/home");
            FS.mkdir("/home/web_user");
          },
          createDefaultDevices: function createDefaultDevices() {
            FS.mkdir("/dev");
            FS.registerDevice(FS.makedev(1, 3), {
              read: function read() {
                return 0;
              },
              write: function write(stream, buffer, offset, length, pos) {
                return length;
              }
            });
            FS.mkdev("/dev/null", FS.makedev(1, 3));
            TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
            TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
            FS.mkdev("/dev/tty", FS.makedev(5, 0));
            FS.mkdev("/dev/tty1", FS.makedev(6, 0));
            var random_device = getRandomDevice();
            FS.createDevice("/dev", "random", random_device);
            FS.createDevice("/dev", "urandom", random_device);
            FS.mkdir("/dev/shm");
            FS.mkdir("/dev/shm/tmp");
          },
          createSpecialDirectories: function createSpecialDirectories() {
            FS.mkdir("/proc");
            var proc_self = FS.mkdir("/proc/self");
            FS.mkdir("/proc/self/fd");
            FS.mount({
              mount: function mount() {
                var node = FS.createNode(proc_self, "fd", 16384 | 511, 73);
                node.node_ops = {
                  lookup: function lookup(parent, name) {
                    var fd = +name;
                    var stream = FS.getStream(fd);
                    if (!stream) throw new FS.ErrnoError(8);
                    var ret = {
                      parent: null,
                      mount: {
                        mountpoint: "fake"
                      },
                      node_ops: {
                        readlink: function readlink() {
                          return stream.path;
                        }
                      }
                    };
                    ret.parent = ret;
                    return ret;
                  }
                };
                return node;
              }
            }, {}, "/proc/self/fd");
          },
          createStandardStreams: function createStandardStreams() {
            if (Module["stdin"]) {
              FS.createDevice("/dev", "stdin", Module["stdin"]);
            } else {
              FS.symlink("/dev/tty", "/dev/stdin");
            }

            if (Module["stdout"]) {
              FS.createDevice("/dev", "stdout", null, Module["stdout"]);
            } else {
              FS.symlink("/dev/tty", "/dev/stdout");
            }

            if (Module["stderr"]) {
              FS.createDevice("/dev", "stderr", null, Module["stderr"]);
            } else {
              FS.symlink("/dev/tty1", "/dev/stderr");
            }

            FS.open("/dev/stdin", 0);
            FS.open("/dev/stdout", 1);
            FS.open("/dev/stderr", 1);
          },
          ensureErrnoError: function ensureErrnoError() {
            if (FS.ErrnoError) return;

            FS.ErrnoError = function ErrnoError(errno, node) {
              this.node = node;

              this.setErrno = function (errno2) {
                this.errno = errno2;
              };

              this.setErrno(errno);
              this.message = "FS error";
            };

            FS.ErrnoError.prototype = new Error();
            FS.ErrnoError.prototype.constructor = FS.ErrnoError;
            [44].forEach(function (code) {
              FS.genericErrors[code] = new FS.ErrnoError(code);
              FS.genericErrors[code].stack = "<generic error, no stack>";
            });
          },
          staticInit: function staticInit() {
            FS.ensureErrnoError();
            FS.nameTable = new Array(4096);
            FS.mount(MEMFS, {}, "/");
            FS.createDefaultDirectories();
            FS.createDefaultDevices();
            FS.createSpecialDirectories();
            FS.filesystems = {
              "MEMFS": MEMFS
            };
          },
          init: function init(input, output, error) {
            FS.init.initialized = true;
            FS.ensureErrnoError();
            Module["stdin"] = input || Module["stdin"];
            Module["stdout"] = output || Module["stdout"];
            Module["stderr"] = error || Module["stderr"];
            FS.createStandardStreams();
          },
          quit: function quit() {
            FS.init.initialized = false;

            for (var i = 0; i < FS.streams.length; i++) {
              var stream = FS.streams[i];

              if (!stream) {
                continue;
              }

              FS.close(stream);
            }
          },
          getMode: function getMode(canRead, canWrite) {
            var mode = 0;
            if (canRead) mode |= 292 | 73;
            if (canWrite) mode |= 146;
            return mode;
          },
          findObject: function findObject(path, dontResolveLastLink) {
            var ret = FS.analyzePath(path, dontResolveLastLink);

            if (!ret.exists) {
              return null;
            }

            return ret.object;
          },
          analyzePath: function analyzePath(path, dontResolveLastLink) {
            try {
              var lookup = FS.lookupPath(path, {
                follow: !dontResolveLastLink
              });
              path = lookup.path;
            } catch (e) {}

            var ret = {
              isRoot: false,
              exists: false,
              error: 0,
              name: null,
              path: null,
              object: null,
              parentExists: false,
              parentPath: null,
              parentObject: null
            };

            try {
              var lookup = FS.lookupPath(path, {
                parent: true
              });
              ret.parentExists = true;
              ret.parentPath = lookup.path;
              ret.parentObject = lookup.node;
              ret.name = PATH.basename(path);
              lookup = FS.lookupPath(path, {
                follow: !dontResolveLastLink
              });
              ret.exists = true;
              ret.path = lookup.path;
              ret.object = lookup.node;
              ret.name = lookup.node.name;
              ret.isRoot = lookup.path === "/";
            } catch (e) {
              ret.error = e.errno;
            }

            return ret;
          },
          createPath: function createPath(parent, path, canRead, canWrite) {
            parent = typeof parent == "string" ? parent : FS.getPath(parent);
            var parts = path.split("/").reverse();

            while (parts.length) {
              var part = parts.pop();
              if (!part) continue;
              var current = PATH.join2(parent, part);

              try {
                FS.mkdir(current);
              } catch (e) {}

              parent = current;
            }

            return current;
          },
          createFile: function createFile(parent, name, properties, canRead, canWrite) {
            var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
            var mode = FS.getMode(canRead, canWrite);
            return FS.create(path, mode);
          },
          createDataFile: function createDataFile(parent, name, data, canRead, canWrite, canOwn) {
            var path = name;

            if (parent) {
              parent = typeof parent == "string" ? parent : FS.getPath(parent);
              path = name ? PATH.join2(parent, name) : parent;
            }

            var mode = FS.getMode(canRead, canWrite);
            var node = FS.create(path, mode);

            if (data) {
              if (typeof data == "string") {
                var arr = new Array(data.length);

                for (var i = 0, len = data.length; i < len; ++i) {
                  arr[i] = data.charCodeAt(i);
                }

                data = arr;
              }

              FS.chmod(node, mode | 146);
              var stream = FS.open(node, 577);
              FS.write(stream, data, 0, data.length, 0, canOwn);
              FS.close(stream);
              FS.chmod(node, mode);
            }

            return node;
          },
          createDevice: function createDevice(parent, name, input, output) {
            var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
            var mode = FS.getMode(!!input, !!output);
            if (!FS.createDevice.major) FS.createDevice.major = 64;
            var dev = FS.makedev(FS.createDevice.major++, 0);
            FS.registerDevice(dev, {
              open: function open(stream) {
                stream.seekable = false;
              },
              close: function close(stream) {
                if (output && output.buffer && output.buffer.length) {
                  output(10);
                }
              },
              read: function read(stream, buffer, offset, length, pos) {
                var bytesRead = 0;

                for (var i = 0; i < length; i++) {
                  var result;

                  try {
                    result = input();
                  } catch (e) {
                    throw new FS.ErrnoError(29);
                  }

                  if (result === void 0 && bytesRead === 0) {
                    throw new FS.ErrnoError(6);
                  }

                  if (result === null || result === void 0) break;
                  bytesRead++;
                  buffer[offset + i] = result;
                }

                if (bytesRead) {
                  stream.node.timestamp = Date.now();
                }

                return bytesRead;
              },
              write: function write(stream, buffer, offset, length, pos) {
                for (var i = 0; i < length; i++) {
                  try {
                    output(buffer[offset + i]);
                  } catch (e) {
                    throw new FS.ErrnoError(29);
                  }
                }

                if (length) {
                  stream.node.timestamp = Date.now();
                }

                return i;
              }
            });
            return FS.mkdev(path, mode, dev);
          },
          forceLoadFile: function forceLoadFile(obj) {
            if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;

            if (typeof XMLHttpRequest != "undefined") {
              throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
            } else if (read_) {
              try {
                obj.contents = intArrayFromString(read_(obj.url), true);
                obj.usedBytes = obj.contents.length;
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
            } else {
              throw new Error("Cannot load without read() or XMLHttpRequest.");
            }
          },
          createLazyFile: function createLazyFile(parent, name, url, canRead, canWrite) {
            function LazyUint8Array() {
              this.lengthKnown = false;
              this.chunks = [];
            }

            LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
              if (idx > this.length - 1 || idx < 0) {
                return void 0;
              }

              var chunkOffset = idx % this.chunkSize;
              var chunkNum = idx / this.chunkSize | 0;
              return this.getter(chunkNum)[chunkOffset];
            };

            LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
              this.getter = getter;
            };

            LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
              var xhr = new XMLHttpRequest();
              xhr.open("HEAD", url, false);
              xhr.send(null);
              if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
              var datalength = Number(xhr.getResponseHeader("Content-length"));
              var header;
              var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
              var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
              var chunkSize = 1024 * 1024;
              if (!hasByteServing) chunkSize = datalength;

              var doXHR = function doXHR(from, to) {
                if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
                var xhr2 = new XMLHttpRequest();
                xhr2.open("GET", url, false);
                if (datalength !== chunkSize) xhr2.setRequestHeader("Range", "bytes=" + from + "-" + to);
                xhr2.responseType = "arraybuffer";

                if (xhr2.overrideMimeType) {
                  xhr2.overrideMimeType("text/plain; charset=x-user-defined");
                }

                xhr2.send(null);
                if (!(xhr2.status >= 200 && xhr2.status < 300 || xhr2.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr2.status);

                if (xhr2.response !== void 0) {
                  return new Uint8Array(xhr2.response || []);
                }

                return intArrayFromString(xhr2.responseText || "", true);
              };

              var lazyArray2 = this;
              lazyArray2.setDataGetter(function (chunkNum) {
                var start = chunkNum * chunkSize;
                var end = (chunkNum + 1) * chunkSize - 1;
                end = Math.min(end, datalength - 1);

                if (typeof lazyArray2.chunks[chunkNum] == "undefined") {
                  lazyArray2.chunks[chunkNum] = doXHR(start, end);
                }

                if (typeof lazyArray2.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
                return lazyArray2.chunks[chunkNum];
              });

              if (usesGzip || !datalength) {
                chunkSize = datalength = 1;
                datalength = this.getter(0).length;
                chunkSize = datalength;
                out("LazyFiles on gzip forces download of the whole file when length is accessed");
              }

              this._length = datalength;
              this._chunkSize = chunkSize;
              this.lengthKnown = true;
            };

            if (typeof XMLHttpRequest != "undefined") {
              if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
              var lazyArray = new LazyUint8Array();
              Object.defineProperties(lazyArray, {
                length: {
                  get: function get() {
                    if (!this.lengthKnown) {
                      this.cacheLength();
                    }

                    return this._length;
                  }
                },
                chunkSize: {
                  get: function get() {
                    if (!this.lengthKnown) {
                      this.cacheLength();
                    }

                    return this._chunkSize;
                  }
                }
              });
              var properties = {
                isDevice: false,
                contents: lazyArray
              };
            } else {
              var properties = {
                isDevice: false,
                url: url
              };
            }

            var node = FS.createFile(parent, name, properties, canRead, canWrite);

            if (properties.contents) {
              node.contents = properties.contents;
            } else if (properties.url) {
              node.contents = null;
              node.url = properties.url;
            }

            Object.defineProperties(node, {
              usedBytes: {
                get: function get() {
                  return this.contents.length;
                }
              }
            });
            var stream_ops = {};
            var keys = Object.keys(node.stream_ops);
            keys.forEach(function (key) {
              var fn = node.stream_ops[key];

              stream_ops[key] = function forceLoadLazyFile() {
                FS.forceLoadFile(node);
                return fn.apply(null, arguments);
              };
            });

            function writeChunks(stream, buffer, offset, length, position) {
              var contents = stream.node.contents;
              if (position >= contents.length) return 0;
              var size = Math.min(contents.length - position, length);

              if (contents.slice) {
                for (var i = 0; i < size; i++) {
                  buffer[offset + i] = contents[position + i];
                }
              } else {
                for (var i = 0; i < size; i++) {
                  buffer[offset + i] = contents.get(position + i);
                }
              }

              return size;
            }

            stream_ops.read = function (stream, buffer, offset, length, position) {
              FS.forceLoadFile(node);
              return writeChunks(stream, buffer, offset, length, position);
            };

            stream_ops.mmap = function (stream, length, position, prot, flags) {
              FS.forceLoadFile(node);
              var ptr = mmapAlloc();

              if (!ptr) {
                throw new FS.ErrnoError(48);
              }

              writeChunks(stream, GROWABLE_HEAP_I8(), ptr, length, position);
              return {
                ptr: ptr,
                allocated: true
              };
            };

            node.stream_ops = stream_ops;
            return node;
          },
          createPreloadedFile: function createPreloadedFile(parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) {
            var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;

            function processData(byteArray) {
              function finish(byteArray2) {
                if (preFinish) preFinish();

                if (!dontCreateFile) {
                  FS.createDataFile(parent, name, byteArray2, canRead, canWrite, canOwn);
                }

                if (onload) onload();
                removeRunDependency();
              }

              if (Browser.handledByPreloadPlugin(byteArray, fullname, finish, function () {
                if (onerror) onerror();
                removeRunDependency();
              })) {
                return;
              }

              finish(byteArray);
            }

            addRunDependency();

            if (typeof url == "string") {
              asyncLoad(url, function (byteArray) {
                return processData(byteArray);
              }, onerror);
            } else {
              processData(url);
            }
          },
          indexedDB: function indexedDB() {
            return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
          },
          DB_NAME: function DB_NAME() {
            return "EM_FS_" + window.location.pathname;
          },
          DB_VERSION: 20,
          DB_STORE_NAME: "FILE_DATA",
          saveFilesToDB: function saveFilesToDB(paths) {
            var onload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
            var onerror = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
            var indexedDB = FS.indexedDB();

            try {
              var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
            } catch (e) {
              return onerror(e);
            }

            openRequest.onupgradeneeded = function () {
              out("creating db");
              var db = openRequest.result;
              db.createObjectStore(FS.DB_STORE_NAME);
            };

            openRequest.onsuccess = function () {
              var db = openRequest.result;
              var transaction = db.transaction([FS.DB_STORE_NAME], "readwrite");
              var files = transaction.objectStore(FS.DB_STORE_NAME);
              var ok = 0,
                  fail = 0,
                  total = paths.length;

              function finish() {
                if (fail == 0) onload();else onerror();
              }

              paths.forEach(function (path) {
                var putRequest = files.put(FS.analyzePath(path).object.contents, path);

                putRequest.onsuccess = function () {
                  ok++;
                  if (ok + fail == total) finish();
                };

                putRequest.onerror = function () {
                  fail++;
                  if (ok + fail == total) finish();
                };
              });
              transaction.onerror = onerror;
            };

            openRequest.onerror = onerror;
          },
          loadFilesFromDB: function loadFilesFromDB(paths) {
            var onload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
            var onerror = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
            var indexedDB = FS.indexedDB();

            try {
              var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
            } catch (e) {
              return onerror(e);
            }

            openRequest.onupgradeneeded = onerror;

            openRequest.onsuccess = function () {
              var db = openRequest.result;

              try {
                var transaction = db.transaction([FS.DB_STORE_NAME], "readonly");
              } catch (e) {
                onerror(e);
                return;
              }

              var files = transaction.objectStore(FS.DB_STORE_NAME);
              var ok = 0,
                  fail = 0,
                  total = paths.length;

              function finish() {
                if (fail == 0) onload();else onerror();
              }

              paths.forEach(function (path) {
                var getRequest = files.get(path);

                getRequest.onsuccess = function () {
                  if (FS.analyzePath(path).exists) {
                    FS.unlink(path);
                  }

                  FS.createDataFile(PATH.dirname(path), PATH.basename(path), getRequest.result, true, true, true);
                  ok++;
                  if (ok + fail == total) finish();
                };

                getRequest.onerror = function () {
                  fail++;
                  if (ok + fail == total) finish();
                };
              });
              transaction.onerror = onerror;
            };

            openRequest.onerror = onerror;
          }
        };
        var SYSCALLS = {
          DEFAULT_POLLMASK: 5,
          calculateAt: function calculateAt(dirfd, path, allowEmpty) {
            if (PATH.isAbs(path)) {
              return path;
            }

            var dir;

            if (dirfd === -100) {
              dir = FS.cwd();
            } else {
              var dirstream = SYSCALLS.getStreamFromFD(dirfd);
              dir = dirstream.path;
            }

            if (path.length == 0) {
              if (!allowEmpty) {
                throw new FS.ErrnoError(44);
              }

              return dir;
            }

            return PATH.join2(dir, path);
          },
          doStat: function doStat(func, path, buf) {
            try {
              var stat = func(path);
            } catch (e) {
              if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) {
                return -54;
              }

              throw e;
            }

            GROWABLE_HEAP_I32()[buf >>> 2] = stat.dev;
            GROWABLE_HEAP_I32()[buf + 8 >>> 2] = stat.ino;
            GROWABLE_HEAP_I32()[buf + 12 >>> 2] = stat.mode;
            GROWABLE_HEAP_U32()[buf + 16 >>> 2] = stat.nlink;
            GROWABLE_HEAP_I32()[buf + 20 >>> 2] = stat.uid;
            GROWABLE_HEAP_I32()[buf + 24 >>> 2] = stat.gid;
            GROWABLE_HEAP_I32()[buf + 28 >>> 2] = stat.rdev;
            tempI64 = [stat.size >>> 0, (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 40 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 44 >>> 2] = tempI64[1];
            GROWABLE_HEAP_I32()[buf + 48 >>> 2] = 4096;
            GROWABLE_HEAP_I32()[buf + 52 >>> 2] = stat.blocks;
            var atime = stat.atime.getTime();
            var mtime = stat.mtime.getTime();
            var ctime = stat.ctime.getTime();
            tempI64 = [Math.floor(atime / 1e3) >>> 0, (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 56 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 60 >>> 2] = tempI64[1];
            GROWABLE_HEAP_U32()[buf + 64 >>> 2] = atime % 1e3 * 1e3;
            tempI64 = [Math.floor(mtime / 1e3) >>> 0, (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 72 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 76 >>> 2] = tempI64[1];
            GROWABLE_HEAP_U32()[buf + 80 >>> 2] = mtime % 1e3 * 1e3;
            tempI64 = [Math.floor(ctime / 1e3) >>> 0, (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 88 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 92 >>> 2] = tempI64[1];
            GROWABLE_HEAP_U32()[buf + 96 >>> 2] = ctime % 1e3 * 1e3;
            tempI64 = [stat.ino >>> 0, (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[buf + 104 >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[buf + 108 >>> 2] = tempI64[1];
            return 0;
          },
          doMsync: function doMsync(addr, stream, len, flags, offset) {
            if (!FS.isFile(stream.node.mode)) {
              throw new FS.ErrnoError(43);
            }

            if (flags & 2) {
              return 0;
            }

            addr >>>= 0;
            var buffer = GROWABLE_HEAP_U8().slice(addr, addr + len);
            FS.msync(stream, buffer, offset, len, flags);
          },
          varargs: void 0,
          get: function get() {
            SYSCALLS.varargs += 4;
            var ret = GROWABLE_HEAP_I32()[SYSCALLS.varargs - 4 >>> 2];
            return ret;
          },
          getStr: function getStr(ptr) {
            var ret = UTF8ToString(ptr);
            return ret;
          },
          getStreamFromFD: function getStreamFromFD(fd) {
            var stream = FS.getStream(fd);
            if (!stream) throw new FS.ErrnoError(8);
            return stream;
          }
        };

        function _proc_exit(code) {
          if (ENVIRONMENT_IS_PTHREAD) return _emscripten_proxy_to_main_thread_js(1, 1, code);
          EXITSTATUS = code;

          if (!keepRuntimeAlive()) {
            PThread.terminateAllThreads();
            if (Module["onExit"]) Module["onExit"](code);
            ABORT = true;
          }

          quit_(code, new ExitStatus(code));
        }

        function exitJS(status, implicit) {
          EXITSTATUS = status;

          if (!implicit) {
            if (ENVIRONMENT_IS_PTHREAD) {
              exitOnMainThread(status);
              throw "unwind";
            }
          }

          _proc_exit(status);
        }

        var _exit = exitJS;

        function handleException(e) {
          if (e instanceof ExitStatus || e == "unwind") {
            return EXITSTATUS;
          }

          quit_(1, e);
        }

        var PThread = {
          unusedWorkers: [],
          runningWorkers: [],
          tlsInitFunctions: [],
          pthreads: {},
          init: function init() {
            if (ENVIRONMENT_IS_PTHREAD) {
              PThread.initWorker();
            } else {
              PThread.initMainThread();
            }
          },
          initMainThread: function initMainThread() {
            var pthreadPoolSize = navigator.hardwareConcurrency;

            while (pthreadPoolSize--) {
              PThread.allocateUnusedWorker();
            }
          },
          initWorker: function initWorker() {
            noExitRuntime = false;
          },
          setExitStatus: function setExitStatus(status) {
            EXITSTATUS = status;
          },
          terminateAllThreads: function terminateAllThreads() {
            for (var _i343 = 0, _Object$values = Object.values(PThread.pthreads); _i343 < _Object$values.length; _i343++) {
              var worker = _Object$values[_i343];
              PThread.returnWorkerToPool(worker);
            }

            var _iterator12 = _createForOfIteratorHelper(PThread.unusedWorkers),
                _step12;

            try {
              for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                var worker = _step12.value;
                worker.terminate();
              }
            } catch (err) {
              _iterator12.e(err);
            } finally {
              _iterator12.f();
            }

            PThread.unusedWorkers = [];
          },
          returnWorkerToPool: function returnWorkerToPool(worker) {
            var pthread_ptr = worker.pthread_ptr;
            delete PThread.pthreads[pthread_ptr];
            PThread.unusedWorkers.push(worker);
            PThread.runningWorkers.splice(PThread.runningWorkers.indexOf(worker), 1);
            worker.pthread_ptr = 0;

            if (ENVIRONMENT_IS_NODE) {
              worker.unref();
            }

            _emscripten_thread_free_data(pthread_ptr);
          },
          receiveObjectTransfer: function receiveObjectTransfer(data) {},
          threadInitTLS: function threadInitTLS() {
            PThread.tlsInitFunctions.forEach(function (f) {
              return f();
            });
          },
          loadWasmModuleToWorker: function loadWasmModuleToWorker(worker) {
            return new Promise(function (onFinishedLoading) {
              worker.onmessage = function (e) {
                var d = e["data"];
                var cmd = d["cmd"];
                if (worker.pthread_ptr) PThread.currentProxiedOperationCallerThread = worker.pthread_ptr;

                if (d["targetThread"] && d["targetThread"] != _pthread_self()) {
                  var targetWorker = PThread.pthreads[d.targetThread];

                  if (targetWorker) {
                    targetWorker.postMessage(d, d["transferList"]);
                  } else {
                    err('Internal error! Worker sent a message "' + cmd + '" to target pthread ' + d["targetThread"] + ", but that thread no longer exists!");
                  }

                  PThread.currentProxiedOperationCallerThread = void 0;
                  return;
                }

                if (cmd === "processProxyingQueue") {
                  executeNotifiedProxyingQueue(d["queue"]);
                } else if (cmd === "spawnThread") {
                  spawnThread(d);
                } else if (cmd === "cleanupThread") {
                  cleanupThread(d["thread"]);
                } else if (cmd === "killThread") {
                  killThread(d["thread"]);
                } else if (cmd === "cancelThread") {
                  cancelThread(d["thread"]);
                } else if (cmd === "loaded") {
                  worker.loaded = true;

                  if (ENVIRONMENT_IS_NODE && !worker.pthread_ptr) {
                    worker.unref();
                  }

                  onFinishedLoading(worker);
                } else if (cmd === "print") {
                  out("Thread " + d["threadId"] + ": " + d["text"]);
                } else if (cmd === "printErr") {
                  err("Thread " + d["threadId"] + ": " + d["text"]);
                } else if (cmd === "alert") {
                  alert("Thread " + d["threadId"] + ": " + d["text"]);
                } else if (d.target === "setimmediate") {
                  worker.postMessage(d);
                } else if (cmd === "callHandler") {
                  Module[d["handler"]].apply(Module, _toConsumableArray(d["args"]));
                } else if (cmd) {
                  err("worker sent an unknown command " + cmd);
                }

                PThread.currentProxiedOperationCallerThread = void 0;
              };

              worker.onerror = function (e) {
                var message = "worker sent an error!";
                err(message + " " + e.filename + ":" + e.lineno + ": " + e.message);
                throw e;
              };

              if (ENVIRONMENT_IS_NODE) {
                worker.on("message", function (data) {
                  worker.onmessage({
                    data: data
                  });
                });
                worker.on("error", function (e) {
                  worker.onerror(e);
                });
                worker.on("detachedExit", function () {});
              }

              var handlers = [];
              var knownHandlers = ["onExit", "onAbort", "print", "printErr"];

              for (var _i344 = 0, _knownHandlers = knownHandlers; _i344 < _knownHandlers.length; _i344++) {
                var handler = _knownHandlers[_i344];

                if (Module.hasOwnProperty(handler)) {
                  handlers.push(handler);
                }
              }

              worker.postMessage({
                "cmd": "load",
                "handlers": handlers,
                "urlOrBlob": Module["mainScriptUrlOrBlob"] || _scriptDir,
                "wasmMemory": wasmMemory,
                "wasmModule": wasmModule
              });
            });
          },
          loadWasmModuleToAllWorkers: function loadWasmModuleToAllWorkers(onMaybeReady) {
            if (ENVIRONMENT_IS_PTHREAD) {
              return onMaybeReady();
            }

            var pthreadPoolReady = Promise.all(PThread.unusedWorkers.map(PThread.loadWasmModuleToWorker));
            pthreadPoolReady.then(onMaybeReady);
          },
          allocateUnusedWorker: function allocateUnusedWorker() {
            var worker;
            var pthreadMainJs = locateFile("web-ifc-mt.worker.js");
            worker = new Worker(pthreadMainJs);
            PThread.unusedWorkers.push(worker);
          },
          getNewWorker: function getNewWorker() {
            if (PThread.unusedWorkers.length == 0) {
              PThread.allocateUnusedWorker();
              PThread.loadWasmModuleToWorker(PThread.unusedWorkers[0]);
            }

            return PThread.unusedWorkers.pop();
          }
        };
        Module["PThread"] = PThread;

        function callRuntimeCallbacks(callbacks) {
          while (callbacks.length > 0) {
            callbacks.shift()(Module);
          }
        }

        function establishStackSpace() {
          var pthread_ptr = _pthread_self();

          var stackTop = GROWABLE_HEAP_I32()[pthread_ptr + 52 >>> 2];
          var stackSize = GROWABLE_HEAP_I32()[pthread_ptr + 56 >>> 2];
          var stackMax = stackTop - stackSize;

          _emscripten_stack_set_limits2(stackTop, stackMax);

          _stackRestore(stackTop);
        }

        Module["establishStackSpace"] = establishStackSpace;

        function exitOnMainThread(returnCode) {
          if (ENVIRONMENT_IS_PTHREAD) return _emscripten_proxy_to_main_thread_js(2, 0, returnCode);

          try {
            _exit(returnCode);
          } catch (e) {
            handleException(e);
          }
        }

        var wasmTableMirror = [];

        function getWasmTableEntry(funcPtr) {
          var func = wasmTableMirror[funcPtr];

          if (!func) {
            if (funcPtr >= wasmTableMirror.length) wasmTableMirror.length = funcPtr + 1;
            wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
          }

          return func;
        }

        function invokeEntryPoint(ptr, arg) {
          var result = getWasmTableEntry(ptr)(arg);

          if (keepRuntimeAlive()) {
            PThread.setExitStatus(result);
          } else {
            __emscripten_thread_exit(result);
          }
        }

        Module["invokeEntryPoint"] = invokeEntryPoint;

        function registerTLSInit(tlsInitFunc) {
          PThread.tlsInitFunctions.push(tlsInitFunc);
        }

        function ExceptionInfo(excPtr) {
          this.excPtr = excPtr;
          this.ptr = excPtr - 24;

          this.set_type = function (type) {
            GROWABLE_HEAP_U32()[this.ptr + 4 >>> 2] = type;
          };

          this.get_type = function () {
            return GROWABLE_HEAP_U32()[this.ptr + 4 >>> 2];
          };

          this.set_destructor = function (destructor) {
            GROWABLE_HEAP_U32()[this.ptr + 8 >>> 2] = destructor;
          };

          this.get_destructor = function () {
            return GROWABLE_HEAP_U32()[this.ptr + 8 >>> 2];
          };

          this.set_refcount = function (refcount) {
            GROWABLE_HEAP_I32()[this.ptr >>> 2] = refcount;
          };

          this.set_caught = function (caught) {
            caught = caught ? 1 : 0;
            GROWABLE_HEAP_I8()[this.ptr + 12 >>> 0] = caught;
          };

          this.get_caught = function () {
            return GROWABLE_HEAP_I8()[this.ptr + 12 >>> 0] != 0;
          };

          this.set_rethrown = function (rethrown) {
            rethrown = rethrown ? 1 : 0;
            GROWABLE_HEAP_I8()[this.ptr + 13 >>> 0] = rethrown;
          };

          this.get_rethrown = function () {
            return GROWABLE_HEAP_I8()[this.ptr + 13 >>> 0] != 0;
          };

          this.init = function (type, destructor) {
            this.set_adjusted_ptr(0);
            this.set_type(type);
            this.set_destructor(destructor);
            this.set_refcount(0);
            this.set_caught(false);
            this.set_rethrown(false);
          };

          this.add_ref = function () {
            Atomics.add(GROWABLE_HEAP_I32(), this.ptr + 0 >> 2, 1);
          };

          this.release_ref = function () {
            var prev = Atomics.sub(GROWABLE_HEAP_I32(), this.ptr + 0 >> 2, 1);
            return prev === 1;
          };

          this.set_adjusted_ptr = function (adjustedPtr) {
            GROWABLE_HEAP_U32()[this.ptr + 16 >>> 2] = adjustedPtr;
          };

          this.get_adjusted_ptr = function () {
            return GROWABLE_HEAP_U32()[this.ptr + 16 >>> 2];
          };

          this.get_exception_ptr = function () {
            var isPointer = _cxa_is_pointer_type(this.get_type());

            if (isPointer) {
              return GROWABLE_HEAP_U32()[this.excPtr >>> 2];
            }

            var adjusted = this.get_adjusted_ptr();
            if (adjusted !== 0) return adjusted;
            return this.excPtr;
          };
        }

        function ___cxa_throw(ptr, type, destructor) {
          var info = new ExceptionInfo(ptr);
          info.init(type, destructor);
          throw ptr;
        }

        function ___emscripten_init_main_thread_js(tb) {
          __emscripten_thread_init(tb, !ENVIRONMENT_IS_WORKER, 1, !ENVIRONMENT_IS_WEB);

          PThread.threadInitTLS();
        }

        function ___emscripten_thread_cleanup(thread) {
          if (!ENVIRONMENT_IS_PTHREAD) cleanupThread(thread);else postMessage({
            "cmd": "cleanupThread",
            "thread": thread
          });
        }

        function setErrNo(value) {
          GROWABLE_HEAP_I32()[_errno_location() >>> 2] = value;
          return value;
        }

        function ___syscall_fcntl64(fd, cmd, varargs) {
          if (ENVIRONMENT_IS_PTHREAD) return _emscripten_proxy_to_main_thread_js(3, 1, fd, cmd, varargs);
          SYSCALLS.varargs = varargs;

          try {
            var stream = SYSCALLS.getStreamFromFD(fd);

            switch (cmd) {
              case 0:
                {
                  var arg = SYSCALLS.get();

                  if (arg < 0) {
                    return -28;
                  }

                  var newStream;
                  newStream = FS.createStream(stream, arg);
                  return newStream.fd;
                }

              case 1:
              case 2:
                return 0;

              case 3:
                return stream.flags;

              case 4:
                {
                  var arg = SYSCALLS.get();
                  stream.flags |= arg;
                  return 0;
                }

              case 5:
                {
                  var arg = SYSCALLS.get();
                  var offset = 0;
                  GROWABLE_HEAP_I16()[arg + offset >>> 1] = 2;
                  return 0;
                }

              case 6:
              case 7:
                return 0;

              case 16:
              case 8:
                return -28;

              case 9:
                setErrNo(28);
                return -1;

              default:
                {
                  return -28;
                }
            }
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return -e.errno;
          }
        }

        function ___syscall_ioctl(fd, op, varargs) {
          if (ENVIRONMENT_IS_PTHREAD) return _emscripten_proxy_to_main_thread_js(4, 1, fd, op, varargs);
          SYSCALLS.varargs = varargs;

          try {
            var stream = SYSCALLS.getStreamFromFD(fd);

            switch (op) {
              case 21509:
              case 21505:
                {
                  if (!stream.tty) return -59;
                  return 0;
                }

              case 21510:
              case 21511:
              case 21512:
              case 21506:
              case 21507:
              case 21508:
                {
                  if (!stream.tty) return -59;
                  return 0;
                }

              case 21519:
                {
                  if (!stream.tty) return -59;
                  var argp = SYSCALLS.get();
                  GROWABLE_HEAP_I32()[argp >>> 2] = 0;
                  return 0;
                }

              case 21520:
                {
                  if (!stream.tty) return -59;
                  return -28;
                }

              case 21531:
                {
                  var argp = SYSCALLS.get();
                  return FS.ioctl(stream, op, argp);
                }

              case 21523:
                {
                  if (!stream.tty) return -59;
                  return 0;
                }

              case 21524:
                {
                  if (!stream.tty) return -59;
                  return 0;
                }

              default:
                return -28;
            }
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return -e.errno;
          }
        }

        function ___syscall_openat(dirfd, path, flags, varargs) {
          if (ENVIRONMENT_IS_PTHREAD) return _emscripten_proxy_to_main_thread_js(5, 1, dirfd, path, flags, varargs);
          SYSCALLS.varargs = varargs;

          try {
            path = SYSCALLS.getStr(path);
            path = SYSCALLS.calculateAt(dirfd, path);
            var mode = varargs ? SYSCALLS.get() : 0;
            return FS.open(path, flags, mode).fd;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return -e.errno;
          }
        }

        function __dlinit(main_dso_handle) {}

        var dlopenMissingError = "To use dlopen, you need enable dynamic linking, see https://github.com/emscripten-core/emscripten/wiki/Linking";

        function __dlopen_js(handle) {
          abort(dlopenMissingError);
        }

        function __dlsym_catchup_js(handle, symbolIndex) {
          abort(dlopenMissingError);
        }

        var tupleRegistrations = {};

        function runDestructors(destructors) {
          while (destructors.length) {
            var ptr = destructors.pop();
            var del = destructors.pop();
            del(ptr);
          }
        }

        function simpleReadValueFromPointer(pointer) {
          return this["fromWireType"](GROWABLE_HEAP_I32()[pointer >>> 2]);
        }

        var awaitingDependencies = {};
        var registeredTypes = {};
        var typeDependencies = {};
        var char_0 = 48;
        var char_9 = 57;

        function makeLegalFunctionName(name) {
          if (name === void 0) {
            return "_unknown";
          }

          name = name.replace(/[^a-zA-Z0-9_]/g, "$");
          var f = name.charCodeAt(0);

          if (f >= char_0 && f <= char_9) {
            return "_" + name;
          }

          return name;
        }

        function createNamedFunction(name, body) {
          name = makeLegalFunctionName(name);
          return new Function("body", "return function " + name + '() {\n    "use strict";    return body.apply(this, arguments);\n};\n')(body);
        }

        function extendError(baseErrorType, errorName) {
          var errorClass = createNamedFunction(errorName, function (message) {
            this.name = errorName;
            this.message = message;
            var stack = new Error(message).stack;

            if (stack !== void 0) {
              this.stack = this.toString() + "\n" + stack.replace(/^Error(:[^\n]*)?\n/, "");
            }
          });
          errorClass.prototype = Object.create(baseErrorType.prototype);
          errorClass.prototype.constructor = errorClass;

          errorClass.prototype.toString = function () {
            if (this.message === void 0) {
              return this.name;
            } else {
              return this.name + ": " + this.message;
            }
          };

          return errorClass;
        }

        var InternalError = void 0;

        function throwInternalError(message) {
          throw new InternalError(message);
        }

        function whenDependentTypesAreResolved(myTypes, dependentTypes, getTypeConverters) {
          myTypes.forEach(function (type) {
            typeDependencies[type] = dependentTypes;
          });

          function onComplete(typeConverters2) {
            var myTypeConverters = getTypeConverters(typeConverters2);

            if (myTypeConverters.length !== myTypes.length) {
              throwInternalError("Mismatched type converter count");
            }

            for (var i = 0; i < myTypes.length; ++i) {
              registerType(myTypes[i], myTypeConverters[i]);
            }
          }

          var typeConverters = new Array(dependentTypes.length);
          var unregisteredTypes = [];
          var registered = 0;
          dependentTypes.forEach(function (dt, i) {
            if (registeredTypes.hasOwnProperty(dt)) {
              typeConverters[i] = registeredTypes[dt];
            } else {
              unregisteredTypes.push(dt);

              if (!awaitingDependencies.hasOwnProperty(dt)) {
                awaitingDependencies[dt] = [];
              }

              awaitingDependencies[dt].push(function () {
                typeConverters[i] = registeredTypes[dt];
                ++registered;

                if (registered === unregisteredTypes.length) {
                  onComplete(typeConverters);
                }
              });
            }
          });

          if (unregisteredTypes.length === 0) {
            onComplete(typeConverters);
          }
        }

        function __embind_finalize_value_array(rawTupleType) {
          var reg = tupleRegistrations[rawTupleType];
          delete tupleRegistrations[rawTupleType];
          var elements = reg.elements;
          var elementsLength = elements.length;
          var elementTypes = elements.map(function (elt) {
            return elt.getterReturnType;
          }).concat(elements.map(function (elt) {
            return elt.setterArgumentType;
          }));
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          whenDependentTypesAreResolved([rawTupleType], elementTypes, function (elementTypes2) {
            elements.forEach(function (elt, i) {
              var getterReturnType = elementTypes2[i];
              var getter = elt.getter;
              var getterContext = elt.getterContext;
              var setterArgumentType = elementTypes2[i + elementsLength];
              var setter = elt.setter;
              var setterContext = elt.setterContext;

              elt.read = function (ptr) {
                return getterReturnType["fromWireType"](getter(getterContext, ptr));
              };

              elt.write = function (ptr, o) {
                var destructors = [];
                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                runDestructors(destructors);
              };
            });
            return [{
              name: reg.name,
              "fromWireType": function fromWireType(ptr) {
                var rv = new Array(elementsLength);

                for (var i = 0; i < elementsLength; ++i) {
                  rv[i] = elements[i].read(ptr);
                }

                rawDestructor(ptr);
                return rv;
              },
              "toWireType": function toWireType(destructors, o) {
                if (elementsLength !== o.length) {
                  throw new TypeError("Incorrect number of tuple elements for " + reg.name + ": expected=" + elementsLength + ", actual=" + o.length);
                }

                var ptr = rawConstructor();

                for (var i = 0; i < elementsLength; ++i) {
                  elements[i].write(ptr, o[i]);
                }

                if (destructors !== null) {
                  destructors.push(rawDestructor, ptr);
                }

                return ptr;
              },
              "argPackAdvance": 8,
              "readValueFromPointer": simpleReadValueFromPointer,
              destructorFunction: rawDestructor
            }];
          });
        }

        var structRegistrations = {};

        function __embind_finalize_value_object(structType) {
          var reg = structRegistrations[structType];
          delete structRegistrations[structType];
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          var fieldRecords = reg.fields;
          var fieldTypes = fieldRecords.map(function (field) {
            return field.getterReturnType;
          }).concat(fieldRecords.map(function (field) {
            return field.setterArgumentType;
          }));
          whenDependentTypesAreResolved([structType], fieldTypes, function (fieldTypes2) {
            var fields = {};
            fieldRecords.forEach(function (field, i) {
              var fieldName = field.fieldName;
              var getterReturnType = fieldTypes2[i];
              var getter = field.getter;
              var getterContext = field.getterContext;
              var setterArgumentType = fieldTypes2[i + fieldRecords.length];
              var setter = field.setter;
              var setterContext = field.setterContext;
              fields[fieldName] = {
                read: function read(ptr) {
                  return getterReturnType["fromWireType"](getter(getterContext, ptr));
                },
                write: function write(ptr, o) {
                  var destructors = [];
                  setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                  runDestructors(destructors);
                }
              };
            });
            return [{
              name: reg.name,
              "fromWireType": function fromWireType(ptr) {
                var rv = {};

                for (var i in fields) {
                  rv[i] = fields[i].read(ptr);
                }

                rawDestructor(ptr);
                return rv;
              },
              "toWireType": function toWireType(destructors, o) {
                for (var fieldName in fields) {
                  if (!(fieldName in o)) {
                    throw new TypeError('Missing field:  "' + fieldName + '"');
                  }
                }

                var ptr = rawConstructor();

                for (fieldName in fields) {
                  fields[fieldName].write(ptr, o[fieldName]);
                }

                if (destructors !== null) {
                  destructors.push(rawDestructor, ptr);
                }

                return ptr;
              },
              "argPackAdvance": 8,
              "readValueFromPointer": simpleReadValueFromPointer,
              destructorFunction: rawDestructor
            }];
          });
        }

        function __embind_register_bigint(primitiveType, name, size, minRange, maxRange) {}

        function getShiftFromSize(size) {
          switch (size) {
            case 1:
              return 0;

            case 2:
              return 1;

            case 4:
              return 2;

            case 8:
              return 3;

            default:
              throw new TypeError("Unknown type size: " + size);
          }
        }

        function embind_init_charCodes() {
          var codes = new Array(256);

          for (var i = 0; i < 256; ++i) {
            codes[i] = String.fromCharCode(i);
          }

          embind_charCodes = codes;
        }

        var embind_charCodes = void 0;

        function readLatin1String(ptr) {
          var ret = "";
          var c = ptr;

          while (GROWABLE_HEAP_U8()[c >>> 0]) {
            ret += embind_charCodes[GROWABLE_HEAP_U8()[c++ >>> 0]];
          }

          return ret;
        }

        var BindingError = void 0;

        function throwBindingError(message) {
          throw new BindingError(message);
        }

        function registerType(rawType, registeredInstance) {
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          if (!("argPackAdvance" in registeredInstance)) {
            throw new TypeError("registerType registeredInstance requires argPackAdvance");
          }

          var name = registeredInstance.name;

          if (!rawType) {
            throwBindingError('type "' + name + '" must have a positive integer typeid pointer');
          }

          if (registeredTypes.hasOwnProperty(rawType)) {
            if (options.ignoreDuplicateRegistrations) {
              return;
            } else {
              throwBindingError("Cannot register type '" + name + "' twice");
            }
          }

          registeredTypes[rawType] = registeredInstance;
          delete typeDependencies[rawType];

          if (awaitingDependencies.hasOwnProperty(rawType)) {
            var callbacks = awaitingDependencies[rawType];
            delete awaitingDependencies[rawType];
            callbacks.forEach(function (cb) {
              return cb();
            });
          }
        }

        function __embind_register_bool(rawType, name, size, trueValue, falseValue) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, {
            name: name,
            "fromWireType": function fromWireType(wt) {
              return !!wt;
            },
            "toWireType": function toWireType(destructors, o) {
              return o ? trueValue : falseValue;
            },
            "argPackAdvance": 8,
            "readValueFromPointer": function readValueFromPointer(pointer) {
              var heap;

              if (size === 1) {
                heap = GROWABLE_HEAP_I8();
              } else if (size === 2) {
                heap = GROWABLE_HEAP_I16();
              } else if (size === 4) {
                heap = GROWABLE_HEAP_I32();
              } else {
                throw new TypeError("Unknown boolean type size: " + name);
              }

              return this["fromWireType"](heap[pointer >>> shift]);
            },
            destructorFunction: null
          });
        }

        function ClassHandle_isAliasOf(other) {
          if (!(this instanceof ClassHandle)) {
            return false;
          }

          if (!(other instanceof ClassHandle)) {
            return false;
          }

          var leftClass = this.$$.ptrType.registeredClass;
          var left = this.$$.ptr;
          var rightClass = other.$$.ptrType.registeredClass;
          var right = other.$$.ptr;

          while (leftClass.baseClass) {
            left = leftClass.upcast(left);
            leftClass = leftClass.baseClass;
          }

          while (rightClass.baseClass) {
            right = rightClass.upcast(right);
            rightClass = rightClass.baseClass;
          }

          return leftClass === rightClass && left === right;
        }

        function shallowCopyInternalPointer(o) {
          return {
            count: o.count,
            deleteScheduled: o.deleteScheduled,
            preservePointerOnDelete: o.preservePointerOnDelete,
            ptr: o.ptr,
            ptrType: o.ptrType,
            smartPtr: o.smartPtr,
            smartPtrType: o.smartPtrType
          };
        }

        function throwInstanceAlreadyDeleted(obj) {
          function getInstanceTypeName(handle) {
            return handle.$$.ptrType.registeredClass.name;
          }

          throwBindingError(getInstanceTypeName(obj) + " instance already deleted");
        }

        var finalizationRegistry = false;

        function detachFinalizer(handle) {}

        function runDestructor($$) {
          if ($$.smartPtr) {
            $$.smartPtrType.rawDestructor($$.smartPtr);
          } else {
            $$.ptrType.registeredClass.rawDestructor($$.ptr);
          }
        }

        function releaseClassHandle($$) {
          $$.count.value -= 1;
          var toDelete = $$.count.value === 0;

          if (toDelete) {
            runDestructor($$);
          }
        }

        function downcastPointer(ptr, ptrClass, desiredClass) {
          if (ptrClass === desiredClass) {
            return ptr;
          }

          if (desiredClass.baseClass === void 0) {
            return null;
          }

          var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass);

          if (rv === null) {
            return null;
          }

          return desiredClass.downcast(rv);
        }

        var registeredPointers = {};

        function getInheritedInstanceCount() {
          return Object.keys(registeredInstances).length;
        }

        function getLiveInheritedInstances() {
          var rv = [];

          for (var k in registeredInstances) {
            if (registeredInstances.hasOwnProperty(k)) {
              rv.push(registeredInstances[k]);
            }
          }

          return rv;
        }

        var deletionQueue = [];

        function flushPendingDeletes() {
          while (deletionQueue.length) {
            var obj = deletionQueue.pop();
            obj.$$.deleteScheduled = false;
            obj["delete"]();
          }
        }

        var delayFunction = void 0;

        function setDelayFunction(fn) {
          delayFunction = fn;

          if (deletionQueue.length && delayFunction) {
            delayFunction(flushPendingDeletes);
          }
        }

        function init_embind() {
          Module["getInheritedInstanceCount"] = getInheritedInstanceCount;
          Module["getLiveInheritedInstances"] = getLiveInheritedInstances;
          Module["flushPendingDeletes"] = flushPendingDeletes;
          Module["setDelayFunction"] = setDelayFunction;
        }

        var registeredInstances = {};

        function getBasestPointer(class_, ptr) {
          if (ptr === void 0) {
            throwBindingError("ptr should not be undefined");
          }

          while (class_.baseClass) {
            ptr = class_.upcast(ptr);
            class_ = class_.baseClass;
          }

          return ptr;
        }

        function getInheritedInstance(class_, ptr) {
          ptr = getBasestPointer(class_, ptr);
          return registeredInstances[ptr];
        }

        function makeClassHandle(prototype, record) {
          if (!record.ptrType || !record.ptr) {
            throwInternalError("makeClassHandle requires ptr and ptrType");
          }

          var hasSmartPtrType = !!record.smartPtrType;
          var hasSmartPtr = !!record.smartPtr;

          if (hasSmartPtrType !== hasSmartPtr) {
            throwInternalError("Both smartPtrType and smartPtr must be specified");
          }

          record.count = {
            value: 1
          };
          return attachFinalizer(Object.create(prototype, {
            $$: {
              value: record
            }
          }));
        }

        function RegisteredPointer_fromWireType(ptr) {
          var rawPointer = this.getPointee(ptr);

          if (!rawPointer) {
            this.destructor(ptr);
            return null;
          }

          var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer);

          if (registeredInstance !== void 0) {
            if (registeredInstance.$$.count.value === 0) {
              registeredInstance.$$.ptr = rawPointer;
              registeredInstance.$$.smartPtr = ptr;
              return registeredInstance["clone"]();
            } else {
              var rv = registeredInstance["clone"]();
              this.destructor(ptr);
              return rv;
            }
          }

          function makeDefaultHandle() {
            if (this.isSmartPointer) {
              return makeClassHandle(this.registeredClass.instancePrototype, {
                ptrType: this.pointeeType,
                ptr: rawPointer,
                smartPtrType: this,
                smartPtr: ptr
              });
            } else {
              return makeClassHandle(this.registeredClass.instancePrototype, {
                ptrType: this,
                ptr: ptr
              });
            }
          }

          var actualType = this.registeredClass.getActualType(rawPointer);
          var registeredPointerRecord = registeredPointers[actualType];

          if (!registeredPointerRecord) {
            return makeDefaultHandle.call(this);
          }

          var toType;

          if (this.isConst) {
            toType = registeredPointerRecord.constPointerType;
          } else {
            toType = registeredPointerRecord.pointerType;
          }

          var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);

          if (dp === null) {
            return makeDefaultHandle.call(this);
          }

          if (this.isSmartPointer) {
            return makeClassHandle(toType.registeredClass.instancePrototype, {
              ptrType: toType,
              ptr: dp,
              smartPtrType: this,
              smartPtr: ptr
            });
          } else {
            return makeClassHandle(toType.registeredClass.instancePrototype, {
              ptrType: toType,
              ptr: dp
            });
          }
        }

        function attachFinalizer(handle) {
          if (typeof FinalizationRegistry === "undefined") {
            attachFinalizer = function attachFinalizer(handle2) {
              return handle2;
            };

            return handle;
          }

          finalizationRegistry = new FinalizationRegistry(function (info) {
            releaseClassHandle(info.$$);
          });

          attachFinalizer = function attachFinalizer(handle2) {
            var $$ = handle2.$$;
            var hasSmartPtr = !!$$.smartPtr;

            if (hasSmartPtr) {
              var info = {
                $$: $$
              };
              finalizationRegistry.register(handle2, info, handle2);
            }

            return handle2;
          };

          detachFinalizer = function detachFinalizer(handle2) {
            return finalizationRegistry.unregister(handle2);
          };

          return attachFinalizer(handle);
        }

        function ClassHandle_clone() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }

          if (this.$$.preservePointerOnDelete) {
            this.$$.count.value += 1;
            return this;
          } else {
            var clone = attachFinalizer(Object.create(Object.getPrototypeOf(this), {
              $$: {
                value: shallowCopyInternalPointer(this.$$)
              }
            }));
            clone.$$.count.value += 1;
            clone.$$.deleteScheduled = false;
            return clone;
          }
        }

        function ClassHandle_delete() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }

          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }

          detachFinalizer(this);
          releaseClassHandle(this.$$);

          if (!this.$$.preservePointerOnDelete) {
            this.$$.smartPtr = void 0;
            this.$$.ptr = void 0;
          }
        }

        function ClassHandle_isDeleted() {
          return !this.$$.ptr;
        }

        function ClassHandle_deleteLater() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }

          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }

          deletionQueue.push(this);

          if (deletionQueue.length === 1 && delayFunction) {
            delayFunction(flushPendingDeletes);
          }

          this.$$.deleteScheduled = true;
          return this;
        }

        function init_ClassHandle() {
          ClassHandle.prototype["isAliasOf"] = ClassHandle_isAliasOf;
          ClassHandle.prototype["clone"] = ClassHandle_clone;
          ClassHandle.prototype["delete"] = ClassHandle_delete;
          ClassHandle.prototype["isDeleted"] = ClassHandle_isDeleted;
          ClassHandle.prototype["deleteLater"] = ClassHandle_deleteLater;
        }

        function ClassHandle() {}

        function ensureOverloadTable(proto, methodName, humanName) {
          if (proto[methodName].overloadTable === void 0) {
            var prevFunc = proto[methodName];

            proto[methodName] = function () {
              if (!proto[methodName].overloadTable.hasOwnProperty(arguments.length)) {
                throwBindingError("Function '" + humanName + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + proto[methodName].overloadTable + ")!");
              }

              return proto[methodName].overloadTable[arguments.length].apply(this, arguments);
            };

            proto[methodName].overloadTable = [];
            proto[methodName].overloadTable[prevFunc.argCount] = prevFunc;
          }
        }

        function exposePublicSymbol(name, value, numArguments) {
          if (Module.hasOwnProperty(name)) {
            if (numArguments === void 0 || Module[name].overloadTable !== void 0 && Module[name].overloadTable[numArguments] !== void 0) {
              throwBindingError("Cannot register public name '" + name + "' twice");
            }

            ensureOverloadTable(Module, name, name);

            if (Module.hasOwnProperty(numArguments)) {
              throwBindingError("Cannot register multiple overloads of a function with the same number of arguments (" + numArguments + ")!");
            }

            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;

            if (numArguments !== void 0) {
              Module[name].numArguments = numArguments;
            }
          }
        }

        function RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
          this.name = name;
          this.constructor = constructor;
          this.instancePrototype = instancePrototype;
          this.rawDestructor = rawDestructor;
          this.baseClass = baseClass;
          this.getActualType = getActualType;
          this.upcast = upcast;
          this.downcast = downcast;
          this.pureVirtualFunctions = [];
        }

        function upcastPointer(ptr, ptrClass, desiredClass) {
          while (ptrClass !== desiredClass) {
            if (!ptrClass.upcast) {
              throwBindingError("Expected null or instance of " + desiredClass.name + ", got an instance of " + ptrClass.name);
            }

            ptr = ptrClass.upcast(ptr);
            ptrClass = ptrClass.baseClass;
          }

          return ptr;
        }

        function constNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }

            return 0;
          }

          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }

          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }

          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }

        function genericPointerToWireType(destructors, handle) {
          var ptr;

          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }

            if (this.isSmartPointer) {
              ptr = this.rawConstructor();

              if (destructors !== null) {
                destructors.push(this.rawDestructor, ptr);
              }

              return ptr;
            } else {
              return 0;
            }
          }

          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }

          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }

          if (!this.isConst && handle.$$.ptrType.isConst) {
            throwBindingError("Cannot convert argument of type " + (handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name) + " to parameter type " + this.name);
          }

          var handleClass = handle.$$.ptrType.registeredClass;
          ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);

          if (this.isSmartPointer) {
            if (handle.$$.smartPtr === void 0) {
              throwBindingError("Passing raw pointer to smart pointer is illegal");
            }

            switch (this.sharingPolicy) {
              case 0:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  throwBindingError("Cannot convert argument of type " + (handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name) + " to parameter type " + this.name);
                }

                break;

              case 1:
                ptr = handle.$$.smartPtr;
                break;

              case 2:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  var clonedHandle = handle["clone"]();
                  ptr = this.rawShare(ptr, Emval.toHandle(function () {
                    clonedHandle["delete"]();
                  }));

                  if (destructors !== null) {
                    destructors.push(this.rawDestructor, ptr);
                  }
                }

                break;

              default:
                throwBindingError("Unsupporting sharing policy");
            }
          }

          return ptr;
        }

        function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }

            return 0;
          }

          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }

          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }

          if (handle.$$.ptrType.isConst) {
            throwBindingError("Cannot convert argument of type " + handle.$$.ptrType.name + " to parameter type " + this.name);
          }

          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }

        function RegisteredPointer_getPointee(ptr) {
          if (this.rawGetPointee) {
            ptr = this.rawGetPointee(ptr);
          }

          return ptr;
        }

        function RegisteredPointer_destructor(ptr) {
          if (this.rawDestructor) {
            this.rawDestructor(ptr);
          }
        }

        function RegisteredPointer_deleteObject(handle) {
          if (handle !== null) {
            handle["delete"]();
          }
        }

        function init_RegisteredPointer() {
          RegisteredPointer.prototype.getPointee = RegisteredPointer_getPointee;
          RegisteredPointer.prototype.destructor = RegisteredPointer_destructor;
          RegisteredPointer.prototype["argPackAdvance"] = 8;
          RegisteredPointer.prototype["readValueFromPointer"] = simpleReadValueFromPointer;
          RegisteredPointer.prototype["deleteObject"] = RegisteredPointer_deleteObject;
          RegisteredPointer.prototype["fromWireType"] = RegisteredPointer_fromWireType;
        }

        function RegisteredPointer(name, registeredClass, isReference, isConst, isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
          this.name = name;
          this.registeredClass = registeredClass;
          this.isReference = isReference;
          this.isConst = isConst;
          this.isSmartPointer = isSmartPointer;
          this.pointeeType = pointeeType;
          this.sharingPolicy = sharingPolicy;
          this.rawGetPointee = rawGetPointee;
          this.rawConstructor = rawConstructor;
          this.rawShare = rawShare;
          this.rawDestructor = rawDestructor;

          if (!isSmartPointer && registeredClass.baseClass === void 0) {
            if (isConst) {
              this["toWireType"] = constNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            } else {
              this["toWireType"] = nonConstNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            }
          } else {
            this["toWireType"] = genericPointerToWireType;
          }
        }

        function replacePublicSymbol(name, value, numArguments) {
          if (!Module.hasOwnProperty(name)) {
            throwInternalError("Replacing nonexistant public symbol");
          }

          if (Module[name].overloadTable !== void 0 && numArguments !== void 0) {
            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;
            Module[name].argCount = numArguments;
          }
        }

        function dynCallLegacy(sig, ptr, args) {
          var f = Module["dynCall_" + sig];
          return args && args.length ? f.apply(null, [ptr].concat(args)) : f.call(null, ptr);
        }

        function dynCall(sig, ptr, args) {
          if (sig.includes("j")) {
            return dynCallLegacy(sig, ptr, args);
          }

          var rtn = getWasmTableEntry(ptr).apply(null, args);
          return rtn;
        }

        function getDynCaller(sig, ptr) {
          var argCache = [];
          return function () {
            argCache.length = 0;
            Object.assign(argCache, arguments);
            return dynCall(sig, ptr, argCache);
          };
        }

        function embind__requireFunction(signature, rawFunction) {
          signature = readLatin1String(signature);

          function makeDynCaller() {
            if (signature.includes("j")) {
              return getDynCaller(signature, rawFunction);
            }

            return getWasmTableEntry(rawFunction);
          }

          var fp = makeDynCaller();

          if (typeof fp != "function") {
            throwBindingError("unknown function pointer with signature " + signature + ": " + rawFunction);
          }

          return fp;
        }

        var UnboundTypeError = void 0;

        function getTypeName(type) {
          var ptr = ___getTypeName(type);

          var rv = readLatin1String(ptr);

          _free2(ptr);

          return rv;
        }

        function throwUnboundTypeError(message, types) {
          var unboundTypes = [];
          var seen = {};

          function visit(type) {
            if (seen[type]) {
              return;
            }

            if (registeredTypes[type]) {
              return;
            }

            if (typeDependencies[type]) {
              typeDependencies[type].forEach(visit);
              return;
            }

            unboundTypes.push(type);
            seen[type] = true;
          }

          types.forEach(visit);
          throw new UnboundTypeError(message + ": " + unboundTypes.map(getTypeName).join([", "]));
        }

        function __embind_register_class(rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor) {
          name = readLatin1String(name);
          getActualType = embind__requireFunction(getActualTypeSignature, getActualType);

          if (upcast) {
            upcast = embind__requireFunction(upcastSignature, upcast);
          }

          if (downcast) {
            downcast = embind__requireFunction(downcastSignature, downcast);
          }

          rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
          var legalFunctionName = makeLegalFunctionName(name);
          exposePublicSymbol(legalFunctionName, function () {
            throwUnboundTypeError("Cannot construct " + name + " due to unbound types", [baseClassRawType]);
          });
          whenDependentTypesAreResolved([rawType, rawPointerType, rawConstPointerType], baseClassRawType ? [baseClassRawType] : [], function (base) {
            base = base[0];
            var baseClass;
            var basePrototype;

            if (baseClassRawType) {
              baseClass = base.registeredClass;
              basePrototype = baseClass.instancePrototype;
            } else {
              basePrototype = ClassHandle.prototype;
            }

            var constructor = createNamedFunction(legalFunctionName, function () {
              if (Object.getPrototypeOf(this) !== instancePrototype) {
                throw new BindingError("Use 'new' to construct " + name);
              }

              if (registeredClass.constructor_body === void 0) {
                throw new BindingError(name + " has no accessible constructor");
              }

              var body = registeredClass.constructor_body[arguments.length];

              if (body === void 0) {
                throw new BindingError("Tried to invoke ctor of " + name + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(registeredClass.constructor_body).toString() + ") parameters instead!");
              }

              return body.apply(this, arguments);
            });
            var instancePrototype = Object.create(basePrototype, {
              constructor: {
                value: constructor
              }
            });
            constructor.prototype = instancePrototype;
            var registeredClass = new RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
            var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false);
            var pointerConverter = new RegisteredPointer(name + "*", registeredClass, false, false, false);
            var constPointerConverter = new RegisteredPointer(name + " const*", registeredClass, false, true, false);
            registeredPointers[rawType] = {
              pointerType: pointerConverter,
              constPointerType: constPointerConverter
            };
            replacePublicSymbol(legalFunctionName, constructor);
            return [referenceConverter, pointerConverter, constPointerConverter];
          });
        }

        function heap32VectorToArray(count, firstElement) {
          var array = [];

          for (var i = 0; i < count; i++) {
            array.push(GROWABLE_HEAP_U32()[firstElement + i * 4 >>> 2]);
          }

          return array;
        }

        function new_(constructor, argumentList) {
          if (!(constructor instanceof Function)) {
            throw new TypeError("new_ called with constructor type " + typeof constructor + " which is not a function");
          }

          var dummy = createNamedFunction(constructor.name || "unknownFunctionName", function () {});
          dummy.prototype = constructor.prototype;
          var obj = new dummy();
          var r = constructor.apply(obj, argumentList);
          return r instanceof Object ? r : obj;
        }

        function craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc) {
          var argCount = argTypes.length;

          if (argCount < 2) {
            throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");
          }

          var isClassMethodFunc = argTypes[1] !== null && classType !== null;
          var needsDestructorStack = false;

          for (var i = 1; i < argTypes.length; ++i) {
            if (argTypes[i] !== null && argTypes[i].destructorFunction === void 0) {
              needsDestructorStack = true;
              break;
            }
          }

          var returns = argTypes[0].name !== "void";
          var argsList = "";
          var argsListWired = "";

          for (var i = 0; i < argCount - 2; ++i) {
            argsList += (i !== 0 ? ", " : "") + "arg" + i;
            argsListWired += (i !== 0 ? ", " : "") + "arg" + i + "Wired";
          }

          var invokerFnBody = "return function " + makeLegalFunctionName(humanName) + "(" + argsList + ") {\nif (arguments.length !== " + (argCount - 2) + ") {\nthrowBindingError('function " + humanName + " called with ' + arguments.length + ' arguments, expected " + (argCount - 2) + " args!');\n}\n";

          if (needsDestructorStack) {
            invokerFnBody += "var destructors = [];\n";
          }

          var dtorStack = needsDestructorStack ? "destructors" : "null";
          var args1 = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"];
          var args2 = [throwBindingError, cppInvokerFunc, cppTargetFunc, runDestructors, argTypes[0], argTypes[1]];

          if (isClassMethodFunc) {
            invokerFnBody += "var thisWired = classParam.toWireType(" + dtorStack + ", this);\n";
          }

          for (var i = 0; i < argCount - 2; ++i) {
            invokerFnBody += "var arg" + i + "Wired = argType" + i + ".toWireType(" + dtorStack + ", arg" + i + "); // " + argTypes[i + 2].name + "\n";
            args1.push("argType" + i);
            args2.push(argTypes[i + 2]);
          }

          if (isClassMethodFunc) {
            argsListWired = "thisWired" + (argsListWired.length > 0 ? ", " : "") + argsListWired;
          }

          invokerFnBody += (returns ? "var rv = " : "") + "invoker(fn" + (argsListWired.length > 0 ? ", " : "") + argsListWired + ");\n";

          if (needsDestructorStack) {
            invokerFnBody += "runDestructors(destructors);\n";
          } else {
            for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i) {
              var paramName = i === 1 ? "thisWired" : "arg" + (i - 2) + "Wired";

              if (argTypes[i].destructorFunction !== null) {
                invokerFnBody += paramName + "_dtor(" + paramName + "); // " + argTypes[i].name + "\n";
                args1.push(paramName + "_dtor");
                args2.push(argTypes[i].destructorFunction);
              }
            }
          }

          if (returns) {
            invokerFnBody += "var ret = retType.fromWireType(rv);\nreturn ret;\n";
          }

          invokerFnBody += "}\n";
          args1.push(invokerFnBody);
          var invokerFunction = new_(Function, args1).apply(null, args2);
          return invokerFunction;
        }

        function __embind_register_class_constructor(rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor) {
          assert(argCount > 0);
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          invoker = embind__requireFunction(invokerSignature, invoker);
          whenDependentTypesAreResolved([], [rawClassType], function (classType) {
            classType = classType[0];
            var humanName = "constructor " + classType.name;

            if (classType.registeredClass.constructor_body === void 0) {
              classType.registeredClass.constructor_body = [];
            }

            if (classType.registeredClass.constructor_body[argCount - 1] !== void 0) {
              throw new BindingError("Cannot register multiple constructors with identical number of parameters (" + (argCount - 1) + ") for class '" + classType.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
            }

            classType.registeredClass.constructor_body[argCount - 1] = function () {
              throwUnboundTypeError("Cannot construct " + classType.name + " due to unbound types", rawArgTypes);
            };

            whenDependentTypesAreResolved([], rawArgTypes, function (argTypes) {
              argTypes.splice(1, 0, null);
              classType.registeredClass.constructor_body[argCount - 1] = craftInvokerFunction(humanName, argTypes, null, invoker, rawConstructor);
              return [];
            });
            return [];
          });
        }

        function __embind_register_class_function(rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, context, isPureVirtual) {
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          methodName = readLatin1String(methodName);
          rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
          whenDependentTypesAreResolved([], [rawClassType], function (classType) {
            classType = classType[0];
            var humanName = classType.name + "." + methodName;

            if (methodName.startsWith("@@")) {
              methodName = Symbol[methodName.substring(2)];
            }

            if (isPureVirtual) {
              classType.registeredClass.pureVirtualFunctions.push(methodName);
            }

            function unboundTypesHandler() {
              throwUnboundTypeError("Cannot call " + humanName + " due to unbound types", rawArgTypes);
            }

            var proto = classType.registeredClass.instancePrototype;
            var method = proto[methodName];

            if (method === void 0 || method.overloadTable === void 0 && method.className !== classType.name && method.argCount === argCount - 2) {
              unboundTypesHandler.argCount = argCount - 2;
              unboundTypesHandler.className = classType.name;
              proto[methodName] = unboundTypesHandler;
            } else {
              ensureOverloadTable(proto, methodName, humanName);
              proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler;
            }

            whenDependentTypesAreResolved([], rawArgTypes, function (argTypes) {
              var memberFunction = craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context);

              if (proto[methodName].overloadTable === void 0) {
                memberFunction.argCount = argCount - 2;
                proto[methodName] = memberFunction;
              } else {
                proto[methodName].overloadTable[argCount - 2] = memberFunction;
              }

              return [];
            });
            return [];
          });
        }

        var emval_free_list = [];
        var emval_handle_array = [{}, {
          value: void 0
        }, {
          value: null
        }, {
          value: true
        }, {
          value: false
        }];

        function __emval_decref(handle) {
          if (handle > 4 && --emval_handle_array[handle].refcount === 0) {
            emval_handle_array[handle] = void 0;
            emval_free_list.push(handle);
          }
        }

        function count_emval_handles() {
          var count = 0;

          for (var i = 5; i < emval_handle_array.length; ++i) {
            if (emval_handle_array[i] !== void 0) {
              ++count;
            }
          }

          return count;
        }

        function get_first_emval() {
          for (var i = 5; i < emval_handle_array.length; ++i) {
            if (emval_handle_array[i] !== void 0) {
              return emval_handle_array[i];
            }
          }

          return null;
        }

        function init_emval() {
          Module["count_emval_handles"] = count_emval_handles;
          Module["get_first_emval"] = get_first_emval;
        }

        var Emval = {
          toValue: function toValue(handle) {
            if (!handle) {
              throwBindingError("Cannot use deleted val. handle = " + handle);
            }

            return emval_handle_array[handle].value;
          },
          toHandle: function toHandle(value) {
            switch (value) {
              case void 0:
                return 1;

              case null:
                return 2;

              case true:
                return 3;

              case false:
                return 4;

              default:
                {
                  var handle = emval_free_list.length ? emval_free_list.pop() : emval_handle_array.length;
                  emval_handle_array[handle] = {
                    refcount: 1,
                    value: value
                  };
                  return handle;
                }
            }
          }
        };

        function __embind_register_emval(rawType, name) {
          name = readLatin1String(name);
          registerType(rawType, {
            name: name,
            "fromWireType": function fromWireType(handle) {
              var rv = Emval.toValue(handle);

              __emval_decref(handle);

              return rv;
            },
            "toWireType": function toWireType(destructors, value) {
              return Emval.toHandle(value);
            },
            "argPackAdvance": 8,
            "readValueFromPointer": simpleReadValueFromPointer,
            destructorFunction: null
          });
        }

        function enumReadValueFromPointer(name, shift, signed) {
          switch (shift) {
            case 0:
              return function (pointer) {
                var heap = signed ? GROWABLE_HEAP_I8() : GROWABLE_HEAP_U8();
                return this["fromWireType"](heap[pointer >>> 0]);
              };

            case 1:
              return function (pointer) {
                var heap = signed ? GROWABLE_HEAP_I16() : GROWABLE_HEAP_U16();
                return this["fromWireType"](heap[pointer >>> 1]);
              };

            case 2:
              return function (pointer) {
                var heap = signed ? GROWABLE_HEAP_I32() : GROWABLE_HEAP_U32();
                return this["fromWireType"](heap[pointer >>> 2]);
              };

            default:
              throw new TypeError("Unknown integer type: " + name);
          }
        }

        function __embind_register_enum(rawType, name, size, isSigned) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);

          function ctor() {}

          ctor.values = {};
          registerType(rawType, {
            name: name,
            constructor: ctor,
            "fromWireType": function fromWireType(c) {
              return this.constructor.values[c];
            },
            "toWireType": function toWireType(destructors, c) {
              return c.value;
            },
            "argPackAdvance": 8,
            "readValueFromPointer": enumReadValueFromPointer(name, shift, isSigned),
            destructorFunction: null
          });
          exposePublicSymbol(name, ctor);
        }

        function requireRegisteredType(rawType, humanName) {
          var impl = registeredTypes[rawType];

          if (impl === void 0) {
            throwBindingError(humanName + " has unknown type " + getTypeName(rawType));
          }

          return impl;
        }

        function __embind_register_enum_value(rawEnumType, name, enumValue) {
          var enumType = requireRegisteredType(rawEnumType, "enum");
          name = readLatin1String(name);
          var Enum = enumType.constructor;
          var Value = Object.create(enumType.constructor.prototype, {
            value: {
              value: enumValue
            },
            constructor: {
              value: createNamedFunction(enumType.name + "_" + name, function () {})
            }
          });
          Enum.values[enumValue] = Value;
          Enum[name] = Value;
        }

        function embindRepr(v) {
          if (v === null) {
            return "null";
          }

          var t = typeof v;

          if (t === "object" || t === "array" || t === "function") {
            return v.toString();
          } else {
            return "" + v;
          }
        }

        function floatReadValueFromPointer(name, shift) {
          switch (shift) {
            case 2:
              return function (pointer) {
                return this["fromWireType"](GROWABLE_HEAP_F32()[pointer >>> 2]);
              };

            case 3:
              return function (pointer) {
                return this["fromWireType"](GROWABLE_HEAP_F64()[pointer >>> 3]);
              };

            default:
              throw new TypeError("Unknown float type: " + name);
          }
        }

        function __embind_register_float(rawType, name, size) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, {
            name: name,
            "fromWireType": function fromWireType(value) {
              return value;
            },
            "toWireType": function toWireType(destructors, value) {
              return value;
            },
            "argPackAdvance": 8,
            "readValueFromPointer": floatReadValueFromPointer(name, shift),
            destructorFunction: null
          });
        }

        function __embind_register_function(name, argCount, rawArgTypesAddr, signature, rawInvoker, fn) {
          var argTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          name = readLatin1String(name);
          rawInvoker = embind__requireFunction(signature, rawInvoker);
          exposePublicSymbol(name, function () {
            throwUnboundTypeError("Cannot call " + name + " due to unbound types", argTypes);
          }, argCount - 1);
          whenDependentTypesAreResolved([], argTypes, function (argTypes2) {
            var invokerArgsArray = [argTypes2[0], null].concat(argTypes2.slice(1));
            replacePublicSymbol(name, craftInvokerFunction(name, invokerArgsArray, null, rawInvoker, fn), argCount - 1);
            return [];
          });
        }

        function integerReadValueFromPointer(name, shift, signed) {
          switch (shift) {
            case 0:
              return signed ? function readS8FromPointer(pointer) {
                return GROWABLE_HEAP_I8()[pointer >>> 0];
              } : function readU8FromPointer(pointer) {
                return GROWABLE_HEAP_U8()[pointer >>> 0];
              };

            case 1:
              return signed ? function readS16FromPointer(pointer) {
                return GROWABLE_HEAP_I16()[pointer >>> 1];
              } : function readU16FromPointer(pointer) {
                return GROWABLE_HEAP_U16()[pointer >>> 1];
              };

            case 2:
              return signed ? function readS32FromPointer(pointer) {
                return GROWABLE_HEAP_I32()[pointer >>> 2];
              } : function readU32FromPointer(pointer) {
                return GROWABLE_HEAP_U32()[pointer >>> 2];
              };

            default:
              throw new TypeError("Unknown integer type: " + name);
          }
        }

        function __embind_register_integer(primitiveType, name, size, minRange, maxRange) {
          name = readLatin1String(name);
          var shift = getShiftFromSize(size);

          var fromWireType = function fromWireType(value) {
            return value;
          };

          if (minRange === 0) {
            var bitshift = 32 - 8 * size;

            fromWireType = function fromWireType(value) {
              return value << bitshift >>> bitshift;
            };
          }

          var isUnsignedType = name.includes("unsigned");

          var checkAssertions = function checkAssertions(value, toTypeName) {};

          var toWireType;

          if (isUnsignedType) {
            toWireType = function toWireType(destructors, value) {
              checkAssertions(value, this.name);
              return value >>> 0;
            };
          } else {
            toWireType = function toWireType(destructors, value) {
              checkAssertions(value, this.name);
              return value;
            };
          }

          registerType(primitiveType, {
            name: name,
            "fromWireType": fromWireType,
            "toWireType": toWireType,
            "argPackAdvance": 8,
            "readValueFromPointer": integerReadValueFromPointer(name, shift, minRange !== 0),
            destructorFunction: null
          });
        }

        function __embind_register_memory_view(rawType, dataTypeIndex, name) {
          var typeMapping = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
          var TA = typeMapping[dataTypeIndex];

          function decodeMemoryView(handle) {
            handle = handle >> 2;
            var heap = GROWABLE_HEAP_U32();
            var size = heap[handle >>> 0];
            var data = heap[handle + 1 >>> 0];
            return new TA(heap.buffer, data, size);
          }

          name = readLatin1String(name);
          registerType(rawType, {
            name: name,
            "fromWireType": decodeMemoryView,
            "argPackAdvance": 8,
            "readValueFromPointer": decodeMemoryView
          }, {
            ignoreDuplicateRegistrations: true
          });
        }

        function __embind_register_std_string(rawType, name) {
          name = readLatin1String(name);
          var stdStringIsUTF8 = name === "std::string";
          registerType(rawType, {
            name: name,
            "fromWireType": function fromWireType(value) {
              var length = GROWABLE_HEAP_U32()[value >>> 2];
              var payload = value + 4;
              var str;

              if (stdStringIsUTF8) {
                var decodeStartPtr = payload;

                for (var i = 0; i <= length; ++i) {
                  var currentBytePtr = payload + i;

                  if (i == length || GROWABLE_HEAP_U8()[currentBytePtr >>> 0] == 0) {
                    var maxRead = currentBytePtr - decodeStartPtr;
                    var stringSegment = UTF8ToString(decodeStartPtr, maxRead);

                    if (str === void 0) {
                      str = stringSegment;
                    } else {
                      str += String.fromCharCode(0);
                      str += stringSegment;
                    }

                    decodeStartPtr = currentBytePtr + 1;
                  }
                }
              } else {
                var a = new Array(length);

                for (var i = 0; i < length; ++i) {
                  a[i] = String.fromCharCode(GROWABLE_HEAP_U8()[payload + i >>> 0]);
                }

                str = a.join("");
              }

              _free2(value);

              return str;
            },
            "toWireType": function toWireType(destructors, value) {
              if (value instanceof ArrayBuffer) {
                value = new Uint8Array(value);
              }

              var length;
              var valueIsOfTypeString = typeof value == "string";

              if (!(valueIsOfTypeString || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Int8Array)) {
                throwBindingError("Cannot pass non-string to std::string");
              }

              if (stdStringIsUTF8 && valueIsOfTypeString) {
                length = lengthBytesUTF8(value);
              } else {
                length = value.length;
              }

              var base = _malloc2(4 + length + 1);

              var ptr = base + 4;
              ptr >>>= 0;
              GROWABLE_HEAP_U32()[base >>> 2] = length;

              if (stdStringIsUTF8 && valueIsOfTypeString) {
                stringToUTF8(value, ptr, length + 1);
              } else {
                if (valueIsOfTypeString) {
                  for (var i = 0; i < length; ++i) {
                    var charCode = value.charCodeAt(i);

                    if (charCode > 255) {
                      _free2(ptr);

                      throwBindingError("String has UTF-16 code units that do not fit in 8 bits");
                    }

                    GROWABLE_HEAP_U8()[ptr + i >>> 0] = charCode;
                  }
                } else {
                  for (var i = 0; i < length; ++i) {
                    GROWABLE_HEAP_U8()[ptr + i >>> 0] = value[i];
                  }
                }
              }

              if (destructors !== null) {
                destructors.push(_free2, base);
              }

              return base;
            },
            "argPackAdvance": 8,
            "readValueFromPointer": simpleReadValueFromPointer,
            destructorFunction: function destructorFunction(ptr) {
              _free2(ptr);
            }
          });
        }

        var UTF16Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0;

        function UTF16ToString(ptr, maxBytesToRead) {
          var endPtr = ptr;
          var idx = endPtr >> 1;
          var maxIdx = idx + maxBytesToRead / 2;

          while (!(idx >= maxIdx) && GROWABLE_HEAP_U16()[idx >>> 0]) {
            ++idx;
          }

          endPtr = idx << 1;
          if (endPtr - ptr > 32 && UTF16Decoder) return UTF16Decoder.decode(GROWABLE_HEAP_U8().slice(ptr, endPtr));
          var str = "";

          for (var i = 0; !(i >= maxBytesToRead / 2); ++i) {
            var codeUnit = GROWABLE_HEAP_I16()[ptr + i * 2 >>> 1];
            if (codeUnit == 0) break;
            str += String.fromCharCode(codeUnit);
          }

          return str;
        }

        function stringToUTF16(str, outPtr, maxBytesToWrite) {
          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }

          if (maxBytesToWrite < 2) return 0;
          maxBytesToWrite -= 2;
          var startPtr = outPtr;
          var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;

          for (var i = 0; i < numCharsToWrite; ++i) {
            var codeUnit = str.charCodeAt(i);
            GROWABLE_HEAP_I16()[outPtr >>> 1] = codeUnit;
            outPtr += 2;
          }

          GROWABLE_HEAP_I16()[outPtr >>> 1] = 0;
          return outPtr - startPtr;
        }

        function lengthBytesUTF16(str) {
          return str.length * 2;
        }

        function UTF32ToString(ptr, maxBytesToRead) {
          var i = 0;
          var str = "";

          while (!(i >= maxBytesToRead / 4)) {
            var utf32 = GROWABLE_HEAP_I32()[ptr + i * 4 >>> 2];
            if (utf32 == 0) break;
            ++i;

            if (utf32 >= 65536) {
              var ch = utf32 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            } else {
              str += String.fromCharCode(utf32);
            }
          }

          return str;
        }

        function stringToUTF32(str, outPtr, maxBytesToWrite) {
          outPtr >>>= 0;

          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }

          if (maxBytesToWrite < 4) return 0;
          var startPtr = outPtr;
          var endPtr = startPtr + maxBytesToWrite - 4;

          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);

            if (codeUnit >= 55296 && codeUnit <= 57343) {
              var trailSurrogate = str.charCodeAt(++i);
              codeUnit = 65536 + ((codeUnit & 1023) << 10) | trailSurrogate & 1023;
            }

            GROWABLE_HEAP_I32()[outPtr >>> 2] = codeUnit;
            outPtr += 4;
            if (outPtr + 4 > endPtr) break;
          }

          GROWABLE_HEAP_I32()[outPtr >>> 2] = 0;
          return outPtr - startPtr;
        }

        function lengthBytesUTF32(str) {
          var len = 0;

          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);
            if (codeUnit >= 55296 && codeUnit <= 57343) ++i;
            len += 4;
          }

          return len;
        }

        function __embind_register_std_wstring(rawType, charSize, name) {
          name = readLatin1String(name);
          var decodeString, encodeString, getHeap, lengthBytesUTF, shift;

          if (charSize === 2) {
            decodeString = UTF16ToString;
            encodeString = stringToUTF16;
            lengthBytesUTF = lengthBytesUTF16;

            getHeap = function getHeap() {
              return GROWABLE_HEAP_U16();
            };

            shift = 1;
          } else if (charSize === 4) {
            decodeString = UTF32ToString;
            encodeString = stringToUTF32;
            lengthBytesUTF = lengthBytesUTF32;

            getHeap = function getHeap() {
              return GROWABLE_HEAP_U32();
            };

            shift = 2;
          }

          registerType(rawType, {
            name: name,
            "fromWireType": function fromWireType(value) {
              var length = GROWABLE_HEAP_U32()[value >>> 2];
              var HEAP = getHeap();
              var str;
              var decodeStartPtr = value + 4;

              for (var i = 0; i <= length; ++i) {
                var currentBytePtr = value + 4 + i * charSize;

                if (i == length || HEAP[currentBytePtr >>> shift] == 0) {
                  var maxReadBytes = currentBytePtr - decodeStartPtr;
                  var stringSegment = decodeString(decodeStartPtr, maxReadBytes);

                  if (str === void 0) {
                    str = stringSegment;
                  } else {
                    str += String.fromCharCode(0);
                    str += stringSegment;
                  }

                  decodeStartPtr = currentBytePtr + charSize;
                }
              }

              _free2(value);

              return str;
            },
            "toWireType": function toWireType(destructors, value) {
              if (!(typeof value == "string")) {
                throwBindingError("Cannot pass non-string to C++ string type " + name);
              }

              var length = lengthBytesUTF(value);

              var ptr = _malloc2(4 + length + charSize);

              ptr >>>= 0;
              GROWABLE_HEAP_U32()[ptr >>> 2] = length >> shift;
              encodeString(value, ptr + 4, length + charSize);

              if (destructors !== null) {
                destructors.push(_free2, ptr);
              }

              return ptr;
            },
            "argPackAdvance": 8,
            "readValueFromPointer": simpleReadValueFromPointer,
            destructorFunction: function destructorFunction(ptr) {
              _free2(ptr);
            }
          });
        }

        function __embind_register_value_array(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          tupleRegistrations[rawType] = {
            name: readLatin1String(name),
            rawConstructor: embind__requireFunction(constructorSignature, rawConstructor),
            rawDestructor: embind__requireFunction(destructorSignature, rawDestructor),
            elements: []
          };
        }

        function __embind_register_value_array_element(rawTupleType, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          tupleRegistrations[rawTupleType].elements.push({
            getterReturnType: getterReturnType,
            getter: embind__requireFunction(getterSignature, getter),
            getterContext: getterContext,
            setterArgumentType: setterArgumentType,
            setter: embind__requireFunction(setterSignature, setter),
            setterContext: setterContext
          });
        }

        function __embind_register_value_object(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          structRegistrations[rawType] = {
            name: readLatin1String(name),
            rawConstructor: embind__requireFunction(constructorSignature, rawConstructor),
            rawDestructor: embind__requireFunction(destructorSignature, rawDestructor),
            fields: []
          };
        }

        function __embind_register_value_object_field(structType, fieldName, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          structRegistrations[structType].fields.push({
            fieldName: readLatin1String(fieldName),
            getterReturnType: getterReturnType,
            getter: embind__requireFunction(getterSignature, getter),
            getterContext: getterContext,
            setterArgumentType: setterArgumentType,
            setter: embind__requireFunction(setterSignature, setter),
            setterContext: setterContext
          });
        }

        function __embind_register_void(rawType, name) {
          name = readLatin1String(name);
          registerType(rawType, {
            isVoid: true,
            name: name,
            "argPackAdvance": 0,
            "fromWireType": function fromWireType() {
              return void 0;
            },
            "toWireType": function toWireType(destructors, o) {
              return void 0;
            }
          });
        }

        function __emscripten_err(str) {
          err(UTF8ToString(str));
        }

        function executeNotifiedProxyingQueue(queue) {
          Atomics.store(GROWABLE_HEAP_I32(), queue >> 2, 1);

          if (_pthread_self()) {
            __emscripten_proxy_execute_task_queue(queue);
          }

          Atomics.compareExchange(GROWABLE_HEAP_I32(), queue >> 2, 1, 0);
        }

        Module["executeNotifiedProxyingQueue"] = executeNotifiedProxyingQueue;

        function __emscripten_notify_task_queue(targetThreadId, currThreadId, mainThreadId, queue) {
          if (targetThreadId == currThreadId) {
            setTimeout(function () {
              return executeNotifiedProxyingQueue(queue);
            });
          } else if (ENVIRONMENT_IS_PTHREAD) {
            postMessage({
              "targetThread": targetThreadId,
              "cmd": "processProxyingQueue",
              "queue": queue
            });
          } else {
            var worker = PThread.pthreads[targetThreadId];

            if (!worker) {
              return;
            }

            worker.postMessage({
              "cmd": "processProxyingQueue",
              "queue": queue
            });
          }

          return 1;
        }

        function __emscripten_set_offscreencanvas_size(target, width, height) {
          return -1;
        }

        function __emval_as(handle, returnType, destructorsRef) {
          handle = Emval.toValue(handle);
          returnType = requireRegisteredType(returnType, "emval::as");
          var destructors = [];
          var rd = Emval.toHandle(destructors);
          GROWABLE_HEAP_U32()[destructorsRef >>> 2] = rd;
          return returnType["toWireType"](destructors, handle);
        }

        function emval_lookupTypes(argCount, argTypes) {
          var a = new Array(argCount);

          for (var i = 0; i < argCount; ++i) {
            a[i] = requireRegisteredType(GROWABLE_HEAP_U32()[argTypes + i * 4 >>> 2], "parameter " + i);
          }

          return a;
        }

        function __emval_call(handle, argCount, argTypes, argv) {
          handle = Emval.toValue(handle);
          var types = emval_lookupTypes(argCount, argTypes);
          var args = new Array(argCount);

          for (var i = 0; i < argCount; ++i) {
            var type = types[i];
            args[i] = type["readValueFromPointer"](argv);
            argv += type["argPackAdvance"];
          }

          var rv = handle.apply(void 0, args);
          return Emval.toHandle(rv);
        }

        var emval_symbols = {};

        function getStringOrSymbol(address) {
          var symbol = emval_symbols[address];

          if (symbol === void 0) {
            return readLatin1String(address);
          }

          return symbol;
        }

        function emval_get_global() {
          if (typeof globalThis == "object") {
            return globalThis;
          }

          return function () {
            return Function;
          }()("return this")();
        }

        function __emval_get_global(name) {
          if (name === 0) {
            return Emval.toHandle(emval_get_global());
          } else {
            name = getStringOrSymbol(name);
            return Emval.toHandle(emval_get_global()[name]);
          }
        }

        function __emval_get_property(handle, key) {
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          return Emval.toHandle(handle[key]);
        }

        function __emval_incref(handle) {
          if (handle > 4) {
            emval_handle_array[handle].refcount += 1;
          }
        }

        function __emval_instanceof(object, constructor) {
          object = Emval.toValue(object);
          constructor = Emval.toValue(constructor);
          return object instanceof constructor;
        }

        function __emval_is_number(handle) {
          handle = Emval.toValue(handle);
          return typeof handle == "number";
        }

        function __emval_new_array() {
          return Emval.toHandle([]);
        }

        function __emval_new_cstring(v) {
          return Emval.toHandle(getStringOrSymbol(v));
        }

        function __emval_new_object() {
          return Emval.toHandle({});
        }

        function __emval_run_destructors(handle) {
          var destructors = Emval.toValue(handle);
          runDestructors(destructors);

          __emval_decref(handle);
        }

        function __emval_set_property(handle, key, value) {
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          value = Emval.toValue(value);
          handle[key] = value;
        }

        function __emval_take_value(type, arg) {
          type = requireRegisteredType(type, "_emval_take_value");
          var v = type["readValueFromPointer"](arg);
          return Emval.toHandle(v);
        }

        function _abort() {
          abort("");
        }

        function warnOnce(text) {
          if (!warnOnce.shown) warnOnce.shown = {};

          if (!warnOnce.shown[text]) {
            warnOnce.shown[text] = 1;
            if (ENVIRONMENT_IS_NODE) text = "warning: " + text;
            err(text);
          }
        }

        function _emscripten_check_blocking_allowed() {
          if (ENVIRONMENT_IS_NODE) return;
          if (ENVIRONMENT_IS_WORKER) return;
          warnOnce("Blocking on the main thread is very dangerous, see https://emscripten.org/docs/porting/pthreads.html#blocking-on-the-main-browser-thread");
        }

        var _emscripten_get_now;

        if (ENVIRONMENT_IS_NODE) {
          _emscripten_get_now = function _emscripten_get_now() {
            var t = process["hrtime"]();
            return t[0] * 1e3 + t[1] / 1e6;
          };
        } else _emscripten_get_now = function _emscripten_get_now() {
          return performance.timeOrigin + performance.now();
        };

        function _emscripten_memcpy_big(dest, src, num) {
          GROWABLE_HEAP_U8().copyWithin(dest >>> 0, src >>> 0, src + num >>> 0);
        }

        function withStackSave(f) {
          var stack = _stackSave();

          var ret = f();

          _stackRestore(stack);

          return ret;
        }

        function _emscripten_proxy_to_main_thread_js(index, sync) {
          var numCallArgs = arguments.length - 2;
          var outerArgs = arguments;
          return withStackSave(function () {
            var serializedNumCallArgs = numCallArgs;

            var args = _stackAlloc(serializedNumCallArgs * 8);

            var b = args >> 3;

            for (var i = 0; i < numCallArgs; i++) {
              var arg = outerArgs[2 + i];
              GROWABLE_HEAP_F64()[b + i >>> 0] = arg;
            }

            return _emscripten_run_in_main_runtime_thread_js2(index, serializedNumCallArgs, args, sync);
          });
        }

        var _emscripten_receive_on_main_thread_js_callArgs = [];

        function _emscripten_receive_on_main_thread_js(index, numCallArgs, args) {
          _emscripten_receive_on_main_thread_js_callArgs.length = numCallArgs;
          var b = args >> 3;

          for (var i = 0; i < numCallArgs; i++) {
            _emscripten_receive_on_main_thread_js_callArgs[i] = GROWABLE_HEAP_F64()[b + i >>> 0];
          }

          var func = proxiedFunctionTable[index];
          return func.apply(null, _emscripten_receive_on_main_thread_js_callArgs);
        }

        function getHeapMax() {
          return 4294901760;
        }

        function emscripten_realloc_buffer(size) {
          var b = wasmMemory.buffer;

          try {
            wasmMemory.grow(size - b.byteLength + 65535 >>> 16);
            updateMemoryViews();
            return 1;
          } catch (e) {}
        }

        function _emscripten_resize_heap(requestedSize) {
          var oldSize = GROWABLE_HEAP_U8().length;
          requestedSize = requestedSize >>> 0;

          if (requestedSize <= oldSize) {
            return false;
          }

          var maxHeapSize = getHeapMax();

          if (requestedSize > maxHeapSize) {
            return false;
          }

          var alignUp = function alignUp(x, multiple) {
            return x + (multiple - x % multiple) % multiple;
          };

          for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
            var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
            overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
            var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
            var replacement = emscripten_realloc_buffer(newSize);

            if (replacement) {
              return true;
            }
          }

          return false;
        }

        function _emscripten_unwind_to_js_event_loop() {
          throw "unwind";
        }

        var ENV = {};

        function getExecutableName() {
          return thisProgram || "./this.program";
        }

        function getEnvStrings() {
          if (!getEnvStrings.strings) {
            var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
            var env = {
              "USER": "web_user",
              "LOGNAME": "web_user",
              "PATH": "/",
              "PWD": "/",
              "HOME": "/home/web_user",
              "LANG": lang,
              "_": getExecutableName()
            };

            for (var x in ENV) {
              if (ENV[x] === void 0) delete env[x];else env[x] = ENV[x];
            }

            var strings = [];

            for (var x in env) {
              strings.push(x + "=" + env[x]);
            }

            getEnvStrings.strings = strings;
          }

          return getEnvStrings.strings;
        }

        function writeAsciiToMemory(str, buffer, dontAddNull) {
          for (var i = 0; i < str.length; ++i) {
            GROWABLE_HEAP_I8()[buffer++ >>> 0] = str.charCodeAt(i);
          }

          if (!dontAddNull) GROWABLE_HEAP_I8()[buffer >>> 0] = 0;
        }

        function _environ_get(__environ, environ_buf) {
          if (ENVIRONMENT_IS_PTHREAD) return _emscripten_proxy_to_main_thread_js(6, 1, __environ, environ_buf);
          var bufSize = 0;
          getEnvStrings().forEach(function (string, i) {
            var ptr = environ_buf + bufSize;
            GROWABLE_HEAP_U32()[__environ + i * 4 >>> 2] = ptr;
            writeAsciiToMemory(string, ptr);
            bufSize += string.length + 1;
          });
          return 0;
        }

        function _environ_sizes_get(penviron_count, penviron_buf_size) {
          if (ENVIRONMENT_IS_PTHREAD) return _emscripten_proxy_to_main_thread_js(7, 1, penviron_count, penviron_buf_size);
          var strings = getEnvStrings();
          GROWABLE_HEAP_U32()[penviron_count >>> 2] = strings.length;
          var bufSize = 0;
          strings.forEach(function (string) {
            bufSize += string.length + 1;
          });
          GROWABLE_HEAP_U32()[penviron_buf_size >>> 2] = bufSize;
          return 0;
        }

        function _fd_close(fd) {
          if (ENVIRONMENT_IS_PTHREAD) return _emscripten_proxy_to_main_thread_js(8, 1, fd);

          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.close(stream);
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return e.errno;
          }
        }

        function doReadv(stream, iov, iovcnt, offset) {
          var ret = 0;

          for (var i = 0; i < iovcnt; i++) {
            var ptr = GROWABLE_HEAP_U32()[iov >>> 2];
            var len = GROWABLE_HEAP_U32()[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.read(stream, GROWABLE_HEAP_I8(), ptr, len, offset);
            if (curr < 0) return -1;
            ret += curr;
            if (curr < len) break;

            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }

          return ret;
        }

        function _fd_read(fd, iov, iovcnt, pnum) {
          if (ENVIRONMENT_IS_PTHREAD) return _emscripten_proxy_to_main_thread_js(9, 1, fd, iov, iovcnt, pnum);

          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doReadv(stream, iov, iovcnt);
            GROWABLE_HEAP_U32()[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return e.errno;
          }
        }

        function convertI32PairToI53Checked(lo, hi) {
          return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
        }

        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
          if (ENVIRONMENT_IS_PTHREAD) return _emscripten_proxy_to_main_thread_js(10, 1, fd, offset_low, offset_high, whence, newOffset);

          try {
            var offset = convertI32PairToI53Checked(offset_low, offset_high);
            if (isNaN(offset)) return 61;
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.llseek(stream, offset, whence);
            tempI64 = [stream.position >>> 0, (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], GROWABLE_HEAP_I32()[newOffset >>> 2] = tempI64[0], GROWABLE_HEAP_I32()[newOffset + 4 >>> 2] = tempI64[1];
            if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return e.errno;
          }
        }

        function doWritev(stream, iov, iovcnt, offset) {
          var ret = 0;

          for (var i = 0; i < iovcnt; i++) {
            var ptr = GROWABLE_HEAP_U32()[iov >>> 2];
            var len = GROWABLE_HEAP_U32()[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.write(stream, GROWABLE_HEAP_I8(), ptr, len, offset);
            if (curr < 0) return -1;
            ret += curr;

            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }

          return ret;
        }

        function _fd_write(fd, iov, iovcnt, pnum) {
          if (ENVIRONMENT_IS_PTHREAD) return _emscripten_proxy_to_main_thread_js(11, 1, fd, iov, iovcnt, pnum);

          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doWritev(stream, iov, iovcnt);
            GROWABLE_HEAP_U32()[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return e.errno;
          }
        }

        function __isLeapYear(year) {
          return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        }

        function __arraySum(array, index) {
          var sum = 0;

          for (var i = 0; i <= index; sum += array[i++]) {}

          return sum;
        }

        var __MONTH_DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var __MONTH_DAYS_REGULAR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        function __addDays(date, days) {
          var newDate = new Date(date.getTime());

          while (days > 0) {
            var leap = __isLeapYear(newDate.getFullYear());

            var currentMonth = newDate.getMonth();
            var daysInCurrentMonth = (leap ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[currentMonth];

            if (days > daysInCurrentMonth - newDate.getDate()) {
              days -= daysInCurrentMonth - newDate.getDate() + 1;
              newDate.setDate(1);

              if (currentMonth < 11) {
                newDate.setMonth(currentMonth + 1);
              } else {
                newDate.setMonth(0);
                newDate.setFullYear(newDate.getFullYear() + 1);
              }
            } else {
              newDate.setDate(newDate.getDate() + days);
              return newDate;
            }
          }

          return newDate;
        }

        function writeArrayToMemory(array, buffer) {
          GROWABLE_HEAP_I8().set(array, buffer >>> 0);
        }

        function _strftime(s, maxsize, format, tm) {
          var tm_zone = GROWABLE_HEAP_I32()[tm + 40 >>> 2];
          var date = {
            tm_sec: GROWABLE_HEAP_I32()[tm >>> 2],
            tm_min: GROWABLE_HEAP_I32()[tm + 4 >>> 2],
            tm_hour: GROWABLE_HEAP_I32()[tm + 8 >>> 2],
            tm_mday: GROWABLE_HEAP_I32()[tm + 12 >>> 2],
            tm_mon: GROWABLE_HEAP_I32()[tm + 16 >>> 2],
            tm_year: GROWABLE_HEAP_I32()[tm + 20 >>> 2],
            tm_wday: GROWABLE_HEAP_I32()[tm + 24 >>> 2],
            tm_yday: GROWABLE_HEAP_I32()[tm + 28 >>> 2],
            tm_isdst: GROWABLE_HEAP_I32()[tm + 32 >>> 2],
            tm_gmtoff: GROWABLE_HEAP_I32()[tm + 36 >>> 2],
            tm_zone: tm_zone ? UTF8ToString(tm_zone) : ""
          };
          var pattern = UTF8ToString(format);
          var EXPANSION_RULES_1 = {
            "%c": "%a %b %d %H:%M:%S %Y",
            "%D": "%m/%d/%y",
            "%F": "%Y-%m-%d",
            "%h": "%b",
            "%r": "%I:%M:%S %p",
            "%R": "%H:%M",
            "%T": "%H:%M:%S",
            "%x": "%m/%d/%y",
            "%X": "%H:%M:%S",
            "%Ec": "%c",
            "%EC": "%C",
            "%Ex": "%m/%d/%y",
            "%EX": "%H:%M:%S",
            "%Ey": "%y",
            "%EY": "%Y",
            "%Od": "%d",
            "%Oe": "%e",
            "%OH": "%H",
            "%OI": "%I",
            "%Om": "%m",
            "%OM": "%M",
            "%OS": "%S",
            "%Ou": "%u",
            "%OU": "%U",
            "%OV": "%V",
            "%Ow": "%w",
            "%OW": "%W",
            "%Oy": "%y"
          };

          for (var rule in EXPANSION_RULES_1) {
            pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
          }

          var WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
          var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

          function leadingSomething(value, digits, character) {
            var str = typeof value == "number" ? value.toString() : value || "";

            while (str.length < digits) {
              str = character[0] + str;
            }

            return str;
          }

          function leadingNulls(value, digits) {
            return leadingSomething(value, digits, "0");
          }

          function compareByDay(date1, date2) {
            function sgn(value) {
              return value < 0 ? -1 : value > 0 ? 1 : 0;
            }

            var compare;

            if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
              if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) {
                compare = sgn(date1.getDate() - date2.getDate());
              }
            }

            return compare;
          }

          function getFirstWeekStartDate(janFourth) {
            switch (janFourth.getDay()) {
              case 0:
                return new Date(janFourth.getFullYear() - 1, 11, 29);

              case 1:
                return janFourth;

              case 2:
                return new Date(janFourth.getFullYear(), 0, 3);

              case 3:
                return new Date(janFourth.getFullYear(), 0, 2);

              case 4:
                return new Date(janFourth.getFullYear(), 0, 1);

              case 5:
                return new Date(janFourth.getFullYear() - 1, 11, 31);

              case 6:
                return new Date(janFourth.getFullYear() - 1, 11, 30);
            }
          }

          function getWeekBasedYear(date2) {
            var thisDate = __addDays(new Date(date2.tm_year + 1900, 0, 1), date2.tm_yday);

            var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
            var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
            var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
            var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);

            if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
              if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {
                return thisDate.getFullYear() + 1;
              }

              return thisDate.getFullYear();
            }

            return thisDate.getFullYear() - 1;
          }

          var EXPANSION_RULES_2 = {
            "%a": function a(date2) {
              return WEEKDAYS[date2.tm_wday].substring(0, 3);
            },
            "%A": function A(date2) {
              return WEEKDAYS[date2.tm_wday];
            },
            "%b": function b(date2) {
              return MONTHS[date2.tm_mon].substring(0, 3);
            },
            "%B": function B(date2) {
              return MONTHS[date2.tm_mon];
            },
            "%C": function C(date2) {
              var year = date2.tm_year + 1900;
              return leadingNulls(year / 100 | 0, 2);
            },
            "%d": function d(date2) {
              return leadingNulls(date2.tm_mday, 2);
            },
            "%e": function e(date2) {
              return leadingSomething(date2.tm_mday, 2, " ");
            },
            "%g": function g(date2) {
              return getWeekBasedYear(date2).toString().substring(2);
            },
            "%G": function G(date2) {
              return getWeekBasedYear(date2);
            },
            "%H": function H(date2) {
              return leadingNulls(date2.tm_hour, 2);
            },
            "%I": function I(date2) {
              var twelveHour = date2.tm_hour;
              if (twelveHour == 0) twelveHour = 12;else if (twelveHour > 12) twelveHour -= 12;
              return leadingNulls(twelveHour, 2);
            },
            "%j": function j(date2) {
              return leadingNulls(date2.tm_mday + __arraySum(__isLeapYear(date2.tm_year + 1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, date2.tm_mon - 1), 3);
            },
            "%m": function m(date2) {
              return leadingNulls(date2.tm_mon + 1, 2);
            },
            "%M": function M(date2) {
              return leadingNulls(date2.tm_min, 2);
            },
            "%n": function n() {
              return "\n";
            },
            "%p": function p(date2) {
              if (date2.tm_hour >= 0 && date2.tm_hour < 12) {
                return "AM";
              }

              return "PM";
            },
            "%S": function S(date2) {
              return leadingNulls(date2.tm_sec, 2);
            },
            "%t": function t() {
              return "	";
            },
            "%u": function u(date2) {
              return date2.tm_wday || 7;
            },
            "%U": function U(date2) {
              var days = date2.tm_yday + 7 - date2.tm_wday;
              return leadingNulls(Math.floor(days / 7), 2);
            },
            "%V": function V(date2) {
              var val = Math.floor((date2.tm_yday + 7 - (date2.tm_wday + 6) % 7) / 7);

              if ((date2.tm_wday + 371 - date2.tm_yday - 2) % 7 <= 2) {
                val++;
              }

              if (!val) {
                val = 52;
                var dec31 = (date2.tm_wday + 7 - date2.tm_yday - 1) % 7;

                if (dec31 == 4 || dec31 == 5 && __isLeapYear(date2.tm_year % 400 - 1)) {
                  val++;
                }
              } else if (val == 53) {
                var jan1 = (date2.tm_wday + 371 - date2.tm_yday) % 7;
                if (jan1 != 4 && (jan1 != 3 || !__isLeapYear(date2.tm_year))) val = 1;
              }

              return leadingNulls(val, 2);
            },
            "%w": function w(date2) {
              return date2.tm_wday;
            },
            "%W": function W(date2) {
              var days = date2.tm_yday + 7 - (date2.tm_wday + 6) % 7;
              return leadingNulls(Math.floor(days / 7), 2);
            },
            "%y": function y(date2) {
              return (date2.tm_year + 1900).toString().substring(2);
            },
            "%Y": function Y(date2) {
              return date2.tm_year + 1900;
            },
            "%z": function z(date2) {
              var off = date2.tm_gmtoff;
              var ahead = off >= 0;
              off = Math.abs(off) / 60;
              off = off / 60 * 100 + off % 60;
              return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
            },
            "%Z": function Z(date2) {
              return date2.tm_zone;
            },
            "%%": function _() {
              return "%";
            }
          };
          pattern = pattern.replace(/%%/g, "\0\0");

          for (var rule in EXPANSION_RULES_2) {
            if (pattern.includes(rule)) {
              pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
            }
          }

          pattern = pattern.replace(/\0\0/g, "%");
          var bytes = intArrayFromString(pattern, false);

          if (bytes.length > maxsize) {
            return 0;
          }

          writeArrayToMemory(bytes, s);
          return bytes.length - 1;
        }

        function _strftime_l(s, maxsize, format, tm, loc) {
          return _strftime(s, maxsize, format, tm);
        }

        PThread.init();

        var FSNode = function FSNode(parent, name, mode, rdev) {
          if (!parent) {
            parent = this;
          }

          this.parent = parent;
          this.mount = parent.mount;
          this.mounted = null;
          this.id = FS.nextInode++;
          this.name = name;
          this.mode = mode;
          this.node_ops = {};
          this.stream_ops = {};
          this.rdev = rdev;
        };

        var readMode = 292 | 73;
        var writeMode = 146;
        Object.defineProperties(FSNode.prototype, {
          read: {
            get: function get() {
              return (this.mode & readMode) === readMode;
            },
            set: function set(val) {
              val ? this.mode |= readMode : this.mode &= ~readMode;
            }
          },
          write: {
            get: function get() {
              return (this.mode & writeMode) === writeMode;
            },
            set: function set(val) {
              val ? this.mode |= writeMode : this.mode &= ~writeMode;
            }
          },
          isFolder: {
            get: function get() {
              return FS.isDir(this.mode);
            }
          },
          isDevice: {
            get: function get() {
              return FS.isChrdev(this.mode);
            }
          }
        });
        FS.FSNode = FSNode;
        FS.staticInit();
        InternalError = Module["InternalError"] = extendError(Error, "InternalError");
        embind_init_charCodes();
        BindingError = Module["BindingError"] = extendError(Error, "BindingError");
        init_ClassHandle();
        init_embind();
        init_RegisteredPointer();
        UnboundTypeError = Module["UnboundTypeError"] = extendError(Error, "UnboundTypeError");
        init_emval();
        var proxiedFunctionTable = [null, _proc_exit, exitOnMainThread, ___syscall_fcntl64, ___syscall_ioctl, ___syscall_openat, _environ_get, _environ_sizes_get, _fd_close, _fd_read, _fd_seek, _fd_write];
        var wasmImports = {
          "f": ___cxa_throw,
          "V": ___emscripten_init_main_thread_js,
          "K": ___emscripten_thread_cleanup,
          "B": ___syscall_fcntl64,
          "P": ___syscall_ioctl,
          "Q": ___syscall_openat,
          "Z": __dlinit,
          "aa": __dlopen_js,
          "$": __dlsym_catchup_js,
          "fa": __embind_finalize_value_array,
          "u": __embind_finalize_value_object,
          "I": __embind_register_bigint,
          "da": __embind_register_bool,
          "t": __embind_register_class,
          "s": __embind_register_class_constructor,
          "d": __embind_register_class_function,
          "ca": __embind_register_emval,
          "F": __embind_register_enum,
          "q": __embind_register_enum_value,
          "D": __embind_register_float,
          "c": __embind_register_function,
          "p": __embind_register_integer,
          "i": __embind_register_memory_view,
          "E": __embind_register_std_string,
          "x": __embind_register_std_wstring,
          "ga": __embind_register_value_array,
          "k": __embind_register_value_array_element,
          "v": __embind_register_value_object,
          "h": __embind_register_value_object_field,
          "ea": __embind_register_void,
          "_": __emscripten_err,
          "X": __emscripten_notify_task_queue,
          "U": __emscripten_set_offscreencanvas_size,
          "m": __emval_as,
          "z": __emval_call,
          "b": __emval_decref,
          "G": __emval_get_global,
          "n": __emval_get_property,
          "o": __emval_incref,
          "ia": __emval_instanceof,
          "ha": __emval_is_number,
          "y": __emval_new_array,
          "g": __emval_new_cstring,
          "w": __emval_new_object,
          "l": __emval_run_destructors,
          "j": __emval_set_property,
          "e": __emval_take_value,
          "C": _abort,
          "W": _emscripten_check_blocking_allowed,
          "r": _emscripten_get_now,
          "Y": _emscripten_memcpy_big,
          "T": _emscripten_receive_on_main_thread_js,
          "R": _emscripten_resize_heap,
          "ba": _emscripten_unwind_to_js_event_loop,
          "M": _environ_get,
          "N": _environ_sizes_get,
          "J": _exit,
          "A": _fd_close,
          "O": _fd_read,
          "H": _fd_seek,
          "S": _fd_write,
          "a": wasmMemory || Module["wasmMemory"],
          "L": _strftime_l
        };
        createWasm();

        var _malloc2 = function _malloc() {
          return (_malloc2 = Module["asm"]["la"]).apply(null, arguments);
        };

        Module["__emscripten_tls_init"] = function () {
          return (Module["__emscripten_tls_init"] = Module["asm"]["ma"]).apply(null, arguments);
        };

        var _pthread_self = Module["_pthread_self"] = function () {
          return (_pthread_self = Module["_pthread_self"] = Module["asm"]["na"]).apply(null, arguments);
        };

        var ___getTypeName = Module["___getTypeName"] = function () {
          return (___getTypeName = Module["___getTypeName"] = Module["asm"]["oa"]).apply(null, arguments);
        };

        Module["__embind_initialize_bindings"] = function () {
          return (Module["__embind_initialize_bindings"] = Module["asm"]["pa"]).apply(null, arguments);
        };

        var _errno_location = function ___errno_location() {
          return (_errno_location = Module["asm"]["qa"]).apply(null, arguments);
        };

        var __emscripten_thread_init = Module["__emscripten_thread_init"] = function () {
          return (__emscripten_thread_init = Module["__emscripten_thread_init"] = Module["asm"]["ra"]).apply(null, arguments);
        };

        Module["__emscripten_thread_crashed"] = function () {
          return (Module["__emscripten_thread_crashed"] = Module["asm"]["sa"]).apply(null, arguments);
        };

        var _emscripten_run_in_main_runtime_thread_js2 = function _emscripten_run_in_main_runtime_thread_js() {
          return (_emscripten_run_in_main_runtime_thread_js2 = Module["asm"]["ta"]).apply(null, arguments);
        };

        var __emscripten_proxy_execute_task_queue = Module["__emscripten_proxy_execute_task_queue"] = function () {
          return (__emscripten_proxy_execute_task_queue = Module["__emscripten_proxy_execute_task_queue"] = Module["asm"]["ua"]).apply(null, arguments);
        };

        var _emscripten_thread_free_data = function __emscripten_thread_free_data() {
          return (_emscripten_thread_free_data = Module["asm"]["va"]).apply(null, arguments);
        };

        var __emscripten_thread_exit = Module["__emscripten_thread_exit"] = function () {
          return (__emscripten_thread_exit = Module["__emscripten_thread_exit"] = Module["asm"]["wa"]).apply(null, arguments);
        };

        var _free2 = function _free() {
          return (_free2 = Module["asm"]["xa"]).apply(null, arguments);
        };

        var _emscripten_stack_set_limits2 = function _emscripten_stack_set_limits() {
          return (_emscripten_stack_set_limits2 = Module["asm"]["ya"]).apply(null, arguments);
        };

        var _stackSave = function stackSave() {
          return (_stackSave = Module["asm"]["za"]).apply(null, arguments);
        };

        var _stackRestore = function stackRestore() {
          return (_stackRestore = Module["asm"]["Aa"]).apply(null, arguments);
        };

        var _stackAlloc = function stackAlloc() {
          return (_stackAlloc = Module["asm"]["Ba"]).apply(null, arguments);
        };

        var _cxa_is_pointer_type = function ___cxa_is_pointer_type() {
          return (_cxa_is_pointer_type = Module["asm"]["Ca"]).apply(null, arguments);
        };

        Module["dynCall_jiji"] = function () {
          return (Module["dynCall_jiji"] = Module["asm"]["Da"]).apply(null, arguments);
        };

        Module["dynCall_viijii"] = function () {
          return (Module["dynCall_viijii"] = Module["asm"]["Ea"]).apply(null, arguments);
        };

        Module["dynCall_iiiiij"] = function () {
          return (Module["dynCall_iiiiij"] = Module["asm"]["Fa"]).apply(null, arguments);
        };

        Module["dynCall_iiiiijj"] = function () {
          return (Module["dynCall_iiiiijj"] = Module["asm"]["Ga"]).apply(null, arguments);
        };

        Module["dynCall_iiiiiijj"] = function () {
          return (Module["dynCall_iiiiiijj"] = Module["asm"]["Ha"]).apply(null, arguments);
        };

        Module["keepRuntimeAlive"] = keepRuntimeAlive;
        Module["wasmMemory"] = wasmMemory;
        Module["ExitStatus"] = ExitStatus;
        Module["PThread"] = PThread;
        var calledRun;

        dependenciesFulfilled = function runCaller() {
          if (!calledRun) run();
          if (!calledRun) dependenciesFulfilled = runCaller;
        };

        function run() {
          if (runDependencies > 0) {
            return;
          }

          if (ENVIRONMENT_IS_PTHREAD) {
            readyPromiseResolve(Module);
            initRuntime();
            startWorker(Module);
            return;
          }

          preRun();

          if (runDependencies > 0) {
            return;
          }

          function doRun() {
            if (calledRun) return;
            calledRun = true;
            Module["calledRun"] = true;
            if (ABORT) return;
            initRuntime();
            readyPromiseResolve(Module);
            if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
            postRun();
          }

          if (Module["setStatus"]) {
            Module["setStatus"]("Running...");
            setTimeout(function () {
              setTimeout(function () {
                Module["setStatus"]("");
              }, 1);
              doRun();
            }, 1);
          } else {
            doRun();
          }
        }

        if (Module["preInit"]) {
          if (typeof Module["preInit"] == "function") Module["preInit"] = [Module["preInit"]];

          while (Module["preInit"].length > 0) {
            Module["preInit"].pop()();
          }
        }

        run();
        return WebIFCWasm3.ready;
      };
    }();

    if (typeof exports === "object" && typeof module === "object") module.exports = WebIFCWasm2;else if (typeof define === "function" && define["amd"]) define([], function () {
      return WebIFCWasm2;
    });else if (typeof exports === "object") exports["WebIFCWasm"] = WebIFCWasm2;
  }
}); // dist/web-ifc.js


var require_web_ifc = __commonJS({
  "dist/web-ifc.js": function distWebIfcJs(exports, module) {
    var WebIFCWasm2 = function () {
      var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : void 0;

      if (typeof __filename !== "undefined") _scriptDir = _scriptDir || __filename;
      return function () {
        var WebIFCWasm3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var Module = typeof WebIFCWasm3 != "undefined" ? WebIFCWasm3 : {};
        var readyPromiseResolve, readyPromiseReject;
        Module["ready"] = new Promise(function (resolve, reject) {
          readyPromiseResolve = resolve;
          readyPromiseReject = reject;
        });
        var moduleOverrides = Object.assign({}, Module);
        var thisProgram = "./this.program";
        var ENVIRONMENT_IS_WEB = typeof window == "object";
        var ENVIRONMENT_IS_WORKER = typeof importScripts == "function";
        var ENVIRONMENT_IS_NODE = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string";
        var scriptDirectory = "";

        function locateFile(path) {
          if (Module["locateFile"]) {
            return Module["locateFile"](path, scriptDirectory);
          }

          return scriptDirectory + path;
        }

        var read_, readAsync, readBinary;

        if (ENVIRONMENT_IS_NODE) {
          var fs = __require("fs");

          var nodePath = __require("path");

          if (ENVIRONMENT_IS_WORKER) {
            scriptDirectory = nodePath.dirname(scriptDirectory) + "/";
          } else {
            scriptDirectory = __dirname + "/";
          }

          read_ = function read_(filename, binary) {
            filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
            return fs.readFileSync(filename, binary ? void 0 : "utf8");
          };

          readBinary = function readBinary(filename) {
            var ret = read_(filename, true);

            if (!ret.buffer) {
              ret = new Uint8Array(ret);
            }

            return ret;
          };

          readAsync = function readAsync(filename, onload, onerror) {
            filename = isFileURI(filename) ? new URL(filename) : nodePath.normalize(filename);
            fs.readFile(filename, function (err2, data) {
              if (err2) onerror(err2);else onload(data.buffer);
            });
          };

          if (process["argv"].length > 1) {
            thisProgram = process["argv"][1].replace(/\\/g, "/");
          }

          process["argv"].slice(2);
          process["on"]("uncaughtException", function (ex) {
            if (!(ex instanceof ExitStatus)) {
              throw ex;
            }
          });
          var nodeMajor = process.version.match(/^v(\d+)\./)[1];

          if (nodeMajor < 15) {
            process["on"]("unhandledRejection", function (reason) {
              throw reason;
            });
          }

          Module["inspect"] = function () {
            return "[Emscripten Module object]";
          };
        } else if (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER) {
          if (ENVIRONMENT_IS_WORKER) {
            scriptDirectory = self.location.href;
          } else if (typeof document != "undefined" && document.currentScript) {
            scriptDirectory = document.currentScript.src;
          }

          if (_scriptDir) {
            scriptDirectory = _scriptDir;
          }

          if (scriptDirectory.indexOf("blob:") !== 0) {
            scriptDirectory = scriptDirectory.substr(0, scriptDirectory.replace(/[?#].*/, "").lastIndexOf("/") + 1);
          } else {
            scriptDirectory = "";
          }

          {
            read_ = function read_(url) {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, false);
              xhr.send(null);
              return xhr.responseText;
            };

            if (ENVIRONMENT_IS_WORKER) {
              readBinary = function readBinary(url) {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, false);
                xhr.responseType = "arraybuffer";
                xhr.send(null);
                return new Uint8Array(xhr.response);
              };
            }

            readAsync = function readAsync(url, onload, onerror) {
              var xhr = new XMLHttpRequest();
              xhr.open("GET", url, true);
              xhr.responseType = "arraybuffer";

              xhr.onload = function () {
                if (xhr.status == 200 || xhr.status == 0 && xhr.response) {
                  onload(xhr.response);
                  return;
                }

                onerror();
              };

              xhr.onerror = onerror;
              xhr.send(null);
            };
          }
        } else ;

        var out = Module["print"] || console.log.bind(console);
        var err = Module["printErr"] || console.warn.bind(console);
        Object.assign(Module, moduleOverrides);
        moduleOverrides = null;
        if (Module["arguments"]) Module["arguments"];
        if (Module["thisProgram"]) thisProgram = Module["thisProgram"];
        if (Module["quit"]) Module["quit"];
        var wasmBinary;
        if (Module["wasmBinary"]) wasmBinary = Module["wasmBinary"];
        Module["noExitRuntime"] || true;

        if (typeof WebAssembly != "object") {
          abort("no native wasm support detected");
        }

        var wasmMemory;
        var ABORT = false;

        function assert(condition, text) {
          if (!condition) {
            abort(text);
          }
        }

        var UTF8Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0;

        function UTF8ArrayToString(heapOrArray, idx, maxBytesToRead) {
          idx >>>= 0;
          var endIdx = idx + maxBytesToRead;
          var endPtr = idx;

          while (heapOrArray[endPtr] && !(endPtr >= endIdx)) {
            ++endPtr;
          }

          if (endPtr - idx > 16 && heapOrArray.buffer && UTF8Decoder) {
            return UTF8Decoder.decode(heapOrArray.subarray(idx, endPtr));
          }

          var str = "";

          while (idx < endPtr) {
            var u0 = heapOrArray[idx++];

            if (!(u0 & 128)) {
              str += String.fromCharCode(u0);
              continue;
            }

            var u1 = heapOrArray[idx++] & 63;

            if ((u0 & 224) == 192) {
              str += String.fromCharCode((u0 & 31) << 6 | u1);
              continue;
            }

            var u2 = heapOrArray[idx++] & 63;

            if ((u0 & 240) == 224) {
              u0 = (u0 & 15) << 12 | u1 << 6 | u2;
            } else {
              u0 = (u0 & 7) << 18 | u1 << 12 | u2 << 6 | heapOrArray[idx++] & 63;
            }

            if (u0 < 65536) {
              str += String.fromCharCode(u0);
            } else {
              var ch = u0 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            }
          }

          return str;
        }

        function UTF8ToString(ptr, maxBytesToRead) {
          ptr >>>= 0;
          return ptr ? UTF8ArrayToString(HEAPU8, ptr, maxBytesToRead) : "";
        }

        function stringToUTF8Array(str, heap, outIdx, maxBytesToWrite) {
          outIdx >>>= 0;
          if (!(maxBytesToWrite > 0)) return 0;
          var startIdx = outIdx;
          var endIdx = outIdx + maxBytesToWrite - 1;

          for (var i = 0; i < str.length; ++i) {
            var u = str.charCodeAt(i);

            if (u >= 55296 && u <= 57343) {
              var u1 = str.charCodeAt(++i);
              u = 65536 + ((u & 1023) << 10) | u1 & 1023;
            }

            if (u <= 127) {
              if (outIdx >= endIdx) break;
              heap[outIdx++ >>> 0] = u;
            } else if (u <= 2047) {
              if (outIdx + 1 >= endIdx) break;
              heap[outIdx++ >>> 0] = 192 | u >> 6;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else if (u <= 65535) {
              if (outIdx + 2 >= endIdx) break;
              heap[outIdx++ >>> 0] = 224 | u >> 12;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            } else {
              if (outIdx + 3 >= endIdx) break;
              heap[outIdx++ >>> 0] = 240 | u >> 18;
              heap[outIdx++ >>> 0] = 128 | u >> 12 & 63;
              heap[outIdx++ >>> 0] = 128 | u >> 6 & 63;
              heap[outIdx++ >>> 0] = 128 | u & 63;
            }
          }

          heap[outIdx >>> 0] = 0;
          return outIdx - startIdx;
        }

        function stringToUTF8(str, outPtr, maxBytesToWrite) {
          return stringToUTF8Array(str, HEAPU8, outPtr, maxBytesToWrite);
        }

        function lengthBytesUTF8(str) {
          var len = 0;

          for (var i = 0; i < str.length; ++i) {
            var c = str.charCodeAt(i);

            if (c <= 127) {
              len++;
            } else if (c <= 2047) {
              len += 2;
            } else if (c >= 55296 && c <= 57343) {
              len += 4;
              ++i;
            } else {
              len += 3;
            }
          }

          return len;
        }

        var HEAP8, HEAPU8, HEAP16, HEAPU16, HEAP32, HEAPU32, HEAPF32, HEAPF64;

        function updateMemoryViews() {
          var b = wasmMemory.buffer;
          Module["HEAP8"] = HEAP8 = new Int8Array(b);
          Module["HEAP16"] = HEAP16 = new Int16Array(b);
          Module["HEAP32"] = HEAP32 = new Int32Array(b);
          Module["HEAPU8"] = HEAPU8 = new Uint8Array(b);
          Module["HEAPU16"] = HEAPU16 = new Uint16Array(b);
          Module["HEAPU32"] = HEAPU32 = new Uint32Array(b);
          Module["HEAPF32"] = HEAPF32 = new Float32Array(b);
          Module["HEAPF64"] = HEAPF64 = new Float64Array(b);
        }

        var wasmTable;
        var __ATPRERUN__ = [];
        var __ATINIT__ = [];
        var __ATPOSTRUN__ = [];

        function preRun() {
          if (Module["preRun"]) {
            if (typeof Module["preRun"] == "function") Module["preRun"] = [Module["preRun"]];

            while (Module["preRun"].length) {
              addOnPreRun(Module["preRun"].shift());
            }
          }

          callRuntimeCallbacks(__ATPRERUN__);
        }

        function initRuntime() {
          if (!Module["noFSInit"] && !FS.init.initialized) FS.init();
          FS.ignorePermissions = false;
          TTY.init();
          callRuntimeCallbacks(__ATINIT__);
        }

        function postRun() {
          if (Module["postRun"]) {
            if (typeof Module["postRun"] == "function") Module["postRun"] = [Module["postRun"]];

            while (Module["postRun"].length) {
              addOnPostRun(Module["postRun"].shift());
            }
          }

          callRuntimeCallbacks(__ATPOSTRUN__);
        }

        function addOnPreRun(cb) {
          __ATPRERUN__.unshift(cb);
        }

        function addOnInit(cb) {
          __ATINIT__.unshift(cb);
        }

        function addOnPostRun(cb) {
          __ATPOSTRUN__.unshift(cb);
        }

        var runDependencies = 0;
        var dependenciesFulfilled = null;

        function getUniqueRunDependency(id) {
          return id;
        }

        function addRunDependency(id) {
          runDependencies++;

          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }
        }

        function removeRunDependency(id) {
          runDependencies--;

          if (Module["monitorRunDependencies"]) {
            Module["monitorRunDependencies"](runDependencies);
          }

          if (runDependencies == 0) {
            if (dependenciesFulfilled) {
              var callback = dependenciesFulfilled;
              dependenciesFulfilled = null;
              callback();
            }
          }
        }

        function abort(what) {
          if (Module["onAbort"]) {
            Module["onAbort"](what);
          }

          what = "Aborted(" + what + ")";
          err(what);
          ABORT = true;
          what += ". Build with -sASSERTIONS for more info.";
          var e = new WebAssembly.RuntimeError(what);
          readyPromiseReject(e);
          throw e;
        }

        var dataURIPrefix = "data:application/octet-stream;base64,";

        function isDataURI(filename) {
          return filename.startsWith(dataURIPrefix);
        }

        function isFileURI(filename) {
          return filename.startsWith("file://");
        }

        var wasmBinaryFile;
        wasmBinaryFile = "web-ifc.wasm";

        if (!isDataURI(wasmBinaryFile)) {
          wasmBinaryFile = locateFile(wasmBinaryFile);
        }

        function getBinary(file) {
          try {
            if (file == wasmBinaryFile && wasmBinary) {
              return new Uint8Array(wasmBinary);
            }

            if (readBinary) {
              return readBinary(file);
            }

            throw "both async and sync fetching of the wasm failed";
          } catch (err2) {
            abort(err2);
          }
        }

        function getBinaryPromise() {
          if (!wasmBinary && (ENVIRONMENT_IS_WEB || ENVIRONMENT_IS_WORKER)) {
            if (typeof fetch == "function" && !isFileURI(wasmBinaryFile)) {
              return fetch(wasmBinaryFile, {
                credentials: "same-origin"
              }).then(function (response) {
                if (!response["ok"]) {
                  throw "failed to load wasm binary file at '" + wasmBinaryFile + "'";
                }

                return response["arrayBuffer"]();
              }).catch(function () {
                return getBinary(wasmBinaryFile);
              });
            } else {
              if (readAsync) {
                return new Promise(function (resolve, reject) {
                  readAsync(wasmBinaryFile, function (response) {
                    resolve(new Uint8Array(response));
                  }, reject);
                });
              }
            }
          }

          return Promise.resolve().then(function () {
            return getBinary(wasmBinaryFile);
          });
        }

        function createWasm() {
          var info = {
            "a": wasmImports
          };

          function receiveInstance(instance, module2) {
            var exports3 = instance.exports;
            Module["asm"] = exports3;
            wasmMemory = Module["asm"]["X"];
            updateMemoryViews();
            wasmTable = Module["asm"]["Z"];
            addOnInit(Module["asm"]["Y"]);
            removeRunDependency();
          }

          addRunDependency();

          function receiveInstantiationResult(result) {
            receiveInstance(result["instance"]);
          }

          function instantiateArrayBuffer(receiver) {
            return getBinaryPromise().then(function (binary) {
              return WebAssembly.instantiate(binary, info);
            }).then(function (instance) {
              return instance;
            }).then(receiver, function (reason) {
              err("failed to asynchronously prepare wasm: " + reason);
              abort(reason);
            });
          }

          function instantiateAsync() {
            if (!wasmBinary && typeof WebAssembly.instantiateStreaming == "function" && !isDataURI(wasmBinaryFile) && !isFileURI(wasmBinaryFile) && !ENVIRONMENT_IS_NODE && typeof fetch == "function") {
              return fetch(wasmBinaryFile, {
                credentials: "same-origin"
              }).then(function (response) {
                var result = WebAssembly.instantiateStreaming(response, info);
                return result.then(receiveInstantiationResult, function (reason) {
                  err("wasm streaming compile failed: " + reason);
                  err("falling back to ArrayBuffer instantiation");
                  return instantiateArrayBuffer(receiveInstantiationResult);
                });
              });
            } else {
              return instantiateArrayBuffer(receiveInstantiationResult);
            }
          }

          if (Module["instantiateWasm"]) {
            try {
              var exports2 = Module["instantiateWasm"](info, receiveInstance);
              return exports2;
            } catch (e) {
              err("Module.instantiateWasm callback failed with error: " + e);
              readyPromiseReject(e);
            }
          }

          instantiateAsync().catch(readyPromiseReject);
          return {};
        }

        var tempDouble;
        var tempI64;

        function ExitStatus(status) {
          this.name = "ExitStatus";
          this.message = "Program terminated with exit(" + status + ")";
          this.status = status;
        }

        function callRuntimeCallbacks(callbacks) {
          while (callbacks.length > 0) {
            callbacks.shift()(Module);
          }
        }

        function ExceptionInfo(excPtr) {
          this.excPtr = excPtr;
          this.ptr = excPtr - 24;

          this.set_type = function (type) {
            HEAPU32[this.ptr + 4 >>> 2] = type;
          };

          this.get_type = function () {
            return HEAPU32[this.ptr + 4 >>> 2];
          };

          this.set_destructor = function (destructor) {
            HEAPU32[this.ptr + 8 >>> 2] = destructor;
          };

          this.get_destructor = function () {
            return HEAPU32[this.ptr + 8 >>> 2];
          };

          this.set_refcount = function (refcount) {
            HEAP32[this.ptr >>> 2] = refcount;
          };

          this.set_caught = function (caught) {
            caught = caught ? 1 : 0;
            HEAP8[this.ptr + 12 >>> 0] = caught;
          };

          this.get_caught = function () {
            return HEAP8[this.ptr + 12 >>> 0] != 0;
          };

          this.set_rethrown = function (rethrown) {
            rethrown = rethrown ? 1 : 0;
            HEAP8[this.ptr + 13 >>> 0] = rethrown;
          };

          this.get_rethrown = function () {
            return HEAP8[this.ptr + 13 >>> 0] != 0;
          };

          this.init = function (type, destructor) {
            this.set_adjusted_ptr(0);
            this.set_type(type);
            this.set_destructor(destructor);
            this.set_refcount(0);
            this.set_caught(false);
            this.set_rethrown(false);
          };

          this.add_ref = function () {
            var value = HEAP32[this.ptr >>> 2];
            HEAP32[this.ptr >>> 2] = value + 1;
          };

          this.release_ref = function () {
            var prev = HEAP32[this.ptr >>> 2];
            HEAP32[this.ptr >>> 2] = prev - 1;
            return prev === 1;
          };

          this.set_adjusted_ptr = function (adjustedPtr) {
            HEAPU32[this.ptr + 16 >>> 2] = adjustedPtr;
          };

          this.get_adjusted_ptr = function () {
            return HEAPU32[this.ptr + 16 >>> 2];
          };

          this.get_exception_ptr = function () {
            var isPointer = _cxa_is_pointer_type2(this.get_type());

            if (isPointer) {
              return HEAPU32[this.excPtr >>> 2];
            }

            var adjusted = this.get_adjusted_ptr();
            if (adjusted !== 0) return adjusted;
            return this.excPtr;
          };
        }

        function ___cxa_throw(ptr, type, destructor) {
          var info = new ExceptionInfo(ptr);
          info.init(type, destructor);
          throw ptr;
        }

        function setErrNo(value) {
          HEAP32[_errno_location2() >>> 2] = value;
          return value;
        }

        var PATH = {
          isAbs: function isAbs(path) {
            return path.charAt(0) === "/";
          },
          splitPath: function splitPath(filename) {
            var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
            return splitPathRe.exec(filename).slice(1);
          },
          normalizeArray: function normalizeArray(parts, allowAboveRoot) {
            var up = 0;

            for (var i = parts.length - 1; i >= 0; i--) {
              var last = parts[i];

              if (last === ".") {
                parts.splice(i, 1);
              } else if (last === "..") {
                parts.splice(i, 1);
                up++;
              } else if (up) {
                parts.splice(i, 1);
                up--;
              }
            }

            if (allowAboveRoot) {
              for (; up; up--) {
                parts.unshift("..");
              }
            }

            return parts;
          },
          normalize: function normalize(path) {
            var isAbsolute = PATH.isAbs(path),
                trailingSlash = path.substr(-1) === "/";
            path = PATH.normalizeArray(path.split("/").filter(function (p) {
              return !!p;
            }), !isAbsolute).join("/");

            if (!path && !isAbsolute) {
              path = ".";
            }

            if (path && trailingSlash) {
              path += "/";
            }

            return (isAbsolute ? "/" : "") + path;
          },
          dirname: function dirname(path) {
            var result = PATH.splitPath(path),
                root = result[0],
                dir = result[1];

            if (!root && !dir) {
              return ".";
            }

            if (dir) {
              dir = dir.substr(0, dir.length - 1);
            }

            return root + dir;
          },
          basename: function basename(path) {
            if (path === "/") return "/";
            path = PATH.normalize(path);
            path = path.replace(/\/$/, "");
            var lastSlash = path.lastIndexOf("/");
            if (lastSlash === -1) return path;
            return path.substr(lastSlash + 1);
          },
          join: function join() {
            var paths = Array.prototype.slice.call(arguments);
            return PATH.normalize(paths.join("/"));
          },
          join2: function join2(l, r) {
            return PATH.normalize(l + "/" + r);
          }
        };

        function getRandomDevice() {
          if (typeof crypto == "object" && typeof crypto["getRandomValues"] == "function") {
            var randomBuffer = new Uint8Array(1);
            return function () {
              crypto.getRandomValues(randomBuffer);
              return randomBuffer[0];
            };
          } else if (ENVIRONMENT_IS_NODE) {
            try {
              var crypto_module = require_crypto();
              return function () {
                return crypto_module["randomBytes"](1)[0];
              };
            } catch (e) {}
          }

          return function () {
            return abort("randomDevice");
          };
        }

        var PATH_FS = {
          resolve: function resolve() {
            var resolvedPath = "",
                resolvedAbsolute = false;

            for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
              var path = i >= 0 ? arguments[i] : FS.cwd();

              if (typeof path != "string") {
                throw new TypeError("Arguments to path.resolve must be strings");
              } else if (!path) {
                return "";
              }

              resolvedPath = path + "/" + resolvedPath;
              resolvedAbsolute = PATH.isAbs(path);
            }

            resolvedPath = PATH.normalizeArray(resolvedPath.split("/").filter(function (p) {
              return !!p;
            }), !resolvedAbsolute).join("/");
            return (resolvedAbsolute ? "/" : "") + resolvedPath || ".";
          },
          relative: function relative(from, to) {
            from = PATH_FS.resolve(from).substr(1);
            to = PATH_FS.resolve(to).substr(1);

            function trim(arr) {
              var start = 0;

              for (; start < arr.length; start++) {
                if (arr[start] !== "") break;
              }

              var end = arr.length - 1;

              for (; end >= 0; end--) {
                if (arr[end] !== "") break;
              }

              if (start > end) return [];
              return arr.slice(start, end - start + 1);
            }

            var fromParts = trim(from.split("/"));
            var toParts = trim(to.split("/"));
            var length = Math.min(fromParts.length, toParts.length);
            var samePartsLength = length;

            for (var i = 0; i < length; i++) {
              if (fromParts[i] !== toParts[i]) {
                samePartsLength = i;
                break;
              }
            }

            var outputParts = [];

            for (var i = samePartsLength; i < fromParts.length; i++) {
              outputParts.push("..");
            }

            outputParts = outputParts.concat(toParts.slice(samePartsLength));
            return outputParts.join("/");
          }
        };

        function intArrayFromString(stringy, dontAddNull, length) {
          var len = length > 0 ? length : lengthBytesUTF8(stringy) + 1;
          var u8array = new Array(len);
          var numBytesWritten = stringToUTF8Array(stringy, u8array, 0, u8array.length);
          if (dontAddNull) u8array.length = numBytesWritten;
          return u8array;
        }

        var TTY = {
          ttys: [],
          init: function init() {},
          shutdown: function shutdown() {},
          register: function register(dev, ops) {
            TTY.ttys[dev] = {
              input: [],
              output: [],
              ops: ops
            };
            FS.registerDevice(dev, TTY.stream_ops);
          },
          stream_ops: {
            open: function open(stream) {
              var tty = TTY.ttys[stream.node.rdev];

              if (!tty) {
                throw new FS.ErrnoError(43);
              }

              stream.tty = tty;
              stream.seekable = false;
            },
            close: function close(stream) {
              stream.tty.ops.fsync(stream.tty);
            },
            fsync: function fsync(stream) {
              stream.tty.ops.fsync(stream.tty);
            },
            read: function read(stream, buffer, offset, length, pos) {
              if (!stream.tty || !stream.tty.ops.get_char) {
                throw new FS.ErrnoError(60);
              }

              var bytesRead = 0;

              for (var i = 0; i < length; i++) {
                var result;

                try {
                  result = stream.tty.ops.get_char(stream.tty);
                } catch (e) {
                  throw new FS.ErrnoError(29);
                }

                if (result === void 0 && bytesRead === 0) {
                  throw new FS.ErrnoError(6);
                }

                if (result === null || result === void 0) break;
                bytesRead++;
                buffer[offset + i] = result;
              }

              if (bytesRead) {
                stream.node.timestamp = Date.now();
              }

              return bytesRead;
            },
            write: function write(stream, buffer, offset, length, pos) {
              if (!stream.tty || !stream.tty.ops.put_char) {
                throw new FS.ErrnoError(60);
              }

              try {
                for (var i = 0; i < length; i++) {
                  stream.tty.ops.put_char(stream.tty, buffer[offset + i]);
                }
              } catch (e) {
                throw new FS.ErrnoError(29);
              }

              if (length) {
                stream.node.timestamp = Date.now();
              }

              return i;
            }
          },
          default_tty_ops: {
            get_char: function get_char(tty) {
              if (!tty.input.length) {
                var result = null;

                if (ENVIRONMENT_IS_NODE) {
                  var BUFSIZE = 256;
                  var buf = Buffer.alloc(BUFSIZE);
                  var bytesRead = 0;

                  try {
                    bytesRead = fs.readSync(process.stdin.fd, buf, 0, BUFSIZE, -1);
                  } catch (e) {
                    if (e.toString().includes("EOF")) bytesRead = 0;else throw e;
                  }

                  if (bytesRead > 0) {
                    result = buf.slice(0, bytesRead).toString("utf-8");
                  } else {
                    result = null;
                  }
                } else if (typeof window != "undefined" && typeof window.prompt == "function") {
                  result = window.prompt("Input: ");

                  if (result !== null) {
                    result += "\n";
                  }
                } else if (typeof readline == "function") {
                  result = readline();

                  if (result !== null) {
                    result += "\n";
                  }
                }

                if (!result) {
                  return null;
                }

                tty.input = intArrayFromString(result, true);
              }

              return tty.input.shift();
            },
            put_char: function put_char(tty, val) {
              if (val === null || val === 10) {
                out(UTF8ArrayToString(tty.output, 0));
                tty.output = [];
              } else {
                if (val != 0) tty.output.push(val);
              }
            },
            fsync: function fsync(tty) {
              if (tty.output && tty.output.length > 0) {
                out(UTF8ArrayToString(tty.output, 0));
                tty.output = [];
              }
            }
          },
          default_tty1_ops: {
            put_char: function put_char(tty, val) {
              if (val === null || val === 10) {
                err(UTF8ArrayToString(tty.output, 0));
                tty.output = [];
              } else {
                if (val != 0) tty.output.push(val);
              }
            },
            fsync: function fsync(tty) {
              if (tty.output && tty.output.length > 0) {
                err(UTF8ArrayToString(tty.output, 0));
                tty.output = [];
              }
            }
          }
        };

        function mmapAlloc(size) {
          abort();
        }

        var MEMFS = {
          ops_table: null,
          mount: function mount(_mount2) {
            return MEMFS.createNode(null, "/", 16384 | 511, 0);
          },
          createNode: function createNode(parent, name, mode, dev) {
            if (FS.isBlkdev(mode) || FS.isFIFO(mode)) {
              throw new FS.ErrnoError(63);
            }

            if (!MEMFS.ops_table) {
              MEMFS.ops_table = {
                dir: {
                  node: {
                    getattr: MEMFS.node_ops.getattr,
                    setattr: MEMFS.node_ops.setattr,
                    lookup: MEMFS.node_ops.lookup,
                    mknod: MEMFS.node_ops.mknod,
                    rename: MEMFS.node_ops.rename,
                    unlink: MEMFS.node_ops.unlink,
                    rmdir: MEMFS.node_ops.rmdir,
                    readdir: MEMFS.node_ops.readdir,
                    symlink: MEMFS.node_ops.symlink
                  },
                  stream: {
                    llseek: MEMFS.stream_ops.llseek
                  }
                },
                file: {
                  node: {
                    getattr: MEMFS.node_ops.getattr,
                    setattr: MEMFS.node_ops.setattr
                  },
                  stream: {
                    llseek: MEMFS.stream_ops.llseek,
                    read: MEMFS.stream_ops.read,
                    write: MEMFS.stream_ops.write,
                    allocate: MEMFS.stream_ops.allocate,
                    mmap: MEMFS.stream_ops.mmap,
                    msync: MEMFS.stream_ops.msync
                  }
                },
                link: {
                  node: {
                    getattr: MEMFS.node_ops.getattr,
                    setattr: MEMFS.node_ops.setattr,
                    readlink: MEMFS.node_ops.readlink
                  },
                  stream: {}
                },
                chrdev: {
                  node: {
                    getattr: MEMFS.node_ops.getattr,
                    setattr: MEMFS.node_ops.setattr
                  },
                  stream: FS.chrdev_stream_ops
                }
              };
            }

            var node = FS.createNode(parent, name, mode, dev);

            if (FS.isDir(node.mode)) {
              node.node_ops = MEMFS.ops_table.dir.node;
              node.stream_ops = MEMFS.ops_table.dir.stream;
              node.contents = {};
            } else if (FS.isFile(node.mode)) {
              node.node_ops = MEMFS.ops_table.file.node;
              node.stream_ops = MEMFS.ops_table.file.stream;
              node.usedBytes = 0;
              node.contents = null;
            } else if (FS.isLink(node.mode)) {
              node.node_ops = MEMFS.ops_table.link.node;
              node.stream_ops = MEMFS.ops_table.link.stream;
            } else if (FS.isChrdev(node.mode)) {
              node.node_ops = MEMFS.ops_table.chrdev.node;
              node.stream_ops = MEMFS.ops_table.chrdev.stream;
            }

            node.timestamp = Date.now();

            if (parent) {
              parent.contents[name] = node;
              parent.timestamp = node.timestamp;
            }

            return node;
          },
          getFileDataAsTypedArray: function getFileDataAsTypedArray(node) {
            if (!node.contents) return new Uint8Array(0);
            if (node.contents.subarray) return node.contents.subarray(0, node.usedBytes);
            return new Uint8Array(node.contents);
          },
          expandFileStorage: function expandFileStorage(node, newCapacity) {
            newCapacity >>>= 0;
            var prevCapacity = node.contents ? node.contents.length : 0;
            if (prevCapacity >= newCapacity) return;
            var CAPACITY_DOUBLING_MAX = 1024 * 1024;
            newCapacity = Math.max(newCapacity, prevCapacity * (prevCapacity < CAPACITY_DOUBLING_MAX ? 2 : 1.125) >>> 0);
            if (prevCapacity != 0) newCapacity = Math.max(newCapacity, 256);
            var oldContents = node.contents;
            node.contents = new Uint8Array(newCapacity);
            if (node.usedBytes > 0) node.contents.set(oldContents.subarray(0, node.usedBytes), 0);
          },
          resizeFileStorage: function resizeFileStorage(node, newSize) {
            newSize >>>= 0;
            if (node.usedBytes == newSize) return;

            if (newSize == 0) {
              node.contents = null;
              node.usedBytes = 0;
            } else {
              var oldContents = node.contents;
              node.contents = new Uint8Array(newSize);

              if (oldContents) {
                node.contents.set(oldContents.subarray(0, Math.min(newSize, node.usedBytes)));
              }

              node.usedBytes = newSize;
            }
          },
          node_ops: {
            getattr: function getattr(node) {
              var attr = {};
              attr.dev = FS.isChrdev(node.mode) ? node.id : 1;
              attr.ino = node.id;
              attr.mode = node.mode;
              attr.nlink = 1;
              attr.uid = 0;
              attr.gid = 0;
              attr.rdev = node.rdev;

              if (FS.isDir(node.mode)) {
                attr.size = 4096;
              } else if (FS.isFile(node.mode)) {
                attr.size = node.usedBytes;
              } else if (FS.isLink(node.mode)) {
                attr.size = node.link.length;
              } else {
                attr.size = 0;
              }

              attr.atime = new Date(node.timestamp);
              attr.mtime = new Date(node.timestamp);
              attr.ctime = new Date(node.timestamp);
              attr.blksize = 4096;
              attr.blocks = Math.ceil(attr.size / attr.blksize);
              return attr;
            },
            setattr: function setattr(node, attr) {
              if (attr.mode !== void 0) {
                node.mode = attr.mode;
              }

              if (attr.timestamp !== void 0) {
                node.timestamp = attr.timestamp;
              }

              if (attr.size !== void 0) {
                MEMFS.resizeFileStorage(node, attr.size);
              }
            },
            lookup: function lookup(parent, name) {
              throw FS.genericErrors[44];
            },
            mknod: function mknod(parent, name, mode, dev) {
              return MEMFS.createNode(parent, name, mode, dev);
            },
            rename: function rename(old_node, new_dir, new_name) {
              if (FS.isDir(old_node.mode)) {
                var new_node;

                try {
                  new_node = FS.lookupNode(new_dir, new_name);
                } catch (e) {}

                if (new_node) {
                  for (var i in new_node.contents) {
                    throw new FS.ErrnoError(55);
                  }
                }
              }

              delete old_node.parent.contents[old_node.name];
              old_node.parent.timestamp = Date.now();
              old_node.name = new_name;
              new_dir.contents[new_name] = old_node;
              new_dir.timestamp = old_node.parent.timestamp;
              old_node.parent = new_dir;
            },
            unlink: function unlink(parent, name) {
              delete parent.contents[name];
              parent.timestamp = Date.now();
            },
            rmdir: function rmdir(parent, name) {
              var node = FS.lookupNode(parent, name);

              for (var i in node.contents) {
                throw new FS.ErrnoError(55);
              }

              delete parent.contents[name];
              parent.timestamp = Date.now();
            },
            readdir: function readdir(node) {
              var entries = [".", ".."];

              for (var key in node.contents) {
                if (!node.contents.hasOwnProperty(key)) {
                  continue;
                }

                entries.push(key);
              }

              return entries;
            },
            symlink: function symlink(parent, newname, oldpath) {
              var node = MEMFS.createNode(parent, newname, 511 | 40960, 0);
              node.link = oldpath;
              return node;
            },
            readlink: function readlink(node) {
              if (!FS.isLink(node.mode)) {
                throw new FS.ErrnoError(28);
              }

              return node.link;
            }
          },
          stream_ops: {
            read: function read(stream, buffer, offset, length, position) {
              var contents = stream.node.contents;
              if (position >= stream.node.usedBytes) return 0;
              var size = Math.min(stream.node.usedBytes - position, length);

              if (size > 8 && contents.subarray) {
                buffer.set(contents.subarray(position, position + size), offset);
              } else {
                for (var i = 0; i < size; i++) {
                  buffer[offset + i] = contents[position + i];
                }
              }

              return size;
            },
            write: function write(stream, buffer, offset, length, position, canOwn) {
              if (buffer.buffer === HEAP8.buffer) {
                canOwn = false;
              }

              if (!length) return 0;
              var node = stream.node;
              node.timestamp = Date.now();

              if (buffer.subarray && (!node.contents || node.contents.subarray)) {
                if (canOwn) {
                  node.contents = buffer.subarray(offset, offset + length);
                  node.usedBytes = length;
                  return length;
                } else if (node.usedBytes === 0 && position === 0) {
                  node.contents = buffer.slice(offset, offset + length);
                  node.usedBytes = length;
                  return length;
                } else if (position + length <= node.usedBytes) {
                  node.contents.set(buffer.subarray(offset, offset + length), position);
                  return length;
                }
              }

              MEMFS.expandFileStorage(node, position + length);

              if (node.contents.subarray && buffer.subarray) {
                node.contents.set(buffer.subarray(offset, offset + length), position);
              } else {
                for (var i = 0; i < length; i++) {
                  node.contents[position + i] = buffer[offset + i];
                }
              }

              node.usedBytes = Math.max(node.usedBytes, position + length);
              return length;
            },
            llseek: function llseek(stream, offset, whence) {
              var position = offset;

              if (whence === 1) {
                position += stream.position;
              } else if (whence === 2) {
                if (FS.isFile(stream.node.mode)) {
                  position += stream.node.usedBytes;
                }
              }

              if (position < 0) {
                throw new FS.ErrnoError(28);
              }

              return position;
            },
            allocate: function allocate(stream, offset, length) {
              MEMFS.expandFileStorage(stream.node, offset + length);
              stream.node.usedBytes = Math.max(stream.node.usedBytes, offset + length);
            },
            mmap: function mmap(stream, length, position, prot, flags) {
              if (!FS.isFile(stream.node.mode)) {
                throw new FS.ErrnoError(43);
              }

              var ptr;
              var allocated;
              var contents = stream.node.contents;

              if (!(flags & 2) && contents.buffer === HEAP8.buffer) {
                allocated = false;
                ptr = contents.byteOffset;
              } else {
                if (position > 0 || position + length < contents.length) {
                  if (contents.subarray) {
                    contents = contents.subarray(position, position + length);
                  } else {
                    contents = Array.prototype.slice.call(contents, position, position + length);
                  }
                }

                allocated = true;
                ptr = mmapAlloc();

                if (!ptr) {
                  throw new FS.ErrnoError(48);
                }

                ptr >>>= 0;
                HEAP8.set(contents, ptr >>> 0);
              }

              return {
                ptr: ptr,
                allocated: allocated
              };
            },
            msync: function msync(stream, buffer, offset, length, mmapFlags) {
              MEMFS.stream_ops.write(stream, buffer, 0, length, offset, false);
              return 0;
            }
          }
        };

        function asyncLoad(url, onload, onerror, noRunDep) {
          var dep = !noRunDep ? getUniqueRunDependency("al " + url) : "";
          readAsync(url, function (arrayBuffer) {
            assert(arrayBuffer, 'Loading data file "' + url + '" failed (no arrayBuffer).');
            onload(new Uint8Array(arrayBuffer));
            if (dep) removeRunDependency();
          }, function (event) {
            if (onerror) {
              onerror();
            } else {
              throw 'Loading data file "' + url + '" failed.';
            }
          });
          if (dep) addRunDependency();
        }

        var FS = {
          root: null,
          mounts: [],
          devices: {},
          streams: [],
          nextInode: 1,
          nameTable: null,
          currentPath: "/",
          initialized: false,
          ignorePermissions: true,
          ErrnoError: null,
          genericErrors: {},
          filesystems: null,
          syncFSRequests: 0,
          lookupPath: function lookupPath(path) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            path = PATH_FS.resolve(path);
            if (!path) return {
              path: "",
              node: null
            };
            var defaults = {
              follow_mount: true,
              recurse_count: 0
            };
            opts = Object.assign(defaults, opts);

            if (opts.recurse_count > 8) {
              throw new FS.ErrnoError(32);
            }

            var parts = path.split("/").filter(function (p) {
              return !!p;
            });
            var current = FS.root;
            var current_path = "/";

            for (var i = 0; i < parts.length; i++) {
              var islast = i === parts.length - 1;

              if (islast && opts.parent) {
                break;
              }

              current = FS.lookupNode(current, parts[i]);
              current_path = PATH.join2(current_path, parts[i]);

              if (FS.isMountpoint(current)) {
                if (!islast || islast && opts.follow_mount) {
                  current = current.mounted.root;
                }
              }

              if (!islast || opts.follow) {
                var count = 0;

                while (FS.isLink(current.mode)) {
                  var link = FS.readlink(current_path);
                  current_path = PATH_FS.resolve(PATH.dirname(current_path), link);
                  var lookup = FS.lookupPath(current_path, {
                    recurse_count: opts.recurse_count + 1
                  });
                  current = lookup.node;

                  if (count++ > 40) {
                    throw new FS.ErrnoError(32);
                  }
                }
              }
            }

            return {
              path: current_path,
              node: current
            };
          },
          getPath: function getPath(node) {
            var path;

            while (true) {
              if (FS.isRoot(node)) {
                var mount = node.mount.mountpoint;
                if (!path) return mount;
                return mount[mount.length - 1] !== "/" ? mount + "/" + path : mount + path;
              }

              path = path ? node.name + "/" + path : node.name;
              node = node.parent;
            }
          },
          hashName: function hashName(parentid, name) {
            var hash = 0;

            for (var i = 0; i < name.length; i++) {
              hash = (hash << 5) - hash + name.charCodeAt(i) | 0;
            }

            return (parentid + hash >>> 0) % FS.nameTable.length;
          },
          hashAddNode: function hashAddNode(node) {
            var hash = FS.hashName(node.parent.id, node.name);
            node.name_next = FS.nameTable[hash];
            FS.nameTable[hash] = node;
          },
          hashRemoveNode: function hashRemoveNode(node) {
            var hash = FS.hashName(node.parent.id, node.name);

            if (FS.nameTable[hash] === node) {
              FS.nameTable[hash] = node.name_next;
            } else {
              var current = FS.nameTable[hash];

              while (current) {
                if (current.name_next === node) {
                  current.name_next = node.name_next;
                  break;
                }

                current = current.name_next;
              }
            }
          },
          lookupNode: function lookupNode(parent, name) {
            var errCode = FS.mayLookup(parent);

            if (errCode) {
              throw new FS.ErrnoError(errCode, parent);
            }

            var hash = FS.hashName(parent.id, name);

            for (var node = FS.nameTable[hash]; node; node = node.name_next) {
              var nodeName = node.name;

              if (node.parent.id === parent.id && nodeName === name) {
                return node;
              }
            }

            return FS.lookup(parent, name);
          },
          createNode: function createNode(parent, name, mode, rdev) {
            var node = new FS.FSNode(parent, name, mode, rdev);
            FS.hashAddNode(node);
            return node;
          },
          destroyNode: function destroyNode(node) {
            FS.hashRemoveNode(node);
          },
          isRoot: function isRoot(node) {
            return node === node.parent;
          },
          isMountpoint: function isMountpoint(node) {
            return !!node.mounted;
          },
          isFile: function isFile(mode) {
            return (mode & 61440) === 32768;
          },
          isDir: function isDir(mode) {
            return (mode & 61440) === 16384;
          },
          isLink: function isLink(mode) {
            return (mode & 61440) === 40960;
          },
          isChrdev: function isChrdev(mode) {
            return (mode & 61440) === 8192;
          },
          isBlkdev: function isBlkdev(mode) {
            return (mode & 61440) === 24576;
          },
          isFIFO: function isFIFO(mode) {
            return (mode & 61440) === 4096;
          },
          isSocket: function isSocket(mode) {
            return (mode & 49152) === 49152;
          },
          flagModes: {
            "r": 0,
            "r+": 2,
            "w": 577,
            "w+": 578,
            "a": 1089,
            "a+": 1090
          },
          modeStringToFlags: function modeStringToFlags(str) {
            var flags = FS.flagModes[str];

            if (typeof flags == "undefined") {
              throw new Error("Unknown file open mode: " + str);
            }

            return flags;
          },
          flagsToPermissionString: function flagsToPermissionString(flag) {
            var perms = ["r", "w", "rw"][flag & 3];

            if (flag & 512) {
              perms += "w";
            }

            return perms;
          },
          nodePermissions: function nodePermissions(node, perms) {
            if (FS.ignorePermissions) {
              return 0;
            }

            if (perms.includes("r") && !(node.mode & 292)) {
              return 2;
            } else if (perms.includes("w") && !(node.mode & 146)) {
              return 2;
            } else if (perms.includes("x") && !(node.mode & 73)) {
              return 2;
            }

            return 0;
          },
          mayLookup: function mayLookup(dir) {
            var errCode = FS.nodePermissions(dir, "x");
            if (errCode) return errCode;
            if (!dir.node_ops.lookup) return 2;
            return 0;
          },
          mayCreate: function mayCreate(dir, name) {
            try {
              var node = FS.lookupNode(dir, name);
              return 20;
            } catch (e) {}

            return FS.nodePermissions(dir, "wx");
          },
          mayDelete: function mayDelete(dir, name, isdir) {
            var node;

            try {
              node = FS.lookupNode(dir, name);
            } catch (e) {
              return e.errno;
            }

            var errCode = FS.nodePermissions(dir, "wx");

            if (errCode) {
              return errCode;
            }

            if (isdir) {
              if (!FS.isDir(node.mode)) {
                return 54;
              }

              if (FS.isRoot(node) || FS.getPath(node) === FS.cwd()) {
                return 10;
              }
            } else {
              if (FS.isDir(node.mode)) {
                return 31;
              }
            }

            return 0;
          },
          mayOpen: function mayOpen(node, flags) {
            if (!node) {
              return 44;
            }

            if (FS.isLink(node.mode)) {
              return 32;
            } else if (FS.isDir(node.mode)) {
              if (FS.flagsToPermissionString(flags) !== "r" || flags & 512) {
                return 31;
              }
            }

            return FS.nodePermissions(node, FS.flagsToPermissionString(flags));
          },
          MAX_OPEN_FDS: 4096,
          nextfd: function nextfd() {
            var fd_start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            var fd_end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : FS.MAX_OPEN_FDS;

            for (var fd = fd_start; fd <= fd_end; fd++) {
              if (!FS.streams[fd]) {
                return fd;
              }
            }

            throw new FS.ErrnoError(33);
          },
          getStream: function getStream(fd) {
            return FS.streams[fd];
          },
          createStream: function createStream(stream, fd_start, fd_end) {
            if (!FS.FSStream) {
              FS.FSStream = function () {
                this.shared = {};
              };

              FS.FSStream.prototype = {};
              Object.defineProperties(FS.FSStream.prototype, {
                object: {
                  get: function get() {
                    return this.node;
                  },
                  set: function set(val) {
                    this.node = val;
                  }
                },
                isRead: {
                  get: function get() {
                    return (this.flags & 2097155) !== 1;
                  }
                },
                isWrite: {
                  get: function get() {
                    return (this.flags & 2097155) !== 0;
                  }
                },
                isAppend: {
                  get: function get() {
                    return this.flags & 1024;
                  }
                },
                flags: {
                  get: function get() {
                    return this.shared.flags;
                  },
                  set: function set(val) {
                    this.shared.flags = val;
                  }
                },
                position: {
                  get: function get() {
                    return this.shared.position;
                  },
                  set: function set(val) {
                    this.shared.position = val;
                  }
                }
              });
            }

            stream = Object.assign(new FS.FSStream(), stream);
            var fd = FS.nextfd(fd_start, fd_end);
            stream.fd = fd;
            FS.streams[fd] = stream;
            return stream;
          },
          closeStream: function closeStream(fd) {
            FS.streams[fd] = null;
          },
          chrdev_stream_ops: {
            open: function open(stream) {
              var device = FS.getDevice(stream.node.rdev);
              stream.stream_ops = device.stream_ops;

              if (stream.stream_ops.open) {
                stream.stream_ops.open(stream);
              }
            },
            llseek: function llseek() {
              throw new FS.ErrnoError(70);
            }
          },
          major: function major(dev) {
            return dev >> 8;
          },
          minor: function minor(dev) {
            return dev & 255;
          },
          makedev: function makedev(ma, mi) {
            return ma << 8 | mi;
          },
          registerDevice: function registerDevice(dev, ops) {
            FS.devices[dev] = {
              stream_ops: ops
            };
          },
          getDevice: function getDevice(dev) {
            return FS.devices[dev];
          },
          getMounts: function getMounts(mount) {
            var mounts = [];
            var check = [mount];

            while (check.length) {
              var m = check.pop();
              mounts.push(m);
              check.push.apply(check, m.mounts);
            }

            return mounts;
          },
          syncfs: function syncfs(populate, callback) {
            if (typeof populate == "function") {
              callback = populate;
              populate = false;
            }

            FS.syncFSRequests++;

            if (FS.syncFSRequests > 1) {
              err("warning: " + FS.syncFSRequests + " FS.syncfs operations in flight at once, probably just doing extra work");
            }

            var mounts = FS.getMounts(FS.root.mount);
            var completed = 0;

            function doCallback(errCode) {
              FS.syncFSRequests--;
              return callback(errCode);
            }

            function done(errCode) {
              if (errCode) {
                if (!done.errored) {
                  done.errored = true;
                  return doCallback(errCode);
                }

                return;
              }

              if (++completed >= mounts.length) {
                doCallback(null);
              }
            }

            mounts.forEach(function (mount) {
              if (!mount.type.syncfs) {
                return done(null);
              }

              mount.type.syncfs(mount, populate, done);
            });
          },
          mount: function mount(type, opts, mountpoint) {
            var root = mountpoint === "/";
            var pseudo = !mountpoint;
            var node;

            if (root && FS.root) {
              throw new FS.ErrnoError(10);
            } else if (!root && !pseudo) {
              var lookup = FS.lookupPath(mountpoint, {
                follow_mount: false
              });
              mountpoint = lookup.path;
              node = lookup.node;

              if (FS.isMountpoint(node)) {
                throw new FS.ErrnoError(10);
              }

              if (!FS.isDir(node.mode)) {
                throw new FS.ErrnoError(54);
              }
            }

            var mount = {
              type: type,
              opts: opts,
              mountpoint: mountpoint,
              mounts: []
            };
            var mountRoot = type.mount(mount);
            mountRoot.mount = mount;
            mount.root = mountRoot;

            if (root) {
              FS.root = mountRoot;
            } else if (node) {
              node.mounted = mount;

              if (node.mount) {
                node.mount.mounts.push(mount);
              }
            }

            return mountRoot;
          },
          unmount: function unmount(mountpoint) {
            var lookup = FS.lookupPath(mountpoint, {
              follow_mount: false
            });

            if (!FS.isMountpoint(lookup.node)) {
              throw new FS.ErrnoError(28);
            }

            var node = lookup.node;
            var mount = node.mounted;
            var mounts = FS.getMounts(mount);
            Object.keys(FS.nameTable).forEach(function (hash) {
              var current = FS.nameTable[hash];

              while (current) {
                var next = current.name_next;

                if (mounts.includes(current.mount)) {
                  FS.destroyNode(current);
                }

                current = next;
              }
            });
            node.mounted = null;
            var idx = node.mount.mounts.indexOf(mount);
            node.mount.mounts.splice(idx, 1);
          },
          lookup: function lookup(parent, name) {
            return parent.node_ops.lookup(parent, name);
          },
          mknod: function mknod(path, mode, dev) {
            var lookup = FS.lookupPath(path, {
              parent: true
            });
            var parent = lookup.node;
            var name = PATH.basename(path);

            if (!name || name === "." || name === "..") {
              throw new FS.ErrnoError(28);
            }

            var errCode = FS.mayCreate(parent, name);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            if (!parent.node_ops.mknod) {
              throw new FS.ErrnoError(63);
            }

            return parent.node_ops.mknod(parent, name, mode, dev);
          },
          create: function create(path, mode) {
            mode = mode !== void 0 ? mode : 438;
            mode &= 4095;
            mode |= 32768;
            return FS.mknod(path, mode, 0);
          },
          mkdir: function mkdir(path, mode) {
            mode = mode !== void 0 ? mode : 511;
            mode &= 511 | 512;
            mode |= 16384;
            return FS.mknod(path, mode, 0);
          },
          mkdirTree: function mkdirTree(path, mode) {
            var dirs = path.split("/");
            var d = "";

            for (var i = 0; i < dirs.length; ++i) {
              if (!dirs[i]) continue;
              d += "/" + dirs[i];

              try {
                FS.mkdir(d, mode);
              } catch (e) {
                if (e.errno != 20) throw e;
              }
            }
          },
          mkdev: function mkdev(path, mode, dev) {
            if (typeof dev == "undefined") {
              dev = mode;
              mode = 438;
            }

            mode |= 8192;
            return FS.mknod(path, mode, dev);
          },
          symlink: function symlink(oldpath, newpath) {
            if (!PATH_FS.resolve(oldpath)) {
              throw new FS.ErrnoError(44);
            }

            var lookup = FS.lookupPath(newpath, {
              parent: true
            });
            var parent = lookup.node;

            if (!parent) {
              throw new FS.ErrnoError(44);
            }

            var newname = PATH.basename(newpath);
            var errCode = FS.mayCreate(parent, newname);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            if (!parent.node_ops.symlink) {
              throw new FS.ErrnoError(63);
            }

            return parent.node_ops.symlink(parent, newname, oldpath);
          },
          rename: function rename(old_path, new_path) {
            var old_dirname = PATH.dirname(old_path);
            var new_dirname = PATH.dirname(new_path);
            var old_name = PATH.basename(old_path);
            var new_name = PATH.basename(new_path);
            var lookup, old_dir, new_dir;
            lookup = FS.lookupPath(old_path, {
              parent: true
            });
            old_dir = lookup.node;
            lookup = FS.lookupPath(new_path, {
              parent: true
            });
            new_dir = lookup.node;
            if (!old_dir || !new_dir) throw new FS.ErrnoError(44);

            if (old_dir.mount !== new_dir.mount) {
              throw new FS.ErrnoError(75);
            }

            var old_node = FS.lookupNode(old_dir, old_name);
            var relative = PATH_FS.relative(old_path, new_dirname);

            if (relative.charAt(0) !== ".") {
              throw new FS.ErrnoError(28);
            }

            relative = PATH_FS.relative(new_path, old_dirname);

            if (relative.charAt(0) !== ".") {
              throw new FS.ErrnoError(55);
            }

            var new_node;

            try {
              new_node = FS.lookupNode(new_dir, new_name);
            } catch (e) {}

            if (old_node === new_node) {
              return;
            }

            var isdir = FS.isDir(old_node.mode);
            var errCode = FS.mayDelete(old_dir, old_name, isdir);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            errCode = new_node ? FS.mayDelete(new_dir, new_name, isdir) : FS.mayCreate(new_dir, new_name);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            if (!old_dir.node_ops.rename) {
              throw new FS.ErrnoError(63);
            }

            if (FS.isMountpoint(old_node) || new_node && FS.isMountpoint(new_node)) {
              throw new FS.ErrnoError(10);
            }

            if (new_dir !== old_dir) {
              errCode = FS.nodePermissions(old_dir, "w");

              if (errCode) {
                throw new FS.ErrnoError(errCode);
              }
            }

            FS.hashRemoveNode(old_node);

            try {
              old_dir.node_ops.rename(old_node, new_dir, new_name);
            } catch (e) {
              throw e;
            } finally {
              FS.hashAddNode(old_node);
            }
          },
          rmdir: function rmdir(path) {
            var lookup = FS.lookupPath(path, {
              parent: true
            });
            var parent = lookup.node;
            var name = PATH.basename(path);
            var node = FS.lookupNode(parent, name);
            var errCode = FS.mayDelete(parent, name, true);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            if (!parent.node_ops.rmdir) {
              throw new FS.ErrnoError(63);
            }

            if (FS.isMountpoint(node)) {
              throw new FS.ErrnoError(10);
            }

            parent.node_ops.rmdir(parent, name);
            FS.destroyNode(node);
          },
          readdir: function readdir(path) {
            var lookup = FS.lookupPath(path, {
              follow: true
            });
            var node = lookup.node;

            if (!node.node_ops.readdir) {
              throw new FS.ErrnoError(54);
            }

            return node.node_ops.readdir(node);
          },
          unlink: function unlink(path) {
            var lookup = FS.lookupPath(path, {
              parent: true
            });
            var parent = lookup.node;

            if (!parent) {
              throw new FS.ErrnoError(44);
            }

            var name = PATH.basename(path);
            var node = FS.lookupNode(parent, name);
            var errCode = FS.mayDelete(parent, name, false);

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            if (!parent.node_ops.unlink) {
              throw new FS.ErrnoError(63);
            }

            if (FS.isMountpoint(node)) {
              throw new FS.ErrnoError(10);
            }

            parent.node_ops.unlink(parent, name);
            FS.destroyNode(node);
          },
          readlink: function readlink(path) {
            var lookup = FS.lookupPath(path);
            var link = lookup.node;

            if (!link) {
              throw new FS.ErrnoError(44);
            }

            if (!link.node_ops.readlink) {
              throw new FS.ErrnoError(28);
            }

            return PATH_FS.resolve(FS.getPath(link.parent), link.node_ops.readlink(link));
          },
          stat: function stat(path, dontFollow) {
            var lookup = FS.lookupPath(path, {
              follow: !dontFollow
            });
            var node = lookup.node;

            if (!node) {
              throw new FS.ErrnoError(44);
            }

            if (!node.node_ops.getattr) {
              throw new FS.ErrnoError(63);
            }

            return node.node_ops.getattr(node);
          },
          lstat: function lstat(path) {
            return FS.stat(path, true);
          },
          chmod: function chmod(path, mode, dontFollow) {
            var node;

            if (typeof path == "string") {
              var lookup = FS.lookupPath(path, {
                follow: !dontFollow
              });
              node = lookup.node;
            } else {
              node = path;
            }

            if (!node.node_ops.setattr) {
              throw new FS.ErrnoError(63);
            }

            node.node_ops.setattr(node, {
              mode: mode & 4095 | node.mode & ~4095,
              timestamp: Date.now()
            });
          },
          lchmod: function lchmod(path, mode) {
            FS.chmod(path, mode, true);
          },
          fchmod: function fchmod(fd, mode) {
            var stream = FS.getStream(fd);

            if (!stream) {
              throw new FS.ErrnoError(8);
            }

            FS.chmod(stream.node, mode);
          },
          chown: function chown(path, uid, gid, dontFollow) {
            var node;

            if (typeof path == "string") {
              var lookup = FS.lookupPath(path, {
                follow: !dontFollow
              });
              node = lookup.node;
            } else {
              node = path;
            }

            if (!node.node_ops.setattr) {
              throw new FS.ErrnoError(63);
            }

            node.node_ops.setattr(node, {
              timestamp: Date.now()
            });
          },
          lchown: function lchown(path, uid, gid) {
            FS.chown(path, uid, gid, true);
          },
          fchown: function fchown(fd, uid, gid) {
            var stream = FS.getStream(fd);

            if (!stream) {
              throw new FS.ErrnoError(8);
            }

            FS.chown(stream.node, uid, gid);
          },
          truncate: function truncate(path, len) {
            if (len < 0) {
              throw new FS.ErrnoError(28);
            }

            var node;

            if (typeof path == "string") {
              var lookup = FS.lookupPath(path, {
                follow: true
              });
              node = lookup.node;
            } else {
              node = path;
            }

            if (!node.node_ops.setattr) {
              throw new FS.ErrnoError(63);
            }

            if (FS.isDir(node.mode)) {
              throw new FS.ErrnoError(31);
            }

            if (!FS.isFile(node.mode)) {
              throw new FS.ErrnoError(28);
            }

            var errCode = FS.nodePermissions(node, "w");

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            node.node_ops.setattr(node, {
              size: len,
              timestamp: Date.now()
            });
          },
          ftruncate: function ftruncate(fd, len) {
            var stream = FS.getStream(fd);

            if (!stream) {
              throw new FS.ErrnoError(8);
            }

            if ((stream.flags & 2097155) === 0) {
              throw new FS.ErrnoError(28);
            }

            FS.truncate(stream.node, len);
          },
          utime: function utime(path, atime, mtime) {
            var lookup = FS.lookupPath(path, {
              follow: true
            });
            var node = lookup.node;
            node.node_ops.setattr(node, {
              timestamp: Math.max(atime, mtime)
            });
          },
          open: function open(path, flags, mode) {
            if (path === "") {
              throw new FS.ErrnoError(44);
            }

            flags = typeof flags == "string" ? FS.modeStringToFlags(flags) : flags;
            mode = typeof mode == "undefined" ? 438 : mode;

            if (flags & 64) {
              mode = mode & 4095 | 32768;
            } else {
              mode = 0;
            }

            var node;

            if (typeof path == "object") {
              node = path;
            } else {
              path = PATH.normalize(path);

              try {
                var lookup = FS.lookupPath(path, {
                  follow: !(flags & 131072)
                });
                node = lookup.node;
              } catch (e) {}
            }

            var created = false;

            if (flags & 64) {
              if (node) {
                if (flags & 128) {
                  throw new FS.ErrnoError(20);
                }
              } else {
                node = FS.mknod(path, mode, 0);
                created = true;
              }
            }

            if (!node) {
              throw new FS.ErrnoError(44);
            }

            if (FS.isChrdev(node.mode)) {
              flags &= ~512;
            }

            if (flags & 65536 && !FS.isDir(node.mode)) {
              throw new FS.ErrnoError(54);
            }

            if (!created) {
              var errCode = FS.mayOpen(node, flags);

              if (errCode) {
                throw new FS.ErrnoError(errCode);
              }
            }

            if (flags & 512 && !created) {
              FS.truncate(node, 0);
            }

            flags &= ~(128 | 512 | 131072);
            var stream = FS.createStream({
              node: node,
              path: FS.getPath(node),
              flags: flags,
              seekable: true,
              position: 0,
              stream_ops: node.stream_ops,
              ungotten: [],
              error: false
            });

            if (stream.stream_ops.open) {
              stream.stream_ops.open(stream);
            }

            if (Module["logReadFiles"] && !(flags & 1)) {
              if (!FS.readFiles) FS.readFiles = {};

              if (!(path in FS.readFiles)) {
                FS.readFiles[path] = 1;
              }
            }

            return stream;
          },
          close: function close(stream) {
            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }

            if (stream.getdents) stream.getdents = null;

            try {
              if (stream.stream_ops.close) {
                stream.stream_ops.close(stream);
              }
            } catch (e) {
              throw e;
            } finally {
              FS.closeStream(stream.fd);
            }

            stream.fd = null;
          },
          isClosed: function isClosed(stream) {
            return stream.fd === null;
          },
          llseek: function llseek(stream, offset, whence) {
            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }

            if (!stream.seekable || !stream.stream_ops.llseek) {
              throw new FS.ErrnoError(70);
            }

            if (whence != 0 && whence != 1 && whence != 2) {
              throw new FS.ErrnoError(28);
            }

            stream.position = stream.stream_ops.llseek(stream, offset, whence);
            stream.ungotten = [];
            return stream.position;
          },
          read: function read(stream, buffer, offset, length, position) {
            offset >>>= 0;

            if (length < 0 || position < 0) {
              throw new FS.ErrnoError(28);
            }

            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }

            if ((stream.flags & 2097155) === 1) {
              throw new FS.ErrnoError(8);
            }

            if (FS.isDir(stream.node.mode)) {
              throw new FS.ErrnoError(31);
            }

            if (!stream.stream_ops.read) {
              throw new FS.ErrnoError(28);
            }

            var seeking = typeof position != "undefined";

            if (!seeking) {
              position = stream.position;
            } else if (!stream.seekable) {
              throw new FS.ErrnoError(70);
            }

            var bytesRead = stream.stream_ops.read(stream, buffer, offset, length, position);
            if (!seeking) stream.position += bytesRead;
            return bytesRead;
          },
          write: function write(stream, buffer, offset, length, position, canOwn) {
            offset >>>= 0;

            if (length < 0 || position < 0) {
              throw new FS.ErrnoError(28);
            }

            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }

            if ((stream.flags & 2097155) === 0) {
              throw new FS.ErrnoError(8);
            }

            if (FS.isDir(stream.node.mode)) {
              throw new FS.ErrnoError(31);
            }

            if (!stream.stream_ops.write) {
              throw new FS.ErrnoError(28);
            }

            if (stream.seekable && stream.flags & 1024) {
              FS.llseek(stream, 0, 2);
            }

            var seeking = typeof position != "undefined";

            if (!seeking) {
              position = stream.position;
            } else if (!stream.seekable) {
              throw new FS.ErrnoError(70);
            }

            var bytesWritten = stream.stream_ops.write(stream, buffer, offset, length, position, canOwn);
            if (!seeking) stream.position += bytesWritten;
            return bytesWritten;
          },
          allocate: function allocate(stream, offset, length) {
            if (FS.isClosed(stream)) {
              throw new FS.ErrnoError(8);
            }

            if (offset < 0 || length <= 0) {
              throw new FS.ErrnoError(28);
            }

            if ((stream.flags & 2097155) === 0) {
              throw new FS.ErrnoError(8);
            }

            if (!FS.isFile(stream.node.mode) && !FS.isDir(stream.node.mode)) {
              throw new FS.ErrnoError(43);
            }

            if (!stream.stream_ops.allocate) {
              throw new FS.ErrnoError(138);
            }

            stream.stream_ops.allocate(stream, offset, length);
          },
          mmap: function mmap(stream, length, position, prot, flags) {
            if ((prot & 2) !== 0 && (flags & 2) === 0 && (stream.flags & 2097155) !== 2) {
              throw new FS.ErrnoError(2);
            }

            if ((stream.flags & 2097155) === 1) {
              throw new FS.ErrnoError(2);
            }

            if (!stream.stream_ops.mmap) {
              throw new FS.ErrnoError(43);
            }

            return stream.stream_ops.mmap(stream, length, position, prot, flags);
          },
          msync: function msync(stream, buffer, offset, length, mmapFlags) {
            offset >>>= 0;

            if (!stream.stream_ops.msync) {
              return 0;
            }

            return stream.stream_ops.msync(stream, buffer, offset, length, mmapFlags);
          },
          munmap: function munmap(stream) {
            return 0;
          },
          ioctl: function ioctl(stream, cmd, arg) {
            if (!stream.stream_ops.ioctl) {
              throw new FS.ErrnoError(59);
            }

            return stream.stream_ops.ioctl(stream, cmd, arg);
          },
          readFile: function readFile(path) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            opts.flags = opts.flags || 0;
            opts.encoding = opts.encoding || "binary";

            if (opts.encoding !== "utf8" && opts.encoding !== "binary") {
              throw new Error('Invalid encoding type "' + opts.encoding + '"');
            }

            var ret;
            var stream = FS.open(path, opts.flags);
            var stat = FS.stat(path);
            var length = stat.size;
            var buf = new Uint8Array(length);
            FS.read(stream, buf, 0, length, 0);

            if (opts.encoding === "utf8") {
              ret = UTF8ArrayToString(buf, 0);
            } else if (opts.encoding === "binary") {
              ret = buf;
            }

            FS.close(stream);
            return ret;
          },
          writeFile: function writeFile(path, data) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            opts.flags = opts.flags || 577;
            var stream = FS.open(path, opts.flags, opts.mode);

            if (typeof data == "string") {
              var buf = new Uint8Array(lengthBytesUTF8(data) + 1);
              var actualNumBytes = stringToUTF8Array(data, buf, 0, buf.length);
              FS.write(stream, buf, 0, actualNumBytes, void 0, opts.canOwn);
            } else if (ArrayBuffer.isView(data)) {
              FS.write(stream, data, 0, data.byteLength, void 0, opts.canOwn);
            } else {
              throw new Error("Unsupported data type");
            }

            FS.close(stream);
          },
          cwd: function cwd() {
            return FS.currentPath;
          },
          chdir: function chdir(path) {
            var lookup = FS.lookupPath(path, {
              follow: true
            });

            if (lookup.node === null) {
              throw new FS.ErrnoError(44);
            }

            if (!FS.isDir(lookup.node.mode)) {
              throw new FS.ErrnoError(54);
            }

            var errCode = FS.nodePermissions(lookup.node, "x");

            if (errCode) {
              throw new FS.ErrnoError(errCode);
            }

            FS.currentPath = lookup.path;
          },
          createDefaultDirectories: function createDefaultDirectories() {
            FS.mkdir("/tmp");
            FS.mkdir("/home");
            FS.mkdir("/home/web_user");
          },
          createDefaultDevices: function createDefaultDevices() {
            FS.mkdir("/dev");
            FS.registerDevice(FS.makedev(1, 3), {
              read: function read() {
                return 0;
              },
              write: function write(stream, buffer, offset, length, pos) {
                return length;
              }
            });
            FS.mkdev("/dev/null", FS.makedev(1, 3));
            TTY.register(FS.makedev(5, 0), TTY.default_tty_ops);
            TTY.register(FS.makedev(6, 0), TTY.default_tty1_ops);
            FS.mkdev("/dev/tty", FS.makedev(5, 0));
            FS.mkdev("/dev/tty1", FS.makedev(6, 0));
            var random_device = getRandomDevice();
            FS.createDevice("/dev", "random", random_device);
            FS.createDevice("/dev", "urandom", random_device);
            FS.mkdir("/dev/shm");
            FS.mkdir("/dev/shm/tmp");
          },
          createSpecialDirectories: function createSpecialDirectories() {
            FS.mkdir("/proc");
            var proc_self = FS.mkdir("/proc/self");
            FS.mkdir("/proc/self/fd");
            FS.mount({
              mount: function mount() {
                var node = FS.createNode(proc_self, "fd", 16384 | 511, 73);
                node.node_ops = {
                  lookup: function lookup(parent, name) {
                    var fd = +name;
                    var stream = FS.getStream(fd);
                    if (!stream) throw new FS.ErrnoError(8);
                    var ret = {
                      parent: null,
                      mount: {
                        mountpoint: "fake"
                      },
                      node_ops: {
                        readlink: function readlink() {
                          return stream.path;
                        }
                      }
                    };
                    ret.parent = ret;
                    return ret;
                  }
                };
                return node;
              }
            }, {}, "/proc/self/fd");
          },
          createStandardStreams: function createStandardStreams() {
            if (Module["stdin"]) {
              FS.createDevice("/dev", "stdin", Module["stdin"]);
            } else {
              FS.symlink("/dev/tty", "/dev/stdin");
            }

            if (Module["stdout"]) {
              FS.createDevice("/dev", "stdout", null, Module["stdout"]);
            } else {
              FS.symlink("/dev/tty", "/dev/stdout");
            }

            if (Module["stderr"]) {
              FS.createDevice("/dev", "stderr", null, Module["stderr"]);
            } else {
              FS.symlink("/dev/tty1", "/dev/stderr");
            }

            FS.open("/dev/stdin", 0);
            FS.open("/dev/stdout", 1);
            FS.open("/dev/stderr", 1);
          },
          ensureErrnoError: function ensureErrnoError() {
            if (FS.ErrnoError) return;

            FS.ErrnoError = function ErrnoError(errno, node) {
              this.node = node;

              this.setErrno = function (errno2) {
                this.errno = errno2;
              };

              this.setErrno(errno);
              this.message = "FS error";
            };

            FS.ErrnoError.prototype = new Error();
            FS.ErrnoError.prototype.constructor = FS.ErrnoError;
            [44].forEach(function (code) {
              FS.genericErrors[code] = new FS.ErrnoError(code);
              FS.genericErrors[code].stack = "<generic error, no stack>";
            });
          },
          staticInit: function staticInit() {
            FS.ensureErrnoError();
            FS.nameTable = new Array(4096);
            FS.mount(MEMFS, {}, "/");
            FS.createDefaultDirectories();
            FS.createDefaultDevices();
            FS.createSpecialDirectories();
            FS.filesystems = {
              "MEMFS": MEMFS
            };
          },
          init: function init(input, output, error) {
            FS.init.initialized = true;
            FS.ensureErrnoError();
            Module["stdin"] = input || Module["stdin"];
            Module["stdout"] = output || Module["stdout"];
            Module["stderr"] = error || Module["stderr"];
            FS.createStandardStreams();
          },
          quit: function quit() {
            FS.init.initialized = false;

            for (var i = 0; i < FS.streams.length; i++) {
              var stream = FS.streams[i];

              if (!stream) {
                continue;
              }

              FS.close(stream);
            }
          },
          getMode: function getMode(canRead, canWrite) {
            var mode = 0;
            if (canRead) mode |= 292 | 73;
            if (canWrite) mode |= 146;
            return mode;
          },
          findObject: function findObject(path, dontResolveLastLink) {
            var ret = FS.analyzePath(path, dontResolveLastLink);

            if (!ret.exists) {
              return null;
            }

            return ret.object;
          },
          analyzePath: function analyzePath(path, dontResolveLastLink) {
            try {
              var lookup = FS.lookupPath(path, {
                follow: !dontResolveLastLink
              });
              path = lookup.path;
            } catch (e) {}

            var ret = {
              isRoot: false,
              exists: false,
              error: 0,
              name: null,
              path: null,
              object: null,
              parentExists: false,
              parentPath: null,
              parentObject: null
            };

            try {
              var lookup = FS.lookupPath(path, {
                parent: true
              });
              ret.parentExists = true;
              ret.parentPath = lookup.path;
              ret.parentObject = lookup.node;
              ret.name = PATH.basename(path);
              lookup = FS.lookupPath(path, {
                follow: !dontResolveLastLink
              });
              ret.exists = true;
              ret.path = lookup.path;
              ret.object = lookup.node;
              ret.name = lookup.node.name;
              ret.isRoot = lookup.path === "/";
            } catch (e) {
              ret.error = e.errno;
            }

            return ret;
          },
          createPath: function createPath(parent, path, canRead, canWrite) {
            parent = typeof parent == "string" ? parent : FS.getPath(parent);
            var parts = path.split("/").reverse();

            while (parts.length) {
              var part = parts.pop();
              if (!part) continue;
              var current = PATH.join2(parent, part);

              try {
                FS.mkdir(current);
              } catch (e) {}

              parent = current;
            }

            return current;
          },
          createFile: function createFile(parent, name, properties, canRead, canWrite) {
            var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
            var mode = FS.getMode(canRead, canWrite);
            return FS.create(path, mode);
          },
          createDataFile: function createDataFile(parent, name, data, canRead, canWrite, canOwn) {
            var path = name;

            if (parent) {
              parent = typeof parent == "string" ? parent : FS.getPath(parent);
              path = name ? PATH.join2(parent, name) : parent;
            }

            var mode = FS.getMode(canRead, canWrite);
            var node = FS.create(path, mode);

            if (data) {
              if (typeof data == "string") {
                var arr = new Array(data.length);

                for (var i = 0, len = data.length; i < len; ++i) {
                  arr[i] = data.charCodeAt(i);
                }

                data = arr;
              }

              FS.chmod(node, mode | 146);
              var stream = FS.open(node, 577);
              FS.write(stream, data, 0, data.length, 0, canOwn);
              FS.close(stream);
              FS.chmod(node, mode);
            }

            return node;
          },
          createDevice: function createDevice(parent, name, input, output) {
            var path = PATH.join2(typeof parent == "string" ? parent : FS.getPath(parent), name);
            var mode = FS.getMode(!!input, !!output);
            if (!FS.createDevice.major) FS.createDevice.major = 64;
            var dev = FS.makedev(FS.createDevice.major++, 0);
            FS.registerDevice(dev, {
              open: function open(stream) {
                stream.seekable = false;
              },
              close: function close(stream) {
                if (output && output.buffer && output.buffer.length) {
                  output(10);
                }
              },
              read: function read(stream, buffer, offset, length, pos) {
                var bytesRead = 0;

                for (var i = 0; i < length; i++) {
                  var result;

                  try {
                    result = input();
                  } catch (e) {
                    throw new FS.ErrnoError(29);
                  }

                  if (result === void 0 && bytesRead === 0) {
                    throw new FS.ErrnoError(6);
                  }

                  if (result === null || result === void 0) break;
                  bytesRead++;
                  buffer[offset + i] = result;
                }

                if (bytesRead) {
                  stream.node.timestamp = Date.now();
                }

                return bytesRead;
              },
              write: function write(stream, buffer, offset, length, pos) {
                for (var i = 0; i < length; i++) {
                  try {
                    output(buffer[offset + i]);
                  } catch (e) {
                    throw new FS.ErrnoError(29);
                  }
                }

                if (length) {
                  stream.node.timestamp = Date.now();
                }

                return i;
              }
            });
            return FS.mkdev(path, mode, dev);
          },
          forceLoadFile: function forceLoadFile(obj) {
            if (obj.isDevice || obj.isFolder || obj.link || obj.contents) return true;

            if (typeof XMLHttpRequest != "undefined") {
              throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
            } else if (read_) {
              try {
                obj.contents = intArrayFromString(read_(obj.url), true);
                obj.usedBytes = obj.contents.length;
              } catch (e) {
                throw new FS.ErrnoError(29);
              }
            } else {
              throw new Error("Cannot load without read() or XMLHttpRequest.");
            }
          },
          createLazyFile: function createLazyFile(parent, name, url, canRead, canWrite) {
            function LazyUint8Array() {
              this.lengthKnown = false;
              this.chunks = [];
            }

            LazyUint8Array.prototype.get = function LazyUint8Array_get(idx) {
              if (idx > this.length - 1 || idx < 0) {
                return void 0;
              }

              var chunkOffset = idx % this.chunkSize;
              var chunkNum = idx / this.chunkSize | 0;
              return this.getter(chunkNum)[chunkOffset];
            };

            LazyUint8Array.prototype.setDataGetter = function LazyUint8Array_setDataGetter(getter) {
              this.getter = getter;
            };

            LazyUint8Array.prototype.cacheLength = function LazyUint8Array_cacheLength() {
              var xhr = new XMLHttpRequest();
              xhr.open("HEAD", url, false);
              xhr.send(null);
              if (!(xhr.status >= 200 && xhr.status < 300 || xhr.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr.status);
              var datalength = Number(xhr.getResponseHeader("Content-length"));
              var header;
              var hasByteServing = (header = xhr.getResponseHeader("Accept-Ranges")) && header === "bytes";
              var usesGzip = (header = xhr.getResponseHeader("Content-Encoding")) && header === "gzip";
              var chunkSize = 1024 * 1024;
              if (!hasByteServing) chunkSize = datalength;

              var doXHR = function doXHR(from, to) {
                if (from > to) throw new Error("invalid range (" + from + ", " + to + ") or no bytes requested!");
                if (to > datalength - 1) throw new Error("only " + datalength + " bytes available! programmer error!");
                var xhr2 = new XMLHttpRequest();
                xhr2.open("GET", url, false);
                if (datalength !== chunkSize) xhr2.setRequestHeader("Range", "bytes=" + from + "-" + to);
                xhr2.responseType = "arraybuffer";

                if (xhr2.overrideMimeType) {
                  xhr2.overrideMimeType("text/plain; charset=x-user-defined");
                }

                xhr2.send(null);
                if (!(xhr2.status >= 200 && xhr2.status < 300 || xhr2.status === 304)) throw new Error("Couldn't load " + url + ". Status: " + xhr2.status);

                if (xhr2.response !== void 0) {
                  return new Uint8Array(xhr2.response || []);
                }

                return intArrayFromString(xhr2.responseText || "", true);
              };

              var lazyArray2 = this;
              lazyArray2.setDataGetter(function (chunkNum) {
                var start = chunkNum * chunkSize;
                var end = (chunkNum + 1) * chunkSize - 1;
                end = Math.min(end, datalength - 1);

                if (typeof lazyArray2.chunks[chunkNum] == "undefined") {
                  lazyArray2.chunks[chunkNum] = doXHR(start, end);
                }

                if (typeof lazyArray2.chunks[chunkNum] == "undefined") throw new Error("doXHR failed!");
                return lazyArray2.chunks[chunkNum];
              });

              if (usesGzip || !datalength) {
                chunkSize = datalength = 1;
                datalength = this.getter(0).length;
                chunkSize = datalength;
                out("LazyFiles on gzip forces download of the whole file when length is accessed");
              }

              this._length = datalength;
              this._chunkSize = chunkSize;
              this.lengthKnown = true;
            };

            if (typeof XMLHttpRequest != "undefined") {
              if (!ENVIRONMENT_IS_WORKER) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
              var lazyArray = new LazyUint8Array();
              Object.defineProperties(lazyArray, {
                length: {
                  get: function get() {
                    if (!this.lengthKnown) {
                      this.cacheLength();
                    }

                    return this._length;
                  }
                },
                chunkSize: {
                  get: function get() {
                    if (!this.lengthKnown) {
                      this.cacheLength();
                    }

                    return this._chunkSize;
                  }
                }
              });
              var properties = {
                isDevice: false,
                contents: lazyArray
              };
            } else {
              var properties = {
                isDevice: false,
                url: url
              };
            }

            var node = FS.createFile(parent, name, properties, canRead, canWrite);

            if (properties.contents) {
              node.contents = properties.contents;
            } else if (properties.url) {
              node.contents = null;
              node.url = properties.url;
            }

            Object.defineProperties(node, {
              usedBytes: {
                get: function get() {
                  return this.contents.length;
                }
              }
            });
            var stream_ops = {};
            var keys = Object.keys(node.stream_ops);
            keys.forEach(function (key) {
              var fn = node.stream_ops[key];

              stream_ops[key] = function forceLoadLazyFile() {
                FS.forceLoadFile(node);
                return fn.apply(null, arguments);
              };
            });

            function writeChunks(stream, buffer, offset, length, position) {
              var contents = stream.node.contents;
              if (position >= contents.length) return 0;
              var size = Math.min(contents.length - position, length);

              if (contents.slice) {
                for (var i = 0; i < size; i++) {
                  buffer[offset + i] = contents[position + i];
                }
              } else {
                for (var i = 0; i < size; i++) {
                  buffer[offset + i] = contents.get(position + i);
                }
              }

              return size;
            }

            stream_ops.read = function (stream, buffer, offset, length, position) {
              FS.forceLoadFile(node);
              return writeChunks(stream, buffer, offset, length, position);
            };

            stream_ops.mmap = function (stream, length, position, prot, flags) {
              FS.forceLoadFile(node);
              var ptr = mmapAlloc();

              if (!ptr) {
                throw new FS.ErrnoError(48);
              }

              writeChunks(stream, HEAP8, ptr, length, position);
              return {
                ptr: ptr,
                allocated: true
              };
            };

            node.stream_ops = stream_ops;
            return node;
          },
          createPreloadedFile: function createPreloadedFile(parent, name, url, canRead, canWrite, onload, onerror, dontCreateFile, canOwn, preFinish) {
            var fullname = name ? PATH_FS.resolve(PATH.join2(parent, name)) : parent;

            function processData(byteArray) {
              function finish(byteArray2) {
                if (preFinish) preFinish();

                if (!dontCreateFile) {
                  FS.createDataFile(parent, name, byteArray2, canRead, canWrite, canOwn);
                }

                if (onload) onload();
                removeRunDependency();
              }

              if (Browser.handledByPreloadPlugin(byteArray, fullname, finish, function () {
                if (onerror) onerror();
                removeRunDependency();
              })) {
                return;
              }

              finish(byteArray);
            }

            addRunDependency();

            if (typeof url == "string") {
              asyncLoad(url, function (byteArray) {
                return processData(byteArray);
              }, onerror);
            } else {
              processData(url);
            }
          },
          indexedDB: function indexedDB() {
            return window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
          },
          DB_NAME: function DB_NAME() {
            return "EM_FS_" + window.location.pathname;
          },
          DB_VERSION: 20,
          DB_STORE_NAME: "FILE_DATA",
          saveFilesToDB: function saveFilesToDB(paths) {
            var onload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
            var onerror = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
            var indexedDB = FS.indexedDB();

            try {
              var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
            } catch (e) {
              return onerror(e);
            }

            openRequest.onupgradeneeded = function () {
              out("creating db");
              var db = openRequest.result;
              db.createObjectStore(FS.DB_STORE_NAME);
            };

            openRequest.onsuccess = function () {
              var db = openRequest.result;
              var transaction = db.transaction([FS.DB_STORE_NAME], "readwrite");
              var files = transaction.objectStore(FS.DB_STORE_NAME);
              var ok = 0,
                  fail = 0,
                  total = paths.length;

              function finish() {
                if (fail == 0) onload();else onerror();
              }

              paths.forEach(function (path) {
                var putRequest = files.put(FS.analyzePath(path).object.contents, path);

                putRequest.onsuccess = function () {
                  ok++;
                  if (ok + fail == total) finish();
                };

                putRequest.onerror = function () {
                  fail++;
                  if (ok + fail == total) finish();
                };
              });
              transaction.onerror = onerror;
            };

            openRequest.onerror = onerror;
          },
          loadFilesFromDB: function loadFilesFromDB(paths) {
            var onload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
            var onerror = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
            var indexedDB = FS.indexedDB();

            try {
              var openRequest = indexedDB.open(FS.DB_NAME(), FS.DB_VERSION);
            } catch (e) {
              return onerror(e);
            }

            openRequest.onupgradeneeded = onerror;

            openRequest.onsuccess = function () {
              var db = openRequest.result;

              try {
                var transaction = db.transaction([FS.DB_STORE_NAME], "readonly");
              } catch (e) {
                onerror(e);
                return;
              }

              var files = transaction.objectStore(FS.DB_STORE_NAME);
              var ok = 0,
                  fail = 0,
                  total = paths.length;

              function finish() {
                if (fail == 0) onload();else onerror();
              }

              paths.forEach(function (path) {
                var getRequest = files.get(path);

                getRequest.onsuccess = function () {
                  if (FS.analyzePath(path).exists) {
                    FS.unlink(path);
                  }

                  FS.createDataFile(PATH.dirname(path), PATH.basename(path), getRequest.result, true, true, true);
                  ok++;
                  if (ok + fail == total) finish();
                };

                getRequest.onerror = function () {
                  fail++;
                  if (ok + fail == total) finish();
                };
              });
              transaction.onerror = onerror;
            };

            openRequest.onerror = onerror;
          }
        };
        var SYSCALLS = {
          DEFAULT_POLLMASK: 5,
          calculateAt: function calculateAt(dirfd, path, allowEmpty) {
            if (PATH.isAbs(path)) {
              return path;
            }

            var dir;

            if (dirfd === -100) {
              dir = FS.cwd();
            } else {
              var dirstream = SYSCALLS.getStreamFromFD(dirfd);
              dir = dirstream.path;
            }

            if (path.length == 0) {
              if (!allowEmpty) {
                throw new FS.ErrnoError(44);
              }

              return dir;
            }

            return PATH.join2(dir, path);
          },
          doStat: function doStat(func, path, buf) {
            try {
              var stat = func(path);
            } catch (e) {
              if (e && e.node && PATH.normalize(path) !== PATH.normalize(FS.getPath(e.node))) {
                return -54;
              }

              throw e;
            }

            HEAP32[buf >>> 2] = stat.dev;
            HEAP32[buf + 8 >>> 2] = stat.ino;
            HEAP32[buf + 12 >>> 2] = stat.mode;
            HEAPU32[buf + 16 >>> 2] = stat.nlink;
            HEAP32[buf + 20 >>> 2] = stat.uid;
            HEAP32[buf + 24 >>> 2] = stat.gid;
            HEAP32[buf + 28 >>> 2] = stat.rdev;
            tempI64 = [stat.size >>> 0, (tempDouble = stat.size, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 40 >>> 2] = tempI64[0], HEAP32[buf + 44 >>> 2] = tempI64[1];
            HEAP32[buf + 48 >>> 2] = 4096;
            HEAP32[buf + 52 >>> 2] = stat.blocks;
            var atime = stat.atime.getTime();
            var mtime = stat.mtime.getTime();
            var ctime = stat.ctime.getTime();
            tempI64 = [Math.floor(atime / 1e3) >>> 0, (tempDouble = Math.floor(atime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 56 >>> 2] = tempI64[0], HEAP32[buf + 60 >>> 2] = tempI64[1];
            HEAPU32[buf + 64 >>> 2] = atime % 1e3 * 1e3;
            tempI64 = [Math.floor(mtime / 1e3) >>> 0, (tempDouble = Math.floor(mtime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 72 >>> 2] = tempI64[0], HEAP32[buf + 76 >>> 2] = tempI64[1];
            HEAPU32[buf + 80 >>> 2] = mtime % 1e3 * 1e3;
            tempI64 = [Math.floor(ctime / 1e3) >>> 0, (tempDouble = Math.floor(ctime / 1e3), +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 88 >>> 2] = tempI64[0], HEAP32[buf + 92 >>> 2] = tempI64[1];
            HEAPU32[buf + 96 >>> 2] = ctime % 1e3 * 1e3;
            tempI64 = [stat.ino >>> 0, (tempDouble = stat.ino, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[buf + 104 >>> 2] = tempI64[0], HEAP32[buf + 108 >>> 2] = tempI64[1];
            return 0;
          },
          doMsync: function doMsync(addr, stream, len, flags, offset) {
            if (!FS.isFile(stream.node.mode)) {
              throw new FS.ErrnoError(43);
            }

            if (flags & 2) {
              return 0;
            }

            addr >>>= 0;
            var buffer = HEAPU8.slice(addr, addr + len);
            FS.msync(stream, buffer, offset, len, flags);
          },
          varargs: void 0,
          get: function get() {
            SYSCALLS.varargs += 4;
            var ret = HEAP32[SYSCALLS.varargs - 4 >>> 2];
            return ret;
          },
          getStr: function getStr(ptr) {
            var ret = UTF8ToString(ptr);
            return ret;
          },
          getStreamFromFD: function getStreamFromFD(fd) {
            var stream = FS.getStream(fd);
            if (!stream) throw new FS.ErrnoError(8);
            return stream;
          }
        };

        function ___syscall_fcntl64(fd, cmd, varargs) {
          SYSCALLS.varargs = varargs;

          try {
            var stream = SYSCALLS.getStreamFromFD(fd);

            switch (cmd) {
              case 0:
                {
                  var arg = SYSCALLS.get();

                  if (arg < 0) {
                    return -28;
                  }

                  var newStream;
                  newStream = FS.createStream(stream, arg);
                  return newStream.fd;
                }

              case 1:
              case 2:
                return 0;

              case 3:
                return stream.flags;

              case 4:
                {
                  var arg = SYSCALLS.get();
                  stream.flags |= arg;
                  return 0;
                }

              case 5:
                {
                  var arg = SYSCALLS.get();
                  var offset = 0;
                  HEAP16[arg + offset >>> 1] = 2;
                  return 0;
                }

              case 6:
              case 7:
                return 0;

              case 16:
              case 8:
                return -28;

              case 9:
                setErrNo(28);
                return -1;

              default:
                {
                  return -28;
                }
            }
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return -e.errno;
          }
        }

        function ___syscall_ioctl(fd, op, varargs) {
          SYSCALLS.varargs = varargs;

          try {
            var stream = SYSCALLS.getStreamFromFD(fd);

            switch (op) {
              case 21509:
              case 21505:
                {
                  if (!stream.tty) return -59;
                  return 0;
                }

              case 21510:
              case 21511:
              case 21512:
              case 21506:
              case 21507:
              case 21508:
                {
                  if (!stream.tty) return -59;
                  return 0;
                }

              case 21519:
                {
                  if (!stream.tty) return -59;
                  var argp = SYSCALLS.get();
                  HEAP32[argp >>> 2] = 0;
                  return 0;
                }

              case 21520:
                {
                  if (!stream.tty) return -59;
                  return -28;
                }

              case 21531:
                {
                  var argp = SYSCALLS.get();
                  return FS.ioctl(stream, op, argp);
                }

              case 21523:
                {
                  if (!stream.tty) return -59;
                  return 0;
                }

              case 21524:
                {
                  if (!stream.tty) return -59;
                  return 0;
                }

              default:
                return -28;
            }
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return -e.errno;
          }
        }

        function ___syscall_openat(dirfd, path, flags, varargs) {
          SYSCALLS.varargs = varargs;

          try {
            path = SYSCALLS.getStr(path);
            path = SYSCALLS.calculateAt(dirfd, path);
            var mode = varargs ? SYSCALLS.get() : 0;
            return FS.open(path, flags, mode).fd;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return -e.errno;
          }
        }

        var tupleRegistrations = {};

        function runDestructors(destructors) {
          while (destructors.length) {
            var ptr = destructors.pop();
            var del = destructors.pop();
            del(ptr);
          }
        }

        function simpleReadValueFromPointer(pointer) {
          return this["fromWireType"](HEAP32[pointer >>> 2]);
        }

        var awaitingDependencies = {};
        var registeredTypes = {};
        var typeDependencies = {};
        var char_0 = 48;
        var char_9 = 57;

        function makeLegalFunctionName(name) {
          if (name === void 0) {
            return "_unknown";
          }

          name = name.replace(/[^a-zA-Z0-9_]/g, "$");
          var f = name.charCodeAt(0);

          if (f >= char_0 && f <= char_9) {
            return "_" + name;
          }

          return name;
        }

        function createNamedFunction(name, body) {
          name = makeLegalFunctionName(name);
          return new Function("body", "return function " + name + '() {\n    "use strict";    return body.apply(this, arguments);\n};\n')(body);
        }

        function extendError(baseErrorType, errorName) {
          var errorClass = createNamedFunction(errorName, function (message) {
            this.name = errorName;
            this.message = message;
            var stack = new Error(message).stack;

            if (stack !== void 0) {
              this.stack = this.toString() + "\n" + stack.replace(/^Error(:[^\n]*)?\n/, "");
            }
          });
          errorClass.prototype = Object.create(baseErrorType.prototype);
          errorClass.prototype.constructor = errorClass;

          errorClass.prototype.toString = function () {
            if (this.message === void 0) {
              return this.name;
            } else {
              return this.name + ": " + this.message;
            }
          };

          return errorClass;
        }

        var InternalError = void 0;

        function throwInternalError(message) {
          throw new InternalError(message);
        }

        function whenDependentTypesAreResolved(myTypes, dependentTypes, getTypeConverters) {
          myTypes.forEach(function (type) {
            typeDependencies[type] = dependentTypes;
          });

          function onComplete(typeConverters2) {
            var myTypeConverters = getTypeConverters(typeConverters2);

            if (myTypeConverters.length !== myTypes.length) {
              throwInternalError("Mismatched type converter count");
            }

            for (var i = 0; i < myTypes.length; ++i) {
              registerType(myTypes[i], myTypeConverters[i]);
            }
          }

          var typeConverters = new Array(dependentTypes.length);
          var unregisteredTypes = [];
          var registered = 0;
          dependentTypes.forEach(function (dt, i) {
            if (registeredTypes.hasOwnProperty(dt)) {
              typeConverters[i] = registeredTypes[dt];
            } else {
              unregisteredTypes.push(dt);

              if (!awaitingDependencies.hasOwnProperty(dt)) {
                awaitingDependencies[dt] = [];
              }

              awaitingDependencies[dt].push(function () {
                typeConverters[i] = registeredTypes[dt];
                ++registered;

                if (registered === unregisteredTypes.length) {
                  onComplete(typeConverters);
                }
              });
            }
          });

          if (unregisteredTypes.length === 0) {
            onComplete(typeConverters);
          }
        }

        function __embind_finalize_value_array(rawTupleType) {
          var reg = tupleRegistrations[rawTupleType];
          delete tupleRegistrations[rawTupleType];
          var elements = reg.elements;
          var elementsLength = elements.length;
          var elementTypes = elements.map(function (elt) {
            return elt.getterReturnType;
          }).concat(elements.map(function (elt) {
            return elt.setterArgumentType;
          }));
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          whenDependentTypesAreResolved([rawTupleType], elementTypes, function (elementTypes2) {
            elements.forEach(function (elt, i) {
              var getterReturnType = elementTypes2[i];
              var getter = elt.getter;
              var getterContext = elt.getterContext;
              var setterArgumentType = elementTypes2[i + elementsLength];
              var setter = elt.setter;
              var setterContext = elt.setterContext;

              elt.read = function (ptr) {
                return getterReturnType["fromWireType"](getter(getterContext, ptr));
              };

              elt.write = function (ptr, o) {
                var destructors = [];
                setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                runDestructors(destructors);
              };
            });
            return [{
              name: reg.name,
              "fromWireType": function fromWireType(ptr) {
                var rv = new Array(elementsLength);

                for (var i = 0; i < elementsLength; ++i) {
                  rv[i] = elements[i].read(ptr);
                }

                rawDestructor(ptr);
                return rv;
              },
              "toWireType": function toWireType(destructors, o) {
                if (elementsLength !== o.length) {
                  throw new TypeError("Incorrect number of tuple elements for " + reg.name + ": expected=" + elementsLength + ", actual=" + o.length);
                }

                var ptr = rawConstructor();

                for (var i = 0; i < elementsLength; ++i) {
                  elements[i].write(ptr, o[i]);
                }

                if (destructors !== null) {
                  destructors.push(rawDestructor, ptr);
                }

                return ptr;
              },
              "argPackAdvance": 8,
              "readValueFromPointer": simpleReadValueFromPointer,
              destructorFunction: rawDestructor
            }];
          });
        }

        var structRegistrations = {};

        function __embind_finalize_value_object(structType) {
          var reg = structRegistrations[structType];
          delete structRegistrations[structType];
          var rawConstructor = reg.rawConstructor;
          var rawDestructor = reg.rawDestructor;
          var fieldRecords = reg.fields;
          var fieldTypes = fieldRecords.map(function (field) {
            return field.getterReturnType;
          }).concat(fieldRecords.map(function (field) {
            return field.setterArgumentType;
          }));
          whenDependentTypesAreResolved([structType], fieldTypes, function (fieldTypes2) {
            var fields = {};
            fieldRecords.forEach(function (field, i) {
              var fieldName = field.fieldName;
              var getterReturnType = fieldTypes2[i];
              var getter = field.getter;
              var getterContext = field.getterContext;
              var setterArgumentType = fieldTypes2[i + fieldRecords.length];
              var setter = field.setter;
              var setterContext = field.setterContext;
              fields[fieldName] = {
                read: function read(ptr) {
                  return getterReturnType["fromWireType"](getter(getterContext, ptr));
                },
                write: function write(ptr, o) {
                  var destructors = [];
                  setter(setterContext, ptr, setterArgumentType["toWireType"](destructors, o));
                  runDestructors(destructors);
                }
              };
            });
            return [{
              name: reg.name,
              "fromWireType": function fromWireType(ptr) {
                var rv = {};

                for (var i in fields) {
                  rv[i] = fields[i].read(ptr);
                }

                rawDestructor(ptr);
                return rv;
              },
              "toWireType": function toWireType(destructors, o) {
                for (var fieldName in fields) {
                  if (!(fieldName in o)) {
                    throw new TypeError('Missing field:  "' + fieldName + '"');
                  }
                }

                var ptr = rawConstructor();

                for (fieldName in fields) {
                  fields[fieldName].write(ptr, o[fieldName]);
                }

                if (destructors !== null) {
                  destructors.push(rawDestructor, ptr);
                }

                return ptr;
              },
              "argPackAdvance": 8,
              "readValueFromPointer": simpleReadValueFromPointer,
              destructorFunction: rawDestructor
            }];
          });
        }

        function __embind_register_bigint(primitiveType, name, size, minRange, maxRange) {}

        function getShiftFromSize(size) {
          switch (size) {
            case 1:
              return 0;

            case 2:
              return 1;

            case 4:
              return 2;

            case 8:
              return 3;

            default:
              throw new TypeError("Unknown type size: " + size);
          }
        }

        function embind_init_charCodes() {
          var codes = new Array(256);

          for (var i = 0; i < 256; ++i) {
            codes[i] = String.fromCharCode(i);
          }

          embind_charCodes = codes;
        }

        var embind_charCodes = void 0;

        function readLatin1String(ptr) {
          var ret = "";
          var c = ptr;

          while (HEAPU8[c >>> 0]) {
            ret += embind_charCodes[HEAPU8[c++ >>> 0]];
          }

          return ret;
        }

        var BindingError = void 0;

        function throwBindingError(message) {
          throw new BindingError(message);
        }

        function registerType(rawType, registeredInstance) {
          var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

          if (!("argPackAdvance" in registeredInstance)) {
            throw new TypeError("registerType registeredInstance requires argPackAdvance");
          }

          var name = registeredInstance.name;

          if (!rawType) {
            throwBindingError('type "' + name + '" must have a positive integer typeid pointer');
          }

          if (registeredTypes.hasOwnProperty(rawType)) {
            if (options.ignoreDuplicateRegistrations) {
              return;
            } else {
              throwBindingError("Cannot register type '" + name + "' twice");
            }
          }

          registeredTypes[rawType] = registeredInstance;
          delete typeDependencies[rawType];

          if (awaitingDependencies.hasOwnProperty(rawType)) {
            var callbacks = awaitingDependencies[rawType];
            delete awaitingDependencies[rawType];
            callbacks.forEach(function (cb) {
              return cb();
            });
          }
        }

        function __embind_register_bool(rawType, name, size, trueValue, falseValue) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, {
            name: name,
            "fromWireType": function fromWireType(wt) {
              return !!wt;
            },
            "toWireType": function toWireType(destructors, o) {
              return o ? trueValue : falseValue;
            },
            "argPackAdvance": 8,
            "readValueFromPointer": function readValueFromPointer(pointer) {
              var heap;

              if (size === 1) {
                heap = HEAP8;
              } else if (size === 2) {
                heap = HEAP16;
              } else if (size === 4) {
                heap = HEAP32;
              } else {
                throw new TypeError("Unknown boolean type size: " + name);
              }

              return this["fromWireType"](heap[pointer >>> shift]);
            },
            destructorFunction: null
          });
        }

        function ClassHandle_isAliasOf(other) {
          if (!(this instanceof ClassHandle)) {
            return false;
          }

          if (!(other instanceof ClassHandle)) {
            return false;
          }

          var leftClass = this.$$.ptrType.registeredClass;
          var left = this.$$.ptr;
          var rightClass = other.$$.ptrType.registeredClass;
          var right = other.$$.ptr;

          while (leftClass.baseClass) {
            left = leftClass.upcast(left);
            leftClass = leftClass.baseClass;
          }

          while (rightClass.baseClass) {
            right = rightClass.upcast(right);
            rightClass = rightClass.baseClass;
          }

          return leftClass === rightClass && left === right;
        }

        function shallowCopyInternalPointer(o) {
          return {
            count: o.count,
            deleteScheduled: o.deleteScheduled,
            preservePointerOnDelete: o.preservePointerOnDelete,
            ptr: o.ptr,
            ptrType: o.ptrType,
            smartPtr: o.smartPtr,
            smartPtrType: o.smartPtrType
          };
        }

        function throwInstanceAlreadyDeleted(obj) {
          function getInstanceTypeName(handle) {
            return handle.$$.ptrType.registeredClass.name;
          }

          throwBindingError(getInstanceTypeName(obj) + " instance already deleted");
        }

        var finalizationRegistry = false;

        function detachFinalizer(handle) {}

        function runDestructor($$) {
          if ($$.smartPtr) {
            $$.smartPtrType.rawDestructor($$.smartPtr);
          } else {
            $$.ptrType.registeredClass.rawDestructor($$.ptr);
          }
        }

        function releaseClassHandle($$) {
          $$.count.value -= 1;
          var toDelete = $$.count.value === 0;

          if (toDelete) {
            runDestructor($$);
          }
        }

        function downcastPointer(ptr, ptrClass, desiredClass) {
          if (ptrClass === desiredClass) {
            return ptr;
          }

          if (desiredClass.baseClass === void 0) {
            return null;
          }

          var rv = downcastPointer(ptr, ptrClass, desiredClass.baseClass);

          if (rv === null) {
            return null;
          }

          return desiredClass.downcast(rv);
        }

        var registeredPointers = {};

        function getInheritedInstanceCount() {
          return Object.keys(registeredInstances).length;
        }

        function getLiveInheritedInstances() {
          var rv = [];

          for (var k in registeredInstances) {
            if (registeredInstances.hasOwnProperty(k)) {
              rv.push(registeredInstances[k]);
            }
          }

          return rv;
        }

        var deletionQueue = [];

        function flushPendingDeletes() {
          while (deletionQueue.length) {
            var obj = deletionQueue.pop();
            obj.$$.deleteScheduled = false;
            obj["delete"]();
          }
        }

        var delayFunction = void 0;

        function setDelayFunction(fn) {
          delayFunction = fn;

          if (deletionQueue.length && delayFunction) {
            delayFunction(flushPendingDeletes);
          }
        }

        function init_embind() {
          Module["getInheritedInstanceCount"] = getInheritedInstanceCount;
          Module["getLiveInheritedInstances"] = getLiveInheritedInstances;
          Module["flushPendingDeletes"] = flushPendingDeletes;
          Module["setDelayFunction"] = setDelayFunction;
        }

        var registeredInstances = {};

        function getBasestPointer(class_, ptr) {
          if (ptr === void 0) {
            throwBindingError("ptr should not be undefined");
          }

          while (class_.baseClass) {
            ptr = class_.upcast(ptr);
            class_ = class_.baseClass;
          }

          return ptr;
        }

        function getInheritedInstance(class_, ptr) {
          ptr = getBasestPointer(class_, ptr);
          return registeredInstances[ptr];
        }

        function makeClassHandle(prototype, record) {
          if (!record.ptrType || !record.ptr) {
            throwInternalError("makeClassHandle requires ptr and ptrType");
          }

          var hasSmartPtrType = !!record.smartPtrType;
          var hasSmartPtr = !!record.smartPtr;

          if (hasSmartPtrType !== hasSmartPtr) {
            throwInternalError("Both smartPtrType and smartPtr must be specified");
          }

          record.count = {
            value: 1
          };
          return attachFinalizer(Object.create(prototype, {
            $$: {
              value: record
            }
          }));
        }

        function RegisteredPointer_fromWireType(ptr) {
          var rawPointer = this.getPointee(ptr);

          if (!rawPointer) {
            this.destructor(ptr);
            return null;
          }

          var registeredInstance = getInheritedInstance(this.registeredClass, rawPointer);

          if (registeredInstance !== void 0) {
            if (registeredInstance.$$.count.value === 0) {
              registeredInstance.$$.ptr = rawPointer;
              registeredInstance.$$.smartPtr = ptr;
              return registeredInstance["clone"]();
            } else {
              var rv = registeredInstance["clone"]();
              this.destructor(ptr);
              return rv;
            }
          }

          function makeDefaultHandle() {
            if (this.isSmartPointer) {
              return makeClassHandle(this.registeredClass.instancePrototype, {
                ptrType: this.pointeeType,
                ptr: rawPointer,
                smartPtrType: this,
                smartPtr: ptr
              });
            } else {
              return makeClassHandle(this.registeredClass.instancePrototype, {
                ptrType: this,
                ptr: ptr
              });
            }
          }

          var actualType = this.registeredClass.getActualType(rawPointer);
          var registeredPointerRecord = registeredPointers[actualType];

          if (!registeredPointerRecord) {
            return makeDefaultHandle.call(this);
          }

          var toType;

          if (this.isConst) {
            toType = registeredPointerRecord.constPointerType;
          } else {
            toType = registeredPointerRecord.pointerType;
          }

          var dp = downcastPointer(rawPointer, this.registeredClass, toType.registeredClass);

          if (dp === null) {
            return makeDefaultHandle.call(this);
          }

          if (this.isSmartPointer) {
            return makeClassHandle(toType.registeredClass.instancePrototype, {
              ptrType: toType,
              ptr: dp,
              smartPtrType: this,
              smartPtr: ptr
            });
          } else {
            return makeClassHandle(toType.registeredClass.instancePrototype, {
              ptrType: toType,
              ptr: dp
            });
          }
        }

        function attachFinalizer(handle) {
          if (typeof FinalizationRegistry === "undefined") {
            attachFinalizer = function attachFinalizer(handle2) {
              return handle2;
            };

            return handle;
          }

          finalizationRegistry = new FinalizationRegistry(function (info) {
            releaseClassHandle(info.$$);
          });

          attachFinalizer = function attachFinalizer(handle2) {
            var $$ = handle2.$$;
            var hasSmartPtr = !!$$.smartPtr;

            if (hasSmartPtr) {
              var info = {
                $$: $$
              };
              finalizationRegistry.register(handle2, info, handle2);
            }

            return handle2;
          };

          detachFinalizer = function detachFinalizer(handle2) {
            return finalizationRegistry.unregister(handle2);
          };

          return attachFinalizer(handle);
        }

        function ClassHandle_clone() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }

          if (this.$$.preservePointerOnDelete) {
            this.$$.count.value += 1;
            return this;
          } else {
            var clone = attachFinalizer(Object.create(Object.getPrototypeOf(this), {
              $$: {
                value: shallowCopyInternalPointer(this.$$)
              }
            }));
            clone.$$.count.value += 1;
            clone.$$.deleteScheduled = false;
            return clone;
          }
        }

        function ClassHandle_delete() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }

          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }

          detachFinalizer(this);
          releaseClassHandle(this.$$);

          if (!this.$$.preservePointerOnDelete) {
            this.$$.smartPtr = void 0;
            this.$$.ptr = void 0;
          }
        }

        function ClassHandle_isDeleted() {
          return !this.$$.ptr;
        }

        function ClassHandle_deleteLater() {
          if (!this.$$.ptr) {
            throwInstanceAlreadyDeleted(this);
          }

          if (this.$$.deleteScheduled && !this.$$.preservePointerOnDelete) {
            throwBindingError("Object already scheduled for deletion");
          }

          deletionQueue.push(this);

          if (deletionQueue.length === 1 && delayFunction) {
            delayFunction(flushPendingDeletes);
          }

          this.$$.deleteScheduled = true;
          return this;
        }

        function init_ClassHandle() {
          ClassHandle.prototype["isAliasOf"] = ClassHandle_isAliasOf;
          ClassHandle.prototype["clone"] = ClassHandle_clone;
          ClassHandle.prototype["delete"] = ClassHandle_delete;
          ClassHandle.prototype["isDeleted"] = ClassHandle_isDeleted;
          ClassHandle.prototype["deleteLater"] = ClassHandle_deleteLater;
        }

        function ClassHandle() {}

        function ensureOverloadTable(proto, methodName, humanName) {
          if (proto[methodName].overloadTable === void 0) {
            var prevFunc = proto[methodName];

            proto[methodName] = function () {
              if (!proto[methodName].overloadTable.hasOwnProperty(arguments.length)) {
                throwBindingError("Function '" + humanName + "' called with an invalid number of arguments (" + arguments.length + ") - expects one of (" + proto[methodName].overloadTable + ")!");
              }

              return proto[methodName].overloadTable[arguments.length].apply(this, arguments);
            };

            proto[methodName].overloadTable = [];
            proto[methodName].overloadTable[prevFunc.argCount] = prevFunc;
          }
        }

        function exposePublicSymbol(name, value, numArguments) {
          if (Module.hasOwnProperty(name)) {
            if (numArguments === void 0 || Module[name].overloadTable !== void 0 && Module[name].overloadTable[numArguments] !== void 0) {
              throwBindingError("Cannot register public name '" + name + "' twice");
            }

            ensureOverloadTable(Module, name, name);

            if (Module.hasOwnProperty(numArguments)) {
              throwBindingError("Cannot register multiple overloads of a function with the same number of arguments (" + numArguments + ")!");
            }

            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;

            if (numArguments !== void 0) {
              Module[name].numArguments = numArguments;
            }
          }
        }

        function RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast) {
          this.name = name;
          this.constructor = constructor;
          this.instancePrototype = instancePrototype;
          this.rawDestructor = rawDestructor;
          this.baseClass = baseClass;
          this.getActualType = getActualType;
          this.upcast = upcast;
          this.downcast = downcast;
          this.pureVirtualFunctions = [];
        }

        function upcastPointer(ptr, ptrClass, desiredClass) {
          while (ptrClass !== desiredClass) {
            if (!ptrClass.upcast) {
              throwBindingError("Expected null or instance of " + desiredClass.name + ", got an instance of " + ptrClass.name);
            }

            ptr = ptrClass.upcast(ptr);
            ptrClass = ptrClass.baseClass;
          }

          return ptr;
        }

        function constNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }

            return 0;
          }

          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }

          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }

          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }

        function genericPointerToWireType(destructors, handle) {
          var ptr;

          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }

            if (this.isSmartPointer) {
              ptr = this.rawConstructor();

              if (destructors !== null) {
                destructors.push(this.rawDestructor, ptr);
              }

              return ptr;
            } else {
              return 0;
            }
          }

          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }

          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }

          if (!this.isConst && handle.$$.ptrType.isConst) {
            throwBindingError("Cannot convert argument of type " + (handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name) + " to parameter type " + this.name);
          }

          var handleClass = handle.$$.ptrType.registeredClass;
          ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);

          if (this.isSmartPointer) {
            if (handle.$$.smartPtr === void 0) {
              throwBindingError("Passing raw pointer to smart pointer is illegal");
            }

            switch (this.sharingPolicy) {
              case 0:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  throwBindingError("Cannot convert argument of type " + (handle.$$.smartPtrType ? handle.$$.smartPtrType.name : handle.$$.ptrType.name) + " to parameter type " + this.name);
                }

                break;

              case 1:
                ptr = handle.$$.smartPtr;
                break;

              case 2:
                if (handle.$$.smartPtrType === this) {
                  ptr = handle.$$.smartPtr;
                } else {
                  var clonedHandle = handle["clone"]();
                  ptr = this.rawShare(ptr, Emval.toHandle(function () {
                    clonedHandle["delete"]();
                  }));

                  if (destructors !== null) {
                    destructors.push(this.rawDestructor, ptr);
                  }
                }

                break;

              default:
                throwBindingError("Unsupporting sharing policy");
            }
          }

          return ptr;
        }

        function nonConstNoSmartPtrRawPointerToWireType(destructors, handle) {
          if (handle === null) {
            if (this.isReference) {
              throwBindingError("null is not a valid " + this.name);
            }

            return 0;
          }

          if (!handle.$$) {
            throwBindingError('Cannot pass "' + embindRepr(handle) + '" as a ' + this.name);
          }

          if (!handle.$$.ptr) {
            throwBindingError("Cannot pass deleted object as a pointer of type " + this.name);
          }

          if (handle.$$.ptrType.isConst) {
            throwBindingError("Cannot convert argument of type " + handle.$$.ptrType.name + " to parameter type " + this.name);
          }

          var handleClass = handle.$$.ptrType.registeredClass;
          var ptr = upcastPointer(handle.$$.ptr, handleClass, this.registeredClass);
          return ptr;
        }

        function RegisteredPointer_getPointee(ptr) {
          if (this.rawGetPointee) {
            ptr = this.rawGetPointee(ptr);
          }

          return ptr;
        }

        function RegisteredPointer_destructor(ptr) {
          if (this.rawDestructor) {
            this.rawDestructor(ptr);
          }
        }

        function RegisteredPointer_deleteObject(handle) {
          if (handle !== null) {
            handle["delete"]();
          }
        }

        function init_RegisteredPointer() {
          RegisteredPointer.prototype.getPointee = RegisteredPointer_getPointee;
          RegisteredPointer.prototype.destructor = RegisteredPointer_destructor;
          RegisteredPointer.prototype["argPackAdvance"] = 8;
          RegisteredPointer.prototype["readValueFromPointer"] = simpleReadValueFromPointer;
          RegisteredPointer.prototype["deleteObject"] = RegisteredPointer_deleteObject;
          RegisteredPointer.prototype["fromWireType"] = RegisteredPointer_fromWireType;
        }

        function RegisteredPointer(name, registeredClass, isReference, isConst, isSmartPointer, pointeeType, sharingPolicy, rawGetPointee, rawConstructor, rawShare, rawDestructor) {
          this.name = name;
          this.registeredClass = registeredClass;
          this.isReference = isReference;
          this.isConst = isConst;
          this.isSmartPointer = isSmartPointer;
          this.pointeeType = pointeeType;
          this.sharingPolicy = sharingPolicy;
          this.rawGetPointee = rawGetPointee;
          this.rawConstructor = rawConstructor;
          this.rawShare = rawShare;
          this.rawDestructor = rawDestructor;

          if (!isSmartPointer && registeredClass.baseClass === void 0) {
            if (isConst) {
              this["toWireType"] = constNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            } else {
              this["toWireType"] = nonConstNoSmartPtrRawPointerToWireType;
              this.destructorFunction = null;
            }
          } else {
            this["toWireType"] = genericPointerToWireType;
          }
        }

        function replacePublicSymbol(name, value, numArguments) {
          if (!Module.hasOwnProperty(name)) {
            throwInternalError("Replacing nonexistant public symbol");
          }

          if (Module[name].overloadTable !== void 0 && numArguments !== void 0) {
            Module[name].overloadTable[numArguments] = value;
          } else {
            Module[name] = value;
            Module[name].argCount = numArguments;
          }
        }

        function dynCallLegacy(sig, ptr, args) {
          var f = Module["dynCall_" + sig];
          return args && args.length ? f.apply(null, [ptr].concat(args)) : f.call(null, ptr);
        }

        var wasmTableMirror = [];

        function getWasmTableEntry(funcPtr) {
          var func = wasmTableMirror[funcPtr];

          if (!func) {
            if (funcPtr >= wasmTableMirror.length) wasmTableMirror.length = funcPtr + 1;
            wasmTableMirror[funcPtr] = func = wasmTable.get(funcPtr);
          }

          return func;
        }

        function dynCall(sig, ptr, args) {
          if (sig.includes("j")) {
            return dynCallLegacy(sig, ptr, args);
          }

          var rtn = getWasmTableEntry(ptr).apply(null, args);
          return rtn;
        }

        function getDynCaller(sig, ptr) {
          var argCache = [];
          return function () {
            argCache.length = 0;
            Object.assign(argCache, arguments);
            return dynCall(sig, ptr, argCache);
          };
        }

        function embind__requireFunction(signature, rawFunction) {
          signature = readLatin1String(signature);

          function makeDynCaller() {
            if (signature.includes("j")) {
              return getDynCaller(signature, rawFunction);
            }

            return getWasmTableEntry(rawFunction);
          }

          var fp = makeDynCaller();

          if (typeof fp != "function") {
            throwBindingError("unknown function pointer with signature " + signature + ": " + rawFunction);
          }

          return fp;
        }

        var UnboundTypeError = void 0;

        function getTypeName(type) {
          var ptr = ___getTypeName(type);

          var rv = readLatin1String(ptr);

          _free3(ptr);

          return rv;
        }

        function throwUnboundTypeError(message, types) {
          var unboundTypes = [];
          var seen = {};

          function visit(type) {
            if (seen[type]) {
              return;
            }

            if (registeredTypes[type]) {
              return;
            }

            if (typeDependencies[type]) {
              typeDependencies[type].forEach(visit);
              return;
            }

            unboundTypes.push(type);
            seen[type] = true;
          }

          types.forEach(visit);
          throw new UnboundTypeError(message + ": " + unboundTypes.map(getTypeName).join([", "]));
        }

        function __embind_register_class(rawType, rawPointerType, rawConstPointerType, baseClassRawType, getActualTypeSignature, getActualType, upcastSignature, upcast, downcastSignature, downcast, name, destructorSignature, rawDestructor) {
          name = readLatin1String(name);
          getActualType = embind__requireFunction(getActualTypeSignature, getActualType);

          if (upcast) {
            upcast = embind__requireFunction(upcastSignature, upcast);
          }

          if (downcast) {
            downcast = embind__requireFunction(downcastSignature, downcast);
          }

          rawDestructor = embind__requireFunction(destructorSignature, rawDestructor);
          var legalFunctionName = makeLegalFunctionName(name);
          exposePublicSymbol(legalFunctionName, function () {
            throwUnboundTypeError("Cannot construct " + name + " due to unbound types", [baseClassRawType]);
          });
          whenDependentTypesAreResolved([rawType, rawPointerType, rawConstPointerType], baseClassRawType ? [baseClassRawType] : [], function (base) {
            base = base[0];
            var baseClass;
            var basePrototype;

            if (baseClassRawType) {
              baseClass = base.registeredClass;
              basePrototype = baseClass.instancePrototype;
            } else {
              basePrototype = ClassHandle.prototype;
            }

            var constructor = createNamedFunction(legalFunctionName, function () {
              if (Object.getPrototypeOf(this) !== instancePrototype) {
                throw new BindingError("Use 'new' to construct " + name);
              }

              if (registeredClass.constructor_body === void 0) {
                throw new BindingError(name + " has no accessible constructor");
              }

              var body = registeredClass.constructor_body[arguments.length];

              if (body === void 0) {
                throw new BindingError("Tried to invoke ctor of " + name + " with invalid number of parameters (" + arguments.length + ") - expected (" + Object.keys(registeredClass.constructor_body).toString() + ") parameters instead!");
              }

              return body.apply(this, arguments);
            });
            var instancePrototype = Object.create(basePrototype, {
              constructor: {
                value: constructor
              }
            });
            constructor.prototype = instancePrototype;
            var registeredClass = new RegisteredClass(name, constructor, instancePrototype, rawDestructor, baseClass, getActualType, upcast, downcast);
            var referenceConverter = new RegisteredPointer(name, registeredClass, true, false, false);
            var pointerConverter = new RegisteredPointer(name + "*", registeredClass, false, false, false);
            var constPointerConverter = new RegisteredPointer(name + " const*", registeredClass, false, true, false);
            registeredPointers[rawType] = {
              pointerType: pointerConverter,
              constPointerType: constPointerConverter
            };
            replacePublicSymbol(legalFunctionName, constructor);
            return [referenceConverter, pointerConverter, constPointerConverter];
          });
        }

        function heap32VectorToArray(count, firstElement) {
          var array = [];

          for (var i = 0; i < count; i++) {
            array.push(HEAPU32[firstElement + i * 4 >>> 2]);
          }

          return array;
        }

        function new_(constructor, argumentList) {
          if (!(constructor instanceof Function)) {
            throw new TypeError("new_ called with constructor type " + typeof constructor + " which is not a function");
          }

          var dummy = createNamedFunction(constructor.name || "unknownFunctionName", function () {});
          dummy.prototype = constructor.prototype;
          var obj = new dummy();
          var r = constructor.apply(obj, argumentList);
          return r instanceof Object ? r : obj;
        }

        function craftInvokerFunction(humanName, argTypes, classType, cppInvokerFunc, cppTargetFunc) {
          var argCount = argTypes.length;

          if (argCount < 2) {
            throwBindingError("argTypes array size mismatch! Must at least get return value and 'this' types!");
          }

          var isClassMethodFunc = argTypes[1] !== null && classType !== null;
          var needsDestructorStack = false;

          for (var i = 1; i < argTypes.length; ++i) {
            if (argTypes[i] !== null && argTypes[i].destructorFunction === void 0) {
              needsDestructorStack = true;
              break;
            }
          }

          var returns = argTypes[0].name !== "void";
          var argsList = "";
          var argsListWired = "";

          for (var i = 0; i < argCount - 2; ++i) {
            argsList += (i !== 0 ? ", " : "") + "arg" + i;
            argsListWired += (i !== 0 ? ", " : "") + "arg" + i + "Wired";
          }

          var invokerFnBody = "return function " + makeLegalFunctionName(humanName) + "(" + argsList + ") {\nif (arguments.length !== " + (argCount - 2) + ") {\nthrowBindingError('function " + humanName + " called with ' + arguments.length + ' arguments, expected " + (argCount - 2) + " args!');\n}\n";

          if (needsDestructorStack) {
            invokerFnBody += "var destructors = [];\n";
          }

          var dtorStack = needsDestructorStack ? "destructors" : "null";
          var args1 = ["throwBindingError", "invoker", "fn", "runDestructors", "retType", "classParam"];
          var args2 = [throwBindingError, cppInvokerFunc, cppTargetFunc, runDestructors, argTypes[0], argTypes[1]];

          if (isClassMethodFunc) {
            invokerFnBody += "var thisWired = classParam.toWireType(" + dtorStack + ", this);\n";
          }

          for (var i = 0; i < argCount - 2; ++i) {
            invokerFnBody += "var arg" + i + "Wired = argType" + i + ".toWireType(" + dtorStack + ", arg" + i + "); // " + argTypes[i + 2].name + "\n";
            args1.push("argType" + i);
            args2.push(argTypes[i + 2]);
          }

          if (isClassMethodFunc) {
            argsListWired = "thisWired" + (argsListWired.length > 0 ? ", " : "") + argsListWired;
          }

          invokerFnBody += (returns ? "var rv = " : "") + "invoker(fn" + (argsListWired.length > 0 ? ", " : "") + argsListWired + ");\n";

          if (needsDestructorStack) {
            invokerFnBody += "runDestructors(destructors);\n";
          } else {
            for (var i = isClassMethodFunc ? 1 : 2; i < argTypes.length; ++i) {
              var paramName = i === 1 ? "thisWired" : "arg" + (i - 2) + "Wired";

              if (argTypes[i].destructorFunction !== null) {
                invokerFnBody += paramName + "_dtor(" + paramName + "); // " + argTypes[i].name + "\n";
                args1.push(paramName + "_dtor");
                args2.push(argTypes[i].destructorFunction);
              }
            }
          }

          if (returns) {
            invokerFnBody += "var ret = retType.fromWireType(rv);\nreturn ret;\n";
          }

          invokerFnBody += "}\n";
          args1.push(invokerFnBody);
          var invokerFunction = new_(Function, args1).apply(null, args2);
          return invokerFunction;
        }

        function __embind_register_class_constructor(rawClassType, argCount, rawArgTypesAddr, invokerSignature, invoker, rawConstructor) {
          assert(argCount > 0);
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          invoker = embind__requireFunction(invokerSignature, invoker);
          whenDependentTypesAreResolved([], [rawClassType], function (classType) {
            classType = classType[0];
            var humanName = "constructor " + classType.name;

            if (classType.registeredClass.constructor_body === void 0) {
              classType.registeredClass.constructor_body = [];
            }

            if (classType.registeredClass.constructor_body[argCount - 1] !== void 0) {
              throw new BindingError("Cannot register multiple constructors with identical number of parameters (" + (argCount - 1) + ") for class '" + classType.name + "'! Overload resolution is currently only performed using the parameter count, not actual type info!");
            }

            classType.registeredClass.constructor_body[argCount - 1] = function () {
              throwUnboundTypeError("Cannot construct " + classType.name + " due to unbound types", rawArgTypes);
            };

            whenDependentTypesAreResolved([], rawArgTypes, function (argTypes) {
              argTypes.splice(1, 0, null);
              classType.registeredClass.constructor_body[argCount - 1] = craftInvokerFunction(humanName, argTypes, null, invoker, rawConstructor);
              return [];
            });
            return [];
          });
        }

        function __embind_register_class_function(rawClassType, methodName, argCount, rawArgTypesAddr, invokerSignature, rawInvoker, context, isPureVirtual) {
          var rawArgTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          methodName = readLatin1String(methodName);
          rawInvoker = embind__requireFunction(invokerSignature, rawInvoker);
          whenDependentTypesAreResolved([], [rawClassType], function (classType) {
            classType = classType[0];
            var humanName = classType.name + "." + methodName;

            if (methodName.startsWith("@@")) {
              methodName = Symbol[methodName.substring(2)];
            }

            if (isPureVirtual) {
              classType.registeredClass.pureVirtualFunctions.push(methodName);
            }

            function unboundTypesHandler() {
              throwUnboundTypeError("Cannot call " + humanName + " due to unbound types", rawArgTypes);
            }

            var proto = classType.registeredClass.instancePrototype;
            var method = proto[methodName];

            if (method === void 0 || method.overloadTable === void 0 && method.className !== classType.name && method.argCount === argCount - 2) {
              unboundTypesHandler.argCount = argCount - 2;
              unboundTypesHandler.className = classType.name;
              proto[methodName] = unboundTypesHandler;
            } else {
              ensureOverloadTable(proto, methodName, humanName);
              proto[methodName].overloadTable[argCount - 2] = unboundTypesHandler;
            }

            whenDependentTypesAreResolved([], rawArgTypes, function (argTypes) {
              var memberFunction = craftInvokerFunction(humanName, argTypes, classType, rawInvoker, context);

              if (proto[methodName].overloadTable === void 0) {
                memberFunction.argCount = argCount - 2;
                proto[methodName] = memberFunction;
              } else {
                proto[methodName].overloadTable[argCount - 2] = memberFunction;
              }

              return [];
            });
            return [];
          });
        }

        var emval_free_list = [];
        var emval_handle_array = [{}, {
          value: void 0
        }, {
          value: null
        }, {
          value: true
        }, {
          value: false
        }];

        function __emval_decref(handle) {
          if (handle > 4 && --emval_handle_array[handle].refcount === 0) {
            emval_handle_array[handle] = void 0;
            emval_free_list.push(handle);
          }
        }

        function count_emval_handles() {
          var count = 0;

          for (var i = 5; i < emval_handle_array.length; ++i) {
            if (emval_handle_array[i] !== void 0) {
              ++count;
            }
          }

          return count;
        }

        function get_first_emval() {
          for (var i = 5; i < emval_handle_array.length; ++i) {
            if (emval_handle_array[i] !== void 0) {
              return emval_handle_array[i];
            }
          }

          return null;
        }

        function init_emval() {
          Module["count_emval_handles"] = count_emval_handles;
          Module["get_first_emval"] = get_first_emval;
        }

        var Emval = {
          toValue: function toValue(handle) {
            if (!handle) {
              throwBindingError("Cannot use deleted val. handle = " + handle);
            }

            return emval_handle_array[handle].value;
          },
          toHandle: function toHandle(value) {
            switch (value) {
              case void 0:
                return 1;

              case null:
                return 2;

              case true:
                return 3;

              case false:
                return 4;

              default:
                {
                  var handle = emval_free_list.length ? emval_free_list.pop() : emval_handle_array.length;
                  emval_handle_array[handle] = {
                    refcount: 1,
                    value: value
                  };
                  return handle;
                }
            }
          }
        };

        function __embind_register_emval(rawType, name) {
          name = readLatin1String(name);
          registerType(rawType, {
            name: name,
            "fromWireType": function fromWireType(handle) {
              var rv = Emval.toValue(handle);

              __emval_decref(handle);

              return rv;
            },
            "toWireType": function toWireType(destructors, value) {
              return Emval.toHandle(value);
            },
            "argPackAdvance": 8,
            "readValueFromPointer": simpleReadValueFromPointer,
            destructorFunction: null
          });
        }

        function enumReadValueFromPointer(name, shift, signed) {
          switch (shift) {
            case 0:
              return function (pointer) {
                var heap = signed ? HEAP8 : HEAPU8;
                return this["fromWireType"](heap[pointer >>> 0]);
              };

            case 1:
              return function (pointer) {
                var heap = signed ? HEAP16 : HEAPU16;
                return this["fromWireType"](heap[pointer >>> 1]);
              };

            case 2:
              return function (pointer) {
                var heap = signed ? HEAP32 : HEAPU32;
                return this["fromWireType"](heap[pointer >>> 2]);
              };

            default:
              throw new TypeError("Unknown integer type: " + name);
          }
        }

        function __embind_register_enum(rawType, name, size, isSigned) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);

          function ctor() {}

          ctor.values = {};
          registerType(rawType, {
            name: name,
            constructor: ctor,
            "fromWireType": function fromWireType(c) {
              return this.constructor.values[c];
            },
            "toWireType": function toWireType(destructors, c) {
              return c.value;
            },
            "argPackAdvance": 8,
            "readValueFromPointer": enumReadValueFromPointer(name, shift, isSigned),
            destructorFunction: null
          });
          exposePublicSymbol(name, ctor);
        }

        function requireRegisteredType(rawType, humanName) {
          var impl = registeredTypes[rawType];

          if (impl === void 0) {
            throwBindingError(humanName + " has unknown type " + getTypeName(rawType));
          }

          return impl;
        }

        function __embind_register_enum_value(rawEnumType, name, enumValue) {
          var enumType = requireRegisteredType(rawEnumType, "enum");
          name = readLatin1String(name);
          var Enum = enumType.constructor;
          var Value = Object.create(enumType.constructor.prototype, {
            value: {
              value: enumValue
            },
            constructor: {
              value: createNamedFunction(enumType.name + "_" + name, function () {})
            }
          });
          Enum.values[enumValue] = Value;
          Enum[name] = Value;
        }

        function embindRepr(v) {
          if (v === null) {
            return "null";
          }

          var t = typeof v;

          if (t === "object" || t === "array" || t === "function") {
            return v.toString();
          } else {
            return "" + v;
          }
        }

        function floatReadValueFromPointer(name, shift) {
          switch (shift) {
            case 2:
              return function (pointer) {
                return this["fromWireType"](HEAPF32[pointer >>> 2]);
              };

            case 3:
              return function (pointer) {
                return this["fromWireType"](HEAPF64[pointer >>> 3]);
              };

            default:
              throw new TypeError("Unknown float type: " + name);
          }
        }

        function __embind_register_float(rawType, name, size) {
          var shift = getShiftFromSize(size);
          name = readLatin1String(name);
          registerType(rawType, {
            name: name,
            "fromWireType": function fromWireType(value) {
              return value;
            },
            "toWireType": function toWireType(destructors, value) {
              return value;
            },
            "argPackAdvance": 8,
            "readValueFromPointer": floatReadValueFromPointer(name, shift),
            destructorFunction: null
          });
        }

        function __embind_register_function(name, argCount, rawArgTypesAddr, signature, rawInvoker, fn) {
          var argTypes = heap32VectorToArray(argCount, rawArgTypesAddr);
          name = readLatin1String(name);
          rawInvoker = embind__requireFunction(signature, rawInvoker);
          exposePublicSymbol(name, function () {
            throwUnboundTypeError("Cannot call " + name + " due to unbound types", argTypes);
          }, argCount - 1);
          whenDependentTypesAreResolved([], argTypes, function (argTypes2) {
            var invokerArgsArray = [argTypes2[0], null].concat(argTypes2.slice(1));
            replacePublicSymbol(name, craftInvokerFunction(name, invokerArgsArray, null, rawInvoker, fn), argCount - 1);
            return [];
          });
        }

        function integerReadValueFromPointer(name, shift, signed) {
          switch (shift) {
            case 0:
              return signed ? function readS8FromPointer(pointer) {
                return HEAP8[pointer >>> 0];
              } : function readU8FromPointer(pointer) {
                return HEAPU8[pointer >>> 0];
              };

            case 1:
              return signed ? function readS16FromPointer(pointer) {
                return HEAP16[pointer >>> 1];
              } : function readU16FromPointer(pointer) {
                return HEAPU16[pointer >>> 1];
              };

            case 2:
              return signed ? function readS32FromPointer(pointer) {
                return HEAP32[pointer >>> 2];
              } : function readU32FromPointer(pointer) {
                return HEAPU32[pointer >>> 2];
              };

            default:
              throw new TypeError("Unknown integer type: " + name);
          }
        }

        function __embind_register_integer(primitiveType, name, size, minRange, maxRange) {
          name = readLatin1String(name);
          var shift = getShiftFromSize(size);

          var fromWireType = function fromWireType(value) {
            return value;
          };

          if (minRange === 0) {
            var bitshift = 32 - 8 * size;

            fromWireType = function fromWireType(value) {
              return value << bitshift >>> bitshift;
            };
          }

          var isUnsignedType = name.includes("unsigned");

          var checkAssertions = function checkAssertions(value, toTypeName) {};

          var toWireType;

          if (isUnsignedType) {
            toWireType = function toWireType(destructors, value) {
              checkAssertions(value, this.name);
              return value >>> 0;
            };
          } else {
            toWireType = function toWireType(destructors, value) {
              checkAssertions(value, this.name);
              return value;
            };
          }

          registerType(primitiveType, {
            name: name,
            "fromWireType": fromWireType,
            "toWireType": toWireType,
            "argPackAdvance": 8,
            "readValueFromPointer": integerReadValueFromPointer(name, shift, minRange !== 0),
            destructorFunction: null
          });
        }

        function __embind_register_memory_view(rawType, dataTypeIndex, name) {
          var typeMapping = [Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array];
          var TA = typeMapping[dataTypeIndex];

          function decodeMemoryView(handle) {
            handle = handle >> 2;
            var heap = HEAPU32;
            var size = heap[handle >>> 0];
            var data = heap[handle + 1 >>> 0];
            return new TA(heap.buffer, data, size);
          }

          name = readLatin1String(name);
          registerType(rawType, {
            name: name,
            "fromWireType": decodeMemoryView,
            "argPackAdvance": 8,
            "readValueFromPointer": decodeMemoryView
          }, {
            ignoreDuplicateRegistrations: true
          });
        }

        function __embind_register_std_string(rawType, name) {
          name = readLatin1String(name);
          var stdStringIsUTF8 = name === "std::string";
          registerType(rawType, {
            name: name,
            "fromWireType": function fromWireType(value) {
              var length = HEAPU32[value >>> 2];
              var payload = value + 4;
              var str;

              if (stdStringIsUTF8) {
                var decodeStartPtr = payload;

                for (var i = 0; i <= length; ++i) {
                  var currentBytePtr = payload + i;

                  if (i == length || HEAPU8[currentBytePtr >>> 0] == 0) {
                    var maxRead = currentBytePtr - decodeStartPtr;
                    var stringSegment = UTF8ToString(decodeStartPtr, maxRead);

                    if (str === void 0) {
                      str = stringSegment;
                    } else {
                      str += String.fromCharCode(0);
                      str += stringSegment;
                    }

                    decodeStartPtr = currentBytePtr + 1;
                  }
                }
              } else {
                var a = new Array(length);

                for (var i = 0; i < length; ++i) {
                  a[i] = String.fromCharCode(HEAPU8[payload + i >>> 0]);
                }

                str = a.join("");
              }

              _free3(value);

              return str;
            },
            "toWireType": function toWireType(destructors, value) {
              if (value instanceof ArrayBuffer) {
                value = new Uint8Array(value);
              }

              var length;
              var valueIsOfTypeString = typeof value == "string";

              if (!(valueIsOfTypeString || value instanceof Uint8Array || value instanceof Uint8ClampedArray || value instanceof Int8Array)) {
                throwBindingError("Cannot pass non-string to std::string");
              }

              if (stdStringIsUTF8 && valueIsOfTypeString) {
                length = lengthBytesUTF8(value);
              } else {
                length = value.length;
              }

              var base = _malloc3(4 + length + 1);

              var ptr = base + 4;
              ptr >>>= 0;
              HEAPU32[base >>> 2] = length;

              if (stdStringIsUTF8 && valueIsOfTypeString) {
                stringToUTF8(value, ptr, length + 1);
              } else {
                if (valueIsOfTypeString) {
                  for (var i = 0; i < length; ++i) {
                    var charCode = value.charCodeAt(i);

                    if (charCode > 255) {
                      _free3(ptr);

                      throwBindingError("String has UTF-16 code units that do not fit in 8 bits");
                    }

                    HEAPU8[ptr + i >>> 0] = charCode;
                  }
                } else {
                  for (var i = 0; i < length; ++i) {
                    HEAPU8[ptr + i >>> 0] = value[i];
                  }
                }
              }

              if (destructors !== null) {
                destructors.push(_free3, base);
              }

              return base;
            },
            "argPackAdvance": 8,
            "readValueFromPointer": simpleReadValueFromPointer,
            destructorFunction: function destructorFunction(ptr) {
              _free3(ptr);
            }
          });
        }

        var UTF16Decoder = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0;

        function UTF16ToString(ptr, maxBytesToRead) {
          var endPtr = ptr;
          var idx = endPtr >> 1;
          var maxIdx = idx + maxBytesToRead / 2;

          while (!(idx >= maxIdx) && HEAPU16[idx >>> 0]) {
            ++idx;
          }

          endPtr = idx << 1;
          if (endPtr - ptr > 32 && UTF16Decoder) return UTF16Decoder.decode(HEAPU8.subarray(ptr >>> 0, endPtr >>> 0));
          var str = "";

          for (var i = 0; !(i >= maxBytesToRead / 2); ++i) {
            var codeUnit = HEAP16[ptr + i * 2 >>> 1];
            if (codeUnit == 0) break;
            str += String.fromCharCode(codeUnit);
          }

          return str;
        }

        function stringToUTF16(str, outPtr, maxBytesToWrite) {
          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }

          if (maxBytesToWrite < 2) return 0;
          maxBytesToWrite -= 2;
          var startPtr = outPtr;
          var numCharsToWrite = maxBytesToWrite < str.length * 2 ? maxBytesToWrite / 2 : str.length;

          for (var i = 0; i < numCharsToWrite; ++i) {
            var codeUnit = str.charCodeAt(i);
            HEAP16[outPtr >>> 1] = codeUnit;
            outPtr += 2;
          }

          HEAP16[outPtr >>> 1] = 0;
          return outPtr - startPtr;
        }

        function lengthBytesUTF16(str) {
          return str.length * 2;
        }

        function UTF32ToString(ptr, maxBytesToRead) {
          var i = 0;
          var str = "";

          while (!(i >= maxBytesToRead / 4)) {
            var utf32 = HEAP32[ptr + i * 4 >>> 2];
            if (utf32 == 0) break;
            ++i;

            if (utf32 >= 65536) {
              var ch = utf32 - 65536;
              str += String.fromCharCode(55296 | ch >> 10, 56320 | ch & 1023);
            } else {
              str += String.fromCharCode(utf32);
            }
          }

          return str;
        }

        function stringToUTF32(str, outPtr, maxBytesToWrite) {
          outPtr >>>= 0;

          if (maxBytesToWrite === void 0) {
            maxBytesToWrite = 2147483647;
          }

          if (maxBytesToWrite < 4) return 0;
          var startPtr = outPtr;
          var endPtr = startPtr + maxBytesToWrite - 4;

          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);

            if (codeUnit >= 55296 && codeUnit <= 57343) {
              var trailSurrogate = str.charCodeAt(++i);
              codeUnit = 65536 + ((codeUnit & 1023) << 10) | trailSurrogate & 1023;
            }

            HEAP32[outPtr >>> 2] = codeUnit;
            outPtr += 4;
            if (outPtr + 4 > endPtr) break;
          }

          HEAP32[outPtr >>> 2] = 0;
          return outPtr - startPtr;
        }

        function lengthBytesUTF32(str) {
          var len = 0;

          for (var i = 0; i < str.length; ++i) {
            var codeUnit = str.charCodeAt(i);
            if (codeUnit >= 55296 && codeUnit <= 57343) ++i;
            len += 4;
          }

          return len;
        }

        function __embind_register_std_wstring(rawType, charSize, name) {
          name = readLatin1String(name);
          var decodeString, encodeString, getHeap, lengthBytesUTF, shift;

          if (charSize === 2) {
            decodeString = UTF16ToString;
            encodeString = stringToUTF16;
            lengthBytesUTF = lengthBytesUTF16;

            getHeap = function getHeap() {
              return HEAPU16;
            };

            shift = 1;
          } else if (charSize === 4) {
            decodeString = UTF32ToString;
            encodeString = stringToUTF32;
            lengthBytesUTF = lengthBytesUTF32;

            getHeap = function getHeap() {
              return HEAPU32;
            };

            shift = 2;
          }

          registerType(rawType, {
            name: name,
            "fromWireType": function fromWireType(value) {
              var length = HEAPU32[value >>> 2];
              var HEAP = getHeap();
              var str;
              var decodeStartPtr = value + 4;

              for (var i = 0; i <= length; ++i) {
                var currentBytePtr = value + 4 + i * charSize;

                if (i == length || HEAP[currentBytePtr >>> shift] == 0) {
                  var maxReadBytes = currentBytePtr - decodeStartPtr;
                  var stringSegment = decodeString(decodeStartPtr, maxReadBytes);

                  if (str === void 0) {
                    str = stringSegment;
                  } else {
                    str += String.fromCharCode(0);
                    str += stringSegment;
                  }

                  decodeStartPtr = currentBytePtr + charSize;
                }
              }

              _free3(value);

              return str;
            },
            "toWireType": function toWireType(destructors, value) {
              if (!(typeof value == "string")) {
                throwBindingError("Cannot pass non-string to C++ string type " + name);
              }

              var length = lengthBytesUTF(value);

              var ptr = _malloc3(4 + length + charSize);

              ptr >>>= 0;
              HEAPU32[ptr >>> 2] = length >> shift;
              encodeString(value, ptr + 4, length + charSize);

              if (destructors !== null) {
                destructors.push(_free3, ptr);
              }

              return ptr;
            },
            "argPackAdvance": 8,
            "readValueFromPointer": simpleReadValueFromPointer,
            destructorFunction: function destructorFunction(ptr) {
              _free3(ptr);
            }
          });
        }

        function __embind_register_value_array(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          tupleRegistrations[rawType] = {
            name: readLatin1String(name),
            rawConstructor: embind__requireFunction(constructorSignature, rawConstructor),
            rawDestructor: embind__requireFunction(destructorSignature, rawDestructor),
            elements: []
          };
        }

        function __embind_register_value_array_element(rawTupleType, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          tupleRegistrations[rawTupleType].elements.push({
            getterReturnType: getterReturnType,
            getter: embind__requireFunction(getterSignature, getter),
            getterContext: getterContext,
            setterArgumentType: setterArgumentType,
            setter: embind__requireFunction(setterSignature, setter),
            setterContext: setterContext
          });
        }

        function __embind_register_value_object(rawType, name, constructorSignature, rawConstructor, destructorSignature, rawDestructor) {
          structRegistrations[rawType] = {
            name: readLatin1String(name),
            rawConstructor: embind__requireFunction(constructorSignature, rawConstructor),
            rawDestructor: embind__requireFunction(destructorSignature, rawDestructor),
            fields: []
          };
        }

        function __embind_register_value_object_field(structType, fieldName, getterReturnType, getterSignature, getter, getterContext, setterArgumentType, setterSignature, setter, setterContext) {
          structRegistrations[structType].fields.push({
            fieldName: readLatin1String(fieldName),
            getterReturnType: getterReturnType,
            getter: embind__requireFunction(getterSignature, getter),
            getterContext: getterContext,
            setterArgumentType: setterArgumentType,
            setter: embind__requireFunction(setterSignature, setter),
            setterContext: setterContext
          });
        }

        function __embind_register_void(rawType, name) {
          name = readLatin1String(name);
          registerType(rawType, {
            isVoid: true,
            name: name,
            "argPackAdvance": 0,
            "fromWireType": function fromWireType() {
              return void 0;
            },
            "toWireType": function toWireType(destructors, o) {
              return void 0;
            }
          });
        }

        function __emval_as(handle, returnType, destructorsRef) {
          handle = Emval.toValue(handle);
          returnType = requireRegisteredType(returnType, "emval::as");
          var destructors = [];
          var rd = Emval.toHandle(destructors);
          HEAPU32[destructorsRef >>> 2] = rd;
          return returnType["toWireType"](destructors, handle);
        }

        function emval_lookupTypes(argCount, argTypes) {
          var a = new Array(argCount);

          for (var i = 0; i < argCount; ++i) {
            a[i] = requireRegisteredType(HEAPU32[argTypes + i * 4 >>> 2], "parameter " + i);
          }

          return a;
        }

        function __emval_call(handle, argCount, argTypes, argv) {
          handle = Emval.toValue(handle);
          var types = emval_lookupTypes(argCount, argTypes);
          var args = new Array(argCount);

          for (var i = 0; i < argCount; ++i) {
            var type = types[i];
            args[i] = type["readValueFromPointer"](argv);
            argv += type["argPackAdvance"];
          }

          var rv = handle.apply(void 0, args);
          return Emval.toHandle(rv);
        }

        var emval_symbols = {};

        function getStringOrSymbol(address) {
          var symbol = emval_symbols[address];

          if (symbol === void 0) {
            return readLatin1String(address);
          }

          return symbol;
        }

        function emval_get_global() {
          if (typeof globalThis == "object") {
            return globalThis;
          }

          return function () {
            return Function;
          }()("return this")();
        }

        function __emval_get_global(name) {
          if (name === 0) {
            return Emval.toHandle(emval_get_global());
          } else {
            name = getStringOrSymbol(name);
            return Emval.toHandle(emval_get_global()[name]);
          }
        }

        function __emval_get_property(handle, key) {
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          return Emval.toHandle(handle[key]);
        }

        function __emval_incref(handle) {
          if (handle > 4) {
            emval_handle_array[handle].refcount += 1;
          }
        }

        function __emval_instanceof(object, constructor) {
          object = Emval.toValue(object);
          constructor = Emval.toValue(constructor);
          return object instanceof constructor;
        }

        function __emval_is_number(handle) {
          handle = Emval.toValue(handle);
          return typeof handle == "number";
        }

        function __emval_new_array() {
          return Emval.toHandle([]);
        }

        function __emval_new_cstring(v) {
          return Emval.toHandle(getStringOrSymbol(v));
        }

        function __emval_new_object() {
          return Emval.toHandle({});
        }

        function __emval_run_destructors(handle) {
          var destructors = Emval.toValue(handle);
          runDestructors(destructors);

          __emval_decref(handle);
        }

        function __emval_set_property(handle, key, value) {
          handle = Emval.toValue(handle);
          key = Emval.toValue(key);
          value = Emval.toValue(value);
          handle[key] = value;
        }

        function __emval_take_value(type, arg) {
          type = requireRegisteredType(type, "_emval_take_value");
          var v = type["readValueFromPointer"](arg);
          return Emval.toHandle(v);
        }

        function _abort() {
          abort("");
        }

        function _emscripten_memcpy_big(dest, src, num) {
          HEAPU8.copyWithin(dest >>> 0, src >>> 0, src + num >>> 0);
        }

        function getHeapMax() {
          return 4294901760;
        }

        function emscripten_realloc_buffer(size) {
          var b = wasmMemory.buffer;

          try {
            wasmMemory.grow(size - b.byteLength + 65535 >>> 16);
            updateMemoryViews();
            return 1;
          } catch (e) {}
        }

        function _emscripten_resize_heap(requestedSize) {
          var oldSize = HEAPU8.length;
          requestedSize = requestedSize >>> 0;
          var maxHeapSize = getHeapMax();

          if (requestedSize > maxHeapSize) {
            return false;
          }

          var alignUp = function alignUp(x, multiple) {
            return x + (multiple - x % multiple) % multiple;
          };

          for (var cutDown = 1; cutDown <= 4; cutDown *= 2) {
            var overGrownHeapSize = oldSize * (1 + 0.2 / cutDown);
            overGrownHeapSize = Math.min(overGrownHeapSize, requestedSize + 100663296);
            var newSize = Math.min(maxHeapSize, alignUp(Math.max(requestedSize, overGrownHeapSize), 65536));
            var replacement = emscripten_realloc_buffer(newSize);

            if (replacement) {
              return true;
            }
          }

          return false;
        }

        var ENV = {};

        function getExecutableName() {
          return thisProgram || "./this.program";
        }

        function getEnvStrings() {
          if (!getEnvStrings.strings) {
            var lang = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8";
            var env = {
              "USER": "web_user",
              "LOGNAME": "web_user",
              "PATH": "/",
              "PWD": "/",
              "HOME": "/home/web_user",
              "LANG": lang,
              "_": getExecutableName()
            };

            for (var x in ENV) {
              if (ENV[x] === void 0) delete env[x];else env[x] = ENV[x];
            }

            var strings = [];

            for (var x in env) {
              strings.push(x + "=" + env[x]);
            }

            getEnvStrings.strings = strings;
          }

          return getEnvStrings.strings;
        }

        function writeAsciiToMemory(str, buffer, dontAddNull) {
          for (var i = 0; i < str.length; ++i) {
            HEAP8[buffer++ >>> 0] = str.charCodeAt(i);
          }

          if (!dontAddNull) HEAP8[buffer >>> 0] = 0;
        }

        function _environ_get(__environ, environ_buf) {
          var bufSize = 0;
          getEnvStrings().forEach(function (string, i) {
            var ptr = environ_buf + bufSize;
            HEAPU32[__environ + i * 4 >>> 2] = ptr;
            writeAsciiToMemory(string, ptr);
            bufSize += string.length + 1;
          });
          return 0;
        }

        function _environ_sizes_get(penviron_count, penviron_buf_size) {
          var strings = getEnvStrings();
          HEAPU32[penviron_count >>> 2] = strings.length;
          var bufSize = 0;
          strings.forEach(function (string) {
            bufSize += string.length + 1;
          });
          HEAPU32[penviron_buf_size >>> 2] = bufSize;
          return 0;
        }

        function _fd_close(fd) {
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.close(stream);
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return e.errno;
          }
        }

        function doReadv(stream, iov, iovcnt, offset) {
          var ret = 0;

          for (var i = 0; i < iovcnt; i++) {
            var ptr = HEAPU32[iov >>> 2];
            var len = HEAPU32[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.read(stream, HEAP8, ptr, len, offset);
            if (curr < 0) return -1;
            ret += curr;
            if (curr < len) break;

            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }

          return ret;
        }

        function _fd_read(fd, iov, iovcnt, pnum) {
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doReadv(stream, iov, iovcnt);
            HEAPU32[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return e.errno;
          }
        }

        function convertI32PairToI53Checked(lo, hi) {
          return hi + 2097152 >>> 0 < 4194305 - !!lo ? (lo >>> 0) + hi * 4294967296 : NaN;
        }

        function _fd_seek(fd, offset_low, offset_high, whence, newOffset) {
          try {
            var offset = convertI32PairToI53Checked(offset_low, offset_high);
            if (isNaN(offset)) return 61;
            var stream = SYSCALLS.getStreamFromFD(fd);
            FS.llseek(stream, offset, whence);
            tempI64 = [stream.position >>> 0, (tempDouble = stream.position, +Math.abs(tempDouble) >= 1 ? tempDouble > 0 ? (Math.min(+Math.floor(tempDouble / 4294967296), 4294967295) | 0) >>> 0 : ~~+Math.ceil((tempDouble - +(~~tempDouble >>> 0)) / 4294967296) >>> 0 : 0)], HEAP32[newOffset >>> 2] = tempI64[0], HEAP32[newOffset + 4 >>> 2] = tempI64[1];
            if (stream.getdents && offset === 0 && whence === 0) stream.getdents = null;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return e.errno;
          }
        }

        function doWritev(stream, iov, iovcnt, offset) {
          var ret = 0;

          for (var i = 0; i < iovcnt; i++) {
            var ptr = HEAPU32[iov >>> 2];
            var len = HEAPU32[iov + 4 >>> 2];
            iov += 8;
            var curr = FS.write(stream, HEAP8, ptr, len, offset);
            if (curr < 0) return -1;
            ret += curr;

            if (typeof offset !== "undefined") {
              offset += curr;
            }
          }

          return ret;
        }

        function _fd_write(fd, iov, iovcnt, pnum) {
          try {
            var stream = SYSCALLS.getStreamFromFD(fd);
            var num = doWritev(stream, iov, iovcnt);
            HEAPU32[pnum >>> 2] = num;
            return 0;
          } catch (e) {
            if (typeof FS == "undefined" || !(e instanceof FS.ErrnoError)) throw e;
            return e.errno;
          }
        }

        function __isLeapYear(year) {
          return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        }

        function __arraySum(array, index) {
          var sum = 0;

          for (var i = 0; i <= index; sum += array[i++]) {}

          return sum;
        }

        var __MONTH_DAYS_LEAP = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        var __MONTH_DAYS_REGULAR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        function __addDays(date, days) {
          var newDate = new Date(date.getTime());

          while (days > 0) {
            var leap = __isLeapYear(newDate.getFullYear());

            var currentMonth = newDate.getMonth();
            var daysInCurrentMonth = (leap ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR)[currentMonth];

            if (days > daysInCurrentMonth - newDate.getDate()) {
              days -= daysInCurrentMonth - newDate.getDate() + 1;
              newDate.setDate(1);

              if (currentMonth < 11) {
                newDate.setMonth(currentMonth + 1);
              } else {
                newDate.setMonth(0);
                newDate.setFullYear(newDate.getFullYear() + 1);
              }
            } else {
              newDate.setDate(newDate.getDate() + days);
              return newDate;
            }
          }

          return newDate;
        }

        function writeArrayToMemory(array, buffer) {
          HEAP8.set(array, buffer >>> 0);
        }

        function _strftime(s, maxsize, format, tm) {
          var tm_zone = HEAP32[tm + 40 >>> 2];
          var date = {
            tm_sec: HEAP32[tm >>> 2],
            tm_min: HEAP32[tm + 4 >>> 2],
            tm_hour: HEAP32[tm + 8 >>> 2],
            tm_mday: HEAP32[tm + 12 >>> 2],
            tm_mon: HEAP32[tm + 16 >>> 2],
            tm_year: HEAP32[tm + 20 >>> 2],
            tm_wday: HEAP32[tm + 24 >>> 2],
            tm_yday: HEAP32[tm + 28 >>> 2],
            tm_isdst: HEAP32[tm + 32 >>> 2],
            tm_gmtoff: HEAP32[tm + 36 >>> 2],
            tm_zone: tm_zone ? UTF8ToString(tm_zone) : ""
          };
          var pattern = UTF8ToString(format);
          var EXPANSION_RULES_1 = {
            "%c": "%a %b %d %H:%M:%S %Y",
            "%D": "%m/%d/%y",
            "%F": "%Y-%m-%d",
            "%h": "%b",
            "%r": "%I:%M:%S %p",
            "%R": "%H:%M",
            "%T": "%H:%M:%S",
            "%x": "%m/%d/%y",
            "%X": "%H:%M:%S",
            "%Ec": "%c",
            "%EC": "%C",
            "%Ex": "%m/%d/%y",
            "%EX": "%H:%M:%S",
            "%Ey": "%y",
            "%EY": "%Y",
            "%Od": "%d",
            "%Oe": "%e",
            "%OH": "%H",
            "%OI": "%I",
            "%Om": "%m",
            "%OM": "%M",
            "%OS": "%S",
            "%Ou": "%u",
            "%OU": "%U",
            "%OV": "%V",
            "%Ow": "%w",
            "%OW": "%W",
            "%Oy": "%y"
          };

          for (var rule in EXPANSION_RULES_1) {
            pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_1[rule]);
          }

          var WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
          var MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

          function leadingSomething(value, digits, character) {
            var str = typeof value == "number" ? value.toString() : value || "";

            while (str.length < digits) {
              str = character[0] + str;
            }

            return str;
          }

          function leadingNulls(value, digits) {
            return leadingSomething(value, digits, "0");
          }

          function compareByDay(date1, date2) {
            function sgn(value) {
              return value < 0 ? -1 : value > 0 ? 1 : 0;
            }

            var compare;

            if ((compare = sgn(date1.getFullYear() - date2.getFullYear())) === 0) {
              if ((compare = sgn(date1.getMonth() - date2.getMonth())) === 0) {
                compare = sgn(date1.getDate() - date2.getDate());
              }
            }

            return compare;
          }

          function getFirstWeekStartDate(janFourth) {
            switch (janFourth.getDay()) {
              case 0:
                return new Date(janFourth.getFullYear() - 1, 11, 29);

              case 1:
                return janFourth;

              case 2:
                return new Date(janFourth.getFullYear(), 0, 3);

              case 3:
                return new Date(janFourth.getFullYear(), 0, 2);

              case 4:
                return new Date(janFourth.getFullYear(), 0, 1);

              case 5:
                return new Date(janFourth.getFullYear() - 1, 11, 31);

              case 6:
                return new Date(janFourth.getFullYear() - 1, 11, 30);
            }
          }

          function getWeekBasedYear(date2) {
            var thisDate = __addDays(new Date(date2.tm_year + 1900, 0, 1), date2.tm_yday);

            var janFourthThisYear = new Date(thisDate.getFullYear(), 0, 4);
            var janFourthNextYear = new Date(thisDate.getFullYear() + 1, 0, 4);
            var firstWeekStartThisYear = getFirstWeekStartDate(janFourthThisYear);
            var firstWeekStartNextYear = getFirstWeekStartDate(janFourthNextYear);

            if (compareByDay(firstWeekStartThisYear, thisDate) <= 0) {
              if (compareByDay(firstWeekStartNextYear, thisDate) <= 0) {
                return thisDate.getFullYear() + 1;
              }

              return thisDate.getFullYear();
            }

            return thisDate.getFullYear() - 1;
          }

          var EXPANSION_RULES_2 = {
            "%a": function a(date2) {
              return WEEKDAYS[date2.tm_wday].substring(0, 3);
            },
            "%A": function A(date2) {
              return WEEKDAYS[date2.tm_wday];
            },
            "%b": function b(date2) {
              return MONTHS[date2.tm_mon].substring(0, 3);
            },
            "%B": function B(date2) {
              return MONTHS[date2.tm_mon];
            },
            "%C": function C(date2) {
              var year = date2.tm_year + 1900;
              return leadingNulls(year / 100 | 0, 2);
            },
            "%d": function d(date2) {
              return leadingNulls(date2.tm_mday, 2);
            },
            "%e": function e(date2) {
              return leadingSomething(date2.tm_mday, 2, " ");
            },
            "%g": function g(date2) {
              return getWeekBasedYear(date2).toString().substring(2);
            },
            "%G": function G(date2) {
              return getWeekBasedYear(date2);
            },
            "%H": function H(date2) {
              return leadingNulls(date2.tm_hour, 2);
            },
            "%I": function I(date2) {
              var twelveHour = date2.tm_hour;
              if (twelveHour == 0) twelveHour = 12;else if (twelveHour > 12) twelveHour -= 12;
              return leadingNulls(twelveHour, 2);
            },
            "%j": function j(date2) {
              return leadingNulls(date2.tm_mday + __arraySum(__isLeapYear(date2.tm_year + 1900) ? __MONTH_DAYS_LEAP : __MONTH_DAYS_REGULAR, date2.tm_mon - 1), 3);
            },
            "%m": function m(date2) {
              return leadingNulls(date2.tm_mon + 1, 2);
            },
            "%M": function M(date2) {
              return leadingNulls(date2.tm_min, 2);
            },
            "%n": function n() {
              return "\n";
            },
            "%p": function p(date2) {
              if (date2.tm_hour >= 0 && date2.tm_hour < 12) {
                return "AM";
              }

              return "PM";
            },
            "%S": function S(date2) {
              return leadingNulls(date2.tm_sec, 2);
            },
            "%t": function t() {
              return "	";
            },
            "%u": function u(date2) {
              return date2.tm_wday || 7;
            },
            "%U": function U(date2) {
              var days = date2.tm_yday + 7 - date2.tm_wday;
              return leadingNulls(Math.floor(days / 7), 2);
            },
            "%V": function V(date2) {
              var val = Math.floor((date2.tm_yday + 7 - (date2.tm_wday + 6) % 7) / 7);

              if ((date2.tm_wday + 371 - date2.tm_yday - 2) % 7 <= 2) {
                val++;
              }

              if (!val) {
                val = 52;
                var dec31 = (date2.tm_wday + 7 - date2.tm_yday - 1) % 7;

                if (dec31 == 4 || dec31 == 5 && __isLeapYear(date2.tm_year % 400 - 1)) {
                  val++;
                }
              } else if (val == 53) {
                var jan1 = (date2.tm_wday + 371 - date2.tm_yday) % 7;
                if (jan1 != 4 && (jan1 != 3 || !__isLeapYear(date2.tm_year))) val = 1;
              }

              return leadingNulls(val, 2);
            },
            "%w": function w(date2) {
              return date2.tm_wday;
            },
            "%W": function W(date2) {
              var days = date2.tm_yday + 7 - (date2.tm_wday + 6) % 7;
              return leadingNulls(Math.floor(days / 7), 2);
            },
            "%y": function y(date2) {
              return (date2.tm_year + 1900).toString().substring(2);
            },
            "%Y": function Y(date2) {
              return date2.tm_year + 1900;
            },
            "%z": function z(date2) {
              var off = date2.tm_gmtoff;
              var ahead = off >= 0;
              off = Math.abs(off) / 60;
              off = off / 60 * 100 + off % 60;
              return (ahead ? "+" : "-") + String("0000" + off).slice(-4);
            },
            "%Z": function Z(date2) {
              return date2.tm_zone;
            },
            "%%": function _() {
              return "%";
            }
          };
          pattern = pattern.replace(/%%/g, "\0\0");

          for (var rule in EXPANSION_RULES_2) {
            if (pattern.includes(rule)) {
              pattern = pattern.replace(new RegExp(rule, "g"), EXPANSION_RULES_2[rule](date));
            }
          }

          pattern = pattern.replace(/\0\0/g, "%");
          var bytes = intArrayFromString(pattern, false);

          if (bytes.length > maxsize) {
            return 0;
          }

          writeArrayToMemory(bytes, s);
          return bytes.length - 1;
        }

        function _strftime_l(s, maxsize, format, tm, loc) {
          return _strftime(s, maxsize, format, tm);
        }

        var FSNode = function FSNode(parent, name, mode, rdev) {
          if (!parent) {
            parent = this;
          }

          this.parent = parent;
          this.mount = parent.mount;
          this.mounted = null;
          this.id = FS.nextInode++;
          this.name = name;
          this.mode = mode;
          this.node_ops = {};
          this.stream_ops = {};
          this.rdev = rdev;
        };

        var readMode = 292 | 73;
        var writeMode = 146;
        Object.defineProperties(FSNode.prototype, {
          read: {
            get: function get() {
              return (this.mode & readMode) === readMode;
            },
            set: function set(val) {
              val ? this.mode |= readMode : this.mode &= ~readMode;
            }
          },
          write: {
            get: function get() {
              return (this.mode & writeMode) === writeMode;
            },
            set: function set(val) {
              val ? this.mode |= writeMode : this.mode &= ~writeMode;
            }
          },
          isFolder: {
            get: function get() {
              return FS.isDir(this.mode);
            }
          },
          isDevice: {
            get: function get() {
              return FS.isChrdev(this.mode);
            }
          }
        });
        FS.FSNode = FSNode;
        FS.staticInit();
        InternalError = Module["InternalError"] = extendError(Error, "InternalError");
        embind_init_charCodes();
        BindingError = Module["BindingError"] = extendError(Error, "BindingError");
        init_ClassHandle();
        init_embind();
        init_RegisteredPointer();
        UnboundTypeError = Module["UnboundTypeError"] = extendError(Error, "UnboundTypeError");
        init_emval();
        var wasmImports = {
          "e": ___cxa_throw,
          "z": ___syscall_fcntl64,
          "L": ___syscall_ioctl,
          "M": ___syscall_openat,
          "T": __embind_finalize_value_array,
          "s": __embind_finalize_value_object,
          "G": __embind_register_bigint,
          "R": __embind_register_bool,
          "r": __embind_register_class,
          "q": __embind_register_class_constructor,
          "c": __embind_register_class_function,
          "Q": __embind_register_emval,
          "D": __embind_register_enum,
          "p": __embind_register_enum_value,
          "B": __embind_register_float,
          "b": __embind_register_function,
          "o": __embind_register_integer,
          "h": __embind_register_memory_view,
          "C": __embind_register_std_string,
          "v": __embind_register_std_wstring,
          "U": __embind_register_value_array,
          "j": __embind_register_value_array_element,
          "t": __embind_register_value_object,
          "g": __embind_register_value_object_field,
          "S": __embind_register_void,
          "l": __emval_as,
          "x": __emval_call,
          "a": __emval_decref,
          "E": __emval_get_global,
          "m": __emval_get_property,
          "n": __emval_incref,
          "W": __emval_instanceof,
          "V": __emval_is_number,
          "w": __emval_new_array,
          "f": __emval_new_cstring,
          "u": __emval_new_object,
          "k": __emval_run_destructors,
          "i": __emval_set_property,
          "d": __emval_take_value,
          "A": _abort,
          "P": _emscripten_memcpy_big,
          "N": _emscripten_resize_heap,
          "I": _environ_get,
          "J": _environ_sizes_get,
          "y": _fd_close,
          "K": _fd_read,
          "F": _fd_seek,
          "O": _fd_write,
          "H": _strftime_l
        };
        createWasm();

        var _malloc3 = function _malloc() {
          return (_malloc3 = Module["asm"]["_"]).apply(null, arguments);
        };

        var ___getTypeName = Module["___getTypeName"] = function () {
          return (___getTypeName = Module["___getTypeName"] = Module["asm"]["$"]).apply(null, arguments);
        };

        Module["__embind_initialize_bindings"] = function () {
          return (Module["__embind_initialize_bindings"] = Module["asm"]["aa"]).apply(null, arguments);
        };

        var _errno_location2 = function ___errno_location() {
          return (_errno_location2 = Module["asm"]["ba"]).apply(null, arguments);
        };

        var _free3 = function _free() {
          return (_free3 = Module["asm"]["ca"]).apply(null, arguments);
        };

        var _cxa_is_pointer_type2 = function ___cxa_is_pointer_type() {
          return (_cxa_is_pointer_type2 = Module["asm"]["da"]).apply(null, arguments);
        };

        Module["dynCall_jiji"] = function () {
          return (Module["dynCall_jiji"] = Module["asm"]["ea"]).apply(null, arguments);
        };

        Module["dynCall_viijii"] = function () {
          return (Module["dynCall_viijii"] = Module["asm"]["fa"]).apply(null, arguments);
        };

        Module["dynCall_iiiiij"] = function () {
          return (Module["dynCall_iiiiij"] = Module["asm"]["ga"]).apply(null, arguments);
        };

        Module["dynCall_iiiiijj"] = function () {
          return (Module["dynCall_iiiiijj"] = Module["asm"]["ha"]).apply(null, arguments);
        };

        Module["dynCall_iiiiiijj"] = function () {
          return (Module["dynCall_iiiiiijj"] = Module["asm"]["ia"]).apply(null, arguments);
        };

        var calledRun;

        dependenciesFulfilled = function runCaller() {
          if (!calledRun) run();
          if (!calledRun) dependenciesFulfilled = runCaller;
        };

        function run() {
          if (runDependencies > 0) {
            return;
          }

          preRun();

          if (runDependencies > 0) {
            return;
          }

          function doRun() {
            if (calledRun) return;
            calledRun = true;
            Module["calledRun"] = true;
            if (ABORT) return;
            initRuntime();
            readyPromiseResolve(Module);
            if (Module["onRuntimeInitialized"]) Module["onRuntimeInitialized"]();
            postRun();
          }

          if (Module["setStatus"]) {
            Module["setStatus"]("Running...");
            setTimeout(function () {
              setTimeout(function () {
                Module["setStatus"]("");
              }, 1);
              doRun();
            }, 1);
          } else {
            doRun();
          }
        }

        if (Module["preInit"]) {
          if (typeof Module["preInit"] == "function") Module["preInit"] = [Module["preInit"]];

          while (Module["preInit"].length > 0) {
            Module["preInit"].pop()();
          }
        }

        run();
        return WebIFCWasm3.ready;
      };
    }();

    if (typeof exports === "object" && typeof module === "object") module.exports = WebIFCWasm2;else if (typeof define === "function" && define["amd"]) define([], function () {
      return WebIFCWasm2;
    });else if (typeof exports === "object") exports["WebIFCWasm"] = WebIFCWasm2;
  }
});

var IFCBEAMSTANDARDCASE = 2906023776;
var IFCWINDOWSTANDARDCASE = 486154966;
var IFCWALLELEMENTEDCASE = 4156078855;
var IFCSLABSTANDARDCASE = 3027962421;
var IFCSLABELEMENTEDCASE = 3127900445;
var IFCPLATESTANDARDCASE = 1156407060;
var IFCMEMBERSTANDARDCASE = 1911478936;
var IFCDOORSTANDARDCASE = 3242481149;
var IFCCOLUMNSTANDARDCASE = 905975707;
var IFCOPENINGSTANDARDCASE = 3079942009;
var IFCCONTROLLER = 25142252;
var IFCALARM = 3087945054;
var IFCACTUATOR = 4288193352;
var IFCUNITARYCONTROLELEMENT = 630975310;
var IFCSENSOR = 4086658281;
var IFCPROTECTIVEDEVICETRIPPINGUNIT = 2295281155;
var IFCGEOSLICE = 1971632696;
var IFCGEOMODEL = 2680139844;
var IFCFLOWINSTRUMENT = 182646315;
var IFCFIRESUPPRESSIONTERMINAL = 1426591983;
var IFCFILTER = 819412036;
var IFCFAN = 3415622556;
var IFCELECTRICTIMECONTROL = 1003880860;
var IFCELECTRICMOTOR = 402227799;
var IFCELECTRICGENERATOR = 264262732;
var IFCELECTRICFLOWTREATMENTDEVICE = 24726584;
var IFCELECTRICFLOWSTORAGEDEVICE = 3310460725;
var IFCELECTRICDISTRIBUTIONBOARD = 862014818;
var IFCELECTRICAPPLIANCE = 1904799276;
var IFCDUCTSILENCER = 1360408905;
var IFCDUCTSEGMENT = 3518393246;
var IFCDUCTFITTING = 342316401;
var IFCDISTRIBUTIONCIRCUIT = 562808652;
var IFCDISTRIBUTIONBOARD = 3693000487;
var IFCDAMPER = 4074379575;
var IFCCOOLINGTOWER = 3640358203;
var IFCCOOLEDBEAM = 4136498852;
var IFCCONVEYORSEGMENT = 3460952963;
var IFCCONDENSER = 2272882330;
var IFCCOMPRESSOR = 3571504051;
var IFCCOMMUNICATIONSAPPLIANCE = 3221913625;
var IFCCOIL = 639361253;
var IFCCHILLER = 3902619387;
var IFCCAISSONFOUNDATION = 3999819293;
var IFCCABLESEGMENT = 4217484030;
var IFCCABLEFITTING = 1051757585;
var IFCCABLECARRIERSEGMENT = 3758799889;
var IFCCABLECARRIERFITTING = 635142910;
var IFCBURNER = 2938176219;
var IFCBOREHOLE = 3314249567;
var IFCBOILER = 32344328;
var IFCBEARING = 4196446775;
var IFCAUDIOVISUALAPPLIANCE = 277319702;
var IFCALIGNMENT = 325726236;
var IFCAIRTOAIRHEATRECOVERY = 2056796094;
var IFCAIRTERMINALBOX = 177149247;
var IFCAIRTERMINAL = 1634111441;
var IFCWASTETERMINAL = 4237592921;
var IFCVALVE = 4207607924;
var IFCUNITARYEQUIPMENT = 4292641817;
var IFCUNITARYCONTROLELEMENTTYPE = 3179687236;
var IFCTUBEBUNDLE = 3026737570;
var IFCTRANSFORMER = 3825984169;
var IFCTRACKELEMENT = 3425753595;
var IFCTANK = 812556717;
var IFCSWITCHINGDEVICE = 1162798199;
var IFCSTRUCTURALLOADCASE = 385403989;
var IFCSTACKTERMINAL = 1404847402;
var IFCSPACEHEATER = 1999602285;
var IFCSOLARDEVICE = 3420628829;
var IFCSIGNAL = 991950508;
var IFCSHADINGDEVICE = 1329646415;
var IFCSANITARYTERMINAL = 3053780830;
var IFCREINFORCINGBARTYPE = 2572171363;
var IFCREINFORCEDSOIL = 3798194928;
var IFCRATIONALBSPLINECURVEWITHKNOTS = 1232101972;
var IFCRAIL = 3290496277;
var IFCPUMP = 90941305;
var IFCPROTECTIVEDEVICETRIPPINGUNITTYPE = 655969474;
var IFCPROTECTIVEDEVICE = 738039164;
var IFCPIPESEGMENT = 3612865200;
var IFCPIPEFITTING = 310824031;
var IFCPAVEMENT = 1383356374;
var IFCOUTLET = 3694346114;
var IFCOUTERBOUNDARYCURVE = 144952367;
var IFCNAVIGATIONELEMENT = 2182337498;
var IFCMOTORCONNECTION = 2474470126;
var IFCMOORINGDEVICE = 234836483;
var IFCMOBILETELECOMMUNICATIONSAPPLIANCE = 2078563270;
var IFCMEDICALDEVICE = 1437502449;
var IFCLIQUIDTERMINAL = 1638804497;
var IFCLINEARPOSITIONINGELEMENT = 1154579445;
var IFCLIGHTFIXTURE = 629592764;
var IFCLAMP = 76236018;
var IFCKERB = 2696325953;
var IFCJUNCTIONBOX = 2176052936;
var IFCINTERCEPTOR = 4175244083;
var IFCHUMIDIFIER = 2068733104;
var IFCHEATEXCHANGER = 3319311131;
var IFCGEOTECHNICALASSEMBLY = 2713699986;
var IFCFLOWMETER = 2188021234;
var IFCEXTERNALSPATIALELEMENT = 1209101575;
var IFCEVAPORATOR = 484807127;
var IFCEVAPORATIVECOOLER = 3747195512;
var IFCENGINE = 2814081492;
var IFCELECTRICFLOWTREATMENTDEVICETYPE = 2142170206;
var IFCELECTRICDISTRIBUTIONBOARDTYPE = 2417008758;
var IFCEARTHWORKSFILL = 3376911765;
var IFCEARTHWORKSELEMENT = 1077100507;
var IFCEARTHWORKSCUT = 3071239417;
var IFCDISTRIBUTIONSYSTEM = 3205830791;
var IFCDISTRIBUTIONBOARDTYPE = 479945903;
var IFCDEEPFOUNDATION = 3426335179;
var IFCCOURSE = 1502416096;
var IFCCONVEYORSEGMENTTYPE = 2940368186;
var IFCCOMMUNICATIONSAPPLIANCETYPE = 400855858;
var IFCCIVILELEMENT = 1677625105;
var IFCCHIMNEY = 3296154744;
var IFCCAISSONFOUNDATIONTYPE = 3203706013;
var IFCCABLEFITTINGTYPE = 2674252688;
var IFCBURNERTYPE = 2188180465;
var IFCBUILTSYSTEM = 3862327254;
var IFCBUILTELEMENT = 1876633798;
var IFCBUILDINGSYSTEM = 1177604601;
var IFCBUILDINGELEMENTPARTTYPE = 39481116;
var IFCBRIDGEPART = 963979645;
var IFCBRIDGE = 644574406;
var IFCBOUNDARYCURVE = 1136057603;
var IFCBEARINGTYPE = 3649138523;
var IFCBSPLINECURVEWITHKNOTS = 2461110595;
var IFCAUDIOVISUALAPPLIANCETYPE = 1532957894;
var IFCALIGNMENTVERTICAL = 1662888072;
var IFCALIGNMENTSEGMENT = 317615605;
var IFCALIGNMENTHORIZONTAL = 1545765605;
var IFCALIGNMENTCANT = 4266260250;
var IFCWORKCALENDAR = 4088093105;
var IFCWINDOWTYPE = 4009809668;
var IFCVOIDINGFEATURE = 926996030;
var IFCVIBRATIONISOLATOR = 2391383451;
var IFCVIBRATIONDAMPERTYPE = 3956297820;
var IFCVIBRATIONDAMPER = 1530820697;
var IFCVEHICLE = 840318589;
var IFCTRANSPORTATIONDEVICE = 1953115116;
var IFCTRACKELEMENTTYPE = 618700268;
var IFCTENDONTYPE = 2415094496;
var IFCTENDONCONDUITTYPE = 2281632017;
var IFCTENDONCONDUIT = 3663046924;
var IFCTENDONANCHORTYPE = 3081323446;
var IFCSYSTEMFURNITUREELEMENT = 413509423;
var IFCSURFACEFEATURE = 3101698114;
var IFCSTRUCTURALSURFACEACTION = 3657597509;
var IFCSTRUCTURALCURVEREACTION = 2757150158;
var IFCSTRUCTURALCURVEACTION = 1004757350;
var IFCSTAIRTYPE = 338393293;
var IFCSOLARDEVICETYPE = 1072016465;
var IFCSINESPIRAL = 42703149;
var IFCSIGNALTYPE = 1894708472;
var IFCSIGNTYPE = 3599934289;
var IFCSIGN = 33720170;
var IFCSHADINGDEVICETYPE = 4074543187;
var IFCSEVENTHORDERPOLYNOMIALSPIRAL = 1027922057;
var IFCSEGMENTEDREFERENCECURVE = 544395925;
var IFCSECONDORDERPOLYNOMIALSPIRAL = 3649235739;
var IFCSEAMCURVE = 2157484638;
var IFCROOFTYPE = 2781568857;
var IFCROADPART = 550521510;
var IFCROAD = 146592293;
var IFCRELADHERESTOELEMENT = 3818125796;
var IFCREINFORCINGMESHTYPE = 2310774935;
var IFCREINFORCINGELEMENTTYPE = 964333572;
var IFCREFERENT = 4021432810;
var IFCRATIONALBSPLINESURFACEWITHKNOTS = 683857671;
var IFCRAMPTYPE = 1469900589;
var IFCRAILWAYPART = 1891881377;
var IFCRAILWAY = 3992365140;
var IFCRAILTYPE = 1763565496;
var IFCPOSITIONINGELEMENT = 1946335990;
var IFCPOLYGONALFACESET = 2839578677;
var IFCPILETYPE = 1158309216;
var IFCPAVEMENTTYPE = 514975943;
var IFCNAVIGATIONELEMENTTYPE = 506776471;
var IFCMOORINGDEVICETYPE = 710110818;
var IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE = 1950438474;
var IFCMEDICALDEVICETYPE = 1114901282;
var IFCMARINEPART = 976884017;
var IFCMARINEFACILITY = 525669439;
var IFCLIQUIDTERMINALTYPE = 1770583370;
var IFCLINEARELEMENT = 2176059722;
var IFCKERBTYPE = 679976338;
var IFCINTERSECTIONCURVE = 3113134337;
var IFCINTERCEPTORTYPE = 3946677679;
var IFCINDEXEDPOLYCURVE = 2571569899;
var IFCIMPACTPROTECTIONDEVICETYPE = 3948183225;
var IFCIMPACTPROTECTIONDEVICE = 2568555532;
var IFCGRADIENTCURVE = 2898700619;
var IFCGEOTECHNICALSTRATUM = 1594536857;
var IFCGEOTECHNICALELEMENT = 4230923436;
var IFCGEOGRAPHICELEMENT = 3493046030;
var IFCFURNITURE = 1509553395;
var IFCFOOTINGTYPE = 1893162501;
var IFCFACILITYPARTCOMMON = 4228831410;
var IFCFACILITYPART = 1310830890;
var IFCFACILITY = 24185140;
var IFCEXTERNALSPATIALSTRUCTUREELEMENT = 2853485674;
var IFCEVENT = 4148101412;
var IFCENGINETYPE = 132023988;
var IFCELEMENTASSEMBLYTYPE = 2397081782;
var IFCDOORTYPE = 2323601079;
var IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID = 4234616927;
var IFCDEEPFOUNDATIONTYPE = 1306400036;
var IFCCYLINDRICALSURFACE = 1213902940;
var IFCCOURSETYPE = 4189326743;
var IFCCOSINESPIRAL = 2000195564;
var IFCCONSTRUCTIONPRODUCTRESOURCETYPE = 1525564444;
var IFCCONSTRUCTIONMATERIALRESOURCETYPE = 4105962743;
var IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE = 2185764099;
var IFCCOMPOSITECURVEONSURFACE = 15328376;
var IFCCOMPLEXPROPERTYTEMPLATE = 3875453745;
var IFCCLOTHOID = 3497074424;
var IFCCIVILELEMENTTYPE = 3893394355;
var IFCCHIMNEYTYPE = 2197970202;
var IFCBUILTELEMENTTYPE = 1626504194;
var IFCBSPLINESURFACEWITHKNOTS = 167062518;
var IFCBSPLINESURFACE = 2887950389;
var IFCADVANCEDBREPWITHVOIDS = 2603310189;
var IFCADVANCEDBREP = 1635779807;
var IFCVEHICLETYPE = 3651464721;
var IFCTRIANGULATEDIRREGULARNETWORK = 1229763772;
var IFCTRIANGULATEDFACESET = 2916149573;
var IFCTRANSPORTATIONDEVICETYPE = 3665877780;
var IFCTOROIDALSURFACE = 1935646853;
var IFCTHIRDORDERPOLYNOMIALSPIRAL = 782932809;
var IFCTESSELLATEDFACESET = 2387106220;
var IFCTASKTYPE = 3206491090;
var IFCSURFACECURVE = 699246055;
var IFCSUBCONTRACTRESOURCETYPE = 4095615324;
var IFCSTRUCTURALSURFACEREACTION = 603775116;
var IFCSPIRAL = 2735484536;
var IFCSPHERICALSURFACE = 4015995234;
var IFCSPATIALZONETYPE = 2481509218;
var IFCSPATIALZONE = 463610769;
var IFCSPATIALELEMENTTYPE = 710998568;
var IFCSPATIALELEMENT = 1412071761;
var IFCSIMPLEPROPERTYTEMPLATE = 3663146110;
var IFCSECTIONEDSURFACE = 1356537516;
var IFCSECTIONEDSOLIDHORIZONTAL = 1290935644;
var IFCSECTIONEDSOLID = 1862484736;
var IFCREVOLVEDAREASOLIDTAPERED = 3243963512;
var IFCREPARAMETRISEDCOMPOSITECURVESEGMENT = 816062949;
var IFCRELSPACEBOUNDARY2NDLEVEL = 1521410863;
var IFCRELSPACEBOUNDARY1STLEVEL = 3523091289;
var IFCRELPOSITIONS = 1441486842;
var IFCRELINTERFERESELEMENTS = 427948657;
var IFCRELDEFINESBYTEMPLATE = 307848117;
var IFCRELDEFINESBYOBJECT = 1462361463;
var IFCRELDECLARES = 2565941209;
var IFCRELASSOCIATESPROFILEDEF = 1033248425;
var IFCRELASSIGNSTOGROUPBYFACTOR = 1027710054;
var IFCPROPERTYTEMPLATE = 3521284610;
var IFCPROPERTYSETTEMPLATE = 492091185;
var IFCPROJECTLIBRARY = 653396225;
var IFCPROCEDURETYPE = 569719735;
var IFCPREDEFINEDPROPERTYSET = 3967405729;
var IFCPOLYNOMIALCURVE = 3381221214;
var IFCPCURVE = 1682466193;
var IFCOFFSETCURVEBYDISTANCES = 2485787929;
var IFCOFFSETCURVE = 590820931;
var IFCLABORRESOURCETYPE = 428585644;
var IFCINDEXEDPOLYGONALTEXTUREMAP = 3465909080;
var IFCINDEXEDPOLYGONALFACEWITHVOIDS = 2294589976;
var IFCINDEXEDPOLYGONALFACE = 178912537;
var IFCGEOGRAPHICELEMENTTYPE = 4095422895;
var IFCFIXEDREFERENCESWEPTAREASOLID = 2652556860;
var IFCEXTRUDEDAREASOLIDTAPERED = 2804161546;
var IFCEVENTTYPE = 4024345920;
var IFCDIRECTRIXCURVESWEPTAREASOLID = 593015953;
var IFCCURVESEGMENT = 4212018352;
var IFCCURVEBOUNDEDSURFACE = 2629017746;
var IFCCREWRESOURCETYPE = 1815067380;
var IFCCONTEXT = 3419103109;
var IFCCONSTRUCTIONRESOURCETYPE = 2574617495;
var IFCCARTESIANPOINTLIST3D = 2059837836;
var IFCCARTESIANPOINTLIST2D = 1675464909;
var IFCCARTESIANPOINTLIST = 574549367;
var IFCAXIS2PLACEMENTLINEAR = 3425423356;
var IFCADVANCEDFACE = 3406155212;
var IFCTYPERESOURCE = 3698973494;
var IFCTYPEPROCESS = 3736923433;
var IFCTESSELLATEDITEM = 901063453;
var IFCSWEPTDISKSOLIDPOLYGONAL = 1096409881;
var IFCSEGMENT = 823603102;
var IFCRESOURCETIME = 1042787934;
var IFCRESOURCECONSTRAINTRELATIONSHIP = 1608871552;
var IFCRESOURCEAPPROVALRELATIONSHIP = 2943643501;
var IFCQUANTITYSET = 2090586900;
var IFCPROPERTYTEMPLATEDEFINITION = 1482703590;
var IFCPREDEFINEDPROPERTIES = 3778827333;
var IFCPOINTBYDISTANCEEXPRESSION = 2165702409;
var IFCOPENCROSSPROFILEDEF = 182550632;
var IFCMIRROREDPROFILEDEF = 2998442950;
var IFCMATERIALRELATIONSHIP = 853536259;
var IFCMATERIALPROFILESETUSAGETAPERING = 3404854881;
var IFCMATERIALPROFILESETUSAGE = 3079605661;
var IFCMATERIALCONSTITUENTSET = 2852063980;
var IFCMATERIALCONSTITUENT = 3708119e3;
var IFCLINEARPLACEMENT = 388784114;
var IFCLAGTIME = 1585845231;
var IFCINDEXEDTRIANGLETEXTUREMAP = 2133299955;
var IFCINDEXEDTEXTUREMAP = 1437953363;
var IFCINDEXEDCOLOURMAP = 3570813810;
var IFCEXTERNALREFERENCERELATIONSHIP = 1437805879;
var IFCEXTENDEDPROPERTIES = 297599258;
var IFCEVENTTIME = 211053100;
var IFCCONVERSIONBASEDUNITWITHOFFSET = 2713554722;
var IFCCOLOURRGBLIST = 3285139300;
var IFCALIGNMENTHORIZONTALSEGMENT = 536804194;
var IFCALIGNMENTCANTSEGMENT = 3752311538;
var IFCWORKTIME = 1236880293;
var IFCTEXTUREVERTEXLIST = 3611470254;
var IFCTEXTURECOORDINATEINDICESWITHVOIDS = 1010789467;
var IFCTEXTURECOORDINATEINDICES = 222769930;
var IFCTASKTIMERECURRING = 2771591690;
var IFCTASKTIME = 1549132990;
var IFCSURFACEREINFORCEMENTAREA = 2934153892;
var IFCSTRUCTURALLOADORRESULT = 609421318;
var IFCSTRUCTURALLOADCONFIGURATION = 3478079324;
var IFCQUANTITYNUMBER = 2691318326;
var IFCPROJECTEDCRS = 3843373140;
var IFCMATERIALPROFILEWITHOFFSETS = 552965576;
var IFCMATERIALPROFILESET = 164193824;
var IFCMATERIALPROFILE = 2235152071;
var IFCMATERIALLAYERWITHOFFSETS = 1847252529;
var IFCMAPCONVERSION = 3057273783;
var IFCCOORDINATEOPERATION = 1785450214;
var IFCCONNECTIONVOLUMEGEOMETRY = 775493141;
var IFCALIGNMENTVERTICALSEGMENT = 3633395639;
var IFCREINFORCINGBAR = 979691226;
var IFCELECTRICDISTRIBUTIONPOINT = 3700593921;
var IFCDISTRIBUTIONCONTROLELEMENT = 1062813311;
var IFCDISTRIBUTIONCHAMBERELEMENT = 1052013943;
var IFCCONTROLLERTYPE = 578613899;
var IFCCHAMFEREDGEFEATURE = 2454782716;
var IFCBEAM = 753842376;
var IFCALARMTYPE = 3001207471;
var IFCACTUATORTYPE = 2874132201;
var IFCWINDOW = 3304561284;
var IFCWALLSTANDARDCASE = 3512223829;
var IFCWALL = 2391406946;
var IFCVIBRATIONISOLATORTYPE = 3313531582;
var IFCTENDONANCHOR = 2347447852;
var IFCTENDON = 3824725483;
var IFCSTRUCTURALANALYSISMODEL = 2515109513;
var IFCSTAIRFLIGHT = 4252922144;
var IFCSTAIR = 331165859;
var IFCSLAB = 1529196076;
var IFCSENSORTYPE = 1783015770;
var IFCROUNDEDEDGEFEATURE = 1376911519;
var IFCROOF = 2016517767;
var IFCREINFORCINGMESH = 2320036040;
var IFCREINFORCINGELEMENT = 3027567501;
var IFCRATIONALBEZIERCURVE = 3055160366;
var IFCRAMPFLIGHT = 3283111854;
var IFCRAMP = 3024970846;
var IFCRAILING = 2262370178;
var IFCPLATE = 3171933400;
var IFCPILE = 1687234759;
var IFCMEMBER = 1073191201;
var IFCFOOTING = 900683007;
var IFCFLOWTREATMENTDEVICE = 3508470533;
var IFCFLOWTERMINAL = 2223149337;
var IFCFLOWSTORAGEDEVICE = 707683696;
var IFCFLOWSEGMENT = 987401354;
var IFCFLOWMOVINGDEVICE = 3132237377;
var IFCFLOWINSTRUMENTTYPE = 4037862832;
var IFCFLOWFITTING = 4278956645;
var IFCFLOWCONTROLLER = 2058353004;
var IFCFIRESUPPRESSIONTERMINALTYPE = 4222183408;
var IFCFILTERTYPE = 1810631287;
var IFCFANTYPE = 346874300;
var IFCENERGYCONVERSIONDEVICE = 1658829314;
var IFCELECTRICALELEMENT = 857184966;
var IFCELECTRICALCIRCUIT = 1634875225;
var IFCELECTRICTIMECONTROLTYPE = 712377611;
var IFCELECTRICMOTORTYPE = 1217240411;
var IFCELECTRICHEATERTYPE = 1365060375;
var IFCELECTRICGENERATORTYPE = 1534661035;
var IFCELECTRICFLOWSTORAGEDEVICETYPE = 3277789161;
var IFCELECTRICAPPLIANCETYPE = 663422040;
var IFCEDGEFEATURE = 855621170;
var IFCDUCTSILENCERTYPE = 2030761528;
var IFCDUCTSEGMENTTYPE = 3760055223;
var IFCDUCTFITTINGTYPE = 869906466;
var IFCDOOR = 395920057;
var IFCDISTRIBUTIONPORT = 3041715199;
var IFCDISTRIBUTIONFLOWELEMENT = 3040386961;
var IFCDISTRIBUTIONELEMENT = 1945004755;
var IFCDISTRIBUTIONCONTROLELEMENTTYPE = 2063403501;
var IFCDISTRIBUTIONCHAMBERELEMENTTYPE = 1599208980;
var IFCDISCRETEACCESSORYTYPE = 2635815018;
var IFCDISCRETEACCESSORY = 1335981549;
var IFCDIAMETERDIMENSION = 4147604152;
var IFCDAMPERTYPE = 3961806047;
var IFCCURTAINWALL = 3495092785;
var IFCCOVERING = 1973544240;
var IFCCOOLINGTOWERTYPE = 2954562838;
var IFCCOOLEDBEAMTYPE = 335055490;
var IFCCONSTRUCTIONPRODUCTRESOURCE = 488727124;
var IFCCONSTRUCTIONMATERIALRESOURCE = 1060000209;
var IFCCONSTRUCTIONEQUIPMENTRESOURCE = 3898045240;
var IFCCONDITIONCRITERION = 1163958913;
var IFCCONDITION = 2188551683;
var IFCCONDENSERTYPE = 2816379211;
var IFCCOMPRESSORTYPE = 3850581409;
var IFCCOLUMN = 843113511;
var IFCCOILTYPE = 2301859152;
var IFCCIRCLE = 2611217952;
var IFCCHILLERTYPE = 2951183804;
var IFCCABLESEGMENTTYPE = 1285652485;
var IFCCABLECARRIERSEGMENTTYPE = 3293546465;
var IFCCABLECARRIERFITTINGTYPE = 395041908;
var IFCBUILDINGELEMENTPROXYTYPE = 1909888760;
var IFCBUILDINGELEMENTPROXY = 1095909175;
var IFCBUILDINGELEMENTPART = 2979338954;
var IFCBUILDINGELEMENTCOMPONENT = 52481810;
var IFCBUILDINGELEMENT = 3299480353;
var IFCBOILERTYPE = 231477066;
var IFCBEZIERCURVE = 1916977116;
var IFCBEAMTYPE = 819618141;
var IFCBSPLINECURVE = 1967976161;
var IFCASSET = 3460190687;
var IFCANGULARDIMENSION = 2470393545;
var IFCAIRTOAIRHEATRECOVERYTYPE = 1871374353;
var IFCAIRTERMINALTYPE = 3352864051;
var IFCAIRTERMINALBOXTYPE = 1411407467;
var IFCACTIONREQUEST = 3821786052;
var IFC2DCOMPOSITECURVE = 1213861670;
var IFCZONE = 1033361043;
var IFCWORKSCHEDULE = 3342526732;
var IFCWORKPLAN = 4218914973;
var IFCWORKCONTROL = 1028945134;
var IFCWASTETERMINALTYPE = 1133259667;
var IFCWALLTYPE = 1898987631;
var IFCVIRTUALELEMENT = 2769231204;
var IFCVALVETYPE = 728799441;
var IFCUNITARYEQUIPMENTTYPE = 1911125066;
var IFCTUBEBUNDLETYPE = 1600972822;
var IFCTRIMMEDCURVE = 3593883385;
var IFCTRANSPORTELEMENT = 1620046519;
var IFCTRANSFORMERTYPE = 1692211062;
var IFCTIMESERIESSCHEDULE = 1637806684;
var IFCTANKTYPE = 5716631;
var IFCSYSTEM = 2254336722;
var IFCSWITCHINGDEVICETYPE = 2315554128;
var IFCSUBCONTRACTRESOURCE = 148013059;
var IFCSTRUCTURALSURFACECONNECTION = 1975003073;
var IFCSTRUCTURALRESULTGROUP = 2986769608;
var IFCSTRUCTURALPOINTREACTION = 1235345126;
var IFCSTRUCTURALPOINTCONNECTION = 734778138;
var IFCSTRUCTURALPOINTACTION = 2082059205;
var IFCSTRUCTURALPLANARACTIONVARYING = 3987759626;
var IFCSTRUCTURALPLANARACTION = 1621171031;
var IFCSTRUCTURALLOADGROUP = 1252848954;
var IFCSTRUCTURALLINEARACTIONVARYING = 1721250024;
var IFCSTRUCTURALLINEARACTION = 1807405624;
var IFCSTRUCTURALCURVEMEMBERVARYING = 2445595289;
var IFCSTRUCTURALCURVEMEMBER = 214636428;
var IFCSTRUCTURALCURVECONNECTION = 4243806635;
var IFCSTRUCTURALCONNECTION = 1179482911;
var IFCSTRUCTURALACTION = 682877961;
var IFCSTAIRFLIGHTTYPE = 1039846685;
var IFCSTACKTERMINALTYPE = 3112655638;
var IFCSPACETYPE = 3812236995;
var IFCSPACEPROGRAM = 652456506;
var IFCSPACEHEATERTYPE = 1305183839;
var IFCSPACE = 3856911033;
var IFCSLABTYPE = 2533589738;
var IFCSITE = 4097777520;
var IFCSERVICELIFE = 4105383287;
var IFCSCHEDULETIMECONTROL = 3517283431;
var IFCSANITARYTERMINALTYPE = 1768891740;
var IFCRELASSIGNSTASKS = 2863920197;
var IFCRELAGGREGATES = 160246688;
var IFCRAMPFLIGHTTYPE = 2324767716;
var IFCRAILINGTYPE = 2893384427;
var IFCRADIUSDIMENSION = 3248260540;
var IFCPUMPTYPE = 2250791053;
var IFCPROTECTIVEDEVICETYPE = 1842657554;
var IFCPROJECTIONELEMENT = 3651124850;
var IFCPROJECTORDERRECORD = 3642467123;
var IFCPROJECTORDER = 2904328755;
var IFCPROCEDURE = 2744685151;
var IFCPORT = 3740093272;
var IFCPOLYLINE = 3724593414;
var IFCPLATETYPE = 4017108033;
var IFCPIPESEGMENTTYPE = 4231323485;
var IFCPIPEFITTINGTYPE = 804291784;
var IFCPERMIT = 3327091369;
var IFCPERFORMANCEHISTORY = 2382730787;
var IFCOUTLETTYPE = 2837617999;
var IFCORDERACTION = 3425660407;
var IFCOPENINGELEMENT = 3588315303;
var IFCOCCUPANT = 4143007308;
var IFCMOVE = 1916936684;
var IFCMOTORCONNECTIONTYPE = 977012517;
var IFCMEMBERTYPE = 3181161470;
var IFCMECHANICALFASTENERTYPE = 2108223431;
var IFCMECHANICALFASTENER = 377706215;
var IFCLINEARDIMENSION = 2506943328;
var IFCLIGHTFIXTURETYPE = 1161773419;
var IFCLAMPTYPE = 1051575348;
var IFCLABORRESOURCE = 3827777499;
var IFCJUNCTIONBOXTYPE = 4288270099;
var IFCINVENTORY = 2391368822;
var IFCHUMIDIFIERTYPE = 1806887404;
var IFCHEATEXCHANGERTYPE = 1251058090;
var IFCGROUP = 2706460486;
var IFCGRID = 3009204131;
var IFCGASTERMINALTYPE = 200128114;
var IFCFURNITURESTANDARD = 814719939;
var IFCFURNISHINGELEMENT = 263784265;
var IFCFLOWTREATMENTDEVICETYPE = 3009222698;
var IFCFLOWTERMINALTYPE = 2297155007;
var IFCFLOWSTORAGEDEVICETYPE = 1339347760;
var IFCFLOWSEGMENTTYPE = 1834744321;
var IFCFLOWMOVINGDEVICETYPE = 1482959167;
var IFCFLOWMETERTYPE = 3815607619;
var IFCFLOWFITTINGTYPE = 3198132628;
var IFCFLOWCONTROLLERTYPE = 3907093117;
var IFCFEATUREELEMENTSUBTRACTION = 1287392070;
var IFCFEATUREELEMENTADDITION = 2143335405;
var IFCFEATUREELEMENT = 2827207264;
var IFCFASTENERTYPE = 2489546625;
var IFCFASTENER = 647756555;
var IFCFACETEDBREPWITHVOIDS = 3737207727;
var IFCFACETEDBREP = 807026263;
var IFCEVAPORATORTYPE = 3390157468;
var IFCEVAPORATIVECOOLERTYPE = 3174744832;
var IFCEQUIPMENTSTANDARD = 3272907226;
var IFCEQUIPMENTELEMENT = 1962604670;
var IFCENERGYCONVERSIONDEVICETYPE = 2107101300;
var IFCELLIPSE = 1704287377;
var IFCELEMENTCOMPONENTTYPE = 2590856083;
var IFCELEMENTCOMPONENT = 1623761950;
var IFCELEMENTASSEMBLY = 4123344466;
var IFCELEMENT = 1758889154;
var IFCELECTRICALBASEPROPERTIES = 360485395;
var IFCDISTRIBUTIONFLOWELEMENTTYPE = 3849074793;
var IFCDISTRIBUTIONELEMENTTYPE = 3256556792;
var IFCDIMENSIONCURVEDIRECTEDCALLOUT = 681481545;
var IFCCURTAINWALLTYPE = 1457835157;
var IFCCREWRESOURCE = 3295246426;
var IFCCOVERINGTYPE = 1916426348;
var IFCCOSTSCHEDULE = 1419761937;
var IFCCOSTITEM = 3895139033;
var IFCCONTROL = 3293443760;
var IFCCONSTRUCTIONRESOURCE = 2559216714;
var IFCCONIC = 2510884976;
var IFCCOMPOSITECURVE = 3732776249;
var IFCCOLUMNTYPE = 300633059;
var IFCCIRCLEHOLLOWPROFILEDEF = 2937912522;
var IFCBUILDINGSTOREY = 3124254112;
var IFCBUILDINGELEMENTTYPE = 1950629157;
var IFCBUILDING = 4031249490;
var IFCBOUNDEDCURVE = 1260505505;
var IFCBOOLEANCLIPPINGRESULT = 3649129432;
var IFCBLOCK = 1334484129;
var IFCASYMMETRICISHAPEPROFILEDEF = 3207858831;
var IFCANNOTATION = 1674181508;
var IFCACTOR = 2296667514;
var IFCTRANSPORTELEMENTTYPE = 2097647324;
var IFCTASK = 3473067441;
var IFCSYSTEMFURNITUREELEMENTTYPE = 1580310250;
var IFCSURFACEOFREVOLUTION = 4124788165;
var IFCSURFACEOFLINEAREXTRUSION = 2809605785;
var IFCSURFACECURVESWEPTAREASOLID = 2028607225;
var IFCSTRUCTUREDDIMENSIONCALLOUT = 4070609034;
var IFCSTRUCTURALSURFACEMEMBERVARYING = 2218152070;
var IFCSTRUCTURALSURFACEMEMBER = 3979015343;
var IFCSTRUCTURALREACTION = 3689010777;
var IFCSTRUCTURALMEMBER = 530289379;
var IFCSTRUCTURALITEM = 3136571912;
var IFCSTRUCTURALACTIVITY = 3544373492;
var IFCSPHERE = 451544542;
var IFCSPATIALSTRUCTUREELEMENTTYPE = 3893378262;
var IFCSPATIALSTRUCTUREELEMENT = 2706606064;
var IFCRIGHTCIRCULARCYLINDER = 3626867408;
var IFCRIGHTCIRCULARCONE = 4158566097;
var IFCREVOLVEDAREASOLID = 1856042241;
var IFCRESOURCE = 2914609552;
var IFCRELVOIDSELEMENT = 1401173127;
var IFCRELSPACEBOUNDARY = 3451746338;
var IFCRELSERVICESBUILDINGS = 366585022;
var IFCRELSEQUENCE = 4122056220;
var IFCRELSCHEDULESCOSTITEMS = 1058617721;
var IFCRELREFERENCEDINSPATIALSTRUCTURE = 1245217292;
var IFCRELPROJECTSELEMENT = 750771296;
var IFCRELOVERRIDESPROPERTIES = 202636808;
var IFCRELOCCUPIESSPACES = 2051452291;
var IFCRELNESTS = 3268803585;
var IFCRELINTERACTIONREQUIREMENTS = 4189434867;
var IFCRELFLOWCONTROLELEMENTS = 279856033;
var IFCRELFILLSELEMENT = 3940055652;
var IFCRELDEFINESBYTYPE = 781010003;
var IFCRELDEFINESBYPROPERTIES = 4186316022;
var IFCRELDEFINES = 693640335;
var IFCRELDECOMPOSES = 2551354335;
var IFCRELCOVERSSPACES = 2802773753;
var IFCRELCOVERSBLDGELEMENTS = 886880790;
var IFCRELCONTAINEDINSPATIALSTRUCTURE = 3242617779;
var IFCRELCONNECTSWITHREALIZINGELEMENTS = 3678494232;
var IFCRELCONNECTSWITHECCENTRICITY = 504942748;
var IFCRELCONNECTSSTRUCTURALMEMBER = 1638771189;
var IFCRELCONNECTSSTRUCTURALELEMENT = 3912681535;
var IFCRELCONNECTSSTRUCTURALACTIVITY = 2127690289;
var IFCRELCONNECTSPORTS = 3190031847;
var IFCRELCONNECTSPORTTOELEMENT = 4201705270;
var IFCRELCONNECTSPATHELEMENTS = 3945020480;
var IFCRELCONNECTSELEMENTS = 1204542856;
var IFCRELCONNECTS = 826625072;
var IFCRELASSOCIATESPROFILEPROPERTIES = 2851387026;
var IFCRELASSOCIATESMATERIAL = 2655215786;
var IFCRELASSOCIATESLIBRARY = 3840914261;
var IFCRELASSOCIATESDOCUMENT = 982818633;
var IFCRELASSOCIATESCONSTRAINT = 2728634034;
var IFCRELASSOCIATESCLASSIFICATION = 919958153;
var IFCRELASSOCIATESAPPROVAL = 4095574036;
var IFCRELASSOCIATESAPPLIEDVALUE = 1327628568;
var IFCRELASSOCIATES = 1865459582;
var IFCRELASSIGNSTORESOURCE = 205026976;
var IFCRELASSIGNSTOPROJECTORDER = 3372526763;
var IFCRELASSIGNSTOPRODUCT = 2857406711;
var IFCRELASSIGNSTOPROCESS = 4278684876;
var IFCRELASSIGNSTOGROUP = 1307041759;
var IFCRELASSIGNSTOCONTROL = 2495723537;
var IFCRELASSIGNSTOACTOR = 1683148259;
var IFCRELASSIGNS = 3939117080;
var IFCRECTANGULARTRIMMEDSURFACE = 3454111270;
var IFCRECTANGULARPYRAMID = 2798486643;
var IFCRECTANGLEHOLLOWPROFILEDEF = 2770003689;
var IFCPROXY = 3219374653;
var IFCPROPERTYSET = 1451395588;
var IFCPROJECTIONCURVE = 4194566429;
var IFCPROJECT = 103090709;
var IFCPRODUCT = 4208778838;
var IFCPROCESS = 2945172077;
var IFCPLANE = 220341763;
var IFCPLANARBOX = 603570806;
var IFCPERMEABLECOVERINGPROPERTIES = 3566463478;
var IFCOFFSETCURVE3D = 3505215534;
var IFCOFFSETCURVE2D = 3388369263;
var IFCOBJECT = 3888040117;
var IFCMANIFOLDSOLIDBREP = 1425443689;
var IFCLINE = 1281925730;
var IFCLSHAPEPROFILEDEF = 572779678;
var IFCISHAPEPROFILEDEF = 1484403080;
var IFCGEOMETRICCURVESET = 987898635;
var IFCFURNITURETYPE = 1268542332;
var IFCFURNISHINGELEMENTTYPE = 4238390223;
var IFCFLUIDFLOWPROPERTIES = 3455213021;
var IFCFILLAREASTYLETILES = 315944413;
var IFCFILLAREASTYLETILESYMBOLWITHSTYLE = 4203026998;
var IFCFILLAREASTYLEHATCHING = 374418227;
var IFCFACEBASEDSURFACEMODEL = 2047409740;
var IFCEXTRUDEDAREASOLID = 477187591;
var IFCENERGYPROPERTIES = 80994333;
var IFCELLIPSEPROFILEDEF = 2835456948;
var IFCELEMENTARYSURFACE = 2777663545;
var IFCELEMENTTYPE = 339256511;
var IFCELEMENTQUANTITY = 1883228015;
var IFCEDGELOOP = 1472233963;
var IFCDRAUGHTINGPREDEFINEDCURVEFONT = 4006246654;
var IFCDRAUGHTINGPREDEFINEDCOLOUR = 445594917;
var IFCDRAUGHTINGCALLOUT = 3073041342;
var IFCDOORSTYLE = 526551008;
var IFCDOORPANELPROPERTIES = 1714330368;
var IFCDOORLININGPROPERTIES = 2963535650;
var IFCDIRECTION = 32440307;
var IFCDIMENSIONCURVETERMINATOR = 4054601972;
var IFCDIMENSIONCURVE = 606661476;
var IFCDEFINEDSYMBOL = 693772133;
var IFCCURVEBOUNDEDPLANE = 2827736869;
var IFCCURVE = 2601014836;
var IFCCSGSOLID = 2147822146;
var IFCCSGPRIMITIVE3D = 2506170314;
var IFCCRANERAILFSHAPEPROFILEDEF = 194851669;
var IFCCRANERAILASHAPEPROFILEDEF = 4133800736;
var IFCCOMPOSITECURVESEGMENT = 2485617015;
var IFCCLOSEDSHELL = 2205249479;
var IFCCIRCLEPROFILEDEF = 1383045692;
var IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM = 1416205885;
var IFCCARTESIANTRANSFORMATIONOPERATOR3D = 3331915920;
var IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM = 3486308946;
var IFCCARTESIANTRANSFORMATIONOPERATOR2D = 3749851601;
var IFCCARTESIANTRANSFORMATIONOPERATOR = 59481748;
var IFCCARTESIANPOINT = 1123145078;
var IFCCSHAPEPROFILEDEF = 2898889636;
var IFCBOXEDHALFSPACE = 2713105998;
var IFCBOUNDINGBOX = 2581212453;
var IFCBOUNDEDSURFACE = 4182860854;
var IFCBOOLEANRESULT = 2736907675;
var IFCAXIS2PLACEMENT3D = 2740243338;
var IFCAXIS2PLACEMENT2D = 3125803723;
var IFCAXIS1PLACEMENT = 4261334040;
var IFCANNOTATIONSURFACE = 1302238472;
var IFCANNOTATIONFILLAREAOCCURRENCE = 2265737646;
var IFCANNOTATIONFILLAREA = 669184980;
var IFCANNOTATIONCURVEOCCURRENCE = 3288037868;
var IFCZSHAPEPROFILEDEF = 2543172580;
var IFCWINDOWSTYLE = 1299126871;
var IFCWINDOWPANELPROPERTIES = 512836454;
var IFCWINDOWLININGPROPERTIES = 336235671;
var IFCVERTEXLOOP = 2759199220;
var IFCVECTOR = 1417489154;
var IFCUSHAPEPROFILEDEF = 427810014;
var IFCTYPEPRODUCT = 2347495698;
var IFCTYPEOBJECT = 1628702193;
var IFCTWODIRECTIONREPEATFACTOR = 1345879162;
var IFCTRAPEZIUMPROFILEDEF = 2715220739;
var IFCTEXTLITERALWITHEXTENT = 3124975700;
var IFCTEXTLITERAL = 4282788508;
var IFCTERMINATORSYMBOL = 3028897424;
var IFCTSHAPEPROFILEDEF = 3071757647;
var IFCSWEPTSURFACE = 230924584;
var IFCSWEPTDISKSOLID = 1260650574;
var IFCSWEPTAREASOLID = 2247615214;
var IFCSURFACESTYLERENDERING = 1878645084;
var IFCSURFACE = 2513912981;
var IFCSUBEDGE = 2233826070;
var IFCSTRUCTURALSTEELPROFILEPROPERTIES = 3653947884;
var IFCSTRUCTURALPROFILEPROPERTIES = 3843319758;
var IFCSTRUCTURALLOADSINGLEFORCEWARPING = 1190533807;
var IFCSTRUCTURALLOADSINGLEFORCE = 1597423693;
var IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION = 1973038258;
var IFCSTRUCTURALLOADSINGLEDISPLACEMENT = 2473145415;
var IFCSTRUCTURALLOADPLANARFORCE = 2668620305;
var IFCSTRUCTURALLOADLINEARFORCE = 1595516126;
var IFCSPACETHERMALLOADPROPERTIES = 390701378;
var IFCSOUNDVALUE = 1202362311;
var IFCSOUNDPROPERTIES = 2485662743;
var IFCSOLIDMODEL = 723233188;
var IFCSLIPPAGECONNECTIONCONDITION = 2609359061;
var IFCSHELLBASEDSURFACEMODEL = 4124623270;
var IFCSERVICELIFEFACTOR = 2411513650;
var IFCSECTIONEDSPINE = 1509187699;
var IFCROUNDEDRECTANGLEPROFILEDEF = 2778083089;
var IFCRELATIONSHIP = 478536968;
var IFCREINFORCEMENTDEFINITIONPROPERTIES = 3765753017;
var IFCREGULARTIMESERIES = 3413951693;
var IFCRECTANGLEPROFILEDEF = 3615266464;
var IFCPROPERTYTABLEVALUE = 110355661;
var IFCPROPERTYSINGLEVALUE = 3650150729;
var IFCPROPERTYSETDEFINITION = 3357820518;
var IFCPROPERTYREFERENCEVALUE = 941946838;
var IFCPROPERTYLISTVALUE = 2752243245;
var IFCPROPERTYENUMERATEDVALUE = 4166981789;
var IFCPROPERTYDEFINITION = 1680319473;
var IFCPROPERTYBOUNDEDVALUE = 871118103;
var IFCPRODUCTDEFINITIONSHAPE = 673634403;
var IFCPREDEFINEDPOINTMARKERSYMBOL = 179317114;
var IFCPREDEFINEDDIMENSIONSYMBOL = 433424934;
var IFCPREDEFINEDCURVEFONT = 2559016684;
var IFCPREDEFINEDCOLOUR = 759155922;
var IFCPOLYGONALBOUNDEDHALFSPACE = 2775532180;
var IFCPOLYLOOP = 2924175390;
var IFCPOINTONSURFACE = 1423911732;
var IFCPOINTONCURVE = 4022376103;
var IFCPOINT = 2067069095;
var IFCPLANAREXTENT = 1663979128;
var IFCPLACEMENT = 2004835150;
var IFCPIXELTEXTURE = 597895409;
var IFCPHYSICALCOMPLEXQUANTITY = 3021840470;
var IFCPATH = 2519244187;
var IFCPARAMETERIZEDPROFILEDEF = 2529465313;
var IFCORIENTEDEDGE = 1029017970;
var IFCOPENSHELL = 2665983363;
var IFCONEDIRECTIONREPEATFACTOR = 2833995503;
var IFCOBJECTDEFINITION = 219451334;
var IFCMECHANICALCONCRETEMATERIALPROPERTIES = 1430189142;
var IFCMATERIALDEFINITIONREPRESENTATION = 2022407955;
var IFCMAPPEDITEM = 2347385850;
var IFCLOOP = 1008929658;
var IFCLOCALPLACEMENT = 2624227202;
var IFCLIGHTSOURCESPOT = 3422422726;
var IFCLIGHTSOURCEPOSITIONAL = 1520743889;
var IFCLIGHTSOURCEGONIOMETRIC = 4266656042;
var IFCLIGHTSOURCEDIRECTIONAL = 2604431987;
var IFCLIGHTSOURCEAMBIENT = 125510826;
var IFCLIGHTSOURCE = 1402838566;
var IFCIRREGULARTIMESERIES = 3741457305;
var IFCIMAGETEXTURE = 3905492369;
var IFCHYGROSCOPICMATERIALPROPERTIES = 2445078500;
var IFCHALFSPACESOLID = 812098782;
var IFCGRIDPLACEMENT = 178086475;
var IFCGEOMETRICSET = 3590301190;
var IFCGEOMETRICREPRESENTATIONSUBCONTEXT = 4142052618;
var IFCGEOMETRICREPRESENTATIONITEM = 2453401579;
var IFCGEOMETRICREPRESENTATIONCONTEXT = 3448662350;
var IFCGENERALPROFILEPROPERTIES = 1446786286;
var IFCGENERALMATERIALPROPERTIES = 803998398;
var IFCFUELPROPERTIES = 3857492461;
var IFCFILLAREASTYLE = 738692330;
var IFCFAILURECONNECTIONCONDITION = 4219587988;
var IFCFACESURFACE = 3008276851;
var IFCFACEOUTERBOUND = 803316827;
var IFCFACEBOUND = 1809719519;
var IFCFACE = 2556980723;
var IFCEXTENDEDMATERIALPROPERTIES = 1860660968;
var IFCEDGECURVE = 476780140;
var IFCEDGE = 3900360178;
var IFCDRAUGHTINGPREDEFINEDTEXTFONT = 4170525392;
var IFCDOCUMENTREFERENCE = 3732053477;
var IFCDIMENSIONPAIR = 1694125774;
var IFCDIMENSIONCALLOUTRELATIONSHIP = 2273265877;
var IFCDERIVEDPROFILEDEF = 3632507154;
var IFCCURVESTYLE = 3800577675;
var IFCCONVERSIONBASEDUNIT = 2889183280;
var IFCCONTEXTDEPENDENTUNIT = 3050246964;
var IFCCONNECTIONPOINTECCENTRICITY = 45288368;
var IFCCONNECTIONCURVEGEOMETRY = 1981873012;
var IFCCONNECTEDFACESET = 370225590;
var IFCCOMPOSITEPROFILEDEF = 1485152156;
var IFCCOMPLEXPROPERTY = 2542286263;
var IFCCOLOURRGB = 776857604;
var IFCCLASSIFICATIONREFERENCE = 647927063;
var IFCCENTERLINEPROFILEDEF = 3150382593;
var IFCBLOBTEXTURE = 616511568;
var IFCARBITRARYPROFILEDEFWITHVOIDS = 2705031697;
var IFCARBITRARYOPENPROFILEDEF = 1310608509;
var IFCARBITRARYCLOSEDPROFILEDEF = 3798115385;
var IFCANNOTATIONTEXTOCCURRENCE = 2297822566;
var IFCANNOTATIONSYMBOLOCCURRENCE = 3612888222;
var IFCANNOTATIONSURFACEOCCURRENCE = 962685235;
var IFCANNOTATIONOCCURRENCE = 2442683028;
var IFCWATERPROPERTIES = 1065908215;
var IFCVIRTUALGRIDINTERSECTION = 891718957;
var IFCVERTEXPOINT = 1907098498;
var IFCVERTEX = 2799835756;
var IFCTOPOLOGYREPRESENTATION = 1735638870;
var IFCTOPOLOGICALREPRESENTATIONITEM = 1377556343;
var IFCTIMESERIESREFERENCERELATIONSHIP = 1718945513;
var IFCTHERMALMATERIALPROPERTIES = 3317419933;
var IFCTEXTUREVERTEX = 1210645708;
var IFCTEXTUREMAP = 2552916305;
var IFCTEXTURECOORDINATEGENERATOR = 1742049831;
var IFCTEXTURECOORDINATE = 280115917;
var IFCTEXTSTYLETEXTMODEL = 1640371178;
var IFCTEXTSTYLEFORDEFINEDFONT = 2636378356;
var IFCTEXTSTYLEFONTMODEL = 1983826977;
var IFCTEXTSTYLE = 1447204868;
var IFCTELECOMADDRESS = 912023232;
var IFCTABLE = 985171141;
var IFCSYMBOLSTYLE = 1290481447;
var IFCSURFACETEXTURE = 626085974;
var IFCSURFACESTYLEWITHTEXTURES = 1351298697;
var IFCSURFACESTYLESHADING = 846575682;
var IFCSURFACESTYLEREFRACTION = 1607154358;
var IFCSURFACESTYLELIGHTING = 3303107099;
var IFCSURFACESTYLE = 1300840506;
var IFCSTYLEDREPRESENTATION = 3049322572;
var IFCSTYLEDITEM = 3958052878;
var IFCSTYLEMODEL = 2830218821;
var IFCSTRUCTURALLOADTEMPERATURE = 3408363356;
var IFCSTRUCTURALLOADSTATIC = 2525727697;
var IFCSIMPLEPROPERTY = 3692461612;
var IFCSHAPEREPRESENTATION = 4240577450;
var IFCSHAPEMODEL = 3982875396;
var IFCSHAPEASPECT = 867548509;
var IFCSECTIONREINFORCEMENTPROPERTIES = 4165799628;
var IFCSECTIONPROPERTIES = 2042790032;
var IFCSIUNIT = 448429030;
var IFCRIBPLATEPROFILEPROPERTIES = 3679540991;
var IFCREPRESENTATIONMAP = 1660063152;
var IFCREPRESENTATION = 1076942058;
var IFCREINFORCEMENTBARPROPERTIES = 1580146022;
var IFCREFERENCESVALUEDOCUMENT = 2692823254;
var IFCQUANTITYWEIGHT = 825690147;
var IFCQUANTITYVOLUME = 2405470396;
var IFCQUANTITYTIME = 3252649465;
var IFCQUANTITYLENGTH = 931644368;
var IFCQUANTITYCOUNT = 2093928680;
var IFCQUANTITYAREA = 2044713172;
var IFCPROPERTYENUMERATION = 3710013099;
var IFCPROPERTYDEPENDENCYRELATIONSHIP = 148025276;
var IFCPROPERTYCONSTRAINTRELATIONSHIP = 3896028662;
var IFCPROPERTY = 2598011224;
var IFCPROFILEPROPERTIES = 2802850158;
var IFCPRODUCTSOFCOMBUSTIONPROPERTIES = 2267347899;
var IFCPRODUCTREPRESENTATION = 2095639259;
var IFCPRESENTATIONLAYERWITHSTYLE = 1304840413;
var IFCPRESENTATIONLAYERASSIGNMENT = 2022622350;
var IFCPREDEFINEDTEXTFONT = 1775413392;
var IFCPREDEFINEDTERMINATORSYMBOL = 3213052703;
var IFCPREDEFINEDSYMBOL = 990879717;
var IFCPREDEFINEDITEM = 3727388367;
var IFCPOSTALADDRESS = 3355820592;
var IFCPHYSICALSIMPLEQUANTITY = 2226359599;
var IFCPERSONANDORGANIZATION = 101040310;
var IFCPERSON = 2077209135;
var IFCORGANIZATIONRELATIONSHIP = 1411181986;
var IFCORGANIZATION = 4251960020;
var IFCOPTICALMATERIALPROPERTIES = 1227763645;
var IFCOBJECTIVE = 2251480897;
var IFCOBJECTPLACEMENT = 3701648758;
var IFCMETRIC = 3368373690;
var IFCMECHANICALSTEELMATERIALPROPERTIES = 677618848;
var IFCMECHANICALMATERIALPROPERTIES = 4256014907;
var IFCMATERIALPROPERTIES = 3265635763;
var IFCMATERIALLAYERSETUSAGE = 1303795690;
var IFCMATERIALLAYERSET = 3303938423;
var IFCMATERIALLAYER = 248100487;
var IFCMATERIALCLASSIFICATIONRELATIONSHIP = 1847130766;
var IFCMATERIAL = 1838606355;
var IFCLIBRARYREFERENCE = 3452421091;
var IFCLIBRARYINFORMATION = 2655187982;
var IFCEXTERNALLYDEFINEDTEXTFONT = 3548104201;
var IFCEXTERNALLYDEFINEDSYMBOL = 3207319532;
var IFCEXTERNALLYDEFINEDSURFACESTYLE = 1040185647;
var IFCEXTERNALLYDEFINEDHATCHSTYLE = 2242383968;
var IFCENVIRONMENTALIMPACTVALUE = 1648886627;
var IFCDRAUGHTINGCALLOUTRELATIONSHIP = 3796139169;
var IFCDOCUMENTINFORMATIONRELATIONSHIP = 770865208;
var IFCDOCUMENTINFORMATION = 1154170062;
var IFCCURVESTYLEFONTPATTERN = 3510044353;
var IFCCURVESTYLEFONTANDSCALING = 2367409068;
var IFCCURVESTYLEFONT = 1105321065;
var IFCCURRENCYRELATIONSHIP = 539742890;
var IFCCOSTVALUE = 602808272;
var IFCCONSTRAINTRELATIONSHIP = 347226245;
var IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP = 613356794;
var IFCCONSTRAINTAGGREGATIONRELATIONSHIP = 1658513725;
var IFCCONNECTIONSURFACEGEOMETRY = 2732653382;
var IFCCONNECTIONPORTGEOMETRY = 4257277454;
var IFCCONNECTIONPOINTGEOMETRY = 2614616156;
var IFCCOLOURSPECIFICATION = 3264961684;
var IFCCLASSIFICATIONITEMRELATIONSHIP = 1098599126;
var IFCCLASSIFICATIONITEM = 1767535486;
var IFCCLASSIFICATION = 747523909;
var IFCBOUNDARYNODECONDITIONWARPING = 2069777674;
var IFCBOUNDARYNODECONDITION = 1387855156;
var IFCBOUNDARYFACECONDITION = 3367102660;
var IFCBOUNDARYEDGECONDITION = 1560379544;
var IFCAPPROVALRELATIONSHIP = 3869604511;
var IFCAPPROVALACTORRELATIONSHIP = 2080292479;
var IFCAPPLIEDVALUERELATIONSHIP = 1110488051;
var FILE_DESCRIPTION = 599546466;
var FILE_NAME = 1390159747;
var FILE_SCHEMA = 1109904537;

var Handle = function Handle(value) {
  _classCallCheck2(this, Handle);

  this.value = value;
  this.type = 5;
};

var IfcLineObject = function IfcLineObject(expressID) {
  _classCallCheck2(this, IfcLineObject);

  this.expressID = expressID;
  this.type = 0;
};

var FromRawLineData = [];
var InversePropertyDef = {};
var InheritanceDef = {};
var Constructors = {};
var ToRawLineData = {};
var TypeInitialisers = {};
var SchemaNames = [];

function TypeInitialiser(schema, tapeItem) {
  if (tapeItem.typecode) return TypeInitialisers[schema][tapeItem.typecode](tapeItem.value);else return tapeItem.value;
}

function Labelise(tapeItem) {
  tapeItem.valueType = tapeItem.type;
  tapeItem.type = 2;
  tapeItem.label = tapeItem.constructor.name.toUpperCase();
  return tapeItem;
}

var Schemas;

(function (Schemas2) {
  Schemas2["IFC2X3"] = "IFC2X3";
  Schemas2["IFC4_3"] = "IFC4.3";
  Schemas2["IFC4"] = "IFC4";
})(Schemas || (Schemas = {}));

SchemaNames[1] = "IFC2X3";
FromRawLineData[1] = {
  3630933823: function _(id, v) {
    return new IFC2X3.IfcActorRole(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcText(v[2].value));
  },
  618182010: function _(id, v) {
    return new IFC2X3.IfcAddress(id, v[0], !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  639542469: function _(id, v) {
    return new IFC2X3.IfcApplication(id, new Handle(v[0].value), new IFC2X3.IfcLabel(v[1].value), new IFC2X3.IfcLabel(v[2].value), new IFC2X3.IfcIdentifier(v[3].value));
  },
  411424972: function _(id, v) {
    return new IFC2X3.IfcAppliedValue(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value));
  },
  1110488051: function _(id, v) {
    return new IFC2X3.IfcAppliedValueRelationship(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2], !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new IFC2X3.IfcText(v[4].value));
  },
  130549933: function _(id, v) {
    return new IFC2X3.IfcApproval(id, !v[0] ? null : new IFC2X3.IfcText(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new IFC2X3.IfcText(v[4].value), new IFC2X3.IfcLabel(v[5].value), new IFC2X3.IfcIdentifier(v[6].value));
  },
  2080292479: function _(id, v) {
    return new IFC2X3.IfcApprovalActorRelationship(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value));
  },
  390851274: function _(id, v) {
    return new IFC2X3.IfcApprovalPropertyRelationship(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value));
  },
  3869604511: function _(id, v) {
    return new IFC2X3.IfcApprovalRelationship(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcText(v[2].value), new IFC2X3.IfcLabel(v[3].value));
  },
  4037036970: function _(id, v) {
    return new IFC2X3.IfcBoundaryCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value));
  },
  1560379544: function _(id, v) {
    return new IFC2X3.IfcBoundaryEdgeCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(v[6].value));
  },
  3367102660: function _(id, v) {
    return new IFC2X3.IfcBoundaryFaceCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcModulusOfSubgradeReactionMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcModulusOfSubgradeReactionMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcModulusOfSubgradeReactionMeasure(v[3].value));
  },
  1387855156: function _(id, v) {
    return new IFC2X3.IfcBoundaryNodeCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[6].value));
  },
  2069777674: function _(id, v) {
    return new IFC2X3.IfcBoundaryNodeConditionWarping(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLinearStiffnessMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcRotationalStiffnessMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcWarpingMomentMeasure(v[7].value));
  },
  622194075: function _(id, v) {
    return new IFC2X3.IfcCalendarDate(id, new IFC2X3.IfcDayInMonthNumber(v[0].value), new IFC2X3.IfcMonthInYearNumber(v[1].value), new IFC2X3.IfcYearNumber(v[2].value));
  },
  747523909: function _(id, v) {
    return new IFC2X3.IfcClassification(id, new IFC2X3.IfcLabel(v[0].value), new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcLabel(v[3].value));
  },
  1767535486: function _(id, v) {
    return new IFC2X3.IfcClassificationItem(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new IFC2X3.IfcLabel(v[2].value));
  },
  1098599126: function _(id, v) {
    return new IFC2X3.IfcClassificationItemRelationship(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  938368621: function _(id, v) {
    return new IFC2X3.IfcClassificationNotation(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3639012971: function _(id, v) {
    return new IFC2X3.IfcClassificationNotationFacet(id, new IFC2X3.IfcLabel(v[0].value));
  },
  3264961684: function _(id, v) {
    return new IFC2X3.IfcColourSpecification(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value));
  },
  2859738748: function _(id, _2) {
    return new IFC2X3.IfcConnectionGeometry(id);
  },
  2614616156: function _(id, v) {
    return new IFC2X3.IfcConnectionPointGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  4257277454: function _(id, v) {
    return new IFC2X3.IfcConnectionPortGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value));
  },
  2732653382: function _(id, v) {
    return new IFC2X3.IfcConnectionSurfaceGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  1959218052: function _(id, v) {
    return new IFC2X3.IfcConstraint(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value));
  },
  1658513725: function _(id, v) {
    return new IFC2X3.IfcConstraintAggregationRelationship(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }), v[4]);
  },
  613356794: function _(id, v) {
    return new IFC2X3.IfcConstraintClassificationRelationship(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  347226245: function _(id, v) {
    return new IFC2X3.IfcConstraintRelationship(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1065062679: function _(id, v) {
    return new IFC2X3.IfcCoordinatedUniversalTimeOffset(id, new IFC2X3.IfcHourInDay(v[0].value), !v[1] ? null : new IFC2X3.IfcMinuteInHour(v[1].value), v[2]);
  },
  602808272: function _(id, v) {
    return new IFC2X3.IfcCostValue(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new IFC2X3.IfcText(v[7].value));
  },
  539742890: function _(id, v) {
    return new IFC2X3.IfcCurrencyRelationship(id, new Handle(v[0].value), new Handle(v[1].value), new IFC2X3.IfcPositiveRatioMeasure(v[2].value), new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value));
  },
  1105321065: function _(id, v) {
    return new IFC2X3.IfcCurveStyleFont(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2367409068: function _(id, v) {
    return new IFC2X3.IfcCurveStyleFontAndScaling(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), new IFC2X3.IfcPositiveRatioMeasure(v[2].value));
  },
  3510044353: function _(id, v) {
    return new IFC2X3.IfcCurveStyleFontPattern(id, new IFC2X3.IfcLengthMeasure(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value));
  },
  1072939445: function _(id, v) {
    return new IFC2X3.IfcDateAndTime(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  1765591967: function _(id, v) {
    return new IFC2X3.IfcDerivedUnit(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1], !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  1045800335: function _(id, v) {
    return new IFC2X3.IfcDerivedUnitElement(id, new Handle(v[0].value), v[1].value);
  },
  2949456006: function _(id, v) {
    return new IFC2X3.IfcDimensionalExponents(id, v[0].value, v[1].value, v[2].value, v[3].value, v[4].value, v[5].value, v[6].value);
  },
  1376555844: function _(id, v) {
    return new IFC2X3.IfcDocumentElectronicFormat(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  1154170062: function _(id, v) {
    return new IFC2X3.IfcDocumentInformation(id, new IFC2X3.IfcIdentifier(v[0].value), new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcText(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new Handle(p.value);
    }), !v[4] ? null : new IFC2X3.IfcText(v[4].value), !v[5] ? null : new IFC2X3.IfcText(v[5].value), !v[6] ? null : new IFC2X3.IfcText(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), !v[11] ? null : new Handle(v[11].value), !v[12] ? null : new Handle(v[12].value), !v[13] ? null : new Handle(v[13].value), !v[14] ? null : new Handle(v[14].value), v[15], v[16]);
  },
  770865208: function _(id, v) {
    return new IFC2X3.IfcDocumentInformationRelationship(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  3796139169: function _(id, v) {
    return new IFC2X3.IfcDraughtingCalloutRelationship(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value));
  },
  1648886627: function _(id, v) {
    return new IFC2X3.IfcEnvironmentalImpactValue(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  3200245327: function _(id, v) {
    return new IFC2X3.IfcExternalReference(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  2242383968: function _(id, v) {
    return new IFC2X3.IfcExternallyDefinedHatchStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  1040185647: function _(id, v) {
    return new IFC2X3.IfcExternallyDefinedSurfaceStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  3207319532: function _(id, v) {
    return new IFC2X3.IfcExternallyDefinedSymbol(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  3548104201: function _(id, v) {
    return new IFC2X3.IfcExternallyDefinedTextFont(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  852622518: function _(id, v) {
    return new IFC2X3.IfcGridAxis(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), new IFC2X3.IfcBoolean(v[2].value));
  },
  3020489413: function _(id, v) {
    return new IFC2X3.IfcIrregularTimeSeriesValue(id, new Handle(v[0].value), v[1].map(function (p) {
      return TypeInitialiser(1, p);
    }));
  },
  2655187982: function _(id, v) {
    return new IFC2X3.IfcLibraryInformation(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3452421091: function _(id, v) {
    return new IFC2X3.IfcLibraryReference(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  4162380809: function _(id, v) {
    return new IFC2X3.IfcLightDistributionData(id, new IFC2X3.IfcPlaneAngleMeasure(v[0].value), v[1].map(function (p) {
      return new IFC2X3.IfcPlaneAngleMeasure(p.value);
    }), v[2].map(function (p) {
      return new IFC2X3.IfcLuminousIntensityDistributionMeasure(p.value);
    }));
  },
  1566485204: function _(id, v) {
    return new IFC2X3.IfcLightIntensityDistribution(id, v[0], v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  30780891: function _(id, v) {
    return new IFC2X3.IfcLocalTime(id, new IFC2X3.IfcHourInDay(v[0].value), !v[1] ? null : new IFC2X3.IfcMinuteInHour(v[1].value), !v[2] ? null : new IFC2X3.IfcSecondInMinute(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC2X3.IfcDaylightSavingHour(v[4].value));
  },
  1838606355: function _(id, v) {
    return new IFC2X3.IfcMaterial(id, new IFC2X3.IfcLabel(v[0].value));
  },
  1847130766: function _(id, v) {
    return new IFC2X3.IfcMaterialClassificationRelationship(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value));
  },
  248100487: function _(id, v) {
    return new IFC2X3.IfcMaterialLayer(id, !v[0] ? null : new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLogical(v[2].value));
  },
  3303938423: function _(id, v) {
    return new IFC2X3.IfcMaterialLayerSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value));
  },
  1303795690: function _(id, v) {
    return new IFC2X3.IfcMaterialLayerSetUsage(id, new Handle(v[0].value), v[1], v[2], new IFC2X3.IfcLengthMeasure(v[3].value));
  },
  2199411900: function _(id, v) {
    return new IFC2X3.IfcMaterialList(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3265635763: function _(id, v) {
    return new IFC2X3.IfcMaterialProperties(id, new Handle(v[0].value));
  },
  2597039031: function _(id, v) {
    return new IFC2X3.IfcMeasureWithUnit(id, TypeInitialiser(1, v[0]), new Handle(v[1].value));
  },
  4256014907: function _(id, v) {
    return new IFC2X3.IfcMechanicalMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcDynamicViscosityMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcThermalExpansionCoefficientMeasure(v[5].value));
  },
  677618848: function _(id, v) {
    return new IFC2X3.IfcMechanicalSteelMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcDynamicViscosityMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcThermalExpansionCoefficientMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPressureMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPressureMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPressureMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[11].value), !v[12] ? null : v[12].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3368373690: function _(id, v) {
    return new IFC2X3.IfcMetric(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), new Handle(v[9].value));
  },
  2706619895: function _(id, v) {
    return new IFC2X3.IfcMonetaryUnit(id, v[0]);
  },
  1918398963: function _(id, v) {
    return new IFC2X3.IfcNamedUnit(id, new Handle(v[0].value), v[1]);
  },
  3701648758: function _(id, _3) {
    return new IFC2X3.IfcObjectPlacement(id);
  },
  2251480897: function _(id, v) {
    return new IFC2X3.IfcObjective(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), v[9], !v[10] ? null : new IFC2X3.IfcLabel(v[10].value));
  },
  1227763645: function _(id, v) {
    return new IFC2X3.IfcOpticalMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[9].value));
  },
  4251960020: function _(id, v) {
    return new IFC2X3.IfcOrganization(id, !v[0] ? null : new IFC2X3.IfcIdentifier(v[0].value), new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcText(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new Handle(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1411181986: function _(id, v) {
    return new IFC2X3.IfcOrganizationRelationship(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1207048766: function _(id, v) {
    return new IFC2X3.IfcOwnerHistory(id, new Handle(v[0].value), new Handle(v[1].value), v[2], v[3], !v[4] ? null : new IFC2X3.IfcTimeStamp(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new IFC2X3.IfcTimeStamp(v[7].value));
  },
  2077209135: function _(id, v) {
    return new IFC2X3.IfcPerson(id, !v[0] ? null : new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new IFC2X3.IfcLabel(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new IFC2X3.IfcLabel(p.value);
    }), !v[5] ? null : v[5].map(function (p) {
      return new IFC2X3.IfcLabel(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }));
  },
  101040310: function _(id, v) {
    return new IFC2X3.IfcPersonAndOrganization(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2483315170: function _(id, v) {
    return new IFC2X3.IfcPhysicalQuantity(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value));
  },
  2226359599: function _(id, v) {
    return new IFC2X3.IfcPhysicalSimpleQuantity(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  3355820592: function _(id, v) {
    return new IFC2X3.IfcPostalAddress(id, v[0], !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new IFC2X3.IfcLabel(p.value);
    }), !v[5] ? null : new IFC2X3.IfcLabel(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : new IFC2X3.IfcLabel(v[9].value));
  },
  3727388367: function _(id, v) {
    return new IFC2X3.IfcPreDefinedItem(id, new IFC2X3.IfcLabel(v[0].value));
  },
  990879717: function _(id, v) {
    return new IFC2X3.IfcPreDefinedSymbol(id, new IFC2X3.IfcLabel(v[0].value));
  },
  3213052703: function _(id, v) {
    return new IFC2X3.IfcPreDefinedTerminatorSymbol(id, new IFC2X3.IfcLabel(v[0].value));
  },
  1775413392: function _(id, v) {
    return new IFC2X3.IfcPreDefinedTextFont(id, new IFC2X3.IfcLabel(v[0].value));
  },
  2022622350: function _(id, v) {
    return new IFC2X3.IfcPresentationLayerAssignment(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : new IFC2X3.IfcIdentifier(v[3].value));
  },
  1304840413: function _(id, v) {
    return new IFC2X3.IfcPresentationLayerWithStyle(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : new IFC2X3.IfcIdentifier(v[3].value), v[4].value, v[5].value, v[6].value, v[7].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3119450353: function _(id, v) {
    return new IFC2X3.IfcPresentationStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value));
  },
  2417041796: function _(id, v) {
    return new IFC2X3.IfcPresentationStyleAssignment(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2095639259: function _(id, v) {
    return new IFC2X3.IfcProductRepresentation(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2267347899: function _(id, v) {
    return new IFC2X3.IfcProductsOfCombustionProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcSpecificHeatCapacityMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value));
  },
  3958567839: function _(id, v) {
    return new IFC2X3.IfcProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value));
  },
  2802850158: function _(id, v) {
    return new IFC2X3.IfcProfileProperties(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  2598011224: function _(id, v) {
    return new IFC2X3.IfcProperty(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value));
  },
  3896028662: function _(id, v) {
    return new IFC2X3.IfcPropertyConstraintRelationship(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value));
  },
  148025276: function _(id, v) {
    return new IFC2X3.IfcPropertyDependencyRelationship(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcText(v[4].value));
  },
  3710013099: function _(id, v) {
    return new IFC2X3.IfcPropertyEnumeration(id, new IFC2X3.IfcLabel(v[0].value), v[1].map(function (p) {
      return TypeInitialiser(1, p);
    }), !v[2] ? null : new Handle(v[2].value));
  },
  2044713172: function _(id, v) {
    return new IFC2X3.IfcQuantityArea(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcAreaMeasure(v[3].value));
  },
  2093928680: function _(id, v) {
    return new IFC2X3.IfcQuantityCount(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcCountMeasure(v[3].value));
  },
  931644368: function _(id, v) {
    return new IFC2X3.IfcQuantityLength(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcLengthMeasure(v[3].value));
  },
  3252649465: function _(id, v) {
    return new IFC2X3.IfcQuantityTime(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcTimeMeasure(v[3].value));
  },
  2405470396: function _(id, v) {
    return new IFC2X3.IfcQuantityVolume(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcVolumeMeasure(v[3].value));
  },
  825690147: function _(id, v) {
    return new IFC2X3.IfcQuantityWeight(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC2X3.IfcMassMeasure(v[3].value));
  },
  2692823254: function _(id, v) {
    return new IFC2X3.IfcReferencesValueDocument(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value));
  },
  1580146022: function _(id, v) {
    return new IFC2X3.IfcReinforcementBarProperties(id, new IFC2X3.IfcAreaMeasure(v[0].value), new IFC2X3.IfcLabel(v[1].value), v[2], !v[3] ? null : new IFC2X3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcCountMeasure(v[5].value));
  },
  1222501353: function _(id, v) {
    return new IFC2X3.IfcRelaxation(id, new IFC2X3.IfcNormalisedRatioMeasure(v[0].value), new IFC2X3.IfcNormalisedRatioMeasure(v[1].value));
  },
  1076942058: function _(id, v) {
    return new IFC2X3.IfcRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3377609919: function _(id, v) {
    return new IFC2X3.IfcRepresentationContext(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value));
  },
  3008791417: function _(id, _4) {
    return new IFC2X3.IfcRepresentationItem(id);
  },
  1660063152: function _(id, v) {
    return new IFC2X3.IfcRepresentationMap(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  3679540991: function _(id, v) {
    return new IFC2X3.IfcRibPlateProfileProperties(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), v[6]);
  },
  2341007311: function _(id, v) {
    return new IFC2X3.IfcRoot(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value));
  },
  448429030: function _(id, v) {
    return new IFC2X3.IfcSIUnit(id, v[0], v[1], v[2]);
  },
  2042790032: function _(id, v) {
    return new IFC2X3.IfcSectionProperties(id, v[0], new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  4165799628: function _(id, v) {
    return new IFC2X3.IfcSectionReinforcementProperties(id, new IFC2X3.IfcLengthMeasure(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLengthMeasure(v[2].value), v[3], new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  867548509: function _(id, v) {
    return new IFC2X3.IfcShapeAspect(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcText(v[2].value), v[3].value, new Handle(v[4].value));
  },
  3982875396: function _(id, v) {
    return new IFC2X3.IfcShapeModel(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  4240577450: function _(id, v) {
    return new IFC2X3.IfcShapeRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3692461612: function _(id, v) {
    return new IFC2X3.IfcSimpleProperty(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value));
  },
  2273995522: function _(id, v) {
    return new IFC2X3.IfcStructuralConnectionCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value));
  },
  2162789131: function _(id, v) {
    return new IFC2X3.IfcStructuralLoad(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value));
  },
  2525727697: function _(id, v) {
    return new IFC2X3.IfcStructuralLoadStatic(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value));
  },
  3408363356: function _(id, v) {
    return new IFC2X3.IfcStructuralLoadTemperature(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[3].value));
  },
  2830218821: function _(id, v) {
    return new IFC2X3.IfcStyleModel(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3958052878: function _(id, v) {
    return new IFC2X3.IfcStyledItem(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  3049322572: function _(id, v) {
    return new IFC2X3.IfcStyledRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1300840506: function _(id, v) {
    return new IFC2X3.IfcSurfaceStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), v[1], v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3303107099: function _(id, v) {
    return new IFC2X3.IfcSurfaceStyleLighting(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new Handle(v[3].value));
  },
  1607154358: function _(id, v) {
    return new IFC2X3.IfcSurfaceStyleRefraction(id, !v[0] ? null : new IFC2X3.IfcReal(v[0].value), !v[1] ? null : new IFC2X3.IfcReal(v[1].value));
  },
  846575682: function _(id, v) {
    return new IFC2X3.IfcSurfaceStyleShading(id, new Handle(v[0].value));
  },
  1351298697: function _(id, v) {
    return new IFC2X3.IfcSurfaceStyleWithTextures(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  626085974: function _(id, v) {
    return new IFC2X3.IfcSurfaceTexture(id, v[0].value, v[1].value, v[2], !v[3] ? null : new Handle(v[3].value));
  },
  1290481447: function _(id, v) {
    return new IFC2X3.IfcSymbolStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), TypeInitialiser(1, v[1]));
  },
  985171141: function _(id, v) {
    return new IFC2X3.IfcTable(id, v[0].value, v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  531007025: function _(id, v) {
    return new IFC2X3.IfcTableRow(id, v[0].map(function (p) {
      return TypeInitialiser(1, p);
    }), v[1].value);
  },
  912023232: function _(id, v) {
    return new IFC2X3.IfcTelecomAddress(id, v[0], !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new IFC2X3.IfcLabel(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new IFC2X3.IfcLabel(p.value);
    }), !v[5] ? null : new IFC2X3.IfcLabel(v[5].value), !v[6] ? null : v[6].map(function (p) {
      return new IFC2X3.IfcLabel(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value));
  },
  1447204868: function _(id, v) {
    return new IFC2X3.IfcTextStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value));
  },
  1983826977: function _(id, v) {
    return new IFC2X3.IfcTextStyleFontModel(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return new IFC2X3.IfcTextFontName(p.value);
    }), !v[2] ? null : new IFC2X3.IfcFontStyle(v[2].value), !v[3] ? null : new IFC2X3.IfcFontVariant(v[3].value), !v[4] ? null : new IFC2X3.IfcFontWeight(v[4].value), TypeInitialiser(1, v[5]));
  },
  2636378356: function _(id, v) {
    return new IFC2X3.IfcTextStyleForDefinedFont(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  1640371178: function _(id, v) {
    return new IFC2X3.IfcTextStyleTextModel(id, !v[0] ? null : TypeInitialiser(1, v[0]), !v[1] ? null : new IFC2X3.IfcTextAlignment(v[1].value), !v[2] ? null : new IFC2X3.IfcTextDecoration(v[2].value), !v[3] ? null : TypeInitialiser(1, v[3]), !v[4] ? null : TypeInitialiser(1, v[4]), !v[5] ? null : new IFC2X3.IfcTextTransformation(v[5].value), !v[6] ? null : TypeInitialiser(1, v[6]));
  },
  1484833681: function _(id, v) {
    return new IFC2X3.IfcTextStyleWithBoxCharacteristics(id, !v[0] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[0].value), !v[1] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[3].value), !v[4] ? null : TypeInitialiser(1, v[4]));
  },
  280115917: function _(id, _5) {
    return new IFC2X3.IfcTextureCoordinate(id);
  },
  1742049831: function _(id, v) {
    return new IFC2X3.IfcTextureCoordinateGenerator(id, new IFC2X3.IfcLabel(v[0].value), v[1].map(function (p) {
      return TypeInitialiser(1, p);
    }));
  },
  2552916305: function _(id, v) {
    return new IFC2X3.IfcTextureMap(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1210645708: function _(id, v) {
    return new IFC2X3.IfcTextureVertex(id, v[0].map(function (p) {
      return new IFC2X3.IfcParameterValue(p.value);
    }));
  },
  3317419933: function _(id, v) {
    return new IFC2X3.IfcThermalMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcSpecificHeatCapacityMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcThermalConductivityMeasure(v[4].value));
  },
  3101149627: function _(id, v) {
    return new IFC2X3.IfcTimeSeries(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), v[4], v[5], !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  1718945513: function _(id, v) {
    return new IFC2X3.IfcTimeSeriesReferenceRelationship(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  581633288: function _(id, v) {
    return new IFC2X3.IfcTimeSeriesValue(id, v[0].map(function (p) {
      return TypeInitialiser(1, p);
    }));
  },
  1377556343: function _(id, _6) {
    return new IFC2X3.IfcTopologicalRepresentationItem(id);
  },
  1735638870: function _(id, v) {
    return new IFC2X3.IfcTopologyRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  180925521: function _(id, v) {
    return new IFC2X3.IfcUnitAssignment(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2799835756: function _(id, _7) {
    return new IFC2X3.IfcVertex(id);
  },
  3304826586: function _(id, v) {
    return new IFC2X3.IfcVertexBasedTextureMap(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1907098498: function _(id, v) {
    return new IFC2X3.IfcVertexPoint(id, new Handle(v[0].value));
  },
  891718957: function _(id, v) {
    return new IFC2X3.IfcVirtualGridIntersection(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1].map(function (p) {
      return new IFC2X3.IfcLengthMeasure(p.value);
    }));
  },
  1065908215: function _(id, v) {
    return new IFC2X3.IfcWaterProperties(id, new Handle(v[0].value), !v[1] ? null : v[1].value, !v[2] ? null : new IFC2X3.IfcIonConcentrationMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcIonConcentrationMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcIonConcentrationMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPHMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[7].value));
  },
  2442683028: function _(id, v) {
    return new IFC2X3.IfcAnnotationOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  962685235: function _(id, v) {
    return new IFC2X3.IfcAnnotationSurfaceOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  3612888222: function _(id, v) {
    return new IFC2X3.IfcAnnotationSymbolOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  2297822566: function _(id, v) {
    return new IFC2X3.IfcAnnotationTextOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  3798115385: function _(id, v) {
    return new IFC2X3.IfcArbitraryClosedProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value));
  },
  1310608509: function _(id, v) {
    return new IFC2X3.IfcArbitraryOpenProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value));
  },
  2705031697: function _(id, v) {
    return new IFC2X3.IfcArbitraryProfileDefWithVoids(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  616511568: function _(id, v) {
    return new IFC2X3.IfcBlobTexture(id, v[0].value, v[1].value, v[2], !v[3] ? null : new Handle(v[3].value), new IFC2X3.IfcIdentifier(v[4].value), v[5].value);
  },
  3150382593: function _(id, v) {
    return new IFC2X3.IfcCenterLineProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value));
  },
  647927063: function _(id, v) {
    return new IFC2X3.IfcClassificationReference(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value));
  },
  776857604: function _(id, v) {
    return new IFC2X3.IfcColourRgb(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new IFC2X3.IfcNormalisedRatioMeasure(v[1].value), new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), new IFC2X3.IfcNormalisedRatioMeasure(v[3].value));
  },
  2542286263: function _(id, v) {
    return new IFC2X3.IfcComplexProperty(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new IFC2X3.IfcIdentifier(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1485152156: function _(id, v) {
    return new IFC2X3.IfcCompositeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : new IFC2X3.IfcLabel(v[3].value));
  },
  370225590: function _(id, v) {
    return new IFC2X3.IfcConnectedFaceSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1981873012: function _(id, v) {
    return new IFC2X3.IfcConnectionCurveGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  45288368: function _(id, v) {
    return new IFC2X3.IfcConnectionPointEccentricity(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcLengthMeasure(v[4].value));
  },
  3050246964: function _(id, v) {
    return new IFC2X3.IfcContextDependentUnit(id, new Handle(v[0].value), v[1], new IFC2X3.IfcLabel(v[2].value));
  },
  2889183280: function _(id, v) {
    return new IFC2X3.IfcConversionBasedUnit(id, new Handle(v[0].value), v[1], new IFC2X3.IfcLabel(v[2].value), new Handle(v[3].value));
  },
  3800577675: function _(id, v) {
    return new IFC2X3.IfcCurveStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : TypeInitialiser(1, v[2]), !v[3] ? null : new Handle(v[3].value));
  },
  3632507154: function _(id, v) {
    return new IFC2X3.IfcDerivedProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  2273265877: function _(id, v) {
    return new IFC2X3.IfcDimensionCalloutRelationship(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value));
  },
  1694125774: function _(id, v) {
    return new IFC2X3.IfcDimensionPair(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value));
  },
  3732053477: function _(id, v) {
    return new IFC2X3.IfcDocumentReference(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  4170525392: function _(id, v) {
    return new IFC2X3.IfcDraughtingPreDefinedTextFont(id, new IFC2X3.IfcLabel(v[0].value));
  },
  3900360178: function _(id, v) {
    return new IFC2X3.IfcEdge(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  476780140: function _(id, v) {
    return new IFC2X3.IfcEdgeCurve(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), v[3].value);
  },
  1860660968: function _(id, v) {
    return new IFC2X3.IfcExtendedMaterialProperties(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcText(v[2].value), new IFC2X3.IfcLabel(v[3].value));
  },
  2556980723: function _(id, v) {
    return new IFC2X3.IfcFace(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1809719519: function _(id, v) {
    return new IFC2X3.IfcFaceBound(id, new Handle(v[0].value), v[1].value);
  },
  803316827: function _(id, v) {
    return new IFC2X3.IfcFaceOuterBound(id, new Handle(v[0].value), v[1].value);
  },
  3008276851: function _(id, v) {
    return new IFC2X3.IfcFaceSurface(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value), v[2].value);
  },
  4219587988: function _(id, v) {
    return new IFC2X3.IfcFailureConnectionCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcForceMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcForceMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcForceMeasure(v[6].value));
  },
  738692330: function _(id, v) {
    return new IFC2X3.IfcFillAreaStyle(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3857492461: function _(id, v) {
    return new IFC2X3.IfcFuelProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcHeatingValueMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcHeatingValueMeasure(v[4].value));
  },
  803998398: function _(id, v) {
    return new IFC2X3.IfcGeneralMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcMolecularWeightMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcMassDensityMeasure(v[3].value));
  },
  1446786286: function _(id, v) {
    return new IFC2X3.IfcGeneralProfileProperties(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcMassPerLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcAreaMeasure(v[6].value));
  },
  3448662350: function _(id, v) {
    return new IFC2X3.IfcGeometricRepresentationContext(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new IFC2X3.IfcDimensionCount(v[2].value), !v[3] ? null : v[3].value, new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value));
  },
  2453401579: function _(id, _8) {
    return new IFC2X3.IfcGeometricRepresentationItem(id);
  },
  4142052618: function _(id, v) {
    return new IFC2X3.IfcGeometricRepresentationSubContext(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[3].value), v[4], !v[5] ? null : new IFC2X3.IfcLabel(v[5].value));
  },
  3590301190: function _(id, v) {
    return new IFC2X3.IfcGeometricSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  178086475: function _(id, v) {
    return new IFC2X3.IfcGridPlacement(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  812098782: function _(id, v) {
    return new IFC2X3.IfcHalfSpaceSolid(id, new Handle(v[0].value), v[1].value);
  },
  2445078500: function _(id, v) {
    return new IFC2X3.IfcHygroscopicMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcIsothermalMoistureCapacityMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcVaporPermeabilityMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcMoistureDiffusivityMeasure(v[5].value));
  },
  3905492369: function _(id, v) {
    return new IFC2X3.IfcImageTexture(id, v[0].value, v[1].value, v[2], !v[3] ? null : new Handle(v[3].value), new IFC2X3.IfcIdentifier(v[4].value));
  },
  3741457305: function _(id, v) {
    return new IFC2X3.IfcIrregularTimeSeries(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), v[4], v[5], !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), v[8].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1402838566: function _(id, v) {
    return new IFC2X3.IfcLightSource(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value));
  },
  125510826: function _(id, v) {
    return new IFC2X3.IfcLightSourceAmbient(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value));
  },
  2604431987: function _(id, v) {
    return new IFC2X3.IfcLightSourceDirectional(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value));
  },
  4266656042: function _(id, v) {
    return new IFC2X3.IfcLightSourceGoniometric(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), new IFC2X3.IfcThermodynamicTemperatureMeasure(v[6].value), new IFC2X3.IfcLuminousFluxMeasure(v[7].value), v[8], new Handle(v[9].value));
  },
  1520743889: function _(id, v) {
    return new IFC2X3.IfcLightSourcePositional(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcReal(v[6].value), new IFC2X3.IfcReal(v[7].value), new IFC2X3.IfcReal(v[8].value));
  },
  3422422726: function _(id, v) {
    return new IFC2X3.IfcLightSourceSpot(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcReal(v[6].value), new IFC2X3.IfcReal(v[7].value), new IFC2X3.IfcReal(v[8].value), new Handle(v[9].value), !v[10] ? null : new IFC2X3.IfcReal(v[10].value), new IFC2X3.IfcPositivePlaneAngleMeasure(v[11].value), new IFC2X3.IfcPositivePlaneAngleMeasure(v[12].value));
  },
  2624227202: function _(id, v) {
    return new IFC2X3.IfcLocalPlacement(id, !v[0] ? null : new Handle(v[0].value), new Handle(v[1].value));
  },
  1008929658: function _(id, _9) {
    return new IFC2X3.IfcLoop(id);
  },
  2347385850: function _(id, v) {
    return new IFC2X3.IfcMappedItem(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  2022407955: function _(id, v) {
    return new IFC2X3.IfcMaterialDefinitionRepresentation(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[3].value));
  },
  1430189142: function _(id, v) {
    return new IFC2X3.IfcMechanicalConcreteMaterialProperties(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcDynamicViscosityMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcModulusOfElasticityMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcThermalExpansionCoefficientMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPressureMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcText(v[8].value), !v[9] ? null : new IFC2X3.IfcText(v[9].value), !v[10] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcText(v[11].value));
  },
  219451334: function _(id, v) {
    return new IFC2X3.IfcObjectDefinition(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value));
  },
  2833995503: function _(id, v) {
    return new IFC2X3.IfcOneDirectionRepeatFactor(id, new Handle(v[0].value));
  },
  2665983363: function _(id, v) {
    return new IFC2X3.IfcOpenShell(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1029017970: function _(id, v) {
    return new IFC2X3.IfcOrientedEdge(id, new Handle(v[0].value), v[1].value);
  },
  2529465313: function _(id, v) {
    return new IFC2X3.IfcParameterizedProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value));
  },
  2519244187: function _(id, v) {
    return new IFC2X3.IfcPath(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3021840470: function _(id, v) {
    return new IFC2X3.IfcPhysicalComplexQuantity(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new IFC2X3.IfcLabel(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcLabel(v[5].value));
  },
  597895409: function _(id, v) {
    return new IFC2X3.IfcPixelTexture(id, v[0].value, v[1].value, v[2], !v[3] ? null : new Handle(v[3].value), new IFC2X3.IfcInteger(v[4].value), new IFC2X3.IfcInteger(v[5].value), new IFC2X3.IfcInteger(v[6].value), v[7].map(function (p) {
      return p.value;
    }));
  },
  2004835150: function _(id, v) {
    return new IFC2X3.IfcPlacement(id, new Handle(v[0].value));
  },
  1663979128: function _(id, v) {
    return new IFC2X3.IfcPlanarExtent(id, new IFC2X3.IfcLengthMeasure(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value));
  },
  2067069095: function _(id, _10) {
    return new IFC2X3.IfcPoint(id);
  },
  4022376103: function _(id, v) {
    return new IFC2X3.IfcPointOnCurve(id, new Handle(v[0].value), new IFC2X3.IfcParameterValue(v[1].value));
  },
  1423911732: function _(id, v) {
    return new IFC2X3.IfcPointOnSurface(id, new Handle(v[0].value), new IFC2X3.IfcParameterValue(v[1].value), new IFC2X3.IfcParameterValue(v[2].value));
  },
  2924175390: function _(id, v) {
    return new IFC2X3.IfcPolyLoop(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2775532180: function _(id, v) {
    return new IFC2X3.IfcPolygonalBoundedHalfSpace(id, new Handle(v[0].value), v[1].value, new Handle(v[2].value), new Handle(v[3].value));
  },
  759155922: function _(id, v) {
    return new IFC2X3.IfcPreDefinedColour(id, new IFC2X3.IfcLabel(v[0].value));
  },
  2559016684: function _(id, v) {
    return new IFC2X3.IfcPreDefinedCurveFont(id, new IFC2X3.IfcLabel(v[0].value));
  },
  433424934: function _(id, v) {
    return new IFC2X3.IfcPreDefinedDimensionSymbol(id, new IFC2X3.IfcLabel(v[0].value));
  },
  179317114: function _(id, v) {
    return new IFC2X3.IfcPreDefinedPointMarkerSymbol(id, new IFC2X3.IfcLabel(v[0].value));
  },
  673634403: function _(id, v) {
    return new IFC2X3.IfcProductDefinitionShape(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  871118103: function _(id, v) {
    return new IFC2X3.IfcPropertyBoundedValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(1, v[2]), !v[3] ? null : TypeInitialiser(1, v[3]), !v[4] ? null : new Handle(v[4].value));
  },
  1680319473: function _(id, v) {
    return new IFC2X3.IfcPropertyDefinition(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value));
  },
  4166981789: function _(id, v) {
    return new IFC2X3.IfcPropertyEnumeratedValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map(function (p) {
      return TypeInitialiser(1, p);
    }), !v[3] ? null : new Handle(v[3].value));
  },
  2752243245: function _(id, v) {
    return new IFC2X3.IfcPropertyListValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map(function (p) {
      return TypeInitialiser(1, p);
    }), !v[3] ? null : new Handle(v[3].value));
  },
  941946838: function _(id, v) {
    return new IFC2X3.IfcPropertyReferenceValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), new Handle(v[3].value));
  },
  3357820518: function _(id, v) {
    return new IFC2X3.IfcPropertySetDefinition(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value));
  },
  3650150729: function _(id, v) {
    return new IFC2X3.IfcPropertySingleValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(1, v[2]), !v[3] ? null : new Handle(v[3].value));
  },
  110355661: function _(id, v) {
    return new IFC2X3.IfcPropertyTableValue(id, new IFC2X3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), v[2].map(function (p) {
      return TypeInitialiser(1, p);
    }), v[3].map(function (p) {
      return TypeInitialiser(1, p);
    }), !v[4] ? null : new IFC2X3.IfcText(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  3615266464: function _(id, v) {
    return new IFC2X3.IfcRectangleProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value));
  },
  3413951693: function _(id, v) {
    return new IFC2X3.IfcRegularTimeSeries(id, new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), v[4], v[5], !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), new IFC2X3.IfcTimeMeasure(v[8].value), v[9].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3765753017: function _(id, v) {
    return new IFC2X3.IfcReinforcementDefinitionProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  478536968: function _(id, v) {
    return new IFC2X3.IfcRelationship(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value));
  },
  2778083089: function _(id, v) {
    return new IFC2X3.IfcRoundedRectangleProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value));
  },
  1509187699: function _(id, v) {
    return new IFC2X3.IfcSectionedSpine(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2411513650: function _(id, v) {
    return new IFC2X3.IfcServiceLifeFactor(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], !v[5] ? null : TypeInitialiser(1, v[5]), TypeInitialiser(1, v[6]), !v[7] ? null : TypeInitialiser(1, v[7]));
  },
  4124623270: function _(id, v) {
    return new IFC2X3.IfcShellBasedSurfaceModel(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2609359061: function _(id, v) {
    return new IFC2X3.IfcSlippageConnectionCondition(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLengthMeasure(v[3].value));
  },
  723233188: function _(id, _11) {
    return new IFC2X3.IfcSolidModel(id);
  },
  2485662743: function _(id, v) {
    return new IFC2X3.IfcSoundProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new IFC2X3.IfcBoolean(v[4].value), v[5], v[6].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1202362311: function _(id, v) {
    return new IFC2X3.IfcSoundValue(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new IFC2X3.IfcFrequencyMeasure(v[5].value), !v[6] ? null : TypeInitialiser(1, v[6]));
  },
  390701378: function _(id, v) {
    return new IFC2X3.IfcSpaceThermalLoadProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[4].value), v[5], v[6], !v[7] ? null : new IFC2X3.IfcText(v[7].value), new IFC2X3.IfcPowerMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPowerMeasure(v[9].value), !v[10] ? null : new Handle(v[10].value), !v[11] ? null : new IFC2X3.IfcLabel(v[11].value), !v[12] ? null : new IFC2X3.IfcLabel(v[12].value), v[13]);
  },
  1595516126: function _(id, v) {
    return new IFC2X3.IfcStructuralLoadLinearForce(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLinearForceMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLinearForceMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLinearForceMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcLinearMomentMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcLinearMomentMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcLinearMomentMeasure(v[6].value));
  },
  2668620305: function _(id, v) {
    return new IFC2X3.IfcStructuralLoadPlanarForce(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcPlanarForceMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPlanarForceMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPlanarForceMeasure(v[3].value));
  },
  2473145415: function _(id, v) {
    return new IFC2X3.IfcStructuralLoadSingleDisplacement(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[6].value));
  },
  1973038258: function _(id, v) {
    return new IFC2X3.IfcStructuralLoadSingleDisplacementDistortion(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcCurvatureMeasure(v[7].value));
  },
  1597423693: function _(id, v) {
    return new IFC2X3.IfcStructuralLoadSingleForce(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcTorqueMeasure(v[6].value));
  },
  1190533807: function _(id, v) {
    return new IFC2X3.IfcStructuralLoadSingleForceWarping(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new IFC2X3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcTorqueMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcWarpingMomentMeasure(v[7].value));
  },
  3843319758: function _(id, v) {
    return new IFC2X3.IfcStructuralProfileProperties(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcMassPerLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcAreaMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcWarpingConstantMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcLengthMeasure(v[12].value), !v[13] ? null : new IFC2X3.IfcLengthMeasure(v[13].value), !v[14] ? null : new IFC2X3.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC2X3.IfcAreaMeasure(v[15].value), !v[16] ? null : new IFC2X3.IfcSectionModulusMeasure(v[16].value), !v[17] ? null : new IFC2X3.IfcSectionModulusMeasure(v[17].value), !v[18] ? null : new IFC2X3.IfcSectionModulusMeasure(v[18].value), !v[19] ? null : new IFC2X3.IfcSectionModulusMeasure(v[19].value), !v[20] ? null : new IFC2X3.IfcSectionModulusMeasure(v[20].value), !v[21] ? null : new IFC2X3.IfcLengthMeasure(v[21].value), !v[22] ? null : new IFC2X3.IfcLengthMeasure(v[22].value));
  },
  3653947884: function _(id, v) {
    return new IFC2X3.IfcStructuralSteelProfileProperties(id, !v[0] ? null : new IFC2X3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcMassPerLengthMeasure(v[2].value), !v[3] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcAreaMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcMomentOfInertiaMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcWarpingConstantMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcLengthMeasure(v[12].value), !v[13] ? null : new IFC2X3.IfcLengthMeasure(v[13].value), !v[14] ? null : new IFC2X3.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC2X3.IfcAreaMeasure(v[15].value), !v[16] ? null : new IFC2X3.IfcSectionModulusMeasure(v[16].value), !v[17] ? null : new IFC2X3.IfcSectionModulusMeasure(v[17].value), !v[18] ? null : new IFC2X3.IfcSectionModulusMeasure(v[18].value), !v[19] ? null : new IFC2X3.IfcSectionModulusMeasure(v[19].value), !v[20] ? null : new IFC2X3.IfcSectionModulusMeasure(v[20].value), !v[21] ? null : new IFC2X3.IfcLengthMeasure(v[21].value), !v[22] ? null : new IFC2X3.IfcLengthMeasure(v[22].value), !v[23] ? null : new IFC2X3.IfcAreaMeasure(v[23].value), !v[24] ? null : new IFC2X3.IfcAreaMeasure(v[24].value), !v[25] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[25].value), !v[26] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[26].value));
  },
  2233826070: function _(id, v) {
    return new IFC2X3.IfcSubedge(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value));
  },
  2513912981: function _(id, _12) {
    return new IFC2X3.IfcSurface(id);
  },
  1878645084: function _(id, v) {
    return new IFC2X3.IfcSurfaceStyleRendering(id, new Handle(v[0].value), !v[1] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : TypeInitialiser(1, v[7]), v[8]);
  },
  2247615214: function _(id, v) {
    return new IFC2X3.IfcSweptAreaSolid(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  1260650574: function _(id, v) {
    return new IFC2X3.IfcSweptDiskSolid(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[2].value), new IFC2X3.IfcParameterValue(v[3].value), new IFC2X3.IfcParameterValue(v[4].value));
  },
  230924584: function _(id, v) {
    return new IFC2X3.IfcSweptSurface(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  3071757647: function _(id, v) {
    return new IFC2X3.IfcTShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[12].value));
  },
  3028897424: function _(id, v) {
    return new IFC2X3.IfcTerminatorSymbol(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), new Handle(v[3].value));
  },
  4282788508: function _(id, v) {
    return new IFC2X3.IfcTextLiteral(id, new IFC2X3.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2]);
  },
  3124975700: function _(id, v) {
    return new IFC2X3.IfcTextLiteralWithExtent(id, new IFC2X3.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2], new Handle(v[3].value), new IFC2X3.IfcBoxAlignment(v[4].value));
  },
  2715220739: function _(id, v) {
    return new IFC2X3.IfcTrapeziumProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcLengthMeasure(v[6].value));
  },
  1345879162: function _(id, v) {
    return new IFC2X3.IfcTwoDirectionRepeatFactor(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  1628702193: function _(id, v) {
    return new IFC2X3.IfcTypeObject(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2347495698: function _(id, v) {
    return new IFC2X3.IfcTypeProduct(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value));
  },
  427810014: function _(id, v) {
    return new IFC2X3.IfcUShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value));
  },
  1417489154: function _(id, v) {
    return new IFC2X3.IfcVector(id, new Handle(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value));
  },
  2759199220: function _(id, v) {
    return new IFC2X3.IfcVertexLoop(id, new Handle(v[0].value));
  },
  336235671: function _(id, v) {
    return new IFC2X3.IfcWindowLiningProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[11].value), !v[12] ? null : new Handle(v[12].value));
  },
  512836454: function _(id, v) {
    return new IFC2X3.IfcWindowPanelProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value));
  },
  1299126871: function _(id, v) {
    return new IFC2X3.IfcWindowStyle(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], v[9], v[10].value, v[11].value);
  },
  2543172580: function _(id, v) {
    return new IFC2X3.IfcZShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value));
  },
  3288037868: function _(id, v) {
    return new IFC2X3.IfcAnnotationCurveOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  669184980: function _(id, v) {
    return new IFC2X3.IfcAnnotationFillArea(id, new Handle(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2265737646: function _(id, v) {
    return new IFC2X3.IfcAnnotationFillAreaOccurrence(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value), v[4]);
  },
  1302238472: function _(id, v) {
    return new IFC2X3.IfcAnnotationSurface(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  4261334040: function _(id, v) {
    return new IFC2X3.IfcAxis1Placement(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  3125803723: function _(id, v) {
    return new IFC2X3.IfcAxis2Placement2D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  2740243338: function _(id, v) {
    return new IFC2X3.IfcAxis2Placement3D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  2736907675: function _(id, v) {
    return new IFC2X3.IfcBooleanResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value));
  },
  4182860854: function _(id, _13) {
    return new IFC2X3.IfcBoundedSurface(id);
  },
  2581212453: function _(id, v) {
    return new IFC2X3.IfcBoundingBox(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value));
  },
  2713105998: function _(id, v) {
    return new IFC2X3.IfcBoxedHalfSpace(id, new Handle(v[0].value), v[1].value, new Handle(v[2].value));
  },
  2898889636: function _(id, v) {
    return new IFC2X3.IfcCShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value));
  },
  1123145078: function _(id, v) {
    return new IFC2X3.IfcCartesianPoint(id, v[0].map(function (p) {
      return new IFC2X3.IfcLengthMeasure(p.value);
    }));
  },
  59481748: function _(id, v) {
    return new IFC2X3.IfcCartesianTransformationOperator(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].value);
  },
  3749851601: function _(id, v) {
    return new IFC2X3.IfcCartesianTransformationOperator2D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].value);
  },
  3486308946: function _(id, v) {
    return new IFC2X3.IfcCartesianTransformationOperator2DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].value, !v[4] ? null : v[4].value);
  },
  3331915920: function _(id, v) {
    return new IFC2X3.IfcCartesianTransformationOperator3D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].value, !v[4] ? null : new Handle(v[4].value));
  },
  1416205885: function _(id, v) {
    return new IFC2X3.IfcCartesianTransformationOperator3DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].value, !v[4] ? null : new Handle(v[4].value), !v[5] ? null : v[5].value, !v[6] ? null : v[6].value);
  },
  1383045692: function _(id, v) {
    return new IFC2X3.IfcCircleProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value));
  },
  2205249479: function _(id, v) {
    return new IFC2X3.IfcClosedShell(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2485617015: function _(id, v) {
    return new IFC2X3.IfcCompositeCurveSegment(id, v[0], v[1].value, new Handle(v[2].value));
  },
  4133800736: function _(id, v) {
    return new IFC2X3.IfcCraneRailAShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), new IFC2X3.IfcPositiveLengthMeasure(v[7].value), new IFC2X3.IfcPositiveLengthMeasure(v[8].value), new IFC2X3.IfcPositiveLengthMeasure(v[9].value), new IFC2X3.IfcPositiveLengthMeasure(v[10].value), new IFC2X3.IfcPositiveLengthMeasure(v[11].value), new IFC2X3.IfcPositiveLengthMeasure(v[12].value), new IFC2X3.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[14].value));
  },
  194851669: function _(id, v) {
    return new IFC2X3.IfcCraneRailFShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), new IFC2X3.IfcPositiveLengthMeasure(v[7].value), new IFC2X3.IfcPositiveLengthMeasure(v[8].value), new IFC2X3.IfcPositiveLengthMeasure(v[9].value), new IFC2X3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[11].value));
  },
  2506170314: function _(id, v) {
    return new IFC2X3.IfcCsgPrimitive3D(id, new Handle(v[0].value));
  },
  2147822146: function _(id, v) {
    return new IFC2X3.IfcCsgSolid(id, new Handle(v[0].value));
  },
  2601014836: function _(id, _14) {
    return new IFC2X3.IfcCurve(id);
  },
  2827736869: function _(id, v) {
    return new IFC2X3.IfcCurveBoundedPlane(id, new Handle(v[0].value), new Handle(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  693772133: function _(id, v) {
    return new IFC2X3.IfcDefinedSymbol(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  606661476: function _(id, v) {
    return new IFC2X3.IfcDimensionCurve(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  4054601972: function _(id, v) {
    return new IFC2X3.IfcDimensionCurveTerminator(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), new Handle(v[3].value), v[4]);
  },
  32440307: function _(id, v) {
    return new IFC2X3.IfcDirection(id, v[0].map(function (p) {
      return p.value;
    }));
  },
  2963535650: function _(id, v) {
    return new IFC2X3.IfcDoorLiningProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcLengthMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new Handle(v[14].value));
  },
  1714330368: function _(id, v) {
    return new IFC2X3.IfcDoorPanelProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), v[5], !v[6] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value));
  },
  526551008: function _(id, v) {
    return new IFC2X3.IfcDoorStyle(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], v[9], v[10].value, v[11].value);
  },
  3073041342: function _(id, v) {
    return new IFC2X3.IfcDraughtingCallout(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  445594917: function _(id, v) {
    return new IFC2X3.IfcDraughtingPreDefinedColour(id, new IFC2X3.IfcLabel(v[0].value));
  },
  4006246654: function _(id, v) {
    return new IFC2X3.IfcDraughtingPreDefinedCurveFont(id, new IFC2X3.IfcLabel(v[0].value));
  },
  1472233963: function _(id, v) {
    return new IFC2X3.IfcEdgeLoop(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1883228015: function _(id, v) {
    return new IFC2X3.IfcElementQuantity(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  339256511: function _(id, v) {
    return new IFC2X3.IfcElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  2777663545: function _(id, v) {
    return new IFC2X3.IfcElementarySurface(id, new Handle(v[0].value));
  },
  2835456948: function _(id, v) {
    return new IFC2X3.IfcEllipseProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value));
  },
  80994333: function _(id, v) {
    return new IFC2X3.IfcEnergyProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], !v[5] ? null : new IFC2X3.IfcLabel(v[5].value));
  },
  477187591: function _(id, v) {
    return new IFC2X3.IfcExtrudedAreaSolid(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value));
  },
  2047409740: function _(id, v) {
    return new IFC2X3.IfcFaceBasedSurfaceModel(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  374418227: function _(id, v) {
    return new IFC2X3.IfcFillAreaStyleHatching(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), new IFC2X3.IfcPlaneAngleMeasure(v[4].value));
  },
  4203026998: function _(id, v) {
    return new IFC2X3.IfcFillAreaStyleTileSymbolWithStyle(id, new Handle(v[0].value));
  },
  315944413: function _(id, v) {
    return new IFC2X3.IfcFillAreaStyleTiles(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), new IFC2X3.IfcPositiveRatioMeasure(v[2].value));
  },
  3455213021: function _(id, v) {
    return new IFC2X3.IfcFluidFlowProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new IFC2X3.IfcLabel(v[10].value), !v[11] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcThermodynamicTemperatureMeasure(v[12].value), !v[13] ? null : new Handle(v[13].value), !v[14] ? null : new Handle(v[14].value), !v[15] ? null : TypeInitialiser(1, v[15]), !v[16] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[16].value), !v[17] ? null : new IFC2X3.IfcLinearVelocityMeasure(v[17].value), !v[18] ? null : new IFC2X3.IfcPressureMeasure(v[18].value));
  },
  4238390223: function _(id, v) {
    return new IFC2X3.IfcFurnishingElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  1268542332: function _(id, v) {
    return new IFC2X3.IfcFurnitureType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  987898635: function _(id, v) {
    return new IFC2X3.IfcGeometricCurveSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1484403080: function _(id, v) {
    return new IFC2X3.IfcIShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value));
  },
  572779678: function _(id, v) {
    return new IFC2X3.IfcLShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new IFC2X3.IfcPlaneAngleMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value));
  },
  1281925730: function _(id, v) {
    return new IFC2X3.IfcLine(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  1425443689: function _(id, v) {
    return new IFC2X3.IfcManifoldSolidBrep(id, new Handle(v[0].value));
  },
  3888040117: function _(id, v) {
    return new IFC2X3.IfcObject(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  3388369263: function _(id, v) {
    return new IFC2X3.IfcOffsetCurve2D(id, new Handle(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value), v[2].value);
  },
  3505215534: function _(id, v) {
    return new IFC2X3.IfcOffsetCurve3D(id, new Handle(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value), v[2].value, new Handle(v[3].value));
  },
  3566463478: function _(id, v) {
    return new IFC2X3.IfcPermeableCoveringProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value));
  },
  603570806: function _(id, v) {
    return new IFC2X3.IfcPlanarBox(id, new IFC2X3.IfcLengthMeasure(v[0].value), new IFC2X3.IfcLengthMeasure(v[1].value), new Handle(v[2].value));
  },
  220341763: function _(id, v) {
    return new IFC2X3.IfcPlane(id, new Handle(v[0].value));
  },
  2945172077: function _(id, v) {
    return new IFC2X3.IfcProcess(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  4208778838: function _(id, v) {
    return new IFC2X3.IfcProduct(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  103090709: function _(id, v) {
    return new IFC2X3.IfcProject(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcLabel(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[8].value));
  },
  4194566429: function _(id, v) {
    return new IFC2X3.IfcProjectionCurve(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value));
  },
  1451395588: function _(id, v) {
    return new IFC2X3.IfcPropertySet(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3219374653: function _(id, v) {
    return new IFC2X3.IfcProxy(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  2770003689: function _(id, v) {
    return new IFC2X3.IfcRectangleHollowProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value));
  },
  2798486643: function _(id, v) {
    return new IFC2X3.IfcRectangularPyramid(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value));
  },
  3454111270: function _(id, v) {
    return new IFC2X3.IfcRectangularTrimmedSurface(id, new Handle(v[0].value), new IFC2X3.IfcParameterValue(v[1].value), new IFC2X3.IfcParameterValue(v[2].value), new IFC2X3.IfcParameterValue(v[3].value), new IFC2X3.IfcParameterValue(v[4].value), v[5].value, v[6].value);
  },
  3939117080: function _(id, v) {
    return new IFC2X3.IfcRelAssigns(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5]);
  },
  1683148259: function _(id, v) {
    return new IFC2X3.IfcRelAssignsToActor(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  2495723537: function _(id, v) {
    return new IFC2X3.IfcRelAssignsToControl(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  1307041759: function _(id, v) {
    return new IFC2X3.IfcRelAssignsToGroup(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  4278684876: function _(id, v) {
    return new IFC2X3.IfcRelAssignsToProcess(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  2857406711: function _(id, v) {
    return new IFC2X3.IfcRelAssignsToProduct(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  3372526763: function _(id, v) {
    return new IFC2X3.IfcRelAssignsToProjectOrder(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  205026976: function _(id, v) {
    return new IFC2X3.IfcRelAssignsToResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  1865459582: function _(id, v) {
    return new IFC2X3.IfcRelAssociates(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1327628568: function _(id, v) {
    return new IFC2X3.IfcRelAssociatesAppliedValue(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  4095574036: function _(id, v) {
    return new IFC2X3.IfcRelAssociatesApproval(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  919958153: function _(id, v) {
    return new IFC2X3.IfcRelAssociatesClassification(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  2728634034: function _(id, v) {
    return new IFC2X3.IfcRelAssociatesConstraint(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new IFC2X3.IfcLabel(v[5].value), new Handle(v[6].value));
  },
  982818633: function _(id, v) {
    return new IFC2X3.IfcRelAssociatesDocument(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  3840914261: function _(id, v) {
    return new IFC2X3.IfcRelAssociatesLibrary(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  2655215786: function _(id, v) {
    return new IFC2X3.IfcRelAssociatesMaterial(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  2851387026: function _(id, v) {
    return new IFC2X3.IfcRelAssociatesProfileProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  826625072: function _(id, v) {
    return new IFC2X3.IfcRelConnects(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value));
  },
  1204542856: function _(id, v) {
    return new IFC2X3.IfcRelConnectsElements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value));
  },
  3945020480: function _(id, v) {
    return new IFC2X3.IfcRelConnectsPathElements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map(function (p) {
      return p.value;
    }), v[8].map(function (p) {
      return p.value;
    }), v[9], v[10]);
  },
  4201705270: function _(id, v) {
    return new IFC2X3.IfcRelConnectsPortToElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  3190031847: function _(id, v) {
    return new IFC2X3.IfcRelConnectsPorts(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  2127690289: function _(id, v) {
    return new IFC2X3.IfcRelConnectsStructuralActivity(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  3912681535: function _(id, v) {
    return new IFC2X3.IfcRelConnectsStructuralElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  1638771189: function _(id, v) {
    return new IFC2X3.IfcRelConnectsStructuralMember(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC2X3.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value));
  },
  504942748: function _(id, v) {
    return new IFC2X3.IfcRelConnectsWithEccentricity(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC2X3.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value), new Handle(v[10].value));
  },
  3678494232: function _(id, v) {
    return new IFC2X3.IfcRelConnectsWithRealizingElements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  3242617779: function _(id, v) {
    return new IFC2X3.IfcRelContainedInSpatialStructure(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  886880790: function _(id, v) {
    return new IFC2X3.IfcRelCoversBldgElements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2802773753: function _(id, v) {
    return new IFC2X3.IfcRelCoversSpaces(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2551354335: function _(id, v) {
    return new IFC2X3.IfcRelDecomposes(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  693640335: function _(id, v) {
    return new IFC2X3.IfcRelDefines(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }));
  },
  4186316022: function _(id, v) {
    return new IFC2X3.IfcRelDefinesByProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  781010003: function _(id, v) {
    return new IFC2X3.IfcRelDefinesByType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  3940055652: function _(id, v) {
    return new IFC2X3.IfcRelFillsElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  279856033: function _(id, v) {
    return new IFC2X3.IfcRelFlowControlElements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  4189434867: function _(id, v) {
    return new IFC2X3.IfcRelInteractionRequirements(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcCountMeasure(v[4].value), !v[5] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), new Handle(v[8].value));
  },
  3268803585: function _(id, v) {
    return new IFC2X3.IfcRelNests(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2051452291: function _(id, v) {
    return new IFC2X3.IfcRelOccupiesSpaces(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  202636808: function _(id, v) {
    return new IFC2X3.IfcRelOverridesProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value), v[6].map(function (p) {
      return new Handle(p.value);
    }));
  },
  750771296: function _(id, v) {
    return new IFC2X3.IfcRelProjectsElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  1245217292: function _(id, v) {
    return new IFC2X3.IfcRelReferencedInSpatialStructure(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  1058617721: function _(id, v) {
    return new IFC2X3.IfcRelSchedulesCostItems(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  4122056220: function _(id, v) {
    return new IFC2X3.IfcRelSequence(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), new IFC2X3.IfcTimeMeasure(v[6].value), v[7]);
  },
  366585022: function _(id, v) {
    return new IFC2X3.IfcRelServicesBuildings(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3451746338: function _(id, v) {
    return new IFC2X3.IfcRelSpaceBoundary(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8]);
  },
  1401173127: function _(id, v) {
    return new IFC2X3.IfcRelVoidsElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  2914609552: function _(id, v) {
    return new IFC2X3.IfcResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  1856042241: function _(id, v) {
    return new IFC2X3.IfcRevolvedAreaSolid(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPlaneAngleMeasure(v[3].value));
  },
  4158566097: function _(id, v) {
    return new IFC2X3.IfcRightCircularCone(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value));
  },
  3626867408: function _(id, v) {
    return new IFC2X3.IfcRightCircularCylinder(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value));
  },
  2706606064: function _(id, v) {
    return new IFC2X3.IfcSpatialStructureElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8]);
  },
  3893378262: function _(id, v) {
    return new IFC2X3.IfcSpatialStructureElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  451544542: function _(id, v) {
    return new IFC2X3.IfcSphere(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value));
  },
  3544373492: function _(id, v) {
    return new IFC2X3.IfcStructuralActivity(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]);
  },
  3136571912: function _(id, v) {
    return new IFC2X3.IfcStructuralItem(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  530289379: function _(id, v) {
    return new IFC2X3.IfcStructuralMember(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  3689010777: function _(id, v) {
    return new IFC2X3.IfcStructuralReaction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]);
  },
  3979015343: function _(id, v) {
    return new IFC2X3.IfcStructuralSurfaceMember(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value));
  },
  2218152070: function _(id, v) {
    return new IFC2X3.IfcStructuralSurfaceMemberVarying(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), v[9].map(function (p) {
      return new IFC2X3.IfcPositiveLengthMeasure(p.value);
    }), new Handle(v[10].value));
  },
  4070609034: function _(id, v) {
    return new IFC2X3.IfcStructuredDimensionCallout(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2028607225: function _(id, v) {
    return new IFC2X3.IfcSurfaceCurveSweptAreaSolid(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC2X3.IfcParameterValue(v[3].value), new IFC2X3.IfcParameterValue(v[4].value), new Handle(v[5].value));
  },
  2809605785: function _(id, v) {
    return new IFC2X3.IfcSurfaceOfLinearExtrusion(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC2X3.IfcLengthMeasure(v[3].value));
  },
  4124788165: function _(id, v) {
    return new IFC2X3.IfcSurfaceOfRevolution(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value));
  },
  1580310250: function _(id, v) {
    return new IFC2X3.IfcSystemFurnitureElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  3473067441: function _(id, v) {
    return new IFC2X3.IfcTask(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8].value, !v[9] ? null : v[9].value);
  },
  2097647324: function _(id, v) {
    return new IFC2X3.IfcTransportElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2296667514: function _(id, v) {
    return new IFC2X3.IfcActor(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new Handle(v[5].value));
  },
  1674181508: function _(id, v) {
    return new IFC2X3.IfcAnnotation(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  3207858831: function _(id, v) {
    return new IFC2X3.IfcAsymmetricIShapeProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value), new IFC2X3.IfcPositiveLengthMeasure(v[5].value), new IFC2X3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[7].value), new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[11].value));
  },
  1334484129: function _(id, v) {
    return new IFC2X3.IfcBlock(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value));
  },
  3649129432: function _(id, v) {
    return new IFC2X3.IfcBooleanClippingResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value));
  },
  1260505505: function _(id, _15) {
    return new IFC2X3.IfcBoundedCurve(id);
  },
  4031249490: function _(id, v) {
    return new IFC2X3.IfcBuilding(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC2X3.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcLengthMeasure(v[10].value), !v[11] ? null : new Handle(v[11].value));
  },
  1950629157: function _(id, v) {
    return new IFC2X3.IfcBuildingElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  3124254112: function _(id, v) {
    return new IFC2X3.IfcBuildingStorey(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC2X3.IfcLengthMeasure(v[9].value));
  },
  2937912522: function _(id, v) {
    return new IFC2X3.IfcCircleHollowProfileDef(id, v[0], !v[1] ? null : new IFC2X3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC2X3.IfcPositiveLengthMeasure(v[3].value), new IFC2X3.IfcPositiveLengthMeasure(v[4].value));
  },
  300633059: function _(id, v) {
    return new IFC2X3.IfcColumnType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3732776249: function _(id, v) {
    return new IFC2X3.IfcCompositeCurve(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1].value);
  },
  2510884976: function _(id, v) {
    return new IFC2X3.IfcConic(id, new Handle(v[0].value));
  },
  2559216714: function _(id, v) {
    return new IFC2X3.IfcConstructionResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value));
  },
  3293443760: function _(id, v) {
    return new IFC2X3.IfcControl(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  3895139033: function _(id, v) {
    return new IFC2X3.IfcCostItem(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  1419761937: function _(id, v) {
    return new IFC2X3.IfcCostSchedule(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), new IFC2X3.IfcIdentifier(v[11].value), v[12]);
  },
  1916426348: function _(id, v) {
    return new IFC2X3.IfcCoveringType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3295246426: function _(id, v) {
    return new IFC2X3.IfcCrewResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value));
  },
  1457835157: function _(id, v) {
    return new IFC2X3.IfcCurtainWallType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  681481545: function _(id, v) {
    return new IFC2X3.IfcDimensionCurveDirectedCallout(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3256556792: function _(id, v) {
    return new IFC2X3.IfcDistributionElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  3849074793: function _(id, v) {
    return new IFC2X3.IfcDistributionFlowElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  360485395: function _(id, v) {
    return new IFC2X3.IfcElectricalBaseProperties(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4], !v[5] ? null : new IFC2X3.IfcLabel(v[5].value), v[6], new IFC2X3.IfcElectricVoltageMeasure(v[7].value), new IFC2X3.IfcFrequencyMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcElectricCurrentMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcElectricCurrentMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPowerMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcPowerMeasure(v[12].value), v[13].value);
  },
  1758889154: function _(id, v) {
    return new IFC2X3.IfcElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  4123344466: function _(id, v) {
    return new IFC2X3.IfcElementAssembly(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8], v[9]);
  },
  1623761950: function _(id, v) {
    return new IFC2X3.IfcElementComponent(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  2590856083: function _(id, v) {
    return new IFC2X3.IfcElementComponentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  1704287377: function _(id, v) {
    return new IFC2X3.IfcEllipse(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value), new IFC2X3.IfcPositiveLengthMeasure(v[2].value));
  },
  2107101300: function _(id, v) {
    return new IFC2X3.IfcEnergyConversionDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  1962604670: function _(id, v) {
    return new IFC2X3.IfcEquipmentElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  3272907226: function _(id, v) {
    return new IFC2X3.IfcEquipmentStandard(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  3174744832: function _(id, v) {
    return new IFC2X3.IfcEvaporativeCoolerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3390157468: function _(id, v) {
    return new IFC2X3.IfcEvaporatorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  807026263: function _(id, v) {
    return new IFC2X3.IfcFacetedBrep(id, new Handle(v[0].value));
  },
  3737207727: function _(id, v) {
    return new IFC2X3.IfcFacetedBrepWithVoids(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  647756555: function _(id, v) {
    return new IFC2X3.IfcFastener(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  2489546625: function _(id, v) {
    return new IFC2X3.IfcFastenerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  2827207264: function _(id, v) {
    return new IFC2X3.IfcFeatureElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  2143335405: function _(id, v) {
    return new IFC2X3.IfcFeatureElementAddition(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  1287392070: function _(id, v) {
    return new IFC2X3.IfcFeatureElementSubtraction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  3907093117: function _(id, v) {
    return new IFC2X3.IfcFlowControllerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  3198132628: function _(id, v) {
    return new IFC2X3.IfcFlowFittingType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  3815607619: function _(id, v) {
    return new IFC2X3.IfcFlowMeterType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1482959167: function _(id, v) {
    return new IFC2X3.IfcFlowMovingDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  1834744321: function _(id, v) {
    return new IFC2X3.IfcFlowSegmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  1339347760: function _(id, v) {
    return new IFC2X3.IfcFlowStorageDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  2297155007: function _(id, v) {
    return new IFC2X3.IfcFlowTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  3009222698: function _(id, v) {
    return new IFC2X3.IfcFlowTreatmentDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  263784265: function _(id, v) {
    return new IFC2X3.IfcFurnishingElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  814719939: function _(id, v) {
    return new IFC2X3.IfcFurnitureStandard(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  200128114: function _(id, v) {
    return new IFC2X3.IfcGasTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3009204131: function _(id, v) {
    return new IFC2X3.IfcGrid(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7].map(function (p) {
      return new Handle(p.value);
    }), v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2706460486: function _(id, v) {
    return new IFC2X3.IfcGroup(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  1251058090: function _(id, v) {
    return new IFC2X3.IfcHeatExchangerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1806887404: function _(id, v) {
    return new IFC2X3.IfcHumidifierType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2391368822: function _(id, v) {
    return new IFC2X3.IfcInventory(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5], new Handle(v[6].value), v[7].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value));
  },
  4288270099: function _(id, v) {
    return new IFC2X3.IfcJunctionBoxType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3827777499: function _(id, v) {
    return new IFC2X3.IfcLaborResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new IFC2X3.IfcText(v[9].value));
  },
  1051575348: function _(id, v) {
    return new IFC2X3.IfcLampType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1161773419: function _(id, v) {
    return new IFC2X3.IfcLightFixtureType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2506943328: function _(id, v) {
    return new IFC2X3.IfcLinearDimension(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  377706215: function _(id, v) {
    return new IFC2X3.IfcMechanicalFastener(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value));
  },
  2108223431: function _(id, v) {
    return new IFC2X3.IfcMechanicalFastenerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  3181161470: function _(id, v) {
    return new IFC2X3.IfcMemberType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  977012517: function _(id, v) {
    return new IFC2X3.IfcMotorConnectionType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1916936684: function _(id, v) {
    return new IFC2X3.IfcMove(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8].value, !v[9] ? null : v[9].value, new Handle(v[10].value), new Handle(v[11].value), !v[12] ? null : v[12].map(function (p) {
      return new IFC2X3.IfcText(p.value);
    }));
  },
  4143007308: function _(id, v) {
    return new IFC2X3.IfcOccupant(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new Handle(v[5].value), v[6]);
  },
  3588315303: function _(id, v) {
    return new IFC2X3.IfcOpeningElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  3425660407: function _(id, v) {
    return new IFC2X3.IfcOrderAction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8].value, !v[9] ? null : v[9].value, new IFC2X3.IfcIdentifier(v[10].value));
  },
  2837617999: function _(id, v) {
    return new IFC2X3.IfcOutletType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2382730787: function _(id, v) {
    return new IFC2X3.IfcPerformanceHistory(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcLabel(v[5].value));
  },
  3327091369: function _(id, v) {
    return new IFC2X3.IfcPermit(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value));
  },
  804291784: function _(id, v) {
    return new IFC2X3.IfcPipeFittingType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  4231323485: function _(id, v) {
    return new IFC2X3.IfcPipeSegmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  4017108033: function _(id, v) {
    return new IFC2X3.IfcPlateType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3724593414: function _(id, v) {
    return new IFC2X3.IfcPolyline(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3740093272: function _(id, v) {
    return new IFC2X3.IfcPort(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  2744685151: function _(id, v) {
    return new IFC2X3.IfcProcedure(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC2X3.IfcLabel(v[7].value));
  },
  2904328755: function _(id, v) {
    return new IFC2X3.IfcProjectOrder(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC2X3.IfcLabel(v[7].value));
  },
  3642467123: function _(id, v) {
    return new IFC2X3.IfcProjectOrderRecord(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }), v[6]);
  },
  3651124850: function _(id, v) {
    return new IFC2X3.IfcProjectionElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  1842657554: function _(id, v) {
    return new IFC2X3.IfcProtectiveDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2250791053: function _(id, v) {
    return new IFC2X3.IfcPumpType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3248260540: function _(id, v) {
    return new IFC2X3.IfcRadiusDimension(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2893384427: function _(id, v) {
    return new IFC2X3.IfcRailingType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2324767716: function _(id, v) {
    return new IFC2X3.IfcRampFlightType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  160246688: function _(id, v) {
    return new IFC2X3.IfcRelAggregates(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2863920197: function _(id, v) {
    return new IFC2X3.IfcRelAssignsTasks(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  1768891740: function _(id, v) {
    return new IFC2X3.IfcSanitaryTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3517283431: function _(id, v) {
    return new IFC2X3.IfcScheduleTimeControl(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value), !v[11] ? null : new Handle(v[11].value), !v[12] ? null : new Handle(v[12].value), !v[13] ? null : new IFC2X3.IfcTimeMeasure(v[13].value), !v[14] ? null : new IFC2X3.IfcTimeMeasure(v[14].value), !v[15] ? null : new IFC2X3.IfcTimeMeasure(v[15].value), !v[16] ? null : new IFC2X3.IfcTimeMeasure(v[16].value), !v[17] ? null : new IFC2X3.IfcTimeMeasure(v[17].value), !v[18] ? null : v[18].value, !v[19] ? null : new Handle(v[19].value), !v[20] ? null : new IFC2X3.IfcTimeMeasure(v[20].value), !v[21] ? null : new IFC2X3.IfcTimeMeasure(v[21].value), !v[22] ? null : new IFC2X3.IfcPositiveRatioMeasure(v[22].value));
  },
  4105383287: function _(id, v) {
    return new IFC2X3.IfcServiceLife(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5], new IFC2X3.IfcTimeMeasure(v[6].value));
  },
  4097777520: function _(id, v) {
    return new IFC2X3.IfcSite(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC2X3.IfcCompoundPlaneAngleMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcCompoundPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcLabel(v[12].value), !v[13] ? null : new Handle(v[13].value));
  },
  2533589738: function _(id, v) {
    return new IFC2X3.IfcSlabType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3856911033: function _(id, v) {
    return new IFC2X3.IfcSpace(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), v[8], v[9], !v[10] ? null : new IFC2X3.IfcLengthMeasure(v[10].value));
  },
  1305183839: function _(id, v) {
    return new IFC2X3.IfcSpaceHeaterType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  652456506: function _(id, v) {
    return new IFC2X3.IfcSpaceProgram(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcAreaMeasure(v[6].value), !v[7] ? null : new IFC2X3.IfcAreaMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value), new IFC2X3.IfcAreaMeasure(v[9].value));
  },
  3812236995: function _(id, v) {
    return new IFC2X3.IfcSpaceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3112655638: function _(id, v) {
    return new IFC2X3.IfcStackTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1039846685: function _(id, v) {
    return new IFC2X3.IfcStairFlightType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  682877961: function _(id, v) {
    return new IFC2X3.IfcStructuralAction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value));
  },
  1179482911: function _(id, v) {
    return new IFC2X3.IfcStructuralConnection(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  4243806635: function _(id, v) {
    return new IFC2X3.IfcStructuralCurveConnection(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  214636428: function _(id, v) {
    return new IFC2X3.IfcStructuralCurveMember(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]);
  },
  2445595289: function _(id, v) {
    return new IFC2X3.IfcStructuralCurveMemberVarying(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]);
  },
  1807405624: function _(id, v) {
    return new IFC2X3.IfcStructuralLinearAction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  1721250024: function _(id, v) {
    return new IFC2X3.IfcStructuralLinearActionVarying(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value), v[11], new Handle(v[12].value), v[13].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1252848954: function _(id, v) {
    return new IFC2X3.IfcStructuralLoadGroup(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5], v[6], v[7], !v[8] ? null : new IFC2X3.IfcRatioMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcLabel(v[9].value));
  },
  1621171031: function _(id, v) {
    return new IFC2X3.IfcStructuralPlanarAction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  3987759626: function _(id, v) {
    return new IFC2X3.IfcStructuralPlanarActionVarying(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value), v[11], new Handle(v[12].value), v[13].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2082059205: function _(id, v) {
    return new IFC2X3.IfcStructuralPointAction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9].value, !v[10] ? null : new Handle(v[10].value));
  },
  734778138: function _(id, v) {
    return new IFC2X3.IfcStructuralPointConnection(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  1235345126: function _(id, v) {
    return new IFC2X3.IfcStructuralPointReaction(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]);
  },
  2986769608: function _(id, v) {
    return new IFC2X3.IfcStructuralResultGroup(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), v[7].value);
  },
  1975003073: function _(id, v) {
    return new IFC2X3.IfcStructuralSurfaceConnection(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  148013059: function _(id, v) {
    return new IFC2X3.IfcSubContractResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new IFC2X3.IfcText(v[10].value));
  },
  2315554128: function _(id, v) {
    return new IFC2X3.IfcSwitchingDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2254336722: function _(id, v) {
    return new IFC2X3.IfcSystem(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  5716631: function _(id, v) {
    return new IFC2X3.IfcTankType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1637806684: function _(id, v) {
    return new IFC2X3.IfcTimeSeriesSchedule(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), v[6], new Handle(v[7].value));
  },
  1692211062: function _(id, v) {
    return new IFC2X3.IfcTransformerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1620046519: function _(id, v) {
    return new IFC2X3.IfcTransportElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8], !v[9] ? null : new IFC2X3.IfcMassMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcCountMeasure(v[10].value));
  },
  3593883385: function _(id, v) {
    return new IFC2X3.IfcTrimmedCurve(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2].map(function (p) {
      return new Handle(p.value);
    }), v[3].value, v[4]);
  },
  1600972822: function _(id, v) {
    return new IFC2X3.IfcTubeBundleType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1911125066: function _(id, v) {
    return new IFC2X3.IfcUnitaryEquipmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  728799441: function _(id, v) {
    return new IFC2X3.IfcValveType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2769231204: function _(id, v) {
    return new IFC2X3.IfcVirtualElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  1898987631: function _(id, v) {
    return new IFC2X3.IfcWallType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1133259667: function _(id, v) {
    return new IFC2X3.IfcWasteTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1028945134: function _(id, v) {
    return new IFC2X3.IfcWorkControl(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), new Handle(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : new IFC2X3.IfcTimeMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcTimeMeasure(v[10].value), new Handle(v[11].value), !v[12] ? null : new Handle(v[12].value), v[13], !v[14] ? null : new IFC2X3.IfcLabel(v[14].value));
  },
  4218914973: function _(id, v) {
    return new IFC2X3.IfcWorkPlan(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), new Handle(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : new IFC2X3.IfcTimeMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcTimeMeasure(v[10].value), new Handle(v[11].value), !v[12] ? null : new Handle(v[12].value), v[13], !v[14] ? null : new IFC2X3.IfcLabel(v[14].value));
  },
  3342526732: function _(id, v) {
    return new IFC2X3.IfcWorkSchedule(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), new Handle(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : new IFC2X3.IfcTimeMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcTimeMeasure(v[10].value), new Handle(v[11].value), !v[12] ? null : new Handle(v[12].value), v[13], !v[14] ? null : new IFC2X3.IfcLabel(v[14].value));
  },
  1033361043: function _(id, v) {
    return new IFC2X3.IfcZone(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  1213861670: function _(id, v) {
    return new IFC2X3.Ifc2DCompositeCurve(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1].value);
  },
  3821786052: function _(id, v) {
    return new IFC2X3.IfcActionRequest(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value));
  },
  1411407467: function _(id, v) {
    return new IFC2X3.IfcAirTerminalBoxType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3352864051: function _(id, v) {
    return new IFC2X3.IfcAirTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1871374353: function _(id, v) {
    return new IFC2X3.IfcAirToAirHeatRecoveryType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2470393545: function _(id, v) {
    return new IFC2X3.IfcAngularDimension(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3460190687: function _(id, v) {
    return new IFC2X3.IfcAsset(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new IFC2X3.IfcIdentifier(v[5].value), new Handle(v[6].value), new Handle(v[7].value), new Handle(v[8].value), new Handle(v[9].value), new Handle(v[10].value), new Handle(v[11].value), new Handle(v[12].value), new Handle(v[13].value));
  },
  1967976161: function _(id, v) {
    return new IFC2X3.IfcBSplineCurve(id, v[0].value, v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2], v[3].value, v[4].value);
  },
  819618141: function _(id, v) {
    return new IFC2X3.IfcBeamType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1916977116: function _(id, v) {
    return new IFC2X3.IfcBezierCurve(id, v[0].value, v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2], v[3].value, v[4].value);
  },
  231477066: function _(id, v) {
    return new IFC2X3.IfcBoilerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3299480353: function _(id, v) {
    return new IFC2X3.IfcBuildingElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  52481810: function _(id, v) {
    return new IFC2X3.IfcBuildingElementComponent(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  2979338954: function _(id, v) {
    return new IFC2X3.IfcBuildingElementPart(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  1095909175: function _(id, v) {
    return new IFC2X3.IfcBuildingElementProxy(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]);
  },
  1909888760: function _(id, v) {
    return new IFC2X3.IfcBuildingElementProxyType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  395041908: function _(id, v) {
    return new IFC2X3.IfcCableCarrierFittingType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3293546465: function _(id, v) {
    return new IFC2X3.IfcCableCarrierSegmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1285652485: function _(id, v) {
    return new IFC2X3.IfcCableSegmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2951183804: function _(id, v) {
    return new IFC2X3.IfcChillerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2611217952: function _(id, v) {
    return new IFC2X3.IfcCircle(id, new Handle(v[0].value), new IFC2X3.IfcPositiveLengthMeasure(v[1].value));
  },
  2301859152: function _(id, v) {
    return new IFC2X3.IfcCoilType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  843113511: function _(id, v) {
    return new IFC2X3.IfcColumn(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  3850581409: function _(id, v) {
    return new IFC2X3.IfcCompressorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2816379211: function _(id, v) {
    return new IFC2X3.IfcCondenserType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2188551683: function _(id, v) {
    return new IFC2X3.IfcCondition(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  1163958913: function _(id, v) {
    return new IFC2X3.IfcConditionCriterion(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), new Handle(v[5].value), new Handle(v[6].value));
  },
  3898045240: function _(id, v) {
    return new IFC2X3.IfcConstructionEquipmentResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value));
  },
  1060000209: function _(id, v) {
    return new IFC2X3.IfcConstructionMaterialResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new IFC2X3.IfcRatioMeasure(v[10].value));
  },
  488727124: function _(id, v) {
    return new IFC2X3.IfcConstructionProductResource(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new IFC2X3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC2X3.IfcLabel(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value));
  },
  335055490: function _(id, v) {
    return new IFC2X3.IfcCooledBeamType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2954562838: function _(id, v) {
    return new IFC2X3.IfcCoolingTowerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1973544240: function _(id, v) {
    return new IFC2X3.IfcCovering(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]);
  },
  3495092785: function _(id, v) {
    return new IFC2X3.IfcCurtainWall(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  3961806047: function _(id, v) {
    return new IFC2X3.IfcDamperType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  4147604152: function _(id, v) {
    return new IFC2X3.IfcDiameterDimension(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1335981549: function _(id, v) {
    return new IFC2X3.IfcDiscreteAccessory(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  2635815018: function _(id, v) {
    return new IFC2X3.IfcDiscreteAccessoryType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  1599208980: function _(id, v) {
    return new IFC2X3.IfcDistributionChamberElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2063403501: function _(id, v) {
    return new IFC2X3.IfcDistributionControlElementType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  1945004755: function _(id, v) {
    return new IFC2X3.IfcDistributionElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  3040386961: function _(id, v) {
    return new IFC2X3.IfcDistributionFlowElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  3041715199: function _(id, v) {
    return new IFC2X3.IfcDistributionPort(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]);
  },
  395920057: function _(id, v) {
    return new IFC2X3.IfcDoor(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value));
  },
  869906466: function _(id, v) {
    return new IFC2X3.IfcDuctFittingType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3760055223: function _(id, v) {
    return new IFC2X3.IfcDuctSegmentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2030761528: function _(id, v) {
    return new IFC2X3.IfcDuctSilencerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  855621170: function _(id, v) {
    return new IFC2X3.IfcEdgeFeature(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value));
  },
  663422040: function _(id, v) {
    return new IFC2X3.IfcElectricApplianceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3277789161: function _(id, v) {
    return new IFC2X3.IfcElectricFlowStorageDeviceType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1534661035: function _(id, v) {
    return new IFC2X3.IfcElectricGeneratorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1365060375: function _(id, v) {
    return new IFC2X3.IfcElectricHeaterType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1217240411: function _(id, v) {
    return new IFC2X3.IfcElectricMotorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  712377611: function _(id, v) {
    return new IFC2X3.IfcElectricTimeControlType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1634875225: function _(id, v) {
    return new IFC2X3.IfcElectricalCircuit(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value));
  },
  857184966: function _(id, v) {
    return new IFC2X3.IfcElectricalElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  1658829314: function _(id, v) {
    return new IFC2X3.IfcEnergyConversionDevice(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  346874300: function _(id, v) {
    return new IFC2X3.IfcFanType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1810631287: function _(id, v) {
    return new IFC2X3.IfcFilterType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  4222183408: function _(id, v) {
    return new IFC2X3.IfcFireSuppressionTerminalType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2058353004: function _(id, v) {
    return new IFC2X3.IfcFlowController(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  4278956645: function _(id, v) {
    return new IFC2X3.IfcFlowFitting(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  4037862832: function _(id, v) {
    return new IFC2X3.IfcFlowInstrumentType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3132237377: function _(id, v) {
    return new IFC2X3.IfcFlowMovingDevice(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  987401354: function _(id, v) {
    return new IFC2X3.IfcFlowSegment(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  707683696: function _(id, v) {
    return new IFC2X3.IfcFlowStorageDevice(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  2223149337: function _(id, v) {
    return new IFC2X3.IfcFlowTerminal(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  3508470533: function _(id, v) {
    return new IFC2X3.IfcFlowTreatmentDevice(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  900683007: function _(id, v) {
    return new IFC2X3.IfcFooting(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]);
  },
  1073191201: function _(id, v) {
    return new IFC2X3.IfcMember(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  1687234759: function _(id, v) {
    return new IFC2X3.IfcPile(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8], v[9]);
  },
  3171933400: function _(id, v) {
    return new IFC2X3.IfcPlate(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  2262370178: function _(id, v) {
    return new IFC2X3.IfcRailing(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]);
  },
  3024970846: function _(id, v) {
    return new IFC2X3.IfcRamp(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]);
  },
  3283111854: function _(id, v) {
    return new IFC2X3.IfcRampFlight(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  3055160366: function _(id, v) {
    return new IFC2X3.IfcRationalBezierCurve(id, v[0].value, v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2], v[3].value, v[4].value, v[5].map(function (p) {
      return p.value;
    }));
  },
  3027567501: function _(id, v) {
    return new IFC2X3.IfcReinforcingElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  2320036040: function _(id, v) {
    return new IFC2X3.IfcReinforcingMesh(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value), new IFC2X3.IfcPositiveLengthMeasure(v[11].value), new IFC2X3.IfcPositiveLengthMeasure(v[12].value), new IFC2X3.IfcAreaMeasure(v[13].value), new IFC2X3.IfcAreaMeasure(v[14].value), new IFC2X3.IfcPositiveLengthMeasure(v[15].value), new IFC2X3.IfcPositiveLengthMeasure(v[16].value));
  },
  2016517767: function _(id, v) {
    return new IFC2X3.IfcRoof(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]);
  },
  1376911519: function _(id, v) {
    return new IFC2X3.IfcRoundedEdgeFeature(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value));
  },
  1783015770: function _(id, v) {
    return new IFC2X3.IfcSensorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1529196076: function _(id, v) {
    return new IFC2X3.IfcSlab(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]);
  },
  331165859: function _(id, v) {
    return new IFC2X3.IfcStair(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8]);
  },
  4252922144: function _(id, v) {
    return new IFC2X3.IfcStairFlight(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : v[8].value, !v[9] ? null : v[9].value, !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[11].value));
  },
  2515109513: function _(id, v) {
    return new IFC2X3.IfcStructuralAnalysisModel(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3824725483: function _(id, v) {
    return new IFC2X3.IfcTendon(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9], new IFC2X3.IfcPositiveLengthMeasure(v[10].value), new IFC2X3.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC2X3.IfcForceMeasure(v[12].value), !v[13] ? null : new IFC2X3.IfcPressureMeasure(v[13].value), !v[14] ? null : new IFC2X3.IfcNormalisedRatioMeasure(v[14].value), !v[15] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[15].value), !v[16] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[16].value));
  },
  2347447852: function _(id, v) {
    return new IFC2X3.IfcTendonAnchor(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value));
  },
  3313531582: function _(id, v) {
    return new IFC2X3.IfcVibrationIsolatorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  2391406946: function _(id, v) {
    return new IFC2X3.IfcWall(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  3512223829: function _(id, v) {
    return new IFC2X3.IfcWallStandardCase(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  3304561284: function _(id, v) {
    return new IFC2X3.IfcWindow(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value));
  },
  2874132201: function _(id, v) {
    return new IFC2X3.IfcActuatorType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  3001207471: function _(id, v) {
    return new IFC2X3.IfcAlarmType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  753842376: function _(id, v) {
    return new IFC2X3.IfcBeam(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  2454782716: function _(id, v) {
    return new IFC2X3.IfcChamferEdgeFeature(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[10].value));
  },
  578613899: function _(id, v) {
    return new IFC2X3.IfcControllerType(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC2X3.IfcLabel(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), v[9]);
  },
  1052013943: function _(id, v) {
    return new IFC2X3.IfcDistributionChamberElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value));
  },
  1062813311: function _(id, v) {
    return new IFC2X3.IfcDistributionControlElement(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcIdentifier(v[8].value));
  },
  3700593921: function _(id, v) {
    return new IFC2X3.IfcElectricDistributionPoint(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), v[8], !v[9] ? null : new IFC2X3.IfcLabel(v[9].value));
  },
  979691226: function _(id, v) {
    return new IFC2X3.IfcReinforcingBar(id, new IFC2X3.IfcGloballyUniqueId(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC2X3.IfcLabel(v[2].value), !v[3] ? null : new IFC2X3.IfcText(v[3].value), !v[4] ? null : new IFC2X3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC2X3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC2X3.IfcLabel(v[8].value), new IFC2X3.IfcPositiveLengthMeasure(v[9].value), new IFC2X3.IfcAreaMeasure(v[10].value), !v[11] ? null : new IFC2X3.IfcPositiveLengthMeasure(v[11].value), v[12], v[13]);
  }
};
InheritanceDef[1] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  411424972: [IFCENVIRONMENTALIMPACTVALUE, IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  3264961684: [IFCCOLOURRGB],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPORTGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  3796139169: [IFCDIMENSIONPAIR, IFCDIMENSIONCALLOUTRELATIONSHIP],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSYMBOL, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  3265635763: [IFCHYGROSCOPICMATERIALPROPERTIES, IFCGENERALMATERIALPROPERTIES, IFCFUELPROPERTIES, IFCEXTENDEDMATERIALPROPERTIES, IFCWATERPROPERTIES, IFCTHERMALMATERIALPROPERTIES, IFCPRODUCTSOFCOMBUSTIONPROPERTIES, IFCOPTICALMATERIALPROPERTIES, IFCMECHANICALCONCRETEMATERIALPROPERTIES, IFCMECHANICALSTEELMATERIALPROPERTIES, IFCMECHANICALMATERIALPROPERTIES],
  4256014907: [IFCMECHANICALCONCRETEMATERIALPROPERTIES, IFCMECHANICALSTEELMATERIALPROPERTIES],
  1918398963: [IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCDRAUGHTINGPREDEFINEDTEXTFONT, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDPOINTMARKERSYMBOL, IFCPREDEFINEDDIMENSIONSYMBOL, IFCPREDEFINEDTERMINATORSYMBOL, IFCPREDEFINEDSYMBOL],
  990879717: [IFCPREDEFINEDPOINTMARKERSYMBOL, IFCPREDEFINEDDIMENSIONSYMBOL, IFCPREDEFINEDTERMINATORSYMBOL],
  1775413392: [IFCDRAUGHTINGPREDEFINEDTEXTFONT, IFCTEXTSTYLEFONTMODEL],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSYMBOLSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCRANERAILFSHAPEPROFILEDEF, IFCCRANERAILASHAPEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  2802850158: [IFCSTRUCTURALSTEELPROFILEPROPERTIES, IFCSTRUCTURALPROFILEPROPERTIES, IFCGENERALPROFILEPROPERTIES, IFCRIBPLATEPROFILEPROPERTIES],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLETILESYMBOLWITHSTYLE, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT, IFCDRAUGHTINGCALLOUT, IFCDIRECTION, IFCDEFINEDSYMBOL, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONSURFACE, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCTWODIRECTIONREPEATFACTOR, IFCONEDIRECTIONREPEATFACTOR, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE, IFCANNOTATIONOCCURRENCE, IFCSTYLEDITEM],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS, IFCOBJECT, IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  3958052878: [IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE, IFCANNOTATIONOCCURRENCE],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  280115917: [IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  2442683028: [IFCANNOTATIONFILLAREAOCCURRENCE, IFCPROJECTIONCURVE, IFCDIMENSIONCURVE, IFCANNOTATIONCURVEOCCURRENCE, IFCANNOTATIONTEXTOCCURRENCE, IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL, IFCANNOTATIONSYMBOLOCCURRENCE, IFCANNOTATIONSURFACEOCCURRENCE],
  3612888222: [IFCDIMENSIONCURVETERMINATOR, IFCTERMINATORSYMBOL],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  2556980723: [IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  1446786286: [IFCSTRUCTURALSTEELPROFILEPROPERTIES, IFCSTRUCTURALPROFILEPROPERTIES],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLETILESYMBOLWITHSTYLE, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT, IFCDRAUGHTINGCALLOUT, IFCDIRECTION, IFCDEFINEDSYMBOL, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONSURFACE, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCTWODIRECTIONREPEATFACTOR, IFCONEDIRECTIONREPEATFACTOR, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  219451334: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS, IFCOBJECT, IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTYPEOBJECT],
  2833995503: [IFCTWODIRECTIONREPEATFACTOR],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCRANERAILFSHAPEPROFILEDEF, IFCCRANERAILASHAPEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  1680319473: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCFLUIDFLOWPROPERTIES, IFCELECTRICALBASEPROPERTIES, IFCENERGYPROPERTIES, IFCELEMENTQUANTITY, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCSPACETHERMALLOADPROPERTIES, IFCSOUNDVALUE, IFCSOUNDPROPERTIES, IFCSERVICELIFEFACTOR, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  723233188: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  3843319758: [IFCSTRUCTURALSTEELPROFILEPROPERTIES],
  2513912981: [IFCPLANE, IFCELEMENTARYSURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLID],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  3028897424: [IFCDIMENSIONCURVETERMINATOR],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT],
  2347495698: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE],
  3288037868: [IFCPROJECTIONCURVE, IFCDIMENSIONCURVE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDPLANE],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE],
  3073041342: [IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION, IFCDIMENSIONCURVEDIRECTEDCALLOUT, IFCSTRUCTUREDDIMENSIONCALLOUT],
  339256511: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCPLANE],
  80994333: [IFCELECTRICALBASEPROPERTIES],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  1484403080: [IFCASYMMETRICISHAPEPROFILEDEF],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP],
  3888040117: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCPROJECT, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK, IFCPROCESS],
  2945172077: [IFCPROCEDURE, IFCORDERACTION, IFCMOVE, IFCTASK],
  4208778838: [IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCPROXY],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER, IFCRELASSIGNSTOCONTROL, IFCRELOCCUPIESSPACES, IFCRELASSIGNSTOACTOR],
  1683148259: [IFCRELOCCUPIESSPACES],
  2495723537: [IFCRELASSIGNSTASKS, IFCRELSCHEDULESCOSTITEMS, IFCRELASSIGNSTOPROJECTORDER],
  1865459582: [IFCRELASSOCIATESPROFILEPROPERTIES, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATESAPPLIEDVALUE],
  826625072: [IFCRELVOIDSELEMENT, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPROJECTSELEMENT, IFCRELINTERACTIONREQUIREMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALELEMENT, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELOVERRIDESPROPERTIES, IFCRELDEFINESBYPROPERTIES],
  4186316022: [IFCRELOVERRIDESPROPERTIES],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  2706606064: [IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING],
  3893378262: [IFCSPACETYPE],
  3544373492: [IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  3473067441: [IFCORDERACTION, IFCMOVE],
  2296667514: [IFCOCCUPANT],
  1260505505: [IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFC2DCOMPOSITECURVE, IFCCOMPOSITECURVE],
  1950629157: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWALLTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCMEMBERTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE],
  3732776249: [IFC2DCOMPOSITECURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCCONDITIONCRITERION, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCTIMESERIESSCHEDULE, IFCSPACEPROGRAM, IFCSERVICELIFE, IFCSCHEDULETIMECONTROL, IFCPROJECTORDERRECORD, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCFURNITURESTANDARD, IFCEQUIPMENTSTANDARD, IFCCOSTSCHEDULE, IFCCOSTITEM],
  681481545: [IFCDIAMETERDIMENSION, IFCANGULARDIMENSION, IFCRADIUSDIMENSION, IFCLINEARDIMENSION],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCELECTRICALELEMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCFURNISHINGELEMENT, IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCEQUIPMENTELEMENT, IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCMECHANICALFASTENER, IFCFASTENER],
  2590856083: [IFCVIBRATIONISOLATORTYPE, IFCDISCRETEACCESSORYTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSPACEHEATERTYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE],
  647756555: [IFCMECHANICALFASTENER],
  2489546625: [IFCMECHANICALFASTENERTYPE],
  2827207264: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE, IFCEDGEFEATURE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICHEATERTYPE, IFCELECTRICAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCGASTERMINALTYPE],
  3009222698: [IFCFILTERTYPE, IFCDUCTSILENCERTYPE],
  2706460486: [IFCCONDITION, IFCASSET, IFCZONE, IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  3740093272: [IFCDISTRIBUTIONPORT],
  682877961: [IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALPLANARACTIONVARYING, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALLINEARACTIONVARYING, IFCSTRUCTURALLINEARACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1807405624: [IFCSTRUCTURALLINEARACTIONVARYING],
  1621171031: [IFCSTRUCTURALPLANARACTIONVARYING],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCELECTRICALCIRCUIT],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBEZIERCURVE, IFCBEZIERCURVE],
  1916977116: [IFCRATIONALBEZIERCURVE],
  3299480353: [IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATE, IFCPILE, IFCMEMBER, IFCFOOTING, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMN, IFCBUILDINGELEMENTPROXY, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART, IFCBUILDINGELEMENTCOMPONENT],
  52481810: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCBUILDINGELEMENTPART],
  2635815018: [IFCVIBRATIONISOLATORTYPE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCSENSORTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFLOWTREATMENTDEVICE, IFCFLOWTERMINAL, IFCFLOWSTORAGEDEVICE, IFCFLOWSEGMENT, IFCFLOWMOVINGDEVICE, IFCFLOWFITTING, IFCELECTRICDISTRIBUTIONPOINT, IFCFLOWCONTROLLER, IFCENERGYCONVERSIONDEVICE],
  855621170: [IFCCHAMFEREDGEFEATURE, IFCROUNDEDEDGEFEATURE],
  2058353004: [IFCELECTRICDISTRIBUTIONPOINT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  2391406946: [IFCWALLSTANDARDCASE]
};
InversePropertyDef[1] = {
  618182010: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  411424972: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, true], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, true], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, true]],
  130549933: [["Actors", IFCAPPROVALACTORRELATIONSHIP, 1, true], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 0, true], ["Relates", IFCAPPROVALRELATIONSHIP, 1, true]],
  747523909: [["Contains", IFCCLASSIFICATIONITEM, 1, true]],
  1767535486: [["IsClassifiedItemIn", IFCCLASSIFICATIONITEMRELATIONSHIP, 1, true], ["IsClassifyingItemIn", IFCCLASSIFICATIONITEMRELATIONSHIP, 0, true]],
  1959218052: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, true], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, true], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, true], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, true], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, true]],
  602808272: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, true], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, true], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, true]],
  1154170062: [["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 1, true], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 0, true]],
  1648886627: [["ValuesReferenced", IFCREFERENCESVALUEDOCUMENT, 1, true], ["ValueOfComponents", IFCAPPLIEDVALUERELATIONSHIP, 0, true], ["IsComponentIn", IFCAPPLIEDVALUERELATIONSHIP, 1, true]],
  852622518: [["PartOfW", IFCGRID, 9, true], ["PartOfV", IFCGRID, 8, true], ["PartOfU", IFCGRID, 7, true], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, true]],
  3452421091: [["ReferenceIntoLibrary", IFCLIBRARYINFORMATION, 4, true]],
  1838606355: [["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, true], ["ClassifiedAs", IFCMATERIALCLASSIFICATIONRELATIONSHIP, 1, true]],
  248100487: [["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  3368373690: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, true], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, true], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, true], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, true], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, true]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  2251480897: [["ClassifiedAs", IFCCONSTRAINTCLASSIFICATIONRELATIONSHIP, 0, true], ["RelatesConstraints", IFCCONSTRAINTRELATIONSHIP, 2, true], ["IsRelatedWith", IFCCONSTRAINTRELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCPROPERTYCONSTRAINTRELATIONSHIP, 0, true], ["Aggregates", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 2, true], ["IsAggregatedIn", IFCCONSTRAINTAGGREGATIONRELATIONSHIP, 3, true]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, true], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, true], ["Engages", IFCPERSONANDORGANIZATION, 1, true]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, true]],
  2483315170: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2226359599: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3355820592: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  2598011224: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  2044713172: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2093928680: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  931644368: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3252649465: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2405470396: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  825690147: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, true]],
  3008791417: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1660063152: [["MapUsage", IFCMAPPEDITEM, 0, true]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  3692461612: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3958052878: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  531007025: [["OfTable", IFCTABLE, 1, false]],
  912023232: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  280115917: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, true]],
  1742049831: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, true]],
  2552916305: [["AnnotatedSurface", IFCANNOTATIONSURFACE, 1, true]],
  3101149627: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, true]],
  1377556343: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2799835756: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1907098498: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2442683028: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  962685235: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3612888222: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2297822566: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2542286263: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  370225590: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3732053477: [["ReferenceToDocument", IFCDOCUMENTINFORMATION, 3, true]],
  3900360178: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  476780140: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2556980723: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1809719519: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  803316827: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3008276851: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true]],
  2453401579: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true]],
  3590301190: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  812098782: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3741457305: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, true]],
  1402838566: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  125510826: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2604431987: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4266656042: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1520743889: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3422422726: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  1008929658: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2347385850: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2833995503: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2665983363: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1029017970: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2519244187: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3021840470: [["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2004835150: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1663979128: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2067069095: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4022376103: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1423911732: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2924175390: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2775532180: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, true], ["HasShapeAspects", IFCSHAPEASPECT, 4, true]],
  871118103: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  1680319473: [["HasAssociations", IFCRELASSOCIATES, 4, true]],
  4166981789: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  2752243245: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  941946838: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  3357820518: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  3650150729: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  110355661: [["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 0, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 1, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true]],
  3413951693: [["DocumentedBy", IFCTIMESERIESREFERENCERELATIONSHIP, 0, true]],
  3765753017: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1509187699: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2411513650: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  4124623270: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  723233188: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2485662743: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1202362311: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  390701378: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  2233826070: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2513912981: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2247615214: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260650574: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  230924584: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3028897424: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4282788508: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124975700: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1345879162: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1417489154: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2759199220: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  336235671: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  512836454: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1299126871: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3288037868: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  669184980: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2265737646: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1302238472: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4261334040: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3125803723: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2740243338: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2736907675: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4182860854: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2581212453: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2713105998: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1123145078: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  59481748: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3749851601: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3486308946: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3331915920: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1416205885: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2205249479: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2485617015: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2506170314: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2147822146: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2601014836: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2827736869: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  693772133: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  606661476: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["AnnotatedBySymbols", IFCTERMINATORSYMBOL, 3, true]],
  4054601972: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  32440307: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2963535650: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1714330368: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  526551008: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3073041342: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  1472233963: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1883228015: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2777663545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  80994333: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  477187591: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2047409740: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  374418227: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4203026998: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  315944413: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3455213021: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  987898635: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1281925730: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1425443689: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true]],
  3388369263: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3505215534: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3566463478: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  603570806: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  220341763: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true]],
  4194566429: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1451395588: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  3219374653: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2798486643: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3454111270: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1856042241: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4158566097: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3626867408: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  451544542: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false], ["Causes", IFCSTRUCTURALACTION, 10, true]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  4070609034: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  2028607225: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2809605785: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124788165: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1334484129: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649129432: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260505505: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  1950629157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3732776249: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2510884976: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  681481545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  360485395: [["HasAssociations", IFCRELASSOCIATES, 4, true], ["PropertyDefinitionOf", IFCRELDEFINESBYPROPERTIES, 5, true], ["DefinesType", IFCTYPEOBJECT, 5, true]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1704287377: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1962604670: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3272907226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  807026263: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3737207727: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  814719939: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  200128114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2506943328: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1916936684: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  3425660407: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3724593414: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, false], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3642467123: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3248260540: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3517283431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true], ["ScheduleTimeControlAssigned", IFCRELASSIGNSTASKS, 7, false]],
  4105383287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["HasCoverings", IFCRELCOVERSSPACES, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  652456506: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true], ["HasInteractionReqsFrom", IFCRELINTERACTIONREQUIREMENTS, 7, true], ["HasInteractionReqsTo", IFCRELINTERACTIONREQUIREMENTS, 8, true]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ReferencesElement", IFCRELCONNECTSSTRUCTURALELEMENT, 5, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  1721250024: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  3987759626: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, false], ["Causes", IFCSTRUCTURALACTION, 10, true]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, true]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1637806684: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3593883385: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1213861670: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2470393545: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1967976161: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1916977116: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3299480353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  52481810: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2611217952: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2188551683: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false]],
  1163958913: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["CoversSpaces", IFCRELCOVERSSPACES, 5, true], ["Covers", IFCRELCOVERSBLDGELEMENTS, 5, true]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4147604152: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["IsRelatedFromCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 3, true], ["IsRelatedToCallout", IFCDRAUGHTINGCALLOUTRELATIONSHIP, 2, true]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, false], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  855621170: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1365060375: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1634875225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  857184966: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3055160366: [["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  1376911519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, false], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2454782716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["ObjectTypeOf", IFCRELDEFINESBYTYPE, 5, true]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  3700593921: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["IsDecomposedBy", IFCRELDECOMPOSES, 4, true], ["Decomposes", IFCRELDECOMPOSES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["HasStructuralMember", IFCRELCONNECTSSTRUCTURALELEMENT, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]]
};
Constructors[1] = {
  3630933823: function _(ID, a) {
    return new IFC2X3.IfcActorRole(ID, a[0], a[1], a[2]);
  },
  618182010: function _(ID, a) {
    return new IFC2X3.IfcAddress(ID, a[0], a[1], a[2]);
  },
  639542469: function _(ID, a) {
    return new IFC2X3.IfcApplication(ID, a[0], a[1], a[2], a[3]);
  },
  411424972: function _(ID, a) {
    return new IFC2X3.IfcAppliedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1110488051: function _(ID, a) {
    return new IFC2X3.IfcAppliedValueRelationship(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  130549933: function _(ID, a) {
    return new IFC2X3.IfcApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2080292479: function _(ID, a) {
    return new IFC2X3.IfcApprovalActorRelationship(ID, a[0], a[1], a[2]);
  },
  390851274: function _(ID, a) {
    return new IFC2X3.IfcApprovalPropertyRelationship(ID, a[0], a[1]);
  },
  3869604511: function _(ID, a) {
    return new IFC2X3.IfcApprovalRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  4037036970: function _(ID, a) {
    return new IFC2X3.IfcBoundaryCondition(ID, a[0]);
  },
  1560379544: function _(ID, a) {
    return new IFC2X3.IfcBoundaryEdgeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3367102660: function _(ID, a) {
    return new IFC2X3.IfcBoundaryFaceCondition(ID, a[0], a[1], a[2], a[3]);
  },
  1387855156: function _(ID, a) {
    return new IFC2X3.IfcBoundaryNodeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2069777674: function _(ID, a) {
    return new IFC2X3.IfcBoundaryNodeConditionWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  622194075: function _(ID, a) {
    return new IFC2X3.IfcCalendarDate(ID, a[0], a[1], a[2]);
  },
  747523909: function _(ID, a) {
    return new IFC2X3.IfcClassification(ID, a[0], a[1], a[2], a[3]);
  },
  1767535486: function _(ID, a) {
    return new IFC2X3.IfcClassificationItem(ID, a[0], a[1], a[2]);
  },
  1098599126: function _(ID, a) {
    return new IFC2X3.IfcClassificationItemRelationship(ID, a[0], a[1]);
  },
  938368621: function _(ID, a) {
    return new IFC2X3.IfcClassificationNotation(ID, a[0]);
  },
  3639012971: function _(ID, a) {
    return new IFC2X3.IfcClassificationNotationFacet(ID, a[0]);
  },
  3264961684: function _(ID, a) {
    return new IFC2X3.IfcColourSpecification(ID, a[0]);
  },
  2859738748: function _(ID, _16) {
    return new IFC2X3.IfcConnectionGeometry(ID);
  },
  2614616156: function _(ID, a) {
    return new IFC2X3.IfcConnectionPointGeometry(ID, a[0], a[1]);
  },
  4257277454: function _(ID, a) {
    return new IFC2X3.IfcConnectionPortGeometry(ID, a[0], a[1], a[2]);
  },
  2732653382: function _(ID, a) {
    return new IFC2X3.IfcConnectionSurfaceGeometry(ID, a[0], a[1]);
  },
  1959218052: function _(ID, a) {
    return new IFC2X3.IfcConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1658513725: function _(ID, a) {
    return new IFC2X3.IfcConstraintAggregationRelationship(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  613356794: function _(ID, a) {
    return new IFC2X3.IfcConstraintClassificationRelationship(ID, a[0], a[1]);
  },
  347226245: function _(ID, a) {
    return new IFC2X3.IfcConstraintRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  1065062679: function _(ID, a) {
    return new IFC2X3.IfcCoordinatedUniversalTimeOffset(ID, a[0], a[1], a[2]);
  },
  602808272: function _(ID, a) {
    return new IFC2X3.IfcCostValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  539742890: function _(ID, a) {
    return new IFC2X3.IfcCurrencyRelationship(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1105321065: function _(ID, a) {
    return new IFC2X3.IfcCurveStyleFont(ID, a[0], a[1]);
  },
  2367409068: function _(ID, a) {
    return new IFC2X3.IfcCurveStyleFontAndScaling(ID, a[0], a[1], a[2]);
  },
  3510044353: function _(ID, a) {
    return new IFC2X3.IfcCurveStyleFontPattern(ID, a[0], a[1]);
  },
  1072939445: function _(ID, a) {
    return new IFC2X3.IfcDateAndTime(ID, a[0], a[1]);
  },
  1765591967: function _(ID, a) {
    return new IFC2X3.IfcDerivedUnit(ID, a[0], a[1], a[2]);
  },
  1045800335: function _(ID, a) {
    return new IFC2X3.IfcDerivedUnitElement(ID, a[0], a[1]);
  },
  2949456006: function _(ID, a) {
    return new IFC2X3.IfcDimensionalExponents(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1376555844: function _(ID, a) {
    return new IFC2X3.IfcDocumentElectronicFormat(ID, a[0], a[1], a[2]);
  },
  1154170062: function _(ID, a) {
    return new IFC2X3.IfcDocumentInformation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]);
  },
  770865208: function _(ID, a) {
    return new IFC2X3.IfcDocumentInformationRelationship(ID, a[0], a[1], a[2]);
  },
  3796139169: function _(ID, a) {
    return new IFC2X3.IfcDraughtingCalloutRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  1648886627: function _(ID, a) {
    return new IFC2X3.IfcEnvironmentalImpactValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3200245327: function _(ID, a) {
    return new IFC2X3.IfcExternalReference(ID, a[0], a[1], a[2]);
  },
  2242383968: function _(ID, a) {
    return new IFC2X3.IfcExternallyDefinedHatchStyle(ID, a[0], a[1], a[2]);
  },
  1040185647: function _(ID, a) {
    return new IFC2X3.IfcExternallyDefinedSurfaceStyle(ID, a[0], a[1], a[2]);
  },
  3207319532: function _(ID, a) {
    return new IFC2X3.IfcExternallyDefinedSymbol(ID, a[0], a[1], a[2]);
  },
  3548104201: function _(ID, a) {
    return new IFC2X3.IfcExternallyDefinedTextFont(ID, a[0], a[1], a[2]);
  },
  852622518: function _(ID, a) {
    return new IFC2X3.IfcGridAxis(ID, a[0], a[1], a[2]);
  },
  3020489413: function _(ID, a) {
    return new IFC2X3.IfcIrregularTimeSeriesValue(ID, a[0], a[1]);
  },
  2655187982: function _(ID, a) {
    return new IFC2X3.IfcLibraryInformation(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3452421091: function _(ID, a) {
    return new IFC2X3.IfcLibraryReference(ID, a[0], a[1], a[2]);
  },
  4162380809: function _(ID, a) {
    return new IFC2X3.IfcLightDistributionData(ID, a[0], a[1], a[2]);
  },
  1566485204: function _(ID, a) {
    return new IFC2X3.IfcLightIntensityDistribution(ID, a[0], a[1]);
  },
  30780891: function _(ID, a) {
    return new IFC2X3.IfcLocalTime(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1838606355: function _(ID, a) {
    return new IFC2X3.IfcMaterial(ID, a[0]);
  },
  1847130766: function _(ID, a) {
    return new IFC2X3.IfcMaterialClassificationRelationship(ID, a[0], a[1]);
  },
  248100487: function _(ID, a) {
    return new IFC2X3.IfcMaterialLayer(ID, a[0], a[1], a[2]);
  },
  3303938423: function _(ID, a) {
    return new IFC2X3.IfcMaterialLayerSet(ID, a[0], a[1]);
  },
  1303795690: function _(ID, a) {
    return new IFC2X3.IfcMaterialLayerSetUsage(ID, a[0], a[1], a[2], a[3]);
  },
  2199411900: function _(ID, a) {
    return new IFC2X3.IfcMaterialList(ID, a[0]);
  },
  3265635763: function _(ID, a) {
    return new IFC2X3.IfcMaterialProperties(ID, a[0]);
  },
  2597039031: function _(ID, a) {
    return new IFC2X3.IfcMeasureWithUnit(ID, a[0], a[1]);
  },
  4256014907: function _(ID, a) {
    return new IFC2X3.IfcMechanicalMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  677618848: function _(ID, a) {
    return new IFC2X3.IfcMechanicalSteelMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  3368373690: function _(ID, a) {
    return new IFC2X3.IfcMetric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2706619895: function _(ID, a) {
    return new IFC2X3.IfcMonetaryUnit(ID, a[0]);
  },
  1918398963: function _(ID, a) {
    return new IFC2X3.IfcNamedUnit(ID, a[0], a[1]);
  },
  3701648758: function _(ID, _17) {
    return new IFC2X3.IfcObjectPlacement(ID);
  },
  2251480897: function _(ID, a) {
    return new IFC2X3.IfcObjective(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1227763645: function _(ID, a) {
    return new IFC2X3.IfcOpticalMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4251960020: function _(ID, a) {
    return new IFC2X3.IfcOrganization(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1411181986: function _(ID, a) {
    return new IFC2X3.IfcOrganizationRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  1207048766: function _(ID, a) {
    return new IFC2X3.IfcOwnerHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2077209135: function _(ID, a) {
    return new IFC2X3.IfcPerson(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  101040310: function _(ID, a) {
    return new IFC2X3.IfcPersonAndOrganization(ID, a[0], a[1], a[2]);
  },
  2483315170: function _(ID, a) {
    return new IFC2X3.IfcPhysicalQuantity(ID, a[0], a[1]);
  },
  2226359599: function _(ID, a) {
    return new IFC2X3.IfcPhysicalSimpleQuantity(ID, a[0], a[1], a[2]);
  },
  3355820592: function _(ID, a) {
    return new IFC2X3.IfcPostalAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3727388367: function _(ID, a) {
    return new IFC2X3.IfcPreDefinedItem(ID, a[0]);
  },
  990879717: function _(ID, a) {
    return new IFC2X3.IfcPreDefinedSymbol(ID, a[0]);
  },
  3213052703: function _(ID, a) {
    return new IFC2X3.IfcPreDefinedTerminatorSymbol(ID, a[0]);
  },
  1775413392: function _(ID, a) {
    return new IFC2X3.IfcPreDefinedTextFont(ID, a[0]);
  },
  2022622350: function _(ID, a) {
    return new IFC2X3.IfcPresentationLayerAssignment(ID, a[0], a[1], a[2], a[3]);
  },
  1304840413: function _(ID, a) {
    return new IFC2X3.IfcPresentationLayerWithStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3119450353: function _(ID, a) {
    return new IFC2X3.IfcPresentationStyle(ID, a[0]);
  },
  2417041796: function _(ID, a) {
    return new IFC2X3.IfcPresentationStyleAssignment(ID, a[0]);
  },
  2095639259: function _(ID, a) {
    return new IFC2X3.IfcProductRepresentation(ID, a[0], a[1], a[2]);
  },
  2267347899: function _(ID, a) {
    return new IFC2X3.IfcProductsOfCombustionProperties(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3958567839: function _(ID, a) {
    return new IFC2X3.IfcProfileDef(ID, a[0], a[1]);
  },
  2802850158: function _(ID, a) {
    return new IFC2X3.IfcProfileProperties(ID, a[0], a[1]);
  },
  2598011224: function _(ID, a) {
    return new IFC2X3.IfcProperty(ID, a[0], a[1]);
  },
  3896028662: function _(ID, a) {
    return new IFC2X3.IfcPropertyConstraintRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  148025276: function _(ID, a) {
    return new IFC2X3.IfcPropertyDependencyRelationship(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3710013099: function _(ID, a) {
    return new IFC2X3.IfcPropertyEnumeration(ID, a[0], a[1], a[2]);
  },
  2044713172: function _(ID, a) {
    return new IFC2X3.IfcQuantityArea(ID, a[0], a[1], a[2], a[3]);
  },
  2093928680: function _(ID, a) {
    return new IFC2X3.IfcQuantityCount(ID, a[0], a[1], a[2], a[3]);
  },
  931644368: function _(ID, a) {
    return new IFC2X3.IfcQuantityLength(ID, a[0], a[1], a[2], a[3]);
  },
  3252649465: function _(ID, a) {
    return new IFC2X3.IfcQuantityTime(ID, a[0], a[1], a[2], a[3]);
  },
  2405470396: function _(ID, a) {
    return new IFC2X3.IfcQuantityVolume(ID, a[0], a[1], a[2], a[3]);
  },
  825690147: function _(ID, a) {
    return new IFC2X3.IfcQuantityWeight(ID, a[0], a[1], a[2], a[3]);
  },
  2692823254: function _(ID, a) {
    return new IFC2X3.IfcReferencesValueDocument(ID, a[0], a[1], a[2], a[3]);
  },
  1580146022: function _(ID, a) {
    return new IFC2X3.IfcReinforcementBarProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1222501353: function _(ID, a) {
    return new IFC2X3.IfcRelaxation(ID, a[0], a[1]);
  },
  1076942058: function _(ID, a) {
    return new IFC2X3.IfcRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  3377609919: function _(ID, a) {
    return new IFC2X3.IfcRepresentationContext(ID, a[0], a[1]);
  },
  3008791417: function _(ID, _18) {
    return new IFC2X3.IfcRepresentationItem(ID);
  },
  1660063152: function _(ID, a) {
    return new IFC2X3.IfcRepresentationMap(ID, a[0], a[1]);
  },
  3679540991: function _(ID, a) {
    return new IFC2X3.IfcRibPlateProfileProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2341007311: function _(ID, a) {
    return new IFC2X3.IfcRoot(ID, a[0], a[1], a[2], a[3]);
  },
  448429030: function _(ID, a) {
    return new IFC2X3.IfcSIUnit(ID, a[0], a[1], a[2]);
  },
  2042790032: function _(ID, a) {
    return new IFC2X3.IfcSectionProperties(ID, a[0], a[1], a[2]);
  },
  4165799628: function _(ID, a) {
    return new IFC2X3.IfcSectionReinforcementProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  867548509: function _(ID, a) {
    return new IFC2X3.IfcShapeAspect(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3982875396: function _(ID, a) {
    return new IFC2X3.IfcShapeModel(ID, a[0], a[1], a[2], a[3]);
  },
  4240577450: function _(ID, a) {
    return new IFC2X3.IfcShapeRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  3692461612: function _(ID, a) {
    return new IFC2X3.IfcSimpleProperty(ID, a[0], a[1]);
  },
  2273995522: function _(ID, a) {
    return new IFC2X3.IfcStructuralConnectionCondition(ID, a[0]);
  },
  2162789131: function _(ID, a) {
    return new IFC2X3.IfcStructuralLoad(ID, a[0]);
  },
  2525727697: function _(ID, a) {
    return new IFC2X3.IfcStructuralLoadStatic(ID, a[0]);
  },
  3408363356: function _(ID, a) {
    return new IFC2X3.IfcStructuralLoadTemperature(ID, a[0], a[1], a[2], a[3]);
  },
  2830218821: function _(ID, a) {
    return new IFC2X3.IfcStyleModel(ID, a[0], a[1], a[2], a[3]);
  },
  3958052878: function _(ID, a) {
    return new IFC2X3.IfcStyledItem(ID, a[0], a[1], a[2]);
  },
  3049322572: function _(ID, a) {
    return new IFC2X3.IfcStyledRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  1300840506: function _(ID, a) {
    return new IFC2X3.IfcSurfaceStyle(ID, a[0], a[1], a[2]);
  },
  3303107099: function _(ID, a) {
    return new IFC2X3.IfcSurfaceStyleLighting(ID, a[0], a[1], a[2], a[3]);
  },
  1607154358: function _(ID, a) {
    return new IFC2X3.IfcSurfaceStyleRefraction(ID, a[0], a[1]);
  },
  846575682: function _(ID, a) {
    return new IFC2X3.IfcSurfaceStyleShading(ID, a[0]);
  },
  1351298697: function _(ID, a) {
    return new IFC2X3.IfcSurfaceStyleWithTextures(ID, a[0]);
  },
  626085974: function _(ID, a) {
    return new IFC2X3.IfcSurfaceTexture(ID, a[0], a[1], a[2], a[3]);
  },
  1290481447: function _(ID, a) {
    return new IFC2X3.IfcSymbolStyle(ID, a[0], a[1]);
  },
  985171141: function _(ID, a) {
    return new IFC2X3.IfcTable(ID, a[0], a[1]);
  },
  531007025: function _(ID, a) {
    return new IFC2X3.IfcTableRow(ID, a[0], a[1]);
  },
  912023232: function _(ID, a) {
    return new IFC2X3.IfcTelecomAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1447204868: function _(ID, a) {
    return new IFC2X3.IfcTextStyle(ID, a[0], a[1], a[2], a[3]);
  },
  1983826977: function _(ID, a) {
    return new IFC2X3.IfcTextStyleFontModel(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2636378356: function _(ID, a) {
    return new IFC2X3.IfcTextStyleForDefinedFont(ID, a[0], a[1]);
  },
  1640371178: function _(ID, a) {
    return new IFC2X3.IfcTextStyleTextModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1484833681: function _(ID, a) {
    return new IFC2X3.IfcTextStyleWithBoxCharacteristics(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  280115917: function _(ID, _19) {
    return new IFC2X3.IfcTextureCoordinate(ID);
  },
  1742049831: function _(ID, a) {
    return new IFC2X3.IfcTextureCoordinateGenerator(ID, a[0], a[1]);
  },
  2552916305: function _(ID, a) {
    return new IFC2X3.IfcTextureMap(ID, a[0]);
  },
  1210645708: function _(ID, a) {
    return new IFC2X3.IfcTextureVertex(ID, a[0]);
  },
  3317419933: function _(ID, a) {
    return new IFC2X3.IfcThermalMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3101149627: function _(ID, a) {
    return new IFC2X3.IfcTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1718945513: function _(ID, a) {
    return new IFC2X3.IfcTimeSeriesReferenceRelationship(ID, a[0], a[1]);
  },
  581633288: function _(ID, a) {
    return new IFC2X3.IfcTimeSeriesValue(ID, a[0]);
  },
  1377556343: function _(ID, _20) {
    return new IFC2X3.IfcTopologicalRepresentationItem(ID);
  },
  1735638870: function _(ID, a) {
    return new IFC2X3.IfcTopologyRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  180925521: function _(ID, a) {
    return new IFC2X3.IfcUnitAssignment(ID, a[0]);
  },
  2799835756: function _(ID, _21) {
    return new IFC2X3.IfcVertex(ID);
  },
  3304826586: function _(ID, a) {
    return new IFC2X3.IfcVertexBasedTextureMap(ID, a[0], a[1]);
  },
  1907098498: function _(ID, a) {
    return new IFC2X3.IfcVertexPoint(ID, a[0]);
  },
  891718957: function _(ID, a) {
    return new IFC2X3.IfcVirtualGridIntersection(ID, a[0], a[1]);
  },
  1065908215: function _(ID, a) {
    return new IFC2X3.IfcWaterProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2442683028: function _(ID, a) {
    return new IFC2X3.IfcAnnotationOccurrence(ID, a[0], a[1], a[2]);
  },
  962685235: function _(ID, a) {
    return new IFC2X3.IfcAnnotationSurfaceOccurrence(ID, a[0], a[1], a[2]);
  },
  3612888222: function _(ID, a) {
    return new IFC2X3.IfcAnnotationSymbolOccurrence(ID, a[0], a[1], a[2]);
  },
  2297822566: function _(ID, a) {
    return new IFC2X3.IfcAnnotationTextOccurrence(ID, a[0], a[1], a[2]);
  },
  3798115385: function _(ID, a) {
    return new IFC2X3.IfcArbitraryClosedProfileDef(ID, a[0], a[1], a[2]);
  },
  1310608509: function _(ID, a) {
    return new IFC2X3.IfcArbitraryOpenProfileDef(ID, a[0], a[1], a[2]);
  },
  2705031697: function _(ID, a) {
    return new IFC2X3.IfcArbitraryProfileDefWithVoids(ID, a[0], a[1], a[2], a[3]);
  },
  616511568: function _(ID, a) {
    return new IFC2X3.IfcBlobTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3150382593: function _(ID, a) {
    return new IFC2X3.IfcCenterLineProfileDef(ID, a[0], a[1], a[2], a[3]);
  },
  647927063: function _(ID, a) {
    return new IFC2X3.IfcClassificationReference(ID, a[0], a[1], a[2], a[3]);
  },
  776857604: function _(ID, a) {
    return new IFC2X3.IfcColourRgb(ID, a[0], a[1], a[2], a[3]);
  },
  2542286263: function _(ID, a) {
    return new IFC2X3.IfcComplexProperty(ID, a[0], a[1], a[2], a[3]);
  },
  1485152156: function _(ID, a) {
    return new IFC2X3.IfcCompositeProfileDef(ID, a[0], a[1], a[2], a[3]);
  },
  370225590: function _(ID, a) {
    return new IFC2X3.IfcConnectedFaceSet(ID, a[0]);
  },
  1981873012: function _(ID, a) {
    return new IFC2X3.IfcConnectionCurveGeometry(ID, a[0], a[1]);
  },
  45288368: function _(ID, a) {
    return new IFC2X3.IfcConnectionPointEccentricity(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3050246964: function _(ID, a) {
    return new IFC2X3.IfcContextDependentUnit(ID, a[0], a[1], a[2]);
  },
  2889183280: function _(ID, a) {
    return new IFC2X3.IfcConversionBasedUnit(ID, a[0], a[1], a[2], a[3]);
  },
  3800577675: function _(ID, a) {
    return new IFC2X3.IfcCurveStyle(ID, a[0], a[1], a[2], a[3]);
  },
  3632507154: function _(ID, a) {
    return new IFC2X3.IfcDerivedProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2273265877: function _(ID, a) {
    return new IFC2X3.IfcDimensionCalloutRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  1694125774: function _(ID, a) {
    return new IFC2X3.IfcDimensionPair(ID, a[0], a[1], a[2], a[3]);
  },
  3732053477: function _(ID, a) {
    return new IFC2X3.IfcDocumentReference(ID, a[0], a[1], a[2]);
  },
  4170525392: function _(ID, a) {
    return new IFC2X3.IfcDraughtingPreDefinedTextFont(ID, a[0]);
  },
  3900360178: function _(ID, a) {
    return new IFC2X3.IfcEdge(ID, a[0], a[1]);
  },
  476780140: function _(ID, a) {
    return new IFC2X3.IfcEdgeCurve(ID, a[0], a[1], a[2], a[3]);
  },
  1860660968: function _(ID, a) {
    return new IFC2X3.IfcExtendedMaterialProperties(ID, a[0], a[1], a[2], a[3]);
  },
  2556980723: function _(ID, a) {
    return new IFC2X3.IfcFace(ID, a[0]);
  },
  1809719519: function _(ID, a) {
    return new IFC2X3.IfcFaceBound(ID, a[0], a[1]);
  },
  803316827: function _(ID, a) {
    return new IFC2X3.IfcFaceOuterBound(ID, a[0], a[1]);
  },
  3008276851: function _(ID, a) {
    return new IFC2X3.IfcFaceSurface(ID, a[0], a[1], a[2]);
  },
  4219587988: function _(ID, a) {
    return new IFC2X3.IfcFailureConnectionCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  738692330: function _(ID, a) {
    return new IFC2X3.IfcFillAreaStyle(ID, a[0], a[1]);
  },
  3857492461: function _(ID, a) {
    return new IFC2X3.IfcFuelProperties(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  803998398: function _(ID, a) {
    return new IFC2X3.IfcGeneralMaterialProperties(ID, a[0], a[1], a[2], a[3]);
  },
  1446786286: function _(ID, a) {
    return new IFC2X3.IfcGeneralProfileProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3448662350: function _(ID, a) {
    return new IFC2X3.IfcGeometricRepresentationContext(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2453401579: function _(ID, _22) {
    return new IFC2X3.IfcGeometricRepresentationItem(ID);
  },
  4142052618: function _(ID, a) {
    return new IFC2X3.IfcGeometricRepresentationSubContext(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3590301190: function _(ID, a) {
    return new IFC2X3.IfcGeometricSet(ID, a[0]);
  },
  178086475: function _(ID, a) {
    return new IFC2X3.IfcGridPlacement(ID, a[0], a[1]);
  },
  812098782: function _(ID, a) {
    return new IFC2X3.IfcHalfSpaceSolid(ID, a[0], a[1]);
  },
  2445078500: function _(ID, a) {
    return new IFC2X3.IfcHygroscopicMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3905492369: function _(ID, a) {
    return new IFC2X3.IfcImageTexture(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3741457305: function _(ID, a) {
    return new IFC2X3.IfcIrregularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1402838566: function _(ID, a) {
    return new IFC2X3.IfcLightSource(ID, a[0], a[1], a[2], a[3]);
  },
  125510826: function _(ID, a) {
    return new IFC2X3.IfcLightSourceAmbient(ID, a[0], a[1], a[2], a[3]);
  },
  2604431987: function _(ID, a) {
    return new IFC2X3.IfcLightSourceDirectional(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4266656042: function _(ID, a) {
    return new IFC2X3.IfcLightSourceGoniometric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1520743889: function _(ID, a) {
    return new IFC2X3.IfcLightSourcePositional(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3422422726: function _(ID, a) {
    return new IFC2X3.IfcLightSourceSpot(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  2624227202: function _(ID, a) {
    return new IFC2X3.IfcLocalPlacement(ID, a[0], a[1]);
  },
  1008929658: function _(ID, _23) {
    return new IFC2X3.IfcLoop(ID);
  },
  2347385850: function _(ID, a) {
    return new IFC2X3.IfcMappedItem(ID, a[0], a[1]);
  },
  2022407955: function _(ID, a) {
    return new IFC2X3.IfcMaterialDefinitionRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  1430189142: function _(ID, a) {
    return new IFC2X3.IfcMechanicalConcreteMaterialProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  219451334: function _(ID, a) {
    return new IFC2X3.IfcObjectDefinition(ID, a[0], a[1], a[2], a[3]);
  },
  2833995503: function _(ID, a) {
    return new IFC2X3.IfcOneDirectionRepeatFactor(ID, a[0]);
  },
  2665983363: function _(ID, a) {
    return new IFC2X3.IfcOpenShell(ID, a[0]);
  },
  1029017970: function _(ID, a) {
    return new IFC2X3.IfcOrientedEdge(ID, a[0], a[1]);
  },
  2529465313: function _(ID, a) {
    return new IFC2X3.IfcParameterizedProfileDef(ID, a[0], a[1], a[2]);
  },
  2519244187: function _(ID, a) {
    return new IFC2X3.IfcPath(ID, a[0]);
  },
  3021840470: function _(ID, a) {
    return new IFC2X3.IfcPhysicalComplexQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  597895409: function _(ID, a) {
    return new IFC2X3.IfcPixelTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2004835150: function _(ID, a) {
    return new IFC2X3.IfcPlacement(ID, a[0]);
  },
  1663979128: function _(ID, a) {
    return new IFC2X3.IfcPlanarExtent(ID, a[0], a[1]);
  },
  2067069095: function _(ID, _24) {
    return new IFC2X3.IfcPoint(ID);
  },
  4022376103: function _(ID, a) {
    return new IFC2X3.IfcPointOnCurve(ID, a[0], a[1]);
  },
  1423911732: function _(ID, a) {
    return new IFC2X3.IfcPointOnSurface(ID, a[0], a[1], a[2]);
  },
  2924175390: function _(ID, a) {
    return new IFC2X3.IfcPolyLoop(ID, a[0]);
  },
  2775532180: function _(ID, a) {
    return new IFC2X3.IfcPolygonalBoundedHalfSpace(ID, a[0], a[1], a[2], a[3]);
  },
  759155922: function _(ID, a) {
    return new IFC2X3.IfcPreDefinedColour(ID, a[0]);
  },
  2559016684: function _(ID, a) {
    return new IFC2X3.IfcPreDefinedCurveFont(ID, a[0]);
  },
  433424934: function _(ID, a) {
    return new IFC2X3.IfcPreDefinedDimensionSymbol(ID, a[0]);
  },
  179317114: function _(ID, a) {
    return new IFC2X3.IfcPreDefinedPointMarkerSymbol(ID, a[0]);
  },
  673634403: function _(ID, a) {
    return new IFC2X3.IfcProductDefinitionShape(ID, a[0], a[1], a[2]);
  },
  871118103: function _(ID, a) {
    return new IFC2X3.IfcPropertyBoundedValue(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1680319473: function _(ID, a) {
    return new IFC2X3.IfcPropertyDefinition(ID, a[0], a[1], a[2], a[3]);
  },
  4166981789: function _(ID, a) {
    return new IFC2X3.IfcPropertyEnumeratedValue(ID, a[0], a[1], a[2], a[3]);
  },
  2752243245: function _(ID, a) {
    return new IFC2X3.IfcPropertyListValue(ID, a[0], a[1], a[2], a[3]);
  },
  941946838: function _(ID, a) {
    return new IFC2X3.IfcPropertyReferenceValue(ID, a[0], a[1], a[2], a[3]);
  },
  3357820518: function _(ID, a) {
    return new IFC2X3.IfcPropertySetDefinition(ID, a[0], a[1], a[2], a[3]);
  },
  3650150729: function _(ID, a) {
    return new IFC2X3.IfcPropertySingleValue(ID, a[0], a[1], a[2], a[3]);
  },
  110355661: function _(ID, a) {
    return new IFC2X3.IfcPropertyTableValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3615266464: function _(ID, a) {
    return new IFC2X3.IfcRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3413951693: function _(ID, a) {
    return new IFC2X3.IfcRegularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3765753017: function _(ID, a) {
    return new IFC2X3.IfcReinforcementDefinitionProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  478536968: function _(ID, a) {
    return new IFC2X3.IfcRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  2778083089: function _(ID, a) {
    return new IFC2X3.IfcRoundedRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1509187699: function _(ID, a) {
    return new IFC2X3.IfcSectionedSpine(ID, a[0], a[1], a[2]);
  },
  2411513650: function _(ID, a) {
    return new IFC2X3.IfcServiceLifeFactor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4124623270: function _(ID, a) {
    return new IFC2X3.IfcShellBasedSurfaceModel(ID, a[0]);
  },
  2609359061: function _(ID, a) {
    return new IFC2X3.IfcSlippageConnectionCondition(ID, a[0], a[1], a[2], a[3]);
  },
  723233188: function _(ID, _25) {
    return new IFC2X3.IfcSolidModel(ID);
  },
  2485662743: function _(ID, a) {
    return new IFC2X3.IfcSoundProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1202362311: function _(ID, a) {
    return new IFC2X3.IfcSoundValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  390701378: function _(ID, a) {
    return new IFC2X3.IfcSpaceThermalLoadProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  1595516126: function _(ID, a) {
    return new IFC2X3.IfcStructuralLoadLinearForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2668620305: function _(ID, a) {
    return new IFC2X3.IfcStructuralLoadPlanarForce(ID, a[0], a[1], a[2], a[3]);
  },
  2473145415: function _(ID, a) {
    return new IFC2X3.IfcStructuralLoadSingleDisplacement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1973038258: function _(ID, a) {
    return new IFC2X3.IfcStructuralLoadSingleDisplacementDistortion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1597423693: function _(ID, a) {
    return new IFC2X3.IfcStructuralLoadSingleForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1190533807: function _(ID, a) {
    return new IFC2X3.IfcStructuralLoadSingleForceWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3843319758: function _(ID, a) {
    return new IFC2X3.IfcStructuralProfileProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22]);
  },
  3653947884: function _(ID, a) {
    return new IFC2X3.IfcStructuralSteelProfileProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22], a[23], a[24], a[25], a[26]);
  },
  2233826070: function _(ID, a) {
    return new IFC2X3.IfcSubedge(ID, a[0], a[1], a[2]);
  },
  2513912981: function _(ID, _26) {
    return new IFC2X3.IfcSurface(ID);
  },
  1878645084: function _(ID, a) {
    return new IFC2X3.IfcSurfaceStyleRendering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2247615214: function _(ID, a) {
    return new IFC2X3.IfcSweptAreaSolid(ID, a[0], a[1]);
  },
  1260650574: function _(ID, a) {
    return new IFC2X3.IfcSweptDiskSolid(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  230924584: function _(ID, a) {
    return new IFC2X3.IfcSweptSurface(ID, a[0], a[1]);
  },
  3071757647: function _(ID, a) {
    return new IFC2X3.IfcTShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  3028897424: function _(ID, a) {
    return new IFC2X3.IfcTerminatorSymbol(ID, a[0], a[1], a[2], a[3]);
  },
  4282788508: function _(ID, a) {
    return new IFC2X3.IfcTextLiteral(ID, a[0], a[1], a[2]);
  },
  3124975700: function _(ID, a) {
    return new IFC2X3.IfcTextLiteralWithExtent(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2715220739: function _(ID, a) {
    return new IFC2X3.IfcTrapeziumProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1345879162: function _(ID, a) {
    return new IFC2X3.IfcTwoDirectionRepeatFactor(ID, a[0], a[1]);
  },
  1628702193: function _(ID, a) {
    return new IFC2X3.IfcTypeObject(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2347495698: function _(ID, a) {
    return new IFC2X3.IfcTypeProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  427810014: function _(ID, a) {
    return new IFC2X3.IfcUShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1417489154: function _(ID, a) {
    return new IFC2X3.IfcVector(ID, a[0], a[1]);
  },
  2759199220: function _(ID, a) {
    return new IFC2X3.IfcVertexLoop(ID, a[0]);
  },
  336235671: function _(ID, a) {
    return new IFC2X3.IfcWindowLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  512836454: function _(ID, a) {
    return new IFC2X3.IfcWindowPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1299126871: function _(ID, a) {
    return new IFC2X3.IfcWindowStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  2543172580: function _(ID, a) {
    return new IFC2X3.IfcZShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3288037868: function _(ID, a) {
    return new IFC2X3.IfcAnnotationCurveOccurrence(ID, a[0], a[1], a[2]);
  },
  669184980: function _(ID, a) {
    return new IFC2X3.IfcAnnotationFillArea(ID, a[0], a[1]);
  },
  2265737646: function _(ID, a) {
    return new IFC2X3.IfcAnnotationFillAreaOccurrence(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1302238472: function _(ID, a) {
    return new IFC2X3.IfcAnnotationSurface(ID, a[0], a[1]);
  },
  4261334040: function _(ID, a) {
    return new IFC2X3.IfcAxis1Placement(ID, a[0], a[1]);
  },
  3125803723: function _(ID, a) {
    return new IFC2X3.IfcAxis2Placement2D(ID, a[0], a[1]);
  },
  2740243338: function _(ID, a) {
    return new IFC2X3.IfcAxis2Placement3D(ID, a[0], a[1], a[2]);
  },
  2736907675: function _(ID, a) {
    return new IFC2X3.IfcBooleanResult(ID, a[0], a[1], a[2]);
  },
  4182860854: function _(ID, _27) {
    return new IFC2X3.IfcBoundedSurface(ID);
  },
  2581212453: function _(ID, a) {
    return new IFC2X3.IfcBoundingBox(ID, a[0], a[1], a[2], a[3]);
  },
  2713105998: function _(ID, a) {
    return new IFC2X3.IfcBoxedHalfSpace(ID, a[0], a[1], a[2]);
  },
  2898889636: function _(ID, a) {
    return new IFC2X3.IfcCShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1123145078: function _(ID, a) {
    return new IFC2X3.IfcCartesianPoint(ID, a[0]);
  },
  59481748: function _(ID, a) {
    return new IFC2X3.IfcCartesianTransformationOperator(ID, a[0], a[1], a[2], a[3]);
  },
  3749851601: function _(ID, a) {
    return new IFC2X3.IfcCartesianTransformationOperator2D(ID, a[0], a[1], a[2], a[3]);
  },
  3486308946: function _(ID, a) {
    return new IFC2X3.IfcCartesianTransformationOperator2DnonUniform(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3331915920: function _(ID, a) {
    return new IFC2X3.IfcCartesianTransformationOperator3D(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1416205885: function _(ID, a) {
    return new IFC2X3.IfcCartesianTransformationOperator3DnonUniform(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1383045692: function _(ID, a) {
    return new IFC2X3.IfcCircleProfileDef(ID, a[0], a[1], a[2], a[3]);
  },
  2205249479: function _(ID, a) {
    return new IFC2X3.IfcClosedShell(ID, a[0]);
  },
  2485617015: function _(ID, a) {
    return new IFC2X3.IfcCompositeCurveSegment(ID, a[0], a[1], a[2]);
  },
  4133800736: function _(ID, a) {
    return new IFC2X3.IfcCraneRailAShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]);
  },
  194851669: function _(ID, a) {
    return new IFC2X3.IfcCraneRailFShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  2506170314: function _(ID, a) {
    return new IFC2X3.IfcCsgPrimitive3D(ID, a[0]);
  },
  2147822146: function _(ID, a) {
    return new IFC2X3.IfcCsgSolid(ID, a[0]);
  },
  2601014836: function _(ID, _28) {
    return new IFC2X3.IfcCurve(ID);
  },
  2827736869: function _(ID, a) {
    return new IFC2X3.IfcCurveBoundedPlane(ID, a[0], a[1], a[2]);
  },
  693772133: function _(ID, a) {
    return new IFC2X3.IfcDefinedSymbol(ID, a[0], a[1]);
  },
  606661476: function _(ID, a) {
    return new IFC2X3.IfcDimensionCurve(ID, a[0], a[1], a[2]);
  },
  4054601972: function _(ID, a) {
    return new IFC2X3.IfcDimensionCurveTerminator(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  32440307: function _(ID, a) {
    return new IFC2X3.IfcDirection(ID, a[0]);
  },
  2963535650: function _(ID, a) {
    return new IFC2X3.IfcDoorLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]);
  },
  1714330368: function _(ID, a) {
    return new IFC2X3.IfcDoorPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  526551008: function _(ID, a) {
    return new IFC2X3.IfcDoorStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  3073041342: function _(ID, a) {
    return new IFC2X3.IfcDraughtingCallout(ID, a[0]);
  },
  445594917: function _(ID, a) {
    return new IFC2X3.IfcDraughtingPreDefinedColour(ID, a[0]);
  },
  4006246654: function _(ID, a) {
    return new IFC2X3.IfcDraughtingPreDefinedCurveFont(ID, a[0]);
  },
  1472233963: function _(ID, a) {
    return new IFC2X3.IfcEdgeLoop(ID, a[0]);
  },
  1883228015: function _(ID, a) {
    return new IFC2X3.IfcElementQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  339256511: function _(ID, a) {
    return new IFC2X3.IfcElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2777663545: function _(ID, a) {
    return new IFC2X3.IfcElementarySurface(ID, a[0]);
  },
  2835456948: function _(ID, a) {
    return new IFC2X3.IfcEllipseProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  80994333: function _(ID, a) {
    return new IFC2X3.IfcEnergyProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  477187591: function _(ID, a) {
    return new IFC2X3.IfcExtrudedAreaSolid(ID, a[0], a[1], a[2], a[3]);
  },
  2047409740: function _(ID, a) {
    return new IFC2X3.IfcFaceBasedSurfaceModel(ID, a[0]);
  },
  374418227: function _(ID, a) {
    return new IFC2X3.IfcFillAreaStyleHatching(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4203026998: function _(ID, a) {
    return new IFC2X3.IfcFillAreaStyleTileSymbolWithStyle(ID, a[0]);
  },
  315944413: function _(ID, a) {
    return new IFC2X3.IfcFillAreaStyleTiles(ID, a[0], a[1], a[2]);
  },
  3455213021: function _(ID, a) {
    return new IFC2X3.IfcFluidFlowProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18]);
  },
  4238390223: function _(ID, a) {
    return new IFC2X3.IfcFurnishingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1268542332: function _(ID, a) {
    return new IFC2X3.IfcFurnitureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  987898635: function _(ID, a) {
    return new IFC2X3.IfcGeometricCurveSet(ID, a[0]);
  },
  1484403080: function _(ID, a) {
    return new IFC2X3.IfcIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  572779678: function _(ID, a) {
    return new IFC2X3.IfcLShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1281925730: function _(ID, a) {
    return new IFC2X3.IfcLine(ID, a[0], a[1]);
  },
  1425443689: function _(ID, a) {
    return new IFC2X3.IfcManifoldSolidBrep(ID, a[0]);
  },
  3888040117: function _(ID, a) {
    return new IFC2X3.IfcObject(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3388369263: function _(ID, a) {
    return new IFC2X3.IfcOffsetCurve2D(ID, a[0], a[1], a[2]);
  },
  3505215534: function _(ID, a) {
    return new IFC2X3.IfcOffsetCurve3D(ID, a[0], a[1], a[2], a[3]);
  },
  3566463478: function _(ID, a) {
    return new IFC2X3.IfcPermeableCoveringProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  603570806: function _(ID, a) {
    return new IFC2X3.IfcPlanarBox(ID, a[0], a[1], a[2]);
  },
  220341763: function _(ID, a) {
    return new IFC2X3.IfcPlane(ID, a[0]);
  },
  2945172077: function _(ID, a) {
    return new IFC2X3.IfcProcess(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4208778838: function _(ID, a) {
    return new IFC2X3.IfcProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  103090709: function _(ID, a) {
    return new IFC2X3.IfcProject(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4194566429: function _(ID, a) {
    return new IFC2X3.IfcProjectionCurve(ID, a[0], a[1], a[2]);
  },
  1451395588: function _(ID, a) {
    return new IFC2X3.IfcPropertySet(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3219374653: function _(ID, a) {
    return new IFC2X3.IfcProxy(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2770003689: function _(ID, a) {
    return new IFC2X3.IfcRectangleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2798486643: function _(ID, a) {
    return new IFC2X3.IfcRectangularPyramid(ID, a[0], a[1], a[2], a[3]);
  },
  3454111270: function _(ID, a) {
    return new IFC2X3.IfcRectangularTrimmedSurface(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3939117080: function _(ID, a) {
    return new IFC2X3.IfcRelAssigns(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1683148259: function _(ID, a) {
    return new IFC2X3.IfcRelAssignsToActor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2495723537: function _(ID, a) {
    return new IFC2X3.IfcRelAssignsToControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1307041759: function _(ID, a) {
    return new IFC2X3.IfcRelAssignsToGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  4278684876: function _(ID, a) {
    return new IFC2X3.IfcRelAssignsToProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2857406711: function _(ID, a) {
    return new IFC2X3.IfcRelAssignsToProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3372526763: function _(ID, a) {
    return new IFC2X3.IfcRelAssignsToProjectOrder(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  205026976: function _(ID, a) {
    return new IFC2X3.IfcRelAssignsToResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1865459582: function _(ID, a) {
    return new IFC2X3.IfcRelAssociates(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1327628568: function _(ID, a) {
    return new IFC2X3.IfcRelAssociatesAppliedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4095574036: function _(ID, a) {
    return new IFC2X3.IfcRelAssociatesApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  919958153: function _(ID, a) {
    return new IFC2X3.IfcRelAssociatesClassification(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2728634034: function _(ID, a) {
    return new IFC2X3.IfcRelAssociatesConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  982818633: function _(ID, a) {
    return new IFC2X3.IfcRelAssociatesDocument(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3840914261: function _(ID, a) {
    return new IFC2X3.IfcRelAssociatesLibrary(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2655215786: function _(ID, a) {
    return new IFC2X3.IfcRelAssociatesMaterial(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2851387026: function _(ID, a) {
    return new IFC2X3.IfcRelAssociatesProfileProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  826625072: function _(ID, a) {
    return new IFC2X3.IfcRelConnects(ID, a[0], a[1], a[2], a[3]);
  },
  1204542856: function _(ID, a) {
    return new IFC2X3.IfcRelConnectsElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3945020480: function _(ID, a) {
    return new IFC2X3.IfcRelConnectsPathElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4201705270: function _(ID, a) {
    return new IFC2X3.IfcRelConnectsPortToElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3190031847: function _(ID, a) {
    return new IFC2X3.IfcRelConnectsPorts(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2127690289: function _(ID, a) {
    return new IFC2X3.IfcRelConnectsStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3912681535: function _(ID, a) {
    return new IFC2X3.IfcRelConnectsStructuralElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1638771189: function _(ID, a) {
    return new IFC2X3.IfcRelConnectsStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  504942748: function _(ID, a) {
    return new IFC2X3.IfcRelConnectsWithEccentricity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  3678494232: function _(ID, a) {
    return new IFC2X3.IfcRelConnectsWithRealizingElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3242617779: function _(ID, a) {
    return new IFC2X3.IfcRelContainedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  886880790: function _(ID, a) {
    return new IFC2X3.IfcRelCoversBldgElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2802773753: function _(ID, a) {
    return new IFC2X3.IfcRelCoversSpaces(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2551354335: function _(ID, a) {
    return new IFC2X3.IfcRelDecomposes(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  693640335: function _(ID, a) {
    return new IFC2X3.IfcRelDefines(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4186316022: function _(ID, a) {
    return new IFC2X3.IfcRelDefinesByProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  781010003: function _(ID, a) {
    return new IFC2X3.IfcRelDefinesByType(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3940055652: function _(ID, a) {
    return new IFC2X3.IfcRelFillsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  279856033: function _(ID, a) {
    return new IFC2X3.IfcRelFlowControlElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4189434867: function _(ID, a) {
    return new IFC2X3.IfcRelInteractionRequirements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3268803585: function _(ID, a) {
    return new IFC2X3.IfcRelNests(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2051452291: function _(ID, a) {
    return new IFC2X3.IfcRelOccupiesSpaces(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  202636808: function _(ID, a) {
    return new IFC2X3.IfcRelOverridesProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  750771296: function _(ID, a) {
    return new IFC2X3.IfcRelProjectsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1245217292: function _(ID, a) {
    return new IFC2X3.IfcRelReferencedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1058617721: function _(ID, a) {
    return new IFC2X3.IfcRelSchedulesCostItems(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  4122056220: function _(ID, a) {
    return new IFC2X3.IfcRelSequence(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  366585022: function _(ID, a) {
    return new IFC2X3.IfcRelServicesBuildings(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3451746338: function _(ID, a) {
    return new IFC2X3.IfcRelSpaceBoundary(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1401173127: function _(ID, a) {
    return new IFC2X3.IfcRelVoidsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2914609552: function _(ID, a) {
    return new IFC2X3.IfcResource(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1856042241: function _(ID, a) {
    return new IFC2X3.IfcRevolvedAreaSolid(ID, a[0], a[1], a[2], a[3]);
  },
  4158566097: function _(ID, a) {
    return new IFC2X3.IfcRightCircularCone(ID, a[0], a[1], a[2]);
  },
  3626867408: function _(ID, a) {
    return new IFC2X3.IfcRightCircularCylinder(ID, a[0], a[1], a[2]);
  },
  2706606064: function _(ID, a) {
    return new IFC2X3.IfcSpatialStructureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3893378262: function _(ID, a) {
    return new IFC2X3.IfcSpatialStructureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  451544542: function _(ID, a) {
    return new IFC2X3.IfcSphere(ID, a[0], a[1]);
  },
  3544373492: function _(ID, a) {
    return new IFC2X3.IfcStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3136571912: function _(ID, a) {
    return new IFC2X3.IfcStructuralItem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  530289379: function _(ID, a) {
    return new IFC2X3.IfcStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3689010777: function _(ID, a) {
    return new IFC2X3.IfcStructuralReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3979015343: function _(ID, a) {
    return new IFC2X3.IfcStructuralSurfaceMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2218152070: function _(ID, a) {
    return new IFC2X3.IfcStructuralSurfaceMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4070609034: function _(ID, a) {
    return new IFC2X3.IfcStructuredDimensionCallout(ID, a[0]);
  },
  2028607225: function _(ID, a) {
    return new IFC2X3.IfcSurfaceCurveSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2809605785: function _(ID, a) {
    return new IFC2X3.IfcSurfaceOfLinearExtrusion(ID, a[0], a[1], a[2], a[3]);
  },
  4124788165: function _(ID, a) {
    return new IFC2X3.IfcSurfaceOfRevolution(ID, a[0], a[1], a[2]);
  },
  1580310250: function _(ID, a) {
    return new IFC2X3.IfcSystemFurnitureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3473067441: function _(ID, a) {
    return new IFC2X3.IfcTask(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2097647324: function _(ID, a) {
    return new IFC2X3.IfcTransportElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2296667514: function _(ID, a) {
    return new IFC2X3.IfcActor(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1674181508: function _(ID, a) {
    return new IFC2X3.IfcAnnotation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3207858831: function _(ID, a) {
    return new IFC2X3.IfcAsymmetricIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1334484129: function _(ID, a) {
    return new IFC2X3.IfcBlock(ID, a[0], a[1], a[2], a[3]);
  },
  3649129432: function _(ID, a) {
    return new IFC2X3.IfcBooleanClippingResult(ID, a[0], a[1], a[2]);
  },
  1260505505: function _(ID, _29) {
    return new IFC2X3.IfcBoundedCurve(ID);
  },
  4031249490: function _(ID, a) {
    return new IFC2X3.IfcBuilding(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1950629157: function _(ID, a) {
    return new IFC2X3.IfcBuildingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3124254112: function _(ID, a) {
    return new IFC2X3.IfcBuildingStorey(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2937912522: function _(ID, a) {
    return new IFC2X3.IfcCircleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  300633059: function _(ID, a) {
    return new IFC2X3.IfcColumnType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3732776249: function _(ID, a) {
    return new IFC2X3.IfcCompositeCurve(ID, a[0], a[1]);
  },
  2510884976: function _(ID, a) {
    return new IFC2X3.IfcConic(ID, a[0]);
  },
  2559216714: function _(ID, a) {
    return new IFC2X3.IfcConstructionResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3293443760: function _(ID, a) {
    return new IFC2X3.IfcControl(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3895139033: function _(ID, a) {
    return new IFC2X3.IfcCostItem(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1419761937: function _(ID, a) {
    return new IFC2X3.IfcCostSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  1916426348: function _(ID, a) {
    return new IFC2X3.IfcCoveringType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3295246426: function _(ID, a) {
    return new IFC2X3.IfcCrewResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1457835157: function _(ID, a) {
    return new IFC2X3.IfcCurtainWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  681481545: function _(ID, a) {
    return new IFC2X3.IfcDimensionCurveDirectedCallout(ID, a[0]);
  },
  3256556792: function _(ID, a) {
    return new IFC2X3.IfcDistributionElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3849074793: function _(ID, a) {
    return new IFC2X3.IfcDistributionFlowElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  360485395: function _(ID, a) {
    return new IFC2X3.IfcElectricalBaseProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  1758889154: function _(ID, a) {
    return new IFC2X3.IfcElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4123344466: function _(ID, a) {
    return new IFC2X3.IfcElementAssembly(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1623761950: function _(ID, a) {
    return new IFC2X3.IfcElementComponent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2590856083: function _(ID, a) {
    return new IFC2X3.IfcElementComponentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1704287377: function _(ID, a) {
    return new IFC2X3.IfcEllipse(ID, a[0], a[1], a[2]);
  },
  2107101300: function _(ID, a) {
    return new IFC2X3.IfcEnergyConversionDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1962604670: function _(ID, a) {
    return new IFC2X3.IfcEquipmentElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3272907226: function _(ID, a) {
    return new IFC2X3.IfcEquipmentStandard(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3174744832: function _(ID, a) {
    return new IFC2X3.IfcEvaporativeCoolerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3390157468: function _(ID, a) {
    return new IFC2X3.IfcEvaporatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  807026263: function _(ID, a) {
    return new IFC2X3.IfcFacetedBrep(ID, a[0]);
  },
  3737207727: function _(ID, a) {
    return new IFC2X3.IfcFacetedBrepWithVoids(ID, a[0], a[1]);
  },
  647756555: function _(ID, a) {
    return new IFC2X3.IfcFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2489546625: function _(ID, a) {
    return new IFC2X3.IfcFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2827207264: function _(ID, a) {
    return new IFC2X3.IfcFeatureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2143335405: function _(ID, a) {
    return new IFC2X3.IfcFeatureElementAddition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1287392070: function _(ID, a) {
    return new IFC2X3.IfcFeatureElementSubtraction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3907093117: function _(ID, a) {
    return new IFC2X3.IfcFlowControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3198132628: function _(ID, a) {
    return new IFC2X3.IfcFlowFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3815607619: function _(ID, a) {
    return new IFC2X3.IfcFlowMeterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1482959167: function _(ID, a) {
    return new IFC2X3.IfcFlowMovingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1834744321: function _(ID, a) {
    return new IFC2X3.IfcFlowSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1339347760: function _(ID, a) {
    return new IFC2X3.IfcFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2297155007: function _(ID, a) {
    return new IFC2X3.IfcFlowTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3009222698: function _(ID, a) {
    return new IFC2X3.IfcFlowTreatmentDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  263784265: function _(ID, a) {
    return new IFC2X3.IfcFurnishingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  814719939: function _(ID, a) {
    return new IFC2X3.IfcFurnitureStandard(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  200128114: function _(ID, a) {
    return new IFC2X3.IfcGasTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3009204131: function _(ID, a) {
    return new IFC2X3.IfcGrid(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2706460486: function _(ID, a) {
    return new IFC2X3.IfcGroup(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1251058090: function _(ID, a) {
    return new IFC2X3.IfcHeatExchangerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1806887404: function _(ID, a) {
    return new IFC2X3.IfcHumidifierType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2391368822: function _(ID, a) {
    return new IFC2X3.IfcInventory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4288270099: function _(ID, a) {
    return new IFC2X3.IfcJunctionBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3827777499: function _(ID, a) {
    return new IFC2X3.IfcLaborResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1051575348: function _(ID, a) {
    return new IFC2X3.IfcLampType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1161773419: function _(ID, a) {
    return new IFC2X3.IfcLightFixtureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2506943328: function _(ID, a) {
    return new IFC2X3.IfcLinearDimension(ID, a[0]);
  },
  377706215: function _(ID, a) {
    return new IFC2X3.IfcMechanicalFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2108223431: function _(ID, a) {
    return new IFC2X3.IfcMechanicalFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3181161470: function _(ID, a) {
    return new IFC2X3.IfcMemberType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  977012517: function _(ID, a) {
    return new IFC2X3.IfcMotorConnectionType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1916936684: function _(ID, a) {
    return new IFC2X3.IfcMove(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  4143007308: function _(ID, a) {
    return new IFC2X3.IfcOccupant(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3588315303: function _(ID, a) {
    return new IFC2X3.IfcOpeningElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3425660407: function _(ID, a) {
    return new IFC2X3.IfcOrderAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2837617999: function _(ID, a) {
    return new IFC2X3.IfcOutletType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2382730787: function _(ID, a) {
    return new IFC2X3.IfcPerformanceHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3327091369: function _(ID, a) {
    return new IFC2X3.IfcPermit(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  804291784: function _(ID, a) {
    return new IFC2X3.IfcPipeFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4231323485: function _(ID, a) {
    return new IFC2X3.IfcPipeSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4017108033: function _(ID, a) {
    return new IFC2X3.IfcPlateType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3724593414: function _(ID, a) {
    return new IFC2X3.IfcPolyline(ID, a[0]);
  },
  3740093272: function _(ID, a) {
    return new IFC2X3.IfcPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2744685151: function _(ID, a) {
    return new IFC2X3.IfcProcedure(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2904328755: function _(ID, a) {
    return new IFC2X3.IfcProjectOrder(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3642467123: function _(ID, a) {
    return new IFC2X3.IfcProjectOrderRecord(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3651124850: function _(ID, a) {
    return new IFC2X3.IfcProjectionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1842657554: function _(ID, a) {
    return new IFC2X3.IfcProtectiveDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2250791053: function _(ID, a) {
    return new IFC2X3.IfcPumpType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3248260540: function _(ID, a) {
    return new IFC2X3.IfcRadiusDimension(ID, a[0]);
  },
  2893384427: function _(ID, a) {
    return new IFC2X3.IfcRailingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2324767716: function _(ID, a) {
    return new IFC2X3.IfcRampFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  160246688: function _(ID, a) {
    return new IFC2X3.IfcRelAggregates(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2863920197: function _(ID, a) {
    return new IFC2X3.IfcRelAssignsTasks(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1768891740: function _(ID, a) {
    return new IFC2X3.IfcSanitaryTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3517283431: function _(ID, a) {
    return new IFC2X3.IfcScheduleTimeControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20], a[21], a[22]);
  },
  4105383287: function _(ID, a) {
    return new IFC2X3.IfcServiceLife(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  4097777520: function _(ID, a) {
    return new IFC2X3.IfcSite(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  2533589738: function _(ID, a) {
    return new IFC2X3.IfcSlabType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3856911033: function _(ID, a) {
    return new IFC2X3.IfcSpace(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1305183839: function _(ID, a) {
    return new IFC2X3.IfcSpaceHeaterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  652456506: function _(ID, a) {
    return new IFC2X3.IfcSpaceProgram(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3812236995: function _(ID, a) {
    return new IFC2X3.IfcSpaceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3112655638: function _(ID, a) {
    return new IFC2X3.IfcStackTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1039846685: function _(ID, a) {
    return new IFC2X3.IfcStairFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  682877961: function _(ID, a) {
    return new IFC2X3.IfcStructuralAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1179482911: function _(ID, a) {
    return new IFC2X3.IfcStructuralConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4243806635: function _(ID, a) {
    return new IFC2X3.IfcStructuralCurveConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  214636428: function _(ID, a) {
    return new IFC2X3.IfcStructuralCurveMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2445595289: function _(ID, a) {
    return new IFC2X3.IfcStructuralCurveMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1807405624: function _(ID, a) {
    return new IFC2X3.IfcStructuralLinearAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1721250024: function _(ID, a) {
    return new IFC2X3.IfcStructuralLinearActionVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  1252848954: function _(ID, a) {
    return new IFC2X3.IfcStructuralLoadGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1621171031: function _(ID, a) {
    return new IFC2X3.IfcStructuralPlanarAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  3987759626: function _(ID, a) {
    return new IFC2X3.IfcStructuralPlanarActionVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  2082059205: function _(ID, a) {
    return new IFC2X3.IfcStructuralPointAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  734778138: function _(ID, a) {
    return new IFC2X3.IfcStructuralPointConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1235345126: function _(ID, a) {
    return new IFC2X3.IfcStructuralPointReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2986769608: function _(ID, a) {
    return new IFC2X3.IfcStructuralResultGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1975003073: function _(ID, a) {
    return new IFC2X3.IfcStructuralSurfaceConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  148013059: function _(ID, a) {
    return new IFC2X3.IfcSubContractResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2315554128: function _(ID, a) {
    return new IFC2X3.IfcSwitchingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2254336722: function _(ID, a) {
    return new IFC2X3.IfcSystem(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  5716631: function _(ID, a) {
    return new IFC2X3.IfcTankType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1637806684: function _(ID, a) {
    return new IFC2X3.IfcTimeSeriesSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1692211062: function _(ID, a) {
    return new IFC2X3.IfcTransformerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1620046519: function _(ID, a) {
    return new IFC2X3.IfcTransportElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  3593883385: function _(ID, a) {
    return new IFC2X3.IfcTrimmedCurve(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1600972822: function _(ID, a) {
    return new IFC2X3.IfcTubeBundleType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1911125066: function _(ID, a) {
    return new IFC2X3.IfcUnitaryEquipmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  728799441: function _(ID, a) {
    return new IFC2X3.IfcValveType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2769231204: function _(ID, a) {
    return new IFC2X3.IfcVirtualElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1898987631: function _(ID, a) {
    return new IFC2X3.IfcWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1133259667: function _(ID, a) {
    return new IFC2X3.IfcWasteTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1028945134: function _(ID, a) {
    return new IFC2X3.IfcWorkControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]);
  },
  4218914973: function _(ID, a) {
    return new IFC2X3.IfcWorkPlan(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]);
  },
  3342526732: function _(ID, a) {
    return new IFC2X3.IfcWorkSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]);
  },
  1033361043: function _(ID, a) {
    return new IFC2X3.IfcZone(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1213861670: function _(ID, a) {
    return new IFC2X3.Ifc2DCompositeCurve(ID, a[0], a[1]);
  },
  3821786052: function _(ID, a) {
    return new IFC2X3.IfcActionRequest(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1411407467: function _(ID, a) {
    return new IFC2X3.IfcAirTerminalBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3352864051: function _(ID, a) {
    return new IFC2X3.IfcAirTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1871374353: function _(ID, a) {
    return new IFC2X3.IfcAirToAirHeatRecoveryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2470393545: function _(ID, a) {
    return new IFC2X3.IfcAngularDimension(ID, a[0]);
  },
  3460190687: function _(ID, a) {
    return new IFC2X3.IfcAsset(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  1967976161: function _(ID, a) {
    return new IFC2X3.IfcBSplineCurve(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  819618141: function _(ID, a) {
    return new IFC2X3.IfcBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1916977116: function _(ID, a) {
    return new IFC2X3.IfcBezierCurve(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  231477066: function _(ID, a) {
    return new IFC2X3.IfcBoilerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3299480353: function _(ID, a) {
    return new IFC2X3.IfcBuildingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  52481810: function _(ID, a) {
    return new IFC2X3.IfcBuildingElementComponent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2979338954: function _(ID, a) {
    return new IFC2X3.IfcBuildingElementPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1095909175: function _(ID, a) {
    return new IFC2X3.IfcBuildingElementProxy(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1909888760: function _(ID, a) {
    return new IFC2X3.IfcBuildingElementProxyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  395041908: function _(ID, a) {
    return new IFC2X3.IfcCableCarrierFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3293546465: function _(ID, a) {
    return new IFC2X3.IfcCableCarrierSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1285652485: function _(ID, a) {
    return new IFC2X3.IfcCableSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2951183804: function _(ID, a) {
    return new IFC2X3.IfcChillerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2611217952: function _(ID, a) {
    return new IFC2X3.IfcCircle(ID, a[0], a[1]);
  },
  2301859152: function _(ID, a) {
    return new IFC2X3.IfcCoilType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  843113511: function _(ID, a) {
    return new IFC2X3.IfcColumn(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3850581409: function _(ID, a) {
    return new IFC2X3.IfcCompressorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2816379211: function _(ID, a) {
    return new IFC2X3.IfcCondenserType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2188551683: function _(ID, a) {
    return new IFC2X3.IfcCondition(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1163958913: function _(ID, a) {
    return new IFC2X3.IfcConditionCriterion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3898045240: function _(ID, a) {
    return new IFC2X3.IfcConstructionEquipmentResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1060000209: function _(ID, a) {
    return new IFC2X3.IfcConstructionMaterialResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  488727124: function _(ID, a) {
    return new IFC2X3.IfcConstructionProductResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  335055490: function _(ID, a) {
    return new IFC2X3.IfcCooledBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2954562838: function _(ID, a) {
    return new IFC2X3.IfcCoolingTowerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1973544240: function _(ID, a) {
    return new IFC2X3.IfcCovering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3495092785: function _(ID, a) {
    return new IFC2X3.IfcCurtainWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3961806047: function _(ID, a) {
    return new IFC2X3.IfcDamperType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4147604152: function _(ID, a) {
    return new IFC2X3.IfcDiameterDimension(ID, a[0]);
  },
  1335981549: function _(ID, a) {
    return new IFC2X3.IfcDiscreteAccessory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2635815018: function _(ID, a) {
    return new IFC2X3.IfcDiscreteAccessoryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1599208980: function _(ID, a) {
    return new IFC2X3.IfcDistributionChamberElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2063403501: function _(ID, a) {
    return new IFC2X3.IfcDistributionControlElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1945004755: function _(ID, a) {
    return new IFC2X3.IfcDistributionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3040386961: function _(ID, a) {
    return new IFC2X3.IfcDistributionFlowElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3041715199: function _(ID, a) {
    return new IFC2X3.IfcDistributionPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  395920057: function _(ID, a) {
    return new IFC2X3.IfcDoor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  869906466: function _(ID, a) {
    return new IFC2X3.IfcDuctFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3760055223: function _(ID, a) {
    return new IFC2X3.IfcDuctSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2030761528: function _(ID, a) {
    return new IFC2X3.IfcDuctSilencerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  855621170: function _(ID, a) {
    return new IFC2X3.IfcEdgeFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  663422040: function _(ID, a) {
    return new IFC2X3.IfcElectricApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3277789161: function _(ID, a) {
    return new IFC2X3.IfcElectricFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1534661035: function _(ID, a) {
    return new IFC2X3.IfcElectricGeneratorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1365060375: function _(ID, a) {
    return new IFC2X3.IfcElectricHeaterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1217240411: function _(ID, a) {
    return new IFC2X3.IfcElectricMotorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  712377611: function _(ID, a) {
    return new IFC2X3.IfcElectricTimeControlType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1634875225: function _(ID, a) {
    return new IFC2X3.IfcElectricalCircuit(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  857184966: function _(ID, a) {
    return new IFC2X3.IfcElectricalElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1658829314: function _(ID, a) {
    return new IFC2X3.IfcEnergyConversionDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  346874300: function _(ID, a) {
    return new IFC2X3.IfcFanType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1810631287: function _(ID, a) {
    return new IFC2X3.IfcFilterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4222183408: function _(ID, a) {
    return new IFC2X3.IfcFireSuppressionTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2058353004: function _(ID, a) {
    return new IFC2X3.IfcFlowController(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4278956645: function _(ID, a) {
    return new IFC2X3.IfcFlowFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4037862832: function _(ID, a) {
    return new IFC2X3.IfcFlowInstrumentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3132237377: function _(ID, a) {
    return new IFC2X3.IfcFlowMovingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  987401354: function _(ID, a) {
    return new IFC2X3.IfcFlowSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  707683696: function _(ID, a) {
    return new IFC2X3.IfcFlowStorageDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2223149337: function _(ID, a) {
    return new IFC2X3.IfcFlowTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3508470533: function _(ID, a) {
    return new IFC2X3.IfcFlowTreatmentDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  900683007: function _(ID, a) {
    return new IFC2X3.IfcFooting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1073191201: function _(ID, a) {
    return new IFC2X3.IfcMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1687234759: function _(ID, a) {
    return new IFC2X3.IfcPile(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3171933400: function _(ID, a) {
    return new IFC2X3.IfcPlate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2262370178: function _(ID, a) {
    return new IFC2X3.IfcRailing(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3024970846: function _(ID, a) {
    return new IFC2X3.IfcRamp(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3283111854: function _(ID, a) {
    return new IFC2X3.IfcRampFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3055160366: function _(ID, a) {
    return new IFC2X3.IfcRationalBezierCurve(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3027567501: function _(ID, a) {
    return new IFC2X3.IfcReinforcingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2320036040: function _(ID, a) {
    return new IFC2X3.IfcReinforcingMesh(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]);
  },
  2016517767: function _(ID, a) {
    return new IFC2X3.IfcRoof(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1376911519: function _(ID, a) {
    return new IFC2X3.IfcRoundedEdgeFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1783015770: function _(ID, a) {
    return new IFC2X3.IfcSensorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1529196076: function _(ID, a) {
    return new IFC2X3.IfcSlab(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  331165859: function _(ID, a) {
    return new IFC2X3.IfcStair(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4252922144: function _(ID, a) {
    return new IFC2X3.IfcStairFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  2515109513: function _(ID, a) {
    return new IFC2X3.IfcStructuralAnalysisModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3824725483: function _(ID, a) {
    return new IFC2X3.IfcTendon(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]);
  },
  2347447852: function _(ID, a) {
    return new IFC2X3.IfcTendonAnchor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3313531582: function _(ID, a) {
    return new IFC2X3.IfcVibrationIsolatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2391406946: function _(ID, a) {
    return new IFC2X3.IfcWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3512223829: function _(ID, a) {
    return new IFC2X3.IfcWallStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3304561284: function _(ID, a) {
    return new IFC2X3.IfcWindow(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2874132201: function _(ID, a) {
    return new IFC2X3.IfcActuatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3001207471: function _(ID, a) {
    return new IFC2X3.IfcAlarmType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  753842376: function _(ID, a) {
    return new IFC2X3.IfcBeam(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2454782716: function _(ID, a) {
    return new IFC2X3.IfcChamferEdgeFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  578613899: function _(ID, a) {
    return new IFC2X3.IfcControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1052013943: function _(ID, a) {
    return new IFC2X3.IfcDistributionChamberElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1062813311: function _(ID, a) {
    return new IFC2X3.IfcDistributionControlElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3700593921: function _(ID, a) {
    return new IFC2X3.IfcElectricDistributionPoint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  979691226: function _(ID, a) {
    return new IFC2X3.IfcReinforcingBar(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  }
};
ToRawLineData[1] = {
  3630933823: function _(i) {
    return [i.Role, i.UserDefinedRole, i.Description];
  },
  618182010: function _(i) {
    return [i.Purpose, i.Description, i.UserDefinedPurpose];
  },
  639542469: function _(i) {
    return [i.ApplicationDeveloper, i.Version, i.ApplicationFullName, i.ApplicationIdentifier];
  },
  411424972: function _(i) {
    return [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate];
  },
  1110488051: function _(i) {
    return [i.ComponentOfTotal, i.Components, i.ArithmeticOperator, i.Name, i.Description];
  },
  130549933: function _(i) {
    return [i.Description, i.ApprovalDateTime, i.ApprovalStatus, i.ApprovalLevel, i.ApprovalQualifier, i.Name, i.Identifier];
  },
  2080292479: function _(i) {
    return [i.Actor, i.Approval, i.Role];
  },
  390851274: function _(i) {
    return [i.ApprovedProperties, i.Approval];
  },
  3869604511: function _(i) {
    return [i.RelatedApproval, i.RelatingApproval, i.Description, i.Name];
  },
  4037036970: function _(i) {
    return [i.Name];
  },
  1560379544: function _(i) {
    return [i.Name, i.LinearStiffnessByLengthX, i.LinearStiffnessByLengthY, i.LinearStiffnessByLengthZ, i.RotationalStiffnessByLengthX, i.RotationalStiffnessByLengthY, i.RotationalStiffnessByLengthZ];
  },
  3367102660: function _(i) {
    return [i.Name, i.LinearStiffnessByAreaX, i.LinearStiffnessByAreaY, i.LinearStiffnessByAreaZ];
  },
  1387855156: function _(i) {
    return [i.Name, i.LinearStiffnessX, i.LinearStiffnessY, i.LinearStiffnessZ, i.RotationalStiffnessX, i.RotationalStiffnessY, i.RotationalStiffnessZ];
  },
  2069777674: function _(i) {
    return [i.Name, i.LinearStiffnessX, i.LinearStiffnessY, i.LinearStiffnessZ, i.RotationalStiffnessX, i.RotationalStiffnessY, i.RotationalStiffnessZ, i.WarpingStiffness];
  },
  622194075: function _(i) {
    return [i.DayComponent, i.MonthComponent, i.YearComponent];
  },
  747523909: function _(i) {
    return [i.Source, i.Edition, i.EditionDate, i.Name];
  },
  1767535486: function _(i) {
    return [i.Notation, i.ItemOf, i.Title];
  },
  1098599126: function _(i) {
    return [i.RelatingItem, i.RelatedItems];
  },
  938368621: function _(i) {
    return [i.NotationFacets];
  },
  3639012971: function _(i) {
    return [i.NotationValue];
  },
  3264961684: function _(i) {
    return [i.Name];
  },
  2859738748: function _(_30) {
    return [];
  },
  2614616156: function _(i) {
    return [i.PointOnRelatingElement, i.PointOnRelatedElement];
  },
  4257277454: function _(i) {
    return [i.LocationAtRelatingElement, i.LocationAtRelatedElement, i.ProfileOfPort];
  },
  2732653382: function _(i) {
    return [i.SurfaceOnRelatingElement, i.SurfaceOnRelatedElement];
  },
  1959218052: function _(i) {
    return [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade];
  },
  1658513725: function _(i) {
    return [i.Name, i.Description, i.RelatingConstraint, i.RelatedConstraints, i.LogicalAggregator];
  },
  613356794: function _(i) {
    return [i.ClassifiedConstraint, i.RelatedClassifications];
  },
  347226245: function _(i) {
    return [i.Name, i.Description, i.RelatingConstraint, i.RelatedConstraints];
  },
  1065062679: function _(i) {
    return [i.HourOffset, i.MinuteOffset, i.Sense];
  },
  602808272: function _(i) {
    return [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.CostType, i.Condition];
  },
  539742890: function _(i) {
    return [i.RelatingMonetaryUnit, i.RelatedMonetaryUnit, i.ExchangeRate, i.RateDateTime, i.RateSource];
  },
  1105321065: function _(i) {
    return [i.Name, i.PatternList];
  },
  2367409068: function _(i) {
    return [i.Name, i.CurveFont, i.CurveFontScaling];
  },
  3510044353: function _(i) {
    return [i.VisibleSegmentLength, i.InvisibleSegmentLength];
  },
  1072939445: function _(i) {
    return [i.DateComponent, i.TimeComponent];
  },
  1765591967: function _(i) {
    return [i.Elements, i.UnitType, i.UserDefinedType];
  },
  1045800335: function _(i) {
    return [i.Unit, i.Exponent];
  },
  2949456006: function _(i) {
    return [i.LengthExponent, i.MassExponent, i.TimeExponent, i.ElectricCurrentExponent, i.ThermodynamicTemperatureExponent, i.AmountOfSubstanceExponent, i.LuminousIntensityExponent];
  },
  1376555844: function _(i) {
    return [i.FileExtension, i.MimeContentType, i.MimeSubtype];
  },
  1154170062: function _(i) {
    return [i.DocumentId, i.Name, i.Description, i.DocumentReferences, i.Purpose, i.IntendedUse, i.Scope, i.Revision, i.DocumentOwner, i.Editors, i.CreationTime, i.LastRevisionTime, i.ElectronicFormat, i.ValidFrom, i.ValidUntil, i.Confidentiality, i.Status];
  },
  770865208: function _(i) {
    return [i.RelatingDocument, i.RelatedDocuments, i.RelationshipType];
  },
  3796139169: function _(i) {
    return [i.Name, i.Description, i.RelatingDraughtingCallout, i.RelatedDraughtingCallout];
  },
  1648886627: function _(i) {
    return [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.ImpactType, i.Category, i.UserDefinedCategory];
  },
  3200245327: function _(i) {
    return [i.Location, i.ItemReference, i.Name];
  },
  2242383968: function _(i) {
    return [i.Location, i.ItemReference, i.Name];
  },
  1040185647: function _(i) {
    return [i.Location, i.ItemReference, i.Name];
  },
  3207319532: function _(i) {
    return [i.Location, i.ItemReference, i.Name];
  },
  3548104201: function _(i) {
    return [i.Location, i.ItemReference, i.Name];
  },
  852622518: function _(i) {
    return [i.AxisTag, i.AxisCurve, i.SameSense];
  },
  3020489413: function _(i) {
    return [i.TimeStamp, i.ListValues.map(function (p) {
      return Labelise(p);
    })];
  },
  2655187982: function _(i) {
    return [i.Name, i.Version, i.Publisher, i.VersionDate, i.LibraryReference];
  },
  3452421091: function _(i) {
    return [i.Location, i.ItemReference, i.Name];
  },
  4162380809: function _(i) {
    return [i.MainPlaneAngle, i.SecondaryPlaneAngle, i.LuminousIntensity];
  },
  1566485204: function _(i) {
    return [i.LightDistributionCurve, i.DistributionData];
  },
  30780891: function _(i) {
    return [i.HourComponent, i.MinuteComponent, i.SecondComponent, i.Zone, i.DaylightSavingOffset];
  },
  1838606355: function _(i) {
    return [i.Name];
  },
  1847130766: function _(i) {
    return [i.MaterialClassifications, i.ClassifiedMaterial];
  },
  248100487: function _(i) {
    return [i.Material, i.LayerThickness, i.IsVentilated];
  },
  3303938423: function _(i) {
    return [i.MaterialLayers, i.LayerSetName];
  },
  1303795690: function _(i) {
    return [i.ForLayerSet, i.LayerSetDirection, i.DirectionSense, i.OffsetFromReferenceLine];
  },
  2199411900: function _(i) {
    return [i.Materials];
  },
  3265635763: function _(i) {
    return [i.Material];
  },
  2597039031: function _(i) {
    return [Labelise(i.ValueComponent), i.UnitComponent];
  },
  4256014907: function _(i) {
    return [i.Material, i.DynamicViscosity, i.YoungModulus, i.ShearModulus, i.PoissonRatio, i.ThermalExpansionCoefficient];
  },
  677618848: function _(i) {
    return [i.Material, i.DynamicViscosity, i.YoungModulus, i.ShearModulus, i.PoissonRatio, i.ThermalExpansionCoefficient, i.YieldStress, i.UltimateStress, i.UltimateStrain, i.HardeningModule, i.ProportionalStress, i.PlasticStrain, i.Relaxations];
  },
  3368373690: function _(i) {
    return [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.Benchmark, i.ValueSource, i.DataValue];
  },
  2706619895: function _(i) {
    return [i.Currency];
  },
  1918398963: function _(i) {
    return [i.Dimensions, i.UnitType];
  },
  3701648758: function _(_31) {
    return [];
  },
  2251480897: function _(i) {
    return [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.BenchmarkValues, i.ResultValues, i.ObjectiveQualifier, i.UserDefinedQualifier];
  },
  1227763645: function _(i) {
    return [i.Material, i.VisibleTransmittance, i.SolarTransmittance, i.ThermalIrTransmittance, i.ThermalIrEmissivityBack, i.ThermalIrEmissivityFront, i.VisibleReflectanceBack, i.VisibleReflectanceFront, i.SolarReflectanceFront, i.SolarReflectanceBack];
  },
  4251960020: function _(i) {
    return [i.Id, i.Name, i.Description, i.Roles, i.Addresses];
  },
  1411181986: function _(i) {
    return [i.Name, i.Description, i.RelatingOrganization, i.RelatedOrganizations];
  },
  1207048766: function _(i) {
    return [i.OwningUser, i.OwningApplication, i.State, i.ChangeAction, i.LastModifiedDate, i.LastModifyingUser, i.LastModifyingApplication, i.CreationDate];
  },
  2077209135: function _(i) {
    return [i.Id, i.FamilyName, i.GivenName, i.MiddleNames, i.PrefixTitles, i.SuffixTitles, i.Roles, i.Addresses];
  },
  101040310: function _(i) {
    return [i.ThePerson, i.TheOrganization, i.Roles];
  },
  2483315170: function _(i) {
    return [i.Name, i.Description];
  },
  2226359599: function _(i) {
    return [i.Name, i.Description, i.Unit];
  },
  3355820592: function _(i) {
    return [i.Purpose, i.Description, i.UserDefinedPurpose, i.InternalLocation, i.AddressLines, i.PostalBox, i.Town, i.Region, i.PostalCode, i.Country];
  },
  3727388367: function _(i) {
    return [i.Name];
  },
  990879717: function _(i) {
    return [i.Name];
  },
  3213052703: function _(i) {
    return [i.Name];
  },
  1775413392: function _(i) {
    return [i.Name];
  },
  2022622350: function _(i) {
    return [i.Name, i.Description, i.AssignedItems, i.Identifier];
  },
  1304840413: function _(i) {
    return [i.Name, i.Description, i.AssignedItems, i.Identifier, i.LayerOn, i.LayerFrozen, i.LayerBlocked, i.LayerStyles];
  },
  3119450353: function _(i) {
    return [i.Name];
  },
  2417041796: function _(i) {
    return [i.Styles];
  },
  2095639259: function _(i) {
    return [i.Name, i.Description, i.Representations];
  },
  2267347899: function _(i) {
    return [i.Material, i.SpecificHeatCapacity, i.N20Content, i.COContent, i.CO2Content];
  },
  3958567839: function _(i) {
    return [i.ProfileType, i.ProfileName];
  },
  2802850158: function _(i) {
    return [i.ProfileName, i.ProfileDefinition];
  },
  2598011224: function _(i) {
    return [i.Name, i.Description];
  },
  3896028662: function _(i) {
    return [i.RelatingConstraint, i.RelatedProperties, i.Name, i.Description];
  },
  148025276: function _(i) {
    return [i.DependingProperty, i.DependantProperty, i.Name, i.Description, i.Expression];
  },
  3710013099: function _(i) {
    return [i.Name, i.EnumerationValues.map(function (p) {
      return Labelise(p);
    }), i.Unit];
  },
  2044713172: function _(i) {
    return [i.Name, i.Description, i.Unit, i.AreaValue];
  },
  2093928680: function _(i) {
    return [i.Name, i.Description, i.Unit, i.CountValue];
  },
  931644368: function _(i) {
    return [i.Name, i.Description, i.Unit, i.LengthValue];
  },
  3252649465: function _(i) {
    return [i.Name, i.Description, i.Unit, i.TimeValue];
  },
  2405470396: function _(i) {
    return [i.Name, i.Description, i.Unit, i.VolumeValue];
  },
  825690147: function _(i) {
    return [i.Name, i.Description, i.Unit, i.WeightValue];
  },
  2692823254: function _(i) {
    return [i.ReferencedDocument, i.ReferencingValues, i.Name, i.Description];
  },
  1580146022: function _(i) {
    return [i.TotalCrossSectionArea, i.SteelGrade, i.BarSurface, i.EffectiveDepth, i.NominalBarDiameter, i.BarCount];
  },
  1222501353: function _(i) {
    return [i.RelaxationValue, i.InitialStress];
  },
  1076942058: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  3377609919: function _(i) {
    return [i.ContextIdentifier, i.ContextType];
  },
  3008791417: function _(_32) {
    return [];
  },
  1660063152: function _(i) {
    return [i.MappingOrigin, i.MappedRepresentation];
  },
  3679540991: function _(i) {
    return [i.ProfileName, i.ProfileDefinition, i.Thickness, i.RibHeight, i.RibWidth, i.RibSpacing, i.Direction];
  },
  2341007311: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  448429030: function _(i) {
    return [i.Dimensions, i.UnitType, i.Prefix, i.Name];
  },
  2042790032: function _(i) {
    return [i.SectionType, i.StartProfile, i.EndProfile];
  },
  4165799628: function _(i) {
    return [i.LongitudinalStartPosition, i.LongitudinalEndPosition, i.TransversePosition, i.ReinforcementRole, i.SectionDefinition, i.CrossSectionReinforcementDefinitions];
  },
  867548509: function _(i) {
    return [i.ShapeRepresentations, i.Name, i.Description, i.ProductDefinitional, i.PartOfProductDefinitionShape];
  },
  3982875396: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  4240577450: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  3692461612: function _(i) {
    return [i.Name, i.Description];
  },
  2273995522: function _(i) {
    return [i.Name];
  },
  2162789131: function _(i) {
    return [i.Name];
  },
  2525727697: function _(i) {
    return [i.Name];
  },
  3408363356: function _(i) {
    return [i.Name, i.DeltaT_Constant, i.DeltaT_Y, i.DeltaT_Z];
  },
  2830218821: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  3958052878: function _(i) {
    return [i.Item, i.Styles, i.Name];
  },
  3049322572: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  1300840506: function _(i) {
    return [i.Name, i.Side, i.Styles];
  },
  3303107099: function _(i) {
    return [i.DiffuseTransmissionColour, i.DiffuseReflectionColour, i.TransmissionColour, i.ReflectanceColour];
  },
  1607154358: function _(i) {
    return [i.RefractionIndex, i.DispersionFactor];
  },
  846575682: function _(i) {
    return [i.SurfaceColour];
  },
  1351298697: function _(i) {
    return [i.Textures];
  },
  626085974: function _(i) {
    return [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform];
  },
  1290481447: function _(i) {
    return [i.Name, Labelise(i.StyleOfSymbol)];
  },
  985171141: function _(i) {
    return [i.Name, i.Rows];
  },
  531007025: function _(i) {
    return [i.RowCells.map(function (p) {
      return Labelise(p);
    }), i.IsHeading];
  },
  912023232: function _(i) {
    return [i.Purpose, i.Description, i.UserDefinedPurpose, i.TelephoneNumbers, i.FacsimileNumbers, i.PagerNumber, i.ElectronicMailAddresses, i.WWWHomePageURL];
  },
  1447204868: function _(i) {
    return [i.Name, i.TextCharacterAppearance, i.TextStyle, i.TextFontStyle];
  },
  1983826977: function _(i) {
    return [i.Name, i.FontFamily, i.FontStyle, i.FontVariant, i.FontWeight, Labelise(i.FontSize)];
  },
  2636378356: function _(i) {
    return [i.Colour, i.BackgroundColour];
  },
  1640371178: function _(i) {
    return [!i.TextIndent ? null : Labelise(i.TextIndent), i.TextAlign, i.TextDecoration, !i.LetterSpacing ? null : Labelise(i.LetterSpacing), !i.WordSpacing ? null : Labelise(i.WordSpacing), i.TextTransform, !i.LineHeight ? null : Labelise(i.LineHeight)];
  },
  1484833681: function _(i) {
    return [i.BoxHeight, i.BoxWidth, i.BoxSlantAngle, i.BoxRotateAngle, !i.CharacterSpacing ? null : Labelise(i.CharacterSpacing)];
  },
  280115917: function _(_33) {
    return [];
  },
  1742049831: function _(i) {
    return [i.Mode, i.Parameter.map(function (p) {
      return Labelise(p);
    })];
  },
  2552916305: function _(i) {
    return [i.TextureMaps];
  },
  1210645708: function _(i) {
    return [i.Coordinates];
  },
  3317419933: function _(i) {
    return [i.Material, i.SpecificHeatCapacity, i.BoilingPoint, i.FreezingPoint, i.ThermalConductivity];
  },
  3101149627: function _(i) {
    return [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit];
  },
  1718945513: function _(i) {
    return [i.ReferencedTimeSeries, i.TimeSeriesReferences];
  },
  581633288: function _(i) {
    return [i.ListValues.map(function (p) {
      return Labelise(p);
    })];
  },
  1377556343: function _(_34) {
    return [];
  },
  1735638870: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  180925521: function _(i) {
    return [i.Units];
  },
  2799835756: function _(_35) {
    return [];
  },
  3304826586: function _(i) {
    return [i.TextureVertices, i.TexturePoints];
  },
  1907098498: function _(i) {
    return [i.VertexGeometry];
  },
  891718957: function _(i) {
    return [i.IntersectingAxes, i.OffsetDistances];
  },
  1065908215: function _(i) {
    return [i.Material, i.IsPotable, i.Hardness, i.AlkalinityConcentration, i.AcidityConcentration, i.ImpuritiesContent, i.PHLevel, i.DissolvedSolidsContent];
  },
  2442683028: function _(i) {
    return [i.Item, i.Styles, i.Name];
  },
  962685235: function _(i) {
    return [i.Item, i.Styles, i.Name];
  },
  3612888222: function _(i) {
    return [i.Item, i.Styles, i.Name];
  },
  2297822566: function _(i) {
    return [i.Item, i.Styles, i.Name];
  },
  3798115385: function _(i) {
    return [i.ProfileType, i.ProfileName, i.OuterCurve];
  },
  1310608509: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Curve];
  },
  2705031697: function _(i) {
    return [i.ProfileType, i.ProfileName, i.OuterCurve, i.InnerCurves];
  },
  616511568: function _(i) {
    return [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform, i.RasterFormat, i.RasterCode];
  },
  3150382593: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Curve, i.Thickness];
  },
  647927063: function _(i) {
    return [i.Location, i.ItemReference, i.Name, i.ReferencedSource];
  },
  776857604: function _(i) {
    return [i.Name, i.Red, i.Green, i.Blue];
  },
  2542286263: function _(i) {
    return [i.Name, i.Description, i.UsageName, i.HasProperties];
  },
  1485152156: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Profiles, i.Label];
  },
  370225590: function _(i) {
    return [i.CfsFaces];
  },
  1981873012: function _(i) {
    return [i.CurveOnRelatingElement, i.CurveOnRelatedElement];
  },
  45288368: function _(i) {
    return [i.PointOnRelatingElement, i.PointOnRelatedElement, i.EccentricityInX, i.EccentricityInY, i.EccentricityInZ];
  },
  3050246964: function _(i) {
    return [i.Dimensions, i.UnitType, i.Name];
  },
  2889183280: function _(i) {
    return [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor];
  },
  3800577675: function _(i) {
    return [i.Name, i.CurveFont, !i.CurveWidth ? null : Labelise(i.CurveWidth), i.CurveColour];
  },
  3632507154: function _(i) {
    return [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label];
  },
  2273265877: function _(i) {
    return [i.Name, i.Description, i.RelatingDraughtingCallout, i.RelatedDraughtingCallout];
  },
  1694125774: function _(i) {
    return [i.Name, i.Description, i.RelatingDraughtingCallout, i.RelatedDraughtingCallout];
  },
  3732053477: function _(i) {
    return [i.Location, i.ItemReference, i.Name];
  },
  4170525392: function _(i) {
    return [i.Name];
  },
  3900360178: function _(i) {
    return [i.EdgeStart, i.EdgeEnd];
  },
  476780140: function _(i) {
    return [i.EdgeStart, i.EdgeEnd, i.EdgeGeometry, i.SameSense];
  },
  1860660968: function _(i) {
    return [i.Material, i.ExtendedProperties, i.Description, i.Name];
  },
  2556980723: function _(i) {
    return [i.Bounds];
  },
  1809719519: function _(i) {
    return [i.Bound, i.Orientation];
  },
  803316827: function _(i) {
    return [i.Bound, i.Orientation];
  },
  3008276851: function _(i) {
    return [i.Bounds, i.FaceSurface, i.SameSense];
  },
  4219587988: function _(i) {
    return [i.Name, i.TensionFailureX, i.TensionFailureY, i.TensionFailureZ, i.CompressionFailureX, i.CompressionFailureY, i.CompressionFailureZ];
  },
  738692330: function _(i) {
    return [i.Name, i.FillStyles];
  },
  3857492461: function _(i) {
    return [i.Material, i.CombustionTemperature, i.CarbonContent, i.LowerHeatingValue, i.HigherHeatingValue];
  },
  803998398: function _(i) {
    return [i.Material, i.MolecularWeight, i.Porosity, i.MassDensity];
  },
  1446786286: function _(i) {
    return [i.ProfileName, i.ProfileDefinition, i.PhysicalWeight, i.Perimeter, i.MinimumPlateThickness, i.MaximumPlateThickness, i.CrossSectionArea];
  },
  3448662350: function _(i) {
    return [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth];
  },
  2453401579: function _(_36) {
    return [];
  },
  4142052618: function _(i) {
    return [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth, i.ParentContext, i.TargetScale, i.TargetView, i.UserDefinedTargetView];
  },
  3590301190: function _(i) {
    return [i.Elements];
  },
  178086475: function _(i) {
    return [i.PlacementLocation, i.PlacementRefDirection];
  },
  812098782: function _(i) {
    return [i.BaseSurface, i.AgreementFlag];
  },
  2445078500: function _(i) {
    return [i.Material, i.UpperVaporResistanceFactor, i.LowerVaporResistanceFactor, i.IsothermalMoistureCapacity, i.VaporPermeability, i.MoistureDiffusivity];
  },
  3905492369: function _(i) {
    return [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform, i.UrlReference];
  },
  3741457305: function _(i) {
    return [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.Values];
  },
  1402838566: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity];
  },
  125510826: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity];
  },
  2604431987: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Orientation];
  },
  4266656042: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.ColourAppearance, i.ColourTemperature, i.LuminousFlux, i.LightEmissionSource, i.LightDistributionDataSource];
  },
  1520743889: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation];
  },
  3422422726: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation, i.Orientation, i.ConcentrationExponent, i.SpreadAngle, i.BeamWidthAngle];
  },
  2624227202: function _(i) {
    return [i.PlacementRelTo, i.RelativePlacement];
  },
  1008929658: function _(_37) {
    return [];
  },
  2347385850: function _(i) {
    return [i.MappingSource, i.MappingTarget];
  },
  2022407955: function _(i) {
    return [i.Name, i.Description, i.Representations, i.RepresentedMaterial];
  },
  1430189142: function _(i) {
    return [i.Material, i.DynamicViscosity, i.YoungModulus, i.ShearModulus, i.PoissonRatio, i.ThermalExpansionCoefficient, i.CompressiveStrength, i.MaxAggregateSize, i.AdmixturesDescription, i.Workability, i.ProtectivePoreRatio, i.WaterImpermeability];
  },
  219451334: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  2833995503: function _(i) {
    return [i.RepeatFactor];
  },
  2665983363: function _(i) {
    return [i.CfsFaces];
  },
  1029017970: function _(i) {
    return [i.EdgeStart, i.EdgeEnd, i.EdgeElement, i.Orientation];
  },
  2529465313: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position];
  },
  2519244187: function _(i) {
    return [i.EdgeList];
  },
  3021840470: function _(i) {
    return [i.Name, i.Description, i.HasQuantities, i.Discrimination, i.Quality, i.Usage];
  },
  597895409: function _(i) {
    return [i.RepeatS, i.RepeatT, i.TextureType, i.TextureTransform, i.Width, i.Height, i.ColourComponents, i.Pixel];
  },
  2004835150: function _(i) {
    return [i.Location];
  },
  1663979128: function _(i) {
    return [i.SizeInX, i.SizeInY];
  },
  2067069095: function _(_38) {
    return [];
  },
  4022376103: function _(i) {
    return [i.BasisCurve, i.PointParameter];
  },
  1423911732: function _(i) {
    return [i.BasisSurface, i.PointParameterU, i.PointParameterV];
  },
  2924175390: function _(i) {
    return [i.Polygon];
  },
  2775532180: function _(i) {
    return [i.BaseSurface, i.AgreementFlag, i.Position, i.PolygonalBoundary];
  },
  759155922: function _(i) {
    return [i.Name];
  },
  2559016684: function _(i) {
    return [i.Name];
  },
  433424934: function _(i) {
    return [i.Name];
  },
  179317114: function _(i) {
    return [i.Name];
  },
  673634403: function _(i) {
    return [i.Name, i.Description, i.Representations];
  },
  871118103: function _(i) {
    return [i.Name, i.Description, !i.UpperBoundValue ? null : Labelise(i.UpperBoundValue), !i.LowerBoundValue ? null : Labelise(i.LowerBoundValue), i.Unit];
  },
  1680319473: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  4166981789: function _(i) {
    return [i.Name, i.Description, i.EnumerationValues.map(function (p) {
      return Labelise(p);
    }), i.EnumerationReference];
  },
  2752243245: function _(i) {
    return [i.Name, i.Description, i.ListValues.map(function (p) {
      return Labelise(p);
    }), i.Unit];
  },
  941946838: function _(i) {
    return [i.Name, i.Description, i.UsageName, i.PropertyReference];
  },
  3357820518: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  3650150729: function _(i) {
    return [i.Name, i.Description, !i.NominalValue ? null : Labelise(i.NominalValue), i.Unit];
  },
  110355661: function _(i) {
    return [i.Name, i.Description, i.DefiningValues.map(function (p) {
      return Labelise(p);
    }), i.DefinedValues.map(function (p) {
      return Labelise(p);
    }), i.Expression, i.DefiningUnit, i.DefinedUnit];
  },
  3615266464: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim];
  },
  3413951693: function _(i) {
    return [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.TimeStep, i.Values];
  },
  3765753017: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DefinitionType, i.ReinforcementSectionDefinitions];
  },
  478536968: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  2778083089: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.RoundingRadius];
  },
  1509187699: function _(i) {
    return [i.SpineCurve, i.CrossSections, i.CrossSectionPositions];
  },
  2411513650: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PredefinedType, !i.UpperValue ? null : Labelise(i.UpperValue), Labelise(i.MostUsedValue), !i.LowerValue ? null : Labelise(i.LowerValue)];
  },
  4124623270: function _(i) {
    return [i.SbsmBoundary];
  },
  2609359061: function _(i) {
    return [i.Name, i.SlippageX, i.SlippageY, i.SlippageZ];
  },
  723233188: function _(_39) {
    return [];
  },
  2485662743: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.IsAttenuating, i.SoundScale, i.SoundValues];
  },
  1202362311: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.SoundLevelTimeSeries, i.Frequency, !i.SoundLevelSingleValue ? null : Labelise(i.SoundLevelSingleValue)];
  },
  390701378: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableValueRatio, i.ThermalLoadSource, i.PropertySource, i.SourceDescription, i.MaximumValue, i.MinimumValue, i.ThermalLoadTimeSeriesValues, i.UserDefinedThermalLoadSource, i.UserDefinedPropertySource, i.ThermalLoadType];
  },
  1595516126: function _(i) {
    return [i.Name, i.LinearForceX, i.LinearForceY, i.LinearForceZ, i.LinearMomentX, i.LinearMomentY, i.LinearMomentZ];
  },
  2668620305: function _(i) {
    return [i.Name, i.PlanarForceX, i.PlanarForceY, i.PlanarForceZ];
  },
  2473145415: function _(i) {
    return [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ];
  },
  1973038258: function _(i) {
    return [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ, i.Distortion];
  },
  1597423693: function _(i) {
    return [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ];
  },
  1190533807: function _(i) {
    return [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ, i.WarpingMoment];
  },
  3843319758: function _(i) {
    return [i.ProfileName, i.ProfileDefinition, i.PhysicalWeight, i.Perimeter, i.MinimumPlateThickness, i.MaximumPlateThickness, i.CrossSectionArea, i.TorsionalConstantX, i.MomentOfInertiaYZ, i.MomentOfInertiaY, i.MomentOfInertiaZ, i.WarpingConstant, i.ShearCentreZ, i.ShearCentreY, i.ShearDeformationAreaZ, i.ShearDeformationAreaY, i.MaximumSectionModulusY, i.MinimumSectionModulusY, i.MaximumSectionModulusZ, i.MinimumSectionModulusZ, i.TorsionalSectionModulus, i.CentreOfGravityInX, i.CentreOfGravityInY];
  },
  3653947884: function _(i) {
    return [i.ProfileName, i.ProfileDefinition, i.PhysicalWeight, i.Perimeter, i.MinimumPlateThickness, i.MaximumPlateThickness, i.CrossSectionArea, i.TorsionalConstantX, i.MomentOfInertiaYZ, i.MomentOfInertiaY, i.MomentOfInertiaZ, i.WarpingConstant, i.ShearCentreZ, i.ShearCentreY, i.ShearDeformationAreaZ, i.ShearDeformationAreaY, i.MaximumSectionModulusY, i.MinimumSectionModulusY, i.MaximumSectionModulusZ, i.MinimumSectionModulusZ, i.TorsionalSectionModulus, i.CentreOfGravityInX, i.CentreOfGravityInY, i.ShearAreaZ, i.ShearAreaY, i.PlasticShapeFactorY, i.PlasticShapeFactorZ];
  },
  2233826070: function _(i) {
    return [i.EdgeStart, i.EdgeEnd, i.ParentEdge];
  },
  2513912981: function _(_40) {
    return [];
  },
  1878645084: function _(i) {
    return [i.SurfaceColour, i.Transparency, i.DiffuseColour, i.TransmissionColour, i.DiffuseTransmissionColour, i.ReflectionColour, i.SpecularColour, !i.SpecularHighlight ? null : Labelise(i.SpecularHighlight), i.ReflectanceMethod];
  },
  2247615214: function _(i) {
    return [i.SweptArea, i.Position];
  },
  1260650574: function _(i) {
    return [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam];
  },
  230924584: function _(i) {
    return [i.SweptCurve, i.Position];
  },
  3071757647: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.WebEdgeRadius, i.WebSlope, i.FlangeSlope, i.CentreOfGravityInY];
  },
  3028897424: function _(i) {
    return [i.Item, i.Styles, i.Name, i.AnnotatedCurve];
  },
  4282788508: function _(i) {
    return [i.Literal, i.Placement, i.Path];
  },
  3124975700: function _(i) {
    return [i.Literal, i.Placement, i.Path, i.Extent, i.BoxAlignment];
  },
  2715220739: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.BottomXDim, i.TopXDim, i.YDim, i.TopXOffset];
  },
  1345879162: function _(i) {
    return [i.RepeatFactor, i.SecondRepeatFactor];
  },
  1628702193: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets];
  },
  2347495698: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag];
  },
  427810014: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius, i.FlangeSlope, i.CentreOfGravityInX];
  },
  1417489154: function _(i) {
    return [i.Orientation, i.Magnitude];
  },
  2759199220: function _(i) {
    return [i.LoopVertex];
  },
  336235671: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.TransomThickness, i.MullionThickness, i.FirstTransomOffset, i.SecondTransomOffset, i.FirstMullionOffset, i.SecondMullionOffset, i.ShapeAspectStyle];
  },
  512836454: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle];
  },
  1299126871: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ConstructionType, i.OperationType, i.ParameterTakesPrecedence, i.Sizeable];
  },
  2543172580: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius];
  },
  3288037868: function _(i) {
    return [i.Item, i.Styles, i.Name];
  },
  669184980: function _(i) {
    return [i.OuterBoundary, i.InnerBoundaries];
  },
  2265737646: function _(i) {
    return [i.Item, i.Styles, i.Name, i.FillStyleTarget, i.GlobalOrLocal];
  },
  1302238472: function _(i) {
    return [i.Item, i.TextureCoordinates];
  },
  4261334040: function _(i) {
    return [i.Location, i.Axis];
  },
  3125803723: function _(i) {
    return [i.Location, i.RefDirection];
  },
  2740243338: function _(i) {
    return [i.Location, i.Axis, i.RefDirection];
  },
  2736907675: function _(i) {
    return [i.Operator, i.FirstOperand, i.SecondOperand];
  },
  4182860854: function _(_41) {
    return [];
  },
  2581212453: function _(i) {
    return [i.Corner, i.XDim, i.YDim, i.ZDim];
  },
  2713105998: function _(i) {
    return [i.BaseSurface, i.AgreementFlag, i.Enclosure];
  },
  2898889636: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.WallThickness, i.Girth, i.InternalFilletRadius, i.CentreOfGravityInX];
  },
  1123145078: function _(i) {
    return [i.Coordinates];
  },
  59481748: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale];
  },
  3749851601: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale];
  },
  3486308946: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Scale2];
  },
  3331915920: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3];
  },
  1416205885: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3, i.Scale2, i.Scale3];
  },
  1383045692: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Radius];
  },
  2205249479: function _(i) {
    return [i.CfsFaces];
  },
  2485617015: function _(i) {
    return [i.Transition, i.SameSense, i.ParentCurve];
  },
  4133800736: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.OverallHeight, i.BaseWidth2, i.Radius, i.HeadWidth, i.HeadDepth2, i.HeadDepth3, i.WebThickness, i.BaseWidth4, i.BaseDepth1, i.BaseDepth2, i.BaseDepth3, i.CentreOfGravityInY];
  },
  194851669: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.OverallHeight, i.HeadWidth, i.Radius, i.HeadDepth2, i.HeadDepth3, i.WebThickness, i.BaseDepth1, i.BaseDepth2, i.CentreOfGravityInY];
  },
  2506170314: function _(i) {
    return [i.Position];
  },
  2147822146: function _(i) {
    return [i.TreeRootExpression];
  },
  2601014836: function _(_42) {
    return [];
  },
  2827736869: function _(i) {
    return [i.BasisSurface, i.OuterBoundary, i.InnerBoundaries];
  },
  693772133: function _(i) {
    return [i.Definition, i.Target];
  },
  606661476: function _(i) {
    return [i.Item, i.Styles, i.Name];
  },
  4054601972: function _(i) {
    return [i.Item, i.Styles, i.Name, i.AnnotatedCurve, i.Role];
  },
  32440307: function _(i) {
    return [i.DirectionRatios];
  },
  2963535650: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.ThresholdDepth, i.ThresholdThickness, i.TransomThickness, i.TransomOffset, i.LiningOffset, i.ThresholdOffset, i.CasingThickness, i.CasingDepth, i.ShapeAspectStyle];
  },
  1714330368: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PanelDepth, i.PanelOperation, i.PanelWidth, i.PanelPosition, i.ShapeAspectStyle];
  },
  526551008: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.OperationType, i.ConstructionType, i.ParameterTakesPrecedence, i.Sizeable];
  },
  3073041342: function _(i) {
    return [i.Contents];
  },
  445594917: function _(i) {
    return [i.Name];
  },
  4006246654: function _(i) {
    return [i.Name];
  },
  1472233963: function _(i) {
    return [i.EdgeList];
  },
  1883228015: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.MethodOfMeasurement, i.Quantities];
  },
  339256511: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2777663545: function _(i) {
    return [i.Position];
  },
  2835456948: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.SemiAxis1, i.SemiAxis2];
  },
  80994333: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.EnergySequence, i.UserDefinedEnergySequence];
  },
  477187591: function _(i) {
    return [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth];
  },
  2047409740: function _(i) {
    return [i.FbsmFaces];
  },
  374418227: function _(i) {
    return [i.HatchLineAppearance, i.StartOfNextHatchLine, i.PointOfReferenceHatchLine, i.PatternStart, i.HatchLineAngle];
  },
  4203026998: function _(i) {
    return [i.Symbol];
  },
  315944413: function _(i) {
    return [i.TilingPattern, i.Tiles, i.TilingScale];
  },
  3455213021: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PropertySource, i.FlowConditionTimeSeries, i.VelocityTimeSeries, i.FlowrateTimeSeries, i.Fluid, i.PressureTimeSeries, i.UserDefinedPropertySource, i.TemperatureSingleValue, i.WetBulbTemperatureSingleValue, i.WetBulbTemperatureTimeSeries, i.TemperatureTimeSeries, !i.FlowrateSingleValue ? null : Labelise(i.FlowrateSingleValue), i.FlowConditionSingleValue, i.VelocitySingleValue, i.PressureSingleValue];
  },
  4238390223: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1268542332: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.AssemblyPlace];
  },
  987898635: function _(i) {
    return [i.Elements];
  },
  1484403080: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius];
  },
  572779678: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.Thickness, i.FilletRadius, i.EdgeRadius, i.LegSlope, i.CentreOfGravityInX, i.CentreOfGravityInY];
  },
  1281925730: function _(i) {
    return [i.Pnt, i.Dir];
  },
  1425443689: function _(i) {
    return [i.Outer];
  },
  3888040117: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  3388369263: function _(i) {
    return [i.BasisCurve, i.Distance, i.SelfIntersect];
  },
  3505215534: function _(i) {
    return [i.BasisCurve, i.Distance, i.SelfIntersect, i.RefDirection];
  },
  3566463478: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle];
  },
  603570806: function _(i) {
    return [i.SizeInX, i.SizeInY, i.Placement];
  },
  220341763: function _(i) {
    return [i.Position];
  },
  2945172077: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  4208778838: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  103090709: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext];
  },
  4194566429: function _(i) {
    return [i.Item, i.Styles, i.Name];
  },
  1451395588: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.HasProperties];
  },
  3219374653: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.ProxyType, i.Tag];
  },
  2770003689: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.WallThickness, i.InnerFilletRadius, i.OuterFilletRadius];
  },
  2798486643: function _(i) {
    return [i.Position, i.XLength, i.YLength, i.Height];
  },
  3454111270: function _(i) {
    return [i.BasisSurface, i.U1, i.V1, i.U2, i.V2, i.Usense, i.Vsense];
  },
  3939117080: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType];
  },
  1683148259: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole];
  },
  2495723537: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl];
  },
  1307041759: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup];
  },
  4278684876: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProcess, i.QuantityInProcess];
  },
  2857406711: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProduct];
  },
  3372526763: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl];
  },
  205026976: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingResource];
  },
  1865459582: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects];
  },
  1327628568: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingAppliedValue];
  },
  4095574036: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingApproval];
  },
  919958153: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingClassification];
  },
  2728634034: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.Intent, i.RelatingConstraint];
  },
  982818633: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingDocument];
  },
  3840914261: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingLibrary];
  },
  2655215786: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingMaterial];
  },
  2851387026: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingProfileProperties, i.ProfileSectionLocation, i.ProfileOrientation];
  },
  826625072: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  1204542856: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement];
  },
  3945020480: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RelatingPriorities, i.RelatedPriorities, i.RelatedConnectionType, i.RelatingConnectionType];
  },
  4201705270: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedElement];
  },
  3190031847: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedPort, i.RealizingElement];
  },
  2127690289: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralActivity];
  },
  3912681535: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralMember];
  },
  1638771189: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem];
  },
  504942748: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem, i.ConnectionConstraint];
  },
  3678494232: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RealizingElements, i.ConnectionType];
  },
  3242617779: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure];
  },
  886880790: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedCoverings];
  },
  2802773753: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedSpace, i.RelatedCoverings];
  },
  2551354335: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects];
  },
  693640335: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects];
  },
  4186316022: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition];
  },
  781010003: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingType];
  },
  3940055652: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingOpeningElement, i.RelatedBuildingElement];
  },
  279856033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedControlElements, i.RelatingFlowElement];
  },
  4189434867: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DailyInteraction, i.ImportanceRating, i.LocationOfInteraction, i.RelatedSpaceProgram, i.RelatingSpaceProgram];
  },
  3268803585: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects];
  },
  2051452291: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole];
  },
  202636808: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition, i.OverridingProperties];
  },
  750771296: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedFeatureElement];
  },
  1245217292: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure];
  },
  1058617721: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl];
  },
  4122056220: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingProcess, i.RelatedProcess, i.TimeLag, i.SequenceType];
  },
  366585022: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSystem, i.RelatedBuildings];
  },
  3451746338: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary];
  },
  1401173127: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedOpeningElement];
  },
  2914609552: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  1856042241: function _(i) {
    return [i.SweptArea, i.Position, i.Axis, i.Angle];
  },
  4158566097: function _(i) {
    return [i.Position, i.Height, i.BottomRadius];
  },
  3626867408: function _(i) {
    return [i.Position, i.Height, i.Radius];
  },
  2706606064: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType];
  },
  3893378262: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  451544542: function _(i) {
    return [i.Position, i.Radius];
  },
  3544373492: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal];
  },
  3136571912: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  530289379: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  3689010777: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal];
  },
  3979015343: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness];
  },
  2218152070: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness, i.SubsequentThickness, i.VaryingThicknessLocation];
  },
  4070609034: function _(i) {
    return [i.Contents];
  },
  2028607225: function _(i) {
    return [i.SweptArea, i.Position, i.Directrix, i.StartParam, i.EndParam, i.ReferenceSurface];
  },
  2809605785: function _(i) {
    return [i.SweptCurve, i.Position, i.ExtrudedDirection, i.Depth];
  },
  4124788165: function _(i) {
    return [i.SweptCurve, i.Position, i.AxisPosition];
  },
  1580310250: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3473067441: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TaskId, i.Status, i.WorkMethod, i.IsMilestone, i.Priority];
  },
  2097647324: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2296667514: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor];
  },
  1674181508: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  3207858831: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.TopFlangeWidth, i.TopFlangeThickness, i.TopFlangeFilletRadius, i.CentreOfGravityInY];
  },
  1334484129: function _(i) {
    return [i.Position, i.XLength, i.YLength, i.ZLength];
  },
  3649129432: function _(i) {
    return [i.Operator, i.FirstOperand, i.SecondOperand];
  },
  1260505505: function _(_43) {
    return [];
  },
  4031249490: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.ElevationOfRefHeight, i.ElevationOfTerrain, i.BuildingAddress];
  },
  1950629157: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3124254112: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.Elevation];
  },
  2937912522: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Radius, i.WallThickness];
  },
  300633059: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3732776249: function _(i) {
    return [i.Segments, i.SelfIntersect];
  },
  2510884976: function _(i) {
    return [i.Position];
  },
  2559216714: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity];
  },
  3293443760: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  3895139033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  1419761937: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.SubmittedBy, i.PreparedBy, i.SubmittedOn, i.Status, i.TargetUsers, i.UpdateDate, i.ID, i.PredefinedType];
  },
  1916426348: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3295246426: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity];
  },
  1457835157: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  681481545: function _(i) {
    return [i.Contents];
  },
  3256556792: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3849074793: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  360485395: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.EnergySequence, i.UserDefinedEnergySequence, i.ElectricCurrentType, i.InputVoltage, i.InputFrequency, i.FullLoadCurrent, i.MinimumCircuitCurrent, i.MaximumPowerInput, i.RatedPowerInput, i.InputPhase];
  },
  1758889154: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  4123344466: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.AssemblyPlace, i.PredefinedType];
  },
  1623761950: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2590856083: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1704287377: function _(i) {
    return [i.Position, i.SemiAxis1, i.SemiAxis2];
  },
  2107101300: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1962604670: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3272907226: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  3174744832: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3390157468: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  807026263: function _(i) {
    return [i.Outer];
  },
  3737207727: function _(i) {
    return [i.Outer, i.Voids];
  },
  647756555: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2489546625: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2827207264: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2143335405: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1287392070: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3907093117: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3198132628: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3815607619: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1482959167: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1834744321: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1339347760: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2297155007: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3009222698: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  263784265: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  814719939: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  200128114: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3009204131: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.UAxes, i.VAxes, i.WAxes];
  },
  2706460486: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  1251058090: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1806887404: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2391368822: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.InventoryType, i.Jurisdiction, i.ResponsiblePersons, i.LastUpdateDate, i.CurrentValue, i.OriginalValue];
  },
  4288270099: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3827777499: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity, i.SkillSet];
  },
  1051575348: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1161773419: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2506943328: function _(i) {
    return [i.Contents];
  },
  377706215: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NominalDiameter, i.NominalLength];
  },
  2108223431: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3181161470: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  977012517: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1916936684: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TaskId, i.Status, i.WorkMethod, i.IsMilestone, i.Priority, i.MoveFrom, i.MoveTo, i.PunchList];
  },
  4143007308: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor, i.PredefinedType];
  },
  3588315303: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3425660407: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TaskId, i.Status, i.WorkMethod, i.IsMilestone, i.Priority, i.ActionID];
  },
  2837617999: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2382730787: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LifeCyclePhase];
  },
  3327091369: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PermitID];
  },
  804291784: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4231323485: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4017108033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3724593414: function _(i) {
    return [i.Points];
  },
  3740093272: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  2744685151: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ProcedureID, i.ProcedureType, i.UserDefinedProcedureType];
  },
  2904328755: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ID, i.PredefinedType, i.Status];
  },
  3642467123: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Records, i.PredefinedType];
  },
  3651124850: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1842657554: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2250791053: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3248260540: function _(i) {
    return [i.Contents];
  },
  2893384427: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2324767716: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  160246688: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects];
  },
  2863920197: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl, i.TimeForTask];
  },
  1768891740: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3517283431: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ActualStart, i.EarlyStart, i.LateStart, i.ScheduleStart, i.ActualFinish, i.EarlyFinish, i.LateFinish, i.ScheduleFinish, i.ScheduleDuration, i.ActualDuration, i.RemainingTime, i.FreeFloat, i.TotalFloat, i.IsCritical, i.StatusTime, i.StartFloat, i.FinishFloat, i.Completion];
  },
  4105383287: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ServiceLifeType, i.ServiceLifeDuration];
  },
  4097777520: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.RefLatitude, i.RefLongitude, i.RefElevation, i.LandTitleNumber, i.SiteAddress];
  },
  2533589738: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3856911033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.InteriorOrExteriorSpace, i.ElevationWithFlooring];
  },
  1305183839: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  652456506: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.SpaceProgramIdentifier, i.MaxRequiredArea, i.MinRequiredArea, i.RequestedLocation, i.StandardRequiredArea];
  },
  3812236995: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3112655638: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1039846685: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  682877961: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy];
  },
  1179482911: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition];
  },
  4243806635: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition];
  },
  214636428: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType];
  },
  2445595289: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType];
  },
  1807405624: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue];
  },
  1721250024: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue, i.VaryingAppliedLoadLocation, i.SubsequentAppliedLoads];
  },
  1252848954: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose];
  },
  1621171031: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue];
  },
  3987759626: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy, i.ProjectedOrTrue, i.VaryingAppliedLoadLocation, i.SubsequentAppliedLoads];
  },
  2082059205: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.CausedBy];
  },
  734778138: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition];
  },
  1235345126: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal];
  },
  2986769608: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheoryType, i.ResultForLoadGroup, i.IsLinear];
  },
  1975003073: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition];
  },
  148013059: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity, i.SubContractor, i.JobDescription];
  },
  2315554128: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2254336722: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  5716631: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1637806684: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ApplicableDates, i.TimeSeriesScheduleType, i.TimeSeries];
  },
  1692211062: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1620046519: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OperationType, i.CapacityByWeight, i.CapacityByNumber];
  },
  3593883385: function _(i) {
    return [i.BasisCurve, i.Trim1, i.Trim2, i.SenseAgreement, i.MasterRepresentation];
  },
  1600972822: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1911125066: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  728799441: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2769231204: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1898987631: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1133259667: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1028945134: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identifier, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.WorkControlType, i.UserDefinedControlType];
  },
  4218914973: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identifier, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.WorkControlType, i.UserDefinedControlType];
  },
  3342526732: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identifier, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.WorkControlType, i.UserDefinedControlType];
  },
  1033361043: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  1213861670: function _(i) {
    return [i.Segments, i.SelfIntersect];
  },
  3821786052: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.RequestID];
  },
  1411407467: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3352864051: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1871374353: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2470393545: function _(i) {
    return [i.Contents];
  },
  3460190687: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.AssetID, i.OriginalValue, i.CurrentValue, i.TotalReplacementCost, i.Owner, i.User, i.ResponsiblePerson, i.IncorporationDate, i.DepreciatedValue];
  },
  1967976161: function _(i) {
    return [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect];
  },
  819618141: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1916977116: function _(i) {
    return [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect];
  },
  231477066: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3299480353: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  52481810: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2979338954: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1095909175: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.CompositionType];
  },
  1909888760: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  395041908: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3293546465: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1285652485: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2951183804: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2611217952: function _(i) {
    return [i.Position, i.Radius];
  },
  2301859152: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  843113511: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3850581409: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2816379211: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2188551683: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  1163958913: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Criterion, i.CriterionDateTime];
  },
  3898045240: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity];
  },
  1060000209: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity, i.Suppliers, i.UsageRatio];
  },
  488727124: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ResourceIdentifier, i.ResourceGroup, i.ResourceConsumption, i.BaseQuantity];
  },
  335055490: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2954562838: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1973544240: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3495092785: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3961806047: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4147604152: function _(i) {
    return [i.Contents];
  },
  1335981549: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2635815018: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1599208980: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2063403501: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1945004755: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3040386961: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3041715199: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.FlowDirection];
  },
  395920057: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth];
  },
  869906466: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3760055223: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2030761528: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  855621170: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.FeatureLength];
  },
  663422040: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3277789161: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1534661035: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1365060375: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1217240411: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  712377611: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1634875225: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  857184966: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1658829314: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  346874300: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1810631287: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4222183408: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2058353004: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  4278956645: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  4037862832: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3132237377: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  987401354: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  707683696: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2223149337: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3508470533: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  900683007: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1073191201: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1687234759: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType, i.ConstructionType];
  },
  3171933400: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2262370178: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3024970846: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ShapeType];
  },
  3283111854: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3055160366: function _(i) {
    return [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect, i.WeightsData];
  },
  3027567501: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade];
  },
  2320036040: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing];
  },
  2016517767: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ShapeType];
  },
  1376911519: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.FeatureLength, i.Radius];
  },
  1783015770: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1529196076: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  331165859: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ShapeType];
  },
  4252922144: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NumberOfRiser, i.NumberOfTreads, i.RiserHeight, i.TreadLength];
  },
  2515109513: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.OrientationOf2DPlane, i.LoadedBy, i.HasResults];
  },
  3824725483: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.TensionForce, i.PreStress, i.FrictionCoefficient, i.AnchorageSlip, i.MinCurvatureRadius];
  },
  2347447852: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade];
  },
  3313531582: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2391406946: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3512223829: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3304561284: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth];
  },
  2874132201: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3001207471: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  753842376: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2454782716: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.FeatureLength, i.Width, i.Height];
  },
  578613899: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1052013943: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1062813311: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.ControlElementId];
  },
  3700593921: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.DistributionPointFunction, i.UserDefinedFunction];
  },
  979691226: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.BarRole, i.BarSurface];
  }
};
TypeInitialisers[1] = {
  3699917729: function _(v) {
    return new IFC2X3.IfcAbsorbedDoseMeasure(v);
  },
  4182062534: function _(v) {
    return new IFC2X3.IfcAccelerationMeasure(v);
  },
  360377573: function _(v) {
    return new IFC2X3.IfcAmountOfSubstanceMeasure(v);
  },
  632304761: function _(v) {
    return new IFC2X3.IfcAngularVelocityMeasure(v);
  },
  2650437152: function _(v) {
    return new IFC2X3.IfcAreaMeasure(v);
  },
  2735952531: function _(v) {
    return new IFC2X3.IfcBoolean(v);
  },
  1867003952: function _(v) {
    return new IFC2X3.IfcBoxAlignment(v);
  },
  2991860651: function _(v) {
    return new IFC2X3.IfcComplexNumber(v);
  },
  3812528620: function _(v) {
    return new IFC2X3.IfcCompoundPlaneAngleMeasure(v);
  },
  3238673880: function _(v) {
    return new IFC2X3.IfcContextDependentMeasure(v);
  },
  1778710042: function _(v) {
    return new IFC2X3.IfcCountMeasure(v);
  },
  94842927: function _(v) {
    return new IFC2X3.IfcCurvatureMeasure(v);
  },
  86635668: function _(v) {
    return new IFC2X3.IfcDayInMonthNumber(v);
  },
  300323983: function _(v) {
    return new IFC2X3.IfcDaylightSavingHour(v);
  },
  1514641115: function _(v) {
    return new IFC2X3.IfcDescriptiveMeasure(v);
  },
  4134073009: function _(v) {
    return new IFC2X3.IfcDimensionCount(v);
  },
  524656162: function _(v) {
    return new IFC2X3.IfcDoseEquivalentMeasure(v);
  },
  69416015: function _(v) {
    return new IFC2X3.IfcDynamicViscosityMeasure(v);
  },
  1827137117: function _(v) {
    return new IFC2X3.IfcElectricCapacitanceMeasure(v);
  },
  3818826038: function _(v) {
    return new IFC2X3.IfcElectricChargeMeasure(v);
  },
  2093906313: function _(v) {
    return new IFC2X3.IfcElectricConductanceMeasure(v);
  },
  3790457270: function _(v) {
    return new IFC2X3.IfcElectricCurrentMeasure(v);
  },
  2951915441: function _(v) {
    return new IFC2X3.IfcElectricResistanceMeasure(v);
  },
  2506197118: function _(v) {
    return new IFC2X3.IfcElectricVoltageMeasure(v);
  },
  2078135608: function _(v) {
    return new IFC2X3.IfcEnergyMeasure(v);
  },
  1102727119: function _(v) {
    return new IFC2X3.IfcFontStyle(v);
  },
  2715512545: function _(v) {
    return new IFC2X3.IfcFontVariant(v);
  },
  2590844177: function _(v) {
    return new IFC2X3.IfcFontWeight(v);
  },
  1361398929: function _(v) {
    return new IFC2X3.IfcForceMeasure(v);
  },
  3044325142: function _(v) {
    return new IFC2X3.IfcFrequencyMeasure(v);
  },
  3064340077: function _(v) {
    return new IFC2X3.IfcGloballyUniqueId(v);
  },
  3113092358: function _(v) {
    return new IFC2X3.IfcHeatFluxDensityMeasure(v);
  },
  1158859006: function _(v) {
    return new IFC2X3.IfcHeatingValueMeasure(v);
  },
  2589826445: function _(v) {
    return new IFC2X3.IfcHourInDay(v);
  },
  983778844: function _(v) {
    return new IFC2X3.IfcIdentifier(v);
  },
  3358199106: function _(v) {
    return new IFC2X3.IfcIlluminanceMeasure(v);
  },
  2679005408: function _(v) {
    return new IFC2X3.IfcInductanceMeasure(v);
  },
  1939436016: function _(v) {
    return new IFC2X3.IfcInteger(v);
  },
  3809634241: function _(v) {
    return new IFC2X3.IfcIntegerCountRateMeasure(v);
  },
  3686016028: function _(v) {
    return new IFC2X3.IfcIonConcentrationMeasure(v);
  },
  3192672207: function _(v) {
    return new IFC2X3.IfcIsothermalMoistureCapacityMeasure(v);
  },
  2054016361: function _(v) {
    return new IFC2X3.IfcKinematicViscosityMeasure(v);
  },
  3258342251: function _(v) {
    return new IFC2X3.IfcLabel(v);
  },
  1243674935: function _(v) {
    return new IFC2X3.IfcLengthMeasure(v);
  },
  191860431: function _(v) {
    return new IFC2X3.IfcLinearForceMeasure(v);
  },
  2128979029: function _(v) {
    return new IFC2X3.IfcLinearMomentMeasure(v);
  },
  1307019551: function _(v) {
    return new IFC2X3.IfcLinearStiffnessMeasure(v);
  },
  3086160713: function _(v) {
    return new IFC2X3.IfcLinearVelocityMeasure(v);
  },
  503418787: function _(v) {
    return new IFC2X3.IfcLogical(v);
  },
  2095003142: function _(v) {
    return new IFC2X3.IfcLuminousFluxMeasure(v);
  },
  2755797622: function _(v) {
    return new IFC2X3.IfcLuminousIntensityDistributionMeasure(v);
  },
  151039812: function _(v) {
    return new IFC2X3.IfcLuminousIntensityMeasure(v);
  },
  286949696: function _(v) {
    return new IFC2X3.IfcMagneticFluxDensityMeasure(v);
  },
  2486716878: function _(v) {
    return new IFC2X3.IfcMagneticFluxMeasure(v);
  },
  1477762836: function _(v) {
    return new IFC2X3.IfcMassDensityMeasure(v);
  },
  4017473158: function _(v) {
    return new IFC2X3.IfcMassFlowRateMeasure(v);
  },
  3124614049: function _(v) {
    return new IFC2X3.IfcMassMeasure(v);
  },
  3531705166: function _(v) {
    return new IFC2X3.IfcMassPerLengthMeasure(v);
  },
  102610177: function _(v) {
    return new IFC2X3.IfcMinuteInHour(v);
  },
  3341486342: function _(v) {
    return new IFC2X3.IfcModulusOfElasticityMeasure(v);
  },
  2173214787: function _(v) {
    return new IFC2X3.IfcModulusOfLinearSubgradeReactionMeasure(v);
  },
  1052454078: function _(v) {
    return new IFC2X3.IfcModulusOfRotationalSubgradeReactionMeasure(v);
  },
  1753493141: function _(v) {
    return new IFC2X3.IfcModulusOfSubgradeReactionMeasure(v);
  },
  3177669450: function _(v) {
    return new IFC2X3.IfcMoistureDiffusivityMeasure(v);
  },
  1648970520: function _(v) {
    return new IFC2X3.IfcMolecularWeightMeasure(v);
  },
  3114022597: function _(v) {
    return new IFC2X3.IfcMomentOfInertiaMeasure(v);
  },
  2615040989: function _(v) {
    return new IFC2X3.IfcMonetaryMeasure(v);
  },
  765770214: function _(v) {
    return new IFC2X3.IfcMonthInYearNumber(v);
  },
  2095195183: function _(v) {
    return new IFC2X3.IfcNormalisedRatioMeasure(v);
  },
  2395907400: function _(v) {
    return new IFC2X3.IfcNumericMeasure(v);
  },
  929793134: function _(v) {
    return new IFC2X3.IfcPHMeasure(v);
  },
  2260317790: function _(v) {
    return new IFC2X3.IfcParameterValue(v);
  },
  2642773653: function _(v) {
    return new IFC2X3.IfcPlanarForceMeasure(v);
  },
  4042175685: function _(v) {
    return new IFC2X3.IfcPlaneAngleMeasure(v);
  },
  2815919920: function _(v) {
    return new IFC2X3.IfcPositiveLengthMeasure(v);
  },
  3054510233: function _(v) {
    return new IFC2X3.IfcPositivePlaneAngleMeasure(v);
  },
  1245737093: function _(v) {
    return new IFC2X3.IfcPositiveRatioMeasure(v);
  },
  1364037233: function _(v) {
    return new IFC2X3.IfcPowerMeasure(v);
  },
  2169031380: function _(v) {
    return new IFC2X3.IfcPresentableText(v);
  },
  3665567075: function _(v) {
    return new IFC2X3.IfcPressureMeasure(v);
  },
  3972513137: function _(v) {
    return new IFC2X3.IfcRadioActivityMeasure(v);
  },
  96294661: function _(v) {
    return new IFC2X3.IfcRatioMeasure(v);
  },
  200335297: function _(v) {
    return new IFC2X3.IfcReal(v);
  },
  2133746277: function _(v) {
    return new IFC2X3.IfcRotationalFrequencyMeasure(v);
  },
  1755127002: function _(v) {
    return new IFC2X3.IfcRotationalMassMeasure(v);
  },
  3211557302: function _(v) {
    return new IFC2X3.IfcRotationalStiffnessMeasure(v);
  },
  2766185779: function _(v) {
    return new IFC2X3.IfcSecondInMinute(v);
  },
  3467162246: function _(v) {
    return new IFC2X3.IfcSectionModulusMeasure(v);
  },
  2190458107: function _(v) {
    return new IFC2X3.IfcSectionalAreaIntegralMeasure(v);
  },
  408310005: function _(v) {
    return new IFC2X3.IfcShearModulusMeasure(v);
  },
  3471399674: function _(v) {
    return new IFC2X3.IfcSolidAngleMeasure(v);
  },
  846465480: function _(v) {
    return new IFC2X3.IfcSoundPowerMeasure(v);
  },
  993287707: function _(v) {
    return new IFC2X3.IfcSoundPressureMeasure(v);
  },
  3477203348: function _(v) {
    return new IFC2X3.IfcSpecificHeatCapacityMeasure(v);
  },
  2757832317: function _(v) {
    return new IFC2X3.IfcSpecularExponent(v);
  },
  361837227: function _(v) {
    return new IFC2X3.IfcSpecularRoughness(v);
  },
  58845555: function _(v) {
    return new IFC2X3.IfcTemperatureGradientMeasure(v);
  },
  2801250643: function _(v) {
    return new IFC2X3.IfcText(v);
  },
  1460886941: function _(v) {
    return new IFC2X3.IfcTextAlignment(v);
  },
  3490877962: function _(v) {
    return new IFC2X3.IfcTextDecoration(v);
  },
  603696268: function _(v) {
    return new IFC2X3.IfcTextFontName(v);
  },
  296282323: function _(v) {
    return new IFC2X3.IfcTextTransformation(v);
  },
  232962298: function _(v) {
    return new IFC2X3.IfcThermalAdmittanceMeasure(v);
  },
  2645777649: function _(v) {
    return new IFC2X3.IfcThermalConductivityMeasure(v);
  },
  2281867870: function _(v) {
    return new IFC2X3.IfcThermalExpansionCoefficientMeasure(v);
  },
  857959152: function _(v) {
    return new IFC2X3.IfcThermalResistanceMeasure(v);
  },
  2016195849: function _(v) {
    return new IFC2X3.IfcThermalTransmittanceMeasure(v);
  },
  743184107: function _(v) {
    return new IFC2X3.IfcThermodynamicTemperatureMeasure(v);
  },
  2726807636: function _(v) {
    return new IFC2X3.IfcTimeMeasure(v);
  },
  2591213694: function _(v) {
    return new IFC2X3.IfcTimeStamp(v);
  },
  1278329552: function _(v) {
    return new IFC2X3.IfcTorqueMeasure(v);
  },
  3345633955: function _(v) {
    return new IFC2X3.IfcVaporPermeabilityMeasure(v);
  },
  3458127941: function _(v) {
    return new IFC2X3.IfcVolumeMeasure(v);
  },
  2593997549: function _(v) {
    return new IFC2X3.IfcVolumetricFlowRateMeasure(v);
  },
  51269191: function _(v) {
    return new IFC2X3.IfcWarpingConstantMeasure(v);
  },
  1718600412: function _(v) {
    return new IFC2X3.IfcWarpingMomentMeasure(v);
  },
  4065007721: function _(v) {
    return new IFC2X3.IfcYearNumber(v);
  }
};
var IFC2X3;

(function (IFC2X32) {
  var IfcAbsorbedDoseMeasure = function IfcAbsorbedDoseMeasure(value) {
    _classCallCheck2(this, IfcAbsorbedDoseMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;

  var IfcAccelerationMeasure = function IfcAccelerationMeasure(value) {
    _classCallCheck2(this, IfcAccelerationMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcAccelerationMeasure = IfcAccelerationMeasure;

  var IfcAmountOfSubstanceMeasure = function IfcAmountOfSubstanceMeasure(value) {
    _classCallCheck2(this, IfcAmountOfSubstanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;

  var IfcAngularVelocityMeasure = function IfcAngularVelocityMeasure(value) {
    _classCallCheck2(this, IfcAngularVelocityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;

  var IfcAreaMeasure = function IfcAreaMeasure(value) {
    _classCallCheck2(this, IfcAreaMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcAreaMeasure = IfcAreaMeasure;

  var IfcBoolean = function IfcBoolean(value) {
    _classCallCheck2(this, IfcBoolean);

    this.value = value;
    this.type = 3;
  };

  IFC2X32.IfcBoolean = IfcBoolean;

  var IfcBoxAlignment = function IfcBoxAlignment(value) {
    _classCallCheck2(this, IfcBoxAlignment);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcBoxAlignment = IfcBoxAlignment;

  var IfcComplexNumber = function IfcComplexNumber(value) {
    _classCallCheck2(this, IfcComplexNumber);

    this.value = value;
  };

  IFC2X32.IfcComplexNumber = IfcComplexNumber;

  var IfcCompoundPlaneAngleMeasure = function IfcCompoundPlaneAngleMeasure(value) {
    _classCallCheck2(this, IfcCompoundPlaneAngleMeasure);

    this.value = value;
  };

  IFC2X32.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;

  var IfcContextDependentMeasure = function IfcContextDependentMeasure(value) {
    _classCallCheck2(this, IfcContextDependentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcContextDependentMeasure = IfcContextDependentMeasure;

  var IfcCountMeasure = function IfcCountMeasure(value) {
    _classCallCheck2(this, IfcCountMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcCountMeasure = IfcCountMeasure;

  var IfcCurvatureMeasure = function IfcCurvatureMeasure(value) {
    _classCallCheck2(this, IfcCurvatureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcCurvatureMeasure = IfcCurvatureMeasure;

  var IfcDayInMonthNumber = function IfcDayInMonthNumber(value) {
    _classCallCheck2(this, IfcDayInMonthNumber);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcDayInMonthNumber = IfcDayInMonthNumber;

  var IfcDaylightSavingHour = function IfcDaylightSavingHour(value) {
    _classCallCheck2(this, IfcDaylightSavingHour);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcDaylightSavingHour = IfcDaylightSavingHour;

  var IfcDescriptiveMeasure = function IfcDescriptiveMeasure(value) {
    _classCallCheck2(this, IfcDescriptiveMeasure);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcDescriptiveMeasure = IfcDescriptiveMeasure;

  var IfcDimensionCount = function IfcDimensionCount(value) {
    _classCallCheck2(this, IfcDimensionCount);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcDimensionCount = IfcDimensionCount;

  var IfcDoseEquivalentMeasure = function IfcDoseEquivalentMeasure(value) {
    _classCallCheck2(this, IfcDoseEquivalentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;

  var IfcDynamicViscosityMeasure = function IfcDynamicViscosityMeasure(value) {
    _classCallCheck2(this, IfcDynamicViscosityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;

  var IfcElectricCapacitanceMeasure = function IfcElectricCapacitanceMeasure(value) {
    _classCallCheck2(this, IfcElectricCapacitanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;

  var IfcElectricChargeMeasure = function IfcElectricChargeMeasure(value) {
    _classCallCheck2(this, IfcElectricChargeMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcElectricChargeMeasure = IfcElectricChargeMeasure;

  var IfcElectricConductanceMeasure = function IfcElectricConductanceMeasure(value) {
    _classCallCheck2(this, IfcElectricConductanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;

  var IfcElectricCurrentMeasure = function IfcElectricCurrentMeasure(value) {
    _classCallCheck2(this, IfcElectricCurrentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;

  var IfcElectricResistanceMeasure = function IfcElectricResistanceMeasure(value) {
    _classCallCheck2(this, IfcElectricResistanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;

  var IfcElectricVoltageMeasure = function IfcElectricVoltageMeasure(value) {
    _classCallCheck2(this, IfcElectricVoltageMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;

  var IfcEnergyMeasure = function IfcEnergyMeasure(value) {
    _classCallCheck2(this, IfcEnergyMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcEnergyMeasure = IfcEnergyMeasure;

  var IfcFontStyle = function IfcFontStyle(value) {
    _classCallCheck2(this, IfcFontStyle);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcFontStyle = IfcFontStyle;

  var IfcFontVariant = function IfcFontVariant(value) {
    _classCallCheck2(this, IfcFontVariant);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcFontVariant = IfcFontVariant;

  var IfcFontWeight = function IfcFontWeight(value) {
    _classCallCheck2(this, IfcFontWeight);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcFontWeight = IfcFontWeight;

  var IfcForceMeasure = function IfcForceMeasure(value) {
    _classCallCheck2(this, IfcForceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcForceMeasure = IfcForceMeasure;

  var IfcFrequencyMeasure = function IfcFrequencyMeasure(value) {
    _classCallCheck2(this, IfcFrequencyMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcFrequencyMeasure = IfcFrequencyMeasure;

  var IfcGloballyUniqueId = function IfcGloballyUniqueId(value) {
    _classCallCheck2(this, IfcGloballyUniqueId);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcGloballyUniqueId = IfcGloballyUniqueId;

  var IfcHeatFluxDensityMeasure = function IfcHeatFluxDensityMeasure(value) {
    _classCallCheck2(this, IfcHeatFluxDensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;

  var IfcHeatingValueMeasure = function IfcHeatingValueMeasure(value) {
    _classCallCheck2(this, IfcHeatingValueMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcHeatingValueMeasure = IfcHeatingValueMeasure;

  var IfcHourInDay = function IfcHourInDay(value) {
    _classCallCheck2(this, IfcHourInDay);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcHourInDay = IfcHourInDay;

  var IfcIdentifier = function IfcIdentifier(value) {
    _classCallCheck2(this, IfcIdentifier);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcIdentifier = IfcIdentifier;

  var IfcIlluminanceMeasure = function IfcIlluminanceMeasure(value) {
    _classCallCheck2(this, IfcIlluminanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcIlluminanceMeasure = IfcIlluminanceMeasure;

  var IfcInductanceMeasure = function IfcInductanceMeasure(value) {
    _classCallCheck2(this, IfcInductanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcInductanceMeasure = IfcInductanceMeasure;

  var IfcInteger = function IfcInteger(value) {
    _classCallCheck2(this, IfcInteger);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcInteger = IfcInteger;

  var IfcIntegerCountRateMeasure = function IfcIntegerCountRateMeasure(value) {
    _classCallCheck2(this, IfcIntegerCountRateMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;

  var IfcIonConcentrationMeasure = function IfcIonConcentrationMeasure(value) {
    _classCallCheck2(this, IfcIonConcentrationMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;

  var IfcIsothermalMoistureCapacityMeasure = function IfcIsothermalMoistureCapacityMeasure(value) {
    _classCallCheck2(this, IfcIsothermalMoistureCapacityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;

  var IfcKinematicViscosityMeasure = function IfcKinematicViscosityMeasure(value) {
    _classCallCheck2(this, IfcKinematicViscosityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;

  var IfcLabel = function IfcLabel(value) {
    _classCallCheck2(this, IfcLabel);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcLabel = IfcLabel;

  var IfcLengthMeasure = function IfcLengthMeasure(value) {
    _classCallCheck2(this, IfcLengthMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcLengthMeasure = IfcLengthMeasure;

  var IfcLinearForceMeasure = function IfcLinearForceMeasure(value) {
    _classCallCheck2(this, IfcLinearForceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcLinearForceMeasure = IfcLinearForceMeasure;

  var IfcLinearMomentMeasure = function IfcLinearMomentMeasure(value) {
    _classCallCheck2(this, IfcLinearMomentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcLinearMomentMeasure = IfcLinearMomentMeasure;

  var IfcLinearStiffnessMeasure = function IfcLinearStiffnessMeasure(value) {
    _classCallCheck2(this, IfcLinearStiffnessMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;

  var IfcLinearVelocityMeasure = function IfcLinearVelocityMeasure(value) {
    _classCallCheck2(this, IfcLinearVelocityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;

  var IfcLogical = function IfcLogical(value) {
    _classCallCheck2(this, IfcLogical);

    this.value = value;
    this.type = 3;
  };

  IFC2X32.IfcLogical = IfcLogical;

  var IfcLuminousFluxMeasure = function IfcLuminousFluxMeasure(value) {
    _classCallCheck2(this, IfcLuminousFluxMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;

  var IfcLuminousIntensityDistributionMeasure = function IfcLuminousIntensityDistributionMeasure(value) {
    _classCallCheck2(this, IfcLuminousIntensityDistributionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;

  var IfcLuminousIntensityMeasure = function IfcLuminousIntensityMeasure(value) {
    _classCallCheck2(this, IfcLuminousIntensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;

  var IfcMagneticFluxDensityMeasure = function IfcMagneticFluxDensityMeasure(value) {
    _classCallCheck2(this, IfcMagneticFluxDensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;

  var IfcMagneticFluxMeasure = function IfcMagneticFluxMeasure(value) {
    _classCallCheck2(this, IfcMagneticFluxMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;

  var IfcMassDensityMeasure = function IfcMassDensityMeasure(value) {
    _classCallCheck2(this, IfcMassDensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMassDensityMeasure = IfcMassDensityMeasure;

  var IfcMassFlowRateMeasure = function IfcMassFlowRateMeasure(value) {
    _classCallCheck2(this, IfcMassFlowRateMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;

  var IfcMassMeasure = function IfcMassMeasure(value) {
    _classCallCheck2(this, IfcMassMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMassMeasure = IfcMassMeasure;

  var IfcMassPerLengthMeasure = function IfcMassPerLengthMeasure(value) {
    _classCallCheck2(this, IfcMassPerLengthMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;

  var IfcMinuteInHour = function IfcMinuteInHour(value) {
    _classCallCheck2(this, IfcMinuteInHour);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMinuteInHour = IfcMinuteInHour;

  var IfcModulusOfElasticityMeasure = function IfcModulusOfElasticityMeasure(value) {
    _classCallCheck2(this, IfcModulusOfElasticityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;

  var IfcModulusOfLinearSubgradeReactionMeasure = function IfcModulusOfLinearSubgradeReactionMeasure(value) {
    _classCallCheck2(this, IfcModulusOfLinearSubgradeReactionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;

  var IfcModulusOfRotationalSubgradeReactionMeasure = function IfcModulusOfRotationalSubgradeReactionMeasure(value) {
    _classCallCheck2(this, IfcModulusOfRotationalSubgradeReactionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;

  var IfcModulusOfSubgradeReactionMeasure = function IfcModulusOfSubgradeReactionMeasure(value) {
    _classCallCheck2(this, IfcModulusOfSubgradeReactionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;

  var IfcMoistureDiffusivityMeasure = function IfcMoistureDiffusivityMeasure(value) {
    _classCallCheck2(this, IfcMoistureDiffusivityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;

  var IfcMolecularWeightMeasure = function IfcMolecularWeightMeasure(value) {
    _classCallCheck2(this, IfcMolecularWeightMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;

  var IfcMomentOfInertiaMeasure = function IfcMomentOfInertiaMeasure(value) {
    _classCallCheck2(this, IfcMomentOfInertiaMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;

  var IfcMonetaryMeasure = function IfcMonetaryMeasure(value) {
    _classCallCheck2(this, IfcMonetaryMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMonetaryMeasure = IfcMonetaryMeasure;

  var IfcMonthInYearNumber = function IfcMonthInYearNumber(value) {
    _classCallCheck2(this, IfcMonthInYearNumber);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcMonthInYearNumber = IfcMonthInYearNumber;

  var IfcNormalisedRatioMeasure = function IfcNormalisedRatioMeasure(value) {
    _classCallCheck2(this, IfcNormalisedRatioMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;

  var IfcNumericMeasure = function IfcNumericMeasure(value) {
    _classCallCheck2(this, IfcNumericMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcNumericMeasure = IfcNumericMeasure;

  var IfcPHMeasure = function IfcPHMeasure(value) {
    _classCallCheck2(this, IfcPHMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcPHMeasure = IfcPHMeasure;

  var IfcParameterValue = function IfcParameterValue(value) {
    _classCallCheck2(this, IfcParameterValue);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcParameterValue = IfcParameterValue;

  var IfcPlanarForceMeasure = function IfcPlanarForceMeasure(value) {
    _classCallCheck2(this, IfcPlanarForceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcPlanarForceMeasure = IfcPlanarForceMeasure;

  var IfcPlaneAngleMeasure = function IfcPlaneAngleMeasure(value) {
    _classCallCheck2(this, IfcPlaneAngleMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;

  var IfcPositiveLengthMeasure = function IfcPositiveLengthMeasure(value) {
    _classCallCheck2(this, IfcPositiveLengthMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;

  var IfcPositivePlaneAngleMeasure = function IfcPositivePlaneAngleMeasure(value) {
    _classCallCheck2(this, IfcPositivePlaneAngleMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;

  var IfcPositiveRatioMeasure = function IfcPositiveRatioMeasure(value) {
    _classCallCheck2(this, IfcPositiveRatioMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;

  var IfcPowerMeasure = function IfcPowerMeasure(value) {
    _classCallCheck2(this, IfcPowerMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcPowerMeasure = IfcPowerMeasure;

  var IfcPresentableText = function IfcPresentableText(value) {
    _classCallCheck2(this, IfcPresentableText);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcPresentableText = IfcPresentableText;

  var IfcPressureMeasure = function IfcPressureMeasure(value) {
    _classCallCheck2(this, IfcPressureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcPressureMeasure = IfcPressureMeasure;

  var IfcRadioActivityMeasure = function IfcRadioActivityMeasure(value) {
    _classCallCheck2(this, IfcRadioActivityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcRadioActivityMeasure = IfcRadioActivityMeasure;

  var IfcRatioMeasure = function IfcRatioMeasure(value) {
    _classCallCheck2(this, IfcRatioMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcRatioMeasure = IfcRatioMeasure;

  var IfcReal = function IfcReal(value) {
    _classCallCheck2(this, IfcReal);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcReal = IfcReal;

  var IfcRotationalFrequencyMeasure = function IfcRotationalFrequencyMeasure(value) {
    _classCallCheck2(this, IfcRotationalFrequencyMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;

  var IfcRotationalMassMeasure = function IfcRotationalMassMeasure(value) {
    _classCallCheck2(this, IfcRotationalMassMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcRotationalMassMeasure = IfcRotationalMassMeasure;

  var IfcRotationalStiffnessMeasure = function IfcRotationalStiffnessMeasure(value) {
    _classCallCheck2(this, IfcRotationalStiffnessMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;

  var IfcSecondInMinute = function IfcSecondInMinute(value) {
    _classCallCheck2(this, IfcSecondInMinute);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcSecondInMinute = IfcSecondInMinute;

  var IfcSectionModulusMeasure = function IfcSectionModulusMeasure(value) {
    _classCallCheck2(this, IfcSectionModulusMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcSectionModulusMeasure = IfcSectionModulusMeasure;

  var IfcSectionalAreaIntegralMeasure = function IfcSectionalAreaIntegralMeasure(value) {
    _classCallCheck2(this, IfcSectionalAreaIntegralMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;

  var IfcShearModulusMeasure = function IfcShearModulusMeasure(value) {
    _classCallCheck2(this, IfcShearModulusMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcShearModulusMeasure = IfcShearModulusMeasure;

  var IfcSolidAngleMeasure = function IfcSolidAngleMeasure(value) {
    _classCallCheck2(this, IfcSolidAngleMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcSolidAngleMeasure = IfcSolidAngleMeasure;

  var IfcSoundPowerMeasure = function IfcSoundPowerMeasure(value) {
    _classCallCheck2(this, IfcSoundPowerMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcSoundPowerMeasure = IfcSoundPowerMeasure;

  var IfcSoundPressureMeasure = function IfcSoundPressureMeasure(value) {
    _classCallCheck2(this, IfcSoundPressureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcSoundPressureMeasure = IfcSoundPressureMeasure;

  var IfcSpecificHeatCapacityMeasure = function IfcSpecificHeatCapacityMeasure(value) {
    _classCallCheck2(this, IfcSpecificHeatCapacityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;

  var IfcSpecularExponent = function IfcSpecularExponent(value) {
    _classCallCheck2(this, IfcSpecularExponent);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcSpecularExponent = IfcSpecularExponent;

  var IfcSpecularRoughness = function IfcSpecularRoughness(value) {
    _classCallCheck2(this, IfcSpecularRoughness);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcSpecularRoughness = IfcSpecularRoughness;

  var IfcTemperatureGradientMeasure = function IfcTemperatureGradientMeasure(value) {
    _classCallCheck2(this, IfcTemperatureGradientMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;

  var IfcText = function IfcText(value) {
    _classCallCheck2(this, IfcText);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcText = IfcText;

  var IfcTextAlignment = function IfcTextAlignment(value) {
    _classCallCheck2(this, IfcTextAlignment);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcTextAlignment = IfcTextAlignment;

  var IfcTextDecoration = function IfcTextDecoration(value) {
    _classCallCheck2(this, IfcTextDecoration);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcTextDecoration = IfcTextDecoration;

  var IfcTextFontName = function IfcTextFontName(value) {
    _classCallCheck2(this, IfcTextFontName);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcTextFontName = IfcTextFontName;

  var IfcTextTransformation = function IfcTextTransformation(value) {
    _classCallCheck2(this, IfcTextTransformation);

    this.value = value;
    this.type = 1;
  };

  IFC2X32.IfcTextTransformation = IfcTextTransformation;

  var IfcThermalAdmittanceMeasure = function IfcThermalAdmittanceMeasure(value) {
    _classCallCheck2(this, IfcThermalAdmittanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;

  var IfcThermalConductivityMeasure = function IfcThermalConductivityMeasure(value) {
    _classCallCheck2(this, IfcThermalConductivityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;

  var IfcThermalExpansionCoefficientMeasure = function IfcThermalExpansionCoefficientMeasure(value) {
    _classCallCheck2(this, IfcThermalExpansionCoefficientMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;

  var IfcThermalResistanceMeasure = function IfcThermalResistanceMeasure(value) {
    _classCallCheck2(this, IfcThermalResistanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;

  var IfcThermalTransmittanceMeasure = function IfcThermalTransmittanceMeasure(value) {
    _classCallCheck2(this, IfcThermalTransmittanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;

  var IfcThermodynamicTemperatureMeasure = function IfcThermodynamicTemperatureMeasure(value) {
    _classCallCheck2(this, IfcThermodynamicTemperatureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;

  var IfcTimeMeasure = function IfcTimeMeasure(value) {
    _classCallCheck2(this, IfcTimeMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcTimeMeasure = IfcTimeMeasure;

  var IfcTimeStamp = function IfcTimeStamp(value) {
    _classCallCheck2(this, IfcTimeStamp);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcTimeStamp = IfcTimeStamp;

  var IfcTorqueMeasure = function IfcTorqueMeasure(value) {
    _classCallCheck2(this, IfcTorqueMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcTorqueMeasure = IfcTorqueMeasure;

  var IfcVaporPermeabilityMeasure = function IfcVaporPermeabilityMeasure(value) {
    _classCallCheck2(this, IfcVaporPermeabilityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;

  var IfcVolumeMeasure = function IfcVolumeMeasure(value) {
    _classCallCheck2(this, IfcVolumeMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcVolumeMeasure = IfcVolumeMeasure;

  var IfcVolumetricFlowRateMeasure = function IfcVolumetricFlowRateMeasure(value) {
    _classCallCheck2(this, IfcVolumetricFlowRateMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;

  var IfcWarpingConstantMeasure = function IfcWarpingConstantMeasure(value) {
    _classCallCheck2(this, IfcWarpingConstantMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;

  var IfcWarpingMomentMeasure = function IfcWarpingMomentMeasure(value) {
    _classCallCheck2(this, IfcWarpingMomentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;

  var IfcYearNumber = function IfcYearNumber(value) {
    _classCallCheck2(this, IfcYearNumber);

    this.value = value;
    this.type = 4;
  };

  IFC2X32.IfcYearNumber = IfcYearNumber;

  var IfcActionSourceTypeEnum = function IfcActionSourceTypeEnum() {
    _classCallCheck2(this, IfcActionSourceTypeEnum);
  };

  IfcActionSourceTypeEnum.DEAD_LOAD_G = {
    type: 3,
    value: "DEAD_LOAD_G"
  };
  IfcActionSourceTypeEnum.COMPLETION_G1 = {
    type: 3,
    value: "COMPLETION_G1"
  };
  IfcActionSourceTypeEnum.LIVE_LOAD_Q = {
    type: 3,
    value: "LIVE_LOAD_Q"
  };
  IfcActionSourceTypeEnum.SNOW_S = {
    type: 3,
    value: "SNOW_S"
  };
  IfcActionSourceTypeEnum.WIND_W = {
    type: 3,
    value: "WIND_W"
  };
  IfcActionSourceTypeEnum.PRESTRESSING_P = {
    type: 3,
    value: "PRESTRESSING_P"
  };
  IfcActionSourceTypeEnum.SETTLEMENT_U = {
    type: 3,
    value: "SETTLEMENT_U"
  };
  IfcActionSourceTypeEnum.TEMPERATURE_T = {
    type: 3,
    value: "TEMPERATURE_T"
  };
  IfcActionSourceTypeEnum.EARTHQUAKE_E = {
    type: 3,
    value: "EARTHQUAKE_E"
  };
  IfcActionSourceTypeEnum.FIRE = {
    type: 3,
    value: "FIRE"
  };
  IfcActionSourceTypeEnum.IMPULSE = {
    type: 3,
    value: "IMPULSE"
  };
  IfcActionSourceTypeEnum.IMPACT = {
    type: 3,
    value: "IMPACT"
  };
  IfcActionSourceTypeEnum.TRANSPORT = {
    type: 3,
    value: "TRANSPORT"
  };
  IfcActionSourceTypeEnum.ERECTION = {
    type: 3,
    value: "ERECTION"
  };
  IfcActionSourceTypeEnum.PROPPING = {
    type: 3,
    value: "PROPPING"
  };
  IfcActionSourceTypeEnum.SYSTEM_IMPERFECTION = {
    type: 3,
    value: "SYSTEM_IMPERFECTION"
  };
  IfcActionSourceTypeEnum.SHRINKAGE = {
    type: 3,
    value: "SHRINKAGE"
  };
  IfcActionSourceTypeEnum.CREEP = {
    type: 3,
    value: "CREEP"
  };
  IfcActionSourceTypeEnum.LACK_OF_FIT = {
    type: 3,
    value: "LACK_OF_FIT"
  };
  IfcActionSourceTypeEnum.BUOYANCY = {
    type: 3,
    value: "BUOYANCY"
  };
  IfcActionSourceTypeEnum.ICE = {
    type: 3,
    value: "ICE"
  };
  IfcActionSourceTypeEnum.CURRENT = {
    type: 3,
    value: "CURRENT"
  };
  IfcActionSourceTypeEnum.WAVE = {
    type: 3,
    value: "WAVE"
  };
  IfcActionSourceTypeEnum.RAIN = {
    type: 3,
    value: "RAIN"
  };
  IfcActionSourceTypeEnum.BRAKES = {
    type: 3,
    value: "BRAKES"
  };
  IfcActionSourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcActionSourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;

  var IfcActionTypeEnum = function IfcActionTypeEnum() {
    _classCallCheck2(this, IfcActionTypeEnum);
  };

  IfcActionTypeEnum.PERMANENT_G = {
    type: 3,
    value: "PERMANENT_G"
  };
  IfcActionTypeEnum.VARIABLE_Q = {
    type: 3,
    value: "VARIABLE_Q"
  };
  IfcActionTypeEnum.EXTRAORDINARY_A = {
    type: 3,
    value: "EXTRAORDINARY_A"
  };
  IfcActionTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcActionTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcActionTypeEnum = IfcActionTypeEnum;

  var IfcActuatorTypeEnum = function IfcActuatorTypeEnum() {
    _classCallCheck2(this, IfcActuatorTypeEnum);
  };

  IfcActuatorTypeEnum.ELECTRICACTUATOR = {
    type: 3,
    value: "ELECTRICACTUATOR"
  };
  IfcActuatorTypeEnum.HANDOPERATEDACTUATOR = {
    type: 3,
    value: "HANDOPERATEDACTUATOR"
  };
  IfcActuatorTypeEnum.HYDRAULICACTUATOR = {
    type: 3,
    value: "HYDRAULICACTUATOR"
  };
  IfcActuatorTypeEnum.PNEUMATICACTUATOR = {
    type: 3,
    value: "PNEUMATICACTUATOR"
  };
  IfcActuatorTypeEnum.THERMOSTATICACTUATOR = {
    type: 3,
    value: "THERMOSTATICACTUATOR"
  };
  IfcActuatorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcActuatorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcActuatorTypeEnum = IfcActuatorTypeEnum;

  var IfcAddressTypeEnum = function IfcAddressTypeEnum() {
    _classCallCheck2(this, IfcAddressTypeEnum);
  };

  IfcAddressTypeEnum.OFFICE = {
    type: 3,
    value: "OFFICE"
  };
  IfcAddressTypeEnum.SITE = {
    type: 3,
    value: "SITE"
  };
  IfcAddressTypeEnum.HOME = {
    type: 3,
    value: "HOME"
  };
  IfcAddressTypeEnum.DISTRIBUTIONPOINT = {
    type: 3,
    value: "DISTRIBUTIONPOINT"
  };
  IfcAddressTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC2X32.IfcAddressTypeEnum = IfcAddressTypeEnum;

  var IfcAheadOrBehind = function IfcAheadOrBehind() {
    _classCallCheck2(this, IfcAheadOrBehind);
  };

  IfcAheadOrBehind.AHEAD = {
    type: 3,
    value: "AHEAD"
  };
  IfcAheadOrBehind.BEHIND = {
    type: 3,
    value: "BEHIND"
  };
  IFC2X32.IfcAheadOrBehind = IfcAheadOrBehind;

  var IfcAirTerminalBoxTypeEnum = function IfcAirTerminalBoxTypeEnum() {
    _classCallCheck2(this, IfcAirTerminalBoxTypeEnum);
  };

  IfcAirTerminalBoxTypeEnum.CONSTANTFLOW = {
    type: 3,
    value: "CONSTANTFLOW"
  };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREDEPENDANT = {
    type: 3,
    value: "VARIABLEFLOWPRESSUREDEPENDANT"
  };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREINDEPENDANT = {
    type: 3,
    value: "VARIABLEFLOWPRESSUREINDEPENDANT"
  };
  IfcAirTerminalBoxTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAirTerminalBoxTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;

  var IfcAirTerminalTypeEnum = function IfcAirTerminalTypeEnum() {
    _classCallCheck2(this, IfcAirTerminalTypeEnum);
  };

  IfcAirTerminalTypeEnum.GRILLE = {
    type: 3,
    value: "GRILLE"
  };
  IfcAirTerminalTypeEnum.REGISTER = {
    type: 3,
    value: "REGISTER"
  };
  IfcAirTerminalTypeEnum.DIFFUSER = {
    type: 3,
    value: "DIFFUSER"
  };
  IfcAirTerminalTypeEnum.EYEBALL = {
    type: 3,
    value: "EYEBALL"
  };
  IfcAirTerminalTypeEnum.IRIS = {
    type: 3,
    value: "IRIS"
  };
  IfcAirTerminalTypeEnum.LINEARGRILLE = {
    type: 3,
    value: "LINEARGRILLE"
  };
  IfcAirTerminalTypeEnum.LINEARDIFFUSER = {
    type: 3,
    value: "LINEARDIFFUSER"
  };
  IfcAirTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAirTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;

  var IfcAirToAirHeatRecoveryTypeEnum = function IfcAirToAirHeatRecoveryTypeEnum() {
    _classCallCheck2(this, IfcAirToAirHeatRecoveryTypeEnum);
  };

  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECOUNTERFLOWEXCHANGER = {
    type: 3,
    value: "FIXEDPLATECOUNTERFLOWEXCHANGER"
  };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECROSSFLOWEXCHANGER = {
    type: 3,
    value: "FIXEDPLATECROSSFLOWEXCHANGER"
  };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATEPARALLELFLOWEXCHANGER = {
    type: 3,
    value: "FIXEDPLATEPARALLELFLOWEXCHANGER"
  };
  IfcAirToAirHeatRecoveryTypeEnum.ROTARYWHEEL = {
    type: 3,
    value: "ROTARYWHEEL"
  };
  IfcAirToAirHeatRecoveryTypeEnum.RUNAROUNDCOILLOOP = {
    type: 3,
    value: "RUNAROUNDCOILLOOP"
  };
  IfcAirToAirHeatRecoveryTypeEnum.HEATPIPE = {
    type: 3,
    value: "HEATPIPE"
  };
  IfcAirToAirHeatRecoveryTypeEnum.TWINTOWERENTHALPYRECOVERYLOOPS = {
    type: 3,
    value: "TWINTOWERENTHALPYRECOVERYLOOPS"
  };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = {
    type: 3,
    value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS"
  };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONCOILTYPEHEATEXCHANGERS = {
    type: 3,
    value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS"
  };
  IfcAirToAirHeatRecoveryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAirToAirHeatRecoveryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;

  var IfcAlarmTypeEnum = function IfcAlarmTypeEnum() {
    _classCallCheck2(this, IfcAlarmTypeEnum);
  };

  IfcAlarmTypeEnum.BELL = {
    type: 3,
    value: "BELL"
  };
  IfcAlarmTypeEnum.BREAKGLASSBUTTON = {
    type: 3,
    value: "BREAKGLASSBUTTON"
  };
  IfcAlarmTypeEnum.LIGHT = {
    type: 3,
    value: "LIGHT"
  };
  IfcAlarmTypeEnum.MANUALPULLBOX = {
    type: 3,
    value: "MANUALPULLBOX"
  };
  IfcAlarmTypeEnum.SIREN = {
    type: 3,
    value: "SIREN"
  };
  IfcAlarmTypeEnum.WHISTLE = {
    type: 3,
    value: "WHISTLE"
  };
  IfcAlarmTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAlarmTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcAlarmTypeEnum = IfcAlarmTypeEnum;

  var IfcAnalysisModelTypeEnum = function IfcAnalysisModelTypeEnum() {
    _classCallCheck2(this, IfcAnalysisModelTypeEnum);
  };

  IfcAnalysisModelTypeEnum.IN_PLANE_LOADING_2D = {
    type: 3,
    value: "IN_PLANE_LOADING_2D"
  };
  IfcAnalysisModelTypeEnum.OUT_PLANE_LOADING_2D = {
    type: 3,
    value: "OUT_PLANE_LOADING_2D"
  };
  IfcAnalysisModelTypeEnum.LOADING_3D = {
    type: 3,
    value: "LOADING_3D"
  };
  IfcAnalysisModelTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAnalysisModelTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;

  var IfcAnalysisTheoryTypeEnum = function IfcAnalysisTheoryTypeEnum() {
    _classCallCheck2(this, IfcAnalysisTheoryTypeEnum);
  };

  IfcAnalysisTheoryTypeEnum.FIRST_ORDER_THEORY = {
    type: 3,
    value: "FIRST_ORDER_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.SECOND_ORDER_THEORY = {
    type: 3,
    value: "SECOND_ORDER_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.THIRD_ORDER_THEORY = {
    type: 3,
    value: "THIRD_ORDER_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.FULL_NONLINEAR_THEORY = {
    type: 3,
    value: "FULL_NONLINEAR_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAnalysisTheoryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;

  var IfcArithmeticOperatorEnum = function IfcArithmeticOperatorEnum() {
    _classCallCheck2(this, IfcArithmeticOperatorEnum);
  };

  IfcArithmeticOperatorEnum.ADD = {
    type: 3,
    value: "ADD"
  };
  IfcArithmeticOperatorEnum.DIVIDE = {
    type: 3,
    value: "DIVIDE"
  };
  IfcArithmeticOperatorEnum.MULTIPLY = {
    type: 3,
    value: "MULTIPLY"
  };
  IfcArithmeticOperatorEnum.SUBTRACT = {
    type: 3,
    value: "SUBTRACT"
  };
  IFC2X32.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;

  var IfcAssemblyPlaceEnum = function IfcAssemblyPlaceEnum() {
    _classCallCheck2(this, IfcAssemblyPlaceEnum);
  };

  IfcAssemblyPlaceEnum.SITE = {
    type: 3,
    value: "SITE"
  };
  IfcAssemblyPlaceEnum.FACTORY = {
    type: 3,
    value: "FACTORY"
  };
  IfcAssemblyPlaceEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;

  var IfcBSplineCurveForm = function IfcBSplineCurveForm() {
    _classCallCheck2(this, IfcBSplineCurveForm);
  };

  IfcBSplineCurveForm.POLYLINE_FORM = {
    type: 3,
    value: "POLYLINE_FORM"
  };
  IfcBSplineCurveForm.CIRCULAR_ARC = {
    type: 3,
    value: "CIRCULAR_ARC"
  };
  IfcBSplineCurveForm.ELLIPTIC_ARC = {
    type: 3,
    value: "ELLIPTIC_ARC"
  };
  IfcBSplineCurveForm.PARABOLIC_ARC = {
    type: 3,
    value: "PARABOLIC_ARC"
  };
  IfcBSplineCurveForm.HYPERBOLIC_ARC = {
    type: 3,
    value: "HYPERBOLIC_ARC"
  };
  IfcBSplineCurveForm.UNSPECIFIED = {
    type: 3,
    value: "UNSPECIFIED"
  };
  IFC2X32.IfcBSplineCurveForm = IfcBSplineCurveForm;

  var IfcBeamTypeEnum = function IfcBeamTypeEnum() {
    _classCallCheck2(this, IfcBeamTypeEnum);
  };

  IfcBeamTypeEnum.BEAM = {
    type: 3,
    value: "BEAM"
  };
  IfcBeamTypeEnum.JOIST = {
    type: 3,
    value: "JOIST"
  };
  IfcBeamTypeEnum.LINTEL = {
    type: 3,
    value: "LINTEL"
  };
  IfcBeamTypeEnum.T_BEAM = {
    type: 3,
    value: "T_BEAM"
  };
  IfcBeamTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBeamTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcBeamTypeEnum = IfcBeamTypeEnum;

  var IfcBenchmarkEnum = function IfcBenchmarkEnum() {
    _classCallCheck2(this, IfcBenchmarkEnum);
  };

  IfcBenchmarkEnum.GREATERTHAN = {
    type: 3,
    value: "GREATERTHAN"
  };
  IfcBenchmarkEnum.GREATERTHANOREQUALTO = {
    type: 3,
    value: "GREATERTHANOREQUALTO"
  };
  IfcBenchmarkEnum.LESSTHAN = {
    type: 3,
    value: "LESSTHAN"
  };
  IfcBenchmarkEnum.LESSTHANOREQUALTO = {
    type: 3,
    value: "LESSTHANOREQUALTO"
  };
  IfcBenchmarkEnum.EQUALTO = {
    type: 3,
    value: "EQUALTO"
  };
  IfcBenchmarkEnum.NOTEQUALTO = {
    type: 3,
    value: "NOTEQUALTO"
  };
  IFC2X32.IfcBenchmarkEnum = IfcBenchmarkEnum;

  var IfcBoilerTypeEnum = function IfcBoilerTypeEnum() {
    _classCallCheck2(this, IfcBoilerTypeEnum);
  };

  IfcBoilerTypeEnum.WATER = {
    type: 3,
    value: "WATER"
  };
  IfcBoilerTypeEnum.STEAM = {
    type: 3,
    value: "STEAM"
  };
  IfcBoilerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBoilerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcBoilerTypeEnum = IfcBoilerTypeEnum;

  var IfcBooleanOperator = function IfcBooleanOperator() {
    _classCallCheck2(this, IfcBooleanOperator);
  };

  IfcBooleanOperator.UNION = {
    type: 3,
    value: "UNION"
  };
  IfcBooleanOperator.INTERSECTION = {
    type: 3,
    value: "INTERSECTION"
  };
  IfcBooleanOperator.DIFFERENCE = {
    type: 3,
    value: "DIFFERENCE"
  };
  IFC2X32.IfcBooleanOperator = IfcBooleanOperator;

  var IfcBuildingElementProxyTypeEnum = function IfcBuildingElementProxyTypeEnum() {
    _classCallCheck2(this, IfcBuildingElementProxyTypeEnum);
  };

  IfcBuildingElementProxyTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBuildingElementProxyTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;

  var IfcCableCarrierFittingTypeEnum = function IfcCableCarrierFittingTypeEnum() {
    _classCallCheck2(this, IfcCableCarrierFittingTypeEnum);
  };

  IfcCableCarrierFittingTypeEnum.BEND = {
    type: 3,
    value: "BEND"
  };
  IfcCableCarrierFittingTypeEnum.CROSS = {
    type: 3,
    value: "CROSS"
  };
  IfcCableCarrierFittingTypeEnum.REDUCER = {
    type: 3,
    value: "REDUCER"
  };
  IfcCableCarrierFittingTypeEnum.TEE = {
    type: 3,
    value: "TEE"
  };
  IfcCableCarrierFittingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCableCarrierFittingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;

  var IfcCableCarrierSegmentTypeEnum = function IfcCableCarrierSegmentTypeEnum() {
    _classCallCheck2(this, IfcCableCarrierSegmentTypeEnum);
  };

  IfcCableCarrierSegmentTypeEnum.CABLELADDERSEGMENT = {
    type: 3,
    value: "CABLELADDERSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.CABLETRAYSEGMENT = {
    type: 3,
    value: "CABLETRAYSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.CABLETRUNKINGSEGMENT = {
    type: 3,
    value: "CABLETRUNKINGSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.CONDUITSEGMENT = {
    type: 3,
    value: "CONDUITSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCableCarrierSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;

  var IfcCableSegmentTypeEnum = function IfcCableSegmentTypeEnum() {
    _classCallCheck2(this, IfcCableSegmentTypeEnum);
  };

  IfcCableSegmentTypeEnum.CABLESEGMENT = {
    type: 3,
    value: "CABLESEGMENT"
  };
  IfcCableSegmentTypeEnum.CONDUCTORSEGMENT = {
    type: 3,
    value: "CONDUCTORSEGMENT"
  };
  IfcCableSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCableSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;

  var IfcChangeActionEnum = function IfcChangeActionEnum() {
    _classCallCheck2(this, IfcChangeActionEnum);
  };

  IfcChangeActionEnum.NOCHANGE = {
    type: 3,
    value: "NOCHANGE"
  };
  IfcChangeActionEnum.MODIFIED = {
    type: 3,
    value: "MODIFIED"
  };
  IfcChangeActionEnum.ADDED = {
    type: 3,
    value: "ADDED"
  };
  IfcChangeActionEnum.DELETED = {
    type: 3,
    value: "DELETED"
  };
  IfcChangeActionEnum.MODIFIEDADDED = {
    type: 3,
    value: "MODIFIEDADDED"
  };
  IfcChangeActionEnum.MODIFIEDDELETED = {
    type: 3,
    value: "MODIFIEDDELETED"
  };
  IFC2X32.IfcChangeActionEnum = IfcChangeActionEnum;

  var IfcChillerTypeEnum = function IfcChillerTypeEnum() {
    _classCallCheck2(this, IfcChillerTypeEnum);
  };

  IfcChillerTypeEnum.AIRCOOLED = {
    type: 3,
    value: "AIRCOOLED"
  };
  IfcChillerTypeEnum.WATERCOOLED = {
    type: 3,
    value: "WATERCOOLED"
  };
  IfcChillerTypeEnum.HEATRECOVERY = {
    type: 3,
    value: "HEATRECOVERY"
  };
  IfcChillerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcChillerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcChillerTypeEnum = IfcChillerTypeEnum;

  var IfcCoilTypeEnum = function IfcCoilTypeEnum() {
    _classCallCheck2(this, IfcCoilTypeEnum);
  };

  IfcCoilTypeEnum.DXCOOLINGCOIL = {
    type: 3,
    value: "DXCOOLINGCOIL"
  };
  IfcCoilTypeEnum.WATERCOOLINGCOIL = {
    type: 3,
    value: "WATERCOOLINGCOIL"
  };
  IfcCoilTypeEnum.STEAMHEATINGCOIL = {
    type: 3,
    value: "STEAMHEATINGCOIL"
  };
  IfcCoilTypeEnum.WATERHEATINGCOIL = {
    type: 3,
    value: "WATERHEATINGCOIL"
  };
  IfcCoilTypeEnum.ELECTRICHEATINGCOIL = {
    type: 3,
    value: "ELECTRICHEATINGCOIL"
  };
  IfcCoilTypeEnum.GASHEATINGCOIL = {
    type: 3,
    value: "GASHEATINGCOIL"
  };
  IfcCoilTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCoilTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcCoilTypeEnum = IfcCoilTypeEnum;

  var IfcColumnTypeEnum = function IfcColumnTypeEnum() {
    _classCallCheck2(this, IfcColumnTypeEnum);
  };

  IfcColumnTypeEnum.COLUMN = {
    type: 3,
    value: "COLUMN"
  };
  IfcColumnTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcColumnTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcColumnTypeEnum = IfcColumnTypeEnum;

  var IfcCompressorTypeEnum = function IfcCompressorTypeEnum() {
    _classCallCheck2(this, IfcCompressorTypeEnum);
  };

  IfcCompressorTypeEnum.DYNAMIC = {
    type: 3,
    value: "DYNAMIC"
  };
  IfcCompressorTypeEnum.RECIPROCATING = {
    type: 3,
    value: "RECIPROCATING"
  };
  IfcCompressorTypeEnum.ROTARY = {
    type: 3,
    value: "ROTARY"
  };
  IfcCompressorTypeEnum.SCROLL = {
    type: 3,
    value: "SCROLL"
  };
  IfcCompressorTypeEnum.TROCHOIDAL = {
    type: 3,
    value: "TROCHOIDAL"
  };
  IfcCompressorTypeEnum.SINGLESTAGE = {
    type: 3,
    value: "SINGLESTAGE"
  };
  IfcCompressorTypeEnum.BOOSTER = {
    type: 3,
    value: "BOOSTER"
  };
  IfcCompressorTypeEnum.OPENTYPE = {
    type: 3,
    value: "OPENTYPE"
  };
  IfcCompressorTypeEnum.HERMETIC = {
    type: 3,
    value: "HERMETIC"
  };
  IfcCompressorTypeEnum.SEMIHERMETIC = {
    type: 3,
    value: "SEMIHERMETIC"
  };
  IfcCompressorTypeEnum.WELDEDSHELLHERMETIC = {
    type: 3,
    value: "WELDEDSHELLHERMETIC"
  };
  IfcCompressorTypeEnum.ROLLINGPISTON = {
    type: 3,
    value: "ROLLINGPISTON"
  };
  IfcCompressorTypeEnum.ROTARYVANE = {
    type: 3,
    value: "ROTARYVANE"
  };
  IfcCompressorTypeEnum.SINGLESCREW = {
    type: 3,
    value: "SINGLESCREW"
  };
  IfcCompressorTypeEnum.TWINSCREW = {
    type: 3,
    value: "TWINSCREW"
  };
  IfcCompressorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCompressorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcCompressorTypeEnum = IfcCompressorTypeEnum;

  var IfcCondenserTypeEnum = function IfcCondenserTypeEnum() {
    _classCallCheck2(this, IfcCondenserTypeEnum);
  };

  IfcCondenserTypeEnum.WATERCOOLEDSHELLTUBE = {
    type: 3,
    value: "WATERCOOLEDSHELLTUBE"
  };
  IfcCondenserTypeEnum.WATERCOOLEDSHELLCOIL = {
    type: 3,
    value: "WATERCOOLEDSHELLCOIL"
  };
  IfcCondenserTypeEnum.WATERCOOLEDTUBEINTUBE = {
    type: 3,
    value: "WATERCOOLEDTUBEINTUBE"
  };
  IfcCondenserTypeEnum.WATERCOOLEDBRAZEDPLATE = {
    type: 3,
    value: "WATERCOOLEDBRAZEDPLATE"
  };
  IfcCondenserTypeEnum.AIRCOOLED = {
    type: 3,
    value: "AIRCOOLED"
  };
  IfcCondenserTypeEnum.EVAPORATIVECOOLED = {
    type: 3,
    value: "EVAPORATIVECOOLED"
  };
  IfcCondenserTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCondenserTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcCondenserTypeEnum = IfcCondenserTypeEnum;

  var IfcConnectionTypeEnum = function IfcConnectionTypeEnum() {
    _classCallCheck2(this, IfcConnectionTypeEnum);
  };

  IfcConnectionTypeEnum.ATPATH = {
    type: 3,
    value: "ATPATH"
  };
  IfcConnectionTypeEnum.ATSTART = {
    type: 3,
    value: "ATSTART"
  };
  IfcConnectionTypeEnum.ATEND = {
    type: 3,
    value: "ATEND"
  };
  IfcConnectionTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcConnectionTypeEnum = IfcConnectionTypeEnum;

  var IfcConstraintEnum = function IfcConstraintEnum() {
    _classCallCheck2(this, IfcConstraintEnum);
  };

  IfcConstraintEnum.HARD = {
    type: 3,
    value: "HARD"
  };
  IfcConstraintEnum.SOFT = {
    type: 3,
    value: "SOFT"
  };
  IfcConstraintEnum.ADVISORY = {
    type: 3,
    value: "ADVISORY"
  };
  IfcConstraintEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcConstraintEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcConstraintEnum = IfcConstraintEnum;

  var IfcControllerTypeEnum = function IfcControllerTypeEnum() {
    _classCallCheck2(this, IfcControllerTypeEnum);
  };

  IfcControllerTypeEnum.FLOATING = {
    type: 3,
    value: "FLOATING"
  };
  IfcControllerTypeEnum.PROPORTIONAL = {
    type: 3,
    value: "PROPORTIONAL"
  };
  IfcControllerTypeEnum.PROPORTIONALINTEGRAL = {
    type: 3,
    value: "PROPORTIONALINTEGRAL"
  };
  IfcControllerTypeEnum.PROPORTIONALINTEGRALDERIVATIVE = {
    type: 3,
    value: "PROPORTIONALINTEGRALDERIVATIVE"
  };
  IfcControllerTypeEnum.TIMEDTWOPOSITION = {
    type: 3,
    value: "TIMEDTWOPOSITION"
  };
  IfcControllerTypeEnum.TWOPOSITION = {
    type: 3,
    value: "TWOPOSITION"
  };
  IfcControllerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcControllerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcControllerTypeEnum = IfcControllerTypeEnum;

  var IfcCooledBeamTypeEnum = function IfcCooledBeamTypeEnum() {
    _classCallCheck2(this, IfcCooledBeamTypeEnum);
  };

  IfcCooledBeamTypeEnum.ACTIVE = {
    type: 3,
    value: "ACTIVE"
  };
  IfcCooledBeamTypeEnum.PASSIVE = {
    type: 3,
    value: "PASSIVE"
  };
  IfcCooledBeamTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCooledBeamTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;

  var IfcCoolingTowerTypeEnum = function IfcCoolingTowerTypeEnum() {
    _classCallCheck2(this, IfcCoolingTowerTypeEnum);
  };

  IfcCoolingTowerTypeEnum.NATURALDRAFT = {
    type: 3,
    value: "NATURALDRAFT"
  };
  IfcCoolingTowerTypeEnum.MECHANICALINDUCEDDRAFT = {
    type: 3,
    value: "MECHANICALINDUCEDDRAFT"
  };
  IfcCoolingTowerTypeEnum.MECHANICALFORCEDDRAFT = {
    type: 3,
    value: "MECHANICALFORCEDDRAFT"
  };
  IfcCoolingTowerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCoolingTowerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;

  var IfcCostScheduleTypeEnum = function IfcCostScheduleTypeEnum() {
    _classCallCheck2(this, IfcCostScheduleTypeEnum);
  };

  IfcCostScheduleTypeEnum.BUDGET = {
    type: 3,
    value: "BUDGET"
  };
  IfcCostScheduleTypeEnum.COSTPLAN = {
    type: 3,
    value: "COSTPLAN"
  };
  IfcCostScheduleTypeEnum.ESTIMATE = {
    type: 3,
    value: "ESTIMATE"
  };
  IfcCostScheduleTypeEnum.TENDER = {
    type: 3,
    value: "TENDER"
  };
  IfcCostScheduleTypeEnum.PRICEDBILLOFQUANTITIES = {
    type: 3,
    value: "PRICEDBILLOFQUANTITIES"
  };
  IfcCostScheduleTypeEnum.UNPRICEDBILLOFQUANTITIES = {
    type: 3,
    value: "UNPRICEDBILLOFQUANTITIES"
  };
  IfcCostScheduleTypeEnum.SCHEDULEOFRATES = {
    type: 3,
    value: "SCHEDULEOFRATES"
  };
  IfcCostScheduleTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCostScheduleTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;

  var IfcCoveringTypeEnum = function IfcCoveringTypeEnum() {
    _classCallCheck2(this, IfcCoveringTypeEnum);
  };

  IfcCoveringTypeEnum.CEILING = {
    type: 3,
    value: "CEILING"
  };
  IfcCoveringTypeEnum.FLOORING = {
    type: 3,
    value: "FLOORING"
  };
  IfcCoveringTypeEnum.CLADDING = {
    type: 3,
    value: "CLADDING"
  };
  IfcCoveringTypeEnum.ROOFING = {
    type: 3,
    value: "ROOFING"
  };
  IfcCoveringTypeEnum.INSULATION = {
    type: 3,
    value: "INSULATION"
  };
  IfcCoveringTypeEnum.MEMBRANE = {
    type: 3,
    value: "MEMBRANE"
  };
  IfcCoveringTypeEnum.SLEEVING = {
    type: 3,
    value: "SLEEVING"
  };
  IfcCoveringTypeEnum.WRAPPING = {
    type: 3,
    value: "WRAPPING"
  };
  IfcCoveringTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCoveringTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcCoveringTypeEnum = IfcCoveringTypeEnum;

  var IfcCurrencyEnum = function IfcCurrencyEnum() {
    _classCallCheck2(this, IfcCurrencyEnum);
  };

  IfcCurrencyEnum.AED = {
    type: 3,
    value: "AED"
  };
  IfcCurrencyEnum.AES = {
    type: 3,
    value: "AES"
  };
  IfcCurrencyEnum.ATS = {
    type: 3,
    value: "ATS"
  };
  IfcCurrencyEnum.AUD = {
    type: 3,
    value: "AUD"
  };
  IfcCurrencyEnum.BBD = {
    type: 3,
    value: "BBD"
  };
  IfcCurrencyEnum.BEG = {
    type: 3,
    value: "BEG"
  };
  IfcCurrencyEnum.BGL = {
    type: 3,
    value: "BGL"
  };
  IfcCurrencyEnum.BHD = {
    type: 3,
    value: "BHD"
  };
  IfcCurrencyEnum.BMD = {
    type: 3,
    value: "BMD"
  };
  IfcCurrencyEnum.BND = {
    type: 3,
    value: "BND"
  };
  IfcCurrencyEnum.BRL = {
    type: 3,
    value: "BRL"
  };
  IfcCurrencyEnum.BSD = {
    type: 3,
    value: "BSD"
  };
  IfcCurrencyEnum.BWP = {
    type: 3,
    value: "BWP"
  };
  IfcCurrencyEnum.BZD = {
    type: 3,
    value: "BZD"
  };
  IfcCurrencyEnum.CAD = {
    type: 3,
    value: "CAD"
  };
  IfcCurrencyEnum.CBD = {
    type: 3,
    value: "CBD"
  };
  IfcCurrencyEnum.CHF = {
    type: 3,
    value: "CHF"
  };
  IfcCurrencyEnum.CLP = {
    type: 3,
    value: "CLP"
  };
  IfcCurrencyEnum.CNY = {
    type: 3,
    value: "CNY"
  };
  IfcCurrencyEnum.CYS = {
    type: 3,
    value: "CYS"
  };
  IfcCurrencyEnum.CZK = {
    type: 3,
    value: "CZK"
  };
  IfcCurrencyEnum.DDP = {
    type: 3,
    value: "DDP"
  };
  IfcCurrencyEnum.DEM = {
    type: 3,
    value: "DEM"
  };
  IfcCurrencyEnum.DKK = {
    type: 3,
    value: "DKK"
  };
  IfcCurrencyEnum.EGL = {
    type: 3,
    value: "EGL"
  };
  IfcCurrencyEnum.EST = {
    type: 3,
    value: "EST"
  };
  IfcCurrencyEnum.EUR = {
    type: 3,
    value: "EUR"
  };
  IfcCurrencyEnum.FAK = {
    type: 3,
    value: "FAK"
  };
  IfcCurrencyEnum.FIM = {
    type: 3,
    value: "FIM"
  };
  IfcCurrencyEnum.FJD = {
    type: 3,
    value: "FJD"
  };
  IfcCurrencyEnum.FKP = {
    type: 3,
    value: "FKP"
  };
  IfcCurrencyEnum.FRF = {
    type: 3,
    value: "FRF"
  };
  IfcCurrencyEnum.GBP = {
    type: 3,
    value: "GBP"
  };
  IfcCurrencyEnum.GIP = {
    type: 3,
    value: "GIP"
  };
  IfcCurrencyEnum.GMD = {
    type: 3,
    value: "GMD"
  };
  IfcCurrencyEnum.GRX = {
    type: 3,
    value: "GRX"
  };
  IfcCurrencyEnum.HKD = {
    type: 3,
    value: "HKD"
  };
  IfcCurrencyEnum.HUF = {
    type: 3,
    value: "HUF"
  };
  IfcCurrencyEnum.ICK = {
    type: 3,
    value: "ICK"
  };
  IfcCurrencyEnum.IDR = {
    type: 3,
    value: "IDR"
  };
  IfcCurrencyEnum.ILS = {
    type: 3,
    value: "ILS"
  };
  IfcCurrencyEnum.INR = {
    type: 3,
    value: "INR"
  };
  IfcCurrencyEnum.IRP = {
    type: 3,
    value: "IRP"
  };
  IfcCurrencyEnum.ITL = {
    type: 3,
    value: "ITL"
  };
  IfcCurrencyEnum.JMD = {
    type: 3,
    value: "JMD"
  };
  IfcCurrencyEnum.JOD = {
    type: 3,
    value: "JOD"
  };
  IfcCurrencyEnum.JPY = {
    type: 3,
    value: "JPY"
  };
  IfcCurrencyEnum.KES = {
    type: 3,
    value: "KES"
  };
  IfcCurrencyEnum.KRW = {
    type: 3,
    value: "KRW"
  };
  IfcCurrencyEnum.KWD = {
    type: 3,
    value: "KWD"
  };
  IfcCurrencyEnum.KYD = {
    type: 3,
    value: "KYD"
  };
  IfcCurrencyEnum.LKR = {
    type: 3,
    value: "LKR"
  };
  IfcCurrencyEnum.LUF = {
    type: 3,
    value: "LUF"
  };
  IfcCurrencyEnum.MTL = {
    type: 3,
    value: "MTL"
  };
  IfcCurrencyEnum.MUR = {
    type: 3,
    value: "MUR"
  };
  IfcCurrencyEnum.MXN = {
    type: 3,
    value: "MXN"
  };
  IfcCurrencyEnum.MYR = {
    type: 3,
    value: "MYR"
  };
  IfcCurrencyEnum.NLG = {
    type: 3,
    value: "NLG"
  };
  IfcCurrencyEnum.NZD = {
    type: 3,
    value: "NZD"
  };
  IfcCurrencyEnum.OMR = {
    type: 3,
    value: "OMR"
  };
  IfcCurrencyEnum.PGK = {
    type: 3,
    value: "PGK"
  };
  IfcCurrencyEnum.PHP = {
    type: 3,
    value: "PHP"
  };
  IfcCurrencyEnum.PKR = {
    type: 3,
    value: "PKR"
  };
  IfcCurrencyEnum.PLN = {
    type: 3,
    value: "PLN"
  };
  IfcCurrencyEnum.PTN = {
    type: 3,
    value: "PTN"
  };
  IfcCurrencyEnum.QAR = {
    type: 3,
    value: "QAR"
  };
  IfcCurrencyEnum.RUR = {
    type: 3,
    value: "RUR"
  };
  IfcCurrencyEnum.SAR = {
    type: 3,
    value: "SAR"
  };
  IfcCurrencyEnum.SCR = {
    type: 3,
    value: "SCR"
  };
  IfcCurrencyEnum.SEK = {
    type: 3,
    value: "SEK"
  };
  IfcCurrencyEnum.SGD = {
    type: 3,
    value: "SGD"
  };
  IfcCurrencyEnum.SKP = {
    type: 3,
    value: "SKP"
  };
  IfcCurrencyEnum.THB = {
    type: 3,
    value: "THB"
  };
  IfcCurrencyEnum.TRL = {
    type: 3,
    value: "TRL"
  };
  IfcCurrencyEnum.TTD = {
    type: 3,
    value: "TTD"
  };
  IfcCurrencyEnum.TWD = {
    type: 3,
    value: "TWD"
  };
  IfcCurrencyEnum.USD = {
    type: 3,
    value: "USD"
  };
  IfcCurrencyEnum.VEB = {
    type: 3,
    value: "VEB"
  };
  IfcCurrencyEnum.VND = {
    type: 3,
    value: "VND"
  };
  IfcCurrencyEnum.XEU = {
    type: 3,
    value: "XEU"
  };
  IfcCurrencyEnum.ZAR = {
    type: 3,
    value: "ZAR"
  };
  IfcCurrencyEnum.ZWD = {
    type: 3,
    value: "ZWD"
  };
  IfcCurrencyEnum.NOK = {
    type: 3,
    value: "NOK"
  };
  IFC2X32.IfcCurrencyEnum = IfcCurrencyEnum;

  var IfcCurtainWallTypeEnum = function IfcCurtainWallTypeEnum() {
    _classCallCheck2(this, IfcCurtainWallTypeEnum);
  };

  IfcCurtainWallTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCurtainWallTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;

  var IfcDamperTypeEnum = function IfcDamperTypeEnum() {
    _classCallCheck2(this, IfcDamperTypeEnum);
  };

  IfcDamperTypeEnum.CONTROLDAMPER = {
    type: 3,
    value: "CONTROLDAMPER"
  };
  IfcDamperTypeEnum.FIREDAMPER = {
    type: 3,
    value: "FIREDAMPER"
  };
  IfcDamperTypeEnum.SMOKEDAMPER = {
    type: 3,
    value: "SMOKEDAMPER"
  };
  IfcDamperTypeEnum.FIRESMOKEDAMPER = {
    type: 3,
    value: "FIRESMOKEDAMPER"
  };
  IfcDamperTypeEnum.BACKDRAFTDAMPER = {
    type: 3,
    value: "BACKDRAFTDAMPER"
  };
  IfcDamperTypeEnum.RELIEFDAMPER = {
    type: 3,
    value: "RELIEFDAMPER"
  };
  IfcDamperTypeEnum.BLASTDAMPER = {
    type: 3,
    value: "BLASTDAMPER"
  };
  IfcDamperTypeEnum.GRAVITYDAMPER = {
    type: 3,
    value: "GRAVITYDAMPER"
  };
  IfcDamperTypeEnum.GRAVITYRELIEFDAMPER = {
    type: 3,
    value: "GRAVITYRELIEFDAMPER"
  };
  IfcDamperTypeEnum.BALANCINGDAMPER = {
    type: 3,
    value: "BALANCINGDAMPER"
  };
  IfcDamperTypeEnum.FUMEHOODEXHAUST = {
    type: 3,
    value: "FUMEHOODEXHAUST"
  };
  IfcDamperTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDamperTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDamperTypeEnum = IfcDamperTypeEnum;

  var IfcDataOriginEnum = function IfcDataOriginEnum() {
    _classCallCheck2(this, IfcDataOriginEnum);
  };

  IfcDataOriginEnum.MEASURED = {
    type: 3,
    value: "MEASURED"
  };
  IfcDataOriginEnum.PREDICTED = {
    type: 3,
    value: "PREDICTED"
  };
  IfcDataOriginEnum.SIMULATED = {
    type: 3,
    value: "SIMULATED"
  };
  IfcDataOriginEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDataOriginEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDataOriginEnum = IfcDataOriginEnum;

  var IfcDerivedUnitEnum = function IfcDerivedUnitEnum() {
    _classCallCheck2(this, IfcDerivedUnitEnum);
  };

  IfcDerivedUnitEnum.ANGULARVELOCITYUNIT = {
    type: 3,
    value: "ANGULARVELOCITYUNIT"
  };
  IfcDerivedUnitEnum.COMPOUNDPLANEANGLEUNIT = {
    type: 3,
    value: "COMPOUNDPLANEANGLEUNIT"
  };
  IfcDerivedUnitEnum.DYNAMICVISCOSITYUNIT = {
    type: 3,
    value: "DYNAMICVISCOSITYUNIT"
  };
  IfcDerivedUnitEnum.HEATFLUXDENSITYUNIT = {
    type: 3,
    value: "HEATFLUXDENSITYUNIT"
  };
  IfcDerivedUnitEnum.INTEGERCOUNTRATEUNIT = {
    type: 3,
    value: "INTEGERCOUNTRATEUNIT"
  };
  IfcDerivedUnitEnum.ISOTHERMALMOISTURECAPACITYUNIT = {
    type: 3,
    value: "ISOTHERMALMOISTURECAPACITYUNIT"
  };
  IfcDerivedUnitEnum.KINEMATICVISCOSITYUNIT = {
    type: 3,
    value: "KINEMATICVISCOSITYUNIT"
  };
  IfcDerivedUnitEnum.LINEARVELOCITYUNIT = {
    type: 3,
    value: "LINEARVELOCITYUNIT"
  };
  IfcDerivedUnitEnum.MASSDENSITYUNIT = {
    type: 3,
    value: "MASSDENSITYUNIT"
  };
  IfcDerivedUnitEnum.MASSFLOWRATEUNIT = {
    type: 3,
    value: "MASSFLOWRATEUNIT"
  };
  IfcDerivedUnitEnum.MOISTUREDIFFUSIVITYUNIT = {
    type: 3,
    value: "MOISTUREDIFFUSIVITYUNIT"
  };
  IfcDerivedUnitEnum.MOLECULARWEIGHTUNIT = {
    type: 3,
    value: "MOLECULARWEIGHTUNIT"
  };
  IfcDerivedUnitEnum.SPECIFICHEATCAPACITYUNIT = {
    type: 3,
    value: "SPECIFICHEATCAPACITYUNIT"
  };
  IfcDerivedUnitEnum.THERMALADMITTANCEUNIT = {
    type: 3,
    value: "THERMALADMITTANCEUNIT"
  };
  IfcDerivedUnitEnum.THERMALCONDUCTANCEUNIT = {
    type: 3,
    value: "THERMALCONDUCTANCEUNIT"
  };
  IfcDerivedUnitEnum.THERMALRESISTANCEUNIT = {
    type: 3,
    value: "THERMALRESISTANCEUNIT"
  };
  IfcDerivedUnitEnum.THERMALTRANSMITTANCEUNIT = {
    type: 3,
    value: "THERMALTRANSMITTANCEUNIT"
  };
  IfcDerivedUnitEnum.VAPORPERMEABILITYUNIT = {
    type: 3,
    value: "VAPORPERMEABILITYUNIT"
  };
  IfcDerivedUnitEnum.VOLUMETRICFLOWRATEUNIT = {
    type: 3,
    value: "VOLUMETRICFLOWRATEUNIT"
  };
  IfcDerivedUnitEnum.ROTATIONALFREQUENCYUNIT = {
    type: 3,
    value: "ROTATIONALFREQUENCYUNIT"
  };
  IfcDerivedUnitEnum.TORQUEUNIT = {
    type: 3,
    value: "TORQUEUNIT"
  };
  IfcDerivedUnitEnum.MOMENTOFINERTIAUNIT = {
    type: 3,
    value: "MOMENTOFINERTIAUNIT"
  };
  IfcDerivedUnitEnum.LINEARMOMENTUNIT = {
    type: 3,
    value: "LINEARMOMENTUNIT"
  };
  IfcDerivedUnitEnum.LINEARFORCEUNIT = {
    type: 3,
    value: "LINEARFORCEUNIT"
  };
  IfcDerivedUnitEnum.PLANARFORCEUNIT = {
    type: 3,
    value: "PLANARFORCEUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFELASTICITYUNIT = {
    type: 3,
    value: "MODULUSOFELASTICITYUNIT"
  };
  IfcDerivedUnitEnum.SHEARMODULUSUNIT = {
    type: 3,
    value: "SHEARMODULUSUNIT"
  };
  IfcDerivedUnitEnum.LINEARSTIFFNESSUNIT = {
    type: 3,
    value: "LINEARSTIFFNESSUNIT"
  };
  IfcDerivedUnitEnum.ROTATIONALSTIFFNESSUNIT = {
    type: 3,
    value: "ROTATIONALSTIFFNESSUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFSUBGRADEREACTIONUNIT = {
    type: 3,
    value: "MODULUSOFSUBGRADEREACTIONUNIT"
  };
  IfcDerivedUnitEnum.ACCELERATIONUNIT = {
    type: 3,
    value: "ACCELERATIONUNIT"
  };
  IfcDerivedUnitEnum.CURVATUREUNIT = {
    type: 3,
    value: "CURVATUREUNIT"
  };
  IfcDerivedUnitEnum.HEATINGVALUEUNIT = {
    type: 3,
    value: "HEATINGVALUEUNIT"
  };
  IfcDerivedUnitEnum.IONCONCENTRATIONUNIT = {
    type: 3,
    value: "IONCONCENTRATIONUNIT"
  };
  IfcDerivedUnitEnum.LUMINOUSINTENSITYDISTRIBUTIONUNIT = {
    type: 3,
    value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT"
  };
  IfcDerivedUnitEnum.MASSPERLENGTHUNIT = {
    type: 3,
    value: "MASSPERLENGTHUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFLINEARSUBGRADEREACTIONUNIT = {
    type: 3,
    value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = {
    type: 3,
    value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT"
  };
  IfcDerivedUnitEnum.PHUNIT = {
    type: 3,
    value: "PHUNIT"
  };
  IfcDerivedUnitEnum.ROTATIONALMASSUNIT = {
    type: 3,
    value: "ROTATIONALMASSUNIT"
  };
  IfcDerivedUnitEnum.SECTIONAREAINTEGRALUNIT = {
    type: 3,
    value: "SECTIONAREAINTEGRALUNIT"
  };
  IfcDerivedUnitEnum.SECTIONMODULUSUNIT = {
    type: 3,
    value: "SECTIONMODULUSUNIT"
  };
  IfcDerivedUnitEnum.SOUNDPOWERUNIT = {
    type: 3,
    value: "SOUNDPOWERUNIT"
  };
  IfcDerivedUnitEnum.SOUNDPRESSUREUNIT = {
    type: 3,
    value: "SOUNDPRESSUREUNIT"
  };
  IfcDerivedUnitEnum.TEMPERATUREGRADIENTUNIT = {
    type: 3,
    value: "TEMPERATUREGRADIENTUNIT"
  };
  IfcDerivedUnitEnum.THERMALEXPANSIONCOEFFICIENTUNIT = {
    type: 3,
    value: "THERMALEXPANSIONCOEFFICIENTUNIT"
  };
  IfcDerivedUnitEnum.WARPINGCONSTANTUNIT = {
    type: 3,
    value: "WARPINGCONSTANTUNIT"
  };
  IfcDerivedUnitEnum.WARPINGMOMENTUNIT = {
    type: 3,
    value: "WARPINGMOMENTUNIT"
  };
  IfcDerivedUnitEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC2X32.IfcDerivedUnitEnum = IfcDerivedUnitEnum;

  var IfcDimensionExtentUsage = function IfcDimensionExtentUsage() {
    _classCallCheck2(this, IfcDimensionExtentUsage);
  };

  IfcDimensionExtentUsage.ORIGIN = {
    type: 3,
    value: "ORIGIN"
  };
  IfcDimensionExtentUsage.TARGET = {
    type: 3,
    value: "TARGET"
  };
  IFC2X32.IfcDimensionExtentUsage = IfcDimensionExtentUsage;

  var IfcDirectionSenseEnum = function IfcDirectionSenseEnum() {
    _classCallCheck2(this, IfcDirectionSenseEnum);
  };

  IfcDirectionSenseEnum.POSITIVE = {
    type: 3,
    value: "POSITIVE"
  };
  IfcDirectionSenseEnum.NEGATIVE = {
    type: 3,
    value: "NEGATIVE"
  };
  IFC2X32.IfcDirectionSenseEnum = IfcDirectionSenseEnum;

  var IfcDistributionChamberElementTypeEnum = function IfcDistributionChamberElementTypeEnum() {
    _classCallCheck2(this, IfcDistributionChamberElementTypeEnum);
  };

  IfcDistributionChamberElementTypeEnum.FORMEDDUCT = {
    type: 3,
    value: "FORMEDDUCT"
  };
  IfcDistributionChamberElementTypeEnum.INSPECTIONCHAMBER = {
    type: 3,
    value: "INSPECTIONCHAMBER"
  };
  IfcDistributionChamberElementTypeEnum.INSPECTIONPIT = {
    type: 3,
    value: "INSPECTIONPIT"
  };
  IfcDistributionChamberElementTypeEnum.MANHOLE = {
    type: 3,
    value: "MANHOLE"
  };
  IfcDistributionChamberElementTypeEnum.METERCHAMBER = {
    type: 3,
    value: "METERCHAMBER"
  };
  IfcDistributionChamberElementTypeEnum.SUMP = {
    type: 3,
    value: "SUMP"
  };
  IfcDistributionChamberElementTypeEnum.TRENCH = {
    type: 3,
    value: "TRENCH"
  };
  IfcDistributionChamberElementTypeEnum.VALVECHAMBER = {
    type: 3,
    value: "VALVECHAMBER"
  };
  IfcDistributionChamberElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDistributionChamberElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;

  var IfcDocumentConfidentialityEnum = function IfcDocumentConfidentialityEnum() {
    _classCallCheck2(this, IfcDocumentConfidentialityEnum);
  };

  IfcDocumentConfidentialityEnum.PUBLIC = {
    type: 3,
    value: "PUBLIC"
  };
  IfcDocumentConfidentialityEnum.RESTRICTED = {
    type: 3,
    value: "RESTRICTED"
  };
  IfcDocumentConfidentialityEnum.CONFIDENTIAL = {
    type: 3,
    value: "CONFIDENTIAL"
  };
  IfcDocumentConfidentialityEnum.PERSONAL = {
    type: 3,
    value: "PERSONAL"
  };
  IfcDocumentConfidentialityEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDocumentConfidentialityEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;

  var IfcDocumentStatusEnum = function IfcDocumentStatusEnum() {
    _classCallCheck2(this, IfcDocumentStatusEnum);
  };

  IfcDocumentStatusEnum.DRAFT = {
    type: 3,
    value: "DRAFT"
  };
  IfcDocumentStatusEnum.FINALDRAFT = {
    type: 3,
    value: "FINALDRAFT"
  };
  IfcDocumentStatusEnum.FINAL = {
    type: 3,
    value: "FINAL"
  };
  IfcDocumentStatusEnum.REVISION = {
    type: 3,
    value: "REVISION"
  };
  IfcDocumentStatusEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDocumentStatusEnum = IfcDocumentStatusEnum;

  var IfcDoorPanelOperationEnum = function IfcDoorPanelOperationEnum() {
    _classCallCheck2(this, IfcDoorPanelOperationEnum);
  };

  IfcDoorPanelOperationEnum.SWINGING = {
    type: 3,
    value: "SWINGING"
  };
  IfcDoorPanelOperationEnum.DOUBLE_ACTING = {
    type: 3,
    value: "DOUBLE_ACTING"
  };
  IfcDoorPanelOperationEnum.SLIDING = {
    type: 3,
    value: "SLIDING"
  };
  IfcDoorPanelOperationEnum.FOLDING = {
    type: 3,
    value: "FOLDING"
  };
  IfcDoorPanelOperationEnum.REVOLVING = {
    type: 3,
    value: "REVOLVING"
  };
  IfcDoorPanelOperationEnum.ROLLINGUP = {
    type: 3,
    value: "ROLLINGUP"
  };
  IfcDoorPanelOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorPanelOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;

  var IfcDoorPanelPositionEnum = function IfcDoorPanelPositionEnum() {
    _classCallCheck2(this, IfcDoorPanelPositionEnum);
  };

  IfcDoorPanelPositionEnum.LEFT = {
    type: 3,
    value: "LEFT"
  };
  IfcDoorPanelPositionEnum.MIDDLE = {
    type: 3,
    value: "MIDDLE"
  };
  IfcDoorPanelPositionEnum.RIGHT = {
    type: 3,
    value: "RIGHT"
  };
  IfcDoorPanelPositionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;

  var IfcDoorStyleConstructionEnum = function IfcDoorStyleConstructionEnum() {
    _classCallCheck2(this, IfcDoorStyleConstructionEnum);
  };

  IfcDoorStyleConstructionEnum.ALUMINIUM = {
    type: 3,
    value: "ALUMINIUM"
  };
  IfcDoorStyleConstructionEnum.HIGH_GRADE_STEEL = {
    type: 3,
    value: "HIGH_GRADE_STEEL"
  };
  IfcDoorStyleConstructionEnum.STEEL = {
    type: 3,
    value: "STEEL"
  };
  IfcDoorStyleConstructionEnum.WOOD = {
    type: 3,
    value: "WOOD"
  };
  IfcDoorStyleConstructionEnum.ALUMINIUM_WOOD = {
    type: 3,
    value: "ALUMINIUM_WOOD"
  };
  IfcDoorStyleConstructionEnum.ALUMINIUM_PLASTIC = {
    type: 3,
    value: "ALUMINIUM_PLASTIC"
  };
  IfcDoorStyleConstructionEnum.PLASTIC = {
    type: 3,
    value: "PLASTIC"
  };
  IfcDoorStyleConstructionEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorStyleConstructionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDoorStyleConstructionEnum = IfcDoorStyleConstructionEnum;

  var IfcDoorStyleOperationEnum = function IfcDoorStyleOperationEnum() {
    _classCallCheck2(this, IfcDoorStyleOperationEnum);
  };

  IfcDoorStyleOperationEnum.SINGLE_SWING_LEFT = {
    type: 3,
    value: "SINGLE_SWING_LEFT"
  };
  IfcDoorStyleOperationEnum.SINGLE_SWING_RIGHT = {
    type: 3,
    value: "SINGLE_SWING_RIGHT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_LEFT = {
    type: 3,
    value: "DOUBLE_SWING_LEFT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_RIGHT = {
    type: 3,
    value: "DOUBLE_SWING_RIGHT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_DOUBLE_SWING = {
    type: 3,
    value: "DOUBLE_DOOR_DOUBLE_SWING"
  };
  IfcDoorStyleOperationEnum.SLIDING_TO_LEFT = {
    type: 3,
    value: "SLIDING_TO_LEFT"
  };
  IfcDoorStyleOperationEnum.SLIDING_TO_RIGHT = {
    type: 3,
    value: "SLIDING_TO_RIGHT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SLIDING = {
    type: 3,
    value: "DOUBLE_DOOR_SLIDING"
  };
  IfcDoorStyleOperationEnum.FOLDING_TO_LEFT = {
    type: 3,
    value: "FOLDING_TO_LEFT"
  };
  IfcDoorStyleOperationEnum.FOLDING_TO_RIGHT = {
    type: 3,
    value: "FOLDING_TO_RIGHT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_FOLDING = {
    type: 3,
    value: "DOUBLE_DOOR_FOLDING"
  };
  IfcDoorStyleOperationEnum.REVOLVING = {
    type: 3,
    value: "REVOLVING"
  };
  IfcDoorStyleOperationEnum.ROLLINGUP = {
    type: 3,
    value: "ROLLINGUP"
  };
  IfcDoorStyleOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorStyleOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDoorStyleOperationEnum = IfcDoorStyleOperationEnum;

  var IfcDuctFittingTypeEnum = function IfcDuctFittingTypeEnum() {
    _classCallCheck2(this, IfcDuctFittingTypeEnum);
  };

  IfcDuctFittingTypeEnum.BEND = {
    type: 3,
    value: "BEND"
  };
  IfcDuctFittingTypeEnum.CONNECTOR = {
    type: 3,
    value: "CONNECTOR"
  };
  IfcDuctFittingTypeEnum.ENTRY = {
    type: 3,
    value: "ENTRY"
  };
  IfcDuctFittingTypeEnum.EXIT = {
    type: 3,
    value: "EXIT"
  };
  IfcDuctFittingTypeEnum.JUNCTION = {
    type: 3,
    value: "JUNCTION"
  };
  IfcDuctFittingTypeEnum.OBSTRUCTION = {
    type: 3,
    value: "OBSTRUCTION"
  };
  IfcDuctFittingTypeEnum.TRANSITION = {
    type: 3,
    value: "TRANSITION"
  };
  IfcDuctFittingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDuctFittingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;

  var IfcDuctSegmentTypeEnum = function IfcDuctSegmentTypeEnum() {
    _classCallCheck2(this, IfcDuctSegmentTypeEnum);
  };

  IfcDuctSegmentTypeEnum.RIGIDSEGMENT = {
    type: 3,
    value: "RIGIDSEGMENT"
  };
  IfcDuctSegmentTypeEnum.FLEXIBLESEGMENT = {
    type: 3,
    value: "FLEXIBLESEGMENT"
  };
  IfcDuctSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDuctSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;

  var IfcDuctSilencerTypeEnum = function IfcDuctSilencerTypeEnum() {
    _classCallCheck2(this, IfcDuctSilencerTypeEnum);
  };

  IfcDuctSilencerTypeEnum.FLATOVAL = {
    type: 3,
    value: "FLATOVAL"
  };
  IfcDuctSilencerTypeEnum.RECTANGULAR = {
    type: 3,
    value: "RECTANGULAR"
  };
  IfcDuctSilencerTypeEnum.ROUND = {
    type: 3,
    value: "ROUND"
  };
  IfcDuctSilencerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDuctSilencerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;

  var IfcElectricApplianceTypeEnum = function IfcElectricApplianceTypeEnum() {
    _classCallCheck2(this, IfcElectricApplianceTypeEnum);
  };

  IfcElectricApplianceTypeEnum.COMPUTER = {
    type: 3,
    value: "COMPUTER"
  };
  IfcElectricApplianceTypeEnum.DIRECTWATERHEATER = {
    type: 3,
    value: "DIRECTWATERHEATER"
  };
  IfcElectricApplianceTypeEnum.DISHWASHER = {
    type: 3,
    value: "DISHWASHER"
  };
  IfcElectricApplianceTypeEnum.ELECTRICCOOKER = {
    type: 3,
    value: "ELECTRICCOOKER"
  };
  IfcElectricApplianceTypeEnum.ELECTRICHEATER = {
    type: 3,
    value: "ELECTRICHEATER"
  };
  IfcElectricApplianceTypeEnum.FACSIMILE = {
    type: 3,
    value: "FACSIMILE"
  };
  IfcElectricApplianceTypeEnum.FREESTANDINGFAN = {
    type: 3,
    value: "FREESTANDINGFAN"
  };
  IfcElectricApplianceTypeEnum.FREEZER = {
    type: 3,
    value: "FREEZER"
  };
  IfcElectricApplianceTypeEnum.FRIDGE_FREEZER = {
    type: 3,
    value: "FRIDGE_FREEZER"
  };
  IfcElectricApplianceTypeEnum.HANDDRYER = {
    type: 3,
    value: "HANDDRYER"
  };
  IfcElectricApplianceTypeEnum.INDIRECTWATERHEATER = {
    type: 3,
    value: "INDIRECTWATERHEATER"
  };
  IfcElectricApplianceTypeEnum.MICROWAVE = {
    type: 3,
    value: "MICROWAVE"
  };
  IfcElectricApplianceTypeEnum.PHOTOCOPIER = {
    type: 3,
    value: "PHOTOCOPIER"
  };
  IfcElectricApplianceTypeEnum.PRINTER = {
    type: 3,
    value: "PRINTER"
  };
  IfcElectricApplianceTypeEnum.REFRIGERATOR = {
    type: 3,
    value: "REFRIGERATOR"
  };
  IfcElectricApplianceTypeEnum.RADIANTHEATER = {
    type: 3,
    value: "RADIANTHEATER"
  };
  IfcElectricApplianceTypeEnum.SCANNER = {
    type: 3,
    value: "SCANNER"
  };
  IfcElectricApplianceTypeEnum.TELEPHONE = {
    type: 3,
    value: "TELEPHONE"
  };
  IfcElectricApplianceTypeEnum.TUMBLEDRYER = {
    type: 3,
    value: "TUMBLEDRYER"
  };
  IfcElectricApplianceTypeEnum.TV = {
    type: 3,
    value: "TV"
  };
  IfcElectricApplianceTypeEnum.VENDINGMACHINE = {
    type: 3,
    value: "VENDINGMACHINE"
  };
  IfcElectricApplianceTypeEnum.WASHINGMACHINE = {
    type: 3,
    value: "WASHINGMACHINE"
  };
  IfcElectricApplianceTypeEnum.WATERHEATER = {
    type: 3,
    value: "WATERHEATER"
  };
  IfcElectricApplianceTypeEnum.WATERCOOLER = {
    type: 3,
    value: "WATERCOOLER"
  };
  IfcElectricApplianceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricApplianceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;

  var IfcElectricCurrentEnum = function IfcElectricCurrentEnum() {
    _classCallCheck2(this, IfcElectricCurrentEnum);
  };

  IfcElectricCurrentEnum.ALTERNATING = {
    type: 3,
    value: "ALTERNATING"
  };
  IfcElectricCurrentEnum.DIRECT = {
    type: 3,
    value: "DIRECT"
  };
  IfcElectricCurrentEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcElectricCurrentEnum = IfcElectricCurrentEnum;

  var IfcElectricDistributionPointFunctionEnum = function IfcElectricDistributionPointFunctionEnum() {
    _classCallCheck2(this, IfcElectricDistributionPointFunctionEnum);
  };

  IfcElectricDistributionPointFunctionEnum.ALARMPANEL = {
    type: 3,
    value: "ALARMPANEL"
  };
  IfcElectricDistributionPointFunctionEnum.CONSUMERUNIT = {
    type: 3,
    value: "CONSUMERUNIT"
  };
  IfcElectricDistributionPointFunctionEnum.CONTROLPANEL = {
    type: 3,
    value: "CONTROLPANEL"
  };
  IfcElectricDistributionPointFunctionEnum.DISTRIBUTIONBOARD = {
    type: 3,
    value: "DISTRIBUTIONBOARD"
  };
  IfcElectricDistributionPointFunctionEnum.GASDETECTORPANEL = {
    type: 3,
    value: "GASDETECTORPANEL"
  };
  IfcElectricDistributionPointFunctionEnum.INDICATORPANEL = {
    type: 3,
    value: "INDICATORPANEL"
  };
  IfcElectricDistributionPointFunctionEnum.MIMICPANEL = {
    type: 3,
    value: "MIMICPANEL"
  };
  IfcElectricDistributionPointFunctionEnum.MOTORCONTROLCENTRE = {
    type: 3,
    value: "MOTORCONTROLCENTRE"
  };
  IfcElectricDistributionPointFunctionEnum.SWITCHBOARD = {
    type: 3,
    value: "SWITCHBOARD"
  };
  IfcElectricDistributionPointFunctionEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricDistributionPointFunctionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcElectricDistributionPointFunctionEnum = IfcElectricDistributionPointFunctionEnum;

  var IfcElectricFlowStorageDeviceTypeEnum = function IfcElectricFlowStorageDeviceTypeEnum() {
    _classCallCheck2(this, IfcElectricFlowStorageDeviceTypeEnum);
  };

  IfcElectricFlowStorageDeviceTypeEnum.BATTERY = {
    type: 3,
    value: "BATTERY"
  };
  IfcElectricFlowStorageDeviceTypeEnum.CAPACITORBANK = {
    type: 3,
    value: "CAPACITORBANK"
  };
  IfcElectricFlowStorageDeviceTypeEnum.HARMONICFILTER = {
    type: 3,
    value: "HARMONICFILTER"
  };
  IfcElectricFlowStorageDeviceTypeEnum.INDUCTORBANK = {
    type: 3,
    value: "INDUCTORBANK"
  };
  IfcElectricFlowStorageDeviceTypeEnum.UPS = {
    type: 3,
    value: "UPS"
  };
  IfcElectricFlowStorageDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricFlowStorageDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;

  var IfcElectricGeneratorTypeEnum = function IfcElectricGeneratorTypeEnum() {
    _classCallCheck2(this, IfcElectricGeneratorTypeEnum);
  };

  IfcElectricGeneratorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricGeneratorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;

  var IfcElectricHeaterTypeEnum = function IfcElectricHeaterTypeEnum() {
    _classCallCheck2(this, IfcElectricHeaterTypeEnum);
  };

  IfcElectricHeaterTypeEnum.ELECTRICPOINTHEATER = {
    type: 3,
    value: "ELECTRICPOINTHEATER"
  };
  IfcElectricHeaterTypeEnum.ELECTRICCABLEHEATER = {
    type: 3,
    value: "ELECTRICCABLEHEATER"
  };
  IfcElectricHeaterTypeEnum.ELECTRICMATHEATER = {
    type: 3,
    value: "ELECTRICMATHEATER"
  };
  IfcElectricHeaterTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricHeaterTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcElectricHeaterTypeEnum = IfcElectricHeaterTypeEnum;

  var IfcElectricMotorTypeEnum = function IfcElectricMotorTypeEnum() {
    _classCallCheck2(this, IfcElectricMotorTypeEnum);
  };

  IfcElectricMotorTypeEnum.DC = {
    type: 3,
    value: "DC"
  };
  IfcElectricMotorTypeEnum.INDUCTION = {
    type: 3,
    value: "INDUCTION"
  };
  IfcElectricMotorTypeEnum.POLYPHASE = {
    type: 3,
    value: "POLYPHASE"
  };
  IfcElectricMotorTypeEnum.RELUCTANCESYNCHRONOUS = {
    type: 3,
    value: "RELUCTANCESYNCHRONOUS"
  };
  IfcElectricMotorTypeEnum.SYNCHRONOUS = {
    type: 3,
    value: "SYNCHRONOUS"
  };
  IfcElectricMotorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricMotorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;

  var IfcElectricTimeControlTypeEnum = function IfcElectricTimeControlTypeEnum() {
    _classCallCheck2(this, IfcElectricTimeControlTypeEnum);
  };

  IfcElectricTimeControlTypeEnum.TIMECLOCK = {
    type: 3,
    value: "TIMECLOCK"
  };
  IfcElectricTimeControlTypeEnum.TIMEDELAY = {
    type: 3,
    value: "TIMEDELAY"
  };
  IfcElectricTimeControlTypeEnum.RELAY = {
    type: 3,
    value: "RELAY"
  };
  IfcElectricTimeControlTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricTimeControlTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;

  var IfcElementAssemblyTypeEnum = function IfcElementAssemblyTypeEnum() {
    _classCallCheck2(this, IfcElementAssemblyTypeEnum);
  };

  IfcElementAssemblyTypeEnum.ACCESSORY_ASSEMBLY = {
    type: 3,
    value: "ACCESSORY_ASSEMBLY"
  };
  IfcElementAssemblyTypeEnum.ARCH = {
    type: 3,
    value: "ARCH"
  };
  IfcElementAssemblyTypeEnum.BEAM_GRID = {
    type: 3,
    value: "BEAM_GRID"
  };
  IfcElementAssemblyTypeEnum.BRACED_FRAME = {
    type: 3,
    value: "BRACED_FRAME"
  };
  IfcElementAssemblyTypeEnum.GIRDER = {
    type: 3,
    value: "GIRDER"
  };
  IfcElementAssemblyTypeEnum.REINFORCEMENT_UNIT = {
    type: 3,
    value: "REINFORCEMENT_UNIT"
  };
  IfcElementAssemblyTypeEnum.RIGID_FRAME = {
    type: 3,
    value: "RIGID_FRAME"
  };
  IfcElementAssemblyTypeEnum.SLAB_FIELD = {
    type: 3,
    value: "SLAB_FIELD"
  };
  IfcElementAssemblyTypeEnum.TRUSS = {
    type: 3,
    value: "TRUSS"
  };
  IfcElementAssemblyTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElementAssemblyTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;

  var IfcElementCompositionEnum = function IfcElementCompositionEnum() {
    _classCallCheck2(this, IfcElementCompositionEnum);
  };

  IfcElementCompositionEnum.COMPLEX = {
    type: 3,
    value: "COMPLEX"
  };
  IfcElementCompositionEnum.ELEMENT = {
    type: 3,
    value: "ELEMENT"
  };
  IfcElementCompositionEnum.PARTIAL = {
    type: 3,
    value: "PARTIAL"
  };
  IFC2X32.IfcElementCompositionEnum = IfcElementCompositionEnum;

  var IfcEnergySequenceEnum = function IfcEnergySequenceEnum() {
    _classCallCheck2(this, IfcEnergySequenceEnum);
  };

  IfcEnergySequenceEnum.PRIMARY = {
    type: 3,
    value: "PRIMARY"
  };
  IfcEnergySequenceEnum.SECONDARY = {
    type: 3,
    value: "SECONDARY"
  };
  IfcEnergySequenceEnum.TERTIARY = {
    type: 3,
    value: "TERTIARY"
  };
  IfcEnergySequenceEnum.AUXILIARY = {
    type: 3,
    value: "AUXILIARY"
  };
  IfcEnergySequenceEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEnergySequenceEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcEnergySequenceEnum = IfcEnergySequenceEnum;

  var IfcEnvironmentalImpactCategoryEnum = function IfcEnvironmentalImpactCategoryEnum() {
    _classCallCheck2(this, IfcEnvironmentalImpactCategoryEnum);
  };

  IfcEnvironmentalImpactCategoryEnum.COMBINEDVALUE = {
    type: 3,
    value: "COMBINEDVALUE"
  };
  IfcEnvironmentalImpactCategoryEnum.DISPOSAL = {
    type: 3,
    value: "DISPOSAL"
  };
  IfcEnvironmentalImpactCategoryEnum.EXTRACTION = {
    type: 3,
    value: "EXTRACTION"
  };
  IfcEnvironmentalImpactCategoryEnum.INSTALLATION = {
    type: 3,
    value: "INSTALLATION"
  };
  IfcEnvironmentalImpactCategoryEnum.MANUFACTURE = {
    type: 3,
    value: "MANUFACTURE"
  };
  IfcEnvironmentalImpactCategoryEnum.TRANSPORTATION = {
    type: 3,
    value: "TRANSPORTATION"
  };
  IfcEnvironmentalImpactCategoryEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEnvironmentalImpactCategoryEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcEnvironmentalImpactCategoryEnum = IfcEnvironmentalImpactCategoryEnum;

  var IfcEvaporativeCoolerTypeEnum = function IfcEvaporativeCoolerTypeEnum() {
    _classCallCheck2(this, IfcEvaporativeCoolerTypeEnum);
  };

  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEAIRWASHER = {
    type: 3,
    value: "DIRECTEVAPORATIVEAIRWASHER"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = {
    type: 3,
    value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEWETCOIL = {
    type: 3,
    value: "INDIRECTEVAPORATIVEWETCOIL"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = {
    type: 3,
    value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTDIRECTCOMBINATION = {
    type: 3,
    value: "INDIRECTDIRECTCOMBINATION"
  };
  IfcEvaporativeCoolerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEvaporativeCoolerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;

  var IfcEvaporatorTypeEnum = function IfcEvaporatorTypeEnum() {
    _classCallCheck2(this, IfcEvaporatorTypeEnum);
  };

  IfcEvaporatorTypeEnum.DIRECTEXPANSIONSHELLANDTUBE = {
    type: 3,
    value: "DIRECTEXPANSIONSHELLANDTUBE"
  };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONTUBEINTUBE = {
    type: 3,
    value: "DIRECTEXPANSIONTUBEINTUBE"
  };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONBRAZEDPLATE = {
    type: 3,
    value: "DIRECTEXPANSIONBRAZEDPLATE"
  };
  IfcEvaporatorTypeEnum.FLOODEDSHELLANDTUBE = {
    type: 3,
    value: "FLOODEDSHELLANDTUBE"
  };
  IfcEvaporatorTypeEnum.SHELLANDCOIL = {
    type: 3,
    value: "SHELLANDCOIL"
  };
  IfcEvaporatorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEvaporatorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;

  var IfcFanTypeEnum = function IfcFanTypeEnum() {
    _classCallCheck2(this, IfcFanTypeEnum);
  };

  IfcFanTypeEnum.CENTRIFUGALFORWARDCURVED = {
    type: 3,
    value: "CENTRIFUGALFORWARDCURVED"
  };
  IfcFanTypeEnum.CENTRIFUGALRADIAL = {
    type: 3,
    value: "CENTRIFUGALRADIAL"
  };
  IfcFanTypeEnum.CENTRIFUGALBACKWARDINCLINEDCURVED = {
    type: 3,
    value: "CENTRIFUGALBACKWARDINCLINEDCURVED"
  };
  IfcFanTypeEnum.CENTRIFUGALAIRFOIL = {
    type: 3,
    value: "CENTRIFUGALAIRFOIL"
  };
  IfcFanTypeEnum.TUBEAXIAL = {
    type: 3,
    value: "TUBEAXIAL"
  };
  IfcFanTypeEnum.VANEAXIAL = {
    type: 3,
    value: "VANEAXIAL"
  };
  IfcFanTypeEnum.PROPELLORAXIAL = {
    type: 3,
    value: "PROPELLORAXIAL"
  };
  IfcFanTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFanTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcFanTypeEnum = IfcFanTypeEnum;

  var IfcFilterTypeEnum = function IfcFilterTypeEnum() {
    _classCallCheck2(this, IfcFilterTypeEnum);
  };

  IfcFilterTypeEnum.AIRPARTICLEFILTER = {
    type: 3,
    value: "AIRPARTICLEFILTER"
  };
  IfcFilterTypeEnum.ODORFILTER = {
    type: 3,
    value: "ODORFILTER"
  };
  IfcFilterTypeEnum.OILFILTER = {
    type: 3,
    value: "OILFILTER"
  };
  IfcFilterTypeEnum.STRAINER = {
    type: 3,
    value: "STRAINER"
  };
  IfcFilterTypeEnum.WATERFILTER = {
    type: 3,
    value: "WATERFILTER"
  };
  IfcFilterTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFilterTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcFilterTypeEnum = IfcFilterTypeEnum;

  var IfcFireSuppressionTerminalTypeEnum = function IfcFireSuppressionTerminalTypeEnum() {
    _classCallCheck2(this, IfcFireSuppressionTerminalTypeEnum);
  };

  IfcFireSuppressionTerminalTypeEnum.BREECHINGINLET = {
    type: 3,
    value: "BREECHINGINLET"
  };
  IfcFireSuppressionTerminalTypeEnum.FIREHYDRANT = {
    type: 3,
    value: "FIREHYDRANT"
  };
  IfcFireSuppressionTerminalTypeEnum.HOSEREEL = {
    type: 3,
    value: "HOSEREEL"
  };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLER = {
    type: 3,
    value: "SPRINKLER"
  };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLERDEFLECTOR = {
    type: 3,
    value: "SPRINKLERDEFLECTOR"
  };
  IfcFireSuppressionTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFireSuppressionTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;

  var IfcFlowDirectionEnum = function IfcFlowDirectionEnum() {
    _classCallCheck2(this, IfcFlowDirectionEnum);
  };

  IfcFlowDirectionEnum.SOURCE = {
    type: 3,
    value: "SOURCE"
  };
  IfcFlowDirectionEnum.SINK = {
    type: 3,
    value: "SINK"
  };
  IfcFlowDirectionEnum.SOURCEANDSINK = {
    type: 3,
    value: "SOURCEANDSINK"
  };
  IfcFlowDirectionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcFlowDirectionEnum = IfcFlowDirectionEnum;

  var IfcFlowInstrumentTypeEnum = function IfcFlowInstrumentTypeEnum() {
    _classCallCheck2(this, IfcFlowInstrumentTypeEnum);
  };

  IfcFlowInstrumentTypeEnum.PRESSUREGAUGE = {
    type: 3,
    value: "PRESSUREGAUGE"
  };
  IfcFlowInstrumentTypeEnum.THERMOMETER = {
    type: 3,
    value: "THERMOMETER"
  };
  IfcFlowInstrumentTypeEnum.AMMETER = {
    type: 3,
    value: "AMMETER"
  };
  IfcFlowInstrumentTypeEnum.FREQUENCYMETER = {
    type: 3,
    value: "FREQUENCYMETER"
  };
  IfcFlowInstrumentTypeEnum.POWERFACTORMETER = {
    type: 3,
    value: "POWERFACTORMETER"
  };
  IfcFlowInstrumentTypeEnum.PHASEANGLEMETER = {
    type: 3,
    value: "PHASEANGLEMETER"
  };
  IfcFlowInstrumentTypeEnum.VOLTMETER_PEAK = {
    type: 3,
    value: "VOLTMETER_PEAK"
  };
  IfcFlowInstrumentTypeEnum.VOLTMETER_RMS = {
    type: 3,
    value: "VOLTMETER_RMS"
  };
  IfcFlowInstrumentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFlowInstrumentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;

  var IfcFlowMeterTypeEnum = function IfcFlowMeterTypeEnum() {
    _classCallCheck2(this, IfcFlowMeterTypeEnum);
  };

  IfcFlowMeterTypeEnum.ELECTRICMETER = {
    type: 3,
    value: "ELECTRICMETER"
  };
  IfcFlowMeterTypeEnum.ENERGYMETER = {
    type: 3,
    value: "ENERGYMETER"
  };
  IfcFlowMeterTypeEnum.FLOWMETER = {
    type: 3,
    value: "FLOWMETER"
  };
  IfcFlowMeterTypeEnum.GASMETER = {
    type: 3,
    value: "GASMETER"
  };
  IfcFlowMeterTypeEnum.OILMETER = {
    type: 3,
    value: "OILMETER"
  };
  IfcFlowMeterTypeEnum.WATERMETER = {
    type: 3,
    value: "WATERMETER"
  };
  IfcFlowMeterTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFlowMeterTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;

  var IfcFootingTypeEnum = function IfcFootingTypeEnum() {
    _classCallCheck2(this, IfcFootingTypeEnum);
  };

  IfcFootingTypeEnum.FOOTING_BEAM = {
    type: 3,
    value: "FOOTING_BEAM"
  };
  IfcFootingTypeEnum.PAD_FOOTING = {
    type: 3,
    value: "PAD_FOOTING"
  };
  IfcFootingTypeEnum.PILE_CAP = {
    type: 3,
    value: "PILE_CAP"
  };
  IfcFootingTypeEnum.STRIP_FOOTING = {
    type: 3,
    value: "STRIP_FOOTING"
  };
  IfcFootingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFootingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcFootingTypeEnum = IfcFootingTypeEnum;

  var IfcGasTerminalTypeEnum = function IfcGasTerminalTypeEnum() {
    _classCallCheck2(this, IfcGasTerminalTypeEnum);
  };

  IfcGasTerminalTypeEnum.GASAPPLIANCE = {
    type: 3,
    value: "GASAPPLIANCE"
  };
  IfcGasTerminalTypeEnum.GASBOOSTER = {
    type: 3,
    value: "GASBOOSTER"
  };
  IfcGasTerminalTypeEnum.GASBURNER = {
    type: 3,
    value: "GASBURNER"
  };
  IfcGasTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcGasTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcGasTerminalTypeEnum = IfcGasTerminalTypeEnum;

  var IfcGeometricProjectionEnum = function IfcGeometricProjectionEnum() {
    _classCallCheck2(this, IfcGeometricProjectionEnum);
  };

  IfcGeometricProjectionEnum.GRAPH_VIEW = {
    type: 3,
    value: "GRAPH_VIEW"
  };
  IfcGeometricProjectionEnum.SKETCH_VIEW = {
    type: 3,
    value: "SKETCH_VIEW"
  };
  IfcGeometricProjectionEnum.MODEL_VIEW = {
    type: 3,
    value: "MODEL_VIEW"
  };
  IfcGeometricProjectionEnum.PLAN_VIEW = {
    type: 3,
    value: "PLAN_VIEW"
  };
  IfcGeometricProjectionEnum.REFLECTED_PLAN_VIEW = {
    type: 3,
    value: "REFLECTED_PLAN_VIEW"
  };
  IfcGeometricProjectionEnum.SECTION_VIEW = {
    type: 3,
    value: "SECTION_VIEW"
  };
  IfcGeometricProjectionEnum.ELEVATION_VIEW = {
    type: 3,
    value: "ELEVATION_VIEW"
  };
  IfcGeometricProjectionEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcGeometricProjectionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;

  var IfcGlobalOrLocalEnum = function IfcGlobalOrLocalEnum() {
    _classCallCheck2(this, IfcGlobalOrLocalEnum);
  };

  IfcGlobalOrLocalEnum.GLOBAL_COORDS = {
    type: 3,
    value: "GLOBAL_COORDS"
  };
  IfcGlobalOrLocalEnum.LOCAL_COORDS = {
    type: 3,
    value: "LOCAL_COORDS"
  };
  IFC2X32.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;

  var IfcHeatExchangerTypeEnum = function IfcHeatExchangerTypeEnum() {
    _classCallCheck2(this, IfcHeatExchangerTypeEnum);
  };

  IfcHeatExchangerTypeEnum.PLATE = {
    type: 3,
    value: "PLATE"
  };
  IfcHeatExchangerTypeEnum.SHELLANDTUBE = {
    type: 3,
    value: "SHELLANDTUBE"
  };
  IfcHeatExchangerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcHeatExchangerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;

  var IfcHumidifierTypeEnum = function IfcHumidifierTypeEnum() {
    _classCallCheck2(this, IfcHumidifierTypeEnum);
  };

  IfcHumidifierTypeEnum.STEAMINJECTION = {
    type: 3,
    value: "STEAMINJECTION"
  };
  IfcHumidifierTypeEnum.ADIABATICAIRWASHER = {
    type: 3,
    value: "ADIABATICAIRWASHER"
  };
  IfcHumidifierTypeEnum.ADIABATICPAN = {
    type: 3,
    value: "ADIABATICPAN"
  };
  IfcHumidifierTypeEnum.ADIABATICWETTEDELEMENT = {
    type: 3,
    value: "ADIABATICWETTEDELEMENT"
  };
  IfcHumidifierTypeEnum.ADIABATICATOMIZING = {
    type: 3,
    value: "ADIABATICATOMIZING"
  };
  IfcHumidifierTypeEnum.ADIABATICULTRASONIC = {
    type: 3,
    value: "ADIABATICULTRASONIC"
  };
  IfcHumidifierTypeEnum.ADIABATICRIGIDMEDIA = {
    type: 3,
    value: "ADIABATICRIGIDMEDIA"
  };
  IfcHumidifierTypeEnum.ADIABATICCOMPRESSEDAIRNOZZLE = {
    type: 3,
    value: "ADIABATICCOMPRESSEDAIRNOZZLE"
  };
  IfcHumidifierTypeEnum.ASSISTEDELECTRIC = {
    type: 3,
    value: "ASSISTEDELECTRIC"
  };
  IfcHumidifierTypeEnum.ASSISTEDNATURALGAS = {
    type: 3,
    value: "ASSISTEDNATURALGAS"
  };
  IfcHumidifierTypeEnum.ASSISTEDPROPANE = {
    type: 3,
    value: "ASSISTEDPROPANE"
  };
  IfcHumidifierTypeEnum.ASSISTEDBUTANE = {
    type: 3,
    value: "ASSISTEDBUTANE"
  };
  IfcHumidifierTypeEnum.ASSISTEDSTEAM = {
    type: 3,
    value: "ASSISTEDSTEAM"
  };
  IfcHumidifierTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcHumidifierTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;

  var IfcInternalOrExternalEnum = function IfcInternalOrExternalEnum() {
    _classCallCheck2(this, IfcInternalOrExternalEnum);
  };

  IfcInternalOrExternalEnum.INTERNAL = {
    type: 3,
    value: "INTERNAL"
  };
  IfcInternalOrExternalEnum.EXTERNAL = {
    type: 3,
    value: "EXTERNAL"
  };
  IfcInternalOrExternalEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;

  var IfcInventoryTypeEnum = function IfcInventoryTypeEnum() {
    _classCallCheck2(this, IfcInventoryTypeEnum);
  };

  IfcInventoryTypeEnum.ASSETINVENTORY = {
    type: 3,
    value: "ASSETINVENTORY"
  };
  IfcInventoryTypeEnum.SPACEINVENTORY = {
    type: 3,
    value: "SPACEINVENTORY"
  };
  IfcInventoryTypeEnum.FURNITUREINVENTORY = {
    type: 3,
    value: "FURNITUREINVENTORY"
  };
  IfcInventoryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcInventoryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcInventoryTypeEnum = IfcInventoryTypeEnum;

  var IfcJunctionBoxTypeEnum = function IfcJunctionBoxTypeEnum() {
    _classCallCheck2(this, IfcJunctionBoxTypeEnum);
  };

  IfcJunctionBoxTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcJunctionBoxTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;

  var IfcLampTypeEnum = function IfcLampTypeEnum() {
    _classCallCheck2(this, IfcLampTypeEnum);
  };

  IfcLampTypeEnum.COMPACTFLUORESCENT = {
    type: 3,
    value: "COMPACTFLUORESCENT"
  };
  IfcLampTypeEnum.FLUORESCENT = {
    type: 3,
    value: "FLUORESCENT"
  };
  IfcLampTypeEnum.HIGHPRESSUREMERCURY = {
    type: 3,
    value: "HIGHPRESSUREMERCURY"
  };
  IfcLampTypeEnum.HIGHPRESSURESODIUM = {
    type: 3,
    value: "HIGHPRESSURESODIUM"
  };
  IfcLampTypeEnum.METALHALIDE = {
    type: 3,
    value: "METALHALIDE"
  };
  IfcLampTypeEnum.TUNGSTENFILAMENT = {
    type: 3,
    value: "TUNGSTENFILAMENT"
  };
  IfcLampTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLampTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcLampTypeEnum = IfcLampTypeEnum;

  var IfcLayerSetDirectionEnum = function IfcLayerSetDirectionEnum() {
    _classCallCheck2(this, IfcLayerSetDirectionEnum);
  };

  IfcLayerSetDirectionEnum.AXIS1 = {
    type: 3,
    value: "AXIS1"
  };
  IfcLayerSetDirectionEnum.AXIS2 = {
    type: 3,
    value: "AXIS2"
  };
  IfcLayerSetDirectionEnum.AXIS3 = {
    type: 3,
    value: "AXIS3"
  };
  IFC2X32.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;

  var IfcLightDistributionCurveEnum = function IfcLightDistributionCurveEnum() {
    _classCallCheck2(this, IfcLightDistributionCurveEnum);
  };

  IfcLightDistributionCurveEnum.TYPE_A = {
    type: 3,
    value: "TYPE_A"
  };
  IfcLightDistributionCurveEnum.TYPE_B = {
    type: 3,
    value: "TYPE_B"
  };
  IfcLightDistributionCurveEnum.TYPE_C = {
    type: 3,
    value: "TYPE_C"
  };
  IfcLightDistributionCurveEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;

  var IfcLightEmissionSourceEnum = function IfcLightEmissionSourceEnum() {
    _classCallCheck2(this, IfcLightEmissionSourceEnum);
  };

  IfcLightEmissionSourceEnum.COMPACTFLUORESCENT = {
    type: 3,
    value: "COMPACTFLUORESCENT"
  };
  IfcLightEmissionSourceEnum.FLUORESCENT = {
    type: 3,
    value: "FLUORESCENT"
  };
  IfcLightEmissionSourceEnum.HIGHPRESSUREMERCURY = {
    type: 3,
    value: "HIGHPRESSUREMERCURY"
  };
  IfcLightEmissionSourceEnum.HIGHPRESSURESODIUM = {
    type: 3,
    value: "HIGHPRESSURESODIUM"
  };
  IfcLightEmissionSourceEnum.LIGHTEMITTINGDIODE = {
    type: 3,
    value: "LIGHTEMITTINGDIODE"
  };
  IfcLightEmissionSourceEnum.LOWPRESSURESODIUM = {
    type: 3,
    value: "LOWPRESSURESODIUM"
  };
  IfcLightEmissionSourceEnum.LOWVOLTAGEHALOGEN = {
    type: 3,
    value: "LOWVOLTAGEHALOGEN"
  };
  IfcLightEmissionSourceEnum.MAINVOLTAGEHALOGEN = {
    type: 3,
    value: "MAINVOLTAGEHALOGEN"
  };
  IfcLightEmissionSourceEnum.METALHALIDE = {
    type: 3,
    value: "METALHALIDE"
  };
  IfcLightEmissionSourceEnum.TUNGSTENFILAMENT = {
    type: 3,
    value: "TUNGSTENFILAMENT"
  };
  IfcLightEmissionSourceEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;

  var IfcLightFixtureTypeEnum = function IfcLightFixtureTypeEnum() {
    _classCallCheck2(this, IfcLightFixtureTypeEnum);
  };

  IfcLightFixtureTypeEnum.POINTSOURCE = {
    type: 3,
    value: "POINTSOURCE"
  };
  IfcLightFixtureTypeEnum.DIRECTIONSOURCE = {
    type: 3,
    value: "DIRECTIONSOURCE"
  };
  IfcLightFixtureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLightFixtureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;

  var IfcLoadGroupTypeEnum = function IfcLoadGroupTypeEnum() {
    _classCallCheck2(this, IfcLoadGroupTypeEnum);
  };

  IfcLoadGroupTypeEnum.LOAD_GROUP = {
    type: 3,
    value: "LOAD_GROUP"
  };
  IfcLoadGroupTypeEnum.LOAD_CASE = {
    type: 3,
    value: "LOAD_CASE"
  };
  IfcLoadGroupTypeEnum.LOAD_COMBINATION_GROUP = {
    type: 3,
    value: "LOAD_COMBINATION_GROUP"
  };
  IfcLoadGroupTypeEnum.LOAD_COMBINATION = {
    type: 3,
    value: "LOAD_COMBINATION"
  };
  IfcLoadGroupTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLoadGroupTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;

  var IfcLogicalOperatorEnum = function IfcLogicalOperatorEnum() {
    _classCallCheck2(this, IfcLogicalOperatorEnum);
  };

  IfcLogicalOperatorEnum.LOGICALAND = {
    type: 3,
    value: "LOGICALAND"
  };
  IfcLogicalOperatorEnum.LOGICALOR = {
    type: 3,
    value: "LOGICALOR"
  };
  IFC2X32.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;

  var IfcMemberTypeEnum = function IfcMemberTypeEnum() {
    _classCallCheck2(this, IfcMemberTypeEnum);
  };

  IfcMemberTypeEnum.BRACE = {
    type: 3,
    value: "BRACE"
  };
  IfcMemberTypeEnum.CHORD = {
    type: 3,
    value: "CHORD"
  };
  IfcMemberTypeEnum.COLLAR = {
    type: 3,
    value: "COLLAR"
  };
  IfcMemberTypeEnum.MEMBER = {
    type: 3,
    value: "MEMBER"
  };
  IfcMemberTypeEnum.MULLION = {
    type: 3,
    value: "MULLION"
  };
  IfcMemberTypeEnum.PLATE = {
    type: 3,
    value: "PLATE"
  };
  IfcMemberTypeEnum.POST = {
    type: 3,
    value: "POST"
  };
  IfcMemberTypeEnum.PURLIN = {
    type: 3,
    value: "PURLIN"
  };
  IfcMemberTypeEnum.RAFTER = {
    type: 3,
    value: "RAFTER"
  };
  IfcMemberTypeEnum.STRINGER = {
    type: 3,
    value: "STRINGER"
  };
  IfcMemberTypeEnum.STRUT = {
    type: 3,
    value: "STRUT"
  };
  IfcMemberTypeEnum.STUD = {
    type: 3,
    value: "STUD"
  };
  IfcMemberTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMemberTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcMemberTypeEnum = IfcMemberTypeEnum;

  var IfcMotorConnectionTypeEnum = function IfcMotorConnectionTypeEnum() {
    _classCallCheck2(this, IfcMotorConnectionTypeEnum);
  };

  IfcMotorConnectionTypeEnum.BELTDRIVE = {
    type: 3,
    value: "BELTDRIVE"
  };
  IfcMotorConnectionTypeEnum.COUPLING = {
    type: 3,
    value: "COUPLING"
  };
  IfcMotorConnectionTypeEnum.DIRECTDRIVE = {
    type: 3,
    value: "DIRECTDRIVE"
  };
  IfcMotorConnectionTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMotorConnectionTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;

  var IfcNullStyle = function IfcNullStyle() {
    _classCallCheck2(this, IfcNullStyle);
  };

  IfcNullStyle.NULL = {
    type: 3,
    value: "NULL"
  };
  IFC2X32.IfcNullStyle = IfcNullStyle;

  var IfcObjectTypeEnum = function IfcObjectTypeEnum() {
    _classCallCheck2(this, IfcObjectTypeEnum);
  };

  IfcObjectTypeEnum.PRODUCT = {
    type: 3,
    value: "PRODUCT"
  };
  IfcObjectTypeEnum.PROCESS = {
    type: 3,
    value: "PROCESS"
  };
  IfcObjectTypeEnum.CONTROL = {
    type: 3,
    value: "CONTROL"
  };
  IfcObjectTypeEnum.RESOURCE = {
    type: 3,
    value: "RESOURCE"
  };
  IfcObjectTypeEnum.ACTOR = {
    type: 3,
    value: "ACTOR"
  };
  IfcObjectTypeEnum.GROUP = {
    type: 3,
    value: "GROUP"
  };
  IfcObjectTypeEnum.PROJECT = {
    type: 3,
    value: "PROJECT"
  };
  IfcObjectTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcObjectTypeEnum = IfcObjectTypeEnum;

  var IfcObjectiveEnum = function IfcObjectiveEnum() {
    _classCallCheck2(this, IfcObjectiveEnum);
  };

  IfcObjectiveEnum.CODECOMPLIANCE = {
    type: 3,
    value: "CODECOMPLIANCE"
  };
  IfcObjectiveEnum.DESIGNINTENT = {
    type: 3,
    value: "DESIGNINTENT"
  };
  IfcObjectiveEnum.HEALTHANDSAFETY = {
    type: 3,
    value: "HEALTHANDSAFETY"
  };
  IfcObjectiveEnum.REQUIREMENT = {
    type: 3,
    value: "REQUIREMENT"
  };
  IfcObjectiveEnum.SPECIFICATION = {
    type: 3,
    value: "SPECIFICATION"
  };
  IfcObjectiveEnum.TRIGGERCONDITION = {
    type: 3,
    value: "TRIGGERCONDITION"
  };
  IfcObjectiveEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcObjectiveEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcObjectiveEnum = IfcObjectiveEnum;

  var IfcOccupantTypeEnum = function IfcOccupantTypeEnum() {
    _classCallCheck2(this, IfcOccupantTypeEnum);
  };

  IfcOccupantTypeEnum.ASSIGNEE = {
    type: 3,
    value: "ASSIGNEE"
  };
  IfcOccupantTypeEnum.ASSIGNOR = {
    type: 3,
    value: "ASSIGNOR"
  };
  IfcOccupantTypeEnum.LESSEE = {
    type: 3,
    value: "LESSEE"
  };
  IfcOccupantTypeEnum.LESSOR = {
    type: 3,
    value: "LESSOR"
  };
  IfcOccupantTypeEnum.LETTINGAGENT = {
    type: 3,
    value: "LETTINGAGENT"
  };
  IfcOccupantTypeEnum.OWNER = {
    type: 3,
    value: "OWNER"
  };
  IfcOccupantTypeEnum.TENANT = {
    type: 3,
    value: "TENANT"
  };
  IfcOccupantTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcOccupantTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcOccupantTypeEnum = IfcOccupantTypeEnum;

  var IfcOutletTypeEnum = function IfcOutletTypeEnum() {
    _classCallCheck2(this, IfcOutletTypeEnum);
  };

  IfcOutletTypeEnum.AUDIOVISUALOUTLET = {
    type: 3,
    value: "AUDIOVISUALOUTLET"
  };
  IfcOutletTypeEnum.COMMUNICATIONSOUTLET = {
    type: 3,
    value: "COMMUNICATIONSOUTLET"
  };
  IfcOutletTypeEnum.POWEROUTLET = {
    type: 3,
    value: "POWEROUTLET"
  };
  IfcOutletTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcOutletTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcOutletTypeEnum = IfcOutletTypeEnum;

  var IfcPermeableCoveringOperationEnum = function IfcPermeableCoveringOperationEnum() {
    _classCallCheck2(this, IfcPermeableCoveringOperationEnum);
  };

  IfcPermeableCoveringOperationEnum.GRILL = {
    type: 3,
    value: "GRILL"
  };
  IfcPermeableCoveringOperationEnum.LOUVER = {
    type: 3,
    value: "LOUVER"
  };
  IfcPermeableCoveringOperationEnum.SCREEN = {
    type: 3,
    value: "SCREEN"
  };
  IfcPermeableCoveringOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPermeableCoveringOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;

  var IfcPhysicalOrVirtualEnum = function IfcPhysicalOrVirtualEnum() {
    _classCallCheck2(this, IfcPhysicalOrVirtualEnum);
  };

  IfcPhysicalOrVirtualEnum.PHYSICAL = {
    type: 3,
    value: "PHYSICAL"
  };
  IfcPhysicalOrVirtualEnum.VIRTUAL = {
    type: 3,
    value: "VIRTUAL"
  };
  IfcPhysicalOrVirtualEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;

  var IfcPileConstructionEnum = function IfcPileConstructionEnum() {
    _classCallCheck2(this, IfcPileConstructionEnum);
  };

  IfcPileConstructionEnum.CAST_IN_PLACE = {
    type: 3,
    value: "CAST_IN_PLACE"
  };
  IfcPileConstructionEnum.COMPOSITE = {
    type: 3,
    value: "COMPOSITE"
  };
  IfcPileConstructionEnum.PRECAST_CONCRETE = {
    type: 3,
    value: "PRECAST_CONCRETE"
  };
  IfcPileConstructionEnum.PREFAB_STEEL = {
    type: 3,
    value: "PREFAB_STEEL"
  };
  IfcPileConstructionEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPileConstructionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcPileConstructionEnum = IfcPileConstructionEnum;

  var IfcPileTypeEnum = function IfcPileTypeEnum() {
    _classCallCheck2(this, IfcPileTypeEnum);
  };

  IfcPileTypeEnum.COHESION = {
    type: 3,
    value: "COHESION"
  };
  IfcPileTypeEnum.FRICTION = {
    type: 3,
    value: "FRICTION"
  };
  IfcPileTypeEnum.SUPPORT = {
    type: 3,
    value: "SUPPORT"
  };
  IfcPileTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPileTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcPileTypeEnum = IfcPileTypeEnum;

  var IfcPipeFittingTypeEnum = function IfcPipeFittingTypeEnum() {
    _classCallCheck2(this, IfcPipeFittingTypeEnum);
  };

  IfcPipeFittingTypeEnum.BEND = {
    type: 3,
    value: "BEND"
  };
  IfcPipeFittingTypeEnum.CONNECTOR = {
    type: 3,
    value: "CONNECTOR"
  };
  IfcPipeFittingTypeEnum.ENTRY = {
    type: 3,
    value: "ENTRY"
  };
  IfcPipeFittingTypeEnum.EXIT = {
    type: 3,
    value: "EXIT"
  };
  IfcPipeFittingTypeEnum.JUNCTION = {
    type: 3,
    value: "JUNCTION"
  };
  IfcPipeFittingTypeEnum.OBSTRUCTION = {
    type: 3,
    value: "OBSTRUCTION"
  };
  IfcPipeFittingTypeEnum.TRANSITION = {
    type: 3,
    value: "TRANSITION"
  };
  IfcPipeFittingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPipeFittingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;

  var IfcPipeSegmentTypeEnum = function IfcPipeSegmentTypeEnum() {
    _classCallCheck2(this, IfcPipeSegmentTypeEnum);
  };

  IfcPipeSegmentTypeEnum.FLEXIBLESEGMENT = {
    type: 3,
    value: "FLEXIBLESEGMENT"
  };
  IfcPipeSegmentTypeEnum.RIGIDSEGMENT = {
    type: 3,
    value: "RIGIDSEGMENT"
  };
  IfcPipeSegmentTypeEnum.GUTTER = {
    type: 3,
    value: "GUTTER"
  };
  IfcPipeSegmentTypeEnum.SPOOL = {
    type: 3,
    value: "SPOOL"
  };
  IfcPipeSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPipeSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;

  var IfcPlateTypeEnum = function IfcPlateTypeEnum() {
    _classCallCheck2(this, IfcPlateTypeEnum);
  };

  IfcPlateTypeEnum.CURTAIN_PANEL = {
    type: 3,
    value: "CURTAIN_PANEL"
  };
  IfcPlateTypeEnum.SHEET = {
    type: 3,
    value: "SHEET"
  };
  IfcPlateTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPlateTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcPlateTypeEnum = IfcPlateTypeEnum;

  var IfcProcedureTypeEnum = function IfcProcedureTypeEnum() {
    _classCallCheck2(this, IfcProcedureTypeEnum);
  };

  IfcProcedureTypeEnum.ADVICE_CAUTION = {
    type: 3,
    value: "ADVICE_CAUTION"
  };
  IfcProcedureTypeEnum.ADVICE_NOTE = {
    type: 3,
    value: "ADVICE_NOTE"
  };
  IfcProcedureTypeEnum.ADVICE_WARNING = {
    type: 3,
    value: "ADVICE_WARNING"
  };
  IfcProcedureTypeEnum.CALIBRATION = {
    type: 3,
    value: "CALIBRATION"
  };
  IfcProcedureTypeEnum.DIAGNOSTIC = {
    type: 3,
    value: "DIAGNOSTIC"
  };
  IfcProcedureTypeEnum.SHUTDOWN = {
    type: 3,
    value: "SHUTDOWN"
  };
  IfcProcedureTypeEnum.STARTUP = {
    type: 3,
    value: "STARTUP"
  };
  IfcProcedureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProcedureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcProcedureTypeEnum = IfcProcedureTypeEnum;

  var IfcProfileTypeEnum = function IfcProfileTypeEnum() {
    _classCallCheck2(this, IfcProfileTypeEnum);
  };

  IfcProfileTypeEnum.CURVE = {
    type: 3,
    value: "CURVE"
  };
  IfcProfileTypeEnum.AREA = {
    type: 3,
    value: "AREA"
  };
  IFC2X32.IfcProfileTypeEnum = IfcProfileTypeEnum;

  var IfcProjectOrderRecordTypeEnum = function IfcProjectOrderRecordTypeEnum() {
    _classCallCheck2(this, IfcProjectOrderRecordTypeEnum);
  };

  IfcProjectOrderRecordTypeEnum.CHANGE = {
    type: 3,
    value: "CHANGE"
  };
  IfcProjectOrderRecordTypeEnum.MAINTENANCE = {
    type: 3,
    value: "MAINTENANCE"
  };
  IfcProjectOrderRecordTypeEnum.MOVE = {
    type: 3,
    value: "MOVE"
  };
  IfcProjectOrderRecordTypeEnum.PURCHASE = {
    type: 3,
    value: "PURCHASE"
  };
  IfcProjectOrderRecordTypeEnum.WORK = {
    type: 3,
    value: "WORK"
  };
  IfcProjectOrderRecordTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProjectOrderRecordTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcProjectOrderRecordTypeEnum = IfcProjectOrderRecordTypeEnum;

  var IfcProjectOrderTypeEnum = function IfcProjectOrderTypeEnum() {
    _classCallCheck2(this, IfcProjectOrderTypeEnum);
  };

  IfcProjectOrderTypeEnum.CHANGEORDER = {
    type: 3,
    value: "CHANGEORDER"
  };
  IfcProjectOrderTypeEnum.MAINTENANCEWORKORDER = {
    type: 3,
    value: "MAINTENANCEWORKORDER"
  };
  IfcProjectOrderTypeEnum.MOVEORDER = {
    type: 3,
    value: "MOVEORDER"
  };
  IfcProjectOrderTypeEnum.PURCHASEORDER = {
    type: 3,
    value: "PURCHASEORDER"
  };
  IfcProjectOrderTypeEnum.WORKORDER = {
    type: 3,
    value: "WORKORDER"
  };
  IfcProjectOrderTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProjectOrderTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;

  var IfcProjectedOrTrueLengthEnum = function IfcProjectedOrTrueLengthEnum() {
    _classCallCheck2(this, IfcProjectedOrTrueLengthEnum);
  };

  IfcProjectedOrTrueLengthEnum.PROJECTED_LENGTH = {
    type: 3,
    value: "PROJECTED_LENGTH"
  };
  IfcProjectedOrTrueLengthEnum.TRUE_LENGTH = {
    type: 3,
    value: "TRUE_LENGTH"
  };
  IFC2X32.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;

  var IfcPropertySourceEnum = function IfcPropertySourceEnum() {
    _classCallCheck2(this, IfcPropertySourceEnum);
  };

  IfcPropertySourceEnum.DESIGN = {
    type: 3,
    value: "DESIGN"
  };
  IfcPropertySourceEnum.DESIGNMAXIMUM = {
    type: 3,
    value: "DESIGNMAXIMUM"
  };
  IfcPropertySourceEnum.DESIGNMINIMUM = {
    type: 3,
    value: "DESIGNMINIMUM"
  };
  IfcPropertySourceEnum.SIMULATED = {
    type: 3,
    value: "SIMULATED"
  };
  IfcPropertySourceEnum.ASBUILT = {
    type: 3,
    value: "ASBUILT"
  };
  IfcPropertySourceEnum.COMMISSIONING = {
    type: 3,
    value: "COMMISSIONING"
  };
  IfcPropertySourceEnum.MEASURED = {
    type: 3,
    value: "MEASURED"
  };
  IfcPropertySourceEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPropertySourceEnum.NOTKNOWN = {
    type: 3,
    value: "NOTKNOWN"
  };
  IFC2X32.IfcPropertySourceEnum = IfcPropertySourceEnum;

  var IfcProtectiveDeviceTypeEnum = function IfcProtectiveDeviceTypeEnum() {
    _classCallCheck2(this, IfcProtectiveDeviceTypeEnum);
  };

  IfcProtectiveDeviceTypeEnum.FUSEDISCONNECTOR = {
    type: 3,
    value: "FUSEDISCONNECTOR"
  };
  IfcProtectiveDeviceTypeEnum.CIRCUITBREAKER = {
    type: 3,
    value: "CIRCUITBREAKER"
  };
  IfcProtectiveDeviceTypeEnum.EARTHFAILUREDEVICE = {
    type: 3,
    value: "EARTHFAILUREDEVICE"
  };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTCIRCUITBREAKER = {
    type: 3,
    value: "RESIDUALCURRENTCIRCUITBREAKER"
  };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTSWITCH = {
    type: 3,
    value: "RESIDUALCURRENTSWITCH"
  };
  IfcProtectiveDeviceTypeEnum.VARISTOR = {
    type: 3,
    value: "VARISTOR"
  };
  IfcProtectiveDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProtectiveDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;

  var IfcPumpTypeEnum = function IfcPumpTypeEnum() {
    _classCallCheck2(this, IfcPumpTypeEnum);
  };

  IfcPumpTypeEnum.CIRCULATOR = {
    type: 3,
    value: "CIRCULATOR"
  };
  IfcPumpTypeEnum.ENDSUCTION = {
    type: 3,
    value: "ENDSUCTION"
  };
  IfcPumpTypeEnum.SPLITCASE = {
    type: 3,
    value: "SPLITCASE"
  };
  IfcPumpTypeEnum.VERTICALINLINE = {
    type: 3,
    value: "VERTICALINLINE"
  };
  IfcPumpTypeEnum.VERTICALTURBINE = {
    type: 3,
    value: "VERTICALTURBINE"
  };
  IfcPumpTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPumpTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcPumpTypeEnum = IfcPumpTypeEnum;

  var IfcRailingTypeEnum = function IfcRailingTypeEnum() {
    _classCallCheck2(this, IfcRailingTypeEnum);
  };

  IfcRailingTypeEnum.HANDRAIL = {
    type: 3,
    value: "HANDRAIL"
  };
  IfcRailingTypeEnum.GUARDRAIL = {
    type: 3,
    value: "GUARDRAIL"
  };
  IfcRailingTypeEnum.BALUSTRADE = {
    type: 3,
    value: "BALUSTRADE"
  };
  IfcRailingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRailingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcRailingTypeEnum = IfcRailingTypeEnum;

  var IfcRampFlightTypeEnum = function IfcRampFlightTypeEnum() {
    _classCallCheck2(this, IfcRampFlightTypeEnum);
  };

  IfcRampFlightTypeEnum.STRAIGHT = {
    type: 3,
    value: "STRAIGHT"
  };
  IfcRampFlightTypeEnum.SPIRAL = {
    type: 3,
    value: "SPIRAL"
  };
  IfcRampFlightTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRampFlightTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;

  var IfcRampTypeEnum = function IfcRampTypeEnum() {
    _classCallCheck2(this, IfcRampTypeEnum);
  };

  IfcRampTypeEnum.STRAIGHT_RUN_RAMP = {
    type: 3,
    value: "STRAIGHT_RUN_RAMP"
  };
  IfcRampTypeEnum.TWO_STRAIGHT_RUN_RAMP = {
    type: 3,
    value: "TWO_STRAIGHT_RUN_RAMP"
  };
  IfcRampTypeEnum.QUARTER_TURN_RAMP = {
    type: 3,
    value: "QUARTER_TURN_RAMP"
  };
  IfcRampTypeEnum.TWO_QUARTER_TURN_RAMP = {
    type: 3,
    value: "TWO_QUARTER_TURN_RAMP"
  };
  IfcRampTypeEnum.HALF_TURN_RAMP = {
    type: 3,
    value: "HALF_TURN_RAMP"
  };
  IfcRampTypeEnum.SPIRAL_RAMP = {
    type: 3,
    value: "SPIRAL_RAMP"
  };
  IfcRampTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRampTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcRampTypeEnum = IfcRampTypeEnum;

  var IfcReflectanceMethodEnum = function IfcReflectanceMethodEnum() {
    _classCallCheck2(this, IfcReflectanceMethodEnum);
  };

  IfcReflectanceMethodEnum.BLINN = {
    type: 3,
    value: "BLINN"
  };
  IfcReflectanceMethodEnum.FLAT = {
    type: 3,
    value: "FLAT"
  };
  IfcReflectanceMethodEnum.GLASS = {
    type: 3,
    value: "GLASS"
  };
  IfcReflectanceMethodEnum.MATT = {
    type: 3,
    value: "MATT"
  };
  IfcReflectanceMethodEnum.METAL = {
    type: 3,
    value: "METAL"
  };
  IfcReflectanceMethodEnum.MIRROR = {
    type: 3,
    value: "MIRROR"
  };
  IfcReflectanceMethodEnum.PHONG = {
    type: 3,
    value: "PHONG"
  };
  IfcReflectanceMethodEnum.PLASTIC = {
    type: 3,
    value: "PLASTIC"
  };
  IfcReflectanceMethodEnum.STRAUSS = {
    type: 3,
    value: "STRAUSS"
  };
  IfcReflectanceMethodEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;

  var IfcReinforcingBarRoleEnum = function IfcReinforcingBarRoleEnum() {
    _classCallCheck2(this, IfcReinforcingBarRoleEnum);
  };

  IfcReinforcingBarRoleEnum.MAIN = {
    type: 3,
    value: "MAIN"
  };
  IfcReinforcingBarRoleEnum.SHEAR = {
    type: 3,
    value: "SHEAR"
  };
  IfcReinforcingBarRoleEnum.LIGATURE = {
    type: 3,
    value: "LIGATURE"
  };
  IfcReinforcingBarRoleEnum.STUD = {
    type: 3,
    value: "STUD"
  };
  IfcReinforcingBarRoleEnum.PUNCHING = {
    type: 3,
    value: "PUNCHING"
  };
  IfcReinforcingBarRoleEnum.EDGE = {
    type: 3,
    value: "EDGE"
  };
  IfcReinforcingBarRoleEnum.RING = {
    type: 3,
    value: "RING"
  };
  IfcReinforcingBarRoleEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcReinforcingBarRoleEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;

  var IfcReinforcingBarSurfaceEnum = function IfcReinforcingBarSurfaceEnum() {
    _classCallCheck2(this, IfcReinforcingBarSurfaceEnum);
  };

  IfcReinforcingBarSurfaceEnum.PLAIN = {
    type: 3,
    value: "PLAIN"
  };
  IfcReinforcingBarSurfaceEnum.TEXTURED = {
    type: 3,
    value: "TEXTURED"
  };
  IFC2X32.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;

  var IfcResourceConsumptionEnum = function IfcResourceConsumptionEnum() {
    _classCallCheck2(this, IfcResourceConsumptionEnum);
  };

  IfcResourceConsumptionEnum.CONSUMED = {
    type: 3,
    value: "CONSUMED"
  };
  IfcResourceConsumptionEnum.PARTIALLYCONSUMED = {
    type: 3,
    value: "PARTIALLYCONSUMED"
  };
  IfcResourceConsumptionEnum.NOTCONSUMED = {
    type: 3,
    value: "NOTCONSUMED"
  };
  IfcResourceConsumptionEnum.OCCUPIED = {
    type: 3,
    value: "OCCUPIED"
  };
  IfcResourceConsumptionEnum.PARTIALLYOCCUPIED = {
    type: 3,
    value: "PARTIALLYOCCUPIED"
  };
  IfcResourceConsumptionEnum.NOTOCCUPIED = {
    type: 3,
    value: "NOTOCCUPIED"
  };
  IfcResourceConsumptionEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcResourceConsumptionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcResourceConsumptionEnum = IfcResourceConsumptionEnum;

  var IfcRibPlateDirectionEnum = function IfcRibPlateDirectionEnum() {
    _classCallCheck2(this, IfcRibPlateDirectionEnum);
  };

  IfcRibPlateDirectionEnum.DIRECTION_X = {
    type: 3,
    value: "DIRECTION_X"
  };
  IfcRibPlateDirectionEnum.DIRECTION_Y = {
    type: 3,
    value: "DIRECTION_Y"
  };
  IFC2X32.IfcRibPlateDirectionEnum = IfcRibPlateDirectionEnum;

  var IfcRoleEnum = function IfcRoleEnum() {
    _classCallCheck2(this, IfcRoleEnum);
  };

  IfcRoleEnum.SUPPLIER = {
    type: 3,
    value: "SUPPLIER"
  };
  IfcRoleEnum.MANUFACTURER = {
    type: 3,
    value: "MANUFACTURER"
  };
  IfcRoleEnum.CONTRACTOR = {
    type: 3,
    value: "CONTRACTOR"
  };
  IfcRoleEnum.SUBCONTRACTOR = {
    type: 3,
    value: "SUBCONTRACTOR"
  };
  IfcRoleEnum.ARCHITECT = {
    type: 3,
    value: "ARCHITECT"
  };
  IfcRoleEnum.STRUCTURALENGINEER = {
    type: 3,
    value: "STRUCTURALENGINEER"
  };
  IfcRoleEnum.COSTENGINEER = {
    type: 3,
    value: "COSTENGINEER"
  };
  IfcRoleEnum.CLIENT = {
    type: 3,
    value: "CLIENT"
  };
  IfcRoleEnum.BUILDINGOWNER = {
    type: 3,
    value: "BUILDINGOWNER"
  };
  IfcRoleEnum.BUILDINGOPERATOR = {
    type: 3,
    value: "BUILDINGOPERATOR"
  };
  IfcRoleEnum.MECHANICALENGINEER = {
    type: 3,
    value: "MECHANICALENGINEER"
  };
  IfcRoleEnum.ELECTRICALENGINEER = {
    type: 3,
    value: "ELECTRICALENGINEER"
  };
  IfcRoleEnum.PROJECTMANAGER = {
    type: 3,
    value: "PROJECTMANAGER"
  };
  IfcRoleEnum.FACILITIESMANAGER = {
    type: 3,
    value: "FACILITIESMANAGER"
  };
  IfcRoleEnum.CIVILENGINEER = {
    type: 3,
    value: "CIVILENGINEER"
  };
  IfcRoleEnum.COMISSIONINGENGINEER = {
    type: 3,
    value: "COMISSIONINGENGINEER"
  };
  IfcRoleEnum.ENGINEER = {
    type: 3,
    value: "ENGINEER"
  };
  IfcRoleEnum.OWNER = {
    type: 3,
    value: "OWNER"
  };
  IfcRoleEnum.CONSULTANT = {
    type: 3,
    value: "CONSULTANT"
  };
  IfcRoleEnum.CONSTRUCTIONMANAGER = {
    type: 3,
    value: "CONSTRUCTIONMANAGER"
  };
  IfcRoleEnum.FIELDCONSTRUCTIONMANAGER = {
    type: 3,
    value: "FIELDCONSTRUCTIONMANAGER"
  };
  IfcRoleEnum.RESELLER = {
    type: 3,
    value: "RESELLER"
  };
  IfcRoleEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC2X32.IfcRoleEnum = IfcRoleEnum;

  var IfcRoofTypeEnum = function IfcRoofTypeEnum() {
    _classCallCheck2(this, IfcRoofTypeEnum);
  };

  IfcRoofTypeEnum.FLAT_ROOF = {
    type: 3,
    value: "FLAT_ROOF"
  };
  IfcRoofTypeEnum.SHED_ROOF = {
    type: 3,
    value: "SHED_ROOF"
  };
  IfcRoofTypeEnum.GABLE_ROOF = {
    type: 3,
    value: "GABLE_ROOF"
  };
  IfcRoofTypeEnum.HIP_ROOF = {
    type: 3,
    value: "HIP_ROOF"
  };
  IfcRoofTypeEnum.HIPPED_GABLE_ROOF = {
    type: 3,
    value: "HIPPED_GABLE_ROOF"
  };
  IfcRoofTypeEnum.GAMBREL_ROOF = {
    type: 3,
    value: "GAMBREL_ROOF"
  };
  IfcRoofTypeEnum.MANSARD_ROOF = {
    type: 3,
    value: "MANSARD_ROOF"
  };
  IfcRoofTypeEnum.BARREL_ROOF = {
    type: 3,
    value: "BARREL_ROOF"
  };
  IfcRoofTypeEnum.RAINBOW_ROOF = {
    type: 3,
    value: "RAINBOW_ROOF"
  };
  IfcRoofTypeEnum.BUTTERFLY_ROOF = {
    type: 3,
    value: "BUTTERFLY_ROOF"
  };
  IfcRoofTypeEnum.PAVILION_ROOF = {
    type: 3,
    value: "PAVILION_ROOF"
  };
  IfcRoofTypeEnum.DOME_ROOF = {
    type: 3,
    value: "DOME_ROOF"
  };
  IfcRoofTypeEnum.FREEFORM = {
    type: 3,
    value: "FREEFORM"
  };
  IfcRoofTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcRoofTypeEnum = IfcRoofTypeEnum;

  var IfcSIPrefix = function IfcSIPrefix() {
    _classCallCheck2(this, IfcSIPrefix);
  };

  IfcSIPrefix.EXA = {
    type: 3,
    value: "EXA"
  };
  IfcSIPrefix.PETA = {
    type: 3,
    value: "PETA"
  };
  IfcSIPrefix.TERA = {
    type: 3,
    value: "TERA"
  };
  IfcSIPrefix.GIGA = {
    type: 3,
    value: "GIGA"
  };
  IfcSIPrefix.MEGA = {
    type: 3,
    value: "MEGA"
  };
  IfcSIPrefix.KILO = {
    type: 3,
    value: "KILO"
  };
  IfcSIPrefix.HECTO = {
    type: 3,
    value: "HECTO"
  };
  IfcSIPrefix.DECA = {
    type: 3,
    value: "DECA"
  };
  IfcSIPrefix.DECI = {
    type: 3,
    value: "DECI"
  };
  IfcSIPrefix.CENTI = {
    type: 3,
    value: "CENTI"
  };
  IfcSIPrefix.MILLI = {
    type: 3,
    value: "MILLI"
  };
  IfcSIPrefix.MICRO = {
    type: 3,
    value: "MICRO"
  };
  IfcSIPrefix.NANO = {
    type: 3,
    value: "NANO"
  };
  IfcSIPrefix.PICO = {
    type: 3,
    value: "PICO"
  };
  IfcSIPrefix.FEMTO = {
    type: 3,
    value: "FEMTO"
  };
  IfcSIPrefix.ATTO = {
    type: 3,
    value: "ATTO"
  };
  IFC2X32.IfcSIPrefix = IfcSIPrefix;

  var IfcSIUnitName = function IfcSIUnitName() {
    _classCallCheck2(this, IfcSIUnitName);
  };

  IfcSIUnitName.AMPERE = {
    type: 3,
    value: "AMPERE"
  };
  IfcSIUnitName.BECQUEREL = {
    type: 3,
    value: "BECQUEREL"
  };
  IfcSIUnitName.CANDELA = {
    type: 3,
    value: "CANDELA"
  };
  IfcSIUnitName.COULOMB = {
    type: 3,
    value: "COULOMB"
  };
  IfcSIUnitName.CUBIC_METRE = {
    type: 3,
    value: "CUBIC_METRE"
  };
  IfcSIUnitName.DEGREE_CELSIUS = {
    type: 3,
    value: "DEGREE_CELSIUS"
  };
  IfcSIUnitName.FARAD = {
    type: 3,
    value: "FARAD"
  };
  IfcSIUnitName.GRAM = {
    type: 3,
    value: "GRAM"
  };
  IfcSIUnitName.GRAY = {
    type: 3,
    value: "GRAY"
  };
  IfcSIUnitName.HENRY = {
    type: 3,
    value: "HENRY"
  };
  IfcSIUnitName.HERTZ = {
    type: 3,
    value: "HERTZ"
  };
  IfcSIUnitName.JOULE = {
    type: 3,
    value: "JOULE"
  };
  IfcSIUnitName.KELVIN = {
    type: 3,
    value: "KELVIN"
  };
  IfcSIUnitName.LUMEN = {
    type: 3,
    value: "LUMEN"
  };
  IfcSIUnitName.LUX = {
    type: 3,
    value: "LUX"
  };
  IfcSIUnitName.METRE = {
    type: 3,
    value: "METRE"
  };
  IfcSIUnitName.MOLE = {
    type: 3,
    value: "MOLE"
  };
  IfcSIUnitName.NEWTON = {
    type: 3,
    value: "NEWTON"
  };
  IfcSIUnitName.OHM = {
    type: 3,
    value: "OHM"
  };
  IfcSIUnitName.PASCAL = {
    type: 3,
    value: "PASCAL"
  };
  IfcSIUnitName.RADIAN = {
    type: 3,
    value: "RADIAN"
  };
  IfcSIUnitName.SECOND = {
    type: 3,
    value: "SECOND"
  };
  IfcSIUnitName.SIEMENS = {
    type: 3,
    value: "SIEMENS"
  };
  IfcSIUnitName.SIEVERT = {
    type: 3,
    value: "SIEVERT"
  };
  IfcSIUnitName.SQUARE_METRE = {
    type: 3,
    value: "SQUARE_METRE"
  };
  IfcSIUnitName.STERADIAN = {
    type: 3,
    value: "STERADIAN"
  };
  IfcSIUnitName.TESLA = {
    type: 3,
    value: "TESLA"
  };
  IfcSIUnitName.VOLT = {
    type: 3,
    value: "VOLT"
  };
  IfcSIUnitName.WATT = {
    type: 3,
    value: "WATT"
  };
  IfcSIUnitName.WEBER = {
    type: 3,
    value: "WEBER"
  };
  IFC2X32.IfcSIUnitName = IfcSIUnitName;

  var IfcSanitaryTerminalTypeEnum = function IfcSanitaryTerminalTypeEnum() {
    _classCallCheck2(this, IfcSanitaryTerminalTypeEnum);
  };

  IfcSanitaryTerminalTypeEnum.BATH = {
    type: 3,
    value: "BATH"
  };
  IfcSanitaryTerminalTypeEnum.BIDET = {
    type: 3,
    value: "BIDET"
  };
  IfcSanitaryTerminalTypeEnum.CISTERN = {
    type: 3,
    value: "CISTERN"
  };
  IfcSanitaryTerminalTypeEnum.SHOWER = {
    type: 3,
    value: "SHOWER"
  };
  IfcSanitaryTerminalTypeEnum.SINK = {
    type: 3,
    value: "SINK"
  };
  IfcSanitaryTerminalTypeEnum.SANITARYFOUNTAIN = {
    type: 3,
    value: "SANITARYFOUNTAIN"
  };
  IfcSanitaryTerminalTypeEnum.TOILETPAN = {
    type: 3,
    value: "TOILETPAN"
  };
  IfcSanitaryTerminalTypeEnum.URINAL = {
    type: 3,
    value: "URINAL"
  };
  IfcSanitaryTerminalTypeEnum.WASHHANDBASIN = {
    type: 3,
    value: "WASHHANDBASIN"
  };
  IfcSanitaryTerminalTypeEnum.WCSEAT = {
    type: 3,
    value: "WCSEAT"
  };
  IfcSanitaryTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSanitaryTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;

  var IfcSectionTypeEnum = function IfcSectionTypeEnum() {
    _classCallCheck2(this, IfcSectionTypeEnum);
  };

  IfcSectionTypeEnum.UNIFORM = {
    type: 3,
    value: "UNIFORM"
  };
  IfcSectionTypeEnum.TAPERED = {
    type: 3,
    value: "TAPERED"
  };
  IFC2X32.IfcSectionTypeEnum = IfcSectionTypeEnum;

  var IfcSensorTypeEnum = function IfcSensorTypeEnum() {
    _classCallCheck2(this, IfcSensorTypeEnum);
  };

  IfcSensorTypeEnum.CO2SENSOR = {
    type: 3,
    value: "CO2SENSOR"
  };
  IfcSensorTypeEnum.FIRESENSOR = {
    type: 3,
    value: "FIRESENSOR"
  };
  IfcSensorTypeEnum.FLOWSENSOR = {
    type: 3,
    value: "FLOWSENSOR"
  };
  IfcSensorTypeEnum.GASSENSOR = {
    type: 3,
    value: "GASSENSOR"
  };
  IfcSensorTypeEnum.HEATSENSOR = {
    type: 3,
    value: "HEATSENSOR"
  };
  IfcSensorTypeEnum.HUMIDITYSENSOR = {
    type: 3,
    value: "HUMIDITYSENSOR"
  };
  IfcSensorTypeEnum.LIGHTSENSOR = {
    type: 3,
    value: "LIGHTSENSOR"
  };
  IfcSensorTypeEnum.MOISTURESENSOR = {
    type: 3,
    value: "MOISTURESENSOR"
  };
  IfcSensorTypeEnum.MOVEMENTSENSOR = {
    type: 3,
    value: "MOVEMENTSENSOR"
  };
  IfcSensorTypeEnum.PRESSURESENSOR = {
    type: 3,
    value: "PRESSURESENSOR"
  };
  IfcSensorTypeEnum.SMOKESENSOR = {
    type: 3,
    value: "SMOKESENSOR"
  };
  IfcSensorTypeEnum.SOUNDSENSOR = {
    type: 3,
    value: "SOUNDSENSOR"
  };
  IfcSensorTypeEnum.TEMPERATURESENSOR = {
    type: 3,
    value: "TEMPERATURESENSOR"
  };
  IfcSensorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSensorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcSensorTypeEnum = IfcSensorTypeEnum;

  var IfcSequenceEnum = function IfcSequenceEnum() {
    _classCallCheck2(this, IfcSequenceEnum);
  };

  IfcSequenceEnum.START_START = {
    type: 3,
    value: "START_START"
  };
  IfcSequenceEnum.START_FINISH = {
    type: 3,
    value: "START_FINISH"
  };
  IfcSequenceEnum.FINISH_START = {
    type: 3,
    value: "FINISH_START"
  };
  IfcSequenceEnum.FINISH_FINISH = {
    type: 3,
    value: "FINISH_FINISH"
  };
  IfcSequenceEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcSequenceEnum = IfcSequenceEnum;

  var IfcServiceLifeFactorTypeEnum = function IfcServiceLifeFactorTypeEnum() {
    _classCallCheck2(this, IfcServiceLifeFactorTypeEnum);
  };

  IfcServiceLifeFactorTypeEnum.A_QUALITYOFCOMPONENTS = {
    type: 3,
    value: "A_QUALITYOFCOMPONENTS"
  };
  IfcServiceLifeFactorTypeEnum.B_DESIGNLEVEL = {
    type: 3,
    value: "B_DESIGNLEVEL"
  };
  IfcServiceLifeFactorTypeEnum.C_WORKEXECUTIONLEVEL = {
    type: 3,
    value: "C_WORKEXECUTIONLEVEL"
  };
  IfcServiceLifeFactorTypeEnum.D_INDOORENVIRONMENT = {
    type: 3,
    value: "D_INDOORENVIRONMENT"
  };
  IfcServiceLifeFactorTypeEnum.E_OUTDOORENVIRONMENT = {
    type: 3,
    value: "E_OUTDOORENVIRONMENT"
  };
  IfcServiceLifeFactorTypeEnum.F_INUSECONDITIONS = {
    type: 3,
    value: "F_INUSECONDITIONS"
  };
  IfcServiceLifeFactorTypeEnum.G_MAINTENANCELEVEL = {
    type: 3,
    value: "G_MAINTENANCELEVEL"
  };
  IfcServiceLifeFactorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcServiceLifeFactorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcServiceLifeFactorTypeEnum = IfcServiceLifeFactorTypeEnum;

  var IfcServiceLifeTypeEnum = function IfcServiceLifeTypeEnum() {
    _classCallCheck2(this, IfcServiceLifeTypeEnum);
  };

  IfcServiceLifeTypeEnum.ACTUALSERVICELIFE = {
    type: 3,
    value: "ACTUALSERVICELIFE"
  };
  IfcServiceLifeTypeEnum.EXPECTEDSERVICELIFE = {
    type: 3,
    value: "EXPECTEDSERVICELIFE"
  };
  IfcServiceLifeTypeEnum.OPTIMISTICREFERENCESERVICELIFE = {
    type: 3,
    value: "OPTIMISTICREFERENCESERVICELIFE"
  };
  IfcServiceLifeTypeEnum.PESSIMISTICREFERENCESERVICELIFE = {
    type: 3,
    value: "PESSIMISTICREFERENCESERVICELIFE"
  };
  IfcServiceLifeTypeEnum.REFERENCESERVICELIFE = {
    type: 3,
    value: "REFERENCESERVICELIFE"
  };
  IFC2X32.IfcServiceLifeTypeEnum = IfcServiceLifeTypeEnum;

  var IfcSlabTypeEnum = function IfcSlabTypeEnum() {
    _classCallCheck2(this, IfcSlabTypeEnum);
  };

  IfcSlabTypeEnum.FLOOR = {
    type: 3,
    value: "FLOOR"
  };
  IfcSlabTypeEnum.ROOF = {
    type: 3,
    value: "ROOF"
  };
  IfcSlabTypeEnum.LANDING = {
    type: 3,
    value: "LANDING"
  };
  IfcSlabTypeEnum.BASESLAB = {
    type: 3,
    value: "BASESLAB"
  };
  IfcSlabTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSlabTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcSlabTypeEnum = IfcSlabTypeEnum;

  var IfcSoundScaleEnum = function IfcSoundScaleEnum() {
    _classCallCheck2(this, IfcSoundScaleEnum);
  };

  IfcSoundScaleEnum.DBA = {
    type: 3,
    value: "DBA"
  };
  IfcSoundScaleEnum.DBB = {
    type: 3,
    value: "DBB"
  };
  IfcSoundScaleEnum.DBC = {
    type: 3,
    value: "DBC"
  };
  IfcSoundScaleEnum.NC = {
    type: 3,
    value: "NC"
  };
  IfcSoundScaleEnum.NR = {
    type: 3,
    value: "NR"
  };
  IfcSoundScaleEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSoundScaleEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcSoundScaleEnum = IfcSoundScaleEnum;

  var IfcSpaceHeaterTypeEnum = function IfcSpaceHeaterTypeEnum() {
    _classCallCheck2(this, IfcSpaceHeaterTypeEnum);
  };

  IfcSpaceHeaterTypeEnum.SECTIONALRADIATOR = {
    type: 3,
    value: "SECTIONALRADIATOR"
  };
  IfcSpaceHeaterTypeEnum.PANELRADIATOR = {
    type: 3,
    value: "PANELRADIATOR"
  };
  IfcSpaceHeaterTypeEnum.TUBULARRADIATOR = {
    type: 3,
    value: "TUBULARRADIATOR"
  };
  IfcSpaceHeaterTypeEnum.CONVECTOR = {
    type: 3,
    value: "CONVECTOR"
  };
  IfcSpaceHeaterTypeEnum.BASEBOARDHEATER = {
    type: 3,
    value: "BASEBOARDHEATER"
  };
  IfcSpaceHeaterTypeEnum.FINNEDTUBEUNIT = {
    type: 3,
    value: "FINNEDTUBEUNIT"
  };
  IfcSpaceHeaterTypeEnum.UNITHEATER = {
    type: 3,
    value: "UNITHEATER"
  };
  IfcSpaceHeaterTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSpaceHeaterTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;

  var IfcSpaceTypeEnum = function IfcSpaceTypeEnum() {
    _classCallCheck2(this, IfcSpaceTypeEnum);
  };

  IfcSpaceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSpaceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcSpaceTypeEnum = IfcSpaceTypeEnum;

  var IfcStackTerminalTypeEnum = function IfcStackTerminalTypeEnum() {
    _classCallCheck2(this, IfcStackTerminalTypeEnum);
  };

  IfcStackTerminalTypeEnum.BIRDCAGE = {
    type: 3,
    value: "BIRDCAGE"
  };
  IfcStackTerminalTypeEnum.COWL = {
    type: 3,
    value: "COWL"
  };
  IfcStackTerminalTypeEnum.RAINWATERHOPPER = {
    type: 3,
    value: "RAINWATERHOPPER"
  };
  IfcStackTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStackTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;

  var IfcStairFlightTypeEnum = function IfcStairFlightTypeEnum() {
    _classCallCheck2(this, IfcStairFlightTypeEnum);
  };

  IfcStairFlightTypeEnum.STRAIGHT = {
    type: 3,
    value: "STRAIGHT"
  };
  IfcStairFlightTypeEnum.WINDER = {
    type: 3,
    value: "WINDER"
  };
  IfcStairFlightTypeEnum.SPIRAL = {
    type: 3,
    value: "SPIRAL"
  };
  IfcStairFlightTypeEnum.CURVED = {
    type: 3,
    value: "CURVED"
  };
  IfcStairFlightTypeEnum.FREEFORM = {
    type: 3,
    value: "FREEFORM"
  };
  IfcStairFlightTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStairFlightTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;

  var IfcStairTypeEnum = function IfcStairTypeEnum() {
    _classCallCheck2(this, IfcStairTypeEnum);
  };

  IfcStairTypeEnum.STRAIGHT_RUN_STAIR = {
    type: 3,
    value: "STRAIGHT_RUN_STAIR"
  };
  IfcStairTypeEnum.TWO_STRAIGHT_RUN_STAIR = {
    type: 3,
    value: "TWO_STRAIGHT_RUN_STAIR"
  };
  IfcStairTypeEnum.QUARTER_WINDING_STAIR = {
    type: 3,
    value: "QUARTER_WINDING_STAIR"
  };
  IfcStairTypeEnum.QUARTER_TURN_STAIR = {
    type: 3,
    value: "QUARTER_TURN_STAIR"
  };
  IfcStairTypeEnum.HALF_WINDING_STAIR = {
    type: 3,
    value: "HALF_WINDING_STAIR"
  };
  IfcStairTypeEnum.HALF_TURN_STAIR = {
    type: 3,
    value: "HALF_TURN_STAIR"
  };
  IfcStairTypeEnum.TWO_QUARTER_WINDING_STAIR = {
    type: 3,
    value: "TWO_QUARTER_WINDING_STAIR"
  };
  IfcStairTypeEnum.TWO_QUARTER_TURN_STAIR = {
    type: 3,
    value: "TWO_QUARTER_TURN_STAIR"
  };
  IfcStairTypeEnum.THREE_QUARTER_WINDING_STAIR = {
    type: 3,
    value: "THREE_QUARTER_WINDING_STAIR"
  };
  IfcStairTypeEnum.THREE_QUARTER_TURN_STAIR = {
    type: 3,
    value: "THREE_QUARTER_TURN_STAIR"
  };
  IfcStairTypeEnum.SPIRAL_STAIR = {
    type: 3,
    value: "SPIRAL_STAIR"
  };
  IfcStairTypeEnum.DOUBLE_RETURN_STAIR = {
    type: 3,
    value: "DOUBLE_RETURN_STAIR"
  };
  IfcStairTypeEnum.CURVED_RUN_STAIR = {
    type: 3,
    value: "CURVED_RUN_STAIR"
  };
  IfcStairTypeEnum.TWO_CURVED_RUN_STAIR = {
    type: 3,
    value: "TWO_CURVED_RUN_STAIR"
  };
  IfcStairTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStairTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcStairTypeEnum = IfcStairTypeEnum;

  var IfcStateEnum = function IfcStateEnum() {
    _classCallCheck2(this, IfcStateEnum);
  };

  IfcStateEnum.READWRITE = {
    type: 3,
    value: "READWRITE"
  };
  IfcStateEnum.READONLY = {
    type: 3,
    value: "READONLY"
  };
  IfcStateEnum.LOCKED = {
    type: 3,
    value: "LOCKED"
  };
  IfcStateEnum.READWRITELOCKED = {
    type: 3,
    value: "READWRITELOCKED"
  };
  IfcStateEnum.READONLYLOCKED = {
    type: 3,
    value: "READONLYLOCKED"
  };
  IFC2X32.IfcStateEnum = IfcStateEnum;

  var IfcStructuralCurveTypeEnum = function IfcStructuralCurveTypeEnum() {
    _classCallCheck2(this, IfcStructuralCurveTypeEnum);
  };

  IfcStructuralCurveTypeEnum.RIGID_JOINED_MEMBER = {
    type: 3,
    value: "RIGID_JOINED_MEMBER"
  };
  IfcStructuralCurveTypeEnum.PIN_JOINED_MEMBER = {
    type: 3,
    value: "PIN_JOINED_MEMBER"
  };
  IfcStructuralCurveTypeEnum.CABLE = {
    type: 3,
    value: "CABLE"
  };
  IfcStructuralCurveTypeEnum.TENSION_MEMBER = {
    type: 3,
    value: "TENSION_MEMBER"
  };
  IfcStructuralCurveTypeEnum.COMPRESSION_MEMBER = {
    type: 3,
    value: "COMPRESSION_MEMBER"
  };
  IfcStructuralCurveTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStructuralCurveTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcStructuralCurveTypeEnum = IfcStructuralCurveTypeEnum;

  var IfcStructuralSurfaceTypeEnum = function IfcStructuralSurfaceTypeEnum() {
    _classCallCheck2(this, IfcStructuralSurfaceTypeEnum);
  };

  IfcStructuralSurfaceTypeEnum.BENDING_ELEMENT = {
    type: 3,
    value: "BENDING_ELEMENT"
  };
  IfcStructuralSurfaceTypeEnum.MEMBRANE_ELEMENT = {
    type: 3,
    value: "MEMBRANE_ELEMENT"
  };
  IfcStructuralSurfaceTypeEnum.SHELL = {
    type: 3,
    value: "SHELL"
  };
  IfcStructuralSurfaceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStructuralSurfaceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcStructuralSurfaceTypeEnum = IfcStructuralSurfaceTypeEnum;

  var IfcSurfaceSide = function IfcSurfaceSide() {
    _classCallCheck2(this, IfcSurfaceSide);
  };

  IfcSurfaceSide.POSITIVE = {
    type: 3,
    value: "POSITIVE"
  };
  IfcSurfaceSide.NEGATIVE = {
    type: 3,
    value: "NEGATIVE"
  };
  IfcSurfaceSide.BOTH = {
    type: 3,
    value: "BOTH"
  };
  IFC2X32.IfcSurfaceSide = IfcSurfaceSide;

  var IfcSurfaceTextureEnum = function IfcSurfaceTextureEnum() {
    _classCallCheck2(this, IfcSurfaceTextureEnum);
  };

  IfcSurfaceTextureEnum.BUMP = {
    type: 3,
    value: "BUMP"
  };
  IfcSurfaceTextureEnum.OPACITY = {
    type: 3,
    value: "OPACITY"
  };
  IfcSurfaceTextureEnum.REFLECTION = {
    type: 3,
    value: "REFLECTION"
  };
  IfcSurfaceTextureEnum.SELFILLUMINATION = {
    type: 3,
    value: "SELFILLUMINATION"
  };
  IfcSurfaceTextureEnum.SHININESS = {
    type: 3,
    value: "SHININESS"
  };
  IfcSurfaceTextureEnum.SPECULAR = {
    type: 3,
    value: "SPECULAR"
  };
  IfcSurfaceTextureEnum.TEXTURE = {
    type: 3,
    value: "TEXTURE"
  };
  IfcSurfaceTextureEnum.TRANSPARENCYMAP = {
    type: 3,
    value: "TRANSPARENCYMAP"
  };
  IfcSurfaceTextureEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcSurfaceTextureEnum = IfcSurfaceTextureEnum;

  var IfcSwitchingDeviceTypeEnum = function IfcSwitchingDeviceTypeEnum() {
    _classCallCheck2(this, IfcSwitchingDeviceTypeEnum);
  };

  IfcSwitchingDeviceTypeEnum.CONTACTOR = {
    type: 3,
    value: "CONTACTOR"
  };
  IfcSwitchingDeviceTypeEnum.EMERGENCYSTOP = {
    type: 3,
    value: "EMERGENCYSTOP"
  };
  IfcSwitchingDeviceTypeEnum.STARTER = {
    type: 3,
    value: "STARTER"
  };
  IfcSwitchingDeviceTypeEnum.SWITCHDISCONNECTOR = {
    type: 3,
    value: "SWITCHDISCONNECTOR"
  };
  IfcSwitchingDeviceTypeEnum.TOGGLESWITCH = {
    type: 3,
    value: "TOGGLESWITCH"
  };
  IfcSwitchingDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSwitchingDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;

  var IfcTankTypeEnum = function IfcTankTypeEnum() {
    _classCallCheck2(this, IfcTankTypeEnum);
  };

  IfcTankTypeEnum.PREFORMED = {
    type: 3,
    value: "PREFORMED"
  };
  IfcTankTypeEnum.SECTIONAL = {
    type: 3,
    value: "SECTIONAL"
  };
  IfcTankTypeEnum.EXPANSION = {
    type: 3,
    value: "EXPANSION"
  };
  IfcTankTypeEnum.PRESSUREVESSEL = {
    type: 3,
    value: "PRESSUREVESSEL"
  };
  IfcTankTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTankTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcTankTypeEnum = IfcTankTypeEnum;

  var IfcTendonTypeEnum = function IfcTendonTypeEnum() {
    _classCallCheck2(this, IfcTendonTypeEnum);
  };

  IfcTendonTypeEnum.STRAND = {
    type: 3,
    value: "STRAND"
  };
  IfcTendonTypeEnum.WIRE = {
    type: 3,
    value: "WIRE"
  };
  IfcTendonTypeEnum.BAR = {
    type: 3,
    value: "BAR"
  };
  IfcTendonTypeEnum.COATED = {
    type: 3,
    value: "COATED"
  };
  IfcTendonTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTendonTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcTendonTypeEnum = IfcTendonTypeEnum;

  var IfcTextPath = function IfcTextPath() {
    _classCallCheck2(this, IfcTextPath);
  };

  IfcTextPath.LEFT = {
    type: 3,
    value: "LEFT"
  };
  IfcTextPath.RIGHT = {
    type: 3,
    value: "RIGHT"
  };
  IfcTextPath.UP = {
    type: 3,
    value: "UP"
  };
  IfcTextPath.DOWN = {
    type: 3,
    value: "DOWN"
  };
  IFC2X32.IfcTextPath = IfcTextPath;

  var IfcThermalLoadSourceEnum = function IfcThermalLoadSourceEnum() {
    _classCallCheck2(this, IfcThermalLoadSourceEnum);
  };

  IfcThermalLoadSourceEnum.PEOPLE = {
    type: 3,
    value: "PEOPLE"
  };
  IfcThermalLoadSourceEnum.LIGHTING = {
    type: 3,
    value: "LIGHTING"
  };
  IfcThermalLoadSourceEnum.EQUIPMENT = {
    type: 3,
    value: "EQUIPMENT"
  };
  IfcThermalLoadSourceEnum.VENTILATIONINDOORAIR = {
    type: 3,
    value: "VENTILATIONINDOORAIR"
  };
  IfcThermalLoadSourceEnum.VENTILATIONOUTSIDEAIR = {
    type: 3,
    value: "VENTILATIONOUTSIDEAIR"
  };
  IfcThermalLoadSourceEnum.RECIRCULATEDAIR = {
    type: 3,
    value: "RECIRCULATEDAIR"
  };
  IfcThermalLoadSourceEnum.EXHAUSTAIR = {
    type: 3,
    value: "EXHAUSTAIR"
  };
  IfcThermalLoadSourceEnum.AIREXCHANGERATE = {
    type: 3,
    value: "AIREXCHANGERATE"
  };
  IfcThermalLoadSourceEnum.DRYBULBTEMPERATURE = {
    type: 3,
    value: "DRYBULBTEMPERATURE"
  };
  IfcThermalLoadSourceEnum.RELATIVEHUMIDITY = {
    type: 3,
    value: "RELATIVEHUMIDITY"
  };
  IfcThermalLoadSourceEnum.INFILTRATION = {
    type: 3,
    value: "INFILTRATION"
  };
  IfcThermalLoadSourceEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcThermalLoadSourceEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcThermalLoadSourceEnum = IfcThermalLoadSourceEnum;

  var IfcThermalLoadTypeEnum = function IfcThermalLoadTypeEnum() {
    _classCallCheck2(this, IfcThermalLoadTypeEnum);
  };

  IfcThermalLoadTypeEnum.SENSIBLE = {
    type: 3,
    value: "SENSIBLE"
  };
  IfcThermalLoadTypeEnum.LATENT = {
    type: 3,
    value: "LATENT"
  };
  IfcThermalLoadTypeEnum.RADIANT = {
    type: 3,
    value: "RADIANT"
  };
  IfcThermalLoadTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcThermalLoadTypeEnum = IfcThermalLoadTypeEnum;

  var IfcTimeSeriesDataTypeEnum = function IfcTimeSeriesDataTypeEnum() {
    _classCallCheck2(this, IfcTimeSeriesDataTypeEnum);
  };

  IfcTimeSeriesDataTypeEnum.CONTINUOUS = {
    type: 3,
    value: "CONTINUOUS"
  };
  IfcTimeSeriesDataTypeEnum.DISCRETE = {
    type: 3,
    value: "DISCRETE"
  };
  IfcTimeSeriesDataTypeEnum.DISCRETEBINARY = {
    type: 3,
    value: "DISCRETEBINARY"
  };
  IfcTimeSeriesDataTypeEnum.PIECEWISEBINARY = {
    type: 3,
    value: "PIECEWISEBINARY"
  };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONSTANT = {
    type: 3,
    value: "PIECEWISECONSTANT"
  };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONTINUOUS = {
    type: 3,
    value: "PIECEWISECONTINUOUS"
  };
  IfcTimeSeriesDataTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;

  var IfcTimeSeriesScheduleTypeEnum = function IfcTimeSeriesScheduleTypeEnum() {
    _classCallCheck2(this, IfcTimeSeriesScheduleTypeEnum);
  };

  IfcTimeSeriesScheduleTypeEnum.ANNUAL = {
    type: 3,
    value: "ANNUAL"
  };
  IfcTimeSeriesScheduleTypeEnum.MONTHLY = {
    type: 3,
    value: "MONTHLY"
  };
  IfcTimeSeriesScheduleTypeEnum.WEEKLY = {
    type: 3,
    value: "WEEKLY"
  };
  IfcTimeSeriesScheduleTypeEnum.DAILY = {
    type: 3,
    value: "DAILY"
  };
  IfcTimeSeriesScheduleTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTimeSeriesScheduleTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcTimeSeriesScheduleTypeEnum = IfcTimeSeriesScheduleTypeEnum;

  var IfcTransformerTypeEnum = function IfcTransformerTypeEnum() {
    _classCallCheck2(this, IfcTransformerTypeEnum);
  };

  IfcTransformerTypeEnum.CURRENT = {
    type: 3,
    value: "CURRENT"
  };
  IfcTransformerTypeEnum.FREQUENCY = {
    type: 3,
    value: "FREQUENCY"
  };
  IfcTransformerTypeEnum.VOLTAGE = {
    type: 3,
    value: "VOLTAGE"
  };
  IfcTransformerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTransformerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcTransformerTypeEnum = IfcTransformerTypeEnum;

  var IfcTransitionCode = function IfcTransitionCode() {
    _classCallCheck2(this, IfcTransitionCode);
  };

  IfcTransitionCode.DISCONTINUOUS = {
    type: 3,
    value: "DISCONTINUOUS"
  };
  IfcTransitionCode.CONTINUOUS = {
    type: 3,
    value: "CONTINUOUS"
  };
  IfcTransitionCode.CONTSAMEGRADIENT = {
    type: 3,
    value: "CONTSAMEGRADIENT"
  };
  IfcTransitionCode.CONTSAMEGRADIENTSAMECURVATURE = {
    type: 3,
    value: "CONTSAMEGRADIENTSAMECURVATURE"
  };
  IFC2X32.IfcTransitionCode = IfcTransitionCode;

  var IfcTransportElementTypeEnum = function IfcTransportElementTypeEnum() {
    _classCallCheck2(this, IfcTransportElementTypeEnum);
  };

  IfcTransportElementTypeEnum.ELEVATOR = {
    type: 3,
    value: "ELEVATOR"
  };
  IfcTransportElementTypeEnum.ESCALATOR = {
    type: 3,
    value: "ESCALATOR"
  };
  IfcTransportElementTypeEnum.MOVINGWALKWAY = {
    type: 3,
    value: "MOVINGWALKWAY"
  };
  IfcTransportElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTransportElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;

  var IfcTrimmingPreference = function IfcTrimmingPreference() {
    _classCallCheck2(this, IfcTrimmingPreference);
  };

  IfcTrimmingPreference.CARTESIAN = {
    type: 3,
    value: "CARTESIAN"
  };
  IfcTrimmingPreference.PARAMETER = {
    type: 3,
    value: "PARAMETER"
  };
  IfcTrimmingPreference.UNSPECIFIED = {
    type: 3,
    value: "UNSPECIFIED"
  };
  IFC2X32.IfcTrimmingPreference = IfcTrimmingPreference;

  var IfcTubeBundleTypeEnum = function IfcTubeBundleTypeEnum() {
    _classCallCheck2(this, IfcTubeBundleTypeEnum);
  };

  IfcTubeBundleTypeEnum.FINNED = {
    type: 3,
    value: "FINNED"
  };
  IfcTubeBundleTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTubeBundleTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;

  var IfcUnitEnum = function IfcUnitEnum() {
    _classCallCheck2(this, IfcUnitEnum);
  };

  IfcUnitEnum.ABSORBEDDOSEUNIT = {
    type: 3,
    value: "ABSORBEDDOSEUNIT"
  };
  IfcUnitEnum.AMOUNTOFSUBSTANCEUNIT = {
    type: 3,
    value: "AMOUNTOFSUBSTANCEUNIT"
  };
  IfcUnitEnum.AREAUNIT = {
    type: 3,
    value: "AREAUNIT"
  };
  IfcUnitEnum.DOSEEQUIVALENTUNIT = {
    type: 3,
    value: "DOSEEQUIVALENTUNIT"
  };
  IfcUnitEnum.ELECTRICCAPACITANCEUNIT = {
    type: 3,
    value: "ELECTRICCAPACITANCEUNIT"
  };
  IfcUnitEnum.ELECTRICCHARGEUNIT = {
    type: 3,
    value: "ELECTRICCHARGEUNIT"
  };
  IfcUnitEnum.ELECTRICCONDUCTANCEUNIT = {
    type: 3,
    value: "ELECTRICCONDUCTANCEUNIT"
  };
  IfcUnitEnum.ELECTRICCURRENTUNIT = {
    type: 3,
    value: "ELECTRICCURRENTUNIT"
  };
  IfcUnitEnum.ELECTRICRESISTANCEUNIT = {
    type: 3,
    value: "ELECTRICRESISTANCEUNIT"
  };
  IfcUnitEnum.ELECTRICVOLTAGEUNIT = {
    type: 3,
    value: "ELECTRICVOLTAGEUNIT"
  };
  IfcUnitEnum.ENERGYUNIT = {
    type: 3,
    value: "ENERGYUNIT"
  };
  IfcUnitEnum.FORCEUNIT = {
    type: 3,
    value: "FORCEUNIT"
  };
  IfcUnitEnum.FREQUENCYUNIT = {
    type: 3,
    value: "FREQUENCYUNIT"
  };
  IfcUnitEnum.ILLUMINANCEUNIT = {
    type: 3,
    value: "ILLUMINANCEUNIT"
  };
  IfcUnitEnum.INDUCTANCEUNIT = {
    type: 3,
    value: "INDUCTANCEUNIT"
  };
  IfcUnitEnum.LENGTHUNIT = {
    type: 3,
    value: "LENGTHUNIT"
  };
  IfcUnitEnum.LUMINOUSFLUXUNIT = {
    type: 3,
    value: "LUMINOUSFLUXUNIT"
  };
  IfcUnitEnum.LUMINOUSINTENSITYUNIT = {
    type: 3,
    value: "LUMINOUSINTENSITYUNIT"
  };
  IfcUnitEnum.MAGNETICFLUXDENSITYUNIT = {
    type: 3,
    value: "MAGNETICFLUXDENSITYUNIT"
  };
  IfcUnitEnum.MAGNETICFLUXUNIT = {
    type: 3,
    value: "MAGNETICFLUXUNIT"
  };
  IfcUnitEnum.MASSUNIT = {
    type: 3,
    value: "MASSUNIT"
  };
  IfcUnitEnum.PLANEANGLEUNIT = {
    type: 3,
    value: "PLANEANGLEUNIT"
  };
  IfcUnitEnum.POWERUNIT = {
    type: 3,
    value: "POWERUNIT"
  };
  IfcUnitEnum.PRESSUREUNIT = {
    type: 3,
    value: "PRESSUREUNIT"
  };
  IfcUnitEnum.RADIOACTIVITYUNIT = {
    type: 3,
    value: "RADIOACTIVITYUNIT"
  };
  IfcUnitEnum.SOLIDANGLEUNIT = {
    type: 3,
    value: "SOLIDANGLEUNIT"
  };
  IfcUnitEnum.THERMODYNAMICTEMPERATUREUNIT = {
    type: 3,
    value: "THERMODYNAMICTEMPERATUREUNIT"
  };
  IfcUnitEnum.TIMEUNIT = {
    type: 3,
    value: "TIMEUNIT"
  };
  IfcUnitEnum.VOLUMEUNIT = {
    type: 3,
    value: "VOLUMEUNIT"
  };
  IfcUnitEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC2X32.IfcUnitEnum = IfcUnitEnum;

  var IfcUnitaryEquipmentTypeEnum = function IfcUnitaryEquipmentTypeEnum() {
    _classCallCheck2(this, IfcUnitaryEquipmentTypeEnum);
  };

  IfcUnitaryEquipmentTypeEnum.AIRHANDLER = {
    type: 3,
    value: "AIRHANDLER"
  };
  IfcUnitaryEquipmentTypeEnum.AIRCONDITIONINGUNIT = {
    type: 3,
    value: "AIRCONDITIONINGUNIT"
  };
  IfcUnitaryEquipmentTypeEnum.SPLITSYSTEM = {
    type: 3,
    value: "SPLITSYSTEM"
  };
  IfcUnitaryEquipmentTypeEnum.ROOFTOPUNIT = {
    type: 3,
    value: "ROOFTOPUNIT"
  };
  IfcUnitaryEquipmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcUnitaryEquipmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;

  var IfcValveTypeEnum = function IfcValveTypeEnum() {
    _classCallCheck2(this, IfcValveTypeEnum);
  };

  IfcValveTypeEnum.AIRRELEASE = {
    type: 3,
    value: "AIRRELEASE"
  };
  IfcValveTypeEnum.ANTIVACUUM = {
    type: 3,
    value: "ANTIVACUUM"
  };
  IfcValveTypeEnum.CHANGEOVER = {
    type: 3,
    value: "CHANGEOVER"
  };
  IfcValveTypeEnum.CHECK = {
    type: 3,
    value: "CHECK"
  };
  IfcValveTypeEnum.COMMISSIONING = {
    type: 3,
    value: "COMMISSIONING"
  };
  IfcValveTypeEnum.DIVERTING = {
    type: 3,
    value: "DIVERTING"
  };
  IfcValveTypeEnum.DRAWOFFCOCK = {
    type: 3,
    value: "DRAWOFFCOCK"
  };
  IfcValveTypeEnum.DOUBLECHECK = {
    type: 3,
    value: "DOUBLECHECK"
  };
  IfcValveTypeEnum.DOUBLEREGULATING = {
    type: 3,
    value: "DOUBLEREGULATING"
  };
  IfcValveTypeEnum.FAUCET = {
    type: 3,
    value: "FAUCET"
  };
  IfcValveTypeEnum.FLUSHING = {
    type: 3,
    value: "FLUSHING"
  };
  IfcValveTypeEnum.GASCOCK = {
    type: 3,
    value: "GASCOCK"
  };
  IfcValveTypeEnum.GASTAP = {
    type: 3,
    value: "GASTAP"
  };
  IfcValveTypeEnum.ISOLATING = {
    type: 3,
    value: "ISOLATING"
  };
  IfcValveTypeEnum.MIXING = {
    type: 3,
    value: "MIXING"
  };
  IfcValveTypeEnum.PRESSUREREDUCING = {
    type: 3,
    value: "PRESSUREREDUCING"
  };
  IfcValveTypeEnum.PRESSURERELIEF = {
    type: 3,
    value: "PRESSURERELIEF"
  };
  IfcValveTypeEnum.REGULATING = {
    type: 3,
    value: "REGULATING"
  };
  IfcValveTypeEnum.SAFETYCUTOFF = {
    type: 3,
    value: "SAFETYCUTOFF"
  };
  IfcValveTypeEnum.STEAMTRAP = {
    type: 3,
    value: "STEAMTRAP"
  };
  IfcValveTypeEnum.STOPCOCK = {
    type: 3,
    value: "STOPCOCK"
  };
  IfcValveTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcValveTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcValveTypeEnum = IfcValveTypeEnum;

  var IfcVibrationIsolatorTypeEnum = function IfcVibrationIsolatorTypeEnum() {
    _classCallCheck2(this, IfcVibrationIsolatorTypeEnum);
  };

  IfcVibrationIsolatorTypeEnum.COMPRESSION = {
    type: 3,
    value: "COMPRESSION"
  };
  IfcVibrationIsolatorTypeEnum.SPRING = {
    type: 3,
    value: "SPRING"
  };
  IfcVibrationIsolatorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcVibrationIsolatorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;

  var IfcWallTypeEnum = function IfcWallTypeEnum() {
    _classCallCheck2(this, IfcWallTypeEnum);
  };

  IfcWallTypeEnum.STANDARD = {
    type: 3,
    value: "STANDARD"
  };
  IfcWallTypeEnum.POLYGONAL = {
    type: 3,
    value: "POLYGONAL"
  };
  IfcWallTypeEnum.SHEAR = {
    type: 3,
    value: "SHEAR"
  };
  IfcWallTypeEnum.ELEMENTEDWALL = {
    type: 3,
    value: "ELEMENTEDWALL"
  };
  IfcWallTypeEnum.PLUMBINGWALL = {
    type: 3,
    value: "PLUMBINGWALL"
  };
  IfcWallTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWallTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcWallTypeEnum = IfcWallTypeEnum;

  var IfcWasteTerminalTypeEnum = function IfcWasteTerminalTypeEnum() {
    _classCallCheck2(this, IfcWasteTerminalTypeEnum);
  };

  IfcWasteTerminalTypeEnum.FLOORTRAP = {
    type: 3,
    value: "FLOORTRAP"
  };
  IfcWasteTerminalTypeEnum.FLOORWASTE = {
    type: 3,
    value: "FLOORWASTE"
  };
  IfcWasteTerminalTypeEnum.GULLYSUMP = {
    type: 3,
    value: "GULLYSUMP"
  };
  IfcWasteTerminalTypeEnum.GULLYTRAP = {
    type: 3,
    value: "GULLYTRAP"
  };
  IfcWasteTerminalTypeEnum.GREASEINTERCEPTOR = {
    type: 3,
    value: "GREASEINTERCEPTOR"
  };
  IfcWasteTerminalTypeEnum.OILINTERCEPTOR = {
    type: 3,
    value: "OILINTERCEPTOR"
  };
  IfcWasteTerminalTypeEnum.PETROLINTERCEPTOR = {
    type: 3,
    value: "PETROLINTERCEPTOR"
  };
  IfcWasteTerminalTypeEnum.ROOFDRAIN = {
    type: 3,
    value: "ROOFDRAIN"
  };
  IfcWasteTerminalTypeEnum.WASTEDISPOSALUNIT = {
    type: 3,
    value: "WASTEDISPOSALUNIT"
  };
  IfcWasteTerminalTypeEnum.WASTETRAP = {
    type: 3,
    value: "WASTETRAP"
  };
  IfcWasteTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWasteTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;

  var IfcWindowPanelOperationEnum = function IfcWindowPanelOperationEnum() {
    _classCallCheck2(this, IfcWindowPanelOperationEnum);
  };

  IfcWindowPanelOperationEnum.SIDEHUNGRIGHTHAND = {
    type: 3,
    value: "SIDEHUNGRIGHTHAND"
  };
  IfcWindowPanelOperationEnum.SIDEHUNGLEFTHAND = {
    type: 3,
    value: "SIDEHUNGLEFTHAND"
  };
  IfcWindowPanelOperationEnum.TILTANDTURNRIGHTHAND = {
    type: 3,
    value: "TILTANDTURNRIGHTHAND"
  };
  IfcWindowPanelOperationEnum.TILTANDTURNLEFTHAND = {
    type: 3,
    value: "TILTANDTURNLEFTHAND"
  };
  IfcWindowPanelOperationEnum.TOPHUNG = {
    type: 3,
    value: "TOPHUNG"
  };
  IfcWindowPanelOperationEnum.BOTTOMHUNG = {
    type: 3,
    value: "BOTTOMHUNG"
  };
  IfcWindowPanelOperationEnum.PIVOTHORIZONTAL = {
    type: 3,
    value: "PIVOTHORIZONTAL"
  };
  IfcWindowPanelOperationEnum.PIVOTVERTICAL = {
    type: 3,
    value: "PIVOTVERTICAL"
  };
  IfcWindowPanelOperationEnum.SLIDINGHORIZONTAL = {
    type: 3,
    value: "SLIDINGHORIZONTAL"
  };
  IfcWindowPanelOperationEnum.SLIDINGVERTICAL = {
    type: 3,
    value: "SLIDINGVERTICAL"
  };
  IfcWindowPanelOperationEnum.REMOVABLECASEMENT = {
    type: 3,
    value: "REMOVABLECASEMENT"
  };
  IfcWindowPanelOperationEnum.FIXEDCASEMENT = {
    type: 3,
    value: "FIXEDCASEMENT"
  };
  IfcWindowPanelOperationEnum.OTHEROPERATION = {
    type: 3,
    value: "OTHEROPERATION"
  };
  IfcWindowPanelOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;

  var IfcWindowPanelPositionEnum = function IfcWindowPanelPositionEnum() {
    _classCallCheck2(this, IfcWindowPanelPositionEnum);
  };

  IfcWindowPanelPositionEnum.LEFT = {
    type: 3,
    value: "LEFT"
  };
  IfcWindowPanelPositionEnum.MIDDLE = {
    type: 3,
    value: "MIDDLE"
  };
  IfcWindowPanelPositionEnum.RIGHT = {
    type: 3,
    value: "RIGHT"
  };
  IfcWindowPanelPositionEnum.BOTTOM = {
    type: 3,
    value: "BOTTOM"
  };
  IfcWindowPanelPositionEnum.TOP = {
    type: 3,
    value: "TOP"
  };
  IfcWindowPanelPositionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;

  var IfcWindowStyleConstructionEnum = function IfcWindowStyleConstructionEnum() {
    _classCallCheck2(this, IfcWindowStyleConstructionEnum);
  };

  IfcWindowStyleConstructionEnum.ALUMINIUM = {
    type: 3,
    value: "ALUMINIUM"
  };
  IfcWindowStyleConstructionEnum.HIGH_GRADE_STEEL = {
    type: 3,
    value: "HIGH_GRADE_STEEL"
  };
  IfcWindowStyleConstructionEnum.STEEL = {
    type: 3,
    value: "STEEL"
  };
  IfcWindowStyleConstructionEnum.WOOD = {
    type: 3,
    value: "WOOD"
  };
  IfcWindowStyleConstructionEnum.ALUMINIUM_WOOD = {
    type: 3,
    value: "ALUMINIUM_WOOD"
  };
  IfcWindowStyleConstructionEnum.PLASTIC = {
    type: 3,
    value: "PLASTIC"
  };
  IfcWindowStyleConstructionEnum.OTHER_CONSTRUCTION = {
    type: 3,
    value: "OTHER_CONSTRUCTION"
  };
  IfcWindowStyleConstructionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcWindowStyleConstructionEnum = IfcWindowStyleConstructionEnum;

  var IfcWindowStyleOperationEnum = function IfcWindowStyleOperationEnum() {
    _classCallCheck2(this, IfcWindowStyleOperationEnum);
  };

  IfcWindowStyleOperationEnum.SINGLE_PANEL = {
    type: 3,
    value: "SINGLE_PANEL"
  };
  IfcWindowStyleOperationEnum.DOUBLE_PANEL_VERTICAL = {
    type: 3,
    value: "DOUBLE_PANEL_VERTICAL"
  };
  IfcWindowStyleOperationEnum.DOUBLE_PANEL_HORIZONTAL = {
    type: 3,
    value: "DOUBLE_PANEL_HORIZONTAL"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_VERTICAL = {
    type: 3,
    value: "TRIPLE_PANEL_VERTICAL"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_BOTTOM = {
    type: 3,
    value: "TRIPLE_PANEL_BOTTOM"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_TOP = {
    type: 3,
    value: "TRIPLE_PANEL_TOP"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_LEFT = {
    type: 3,
    value: "TRIPLE_PANEL_LEFT"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_RIGHT = {
    type: 3,
    value: "TRIPLE_PANEL_RIGHT"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_HORIZONTAL = {
    type: 3,
    value: "TRIPLE_PANEL_HORIZONTAL"
  };
  IfcWindowStyleOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWindowStyleOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcWindowStyleOperationEnum = IfcWindowStyleOperationEnum;

  var IfcWorkControlTypeEnum = function IfcWorkControlTypeEnum() {
    _classCallCheck2(this, IfcWorkControlTypeEnum);
  };

  IfcWorkControlTypeEnum.ACTUAL = {
    type: 3,
    value: "ACTUAL"
  };
  IfcWorkControlTypeEnum.BASELINE = {
    type: 3,
    value: "BASELINE"
  };
  IfcWorkControlTypeEnum.PLANNED = {
    type: 3,
    value: "PLANNED"
  };
  IfcWorkControlTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWorkControlTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC2X32.IfcWorkControlTypeEnum = IfcWorkControlTypeEnum;

  var IfcActorRole = /*#__PURE__*/function (_IfcLineObject) {
    _inherits(IfcActorRole, _IfcLineObject);

    var _super92 = _createSuper(IfcActorRole);

    function IfcActorRole(expressID, Role, UserDefinedRole, Description) {
      var _this84;

      _classCallCheck2(this, IfcActorRole);

      _this84 = _super92.call(this, expressID);
      _this84.Role = Role;
      _this84.UserDefinedRole = UserDefinedRole;
      _this84.Description = Description;
      _this84.type = 3630933823;
      return _this84;
    }

    return IfcActorRole;
  }(IfcLineObject);

  IFC2X32.IfcActorRole = IfcActorRole;

  var IfcAddress = /*#__PURE__*/function (_IfcLineObject2) {
    _inherits(IfcAddress, _IfcLineObject2);

    var _super93 = _createSuper(IfcAddress);

    function IfcAddress(expressID, Purpose, Description, UserDefinedPurpose) {
      var _this85;

      _classCallCheck2(this, IfcAddress);

      _this85 = _super93.call(this, expressID);
      _this85.Purpose = Purpose;
      _this85.Description = Description;
      _this85.UserDefinedPurpose = UserDefinedPurpose;
      _this85.type = 618182010;
      return _this85;
    }

    return IfcAddress;
  }(IfcLineObject);

  IFC2X32.IfcAddress = IfcAddress;

  var IfcApplication = /*#__PURE__*/function (_IfcLineObject3) {
    _inherits(IfcApplication, _IfcLineObject3);

    var _super94 = _createSuper(IfcApplication);

    function IfcApplication(expressID, ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier) {
      var _this86;

      _classCallCheck2(this, IfcApplication);

      _this86 = _super94.call(this, expressID);
      _this86.ApplicationDeveloper = ApplicationDeveloper;
      _this86.Version = Version;
      _this86.ApplicationFullName = ApplicationFullName;
      _this86.ApplicationIdentifier = ApplicationIdentifier;
      _this86.type = 639542469;
      return _this86;
    }

    return IfcApplication;
  }(IfcLineObject);

  IFC2X32.IfcApplication = IfcApplication;

  var IfcAppliedValue = /*#__PURE__*/function (_IfcLineObject4) {
    _inherits(IfcAppliedValue, _IfcLineObject4);

    var _super95 = _createSuper(IfcAppliedValue);

    function IfcAppliedValue(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate) {
      var _this87;

      _classCallCheck2(this, IfcAppliedValue);

      _this87 = _super95.call(this, expressID);
      _this87.Name = Name;
      _this87.Description = Description;
      _this87.AppliedValue = AppliedValue;
      _this87.UnitBasis = UnitBasis;
      _this87.ApplicableDate = ApplicableDate;
      _this87.FixedUntilDate = FixedUntilDate;
      _this87.type = 411424972;
      return _this87;
    }

    return IfcAppliedValue;
  }(IfcLineObject);

  IFC2X32.IfcAppliedValue = IfcAppliedValue;

  var IfcAppliedValueRelationship = /*#__PURE__*/function (_IfcLineObject5) {
    _inherits(IfcAppliedValueRelationship, _IfcLineObject5);

    var _super96 = _createSuper(IfcAppliedValueRelationship);

    function IfcAppliedValueRelationship(expressID, ComponentOfTotal, Components, ArithmeticOperator, Name, Description) {
      var _this88;

      _classCallCheck2(this, IfcAppliedValueRelationship);

      _this88 = _super96.call(this, expressID);
      _this88.ComponentOfTotal = ComponentOfTotal;
      _this88.Components = Components;
      _this88.ArithmeticOperator = ArithmeticOperator;
      _this88.Name = Name;
      _this88.Description = Description;
      _this88.type = 1110488051;
      return _this88;
    }

    return IfcAppliedValueRelationship;
  }(IfcLineObject);

  IFC2X32.IfcAppliedValueRelationship = IfcAppliedValueRelationship;

  var IfcApproval = /*#__PURE__*/function (_IfcLineObject6) {
    _inherits(IfcApproval, _IfcLineObject6);

    var _super97 = _createSuper(IfcApproval);

    function IfcApproval(expressID, Description, ApprovalDateTime, ApprovalStatus, ApprovalLevel, ApprovalQualifier, Name, Identifier) {
      var _this89;

      _classCallCheck2(this, IfcApproval);

      _this89 = _super97.call(this, expressID);
      _this89.Description = Description;
      _this89.ApprovalDateTime = ApprovalDateTime;
      _this89.ApprovalStatus = ApprovalStatus;
      _this89.ApprovalLevel = ApprovalLevel;
      _this89.ApprovalQualifier = ApprovalQualifier;
      _this89.Name = Name;
      _this89.Identifier = Identifier;
      _this89.type = 130549933;
      return _this89;
    }

    return IfcApproval;
  }(IfcLineObject);

  IFC2X32.IfcApproval = IfcApproval;

  var IfcApprovalActorRelationship = /*#__PURE__*/function (_IfcLineObject7) {
    _inherits(IfcApprovalActorRelationship, _IfcLineObject7);

    var _super98 = _createSuper(IfcApprovalActorRelationship);

    function IfcApprovalActorRelationship(expressID, Actor, Approval, Role) {
      var _this90;

      _classCallCheck2(this, IfcApprovalActorRelationship);

      _this90 = _super98.call(this, expressID);
      _this90.Actor = Actor;
      _this90.Approval = Approval;
      _this90.Role = Role;
      _this90.type = 2080292479;
      return _this90;
    }

    return IfcApprovalActorRelationship;
  }(IfcLineObject);

  IFC2X32.IfcApprovalActorRelationship = IfcApprovalActorRelationship;

  var IfcApprovalPropertyRelationship = /*#__PURE__*/function (_IfcLineObject8) {
    _inherits(IfcApprovalPropertyRelationship, _IfcLineObject8);

    var _super99 = _createSuper(IfcApprovalPropertyRelationship);

    function IfcApprovalPropertyRelationship(expressID, ApprovedProperties, Approval) {
      var _this91;

      _classCallCheck2(this, IfcApprovalPropertyRelationship);

      _this91 = _super99.call(this, expressID);
      _this91.ApprovedProperties = ApprovedProperties;
      _this91.Approval = Approval;
      _this91.type = 390851274;
      return _this91;
    }

    return IfcApprovalPropertyRelationship;
  }(IfcLineObject);

  IFC2X32.IfcApprovalPropertyRelationship = IfcApprovalPropertyRelationship;

  var IfcApprovalRelationship = /*#__PURE__*/function (_IfcLineObject9) {
    _inherits(IfcApprovalRelationship, _IfcLineObject9);

    var _super100 = _createSuper(IfcApprovalRelationship);

    function IfcApprovalRelationship(expressID, RelatedApproval, RelatingApproval, Description, Name) {
      var _this92;

      _classCallCheck2(this, IfcApprovalRelationship);

      _this92 = _super100.call(this, expressID);
      _this92.RelatedApproval = RelatedApproval;
      _this92.RelatingApproval = RelatingApproval;
      _this92.Description = Description;
      _this92.Name = Name;
      _this92.type = 3869604511;
      return _this92;
    }

    return IfcApprovalRelationship;
  }(IfcLineObject);

  IFC2X32.IfcApprovalRelationship = IfcApprovalRelationship;

  var IfcBoundaryCondition = /*#__PURE__*/function (_IfcLineObject10) {
    _inherits(IfcBoundaryCondition, _IfcLineObject10);

    var _super101 = _createSuper(IfcBoundaryCondition);

    function IfcBoundaryCondition(expressID, Name) {
      var _this93;

      _classCallCheck2(this, IfcBoundaryCondition);

      _this93 = _super101.call(this, expressID);
      _this93.Name = Name;
      _this93.type = 4037036970;
      return _this93;
    }

    return IfcBoundaryCondition;
  }(IfcLineObject);

  IFC2X32.IfcBoundaryCondition = IfcBoundaryCondition;

  var IfcBoundaryEdgeCondition = /*#__PURE__*/function (_IfcBoundaryCondition) {
    _inherits(IfcBoundaryEdgeCondition, _IfcBoundaryCondition);

    var _super102 = _createSuper(IfcBoundaryEdgeCondition);

    function IfcBoundaryEdgeCondition(expressID, Name, LinearStiffnessByLengthX, LinearStiffnessByLengthY, LinearStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ) {
      var _this94;

      _classCallCheck2(this, IfcBoundaryEdgeCondition);

      _this94 = _super102.call(this, expressID, Name);
      _this94.Name = Name;
      _this94.LinearStiffnessByLengthX = LinearStiffnessByLengthX;
      _this94.LinearStiffnessByLengthY = LinearStiffnessByLengthY;
      _this94.LinearStiffnessByLengthZ = LinearStiffnessByLengthZ;
      _this94.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
      _this94.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
      _this94.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
      _this94.type = 1560379544;
      return _this94;
    }

    return IfcBoundaryEdgeCondition;
  }(IfcBoundaryCondition);

  IFC2X32.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;

  var IfcBoundaryFaceCondition = /*#__PURE__*/function (_IfcBoundaryCondition2) {
    _inherits(IfcBoundaryFaceCondition, _IfcBoundaryCondition2);

    var _super103 = _createSuper(IfcBoundaryFaceCondition);

    function IfcBoundaryFaceCondition(expressID, Name, LinearStiffnessByAreaX, LinearStiffnessByAreaY, LinearStiffnessByAreaZ) {
      var _this95;

      _classCallCheck2(this, IfcBoundaryFaceCondition);

      _this95 = _super103.call(this, expressID, Name);
      _this95.Name = Name;
      _this95.LinearStiffnessByAreaX = LinearStiffnessByAreaX;
      _this95.LinearStiffnessByAreaY = LinearStiffnessByAreaY;
      _this95.LinearStiffnessByAreaZ = LinearStiffnessByAreaZ;
      _this95.type = 3367102660;
      return _this95;
    }

    return IfcBoundaryFaceCondition;
  }(IfcBoundaryCondition);

  IFC2X32.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;

  var IfcBoundaryNodeCondition = /*#__PURE__*/function (_IfcBoundaryCondition3) {
    _inherits(IfcBoundaryNodeCondition, _IfcBoundaryCondition3);

    var _super104 = _createSuper(IfcBoundaryNodeCondition);

    function IfcBoundaryNodeCondition(expressID, Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ) {
      var _this96;

      _classCallCheck2(this, IfcBoundaryNodeCondition);

      _this96 = _super104.call(this, expressID, Name);
      _this96.Name = Name;
      _this96.LinearStiffnessX = LinearStiffnessX;
      _this96.LinearStiffnessY = LinearStiffnessY;
      _this96.LinearStiffnessZ = LinearStiffnessZ;
      _this96.RotationalStiffnessX = RotationalStiffnessX;
      _this96.RotationalStiffnessY = RotationalStiffnessY;
      _this96.RotationalStiffnessZ = RotationalStiffnessZ;
      _this96.type = 1387855156;
      return _this96;
    }

    return IfcBoundaryNodeCondition;
  }(IfcBoundaryCondition);

  IFC2X32.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;

  var IfcBoundaryNodeConditionWarping = /*#__PURE__*/function (_IfcBoundaryNodeCondi) {
    _inherits(IfcBoundaryNodeConditionWarping, _IfcBoundaryNodeCondi);

    var _super105 = _createSuper(IfcBoundaryNodeConditionWarping);

    function IfcBoundaryNodeConditionWarping(expressID, Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness) {
      var _this97;

      _classCallCheck2(this, IfcBoundaryNodeConditionWarping);

      _this97 = _super105.call(this, expressID, Name, LinearStiffnessX, LinearStiffnessY, LinearStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
      _this97.Name = Name;
      _this97.LinearStiffnessX = LinearStiffnessX;
      _this97.LinearStiffnessY = LinearStiffnessY;
      _this97.LinearStiffnessZ = LinearStiffnessZ;
      _this97.RotationalStiffnessX = RotationalStiffnessX;
      _this97.RotationalStiffnessY = RotationalStiffnessY;
      _this97.RotationalStiffnessZ = RotationalStiffnessZ;
      _this97.WarpingStiffness = WarpingStiffness;
      _this97.type = 2069777674;
      return _this97;
    }

    return IfcBoundaryNodeConditionWarping;
  }(IfcBoundaryNodeCondition);

  IFC2X32.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;

  var IfcCalendarDate = /*#__PURE__*/function (_IfcLineObject11) {
    _inherits(IfcCalendarDate, _IfcLineObject11);

    var _super106 = _createSuper(IfcCalendarDate);

    function IfcCalendarDate(expressID, DayComponent, MonthComponent, YearComponent) {
      var _this98;

      _classCallCheck2(this, IfcCalendarDate);

      _this98 = _super106.call(this, expressID);
      _this98.DayComponent = DayComponent;
      _this98.MonthComponent = MonthComponent;
      _this98.YearComponent = YearComponent;
      _this98.type = 622194075;
      return _this98;
    }

    return IfcCalendarDate;
  }(IfcLineObject);

  IFC2X32.IfcCalendarDate = IfcCalendarDate;

  var IfcClassification = /*#__PURE__*/function (_IfcLineObject12) {
    _inherits(IfcClassification, _IfcLineObject12);

    var _super107 = _createSuper(IfcClassification);

    function IfcClassification(expressID, Source, Edition, EditionDate, Name) {
      var _this99;

      _classCallCheck2(this, IfcClassification);

      _this99 = _super107.call(this, expressID);
      _this99.Source = Source;
      _this99.Edition = Edition;
      _this99.EditionDate = EditionDate;
      _this99.Name = Name;
      _this99.type = 747523909;
      return _this99;
    }

    return IfcClassification;
  }(IfcLineObject);

  IFC2X32.IfcClassification = IfcClassification;

  var IfcClassificationItem = /*#__PURE__*/function (_IfcLineObject13) {
    _inherits(IfcClassificationItem, _IfcLineObject13);

    var _super108 = _createSuper(IfcClassificationItem);

    function IfcClassificationItem(expressID, Notation, ItemOf, Title) {
      var _this100;

      _classCallCheck2(this, IfcClassificationItem);

      _this100 = _super108.call(this, expressID);
      _this100.Notation = Notation;
      _this100.ItemOf = ItemOf;
      _this100.Title = Title;
      _this100.type = 1767535486;
      return _this100;
    }

    return IfcClassificationItem;
  }(IfcLineObject);

  IFC2X32.IfcClassificationItem = IfcClassificationItem;

  var IfcClassificationItemRelationship = /*#__PURE__*/function (_IfcLineObject14) {
    _inherits(IfcClassificationItemRelationship, _IfcLineObject14);

    var _super109 = _createSuper(IfcClassificationItemRelationship);

    function IfcClassificationItemRelationship(expressID, RelatingItem, RelatedItems) {
      var _this101;

      _classCallCheck2(this, IfcClassificationItemRelationship);

      _this101 = _super109.call(this, expressID);
      _this101.RelatingItem = RelatingItem;
      _this101.RelatedItems = RelatedItems;
      _this101.type = 1098599126;
      return _this101;
    }

    return IfcClassificationItemRelationship;
  }(IfcLineObject);

  IFC2X32.IfcClassificationItemRelationship = IfcClassificationItemRelationship;

  var IfcClassificationNotation = /*#__PURE__*/function (_IfcLineObject15) {
    _inherits(IfcClassificationNotation, _IfcLineObject15);

    var _super110 = _createSuper(IfcClassificationNotation);

    function IfcClassificationNotation(expressID, NotationFacets) {
      var _this102;

      _classCallCheck2(this, IfcClassificationNotation);

      _this102 = _super110.call(this, expressID);
      _this102.NotationFacets = NotationFacets;
      _this102.type = 938368621;
      return _this102;
    }

    return IfcClassificationNotation;
  }(IfcLineObject);

  IFC2X32.IfcClassificationNotation = IfcClassificationNotation;

  var IfcClassificationNotationFacet = /*#__PURE__*/function (_IfcLineObject16) {
    _inherits(IfcClassificationNotationFacet, _IfcLineObject16);

    var _super111 = _createSuper(IfcClassificationNotationFacet);

    function IfcClassificationNotationFacet(expressID, NotationValue) {
      var _this103;

      _classCallCheck2(this, IfcClassificationNotationFacet);

      _this103 = _super111.call(this, expressID);
      _this103.NotationValue = NotationValue;
      _this103.type = 3639012971;
      return _this103;
    }

    return IfcClassificationNotationFacet;
  }(IfcLineObject);

  IFC2X32.IfcClassificationNotationFacet = IfcClassificationNotationFacet;

  var IfcColourSpecification = /*#__PURE__*/function (_IfcLineObject17) {
    _inherits(IfcColourSpecification, _IfcLineObject17);

    var _super112 = _createSuper(IfcColourSpecification);

    function IfcColourSpecification(expressID, Name) {
      var _this104;

      _classCallCheck2(this, IfcColourSpecification);

      _this104 = _super112.call(this, expressID);
      _this104.Name = Name;
      _this104.type = 3264961684;
      return _this104;
    }

    return IfcColourSpecification;
  }(IfcLineObject);

  IFC2X32.IfcColourSpecification = IfcColourSpecification;

  var IfcConnectionGeometry = /*#__PURE__*/function (_IfcLineObject18) {
    _inherits(IfcConnectionGeometry, _IfcLineObject18);

    var _super113 = _createSuper(IfcConnectionGeometry);

    function IfcConnectionGeometry(expressID) {
      var _this105;

      _classCallCheck2(this, IfcConnectionGeometry);

      _this105 = _super113.call(this, expressID);
      _this105.type = 2859738748;
      return _this105;
    }

    return IfcConnectionGeometry;
  }(IfcLineObject);

  IFC2X32.IfcConnectionGeometry = IfcConnectionGeometry;

  var IfcConnectionPointGeometry = /*#__PURE__*/function (_IfcConnectionGeometr) {
    _inherits(IfcConnectionPointGeometry, _IfcConnectionGeometr);

    var _super114 = _createSuper(IfcConnectionPointGeometry);

    function IfcConnectionPointGeometry(expressID, PointOnRelatingElement, PointOnRelatedElement) {
      var _this106;

      _classCallCheck2(this, IfcConnectionPointGeometry);

      _this106 = _super114.call(this, expressID);
      _this106.PointOnRelatingElement = PointOnRelatingElement;
      _this106.PointOnRelatedElement = PointOnRelatedElement;
      _this106.type = 2614616156;
      return _this106;
    }

    return IfcConnectionPointGeometry;
  }(IfcConnectionGeometry);

  IFC2X32.IfcConnectionPointGeometry = IfcConnectionPointGeometry;

  var IfcConnectionPortGeometry = /*#__PURE__*/function (_IfcConnectionGeometr2) {
    _inherits(IfcConnectionPortGeometry, _IfcConnectionGeometr2);

    var _super115 = _createSuper(IfcConnectionPortGeometry);

    function IfcConnectionPortGeometry(expressID, LocationAtRelatingElement, LocationAtRelatedElement, ProfileOfPort) {
      var _this107;

      _classCallCheck2(this, IfcConnectionPortGeometry);

      _this107 = _super115.call(this, expressID);
      _this107.LocationAtRelatingElement = LocationAtRelatingElement;
      _this107.LocationAtRelatedElement = LocationAtRelatedElement;
      _this107.ProfileOfPort = ProfileOfPort;
      _this107.type = 4257277454;
      return _this107;
    }

    return IfcConnectionPortGeometry;
  }(IfcConnectionGeometry);

  IFC2X32.IfcConnectionPortGeometry = IfcConnectionPortGeometry;

  var IfcConnectionSurfaceGeometry = /*#__PURE__*/function (_IfcConnectionGeometr3) {
    _inherits(IfcConnectionSurfaceGeometry, _IfcConnectionGeometr3);

    var _super116 = _createSuper(IfcConnectionSurfaceGeometry);

    function IfcConnectionSurfaceGeometry(expressID, SurfaceOnRelatingElement, SurfaceOnRelatedElement) {
      var _this108;

      _classCallCheck2(this, IfcConnectionSurfaceGeometry);

      _this108 = _super116.call(this, expressID);
      _this108.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
      _this108.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
      _this108.type = 2732653382;
      return _this108;
    }

    return IfcConnectionSurfaceGeometry;
  }(IfcConnectionGeometry);

  IFC2X32.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;

  var IfcConstraint = /*#__PURE__*/function (_IfcLineObject19) {
    _inherits(IfcConstraint, _IfcLineObject19);

    var _super117 = _createSuper(IfcConstraint);

    function IfcConstraint(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade) {
      var _this109;

      _classCallCheck2(this, IfcConstraint);

      _this109 = _super117.call(this, expressID);
      _this109.Name = Name;
      _this109.Description = Description;
      _this109.ConstraintGrade = ConstraintGrade;
      _this109.ConstraintSource = ConstraintSource;
      _this109.CreatingActor = CreatingActor;
      _this109.CreationTime = CreationTime;
      _this109.UserDefinedGrade = UserDefinedGrade;
      _this109.type = 1959218052;
      return _this109;
    }

    return IfcConstraint;
  }(IfcLineObject);

  IFC2X32.IfcConstraint = IfcConstraint;

  var IfcConstraintAggregationRelationship = /*#__PURE__*/function (_IfcLineObject20) {
    _inherits(IfcConstraintAggregationRelationship, _IfcLineObject20);

    var _super118 = _createSuper(IfcConstraintAggregationRelationship);

    function IfcConstraintAggregationRelationship(expressID, Name, Description, RelatingConstraint, RelatedConstraints, LogicalAggregator) {
      var _this110;

      _classCallCheck2(this, IfcConstraintAggregationRelationship);

      _this110 = _super118.call(this, expressID);
      _this110.Name = Name;
      _this110.Description = Description;
      _this110.RelatingConstraint = RelatingConstraint;
      _this110.RelatedConstraints = RelatedConstraints;
      _this110.LogicalAggregator = LogicalAggregator;
      _this110.type = 1658513725;
      return _this110;
    }

    return IfcConstraintAggregationRelationship;
  }(IfcLineObject);

  IFC2X32.IfcConstraintAggregationRelationship = IfcConstraintAggregationRelationship;

  var IfcConstraintClassificationRelationship = /*#__PURE__*/function (_IfcLineObject21) {
    _inherits(IfcConstraintClassificationRelationship, _IfcLineObject21);

    var _super119 = _createSuper(IfcConstraintClassificationRelationship);

    function IfcConstraintClassificationRelationship(expressID, ClassifiedConstraint, RelatedClassifications) {
      var _this111;

      _classCallCheck2(this, IfcConstraintClassificationRelationship);

      _this111 = _super119.call(this, expressID);
      _this111.ClassifiedConstraint = ClassifiedConstraint;
      _this111.RelatedClassifications = RelatedClassifications;
      _this111.type = 613356794;
      return _this111;
    }

    return IfcConstraintClassificationRelationship;
  }(IfcLineObject);

  IFC2X32.IfcConstraintClassificationRelationship = IfcConstraintClassificationRelationship;

  var IfcConstraintRelationship = /*#__PURE__*/function (_IfcLineObject22) {
    _inherits(IfcConstraintRelationship, _IfcLineObject22);

    var _super120 = _createSuper(IfcConstraintRelationship);

    function IfcConstraintRelationship(expressID, Name, Description, RelatingConstraint, RelatedConstraints) {
      var _this112;

      _classCallCheck2(this, IfcConstraintRelationship);

      _this112 = _super120.call(this, expressID);
      _this112.Name = Name;
      _this112.Description = Description;
      _this112.RelatingConstraint = RelatingConstraint;
      _this112.RelatedConstraints = RelatedConstraints;
      _this112.type = 347226245;
      return _this112;
    }

    return IfcConstraintRelationship;
  }(IfcLineObject);

  IFC2X32.IfcConstraintRelationship = IfcConstraintRelationship;

  var IfcCoordinatedUniversalTimeOffset = /*#__PURE__*/function (_IfcLineObject23) {
    _inherits(IfcCoordinatedUniversalTimeOffset, _IfcLineObject23);

    var _super121 = _createSuper(IfcCoordinatedUniversalTimeOffset);

    function IfcCoordinatedUniversalTimeOffset(expressID, HourOffset, MinuteOffset, Sense) {
      var _this113;

      _classCallCheck2(this, IfcCoordinatedUniversalTimeOffset);

      _this113 = _super121.call(this, expressID);
      _this113.HourOffset = HourOffset;
      _this113.MinuteOffset = MinuteOffset;
      _this113.Sense = Sense;
      _this113.type = 1065062679;
      return _this113;
    }

    return IfcCoordinatedUniversalTimeOffset;
  }(IfcLineObject);

  IFC2X32.IfcCoordinatedUniversalTimeOffset = IfcCoordinatedUniversalTimeOffset;

  var IfcCostValue = /*#__PURE__*/function (_IfcAppliedValue) {
    _inherits(IfcCostValue, _IfcAppliedValue);

    var _super122 = _createSuper(IfcCostValue);

    function IfcCostValue(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, CostType, Condition) {
      var _this114;

      _classCallCheck2(this, IfcCostValue);

      _this114 = _super122.call(this, expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate);
      _this114.Name = Name;
      _this114.Description = Description;
      _this114.AppliedValue = AppliedValue;
      _this114.UnitBasis = UnitBasis;
      _this114.ApplicableDate = ApplicableDate;
      _this114.FixedUntilDate = FixedUntilDate;
      _this114.CostType = CostType;
      _this114.Condition = Condition;
      _this114.type = 602808272;
      return _this114;
    }

    return IfcCostValue;
  }(IfcAppliedValue);

  IFC2X32.IfcCostValue = IfcCostValue;

  var IfcCurrencyRelationship = /*#__PURE__*/function (_IfcLineObject24) {
    _inherits(IfcCurrencyRelationship, _IfcLineObject24);

    var _super123 = _createSuper(IfcCurrencyRelationship);

    function IfcCurrencyRelationship(expressID, RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource) {
      var _this115;

      _classCallCheck2(this, IfcCurrencyRelationship);

      _this115 = _super123.call(this, expressID);
      _this115.RelatingMonetaryUnit = RelatingMonetaryUnit;
      _this115.RelatedMonetaryUnit = RelatedMonetaryUnit;
      _this115.ExchangeRate = ExchangeRate;
      _this115.RateDateTime = RateDateTime;
      _this115.RateSource = RateSource;
      _this115.type = 539742890;
      return _this115;
    }

    return IfcCurrencyRelationship;
  }(IfcLineObject);

  IFC2X32.IfcCurrencyRelationship = IfcCurrencyRelationship;

  var IfcCurveStyleFont = /*#__PURE__*/function (_IfcLineObject25) {
    _inherits(IfcCurveStyleFont, _IfcLineObject25);

    var _super124 = _createSuper(IfcCurveStyleFont);

    function IfcCurveStyleFont(expressID, Name, PatternList) {
      var _this116;

      _classCallCheck2(this, IfcCurveStyleFont);

      _this116 = _super124.call(this, expressID);
      _this116.Name = Name;
      _this116.PatternList = PatternList;
      _this116.type = 1105321065;
      return _this116;
    }

    return IfcCurveStyleFont;
  }(IfcLineObject);

  IFC2X32.IfcCurveStyleFont = IfcCurveStyleFont;

  var IfcCurveStyleFontAndScaling = /*#__PURE__*/function (_IfcLineObject26) {
    _inherits(IfcCurveStyleFontAndScaling, _IfcLineObject26);

    var _super125 = _createSuper(IfcCurveStyleFontAndScaling);

    function IfcCurveStyleFontAndScaling(expressID, Name, CurveFont, CurveFontScaling) {
      var _this117;

      _classCallCheck2(this, IfcCurveStyleFontAndScaling);

      _this117 = _super125.call(this, expressID);
      _this117.Name = Name;
      _this117.CurveFont = CurveFont;
      _this117.CurveFontScaling = CurveFontScaling;
      _this117.type = 2367409068;
      return _this117;
    }

    return IfcCurveStyleFontAndScaling;
  }(IfcLineObject);

  IFC2X32.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;

  var IfcCurveStyleFontPattern = /*#__PURE__*/function (_IfcLineObject27) {
    _inherits(IfcCurveStyleFontPattern, _IfcLineObject27);

    var _super126 = _createSuper(IfcCurveStyleFontPattern);

    function IfcCurveStyleFontPattern(expressID, VisibleSegmentLength, InvisibleSegmentLength) {
      var _this118;

      _classCallCheck2(this, IfcCurveStyleFontPattern);

      _this118 = _super126.call(this, expressID);
      _this118.VisibleSegmentLength = VisibleSegmentLength;
      _this118.InvisibleSegmentLength = InvisibleSegmentLength;
      _this118.type = 3510044353;
      return _this118;
    }

    return IfcCurveStyleFontPattern;
  }(IfcLineObject);

  IFC2X32.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;

  var IfcDateAndTime = /*#__PURE__*/function (_IfcLineObject28) {
    _inherits(IfcDateAndTime, _IfcLineObject28);

    var _super127 = _createSuper(IfcDateAndTime);

    function IfcDateAndTime(expressID, DateComponent, TimeComponent) {
      var _this119;

      _classCallCheck2(this, IfcDateAndTime);

      _this119 = _super127.call(this, expressID);
      _this119.DateComponent = DateComponent;
      _this119.TimeComponent = TimeComponent;
      _this119.type = 1072939445;
      return _this119;
    }

    return IfcDateAndTime;
  }(IfcLineObject);

  IFC2X32.IfcDateAndTime = IfcDateAndTime;

  var IfcDerivedUnit = /*#__PURE__*/function (_IfcLineObject29) {
    _inherits(IfcDerivedUnit, _IfcLineObject29);

    var _super128 = _createSuper(IfcDerivedUnit);

    function IfcDerivedUnit(expressID, Elements, UnitType, UserDefinedType) {
      var _this120;

      _classCallCheck2(this, IfcDerivedUnit);

      _this120 = _super128.call(this, expressID);
      _this120.Elements = Elements;
      _this120.UnitType = UnitType;
      _this120.UserDefinedType = UserDefinedType;
      _this120.type = 1765591967;
      return _this120;
    }

    return IfcDerivedUnit;
  }(IfcLineObject);

  IFC2X32.IfcDerivedUnit = IfcDerivedUnit;

  var IfcDerivedUnitElement = /*#__PURE__*/function (_IfcLineObject30) {
    _inherits(IfcDerivedUnitElement, _IfcLineObject30);

    var _super129 = _createSuper(IfcDerivedUnitElement);

    function IfcDerivedUnitElement(expressID, Unit, Exponent) {
      var _this121;

      _classCallCheck2(this, IfcDerivedUnitElement);

      _this121 = _super129.call(this, expressID);
      _this121.Unit = Unit;
      _this121.Exponent = Exponent;
      _this121.type = 1045800335;
      return _this121;
    }

    return IfcDerivedUnitElement;
  }(IfcLineObject);

  IFC2X32.IfcDerivedUnitElement = IfcDerivedUnitElement;

  var IfcDimensionalExponents = /*#__PURE__*/function (_IfcLineObject31) {
    _inherits(IfcDimensionalExponents, _IfcLineObject31);

    var _super130 = _createSuper(IfcDimensionalExponents);

    function IfcDimensionalExponents(expressID, LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent) {
      var _this122;

      _classCallCheck2(this, IfcDimensionalExponents);

      _this122 = _super130.call(this, expressID);
      _this122.LengthExponent = LengthExponent;
      _this122.MassExponent = MassExponent;
      _this122.TimeExponent = TimeExponent;
      _this122.ElectricCurrentExponent = ElectricCurrentExponent;
      _this122.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
      _this122.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
      _this122.LuminousIntensityExponent = LuminousIntensityExponent;
      _this122.type = 2949456006;
      return _this122;
    }

    return IfcDimensionalExponents;
  }(IfcLineObject);

  IFC2X32.IfcDimensionalExponents = IfcDimensionalExponents;

  var IfcDocumentElectronicFormat = /*#__PURE__*/function (_IfcLineObject32) {
    _inherits(IfcDocumentElectronicFormat, _IfcLineObject32);

    var _super131 = _createSuper(IfcDocumentElectronicFormat);

    function IfcDocumentElectronicFormat(expressID, FileExtension, MimeContentType, MimeSubtype) {
      var _this123;

      _classCallCheck2(this, IfcDocumentElectronicFormat);

      _this123 = _super131.call(this, expressID);
      _this123.FileExtension = FileExtension;
      _this123.MimeContentType = MimeContentType;
      _this123.MimeSubtype = MimeSubtype;
      _this123.type = 1376555844;
      return _this123;
    }

    return IfcDocumentElectronicFormat;
  }(IfcLineObject);

  IFC2X32.IfcDocumentElectronicFormat = IfcDocumentElectronicFormat;

  var IfcDocumentInformation = /*#__PURE__*/function (_IfcLineObject33) {
    _inherits(IfcDocumentInformation, _IfcLineObject33);

    var _super132 = _createSuper(IfcDocumentInformation);

    function IfcDocumentInformation(expressID, DocumentId, Name, Description, DocumentReferences, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status) {
      var _this124;

      _classCallCheck2(this, IfcDocumentInformation);

      _this124 = _super132.call(this, expressID);
      _this124.DocumentId = DocumentId;
      _this124.Name = Name;
      _this124.Description = Description;
      _this124.DocumentReferences = DocumentReferences;
      _this124.Purpose = Purpose;
      _this124.IntendedUse = IntendedUse;
      _this124.Scope = Scope;
      _this124.Revision = Revision;
      _this124.DocumentOwner = DocumentOwner;
      _this124.Editors = Editors;
      _this124.CreationTime = CreationTime;
      _this124.LastRevisionTime = LastRevisionTime;
      _this124.ElectronicFormat = ElectronicFormat;
      _this124.ValidFrom = ValidFrom;
      _this124.ValidUntil = ValidUntil;
      _this124.Confidentiality = Confidentiality;
      _this124.Status = Status;
      _this124.type = 1154170062;
      return _this124;
    }

    return IfcDocumentInformation;
  }(IfcLineObject);

  IFC2X32.IfcDocumentInformation = IfcDocumentInformation;

  var IfcDocumentInformationRelationship = /*#__PURE__*/function (_IfcLineObject34) {
    _inherits(IfcDocumentInformationRelationship, _IfcLineObject34);

    var _super133 = _createSuper(IfcDocumentInformationRelationship);

    function IfcDocumentInformationRelationship(expressID, RelatingDocument, RelatedDocuments, RelationshipType) {
      var _this125;

      _classCallCheck2(this, IfcDocumentInformationRelationship);

      _this125 = _super133.call(this, expressID);
      _this125.RelatingDocument = RelatingDocument;
      _this125.RelatedDocuments = RelatedDocuments;
      _this125.RelationshipType = RelationshipType;
      _this125.type = 770865208;
      return _this125;
    }

    return IfcDocumentInformationRelationship;
  }(IfcLineObject);

  IFC2X32.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;

  var IfcDraughtingCalloutRelationship = /*#__PURE__*/function (_IfcLineObject35) {
    _inherits(IfcDraughtingCalloutRelationship, _IfcLineObject35);

    var _super134 = _createSuper(IfcDraughtingCalloutRelationship);

    function IfcDraughtingCalloutRelationship(expressID, Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout) {
      var _this126;

      _classCallCheck2(this, IfcDraughtingCalloutRelationship);

      _this126 = _super134.call(this, expressID);
      _this126.Name = Name;
      _this126.Description = Description;
      _this126.RelatingDraughtingCallout = RelatingDraughtingCallout;
      _this126.RelatedDraughtingCallout = RelatedDraughtingCallout;
      _this126.type = 3796139169;
      return _this126;
    }

    return IfcDraughtingCalloutRelationship;
  }(IfcLineObject);

  IFC2X32.IfcDraughtingCalloutRelationship = IfcDraughtingCalloutRelationship;

  var IfcEnvironmentalImpactValue = /*#__PURE__*/function (_IfcAppliedValue2) {
    _inherits(IfcEnvironmentalImpactValue, _IfcAppliedValue2);

    var _super135 = _createSuper(IfcEnvironmentalImpactValue);

    function IfcEnvironmentalImpactValue(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, ImpactType, Category, UserDefinedCategory) {
      var _this127;

      _classCallCheck2(this, IfcEnvironmentalImpactValue);

      _this127 = _super135.call(this, expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate);
      _this127.Name = Name;
      _this127.Description = Description;
      _this127.AppliedValue = AppliedValue;
      _this127.UnitBasis = UnitBasis;
      _this127.ApplicableDate = ApplicableDate;
      _this127.FixedUntilDate = FixedUntilDate;
      _this127.ImpactType = ImpactType;
      _this127.Category = Category;
      _this127.UserDefinedCategory = UserDefinedCategory;
      _this127.type = 1648886627;
      return _this127;
    }

    return IfcEnvironmentalImpactValue;
  }(IfcAppliedValue);

  IFC2X32.IfcEnvironmentalImpactValue = IfcEnvironmentalImpactValue;

  var IfcExternalReference = /*#__PURE__*/function (_IfcLineObject36) {
    _inherits(IfcExternalReference, _IfcLineObject36);

    var _super136 = _createSuper(IfcExternalReference);

    function IfcExternalReference(expressID, Location, ItemReference, Name) {
      var _this128;

      _classCallCheck2(this, IfcExternalReference);

      _this128 = _super136.call(this, expressID);
      _this128.Location = Location;
      _this128.ItemReference = ItemReference;
      _this128.Name = Name;
      _this128.type = 3200245327;
      return _this128;
    }

    return IfcExternalReference;
  }(IfcLineObject);

  IFC2X32.IfcExternalReference = IfcExternalReference;

  var IfcExternallyDefinedHatchStyle = /*#__PURE__*/function (_IfcExternalReference) {
    _inherits(IfcExternallyDefinedHatchStyle, _IfcExternalReference);

    var _super137 = _createSuper(IfcExternallyDefinedHatchStyle);

    function IfcExternallyDefinedHatchStyle(expressID, Location, ItemReference, Name) {
      var _this129;

      _classCallCheck2(this, IfcExternallyDefinedHatchStyle);

      _this129 = _super137.call(this, expressID, Location, ItemReference, Name);
      _this129.Location = Location;
      _this129.ItemReference = ItemReference;
      _this129.Name = Name;
      _this129.type = 2242383968;
      return _this129;
    }

    return IfcExternallyDefinedHatchStyle;
  }(IfcExternalReference);

  IFC2X32.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;

  var IfcExternallyDefinedSurfaceStyle = /*#__PURE__*/function (_IfcExternalReference2) {
    _inherits(IfcExternallyDefinedSurfaceStyle, _IfcExternalReference2);

    var _super138 = _createSuper(IfcExternallyDefinedSurfaceStyle);

    function IfcExternallyDefinedSurfaceStyle(expressID, Location, ItemReference, Name) {
      var _this130;

      _classCallCheck2(this, IfcExternallyDefinedSurfaceStyle);

      _this130 = _super138.call(this, expressID, Location, ItemReference, Name);
      _this130.Location = Location;
      _this130.ItemReference = ItemReference;
      _this130.Name = Name;
      _this130.type = 1040185647;
      return _this130;
    }

    return IfcExternallyDefinedSurfaceStyle;
  }(IfcExternalReference);

  IFC2X32.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;

  var IfcExternallyDefinedSymbol = /*#__PURE__*/function (_IfcExternalReference3) {
    _inherits(IfcExternallyDefinedSymbol, _IfcExternalReference3);

    var _super139 = _createSuper(IfcExternallyDefinedSymbol);

    function IfcExternallyDefinedSymbol(expressID, Location, ItemReference, Name) {
      var _this131;

      _classCallCheck2(this, IfcExternallyDefinedSymbol);

      _this131 = _super139.call(this, expressID, Location, ItemReference, Name);
      _this131.Location = Location;
      _this131.ItemReference = ItemReference;
      _this131.Name = Name;
      _this131.type = 3207319532;
      return _this131;
    }

    return IfcExternallyDefinedSymbol;
  }(IfcExternalReference);

  IFC2X32.IfcExternallyDefinedSymbol = IfcExternallyDefinedSymbol;

  var IfcExternallyDefinedTextFont = /*#__PURE__*/function (_IfcExternalReference4) {
    _inherits(IfcExternallyDefinedTextFont, _IfcExternalReference4);

    var _super140 = _createSuper(IfcExternallyDefinedTextFont);

    function IfcExternallyDefinedTextFont(expressID, Location, ItemReference, Name) {
      var _this132;

      _classCallCheck2(this, IfcExternallyDefinedTextFont);

      _this132 = _super140.call(this, expressID, Location, ItemReference, Name);
      _this132.Location = Location;
      _this132.ItemReference = ItemReference;
      _this132.Name = Name;
      _this132.type = 3548104201;
      return _this132;
    }

    return IfcExternallyDefinedTextFont;
  }(IfcExternalReference);

  IFC2X32.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;

  var IfcGridAxis = /*#__PURE__*/function (_IfcLineObject37) {
    _inherits(IfcGridAxis, _IfcLineObject37);

    var _super141 = _createSuper(IfcGridAxis);

    function IfcGridAxis(expressID, AxisTag, AxisCurve, SameSense) {
      var _this133;

      _classCallCheck2(this, IfcGridAxis);

      _this133 = _super141.call(this, expressID);
      _this133.AxisTag = AxisTag;
      _this133.AxisCurve = AxisCurve;
      _this133.SameSense = SameSense;
      _this133.type = 852622518;
      return _this133;
    }

    return IfcGridAxis;
  }(IfcLineObject);

  IFC2X32.IfcGridAxis = IfcGridAxis;

  var IfcIrregularTimeSeriesValue = /*#__PURE__*/function (_IfcLineObject38) {
    _inherits(IfcIrregularTimeSeriesValue, _IfcLineObject38);

    var _super142 = _createSuper(IfcIrregularTimeSeriesValue);

    function IfcIrregularTimeSeriesValue(expressID, TimeStamp, ListValues) {
      var _this134;

      _classCallCheck2(this, IfcIrregularTimeSeriesValue);

      _this134 = _super142.call(this, expressID);
      _this134.TimeStamp = TimeStamp;
      _this134.ListValues = ListValues;
      _this134.type = 3020489413;
      return _this134;
    }

    return IfcIrregularTimeSeriesValue;
  }(IfcLineObject);

  IFC2X32.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;

  var IfcLibraryInformation = /*#__PURE__*/function (_IfcLineObject39) {
    _inherits(IfcLibraryInformation, _IfcLineObject39);

    var _super143 = _createSuper(IfcLibraryInformation);

    function IfcLibraryInformation(expressID, Name, Version, Publisher, VersionDate, LibraryReference) {
      var _this135;

      _classCallCheck2(this, IfcLibraryInformation);

      _this135 = _super143.call(this, expressID);
      _this135.Name = Name;
      _this135.Version = Version;
      _this135.Publisher = Publisher;
      _this135.VersionDate = VersionDate;
      _this135.LibraryReference = LibraryReference;
      _this135.type = 2655187982;
      return _this135;
    }

    return IfcLibraryInformation;
  }(IfcLineObject);

  IFC2X32.IfcLibraryInformation = IfcLibraryInformation;

  var IfcLibraryReference = /*#__PURE__*/function (_IfcExternalReference5) {
    _inherits(IfcLibraryReference, _IfcExternalReference5);

    var _super144 = _createSuper(IfcLibraryReference);

    function IfcLibraryReference(expressID, Location, ItemReference, Name) {
      var _this136;

      _classCallCheck2(this, IfcLibraryReference);

      _this136 = _super144.call(this, expressID, Location, ItemReference, Name);
      _this136.Location = Location;
      _this136.ItemReference = ItemReference;
      _this136.Name = Name;
      _this136.type = 3452421091;
      return _this136;
    }

    return IfcLibraryReference;
  }(IfcExternalReference);

  IFC2X32.IfcLibraryReference = IfcLibraryReference;

  var IfcLightDistributionData = /*#__PURE__*/function (_IfcLineObject40) {
    _inherits(IfcLightDistributionData, _IfcLineObject40);

    var _super145 = _createSuper(IfcLightDistributionData);

    function IfcLightDistributionData(expressID, MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity) {
      var _this137;

      _classCallCheck2(this, IfcLightDistributionData);

      _this137 = _super145.call(this, expressID);
      _this137.MainPlaneAngle = MainPlaneAngle;
      _this137.SecondaryPlaneAngle = SecondaryPlaneAngle;
      _this137.LuminousIntensity = LuminousIntensity;
      _this137.type = 4162380809;
      return _this137;
    }

    return IfcLightDistributionData;
  }(IfcLineObject);

  IFC2X32.IfcLightDistributionData = IfcLightDistributionData;

  var IfcLightIntensityDistribution = /*#__PURE__*/function (_IfcLineObject41) {
    _inherits(IfcLightIntensityDistribution, _IfcLineObject41);

    var _super146 = _createSuper(IfcLightIntensityDistribution);

    function IfcLightIntensityDistribution(expressID, LightDistributionCurve, DistributionData) {
      var _this138;

      _classCallCheck2(this, IfcLightIntensityDistribution);

      _this138 = _super146.call(this, expressID);
      _this138.LightDistributionCurve = LightDistributionCurve;
      _this138.DistributionData = DistributionData;
      _this138.type = 1566485204;
      return _this138;
    }

    return IfcLightIntensityDistribution;
  }(IfcLineObject);

  IFC2X32.IfcLightIntensityDistribution = IfcLightIntensityDistribution;

  var IfcLocalTime = /*#__PURE__*/function (_IfcLineObject42) {
    _inherits(IfcLocalTime, _IfcLineObject42);

    var _super147 = _createSuper(IfcLocalTime);

    function IfcLocalTime(expressID, HourComponent, MinuteComponent, SecondComponent, Zone, DaylightSavingOffset) {
      var _this139;

      _classCallCheck2(this, IfcLocalTime);

      _this139 = _super147.call(this, expressID);
      _this139.HourComponent = HourComponent;
      _this139.MinuteComponent = MinuteComponent;
      _this139.SecondComponent = SecondComponent;
      _this139.Zone = Zone;
      _this139.DaylightSavingOffset = DaylightSavingOffset;
      _this139.type = 30780891;
      return _this139;
    }

    return IfcLocalTime;
  }(IfcLineObject);

  IFC2X32.IfcLocalTime = IfcLocalTime;

  var IfcMaterial = /*#__PURE__*/function (_IfcLineObject43) {
    _inherits(IfcMaterial, _IfcLineObject43);

    var _super148 = _createSuper(IfcMaterial);

    function IfcMaterial(expressID, Name) {
      var _this140;

      _classCallCheck2(this, IfcMaterial);

      _this140 = _super148.call(this, expressID);
      _this140.Name = Name;
      _this140.type = 1838606355;
      return _this140;
    }

    return IfcMaterial;
  }(IfcLineObject);

  IFC2X32.IfcMaterial = IfcMaterial;

  var IfcMaterialClassificationRelationship = /*#__PURE__*/function (_IfcLineObject44) {
    _inherits(IfcMaterialClassificationRelationship, _IfcLineObject44);

    var _super149 = _createSuper(IfcMaterialClassificationRelationship);

    function IfcMaterialClassificationRelationship(expressID, MaterialClassifications, ClassifiedMaterial) {
      var _this141;

      _classCallCheck2(this, IfcMaterialClassificationRelationship);

      _this141 = _super149.call(this, expressID);
      _this141.MaterialClassifications = MaterialClassifications;
      _this141.ClassifiedMaterial = ClassifiedMaterial;
      _this141.type = 1847130766;
      return _this141;
    }

    return IfcMaterialClassificationRelationship;
  }(IfcLineObject);

  IFC2X32.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;

  var IfcMaterialLayer = /*#__PURE__*/function (_IfcLineObject45) {
    _inherits(IfcMaterialLayer, _IfcLineObject45);

    var _super150 = _createSuper(IfcMaterialLayer);

    function IfcMaterialLayer(expressID, Material, LayerThickness, IsVentilated) {
      var _this142;

      _classCallCheck2(this, IfcMaterialLayer);

      _this142 = _super150.call(this, expressID);
      _this142.Material = Material;
      _this142.LayerThickness = LayerThickness;
      _this142.IsVentilated = IsVentilated;
      _this142.type = 248100487;
      return _this142;
    }

    return IfcMaterialLayer;
  }(IfcLineObject);

  IFC2X32.IfcMaterialLayer = IfcMaterialLayer;

  var IfcMaterialLayerSet = /*#__PURE__*/function (_IfcLineObject46) {
    _inherits(IfcMaterialLayerSet, _IfcLineObject46);

    var _super151 = _createSuper(IfcMaterialLayerSet);

    function IfcMaterialLayerSet(expressID, MaterialLayers, LayerSetName) {
      var _this143;

      _classCallCheck2(this, IfcMaterialLayerSet);

      _this143 = _super151.call(this, expressID);
      _this143.MaterialLayers = MaterialLayers;
      _this143.LayerSetName = LayerSetName;
      _this143.type = 3303938423;
      return _this143;
    }

    return IfcMaterialLayerSet;
  }(IfcLineObject);

  IFC2X32.IfcMaterialLayerSet = IfcMaterialLayerSet;

  var IfcMaterialLayerSetUsage = /*#__PURE__*/function (_IfcLineObject47) {
    _inherits(IfcMaterialLayerSetUsage, _IfcLineObject47);

    var _super152 = _createSuper(IfcMaterialLayerSetUsage);

    function IfcMaterialLayerSetUsage(expressID, ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine) {
      var _this144;

      _classCallCheck2(this, IfcMaterialLayerSetUsage);

      _this144 = _super152.call(this, expressID);
      _this144.ForLayerSet = ForLayerSet;
      _this144.LayerSetDirection = LayerSetDirection;
      _this144.DirectionSense = DirectionSense;
      _this144.OffsetFromReferenceLine = OffsetFromReferenceLine;
      _this144.type = 1303795690;
      return _this144;
    }

    return IfcMaterialLayerSetUsage;
  }(IfcLineObject);

  IFC2X32.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;

  var IfcMaterialList = /*#__PURE__*/function (_IfcLineObject48) {
    _inherits(IfcMaterialList, _IfcLineObject48);

    var _super153 = _createSuper(IfcMaterialList);

    function IfcMaterialList(expressID, Materials) {
      var _this145;

      _classCallCheck2(this, IfcMaterialList);

      _this145 = _super153.call(this, expressID);
      _this145.Materials = Materials;
      _this145.type = 2199411900;
      return _this145;
    }

    return IfcMaterialList;
  }(IfcLineObject);

  IFC2X32.IfcMaterialList = IfcMaterialList;

  var IfcMaterialProperties = /*#__PURE__*/function (_IfcLineObject49) {
    _inherits(IfcMaterialProperties, _IfcLineObject49);

    var _super154 = _createSuper(IfcMaterialProperties);

    function IfcMaterialProperties(expressID, Material) {
      var _this146;

      _classCallCheck2(this, IfcMaterialProperties);

      _this146 = _super154.call(this, expressID);
      _this146.Material = Material;
      _this146.type = 3265635763;
      return _this146;
    }

    return IfcMaterialProperties;
  }(IfcLineObject);

  IFC2X32.IfcMaterialProperties = IfcMaterialProperties;

  var IfcMeasureWithUnit = /*#__PURE__*/function (_IfcLineObject50) {
    _inherits(IfcMeasureWithUnit, _IfcLineObject50);

    var _super155 = _createSuper(IfcMeasureWithUnit);

    function IfcMeasureWithUnit(expressID, ValueComponent, UnitComponent) {
      var _this147;

      _classCallCheck2(this, IfcMeasureWithUnit);

      _this147 = _super155.call(this, expressID);
      _this147.ValueComponent = ValueComponent;
      _this147.UnitComponent = UnitComponent;
      _this147.type = 2597039031;
      return _this147;
    }

    return IfcMeasureWithUnit;
  }(IfcLineObject);

  IFC2X32.IfcMeasureWithUnit = IfcMeasureWithUnit;

  var IfcMechanicalMaterialProperties = /*#__PURE__*/function (_IfcMaterialPropertie) {
    _inherits(IfcMechanicalMaterialProperties, _IfcMaterialPropertie);

    var _super156 = _createSuper(IfcMechanicalMaterialProperties);

    function IfcMechanicalMaterialProperties(expressID, Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient) {
      var _this148;

      _classCallCheck2(this, IfcMechanicalMaterialProperties);

      _this148 = _super156.call(this, expressID, Material);
      _this148.Material = Material;
      _this148.DynamicViscosity = DynamicViscosity;
      _this148.YoungModulus = YoungModulus;
      _this148.ShearModulus = ShearModulus;
      _this148.PoissonRatio = PoissonRatio;
      _this148.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
      _this148.type = 4256014907;
      return _this148;
    }

    return IfcMechanicalMaterialProperties;
  }(IfcMaterialProperties);

  IFC2X32.IfcMechanicalMaterialProperties = IfcMechanicalMaterialProperties;

  var IfcMechanicalSteelMaterialProperties = /*#__PURE__*/function (_IfcMechanicalMateria) {
    _inherits(IfcMechanicalSteelMaterialProperties, _IfcMechanicalMateria);

    var _super157 = _createSuper(IfcMechanicalSteelMaterialProperties);

    function IfcMechanicalSteelMaterialProperties(expressID, Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient, YieldStress, UltimateStress, UltimateStrain, HardeningModule, ProportionalStress, PlasticStrain, Relaxations) {
      var _this149;

      _classCallCheck2(this, IfcMechanicalSteelMaterialProperties);

      _this149 = _super157.call(this, expressID, Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient);
      _this149.Material = Material;
      _this149.DynamicViscosity = DynamicViscosity;
      _this149.YoungModulus = YoungModulus;
      _this149.ShearModulus = ShearModulus;
      _this149.PoissonRatio = PoissonRatio;
      _this149.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
      _this149.YieldStress = YieldStress;
      _this149.UltimateStress = UltimateStress;
      _this149.UltimateStrain = UltimateStrain;
      _this149.HardeningModule = HardeningModule;
      _this149.ProportionalStress = ProportionalStress;
      _this149.PlasticStrain = PlasticStrain;
      _this149.Relaxations = Relaxations;
      _this149.type = 677618848;
      return _this149;
    }

    return IfcMechanicalSteelMaterialProperties;
  }(IfcMechanicalMaterialProperties);

  IFC2X32.IfcMechanicalSteelMaterialProperties = IfcMechanicalSteelMaterialProperties;

  var IfcMetric = /*#__PURE__*/function (_IfcConstraint) {
    _inherits(IfcMetric, _IfcConstraint);

    var _super158 = _createSuper(IfcMetric);

    function IfcMetric(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue) {
      var _this150;

      _classCallCheck2(this, IfcMetric);

      _this150 = _super158.call(this, expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      _this150.Name = Name;
      _this150.Description = Description;
      _this150.ConstraintGrade = ConstraintGrade;
      _this150.ConstraintSource = ConstraintSource;
      _this150.CreatingActor = CreatingActor;
      _this150.CreationTime = CreationTime;
      _this150.UserDefinedGrade = UserDefinedGrade;
      _this150.Benchmark = Benchmark;
      _this150.ValueSource = ValueSource;
      _this150.DataValue = DataValue;
      _this150.type = 3368373690;
      return _this150;
    }

    return IfcMetric;
  }(IfcConstraint);

  IFC2X32.IfcMetric = IfcMetric;

  var IfcMonetaryUnit = /*#__PURE__*/function (_IfcLineObject51) {
    _inherits(IfcMonetaryUnit, _IfcLineObject51);

    var _super159 = _createSuper(IfcMonetaryUnit);

    function IfcMonetaryUnit(expressID, Currency) {
      var _this151;

      _classCallCheck2(this, IfcMonetaryUnit);

      _this151 = _super159.call(this, expressID);
      _this151.Currency = Currency;
      _this151.type = 2706619895;
      return _this151;
    }

    return IfcMonetaryUnit;
  }(IfcLineObject);

  IFC2X32.IfcMonetaryUnit = IfcMonetaryUnit;

  var IfcNamedUnit = /*#__PURE__*/function (_IfcLineObject52) {
    _inherits(IfcNamedUnit, _IfcLineObject52);

    var _super160 = _createSuper(IfcNamedUnit);

    function IfcNamedUnit(expressID, Dimensions, UnitType) {
      var _this152;

      _classCallCheck2(this, IfcNamedUnit);

      _this152 = _super160.call(this, expressID);
      _this152.Dimensions = Dimensions;
      _this152.UnitType = UnitType;
      _this152.type = 1918398963;
      return _this152;
    }

    return IfcNamedUnit;
  }(IfcLineObject);

  IFC2X32.IfcNamedUnit = IfcNamedUnit;

  var IfcObjectPlacement = /*#__PURE__*/function (_IfcLineObject53) {
    _inherits(IfcObjectPlacement, _IfcLineObject53);

    var _super161 = _createSuper(IfcObjectPlacement);

    function IfcObjectPlacement(expressID) {
      var _this153;

      _classCallCheck2(this, IfcObjectPlacement);

      _this153 = _super161.call(this, expressID);
      _this153.type = 3701648758;
      return _this153;
    }

    return IfcObjectPlacement;
  }(IfcLineObject);

  IFC2X32.IfcObjectPlacement = IfcObjectPlacement;

  var IfcObjective = /*#__PURE__*/function (_IfcConstraint2) {
    _inherits(IfcObjective, _IfcConstraint2);

    var _super162 = _createSuper(IfcObjective);

    function IfcObjective(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, ResultValues, ObjectiveQualifier, UserDefinedQualifier) {
      var _this154;

      _classCallCheck2(this, IfcObjective);

      _this154 = _super162.call(this, expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      _this154.Name = Name;
      _this154.Description = Description;
      _this154.ConstraintGrade = ConstraintGrade;
      _this154.ConstraintSource = ConstraintSource;
      _this154.CreatingActor = CreatingActor;
      _this154.CreationTime = CreationTime;
      _this154.UserDefinedGrade = UserDefinedGrade;
      _this154.BenchmarkValues = BenchmarkValues;
      _this154.ResultValues = ResultValues;
      _this154.ObjectiveQualifier = ObjectiveQualifier;
      _this154.UserDefinedQualifier = UserDefinedQualifier;
      _this154.type = 2251480897;
      return _this154;
    }

    return IfcObjective;
  }(IfcConstraint);

  IFC2X32.IfcObjective = IfcObjective;

  var IfcOpticalMaterialProperties = /*#__PURE__*/function (_IfcMaterialPropertie2) {
    _inherits(IfcOpticalMaterialProperties, _IfcMaterialPropertie2);

    var _super163 = _createSuper(IfcOpticalMaterialProperties);

    function IfcOpticalMaterialProperties(expressID, Material, VisibleTransmittance, SolarTransmittance, ThermalIrTransmittance, ThermalIrEmissivityBack, ThermalIrEmissivityFront, VisibleReflectanceBack, VisibleReflectanceFront, SolarReflectanceFront, SolarReflectanceBack) {
      var _this155;

      _classCallCheck2(this, IfcOpticalMaterialProperties);

      _this155 = _super163.call(this, expressID, Material);
      _this155.Material = Material;
      _this155.VisibleTransmittance = VisibleTransmittance;
      _this155.SolarTransmittance = SolarTransmittance;
      _this155.ThermalIrTransmittance = ThermalIrTransmittance;
      _this155.ThermalIrEmissivityBack = ThermalIrEmissivityBack;
      _this155.ThermalIrEmissivityFront = ThermalIrEmissivityFront;
      _this155.VisibleReflectanceBack = VisibleReflectanceBack;
      _this155.VisibleReflectanceFront = VisibleReflectanceFront;
      _this155.SolarReflectanceFront = SolarReflectanceFront;
      _this155.SolarReflectanceBack = SolarReflectanceBack;
      _this155.type = 1227763645;
      return _this155;
    }

    return IfcOpticalMaterialProperties;
  }(IfcMaterialProperties);

  IFC2X32.IfcOpticalMaterialProperties = IfcOpticalMaterialProperties;

  var IfcOrganization = /*#__PURE__*/function (_IfcLineObject54) {
    _inherits(IfcOrganization, _IfcLineObject54);

    var _super164 = _createSuper(IfcOrganization);

    function IfcOrganization(expressID, Id, Name, Description, Roles, Addresses) {
      var _this156;

      _classCallCheck2(this, IfcOrganization);

      _this156 = _super164.call(this, expressID);
      _this156.Id = Id;
      _this156.Name = Name;
      _this156.Description = Description;
      _this156.Roles = Roles;
      _this156.Addresses = Addresses;
      _this156.type = 4251960020;
      return _this156;
    }

    return IfcOrganization;
  }(IfcLineObject);

  IFC2X32.IfcOrganization = IfcOrganization;

  var IfcOrganizationRelationship = /*#__PURE__*/function (_IfcLineObject55) {
    _inherits(IfcOrganizationRelationship, _IfcLineObject55);

    var _super165 = _createSuper(IfcOrganizationRelationship);

    function IfcOrganizationRelationship(expressID, Name, Description, RelatingOrganization, RelatedOrganizations) {
      var _this157;

      _classCallCheck2(this, IfcOrganizationRelationship);

      _this157 = _super165.call(this, expressID);
      _this157.Name = Name;
      _this157.Description = Description;
      _this157.RelatingOrganization = RelatingOrganization;
      _this157.RelatedOrganizations = RelatedOrganizations;
      _this157.type = 1411181986;
      return _this157;
    }

    return IfcOrganizationRelationship;
  }(IfcLineObject);

  IFC2X32.IfcOrganizationRelationship = IfcOrganizationRelationship;

  var IfcOwnerHistory = /*#__PURE__*/function (_IfcLineObject56) {
    _inherits(IfcOwnerHistory, _IfcLineObject56);

    var _super166 = _createSuper(IfcOwnerHistory);

    function IfcOwnerHistory(expressID, OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate) {
      var _this158;

      _classCallCheck2(this, IfcOwnerHistory);

      _this158 = _super166.call(this, expressID);
      _this158.OwningUser = OwningUser;
      _this158.OwningApplication = OwningApplication;
      _this158.State = State;
      _this158.ChangeAction = ChangeAction;
      _this158.LastModifiedDate = LastModifiedDate;
      _this158.LastModifyingUser = LastModifyingUser;
      _this158.LastModifyingApplication = LastModifyingApplication;
      _this158.CreationDate = CreationDate;
      _this158.type = 1207048766;
      return _this158;
    }

    return IfcOwnerHistory;
  }(IfcLineObject);

  IFC2X32.IfcOwnerHistory = IfcOwnerHistory;

  var IfcPerson = /*#__PURE__*/function (_IfcLineObject57) {
    _inherits(IfcPerson, _IfcLineObject57);

    var _super167 = _createSuper(IfcPerson);

    function IfcPerson(expressID, Id, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses) {
      var _this159;

      _classCallCheck2(this, IfcPerson);

      _this159 = _super167.call(this, expressID);
      _this159.Id = Id;
      _this159.FamilyName = FamilyName;
      _this159.GivenName = GivenName;
      _this159.MiddleNames = MiddleNames;
      _this159.PrefixTitles = PrefixTitles;
      _this159.SuffixTitles = SuffixTitles;
      _this159.Roles = Roles;
      _this159.Addresses = Addresses;
      _this159.type = 2077209135;
      return _this159;
    }

    return IfcPerson;
  }(IfcLineObject);

  IFC2X32.IfcPerson = IfcPerson;

  var IfcPersonAndOrganization = /*#__PURE__*/function (_IfcLineObject58) {
    _inherits(IfcPersonAndOrganization, _IfcLineObject58);

    var _super168 = _createSuper(IfcPersonAndOrganization);

    function IfcPersonAndOrganization(expressID, ThePerson, TheOrganization, Roles) {
      var _this160;

      _classCallCheck2(this, IfcPersonAndOrganization);

      _this160 = _super168.call(this, expressID);
      _this160.ThePerson = ThePerson;
      _this160.TheOrganization = TheOrganization;
      _this160.Roles = Roles;
      _this160.type = 101040310;
      return _this160;
    }

    return IfcPersonAndOrganization;
  }(IfcLineObject);

  IFC2X32.IfcPersonAndOrganization = IfcPersonAndOrganization;

  var IfcPhysicalQuantity = /*#__PURE__*/function (_IfcLineObject59) {
    _inherits(IfcPhysicalQuantity, _IfcLineObject59);

    var _super169 = _createSuper(IfcPhysicalQuantity);

    function IfcPhysicalQuantity(expressID, Name, Description) {
      var _this161;

      _classCallCheck2(this, IfcPhysicalQuantity);

      _this161 = _super169.call(this, expressID);
      _this161.Name = Name;
      _this161.Description = Description;
      _this161.type = 2483315170;
      return _this161;
    }

    return IfcPhysicalQuantity;
  }(IfcLineObject);

  IFC2X32.IfcPhysicalQuantity = IfcPhysicalQuantity;

  var IfcPhysicalSimpleQuantity = /*#__PURE__*/function (_IfcPhysicalQuantity) {
    _inherits(IfcPhysicalSimpleQuantity, _IfcPhysicalQuantity);

    var _super170 = _createSuper(IfcPhysicalSimpleQuantity);

    function IfcPhysicalSimpleQuantity(expressID, Name, Description, Unit) {
      var _this162;

      _classCallCheck2(this, IfcPhysicalSimpleQuantity);

      _this162 = _super170.call(this, expressID, Name, Description);
      _this162.Name = Name;
      _this162.Description = Description;
      _this162.Unit = Unit;
      _this162.type = 2226359599;
      return _this162;
    }

    return IfcPhysicalSimpleQuantity;
  }(IfcPhysicalQuantity);

  IFC2X32.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;

  var IfcPostalAddress = /*#__PURE__*/function (_IfcAddress) {
    _inherits(IfcPostalAddress, _IfcAddress);

    var _super171 = _createSuper(IfcPostalAddress);

    function IfcPostalAddress(expressID, Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country) {
      var _this163;

      _classCallCheck2(this, IfcPostalAddress);

      _this163 = _super171.call(this, expressID, Purpose, Description, UserDefinedPurpose);
      _this163.Purpose = Purpose;
      _this163.Description = Description;
      _this163.UserDefinedPurpose = UserDefinedPurpose;
      _this163.InternalLocation = InternalLocation;
      _this163.AddressLines = AddressLines;
      _this163.PostalBox = PostalBox;
      _this163.Town = Town;
      _this163.Region = Region;
      _this163.PostalCode = PostalCode;
      _this163.Country = Country;
      _this163.type = 3355820592;
      return _this163;
    }

    return IfcPostalAddress;
  }(IfcAddress);

  IFC2X32.IfcPostalAddress = IfcPostalAddress;

  var IfcPreDefinedItem = /*#__PURE__*/function (_IfcLineObject60) {
    _inherits(IfcPreDefinedItem, _IfcLineObject60);

    var _super172 = _createSuper(IfcPreDefinedItem);

    function IfcPreDefinedItem(expressID, Name) {
      var _this164;

      _classCallCheck2(this, IfcPreDefinedItem);

      _this164 = _super172.call(this, expressID);
      _this164.Name = Name;
      _this164.type = 3727388367;
      return _this164;
    }

    return IfcPreDefinedItem;
  }(IfcLineObject);

  IFC2X32.IfcPreDefinedItem = IfcPreDefinedItem;

  var IfcPreDefinedSymbol = /*#__PURE__*/function (_IfcPreDefinedItem) {
    _inherits(IfcPreDefinedSymbol, _IfcPreDefinedItem);

    var _super173 = _createSuper(IfcPreDefinedSymbol);

    function IfcPreDefinedSymbol(expressID, Name) {
      var _this165;

      _classCallCheck2(this, IfcPreDefinedSymbol);

      _this165 = _super173.call(this, expressID, Name);
      _this165.Name = Name;
      _this165.type = 990879717;
      return _this165;
    }

    return IfcPreDefinedSymbol;
  }(IfcPreDefinedItem);

  IFC2X32.IfcPreDefinedSymbol = IfcPreDefinedSymbol;

  var IfcPreDefinedTerminatorSymbol = /*#__PURE__*/function (_IfcPreDefinedSymbol) {
    _inherits(IfcPreDefinedTerminatorSymbol, _IfcPreDefinedSymbol);

    var _super174 = _createSuper(IfcPreDefinedTerminatorSymbol);

    function IfcPreDefinedTerminatorSymbol(expressID, Name) {
      var _this166;

      _classCallCheck2(this, IfcPreDefinedTerminatorSymbol);

      _this166 = _super174.call(this, expressID, Name);
      _this166.Name = Name;
      _this166.type = 3213052703;
      return _this166;
    }

    return IfcPreDefinedTerminatorSymbol;
  }(IfcPreDefinedSymbol);

  IFC2X32.IfcPreDefinedTerminatorSymbol = IfcPreDefinedTerminatorSymbol;

  var IfcPreDefinedTextFont = /*#__PURE__*/function (_IfcPreDefinedItem2) {
    _inherits(IfcPreDefinedTextFont, _IfcPreDefinedItem2);

    var _super175 = _createSuper(IfcPreDefinedTextFont);

    function IfcPreDefinedTextFont(expressID, Name) {
      var _this167;

      _classCallCheck2(this, IfcPreDefinedTextFont);

      _this167 = _super175.call(this, expressID, Name);
      _this167.Name = Name;
      _this167.type = 1775413392;
      return _this167;
    }

    return IfcPreDefinedTextFont;
  }(IfcPreDefinedItem);

  IFC2X32.IfcPreDefinedTextFont = IfcPreDefinedTextFont;

  var IfcPresentationLayerAssignment = /*#__PURE__*/function (_IfcLineObject61) {
    _inherits(IfcPresentationLayerAssignment, _IfcLineObject61);

    var _super176 = _createSuper(IfcPresentationLayerAssignment);

    function IfcPresentationLayerAssignment(expressID, Name, Description, AssignedItems, Identifier) {
      var _this168;

      _classCallCheck2(this, IfcPresentationLayerAssignment);

      _this168 = _super176.call(this, expressID);
      _this168.Name = Name;
      _this168.Description = Description;
      _this168.AssignedItems = AssignedItems;
      _this168.Identifier = Identifier;
      _this168.type = 2022622350;
      return _this168;
    }

    return IfcPresentationLayerAssignment;
  }(IfcLineObject);

  IFC2X32.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;

  var IfcPresentationLayerWithStyle = /*#__PURE__*/function (_IfcPresentationLayer) {
    _inherits(IfcPresentationLayerWithStyle, _IfcPresentationLayer);

    var _super177 = _createSuper(IfcPresentationLayerWithStyle);

    function IfcPresentationLayerWithStyle(expressID, Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles) {
      var _this169;

      _classCallCheck2(this, IfcPresentationLayerWithStyle);

      _this169 = _super177.call(this, expressID, Name, Description, AssignedItems, Identifier);
      _this169.Name = Name;
      _this169.Description = Description;
      _this169.AssignedItems = AssignedItems;
      _this169.Identifier = Identifier;
      _this169.LayerOn = LayerOn;
      _this169.LayerFrozen = LayerFrozen;
      _this169.LayerBlocked = LayerBlocked;
      _this169.LayerStyles = LayerStyles;
      _this169.type = 1304840413;
      return _this169;
    }

    return IfcPresentationLayerWithStyle;
  }(IfcPresentationLayerAssignment);

  IFC2X32.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;

  var IfcPresentationStyle = /*#__PURE__*/function (_IfcLineObject62) {
    _inherits(IfcPresentationStyle, _IfcLineObject62);

    var _super178 = _createSuper(IfcPresentationStyle);

    function IfcPresentationStyle(expressID, Name) {
      var _this170;

      _classCallCheck2(this, IfcPresentationStyle);

      _this170 = _super178.call(this, expressID);
      _this170.Name = Name;
      _this170.type = 3119450353;
      return _this170;
    }

    return IfcPresentationStyle;
  }(IfcLineObject);

  IFC2X32.IfcPresentationStyle = IfcPresentationStyle;

  var IfcPresentationStyleAssignment = /*#__PURE__*/function (_IfcLineObject63) {
    _inherits(IfcPresentationStyleAssignment, _IfcLineObject63);

    var _super179 = _createSuper(IfcPresentationStyleAssignment);

    function IfcPresentationStyleAssignment(expressID, Styles) {
      var _this171;

      _classCallCheck2(this, IfcPresentationStyleAssignment);

      _this171 = _super179.call(this, expressID);
      _this171.Styles = Styles;
      _this171.type = 2417041796;
      return _this171;
    }

    return IfcPresentationStyleAssignment;
  }(IfcLineObject);

  IFC2X32.IfcPresentationStyleAssignment = IfcPresentationStyleAssignment;

  var IfcProductRepresentation = /*#__PURE__*/function (_IfcLineObject64) {
    _inherits(IfcProductRepresentation, _IfcLineObject64);

    var _super180 = _createSuper(IfcProductRepresentation);

    function IfcProductRepresentation(expressID, Name, Description, Representations) {
      var _this172;

      _classCallCheck2(this, IfcProductRepresentation);

      _this172 = _super180.call(this, expressID);
      _this172.Name = Name;
      _this172.Description = Description;
      _this172.Representations = Representations;
      _this172.type = 2095639259;
      return _this172;
    }

    return IfcProductRepresentation;
  }(IfcLineObject);

  IFC2X32.IfcProductRepresentation = IfcProductRepresentation;

  var IfcProductsOfCombustionProperties = /*#__PURE__*/function (_IfcMaterialPropertie3) {
    _inherits(IfcProductsOfCombustionProperties, _IfcMaterialPropertie3);

    var _super181 = _createSuper(IfcProductsOfCombustionProperties);

    function IfcProductsOfCombustionProperties(expressID, Material, SpecificHeatCapacity, N20Content, COContent, CO2Content) {
      var _this173;

      _classCallCheck2(this, IfcProductsOfCombustionProperties);

      _this173 = _super181.call(this, expressID, Material);
      _this173.Material = Material;
      _this173.SpecificHeatCapacity = SpecificHeatCapacity;
      _this173.N20Content = N20Content;
      _this173.COContent = COContent;
      _this173.CO2Content = CO2Content;
      _this173.type = 2267347899;
      return _this173;
    }

    return IfcProductsOfCombustionProperties;
  }(IfcMaterialProperties);

  IFC2X32.IfcProductsOfCombustionProperties = IfcProductsOfCombustionProperties;

  var IfcProfileDef = /*#__PURE__*/function (_IfcLineObject65) {
    _inherits(IfcProfileDef, _IfcLineObject65);

    var _super182 = _createSuper(IfcProfileDef);

    function IfcProfileDef(expressID, ProfileType, ProfileName) {
      var _this174;

      _classCallCheck2(this, IfcProfileDef);

      _this174 = _super182.call(this, expressID);
      _this174.ProfileType = ProfileType;
      _this174.ProfileName = ProfileName;
      _this174.type = 3958567839;
      return _this174;
    }

    return IfcProfileDef;
  }(IfcLineObject);

  IFC2X32.IfcProfileDef = IfcProfileDef;

  var IfcProfileProperties = /*#__PURE__*/function (_IfcLineObject66) {
    _inherits(IfcProfileProperties, _IfcLineObject66);

    var _super183 = _createSuper(IfcProfileProperties);

    function IfcProfileProperties(expressID, ProfileName, ProfileDefinition) {
      var _this175;

      _classCallCheck2(this, IfcProfileProperties);

      _this175 = _super183.call(this, expressID);
      _this175.ProfileName = ProfileName;
      _this175.ProfileDefinition = ProfileDefinition;
      _this175.type = 2802850158;
      return _this175;
    }

    return IfcProfileProperties;
  }(IfcLineObject);

  IFC2X32.IfcProfileProperties = IfcProfileProperties;

  var IfcProperty = /*#__PURE__*/function (_IfcLineObject67) {
    _inherits(IfcProperty, _IfcLineObject67);

    var _super184 = _createSuper(IfcProperty);

    function IfcProperty(expressID, Name, Description) {
      var _this176;

      _classCallCheck2(this, IfcProperty);

      _this176 = _super184.call(this, expressID);
      _this176.Name = Name;
      _this176.Description = Description;
      _this176.type = 2598011224;
      return _this176;
    }

    return IfcProperty;
  }(IfcLineObject);

  IFC2X32.IfcProperty = IfcProperty;

  var IfcPropertyConstraintRelationship = /*#__PURE__*/function (_IfcLineObject68) {
    _inherits(IfcPropertyConstraintRelationship, _IfcLineObject68);

    var _super185 = _createSuper(IfcPropertyConstraintRelationship);

    function IfcPropertyConstraintRelationship(expressID, RelatingConstraint, RelatedProperties, Name, Description) {
      var _this177;

      _classCallCheck2(this, IfcPropertyConstraintRelationship);

      _this177 = _super185.call(this, expressID);
      _this177.RelatingConstraint = RelatingConstraint;
      _this177.RelatedProperties = RelatedProperties;
      _this177.Name = Name;
      _this177.Description = Description;
      _this177.type = 3896028662;
      return _this177;
    }

    return IfcPropertyConstraintRelationship;
  }(IfcLineObject);

  IFC2X32.IfcPropertyConstraintRelationship = IfcPropertyConstraintRelationship;

  var IfcPropertyDependencyRelationship = /*#__PURE__*/function (_IfcLineObject69) {
    _inherits(IfcPropertyDependencyRelationship, _IfcLineObject69);

    var _super186 = _createSuper(IfcPropertyDependencyRelationship);

    function IfcPropertyDependencyRelationship(expressID, DependingProperty, DependantProperty, Name, Description, Expression) {
      var _this178;

      _classCallCheck2(this, IfcPropertyDependencyRelationship);

      _this178 = _super186.call(this, expressID);
      _this178.DependingProperty = DependingProperty;
      _this178.DependantProperty = DependantProperty;
      _this178.Name = Name;
      _this178.Description = Description;
      _this178.Expression = Expression;
      _this178.type = 148025276;
      return _this178;
    }

    return IfcPropertyDependencyRelationship;
  }(IfcLineObject);

  IFC2X32.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;

  var IfcPropertyEnumeration = /*#__PURE__*/function (_IfcLineObject70) {
    _inherits(IfcPropertyEnumeration, _IfcLineObject70);

    var _super187 = _createSuper(IfcPropertyEnumeration);

    function IfcPropertyEnumeration(expressID, Name, EnumerationValues, Unit) {
      var _this179;

      _classCallCheck2(this, IfcPropertyEnumeration);

      _this179 = _super187.call(this, expressID);
      _this179.Name = Name;
      _this179.EnumerationValues = EnumerationValues;
      _this179.Unit = Unit;
      _this179.type = 3710013099;
      return _this179;
    }

    return IfcPropertyEnumeration;
  }(IfcLineObject);

  IFC2X32.IfcPropertyEnumeration = IfcPropertyEnumeration;

  var IfcQuantityArea = /*#__PURE__*/function (_IfcPhysicalSimpleQua) {
    _inherits(IfcQuantityArea, _IfcPhysicalSimpleQua);

    var _super188 = _createSuper(IfcQuantityArea);

    function IfcQuantityArea(expressID, Name, Description, Unit, AreaValue) {
      var _this180;

      _classCallCheck2(this, IfcQuantityArea);

      _this180 = _super188.call(this, expressID, Name, Description, Unit);
      _this180.Name = Name;
      _this180.Description = Description;
      _this180.Unit = Unit;
      _this180.AreaValue = AreaValue;
      _this180.type = 2044713172;
      return _this180;
    }

    return IfcQuantityArea;
  }(IfcPhysicalSimpleQuantity);

  IFC2X32.IfcQuantityArea = IfcQuantityArea;

  var IfcQuantityCount = /*#__PURE__*/function (_IfcPhysicalSimpleQua2) {
    _inherits(IfcQuantityCount, _IfcPhysicalSimpleQua2);

    var _super189 = _createSuper(IfcQuantityCount);

    function IfcQuantityCount(expressID, Name, Description, Unit, CountValue) {
      var _this181;

      _classCallCheck2(this, IfcQuantityCount);

      _this181 = _super189.call(this, expressID, Name, Description, Unit);
      _this181.Name = Name;
      _this181.Description = Description;
      _this181.Unit = Unit;
      _this181.CountValue = CountValue;
      _this181.type = 2093928680;
      return _this181;
    }

    return IfcQuantityCount;
  }(IfcPhysicalSimpleQuantity);

  IFC2X32.IfcQuantityCount = IfcQuantityCount;

  var IfcQuantityLength = /*#__PURE__*/function (_IfcPhysicalSimpleQua3) {
    _inherits(IfcQuantityLength, _IfcPhysicalSimpleQua3);

    var _super190 = _createSuper(IfcQuantityLength);

    function IfcQuantityLength(expressID, Name, Description, Unit, LengthValue) {
      var _this182;

      _classCallCheck2(this, IfcQuantityLength);

      _this182 = _super190.call(this, expressID, Name, Description, Unit);
      _this182.Name = Name;
      _this182.Description = Description;
      _this182.Unit = Unit;
      _this182.LengthValue = LengthValue;
      _this182.type = 931644368;
      return _this182;
    }

    return IfcQuantityLength;
  }(IfcPhysicalSimpleQuantity);

  IFC2X32.IfcQuantityLength = IfcQuantityLength;

  var IfcQuantityTime = /*#__PURE__*/function (_IfcPhysicalSimpleQua4) {
    _inherits(IfcQuantityTime, _IfcPhysicalSimpleQua4);

    var _super191 = _createSuper(IfcQuantityTime);

    function IfcQuantityTime(expressID, Name, Description, Unit, TimeValue) {
      var _this183;

      _classCallCheck2(this, IfcQuantityTime);

      _this183 = _super191.call(this, expressID, Name, Description, Unit);
      _this183.Name = Name;
      _this183.Description = Description;
      _this183.Unit = Unit;
      _this183.TimeValue = TimeValue;
      _this183.type = 3252649465;
      return _this183;
    }

    return IfcQuantityTime;
  }(IfcPhysicalSimpleQuantity);

  IFC2X32.IfcQuantityTime = IfcQuantityTime;

  var IfcQuantityVolume = /*#__PURE__*/function (_IfcPhysicalSimpleQua5) {
    _inherits(IfcQuantityVolume, _IfcPhysicalSimpleQua5);

    var _super192 = _createSuper(IfcQuantityVolume);

    function IfcQuantityVolume(expressID, Name, Description, Unit, VolumeValue) {
      var _this184;

      _classCallCheck2(this, IfcQuantityVolume);

      _this184 = _super192.call(this, expressID, Name, Description, Unit);
      _this184.Name = Name;
      _this184.Description = Description;
      _this184.Unit = Unit;
      _this184.VolumeValue = VolumeValue;
      _this184.type = 2405470396;
      return _this184;
    }

    return IfcQuantityVolume;
  }(IfcPhysicalSimpleQuantity);

  IFC2X32.IfcQuantityVolume = IfcQuantityVolume;

  var IfcQuantityWeight = /*#__PURE__*/function (_IfcPhysicalSimpleQua6) {
    _inherits(IfcQuantityWeight, _IfcPhysicalSimpleQua6);

    var _super193 = _createSuper(IfcQuantityWeight);

    function IfcQuantityWeight(expressID, Name, Description, Unit, WeightValue) {
      var _this185;

      _classCallCheck2(this, IfcQuantityWeight);

      _this185 = _super193.call(this, expressID, Name, Description, Unit);
      _this185.Name = Name;
      _this185.Description = Description;
      _this185.Unit = Unit;
      _this185.WeightValue = WeightValue;
      _this185.type = 825690147;
      return _this185;
    }

    return IfcQuantityWeight;
  }(IfcPhysicalSimpleQuantity);

  IFC2X32.IfcQuantityWeight = IfcQuantityWeight;

  var IfcReferencesValueDocument = /*#__PURE__*/function (_IfcLineObject71) {
    _inherits(IfcReferencesValueDocument, _IfcLineObject71);

    var _super194 = _createSuper(IfcReferencesValueDocument);

    function IfcReferencesValueDocument(expressID, ReferencedDocument, ReferencingValues, Name, Description) {
      var _this186;

      _classCallCheck2(this, IfcReferencesValueDocument);

      _this186 = _super194.call(this, expressID);
      _this186.ReferencedDocument = ReferencedDocument;
      _this186.ReferencingValues = ReferencingValues;
      _this186.Name = Name;
      _this186.Description = Description;
      _this186.type = 2692823254;
      return _this186;
    }

    return IfcReferencesValueDocument;
  }(IfcLineObject);

  IFC2X32.IfcReferencesValueDocument = IfcReferencesValueDocument;

  var IfcReinforcementBarProperties = /*#__PURE__*/function (_IfcLineObject72) {
    _inherits(IfcReinforcementBarProperties, _IfcLineObject72);

    var _super195 = _createSuper(IfcReinforcementBarProperties);

    function IfcReinforcementBarProperties(expressID, TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount) {
      var _this187;

      _classCallCheck2(this, IfcReinforcementBarProperties);

      _this187 = _super195.call(this, expressID);
      _this187.TotalCrossSectionArea = TotalCrossSectionArea;
      _this187.SteelGrade = SteelGrade;
      _this187.BarSurface = BarSurface;
      _this187.EffectiveDepth = EffectiveDepth;
      _this187.NominalBarDiameter = NominalBarDiameter;
      _this187.BarCount = BarCount;
      _this187.type = 1580146022;
      return _this187;
    }

    return IfcReinforcementBarProperties;
  }(IfcLineObject);

  IFC2X32.IfcReinforcementBarProperties = IfcReinforcementBarProperties;

  var IfcRelaxation = /*#__PURE__*/function (_IfcLineObject73) {
    _inherits(IfcRelaxation, _IfcLineObject73);

    var _super196 = _createSuper(IfcRelaxation);

    function IfcRelaxation(expressID, RelaxationValue, InitialStress) {
      var _this188;

      _classCallCheck2(this, IfcRelaxation);

      _this188 = _super196.call(this, expressID);
      _this188.RelaxationValue = RelaxationValue;
      _this188.InitialStress = InitialStress;
      _this188.type = 1222501353;
      return _this188;
    }

    return IfcRelaxation;
  }(IfcLineObject);

  IFC2X32.IfcRelaxation = IfcRelaxation;

  var IfcRepresentation = /*#__PURE__*/function (_IfcLineObject74) {
    _inherits(IfcRepresentation, _IfcLineObject74);

    var _super197 = _createSuper(IfcRepresentation);

    function IfcRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this189;

      _classCallCheck2(this, IfcRepresentation);

      _this189 = _super197.call(this, expressID);
      _this189.ContextOfItems = ContextOfItems;
      _this189.RepresentationIdentifier = RepresentationIdentifier;
      _this189.RepresentationType = RepresentationType;
      _this189.Items = Items;
      _this189.type = 1076942058;
      return _this189;
    }

    return IfcRepresentation;
  }(IfcLineObject);

  IFC2X32.IfcRepresentation = IfcRepresentation;

  var IfcRepresentationContext = /*#__PURE__*/function (_IfcLineObject75) {
    _inherits(IfcRepresentationContext, _IfcLineObject75);

    var _super198 = _createSuper(IfcRepresentationContext);

    function IfcRepresentationContext(expressID, ContextIdentifier, ContextType) {
      var _this190;

      _classCallCheck2(this, IfcRepresentationContext);

      _this190 = _super198.call(this, expressID);
      _this190.ContextIdentifier = ContextIdentifier;
      _this190.ContextType = ContextType;
      _this190.type = 3377609919;
      return _this190;
    }

    return IfcRepresentationContext;
  }(IfcLineObject);

  IFC2X32.IfcRepresentationContext = IfcRepresentationContext;

  var IfcRepresentationItem = /*#__PURE__*/function (_IfcLineObject76) {
    _inherits(IfcRepresentationItem, _IfcLineObject76);

    var _super199 = _createSuper(IfcRepresentationItem);

    function IfcRepresentationItem(expressID) {
      var _this191;

      _classCallCheck2(this, IfcRepresentationItem);

      _this191 = _super199.call(this, expressID);
      _this191.type = 3008791417;
      return _this191;
    }

    return IfcRepresentationItem;
  }(IfcLineObject);

  IFC2X32.IfcRepresentationItem = IfcRepresentationItem;

  var IfcRepresentationMap = /*#__PURE__*/function (_IfcLineObject77) {
    _inherits(IfcRepresentationMap, _IfcLineObject77);

    var _super200 = _createSuper(IfcRepresentationMap);

    function IfcRepresentationMap(expressID, MappingOrigin, MappedRepresentation) {
      var _this192;

      _classCallCheck2(this, IfcRepresentationMap);

      _this192 = _super200.call(this, expressID);
      _this192.MappingOrigin = MappingOrigin;
      _this192.MappedRepresentation = MappedRepresentation;
      _this192.type = 1660063152;
      return _this192;
    }

    return IfcRepresentationMap;
  }(IfcLineObject);

  IFC2X32.IfcRepresentationMap = IfcRepresentationMap;

  var IfcRibPlateProfileProperties = /*#__PURE__*/function (_IfcProfileProperties) {
    _inherits(IfcRibPlateProfileProperties, _IfcProfileProperties);

    var _super201 = _createSuper(IfcRibPlateProfileProperties);

    function IfcRibPlateProfileProperties(expressID, ProfileName, ProfileDefinition, Thickness, RibHeight, RibWidth, RibSpacing, Direction) {
      var _this193;

      _classCallCheck2(this, IfcRibPlateProfileProperties);

      _this193 = _super201.call(this, expressID, ProfileName, ProfileDefinition);
      _this193.ProfileName = ProfileName;
      _this193.ProfileDefinition = ProfileDefinition;
      _this193.Thickness = Thickness;
      _this193.RibHeight = RibHeight;
      _this193.RibWidth = RibWidth;
      _this193.RibSpacing = RibSpacing;
      _this193.Direction = Direction;
      _this193.type = 3679540991;
      return _this193;
    }

    return IfcRibPlateProfileProperties;
  }(IfcProfileProperties);

  IFC2X32.IfcRibPlateProfileProperties = IfcRibPlateProfileProperties;

  var IfcRoot = /*#__PURE__*/function (_IfcLineObject78) {
    _inherits(IfcRoot, _IfcLineObject78);

    var _super202 = _createSuper(IfcRoot);

    function IfcRoot(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this194;

      _classCallCheck2(this, IfcRoot);

      _this194 = _super202.call(this, expressID);
      _this194.GlobalId = GlobalId;
      _this194.OwnerHistory = OwnerHistory;
      _this194.Name = Name;
      _this194.Description = Description;
      _this194.type = 2341007311;
      return _this194;
    }

    return IfcRoot;
  }(IfcLineObject);

  IFC2X32.IfcRoot = IfcRoot;

  var IfcSIUnit = /*#__PURE__*/function (_IfcNamedUnit) {
    _inherits(IfcSIUnit, _IfcNamedUnit);

    var _super203 = _createSuper(IfcSIUnit);

    function IfcSIUnit(expressID, UnitType, Prefix, Name) {
      var _this195;

      _classCallCheck2(this, IfcSIUnit);

      _this195 = _super203.call(this, expressID, new Handle(0), UnitType);
      _this195.UnitType = UnitType;
      _this195.Prefix = Prefix;
      _this195.Name = Name;
      _this195.type = 448429030;
      return _this195;
    }

    return IfcSIUnit;
  }(IfcNamedUnit);

  IFC2X32.IfcSIUnit = IfcSIUnit;

  var IfcSectionProperties = /*#__PURE__*/function (_IfcLineObject79) {
    _inherits(IfcSectionProperties, _IfcLineObject79);

    var _super204 = _createSuper(IfcSectionProperties);

    function IfcSectionProperties(expressID, SectionType, StartProfile, EndProfile) {
      var _this196;

      _classCallCheck2(this, IfcSectionProperties);

      _this196 = _super204.call(this, expressID);
      _this196.SectionType = SectionType;
      _this196.StartProfile = StartProfile;
      _this196.EndProfile = EndProfile;
      _this196.type = 2042790032;
      return _this196;
    }

    return IfcSectionProperties;
  }(IfcLineObject);

  IFC2X32.IfcSectionProperties = IfcSectionProperties;

  var IfcSectionReinforcementProperties = /*#__PURE__*/function (_IfcLineObject80) {
    _inherits(IfcSectionReinforcementProperties, _IfcLineObject80);

    var _super205 = _createSuper(IfcSectionReinforcementProperties);

    function IfcSectionReinforcementProperties(expressID, LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions) {
      var _this197;

      _classCallCheck2(this, IfcSectionReinforcementProperties);

      _this197 = _super205.call(this, expressID);
      _this197.LongitudinalStartPosition = LongitudinalStartPosition;
      _this197.LongitudinalEndPosition = LongitudinalEndPosition;
      _this197.TransversePosition = TransversePosition;
      _this197.ReinforcementRole = ReinforcementRole;
      _this197.SectionDefinition = SectionDefinition;
      _this197.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
      _this197.type = 4165799628;
      return _this197;
    }

    return IfcSectionReinforcementProperties;
  }(IfcLineObject);

  IFC2X32.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;

  var IfcShapeAspect = /*#__PURE__*/function (_IfcLineObject81) {
    _inherits(IfcShapeAspect, _IfcLineObject81);

    var _super206 = _createSuper(IfcShapeAspect);

    function IfcShapeAspect(expressID, ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape) {
      var _this198;

      _classCallCheck2(this, IfcShapeAspect);

      _this198 = _super206.call(this, expressID);
      _this198.ShapeRepresentations = ShapeRepresentations;
      _this198.Name = Name;
      _this198.Description = Description;
      _this198.ProductDefinitional = ProductDefinitional;
      _this198.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
      _this198.type = 867548509;
      return _this198;
    }

    return IfcShapeAspect;
  }(IfcLineObject);

  IFC2X32.IfcShapeAspect = IfcShapeAspect;

  var IfcShapeModel = /*#__PURE__*/function (_IfcRepresentation) {
    _inherits(IfcShapeModel, _IfcRepresentation);

    var _super207 = _createSuper(IfcShapeModel);

    function IfcShapeModel(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this199;

      _classCallCheck2(this, IfcShapeModel);

      _this199 = _super207.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this199.ContextOfItems = ContextOfItems;
      _this199.RepresentationIdentifier = RepresentationIdentifier;
      _this199.RepresentationType = RepresentationType;
      _this199.Items = Items;
      _this199.type = 3982875396;
      return _this199;
    }

    return IfcShapeModel;
  }(IfcRepresentation);

  IFC2X32.IfcShapeModel = IfcShapeModel;

  var IfcShapeRepresentation = /*#__PURE__*/function (_IfcShapeModel) {
    _inherits(IfcShapeRepresentation, _IfcShapeModel);

    var _super208 = _createSuper(IfcShapeRepresentation);

    function IfcShapeRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this200;

      _classCallCheck2(this, IfcShapeRepresentation);

      _this200 = _super208.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this200.ContextOfItems = ContextOfItems;
      _this200.RepresentationIdentifier = RepresentationIdentifier;
      _this200.RepresentationType = RepresentationType;
      _this200.Items = Items;
      _this200.type = 4240577450;
      return _this200;
    }

    return IfcShapeRepresentation;
  }(IfcShapeModel);

  IFC2X32.IfcShapeRepresentation = IfcShapeRepresentation;

  var IfcSimpleProperty = /*#__PURE__*/function (_IfcProperty) {
    _inherits(IfcSimpleProperty, _IfcProperty);

    var _super209 = _createSuper(IfcSimpleProperty);

    function IfcSimpleProperty(expressID, Name, Description) {
      var _this201;

      _classCallCheck2(this, IfcSimpleProperty);

      _this201 = _super209.call(this, expressID, Name, Description);
      _this201.Name = Name;
      _this201.Description = Description;
      _this201.type = 3692461612;
      return _this201;
    }

    return IfcSimpleProperty;
  }(IfcProperty);

  IFC2X32.IfcSimpleProperty = IfcSimpleProperty;

  var IfcStructuralConnectionCondition = /*#__PURE__*/function (_IfcLineObject82) {
    _inherits(IfcStructuralConnectionCondition, _IfcLineObject82);

    var _super210 = _createSuper(IfcStructuralConnectionCondition);

    function IfcStructuralConnectionCondition(expressID, Name) {
      var _this202;

      _classCallCheck2(this, IfcStructuralConnectionCondition);

      _this202 = _super210.call(this, expressID);
      _this202.Name = Name;
      _this202.type = 2273995522;
      return _this202;
    }

    return IfcStructuralConnectionCondition;
  }(IfcLineObject);

  IFC2X32.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;

  var IfcStructuralLoad = /*#__PURE__*/function (_IfcLineObject83) {
    _inherits(IfcStructuralLoad, _IfcLineObject83);

    var _super211 = _createSuper(IfcStructuralLoad);

    function IfcStructuralLoad(expressID, Name) {
      var _this203;

      _classCallCheck2(this, IfcStructuralLoad);

      _this203 = _super211.call(this, expressID);
      _this203.Name = Name;
      _this203.type = 2162789131;
      return _this203;
    }

    return IfcStructuralLoad;
  }(IfcLineObject);

  IFC2X32.IfcStructuralLoad = IfcStructuralLoad;

  var IfcStructuralLoadStatic = /*#__PURE__*/function (_IfcStructuralLoad) {
    _inherits(IfcStructuralLoadStatic, _IfcStructuralLoad);

    var _super212 = _createSuper(IfcStructuralLoadStatic);

    function IfcStructuralLoadStatic(expressID, Name) {
      var _this204;

      _classCallCheck2(this, IfcStructuralLoadStatic);

      _this204 = _super212.call(this, expressID, Name);
      _this204.Name = Name;
      _this204.type = 2525727697;
      return _this204;
    }

    return IfcStructuralLoadStatic;
  }(IfcStructuralLoad);

  IFC2X32.IfcStructuralLoadStatic = IfcStructuralLoadStatic;

  var IfcStructuralLoadTemperature = /*#__PURE__*/function (_IfcStructuralLoadSta) {
    _inherits(IfcStructuralLoadTemperature, _IfcStructuralLoadSta);

    var _super213 = _createSuper(IfcStructuralLoadTemperature);

    function IfcStructuralLoadTemperature(expressID, Name, DeltaT_Constant, DeltaT_Y, DeltaT_Z) {
      var _this205;

      _classCallCheck2(this, IfcStructuralLoadTemperature);

      _this205 = _super213.call(this, expressID, Name);
      _this205.Name = Name;
      _this205.DeltaT_Constant = DeltaT_Constant;
      _this205.DeltaT_Y = DeltaT_Y;
      _this205.DeltaT_Z = DeltaT_Z;
      _this205.type = 3408363356;
      return _this205;
    }

    return IfcStructuralLoadTemperature;
  }(IfcStructuralLoadStatic);

  IFC2X32.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;

  var IfcStyleModel = /*#__PURE__*/function (_IfcRepresentation2) {
    _inherits(IfcStyleModel, _IfcRepresentation2);

    var _super214 = _createSuper(IfcStyleModel);

    function IfcStyleModel(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this206;

      _classCallCheck2(this, IfcStyleModel);

      _this206 = _super214.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this206.ContextOfItems = ContextOfItems;
      _this206.RepresentationIdentifier = RepresentationIdentifier;
      _this206.RepresentationType = RepresentationType;
      _this206.Items = Items;
      _this206.type = 2830218821;
      return _this206;
    }

    return IfcStyleModel;
  }(IfcRepresentation);

  IFC2X32.IfcStyleModel = IfcStyleModel;

  var IfcStyledItem = /*#__PURE__*/function (_IfcRepresentationIte) {
    _inherits(IfcStyledItem, _IfcRepresentationIte);

    var _super215 = _createSuper(IfcStyledItem);

    function IfcStyledItem(expressID, Item, Styles, Name) {
      var _this207;

      _classCallCheck2(this, IfcStyledItem);

      _this207 = _super215.call(this, expressID);
      _this207.Item = Item;
      _this207.Styles = Styles;
      _this207.Name = Name;
      _this207.type = 3958052878;
      return _this207;
    }

    return IfcStyledItem;
  }(IfcRepresentationItem);

  IFC2X32.IfcStyledItem = IfcStyledItem;

  var IfcStyledRepresentation = /*#__PURE__*/function (_IfcStyleModel) {
    _inherits(IfcStyledRepresentation, _IfcStyleModel);

    var _super216 = _createSuper(IfcStyledRepresentation);

    function IfcStyledRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this208;

      _classCallCheck2(this, IfcStyledRepresentation);

      _this208 = _super216.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this208.ContextOfItems = ContextOfItems;
      _this208.RepresentationIdentifier = RepresentationIdentifier;
      _this208.RepresentationType = RepresentationType;
      _this208.Items = Items;
      _this208.type = 3049322572;
      return _this208;
    }

    return IfcStyledRepresentation;
  }(IfcStyleModel);

  IFC2X32.IfcStyledRepresentation = IfcStyledRepresentation;

  var IfcSurfaceStyle = /*#__PURE__*/function (_IfcPresentationStyle) {
    _inherits(IfcSurfaceStyle, _IfcPresentationStyle);

    var _super217 = _createSuper(IfcSurfaceStyle);

    function IfcSurfaceStyle(expressID, Name, Side, Styles) {
      var _this209;

      _classCallCheck2(this, IfcSurfaceStyle);

      _this209 = _super217.call(this, expressID, Name);
      _this209.Name = Name;
      _this209.Side = Side;
      _this209.Styles = Styles;
      _this209.type = 1300840506;
      return _this209;
    }

    return IfcSurfaceStyle;
  }(IfcPresentationStyle);

  IFC2X32.IfcSurfaceStyle = IfcSurfaceStyle;

  var IfcSurfaceStyleLighting = /*#__PURE__*/function (_IfcLineObject84) {
    _inherits(IfcSurfaceStyleLighting, _IfcLineObject84);

    var _super218 = _createSuper(IfcSurfaceStyleLighting);

    function IfcSurfaceStyleLighting(expressID, DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour) {
      var _this210;

      _classCallCheck2(this, IfcSurfaceStyleLighting);

      _this210 = _super218.call(this, expressID);
      _this210.DiffuseTransmissionColour = DiffuseTransmissionColour;
      _this210.DiffuseReflectionColour = DiffuseReflectionColour;
      _this210.TransmissionColour = TransmissionColour;
      _this210.ReflectanceColour = ReflectanceColour;
      _this210.type = 3303107099;
      return _this210;
    }

    return IfcSurfaceStyleLighting;
  }(IfcLineObject);

  IFC2X32.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;

  var IfcSurfaceStyleRefraction = /*#__PURE__*/function (_IfcLineObject85) {
    _inherits(IfcSurfaceStyleRefraction, _IfcLineObject85);

    var _super219 = _createSuper(IfcSurfaceStyleRefraction);

    function IfcSurfaceStyleRefraction(expressID, RefractionIndex, DispersionFactor) {
      var _this211;

      _classCallCheck2(this, IfcSurfaceStyleRefraction);

      _this211 = _super219.call(this, expressID);
      _this211.RefractionIndex = RefractionIndex;
      _this211.DispersionFactor = DispersionFactor;
      _this211.type = 1607154358;
      return _this211;
    }

    return IfcSurfaceStyleRefraction;
  }(IfcLineObject);

  IFC2X32.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;

  var IfcSurfaceStyleShading = /*#__PURE__*/function (_IfcLineObject86) {
    _inherits(IfcSurfaceStyleShading, _IfcLineObject86);

    var _super220 = _createSuper(IfcSurfaceStyleShading);

    function IfcSurfaceStyleShading(expressID, SurfaceColour) {
      var _this212;

      _classCallCheck2(this, IfcSurfaceStyleShading);

      _this212 = _super220.call(this, expressID);
      _this212.SurfaceColour = SurfaceColour;
      _this212.type = 846575682;
      return _this212;
    }

    return IfcSurfaceStyleShading;
  }(IfcLineObject);

  IFC2X32.IfcSurfaceStyleShading = IfcSurfaceStyleShading;

  var IfcSurfaceStyleWithTextures = /*#__PURE__*/function (_IfcLineObject87) {
    _inherits(IfcSurfaceStyleWithTextures, _IfcLineObject87);

    var _super221 = _createSuper(IfcSurfaceStyleWithTextures);

    function IfcSurfaceStyleWithTextures(expressID, Textures) {
      var _this213;

      _classCallCheck2(this, IfcSurfaceStyleWithTextures);

      _this213 = _super221.call(this, expressID);
      _this213.Textures = Textures;
      _this213.type = 1351298697;
      return _this213;
    }

    return IfcSurfaceStyleWithTextures;
  }(IfcLineObject);

  IFC2X32.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;

  var IfcSurfaceTexture = /*#__PURE__*/function (_IfcLineObject88) {
    _inherits(IfcSurfaceTexture, _IfcLineObject88);

    var _super222 = _createSuper(IfcSurfaceTexture);

    function IfcSurfaceTexture(expressID, RepeatS, RepeatT, TextureType, TextureTransform) {
      var _this214;

      _classCallCheck2(this, IfcSurfaceTexture);

      _this214 = _super222.call(this, expressID);
      _this214.RepeatS = RepeatS;
      _this214.RepeatT = RepeatT;
      _this214.TextureType = TextureType;
      _this214.TextureTransform = TextureTransform;
      _this214.type = 626085974;
      return _this214;
    }

    return IfcSurfaceTexture;
  }(IfcLineObject);

  IFC2X32.IfcSurfaceTexture = IfcSurfaceTexture;

  var IfcSymbolStyle = /*#__PURE__*/function (_IfcPresentationStyle2) {
    _inherits(IfcSymbolStyle, _IfcPresentationStyle2);

    var _super223 = _createSuper(IfcSymbolStyle);

    function IfcSymbolStyle(expressID, Name, StyleOfSymbol) {
      var _this215;

      _classCallCheck2(this, IfcSymbolStyle);

      _this215 = _super223.call(this, expressID, Name);
      _this215.Name = Name;
      _this215.StyleOfSymbol = StyleOfSymbol;
      _this215.type = 1290481447;
      return _this215;
    }

    return IfcSymbolStyle;
  }(IfcPresentationStyle);

  IFC2X32.IfcSymbolStyle = IfcSymbolStyle;

  var IfcTable = /*#__PURE__*/function (_IfcLineObject89) {
    _inherits(IfcTable, _IfcLineObject89);

    var _super224 = _createSuper(IfcTable);

    function IfcTable(expressID, Name, Rows) {
      var _this216;

      _classCallCheck2(this, IfcTable);

      _this216 = _super224.call(this, expressID);
      _this216.Name = Name;
      _this216.Rows = Rows;
      _this216.type = 985171141;
      return _this216;
    }

    return IfcTable;
  }(IfcLineObject);

  IFC2X32.IfcTable = IfcTable;

  var IfcTableRow = /*#__PURE__*/function (_IfcLineObject90) {
    _inherits(IfcTableRow, _IfcLineObject90);

    var _super225 = _createSuper(IfcTableRow);

    function IfcTableRow(expressID, RowCells, IsHeading) {
      var _this217;

      _classCallCheck2(this, IfcTableRow);

      _this217 = _super225.call(this, expressID);
      _this217.RowCells = RowCells;
      _this217.IsHeading = IsHeading;
      _this217.type = 531007025;
      return _this217;
    }

    return IfcTableRow;
  }(IfcLineObject);

  IFC2X32.IfcTableRow = IfcTableRow;

  var IfcTelecomAddress = /*#__PURE__*/function (_IfcAddress2) {
    _inherits(IfcTelecomAddress, _IfcAddress2);

    var _super226 = _createSuper(IfcTelecomAddress);

    function IfcTelecomAddress(expressID, Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL) {
      var _this218;

      _classCallCheck2(this, IfcTelecomAddress);

      _this218 = _super226.call(this, expressID, Purpose, Description, UserDefinedPurpose);
      _this218.Purpose = Purpose;
      _this218.Description = Description;
      _this218.UserDefinedPurpose = UserDefinedPurpose;
      _this218.TelephoneNumbers = TelephoneNumbers;
      _this218.FacsimileNumbers = FacsimileNumbers;
      _this218.PagerNumber = PagerNumber;
      _this218.ElectronicMailAddresses = ElectronicMailAddresses;
      _this218.WWWHomePageURL = WWWHomePageURL;
      _this218.type = 912023232;
      return _this218;
    }

    return IfcTelecomAddress;
  }(IfcAddress);

  IFC2X32.IfcTelecomAddress = IfcTelecomAddress;

  var IfcTextStyle = /*#__PURE__*/function (_IfcPresentationStyle3) {
    _inherits(IfcTextStyle, _IfcPresentationStyle3);

    var _super227 = _createSuper(IfcTextStyle);

    function IfcTextStyle(expressID, Name, TextCharacterAppearance, TextStyle, TextFontStyle) {
      var _this219;

      _classCallCheck2(this, IfcTextStyle);

      _this219 = _super227.call(this, expressID, Name);
      _this219.Name = Name;
      _this219.TextCharacterAppearance = TextCharacterAppearance;
      _this219.TextStyle = TextStyle;
      _this219.TextFontStyle = TextFontStyle;
      _this219.type = 1447204868;
      return _this219;
    }

    return IfcTextStyle;
  }(IfcPresentationStyle);

  IFC2X32.IfcTextStyle = IfcTextStyle;

  var IfcTextStyleFontModel = /*#__PURE__*/function (_IfcPreDefinedTextFon) {
    _inherits(IfcTextStyleFontModel, _IfcPreDefinedTextFon);

    var _super228 = _createSuper(IfcTextStyleFontModel);

    function IfcTextStyleFontModel(expressID, Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize) {
      var _this220;

      _classCallCheck2(this, IfcTextStyleFontModel);

      _this220 = _super228.call(this, expressID, Name);
      _this220.Name = Name;
      _this220.FontFamily = FontFamily;
      _this220.FontStyle = FontStyle;
      _this220.FontVariant = FontVariant;
      _this220.FontWeight = FontWeight;
      _this220.FontSize = FontSize;
      _this220.type = 1983826977;
      return _this220;
    }

    return IfcTextStyleFontModel;
  }(IfcPreDefinedTextFont);

  IFC2X32.IfcTextStyleFontModel = IfcTextStyleFontModel;

  var IfcTextStyleForDefinedFont = /*#__PURE__*/function (_IfcLineObject91) {
    _inherits(IfcTextStyleForDefinedFont, _IfcLineObject91);

    var _super229 = _createSuper(IfcTextStyleForDefinedFont);

    function IfcTextStyleForDefinedFont(expressID, Colour, BackgroundColour) {
      var _this221;

      _classCallCheck2(this, IfcTextStyleForDefinedFont);

      _this221 = _super229.call(this, expressID);
      _this221.Colour = Colour;
      _this221.BackgroundColour = BackgroundColour;
      _this221.type = 2636378356;
      return _this221;
    }

    return IfcTextStyleForDefinedFont;
  }(IfcLineObject);

  IFC2X32.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;

  var IfcTextStyleTextModel = /*#__PURE__*/function (_IfcLineObject92) {
    _inherits(IfcTextStyleTextModel, _IfcLineObject92);

    var _super230 = _createSuper(IfcTextStyleTextModel);

    function IfcTextStyleTextModel(expressID, TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight) {
      var _this222;

      _classCallCheck2(this, IfcTextStyleTextModel);

      _this222 = _super230.call(this, expressID);
      _this222.TextIndent = TextIndent;
      _this222.TextAlign = TextAlign;
      _this222.TextDecoration = TextDecoration;
      _this222.LetterSpacing = LetterSpacing;
      _this222.WordSpacing = WordSpacing;
      _this222.TextTransform = TextTransform;
      _this222.LineHeight = LineHeight;
      _this222.type = 1640371178;
      return _this222;
    }

    return IfcTextStyleTextModel;
  }(IfcLineObject);

  IFC2X32.IfcTextStyleTextModel = IfcTextStyleTextModel;

  var IfcTextStyleWithBoxCharacteristics = /*#__PURE__*/function (_IfcLineObject93) {
    _inherits(IfcTextStyleWithBoxCharacteristics, _IfcLineObject93);

    var _super231 = _createSuper(IfcTextStyleWithBoxCharacteristics);

    function IfcTextStyleWithBoxCharacteristics(expressID, BoxHeight, BoxWidth, BoxSlantAngle, BoxRotateAngle, CharacterSpacing) {
      var _this223;

      _classCallCheck2(this, IfcTextStyleWithBoxCharacteristics);

      _this223 = _super231.call(this, expressID);
      _this223.BoxHeight = BoxHeight;
      _this223.BoxWidth = BoxWidth;
      _this223.BoxSlantAngle = BoxSlantAngle;
      _this223.BoxRotateAngle = BoxRotateAngle;
      _this223.CharacterSpacing = CharacterSpacing;
      _this223.type = 1484833681;
      return _this223;
    }

    return IfcTextStyleWithBoxCharacteristics;
  }(IfcLineObject);

  IFC2X32.IfcTextStyleWithBoxCharacteristics = IfcTextStyleWithBoxCharacteristics;

  var IfcTextureCoordinate = /*#__PURE__*/function (_IfcLineObject94) {
    _inherits(IfcTextureCoordinate, _IfcLineObject94);

    var _super232 = _createSuper(IfcTextureCoordinate);

    function IfcTextureCoordinate(expressID) {
      var _this224;

      _classCallCheck2(this, IfcTextureCoordinate);

      _this224 = _super232.call(this, expressID);
      _this224.type = 280115917;
      return _this224;
    }

    return IfcTextureCoordinate;
  }(IfcLineObject);

  IFC2X32.IfcTextureCoordinate = IfcTextureCoordinate;

  var IfcTextureCoordinateGenerator = /*#__PURE__*/function (_IfcTextureCoordinate) {
    _inherits(IfcTextureCoordinateGenerator, _IfcTextureCoordinate);

    var _super233 = _createSuper(IfcTextureCoordinateGenerator);

    function IfcTextureCoordinateGenerator(expressID, Mode, Parameter) {
      var _this225;

      _classCallCheck2(this, IfcTextureCoordinateGenerator);

      _this225 = _super233.call(this, expressID);
      _this225.Mode = Mode;
      _this225.Parameter = Parameter;
      _this225.type = 1742049831;
      return _this225;
    }

    return IfcTextureCoordinateGenerator;
  }(IfcTextureCoordinate);

  IFC2X32.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;

  var IfcTextureMap = /*#__PURE__*/function (_IfcTextureCoordinate2) {
    _inherits(IfcTextureMap, _IfcTextureCoordinate2);

    var _super234 = _createSuper(IfcTextureMap);

    function IfcTextureMap(expressID, TextureMaps) {
      var _this226;

      _classCallCheck2(this, IfcTextureMap);

      _this226 = _super234.call(this, expressID);
      _this226.TextureMaps = TextureMaps;
      _this226.type = 2552916305;
      return _this226;
    }

    return IfcTextureMap;
  }(IfcTextureCoordinate);

  IFC2X32.IfcTextureMap = IfcTextureMap;

  var IfcTextureVertex = /*#__PURE__*/function (_IfcLineObject95) {
    _inherits(IfcTextureVertex, _IfcLineObject95);

    var _super235 = _createSuper(IfcTextureVertex);

    function IfcTextureVertex(expressID, Coordinates) {
      var _this227;

      _classCallCheck2(this, IfcTextureVertex);

      _this227 = _super235.call(this, expressID);
      _this227.Coordinates = Coordinates;
      _this227.type = 1210645708;
      return _this227;
    }

    return IfcTextureVertex;
  }(IfcLineObject);

  IFC2X32.IfcTextureVertex = IfcTextureVertex;

  var IfcThermalMaterialProperties = /*#__PURE__*/function (_IfcMaterialPropertie4) {
    _inherits(IfcThermalMaterialProperties, _IfcMaterialPropertie4);

    var _super236 = _createSuper(IfcThermalMaterialProperties);

    function IfcThermalMaterialProperties(expressID, Material, SpecificHeatCapacity, BoilingPoint, FreezingPoint, ThermalConductivity) {
      var _this228;

      _classCallCheck2(this, IfcThermalMaterialProperties);

      _this228 = _super236.call(this, expressID, Material);
      _this228.Material = Material;
      _this228.SpecificHeatCapacity = SpecificHeatCapacity;
      _this228.BoilingPoint = BoilingPoint;
      _this228.FreezingPoint = FreezingPoint;
      _this228.ThermalConductivity = ThermalConductivity;
      _this228.type = 3317419933;
      return _this228;
    }

    return IfcThermalMaterialProperties;
  }(IfcMaterialProperties);

  IFC2X32.IfcThermalMaterialProperties = IfcThermalMaterialProperties;

  var IfcTimeSeries = /*#__PURE__*/function (_IfcLineObject96) {
    _inherits(IfcTimeSeries, _IfcLineObject96);

    var _super237 = _createSuper(IfcTimeSeries);

    function IfcTimeSeries(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit) {
      var _this229;

      _classCallCheck2(this, IfcTimeSeries);

      _this229 = _super237.call(this, expressID);
      _this229.Name = Name;
      _this229.Description = Description;
      _this229.StartTime = StartTime;
      _this229.EndTime = EndTime;
      _this229.TimeSeriesDataType = TimeSeriesDataType;
      _this229.DataOrigin = DataOrigin;
      _this229.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this229.Unit = Unit;
      _this229.type = 3101149627;
      return _this229;
    }

    return IfcTimeSeries;
  }(IfcLineObject);

  IFC2X32.IfcTimeSeries = IfcTimeSeries;

  var IfcTimeSeriesReferenceRelationship = /*#__PURE__*/function (_IfcLineObject97) {
    _inherits(IfcTimeSeriesReferenceRelationship, _IfcLineObject97);

    var _super238 = _createSuper(IfcTimeSeriesReferenceRelationship);

    function IfcTimeSeriesReferenceRelationship(expressID, ReferencedTimeSeries, TimeSeriesReferences) {
      var _this230;

      _classCallCheck2(this, IfcTimeSeriesReferenceRelationship);

      _this230 = _super238.call(this, expressID);
      _this230.ReferencedTimeSeries = ReferencedTimeSeries;
      _this230.TimeSeriesReferences = TimeSeriesReferences;
      _this230.type = 1718945513;
      return _this230;
    }

    return IfcTimeSeriesReferenceRelationship;
  }(IfcLineObject);

  IFC2X32.IfcTimeSeriesReferenceRelationship = IfcTimeSeriesReferenceRelationship;

  var IfcTimeSeriesValue = /*#__PURE__*/function (_IfcLineObject98) {
    _inherits(IfcTimeSeriesValue, _IfcLineObject98);

    var _super239 = _createSuper(IfcTimeSeriesValue);

    function IfcTimeSeriesValue(expressID, ListValues) {
      var _this231;

      _classCallCheck2(this, IfcTimeSeriesValue);

      _this231 = _super239.call(this, expressID);
      _this231.ListValues = ListValues;
      _this231.type = 581633288;
      return _this231;
    }

    return IfcTimeSeriesValue;
  }(IfcLineObject);

  IFC2X32.IfcTimeSeriesValue = IfcTimeSeriesValue;

  var IfcTopologicalRepresentationItem = /*#__PURE__*/function (_IfcRepresentationIte2) {
    _inherits(IfcTopologicalRepresentationItem, _IfcRepresentationIte2);

    var _super240 = _createSuper(IfcTopologicalRepresentationItem);

    function IfcTopologicalRepresentationItem(expressID) {
      var _this232;

      _classCallCheck2(this, IfcTopologicalRepresentationItem);

      _this232 = _super240.call(this, expressID);
      _this232.type = 1377556343;
      return _this232;
    }

    return IfcTopologicalRepresentationItem;
  }(IfcRepresentationItem);

  IFC2X32.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;

  var IfcTopologyRepresentation = /*#__PURE__*/function (_IfcShapeModel2) {
    _inherits(IfcTopologyRepresentation, _IfcShapeModel2);

    var _super241 = _createSuper(IfcTopologyRepresentation);

    function IfcTopologyRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this233;

      _classCallCheck2(this, IfcTopologyRepresentation);

      _this233 = _super241.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this233.ContextOfItems = ContextOfItems;
      _this233.RepresentationIdentifier = RepresentationIdentifier;
      _this233.RepresentationType = RepresentationType;
      _this233.Items = Items;
      _this233.type = 1735638870;
      return _this233;
    }

    return IfcTopologyRepresentation;
  }(IfcShapeModel);

  IFC2X32.IfcTopologyRepresentation = IfcTopologyRepresentation;

  var IfcUnitAssignment = /*#__PURE__*/function (_IfcLineObject99) {
    _inherits(IfcUnitAssignment, _IfcLineObject99);

    var _super242 = _createSuper(IfcUnitAssignment);

    function IfcUnitAssignment(expressID, Units) {
      var _this234;

      _classCallCheck2(this, IfcUnitAssignment);

      _this234 = _super242.call(this, expressID);
      _this234.Units = Units;
      _this234.type = 180925521;
      return _this234;
    }

    return IfcUnitAssignment;
  }(IfcLineObject);

  IFC2X32.IfcUnitAssignment = IfcUnitAssignment;

  var IfcVertex = /*#__PURE__*/function (_IfcTopologicalRepres) {
    _inherits(IfcVertex, _IfcTopologicalRepres);

    var _super243 = _createSuper(IfcVertex);

    function IfcVertex(expressID) {
      var _this235;

      _classCallCheck2(this, IfcVertex);

      _this235 = _super243.call(this, expressID);
      _this235.type = 2799835756;
      return _this235;
    }

    return IfcVertex;
  }(IfcTopologicalRepresentationItem);

  IFC2X32.IfcVertex = IfcVertex;

  var IfcVertexBasedTextureMap = /*#__PURE__*/function (_IfcLineObject100) {
    _inherits(IfcVertexBasedTextureMap, _IfcLineObject100);

    var _super244 = _createSuper(IfcVertexBasedTextureMap);

    function IfcVertexBasedTextureMap(expressID, TextureVertices, TexturePoints) {
      var _this236;

      _classCallCheck2(this, IfcVertexBasedTextureMap);

      _this236 = _super244.call(this, expressID);
      _this236.TextureVertices = TextureVertices;
      _this236.TexturePoints = TexturePoints;
      _this236.type = 3304826586;
      return _this236;
    }

    return IfcVertexBasedTextureMap;
  }(IfcLineObject);

  IFC2X32.IfcVertexBasedTextureMap = IfcVertexBasedTextureMap;

  var IfcVertexPoint = /*#__PURE__*/function (_IfcVertex) {
    _inherits(IfcVertexPoint, _IfcVertex);

    var _super245 = _createSuper(IfcVertexPoint);

    function IfcVertexPoint(expressID, VertexGeometry) {
      var _this237;

      _classCallCheck2(this, IfcVertexPoint);

      _this237 = _super245.call(this, expressID);
      _this237.VertexGeometry = VertexGeometry;
      _this237.type = 1907098498;
      return _this237;
    }

    return IfcVertexPoint;
  }(IfcVertex);

  IFC2X32.IfcVertexPoint = IfcVertexPoint;

  var IfcVirtualGridIntersection = /*#__PURE__*/function (_IfcLineObject101) {
    _inherits(IfcVirtualGridIntersection, _IfcLineObject101);

    var _super246 = _createSuper(IfcVirtualGridIntersection);

    function IfcVirtualGridIntersection(expressID, IntersectingAxes, OffsetDistances) {
      var _this238;

      _classCallCheck2(this, IfcVirtualGridIntersection);

      _this238 = _super246.call(this, expressID);
      _this238.IntersectingAxes = IntersectingAxes;
      _this238.OffsetDistances = OffsetDistances;
      _this238.type = 891718957;
      return _this238;
    }

    return IfcVirtualGridIntersection;
  }(IfcLineObject);

  IFC2X32.IfcVirtualGridIntersection = IfcVirtualGridIntersection;

  var IfcWaterProperties = /*#__PURE__*/function (_IfcMaterialPropertie5) {
    _inherits(IfcWaterProperties, _IfcMaterialPropertie5);

    var _super247 = _createSuper(IfcWaterProperties);

    function IfcWaterProperties(expressID, Material, IsPotable, Hardness, AlkalinityConcentration, AcidityConcentration, ImpuritiesContent, PHLevel, DissolvedSolidsContent) {
      var _this239;

      _classCallCheck2(this, IfcWaterProperties);

      _this239 = _super247.call(this, expressID, Material);
      _this239.Material = Material;
      _this239.IsPotable = IsPotable;
      _this239.Hardness = Hardness;
      _this239.AlkalinityConcentration = AlkalinityConcentration;
      _this239.AcidityConcentration = AcidityConcentration;
      _this239.ImpuritiesContent = ImpuritiesContent;
      _this239.PHLevel = PHLevel;
      _this239.DissolvedSolidsContent = DissolvedSolidsContent;
      _this239.type = 1065908215;
      return _this239;
    }

    return IfcWaterProperties;
  }(IfcMaterialProperties);

  IFC2X32.IfcWaterProperties = IfcWaterProperties;

  var IfcAnnotationOccurrence = /*#__PURE__*/function (_IfcStyledItem) {
    _inherits(IfcAnnotationOccurrence, _IfcStyledItem);

    var _super248 = _createSuper(IfcAnnotationOccurrence);

    function IfcAnnotationOccurrence(expressID, Item, Styles, Name) {
      var _this240;

      _classCallCheck2(this, IfcAnnotationOccurrence);

      _this240 = _super248.call(this, expressID, Item, Styles, Name);
      _this240.Item = Item;
      _this240.Styles = Styles;
      _this240.Name = Name;
      _this240.type = 2442683028;
      return _this240;
    }

    return IfcAnnotationOccurrence;
  }(IfcStyledItem);

  IFC2X32.IfcAnnotationOccurrence = IfcAnnotationOccurrence;

  var IfcAnnotationSurfaceOccurrence = /*#__PURE__*/function (_IfcAnnotationOccurre) {
    _inherits(IfcAnnotationSurfaceOccurrence, _IfcAnnotationOccurre);

    var _super249 = _createSuper(IfcAnnotationSurfaceOccurrence);

    function IfcAnnotationSurfaceOccurrence(expressID, Item, Styles, Name) {
      var _this241;

      _classCallCheck2(this, IfcAnnotationSurfaceOccurrence);

      _this241 = _super249.call(this, expressID, Item, Styles, Name);
      _this241.Item = Item;
      _this241.Styles = Styles;
      _this241.Name = Name;
      _this241.type = 962685235;
      return _this241;
    }

    return IfcAnnotationSurfaceOccurrence;
  }(IfcAnnotationOccurrence);

  IFC2X32.IfcAnnotationSurfaceOccurrence = IfcAnnotationSurfaceOccurrence;

  var IfcAnnotationSymbolOccurrence = /*#__PURE__*/function (_IfcAnnotationOccurre2) {
    _inherits(IfcAnnotationSymbolOccurrence, _IfcAnnotationOccurre2);

    var _super250 = _createSuper(IfcAnnotationSymbolOccurrence);

    function IfcAnnotationSymbolOccurrence(expressID, Item, Styles, Name) {
      var _this242;

      _classCallCheck2(this, IfcAnnotationSymbolOccurrence);

      _this242 = _super250.call(this, expressID, Item, Styles, Name);
      _this242.Item = Item;
      _this242.Styles = Styles;
      _this242.Name = Name;
      _this242.type = 3612888222;
      return _this242;
    }

    return IfcAnnotationSymbolOccurrence;
  }(IfcAnnotationOccurrence);

  IFC2X32.IfcAnnotationSymbolOccurrence = IfcAnnotationSymbolOccurrence;

  var IfcAnnotationTextOccurrence = /*#__PURE__*/function (_IfcAnnotationOccurre3) {
    _inherits(IfcAnnotationTextOccurrence, _IfcAnnotationOccurre3);

    var _super251 = _createSuper(IfcAnnotationTextOccurrence);

    function IfcAnnotationTextOccurrence(expressID, Item, Styles, Name) {
      var _this243;

      _classCallCheck2(this, IfcAnnotationTextOccurrence);

      _this243 = _super251.call(this, expressID, Item, Styles, Name);
      _this243.Item = Item;
      _this243.Styles = Styles;
      _this243.Name = Name;
      _this243.type = 2297822566;
      return _this243;
    }

    return IfcAnnotationTextOccurrence;
  }(IfcAnnotationOccurrence);

  IFC2X32.IfcAnnotationTextOccurrence = IfcAnnotationTextOccurrence;

  var IfcArbitraryClosedProfileDef = /*#__PURE__*/function (_IfcProfileDef) {
    _inherits(IfcArbitraryClosedProfileDef, _IfcProfileDef);

    var _super252 = _createSuper(IfcArbitraryClosedProfileDef);

    function IfcArbitraryClosedProfileDef(expressID, ProfileType, ProfileName, OuterCurve) {
      var _this244;

      _classCallCheck2(this, IfcArbitraryClosedProfileDef);

      _this244 = _super252.call(this, expressID, ProfileType, ProfileName);
      _this244.ProfileType = ProfileType;
      _this244.ProfileName = ProfileName;
      _this244.OuterCurve = OuterCurve;
      _this244.type = 3798115385;
      return _this244;
    }

    return IfcArbitraryClosedProfileDef;
  }(IfcProfileDef);

  IFC2X32.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;

  var IfcArbitraryOpenProfileDef = /*#__PURE__*/function (_IfcProfileDef2) {
    _inherits(IfcArbitraryOpenProfileDef, _IfcProfileDef2);

    var _super253 = _createSuper(IfcArbitraryOpenProfileDef);

    function IfcArbitraryOpenProfileDef(expressID, ProfileType, ProfileName, Curve) {
      var _this245;

      _classCallCheck2(this, IfcArbitraryOpenProfileDef);

      _this245 = _super253.call(this, expressID, ProfileType, ProfileName);
      _this245.ProfileType = ProfileType;
      _this245.ProfileName = ProfileName;
      _this245.Curve = Curve;
      _this245.type = 1310608509;
      return _this245;
    }

    return IfcArbitraryOpenProfileDef;
  }(IfcProfileDef);

  IFC2X32.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;

  var IfcArbitraryProfileDefWithVoids = /*#__PURE__*/function (_IfcArbitraryClosedPr) {
    _inherits(IfcArbitraryProfileDefWithVoids, _IfcArbitraryClosedPr);

    var _super254 = _createSuper(IfcArbitraryProfileDefWithVoids);

    function IfcArbitraryProfileDefWithVoids(expressID, ProfileType, ProfileName, OuterCurve, InnerCurves) {
      var _this246;

      _classCallCheck2(this, IfcArbitraryProfileDefWithVoids);

      _this246 = _super254.call(this, expressID, ProfileType, ProfileName, OuterCurve);
      _this246.ProfileType = ProfileType;
      _this246.ProfileName = ProfileName;
      _this246.OuterCurve = OuterCurve;
      _this246.InnerCurves = InnerCurves;
      _this246.type = 2705031697;
      return _this246;
    }

    return IfcArbitraryProfileDefWithVoids;
  }(IfcArbitraryClosedProfileDef);

  IFC2X32.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;

  var IfcBlobTexture = /*#__PURE__*/function (_IfcSurfaceTexture) {
    _inherits(IfcBlobTexture, _IfcSurfaceTexture);

    var _super255 = _createSuper(IfcBlobTexture);

    function IfcBlobTexture(expressID, RepeatS, RepeatT, TextureType, TextureTransform, RasterFormat, RasterCode) {
      var _this247;

      _classCallCheck2(this, IfcBlobTexture);

      _this247 = _super255.call(this, expressID, RepeatS, RepeatT, TextureType, TextureTransform);
      _this247.RepeatS = RepeatS;
      _this247.RepeatT = RepeatT;
      _this247.TextureType = TextureType;
      _this247.TextureTransform = TextureTransform;
      _this247.RasterFormat = RasterFormat;
      _this247.RasterCode = RasterCode;
      _this247.type = 616511568;
      return _this247;
    }

    return IfcBlobTexture;
  }(IfcSurfaceTexture);

  IFC2X32.IfcBlobTexture = IfcBlobTexture;

  var IfcCenterLineProfileDef = /*#__PURE__*/function (_IfcArbitraryOpenProf) {
    _inherits(IfcCenterLineProfileDef, _IfcArbitraryOpenProf);

    var _super256 = _createSuper(IfcCenterLineProfileDef);

    function IfcCenterLineProfileDef(expressID, ProfileType, ProfileName, Curve, Thickness) {
      var _this248;

      _classCallCheck2(this, IfcCenterLineProfileDef);

      _this248 = _super256.call(this, expressID, ProfileType, ProfileName, Curve);
      _this248.ProfileType = ProfileType;
      _this248.ProfileName = ProfileName;
      _this248.Curve = Curve;
      _this248.Thickness = Thickness;
      _this248.type = 3150382593;
      return _this248;
    }

    return IfcCenterLineProfileDef;
  }(IfcArbitraryOpenProfileDef);

  IFC2X32.IfcCenterLineProfileDef = IfcCenterLineProfileDef;

  var IfcClassificationReference = /*#__PURE__*/function (_IfcExternalReference6) {
    _inherits(IfcClassificationReference, _IfcExternalReference6);

    var _super257 = _createSuper(IfcClassificationReference);

    function IfcClassificationReference(expressID, Location, ItemReference, Name, ReferencedSource) {
      var _this249;

      _classCallCheck2(this, IfcClassificationReference);

      _this249 = _super257.call(this, expressID, Location, ItemReference, Name);
      _this249.Location = Location;
      _this249.ItemReference = ItemReference;
      _this249.Name = Name;
      _this249.ReferencedSource = ReferencedSource;
      _this249.type = 647927063;
      return _this249;
    }

    return IfcClassificationReference;
  }(IfcExternalReference);

  IFC2X32.IfcClassificationReference = IfcClassificationReference;

  var IfcColourRgb = /*#__PURE__*/function (_IfcColourSpecificati) {
    _inherits(IfcColourRgb, _IfcColourSpecificati);

    var _super258 = _createSuper(IfcColourRgb);

    function IfcColourRgb(expressID, Name, Red, Green, Blue) {
      var _this250;

      _classCallCheck2(this, IfcColourRgb);

      _this250 = _super258.call(this, expressID, Name);
      _this250.Name = Name;
      _this250.Red = Red;
      _this250.Green = Green;
      _this250.Blue = Blue;
      _this250.type = 776857604;
      return _this250;
    }

    return IfcColourRgb;
  }(IfcColourSpecification);

  IFC2X32.IfcColourRgb = IfcColourRgb;

  var IfcComplexProperty = /*#__PURE__*/function (_IfcProperty2) {
    _inherits(IfcComplexProperty, _IfcProperty2);

    var _super259 = _createSuper(IfcComplexProperty);

    function IfcComplexProperty(expressID, Name, Description, UsageName, HasProperties) {
      var _this251;

      _classCallCheck2(this, IfcComplexProperty);

      _this251 = _super259.call(this, expressID, Name, Description);
      _this251.Name = Name;
      _this251.Description = Description;
      _this251.UsageName = UsageName;
      _this251.HasProperties = HasProperties;
      _this251.type = 2542286263;
      return _this251;
    }

    return IfcComplexProperty;
  }(IfcProperty);

  IFC2X32.IfcComplexProperty = IfcComplexProperty;

  var IfcCompositeProfileDef = /*#__PURE__*/function (_IfcProfileDef3) {
    _inherits(IfcCompositeProfileDef, _IfcProfileDef3);

    var _super260 = _createSuper(IfcCompositeProfileDef);

    function IfcCompositeProfileDef(expressID, ProfileType, ProfileName, Profiles, Label) {
      var _this252;

      _classCallCheck2(this, IfcCompositeProfileDef);

      _this252 = _super260.call(this, expressID, ProfileType, ProfileName);
      _this252.ProfileType = ProfileType;
      _this252.ProfileName = ProfileName;
      _this252.Profiles = Profiles;
      _this252.Label = Label;
      _this252.type = 1485152156;
      return _this252;
    }

    return IfcCompositeProfileDef;
  }(IfcProfileDef);

  IFC2X32.IfcCompositeProfileDef = IfcCompositeProfileDef;

  var IfcConnectedFaceSet = /*#__PURE__*/function (_IfcTopologicalRepres2) {
    _inherits(IfcConnectedFaceSet, _IfcTopologicalRepres2);

    var _super261 = _createSuper(IfcConnectedFaceSet);

    function IfcConnectedFaceSet(expressID, CfsFaces) {
      var _this253;

      _classCallCheck2(this, IfcConnectedFaceSet);

      _this253 = _super261.call(this, expressID);
      _this253.CfsFaces = CfsFaces;
      _this253.type = 370225590;
      return _this253;
    }

    return IfcConnectedFaceSet;
  }(IfcTopologicalRepresentationItem);

  IFC2X32.IfcConnectedFaceSet = IfcConnectedFaceSet;

  var IfcConnectionCurveGeometry = /*#__PURE__*/function (_IfcConnectionGeometr4) {
    _inherits(IfcConnectionCurveGeometry, _IfcConnectionGeometr4);

    var _super262 = _createSuper(IfcConnectionCurveGeometry);

    function IfcConnectionCurveGeometry(expressID, CurveOnRelatingElement, CurveOnRelatedElement) {
      var _this254;

      _classCallCheck2(this, IfcConnectionCurveGeometry);

      _this254 = _super262.call(this, expressID);
      _this254.CurveOnRelatingElement = CurveOnRelatingElement;
      _this254.CurveOnRelatedElement = CurveOnRelatedElement;
      _this254.type = 1981873012;
      return _this254;
    }

    return IfcConnectionCurveGeometry;
  }(IfcConnectionGeometry);

  IFC2X32.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;

  var IfcConnectionPointEccentricity = /*#__PURE__*/function (_IfcConnectionPointGe) {
    _inherits(IfcConnectionPointEccentricity, _IfcConnectionPointGe);

    var _super263 = _createSuper(IfcConnectionPointEccentricity);

    function IfcConnectionPointEccentricity(expressID, PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ) {
      var _this255;

      _classCallCheck2(this, IfcConnectionPointEccentricity);

      _this255 = _super263.call(this, expressID, PointOnRelatingElement, PointOnRelatedElement);
      _this255.PointOnRelatingElement = PointOnRelatingElement;
      _this255.PointOnRelatedElement = PointOnRelatedElement;
      _this255.EccentricityInX = EccentricityInX;
      _this255.EccentricityInY = EccentricityInY;
      _this255.EccentricityInZ = EccentricityInZ;
      _this255.type = 45288368;
      return _this255;
    }

    return IfcConnectionPointEccentricity;
  }(IfcConnectionPointGeometry);

  IFC2X32.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;

  var IfcContextDependentUnit = /*#__PURE__*/function (_IfcNamedUnit2) {
    _inherits(IfcContextDependentUnit, _IfcNamedUnit2);

    var _super264 = _createSuper(IfcContextDependentUnit);

    function IfcContextDependentUnit(expressID, Dimensions, UnitType, Name) {
      var _this256;

      _classCallCheck2(this, IfcContextDependentUnit);

      _this256 = _super264.call(this, expressID, Dimensions, UnitType);
      _this256.Dimensions = Dimensions;
      _this256.UnitType = UnitType;
      _this256.Name = Name;
      _this256.type = 3050246964;
      return _this256;
    }

    return IfcContextDependentUnit;
  }(IfcNamedUnit);

  IFC2X32.IfcContextDependentUnit = IfcContextDependentUnit;

  var IfcConversionBasedUnit = /*#__PURE__*/function (_IfcNamedUnit3) {
    _inherits(IfcConversionBasedUnit, _IfcNamedUnit3);

    var _super265 = _createSuper(IfcConversionBasedUnit);

    function IfcConversionBasedUnit(expressID, Dimensions, UnitType, Name, ConversionFactor) {
      var _this257;

      _classCallCheck2(this, IfcConversionBasedUnit);

      _this257 = _super265.call(this, expressID, Dimensions, UnitType);
      _this257.Dimensions = Dimensions;
      _this257.UnitType = UnitType;
      _this257.Name = Name;
      _this257.ConversionFactor = ConversionFactor;
      _this257.type = 2889183280;
      return _this257;
    }

    return IfcConversionBasedUnit;
  }(IfcNamedUnit);

  IFC2X32.IfcConversionBasedUnit = IfcConversionBasedUnit;

  var IfcCurveStyle = /*#__PURE__*/function (_IfcPresentationStyle4) {
    _inherits(IfcCurveStyle, _IfcPresentationStyle4);

    var _super266 = _createSuper(IfcCurveStyle);

    function IfcCurveStyle(expressID, Name, CurveFont, CurveWidth, CurveColour) {
      var _this258;

      _classCallCheck2(this, IfcCurveStyle);

      _this258 = _super266.call(this, expressID, Name);
      _this258.Name = Name;
      _this258.CurveFont = CurveFont;
      _this258.CurveWidth = CurveWidth;
      _this258.CurveColour = CurveColour;
      _this258.type = 3800577675;
      return _this258;
    }

    return IfcCurveStyle;
  }(IfcPresentationStyle);

  IFC2X32.IfcCurveStyle = IfcCurveStyle;

  var IfcDerivedProfileDef = /*#__PURE__*/function (_IfcProfileDef4) {
    _inherits(IfcDerivedProfileDef, _IfcProfileDef4);

    var _super267 = _createSuper(IfcDerivedProfileDef);

    function IfcDerivedProfileDef(expressID, ProfileType, ProfileName, ParentProfile, Operator, Label) {
      var _this259;

      _classCallCheck2(this, IfcDerivedProfileDef);

      _this259 = _super267.call(this, expressID, ProfileType, ProfileName);
      _this259.ProfileType = ProfileType;
      _this259.ProfileName = ProfileName;
      _this259.ParentProfile = ParentProfile;
      _this259.Operator = Operator;
      _this259.Label = Label;
      _this259.type = 3632507154;
      return _this259;
    }

    return IfcDerivedProfileDef;
  }(IfcProfileDef);

  IFC2X32.IfcDerivedProfileDef = IfcDerivedProfileDef;

  var IfcDimensionCalloutRelationship = /*#__PURE__*/function (_IfcDraughtingCallout) {
    _inherits(IfcDimensionCalloutRelationship, _IfcDraughtingCallout);

    var _super268 = _createSuper(IfcDimensionCalloutRelationship);

    function IfcDimensionCalloutRelationship(expressID, Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout) {
      var _this260;

      _classCallCheck2(this, IfcDimensionCalloutRelationship);

      _this260 = _super268.call(this, expressID, Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout);
      _this260.Name = Name;
      _this260.Description = Description;
      _this260.RelatingDraughtingCallout = RelatingDraughtingCallout;
      _this260.RelatedDraughtingCallout = RelatedDraughtingCallout;
      _this260.type = 2273265877;
      return _this260;
    }

    return IfcDimensionCalloutRelationship;
  }(IfcDraughtingCalloutRelationship);

  IFC2X32.IfcDimensionCalloutRelationship = IfcDimensionCalloutRelationship;

  var IfcDimensionPair = /*#__PURE__*/function (_IfcDraughtingCallout2) {
    _inherits(IfcDimensionPair, _IfcDraughtingCallout2);

    var _super269 = _createSuper(IfcDimensionPair);

    function IfcDimensionPair(expressID, Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout) {
      var _this261;

      _classCallCheck2(this, IfcDimensionPair);

      _this261 = _super269.call(this, expressID, Name, Description, RelatingDraughtingCallout, RelatedDraughtingCallout);
      _this261.Name = Name;
      _this261.Description = Description;
      _this261.RelatingDraughtingCallout = RelatingDraughtingCallout;
      _this261.RelatedDraughtingCallout = RelatedDraughtingCallout;
      _this261.type = 1694125774;
      return _this261;
    }

    return IfcDimensionPair;
  }(IfcDraughtingCalloutRelationship);

  IFC2X32.IfcDimensionPair = IfcDimensionPair;

  var IfcDocumentReference = /*#__PURE__*/function (_IfcExternalReference7) {
    _inherits(IfcDocumentReference, _IfcExternalReference7);

    var _super270 = _createSuper(IfcDocumentReference);

    function IfcDocumentReference(expressID, Location, ItemReference, Name) {
      var _this262;

      _classCallCheck2(this, IfcDocumentReference);

      _this262 = _super270.call(this, expressID, Location, ItemReference, Name);
      _this262.Location = Location;
      _this262.ItemReference = ItemReference;
      _this262.Name = Name;
      _this262.type = 3732053477;
      return _this262;
    }

    return IfcDocumentReference;
  }(IfcExternalReference);

  IFC2X32.IfcDocumentReference = IfcDocumentReference;

  var IfcDraughtingPreDefinedTextFont = /*#__PURE__*/function (_IfcPreDefinedTextFon2) {
    _inherits(IfcDraughtingPreDefinedTextFont, _IfcPreDefinedTextFon2);

    var _super271 = _createSuper(IfcDraughtingPreDefinedTextFont);

    function IfcDraughtingPreDefinedTextFont(expressID, Name) {
      var _this263;

      _classCallCheck2(this, IfcDraughtingPreDefinedTextFont);

      _this263 = _super271.call(this, expressID, Name);
      _this263.Name = Name;
      _this263.type = 4170525392;
      return _this263;
    }

    return IfcDraughtingPreDefinedTextFont;
  }(IfcPreDefinedTextFont);

  IFC2X32.IfcDraughtingPreDefinedTextFont = IfcDraughtingPreDefinedTextFont;

  var IfcEdge = /*#__PURE__*/function (_IfcTopologicalRepres3) {
    _inherits(IfcEdge, _IfcTopologicalRepres3);

    var _super272 = _createSuper(IfcEdge);

    function IfcEdge(expressID, EdgeStart, EdgeEnd) {
      var _this264;

      _classCallCheck2(this, IfcEdge);

      _this264 = _super272.call(this, expressID);
      _this264.EdgeStart = EdgeStart;
      _this264.EdgeEnd = EdgeEnd;
      _this264.type = 3900360178;
      return _this264;
    }

    return IfcEdge;
  }(IfcTopologicalRepresentationItem);

  IFC2X32.IfcEdge = IfcEdge;

  var IfcEdgeCurve = /*#__PURE__*/function (_IfcEdge) {
    _inherits(IfcEdgeCurve, _IfcEdge);

    var _super273 = _createSuper(IfcEdgeCurve);

    function IfcEdgeCurve(expressID, EdgeStart, EdgeEnd, EdgeGeometry, SameSense) {
      var _this265;

      _classCallCheck2(this, IfcEdgeCurve);

      _this265 = _super273.call(this, expressID, EdgeStart, EdgeEnd);
      _this265.EdgeStart = EdgeStart;
      _this265.EdgeEnd = EdgeEnd;
      _this265.EdgeGeometry = EdgeGeometry;
      _this265.SameSense = SameSense;
      _this265.type = 476780140;
      return _this265;
    }

    return IfcEdgeCurve;
  }(IfcEdge);

  IFC2X32.IfcEdgeCurve = IfcEdgeCurve;

  var IfcExtendedMaterialProperties = /*#__PURE__*/function (_IfcMaterialPropertie6) {
    _inherits(IfcExtendedMaterialProperties, _IfcMaterialPropertie6);

    var _super274 = _createSuper(IfcExtendedMaterialProperties);

    function IfcExtendedMaterialProperties(expressID, Material, ExtendedProperties, Description, Name) {
      var _this266;

      _classCallCheck2(this, IfcExtendedMaterialProperties);

      _this266 = _super274.call(this, expressID, Material);
      _this266.Material = Material;
      _this266.ExtendedProperties = ExtendedProperties;
      _this266.Description = Description;
      _this266.Name = Name;
      _this266.type = 1860660968;
      return _this266;
    }

    return IfcExtendedMaterialProperties;
  }(IfcMaterialProperties);

  IFC2X32.IfcExtendedMaterialProperties = IfcExtendedMaterialProperties;

  var IfcFace = /*#__PURE__*/function (_IfcTopologicalRepres4) {
    _inherits(IfcFace, _IfcTopologicalRepres4);

    var _super275 = _createSuper(IfcFace);

    function IfcFace(expressID, Bounds) {
      var _this267;

      _classCallCheck2(this, IfcFace);

      _this267 = _super275.call(this, expressID);
      _this267.Bounds = Bounds;
      _this267.type = 2556980723;
      return _this267;
    }

    return IfcFace;
  }(IfcTopologicalRepresentationItem);

  IFC2X32.IfcFace = IfcFace;

  var IfcFaceBound = /*#__PURE__*/function (_IfcTopologicalRepres5) {
    _inherits(IfcFaceBound, _IfcTopologicalRepres5);

    var _super276 = _createSuper(IfcFaceBound);

    function IfcFaceBound(expressID, Bound, Orientation) {
      var _this268;

      _classCallCheck2(this, IfcFaceBound);

      _this268 = _super276.call(this, expressID);
      _this268.Bound = Bound;
      _this268.Orientation = Orientation;
      _this268.type = 1809719519;
      return _this268;
    }

    return IfcFaceBound;
  }(IfcTopologicalRepresentationItem);

  IFC2X32.IfcFaceBound = IfcFaceBound;

  var IfcFaceOuterBound = /*#__PURE__*/function (_IfcFaceBound) {
    _inherits(IfcFaceOuterBound, _IfcFaceBound);

    var _super277 = _createSuper(IfcFaceOuterBound);

    function IfcFaceOuterBound(expressID, Bound, Orientation) {
      var _this269;

      _classCallCheck2(this, IfcFaceOuterBound);

      _this269 = _super277.call(this, expressID, Bound, Orientation);
      _this269.Bound = Bound;
      _this269.Orientation = Orientation;
      _this269.type = 803316827;
      return _this269;
    }

    return IfcFaceOuterBound;
  }(IfcFaceBound);

  IFC2X32.IfcFaceOuterBound = IfcFaceOuterBound;

  var IfcFaceSurface = /*#__PURE__*/function (_IfcFace) {
    _inherits(IfcFaceSurface, _IfcFace);

    var _super278 = _createSuper(IfcFaceSurface);

    function IfcFaceSurface(expressID, Bounds, FaceSurface, SameSense) {
      var _this270;

      _classCallCheck2(this, IfcFaceSurface);

      _this270 = _super278.call(this, expressID, Bounds);
      _this270.Bounds = Bounds;
      _this270.FaceSurface = FaceSurface;
      _this270.SameSense = SameSense;
      _this270.type = 3008276851;
      return _this270;
    }

    return IfcFaceSurface;
  }(IfcFace);

  IFC2X32.IfcFaceSurface = IfcFaceSurface;

  var IfcFailureConnectionCondition = /*#__PURE__*/function (_IfcStructuralConnect) {
    _inherits(IfcFailureConnectionCondition, _IfcStructuralConnect);

    var _super279 = _createSuper(IfcFailureConnectionCondition);

    function IfcFailureConnectionCondition(expressID, Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ) {
      var _this271;

      _classCallCheck2(this, IfcFailureConnectionCondition);

      _this271 = _super279.call(this, expressID, Name);
      _this271.Name = Name;
      _this271.TensionFailureX = TensionFailureX;
      _this271.TensionFailureY = TensionFailureY;
      _this271.TensionFailureZ = TensionFailureZ;
      _this271.CompressionFailureX = CompressionFailureX;
      _this271.CompressionFailureY = CompressionFailureY;
      _this271.CompressionFailureZ = CompressionFailureZ;
      _this271.type = 4219587988;
      return _this271;
    }

    return IfcFailureConnectionCondition;
  }(IfcStructuralConnectionCondition);

  IFC2X32.IfcFailureConnectionCondition = IfcFailureConnectionCondition;

  var IfcFillAreaStyle = /*#__PURE__*/function (_IfcPresentationStyle5) {
    _inherits(IfcFillAreaStyle, _IfcPresentationStyle5);

    var _super280 = _createSuper(IfcFillAreaStyle);

    function IfcFillAreaStyle(expressID, Name, FillStyles) {
      var _this272;

      _classCallCheck2(this, IfcFillAreaStyle);

      _this272 = _super280.call(this, expressID, Name);
      _this272.Name = Name;
      _this272.FillStyles = FillStyles;
      _this272.type = 738692330;
      return _this272;
    }

    return IfcFillAreaStyle;
  }(IfcPresentationStyle);

  IFC2X32.IfcFillAreaStyle = IfcFillAreaStyle;

  var IfcFuelProperties = /*#__PURE__*/function (_IfcMaterialPropertie7) {
    _inherits(IfcFuelProperties, _IfcMaterialPropertie7);

    var _super281 = _createSuper(IfcFuelProperties);

    function IfcFuelProperties(expressID, Material, CombustionTemperature, CarbonContent, LowerHeatingValue, HigherHeatingValue) {
      var _this273;

      _classCallCheck2(this, IfcFuelProperties);

      _this273 = _super281.call(this, expressID, Material);
      _this273.Material = Material;
      _this273.CombustionTemperature = CombustionTemperature;
      _this273.CarbonContent = CarbonContent;
      _this273.LowerHeatingValue = LowerHeatingValue;
      _this273.HigherHeatingValue = HigherHeatingValue;
      _this273.type = 3857492461;
      return _this273;
    }

    return IfcFuelProperties;
  }(IfcMaterialProperties);

  IFC2X32.IfcFuelProperties = IfcFuelProperties;

  var IfcGeneralMaterialProperties = /*#__PURE__*/function (_IfcMaterialPropertie8) {
    _inherits(IfcGeneralMaterialProperties, _IfcMaterialPropertie8);

    var _super282 = _createSuper(IfcGeneralMaterialProperties);

    function IfcGeneralMaterialProperties(expressID, Material, MolecularWeight, Porosity, MassDensity) {
      var _this274;

      _classCallCheck2(this, IfcGeneralMaterialProperties);

      _this274 = _super282.call(this, expressID, Material);
      _this274.Material = Material;
      _this274.MolecularWeight = MolecularWeight;
      _this274.Porosity = Porosity;
      _this274.MassDensity = MassDensity;
      _this274.type = 803998398;
      return _this274;
    }

    return IfcGeneralMaterialProperties;
  }(IfcMaterialProperties);

  IFC2X32.IfcGeneralMaterialProperties = IfcGeneralMaterialProperties;

  var IfcGeneralProfileProperties = /*#__PURE__*/function (_IfcProfileProperties2) {
    _inherits(IfcGeneralProfileProperties, _IfcProfileProperties2);

    var _super283 = _createSuper(IfcGeneralProfileProperties);

    function IfcGeneralProfileProperties(expressID, ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea) {
      var _this275;

      _classCallCheck2(this, IfcGeneralProfileProperties);

      _this275 = _super283.call(this, expressID, ProfileName, ProfileDefinition);
      _this275.ProfileName = ProfileName;
      _this275.ProfileDefinition = ProfileDefinition;
      _this275.PhysicalWeight = PhysicalWeight;
      _this275.Perimeter = Perimeter;
      _this275.MinimumPlateThickness = MinimumPlateThickness;
      _this275.MaximumPlateThickness = MaximumPlateThickness;
      _this275.CrossSectionArea = CrossSectionArea;
      _this275.type = 1446786286;
      return _this275;
    }

    return IfcGeneralProfileProperties;
  }(IfcProfileProperties);

  IFC2X32.IfcGeneralProfileProperties = IfcGeneralProfileProperties;

  var IfcGeometricRepresentationContext = /*#__PURE__*/function (_IfcRepresentationCon) {
    _inherits(IfcGeometricRepresentationContext, _IfcRepresentationCon);

    var _super284 = _createSuper(IfcGeometricRepresentationContext);

    function IfcGeometricRepresentationContext(expressID, ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth) {
      var _this276;

      _classCallCheck2(this, IfcGeometricRepresentationContext);

      _this276 = _super284.call(this, expressID, ContextIdentifier, ContextType);
      _this276.ContextIdentifier = ContextIdentifier;
      _this276.ContextType = ContextType;
      _this276.CoordinateSpaceDimension = CoordinateSpaceDimension;
      _this276.Precision = Precision;
      _this276.WorldCoordinateSystem = WorldCoordinateSystem;
      _this276.TrueNorth = TrueNorth;
      _this276.type = 3448662350;
      return _this276;
    }

    return IfcGeometricRepresentationContext;
  }(IfcRepresentationContext);

  IFC2X32.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;

  var IfcGeometricRepresentationItem = /*#__PURE__*/function (_IfcRepresentationIte3) {
    _inherits(IfcGeometricRepresentationItem, _IfcRepresentationIte3);

    var _super285 = _createSuper(IfcGeometricRepresentationItem);

    function IfcGeometricRepresentationItem(expressID) {
      var _this277;

      _classCallCheck2(this, IfcGeometricRepresentationItem);

      _this277 = _super285.call(this, expressID);
      _this277.type = 2453401579;
      return _this277;
    }

    return IfcGeometricRepresentationItem;
  }(IfcRepresentationItem);

  IFC2X32.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;

  var IfcGeometricRepresentationSubContext = /*#__PURE__*/function (_IfcGeometricRepresen) {
    _inherits(IfcGeometricRepresentationSubContext, _IfcGeometricRepresen);

    var _super286 = _createSuper(IfcGeometricRepresentationSubContext);

    function IfcGeometricRepresentationSubContext(expressID, ContextIdentifier, ContextType, ParentContext, TargetScale, TargetView, UserDefinedTargetView) {
      var _this278;

      _classCallCheck2(this, IfcGeometricRepresentationSubContext);

      _this278 = _super286.call(this, expressID, ContextIdentifier, ContextType, new IfcDimensionCount(0), null, new Handle(0), null);
      _this278.ContextIdentifier = ContextIdentifier;
      _this278.ContextType = ContextType;
      _this278.ParentContext = ParentContext;
      _this278.TargetScale = TargetScale;
      _this278.TargetView = TargetView;
      _this278.UserDefinedTargetView = UserDefinedTargetView;
      _this278.type = 4142052618;
      return _this278;
    }

    return IfcGeometricRepresentationSubContext;
  }(IfcGeometricRepresentationContext);

  IFC2X32.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;

  var IfcGeometricSet = /*#__PURE__*/function (_IfcGeometricRepresen2) {
    _inherits(IfcGeometricSet, _IfcGeometricRepresen2);

    var _super287 = _createSuper(IfcGeometricSet);

    function IfcGeometricSet(expressID, Elements) {
      var _this279;

      _classCallCheck2(this, IfcGeometricSet);

      _this279 = _super287.call(this, expressID);
      _this279.Elements = Elements;
      _this279.type = 3590301190;
      return _this279;
    }

    return IfcGeometricSet;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcGeometricSet = IfcGeometricSet;

  var IfcGridPlacement = /*#__PURE__*/function (_IfcObjectPlacement) {
    _inherits(IfcGridPlacement, _IfcObjectPlacement);

    var _super288 = _createSuper(IfcGridPlacement);

    function IfcGridPlacement(expressID, PlacementLocation, PlacementRefDirection) {
      var _this280;

      _classCallCheck2(this, IfcGridPlacement);

      _this280 = _super288.call(this, expressID);
      _this280.PlacementLocation = PlacementLocation;
      _this280.PlacementRefDirection = PlacementRefDirection;
      _this280.type = 178086475;
      return _this280;
    }

    return IfcGridPlacement;
  }(IfcObjectPlacement);

  IFC2X32.IfcGridPlacement = IfcGridPlacement;

  var IfcHalfSpaceSolid = /*#__PURE__*/function (_IfcGeometricRepresen3) {
    _inherits(IfcHalfSpaceSolid, _IfcGeometricRepresen3);

    var _super289 = _createSuper(IfcHalfSpaceSolid);

    function IfcHalfSpaceSolid(expressID, BaseSurface, AgreementFlag) {
      var _this281;

      _classCallCheck2(this, IfcHalfSpaceSolid);

      _this281 = _super289.call(this, expressID);
      _this281.BaseSurface = BaseSurface;
      _this281.AgreementFlag = AgreementFlag;
      _this281.type = 812098782;
      return _this281;
    }

    return IfcHalfSpaceSolid;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcHalfSpaceSolid = IfcHalfSpaceSolid;

  var IfcHygroscopicMaterialProperties = /*#__PURE__*/function (_IfcMaterialPropertie9) {
    _inherits(IfcHygroscopicMaterialProperties, _IfcMaterialPropertie9);

    var _super290 = _createSuper(IfcHygroscopicMaterialProperties);

    function IfcHygroscopicMaterialProperties(expressID, Material, UpperVaporResistanceFactor, LowerVaporResistanceFactor, IsothermalMoistureCapacity, VaporPermeability, MoistureDiffusivity) {
      var _this282;

      _classCallCheck2(this, IfcHygroscopicMaterialProperties);

      _this282 = _super290.call(this, expressID, Material);
      _this282.Material = Material;
      _this282.UpperVaporResistanceFactor = UpperVaporResistanceFactor;
      _this282.LowerVaporResistanceFactor = LowerVaporResistanceFactor;
      _this282.IsothermalMoistureCapacity = IsothermalMoistureCapacity;
      _this282.VaporPermeability = VaporPermeability;
      _this282.MoistureDiffusivity = MoistureDiffusivity;
      _this282.type = 2445078500;
      return _this282;
    }

    return IfcHygroscopicMaterialProperties;
  }(IfcMaterialProperties);

  IFC2X32.IfcHygroscopicMaterialProperties = IfcHygroscopicMaterialProperties;

  var IfcImageTexture = /*#__PURE__*/function (_IfcSurfaceTexture2) {
    _inherits(IfcImageTexture, _IfcSurfaceTexture2);

    var _super291 = _createSuper(IfcImageTexture);

    function IfcImageTexture(expressID, RepeatS, RepeatT, TextureType, TextureTransform, UrlReference) {
      var _this283;

      _classCallCheck2(this, IfcImageTexture);

      _this283 = _super291.call(this, expressID, RepeatS, RepeatT, TextureType, TextureTransform);
      _this283.RepeatS = RepeatS;
      _this283.RepeatT = RepeatT;
      _this283.TextureType = TextureType;
      _this283.TextureTransform = TextureTransform;
      _this283.UrlReference = UrlReference;
      _this283.type = 3905492369;
      return _this283;
    }

    return IfcImageTexture;
  }(IfcSurfaceTexture);

  IFC2X32.IfcImageTexture = IfcImageTexture;

  var IfcIrregularTimeSeries = /*#__PURE__*/function (_IfcTimeSeries) {
    _inherits(IfcIrregularTimeSeries, _IfcTimeSeries);

    var _super292 = _createSuper(IfcIrregularTimeSeries);

    function IfcIrregularTimeSeries(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values) {
      var _this284;

      _classCallCheck2(this, IfcIrregularTimeSeries);

      _this284 = _super292.call(this, expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      _this284.Name = Name;
      _this284.Description = Description;
      _this284.StartTime = StartTime;
      _this284.EndTime = EndTime;
      _this284.TimeSeriesDataType = TimeSeriesDataType;
      _this284.DataOrigin = DataOrigin;
      _this284.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this284.Unit = Unit;
      _this284.Values = Values;
      _this284.type = 3741457305;
      return _this284;
    }

    return IfcIrregularTimeSeries;
  }(IfcTimeSeries);

  IFC2X32.IfcIrregularTimeSeries = IfcIrregularTimeSeries;

  var IfcLightSource = /*#__PURE__*/function (_IfcGeometricRepresen4) {
    _inherits(IfcLightSource, _IfcGeometricRepresen4);

    var _super293 = _createSuper(IfcLightSource);

    function IfcLightSource(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      var _this285;

      _classCallCheck2(this, IfcLightSource);

      _this285 = _super293.call(this, expressID);
      _this285.Name = Name;
      _this285.LightColour = LightColour;
      _this285.AmbientIntensity = AmbientIntensity;
      _this285.Intensity = Intensity;
      _this285.type = 1402838566;
      return _this285;
    }

    return IfcLightSource;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcLightSource = IfcLightSource;

  var IfcLightSourceAmbient = /*#__PURE__*/function (_IfcLightSource) {
    _inherits(IfcLightSourceAmbient, _IfcLightSource);

    var _super294 = _createSuper(IfcLightSourceAmbient);

    function IfcLightSourceAmbient(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      var _this286;

      _classCallCheck2(this, IfcLightSourceAmbient);

      _this286 = _super294.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this286.Name = Name;
      _this286.LightColour = LightColour;
      _this286.AmbientIntensity = AmbientIntensity;
      _this286.Intensity = Intensity;
      _this286.type = 125510826;
      return _this286;
    }

    return IfcLightSourceAmbient;
  }(IfcLightSource);

  IFC2X32.IfcLightSourceAmbient = IfcLightSourceAmbient;

  var IfcLightSourceDirectional = /*#__PURE__*/function (_IfcLightSource2) {
    _inherits(IfcLightSourceDirectional, _IfcLightSource2);

    var _super295 = _createSuper(IfcLightSourceDirectional);

    function IfcLightSourceDirectional(expressID, Name, LightColour, AmbientIntensity, Intensity, Orientation) {
      var _this287;

      _classCallCheck2(this, IfcLightSourceDirectional);

      _this287 = _super295.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this287.Name = Name;
      _this287.LightColour = LightColour;
      _this287.AmbientIntensity = AmbientIntensity;
      _this287.Intensity = Intensity;
      _this287.Orientation = Orientation;
      _this287.type = 2604431987;
      return _this287;
    }

    return IfcLightSourceDirectional;
  }(IfcLightSource);

  IFC2X32.IfcLightSourceDirectional = IfcLightSourceDirectional;

  var IfcLightSourceGoniometric = /*#__PURE__*/function (_IfcLightSource3) {
    _inherits(IfcLightSourceGoniometric, _IfcLightSource3);

    var _super296 = _createSuper(IfcLightSourceGoniometric);

    function IfcLightSourceGoniometric(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource) {
      var _this288;

      _classCallCheck2(this, IfcLightSourceGoniometric);

      _this288 = _super296.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this288.Name = Name;
      _this288.LightColour = LightColour;
      _this288.AmbientIntensity = AmbientIntensity;
      _this288.Intensity = Intensity;
      _this288.Position = Position;
      _this288.ColourAppearance = ColourAppearance;
      _this288.ColourTemperature = ColourTemperature;
      _this288.LuminousFlux = LuminousFlux;
      _this288.LightEmissionSource = LightEmissionSource;
      _this288.LightDistributionDataSource = LightDistributionDataSource;
      _this288.type = 4266656042;
      return _this288;
    }

    return IfcLightSourceGoniometric;
  }(IfcLightSource);

  IFC2X32.IfcLightSourceGoniometric = IfcLightSourceGoniometric;

  var IfcLightSourcePositional = /*#__PURE__*/function (_IfcLightSource4) {
    _inherits(IfcLightSourcePositional, _IfcLightSource4);

    var _super297 = _createSuper(IfcLightSourcePositional);

    function IfcLightSourcePositional(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation) {
      var _this289;

      _classCallCheck2(this, IfcLightSourcePositional);

      _this289 = _super297.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this289.Name = Name;
      _this289.LightColour = LightColour;
      _this289.AmbientIntensity = AmbientIntensity;
      _this289.Intensity = Intensity;
      _this289.Position = Position;
      _this289.Radius = Radius;
      _this289.ConstantAttenuation = ConstantAttenuation;
      _this289.DistanceAttenuation = DistanceAttenuation;
      _this289.QuadricAttenuation = QuadricAttenuation;
      _this289.type = 1520743889;
      return _this289;
    }

    return IfcLightSourcePositional;
  }(IfcLightSource);

  IFC2X32.IfcLightSourcePositional = IfcLightSourcePositional;

  var IfcLightSourceSpot = /*#__PURE__*/function (_IfcLightSourcePositi) {
    _inherits(IfcLightSourceSpot, _IfcLightSourcePositi);

    var _super298 = _createSuper(IfcLightSourceSpot);

    function IfcLightSourceSpot(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle) {
      var _this290;

      _classCallCheck2(this, IfcLightSourceSpot);

      _this290 = _super298.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
      _this290.Name = Name;
      _this290.LightColour = LightColour;
      _this290.AmbientIntensity = AmbientIntensity;
      _this290.Intensity = Intensity;
      _this290.Position = Position;
      _this290.Radius = Radius;
      _this290.ConstantAttenuation = ConstantAttenuation;
      _this290.DistanceAttenuation = DistanceAttenuation;
      _this290.QuadricAttenuation = QuadricAttenuation;
      _this290.Orientation = Orientation;
      _this290.ConcentrationExponent = ConcentrationExponent;
      _this290.SpreadAngle = SpreadAngle;
      _this290.BeamWidthAngle = BeamWidthAngle;
      _this290.type = 3422422726;
      return _this290;
    }

    return IfcLightSourceSpot;
  }(IfcLightSourcePositional);

  IFC2X32.IfcLightSourceSpot = IfcLightSourceSpot;

  var IfcLocalPlacement = /*#__PURE__*/function (_IfcObjectPlacement2) {
    _inherits(IfcLocalPlacement, _IfcObjectPlacement2);

    var _super299 = _createSuper(IfcLocalPlacement);

    function IfcLocalPlacement(expressID, PlacementRelTo, RelativePlacement) {
      var _this291;

      _classCallCheck2(this, IfcLocalPlacement);

      _this291 = _super299.call(this, expressID);
      _this291.PlacementRelTo = PlacementRelTo;
      _this291.RelativePlacement = RelativePlacement;
      _this291.type = 2624227202;
      return _this291;
    }

    return IfcLocalPlacement;
  }(IfcObjectPlacement);

  IFC2X32.IfcLocalPlacement = IfcLocalPlacement;

  var IfcLoop = /*#__PURE__*/function (_IfcTopologicalRepres6) {
    _inherits(IfcLoop, _IfcTopologicalRepres6);

    var _super300 = _createSuper(IfcLoop);

    function IfcLoop(expressID) {
      var _this292;

      _classCallCheck2(this, IfcLoop);

      _this292 = _super300.call(this, expressID);
      _this292.type = 1008929658;
      return _this292;
    }

    return IfcLoop;
  }(IfcTopologicalRepresentationItem);

  IFC2X32.IfcLoop = IfcLoop;

  var IfcMappedItem = /*#__PURE__*/function (_IfcRepresentationIte4) {
    _inherits(IfcMappedItem, _IfcRepresentationIte4);

    var _super301 = _createSuper(IfcMappedItem);

    function IfcMappedItem(expressID, MappingSource, MappingTarget) {
      var _this293;

      _classCallCheck2(this, IfcMappedItem);

      _this293 = _super301.call(this, expressID);
      _this293.MappingSource = MappingSource;
      _this293.MappingTarget = MappingTarget;
      _this293.type = 2347385850;
      return _this293;
    }

    return IfcMappedItem;
  }(IfcRepresentationItem);

  IFC2X32.IfcMappedItem = IfcMappedItem;

  var IfcMaterialDefinitionRepresentation = /*#__PURE__*/function (_IfcProductRepresenta) {
    _inherits(IfcMaterialDefinitionRepresentation, _IfcProductRepresenta);

    var _super302 = _createSuper(IfcMaterialDefinitionRepresentation);

    function IfcMaterialDefinitionRepresentation(expressID, Name, Description, Representations, RepresentedMaterial) {
      var _this294;

      _classCallCheck2(this, IfcMaterialDefinitionRepresentation);

      _this294 = _super302.call(this, expressID, Name, Description, Representations);
      _this294.Name = Name;
      _this294.Description = Description;
      _this294.Representations = Representations;
      _this294.RepresentedMaterial = RepresentedMaterial;
      _this294.type = 2022407955;
      return _this294;
    }

    return IfcMaterialDefinitionRepresentation;
  }(IfcProductRepresentation);

  IFC2X32.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;

  var IfcMechanicalConcreteMaterialProperties = /*#__PURE__*/function (_IfcMechanicalMateria2) {
    _inherits(IfcMechanicalConcreteMaterialProperties, _IfcMechanicalMateria2);

    var _super303 = _createSuper(IfcMechanicalConcreteMaterialProperties);

    function IfcMechanicalConcreteMaterialProperties(expressID, Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient, CompressiveStrength, MaxAggregateSize, AdmixturesDescription, Workability, ProtectivePoreRatio, WaterImpermeability) {
      var _this295;

      _classCallCheck2(this, IfcMechanicalConcreteMaterialProperties);

      _this295 = _super303.call(this, expressID, Material, DynamicViscosity, YoungModulus, ShearModulus, PoissonRatio, ThermalExpansionCoefficient);
      _this295.Material = Material;
      _this295.DynamicViscosity = DynamicViscosity;
      _this295.YoungModulus = YoungModulus;
      _this295.ShearModulus = ShearModulus;
      _this295.PoissonRatio = PoissonRatio;
      _this295.ThermalExpansionCoefficient = ThermalExpansionCoefficient;
      _this295.CompressiveStrength = CompressiveStrength;
      _this295.MaxAggregateSize = MaxAggregateSize;
      _this295.AdmixturesDescription = AdmixturesDescription;
      _this295.Workability = Workability;
      _this295.ProtectivePoreRatio = ProtectivePoreRatio;
      _this295.WaterImpermeability = WaterImpermeability;
      _this295.type = 1430189142;
      return _this295;
    }

    return IfcMechanicalConcreteMaterialProperties;
  }(IfcMechanicalMaterialProperties);

  IFC2X32.IfcMechanicalConcreteMaterialProperties = IfcMechanicalConcreteMaterialProperties;

  var IfcObjectDefinition = /*#__PURE__*/function (_IfcRoot) {
    _inherits(IfcObjectDefinition, _IfcRoot);

    var _super304 = _createSuper(IfcObjectDefinition);

    function IfcObjectDefinition(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this296;

      _classCallCheck2(this, IfcObjectDefinition);

      _this296 = _super304.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this296.GlobalId = GlobalId;
      _this296.OwnerHistory = OwnerHistory;
      _this296.Name = Name;
      _this296.Description = Description;
      _this296.type = 219451334;
      return _this296;
    }

    return IfcObjectDefinition;
  }(IfcRoot);

  IFC2X32.IfcObjectDefinition = IfcObjectDefinition;

  var IfcOneDirectionRepeatFactor = /*#__PURE__*/function (_IfcGeometricRepresen5) {
    _inherits(IfcOneDirectionRepeatFactor, _IfcGeometricRepresen5);

    var _super305 = _createSuper(IfcOneDirectionRepeatFactor);

    function IfcOneDirectionRepeatFactor(expressID, RepeatFactor) {
      var _this297;

      _classCallCheck2(this, IfcOneDirectionRepeatFactor);

      _this297 = _super305.call(this, expressID);
      _this297.RepeatFactor = RepeatFactor;
      _this297.type = 2833995503;
      return _this297;
    }

    return IfcOneDirectionRepeatFactor;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcOneDirectionRepeatFactor = IfcOneDirectionRepeatFactor;

  var IfcOpenShell = /*#__PURE__*/function (_IfcConnectedFaceSet) {
    _inherits(IfcOpenShell, _IfcConnectedFaceSet);

    var _super306 = _createSuper(IfcOpenShell);

    function IfcOpenShell(expressID, CfsFaces) {
      var _this298;

      _classCallCheck2(this, IfcOpenShell);

      _this298 = _super306.call(this, expressID, CfsFaces);
      _this298.CfsFaces = CfsFaces;
      _this298.type = 2665983363;
      return _this298;
    }

    return IfcOpenShell;
  }(IfcConnectedFaceSet);

  IFC2X32.IfcOpenShell = IfcOpenShell;

  var IfcOrientedEdge = /*#__PURE__*/function (_IfcEdge2) {
    _inherits(IfcOrientedEdge, _IfcEdge2);

    var _super307 = _createSuper(IfcOrientedEdge);

    function IfcOrientedEdge(expressID, EdgeElement, Orientation) {
      var _this299;

      _classCallCheck2(this, IfcOrientedEdge);

      _this299 = _super307.call(this, expressID, new Handle(0), new Handle(0));
      _this299.EdgeElement = EdgeElement;
      _this299.Orientation = Orientation;
      _this299.type = 1029017970;
      return _this299;
    }

    return IfcOrientedEdge;
  }(IfcEdge);

  IFC2X32.IfcOrientedEdge = IfcOrientedEdge;

  var IfcParameterizedProfileDef = /*#__PURE__*/function (_IfcProfileDef5) {
    _inherits(IfcParameterizedProfileDef, _IfcProfileDef5);

    var _super308 = _createSuper(IfcParameterizedProfileDef);

    function IfcParameterizedProfileDef(expressID, ProfileType, ProfileName, Position) {
      var _this300;

      _classCallCheck2(this, IfcParameterizedProfileDef);

      _this300 = _super308.call(this, expressID, ProfileType, ProfileName);
      _this300.ProfileType = ProfileType;
      _this300.ProfileName = ProfileName;
      _this300.Position = Position;
      _this300.type = 2529465313;
      return _this300;
    }

    return IfcParameterizedProfileDef;
  }(IfcProfileDef);

  IFC2X32.IfcParameterizedProfileDef = IfcParameterizedProfileDef;

  var IfcPath = /*#__PURE__*/function (_IfcTopologicalRepres7) {
    _inherits(IfcPath, _IfcTopologicalRepres7);

    var _super309 = _createSuper(IfcPath);

    function IfcPath(expressID, EdgeList) {
      var _this301;

      _classCallCheck2(this, IfcPath);

      _this301 = _super309.call(this, expressID);
      _this301.EdgeList = EdgeList;
      _this301.type = 2519244187;
      return _this301;
    }

    return IfcPath;
  }(IfcTopologicalRepresentationItem);

  IFC2X32.IfcPath = IfcPath;

  var IfcPhysicalComplexQuantity = /*#__PURE__*/function (_IfcPhysicalQuantity2) {
    _inherits(IfcPhysicalComplexQuantity, _IfcPhysicalQuantity2);

    var _super310 = _createSuper(IfcPhysicalComplexQuantity);

    function IfcPhysicalComplexQuantity(expressID, Name, Description, HasQuantities, Discrimination, Quality, Usage) {
      var _this302;

      _classCallCheck2(this, IfcPhysicalComplexQuantity);

      _this302 = _super310.call(this, expressID, Name, Description);
      _this302.Name = Name;
      _this302.Description = Description;
      _this302.HasQuantities = HasQuantities;
      _this302.Discrimination = Discrimination;
      _this302.Quality = Quality;
      _this302.Usage = Usage;
      _this302.type = 3021840470;
      return _this302;
    }

    return IfcPhysicalComplexQuantity;
  }(IfcPhysicalQuantity);

  IFC2X32.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;

  var IfcPixelTexture = /*#__PURE__*/function (_IfcSurfaceTexture3) {
    _inherits(IfcPixelTexture, _IfcSurfaceTexture3);

    var _super311 = _createSuper(IfcPixelTexture);

    function IfcPixelTexture(expressID, RepeatS, RepeatT, TextureType, TextureTransform, Width, Height, ColourComponents, Pixel) {
      var _this303;

      _classCallCheck2(this, IfcPixelTexture);

      _this303 = _super311.call(this, expressID, RepeatS, RepeatT, TextureType, TextureTransform);
      _this303.RepeatS = RepeatS;
      _this303.RepeatT = RepeatT;
      _this303.TextureType = TextureType;
      _this303.TextureTransform = TextureTransform;
      _this303.Width = Width;
      _this303.Height = Height;
      _this303.ColourComponents = ColourComponents;
      _this303.Pixel = Pixel;
      _this303.type = 597895409;
      return _this303;
    }

    return IfcPixelTexture;
  }(IfcSurfaceTexture);

  IFC2X32.IfcPixelTexture = IfcPixelTexture;

  var IfcPlacement = /*#__PURE__*/function (_IfcGeometricRepresen6) {
    _inherits(IfcPlacement, _IfcGeometricRepresen6);

    var _super312 = _createSuper(IfcPlacement);

    function IfcPlacement(expressID, Location) {
      var _this304;

      _classCallCheck2(this, IfcPlacement);

      _this304 = _super312.call(this, expressID);
      _this304.Location = Location;
      _this304.type = 2004835150;
      return _this304;
    }

    return IfcPlacement;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcPlacement = IfcPlacement;

  var IfcPlanarExtent = /*#__PURE__*/function (_IfcGeometricRepresen7) {
    _inherits(IfcPlanarExtent, _IfcGeometricRepresen7);

    var _super313 = _createSuper(IfcPlanarExtent);

    function IfcPlanarExtent(expressID, SizeInX, SizeInY) {
      var _this305;

      _classCallCheck2(this, IfcPlanarExtent);

      _this305 = _super313.call(this, expressID);
      _this305.SizeInX = SizeInX;
      _this305.SizeInY = SizeInY;
      _this305.type = 1663979128;
      return _this305;
    }

    return IfcPlanarExtent;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcPlanarExtent = IfcPlanarExtent;

  var IfcPoint = /*#__PURE__*/function (_IfcGeometricRepresen8) {
    _inherits(IfcPoint, _IfcGeometricRepresen8);

    var _super314 = _createSuper(IfcPoint);

    function IfcPoint(expressID) {
      var _this306;

      _classCallCheck2(this, IfcPoint);

      _this306 = _super314.call(this, expressID);
      _this306.type = 2067069095;
      return _this306;
    }

    return IfcPoint;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcPoint = IfcPoint;

  var IfcPointOnCurve = /*#__PURE__*/function (_IfcPoint) {
    _inherits(IfcPointOnCurve, _IfcPoint);

    var _super315 = _createSuper(IfcPointOnCurve);

    function IfcPointOnCurve(expressID, BasisCurve, PointParameter) {
      var _this307;

      _classCallCheck2(this, IfcPointOnCurve);

      _this307 = _super315.call(this, expressID);
      _this307.BasisCurve = BasisCurve;
      _this307.PointParameter = PointParameter;
      _this307.type = 4022376103;
      return _this307;
    }

    return IfcPointOnCurve;
  }(IfcPoint);

  IFC2X32.IfcPointOnCurve = IfcPointOnCurve;

  var IfcPointOnSurface = /*#__PURE__*/function (_IfcPoint2) {
    _inherits(IfcPointOnSurface, _IfcPoint2);

    var _super316 = _createSuper(IfcPointOnSurface);

    function IfcPointOnSurface(expressID, BasisSurface, PointParameterU, PointParameterV) {
      var _this308;

      _classCallCheck2(this, IfcPointOnSurface);

      _this308 = _super316.call(this, expressID);
      _this308.BasisSurface = BasisSurface;
      _this308.PointParameterU = PointParameterU;
      _this308.PointParameterV = PointParameterV;
      _this308.type = 1423911732;
      return _this308;
    }

    return IfcPointOnSurface;
  }(IfcPoint);

  IFC2X32.IfcPointOnSurface = IfcPointOnSurface;

  var IfcPolyLoop = /*#__PURE__*/function (_IfcLoop) {
    _inherits(IfcPolyLoop, _IfcLoop);

    var _super317 = _createSuper(IfcPolyLoop);

    function IfcPolyLoop(expressID, Polygon) {
      var _this309;

      _classCallCheck2(this, IfcPolyLoop);

      _this309 = _super317.call(this, expressID);
      _this309.Polygon = Polygon;
      _this309.type = 2924175390;
      return _this309;
    }

    return IfcPolyLoop;
  }(IfcLoop);

  IFC2X32.IfcPolyLoop = IfcPolyLoop;

  var IfcPolygonalBoundedHalfSpace = /*#__PURE__*/function (_IfcHalfSpaceSolid) {
    _inherits(IfcPolygonalBoundedHalfSpace, _IfcHalfSpaceSolid);

    var _super318 = _createSuper(IfcPolygonalBoundedHalfSpace);

    function IfcPolygonalBoundedHalfSpace(expressID, BaseSurface, AgreementFlag, Position, PolygonalBoundary) {
      var _this310;

      _classCallCheck2(this, IfcPolygonalBoundedHalfSpace);

      _this310 = _super318.call(this, expressID, BaseSurface, AgreementFlag);
      _this310.BaseSurface = BaseSurface;
      _this310.AgreementFlag = AgreementFlag;
      _this310.Position = Position;
      _this310.PolygonalBoundary = PolygonalBoundary;
      _this310.type = 2775532180;
      return _this310;
    }

    return IfcPolygonalBoundedHalfSpace;
  }(IfcHalfSpaceSolid);

  IFC2X32.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;

  var IfcPreDefinedColour = /*#__PURE__*/function (_IfcPreDefinedItem3) {
    _inherits(IfcPreDefinedColour, _IfcPreDefinedItem3);

    var _super319 = _createSuper(IfcPreDefinedColour);

    function IfcPreDefinedColour(expressID, Name) {
      var _this311;

      _classCallCheck2(this, IfcPreDefinedColour);

      _this311 = _super319.call(this, expressID, Name);
      _this311.Name = Name;
      _this311.type = 759155922;
      return _this311;
    }

    return IfcPreDefinedColour;
  }(IfcPreDefinedItem);

  IFC2X32.IfcPreDefinedColour = IfcPreDefinedColour;

  var IfcPreDefinedCurveFont = /*#__PURE__*/function (_IfcPreDefinedItem4) {
    _inherits(IfcPreDefinedCurveFont, _IfcPreDefinedItem4);

    var _super320 = _createSuper(IfcPreDefinedCurveFont);

    function IfcPreDefinedCurveFont(expressID, Name) {
      var _this312;

      _classCallCheck2(this, IfcPreDefinedCurveFont);

      _this312 = _super320.call(this, expressID, Name);
      _this312.Name = Name;
      _this312.type = 2559016684;
      return _this312;
    }

    return IfcPreDefinedCurveFont;
  }(IfcPreDefinedItem);

  IFC2X32.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;

  var IfcPreDefinedDimensionSymbol = /*#__PURE__*/function (_IfcPreDefinedSymbol2) {
    _inherits(IfcPreDefinedDimensionSymbol, _IfcPreDefinedSymbol2);

    var _super321 = _createSuper(IfcPreDefinedDimensionSymbol);

    function IfcPreDefinedDimensionSymbol(expressID, Name) {
      var _this313;

      _classCallCheck2(this, IfcPreDefinedDimensionSymbol);

      _this313 = _super321.call(this, expressID, Name);
      _this313.Name = Name;
      _this313.type = 433424934;
      return _this313;
    }

    return IfcPreDefinedDimensionSymbol;
  }(IfcPreDefinedSymbol);

  IFC2X32.IfcPreDefinedDimensionSymbol = IfcPreDefinedDimensionSymbol;

  var IfcPreDefinedPointMarkerSymbol = /*#__PURE__*/function (_IfcPreDefinedSymbol3) {
    _inherits(IfcPreDefinedPointMarkerSymbol, _IfcPreDefinedSymbol3);

    var _super322 = _createSuper(IfcPreDefinedPointMarkerSymbol);

    function IfcPreDefinedPointMarkerSymbol(expressID, Name) {
      var _this314;

      _classCallCheck2(this, IfcPreDefinedPointMarkerSymbol);

      _this314 = _super322.call(this, expressID, Name);
      _this314.Name = Name;
      _this314.type = 179317114;
      return _this314;
    }

    return IfcPreDefinedPointMarkerSymbol;
  }(IfcPreDefinedSymbol);

  IFC2X32.IfcPreDefinedPointMarkerSymbol = IfcPreDefinedPointMarkerSymbol;

  var IfcProductDefinitionShape = /*#__PURE__*/function (_IfcProductRepresenta2) {
    _inherits(IfcProductDefinitionShape, _IfcProductRepresenta2);

    var _super323 = _createSuper(IfcProductDefinitionShape);

    function IfcProductDefinitionShape(expressID, Name, Description, Representations) {
      var _this315;

      _classCallCheck2(this, IfcProductDefinitionShape);

      _this315 = _super323.call(this, expressID, Name, Description, Representations);
      _this315.Name = Name;
      _this315.Description = Description;
      _this315.Representations = Representations;
      _this315.type = 673634403;
      return _this315;
    }

    return IfcProductDefinitionShape;
  }(IfcProductRepresentation);

  IFC2X32.IfcProductDefinitionShape = IfcProductDefinitionShape;

  var IfcPropertyBoundedValue = /*#__PURE__*/function (_IfcSimpleProperty) {
    _inherits(IfcPropertyBoundedValue, _IfcSimpleProperty);

    var _super324 = _createSuper(IfcPropertyBoundedValue);

    function IfcPropertyBoundedValue(expressID, Name, Description, UpperBoundValue, LowerBoundValue, Unit) {
      var _this316;

      _classCallCheck2(this, IfcPropertyBoundedValue);

      _this316 = _super324.call(this, expressID, Name, Description);
      _this316.Name = Name;
      _this316.Description = Description;
      _this316.UpperBoundValue = UpperBoundValue;
      _this316.LowerBoundValue = LowerBoundValue;
      _this316.Unit = Unit;
      _this316.type = 871118103;
      return _this316;
    }

    return IfcPropertyBoundedValue;
  }(IfcSimpleProperty);

  IFC2X32.IfcPropertyBoundedValue = IfcPropertyBoundedValue;

  var IfcPropertyDefinition = /*#__PURE__*/function (_IfcRoot2) {
    _inherits(IfcPropertyDefinition, _IfcRoot2);

    var _super325 = _createSuper(IfcPropertyDefinition);

    function IfcPropertyDefinition(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this317;

      _classCallCheck2(this, IfcPropertyDefinition);

      _this317 = _super325.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this317.GlobalId = GlobalId;
      _this317.OwnerHistory = OwnerHistory;
      _this317.Name = Name;
      _this317.Description = Description;
      _this317.type = 1680319473;
      return _this317;
    }

    return IfcPropertyDefinition;
  }(IfcRoot);

  IFC2X32.IfcPropertyDefinition = IfcPropertyDefinition;

  var IfcPropertyEnumeratedValue = /*#__PURE__*/function (_IfcSimpleProperty2) {
    _inherits(IfcPropertyEnumeratedValue, _IfcSimpleProperty2);

    var _super326 = _createSuper(IfcPropertyEnumeratedValue);

    function IfcPropertyEnumeratedValue(expressID, Name, Description, EnumerationValues, EnumerationReference) {
      var _this318;

      _classCallCheck2(this, IfcPropertyEnumeratedValue);

      _this318 = _super326.call(this, expressID, Name, Description);
      _this318.Name = Name;
      _this318.Description = Description;
      _this318.EnumerationValues = EnumerationValues;
      _this318.EnumerationReference = EnumerationReference;
      _this318.type = 4166981789;
      return _this318;
    }

    return IfcPropertyEnumeratedValue;
  }(IfcSimpleProperty);

  IFC2X32.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;

  var IfcPropertyListValue = /*#__PURE__*/function (_IfcSimpleProperty3) {
    _inherits(IfcPropertyListValue, _IfcSimpleProperty3);

    var _super327 = _createSuper(IfcPropertyListValue);

    function IfcPropertyListValue(expressID, Name, Description, ListValues, Unit) {
      var _this319;

      _classCallCheck2(this, IfcPropertyListValue);

      _this319 = _super327.call(this, expressID, Name, Description);
      _this319.Name = Name;
      _this319.Description = Description;
      _this319.ListValues = ListValues;
      _this319.Unit = Unit;
      _this319.type = 2752243245;
      return _this319;
    }

    return IfcPropertyListValue;
  }(IfcSimpleProperty);

  IFC2X32.IfcPropertyListValue = IfcPropertyListValue;

  var IfcPropertyReferenceValue = /*#__PURE__*/function (_IfcSimpleProperty4) {
    _inherits(IfcPropertyReferenceValue, _IfcSimpleProperty4);

    var _super328 = _createSuper(IfcPropertyReferenceValue);

    function IfcPropertyReferenceValue(expressID, Name, Description, UsageName, PropertyReference) {
      var _this320;

      _classCallCheck2(this, IfcPropertyReferenceValue);

      _this320 = _super328.call(this, expressID, Name, Description);
      _this320.Name = Name;
      _this320.Description = Description;
      _this320.UsageName = UsageName;
      _this320.PropertyReference = PropertyReference;
      _this320.type = 941946838;
      return _this320;
    }

    return IfcPropertyReferenceValue;
  }(IfcSimpleProperty);

  IFC2X32.IfcPropertyReferenceValue = IfcPropertyReferenceValue;

  var IfcPropertySetDefinition = /*#__PURE__*/function (_IfcPropertyDefinitio) {
    _inherits(IfcPropertySetDefinition, _IfcPropertyDefinitio);

    var _super329 = _createSuper(IfcPropertySetDefinition);

    function IfcPropertySetDefinition(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this321;

      _classCallCheck2(this, IfcPropertySetDefinition);

      _this321 = _super329.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this321.GlobalId = GlobalId;
      _this321.OwnerHistory = OwnerHistory;
      _this321.Name = Name;
      _this321.Description = Description;
      _this321.type = 3357820518;
      return _this321;
    }

    return IfcPropertySetDefinition;
  }(IfcPropertyDefinition);

  IFC2X32.IfcPropertySetDefinition = IfcPropertySetDefinition;

  var IfcPropertySingleValue = /*#__PURE__*/function (_IfcSimpleProperty5) {
    _inherits(IfcPropertySingleValue, _IfcSimpleProperty5);

    var _super330 = _createSuper(IfcPropertySingleValue);

    function IfcPropertySingleValue(expressID, Name, Description, NominalValue, Unit) {
      var _this322;

      _classCallCheck2(this, IfcPropertySingleValue);

      _this322 = _super330.call(this, expressID, Name, Description);
      _this322.Name = Name;
      _this322.Description = Description;
      _this322.NominalValue = NominalValue;
      _this322.Unit = Unit;
      _this322.type = 3650150729;
      return _this322;
    }

    return IfcPropertySingleValue;
  }(IfcSimpleProperty);

  IFC2X32.IfcPropertySingleValue = IfcPropertySingleValue;

  var IfcPropertyTableValue = /*#__PURE__*/function (_IfcSimpleProperty6) {
    _inherits(IfcPropertyTableValue, _IfcSimpleProperty6);

    var _super331 = _createSuper(IfcPropertyTableValue);

    function IfcPropertyTableValue(expressID, Name, Description, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit) {
      var _this323;

      _classCallCheck2(this, IfcPropertyTableValue);

      _this323 = _super331.call(this, expressID, Name, Description);
      _this323.Name = Name;
      _this323.Description = Description;
      _this323.DefiningValues = DefiningValues;
      _this323.DefinedValues = DefinedValues;
      _this323.Expression = Expression;
      _this323.DefiningUnit = DefiningUnit;
      _this323.DefinedUnit = DefinedUnit;
      _this323.type = 110355661;
      return _this323;
    }

    return IfcPropertyTableValue;
  }(IfcSimpleProperty);

  IFC2X32.IfcPropertyTableValue = IfcPropertyTableValue;

  var IfcRectangleProfileDef = /*#__PURE__*/function (_IfcParameterizedProf) {
    _inherits(IfcRectangleProfileDef, _IfcParameterizedProf);

    var _super332 = _createSuper(IfcRectangleProfileDef);

    function IfcRectangleProfileDef(expressID, ProfileType, ProfileName, Position, XDim, YDim) {
      var _this324;

      _classCallCheck2(this, IfcRectangleProfileDef);

      _this324 = _super332.call(this, expressID, ProfileType, ProfileName, Position);
      _this324.ProfileType = ProfileType;
      _this324.ProfileName = ProfileName;
      _this324.Position = Position;
      _this324.XDim = XDim;
      _this324.YDim = YDim;
      _this324.type = 3615266464;
      return _this324;
    }

    return IfcRectangleProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcRectangleProfileDef = IfcRectangleProfileDef;

  var IfcRegularTimeSeries = /*#__PURE__*/function (_IfcTimeSeries2) {
    _inherits(IfcRegularTimeSeries, _IfcTimeSeries2);

    var _super333 = _createSuper(IfcRegularTimeSeries);

    function IfcRegularTimeSeries(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values) {
      var _this325;

      _classCallCheck2(this, IfcRegularTimeSeries);

      _this325 = _super333.call(this, expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      _this325.Name = Name;
      _this325.Description = Description;
      _this325.StartTime = StartTime;
      _this325.EndTime = EndTime;
      _this325.TimeSeriesDataType = TimeSeriesDataType;
      _this325.DataOrigin = DataOrigin;
      _this325.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this325.Unit = Unit;
      _this325.TimeStep = TimeStep;
      _this325.Values = Values;
      _this325.type = 3413951693;
      return _this325;
    }

    return IfcRegularTimeSeries;
  }(IfcTimeSeries);

  IFC2X32.IfcRegularTimeSeries = IfcRegularTimeSeries;

  var IfcReinforcementDefinitionProperties = /*#__PURE__*/function (_IfcPropertySetDefini) {
    _inherits(IfcReinforcementDefinitionProperties, _IfcPropertySetDefini);

    var _super334 = _createSuper(IfcReinforcementDefinitionProperties);

    function IfcReinforcementDefinitionProperties(expressID, GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions) {
      var _this326;

      _classCallCheck2(this, IfcReinforcementDefinitionProperties);

      _this326 = _super334.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this326.GlobalId = GlobalId;
      _this326.OwnerHistory = OwnerHistory;
      _this326.Name = Name;
      _this326.Description = Description;
      _this326.DefinitionType = DefinitionType;
      _this326.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
      _this326.type = 3765753017;
      return _this326;
    }

    return IfcReinforcementDefinitionProperties;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;

  var IfcRelationship = /*#__PURE__*/function (_IfcRoot3) {
    _inherits(IfcRelationship, _IfcRoot3);

    var _super335 = _createSuper(IfcRelationship);

    function IfcRelationship(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this327;

      _classCallCheck2(this, IfcRelationship);

      _this327 = _super335.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this327.GlobalId = GlobalId;
      _this327.OwnerHistory = OwnerHistory;
      _this327.Name = Name;
      _this327.Description = Description;
      _this327.type = 478536968;
      return _this327;
    }

    return IfcRelationship;
  }(IfcRoot);

  IFC2X32.IfcRelationship = IfcRelationship;

  var IfcRoundedRectangleProfileDef = /*#__PURE__*/function (_IfcRectangleProfileD) {
    _inherits(IfcRoundedRectangleProfileDef, _IfcRectangleProfileD);

    var _super336 = _createSuper(IfcRoundedRectangleProfileDef);

    function IfcRoundedRectangleProfileDef(expressID, ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius) {
      var _this328;

      _classCallCheck2(this, IfcRoundedRectangleProfileDef);

      _this328 = _super336.call(this, expressID, ProfileType, ProfileName, Position, XDim, YDim);
      _this328.ProfileType = ProfileType;
      _this328.ProfileName = ProfileName;
      _this328.Position = Position;
      _this328.XDim = XDim;
      _this328.YDim = YDim;
      _this328.RoundingRadius = RoundingRadius;
      _this328.type = 2778083089;
      return _this328;
    }

    return IfcRoundedRectangleProfileDef;
  }(IfcRectangleProfileDef);

  IFC2X32.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;

  var IfcSectionedSpine = /*#__PURE__*/function (_IfcGeometricRepresen9) {
    _inherits(IfcSectionedSpine, _IfcGeometricRepresen9);

    var _super337 = _createSuper(IfcSectionedSpine);

    function IfcSectionedSpine(expressID, SpineCurve, CrossSections, CrossSectionPositions) {
      var _this329;

      _classCallCheck2(this, IfcSectionedSpine);

      _this329 = _super337.call(this, expressID);
      _this329.SpineCurve = SpineCurve;
      _this329.CrossSections = CrossSections;
      _this329.CrossSectionPositions = CrossSectionPositions;
      _this329.type = 1509187699;
      return _this329;
    }

    return IfcSectionedSpine;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcSectionedSpine = IfcSectionedSpine;

  var IfcServiceLifeFactor = /*#__PURE__*/function (_IfcPropertySetDefini2) {
    _inherits(IfcServiceLifeFactor, _IfcPropertySetDefini2);

    var _super338 = _createSuper(IfcServiceLifeFactor);

    function IfcServiceLifeFactor(expressID, GlobalId, OwnerHistory, Name, Description, PredefinedType, UpperValue, MostUsedValue, LowerValue) {
      var _this330;

      _classCallCheck2(this, IfcServiceLifeFactor);

      _this330 = _super338.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this330.GlobalId = GlobalId;
      _this330.OwnerHistory = OwnerHistory;
      _this330.Name = Name;
      _this330.Description = Description;
      _this330.PredefinedType = PredefinedType;
      _this330.UpperValue = UpperValue;
      _this330.MostUsedValue = MostUsedValue;
      _this330.LowerValue = LowerValue;
      _this330.type = 2411513650;
      return _this330;
    }

    return IfcServiceLifeFactor;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcServiceLifeFactor = IfcServiceLifeFactor;

  var IfcShellBasedSurfaceModel = /*#__PURE__*/function (_IfcGeometricRepresen10) {
    _inherits(IfcShellBasedSurfaceModel, _IfcGeometricRepresen10);

    var _super339 = _createSuper(IfcShellBasedSurfaceModel);

    function IfcShellBasedSurfaceModel(expressID, SbsmBoundary) {
      var _this331;

      _classCallCheck2(this, IfcShellBasedSurfaceModel);

      _this331 = _super339.call(this, expressID);
      _this331.SbsmBoundary = SbsmBoundary;
      _this331.type = 4124623270;
      return _this331;
    }

    return IfcShellBasedSurfaceModel;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;

  var IfcSlippageConnectionCondition = /*#__PURE__*/function (_IfcStructuralConnect2) {
    _inherits(IfcSlippageConnectionCondition, _IfcStructuralConnect2);

    var _super340 = _createSuper(IfcSlippageConnectionCondition);

    function IfcSlippageConnectionCondition(expressID, Name, SlippageX, SlippageY, SlippageZ) {
      var _this332;

      _classCallCheck2(this, IfcSlippageConnectionCondition);

      _this332 = _super340.call(this, expressID, Name);
      _this332.Name = Name;
      _this332.SlippageX = SlippageX;
      _this332.SlippageY = SlippageY;
      _this332.SlippageZ = SlippageZ;
      _this332.type = 2609359061;
      return _this332;
    }

    return IfcSlippageConnectionCondition;
  }(IfcStructuralConnectionCondition);

  IFC2X32.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;

  var IfcSolidModel = /*#__PURE__*/function (_IfcGeometricRepresen11) {
    _inherits(IfcSolidModel, _IfcGeometricRepresen11);

    var _super341 = _createSuper(IfcSolidModel);

    function IfcSolidModel(expressID) {
      var _this333;

      _classCallCheck2(this, IfcSolidModel);

      _this333 = _super341.call(this, expressID);
      _this333.type = 723233188;
      return _this333;
    }

    return IfcSolidModel;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcSolidModel = IfcSolidModel;

  var IfcSoundProperties = /*#__PURE__*/function (_IfcPropertySetDefini3) {
    _inherits(IfcSoundProperties, _IfcPropertySetDefini3);

    var _super342 = _createSuper(IfcSoundProperties);

    function IfcSoundProperties(expressID, GlobalId, OwnerHistory, Name, Description, IsAttenuating, SoundScale, SoundValues) {
      var _this334;

      _classCallCheck2(this, IfcSoundProperties);

      _this334 = _super342.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this334.GlobalId = GlobalId;
      _this334.OwnerHistory = OwnerHistory;
      _this334.Name = Name;
      _this334.Description = Description;
      _this334.IsAttenuating = IsAttenuating;
      _this334.SoundScale = SoundScale;
      _this334.SoundValues = SoundValues;
      _this334.type = 2485662743;
      return _this334;
    }

    return IfcSoundProperties;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcSoundProperties = IfcSoundProperties;

  var IfcSoundValue = /*#__PURE__*/function (_IfcPropertySetDefini4) {
    _inherits(IfcSoundValue, _IfcPropertySetDefini4);

    var _super343 = _createSuper(IfcSoundValue);

    function IfcSoundValue(expressID, GlobalId, OwnerHistory, Name, Description, SoundLevelTimeSeries, Frequency, SoundLevelSingleValue) {
      var _this335;

      _classCallCheck2(this, IfcSoundValue);

      _this335 = _super343.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this335.GlobalId = GlobalId;
      _this335.OwnerHistory = OwnerHistory;
      _this335.Name = Name;
      _this335.Description = Description;
      _this335.SoundLevelTimeSeries = SoundLevelTimeSeries;
      _this335.Frequency = Frequency;
      _this335.SoundLevelSingleValue = SoundLevelSingleValue;
      _this335.type = 1202362311;
      return _this335;
    }

    return IfcSoundValue;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcSoundValue = IfcSoundValue;

  var IfcSpaceThermalLoadProperties = /*#__PURE__*/function (_IfcPropertySetDefini5) {
    _inherits(IfcSpaceThermalLoadProperties, _IfcPropertySetDefini5);

    var _super344 = _createSuper(IfcSpaceThermalLoadProperties);

    function IfcSpaceThermalLoadProperties(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableValueRatio, ThermalLoadSource, PropertySource, SourceDescription, MaximumValue, MinimumValue, ThermalLoadTimeSeriesValues, UserDefinedThermalLoadSource, UserDefinedPropertySource, ThermalLoadType) {
      var _this336;

      _classCallCheck2(this, IfcSpaceThermalLoadProperties);

      _this336 = _super344.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this336.GlobalId = GlobalId;
      _this336.OwnerHistory = OwnerHistory;
      _this336.Name = Name;
      _this336.Description = Description;
      _this336.ApplicableValueRatio = ApplicableValueRatio;
      _this336.ThermalLoadSource = ThermalLoadSource;
      _this336.PropertySource = PropertySource;
      _this336.SourceDescription = SourceDescription;
      _this336.MaximumValue = MaximumValue;
      _this336.MinimumValue = MinimumValue;
      _this336.ThermalLoadTimeSeriesValues = ThermalLoadTimeSeriesValues;
      _this336.UserDefinedThermalLoadSource = UserDefinedThermalLoadSource;
      _this336.UserDefinedPropertySource = UserDefinedPropertySource;
      _this336.ThermalLoadType = ThermalLoadType;
      _this336.type = 390701378;
      return _this336;
    }

    return IfcSpaceThermalLoadProperties;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcSpaceThermalLoadProperties = IfcSpaceThermalLoadProperties;

  var IfcStructuralLoadLinearForce = /*#__PURE__*/function (_IfcStructuralLoadSta2) {
    _inherits(IfcStructuralLoadLinearForce, _IfcStructuralLoadSta2);

    var _super345 = _createSuper(IfcStructuralLoadLinearForce);

    function IfcStructuralLoadLinearForce(expressID, Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ) {
      var _this337;

      _classCallCheck2(this, IfcStructuralLoadLinearForce);

      _this337 = _super345.call(this, expressID, Name);
      _this337.Name = Name;
      _this337.LinearForceX = LinearForceX;
      _this337.LinearForceY = LinearForceY;
      _this337.LinearForceZ = LinearForceZ;
      _this337.LinearMomentX = LinearMomentX;
      _this337.LinearMomentY = LinearMomentY;
      _this337.LinearMomentZ = LinearMomentZ;
      _this337.type = 1595516126;
      return _this337;
    }

    return IfcStructuralLoadLinearForce;
  }(IfcStructuralLoadStatic);

  IFC2X32.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;

  var IfcStructuralLoadPlanarForce = /*#__PURE__*/function (_IfcStructuralLoadSta3) {
    _inherits(IfcStructuralLoadPlanarForce, _IfcStructuralLoadSta3);

    var _super346 = _createSuper(IfcStructuralLoadPlanarForce);

    function IfcStructuralLoadPlanarForce(expressID, Name, PlanarForceX, PlanarForceY, PlanarForceZ) {
      var _this338;

      _classCallCheck2(this, IfcStructuralLoadPlanarForce);

      _this338 = _super346.call(this, expressID, Name);
      _this338.Name = Name;
      _this338.PlanarForceX = PlanarForceX;
      _this338.PlanarForceY = PlanarForceY;
      _this338.PlanarForceZ = PlanarForceZ;
      _this338.type = 2668620305;
      return _this338;
    }

    return IfcStructuralLoadPlanarForce;
  }(IfcStructuralLoadStatic);

  IFC2X32.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;

  var IfcStructuralLoadSingleDisplacement = /*#__PURE__*/function (_IfcStructuralLoadSta4) {
    _inherits(IfcStructuralLoadSingleDisplacement, _IfcStructuralLoadSta4);

    var _super347 = _createSuper(IfcStructuralLoadSingleDisplacement);

    function IfcStructuralLoadSingleDisplacement(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ) {
      var _this339;

      _classCallCheck2(this, IfcStructuralLoadSingleDisplacement);

      _this339 = _super347.call(this, expressID, Name);
      _this339.Name = Name;
      _this339.DisplacementX = DisplacementX;
      _this339.DisplacementY = DisplacementY;
      _this339.DisplacementZ = DisplacementZ;
      _this339.RotationalDisplacementRX = RotationalDisplacementRX;
      _this339.RotationalDisplacementRY = RotationalDisplacementRY;
      _this339.RotationalDisplacementRZ = RotationalDisplacementRZ;
      _this339.type = 2473145415;
      return _this339;
    }

    return IfcStructuralLoadSingleDisplacement;
  }(IfcStructuralLoadStatic);

  IFC2X32.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;

  var IfcStructuralLoadSingleDisplacementDistortion = /*#__PURE__*/function (_IfcStructuralLoadSin) {
    _inherits(IfcStructuralLoadSingleDisplacementDistortion, _IfcStructuralLoadSin);

    var _super348 = _createSuper(IfcStructuralLoadSingleDisplacementDistortion);

    function IfcStructuralLoadSingleDisplacementDistortion(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion) {
      var _this340;

      _classCallCheck2(this, IfcStructuralLoadSingleDisplacementDistortion);

      _this340 = _super348.call(this, expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
      _this340.Name = Name;
      _this340.DisplacementX = DisplacementX;
      _this340.DisplacementY = DisplacementY;
      _this340.DisplacementZ = DisplacementZ;
      _this340.RotationalDisplacementRX = RotationalDisplacementRX;
      _this340.RotationalDisplacementRY = RotationalDisplacementRY;
      _this340.RotationalDisplacementRZ = RotationalDisplacementRZ;
      _this340.Distortion = Distortion;
      _this340.type = 1973038258;
      return _this340;
    }

    return IfcStructuralLoadSingleDisplacementDistortion;
  }(IfcStructuralLoadSingleDisplacement);

  IFC2X32.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;

  var IfcStructuralLoadSingleForce = /*#__PURE__*/function (_IfcStructuralLoadSta5) {
    _inherits(IfcStructuralLoadSingleForce, _IfcStructuralLoadSta5);

    var _super349 = _createSuper(IfcStructuralLoadSingleForce);

    function IfcStructuralLoadSingleForce(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ) {
      var _this341;

      _classCallCheck2(this, IfcStructuralLoadSingleForce);

      _this341 = _super349.call(this, expressID, Name);
      _this341.Name = Name;
      _this341.ForceX = ForceX;
      _this341.ForceY = ForceY;
      _this341.ForceZ = ForceZ;
      _this341.MomentX = MomentX;
      _this341.MomentY = MomentY;
      _this341.MomentZ = MomentZ;
      _this341.type = 1597423693;
      return _this341;
    }

    return IfcStructuralLoadSingleForce;
  }(IfcStructuralLoadStatic);

  IFC2X32.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;

  var IfcStructuralLoadSingleForceWarping = /*#__PURE__*/function (_IfcStructuralLoadSin2) {
    _inherits(IfcStructuralLoadSingleForceWarping, _IfcStructuralLoadSin2);

    var _super350 = _createSuper(IfcStructuralLoadSingleForceWarping);

    function IfcStructuralLoadSingleForceWarping(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment) {
      var _this342;

      _classCallCheck2(this, IfcStructuralLoadSingleForceWarping);

      _this342 = _super350.call(this, expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
      _this342.Name = Name;
      _this342.ForceX = ForceX;
      _this342.ForceY = ForceY;
      _this342.ForceZ = ForceZ;
      _this342.MomentX = MomentX;
      _this342.MomentY = MomentY;
      _this342.MomentZ = MomentZ;
      _this342.WarpingMoment = WarpingMoment;
      _this342.type = 1190533807;
      return _this342;
    }

    return IfcStructuralLoadSingleForceWarping;
  }(IfcStructuralLoadSingleForce);

  IFC2X32.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;

  var IfcStructuralProfileProperties = /*#__PURE__*/function (_IfcGeneralProfilePro) {
    _inherits(IfcStructuralProfileProperties, _IfcGeneralProfilePro);

    var _super351 = _createSuper(IfcStructuralProfileProperties);

    function IfcStructuralProfileProperties(expressID, ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY) {
      var _this343;

      _classCallCheck2(this, IfcStructuralProfileProperties);

      _this343 = _super351.call(this, expressID, ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea);
      _this343.ProfileName = ProfileName;
      _this343.ProfileDefinition = ProfileDefinition;
      _this343.PhysicalWeight = PhysicalWeight;
      _this343.Perimeter = Perimeter;
      _this343.MinimumPlateThickness = MinimumPlateThickness;
      _this343.MaximumPlateThickness = MaximumPlateThickness;
      _this343.CrossSectionArea = CrossSectionArea;
      _this343.TorsionalConstantX = TorsionalConstantX;
      _this343.MomentOfInertiaYZ = MomentOfInertiaYZ;
      _this343.MomentOfInertiaY = MomentOfInertiaY;
      _this343.MomentOfInertiaZ = MomentOfInertiaZ;
      _this343.WarpingConstant = WarpingConstant;
      _this343.ShearCentreZ = ShearCentreZ;
      _this343.ShearCentreY = ShearCentreY;
      _this343.ShearDeformationAreaZ = ShearDeformationAreaZ;
      _this343.ShearDeformationAreaY = ShearDeformationAreaY;
      _this343.MaximumSectionModulusY = MaximumSectionModulusY;
      _this343.MinimumSectionModulusY = MinimumSectionModulusY;
      _this343.MaximumSectionModulusZ = MaximumSectionModulusZ;
      _this343.MinimumSectionModulusZ = MinimumSectionModulusZ;
      _this343.TorsionalSectionModulus = TorsionalSectionModulus;
      _this343.CentreOfGravityInX = CentreOfGravityInX;
      _this343.CentreOfGravityInY = CentreOfGravityInY;
      _this343.type = 3843319758;
      return _this343;
    }

    return IfcStructuralProfileProperties;
  }(IfcGeneralProfileProperties);

  IFC2X32.IfcStructuralProfileProperties = IfcStructuralProfileProperties;

  var IfcStructuralSteelProfileProperties = /*#__PURE__*/function (_IfcStructuralProfile) {
    _inherits(IfcStructuralSteelProfileProperties, _IfcStructuralProfile);

    var _super352 = _createSuper(IfcStructuralSteelProfileProperties);

    function IfcStructuralSteelProfileProperties(expressID, ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY, ShearAreaZ, ShearAreaY, PlasticShapeFactorY, PlasticShapeFactorZ) {
      var _this344;

      _classCallCheck2(this, IfcStructuralSteelProfileProperties);

      _this344 = _super352.call(this, expressID, ProfileName, ProfileDefinition, PhysicalWeight, Perimeter, MinimumPlateThickness, MaximumPlateThickness, CrossSectionArea, TorsionalConstantX, MomentOfInertiaYZ, MomentOfInertiaY, MomentOfInertiaZ, WarpingConstant, ShearCentreZ, ShearCentreY, ShearDeformationAreaZ, ShearDeformationAreaY, MaximumSectionModulusY, MinimumSectionModulusY, MaximumSectionModulusZ, MinimumSectionModulusZ, TorsionalSectionModulus, CentreOfGravityInX, CentreOfGravityInY);
      _this344.ProfileName = ProfileName;
      _this344.ProfileDefinition = ProfileDefinition;
      _this344.PhysicalWeight = PhysicalWeight;
      _this344.Perimeter = Perimeter;
      _this344.MinimumPlateThickness = MinimumPlateThickness;
      _this344.MaximumPlateThickness = MaximumPlateThickness;
      _this344.CrossSectionArea = CrossSectionArea;
      _this344.TorsionalConstantX = TorsionalConstantX;
      _this344.MomentOfInertiaYZ = MomentOfInertiaYZ;
      _this344.MomentOfInertiaY = MomentOfInertiaY;
      _this344.MomentOfInertiaZ = MomentOfInertiaZ;
      _this344.WarpingConstant = WarpingConstant;
      _this344.ShearCentreZ = ShearCentreZ;
      _this344.ShearCentreY = ShearCentreY;
      _this344.ShearDeformationAreaZ = ShearDeformationAreaZ;
      _this344.ShearDeformationAreaY = ShearDeformationAreaY;
      _this344.MaximumSectionModulusY = MaximumSectionModulusY;
      _this344.MinimumSectionModulusY = MinimumSectionModulusY;
      _this344.MaximumSectionModulusZ = MaximumSectionModulusZ;
      _this344.MinimumSectionModulusZ = MinimumSectionModulusZ;
      _this344.TorsionalSectionModulus = TorsionalSectionModulus;
      _this344.CentreOfGravityInX = CentreOfGravityInX;
      _this344.CentreOfGravityInY = CentreOfGravityInY;
      _this344.ShearAreaZ = ShearAreaZ;
      _this344.ShearAreaY = ShearAreaY;
      _this344.PlasticShapeFactorY = PlasticShapeFactorY;
      _this344.PlasticShapeFactorZ = PlasticShapeFactorZ;
      _this344.type = 3653947884;
      return _this344;
    }

    return IfcStructuralSteelProfileProperties;
  }(IfcStructuralProfileProperties);

  IFC2X32.IfcStructuralSteelProfileProperties = IfcStructuralSteelProfileProperties;

  var IfcSubedge = /*#__PURE__*/function (_IfcEdge3) {
    _inherits(IfcSubedge, _IfcEdge3);

    var _super353 = _createSuper(IfcSubedge);

    function IfcSubedge(expressID, EdgeStart, EdgeEnd, ParentEdge) {
      var _this345;

      _classCallCheck2(this, IfcSubedge);

      _this345 = _super353.call(this, expressID, EdgeStart, EdgeEnd);
      _this345.EdgeStart = EdgeStart;
      _this345.EdgeEnd = EdgeEnd;
      _this345.ParentEdge = ParentEdge;
      _this345.type = 2233826070;
      return _this345;
    }

    return IfcSubedge;
  }(IfcEdge);

  IFC2X32.IfcSubedge = IfcSubedge;

  var IfcSurface = /*#__PURE__*/function (_IfcGeometricRepresen12) {
    _inherits(IfcSurface, _IfcGeometricRepresen12);

    var _super354 = _createSuper(IfcSurface);

    function IfcSurface(expressID) {
      var _this346;

      _classCallCheck2(this, IfcSurface);

      _this346 = _super354.call(this, expressID);
      _this346.type = 2513912981;
      return _this346;
    }

    return IfcSurface;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcSurface = IfcSurface;

  var IfcSurfaceStyleRendering = /*#__PURE__*/function (_IfcSurfaceStyleShadi) {
    _inherits(IfcSurfaceStyleRendering, _IfcSurfaceStyleShadi);

    var _super355 = _createSuper(IfcSurfaceStyleRendering);

    function IfcSurfaceStyleRendering(expressID, SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod) {
      var _this347;

      _classCallCheck2(this, IfcSurfaceStyleRendering);

      _this347 = _super355.call(this, expressID, SurfaceColour);
      _this347.SurfaceColour = SurfaceColour;
      _this347.Transparency = Transparency;
      _this347.DiffuseColour = DiffuseColour;
      _this347.TransmissionColour = TransmissionColour;
      _this347.DiffuseTransmissionColour = DiffuseTransmissionColour;
      _this347.ReflectionColour = ReflectionColour;
      _this347.SpecularColour = SpecularColour;
      _this347.SpecularHighlight = SpecularHighlight;
      _this347.ReflectanceMethod = ReflectanceMethod;
      _this347.type = 1878645084;
      return _this347;
    }

    return IfcSurfaceStyleRendering;
  }(IfcSurfaceStyleShading);

  IFC2X32.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;

  var IfcSweptAreaSolid = /*#__PURE__*/function (_IfcSolidModel) {
    _inherits(IfcSweptAreaSolid, _IfcSolidModel);

    var _super356 = _createSuper(IfcSweptAreaSolid);

    function IfcSweptAreaSolid(expressID, SweptArea, Position) {
      var _this348;

      _classCallCheck2(this, IfcSweptAreaSolid);

      _this348 = _super356.call(this, expressID);
      _this348.SweptArea = SweptArea;
      _this348.Position = Position;
      _this348.type = 2247615214;
      return _this348;
    }

    return IfcSweptAreaSolid;
  }(IfcSolidModel);

  IFC2X32.IfcSweptAreaSolid = IfcSweptAreaSolid;

  var IfcSweptDiskSolid = /*#__PURE__*/function (_IfcSolidModel2) {
    _inherits(IfcSweptDiskSolid, _IfcSolidModel2);

    var _super357 = _createSuper(IfcSweptDiskSolid);

    function IfcSweptDiskSolid(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam) {
      var _this349;

      _classCallCheck2(this, IfcSweptDiskSolid);

      _this349 = _super357.call(this, expressID);
      _this349.Directrix = Directrix;
      _this349.Radius = Radius;
      _this349.InnerRadius = InnerRadius;
      _this349.StartParam = StartParam;
      _this349.EndParam = EndParam;
      _this349.type = 1260650574;
      return _this349;
    }

    return IfcSweptDiskSolid;
  }(IfcSolidModel);

  IFC2X32.IfcSweptDiskSolid = IfcSweptDiskSolid;

  var IfcSweptSurface = /*#__PURE__*/function (_IfcSurface) {
    _inherits(IfcSweptSurface, _IfcSurface);

    var _super358 = _createSuper(IfcSweptSurface);

    function IfcSweptSurface(expressID, SweptCurve, Position) {
      var _this350;

      _classCallCheck2(this, IfcSweptSurface);

      _this350 = _super358.call(this, expressID);
      _this350.SweptCurve = SweptCurve;
      _this350.Position = Position;
      _this350.type = 230924584;
      return _this350;
    }

    return IfcSweptSurface;
  }(IfcSurface);

  IFC2X32.IfcSweptSurface = IfcSweptSurface;

  var IfcTShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf2) {
    _inherits(IfcTShapeProfileDef, _IfcParameterizedProf2);

    var _super359 = _createSuper(IfcTShapeProfileDef);

    function IfcTShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope, CentreOfGravityInY) {
      var _this351;

      _classCallCheck2(this, IfcTShapeProfileDef);

      _this351 = _super359.call(this, expressID, ProfileType, ProfileName, Position);
      _this351.ProfileType = ProfileType;
      _this351.ProfileName = ProfileName;
      _this351.Position = Position;
      _this351.Depth = Depth;
      _this351.FlangeWidth = FlangeWidth;
      _this351.WebThickness = WebThickness;
      _this351.FlangeThickness = FlangeThickness;
      _this351.FilletRadius = FilletRadius;
      _this351.FlangeEdgeRadius = FlangeEdgeRadius;
      _this351.WebEdgeRadius = WebEdgeRadius;
      _this351.WebSlope = WebSlope;
      _this351.FlangeSlope = FlangeSlope;
      _this351.CentreOfGravityInY = CentreOfGravityInY;
      _this351.type = 3071757647;
      return _this351;
    }

    return IfcTShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcTShapeProfileDef = IfcTShapeProfileDef;

  var IfcTerminatorSymbol = /*#__PURE__*/function (_IfcAnnotationSymbolO) {
    _inherits(IfcTerminatorSymbol, _IfcAnnotationSymbolO);

    var _super360 = _createSuper(IfcTerminatorSymbol);

    function IfcTerminatorSymbol(expressID, Item, Styles, Name, AnnotatedCurve) {
      var _this352;

      _classCallCheck2(this, IfcTerminatorSymbol);

      _this352 = _super360.call(this, expressID, Item, Styles, Name);
      _this352.Item = Item;
      _this352.Styles = Styles;
      _this352.Name = Name;
      _this352.AnnotatedCurve = AnnotatedCurve;
      _this352.type = 3028897424;
      return _this352;
    }

    return IfcTerminatorSymbol;
  }(IfcAnnotationSymbolOccurrence);

  IFC2X32.IfcTerminatorSymbol = IfcTerminatorSymbol;

  var IfcTextLiteral = /*#__PURE__*/function (_IfcGeometricRepresen13) {
    _inherits(IfcTextLiteral, _IfcGeometricRepresen13);

    var _super361 = _createSuper(IfcTextLiteral);

    function IfcTextLiteral(expressID, Literal, Placement, Path) {
      var _this353;

      _classCallCheck2(this, IfcTextLiteral);

      _this353 = _super361.call(this, expressID);
      _this353.Literal = Literal;
      _this353.Placement = Placement;
      _this353.Path = Path;
      _this353.type = 4282788508;
      return _this353;
    }

    return IfcTextLiteral;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcTextLiteral = IfcTextLiteral;

  var IfcTextLiteralWithExtent = /*#__PURE__*/function (_IfcTextLiteral) {
    _inherits(IfcTextLiteralWithExtent, _IfcTextLiteral);

    var _super362 = _createSuper(IfcTextLiteralWithExtent);

    function IfcTextLiteralWithExtent(expressID, Literal, Placement, Path, Extent, BoxAlignment) {
      var _this354;

      _classCallCheck2(this, IfcTextLiteralWithExtent);

      _this354 = _super362.call(this, expressID, Literal, Placement, Path);
      _this354.Literal = Literal;
      _this354.Placement = Placement;
      _this354.Path = Path;
      _this354.Extent = Extent;
      _this354.BoxAlignment = BoxAlignment;
      _this354.type = 3124975700;
      return _this354;
    }

    return IfcTextLiteralWithExtent;
  }(IfcTextLiteral);

  IFC2X32.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;

  var IfcTrapeziumProfileDef = /*#__PURE__*/function (_IfcParameterizedProf3) {
    _inherits(IfcTrapeziumProfileDef, _IfcParameterizedProf3);

    var _super363 = _createSuper(IfcTrapeziumProfileDef);

    function IfcTrapeziumProfileDef(expressID, ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset) {
      var _this355;

      _classCallCheck2(this, IfcTrapeziumProfileDef);

      _this355 = _super363.call(this, expressID, ProfileType, ProfileName, Position);
      _this355.ProfileType = ProfileType;
      _this355.ProfileName = ProfileName;
      _this355.Position = Position;
      _this355.BottomXDim = BottomXDim;
      _this355.TopXDim = TopXDim;
      _this355.YDim = YDim;
      _this355.TopXOffset = TopXOffset;
      _this355.type = 2715220739;
      return _this355;
    }

    return IfcTrapeziumProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;

  var IfcTwoDirectionRepeatFactor = /*#__PURE__*/function (_IfcOneDirectionRepea) {
    _inherits(IfcTwoDirectionRepeatFactor, _IfcOneDirectionRepea);

    var _super364 = _createSuper(IfcTwoDirectionRepeatFactor);

    function IfcTwoDirectionRepeatFactor(expressID, RepeatFactor, SecondRepeatFactor) {
      var _this356;

      _classCallCheck2(this, IfcTwoDirectionRepeatFactor);

      _this356 = _super364.call(this, expressID, RepeatFactor);
      _this356.RepeatFactor = RepeatFactor;
      _this356.SecondRepeatFactor = SecondRepeatFactor;
      _this356.type = 1345879162;
      return _this356;
    }

    return IfcTwoDirectionRepeatFactor;
  }(IfcOneDirectionRepeatFactor);

  IFC2X32.IfcTwoDirectionRepeatFactor = IfcTwoDirectionRepeatFactor;

  var IfcTypeObject = /*#__PURE__*/function (_IfcObjectDefinition) {
    _inherits(IfcTypeObject, _IfcObjectDefinition);

    var _super365 = _createSuper(IfcTypeObject);

    function IfcTypeObject(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets) {
      var _this357;

      _classCallCheck2(this, IfcTypeObject);

      _this357 = _super365.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this357.GlobalId = GlobalId;
      _this357.OwnerHistory = OwnerHistory;
      _this357.Name = Name;
      _this357.Description = Description;
      _this357.ApplicableOccurrence = ApplicableOccurrence;
      _this357.HasPropertySets = HasPropertySets;
      _this357.type = 1628702193;
      return _this357;
    }

    return IfcTypeObject;
  }(IfcObjectDefinition);

  IFC2X32.IfcTypeObject = IfcTypeObject;

  var IfcTypeProduct = /*#__PURE__*/function (_IfcTypeObject) {
    _inherits(IfcTypeProduct, _IfcTypeObject);

    var _super366 = _createSuper(IfcTypeProduct);

    function IfcTypeProduct(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag) {
      var _this358;

      _classCallCheck2(this, IfcTypeProduct);

      _this358 = _super366.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      _this358.GlobalId = GlobalId;
      _this358.OwnerHistory = OwnerHistory;
      _this358.Name = Name;
      _this358.Description = Description;
      _this358.ApplicableOccurrence = ApplicableOccurrence;
      _this358.HasPropertySets = HasPropertySets;
      _this358.RepresentationMaps = RepresentationMaps;
      _this358.Tag = Tag;
      _this358.type = 2347495698;
      return _this358;
    }

    return IfcTypeProduct;
  }(IfcTypeObject);

  IFC2X32.IfcTypeProduct = IfcTypeProduct;

  var IfcUShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf4) {
    _inherits(IfcUShapeProfileDef, _IfcParameterizedProf4);

    var _super367 = _createSuper(IfcUShapeProfileDef);

    function IfcUShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope, CentreOfGravityInX) {
      var _this359;

      _classCallCheck2(this, IfcUShapeProfileDef);

      _this359 = _super367.call(this, expressID, ProfileType, ProfileName, Position);
      _this359.ProfileType = ProfileType;
      _this359.ProfileName = ProfileName;
      _this359.Position = Position;
      _this359.Depth = Depth;
      _this359.FlangeWidth = FlangeWidth;
      _this359.WebThickness = WebThickness;
      _this359.FlangeThickness = FlangeThickness;
      _this359.FilletRadius = FilletRadius;
      _this359.EdgeRadius = EdgeRadius;
      _this359.FlangeSlope = FlangeSlope;
      _this359.CentreOfGravityInX = CentreOfGravityInX;
      _this359.type = 427810014;
      return _this359;
    }

    return IfcUShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcUShapeProfileDef = IfcUShapeProfileDef;

  var IfcVector = /*#__PURE__*/function (_IfcGeometricRepresen14) {
    _inherits(IfcVector, _IfcGeometricRepresen14);

    var _super368 = _createSuper(IfcVector);

    function IfcVector(expressID, Orientation, Magnitude) {
      var _this360;

      _classCallCheck2(this, IfcVector);

      _this360 = _super368.call(this, expressID);
      _this360.Orientation = Orientation;
      _this360.Magnitude = Magnitude;
      _this360.type = 1417489154;
      return _this360;
    }

    return IfcVector;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcVector = IfcVector;

  var IfcVertexLoop = /*#__PURE__*/function (_IfcLoop2) {
    _inherits(IfcVertexLoop, _IfcLoop2);

    var _super369 = _createSuper(IfcVertexLoop);

    function IfcVertexLoop(expressID, LoopVertex) {
      var _this361;

      _classCallCheck2(this, IfcVertexLoop);

      _this361 = _super369.call(this, expressID);
      _this361.LoopVertex = LoopVertex;
      _this361.type = 2759199220;
      return _this361;
    }

    return IfcVertexLoop;
  }(IfcLoop);

  IFC2X32.IfcVertexLoop = IfcVertexLoop;

  var IfcWindowLiningProperties = /*#__PURE__*/function (_IfcPropertySetDefini6) {
    _inherits(IfcWindowLiningProperties, _IfcPropertySetDefini6);

    var _super370 = _createSuper(IfcWindowLiningProperties);

    function IfcWindowLiningProperties(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle) {
      var _this362;

      _classCallCheck2(this, IfcWindowLiningProperties);

      _this362 = _super370.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this362.GlobalId = GlobalId;
      _this362.OwnerHistory = OwnerHistory;
      _this362.Name = Name;
      _this362.Description = Description;
      _this362.LiningDepth = LiningDepth;
      _this362.LiningThickness = LiningThickness;
      _this362.TransomThickness = TransomThickness;
      _this362.MullionThickness = MullionThickness;
      _this362.FirstTransomOffset = FirstTransomOffset;
      _this362.SecondTransomOffset = SecondTransomOffset;
      _this362.FirstMullionOffset = FirstMullionOffset;
      _this362.SecondMullionOffset = SecondMullionOffset;
      _this362.ShapeAspectStyle = ShapeAspectStyle;
      _this362.type = 336235671;
      return _this362;
    }

    return IfcWindowLiningProperties;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcWindowLiningProperties = IfcWindowLiningProperties;

  var IfcWindowPanelProperties = /*#__PURE__*/function (_IfcPropertySetDefini7) {
    _inherits(IfcWindowPanelProperties, _IfcPropertySetDefini7);

    var _super371 = _createSuper(IfcWindowPanelProperties);

    function IfcWindowPanelProperties(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      var _this363;

      _classCallCheck2(this, IfcWindowPanelProperties);

      _this363 = _super371.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this363.GlobalId = GlobalId;
      _this363.OwnerHistory = OwnerHistory;
      _this363.Name = Name;
      _this363.Description = Description;
      _this363.OperationType = OperationType;
      _this363.PanelPosition = PanelPosition;
      _this363.FrameDepth = FrameDepth;
      _this363.FrameThickness = FrameThickness;
      _this363.ShapeAspectStyle = ShapeAspectStyle;
      _this363.type = 512836454;
      return _this363;
    }

    return IfcWindowPanelProperties;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcWindowPanelProperties = IfcWindowPanelProperties;

  var IfcWindowStyle = /*#__PURE__*/function (_IfcTypeProduct) {
    _inherits(IfcWindowStyle, _IfcTypeProduct);

    var _super372 = _createSuper(IfcWindowStyle);

    function IfcWindowStyle(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ConstructionType, OperationType, ParameterTakesPrecedence, Sizeable) {
      var _this364;

      _classCallCheck2(this, IfcWindowStyle);

      _this364 = _super372.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      _this364.GlobalId = GlobalId;
      _this364.OwnerHistory = OwnerHistory;
      _this364.Name = Name;
      _this364.Description = Description;
      _this364.ApplicableOccurrence = ApplicableOccurrence;
      _this364.HasPropertySets = HasPropertySets;
      _this364.RepresentationMaps = RepresentationMaps;
      _this364.Tag = Tag;
      _this364.ConstructionType = ConstructionType;
      _this364.OperationType = OperationType;
      _this364.ParameterTakesPrecedence = ParameterTakesPrecedence;
      _this364.Sizeable = Sizeable;
      _this364.type = 1299126871;
      return _this364;
    }

    return IfcWindowStyle;
  }(IfcTypeProduct);

  IFC2X32.IfcWindowStyle = IfcWindowStyle;

  var IfcZShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf5) {
    _inherits(IfcZShapeProfileDef, _IfcParameterizedProf5);

    var _super373 = _createSuper(IfcZShapeProfileDef);

    function IfcZShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius) {
      var _this365;

      _classCallCheck2(this, IfcZShapeProfileDef);

      _this365 = _super373.call(this, expressID, ProfileType, ProfileName, Position);
      _this365.ProfileType = ProfileType;
      _this365.ProfileName = ProfileName;
      _this365.Position = Position;
      _this365.Depth = Depth;
      _this365.FlangeWidth = FlangeWidth;
      _this365.WebThickness = WebThickness;
      _this365.FlangeThickness = FlangeThickness;
      _this365.FilletRadius = FilletRadius;
      _this365.EdgeRadius = EdgeRadius;
      _this365.type = 2543172580;
      return _this365;
    }

    return IfcZShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcZShapeProfileDef = IfcZShapeProfileDef;

  var IfcAnnotationCurveOccurrence = /*#__PURE__*/function (_IfcAnnotationOccurre4) {
    _inherits(IfcAnnotationCurveOccurrence, _IfcAnnotationOccurre4);

    var _super374 = _createSuper(IfcAnnotationCurveOccurrence);

    function IfcAnnotationCurveOccurrence(expressID, Item, Styles, Name) {
      var _this366;

      _classCallCheck2(this, IfcAnnotationCurveOccurrence);

      _this366 = _super374.call(this, expressID, Item, Styles, Name);
      _this366.Item = Item;
      _this366.Styles = Styles;
      _this366.Name = Name;
      _this366.type = 3288037868;
      return _this366;
    }

    return IfcAnnotationCurveOccurrence;
  }(IfcAnnotationOccurrence);

  IFC2X32.IfcAnnotationCurveOccurrence = IfcAnnotationCurveOccurrence;

  var IfcAnnotationFillArea = /*#__PURE__*/function (_IfcGeometricRepresen15) {
    _inherits(IfcAnnotationFillArea, _IfcGeometricRepresen15);

    var _super375 = _createSuper(IfcAnnotationFillArea);

    function IfcAnnotationFillArea(expressID, OuterBoundary, InnerBoundaries) {
      var _this367;

      _classCallCheck2(this, IfcAnnotationFillArea);

      _this367 = _super375.call(this, expressID);
      _this367.OuterBoundary = OuterBoundary;
      _this367.InnerBoundaries = InnerBoundaries;
      _this367.type = 669184980;
      return _this367;
    }

    return IfcAnnotationFillArea;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcAnnotationFillArea = IfcAnnotationFillArea;

  var IfcAnnotationFillAreaOccurrence = /*#__PURE__*/function (_IfcAnnotationOccurre5) {
    _inherits(IfcAnnotationFillAreaOccurrence, _IfcAnnotationOccurre5);

    var _super376 = _createSuper(IfcAnnotationFillAreaOccurrence);

    function IfcAnnotationFillAreaOccurrence(expressID, Item, Styles, Name, FillStyleTarget, GlobalOrLocal) {
      var _this368;

      _classCallCheck2(this, IfcAnnotationFillAreaOccurrence);

      _this368 = _super376.call(this, expressID, Item, Styles, Name);
      _this368.Item = Item;
      _this368.Styles = Styles;
      _this368.Name = Name;
      _this368.FillStyleTarget = FillStyleTarget;
      _this368.GlobalOrLocal = GlobalOrLocal;
      _this368.type = 2265737646;
      return _this368;
    }

    return IfcAnnotationFillAreaOccurrence;
  }(IfcAnnotationOccurrence);

  IFC2X32.IfcAnnotationFillAreaOccurrence = IfcAnnotationFillAreaOccurrence;

  var IfcAnnotationSurface = /*#__PURE__*/function (_IfcGeometricRepresen16) {
    _inherits(IfcAnnotationSurface, _IfcGeometricRepresen16);

    var _super377 = _createSuper(IfcAnnotationSurface);

    function IfcAnnotationSurface(expressID, Item, TextureCoordinates) {
      var _this369;

      _classCallCheck2(this, IfcAnnotationSurface);

      _this369 = _super377.call(this, expressID);
      _this369.Item = Item;
      _this369.TextureCoordinates = TextureCoordinates;
      _this369.type = 1302238472;
      return _this369;
    }

    return IfcAnnotationSurface;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcAnnotationSurface = IfcAnnotationSurface;

  var IfcAxis1Placement = /*#__PURE__*/function (_IfcPlacement) {
    _inherits(IfcAxis1Placement, _IfcPlacement);

    var _super378 = _createSuper(IfcAxis1Placement);

    function IfcAxis1Placement(expressID, Location, Axis) {
      var _this370;

      _classCallCheck2(this, IfcAxis1Placement);

      _this370 = _super378.call(this, expressID, Location);
      _this370.Location = Location;
      _this370.Axis = Axis;
      _this370.type = 4261334040;
      return _this370;
    }

    return IfcAxis1Placement;
  }(IfcPlacement);

  IFC2X32.IfcAxis1Placement = IfcAxis1Placement;

  var IfcAxis2Placement2D = /*#__PURE__*/function (_IfcPlacement2) {
    _inherits(IfcAxis2Placement2D, _IfcPlacement2);

    var _super379 = _createSuper(IfcAxis2Placement2D);

    function IfcAxis2Placement2D(expressID, Location, RefDirection) {
      var _this371;

      _classCallCheck2(this, IfcAxis2Placement2D);

      _this371 = _super379.call(this, expressID, Location);
      _this371.Location = Location;
      _this371.RefDirection = RefDirection;
      _this371.type = 3125803723;
      return _this371;
    }

    return IfcAxis2Placement2D;
  }(IfcPlacement);

  IFC2X32.IfcAxis2Placement2D = IfcAxis2Placement2D;

  var IfcAxis2Placement3D = /*#__PURE__*/function (_IfcPlacement3) {
    _inherits(IfcAxis2Placement3D, _IfcPlacement3);

    var _super380 = _createSuper(IfcAxis2Placement3D);

    function IfcAxis2Placement3D(expressID, Location, Axis, RefDirection) {
      var _this372;

      _classCallCheck2(this, IfcAxis2Placement3D);

      _this372 = _super380.call(this, expressID, Location);
      _this372.Location = Location;
      _this372.Axis = Axis;
      _this372.RefDirection = RefDirection;
      _this372.type = 2740243338;
      return _this372;
    }

    return IfcAxis2Placement3D;
  }(IfcPlacement);

  IFC2X32.IfcAxis2Placement3D = IfcAxis2Placement3D;

  var IfcBooleanResult = /*#__PURE__*/function (_IfcGeometricRepresen17) {
    _inherits(IfcBooleanResult, _IfcGeometricRepresen17);

    var _super381 = _createSuper(IfcBooleanResult);

    function IfcBooleanResult(expressID, Operator, FirstOperand, SecondOperand) {
      var _this373;

      _classCallCheck2(this, IfcBooleanResult);

      _this373 = _super381.call(this, expressID);
      _this373.Operator = Operator;
      _this373.FirstOperand = FirstOperand;
      _this373.SecondOperand = SecondOperand;
      _this373.type = 2736907675;
      return _this373;
    }

    return IfcBooleanResult;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcBooleanResult = IfcBooleanResult;

  var IfcBoundedSurface = /*#__PURE__*/function (_IfcSurface2) {
    _inherits(IfcBoundedSurface, _IfcSurface2);

    var _super382 = _createSuper(IfcBoundedSurface);

    function IfcBoundedSurface(expressID) {
      var _this374;

      _classCallCheck2(this, IfcBoundedSurface);

      _this374 = _super382.call(this, expressID);
      _this374.type = 4182860854;
      return _this374;
    }

    return IfcBoundedSurface;
  }(IfcSurface);

  IFC2X32.IfcBoundedSurface = IfcBoundedSurface;

  var IfcBoundingBox = /*#__PURE__*/function (_IfcGeometricRepresen18) {
    _inherits(IfcBoundingBox, _IfcGeometricRepresen18);

    var _super383 = _createSuper(IfcBoundingBox);

    function IfcBoundingBox(expressID, Corner, XDim, YDim, ZDim) {
      var _this375;

      _classCallCheck2(this, IfcBoundingBox);

      _this375 = _super383.call(this, expressID);
      _this375.Corner = Corner;
      _this375.XDim = XDim;
      _this375.YDim = YDim;
      _this375.ZDim = ZDim;
      _this375.type = 2581212453;
      return _this375;
    }

    return IfcBoundingBox;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcBoundingBox = IfcBoundingBox;

  var IfcBoxedHalfSpace = /*#__PURE__*/function (_IfcHalfSpaceSolid2) {
    _inherits(IfcBoxedHalfSpace, _IfcHalfSpaceSolid2);

    var _super384 = _createSuper(IfcBoxedHalfSpace);

    function IfcBoxedHalfSpace(expressID, BaseSurface, AgreementFlag, Enclosure) {
      var _this376;

      _classCallCheck2(this, IfcBoxedHalfSpace);

      _this376 = _super384.call(this, expressID, BaseSurface, AgreementFlag);
      _this376.BaseSurface = BaseSurface;
      _this376.AgreementFlag = AgreementFlag;
      _this376.Enclosure = Enclosure;
      _this376.type = 2713105998;
      return _this376;
    }

    return IfcBoxedHalfSpace;
  }(IfcHalfSpaceSolid);

  IFC2X32.IfcBoxedHalfSpace = IfcBoxedHalfSpace;

  var IfcCShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf6) {
    _inherits(IfcCShapeProfileDef, _IfcParameterizedProf6);

    var _super385 = _createSuper(IfcCShapeProfileDef);

    function IfcCShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius, CentreOfGravityInX) {
      var _this377;

      _classCallCheck2(this, IfcCShapeProfileDef);

      _this377 = _super385.call(this, expressID, ProfileType, ProfileName, Position);
      _this377.ProfileType = ProfileType;
      _this377.ProfileName = ProfileName;
      _this377.Position = Position;
      _this377.Depth = Depth;
      _this377.Width = Width;
      _this377.WallThickness = WallThickness;
      _this377.Girth = Girth;
      _this377.InternalFilletRadius = InternalFilletRadius;
      _this377.CentreOfGravityInX = CentreOfGravityInX;
      _this377.type = 2898889636;
      return _this377;
    }

    return IfcCShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcCShapeProfileDef = IfcCShapeProfileDef;

  var IfcCartesianPoint = /*#__PURE__*/function (_IfcPoint3) {
    _inherits(IfcCartesianPoint, _IfcPoint3);

    var _super386 = _createSuper(IfcCartesianPoint);

    function IfcCartesianPoint(expressID, Coordinates) {
      var _this378;

      _classCallCheck2(this, IfcCartesianPoint);

      _this378 = _super386.call(this, expressID);
      _this378.Coordinates = Coordinates;
      _this378.type = 1123145078;
      return _this378;
    }

    return IfcCartesianPoint;
  }(IfcPoint);

  IFC2X32.IfcCartesianPoint = IfcCartesianPoint;

  var IfcCartesianTransformationOperator = /*#__PURE__*/function (_IfcGeometricRepresen19) {
    _inherits(IfcCartesianTransformationOperator, _IfcGeometricRepresen19);

    var _super387 = _createSuper(IfcCartesianTransformationOperator);

    function IfcCartesianTransformationOperator(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      var _this379;

      _classCallCheck2(this, IfcCartesianTransformationOperator);

      _this379 = _super387.call(this, expressID);
      _this379.Axis1 = Axis1;
      _this379.Axis2 = Axis2;
      _this379.LocalOrigin = LocalOrigin;
      _this379.Scale = Scale;
      _this379.type = 59481748;
      return _this379;
    }

    return IfcCartesianTransformationOperator;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;

  var IfcCartesianTransformationOperator2D = /*#__PURE__*/function (_IfcCartesianTransfor) {
    _inherits(IfcCartesianTransformationOperator2D, _IfcCartesianTransfor);

    var _super388 = _createSuper(IfcCartesianTransformationOperator2D);

    function IfcCartesianTransformationOperator2D(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      var _this380;

      _classCallCheck2(this, IfcCartesianTransformationOperator2D);

      _this380 = _super388.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale);
      _this380.Axis1 = Axis1;
      _this380.Axis2 = Axis2;
      _this380.LocalOrigin = LocalOrigin;
      _this380.Scale = Scale;
      _this380.type = 3749851601;
      return _this380;
    }

    return IfcCartesianTransformationOperator2D;
  }(IfcCartesianTransformationOperator);

  IFC2X32.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;

  var IfcCartesianTransformationOperator2DnonUniform = /*#__PURE__*/function (_IfcCartesianTransfor2) {
    _inherits(IfcCartesianTransformationOperator2DnonUniform, _IfcCartesianTransfor2);

    var _super389 = _createSuper(IfcCartesianTransformationOperator2DnonUniform);

    function IfcCartesianTransformationOperator2DnonUniform(expressID, Axis1, Axis2, LocalOrigin, Scale, Scale2) {
      var _this381;

      _classCallCheck2(this, IfcCartesianTransformationOperator2DnonUniform);

      _this381 = _super389.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale);
      _this381.Axis1 = Axis1;
      _this381.Axis2 = Axis2;
      _this381.LocalOrigin = LocalOrigin;
      _this381.Scale = Scale;
      _this381.Scale2 = Scale2;
      _this381.type = 3486308946;
      return _this381;
    }

    return IfcCartesianTransformationOperator2DnonUniform;
  }(IfcCartesianTransformationOperator2D);

  IFC2X32.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;

  var IfcCartesianTransformationOperator3D = /*#__PURE__*/function (_IfcCartesianTransfor3) {
    _inherits(IfcCartesianTransformationOperator3D, _IfcCartesianTransfor3);

    var _super390 = _createSuper(IfcCartesianTransformationOperator3D);

    function IfcCartesianTransformationOperator3D(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3) {
      var _this382;

      _classCallCheck2(this, IfcCartesianTransformationOperator3D);

      _this382 = _super390.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale);
      _this382.Axis1 = Axis1;
      _this382.Axis2 = Axis2;
      _this382.LocalOrigin = LocalOrigin;
      _this382.Scale = Scale;
      _this382.Axis3 = Axis3;
      _this382.type = 3331915920;
      return _this382;
    }

    return IfcCartesianTransformationOperator3D;
  }(IfcCartesianTransformationOperator);

  IFC2X32.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;

  var IfcCartesianTransformationOperator3DnonUniform = /*#__PURE__*/function (_IfcCartesianTransfor4) {
    _inherits(IfcCartesianTransformationOperator3DnonUniform, _IfcCartesianTransfor4);

    var _super391 = _createSuper(IfcCartesianTransformationOperator3DnonUniform);

    function IfcCartesianTransformationOperator3DnonUniform(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3) {
      var _this383;

      _classCallCheck2(this, IfcCartesianTransformationOperator3DnonUniform);

      _this383 = _super391.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3);
      _this383.Axis1 = Axis1;
      _this383.Axis2 = Axis2;
      _this383.LocalOrigin = LocalOrigin;
      _this383.Scale = Scale;
      _this383.Axis3 = Axis3;
      _this383.Scale2 = Scale2;
      _this383.Scale3 = Scale3;
      _this383.type = 1416205885;
      return _this383;
    }

    return IfcCartesianTransformationOperator3DnonUniform;
  }(IfcCartesianTransformationOperator3D);

  IFC2X32.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;

  var IfcCircleProfileDef = /*#__PURE__*/function (_IfcParameterizedProf7) {
    _inherits(IfcCircleProfileDef, _IfcParameterizedProf7);

    var _super392 = _createSuper(IfcCircleProfileDef);

    function IfcCircleProfileDef(expressID, ProfileType, ProfileName, Position, Radius) {
      var _this384;

      _classCallCheck2(this, IfcCircleProfileDef);

      _this384 = _super392.call(this, expressID, ProfileType, ProfileName, Position);
      _this384.ProfileType = ProfileType;
      _this384.ProfileName = ProfileName;
      _this384.Position = Position;
      _this384.Radius = Radius;
      _this384.type = 1383045692;
      return _this384;
    }

    return IfcCircleProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcCircleProfileDef = IfcCircleProfileDef;

  var IfcClosedShell = /*#__PURE__*/function (_IfcConnectedFaceSet2) {
    _inherits(IfcClosedShell, _IfcConnectedFaceSet2);

    var _super393 = _createSuper(IfcClosedShell);

    function IfcClosedShell(expressID, CfsFaces) {
      var _this385;

      _classCallCheck2(this, IfcClosedShell);

      _this385 = _super393.call(this, expressID, CfsFaces);
      _this385.CfsFaces = CfsFaces;
      _this385.type = 2205249479;
      return _this385;
    }

    return IfcClosedShell;
  }(IfcConnectedFaceSet);

  IFC2X32.IfcClosedShell = IfcClosedShell;

  var IfcCompositeCurveSegment = /*#__PURE__*/function (_IfcGeometricRepresen20) {
    _inherits(IfcCompositeCurveSegment, _IfcGeometricRepresen20);

    var _super394 = _createSuper(IfcCompositeCurveSegment);

    function IfcCompositeCurveSegment(expressID, Transition, SameSense, ParentCurve) {
      var _this386;

      _classCallCheck2(this, IfcCompositeCurveSegment);

      _this386 = _super394.call(this, expressID);
      _this386.Transition = Transition;
      _this386.SameSense = SameSense;
      _this386.ParentCurve = ParentCurve;
      _this386.type = 2485617015;
      return _this386;
    }

    return IfcCompositeCurveSegment;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcCompositeCurveSegment = IfcCompositeCurveSegment;

  var IfcCraneRailAShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf8) {
    _inherits(IfcCraneRailAShapeProfileDef, _IfcParameterizedProf8);

    var _super395 = _createSuper(IfcCraneRailAShapeProfileDef);

    function IfcCraneRailAShapeProfileDef(expressID, ProfileType, ProfileName, Position, OverallHeight, BaseWidth2, Radius, HeadWidth, HeadDepth2, HeadDepth3, WebThickness, BaseWidth4, BaseDepth1, BaseDepth2, BaseDepth3, CentreOfGravityInY) {
      var _this387;

      _classCallCheck2(this, IfcCraneRailAShapeProfileDef);

      _this387 = _super395.call(this, expressID, ProfileType, ProfileName, Position);
      _this387.ProfileType = ProfileType;
      _this387.ProfileName = ProfileName;
      _this387.Position = Position;
      _this387.OverallHeight = OverallHeight;
      _this387.BaseWidth2 = BaseWidth2;
      _this387.Radius = Radius;
      _this387.HeadWidth = HeadWidth;
      _this387.HeadDepth2 = HeadDepth2;
      _this387.HeadDepth3 = HeadDepth3;
      _this387.WebThickness = WebThickness;
      _this387.BaseWidth4 = BaseWidth4;
      _this387.BaseDepth1 = BaseDepth1;
      _this387.BaseDepth2 = BaseDepth2;
      _this387.BaseDepth3 = BaseDepth3;
      _this387.CentreOfGravityInY = CentreOfGravityInY;
      _this387.type = 4133800736;
      return _this387;
    }

    return IfcCraneRailAShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcCraneRailAShapeProfileDef = IfcCraneRailAShapeProfileDef;

  var IfcCraneRailFShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf9) {
    _inherits(IfcCraneRailFShapeProfileDef, _IfcParameterizedProf9);

    var _super396 = _createSuper(IfcCraneRailFShapeProfileDef);

    function IfcCraneRailFShapeProfileDef(expressID, ProfileType, ProfileName, Position, OverallHeight, HeadWidth, Radius, HeadDepth2, HeadDepth3, WebThickness, BaseDepth1, BaseDepth2, CentreOfGravityInY) {
      var _this388;

      _classCallCheck2(this, IfcCraneRailFShapeProfileDef);

      _this388 = _super396.call(this, expressID, ProfileType, ProfileName, Position);
      _this388.ProfileType = ProfileType;
      _this388.ProfileName = ProfileName;
      _this388.Position = Position;
      _this388.OverallHeight = OverallHeight;
      _this388.HeadWidth = HeadWidth;
      _this388.Radius = Radius;
      _this388.HeadDepth2 = HeadDepth2;
      _this388.HeadDepth3 = HeadDepth3;
      _this388.WebThickness = WebThickness;
      _this388.BaseDepth1 = BaseDepth1;
      _this388.BaseDepth2 = BaseDepth2;
      _this388.CentreOfGravityInY = CentreOfGravityInY;
      _this388.type = 194851669;
      return _this388;
    }

    return IfcCraneRailFShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcCraneRailFShapeProfileDef = IfcCraneRailFShapeProfileDef;

  var IfcCsgPrimitive3D = /*#__PURE__*/function (_IfcGeometricRepresen21) {
    _inherits(IfcCsgPrimitive3D, _IfcGeometricRepresen21);

    var _super397 = _createSuper(IfcCsgPrimitive3D);

    function IfcCsgPrimitive3D(expressID, Position) {
      var _this389;

      _classCallCheck2(this, IfcCsgPrimitive3D);

      _this389 = _super397.call(this, expressID);
      _this389.Position = Position;
      _this389.type = 2506170314;
      return _this389;
    }

    return IfcCsgPrimitive3D;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcCsgPrimitive3D = IfcCsgPrimitive3D;

  var IfcCsgSolid = /*#__PURE__*/function (_IfcSolidModel3) {
    _inherits(IfcCsgSolid, _IfcSolidModel3);

    var _super398 = _createSuper(IfcCsgSolid);

    function IfcCsgSolid(expressID, TreeRootExpression) {
      var _this390;

      _classCallCheck2(this, IfcCsgSolid);

      _this390 = _super398.call(this, expressID);
      _this390.TreeRootExpression = TreeRootExpression;
      _this390.type = 2147822146;
      return _this390;
    }

    return IfcCsgSolid;
  }(IfcSolidModel);

  IFC2X32.IfcCsgSolid = IfcCsgSolid;

  var IfcCurve = /*#__PURE__*/function (_IfcGeometricRepresen22) {
    _inherits(IfcCurve, _IfcGeometricRepresen22);

    var _super399 = _createSuper(IfcCurve);

    function IfcCurve(expressID) {
      var _this391;

      _classCallCheck2(this, IfcCurve);

      _this391 = _super399.call(this, expressID);
      _this391.type = 2601014836;
      return _this391;
    }

    return IfcCurve;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcCurve = IfcCurve;

  var IfcCurveBoundedPlane = /*#__PURE__*/function (_IfcBoundedSurface) {
    _inherits(IfcCurveBoundedPlane, _IfcBoundedSurface);

    var _super400 = _createSuper(IfcCurveBoundedPlane);

    function IfcCurveBoundedPlane(expressID, BasisSurface, OuterBoundary, InnerBoundaries) {
      var _this392;

      _classCallCheck2(this, IfcCurveBoundedPlane);

      _this392 = _super400.call(this, expressID);
      _this392.BasisSurface = BasisSurface;
      _this392.OuterBoundary = OuterBoundary;
      _this392.InnerBoundaries = InnerBoundaries;
      _this392.type = 2827736869;
      return _this392;
    }

    return IfcCurveBoundedPlane;
  }(IfcBoundedSurface);

  IFC2X32.IfcCurveBoundedPlane = IfcCurveBoundedPlane;

  var IfcDefinedSymbol = /*#__PURE__*/function (_IfcGeometricRepresen23) {
    _inherits(IfcDefinedSymbol, _IfcGeometricRepresen23);

    var _super401 = _createSuper(IfcDefinedSymbol);

    function IfcDefinedSymbol(expressID, Definition, Target) {
      var _this393;

      _classCallCheck2(this, IfcDefinedSymbol);

      _this393 = _super401.call(this, expressID);
      _this393.Definition = Definition;
      _this393.Target = Target;
      _this393.type = 693772133;
      return _this393;
    }

    return IfcDefinedSymbol;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcDefinedSymbol = IfcDefinedSymbol;

  var IfcDimensionCurve = /*#__PURE__*/function (_IfcAnnotationCurveOc) {
    _inherits(IfcDimensionCurve, _IfcAnnotationCurveOc);

    var _super402 = _createSuper(IfcDimensionCurve);

    function IfcDimensionCurve(expressID, Item, Styles, Name) {
      var _this394;

      _classCallCheck2(this, IfcDimensionCurve);

      _this394 = _super402.call(this, expressID, Item, Styles, Name);
      _this394.Item = Item;
      _this394.Styles = Styles;
      _this394.Name = Name;
      _this394.type = 606661476;
      return _this394;
    }

    return IfcDimensionCurve;
  }(IfcAnnotationCurveOccurrence);

  IFC2X32.IfcDimensionCurve = IfcDimensionCurve;

  var IfcDimensionCurveTerminator = /*#__PURE__*/function (_IfcTerminatorSymbol) {
    _inherits(IfcDimensionCurveTerminator, _IfcTerminatorSymbol);

    var _super403 = _createSuper(IfcDimensionCurveTerminator);

    function IfcDimensionCurveTerminator(expressID, Item, Styles, Name, AnnotatedCurve, Role) {
      var _this395;

      _classCallCheck2(this, IfcDimensionCurveTerminator);

      _this395 = _super403.call(this, expressID, Item, Styles, Name, AnnotatedCurve);
      _this395.Item = Item;
      _this395.Styles = Styles;
      _this395.Name = Name;
      _this395.AnnotatedCurve = AnnotatedCurve;
      _this395.Role = Role;
      _this395.type = 4054601972;
      return _this395;
    }

    return IfcDimensionCurveTerminator;
  }(IfcTerminatorSymbol);

  IFC2X32.IfcDimensionCurveTerminator = IfcDimensionCurveTerminator;

  var IfcDirection = /*#__PURE__*/function (_IfcGeometricRepresen24) {
    _inherits(IfcDirection, _IfcGeometricRepresen24);

    var _super404 = _createSuper(IfcDirection);

    function IfcDirection(expressID, DirectionRatios) {
      var _this396;

      _classCallCheck2(this, IfcDirection);

      _this396 = _super404.call(this, expressID);
      _this396.DirectionRatios = DirectionRatios;
      _this396.type = 32440307;
      return _this396;
    }

    return IfcDirection;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcDirection = IfcDirection;

  var IfcDoorLiningProperties = /*#__PURE__*/function (_IfcPropertySetDefini8) {
    _inherits(IfcDoorLiningProperties, _IfcPropertySetDefini8);

    var _super405 = _createSuper(IfcDoorLiningProperties);

    function IfcDoorLiningProperties(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle) {
      var _this397;

      _classCallCheck2(this, IfcDoorLiningProperties);

      _this397 = _super405.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this397.GlobalId = GlobalId;
      _this397.OwnerHistory = OwnerHistory;
      _this397.Name = Name;
      _this397.Description = Description;
      _this397.LiningDepth = LiningDepth;
      _this397.LiningThickness = LiningThickness;
      _this397.ThresholdDepth = ThresholdDepth;
      _this397.ThresholdThickness = ThresholdThickness;
      _this397.TransomThickness = TransomThickness;
      _this397.TransomOffset = TransomOffset;
      _this397.LiningOffset = LiningOffset;
      _this397.ThresholdOffset = ThresholdOffset;
      _this397.CasingThickness = CasingThickness;
      _this397.CasingDepth = CasingDepth;
      _this397.ShapeAspectStyle = ShapeAspectStyle;
      _this397.type = 2963535650;
      return _this397;
    }

    return IfcDoorLiningProperties;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcDoorLiningProperties = IfcDoorLiningProperties;

  var IfcDoorPanelProperties = /*#__PURE__*/function (_IfcPropertySetDefini9) {
    _inherits(IfcDoorPanelProperties, _IfcPropertySetDefini9);

    var _super406 = _createSuper(IfcDoorPanelProperties);

    function IfcDoorPanelProperties(expressID, GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle) {
      var _this398;

      _classCallCheck2(this, IfcDoorPanelProperties);

      _this398 = _super406.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this398.GlobalId = GlobalId;
      _this398.OwnerHistory = OwnerHistory;
      _this398.Name = Name;
      _this398.Description = Description;
      _this398.PanelDepth = PanelDepth;
      _this398.PanelOperation = PanelOperation;
      _this398.PanelWidth = PanelWidth;
      _this398.PanelPosition = PanelPosition;
      _this398.ShapeAspectStyle = ShapeAspectStyle;
      _this398.type = 1714330368;
      return _this398;
    }

    return IfcDoorPanelProperties;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcDoorPanelProperties = IfcDoorPanelProperties;

  var IfcDoorStyle = /*#__PURE__*/function (_IfcTypeProduct2) {
    _inherits(IfcDoorStyle, _IfcTypeProduct2);

    var _super407 = _createSuper(IfcDoorStyle);

    function IfcDoorStyle(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, OperationType, ConstructionType, ParameterTakesPrecedence, Sizeable) {
      var _this399;

      _classCallCheck2(this, IfcDoorStyle);

      _this399 = _super407.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      _this399.GlobalId = GlobalId;
      _this399.OwnerHistory = OwnerHistory;
      _this399.Name = Name;
      _this399.Description = Description;
      _this399.ApplicableOccurrence = ApplicableOccurrence;
      _this399.HasPropertySets = HasPropertySets;
      _this399.RepresentationMaps = RepresentationMaps;
      _this399.Tag = Tag;
      _this399.OperationType = OperationType;
      _this399.ConstructionType = ConstructionType;
      _this399.ParameterTakesPrecedence = ParameterTakesPrecedence;
      _this399.Sizeable = Sizeable;
      _this399.type = 526551008;
      return _this399;
    }

    return IfcDoorStyle;
  }(IfcTypeProduct);

  IFC2X32.IfcDoorStyle = IfcDoorStyle;

  var IfcDraughtingCallout = /*#__PURE__*/function (_IfcGeometricRepresen25) {
    _inherits(IfcDraughtingCallout, _IfcGeometricRepresen25);

    var _super408 = _createSuper(IfcDraughtingCallout);

    function IfcDraughtingCallout(expressID, Contents) {
      var _this400;

      _classCallCheck2(this, IfcDraughtingCallout);

      _this400 = _super408.call(this, expressID);
      _this400.Contents = Contents;
      _this400.type = 3073041342;
      return _this400;
    }

    return IfcDraughtingCallout;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcDraughtingCallout = IfcDraughtingCallout;

  var IfcDraughtingPreDefinedColour = /*#__PURE__*/function (_IfcPreDefinedColour) {
    _inherits(IfcDraughtingPreDefinedColour, _IfcPreDefinedColour);

    var _super409 = _createSuper(IfcDraughtingPreDefinedColour);

    function IfcDraughtingPreDefinedColour(expressID, Name) {
      var _this401;

      _classCallCheck2(this, IfcDraughtingPreDefinedColour);

      _this401 = _super409.call(this, expressID, Name);
      _this401.Name = Name;
      _this401.type = 445594917;
      return _this401;
    }

    return IfcDraughtingPreDefinedColour;
  }(IfcPreDefinedColour);

  IFC2X32.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;

  var IfcDraughtingPreDefinedCurveFont = /*#__PURE__*/function (_IfcPreDefinedCurveFo) {
    _inherits(IfcDraughtingPreDefinedCurveFont, _IfcPreDefinedCurveFo);

    var _super410 = _createSuper(IfcDraughtingPreDefinedCurveFont);

    function IfcDraughtingPreDefinedCurveFont(expressID, Name) {
      var _this402;

      _classCallCheck2(this, IfcDraughtingPreDefinedCurveFont);

      _this402 = _super410.call(this, expressID, Name);
      _this402.Name = Name;
      _this402.type = 4006246654;
      return _this402;
    }

    return IfcDraughtingPreDefinedCurveFont;
  }(IfcPreDefinedCurveFont);

  IFC2X32.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;

  var IfcEdgeLoop = /*#__PURE__*/function (_IfcLoop3) {
    _inherits(IfcEdgeLoop, _IfcLoop3);

    var _super411 = _createSuper(IfcEdgeLoop);

    function IfcEdgeLoop(expressID, EdgeList) {
      var _this403;

      _classCallCheck2(this, IfcEdgeLoop);

      _this403 = _super411.call(this, expressID);
      _this403.EdgeList = EdgeList;
      _this403.type = 1472233963;
      return _this403;
    }

    return IfcEdgeLoop;
  }(IfcLoop);

  IFC2X32.IfcEdgeLoop = IfcEdgeLoop;

  var IfcElementQuantity = /*#__PURE__*/function (_IfcPropertySetDefini10) {
    _inherits(IfcElementQuantity, _IfcPropertySetDefini10);

    var _super412 = _createSuper(IfcElementQuantity);

    function IfcElementQuantity(expressID, GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities) {
      var _this404;

      _classCallCheck2(this, IfcElementQuantity);

      _this404 = _super412.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this404.GlobalId = GlobalId;
      _this404.OwnerHistory = OwnerHistory;
      _this404.Name = Name;
      _this404.Description = Description;
      _this404.MethodOfMeasurement = MethodOfMeasurement;
      _this404.Quantities = Quantities;
      _this404.type = 1883228015;
      return _this404;
    }

    return IfcElementQuantity;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcElementQuantity = IfcElementQuantity;

  var IfcElementType = /*#__PURE__*/function (_IfcTypeProduct3) {
    _inherits(IfcElementType, _IfcTypeProduct3);

    var _super413 = _createSuper(IfcElementType);

    function IfcElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this405;

      _classCallCheck2(this, IfcElementType);

      _this405 = _super413.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      _this405.GlobalId = GlobalId;
      _this405.OwnerHistory = OwnerHistory;
      _this405.Name = Name;
      _this405.Description = Description;
      _this405.ApplicableOccurrence = ApplicableOccurrence;
      _this405.HasPropertySets = HasPropertySets;
      _this405.RepresentationMaps = RepresentationMaps;
      _this405.Tag = Tag;
      _this405.ElementType = ElementType;
      _this405.type = 339256511;
      return _this405;
    }

    return IfcElementType;
  }(IfcTypeProduct);

  IFC2X32.IfcElementType = IfcElementType;

  var IfcElementarySurface = /*#__PURE__*/function (_IfcSurface3) {
    _inherits(IfcElementarySurface, _IfcSurface3);

    var _super414 = _createSuper(IfcElementarySurface);

    function IfcElementarySurface(expressID, Position) {
      var _this406;

      _classCallCheck2(this, IfcElementarySurface);

      _this406 = _super414.call(this, expressID);
      _this406.Position = Position;
      _this406.type = 2777663545;
      return _this406;
    }

    return IfcElementarySurface;
  }(IfcSurface);

  IFC2X32.IfcElementarySurface = IfcElementarySurface;

  var IfcEllipseProfileDef = /*#__PURE__*/function (_IfcParameterizedProf10) {
    _inherits(IfcEllipseProfileDef, _IfcParameterizedProf10);

    var _super415 = _createSuper(IfcEllipseProfileDef);

    function IfcEllipseProfileDef(expressID, ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2) {
      var _this407;

      _classCallCheck2(this, IfcEllipseProfileDef);

      _this407 = _super415.call(this, expressID, ProfileType, ProfileName, Position);
      _this407.ProfileType = ProfileType;
      _this407.ProfileName = ProfileName;
      _this407.Position = Position;
      _this407.SemiAxis1 = SemiAxis1;
      _this407.SemiAxis2 = SemiAxis2;
      _this407.type = 2835456948;
      return _this407;
    }

    return IfcEllipseProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcEllipseProfileDef = IfcEllipseProfileDef;

  var IfcEnergyProperties = /*#__PURE__*/function (_IfcPropertySetDefini11) {
    _inherits(IfcEnergyProperties, _IfcPropertySetDefini11);

    var _super416 = _createSuper(IfcEnergyProperties);

    function IfcEnergyProperties(expressID, GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence) {
      var _this408;

      _classCallCheck2(this, IfcEnergyProperties);

      _this408 = _super416.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this408.GlobalId = GlobalId;
      _this408.OwnerHistory = OwnerHistory;
      _this408.Name = Name;
      _this408.Description = Description;
      _this408.EnergySequence = EnergySequence;
      _this408.UserDefinedEnergySequence = UserDefinedEnergySequence;
      _this408.type = 80994333;
      return _this408;
    }

    return IfcEnergyProperties;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcEnergyProperties = IfcEnergyProperties;

  var IfcExtrudedAreaSolid = /*#__PURE__*/function (_IfcSweptAreaSolid) {
    _inherits(IfcExtrudedAreaSolid, _IfcSweptAreaSolid);

    var _super417 = _createSuper(IfcExtrudedAreaSolid);

    function IfcExtrudedAreaSolid(expressID, SweptArea, Position, ExtrudedDirection, Depth) {
      var _this409;

      _classCallCheck2(this, IfcExtrudedAreaSolid);

      _this409 = _super417.call(this, expressID, SweptArea, Position);
      _this409.SweptArea = SweptArea;
      _this409.Position = Position;
      _this409.ExtrudedDirection = ExtrudedDirection;
      _this409.Depth = Depth;
      _this409.type = 477187591;
      return _this409;
    }

    return IfcExtrudedAreaSolid;
  }(IfcSweptAreaSolid);

  IFC2X32.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;

  var IfcFaceBasedSurfaceModel = /*#__PURE__*/function (_IfcGeometricRepresen26) {
    _inherits(IfcFaceBasedSurfaceModel, _IfcGeometricRepresen26);

    var _super418 = _createSuper(IfcFaceBasedSurfaceModel);

    function IfcFaceBasedSurfaceModel(expressID, FbsmFaces) {
      var _this410;

      _classCallCheck2(this, IfcFaceBasedSurfaceModel);

      _this410 = _super418.call(this, expressID);
      _this410.FbsmFaces = FbsmFaces;
      _this410.type = 2047409740;
      return _this410;
    }

    return IfcFaceBasedSurfaceModel;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;

  var IfcFillAreaStyleHatching = /*#__PURE__*/function (_IfcGeometricRepresen27) {
    _inherits(IfcFillAreaStyleHatching, _IfcGeometricRepresen27);

    var _super419 = _createSuper(IfcFillAreaStyleHatching);

    function IfcFillAreaStyleHatching(expressID, HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle) {
      var _this411;

      _classCallCheck2(this, IfcFillAreaStyleHatching);

      _this411 = _super419.call(this, expressID);
      _this411.HatchLineAppearance = HatchLineAppearance;
      _this411.StartOfNextHatchLine = StartOfNextHatchLine;
      _this411.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
      _this411.PatternStart = PatternStart;
      _this411.HatchLineAngle = HatchLineAngle;
      _this411.type = 374418227;
      return _this411;
    }

    return IfcFillAreaStyleHatching;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;

  var IfcFillAreaStyleTileSymbolWithStyle = /*#__PURE__*/function (_IfcGeometricRepresen28) {
    _inherits(IfcFillAreaStyleTileSymbolWithStyle, _IfcGeometricRepresen28);

    var _super420 = _createSuper(IfcFillAreaStyleTileSymbolWithStyle);

    function IfcFillAreaStyleTileSymbolWithStyle(expressID, Symbol2) {
      var _this412;

      _classCallCheck2(this, IfcFillAreaStyleTileSymbolWithStyle);

      _this412 = _super420.call(this, expressID);
      _this412.Symbol = Symbol2;
      _this412.type = 4203026998;
      return _this412;
    }

    return IfcFillAreaStyleTileSymbolWithStyle;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcFillAreaStyleTileSymbolWithStyle = IfcFillAreaStyleTileSymbolWithStyle;

  var IfcFillAreaStyleTiles = /*#__PURE__*/function (_IfcGeometricRepresen29) {
    _inherits(IfcFillAreaStyleTiles, _IfcGeometricRepresen29);

    var _super421 = _createSuper(IfcFillAreaStyleTiles);

    function IfcFillAreaStyleTiles(expressID, TilingPattern, Tiles, TilingScale) {
      var _this413;

      _classCallCheck2(this, IfcFillAreaStyleTiles);

      _this413 = _super421.call(this, expressID);
      _this413.TilingPattern = TilingPattern;
      _this413.Tiles = Tiles;
      _this413.TilingScale = TilingScale;
      _this413.type = 315944413;
      return _this413;
    }

    return IfcFillAreaStyleTiles;
  }(IfcGeometricRepresentationItem);

  IFC2X32.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;

  var IfcFluidFlowProperties = /*#__PURE__*/function (_IfcPropertySetDefini12) {
    _inherits(IfcFluidFlowProperties, _IfcPropertySetDefini12);

    var _super422 = _createSuper(IfcFluidFlowProperties);

    function IfcFluidFlowProperties(expressID, GlobalId, OwnerHistory, Name, Description, PropertySource, FlowConditionTimeSeries, VelocityTimeSeries, FlowrateTimeSeries, Fluid, PressureTimeSeries, UserDefinedPropertySource, TemperatureSingleValue, WetBulbTemperatureSingleValue, WetBulbTemperatureTimeSeries, TemperatureTimeSeries, FlowrateSingleValue, FlowConditionSingleValue, VelocitySingleValue, PressureSingleValue) {
      var _this414;

      _classCallCheck2(this, IfcFluidFlowProperties);

      _this414 = _super422.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this414.GlobalId = GlobalId;
      _this414.OwnerHistory = OwnerHistory;
      _this414.Name = Name;
      _this414.Description = Description;
      _this414.PropertySource = PropertySource;
      _this414.FlowConditionTimeSeries = FlowConditionTimeSeries;
      _this414.VelocityTimeSeries = VelocityTimeSeries;
      _this414.FlowrateTimeSeries = FlowrateTimeSeries;
      _this414.Fluid = Fluid;
      _this414.PressureTimeSeries = PressureTimeSeries;
      _this414.UserDefinedPropertySource = UserDefinedPropertySource;
      _this414.TemperatureSingleValue = TemperatureSingleValue;
      _this414.WetBulbTemperatureSingleValue = WetBulbTemperatureSingleValue;
      _this414.WetBulbTemperatureTimeSeries = WetBulbTemperatureTimeSeries;
      _this414.TemperatureTimeSeries = TemperatureTimeSeries;
      _this414.FlowrateSingleValue = FlowrateSingleValue;
      _this414.FlowConditionSingleValue = FlowConditionSingleValue;
      _this414.VelocitySingleValue = VelocitySingleValue;
      _this414.PressureSingleValue = PressureSingleValue;
      _this414.type = 3455213021;
      return _this414;
    }

    return IfcFluidFlowProperties;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcFluidFlowProperties = IfcFluidFlowProperties;

  var IfcFurnishingElementType = /*#__PURE__*/function (_IfcElementType) {
    _inherits(IfcFurnishingElementType, _IfcElementType);

    var _super423 = _createSuper(IfcFurnishingElementType);

    function IfcFurnishingElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this415;

      _classCallCheck2(this, IfcFurnishingElementType);

      _this415 = _super423.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this415.GlobalId = GlobalId;
      _this415.OwnerHistory = OwnerHistory;
      _this415.Name = Name;
      _this415.Description = Description;
      _this415.ApplicableOccurrence = ApplicableOccurrence;
      _this415.HasPropertySets = HasPropertySets;
      _this415.RepresentationMaps = RepresentationMaps;
      _this415.Tag = Tag;
      _this415.ElementType = ElementType;
      _this415.type = 4238390223;
      return _this415;
    }

    return IfcFurnishingElementType;
  }(IfcElementType);

  IFC2X32.IfcFurnishingElementType = IfcFurnishingElementType;

  var IfcFurnitureType = /*#__PURE__*/function (_IfcFurnishingElement) {
    _inherits(IfcFurnitureType, _IfcFurnishingElement);

    var _super424 = _createSuper(IfcFurnitureType);

    function IfcFurnitureType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace) {
      var _this416;

      _classCallCheck2(this, IfcFurnitureType);

      _this416 = _super424.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this416.GlobalId = GlobalId;
      _this416.OwnerHistory = OwnerHistory;
      _this416.Name = Name;
      _this416.Description = Description;
      _this416.ApplicableOccurrence = ApplicableOccurrence;
      _this416.HasPropertySets = HasPropertySets;
      _this416.RepresentationMaps = RepresentationMaps;
      _this416.Tag = Tag;
      _this416.ElementType = ElementType;
      _this416.AssemblyPlace = AssemblyPlace;
      _this416.type = 1268542332;
      return _this416;
    }

    return IfcFurnitureType;
  }(IfcFurnishingElementType);

  IFC2X32.IfcFurnitureType = IfcFurnitureType;

  var IfcGeometricCurveSet = /*#__PURE__*/function (_IfcGeometricSet) {
    _inherits(IfcGeometricCurveSet, _IfcGeometricSet);

    var _super425 = _createSuper(IfcGeometricCurveSet);

    function IfcGeometricCurveSet(expressID, Elements) {
      var _this417;

      _classCallCheck2(this, IfcGeometricCurveSet);

      _this417 = _super425.call(this, expressID, Elements);
      _this417.Elements = Elements;
      _this417.type = 987898635;
      return _this417;
    }

    return IfcGeometricCurveSet;
  }(IfcGeometricSet);

  IFC2X32.IfcGeometricCurveSet = IfcGeometricCurveSet;

  var IfcIShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf11) {
    _inherits(IfcIShapeProfileDef, _IfcParameterizedProf11);

    var _super426 = _createSuper(IfcIShapeProfileDef);

    function IfcIShapeProfileDef(expressID, ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius) {
      var _this418;

      _classCallCheck2(this, IfcIShapeProfileDef);

      _this418 = _super426.call(this, expressID, ProfileType, ProfileName, Position);
      _this418.ProfileType = ProfileType;
      _this418.ProfileName = ProfileName;
      _this418.Position = Position;
      _this418.OverallWidth = OverallWidth;
      _this418.OverallDepth = OverallDepth;
      _this418.WebThickness = WebThickness;
      _this418.FlangeThickness = FlangeThickness;
      _this418.FilletRadius = FilletRadius;
      _this418.type = 1484403080;
      return _this418;
    }

    return IfcIShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcIShapeProfileDef = IfcIShapeProfileDef;

  var IfcLShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf12) {
    _inherits(IfcLShapeProfileDef, _IfcParameterizedProf12);

    var _super427 = _createSuper(IfcLShapeProfileDef);

    function IfcLShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope, CentreOfGravityInX, CentreOfGravityInY) {
      var _this419;

      _classCallCheck2(this, IfcLShapeProfileDef);

      _this419 = _super427.call(this, expressID, ProfileType, ProfileName, Position);
      _this419.ProfileType = ProfileType;
      _this419.ProfileName = ProfileName;
      _this419.Position = Position;
      _this419.Depth = Depth;
      _this419.Width = Width;
      _this419.Thickness = Thickness;
      _this419.FilletRadius = FilletRadius;
      _this419.EdgeRadius = EdgeRadius;
      _this419.LegSlope = LegSlope;
      _this419.CentreOfGravityInX = CentreOfGravityInX;
      _this419.CentreOfGravityInY = CentreOfGravityInY;
      _this419.type = 572779678;
      return _this419;
    }

    return IfcLShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC2X32.IfcLShapeProfileDef = IfcLShapeProfileDef;

  var IfcLine = /*#__PURE__*/function (_IfcCurve) {
    _inherits(IfcLine, _IfcCurve);

    var _super428 = _createSuper(IfcLine);

    function IfcLine(expressID, Pnt, Dir) {
      var _this420;

      _classCallCheck2(this, IfcLine);

      _this420 = _super428.call(this, expressID);
      _this420.Pnt = Pnt;
      _this420.Dir = Dir;
      _this420.type = 1281925730;
      return _this420;
    }

    return IfcLine;
  }(IfcCurve);

  IFC2X32.IfcLine = IfcLine;

  var IfcManifoldSolidBrep = /*#__PURE__*/function (_IfcSolidModel4) {
    _inherits(IfcManifoldSolidBrep, _IfcSolidModel4);

    var _super429 = _createSuper(IfcManifoldSolidBrep);

    function IfcManifoldSolidBrep(expressID, Outer) {
      var _this421;

      _classCallCheck2(this, IfcManifoldSolidBrep);

      _this421 = _super429.call(this, expressID);
      _this421.Outer = Outer;
      _this421.type = 1425443689;
      return _this421;
    }

    return IfcManifoldSolidBrep;
  }(IfcSolidModel);

  IFC2X32.IfcManifoldSolidBrep = IfcManifoldSolidBrep;

  var IfcObject = /*#__PURE__*/function (_IfcObjectDefinition2) {
    _inherits(IfcObject, _IfcObjectDefinition2);

    var _super430 = _createSuper(IfcObject);

    function IfcObject(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this422;

      _classCallCheck2(this, IfcObject);

      _this422 = _super430.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this422.GlobalId = GlobalId;
      _this422.OwnerHistory = OwnerHistory;
      _this422.Name = Name;
      _this422.Description = Description;
      _this422.ObjectType = ObjectType;
      _this422.type = 3888040117;
      return _this422;
    }

    return IfcObject;
  }(IfcObjectDefinition);

  IFC2X32.IfcObject = IfcObject;

  var IfcOffsetCurve2D = /*#__PURE__*/function (_IfcCurve2) {
    _inherits(IfcOffsetCurve2D, _IfcCurve2);

    var _super431 = _createSuper(IfcOffsetCurve2D);

    function IfcOffsetCurve2D(expressID, BasisCurve, Distance, SelfIntersect) {
      var _this423;

      _classCallCheck2(this, IfcOffsetCurve2D);

      _this423 = _super431.call(this, expressID);
      _this423.BasisCurve = BasisCurve;
      _this423.Distance = Distance;
      _this423.SelfIntersect = SelfIntersect;
      _this423.type = 3388369263;
      return _this423;
    }

    return IfcOffsetCurve2D;
  }(IfcCurve);

  IFC2X32.IfcOffsetCurve2D = IfcOffsetCurve2D;

  var IfcOffsetCurve3D = /*#__PURE__*/function (_IfcCurve3) {
    _inherits(IfcOffsetCurve3D, _IfcCurve3);

    var _super432 = _createSuper(IfcOffsetCurve3D);

    function IfcOffsetCurve3D(expressID, BasisCurve, Distance, SelfIntersect, RefDirection) {
      var _this424;

      _classCallCheck2(this, IfcOffsetCurve3D);

      _this424 = _super432.call(this, expressID);
      _this424.BasisCurve = BasisCurve;
      _this424.Distance = Distance;
      _this424.SelfIntersect = SelfIntersect;
      _this424.RefDirection = RefDirection;
      _this424.type = 3505215534;
      return _this424;
    }

    return IfcOffsetCurve3D;
  }(IfcCurve);

  IFC2X32.IfcOffsetCurve3D = IfcOffsetCurve3D;

  var IfcPermeableCoveringProperties = /*#__PURE__*/function (_IfcPropertySetDefini13) {
    _inherits(IfcPermeableCoveringProperties, _IfcPropertySetDefini13);

    var _super433 = _createSuper(IfcPermeableCoveringProperties);

    function IfcPermeableCoveringProperties(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      var _this425;

      _classCallCheck2(this, IfcPermeableCoveringProperties);

      _this425 = _super433.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this425.GlobalId = GlobalId;
      _this425.OwnerHistory = OwnerHistory;
      _this425.Name = Name;
      _this425.Description = Description;
      _this425.OperationType = OperationType;
      _this425.PanelPosition = PanelPosition;
      _this425.FrameDepth = FrameDepth;
      _this425.FrameThickness = FrameThickness;
      _this425.ShapeAspectStyle = ShapeAspectStyle;
      _this425.type = 3566463478;
      return _this425;
    }

    return IfcPermeableCoveringProperties;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;

  var IfcPlanarBox = /*#__PURE__*/function (_IfcPlanarExtent) {
    _inherits(IfcPlanarBox, _IfcPlanarExtent);

    var _super434 = _createSuper(IfcPlanarBox);

    function IfcPlanarBox(expressID, SizeInX, SizeInY, Placement) {
      var _this426;

      _classCallCheck2(this, IfcPlanarBox);

      _this426 = _super434.call(this, expressID, SizeInX, SizeInY);
      _this426.SizeInX = SizeInX;
      _this426.SizeInY = SizeInY;
      _this426.Placement = Placement;
      _this426.type = 603570806;
      return _this426;
    }

    return IfcPlanarBox;
  }(IfcPlanarExtent);

  IFC2X32.IfcPlanarBox = IfcPlanarBox;

  var IfcPlane = /*#__PURE__*/function (_IfcElementarySurface) {
    _inherits(IfcPlane, _IfcElementarySurface);

    var _super435 = _createSuper(IfcPlane);

    function IfcPlane(expressID, Position) {
      var _this427;

      _classCallCheck2(this, IfcPlane);

      _this427 = _super435.call(this, expressID, Position);
      _this427.Position = Position;
      _this427.type = 220341763;
      return _this427;
    }

    return IfcPlane;
  }(IfcElementarySurface);

  IFC2X32.IfcPlane = IfcPlane;

  var IfcProcess = /*#__PURE__*/function (_IfcObject) {
    _inherits(IfcProcess, _IfcObject);

    var _super436 = _createSuper(IfcProcess);

    function IfcProcess(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this428;

      _classCallCheck2(this, IfcProcess);

      _this428 = _super436.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this428.GlobalId = GlobalId;
      _this428.OwnerHistory = OwnerHistory;
      _this428.Name = Name;
      _this428.Description = Description;
      _this428.ObjectType = ObjectType;
      _this428.type = 2945172077;
      return _this428;
    }

    return IfcProcess;
  }(IfcObject);

  IFC2X32.IfcProcess = IfcProcess;

  var IfcProduct = /*#__PURE__*/function (_IfcObject2) {
    _inherits(IfcProduct, _IfcObject2);

    var _super437 = _createSuper(IfcProduct);

    function IfcProduct(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this429;

      _classCallCheck2(this, IfcProduct);

      _this429 = _super437.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this429.GlobalId = GlobalId;
      _this429.OwnerHistory = OwnerHistory;
      _this429.Name = Name;
      _this429.Description = Description;
      _this429.ObjectType = ObjectType;
      _this429.ObjectPlacement = ObjectPlacement;
      _this429.Representation = Representation;
      _this429.type = 4208778838;
      return _this429;
    }

    return IfcProduct;
  }(IfcObject);

  IFC2X32.IfcProduct = IfcProduct;

  var IfcProject = /*#__PURE__*/function (_IfcObject3) {
    _inherits(IfcProject, _IfcObject3);

    var _super438 = _createSuper(IfcProject);

    function IfcProject(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      var _this430;

      _classCallCheck2(this, IfcProject);

      _this430 = _super438.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this430.GlobalId = GlobalId;
      _this430.OwnerHistory = OwnerHistory;
      _this430.Name = Name;
      _this430.Description = Description;
      _this430.ObjectType = ObjectType;
      _this430.LongName = LongName;
      _this430.Phase = Phase;
      _this430.RepresentationContexts = RepresentationContexts;
      _this430.UnitsInContext = UnitsInContext;
      _this430.type = 103090709;
      return _this430;
    }

    return IfcProject;
  }(IfcObject);

  IFC2X32.IfcProject = IfcProject;

  var IfcProjectionCurve = /*#__PURE__*/function (_IfcAnnotationCurveOc2) {
    _inherits(IfcProjectionCurve, _IfcAnnotationCurveOc2);

    var _super439 = _createSuper(IfcProjectionCurve);

    function IfcProjectionCurve(expressID, Item, Styles, Name) {
      var _this431;

      _classCallCheck2(this, IfcProjectionCurve);

      _this431 = _super439.call(this, expressID, Item, Styles, Name);
      _this431.Item = Item;
      _this431.Styles = Styles;
      _this431.Name = Name;
      _this431.type = 4194566429;
      return _this431;
    }

    return IfcProjectionCurve;
  }(IfcAnnotationCurveOccurrence);

  IFC2X32.IfcProjectionCurve = IfcProjectionCurve;

  var IfcPropertySet = /*#__PURE__*/function (_IfcPropertySetDefini14) {
    _inherits(IfcPropertySet, _IfcPropertySetDefini14);

    var _super440 = _createSuper(IfcPropertySet);

    function IfcPropertySet(expressID, GlobalId, OwnerHistory, Name, Description, HasProperties) {
      var _this432;

      _classCallCheck2(this, IfcPropertySet);

      _this432 = _super440.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this432.GlobalId = GlobalId;
      _this432.OwnerHistory = OwnerHistory;
      _this432.Name = Name;
      _this432.Description = Description;
      _this432.HasProperties = HasProperties;
      _this432.type = 1451395588;
      return _this432;
    }

    return IfcPropertySet;
  }(IfcPropertySetDefinition);

  IFC2X32.IfcPropertySet = IfcPropertySet;

  var IfcProxy = /*#__PURE__*/function (_IfcProduct) {
    _inherits(IfcProxy, _IfcProduct);

    var _super441 = _createSuper(IfcProxy);

    function IfcProxy(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, ProxyType, Tag) {
      var _this433;

      _classCallCheck2(this, IfcProxy);

      _this433 = _super441.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this433.GlobalId = GlobalId;
      _this433.OwnerHistory = OwnerHistory;
      _this433.Name = Name;
      _this433.Description = Description;
      _this433.ObjectType = ObjectType;
      _this433.ObjectPlacement = ObjectPlacement;
      _this433.Representation = Representation;
      _this433.ProxyType = ProxyType;
      _this433.Tag = Tag;
      _this433.type = 3219374653;
      return _this433;
    }

    return IfcProxy;
  }(IfcProduct);

  IFC2X32.IfcProxy = IfcProxy;

  var IfcRectangleHollowProfileDef = /*#__PURE__*/function (_IfcRectangleProfileD2) {
    _inherits(IfcRectangleHollowProfileDef, _IfcRectangleProfileD2);

    var _super442 = _createSuper(IfcRectangleHollowProfileDef);

    function IfcRectangleHollowProfileDef(expressID, ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius) {
      var _this434;

      _classCallCheck2(this, IfcRectangleHollowProfileDef);

      _this434 = _super442.call(this, expressID, ProfileType, ProfileName, Position, XDim, YDim);
      _this434.ProfileType = ProfileType;
      _this434.ProfileName = ProfileName;
      _this434.Position = Position;
      _this434.XDim = XDim;
      _this434.YDim = YDim;
      _this434.WallThickness = WallThickness;
      _this434.InnerFilletRadius = InnerFilletRadius;
      _this434.OuterFilletRadius = OuterFilletRadius;
      _this434.type = 2770003689;
      return _this434;
    }

    return IfcRectangleHollowProfileDef;
  }(IfcRectangleProfileDef);

  IFC2X32.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;

  var IfcRectangularPyramid = /*#__PURE__*/function (_IfcCsgPrimitive3D) {
    _inherits(IfcRectangularPyramid, _IfcCsgPrimitive3D);

    var _super443 = _createSuper(IfcRectangularPyramid);

    function IfcRectangularPyramid(expressID, Position, XLength, YLength, Height) {
      var _this435;

      _classCallCheck2(this, IfcRectangularPyramid);

      _this435 = _super443.call(this, expressID, Position);
      _this435.Position = Position;
      _this435.XLength = XLength;
      _this435.YLength = YLength;
      _this435.Height = Height;
      _this435.type = 2798486643;
      return _this435;
    }

    return IfcRectangularPyramid;
  }(IfcCsgPrimitive3D);

  IFC2X32.IfcRectangularPyramid = IfcRectangularPyramid;

  var IfcRectangularTrimmedSurface = /*#__PURE__*/function (_IfcBoundedSurface2) {
    _inherits(IfcRectangularTrimmedSurface, _IfcBoundedSurface2);

    var _super444 = _createSuper(IfcRectangularTrimmedSurface);

    function IfcRectangularTrimmedSurface(expressID, BasisSurface, U1, V1, U2, V2, Usense, Vsense) {
      var _this436;

      _classCallCheck2(this, IfcRectangularTrimmedSurface);

      _this436 = _super444.call(this, expressID);
      _this436.BasisSurface = BasisSurface;
      _this436.U1 = U1;
      _this436.V1 = V1;
      _this436.U2 = U2;
      _this436.V2 = V2;
      _this436.Usense = Usense;
      _this436.Vsense = Vsense;
      _this436.type = 3454111270;
      return _this436;
    }

    return IfcRectangularTrimmedSurface;
  }(IfcBoundedSurface);

  IFC2X32.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;

  var IfcRelAssigns = /*#__PURE__*/function (_IfcRelationship) {
    _inherits(IfcRelAssigns, _IfcRelationship);

    var _super445 = _createSuper(IfcRelAssigns);

    function IfcRelAssigns(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType) {
      var _this437;

      _classCallCheck2(this, IfcRelAssigns);

      _this437 = _super445.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this437.GlobalId = GlobalId;
      _this437.OwnerHistory = OwnerHistory;
      _this437.Name = Name;
      _this437.Description = Description;
      _this437.RelatedObjects = RelatedObjects;
      _this437.RelatedObjectsType = RelatedObjectsType;
      _this437.type = 3939117080;
      return _this437;
    }

    return IfcRelAssigns;
  }(IfcRelationship);

  IFC2X32.IfcRelAssigns = IfcRelAssigns;

  var IfcRelAssignsToActor = /*#__PURE__*/function (_IfcRelAssigns) {
    _inherits(IfcRelAssignsToActor, _IfcRelAssigns);

    var _super446 = _createSuper(IfcRelAssignsToActor);

    function IfcRelAssignsToActor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      var _this438;

      _classCallCheck2(this, IfcRelAssignsToActor);

      _this438 = _super446.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this438.GlobalId = GlobalId;
      _this438.OwnerHistory = OwnerHistory;
      _this438.Name = Name;
      _this438.Description = Description;
      _this438.RelatedObjects = RelatedObjects;
      _this438.RelatedObjectsType = RelatedObjectsType;
      _this438.RelatingActor = RelatingActor;
      _this438.ActingRole = ActingRole;
      _this438.type = 1683148259;
      return _this438;
    }

    return IfcRelAssignsToActor;
  }(IfcRelAssigns);

  IFC2X32.IfcRelAssignsToActor = IfcRelAssignsToActor;

  var IfcRelAssignsToControl = /*#__PURE__*/function (_IfcRelAssigns2) {
    _inherits(IfcRelAssignsToControl, _IfcRelAssigns2);

    var _super447 = _createSuper(IfcRelAssignsToControl);

    function IfcRelAssignsToControl(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      var _this439;

      _classCallCheck2(this, IfcRelAssignsToControl);

      _this439 = _super447.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this439.GlobalId = GlobalId;
      _this439.OwnerHistory = OwnerHistory;
      _this439.Name = Name;
      _this439.Description = Description;
      _this439.RelatedObjects = RelatedObjects;
      _this439.RelatedObjectsType = RelatedObjectsType;
      _this439.RelatingControl = RelatingControl;
      _this439.type = 2495723537;
      return _this439;
    }

    return IfcRelAssignsToControl;
  }(IfcRelAssigns);

  IFC2X32.IfcRelAssignsToControl = IfcRelAssignsToControl;

  var IfcRelAssignsToGroup = /*#__PURE__*/function (_IfcRelAssigns3) {
    _inherits(IfcRelAssignsToGroup, _IfcRelAssigns3);

    var _super448 = _createSuper(IfcRelAssignsToGroup);

    function IfcRelAssignsToGroup(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup) {
      var _this440;

      _classCallCheck2(this, IfcRelAssignsToGroup);

      _this440 = _super448.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this440.GlobalId = GlobalId;
      _this440.OwnerHistory = OwnerHistory;
      _this440.Name = Name;
      _this440.Description = Description;
      _this440.RelatedObjects = RelatedObjects;
      _this440.RelatedObjectsType = RelatedObjectsType;
      _this440.RelatingGroup = RelatingGroup;
      _this440.type = 1307041759;
      return _this440;
    }

    return IfcRelAssignsToGroup;
  }(IfcRelAssigns);

  IFC2X32.IfcRelAssignsToGroup = IfcRelAssignsToGroup;

  var IfcRelAssignsToProcess = /*#__PURE__*/function (_IfcRelAssigns4) {
    _inherits(IfcRelAssignsToProcess, _IfcRelAssigns4);

    var _super449 = _createSuper(IfcRelAssignsToProcess);

    function IfcRelAssignsToProcess(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess) {
      var _this441;

      _classCallCheck2(this, IfcRelAssignsToProcess);

      _this441 = _super449.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this441.GlobalId = GlobalId;
      _this441.OwnerHistory = OwnerHistory;
      _this441.Name = Name;
      _this441.Description = Description;
      _this441.RelatedObjects = RelatedObjects;
      _this441.RelatedObjectsType = RelatedObjectsType;
      _this441.RelatingProcess = RelatingProcess;
      _this441.QuantityInProcess = QuantityInProcess;
      _this441.type = 4278684876;
      return _this441;
    }

    return IfcRelAssignsToProcess;
  }(IfcRelAssigns);

  IFC2X32.IfcRelAssignsToProcess = IfcRelAssignsToProcess;

  var IfcRelAssignsToProduct = /*#__PURE__*/function (_IfcRelAssigns5) {
    _inherits(IfcRelAssignsToProduct, _IfcRelAssigns5);

    var _super450 = _createSuper(IfcRelAssignsToProduct);

    function IfcRelAssignsToProduct(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct) {
      var _this442;

      _classCallCheck2(this, IfcRelAssignsToProduct);

      _this442 = _super450.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this442.GlobalId = GlobalId;
      _this442.OwnerHistory = OwnerHistory;
      _this442.Name = Name;
      _this442.Description = Description;
      _this442.RelatedObjects = RelatedObjects;
      _this442.RelatedObjectsType = RelatedObjectsType;
      _this442.RelatingProduct = RelatingProduct;
      _this442.type = 2857406711;
      return _this442;
    }

    return IfcRelAssignsToProduct;
  }(IfcRelAssigns);

  IFC2X32.IfcRelAssignsToProduct = IfcRelAssignsToProduct;

  var IfcRelAssignsToProjectOrder = /*#__PURE__*/function (_IfcRelAssignsToContr) {
    _inherits(IfcRelAssignsToProjectOrder, _IfcRelAssignsToContr);

    var _super451 = _createSuper(IfcRelAssignsToProjectOrder);

    function IfcRelAssignsToProjectOrder(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      var _this443;

      _classCallCheck2(this, IfcRelAssignsToProjectOrder);

      _this443 = _super451.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
      _this443.GlobalId = GlobalId;
      _this443.OwnerHistory = OwnerHistory;
      _this443.Name = Name;
      _this443.Description = Description;
      _this443.RelatedObjects = RelatedObjects;
      _this443.RelatedObjectsType = RelatedObjectsType;
      _this443.RelatingControl = RelatingControl;
      _this443.type = 3372526763;
      return _this443;
    }

    return IfcRelAssignsToProjectOrder;
  }(IfcRelAssignsToControl);

  IFC2X32.IfcRelAssignsToProjectOrder = IfcRelAssignsToProjectOrder;

  var IfcRelAssignsToResource = /*#__PURE__*/function (_IfcRelAssigns6) {
    _inherits(IfcRelAssignsToResource, _IfcRelAssigns6);

    var _super452 = _createSuper(IfcRelAssignsToResource);

    function IfcRelAssignsToResource(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource) {
      var _this444;

      _classCallCheck2(this, IfcRelAssignsToResource);

      _this444 = _super452.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this444.GlobalId = GlobalId;
      _this444.OwnerHistory = OwnerHistory;
      _this444.Name = Name;
      _this444.Description = Description;
      _this444.RelatedObjects = RelatedObjects;
      _this444.RelatedObjectsType = RelatedObjectsType;
      _this444.RelatingResource = RelatingResource;
      _this444.type = 205026976;
      return _this444;
    }

    return IfcRelAssignsToResource;
  }(IfcRelAssigns);

  IFC2X32.IfcRelAssignsToResource = IfcRelAssignsToResource;

  var IfcRelAssociates = /*#__PURE__*/function (_IfcRelationship2) {
    _inherits(IfcRelAssociates, _IfcRelationship2);

    var _super453 = _createSuper(IfcRelAssociates);

    function IfcRelAssociates(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      var _this445;

      _classCallCheck2(this, IfcRelAssociates);

      _this445 = _super453.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this445.GlobalId = GlobalId;
      _this445.OwnerHistory = OwnerHistory;
      _this445.Name = Name;
      _this445.Description = Description;
      _this445.RelatedObjects = RelatedObjects;
      _this445.type = 1865459582;
      return _this445;
    }

    return IfcRelAssociates;
  }(IfcRelationship);

  IFC2X32.IfcRelAssociates = IfcRelAssociates;

  var IfcRelAssociatesAppliedValue = /*#__PURE__*/function (_IfcRelAssociates) {
    _inherits(IfcRelAssociatesAppliedValue, _IfcRelAssociates);

    var _super454 = _createSuper(IfcRelAssociatesAppliedValue);

    function IfcRelAssociatesAppliedValue(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingAppliedValue) {
      var _this446;

      _classCallCheck2(this, IfcRelAssociatesAppliedValue);

      _this446 = _super454.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this446.GlobalId = GlobalId;
      _this446.OwnerHistory = OwnerHistory;
      _this446.Name = Name;
      _this446.Description = Description;
      _this446.RelatedObjects = RelatedObjects;
      _this446.RelatingAppliedValue = RelatingAppliedValue;
      _this446.type = 1327628568;
      return _this446;
    }

    return IfcRelAssociatesAppliedValue;
  }(IfcRelAssociates);

  IFC2X32.IfcRelAssociatesAppliedValue = IfcRelAssociatesAppliedValue;

  var IfcRelAssociatesApproval = /*#__PURE__*/function (_IfcRelAssociates2) {
    _inherits(IfcRelAssociatesApproval, _IfcRelAssociates2);

    var _super455 = _createSuper(IfcRelAssociatesApproval);

    function IfcRelAssociatesApproval(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval) {
      var _this447;

      _classCallCheck2(this, IfcRelAssociatesApproval);

      _this447 = _super455.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this447.GlobalId = GlobalId;
      _this447.OwnerHistory = OwnerHistory;
      _this447.Name = Name;
      _this447.Description = Description;
      _this447.RelatedObjects = RelatedObjects;
      _this447.RelatingApproval = RelatingApproval;
      _this447.type = 4095574036;
      return _this447;
    }

    return IfcRelAssociatesApproval;
  }(IfcRelAssociates);

  IFC2X32.IfcRelAssociatesApproval = IfcRelAssociatesApproval;

  var IfcRelAssociatesClassification = /*#__PURE__*/function (_IfcRelAssociates3) {
    _inherits(IfcRelAssociatesClassification, _IfcRelAssociates3);

    var _super456 = _createSuper(IfcRelAssociatesClassification);

    function IfcRelAssociatesClassification(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification) {
      var _this448;

      _classCallCheck2(this, IfcRelAssociatesClassification);

      _this448 = _super456.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this448.GlobalId = GlobalId;
      _this448.OwnerHistory = OwnerHistory;
      _this448.Name = Name;
      _this448.Description = Description;
      _this448.RelatedObjects = RelatedObjects;
      _this448.RelatingClassification = RelatingClassification;
      _this448.type = 919958153;
      return _this448;
    }

    return IfcRelAssociatesClassification;
  }(IfcRelAssociates);

  IFC2X32.IfcRelAssociatesClassification = IfcRelAssociatesClassification;

  var IfcRelAssociatesConstraint = /*#__PURE__*/function (_IfcRelAssociates4) {
    _inherits(IfcRelAssociatesConstraint, _IfcRelAssociates4);

    var _super457 = _createSuper(IfcRelAssociatesConstraint);

    function IfcRelAssociatesConstraint(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint) {
      var _this449;

      _classCallCheck2(this, IfcRelAssociatesConstraint);

      _this449 = _super457.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this449.GlobalId = GlobalId;
      _this449.OwnerHistory = OwnerHistory;
      _this449.Name = Name;
      _this449.Description = Description;
      _this449.RelatedObjects = RelatedObjects;
      _this449.Intent = Intent;
      _this449.RelatingConstraint = RelatingConstraint;
      _this449.type = 2728634034;
      return _this449;
    }

    return IfcRelAssociatesConstraint;
  }(IfcRelAssociates);

  IFC2X32.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;

  var IfcRelAssociatesDocument = /*#__PURE__*/function (_IfcRelAssociates5) {
    _inherits(IfcRelAssociatesDocument, _IfcRelAssociates5);

    var _super458 = _createSuper(IfcRelAssociatesDocument);

    function IfcRelAssociatesDocument(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument) {
      var _this450;

      _classCallCheck2(this, IfcRelAssociatesDocument);

      _this450 = _super458.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this450.GlobalId = GlobalId;
      _this450.OwnerHistory = OwnerHistory;
      _this450.Name = Name;
      _this450.Description = Description;
      _this450.RelatedObjects = RelatedObjects;
      _this450.RelatingDocument = RelatingDocument;
      _this450.type = 982818633;
      return _this450;
    }

    return IfcRelAssociatesDocument;
  }(IfcRelAssociates);

  IFC2X32.IfcRelAssociatesDocument = IfcRelAssociatesDocument;

  var IfcRelAssociatesLibrary = /*#__PURE__*/function (_IfcRelAssociates6) {
    _inherits(IfcRelAssociatesLibrary, _IfcRelAssociates6);

    var _super459 = _createSuper(IfcRelAssociatesLibrary);

    function IfcRelAssociatesLibrary(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary) {
      var _this451;

      _classCallCheck2(this, IfcRelAssociatesLibrary);

      _this451 = _super459.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this451.GlobalId = GlobalId;
      _this451.OwnerHistory = OwnerHistory;
      _this451.Name = Name;
      _this451.Description = Description;
      _this451.RelatedObjects = RelatedObjects;
      _this451.RelatingLibrary = RelatingLibrary;
      _this451.type = 3840914261;
      return _this451;
    }

    return IfcRelAssociatesLibrary;
  }(IfcRelAssociates);

  IFC2X32.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;

  var IfcRelAssociatesMaterial = /*#__PURE__*/function (_IfcRelAssociates7) {
    _inherits(IfcRelAssociatesMaterial, _IfcRelAssociates7);

    var _super460 = _createSuper(IfcRelAssociatesMaterial);

    function IfcRelAssociatesMaterial(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial) {
      var _this452;

      _classCallCheck2(this, IfcRelAssociatesMaterial);

      _this452 = _super460.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this452.GlobalId = GlobalId;
      _this452.OwnerHistory = OwnerHistory;
      _this452.Name = Name;
      _this452.Description = Description;
      _this452.RelatedObjects = RelatedObjects;
      _this452.RelatingMaterial = RelatingMaterial;
      _this452.type = 2655215786;
      return _this452;
    }

    return IfcRelAssociatesMaterial;
  }(IfcRelAssociates);

  IFC2X32.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;

  var IfcRelAssociatesProfileProperties = /*#__PURE__*/function (_IfcRelAssociates8) {
    _inherits(IfcRelAssociatesProfileProperties, _IfcRelAssociates8);

    var _super461 = _createSuper(IfcRelAssociatesProfileProperties);

    function IfcRelAssociatesProfileProperties(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingProfileProperties, ProfileSectionLocation, ProfileOrientation) {
      var _this453;

      _classCallCheck2(this, IfcRelAssociatesProfileProperties);

      _this453 = _super461.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this453.GlobalId = GlobalId;
      _this453.OwnerHistory = OwnerHistory;
      _this453.Name = Name;
      _this453.Description = Description;
      _this453.RelatedObjects = RelatedObjects;
      _this453.RelatingProfileProperties = RelatingProfileProperties;
      _this453.ProfileSectionLocation = ProfileSectionLocation;
      _this453.ProfileOrientation = ProfileOrientation;
      _this453.type = 2851387026;
      return _this453;
    }

    return IfcRelAssociatesProfileProperties;
  }(IfcRelAssociates);

  IFC2X32.IfcRelAssociatesProfileProperties = IfcRelAssociatesProfileProperties;

  var IfcRelConnects = /*#__PURE__*/function (_IfcRelationship3) {
    _inherits(IfcRelConnects, _IfcRelationship3);

    var _super462 = _createSuper(IfcRelConnects);

    function IfcRelConnects(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this454;

      _classCallCheck2(this, IfcRelConnects);

      _this454 = _super462.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this454.GlobalId = GlobalId;
      _this454.OwnerHistory = OwnerHistory;
      _this454.Name = Name;
      _this454.Description = Description;
      _this454.type = 826625072;
      return _this454;
    }

    return IfcRelConnects;
  }(IfcRelationship);

  IFC2X32.IfcRelConnects = IfcRelConnects;

  var IfcRelConnectsElements = /*#__PURE__*/function (_IfcRelConnects) {
    _inherits(IfcRelConnectsElements, _IfcRelConnects);

    var _super463 = _createSuper(IfcRelConnectsElements);

    function IfcRelConnectsElements(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement) {
      var _this455;

      _classCallCheck2(this, IfcRelConnectsElements);

      _this455 = _super463.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this455.GlobalId = GlobalId;
      _this455.OwnerHistory = OwnerHistory;
      _this455.Name = Name;
      _this455.Description = Description;
      _this455.ConnectionGeometry = ConnectionGeometry;
      _this455.RelatingElement = RelatingElement;
      _this455.RelatedElement = RelatedElement;
      _this455.type = 1204542856;
      return _this455;
    }

    return IfcRelConnectsElements;
  }(IfcRelConnects);

  IFC2X32.IfcRelConnectsElements = IfcRelConnectsElements;

  var IfcRelConnectsPathElements = /*#__PURE__*/function (_IfcRelConnectsElemen) {
    _inherits(IfcRelConnectsPathElements, _IfcRelConnectsElemen);

    var _super464 = _createSuper(IfcRelConnectsPathElements);

    function IfcRelConnectsPathElements(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType) {
      var _this456;

      _classCallCheck2(this, IfcRelConnectsPathElements);

      _this456 = _super464.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      _this456.GlobalId = GlobalId;
      _this456.OwnerHistory = OwnerHistory;
      _this456.Name = Name;
      _this456.Description = Description;
      _this456.ConnectionGeometry = ConnectionGeometry;
      _this456.RelatingElement = RelatingElement;
      _this456.RelatedElement = RelatedElement;
      _this456.RelatingPriorities = RelatingPriorities;
      _this456.RelatedPriorities = RelatedPriorities;
      _this456.RelatedConnectionType = RelatedConnectionType;
      _this456.RelatingConnectionType = RelatingConnectionType;
      _this456.type = 3945020480;
      return _this456;
    }

    return IfcRelConnectsPathElements;
  }(IfcRelConnectsElements);

  IFC2X32.IfcRelConnectsPathElements = IfcRelConnectsPathElements;

  var IfcRelConnectsPortToElement = /*#__PURE__*/function (_IfcRelConnects2) {
    _inherits(IfcRelConnectsPortToElement, _IfcRelConnects2);

    var _super465 = _createSuper(IfcRelConnectsPortToElement);

    function IfcRelConnectsPortToElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement) {
      var _this457;

      _classCallCheck2(this, IfcRelConnectsPortToElement);

      _this457 = _super465.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this457.GlobalId = GlobalId;
      _this457.OwnerHistory = OwnerHistory;
      _this457.Name = Name;
      _this457.Description = Description;
      _this457.RelatingPort = RelatingPort;
      _this457.RelatedElement = RelatedElement;
      _this457.type = 4201705270;
      return _this457;
    }

    return IfcRelConnectsPortToElement;
  }(IfcRelConnects);

  IFC2X32.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;

  var IfcRelConnectsPorts = /*#__PURE__*/function (_IfcRelConnects3) {
    _inherits(IfcRelConnectsPorts, _IfcRelConnects3);

    var _super466 = _createSuper(IfcRelConnectsPorts);

    function IfcRelConnectsPorts(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement) {
      var _this458;

      _classCallCheck2(this, IfcRelConnectsPorts);

      _this458 = _super466.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this458.GlobalId = GlobalId;
      _this458.OwnerHistory = OwnerHistory;
      _this458.Name = Name;
      _this458.Description = Description;
      _this458.RelatingPort = RelatingPort;
      _this458.RelatedPort = RelatedPort;
      _this458.RealizingElement = RealizingElement;
      _this458.type = 3190031847;
      return _this458;
    }

    return IfcRelConnectsPorts;
  }(IfcRelConnects);

  IFC2X32.IfcRelConnectsPorts = IfcRelConnectsPorts;

  var IfcRelConnectsStructuralActivity = /*#__PURE__*/function (_IfcRelConnects4) {
    _inherits(IfcRelConnectsStructuralActivity, _IfcRelConnects4);

    var _super467 = _createSuper(IfcRelConnectsStructuralActivity);

    function IfcRelConnectsStructuralActivity(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity) {
      var _this459;

      _classCallCheck2(this, IfcRelConnectsStructuralActivity);

      _this459 = _super467.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this459.GlobalId = GlobalId;
      _this459.OwnerHistory = OwnerHistory;
      _this459.Name = Name;
      _this459.Description = Description;
      _this459.RelatingElement = RelatingElement;
      _this459.RelatedStructuralActivity = RelatedStructuralActivity;
      _this459.type = 2127690289;
      return _this459;
    }

    return IfcRelConnectsStructuralActivity;
  }(IfcRelConnects);

  IFC2X32.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;

  var IfcRelConnectsStructuralElement = /*#__PURE__*/function (_IfcRelConnects5) {
    _inherits(IfcRelConnectsStructuralElement, _IfcRelConnects5);

    var _super468 = _createSuper(IfcRelConnectsStructuralElement);

    function IfcRelConnectsStructuralElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralMember) {
      var _this460;

      _classCallCheck2(this, IfcRelConnectsStructuralElement);

      _this460 = _super468.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this460.GlobalId = GlobalId;
      _this460.OwnerHistory = OwnerHistory;
      _this460.Name = Name;
      _this460.Description = Description;
      _this460.RelatingElement = RelatingElement;
      _this460.RelatedStructuralMember = RelatedStructuralMember;
      _this460.type = 3912681535;
      return _this460;
    }

    return IfcRelConnectsStructuralElement;
  }(IfcRelConnects);

  IFC2X32.IfcRelConnectsStructuralElement = IfcRelConnectsStructuralElement;

  var IfcRelConnectsStructuralMember = /*#__PURE__*/function (_IfcRelConnects6) {
    _inherits(IfcRelConnectsStructuralMember, _IfcRelConnects6);

    var _super469 = _createSuper(IfcRelConnectsStructuralMember);

    function IfcRelConnectsStructuralMember(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem) {
      var _this461;

      _classCallCheck2(this, IfcRelConnectsStructuralMember);

      _this461 = _super469.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this461.GlobalId = GlobalId;
      _this461.OwnerHistory = OwnerHistory;
      _this461.Name = Name;
      _this461.Description = Description;
      _this461.RelatingStructuralMember = RelatingStructuralMember;
      _this461.RelatedStructuralConnection = RelatedStructuralConnection;
      _this461.AppliedCondition = AppliedCondition;
      _this461.AdditionalConditions = AdditionalConditions;
      _this461.SupportedLength = SupportedLength;
      _this461.ConditionCoordinateSystem = ConditionCoordinateSystem;
      _this461.type = 1638771189;
      return _this461;
    }

    return IfcRelConnectsStructuralMember;
  }(IfcRelConnects);

  IFC2X32.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;

  var IfcRelConnectsWithEccentricity = /*#__PURE__*/function (_IfcRelConnectsStruct) {
    _inherits(IfcRelConnectsWithEccentricity, _IfcRelConnectsStruct);

    var _super470 = _createSuper(IfcRelConnectsWithEccentricity);

    function IfcRelConnectsWithEccentricity(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint) {
      var _this462;

      _classCallCheck2(this, IfcRelConnectsWithEccentricity);

      _this462 = _super470.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
      _this462.GlobalId = GlobalId;
      _this462.OwnerHistory = OwnerHistory;
      _this462.Name = Name;
      _this462.Description = Description;
      _this462.RelatingStructuralMember = RelatingStructuralMember;
      _this462.RelatedStructuralConnection = RelatedStructuralConnection;
      _this462.AppliedCondition = AppliedCondition;
      _this462.AdditionalConditions = AdditionalConditions;
      _this462.SupportedLength = SupportedLength;
      _this462.ConditionCoordinateSystem = ConditionCoordinateSystem;
      _this462.ConnectionConstraint = ConnectionConstraint;
      _this462.type = 504942748;
      return _this462;
    }

    return IfcRelConnectsWithEccentricity;
  }(IfcRelConnectsStructuralMember);

  IFC2X32.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;

  var IfcRelConnectsWithRealizingElements = /*#__PURE__*/function (_IfcRelConnectsElemen2) {
    _inherits(IfcRelConnectsWithRealizingElements, _IfcRelConnectsElemen2);

    var _super471 = _createSuper(IfcRelConnectsWithRealizingElements);

    function IfcRelConnectsWithRealizingElements(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType) {
      var _this463;

      _classCallCheck2(this, IfcRelConnectsWithRealizingElements);

      _this463 = _super471.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      _this463.GlobalId = GlobalId;
      _this463.OwnerHistory = OwnerHistory;
      _this463.Name = Name;
      _this463.Description = Description;
      _this463.ConnectionGeometry = ConnectionGeometry;
      _this463.RelatingElement = RelatingElement;
      _this463.RelatedElement = RelatedElement;
      _this463.RealizingElements = RealizingElements;
      _this463.ConnectionType = ConnectionType;
      _this463.type = 3678494232;
      return _this463;
    }

    return IfcRelConnectsWithRealizingElements;
  }(IfcRelConnectsElements);

  IFC2X32.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;

  var IfcRelContainedInSpatialStructure = /*#__PURE__*/function (_IfcRelConnects7) {
    _inherits(IfcRelContainedInSpatialStructure, _IfcRelConnects7);

    var _super472 = _createSuper(IfcRelContainedInSpatialStructure);

    function IfcRelContainedInSpatialStructure(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      var _this464;

      _classCallCheck2(this, IfcRelContainedInSpatialStructure);

      _this464 = _super472.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this464.GlobalId = GlobalId;
      _this464.OwnerHistory = OwnerHistory;
      _this464.Name = Name;
      _this464.Description = Description;
      _this464.RelatedElements = RelatedElements;
      _this464.RelatingStructure = RelatingStructure;
      _this464.type = 3242617779;
      return _this464;
    }

    return IfcRelContainedInSpatialStructure;
  }(IfcRelConnects);

  IFC2X32.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;

  var IfcRelCoversBldgElements = /*#__PURE__*/function (_IfcRelConnects8) {
    _inherits(IfcRelCoversBldgElements, _IfcRelConnects8);

    var _super473 = _createSuper(IfcRelCoversBldgElements);

    function IfcRelCoversBldgElements(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings) {
      var _this465;

      _classCallCheck2(this, IfcRelCoversBldgElements);

      _this465 = _super473.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this465.GlobalId = GlobalId;
      _this465.OwnerHistory = OwnerHistory;
      _this465.Name = Name;
      _this465.Description = Description;
      _this465.RelatingBuildingElement = RelatingBuildingElement;
      _this465.RelatedCoverings = RelatedCoverings;
      _this465.type = 886880790;
      return _this465;
    }

    return IfcRelCoversBldgElements;
  }(IfcRelConnects);

  IFC2X32.IfcRelCoversBldgElements = IfcRelCoversBldgElements;

  var IfcRelCoversSpaces = /*#__PURE__*/function (_IfcRelConnects9) {
    _inherits(IfcRelCoversSpaces, _IfcRelConnects9);

    var _super474 = _createSuper(IfcRelCoversSpaces);

    function IfcRelCoversSpaces(expressID, GlobalId, OwnerHistory, Name, Description, RelatedSpace, RelatedCoverings) {
      var _this466;

      _classCallCheck2(this, IfcRelCoversSpaces);

      _this466 = _super474.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this466.GlobalId = GlobalId;
      _this466.OwnerHistory = OwnerHistory;
      _this466.Name = Name;
      _this466.Description = Description;
      _this466.RelatedSpace = RelatedSpace;
      _this466.RelatedCoverings = RelatedCoverings;
      _this466.type = 2802773753;
      return _this466;
    }

    return IfcRelCoversSpaces;
  }(IfcRelConnects);

  IFC2X32.IfcRelCoversSpaces = IfcRelCoversSpaces;

  var IfcRelDecomposes = /*#__PURE__*/function (_IfcRelationship4) {
    _inherits(IfcRelDecomposes, _IfcRelationship4);

    var _super475 = _createSuper(IfcRelDecomposes);

    function IfcRelDecomposes(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      var _this467;

      _classCallCheck2(this, IfcRelDecomposes);

      _this467 = _super475.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this467.GlobalId = GlobalId;
      _this467.OwnerHistory = OwnerHistory;
      _this467.Name = Name;
      _this467.Description = Description;
      _this467.RelatingObject = RelatingObject;
      _this467.RelatedObjects = RelatedObjects;
      _this467.type = 2551354335;
      return _this467;
    }

    return IfcRelDecomposes;
  }(IfcRelationship);

  IFC2X32.IfcRelDecomposes = IfcRelDecomposes;

  var IfcRelDefines = /*#__PURE__*/function (_IfcRelationship5) {
    _inherits(IfcRelDefines, _IfcRelationship5);

    var _super476 = _createSuper(IfcRelDefines);

    function IfcRelDefines(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      var _this468;

      _classCallCheck2(this, IfcRelDefines);

      _this468 = _super476.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this468.GlobalId = GlobalId;
      _this468.OwnerHistory = OwnerHistory;
      _this468.Name = Name;
      _this468.Description = Description;
      _this468.RelatedObjects = RelatedObjects;
      _this468.type = 693640335;
      return _this468;
    }

    return IfcRelDefines;
  }(IfcRelationship);

  IFC2X32.IfcRelDefines = IfcRelDefines;

  var IfcRelDefinesByProperties = /*#__PURE__*/function (_IfcRelDefines) {
    _inherits(IfcRelDefinesByProperties, _IfcRelDefines);

    var _super477 = _createSuper(IfcRelDefinesByProperties);

    function IfcRelDefinesByProperties(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition) {
      var _this469;

      _classCallCheck2(this, IfcRelDefinesByProperties);

      _this469 = _super477.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this469.GlobalId = GlobalId;
      _this469.OwnerHistory = OwnerHistory;
      _this469.Name = Name;
      _this469.Description = Description;
      _this469.RelatedObjects = RelatedObjects;
      _this469.RelatingPropertyDefinition = RelatingPropertyDefinition;
      _this469.type = 4186316022;
      return _this469;
    }

    return IfcRelDefinesByProperties;
  }(IfcRelDefines);

  IFC2X32.IfcRelDefinesByProperties = IfcRelDefinesByProperties;

  var IfcRelDefinesByType = /*#__PURE__*/function (_IfcRelDefines2) {
    _inherits(IfcRelDefinesByType, _IfcRelDefines2);

    var _super478 = _createSuper(IfcRelDefinesByType);

    function IfcRelDefinesByType(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType) {
      var _this470;

      _classCallCheck2(this, IfcRelDefinesByType);

      _this470 = _super478.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this470.GlobalId = GlobalId;
      _this470.OwnerHistory = OwnerHistory;
      _this470.Name = Name;
      _this470.Description = Description;
      _this470.RelatedObjects = RelatedObjects;
      _this470.RelatingType = RelatingType;
      _this470.type = 781010003;
      return _this470;
    }

    return IfcRelDefinesByType;
  }(IfcRelDefines);

  IFC2X32.IfcRelDefinesByType = IfcRelDefinesByType;

  var IfcRelFillsElement = /*#__PURE__*/function (_IfcRelConnects10) {
    _inherits(IfcRelFillsElement, _IfcRelConnects10);

    var _super479 = _createSuper(IfcRelFillsElement);

    function IfcRelFillsElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement) {
      var _this471;

      _classCallCheck2(this, IfcRelFillsElement);

      _this471 = _super479.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this471.GlobalId = GlobalId;
      _this471.OwnerHistory = OwnerHistory;
      _this471.Name = Name;
      _this471.Description = Description;
      _this471.RelatingOpeningElement = RelatingOpeningElement;
      _this471.RelatedBuildingElement = RelatedBuildingElement;
      _this471.type = 3940055652;
      return _this471;
    }

    return IfcRelFillsElement;
  }(IfcRelConnects);

  IFC2X32.IfcRelFillsElement = IfcRelFillsElement;

  var IfcRelFlowControlElements = /*#__PURE__*/function (_IfcRelConnects11) {
    _inherits(IfcRelFlowControlElements, _IfcRelConnects11);

    var _super480 = _createSuper(IfcRelFlowControlElements);

    function IfcRelFlowControlElements(expressID, GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement) {
      var _this472;

      _classCallCheck2(this, IfcRelFlowControlElements);

      _this472 = _super480.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this472.GlobalId = GlobalId;
      _this472.OwnerHistory = OwnerHistory;
      _this472.Name = Name;
      _this472.Description = Description;
      _this472.RelatedControlElements = RelatedControlElements;
      _this472.RelatingFlowElement = RelatingFlowElement;
      _this472.type = 279856033;
      return _this472;
    }

    return IfcRelFlowControlElements;
  }(IfcRelConnects);

  IFC2X32.IfcRelFlowControlElements = IfcRelFlowControlElements;

  var IfcRelInteractionRequirements = /*#__PURE__*/function (_IfcRelConnects12) {
    _inherits(IfcRelInteractionRequirements, _IfcRelConnects12);

    var _super481 = _createSuper(IfcRelInteractionRequirements);

    function IfcRelInteractionRequirements(expressID, GlobalId, OwnerHistory, Name, Description, DailyInteraction, ImportanceRating, LocationOfInteraction, RelatedSpaceProgram, RelatingSpaceProgram) {
      var _this473;

      _classCallCheck2(this, IfcRelInteractionRequirements);

      _this473 = _super481.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this473.GlobalId = GlobalId;
      _this473.OwnerHistory = OwnerHistory;
      _this473.Name = Name;
      _this473.Description = Description;
      _this473.DailyInteraction = DailyInteraction;
      _this473.ImportanceRating = ImportanceRating;
      _this473.LocationOfInteraction = LocationOfInteraction;
      _this473.RelatedSpaceProgram = RelatedSpaceProgram;
      _this473.RelatingSpaceProgram = RelatingSpaceProgram;
      _this473.type = 4189434867;
      return _this473;
    }

    return IfcRelInteractionRequirements;
  }(IfcRelConnects);

  IFC2X32.IfcRelInteractionRequirements = IfcRelInteractionRequirements;

  var IfcRelNests = /*#__PURE__*/function (_IfcRelDecomposes) {
    _inherits(IfcRelNests, _IfcRelDecomposes);

    var _super482 = _createSuper(IfcRelNests);

    function IfcRelNests(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      var _this474;

      _classCallCheck2(this, IfcRelNests);

      _this474 = _super482.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects);
      _this474.GlobalId = GlobalId;
      _this474.OwnerHistory = OwnerHistory;
      _this474.Name = Name;
      _this474.Description = Description;
      _this474.RelatingObject = RelatingObject;
      _this474.RelatedObjects = RelatedObjects;
      _this474.type = 3268803585;
      return _this474;
    }

    return IfcRelNests;
  }(IfcRelDecomposes);

  IFC2X32.IfcRelNests = IfcRelNests;

  var IfcRelOccupiesSpaces = /*#__PURE__*/function (_IfcRelAssignsToActor) {
    _inherits(IfcRelOccupiesSpaces, _IfcRelAssignsToActor);

    var _super483 = _createSuper(IfcRelOccupiesSpaces);

    function IfcRelOccupiesSpaces(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      var _this475;

      _classCallCheck2(this, IfcRelOccupiesSpaces);

      _this475 = _super483.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole);
      _this475.GlobalId = GlobalId;
      _this475.OwnerHistory = OwnerHistory;
      _this475.Name = Name;
      _this475.Description = Description;
      _this475.RelatedObjects = RelatedObjects;
      _this475.RelatedObjectsType = RelatedObjectsType;
      _this475.RelatingActor = RelatingActor;
      _this475.ActingRole = ActingRole;
      _this475.type = 2051452291;
      return _this475;
    }

    return IfcRelOccupiesSpaces;
  }(IfcRelAssignsToActor);

  IFC2X32.IfcRelOccupiesSpaces = IfcRelOccupiesSpaces;

  var IfcRelOverridesProperties = /*#__PURE__*/function (_IfcRelDefinesByPrope) {
    _inherits(IfcRelOverridesProperties, _IfcRelDefinesByPrope);

    var _super484 = _createSuper(IfcRelOverridesProperties);

    function IfcRelOverridesProperties(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition, OverridingProperties) {
      var _this476;

      _classCallCheck2(this, IfcRelOverridesProperties);

      _this476 = _super484.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition);
      _this476.GlobalId = GlobalId;
      _this476.OwnerHistory = OwnerHistory;
      _this476.Name = Name;
      _this476.Description = Description;
      _this476.RelatedObjects = RelatedObjects;
      _this476.RelatingPropertyDefinition = RelatingPropertyDefinition;
      _this476.OverridingProperties = OverridingProperties;
      _this476.type = 202636808;
      return _this476;
    }

    return IfcRelOverridesProperties;
  }(IfcRelDefinesByProperties);

  IFC2X32.IfcRelOverridesProperties = IfcRelOverridesProperties;

  var IfcRelProjectsElement = /*#__PURE__*/function (_IfcRelConnects13) {
    _inherits(IfcRelProjectsElement, _IfcRelConnects13);

    var _super485 = _createSuper(IfcRelProjectsElement);

    function IfcRelProjectsElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement) {
      var _this477;

      _classCallCheck2(this, IfcRelProjectsElement);

      _this477 = _super485.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this477.GlobalId = GlobalId;
      _this477.OwnerHistory = OwnerHistory;
      _this477.Name = Name;
      _this477.Description = Description;
      _this477.RelatingElement = RelatingElement;
      _this477.RelatedFeatureElement = RelatedFeatureElement;
      _this477.type = 750771296;
      return _this477;
    }

    return IfcRelProjectsElement;
  }(IfcRelConnects);

  IFC2X32.IfcRelProjectsElement = IfcRelProjectsElement;

  var IfcRelReferencedInSpatialStructure = /*#__PURE__*/function (_IfcRelConnects14) {
    _inherits(IfcRelReferencedInSpatialStructure, _IfcRelConnects14);

    var _super486 = _createSuper(IfcRelReferencedInSpatialStructure);

    function IfcRelReferencedInSpatialStructure(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      var _this478;

      _classCallCheck2(this, IfcRelReferencedInSpatialStructure);

      _this478 = _super486.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this478.GlobalId = GlobalId;
      _this478.OwnerHistory = OwnerHistory;
      _this478.Name = Name;
      _this478.Description = Description;
      _this478.RelatedElements = RelatedElements;
      _this478.RelatingStructure = RelatingStructure;
      _this478.type = 1245217292;
      return _this478;
    }

    return IfcRelReferencedInSpatialStructure;
  }(IfcRelConnects);

  IFC2X32.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;

  var IfcRelSchedulesCostItems = /*#__PURE__*/function (_IfcRelAssignsToContr2) {
    _inherits(IfcRelSchedulesCostItems, _IfcRelAssignsToContr2);

    var _super487 = _createSuper(IfcRelSchedulesCostItems);

    function IfcRelSchedulesCostItems(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      var _this479;

      _classCallCheck2(this, IfcRelSchedulesCostItems);

      _this479 = _super487.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
      _this479.GlobalId = GlobalId;
      _this479.OwnerHistory = OwnerHistory;
      _this479.Name = Name;
      _this479.Description = Description;
      _this479.RelatedObjects = RelatedObjects;
      _this479.RelatedObjectsType = RelatedObjectsType;
      _this479.RelatingControl = RelatingControl;
      _this479.type = 1058617721;
      return _this479;
    }

    return IfcRelSchedulesCostItems;
  }(IfcRelAssignsToControl);

  IFC2X32.IfcRelSchedulesCostItems = IfcRelSchedulesCostItems;

  var IfcRelSequence = /*#__PURE__*/function (_IfcRelConnects15) {
    _inherits(IfcRelSequence, _IfcRelConnects15);

    var _super488 = _createSuper(IfcRelSequence);

    function IfcRelSequence(expressID, GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType) {
      var _this480;

      _classCallCheck2(this, IfcRelSequence);

      _this480 = _super488.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this480.GlobalId = GlobalId;
      _this480.OwnerHistory = OwnerHistory;
      _this480.Name = Name;
      _this480.Description = Description;
      _this480.RelatingProcess = RelatingProcess;
      _this480.RelatedProcess = RelatedProcess;
      _this480.TimeLag = TimeLag;
      _this480.SequenceType = SequenceType;
      _this480.type = 4122056220;
      return _this480;
    }

    return IfcRelSequence;
  }(IfcRelConnects);

  IFC2X32.IfcRelSequence = IfcRelSequence;

  var IfcRelServicesBuildings = /*#__PURE__*/function (_IfcRelConnects16) {
    _inherits(IfcRelServicesBuildings, _IfcRelConnects16);

    var _super489 = _createSuper(IfcRelServicesBuildings);

    function IfcRelServicesBuildings(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings) {
      var _this481;

      _classCallCheck2(this, IfcRelServicesBuildings);

      _this481 = _super489.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this481.GlobalId = GlobalId;
      _this481.OwnerHistory = OwnerHistory;
      _this481.Name = Name;
      _this481.Description = Description;
      _this481.RelatingSystem = RelatingSystem;
      _this481.RelatedBuildings = RelatedBuildings;
      _this481.type = 366585022;
      return _this481;
    }

    return IfcRelServicesBuildings;
  }(IfcRelConnects);

  IFC2X32.IfcRelServicesBuildings = IfcRelServicesBuildings;

  var IfcRelSpaceBoundary = /*#__PURE__*/function (_IfcRelConnects17) {
    _inherits(IfcRelSpaceBoundary, _IfcRelConnects17);

    var _super490 = _createSuper(IfcRelSpaceBoundary);

    function IfcRelSpaceBoundary(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary) {
      var _this482;

      _classCallCheck2(this, IfcRelSpaceBoundary);

      _this482 = _super490.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this482.GlobalId = GlobalId;
      _this482.OwnerHistory = OwnerHistory;
      _this482.Name = Name;
      _this482.Description = Description;
      _this482.RelatingSpace = RelatingSpace;
      _this482.RelatedBuildingElement = RelatedBuildingElement;
      _this482.ConnectionGeometry = ConnectionGeometry;
      _this482.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      _this482.InternalOrExternalBoundary = InternalOrExternalBoundary;
      _this482.type = 3451746338;
      return _this482;
    }

    return IfcRelSpaceBoundary;
  }(IfcRelConnects);

  IFC2X32.IfcRelSpaceBoundary = IfcRelSpaceBoundary;

  var IfcRelVoidsElement = /*#__PURE__*/function (_IfcRelConnects18) {
    _inherits(IfcRelVoidsElement, _IfcRelConnects18);

    var _super491 = _createSuper(IfcRelVoidsElement);

    function IfcRelVoidsElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement) {
      var _this483;

      _classCallCheck2(this, IfcRelVoidsElement);

      _this483 = _super491.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this483.GlobalId = GlobalId;
      _this483.OwnerHistory = OwnerHistory;
      _this483.Name = Name;
      _this483.Description = Description;
      _this483.RelatingBuildingElement = RelatingBuildingElement;
      _this483.RelatedOpeningElement = RelatedOpeningElement;
      _this483.type = 1401173127;
      return _this483;
    }

    return IfcRelVoidsElement;
  }(IfcRelConnects);

  IFC2X32.IfcRelVoidsElement = IfcRelVoidsElement;

  var IfcResource = /*#__PURE__*/function (_IfcObject4) {
    _inherits(IfcResource, _IfcObject4);

    var _super492 = _createSuper(IfcResource);

    function IfcResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this484;

      _classCallCheck2(this, IfcResource);

      _this484 = _super492.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this484.GlobalId = GlobalId;
      _this484.OwnerHistory = OwnerHistory;
      _this484.Name = Name;
      _this484.Description = Description;
      _this484.ObjectType = ObjectType;
      _this484.type = 2914609552;
      return _this484;
    }

    return IfcResource;
  }(IfcObject);

  IFC2X32.IfcResource = IfcResource;

  var IfcRevolvedAreaSolid = /*#__PURE__*/function (_IfcSweptAreaSolid2) {
    _inherits(IfcRevolvedAreaSolid, _IfcSweptAreaSolid2);

    var _super493 = _createSuper(IfcRevolvedAreaSolid);

    function IfcRevolvedAreaSolid(expressID, SweptArea, Position, Axis, Angle) {
      var _this485;

      _classCallCheck2(this, IfcRevolvedAreaSolid);

      _this485 = _super493.call(this, expressID, SweptArea, Position);
      _this485.SweptArea = SweptArea;
      _this485.Position = Position;
      _this485.Axis = Axis;
      _this485.Angle = Angle;
      _this485.type = 1856042241;
      return _this485;
    }

    return IfcRevolvedAreaSolid;
  }(IfcSweptAreaSolid);

  IFC2X32.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;

  var IfcRightCircularCone = /*#__PURE__*/function (_IfcCsgPrimitive3D2) {
    _inherits(IfcRightCircularCone, _IfcCsgPrimitive3D2);

    var _super494 = _createSuper(IfcRightCircularCone);

    function IfcRightCircularCone(expressID, Position, Height, BottomRadius) {
      var _this486;

      _classCallCheck2(this, IfcRightCircularCone);

      _this486 = _super494.call(this, expressID, Position);
      _this486.Position = Position;
      _this486.Height = Height;
      _this486.BottomRadius = BottomRadius;
      _this486.type = 4158566097;
      return _this486;
    }

    return IfcRightCircularCone;
  }(IfcCsgPrimitive3D);

  IFC2X32.IfcRightCircularCone = IfcRightCircularCone;

  var IfcRightCircularCylinder = /*#__PURE__*/function (_IfcCsgPrimitive3D3) {
    _inherits(IfcRightCircularCylinder, _IfcCsgPrimitive3D3);

    var _super495 = _createSuper(IfcRightCircularCylinder);

    function IfcRightCircularCylinder(expressID, Position, Height, Radius) {
      var _this487;

      _classCallCheck2(this, IfcRightCircularCylinder);

      _this487 = _super495.call(this, expressID, Position);
      _this487.Position = Position;
      _this487.Height = Height;
      _this487.Radius = Radius;
      _this487.type = 3626867408;
      return _this487;
    }

    return IfcRightCircularCylinder;
  }(IfcCsgPrimitive3D);

  IFC2X32.IfcRightCircularCylinder = IfcRightCircularCylinder;

  var IfcSpatialStructureElement = /*#__PURE__*/function (_IfcProduct2) {
    _inherits(IfcSpatialStructureElement, _IfcProduct2);

    var _super496 = _createSuper(IfcSpatialStructureElement);

    function IfcSpatialStructureElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      var _this488;

      _classCallCheck2(this, IfcSpatialStructureElement);

      _this488 = _super496.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this488.GlobalId = GlobalId;
      _this488.OwnerHistory = OwnerHistory;
      _this488.Name = Name;
      _this488.Description = Description;
      _this488.ObjectType = ObjectType;
      _this488.ObjectPlacement = ObjectPlacement;
      _this488.Representation = Representation;
      _this488.LongName = LongName;
      _this488.CompositionType = CompositionType;
      _this488.type = 2706606064;
      return _this488;
    }

    return IfcSpatialStructureElement;
  }(IfcProduct);

  IFC2X32.IfcSpatialStructureElement = IfcSpatialStructureElement;

  var IfcSpatialStructureElementType = /*#__PURE__*/function (_IfcElementType2) {
    _inherits(IfcSpatialStructureElementType, _IfcElementType2);

    var _super497 = _createSuper(IfcSpatialStructureElementType);

    function IfcSpatialStructureElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this489;

      _classCallCheck2(this, IfcSpatialStructureElementType);

      _this489 = _super497.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this489.GlobalId = GlobalId;
      _this489.OwnerHistory = OwnerHistory;
      _this489.Name = Name;
      _this489.Description = Description;
      _this489.ApplicableOccurrence = ApplicableOccurrence;
      _this489.HasPropertySets = HasPropertySets;
      _this489.RepresentationMaps = RepresentationMaps;
      _this489.Tag = Tag;
      _this489.ElementType = ElementType;
      _this489.type = 3893378262;
      return _this489;
    }

    return IfcSpatialStructureElementType;
  }(IfcElementType);

  IFC2X32.IfcSpatialStructureElementType = IfcSpatialStructureElementType;

  var IfcSphere = /*#__PURE__*/function (_IfcCsgPrimitive3D4) {
    _inherits(IfcSphere, _IfcCsgPrimitive3D4);

    var _super498 = _createSuper(IfcSphere);

    function IfcSphere(expressID, Position, Radius) {
      var _this490;

      _classCallCheck2(this, IfcSphere);

      _this490 = _super498.call(this, expressID, Position);
      _this490.Position = Position;
      _this490.Radius = Radius;
      _this490.type = 451544542;
      return _this490;
    }

    return IfcSphere;
  }(IfcCsgPrimitive3D);

  IFC2X32.IfcSphere = IfcSphere;

  var IfcStructuralActivity = /*#__PURE__*/function (_IfcProduct3) {
    _inherits(IfcStructuralActivity, _IfcProduct3);

    var _super499 = _createSuper(IfcStructuralActivity);

    function IfcStructuralActivity(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      var _this491;

      _classCallCheck2(this, IfcStructuralActivity);

      _this491 = _super499.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this491.GlobalId = GlobalId;
      _this491.OwnerHistory = OwnerHistory;
      _this491.Name = Name;
      _this491.Description = Description;
      _this491.ObjectType = ObjectType;
      _this491.ObjectPlacement = ObjectPlacement;
      _this491.Representation = Representation;
      _this491.AppliedLoad = AppliedLoad;
      _this491.GlobalOrLocal = GlobalOrLocal;
      _this491.type = 3544373492;
      return _this491;
    }

    return IfcStructuralActivity;
  }(IfcProduct);

  IFC2X32.IfcStructuralActivity = IfcStructuralActivity;

  var IfcStructuralItem = /*#__PURE__*/function (_IfcProduct4) {
    _inherits(IfcStructuralItem, _IfcProduct4);

    var _super500 = _createSuper(IfcStructuralItem);

    function IfcStructuralItem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this492;

      _classCallCheck2(this, IfcStructuralItem);

      _this492 = _super500.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this492.GlobalId = GlobalId;
      _this492.OwnerHistory = OwnerHistory;
      _this492.Name = Name;
      _this492.Description = Description;
      _this492.ObjectType = ObjectType;
      _this492.ObjectPlacement = ObjectPlacement;
      _this492.Representation = Representation;
      _this492.type = 3136571912;
      return _this492;
    }

    return IfcStructuralItem;
  }(IfcProduct);

  IFC2X32.IfcStructuralItem = IfcStructuralItem;

  var IfcStructuralMember = /*#__PURE__*/function (_IfcStructuralItem) {
    _inherits(IfcStructuralMember, _IfcStructuralItem);

    var _super501 = _createSuper(IfcStructuralMember);

    function IfcStructuralMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this493;

      _classCallCheck2(this, IfcStructuralMember);

      _this493 = _super501.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this493.GlobalId = GlobalId;
      _this493.OwnerHistory = OwnerHistory;
      _this493.Name = Name;
      _this493.Description = Description;
      _this493.ObjectType = ObjectType;
      _this493.ObjectPlacement = ObjectPlacement;
      _this493.Representation = Representation;
      _this493.type = 530289379;
      return _this493;
    }

    return IfcStructuralMember;
  }(IfcStructuralItem);

  IFC2X32.IfcStructuralMember = IfcStructuralMember;

  var IfcStructuralReaction = /*#__PURE__*/function (_IfcStructuralActivit) {
    _inherits(IfcStructuralReaction, _IfcStructuralActivit);

    var _super502 = _createSuper(IfcStructuralReaction);

    function IfcStructuralReaction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      var _this494;

      _classCallCheck2(this, IfcStructuralReaction);

      _this494 = _super502.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this494.GlobalId = GlobalId;
      _this494.OwnerHistory = OwnerHistory;
      _this494.Name = Name;
      _this494.Description = Description;
      _this494.ObjectType = ObjectType;
      _this494.ObjectPlacement = ObjectPlacement;
      _this494.Representation = Representation;
      _this494.AppliedLoad = AppliedLoad;
      _this494.GlobalOrLocal = GlobalOrLocal;
      _this494.type = 3689010777;
      return _this494;
    }

    return IfcStructuralReaction;
  }(IfcStructuralActivity);

  IFC2X32.IfcStructuralReaction = IfcStructuralReaction;

  var IfcStructuralSurfaceMember = /*#__PURE__*/function (_IfcStructuralMember) {
    _inherits(IfcStructuralSurfaceMember, _IfcStructuralMember);

    var _super503 = _createSuper(IfcStructuralSurfaceMember);

    function IfcStructuralSurfaceMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      var _this495;

      _classCallCheck2(this, IfcStructuralSurfaceMember);

      _this495 = _super503.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this495.GlobalId = GlobalId;
      _this495.OwnerHistory = OwnerHistory;
      _this495.Name = Name;
      _this495.Description = Description;
      _this495.ObjectType = ObjectType;
      _this495.ObjectPlacement = ObjectPlacement;
      _this495.Representation = Representation;
      _this495.PredefinedType = PredefinedType;
      _this495.Thickness = Thickness;
      _this495.type = 3979015343;
      return _this495;
    }

    return IfcStructuralSurfaceMember;
  }(IfcStructuralMember);

  IFC2X32.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;

  var IfcStructuralSurfaceMemberVarying = /*#__PURE__*/function (_IfcStructuralSurface) {
    _inherits(IfcStructuralSurfaceMemberVarying, _IfcStructuralSurface);

    var _super504 = _createSuper(IfcStructuralSurfaceMemberVarying);

    function IfcStructuralSurfaceMemberVarying(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness, SubsequentThickness, VaryingThicknessLocation) {
      var _this496;

      _classCallCheck2(this, IfcStructuralSurfaceMemberVarying);

      _this496 = _super504.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
      _this496.GlobalId = GlobalId;
      _this496.OwnerHistory = OwnerHistory;
      _this496.Name = Name;
      _this496.Description = Description;
      _this496.ObjectType = ObjectType;
      _this496.ObjectPlacement = ObjectPlacement;
      _this496.Representation = Representation;
      _this496.PredefinedType = PredefinedType;
      _this496.Thickness = Thickness;
      _this496.SubsequentThickness = SubsequentThickness;
      _this496.VaryingThicknessLocation = VaryingThicknessLocation;
      _this496.type = 2218152070;
      return _this496;
    }

    return IfcStructuralSurfaceMemberVarying;
  }(IfcStructuralSurfaceMember);

  IFC2X32.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;

  var IfcStructuredDimensionCallout = /*#__PURE__*/function (_IfcDraughtingCallout3) {
    _inherits(IfcStructuredDimensionCallout, _IfcDraughtingCallout3);

    var _super505 = _createSuper(IfcStructuredDimensionCallout);

    function IfcStructuredDimensionCallout(expressID, Contents) {
      var _this497;

      _classCallCheck2(this, IfcStructuredDimensionCallout);

      _this497 = _super505.call(this, expressID, Contents);
      _this497.Contents = Contents;
      _this497.type = 4070609034;
      return _this497;
    }

    return IfcStructuredDimensionCallout;
  }(IfcDraughtingCallout);

  IFC2X32.IfcStructuredDimensionCallout = IfcStructuredDimensionCallout;

  var IfcSurfaceCurveSweptAreaSolid = /*#__PURE__*/function (_IfcSweptAreaSolid3) {
    _inherits(IfcSurfaceCurveSweptAreaSolid, _IfcSweptAreaSolid3);

    var _super506 = _createSuper(IfcSurfaceCurveSweptAreaSolid);

    function IfcSurfaceCurveSweptAreaSolid(expressID, SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface) {
      var _this498;

      _classCallCheck2(this, IfcSurfaceCurveSweptAreaSolid);

      _this498 = _super506.call(this, expressID, SweptArea, Position);
      _this498.SweptArea = SweptArea;
      _this498.Position = Position;
      _this498.Directrix = Directrix;
      _this498.StartParam = StartParam;
      _this498.EndParam = EndParam;
      _this498.ReferenceSurface = ReferenceSurface;
      _this498.type = 2028607225;
      return _this498;
    }

    return IfcSurfaceCurveSweptAreaSolid;
  }(IfcSweptAreaSolid);

  IFC2X32.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;

  var IfcSurfaceOfLinearExtrusion = /*#__PURE__*/function (_IfcSweptSurface) {
    _inherits(IfcSurfaceOfLinearExtrusion, _IfcSweptSurface);

    var _super507 = _createSuper(IfcSurfaceOfLinearExtrusion);

    function IfcSurfaceOfLinearExtrusion(expressID, SweptCurve, Position, ExtrudedDirection, Depth) {
      var _this499;

      _classCallCheck2(this, IfcSurfaceOfLinearExtrusion);

      _this499 = _super507.call(this, expressID, SweptCurve, Position);
      _this499.SweptCurve = SweptCurve;
      _this499.Position = Position;
      _this499.ExtrudedDirection = ExtrudedDirection;
      _this499.Depth = Depth;
      _this499.type = 2809605785;
      return _this499;
    }

    return IfcSurfaceOfLinearExtrusion;
  }(IfcSweptSurface);

  IFC2X32.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;

  var IfcSurfaceOfRevolution = /*#__PURE__*/function (_IfcSweptSurface2) {
    _inherits(IfcSurfaceOfRevolution, _IfcSweptSurface2);

    var _super508 = _createSuper(IfcSurfaceOfRevolution);

    function IfcSurfaceOfRevolution(expressID, SweptCurve, Position, AxisPosition) {
      var _this500;

      _classCallCheck2(this, IfcSurfaceOfRevolution);

      _this500 = _super508.call(this, expressID, SweptCurve, Position);
      _this500.SweptCurve = SweptCurve;
      _this500.Position = Position;
      _this500.AxisPosition = AxisPosition;
      _this500.type = 4124788165;
      return _this500;
    }

    return IfcSurfaceOfRevolution;
  }(IfcSweptSurface);

  IFC2X32.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;

  var IfcSystemFurnitureElementType = /*#__PURE__*/function (_IfcFurnishingElement2) {
    _inherits(IfcSystemFurnitureElementType, _IfcFurnishingElement2);

    var _super509 = _createSuper(IfcSystemFurnitureElementType);

    function IfcSystemFurnitureElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this501;

      _classCallCheck2(this, IfcSystemFurnitureElementType);

      _this501 = _super509.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this501.GlobalId = GlobalId;
      _this501.OwnerHistory = OwnerHistory;
      _this501.Name = Name;
      _this501.Description = Description;
      _this501.ApplicableOccurrence = ApplicableOccurrence;
      _this501.HasPropertySets = HasPropertySets;
      _this501.RepresentationMaps = RepresentationMaps;
      _this501.Tag = Tag;
      _this501.ElementType = ElementType;
      _this501.type = 1580310250;
      return _this501;
    }

    return IfcSystemFurnitureElementType;
  }(IfcFurnishingElementType);

  IFC2X32.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;

  var IfcTask = /*#__PURE__*/function (_IfcProcess) {
    _inherits(IfcTask, _IfcProcess);

    var _super510 = _createSuper(IfcTask);

    function IfcTask(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority) {
      var _this502;

      _classCallCheck2(this, IfcTask);

      _this502 = _super510.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this502.GlobalId = GlobalId;
      _this502.OwnerHistory = OwnerHistory;
      _this502.Name = Name;
      _this502.Description = Description;
      _this502.ObjectType = ObjectType;
      _this502.TaskId = TaskId;
      _this502.Status = Status;
      _this502.WorkMethod = WorkMethod;
      _this502.IsMilestone = IsMilestone;
      _this502.Priority = Priority;
      _this502.type = 3473067441;
      return _this502;
    }

    return IfcTask;
  }(IfcProcess);

  IFC2X32.IfcTask = IfcTask;

  var IfcTransportElementType = /*#__PURE__*/function (_IfcElementType3) {
    _inherits(IfcTransportElementType, _IfcElementType3);

    var _super511 = _createSuper(IfcTransportElementType);

    function IfcTransportElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this503;

      _classCallCheck2(this, IfcTransportElementType);

      _this503 = _super511.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this503.GlobalId = GlobalId;
      _this503.OwnerHistory = OwnerHistory;
      _this503.Name = Name;
      _this503.Description = Description;
      _this503.ApplicableOccurrence = ApplicableOccurrence;
      _this503.HasPropertySets = HasPropertySets;
      _this503.RepresentationMaps = RepresentationMaps;
      _this503.Tag = Tag;
      _this503.ElementType = ElementType;
      _this503.PredefinedType = PredefinedType;
      _this503.type = 2097647324;
      return _this503;
    }

    return IfcTransportElementType;
  }(IfcElementType);

  IFC2X32.IfcTransportElementType = IfcTransportElementType;

  var IfcActor = /*#__PURE__*/function (_IfcObject5) {
    _inherits(IfcActor, _IfcObject5);

    var _super512 = _createSuper(IfcActor);

    function IfcActor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor) {
      var _this504;

      _classCallCheck2(this, IfcActor);

      _this504 = _super512.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this504.GlobalId = GlobalId;
      _this504.OwnerHistory = OwnerHistory;
      _this504.Name = Name;
      _this504.Description = Description;
      _this504.ObjectType = ObjectType;
      _this504.TheActor = TheActor;
      _this504.type = 2296667514;
      return _this504;
    }

    return IfcActor;
  }(IfcObject);

  IFC2X32.IfcActor = IfcActor;

  var IfcAnnotation = /*#__PURE__*/function (_IfcProduct5) {
    _inherits(IfcAnnotation, _IfcProduct5);

    var _super513 = _createSuper(IfcAnnotation);

    function IfcAnnotation(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this505;

      _classCallCheck2(this, IfcAnnotation);

      _this505 = _super513.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this505.GlobalId = GlobalId;
      _this505.OwnerHistory = OwnerHistory;
      _this505.Name = Name;
      _this505.Description = Description;
      _this505.ObjectType = ObjectType;
      _this505.ObjectPlacement = ObjectPlacement;
      _this505.Representation = Representation;
      _this505.type = 1674181508;
      return _this505;
    }

    return IfcAnnotation;
  }(IfcProduct);

  IFC2X32.IfcAnnotation = IfcAnnotation;

  var IfcAsymmetricIShapeProfileDef = /*#__PURE__*/function (_IfcIShapeProfileDef) {
    _inherits(IfcAsymmetricIShapeProfileDef, _IfcIShapeProfileDef);

    var _super514 = _createSuper(IfcAsymmetricIShapeProfileDef);

    function IfcAsymmetricIShapeProfileDef(expressID, ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, CentreOfGravityInY) {
      var _this506;

      _classCallCheck2(this, IfcAsymmetricIShapeProfileDef);

      _this506 = _super514.call(this, expressID, ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius);
      _this506.ProfileType = ProfileType;
      _this506.ProfileName = ProfileName;
      _this506.Position = Position;
      _this506.OverallWidth = OverallWidth;
      _this506.OverallDepth = OverallDepth;
      _this506.WebThickness = WebThickness;
      _this506.FlangeThickness = FlangeThickness;
      _this506.FilletRadius = FilletRadius;
      _this506.TopFlangeWidth = TopFlangeWidth;
      _this506.TopFlangeThickness = TopFlangeThickness;
      _this506.TopFlangeFilletRadius = TopFlangeFilletRadius;
      _this506.CentreOfGravityInY = CentreOfGravityInY;
      _this506.type = 3207858831;
      return _this506;
    }

    return IfcAsymmetricIShapeProfileDef;
  }(IfcIShapeProfileDef);

  IFC2X32.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;

  var IfcBlock = /*#__PURE__*/function (_IfcCsgPrimitive3D5) {
    _inherits(IfcBlock, _IfcCsgPrimitive3D5);

    var _super515 = _createSuper(IfcBlock);

    function IfcBlock(expressID, Position, XLength, YLength, ZLength) {
      var _this507;

      _classCallCheck2(this, IfcBlock);

      _this507 = _super515.call(this, expressID, Position);
      _this507.Position = Position;
      _this507.XLength = XLength;
      _this507.YLength = YLength;
      _this507.ZLength = ZLength;
      _this507.type = 1334484129;
      return _this507;
    }

    return IfcBlock;
  }(IfcCsgPrimitive3D);

  IFC2X32.IfcBlock = IfcBlock;

  var IfcBooleanClippingResult = /*#__PURE__*/function (_IfcBooleanResult) {
    _inherits(IfcBooleanClippingResult, _IfcBooleanResult);

    var _super516 = _createSuper(IfcBooleanClippingResult);

    function IfcBooleanClippingResult(expressID, Operator, FirstOperand, SecondOperand) {
      var _this508;

      _classCallCheck2(this, IfcBooleanClippingResult);

      _this508 = _super516.call(this, expressID, Operator, FirstOperand, SecondOperand);
      _this508.Operator = Operator;
      _this508.FirstOperand = FirstOperand;
      _this508.SecondOperand = SecondOperand;
      _this508.type = 3649129432;
      return _this508;
    }

    return IfcBooleanClippingResult;
  }(IfcBooleanResult);

  IFC2X32.IfcBooleanClippingResult = IfcBooleanClippingResult;

  var IfcBoundedCurve = /*#__PURE__*/function (_IfcCurve4) {
    _inherits(IfcBoundedCurve, _IfcCurve4);

    var _super517 = _createSuper(IfcBoundedCurve);

    function IfcBoundedCurve(expressID) {
      var _this509;

      _classCallCheck2(this, IfcBoundedCurve);

      _this509 = _super517.call(this, expressID);
      _this509.type = 1260505505;
      return _this509;
    }

    return IfcBoundedCurve;
  }(IfcCurve);

  IFC2X32.IfcBoundedCurve = IfcBoundedCurve;

  var IfcBuilding = /*#__PURE__*/function (_IfcSpatialStructureE) {
    _inherits(IfcBuilding, _IfcSpatialStructureE);

    var _super518 = _createSuper(IfcBuilding);

    function IfcBuilding(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress) {
      var _this510;

      _classCallCheck2(this, IfcBuilding);

      _this510 = _super518.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this510.GlobalId = GlobalId;
      _this510.OwnerHistory = OwnerHistory;
      _this510.Name = Name;
      _this510.Description = Description;
      _this510.ObjectType = ObjectType;
      _this510.ObjectPlacement = ObjectPlacement;
      _this510.Representation = Representation;
      _this510.LongName = LongName;
      _this510.CompositionType = CompositionType;
      _this510.ElevationOfRefHeight = ElevationOfRefHeight;
      _this510.ElevationOfTerrain = ElevationOfTerrain;
      _this510.BuildingAddress = BuildingAddress;
      _this510.type = 4031249490;
      return _this510;
    }

    return IfcBuilding;
  }(IfcSpatialStructureElement);

  IFC2X32.IfcBuilding = IfcBuilding;

  var IfcBuildingElementType = /*#__PURE__*/function (_IfcElementType4) {
    _inherits(IfcBuildingElementType, _IfcElementType4);

    var _super519 = _createSuper(IfcBuildingElementType);

    function IfcBuildingElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this511;

      _classCallCheck2(this, IfcBuildingElementType);

      _this511 = _super519.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this511.GlobalId = GlobalId;
      _this511.OwnerHistory = OwnerHistory;
      _this511.Name = Name;
      _this511.Description = Description;
      _this511.ApplicableOccurrence = ApplicableOccurrence;
      _this511.HasPropertySets = HasPropertySets;
      _this511.RepresentationMaps = RepresentationMaps;
      _this511.Tag = Tag;
      _this511.ElementType = ElementType;
      _this511.type = 1950629157;
      return _this511;
    }

    return IfcBuildingElementType;
  }(IfcElementType);

  IFC2X32.IfcBuildingElementType = IfcBuildingElementType;

  var IfcBuildingStorey = /*#__PURE__*/function (_IfcSpatialStructureE2) {
    _inherits(IfcBuildingStorey, _IfcSpatialStructureE2);

    var _super520 = _createSuper(IfcBuildingStorey);

    function IfcBuildingStorey(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation) {
      var _this512;

      _classCallCheck2(this, IfcBuildingStorey);

      _this512 = _super520.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this512.GlobalId = GlobalId;
      _this512.OwnerHistory = OwnerHistory;
      _this512.Name = Name;
      _this512.Description = Description;
      _this512.ObjectType = ObjectType;
      _this512.ObjectPlacement = ObjectPlacement;
      _this512.Representation = Representation;
      _this512.LongName = LongName;
      _this512.CompositionType = CompositionType;
      _this512.Elevation = Elevation;
      _this512.type = 3124254112;
      return _this512;
    }

    return IfcBuildingStorey;
  }(IfcSpatialStructureElement);

  IFC2X32.IfcBuildingStorey = IfcBuildingStorey;

  var IfcCircleHollowProfileDef = /*#__PURE__*/function (_IfcCircleProfileDef) {
    _inherits(IfcCircleHollowProfileDef, _IfcCircleProfileDef);

    var _super521 = _createSuper(IfcCircleHollowProfileDef);

    function IfcCircleHollowProfileDef(expressID, ProfileType, ProfileName, Position, Radius, WallThickness) {
      var _this513;

      _classCallCheck2(this, IfcCircleHollowProfileDef);

      _this513 = _super521.call(this, expressID, ProfileType, ProfileName, Position, Radius);
      _this513.ProfileType = ProfileType;
      _this513.ProfileName = ProfileName;
      _this513.Position = Position;
      _this513.Radius = Radius;
      _this513.WallThickness = WallThickness;
      _this513.type = 2937912522;
      return _this513;
    }

    return IfcCircleHollowProfileDef;
  }(IfcCircleProfileDef);

  IFC2X32.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;

  var IfcColumnType = /*#__PURE__*/function (_IfcBuildingElementTy) {
    _inherits(IfcColumnType, _IfcBuildingElementTy);

    var _super522 = _createSuper(IfcColumnType);

    function IfcColumnType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this514;

      _classCallCheck2(this, IfcColumnType);

      _this514 = _super522.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this514.GlobalId = GlobalId;
      _this514.OwnerHistory = OwnerHistory;
      _this514.Name = Name;
      _this514.Description = Description;
      _this514.ApplicableOccurrence = ApplicableOccurrence;
      _this514.HasPropertySets = HasPropertySets;
      _this514.RepresentationMaps = RepresentationMaps;
      _this514.Tag = Tag;
      _this514.ElementType = ElementType;
      _this514.PredefinedType = PredefinedType;
      _this514.type = 300633059;
      return _this514;
    }

    return IfcColumnType;
  }(IfcBuildingElementType);

  IFC2X32.IfcColumnType = IfcColumnType;

  var IfcCompositeCurve = /*#__PURE__*/function (_IfcBoundedCurve) {
    _inherits(IfcCompositeCurve, _IfcBoundedCurve);

    var _super523 = _createSuper(IfcCompositeCurve);

    function IfcCompositeCurve(expressID, Segments, SelfIntersect) {
      var _this515;

      _classCallCheck2(this, IfcCompositeCurve);

      _this515 = _super523.call(this, expressID);
      _this515.Segments = Segments;
      _this515.SelfIntersect = SelfIntersect;
      _this515.type = 3732776249;
      return _this515;
    }

    return IfcCompositeCurve;
  }(IfcBoundedCurve);

  IFC2X32.IfcCompositeCurve = IfcCompositeCurve;

  var IfcConic = /*#__PURE__*/function (_IfcCurve5) {
    _inherits(IfcConic, _IfcCurve5);

    var _super524 = _createSuper(IfcConic);

    function IfcConic(expressID, Position) {
      var _this516;

      _classCallCheck2(this, IfcConic);

      _this516 = _super524.call(this, expressID);
      _this516.Position = Position;
      _this516.type = 2510884976;
      return _this516;
    }

    return IfcConic;
  }(IfcCurve);

  IFC2X32.IfcConic = IfcConic;

  var IfcConstructionResource = /*#__PURE__*/function (_IfcResource) {
    _inherits(IfcConstructionResource, _IfcResource);

    var _super525 = _createSuper(IfcConstructionResource);

    function IfcConstructionResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      var _this517;

      _classCallCheck2(this, IfcConstructionResource);

      _this517 = _super525.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this517.GlobalId = GlobalId;
      _this517.OwnerHistory = OwnerHistory;
      _this517.Name = Name;
      _this517.Description = Description;
      _this517.ObjectType = ObjectType;
      _this517.ResourceIdentifier = ResourceIdentifier;
      _this517.ResourceGroup = ResourceGroup;
      _this517.ResourceConsumption = ResourceConsumption;
      _this517.BaseQuantity = BaseQuantity;
      _this517.type = 2559216714;
      return _this517;
    }

    return IfcConstructionResource;
  }(IfcResource);

  IFC2X32.IfcConstructionResource = IfcConstructionResource;

  var IfcControl = /*#__PURE__*/function (_IfcObject6) {
    _inherits(IfcControl, _IfcObject6);

    var _super526 = _createSuper(IfcControl);

    function IfcControl(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this518;

      _classCallCheck2(this, IfcControl);

      _this518 = _super526.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this518.GlobalId = GlobalId;
      _this518.OwnerHistory = OwnerHistory;
      _this518.Name = Name;
      _this518.Description = Description;
      _this518.ObjectType = ObjectType;
      _this518.type = 3293443760;
      return _this518;
    }

    return IfcControl;
  }(IfcObject);

  IFC2X32.IfcControl = IfcControl;

  var IfcCostItem = /*#__PURE__*/function (_IfcControl) {
    _inherits(IfcCostItem, _IfcControl);

    var _super527 = _createSuper(IfcCostItem);

    function IfcCostItem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this519;

      _classCallCheck2(this, IfcCostItem);

      _this519 = _super527.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this519.GlobalId = GlobalId;
      _this519.OwnerHistory = OwnerHistory;
      _this519.Name = Name;
      _this519.Description = Description;
      _this519.ObjectType = ObjectType;
      _this519.type = 3895139033;
      return _this519;
    }

    return IfcCostItem;
  }(IfcControl);

  IFC2X32.IfcCostItem = IfcCostItem;

  var IfcCostSchedule = /*#__PURE__*/function (_IfcControl2) {
    _inherits(IfcCostSchedule, _IfcControl2);

    var _super528 = _createSuper(IfcCostSchedule);

    function IfcCostSchedule(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, SubmittedBy, PreparedBy, SubmittedOn, Status, TargetUsers, UpdateDate, ID, PredefinedType) {
      var _this520;

      _classCallCheck2(this, IfcCostSchedule);

      _this520 = _super528.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this520.GlobalId = GlobalId;
      _this520.OwnerHistory = OwnerHistory;
      _this520.Name = Name;
      _this520.Description = Description;
      _this520.ObjectType = ObjectType;
      _this520.SubmittedBy = SubmittedBy;
      _this520.PreparedBy = PreparedBy;
      _this520.SubmittedOn = SubmittedOn;
      _this520.Status = Status;
      _this520.TargetUsers = TargetUsers;
      _this520.UpdateDate = UpdateDate;
      _this520.ID = ID;
      _this520.PredefinedType = PredefinedType;
      _this520.type = 1419761937;
      return _this520;
    }

    return IfcCostSchedule;
  }(IfcControl);

  IFC2X32.IfcCostSchedule = IfcCostSchedule;

  var IfcCoveringType = /*#__PURE__*/function (_IfcBuildingElementTy2) {
    _inherits(IfcCoveringType, _IfcBuildingElementTy2);

    var _super529 = _createSuper(IfcCoveringType);

    function IfcCoveringType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this521;

      _classCallCheck2(this, IfcCoveringType);

      _this521 = _super529.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this521.GlobalId = GlobalId;
      _this521.OwnerHistory = OwnerHistory;
      _this521.Name = Name;
      _this521.Description = Description;
      _this521.ApplicableOccurrence = ApplicableOccurrence;
      _this521.HasPropertySets = HasPropertySets;
      _this521.RepresentationMaps = RepresentationMaps;
      _this521.Tag = Tag;
      _this521.ElementType = ElementType;
      _this521.PredefinedType = PredefinedType;
      _this521.type = 1916426348;
      return _this521;
    }

    return IfcCoveringType;
  }(IfcBuildingElementType);

  IFC2X32.IfcCoveringType = IfcCoveringType;

  var IfcCrewResource = /*#__PURE__*/function (_IfcConstructionResou) {
    _inherits(IfcCrewResource, _IfcConstructionResou);

    var _super530 = _createSuper(IfcCrewResource);

    function IfcCrewResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      var _this522;

      _classCallCheck2(this, IfcCrewResource);

      _this522 = _super530.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      _this522.GlobalId = GlobalId;
      _this522.OwnerHistory = OwnerHistory;
      _this522.Name = Name;
      _this522.Description = Description;
      _this522.ObjectType = ObjectType;
      _this522.ResourceIdentifier = ResourceIdentifier;
      _this522.ResourceGroup = ResourceGroup;
      _this522.ResourceConsumption = ResourceConsumption;
      _this522.BaseQuantity = BaseQuantity;
      _this522.type = 3295246426;
      return _this522;
    }

    return IfcCrewResource;
  }(IfcConstructionResource);

  IFC2X32.IfcCrewResource = IfcCrewResource;

  var IfcCurtainWallType = /*#__PURE__*/function (_IfcBuildingElementTy3) {
    _inherits(IfcCurtainWallType, _IfcBuildingElementTy3);

    var _super531 = _createSuper(IfcCurtainWallType);

    function IfcCurtainWallType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this523;

      _classCallCheck2(this, IfcCurtainWallType);

      _this523 = _super531.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this523.GlobalId = GlobalId;
      _this523.OwnerHistory = OwnerHistory;
      _this523.Name = Name;
      _this523.Description = Description;
      _this523.ApplicableOccurrence = ApplicableOccurrence;
      _this523.HasPropertySets = HasPropertySets;
      _this523.RepresentationMaps = RepresentationMaps;
      _this523.Tag = Tag;
      _this523.ElementType = ElementType;
      _this523.PredefinedType = PredefinedType;
      _this523.type = 1457835157;
      return _this523;
    }

    return IfcCurtainWallType;
  }(IfcBuildingElementType);

  IFC2X32.IfcCurtainWallType = IfcCurtainWallType;

  var IfcDimensionCurveDirectedCallout = /*#__PURE__*/function (_IfcDraughtingCallout4) {
    _inherits(IfcDimensionCurveDirectedCallout, _IfcDraughtingCallout4);

    var _super532 = _createSuper(IfcDimensionCurveDirectedCallout);

    function IfcDimensionCurveDirectedCallout(expressID, Contents) {
      var _this524;

      _classCallCheck2(this, IfcDimensionCurveDirectedCallout);

      _this524 = _super532.call(this, expressID, Contents);
      _this524.Contents = Contents;
      _this524.type = 681481545;
      return _this524;
    }

    return IfcDimensionCurveDirectedCallout;
  }(IfcDraughtingCallout);

  IFC2X32.IfcDimensionCurveDirectedCallout = IfcDimensionCurveDirectedCallout;

  var IfcDistributionElementType = /*#__PURE__*/function (_IfcElementType5) {
    _inherits(IfcDistributionElementType, _IfcElementType5);

    var _super533 = _createSuper(IfcDistributionElementType);

    function IfcDistributionElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this525;

      _classCallCheck2(this, IfcDistributionElementType);

      _this525 = _super533.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this525.GlobalId = GlobalId;
      _this525.OwnerHistory = OwnerHistory;
      _this525.Name = Name;
      _this525.Description = Description;
      _this525.ApplicableOccurrence = ApplicableOccurrence;
      _this525.HasPropertySets = HasPropertySets;
      _this525.RepresentationMaps = RepresentationMaps;
      _this525.Tag = Tag;
      _this525.ElementType = ElementType;
      _this525.type = 3256556792;
      return _this525;
    }

    return IfcDistributionElementType;
  }(IfcElementType);

  IFC2X32.IfcDistributionElementType = IfcDistributionElementType;

  var IfcDistributionFlowElementType = /*#__PURE__*/function (_IfcDistributionEleme) {
    _inherits(IfcDistributionFlowElementType, _IfcDistributionEleme);

    var _super534 = _createSuper(IfcDistributionFlowElementType);

    function IfcDistributionFlowElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this526;

      _classCallCheck2(this, IfcDistributionFlowElementType);

      _this526 = _super534.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this526.GlobalId = GlobalId;
      _this526.OwnerHistory = OwnerHistory;
      _this526.Name = Name;
      _this526.Description = Description;
      _this526.ApplicableOccurrence = ApplicableOccurrence;
      _this526.HasPropertySets = HasPropertySets;
      _this526.RepresentationMaps = RepresentationMaps;
      _this526.Tag = Tag;
      _this526.ElementType = ElementType;
      _this526.type = 3849074793;
      return _this526;
    }

    return IfcDistributionFlowElementType;
  }(IfcDistributionElementType);

  IFC2X32.IfcDistributionFlowElementType = IfcDistributionFlowElementType;

  var IfcElectricalBaseProperties = /*#__PURE__*/function (_IfcEnergyProperties) {
    _inherits(IfcElectricalBaseProperties, _IfcEnergyProperties);

    var _super535 = _createSuper(IfcElectricalBaseProperties);

    function IfcElectricalBaseProperties(expressID, GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence, ElectricCurrentType, InputVoltage, InputFrequency, FullLoadCurrent, MinimumCircuitCurrent, MaximumPowerInput, RatedPowerInput, InputPhase) {
      var _this527;

      _classCallCheck2(this, IfcElectricalBaseProperties);

      _this527 = _super535.call(this, expressID, GlobalId, OwnerHistory, Name, Description, EnergySequence, UserDefinedEnergySequence);
      _this527.GlobalId = GlobalId;
      _this527.OwnerHistory = OwnerHistory;
      _this527.Name = Name;
      _this527.Description = Description;
      _this527.EnergySequence = EnergySequence;
      _this527.UserDefinedEnergySequence = UserDefinedEnergySequence;
      _this527.ElectricCurrentType = ElectricCurrentType;
      _this527.InputVoltage = InputVoltage;
      _this527.InputFrequency = InputFrequency;
      _this527.FullLoadCurrent = FullLoadCurrent;
      _this527.MinimumCircuitCurrent = MinimumCircuitCurrent;
      _this527.MaximumPowerInput = MaximumPowerInput;
      _this527.RatedPowerInput = RatedPowerInput;
      _this527.InputPhase = InputPhase;
      _this527.type = 360485395;
      return _this527;
    }

    return IfcElectricalBaseProperties;
  }(IfcEnergyProperties);

  IFC2X32.IfcElectricalBaseProperties = IfcElectricalBaseProperties;

  var IfcElement = /*#__PURE__*/function (_IfcProduct6) {
    _inherits(IfcElement, _IfcProduct6);

    var _super536 = _createSuper(IfcElement);

    function IfcElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this528;

      _classCallCheck2(this, IfcElement);

      _this528 = _super536.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this528.GlobalId = GlobalId;
      _this528.OwnerHistory = OwnerHistory;
      _this528.Name = Name;
      _this528.Description = Description;
      _this528.ObjectType = ObjectType;
      _this528.ObjectPlacement = ObjectPlacement;
      _this528.Representation = Representation;
      _this528.Tag = Tag;
      _this528.type = 1758889154;
      return _this528;
    }

    return IfcElement;
  }(IfcProduct);

  IFC2X32.IfcElement = IfcElement;

  var IfcElementAssembly = /*#__PURE__*/function (_IfcElement) {
    _inherits(IfcElementAssembly, _IfcElement);

    var _super537 = _createSuper(IfcElementAssembly);

    function IfcElementAssembly(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType) {
      var _this529;

      _classCallCheck2(this, IfcElementAssembly);

      _this529 = _super537.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this529.GlobalId = GlobalId;
      _this529.OwnerHistory = OwnerHistory;
      _this529.Name = Name;
      _this529.Description = Description;
      _this529.ObjectType = ObjectType;
      _this529.ObjectPlacement = ObjectPlacement;
      _this529.Representation = Representation;
      _this529.Tag = Tag;
      _this529.AssemblyPlace = AssemblyPlace;
      _this529.PredefinedType = PredefinedType;
      _this529.type = 4123344466;
      return _this529;
    }

    return IfcElementAssembly;
  }(IfcElement);

  IFC2X32.IfcElementAssembly = IfcElementAssembly;

  var IfcElementComponent = /*#__PURE__*/function (_IfcElement2) {
    _inherits(IfcElementComponent, _IfcElement2);

    var _super538 = _createSuper(IfcElementComponent);

    function IfcElementComponent(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this530;

      _classCallCheck2(this, IfcElementComponent);

      _this530 = _super538.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this530.GlobalId = GlobalId;
      _this530.OwnerHistory = OwnerHistory;
      _this530.Name = Name;
      _this530.Description = Description;
      _this530.ObjectType = ObjectType;
      _this530.ObjectPlacement = ObjectPlacement;
      _this530.Representation = Representation;
      _this530.Tag = Tag;
      _this530.type = 1623761950;
      return _this530;
    }

    return IfcElementComponent;
  }(IfcElement);

  IFC2X32.IfcElementComponent = IfcElementComponent;

  var IfcElementComponentType = /*#__PURE__*/function (_IfcElementType6) {
    _inherits(IfcElementComponentType, _IfcElementType6);

    var _super539 = _createSuper(IfcElementComponentType);

    function IfcElementComponentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this531;

      _classCallCheck2(this, IfcElementComponentType);

      _this531 = _super539.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this531.GlobalId = GlobalId;
      _this531.OwnerHistory = OwnerHistory;
      _this531.Name = Name;
      _this531.Description = Description;
      _this531.ApplicableOccurrence = ApplicableOccurrence;
      _this531.HasPropertySets = HasPropertySets;
      _this531.RepresentationMaps = RepresentationMaps;
      _this531.Tag = Tag;
      _this531.ElementType = ElementType;
      _this531.type = 2590856083;
      return _this531;
    }

    return IfcElementComponentType;
  }(IfcElementType);

  IFC2X32.IfcElementComponentType = IfcElementComponentType;

  var IfcEllipse = /*#__PURE__*/function (_IfcConic) {
    _inherits(IfcEllipse, _IfcConic);

    var _super540 = _createSuper(IfcEllipse);

    function IfcEllipse(expressID, Position, SemiAxis1, SemiAxis2) {
      var _this532;

      _classCallCheck2(this, IfcEllipse);

      _this532 = _super540.call(this, expressID, Position);
      _this532.Position = Position;
      _this532.SemiAxis1 = SemiAxis1;
      _this532.SemiAxis2 = SemiAxis2;
      _this532.type = 1704287377;
      return _this532;
    }

    return IfcEllipse;
  }(IfcConic);

  IFC2X32.IfcEllipse = IfcEllipse;

  var IfcEnergyConversionDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE) {
    _inherits(IfcEnergyConversionDeviceType, _IfcDistributionFlowE);

    var _super541 = _createSuper(IfcEnergyConversionDeviceType);

    function IfcEnergyConversionDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this533;

      _classCallCheck2(this, IfcEnergyConversionDeviceType);

      _this533 = _super541.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this533.GlobalId = GlobalId;
      _this533.OwnerHistory = OwnerHistory;
      _this533.Name = Name;
      _this533.Description = Description;
      _this533.ApplicableOccurrence = ApplicableOccurrence;
      _this533.HasPropertySets = HasPropertySets;
      _this533.RepresentationMaps = RepresentationMaps;
      _this533.Tag = Tag;
      _this533.ElementType = ElementType;
      _this533.type = 2107101300;
      return _this533;
    }

    return IfcEnergyConversionDeviceType;
  }(IfcDistributionFlowElementType);

  IFC2X32.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;

  var IfcEquipmentElement = /*#__PURE__*/function (_IfcElement3) {
    _inherits(IfcEquipmentElement, _IfcElement3);

    var _super542 = _createSuper(IfcEquipmentElement);

    function IfcEquipmentElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this534;

      _classCallCheck2(this, IfcEquipmentElement);

      _this534 = _super542.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this534.GlobalId = GlobalId;
      _this534.OwnerHistory = OwnerHistory;
      _this534.Name = Name;
      _this534.Description = Description;
      _this534.ObjectType = ObjectType;
      _this534.ObjectPlacement = ObjectPlacement;
      _this534.Representation = Representation;
      _this534.Tag = Tag;
      _this534.type = 1962604670;
      return _this534;
    }

    return IfcEquipmentElement;
  }(IfcElement);

  IFC2X32.IfcEquipmentElement = IfcEquipmentElement;

  var IfcEquipmentStandard = /*#__PURE__*/function (_IfcControl3) {
    _inherits(IfcEquipmentStandard, _IfcControl3);

    var _super543 = _createSuper(IfcEquipmentStandard);

    function IfcEquipmentStandard(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this535;

      _classCallCheck2(this, IfcEquipmentStandard);

      _this535 = _super543.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this535.GlobalId = GlobalId;
      _this535.OwnerHistory = OwnerHistory;
      _this535.Name = Name;
      _this535.Description = Description;
      _this535.ObjectType = ObjectType;
      _this535.type = 3272907226;
      return _this535;
    }

    return IfcEquipmentStandard;
  }(IfcControl);

  IFC2X32.IfcEquipmentStandard = IfcEquipmentStandard;

  var IfcEvaporativeCoolerType = /*#__PURE__*/function (_IfcEnergyConversionD) {
    _inherits(IfcEvaporativeCoolerType, _IfcEnergyConversionD);

    var _super544 = _createSuper(IfcEvaporativeCoolerType);

    function IfcEvaporativeCoolerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this536;

      _classCallCheck2(this, IfcEvaporativeCoolerType);

      _this536 = _super544.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this536.GlobalId = GlobalId;
      _this536.OwnerHistory = OwnerHistory;
      _this536.Name = Name;
      _this536.Description = Description;
      _this536.ApplicableOccurrence = ApplicableOccurrence;
      _this536.HasPropertySets = HasPropertySets;
      _this536.RepresentationMaps = RepresentationMaps;
      _this536.Tag = Tag;
      _this536.ElementType = ElementType;
      _this536.PredefinedType = PredefinedType;
      _this536.type = 3174744832;
      return _this536;
    }

    return IfcEvaporativeCoolerType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;

  var IfcEvaporatorType = /*#__PURE__*/function (_IfcEnergyConversionD2) {
    _inherits(IfcEvaporatorType, _IfcEnergyConversionD2);

    var _super545 = _createSuper(IfcEvaporatorType);

    function IfcEvaporatorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this537;

      _classCallCheck2(this, IfcEvaporatorType);

      _this537 = _super545.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this537.GlobalId = GlobalId;
      _this537.OwnerHistory = OwnerHistory;
      _this537.Name = Name;
      _this537.Description = Description;
      _this537.ApplicableOccurrence = ApplicableOccurrence;
      _this537.HasPropertySets = HasPropertySets;
      _this537.RepresentationMaps = RepresentationMaps;
      _this537.Tag = Tag;
      _this537.ElementType = ElementType;
      _this537.PredefinedType = PredefinedType;
      _this537.type = 3390157468;
      return _this537;
    }

    return IfcEvaporatorType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcEvaporatorType = IfcEvaporatorType;

  var IfcFacetedBrep = /*#__PURE__*/function (_IfcManifoldSolidBrep) {
    _inherits(IfcFacetedBrep, _IfcManifoldSolidBrep);

    var _super546 = _createSuper(IfcFacetedBrep);

    function IfcFacetedBrep(expressID, Outer) {
      var _this538;

      _classCallCheck2(this, IfcFacetedBrep);

      _this538 = _super546.call(this, expressID, Outer);
      _this538.Outer = Outer;
      _this538.type = 807026263;
      return _this538;
    }

    return IfcFacetedBrep;
  }(IfcManifoldSolidBrep);

  IFC2X32.IfcFacetedBrep = IfcFacetedBrep;

  var IfcFacetedBrepWithVoids = /*#__PURE__*/function (_IfcManifoldSolidBrep2) {
    _inherits(IfcFacetedBrepWithVoids, _IfcManifoldSolidBrep2);

    var _super547 = _createSuper(IfcFacetedBrepWithVoids);

    function IfcFacetedBrepWithVoids(expressID, Outer, Voids) {
      var _this539;

      _classCallCheck2(this, IfcFacetedBrepWithVoids);

      _this539 = _super547.call(this, expressID, Outer);
      _this539.Outer = Outer;
      _this539.Voids = Voids;
      _this539.type = 3737207727;
      return _this539;
    }

    return IfcFacetedBrepWithVoids;
  }(IfcManifoldSolidBrep);

  IFC2X32.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;

  var IfcFastener = /*#__PURE__*/function (_IfcElementComponent) {
    _inherits(IfcFastener, _IfcElementComponent);

    var _super548 = _createSuper(IfcFastener);

    function IfcFastener(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this540;

      _classCallCheck2(this, IfcFastener);

      _this540 = _super548.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this540.GlobalId = GlobalId;
      _this540.OwnerHistory = OwnerHistory;
      _this540.Name = Name;
      _this540.Description = Description;
      _this540.ObjectType = ObjectType;
      _this540.ObjectPlacement = ObjectPlacement;
      _this540.Representation = Representation;
      _this540.Tag = Tag;
      _this540.type = 647756555;
      return _this540;
    }

    return IfcFastener;
  }(IfcElementComponent);

  IFC2X32.IfcFastener = IfcFastener;

  var IfcFastenerType = /*#__PURE__*/function (_IfcElementComponentT) {
    _inherits(IfcFastenerType, _IfcElementComponentT);

    var _super549 = _createSuper(IfcFastenerType);

    function IfcFastenerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this541;

      _classCallCheck2(this, IfcFastenerType);

      _this541 = _super549.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this541.GlobalId = GlobalId;
      _this541.OwnerHistory = OwnerHistory;
      _this541.Name = Name;
      _this541.Description = Description;
      _this541.ApplicableOccurrence = ApplicableOccurrence;
      _this541.HasPropertySets = HasPropertySets;
      _this541.RepresentationMaps = RepresentationMaps;
      _this541.Tag = Tag;
      _this541.ElementType = ElementType;
      _this541.type = 2489546625;
      return _this541;
    }

    return IfcFastenerType;
  }(IfcElementComponentType);

  IFC2X32.IfcFastenerType = IfcFastenerType;

  var IfcFeatureElement = /*#__PURE__*/function (_IfcElement4) {
    _inherits(IfcFeatureElement, _IfcElement4);

    var _super550 = _createSuper(IfcFeatureElement);

    function IfcFeatureElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this542;

      _classCallCheck2(this, IfcFeatureElement);

      _this542 = _super550.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this542.GlobalId = GlobalId;
      _this542.OwnerHistory = OwnerHistory;
      _this542.Name = Name;
      _this542.Description = Description;
      _this542.ObjectType = ObjectType;
      _this542.ObjectPlacement = ObjectPlacement;
      _this542.Representation = Representation;
      _this542.Tag = Tag;
      _this542.type = 2827207264;
      return _this542;
    }

    return IfcFeatureElement;
  }(IfcElement);

  IFC2X32.IfcFeatureElement = IfcFeatureElement;

  var IfcFeatureElementAddition = /*#__PURE__*/function (_IfcFeatureElement) {
    _inherits(IfcFeatureElementAddition, _IfcFeatureElement);

    var _super551 = _createSuper(IfcFeatureElementAddition);

    function IfcFeatureElementAddition(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this543;

      _classCallCheck2(this, IfcFeatureElementAddition);

      _this543 = _super551.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this543.GlobalId = GlobalId;
      _this543.OwnerHistory = OwnerHistory;
      _this543.Name = Name;
      _this543.Description = Description;
      _this543.ObjectType = ObjectType;
      _this543.ObjectPlacement = ObjectPlacement;
      _this543.Representation = Representation;
      _this543.Tag = Tag;
      _this543.type = 2143335405;
      return _this543;
    }

    return IfcFeatureElementAddition;
  }(IfcFeatureElement);

  IFC2X32.IfcFeatureElementAddition = IfcFeatureElementAddition;

  var IfcFeatureElementSubtraction = /*#__PURE__*/function (_IfcFeatureElement2) {
    _inherits(IfcFeatureElementSubtraction, _IfcFeatureElement2);

    var _super552 = _createSuper(IfcFeatureElementSubtraction);

    function IfcFeatureElementSubtraction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this544;

      _classCallCheck2(this, IfcFeatureElementSubtraction);

      _this544 = _super552.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this544.GlobalId = GlobalId;
      _this544.OwnerHistory = OwnerHistory;
      _this544.Name = Name;
      _this544.Description = Description;
      _this544.ObjectType = ObjectType;
      _this544.ObjectPlacement = ObjectPlacement;
      _this544.Representation = Representation;
      _this544.Tag = Tag;
      _this544.type = 1287392070;
      return _this544;
    }

    return IfcFeatureElementSubtraction;
  }(IfcFeatureElement);

  IFC2X32.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;

  var IfcFlowControllerType = /*#__PURE__*/function (_IfcDistributionFlowE2) {
    _inherits(IfcFlowControllerType, _IfcDistributionFlowE2);

    var _super553 = _createSuper(IfcFlowControllerType);

    function IfcFlowControllerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this545;

      _classCallCheck2(this, IfcFlowControllerType);

      _this545 = _super553.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this545.GlobalId = GlobalId;
      _this545.OwnerHistory = OwnerHistory;
      _this545.Name = Name;
      _this545.Description = Description;
      _this545.ApplicableOccurrence = ApplicableOccurrence;
      _this545.HasPropertySets = HasPropertySets;
      _this545.RepresentationMaps = RepresentationMaps;
      _this545.Tag = Tag;
      _this545.ElementType = ElementType;
      _this545.type = 3907093117;
      return _this545;
    }

    return IfcFlowControllerType;
  }(IfcDistributionFlowElementType);

  IFC2X32.IfcFlowControllerType = IfcFlowControllerType;

  var IfcFlowFittingType = /*#__PURE__*/function (_IfcDistributionFlowE3) {
    _inherits(IfcFlowFittingType, _IfcDistributionFlowE3);

    var _super554 = _createSuper(IfcFlowFittingType);

    function IfcFlowFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this546;

      _classCallCheck2(this, IfcFlowFittingType);

      _this546 = _super554.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this546.GlobalId = GlobalId;
      _this546.OwnerHistory = OwnerHistory;
      _this546.Name = Name;
      _this546.Description = Description;
      _this546.ApplicableOccurrence = ApplicableOccurrence;
      _this546.HasPropertySets = HasPropertySets;
      _this546.RepresentationMaps = RepresentationMaps;
      _this546.Tag = Tag;
      _this546.ElementType = ElementType;
      _this546.type = 3198132628;
      return _this546;
    }

    return IfcFlowFittingType;
  }(IfcDistributionFlowElementType);

  IFC2X32.IfcFlowFittingType = IfcFlowFittingType;

  var IfcFlowMeterType = /*#__PURE__*/function (_IfcFlowControllerTyp) {
    _inherits(IfcFlowMeterType, _IfcFlowControllerTyp);

    var _super555 = _createSuper(IfcFlowMeterType);

    function IfcFlowMeterType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this547;

      _classCallCheck2(this, IfcFlowMeterType);

      _this547 = _super555.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this547.GlobalId = GlobalId;
      _this547.OwnerHistory = OwnerHistory;
      _this547.Name = Name;
      _this547.Description = Description;
      _this547.ApplicableOccurrence = ApplicableOccurrence;
      _this547.HasPropertySets = HasPropertySets;
      _this547.RepresentationMaps = RepresentationMaps;
      _this547.Tag = Tag;
      _this547.ElementType = ElementType;
      _this547.PredefinedType = PredefinedType;
      _this547.type = 3815607619;
      return _this547;
    }

    return IfcFlowMeterType;
  }(IfcFlowControllerType);

  IFC2X32.IfcFlowMeterType = IfcFlowMeterType;

  var IfcFlowMovingDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE4) {
    _inherits(IfcFlowMovingDeviceType, _IfcDistributionFlowE4);

    var _super556 = _createSuper(IfcFlowMovingDeviceType);

    function IfcFlowMovingDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this548;

      _classCallCheck2(this, IfcFlowMovingDeviceType);

      _this548 = _super556.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this548.GlobalId = GlobalId;
      _this548.OwnerHistory = OwnerHistory;
      _this548.Name = Name;
      _this548.Description = Description;
      _this548.ApplicableOccurrence = ApplicableOccurrence;
      _this548.HasPropertySets = HasPropertySets;
      _this548.RepresentationMaps = RepresentationMaps;
      _this548.Tag = Tag;
      _this548.ElementType = ElementType;
      _this548.type = 1482959167;
      return _this548;
    }

    return IfcFlowMovingDeviceType;
  }(IfcDistributionFlowElementType);

  IFC2X32.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;

  var IfcFlowSegmentType = /*#__PURE__*/function (_IfcDistributionFlowE5) {
    _inherits(IfcFlowSegmentType, _IfcDistributionFlowE5);

    var _super557 = _createSuper(IfcFlowSegmentType);

    function IfcFlowSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this549;

      _classCallCheck2(this, IfcFlowSegmentType);

      _this549 = _super557.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this549.GlobalId = GlobalId;
      _this549.OwnerHistory = OwnerHistory;
      _this549.Name = Name;
      _this549.Description = Description;
      _this549.ApplicableOccurrence = ApplicableOccurrence;
      _this549.HasPropertySets = HasPropertySets;
      _this549.RepresentationMaps = RepresentationMaps;
      _this549.Tag = Tag;
      _this549.ElementType = ElementType;
      _this549.type = 1834744321;
      return _this549;
    }

    return IfcFlowSegmentType;
  }(IfcDistributionFlowElementType);

  IFC2X32.IfcFlowSegmentType = IfcFlowSegmentType;

  var IfcFlowStorageDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE6) {
    _inherits(IfcFlowStorageDeviceType, _IfcDistributionFlowE6);

    var _super558 = _createSuper(IfcFlowStorageDeviceType);

    function IfcFlowStorageDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this550;

      _classCallCheck2(this, IfcFlowStorageDeviceType);

      _this550 = _super558.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this550.GlobalId = GlobalId;
      _this550.OwnerHistory = OwnerHistory;
      _this550.Name = Name;
      _this550.Description = Description;
      _this550.ApplicableOccurrence = ApplicableOccurrence;
      _this550.HasPropertySets = HasPropertySets;
      _this550.RepresentationMaps = RepresentationMaps;
      _this550.Tag = Tag;
      _this550.ElementType = ElementType;
      _this550.type = 1339347760;
      return _this550;
    }

    return IfcFlowStorageDeviceType;
  }(IfcDistributionFlowElementType);

  IFC2X32.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;

  var IfcFlowTerminalType = /*#__PURE__*/function (_IfcDistributionFlowE7) {
    _inherits(IfcFlowTerminalType, _IfcDistributionFlowE7);

    var _super559 = _createSuper(IfcFlowTerminalType);

    function IfcFlowTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this551;

      _classCallCheck2(this, IfcFlowTerminalType);

      _this551 = _super559.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this551.GlobalId = GlobalId;
      _this551.OwnerHistory = OwnerHistory;
      _this551.Name = Name;
      _this551.Description = Description;
      _this551.ApplicableOccurrence = ApplicableOccurrence;
      _this551.HasPropertySets = HasPropertySets;
      _this551.RepresentationMaps = RepresentationMaps;
      _this551.Tag = Tag;
      _this551.ElementType = ElementType;
      _this551.type = 2297155007;
      return _this551;
    }

    return IfcFlowTerminalType;
  }(IfcDistributionFlowElementType);

  IFC2X32.IfcFlowTerminalType = IfcFlowTerminalType;

  var IfcFlowTreatmentDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE8) {
    _inherits(IfcFlowTreatmentDeviceType, _IfcDistributionFlowE8);

    var _super560 = _createSuper(IfcFlowTreatmentDeviceType);

    function IfcFlowTreatmentDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this552;

      _classCallCheck2(this, IfcFlowTreatmentDeviceType);

      _this552 = _super560.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this552.GlobalId = GlobalId;
      _this552.OwnerHistory = OwnerHistory;
      _this552.Name = Name;
      _this552.Description = Description;
      _this552.ApplicableOccurrence = ApplicableOccurrence;
      _this552.HasPropertySets = HasPropertySets;
      _this552.RepresentationMaps = RepresentationMaps;
      _this552.Tag = Tag;
      _this552.ElementType = ElementType;
      _this552.type = 3009222698;
      return _this552;
    }

    return IfcFlowTreatmentDeviceType;
  }(IfcDistributionFlowElementType);

  IFC2X32.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;

  var IfcFurnishingElement = /*#__PURE__*/function (_IfcElement5) {
    _inherits(IfcFurnishingElement, _IfcElement5);

    var _super561 = _createSuper(IfcFurnishingElement);

    function IfcFurnishingElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this553;

      _classCallCheck2(this, IfcFurnishingElement);

      _this553 = _super561.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this553.GlobalId = GlobalId;
      _this553.OwnerHistory = OwnerHistory;
      _this553.Name = Name;
      _this553.Description = Description;
      _this553.ObjectType = ObjectType;
      _this553.ObjectPlacement = ObjectPlacement;
      _this553.Representation = Representation;
      _this553.Tag = Tag;
      _this553.type = 263784265;
      return _this553;
    }

    return IfcFurnishingElement;
  }(IfcElement);

  IFC2X32.IfcFurnishingElement = IfcFurnishingElement;

  var IfcFurnitureStandard = /*#__PURE__*/function (_IfcControl4) {
    _inherits(IfcFurnitureStandard, _IfcControl4);

    var _super562 = _createSuper(IfcFurnitureStandard);

    function IfcFurnitureStandard(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this554;

      _classCallCheck2(this, IfcFurnitureStandard);

      _this554 = _super562.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this554.GlobalId = GlobalId;
      _this554.OwnerHistory = OwnerHistory;
      _this554.Name = Name;
      _this554.Description = Description;
      _this554.ObjectType = ObjectType;
      _this554.type = 814719939;
      return _this554;
    }

    return IfcFurnitureStandard;
  }(IfcControl);

  IFC2X32.IfcFurnitureStandard = IfcFurnitureStandard;

  var IfcGasTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType) {
    _inherits(IfcGasTerminalType, _IfcFlowTerminalType);

    var _super563 = _createSuper(IfcGasTerminalType);

    function IfcGasTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this555;

      _classCallCheck2(this, IfcGasTerminalType);

      _this555 = _super563.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this555.GlobalId = GlobalId;
      _this555.OwnerHistory = OwnerHistory;
      _this555.Name = Name;
      _this555.Description = Description;
      _this555.ApplicableOccurrence = ApplicableOccurrence;
      _this555.HasPropertySets = HasPropertySets;
      _this555.RepresentationMaps = RepresentationMaps;
      _this555.Tag = Tag;
      _this555.ElementType = ElementType;
      _this555.PredefinedType = PredefinedType;
      _this555.type = 200128114;
      return _this555;
    }

    return IfcGasTerminalType;
  }(IfcFlowTerminalType);

  IFC2X32.IfcGasTerminalType = IfcGasTerminalType;

  var IfcGrid = /*#__PURE__*/function (_IfcProduct7) {
    _inherits(IfcGrid, _IfcProduct7);

    var _super564 = _createSuper(IfcGrid);

    function IfcGrid(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes) {
      var _this556;

      _classCallCheck2(this, IfcGrid);

      _this556 = _super564.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this556.GlobalId = GlobalId;
      _this556.OwnerHistory = OwnerHistory;
      _this556.Name = Name;
      _this556.Description = Description;
      _this556.ObjectType = ObjectType;
      _this556.ObjectPlacement = ObjectPlacement;
      _this556.Representation = Representation;
      _this556.UAxes = UAxes;
      _this556.VAxes = VAxes;
      _this556.WAxes = WAxes;
      _this556.type = 3009204131;
      return _this556;
    }

    return IfcGrid;
  }(IfcProduct);

  IFC2X32.IfcGrid = IfcGrid;

  var IfcGroup = /*#__PURE__*/function (_IfcObject7) {
    _inherits(IfcGroup, _IfcObject7);

    var _super565 = _createSuper(IfcGroup);

    function IfcGroup(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this557;

      _classCallCheck2(this, IfcGroup);

      _this557 = _super565.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this557.GlobalId = GlobalId;
      _this557.OwnerHistory = OwnerHistory;
      _this557.Name = Name;
      _this557.Description = Description;
      _this557.ObjectType = ObjectType;
      _this557.type = 2706460486;
      return _this557;
    }

    return IfcGroup;
  }(IfcObject);

  IFC2X32.IfcGroup = IfcGroup;

  var IfcHeatExchangerType = /*#__PURE__*/function (_IfcEnergyConversionD3) {
    _inherits(IfcHeatExchangerType, _IfcEnergyConversionD3);

    var _super566 = _createSuper(IfcHeatExchangerType);

    function IfcHeatExchangerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this558;

      _classCallCheck2(this, IfcHeatExchangerType);

      _this558 = _super566.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this558.GlobalId = GlobalId;
      _this558.OwnerHistory = OwnerHistory;
      _this558.Name = Name;
      _this558.Description = Description;
      _this558.ApplicableOccurrence = ApplicableOccurrence;
      _this558.HasPropertySets = HasPropertySets;
      _this558.RepresentationMaps = RepresentationMaps;
      _this558.Tag = Tag;
      _this558.ElementType = ElementType;
      _this558.PredefinedType = PredefinedType;
      _this558.type = 1251058090;
      return _this558;
    }

    return IfcHeatExchangerType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcHeatExchangerType = IfcHeatExchangerType;

  var IfcHumidifierType = /*#__PURE__*/function (_IfcEnergyConversionD4) {
    _inherits(IfcHumidifierType, _IfcEnergyConversionD4);

    var _super567 = _createSuper(IfcHumidifierType);

    function IfcHumidifierType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this559;

      _classCallCheck2(this, IfcHumidifierType);

      _this559 = _super567.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this559.GlobalId = GlobalId;
      _this559.OwnerHistory = OwnerHistory;
      _this559.Name = Name;
      _this559.Description = Description;
      _this559.ApplicableOccurrence = ApplicableOccurrence;
      _this559.HasPropertySets = HasPropertySets;
      _this559.RepresentationMaps = RepresentationMaps;
      _this559.Tag = Tag;
      _this559.ElementType = ElementType;
      _this559.PredefinedType = PredefinedType;
      _this559.type = 1806887404;
      return _this559;
    }

    return IfcHumidifierType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcHumidifierType = IfcHumidifierType;

  var IfcInventory = /*#__PURE__*/function (_IfcGroup) {
    _inherits(IfcInventory, _IfcGroup);

    var _super568 = _createSuper(IfcInventory);

    function IfcInventory(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, InventoryType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue) {
      var _this560;

      _classCallCheck2(this, IfcInventory);

      _this560 = _super568.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this560.GlobalId = GlobalId;
      _this560.OwnerHistory = OwnerHistory;
      _this560.Name = Name;
      _this560.Description = Description;
      _this560.ObjectType = ObjectType;
      _this560.InventoryType = InventoryType;
      _this560.Jurisdiction = Jurisdiction;
      _this560.ResponsiblePersons = ResponsiblePersons;
      _this560.LastUpdateDate = LastUpdateDate;
      _this560.CurrentValue = CurrentValue;
      _this560.OriginalValue = OriginalValue;
      _this560.type = 2391368822;
      return _this560;
    }

    return IfcInventory;
  }(IfcGroup);

  IFC2X32.IfcInventory = IfcInventory;

  var IfcJunctionBoxType = /*#__PURE__*/function (_IfcFlowFittingType) {
    _inherits(IfcJunctionBoxType, _IfcFlowFittingType);

    var _super569 = _createSuper(IfcJunctionBoxType);

    function IfcJunctionBoxType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this561;

      _classCallCheck2(this, IfcJunctionBoxType);

      _this561 = _super569.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this561.GlobalId = GlobalId;
      _this561.OwnerHistory = OwnerHistory;
      _this561.Name = Name;
      _this561.Description = Description;
      _this561.ApplicableOccurrence = ApplicableOccurrence;
      _this561.HasPropertySets = HasPropertySets;
      _this561.RepresentationMaps = RepresentationMaps;
      _this561.Tag = Tag;
      _this561.ElementType = ElementType;
      _this561.PredefinedType = PredefinedType;
      _this561.type = 4288270099;
      return _this561;
    }

    return IfcJunctionBoxType;
  }(IfcFlowFittingType);

  IFC2X32.IfcJunctionBoxType = IfcJunctionBoxType;

  var IfcLaborResource = /*#__PURE__*/function (_IfcConstructionResou2) {
    _inherits(IfcLaborResource, _IfcConstructionResou2);

    var _super570 = _createSuper(IfcLaborResource);

    function IfcLaborResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, SkillSet) {
      var _this562;

      _classCallCheck2(this, IfcLaborResource);

      _this562 = _super570.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      _this562.GlobalId = GlobalId;
      _this562.OwnerHistory = OwnerHistory;
      _this562.Name = Name;
      _this562.Description = Description;
      _this562.ObjectType = ObjectType;
      _this562.ResourceIdentifier = ResourceIdentifier;
      _this562.ResourceGroup = ResourceGroup;
      _this562.ResourceConsumption = ResourceConsumption;
      _this562.BaseQuantity = BaseQuantity;
      _this562.SkillSet = SkillSet;
      _this562.type = 3827777499;
      return _this562;
    }

    return IfcLaborResource;
  }(IfcConstructionResource);

  IFC2X32.IfcLaborResource = IfcLaborResource;

  var IfcLampType = /*#__PURE__*/function (_IfcFlowTerminalType2) {
    _inherits(IfcLampType, _IfcFlowTerminalType2);

    var _super571 = _createSuper(IfcLampType);

    function IfcLampType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this563;

      _classCallCheck2(this, IfcLampType);

      _this563 = _super571.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this563.GlobalId = GlobalId;
      _this563.OwnerHistory = OwnerHistory;
      _this563.Name = Name;
      _this563.Description = Description;
      _this563.ApplicableOccurrence = ApplicableOccurrence;
      _this563.HasPropertySets = HasPropertySets;
      _this563.RepresentationMaps = RepresentationMaps;
      _this563.Tag = Tag;
      _this563.ElementType = ElementType;
      _this563.PredefinedType = PredefinedType;
      _this563.type = 1051575348;
      return _this563;
    }

    return IfcLampType;
  }(IfcFlowTerminalType);

  IFC2X32.IfcLampType = IfcLampType;

  var IfcLightFixtureType = /*#__PURE__*/function (_IfcFlowTerminalType3) {
    _inherits(IfcLightFixtureType, _IfcFlowTerminalType3);

    var _super572 = _createSuper(IfcLightFixtureType);

    function IfcLightFixtureType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this564;

      _classCallCheck2(this, IfcLightFixtureType);

      _this564 = _super572.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this564.GlobalId = GlobalId;
      _this564.OwnerHistory = OwnerHistory;
      _this564.Name = Name;
      _this564.Description = Description;
      _this564.ApplicableOccurrence = ApplicableOccurrence;
      _this564.HasPropertySets = HasPropertySets;
      _this564.RepresentationMaps = RepresentationMaps;
      _this564.Tag = Tag;
      _this564.ElementType = ElementType;
      _this564.PredefinedType = PredefinedType;
      _this564.type = 1161773419;
      return _this564;
    }

    return IfcLightFixtureType;
  }(IfcFlowTerminalType);

  IFC2X32.IfcLightFixtureType = IfcLightFixtureType;

  var IfcLinearDimension = /*#__PURE__*/function (_IfcDimensionCurveDir) {
    _inherits(IfcLinearDimension, _IfcDimensionCurveDir);

    var _super573 = _createSuper(IfcLinearDimension);

    function IfcLinearDimension(expressID, Contents) {
      var _this565;

      _classCallCheck2(this, IfcLinearDimension);

      _this565 = _super573.call(this, expressID, Contents);
      _this565.Contents = Contents;
      _this565.type = 2506943328;
      return _this565;
    }

    return IfcLinearDimension;
  }(IfcDimensionCurveDirectedCallout);

  IFC2X32.IfcLinearDimension = IfcLinearDimension;

  var IfcMechanicalFastener = /*#__PURE__*/function (_IfcFastener) {
    _inherits(IfcMechanicalFastener, _IfcFastener);

    var _super574 = _createSuper(IfcMechanicalFastener);

    function IfcMechanicalFastener(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength) {
      var _this566;

      _classCallCheck2(this, IfcMechanicalFastener);

      _this566 = _super574.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this566.GlobalId = GlobalId;
      _this566.OwnerHistory = OwnerHistory;
      _this566.Name = Name;
      _this566.Description = Description;
      _this566.ObjectType = ObjectType;
      _this566.ObjectPlacement = ObjectPlacement;
      _this566.Representation = Representation;
      _this566.Tag = Tag;
      _this566.NominalDiameter = NominalDiameter;
      _this566.NominalLength = NominalLength;
      _this566.type = 377706215;
      return _this566;
    }

    return IfcMechanicalFastener;
  }(IfcFastener);

  IFC2X32.IfcMechanicalFastener = IfcMechanicalFastener;

  var IfcMechanicalFastenerType = /*#__PURE__*/function (_IfcFastenerType) {
    _inherits(IfcMechanicalFastenerType, _IfcFastenerType);

    var _super575 = _createSuper(IfcMechanicalFastenerType);

    function IfcMechanicalFastenerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this567;

      _classCallCheck2(this, IfcMechanicalFastenerType);

      _this567 = _super575.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this567.GlobalId = GlobalId;
      _this567.OwnerHistory = OwnerHistory;
      _this567.Name = Name;
      _this567.Description = Description;
      _this567.ApplicableOccurrence = ApplicableOccurrence;
      _this567.HasPropertySets = HasPropertySets;
      _this567.RepresentationMaps = RepresentationMaps;
      _this567.Tag = Tag;
      _this567.ElementType = ElementType;
      _this567.type = 2108223431;
      return _this567;
    }

    return IfcMechanicalFastenerType;
  }(IfcFastenerType);

  IFC2X32.IfcMechanicalFastenerType = IfcMechanicalFastenerType;

  var IfcMemberType = /*#__PURE__*/function (_IfcBuildingElementTy4) {
    _inherits(IfcMemberType, _IfcBuildingElementTy4);

    var _super576 = _createSuper(IfcMemberType);

    function IfcMemberType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this568;

      _classCallCheck2(this, IfcMemberType);

      _this568 = _super576.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this568.GlobalId = GlobalId;
      _this568.OwnerHistory = OwnerHistory;
      _this568.Name = Name;
      _this568.Description = Description;
      _this568.ApplicableOccurrence = ApplicableOccurrence;
      _this568.HasPropertySets = HasPropertySets;
      _this568.RepresentationMaps = RepresentationMaps;
      _this568.Tag = Tag;
      _this568.ElementType = ElementType;
      _this568.PredefinedType = PredefinedType;
      _this568.type = 3181161470;
      return _this568;
    }

    return IfcMemberType;
  }(IfcBuildingElementType);

  IFC2X32.IfcMemberType = IfcMemberType;

  var IfcMotorConnectionType = /*#__PURE__*/function (_IfcEnergyConversionD5) {
    _inherits(IfcMotorConnectionType, _IfcEnergyConversionD5);

    var _super577 = _createSuper(IfcMotorConnectionType);

    function IfcMotorConnectionType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this569;

      _classCallCheck2(this, IfcMotorConnectionType);

      _this569 = _super577.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this569.GlobalId = GlobalId;
      _this569.OwnerHistory = OwnerHistory;
      _this569.Name = Name;
      _this569.Description = Description;
      _this569.ApplicableOccurrence = ApplicableOccurrence;
      _this569.HasPropertySets = HasPropertySets;
      _this569.RepresentationMaps = RepresentationMaps;
      _this569.Tag = Tag;
      _this569.ElementType = ElementType;
      _this569.PredefinedType = PredefinedType;
      _this569.type = 977012517;
      return _this569;
    }

    return IfcMotorConnectionType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcMotorConnectionType = IfcMotorConnectionType;

  var IfcMove = /*#__PURE__*/function (_IfcTask) {
    _inherits(IfcMove, _IfcTask);

    var _super578 = _createSuper(IfcMove);

    function IfcMove(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority, MoveFrom, MoveTo, PunchList) {
      var _this570;

      _classCallCheck2(this, IfcMove);

      _this570 = _super578.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority);
      _this570.GlobalId = GlobalId;
      _this570.OwnerHistory = OwnerHistory;
      _this570.Name = Name;
      _this570.Description = Description;
      _this570.ObjectType = ObjectType;
      _this570.TaskId = TaskId;
      _this570.Status = Status;
      _this570.WorkMethod = WorkMethod;
      _this570.IsMilestone = IsMilestone;
      _this570.Priority = Priority;
      _this570.MoveFrom = MoveFrom;
      _this570.MoveTo = MoveTo;
      _this570.PunchList = PunchList;
      _this570.type = 1916936684;
      return _this570;
    }

    return IfcMove;
  }(IfcTask);

  IFC2X32.IfcMove = IfcMove;

  var IfcOccupant = /*#__PURE__*/function (_IfcActor) {
    _inherits(IfcOccupant, _IfcActor);

    var _super579 = _createSuper(IfcOccupant);

    function IfcOccupant(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType) {
      var _this571;

      _classCallCheck2(this, IfcOccupant);

      _this571 = _super579.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
      _this571.GlobalId = GlobalId;
      _this571.OwnerHistory = OwnerHistory;
      _this571.Name = Name;
      _this571.Description = Description;
      _this571.ObjectType = ObjectType;
      _this571.TheActor = TheActor;
      _this571.PredefinedType = PredefinedType;
      _this571.type = 4143007308;
      return _this571;
    }

    return IfcOccupant;
  }(IfcActor);

  IFC2X32.IfcOccupant = IfcOccupant;

  var IfcOpeningElement = /*#__PURE__*/function (_IfcFeatureElementSub) {
    _inherits(IfcOpeningElement, _IfcFeatureElementSub);

    var _super580 = _createSuper(IfcOpeningElement);

    function IfcOpeningElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this572;

      _classCallCheck2(this, IfcOpeningElement);

      _this572 = _super580.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this572.GlobalId = GlobalId;
      _this572.OwnerHistory = OwnerHistory;
      _this572.Name = Name;
      _this572.Description = Description;
      _this572.ObjectType = ObjectType;
      _this572.ObjectPlacement = ObjectPlacement;
      _this572.Representation = Representation;
      _this572.Tag = Tag;
      _this572.type = 3588315303;
      return _this572;
    }

    return IfcOpeningElement;
  }(IfcFeatureElementSubtraction);

  IFC2X32.IfcOpeningElement = IfcOpeningElement;

  var IfcOrderAction = /*#__PURE__*/function (_IfcTask2) {
    _inherits(IfcOrderAction, _IfcTask2);

    var _super581 = _createSuper(IfcOrderAction);

    function IfcOrderAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority, ActionID) {
      var _this573;

      _classCallCheck2(this, IfcOrderAction);

      _this573 = _super581.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TaskId, Status, WorkMethod, IsMilestone, Priority);
      _this573.GlobalId = GlobalId;
      _this573.OwnerHistory = OwnerHistory;
      _this573.Name = Name;
      _this573.Description = Description;
      _this573.ObjectType = ObjectType;
      _this573.TaskId = TaskId;
      _this573.Status = Status;
      _this573.WorkMethod = WorkMethod;
      _this573.IsMilestone = IsMilestone;
      _this573.Priority = Priority;
      _this573.ActionID = ActionID;
      _this573.type = 3425660407;
      return _this573;
    }

    return IfcOrderAction;
  }(IfcTask);

  IFC2X32.IfcOrderAction = IfcOrderAction;

  var IfcOutletType = /*#__PURE__*/function (_IfcFlowTerminalType4) {
    _inherits(IfcOutletType, _IfcFlowTerminalType4);

    var _super582 = _createSuper(IfcOutletType);

    function IfcOutletType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this574;

      _classCallCheck2(this, IfcOutletType);

      _this574 = _super582.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this574.GlobalId = GlobalId;
      _this574.OwnerHistory = OwnerHistory;
      _this574.Name = Name;
      _this574.Description = Description;
      _this574.ApplicableOccurrence = ApplicableOccurrence;
      _this574.HasPropertySets = HasPropertySets;
      _this574.RepresentationMaps = RepresentationMaps;
      _this574.Tag = Tag;
      _this574.ElementType = ElementType;
      _this574.PredefinedType = PredefinedType;
      _this574.type = 2837617999;
      return _this574;
    }

    return IfcOutletType;
  }(IfcFlowTerminalType);

  IFC2X32.IfcOutletType = IfcOutletType;

  var IfcPerformanceHistory = /*#__PURE__*/function (_IfcControl5) {
    _inherits(IfcPerformanceHistory, _IfcControl5);

    var _super583 = _createSuper(IfcPerformanceHistory);

    function IfcPerformanceHistory(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LifeCyclePhase) {
      var _this575;

      _classCallCheck2(this, IfcPerformanceHistory);

      _this575 = _super583.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this575.GlobalId = GlobalId;
      _this575.OwnerHistory = OwnerHistory;
      _this575.Name = Name;
      _this575.Description = Description;
      _this575.ObjectType = ObjectType;
      _this575.LifeCyclePhase = LifeCyclePhase;
      _this575.type = 2382730787;
      return _this575;
    }

    return IfcPerformanceHistory;
  }(IfcControl);

  IFC2X32.IfcPerformanceHistory = IfcPerformanceHistory;

  var IfcPermit = /*#__PURE__*/function (_IfcControl6) {
    _inherits(IfcPermit, _IfcControl6);

    var _super584 = _createSuper(IfcPermit);

    function IfcPermit(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PermitID) {
      var _this576;

      _classCallCheck2(this, IfcPermit);

      _this576 = _super584.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this576.GlobalId = GlobalId;
      _this576.OwnerHistory = OwnerHistory;
      _this576.Name = Name;
      _this576.Description = Description;
      _this576.ObjectType = ObjectType;
      _this576.PermitID = PermitID;
      _this576.type = 3327091369;
      return _this576;
    }

    return IfcPermit;
  }(IfcControl);

  IFC2X32.IfcPermit = IfcPermit;

  var IfcPipeFittingType = /*#__PURE__*/function (_IfcFlowFittingType2) {
    _inherits(IfcPipeFittingType, _IfcFlowFittingType2);

    var _super585 = _createSuper(IfcPipeFittingType);

    function IfcPipeFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this577;

      _classCallCheck2(this, IfcPipeFittingType);

      _this577 = _super585.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this577.GlobalId = GlobalId;
      _this577.OwnerHistory = OwnerHistory;
      _this577.Name = Name;
      _this577.Description = Description;
      _this577.ApplicableOccurrence = ApplicableOccurrence;
      _this577.HasPropertySets = HasPropertySets;
      _this577.RepresentationMaps = RepresentationMaps;
      _this577.Tag = Tag;
      _this577.ElementType = ElementType;
      _this577.PredefinedType = PredefinedType;
      _this577.type = 804291784;
      return _this577;
    }

    return IfcPipeFittingType;
  }(IfcFlowFittingType);

  IFC2X32.IfcPipeFittingType = IfcPipeFittingType;

  var IfcPipeSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType) {
    _inherits(IfcPipeSegmentType, _IfcFlowSegmentType);

    var _super586 = _createSuper(IfcPipeSegmentType);

    function IfcPipeSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this578;

      _classCallCheck2(this, IfcPipeSegmentType);

      _this578 = _super586.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this578.GlobalId = GlobalId;
      _this578.OwnerHistory = OwnerHistory;
      _this578.Name = Name;
      _this578.Description = Description;
      _this578.ApplicableOccurrence = ApplicableOccurrence;
      _this578.HasPropertySets = HasPropertySets;
      _this578.RepresentationMaps = RepresentationMaps;
      _this578.Tag = Tag;
      _this578.ElementType = ElementType;
      _this578.PredefinedType = PredefinedType;
      _this578.type = 4231323485;
      return _this578;
    }

    return IfcPipeSegmentType;
  }(IfcFlowSegmentType);

  IFC2X32.IfcPipeSegmentType = IfcPipeSegmentType;

  var IfcPlateType = /*#__PURE__*/function (_IfcBuildingElementTy5) {
    _inherits(IfcPlateType, _IfcBuildingElementTy5);

    var _super587 = _createSuper(IfcPlateType);

    function IfcPlateType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this579;

      _classCallCheck2(this, IfcPlateType);

      _this579 = _super587.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this579.GlobalId = GlobalId;
      _this579.OwnerHistory = OwnerHistory;
      _this579.Name = Name;
      _this579.Description = Description;
      _this579.ApplicableOccurrence = ApplicableOccurrence;
      _this579.HasPropertySets = HasPropertySets;
      _this579.RepresentationMaps = RepresentationMaps;
      _this579.Tag = Tag;
      _this579.ElementType = ElementType;
      _this579.PredefinedType = PredefinedType;
      _this579.type = 4017108033;
      return _this579;
    }

    return IfcPlateType;
  }(IfcBuildingElementType);

  IFC2X32.IfcPlateType = IfcPlateType;

  var IfcPolyline = /*#__PURE__*/function (_IfcBoundedCurve2) {
    _inherits(IfcPolyline, _IfcBoundedCurve2);

    var _super588 = _createSuper(IfcPolyline);

    function IfcPolyline(expressID, Points) {
      var _this580;

      _classCallCheck2(this, IfcPolyline);

      _this580 = _super588.call(this, expressID);
      _this580.Points = Points;
      _this580.type = 3724593414;
      return _this580;
    }

    return IfcPolyline;
  }(IfcBoundedCurve);

  IFC2X32.IfcPolyline = IfcPolyline;

  var IfcPort = /*#__PURE__*/function (_IfcProduct8) {
    _inherits(IfcPort, _IfcProduct8);

    var _super589 = _createSuper(IfcPort);

    function IfcPort(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this581;

      _classCallCheck2(this, IfcPort);

      _this581 = _super589.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this581.GlobalId = GlobalId;
      _this581.OwnerHistory = OwnerHistory;
      _this581.Name = Name;
      _this581.Description = Description;
      _this581.ObjectType = ObjectType;
      _this581.ObjectPlacement = ObjectPlacement;
      _this581.Representation = Representation;
      _this581.type = 3740093272;
      return _this581;
    }

    return IfcPort;
  }(IfcProduct);

  IFC2X32.IfcPort = IfcPort;

  var IfcProcedure = /*#__PURE__*/function (_IfcProcess2) {
    _inherits(IfcProcedure, _IfcProcess2);

    var _super590 = _createSuper(IfcProcedure);

    function IfcProcedure(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ProcedureID, ProcedureType, UserDefinedProcedureType) {
      var _this582;

      _classCallCheck2(this, IfcProcedure);

      _this582 = _super590.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this582.GlobalId = GlobalId;
      _this582.OwnerHistory = OwnerHistory;
      _this582.Name = Name;
      _this582.Description = Description;
      _this582.ObjectType = ObjectType;
      _this582.ProcedureID = ProcedureID;
      _this582.ProcedureType = ProcedureType;
      _this582.UserDefinedProcedureType = UserDefinedProcedureType;
      _this582.type = 2744685151;
      return _this582;
    }

    return IfcProcedure;
  }(IfcProcess);

  IFC2X32.IfcProcedure = IfcProcedure;

  var IfcProjectOrder = /*#__PURE__*/function (_IfcControl7) {
    _inherits(IfcProjectOrder, _IfcControl7);

    var _super591 = _createSuper(IfcProjectOrder);

    function IfcProjectOrder(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ID, PredefinedType, Status) {
      var _this583;

      _classCallCheck2(this, IfcProjectOrder);

      _this583 = _super591.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this583.GlobalId = GlobalId;
      _this583.OwnerHistory = OwnerHistory;
      _this583.Name = Name;
      _this583.Description = Description;
      _this583.ObjectType = ObjectType;
      _this583.ID = ID;
      _this583.PredefinedType = PredefinedType;
      _this583.Status = Status;
      _this583.type = 2904328755;
      return _this583;
    }

    return IfcProjectOrder;
  }(IfcControl);

  IFC2X32.IfcProjectOrder = IfcProjectOrder;

  var IfcProjectOrderRecord = /*#__PURE__*/function (_IfcControl8) {
    _inherits(IfcProjectOrderRecord, _IfcControl8);

    var _super592 = _createSuper(IfcProjectOrderRecord);

    function IfcProjectOrderRecord(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Records, PredefinedType) {
      var _this584;

      _classCallCheck2(this, IfcProjectOrderRecord);

      _this584 = _super592.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this584.GlobalId = GlobalId;
      _this584.OwnerHistory = OwnerHistory;
      _this584.Name = Name;
      _this584.Description = Description;
      _this584.ObjectType = ObjectType;
      _this584.Records = Records;
      _this584.PredefinedType = PredefinedType;
      _this584.type = 3642467123;
      return _this584;
    }

    return IfcProjectOrderRecord;
  }(IfcControl);

  IFC2X32.IfcProjectOrderRecord = IfcProjectOrderRecord;

  var IfcProjectionElement = /*#__PURE__*/function (_IfcFeatureElementAdd) {
    _inherits(IfcProjectionElement, _IfcFeatureElementAdd);

    var _super593 = _createSuper(IfcProjectionElement);

    function IfcProjectionElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this585;

      _classCallCheck2(this, IfcProjectionElement);

      _this585 = _super593.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this585.GlobalId = GlobalId;
      _this585.OwnerHistory = OwnerHistory;
      _this585.Name = Name;
      _this585.Description = Description;
      _this585.ObjectType = ObjectType;
      _this585.ObjectPlacement = ObjectPlacement;
      _this585.Representation = Representation;
      _this585.Tag = Tag;
      _this585.type = 3651124850;
      return _this585;
    }

    return IfcProjectionElement;
  }(IfcFeatureElementAddition);

  IFC2X32.IfcProjectionElement = IfcProjectionElement;

  var IfcProtectiveDeviceType = /*#__PURE__*/function (_IfcFlowControllerTyp2) {
    _inherits(IfcProtectiveDeviceType, _IfcFlowControllerTyp2);

    var _super594 = _createSuper(IfcProtectiveDeviceType);

    function IfcProtectiveDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this586;

      _classCallCheck2(this, IfcProtectiveDeviceType);

      _this586 = _super594.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this586.GlobalId = GlobalId;
      _this586.OwnerHistory = OwnerHistory;
      _this586.Name = Name;
      _this586.Description = Description;
      _this586.ApplicableOccurrence = ApplicableOccurrence;
      _this586.HasPropertySets = HasPropertySets;
      _this586.RepresentationMaps = RepresentationMaps;
      _this586.Tag = Tag;
      _this586.ElementType = ElementType;
      _this586.PredefinedType = PredefinedType;
      _this586.type = 1842657554;
      return _this586;
    }

    return IfcProtectiveDeviceType;
  }(IfcFlowControllerType);

  IFC2X32.IfcProtectiveDeviceType = IfcProtectiveDeviceType;

  var IfcPumpType = /*#__PURE__*/function (_IfcFlowMovingDeviceT) {
    _inherits(IfcPumpType, _IfcFlowMovingDeviceT);

    var _super595 = _createSuper(IfcPumpType);

    function IfcPumpType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this587;

      _classCallCheck2(this, IfcPumpType);

      _this587 = _super595.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this587.GlobalId = GlobalId;
      _this587.OwnerHistory = OwnerHistory;
      _this587.Name = Name;
      _this587.Description = Description;
      _this587.ApplicableOccurrence = ApplicableOccurrence;
      _this587.HasPropertySets = HasPropertySets;
      _this587.RepresentationMaps = RepresentationMaps;
      _this587.Tag = Tag;
      _this587.ElementType = ElementType;
      _this587.PredefinedType = PredefinedType;
      _this587.type = 2250791053;
      return _this587;
    }

    return IfcPumpType;
  }(IfcFlowMovingDeviceType);

  IFC2X32.IfcPumpType = IfcPumpType;

  var IfcRadiusDimension = /*#__PURE__*/function (_IfcDimensionCurveDir2) {
    _inherits(IfcRadiusDimension, _IfcDimensionCurveDir2);

    var _super596 = _createSuper(IfcRadiusDimension);

    function IfcRadiusDimension(expressID, Contents) {
      var _this588;

      _classCallCheck2(this, IfcRadiusDimension);

      _this588 = _super596.call(this, expressID, Contents);
      _this588.Contents = Contents;
      _this588.type = 3248260540;
      return _this588;
    }

    return IfcRadiusDimension;
  }(IfcDimensionCurveDirectedCallout);

  IFC2X32.IfcRadiusDimension = IfcRadiusDimension;

  var IfcRailingType = /*#__PURE__*/function (_IfcBuildingElementTy6) {
    _inherits(IfcRailingType, _IfcBuildingElementTy6);

    var _super597 = _createSuper(IfcRailingType);

    function IfcRailingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this589;

      _classCallCheck2(this, IfcRailingType);

      _this589 = _super597.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this589.GlobalId = GlobalId;
      _this589.OwnerHistory = OwnerHistory;
      _this589.Name = Name;
      _this589.Description = Description;
      _this589.ApplicableOccurrence = ApplicableOccurrence;
      _this589.HasPropertySets = HasPropertySets;
      _this589.RepresentationMaps = RepresentationMaps;
      _this589.Tag = Tag;
      _this589.ElementType = ElementType;
      _this589.PredefinedType = PredefinedType;
      _this589.type = 2893384427;
      return _this589;
    }

    return IfcRailingType;
  }(IfcBuildingElementType);

  IFC2X32.IfcRailingType = IfcRailingType;

  var IfcRampFlightType = /*#__PURE__*/function (_IfcBuildingElementTy7) {
    _inherits(IfcRampFlightType, _IfcBuildingElementTy7);

    var _super598 = _createSuper(IfcRampFlightType);

    function IfcRampFlightType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this590;

      _classCallCheck2(this, IfcRampFlightType);

      _this590 = _super598.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this590.GlobalId = GlobalId;
      _this590.OwnerHistory = OwnerHistory;
      _this590.Name = Name;
      _this590.Description = Description;
      _this590.ApplicableOccurrence = ApplicableOccurrence;
      _this590.HasPropertySets = HasPropertySets;
      _this590.RepresentationMaps = RepresentationMaps;
      _this590.Tag = Tag;
      _this590.ElementType = ElementType;
      _this590.PredefinedType = PredefinedType;
      _this590.type = 2324767716;
      return _this590;
    }

    return IfcRampFlightType;
  }(IfcBuildingElementType);

  IFC2X32.IfcRampFlightType = IfcRampFlightType;

  var IfcRelAggregates = /*#__PURE__*/function (_IfcRelDecomposes2) {
    _inherits(IfcRelAggregates, _IfcRelDecomposes2);

    var _super599 = _createSuper(IfcRelAggregates);

    function IfcRelAggregates(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      var _this591;

      _classCallCheck2(this, IfcRelAggregates);

      _this591 = _super599.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects);
      _this591.GlobalId = GlobalId;
      _this591.OwnerHistory = OwnerHistory;
      _this591.Name = Name;
      _this591.Description = Description;
      _this591.RelatingObject = RelatingObject;
      _this591.RelatedObjects = RelatedObjects;
      _this591.type = 160246688;
      return _this591;
    }

    return IfcRelAggregates;
  }(IfcRelDecomposes);

  IFC2X32.IfcRelAggregates = IfcRelAggregates;

  var IfcRelAssignsTasks = /*#__PURE__*/function (_IfcRelAssignsToContr3) {
    _inherits(IfcRelAssignsTasks, _IfcRelAssignsToContr3);

    var _super600 = _createSuper(IfcRelAssignsTasks);

    function IfcRelAssignsTasks(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl, TimeForTask) {
      var _this592;

      _classCallCheck2(this, IfcRelAssignsTasks);

      _this592 = _super600.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl);
      _this592.GlobalId = GlobalId;
      _this592.OwnerHistory = OwnerHistory;
      _this592.Name = Name;
      _this592.Description = Description;
      _this592.RelatedObjects = RelatedObjects;
      _this592.RelatedObjectsType = RelatedObjectsType;
      _this592.RelatingControl = RelatingControl;
      _this592.TimeForTask = TimeForTask;
      _this592.type = 2863920197;
      return _this592;
    }

    return IfcRelAssignsTasks;
  }(IfcRelAssignsToControl);

  IFC2X32.IfcRelAssignsTasks = IfcRelAssignsTasks;

  var IfcSanitaryTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType5) {
    _inherits(IfcSanitaryTerminalType, _IfcFlowTerminalType5);

    var _super601 = _createSuper(IfcSanitaryTerminalType);

    function IfcSanitaryTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this593;

      _classCallCheck2(this, IfcSanitaryTerminalType);

      _this593 = _super601.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this593.GlobalId = GlobalId;
      _this593.OwnerHistory = OwnerHistory;
      _this593.Name = Name;
      _this593.Description = Description;
      _this593.ApplicableOccurrence = ApplicableOccurrence;
      _this593.HasPropertySets = HasPropertySets;
      _this593.RepresentationMaps = RepresentationMaps;
      _this593.Tag = Tag;
      _this593.ElementType = ElementType;
      _this593.PredefinedType = PredefinedType;
      _this593.type = 1768891740;
      return _this593;
    }

    return IfcSanitaryTerminalType;
  }(IfcFlowTerminalType);

  IFC2X32.IfcSanitaryTerminalType = IfcSanitaryTerminalType;

  var IfcScheduleTimeControl = /*#__PURE__*/function (_IfcControl9) {
    _inherits(IfcScheduleTimeControl, _IfcControl9);

    var _super602 = _createSuper(IfcScheduleTimeControl);

    function IfcScheduleTimeControl(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ActualStart, EarlyStart, LateStart, ScheduleStart, ActualFinish, EarlyFinish, LateFinish, ScheduleFinish, ScheduleDuration, ActualDuration, RemainingTime, FreeFloat, TotalFloat, IsCritical, StatusTime, StartFloat, FinishFloat, Completion) {
      var _this594;

      _classCallCheck2(this, IfcScheduleTimeControl);

      _this594 = _super602.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this594.GlobalId = GlobalId;
      _this594.OwnerHistory = OwnerHistory;
      _this594.Name = Name;
      _this594.Description = Description;
      _this594.ObjectType = ObjectType;
      _this594.ActualStart = ActualStart;
      _this594.EarlyStart = EarlyStart;
      _this594.LateStart = LateStart;
      _this594.ScheduleStart = ScheduleStart;
      _this594.ActualFinish = ActualFinish;
      _this594.EarlyFinish = EarlyFinish;
      _this594.LateFinish = LateFinish;
      _this594.ScheduleFinish = ScheduleFinish;
      _this594.ScheduleDuration = ScheduleDuration;
      _this594.ActualDuration = ActualDuration;
      _this594.RemainingTime = RemainingTime;
      _this594.FreeFloat = FreeFloat;
      _this594.TotalFloat = TotalFloat;
      _this594.IsCritical = IsCritical;
      _this594.StatusTime = StatusTime;
      _this594.StartFloat = StartFloat;
      _this594.FinishFloat = FinishFloat;
      _this594.Completion = Completion;
      _this594.type = 3517283431;
      return _this594;
    }

    return IfcScheduleTimeControl;
  }(IfcControl);

  IFC2X32.IfcScheduleTimeControl = IfcScheduleTimeControl;

  var IfcServiceLife = /*#__PURE__*/function (_IfcControl10) {
    _inherits(IfcServiceLife, _IfcControl10);

    var _super603 = _createSuper(IfcServiceLife);

    function IfcServiceLife(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ServiceLifeType, ServiceLifeDuration) {
      var _this595;

      _classCallCheck2(this, IfcServiceLife);

      _this595 = _super603.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this595.GlobalId = GlobalId;
      _this595.OwnerHistory = OwnerHistory;
      _this595.Name = Name;
      _this595.Description = Description;
      _this595.ObjectType = ObjectType;
      _this595.ServiceLifeType = ServiceLifeType;
      _this595.ServiceLifeDuration = ServiceLifeDuration;
      _this595.type = 4105383287;
      return _this595;
    }

    return IfcServiceLife;
  }(IfcControl);

  IFC2X32.IfcServiceLife = IfcServiceLife;

  var IfcSite = /*#__PURE__*/function (_IfcSpatialStructureE3) {
    _inherits(IfcSite, _IfcSpatialStructureE3);

    var _super604 = _createSuper(IfcSite);

    function IfcSite(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress) {
      var _this596;

      _classCallCheck2(this, IfcSite);

      _this596 = _super604.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this596.GlobalId = GlobalId;
      _this596.OwnerHistory = OwnerHistory;
      _this596.Name = Name;
      _this596.Description = Description;
      _this596.ObjectType = ObjectType;
      _this596.ObjectPlacement = ObjectPlacement;
      _this596.Representation = Representation;
      _this596.LongName = LongName;
      _this596.CompositionType = CompositionType;
      _this596.RefLatitude = RefLatitude;
      _this596.RefLongitude = RefLongitude;
      _this596.RefElevation = RefElevation;
      _this596.LandTitleNumber = LandTitleNumber;
      _this596.SiteAddress = SiteAddress;
      _this596.type = 4097777520;
      return _this596;
    }

    return IfcSite;
  }(IfcSpatialStructureElement);

  IFC2X32.IfcSite = IfcSite;

  var IfcSlabType = /*#__PURE__*/function (_IfcBuildingElementTy8) {
    _inherits(IfcSlabType, _IfcBuildingElementTy8);

    var _super605 = _createSuper(IfcSlabType);

    function IfcSlabType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this597;

      _classCallCheck2(this, IfcSlabType);

      _this597 = _super605.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this597.GlobalId = GlobalId;
      _this597.OwnerHistory = OwnerHistory;
      _this597.Name = Name;
      _this597.Description = Description;
      _this597.ApplicableOccurrence = ApplicableOccurrence;
      _this597.HasPropertySets = HasPropertySets;
      _this597.RepresentationMaps = RepresentationMaps;
      _this597.Tag = Tag;
      _this597.ElementType = ElementType;
      _this597.PredefinedType = PredefinedType;
      _this597.type = 2533589738;
      return _this597;
    }

    return IfcSlabType;
  }(IfcBuildingElementType);

  IFC2X32.IfcSlabType = IfcSlabType;

  var IfcSpace = /*#__PURE__*/function (_IfcSpatialStructureE4) {
    _inherits(IfcSpace, _IfcSpatialStructureE4);

    var _super606 = _createSuper(IfcSpace);

    function IfcSpace(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, InteriorOrExteriorSpace, ElevationWithFlooring) {
      var _this598;

      _classCallCheck2(this, IfcSpace);

      _this598 = _super606.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this598.GlobalId = GlobalId;
      _this598.OwnerHistory = OwnerHistory;
      _this598.Name = Name;
      _this598.Description = Description;
      _this598.ObjectType = ObjectType;
      _this598.ObjectPlacement = ObjectPlacement;
      _this598.Representation = Representation;
      _this598.LongName = LongName;
      _this598.CompositionType = CompositionType;
      _this598.InteriorOrExteriorSpace = InteriorOrExteriorSpace;
      _this598.ElevationWithFlooring = ElevationWithFlooring;
      _this598.type = 3856911033;
      return _this598;
    }

    return IfcSpace;
  }(IfcSpatialStructureElement);

  IFC2X32.IfcSpace = IfcSpace;

  var IfcSpaceHeaterType = /*#__PURE__*/function (_IfcEnergyConversionD6) {
    _inherits(IfcSpaceHeaterType, _IfcEnergyConversionD6);

    var _super607 = _createSuper(IfcSpaceHeaterType);

    function IfcSpaceHeaterType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this599;

      _classCallCheck2(this, IfcSpaceHeaterType);

      _this599 = _super607.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this599.GlobalId = GlobalId;
      _this599.OwnerHistory = OwnerHistory;
      _this599.Name = Name;
      _this599.Description = Description;
      _this599.ApplicableOccurrence = ApplicableOccurrence;
      _this599.HasPropertySets = HasPropertySets;
      _this599.RepresentationMaps = RepresentationMaps;
      _this599.Tag = Tag;
      _this599.ElementType = ElementType;
      _this599.PredefinedType = PredefinedType;
      _this599.type = 1305183839;
      return _this599;
    }

    return IfcSpaceHeaterType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcSpaceHeaterType = IfcSpaceHeaterType;

  var IfcSpaceProgram = /*#__PURE__*/function (_IfcControl11) {
    _inherits(IfcSpaceProgram, _IfcControl11);

    var _super608 = _createSuper(IfcSpaceProgram);

    function IfcSpaceProgram(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, SpaceProgramIdentifier, MaxRequiredArea, MinRequiredArea, RequestedLocation, StandardRequiredArea) {
      var _this600;

      _classCallCheck2(this, IfcSpaceProgram);

      _this600 = _super608.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this600.GlobalId = GlobalId;
      _this600.OwnerHistory = OwnerHistory;
      _this600.Name = Name;
      _this600.Description = Description;
      _this600.ObjectType = ObjectType;
      _this600.SpaceProgramIdentifier = SpaceProgramIdentifier;
      _this600.MaxRequiredArea = MaxRequiredArea;
      _this600.MinRequiredArea = MinRequiredArea;
      _this600.RequestedLocation = RequestedLocation;
      _this600.StandardRequiredArea = StandardRequiredArea;
      _this600.type = 652456506;
      return _this600;
    }

    return IfcSpaceProgram;
  }(IfcControl);

  IFC2X32.IfcSpaceProgram = IfcSpaceProgram;

  var IfcSpaceType = /*#__PURE__*/function (_IfcSpatialStructureE5) {
    _inherits(IfcSpaceType, _IfcSpatialStructureE5);

    var _super609 = _createSuper(IfcSpaceType);

    function IfcSpaceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this601;

      _classCallCheck2(this, IfcSpaceType);

      _this601 = _super609.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this601.GlobalId = GlobalId;
      _this601.OwnerHistory = OwnerHistory;
      _this601.Name = Name;
      _this601.Description = Description;
      _this601.ApplicableOccurrence = ApplicableOccurrence;
      _this601.HasPropertySets = HasPropertySets;
      _this601.RepresentationMaps = RepresentationMaps;
      _this601.Tag = Tag;
      _this601.ElementType = ElementType;
      _this601.PredefinedType = PredefinedType;
      _this601.type = 3812236995;
      return _this601;
    }

    return IfcSpaceType;
  }(IfcSpatialStructureElementType);

  IFC2X32.IfcSpaceType = IfcSpaceType;

  var IfcStackTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType6) {
    _inherits(IfcStackTerminalType, _IfcFlowTerminalType6);

    var _super610 = _createSuper(IfcStackTerminalType);

    function IfcStackTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this602;

      _classCallCheck2(this, IfcStackTerminalType);

      _this602 = _super610.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this602.GlobalId = GlobalId;
      _this602.OwnerHistory = OwnerHistory;
      _this602.Name = Name;
      _this602.Description = Description;
      _this602.ApplicableOccurrence = ApplicableOccurrence;
      _this602.HasPropertySets = HasPropertySets;
      _this602.RepresentationMaps = RepresentationMaps;
      _this602.Tag = Tag;
      _this602.ElementType = ElementType;
      _this602.PredefinedType = PredefinedType;
      _this602.type = 3112655638;
      return _this602;
    }

    return IfcStackTerminalType;
  }(IfcFlowTerminalType);

  IFC2X32.IfcStackTerminalType = IfcStackTerminalType;

  var IfcStairFlightType = /*#__PURE__*/function (_IfcBuildingElementTy9) {
    _inherits(IfcStairFlightType, _IfcBuildingElementTy9);

    var _super611 = _createSuper(IfcStairFlightType);

    function IfcStairFlightType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this603;

      _classCallCheck2(this, IfcStairFlightType);

      _this603 = _super611.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this603.GlobalId = GlobalId;
      _this603.OwnerHistory = OwnerHistory;
      _this603.Name = Name;
      _this603.Description = Description;
      _this603.ApplicableOccurrence = ApplicableOccurrence;
      _this603.HasPropertySets = HasPropertySets;
      _this603.RepresentationMaps = RepresentationMaps;
      _this603.Tag = Tag;
      _this603.ElementType = ElementType;
      _this603.PredefinedType = PredefinedType;
      _this603.type = 1039846685;
      return _this603;
    }

    return IfcStairFlightType;
  }(IfcBuildingElementType);

  IFC2X32.IfcStairFlightType = IfcStairFlightType;

  var IfcStructuralAction = /*#__PURE__*/function (_IfcStructuralActivit2) {
    _inherits(IfcStructuralAction, _IfcStructuralActivit2);

    var _super612 = _createSuper(IfcStructuralAction);

    function IfcStructuralAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy) {
      var _this604;

      _classCallCheck2(this, IfcStructuralAction);

      _this604 = _super612.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this604.GlobalId = GlobalId;
      _this604.OwnerHistory = OwnerHistory;
      _this604.Name = Name;
      _this604.Description = Description;
      _this604.ObjectType = ObjectType;
      _this604.ObjectPlacement = ObjectPlacement;
      _this604.Representation = Representation;
      _this604.AppliedLoad = AppliedLoad;
      _this604.GlobalOrLocal = GlobalOrLocal;
      _this604.DestabilizingLoad = DestabilizingLoad;
      _this604.CausedBy = CausedBy;
      _this604.type = 682877961;
      return _this604;
    }

    return IfcStructuralAction;
  }(IfcStructuralActivity);

  IFC2X32.IfcStructuralAction = IfcStructuralAction;

  var IfcStructuralConnection = /*#__PURE__*/function (_IfcStructuralItem2) {
    _inherits(IfcStructuralConnection, _IfcStructuralItem2);

    var _super613 = _createSuper(IfcStructuralConnection);

    function IfcStructuralConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      var _this605;

      _classCallCheck2(this, IfcStructuralConnection);

      _this605 = _super613.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this605.GlobalId = GlobalId;
      _this605.OwnerHistory = OwnerHistory;
      _this605.Name = Name;
      _this605.Description = Description;
      _this605.ObjectType = ObjectType;
      _this605.ObjectPlacement = ObjectPlacement;
      _this605.Representation = Representation;
      _this605.AppliedCondition = AppliedCondition;
      _this605.type = 1179482911;
      return _this605;
    }

    return IfcStructuralConnection;
  }(IfcStructuralItem);

  IFC2X32.IfcStructuralConnection = IfcStructuralConnection;

  var IfcStructuralCurveConnection = /*#__PURE__*/function (_IfcStructuralConnect3) {
    _inherits(IfcStructuralCurveConnection, _IfcStructuralConnect3);

    var _super614 = _createSuper(IfcStructuralCurveConnection);

    function IfcStructuralCurveConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      var _this606;

      _classCallCheck2(this, IfcStructuralCurveConnection);

      _this606 = _super614.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      _this606.GlobalId = GlobalId;
      _this606.OwnerHistory = OwnerHistory;
      _this606.Name = Name;
      _this606.Description = Description;
      _this606.ObjectType = ObjectType;
      _this606.ObjectPlacement = ObjectPlacement;
      _this606.Representation = Representation;
      _this606.AppliedCondition = AppliedCondition;
      _this606.type = 4243806635;
      return _this606;
    }

    return IfcStructuralCurveConnection;
  }(IfcStructuralConnection);

  IFC2X32.IfcStructuralCurveConnection = IfcStructuralCurveConnection;

  var IfcStructuralCurveMember = /*#__PURE__*/function (_IfcStructuralMember2) {
    _inherits(IfcStructuralCurveMember, _IfcStructuralMember2);

    var _super615 = _createSuper(IfcStructuralCurveMember);

    function IfcStructuralCurveMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      var _this607;

      _classCallCheck2(this, IfcStructuralCurveMember);

      _this607 = _super615.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this607.GlobalId = GlobalId;
      _this607.OwnerHistory = OwnerHistory;
      _this607.Name = Name;
      _this607.Description = Description;
      _this607.ObjectType = ObjectType;
      _this607.ObjectPlacement = ObjectPlacement;
      _this607.Representation = Representation;
      _this607.PredefinedType = PredefinedType;
      _this607.type = 214636428;
      return _this607;
    }

    return IfcStructuralCurveMember;
  }(IfcStructuralMember);

  IFC2X32.IfcStructuralCurveMember = IfcStructuralCurveMember;

  var IfcStructuralCurveMemberVarying = /*#__PURE__*/function (_IfcStructuralCurveMe) {
    _inherits(IfcStructuralCurveMemberVarying, _IfcStructuralCurveMe);

    var _super616 = _createSuper(IfcStructuralCurveMemberVarying);

    function IfcStructuralCurveMemberVarying(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      var _this608;

      _classCallCheck2(this, IfcStructuralCurveMemberVarying);

      _this608 = _super616.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType);
      _this608.GlobalId = GlobalId;
      _this608.OwnerHistory = OwnerHistory;
      _this608.Name = Name;
      _this608.Description = Description;
      _this608.ObjectType = ObjectType;
      _this608.ObjectPlacement = ObjectPlacement;
      _this608.Representation = Representation;
      _this608.PredefinedType = PredefinedType;
      _this608.type = 2445595289;
      return _this608;
    }

    return IfcStructuralCurveMemberVarying;
  }(IfcStructuralCurveMember);

  IFC2X32.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;

  var IfcStructuralLinearAction = /*#__PURE__*/function (_IfcStructuralAction) {
    _inherits(IfcStructuralLinearAction, _IfcStructuralAction);

    var _super617 = _createSuper(IfcStructuralLinearAction);

    function IfcStructuralLinearAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue) {
      var _this609;

      _classCallCheck2(this, IfcStructuralLinearAction);

      _this609 = _super617.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
      _this609.GlobalId = GlobalId;
      _this609.OwnerHistory = OwnerHistory;
      _this609.Name = Name;
      _this609.Description = Description;
      _this609.ObjectType = ObjectType;
      _this609.ObjectPlacement = ObjectPlacement;
      _this609.Representation = Representation;
      _this609.AppliedLoad = AppliedLoad;
      _this609.GlobalOrLocal = GlobalOrLocal;
      _this609.DestabilizingLoad = DestabilizingLoad;
      _this609.CausedBy = CausedBy;
      _this609.ProjectedOrTrue = ProjectedOrTrue;
      _this609.type = 1807405624;
      return _this609;
    }

    return IfcStructuralLinearAction;
  }(IfcStructuralAction);

  IFC2X32.IfcStructuralLinearAction = IfcStructuralLinearAction;

  var IfcStructuralLinearActionVarying = /*#__PURE__*/function (_IfcStructuralLinearA) {
    _inherits(IfcStructuralLinearActionVarying, _IfcStructuralLinearA);

    var _super618 = _createSuper(IfcStructuralLinearActionVarying);

    function IfcStructuralLinearActionVarying(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue, VaryingAppliedLoadLocation, SubsequentAppliedLoads) {
      var _this610;

      _classCallCheck2(this, IfcStructuralLinearActionVarying);

      _this610 = _super618.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue);
      _this610.GlobalId = GlobalId;
      _this610.OwnerHistory = OwnerHistory;
      _this610.Name = Name;
      _this610.Description = Description;
      _this610.ObjectType = ObjectType;
      _this610.ObjectPlacement = ObjectPlacement;
      _this610.Representation = Representation;
      _this610.AppliedLoad = AppliedLoad;
      _this610.GlobalOrLocal = GlobalOrLocal;
      _this610.DestabilizingLoad = DestabilizingLoad;
      _this610.CausedBy = CausedBy;
      _this610.ProjectedOrTrue = ProjectedOrTrue;
      _this610.VaryingAppliedLoadLocation = VaryingAppliedLoadLocation;
      _this610.SubsequentAppliedLoads = SubsequentAppliedLoads;
      _this610.type = 1721250024;
      return _this610;
    }

    return IfcStructuralLinearActionVarying;
  }(IfcStructuralLinearAction);

  IFC2X32.IfcStructuralLinearActionVarying = IfcStructuralLinearActionVarying;

  var IfcStructuralLoadGroup = /*#__PURE__*/function (_IfcGroup2) {
    _inherits(IfcStructuralLoadGroup, _IfcGroup2);

    var _super619 = _createSuper(IfcStructuralLoadGroup);

    function IfcStructuralLoadGroup(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose) {
      var _this611;

      _classCallCheck2(this, IfcStructuralLoadGroup);

      _this611 = _super619.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this611.GlobalId = GlobalId;
      _this611.OwnerHistory = OwnerHistory;
      _this611.Name = Name;
      _this611.Description = Description;
      _this611.ObjectType = ObjectType;
      _this611.PredefinedType = PredefinedType;
      _this611.ActionType = ActionType;
      _this611.ActionSource = ActionSource;
      _this611.Coefficient = Coefficient;
      _this611.Purpose = Purpose;
      _this611.type = 1252848954;
      return _this611;
    }

    return IfcStructuralLoadGroup;
  }(IfcGroup);

  IFC2X32.IfcStructuralLoadGroup = IfcStructuralLoadGroup;

  var IfcStructuralPlanarAction = /*#__PURE__*/function (_IfcStructuralAction2) {
    _inherits(IfcStructuralPlanarAction, _IfcStructuralAction2);

    var _super620 = _createSuper(IfcStructuralPlanarAction);

    function IfcStructuralPlanarAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue) {
      var _this612;

      _classCallCheck2(this, IfcStructuralPlanarAction);

      _this612 = _super620.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
      _this612.GlobalId = GlobalId;
      _this612.OwnerHistory = OwnerHistory;
      _this612.Name = Name;
      _this612.Description = Description;
      _this612.ObjectType = ObjectType;
      _this612.ObjectPlacement = ObjectPlacement;
      _this612.Representation = Representation;
      _this612.AppliedLoad = AppliedLoad;
      _this612.GlobalOrLocal = GlobalOrLocal;
      _this612.DestabilizingLoad = DestabilizingLoad;
      _this612.CausedBy = CausedBy;
      _this612.ProjectedOrTrue = ProjectedOrTrue;
      _this612.type = 1621171031;
      return _this612;
    }

    return IfcStructuralPlanarAction;
  }(IfcStructuralAction);

  IFC2X32.IfcStructuralPlanarAction = IfcStructuralPlanarAction;

  var IfcStructuralPlanarActionVarying = /*#__PURE__*/function (_IfcStructuralPlanarA) {
    _inherits(IfcStructuralPlanarActionVarying, _IfcStructuralPlanarA);

    var _super621 = _createSuper(IfcStructuralPlanarActionVarying);

    function IfcStructuralPlanarActionVarying(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue, VaryingAppliedLoadLocation, SubsequentAppliedLoads) {
      var _this613;

      _classCallCheck2(this, IfcStructuralPlanarActionVarying);

      _this613 = _super621.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy, ProjectedOrTrue);
      _this613.GlobalId = GlobalId;
      _this613.OwnerHistory = OwnerHistory;
      _this613.Name = Name;
      _this613.Description = Description;
      _this613.ObjectType = ObjectType;
      _this613.ObjectPlacement = ObjectPlacement;
      _this613.Representation = Representation;
      _this613.AppliedLoad = AppliedLoad;
      _this613.GlobalOrLocal = GlobalOrLocal;
      _this613.DestabilizingLoad = DestabilizingLoad;
      _this613.CausedBy = CausedBy;
      _this613.ProjectedOrTrue = ProjectedOrTrue;
      _this613.VaryingAppliedLoadLocation = VaryingAppliedLoadLocation;
      _this613.SubsequentAppliedLoads = SubsequentAppliedLoads;
      _this613.type = 3987759626;
      return _this613;
    }

    return IfcStructuralPlanarActionVarying;
  }(IfcStructuralPlanarAction);

  IFC2X32.IfcStructuralPlanarActionVarying = IfcStructuralPlanarActionVarying;

  var IfcStructuralPointAction = /*#__PURE__*/function (_IfcStructuralAction3) {
    _inherits(IfcStructuralPointAction, _IfcStructuralAction3);

    var _super622 = _createSuper(IfcStructuralPointAction);

    function IfcStructuralPointAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy) {
      var _this614;

      _classCallCheck2(this, IfcStructuralPointAction);

      _this614 = _super622.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, CausedBy);
      _this614.GlobalId = GlobalId;
      _this614.OwnerHistory = OwnerHistory;
      _this614.Name = Name;
      _this614.Description = Description;
      _this614.ObjectType = ObjectType;
      _this614.ObjectPlacement = ObjectPlacement;
      _this614.Representation = Representation;
      _this614.AppliedLoad = AppliedLoad;
      _this614.GlobalOrLocal = GlobalOrLocal;
      _this614.DestabilizingLoad = DestabilizingLoad;
      _this614.CausedBy = CausedBy;
      _this614.type = 2082059205;
      return _this614;
    }

    return IfcStructuralPointAction;
  }(IfcStructuralAction);

  IFC2X32.IfcStructuralPointAction = IfcStructuralPointAction;

  var IfcStructuralPointConnection = /*#__PURE__*/function (_IfcStructuralConnect4) {
    _inherits(IfcStructuralPointConnection, _IfcStructuralConnect4);

    var _super623 = _createSuper(IfcStructuralPointConnection);

    function IfcStructuralPointConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      var _this615;

      _classCallCheck2(this, IfcStructuralPointConnection);

      _this615 = _super623.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      _this615.GlobalId = GlobalId;
      _this615.OwnerHistory = OwnerHistory;
      _this615.Name = Name;
      _this615.Description = Description;
      _this615.ObjectType = ObjectType;
      _this615.ObjectPlacement = ObjectPlacement;
      _this615.Representation = Representation;
      _this615.AppliedCondition = AppliedCondition;
      _this615.type = 734778138;
      return _this615;
    }

    return IfcStructuralPointConnection;
  }(IfcStructuralConnection);

  IFC2X32.IfcStructuralPointConnection = IfcStructuralPointConnection;

  var IfcStructuralPointReaction = /*#__PURE__*/function (_IfcStructuralReactio) {
    _inherits(IfcStructuralPointReaction, _IfcStructuralReactio);

    var _super624 = _createSuper(IfcStructuralPointReaction);

    function IfcStructuralPointReaction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      var _this616;

      _classCallCheck2(this, IfcStructuralPointReaction);

      _this616 = _super624.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this616.GlobalId = GlobalId;
      _this616.OwnerHistory = OwnerHistory;
      _this616.Name = Name;
      _this616.Description = Description;
      _this616.ObjectType = ObjectType;
      _this616.ObjectPlacement = ObjectPlacement;
      _this616.Representation = Representation;
      _this616.AppliedLoad = AppliedLoad;
      _this616.GlobalOrLocal = GlobalOrLocal;
      _this616.type = 1235345126;
      return _this616;
    }

    return IfcStructuralPointReaction;
  }(IfcStructuralReaction);

  IFC2X32.IfcStructuralPointReaction = IfcStructuralPointReaction;

  var IfcStructuralResultGroup = /*#__PURE__*/function (_IfcGroup3) {
    _inherits(IfcStructuralResultGroup, _IfcGroup3);

    var _super625 = _createSuper(IfcStructuralResultGroup);

    function IfcStructuralResultGroup(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear) {
      var _this617;

      _classCallCheck2(this, IfcStructuralResultGroup);

      _this617 = _super625.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this617.GlobalId = GlobalId;
      _this617.OwnerHistory = OwnerHistory;
      _this617.Name = Name;
      _this617.Description = Description;
      _this617.ObjectType = ObjectType;
      _this617.TheoryType = TheoryType;
      _this617.ResultForLoadGroup = ResultForLoadGroup;
      _this617.IsLinear = IsLinear;
      _this617.type = 2986769608;
      return _this617;
    }

    return IfcStructuralResultGroup;
  }(IfcGroup);

  IFC2X32.IfcStructuralResultGroup = IfcStructuralResultGroup;

  var IfcStructuralSurfaceConnection = /*#__PURE__*/function (_IfcStructuralConnect5) {
    _inherits(IfcStructuralSurfaceConnection, _IfcStructuralConnect5);

    var _super626 = _createSuper(IfcStructuralSurfaceConnection);

    function IfcStructuralSurfaceConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      var _this618;

      _classCallCheck2(this, IfcStructuralSurfaceConnection);

      _this618 = _super626.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      _this618.GlobalId = GlobalId;
      _this618.OwnerHistory = OwnerHistory;
      _this618.Name = Name;
      _this618.Description = Description;
      _this618.ObjectType = ObjectType;
      _this618.ObjectPlacement = ObjectPlacement;
      _this618.Representation = Representation;
      _this618.AppliedCondition = AppliedCondition;
      _this618.type = 1975003073;
      return _this618;
    }

    return IfcStructuralSurfaceConnection;
  }(IfcStructuralConnection);

  IFC2X32.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;

  var IfcSubContractResource = /*#__PURE__*/function (_IfcConstructionResou3) {
    _inherits(IfcSubContractResource, _IfcConstructionResou3);

    var _super627 = _createSuper(IfcSubContractResource);

    function IfcSubContractResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, SubContractor, JobDescription) {
      var _this619;

      _classCallCheck2(this, IfcSubContractResource);

      _this619 = _super627.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      _this619.GlobalId = GlobalId;
      _this619.OwnerHistory = OwnerHistory;
      _this619.Name = Name;
      _this619.Description = Description;
      _this619.ObjectType = ObjectType;
      _this619.ResourceIdentifier = ResourceIdentifier;
      _this619.ResourceGroup = ResourceGroup;
      _this619.ResourceConsumption = ResourceConsumption;
      _this619.BaseQuantity = BaseQuantity;
      _this619.SubContractor = SubContractor;
      _this619.JobDescription = JobDescription;
      _this619.type = 148013059;
      return _this619;
    }

    return IfcSubContractResource;
  }(IfcConstructionResource);

  IFC2X32.IfcSubContractResource = IfcSubContractResource;

  var IfcSwitchingDeviceType = /*#__PURE__*/function (_IfcFlowControllerTyp3) {
    _inherits(IfcSwitchingDeviceType, _IfcFlowControllerTyp3);

    var _super628 = _createSuper(IfcSwitchingDeviceType);

    function IfcSwitchingDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this620;

      _classCallCheck2(this, IfcSwitchingDeviceType);

      _this620 = _super628.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this620.GlobalId = GlobalId;
      _this620.OwnerHistory = OwnerHistory;
      _this620.Name = Name;
      _this620.Description = Description;
      _this620.ApplicableOccurrence = ApplicableOccurrence;
      _this620.HasPropertySets = HasPropertySets;
      _this620.RepresentationMaps = RepresentationMaps;
      _this620.Tag = Tag;
      _this620.ElementType = ElementType;
      _this620.PredefinedType = PredefinedType;
      _this620.type = 2315554128;
      return _this620;
    }

    return IfcSwitchingDeviceType;
  }(IfcFlowControllerType);

  IFC2X32.IfcSwitchingDeviceType = IfcSwitchingDeviceType;

  var IfcSystem = /*#__PURE__*/function (_IfcGroup4) {
    _inherits(IfcSystem, _IfcGroup4);

    var _super629 = _createSuper(IfcSystem);

    function IfcSystem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this621;

      _classCallCheck2(this, IfcSystem);

      _this621 = _super629.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this621.GlobalId = GlobalId;
      _this621.OwnerHistory = OwnerHistory;
      _this621.Name = Name;
      _this621.Description = Description;
      _this621.ObjectType = ObjectType;
      _this621.type = 2254336722;
      return _this621;
    }

    return IfcSystem;
  }(IfcGroup);

  IFC2X32.IfcSystem = IfcSystem;

  var IfcTankType = /*#__PURE__*/function (_IfcFlowStorageDevice) {
    _inherits(IfcTankType, _IfcFlowStorageDevice);

    var _super630 = _createSuper(IfcTankType);

    function IfcTankType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this622;

      _classCallCheck2(this, IfcTankType);

      _this622 = _super630.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this622.GlobalId = GlobalId;
      _this622.OwnerHistory = OwnerHistory;
      _this622.Name = Name;
      _this622.Description = Description;
      _this622.ApplicableOccurrence = ApplicableOccurrence;
      _this622.HasPropertySets = HasPropertySets;
      _this622.RepresentationMaps = RepresentationMaps;
      _this622.Tag = Tag;
      _this622.ElementType = ElementType;
      _this622.PredefinedType = PredefinedType;
      _this622.type = 5716631;
      return _this622;
    }

    return IfcTankType;
  }(IfcFlowStorageDeviceType);

  IFC2X32.IfcTankType = IfcTankType;

  var IfcTimeSeriesSchedule = /*#__PURE__*/function (_IfcControl12) {
    _inherits(IfcTimeSeriesSchedule, _IfcControl12);

    var _super631 = _createSuper(IfcTimeSeriesSchedule);

    function IfcTimeSeriesSchedule(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ApplicableDates, TimeSeriesScheduleType, TimeSeries) {
      var _this623;

      _classCallCheck2(this, IfcTimeSeriesSchedule);

      _this623 = _super631.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this623.GlobalId = GlobalId;
      _this623.OwnerHistory = OwnerHistory;
      _this623.Name = Name;
      _this623.Description = Description;
      _this623.ObjectType = ObjectType;
      _this623.ApplicableDates = ApplicableDates;
      _this623.TimeSeriesScheduleType = TimeSeriesScheduleType;
      _this623.TimeSeries = TimeSeries;
      _this623.type = 1637806684;
      return _this623;
    }

    return IfcTimeSeriesSchedule;
  }(IfcControl);

  IFC2X32.IfcTimeSeriesSchedule = IfcTimeSeriesSchedule;

  var IfcTransformerType = /*#__PURE__*/function (_IfcEnergyConversionD7) {
    _inherits(IfcTransformerType, _IfcEnergyConversionD7);

    var _super632 = _createSuper(IfcTransformerType);

    function IfcTransformerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this624;

      _classCallCheck2(this, IfcTransformerType);

      _this624 = _super632.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this624.GlobalId = GlobalId;
      _this624.OwnerHistory = OwnerHistory;
      _this624.Name = Name;
      _this624.Description = Description;
      _this624.ApplicableOccurrence = ApplicableOccurrence;
      _this624.HasPropertySets = HasPropertySets;
      _this624.RepresentationMaps = RepresentationMaps;
      _this624.Tag = Tag;
      _this624.ElementType = ElementType;
      _this624.PredefinedType = PredefinedType;
      _this624.type = 1692211062;
      return _this624;
    }

    return IfcTransformerType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcTransformerType = IfcTransformerType;

  var IfcTransportElement = /*#__PURE__*/function (_IfcElement6) {
    _inherits(IfcTransportElement, _IfcElement6);

    var _super633 = _createSuper(IfcTransportElement);

    function IfcTransportElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OperationType, CapacityByWeight, CapacityByNumber) {
      var _this625;

      _classCallCheck2(this, IfcTransportElement);

      _this625 = _super633.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this625.GlobalId = GlobalId;
      _this625.OwnerHistory = OwnerHistory;
      _this625.Name = Name;
      _this625.Description = Description;
      _this625.ObjectType = ObjectType;
      _this625.ObjectPlacement = ObjectPlacement;
      _this625.Representation = Representation;
      _this625.Tag = Tag;
      _this625.OperationType = OperationType;
      _this625.CapacityByWeight = CapacityByWeight;
      _this625.CapacityByNumber = CapacityByNumber;
      _this625.type = 1620046519;
      return _this625;
    }

    return IfcTransportElement;
  }(IfcElement);

  IFC2X32.IfcTransportElement = IfcTransportElement;

  var IfcTrimmedCurve = /*#__PURE__*/function (_IfcBoundedCurve3) {
    _inherits(IfcTrimmedCurve, _IfcBoundedCurve3);

    var _super634 = _createSuper(IfcTrimmedCurve);

    function IfcTrimmedCurve(expressID, BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation) {
      var _this626;

      _classCallCheck2(this, IfcTrimmedCurve);

      _this626 = _super634.call(this, expressID);
      _this626.BasisCurve = BasisCurve;
      _this626.Trim1 = Trim1;
      _this626.Trim2 = Trim2;
      _this626.SenseAgreement = SenseAgreement;
      _this626.MasterRepresentation = MasterRepresentation;
      _this626.type = 3593883385;
      return _this626;
    }

    return IfcTrimmedCurve;
  }(IfcBoundedCurve);

  IFC2X32.IfcTrimmedCurve = IfcTrimmedCurve;

  var IfcTubeBundleType = /*#__PURE__*/function (_IfcEnergyConversionD8) {
    _inherits(IfcTubeBundleType, _IfcEnergyConversionD8);

    var _super635 = _createSuper(IfcTubeBundleType);

    function IfcTubeBundleType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this627;

      _classCallCheck2(this, IfcTubeBundleType);

      _this627 = _super635.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this627.GlobalId = GlobalId;
      _this627.OwnerHistory = OwnerHistory;
      _this627.Name = Name;
      _this627.Description = Description;
      _this627.ApplicableOccurrence = ApplicableOccurrence;
      _this627.HasPropertySets = HasPropertySets;
      _this627.RepresentationMaps = RepresentationMaps;
      _this627.Tag = Tag;
      _this627.ElementType = ElementType;
      _this627.PredefinedType = PredefinedType;
      _this627.type = 1600972822;
      return _this627;
    }

    return IfcTubeBundleType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcTubeBundleType = IfcTubeBundleType;

  var IfcUnitaryEquipmentType = /*#__PURE__*/function (_IfcEnergyConversionD9) {
    _inherits(IfcUnitaryEquipmentType, _IfcEnergyConversionD9);

    var _super636 = _createSuper(IfcUnitaryEquipmentType);

    function IfcUnitaryEquipmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this628;

      _classCallCheck2(this, IfcUnitaryEquipmentType);

      _this628 = _super636.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this628.GlobalId = GlobalId;
      _this628.OwnerHistory = OwnerHistory;
      _this628.Name = Name;
      _this628.Description = Description;
      _this628.ApplicableOccurrence = ApplicableOccurrence;
      _this628.HasPropertySets = HasPropertySets;
      _this628.RepresentationMaps = RepresentationMaps;
      _this628.Tag = Tag;
      _this628.ElementType = ElementType;
      _this628.PredefinedType = PredefinedType;
      _this628.type = 1911125066;
      return _this628;
    }

    return IfcUnitaryEquipmentType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;

  var IfcValveType = /*#__PURE__*/function (_IfcFlowControllerTyp4) {
    _inherits(IfcValveType, _IfcFlowControllerTyp4);

    var _super637 = _createSuper(IfcValveType);

    function IfcValveType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this629;

      _classCallCheck2(this, IfcValveType);

      _this629 = _super637.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this629.GlobalId = GlobalId;
      _this629.OwnerHistory = OwnerHistory;
      _this629.Name = Name;
      _this629.Description = Description;
      _this629.ApplicableOccurrence = ApplicableOccurrence;
      _this629.HasPropertySets = HasPropertySets;
      _this629.RepresentationMaps = RepresentationMaps;
      _this629.Tag = Tag;
      _this629.ElementType = ElementType;
      _this629.PredefinedType = PredefinedType;
      _this629.type = 728799441;
      return _this629;
    }

    return IfcValveType;
  }(IfcFlowControllerType);

  IFC2X32.IfcValveType = IfcValveType;

  var IfcVirtualElement = /*#__PURE__*/function (_IfcElement7) {
    _inherits(IfcVirtualElement, _IfcElement7);

    var _super638 = _createSuper(IfcVirtualElement);

    function IfcVirtualElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this630;

      _classCallCheck2(this, IfcVirtualElement);

      _this630 = _super638.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this630.GlobalId = GlobalId;
      _this630.OwnerHistory = OwnerHistory;
      _this630.Name = Name;
      _this630.Description = Description;
      _this630.ObjectType = ObjectType;
      _this630.ObjectPlacement = ObjectPlacement;
      _this630.Representation = Representation;
      _this630.Tag = Tag;
      _this630.type = 2769231204;
      return _this630;
    }

    return IfcVirtualElement;
  }(IfcElement);

  IFC2X32.IfcVirtualElement = IfcVirtualElement;

  var IfcWallType = /*#__PURE__*/function (_IfcBuildingElementTy10) {
    _inherits(IfcWallType, _IfcBuildingElementTy10);

    var _super639 = _createSuper(IfcWallType);

    function IfcWallType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this631;

      _classCallCheck2(this, IfcWallType);

      _this631 = _super639.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this631.GlobalId = GlobalId;
      _this631.OwnerHistory = OwnerHistory;
      _this631.Name = Name;
      _this631.Description = Description;
      _this631.ApplicableOccurrence = ApplicableOccurrence;
      _this631.HasPropertySets = HasPropertySets;
      _this631.RepresentationMaps = RepresentationMaps;
      _this631.Tag = Tag;
      _this631.ElementType = ElementType;
      _this631.PredefinedType = PredefinedType;
      _this631.type = 1898987631;
      return _this631;
    }

    return IfcWallType;
  }(IfcBuildingElementType);

  IFC2X32.IfcWallType = IfcWallType;

  var IfcWasteTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType7) {
    _inherits(IfcWasteTerminalType, _IfcFlowTerminalType7);

    var _super640 = _createSuper(IfcWasteTerminalType);

    function IfcWasteTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this632;

      _classCallCheck2(this, IfcWasteTerminalType);

      _this632 = _super640.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this632.GlobalId = GlobalId;
      _this632.OwnerHistory = OwnerHistory;
      _this632.Name = Name;
      _this632.Description = Description;
      _this632.ApplicableOccurrence = ApplicableOccurrence;
      _this632.HasPropertySets = HasPropertySets;
      _this632.RepresentationMaps = RepresentationMaps;
      _this632.Tag = Tag;
      _this632.ElementType = ElementType;
      _this632.PredefinedType = PredefinedType;
      _this632.type = 1133259667;
      return _this632;
    }

    return IfcWasteTerminalType;
  }(IfcFlowTerminalType);

  IFC2X32.IfcWasteTerminalType = IfcWasteTerminalType;

  var IfcWorkControl = /*#__PURE__*/function (_IfcControl13) {
    _inherits(IfcWorkControl, _IfcControl13);

    var _super641 = _createSuper(IfcWorkControl);

    function IfcWorkControl(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType) {
      var _this633;

      _classCallCheck2(this, IfcWorkControl);

      _this633 = _super641.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this633.GlobalId = GlobalId;
      _this633.OwnerHistory = OwnerHistory;
      _this633.Name = Name;
      _this633.Description = Description;
      _this633.ObjectType = ObjectType;
      _this633.Identifier = Identifier;
      _this633.CreationDate = CreationDate;
      _this633.Creators = Creators;
      _this633.Purpose = Purpose;
      _this633.Duration = Duration;
      _this633.TotalFloat = TotalFloat;
      _this633.StartTime = StartTime;
      _this633.FinishTime = FinishTime;
      _this633.WorkControlType = WorkControlType;
      _this633.UserDefinedControlType = UserDefinedControlType;
      _this633.type = 1028945134;
      return _this633;
    }

    return IfcWorkControl;
  }(IfcControl);

  IFC2X32.IfcWorkControl = IfcWorkControl;

  var IfcWorkPlan = /*#__PURE__*/function (_IfcWorkControl) {
    _inherits(IfcWorkPlan, _IfcWorkControl);

    var _super642 = _createSuper(IfcWorkPlan);

    function IfcWorkPlan(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType) {
      var _this634;

      _classCallCheck2(this, IfcWorkPlan);

      _this634 = _super642.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType);
      _this634.GlobalId = GlobalId;
      _this634.OwnerHistory = OwnerHistory;
      _this634.Name = Name;
      _this634.Description = Description;
      _this634.ObjectType = ObjectType;
      _this634.Identifier = Identifier;
      _this634.CreationDate = CreationDate;
      _this634.Creators = Creators;
      _this634.Purpose = Purpose;
      _this634.Duration = Duration;
      _this634.TotalFloat = TotalFloat;
      _this634.StartTime = StartTime;
      _this634.FinishTime = FinishTime;
      _this634.WorkControlType = WorkControlType;
      _this634.UserDefinedControlType = UserDefinedControlType;
      _this634.type = 4218914973;
      return _this634;
    }

    return IfcWorkPlan;
  }(IfcWorkControl);

  IFC2X32.IfcWorkPlan = IfcWorkPlan;

  var IfcWorkSchedule = /*#__PURE__*/function (_IfcWorkControl2) {
    _inherits(IfcWorkSchedule, _IfcWorkControl2);

    var _super643 = _createSuper(IfcWorkSchedule);

    function IfcWorkSchedule(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType) {
      var _this635;

      _classCallCheck2(this, IfcWorkSchedule);

      _this635 = _super643.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identifier, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, WorkControlType, UserDefinedControlType);
      _this635.GlobalId = GlobalId;
      _this635.OwnerHistory = OwnerHistory;
      _this635.Name = Name;
      _this635.Description = Description;
      _this635.ObjectType = ObjectType;
      _this635.Identifier = Identifier;
      _this635.CreationDate = CreationDate;
      _this635.Creators = Creators;
      _this635.Purpose = Purpose;
      _this635.Duration = Duration;
      _this635.TotalFloat = TotalFloat;
      _this635.StartTime = StartTime;
      _this635.FinishTime = FinishTime;
      _this635.WorkControlType = WorkControlType;
      _this635.UserDefinedControlType = UserDefinedControlType;
      _this635.type = 3342526732;
      return _this635;
    }

    return IfcWorkSchedule;
  }(IfcWorkControl);

  IFC2X32.IfcWorkSchedule = IfcWorkSchedule;

  var IfcZone = /*#__PURE__*/function (_IfcGroup5) {
    _inherits(IfcZone, _IfcGroup5);

    var _super644 = _createSuper(IfcZone);

    function IfcZone(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this636;

      _classCallCheck2(this, IfcZone);

      _this636 = _super644.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this636.GlobalId = GlobalId;
      _this636.OwnerHistory = OwnerHistory;
      _this636.Name = Name;
      _this636.Description = Description;
      _this636.ObjectType = ObjectType;
      _this636.type = 1033361043;
      return _this636;
    }

    return IfcZone;
  }(IfcGroup);

  IFC2X32.IfcZone = IfcZone;

  var Ifc2DCompositeCurve = /*#__PURE__*/function (_IfcCompositeCurve) {
    _inherits(Ifc2DCompositeCurve, _IfcCompositeCurve);

    var _super645 = _createSuper(Ifc2DCompositeCurve);

    function Ifc2DCompositeCurve(expressID, Segments, SelfIntersect) {
      var _this637;

      _classCallCheck2(this, Ifc2DCompositeCurve);

      _this637 = _super645.call(this, expressID, Segments, SelfIntersect);
      _this637.Segments = Segments;
      _this637.SelfIntersect = SelfIntersect;
      _this637.type = 1213861670;
      return _this637;
    }

    return Ifc2DCompositeCurve;
  }(IfcCompositeCurve);

  IFC2X32.Ifc2DCompositeCurve = Ifc2DCompositeCurve;

  var IfcActionRequest = /*#__PURE__*/function (_IfcControl14) {
    _inherits(IfcActionRequest, _IfcControl14);

    var _super646 = _createSuper(IfcActionRequest);

    function IfcActionRequest(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, RequestID) {
      var _this638;

      _classCallCheck2(this, IfcActionRequest);

      _this638 = _super646.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this638.GlobalId = GlobalId;
      _this638.OwnerHistory = OwnerHistory;
      _this638.Name = Name;
      _this638.Description = Description;
      _this638.ObjectType = ObjectType;
      _this638.RequestID = RequestID;
      _this638.type = 3821786052;
      return _this638;
    }

    return IfcActionRequest;
  }(IfcControl);

  IFC2X32.IfcActionRequest = IfcActionRequest;

  var IfcAirTerminalBoxType = /*#__PURE__*/function (_IfcFlowControllerTyp5) {
    _inherits(IfcAirTerminalBoxType, _IfcFlowControllerTyp5);

    var _super647 = _createSuper(IfcAirTerminalBoxType);

    function IfcAirTerminalBoxType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this639;

      _classCallCheck2(this, IfcAirTerminalBoxType);

      _this639 = _super647.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this639.GlobalId = GlobalId;
      _this639.OwnerHistory = OwnerHistory;
      _this639.Name = Name;
      _this639.Description = Description;
      _this639.ApplicableOccurrence = ApplicableOccurrence;
      _this639.HasPropertySets = HasPropertySets;
      _this639.RepresentationMaps = RepresentationMaps;
      _this639.Tag = Tag;
      _this639.ElementType = ElementType;
      _this639.PredefinedType = PredefinedType;
      _this639.type = 1411407467;
      return _this639;
    }

    return IfcAirTerminalBoxType;
  }(IfcFlowControllerType);

  IFC2X32.IfcAirTerminalBoxType = IfcAirTerminalBoxType;

  var IfcAirTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType8) {
    _inherits(IfcAirTerminalType, _IfcFlowTerminalType8);

    var _super648 = _createSuper(IfcAirTerminalType);

    function IfcAirTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this640;

      _classCallCheck2(this, IfcAirTerminalType);

      _this640 = _super648.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this640.GlobalId = GlobalId;
      _this640.OwnerHistory = OwnerHistory;
      _this640.Name = Name;
      _this640.Description = Description;
      _this640.ApplicableOccurrence = ApplicableOccurrence;
      _this640.HasPropertySets = HasPropertySets;
      _this640.RepresentationMaps = RepresentationMaps;
      _this640.Tag = Tag;
      _this640.ElementType = ElementType;
      _this640.PredefinedType = PredefinedType;
      _this640.type = 3352864051;
      return _this640;
    }

    return IfcAirTerminalType;
  }(IfcFlowTerminalType);

  IFC2X32.IfcAirTerminalType = IfcAirTerminalType;

  var IfcAirToAirHeatRecoveryType = /*#__PURE__*/function (_IfcEnergyConversionD10) {
    _inherits(IfcAirToAirHeatRecoveryType, _IfcEnergyConversionD10);

    var _super649 = _createSuper(IfcAirToAirHeatRecoveryType);

    function IfcAirToAirHeatRecoveryType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this641;

      _classCallCheck2(this, IfcAirToAirHeatRecoveryType);

      _this641 = _super649.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this641.GlobalId = GlobalId;
      _this641.OwnerHistory = OwnerHistory;
      _this641.Name = Name;
      _this641.Description = Description;
      _this641.ApplicableOccurrence = ApplicableOccurrence;
      _this641.HasPropertySets = HasPropertySets;
      _this641.RepresentationMaps = RepresentationMaps;
      _this641.Tag = Tag;
      _this641.ElementType = ElementType;
      _this641.PredefinedType = PredefinedType;
      _this641.type = 1871374353;
      return _this641;
    }

    return IfcAirToAirHeatRecoveryType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;

  var IfcAngularDimension = /*#__PURE__*/function (_IfcDimensionCurveDir3) {
    _inherits(IfcAngularDimension, _IfcDimensionCurveDir3);

    var _super650 = _createSuper(IfcAngularDimension);

    function IfcAngularDimension(expressID, Contents) {
      var _this642;

      _classCallCheck2(this, IfcAngularDimension);

      _this642 = _super650.call(this, expressID, Contents);
      _this642.Contents = Contents;
      _this642.type = 2470393545;
      return _this642;
    }

    return IfcAngularDimension;
  }(IfcDimensionCurveDirectedCallout);

  IFC2X32.IfcAngularDimension = IfcAngularDimension;

  var IfcAsset = /*#__PURE__*/function (_IfcGroup6) {
    _inherits(IfcAsset, _IfcGroup6);

    var _super651 = _createSuper(IfcAsset);

    function IfcAsset(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, AssetID, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue) {
      var _this643;

      _classCallCheck2(this, IfcAsset);

      _this643 = _super651.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this643.GlobalId = GlobalId;
      _this643.OwnerHistory = OwnerHistory;
      _this643.Name = Name;
      _this643.Description = Description;
      _this643.ObjectType = ObjectType;
      _this643.AssetID = AssetID;
      _this643.OriginalValue = OriginalValue;
      _this643.CurrentValue = CurrentValue;
      _this643.TotalReplacementCost = TotalReplacementCost;
      _this643.Owner = Owner;
      _this643.User = User;
      _this643.ResponsiblePerson = ResponsiblePerson;
      _this643.IncorporationDate = IncorporationDate;
      _this643.DepreciatedValue = DepreciatedValue;
      _this643.type = 3460190687;
      return _this643;
    }

    return IfcAsset;
  }(IfcGroup);

  IFC2X32.IfcAsset = IfcAsset;

  var IfcBSplineCurve = /*#__PURE__*/function (_IfcBoundedCurve4) {
    _inherits(IfcBSplineCurve, _IfcBoundedCurve4);

    var _super652 = _createSuper(IfcBSplineCurve);

    function IfcBSplineCurve(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      var _this644;

      _classCallCheck2(this, IfcBSplineCurve);

      _this644 = _super652.call(this, expressID);
      _this644.Degree = Degree;
      _this644.ControlPointsList = ControlPointsList;
      _this644.CurveForm = CurveForm;
      _this644.ClosedCurve = ClosedCurve;
      _this644.SelfIntersect = SelfIntersect;
      _this644.type = 1967976161;
      return _this644;
    }

    return IfcBSplineCurve;
  }(IfcBoundedCurve);

  IFC2X32.IfcBSplineCurve = IfcBSplineCurve;

  var IfcBeamType = /*#__PURE__*/function (_IfcBuildingElementTy11) {
    _inherits(IfcBeamType, _IfcBuildingElementTy11);

    var _super653 = _createSuper(IfcBeamType);

    function IfcBeamType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this645;

      _classCallCheck2(this, IfcBeamType);

      _this645 = _super653.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this645.GlobalId = GlobalId;
      _this645.OwnerHistory = OwnerHistory;
      _this645.Name = Name;
      _this645.Description = Description;
      _this645.ApplicableOccurrence = ApplicableOccurrence;
      _this645.HasPropertySets = HasPropertySets;
      _this645.RepresentationMaps = RepresentationMaps;
      _this645.Tag = Tag;
      _this645.ElementType = ElementType;
      _this645.PredefinedType = PredefinedType;
      _this645.type = 819618141;
      return _this645;
    }

    return IfcBeamType;
  }(IfcBuildingElementType);

  IFC2X32.IfcBeamType = IfcBeamType;

  var IfcBezierCurve = /*#__PURE__*/function (_IfcBSplineCurve) {
    _inherits(IfcBezierCurve, _IfcBSplineCurve);

    var _super654 = _createSuper(IfcBezierCurve);

    function IfcBezierCurve(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      var _this646;

      _classCallCheck2(this, IfcBezierCurve);

      _this646 = _super654.call(this, expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      _this646.Degree = Degree;
      _this646.ControlPointsList = ControlPointsList;
      _this646.CurveForm = CurveForm;
      _this646.ClosedCurve = ClosedCurve;
      _this646.SelfIntersect = SelfIntersect;
      _this646.type = 1916977116;
      return _this646;
    }

    return IfcBezierCurve;
  }(IfcBSplineCurve);

  IFC2X32.IfcBezierCurve = IfcBezierCurve;

  var IfcBoilerType = /*#__PURE__*/function (_IfcEnergyConversionD11) {
    _inherits(IfcBoilerType, _IfcEnergyConversionD11);

    var _super655 = _createSuper(IfcBoilerType);

    function IfcBoilerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this647;

      _classCallCheck2(this, IfcBoilerType);

      _this647 = _super655.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this647.GlobalId = GlobalId;
      _this647.OwnerHistory = OwnerHistory;
      _this647.Name = Name;
      _this647.Description = Description;
      _this647.ApplicableOccurrence = ApplicableOccurrence;
      _this647.HasPropertySets = HasPropertySets;
      _this647.RepresentationMaps = RepresentationMaps;
      _this647.Tag = Tag;
      _this647.ElementType = ElementType;
      _this647.PredefinedType = PredefinedType;
      _this647.type = 231477066;
      return _this647;
    }

    return IfcBoilerType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcBoilerType = IfcBoilerType;

  var IfcBuildingElement = /*#__PURE__*/function (_IfcElement8) {
    _inherits(IfcBuildingElement, _IfcElement8);

    var _super656 = _createSuper(IfcBuildingElement);

    function IfcBuildingElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this648;

      _classCallCheck2(this, IfcBuildingElement);

      _this648 = _super656.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this648.GlobalId = GlobalId;
      _this648.OwnerHistory = OwnerHistory;
      _this648.Name = Name;
      _this648.Description = Description;
      _this648.ObjectType = ObjectType;
      _this648.ObjectPlacement = ObjectPlacement;
      _this648.Representation = Representation;
      _this648.Tag = Tag;
      _this648.type = 3299480353;
      return _this648;
    }

    return IfcBuildingElement;
  }(IfcElement);

  IFC2X32.IfcBuildingElement = IfcBuildingElement;

  var IfcBuildingElementComponent = /*#__PURE__*/function (_IfcBuildingElement) {
    _inherits(IfcBuildingElementComponent, _IfcBuildingElement);

    var _super657 = _createSuper(IfcBuildingElementComponent);

    function IfcBuildingElementComponent(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this649;

      _classCallCheck2(this, IfcBuildingElementComponent);

      _this649 = _super657.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this649.GlobalId = GlobalId;
      _this649.OwnerHistory = OwnerHistory;
      _this649.Name = Name;
      _this649.Description = Description;
      _this649.ObjectType = ObjectType;
      _this649.ObjectPlacement = ObjectPlacement;
      _this649.Representation = Representation;
      _this649.Tag = Tag;
      _this649.type = 52481810;
      return _this649;
    }

    return IfcBuildingElementComponent;
  }(IfcBuildingElement);

  IFC2X32.IfcBuildingElementComponent = IfcBuildingElementComponent;

  var IfcBuildingElementPart = /*#__PURE__*/function (_IfcBuildingElementCo) {
    _inherits(IfcBuildingElementPart, _IfcBuildingElementCo);

    var _super658 = _createSuper(IfcBuildingElementPart);

    function IfcBuildingElementPart(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this650;

      _classCallCheck2(this, IfcBuildingElementPart);

      _this650 = _super658.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this650.GlobalId = GlobalId;
      _this650.OwnerHistory = OwnerHistory;
      _this650.Name = Name;
      _this650.Description = Description;
      _this650.ObjectType = ObjectType;
      _this650.ObjectPlacement = ObjectPlacement;
      _this650.Representation = Representation;
      _this650.Tag = Tag;
      _this650.type = 2979338954;
      return _this650;
    }

    return IfcBuildingElementPart;
  }(IfcBuildingElementComponent);

  IFC2X32.IfcBuildingElementPart = IfcBuildingElementPart;

  var IfcBuildingElementProxy = /*#__PURE__*/function (_IfcBuildingElement2) {
    _inherits(IfcBuildingElementProxy, _IfcBuildingElement2);

    var _super659 = _createSuper(IfcBuildingElementProxy);

    function IfcBuildingElementProxy(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, CompositionType) {
      var _this651;

      _classCallCheck2(this, IfcBuildingElementProxy);

      _this651 = _super659.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this651.GlobalId = GlobalId;
      _this651.OwnerHistory = OwnerHistory;
      _this651.Name = Name;
      _this651.Description = Description;
      _this651.ObjectType = ObjectType;
      _this651.ObjectPlacement = ObjectPlacement;
      _this651.Representation = Representation;
      _this651.Tag = Tag;
      _this651.CompositionType = CompositionType;
      _this651.type = 1095909175;
      return _this651;
    }

    return IfcBuildingElementProxy;
  }(IfcBuildingElement);

  IFC2X32.IfcBuildingElementProxy = IfcBuildingElementProxy;

  var IfcBuildingElementProxyType = /*#__PURE__*/function (_IfcBuildingElementTy12) {
    _inherits(IfcBuildingElementProxyType, _IfcBuildingElementTy12);

    var _super660 = _createSuper(IfcBuildingElementProxyType);

    function IfcBuildingElementProxyType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this652;

      _classCallCheck2(this, IfcBuildingElementProxyType);

      _this652 = _super660.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this652.GlobalId = GlobalId;
      _this652.OwnerHistory = OwnerHistory;
      _this652.Name = Name;
      _this652.Description = Description;
      _this652.ApplicableOccurrence = ApplicableOccurrence;
      _this652.HasPropertySets = HasPropertySets;
      _this652.RepresentationMaps = RepresentationMaps;
      _this652.Tag = Tag;
      _this652.ElementType = ElementType;
      _this652.PredefinedType = PredefinedType;
      _this652.type = 1909888760;
      return _this652;
    }

    return IfcBuildingElementProxyType;
  }(IfcBuildingElementType);

  IFC2X32.IfcBuildingElementProxyType = IfcBuildingElementProxyType;

  var IfcCableCarrierFittingType = /*#__PURE__*/function (_IfcFlowFittingType3) {
    _inherits(IfcCableCarrierFittingType, _IfcFlowFittingType3);

    var _super661 = _createSuper(IfcCableCarrierFittingType);

    function IfcCableCarrierFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this653;

      _classCallCheck2(this, IfcCableCarrierFittingType);

      _this653 = _super661.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this653.GlobalId = GlobalId;
      _this653.OwnerHistory = OwnerHistory;
      _this653.Name = Name;
      _this653.Description = Description;
      _this653.ApplicableOccurrence = ApplicableOccurrence;
      _this653.HasPropertySets = HasPropertySets;
      _this653.RepresentationMaps = RepresentationMaps;
      _this653.Tag = Tag;
      _this653.ElementType = ElementType;
      _this653.PredefinedType = PredefinedType;
      _this653.type = 395041908;
      return _this653;
    }

    return IfcCableCarrierFittingType;
  }(IfcFlowFittingType);

  IFC2X32.IfcCableCarrierFittingType = IfcCableCarrierFittingType;

  var IfcCableCarrierSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType2) {
    _inherits(IfcCableCarrierSegmentType, _IfcFlowSegmentType2);

    var _super662 = _createSuper(IfcCableCarrierSegmentType);

    function IfcCableCarrierSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this654;

      _classCallCheck2(this, IfcCableCarrierSegmentType);

      _this654 = _super662.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this654.GlobalId = GlobalId;
      _this654.OwnerHistory = OwnerHistory;
      _this654.Name = Name;
      _this654.Description = Description;
      _this654.ApplicableOccurrence = ApplicableOccurrence;
      _this654.HasPropertySets = HasPropertySets;
      _this654.RepresentationMaps = RepresentationMaps;
      _this654.Tag = Tag;
      _this654.ElementType = ElementType;
      _this654.PredefinedType = PredefinedType;
      _this654.type = 3293546465;
      return _this654;
    }

    return IfcCableCarrierSegmentType;
  }(IfcFlowSegmentType);

  IFC2X32.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;

  var IfcCableSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType3) {
    _inherits(IfcCableSegmentType, _IfcFlowSegmentType3);

    var _super663 = _createSuper(IfcCableSegmentType);

    function IfcCableSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this655;

      _classCallCheck2(this, IfcCableSegmentType);

      _this655 = _super663.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this655.GlobalId = GlobalId;
      _this655.OwnerHistory = OwnerHistory;
      _this655.Name = Name;
      _this655.Description = Description;
      _this655.ApplicableOccurrence = ApplicableOccurrence;
      _this655.HasPropertySets = HasPropertySets;
      _this655.RepresentationMaps = RepresentationMaps;
      _this655.Tag = Tag;
      _this655.ElementType = ElementType;
      _this655.PredefinedType = PredefinedType;
      _this655.type = 1285652485;
      return _this655;
    }

    return IfcCableSegmentType;
  }(IfcFlowSegmentType);

  IFC2X32.IfcCableSegmentType = IfcCableSegmentType;

  var IfcChillerType = /*#__PURE__*/function (_IfcEnergyConversionD12) {
    _inherits(IfcChillerType, _IfcEnergyConversionD12);

    var _super664 = _createSuper(IfcChillerType);

    function IfcChillerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this656;

      _classCallCheck2(this, IfcChillerType);

      _this656 = _super664.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this656.GlobalId = GlobalId;
      _this656.OwnerHistory = OwnerHistory;
      _this656.Name = Name;
      _this656.Description = Description;
      _this656.ApplicableOccurrence = ApplicableOccurrence;
      _this656.HasPropertySets = HasPropertySets;
      _this656.RepresentationMaps = RepresentationMaps;
      _this656.Tag = Tag;
      _this656.ElementType = ElementType;
      _this656.PredefinedType = PredefinedType;
      _this656.type = 2951183804;
      return _this656;
    }

    return IfcChillerType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcChillerType = IfcChillerType;

  var IfcCircle = /*#__PURE__*/function (_IfcConic2) {
    _inherits(IfcCircle, _IfcConic2);

    var _super665 = _createSuper(IfcCircle);

    function IfcCircle(expressID, Position, Radius) {
      var _this657;

      _classCallCheck2(this, IfcCircle);

      _this657 = _super665.call(this, expressID, Position);
      _this657.Position = Position;
      _this657.Radius = Radius;
      _this657.type = 2611217952;
      return _this657;
    }

    return IfcCircle;
  }(IfcConic);

  IFC2X32.IfcCircle = IfcCircle;

  var IfcCoilType = /*#__PURE__*/function (_IfcEnergyConversionD13) {
    _inherits(IfcCoilType, _IfcEnergyConversionD13);

    var _super666 = _createSuper(IfcCoilType);

    function IfcCoilType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this658;

      _classCallCheck2(this, IfcCoilType);

      _this658 = _super666.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this658.GlobalId = GlobalId;
      _this658.OwnerHistory = OwnerHistory;
      _this658.Name = Name;
      _this658.Description = Description;
      _this658.ApplicableOccurrence = ApplicableOccurrence;
      _this658.HasPropertySets = HasPropertySets;
      _this658.RepresentationMaps = RepresentationMaps;
      _this658.Tag = Tag;
      _this658.ElementType = ElementType;
      _this658.PredefinedType = PredefinedType;
      _this658.type = 2301859152;
      return _this658;
    }

    return IfcCoilType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcCoilType = IfcCoilType;

  var IfcColumn = /*#__PURE__*/function (_IfcBuildingElement3) {
    _inherits(IfcColumn, _IfcBuildingElement3);

    var _super667 = _createSuper(IfcColumn);

    function IfcColumn(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this659;

      _classCallCheck2(this, IfcColumn);

      _this659 = _super667.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this659.GlobalId = GlobalId;
      _this659.OwnerHistory = OwnerHistory;
      _this659.Name = Name;
      _this659.Description = Description;
      _this659.ObjectType = ObjectType;
      _this659.ObjectPlacement = ObjectPlacement;
      _this659.Representation = Representation;
      _this659.Tag = Tag;
      _this659.type = 843113511;
      return _this659;
    }

    return IfcColumn;
  }(IfcBuildingElement);

  IFC2X32.IfcColumn = IfcColumn;

  var IfcCompressorType = /*#__PURE__*/function (_IfcFlowMovingDeviceT2) {
    _inherits(IfcCompressorType, _IfcFlowMovingDeviceT2);

    var _super668 = _createSuper(IfcCompressorType);

    function IfcCompressorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this660;

      _classCallCheck2(this, IfcCompressorType);

      _this660 = _super668.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this660.GlobalId = GlobalId;
      _this660.OwnerHistory = OwnerHistory;
      _this660.Name = Name;
      _this660.Description = Description;
      _this660.ApplicableOccurrence = ApplicableOccurrence;
      _this660.HasPropertySets = HasPropertySets;
      _this660.RepresentationMaps = RepresentationMaps;
      _this660.Tag = Tag;
      _this660.ElementType = ElementType;
      _this660.PredefinedType = PredefinedType;
      _this660.type = 3850581409;
      return _this660;
    }

    return IfcCompressorType;
  }(IfcFlowMovingDeviceType);

  IFC2X32.IfcCompressorType = IfcCompressorType;

  var IfcCondenserType = /*#__PURE__*/function (_IfcEnergyConversionD14) {
    _inherits(IfcCondenserType, _IfcEnergyConversionD14);

    var _super669 = _createSuper(IfcCondenserType);

    function IfcCondenserType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this661;

      _classCallCheck2(this, IfcCondenserType);

      _this661 = _super669.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this661.GlobalId = GlobalId;
      _this661.OwnerHistory = OwnerHistory;
      _this661.Name = Name;
      _this661.Description = Description;
      _this661.ApplicableOccurrence = ApplicableOccurrence;
      _this661.HasPropertySets = HasPropertySets;
      _this661.RepresentationMaps = RepresentationMaps;
      _this661.Tag = Tag;
      _this661.ElementType = ElementType;
      _this661.PredefinedType = PredefinedType;
      _this661.type = 2816379211;
      return _this661;
    }

    return IfcCondenserType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcCondenserType = IfcCondenserType;

  var IfcCondition = /*#__PURE__*/function (_IfcGroup7) {
    _inherits(IfcCondition, _IfcGroup7);

    var _super670 = _createSuper(IfcCondition);

    function IfcCondition(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this662;

      _classCallCheck2(this, IfcCondition);

      _this662 = _super670.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this662.GlobalId = GlobalId;
      _this662.OwnerHistory = OwnerHistory;
      _this662.Name = Name;
      _this662.Description = Description;
      _this662.ObjectType = ObjectType;
      _this662.type = 2188551683;
      return _this662;
    }

    return IfcCondition;
  }(IfcGroup);

  IFC2X32.IfcCondition = IfcCondition;

  var IfcConditionCriterion = /*#__PURE__*/function (_IfcControl15) {
    _inherits(IfcConditionCriterion, _IfcControl15);

    var _super671 = _createSuper(IfcConditionCriterion);

    function IfcConditionCriterion(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Criterion, CriterionDateTime) {
      var _this663;

      _classCallCheck2(this, IfcConditionCriterion);

      _this663 = _super671.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this663.GlobalId = GlobalId;
      _this663.OwnerHistory = OwnerHistory;
      _this663.Name = Name;
      _this663.Description = Description;
      _this663.ObjectType = ObjectType;
      _this663.Criterion = Criterion;
      _this663.CriterionDateTime = CriterionDateTime;
      _this663.type = 1163958913;
      return _this663;
    }

    return IfcConditionCriterion;
  }(IfcControl);

  IFC2X32.IfcConditionCriterion = IfcConditionCriterion;

  var IfcConstructionEquipmentResource = /*#__PURE__*/function (_IfcConstructionResou4) {
    _inherits(IfcConstructionEquipmentResource, _IfcConstructionResou4);

    var _super672 = _createSuper(IfcConstructionEquipmentResource);

    function IfcConstructionEquipmentResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      var _this664;

      _classCallCheck2(this, IfcConstructionEquipmentResource);

      _this664 = _super672.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      _this664.GlobalId = GlobalId;
      _this664.OwnerHistory = OwnerHistory;
      _this664.Name = Name;
      _this664.Description = Description;
      _this664.ObjectType = ObjectType;
      _this664.ResourceIdentifier = ResourceIdentifier;
      _this664.ResourceGroup = ResourceGroup;
      _this664.ResourceConsumption = ResourceConsumption;
      _this664.BaseQuantity = BaseQuantity;
      _this664.type = 3898045240;
      return _this664;
    }

    return IfcConstructionEquipmentResource;
  }(IfcConstructionResource);

  IFC2X32.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;

  var IfcConstructionMaterialResource = /*#__PURE__*/function (_IfcConstructionResou5) {
    _inherits(IfcConstructionMaterialResource, _IfcConstructionResou5);

    var _super673 = _createSuper(IfcConstructionMaterialResource);

    function IfcConstructionMaterialResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity, Suppliers, UsageRatio) {
      var _this665;

      _classCallCheck2(this, IfcConstructionMaterialResource);

      _this665 = _super673.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      _this665.GlobalId = GlobalId;
      _this665.OwnerHistory = OwnerHistory;
      _this665.Name = Name;
      _this665.Description = Description;
      _this665.ObjectType = ObjectType;
      _this665.ResourceIdentifier = ResourceIdentifier;
      _this665.ResourceGroup = ResourceGroup;
      _this665.ResourceConsumption = ResourceConsumption;
      _this665.BaseQuantity = BaseQuantity;
      _this665.Suppliers = Suppliers;
      _this665.UsageRatio = UsageRatio;
      _this665.type = 1060000209;
      return _this665;
    }

    return IfcConstructionMaterialResource;
  }(IfcConstructionResource);

  IFC2X32.IfcConstructionMaterialResource = IfcConstructionMaterialResource;

  var IfcConstructionProductResource = /*#__PURE__*/function (_IfcConstructionResou6) {
    _inherits(IfcConstructionProductResource, _IfcConstructionResou6);

    var _super674 = _createSuper(IfcConstructionProductResource);

    function IfcConstructionProductResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity) {
      var _this666;

      _classCallCheck2(this, IfcConstructionProductResource);

      _this666 = _super674.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ResourceIdentifier, ResourceGroup, ResourceConsumption, BaseQuantity);
      _this666.GlobalId = GlobalId;
      _this666.OwnerHistory = OwnerHistory;
      _this666.Name = Name;
      _this666.Description = Description;
      _this666.ObjectType = ObjectType;
      _this666.ResourceIdentifier = ResourceIdentifier;
      _this666.ResourceGroup = ResourceGroup;
      _this666.ResourceConsumption = ResourceConsumption;
      _this666.BaseQuantity = BaseQuantity;
      _this666.type = 488727124;
      return _this666;
    }

    return IfcConstructionProductResource;
  }(IfcConstructionResource);

  IFC2X32.IfcConstructionProductResource = IfcConstructionProductResource;

  var IfcCooledBeamType = /*#__PURE__*/function (_IfcEnergyConversionD15) {
    _inherits(IfcCooledBeamType, _IfcEnergyConversionD15);

    var _super675 = _createSuper(IfcCooledBeamType);

    function IfcCooledBeamType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this667;

      _classCallCheck2(this, IfcCooledBeamType);

      _this667 = _super675.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this667.GlobalId = GlobalId;
      _this667.OwnerHistory = OwnerHistory;
      _this667.Name = Name;
      _this667.Description = Description;
      _this667.ApplicableOccurrence = ApplicableOccurrence;
      _this667.HasPropertySets = HasPropertySets;
      _this667.RepresentationMaps = RepresentationMaps;
      _this667.Tag = Tag;
      _this667.ElementType = ElementType;
      _this667.PredefinedType = PredefinedType;
      _this667.type = 335055490;
      return _this667;
    }

    return IfcCooledBeamType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcCooledBeamType = IfcCooledBeamType;

  var IfcCoolingTowerType = /*#__PURE__*/function (_IfcEnergyConversionD16) {
    _inherits(IfcCoolingTowerType, _IfcEnergyConversionD16);

    var _super676 = _createSuper(IfcCoolingTowerType);

    function IfcCoolingTowerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this668;

      _classCallCheck2(this, IfcCoolingTowerType);

      _this668 = _super676.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this668.GlobalId = GlobalId;
      _this668.OwnerHistory = OwnerHistory;
      _this668.Name = Name;
      _this668.Description = Description;
      _this668.ApplicableOccurrence = ApplicableOccurrence;
      _this668.HasPropertySets = HasPropertySets;
      _this668.RepresentationMaps = RepresentationMaps;
      _this668.Tag = Tag;
      _this668.ElementType = ElementType;
      _this668.PredefinedType = PredefinedType;
      _this668.type = 2954562838;
      return _this668;
    }

    return IfcCoolingTowerType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcCoolingTowerType = IfcCoolingTowerType;

  var IfcCovering = /*#__PURE__*/function (_IfcBuildingElement4) {
    _inherits(IfcCovering, _IfcBuildingElement4);

    var _super677 = _createSuper(IfcCovering);

    function IfcCovering(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this669;

      _classCallCheck2(this, IfcCovering);

      _this669 = _super677.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this669.GlobalId = GlobalId;
      _this669.OwnerHistory = OwnerHistory;
      _this669.Name = Name;
      _this669.Description = Description;
      _this669.ObjectType = ObjectType;
      _this669.ObjectPlacement = ObjectPlacement;
      _this669.Representation = Representation;
      _this669.Tag = Tag;
      _this669.PredefinedType = PredefinedType;
      _this669.type = 1973544240;
      return _this669;
    }

    return IfcCovering;
  }(IfcBuildingElement);

  IFC2X32.IfcCovering = IfcCovering;

  var IfcCurtainWall = /*#__PURE__*/function (_IfcBuildingElement5) {
    _inherits(IfcCurtainWall, _IfcBuildingElement5);

    var _super678 = _createSuper(IfcCurtainWall);

    function IfcCurtainWall(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this670;

      _classCallCheck2(this, IfcCurtainWall);

      _this670 = _super678.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this670.GlobalId = GlobalId;
      _this670.OwnerHistory = OwnerHistory;
      _this670.Name = Name;
      _this670.Description = Description;
      _this670.ObjectType = ObjectType;
      _this670.ObjectPlacement = ObjectPlacement;
      _this670.Representation = Representation;
      _this670.Tag = Tag;
      _this670.type = 3495092785;
      return _this670;
    }

    return IfcCurtainWall;
  }(IfcBuildingElement);

  IFC2X32.IfcCurtainWall = IfcCurtainWall;

  var IfcDamperType = /*#__PURE__*/function (_IfcFlowControllerTyp6) {
    _inherits(IfcDamperType, _IfcFlowControllerTyp6);

    var _super679 = _createSuper(IfcDamperType);

    function IfcDamperType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this671;

      _classCallCheck2(this, IfcDamperType);

      _this671 = _super679.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this671.GlobalId = GlobalId;
      _this671.OwnerHistory = OwnerHistory;
      _this671.Name = Name;
      _this671.Description = Description;
      _this671.ApplicableOccurrence = ApplicableOccurrence;
      _this671.HasPropertySets = HasPropertySets;
      _this671.RepresentationMaps = RepresentationMaps;
      _this671.Tag = Tag;
      _this671.ElementType = ElementType;
      _this671.PredefinedType = PredefinedType;
      _this671.type = 3961806047;
      return _this671;
    }

    return IfcDamperType;
  }(IfcFlowControllerType);

  IFC2X32.IfcDamperType = IfcDamperType;

  var IfcDiameterDimension = /*#__PURE__*/function (_IfcDimensionCurveDir4) {
    _inherits(IfcDiameterDimension, _IfcDimensionCurveDir4);

    var _super680 = _createSuper(IfcDiameterDimension);

    function IfcDiameterDimension(expressID, Contents) {
      var _this672;

      _classCallCheck2(this, IfcDiameterDimension);

      _this672 = _super680.call(this, expressID, Contents);
      _this672.Contents = Contents;
      _this672.type = 4147604152;
      return _this672;
    }

    return IfcDiameterDimension;
  }(IfcDimensionCurveDirectedCallout);

  IFC2X32.IfcDiameterDimension = IfcDiameterDimension;

  var IfcDiscreteAccessory = /*#__PURE__*/function (_IfcElementComponent2) {
    _inherits(IfcDiscreteAccessory, _IfcElementComponent2);

    var _super681 = _createSuper(IfcDiscreteAccessory);

    function IfcDiscreteAccessory(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this673;

      _classCallCheck2(this, IfcDiscreteAccessory);

      _this673 = _super681.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this673.GlobalId = GlobalId;
      _this673.OwnerHistory = OwnerHistory;
      _this673.Name = Name;
      _this673.Description = Description;
      _this673.ObjectType = ObjectType;
      _this673.ObjectPlacement = ObjectPlacement;
      _this673.Representation = Representation;
      _this673.Tag = Tag;
      _this673.type = 1335981549;
      return _this673;
    }

    return IfcDiscreteAccessory;
  }(IfcElementComponent);

  IFC2X32.IfcDiscreteAccessory = IfcDiscreteAccessory;

  var IfcDiscreteAccessoryType = /*#__PURE__*/function (_IfcElementComponentT2) {
    _inherits(IfcDiscreteAccessoryType, _IfcElementComponentT2);

    var _super682 = _createSuper(IfcDiscreteAccessoryType);

    function IfcDiscreteAccessoryType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this674;

      _classCallCheck2(this, IfcDiscreteAccessoryType);

      _this674 = _super682.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this674.GlobalId = GlobalId;
      _this674.OwnerHistory = OwnerHistory;
      _this674.Name = Name;
      _this674.Description = Description;
      _this674.ApplicableOccurrence = ApplicableOccurrence;
      _this674.HasPropertySets = HasPropertySets;
      _this674.RepresentationMaps = RepresentationMaps;
      _this674.Tag = Tag;
      _this674.ElementType = ElementType;
      _this674.type = 2635815018;
      return _this674;
    }

    return IfcDiscreteAccessoryType;
  }(IfcElementComponentType);

  IFC2X32.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;

  var IfcDistributionChamberElementType = /*#__PURE__*/function (_IfcDistributionFlowE9) {
    _inherits(IfcDistributionChamberElementType, _IfcDistributionFlowE9);

    var _super683 = _createSuper(IfcDistributionChamberElementType);

    function IfcDistributionChamberElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this675;

      _classCallCheck2(this, IfcDistributionChamberElementType);

      _this675 = _super683.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this675.GlobalId = GlobalId;
      _this675.OwnerHistory = OwnerHistory;
      _this675.Name = Name;
      _this675.Description = Description;
      _this675.ApplicableOccurrence = ApplicableOccurrence;
      _this675.HasPropertySets = HasPropertySets;
      _this675.RepresentationMaps = RepresentationMaps;
      _this675.Tag = Tag;
      _this675.ElementType = ElementType;
      _this675.PredefinedType = PredefinedType;
      _this675.type = 1599208980;
      return _this675;
    }

    return IfcDistributionChamberElementType;
  }(IfcDistributionFlowElementType);

  IFC2X32.IfcDistributionChamberElementType = IfcDistributionChamberElementType;

  var IfcDistributionControlElementType = /*#__PURE__*/function (_IfcDistributionEleme2) {
    _inherits(IfcDistributionControlElementType, _IfcDistributionEleme2);

    var _super684 = _createSuper(IfcDistributionControlElementType);

    function IfcDistributionControlElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this676;

      _classCallCheck2(this, IfcDistributionControlElementType);

      _this676 = _super684.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this676.GlobalId = GlobalId;
      _this676.OwnerHistory = OwnerHistory;
      _this676.Name = Name;
      _this676.Description = Description;
      _this676.ApplicableOccurrence = ApplicableOccurrence;
      _this676.HasPropertySets = HasPropertySets;
      _this676.RepresentationMaps = RepresentationMaps;
      _this676.Tag = Tag;
      _this676.ElementType = ElementType;
      _this676.type = 2063403501;
      return _this676;
    }

    return IfcDistributionControlElementType;
  }(IfcDistributionElementType);

  IFC2X32.IfcDistributionControlElementType = IfcDistributionControlElementType;

  var IfcDistributionElement = /*#__PURE__*/function (_IfcElement9) {
    _inherits(IfcDistributionElement, _IfcElement9);

    var _super685 = _createSuper(IfcDistributionElement);

    function IfcDistributionElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this677;

      _classCallCheck2(this, IfcDistributionElement);

      _this677 = _super685.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this677.GlobalId = GlobalId;
      _this677.OwnerHistory = OwnerHistory;
      _this677.Name = Name;
      _this677.Description = Description;
      _this677.ObjectType = ObjectType;
      _this677.ObjectPlacement = ObjectPlacement;
      _this677.Representation = Representation;
      _this677.Tag = Tag;
      _this677.type = 1945004755;
      return _this677;
    }

    return IfcDistributionElement;
  }(IfcElement);

  IFC2X32.IfcDistributionElement = IfcDistributionElement;

  var IfcDistributionFlowElement = /*#__PURE__*/function (_IfcDistributionEleme3) {
    _inherits(IfcDistributionFlowElement, _IfcDistributionEleme3);

    var _super686 = _createSuper(IfcDistributionFlowElement);

    function IfcDistributionFlowElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this678;

      _classCallCheck2(this, IfcDistributionFlowElement);

      _this678 = _super686.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this678.GlobalId = GlobalId;
      _this678.OwnerHistory = OwnerHistory;
      _this678.Name = Name;
      _this678.Description = Description;
      _this678.ObjectType = ObjectType;
      _this678.ObjectPlacement = ObjectPlacement;
      _this678.Representation = Representation;
      _this678.Tag = Tag;
      _this678.type = 3040386961;
      return _this678;
    }

    return IfcDistributionFlowElement;
  }(IfcDistributionElement);

  IFC2X32.IfcDistributionFlowElement = IfcDistributionFlowElement;

  var IfcDistributionPort = /*#__PURE__*/function (_IfcPort) {
    _inherits(IfcDistributionPort, _IfcPort);

    var _super687 = _createSuper(IfcDistributionPort);

    function IfcDistributionPort(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection) {
      var _this679;

      _classCallCheck2(this, IfcDistributionPort);

      _this679 = _super687.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this679.GlobalId = GlobalId;
      _this679.OwnerHistory = OwnerHistory;
      _this679.Name = Name;
      _this679.Description = Description;
      _this679.ObjectType = ObjectType;
      _this679.ObjectPlacement = ObjectPlacement;
      _this679.Representation = Representation;
      _this679.FlowDirection = FlowDirection;
      _this679.type = 3041715199;
      return _this679;
    }

    return IfcDistributionPort;
  }(IfcPort);

  IFC2X32.IfcDistributionPort = IfcDistributionPort;

  var IfcDoor = /*#__PURE__*/function (_IfcBuildingElement6) {
    _inherits(IfcDoor, _IfcBuildingElement6);

    var _super688 = _createSuper(IfcDoor);

    function IfcDoor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth) {
      var _this680;

      _classCallCheck2(this, IfcDoor);

      _this680 = _super688.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this680.GlobalId = GlobalId;
      _this680.OwnerHistory = OwnerHistory;
      _this680.Name = Name;
      _this680.Description = Description;
      _this680.ObjectType = ObjectType;
      _this680.ObjectPlacement = ObjectPlacement;
      _this680.Representation = Representation;
      _this680.Tag = Tag;
      _this680.OverallHeight = OverallHeight;
      _this680.OverallWidth = OverallWidth;
      _this680.type = 395920057;
      return _this680;
    }

    return IfcDoor;
  }(IfcBuildingElement);

  IFC2X32.IfcDoor = IfcDoor;

  var IfcDuctFittingType = /*#__PURE__*/function (_IfcFlowFittingType4) {
    _inherits(IfcDuctFittingType, _IfcFlowFittingType4);

    var _super689 = _createSuper(IfcDuctFittingType);

    function IfcDuctFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this681;

      _classCallCheck2(this, IfcDuctFittingType);

      _this681 = _super689.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this681.GlobalId = GlobalId;
      _this681.OwnerHistory = OwnerHistory;
      _this681.Name = Name;
      _this681.Description = Description;
      _this681.ApplicableOccurrence = ApplicableOccurrence;
      _this681.HasPropertySets = HasPropertySets;
      _this681.RepresentationMaps = RepresentationMaps;
      _this681.Tag = Tag;
      _this681.ElementType = ElementType;
      _this681.PredefinedType = PredefinedType;
      _this681.type = 869906466;
      return _this681;
    }

    return IfcDuctFittingType;
  }(IfcFlowFittingType);

  IFC2X32.IfcDuctFittingType = IfcDuctFittingType;

  var IfcDuctSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType4) {
    _inherits(IfcDuctSegmentType, _IfcFlowSegmentType4);

    var _super690 = _createSuper(IfcDuctSegmentType);

    function IfcDuctSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this682;

      _classCallCheck2(this, IfcDuctSegmentType);

      _this682 = _super690.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this682.GlobalId = GlobalId;
      _this682.OwnerHistory = OwnerHistory;
      _this682.Name = Name;
      _this682.Description = Description;
      _this682.ApplicableOccurrence = ApplicableOccurrence;
      _this682.HasPropertySets = HasPropertySets;
      _this682.RepresentationMaps = RepresentationMaps;
      _this682.Tag = Tag;
      _this682.ElementType = ElementType;
      _this682.PredefinedType = PredefinedType;
      _this682.type = 3760055223;
      return _this682;
    }

    return IfcDuctSegmentType;
  }(IfcFlowSegmentType);

  IFC2X32.IfcDuctSegmentType = IfcDuctSegmentType;

  var IfcDuctSilencerType = /*#__PURE__*/function (_IfcFlowTreatmentDevi) {
    _inherits(IfcDuctSilencerType, _IfcFlowTreatmentDevi);

    var _super691 = _createSuper(IfcDuctSilencerType);

    function IfcDuctSilencerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this683;

      _classCallCheck2(this, IfcDuctSilencerType);

      _this683 = _super691.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this683.GlobalId = GlobalId;
      _this683.OwnerHistory = OwnerHistory;
      _this683.Name = Name;
      _this683.Description = Description;
      _this683.ApplicableOccurrence = ApplicableOccurrence;
      _this683.HasPropertySets = HasPropertySets;
      _this683.RepresentationMaps = RepresentationMaps;
      _this683.Tag = Tag;
      _this683.ElementType = ElementType;
      _this683.PredefinedType = PredefinedType;
      _this683.type = 2030761528;
      return _this683;
    }

    return IfcDuctSilencerType;
  }(IfcFlowTreatmentDeviceType);

  IFC2X32.IfcDuctSilencerType = IfcDuctSilencerType;

  var IfcEdgeFeature = /*#__PURE__*/function (_IfcFeatureElementSub2) {
    _inherits(IfcEdgeFeature, _IfcFeatureElementSub2);

    var _super692 = _createSuper(IfcEdgeFeature);

    function IfcEdgeFeature(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength) {
      var _this684;

      _classCallCheck2(this, IfcEdgeFeature);

      _this684 = _super692.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this684.GlobalId = GlobalId;
      _this684.OwnerHistory = OwnerHistory;
      _this684.Name = Name;
      _this684.Description = Description;
      _this684.ObjectType = ObjectType;
      _this684.ObjectPlacement = ObjectPlacement;
      _this684.Representation = Representation;
      _this684.Tag = Tag;
      _this684.FeatureLength = FeatureLength;
      _this684.type = 855621170;
      return _this684;
    }

    return IfcEdgeFeature;
  }(IfcFeatureElementSubtraction);

  IFC2X32.IfcEdgeFeature = IfcEdgeFeature;

  var IfcElectricApplianceType = /*#__PURE__*/function (_IfcFlowTerminalType9) {
    _inherits(IfcElectricApplianceType, _IfcFlowTerminalType9);

    var _super693 = _createSuper(IfcElectricApplianceType);

    function IfcElectricApplianceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this685;

      _classCallCheck2(this, IfcElectricApplianceType);

      _this685 = _super693.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this685.GlobalId = GlobalId;
      _this685.OwnerHistory = OwnerHistory;
      _this685.Name = Name;
      _this685.Description = Description;
      _this685.ApplicableOccurrence = ApplicableOccurrence;
      _this685.HasPropertySets = HasPropertySets;
      _this685.RepresentationMaps = RepresentationMaps;
      _this685.Tag = Tag;
      _this685.ElementType = ElementType;
      _this685.PredefinedType = PredefinedType;
      _this685.type = 663422040;
      return _this685;
    }

    return IfcElectricApplianceType;
  }(IfcFlowTerminalType);

  IFC2X32.IfcElectricApplianceType = IfcElectricApplianceType;

  var IfcElectricFlowStorageDeviceType = /*#__PURE__*/function (_IfcFlowStorageDevice2) {
    _inherits(IfcElectricFlowStorageDeviceType, _IfcFlowStorageDevice2);

    var _super694 = _createSuper(IfcElectricFlowStorageDeviceType);

    function IfcElectricFlowStorageDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this686;

      _classCallCheck2(this, IfcElectricFlowStorageDeviceType);

      _this686 = _super694.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this686.GlobalId = GlobalId;
      _this686.OwnerHistory = OwnerHistory;
      _this686.Name = Name;
      _this686.Description = Description;
      _this686.ApplicableOccurrence = ApplicableOccurrence;
      _this686.HasPropertySets = HasPropertySets;
      _this686.RepresentationMaps = RepresentationMaps;
      _this686.Tag = Tag;
      _this686.ElementType = ElementType;
      _this686.PredefinedType = PredefinedType;
      _this686.type = 3277789161;
      return _this686;
    }

    return IfcElectricFlowStorageDeviceType;
  }(IfcFlowStorageDeviceType);

  IFC2X32.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;

  var IfcElectricGeneratorType = /*#__PURE__*/function (_IfcEnergyConversionD17) {
    _inherits(IfcElectricGeneratorType, _IfcEnergyConversionD17);

    var _super695 = _createSuper(IfcElectricGeneratorType);

    function IfcElectricGeneratorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this687;

      _classCallCheck2(this, IfcElectricGeneratorType);

      _this687 = _super695.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this687.GlobalId = GlobalId;
      _this687.OwnerHistory = OwnerHistory;
      _this687.Name = Name;
      _this687.Description = Description;
      _this687.ApplicableOccurrence = ApplicableOccurrence;
      _this687.HasPropertySets = HasPropertySets;
      _this687.RepresentationMaps = RepresentationMaps;
      _this687.Tag = Tag;
      _this687.ElementType = ElementType;
      _this687.PredefinedType = PredefinedType;
      _this687.type = 1534661035;
      return _this687;
    }

    return IfcElectricGeneratorType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcElectricGeneratorType = IfcElectricGeneratorType;

  var IfcElectricHeaterType = /*#__PURE__*/function (_IfcFlowTerminalType10) {
    _inherits(IfcElectricHeaterType, _IfcFlowTerminalType10);

    var _super696 = _createSuper(IfcElectricHeaterType);

    function IfcElectricHeaterType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this688;

      _classCallCheck2(this, IfcElectricHeaterType);

      _this688 = _super696.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this688.GlobalId = GlobalId;
      _this688.OwnerHistory = OwnerHistory;
      _this688.Name = Name;
      _this688.Description = Description;
      _this688.ApplicableOccurrence = ApplicableOccurrence;
      _this688.HasPropertySets = HasPropertySets;
      _this688.RepresentationMaps = RepresentationMaps;
      _this688.Tag = Tag;
      _this688.ElementType = ElementType;
      _this688.PredefinedType = PredefinedType;
      _this688.type = 1365060375;
      return _this688;
    }

    return IfcElectricHeaterType;
  }(IfcFlowTerminalType);

  IFC2X32.IfcElectricHeaterType = IfcElectricHeaterType;

  var IfcElectricMotorType = /*#__PURE__*/function (_IfcEnergyConversionD18) {
    _inherits(IfcElectricMotorType, _IfcEnergyConversionD18);

    var _super697 = _createSuper(IfcElectricMotorType);

    function IfcElectricMotorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this689;

      _classCallCheck2(this, IfcElectricMotorType);

      _this689 = _super697.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this689.GlobalId = GlobalId;
      _this689.OwnerHistory = OwnerHistory;
      _this689.Name = Name;
      _this689.Description = Description;
      _this689.ApplicableOccurrence = ApplicableOccurrence;
      _this689.HasPropertySets = HasPropertySets;
      _this689.RepresentationMaps = RepresentationMaps;
      _this689.Tag = Tag;
      _this689.ElementType = ElementType;
      _this689.PredefinedType = PredefinedType;
      _this689.type = 1217240411;
      return _this689;
    }

    return IfcElectricMotorType;
  }(IfcEnergyConversionDeviceType);

  IFC2X32.IfcElectricMotorType = IfcElectricMotorType;

  var IfcElectricTimeControlType = /*#__PURE__*/function (_IfcFlowControllerTyp7) {
    _inherits(IfcElectricTimeControlType, _IfcFlowControllerTyp7);

    var _super698 = _createSuper(IfcElectricTimeControlType);

    function IfcElectricTimeControlType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this690;

      _classCallCheck2(this, IfcElectricTimeControlType);

      _this690 = _super698.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this690.GlobalId = GlobalId;
      _this690.OwnerHistory = OwnerHistory;
      _this690.Name = Name;
      _this690.Description = Description;
      _this690.ApplicableOccurrence = ApplicableOccurrence;
      _this690.HasPropertySets = HasPropertySets;
      _this690.RepresentationMaps = RepresentationMaps;
      _this690.Tag = Tag;
      _this690.ElementType = ElementType;
      _this690.PredefinedType = PredefinedType;
      _this690.type = 712377611;
      return _this690;
    }

    return IfcElectricTimeControlType;
  }(IfcFlowControllerType);

  IFC2X32.IfcElectricTimeControlType = IfcElectricTimeControlType;

  var IfcElectricalCircuit = /*#__PURE__*/function (_IfcSystem) {
    _inherits(IfcElectricalCircuit, _IfcSystem);

    var _super699 = _createSuper(IfcElectricalCircuit);

    function IfcElectricalCircuit(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this691;

      _classCallCheck2(this, IfcElectricalCircuit);

      _this691 = _super699.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this691.GlobalId = GlobalId;
      _this691.OwnerHistory = OwnerHistory;
      _this691.Name = Name;
      _this691.Description = Description;
      _this691.ObjectType = ObjectType;
      _this691.type = 1634875225;
      return _this691;
    }

    return IfcElectricalCircuit;
  }(IfcSystem);

  IFC2X32.IfcElectricalCircuit = IfcElectricalCircuit;

  var IfcElectricalElement = /*#__PURE__*/function (_IfcElement10) {
    _inherits(IfcElectricalElement, _IfcElement10);

    var _super700 = _createSuper(IfcElectricalElement);

    function IfcElectricalElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this692;

      _classCallCheck2(this, IfcElectricalElement);

      _this692 = _super700.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this692.GlobalId = GlobalId;
      _this692.OwnerHistory = OwnerHistory;
      _this692.Name = Name;
      _this692.Description = Description;
      _this692.ObjectType = ObjectType;
      _this692.ObjectPlacement = ObjectPlacement;
      _this692.Representation = Representation;
      _this692.Tag = Tag;
      _this692.type = 857184966;
      return _this692;
    }

    return IfcElectricalElement;
  }(IfcElement);

  IFC2X32.IfcElectricalElement = IfcElectricalElement;

  var IfcEnergyConversionDevice = /*#__PURE__*/function (_IfcDistributionFlowE10) {
    _inherits(IfcEnergyConversionDevice, _IfcDistributionFlowE10);

    var _super701 = _createSuper(IfcEnergyConversionDevice);

    function IfcEnergyConversionDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this693;

      _classCallCheck2(this, IfcEnergyConversionDevice);

      _this693 = _super701.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this693.GlobalId = GlobalId;
      _this693.OwnerHistory = OwnerHistory;
      _this693.Name = Name;
      _this693.Description = Description;
      _this693.ObjectType = ObjectType;
      _this693.ObjectPlacement = ObjectPlacement;
      _this693.Representation = Representation;
      _this693.Tag = Tag;
      _this693.type = 1658829314;
      return _this693;
    }

    return IfcEnergyConversionDevice;
  }(IfcDistributionFlowElement);

  IFC2X32.IfcEnergyConversionDevice = IfcEnergyConversionDevice;

  var IfcFanType = /*#__PURE__*/function (_IfcFlowMovingDeviceT3) {
    _inherits(IfcFanType, _IfcFlowMovingDeviceT3);

    var _super702 = _createSuper(IfcFanType);

    function IfcFanType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this694;

      _classCallCheck2(this, IfcFanType);

      _this694 = _super702.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this694.GlobalId = GlobalId;
      _this694.OwnerHistory = OwnerHistory;
      _this694.Name = Name;
      _this694.Description = Description;
      _this694.ApplicableOccurrence = ApplicableOccurrence;
      _this694.HasPropertySets = HasPropertySets;
      _this694.RepresentationMaps = RepresentationMaps;
      _this694.Tag = Tag;
      _this694.ElementType = ElementType;
      _this694.PredefinedType = PredefinedType;
      _this694.type = 346874300;
      return _this694;
    }

    return IfcFanType;
  }(IfcFlowMovingDeviceType);

  IFC2X32.IfcFanType = IfcFanType;

  var IfcFilterType = /*#__PURE__*/function (_IfcFlowTreatmentDevi2) {
    _inherits(IfcFilterType, _IfcFlowTreatmentDevi2);

    var _super703 = _createSuper(IfcFilterType);

    function IfcFilterType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this695;

      _classCallCheck2(this, IfcFilterType);

      _this695 = _super703.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this695.GlobalId = GlobalId;
      _this695.OwnerHistory = OwnerHistory;
      _this695.Name = Name;
      _this695.Description = Description;
      _this695.ApplicableOccurrence = ApplicableOccurrence;
      _this695.HasPropertySets = HasPropertySets;
      _this695.RepresentationMaps = RepresentationMaps;
      _this695.Tag = Tag;
      _this695.ElementType = ElementType;
      _this695.PredefinedType = PredefinedType;
      _this695.type = 1810631287;
      return _this695;
    }

    return IfcFilterType;
  }(IfcFlowTreatmentDeviceType);

  IFC2X32.IfcFilterType = IfcFilterType;

  var IfcFireSuppressionTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType11) {
    _inherits(IfcFireSuppressionTerminalType, _IfcFlowTerminalType11);

    var _super704 = _createSuper(IfcFireSuppressionTerminalType);

    function IfcFireSuppressionTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this696;

      _classCallCheck2(this, IfcFireSuppressionTerminalType);

      _this696 = _super704.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this696.GlobalId = GlobalId;
      _this696.OwnerHistory = OwnerHistory;
      _this696.Name = Name;
      _this696.Description = Description;
      _this696.ApplicableOccurrence = ApplicableOccurrence;
      _this696.HasPropertySets = HasPropertySets;
      _this696.RepresentationMaps = RepresentationMaps;
      _this696.Tag = Tag;
      _this696.ElementType = ElementType;
      _this696.PredefinedType = PredefinedType;
      _this696.type = 4222183408;
      return _this696;
    }

    return IfcFireSuppressionTerminalType;
  }(IfcFlowTerminalType);

  IFC2X32.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;

  var IfcFlowController = /*#__PURE__*/function (_IfcDistributionFlowE11) {
    _inherits(IfcFlowController, _IfcDistributionFlowE11);

    var _super705 = _createSuper(IfcFlowController);

    function IfcFlowController(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this697;

      _classCallCheck2(this, IfcFlowController);

      _this697 = _super705.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this697.GlobalId = GlobalId;
      _this697.OwnerHistory = OwnerHistory;
      _this697.Name = Name;
      _this697.Description = Description;
      _this697.ObjectType = ObjectType;
      _this697.ObjectPlacement = ObjectPlacement;
      _this697.Representation = Representation;
      _this697.Tag = Tag;
      _this697.type = 2058353004;
      return _this697;
    }

    return IfcFlowController;
  }(IfcDistributionFlowElement);

  IFC2X32.IfcFlowController = IfcFlowController;

  var IfcFlowFitting = /*#__PURE__*/function (_IfcDistributionFlowE12) {
    _inherits(IfcFlowFitting, _IfcDistributionFlowE12);

    var _super706 = _createSuper(IfcFlowFitting);

    function IfcFlowFitting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this698;

      _classCallCheck2(this, IfcFlowFitting);

      _this698 = _super706.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this698.GlobalId = GlobalId;
      _this698.OwnerHistory = OwnerHistory;
      _this698.Name = Name;
      _this698.Description = Description;
      _this698.ObjectType = ObjectType;
      _this698.ObjectPlacement = ObjectPlacement;
      _this698.Representation = Representation;
      _this698.Tag = Tag;
      _this698.type = 4278956645;
      return _this698;
    }

    return IfcFlowFitting;
  }(IfcDistributionFlowElement);

  IFC2X32.IfcFlowFitting = IfcFlowFitting;

  var IfcFlowInstrumentType = /*#__PURE__*/function (_IfcDistributionContr) {
    _inherits(IfcFlowInstrumentType, _IfcDistributionContr);

    var _super707 = _createSuper(IfcFlowInstrumentType);

    function IfcFlowInstrumentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this699;

      _classCallCheck2(this, IfcFlowInstrumentType);

      _this699 = _super707.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this699.GlobalId = GlobalId;
      _this699.OwnerHistory = OwnerHistory;
      _this699.Name = Name;
      _this699.Description = Description;
      _this699.ApplicableOccurrence = ApplicableOccurrence;
      _this699.HasPropertySets = HasPropertySets;
      _this699.RepresentationMaps = RepresentationMaps;
      _this699.Tag = Tag;
      _this699.ElementType = ElementType;
      _this699.PredefinedType = PredefinedType;
      _this699.type = 4037862832;
      return _this699;
    }

    return IfcFlowInstrumentType;
  }(IfcDistributionControlElementType);

  IFC2X32.IfcFlowInstrumentType = IfcFlowInstrumentType;

  var IfcFlowMovingDevice = /*#__PURE__*/function (_IfcDistributionFlowE13) {
    _inherits(IfcFlowMovingDevice, _IfcDistributionFlowE13);

    var _super708 = _createSuper(IfcFlowMovingDevice);

    function IfcFlowMovingDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this700;

      _classCallCheck2(this, IfcFlowMovingDevice);

      _this700 = _super708.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this700.GlobalId = GlobalId;
      _this700.OwnerHistory = OwnerHistory;
      _this700.Name = Name;
      _this700.Description = Description;
      _this700.ObjectType = ObjectType;
      _this700.ObjectPlacement = ObjectPlacement;
      _this700.Representation = Representation;
      _this700.Tag = Tag;
      _this700.type = 3132237377;
      return _this700;
    }

    return IfcFlowMovingDevice;
  }(IfcDistributionFlowElement);

  IFC2X32.IfcFlowMovingDevice = IfcFlowMovingDevice;

  var IfcFlowSegment = /*#__PURE__*/function (_IfcDistributionFlowE14) {
    _inherits(IfcFlowSegment, _IfcDistributionFlowE14);

    var _super709 = _createSuper(IfcFlowSegment);

    function IfcFlowSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this701;

      _classCallCheck2(this, IfcFlowSegment);

      _this701 = _super709.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this701.GlobalId = GlobalId;
      _this701.OwnerHistory = OwnerHistory;
      _this701.Name = Name;
      _this701.Description = Description;
      _this701.ObjectType = ObjectType;
      _this701.ObjectPlacement = ObjectPlacement;
      _this701.Representation = Representation;
      _this701.Tag = Tag;
      _this701.type = 987401354;
      return _this701;
    }

    return IfcFlowSegment;
  }(IfcDistributionFlowElement);

  IFC2X32.IfcFlowSegment = IfcFlowSegment;

  var IfcFlowStorageDevice = /*#__PURE__*/function (_IfcDistributionFlowE15) {
    _inherits(IfcFlowStorageDevice, _IfcDistributionFlowE15);

    var _super710 = _createSuper(IfcFlowStorageDevice);

    function IfcFlowStorageDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this702;

      _classCallCheck2(this, IfcFlowStorageDevice);

      _this702 = _super710.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this702.GlobalId = GlobalId;
      _this702.OwnerHistory = OwnerHistory;
      _this702.Name = Name;
      _this702.Description = Description;
      _this702.ObjectType = ObjectType;
      _this702.ObjectPlacement = ObjectPlacement;
      _this702.Representation = Representation;
      _this702.Tag = Tag;
      _this702.type = 707683696;
      return _this702;
    }

    return IfcFlowStorageDevice;
  }(IfcDistributionFlowElement);

  IFC2X32.IfcFlowStorageDevice = IfcFlowStorageDevice;

  var IfcFlowTerminal = /*#__PURE__*/function (_IfcDistributionFlowE16) {
    _inherits(IfcFlowTerminal, _IfcDistributionFlowE16);

    var _super711 = _createSuper(IfcFlowTerminal);

    function IfcFlowTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this703;

      _classCallCheck2(this, IfcFlowTerminal);

      _this703 = _super711.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this703.GlobalId = GlobalId;
      _this703.OwnerHistory = OwnerHistory;
      _this703.Name = Name;
      _this703.Description = Description;
      _this703.ObjectType = ObjectType;
      _this703.ObjectPlacement = ObjectPlacement;
      _this703.Representation = Representation;
      _this703.Tag = Tag;
      _this703.type = 2223149337;
      return _this703;
    }

    return IfcFlowTerminal;
  }(IfcDistributionFlowElement);

  IFC2X32.IfcFlowTerminal = IfcFlowTerminal;

  var IfcFlowTreatmentDevice = /*#__PURE__*/function (_IfcDistributionFlowE17) {
    _inherits(IfcFlowTreatmentDevice, _IfcDistributionFlowE17);

    var _super712 = _createSuper(IfcFlowTreatmentDevice);

    function IfcFlowTreatmentDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this704;

      _classCallCheck2(this, IfcFlowTreatmentDevice);

      _this704 = _super712.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this704.GlobalId = GlobalId;
      _this704.OwnerHistory = OwnerHistory;
      _this704.Name = Name;
      _this704.Description = Description;
      _this704.ObjectType = ObjectType;
      _this704.ObjectPlacement = ObjectPlacement;
      _this704.Representation = Representation;
      _this704.Tag = Tag;
      _this704.type = 3508470533;
      return _this704;
    }

    return IfcFlowTreatmentDevice;
  }(IfcDistributionFlowElement);

  IFC2X32.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;

  var IfcFooting = /*#__PURE__*/function (_IfcBuildingElement7) {
    _inherits(IfcFooting, _IfcBuildingElement7);

    var _super713 = _createSuper(IfcFooting);

    function IfcFooting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this705;

      _classCallCheck2(this, IfcFooting);

      _this705 = _super713.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this705.GlobalId = GlobalId;
      _this705.OwnerHistory = OwnerHistory;
      _this705.Name = Name;
      _this705.Description = Description;
      _this705.ObjectType = ObjectType;
      _this705.ObjectPlacement = ObjectPlacement;
      _this705.Representation = Representation;
      _this705.Tag = Tag;
      _this705.PredefinedType = PredefinedType;
      _this705.type = 900683007;
      return _this705;
    }

    return IfcFooting;
  }(IfcBuildingElement);

  IFC2X32.IfcFooting = IfcFooting;

  var IfcMember = /*#__PURE__*/function (_IfcBuildingElement8) {
    _inherits(IfcMember, _IfcBuildingElement8);

    var _super714 = _createSuper(IfcMember);

    function IfcMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this706;

      _classCallCheck2(this, IfcMember);

      _this706 = _super714.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this706.GlobalId = GlobalId;
      _this706.OwnerHistory = OwnerHistory;
      _this706.Name = Name;
      _this706.Description = Description;
      _this706.ObjectType = ObjectType;
      _this706.ObjectPlacement = ObjectPlacement;
      _this706.Representation = Representation;
      _this706.Tag = Tag;
      _this706.type = 1073191201;
      return _this706;
    }

    return IfcMember;
  }(IfcBuildingElement);

  IFC2X32.IfcMember = IfcMember;

  var IfcPile = /*#__PURE__*/function (_IfcBuildingElement9) {
    _inherits(IfcPile, _IfcBuildingElement9);

    var _super715 = _createSuper(IfcPile);

    function IfcPile(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType) {
      var _this707;

      _classCallCheck2(this, IfcPile);

      _this707 = _super715.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this707.GlobalId = GlobalId;
      _this707.OwnerHistory = OwnerHistory;
      _this707.Name = Name;
      _this707.Description = Description;
      _this707.ObjectType = ObjectType;
      _this707.ObjectPlacement = ObjectPlacement;
      _this707.Representation = Representation;
      _this707.Tag = Tag;
      _this707.PredefinedType = PredefinedType;
      _this707.ConstructionType = ConstructionType;
      _this707.type = 1687234759;
      return _this707;
    }

    return IfcPile;
  }(IfcBuildingElement);

  IFC2X32.IfcPile = IfcPile;

  var IfcPlate = /*#__PURE__*/function (_IfcBuildingElement10) {
    _inherits(IfcPlate, _IfcBuildingElement10);

    var _super716 = _createSuper(IfcPlate);

    function IfcPlate(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this708;

      _classCallCheck2(this, IfcPlate);

      _this708 = _super716.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this708.GlobalId = GlobalId;
      _this708.OwnerHistory = OwnerHistory;
      _this708.Name = Name;
      _this708.Description = Description;
      _this708.ObjectType = ObjectType;
      _this708.ObjectPlacement = ObjectPlacement;
      _this708.Representation = Representation;
      _this708.Tag = Tag;
      _this708.type = 3171933400;
      return _this708;
    }

    return IfcPlate;
  }(IfcBuildingElement);

  IFC2X32.IfcPlate = IfcPlate;

  var IfcRailing = /*#__PURE__*/function (_IfcBuildingElement11) {
    _inherits(IfcRailing, _IfcBuildingElement11);

    var _super717 = _createSuper(IfcRailing);

    function IfcRailing(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this709;

      _classCallCheck2(this, IfcRailing);

      _this709 = _super717.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this709.GlobalId = GlobalId;
      _this709.OwnerHistory = OwnerHistory;
      _this709.Name = Name;
      _this709.Description = Description;
      _this709.ObjectType = ObjectType;
      _this709.ObjectPlacement = ObjectPlacement;
      _this709.Representation = Representation;
      _this709.Tag = Tag;
      _this709.PredefinedType = PredefinedType;
      _this709.type = 2262370178;
      return _this709;
    }

    return IfcRailing;
  }(IfcBuildingElement);

  IFC2X32.IfcRailing = IfcRailing;

  var IfcRamp = /*#__PURE__*/function (_IfcBuildingElement12) {
    _inherits(IfcRamp, _IfcBuildingElement12);

    var _super718 = _createSuper(IfcRamp);

    function IfcRamp(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType) {
      var _this710;

      _classCallCheck2(this, IfcRamp);

      _this710 = _super718.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this710.GlobalId = GlobalId;
      _this710.OwnerHistory = OwnerHistory;
      _this710.Name = Name;
      _this710.Description = Description;
      _this710.ObjectType = ObjectType;
      _this710.ObjectPlacement = ObjectPlacement;
      _this710.Representation = Representation;
      _this710.Tag = Tag;
      _this710.ShapeType = ShapeType;
      _this710.type = 3024970846;
      return _this710;
    }

    return IfcRamp;
  }(IfcBuildingElement);

  IFC2X32.IfcRamp = IfcRamp;

  var IfcRampFlight = /*#__PURE__*/function (_IfcBuildingElement13) {
    _inherits(IfcRampFlight, _IfcBuildingElement13);

    var _super719 = _createSuper(IfcRampFlight);

    function IfcRampFlight(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this711;

      _classCallCheck2(this, IfcRampFlight);

      _this711 = _super719.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this711.GlobalId = GlobalId;
      _this711.OwnerHistory = OwnerHistory;
      _this711.Name = Name;
      _this711.Description = Description;
      _this711.ObjectType = ObjectType;
      _this711.ObjectPlacement = ObjectPlacement;
      _this711.Representation = Representation;
      _this711.Tag = Tag;
      _this711.type = 3283111854;
      return _this711;
    }

    return IfcRampFlight;
  }(IfcBuildingElement);

  IFC2X32.IfcRampFlight = IfcRampFlight;

  var IfcRationalBezierCurve = /*#__PURE__*/function (_IfcBezierCurve) {
    _inherits(IfcRationalBezierCurve, _IfcBezierCurve);

    var _super720 = _createSuper(IfcRationalBezierCurve);

    function IfcRationalBezierCurve(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, WeightsData) {
      var _this712;

      _classCallCheck2(this, IfcRationalBezierCurve);

      _this712 = _super720.call(this, expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      _this712.Degree = Degree;
      _this712.ControlPointsList = ControlPointsList;
      _this712.CurveForm = CurveForm;
      _this712.ClosedCurve = ClosedCurve;
      _this712.SelfIntersect = SelfIntersect;
      _this712.WeightsData = WeightsData;
      _this712.type = 3055160366;
      return _this712;
    }

    return IfcRationalBezierCurve;
  }(IfcBezierCurve);

  IFC2X32.IfcRationalBezierCurve = IfcRationalBezierCurve;

  var IfcReinforcingElement = /*#__PURE__*/function (_IfcBuildingElementCo2) {
    _inherits(IfcReinforcingElement, _IfcBuildingElementCo2);

    var _super721 = _createSuper(IfcReinforcingElement);

    function IfcReinforcingElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      var _this713;

      _classCallCheck2(this, IfcReinforcingElement);

      _this713 = _super721.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this713.GlobalId = GlobalId;
      _this713.OwnerHistory = OwnerHistory;
      _this713.Name = Name;
      _this713.Description = Description;
      _this713.ObjectType = ObjectType;
      _this713.ObjectPlacement = ObjectPlacement;
      _this713.Representation = Representation;
      _this713.Tag = Tag;
      _this713.SteelGrade = SteelGrade;
      _this713.type = 3027567501;
      return _this713;
    }

    return IfcReinforcingElement;
  }(IfcBuildingElementComponent);

  IFC2X32.IfcReinforcingElement = IfcReinforcingElement;

  var IfcReinforcingMesh = /*#__PURE__*/function (_IfcReinforcingElemen) {
    _inherits(IfcReinforcingMesh, _IfcReinforcingElemen);

    var _super722 = _createSuper(IfcReinforcingMesh);

    function IfcReinforcingMesh(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing) {
      var _this714;

      _classCallCheck2(this, IfcReinforcingMesh);

      _this714 = _super722.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this714.GlobalId = GlobalId;
      _this714.OwnerHistory = OwnerHistory;
      _this714.Name = Name;
      _this714.Description = Description;
      _this714.ObjectType = ObjectType;
      _this714.ObjectPlacement = ObjectPlacement;
      _this714.Representation = Representation;
      _this714.Tag = Tag;
      _this714.SteelGrade = SteelGrade;
      _this714.MeshLength = MeshLength;
      _this714.MeshWidth = MeshWidth;
      _this714.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      _this714.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      _this714.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      _this714.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      _this714.LongitudinalBarSpacing = LongitudinalBarSpacing;
      _this714.TransverseBarSpacing = TransverseBarSpacing;
      _this714.type = 2320036040;
      return _this714;
    }

    return IfcReinforcingMesh;
  }(IfcReinforcingElement);

  IFC2X32.IfcReinforcingMesh = IfcReinforcingMesh;

  var IfcRoof = /*#__PURE__*/function (_IfcBuildingElement14) {
    _inherits(IfcRoof, _IfcBuildingElement14);

    var _super723 = _createSuper(IfcRoof);

    function IfcRoof(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType) {
      var _this715;

      _classCallCheck2(this, IfcRoof);

      _this715 = _super723.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this715.GlobalId = GlobalId;
      _this715.OwnerHistory = OwnerHistory;
      _this715.Name = Name;
      _this715.Description = Description;
      _this715.ObjectType = ObjectType;
      _this715.ObjectPlacement = ObjectPlacement;
      _this715.Representation = Representation;
      _this715.Tag = Tag;
      _this715.ShapeType = ShapeType;
      _this715.type = 2016517767;
      return _this715;
    }

    return IfcRoof;
  }(IfcBuildingElement);

  IFC2X32.IfcRoof = IfcRoof;

  var IfcRoundedEdgeFeature = /*#__PURE__*/function (_IfcEdgeFeature) {
    _inherits(IfcRoundedEdgeFeature, _IfcEdgeFeature);

    var _super724 = _createSuper(IfcRoundedEdgeFeature);

    function IfcRoundedEdgeFeature(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength, Radius) {
      var _this716;

      _classCallCheck2(this, IfcRoundedEdgeFeature);

      _this716 = _super724.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength);
      _this716.GlobalId = GlobalId;
      _this716.OwnerHistory = OwnerHistory;
      _this716.Name = Name;
      _this716.Description = Description;
      _this716.ObjectType = ObjectType;
      _this716.ObjectPlacement = ObjectPlacement;
      _this716.Representation = Representation;
      _this716.Tag = Tag;
      _this716.FeatureLength = FeatureLength;
      _this716.Radius = Radius;
      _this716.type = 1376911519;
      return _this716;
    }

    return IfcRoundedEdgeFeature;
  }(IfcEdgeFeature);

  IFC2X32.IfcRoundedEdgeFeature = IfcRoundedEdgeFeature;

  var IfcSensorType = /*#__PURE__*/function (_IfcDistributionContr2) {
    _inherits(IfcSensorType, _IfcDistributionContr2);

    var _super725 = _createSuper(IfcSensorType);

    function IfcSensorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this717;

      _classCallCheck2(this, IfcSensorType);

      _this717 = _super725.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this717.GlobalId = GlobalId;
      _this717.OwnerHistory = OwnerHistory;
      _this717.Name = Name;
      _this717.Description = Description;
      _this717.ApplicableOccurrence = ApplicableOccurrence;
      _this717.HasPropertySets = HasPropertySets;
      _this717.RepresentationMaps = RepresentationMaps;
      _this717.Tag = Tag;
      _this717.ElementType = ElementType;
      _this717.PredefinedType = PredefinedType;
      _this717.type = 1783015770;
      return _this717;
    }

    return IfcSensorType;
  }(IfcDistributionControlElementType);

  IFC2X32.IfcSensorType = IfcSensorType;

  var IfcSlab = /*#__PURE__*/function (_IfcBuildingElement15) {
    _inherits(IfcSlab, _IfcBuildingElement15);

    var _super726 = _createSuper(IfcSlab);

    function IfcSlab(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this718;

      _classCallCheck2(this, IfcSlab);

      _this718 = _super726.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this718.GlobalId = GlobalId;
      _this718.OwnerHistory = OwnerHistory;
      _this718.Name = Name;
      _this718.Description = Description;
      _this718.ObjectType = ObjectType;
      _this718.ObjectPlacement = ObjectPlacement;
      _this718.Representation = Representation;
      _this718.Tag = Tag;
      _this718.PredefinedType = PredefinedType;
      _this718.type = 1529196076;
      return _this718;
    }

    return IfcSlab;
  }(IfcBuildingElement);

  IFC2X32.IfcSlab = IfcSlab;

  var IfcStair = /*#__PURE__*/function (_IfcBuildingElement16) {
    _inherits(IfcStair, _IfcBuildingElement16);

    var _super727 = _createSuper(IfcStair);

    function IfcStair(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ShapeType) {
      var _this719;

      _classCallCheck2(this, IfcStair);

      _this719 = _super727.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this719.GlobalId = GlobalId;
      _this719.OwnerHistory = OwnerHistory;
      _this719.Name = Name;
      _this719.Description = Description;
      _this719.ObjectType = ObjectType;
      _this719.ObjectPlacement = ObjectPlacement;
      _this719.Representation = Representation;
      _this719.Tag = Tag;
      _this719.ShapeType = ShapeType;
      _this719.type = 331165859;
      return _this719;
    }

    return IfcStair;
  }(IfcBuildingElement);

  IFC2X32.IfcStair = IfcStair;

  var IfcStairFlight = /*#__PURE__*/function (_IfcBuildingElement17) {
    _inherits(IfcStairFlight, _IfcBuildingElement17);

    var _super728 = _createSuper(IfcStairFlight);

    function IfcStairFlight(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRiser, NumberOfTreads, RiserHeight, TreadLength) {
      var _this720;

      _classCallCheck2(this, IfcStairFlight);

      _this720 = _super728.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this720.GlobalId = GlobalId;
      _this720.OwnerHistory = OwnerHistory;
      _this720.Name = Name;
      _this720.Description = Description;
      _this720.ObjectType = ObjectType;
      _this720.ObjectPlacement = ObjectPlacement;
      _this720.Representation = Representation;
      _this720.Tag = Tag;
      _this720.NumberOfRiser = NumberOfRiser;
      _this720.NumberOfTreads = NumberOfTreads;
      _this720.RiserHeight = RiserHeight;
      _this720.TreadLength = TreadLength;
      _this720.type = 4252922144;
      return _this720;
    }

    return IfcStairFlight;
  }(IfcBuildingElement);

  IFC2X32.IfcStairFlight = IfcStairFlight;

  var IfcStructuralAnalysisModel = /*#__PURE__*/function (_IfcSystem2) {
    _inherits(IfcStructuralAnalysisModel, _IfcSystem2);

    var _super729 = _createSuper(IfcStructuralAnalysisModel);

    function IfcStructuralAnalysisModel(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults) {
      var _this721;

      _classCallCheck2(this, IfcStructuralAnalysisModel);

      _this721 = _super729.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this721.GlobalId = GlobalId;
      _this721.OwnerHistory = OwnerHistory;
      _this721.Name = Name;
      _this721.Description = Description;
      _this721.ObjectType = ObjectType;
      _this721.PredefinedType = PredefinedType;
      _this721.OrientationOf2DPlane = OrientationOf2DPlane;
      _this721.LoadedBy = LoadedBy;
      _this721.HasResults = HasResults;
      _this721.type = 2515109513;
      return _this721;
    }

    return IfcStructuralAnalysisModel;
  }(IfcSystem);

  IFC2X32.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;

  var IfcTendon = /*#__PURE__*/function (_IfcReinforcingElemen2) {
    _inherits(IfcTendon, _IfcReinforcingElemen2);

    var _super730 = _createSuper(IfcTendon);

    function IfcTendon(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius) {
      var _this722;

      _classCallCheck2(this, IfcTendon);

      _this722 = _super730.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this722.GlobalId = GlobalId;
      _this722.OwnerHistory = OwnerHistory;
      _this722.Name = Name;
      _this722.Description = Description;
      _this722.ObjectType = ObjectType;
      _this722.ObjectPlacement = ObjectPlacement;
      _this722.Representation = Representation;
      _this722.Tag = Tag;
      _this722.SteelGrade = SteelGrade;
      _this722.PredefinedType = PredefinedType;
      _this722.NominalDiameter = NominalDiameter;
      _this722.CrossSectionArea = CrossSectionArea;
      _this722.TensionForce = TensionForce;
      _this722.PreStress = PreStress;
      _this722.FrictionCoefficient = FrictionCoefficient;
      _this722.AnchorageSlip = AnchorageSlip;
      _this722.MinCurvatureRadius = MinCurvatureRadius;
      _this722.type = 3824725483;
      return _this722;
    }

    return IfcTendon;
  }(IfcReinforcingElement);

  IFC2X32.IfcTendon = IfcTendon;

  var IfcTendonAnchor = /*#__PURE__*/function (_IfcReinforcingElemen3) {
    _inherits(IfcTendonAnchor, _IfcReinforcingElemen3);

    var _super731 = _createSuper(IfcTendonAnchor);

    function IfcTendonAnchor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      var _this723;

      _classCallCheck2(this, IfcTendonAnchor);

      _this723 = _super731.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this723.GlobalId = GlobalId;
      _this723.OwnerHistory = OwnerHistory;
      _this723.Name = Name;
      _this723.Description = Description;
      _this723.ObjectType = ObjectType;
      _this723.ObjectPlacement = ObjectPlacement;
      _this723.Representation = Representation;
      _this723.Tag = Tag;
      _this723.SteelGrade = SteelGrade;
      _this723.type = 2347447852;
      return _this723;
    }

    return IfcTendonAnchor;
  }(IfcReinforcingElement);

  IFC2X32.IfcTendonAnchor = IfcTendonAnchor;

  var IfcVibrationIsolatorType = /*#__PURE__*/function (_IfcDiscreteAccessory) {
    _inherits(IfcVibrationIsolatorType, _IfcDiscreteAccessory);

    var _super732 = _createSuper(IfcVibrationIsolatorType);

    function IfcVibrationIsolatorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this724;

      _classCallCheck2(this, IfcVibrationIsolatorType);

      _this724 = _super732.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this724.GlobalId = GlobalId;
      _this724.OwnerHistory = OwnerHistory;
      _this724.Name = Name;
      _this724.Description = Description;
      _this724.ApplicableOccurrence = ApplicableOccurrence;
      _this724.HasPropertySets = HasPropertySets;
      _this724.RepresentationMaps = RepresentationMaps;
      _this724.Tag = Tag;
      _this724.ElementType = ElementType;
      _this724.PredefinedType = PredefinedType;
      _this724.type = 3313531582;
      return _this724;
    }

    return IfcVibrationIsolatorType;
  }(IfcDiscreteAccessoryType);

  IFC2X32.IfcVibrationIsolatorType = IfcVibrationIsolatorType;

  var IfcWall = /*#__PURE__*/function (_IfcBuildingElement18) {
    _inherits(IfcWall, _IfcBuildingElement18);

    var _super733 = _createSuper(IfcWall);

    function IfcWall(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this725;

      _classCallCheck2(this, IfcWall);

      _this725 = _super733.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this725.GlobalId = GlobalId;
      _this725.OwnerHistory = OwnerHistory;
      _this725.Name = Name;
      _this725.Description = Description;
      _this725.ObjectType = ObjectType;
      _this725.ObjectPlacement = ObjectPlacement;
      _this725.Representation = Representation;
      _this725.Tag = Tag;
      _this725.type = 2391406946;
      return _this725;
    }

    return IfcWall;
  }(IfcBuildingElement);

  IFC2X32.IfcWall = IfcWall;

  var IfcWallStandardCase = /*#__PURE__*/function (_IfcWall) {
    _inherits(IfcWallStandardCase, _IfcWall);

    var _super734 = _createSuper(IfcWallStandardCase);

    function IfcWallStandardCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this726;

      _classCallCheck2(this, IfcWallStandardCase);

      _this726 = _super734.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this726.GlobalId = GlobalId;
      _this726.OwnerHistory = OwnerHistory;
      _this726.Name = Name;
      _this726.Description = Description;
      _this726.ObjectType = ObjectType;
      _this726.ObjectPlacement = ObjectPlacement;
      _this726.Representation = Representation;
      _this726.Tag = Tag;
      _this726.type = 3512223829;
      return _this726;
    }

    return IfcWallStandardCase;
  }(IfcWall);

  IFC2X32.IfcWallStandardCase = IfcWallStandardCase;

  var IfcWindow = /*#__PURE__*/function (_IfcBuildingElement19) {
    _inherits(IfcWindow, _IfcBuildingElement19);

    var _super735 = _createSuper(IfcWindow);

    function IfcWindow(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth) {
      var _this727;

      _classCallCheck2(this, IfcWindow);

      _this727 = _super735.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this727.GlobalId = GlobalId;
      _this727.OwnerHistory = OwnerHistory;
      _this727.Name = Name;
      _this727.Description = Description;
      _this727.ObjectType = ObjectType;
      _this727.ObjectPlacement = ObjectPlacement;
      _this727.Representation = Representation;
      _this727.Tag = Tag;
      _this727.OverallHeight = OverallHeight;
      _this727.OverallWidth = OverallWidth;
      _this727.type = 3304561284;
      return _this727;
    }

    return IfcWindow;
  }(IfcBuildingElement);

  IFC2X32.IfcWindow = IfcWindow;

  var IfcActuatorType = /*#__PURE__*/function (_IfcDistributionContr3) {
    _inherits(IfcActuatorType, _IfcDistributionContr3);

    var _super736 = _createSuper(IfcActuatorType);

    function IfcActuatorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this728;

      _classCallCheck2(this, IfcActuatorType);

      _this728 = _super736.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this728.GlobalId = GlobalId;
      _this728.OwnerHistory = OwnerHistory;
      _this728.Name = Name;
      _this728.Description = Description;
      _this728.ApplicableOccurrence = ApplicableOccurrence;
      _this728.HasPropertySets = HasPropertySets;
      _this728.RepresentationMaps = RepresentationMaps;
      _this728.Tag = Tag;
      _this728.ElementType = ElementType;
      _this728.PredefinedType = PredefinedType;
      _this728.type = 2874132201;
      return _this728;
    }

    return IfcActuatorType;
  }(IfcDistributionControlElementType);

  IFC2X32.IfcActuatorType = IfcActuatorType;

  var IfcAlarmType = /*#__PURE__*/function (_IfcDistributionContr4) {
    _inherits(IfcAlarmType, _IfcDistributionContr4);

    var _super737 = _createSuper(IfcAlarmType);

    function IfcAlarmType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this729;

      _classCallCheck2(this, IfcAlarmType);

      _this729 = _super737.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this729.GlobalId = GlobalId;
      _this729.OwnerHistory = OwnerHistory;
      _this729.Name = Name;
      _this729.Description = Description;
      _this729.ApplicableOccurrence = ApplicableOccurrence;
      _this729.HasPropertySets = HasPropertySets;
      _this729.RepresentationMaps = RepresentationMaps;
      _this729.Tag = Tag;
      _this729.ElementType = ElementType;
      _this729.PredefinedType = PredefinedType;
      _this729.type = 3001207471;
      return _this729;
    }

    return IfcAlarmType;
  }(IfcDistributionControlElementType);

  IFC2X32.IfcAlarmType = IfcAlarmType;

  var IfcBeam = /*#__PURE__*/function (_IfcBuildingElement20) {
    _inherits(IfcBeam, _IfcBuildingElement20);

    var _super738 = _createSuper(IfcBeam);

    function IfcBeam(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this730;

      _classCallCheck2(this, IfcBeam);

      _this730 = _super738.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this730.GlobalId = GlobalId;
      _this730.OwnerHistory = OwnerHistory;
      _this730.Name = Name;
      _this730.Description = Description;
      _this730.ObjectType = ObjectType;
      _this730.ObjectPlacement = ObjectPlacement;
      _this730.Representation = Representation;
      _this730.Tag = Tag;
      _this730.type = 753842376;
      return _this730;
    }

    return IfcBeam;
  }(IfcBuildingElement);

  IFC2X32.IfcBeam = IfcBeam;

  var IfcChamferEdgeFeature = /*#__PURE__*/function (_IfcEdgeFeature2) {
    _inherits(IfcChamferEdgeFeature, _IfcEdgeFeature2);

    var _super739 = _createSuper(IfcChamferEdgeFeature);

    function IfcChamferEdgeFeature(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength, Width, Height) {
      var _this731;

      _classCallCheck2(this, IfcChamferEdgeFeature);

      _this731 = _super739.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, FeatureLength);
      _this731.GlobalId = GlobalId;
      _this731.OwnerHistory = OwnerHistory;
      _this731.Name = Name;
      _this731.Description = Description;
      _this731.ObjectType = ObjectType;
      _this731.ObjectPlacement = ObjectPlacement;
      _this731.Representation = Representation;
      _this731.Tag = Tag;
      _this731.FeatureLength = FeatureLength;
      _this731.Width = Width;
      _this731.Height = Height;
      _this731.type = 2454782716;
      return _this731;
    }

    return IfcChamferEdgeFeature;
  }(IfcEdgeFeature);

  IFC2X32.IfcChamferEdgeFeature = IfcChamferEdgeFeature;

  var IfcControllerType = /*#__PURE__*/function (_IfcDistributionContr5) {
    _inherits(IfcControllerType, _IfcDistributionContr5);

    var _super740 = _createSuper(IfcControllerType);

    function IfcControllerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this732;

      _classCallCheck2(this, IfcControllerType);

      _this732 = _super740.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this732.GlobalId = GlobalId;
      _this732.OwnerHistory = OwnerHistory;
      _this732.Name = Name;
      _this732.Description = Description;
      _this732.ApplicableOccurrence = ApplicableOccurrence;
      _this732.HasPropertySets = HasPropertySets;
      _this732.RepresentationMaps = RepresentationMaps;
      _this732.Tag = Tag;
      _this732.ElementType = ElementType;
      _this732.PredefinedType = PredefinedType;
      _this732.type = 578613899;
      return _this732;
    }

    return IfcControllerType;
  }(IfcDistributionControlElementType);

  IFC2X32.IfcControllerType = IfcControllerType;

  var IfcDistributionChamberElement = /*#__PURE__*/function (_IfcDistributionFlowE18) {
    _inherits(IfcDistributionChamberElement, _IfcDistributionFlowE18);

    var _super741 = _createSuper(IfcDistributionChamberElement);

    function IfcDistributionChamberElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this733;

      _classCallCheck2(this, IfcDistributionChamberElement);

      _this733 = _super741.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this733.GlobalId = GlobalId;
      _this733.OwnerHistory = OwnerHistory;
      _this733.Name = Name;
      _this733.Description = Description;
      _this733.ObjectType = ObjectType;
      _this733.ObjectPlacement = ObjectPlacement;
      _this733.Representation = Representation;
      _this733.Tag = Tag;
      _this733.type = 1052013943;
      return _this733;
    }

    return IfcDistributionChamberElement;
  }(IfcDistributionFlowElement);

  IFC2X32.IfcDistributionChamberElement = IfcDistributionChamberElement;

  var IfcDistributionControlElement = /*#__PURE__*/function (_IfcDistributionEleme4) {
    _inherits(IfcDistributionControlElement, _IfcDistributionEleme4);

    var _super742 = _createSuper(IfcDistributionControlElement);

    function IfcDistributionControlElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, ControlElementId) {
      var _this734;

      _classCallCheck2(this, IfcDistributionControlElement);

      _this734 = _super742.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this734.GlobalId = GlobalId;
      _this734.OwnerHistory = OwnerHistory;
      _this734.Name = Name;
      _this734.Description = Description;
      _this734.ObjectType = ObjectType;
      _this734.ObjectPlacement = ObjectPlacement;
      _this734.Representation = Representation;
      _this734.Tag = Tag;
      _this734.ControlElementId = ControlElementId;
      _this734.type = 1062813311;
      return _this734;
    }

    return IfcDistributionControlElement;
  }(IfcDistributionElement);

  IFC2X32.IfcDistributionControlElement = IfcDistributionControlElement;

  var IfcElectricDistributionPoint = /*#__PURE__*/function (_IfcFlowController) {
    _inherits(IfcElectricDistributionPoint, _IfcFlowController);

    var _super743 = _createSuper(IfcElectricDistributionPoint);

    function IfcElectricDistributionPoint(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, DistributionPointFunction, UserDefinedFunction) {
      var _this735;

      _classCallCheck2(this, IfcElectricDistributionPoint);

      _this735 = _super743.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this735.GlobalId = GlobalId;
      _this735.OwnerHistory = OwnerHistory;
      _this735.Name = Name;
      _this735.Description = Description;
      _this735.ObjectType = ObjectType;
      _this735.ObjectPlacement = ObjectPlacement;
      _this735.Representation = Representation;
      _this735.Tag = Tag;
      _this735.DistributionPointFunction = DistributionPointFunction;
      _this735.UserDefinedFunction = UserDefinedFunction;
      _this735.type = 3700593921;
      return _this735;
    }

    return IfcElectricDistributionPoint;
  }(IfcFlowController);

  IFC2X32.IfcElectricDistributionPoint = IfcElectricDistributionPoint;

  var IfcReinforcingBar = /*#__PURE__*/function (_IfcReinforcingElemen4) {
    _inherits(IfcReinforcingBar, _IfcReinforcingElemen4);

    var _super744 = _createSuper(IfcReinforcingBar);

    function IfcReinforcingBar(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, BarRole, BarSurface) {
      var _this736;

      _classCallCheck2(this, IfcReinforcingBar);

      _this736 = _super744.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this736.GlobalId = GlobalId;
      _this736.OwnerHistory = OwnerHistory;
      _this736.Name = Name;
      _this736.Description = Description;
      _this736.ObjectType = ObjectType;
      _this736.ObjectPlacement = ObjectPlacement;
      _this736.Representation = Representation;
      _this736.Tag = Tag;
      _this736.SteelGrade = SteelGrade;
      _this736.NominalDiameter = NominalDiameter;
      _this736.CrossSectionArea = CrossSectionArea;
      _this736.BarLength = BarLength;
      _this736.BarRole = BarRole;
      _this736.BarSurface = BarSurface;
      _this736.type = 979691226;
      return _this736;
    }

    return IfcReinforcingBar;
  }(IfcReinforcingElement);

  IFC2X32.IfcReinforcingBar = IfcReinforcingBar;
})(IFC2X3 || (IFC2X3 = {}));

SchemaNames[2] = "IFC4_3";
FromRawLineData[2] = {
  3630933823: function _(id, v) {
    return new IFC4_3.IfcActorRole(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value));
  },
  618182010: function _(id, v) {
    return new IFC4_3.IfcAddress(id, v[0], !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value));
  },
  2879124712: function _(id, v) {
    return new IFC4_3.IfcAlignmentParameterSegment(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value));
  },
  3633395639: function _(id, v) {
    return new IFC4_3.IfcAlignmentVerticalSegment(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new IFC4_3.IfcLengthMeasure(v[2].value), new IFC4_3.IfcNonNegativeLengthMeasure(v[3].value), new IFC4_3.IfcLengthMeasure(v[4].value), new IFC4_3.IfcRatioMeasure(v[5].value), new IFC4_3.IfcRatioMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcLengthMeasure(v[7].value), v[8]);
  },
  639542469: function _(id, v) {
    return new IFC4_3.IfcApplication(id, new Handle(v[0].value), new IFC4_3.IfcLabel(v[1].value), new IFC4_3.IfcLabel(v[2].value), new IFC4_3.IfcIdentifier(v[3].value));
  },
  411424972: function _(id, v) {
    return new IFC4_3.IfcAppliedValue(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcDate(v[4].value), !v[5] ? null : new IFC4_3.IfcDate(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }));
  },
  130549933: function _(id, v) {
    return new IFC4_3.IfcApproval(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), !v[3] ? null : new IFC4_3.IfcDateTime(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value));
  },
  4037036970: function _(id, v) {
    return new IFC4_3.IfcBoundaryCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value));
  },
  1560379544: function _(id, v) {
    return new IFC4_3.IfcBoundaryEdgeCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(2, v[1]), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), !v[5] ? null : TypeInitialiser(2, v[5]), !v[6] ? null : TypeInitialiser(2, v[6]));
  },
  3367102660: function _(id, v) {
    return new IFC4_3.IfcBoundaryFaceCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(2, v[1]), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : TypeInitialiser(2, v[3]));
  },
  1387855156: function _(id, v) {
    return new IFC4_3.IfcBoundaryNodeCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(2, v[1]), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), !v[5] ? null : TypeInitialiser(2, v[5]), !v[6] ? null : TypeInitialiser(2, v[6]));
  },
  2069777674: function _(id, v) {
    return new IFC4_3.IfcBoundaryNodeConditionWarping(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(2, v[1]), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), !v[5] ? null : TypeInitialiser(2, v[5]), !v[6] ? null : TypeInitialiser(2, v[6]), !v[7] ? null : TypeInitialiser(2, v[7]));
  },
  2859738748: function _(id, _44) {
    return new IFC4_3.IfcConnectionGeometry(id);
  },
  2614616156: function _(id, v) {
    return new IFC4_3.IfcConnectionPointGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  2732653382: function _(id, v) {
    return new IFC4_3.IfcConnectionSurfaceGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  775493141: function _(id, v) {
    return new IFC4_3.IfcConnectionVolumeGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  1959218052: function _(id, v) {
    return new IFC4_3.IfcConstraint(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value));
  },
  1785450214: function _(id, v) {
    return new IFC4_3.IfcCoordinateOperation(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  1466758467: function _(id, v) {
    return new IFC4_3.IfcCoordinateReferenceSystem(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new IFC4_3.IfcIdentifier(v[3].value));
  },
  602808272: function _(id, v) {
    return new IFC4_3.IfcCostValue(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcDate(v[4].value), !v[5] ? null : new IFC4_3.IfcDate(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1765591967: function _(id, v) {
    return new IFC4_3.IfcDerivedUnit(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcLabel(v[3].value));
  },
  1045800335: function _(id, v) {
    return new IFC4_3.IfcDerivedUnitElement(id, new Handle(v[0].value), v[1].value);
  },
  2949456006: function _(id, v) {
    return new IFC4_3.IfcDimensionalExponents(id, v[0].value, v[1].value, v[2].value, v[3].value, v[4].value, v[5].value, v[6].value);
  },
  4294318154: function _(id, _45) {
    return new IFC4_3.IfcExternalInformation(id);
  },
  3200245327: function _(id, v) {
    return new IFC4_3.IfcExternalReference(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value));
  },
  2242383968: function _(id, v) {
    return new IFC4_3.IfcExternallyDefinedHatchStyle(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value));
  },
  1040185647: function _(id, v) {
    return new IFC4_3.IfcExternallyDefinedSurfaceStyle(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value));
  },
  3548104201: function _(id, v) {
    return new IFC4_3.IfcExternallyDefinedTextFont(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value));
  },
  852622518: function _(id, v) {
    return new IFC4_3.IfcGridAxis(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), new IFC4_3.IfcBoolean(v[2].value));
  },
  3020489413: function _(id, v) {
    return new IFC4_3.IfcIrregularTimeSeriesValue(id, new IFC4_3.IfcDateTime(v[0].value), v[1].map(function (p) {
      return TypeInitialiser(2, p);
    }));
  },
  2655187982: function _(id, v) {
    return new IFC4_3.IfcLibraryInformation(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcDateTime(v[3].value), !v[4] ? null : new IFC4_3.IfcURIReference(v[4].value), !v[5] ? null : new IFC4_3.IfcText(v[5].value));
  },
  3452421091: function _(id, v) {
    return new IFC4_3.IfcLibraryReference(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLanguageId(v[4].value), !v[5] ? null : new Handle(v[5].value));
  },
  4162380809: function _(id, v) {
    return new IFC4_3.IfcLightDistributionData(id, new IFC4_3.IfcPlaneAngleMeasure(v[0].value), v[1].map(function (p) {
      return new IFC4_3.IfcPlaneAngleMeasure(p.value);
    }), v[2].map(function (p) {
      return new IFC4_3.IfcLuminousIntensityDistributionMeasure(p.value);
    }));
  },
  1566485204: function _(id, v) {
    return new IFC4_3.IfcLightIntensityDistribution(id, v[0], v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3057273783: function _(id, v) {
    return new IFC4_3.IfcMapConversion(id, new Handle(v[0].value), new Handle(v[1].value), new IFC4_3.IfcLengthMeasure(v[2].value), new IFC4_3.IfcLengthMeasure(v[3].value), new IFC4_3.IfcLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcReal(v[5].value), !v[6] ? null : new IFC4_3.IfcReal(v[6].value), !v[7] ? null : new IFC4_3.IfcReal(v[7].value), !v[8] ? null : new IFC4_3.IfcReal(v[8].value), !v[9] ? null : new IFC4_3.IfcReal(v[9].value));
  },
  1847130766: function _(id, v) {
    return new IFC4_3.IfcMaterialClassificationRelationship(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value));
  },
  760658860: function _(id, _46) {
    return new IFC4_3.IfcMaterialDefinition(id);
  },
  248100487: function _(id, v) {
    return new IFC4_3.IfcMaterialLayer(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcNonNegativeLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLogical(v[2].value), !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcInteger(v[6].value));
  },
  3303938423: function _(id, v) {
    return new IFC4_3.IfcMaterialLayerSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value));
  },
  1847252529: function _(id, v) {
    return new IFC4_3.IfcMaterialLayerWithOffsets(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcNonNegativeLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLogical(v[2].value), !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcInteger(v[6].value), v[7], new IFC4_3.IfcLengthMeasure(v[8].value));
  },
  2199411900: function _(id, v) {
    return new IFC4_3.IfcMaterialList(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2235152071: function _(id, v) {
    return new IFC4_3.IfcMaterialProfile(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcInteger(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value));
  },
  164193824: function _(id, v) {
    return new IFC4_3.IfcMaterialProfileSet(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : new Handle(v[3].value));
  },
  552965576: function _(id, v) {
    return new IFC4_3.IfcMaterialProfileWithOffsets(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcInteger(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), new IFC4_3.IfcLengthMeasure(v[6].value));
  },
  1507914824: function _(id, _47) {
    return new IFC4_3.IfcMaterialUsageDefinition(id);
  },
  2597039031: function _(id, v) {
    return new IFC4_3.IfcMeasureWithUnit(id, TypeInitialiser(2, v[0]), new Handle(v[1].value));
  },
  3368373690: function _(id, v) {
    return new IFC4_3.IfcMetric(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), v[7], !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value));
  },
  2706619895: function _(id, v) {
    return new IFC4_3.IfcMonetaryUnit(id, new IFC4_3.IfcLabel(v[0].value));
  },
  1918398963: function _(id, v) {
    return new IFC4_3.IfcNamedUnit(id, new Handle(v[0].value), v[1]);
  },
  3701648758: function _(id, v) {
    return new IFC4_3.IfcObjectPlacement(id, !v[0] ? null : new Handle(v[0].value));
  },
  2251480897: function _(id, v) {
    return new IFC4_3.IfcObjective(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), v[8], v[9], !v[10] ? null : new IFC4_3.IfcLabel(v[10].value));
  },
  4251960020: function _(id, v) {
    return new IFC4_3.IfcOrganization(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new Handle(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1207048766: function _(id, v) {
    return new IFC4_3.IfcOwnerHistory(id, new Handle(v[0].value), new Handle(v[1].value), v[2], v[3], !v[4] ? null : new IFC4_3.IfcTimeStamp(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new IFC4_3.IfcTimeStamp(v[7].value));
  },
  2077209135: function _(id, v) {
    return new IFC4_3.IfcPerson(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new IFC4_3.IfcLabel(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new IFC4_3.IfcLabel(p.value);
    }), !v[5] ? null : v[5].map(function (p) {
      return new IFC4_3.IfcLabel(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }));
  },
  101040310: function _(id, v) {
    return new IFC4_3.IfcPersonAndOrganization(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2483315170: function _(id, v) {
    return new IFC4_3.IfcPhysicalQuantity(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value));
  },
  2226359599: function _(id, v) {
    return new IFC4_3.IfcPhysicalSimpleQuantity(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  3355820592: function _(id, v) {
    return new IFC4_3.IfcPostalAddress(id, v[0], !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new IFC4_3.IfcLabel(p.value);
    }), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcLabel(v[9].value));
  },
  677532197: function _(id, _48) {
    return new IFC4_3.IfcPresentationItem(id);
  },
  2022622350: function _(id, v) {
    return new IFC4_3.IfcPresentationLayerAssignment(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : new IFC4_3.IfcIdentifier(v[3].value));
  },
  1304840413: function _(id, v) {
    return new IFC4_3.IfcPresentationLayerWithStyle(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : new IFC4_3.IfcIdentifier(v[3].value), new IFC4_3.IfcLogical(v[4].value), new IFC4_3.IfcLogical(v[5].value), new IFC4_3.IfcLogical(v[6].value), v[7].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3119450353: function _(id, v) {
    return new IFC4_3.IfcPresentationStyle(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value));
  },
  2095639259: function _(id, v) {
    return new IFC4_3.IfcProductRepresentation(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3958567839: function _(id, v) {
    return new IFC4_3.IfcProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value));
  },
  3843373140: function _(id, v) {
    return new IFC4_3.IfcProjectedCRS(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new IFC4_3.IfcIdentifier(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  986844984: function _(id, _49) {
    return new IFC4_3.IfcPropertyAbstraction(id);
  },
  3710013099: function _(id, v) {
    return new IFC4_3.IfcPropertyEnumeration(id, new IFC4_3.IfcLabel(v[0].value), v[1].map(function (p) {
      return TypeInitialiser(2, p);
    }), !v[2] ? null : new Handle(v[2].value));
  },
  2044713172: function _(id, v) {
    return new IFC4_3.IfcQuantityArea(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcAreaMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  2093928680: function _(id, v) {
    return new IFC4_3.IfcQuantityCount(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcCountMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  931644368: function _(id, v) {
    return new IFC4_3.IfcQuantityLength(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  2691318326: function _(id, v) {
    return new IFC4_3.IfcQuantityNumber(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcNumericMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  3252649465: function _(id, v) {
    return new IFC4_3.IfcQuantityTime(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcTimeMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  2405470396: function _(id, v) {
    return new IFC4_3.IfcQuantityVolume(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcVolumeMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  825690147: function _(id, v) {
    return new IFC4_3.IfcQuantityWeight(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcMassMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  3915482550: function _(id, v) {
    return new IFC4_3.IfcRecurrencePattern(id, v[0], !v[1] ? null : v[1].map(function (p) {
      return new IFC4_3.IfcDayInMonthNumber(p.value);
    }), !v[2] ? null : v[2].map(function (p) {
      return new IFC4_3.IfcDayInWeekNumber(p.value);
    }), !v[3] ? null : v[3].map(function (p) {
      return new IFC4_3.IfcMonthInYearNumber(p.value);
    }), !v[4] ? null : new IFC4_3.IfcInteger(v[4].value), !v[5] ? null : new IFC4_3.IfcInteger(v[5].value), !v[6] ? null : new IFC4_3.IfcInteger(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2433181523: function _(id, v) {
    return new IFC4_3.IfcReference(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new IFC4_3.IfcInteger(p.value);
    }), !v[4] ? null : new Handle(v[4].value));
  },
  1076942058: function _(id, v) {
    return new IFC4_3.IfcRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3377609919: function _(id, v) {
    return new IFC4_3.IfcRepresentationContext(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value));
  },
  3008791417: function _(id, _50) {
    return new IFC4_3.IfcRepresentationItem(id);
  },
  1660063152: function _(id, v) {
    return new IFC4_3.IfcRepresentationMap(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  2439245199: function _(id, v) {
    return new IFC4_3.IfcResourceLevelRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value));
  },
  2341007311: function _(id, v) {
    return new IFC4_3.IfcRoot(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  448429030: function _(id, v) {
    return new IFC4_3.IfcSIUnit(id, new Handle(v[0].value), v[1], v[2], v[3]);
  },
  1054537805: function _(id, v) {
    return new IFC4_3.IfcSchedulingTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value));
  },
  867548509: function _(id, v) {
    return new IFC4_3.IfcShapeAspect(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), new IFC4_3.IfcLogical(v[3].value), !v[4] ? null : new Handle(v[4].value));
  },
  3982875396: function _(id, v) {
    return new IFC4_3.IfcShapeModel(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  4240577450: function _(id, v) {
    return new IFC4_3.IfcShapeRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2273995522: function _(id, v) {
    return new IFC4_3.IfcStructuralConnectionCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value));
  },
  2162789131: function _(id, v) {
    return new IFC4_3.IfcStructuralLoad(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value));
  },
  3478079324: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadConfiguration(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : v[2].map(function (p) {
      return new IFC4_3.IfcLengthMeasure(p.value);
    }));
  },
  609421318: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadOrResult(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value));
  },
  2525727697: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadStatic(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value));
  },
  3408363356: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadTemperature(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcThermodynamicTemperatureMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcThermodynamicTemperatureMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcThermodynamicTemperatureMeasure(v[3].value));
  },
  2830218821: function _(id, v) {
    return new IFC4_3.IfcStyleModel(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3958052878: function _(id, v) {
    return new IFC4_3.IfcStyledItem(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value));
  },
  3049322572: function _(id, v) {
    return new IFC4_3.IfcStyledRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2934153892: function _(id, v) {
    return new IFC4_3.IfcSurfaceReinforcementArea(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return new IFC4_3.IfcLengthMeasure(p.value);
    }), !v[2] ? null : v[2].map(function (p) {
      return new IFC4_3.IfcLengthMeasure(p.value);
    }), !v[3] ? null : new IFC4_3.IfcRatioMeasure(v[3].value));
  },
  1300840506: function _(id, v) {
    return new IFC4_3.IfcSurfaceStyle(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3303107099: function _(id, v) {
    return new IFC4_3.IfcSurfaceStyleLighting(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new Handle(v[3].value));
  },
  1607154358: function _(id, v) {
    return new IFC4_3.IfcSurfaceStyleRefraction(id, !v[0] ? null : new IFC4_3.IfcReal(v[0].value), !v[1] ? null : new IFC4_3.IfcReal(v[1].value));
  },
  846575682: function _(id, v) {
    return new IFC4_3.IfcSurfaceStyleShading(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[1].value));
  },
  1351298697: function _(id, v) {
    return new IFC4_3.IfcSurfaceStyleWithTextures(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  626085974: function _(id, v) {
    return new IFC4_3.IfcSurfaceTexture(id, new IFC4_3.IfcBoolean(v[0].value), new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new IFC4_3.IfcIdentifier(p.value);
    }));
  },
  985171141: function _(id, v) {
    return new IFC4_3.IfcTable(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2043862942: function _(id, v) {
    return new IFC4_3.IfcTableColumn(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value));
  },
  531007025: function _(id, v) {
    return new IFC4_3.IfcTableRow(id, !v[0] ? null : v[0].map(function (p) {
      return TypeInitialiser(2, p);
    }), !v[1] ? null : new IFC4_3.IfcBoolean(v[1].value));
  },
  1549132990: function _(id, v) {
    return new IFC4_3.IfcTaskTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3], !v[4] ? null : new IFC4_3.IfcDuration(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : new IFC4_3.IfcDateTime(v[7].value), !v[8] ? null : new IFC4_3.IfcDateTime(v[8].value), !v[9] ? null : new IFC4_3.IfcDateTime(v[9].value), !v[10] ? null : new IFC4_3.IfcDateTime(v[10].value), !v[11] ? null : new IFC4_3.IfcDuration(v[11].value), !v[12] ? null : new IFC4_3.IfcDuration(v[12].value), !v[13] ? null : new IFC4_3.IfcBoolean(v[13].value), !v[14] ? null : new IFC4_3.IfcDateTime(v[14].value), !v[15] ? null : new IFC4_3.IfcDuration(v[15].value), !v[16] ? null : new IFC4_3.IfcDateTime(v[16].value), !v[17] ? null : new IFC4_3.IfcDateTime(v[17].value), !v[18] ? null : new IFC4_3.IfcDuration(v[18].value), !v[19] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[19].value));
  },
  2771591690: function _(id, v) {
    return new IFC4_3.IfcTaskTimeRecurring(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3], !v[4] ? null : new IFC4_3.IfcDuration(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : new IFC4_3.IfcDateTime(v[7].value), !v[8] ? null : new IFC4_3.IfcDateTime(v[8].value), !v[9] ? null : new IFC4_3.IfcDateTime(v[9].value), !v[10] ? null : new IFC4_3.IfcDateTime(v[10].value), !v[11] ? null : new IFC4_3.IfcDuration(v[11].value), !v[12] ? null : new IFC4_3.IfcDuration(v[12].value), !v[13] ? null : new IFC4_3.IfcBoolean(v[13].value), !v[14] ? null : new IFC4_3.IfcDateTime(v[14].value), !v[15] ? null : new IFC4_3.IfcDuration(v[15].value), !v[16] ? null : new IFC4_3.IfcDateTime(v[16].value), !v[17] ? null : new IFC4_3.IfcDateTime(v[17].value), !v[18] ? null : new IFC4_3.IfcDuration(v[18].value), !v[19] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[19].value), new Handle(v[20].value));
  },
  912023232: function _(id, v) {
    return new IFC4_3.IfcTelecomAddress(id, v[0], !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new IFC4_3.IfcLabel(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new IFC4_3.IfcLabel(p.value);
    }), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : v[6].map(function (p) {
      return new IFC4_3.IfcLabel(p.value);
    }), !v[7] ? null : new IFC4_3.IfcURIReference(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new IFC4_3.IfcURIReference(p.value);
    }));
  },
  1447204868: function _(id, v) {
    return new IFC4_3.IfcTextStyle(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcBoolean(v[4].value));
  },
  2636378356: function _(id, v) {
    return new IFC4_3.IfcTextStyleForDefinedFont(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  1640371178: function _(id, v) {
    return new IFC4_3.IfcTextStyleTextModel(id, !v[0] ? null : TypeInitialiser(2, v[0]), !v[1] ? null : new IFC4_3.IfcTextAlignment(v[1].value), !v[2] ? null : new IFC4_3.IfcTextDecoration(v[2].value), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), !v[5] ? null : new IFC4_3.IfcTextTransformation(v[5].value), !v[6] ? null : TypeInitialiser(2, v[6]));
  },
  280115917: function _(id, v) {
    return new IFC4_3.IfcTextureCoordinate(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1742049831: function _(id, v) {
    return new IFC4_3.IfcTextureCoordinateGenerator(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return new IFC4_3.IfcReal(p.value);
    }));
  },
  222769930: function _(id, v) {
    return new IFC4_3.IfcTextureCoordinateIndices(id, v[0].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }), new Handle(v[1].value));
  },
  1010789467: function _(id, v) {
    return new IFC4_3.IfcTextureCoordinateIndicesWithVoids(id, v[0].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }), new Handle(v[1].value), v[2].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }));
  },
  2552916305: function _(id, v) {
    return new IFC4_3.IfcTextureMap(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[2].value));
  },
  1210645708: function _(id, v) {
    return new IFC4_3.IfcTextureVertex(id, v[0].map(function (p) {
      return new IFC4_3.IfcParameterValue(p.value);
    }));
  },
  3611470254: function _(id, v) {
    return new IFC4_3.IfcTextureVertexList(id, v[0].map(function (p) {
      return new IFC4_3.IfcParameterValue(p.value);
    }));
  },
  1199560280: function _(id, v) {
    return new IFC4_3.IfcTimePeriod(id, new IFC4_3.IfcTime(v[0].value), new IFC4_3.IfcTime(v[1].value));
  },
  3101149627: function _(id, v) {
    return new IFC4_3.IfcTimeSeries(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new IFC4_3.IfcDateTime(v[2].value), new IFC4_3.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  581633288: function _(id, v) {
    return new IFC4_3.IfcTimeSeriesValue(id, v[0].map(function (p) {
      return TypeInitialiser(2, p);
    }));
  },
  1377556343: function _(id, _51) {
    return new IFC4_3.IfcTopologicalRepresentationItem(id);
  },
  1735638870: function _(id, v) {
    return new IFC4_3.IfcTopologyRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  180925521: function _(id, v) {
    return new IFC4_3.IfcUnitAssignment(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2799835756: function _(id, _52) {
    return new IFC4_3.IfcVertex(id);
  },
  1907098498: function _(id, v) {
    return new IFC4_3.IfcVertexPoint(id, new Handle(v[0].value));
  },
  891718957: function _(id, v) {
    return new IFC4_3.IfcVirtualGridIntersection(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1].map(function (p) {
      return new IFC4_3.IfcLengthMeasure(p.value);
    }));
  },
  1236880293: function _(id, v) {
    return new IFC4_3.IfcWorkTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcDate(v[4].value), !v[5] ? null : new IFC4_3.IfcDate(v[5].value));
  },
  3752311538: function _(id, v) {
    return new IFC4_3.IfcAlignmentCantSegment(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new IFC4_3.IfcLengthMeasure(v[2].value), new IFC4_3.IfcNonNegativeLengthMeasure(v[3].value), new IFC4_3.IfcLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcLengthMeasure(v[5].value), new IFC4_3.IfcLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcLengthMeasure(v[7].value), v[8]);
  },
  536804194: function _(id, v) {
    return new IFC4_3.IfcAlignmentHorizontalSegment(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPlaneAngleMeasure(v[3].value), new IFC4_3.IfcLengthMeasure(v[4].value), new IFC4_3.IfcLengthMeasure(v[5].value), new IFC4_3.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[7].value), v[8]);
  },
  3869604511: function _(id, v) {
    return new IFC4_3.IfcApprovalRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3798115385: function _(id, v) {
    return new IFC4_3.IfcArbitraryClosedProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value));
  },
  1310608509: function _(id, v) {
    return new IFC4_3.IfcArbitraryOpenProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value));
  },
  2705031697: function _(id, v) {
    return new IFC4_3.IfcArbitraryProfileDefWithVoids(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  616511568: function _(id, v) {
    return new IFC4_3.IfcBlobTexture(id, new IFC4_3.IfcBoolean(v[0].value), new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new IFC4_3.IfcIdentifier(p.value);
    }), new IFC4_3.IfcIdentifier(v[5].value), new IFC4_3.IfcBinary(v[6].value));
  },
  3150382593: function _(id, v) {
    return new IFC4_3.IfcCenterLineProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value));
  },
  747523909: function _(id, v) {
    return new IFC4_3.IfcClassification(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcDate(v[2].value), new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new IFC4_3.IfcURIReference(v[5].value), !v[6] ? null : v[6].map(function (p) {
      return new IFC4_3.IfcIdentifier(p.value);
    }));
  },
  647927063: function _(id, v) {
    return new IFC4_3.IfcClassificationReference(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value));
  },
  3285139300: function _(id, v) {
    return new IFC4_3.IfcColourRgbList(id, v[0].map(function (p) {
      return new IFC4_3.IfcNormalisedRatioMeasure(p.value);
    }));
  },
  3264961684: function _(id, v) {
    return new IFC4_3.IfcColourSpecification(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value));
  },
  1485152156: function _(id, v) {
    return new IFC4_3.IfcCompositeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : new IFC4_3.IfcLabel(v[3].value));
  },
  370225590: function _(id, v) {
    return new IFC4_3.IfcConnectedFaceSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1981873012: function _(id, v) {
    return new IFC4_3.IfcConnectionCurveGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  45288368: function _(id, v) {
    return new IFC4_3.IfcConnectionPointEccentricity(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLengthMeasure(v[4].value));
  },
  3050246964: function _(id, v) {
    return new IFC4_3.IfcContextDependentUnit(id, new Handle(v[0].value), v[1], new IFC4_3.IfcLabel(v[2].value));
  },
  2889183280: function _(id, v) {
    return new IFC4_3.IfcConversionBasedUnit(id, new Handle(v[0].value), v[1], new IFC4_3.IfcLabel(v[2].value), new Handle(v[3].value));
  },
  2713554722: function _(id, v) {
    return new IFC4_3.IfcConversionBasedUnitWithOffset(id, new Handle(v[0].value), v[1], new IFC4_3.IfcLabel(v[2].value), new Handle(v[3].value), new IFC4_3.IfcReal(v[4].value));
  },
  539742890: function _(id, v) {
    return new IFC4_3.IfcCurrencyRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), new IFC4_3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  3800577675: function _(id, v) {
    return new IFC4_3.IfcCurveStyle(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcBoolean(v[4].value));
  },
  1105321065: function _(id, v) {
    return new IFC4_3.IfcCurveStyleFont(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2367409068: function _(id, v) {
    return new IFC4_3.IfcCurveStyleFontAndScaling(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), new IFC4_3.IfcPositiveRatioMeasure(v[2].value));
  },
  3510044353: function _(id, v) {
    return new IFC4_3.IfcCurveStyleFontPattern(id, new IFC4_3.IfcLengthMeasure(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value));
  },
  3632507154: function _(id, v) {
    return new IFC4_3.IfcDerivedProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  1154170062: function _(id, v) {
    return new IFC4_3.IfcDocumentInformation(id, new IFC4_3.IfcIdentifier(v[0].value), new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), !v[3] ? null : new IFC4_3.IfcURIReference(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new IFC4_3.IfcText(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new IFC4_3.IfcDateTime(v[10].value), !v[11] ? null : new IFC4_3.IfcDateTime(v[11].value), !v[12] ? null : new IFC4_3.IfcIdentifier(v[12].value), !v[13] ? null : new IFC4_3.IfcDate(v[13].value), !v[14] ? null : new IFC4_3.IfcDate(v[14].value), v[15], v[16]);
  },
  770865208: function _(id, v) {
    return new IFC4_3.IfcDocumentInformationRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  3732053477: function _(id, v) {
    return new IFC4_3.IfcDocumentReference(id, !v[0] ? null : new IFC4_3.IfcURIReference(v[0].value), !v[1] ? null : new IFC4_3.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value));
  },
  3900360178: function _(id, v) {
    return new IFC4_3.IfcEdge(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  476780140: function _(id, v) {
    return new IFC4_3.IfcEdgeCurve(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcBoolean(v[3].value));
  },
  211053100: function _(id, v) {
    return new IFC4_3.IfcEventTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcDateTime(v[3].value), !v[4] ? null : new IFC4_3.IfcDateTime(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcDateTime(v[6].value));
  },
  297599258: function _(id, v) {
    return new IFC4_3.IfcExtendedProperties(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1437805879: function _(id, v) {
    return new IFC4_3.IfcExternalReferenceRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2556980723: function _(id, v) {
    return new IFC4_3.IfcFace(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1809719519: function _(id, v) {
    return new IFC4_3.IfcFaceBound(id, new Handle(v[0].value), new IFC4_3.IfcBoolean(v[1].value));
  },
  803316827: function _(id, v) {
    return new IFC4_3.IfcFaceOuterBound(id, new Handle(v[0].value), new IFC4_3.IfcBoolean(v[1].value));
  },
  3008276851: function _(id, v) {
    return new IFC4_3.IfcFaceSurface(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value), new IFC4_3.IfcBoolean(v[2].value));
  },
  4219587988: function _(id, v) {
    return new IFC4_3.IfcFailureConnectionCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcForceMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcForceMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcForceMeasure(v[6].value));
  },
  738692330: function _(id, v) {
    return new IFC4_3.IfcFillAreaStyle(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC4_3.IfcBoolean(v[2].value));
  },
  3448662350: function _(id, v) {
    return new IFC4_3.IfcGeometricRepresentationContext(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new IFC4_3.IfcDimensionCount(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value));
  },
  2453401579: function _(id, _53) {
    return new IFC4_3.IfcGeometricRepresentationItem(id);
  },
  4142052618: function _(id, v) {
    return new IFC4_3.IfcGeometricRepresentationSubContext(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[4].value), v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value));
  },
  3590301190: function _(id, v) {
    return new IFC4_3.IfcGeometricSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  178086475: function _(id, v) {
    return new IFC4_3.IfcGridPlacement(id, !v[0] ? null : new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  812098782: function _(id, v) {
    return new IFC4_3.IfcHalfSpaceSolid(id, new Handle(v[0].value), new IFC4_3.IfcBoolean(v[1].value));
  },
  3905492369: function _(id, v) {
    return new IFC4_3.IfcImageTexture(id, new IFC4_3.IfcBoolean(v[0].value), new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new IFC4_3.IfcIdentifier(p.value);
    }), new IFC4_3.IfcURIReference(v[5].value));
  },
  3570813810: function _(id, v) {
    return new IFC4_3.IfcIndexedColourMap(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }));
  },
  1437953363: function _(id, v) {
    return new IFC4_3.IfcIndexedTextureMap(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value), new Handle(v[2].value));
  },
  2133299955: function _(id, v) {
    return new IFC4_3.IfcIndexedTriangleTextureMap(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }));
  },
  3741457305: function _(id, v) {
    return new IFC4_3.IfcIrregularTimeSeries(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new IFC4_3.IfcDateTime(v[2].value), new IFC4_3.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), v[8].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1585845231: function _(id, v) {
    return new IFC4_3.IfcLagTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), TypeInitialiser(2, v[3]), v[4]);
  },
  1402838566: function _(id, v) {
    return new IFC4_3.IfcLightSource(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value));
  },
  125510826: function _(id, v) {
    return new IFC4_3.IfcLightSourceAmbient(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value));
  },
  2604431987: function _(id, v) {
    return new IFC4_3.IfcLightSourceDirectional(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value));
  },
  4266656042: function _(id, v) {
    return new IFC4_3.IfcLightSourceGoniometric(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), new IFC4_3.IfcThermodynamicTemperatureMeasure(v[6].value), new IFC4_3.IfcLuminousFluxMeasure(v[7].value), v[8], new Handle(v[9].value));
  },
  1520743889: function _(id, v) {
    return new IFC4_3.IfcLightSourcePositional(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcReal(v[6].value), new IFC4_3.IfcReal(v[7].value), new IFC4_3.IfcReal(v[8].value));
  },
  3422422726: function _(id, v) {
    return new IFC4_3.IfcLightSourceSpot(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcReal(v[6].value), new IFC4_3.IfcReal(v[7].value), new IFC4_3.IfcReal(v[8].value), new Handle(v[9].value), !v[10] ? null : new IFC4_3.IfcReal(v[10].value), new IFC4_3.IfcPositivePlaneAngleMeasure(v[11].value), new IFC4_3.IfcPositivePlaneAngleMeasure(v[12].value));
  },
  388784114: function _(id, v) {
    return new IFC4_3.IfcLinearPlacement(id, !v[0] ? null : new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  2624227202: function _(id, v) {
    return new IFC4_3.IfcLocalPlacement(id, !v[0] ? null : new Handle(v[0].value), new Handle(v[1].value));
  },
  1008929658: function _(id, _54) {
    return new IFC4_3.IfcLoop(id);
  },
  2347385850: function _(id, v) {
    return new IFC4_3.IfcMappedItem(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  1838606355: function _(id, v) {
    return new IFC4_3.IfcMaterial(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value));
  },
  3708119e3: function _(id, v) {
    return new IFC4_3.IfcMaterialConstituent(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  2852063980: function _(id, v) {
    return new IFC4_3.IfcMaterialConstituentSet(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2022407955: function _(id, v) {
    return new IFC4_3.IfcMaterialDefinitionRepresentation(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[3].value));
  },
  1303795690: function _(id, v) {
    return new IFC4_3.IfcMaterialLayerSetUsage(id, new Handle(v[0].value), v[1], v[2], new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value));
  },
  3079605661: function _(id, v) {
    return new IFC4_3.IfcMaterialProfileSetUsage(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcCardinalPointReference(v[1].value), !v[2] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[2].value));
  },
  3404854881: function _(id, v) {
    return new IFC4_3.IfcMaterialProfileSetUsageTapering(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcCardinalPointReference(v[1].value), !v[2] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcCardinalPointReference(v[4].value));
  },
  3265635763: function _(id, v) {
    return new IFC4_3.IfcMaterialProperties(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[3].value));
  },
  853536259: function _(id, v) {
    return new IFC4_3.IfcMaterialRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  2998442950: function _(id, v) {
    return new IFC4_3.IfcMirroredProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  219451334: function _(id, v) {
    return new IFC4_3.IfcObjectDefinition(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  182550632: function _(id, v) {
    return new IFC4_3.IfcOpenCrossProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), new IFC4_3.IfcBoolean(v[2].value), v[3].map(function (p) {
      return new IFC4_3.IfcNonNegativeLengthMeasure(p.value);
    }), v[4].map(function (p) {
      return new IFC4_3.IfcPlaneAngleMeasure(p.value);
    }), !v[5] ? null : v[5].map(function (p) {
      return new IFC4_3.IfcLabel(p.value);
    }), !v[6] ? null : new Handle(v[6].value));
  },
  2665983363: function _(id, v) {
    return new IFC4_3.IfcOpenShell(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1411181986: function _(id, v) {
    return new IFC4_3.IfcOrganizationRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1029017970: function _(id, v) {
    return new IFC4_3.IfcOrientedEdge(id, new Handle(v[0].value), new Handle(v[1].value), new IFC4_3.IfcBoolean(v[2].value));
  },
  2529465313: function _(id, v) {
    return new IFC4_3.IfcParameterizedProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  2519244187: function _(id, v) {
    return new IFC4_3.IfcPath(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3021840470: function _(id, v) {
    return new IFC4_3.IfcPhysicalComplexQuantity(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new IFC4_3.IfcLabel(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value));
  },
  597895409: function _(id, v) {
    return new IFC4_3.IfcPixelTexture(id, new IFC4_3.IfcBoolean(v[0].value), new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : new IFC4_3.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new IFC4_3.IfcIdentifier(p.value);
    }), new IFC4_3.IfcInteger(v[5].value), new IFC4_3.IfcInteger(v[6].value), new IFC4_3.IfcInteger(v[7].value), v[8].map(function (p) {
      return new IFC4_3.IfcBinary(p.value);
    }));
  },
  2004835150: function _(id, v) {
    return new IFC4_3.IfcPlacement(id, new Handle(v[0].value));
  },
  1663979128: function _(id, v) {
    return new IFC4_3.IfcPlanarExtent(id, new IFC4_3.IfcLengthMeasure(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value));
  },
  2067069095: function _(id, _55) {
    return new IFC4_3.IfcPoint(id);
  },
  2165702409: function _(id, v) {
    return new IFC4_3.IfcPointByDistanceExpression(id, TypeInitialiser(2, v[0]), !v[1] ? null : new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), new Handle(v[4].value));
  },
  4022376103: function _(id, v) {
    return new IFC4_3.IfcPointOnCurve(id, new Handle(v[0].value), new IFC4_3.IfcParameterValue(v[1].value));
  },
  1423911732: function _(id, v) {
    return new IFC4_3.IfcPointOnSurface(id, new Handle(v[0].value), new IFC4_3.IfcParameterValue(v[1].value), new IFC4_3.IfcParameterValue(v[2].value));
  },
  2924175390: function _(id, v) {
    return new IFC4_3.IfcPolyLoop(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2775532180: function _(id, v) {
    return new IFC4_3.IfcPolygonalBoundedHalfSpace(id, new Handle(v[0].value), new IFC4_3.IfcBoolean(v[1].value), new Handle(v[2].value), new Handle(v[3].value));
  },
  3727388367: function _(id, v) {
    return new IFC4_3.IfcPreDefinedItem(id, new IFC4_3.IfcLabel(v[0].value));
  },
  3778827333: function _(id, _56) {
    return new IFC4_3.IfcPreDefinedProperties(id);
  },
  1775413392: function _(id, v) {
    return new IFC4_3.IfcPreDefinedTextFont(id, new IFC4_3.IfcLabel(v[0].value));
  },
  673634403: function _(id, v) {
    return new IFC4_3.IfcProductDefinitionShape(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2802850158: function _(id, v) {
    return new IFC4_3.IfcProfileProperties(id, !v[0] ? null : new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[3].value));
  },
  2598011224: function _(id, v) {
    return new IFC4_3.IfcProperty(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value));
  },
  1680319473: function _(id, v) {
    return new IFC4_3.IfcPropertyDefinition(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  148025276: function _(id, v) {
    return new IFC4_3.IfcPropertyDependencyRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4_3.IfcText(v[4].value));
  },
  3357820518: function _(id, v) {
    return new IFC4_3.IfcPropertySetDefinition(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  1482703590: function _(id, v) {
    return new IFC4_3.IfcPropertyTemplateDefinition(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  2090586900: function _(id, v) {
    return new IFC4_3.IfcQuantitySet(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  3615266464: function _(id, v) {
    return new IFC4_3.IfcRectangleProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value));
  },
  3413951693: function _(id, v) {
    return new IFC4_3.IfcRegularTimeSeries(id, new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new IFC4_3.IfcDateTime(v[2].value), new IFC4_3.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), new IFC4_3.IfcTimeMeasure(v[8].value), v[9].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1580146022: function _(id, v) {
    return new IFC4_3.IfcReinforcementBarProperties(id, new IFC4_3.IfcAreaMeasure(v[0].value), new IFC4_3.IfcLabel(v[1].value), v[2], !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcCountMeasure(v[5].value));
  },
  478536968: function _(id, v) {
    return new IFC4_3.IfcRelationship(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  2943643501: function _(id, v) {
    return new IFC4_3.IfcResourceApprovalRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[3].value));
  },
  1608871552: function _(id, v) {
    return new IFC4_3.IfcResourceConstraintRelationship(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1042787934: function _(id, v) {
    return new IFC4_3.IfcResourceTime(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcDuration(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcDateTime(v[5].value), !v[6] ? null : new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcDuration(v[8].value), !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value), !v[10] ? null : new IFC4_3.IfcDateTime(v[10].value), !v[11] ? null : new IFC4_3.IfcDuration(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcDateTime(v[13].value), !v[14] ? null : new IFC4_3.IfcDateTime(v[14].value), !v[15] ? null : new IFC4_3.IfcDuration(v[15].value), !v[16] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[16].value), !v[17] ? null : new IFC4_3.IfcPositiveRatioMeasure(v[17].value));
  },
  2778083089: function _(id, v) {
    return new IFC4_3.IfcRoundedRectangleProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value));
  },
  2042790032: function _(id, v) {
    return new IFC4_3.IfcSectionProperties(id, v[0], new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  4165799628: function _(id, v) {
    return new IFC4_3.IfcSectionReinforcementProperties(id, new IFC4_3.IfcLengthMeasure(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), v[3], new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1509187699: function _(id, v) {
    return new IFC4_3.IfcSectionedSpine(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  823603102: function _(id, v) {
    return new IFC4_3.IfcSegment(id, v[0]);
  },
  4124623270: function _(id, v) {
    return new IFC4_3.IfcShellBasedSurfaceModel(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3692461612: function _(id, v) {
    return new IFC4_3.IfcSimpleProperty(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value));
  },
  2609359061: function _(id, v) {
    return new IFC4_3.IfcSlippageConnectionCondition(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value));
  },
  723233188: function _(id, _57) {
    return new IFC4_3.IfcSolidModel(id);
  },
  1595516126: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadLinearForce(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLinearForceMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLinearForceMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLinearForceMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLinearMomentMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcLinearMomentMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcLinearMomentMeasure(v[6].value));
  },
  2668620305: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadPlanarForce(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcPlanarForceMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcPlanarForceMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcPlanarForceMeasure(v[3].value));
  },
  2473145415: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadSingleDisplacement(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[6].value));
  },
  1973038258: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadSingleDisplacementDistortion(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcCurvatureMeasure(v[7].value));
  },
  1597423693: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadSingleForce(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcTorqueMeasure(v[6].value));
  },
  1190533807: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadSingleForceWarping(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), !v[1] ? null : new IFC4_3.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcTorqueMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcWarpingMomentMeasure(v[7].value));
  },
  2233826070: function _(id, v) {
    return new IFC4_3.IfcSubedge(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value));
  },
  2513912981: function _(id, _58) {
    return new IFC4_3.IfcSurface(id);
  },
  1878645084: function _(id, v) {
    return new IFC4_3.IfcSurfaceStyleRendering(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : TypeInitialiser(2, v[7]), v[8]);
  },
  2247615214: function _(id, v) {
    return new IFC4_3.IfcSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  1260650574: function _(id, v) {
    return new IFC4_3.IfcSweptDiskSolid(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4_3.IfcParameterValue(v[4].value));
  },
  1096409881: function _(id, v) {
    return new IFC4_3.IfcSweptDiskSolidPolygonal(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4_3.IfcParameterValue(v[4].value), !v[5] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[5].value));
  },
  230924584: function _(id, v) {
    return new IFC4_3.IfcSweptSurface(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  3071757647: function _(id, v) {
    return new IFC4_3.IfcTShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[11].value));
  },
  901063453: function _(id, _59) {
    return new IFC4_3.IfcTessellatedItem(id);
  },
  4282788508: function _(id, v) {
    return new IFC4_3.IfcTextLiteral(id, new IFC4_3.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2]);
  },
  3124975700: function _(id, v) {
    return new IFC4_3.IfcTextLiteralWithExtent(id, new IFC4_3.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2], new Handle(v[3].value), new IFC4_3.IfcBoxAlignment(v[4].value));
  },
  1983826977: function _(id, v) {
    return new IFC4_3.IfcTextStyleFontModel(id, new IFC4_3.IfcLabel(v[0].value), v[1].map(function (p) {
      return new IFC4_3.IfcTextFontName(p.value);
    }), !v[2] ? null : new IFC4_3.IfcFontStyle(v[2].value), !v[3] ? null : new IFC4_3.IfcFontVariant(v[3].value), !v[4] ? null : new IFC4_3.IfcFontWeight(v[4].value), TypeInitialiser(2, v[5]));
  },
  2715220739: function _(id, v) {
    return new IFC4_3.IfcTrapeziumProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcLengthMeasure(v[6].value));
  },
  1628702193: function _(id, v) {
    return new IFC4_3.IfcTypeObject(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3736923433: function _(id, v) {
    return new IFC4_3.IfcTypeProcess(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  2347495698: function _(id, v) {
    return new IFC4_3.IfcTypeProduct(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value));
  },
  3698973494: function _(id, v) {
    return new IFC4_3.IfcTypeResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  427810014: function _(id, v) {
    return new IFC4_3.IfcUShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[9].value));
  },
  1417489154: function _(id, v) {
    return new IFC4_3.IfcVector(id, new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value));
  },
  2759199220: function _(id, v) {
    return new IFC4_3.IfcVertexLoop(id, new Handle(v[0].value));
  },
  2543172580: function _(id, v) {
    return new IFC4_3.IfcZShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[8].value));
  },
  3406155212: function _(id, v) {
    return new IFC4_3.IfcAdvancedFace(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value), new IFC4_3.IfcBoolean(v[2].value));
  },
  669184980: function _(id, v) {
    return new IFC4_3.IfcAnnotationFillArea(id, new Handle(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3207858831: function _(id, v) {
    return new IFC4_3.IfcAsymmetricIShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), new IFC4_3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[13].value), !v[14] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[14].value));
  },
  4261334040: function _(id, v) {
    return new IFC4_3.IfcAxis1Placement(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  3125803723: function _(id, v) {
    return new IFC4_3.IfcAxis2Placement2D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  2740243338: function _(id, v) {
    return new IFC4_3.IfcAxis2Placement3D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  3425423356: function _(id, v) {
    return new IFC4_3.IfcAxis2PlacementLinear(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  2736907675: function _(id, v) {
    return new IFC4_3.IfcBooleanResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value));
  },
  4182860854: function _(id, _60) {
    return new IFC4_3.IfcBoundedSurface(id);
  },
  2581212453: function _(id, v) {
    return new IFC4_3.IfcBoundingBox(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value));
  },
  2713105998: function _(id, v) {
    return new IFC4_3.IfcBoxedHalfSpace(id, new Handle(v[0].value), new IFC4_3.IfcBoolean(v[1].value), new Handle(v[2].value));
  },
  2898889636: function _(id, v) {
    return new IFC4_3.IfcCShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value));
  },
  1123145078: function _(id, v) {
    return new IFC4_3.IfcCartesianPoint(id, v[0].map(function (p) {
      return new IFC4_3.IfcLengthMeasure(p.value);
    }));
  },
  574549367: function _(id, _61) {
    return new IFC4_3.IfcCartesianPointList(id);
  },
  1675464909: function _(id, v) {
    return new IFC4_3.IfcCartesianPointList2D(id, v[0].map(function (p) {
      return new IFC4_3.IfcLengthMeasure(p.value);
    }), !v[1] ? null : v[1].map(function (p) {
      return new IFC4_3.IfcLabel(p.value);
    }));
  },
  2059837836: function _(id, v) {
    return new IFC4_3.IfcCartesianPointList3D(id, v[0].map(function (p) {
      return new IFC4_3.IfcLengthMeasure(p.value);
    }), !v[1] ? null : v[1].map(function (p) {
      return new IFC4_3.IfcLabel(p.value);
    }));
  },
  59481748: function _(id, v) {
    return new IFC4_3.IfcCartesianTransformationOperator(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value));
  },
  3749851601: function _(id, v) {
    return new IFC4_3.IfcCartesianTransformationOperator2D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value));
  },
  3486308946: function _(id, v) {
    return new IFC4_3.IfcCartesianTransformationOperator2DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value), !v[4] ? null : new IFC4_3.IfcReal(v[4].value));
  },
  3331915920: function _(id, v) {
    return new IFC4_3.IfcCartesianTransformationOperator3D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value), !v[4] ? null : new Handle(v[4].value));
  },
  1416205885: function _(id, v) {
    return new IFC4_3.IfcCartesianTransformationOperator3DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4_3.IfcReal(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4_3.IfcReal(v[5].value), !v[6] ? null : new IFC4_3.IfcReal(v[6].value));
  },
  1383045692: function _(id, v) {
    return new IFC4_3.IfcCircleProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value));
  },
  2205249479: function _(id, v) {
    return new IFC4_3.IfcClosedShell(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  776857604: function _(id, v) {
    return new IFC4_3.IfcColourRgb(id, !v[0] ? null : new IFC4_3.IfcLabel(v[0].value), new IFC4_3.IfcNormalisedRatioMeasure(v[1].value), new IFC4_3.IfcNormalisedRatioMeasure(v[2].value), new IFC4_3.IfcNormalisedRatioMeasure(v[3].value));
  },
  2542286263: function _(id, v) {
    return new IFC4_3.IfcComplexProperty(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), new IFC4_3.IfcIdentifier(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2485617015: function _(id, v) {
    return new IFC4_3.IfcCompositeCurveSegment(id, v[0], new IFC4_3.IfcBoolean(v[1].value), new Handle(v[2].value));
  },
  2574617495: function _(id, v) {
    return new IFC4_3.IfcConstructionResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value));
  },
  3419103109: function _(id, v) {
    return new IFC4_3.IfcContext(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new Handle(v[8].value));
  },
  1815067380: function _(id, v) {
    return new IFC4_3.IfcCrewResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  2506170314: function _(id, v) {
    return new IFC4_3.IfcCsgPrimitive3D(id, new Handle(v[0].value));
  },
  2147822146: function _(id, v) {
    return new IFC4_3.IfcCsgSolid(id, new Handle(v[0].value));
  },
  2601014836: function _(id, _62) {
    return new IFC4_3.IfcCurve(id);
  },
  2827736869: function _(id, v) {
    return new IFC4_3.IfcCurveBoundedPlane(id, new Handle(v[0].value), new Handle(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2629017746: function _(id, v) {
    return new IFC4_3.IfcCurveBoundedSurface(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), new IFC4_3.IfcBoolean(v[2].value));
  },
  4212018352: function _(id, v) {
    return new IFC4_3.IfcCurveSegment(id, v[0], new Handle(v[1].value), TypeInitialiser(2, v[2]), TypeInitialiser(2, v[3]), new Handle(v[4].value));
  },
  32440307: function _(id, v) {
    return new IFC4_3.IfcDirection(id, v[0].map(function (p) {
      return new IFC4_3.IfcReal(p.value);
    }));
  },
  593015953: function _(id, v) {
    return new IFC4_3.IfcDirectrixCurveSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]));
  },
  1472233963: function _(id, v) {
    return new IFC4_3.IfcEdgeLoop(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1883228015: function _(id, v) {
    return new IFC4_3.IfcElementQuantity(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  339256511: function _(id, v) {
    return new IFC4_3.IfcElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  2777663545: function _(id, v) {
    return new IFC4_3.IfcElementarySurface(id, new Handle(v[0].value));
  },
  2835456948: function _(id, v) {
    return new IFC4_3.IfcEllipseProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value));
  },
  4024345920: function _(id, v) {
    return new IFC4_3.IfcEventType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4_3.IfcLabel(v[11].value));
  },
  477187591: function _(id, v) {
    return new IFC4_3.IfcExtrudedAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value));
  },
  2804161546: function _(id, v) {
    return new IFC4_3.IfcExtrudedAreaSolidTapered(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new Handle(v[4].value));
  },
  2047409740: function _(id, v) {
    return new IFC4_3.IfcFaceBasedSurfaceModel(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  374418227: function _(id, v) {
    return new IFC4_3.IfcFillAreaStyleHatching(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), new IFC4_3.IfcPlaneAngleMeasure(v[4].value));
  },
  315944413: function _(id, v) {
    return new IFC4_3.IfcFillAreaStyleTiles(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1].map(function (p) {
      return new Handle(p.value);
    }), new IFC4_3.IfcPositiveRatioMeasure(v[2].value));
  },
  2652556860: function _(id, v) {
    return new IFC4_3.IfcFixedReferenceSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), new Handle(v[5].value));
  },
  4238390223: function _(id, v) {
    return new IFC4_3.IfcFurnishingElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  1268542332: function _(id, v) {
    return new IFC4_3.IfcFurnitureType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], v[10]);
  },
  4095422895: function _(id, v) {
    return new IFC4_3.IfcGeographicElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  987898635: function _(id, v) {
    return new IFC4_3.IfcGeometricCurveSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1484403080: function _(id, v) {
    return new IFC4_3.IfcIShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[9].value));
  },
  178912537: function _(id, v) {
    return new IFC4_3.IfcIndexedPolygonalFace(id, v[0].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }));
  },
  2294589976: function _(id, v) {
    return new IFC4_3.IfcIndexedPolygonalFaceWithVoids(id, v[0].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }), v[1].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }));
  },
  3465909080: function _(id, v) {
    return new IFC4_3.IfcIndexedPolygonalTextureMap(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  572779678: function _(id, v) {
    return new IFC4_3.IfcLShapeProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcPlaneAngleMeasure(v[8].value));
  },
  428585644: function _(id, v) {
    return new IFC4_3.IfcLaborResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  1281925730: function _(id, v) {
    return new IFC4_3.IfcLine(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  1425443689: function _(id, v) {
    return new IFC4_3.IfcManifoldSolidBrep(id, new Handle(v[0].value));
  },
  3888040117: function _(id, v) {
    return new IFC4_3.IfcObject(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  590820931: function _(id, v) {
    return new IFC4_3.IfcOffsetCurve(id, new Handle(v[0].value));
  },
  3388369263: function _(id, v) {
    return new IFC4_3.IfcOffsetCurve2D(id, new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), new IFC4_3.IfcLogical(v[2].value));
  },
  3505215534: function _(id, v) {
    return new IFC4_3.IfcOffsetCurve3D(id, new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), new IFC4_3.IfcLogical(v[2].value), new Handle(v[3].value));
  },
  2485787929: function _(id, v) {
    return new IFC4_3.IfcOffsetCurveByDistances(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value));
  },
  1682466193: function _(id, v) {
    return new IFC4_3.IfcPcurve(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  603570806: function _(id, v) {
    return new IFC4_3.IfcPlanarBox(id, new IFC4_3.IfcLengthMeasure(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), new Handle(v[2].value));
  },
  220341763: function _(id, v) {
    return new IFC4_3.IfcPlane(id, new Handle(v[0].value));
  },
  3381221214: function _(id, v) {
    return new IFC4_3.IfcPolynomialCurve(id, new Handle(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return new IFC4_3.IfcReal(p.value);
    }), !v[2] ? null : v[2].map(function (p) {
      return new IFC4_3.IfcReal(p.value);
    }), !v[3] ? null : v[3].map(function (p) {
      return new IFC4_3.IfcReal(p.value);
    }));
  },
  759155922: function _(id, v) {
    return new IFC4_3.IfcPreDefinedColour(id, new IFC4_3.IfcLabel(v[0].value));
  },
  2559016684: function _(id, v) {
    return new IFC4_3.IfcPreDefinedCurveFont(id, new IFC4_3.IfcLabel(v[0].value));
  },
  3967405729: function _(id, v) {
    return new IFC4_3.IfcPreDefinedPropertySet(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  569719735: function _(id, v) {
    return new IFC4_3.IfcProcedureType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2945172077: function _(id, v) {
    return new IFC4_3.IfcProcess(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value));
  },
  4208778838: function _(id, v) {
    return new IFC4_3.IfcProduct(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  103090709: function _(id, v) {
    return new IFC4_3.IfcProject(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new Handle(v[8].value));
  },
  653396225: function _(id, v) {
    return new IFC4_3.IfcProjectLibrary(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new Handle(v[8].value));
  },
  871118103: function _(id, v) {
    return new IFC4_3.IfcPropertyBoundedValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : TypeInitialiser(2, v[5]));
  },
  4166981789: function _(id, v) {
    return new IFC4_3.IfcPropertyEnumeratedValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return TypeInitialiser(2, p);
    }), !v[3] ? null : new Handle(v[3].value));
  },
  2752243245: function _(id, v) {
    return new IFC4_3.IfcPropertyListValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return TypeInitialiser(2, p);
    }), !v[3] ? null : new Handle(v[3].value));
  },
  941946838: function _(id, v) {
    return new IFC4_3.IfcPropertyReferenceValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : new IFC4_3.IfcText(v[2].value), !v[3] ? null : new Handle(v[3].value));
  },
  1451395588: function _(id, v) {
    return new IFC4_3.IfcPropertySet(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }));
  },
  492091185: function _(id, v) {
    return new IFC4_3.IfcPropertySetTemplate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4], !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3650150729: function _(id, v) {
    return new IFC4_3.IfcPropertySingleValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(2, v[2]), !v[3] ? null : new Handle(v[3].value));
  },
  110355661: function _(id, v) {
    return new IFC4_3.IfcPropertyTableValue(id, new IFC4_3.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4_3.IfcText(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return TypeInitialiser(2, p);
    }), !v[3] ? null : v[3].map(function (p) {
      return TypeInitialiser(2, p);
    }), !v[4] ? null : new IFC4_3.IfcText(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]);
  },
  3521284610: function _(id, v) {
    return new IFC4_3.IfcPropertyTemplate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  2770003689: function _(id, v) {
    return new IFC4_3.IfcRectangleHollowProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value), new IFC4_3.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value));
  },
  2798486643: function _(id, v) {
    return new IFC4_3.IfcRectangularPyramid(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value));
  },
  3454111270: function _(id, v) {
    return new IFC4_3.IfcRectangularTrimmedSurface(id, new Handle(v[0].value), new IFC4_3.IfcParameterValue(v[1].value), new IFC4_3.IfcParameterValue(v[2].value), new IFC4_3.IfcParameterValue(v[3].value), new IFC4_3.IfcParameterValue(v[4].value), new IFC4_3.IfcBoolean(v[5].value), new IFC4_3.IfcBoolean(v[6].value));
  },
  3765753017: function _(id, v) {
    return new IFC4_3.IfcReinforcementDefinitionProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3939117080: function _(id, v) {
    return new IFC4_3.IfcRelAssigns(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5]);
  },
  1683148259: function _(id, v) {
    return new IFC4_3.IfcRelAssignsToActor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  2495723537: function _(id, v) {
    return new IFC4_3.IfcRelAssignsToControl(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  1307041759: function _(id, v) {
    return new IFC4_3.IfcRelAssignsToGroup(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  1027710054: function _(id, v) {
    return new IFC4_3.IfcRelAssignsToGroupByFactor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value), new IFC4_3.IfcRatioMeasure(v[7].value));
  },
  4278684876: function _(id, v) {
    return new IFC4_3.IfcRelAssignsToProcess(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  2857406711: function _(id, v) {
    return new IFC4_3.IfcRelAssignsToProduct(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  205026976: function _(id, v) {
    return new IFC4_3.IfcRelAssignsToResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  1865459582: function _(id, v) {
    return new IFC4_3.IfcRelAssociates(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }));
  },
  4095574036: function _(id, v) {
    return new IFC4_3.IfcRelAssociatesApproval(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  919958153: function _(id, v) {
    return new IFC4_3.IfcRelAssociatesClassification(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  2728634034: function _(id, v) {
    return new IFC4_3.IfcRelAssociatesConstraint(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), new Handle(v[6].value));
  },
  982818633: function _(id, v) {
    return new IFC4_3.IfcRelAssociatesDocument(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  3840914261: function _(id, v) {
    return new IFC4_3.IfcRelAssociatesLibrary(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  2655215786: function _(id, v) {
    return new IFC4_3.IfcRelAssociatesMaterial(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  1033248425: function _(id, v) {
    return new IFC4_3.IfcRelAssociatesProfileDef(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  826625072: function _(id, v) {
    return new IFC4_3.IfcRelConnects(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  1204542856: function _(id, v) {
    return new IFC4_3.IfcRelConnectsElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value));
  },
  3945020480: function _(id, v) {
    return new IFC4_3.IfcRelConnectsPathElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map(function (p) {
      return new IFC4_3.IfcInteger(p.value);
    }), v[8].map(function (p) {
      return new IFC4_3.IfcInteger(p.value);
    }), v[9], v[10]);
  },
  4201705270: function _(id, v) {
    return new IFC4_3.IfcRelConnectsPortToElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  3190031847: function _(id, v) {
    return new IFC4_3.IfcRelConnectsPorts(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  2127690289: function _(id, v) {
    return new IFC4_3.IfcRelConnectsStructuralActivity(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  1638771189: function _(id, v) {
    return new IFC4_3.IfcRelConnectsStructuralMember(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC4_3.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value));
  },
  504942748: function _(id, v) {
    return new IFC4_3.IfcRelConnectsWithEccentricity(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC4_3.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value), new Handle(v[10].value));
  },
  3678494232: function _(id, v) {
    return new IFC4_3.IfcRelConnectsWithRealizingElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  3242617779: function _(id, v) {
    return new IFC4_3.IfcRelContainedInSpatialStructure(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  886880790: function _(id, v) {
    return new IFC4_3.IfcRelCoversBldgElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2802773753: function _(id, v) {
    return new IFC4_3.IfcRelCoversSpaces(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2565941209: function _(id, v) {
    return new IFC4_3.IfcRelDeclares(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2551354335: function _(id, v) {
    return new IFC4_3.IfcRelDecomposes(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  693640335: function _(id, v) {
    return new IFC4_3.IfcRelDefines(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value));
  },
  1462361463: function _(id, v) {
    return new IFC4_3.IfcRelDefinesByObject(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  4186316022: function _(id, v) {
    return new IFC4_3.IfcRelDefinesByProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  307848117: function _(id, v) {
    return new IFC4_3.IfcRelDefinesByTemplate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  781010003: function _(id, v) {
    return new IFC4_3.IfcRelDefinesByType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  3940055652: function _(id, v) {
    return new IFC4_3.IfcRelFillsElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  279856033: function _(id, v) {
    return new IFC4_3.IfcRelFlowControlElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  427948657: function _(id, v) {
    return new IFC4_3.IfcRelInterferesElements(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC4_3.IfcIdentifier(v[8].value), new IFC4_3.IfcLogical(v[9].value));
  },
  3268803585: function _(id, v) {
    return new IFC4_3.IfcRelNests(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1441486842: function _(id, v) {
    return new IFC4_3.IfcRelPositions(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  750771296: function _(id, v) {
    return new IFC4_3.IfcRelProjectsElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  1245217292: function _(id, v) {
    return new IFC4_3.IfcRelReferencedInSpatialStructure(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  4122056220: function _(id, v) {
    return new IFC4_3.IfcRelSequence(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  366585022: function _(id, v) {
    return new IFC4_3.IfcRelServicesBuildings(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3451746338: function _(id, v) {
    return new IFC4_3.IfcRelSpaceBoundary(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8]);
  },
  3523091289: function _(id, v) {
    return new IFC4_3.IfcRelSpaceBoundary1stLevel(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], !v[9] ? null : new Handle(v[9].value));
  },
  1521410863: function _(id, v) {
    return new IFC4_3.IfcRelSpaceBoundary2ndLevel(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value));
  },
  1401173127: function _(id, v) {
    return new IFC4_3.IfcRelVoidsElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  816062949: function _(id, v) {
    return new IFC4_3.IfcReparametrisedCompositeCurveSegment(id, v[0], new IFC4_3.IfcBoolean(v[1].value), new Handle(v[2].value), new IFC4_3.IfcParameterValue(v[3].value));
  },
  2914609552: function _(id, v) {
    return new IFC4_3.IfcResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value));
  },
  1856042241: function _(id, v) {
    return new IFC4_3.IfcRevolvedAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPlaneAngleMeasure(v[3].value));
  },
  3243963512: function _(id, v) {
    return new IFC4_3.IfcRevolvedAreaSolidTapered(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcPlaneAngleMeasure(v[3].value), new Handle(v[4].value));
  },
  4158566097: function _(id, v) {
    return new IFC4_3.IfcRightCircularCone(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value));
  },
  3626867408: function _(id, v) {
    return new IFC4_3.IfcRightCircularCylinder(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value));
  },
  1862484736: function _(id, v) {
    return new IFC4_3.IfcSectionedSolid(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1290935644: function _(id, v) {
    return new IFC4_3.IfcSectionedSolidHorizontal(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1356537516: function _(id, v) {
    return new IFC4_3.IfcSectionedSurface(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3663146110: function _(id, v) {
    return new IFC4_3.IfcSimplePropertyTemplate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4], !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), !v[6] ? null : new IFC4_3.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new IFC4_3.IfcLabel(v[10].value), v[11]);
  },
  1412071761: function _(id, v) {
    return new IFC4_3.IfcSpatialElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value));
  },
  710998568: function _(id, v) {
    return new IFC4_3.IfcSpatialElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  2706606064: function _(id, v) {
    return new IFC4_3.IfcSpatialStructureElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8]);
  },
  3893378262: function _(id, v) {
    return new IFC4_3.IfcSpatialStructureElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  463610769: function _(id, v) {
    return new IFC4_3.IfcSpatialZone(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8]);
  },
  2481509218: function _(id, v) {
    return new IFC4_3.IfcSpatialZoneType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcLabel(v[10].value));
  },
  451544542: function _(id, v) {
    return new IFC4_3.IfcSphere(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value));
  },
  4015995234: function _(id, v) {
    return new IFC4_3.IfcSphericalSurface(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value));
  },
  2735484536: function _(id, v) {
    return new IFC4_3.IfcSpiral(id, !v[0] ? null : new Handle(v[0].value));
  },
  3544373492: function _(id, v) {
    return new IFC4_3.IfcStructuralActivity(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]);
  },
  3136571912: function _(id, v) {
    return new IFC4_3.IfcStructuralItem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  530289379: function _(id, v) {
    return new IFC4_3.IfcStructuralMember(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  3689010777: function _(id, v) {
    return new IFC4_3.IfcStructuralReaction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]);
  },
  3979015343: function _(id, v) {
    return new IFC4_3.IfcStructuralSurfaceMember(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[8].value));
  },
  2218152070: function _(id, v) {
    return new IFC4_3.IfcStructuralSurfaceMemberVarying(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[8].value));
  },
  603775116: function _(id, v) {
    return new IFC4_3.IfcStructuralSurfaceReaction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9]);
  },
  4095615324: function _(id, v) {
    return new IFC4_3.IfcSubContractResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  699246055: function _(id, v) {
    return new IFC4_3.IfcSurfaceCurve(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2]);
  },
  2028607225: function _(id, v) {
    return new IFC4_3.IfcSurfaceCurveSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), new Handle(v[5].value));
  },
  2809605785: function _(id, v) {
    return new IFC4_3.IfcSurfaceOfLinearExtrusion(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4_3.IfcLengthMeasure(v[3].value));
  },
  4124788165: function _(id, v) {
    return new IFC4_3.IfcSurfaceOfRevolution(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value));
  },
  1580310250: function _(id, v) {
    return new IFC4_3.IfcSystemFurnitureElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3473067441: function _(id, v) {
    return new IFC4_3.IfcTask(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), new IFC4_3.IfcBoolean(v[9].value), !v[10] ? null : new IFC4_3.IfcInteger(v[10].value), !v[11] ? null : new Handle(v[11].value), v[12]);
  },
  3206491090: function _(id, v) {
    return new IFC4_3.IfcTaskType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcLabel(v[10].value));
  },
  2387106220: function _(id, v) {
    return new IFC4_3.IfcTessellatedFaceSet(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcBoolean(v[1].value));
  },
  782932809: function _(id, v) {
    return new IFC4_3.IfcThirdOrderPolynomialSpiral(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLengthMeasure(v[4].value));
  },
  1935646853: function _(id, v) {
    return new IFC4_3.IfcToroidalSurface(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value));
  },
  3665877780: function _(id, v) {
    return new IFC4_3.IfcTransportationDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  2916149573: function _(id, v) {
    return new IFC4_3.IfcTriangulatedFaceSet(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return new IFC4_3.IfcParameterValue(p.value);
    }), v[3].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }));
  },
  1229763772: function _(id, v) {
    return new IFC4_3.IfcTriangulatedIrregularNetwork(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcBoolean(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return new IFC4_3.IfcParameterValue(p.value);
    }), v[3].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }), v[5].map(function (p) {
      return new IFC4_3.IfcInteger(p.value);
    }));
  },
  3651464721: function _(id, v) {
    return new IFC4_3.IfcVehicleType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  336235671: function _(id, v) {
    return new IFC4_3.IfcWindowLiningProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[11].value), !v[12] ? null : new Handle(v[12].value), !v[13] ? null : new IFC4_3.IfcLengthMeasure(v[13].value), !v[14] ? null : new IFC4_3.IfcLengthMeasure(v[14].value), !v[15] ? null : new IFC4_3.IfcLengthMeasure(v[15].value));
  },
  512836454: function _(id, v) {
    return new IFC4_3.IfcWindowPanelProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value));
  },
  2296667514: function _(id, v) {
    return new IFC4_3.IfcActor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), new Handle(v[5].value));
  },
  1635779807: function _(id, v) {
    return new IFC4_3.IfcAdvancedBrep(id, new Handle(v[0].value));
  },
  2603310189: function _(id, v) {
    return new IFC4_3.IfcAdvancedBrepWithVoids(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1674181508: function _(id, v) {
    return new IFC4_3.IfcAnnotation(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]);
  },
  2887950389: function _(id, v) {
    return new IFC4_3.IfcBSplineSurface(id, new IFC4_3.IfcInteger(v[0].value), new IFC4_3.IfcInteger(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), v[3], new IFC4_3.IfcLogical(v[4].value), new IFC4_3.IfcLogical(v[5].value), new IFC4_3.IfcLogical(v[6].value));
  },
  167062518: function _(id, v) {
    return new IFC4_3.IfcBSplineSurfaceWithKnots(id, new IFC4_3.IfcInteger(v[0].value), new IFC4_3.IfcInteger(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), v[3], new IFC4_3.IfcLogical(v[4].value), new IFC4_3.IfcLogical(v[5].value), new IFC4_3.IfcLogical(v[6].value), v[7].map(function (p) {
      return new IFC4_3.IfcInteger(p.value);
    }), v[8].map(function (p) {
      return new IFC4_3.IfcInteger(p.value);
    }), v[9].map(function (p) {
      return new IFC4_3.IfcParameterValue(p.value);
    }), v[10].map(function (p) {
      return new IFC4_3.IfcParameterValue(p.value);
    }), v[11]);
  },
  1334484129: function _(id, v) {
    return new IFC4_3.IfcBlock(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value));
  },
  3649129432: function _(id, v) {
    return new IFC4_3.IfcBooleanClippingResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value));
  },
  1260505505: function _(id, _63) {
    return new IFC4_3.IfcBoundedCurve(id);
  },
  3124254112: function _(id, v) {
    return new IFC4_3.IfcBuildingStorey(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcLengthMeasure(v[9].value));
  },
  1626504194: function _(id, v) {
    return new IFC4_3.IfcBuiltElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  2197970202: function _(id, v) {
    return new IFC4_3.IfcChimneyType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2937912522: function _(id, v) {
    return new IFC4_3.IfcCircleHollowProfileDef(id, v[0], !v[1] ? null : new IFC4_3.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4_3.IfcPositiveLengthMeasure(v[3].value), new IFC4_3.IfcPositiveLengthMeasure(v[4].value));
  },
  3893394355: function _(id, v) {
    return new IFC4_3.IfcCivilElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  3497074424: function _(id, v) {
    return new IFC4_3.IfcClothoid(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value));
  },
  300633059: function _(id, v) {
    return new IFC4_3.IfcColumnType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3875453745: function _(id, v) {
    return new IFC4_3.IfcComplexPropertyTemplate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3732776249: function _(id, v) {
    return new IFC4_3.IfcCompositeCurve(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4_3.IfcLogical(v[1].value));
  },
  15328376: function _(id, v) {
    return new IFC4_3.IfcCompositeCurveOnSurface(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4_3.IfcLogical(v[1].value));
  },
  2510884976: function _(id, v) {
    return new IFC4_3.IfcConic(id, new Handle(v[0].value));
  },
  2185764099: function _(id, v) {
    return new IFC4_3.IfcConstructionEquipmentResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  4105962743: function _(id, v) {
    return new IFC4_3.IfcConstructionMaterialResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  1525564444: function _(id, v) {
    return new IFC4_3.IfcConstructionProductResourceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4_3.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4_3.IfcText(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  2559216714: function _(id, v) {
    return new IFC4_3.IfcConstructionResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value));
  },
  3293443760: function _(id, v) {
    return new IFC4_3.IfcControl(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value));
  },
  2000195564: function _(id, v) {
    return new IFC4_3.IfcCosineSpiral(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value));
  },
  3895139033: function _(id, v) {
    return new IFC4_3.IfcCostItem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1419761937: function _(id, v) {
    return new IFC4_3.IfcCostSchedule(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcDateTime(v[8].value), !v[9] ? null : new IFC4_3.IfcDateTime(v[9].value));
  },
  4189326743: function _(id, v) {
    return new IFC4_3.IfcCourseType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1916426348: function _(id, v) {
    return new IFC4_3.IfcCoveringType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3295246426: function _(id, v) {
    return new IFC4_3.IfcCrewResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  1457835157: function _(id, v) {
    return new IFC4_3.IfcCurtainWallType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1213902940: function _(id, v) {
    return new IFC4_3.IfcCylindricalSurface(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value));
  },
  1306400036: function _(id, v) {
    return new IFC4_3.IfcDeepFoundationType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  4234616927: function _(id, v) {
    return new IFC4_3.IfcDirectrixDerivedReferenceSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : TypeInitialiser(2, v[3]), !v[4] ? null : TypeInitialiser(2, v[4]), new Handle(v[5].value));
  },
  3256556792: function _(id, v) {
    return new IFC4_3.IfcDistributionElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  3849074793: function _(id, v) {
    return new IFC4_3.IfcDistributionFlowElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  2963535650: function _(id, v) {
    return new IFC4_3.IfcDoorLiningProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new Handle(v[14].value), !v[15] ? null : new IFC4_3.IfcLengthMeasure(v[15].value), !v[16] ? null : new IFC4_3.IfcLengthMeasure(v[16].value));
  },
  1714330368: function _(id, v) {
    return new IFC4_3.IfcDoorPanelProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[4].value), v[5], !v[6] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value));
  },
  2323601079: function _(id, v) {
    return new IFC4_3.IfcDoorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4_3.IfcBoolean(v[11].value), !v[12] ? null : new IFC4_3.IfcLabel(v[12].value));
  },
  445594917: function _(id, v) {
    return new IFC4_3.IfcDraughtingPreDefinedColour(id, new IFC4_3.IfcLabel(v[0].value));
  },
  4006246654: function _(id, v) {
    return new IFC4_3.IfcDraughtingPreDefinedCurveFont(id, new IFC4_3.IfcLabel(v[0].value));
  },
  1758889154: function _(id, v) {
    return new IFC4_3.IfcElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  4123344466: function _(id, v) {
    return new IFC4_3.IfcElementAssembly(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8], v[9]);
  },
  2397081782: function _(id, v) {
    return new IFC4_3.IfcElementAssemblyType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1623761950: function _(id, v) {
    return new IFC4_3.IfcElementComponent(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  2590856083: function _(id, v) {
    return new IFC4_3.IfcElementComponentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  1704287377: function _(id, v) {
    return new IFC4_3.IfcEllipse(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value), new IFC4_3.IfcPositiveLengthMeasure(v[2].value));
  },
  2107101300: function _(id, v) {
    return new IFC4_3.IfcEnergyConversionDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  132023988: function _(id, v) {
    return new IFC4_3.IfcEngineType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3174744832: function _(id, v) {
    return new IFC4_3.IfcEvaporativeCoolerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3390157468: function _(id, v) {
    return new IFC4_3.IfcEvaporatorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  4148101412: function _(id, v) {
    return new IFC4_3.IfcEvent(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), v[7], v[8], !v[9] ? null : new IFC4_3.IfcLabel(v[9].value), !v[10] ? null : new Handle(v[10].value));
  },
  2853485674: function _(id, v) {
    return new IFC4_3.IfcExternalSpatialStructureElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value));
  },
  807026263: function _(id, v) {
    return new IFC4_3.IfcFacetedBrep(id, new Handle(v[0].value));
  },
  3737207727: function _(id, v) {
    return new IFC4_3.IfcFacetedBrepWithVoids(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  24185140: function _(id, v) {
    return new IFC4_3.IfcFacility(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8]);
  },
  1310830890: function _(id, v) {
    return new IFC4_3.IfcFacilityPart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9]);
  },
  4228831410: function _(id, v) {
    return new IFC4_3.IfcFacilityPartCommon(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], v[10]);
  },
  647756555: function _(id, v) {
    return new IFC4_3.IfcFastener(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2489546625: function _(id, v) {
    return new IFC4_3.IfcFastenerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2827207264: function _(id, v) {
    return new IFC4_3.IfcFeatureElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  2143335405: function _(id, v) {
    return new IFC4_3.IfcFeatureElementAddition(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  1287392070: function _(id, v) {
    return new IFC4_3.IfcFeatureElementSubtraction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  3907093117: function _(id, v) {
    return new IFC4_3.IfcFlowControllerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  3198132628: function _(id, v) {
    return new IFC4_3.IfcFlowFittingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  3815607619: function _(id, v) {
    return new IFC4_3.IfcFlowMeterType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1482959167: function _(id, v) {
    return new IFC4_3.IfcFlowMovingDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  1834744321: function _(id, v) {
    return new IFC4_3.IfcFlowSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  1339347760: function _(id, v) {
    return new IFC4_3.IfcFlowStorageDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  2297155007: function _(id, v) {
    return new IFC4_3.IfcFlowTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  3009222698: function _(id, v) {
    return new IFC4_3.IfcFlowTreatmentDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  1893162501: function _(id, v) {
    return new IFC4_3.IfcFootingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  263784265: function _(id, v) {
    return new IFC4_3.IfcFurnishingElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  1509553395: function _(id, v) {
    return new IFC4_3.IfcFurniture(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3493046030: function _(id, v) {
    return new IFC4_3.IfcGeographicElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  4230923436: function _(id, v) {
    return new IFC4_3.IfcGeotechnicalElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  1594536857: function _(id, v) {
    return new IFC4_3.IfcGeotechnicalStratum(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2898700619: function _(id, v) {
    return new IFC4_3.IfcGradientCurve(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4_3.IfcLogical(v[1].value), new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value));
  },
  2706460486: function _(id, v) {
    return new IFC4_3.IfcGroup(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  1251058090: function _(id, v) {
    return new IFC4_3.IfcHeatExchangerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1806887404: function _(id, v) {
    return new IFC4_3.IfcHumidifierType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2568555532: function _(id, v) {
    return new IFC4_3.IfcImpactProtectionDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3948183225: function _(id, v) {
    return new IFC4_3.IfcImpactProtectionDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2571569899: function _(id, v) {
    return new IFC4_3.IfcIndexedPolyCurve(id, new Handle(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return TypeInitialiser(2, p);
    }), new IFC4_3.IfcLogical(v[2].value));
  },
  3946677679: function _(id, v) {
    return new IFC4_3.IfcInterceptorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3113134337: function _(id, v) {
    return new IFC4_3.IfcIntersectionCurve(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2]);
  },
  2391368822: function _(id, v) {
    return new IFC4_3.IfcInventory(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC4_3.IfcDate(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value));
  },
  4288270099: function _(id, v) {
    return new IFC4_3.IfcJunctionBoxType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  679976338: function _(id, v) {
    return new IFC4_3.IfcKerbType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), new IFC4_3.IfcBoolean(v[9].value));
  },
  3827777499: function _(id, v) {
    return new IFC4_3.IfcLaborResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  1051575348: function _(id, v) {
    return new IFC4_3.IfcLampType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1161773419: function _(id, v) {
    return new IFC4_3.IfcLightFixtureType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2176059722: function _(id, v) {
    return new IFC4_3.IfcLinearElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  1770583370: function _(id, v) {
    return new IFC4_3.IfcLiquidTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  525669439: function _(id, v) {
    return new IFC4_3.IfcMarineFacility(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9]);
  },
  976884017: function _(id, v) {
    return new IFC4_3.IfcMarinePart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], v[10]);
  },
  377706215: function _(id, v) {
    return new IFC4_3.IfcMechanicalFastener(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), v[10]);
  },
  2108223431: function _(id, v) {
    return new IFC4_3.IfcMechanicalFastenerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[11].value));
  },
  1114901282: function _(id, v) {
    return new IFC4_3.IfcMedicalDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3181161470: function _(id, v) {
    return new IFC4_3.IfcMemberType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1950438474: function _(id, v) {
    return new IFC4_3.IfcMobileTelecommunicationsApplianceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  710110818: function _(id, v) {
    return new IFC4_3.IfcMooringDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  977012517: function _(id, v) {
    return new IFC4_3.IfcMotorConnectionType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  506776471: function _(id, v) {
    return new IFC4_3.IfcNavigationElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  4143007308: function _(id, v) {
    return new IFC4_3.IfcOccupant(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), new Handle(v[5].value), v[6]);
  },
  3588315303: function _(id, v) {
    return new IFC4_3.IfcOpeningElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2837617999: function _(id, v) {
    return new IFC4_3.IfcOutletType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  514975943: function _(id, v) {
    return new IFC4_3.IfcPavementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2382730787: function _(id, v) {
    return new IFC4_3.IfcPerformanceHistory(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), new IFC4_3.IfcLabel(v[6].value), v[7]);
  },
  3566463478: function _(id, v) {
    return new IFC4_3.IfcPermeableCoveringProperties(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value));
  },
  3327091369: function _(id, v) {
    return new IFC4_3.IfcPermit(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcText(v[8].value));
  },
  1158309216: function _(id, v) {
    return new IFC4_3.IfcPileType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  804291784: function _(id, v) {
    return new IFC4_3.IfcPipeFittingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  4231323485: function _(id, v) {
    return new IFC4_3.IfcPipeSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  4017108033: function _(id, v) {
    return new IFC4_3.IfcPlateType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2839578677: function _(id, v) {
    return new IFC4_3.IfcPolygonalFaceSet(id, new Handle(v[0].value), !v[1] ? null : new IFC4_3.IfcBoolean(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : v[3].map(function (p) {
      return new IFC4_3.IfcPositiveInteger(p.value);
    }));
  },
  3724593414: function _(id, v) {
    return new IFC4_3.IfcPolyline(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3740093272: function _(id, v) {
    return new IFC4_3.IfcPort(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  1946335990: function _(id, v) {
    return new IFC4_3.IfcPositioningElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  2744685151: function _(id, v) {
    return new IFC4_3.IfcProcedure(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), v[7]);
  },
  2904328755: function _(id, v) {
    return new IFC4_3.IfcProjectOrder(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcText(v[8].value));
  },
  3651124850: function _(id, v) {
    return new IFC4_3.IfcProjectionElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1842657554: function _(id, v) {
    return new IFC4_3.IfcProtectiveDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2250791053: function _(id, v) {
    return new IFC4_3.IfcPumpType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1763565496: function _(id, v) {
    return new IFC4_3.IfcRailType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2893384427: function _(id, v) {
    return new IFC4_3.IfcRailingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3992365140: function _(id, v) {
    return new IFC4_3.IfcRailway(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9]);
  },
  1891881377: function _(id, v) {
    return new IFC4_3.IfcRailwayPart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], v[10]);
  },
  2324767716: function _(id, v) {
    return new IFC4_3.IfcRampFlightType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1469900589: function _(id, v) {
    return new IFC4_3.IfcRampType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  683857671: function _(id, v) {
    return new IFC4_3.IfcRationalBSplineSurfaceWithKnots(id, new IFC4_3.IfcInteger(v[0].value), new IFC4_3.IfcInteger(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), v[3], new IFC4_3.IfcLogical(v[4].value), new IFC4_3.IfcLogical(v[5].value), new IFC4_3.IfcLogical(v[6].value), v[7].map(function (p) {
      return new IFC4_3.IfcInteger(p.value);
    }), v[8].map(function (p) {
      return new IFC4_3.IfcInteger(p.value);
    }), v[9].map(function (p) {
      return new IFC4_3.IfcParameterValue(p.value);
    }), v[10].map(function (p) {
      return new IFC4_3.IfcParameterValue(p.value);
    }), v[11], v[12].map(function (p) {
      return new IFC4_3.IfcReal(p.value);
    }));
  },
  4021432810: function _(id, v) {
    return new IFC4_3.IfcReferent(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]);
  },
  3027567501: function _(id, v) {
    return new IFC4_3.IfcReinforcingElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  964333572: function _(id, v) {
    return new IFC4_3.IfcReinforcingElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  2320036040: function _(id, v) {
    return new IFC4_3.IfcReinforcingMesh(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcAreaMeasure(v[13].value), !v[14] ? null : new IFC4_3.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[15].value), !v[16] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[16].value), v[17]);
  },
  2310774935: function _(id, v) {
    return new IFC4_3.IfcReinforcingMeshType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new IFC4_3.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC4_3.IfcAreaMeasure(v[15].value), !v[16] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[16].value), !v[17] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[17].value), !v[18] ? null : new IFC4_3.IfcLabel(v[18].value), !v[19] ? null : v[19].map(function (p) {
      return TypeInitialiser(2, p);
    }));
  },
  3818125796: function _(id, v) {
    return new IFC4_3.IfcRelAdheresToElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  160246688: function _(id, v) {
    return new IFC4_3.IfcRelAggregates(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  146592293: function _(id, v) {
    return new IFC4_3.IfcRoad(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9]);
  },
  550521510: function _(id, v) {
    return new IFC4_3.IfcRoadPart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], v[10]);
  },
  2781568857: function _(id, v) {
    return new IFC4_3.IfcRoofType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1768891740: function _(id, v) {
    return new IFC4_3.IfcSanitaryTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2157484638: function _(id, v) {
    return new IFC4_3.IfcSeamCurve(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2]);
  },
  3649235739: function _(id, v) {
    return new IFC4_3.IfcSecondOrderPolynomialSpiral(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value));
  },
  544395925: function _(id, v) {
    return new IFC4_3.IfcSegmentedReferenceCurve(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4_3.IfcLogical(v[1].value), new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value));
  },
  1027922057: function _(id, v) {
    return new IFC4_3.IfcSeventhOrderPolynomialSpiral(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4_3.IfcLengthMeasure(v[4].value), !v[5] ? null : new IFC4_3.IfcLengthMeasure(v[5].value), !v[6] ? null : new IFC4_3.IfcLengthMeasure(v[6].value), !v[7] ? null : new IFC4_3.IfcLengthMeasure(v[7].value), !v[8] ? null : new IFC4_3.IfcLengthMeasure(v[8].value));
  },
  4074543187: function _(id, v) {
    return new IFC4_3.IfcShadingDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  33720170: function _(id, v) {
    return new IFC4_3.IfcSign(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3599934289: function _(id, v) {
    return new IFC4_3.IfcSignType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1894708472: function _(id, v) {
    return new IFC4_3.IfcSignalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  42703149: function _(id, v) {
    return new IFC4_3.IfcSineSpiral(id, !v[0] ? null : new Handle(v[0].value), new IFC4_3.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4_3.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4_3.IfcLengthMeasure(v[3].value));
  },
  4097777520: function _(id, v) {
    return new IFC4_3.IfcSite(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcCompoundPlaneAngleMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcCompoundPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcLabel(v[12].value), !v[13] ? null : new Handle(v[13].value));
  },
  2533589738: function _(id, v) {
    return new IFC4_3.IfcSlabType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1072016465: function _(id, v) {
    return new IFC4_3.IfcSolarDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3856911033: function _(id, v) {
    return new IFC4_3.IfcSpace(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], !v[10] ? null : new IFC4_3.IfcLengthMeasure(v[10].value));
  },
  1305183839: function _(id, v) {
    return new IFC4_3.IfcSpaceHeaterType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3812236995: function _(id, v) {
    return new IFC4_3.IfcSpaceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcLabel(v[10].value));
  },
  3112655638: function _(id, v) {
    return new IFC4_3.IfcStackTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1039846685: function _(id, v) {
    return new IFC4_3.IfcStairFlightType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  338393293: function _(id, v) {
    return new IFC4_3.IfcStairType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  682877961: function _(id, v) {
    return new IFC4_3.IfcStructuralAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value));
  },
  1179482911: function _(id, v) {
    return new IFC4_3.IfcStructuralConnection(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  1004757350: function _(id, v) {
    return new IFC4_3.IfcStructuralCurveAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value), v[10], v[11]);
  },
  4243806635: function _(id, v) {
    return new IFC4_3.IfcStructuralCurveConnection(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), new Handle(v[8].value));
  },
  214636428: function _(id, v) {
    return new IFC4_3.IfcStructuralCurveMember(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], new Handle(v[8].value));
  },
  2445595289: function _(id, v) {
    return new IFC4_3.IfcStructuralCurveMemberVarying(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], new Handle(v[8].value));
  },
  2757150158: function _(id, v) {
    return new IFC4_3.IfcStructuralCurveReaction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9]);
  },
  1807405624: function _(id, v) {
    return new IFC4_3.IfcStructuralLinearAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value), v[10], v[11]);
  },
  1252848954: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadGroup(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], v[6], v[7], !v[8] ? null : new IFC4_3.IfcRatioMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcLabel(v[9].value));
  },
  2082059205: function _(id, v) {
    return new IFC4_3.IfcStructuralPointAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value));
  },
  734778138: function _(id, v) {
    return new IFC4_3.IfcStructuralPointConnection(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value));
  },
  1235345126: function _(id, v) {
    return new IFC4_3.IfcStructuralPointReaction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]);
  },
  2986769608: function _(id, v) {
    return new IFC4_3.IfcStructuralResultGroup(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), new IFC4_3.IfcBoolean(v[7].value));
  },
  3657597509: function _(id, v) {
    return new IFC4_3.IfcStructuralSurfaceAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value), v[10], v[11]);
  },
  1975003073: function _(id, v) {
    return new IFC4_3.IfcStructuralSurfaceConnection(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  148013059: function _(id, v) {
    return new IFC4_3.IfcSubContractResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  3101698114: function _(id, v) {
    return new IFC4_3.IfcSurfaceFeature(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2315554128: function _(id, v) {
    return new IFC4_3.IfcSwitchingDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2254336722: function _(id, v) {
    return new IFC4_3.IfcSystem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value));
  },
  413509423: function _(id, v) {
    return new IFC4_3.IfcSystemFurnitureElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  5716631: function _(id, v) {
    return new IFC4_3.IfcTankType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3824725483: function _(id, v) {
    return new IFC4_3.IfcTendon(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcForceMeasure(v[12].value), !v[13] ? null : new IFC4_3.IfcPressureMeasure(v[13].value), !v[14] ? null : new IFC4_3.IfcNormalisedRatioMeasure(v[14].value), !v[15] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[15].value), !v[16] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[16].value));
  },
  2347447852: function _(id, v) {
    return new IFC4_3.IfcTendonAnchor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3081323446: function _(id, v) {
    return new IFC4_3.IfcTendonAnchorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3663046924: function _(id, v) {
    return new IFC4_3.IfcTendonConduit(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2281632017: function _(id, v) {
    return new IFC4_3.IfcTendonConduitType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2415094496: function _(id, v) {
    return new IFC4_3.IfcTendonType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[12].value));
  },
  618700268: function _(id, v) {
    return new IFC4_3.IfcTrackElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1692211062: function _(id, v) {
    return new IFC4_3.IfcTransformerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2097647324: function _(id, v) {
    return new IFC4_3.IfcTransportElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1953115116: function _(id, v) {
    return new IFC4_3.IfcTransportationDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  3593883385: function _(id, v) {
    return new IFC4_3.IfcTrimmedCurve(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2].map(function (p) {
      return new Handle(p.value);
    }), new IFC4_3.IfcBoolean(v[3].value), v[4]);
  },
  1600972822: function _(id, v) {
    return new IFC4_3.IfcTubeBundleType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1911125066: function _(id, v) {
    return new IFC4_3.IfcUnitaryEquipmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  728799441: function _(id, v) {
    return new IFC4_3.IfcValveType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  840318589: function _(id, v) {
    return new IFC4_3.IfcVehicle(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1530820697: function _(id, v) {
    return new IFC4_3.IfcVibrationDamper(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3956297820: function _(id, v) {
    return new IFC4_3.IfcVibrationDamperType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2391383451: function _(id, v) {
    return new IFC4_3.IfcVibrationIsolator(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3313531582: function _(id, v) {
    return new IFC4_3.IfcVibrationIsolatorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2769231204: function _(id, v) {
    return new IFC4_3.IfcVirtualElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  926996030: function _(id, v) {
    return new IFC4_3.IfcVoidingFeature(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1898987631: function _(id, v) {
    return new IFC4_3.IfcWallType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1133259667: function _(id, v) {
    return new IFC4_3.IfcWasteTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  4009809668: function _(id, v) {
    return new IFC4_3.IfcWindowType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4_3.IfcBoolean(v[11].value), !v[12] ? null : new IFC4_3.IfcLabel(v[12].value));
  },
  4088093105: function _(id, v) {
    return new IFC4_3.IfcWorkCalendar(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), v[8]);
  },
  1028945134: function _(id, v) {
    return new IFC4_3.IfcWorkControl(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcDuration(v[9].value), !v[10] ? null : new IFC4_3.IfcDuration(v[10].value), new IFC4_3.IfcDateTime(v[11].value), !v[12] ? null : new IFC4_3.IfcDateTime(v[12].value));
  },
  4218914973: function _(id, v) {
    return new IFC4_3.IfcWorkPlan(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcDuration(v[9].value), !v[10] ? null : new IFC4_3.IfcDuration(v[10].value), new IFC4_3.IfcDateTime(v[11].value), !v[12] ? null : new IFC4_3.IfcDateTime(v[12].value), v[13]);
  },
  3342526732: function _(id, v) {
    return new IFC4_3.IfcWorkSchedule(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), new IFC4_3.IfcDateTime(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcDuration(v[9].value), !v[10] ? null : new IFC4_3.IfcDuration(v[10].value), new IFC4_3.IfcDateTime(v[11].value), !v[12] ? null : new IFC4_3.IfcDateTime(v[12].value), v[13]);
  },
  1033361043: function _(id, v) {
    return new IFC4_3.IfcZone(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value));
  },
  3821786052: function _(id, v) {
    return new IFC4_3.IfcActionRequest(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcText(v[8].value));
  },
  1411407467: function _(id, v) {
    return new IFC4_3.IfcAirTerminalBoxType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3352864051: function _(id, v) {
    return new IFC4_3.IfcAirTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1871374353: function _(id, v) {
    return new IFC4_3.IfcAirToAirHeatRecoveryType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  4266260250: function _(id, v) {
    return new IFC4_3.IfcAlignmentCant(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new IFC4_3.IfcPositiveLengthMeasure(v[7].value));
  },
  1545765605: function _(id, v) {
    return new IFC4_3.IfcAlignmentHorizontal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  317615605: function _(id, v) {
    return new IFC4_3.IfcAlignmentSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value));
  },
  1662888072: function _(id, v) {
    return new IFC4_3.IfcAlignmentVertical(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  3460190687: function _(id, v) {
    return new IFC4_3.IfcAsset(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value), !v[11] ? null : new Handle(v[11].value), !v[12] ? null : new IFC4_3.IfcDate(v[12].value), !v[13] ? null : new Handle(v[13].value));
  },
  1532957894: function _(id, v) {
    return new IFC4_3.IfcAudioVisualApplianceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1967976161: function _(id, v) {
    return new IFC4_3.IfcBSplineCurve(id, new IFC4_3.IfcInteger(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2], new IFC4_3.IfcLogical(v[3].value), new IFC4_3.IfcLogical(v[4].value));
  },
  2461110595: function _(id, v) {
    return new IFC4_3.IfcBSplineCurveWithKnots(id, new IFC4_3.IfcInteger(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2], new IFC4_3.IfcLogical(v[3].value), new IFC4_3.IfcLogical(v[4].value), v[5].map(function (p) {
      return new IFC4_3.IfcInteger(p.value);
    }), v[6].map(function (p) {
      return new IFC4_3.IfcParameterValue(p.value);
    }), v[7]);
  },
  819618141: function _(id, v) {
    return new IFC4_3.IfcBeamType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3649138523: function _(id, v) {
    return new IFC4_3.IfcBearingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  231477066: function _(id, v) {
    return new IFC4_3.IfcBoilerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1136057603: function _(id, v) {
    return new IFC4_3.IfcBoundaryCurve(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4_3.IfcLogical(v[1].value));
  },
  644574406: function _(id, v) {
    return new IFC4_3.IfcBridge(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9]);
  },
  963979645: function _(id, v) {
    return new IFC4_3.IfcBridgePart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], v[9], v[10]);
  },
  4031249490: function _(id, v) {
    return new IFC4_3.IfcBuilding(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcLengthMeasure(v[10].value), !v[11] ? null : new Handle(v[11].value));
  },
  2979338954: function _(id, v) {
    return new IFC4_3.IfcBuildingElementPart(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  39481116: function _(id, v) {
    return new IFC4_3.IfcBuildingElementPartType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1909888760: function _(id, v) {
    return new IFC4_3.IfcBuildingElementProxyType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1177604601: function _(id, v) {
    return new IFC4_3.IfcBuildingSystem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value));
  },
  1876633798: function _(id, v) {
    return new IFC4_3.IfcBuiltElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  3862327254: function _(id, v) {
    return new IFC4_3.IfcBuiltSystem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : new IFC4_3.IfcLabel(v[6].value));
  },
  2188180465: function _(id, v) {
    return new IFC4_3.IfcBurnerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  395041908: function _(id, v) {
    return new IFC4_3.IfcCableCarrierFittingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3293546465: function _(id, v) {
    return new IFC4_3.IfcCableCarrierSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2674252688: function _(id, v) {
    return new IFC4_3.IfcCableFittingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1285652485: function _(id, v) {
    return new IFC4_3.IfcCableSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3203706013: function _(id, v) {
    return new IFC4_3.IfcCaissonFoundationType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2951183804: function _(id, v) {
    return new IFC4_3.IfcChillerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3296154744: function _(id, v) {
    return new IFC4_3.IfcChimney(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2611217952: function _(id, v) {
    return new IFC4_3.IfcCircle(id, new Handle(v[0].value), new IFC4_3.IfcPositiveLengthMeasure(v[1].value));
  },
  1677625105: function _(id, v) {
    return new IFC4_3.IfcCivilElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  2301859152: function _(id, v) {
    return new IFC4_3.IfcCoilType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  843113511: function _(id, v) {
    return new IFC4_3.IfcColumn(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  400855858: function _(id, v) {
    return new IFC4_3.IfcCommunicationsApplianceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3850581409: function _(id, v) {
    return new IFC4_3.IfcCompressorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2816379211: function _(id, v) {
    return new IFC4_3.IfcCondenserType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3898045240: function _(id, v) {
    return new IFC4_3.IfcConstructionEquipmentResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  1060000209: function _(id, v) {
    return new IFC4_3.IfcConstructionMaterialResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  488727124: function _(id, v) {
    return new IFC4_3.IfcConstructionProductResource(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4_3.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  2940368186: function _(id, v) {
    return new IFC4_3.IfcConveyorSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  335055490: function _(id, v) {
    return new IFC4_3.IfcCooledBeamType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2954562838: function _(id, v) {
    return new IFC4_3.IfcCoolingTowerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1502416096: function _(id, v) {
    return new IFC4_3.IfcCourse(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1973544240: function _(id, v) {
    return new IFC4_3.IfcCovering(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3495092785: function _(id, v) {
    return new IFC4_3.IfcCurtainWall(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3961806047: function _(id, v) {
    return new IFC4_3.IfcDamperType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3426335179: function _(id, v) {
    return new IFC4_3.IfcDeepFoundation(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  1335981549: function _(id, v) {
    return new IFC4_3.IfcDiscreteAccessory(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2635815018: function _(id, v) {
    return new IFC4_3.IfcDiscreteAccessoryType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  479945903: function _(id, v) {
    return new IFC4_3.IfcDistributionBoardType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1599208980: function _(id, v) {
    return new IFC4_3.IfcDistributionChamberElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2063403501: function _(id, v) {
    return new IFC4_3.IfcDistributionControlElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value));
  },
  1945004755: function _(id, v) {
    return new IFC4_3.IfcDistributionElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  3040386961: function _(id, v) {
    return new IFC4_3.IfcDistributionFlowElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  3041715199: function _(id, v) {
    return new IFC4_3.IfcDistributionPort(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], v[9]);
  },
  3205830791: function _(id, v) {
    return new IFC4_3.IfcDistributionSystem(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), v[6]);
  },
  395920057: function _(id, v) {
    return new IFC4_3.IfcDoor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4_3.IfcLabel(v[12].value));
  },
  869906466: function _(id, v) {
    return new IFC4_3.IfcDuctFittingType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3760055223: function _(id, v) {
    return new IFC4_3.IfcDuctSegmentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2030761528: function _(id, v) {
    return new IFC4_3.IfcDuctSilencerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3071239417: function _(id, v) {
    return new IFC4_3.IfcEarthworksCut(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1077100507: function _(id, v) {
    return new IFC4_3.IfcEarthworksElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  3376911765: function _(id, v) {
    return new IFC4_3.IfcEarthworksFill(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  663422040: function _(id, v) {
    return new IFC4_3.IfcElectricApplianceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2417008758: function _(id, v) {
    return new IFC4_3.IfcElectricDistributionBoardType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3277789161: function _(id, v) {
    return new IFC4_3.IfcElectricFlowStorageDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2142170206: function _(id, v) {
    return new IFC4_3.IfcElectricFlowTreatmentDeviceType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1534661035: function _(id, v) {
    return new IFC4_3.IfcElectricGeneratorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1217240411: function _(id, v) {
    return new IFC4_3.IfcElectricMotorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  712377611: function _(id, v) {
    return new IFC4_3.IfcElectricTimeControlType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1658829314: function _(id, v) {
    return new IFC4_3.IfcEnergyConversionDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  2814081492: function _(id, v) {
    return new IFC4_3.IfcEngine(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3747195512: function _(id, v) {
    return new IFC4_3.IfcEvaporativeCooler(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  484807127: function _(id, v) {
    return new IFC4_3.IfcEvaporator(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1209101575: function _(id, v) {
    return new IFC4_3.IfcExternalSpatialElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), v[8]);
  },
  346874300: function _(id, v) {
    return new IFC4_3.IfcFanType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1810631287: function _(id, v) {
    return new IFC4_3.IfcFilterType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  4222183408: function _(id, v) {
    return new IFC4_3.IfcFireSuppressionTerminalType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2058353004: function _(id, v) {
    return new IFC4_3.IfcFlowController(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  4278956645: function _(id, v) {
    return new IFC4_3.IfcFlowFitting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  4037862832: function _(id, v) {
    return new IFC4_3.IfcFlowInstrumentType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  2188021234: function _(id, v) {
    return new IFC4_3.IfcFlowMeter(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3132237377: function _(id, v) {
    return new IFC4_3.IfcFlowMovingDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  987401354: function _(id, v) {
    return new IFC4_3.IfcFlowSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  707683696: function _(id, v) {
    return new IFC4_3.IfcFlowStorageDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  2223149337: function _(id, v) {
    return new IFC4_3.IfcFlowTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  3508470533: function _(id, v) {
    return new IFC4_3.IfcFlowTreatmentDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  900683007: function _(id, v) {
    return new IFC4_3.IfcFooting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2713699986: function _(id, v) {
    return new IFC4_3.IfcGeotechnicalAssembly(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  3009204131: function _(id, v) {
    return new IFC4_3.IfcGrid(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7].map(function (p) {
      return new Handle(p.value);
    }), v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), v[10]);
  },
  3319311131: function _(id, v) {
    return new IFC4_3.IfcHeatExchanger(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2068733104: function _(id, v) {
    return new IFC4_3.IfcHumidifier(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  4175244083: function _(id, v) {
    return new IFC4_3.IfcInterceptor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2176052936: function _(id, v) {
    return new IFC4_3.IfcJunctionBox(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2696325953: function _(id, v) {
    return new IFC4_3.IfcKerb(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), new IFC4_3.IfcBoolean(v[8].value));
  },
  76236018: function _(id, v) {
    return new IFC4_3.IfcLamp(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  629592764: function _(id, v) {
    return new IFC4_3.IfcLightFixture(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1154579445: function _(id, v) {
    return new IFC4_3.IfcLinearPositioningElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  1638804497: function _(id, v) {
    return new IFC4_3.IfcLiquidTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1437502449: function _(id, v) {
    return new IFC4_3.IfcMedicalDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1073191201: function _(id, v) {
    return new IFC4_3.IfcMember(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2078563270: function _(id, v) {
    return new IFC4_3.IfcMobileTelecommunicationsAppliance(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  234836483: function _(id, v) {
    return new IFC4_3.IfcMooringDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2474470126: function _(id, v) {
    return new IFC4_3.IfcMotorConnection(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2182337498: function _(id, v) {
    return new IFC4_3.IfcNavigationElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  144952367: function _(id, v) {
    return new IFC4_3.IfcOuterBoundaryCurve(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4_3.IfcLogical(v[1].value));
  },
  3694346114: function _(id, v) {
    return new IFC4_3.IfcOutlet(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1383356374: function _(id, v) {
    return new IFC4_3.IfcPavement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1687234759: function _(id, v) {
    return new IFC4_3.IfcPile(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8], v[9]);
  },
  310824031: function _(id, v) {
    return new IFC4_3.IfcPipeFitting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3612865200: function _(id, v) {
    return new IFC4_3.IfcPipeSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3171933400: function _(id, v) {
    return new IFC4_3.IfcPlate(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  738039164: function _(id, v) {
    return new IFC4_3.IfcProtectiveDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  655969474: function _(id, v) {
    return new IFC4_3.IfcProtectiveDeviceTrippingUnitType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  90941305: function _(id, v) {
    return new IFC4_3.IfcPump(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3290496277: function _(id, v) {
    return new IFC4_3.IfcRail(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2262370178: function _(id, v) {
    return new IFC4_3.IfcRailing(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3024970846: function _(id, v) {
    return new IFC4_3.IfcRamp(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3283111854: function _(id, v) {
    return new IFC4_3.IfcRampFlight(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1232101972: function _(id, v) {
    return new IFC4_3.IfcRationalBSplineCurveWithKnots(id, new IFC4_3.IfcInteger(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2], new IFC4_3.IfcLogical(v[3].value), new IFC4_3.IfcLogical(v[4].value), v[5].map(function (p) {
      return new IFC4_3.IfcInteger(p.value);
    }), v[6].map(function (p) {
      return new IFC4_3.IfcParameterValue(p.value);
    }), v[7], v[8].map(function (p) {
      return new IFC4_3.IfcReal(p.value);
    }));
  },
  3798194928: function _(id, v) {
    return new IFC4_3.IfcReinforcedSoil(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  979691226: function _(id, v) {
    return new IFC4_3.IfcReinforcingBar(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4_3.IfcAreaMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[11].value), v[12], v[13]);
  },
  2572171363: function _(id, v) {
    return new IFC4_3.IfcReinforcingBarType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[12].value), v[13], !v[14] ? null : new IFC4_3.IfcLabel(v[14].value), !v[15] ? null : v[15].map(function (p) {
      return TypeInitialiser(2, p);
    }));
  },
  2016517767: function _(id, v) {
    return new IFC4_3.IfcRoof(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3053780830: function _(id, v) {
    return new IFC4_3.IfcSanitaryTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1783015770: function _(id, v) {
    return new IFC4_3.IfcSensorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1329646415: function _(id, v) {
    return new IFC4_3.IfcShadingDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  991950508: function _(id, v) {
    return new IFC4_3.IfcSignal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1529196076: function _(id, v) {
    return new IFC4_3.IfcSlab(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3420628829: function _(id, v) {
    return new IFC4_3.IfcSolarDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1999602285: function _(id, v) {
    return new IFC4_3.IfcSpaceHeater(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1404847402: function _(id, v) {
    return new IFC4_3.IfcStackTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  331165859: function _(id, v) {
    return new IFC4_3.IfcStair(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  4252922144: function _(id, v) {
    return new IFC4_3.IfcStairFlight(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcInteger(v[8].value), !v[9] ? null : new IFC4_3.IfcInteger(v[9].value), !v[10] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[11].value), v[12]);
  },
  2515109513: function _(id, v) {
    return new IFC4_3.IfcStructuralAnalysisModel(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value));
  },
  385403989: function _(id, v) {
    return new IFC4_3.IfcStructuralLoadCase(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), v[5], v[6], v[7], !v[8] ? null : new IFC4_3.IfcRatioMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcLabel(v[9].value), !v[10] ? null : v[10].map(function (p) {
      return new IFC4_3.IfcRatioMeasure(p.value);
    }));
  },
  1621171031: function _(id, v) {
    return new IFC4_3.IfcStructuralPlanarAction(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4_3.IfcBoolean(v[9].value), v[10], v[11]);
  },
  1162798199: function _(id, v) {
    return new IFC4_3.IfcSwitchingDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  812556717: function _(id, v) {
    return new IFC4_3.IfcTank(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3425753595: function _(id, v) {
    return new IFC4_3.IfcTrackElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3825984169: function _(id, v) {
    return new IFC4_3.IfcTransformer(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1620046519: function _(id, v) {
    return new IFC4_3.IfcTransportElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3026737570: function _(id, v) {
    return new IFC4_3.IfcTubeBundle(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3179687236: function _(id, v) {
    return new IFC4_3.IfcUnitaryControlElementType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  4292641817: function _(id, v) {
    return new IFC4_3.IfcUnitaryEquipment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  4207607924: function _(id, v) {
    return new IFC4_3.IfcValve(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2391406946: function _(id, v) {
    return new IFC4_3.IfcWall(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3512223829: function _(id, v) {
    return new IFC4_3.IfcWallStandardCase(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  4237592921: function _(id, v) {
    return new IFC4_3.IfcWasteTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3304561284: function _(id, v) {
    return new IFC4_3.IfcWindow(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4_3.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4_3.IfcLabel(v[12].value));
  },
  2874132201: function _(id, v) {
    return new IFC4_3.IfcActuatorType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  1634111441: function _(id, v) {
    return new IFC4_3.IfcAirTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  177149247: function _(id, v) {
    return new IFC4_3.IfcAirTerminalBox(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2056796094: function _(id, v) {
    return new IFC4_3.IfcAirToAirHeatRecovery(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3001207471: function _(id, v) {
    return new IFC4_3.IfcAlarmType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  325726236: function _(id, v) {
    return new IFC4_3.IfcAlignment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]);
  },
  277319702: function _(id, v) {
    return new IFC4_3.IfcAudioVisualAppliance(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  753842376: function _(id, v) {
    return new IFC4_3.IfcBeam(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  4196446775: function _(id, v) {
    return new IFC4_3.IfcBearing(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  32344328: function _(id, v) {
    return new IFC4_3.IfcBoiler(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3314249567: function _(id, v) {
    return new IFC4_3.IfcBorehole(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  1095909175: function _(id, v) {
    return new IFC4_3.IfcBuildingElementProxy(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2938176219: function _(id, v) {
    return new IFC4_3.IfcBurner(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  635142910: function _(id, v) {
    return new IFC4_3.IfcCableCarrierFitting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3758799889: function _(id, v) {
    return new IFC4_3.IfcCableCarrierSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1051757585: function _(id, v) {
    return new IFC4_3.IfcCableFitting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  4217484030: function _(id, v) {
    return new IFC4_3.IfcCableSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3999819293: function _(id, v) {
    return new IFC4_3.IfcCaissonFoundation(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3902619387: function _(id, v) {
    return new IFC4_3.IfcChiller(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  639361253: function _(id, v) {
    return new IFC4_3.IfcCoil(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3221913625: function _(id, v) {
    return new IFC4_3.IfcCommunicationsAppliance(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3571504051: function _(id, v) {
    return new IFC4_3.IfcCompressor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2272882330: function _(id, v) {
    return new IFC4_3.IfcCondenser(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  578613899: function _(id, v) {
    return new IFC4_3.IfcControllerType(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4_3.IfcLabel(v[7].value), !v[8] ? null : new IFC4_3.IfcLabel(v[8].value), v[9]);
  },
  3460952963: function _(id, v) {
    return new IFC4_3.IfcConveyorSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  4136498852: function _(id, v) {
    return new IFC4_3.IfcCooledBeam(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3640358203: function _(id, v) {
    return new IFC4_3.IfcCoolingTower(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  4074379575: function _(id, v) {
    return new IFC4_3.IfcDamper(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3693000487: function _(id, v) {
    return new IFC4_3.IfcDistributionBoard(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1052013943: function _(id, v) {
    return new IFC4_3.IfcDistributionChamberElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  562808652: function _(id, v) {
    return new IFC4_3.IfcDistributionCircuit(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new IFC4_3.IfcLabel(v[5].value), v[6]);
  },
  1062813311: function _(id, v) {
    return new IFC4_3.IfcDistributionControlElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  342316401: function _(id, v) {
    return new IFC4_3.IfcDuctFitting(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3518393246: function _(id, v) {
    return new IFC4_3.IfcDuctSegment(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1360408905: function _(id, v) {
    return new IFC4_3.IfcDuctSilencer(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1904799276: function _(id, v) {
    return new IFC4_3.IfcElectricAppliance(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  862014818: function _(id, v) {
    return new IFC4_3.IfcElectricDistributionBoard(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3310460725: function _(id, v) {
    return new IFC4_3.IfcElectricFlowStorageDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  24726584: function _(id, v) {
    return new IFC4_3.IfcElectricFlowTreatmentDevice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  264262732: function _(id, v) {
    return new IFC4_3.IfcElectricGenerator(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  402227799: function _(id, v) {
    return new IFC4_3.IfcElectricMotor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1003880860: function _(id, v) {
    return new IFC4_3.IfcElectricTimeControl(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3415622556: function _(id, v) {
    return new IFC4_3.IfcFan(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  819412036: function _(id, v) {
    return new IFC4_3.IfcFilter(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  1426591983: function _(id, v) {
    return new IFC4_3.IfcFireSuppressionTerminal(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  182646315: function _(id, v) {
    return new IFC4_3.IfcFlowInstrument(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  2680139844: function _(id, v) {
    return new IFC4_3.IfcGeomodel(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  1971632696: function _(id, v) {
    return new IFC4_3.IfcGeoslice(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value));
  },
  2295281155: function _(id, v) {
    return new IFC4_3.IfcProtectiveDeviceTrippingUnit(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  4086658281: function _(id, v) {
    return new IFC4_3.IfcSensor(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  630975310: function _(id, v) {
    return new IFC4_3.IfcUnitaryControlElement(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  4288193352: function _(id, v) {
    return new IFC4_3.IfcActuator(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  3087945054: function _(id, v) {
    return new IFC4_3.IfcAlarm(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  },
  25142252: function _(id, v) {
    return new IFC4_3.IfcController(id, new IFC4_3.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4_3.IfcLabel(v[2].value), !v[3] ? null : new IFC4_3.IfcText(v[3].value), !v[4] ? null : new IFC4_3.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4_3.IfcIdentifier(v[7].value), v[8]);
  }
};
InheritanceDef[2] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  2879124712: [IFCALIGNMENTHORIZONTALSEGMENT, IFCALIGNMENTCANTSEGMENT, IFCALIGNMENTVERTICALSEGMENT],
  411424972: [IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONVOLUMEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  1785450214: [IFCMAPCONVERSION],
  1466758467: [IFCPROJECTEDCRS],
  4294318154: [IFCDOCUMENTINFORMATION, IFCCLASSIFICATION, IFCLIBRARYINFORMATION],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  760658860: [IFCMATERIALCONSTITUENTSET, IFCMATERIALCONSTITUENT, IFCMATERIAL, IFCMATERIALPROFILESET, IFCMATERIALPROFILEWITHOFFSETS, IFCMATERIALPROFILE, IFCMATERIALLAYERSET, IFCMATERIALLAYERWITHOFFSETS, IFCMATERIALLAYER],
  248100487: [IFCMATERIALLAYERWITHOFFSETS],
  2235152071: [IFCMATERIALPROFILEWITHOFFSETS],
  1507914824: [IFCMATERIALPROFILESETUSAGETAPERING, IFCMATERIALPROFILESETUSAGE, IFCMATERIALLAYERSETUSAGE],
  1918398963: [IFCCONVERSIONBASEDUNITWITHOFFSET, IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCLINEARPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYNUMBER, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYNUMBER, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  677532197: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDITEM, IFCINDEXEDCOLOURMAP, IFCCURVESTYLEFONTPATTERN, IFCCURVESTYLEFONTANDSCALING, IFCCURVESTYLEFONT, IFCCOLOURRGB, IFCCOLOURSPECIFICATION, IFCCOLOURRGBLIST, IFCTEXTUREVERTEXLIST, IFCTEXTUREVERTEX, IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR, IFCTEXTURECOORDINATE, IFCTEXTSTYLETEXTMODEL, IFCTEXTSTYLEFORDEFINEDFONT, IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE, IFCSURFACETEXTURE, IFCSURFACESTYLEWITHTEXTURES, IFCSURFACESTYLERENDERING, IFCSURFACESTYLESHADING, IFCSURFACESTYLEREFRACTION, IFCSURFACESTYLELIGHTING],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCOPENCROSSPROFILEDEF, IFCMIRROREDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  986844984: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY, IFCPROPERTY, IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES, IFCPREDEFINEDPROPERTIES, IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES, IFCEXTENDEDPROPERTIES, IFCPROPERTYENUMERATION],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCSEGMENT, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCSTYLEDITEM],
  2439245199: [IFCRESOURCECONSTRAINTRELATIONSHIP, IFCRESOURCEAPPROVALRELATIONSHIP, IFCPROPERTYDEPENDENCYRELATIONSHIP, IFCORGANIZATIONRELATIONSHIP, IFCMATERIALRELATIONSHIP, IFCEXTERNALREFERENCERELATIONSHIP, IFCDOCUMENTINFORMATIONRELATIONSHIP, IFCCURRENCYRELATIONSHIP, IFCAPPROVALRELATIONSHIP],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  1054537805: [IFCRESOURCETIME, IFCLAGTIME, IFCEVENTTIME, IFCWORKTIME, IFCTASKTIMERECURRING, IFCTASKTIME],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC, IFCSTRUCTURALLOADORRESULT, IFCSTRUCTURALLOADCONFIGURATION],
  609421318: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  1549132990: [IFCTASKTIMERECURRING],
  280115917: [IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  222769930: [IFCTEXTURECOORDINATEINDICESWITHVOIDS],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  3264961684: [IFCCOLOURRGB],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  2889183280: [IFCCONVERSIONBASEDUNITWITHOFFSET],
  3632507154: [IFCMIRROREDPROFILEDEF],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  297599258: [IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES],
  2556980723: [IFCADVANCEDFACE, IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  3008276851: [IFCADVANCEDFACE],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCSEGMENT, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1437953363: [IFCINDEXEDPOLYGONALTEXTUREMAP, IFCINDEXEDTRIANGLETEXTUREMAP],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  3079605661: [IFCMATERIALPROFILESETUSAGETAPERING],
  219451334: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENTLINEAR, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINTBYDISTANCEEXPRESSION],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT],
  3778827333: [IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES],
  1775413392: [IFCTEXTSTYLEFONTMODEL],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1680319473: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET],
  1482703590: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE],
  2090586900: [IFCELEMENTQUANTITY],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  823603102: [IFCCURVESEGMENT, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  723233188: [IFCSECTIONEDSOLIDHORIZONTAL, IFCSECTIONEDSOLID, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  2513912981: [IFCSECTIONEDSURFACE, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCDIRECTRIXCURVESWEPTAREASOLID],
  1260650574: [IFCSWEPTDISKSOLIDPOLYGONAL],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  901063453: [IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS],
  3736923433: [IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE],
  2347495698: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE],
  3698973494: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE],
  574549367: [IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2485617015: [IFCREPARAMETRISEDCOMPOSITECURVESEGMENT],
  2574617495: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE],
  3419103109: [IFCPROJECTLIBRARY, IFCPROJECT],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL, IFCSPIRAL, IFCPOLYNOMIALCURVE, IFCPCURVE, IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCOFFSETCURVE, IFCLINE],
  593015953: [IFCSURFACECURVESWEPTAREASOLID, IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID],
  339256511: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILTELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE, IFCTRANSPORTATIONDEVICETYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE],
  477187591: [IFCEXTRUDEDAREASOLIDTAPERED],
  2652556860: [IFCDIRECTRIXDERIVEDREFERENCESWEPTAREASOLID],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  178912537: [IFCINDEXEDPOLYGONALFACEWITHVOIDS],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP],
  3888040117: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS],
  590820931: [IFCOFFSETCURVEBYDISTANCES, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  3967405729: [IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  2945172077: [IFCPROCEDURE, IFCEVENT, IFCTASK],
  4208778838: [IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT, IFCPOSITIONINGELEMENT, IFCDISTRIBUTIONPORT, IFCPORT, IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT, IFCLINEARELEMENT, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT],
  3521284610: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR],
  1307041759: [IFCRELASSIGNSTOGROUPBYFACTOR],
  1865459582: [IFCRELASSOCIATESPROFILEDEF, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL],
  826625072: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELPOSITIONS, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELADHERESTOELEMENT, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT],
  3451746338: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL],
  3523091289: [IFCRELSPACEBOUNDARY2NDLEVEL],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  1856042241: [IFCREVOLVEDAREASOLIDTAPERED],
  1862484736: [IFCSECTIONEDSOLIDHORIZONTAL],
  1412071761: [IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY, IFCSPATIALSTRUCTUREELEMENT],
  710998568: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE],
  2706606064: [IFCSPACE, IFCSITE, IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON, IFCFACILITYPART, IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY, IFCFACILITY, IFCBUILDINGSTOREY],
  3893378262: [IFCSPACETYPE],
  2735484536: [IFCSINESPIRAL, IFCSEVENTHORDERPOLYNOMIALSPIRAL, IFCSECONDORDERPOLYNOMIALSPIRAL, IFCCOSINESPIRAL, IFCCLOTHOID, IFCTHIRDORDERPOLYNOMIALSPIRAL],
  3544373492: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  699246055: [IFCSEAMCURVE, IFCINTERSECTIONCURVE],
  2387106220: [IFCPOLYGONALFACESET, IFCTRIANGULATEDIRREGULARNETWORK, IFCTRIANGULATEDFACESET],
  3665877780: [IFCTRANSPORTELEMENTTYPE, IFCVEHICLETYPE],
  2916149573: [IFCTRIANGULATEDIRREGULARNETWORK],
  2296667514: [IFCOCCUPANT],
  1635779807: [IFCADVANCEDBREPWITHVOIDS],
  2887950389: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS],
  167062518: [IFCRATIONALBSPLINESURFACEWITHKNOTS],
  1260505505: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE],
  1626504194: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEARINGTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCTRACKELEMENTTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCRAILTYPE, IFCPLATETYPE, IFCPAVEMENTTYPE, IFCNAVIGATIONELEMENTTYPE, IFCMOORINGDEVICETYPE, IFCMEMBERTYPE, IFCKERBTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE, IFCDEEPFOUNDATIONTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOURSETYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE],
  3732776249: [IFCSEGMENTEDREFERENCECURVE, IFCGRADIENTCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE],
  15328376: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM],
  1306400036: [IFCCAISSONFOUNDATIONTYPE, IFCPILETYPE],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY, IFCBUILTELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCVEHICLE, IFCTRANSPORTATIONDEVICE, IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM, IFCGEOTECHNICALELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCVIBRATIONDAMPER, IFCSIGN, IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCIMPACTPROTECTIONDEVICE, IFCFASTENER],
  2590856083: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCVIBRATIONDAMPERTYPE, IFCSIGNTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCIMPACTPROTECTIONDEVICETYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE],
  2853485674: [IFCEXTERNALSPATIALELEMENT],
  807026263: [IFCFACETEDBREPWITHVOIDS],
  24185140: [IFCBUILDING, IFCBRIDGE, IFCROAD, IFCRAILWAY, IFCMARINEFACILITY],
  1310830890: [IFCBRIDGEPART, IFCROADPART, IFCRAILWAYPART, IFCMARINEPART, IFCFACILITYPARTCOMMON],
  2827207264: [IFCSURFACEFEATURE, IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCEARTHWORKSCUT, IFCVOIDINGFEATURE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCONVEYORSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSIGNALTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMOBILETELECOMMUNICATIONSAPPLIANCETYPE, IFCMEDICALDEVICETYPE, IFCLIQUIDTERMINALTYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE],
  3009222698: [IFCFILTERTYPE, IFCELECTRICFLOWTREATMENTDEVICETYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE],
  263784265: [IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE],
  4230923436: [IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE, IFCGEOTECHNICALASSEMBLY, IFCGEOTECHNICALSTRATUM],
  2706460486: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  2176059722: [IFCALIGNMENTVERTICAL, IFCALIGNMENTSEGMENT, IFCALIGNMENTHORIZONTAL, IFCALIGNMENTCANT],
  3740093272: [IFCDISTRIBUTIONPORT],
  1946335990: [IFCALIGNMENT, IFCLINEARPOSITIONINGELEMENT, IFCGRID, IFCREFERENT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONCONDUIT, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  964333572: [IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONCONDUITTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE],
  682877961: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  1004757350: [IFCSTRUCTURALLINEARACTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1252848954: [IFCSTRUCTURALLOADCASE],
  3657597509: [IFCSTRUCTURALPLANARACTION],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILTSYSTEM, IFCBUILDINGSYSTEM, IFCZONE],
  1953115116: [IFCTRANSPORTELEMENT, IFCVEHICLE],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS],
  2461110595: [IFCRATIONALBSPLINECURVEWITHKNOTS],
  1136057603: [IFCOUTERBOUNDARYCURVE],
  1876633798: [IFCBUILDINGELEMENTPROXY, IFCBEARING, IFCBEAM, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALL, IFCTRACKELEMENT, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCRAIL, IFCPLATE, IFCPAVEMENT, IFCNAVIGATIONELEMENT, IFCMOORINGDEVICE, IFCMEMBER, IFCKERB, IFCFOOTING, IFCREINFORCEDSOIL, IFCEARTHWORKSFILL, IFCEARTHWORKSELEMENT, IFCDOOR, IFCCAISSONFOUNDATION, IFCPILE, IFCDEEPFOUNDATION, IFCCURTAINWALL, IFCCOVERING, IFCCOURSE, IFCCOLUMN, IFCCHIMNEY],
  3426335179: [IFCCAISSONFOUNDATION, IFCPILE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE],
  3205830791: [IFCDISTRIBUTIONCIRCUIT],
  1077100507: [IFCREINFORCEDSOIL, IFCEARTHWORKSFILL],
  1658829314: [IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE],
  2058353004: [IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER],
  4278956645: [IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX],
  3132237377: [IFCFAN, IFCCOMPRESSOR, IFCPUMP],
  987401354: [IFCDUCTSEGMENT, IFCCONVEYORSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT],
  707683696: [IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK],
  2223149337: [IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSIGNAL, IFCSANITARYTERMINAL, IFCOUTLET, IFCMOBILETELECOMMUNICATIONSAPPLIANCE, IFCMEDICALDEVICE, IFCLIQUIDTERMINAL, IFCLIGHTFIXTURE, IFCLAMP],
  3508470533: [IFCFILTER, IFCELECTRICFLOWTREATMENTDEVICE, IFCDUCTSILENCER, IFCINTERCEPTOR],
  2713699986: [IFCGEOSLICE, IFCGEOMODEL, IFCBOREHOLE],
  1154579445: [IFCALIGNMENT],
  2391406946: [IFCWALLSTANDARDCASE],
  1062813311: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT]
};
InversePropertyDef[2] = {
  3630933823: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  618182010: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  411424972: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  130549933: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["ApprovedObjects", IFCRELASSOCIATESAPPROVAL, 5, true], ["ApprovedResources", IFCRESOURCEAPPROVALRELATIONSHIP, 3, true], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 3, true], ["Relates", IFCAPPROVALRELATIONSHIP, 2, true]],
  1959218052: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  1466758467: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  602808272: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3200245327: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  2242383968: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  1040185647: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  3548104201: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  852622518: [["PartOfW", IFCGRID, 9, true], ["PartOfV", IFCGRID, 8, true], ["PartOfU", IFCGRID, 7, true], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, true]],
  2655187982: [["LibraryInfoForObjects", IFCRELASSOCIATESLIBRARY, 5, true], ["HasLibraryReferences", IFCLIBRARYREFERENCE, 5, true]],
  3452421091: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["LibraryRefForObjects", IFCRELASSOCIATESLIBRARY, 5, true]],
  760658860: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  248100487: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  3303938423: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1847252529: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  2235152071: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  164193824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  552965576: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  1507914824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3368373690: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  2251480897: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, true], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, true], ["Engages", IFCPERSONANDORGANIZATION, 1, true]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, true]],
  2483315170: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2226359599: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3355820592: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  3958567839: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3843373140: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  986844984: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3710013099: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2044713172: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2093928680: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  931644368: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2691318326: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3252649465: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2405470396: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  825690147: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, true]],
  3008791417: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1660063152: [["HasShapeAspects", IFCSHAPEASPECT, 4, true], ["MapUsage", IFCMAPPEDITEM, 0, true]],
  867548509: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3958052878: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  626085974: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  912023232: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  222769930: [["ToTexMap", IFCINDEXEDPOLYGONALTEXTUREMAP, 3, false]],
  1010789467: [["ToTexMap", IFCINDEXEDPOLYGONALTEXTUREMAP, 3, false]],
  3101149627: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1377556343: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2799835756: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1907098498: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3798115385: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1310608509: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2705031697: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  616511568: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3150382593: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  747523909: [["ClassificationForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  647927063: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["ClassificationRefForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  1485152156: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  370225590: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3050246964: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2889183280: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2713554722: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3632507154: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1154170062: [["DocumentInfoForObjects", IFCRELASSOCIATESDOCUMENT, 5, true], ["HasDocumentReferences", IFCDOCUMENTREFERENCE, 4, true], ["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 3, true], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 2, true]],
  3732053477: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["DocumentRefForObjects", IFCRELASSOCIATESDOCUMENT, 5, true]],
  3900360178: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  476780140: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  297599258: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2556980723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  1809719519: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  803316827: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3008276851: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  2453401579: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  3590301190: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  812098782: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3905492369: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3741457305: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1402838566: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  125510826: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2604431987: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4266656042: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1520743889: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3422422726: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  388784114: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCOBJECTPLACEMENT, 0, true]],
  1008929658: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2347385850: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1838606355: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, true], ["IsRelatedWith", IFCMATERIALRELATIONSHIP, 3, true], ["RelatesTo", IFCMATERIALRELATIONSHIP, 2, true]],
  3708119e3: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialConstituentSet", IFCMATERIALCONSTITUENTSET, 2, false]],
  2852063980: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1303795690: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3079605661: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3404854881: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3265635763: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2998442950: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  182550632: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2665983363: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1029017970: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2529465313: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2519244187: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3021840470: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  597895409: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  2004835150: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1663979128: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2067069095: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2165702409: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4022376103: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1423911732: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2924175390: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2775532180: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3778827333: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, true], ["HasShapeAspects", IFCSHAPEASPECT, 4, true]],
  2802850158: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2598011224: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1680319473: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  3357820518: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1482703590: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2090586900: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3615266464: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3413951693: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1580146022: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2778083089: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2042790032: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  4165799628: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1509187699: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  823603102: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  4124623270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3692461612: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  723233188: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2233826070: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2513912981: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2247615214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260650574: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1096409881: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  230924584: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3071757647: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  901063453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4282788508: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124975700: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2715220739: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true]],
  3736923433: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3698973494: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  427810014: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1417489154: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2759199220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2543172580: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3406155212: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  669184980: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3207858831: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4261334040: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3125803723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2740243338: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3425423356: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2736907675: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4182860854: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2581212453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2713105998: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2898889636: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1123145078: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  574549367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1675464909: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2059837836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  59481748: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3749851601: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3486308946: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3331915920: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1416205885: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1383045692: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2205249479: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2542286263: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2485617015: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2574617495: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3419103109: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  1815067380: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2506170314: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2147822146: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2601014836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2827736869: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2629017746: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4212018352: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  32440307: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  593015953: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1472233963: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1883228015: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2777663545: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2835456948: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4024345920: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  477187591: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2804161546: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2047409740: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  374418227: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  315944413: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2652556860: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4095422895: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  987898635: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1484403080: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  178912537: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true], ["HasTexCoords", IFCTEXTURECOORDINATEINDICES, 1, true]],
  2294589976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true], ["HasTexCoords", IFCTEXTURECOORDINATEINDICES, 1, true]],
  572779678: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  428585644: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1281925730: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1425443689: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true]],
  590820931: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3388369263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3505215534: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2485787929: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1682466193: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  603570806: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  220341763: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3381221214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3967405729: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  569719735: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  653396225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  871118103: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  4166981789: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2752243245: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  941946838: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1451395588: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  492091185: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Defines", IFCRELDEFINESBYTEMPLATE, 5, true]],
  3650150729: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  110355661: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  3521284610: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  2770003689: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2798486643: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3454111270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3765753017: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3523091289: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true]],
  1521410863: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true], ["Corresponds", IFCRELSPACEBOUNDARY2NDLEVEL, 10, true]],
  816062949: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1856042241: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3243963512: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4158566097: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3626867408: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1862484736: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1290935644: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1356537516: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3663146110: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  1412071761: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  710998568: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  463610769: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2481509218: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  451544542: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4015995234: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2735484536: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  603775116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4095615324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  699246055: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2028607225: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2809605785: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124788165: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  3206491090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2387106220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  782932809: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1935646853: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3665877780: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2916149573: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  1229763772: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  3651464721: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  336235671: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  512836454: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  1635779807: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2603310189: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2887950389: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  167062518: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1334484129: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649129432: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260505505: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  1626504194: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2197970202: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2937912522: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3893394355: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3497074424: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3875453745: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  3732776249: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  15328376: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2510884976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2185764099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  4105962743: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1525564444: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  2000195564: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4189326743: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1213902940: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1306400036: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4234616927: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2963535650: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1714330368: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2323601079: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2397081782: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1704287377: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  132023988: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4148101412: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2853485674: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  807026263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3737207727: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  24185140: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  1310830890: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  4228831410: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1893162501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1509553395: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3493046030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4230923436: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1594536857: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2898700619: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2568555532: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3948183225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2571569899: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3946677679: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3113134337: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  679976338: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2176059722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1770583370: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  525669439: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  976884017: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1114901282: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1950438474: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  710110818: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  506776471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  514975943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3566463478: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1158309216: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2839578677: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  3724593414: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  1946335990: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1763565496: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3992365140: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  1891881377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1469900589: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  683857671: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4021432810: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  964333572: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2310774935: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  146592293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  550521510: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2781568857: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2157484638: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649235739: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  544395925: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1027922057: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4074543187: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  33720170: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3599934289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1894708472: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  42703149: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1072016465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasCoverings", IFCRELCOVERSSPACES, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  338393293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1004757350: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2757150158: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, true]],
  3657597509: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3101698114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["AdheresToElement", IFCRELADHERESTOELEMENT, 5, false]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  413509423: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3081323446: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3663046924: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2281632017: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2415094496: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  618700268: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1953115116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3593883385: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  840318589: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1530820697: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3956297820: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2391383451: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  926996030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4009809668: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4088093105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4266260250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1545765605: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  317615605: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1662888072: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1532957894: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1967976161: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2461110595: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3649138523: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1136057603: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  644574406: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  963979645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  39481116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1177604601: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1876633798: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3862327254: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  2188180465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2674252688: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3203706013: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3296154744: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2611217952: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1677625105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  400855858: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2940368186: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1502416096: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["CoversSpaces", IFCRELCOVERSSPACES, 5, true], ["CoversElements", IFCRELCOVERSBLDGELEMENTS, 5, true]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3426335179: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  479945903: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  3205830791: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3071239417: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1077100507: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3376911765: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2417008758: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2142170206: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2814081492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3747195512: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  484807127: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1209101575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2188021234: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2713699986: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  3319311131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2068733104: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4175244083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2176052936: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2696325953: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  76236018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  629592764: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1154579445: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  1638804497: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1437502449: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2078563270: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  234836483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2474470126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2182337498: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  144952367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3694346114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1383356374: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  310824031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3612865200: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  738039164: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  655969474: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  90941305: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3290496277: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1232101972: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3798194928: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2572171363: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3053780830: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1329646415: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  991950508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3420628829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1999602285: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1404847402: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  385403989: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1162798199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  812556717: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3425753595: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3825984169: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3026737570: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3179687236: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4292641817: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4207607924: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4237592921: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1634111441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  177149247: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2056796094: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  325726236: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["Positions", IFCRELPOSITIONS, 4, true]],
  277319702: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  4196446775: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  32344328: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3314249567: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2938176219: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  635142910: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3758799889: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1051757585: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4217484030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3999819293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  3902619387: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  639361253: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3221913625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3571504051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2272882330: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3460952963: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4136498852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3640358203: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4074379575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3693000487: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  562808652: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true], ["ServicesFacilities", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  342316401: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3518393246: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1360408905: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1904799276: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  862014818: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3310460725: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  24726584: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  264262732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  402227799: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1003880860: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3415622556: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  819412036: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1426591983: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  182646315: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  2680139844: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  1971632696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true]],
  2295281155: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4086658281: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  630975310: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4288193352: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  3087945054: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  25142252: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["PositionedRelativeTo", IFCRELPOSITIONS, 5, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasSurfaceFeatures", IFCRELADHERESTOELEMENT, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]]
};
Constructors[2] = {
  3630933823: function _(ID, a) {
    return new IFC4_3.IfcActorRole(ID, a[0], a[1], a[2]);
  },
  618182010: function _(ID, a) {
    return new IFC4_3.IfcAddress(ID, a[0], a[1], a[2]);
  },
  2879124712: function _(ID, a) {
    return new IFC4_3.IfcAlignmentParameterSegment(ID, a[0], a[1]);
  },
  3633395639: function _(ID, a) {
    return new IFC4_3.IfcAlignmentVerticalSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  639542469: function _(ID, a) {
    return new IFC4_3.IfcApplication(ID, a[0], a[1], a[2], a[3]);
  },
  411424972: function _(ID, a) {
    return new IFC4_3.IfcAppliedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  130549933: function _(ID, a) {
    return new IFC4_3.IfcApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4037036970: function _(ID, a) {
    return new IFC4_3.IfcBoundaryCondition(ID, a[0]);
  },
  1560379544: function _(ID, a) {
    return new IFC4_3.IfcBoundaryEdgeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3367102660: function _(ID, a) {
    return new IFC4_3.IfcBoundaryFaceCondition(ID, a[0], a[1], a[2], a[3]);
  },
  1387855156: function _(ID, a) {
    return new IFC4_3.IfcBoundaryNodeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2069777674: function _(ID, a) {
    return new IFC4_3.IfcBoundaryNodeConditionWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2859738748: function _(ID, _64) {
    return new IFC4_3.IfcConnectionGeometry(ID);
  },
  2614616156: function _(ID, a) {
    return new IFC4_3.IfcConnectionPointGeometry(ID, a[0], a[1]);
  },
  2732653382: function _(ID, a) {
    return new IFC4_3.IfcConnectionSurfaceGeometry(ID, a[0], a[1]);
  },
  775493141: function _(ID, a) {
    return new IFC4_3.IfcConnectionVolumeGeometry(ID, a[0], a[1]);
  },
  1959218052: function _(ID, a) {
    return new IFC4_3.IfcConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1785450214: function _(ID, a) {
    return new IFC4_3.IfcCoordinateOperation(ID, a[0], a[1]);
  },
  1466758467: function _(ID, a) {
    return new IFC4_3.IfcCoordinateReferenceSystem(ID, a[0], a[1], a[2], a[3]);
  },
  602808272: function _(ID, a) {
    return new IFC4_3.IfcCostValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1765591967: function _(ID, a) {
    return new IFC4_3.IfcDerivedUnit(ID, a[0], a[1], a[2], a[3]);
  },
  1045800335: function _(ID, a) {
    return new IFC4_3.IfcDerivedUnitElement(ID, a[0], a[1]);
  },
  2949456006: function _(ID, a) {
    return new IFC4_3.IfcDimensionalExponents(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  4294318154: function _(ID, _65) {
    return new IFC4_3.IfcExternalInformation(ID);
  },
  3200245327: function _(ID, a) {
    return new IFC4_3.IfcExternalReference(ID, a[0], a[1], a[2]);
  },
  2242383968: function _(ID, a) {
    return new IFC4_3.IfcExternallyDefinedHatchStyle(ID, a[0], a[1], a[2]);
  },
  1040185647: function _(ID, a) {
    return new IFC4_3.IfcExternallyDefinedSurfaceStyle(ID, a[0], a[1], a[2]);
  },
  3548104201: function _(ID, a) {
    return new IFC4_3.IfcExternallyDefinedTextFont(ID, a[0], a[1], a[2]);
  },
  852622518: function _(ID, a) {
    return new IFC4_3.IfcGridAxis(ID, a[0], a[1], a[2]);
  },
  3020489413: function _(ID, a) {
    return new IFC4_3.IfcIrregularTimeSeriesValue(ID, a[0], a[1]);
  },
  2655187982: function _(ID, a) {
    return new IFC4_3.IfcLibraryInformation(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3452421091: function _(ID, a) {
    return new IFC4_3.IfcLibraryReference(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4162380809: function _(ID, a) {
    return new IFC4_3.IfcLightDistributionData(ID, a[0], a[1], a[2]);
  },
  1566485204: function _(ID, a) {
    return new IFC4_3.IfcLightIntensityDistribution(ID, a[0], a[1]);
  },
  3057273783: function _(ID, a) {
    return new IFC4_3.IfcMapConversion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1847130766: function _(ID, a) {
    return new IFC4_3.IfcMaterialClassificationRelationship(ID, a[0], a[1]);
  },
  760658860: function _(ID, _66) {
    return new IFC4_3.IfcMaterialDefinition(ID);
  },
  248100487: function _(ID, a) {
    return new IFC4_3.IfcMaterialLayer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3303938423: function _(ID, a) {
    return new IFC4_3.IfcMaterialLayerSet(ID, a[0], a[1], a[2]);
  },
  1847252529: function _(ID, a) {
    return new IFC4_3.IfcMaterialLayerWithOffsets(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2199411900: function _(ID, a) {
    return new IFC4_3.IfcMaterialList(ID, a[0]);
  },
  2235152071: function _(ID, a) {
    return new IFC4_3.IfcMaterialProfile(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  164193824: function _(ID, a) {
    return new IFC4_3.IfcMaterialProfileSet(ID, a[0], a[1], a[2], a[3]);
  },
  552965576: function _(ID, a) {
    return new IFC4_3.IfcMaterialProfileWithOffsets(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1507914824: function _(ID, _67) {
    return new IFC4_3.IfcMaterialUsageDefinition(ID);
  },
  2597039031: function _(ID, a) {
    return new IFC4_3.IfcMeasureWithUnit(ID, a[0], a[1]);
  },
  3368373690: function _(ID, a) {
    return new IFC4_3.IfcMetric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2706619895: function _(ID, a) {
    return new IFC4_3.IfcMonetaryUnit(ID, a[0]);
  },
  1918398963: function _(ID, a) {
    return new IFC4_3.IfcNamedUnit(ID, a[0], a[1]);
  },
  3701648758: function _(ID, a) {
    return new IFC4_3.IfcObjectPlacement(ID, a[0]);
  },
  2251480897: function _(ID, a) {
    return new IFC4_3.IfcObjective(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4251960020: function _(ID, a) {
    return new IFC4_3.IfcOrganization(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1207048766: function _(ID, a) {
    return new IFC4_3.IfcOwnerHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2077209135: function _(ID, a) {
    return new IFC4_3.IfcPerson(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  101040310: function _(ID, a) {
    return new IFC4_3.IfcPersonAndOrganization(ID, a[0], a[1], a[2]);
  },
  2483315170: function _(ID, a) {
    return new IFC4_3.IfcPhysicalQuantity(ID, a[0], a[1]);
  },
  2226359599: function _(ID, a) {
    return new IFC4_3.IfcPhysicalSimpleQuantity(ID, a[0], a[1], a[2]);
  },
  3355820592: function _(ID, a) {
    return new IFC4_3.IfcPostalAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  677532197: function _(ID, _68) {
    return new IFC4_3.IfcPresentationItem(ID);
  },
  2022622350: function _(ID, a) {
    return new IFC4_3.IfcPresentationLayerAssignment(ID, a[0], a[1], a[2], a[3]);
  },
  1304840413: function _(ID, a) {
    return new IFC4_3.IfcPresentationLayerWithStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3119450353: function _(ID, a) {
    return new IFC4_3.IfcPresentationStyle(ID, a[0]);
  },
  2095639259: function _(ID, a) {
    return new IFC4_3.IfcProductRepresentation(ID, a[0], a[1], a[2]);
  },
  3958567839: function _(ID, a) {
    return new IFC4_3.IfcProfileDef(ID, a[0], a[1]);
  },
  3843373140: function _(ID, a) {
    return new IFC4_3.IfcProjectedCRS(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  986844984: function _(ID, _69) {
    return new IFC4_3.IfcPropertyAbstraction(ID);
  },
  3710013099: function _(ID, a) {
    return new IFC4_3.IfcPropertyEnumeration(ID, a[0], a[1], a[2]);
  },
  2044713172: function _(ID, a) {
    return new IFC4_3.IfcQuantityArea(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2093928680: function _(ID, a) {
    return new IFC4_3.IfcQuantityCount(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  931644368: function _(ID, a) {
    return new IFC4_3.IfcQuantityLength(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2691318326: function _(ID, a) {
    return new IFC4_3.IfcQuantityNumber(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3252649465: function _(ID, a) {
    return new IFC4_3.IfcQuantityTime(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2405470396: function _(ID, a) {
    return new IFC4_3.IfcQuantityVolume(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  825690147: function _(ID, a) {
    return new IFC4_3.IfcQuantityWeight(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3915482550: function _(ID, a) {
    return new IFC4_3.IfcRecurrencePattern(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2433181523: function _(ID, a) {
    return new IFC4_3.IfcReference(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1076942058: function _(ID, a) {
    return new IFC4_3.IfcRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  3377609919: function _(ID, a) {
    return new IFC4_3.IfcRepresentationContext(ID, a[0], a[1]);
  },
  3008791417: function _(ID, _70) {
    return new IFC4_3.IfcRepresentationItem(ID);
  },
  1660063152: function _(ID, a) {
    return new IFC4_3.IfcRepresentationMap(ID, a[0], a[1]);
  },
  2439245199: function _(ID, a) {
    return new IFC4_3.IfcResourceLevelRelationship(ID, a[0], a[1]);
  },
  2341007311: function _(ID, a) {
    return new IFC4_3.IfcRoot(ID, a[0], a[1], a[2], a[3]);
  },
  448429030: function _(ID, a) {
    return new IFC4_3.IfcSIUnit(ID, a[0], a[1], a[2], a[3]);
  },
  1054537805: function _(ID, a) {
    return new IFC4_3.IfcSchedulingTime(ID, a[0], a[1], a[2]);
  },
  867548509: function _(ID, a) {
    return new IFC4_3.IfcShapeAspect(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3982875396: function _(ID, a) {
    return new IFC4_3.IfcShapeModel(ID, a[0], a[1], a[2], a[3]);
  },
  4240577450: function _(ID, a) {
    return new IFC4_3.IfcShapeRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  2273995522: function _(ID, a) {
    return new IFC4_3.IfcStructuralConnectionCondition(ID, a[0]);
  },
  2162789131: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoad(ID, a[0]);
  },
  3478079324: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadConfiguration(ID, a[0], a[1], a[2]);
  },
  609421318: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadOrResult(ID, a[0]);
  },
  2525727697: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadStatic(ID, a[0]);
  },
  3408363356: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadTemperature(ID, a[0], a[1], a[2], a[3]);
  },
  2830218821: function _(ID, a) {
    return new IFC4_3.IfcStyleModel(ID, a[0], a[1], a[2], a[3]);
  },
  3958052878: function _(ID, a) {
    return new IFC4_3.IfcStyledItem(ID, a[0], a[1], a[2]);
  },
  3049322572: function _(ID, a) {
    return new IFC4_3.IfcStyledRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  2934153892: function _(ID, a) {
    return new IFC4_3.IfcSurfaceReinforcementArea(ID, a[0], a[1], a[2], a[3]);
  },
  1300840506: function _(ID, a) {
    return new IFC4_3.IfcSurfaceStyle(ID, a[0], a[1], a[2]);
  },
  3303107099: function _(ID, a) {
    return new IFC4_3.IfcSurfaceStyleLighting(ID, a[0], a[1], a[2], a[3]);
  },
  1607154358: function _(ID, a) {
    return new IFC4_3.IfcSurfaceStyleRefraction(ID, a[0], a[1]);
  },
  846575682: function _(ID, a) {
    return new IFC4_3.IfcSurfaceStyleShading(ID, a[0], a[1]);
  },
  1351298697: function _(ID, a) {
    return new IFC4_3.IfcSurfaceStyleWithTextures(ID, a[0]);
  },
  626085974: function _(ID, a) {
    return new IFC4_3.IfcSurfaceTexture(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  985171141: function _(ID, a) {
    return new IFC4_3.IfcTable(ID, a[0], a[1], a[2]);
  },
  2043862942: function _(ID, a) {
    return new IFC4_3.IfcTableColumn(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  531007025: function _(ID, a) {
    return new IFC4_3.IfcTableRow(ID, a[0], a[1]);
  },
  1549132990: function _(ID, a) {
    return new IFC4_3.IfcTaskTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]);
  },
  2771591690: function _(ID, a) {
    return new IFC4_3.IfcTaskTimeRecurring(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20]);
  },
  912023232: function _(ID, a) {
    return new IFC4_3.IfcTelecomAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1447204868: function _(ID, a) {
    return new IFC4_3.IfcTextStyle(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2636378356: function _(ID, a) {
    return new IFC4_3.IfcTextStyleForDefinedFont(ID, a[0], a[1]);
  },
  1640371178: function _(ID, a) {
    return new IFC4_3.IfcTextStyleTextModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  280115917: function _(ID, a) {
    return new IFC4_3.IfcTextureCoordinate(ID, a[0]);
  },
  1742049831: function _(ID, a) {
    return new IFC4_3.IfcTextureCoordinateGenerator(ID, a[0], a[1], a[2]);
  },
  222769930: function _(ID, a) {
    return new IFC4_3.IfcTextureCoordinateIndices(ID, a[0], a[1]);
  },
  1010789467: function _(ID, a) {
    return new IFC4_3.IfcTextureCoordinateIndicesWithVoids(ID, a[0], a[1], a[2]);
  },
  2552916305: function _(ID, a) {
    return new IFC4_3.IfcTextureMap(ID, a[0], a[1], a[2]);
  },
  1210645708: function _(ID, a) {
    return new IFC4_3.IfcTextureVertex(ID, a[0]);
  },
  3611470254: function _(ID, a) {
    return new IFC4_3.IfcTextureVertexList(ID, a[0]);
  },
  1199560280: function _(ID, a) {
    return new IFC4_3.IfcTimePeriod(ID, a[0], a[1]);
  },
  3101149627: function _(ID, a) {
    return new IFC4_3.IfcTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  581633288: function _(ID, a) {
    return new IFC4_3.IfcTimeSeriesValue(ID, a[0]);
  },
  1377556343: function _(ID, _71) {
    return new IFC4_3.IfcTopologicalRepresentationItem(ID);
  },
  1735638870: function _(ID, a) {
    return new IFC4_3.IfcTopologyRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  180925521: function _(ID, a) {
    return new IFC4_3.IfcUnitAssignment(ID, a[0]);
  },
  2799835756: function _(ID, _72) {
    return new IFC4_3.IfcVertex(ID);
  },
  1907098498: function _(ID, a) {
    return new IFC4_3.IfcVertexPoint(ID, a[0]);
  },
  891718957: function _(ID, a) {
    return new IFC4_3.IfcVirtualGridIntersection(ID, a[0], a[1]);
  },
  1236880293: function _(ID, a) {
    return new IFC4_3.IfcWorkTime(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3752311538: function _(ID, a) {
    return new IFC4_3.IfcAlignmentCantSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  536804194: function _(ID, a) {
    return new IFC4_3.IfcAlignmentHorizontalSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3869604511: function _(ID, a) {
    return new IFC4_3.IfcApprovalRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  3798115385: function _(ID, a) {
    return new IFC4_3.IfcArbitraryClosedProfileDef(ID, a[0], a[1], a[2]);
  },
  1310608509: function _(ID, a) {
    return new IFC4_3.IfcArbitraryOpenProfileDef(ID, a[0], a[1], a[2]);
  },
  2705031697: function _(ID, a) {
    return new IFC4_3.IfcArbitraryProfileDefWithVoids(ID, a[0], a[1], a[2], a[3]);
  },
  616511568: function _(ID, a) {
    return new IFC4_3.IfcBlobTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3150382593: function _(ID, a) {
    return new IFC4_3.IfcCenterLineProfileDef(ID, a[0], a[1], a[2], a[3]);
  },
  747523909: function _(ID, a) {
    return new IFC4_3.IfcClassification(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  647927063: function _(ID, a) {
    return new IFC4_3.IfcClassificationReference(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3285139300: function _(ID, a) {
    return new IFC4_3.IfcColourRgbList(ID, a[0]);
  },
  3264961684: function _(ID, a) {
    return new IFC4_3.IfcColourSpecification(ID, a[0]);
  },
  1485152156: function _(ID, a) {
    return new IFC4_3.IfcCompositeProfileDef(ID, a[0], a[1], a[2], a[3]);
  },
  370225590: function _(ID, a) {
    return new IFC4_3.IfcConnectedFaceSet(ID, a[0]);
  },
  1981873012: function _(ID, a) {
    return new IFC4_3.IfcConnectionCurveGeometry(ID, a[0], a[1]);
  },
  45288368: function _(ID, a) {
    return new IFC4_3.IfcConnectionPointEccentricity(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3050246964: function _(ID, a) {
    return new IFC4_3.IfcContextDependentUnit(ID, a[0], a[1], a[2]);
  },
  2889183280: function _(ID, a) {
    return new IFC4_3.IfcConversionBasedUnit(ID, a[0], a[1], a[2], a[3]);
  },
  2713554722: function _(ID, a) {
    return new IFC4_3.IfcConversionBasedUnitWithOffset(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  539742890: function _(ID, a) {
    return new IFC4_3.IfcCurrencyRelationship(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3800577675: function _(ID, a) {
    return new IFC4_3.IfcCurveStyle(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1105321065: function _(ID, a) {
    return new IFC4_3.IfcCurveStyleFont(ID, a[0], a[1]);
  },
  2367409068: function _(ID, a) {
    return new IFC4_3.IfcCurveStyleFontAndScaling(ID, a[0], a[1], a[2]);
  },
  3510044353: function _(ID, a) {
    return new IFC4_3.IfcCurveStyleFontPattern(ID, a[0], a[1]);
  },
  3632507154: function _(ID, a) {
    return new IFC4_3.IfcDerivedProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1154170062: function _(ID, a) {
    return new IFC4_3.IfcDocumentInformation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]);
  },
  770865208: function _(ID, a) {
    return new IFC4_3.IfcDocumentInformationRelationship(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3732053477: function _(ID, a) {
    return new IFC4_3.IfcDocumentReference(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3900360178: function _(ID, a) {
    return new IFC4_3.IfcEdge(ID, a[0], a[1]);
  },
  476780140: function _(ID, a) {
    return new IFC4_3.IfcEdgeCurve(ID, a[0], a[1], a[2], a[3]);
  },
  211053100: function _(ID, a) {
    return new IFC4_3.IfcEventTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  297599258: function _(ID, a) {
    return new IFC4_3.IfcExtendedProperties(ID, a[0], a[1], a[2]);
  },
  1437805879: function _(ID, a) {
    return new IFC4_3.IfcExternalReferenceRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  2556980723: function _(ID, a) {
    return new IFC4_3.IfcFace(ID, a[0]);
  },
  1809719519: function _(ID, a) {
    return new IFC4_3.IfcFaceBound(ID, a[0], a[1]);
  },
  803316827: function _(ID, a) {
    return new IFC4_3.IfcFaceOuterBound(ID, a[0], a[1]);
  },
  3008276851: function _(ID, a) {
    return new IFC4_3.IfcFaceSurface(ID, a[0], a[1], a[2]);
  },
  4219587988: function _(ID, a) {
    return new IFC4_3.IfcFailureConnectionCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  738692330: function _(ID, a) {
    return new IFC4_3.IfcFillAreaStyle(ID, a[0], a[1], a[2]);
  },
  3448662350: function _(ID, a) {
    return new IFC4_3.IfcGeometricRepresentationContext(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2453401579: function _(ID, _73) {
    return new IFC4_3.IfcGeometricRepresentationItem(ID);
  },
  4142052618: function _(ID, a) {
    return new IFC4_3.IfcGeometricRepresentationSubContext(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3590301190: function _(ID, a) {
    return new IFC4_3.IfcGeometricSet(ID, a[0]);
  },
  178086475: function _(ID, a) {
    return new IFC4_3.IfcGridPlacement(ID, a[0], a[1], a[2]);
  },
  812098782: function _(ID, a) {
    return new IFC4_3.IfcHalfSpaceSolid(ID, a[0], a[1]);
  },
  3905492369: function _(ID, a) {
    return new IFC4_3.IfcImageTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3570813810: function _(ID, a) {
    return new IFC4_3.IfcIndexedColourMap(ID, a[0], a[1], a[2], a[3]);
  },
  1437953363: function _(ID, a) {
    return new IFC4_3.IfcIndexedTextureMap(ID, a[0], a[1], a[2]);
  },
  2133299955: function _(ID, a) {
    return new IFC4_3.IfcIndexedTriangleTextureMap(ID, a[0], a[1], a[2], a[3]);
  },
  3741457305: function _(ID, a) {
    return new IFC4_3.IfcIrregularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1585845231: function _(ID, a) {
    return new IFC4_3.IfcLagTime(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1402838566: function _(ID, a) {
    return new IFC4_3.IfcLightSource(ID, a[0], a[1], a[2], a[3]);
  },
  125510826: function _(ID, a) {
    return new IFC4_3.IfcLightSourceAmbient(ID, a[0], a[1], a[2], a[3]);
  },
  2604431987: function _(ID, a) {
    return new IFC4_3.IfcLightSourceDirectional(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4266656042: function _(ID, a) {
    return new IFC4_3.IfcLightSourceGoniometric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1520743889: function _(ID, a) {
    return new IFC4_3.IfcLightSourcePositional(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3422422726: function _(ID, a) {
    return new IFC4_3.IfcLightSourceSpot(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  388784114: function _(ID, a) {
    return new IFC4_3.IfcLinearPlacement(ID, a[0], a[1], a[2]);
  },
  2624227202: function _(ID, a) {
    return new IFC4_3.IfcLocalPlacement(ID, a[0], a[1]);
  },
  1008929658: function _(ID, _74) {
    return new IFC4_3.IfcLoop(ID);
  },
  2347385850: function _(ID, a) {
    return new IFC4_3.IfcMappedItem(ID, a[0], a[1]);
  },
  1838606355: function _(ID, a) {
    return new IFC4_3.IfcMaterial(ID, a[0], a[1], a[2]);
  },
  3708119e3: function _(ID, a) {
    return new IFC4_3.IfcMaterialConstituent(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2852063980: function _(ID, a) {
    return new IFC4_3.IfcMaterialConstituentSet(ID, a[0], a[1], a[2]);
  },
  2022407955: function _(ID, a) {
    return new IFC4_3.IfcMaterialDefinitionRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  1303795690: function _(ID, a) {
    return new IFC4_3.IfcMaterialLayerSetUsage(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3079605661: function _(ID, a) {
    return new IFC4_3.IfcMaterialProfileSetUsage(ID, a[0], a[1], a[2]);
  },
  3404854881: function _(ID, a) {
    return new IFC4_3.IfcMaterialProfileSetUsageTapering(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3265635763: function _(ID, a) {
    return new IFC4_3.IfcMaterialProperties(ID, a[0], a[1], a[2], a[3]);
  },
  853536259: function _(ID, a) {
    return new IFC4_3.IfcMaterialRelationship(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2998442950: function _(ID, a) {
    return new IFC4_3.IfcMirroredProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  219451334: function _(ID, a) {
    return new IFC4_3.IfcObjectDefinition(ID, a[0], a[1], a[2], a[3]);
  },
  182550632: function _(ID, a) {
    return new IFC4_3.IfcOpenCrossProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2665983363: function _(ID, a) {
    return new IFC4_3.IfcOpenShell(ID, a[0]);
  },
  1411181986: function _(ID, a) {
    return new IFC4_3.IfcOrganizationRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  1029017970: function _(ID, a) {
    return new IFC4_3.IfcOrientedEdge(ID, a[0], a[1], a[2]);
  },
  2529465313: function _(ID, a) {
    return new IFC4_3.IfcParameterizedProfileDef(ID, a[0], a[1], a[2]);
  },
  2519244187: function _(ID, a) {
    return new IFC4_3.IfcPath(ID, a[0]);
  },
  3021840470: function _(ID, a) {
    return new IFC4_3.IfcPhysicalComplexQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  597895409: function _(ID, a) {
    return new IFC4_3.IfcPixelTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2004835150: function _(ID, a) {
    return new IFC4_3.IfcPlacement(ID, a[0]);
  },
  1663979128: function _(ID, a) {
    return new IFC4_3.IfcPlanarExtent(ID, a[0], a[1]);
  },
  2067069095: function _(ID, _75) {
    return new IFC4_3.IfcPoint(ID);
  },
  2165702409: function _(ID, a) {
    return new IFC4_3.IfcPointByDistanceExpression(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4022376103: function _(ID, a) {
    return new IFC4_3.IfcPointOnCurve(ID, a[0], a[1]);
  },
  1423911732: function _(ID, a) {
    return new IFC4_3.IfcPointOnSurface(ID, a[0], a[1], a[2]);
  },
  2924175390: function _(ID, a) {
    return new IFC4_3.IfcPolyLoop(ID, a[0]);
  },
  2775532180: function _(ID, a) {
    return new IFC4_3.IfcPolygonalBoundedHalfSpace(ID, a[0], a[1], a[2], a[3]);
  },
  3727388367: function _(ID, a) {
    return new IFC4_3.IfcPreDefinedItem(ID, a[0]);
  },
  3778827333: function _(ID, _76) {
    return new IFC4_3.IfcPreDefinedProperties(ID);
  },
  1775413392: function _(ID, a) {
    return new IFC4_3.IfcPreDefinedTextFont(ID, a[0]);
  },
  673634403: function _(ID, a) {
    return new IFC4_3.IfcProductDefinitionShape(ID, a[0], a[1], a[2]);
  },
  2802850158: function _(ID, a) {
    return new IFC4_3.IfcProfileProperties(ID, a[0], a[1], a[2], a[3]);
  },
  2598011224: function _(ID, a) {
    return new IFC4_3.IfcProperty(ID, a[0], a[1]);
  },
  1680319473: function _(ID, a) {
    return new IFC4_3.IfcPropertyDefinition(ID, a[0], a[1], a[2], a[3]);
  },
  148025276: function _(ID, a) {
    return new IFC4_3.IfcPropertyDependencyRelationship(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3357820518: function _(ID, a) {
    return new IFC4_3.IfcPropertySetDefinition(ID, a[0], a[1], a[2], a[3]);
  },
  1482703590: function _(ID, a) {
    return new IFC4_3.IfcPropertyTemplateDefinition(ID, a[0], a[1], a[2], a[3]);
  },
  2090586900: function _(ID, a) {
    return new IFC4_3.IfcQuantitySet(ID, a[0], a[1], a[2], a[3]);
  },
  3615266464: function _(ID, a) {
    return new IFC4_3.IfcRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3413951693: function _(ID, a) {
    return new IFC4_3.IfcRegularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1580146022: function _(ID, a) {
    return new IFC4_3.IfcReinforcementBarProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  478536968: function _(ID, a) {
    return new IFC4_3.IfcRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  2943643501: function _(ID, a) {
    return new IFC4_3.IfcResourceApprovalRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  1608871552: function _(ID, a) {
    return new IFC4_3.IfcResourceConstraintRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  1042787934: function _(ID, a) {
    return new IFC4_3.IfcResourceTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]);
  },
  2778083089: function _(ID, a) {
    return new IFC4_3.IfcRoundedRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2042790032: function _(ID, a) {
    return new IFC4_3.IfcSectionProperties(ID, a[0], a[1], a[2]);
  },
  4165799628: function _(ID, a) {
    return new IFC4_3.IfcSectionReinforcementProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1509187699: function _(ID, a) {
    return new IFC4_3.IfcSectionedSpine(ID, a[0], a[1], a[2]);
  },
  823603102: function _(ID, a) {
    return new IFC4_3.IfcSegment(ID, a[0]);
  },
  4124623270: function _(ID, a) {
    return new IFC4_3.IfcShellBasedSurfaceModel(ID, a[0]);
  },
  3692461612: function _(ID, a) {
    return new IFC4_3.IfcSimpleProperty(ID, a[0], a[1]);
  },
  2609359061: function _(ID, a) {
    return new IFC4_3.IfcSlippageConnectionCondition(ID, a[0], a[1], a[2], a[3]);
  },
  723233188: function _(ID, _77) {
    return new IFC4_3.IfcSolidModel(ID);
  },
  1595516126: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadLinearForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2668620305: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadPlanarForce(ID, a[0], a[1], a[2], a[3]);
  },
  2473145415: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadSingleDisplacement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1973038258: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadSingleDisplacementDistortion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1597423693: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadSingleForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1190533807: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadSingleForceWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2233826070: function _(ID, a) {
    return new IFC4_3.IfcSubedge(ID, a[0], a[1], a[2]);
  },
  2513912981: function _(ID, _78) {
    return new IFC4_3.IfcSurface(ID);
  },
  1878645084: function _(ID, a) {
    return new IFC4_3.IfcSurfaceStyleRendering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2247615214: function _(ID, a) {
    return new IFC4_3.IfcSweptAreaSolid(ID, a[0], a[1]);
  },
  1260650574: function _(ID, a) {
    return new IFC4_3.IfcSweptDiskSolid(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1096409881: function _(ID, a) {
    return new IFC4_3.IfcSweptDiskSolidPolygonal(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  230924584: function _(ID, a) {
    return new IFC4_3.IfcSweptSurface(ID, a[0], a[1]);
  },
  3071757647: function _(ID, a) {
    return new IFC4_3.IfcTShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  901063453: function _(ID, _79) {
    return new IFC4_3.IfcTessellatedItem(ID);
  },
  4282788508: function _(ID, a) {
    return new IFC4_3.IfcTextLiteral(ID, a[0], a[1], a[2]);
  },
  3124975700: function _(ID, a) {
    return new IFC4_3.IfcTextLiteralWithExtent(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1983826977: function _(ID, a) {
    return new IFC4_3.IfcTextStyleFontModel(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2715220739: function _(ID, a) {
    return new IFC4_3.IfcTrapeziumProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1628702193: function _(ID, a) {
    return new IFC4_3.IfcTypeObject(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3736923433: function _(ID, a) {
    return new IFC4_3.IfcTypeProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2347495698: function _(ID, a) {
    return new IFC4_3.IfcTypeProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3698973494: function _(ID, a) {
    return new IFC4_3.IfcTypeResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  427810014: function _(ID, a) {
    return new IFC4_3.IfcUShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1417489154: function _(ID, a) {
    return new IFC4_3.IfcVector(ID, a[0], a[1]);
  },
  2759199220: function _(ID, a) {
    return new IFC4_3.IfcVertexLoop(ID, a[0]);
  },
  2543172580: function _(ID, a) {
    return new IFC4_3.IfcZShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3406155212: function _(ID, a) {
    return new IFC4_3.IfcAdvancedFace(ID, a[0], a[1], a[2]);
  },
  669184980: function _(ID, a) {
    return new IFC4_3.IfcAnnotationFillArea(ID, a[0], a[1]);
  },
  3207858831: function _(ID, a) {
    return new IFC4_3.IfcAsymmetricIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]);
  },
  4261334040: function _(ID, a) {
    return new IFC4_3.IfcAxis1Placement(ID, a[0], a[1]);
  },
  3125803723: function _(ID, a) {
    return new IFC4_3.IfcAxis2Placement2D(ID, a[0], a[1]);
  },
  2740243338: function _(ID, a) {
    return new IFC4_3.IfcAxis2Placement3D(ID, a[0], a[1], a[2]);
  },
  3425423356: function _(ID, a) {
    return new IFC4_3.IfcAxis2PlacementLinear(ID, a[0], a[1], a[2]);
  },
  2736907675: function _(ID, a) {
    return new IFC4_3.IfcBooleanResult(ID, a[0], a[1], a[2]);
  },
  4182860854: function _(ID, _80) {
    return new IFC4_3.IfcBoundedSurface(ID);
  },
  2581212453: function _(ID, a) {
    return new IFC4_3.IfcBoundingBox(ID, a[0], a[1], a[2], a[3]);
  },
  2713105998: function _(ID, a) {
    return new IFC4_3.IfcBoxedHalfSpace(ID, a[0], a[1], a[2]);
  },
  2898889636: function _(ID, a) {
    return new IFC4_3.IfcCShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1123145078: function _(ID, a) {
    return new IFC4_3.IfcCartesianPoint(ID, a[0]);
  },
  574549367: function _(ID, _81) {
    return new IFC4_3.IfcCartesianPointList(ID);
  },
  1675464909: function _(ID, a) {
    return new IFC4_3.IfcCartesianPointList2D(ID, a[0], a[1]);
  },
  2059837836: function _(ID, a) {
    return new IFC4_3.IfcCartesianPointList3D(ID, a[0], a[1]);
  },
  59481748: function _(ID, a) {
    return new IFC4_3.IfcCartesianTransformationOperator(ID, a[0], a[1], a[2], a[3]);
  },
  3749851601: function _(ID, a) {
    return new IFC4_3.IfcCartesianTransformationOperator2D(ID, a[0], a[1], a[2], a[3]);
  },
  3486308946: function _(ID, a) {
    return new IFC4_3.IfcCartesianTransformationOperator2DnonUniform(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3331915920: function _(ID, a) {
    return new IFC4_3.IfcCartesianTransformationOperator3D(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1416205885: function _(ID, a) {
    return new IFC4_3.IfcCartesianTransformationOperator3DnonUniform(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1383045692: function _(ID, a) {
    return new IFC4_3.IfcCircleProfileDef(ID, a[0], a[1], a[2], a[3]);
  },
  2205249479: function _(ID, a) {
    return new IFC4_3.IfcClosedShell(ID, a[0]);
  },
  776857604: function _(ID, a) {
    return new IFC4_3.IfcColourRgb(ID, a[0], a[1], a[2], a[3]);
  },
  2542286263: function _(ID, a) {
    return new IFC4_3.IfcComplexProperty(ID, a[0], a[1], a[2], a[3]);
  },
  2485617015: function _(ID, a) {
    return new IFC4_3.IfcCompositeCurveSegment(ID, a[0], a[1], a[2]);
  },
  2574617495: function _(ID, a) {
    return new IFC4_3.IfcConstructionResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  3419103109: function _(ID, a) {
    return new IFC4_3.IfcContext(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1815067380: function _(ID, a) {
    return new IFC4_3.IfcCrewResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  2506170314: function _(ID, a) {
    return new IFC4_3.IfcCsgPrimitive3D(ID, a[0]);
  },
  2147822146: function _(ID, a) {
    return new IFC4_3.IfcCsgSolid(ID, a[0]);
  },
  2601014836: function _(ID, _82) {
    return new IFC4_3.IfcCurve(ID);
  },
  2827736869: function _(ID, a) {
    return new IFC4_3.IfcCurveBoundedPlane(ID, a[0], a[1], a[2]);
  },
  2629017746: function _(ID, a) {
    return new IFC4_3.IfcCurveBoundedSurface(ID, a[0], a[1], a[2]);
  },
  4212018352: function _(ID, a) {
    return new IFC4_3.IfcCurveSegment(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  32440307: function _(ID, a) {
    return new IFC4_3.IfcDirection(ID, a[0]);
  },
  593015953: function _(ID, a) {
    return new IFC4_3.IfcDirectrixCurveSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1472233963: function _(ID, a) {
    return new IFC4_3.IfcEdgeLoop(ID, a[0]);
  },
  1883228015: function _(ID, a) {
    return new IFC4_3.IfcElementQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  339256511: function _(ID, a) {
    return new IFC4_3.IfcElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2777663545: function _(ID, a) {
    return new IFC4_3.IfcElementarySurface(ID, a[0]);
  },
  2835456948: function _(ID, a) {
    return new IFC4_3.IfcEllipseProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4024345920: function _(ID, a) {
    return new IFC4_3.IfcEventType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  477187591: function _(ID, a) {
    return new IFC4_3.IfcExtrudedAreaSolid(ID, a[0], a[1], a[2], a[3]);
  },
  2804161546: function _(ID, a) {
    return new IFC4_3.IfcExtrudedAreaSolidTapered(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2047409740: function _(ID, a) {
    return new IFC4_3.IfcFaceBasedSurfaceModel(ID, a[0]);
  },
  374418227: function _(ID, a) {
    return new IFC4_3.IfcFillAreaStyleHatching(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  315944413: function _(ID, a) {
    return new IFC4_3.IfcFillAreaStyleTiles(ID, a[0], a[1], a[2]);
  },
  2652556860: function _(ID, a) {
    return new IFC4_3.IfcFixedReferenceSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4238390223: function _(ID, a) {
    return new IFC4_3.IfcFurnishingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1268542332: function _(ID, a) {
    return new IFC4_3.IfcFurnitureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4095422895: function _(ID, a) {
    return new IFC4_3.IfcGeographicElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  987898635: function _(ID, a) {
    return new IFC4_3.IfcGeometricCurveSet(ID, a[0]);
  },
  1484403080: function _(ID, a) {
    return new IFC4_3.IfcIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  178912537: function _(ID, a) {
    return new IFC4_3.IfcIndexedPolygonalFace(ID, a[0]);
  },
  2294589976: function _(ID, a) {
    return new IFC4_3.IfcIndexedPolygonalFaceWithVoids(ID, a[0], a[1]);
  },
  3465909080: function _(ID, a) {
    return new IFC4_3.IfcIndexedPolygonalTextureMap(ID, a[0], a[1], a[2], a[3]);
  },
  572779678: function _(ID, a) {
    return new IFC4_3.IfcLShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  428585644: function _(ID, a) {
    return new IFC4_3.IfcLaborResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1281925730: function _(ID, a) {
    return new IFC4_3.IfcLine(ID, a[0], a[1]);
  },
  1425443689: function _(ID, a) {
    return new IFC4_3.IfcManifoldSolidBrep(ID, a[0]);
  },
  3888040117: function _(ID, a) {
    return new IFC4_3.IfcObject(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  590820931: function _(ID, a) {
    return new IFC4_3.IfcOffsetCurve(ID, a[0]);
  },
  3388369263: function _(ID, a) {
    return new IFC4_3.IfcOffsetCurve2D(ID, a[0], a[1], a[2]);
  },
  3505215534: function _(ID, a) {
    return new IFC4_3.IfcOffsetCurve3D(ID, a[0], a[1], a[2], a[3]);
  },
  2485787929: function _(ID, a) {
    return new IFC4_3.IfcOffsetCurveByDistances(ID, a[0], a[1], a[2]);
  },
  1682466193: function _(ID, a) {
    return new IFC4_3.IfcPcurve(ID, a[0], a[1]);
  },
  603570806: function _(ID, a) {
    return new IFC4_3.IfcPlanarBox(ID, a[0], a[1], a[2]);
  },
  220341763: function _(ID, a) {
    return new IFC4_3.IfcPlane(ID, a[0]);
  },
  3381221214: function _(ID, a) {
    return new IFC4_3.IfcPolynomialCurve(ID, a[0], a[1], a[2], a[3]);
  },
  759155922: function _(ID, a) {
    return new IFC4_3.IfcPreDefinedColour(ID, a[0]);
  },
  2559016684: function _(ID, a) {
    return new IFC4_3.IfcPreDefinedCurveFont(ID, a[0]);
  },
  3967405729: function _(ID, a) {
    return new IFC4_3.IfcPreDefinedPropertySet(ID, a[0], a[1], a[2], a[3]);
  },
  569719735: function _(ID, a) {
    return new IFC4_3.IfcProcedureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2945172077: function _(ID, a) {
    return new IFC4_3.IfcProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  4208778838: function _(ID, a) {
    return new IFC4_3.IfcProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  103090709: function _(ID, a) {
    return new IFC4_3.IfcProject(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  653396225: function _(ID, a) {
    return new IFC4_3.IfcProjectLibrary(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  871118103: function _(ID, a) {
    return new IFC4_3.IfcPropertyBoundedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4166981789: function _(ID, a) {
    return new IFC4_3.IfcPropertyEnumeratedValue(ID, a[0], a[1], a[2], a[3]);
  },
  2752243245: function _(ID, a) {
    return new IFC4_3.IfcPropertyListValue(ID, a[0], a[1], a[2], a[3]);
  },
  941946838: function _(ID, a) {
    return new IFC4_3.IfcPropertyReferenceValue(ID, a[0], a[1], a[2], a[3]);
  },
  1451395588: function _(ID, a) {
    return new IFC4_3.IfcPropertySet(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  492091185: function _(ID, a) {
    return new IFC4_3.IfcPropertySetTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3650150729: function _(ID, a) {
    return new IFC4_3.IfcPropertySingleValue(ID, a[0], a[1], a[2], a[3]);
  },
  110355661: function _(ID, a) {
    return new IFC4_3.IfcPropertyTableValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3521284610: function _(ID, a) {
    return new IFC4_3.IfcPropertyTemplate(ID, a[0], a[1], a[2], a[3]);
  },
  2770003689: function _(ID, a) {
    return new IFC4_3.IfcRectangleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2798486643: function _(ID, a) {
    return new IFC4_3.IfcRectangularPyramid(ID, a[0], a[1], a[2], a[3]);
  },
  3454111270: function _(ID, a) {
    return new IFC4_3.IfcRectangularTrimmedSurface(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3765753017: function _(ID, a) {
    return new IFC4_3.IfcReinforcementDefinitionProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3939117080: function _(ID, a) {
    return new IFC4_3.IfcRelAssigns(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1683148259: function _(ID, a) {
    return new IFC4_3.IfcRelAssignsToActor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2495723537: function _(ID, a) {
    return new IFC4_3.IfcRelAssignsToControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1307041759: function _(ID, a) {
    return new IFC4_3.IfcRelAssignsToGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1027710054: function _(ID, a) {
    return new IFC4_3.IfcRelAssignsToGroupByFactor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4278684876: function _(ID, a) {
    return new IFC4_3.IfcRelAssignsToProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2857406711: function _(ID, a) {
    return new IFC4_3.IfcRelAssignsToProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  205026976: function _(ID, a) {
    return new IFC4_3.IfcRelAssignsToResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1865459582: function _(ID, a) {
    return new IFC4_3.IfcRelAssociates(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4095574036: function _(ID, a) {
    return new IFC4_3.IfcRelAssociatesApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  919958153: function _(ID, a) {
    return new IFC4_3.IfcRelAssociatesClassification(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2728634034: function _(ID, a) {
    return new IFC4_3.IfcRelAssociatesConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  982818633: function _(ID, a) {
    return new IFC4_3.IfcRelAssociatesDocument(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3840914261: function _(ID, a) {
    return new IFC4_3.IfcRelAssociatesLibrary(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2655215786: function _(ID, a) {
    return new IFC4_3.IfcRelAssociatesMaterial(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1033248425: function _(ID, a) {
    return new IFC4_3.IfcRelAssociatesProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  826625072: function _(ID, a) {
    return new IFC4_3.IfcRelConnects(ID, a[0], a[1], a[2], a[3]);
  },
  1204542856: function _(ID, a) {
    return new IFC4_3.IfcRelConnectsElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3945020480: function _(ID, a) {
    return new IFC4_3.IfcRelConnectsPathElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4201705270: function _(ID, a) {
    return new IFC4_3.IfcRelConnectsPortToElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3190031847: function _(ID, a) {
    return new IFC4_3.IfcRelConnectsPorts(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2127690289: function _(ID, a) {
    return new IFC4_3.IfcRelConnectsStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1638771189: function _(ID, a) {
    return new IFC4_3.IfcRelConnectsStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  504942748: function _(ID, a) {
    return new IFC4_3.IfcRelConnectsWithEccentricity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  3678494232: function _(ID, a) {
    return new IFC4_3.IfcRelConnectsWithRealizingElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3242617779: function _(ID, a) {
    return new IFC4_3.IfcRelContainedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  886880790: function _(ID, a) {
    return new IFC4_3.IfcRelCoversBldgElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2802773753: function _(ID, a) {
    return new IFC4_3.IfcRelCoversSpaces(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2565941209: function _(ID, a) {
    return new IFC4_3.IfcRelDeclares(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2551354335: function _(ID, a) {
    return new IFC4_3.IfcRelDecomposes(ID, a[0], a[1], a[2], a[3]);
  },
  693640335: function _(ID, a) {
    return new IFC4_3.IfcRelDefines(ID, a[0], a[1], a[2], a[3]);
  },
  1462361463: function _(ID, a) {
    return new IFC4_3.IfcRelDefinesByObject(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4186316022: function _(ID, a) {
    return new IFC4_3.IfcRelDefinesByProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  307848117: function _(ID, a) {
    return new IFC4_3.IfcRelDefinesByTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  781010003: function _(ID, a) {
    return new IFC4_3.IfcRelDefinesByType(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3940055652: function _(ID, a) {
    return new IFC4_3.IfcRelFillsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  279856033: function _(ID, a) {
    return new IFC4_3.IfcRelFlowControlElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  427948657: function _(ID, a) {
    return new IFC4_3.IfcRelInterferesElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3268803585: function _(ID, a) {
    return new IFC4_3.IfcRelNests(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1441486842: function _(ID, a) {
    return new IFC4_3.IfcRelPositions(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  750771296: function _(ID, a) {
    return new IFC4_3.IfcRelProjectsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1245217292: function _(ID, a) {
    return new IFC4_3.IfcRelReferencedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4122056220: function _(ID, a) {
    return new IFC4_3.IfcRelSequence(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  366585022: function _(ID, a) {
    return new IFC4_3.IfcRelServicesBuildings(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3451746338: function _(ID, a) {
    return new IFC4_3.IfcRelSpaceBoundary(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3523091289: function _(ID, a) {
    return new IFC4_3.IfcRelSpaceBoundary1stLevel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1521410863: function _(ID, a) {
    return new IFC4_3.IfcRelSpaceBoundary2ndLevel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1401173127: function _(ID, a) {
    return new IFC4_3.IfcRelVoidsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  816062949: function _(ID, a) {
    return new IFC4_3.IfcReparametrisedCompositeCurveSegment(ID, a[0], a[1], a[2], a[3]);
  },
  2914609552: function _(ID, a) {
    return new IFC4_3.IfcResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1856042241: function _(ID, a) {
    return new IFC4_3.IfcRevolvedAreaSolid(ID, a[0], a[1], a[2], a[3]);
  },
  3243963512: function _(ID, a) {
    return new IFC4_3.IfcRevolvedAreaSolidTapered(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4158566097: function _(ID, a) {
    return new IFC4_3.IfcRightCircularCone(ID, a[0], a[1], a[2]);
  },
  3626867408: function _(ID, a) {
    return new IFC4_3.IfcRightCircularCylinder(ID, a[0], a[1], a[2]);
  },
  1862484736: function _(ID, a) {
    return new IFC4_3.IfcSectionedSolid(ID, a[0], a[1]);
  },
  1290935644: function _(ID, a) {
    return new IFC4_3.IfcSectionedSolidHorizontal(ID, a[0], a[1], a[2]);
  },
  1356537516: function _(ID, a) {
    return new IFC4_3.IfcSectionedSurface(ID, a[0], a[1], a[2]);
  },
  3663146110: function _(ID, a) {
    return new IFC4_3.IfcSimplePropertyTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1412071761: function _(ID, a) {
    return new IFC4_3.IfcSpatialElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  710998568: function _(ID, a) {
    return new IFC4_3.IfcSpatialElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2706606064: function _(ID, a) {
    return new IFC4_3.IfcSpatialStructureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3893378262: function _(ID, a) {
    return new IFC4_3.IfcSpatialStructureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  463610769: function _(ID, a) {
    return new IFC4_3.IfcSpatialZone(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2481509218: function _(ID, a) {
    return new IFC4_3.IfcSpatialZoneType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  451544542: function _(ID, a) {
    return new IFC4_3.IfcSphere(ID, a[0], a[1]);
  },
  4015995234: function _(ID, a) {
    return new IFC4_3.IfcSphericalSurface(ID, a[0], a[1]);
  },
  2735484536: function _(ID, a) {
    return new IFC4_3.IfcSpiral(ID, a[0]);
  },
  3544373492: function _(ID, a) {
    return new IFC4_3.IfcStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3136571912: function _(ID, a) {
    return new IFC4_3.IfcStructuralItem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  530289379: function _(ID, a) {
    return new IFC4_3.IfcStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3689010777: function _(ID, a) {
    return new IFC4_3.IfcStructuralReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3979015343: function _(ID, a) {
    return new IFC4_3.IfcStructuralSurfaceMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2218152070: function _(ID, a) {
    return new IFC4_3.IfcStructuralSurfaceMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  603775116: function _(ID, a) {
    return new IFC4_3.IfcStructuralSurfaceReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4095615324: function _(ID, a) {
    return new IFC4_3.IfcSubContractResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  699246055: function _(ID, a) {
    return new IFC4_3.IfcSurfaceCurve(ID, a[0], a[1], a[2]);
  },
  2028607225: function _(ID, a) {
    return new IFC4_3.IfcSurfaceCurveSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2809605785: function _(ID, a) {
    return new IFC4_3.IfcSurfaceOfLinearExtrusion(ID, a[0], a[1], a[2], a[3]);
  },
  4124788165: function _(ID, a) {
    return new IFC4_3.IfcSurfaceOfRevolution(ID, a[0], a[1], a[2]);
  },
  1580310250: function _(ID, a) {
    return new IFC4_3.IfcSystemFurnitureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3473067441: function _(ID, a) {
    return new IFC4_3.IfcTask(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  3206491090: function _(ID, a) {
    return new IFC4_3.IfcTaskType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2387106220: function _(ID, a) {
    return new IFC4_3.IfcTessellatedFaceSet(ID, a[0], a[1]);
  },
  782932809: function _(ID, a) {
    return new IFC4_3.IfcThirdOrderPolynomialSpiral(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1935646853: function _(ID, a) {
    return new IFC4_3.IfcToroidalSurface(ID, a[0], a[1], a[2]);
  },
  3665877780: function _(ID, a) {
    return new IFC4_3.IfcTransportationDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2916149573: function _(ID, a) {
    return new IFC4_3.IfcTriangulatedFaceSet(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1229763772: function _(ID, a) {
    return new IFC4_3.IfcTriangulatedIrregularNetwork(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3651464721: function _(ID, a) {
    return new IFC4_3.IfcVehicleType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  336235671: function _(ID, a) {
    return new IFC4_3.IfcWindowLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
  },
  512836454: function _(ID, a) {
    return new IFC4_3.IfcWindowPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2296667514: function _(ID, a) {
    return new IFC4_3.IfcActor(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1635779807: function _(ID, a) {
    return new IFC4_3.IfcAdvancedBrep(ID, a[0]);
  },
  2603310189: function _(ID, a) {
    return new IFC4_3.IfcAdvancedBrepWithVoids(ID, a[0], a[1]);
  },
  1674181508: function _(ID, a) {
    return new IFC4_3.IfcAnnotation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2887950389: function _(ID, a) {
    return new IFC4_3.IfcBSplineSurface(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  167062518: function _(ID, a) {
    return new IFC4_3.IfcBSplineSurfaceWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1334484129: function _(ID, a) {
    return new IFC4_3.IfcBlock(ID, a[0], a[1], a[2], a[3]);
  },
  3649129432: function _(ID, a) {
    return new IFC4_3.IfcBooleanClippingResult(ID, a[0], a[1], a[2]);
  },
  1260505505: function _(ID, _83) {
    return new IFC4_3.IfcBoundedCurve(ID);
  },
  3124254112: function _(ID, a) {
    return new IFC4_3.IfcBuildingStorey(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1626504194: function _(ID, a) {
    return new IFC4_3.IfcBuiltElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2197970202: function _(ID, a) {
    return new IFC4_3.IfcChimneyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2937912522: function _(ID, a) {
    return new IFC4_3.IfcCircleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3893394355: function _(ID, a) {
    return new IFC4_3.IfcCivilElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3497074424: function _(ID, a) {
    return new IFC4_3.IfcClothoid(ID, a[0], a[1]);
  },
  300633059: function _(ID, a) {
    return new IFC4_3.IfcColumnType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3875453745: function _(ID, a) {
    return new IFC4_3.IfcComplexPropertyTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3732776249: function _(ID, a) {
    return new IFC4_3.IfcCompositeCurve(ID, a[0], a[1]);
  },
  15328376: function _(ID, a) {
    return new IFC4_3.IfcCompositeCurveOnSurface(ID, a[0], a[1]);
  },
  2510884976: function _(ID, a) {
    return new IFC4_3.IfcConic(ID, a[0]);
  },
  2185764099: function _(ID, a) {
    return new IFC4_3.IfcConstructionEquipmentResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  4105962743: function _(ID, a) {
    return new IFC4_3.IfcConstructionMaterialResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1525564444: function _(ID, a) {
    return new IFC4_3.IfcConstructionProductResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  2559216714: function _(ID, a) {
    return new IFC4_3.IfcConstructionResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3293443760: function _(ID, a) {
    return new IFC4_3.IfcControl(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2000195564: function _(ID, a) {
    return new IFC4_3.IfcCosineSpiral(ID, a[0], a[1], a[2]);
  },
  3895139033: function _(ID, a) {
    return new IFC4_3.IfcCostItem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1419761937: function _(ID, a) {
    return new IFC4_3.IfcCostSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4189326743: function _(ID, a) {
    return new IFC4_3.IfcCourseType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1916426348: function _(ID, a) {
    return new IFC4_3.IfcCoveringType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3295246426: function _(ID, a) {
    return new IFC4_3.IfcCrewResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1457835157: function _(ID, a) {
    return new IFC4_3.IfcCurtainWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1213902940: function _(ID, a) {
    return new IFC4_3.IfcCylindricalSurface(ID, a[0], a[1]);
  },
  1306400036: function _(ID, a) {
    return new IFC4_3.IfcDeepFoundationType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4234616927: function _(ID, a) {
    return new IFC4_3.IfcDirectrixDerivedReferenceSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3256556792: function _(ID, a) {
    return new IFC4_3.IfcDistributionElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3849074793: function _(ID, a) {
    return new IFC4_3.IfcDistributionFlowElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2963535650: function _(ID, a) {
    return new IFC4_3.IfcDoorLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]);
  },
  1714330368: function _(ID, a) {
    return new IFC4_3.IfcDoorPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2323601079: function _(ID, a) {
    return new IFC4_3.IfcDoorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  445594917: function _(ID, a) {
    return new IFC4_3.IfcDraughtingPreDefinedColour(ID, a[0]);
  },
  4006246654: function _(ID, a) {
    return new IFC4_3.IfcDraughtingPreDefinedCurveFont(ID, a[0]);
  },
  1758889154: function _(ID, a) {
    return new IFC4_3.IfcElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4123344466: function _(ID, a) {
    return new IFC4_3.IfcElementAssembly(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2397081782: function _(ID, a) {
    return new IFC4_3.IfcElementAssemblyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1623761950: function _(ID, a) {
    return new IFC4_3.IfcElementComponent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2590856083: function _(ID, a) {
    return new IFC4_3.IfcElementComponentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1704287377: function _(ID, a) {
    return new IFC4_3.IfcEllipse(ID, a[0], a[1], a[2]);
  },
  2107101300: function _(ID, a) {
    return new IFC4_3.IfcEnergyConversionDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  132023988: function _(ID, a) {
    return new IFC4_3.IfcEngineType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3174744832: function _(ID, a) {
    return new IFC4_3.IfcEvaporativeCoolerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3390157468: function _(ID, a) {
    return new IFC4_3.IfcEvaporatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4148101412: function _(ID, a) {
    return new IFC4_3.IfcEvent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2853485674: function _(ID, a) {
    return new IFC4_3.IfcExternalSpatialStructureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  807026263: function _(ID, a) {
    return new IFC4_3.IfcFacetedBrep(ID, a[0]);
  },
  3737207727: function _(ID, a) {
    return new IFC4_3.IfcFacetedBrepWithVoids(ID, a[0], a[1]);
  },
  24185140: function _(ID, a) {
    return new IFC4_3.IfcFacility(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1310830890: function _(ID, a) {
    return new IFC4_3.IfcFacilityPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4228831410: function _(ID, a) {
    return new IFC4_3.IfcFacilityPartCommon(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  647756555: function _(ID, a) {
    return new IFC4_3.IfcFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2489546625: function _(ID, a) {
    return new IFC4_3.IfcFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2827207264: function _(ID, a) {
    return new IFC4_3.IfcFeatureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2143335405: function _(ID, a) {
    return new IFC4_3.IfcFeatureElementAddition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1287392070: function _(ID, a) {
    return new IFC4_3.IfcFeatureElementSubtraction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3907093117: function _(ID, a) {
    return new IFC4_3.IfcFlowControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3198132628: function _(ID, a) {
    return new IFC4_3.IfcFlowFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3815607619: function _(ID, a) {
    return new IFC4_3.IfcFlowMeterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1482959167: function _(ID, a) {
    return new IFC4_3.IfcFlowMovingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1834744321: function _(ID, a) {
    return new IFC4_3.IfcFlowSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1339347760: function _(ID, a) {
    return new IFC4_3.IfcFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2297155007: function _(ID, a) {
    return new IFC4_3.IfcFlowTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3009222698: function _(ID, a) {
    return new IFC4_3.IfcFlowTreatmentDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1893162501: function _(ID, a) {
    return new IFC4_3.IfcFootingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  263784265: function _(ID, a) {
    return new IFC4_3.IfcFurnishingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1509553395: function _(ID, a) {
    return new IFC4_3.IfcFurniture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3493046030: function _(ID, a) {
    return new IFC4_3.IfcGeographicElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4230923436: function _(ID, a) {
    return new IFC4_3.IfcGeotechnicalElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1594536857: function _(ID, a) {
    return new IFC4_3.IfcGeotechnicalStratum(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2898700619: function _(ID, a) {
    return new IFC4_3.IfcGradientCurve(ID, a[0], a[1], a[2], a[3]);
  },
  2706460486: function _(ID, a) {
    return new IFC4_3.IfcGroup(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1251058090: function _(ID, a) {
    return new IFC4_3.IfcHeatExchangerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1806887404: function _(ID, a) {
    return new IFC4_3.IfcHumidifierType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2568555532: function _(ID, a) {
    return new IFC4_3.IfcImpactProtectionDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3948183225: function _(ID, a) {
    return new IFC4_3.IfcImpactProtectionDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2571569899: function _(ID, a) {
    return new IFC4_3.IfcIndexedPolyCurve(ID, a[0], a[1], a[2]);
  },
  3946677679: function _(ID, a) {
    return new IFC4_3.IfcInterceptorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3113134337: function _(ID, a) {
    return new IFC4_3.IfcIntersectionCurve(ID, a[0], a[1], a[2]);
  },
  2391368822: function _(ID, a) {
    return new IFC4_3.IfcInventory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4288270099: function _(ID, a) {
    return new IFC4_3.IfcJunctionBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  679976338: function _(ID, a) {
    return new IFC4_3.IfcKerbType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3827777499: function _(ID, a) {
    return new IFC4_3.IfcLaborResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1051575348: function _(ID, a) {
    return new IFC4_3.IfcLampType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1161773419: function _(ID, a) {
    return new IFC4_3.IfcLightFixtureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2176059722: function _(ID, a) {
    return new IFC4_3.IfcLinearElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1770583370: function _(ID, a) {
    return new IFC4_3.IfcLiquidTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  525669439: function _(ID, a) {
    return new IFC4_3.IfcMarineFacility(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  976884017: function _(ID, a) {
    return new IFC4_3.IfcMarinePart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  377706215: function _(ID, a) {
    return new IFC4_3.IfcMechanicalFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2108223431: function _(ID, a) {
    return new IFC4_3.IfcMechanicalFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1114901282: function _(ID, a) {
    return new IFC4_3.IfcMedicalDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3181161470: function _(ID, a) {
    return new IFC4_3.IfcMemberType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1950438474: function _(ID, a) {
    return new IFC4_3.IfcMobileTelecommunicationsApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  710110818: function _(ID, a) {
    return new IFC4_3.IfcMooringDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  977012517: function _(ID, a) {
    return new IFC4_3.IfcMotorConnectionType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  506776471: function _(ID, a) {
    return new IFC4_3.IfcNavigationElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4143007308: function _(ID, a) {
    return new IFC4_3.IfcOccupant(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3588315303: function _(ID, a) {
    return new IFC4_3.IfcOpeningElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2837617999: function _(ID, a) {
    return new IFC4_3.IfcOutletType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  514975943: function _(ID, a) {
    return new IFC4_3.IfcPavementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2382730787: function _(ID, a) {
    return new IFC4_3.IfcPerformanceHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3566463478: function _(ID, a) {
    return new IFC4_3.IfcPermeableCoveringProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3327091369: function _(ID, a) {
    return new IFC4_3.IfcPermit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1158309216: function _(ID, a) {
    return new IFC4_3.IfcPileType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  804291784: function _(ID, a) {
    return new IFC4_3.IfcPipeFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4231323485: function _(ID, a) {
    return new IFC4_3.IfcPipeSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4017108033: function _(ID, a) {
    return new IFC4_3.IfcPlateType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2839578677: function _(ID, a) {
    return new IFC4_3.IfcPolygonalFaceSet(ID, a[0], a[1], a[2], a[3]);
  },
  3724593414: function _(ID, a) {
    return new IFC4_3.IfcPolyline(ID, a[0]);
  },
  3740093272: function _(ID, a) {
    return new IFC4_3.IfcPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1946335990: function _(ID, a) {
    return new IFC4_3.IfcPositioningElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2744685151: function _(ID, a) {
    return new IFC4_3.IfcProcedure(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2904328755: function _(ID, a) {
    return new IFC4_3.IfcProjectOrder(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3651124850: function _(ID, a) {
    return new IFC4_3.IfcProjectionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1842657554: function _(ID, a) {
    return new IFC4_3.IfcProtectiveDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2250791053: function _(ID, a) {
    return new IFC4_3.IfcPumpType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1763565496: function _(ID, a) {
    return new IFC4_3.IfcRailType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2893384427: function _(ID, a) {
    return new IFC4_3.IfcRailingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3992365140: function _(ID, a) {
    return new IFC4_3.IfcRailway(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1891881377: function _(ID, a) {
    return new IFC4_3.IfcRailwayPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2324767716: function _(ID, a) {
    return new IFC4_3.IfcRampFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1469900589: function _(ID, a) {
    return new IFC4_3.IfcRampType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  683857671: function _(ID, a) {
    return new IFC4_3.IfcRationalBSplineSurfaceWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  4021432810: function _(ID, a) {
    return new IFC4_3.IfcReferent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3027567501: function _(ID, a) {
    return new IFC4_3.IfcReinforcingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  964333572: function _(ID, a) {
    return new IFC4_3.IfcReinforcingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2320036040: function _(ID, a) {
    return new IFC4_3.IfcReinforcingMesh(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]);
  },
  2310774935: function _(ID, a) {
    return new IFC4_3.IfcReinforcingMeshType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]);
  },
  3818125796: function _(ID, a) {
    return new IFC4_3.IfcRelAdheresToElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  160246688: function _(ID, a) {
    return new IFC4_3.IfcRelAggregates(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  146592293: function _(ID, a) {
    return new IFC4_3.IfcRoad(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  550521510: function _(ID, a) {
    return new IFC4_3.IfcRoadPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2781568857: function _(ID, a) {
    return new IFC4_3.IfcRoofType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1768891740: function _(ID, a) {
    return new IFC4_3.IfcSanitaryTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2157484638: function _(ID, a) {
    return new IFC4_3.IfcSeamCurve(ID, a[0], a[1], a[2]);
  },
  3649235739: function _(ID, a) {
    return new IFC4_3.IfcSecondOrderPolynomialSpiral(ID, a[0], a[1], a[2], a[3]);
  },
  544395925: function _(ID, a) {
    return new IFC4_3.IfcSegmentedReferenceCurve(ID, a[0], a[1], a[2], a[3]);
  },
  1027922057: function _(ID, a) {
    return new IFC4_3.IfcSeventhOrderPolynomialSpiral(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4074543187: function _(ID, a) {
    return new IFC4_3.IfcShadingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  33720170: function _(ID, a) {
    return new IFC4_3.IfcSign(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3599934289: function _(ID, a) {
    return new IFC4_3.IfcSignType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1894708472: function _(ID, a) {
    return new IFC4_3.IfcSignalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  42703149: function _(ID, a) {
    return new IFC4_3.IfcSineSpiral(ID, a[0], a[1], a[2], a[3]);
  },
  4097777520: function _(ID, a) {
    return new IFC4_3.IfcSite(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  2533589738: function _(ID, a) {
    return new IFC4_3.IfcSlabType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1072016465: function _(ID, a) {
    return new IFC4_3.IfcSolarDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3856911033: function _(ID, a) {
    return new IFC4_3.IfcSpace(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1305183839: function _(ID, a) {
    return new IFC4_3.IfcSpaceHeaterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3812236995: function _(ID, a) {
    return new IFC4_3.IfcSpaceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  3112655638: function _(ID, a) {
    return new IFC4_3.IfcStackTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1039846685: function _(ID, a) {
    return new IFC4_3.IfcStairFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  338393293: function _(ID, a) {
    return new IFC4_3.IfcStairType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  682877961: function _(ID, a) {
    return new IFC4_3.IfcStructuralAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1179482911: function _(ID, a) {
    return new IFC4_3.IfcStructuralConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1004757350: function _(ID, a) {
    return new IFC4_3.IfcStructuralCurveAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  4243806635: function _(ID, a) {
    return new IFC4_3.IfcStructuralCurveConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  214636428: function _(ID, a) {
    return new IFC4_3.IfcStructuralCurveMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2445595289: function _(ID, a) {
    return new IFC4_3.IfcStructuralCurveMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2757150158: function _(ID, a) {
    return new IFC4_3.IfcStructuralCurveReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1807405624: function _(ID, a) {
    return new IFC4_3.IfcStructuralLinearAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1252848954: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2082059205: function _(ID, a) {
    return new IFC4_3.IfcStructuralPointAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  734778138: function _(ID, a) {
    return new IFC4_3.IfcStructuralPointConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1235345126: function _(ID, a) {
    return new IFC4_3.IfcStructuralPointReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2986769608: function _(ID, a) {
    return new IFC4_3.IfcStructuralResultGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3657597509: function _(ID, a) {
    return new IFC4_3.IfcStructuralSurfaceAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1975003073: function _(ID, a) {
    return new IFC4_3.IfcStructuralSurfaceConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  148013059: function _(ID, a) {
    return new IFC4_3.IfcSubContractResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  3101698114: function _(ID, a) {
    return new IFC4_3.IfcSurfaceFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2315554128: function _(ID, a) {
    return new IFC4_3.IfcSwitchingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2254336722: function _(ID, a) {
    return new IFC4_3.IfcSystem(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  413509423: function _(ID, a) {
    return new IFC4_3.IfcSystemFurnitureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  5716631: function _(ID, a) {
    return new IFC4_3.IfcTankType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3824725483: function _(ID, a) {
    return new IFC4_3.IfcTendon(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]);
  },
  2347447852: function _(ID, a) {
    return new IFC4_3.IfcTendonAnchor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3081323446: function _(ID, a) {
    return new IFC4_3.IfcTendonAnchorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3663046924: function _(ID, a) {
    return new IFC4_3.IfcTendonConduit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2281632017: function _(ID, a) {
    return new IFC4_3.IfcTendonConduitType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2415094496: function _(ID, a) {
    return new IFC4_3.IfcTendonType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  618700268: function _(ID, a) {
    return new IFC4_3.IfcTrackElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1692211062: function _(ID, a) {
    return new IFC4_3.IfcTransformerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2097647324: function _(ID, a) {
    return new IFC4_3.IfcTransportElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1953115116: function _(ID, a) {
    return new IFC4_3.IfcTransportationDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3593883385: function _(ID, a) {
    return new IFC4_3.IfcTrimmedCurve(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1600972822: function _(ID, a) {
    return new IFC4_3.IfcTubeBundleType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1911125066: function _(ID, a) {
    return new IFC4_3.IfcUnitaryEquipmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  728799441: function _(ID, a) {
    return new IFC4_3.IfcValveType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  840318589: function _(ID, a) {
    return new IFC4_3.IfcVehicle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1530820697: function _(ID, a) {
    return new IFC4_3.IfcVibrationDamper(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3956297820: function _(ID, a) {
    return new IFC4_3.IfcVibrationDamperType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2391383451: function _(ID, a) {
    return new IFC4_3.IfcVibrationIsolator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3313531582: function _(ID, a) {
    return new IFC4_3.IfcVibrationIsolatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2769231204: function _(ID, a) {
    return new IFC4_3.IfcVirtualElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  926996030: function _(ID, a) {
    return new IFC4_3.IfcVoidingFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1898987631: function _(ID, a) {
    return new IFC4_3.IfcWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1133259667: function _(ID, a) {
    return new IFC4_3.IfcWasteTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4009809668: function _(ID, a) {
    return new IFC4_3.IfcWindowType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  4088093105: function _(ID, a) {
    return new IFC4_3.IfcWorkCalendar(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1028945134: function _(ID, a) {
    return new IFC4_3.IfcWorkControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  4218914973: function _(ID, a) {
    return new IFC4_3.IfcWorkPlan(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  3342526732: function _(ID, a) {
    return new IFC4_3.IfcWorkSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  1033361043: function _(ID, a) {
    return new IFC4_3.IfcZone(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3821786052: function _(ID, a) {
    return new IFC4_3.IfcActionRequest(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1411407467: function _(ID, a) {
    return new IFC4_3.IfcAirTerminalBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3352864051: function _(ID, a) {
    return new IFC4_3.IfcAirTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1871374353: function _(ID, a) {
    return new IFC4_3.IfcAirToAirHeatRecoveryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4266260250: function _(ID, a) {
    return new IFC4_3.IfcAlignmentCant(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1545765605: function _(ID, a) {
    return new IFC4_3.IfcAlignmentHorizontal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  317615605: function _(ID, a) {
    return new IFC4_3.IfcAlignmentSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1662888072: function _(ID, a) {
    return new IFC4_3.IfcAlignmentVertical(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3460190687: function _(ID, a) {
    return new IFC4_3.IfcAsset(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  1532957894: function _(ID, a) {
    return new IFC4_3.IfcAudioVisualApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1967976161: function _(ID, a) {
    return new IFC4_3.IfcBSplineCurve(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2461110595: function _(ID, a) {
    return new IFC4_3.IfcBSplineCurveWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  819618141: function _(ID, a) {
    return new IFC4_3.IfcBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3649138523: function _(ID, a) {
    return new IFC4_3.IfcBearingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  231477066: function _(ID, a) {
    return new IFC4_3.IfcBoilerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1136057603: function _(ID, a) {
    return new IFC4_3.IfcBoundaryCurve(ID, a[0], a[1]);
  },
  644574406: function _(ID, a) {
    return new IFC4_3.IfcBridge(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  963979645: function _(ID, a) {
    return new IFC4_3.IfcBridgePart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4031249490: function _(ID, a) {
    return new IFC4_3.IfcBuilding(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  2979338954: function _(ID, a) {
    return new IFC4_3.IfcBuildingElementPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  39481116: function _(ID, a) {
    return new IFC4_3.IfcBuildingElementPartType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1909888760: function _(ID, a) {
    return new IFC4_3.IfcBuildingElementProxyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1177604601: function _(ID, a) {
    return new IFC4_3.IfcBuildingSystem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1876633798: function _(ID, a) {
    return new IFC4_3.IfcBuiltElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3862327254: function _(ID, a) {
    return new IFC4_3.IfcBuiltSystem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2188180465: function _(ID, a) {
    return new IFC4_3.IfcBurnerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  395041908: function _(ID, a) {
    return new IFC4_3.IfcCableCarrierFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3293546465: function _(ID, a) {
    return new IFC4_3.IfcCableCarrierSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2674252688: function _(ID, a) {
    return new IFC4_3.IfcCableFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1285652485: function _(ID, a) {
    return new IFC4_3.IfcCableSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3203706013: function _(ID, a) {
    return new IFC4_3.IfcCaissonFoundationType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2951183804: function _(ID, a) {
    return new IFC4_3.IfcChillerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3296154744: function _(ID, a) {
    return new IFC4_3.IfcChimney(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2611217952: function _(ID, a) {
    return new IFC4_3.IfcCircle(ID, a[0], a[1]);
  },
  1677625105: function _(ID, a) {
    return new IFC4_3.IfcCivilElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2301859152: function _(ID, a) {
    return new IFC4_3.IfcCoilType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  843113511: function _(ID, a) {
    return new IFC4_3.IfcColumn(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  400855858: function _(ID, a) {
    return new IFC4_3.IfcCommunicationsApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3850581409: function _(ID, a) {
    return new IFC4_3.IfcCompressorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2816379211: function _(ID, a) {
    return new IFC4_3.IfcCondenserType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3898045240: function _(ID, a) {
    return new IFC4_3.IfcConstructionEquipmentResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1060000209: function _(ID, a) {
    return new IFC4_3.IfcConstructionMaterialResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  488727124: function _(ID, a) {
    return new IFC4_3.IfcConstructionProductResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2940368186: function _(ID, a) {
    return new IFC4_3.IfcConveyorSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  335055490: function _(ID, a) {
    return new IFC4_3.IfcCooledBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2954562838: function _(ID, a) {
    return new IFC4_3.IfcCoolingTowerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1502416096: function _(ID, a) {
    return new IFC4_3.IfcCourse(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1973544240: function _(ID, a) {
    return new IFC4_3.IfcCovering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3495092785: function _(ID, a) {
    return new IFC4_3.IfcCurtainWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3961806047: function _(ID, a) {
    return new IFC4_3.IfcDamperType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3426335179: function _(ID, a) {
    return new IFC4_3.IfcDeepFoundation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1335981549: function _(ID, a) {
    return new IFC4_3.IfcDiscreteAccessory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2635815018: function _(ID, a) {
    return new IFC4_3.IfcDiscreteAccessoryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  479945903: function _(ID, a) {
    return new IFC4_3.IfcDistributionBoardType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1599208980: function _(ID, a) {
    return new IFC4_3.IfcDistributionChamberElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2063403501: function _(ID, a) {
    return new IFC4_3.IfcDistributionControlElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1945004755: function _(ID, a) {
    return new IFC4_3.IfcDistributionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3040386961: function _(ID, a) {
    return new IFC4_3.IfcDistributionFlowElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3041715199: function _(ID, a) {
    return new IFC4_3.IfcDistributionPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3205830791: function _(ID, a) {
    return new IFC4_3.IfcDistributionSystem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  395920057: function _(ID, a) {
    return new IFC4_3.IfcDoor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  869906466: function _(ID, a) {
    return new IFC4_3.IfcDuctFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3760055223: function _(ID, a) {
    return new IFC4_3.IfcDuctSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2030761528: function _(ID, a) {
    return new IFC4_3.IfcDuctSilencerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3071239417: function _(ID, a) {
    return new IFC4_3.IfcEarthworksCut(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1077100507: function _(ID, a) {
    return new IFC4_3.IfcEarthworksElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3376911765: function _(ID, a) {
    return new IFC4_3.IfcEarthworksFill(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  663422040: function _(ID, a) {
    return new IFC4_3.IfcElectricApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2417008758: function _(ID, a) {
    return new IFC4_3.IfcElectricDistributionBoardType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3277789161: function _(ID, a) {
    return new IFC4_3.IfcElectricFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2142170206: function _(ID, a) {
    return new IFC4_3.IfcElectricFlowTreatmentDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1534661035: function _(ID, a) {
    return new IFC4_3.IfcElectricGeneratorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1217240411: function _(ID, a) {
    return new IFC4_3.IfcElectricMotorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  712377611: function _(ID, a) {
    return new IFC4_3.IfcElectricTimeControlType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1658829314: function _(ID, a) {
    return new IFC4_3.IfcEnergyConversionDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2814081492: function _(ID, a) {
    return new IFC4_3.IfcEngine(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3747195512: function _(ID, a) {
    return new IFC4_3.IfcEvaporativeCooler(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  484807127: function _(ID, a) {
    return new IFC4_3.IfcEvaporator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1209101575: function _(ID, a) {
    return new IFC4_3.IfcExternalSpatialElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  346874300: function _(ID, a) {
    return new IFC4_3.IfcFanType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1810631287: function _(ID, a) {
    return new IFC4_3.IfcFilterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4222183408: function _(ID, a) {
    return new IFC4_3.IfcFireSuppressionTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2058353004: function _(ID, a) {
    return new IFC4_3.IfcFlowController(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4278956645: function _(ID, a) {
    return new IFC4_3.IfcFlowFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4037862832: function _(ID, a) {
    return new IFC4_3.IfcFlowInstrumentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2188021234: function _(ID, a) {
    return new IFC4_3.IfcFlowMeter(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3132237377: function _(ID, a) {
    return new IFC4_3.IfcFlowMovingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  987401354: function _(ID, a) {
    return new IFC4_3.IfcFlowSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  707683696: function _(ID, a) {
    return new IFC4_3.IfcFlowStorageDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2223149337: function _(ID, a) {
    return new IFC4_3.IfcFlowTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3508470533: function _(ID, a) {
    return new IFC4_3.IfcFlowTreatmentDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  900683007: function _(ID, a) {
    return new IFC4_3.IfcFooting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2713699986: function _(ID, a) {
    return new IFC4_3.IfcGeotechnicalAssembly(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3009204131: function _(ID, a) {
    return new IFC4_3.IfcGrid(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  3319311131: function _(ID, a) {
    return new IFC4_3.IfcHeatExchanger(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2068733104: function _(ID, a) {
    return new IFC4_3.IfcHumidifier(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4175244083: function _(ID, a) {
    return new IFC4_3.IfcInterceptor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2176052936: function _(ID, a) {
    return new IFC4_3.IfcJunctionBox(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2696325953: function _(ID, a) {
    return new IFC4_3.IfcKerb(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  76236018: function _(ID, a) {
    return new IFC4_3.IfcLamp(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  629592764: function _(ID, a) {
    return new IFC4_3.IfcLightFixture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1154579445: function _(ID, a) {
    return new IFC4_3.IfcLinearPositioningElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1638804497: function _(ID, a) {
    return new IFC4_3.IfcLiquidTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1437502449: function _(ID, a) {
    return new IFC4_3.IfcMedicalDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1073191201: function _(ID, a) {
    return new IFC4_3.IfcMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2078563270: function _(ID, a) {
    return new IFC4_3.IfcMobileTelecommunicationsAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  234836483: function _(ID, a) {
    return new IFC4_3.IfcMooringDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2474470126: function _(ID, a) {
    return new IFC4_3.IfcMotorConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2182337498: function _(ID, a) {
    return new IFC4_3.IfcNavigationElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  144952367: function _(ID, a) {
    return new IFC4_3.IfcOuterBoundaryCurve(ID, a[0], a[1]);
  },
  3694346114: function _(ID, a) {
    return new IFC4_3.IfcOutlet(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1383356374: function _(ID, a) {
    return new IFC4_3.IfcPavement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1687234759: function _(ID, a) {
    return new IFC4_3.IfcPile(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  310824031: function _(ID, a) {
    return new IFC4_3.IfcPipeFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3612865200: function _(ID, a) {
    return new IFC4_3.IfcPipeSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3171933400: function _(ID, a) {
    return new IFC4_3.IfcPlate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  738039164: function _(ID, a) {
    return new IFC4_3.IfcProtectiveDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  655969474: function _(ID, a) {
    return new IFC4_3.IfcProtectiveDeviceTrippingUnitType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  90941305: function _(ID, a) {
    return new IFC4_3.IfcPump(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3290496277: function _(ID, a) {
    return new IFC4_3.IfcRail(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2262370178: function _(ID, a) {
    return new IFC4_3.IfcRailing(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3024970846: function _(ID, a) {
    return new IFC4_3.IfcRamp(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3283111854: function _(ID, a) {
    return new IFC4_3.IfcRampFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1232101972: function _(ID, a) {
    return new IFC4_3.IfcRationalBSplineCurveWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3798194928: function _(ID, a) {
    return new IFC4_3.IfcReinforcedSoil(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  979691226: function _(ID, a) {
    return new IFC4_3.IfcReinforcingBar(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  2572171363: function _(ID, a) {
    return new IFC4_3.IfcReinforcingBarType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
  },
  2016517767: function _(ID, a) {
    return new IFC4_3.IfcRoof(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3053780830: function _(ID, a) {
    return new IFC4_3.IfcSanitaryTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1783015770: function _(ID, a) {
    return new IFC4_3.IfcSensorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1329646415: function _(ID, a) {
    return new IFC4_3.IfcShadingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  991950508: function _(ID, a) {
    return new IFC4_3.IfcSignal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1529196076: function _(ID, a) {
    return new IFC4_3.IfcSlab(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3420628829: function _(ID, a) {
    return new IFC4_3.IfcSolarDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1999602285: function _(ID, a) {
    return new IFC4_3.IfcSpaceHeater(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1404847402: function _(ID, a) {
    return new IFC4_3.IfcStackTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  331165859: function _(ID, a) {
    return new IFC4_3.IfcStair(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4252922144: function _(ID, a) {
    return new IFC4_3.IfcStairFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  2515109513: function _(ID, a) {
    return new IFC4_3.IfcStructuralAnalysisModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  385403989: function _(ID, a) {
    return new IFC4_3.IfcStructuralLoadCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1621171031: function _(ID, a) {
    return new IFC4_3.IfcStructuralPlanarAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1162798199: function _(ID, a) {
    return new IFC4_3.IfcSwitchingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  812556717: function _(ID, a) {
    return new IFC4_3.IfcTank(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3425753595: function _(ID, a) {
    return new IFC4_3.IfcTrackElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3825984169: function _(ID, a) {
    return new IFC4_3.IfcTransformer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1620046519: function _(ID, a) {
    return new IFC4_3.IfcTransportElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3026737570: function _(ID, a) {
    return new IFC4_3.IfcTubeBundle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3179687236: function _(ID, a) {
    return new IFC4_3.IfcUnitaryControlElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4292641817: function _(ID, a) {
    return new IFC4_3.IfcUnitaryEquipment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4207607924: function _(ID, a) {
    return new IFC4_3.IfcValve(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2391406946: function _(ID, a) {
    return new IFC4_3.IfcWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3512223829: function _(ID, a) {
    return new IFC4_3.IfcWallStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4237592921: function _(ID, a) {
    return new IFC4_3.IfcWasteTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3304561284: function _(ID, a) {
    return new IFC4_3.IfcWindow(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  2874132201: function _(ID, a) {
    return new IFC4_3.IfcActuatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1634111441: function _(ID, a) {
    return new IFC4_3.IfcAirTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  177149247: function _(ID, a) {
    return new IFC4_3.IfcAirTerminalBox(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2056796094: function _(ID, a) {
    return new IFC4_3.IfcAirToAirHeatRecovery(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3001207471: function _(ID, a) {
    return new IFC4_3.IfcAlarmType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  325726236: function _(ID, a) {
    return new IFC4_3.IfcAlignment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  277319702: function _(ID, a) {
    return new IFC4_3.IfcAudioVisualAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  753842376: function _(ID, a) {
    return new IFC4_3.IfcBeam(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4196446775: function _(ID, a) {
    return new IFC4_3.IfcBearing(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  32344328: function _(ID, a) {
    return new IFC4_3.IfcBoiler(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3314249567: function _(ID, a) {
    return new IFC4_3.IfcBorehole(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1095909175: function _(ID, a) {
    return new IFC4_3.IfcBuildingElementProxy(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2938176219: function _(ID, a) {
    return new IFC4_3.IfcBurner(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  635142910: function _(ID, a) {
    return new IFC4_3.IfcCableCarrierFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3758799889: function _(ID, a) {
    return new IFC4_3.IfcCableCarrierSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1051757585: function _(ID, a) {
    return new IFC4_3.IfcCableFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4217484030: function _(ID, a) {
    return new IFC4_3.IfcCableSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3999819293: function _(ID, a) {
    return new IFC4_3.IfcCaissonFoundation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3902619387: function _(ID, a) {
    return new IFC4_3.IfcChiller(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  639361253: function _(ID, a) {
    return new IFC4_3.IfcCoil(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3221913625: function _(ID, a) {
    return new IFC4_3.IfcCommunicationsAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3571504051: function _(ID, a) {
    return new IFC4_3.IfcCompressor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2272882330: function _(ID, a) {
    return new IFC4_3.IfcCondenser(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  578613899: function _(ID, a) {
    return new IFC4_3.IfcControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3460952963: function _(ID, a) {
    return new IFC4_3.IfcConveyorSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4136498852: function _(ID, a) {
    return new IFC4_3.IfcCooledBeam(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3640358203: function _(ID, a) {
    return new IFC4_3.IfcCoolingTower(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4074379575: function _(ID, a) {
    return new IFC4_3.IfcDamper(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3693000487: function _(ID, a) {
    return new IFC4_3.IfcDistributionBoard(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1052013943: function _(ID, a) {
    return new IFC4_3.IfcDistributionChamberElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  562808652: function _(ID, a) {
    return new IFC4_3.IfcDistributionCircuit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1062813311: function _(ID, a) {
    return new IFC4_3.IfcDistributionControlElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  342316401: function _(ID, a) {
    return new IFC4_3.IfcDuctFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3518393246: function _(ID, a) {
    return new IFC4_3.IfcDuctSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1360408905: function _(ID, a) {
    return new IFC4_3.IfcDuctSilencer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1904799276: function _(ID, a) {
    return new IFC4_3.IfcElectricAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  862014818: function _(ID, a) {
    return new IFC4_3.IfcElectricDistributionBoard(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3310460725: function _(ID, a) {
    return new IFC4_3.IfcElectricFlowStorageDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  24726584: function _(ID, a) {
    return new IFC4_3.IfcElectricFlowTreatmentDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  264262732: function _(ID, a) {
    return new IFC4_3.IfcElectricGenerator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  402227799: function _(ID, a) {
    return new IFC4_3.IfcElectricMotor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1003880860: function _(ID, a) {
    return new IFC4_3.IfcElectricTimeControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3415622556: function _(ID, a) {
    return new IFC4_3.IfcFan(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  819412036: function _(ID, a) {
    return new IFC4_3.IfcFilter(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1426591983: function _(ID, a) {
    return new IFC4_3.IfcFireSuppressionTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  182646315: function _(ID, a) {
    return new IFC4_3.IfcFlowInstrument(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2680139844: function _(ID, a) {
    return new IFC4_3.IfcGeomodel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1971632696: function _(ID, a) {
    return new IFC4_3.IfcGeoslice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2295281155: function _(ID, a) {
    return new IFC4_3.IfcProtectiveDeviceTrippingUnit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4086658281: function _(ID, a) {
    return new IFC4_3.IfcSensor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  630975310: function _(ID, a) {
    return new IFC4_3.IfcUnitaryControlElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4288193352: function _(ID, a) {
    return new IFC4_3.IfcActuator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3087945054: function _(ID, a) {
    return new IFC4_3.IfcAlarm(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  25142252: function _(ID, a) {
    return new IFC4_3.IfcController(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  }
};
ToRawLineData[2] = {
  3630933823: function _(i) {
    return [i.Role, i.UserDefinedRole, i.Description];
  },
  618182010: function _(i) {
    return [i.Purpose, i.Description, i.UserDefinedPurpose];
  },
  2879124712: function _(i) {
    return [i.StartTag, i.EndTag];
  },
  3633395639: function _(i) {
    return [i.StartTag, i.EndTag, i.StartDistAlong, i.HorizontalLength, i.StartHeight, i.StartGradient, i.EndGradient, i.RadiusOfCurvature, i.PredefinedType];
  },
  639542469: function _(i) {
    return [i.ApplicationDeveloper, i.Version, i.ApplicationFullName, i.ApplicationIdentifier];
  },
  411424972: function _(i) {
    return [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components];
  },
  130549933: function _(i) {
    return [i.Identifier, i.Name, i.Description, i.TimeOfApproval, i.Status, i.Level, i.Qualifier, i.RequestingApproval, i.GivingApproval];
  },
  4037036970: function _(i) {
    return [i.Name];
  },
  1560379544: function _(i) {
    return [i.Name, !i.TranslationalStiffnessByLengthX ? null : Labelise(i.TranslationalStiffnessByLengthX), !i.TranslationalStiffnessByLengthY ? null : Labelise(i.TranslationalStiffnessByLengthY), !i.TranslationalStiffnessByLengthZ ? null : Labelise(i.TranslationalStiffnessByLengthZ), !i.RotationalStiffnessByLengthX ? null : Labelise(i.RotationalStiffnessByLengthX), !i.RotationalStiffnessByLengthY ? null : Labelise(i.RotationalStiffnessByLengthY), !i.RotationalStiffnessByLengthZ ? null : Labelise(i.RotationalStiffnessByLengthZ)];
  },
  3367102660: function _(i) {
    return [i.Name, !i.TranslationalStiffnessByAreaX ? null : Labelise(i.TranslationalStiffnessByAreaX), !i.TranslationalStiffnessByAreaY ? null : Labelise(i.TranslationalStiffnessByAreaY), !i.TranslationalStiffnessByAreaZ ? null : Labelise(i.TranslationalStiffnessByAreaZ)];
  },
  1387855156: function _(i) {
    return [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ)];
  },
  2069777674: function _(i) {
    return [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ), !i.WarpingStiffness ? null : Labelise(i.WarpingStiffness)];
  },
  2859738748: function _(_84) {
    return [];
  },
  2614616156: function _(i) {
    return [i.PointOnRelatingElement, i.PointOnRelatedElement];
  },
  2732653382: function _(i) {
    return [i.SurfaceOnRelatingElement, i.SurfaceOnRelatedElement];
  },
  775493141: function _(i) {
    return [i.VolumeOnRelatingElement, i.VolumeOnRelatedElement];
  },
  1959218052: function _(i) {
    return [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade];
  },
  1785450214: function _(i) {
    return [i.SourceCRS, i.TargetCRS];
  },
  1466758467: function _(i) {
    return [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum];
  },
  602808272: function _(i) {
    return [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components];
  },
  1765591967: function _(i) {
    return [i.Elements, i.UnitType, i.UserDefinedType, i.Name];
  },
  1045800335: function _(i) {
    return [i.Unit, i.Exponent];
  },
  2949456006: function _(i) {
    return [i.LengthExponent, i.MassExponent, i.TimeExponent, i.ElectricCurrentExponent, i.ThermodynamicTemperatureExponent, i.AmountOfSubstanceExponent, i.LuminousIntensityExponent];
  },
  4294318154: function _(_85) {
    return [];
  },
  3200245327: function _(i) {
    return [i.Location, i.Identification, i.Name];
  },
  2242383968: function _(i) {
    return [i.Location, i.Identification, i.Name];
  },
  1040185647: function _(i) {
    return [i.Location, i.Identification, i.Name];
  },
  3548104201: function _(i) {
    return [i.Location, i.Identification, i.Name];
  },
  852622518: function _(i) {
    return [i.AxisTag, i.AxisCurve, i.SameSense];
  },
  3020489413: function _(i) {
    return [i.TimeStamp, i.ListValues.map(function (p) {
      return Labelise(p);
    })];
  },
  2655187982: function _(i) {
    return [i.Name, i.Version, i.Publisher, i.VersionDate, i.Location, i.Description];
  },
  3452421091: function _(i) {
    return [i.Location, i.Identification, i.Name, i.Description, i.Language, i.ReferencedLibrary];
  },
  4162380809: function _(i) {
    return [i.MainPlaneAngle, i.SecondaryPlaneAngle, i.LuminousIntensity];
  },
  1566485204: function _(i) {
    return [i.LightDistributionCurve, i.DistributionData];
  },
  3057273783: function _(i) {
    return [i.SourceCRS, i.TargetCRS, i.Eastings, i.Northings, i.OrthogonalHeight, i.XAxisAbscissa, i.XAxisOrdinate, i.Scale, i.ScaleY, i.ScaleZ];
  },
  1847130766: function _(i) {
    return [i.MaterialClassifications, i.ClassifiedMaterial];
  },
  760658860: function _(_86) {
    return [];
  },
  248100487: function _(i) {
    return [i.Material, i.LayerThickness, i.IsVentilated, i.Name, i.Description, i.Category, i.Priority];
  },
  3303938423: function _(i) {
    return [i.MaterialLayers, i.LayerSetName, i.Description];
  },
  1847252529: function _(i) {
    return [i.Material, i.LayerThickness, i.IsVentilated, i.Name, i.Description, i.Category, i.Priority, i.OffsetDirection, i.OffsetValues];
  },
  2199411900: function _(i) {
    return [i.Materials];
  },
  2235152071: function _(i) {
    return [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category];
  },
  164193824: function _(i) {
    return [i.Name, i.Description, i.MaterialProfiles, i.CompositeProfile];
  },
  552965576: function _(i) {
    return [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category, i.OffsetValues];
  },
  1507914824: function _(_87) {
    return [];
  },
  2597039031: function _(i) {
    return [Labelise(i.ValueComponent), i.UnitComponent];
  },
  3368373690: function _(i) {
    return [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.Benchmark, i.ValueSource, i.DataValue, i.ReferencePath];
  },
  2706619895: function _(i) {
    return [i.Currency];
  },
  1918398963: function _(i) {
    return [i.Dimensions, i.UnitType];
  },
  3701648758: function _(i) {
    return [i.PlacementRelTo];
  },
  2251480897: function _(i) {
    return [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.BenchmarkValues, i.LogicalAggregator, i.ObjectiveQualifier, i.UserDefinedQualifier];
  },
  4251960020: function _(i) {
    return [i.Identification, i.Name, i.Description, i.Roles, i.Addresses];
  },
  1207048766: function _(i) {
    return [i.OwningUser, i.OwningApplication, i.State, i.ChangeAction, i.LastModifiedDate, i.LastModifyingUser, i.LastModifyingApplication, i.CreationDate];
  },
  2077209135: function _(i) {
    return [i.Identification, i.FamilyName, i.GivenName, i.MiddleNames, i.PrefixTitles, i.SuffixTitles, i.Roles, i.Addresses];
  },
  101040310: function _(i) {
    return [i.ThePerson, i.TheOrganization, i.Roles];
  },
  2483315170: function _(i) {
    return [i.Name, i.Description];
  },
  2226359599: function _(i) {
    return [i.Name, i.Description, i.Unit];
  },
  3355820592: function _(i) {
    return [i.Purpose, i.Description, i.UserDefinedPurpose, i.InternalLocation, i.AddressLines, i.PostalBox, i.Town, i.Region, i.PostalCode, i.Country];
  },
  677532197: function _(_88) {
    return [];
  },
  2022622350: function _(i) {
    return [i.Name, i.Description, i.AssignedItems, i.Identifier];
  },
  1304840413: function _(i) {
    return [i.Name, i.Description, i.AssignedItems, i.Identifier, i.LayerOn, i.LayerFrozen, i.LayerBlocked, i.LayerStyles];
  },
  3119450353: function _(i) {
    return [i.Name];
  },
  2095639259: function _(i) {
    return [i.Name, i.Description, i.Representations];
  },
  3958567839: function _(i) {
    return [i.ProfileType, i.ProfileName];
  },
  3843373140: function _(i) {
    return [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum, i.MapProjection, i.MapZone, i.MapUnit];
  },
  986844984: function _(_89) {
    return [];
  },
  3710013099: function _(i) {
    return [i.Name, i.EnumerationValues.map(function (p) {
      return Labelise(p);
    }), i.Unit];
  },
  2044713172: function _(i) {
    return [i.Name, i.Description, i.Unit, i.AreaValue, i.Formula];
  },
  2093928680: function _(i) {
    return [i.Name, i.Description, i.Unit, i.CountValue, i.Formula];
  },
  931644368: function _(i) {
    return [i.Name, i.Description, i.Unit, i.LengthValue, i.Formula];
  },
  2691318326: function _(i) {
    return [i.Name, i.Description, i.Unit, i.NumberValue, i.Formula];
  },
  3252649465: function _(i) {
    return [i.Name, i.Description, i.Unit, i.TimeValue, i.Formula];
  },
  2405470396: function _(i) {
    return [i.Name, i.Description, i.Unit, i.VolumeValue, i.Formula];
  },
  825690147: function _(i) {
    return [i.Name, i.Description, i.Unit, i.WeightValue, i.Formula];
  },
  3915482550: function _(i) {
    return [i.RecurrenceType, i.DayComponent, i.WeekdayComponent, i.MonthComponent, i.Position, i.Interval, i.Occurrences, i.TimePeriods];
  },
  2433181523: function _(i) {
    return [i.TypeIdentifier, i.AttributeIdentifier, i.InstanceName, i.ListPositions, i.InnerReference];
  },
  1076942058: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  3377609919: function _(i) {
    return [i.ContextIdentifier, i.ContextType];
  },
  3008791417: function _(_90) {
    return [];
  },
  1660063152: function _(i) {
    return [i.MappingOrigin, i.MappedRepresentation];
  },
  2439245199: function _(i) {
    return [i.Name, i.Description];
  },
  2341007311: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  448429030: function _(i) {
    return [i.Dimensions, i.UnitType, i.Prefix, i.Name];
  },
  1054537805: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin];
  },
  867548509: function _(i) {
    return [i.ShapeRepresentations, i.Name, i.Description, i.ProductDefinitional, i.PartOfProductDefinitionShape];
  },
  3982875396: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  4240577450: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  2273995522: function _(i) {
    return [i.Name];
  },
  2162789131: function _(i) {
    return [i.Name];
  },
  3478079324: function _(i) {
    return [i.Name, i.Values, i.Locations];
  },
  609421318: function _(i) {
    return [i.Name];
  },
  2525727697: function _(i) {
    return [i.Name];
  },
  3408363356: function _(i) {
    return [i.Name, i.DeltaTConstant, i.DeltaTY, i.DeltaTZ];
  },
  2830218821: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  3958052878: function _(i) {
    return [i.Item, i.Styles, i.Name];
  },
  3049322572: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  2934153892: function _(i) {
    return [i.Name, i.SurfaceReinforcement1, i.SurfaceReinforcement2, i.ShearReinforcement];
  },
  1300840506: function _(i) {
    return [i.Name, i.Side, i.Styles];
  },
  3303107099: function _(i) {
    return [i.DiffuseTransmissionColour, i.DiffuseReflectionColour, i.TransmissionColour, i.ReflectanceColour];
  },
  1607154358: function _(i) {
    return [i.RefractionIndex, i.DispersionFactor];
  },
  846575682: function _(i) {
    return [i.SurfaceColour, i.Transparency];
  },
  1351298697: function _(i) {
    return [i.Textures];
  },
  626085974: function _(i) {
    return [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter];
  },
  985171141: function _(i) {
    return [i.Name, i.Rows, i.Columns];
  },
  2043862942: function _(i) {
    return [i.Identifier, i.Name, i.Description, i.Unit, i.ReferencePath];
  },
  531007025: function _(i) {
    return [!i.RowCells ? null : i.RowCells.map(function (p) {
      return Labelise(p);
    }), i.IsHeading];
  },
  1549132990: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion];
  },
  2771591690: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion, i.Recurrence];
  },
  912023232: function _(i) {
    return [i.Purpose, i.Description, i.UserDefinedPurpose, i.TelephoneNumbers, i.FacsimileNumbers, i.PagerNumber, i.ElectronicMailAddresses, i.WWWHomePageURL, i.MessagingIDs];
  },
  1447204868: function _(i) {
    return [i.Name, i.TextCharacterAppearance, i.TextStyle, i.TextFontStyle, i.ModelOrDraughting];
  },
  2636378356: function _(i) {
    return [i.Colour, i.BackgroundColour];
  },
  1640371178: function _(i) {
    return [!i.TextIndent ? null : Labelise(i.TextIndent), i.TextAlign, i.TextDecoration, !i.LetterSpacing ? null : Labelise(i.LetterSpacing), !i.WordSpacing ? null : Labelise(i.WordSpacing), i.TextTransform, !i.LineHeight ? null : Labelise(i.LineHeight)];
  },
  280115917: function _(i) {
    return [i.Maps];
  },
  1742049831: function _(i) {
    return [i.Maps, i.Mode, i.Parameter];
  },
  222769930: function _(i) {
    return [i.TexCoordIndex, i.TexCoordsOf];
  },
  1010789467: function _(i) {
    return [i.TexCoordIndex, i.TexCoordsOf, i.InnerTexCoordIndices];
  },
  2552916305: function _(i) {
    return [i.Maps, i.Vertices, i.MappedTo];
  },
  1210645708: function _(i) {
    return [i.Coordinates];
  },
  3611470254: function _(i) {
    return [i.TexCoordsList];
  },
  1199560280: function _(i) {
    return [i.StartTime, i.EndTime];
  },
  3101149627: function _(i) {
    return [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit];
  },
  581633288: function _(i) {
    return [i.ListValues.map(function (p) {
      return Labelise(p);
    })];
  },
  1377556343: function _(_91) {
    return [];
  },
  1735638870: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  180925521: function _(i) {
    return [i.Units];
  },
  2799835756: function _(_92) {
    return [];
  },
  1907098498: function _(i) {
    return [i.VertexGeometry];
  },
  891718957: function _(i) {
    return [i.IntersectingAxes, i.OffsetDistances];
  },
  1236880293: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.RecurrencePattern, i.StartDate, i.FinishDate];
  },
  3752311538: function _(i) {
    return [i.StartTag, i.EndTag, i.StartDistAlong, i.HorizontalLength, i.StartCantLeft, i.EndCantLeft, i.StartCantRight, i.EndCantRight, i.PredefinedType];
  },
  536804194: function _(i) {
    return [i.StartTag, i.EndTag, i.StartPoint, i.StartDirection, i.StartRadiusOfCurvature, i.EndRadiusOfCurvature, i.SegmentLength, i.GravityCenterLineHeight, i.PredefinedType];
  },
  3869604511: function _(i) {
    return [i.Name, i.Description, i.RelatingApproval, i.RelatedApprovals];
  },
  3798115385: function _(i) {
    return [i.ProfileType, i.ProfileName, i.OuterCurve];
  },
  1310608509: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Curve];
  },
  2705031697: function _(i) {
    return [i.ProfileType, i.ProfileName, i.OuterCurve, i.InnerCurves];
  },
  616511568: function _(i) {
    return [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.RasterFormat, i.RasterCode];
  },
  3150382593: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Curve, i.Thickness];
  },
  747523909: function _(i) {
    return [i.Source, i.Edition, i.EditionDate, i.Name, i.Description, i.Specification, i.ReferenceTokens];
  },
  647927063: function _(i) {
    return [i.Location, i.Identification, i.Name, i.ReferencedSource, i.Description, i.Sort];
  },
  3285139300: function _(i) {
    return [i.ColourList];
  },
  3264961684: function _(i) {
    return [i.Name];
  },
  1485152156: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Profiles, i.Label];
  },
  370225590: function _(i) {
    return [i.CfsFaces];
  },
  1981873012: function _(i) {
    return [i.CurveOnRelatingElement, i.CurveOnRelatedElement];
  },
  45288368: function _(i) {
    return [i.PointOnRelatingElement, i.PointOnRelatedElement, i.EccentricityInX, i.EccentricityInY, i.EccentricityInZ];
  },
  3050246964: function _(i) {
    return [i.Dimensions, i.UnitType, i.Name];
  },
  2889183280: function _(i) {
    return [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor];
  },
  2713554722: function _(i) {
    return [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor, i.ConversionOffset];
  },
  539742890: function _(i) {
    return [i.Name, i.Description, i.RelatingMonetaryUnit, i.RelatedMonetaryUnit, i.ExchangeRate, i.RateDateTime, i.RateSource];
  },
  3800577675: function _(i) {
    return [i.Name, i.CurveFont, !i.CurveWidth ? null : Labelise(i.CurveWidth), i.CurveColour, i.ModelOrDraughting];
  },
  1105321065: function _(i) {
    return [i.Name, i.PatternList];
  },
  2367409068: function _(i) {
    return [i.Name, i.CurveStyleFont, i.CurveFontScaling];
  },
  3510044353: function _(i) {
    return [i.VisibleSegmentLength, i.InvisibleSegmentLength];
  },
  3632507154: function _(i) {
    return [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label];
  },
  1154170062: function _(i) {
    return [i.Identification, i.Name, i.Description, i.Location, i.Purpose, i.IntendedUse, i.Scope, i.Revision, i.DocumentOwner, i.Editors, i.CreationTime, i.LastRevisionTime, i.ElectronicFormat, i.ValidFrom, i.ValidUntil, i.Confidentiality, i.Status];
  },
  770865208: function _(i) {
    return [i.Name, i.Description, i.RelatingDocument, i.RelatedDocuments, i.RelationshipType];
  },
  3732053477: function _(i) {
    return [i.Location, i.Identification, i.Name, i.Description, i.ReferencedDocument];
  },
  3900360178: function _(i) {
    return [i.EdgeStart, i.EdgeEnd];
  },
  476780140: function _(i) {
    return [i.EdgeStart, i.EdgeEnd, i.EdgeGeometry, i.SameSense];
  },
  211053100: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ActualDate, i.EarlyDate, i.LateDate, i.ScheduleDate];
  },
  297599258: function _(i) {
    return [i.Name, i.Description, i.Properties];
  },
  1437805879: function _(i) {
    return [i.Name, i.Description, i.RelatingReference, i.RelatedResourceObjects];
  },
  2556980723: function _(i) {
    return [i.Bounds];
  },
  1809719519: function _(i) {
    return [i.Bound, i.Orientation];
  },
  803316827: function _(i) {
    return [i.Bound, i.Orientation];
  },
  3008276851: function _(i) {
    return [i.Bounds, i.FaceSurface, i.SameSense];
  },
  4219587988: function _(i) {
    return [i.Name, i.TensionFailureX, i.TensionFailureY, i.TensionFailureZ, i.CompressionFailureX, i.CompressionFailureY, i.CompressionFailureZ];
  },
  738692330: function _(i) {
    return [i.Name, i.FillStyles, i.ModelOrDraughting];
  },
  3448662350: function _(i) {
    return [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth];
  },
  2453401579: function _(_93) {
    return [];
  },
  4142052618: function _(i) {
    return [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth, i.ParentContext, i.TargetScale, i.TargetView, i.UserDefinedTargetView];
  },
  3590301190: function _(i) {
    return [i.Elements];
  },
  178086475: function _(i) {
    return [i.PlacementRelTo, i.PlacementLocation, i.PlacementRefDirection];
  },
  812098782: function _(i) {
    return [i.BaseSurface, i.AgreementFlag];
  },
  3905492369: function _(i) {
    return [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.URLReference];
  },
  3570813810: function _(i) {
    return [i.MappedTo, i.Opacity, i.Colours, i.ColourIndex];
  },
  1437953363: function _(i) {
    return [i.Maps, i.MappedTo, i.TexCoords];
  },
  2133299955: function _(i) {
    return [i.Maps, i.MappedTo, i.TexCoords, i.TexCoordIndex];
  },
  3741457305: function _(i) {
    return [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.Values];
  },
  1585845231: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, Labelise(i.LagValue), i.DurationType];
  },
  1402838566: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity];
  },
  125510826: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity];
  },
  2604431987: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Orientation];
  },
  4266656042: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.ColourAppearance, i.ColourTemperature, i.LuminousFlux, i.LightEmissionSource, i.LightDistributionDataSource];
  },
  1520743889: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation];
  },
  3422422726: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation, i.Orientation, i.ConcentrationExponent, i.SpreadAngle, i.BeamWidthAngle];
  },
  388784114: function _(i) {
    return [i.PlacementRelTo, i.RelativePlacement, i.CartesianPosition];
  },
  2624227202: function _(i) {
    return [i.PlacementRelTo, i.RelativePlacement];
  },
  1008929658: function _(_94) {
    return [];
  },
  2347385850: function _(i) {
    return [i.MappingSource, i.MappingTarget];
  },
  1838606355: function _(i) {
    return [i.Name, i.Description, i.Category];
  },
  3708119e3: function _(i) {
    return [i.Name, i.Description, i.Material, i.Fraction, i.Category];
  },
  2852063980: function _(i) {
    return [i.Name, i.Description, i.MaterialConstituents];
  },
  2022407955: function _(i) {
    return [i.Name, i.Description, i.Representations, i.RepresentedMaterial];
  },
  1303795690: function _(i) {
    return [i.ForLayerSet, i.LayerSetDirection, i.DirectionSense, i.OffsetFromReferenceLine, i.ReferenceExtent];
  },
  3079605661: function _(i) {
    return [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent];
  },
  3404854881: function _(i) {
    return [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent, i.ForProfileEndSet, i.CardinalEndPoint];
  },
  3265635763: function _(i) {
    return [i.Name, i.Description, i.Properties, i.Material];
  },
  853536259: function _(i) {
    return [i.Name, i.Description, i.RelatingMaterial, i.RelatedMaterials, i.MaterialExpression];
  },
  2998442950: function _(i) {
    return [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label];
  },
  219451334: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  182550632: function _(i) {
    return [i.ProfileType, i.ProfileName, i.HorizontalWidths, i.Widths, i.Slopes, i.Tags, i.OffsetPoint];
  },
  2665983363: function _(i) {
    return [i.CfsFaces];
  },
  1411181986: function _(i) {
    return [i.Name, i.Description, i.RelatingOrganization, i.RelatedOrganizations];
  },
  1029017970: function _(i) {
    return [i.EdgeStart, i.EdgeEnd, i.EdgeElement, i.Orientation];
  },
  2529465313: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position];
  },
  2519244187: function _(i) {
    return [i.EdgeList];
  },
  3021840470: function _(i) {
    return [i.Name, i.Description, i.HasQuantities, i.Discrimination, i.Quality, i.Usage];
  },
  597895409: function _(i) {
    return [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.Width, i.Height, i.ColourComponents, i.Pixel];
  },
  2004835150: function _(i) {
    return [i.Location];
  },
  1663979128: function _(i) {
    return [i.SizeInX, i.SizeInY];
  },
  2067069095: function _(_95) {
    return [];
  },
  2165702409: function _(i) {
    return [Labelise(i.DistanceAlong), i.OffsetLateral, i.OffsetVertical, i.OffsetLongitudinal, i.BasisCurve];
  },
  4022376103: function _(i) {
    return [i.BasisCurve, i.PointParameter];
  },
  1423911732: function _(i) {
    return [i.BasisSurface, i.PointParameterU, i.PointParameterV];
  },
  2924175390: function _(i) {
    return [i.Polygon];
  },
  2775532180: function _(i) {
    return [i.BaseSurface, i.AgreementFlag, i.Position, i.PolygonalBoundary];
  },
  3727388367: function _(i) {
    return [i.Name];
  },
  3778827333: function _(_96) {
    return [];
  },
  1775413392: function _(i) {
    return [i.Name];
  },
  673634403: function _(i) {
    return [i.Name, i.Description, i.Representations];
  },
  2802850158: function _(i) {
    return [i.Name, i.Description, i.Properties, i.ProfileDefinition];
  },
  2598011224: function _(i) {
    return [i.Name, i.Specification];
  },
  1680319473: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  148025276: function _(i) {
    return [i.Name, i.Description, i.DependingProperty, i.DependantProperty, i.Expression];
  },
  3357820518: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  1482703590: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  2090586900: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  3615266464: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim];
  },
  3413951693: function _(i) {
    return [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.TimeStep, i.Values];
  },
  1580146022: function _(i) {
    return [i.TotalCrossSectionArea, i.SteelGrade, i.BarSurface, i.EffectiveDepth, i.NominalBarDiameter, i.BarCount];
  },
  478536968: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  2943643501: function _(i) {
    return [i.Name, i.Description, i.RelatedResourceObjects, i.RelatingApproval];
  },
  1608871552: function _(i) {
    return [i.Name, i.Description, i.RelatingConstraint, i.RelatedResourceObjects];
  },
  1042787934: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ScheduleWork, i.ScheduleUsage, i.ScheduleStart, i.ScheduleFinish, i.ScheduleContour, i.LevelingDelay, i.IsOverAllocated, i.StatusTime, i.ActualWork, i.ActualUsage, i.ActualStart, i.ActualFinish, i.RemainingWork, i.RemainingUsage, i.Completion];
  },
  2778083089: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.RoundingRadius];
  },
  2042790032: function _(i) {
    return [i.SectionType, i.StartProfile, i.EndProfile];
  },
  4165799628: function _(i) {
    return [i.LongitudinalStartPosition, i.LongitudinalEndPosition, i.TransversePosition, i.ReinforcementRole, i.SectionDefinition, i.CrossSectionReinforcementDefinitions];
  },
  1509187699: function _(i) {
    return [i.SpineCurve, i.CrossSections, i.CrossSectionPositions];
  },
  823603102: function _(i) {
    return [i.Transition];
  },
  4124623270: function _(i) {
    return [i.SbsmBoundary];
  },
  3692461612: function _(i) {
    return [i.Name, i.Specification];
  },
  2609359061: function _(i) {
    return [i.Name, i.SlippageX, i.SlippageY, i.SlippageZ];
  },
  723233188: function _(_97) {
    return [];
  },
  1595516126: function _(i) {
    return [i.Name, i.LinearForceX, i.LinearForceY, i.LinearForceZ, i.LinearMomentX, i.LinearMomentY, i.LinearMomentZ];
  },
  2668620305: function _(i) {
    return [i.Name, i.PlanarForceX, i.PlanarForceY, i.PlanarForceZ];
  },
  2473145415: function _(i) {
    return [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ];
  },
  1973038258: function _(i) {
    return [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ, i.Distortion];
  },
  1597423693: function _(i) {
    return [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ];
  },
  1190533807: function _(i) {
    return [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ, i.WarpingMoment];
  },
  2233826070: function _(i) {
    return [i.EdgeStart, i.EdgeEnd, i.ParentEdge];
  },
  2513912981: function _(_98) {
    return [];
  },
  1878645084: function _(i) {
    return [i.SurfaceColour, i.Transparency, i.DiffuseColour, i.TransmissionColour, i.DiffuseTransmissionColour, i.ReflectionColour, i.SpecularColour, !i.SpecularHighlight ? null : Labelise(i.SpecularHighlight), i.ReflectanceMethod];
  },
  2247615214: function _(i) {
    return [i.SweptArea, i.Position];
  },
  1260650574: function _(i) {
    return [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam];
  },
  1096409881: function _(i) {
    return [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam, i.FilletRadius];
  },
  230924584: function _(i) {
    return [i.SweptCurve, i.Position];
  },
  3071757647: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.WebEdgeRadius, i.WebSlope, i.FlangeSlope];
  },
  901063453: function _(_99) {
    return [];
  },
  4282788508: function _(i) {
    return [i.Literal, i.Placement, i.Path];
  },
  3124975700: function _(i) {
    return [i.Literal, i.Placement, i.Path, i.Extent, i.BoxAlignment];
  },
  1983826977: function _(i) {
    return [i.Name, i.FontFamily, i.FontStyle, i.FontVariant, i.FontWeight, Labelise(i.FontSize)];
  },
  2715220739: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.BottomXDim, i.TopXDim, i.YDim, i.TopXOffset];
  },
  1628702193: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets];
  },
  3736923433: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType];
  },
  2347495698: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag];
  },
  3698973494: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType];
  },
  427810014: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius, i.FlangeSlope];
  },
  1417489154: function _(i) {
    return [i.Orientation, i.Magnitude];
  },
  2759199220: function _(i) {
    return [i.LoopVertex];
  },
  2543172580: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius];
  },
  3406155212: function _(i) {
    return [i.Bounds, i.FaceSurface, i.SameSense];
  },
  669184980: function _(i) {
    return [i.OuterBoundary, i.InnerBoundaries];
  },
  3207858831: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.BottomFlangeWidth, i.OverallDepth, i.WebThickness, i.BottomFlangeThickness, i.BottomFlangeFilletRadius, i.TopFlangeWidth, i.TopFlangeThickness, i.TopFlangeFilletRadius, i.BottomFlangeEdgeRadius, i.BottomFlangeSlope, i.TopFlangeEdgeRadius, i.TopFlangeSlope];
  },
  4261334040: function _(i) {
    return [i.Location, i.Axis];
  },
  3125803723: function _(i) {
    return [i.Location, i.RefDirection];
  },
  2740243338: function _(i) {
    return [i.Location, i.Axis, i.RefDirection];
  },
  3425423356: function _(i) {
    return [i.Location, i.Axis, i.RefDirection];
  },
  2736907675: function _(i) {
    return [i.Operator, i.FirstOperand, i.SecondOperand];
  },
  4182860854: function _(_100) {
    return [];
  },
  2581212453: function _(i) {
    return [i.Corner, i.XDim, i.YDim, i.ZDim];
  },
  2713105998: function _(i) {
    return [i.BaseSurface, i.AgreementFlag, i.Enclosure];
  },
  2898889636: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.WallThickness, i.Girth, i.InternalFilletRadius];
  },
  1123145078: function _(i) {
    return [i.Coordinates];
  },
  574549367: function _(_101) {
    return [];
  },
  1675464909: function _(i) {
    return [i.CoordList, i.TagList];
  },
  2059837836: function _(i) {
    return [i.CoordList, i.TagList];
  },
  59481748: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale];
  },
  3749851601: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale];
  },
  3486308946: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Scale2];
  },
  3331915920: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3];
  },
  1416205885: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3, i.Scale2, i.Scale3];
  },
  1383045692: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Radius];
  },
  2205249479: function _(i) {
    return [i.CfsFaces];
  },
  776857604: function _(i) {
    return [i.Name, i.Red, i.Green, i.Blue];
  },
  2542286263: function _(i) {
    return [i.Name, i.Specification, i.UsageName, i.HasProperties];
  },
  2485617015: function _(i) {
    return [i.Transition, i.SameSense, i.ParentCurve];
  },
  2574617495: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity];
  },
  3419103109: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext];
  },
  1815067380: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  2506170314: function _(i) {
    return [i.Position];
  },
  2147822146: function _(i) {
    return [i.TreeRootExpression];
  },
  2601014836: function _(_102) {
    return [];
  },
  2827736869: function _(i) {
    return [i.BasisSurface, i.OuterBoundary, i.InnerBoundaries];
  },
  2629017746: function _(i) {
    return [i.BasisSurface, i.Boundaries, i.ImplicitOuter];
  },
  4212018352: function _(i) {
    return [i.Transition, i.Placement, Labelise(i.SegmentStart), Labelise(i.SegmentLength), i.ParentCurve];
  },
  32440307: function _(i) {
    return [i.DirectionRatios];
  },
  593015953: function _(i) {
    return [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam)];
  },
  1472233963: function _(i) {
    return [i.EdgeList];
  },
  1883228015: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.MethodOfMeasurement, i.Quantities];
  },
  339256511: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2777663545: function _(i) {
    return [i.Position];
  },
  2835456948: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.SemiAxis1, i.SemiAxis2];
  },
  4024345920: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType];
  },
  477187591: function _(i) {
    return [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth];
  },
  2804161546: function _(i) {
    return [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth, i.EndSweptArea];
  },
  2047409740: function _(i) {
    return [i.FbsmFaces];
  },
  374418227: function _(i) {
    return [i.HatchLineAppearance, i.StartOfNextHatchLine, i.PointOfReferenceHatchLine, i.PatternStart, i.HatchLineAngle];
  },
  315944413: function _(i) {
    return [i.TilingPattern, i.Tiles, i.TilingScale];
  },
  2652556860: function _(i) {
    return [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam), i.FixedReference];
  },
  4238390223: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1268542332: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.AssemblyPlace, i.PredefinedType];
  },
  4095422895: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  987898635: function _(i) {
    return [i.Elements];
  },
  1484403080: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.FlangeSlope];
  },
  178912537: function _(i) {
    return [i.CoordIndex];
  },
  2294589976: function _(i) {
    return [i.CoordIndex, i.InnerCoordIndices];
  },
  3465909080: function _(i) {
    return [i.Maps, i.MappedTo, i.TexCoords, i.TexCoordIndices];
  },
  572779678: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.Thickness, i.FilletRadius, i.EdgeRadius, i.LegSlope];
  },
  428585644: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  1281925730: function _(i) {
    return [i.Pnt, i.Dir];
  },
  1425443689: function _(i) {
    return [i.Outer];
  },
  3888040117: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  590820931: function _(i) {
    return [i.BasisCurve];
  },
  3388369263: function _(i) {
    return [i.BasisCurve, i.Distance, i.SelfIntersect];
  },
  3505215534: function _(i) {
    return [i.BasisCurve, i.Distance, i.SelfIntersect, i.RefDirection];
  },
  2485787929: function _(i) {
    return [i.BasisCurve, i.OffsetValues, i.Tag];
  },
  1682466193: function _(i) {
    return [i.BasisSurface, i.ReferenceCurve];
  },
  603570806: function _(i) {
    return [i.SizeInX, i.SizeInY, i.Placement];
  },
  220341763: function _(i) {
    return [i.Position];
  },
  3381221214: function _(i) {
    return [i.Position, i.CoefficientsX, i.CoefficientsY, i.CoefficientsZ];
  },
  759155922: function _(i) {
    return [i.Name];
  },
  2559016684: function _(i) {
    return [i.Name];
  },
  3967405729: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  569719735: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType];
  },
  2945172077: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription];
  },
  4208778838: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  103090709: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext];
  },
  653396225: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext];
  },
  871118103: function _(i) {
    return [i.Name, i.Specification, !i.UpperBoundValue ? null : Labelise(i.UpperBoundValue), !i.LowerBoundValue ? null : Labelise(i.LowerBoundValue), i.Unit, !i.SetPointValue ? null : Labelise(i.SetPointValue)];
  },
  4166981789: function _(i) {
    return [i.Name, i.Specification, !i.EnumerationValues ? null : i.EnumerationValues.map(function (p) {
      return Labelise(p);
    }), i.EnumerationReference];
  },
  2752243245: function _(i) {
    return [i.Name, i.Specification, !i.ListValues ? null : i.ListValues.map(function (p) {
      return Labelise(p);
    }), i.Unit];
  },
  941946838: function _(i) {
    return [i.Name, i.Specification, i.UsageName, i.PropertyReference];
  },
  1451395588: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.HasProperties];
  },
  492091185: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.ApplicableEntity, i.HasPropertyTemplates];
  },
  3650150729: function _(i) {
    return [i.Name, i.Specification, !i.NominalValue ? null : Labelise(i.NominalValue), i.Unit];
  },
  110355661: function _(i) {
    return [i.Name, i.Specification, !i.DefiningValues ? null : i.DefiningValues.map(function (p) {
      return Labelise(p);
    }), !i.DefinedValues ? null : i.DefinedValues.map(function (p) {
      return Labelise(p);
    }), i.Expression, i.DefiningUnit, i.DefinedUnit, i.CurveInterpolation];
  },
  3521284610: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  2770003689: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.WallThickness, i.InnerFilletRadius, i.OuterFilletRadius];
  },
  2798486643: function _(i) {
    return [i.Position, i.XLength, i.YLength, i.Height];
  },
  3454111270: function _(i) {
    return [i.BasisSurface, i.U1, i.V1, i.U2, i.V2, i.Usense, i.Vsense];
  },
  3765753017: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DefinitionType, i.ReinforcementSectionDefinitions];
  },
  3939117080: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType];
  },
  1683148259: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole];
  },
  2495723537: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl];
  },
  1307041759: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup];
  },
  1027710054: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup, i.Factor];
  },
  4278684876: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProcess, i.QuantityInProcess];
  },
  2857406711: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProduct];
  },
  205026976: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingResource];
  },
  1865459582: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects];
  },
  4095574036: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingApproval];
  },
  919958153: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingClassification];
  },
  2728634034: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.Intent, i.RelatingConstraint];
  },
  982818633: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingDocument];
  },
  3840914261: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingLibrary];
  },
  2655215786: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingMaterial];
  },
  1033248425: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingProfileDef];
  },
  826625072: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  1204542856: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement];
  },
  3945020480: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RelatingPriorities, i.RelatedPriorities, i.RelatedConnectionType, i.RelatingConnectionType];
  },
  4201705270: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedElement];
  },
  3190031847: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedPort, i.RealizingElement];
  },
  2127690289: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralActivity];
  },
  1638771189: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem];
  },
  504942748: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem, i.ConnectionConstraint];
  },
  3678494232: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RealizingElements, i.ConnectionType];
  },
  3242617779: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure];
  },
  886880790: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedCoverings];
  },
  2802773753: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedCoverings];
  },
  2565941209: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingContext, i.RelatedDefinitions];
  },
  2551354335: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  693640335: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  1462361463: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingObject];
  },
  4186316022: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition];
  },
  307848117: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedPropertySets, i.RelatingTemplate];
  },
  781010003: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingType];
  },
  3940055652: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingOpeningElement, i.RelatedBuildingElement];
  },
  279856033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedControlElements, i.RelatingFlowElement];
  },
  427948657: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedElement, i.InterferenceGeometry, i.InterferenceSpace, i.InterferenceType, i.ImpliedOrder];
  },
  3268803585: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects];
  },
  1441486842: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPositioningElement, i.RelatedProducts];
  },
  750771296: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedFeatureElement];
  },
  1245217292: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure];
  },
  4122056220: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingProcess, i.RelatedProcess, i.TimeLag, i.SequenceType, i.UserDefinedSequenceType];
  },
  366585022: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSystem, i.RelatedBuildings];
  },
  3451746338: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary];
  },
  3523091289: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary];
  },
  1521410863: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary, i.CorrespondingBoundary];
  },
  1401173127: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedOpeningElement];
  },
  816062949: function _(i) {
    return [i.Transition, i.SameSense, i.ParentCurve, i.ParamLength];
  },
  2914609552: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription];
  },
  1856042241: function _(i) {
    return [i.SweptArea, i.Position, i.Axis, i.Angle];
  },
  3243963512: function _(i) {
    return [i.SweptArea, i.Position, i.Axis, i.Angle, i.EndSweptArea];
  },
  4158566097: function _(i) {
    return [i.Position, i.Height, i.BottomRadius];
  },
  3626867408: function _(i) {
    return [i.Position, i.Height, i.Radius];
  },
  1862484736: function _(i) {
    return [i.Directrix, i.CrossSections];
  },
  1290935644: function _(i) {
    return [i.Directrix, i.CrossSections, i.CrossSectionPositions];
  },
  1356537516: function _(i) {
    return [i.Directrix, i.CrossSectionPositions, i.CrossSections];
  },
  3663146110: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.PrimaryMeasureType, i.SecondaryMeasureType, i.Enumerators, i.PrimaryUnit, i.SecondaryUnit, i.Expression, i.AccessState];
  },
  1412071761: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName];
  },
  710998568: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2706606064: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType];
  },
  3893378262: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  463610769: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType];
  },
  2481509218: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName];
  },
  451544542: function _(i) {
    return [i.Position, i.Radius];
  },
  4015995234: function _(i) {
    return [i.Position, i.Radius];
  },
  2735484536: function _(i) {
    return [i.Position];
  },
  3544373492: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal];
  },
  3136571912: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  530289379: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  3689010777: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal];
  },
  3979015343: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness];
  },
  2218152070: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness];
  },
  603775116: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType];
  },
  4095615324: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  699246055: function _(i) {
    return [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation];
  },
  2028607225: function _(i) {
    return [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam), i.ReferenceSurface];
  },
  2809605785: function _(i) {
    return [i.SweptCurve, i.Position, i.ExtrudedDirection, i.Depth];
  },
  4124788165: function _(i) {
    return [i.SweptCurve, i.Position, i.AxisPosition];
  },
  1580310250: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3473067441: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Status, i.WorkMethod, i.IsMilestone, i.Priority, i.TaskTime, i.PredefinedType];
  },
  3206491090: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.WorkMethod];
  },
  2387106220: function _(i) {
    return [i.Coordinates, i.Closed];
  },
  782932809: function _(i) {
    return [i.Position, i.CubicTerm, i.QuadraticTerm, i.LinearTerm, i.ConstantTerm];
  },
  1935646853: function _(i) {
    return [i.Position, i.MajorRadius, i.MinorRadius];
  },
  3665877780: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2916149573: function _(i) {
    return [i.Coordinates, i.Closed, i.Normals, i.CoordIndex, i.PnIndex];
  },
  1229763772: function _(i) {
    return [i.Coordinates, i.Closed, i.Normals, i.CoordIndex, i.PnIndex, i.Flags];
  },
  3651464721: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  336235671: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.TransomThickness, i.MullionThickness, i.FirstTransomOffset, i.SecondTransomOffset, i.FirstMullionOffset, i.SecondMullionOffset, i.ShapeAspectStyle, i.LiningOffset, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY];
  },
  512836454: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle];
  },
  2296667514: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor];
  },
  1635779807: function _(i) {
    return [i.Outer];
  },
  2603310189: function _(i) {
    return [i.Outer, i.Voids];
  },
  1674181508: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType];
  },
  2887950389: function _(i) {
    return [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect];
  },
  167062518: function _(i) {
    return [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec];
  },
  1334484129: function _(i) {
    return [i.Position, i.XLength, i.YLength, i.ZLength];
  },
  3649129432: function _(i) {
    return [i.Operator, i.FirstOperand, i.SecondOperand];
  },
  1260505505: function _(_103) {
    return [];
  },
  3124254112: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.Elevation];
  },
  1626504194: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2197970202: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2937912522: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Radius, i.WallThickness];
  },
  3893394355: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3497074424: function _(i) {
    return [i.Position, i.ClothoidConstant];
  },
  300633059: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3875453745: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.UsageName, i.TemplateType, i.HasPropertyTemplates];
  },
  3732776249: function _(i) {
    return [i.Segments, i.SelfIntersect];
  },
  15328376: function _(i) {
    return [i.Segments, i.SelfIntersect];
  },
  2510884976: function _(i) {
    return [i.Position];
  },
  2185764099: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  4105962743: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  1525564444: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  2559216714: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity];
  },
  3293443760: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification];
  },
  2000195564: function _(i) {
    return [i.Position, i.CosineTerm, i.ConstantTerm];
  },
  3895139033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.CostValues, i.CostQuantities];
  },
  1419761937: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.SubmittedOn, i.UpdateDate];
  },
  4189326743: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1916426348: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3295246426: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  1457835157: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1213902940: function _(i) {
    return [i.Position, i.Radius];
  },
  1306400036: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  4234616927: function _(i) {
    return [i.SweptArea, i.Position, i.Directrix, !i.StartParam ? null : Labelise(i.StartParam), !i.EndParam ? null : Labelise(i.EndParam), i.FixedReference];
  },
  3256556792: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3849074793: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2963535650: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.ThresholdDepth, i.ThresholdThickness, i.TransomThickness, i.TransomOffset, i.LiningOffset, i.ThresholdOffset, i.CasingThickness, i.CasingDepth, i.ShapeAspectStyle, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY];
  },
  1714330368: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PanelDepth, i.PanelOperation, i.PanelWidth, i.PanelPosition, i.ShapeAspectStyle];
  },
  2323601079: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.OperationType, i.ParameterTakesPrecedence, i.UserDefinedOperationType];
  },
  445594917: function _(i) {
    return [i.Name];
  },
  4006246654: function _(i) {
    return [i.Name];
  },
  1758889154: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  4123344466: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.AssemblyPlace, i.PredefinedType];
  },
  2397081782: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1623761950: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2590856083: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1704287377: function _(i) {
    return [i.Position, i.SemiAxis1, i.SemiAxis2];
  },
  2107101300: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  132023988: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3174744832: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3390157468: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4148101412: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType, i.EventOccurenceTime];
  },
  2853485674: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName];
  },
  807026263: function _(i) {
    return [i.Outer];
  },
  3737207727: function _(i) {
    return [i.Outer, i.Voids];
  },
  24185140: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType];
  },
  1310830890: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType];
  },
  4228831410: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType];
  },
  647756555: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2489546625: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2827207264: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2143335405: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1287392070: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3907093117: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3198132628: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3815607619: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1482959167: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1834744321: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1339347760: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2297155007: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3009222698: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1893162501: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  263784265: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1509553395: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3493046030: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4230923436: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1594536857: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2898700619: function _(i) {
    return [i.Segments, i.SelfIntersect, i.BaseCurve, i.EndPoint];
  },
  2706460486: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  1251058090: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1806887404: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2568555532: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3948183225: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2571569899: function _(i) {
    return [i.Points, !i.Segments ? null : i.Segments.map(function (p) {
      return Labelise(p);
    }), i.SelfIntersect];
  },
  3946677679: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3113134337: function _(i) {
    return [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation];
  },
  2391368822: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.Jurisdiction, i.ResponsiblePersons, i.LastUpdateDate, i.CurrentValue, i.OriginalValue];
  },
  4288270099: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  679976338: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.Mountable];
  },
  3827777499: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  1051575348: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1161773419: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2176059722: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  1770583370: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  525669439: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType];
  },
  976884017: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType];
  },
  377706215: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NominalDiameter, i.NominalLength, i.PredefinedType];
  },
  2108223431: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.NominalLength];
  },
  1114901282: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3181161470: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1950438474: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  710110818: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  977012517: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  506776471: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4143007308: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor, i.PredefinedType];
  },
  3588315303: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2837617999: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  514975943: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2382730787: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LifeCyclePhase, i.PredefinedType];
  },
  3566463478: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle];
  },
  3327091369: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription];
  },
  1158309216: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  804291784: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4231323485: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4017108033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2839578677: function _(i) {
    return [i.Coordinates, i.Closed, i.Faces, i.PnIndex];
  },
  3724593414: function _(i) {
    return [i.Points];
  },
  3740093272: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  1946335990: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  2744685151: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType];
  },
  2904328755: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription];
  },
  3651124850: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1842657554: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2250791053: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1763565496: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2893384427: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3992365140: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType];
  },
  1891881377: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType];
  },
  2324767716: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1469900589: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  683857671: function _(i) {
    return [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec, i.WeightsData];
  },
  4021432810: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType];
  },
  3027567501: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade];
  },
  964333572: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2320036040: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.PredefinedType];
  },
  2310774935: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map(function (p) {
      return Labelise(p);
    })];
  },
  3818125796: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedSurfaceFeatures];
  },
  160246688: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects];
  },
  146592293: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType];
  },
  550521510: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType];
  },
  2781568857: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1768891740: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2157484638: function _(i) {
    return [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation];
  },
  3649235739: function _(i) {
    return [i.Position, i.QuadraticTerm, i.LinearTerm, i.ConstantTerm];
  },
  544395925: function _(i) {
    return [i.Segments, i.SelfIntersect, i.BaseCurve, i.EndPoint];
  },
  1027922057: function _(i) {
    return [i.Position, i.SepticTerm, i.SexticTerm, i.QuinticTerm, i.QuarticTerm, i.CubicTerm, i.QuadraticTerm, i.LinearTerm, i.ConstantTerm];
  },
  4074543187: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  33720170: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3599934289: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1894708472: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  42703149: function _(i) {
    return [i.Position, i.SineTerm, i.LinearTerm, i.ConstantTerm];
  },
  4097777520: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.RefLatitude, i.RefLongitude, i.RefElevation, i.LandTitleNumber, i.SiteAddress];
  },
  2533589738: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1072016465: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3856911033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType, i.ElevationWithFlooring];
  },
  1305183839: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3812236995: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName];
  },
  3112655638: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1039846685: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  338393293: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  682877961: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad];
  },
  1179482911: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition];
  },
  1004757350: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType];
  },
  4243806635: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.AxisDirection];
  },
  214636428: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis];
  },
  2445595289: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis];
  },
  2757150158: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType];
  },
  1807405624: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType];
  },
  1252848954: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose];
  },
  2082059205: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad];
  },
  734778138: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.ConditionCoordinateSystem];
  },
  1235345126: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal];
  },
  2986769608: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheoryType, i.ResultForLoadGroup, i.IsLinear];
  },
  3657597509: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType];
  },
  1975003073: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition];
  },
  148013059: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  3101698114: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2315554128: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2254336722: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  413509423: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  5716631: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3824725483: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.TensionForce, i.PreStress, i.FrictionCoefficient, i.AnchorageSlip, i.MinCurvatureRadius];
  },
  2347447852: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType];
  },
  3081323446: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3663046924: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType];
  },
  2281632017: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2415094496: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.SheathDiameter];
  },
  618700268: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1692211062: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2097647324: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1953115116: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3593883385: function _(i) {
    return [i.BasisCurve, i.Trim1, i.Trim2, i.SenseAgreement, i.MasterRepresentation];
  },
  1600972822: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1911125066: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  728799441: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  840318589: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1530820697: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3956297820: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2391383451: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3313531582: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2769231204: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  926996030: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1898987631: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1133259667: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4009809668: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.PartitioningType, i.ParameterTakesPrecedence, i.UserDefinedPartitioningType];
  },
  4088093105: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.WorkingTimes, i.ExceptionTimes, i.PredefinedType];
  },
  1028945134: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime];
  },
  4218914973: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType];
  },
  3342526732: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType];
  },
  1033361043: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName];
  },
  3821786052: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription];
  },
  1411407467: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3352864051: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1871374353: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4266260250: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.RailHeadDistance];
  },
  1545765605: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  317615605: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.DesignParameters];
  },
  1662888072: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  3460190687: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.OriginalValue, i.CurrentValue, i.TotalReplacementCost, i.Owner, i.User, i.ResponsiblePerson, i.IncorporationDate, i.DepreciatedValue];
  },
  1532957894: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1967976161: function _(i) {
    return [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect];
  },
  2461110595: function _(i) {
    return [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect, i.KnotMultiplicities, i.Knots, i.KnotSpec];
  },
  819618141: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3649138523: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  231477066: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1136057603: function _(i) {
    return [i.Segments, i.SelfIntersect];
  },
  644574406: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType];
  },
  963979645: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.UsageType, i.PredefinedType];
  },
  4031249490: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.ElevationOfRefHeight, i.ElevationOfTerrain, i.BuildingAddress];
  },
  2979338954: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  39481116: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1909888760: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1177604601: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.LongName];
  },
  1876633798: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3862327254: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.LongName];
  },
  2188180465: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  395041908: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3293546465: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2674252688: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1285652485: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3203706013: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2951183804: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3296154744: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2611217952: function _(i) {
    return [i.Position, i.Radius];
  },
  1677625105: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2301859152: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  843113511: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  400855858: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3850581409: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2816379211: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3898045240: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  1060000209: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  488727124: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  2940368186: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  335055490: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2954562838: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1502416096: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1973544240: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3495092785: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3961806047: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3426335179: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1335981549: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2635815018: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  479945903: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1599208980: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2063403501: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1945004755: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3040386961: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3041715199: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.FlowDirection, i.PredefinedType, i.SystemType];
  },
  3205830791: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType];
  },
  395920057: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.OperationType, i.UserDefinedOperationType];
  },
  869906466: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3760055223: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2030761528: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3071239417: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1077100507: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3376911765: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  663422040: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2417008758: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3277789161: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2142170206: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1534661035: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1217240411: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  712377611: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1658829314: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2814081492: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3747195512: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  484807127: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1209101575: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType];
  },
  346874300: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1810631287: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4222183408: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2058353004: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  4278956645: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  4037862832: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2188021234: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3132237377: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  987401354: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  707683696: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2223149337: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3508470533: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  900683007: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2713699986: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3009204131: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.UAxes, i.VAxes, i.WAxes, i.PredefinedType];
  },
  3319311131: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2068733104: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4175244083: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2176052936: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2696325953: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.Mountable];
  },
  76236018: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  629592764: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1154579445: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  1638804497: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1437502449: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1073191201: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2078563270: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  234836483: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2474470126: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2182337498: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  144952367: function _(i) {
    return [i.Segments, i.SelfIntersect];
  },
  3694346114: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1383356374: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1687234759: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType, i.ConstructionType];
  },
  310824031: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3612865200: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3171933400: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  738039164: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  655969474: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  90941305: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3290496277: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2262370178: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3024970846: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3283111854: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1232101972: function _(i) {
    return [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect, i.KnotMultiplicities, i.Knots, i.KnotSpec, i.WeightsData];
  },
  3798194928: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  979691226: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.PredefinedType, i.BarSurface];
  },
  2572171363: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.BarSurface, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map(function (p) {
      return Labelise(p);
    })];
  },
  2016517767: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3053780830: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1783015770: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1329646415: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  991950508: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1529196076: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3420628829: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1999602285: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1404847402: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  331165859: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4252922144: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NumberOfRisers, i.NumberOfTreads, i.RiserHeight, i.TreadLength, i.PredefinedType];
  },
  2515109513: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.OrientationOf2DPlane, i.LoadedBy, i.HasResults, i.SharedPlacement];
  },
  385403989: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose, i.SelfWeightCoefficients];
  },
  1621171031: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType];
  },
  1162798199: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  812556717: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3425753595: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3825984169: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1620046519: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3026737570: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3179687236: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4292641817: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4207607924: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2391406946: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3512223829: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4237592921: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3304561284: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.PartitioningType, i.UserDefinedPartitioningType];
  },
  2874132201: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1634111441: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  177149247: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2056796094: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3001207471: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  325726236: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType];
  },
  277319702: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  753842376: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4196446775: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  32344328: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3314249567: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1095909175: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2938176219: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  635142910: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3758799889: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1051757585: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4217484030: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3999819293: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3902619387: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  639361253: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3221913625: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3571504051: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2272882330: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  578613899: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3460952963: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4136498852: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3640358203: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4074379575: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3693000487: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1052013943: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  562808652: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType];
  },
  1062813311: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  342316401: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3518393246: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1360408905: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1904799276: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  862014818: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3310460725: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  24726584: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  264262732: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  402227799: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1003880860: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3415622556: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  819412036: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1426591983: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  182646315: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2680139844: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1971632696: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2295281155: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4086658281: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  630975310: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4288193352: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3087945054: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  25142252: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  }
};
TypeInitialisers[2] = {
  3699917729: function _(v) {
    return new IFC4_3.IfcAbsorbedDoseMeasure(v);
  },
  4182062534: function _(v) {
    return new IFC4_3.IfcAccelerationMeasure(v);
  },
  360377573: function _(v) {
    return new IFC4_3.IfcAmountOfSubstanceMeasure(v);
  },
  632304761: function _(v) {
    return new IFC4_3.IfcAngularVelocityMeasure(v);
  },
  3683503648: function _(v) {
    return new IFC4_3.IfcArcIndex(v);
  },
  1500781891: function _(v) {
    return new IFC4_3.IfcAreaDensityMeasure(v);
  },
  2650437152: function _(v) {
    return new IFC4_3.IfcAreaMeasure(v);
  },
  2314439260: function _(v) {
    return new IFC4_3.IfcBinary(v);
  },
  2735952531: function _(v) {
    return new IFC4_3.IfcBoolean(v);
  },
  1867003952: function _(v) {
    return new IFC4_3.IfcBoxAlignment(v);
  },
  1683019596: function _(v) {
    return new IFC4_3.IfcCardinalPointReference(v);
  },
  2991860651: function _(v) {
    return new IFC4_3.IfcComplexNumber(v);
  },
  3812528620: function _(v) {
    return new IFC4_3.IfcCompoundPlaneAngleMeasure(v);
  },
  3238673880: function _(v) {
    return new IFC4_3.IfcContextDependentMeasure(v);
  },
  1778710042: function _(v) {
    return new IFC4_3.IfcCountMeasure(v);
  },
  94842927: function _(v) {
    return new IFC4_3.IfcCurvatureMeasure(v);
  },
  937566702: function _(v) {
    return new IFC4_3.IfcDate(v);
  },
  2195413836: function _(v) {
    return new IFC4_3.IfcDateTime(v);
  },
  86635668: function _(v) {
    return new IFC4_3.IfcDayInMonthNumber(v);
  },
  3701338814: function _(v) {
    return new IFC4_3.IfcDayInWeekNumber(v);
  },
  1514641115: function _(v) {
    return new IFC4_3.IfcDescriptiveMeasure(v);
  },
  4134073009: function _(v) {
    return new IFC4_3.IfcDimensionCount(v);
  },
  524656162: function _(v) {
    return new IFC4_3.IfcDoseEquivalentMeasure(v);
  },
  2541165894: function _(v) {
    return new IFC4_3.IfcDuration(v);
  },
  69416015: function _(v) {
    return new IFC4_3.IfcDynamicViscosityMeasure(v);
  },
  1827137117: function _(v) {
    return new IFC4_3.IfcElectricCapacitanceMeasure(v);
  },
  3818826038: function _(v) {
    return new IFC4_3.IfcElectricChargeMeasure(v);
  },
  2093906313: function _(v) {
    return new IFC4_3.IfcElectricConductanceMeasure(v);
  },
  3790457270: function _(v) {
    return new IFC4_3.IfcElectricCurrentMeasure(v);
  },
  2951915441: function _(v) {
    return new IFC4_3.IfcElectricResistanceMeasure(v);
  },
  2506197118: function _(v) {
    return new IFC4_3.IfcElectricVoltageMeasure(v);
  },
  2078135608: function _(v) {
    return new IFC4_3.IfcEnergyMeasure(v);
  },
  1102727119: function _(v) {
    return new IFC4_3.IfcFontStyle(v);
  },
  2715512545: function _(v) {
    return new IFC4_3.IfcFontVariant(v);
  },
  2590844177: function _(v) {
    return new IFC4_3.IfcFontWeight(v);
  },
  1361398929: function _(v) {
    return new IFC4_3.IfcForceMeasure(v);
  },
  3044325142: function _(v) {
    return new IFC4_3.IfcFrequencyMeasure(v);
  },
  3064340077: function _(v) {
    return new IFC4_3.IfcGloballyUniqueId(v);
  },
  3113092358: function _(v) {
    return new IFC4_3.IfcHeatFluxDensityMeasure(v);
  },
  1158859006: function _(v) {
    return new IFC4_3.IfcHeatingValueMeasure(v);
  },
  983778844: function _(v) {
    return new IFC4_3.IfcIdentifier(v);
  },
  3358199106: function _(v) {
    return new IFC4_3.IfcIlluminanceMeasure(v);
  },
  2679005408: function _(v) {
    return new IFC4_3.IfcInductanceMeasure(v);
  },
  1939436016: function _(v) {
    return new IFC4_3.IfcInteger(v);
  },
  3809634241: function _(v) {
    return new IFC4_3.IfcIntegerCountRateMeasure(v);
  },
  3686016028: function _(v) {
    return new IFC4_3.IfcIonConcentrationMeasure(v);
  },
  3192672207: function _(v) {
    return new IFC4_3.IfcIsothermalMoistureCapacityMeasure(v);
  },
  2054016361: function _(v) {
    return new IFC4_3.IfcKinematicViscosityMeasure(v);
  },
  3258342251: function _(v) {
    return new IFC4_3.IfcLabel(v);
  },
  1275358634: function _(v) {
    return new IFC4_3.IfcLanguageId(v);
  },
  1243674935: function _(v) {
    return new IFC4_3.IfcLengthMeasure(v);
  },
  1774176899: function _(v) {
    return new IFC4_3.IfcLineIndex(v);
  },
  191860431: function _(v) {
    return new IFC4_3.IfcLinearForceMeasure(v);
  },
  2128979029: function _(v) {
    return new IFC4_3.IfcLinearMomentMeasure(v);
  },
  1307019551: function _(v) {
    return new IFC4_3.IfcLinearStiffnessMeasure(v);
  },
  3086160713: function _(v) {
    return new IFC4_3.IfcLinearVelocityMeasure(v);
  },
  503418787: function _(v) {
    return new IFC4_3.IfcLogical(v);
  },
  2095003142: function _(v) {
    return new IFC4_3.IfcLuminousFluxMeasure(v);
  },
  2755797622: function _(v) {
    return new IFC4_3.IfcLuminousIntensityDistributionMeasure(v);
  },
  151039812: function _(v) {
    return new IFC4_3.IfcLuminousIntensityMeasure(v);
  },
  286949696: function _(v) {
    return new IFC4_3.IfcMagneticFluxDensityMeasure(v);
  },
  2486716878: function _(v) {
    return new IFC4_3.IfcMagneticFluxMeasure(v);
  },
  1477762836: function _(v) {
    return new IFC4_3.IfcMassDensityMeasure(v);
  },
  4017473158: function _(v) {
    return new IFC4_3.IfcMassFlowRateMeasure(v);
  },
  3124614049: function _(v) {
    return new IFC4_3.IfcMassMeasure(v);
  },
  3531705166: function _(v) {
    return new IFC4_3.IfcMassPerLengthMeasure(v);
  },
  3341486342: function _(v) {
    return new IFC4_3.IfcModulusOfElasticityMeasure(v);
  },
  2173214787: function _(v) {
    return new IFC4_3.IfcModulusOfLinearSubgradeReactionMeasure(v);
  },
  1052454078: function _(v) {
    return new IFC4_3.IfcModulusOfRotationalSubgradeReactionMeasure(v);
  },
  1753493141: function _(v) {
    return new IFC4_3.IfcModulusOfSubgradeReactionMeasure(v);
  },
  3177669450: function _(v) {
    return new IFC4_3.IfcMoistureDiffusivityMeasure(v);
  },
  1648970520: function _(v) {
    return new IFC4_3.IfcMolecularWeightMeasure(v);
  },
  3114022597: function _(v) {
    return new IFC4_3.IfcMomentOfInertiaMeasure(v);
  },
  2615040989: function _(v) {
    return new IFC4_3.IfcMonetaryMeasure(v);
  },
  765770214: function _(v) {
    return new IFC4_3.IfcMonthInYearNumber(v);
  },
  525895558: function _(v) {
    return new IFC4_3.IfcNonNegativeLengthMeasure(v);
  },
  2095195183: function _(v) {
    return new IFC4_3.IfcNormalisedRatioMeasure(v);
  },
  2395907400: function _(v) {
    return new IFC4_3.IfcNumericMeasure(v);
  },
  929793134: function _(v) {
    return new IFC4_3.IfcPHMeasure(v);
  },
  2260317790: function _(v) {
    return new IFC4_3.IfcParameterValue(v);
  },
  2642773653: function _(v) {
    return new IFC4_3.IfcPlanarForceMeasure(v);
  },
  4042175685: function _(v) {
    return new IFC4_3.IfcPlaneAngleMeasure(v);
  },
  1790229001: function _(v) {
    return new IFC4_3.IfcPositiveInteger(v);
  },
  2815919920: function _(v) {
    return new IFC4_3.IfcPositiveLengthMeasure(v);
  },
  3054510233: function _(v) {
    return new IFC4_3.IfcPositivePlaneAngleMeasure(v);
  },
  1245737093: function _(v) {
    return new IFC4_3.IfcPositiveRatioMeasure(v);
  },
  1364037233: function _(v) {
    return new IFC4_3.IfcPowerMeasure(v);
  },
  2169031380: function _(v) {
    return new IFC4_3.IfcPresentableText(v);
  },
  3665567075: function _(v) {
    return new IFC4_3.IfcPressureMeasure(v);
  },
  2798247006: function _(v) {
    return new IFC4_3.IfcPropertySetDefinitionSet(v);
  },
  3972513137: function _(v) {
    return new IFC4_3.IfcRadioActivityMeasure(v);
  },
  96294661: function _(v) {
    return new IFC4_3.IfcRatioMeasure(v);
  },
  200335297: function _(v) {
    return new IFC4_3.IfcReal(v);
  },
  2133746277: function _(v) {
    return new IFC4_3.IfcRotationalFrequencyMeasure(v);
  },
  1755127002: function _(v) {
    return new IFC4_3.IfcRotationalMassMeasure(v);
  },
  3211557302: function _(v) {
    return new IFC4_3.IfcRotationalStiffnessMeasure(v);
  },
  3467162246: function _(v) {
    return new IFC4_3.IfcSectionModulusMeasure(v);
  },
  2190458107: function _(v) {
    return new IFC4_3.IfcSectionalAreaIntegralMeasure(v);
  },
  408310005: function _(v) {
    return new IFC4_3.IfcShearModulusMeasure(v);
  },
  3471399674: function _(v) {
    return new IFC4_3.IfcSolidAngleMeasure(v);
  },
  4157543285: function _(v) {
    return new IFC4_3.IfcSoundPowerLevelMeasure(v);
  },
  846465480: function _(v) {
    return new IFC4_3.IfcSoundPowerMeasure(v);
  },
  3457685358: function _(v) {
    return new IFC4_3.IfcSoundPressureLevelMeasure(v);
  },
  993287707: function _(v) {
    return new IFC4_3.IfcSoundPressureMeasure(v);
  },
  3477203348: function _(v) {
    return new IFC4_3.IfcSpecificHeatCapacityMeasure(v);
  },
  2757832317: function _(v) {
    return new IFC4_3.IfcSpecularExponent(v);
  },
  361837227: function _(v) {
    return new IFC4_3.IfcSpecularRoughness(v);
  },
  58845555: function _(v) {
    return new IFC4_3.IfcTemperatureGradientMeasure(v);
  },
  1209108979: function _(v) {
    return new IFC4_3.IfcTemperatureRateOfChangeMeasure(v);
  },
  2801250643: function _(v) {
    return new IFC4_3.IfcText(v);
  },
  1460886941: function _(v) {
    return new IFC4_3.IfcTextAlignment(v);
  },
  3490877962: function _(v) {
    return new IFC4_3.IfcTextDecoration(v);
  },
  603696268: function _(v) {
    return new IFC4_3.IfcTextFontName(v);
  },
  296282323: function _(v) {
    return new IFC4_3.IfcTextTransformation(v);
  },
  232962298: function _(v) {
    return new IFC4_3.IfcThermalAdmittanceMeasure(v);
  },
  2645777649: function _(v) {
    return new IFC4_3.IfcThermalConductivityMeasure(v);
  },
  2281867870: function _(v) {
    return new IFC4_3.IfcThermalExpansionCoefficientMeasure(v);
  },
  857959152: function _(v) {
    return new IFC4_3.IfcThermalResistanceMeasure(v);
  },
  2016195849: function _(v) {
    return new IFC4_3.IfcThermalTransmittanceMeasure(v);
  },
  743184107: function _(v) {
    return new IFC4_3.IfcThermodynamicTemperatureMeasure(v);
  },
  4075327185: function _(v) {
    return new IFC4_3.IfcTime(v);
  },
  2726807636: function _(v) {
    return new IFC4_3.IfcTimeMeasure(v);
  },
  2591213694: function _(v) {
    return new IFC4_3.IfcTimeStamp(v);
  },
  1278329552: function _(v) {
    return new IFC4_3.IfcTorqueMeasure(v);
  },
  950732822: function _(v) {
    return new IFC4_3.IfcURIReference(v);
  },
  3345633955: function _(v) {
    return new IFC4_3.IfcVaporPermeabilityMeasure(v);
  },
  3458127941: function _(v) {
    return new IFC4_3.IfcVolumeMeasure(v);
  },
  2593997549: function _(v) {
    return new IFC4_3.IfcVolumetricFlowRateMeasure(v);
  },
  51269191: function _(v) {
    return new IFC4_3.IfcWarpingConstantMeasure(v);
  },
  1718600412: function _(v) {
    return new IFC4_3.IfcWarpingMomentMeasure(v);
  }
};
var IFC4_3;

(function (IFC4_32) {
  var IfcAbsorbedDoseMeasure = function IfcAbsorbedDoseMeasure(value) {
    _classCallCheck2(this, IfcAbsorbedDoseMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;

  var IfcAccelerationMeasure = function IfcAccelerationMeasure(value) {
    _classCallCheck2(this, IfcAccelerationMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcAccelerationMeasure = IfcAccelerationMeasure;

  var IfcAmountOfSubstanceMeasure = function IfcAmountOfSubstanceMeasure(value) {
    _classCallCheck2(this, IfcAmountOfSubstanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;

  var IfcAngularVelocityMeasure = function IfcAngularVelocityMeasure(value) {
    _classCallCheck2(this, IfcAngularVelocityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;

  var IfcArcIndex = function IfcArcIndex(value) {
    _classCallCheck2(this, IfcArcIndex);

    this.value = value;
  };

  IFC4_32.IfcArcIndex = IfcArcIndex;

  var IfcAreaDensityMeasure = function IfcAreaDensityMeasure(value) {
    _classCallCheck2(this, IfcAreaDensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcAreaDensityMeasure = IfcAreaDensityMeasure;

  var IfcAreaMeasure = function IfcAreaMeasure(value) {
    _classCallCheck2(this, IfcAreaMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcAreaMeasure = IfcAreaMeasure;

  var IfcBinary = function IfcBinary(value) {
    _classCallCheck2(this, IfcBinary);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcBinary = IfcBinary;

  var IfcBoolean = function IfcBoolean(value) {
    _classCallCheck2(this, IfcBoolean);

    this.value = value;
    this.type = 3;
  };

  IFC4_32.IfcBoolean = IfcBoolean;

  var IfcBoxAlignment = function IfcBoxAlignment(value) {
    _classCallCheck2(this, IfcBoxAlignment);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcBoxAlignment = IfcBoxAlignment;

  var IfcCardinalPointReference = function IfcCardinalPointReference(value) {
    _classCallCheck2(this, IfcCardinalPointReference);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcCardinalPointReference = IfcCardinalPointReference;

  var IfcComplexNumber = function IfcComplexNumber(value) {
    _classCallCheck2(this, IfcComplexNumber);

    this.value = value;
  };

  IFC4_32.IfcComplexNumber = IfcComplexNumber;

  var IfcCompoundPlaneAngleMeasure = function IfcCompoundPlaneAngleMeasure(value) {
    _classCallCheck2(this, IfcCompoundPlaneAngleMeasure);

    this.value = value;
  };

  IFC4_32.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;

  var IfcContextDependentMeasure = function IfcContextDependentMeasure(value) {
    _classCallCheck2(this, IfcContextDependentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcContextDependentMeasure = IfcContextDependentMeasure;

  var IfcCountMeasure = function IfcCountMeasure(value) {
    _classCallCheck2(this, IfcCountMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcCountMeasure = IfcCountMeasure;

  var IfcCurvatureMeasure = function IfcCurvatureMeasure(value) {
    _classCallCheck2(this, IfcCurvatureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcCurvatureMeasure = IfcCurvatureMeasure;

  var IfcDate = function IfcDate(value) {
    _classCallCheck2(this, IfcDate);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcDate = IfcDate;

  var IfcDateTime = function IfcDateTime(value) {
    _classCallCheck2(this, IfcDateTime);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcDateTime = IfcDateTime;

  var IfcDayInMonthNumber = function IfcDayInMonthNumber(value) {
    _classCallCheck2(this, IfcDayInMonthNumber);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcDayInMonthNumber = IfcDayInMonthNumber;

  var IfcDayInWeekNumber = function IfcDayInWeekNumber(value) {
    _classCallCheck2(this, IfcDayInWeekNumber);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcDayInWeekNumber = IfcDayInWeekNumber;

  var IfcDescriptiveMeasure = function IfcDescriptiveMeasure(value) {
    _classCallCheck2(this, IfcDescriptiveMeasure);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcDescriptiveMeasure = IfcDescriptiveMeasure;

  var IfcDimensionCount = function IfcDimensionCount(value) {
    _classCallCheck2(this, IfcDimensionCount);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcDimensionCount = IfcDimensionCount;

  var IfcDoseEquivalentMeasure = function IfcDoseEquivalentMeasure(value) {
    _classCallCheck2(this, IfcDoseEquivalentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;

  var IfcDuration = function IfcDuration(value) {
    _classCallCheck2(this, IfcDuration);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcDuration = IfcDuration;

  var IfcDynamicViscosityMeasure = function IfcDynamicViscosityMeasure(value) {
    _classCallCheck2(this, IfcDynamicViscosityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;

  var IfcElectricCapacitanceMeasure = function IfcElectricCapacitanceMeasure(value) {
    _classCallCheck2(this, IfcElectricCapacitanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;

  var IfcElectricChargeMeasure = function IfcElectricChargeMeasure(value) {
    _classCallCheck2(this, IfcElectricChargeMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcElectricChargeMeasure = IfcElectricChargeMeasure;

  var IfcElectricConductanceMeasure = function IfcElectricConductanceMeasure(value) {
    _classCallCheck2(this, IfcElectricConductanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;

  var IfcElectricCurrentMeasure = function IfcElectricCurrentMeasure(value) {
    _classCallCheck2(this, IfcElectricCurrentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;

  var IfcElectricResistanceMeasure = function IfcElectricResistanceMeasure(value) {
    _classCallCheck2(this, IfcElectricResistanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;

  var IfcElectricVoltageMeasure = function IfcElectricVoltageMeasure(value) {
    _classCallCheck2(this, IfcElectricVoltageMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;

  var IfcEnergyMeasure = function IfcEnergyMeasure(value) {
    _classCallCheck2(this, IfcEnergyMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcEnergyMeasure = IfcEnergyMeasure;

  var IfcFontStyle = function IfcFontStyle(value) {
    _classCallCheck2(this, IfcFontStyle);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcFontStyle = IfcFontStyle;

  var IfcFontVariant = function IfcFontVariant(value) {
    _classCallCheck2(this, IfcFontVariant);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcFontVariant = IfcFontVariant;

  var IfcFontWeight = function IfcFontWeight(value) {
    _classCallCheck2(this, IfcFontWeight);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcFontWeight = IfcFontWeight;

  var IfcForceMeasure = function IfcForceMeasure(value) {
    _classCallCheck2(this, IfcForceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcForceMeasure = IfcForceMeasure;

  var IfcFrequencyMeasure = function IfcFrequencyMeasure(value) {
    _classCallCheck2(this, IfcFrequencyMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcFrequencyMeasure = IfcFrequencyMeasure;

  var IfcGloballyUniqueId = function IfcGloballyUniqueId(value) {
    _classCallCheck2(this, IfcGloballyUniqueId);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcGloballyUniqueId = IfcGloballyUniqueId;

  var IfcHeatFluxDensityMeasure = function IfcHeatFluxDensityMeasure(value) {
    _classCallCheck2(this, IfcHeatFluxDensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;

  var IfcHeatingValueMeasure = function IfcHeatingValueMeasure(value) {
    _classCallCheck2(this, IfcHeatingValueMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcHeatingValueMeasure = IfcHeatingValueMeasure;

  var IfcIdentifier = function IfcIdentifier(value) {
    _classCallCheck2(this, IfcIdentifier);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcIdentifier = IfcIdentifier;

  var IfcIlluminanceMeasure = function IfcIlluminanceMeasure(value) {
    _classCallCheck2(this, IfcIlluminanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcIlluminanceMeasure = IfcIlluminanceMeasure;

  var IfcInductanceMeasure = function IfcInductanceMeasure(value) {
    _classCallCheck2(this, IfcInductanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcInductanceMeasure = IfcInductanceMeasure;

  var IfcInteger = function IfcInteger(value) {
    _classCallCheck2(this, IfcInteger);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcInteger = IfcInteger;

  var IfcIntegerCountRateMeasure = function IfcIntegerCountRateMeasure(value) {
    _classCallCheck2(this, IfcIntegerCountRateMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;

  var IfcIonConcentrationMeasure = function IfcIonConcentrationMeasure(value) {
    _classCallCheck2(this, IfcIonConcentrationMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;

  var IfcIsothermalMoistureCapacityMeasure = function IfcIsothermalMoistureCapacityMeasure(value) {
    _classCallCheck2(this, IfcIsothermalMoistureCapacityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;

  var IfcKinematicViscosityMeasure = function IfcKinematicViscosityMeasure(value) {
    _classCallCheck2(this, IfcKinematicViscosityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;

  var IfcLabel = function IfcLabel(value) {
    _classCallCheck2(this, IfcLabel);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcLabel = IfcLabel;

  var IfcLanguageId = function IfcLanguageId(value) {
    _classCallCheck2(this, IfcLanguageId);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcLanguageId = IfcLanguageId;

  var IfcLengthMeasure = function IfcLengthMeasure(value) {
    _classCallCheck2(this, IfcLengthMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcLengthMeasure = IfcLengthMeasure;

  var IfcLineIndex = function IfcLineIndex(value) {
    _classCallCheck2(this, IfcLineIndex);

    this.value = value;
  };

  IFC4_32.IfcLineIndex = IfcLineIndex;

  var IfcLinearForceMeasure = function IfcLinearForceMeasure(value) {
    _classCallCheck2(this, IfcLinearForceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcLinearForceMeasure = IfcLinearForceMeasure;

  var IfcLinearMomentMeasure = function IfcLinearMomentMeasure(value) {
    _classCallCheck2(this, IfcLinearMomentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcLinearMomentMeasure = IfcLinearMomentMeasure;

  var IfcLinearStiffnessMeasure = function IfcLinearStiffnessMeasure(value) {
    _classCallCheck2(this, IfcLinearStiffnessMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;

  var IfcLinearVelocityMeasure = function IfcLinearVelocityMeasure(value) {
    _classCallCheck2(this, IfcLinearVelocityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;

  var IfcLogical = function IfcLogical(value) {
    _classCallCheck2(this, IfcLogical);

    this.value = value;
    this.type = 3;
  };

  IFC4_32.IfcLogical = IfcLogical;

  var IfcLuminousFluxMeasure = function IfcLuminousFluxMeasure(value) {
    _classCallCheck2(this, IfcLuminousFluxMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;

  var IfcLuminousIntensityDistributionMeasure = function IfcLuminousIntensityDistributionMeasure(value) {
    _classCallCheck2(this, IfcLuminousIntensityDistributionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;

  var IfcLuminousIntensityMeasure = function IfcLuminousIntensityMeasure(value) {
    _classCallCheck2(this, IfcLuminousIntensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;

  var IfcMagneticFluxDensityMeasure = function IfcMagneticFluxDensityMeasure(value) {
    _classCallCheck2(this, IfcMagneticFluxDensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;

  var IfcMagneticFluxMeasure = function IfcMagneticFluxMeasure(value) {
    _classCallCheck2(this, IfcMagneticFluxMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;

  var IfcMassDensityMeasure = function IfcMassDensityMeasure(value) {
    _classCallCheck2(this, IfcMassDensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcMassDensityMeasure = IfcMassDensityMeasure;

  var IfcMassFlowRateMeasure = function IfcMassFlowRateMeasure(value) {
    _classCallCheck2(this, IfcMassFlowRateMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;

  var IfcMassMeasure = function IfcMassMeasure(value) {
    _classCallCheck2(this, IfcMassMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcMassMeasure = IfcMassMeasure;

  var IfcMassPerLengthMeasure = function IfcMassPerLengthMeasure(value) {
    _classCallCheck2(this, IfcMassPerLengthMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;

  var IfcModulusOfElasticityMeasure = function IfcModulusOfElasticityMeasure(value) {
    _classCallCheck2(this, IfcModulusOfElasticityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;

  var IfcModulusOfLinearSubgradeReactionMeasure = function IfcModulusOfLinearSubgradeReactionMeasure(value) {
    _classCallCheck2(this, IfcModulusOfLinearSubgradeReactionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;

  var IfcModulusOfRotationalSubgradeReactionMeasure = function IfcModulusOfRotationalSubgradeReactionMeasure(value) {
    _classCallCheck2(this, IfcModulusOfRotationalSubgradeReactionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;

  var IfcModulusOfSubgradeReactionMeasure = function IfcModulusOfSubgradeReactionMeasure(value) {
    _classCallCheck2(this, IfcModulusOfSubgradeReactionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;

  var IfcMoistureDiffusivityMeasure = function IfcMoistureDiffusivityMeasure(value) {
    _classCallCheck2(this, IfcMoistureDiffusivityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;

  var IfcMolecularWeightMeasure = function IfcMolecularWeightMeasure(value) {
    _classCallCheck2(this, IfcMolecularWeightMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;

  var IfcMomentOfInertiaMeasure = function IfcMomentOfInertiaMeasure(value) {
    _classCallCheck2(this, IfcMomentOfInertiaMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;

  var IfcMonetaryMeasure = function IfcMonetaryMeasure(value) {
    _classCallCheck2(this, IfcMonetaryMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcMonetaryMeasure = IfcMonetaryMeasure;

  var IfcMonthInYearNumber = function IfcMonthInYearNumber(value) {
    _classCallCheck2(this, IfcMonthInYearNumber);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcMonthInYearNumber = IfcMonthInYearNumber;

  var IfcNonNegativeLengthMeasure = function IfcNonNegativeLengthMeasure(value) {
    _classCallCheck2(this, IfcNonNegativeLengthMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcNonNegativeLengthMeasure = IfcNonNegativeLengthMeasure;

  var IfcNormalisedRatioMeasure = function IfcNormalisedRatioMeasure(value) {
    _classCallCheck2(this, IfcNormalisedRatioMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;

  var IfcNumericMeasure = function IfcNumericMeasure(value) {
    _classCallCheck2(this, IfcNumericMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcNumericMeasure = IfcNumericMeasure;

  var IfcPHMeasure = function IfcPHMeasure(value) {
    _classCallCheck2(this, IfcPHMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcPHMeasure = IfcPHMeasure;

  var IfcParameterValue = function IfcParameterValue(value) {
    _classCallCheck2(this, IfcParameterValue);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcParameterValue = IfcParameterValue;

  var IfcPlanarForceMeasure = function IfcPlanarForceMeasure(value) {
    _classCallCheck2(this, IfcPlanarForceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcPlanarForceMeasure = IfcPlanarForceMeasure;

  var IfcPlaneAngleMeasure = function IfcPlaneAngleMeasure(value) {
    _classCallCheck2(this, IfcPlaneAngleMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;

  var IfcPositiveInteger = function IfcPositiveInteger(value) {
    _classCallCheck2(this, IfcPositiveInteger);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcPositiveInteger = IfcPositiveInteger;

  var IfcPositiveLengthMeasure = function IfcPositiveLengthMeasure(value) {
    _classCallCheck2(this, IfcPositiveLengthMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;

  var IfcPositivePlaneAngleMeasure = function IfcPositivePlaneAngleMeasure(value) {
    _classCallCheck2(this, IfcPositivePlaneAngleMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;

  var IfcPositiveRatioMeasure = function IfcPositiveRatioMeasure(value) {
    _classCallCheck2(this, IfcPositiveRatioMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;

  var IfcPowerMeasure = function IfcPowerMeasure(value) {
    _classCallCheck2(this, IfcPowerMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcPowerMeasure = IfcPowerMeasure;

  var IfcPresentableText = function IfcPresentableText(value) {
    _classCallCheck2(this, IfcPresentableText);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcPresentableText = IfcPresentableText;

  var IfcPressureMeasure = function IfcPressureMeasure(value) {
    _classCallCheck2(this, IfcPressureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcPressureMeasure = IfcPressureMeasure;

  var IfcPropertySetDefinitionSet = function IfcPropertySetDefinitionSet(value) {
    _classCallCheck2(this, IfcPropertySetDefinitionSet);

    this.value = value;
  };

  IFC4_32.IfcPropertySetDefinitionSet = IfcPropertySetDefinitionSet;

  var IfcRadioActivityMeasure = function IfcRadioActivityMeasure(value) {
    _classCallCheck2(this, IfcRadioActivityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcRadioActivityMeasure = IfcRadioActivityMeasure;

  var IfcRatioMeasure = function IfcRatioMeasure(value) {
    _classCallCheck2(this, IfcRatioMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcRatioMeasure = IfcRatioMeasure;

  var IfcReal = function IfcReal(value) {
    _classCallCheck2(this, IfcReal);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcReal = IfcReal;

  var IfcRotationalFrequencyMeasure = function IfcRotationalFrequencyMeasure(value) {
    _classCallCheck2(this, IfcRotationalFrequencyMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;

  var IfcRotationalMassMeasure = function IfcRotationalMassMeasure(value) {
    _classCallCheck2(this, IfcRotationalMassMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcRotationalMassMeasure = IfcRotationalMassMeasure;

  var IfcRotationalStiffnessMeasure = function IfcRotationalStiffnessMeasure(value) {
    _classCallCheck2(this, IfcRotationalStiffnessMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;

  var IfcSectionModulusMeasure = function IfcSectionModulusMeasure(value) {
    _classCallCheck2(this, IfcSectionModulusMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcSectionModulusMeasure = IfcSectionModulusMeasure;

  var IfcSectionalAreaIntegralMeasure = function IfcSectionalAreaIntegralMeasure(value) {
    _classCallCheck2(this, IfcSectionalAreaIntegralMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;

  var IfcShearModulusMeasure = function IfcShearModulusMeasure(value) {
    _classCallCheck2(this, IfcShearModulusMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcShearModulusMeasure = IfcShearModulusMeasure;

  var IfcSolidAngleMeasure = function IfcSolidAngleMeasure(value) {
    _classCallCheck2(this, IfcSolidAngleMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcSolidAngleMeasure = IfcSolidAngleMeasure;

  var IfcSoundPowerLevelMeasure = function IfcSoundPowerLevelMeasure(value) {
    _classCallCheck2(this, IfcSoundPowerLevelMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcSoundPowerLevelMeasure = IfcSoundPowerLevelMeasure;

  var IfcSoundPowerMeasure = function IfcSoundPowerMeasure(value) {
    _classCallCheck2(this, IfcSoundPowerMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcSoundPowerMeasure = IfcSoundPowerMeasure;

  var IfcSoundPressureLevelMeasure = function IfcSoundPressureLevelMeasure(value) {
    _classCallCheck2(this, IfcSoundPressureLevelMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcSoundPressureLevelMeasure = IfcSoundPressureLevelMeasure;

  var IfcSoundPressureMeasure = function IfcSoundPressureMeasure(value) {
    _classCallCheck2(this, IfcSoundPressureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcSoundPressureMeasure = IfcSoundPressureMeasure;

  var IfcSpecificHeatCapacityMeasure = function IfcSpecificHeatCapacityMeasure(value) {
    _classCallCheck2(this, IfcSpecificHeatCapacityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;

  var IfcSpecularExponent = function IfcSpecularExponent(value) {
    _classCallCheck2(this, IfcSpecularExponent);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcSpecularExponent = IfcSpecularExponent;

  var IfcSpecularRoughness = function IfcSpecularRoughness(value) {
    _classCallCheck2(this, IfcSpecularRoughness);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcSpecularRoughness = IfcSpecularRoughness;

  var IfcTemperatureGradientMeasure = function IfcTemperatureGradientMeasure(value) {
    _classCallCheck2(this, IfcTemperatureGradientMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;

  var IfcTemperatureRateOfChangeMeasure = function IfcTemperatureRateOfChangeMeasure(value) {
    _classCallCheck2(this, IfcTemperatureRateOfChangeMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcTemperatureRateOfChangeMeasure = IfcTemperatureRateOfChangeMeasure;

  var IfcText = function IfcText(value) {
    _classCallCheck2(this, IfcText);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcText = IfcText;

  var IfcTextAlignment = function IfcTextAlignment(value) {
    _classCallCheck2(this, IfcTextAlignment);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcTextAlignment = IfcTextAlignment;

  var IfcTextDecoration = function IfcTextDecoration(value) {
    _classCallCheck2(this, IfcTextDecoration);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcTextDecoration = IfcTextDecoration;

  var IfcTextFontName = function IfcTextFontName(value) {
    _classCallCheck2(this, IfcTextFontName);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcTextFontName = IfcTextFontName;

  var IfcTextTransformation = function IfcTextTransformation(value) {
    _classCallCheck2(this, IfcTextTransformation);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcTextTransformation = IfcTextTransformation;

  var IfcThermalAdmittanceMeasure = function IfcThermalAdmittanceMeasure(value) {
    _classCallCheck2(this, IfcThermalAdmittanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;

  var IfcThermalConductivityMeasure = function IfcThermalConductivityMeasure(value) {
    _classCallCheck2(this, IfcThermalConductivityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;

  var IfcThermalExpansionCoefficientMeasure = function IfcThermalExpansionCoefficientMeasure(value) {
    _classCallCheck2(this, IfcThermalExpansionCoefficientMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;

  var IfcThermalResistanceMeasure = function IfcThermalResistanceMeasure(value) {
    _classCallCheck2(this, IfcThermalResistanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;

  var IfcThermalTransmittanceMeasure = function IfcThermalTransmittanceMeasure(value) {
    _classCallCheck2(this, IfcThermalTransmittanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;

  var IfcThermodynamicTemperatureMeasure = function IfcThermodynamicTemperatureMeasure(value) {
    _classCallCheck2(this, IfcThermodynamicTemperatureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;

  var IfcTime = function IfcTime(value) {
    _classCallCheck2(this, IfcTime);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcTime = IfcTime;

  var IfcTimeMeasure = function IfcTimeMeasure(value) {
    _classCallCheck2(this, IfcTimeMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcTimeMeasure = IfcTimeMeasure;

  var IfcTimeStamp = function IfcTimeStamp(value) {
    _classCallCheck2(this, IfcTimeStamp);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcTimeStamp = IfcTimeStamp;

  var IfcTorqueMeasure = function IfcTorqueMeasure(value) {
    _classCallCheck2(this, IfcTorqueMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcTorqueMeasure = IfcTorqueMeasure;

  var IfcURIReference = function IfcURIReference(value) {
    _classCallCheck2(this, IfcURIReference);

    this.value = value;
    this.type = 1;
  };

  IFC4_32.IfcURIReference = IfcURIReference;

  var IfcVaporPermeabilityMeasure = function IfcVaporPermeabilityMeasure(value) {
    _classCallCheck2(this, IfcVaporPermeabilityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;

  var IfcVolumeMeasure = function IfcVolumeMeasure(value) {
    _classCallCheck2(this, IfcVolumeMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcVolumeMeasure = IfcVolumeMeasure;

  var IfcVolumetricFlowRateMeasure = function IfcVolumetricFlowRateMeasure(value) {
    _classCallCheck2(this, IfcVolumetricFlowRateMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;

  var IfcWarpingConstantMeasure = function IfcWarpingConstantMeasure(value) {
    _classCallCheck2(this, IfcWarpingConstantMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;

  var IfcWarpingMomentMeasure = function IfcWarpingMomentMeasure(value) {
    _classCallCheck2(this, IfcWarpingMomentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC4_32.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;

  var IfcActionRequestTypeEnum = function IfcActionRequestTypeEnum() {
    _classCallCheck2(this, IfcActionRequestTypeEnum);
  };

  IfcActionRequestTypeEnum.EMAIL = {
    type: 3,
    value: "EMAIL"
  };
  IfcActionRequestTypeEnum.FAX = {
    type: 3,
    value: "FAX"
  };
  IfcActionRequestTypeEnum.PHONE = {
    type: 3,
    value: "PHONE"
  };
  IfcActionRequestTypeEnum.POST = {
    type: 3,
    value: "POST"
  };
  IfcActionRequestTypeEnum.VERBAL = {
    type: 3,
    value: "VERBAL"
  };
  IfcActionRequestTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcActionRequestTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcActionRequestTypeEnum = IfcActionRequestTypeEnum;

  var IfcActionSourceTypeEnum = function IfcActionSourceTypeEnum() {
    _classCallCheck2(this, IfcActionSourceTypeEnum);
  };

  IfcActionSourceTypeEnum.BRAKES = {
    type: 3,
    value: "BRAKES"
  };
  IfcActionSourceTypeEnum.BUOYANCY = {
    type: 3,
    value: "BUOYANCY"
  };
  IfcActionSourceTypeEnum.COMPLETION_G1 = {
    type: 3,
    value: "COMPLETION_G1"
  };
  IfcActionSourceTypeEnum.CREEP = {
    type: 3,
    value: "CREEP"
  };
  IfcActionSourceTypeEnum.CURRENT = {
    type: 3,
    value: "CURRENT"
  };
  IfcActionSourceTypeEnum.DEAD_LOAD_G = {
    type: 3,
    value: "DEAD_LOAD_G"
  };
  IfcActionSourceTypeEnum.EARTHQUAKE_E = {
    type: 3,
    value: "EARTHQUAKE_E"
  };
  IfcActionSourceTypeEnum.ERECTION = {
    type: 3,
    value: "ERECTION"
  };
  IfcActionSourceTypeEnum.FIRE = {
    type: 3,
    value: "FIRE"
  };
  IfcActionSourceTypeEnum.ICE = {
    type: 3,
    value: "ICE"
  };
  IfcActionSourceTypeEnum.IMPACT = {
    type: 3,
    value: "IMPACT"
  };
  IfcActionSourceTypeEnum.IMPULSE = {
    type: 3,
    value: "IMPULSE"
  };
  IfcActionSourceTypeEnum.LACK_OF_FIT = {
    type: 3,
    value: "LACK_OF_FIT"
  };
  IfcActionSourceTypeEnum.LIVE_LOAD_Q = {
    type: 3,
    value: "LIVE_LOAD_Q"
  };
  IfcActionSourceTypeEnum.PRESTRESSING_P = {
    type: 3,
    value: "PRESTRESSING_P"
  };
  IfcActionSourceTypeEnum.PROPPING = {
    type: 3,
    value: "PROPPING"
  };
  IfcActionSourceTypeEnum.RAIN = {
    type: 3,
    value: "RAIN"
  };
  IfcActionSourceTypeEnum.SETTLEMENT_U = {
    type: 3,
    value: "SETTLEMENT_U"
  };
  IfcActionSourceTypeEnum.SHRINKAGE = {
    type: 3,
    value: "SHRINKAGE"
  };
  IfcActionSourceTypeEnum.SNOW_S = {
    type: 3,
    value: "SNOW_S"
  };
  IfcActionSourceTypeEnum.SYSTEM_IMPERFECTION = {
    type: 3,
    value: "SYSTEM_IMPERFECTION"
  };
  IfcActionSourceTypeEnum.TEMPERATURE_T = {
    type: 3,
    value: "TEMPERATURE_T"
  };
  IfcActionSourceTypeEnum.TRANSPORT = {
    type: 3,
    value: "TRANSPORT"
  };
  IfcActionSourceTypeEnum.WAVE = {
    type: 3,
    value: "WAVE"
  };
  IfcActionSourceTypeEnum.WIND_W = {
    type: 3,
    value: "WIND_W"
  };
  IfcActionSourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcActionSourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;

  var IfcActionTypeEnum = function IfcActionTypeEnum() {
    _classCallCheck2(this, IfcActionTypeEnum);
  };

  IfcActionTypeEnum.EXTRAORDINARY_A = {
    type: 3,
    value: "EXTRAORDINARY_A"
  };
  IfcActionTypeEnum.PERMANENT_G = {
    type: 3,
    value: "PERMANENT_G"
  };
  IfcActionTypeEnum.VARIABLE_Q = {
    type: 3,
    value: "VARIABLE_Q"
  };
  IfcActionTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcActionTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcActionTypeEnum = IfcActionTypeEnum;

  var IfcActuatorTypeEnum = function IfcActuatorTypeEnum() {
    _classCallCheck2(this, IfcActuatorTypeEnum);
  };

  IfcActuatorTypeEnum.ELECTRICACTUATOR = {
    type: 3,
    value: "ELECTRICACTUATOR"
  };
  IfcActuatorTypeEnum.HANDOPERATEDACTUATOR = {
    type: 3,
    value: "HANDOPERATEDACTUATOR"
  };
  IfcActuatorTypeEnum.HYDRAULICACTUATOR = {
    type: 3,
    value: "HYDRAULICACTUATOR"
  };
  IfcActuatorTypeEnum.PNEUMATICACTUATOR = {
    type: 3,
    value: "PNEUMATICACTUATOR"
  };
  IfcActuatorTypeEnum.THERMOSTATICACTUATOR = {
    type: 3,
    value: "THERMOSTATICACTUATOR"
  };
  IfcActuatorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcActuatorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcActuatorTypeEnum = IfcActuatorTypeEnum;

  var IfcAddressTypeEnum = function IfcAddressTypeEnum() {
    _classCallCheck2(this, IfcAddressTypeEnum);
  };

  IfcAddressTypeEnum.DISTRIBUTIONPOINT = {
    type: 3,
    value: "DISTRIBUTIONPOINT"
  };
  IfcAddressTypeEnum.HOME = {
    type: 3,
    value: "HOME"
  };
  IfcAddressTypeEnum.OFFICE = {
    type: 3,
    value: "OFFICE"
  };
  IfcAddressTypeEnum.SITE = {
    type: 3,
    value: "SITE"
  };
  IfcAddressTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC4_32.IfcAddressTypeEnum = IfcAddressTypeEnum;

  var IfcAirTerminalBoxTypeEnum = function IfcAirTerminalBoxTypeEnum() {
    _classCallCheck2(this, IfcAirTerminalBoxTypeEnum);
  };

  IfcAirTerminalBoxTypeEnum.CONSTANTFLOW = {
    type: 3,
    value: "CONSTANTFLOW"
  };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREDEPENDANT = {
    type: 3,
    value: "VARIABLEFLOWPRESSUREDEPENDANT"
  };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREINDEPENDANT = {
    type: 3,
    value: "VARIABLEFLOWPRESSUREINDEPENDANT"
  };
  IfcAirTerminalBoxTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAirTerminalBoxTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;

  var IfcAirTerminalTypeEnum = function IfcAirTerminalTypeEnum() {
    _classCallCheck2(this, IfcAirTerminalTypeEnum);
  };

  IfcAirTerminalTypeEnum.DIFFUSER = {
    type: 3,
    value: "DIFFUSER"
  };
  IfcAirTerminalTypeEnum.GRILLE = {
    type: 3,
    value: "GRILLE"
  };
  IfcAirTerminalTypeEnum.LOUVRE = {
    type: 3,
    value: "LOUVRE"
  };
  IfcAirTerminalTypeEnum.REGISTER = {
    type: 3,
    value: "REGISTER"
  };
  IfcAirTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAirTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;

  var IfcAirToAirHeatRecoveryTypeEnum = function IfcAirToAirHeatRecoveryTypeEnum() {
    _classCallCheck2(this, IfcAirToAirHeatRecoveryTypeEnum);
  };

  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECOUNTERFLOWEXCHANGER = {
    type: 3,
    value: "FIXEDPLATECOUNTERFLOWEXCHANGER"
  };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECROSSFLOWEXCHANGER = {
    type: 3,
    value: "FIXEDPLATECROSSFLOWEXCHANGER"
  };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATEPARALLELFLOWEXCHANGER = {
    type: 3,
    value: "FIXEDPLATEPARALLELFLOWEXCHANGER"
  };
  IfcAirToAirHeatRecoveryTypeEnum.HEATPIPE = {
    type: 3,
    value: "HEATPIPE"
  };
  IfcAirToAirHeatRecoveryTypeEnum.ROTARYWHEEL = {
    type: 3,
    value: "ROTARYWHEEL"
  };
  IfcAirToAirHeatRecoveryTypeEnum.RUNAROUNDCOILLOOP = {
    type: 3,
    value: "RUNAROUNDCOILLOOP"
  };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONCOILTYPEHEATEXCHANGERS = {
    type: 3,
    value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS"
  };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = {
    type: 3,
    value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS"
  };
  IfcAirToAirHeatRecoveryTypeEnum.TWINTOWERENTHALPYRECOVERYLOOPS = {
    type: 3,
    value: "TWINTOWERENTHALPYRECOVERYLOOPS"
  };
  IfcAirToAirHeatRecoveryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAirToAirHeatRecoveryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;

  var IfcAlarmTypeEnum = function IfcAlarmTypeEnum() {
    _classCallCheck2(this, IfcAlarmTypeEnum);
  };

  IfcAlarmTypeEnum.BELL = {
    type: 3,
    value: "BELL"
  };
  IfcAlarmTypeEnum.BREAKGLASSBUTTON = {
    type: 3,
    value: "BREAKGLASSBUTTON"
  };
  IfcAlarmTypeEnum.LIGHT = {
    type: 3,
    value: "LIGHT"
  };
  IfcAlarmTypeEnum.MANUALPULLBOX = {
    type: 3,
    value: "MANUALPULLBOX"
  };
  IfcAlarmTypeEnum.RAILWAYCROCODILE = {
    type: 3,
    value: "RAILWAYCROCODILE"
  };
  IfcAlarmTypeEnum.RAILWAYDETONATOR = {
    type: 3,
    value: "RAILWAYDETONATOR"
  };
  IfcAlarmTypeEnum.SIREN = {
    type: 3,
    value: "SIREN"
  };
  IfcAlarmTypeEnum.WHISTLE = {
    type: 3,
    value: "WHISTLE"
  };
  IfcAlarmTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAlarmTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcAlarmTypeEnum = IfcAlarmTypeEnum;

  var IfcAlignmentCantSegmentTypeEnum = function IfcAlignmentCantSegmentTypeEnum() {
    _classCallCheck2(this, IfcAlignmentCantSegmentTypeEnum);
  };

  IfcAlignmentCantSegmentTypeEnum.BLOSSCURVE = {
    type: 3,
    value: "BLOSSCURVE"
  };
  IfcAlignmentCantSegmentTypeEnum.CONSTANTCANT = {
    type: 3,
    value: "CONSTANTCANT"
  };
  IfcAlignmentCantSegmentTypeEnum.COSINECURVE = {
    type: 3,
    value: "COSINECURVE"
  };
  IfcAlignmentCantSegmentTypeEnum.HELMERTCURVE = {
    type: 3,
    value: "HELMERTCURVE"
  };
  IfcAlignmentCantSegmentTypeEnum.LINEARTRANSITION = {
    type: 3,
    value: "LINEARTRANSITION"
  };
  IfcAlignmentCantSegmentTypeEnum.SINECURVE = {
    type: 3,
    value: "SINECURVE"
  };
  IfcAlignmentCantSegmentTypeEnum.VIENNESEBEND = {
    type: 3,
    value: "VIENNESEBEND"
  };
  IFC4_32.IfcAlignmentCantSegmentTypeEnum = IfcAlignmentCantSegmentTypeEnum;

  var IfcAlignmentHorizontalSegmentTypeEnum = function IfcAlignmentHorizontalSegmentTypeEnum() {
    _classCallCheck2(this, IfcAlignmentHorizontalSegmentTypeEnum);
  };

  IfcAlignmentHorizontalSegmentTypeEnum.BLOSSCURVE = {
    type: 3,
    value: "BLOSSCURVE"
  };
  IfcAlignmentHorizontalSegmentTypeEnum.CIRCULARARC = {
    type: 3,
    value: "CIRCULARARC"
  };
  IfcAlignmentHorizontalSegmentTypeEnum.CLOTHOID = {
    type: 3,
    value: "CLOTHOID"
  };
  IfcAlignmentHorizontalSegmentTypeEnum.COSINECURVE = {
    type: 3,
    value: "COSINECURVE"
  };
  IfcAlignmentHorizontalSegmentTypeEnum.CUBIC = {
    type: 3,
    value: "CUBIC"
  };
  IfcAlignmentHorizontalSegmentTypeEnum.HELMERTCURVE = {
    type: 3,
    value: "HELMERTCURVE"
  };
  IfcAlignmentHorizontalSegmentTypeEnum.LINE = {
    type: 3,
    value: "LINE"
  };
  IfcAlignmentHorizontalSegmentTypeEnum.SINECURVE = {
    type: 3,
    value: "SINECURVE"
  };
  IfcAlignmentHorizontalSegmentTypeEnum.VIENNESEBEND = {
    type: 3,
    value: "VIENNESEBEND"
  };
  IFC4_32.IfcAlignmentHorizontalSegmentTypeEnum = IfcAlignmentHorizontalSegmentTypeEnum;

  var IfcAlignmentTypeEnum = function IfcAlignmentTypeEnum() {
    _classCallCheck2(this, IfcAlignmentTypeEnum);
  };

  IfcAlignmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAlignmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcAlignmentTypeEnum = IfcAlignmentTypeEnum;

  var IfcAlignmentVerticalSegmentTypeEnum = function IfcAlignmentVerticalSegmentTypeEnum() {
    _classCallCheck2(this, IfcAlignmentVerticalSegmentTypeEnum);
  };

  IfcAlignmentVerticalSegmentTypeEnum.CIRCULARARC = {
    type: 3,
    value: "CIRCULARARC"
  };
  IfcAlignmentVerticalSegmentTypeEnum.CLOTHOID = {
    type: 3,
    value: "CLOTHOID"
  };
  IfcAlignmentVerticalSegmentTypeEnum.CONSTANTGRADIENT = {
    type: 3,
    value: "CONSTANTGRADIENT"
  };
  IfcAlignmentVerticalSegmentTypeEnum.PARABOLICARC = {
    type: 3,
    value: "PARABOLICARC"
  };
  IFC4_32.IfcAlignmentVerticalSegmentTypeEnum = IfcAlignmentVerticalSegmentTypeEnum;

  var IfcAnalysisModelTypeEnum = function IfcAnalysisModelTypeEnum() {
    _classCallCheck2(this, IfcAnalysisModelTypeEnum);
  };

  IfcAnalysisModelTypeEnum.IN_PLANE_LOADING_2D = {
    type: 3,
    value: "IN_PLANE_LOADING_2D"
  };
  IfcAnalysisModelTypeEnum.LOADING_3D = {
    type: 3,
    value: "LOADING_3D"
  };
  IfcAnalysisModelTypeEnum.OUT_PLANE_LOADING_2D = {
    type: 3,
    value: "OUT_PLANE_LOADING_2D"
  };
  IfcAnalysisModelTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAnalysisModelTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;

  var IfcAnalysisTheoryTypeEnum = function IfcAnalysisTheoryTypeEnum() {
    _classCallCheck2(this, IfcAnalysisTheoryTypeEnum);
  };

  IfcAnalysisTheoryTypeEnum.FIRST_ORDER_THEORY = {
    type: 3,
    value: "FIRST_ORDER_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.FULL_NONLINEAR_THEORY = {
    type: 3,
    value: "FULL_NONLINEAR_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.SECOND_ORDER_THEORY = {
    type: 3,
    value: "SECOND_ORDER_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.THIRD_ORDER_THEORY = {
    type: 3,
    value: "THIRD_ORDER_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAnalysisTheoryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;

  var IfcAnnotationTypeEnum = function IfcAnnotationTypeEnum() {
    _classCallCheck2(this, IfcAnnotationTypeEnum);
  };

  IfcAnnotationTypeEnum.ASBUILTAREA = {
    type: 3,
    value: "ASBUILTAREA"
  };
  IfcAnnotationTypeEnum.ASBUILTLINE = {
    type: 3,
    value: "ASBUILTLINE"
  };
  IfcAnnotationTypeEnum.ASBUILTPOINT = {
    type: 3,
    value: "ASBUILTPOINT"
  };
  IfcAnnotationTypeEnum.ASSUMEDAREA = {
    type: 3,
    value: "ASSUMEDAREA"
  };
  IfcAnnotationTypeEnum.ASSUMEDLINE = {
    type: 3,
    value: "ASSUMEDLINE"
  };
  IfcAnnotationTypeEnum.ASSUMEDPOINT = {
    type: 3,
    value: "ASSUMEDPOINT"
  };
  IfcAnnotationTypeEnum.NON_PHYSICAL_SIGNAL = {
    type: 3,
    value: "NON_PHYSICAL_SIGNAL"
  };
  IfcAnnotationTypeEnum.SUPERELEVATIONEVENT = {
    type: 3,
    value: "SUPERELEVATIONEVENT"
  };
  IfcAnnotationTypeEnum.WIDTHEVENT = {
    type: 3,
    value: "WIDTHEVENT"
  };
  IfcAnnotationTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAnnotationTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcAnnotationTypeEnum = IfcAnnotationTypeEnum;

  var IfcArithmeticOperatorEnum = function IfcArithmeticOperatorEnum() {
    _classCallCheck2(this, IfcArithmeticOperatorEnum);
  };

  IfcArithmeticOperatorEnum.ADD = {
    type: 3,
    value: "ADD"
  };
  IfcArithmeticOperatorEnum.DIVIDE = {
    type: 3,
    value: "DIVIDE"
  };
  IfcArithmeticOperatorEnum.MULTIPLY = {
    type: 3,
    value: "MULTIPLY"
  };
  IfcArithmeticOperatorEnum.SUBTRACT = {
    type: 3,
    value: "SUBTRACT"
  };
  IFC4_32.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;

  var IfcAssemblyPlaceEnum = function IfcAssemblyPlaceEnum() {
    _classCallCheck2(this, IfcAssemblyPlaceEnum);
  };

  IfcAssemblyPlaceEnum.FACTORY = {
    type: 3,
    value: "FACTORY"
  };
  IfcAssemblyPlaceEnum.SITE = {
    type: 3,
    value: "SITE"
  };
  IfcAssemblyPlaceEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;

  var IfcAudioVisualApplianceTypeEnum = function IfcAudioVisualApplianceTypeEnum() {
    _classCallCheck2(this, IfcAudioVisualApplianceTypeEnum);
  };

  IfcAudioVisualApplianceTypeEnum.AMPLIFIER = {
    type: 3,
    value: "AMPLIFIER"
  };
  IfcAudioVisualApplianceTypeEnum.CAMERA = {
    type: 3,
    value: "CAMERA"
  };
  IfcAudioVisualApplianceTypeEnum.COMMUNICATIONTERMINAL = {
    type: 3,
    value: "COMMUNICATIONTERMINAL"
  };
  IfcAudioVisualApplianceTypeEnum.DISPLAY = {
    type: 3,
    value: "DISPLAY"
  };
  IfcAudioVisualApplianceTypeEnum.MICROPHONE = {
    type: 3,
    value: "MICROPHONE"
  };
  IfcAudioVisualApplianceTypeEnum.PLAYER = {
    type: 3,
    value: "PLAYER"
  };
  IfcAudioVisualApplianceTypeEnum.PROJECTOR = {
    type: 3,
    value: "PROJECTOR"
  };
  IfcAudioVisualApplianceTypeEnum.RECEIVER = {
    type: 3,
    value: "RECEIVER"
  };
  IfcAudioVisualApplianceTypeEnum.RECORDINGEQUIPMENT = {
    type: 3,
    value: "RECORDINGEQUIPMENT"
  };
  IfcAudioVisualApplianceTypeEnum.SPEAKER = {
    type: 3,
    value: "SPEAKER"
  };
  IfcAudioVisualApplianceTypeEnum.SWITCHER = {
    type: 3,
    value: "SWITCHER"
  };
  IfcAudioVisualApplianceTypeEnum.TELEPHONE = {
    type: 3,
    value: "TELEPHONE"
  };
  IfcAudioVisualApplianceTypeEnum.TUNER = {
    type: 3,
    value: "TUNER"
  };
  IfcAudioVisualApplianceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAudioVisualApplianceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcAudioVisualApplianceTypeEnum = IfcAudioVisualApplianceTypeEnum;

  var IfcBSplineCurveForm = function IfcBSplineCurveForm() {
    _classCallCheck2(this, IfcBSplineCurveForm);
  };

  IfcBSplineCurveForm.CIRCULAR_ARC = {
    type: 3,
    value: "CIRCULAR_ARC"
  };
  IfcBSplineCurveForm.ELLIPTIC_ARC = {
    type: 3,
    value: "ELLIPTIC_ARC"
  };
  IfcBSplineCurveForm.HYPERBOLIC_ARC = {
    type: 3,
    value: "HYPERBOLIC_ARC"
  };
  IfcBSplineCurveForm.PARABOLIC_ARC = {
    type: 3,
    value: "PARABOLIC_ARC"
  };
  IfcBSplineCurveForm.POLYLINE_FORM = {
    type: 3,
    value: "POLYLINE_FORM"
  };
  IfcBSplineCurveForm.UNSPECIFIED = {
    type: 3,
    value: "UNSPECIFIED"
  };
  IFC4_32.IfcBSplineCurveForm = IfcBSplineCurveForm;

  var IfcBSplineSurfaceForm = function IfcBSplineSurfaceForm() {
    _classCallCheck2(this, IfcBSplineSurfaceForm);
  };

  IfcBSplineSurfaceForm.CONICAL_SURF = {
    type: 3,
    value: "CONICAL_SURF"
  };
  IfcBSplineSurfaceForm.CYLINDRICAL_SURF = {
    type: 3,
    value: "CYLINDRICAL_SURF"
  };
  IfcBSplineSurfaceForm.GENERALISED_CONE = {
    type: 3,
    value: "GENERALISED_CONE"
  };
  IfcBSplineSurfaceForm.PLANE_SURF = {
    type: 3,
    value: "PLANE_SURF"
  };
  IfcBSplineSurfaceForm.QUADRIC_SURF = {
    type: 3,
    value: "QUADRIC_SURF"
  };
  IfcBSplineSurfaceForm.RULED_SURF = {
    type: 3,
    value: "RULED_SURF"
  };
  IfcBSplineSurfaceForm.SPHERICAL_SURF = {
    type: 3,
    value: "SPHERICAL_SURF"
  };
  IfcBSplineSurfaceForm.SURF_OF_LINEAR_EXTRUSION = {
    type: 3,
    value: "SURF_OF_LINEAR_EXTRUSION"
  };
  IfcBSplineSurfaceForm.SURF_OF_REVOLUTION = {
    type: 3,
    value: "SURF_OF_REVOLUTION"
  };
  IfcBSplineSurfaceForm.TOROIDAL_SURF = {
    type: 3,
    value: "TOROIDAL_SURF"
  };
  IfcBSplineSurfaceForm.UNSPECIFIED = {
    type: 3,
    value: "UNSPECIFIED"
  };
  IFC4_32.IfcBSplineSurfaceForm = IfcBSplineSurfaceForm;

  var IfcBeamTypeEnum = function IfcBeamTypeEnum() {
    _classCallCheck2(this, IfcBeamTypeEnum);
  };

  IfcBeamTypeEnum.BEAM = {
    type: 3,
    value: "BEAM"
  };
  IfcBeamTypeEnum.CORNICE = {
    type: 3,
    value: "CORNICE"
  };
  IfcBeamTypeEnum.DIAPHRAGM = {
    type: 3,
    value: "DIAPHRAGM"
  };
  IfcBeamTypeEnum.EDGEBEAM = {
    type: 3,
    value: "EDGEBEAM"
  };
  IfcBeamTypeEnum.GIRDER_SEGMENT = {
    type: 3,
    value: "GIRDER_SEGMENT"
  };
  IfcBeamTypeEnum.HATSTONE = {
    type: 3,
    value: "HATSTONE"
  };
  IfcBeamTypeEnum.HOLLOWCORE = {
    type: 3,
    value: "HOLLOWCORE"
  };
  IfcBeamTypeEnum.JOIST = {
    type: 3,
    value: "JOIST"
  };
  IfcBeamTypeEnum.LINTEL = {
    type: 3,
    value: "LINTEL"
  };
  IfcBeamTypeEnum.PIERCAP = {
    type: 3,
    value: "PIERCAP"
  };
  IfcBeamTypeEnum.SPANDREL = {
    type: 3,
    value: "SPANDREL"
  };
  IfcBeamTypeEnum.T_BEAM = {
    type: 3,
    value: "T_BEAM"
  };
  IfcBeamTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBeamTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcBeamTypeEnum = IfcBeamTypeEnum;

  var IfcBearingTypeDisplacementEnum = function IfcBearingTypeDisplacementEnum() {
    _classCallCheck2(this, IfcBearingTypeDisplacementEnum);
  };

  IfcBearingTypeDisplacementEnum.FIXED_MOVEMENT = {
    type: 3,
    value: "FIXED_MOVEMENT"
  };
  IfcBearingTypeDisplacementEnum.FREE_MOVEMENT = {
    type: 3,
    value: "FREE_MOVEMENT"
  };
  IfcBearingTypeDisplacementEnum.GUIDED_LONGITUDINAL = {
    type: 3,
    value: "GUIDED_LONGITUDINAL"
  };
  IfcBearingTypeDisplacementEnum.GUIDED_TRANSVERSAL = {
    type: 3,
    value: "GUIDED_TRANSVERSAL"
  };
  IfcBearingTypeDisplacementEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcBearingTypeDisplacementEnum = IfcBearingTypeDisplacementEnum;

  var IfcBearingTypeEnum = function IfcBearingTypeEnum() {
    _classCallCheck2(this, IfcBearingTypeEnum);
  };

  IfcBearingTypeEnum.CYLINDRICAL = {
    type: 3,
    value: "CYLINDRICAL"
  };
  IfcBearingTypeEnum.DISK = {
    type: 3,
    value: "DISK"
  };
  IfcBearingTypeEnum.ELASTOMERIC = {
    type: 3,
    value: "ELASTOMERIC"
  };
  IfcBearingTypeEnum.GUIDE = {
    type: 3,
    value: "GUIDE"
  };
  IfcBearingTypeEnum.POT = {
    type: 3,
    value: "POT"
  };
  IfcBearingTypeEnum.ROCKER = {
    type: 3,
    value: "ROCKER"
  };
  IfcBearingTypeEnum.ROLLER = {
    type: 3,
    value: "ROLLER"
  };
  IfcBearingTypeEnum.SPHERICAL = {
    type: 3,
    value: "SPHERICAL"
  };
  IfcBearingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBearingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcBearingTypeEnum = IfcBearingTypeEnum;

  var IfcBenchmarkEnum = function IfcBenchmarkEnum() {
    _classCallCheck2(this, IfcBenchmarkEnum);
  };

  IfcBenchmarkEnum.EQUALTO = {
    type: 3,
    value: "EQUALTO"
  };
  IfcBenchmarkEnum.GREATERTHAN = {
    type: 3,
    value: "GREATERTHAN"
  };
  IfcBenchmarkEnum.GREATERTHANOREQUALTO = {
    type: 3,
    value: "GREATERTHANOREQUALTO"
  };
  IfcBenchmarkEnum.INCLUDEDIN = {
    type: 3,
    value: "INCLUDEDIN"
  };
  IfcBenchmarkEnum.INCLUDES = {
    type: 3,
    value: "INCLUDES"
  };
  IfcBenchmarkEnum.LESSTHAN = {
    type: 3,
    value: "LESSTHAN"
  };
  IfcBenchmarkEnum.LESSTHANOREQUALTO = {
    type: 3,
    value: "LESSTHANOREQUALTO"
  };
  IfcBenchmarkEnum.NOTEQUALTO = {
    type: 3,
    value: "NOTEQUALTO"
  };
  IfcBenchmarkEnum.NOTINCLUDEDIN = {
    type: 3,
    value: "NOTINCLUDEDIN"
  };
  IfcBenchmarkEnum.NOTINCLUDES = {
    type: 3,
    value: "NOTINCLUDES"
  };
  IFC4_32.IfcBenchmarkEnum = IfcBenchmarkEnum;

  var IfcBoilerTypeEnum = function IfcBoilerTypeEnum() {
    _classCallCheck2(this, IfcBoilerTypeEnum);
  };

  IfcBoilerTypeEnum.STEAM = {
    type: 3,
    value: "STEAM"
  };
  IfcBoilerTypeEnum.WATER = {
    type: 3,
    value: "WATER"
  };
  IfcBoilerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBoilerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcBoilerTypeEnum = IfcBoilerTypeEnum;

  var IfcBooleanOperator = function IfcBooleanOperator() {
    _classCallCheck2(this, IfcBooleanOperator);
  };

  IfcBooleanOperator.DIFFERENCE = {
    type: 3,
    value: "DIFFERENCE"
  };
  IfcBooleanOperator.INTERSECTION = {
    type: 3,
    value: "INTERSECTION"
  };
  IfcBooleanOperator.UNION = {
    type: 3,
    value: "UNION"
  };
  IFC4_32.IfcBooleanOperator = IfcBooleanOperator;

  var IfcBridgePartTypeEnum = function IfcBridgePartTypeEnum() {
    _classCallCheck2(this, IfcBridgePartTypeEnum);
  };

  IfcBridgePartTypeEnum.ABUTMENT = {
    type: 3,
    value: "ABUTMENT"
  };
  IfcBridgePartTypeEnum.DECK = {
    type: 3,
    value: "DECK"
  };
  IfcBridgePartTypeEnum.DECK_SEGMENT = {
    type: 3,
    value: "DECK_SEGMENT"
  };
  IfcBridgePartTypeEnum.FOUNDATION = {
    type: 3,
    value: "FOUNDATION"
  };
  IfcBridgePartTypeEnum.PIER = {
    type: 3,
    value: "PIER"
  };
  IfcBridgePartTypeEnum.PIER_SEGMENT = {
    type: 3,
    value: "PIER_SEGMENT"
  };
  IfcBridgePartTypeEnum.PYLON = {
    type: 3,
    value: "PYLON"
  };
  IfcBridgePartTypeEnum.SUBSTRUCTURE = {
    type: 3,
    value: "SUBSTRUCTURE"
  };
  IfcBridgePartTypeEnum.SUPERSTRUCTURE = {
    type: 3,
    value: "SUPERSTRUCTURE"
  };
  IfcBridgePartTypeEnum.SURFACESTRUCTURE = {
    type: 3,
    value: "SURFACESTRUCTURE"
  };
  IfcBridgePartTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBridgePartTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcBridgePartTypeEnum = IfcBridgePartTypeEnum;

  var IfcBridgeTypeEnum = function IfcBridgeTypeEnum() {
    _classCallCheck2(this, IfcBridgeTypeEnum);
  };

  IfcBridgeTypeEnum.ARCHED = {
    type: 3,
    value: "ARCHED"
  };
  IfcBridgeTypeEnum.CABLE_STAYED = {
    type: 3,
    value: "CABLE_STAYED"
  };
  IfcBridgeTypeEnum.CANTILEVER = {
    type: 3,
    value: "CANTILEVER"
  };
  IfcBridgeTypeEnum.CULVERT = {
    type: 3,
    value: "CULVERT"
  };
  IfcBridgeTypeEnum.FRAMEWORK = {
    type: 3,
    value: "FRAMEWORK"
  };
  IfcBridgeTypeEnum.GIRDER = {
    type: 3,
    value: "GIRDER"
  };
  IfcBridgeTypeEnum.SUSPENSION = {
    type: 3,
    value: "SUSPENSION"
  };
  IfcBridgeTypeEnum.TRUSS = {
    type: 3,
    value: "TRUSS"
  };
  IfcBridgeTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBridgeTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcBridgeTypeEnum = IfcBridgeTypeEnum;

  var IfcBuildingElementPartTypeEnum = function IfcBuildingElementPartTypeEnum() {
    _classCallCheck2(this, IfcBuildingElementPartTypeEnum);
  };

  IfcBuildingElementPartTypeEnum.APRON = {
    type: 3,
    value: "APRON"
  };
  IfcBuildingElementPartTypeEnum.ARMOURUNIT = {
    type: 3,
    value: "ARMOURUNIT"
  };
  IfcBuildingElementPartTypeEnum.INSULATION = {
    type: 3,
    value: "INSULATION"
  };
  IfcBuildingElementPartTypeEnum.PRECASTPANEL = {
    type: 3,
    value: "PRECASTPANEL"
  };
  IfcBuildingElementPartTypeEnum.SAFETYCAGE = {
    type: 3,
    value: "SAFETYCAGE"
  };
  IfcBuildingElementPartTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBuildingElementPartTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcBuildingElementPartTypeEnum = IfcBuildingElementPartTypeEnum;

  var IfcBuildingElementProxyTypeEnum = function IfcBuildingElementProxyTypeEnum() {
    _classCallCheck2(this, IfcBuildingElementProxyTypeEnum);
  };

  IfcBuildingElementProxyTypeEnum.COMPLEX = {
    type: 3,
    value: "COMPLEX"
  };
  IfcBuildingElementProxyTypeEnum.ELEMENT = {
    type: 3,
    value: "ELEMENT"
  };
  IfcBuildingElementProxyTypeEnum.PARTIAL = {
    type: 3,
    value: "PARTIAL"
  };
  IfcBuildingElementProxyTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBuildingElementProxyTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;

  var IfcBuildingSystemTypeEnum = function IfcBuildingSystemTypeEnum() {
    _classCallCheck2(this, IfcBuildingSystemTypeEnum);
  };

  IfcBuildingSystemTypeEnum.EROSIONPREVENTION = {
    type: 3,
    value: "EROSIONPREVENTION"
  };
  IfcBuildingSystemTypeEnum.FENESTRATION = {
    type: 3,
    value: "FENESTRATION"
  };
  IfcBuildingSystemTypeEnum.FOUNDATION = {
    type: 3,
    value: "FOUNDATION"
  };
  IfcBuildingSystemTypeEnum.LOADBEARING = {
    type: 3,
    value: "LOADBEARING"
  };
  IfcBuildingSystemTypeEnum.OUTERSHELL = {
    type: 3,
    value: "OUTERSHELL"
  };
  IfcBuildingSystemTypeEnum.PRESTRESSING = {
    type: 3,
    value: "PRESTRESSING"
  };
  IfcBuildingSystemTypeEnum.REINFORCING = {
    type: 3,
    value: "REINFORCING"
  };
  IfcBuildingSystemTypeEnum.SHADING = {
    type: 3,
    value: "SHADING"
  };
  IfcBuildingSystemTypeEnum.TRANSPORT = {
    type: 3,
    value: "TRANSPORT"
  };
  IfcBuildingSystemTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBuildingSystemTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcBuildingSystemTypeEnum = IfcBuildingSystemTypeEnum;

  var IfcBuiltSystemTypeEnum = function IfcBuiltSystemTypeEnum() {
    _classCallCheck2(this, IfcBuiltSystemTypeEnum);
  };

  IfcBuiltSystemTypeEnum.EROSIONPREVENTION = {
    type: 3,
    value: "EROSIONPREVENTION"
  };
  IfcBuiltSystemTypeEnum.FENESTRATION = {
    type: 3,
    value: "FENESTRATION"
  };
  IfcBuiltSystemTypeEnum.FOUNDATION = {
    type: 3,
    value: "FOUNDATION"
  };
  IfcBuiltSystemTypeEnum.LOADBEARING = {
    type: 3,
    value: "LOADBEARING"
  };
  IfcBuiltSystemTypeEnum.MOORING = {
    type: 3,
    value: "MOORING"
  };
  IfcBuiltSystemTypeEnum.OUTERSHELL = {
    type: 3,
    value: "OUTERSHELL"
  };
  IfcBuiltSystemTypeEnum.PRESTRESSING = {
    type: 3,
    value: "PRESTRESSING"
  };
  IfcBuiltSystemTypeEnum.RAILWAYLINE = {
    type: 3,
    value: "RAILWAYLINE"
  };
  IfcBuiltSystemTypeEnum.RAILWAYTRACK = {
    type: 3,
    value: "RAILWAYTRACK"
  };
  IfcBuiltSystemTypeEnum.REINFORCING = {
    type: 3,
    value: "REINFORCING"
  };
  IfcBuiltSystemTypeEnum.SHADING = {
    type: 3,
    value: "SHADING"
  };
  IfcBuiltSystemTypeEnum.TRACKCIRCUIT = {
    type: 3,
    value: "TRACKCIRCUIT"
  };
  IfcBuiltSystemTypeEnum.TRANSPORT = {
    type: 3,
    value: "TRANSPORT"
  };
  IfcBuiltSystemTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBuiltSystemTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcBuiltSystemTypeEnum = IfcBuiltSystemTypeEnum;

  var IfcBurnerTypeEnum = function IfcBurnerTypeEnum() {
    _classCallCheck2(this, IfcBurnerTypeEnum);
  };

  IfcBurnerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBurnerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcBurnerTypeEnum = IfcBurnerTypeEnum;

  var IfcCableCarrierFittingTypeEnum = function IfcCableCarrierFittingTypeEnum() {
    _classCallCheck2(this, IfcCableCarrierFittingTypeEnum);
  };

  IfcCableCarrierFittingTypeEnum.BEND = {
    type: 3,
    value: "BEND"
  };
  IfcCableCarrierFittingTypeEnum.CONNECTOR = {
    type: 3,
    value: "CONNECTOR"
  };
  IfcCableCarrierFittingTypeEnum.CROSS = {
    type: 3,
    value: "CROSS"
  };
  IfcCableCarrierFittingTypeEnum.JUNCTION = {
    type: 3,
    value: "JUNCTION"
  };
  IfcCableCarrierFittingTypeEnum.TEE = {
    type: 3,
    value: "TEE"
  };
  IfcCableCarrierFittingTypeEnum.TRANSITION = {
    type: 3,
    value: "TRANSITION"
  };
  IfcCableCarrierFittingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCableCarrierFittingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;

  var IfcCableCarrierSegmentTypeEnum = function IfcCableCarrierSegmentTypeEnum() {
    _classCallCheck2(this, IfcCableCarrierSegmentTypeEnum);
  };

  IfcCableCarrierSegmentTypeEnum.CABLEBRACKET = {
    type: 3,
    value: "CABLEBRACKET"
  };
  IfcCableCarrierSegmentTypeEnum.CABLELADDERSEGMENT = {
    type: 3,
    value: "CABLELADDERSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.CABLETRAYSEGMENT = {
    type: 3,
    value: "CABLETRAYSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.CABLETRUNKINGSEGMENT = {
    type: 3,
    value: "CABLETRUNKINGSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.CATENARYWIRE = {
    type: 3,
    value: "CATENARYWIRE"
  };
  IfcCableCarrierSegmentTypeEnum.CONDUITSEGMENT = {
    type: 3,
    value: "CONDUITSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.DROPPER = {
    type: 3,
    value: "DROPPER"
  };
  IfcCableCarrierSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCableCarrierSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;

  var IfcCableFittingTypeEnum = function IfcCableFittingTypeEnum() {
    _classCallCheck2(this, IfcCableFittingTypeEnum);
  };

  IfcCableFittingTypeEnum.CONNECTOR = {
    type: 3,
    value: "CONNECTOR"
  };
  IfcCableFittingTypeEnum.ENTRY = {
    type: 3,
    value: "ENTRY"
  };
  IfcCableFittingTypeEnum.EXIT = {
    type: 3,
    value: "EXIT"
  };
  IfcCableFittingTypeEnum.FANOUT = {
    type: 3,
    value: "FANOUT"
  };
  IfcCableFittingTypeEnum.JUNCTION = {
    type: 3,
    value: "JUNCTION"
  };
  IfcCableFittingTypeEnum.TRANSITION = {
    type: 3,
    value: "TRANSITION"
  };
  IfcCableFittingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCableFittingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCableFittingTypeEnum = IfcCableFittingTypeEnum;

  var IfcCableSegmentTypeEnum = function IfcCableSegmentTypeEnum() {
    _classCallCheck2(this, IfcCableSegmentTypeEnum);
  };

  IfcCableSegmentTypeEnum.BUSBARSEGMENT = {
    type: 3,
    value: "BUSBARSEGMENT"
  };
  IfcCableSegmentTypeEnum.CABLESEGMENT = {
    type: 3,
    value: "CABLESEGMENT"
  };
  IfcCableSegmentTypeEnum.CONDUCTORSEGMENT = {
    type: 3,
    value: "CONDUCTORSEGMENT"
  };
  IfcCableSegmentTypeEnum.CONTACTWIRESEGMENT = {
    type: 3,
    value: "CONTACTWIRESEGMENT"
  };
  IfcCableSegmentTypeEnum.CORESEGMENT = {
    type: 3,
    value: "CORESEGMENT"
  };
  IfcCableSegmentTypeEnum.FIBERSEGMENT = {
    type: 3,
    value: "FIBERSEGMENT"
  };
  IfcCableSegmentTypeEnum.FIBERTUBE = {
    type: 3,
    value: "FIBERTUBE"
  };
  IfcCableSegmentTypeEnum.OPTICALCABLESEGMENT = {
    type: 3,
    value: "OPTICALCABLESEGMENT"
  };
  IfcCableSegmentTypeEnum.STITCHWIRE = {
    type: 3,
    value: "STITCHWIRE"
  };
  IfcCableSegmentTypeEnum.WIREPAIRSEGMENT = {
    type: 3,
    value: "WIREPAIRSEGMENT"
  };
  IfcCableSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCableSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;

  var IfcCaissonFoundationTypeEnum = function IfcCaissonFoundationTypeEnum() {
    _classCallCheck2(this, IfcCaissonFoundationTypeEnum);
  };

  IfcCaissonFoundationTypeEnum.CAISSON = {
    type: 3,
    value: "CAISSON"
  };
  IfcCaissonFoundationTypeEnum.WELL = {
    type: 3,
    value: "WELL"
  };
  IfcCaissonFoundationTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCaissonFoundationTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCaissonFoundationTypeEnum = IfcCaissonFoundationTypeEnum;

  var IfcChangeActionEnum = function IfcChangeActionEnum() {
    _classCallCheck2(this, IfcChangeActionEnum);
  };

  IfcChangeActionEnum.ADDED = {
    type: 3,
    value: "ADDED"
  };
  IfcChangeActionEnum.DELETED = {
    type: 3,
    value: "DELETED"
  };
  IfcChangeActionEnum.MODIFIED = {
    type: 3,
    value: "MODIFIED"
  };
  IfcChangeActionEnum.NOCHANGE = {
    type: 3,
    value: "NOCHANGE"
  };
  IfcChangeActionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcChangeActionEnum = IfcChangeActionEnum;

  var IfcChillerTypeEnum = function IfcChillerTypeEnum() {
    _classCallCheck2(this, IfcChillerTypeEnum);
  };

  IfcChillerTypeEnum.AIRCOOLED = {
    type: 3,
    value: "AIRCOOLED"
  };
  IfcChillerTypeEnum.HEATRECOVERY = {
    type: 3,
    value: "HEATRECOVERY"
  };
  IfcChillerTypeEnum.WATERCOOLED = {
    type: 3,
    value: "WATERCOOLED"
  };
  IfcChillerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcChillerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcChillerTypeEnum = IfcChillerTypeEnum;

  var IfcChimneyTypeEnum = function IfcChimneyTypeEnum() {
    _classCallCheck2(this, IfcChimneyTypeEnum);
  };

  IfcChimneyTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcChimneyTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcChimneyTypeEnum = IfcChimneyTypeEnum;

  var IfcCoilTypeEnum = function IfcCoilTypeEnum() {
    _classCallCheck2(this, IfcCoilTypeEnum);
  };

  IfcCoilTypeEnum.DXCOOLINGCOIL = {
    type: 3,
    value: "DXCOOLINGCOIL"
  };
  IfcCoilTypeEnum.ELECTRICHEATINGCOIL = {
    type: 3,
    value: "ELECTRICHEATINGCOIL"
  };
  IfcCoilTypeEnum.GASHEATINGCOIL = {
    type: 3,
    value: "GASHEATINGCOIL"
  };
  IfcCoilTypeEnum.HYDRONICCOIL = {
    type: 3,
    value: "HYDRONICCOIL"
  };
  IfcCoilTypeEnum.STEAMHEATINGCOIL = {
    type: 3,
    value: "STEAMHEATINGCOIL"
  };
  IfcCoilTypeEnum.WATERCOOLINGCOIL = {
    type: 3,
    value: "WATERCOOLINGCOIL"
  };
  IfcCoilTypeEnum.WATERHEATINGCOIL = {
    type: 3,
    value: "WATERHEATINGCOIL"
  };
  IfcCoilTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCoilTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCoilTypeEnum = IfcCoilTypeEnum;

  var IfcColumnTypeEnum = function IfcColumnTypeEnum() {
    _classCallCheck2(this, IfcColumnTypeEnum);
  };

  IfcColumnTypeEnum.COLUMN = {
    type: 3,
    value: "COLUMN"
  };
  IfcColumnTypeEnum.PIERSTEM = {
    type: 3,
    value: "PIERSTEM"
  };
  IfcColumnTypeEnum.PIERSTEM_SEGMENT = {
    type: 3,
    value: "PIERSTEM_SEGMENT"
  };
  IfcColumnTypeEnum.PILASTER = {
    type: 3,
    value: "PILASTER"
  };
  IfcColumnTypeEnum.STANDCOLUMN = {
    type: 3,
    value: "STANDCOLUMN"
  };
  IfcColumnTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcColumnTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcColumnTypeEnum = IfcColumnTypeEnum;

  var IfcCommunicationsApplianceTypeEnum = function IfcCommunicationsApplianceTypeEnum() {
    _classCallCheck2(this, IfcCommunicationsApplianceTypeEnum);
  };

  IfcCommunicationsApplianceTypeEnum.ANTENNA = {
    type: 3,
    value: "ANTENNA"
  };
  IfcCommunicationsApplianceTypeEnum.AUTOMATON = {
    type: 3,
    value: "AUTOMATON"
  };
  IfcCommunicationsApplianceTypeEnum.COMPUTER = {
    type: 3,
    value: "COMPUTER"
  };
  IfcCommunicationsApplianceTypeEnum.FAX = {
    type: 3,
    value: "FAX"
  };
  IfcCommunicationsApplianceTypeEnum.GATEWAY = {
    type: 3,
    value: "GATEWAY"
  };
  IfcCommunicationsApplianceTypeEnum.INTELLIGENTPERIPHERAL = {
    type: 3,
    value: "INTELLIGENTPERIPHERAL"
  };
  IfcCommunicationsApplianceTypeEnum.IPNETWORKEQUIPMENT = {
    type: 3,
    value: "IPNETWORKEQUIPMENT"
  };
  IfcCommunicationsApplianceTypeEnum.LINESIDEELECTRONICUNIT = {
    type: 3,
    value: "LINESIDEELECTRONICUNIT"
  };
  IfcCommunicationsApplianceTypeEnum.MODEM = {
    type: 3,
    value: "MODEM"
  };
  IfcCommunicationsApplianceTypeEnum.NETWORKAPPLIANCE = {
    type: 3,
    value: "NETWORKAPPLIANCE"
  };
  IfcCommunicationsApplianceTypeEnum.NETWORKBRIDGE = {
    type: 3,
    value: "NETWORKBRIDGE"
  };
  IfcCommunicationsApplianceTypeEnum.NETWORKHUB = {
    type: 3,
    value: "NETWORKHUB"
  };
  IfcCommunicationsApplianceTypeEnum.OPTICALLINETERMINAL = {
    type: 3,
    value: "OPTICALLINETERMINAL"
  };
  IfcCommunicationsApplianceTypeEnum.OPTICALNETWORKUNIT = {
    type: 3,
    value: "OPTICALNETWORKUNIT"
  };
  IfcCommunicationsApplianceTypeEnum.PRINTER = {
    type: 3,
    value: "PRINTER"
  };
  IfcCommunicationsApplianceTypeEnum.RADIOBLOCKCENTER = {
    type: 3,
    value: "RADIOBLOCKCENTER"
  };
  IfcCommunicationsApplianceTypeEnum.REPEATER = {
    type: 3,
    value: "REPEATER"
  };
  IfcCommunicationsApplianceTypeEnum.ROUTER = {
    type: 3,
    value: "ROUTER"
  };
  IfcCommunicationsApplianceTypeEnum.SCANNER = {
    type: 3,
    value: "SCANNER"
  };
  IfcCommunicationsApplianceTypeEnum.TELECOMMAND = {
    type: 3,
    value: "TELECOMMAND"
  };
  IfcCommunicationsApplianceTypeEnum.TELEPHONYEXCHANGE = {
    type: 3,
    value: "TELEPHONYEXCHANGE"
  };
  IfcCommunicationsApplianceTypeEnum.TRANSITIONCOMPONENT = {
    type: 3,
    value: "TRANSITIONCOMPONENT"
  };
  IfcCommunicationsApplianceTypeEnum.TRANSPONDER = {
    type: 3,
    value: "TRANSPONDER"
  };
  IfcCommunicationsApplianceTypeEnum.TRANSPORTEQUIPMENT = {
    type: 3,
    value: "TRANSPORTEQUIPMENT"
  };
  IfcCommunicationsApplianceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCommunicationsApplianceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCommunicationsApplianceTypeEnum = IfcCommunicationsApplianceTypeEnum;

  var IfcComplexPropertyTemplateTypeEnum = function IfcComplexPropertyTemplateTypeEnum() {
    _classCallCheck2(this, IfcComplexPropertyTemplateTypeEnum);
  };

  IfcComplexPropertyTemplateTypeEnum.P_COMPLEX = {
    type: 3,
    value: "P_COMPLEX"
  };
  IfcComplexPropertyTemplateTypeEnum.Q_COMPLEX = {
    type: 3,
    value: "Q_COMPLEX"
  };
  IFC4_32.IfcComplexPropertyTemplateTypeEnum = IfcComplexPropertyTemplateTypeEnum;

  var IfcCompressorTypeEnum = function IfcCompressorTypeEnum() {
    _classCallCheck2(this, IfcCompressorTypeEnum);
  };

  IfcCompressorTypeEnum.BOOSTER = {
    type: 3,
    value: "BOOSTER"
  };
  IfcCompressorTypeEnum.DYNAMIC = {
    type: 3,
    value: "DYNAMIC"
  };
  IfcCompressorTypeEnum.HERMETIC = {
    type: 3,
    value: "HERMETIC"
  };
  IfcCompressorTypeEnum.OPENTYPE = {
    type: 3,
    value: "OPENTYPE"
  };
  IfcCompressorTypeEnum.RECIPROCATING = {
    type: 3,
    value: "RECIPROCATING"
  };
  IfcCompressorTypeEnum.ROLLINGPISTON = {
    type: 3,
    value: "ROLLINGPISTON"
  };
  IfcCompressorTypeEnum.ROTARY = {
    type: 3,
    value: "ROTARY"
  };
  IfcCompressorTypeEnum.ROTARYVANE = {
    type: 3,
    value: "ROTARYVANE"
  };
  IfcCompressorTypeEnum.SCROLL = {
    type: 3,
    value: "SCROLL"
  };
  IfcCompressorTypeEnum.SEMIHERMETIC = {
    type: 3,
    value: "SEMIHERMETIC"
  };
  IfcCompressorTypeEnum.SINGLESCREW = {
    type: 3,
    value: "SINGLESCREW"
  };
  IfcCompressorTypeEnum.SINGLESTAGE = {
    type: 3,
    value: "SINGLESTAGE"
  };
  IfcCompressorTypeEnum.TROCHOIDAL = {
    type: 3,
    value: "TROCHOIDAL"
  };
  IfcCompressorTypeEnum.TWINSCREW = {
    type: 3,
    value: "TWINSCREW"
  };
  IfcCompressorTypeEnum.WELDEDSHELLHERMETIC = {
    type: 3,
    value: "WELDEDSHELLHERMETIC"
  };
  IfcCompressorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCompressorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCompressorTypeEnum = IfcCompressorTypeEnum;

  var IfcCondenserTypeEnum = function IfcCondenserTypeEnum() {
    _classCallCheck2(this, IfcCondenserTypeEnum);
  };

  IfcCondenserTypeEnum.AIRCOOLED = {
    type: 3,
    value: "AIRCOOLED"
  };
  IfcCondenserTypeEnum.EVAPORATIVECOOLED = {
    type: 3,
    value: "EVAPORATIVECOOLED"
  };
  IfcCondenserTypeEnum.WATERCOOLED = {
    type: 3,
    value: "WATERCOOLED"
  };
  IfcCondenserTypeEnum.WATERCOOLEDBRAZEDPLATE = {
    type: 3,
    value: "WATERCOOLEDBRAZEDPLATE"
  };
  IfcCondenserTypeEnum.WATERCOOLEDSHELLCOIL = {
    type: 3,
    value: "WATERCOOLEDSHELLCOIL"
  };
  IfcCondenserTypeEnum.WATERCOOLEDSHELLTUBE = {
    type: 3,
    value: "WATERCOOLEDSHELLTUBE"
  };
  IfcCondenserTypeEnum.WATERCOOLEDTUBEINTUBE = {
    type: 3,
    value: "WATERCOOLEDTUBEINTUBE"
  };
  IfcCondenserTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCondenserTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCondenserTypeEnum = IfcCondenserTypeEnum;

  var IfcConnectionTypeEnum = function IfcConnectionTypeEnum() {
    _classCallCheck2(this, IfcConnectionTypeEnum);
  };

  IfcConnectionTypeEnum.ATEND = {
    type: 3,
    value: "ATEND"
  };
  IfcConnectionTypeEnum.ATPATH = {
    type: 3,
    value: "ATPATH"
  };
  IfcConnectionTypeEnum.ATSTART = {
    type: 3,
    value: "ATSTART"
  };
  IfcConnectionTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcConnectionTypeEnum = IfcConnectionTypeEnum;

  var IfcConstraintEnum = function IfcConstraintEnum() {
    _classCallCheck2(this, IfcConstraintEnum);
  };

  IfcConstraintEnum.ADVISORY = {
    type: 3,
    value: "ADVISORY"
  };
  IfcConstraintEnum.HARD = {
    type: 3,
    value: "HARD"
  };
  IfcConstraintEnum.SOFT = {
    type: 3,
    value: "SOFT"
  };
  IfcConstraintEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcConstraintEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcConstraintEnum = IfcConstraintEnum;

  var IfcConstructionEquipmentResourceTypeEnum = function IfcConstructionEquipmentResourceTypeEnum() {
    _classCallCheck2(this, IfcConstructionEquipmentResourceTypeEnum);
  };

  IfcConstructionEquipmentResourceTypeEnum.DEMOLISHING = {
    type: 3,
    value: "DEMOLISHING"
  };
  IfcConstructionEquipmentResourceTypeEnum.EARTHMOVING = {
    type: 3,
    value: "EARTHMOVING"
  };
  IfcConstructionEquipmentResourceTypeEnum.ERECTING = {
    type: 3,
    value: "ERECTING"
  };
  IfcConstructionEquipmentResourceTypeEnum.HEATING = {
    type: 3,
    value: "HEATING"
  };
  IfcConstructionEquipmentResourceTypeEnum.LIGHTING = {
    type: 3,
    value: "LIGHTING"
  };
  IfcConstructionEquipmentResourceTypeEnum.PAVING = {
    type: 3,
    value: "PAVING"
  };
  IfcConstructionEquipmentResourceTypeEnum.PUMPING = {
    type: 3,
    value: "PUMPING"
  };
  IfcConstructionEquipmentResourceTypeEnum.TRANSPORTING = {
    type: 3,
    value: "TRANSPORTING"
  };
  IfcConstructionEquipmentResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcConstructionEquipmentResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcConstructionEquipmentResourceTypeEnum = IfcConstructionEquipmentResourceTypeEnum;

  var IfcConstructionMaterialResourceTypeEnum = function IfcConstructionMaterialResourceTypeEnum() {
    _classCallCheck2(this, IfcConstructionMaterialResourceTypeEnum);
  };

  IfcConstructionMaterialResourceTypeEnum.AGGREGATES = {
    type: 3,
    value: "AGGREGATES"
  };
  IfcConstructionMaterialResourceTypeEnum.CONCRETE = {
    type: 3,
    value: "CONCRETE"
  };
  IfcConstructionMaterialResourceTypeEnum.DRYWALL = {
    type: 3,
    value: "DRYWALL"
  };
  IfcConstructionMaterialResourceTypeEnum.FUEL = {
    type: 3,
    value: "FUEL"
  };
  IfcConstructionMaterialResourceTypeEnum.GYPSUM = {
    type: 3,
    value: "GYPSUM"
  };
  IfcConstructionMaterialResourceTypeEnum.MASONRY = {
    type: 3,
    value: "MASONRY"
  };
  IfcConstructionMaterialResourceTypeEnum.METAL = {
    type: 3,
    value: "METAL"
  };
  IfcConstructionMaterialResourceTypeEnum.PLASTIC = {
    type: 3,
    value: "PLASTIC"
  };
  IfcConstructionMaterialResourceTypeEnum.WOOD = {
    type: 3,
    value: "WOOD"
  };
  IfcConstructionMaterialResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcConstructionMaterialResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcConstructionMaterialResourceTypeEnum = IfcConstructionMaterialResourceTypeEnum;

  var IfcConstructionProductResourceTypeEnum = function IfcConstructionProductResourceTypeEnum() {
    _classCallCheck2(this, IfcConstructionProductResourceTypeEnum);
  };

  IfcConstructionProductResourceTypeEnum.ASSEMBLY = {
    type: 3,
    value: "ASSEMBLY"
  };
  IfcConstructionProductResourceTypeEnum.FORMWORK = {
    type: 3,
    value: "FORMWORK"
  };
  IfcConstructionProductResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcConstructionProductResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcConstructionProductResourceTypeEnum = IfcConstructionProductResourceTypeEnum;

  var IfcControllerTypeEnum = function IfcControllerTypeEnum() {
    _classCallCheck2(this, IfcControllerTypeEnum);
  };

  IfcControllerTypeEnum.FLOATING = {
    type: 3,
    value: "FLOATING"
  };
  IfcControllerTypeEnum.MULTIPOSITION = {
    type: 3,
    value: "MULTIPOSITION"
  };
  IfcControllerTypeEnum.PROGRAMMABLE = {
    type: 3,
    value: "PROGRAMMABLE"
  };
  IfcControllerTypeEnum.PROPORTIONAL = {
    type: 3,
    value: "PROPORTIONAL"
  };
  IfcControllerTypeEnum.TWOPOSITION = {
    type: 3,
    value: "TWOPOSITION"
  };
  IfcControllerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcControllerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcControllerTypeEnum = IfcControllerTypeEnum;

  var IfcConveyorSegmentTypeEnum = function IfcConveyorSegmentTypeEnum() {
    _classCallCheck2(this, IfcConveyorSegmentTypeEnum);
  };

  IfcConveyorSegmentTypeEnum.BELTCONVEYOR = {
    type: 3,
    value: "BELTCONVEYOR"
  };
  IfcConveyorSegmentTypeEnum.BUCKETCONVEYOR = {
    type: 3,
    value: "BUCKETCONVEYOR"
  };
  IfcConveyorSegmentTypeEnum.CHUTECONVEYOR = {
    type: 3,
    value: "CHUTECONVEYOR"
  };
  IfcConveyorSegmentTypeEnum.SCREWCONVEYOR = {
    type: 3,
    value: "SCREWCONVEYOR"
  };
  IfcConveyorSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcConveyorSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcConveyorSegmentTypeEnum = IfcConveyorSegmentTypeEnum;

  var IfcCooledBeamTypeEnum = function IfcCooledBeamTypeEnum() {
    _classCallCheck2(this, IfcCooledBeamTypeEnum);
  };

  IfcCooledBeamTypeEnum.ACTIVE = {
    type: 3,
    value: "ACTIVE"
  };
  IfcCooledBeamTypeEnum.PASSIVE = {
    type: 3,
    value: "PASSIVE"
  };
  IfcCooledBeamTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCooledBeamTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;

  var IfcCoolingTowerTypeEnum = function IfcCoolingTowerTypeEnum() {
    _classCallCheck2(this, IfcCoolingTowerTypeEnum);
  };

  IfcCoolingTowerTypeEnum.MECHANICALFORCEDDRAFT = {
    type: 3,
    value: "MECHANICALFORCEDDRAFT"
  };
  IfcCoolingTowerTypeEnum.MECHANICALINDUCEDDRAFT = {
    type: 3,
    value: "MECHANICALINDUCEDDRAFT"
  };
  IfcCoolingTowerTypeEnum.NATURALDRAFT = {
    type: 3,
    value: "NATURALDRAFT"
  };
  IfcCoolingTowerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCoolingTowerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;

  var IfcCostItemTypeEnum = function IfcCostItemTypeEnum() {
    _classCallCheck2(this, IfcCostItemTypeEnum);
  };

  IfcCostItemTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCostItemTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCostItemTypeEnum = IfcCostItemTypeEnum;

  var IfcCostScheduleTypeEnum = function IfcCostScheduleTypeEnum() {
    _classCallCheck2(this, IfcCostScheduleTypeEnum);
  };

  IfcCostScheduleTypeEnum.BUDGET = {
    type: 3,
    value: "BUDGET"
  };
  IfcCostScheduleTypeEnum.COSTPLAN = {
    type: 3,
    value: "COSTPLAN"
  };
  IfcCostScheduleTypeEnum.ESTIMATE = {
    type: 3,
    value: "ESTIMATE"
  };
  IfcCostScheduleTypeEnum.PRICEDBILLOFQUANTITIES = {
    type: 3,
    value: "PRICEDBILLOFQUANTITIES"
  };
  IfcCostScheduleTypeEnum.SCHEDULEOFRATES = {
    type: 3,
    value: "SCHEDULEOFRATES"
  };
  IfcCostScheduleTypeEnum.TENDER = {
    type: 3,
    value: "TENDER"
  };
  IfcCostScheduleTypeEnum.UNPRICEDBILLOFQUANTITIES = {
    type: 3,
    value: "UNPRICEDBILLOFQUANTITIES"
  };
  IfcCostScheduleTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCostScheduleTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;

  var IfcCourseTypeEnum = function IfcCourseTypeEnum() {
    _classCallCheck2(this, IfcCourseTypeEnum);
  };

  IfcCourseTypeEnum.ARMOUR = {
    type: 3,
    value: "ARMOUR"
  };
  IfcCourseTypeEnum.BALLASTBED = {
    type: 3,
    value: "BALLASTBED"
  };
  IfcCourseTypeEnum.CORE = {
    type: 3,
    value: "CORE"
  };
  IfcCourseTypeEnum.FILTER = {
    type: 3,
    value: "FILTER"
  };
  IfcCourseTypeEnum.PAVEMENT = {
    type: 3,
    value: "PAVEMENT"
  };
  IfcCourseTypeEnum.PROTECTION = {
    type: 3,
    value: "PROTECTION"
  };
  IfcCourseTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCourseTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCourseTypeEnum = IfcCourseTypeEnum;

  var IfcCoveringTypeEnum = function IfcCoveringTypeEnum() {
    _classCallCheck2(this, IfcCoveringTypeEnum);
  };

  IfcCoveringTypeEnum.CEILING = {
    type: 3,
    value: "CEILING"
  };
  IfcCoveringTypeEnum.CLADDING = {
    type: 3,
    value: "CLADDING"
  };
  IfcCoveringTypeEnum.COPING = {
    type: 3,
    value: "COPING"
  };
  IfcCoveringTypeEnum.FLOORING = {
    type: 3,
    value: "FLOORING"
  };
  IfcCoveringTypeEnum.INSULATION = {
    type: 3,
    value: "INSULATION"
  };
  IfcCoveringTypeEnum.MEMBRANE = {
    type: 3,
    value: "MEMBRANE"
  };
  IfcCoveringTypeEnum.MOLDING = {
    type: 3,
    value: "MOLDING"
  };
  IfcCoveringTypeEnum.ROOFING = {
    type: 3,
    value: "ROOFING"
  };
  IfcCoveringTypeEnum.SKIRTINGBOARD = {
    type: 3,
    value: "SKIRTINGBOARD"
  };
  IfcCoveringTypeEnum.SLEEVING = {
    type: 3,
    value: "SLEEVING"
  };
  IfcCoveringTypeEnum.TOPPING = {
    type: 3,
    value: "TOPPING"
  };
  IfcCoveringTypeEnum.WRAPPING = {
    type: 3,
    value: "WRAPPING"
  };
  IfcCoveringTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCoveringTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCoveringTypeEnum = IfcCoveringTypeEnum;

  var IfcCrewResourceTypeEnum = function IfcCrewResourceTypeEnum() {
    _classCallCheck2(this, IfcCrewResourceTypeEnum);
  };

  IfcCrewResourceTypeEnum.OFFICE = {
    type: 3,
    value: "OFFICE"
  };
  IfcCrewResourceTypeEnum.SITE = {
    type: 3,
    value: "SITE"
  };
  IfcCrewResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCrewResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCrewResourceTypeEnum = IfcCrewResourceTypeEnum;

  var IfcCurtainWallTypeEnum = function IfcCurtainWallTypeEnum() {
    _classCallCheck2(this, IfcCurtainWallTypeEnum);
  };

  IfcCurtainWallTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCurtainWallTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;

  var IfcCurveInterpolationEnum = function IfcCurveInterpolationEnum() {
    _classCallCheck2(this, IfcCurveInterpolationEnum);
  };

  IfcCurveInterpolationEnum.LINEAR = {
    type: 3,
    value: "LINEAR"
  };
  IfcCurveInterpolationEnum.LOG_LINEAR = {
    type: 3,
    value: "LOG_LINEAR"
  };
  IfcCurveInterpolationEnum.LOG_LOG = {
    type: 3,
    value: "LOG_LOG"
  };
  IfcCurveInterpolationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcCurveInterpolationEnum = IfcCurveInterpolationEnum;

  var IfcDamperTypeEnum = function IfcDamperTypeEnum() {
    _classCallCheck2(this, IfcDamperTypeEnum);
  };

  IfcDamperTypeEnum.BACKDRAFTDAMPER = {
    type: 3,
    value: "BACKDRAFTDAMPER"
  };
  IfcDamperTypeEnum.BALANCINGDAMPER = {
    type: 3,
    value: "BALANCINGDAMPER"
  };
  IfcDamperTypeEnum.BLASTDAMPER = {
    type: 3,
    value: "BLASTDAMPER"
  };
  IfcDamperTypeEnum.CONTROLDAMPER = {
    type: 3,
    value: "CONTROLDAMPER"
  };
  IfcDamperTypeEnum.FIREDAMPER = {
    type: 3,
    value: "FIREDAMPER"
  };
  IfcDamperTypeEnum.FIRESMOKEDAMPER = {
    type: 3,
    value: "FIRESMOKEDAMPER"
  };
  IfcDamperTypeEnum.FUMEHOODEXHAUST = {
    type: 3,
    value: "FUMEHOODEXHAUST"
  };
  IfcDamperTypeEnum.GRAVITYDAMPER = {
    type: 3,
    value: "GRAVITYDAMPER"
  };
  IfcDamperTypeEnum.GRAVITYRELIEFDAMPER = {
    type: 3,
    value: "GRAVITYRELIEFDAMPER"
  };
  IfcDamperTypeEnum.RELIEFDAMPER = {
    type: 3,
    value: "RELIEFDAMPER"
  };
  IfcDamperTypeEnum.SMOKEDAMPER = {
    type: 3,
    value: "SMOKEDAMPER"
  };
  IfcDamperTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDamperTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDamperTypeEnum = IfcDamperTypeEnum;

  var IfcDataOriginEnum = function IfcDataOriginEnum() {
    _classCallCheck2(this, IfcDataOriginEnum);
  };

  IfcDataOriginEnum.MEASURED = {
    type: 3,
    value: "MEASURED"
  };
  IfcDataOriginEnum.PREDICTED = {
    type: 3,
    value: "PREDICTED"
  };
  IfcDataOriginEnum.SIMULATED = {
    type: 3,
    value: "SIMULATED"
  };
  IfcDataOriginEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDataOriginEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDataOriginEnum = IfcDataOriginEnum;

  var IfcDerivedUnitEnum = function IfcDerivedUnitEnum() {
    _classCallCheck2(this, IfcDerivedUnitEnum);
  };

  IfcDerivedUnitEnum.ACCELERATIONUNIT = {
    type: 3,
    value: "ACCELERATIONUNIT"
  };
  IfcDerivedUnitEnum.ANGULARVELOCITYUNIT = {
    type: 3,
    value: "ANGULARVELOCITYUNIT"
  };
  IfcDerivedUnitEnum.AREADENSITYUNIT = {
    type: 3,
    value: "AREADENSITYUNIT"
  };
  IfcDerivedUnitEnum.COMPOUNDPLANEANGLEUNIT = {
    type: 3,
    value: "COMPOUNDPLANEANGLEUNIT"
  };
  IfcDerivedUnitEnum.CURVATUREUNIT = {
    type: 3,
    value: "CURVATUREUNIT"
  };
  IfcDerivedUnitEnum.DYNAMICVISCOSITYUNIT = {
    type: 3,
    value: "DYNAMICVISCOSITYUNIT"
  };
  IfcDerivedUnitEnum.HEATFLUXDENSITYUNIT = {
    type: 3,
    value: "HEATFLUXDENSITYUNIT"
  };
  IfcDerivedUnitEnum.HEATINGVALUEUNIT = {
    type: 3,
    value: "HEATINGVALUEUNIT"
  };
  IfcDerivedUnitEnum.INTEGERCOUNTRATEUNIT = {
    type: 3,
    value: "INTEGERCOUNTRATEUNIT"
  };
  IfcDerivedUnitEnum.IONCONCENTRATIONUNIT = {
    type: 3,
    value: "IONCONCENTRATIONUNIT"
  };
  IfcDerivedUnitEnum.ISOTHERMALMOISTURECAPACITYUNIT = {
    type: 3,
    value: "ISOTHERMALMOISTURECAPACITYUNIT"
  };
  IfcDerivedUnitEnum.KINEMATICVISCOSITYUNIT = {
    type: 3,
    value: "KINEMATICVISCOSITYUNIT"
  };
  IfcDerivedUnitEnum.LINEARFORCEUNIT = {
    type: 3,
    value: "LINEARFORCEUNIT"
  };
  IfcDerivedUnitEnum.LINEARMOMENTUNIT = {
    type: 3,
    value: "LINEARMOMENTUNIT"
  };
  IfcDerivedUnitEnum.LINEARSTIFFNESSUNIT = {
    type: 3,
    value: "LINEARSTIFFNESSUNIT"
  };
  IfcDerivedUnitEnum.LINEARVELOCITYUNIT = {
    type: 3,
    value: "LINEARVELOCITYUNIT"
  };
  IfcDerivedUnitEnum.LUMINOUSINTENSITYDISTRIBUTIONUNIT = {
    type: 3,
    value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT"
  };
  IfcDerivedUnitEnum.MASSDENSITYUNIT = {
    type: 3,
    value: "MASSDENSITYUNIT"
  };
  IfcDerivedUnitEnum.MASSFLOWRATEUNIT = {
    type: 3,
    value: "MASSFLOWRATEUNIT"
  };
  IfcDerivedUnitEnum.MASSPERLENGTHUNIT = {
    type: 3,
    value: "MASSPERLENGTHUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFELASTICITYUNIT = {
    type: 3,
    value: "MODULUSOFELASTICITYUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFLINEARSUBGRADEREACTIONUNIT = {
    type: 3,
    value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = {
    type: 3,
    value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFSUBGRADEREACTIONUNIT = {
    type: 3,
    value: "MODULUSOFSUBGRADEREACTIONUNIT"
  };
  IfcDerivedUnitEnum.MOISTUREDIFFUSIVITYUNIT = {
    type: 3,
    value: "MOISTUREDIFFUSIVITYUNIT"
  };
  IfcDerivedUnitEnum.MOLECULARWEIGHTUNIT = {
    type: 3,
    value: "MOLECULARWEIGHTUNIT"
  };
  IfcDerivedUnitEnum.MOMENTOFINERTIAUNIT = {
    type: 3,
    value: "MOMENTOFINERTIAUNIT"
  };
  IfcDerivedUnitEnum.PHUNIT = {
    type: 3,
    value: "PHUNIT"
  };
  IfcDerivedUnitEnum.PLANARFORCEUNIT = {
    type: 3,
    value: "PLANARFORCEUNIT"
  };
  IfcDerivedUnitEnum.ROTATIONALFREQUENCYUNIT = {
    type: 3,
    value: "ROTATIONALFREQUENCYUNIT"
  };
  IfcDerivedUnitEnum.ROTATIONALMASSUNIT = {
    type: 3,
    value: "ROTATIONALMASSUNIT"
  };
  IfcDerivedUnitEnum.ROTATIONALSTIFFNESSUNIT = {
    type: 3,
    value: "ROTATIONALSTIFFNESSUNIT"
  };
  IfcDerivedUnitEnum.SECTIONAREAINTEGRALUNIT = {
    type: 3,
    value: "SECTIONAREAINTEGRALUNIT"
  };
  IfcDerivedUnitEnum.SECTIONMODULUSUNIT = {
    type: 3,
    value: "SECTIONMODULUSUNIT"
  };
  IfcDerivedUnitEnum.SHEARMODULUSUNIT = {
    type: 3,
    value: "SHEARMODULUSUNIT"
  };
  IfcDerivedUnitEnum.SOUNDPOWERLEVELUNIT = {
    type: 3,
    value: "SOUNDPOWERLEVELUNIT"
  };
  IfcDerivedUnitEnum.SOUNDPOWERUNIT = {
    type: 3,
    value: "SOUNDPOWERUNIT"
  };
  IfcDerivedUnitEnum.SOUNDPRESSURELEVELUNIT = {
    type: 3,
    value: "SOUNDPRESSURELEVELUNIT"
  };
  IfcDerivedUnitEnum.SOUNDPRESSUREUNIT = {
    type: 3,
    value: "SOUNDPRESSUREUNIT"
  };
  IfcDerivedUnitEnum.SPECIFICHEATCAPACITYUNIT = {
    type: 3,
    value: "SPECIFICHEATCAPACITYUNIT"
  };
  IfcDerivedUnitEnum.TEMPERATUREGRADIENTUNIT = {
    type: 3,
    value: "TEMPERATUREGRADIENTUNIT"
  };
  IfcDerivedUnitEnum.TEMPERATURERATEOFCHANGEUNIT = {
    type: 3,
    value: "TEMPERATURERATEOFCHANGEUNIT"
  };
  IfcDerivedUnitEnum.THERMALADMITTANCEUNIT = {
    type: 3,
    value: "THERMALADMITTANCEUNIT"
  };
  IfcDerivedUnitEnum.THERMALCONDUCTANCEUNIT = {
    type: 3,
    value: "THERMALCONDUCTANCEUNIT"
  };
  IfcDerivedUnitEnum.THERMALEXPANSIONCOEFFICIENTUNIT = {
    type: 3,
    value: "THERMALEXPANSIONCOEFFICIENTUNIT"
  };
  IfcDerivedUnitEnum.THERMALRESISTANCEUNIT = {
    type: 3,
    value: "THERMALRESISTANCEUNIT"
  };
  IfcDerivedUnitEnum.THERMALTRANSMITTANCEUNIT = {
    type: 3,
    value: "THERMALTRANSMITTANCEUNIT"
  };
  IfcDerivedUnitEnum.TORQUEUNIT = {
    type: 3,
    value: "TORQUEUNIT"
  };
  IfcDerivedUnitEnum.VAPORPERMEABILITYUNIT = {
    type: 3,
    value: "VAPORPERMEABILITYUNIT"
  };
  IfcDerivedUnitEnum.VOLUMETRICFLOWRATEUNIT = {
    type: 3,
    value: "VOLUMETRICFLOWRATEUNIT"
  };
  IfcDerivedUnitEnum.WARPINGCONSTANTUNIT = {
    type: 3,
    value: "WARPINGCONSTANTUNIT"
  };
  IfcDerivedUnitEnum.WARPINGMOMENTUNIT = {
    type: 3,
    value: "WARPINGMOMENTUNIT"
  };
  IfcDerivedUnitEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC4_32.IfcDerivedUnitEnum = IfcDerivedUnitEnum;

  var IfcDirectionSenseEnum = function IfcDirectionSenseEnum() {
    _classCallCheck2(this, IfcDirectionSenseEnum);
  };

  IfcDirectionSenseEnum.NEGATIVE = {
    type: 3,
    value: "NEGATIVE"
  };
  IfcDirectionSenseEnum.POSITIVE = {
    type: 3,
    value: "POSITIVE"
  };
  IFC4_32.IfcDirectionSenseEnum = IfcDirectionSenseEnum;

  var IfcDiscreteAccessoryTypeEnum = function IfcDiscreteAccessoryTypeEnum() {
    _classCallCheck2(this, IfcDiscreteAccessoryTypeEnum);
  };

  IfcDiscreteAccessoryTypeEnum.ANCHORPLATE = {
    type: 3,
    value: "ANCHORPLATE"
  };
  IfcDiscreteAccessoryTypeEnum.BIRDPROTECTION = {
    type: 3,
    value: "BIRDPROTECTION"
  };
  IfcDiscreteAccessoryTypeEnum.BRACKET = {
    type: 3,
    value: "BRACKET"
  };
  IfcDiscreteAccessoryTypeEnum.CABLEARRANGER = {
    type: 3,
    value: "CABLEARRANGER"
  };
  IfcDiscreteAccessoryTypeEnum.ELASTIC_CUSHION = {
    type: 3,
    value: "ELASTIC_CUSHION"
  };
  IfcDiscreteAccessoryTypeEnum.EXPANSION_JOINT_DEVICE = {
    type: 3,
    value: "EXPANSION_JOINT_DEVICE"
  };
  IfcDiscreteAccessoryTypeEnum.FILLER = {
    type: 3,
    value: "FILLER"
  };
  IfcDiscreteAccessoryTypeEnum.FLASHING = {
    type: 3,
    value: "FLASHING"
  };
  IfcDiscreteAccessoryTypeEnum.INSULATOR = {
    type: 3,
    value: "INSULATOR"
  };
  IfcDiscreteAccessoryTypeEnum.LOCK = {
    type: 3,
    value: "LOCK"
  };
  IfcDiscreteAccessoryTypeEnum.PANEL_STRENGTHENING = {
    type: 3,
    value: "PANEL_STRENGTHENING"
  };
  IfcDiscreteAccessoryTypeEnum.POINTMACHINEMOUNTINGDEVICE = {
    type: 3,
    value: "POINTMACHINEMOUNTINGDEVICE"
  };
  IfcDiscreteAccessoryTypeEnum.POINT_MACHINE_LOCKING_DEVICE = {
    type: 3,
    value: "POINT_MACHINE_LOCKING_DEVICE"
  };
  IfcDiscreteAccessoryTypeEnum.RAILBRACE = {
    type: 3,
    value: "RAILBRACE"
  };
  IfcDiscreteAccessoryTypeEnum.RAILPAD = {
    type: 3,
    value: "RAILPAD"
  };
  IfcDiscreteAccessoryTypeEnum.RAIL_LUBRICATION = {
    type: 3,
    value: "RAIL_LUBRICATION"
  };
  IfcDiscreteAccessoryTypeEnum.RAIL_MECHANICAL_EQUIPMENT = {
    type: 3,
    value: "RAIL_MECHANICAL_EQUIPMENT"
  };
  IfcDiscreteAccessoryTypeEnum.SHOE = {
    type: 3,
    value: "SHOE"
  };
  IfcDiscreteAccessoryTypeEnum.SLIDINGCHAIR = {
    type: 3,
    value: "SLIDINGCHAIR"
  };
  IfcDiscreteAccessoryTypeEnum.SOUNDABSORPTION = {
    type: 3,
    value: "SOUNDABSORPTION"
  };
  IfcDiscreteAccessoryTypeEnum.TENSIONINGEQUIPMENT = {
    type: 3,
    value: "TENSIONINGEQUIPMENT"
  };
  IfcDiscreteAccessoryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDiscreteAccessoryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDiscreteAccessoryTypeEnum = IfcDiscreteAccessoryTypeEnum;

  var IfcDistributionBoardTypeEnum = function IfcDistributionBoardTypeEnum() {
    _classCallCheck2(this, IfcDistributionBoardTypeEnum);
  };

  IfcDistributionBoardTypeEnum.CONSUMERUNIT = {
    type: 3,
    value: "CONSUMERUNIT"
  };
  IfcDistributionBoardTypeEnum.DISPATCHINGBOARD = {
    type: 3,
    value: "DISPATCHINGBOARD"
  };
  IfcDistributionBoardTypeEnum.DISTRIBUTIONBOARD = {
    type: 3,
    value: "DISTRIBUTIONBOARD"
  };
  IfcDistributionBoardTypeEnum.DISTRIBUTIONFRAME = {
    type: 3,
    value: "DISTRIBUTIONFRAME"
  };
  IfcDistributionBoardTypeEnum.MOTORCONTROLCENTRE = {
    type: 3,
    value: "MOTORCONTROLCENTRE"
  };
  IfcDistributionBoardTypeEnum.SWITCHBOARD = {
    type: 3,
    value: "SWITCHBOARD"
  };
  IfcDistributionBoardTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDistributionBoardTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDistributionBoardTypeEnum = IfcDistributionBoardTypeEnum;

  var IfcDistributionChamberElementTypeEnum = function IfcDistributionChamberElementTypeEnum() {
    _classCallCheck2(this, IfcDistributionChamberElementTypeEnum);
  };

  IfcDistributionChamberElementTypeEnum.FORMEDDUCT = {
    type: 3,
    value: "FORMEDDUCT"
  };
  IfcDistributionChamberElementTypeEnum.INSPECTIONCHAMBER = {
    type: 3,
    value: "INSPECTIONCHAMBER"
  };
  IfcDistributionChamberElementTypeEnum.INSPECTIONPIT = {
    type: 3,
    value: "INSPECTIONPIT"
  };
  IfcDistributionChamberElementTypeEnum.MANHOLE = {
    type: 3,
    value: "MANHOLE"
  };
  IfcDistributionChamberElementTypeEnum.METERCHAMBER = {
    type: 3,
    value: "METERCHAMBER"
  };
  IfcDistributionChamberElementTypeEnum.SUMP = {
    type: 3,
    value: "SUMP"
  };
  IfcDistributionChamberElementTypeEnum.TRENCH = {
    type: 3,
    value: "TRENCH"
  };
  IfcDistributionChamberElementTypeEnum.VALVECHAMBER = {
    type: 3,
    value: "VALVECHAMBER"
  };
  IfcDistributionChamberElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDistributionChamberElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;

  var IfcDistributionPortTypeEnum = function IfcDistributionPortTypeEnum() {
    _classCallCheck2(this, IfcDistributionPortTypeEnum);
  };

  IfcDistributionPortTypeEnum.CABLE = {
    type: 3,
    value: "CABLE"
  };
  IfcDistributionPortTypeEnum.CABLECARRIER = {
    type: 3,
    value: "CABLECARRIER"
  };
  IfcDistributionPortTypeEnum.DUCT = {
    type: 3,
    value: "DUCT"
  };
  IfcDistributionPortTypeEnum.PIPE = {
    type: 3,
    value: "PIPE"
  };
  IfcDistributionPortTypeEnum.WIRELESS = {
    type: 3,
    value: "WIRELESS"
  };
  IfcDistributionPortTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDistributionPortTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDistributionPortTypeEnum = IfcDistributionPortTypeEnum;

  var IfcDistributionSystemEnum = function IfcDistributionSystemEnum() {
    _classCallCheck2(this, IfcDistributionSystemEnum);
  };

  IfcDistributionSystemEnum.AIRCONDITIONING = {
    type: 3,
    value: "AIRCONDITIONING"
  };
  IfcDistributionSystemEnum.AUDIOVISUAL = {
    type: 3,
    value: "AUDIOVISUAL"
  };
  IfcDistributionSystemEnum.CATENARY_SYSTEM = {
    type: 3,
    value: "CATENARY_SYSTEM"
  };
  IfcDistributionSystemEnum.CHEMICAL = {
    type: 3,
    value: "CHEMICAL"
  };
  IfcDistributionSystemEnum.CHILLEDWATER = {
    type: 3,
    value: "CHILLEDWATER"
  };
  IfcDistributionSystemEnum.COMMUNICATION = {
    type: 3,
    value: "COMMUNICATION"
  };
  IfcDistributionSystemEnum.COMPRESSEDAIR = {
    type: 3,
    value: "COMPRESSEDAIR"
  };
  IfcDistributionSystemEnum.CONDENSERWATER = {
    type: 3,
    value: "CONDENSERWATER"
  };
  IfcDistributionSystemEnum.CONTROL = {
    type: 3,
    value: "CONTROL"
  };
  IfcDistributionSystemEnum.CONVEYING = {
    type: 3,
    value: "CONVEYING"
  };
  IfcDistributionSystemEnum.DATA = {
    type: 3,
    value: "DATA"
  };
  IfcDistributionSystemEnum.DISPOSAL = {
    type: 3,
    value: "DISPOSAL"
  };
  IfcDistributionSystemEnum.DOMESTICCOLDWATER = {
    type: 3,
    value: "DOMESTICCOLDWATER"
  };
  IfcDistributionSystemEnum.DOMESTICHOTWATER = {
    type: 3,
    value: "DOMESTICHOTWATER"
  };
  IfcDistributionSystemEnum.DRAINAGE = {
    type: 3,
    value: "DRAINAGE"
  };
  IfcDistributionSystemEnum.EARTHING = {
    type: 3,
    value: "EARTHING"
  };
  IfcDistributionSystemEnum.ELECTRICAL = {
    type: 3,
    value: "ELECTRICAL"
  };
  IfcDistributionSystemEnum.ELECTROACOUSTIC = {
    type: 3,
    value: "ELECTROACOUSTIC"
  };
  IfcDistributionSystemEnum.EXHAUST = {
    type: 3,
    value: "EXHAUST"
  };
  IfcDistributionSystemEnum.FIREPROTECTION = {
    type: 3,
    value: "FIREPROTECTION"
  };
  IfcDistributionSystemEnum.FIXEDTRANSMISSIONNETWORK = {
    type: 3,
    value: "FIXEDTRANSMISSIONNETWORK"
  };
  IfcDistributionSystemEnum.FUEL = {
    type: 3,
    value: "FUEL"
  };
  IfcDistributionSystemEnum.GAS = {
    type: 3,
    value: "GAS"
  };
  IfcDistributionSystemEnum.HAZARDOUS = {
    type: 3,
    value: "HAZARDOUS"
  };
  IfcDistributionSystemEnum.HEATING = {
    type: 3,
    value: "HEATING"
  };
  IfcDistributionSystemEnum.LIGHTING = {
    type: 3,
    value: "LIGHTING"
  };
  IfcDistributionSystemEnum.LIGHTNINGPROTECTION = {
    type: 3,
    value: "LIGHTNINGPROTECTION"
  };
  IfcDistributionSystemEnum.MOBILENETWORK = {
    type: 3,
    value: "MOBILENETWORK"
  };
  IfcDistributionSystemEnum.MONITORINGSYSTEM = {
    type: 3,
    value: "MONITORINGSYSTEM"
  };
  IfcDistributionSystemEnum.MUNICIPALSOLIDWASTE = {
    type: 3,
    value: "MUNICIPALSOLIDWASTE"
  };
  IfcDistributionSystemEnum.OIL = {
    type: 3,
    value: "OIL"
  };
  IfcDistributionSystemEnum.OPERATIONAL = {
    type: 3,
    value: "OPERATIONAL"
  };
  IfcDistributionSystemEnum.OPERATIONALTELEPHONYSYSTEM = {
    type: 3,
    value: "OPERATIONALTELEPHONYSYSTEM"
  };
  IfcDistributionSystemEnum.OVERHEAD_CONTACTLINE_SYSTEM = {
    type: 3,
    value: "OVERHEAD_CONTACTLINE_SYSTEM"
  };
  IfcDistributionSystemEnum.POWERGENERATION = {
    type: 3,
    value: "POWERGENERATION"
  };
  IfcDistributionSystemEnum.RAINWATER = {
    type: 3,
    value: "RAINWATER"
  };
  IfcDistributionSystemEnum.REFRIGERATION = {
    type: 3,
    value: "REFRIGERATION"
  };
  IfcDistributionSystemEnum.RETURN_CIRCUIT = {
    type: 3,
    value: "RETURN_CIRCUIT"
  };
  IfcDistributionSystemEnum.SECURITY = {
    type: 3,
    value: "SECURITY"
  };
  IfcDistributionSystemEnum.SEWAGE = {
    type: 3,
    value: "SEWAGE"
  };
  IfcDistributionSystemEnum.SIGNAL = {
    type: 3,
    value: "SIGNAL"
  };
  IfcDistributionSystemEnum.STORMWATER = {
    type: 3,
    value: "STORMWATER"
  };
  IfcDistributionSystemEnum.TELEPHONE = {
    type: 3,
    value: "TELEPHONE"
  };
  IfcDistributionSystemEnum.TV = {
    type: 3,
    value: "TV"
  };
  IfcDistributionSystemEnum.VACUUM = {
    type: 3,
    value: "VACUUM"
  };
  IfcDistributionSystemEnum.VENT = {
    type: 3,
    value: "VENT"
  };
  IfcDistributionSystemEnum.VENTILATION = {
    type: 3,
    value: "VENTILATION"
  };
  IfcDistributionSystemEnum.WASTEWATER = {
    type: 3,
    value: "WASTEWATER"
  };
  IfcDistributionSystemEnum.WATERSUPPLY = {
    type: 3,
    value: "WATERSUPPLY"
  };
  IfcDistributionSystemEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDistributionSystemEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDistributionSystemEnum = IfcDistributionSystemEnum;

  var IfcDocumentConfidentialityEnum = function IfcDocumentConfidentialityEnum() {
    _classCallCheck2(this, IfcDocumentConfidentialityEnum);
  };

  IfcDocumentConfidentialityEnum.CONFIDENTIAL = {
    type: 3,
    value: "CONFIDENTIAL"
  };
  IfcDocumentConfidentialityEnum.PERSONAL = {
    type: 3,
    value: "PERSONAL"
  };
  IfcDocumentConfidentialityEnum.PUBLIC = {
    type: 3,
    value: "PUBLIC"
  };
  IfcDocumentConfidentialityEnum.RESTRICTED = {
    type: 3,
    value: "RESTRICTED"
  };
  IfcDocumentConfidentialityEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDocumentConfidentialityEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;

  var IfcDocumentStatusEnum = function IfcDocumentStatusEnum() {
    _classCallCheck2(this, IfcDocumentStatusEnum);
  };

  IfcDocumentStatusEnum.DRAFT = {
    type: 3,
    value: "DRAFT"
  };
  IfcDocumentStatusEnum.FINAL = {
    type: 3,
    value: "FINAL"
  };
  IfcDocumentStatusEnum.FINALDRAFT = {
    type: 3,
    value: "FINALDRAFT"
  };
  IfcDocumentStatusEnum.REVISION = {
    type: 3,
    value: "REVISION"
  };
  IfcDocumentStatusEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDocumentStatusEnum = IfcDocumentStatusEnum;

  var IfcDoorPanelOperationEnum = function IfcDoorPanelOperationEnum() {
    _classCallCheck2(this, IfcDoorPanelOperationEnum);
  };

  IfcDoorPanelOperationEnum.DOUBLE_ACTING = {
    type: 3,
    value: "DOUBLE_ACTING"
  };
  IfcDoorPanelOperationEnum.FIXEDPANEL = {
    type: 3,
    value: "FIXEDPANEL"
  };
  IfcDoorPanelOperationEnum.FOLDING = {
    type: 3,
    value: "FOLDING"
  };
  IfcDoorPanelOperationEnum.REVOLVING = {
    type: 3,
    value: "REVOLVING"
  };
  IfcDoorPanelOperationEnum.ROLLINGUP = {
    type: 3,
    value: "ROLLINGUP"
  };
  IfcDoorPanelOperationEnum.SLIDING = {
    type: 3,
    value: "SLIDING"
  };
  IfcDoorPanelOperationEnum.SWINGING = {
    type: 3,
    value: "SWINGING"
  };
  IfcDoorPanelOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorPanelOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;

  var IfcDoorPanelPositionEnum = function IfcDoorPanelPositionEnum() {
    _classCallCheck2(this, IfcDoorPanelPositionEnum);
  };

  IfcDoorPanelPositionEnum.LEFT = {
    type: 3,
    value: "LEFT"
  };
  IfcDoorPanelPositionEnum.MIDDLE = {
    type: 3,
    value: "MIDDLE"
  };
  IfcDoorPanelPositionEnum.RIGHT = {
    type: 3,
    value: "RIGHT"
  };
  IfcDoorPanelPositionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;

  var IfcDoorStyleConstructionEnum = function IfcDoorStyleConstructionEnum() {
    _classCallCheck2(this, IfcDoorStyleConstructionEnum);
  };

  IfcDoorStyleConstructionEnum.ALUMINIUM = {
    type: 3,
    value: "ALUMINIUM"
  };
  IfcDoorStyleConstructionEnum.ALUMINIUM_PLASTIC = {
    type: 3,
    value: "ALUMINIUM_PLASTIC"
  };
  IfcDoorStyleConstructionEnum.ALUMINIUM_WOOD = {
    type: 3,
    value: "ALUMINIUM_WOOD"
  };
  IfcDoorStyleConstructionEnum.HIGH_GRADE_STEEL = {
    type: 3,
    value: "HIGH_GRADE_STEEL"
  };
  IfcDoorStyleConstructionEnum.PLASTIC = {
    type: 3,
    value: "PLASTIC"
  };
  IfcDoorStyleConstructionEnum.STEEL = {
    type: 3,
    value: "STEEL"
  };
  IfcDoorStyleConstructionEnum.WOOD = {
    type: 3,
    value: "WOOD"
  };
  IfcDoorStyleConstructionEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorStyleConstructionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDoorStyleConstructionEnum = IfcDoorStyleConstructionEnum;

  var IfcDoorStyleOperationEnum = function IfcDoorStyleOperationEnum() {
    _classCallCheck2(this, IfcDoorStyleOperationEnum);
  };

  IfcDoorStyleOperationEnum.DOUBLE_DOOR_DOUBLE_SWING = {
    type: 3,
    value: "DOUBLE_DOOR_DOUBLE_SWING"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_FOLDING = {
    type: 3,
    value: "DOUBLE_DOOR_FOLDING"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SLIDING = {
    type: 3,
    value: "DOUBLE_DOOR_SLIDING"
  };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_LEFT = {
    type: 3,
    value: "DOUBLE_SWING_LEFT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_RIGHT = {
    type: 3,
    value: "DOUBLE_SWING_RIGHT"
  };
  IfcDoorStyleOperationEnum.FOLDING_TO_LEFT = {
    type: 3,
    value: "FOLDING_TO_LEFT"
  };
  IfcDoorStyleOperationEnum.FOLDING_TO_RIGHT = {
    type: 3,
    value: "FOLDING_TO_RIGHT"
  };
  IfcDoorStyleOperationEnum.REVOLVING = {
    type: 3,
    value: "REVOLVING"
  };
  IfcDoorStyleOperationEnum.ROLLINGUP = {
    type: 3,
    value: "ROLLINGUP"
  };
  IfcDoorStyleOperationEnum.SINGLE_SWING_LEFT = {
    type: 3,
    value: "SINGLE_SWING_LEFT"
  };
  IfcDoorStyleOperationEnum.SINGLE_SWING_RIGHT = {
    type: 3,
    value: "SINGLE_SWING_RIGHT"
  };
  IfcDoorStyleOperationEnum.SLIDING_TO_LEFT = {
    type: 3,
    value: "SLIDING_TO_LEFT"
  };
  IfcDoorStyleOperationEnum.SLIDING_TO_RIGHT = {
    type: 3,
    value: "SLIDING_TO_RIGHT"
  };
  IfcDoorStyleOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorStyleOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDoorStyleOperationEnum = IfcDoorStyleOperationEnum;

  var IfcDoorTypeEnum = function IfcDoorTypeEnum() {
    _classCallCheck2(this, IfcDoorTypeEnum);
  };

  IfcDoorTypeEnum.BOOM_BARRIER = {
    type: 3,
    value: "BOOM_BARRIER"
  };
  IfcDoorTypeEnum.DOOR = {
    type: 3,
    value: "DOOR"
  };
  IfcDoorTypeEnum.GATE = {
    type: 3,
    value: "GATE"
  };
  IfcDoorTypeEnum.TRAPDOOR = {
    type: 3,
    value: "TRAPDOOR"
  };
  IfcDoorTypeEnum.TURNSTILE = {
    type: 3,
    value: "TURNSTILE"
  };
  IfcDoorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDoorTypeEnum = IfcDoorTypeEnum;

  var IfcDoorTypeOperationEnum = function IfcDoorTypeOperationEnum() {
    _classCallCheck2(this, IfcDoorTypeOperationEnum);
  };

  IfcDoorTypeOperationEnum.DOUBLE_PANEL_DOUBLE_SWING = {
    type: 3,
    value: "DOUBLE_PANEL_DOUBLE_SWING"
  };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_FOLDING = {
    type: 3,
    value: "DOUBLE_PANEL_FOLDING"
  };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_LIFTING_VERTICAL = {
    type: 3,
    value: "DOUBLE_PANEL_LIFTING_VERTICAL"
  };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_SINGLE_SWING = {
    type: 3,
    value: "DOUBLE_PANEL_SINGLE_SWING"
  };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_LEFT = {
    type: 3,
    value: "DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_LEFT"
  };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_RIGHT = {
    type: 3,
    value: "DOUBLE_PANEL_SINGLE_SWING_OPPOSITE_RIGHT"
  };
  IfcDoorTypeOperationEnum.DOUBLE_PANEL_SLIDING = {
    type: 3,
    value: "DOUBLE_PANEL_SLIDING"
  };
  IfcDoorTypeOperationEnum.DOUBLE_SWING_LEFT = {
    type: 3,
    value: "DOUBLE_SWING_LEFT"
  };
  IfcDoorTypeOperationEnum.DOUBLE_SWING_RIGHT = {
    type: 3,
    value: "DOUBLE_SWING_RIGHT"
  };
  IfcDoorTypeOperationEnum.FOLDING_TO_LEFT = {
    type: 3,
    value: "FOLDING_TO_LEFT"
  };
  IfcDoorTypeOperationEnum.FOLDING_TO_RIGHT = {
    type: 3,
    value: "FOLDING_TO_RIGHT"
  };
  IfcDoorTypeOperationEnum.LIFTING_HORIZONTAL = {
    type: 3,
    value: "LIFTING_HORIZONTAL"
  };
  IfcDoorTypeOperationEnum.LIFTING_VERTICAL_LEFT = {
    type: 3,
    value: "LIFTING_VERTICAL_LEFT"
  };
  IfcDoorTypeOperationEnum.LIFTING_VERTICAL_RIGHT = {
    type: 3,
    value: "LIFTING_VERTICAL_RIGHT"
  };
  IfcDoorTypeOperationEnum.REVOLVING_HORIZONTAL = {
    type: 3,
    value: "REVOLVING_HORIZONTAL"
  };
  IfcDoorTypeOperationEnum.REVOLVING_VERTICAL = {
    type: 3,
    value: "REVOLVING_VERTICAL"
  };
  IfcDoorTypeOperationEnum.ROLLINGUP = {
    type: 3,
    value: "ROLLINGUP"
  };
  IfcDoorTypeOperationEnum.SINGLE_SWING_LEFT = {
    type: 3,
    value: "SINGLE_SWING_LEFT"
  };
  IfcDoorTypeOperationEnum.SINGLE_SWING_RIGHT = {
    type: 3,
    value: "SINGLE_SWING_RIGHT"
  };
  IfcDoorTypeOperationEnum.SLIDING_TO_LEFT = {
    type: 3,
    value: "SLIDING_TO_LEFT"
  };
  IfcDoorTypeOperationEnum.SLIDING_TO_RIGHT = {
    type: 3,
    value: "SLIDING_TO_RIGHT"
  };
  IfcDoorTypeOperationEnum.SWING_FIXED_LEFT = {
    type: 3,
    value: "SWING_FIXED_LEFT"
  };
  IfcDoorTypeOperationEnum.SWING_FIXED_RIGHT = {
    type: 3,
    value: "SWING_FIXED_RIGHT"
  };
  IfcDoorTypeOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorTypeOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDoorTypeOperationEnum = IfcDoorTypeOperationEnum;

  var IfcDuctFittingTypeEnum = function IfcDuctFittingTypeEnum() {
    _classCallCheck2(this, IfcDuctFittingTypeEnum);
  };

  IfcDuctFittingTypeEnum.BEND = {
    type: 3,
    value: "BEND"
  };
  IfcDuctFittingTypeEnum.CONNECTOR = {
    type: 3,
    value: "CONNECTOR"
  };
  IfcDuctFittingTypeEnum.ENTRY = {
    type: 3,
    value: "ENTRY"
  };
  IfcDuctFittingTypeEnum.EXIT = {
    type: 3,
    value: "EXIT"
  };
  IfcDuctFittingTypeEnum.JUNCTION = {
    type: 3,
    value: "JUNCTION"
  };
  IfcDuctFittingTypeEnum.OBSTRUCTION = {
    type: 3,
    value: "OBSTRUCTION"
  };
  IfcDuctFittingTypeEnum.TRANSITION = {
    type: 3,
    value: "TRANSITION"
  };
  IfcDuctFittingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDuctFittingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;

  var IfcDuctSegmentTypeEnum = function IfcDuctSegmentTypeEnum() {
    _classCallCheck2(this, IfcDuctSegmentTypeEnum);
  };

  IfcDuctSegmentTypeEnum.FLEXIBLESEGMENT = {
    type: 3,
    value: "FLEXIBLESEGMENT"
  };
  IfcDuctSegmentTypeEnum.RIGIDSEGMENT = {
    type: 3,
    value: "RIGIDSEGMENT"
  };
  IfcDuctSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDuctSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;

  var IfcDuctSilencerTypeEnum = function IfcDuctSilencerTypeEnum() {
    _classCallCheck2(this, IfcDuctSilencerTypeEnum);
  };

  IfcDuctSilencerTypeEnum.FLATOVAL = {
    type: 3,
    value: "FLATOVAL"
  };
  IfcDuctSilencerTypeEnum.RECTANGULAR = {
    type: 3,
    value: "RECTANGULAR"
  };
  IfcDuctSilencerTypeEnum.ROUND = {
    type: 3,
    value: "ROUND"
  };
  IfcDuctSilencerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDuctSilencerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;

  var IfcEarthworksCutTypeEnum = function IfcEarthworksCutTypeEnum() {
    _classCallCheck2(this, IfcEarthworksCutTypeEnum);
  };

  IfcEarthworksCutTypeEnum.BASE_EXCAVATION = {
    type: 3,
    value: "BASE_EXCAVATION"
  };
  IfcEarthworksCutTypeEnum.CUT = {
    type: 3,
    value: "CUT"
  };
  IfcEarthworksCutTypeEnum.DREDGING = {
    type: 3,
    value: "DREDGING"
  };
  IfcEarthworksCutTypeEnum.EXCAVATION = {
    type: 3,
    value: "EXCAVATION"
  };
  IfcEarthworksCutTypeEnum.OVEREXCAVATION = {
    type: 3,
    value: "OVEREXCAVATION"
  };
  IfcEarthworksCutTypeEnum.PAVEMENTMILLING = {
    type: 3,
    value: "PAVEMENTMILLING"
  };
  IfcEarthworksCutTypeEnum.STEPEXCAVATION = {
    type: 3,
    value: "STEPEXCAVATION"
  };
  IfcEarthworksCutTypeEnum.TOPSOILREMOVAL = {
    type: 3,
    value: "TOPSOILREMOVAL"
  };
  IfcEarthworksCutTypeEnum.TRENCH = {
    type: 3,
    value: "TRENCH"
  };
  IfcEarthworksCutTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEarthworksCutTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcEarthworksCutTypeEnum = IfcEarthworksCutTypeEnum;

  var IfcEarthworksFillTypeEnum = function IfcEarthworksFillTypeEnum() {
    _classCallCheck2(this, IfcEarthworksFillTypeEnum);
  };

  IfcEarthworksFillTypeEnum.BACKFILL = {
    type: 3,
    value: "BACKFILL"
  };
  IfcEarthworksFillTypeEnum.COUNTERWEIGHT = {
    type: 3,
    value: "COUNTERWEIGHT"
  };
  IfcEarthworksFillTypeEnum.EMBANKMENT = {
    type: 3,
    value: "EMBANKMENT"
  };
  IfcEarthworksFillTypeEnum.SLOPEFILL = {
    type: 3,
    value: "SLOPEFILL"
  };
  IfcEarthworksFillTypeEnum.SUBGRADE = {
    type: 3,
    value: "SUBGRADE"
  };
  IfcEarthworksFillTypeEnum.SUBGRADEBED = {
    type: 3,
    value: "SUBGRADEBED"
  };
  IfcEarthworksFillTypeEnum.TRANSITIONSECTION = {
    type: 3,
    value: "TRANSITIONSECTION"
  };
  IfcEarthworksFillTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEarthworksFillTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcEarthworksFillTypeEnum = IfcEarthworksFillTypeEnum;

  var IfcElectricApplianceTypeEnum = function IfcElectricApplianceTypeEnum() {
    _classCallCheck2(this, IfcElectricApplianceTypeEnum);
  };

  IfcElectricApplianceTypeEnum.DISHWASHER = {
    type: 3,
    value: "DISHWASHER"
  };
  IfcElectricApplianceTypeEnum.ELECTRICCOOKER = {
    type: 3,
    value: "ELECTRICCOOKER"
  };
  IfcElectricApplianceTypeEnum.FREESTANDINGELECTRICHEATER = {
    type: 3,
    value: "FREESTANDINGELECTRICHEATER"
  };
  IfcElectricApplianceTypeEnum.FREESTANDINGFAN = {
    type: 3,
    value: "FREESTANDINGFAN"
  };
  IfcElectricApplianceTypeEnum.FREESTANDINGWATERCOOLER = {
    type: 3,
    value: "FREESTANDINGWATERCOOLER"
  };
  IfcElectricApplianceTypeEnum.FREESTANDINGWATERHEATER = {
    type: 3,
    value: "FREESTANDINGWATERHEATER"
  };
  IfcElectricApplianceTypeEnum.FREEZER = {
    type: 3,
    value: "FREEZER"
  };
  IfcElectricApplianceTypeEnum.FRIDGE_FREEZER = {
    type: 3,
    value: "FRIDGE_FREEZER"
  };
  IfcElectricApplianceTypeEnum.HANDDRYER = {
    type: 3,
    value: "HANDDRYER"
  };
  IfcElectricApplianceTypeEnum.KITCHENMACHINE = {
    type: 3,
    value: "KITCHENMACHINE"
  };
  IfcElectricApplianceTypeEnum.MICROWAVE = {
    type: 3,
    value: "MICROWAVE"
  };
  IfcElectricApplianceTypeEnum.PHOTOCOPIER = {
    type: 3,
    value: "PHOTOCOPIER"
  };
  IfcElectricApplianceTypeEnum.REFRIGERATOR = {
    type: 3,
    value: "REFRIGERATOR"
  };
  IfcElectricApplianceTypeEnum.TUMBLEDRYER = {
    type: 3,
    value: "TUMBLEDRYER"
  };
  IfcElectricApplianceTypeEnum.VENDINGMACHINE = {
    type: 3,
    value: "VENDINGMACHINE"
  };
  IfcElectricApplianceTypeEnum.WASHINGMACHINE = {
    type: 3,
    value: "WASHINGMACHINE"
  };
  IfcElectricApplianceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricApplianceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;

  var IfcElectricDistributionBoardTypeEnum = function IfcElectricDistributionBoardTypeEnum() {
    _classCallCheck2(this, IfcElectricDistributionBoardTypeEnum);
  };

  IfcElectricDistributionBoardTypeEnum.CONSUMERUNIT = {
    type: 3,
    value: "CONSUMERUNIT"
  };
  IfcElectricDistributionBoardTypeEnum.DISTRIBUTIONBOARD = {
    type: 3,
    value: "DISTRIBUTIONBOARD"
  };
  IfcElectricDistributionBoardTypeEnum.MOTORCONTROLCENTRE = {
    type: 3,
    value: "MOTORCONTROLCENTRE"
  };
  IfcElectricDistributionBoardTypeEnum.SWITCHBOARD = {
    type: 3,
    value: "SWITCHBOARD"
  };
  IfcElectricDistributionBoardTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricDistributionBoardTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcElectricDistributionBoardTypeEnum = IfcElectricDistributionBoardTypeEnum;

  var IfcElectricFlowStorageDeviceTypeEnum = function IfcElectricFlowStorageDeviceTypeEnum() {
    _classCallCheck2(this, IfcElectricFlowStorageDeviceTypeEnum);
  };

  IfcElectricFlowStorageDeviceTypeEnum.BATTERY = {
    type: 3,
    value: "BATTERY"
  };
  IfcElectricFlowStorageDeviceTypeEnum.CAPACITOR = {
    type: 3,
    value: "CAPACITOR"
  };
  IfcElectricFlowStorageDeviceTypeEnum.CAPACITORBANK = {
    type: 3,
    value: "CAPACITORBANK"
  };
  IfcElectricFlowStorageDeviceTypeEnum.COMPENSATOR = {
    type: 3,
    value: "COMPENSATOR"
  };
  IfcElectricFlowStorageDeviceTypeEnum.HARMONICFILTER = {
    type: 3,
    value: "HARMONICFILTER"
  };
  IfcElectricFlowStorageDeviceTypeEnum.INDUCTOR = {
    type: 3,
    value: "INDUCTOR"
  };
  IfcElectricFlowStorageDeviceTypeEnum.INDUCTORBANK = {
    type: 3,
    value: "INDUCTORBANK"
  };
  IfcElectricFlowStorageDeviceTypeEnum.RECHARGER = {
    type: 3,
    value: "RECHARGER"
  };
  IfcElectricFlowStorageDeviceTypeEnum.UPS = {
    type: 3,
    value: "UPS"
  };
  IfcElectricFlowStorageDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricFlowStorageDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;

  var IfcElectricFlowTreatmentDeviceTypeEnum = function IfcElectricFlowTreatmentDeviceTypeEnum() {
    _classCallCheck2(this, IfcElectricFlowTreatmentDeviceTypeEnum);
  };

  IfcElectricFlowTreatmentDeviceTypeEnum.ELECTRONICFILTER = {
    type: 3,
    value: "ELECTRONICFILTER"
  };
  IfcElectricFlowTreatmentDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricFlowTreatmentDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcElectricFlowTreatmentDeviceTypeEnum = IfcElectricFlowTreatmentDeviceTypeEnum;

  var IfcElectricGeneratorTypeEnum = function IfcElectricGeneratorTypeEnum() {
    _classCallCheck2(this, IfcElectricGeneratorTypeEnum);
  };

  IfcElectricGeneratorTypeEnum.CHP = {
    type: 3,
    value: "CHP"
  };
  IfcElectricGeneratorTypeEnum.ENGINEGENERATOR = {
    type: 3,
    value: "ENGINEGENERATOR"
  };
  IfcElectricGeneratorTypeEnum.STANDALONE = {
    type: 3,
    value: "STANDALONE"
  };
  IfcElectricGeneratorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricGeneratorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;

  var IfcElectricMotorTypeEnum = function IfcElectricMotorTypeEnum() {
    _classCallCheck2(this, IfcElectricMotorTypeEnum);
  };

  IfcElectricMotorTypeEnum.DC = {
    type: 3,
    value: "DC"
  };
  IfcElectricMotorTypeEnum.INDUCTION = {
    type: 3,
    value: "INDUCTION"
  };
  IfcElectricMotorTypeEnum.POLYPHASE = {
    type: 3,
    value: "POLYPHASE"
  };
  IfcElectricMotorTypeEnum.RELUCTANCESYNCHRONOUS = {
    type: 3,
    value: "RELUCTANCESYNCHRONOUS"
  };
  IfcElectricMotorTypeEnum.SYNCHRONOUS = {
    type: 3,
    value: "SYNCHRONOUS"
  };
  IfcElectricMotorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricMotorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;

  var IfcElectricTimeControlTypeEnum = function IfcElectricTimeControlTypeEnum() {
    _classCallCheck2(this, IfcElectricTimeControlTypeEnum);
  };

  IfcElectricTimeControlTypeEnum.RELAY = {
    type: 3,
    value: "RELAY"
  };
  IfcElectricTimeControlTypeEnum.TIMECLOCK = {
    type: 3,
    value: "TIMECLOCK"
  };
  IfcElectricTimeControlTypeEnum.TIMEDELAY = {
    type: 3,
    value: "TIMEDELAY"
  };
  IfcElectricTimeControlTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricTimeControlTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;

  var IfcElementAssemblyTypeEnum = function IfcElementAssemblyTypeEnum() {
    _classCallCheck2(this, IfcElementAssemblyTypeEnum);
  };

  IfcElementAssemblyTypeEnum.ABUTMENT = {
    type: 3,
    value: "ABUTMENT"
  };
  IfcElementAssemblyTypeEnum.ACCESSORY_ASSEMBLY = {
    type: 3,
    value: "ACCESSORY_ASSEMBLY"
  };
  IfcElementAssemblyTypeEnum.ARCH = {
    type: 3,
    value: "ARCH"
  };
  IfcElementAssemblyTypeEnum.BEAM_GRID = {
    type: 3,
    value: "BEAM_GRID"
  };
  IfcElementAssemblyTypeEnum.BRACED_FRAME = {
    type: 3,
    value: "BRACED_FRAME"
  };
  IfcElementAssemblyTypeEnum.CROSS_BRACING = {
    type: 3,
    value: "CROSS_BRACING"
  };
  IfcElementAssemblyTypeEnum.DECK = {
    type: 3,
    value: "DECK"
  };
  IfcElementAssemblyTypeEnum.DILATATIONPANEL = {
    type: 3,
    value: "DILATATIONPANEL"
  };
  IfcElementAssemblyTypeEnum.ENTRANCEWORKS = {
    type: 3,
    value: "ENTRANCEWORKS"
  };
  IfcElementAssemblyTypeEnum.GIRDER = {
    type: 3,
    value: "GIRDER"
  };
  IfcElementAssemblyTypeEnum.GRID = {
    type: 3,
    value: "GRID"
  };
  IfcElementAssemblyTypeEnum.MAST = {
    type: 3,
    value: "MAST"
  };
  IfcElementAssemblyTypeEnum.PIER = {
    type: 3,
    value: "PIER"
  };
  IfcElementAssemblyTypeEnum.PYLON = {
    type: 3,
    value: "PYLON"
  };
  IfcElementAssemblyTypeEnum.RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY = {
    type: 3,
    value: "RAIL_MECHANICAL_EQUIPMENT_ASSEMBLY"
  };
  IfcElementAssemblyTypeEnum.REINFORCEMENT_UNIT = {
    type: 3,
    value: "REINFORCEMENT_UNIT"
  };
  IfcElementAssemblyTypeEnum.RIGID_FRAME = {
    type: 3,
    value: "RIGID_FRAME"
  };
  IfcElementAssemblyTypeEnum.SHELTER = {
    type: 3,
    value: "SHELTER"
  };
  IfcElementAssemblyTypeEnum.SIGNALASSEMBLY = {
    type: 3,
    value: "SIGNALASSEMBLY"
  };
  IfcElementAssemblyTypeEnum.SLAB_FIELD = {
    type: 3,
    value: "SLAB_FIELD"
  };
  IfcElementAssemblyTypeEnum.SUMPBUSTER = {
    type: 3,
    value: "SUMPBUSTER"
  };
  IfcElementAssemblyTypeEnum.SUPPORTINGASSEMBLY = {
    type: 3,
    value: "SUPPORTINGASSEMBLY"
  };
  IfcElementAssemblyTypeEnum.SUSPENSIONASSEMBLY = {
    type: 3,
    value: "SUSPENSIONASSEMBLY"
  };
  IfcElementAssemblyTypeEnum.TRACKPANEL = {
    type: 3,
    value: "TRACKPANEL"
  };
  IfcElementAssemblyTypeEnum.TRACTION_SWITCHING_ASSEMBLY = {
    type: 3,
    value: "TRACTION_SWITCHING_ASSEMBLY"
  };
  IfcElementAssemblyTypeEnum.TRAFFIC_CALMING_DEVICE = {
    type: 3,
    value: "TRAFFIC_CALMING_DEVICE"
  };
  IfcElementAssemblyTypeEnum.TRUSS = {
    type: 3,
    value: "TRUSS"
  };
  IfcElementAssemblyTypeEnum.TURNOUTPANEL = {
    type: 3,
    value: "TURNOUTPANEL"
  };
  IfcElementAssemblyTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElementAssemblyTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;

  var IfcElementCompositionEnum = function IfcElementCompositionEnum() {
    _classCallCheck2(this, IfcElementCompositionEnum);
  };

  IfcElementCompositionEnum.COMPLEX = {
    type: 3,
    value: "COMPLEX"
  };
  IfcElementCompositionEnum.ELEMENT = {
    type: 3,
    value: "ELEMENT"
  };
  IfcElementCompositionEnum.PARTIAL = {
    type: 3,
    value: "PARTIAL"
  };
  IFC4_32.IfcElementCompositionEnum = IfcElementCompositionEnum;

  var IfcEngineTypeEnum = function IfcEngineTypeEnum() {
    _classCallCheck2(this, IfcEngineTypeEnum);
  };

  IfcEngineTypeEnum.EXTERNALCOMBUSTION = {
    type: 3,
    value: "EXTERNALCOMBUSTION"
  };
  IfcEngineTypeEnum.INTERNALCOMBUSTION = {
    type: 3,
    value: "INTERNALCOMBUSTION"
  };
  IfcEngineTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEngineTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcEngineTypeEnum = IfcEngineTypeEnum;

  var IfcEvaporativeCoolerTypeEnum = function IfcEvaporativeCoolerTypeEnum() {
    _classCallCheck2(this, IfcEvaporativeCoolerTypeEnum);
  };

  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEAIRWASHER = {
    type: 3,
    value: "DIRECTEVAPORATIVEAIRWASHER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTDIRECTCOMBINATION = {
    type: 3,
    value: "INDIRECTDIRECTCOMBINATION"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = {
    type: 3,
    value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = {
    type: 3,
    value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEWETCOIL = {
    type: 3,
    value: "INDIRECTEVAPORATIVEWETCOIL"
  };
  IfcEvaporativeCoolerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEvaporativeCoolerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;

  var IfcEvaporatorTypeEnum = function IfcEvaporatorTypeEnum() {
    _classCallCheck2(this, IfcEvaporatorTypeEnum);
  };

  IfcEvaporatorTypeEnum.DIRECTEXPANSION = {
    type: 3,
    value: "DIRECTEXPANSION"
  };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONBRAZEDPLATE = {
    type: 3,
    value: "DIRECTEXPANSIONBRAZEDPLATE"
  };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONSHELLANDTUBE = {
    type: 3,
    value: "DIRECTEXPANSIONSHELLANDTUBE"
  };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONTUBEINTUBE = {
    type: 3,
    value: "DIRECTEXPANSIONTUBEINTUBE"
  };
  IfcEvaporatorTypeEnum.FLOODEDSHELLANDTUBE = {
    type: 3,
    value: "FLOODEDSHELLANDTUBE"
  };
  IfcEvaporatorTypeEnum.SHELLANDCOIL = {
    type: 3,
    value: "SHELLANDCOIL"
  };
  IfcEvaporatorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEvaporatorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;

  var IfcEventTriggerTypeEnum = function IfcEventTriggerTypeEnum() {
    _classCallCheck2(this, IfcEventTriggerTypeEnum);
  };

  IfcEventTriggerTypeEnum.EVENTCOMPLEX = {
    type: 3,
    value: "EVENTCOMPLEX"
  };
  IfcEventTriggerTypeEnum.EVENTMESSAGE = {
    type: 3,
    value: "EVENTMESSAGE"
  };
  IfcEventTriggerTypeEnum.EVENTRULE = {
    type: 3,
    value: "EVENTRULE"
  };
  IfcEventTriggerTypeEnum.EVENTTIME = {
    type: 3,
    value: "EVENTTIME"
  };
  IfcEventTriggerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEventTriggerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcEventTriggerTypeEnum = IfcEventTriggerTypeEnum;

  var IfcEventTypeEnum = function IfcEventTypeEnum() {
    _classCallCheck2(this, IfcEventTypeEnum);
  };

  IfcEventTypeEnum.ENDEVENT = {
    type: 3,
    value: "ENDEVENT"
  };
  IfcEventTypeEnum.INTERMEDIATEEVENT = {
    type: 3,
    value: "INTERMEDIATEEVENT"
  };
  IfcEventTypeEnum.STARTEVENT = {
    type: 3,
    value: "STARTEVENT"
  };
  IfcEventTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEventTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcEventTypeEnum = IfcEventTypeEnum;

  var IfcExternalSpatialElementTypeEnum = function IfcExternalSpatialElementTypeEnum() {
    _classCallCheck2(this, IfcExternalSpatialElementTypeEnum);
  };

  IfcExternalSpatialElementTypeEnum.EXTERNAL = {
    type: 3,
    value: "EXTERNAL"
  };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_EARTH = {
    type: 3,
    value: "EXTERNAL_EARTH"
  };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_FIRE = {
    type: 3,
    value: "EXTERNAL_FIRE"
  };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_WATER = {
    type: 3,
    value: "EXTERNAL_WATER"
  };
  IfcExternalSpatialElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcExternalSpatialElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcExternalSpatialElementTypeEnum = IfcExternalSpatialElementTypeEnum;

  var IfcFacilityPartCommonTypeEnum = function IfcFacilityPartCommonTypeEnum() {
    _classCallCheck2(this, IfcFacilityPartCommonTypeEnum);
  };

  IfcFacilityPartCommonTypeEnum.ABOVEGROUND = {
    type: 3,
    value: "ABOVEGROUND"
  };
  IfcFacilityPartCommonTypeEnum.BELOWGROUND = {
    type: 3,
    value: "BELOWGROUND"
  };
  IfcFacilityPartCommonTypeEnum.JUNCTION = {
    type: 3,
    value: "JUNCTION"
  };
  IfcFacilityPartCommonTypeEnum.LEVELCROSSING = {
    type: 3,
    value: "LEVELCROSSING"
  };
  IfcFacilityPartCommonTypeEnum.SEGMENT = {
    type: 3,
    value: "SEGMENT"
  };
  IfcFacilityPartCommonTypeEnum.SUBSTRUCTURE = {
    type: 3,
    value: "SUBSTRUCTURE"
  };
  IfcFacilityPartCommonTypeEnum.SUPERSTRUCTURE = {
    type: 3,
    value: "SUPERSTRUCTURE"
  };
  IfcFacilityPartCommonTypeEnum.TERMINAL = {
    type: 3,
    value: "TERMINAL"
  };
  IfcFacilityPartCommonTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFacilityPartCommonTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcFacilityPartCommonTypeEnum = IfcFacilityPartCommonTypeEnum;

  var IfcFacilityUsageEnum = function IfcFacilityUsageEnum() {
    _classCallCheck2(this, IfcFacilityUsageEnum);
  };

  IfcFacilityUsageEnum.LATERAL = {
    type: 3,
    value: "LATERAL"
  };
  IfcFacilityUsageEnum.LONGITUDINAL = {
    type: 3,
    value: "LONGITUDINAL"
  };
  IfcFacilityUsageEnum.REGION = {
    type: 3,
    value: "REGION"
  };
  IfcFacilityUsageEnum.VERTICAL = {
    type: 3,
    value: "VERTICAL"
  };
  IfcFacilityUsageEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFacilityUsageEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcFacilityUsageEnum = IfcFacilityUsageEnum;

  var IfcFanTypeEnum = function IfcFanTypeEnum() {
    _classCallCheck2(this, IfcFanTypeEnum);
  };

  IfcFanTypeEnum.CENTRIFUGALAIRFOIL = {
    type: 3,
    value: "CENTRIFUGALAIRFOIL"
  };
  IfcFanTypeEnum.CENTRIFUGALBACKWARDINCLINEDCURVED = {
    type: 3,
    value: "CENTRIFUGALBACKWARDINCLINEDCURVED"
  };
  IfcFanTypeEnum.CENTRIFUGALFORWARDCURVED = {
    type: 3,
    value: "CENTRIFUGALFORWARDCURVED"
  };
  IfcFanTypeEnum.CENTRIFUGALRADIAL = {
    type: 3,
    value: "CENTRIFUGALRADIAL"
  };
  IfcFanTypeEnum.PROPELLORAXIAL = {
    type: 3,
    value: "PROPELLORAXIAL"
  };
  IfcFanTypeEnum.TUBEAXIAL = {
    type: 3,
    value: "TUBEAXIAL"
  };
  IfcFanTypeEnum.VANEAXIAL = {
    type: 3,
    value: "VANEAXIAL"
  };
  IfcFanTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFanTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcFanTypeEnum = IfcFanTypeEnum;

  var IfcFastenerTypeEnum = function IfcFastenerTypeEnum() {
    _classCallCheck2(this, IfcFastenerTypeEnum);
  };

  IfcFastenerTypeEnum.GLUE = {
    type: 3,
    value: "GLUE"
  };
  IfcFastenerTypeEnum.MORTAR = {
    type: 3,
    value: "MORTAR"
  };
  IfcFastenerTypeEnum.WELD = {
    type: 3,
    value: "WELD"
  };
  IfcFastenerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFastenerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcFastenerTypeEnum = IfcFastenerTypeEnum;

  var IfcFilterTypeEnum = function IfcFilterTypeEnum() {
    _classCallCheck2(this, IfcFilterTypeEnum);
  };

  IfcFilterTypeEnum.AIRPARTICLEFILTER = {
    type: 3,
    value: "AIRPARTICLEFILTER"
  };
  IfcFilterTypeEnum.COMPRESSEDAIRFILTER = {
    type: 3,
    value: "COMPRESSEDAIRFILTER"
  };
  IfcFilterTypeEnum.ODORFILTER = {
    type: 3,
    value: "ODORFILTER"
  };
  IfcFilterTypeEnum.OILFILTER = {
    type: 3,
    value: "OILFILTER"
  };
  IfcFilterTypeEnum.STRAINER = {
    type: 3,
    value: "STRAINER"
  };
  IfcFilterTypeEnum.WATERFILTER = {
    type: 3,
    value: "WATERFILTER"
  };
  IfcFilterTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFilterTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcFilterTypeEnum = IfcFilterTypeEnum;

  var IfcFireSuppressionTerminalTypeEnum = function IfcFireSuppressionTerminalTypeEnum() {
    _classCallCheck2(this, IfcFireSuppressionTerminalTypeEnum);
  };

  IfcFireSuppressionTerminalTypeEnum.BREECHINGINLET = {
    type: 3,
    value: "BREECHINGINLET"
  };
  IfcFireSuppressionTerminalTypeEnum.FIREHYDRANT = {
    type: 3,
    value: "FIREHYDRANT"
  };
  IfcFireSuppressionTerminalTypeEnum.FIREMONITOR = {
    type: 3,
    value: "FIREMONITOR"
  };
  IfcFireSuppressionTerminalTypeEnum.HOSEREEL = {
    type: 3,
    value: "HOSEREEL"
  };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLER = {
    type: 3,
    value: "SPRINKLER"
  };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLERDEFLECTOR = {
    type: 3,
    value: "SPRINKLERDEFLECTOR"
  };
  IfcFireSuppressionTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFireSuppressionTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;

  var IfcFlowDirectionEnum = function IfcFlowDirectionEnum() {
    _classCallCheck2(this, IfcFlowDirectionEnum);
  };

  IfcFlowDirectionEnum.SINK = {
    type: 3,
    value: "SINK"
  };
  IfcFlowDirectionEnum.SOURCE = {
    type: 3,
    value: "SOURCE"
  };
  IfcFlowDirectionEnum.SOURCEANDSINK = {
    type: 3,
    value: "SOURCEANDSINK"
  };
  IfcFlowDirectionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcFlowDirectionEnum = IfcFlowDirectionEnum;

  var IfcFlowInstrumentTypeEnum = function IfcFlowInstrumentTypeEnum() {
    _classCallCheck2(this, IfcFlowInstrumentTypeEnum);
  };

  IfcFlowInstrumentTypeEnum.AMMETER = {
    type: 3,
    value: "AMMETER"
  };
  IfcFlowInstrumentTypeEnum.COMBINED = {
    type: 3,
    value: "COMBINED"
  };
  IfcFlowInstrumentTypeEnum.FREQUENCYMETER = {
    type: 3,
    value: "FREQUENCYMETER"
  };
  IfcFlowInstrumentTypeEnum.PHASEANGLEMETER = {
    type: 3,
    value: "PHASEANGLEMETER"
  };
  IfcFlowInstrumentTypeEnum.POWERFACTORMETER = {
    type: 3,
    value: "POWERFACTORMETER"
  };
  IfcFlowInstrumentTypeEnum.PRESSUREGAUGE = {
    type: 3,
    value: "PRESSUREGAUGE"
  };
  IfcFlowInstrumentTypeEnum.THERMOMETER = {
    type: 3,
    value: "THERMOMETER"
  };
  IfcFlowInstrumentTypeEnum.VOLTMETER = {
    type: 3,
    value: "VOLTMETER"
  };
  IfcFlowInstrumentTypeEnum.VOLTMETER_PEAK = {
    type: 3,
    value: "VOLTMETER_PEAK"
  };
  IfcFlowInstrumentTypeEnum.VOLTMETER_RMS = {
    type: 3,
    value: "VOLTMETER_RMS"
  };
  IfcFlowInstrumentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFlowInstrumentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;

  var IfcFlowMeterTypeEnum = function IfcFlowMeterTypeEnum() {
    _classCallCheck2(this, IfcFlowMeterTypeEnum);
  };

  IfcFlowMeterTypeEnum.ENERGYMETER = {
    type: 3,
    value: "ENERGYMETER"
  };
  IfcFlowMeterTypeEnum.GASMETER = {
    type: 3,
    value: "GASMETER"
  };
  IfcFlowMeterTypeEnum.OILMETER = {
    type: 3,
    value: "OILMETER"
  };
  IfcFlowMeterTypeEnum.WATERMETER = {
    type: 3,
    value: "WATERMETER"
  };
  IfcFlowMeterTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFlowMeterTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;

  var IfcFootingTypeEnum = function IfcFootingTypeEnum() {
    _classCallCheck2(this, IfcFootingTypeEnum);
  };

  IfcFootingTypeEnum.CAISSON_FOUNDATION = {
    type: 3,
    value: "CAISSON_FOUNDATION"
  };
  IfcFootingTypeEnum.FOOTING_BEAM = {
    type: 3,
    value: "FOOTING_BEAM"
  };
  IfcFootingTypeEnum.PAD_FOOTING = {
    type: 3,
    value: "PAD_FOOTING"
  };
  IfcFootingTypeEnum.PILE_CAP = {
    type: 3,
    value: "PILE_CAP"
  };
  IfcFootingTypeEnum.STRIP_FOOTING = {
    type: 3,
    value: "STRIP_FOOTING"
  };
  IfcFootingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFootingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcFootingTypeEnum = IfcFootingTypeEnum;

  var IfcFurnitureTypeEnum = function IfcFurnitureTypeEnum() {
    _classCallCheck2(this, IfcFurnitureTypeEnum);
  };

  IfcFurnitureTypeEnum.BED = {
    type: 3,
    value: "BED"
  };
  IfcFurnitureTypeEnum.CHAIR = {
    type: 3,
    value: "CHAIR"
  };
  IfcFurnitureTypeEnum.DESK = {
    type: 3,
    value: "DESK"
  };
  IfcFurnitureTypeEnum.FILECABINET = {
    type: 3,
    value: "FILECABINET"
  };
  IfcFurnitureTypeEnum.SHELF = {
    type: 3,
    value: "SHELF"
  };
  IfcFurnitureTypeEnum.SOFA = {
    type: 3,
    value: "SOFA"
  };
  IfcFurnitureTypeEnum.TABLE = {
    type: 3,
    value: "TABLE"
  };
  IfcFurnitureTypeEnum.TECHNICALCABINET = {
    type: 3,
    value: "TECHNICALCABINET"
  };
  IfcFurnitureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFurnitureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcFurnitureTypeEnum = IfcFurnitureTypeEnum;

  var IfcGeographicElementTypeEnum = function IfcGeographicElementTypeEnum() {
    _classCallCheck2(this, IfcGeographicElementTypeEnum);
  };

  IfcGeographicElementTypeEnum.SOIL_BORING_POINT = {
    type: 3,
    value: "SOIL_BORING_POINT"
  };
  IfcGeographicElementTypeEnum.TERRAIN = {
    type: 3,
    value: "TERRAIN"
  };
  IfcGeographicElementTypeEnum.VEGETATION = {
    type: 3,
    value: "VEGETATION"
  };
  IfcGeographicElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcGeographicElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcGeographicElementTypeEnum = IfcGeographicElementTypeEnum;

  var IfcGeometricProjectionEnum = function IfcGeometricProjectionEnum() {
    _classCallCheck2(this, IfcGeometricProjectionEnum);
  };

  IfcGeometricProjectionEnum.ELEVATION_VIEW = {
    type: 3,
    value: "ELEVATION_VIEW"
  };
  IfcGeometricProjectionEnum.GRAPH_VIEW = {
    type: 3,
    value: "GRAPH_VIEW"
  };
  IfcGeometricProjectionEnum.MODEL_VIEW = {
    type: 3,
    value: "MODEL_VIEW"
  };
  IfcGeometricProjectionEnum.PLAN_VIEW = {
    type: 3,
    value: "PLAN_VIEW"
  };
  IfcGeometricProjectionEnum.REFLECTED_PLAN_VIEW = {
    type: 3,
    value: "REFLECTED_PLAN_VIEW"
  };
  IfcGeometricProjectionEnum.SECTION_VIEW = {
    type: 3,
    value: "SECTION_VIEW"
  };
  IfcGeometricProjectionEnum.SKETCH_VIEW = {
    type: 3,
    value: "SKETCH_VIEW"
  };
  IfcGeometricProjectionEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcGeometricProjectionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;

  var IfcGeotechnicalStratumTypeEnum = function IfcGeotechnicalStratumTypeEnum() {
    _classCallCheck2(this, IfcGeotechnicalStratumTypeEnum);
  };

  IfcGeotechnicalStratumTypeEnum.SOLID = {
    type: 3,
    value: "SOLID"
  };
  IfcGeotechnicalStratumTypeEnum.VOID = {
    type: 3,
    value: "VOID"
  };
  IfcGeotechnicalStratumTypeEnum.WATER = {
    type: 3,
    value: "WATER"
  };
  IfcGeotechnicalStratumTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcGeotechnicalStratumTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcGeotechnicalStratumTypeEnum = IfcGeotechnicalStratumTypeEnum;

  var IfcGlobalOrLocalEnum = function IfcGlobalOrLocalEnum() {
    _classCallCheck2(this, IfcGlobalOrLocalEnum);
  };

  IfcGlobalOrLocalEnum.GLOBAL_COORDS = {
    type: 3,
    value: "GLOBAL_COORDS"
  };
  IfcGlobalOrLocalEnum.LOCAL_COORDS = {
    type: 3,
    value: "LOCAL_COORDS"
  };
  IFC4_32.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;

  var IfcGridTypeEnum = function IfcGridTypeEnum() {
    _classCallCheck2(this, IfcGridTypeEnum);
  };

  IfcGridTypeEnum.IRREGULAR = {
    type: 3,
    value: "IRREGULAR"
  };
  IfcGridTypeEnum.RADIAL = {
    type: 3,
    value: "RADIAL"
  };
  IfcGridTypeEnum.RECTANGULAR = {
    type: 3,
    value: "RECTANGULAR"
  };
  IfcGridTypeEnum.TRIANGULAR = {
    type: 3,
    value: "TRIANGULAR"
  };
  IfcGridTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcGridTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcGridTypeEnum = IfcGridTypeEnum;

  var IfcHeatExchangerTypeEnum = function IfcHeatExchangerTypeEnum() {
    _classCallCheck2(this, IfcHeatExchangerTypeEnum);
  };

  IfcHeatExchangerTypeEnum.PLATE = {
    type: 3,
    value: "PLATE"
  };
  IfcHeatExchangerTypeEnum.SHELLANDTUBE = {
    type: 3,
    value: "SHELLANDTUBE"
  };
  IfcHeatExchangerTypeEnum.TURNOUTHEATING = {
    type: 3,
    value: "TURNOUTHEATING"
  };
  IfcHeatExchangerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcHeatExchangerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;

  var IfcHumidifierTypeEnum = function IfcHumidifierTypeEnum() {
    _classCallCheck2(this, IfcHumidifierTypeEnum);
  };

  IfcHumidifierTypeEnum.ADIABATICAIRWASHER = {
    type: 3,
    value: "ADIABATICAIRWASHER"
  };
  IfcHumidifierTypeEnum.ADIABATICATOMIZING = {
    type: 3,
    value: "ADIABATICATOMIZING"
  };
  IfcHumidifierTypeEnum.ADIABATICCOMPRESSEDAIRNOZZLE = {
    type: 3,
    value: "ADIABATICCOMPRESSEDAIRNOZZLE"
  };
  IfcHumidifierTypeEnum.ADIABATICPAN = {
    type: 3,
    value: "ADIABATICPAN"
  };
  IfcHumidifierTypeEnum.ADIABATICRIGIDMEDIA = {
    type: 3,
    value: "ADIABATICRIGIDMEDIA"
  };
  IfcHumidifierTypeEnum.ADIABATICULTRASONIC = {
    type: 3,
    value: "ADIABATICULTRASONIC"
  };
  IfcHumidifierTypeEnum.ADIABATICWETTEDELEMENT = {
    type: 3,
    value: "ADIABATICWETTEDELEMENT"
  };
  IfcHumidifierTypeEnum.ASSISTEDBUTANE = {
    type: 3,
    value: "ASSISTEDBUTANE"
  };
  IfcHumidifierTypeEnum.ASSISTEDELECTRIC = {
    type: 3,
    value: "ASSISTEDELECTRIC"
  };
  IfcHumidifierTypeEnum.ASSISTEDNATURALGAS = {
    type: 3,
    value: "ASSISTEDNATURALGAS"
  };
  IfcHumidifierTypeEnum.ASSISTEDPROPANE = {
    type: 3,
    value: "ASSISTEDPROPANE"
  };
  IfcHumidifierTypeEnum.ASSISTEDSTEAM = {
    type: 3,
    value: "ASSISTEDSTEAM"
  };
  IfcHumidifierTypeEnum.STEAMINJECTION = {
    type: 3,
    value: "STEAMINJECTION"
  };
  IfcHumidifierTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcHumidifierTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;

  var IfcImpactProtectionDeviceTypeEnum = function IfcImpactProtectionDeviceTypeEnum() {
    _classCallCheck2(this, IfcImpactProtectionDeviceTypeEnum);
  };

  IfcImpactProtectionDeviceTypeEnum.BUMPER = {
    type: 3,
    value: "BUMPER"
  };
  IfcImpactProtectionDeviceTypeEnum.CRASHCUSHION = {
    type: 3,
    value: "CRASHCUSHION"
  };
  IfcImpactProtectionDeviceTypeEnum.DAMPINGSYSTEM = {
    type: 3,
    value: "DAMPINGSYSTEM"
  };
  IfcImpactProtectionDeviceTypeEnum.FENDER = {
    type: 3,
    value: "FENDER"
  };
  IfcImpactProtectionDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcImpactProtectionDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcImpactProtectionDeviceTypeEnum = IfcImpactProtectionDeviceTypeEnum;

  var IfcInterceptorTypeEnum = function IfcInterceptorTypeEnum() {
    _classCallCheck2(this, IfcInterceptorTypeEnum);
  };

  IfcInterceptorTypeEnum.CYCLONIC = {
    type: 3,
    value: "CYCLONIC"
  };
  IfcInterceptorTypeEnum.GREASE = {
    type: 3,
    value: "GREASE"
  };
  IfcInterceptorTypeEnum.OIL = {
    type: 3,
    value: "OIL"
  };
  IfcInterceptorTypeEnum.PETROL = {
    type: 3,
    value: "PETROL"
  };
  IfcInterceptorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcInterceptorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcInterceptorTypeEnum = IfcInterceptorTypeEnum;

  var IfcInternalOrExternalEnum = function IfcInternalOrExternalEnum() {
    _classCallCheck2(this, IfcInternalOrExternalEnum);
  };

  IfcInternalOrExternalEnum.EXTERNAL = {
    type: 3,
    value: "EXTERNAL"
  };
  IfcInternalOrExternalEnum.EXTERNAL_EARTH = {
    type: 3,
    value: "EXTERNAL_EARTH"
  };
  IfcInternalOrExternalEnum.EXTERNAL_FIRE = {
    type: 3,
    value: "EXTERNAL_FIRE"
  };
  IfcInternalOrExternalEnum.EXTERNAL_WATER = {
    type: 3,
    value: "EXTERNAL_WATER"
  };
  IfcInternalOrExternalEnum.INTERNAL = {
    type: 3,
    value: "INTERNAL"
  };
  IfcInternalOrExternalEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;

  var IfcInventoryTypeEnum = function IfcInventoryTypeEnum() {
    _classCallCheck2(this, IfcInventoryTypeEnum);
  };

  IfcInventoryTypeEnum.ASSETINVENTORY = {
    type: 3,
    value: "ASSETINVENTORY"
  };
  IfcInventoryTypeEnum.FURNITUREINVENTORY = {
    type: 3,
    value: "FURNITUREINVENTORY"
  };
  IfcInventoryTypeEnum.SPACEINVENTORY = {
    type: 3,
    value: "SPACEINVENTORY"
  };
  IfcInventoryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcInventoryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcInventoryTypeEnum = IfcInventoryTypeEnum;

  var IfcJunctionBoxTypeEnum = function IfcJunctionBoxTypeEnum() {
    _classCallCheck2(this, IfcJunctionBoxTypeEnum);
  };

  IfcJunctionBoxTypeEnum.DATA = {
    type: 3,
    value: "DATA"
  };
  IfcJunctionBoxTypeEnum.POWER = {
    type: 3,
    value: "POWER"
  };
  IfcJunctionBoxTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcJunctionBoxTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;

  var IfcKnotType = function IfcKnotType() {
    _classCallCheck2(this, IfcKnotType);
  };

  IfcKnotType.PIECEWISE_BEZIER_KNOTS = {
    type: 3,
    value: "PIECEWISE_BEZIER_KNOTS"
  };
  IfcKnotType.QUASI_UNIFORM_KNOTS = {
    type: 3,
    value: "QUASI_UNIFORM_KNOTS"
  };
  IfcKnotType.UNIFORM_KNOTS = {
    type: 3,
    value: "UNIFORM_KNOTS"
  };
  IfcKnotType.UNSPECIFIED = {
    type: 3,
    value: "UNSPECIFIED"
  };
  IFC4_32.IfcKnotType = IfcKnotType;

  var IfcLaborResourceTypeEnum = function IfcLaborResourceTypeEnum() {
    _classCallCheck2(this, IfcLaborResourceTypeEnum);
  };

  IfcLaborResourceTypeEnum.ADMINISTRATION = {
    type: 3,
    value: "ADMINISTRATION"
  };
  IfcLaborResourceTypeEnum.CARPENTRY = {
    type: 3,
    value: "CARPENTRY"
  };
  IfcLaborResourceTypeEnum.CLEANING = {
    type: 3,
    value: "CLEANING"
  };
  IfcLaborResourceTypeEnum.CONCRETE = {
    type: 3,
    value: "CONCRETE"
  };
  IfcLaborResourceTypeEnum.DRYWALL = {
    type: 3,
    value: "DRYWALL"
  };
  IfcLaborResourceTypeEnum.ELECTRIC = {
    type: 3,
    value: "ELECTRIC"
  };
  IfcLaborResourceTypeEnum.FINISHING = {
    type: 3,
    value: "FINISHING"
  };
  IfcLaborResourceTypeEnum.FLOORING = {
    type: 3,
    value: "FLOORING"
  };
  IfcLaborResourceTypeEnum.GENERAL = {
    type: 3,
    value: "GENERAL"
  };
  IfcLaborResourceTypeEnum.HVAC = {
    type: 3,
    value: "HVAC"
  };
  IfcLaborResourceTypeEnum.LANDSCAPING = {
    type: 3,
    value: "LANDSCAPING"
  };
  IfcLaborResourceTypeEnum.MASONRY = {
    type: 3,
    value: "MASONRY"
  };
  IfcLaborResourceTypeEnum.PAINTING = {
    type: 3,
    value: "PAINTING"
  };
  IfcLaborResourceTypeEnum.PAVING = {
    type: 3,
    value: "PAVING"
  };
  IfcLaborResourceTypeEnum.PLUMBING = {
    type: 3,
    value: "PLUMBING"
  };
  IfcLaborResourceTypeEnum.ROOFING = {
    type: 3,
    value: "ROOFING"
  };
  IfcLaborResourceTypeEnum.SITEGRADING = {
    type: 3,
    value: "SITEGRADING"
  };
  IfcLaborResourceTypeEnum.STEELWORK = {
    type: 3,
    value: "STEELWORK"
  };
  IfcLaborResourceTypeEnum.SURVEYING = {
    type: 3,
    value: "SURVEYING"
  };
  IfcLaborResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLaborResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcLaborResourceTypeEnum = IfcLaborResourceTypeEnum;

  var IfcLampTypeEnum = function IfcLampTypeEnum() {
    _classCallCheck2(this, IfcLampTypeEnum);
  };

  IfcLampTypeEnum.COMPACTFLUORESCENT = {
    type: 3,
    value: "COMPACTFLUORESCENT"
  };
  IfcLampTypeEnum.FLUORESCENT = {
    type: 3,
    value: "FLUORESCENT"
  };
  IfcLampTypeEnum.HALOGEN = {
    type: 3,
    value: "HALOGEN"
  };
  IfcLampTypeEnum.HIGHPRESSUREMERCURY = {
    type: 3,
    value: "HIGHPRESSUREMERCURY"
  };
  IfcLampTypeEnum.HIGHPRESSURESODIUM = {
    type: 3,
    value: "HIGHPRESSURESODIUM"
  };
  IfcLampTypeEnum.LED = {
    type: 3,
    value: "LED"
  };
  IfcLampTypeEnum.METALHALIDE = {
    type: 3,
    value: "METALHALIDE"
  };
  IfcLampTypeEnum.OLED = {
    type: 3,
    value: "OLED"
  };
  IfcLampTypeEnum.TUNGSTENFILAMENT = {
    type: 3,
    value: "TUNGSTENFILAMENT"
  };
  IfcLampTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLampTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcLampTypeEnum = IfcLampTypeEnum;

  var IfcLayerSetDirectionEnum = function IfcLayerSetDirectionEnum() {
    _classCallCheck2(this, IfcLayerSetDirectionEnum);
  };

  IfcLayerSetDirectionEnum.AXIS1 = {
    type: 3,
    value: "AXIS1"
  };
  IfcLayerSetDirectionEnum.AXIS2 = {
    type: 3,
    value: "AXIS2"
  };
  IfcLayerSetDirectionEnum.AXIS3 = {
    type: 3,
    value: "AXIS3"
  };
  IFC4_32.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;

  var IfcLightDistributionCurveEnum = function IfcLightDistributionCurveEnum() {
    _classCallCheck2(this, IfcLightDistributionCurveEnum);
  };

  IfcLightDistributionCurveEnum.TYPE_A = {
    type: 3,
    value: "TYPE_A"
  };
  IfcLightDistributionCurveEnum.TYPE_B = {
    type: 3,
    value: "TYPE_B"
  };
  IfcLightDistributionCurveEnum.TYPE_C = {
    type: 3,
    value: "TYPE_C"
  };
  IfcLightDistributionCurveEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;

  var IfcLightEmissionSourceEnum = function IfcLightEmissionSourceEnum() {
    _classCallCheck2(this, IfcLightEmissionSourceEnum);
  };

  IfcLightEmissionSourceEnum.COMPACTFLUORESCENT = {
    type: 3,
    value: "COMPACTFLUORESCENT"
  };
  IfcLightEmissionSourceEnum.FLUORESCENT = {
    type: 3,
    value: "FLUORESCENT"
  };
  IfcLightEmissionSourceEnum.HIGHPRESSUREMERCURY = {
    type: 3,
    value: "HIGHPRESSUREMERCURY"
  };
  IfcLightEmissionSourceEnum.HIGHPRESSURESODIUM = {
    type: 3,
    value: "HIGHPRESSURESODIUM"
  };
  IfcLightEmissionSourceEnum.LIGHTEMITTINGDIODE = {
    type: 3,
    value: "LIGHTEMITTINGDIODE"
  };
  IfcLightEmissionSourceEnum.LOWPRESSURESODIUM = {
    type: 3,
    value: "LOWPRESSURESODIUM"
  };
  IfcLightEmissionSourceEnum.LOWVOLTAGEHALOGEN = {
    type: 3,
    value: "LOWVOLTAGEHALOGEN"
  };
  IfcLightEmissionSourceEnum.MAINVOLTAGEHALOGEN = {
    type: 3,
    value: "MAINVOLTAGEHALOGEN"
  };
  IfcLightEmissionSourceEnum.METALHALIDE = {
    type: 3,
    value: "METALHALIDE"
  };
  IfcLightEmissionSourceEnum.TUNGSTENFILAMENT = {
    type: 3,
    value: "TUNGSTENFILAMENT"
  };
  IfcLightEmissionSourceEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;

  var IfcLightFixtureTypeEnum = function IfcLightFixtureTypeEnum() {
    _classCallCheck2(this, IfcLightFixtureTypeEnum);
  };

  IfcLightFixtureTypeEnum.DIRECTIONSOURCE = {
    type: 3,
    value: "DIRECTIONSOURCE"
  };
  IfcLightFixtureTypeEnum.POINTSOURCE = {
    type: 3,
    value: "POINTSOURCE"
  };
  IfcLightFixtureTypeEnum.SECURITYLIGHTING = {
    type: 3,
    value: "SECURITYLIGHTING"
  };
  IfcLightFixtureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLightFixtureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;

  var IfcLiquidTerminalTypeEnum = function IfcLiquidTerminalTypeEnum() {
    _classCallCheck2(this, IfcLiquidTerminalTypeEnum);
  };

  IfcLiquidTerminalTypeEnum.HOSEREEL = {
    type: 3,
    value: "HOSEREEL"
  };
  IfcLiquidTerminalTypeEnum.LOADINGARM = {
    type: 3,
    value: "LOADINGARM"
  };
  IfcLiquidTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLiquidTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcLiquidTerminalTypeEnum = IfcLiquidTerminalTypeEnum;

  var IfcLoadGroupTypeEnum = function IfcLoadGroupTypeEnum() {
    _classCallCheck2(this, IfcLoadGroupTypeEnum);
  };

  IfcLoadGroupTypeEnum.LOAD_CASE = {
    type: 3,
    value: "LOAD_CASE"
  };
  IfcLoadGroupTypeEnum.LOAD_COMBINATION = {
    type: 3,
    value: "LOAD_COMBINATION"
  };
  IfcLoadGroupTypeEnum.LOAD_GROUP = {
    type: 3,
    value: "LOAD_GROUP"
  };
  IfcLoadGroupTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLoadGroupTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;

  var IfcLogicalOperatorEnum = function IfcLogicalOperatorEnum() {
    _classCallCheck2(this, IfcLogicalOperatorEnum);
  };

  IfcLogicalOperatorEnum.LOGICALAND = {
    type: 3,
    value: "LOGICALAND"
  };
  IfcLogicalOperatorEnum.LOGICALNOTAND = {
    type: 3,
    value: "LOGICALNOTAND"
  };
  IfcLogicalOperatorEnum.LOGICALNOTOR = {
    type: 3,
    value: "LOGICALNOTOR"
  };
  IfcLogicalOperatorEnum.LOGICALOR = {
    type: 3,
    value: "LOGICALOR"
  };
  IfcLogicalOperatorEnum.LOGICALXOR = {
    type: 3,
    value: "LOGICALXOR"
  };
  IFC4_32.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;

  var IfcMarineFacilityTypeEnum = function IfcMarineFacilityTypeEnum() {
    _classCallCheck2(this, IfcMarineFacilityTypeEnum);
  };

  IfcMarineFacilityTypeEnum.BARRIERBEACH = {
    type: 3,
    value: "BARRIERBEACH"
  };
  IfcMarineFacilityTypeEnum.BREAKWATER = {
    type: 3,
    value: "BREAKWATER"
  };
  IfcMarineFacilityTypeEnum.CANAL = {
    type: 3,
    value: "CANAL"
  };
  IfcMarineFacilityTypeEnum.DRYDOCK = {
    type: 3,
    value: "DRYDOCK"
  };
  IfcMarineFacilityTypeEnum.FLOATINGDOCK = {
    type: 3,
    value: "FLOATINGDOCK"
  };
  IfcMarineFacilityTypeEnum.HYDROLIFT = {
    type: 3,
    value: "HYDROLIFT"
  };
  IfcMarineFacilityTypeEnum.JETTY = {
    type: 3,
    value: "JETTY"
  };
  IfcMarineFacilityTypeEnum.LAUNCHRECOVERY = {
    type: 3,
    value: "LAUNCHRECOVERY"
  };
  IfcMarineFacilityTypeEnum.MARINEDEFENCE = {
    type: 3,
    value: "MARINEDEFENCE"
  };
  IfcMarineFacilityTypeEnum.NAVIGATIONALCHANNEL = {
    type: 3,
    value: "NAVIGATIONALCHANNEL"
  };
  IfcMarineFacilityTypeEnum.PORT = {
    type: 3,
    value: "PORT"
  };
  IfcMarineFacilityTypeEnum.QUAY = {
    type: 3,
    value: "QUAY"
  };
  IfcMarineFacilityTypeEnum.REVETMENT = {
    type: 3,
    value: "REVETMENT"
  };
  IfcMarineFacilityTypeEnum.SHIPLIFT = {
    type: 3,
    value: "SHIPLIFT"
  };
  IfcMarineFacilityTypeEnum.SHIPLOCK = {
    type: 3,
    value: "SHIPLOCK"
  };
  IfcMarineFacilityTypeEnum.SHIPYARD = {
    type: 3,
    value: "SHIPYARD"
  };
  IfcMarineFacilityTypeEnum.SLIPWAY = {
    type: 3,
    value: "SLIPWAY"
  };
  IfcMarineFacilityTypeEnum.WATERWAY = {
    type: 3,
    value: "WATERWAY"
  };
  IfcMarineFacilityTypeEnum.WATERWAYSHIPLIFT = {
    type: 3,
    value: "WATERWAYSHIPLIFT"
  };
  IfcMarineFacilityTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMarineFacilityTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcMarineFacilityTypeEnum = IfcMarineFacilityTypeEnum;

  var IfcMarinePartTypeEnum = function IfcMarinePartTypeEnum() {
    _classCallCheck2(this, IfcMarinePartTypeEnum);
  };

  IfcMarinePartTypeEnum.ABOVEWATERLINE = {
    type: 3,
    value: "ABOVEWATERLINE"
  };
  IfcMarinePartTypeEnum.ANCHORAGE = {
    type: 3,
    value: "ANCHORAGE"
  };
  IfcMarinePartTypeEnum.APPROACHCHANNEL = {
    type: 3,
    value: "APPROACHCHANNEL"
  };
  IfcMarinePartTypeEnum.BELOWWATERLINE = {
    type: 3,
    value: "BELOWWATERLINE"
  };
  IfcMarinePartTypeEnum.BERTHINGSTRUCTURE = {
    type: 3,
    value: "BERTHINGSTRUCTURE"
  };
  IfcMarinePartTypeEnum.CHAMBER = {
    type: 3,
    value: "CHAMBER"
  };
  IfcMarinePartTypeEnum.CILL_LEVEL = {
    type: 3,
    value: "CILL_LEVEL"
  };
  IfcMarinePartTypeEnum.COPELEVEL = {
    type: 3,
    value: "COPELEVEL"
  };
  IfcMarinePartTypeEnum.CORE = {
    type: 3,
    value: "CORE"
  };
  IfcMarinePartTypeEnum.CREST = {
    type: 3,
    value: "CREST"
  };
  IfcMarinePartTypeEnum.GATEHEAD = {
    type: 3,
    value: "GATEHEAD"
  };
  IfcMarinePartTypeEnum.GUDINGSTRUCTURE = {
    type: 3,
    value: "GUDINGSTRUCTURE"
  };
  IfcMarinePartTypeEnum.HIGHWATERLINE = {
    type: 3,
    value: "HIGHWATERLINE"
  };
  IfcMarinePartTypeEnum.LANDFIELD = {
    type: 3,
    value: "LANDFIELD"
  };
  IfcMarinePartTypeEnum.LEEWARDSIDE = {
    type: 3,
    value: "LEEWARDSIDE"
  };
  IfcMarinePartTypeEnum.LOWWATERLINE = {
    type: 3,
    value: "LOWWATERLINE"
  };
  IfcMarinePartTypeEnum.MANUFACTURING = {
    type: 3,
    value: "MANUFACTURING"
  };
  IfcMarinePartTypeEnum.NAVIGATIONALAREA = {
    type: 3,
    value: "NAVIGATIONALAREA"
  };
  IfcMarinePartTypeEnum.PROTECTION = {
    type: 3,
    value: "PROTECTION"
  };
  IfcMarinePartTypeEnum.SHIPTRANSFER = {
    type: 3,
    value: "SHIPTRANSFER"
  };
  IfcMarinePartTypeEnum.STORAGEAREA = {
    type: 3,
    value: "STORAGEAREA"
  };
  IfcMarinePartTypeEnum.VEHICLESERVICING = {
    type: 3,
    value: "VEHICLESERVICING"
  };
  IfcMarinePartTypeEnum.WATERFIELD = {
    type: 3,
    value: "WATERFIELD"
  };
  IfcMarinePartTypeEnum.WEATHERSIDE = {
    type: 3,
    value: "WEATHERSIDE"
  };
  IfcMarinePartTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMarinePartTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcMarinePartTypeEnum = IfcMarinePartTypeEnum;

  var IfcMechanicalFastenerTypeEnum = function IfcMechanicalFastenerTypeEnum() {
    _classCallCheck2(this, IfcMechanicalFastenerTypeEnum);
  };

  IfcMechanicalFastenerTypeEnum.ANCHORBOLT = {
    type: 3,
    value: "ANCHORBOLT"
  };
  IfcMechanicalFastenerTypeEnum.BOLT = {
    type: 3,
    value: "BOLT"
  };
  IfcMechanicalFastenerTypeEnum.CHAIN = {
    type: 3,
    value: "CHAIN"
  };
  IfcMechanicalFastenerTypeEnum.COUPLER = {
    type: 3,
    value: "COUPLER"
  };
  IfcMechanicalFastenerTypeEnum.DOWEL = {
    type: 3,
    value: "DOWEL"
  };
  IfcMechanicalFastenerTypeEnum.NAIL = {
    type: 3,
    value: "NAIL"
  };
  IfcMechanicalFastenerTypeEnum.NAILPLATE = {
    type: 3,
    value: "NAILPLATE"
  };
  IfcMechanicalFastenerTypeEnum.RAILFASTENING = {
    type: 3,
    value: "RAILFASTENING"
  };
  IfcMechanicalFastenerTypeEnum.RAILJOINT = {
    type: 3,
    value: "RAILJOINT"
  };
  IfcMechanicalFastenerTypeEnum.RIVET = {
    type: 3,
    value: "RIVET"
  };
  IfcMechanicalFastenerTypeEnum.ROPE = {
    type: 3,
    value: "ROPE"
  };
  IfcMechanicalFastenerTypeEnum.SCREW = {
    type: 3,
    value: "SCREW"
  };
  IfcMechanicalFastenerTypeEnum.SHEARCONNECTOR = {
    type: 3,
    value: "SHEARCONNECTOR"
  };
  IfcMechanicalFastenerTypeEnum.STAPLE = {
    type: 3,
    value: "STAPLE"
  };
  IfcMechanicalFastenerTypeEnum.STUDSHEARCONNECTOR = {
    type: 3,
    value: "STUDSHEARCONNECTOR"
  };
  IfcMechanicalFastenerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMechanicalFastenerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcMechanicalFastenerTypeEnum = IfcMechanicalFastenerTypeEnum;

  var IfcMedicalDeviceTypeEnum = function IfcMedicalDeviceTypeEnum() {
    _classCallCheck2(this, IfcMedicalDeviceTypeEnum);
  };

  IfcMedicalDeviceTypeEnum.AIRSTATION = {
    type: 3,
    value: "AIRSTATION"
  };
  IfcMedicalDeviceTypeEnum.FEEDAIRUNIT = {
    type: 3,
    value: "FEEDAIRUNIT"
  };
  IfcMedicalDeviceTypeEnum.OXYGENGENERATOR = {
    type: 3,
    value: "OXYGENGENERATOR"
  };
  IfcMedicalDeviceTypeEnum.OXYGENPLANT = {
    type: 3,
    value: "OXYGENPLANT"
  };
  IfcMedicalDeviceTypeEnum.VACUUMSTATION = {
    type: 3,
    value: "VACUUMSTATION"
  };
  IfcMedicalDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMedicalDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcMedicalDeviceTypeEnum = IfcMedicalDeviceTypeEnum;

  var IfcMemberTypeEnum = function IfcMemberTypeEnum() {
    _classCallCheck2(this, IfcMemberTypeEnum);
  };

  IfcMemberTypeEnum.ARCH_SEGMENT = {
    type: 3,
    value: "ARCH_SEGMENT"
  };
  IfcMemberTypeEnum.BRACE = {
    type: 3,
    value: "BRACE"
  };
  IfcMemberTypeEnum.CHORD = {
    type: 3,
    value: "CHORD"
  };
  IfcMemberTypeEnum.COLLAR = {
    type: 3,
    value: "COLLAR"
  };
  IfcMemberTypeEnum.MEMBER = {
    type: 3,
    value: "MEMBER"
  };
  IfcMemberTypeEnum.MULLION = {
    type: 3,
    value: "MULLION"
  };
  IfcMemberTypeEnum.PLATE = {
    type: 3,
    value: "PLATE"
  };
  IfcMemberTypeEnum.POST = {
    type: 3,
    value: "POST"
  };
  IfcMemberTypeEnum.PURLIN = {
    type: 3,
    value: "PURLIN"
  };
  IfcMemberTypeEnum.RAFTER = {
    type: 3,
    value: "RAFTER"
  };
  IfcMemberTypeEnum.STAY_CABLE = {
    type: 3,
    value: "STAY_CABLE"
  };
  IfcMemberTypeEnum.STIFFENING_RIB = {
    type: 3,
    value: "STIFFENING_RIB"
  };
  IfcMemberTypeEnum.STRINGER = {
    type: 3,
    value: "STRINGER"
  };
  IfcMemberTypeEnum.STRUCTURALCABLE = {
    type: 3,
    value: "STRUCTURALCABLE"
  };
  IfcMemberTypeEnum.STRUT = {
    type: 3,
    value: "STRUT"
  };
  IfcMemberTypeEnum.STUD = {
    type: 3,
    value: "STUD"
  };
  IfcMemberTypeEnum.SUSPENDER = {
    type: 3,
    value: "SUSPENDER"
  };
  IfcMemberTypeEnum.SUSPENSION_CABLE = {
    type: 3,
    value: "SUSPENSION_CABLE"
  };
  IfcMemberTypeEnum.TIEBAR = {
    type: 3,
    value: "TIEBAR"
  };
  IfcMemberTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMemberTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcMemberTypeEnum = IfcMemberTypeEnum;

  var IfcMobileTelecommunicationsApplianceTypeEnum = function IfcMobileTelecommunicationsApplianceTypeEnum() {
    _classCallCheck2(this, IfcMobileTelecommunicationsApplianceTypeEnum);
  };

  IfcMobileTelecommunicationsApplianceTypeEnum.ACCESSPOINT = {
    type: 3,
    value: "ACCESSPOINT"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.BASEBANDUNIT = {
    type: 3,
    value: "BASEBANDUNIT"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.BASETRANSCEIVERSTATION = {
    type: 3,
    value: "BASETRANSCEIVERSTATION"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.E_UTRAN_NODE_B = {
    type: 3,
    value: "E_UTRAN_NODE_B"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.GATEWAY_GPRS_SUPPORT_NODE = {
    type: 3,
    value: "GATEWAY_GPRS_SUPPORT_NODE"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.MASTERUNIT = {
    type: 3,
    value: "MASTERUNIT"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.MOBILESWITCHINGCENTER = {
    type: 3,
    value: "MOBILESWITCHINGCENTER"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.MSCSERVER = {
    type: 3,
    value: "MSCSERVER"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.PACKETCONTROLUNIT = {
    type: 3,
    value: "PACKETCONTROLUNIT"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.REMOTERADIOUNIT = {
    type: 3,
    value: "REMOTERADIOUNIT"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.REMOTEUNIT = {
    type: 3,
    value: "REMOTEUNIT"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.SERVICE_GPRS_SUPPORT_NODE = {
    type: 3,
    value: "SERVICE_GPRS_SUPPORT_NODE"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.SUBSCRIBERSERVER = {
    type: 3,
    value: "SUBSCRIBERSERVER"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMobileTelecommunicationsApplianceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcMobileTelecommunicationsApplianceTypeEnum = IfcMobileTelecommunicationsApplianceTypeEnum;

  var IfcMooringDeviceTypeEnum = function IfcMooringDeviceTypeEnum() {
    _classCallCheck2(this, IfcMooringDeviceTypeEnum);
  };

  IfcMooringDeviceTypeEnum.BOLLARD = {
    type: 3,
    value: "BOLLARD"
  };
  IfcMooringDeviceTypeEnum.LINETENSIONER = {
    type: 3,
    value: "LINETENSIONER"
  };
  IfcMooringDeviceTypeEnum.MAGNETICDEVICE = {
    type: 3,
    value: "MAGNETICDEVICE"
  };
  IfcMooringDeviceTypeEnum.MOORINGHOOKS = {
    type: 3,
    value: "MOORINGHOOKS"
  };
  IfcMooringDeviceTypeEnum.VACUUMDEVICE = {
    type: 3,
    value: "VACUUMDEVICE"
  };
  IfcMooringDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMooringDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcMooringDeviceTypeEnum = IfcMooringDeviceTypeEnum;

  var IfcMotorConnectionTypeEnum = function IfcMotorConnectionTypeEnum() {
    _classCallCheck2(this, IfcMotorConnectionTypeEnum);
  };

  IfcMotorConnectionTypeEnum.BELTDRIVE = {
    type: 3,
    value: "BELTDRIVE"
  };
  IfcMotorConnectionTypeEnum.COUPLING = {
    type: 3,
    value: "COUPLING"
  };
  IfcMotorConnectionTypeEnum.DIRECTDRIVE = {
    type: 3,
    value: "DIRECTDRIVE"
  };
  IfcMotorConnectionTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMotorConnectionTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;

  var IfcNavigationElementTypeEnum = function IfcNavigationElementTypeEnum() {
    _classCallCheck2(this, IfcNavigationElementTypeEnum);
  };

  IfcNavigationElementTypeEnum.BEACON = {
    type: 3,
    value: "BEACON"
  };
  IfcNavigationElementTypeEnum.BUOY = {
    type: 3,
    value: "BUOY"
  };
  IfcNavigationElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcNavigationElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcNavigationElementTypeEnum = IfcNavigationElementTypeEnum;

  var IfcObjectTypeEnum = function IfcObjectTypeEnum() {
    _classCallCheck2(this, IfcObjectTypeEnum);
  };

  IfcObjectTypeEnum.ACTOR = {
    type: 3,
    value: "ACTOR"
  };
  IfcObjectTypeEnum.CONTROL = {
    type: 3,
    value: "CONTROL"
  };
  IfcObjectTypeEnum.GROUP = {
    type: 3,
    value: "GROUP"
  };
  IfcObjectTypeEnum.PROCESS = {
    type: 3,
    value: "PROCESS"
  };
  IfcObjectTypeEnum.PRODUCT = {
    type: 3,
    value: "PRODUCT"
  };
  IfcObjectTypeEnum.PROJECT = {
    type: 3,
    value: "PROJECT"
  };
  IfcObjectTypeEnum.RESOURCE = {
    type: 3,
    value: "RESOURCE"
  };
  IfcObjectTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcObjectTypeEnum = IfcObjectTypeEnum;

  var IfcObjectiveEnum = function IfcObjectiveEnum() {
    _classCallCheck2(this, IfcObjectiveEnum);
  };

  IfcObjectiveEnum.CODECOMPLIANCE = {
    type: 3,
    value: "CODECOMPLIANCE"
  };
  IfcObjectiveEnum.CODEWAIVER = {
    type: 3,
    value: "CODEWAIVER"
  };
  IfcObjectiveEnum.DESIGNINTENT = {
    type: 3,
    value: "DESIGNINTENT"
  };
  IfcObjectiveEnum.EXTERNAL = {
    type: 3,
    value: "EXTERNAL"
  };
  IfcObjectiveEnum.HEALTHANDSAFETY = {
    type: 3,
    value: "HEALTHANDSAFETY"
  };
  IfcObjectiveEnum.MERGECONFLICT = {
    type: 3,
    value: "MERGECONFLICT"
  };
  IfcObjectiveEnum.MODELVIEW = {
    type: 3,
    value: "MODELVIEW"
  };
  IfcObjectiveEnum.PARAMETER = {
    type: 3,
    value: "PARAMETER"
  };
  IfcObjectiveEnum.REQUIREMENT = {
    type: 3,
    value: "REQUIREMENT"
  };
  IfcObjectiveEnum.SPECIFICATION = {
    type: 3,
    value: "SPECIFICATION"
  };
  IfcObjectiveEnum.TRIGGERCONDITION = {
    type: 3,
    value: "TRIGGERCONDITION"
  };
  IfcObjectiveEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcObjectiveEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcObjectiveEnum = IfcObjectiveEnum;

  var IfcOccupantTypeEnum = function IfcOccupantTypeEnum() {
    _classCallCheck2(this, IfcOccupantTypeEnum);
  };

  IfcOccupantTypeEnum.ASSIGNEE = {
    type: 3,
    value: "ASSIGNEE"
  };
  IfcOccupantTypeEnum.ASSIGNOR = {
    type: 3,
    value: "ASSIGNOR"
  };
  IfcOccupantTypeEnum.LESSEE = {
    type: 3,
    value: "LESSEE"
  };
  IfcOccupantTypeEnum.LESSOR = {
    type: 3,
    value: "LESSOR"
  };
  IfcOccupantTypeEnum.LETTINGAGENT = {
    type: 3,
    value: "LETTINGAGENT"
  };
  IfcOccupantTypeEnum.OWNER = {
    type: 3,
    value: "OWNER"
  };
  IfcOccupantTypeEnum.TENANT = {
    type: 3,
    value: "TENANT"
  };
  IfcOccupantTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcOccupantTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcOccupantTypeEnum = IfcOccupantTypeEnum;

  var IfcOpeningElementTypeEnum = function IfcOpeningElementTypeEnum() {
    _classCallCheck2(this, IfcOpeningElementTypeEnum);
  };

  IfcOpeningElementTypeEnum.OPENING = {
    type: 3,
    value: "OPENING"
  };
  IfcOpeningElementTypeEnum.RECESS = {
    type: 3,
    value: "RECESS"
  };
  IfcOpeningElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcOpeningElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcOpeningElementTypeEnum = IfcOpeningElementTypeEnum;

  var IfcOutletTypeEnum = function IfcOutletTypeEnum() {
    _classCallCheck2(this, IfcOutletTypeEnum);
  };

  IfcOutletTypeEnum.AUDIOVISUALOUTLET = {
    type: 3,
    value: "AUDIOVISUALOUTLET"
  };
  IfcOutletTypeEnum.COMMUNICATIONSOUTLET = {
    type: 3,
    value: "COMMUNICATIONSOUTLET"
  };
  IfcOutletTypeEnum.DATAOUTLET = {
    type: 3,
    value: "DATAOUTLET"
  };
  IfcOutletTypeEnum.POWEROUTLET = {
    type: 3,
    value: "POWEROUTLET"
  };
  IfcOutletTypeEnum.TELEPHONEOUTLET = {
    type: 3,
    value: "TELEPHONEOUTLET"
  };
  IfcOutletTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcOutletTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcOutletTypeEnum = IfcOutletTypeEnum;

  var IfcPavementTypeEnum = function IfcPavementTypeEnum() {
    _classCallCheck2(this, IfcPavementTypeEnum);
  };

  IfcPavementTypeEnum.FLEXIBLE = {
    type: 3,
    value: "FLEXIBLE"
  };
  IfcPavementTypeEnum.RIGID = {
    type: 3,
    value: "RIGID"
  };
  IfcPavementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPavementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPavementTypeEnum = IfcPavementTypeEnum;

  var IfcPerformanceHistoryTypeEnum = function IfcPerformanceHistoryTypeEnum() {
    _classCallCheck2(this, IfcPerformanceHistoryTypeEnum);
  };

  IfcPerformanceHistoryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPerformanceHistoryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPerformanceHistoryTypeEnum = IfcPerformanceHistoryTypeEnum;

  var IfcPermeableCoveringOperationEnum = function IfcPermeableCoveringOperationEnum() {
    _classCallCheck2(this, IfcPermeableCoveringOperationEnum);
  };

  IfcPermeableCoveringOperationEnum.GRILL = {
    type: 3,
    value: "GRILL"
  };
  IfcPermeableCoveringOperationEnum.LOUVER = {
    type: 3,
    value: "LOUVER"
  };
  IfcPermeableCoveringOperationEnum.SCREEN = {
    type: 3,
    value: "SCREEN"
  };
  IfcPermeableCoveringOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPermeableCoveringOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;

  var IfcPermitTypeEnum = function IfcPermitTypeEnum() {
    _classCallCheck2(this, IfcPermitTypeEnum);
  };

  IfcPermitTypeEnum.ACCESS = {
    type: 3,
    value: "ACCESS"
  };
  IfcPermitTypeEnum.BUILDING = {
    type: 3,
    value: "BUILDING"
  };
  IfcPermitTypeEnum.WORK = {
    type: 3,
    value: "WORK"
  };
  IfcPermitTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPermitTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPermitTypeEnum = IfcPermitTypeEnum;

  var IfcPhysicalOrVirtualEnum = function IfcPhysicalOrVirtualEnum() {
    _classCallCheck2(this, IfcPhysicalOrVirtualEnum);
  };

  IfcPhysicalOrVirtualEnum.PHYSICAL = {
    type: 3,
    value: "PHYSICAL"
  };
  IfcPhysicalOrVirtualEnum.VIRTUAL = {
    type: 3,
    value: "VIRTUAL"
  };
  IfcPhysicalOrVirtualEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;

  var IfcPileConstructionEnum = function IfcPileConstructionEnum() {
    _classCallCheck2(this, IfcPileConstructionEnum);
  };

  IfcPileConstructionEnum.CAST_IN_PLACE = {
    type: 3,
    value: "CAST_IN_PLACE"
  };
  IfcPileConstructionEnum.COMPOSITE = {
    type: 3,
    value: "COMPOSITE"
  };
  IfcPileConstructionEnum.PRECAST_CONCRETE = {
    type: 3,
    value: "PRECAST_CONCRETE"
  };
  IfcPileConstructionEnum.PREFAB_STEEL = {
    type: 3,
    value: "PREFAB_STEEL"
  };
  IfcPileConstructionEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPileConstructionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPileConstructionEnum = IfcPileConstructionEnum;

  var IfcPileTypeEnum = function IfcPileTypeEnum() {
    _classCallCheck2(this, IfcPileTypeEnum);
  };

  IfcPileTypeEnum.BORED = {
    type: 3,
    value: "BORED"
  };
  IfcPileTypeEnum.COHESION = {
    type: 3,
    value: "COHESION"
  };
  IfcPileTypeEnum.DRIVEN = {
    type: 3,
    value: "DRIVEN"
  };
  IfcPileTypeEnum.FRICTION = {
    type: 3,
    value: "FRICTION"
  };
  IfcPileTypeEnum.JETGROUTING = {
    type: 3,
    value: "JETGROUTING"
  };
  IfcPileTypeEnum.SUPPORT = {
    type: 3,
    value: "SUPPORT"
  };
  IfcPileTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPileTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPileTypeEnum = IfcPileTypeEnum;

  var IfcPipeFittingTypeEnum = function IfcPipeFittingTypeEnum() {
    _classCallCheck2(this, IfcPipeFittingTypeEnum);
  };

  IfcPipeFittingTypeEnum.BEND = {
    type: 3,
    value: "BEND"
  };
  IfcPipeFittingTypeEnum.CONNECTOR = {
    type: 3,
    value: "CONNECTOR"
  };
  IfcPipeFittingTypeEnum.ENTRY = {
    type: 3,
    value: "ENTRY"
  };
  IfcPipeFittingTypeEnum.EXIT = {
    type: 3,
    value: "EXIT"
  };
  IfcPipeFittingTypeEnum.JUNCTION = {
    type: 3,
    value: "JUNCTION"
  };
  IfcPipeFittingTypeEnum.OBSTRUCTION = {
    type: 3,
    value: "OBSTRUCTION"
  };
  IfcPipeFittingTypeEnum.TRANSITION = {
    type: 3,
    value: "TRANSITION"
  };
  IfcPipeFittingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPipeFittingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;

  var IfcPipeSegmentTypeEnum = function IfcPipeSegmentTypeEnum() {
    _classCallCheck2(this, IfcPipeSegmentTypeEnum);
  };

  IfcPipeSegmentTypeEnum.CULVERT = {
    type: 3,
    value: "CULVERT"
  };
  IfcPipeSegmentTypeEnum.FLEXIBLESEGMENT = {
    type: 3,
    value: "FLEXIBLESEGMENT"
  };
  IfcPipeSegmentTypeEnum.GUTTER = {
    type: 3,
    value: "GUTTER"
  };
  IfcPipeSegmentTypeEnum.RIGIDSEGMENT = {
    type: 3,
    value: "RIGIDSEGMENT"
  };
  IfcPipeSegmentTypeEnum.SPOOL = {
    type: 3,
    value: "SPOOL"
  };
  IfcPipeSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPipeSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;

  var IfcPlateTypeEnum = function IfcPlateTypeEnum() {
    _classCallCheck2(this, IfcPlateTypeEnum);
  };

  IfcPlateTypeEnum.BASE_PLATE = {
    type: 3,
    value: "BASE_PLATE"
  };
  IfcPlateTypeEnum.COVER_PLATE = {
    type: 3,
    value: "COVER_PLATE"
  };
  IfcPlateTypeEnum.CURTAIN_PANEL = {
    type: 3,
    value: "CURTAIN_PANEL"
  };
  IfcPlateTypeEnum.FLANGE_PLATE = {
    type: 3,
    value: "FLANGE_PLATE"
  };
  IfcPlateTypeEnum.GUSSET_PLATE = {
    type: 3,
    value: "GUSSET_PLATE"
  };
  IfcPlateTypeEnum.SHEET = {
    type: 3,
    value: "SHEET"
  };
  IfcPlateTypeEnum.SPLICE_PLATE = {
    type: 3,
    value: "SPLICE_PLATE"
  };
  IfcPlateTypeEnum.STIFFENER_PLATE = {
    type: 3,
    value: "STIFFENER_PLATE"
  };
  IfcPlateTypeEnum.WEB_PLATE = {
    type: 3,
    value: "WEB_PLATE"
  };
  IfcPlateTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPlateTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPlateTypeEnum = IfcPlateTypeEnum;

  var IfcPreferredSurfaceCurveRepresentation = function IfcPreferredSurfaceCurveRepresentation() {
    _classCallCheck2(this, IfcPreferredSurfaceCurveRepresentation);
  };

  IfcPreferredSurfaceCurveRepresentation.CURVE3D = {
    type: 3,
    value: "CURVE3D"
  };
  IfcPreferredSurfaceCurveRepresentation.PCURVE_S1 = {
    type: 3,
    value: "PCURVE_S1"
  };
  IfcPreferredSurfaceCurveRepresentation.PCURVE_S2 = {
    type: 3,
    value: "PCURVE_S2"
  };
  IFC4_32.IfcPreferredSurfaceCurveRepresentation = IfcPreferredSurfaceCurveRepresentation;

  var IfcProcedureTypeEnum = function IfcProcedureTypeEnum() {
    _classCallCheck2(this, IfcProcedureTypeEnum);
  };

  IfcProcedureTypeEnum.ADVICE_CAUTION = {
    type: 3,
    value: "ADVICE_CAUTION"
  };
  IfcProcedureTypeEnum.ADVICE_NOTE = {
    type: 3,
    value: "ADVICE_NOTE"
  };
  IfcProcedureTypeEnum.ADVICE_WARNING = {
    type: 3,
    value: "ADVICE_WARNING"
  };
  IfcProcedureTypeEnum.CALIBRATION = {
    type: 3,
    value: "CALIBRATION"
  };
  IfcProcedureTypeEnum.DIAGNOSTIC = {
    type: 3,
    value: "DIAGNOSTIC"
  };
  IfcProcedureTypeEnum.SHUTDOWN = {
    type: 3,
    value: "SHUTDOWN"
  };
  IfcProcedureTypeEnum.STARTUP = {
    type: 3,
    value: "STARTUP"
  };
  IfcProcedureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProcedureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcProcedureTypeEnum = IfcProcedureTypeEnum;

  var IfcProfileTypeEnum = function IfcProfileTypeEnum() {
    _classCallCheck2(this, IfcProfileTypeEnum);
  };

  IfcProfileTypeEnum.AREA = {
    type: 3,
    value: "AREA"
  };
  IfcProfileTypeEnum.CURVE = {
    type: 3,
    value: "CURVE"
  };
  IFC4_32.IfcProfileTypeEnum = IfcProfileTypeEnum;

  var IfcProjectOrderTypeEnum = function IfcProjectOrderTypeEnum() {
    _classCallCheck2(this, IfcProjectOrderTypeEnum);
  };

  IfcProjectOrderTypeEnum.CHANGEORDER = {
    type: 3,
    value: "CHANGEORDER"
  };
  IfcProjectOrderTypeEnum.MAINTENANCEWORKORDER = {
    type: 3,
    value: "MAINTENANCEWORKORDER"
  };
  IfcProjectOrderTypeEnum.MOVEORDER = {
    type: 3,
    value: "MOVEORDER"
  };
  IfcProjectOrderTypeEnum.PURCHASEORDER = {
    type: 3,
    value: "PURCHASEORDER"
  };
  IfcProjectOrderTypeEnum.WORKORDER = {
    type: 3,
    value: "WORKORDER"
  };
  IfcProjectOrderTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProjectOrderTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;

  var IfcProjectedOrTrueLengthEnum = function IfcProjectedOrTrueLengthEnum() {
    _classCallCheck2(this, IfcProjectedOrTrueLengthEnum);
  };

  IfcProjectedOrTrueLengthEnum.PROJECTED_LENGTH = {
    type: 3,
    value: "PROJECTED_LENGTH"
  };
  IfcProjectedOrTrueLengthEnum.TRUE_LENGTH = {
    type: 3,
    value: "TRUE_LENGTH"
  };
  IFC4_32.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;

  var IfcProjectionElementTypeEnum = function IfcProjectionElementTypeEnum() {
    _classCallCheck2(this, IfcProjectionElementTypeEnum);
  };

  IfcProjectionElementTypeEnum.BLISTER = {
    type: 3,
    value: "BLISTER"
  };
  IfcProjectionElementTypeEnum.DEVIATOR = {
    type: 3,
    value: "DEVIATOR"
  };
  IfcProjectionElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProjectionElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcProjectionElementTypeEnum = IfcProjectionElementTypeEnum;

  var IfcPropertySetTemplateTypeEnum = function IfcPropertySetTemplateTypeEnum() {
    _classCallCheck2(this, IfcPropertySetTemplateTypeEnum);
  };

  IfcPropertySetTemplateTypeEnum.PSET_MATERIALDRIVEN = {
    type: 3,
    value: "PSET_MATERIALDRIVEN"
  };
  IfcPropertySetTemplateTypeEnum.PSET_OCCURRENCEDRIVEN = {
    type: 3,
    value: "PSET_OCCURRENCEDRIVEN"
  };
  IfcPropertySetTemplateTypeEnum.PSET_PERFORMANCEDRIVEN = {
    type: 3,
    value: "PSET_PERFORMANCEDRIVEN"
  };
  IfcPropertySetTemplateTypeEnum.PSET_PROFILEDRIVEN = {
    type: 3,
    value: "PSET_PROFILEDRIVEN"
  };
  IfcPropertySetTemplateTypeEnum.PSET_TYPEDRIVENONLY = {
    type: 3,
    value: "PSET_TYPEDRIVENONLY"
  };
  IfcPropertySetTemplateTypeEnum.PSET_TYPEDRIVENOVERRIDE = {
    type: 3,
    value: "PSET_TYPEDRIVENOVERRIDE"
  };
  IfcPropertySetTemplateTypeEnum.QTO_OCCURRENCEDRIVEN = {
    type: 3,
    value: "QTO_OCCURRENCEDRIVEN"
  };
  IfcPropertySetTemplateTypeEnum.QTO_TYPEDRIVENONLY = {
    type: 3,
    value: "QTO_TYPEDRIVENONLY"
  };
  IfcPropertySetTemplateTypeEnum.QTO_TYPEDRIVENOVERRIDE = {
    type: 3,
    value: "QTO_TYPEDRIVENOVERRIDE"
  };
  IfcPropertySetTemplateTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPropertySetTemplateTypeEnum = IfcPropertySetTemplateTypeEnum;

  var IfcProtectiveDeviceTrippingUnitTypeEnum = function IfcProtectiveDeviceTrippingUnitTypeEnum() {
    _classCallCheck2(this, IfcProtectiveDeviceTrippingUnitTypeEnum);
  };

  IfcProtectiveDeviceTrippingUnitTypeEnum.ELECTROMAGNETIC = {
    type: 3,
    value: "ELECTROMAGNETIC"
  };
  IfcProtectiveDeviceTrippingUnitTypeEnum.ELECTRONIC = {
    type: 3,
    value: "ELECTRONIC"
  };
  IfcProtectiveDeviceTrippingUnitTypeEnum.RESIDUALCURRENT = {
    type: 3,
    value: "RESIDUALCURRENT"
  };
  IfcProtectiveDeviceTrippingUnitTypeEnum.THERMAL = {
    type: 3,
    value: "THERMAL"
  };
  IfcProtectiveDeviceTrippingUnitTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProtectiveDeviceTrippingUnitTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcProtectiveDeviceTrippingUnitTypeEnum = IfcProtectiveDeviceTrippingUnitTypeEnum;

  var IfcProtectiveDeviceTypeEnum = function IfcProtectiveDeviceTypeEnum() {
    _classCallCheck2(this, IfcProtectiveDeviceTypeEnum);
  };

  IfcProtectiveDeviceTypeEnum.ANTI_ARCING_DEVICE = {
    type: 3,
    value: "ANTI_ARCING_DEVICE"
  };
  IfcProtectiveDeviceTypeEnum.CIRCUITBREAKER = {
    type: 3,
    value: "CIRCUITBREAKER"
  };
  IfcProtectiveDeviceTypeEnum.EARTHINGSWITCH = {
    type: 3,
    value: "EARTHINGSWITCH"
  };
  IfcProtectiveDeviceTypeEnum.EARTHLEAKAGECIRCUITBREAKER = {
    type: 3,
    value: "EARTHLEAKAGECIRCUITBREAKER"
  };
  IfcProtectiveDeviceTypeEnum.FUSEDISCONNECTOR = {
    type: 3,
    value: "FUSEDISCONNECTOR"
  };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTCIRCUITBREAKER = {
    type: 3,
    value: "RESIDUALCURRENTCIRCUITBREAKER"
  };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTSWITCH = {
    type: 3,
    value: "RESIDUALCURRENTSWITCH"
  };
  IfcProtectiveDeviceTypeEnum.SPARKGAP = {
    type: 3,
    value: "SPARKGAP"
  };
  IfcProtectiveDeviceTypeEnum.VARISTOR = {
    type: 3,
    value: "VARISTOR"
  };
  IfcProtectiveDeviceTypeEnum.VOLTAGELIMITER = {
    type: 3,
    value: "VOLTAGELIMITER"
  };
  IfcProtectiveDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProtectiveDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;

  var IfcPumpTypeEnum = function IfcPumpTypeEnum() {
    _classCallCheck2(this, IfcPumpTypeEnum);
  };

  IfcPumpTypeEnum.CIRCULATOR = {
    type: 3,
    value: "CIRCULATOR"
  };
  IfcPumpTypeEnum.ENDSUCTION = {
    type: 3,
    value: "ENDSUCTION"
  };
  IfcPumpTypeEnum.SPLITCASE = {
    type: 3,
    value: "SPLITCASE"
  };
  IfcPumpTypeEnum.SUBMERSIBLEPUMP = {
    type: 3,
    value: "SUBMERSIBLEPUMP"
  };
  IfcPumpTypeEnum.SUMPPUMP = {
    type: 3,
    value: "SUMPPUMP"
  };
  IfcPumpTypeEnum.VERTICALINLINE = {
    type: 3,
    value: "VERTICALINLINE"
  };
  IfcPumpTypeEnum.VERTICALTURBINE = {
    type: 3,
    value: "VERTICALTURBINE"
  };
  IfcPumpTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPumpTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcPumpTypeEnum = IfcPumpTypeEnum;

  var IfcRailTypeEnum = function IfcRailTypeEnum() {
    _classCallCheck2(this, IfcRailTypeEnum);
  };

  IfcRailTypeEnum.BLADE = {
    type: 3,
    value: "BLADE"
  };
  IfcRailTypeEnum.CHECKRAIL = {
    type: 3,
    value: "CHECKRAIL"
  };
  IfcRailTypeEnum.GUARDRAIL = {
    type: 3,
    value: "GUARDRAIL"
  };
  IfcRailTypeEnum.RACKRAIL = {
    type: 3,
    value: "RACKRAIL"
  };
  IfcRailTypeEnum.RAIL = {
    type: 3,
    value: "RAIL"
  };
  IfcRailTypeEnum.STOCKRAIL = {
    type: 3,
    value: "STOCKRAIL"
  };
  IfcRailTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRailTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcRailTypeEnum = IfcRailTypeEnum;

  var IfcRailingTypeEnum = function IfcRailingTypeEnum() {
    _classCallCheck2(this, IfcRailingTypeEnum);
  };

  IfcRailingTypeEnum.BALUSTRADE = {
    type: 3,
    value: "BALUSTRADE"
  };
  IfcRailingTypeEnum.FENCE = {
    type: 3,
    value: "FENCE"
  };
  IfcRailingTypeEnum.GUARDRAIL = {
    type: 3,
    value: "GUARDRAIL"
  };
  IfcRailingTypeEnum.HANDRAIL = {
    type: 3,
    value: "HANDRAIL"
  };
  IfcRailingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRailingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcRailingTypeEnum = IfcRailingTypeEnum;

  var IfcRailwayPartTypeEnum = function IfcRailwayPartTypeEnum() {
    _classCallCheck2(this, IfcRailwayPartTypeEnum);
  };

  IfcRailwayPartTypeEnum.DILATATIONSUPERSTRUCTURE = {
    type: 3,
    value: "DILATATIONSUPERSTRUCTURE"
  };
  IfcRailwayPartTypeEnum.LINESIDESTRUCTURE = {
    type: 3,
    value: "LINESIDESTRUCTURE"
  };
  IfcRailwayPartTypeEnum.LINESIDESTRUCTUREPART = {
    type: 3,
    value: "LINESIDESTRUCTUREPART"
  };
  IfcRailwayPartTypeEnum.PLAINTRACKSUPERSTRUCTURE = {
    type: 3,
    value: "PLAINTRACKSUPERSTRUCTURE"
  };
  IfcRailwayPartTypeEnum.SUPERSTRUCTURE = {
    type: 3,
    value: "SUPERSTRUCTURE"
  };
  IfcRailwayPartTypeEnum.TRACKSTRUCTURE = {
    type: 3,
    value: "TRACKSTRUCTURE"
  };
  IfcRailwayPartTypeEnum.TRACKSTRUCTUREPART = {
    type: 3,
    value: "TRACKSTRUCTUREPART"
  };
  IfcRailwayPartTypeEnum.TURNOUTSUPERSTRUCTURE = {
    type: 3,
    value: "TURNOUTSUPERSTRUCTURE"
  };
  IfcRailwayPartTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRailwayPartTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcRailwayPartTypeEnum = IfcRailwayPartTypeEnum;

  var IfcRailwayTypeEnum = function IfcRailwayTypeEnum() {
    _classCallCheck2(this, IfcRailwayTypeEnum);
  };

  IfcRailwayTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRailwayTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcRailwayTypeEnum = IfcRailwayTypeEnum;

  var IfcRampFlightTypeEnum = function IfcRampFlightTypeEnum() {
    _classCallCheck2(this, IfcRampFlightTypeEnum);
  };

  IfcRampFlightTypeEnum.SPIRAL = {
    type: 3,
    value: "SPIRAL"
  };
  IfcRampFlightTypeEnum.STRAIGHT = {
    type: 3,
    value: "STRAIGHT"
  };
  IfcRampFlightTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRampFlightTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;

  var IfcRampTypeEnum = function IfcRampTypeEnum() {
    _classCallCheck2(this, IfcRampTypeEnum);
  };

  IfcRampTypeEnum.HALF_TURN_RAMP = {
    type: 3,
    value: "HALF_TURN_RAMP"
  };
  IfcRampTypeEnum.QUARTER_TURN_RAMP = {
    type: 3,
    value: "QUARTER_TURN_RAMP"
  };
  IfcRampTypeEnum.SPIRAL_RAMP = {
    type: 3,
    value: "SPIRAL_RAMP"
  };
  IfcRampTypeEnum.STRAIGHT_RUN_RAMP = {
    type: 3,
    value: "STRAIGHT_RUN_RAMP"
  };
  IfcRampTypeEnum.TWO_QUARTER_TURN_RAMP = {
    type: 3,
    value: "TWO_QUARTER_TURN_RAMP"
  };
  IfcRampTypeEnum.TWO_STRAIGHT_RUN_RAMP = {
    type: 3,
    value: "TWO_STRAIGHT_RUN_RAMP"
  };
  IfcRampTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRampTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcRampTypeEnum = IfcRampTypeEnum;

  var IfcRecurrenceTypeEnum = function IfcRecurrenceTypeEnum() {
    _classCallCheck2(this, IfcRecurrenceTypeEnum);
  };

  IfcRecurrenceTypeEnum.BY_DAY_COUNT = {
    type: 3,
    value: "BY_DAY_COUNT"
  };
  IfcRecurrenceTypeEnum.BY_WEEKDAY_COUNT = {
    type: 3,
    value: "BY_WEEKDAY_COUNT"
  };
  IfcRecurrenceTypeEnum.DAILY = {
    type: 3,
    value: "DAILY"
  };
  IfcRecurrenceTypeEnum.MONTHLY_BY_DAY_OF_MONTH = {
    type: 3,
    value: "MONTHLY_BY_DAY_OF_MONTH"
  };
  IfcRecurrenceTypeEnum.MONTHLY_BY_POSITION = {
    type: 3,
    value: "MONTHLY_BY_POSITION"
  };
  IfcRecurrenceTypeEnum.WEEKLY = {
    type: 3,
    value: "WEEKLY"
  };
  IfcRecurrenceTypeEnum.YEARLY_BY_DAY_OF_MONTH = {
    type: 3,
    value: "YEARLY_BY_DAY_OF_MONTH"
  };
  IfcRecurrenceTypeEnum.YEARLY_BY_POSITION = {
    type: 3,
    value: "YEARLY_BY_POSITION"
  };
  IFC4_32.IfcRecurrenceTypeEnum = IfcRecurrenceTypeEnum;

  var IfcReferentTypeEnum = function IfcReferentTypeEnum() {
    _classCallCheck2(this, IfcReferentTypeEnum);
  };

  IfcReferentTypeEnum.BOUNDARY = {
    type: 3,
    value: "BOUNDARY"
  };
  IfcReferentTypeEnum.INTERSECTION = {
    type: 3,
    value: "INTERSECTION"
  };
  IfcReferentTypeEnum.KILOPOINT = {
    type: 3,
    value: "KILOPOINT"
  };
  IfcReferentTypeEnum.LANDMARK = {
    type: 3,
    value: "LANDMARK"
  };
  IfcReferentTypeEnum.MILEPOINT = {
    type: 3,
    value: "MILEPOINT"
  };
  IfcReferentTypeEnum.POSITION = {
    type: 3,
    value: "POSITION"
  };
  IfcReferentTypeEnum.REFERENCEMARKER = {
    type: 3,
    value: "REFERENCEMARKER"
  };
  IfcReferentTypeEnum.STATION = {
    type: 3,
    value: "STATION"
  };
  IfcReferentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcReferentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcReferentTypeEnum = IfcReferentTypeEnum;

  var IfcReflectanceMethodEnum = function IfcReflectanceMethodEnum() {
    _classCallCheck2(this, IfcReflectanceMethodEnum);
  };

  IfcReflectanceMethodEnum.BLINN = {
    type: 3,
    value: "BLINN"
  };
  IfcReflectanceMethodEnum.FLAT = {
    type: 3,
    value: "FLAT"
  };
  IfcReflectanceMethodEnum.GLASS = {
    type: 3,
    value: "GLASS"
  };
  IfcReflectanceMethodEnum.MATT = {
    type: 3,
    value: "MATT"
  };
  IfcReflectanceMethodEnum.METAL = {
    type: 3,
    value: "METAL"
  };
  IfcReflectanceMethodEnum.MIRROR = {
    type: 3,
    value: "MIRROR"
  };
  IfcReflectanceMethodEnum.PHONG = {
    type: 3,
    value: "PHONG"
  };
  IfcReflectanceMethodEnum.PHYSICAL = {
    type: 3,
    value: "PHYSICAL"
  };
  IfcReflectanceMethodEnum.PLASTIC = {
    type: 3,
    value: "PLASTIC"
  };
  IfcReflectanceMethodEnum.STRAUSS = {
    type: 3,
    value: "STRAUSS"
  };
  IfcReflectanceMethodEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;

  var IfcReinforcedSoilTypeEnum = function IfcReinforcedSoilTypeEnum() {
    _classCallCheck2(this, IfcReinforcedSoilTypeEnum);
  };

  IfcReinforcedSoilTypeEnum.DYNAMICALLYCOMPACTED = {
    type: 3,
    value: "DYNAMICALLYCOMPACTED"
  };
  IfcReinforcedSoilTypeEnum.GROUTED = {
    type: 3,
    value: "GROUTED"
  };
  IfcReinforcedSoilTypeEnum.REPLACED = {
    type: 3,
    value: "REPLACED"
  };
  IfcReinforcedSoilTypeEnum.ROLLERCOMPACTED = {
    type: 3,
    value: "ROLLERCOMPACTED"
  };
  IfcReinforcedSoilTypeEnum.SURCHARGEPRELOADED = {
    type: 3,
    value: "SURCHARGEPRELOADED"
  };
  IfcReinforcedSoilTypeEnum.VERTICALLYDRAINED = {
    type: 3,
    value: "VERTICALLYDRAINED"
  };
  IfcReinforcedSoilTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcReinforcedSoilTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcReinforcedSoilTypeEnum = IfcReinforcedSoilTypeEnum;

  var IfcReinforcingBarRoleEnum = function IfcReinforcingBarRoleEnum() {
    _classCallCheck2(this, IfcReinforcingBarRoleEnum);
  };

  IfcReinforcingBarRoleEnum.ANCHORING = {
    type: 3,
    value: "ANCHORING"
  };
  IfcReinforcingBarRoleEnum.EDGE = {
    type: 3,
    value: "EDGE"
  };
  IfcReinforcingBarRoleEnum.LIGATURE = {
    type: 3,
    value: "LIGATURE"
  };
  IfcReinforcingBarRoleEnum.MAIN = {
    type: 3,
    value: "MAIN"
  };
  IfcReinforcingBarRoleEnum.PUNCHING = {
    type: 3,
    value: "PUNCHING"
  };
  IfcReinforcingBarRoleEnum.RING = {
    type: 3,
    value: "RING"
  };
  IfcReinforcingBarRoleEnum.SHEAR = {
    type: 3,
    value: "SHEAR"
  };
  IfcReinforcingBarRoleEnum.STUD = {
    type: 3,
    value: "STUD"
  };
  IfcReinforcingBarRoleEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcReinforcingBarRoleEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;

  var IfcReinforcingBarSurfaceEnum = function IfcReinforcingBarSurfaceEnum() {
    _classCallCheck2(this, IfcReinforcingBarSurfaceEnum);
  };

  IfcReinforcingBarSurfaceEnum.PLAIN = {
    type: 3,
    value: "PLAIN"
  };
  IfcReinforcingBarSurfaceEnum.TEXTURED = {
    type: 3,
    value: "TEXTURED"
  };
  IFC4_32.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;

  var IfcReinforcingBarTypeEnum = function IfcReinforcingBarTypeEnum() {
    _classCallCheck2(this, IfcReinforcingBarTypeEnum);
  };

  IfcReinforcingBarTypeEnum.ANCHORING = {
    type: 3,
    value: "ANCHORING"
  };
  IfcReinforcingBarTypeEnum.EDGE = {
    type: 3,
    value: "EDGE"
  };
  IfcReinforcingBarTypeEnum.LIGATURE = {
    type: 3,
    value: "LIGATURE"
  };
  IfcReinforcingBarTypeEnum.MAIN = {
    type: 3,
    value: "MAIN"
  };
  IfcReinforcingBarTypeEnum.PUNCHING = {
    type: 3,
    value: "PUNCHING"
  };
  IfcReinforcingBarTypeEnum.RING = {
    type: 3,
    value: "RING"
  };
  IfcReinforcingBarTypeEnum.SHEAR = {
    type: 3,
    value: "SHEAR"
  };
  IfcReinforcingBarTypeEnum.SPACEBAR = {
    type: 3,
    value: "SPACEBAR"
  };
  IfcReinforcingBarTypeEnum.STUD = {
    type: 3,
    value: "STUD"
  };
  IfcReinforcingBarTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcReinforcingBarTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcReinforcingBarTypeEnum = IfcReinforcingBarTypeEnum;

  var IfcReinforcingMeshTypeEnum = function IfcReinforcingMeshTypeEnum() {
    _classCallCheck2(this, IfcReinforcingMeshTypeEnum);
  };

  IfcReinforcingMeshTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcReinforcingMeshTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcReinforcingMeshTypeEnum = IfcReinforcingMeshTypeEnum;

  var IfcRoadPartTypeEnum = function IfcRoadPartTypeEnum() {
    _classCallCheck2(this, IfcRoadPartTypeEnum);
  };

  IfcRoadPartTypeEnum.BICYCLECROSSING = {
    type: 3,
    value: "BICYCLECROSSING"
  };
  IfcRoadPartTypeEnum.BUS_STOP = {
    type: 3,
    value: "BUS_STOP"
  };
  IfcRoadPartTypeEnum.CARRIAGEWAY = {
    type: 3,
    value: "CARRIAGEWAY"
  };
  IfcRoadPartTypeEnum.CENTRALISLAND = {
    type: 3,
    value: "CENTRALISLAND"
  };
  IfcRoadPartTypeEnum.CENTRALRESERVE = {
    type: 3,
    value: "CENTRALRESERVE"
  };
  IfcRoadPartTypeEnum.HARDSHOULDER = {
    type: 3,
    value: "HARDSHOULDER"
  };
  IfcRoadPartTypeEnum.INTERSECTION = {
    type: 3,
    value: "INTERSECTION"
  };
  IfcRoadPartTypeEnum.LAYBY = {
    type: 3,
    value: "LAYBY"
  };
  IfcRoadPartTypeEnum.PARKINGBAY = {
    type: 3,
    value: "PARKINGBAY"
  };
  IfcRoadPartTypeEnum.PASSINGBAY = {
    type: 3,
    value: "PASSINGBAY"
  };
  IfcRoadPartTypeEnum.PEDESTRIAN_CROSSING = {
    type: 3,
    value: "PEDESTRIAN_CROSSING"
  };
  IfcRoadPartTypeEnum.RAILWAYCROSSING = {
    type: 3,
    value: "RAILWAYCROSSING"
  };
  IfcRoadPartTypeEnum.REFUGEISLAND = {
    type: 3,
    value: "REFUGEISLAND"
  };
  IfcRoadPartTypeEnum.ROADSEGMENT = {
    type: 3,
    value: "ROADSEGMENT"
  };
  IfcRoadPartTypeEnum.ROADSIDE = {
    type: 3,
    value: "ROADSIDE"
  };
  IfcRoadPartTypeEnum.ROADSIDEPART = {
    type: 3,
    value: "ROADSIDEPART"
  };
  IfcRoadPartTypeEnum.ROADWAYPLATEAU = {
    type: 3,
    value: "ROADWAYPLATEAU"
  };
  IfcRoadPartTypeEnum.ROUNDABOUT = {
    type: 3,
    value: "ROUNDABOUT"
  };
  IfcRoadPartTypeEnum.SHOULDER = {
    type: 3,
    value: "SHOULDER"
  };
  IfcRoadPartTypeEnum.SIDEWALK = {
    type: 3,
    value: "SIDEWALK"
  };
  IfcRoadPartTypeEnum.SOFTSHOULDER = {
    type: 3,
    value: "SOFTSHOULDER"
  };
  IfcRoadPartTypeEnum.TOLLPLAZA = {
    type: 3,
    value: "TOLLPLAZA"
  };
  IfcRoadPartTypeEnum.TRAFFICISLAND = {
    type: 3,
    value: "TRAFFICISLAND"
  };
  IfcRoadPartTypeEnum.TRAFFICLANE = {
    type: 3,
    value: "TRAFFICLANE"
  };
  IfcRoadPartTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRoadPartTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcRoadPartTypeEnum = IfcRoadPartTypeEnum;

  var IfcRoadTypeEnum = function IfcRoadTypeEnum() {
    _classCallCheck2(this, IfcRoadTypeEnum);
  };

  IfcRoadTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRoadTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcRoadTypeEnum = IfcRoadTypeEnum;

  var IfcRoleEnum = function IfcRoleEnum() {
    _classCallCheck2(this, IfcRoleEnum);
  };

  IfcRoleEnum.ARCHITECT = {
    type: 3,
    value: "ARCHITECT"
  };
  IfcRoleEnum.BUILDINGOPERATOR = {
    type: 3,
    value: "BUILDINGOPERATOR"
  };
  IfcRoleEnum.BUILDINGOWNER = {
    type: 3,
    value: "BUILDINGOWNER"
  };
  IfcRoleEnum.CIVILENGINEER = {
    type: 3,
    value: "CIVILENGINEER"
  };
  IfcRoleEnum.CLIENT = {
    type: 3,
    value: "CLIENT"
  };
  IfcRoleEnum.COMMISSIONINGENGINEER = {
    type: 3,
    value: "COMMISSIONINGENGINEER"
  };
  IfcRoleEnum.CONSTRUCTIONMANAGER = {
    type: 3,
    value: "CONSTRUCTIONMANAGER"
  };
  IfcRoleEnum.CONSULTANT = {
    type: 3,
    value: "CONSULTANT"
  };
  IfcRoleEnum.CONTRACTOR = {
    type: 3,
    value: "CONTRACTOR"
  };
  IfcRoleEnum.COSTENGINEER = {
    type: 3,
    value: "COSTENGINEER"
  };
  IfcRoleEnum.ELECTRICALENGINEER = {
    type: 3,
    value: "ELECTRICALENGINEER"
  };
  IfcRoleEnum.ENGINEER = {
    type: 3,
    value: "ENGINEER"
  };
  IfcRoleEnum.FACILITIESMANAGER = {
    type: 3,
    value: "FACILITIESMANAGER"
  };
  IfcRoleEnum.FIELDCONSTRUCTIONMANAGER = {
    type: 3,
    value: "FIELDCONSTRUCTIONMANAGER"
  };
  IfcRoleEnum.MANUFACTURER = {
    type: 3,
    value: "MANUFACTURER"
  };
  IfcRoleEnum.MECHANICALENGINEER = {
    type: 3,
    value: "MECHANICALENGINEER"
  };
  IfcRoleEnum.OWNER = {
    type: 3,
    value: "OWNER"
  };
  IfcRoleEnum.PROJECTMANAGER = {
    type: 3,
    value: "PROJECTMANAGER"
  };
  IfcRoleEnum.RESELLER = {
    type: 3,
    value: "RESELLER"
  };
  IfcRoleEnum.STRUCTURALENGINEER = {
    type: 3,
    value: "STRUCTURALENGINEER"
  };
  IfcRoleEnum.SUBCONTRACTOR = {
    type: 3,
    value: "SUBCONTRACTOR"
  };
  IfcRoleEnum.SUPPLIER = {
    type: 3,
    value: "SUPPLIER"
  };
  IfcRoleEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC4_32.IfcRoleEnum = IfcRoleEnum;

  var IfcRoofTypeEnum = function IfcRoofTypeEnum() {
    _classCallCheck2(this, IfcRoofTypeEnum);
  };

  IfcRoofTypeEnum.BARREL_ROOF = {
    type: 3,
    value: "BARREL_ROOF"
  };
  IfcRoofTypeEnum.BUTTERFLY_ROOF = {
    type: 3,
    value: "BUTTERFLY_ROOF"
  };
  IfcRoofTypeEnum.DOME_ROOF = {
    type: 3,
    value: "DOME_ROOF"
  };
  IfcRoofTypeEnum.FLAT_ROOF = {
    type: 3,
    value: "FLAT_ROOF"
  };
  IfcRoofTypeEnum.FREEFORM = {
    type: 3,
    value: "FREEFORM"
  };
  IfcRoofTypeEnum.GABLE_ROOF = {
    type: 3,
    value: "GABLE_ROOF"
  };
  IfcRoofTypeEnum.GAMBREL_ROOF = {
    type: 3,
    value: "GAMBREL_ROOF"
  };
  IfcRoofTypeEnum.HIPPED_GABLE_ROOF = {
    type: 3,
    value: "HIPPED_GABLE_ROOF"
  };
  IfcRoofTypeEnum.HIP_ROOF = {
    type: 3,
    value: "HIP_ROOF"
  };
  IfcRoofTypeEnum.MANSARD_ROOF = {
    type: 3,
    value: "MANSARD_ROOF"
  };
  IfcRoofTypeEnum.PAVILION_ROOF = {
    type: 3,
    value: "PAVILION_ROOF"
  };
  IfcRoofTypeEnum.RAINBOW_ROOF = {
    type: 3,
    value: "RAINBOW_ROOF"
  };
  IfcRoofTypeEnum.SHED_ROOF = {
    type: 3,
    value: "SHED_ROOF"
  };
  IfcRoofTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRoofTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcRoofTypeEnum = IfcRoofTypeEnum;

  var IfcSIPrefix = function IfcSIPrefix() {
    _classCallCheck2(this, IfcSIPrefix);
  };

  IfcSIPrefix.ATTO = {
    type: 3,
    value: "ATTO"
  };
  IfcSIPrefix.CENTI = {
    type: 3,
    value: "CENTI"
  };
  IfcSIPrefix.DECA = {
    type: 3,
    value: "DECA"
  };
  IfcSIPrefix.DECI = {
    type: 3,
    value: "DECI"
  };
  IfcSIPrefix.EXA = {
    type: 3,
    value: "EXA"
  };
  IfcSIPrefix.FEMTO = {
    type: 3,
    value: "FEMTO"
  };
  IfcSIPrefix.GIGA = {
    type: 3,
    value: "GIGA"
  };
  IfcSIPrefix.HECTO = {
    type: 3,
    value: "HECTO"
  };
  IfcSIPrefix.KILO = {
    type: 3,
    value: "KILO"
  };
  IfcSIPrefix.MEGA = {
    type: 3,
    value: "MEGA"
  };
  IfcSIPrefix.MICRO = {
    type: 3,
    value: "MICRO"
  };
  IfcSIPrefix.MILLI = {
    type: 3,
    value: "MILLI"
  };
  IfcSIPrefix.NANO = {
    type: 3,
    value: "NANO"
  };
  IfcSIPrefix.PETA = {
    type: 3,
    value: "PETA"
  };
  IfcSIPrefix.PICO = {
    type: 3,
    value: "PICO"
  };
  IfcSIPrefix.TERA = {
    type: 3,
    value: "TERA"
  };
  IFC4_32.IfcSIPrefix = IfcSIPrefix;

  var IfcSIUnitName = function IfcSIUnitName() {
    _classCallCheck2(this, IfcSIUnitName);
  };

  IfcSIUnitName.AMPERE = {
    type: 3,
    value: "AMPERE"
  };
  IfcSIUnitName.BECQUEREL = {
    type: 3,
    value: "BECQUEREL"
  };
  IfcSIUnitName.CANDELA = {
    type: 3,
    value: "CANDELA"
  };
  IfcSIUnitName.COULOMB = {
    type: 3,
    value: "COULOMB"
  };
  IfcSIUnitName.CUBIC_METRE = {
    type: 3,
    value: "CUBIC_METRE"
  };
  IfcSIUnitName.DEGREE_CELSIUS = {
    type: 3,
    value: "DEGREE_CELSIUS"
  };
  IfcSIUnitName.FARAD = {
    type: 3,
    value: "FARAD"
  };
  IfcSIUnitName.GRAM = {
    type: 3,
    value: "GRAM"
  };
  IfcSIUnitName.GRAY = {
    type: 3,
    value: "GRAY"
  };
  IfcSIUnitName.HENRY = {
    type: 3,
    value: "HENRY"
  };
  IfcSIUnitName.HERTZ = {
    type: 3,
    value: "HERTZ"
  };
  IfcSIUnitName.JOULE = {
    type: 3,
    value: "JOULE"
  };
  IfcSIUnitName.KELVIN = {
    type: 3,
    value: "KELVIN"
  };
  IfcSIUnitName.LUMEN = {
    type: 3,
    value: "LUMEN"
  };
  IfcSIUnitName.LUX = {
    type: 3,
    value: "LUX"
  };
  IfcSIUnitName.METRE = {
    type: 3,
    value: "METRE"
  };
  IfcSIUnitName.MOLE = {
    type: 3,
    value: "MOLE"
  };
  IfcSIUnitName.NEWTON = {
    type: 3,
    value: "NEWTON"
  };
  IfcSIUnitName.OHM = {
    type: 3,
    value: "OHM"
  };
  IfcSIUnitName.PASCAL = {
    type: 3,
    value: "PASCAL"
  };
  IfcSIUnitName.RADIAN = {
    type: 3,
    value: "RADIAN"
  };
  IfcSIUnitName.SECOND = {
    type: 3,
    value: "SECOND"
  };
  IfcSIUnitName.SIEMENS = {
    type: 3,
    value: "SIEMENS"
  };
  IfcSIUnitName.SIEVERT = {
    type: 3,
    value: "SIEVERT"
  };
  IfcSIUnitName.SQUARE_METRE = {
    type: 3,
    value: "SQUARE_METRE"
  };
  IfcSIUnitName.STERADIAN = {
    type: 3,
    value: "STERADIAN"
  };
  IfcSIUnitName.TESLA = {
    type: 3,
    value: "TESLA"
  };
  IfcSIUnitName.VOLT = {
    type: 3,
    value: "VOLT"
  };
  IfcSIUnitName.WATT = {
    type: 3,
    value: "WATT"
  };
  IfcSIUnitName.WEBER = {
    type: 3,
    value: "WEBER"
  };
  IFC4_32.IfcSIUnitName = IfcSIUnitName;

  var IfcSanitaryTerminalTypeEnum = function IfcSanitaryTerminalTypeEnum() {
    _classCallCheck2(this, IfcSanitaryTerminalTypeEnum);
  };

  IfcSanitaryTerminalTypeEnum.BATH = {
    type: 3,
    value: "BATH"
  };
  IfcSanitaryTerminalTypeEnum.BIDET = {
    type: 3,
    value: "BIDET"
  };
  IfcSanitaryTerminalTypeEnum.CISTERN = {
    type: 3,
    value: "CISTERN"
  };
  IfcSanitaryTerminalTypeEnum.SANITARYFOUNTAIN = {
    type: 3,
    value: "SANITARYFOUNTAIN"
  };
  IfcSanitaryTerminalTypeEnum.SHOWER = {
    type: 3,
    value: "SHOWER"
  };
  IfcSanitaryTerminalTypeEnum.SINK = {
    type: 3,
    value: "SINK"
  };
  IfcSanitaryTerminalTypeEnum.TOILETPAN = {
    type: 3,
    value: "TOILETPAN"
  };
  IfcSanitaryTerminalTypeEnum.URINAL = {
    type: 3,
    value: "URINAL"
  };
  IfcSanitaryTerminalTypeEnum.WASHHANDBASIN = {
    type: 3,
    value: "WASHHANDBASIN"
  };
  IfcSanitaryTerminalTypeEnum.WCSEAT = {
    type: 3,
    value: "WCSEAT"
  };
  IfcSanitaryTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSanitaryTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;

  var IfcSectionTypeEnum = function IfcSectionTypeEnum() {
    _classCallCheck2(this, IfcSectionTypeEnum);
  };

  IfcSectionTypeEnum.TAPERED = {
    type: 3,
    value: "TAPERED"
  };
  IfcSectionTypeEnum.UNIFORM = {
    type: 3,
    value: "UNIFORM"
  };
  IFC4_32.IfcSectionTypeEnum = IfcSectionTypeEnum;

  var IfcSensorTypeEnum = function IfcSensorTypeEnum() {
    _classCallCheck2(this, IfcSensorTypeEnum);
  };

  IfcSensorTypeEnum.CO2SENSOR = {
    type: 3,
    value: "CO2SENSOR"
  };
  IfcSensorTypeEnum.CONDUCTANCESENSOR = {
    type: 3,
    value: "CONDUCTANCESENSOR"
  };
  IfcSensorTypeEnum.CONTACTSENSOR = {
    type: 3,
    value: "CONTACTSENSOR"
  };
  IfcSensorTypeEnum.COSENSOR = {
    type: 3,
    value: "COSENSOR"
  };
  IfcSensorTypeEnum.EARTHQUAKESENSOR = {
    type: 3,
    value: "EARTHQUAKESENSOR"
  };
  IfcSensorTypeEnum.FIRESENSOR = {
    type: 3,
    value: "FIRESENSOR"
  };
  IfcSensorTypeEnum.FLOWSENSOR = {
    type: 3,
    value: "FLOWSENSOR"
  };
  IfcSensorTypeEnum.FOREIGNOBJECTDETECTIONSENSOR = {
    type: 3,
    value: "FOREIGNOBJECTDETECTIONSENSOR"
  };
  IfcSensorTypeEnum.FROSTSENSOR = {
    type: 3,
    value: "FROSTSENSOR"
  };
  IfcSensorTypeEnum.GASSENSOR = {
    type: 3,
    value: "GASSENSOR"
  };
  IfcSensorTypeEnum.HEATSENSOR = {
    type: 3,
    value: "HEATSENSOR"
  };
  IfcSensorTypeEnum.HUMIDITYSENSOR = {
    type: 3,
    value: "HUMIDITYSENSOR"
  };
  IfcSensorTypeEnum.IDENTIFIERSENSOR = {
    type: 3,
    value: "IDENTIFIERSENSOR"
  };
  IfcSensorTypeEnum.IONCONCENTRATIONSENSOR = {
    type: 3,
    value: "IONCONCENTRATIONSENSOR"
  };
  IfcSensorTypeEnum.LEVELSENSOR = {
    type: 3,
    value: "LEVELSENSOR"
  };
  IfcSensorTypeEnum.LIGHTSENSOR = {
    type: 3,
    value: "LIGHTSENSOR"
  };
  IfcSensorTypeEnum.MOISTURESENSOR = {
    type: 3,
    value: "MOISTURESENSOR"
  };
  IfcSensorTypeEnum.MOVEMENTSENSOR = {
    type: 3,
    value: "MOVEMENTSENSOR"
  };
  IfcSensorTypeEnum.OBSTACLESENSOR = {
    type: 3,
    value: "OBSTACLESENSOR"
  };
  IfcSensorTypeEnum.PHSENSOR = {
    type: 3,
    value: "PHSENSOR"
  };
  IfcSensorTypeEnum.PRESSURESENSOR = {
    type: 3,
    value: "PRESSURESENSOR"
  };
  IfcSensorTypeEnum.RADIATIONSENSOR = {
    type: 3,
    value: "RADIATIONSENSOR"
  };
  IfcSensorTypeEnum.RADIOACTIVITYSENSOR = {
    type: 3,
    value: "RADIOACTIVITYSENSOR"
  };
  IfcSensorTypeEnum.RAINSENSOR = {
    type: 3,
    value: "RAINSENSOR"
  };
  IfcSensorTypeEnum.SMOKESENSOR = {
    type: 3,
    value: "SMOKESENSOR"
  };
  IfcSensorTypeEnum.SNOWDEPTHSENSOR = {
    type: 3,
    value: "SNOWDEPTHSENSOR"
  };
  IfcSensorTypeEnum.SOUNDSENSOR = {
    type: 3,
    value: "SOUNDSENSOR"
  };
  IfcSensorTypeEnum.TEMPERATURESENSOR = {
    type: 3,
    value: "TEMPERATURESENSOR"
  };
  IfcSensorTypeEnum.TRAINSENSOR = {
    type: 3,
    value: "TRAINSENSOR"
  };
  IfcSensorTypeEnum.TURNOUTCLOSURESENSOR = {
    type: 3,
    value: "TURNOUTCLOSURESENSOR"
  };
  IfcSensorTypeEnum.WHEELSENSOR = {
    type: 3,
    value: "WHEELSENSOR"
  };
  IfcSensorTypeEnum.WINDSENSOR = {
    type: 3,
    value: "WINDSENSOR"
  };
  IfcSensorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSensorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSensorTypeEnum = IfcSensorTypeEnum;

  var IfcSequenceEnum = function IfcSequenceEnum() {
    _classCallCheck2(this, IfcSequenceEnum);
  };

  IfcSequenceEnum.FINISH_FINISH = {
    type: 3,
    value: "FINISH_FINISH"
  };
  IfcSequenceEnum.FINISH_START = {
    type: 3,
    value: "FINISH_START"
  };
  IfcSequenceEnum.START_FINISH = {
    type: 3,
    value: "START_FINISH"
  };
  IfcSequenceEnum.START_START = {
    type: 3,
    value: "START_START"
  };
  IfcSequenceEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSequenceEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSequenceEnum = IfcSequenceEnum;

  var IfcShadingDeviceTypeEnum = function IfcShadingDeviceTypeEnum() {
    _classCallCheck2(this, IfcShadingDeviceTypeEnum);
  };

  IfcShadingDeviceTypeEnum.AWNING = {
    type: 3,
    value: "AWNING"
  };
  IfcShadingDeviceTypeEnum.JALOUSIE = {
    type: 3,
    value: "JALOUSIE"
  };
  IfcShadingDeviceTypeEnum.SHUTTER = {
    type: 3,
    value: "SHUTTER"
  };
  IfcShadingDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcShadingDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcShadingDeviceTypeEnum = IfcShadingDeviceTypeEnum;

  var IfcSignTypeEnum = function IfcSignTypeEnum() {
    _classCallCheck2(this, IfcSignTypeEnum);
  };

  IfcSignTypeEnum.MARKER = {
    type: 3,
    value: "MARKER"
  };
  IfcSignTypeEnum.MIRROR = {
    type: 3,
    value: "MIRROR"
  };
  IfcSignTypeEnum.PICTORAL = {
    type: 3,
    value: "PICTORAL"
  };
  IfcSignTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSignTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSignTypeEnum = IfcSignTypeEnum;

  var IfcSignalTypeEnum = function IfcSignalTypeEnum() {
    _classCallCheck2(this, IfcSignalTypeEnum);
  };

  IfcSignalTypeEnum.AUDIO = {
    type: 3,
    value: "AUDIO"
  };
  IfcSignalTypeEnum.MIXED = {
    type: 3,
    value: "MIXED"
  };
  IfcSignalTypeEnum.VISUAL = {
    type: 3,
    value: "VISUAL"
  };
  IfcSignalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSignalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSignalTypeEnum = IfcSignalTypeEnum;

  var IfcSimplePropertyTemplateTypeEnum = function IfcSimplePropertyTemplateTypeEnum() {
    _classCallCheck2(this, IfcSimplePropertyTemplateTypeEnum);
  };

  IfcSimplePropertyTemplateTypeEnum.P_BOUNDEDVALUE = {
    type: 3,
    value: "P_BOUNDEDVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.P_ENUMERATEDVALUE = {
    type: 3,
    value: "P_ENUMERATEDVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.P_LISTVALUE = {
    type: 3,
    value: "P_LISTVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.P_REFERENCEVALUE = {
    type: 3,
    value: "P_REFERENCEVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.P_SINGLEVALUE = {
    type: 3,
    value: "P_SINGLEVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.P_TABLEVALUE = {
    type: 3,
    value: "P_TABLEVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_AREA = {
    type: 3,
    value: "Q_AREA"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_COUNT = {
    type: 3,
    value: "Q_COUNT"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_LENGTH = {
    type: 3,
    value: "Q_LENGTH"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_NUMBER = {
    type: 3,
    value: "Q_NUMBER"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_TIME = {
    type: 3,
    value: "Q_TIME"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_VOLUME = {
    type: 3,
    value: "Q_VOLUME"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_WEIGHT = {
    type: 3,
    value: "Q_WEIGHT"
  };
  IFC4_32.IfcSimplePropertyTemplateTypeEnum = IfcSimplePropertyTemplateTypeEnum;

  var IfcSlabTypeEnum = function IfcSlabTypeEnum() {
    _classCallCheck2(this, IfcSlabTypeEnum);
  };

  IfcSlabTypeEnum.APPROACH_SLAB = {
    type: 3,
    value: "APPROACH_SLAB"
  };
  IfcSlabTypeEnum.BASESLAB = {
    type: 3,
    value: "BASESLAB"
  };
  IfcSlabTypeEnum.FLOOR = {
    type: 3,
    value: "FLOOR"
  };
  IfcSlabTypeEnum.LANDING = {
    type: 3,
    value: "LANDING"
  };
  IfcSlabTypeEnum.PAVING = {
    type: 3,
    value: "PAVING"
  };
  IfcSlabTypeEnum.ROOF = {
    type: 3,
    value: "ROOF"
  };
  IfcSlabTypeEnum.SIDEWALK = {
    type: 3,
    value: "SIDEWALK"
  };
  IfcSlabTypeEnum.TRACKSLAB = {
    type: 3,
    value: "TRACKSLAB"
  };
  IfcSlabTypeEnum.WEARING = {
    type: 3,
    value: "WEARING"
  };
  IfcSlabTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSlabTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSlabTypeEnum = IfcSlabTypeEnum;

  var IfcSolarDeviceTypeEnum = function IfcSolarDeviceTypeEnum() {
    _classCallCheck2(this, IfcSolarDeviceTypeEnum);
  };

  IfcSolarDeviceTypeEnum.SOLARCOLLECTOR = {
    type: 3,
    value: "SOLARCOLLECTOR"
  };
  IfcSolarDeviceTypeEnum.SOLARPANEL = {
    type: 3,
    value: "SOLARPANEL"
  };
  IfcSolarDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSolarDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSolarDeviceTypeEnum = IfcSolarDeviceTypeEnum;

  var IfcSpaceHeaterTypeEnum = function IfcSpaceHeaterTypeEnum() {
    _classCallCheck2(this, IfcSpaceHeaterTypeEnum);
  };

  IfcSpaceHeaterTypeEnum.CONVECTOR = {
    type: 3,
    value: "CONVECTOR"
  };
  IfcSpaceHeaterTypeEnum.RADIATOR = {
    type: 3,
    value: "RADIATOR"
  };
  IfcSpaceHeaterTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSpaceHeaterTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;

  var IfcSpaceTypeEnum = function IfcSpaceTypeEnum() {
    _classCallCheck2(this, IfcSpaceTypeEnum);
  };

  IfcSpaceTypeEnum.BERTH = {
    type: 3,
    value: "BERTH"
  };
  IfcSpaceTypeEnum.EXTERNAL = {
    type: 3,
    value: "EXTERNAL"
  };
  IfcSpaceTypeEnum.GFA = {
    type: 3,
    value: "GFA"
  };
  IfcSpaceTypeEnum.INTERNAL = {
    type: 3,
    value: "INTERNAL"
  };
  IfcSpaceTypeEnum.PARKING = {
    type: 3,
    value: "PARKING"
  };
  IfcSpaceTypeEnum.SPACE = {
    type: 3,
    value: "SPACE"
  };
  IfcSpaceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSpaceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSpaceTypeEnum = IfcSpaceTypeEnum;

  var IfcSpatialZoneTypeEnum = function IfcSpatialZoneTypeEnum() {
    _classCallCheck2(this, IfcSpatialZoneTypeEnum);
  };

  IfcSpatialZoneTypeEnum.CONSTRUCTION = {
    type: 3,
    value: "CONSTRUCTION"
  };
  IfcSpatialZoneTypeEnum.FIRESAFETY = {
    type: 3,
    value: "FIRESAFETY"
  };
  IfcSpatialZoneTypeEnum.INTERFERENCE = {
    type: 3,
    value: "INTERFERENCE"
  };
  IfcSpatialZoneTypeEnum.LIGHTING = {
    type: 3,
    value: "LIGHTING"
  };
  IfcSpatialZoneTypeEnum.OCCUPANCY = {
    type: 3,
    value: "OCCUPANCY"
  };
  IfcSpatialZoneTypeEnum.RESERVATION = {
    type: 3,
    value: "RESERVATION"
  };
  IfcSpatialZoneTypeEnum.SECURITY = {
    type: 3,
    value: "SECURITY"
  };
  IfcSpatialZoneTypeEnum.THERMAL = {
    type: 3,
    value: "THERMAL"
  };
  IfcSpatialZoneTypeEnum.TRANSPORT = {
    type: 3,
    value: "TRANSPORT"
  };
  IfcSpatialZoneTypeEnum.VENTILATION = {
    type: 3,
    value: "VENTILATION"
  };
  IfcSpatialZoneTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSpatialZoneTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSpatialZoneTypeEnum = IfcSpatialZoneTypeEnum;

  var IfcStackTerminalTypeEnum = function IfcStackTerminalTypeEnum() {
    _classCallCheck2(this, IfcStackTerminalTypeEnum);
  };

  IfcStackTerminalTypeEnum.BIRDCAGE = {
    type: 3,
    value: "BIRDCAGE"
  };
  IfcStackTerminalTypeEnum.COWL = {
    type: 3,
    value: "COWL"
  };
  IfcStackTerminalTypeEnum.RAINWATERHOPPER = {
    type: 3,
    value: "RAINWATERHOPPER"
  };
  IfcStackTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStackTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;

  var IfcStairFlightTypeEnum = function IfcStairFlightTypeEnum() {
    _classCallCheck2(this, IfcStairFlightTypeEnum);
  };

  IfcStairFlightTypeEnum.CURVED = {
    type: 3,
    value: "CURVED"
  };
  IfcStairFlightTypeEnum.FREEFORM = {
    type: 3,
    value: "FREEFORM"
  };
  IfcStairFlightTypeEnum.SPIRAL = {
    type: 3,
    value: "SPIRAL"
  };
  IfcStairFlightTypeEnum.STRAIGHT = {
    type: 3,
    value: "STRAIGHT"
  };
  IfcStairFlightTypeEnum.WINDER = {
    type: 3,
    value: "WINDER"
  };
  IfcStairFlightTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStairFlightTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;

  var IfcStairTypeEnum = function IfcStairTypeEnum() {
    _classCallCheck2(this, IfcStairTypeEnum);
  };

  IfcStairTypeEnum.CURVED_RUN_STAIR = {
    type: 3,
    value: "CURVED_RUN_STAIR"
  };
  IfcStairTypeEnum.DOUBLE_RETURN_STAIR = {
    type: 3,
    value: "DOUBLE_RETURN_STAIR"
  };
  IfcStairTypeEnum.HALF_TURN_STAIR = {
    type: 3,
    value: "HALF_TURN_STAIR"
  };
  IfcStairTypeEnum.HALF_WINDING_STAIR = {
    type: 3,
    value: "HALF_WINDING_STAIR"
  };
  IfcStairTypeEnum.LADDER = {
    type: 3,
    value: "LADDER"
  };
  IfcStairTypeEnum.QUARTER_TURN_STAIR = {
    type: 3,
    value: "QUARTER_TURN_STAIR"
  };
  IfcStairTypeEnum.QUARTER_WINDING_STAIR = {
    type: 3,
    value: "QUARTER_WINDING_STAIR"
  };
  IfcStairTypeEnum.SPIRAL_STAIR = {
    type: 3,
    value: "SPIRAL_STAIR"
  };
  IfcStairTypeEnum.STRAIGHT_RUN_STAIR = {
    type: 3,
    value: "STRAIGHT_RUN_STAIR"
  };
  IfcStairTypeEnum.THREE_QUARTER_TURN_STAIR = {
    type: 3,
    value: "THREE_QUARTER_TURN_STAIR"
  };
  IfcStairTypeEnum.THREE_QUARTER_WINDING_STAIR = {
    type: 3,
    value: "THREE_QUARTER_WINDING_STAIR"
  };
  IfcStairTypeEnum.TWO_CURVED_RUN_STAIR = {
    type: 3,
    value: "TWO_CURVED_RUN_STAIR"
  };
  IfcStairTypeEnum.TWO_QUARTER_TURN_STAIR = {
    type: 3,
    value: "TWO_QUARTER_TURN_STAIR"
  };
  IfcStairTypeEnum.TWO_QUARTER_WINDING_STAIR = {
    type: 3,
    value: "TWO_QUARTER_WINDING_STAIR"
  };
  IfcStairTypeEnum.TWO_STRAIGHT_RUN_STAIR = {
    type: 3,
    value: "TWO_STRAIGHT_RUN_STAIR"
  };
  IfcStairTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStairTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcStairTypeEnum = IfcStairTypeEnum;

  var IfcStateEnum = function IfcStateEnum() {
    _classCallCheck2(this, IfcStateEnum);
  };

  IfcStateEnum.LOCKED = {
    type: 3,
    value: "LOCKED"
  };
  IfcStateEnum.READONLY = {
    type: 3,
    value: "READONLY"
  };
  IfcStateEnum.READONLYLOCKED = {
    type: 3,
    value: "READONLYLOCKED"
  };
  IfcStateEnum.READWRITE = {
    type: 3,
    value: "READWRITE"
  };
  IfcStateEnum.READWRITELOCKED = {
    type: 3,
    value: "READWRITELOCKED"
  };
  IFC4_32.IfcStateEnum = IfcStateEnum;

  var IfcStructuralCurveActivityTypeEnum = function IfcStructuralCurveActivityTypeEnum() {
    _classCallCheck2(this, IfcStructuralCurveActivityTypeEnum);
  };

  IfcStructuralCurveActivityTypeEnum.CONST = {
    type: 3,
    value: "CONST"
  };
  IfcStructuralCurveActivityTypeEnum.DISCRETE = {
    type: 3,
    value: "DISCRETE"
  };
  IfcStructuralCurveActivityTypeEnum.EQUIDISTANT = {
    type: 3,
    value: "EQUIDISTANT"
  };
  IfcStructuralCurveActivityTypeEnum.LINEAR = {
    type: 3,
    value: "LINEAR"
  };
  IfcStructuralCurveActivityTypeEnum.PARABOLA = {
    type: 3,
    value: "PARABOLA"
  };
  IfcStructuralCurveActivityTypeEnum.POLYGONAL = {
    type: 3,
    value: "POLYGONAL"
  };
  IfcStructuralCurveActivityTypeEnum.SINUS = {
    type: 3,
    value: "SINUS"
  };
  IfcStructuralCurveActivityTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStructuralCurveActivityTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcStructuralCurveActivityTypeEnum = IfcStructuralCurveActivityTypeEnum;

  var IfcStructuralCurveMemberTypeEnum = function IfcStructuralCurveMemberTypeEnum() {
    _classCallCheck2(this, IfcStructuralCurveMemberTypeEnum);
  };

  IfcStructuralCurveMemberTypeEnum.CABLE = {
    type: 3,
    value: "CABLE"
  };
  IfcStructuralCurveMemberTypeEnum.COMPRESSION_MEMBER = {
    type: 3,
    value: "COMPRESSION_MEMBER"
  };
  IfcStructuralCurveMemberTypeEnum.PIN_JOINED_MEMBER = {
    type: 3,
    value: "PIN_JOINED_MEMBER"
  };
  IfcStructuralCurveMemberTypeEnum.RIGID_JOINED_MEMBER = {
    type: 3,
    value: "RIGID_JOINED_MEMBER"
  };
  IfcStructuralCurveMemberTypeEnum.TENSION_MEMBER = {
    type: 3,
    value: "TENSION_MEMBER"
  };
  IfcStructuralCurveMemberTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStructuralCurveMemberTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcStructuralCurveMemberTypeEnum = IfcStructuralCurveMemberTypeEnum;

  var IfcStructuralSurfaceActivityTypeEnum = function IfcStructuralSurfaceActivityTypeEnum() {
    _classCallCheck2(this, IfcStructuralSurfaceActivityTypeEnum);
  };

  IfcStructuralSurfaceActivityTypeEnum.BILINEAR = {
    type: 3,
    value: "BILINEAR"
  };
  IfcStructuralSurfaceActivityTypeEnum.CONST = {
    type: 3,
    value: "CONST"
  };
  IfcStructuralSurfaceActivityTypeEnum.DISCRETE = {
    type: 3,
    value: "DISCRETE"
  };
  IfcStructuralSurfaceActivityTypeEnum.ISOCONTOUR = {
    type: 3,
    value: "ISOCONTOUR"
  };
  IfcStructuralSurfaceActivityTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStructuralSurfaceActivityTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcStructuralSurfaceActivityTypeEnum = IfcStructuralSurfaceActivityTypeEnum;

  var IfcStructuralSurfaceMemberTypeEnum = function IfcStructuralSurfaceMemberTypeEnum() {
    _classCallCheck2(this, IfcStructuralSurfaceMemberTypeEnum);
  };

  IfcStructuralSurfaceMemberTypeEnum.BENDING_ELEMENT = {
    type: 3,
    value: "BENDING_ELEMENT"
  };
  IfcStructuralSurfaceMemberTypeEnum.MEMBRANE_ELEMENT = {
    type: 3,
    value: "MEMBRANE_ELEMENT"
  };
  IfcStructuralSurfaceMemberTypeEnum.SHELL = {
    type: 3,
    value: "SHELL"
  };
  IfcStructuralSurfaceMemberTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStructuralSurfaceMemberTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcStructuralSurfaceMemberTypeEnum = IfcStructuralSurfaceMemberTypeEnum;

  var IfcSubContractResourceTypeEnum = function IfcSubContractResourceTypeEnum() {
    _classCallCheck2(this, IfcSubContractResourceTypeEnum);
  };

  IfcSubContractResourceTypeEnum.PURCHASE = {
    type: 3,
    value: "PURCHASE"
  };
  IfcSubContractResourceTypeEnum.WORK = {
    type: 3,
    value: "WORK"
  };
  IfcSubContractResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSubContractResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSubContractResourceTypeEnum = IfcSubContractResourceTypeEnum;

  var IfcSurfaceFeatureTypeEnum = function IfcSurfaceFeatureTypeEnum() {
    _classCallCheck2(this, IfcSurfaceFeatureTypeEnum);
  };

  IfcSurfaceFeatureTypeEnum.DEFECT = {
    type: 3,
    value: "DEFECT"
  };
  IfcSurfaceFeatureTypeEnum.HATCHMARKING = {
    type: 3,
    value: "HATCHMARKING"
  };
  IfcSurfaceFeatureTypeEnum.LINEMARKING = {
    type: 3,
    value: "LINEMARKING"
  };
  IfcSurfaceFeatureTypeEnum.MARK = {
    type: 3,
    value: "MARK"
  };
  IfcSurfaceFeatureTypeEnum.NONSKIDSURFACING = {
    type: 3,
    value: "NONSKIDSURFACING"
  };
  IfcSurfaceFeatureTypeEnum.PAVEMENTSURFACEMARKING = {
    type: 3,
    value: "PAVEMENTSURFACEMARKING"
  };
  IfcSurfaceFeatureTypeEnum.RUMBLESTRIP = {
    type: 3,
    value: "RUMBLESTRIP"
  };
  IfcSurfaceFeatureTypeEnum.SYMBOLMARKING = {
    type: 3,
    value: "SYMBOLMARKING"
  };
  IfcSurfaceFeatureTypeEnum.TAG = {
    type: 3,
    value: "TAG"
  };
  IfcSurfaceFeatureTypeEnum.TRANSVERSERUMBLESTRIP = {
    type: 3,
    value: "TRANSVERSERUMBLESTRIP"
  };
  IfcSurfaceFeatureTypeEnum.TREATMENT = {
    type: 3,
    value: "TREATMENT"
  };
  IfcSurfaceFeatureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSurfaceFeatureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSurfaceFeatureTypeEnum = IfcSurfaceFeatureTypeEnum;

  var IfcSurfaceSide = function IfcSurfaceSide() {
    _classCallCheck2(this, IfcSurfaceSide);
  };

  IfcSurfaceSide.BOTH = {
    type: 3,
    value: "BOTH"
  };
  IfcSurfaceSide.NEGATIVE = {
    type: 3,
    value: "NEGATIVE"
  };
  IfcSurfaceSide.POSITIVE = {
    type: 3,
    value: "POSITIVE"
  };
  IFC4_32.IfcSurfaceSide = IfcSurfaceSide;

  var IfcSwitchingDeviceTypeEnum = function IfcSwitchingDeviceTypeEnum() {
    _classCallCheck2(this, IfcSwitchingDeviceTypeEnum);
  };

  IfcSwitchingDeviceTypeEnum.CONTACTOR = {
    type: 3,
    value: "CONTACTOR"
  };
  IfcSwitchingDeviceTypeEnum.DIMMERSWITCH = {
    type: 3,
    value: "DIMMERSWITCH"
  };
  IfcSwitchingDeviceTypeEnum.EMERGENCYSTOP = {
    type: 3,
    value: "EMERGENCYSTOP"
  };
  IfcSwitchingDeviceTypeEnum.KEYPAD = {
    type: 3,
    value: "KEYPAD"
  };
  IfcSwitchingDeviceTypeEnum.MOMENTARYSWITCH = {
    type: 3,
    value: "MOMENTARYSWITCH"
  };
  IfcSwitchingDeviceTypeEnum.RELAY = {
    type: 3,
    value: "RELAY"
  };
  IfcSwitchingDeviceTypeEnum.SELECTORSWITCH = {
    type: 3,
    value: "SELECTORSWITCH"
  };
  IfcSwitchingDeviceTypeEnum.STARTER = {
    type: 3,
    value: "STARTER"
  };
  IfcSwitchingDeviceTypeEnum.START_AND_STOP_EQUIPMENT = {
    type: 3,
    value: "START_AND_STOP_EQUIPMENT"
  };
  IfcSwitchingDeviceTypeEnum.SWITCHDISCONNECTOR = {
    type: 3,
    value: "SWITCHDISCONNECTOR"
  };
  IfcSwitchingDeviceTypeEnum.TOGGLESWITCH = {
    type: 3,
    value: "TOGGLESWITCH"
  };
  IfcSwitchingDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSwitchingDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;

  var IfcSystemFurnitureElementTypeEnum = function IfcSystemFurnitureElementTypeEnum() {
    _classCallCheck2(this, IfcSystemFurnitureElementTypeEnum);
  };

  IfcSystemFurnitureElementTypeEnum.PANEL = {
    type: 3,
    value: "PANEL"
  };
  IfcSystemFurnitureElementTypeEnum.SUBRACK = {
    type: 3,
    value: "SUBRACK"
  };
  IfcSystemFurnitureElementTypeEnum.WORKSURFACE = {
    type: 3,
    value: "WORKSURFACE"
  };
  IfcSystemFurnitureElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSystemFurnitureElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcSystemFurnitureElementTypeEnum = IfcSystemFurnitureElementTypeEnum;

  var IfcTankTypeEnum = function IfcTankTypeEnum() {
    _classCallCheck2(this, IfcTankTypeEnum);
  };

  IfcTankTypeEnum.BASIN = {
    type: 3,
    value: "BASIN"
  };
  IfcTankTypeEnum.BREAKPRESSURE = {
    type: 3,
    value: "BREAKPRESSURE"
  };
  IfcTankTypeEnum.EXPANSION = {
    type: 3,
    value: "EXPANSION"
  };
  IfcTankTypeEnum.FEEDANDEXPANSION = {
    type: 3,
    value: "FEEDANDEXPANSION"
  };
  IfcTankTypeEnum.OILRETENTIONTRAY = {
    type: 3,
    value: "OILRETENTIONTRAY"
  };
  IfcTankTypeEnum.PRESSUREVESSEL = {
    type: 3,
    value: "PRESSUREVESSEL"
  };
  IfcTankTypeEnum.STORAGE = {
    type: 3,
    value: "STORAGE"
  };
  IfcTankTypeEnum.VESSEL = {
    type: 3,
    value: "VESSEL"
  };
  IfcTankTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTankTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcTankTypeEnum = IfcTankTypeEnum;

  var IfcTaskDurationEnum = function IfcTaskDurationEnum() {
    _classCallCheck2(this, IfcTaskDurationEnum);
  };

  IfcTaskDurationEnum.ELAPSEDTIME = {
    type: 3,
    value: "ELAPSEDTIME"
  };
  IfcTaskDurationEnum.WORKTIME = {
    type: 3,
    value: "WORKTIME"
  };
  IfcTaskDurationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcTaskDurationEnum = IfcTaskDurationEnum;

  var IfcTaskTypeEnum = function IfcTaskTypeEnum() {
    _classCallCheck2(this, IfcTaskTypeEnum);
  };

  IfcTaskTypeEnum.ADJUSTMENT = {
    type: 3,
    value: "ADJUSTMENT"
  };
  IfcTaskTypeEnum.ATTENDANCE = {
    type: 3,
    value: "ATTENDANCE"
  };
  IfcTaskTypeEnum.CALIBRATION = {
    type: 3,
    value: "CALIBRATION"
  };
  IfcTaskTypeEnum.CONSTRUCTION = {
    type: 3,
    value: "CONSTRUCTION"
  };
  IfcTaskTypeEnum.DEMOLITION = {
    type: 3,
    value: "DEMOLITION"
  };
  IfcTaskTypeEnum.DISMANTLE = {
    type: 3,
    value: "DISMANTLE"
  };
  IfcTaskTypeEnum.DISPOSAL = {
    type: 3,
    value: "DISPOSAL"
  };
  IfcTaskTypeEnum.EMERGENCY = {
    type: 3,
    value: "EMERGENCY"
  };
  IfcTaskTypeEnum.INSPECTION = {
    type: 3,
    value: "INSPECTION"
  };
  IfcTaskTypeEnum.INSTALLATION = {
    type: 3,
    value: "INSTALLATION"
  };
  IfcTaskTypeEnum.LOGISTIC = {
    type: 3,
    value: "LOGISTIC"
  };
  IfcTaskTypeEnum.MAINTENANCE = {
    type: 3,
    value: "MAINTENANCE"
  };
  IfcTaskTypeEnum.MOVE = {
    type: 3,
    value: "MOVE"
  };
  IfcTaskTypeEnum.OPERATION = {
    type: 3,
    value: "OPERATION"
  };
  IfcTaskTypeEnum.REMOVAL = {
    type: 3,
    value: "REMOVAL"
  };
  IfcTaskTypeEnum.RENOVATION = {
    type: 3,
    value: "RENOVATION"
  };
  IfcTaskTypeEnum.SAFETY = {
    type: 3,
    value: "SAFETY"
  };
  IfcTaskTypeEnum.SHUTDOWN = {
    type: 3,
    value: "SHUTDOWN"
  };
  IfcTaskTypeEnum.STARTUP = {
    type: 3,
    value: "STARTUP"
  };
  IfcTaskTypeEnum.TESTING = {
    type: 3,
    value: "TESTING"
  };
  IfcTaskTypeEnum.TROUBLESHOOTING = {
    type: 3,
    value: "TROUBLESHOOTING"
  };
  IfcTaskTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTaskTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcTaskTypeEnum = IfcTaskTypeEnum;

  var IfcTendonAnchorTypeEnum = function IfcTendonAnchorTypeEnum() {
    _classCallCheck2(this, IfcTendonAnchorTypeEnum);
  };

  IfcTendonAnchorTypeEnum.COUPLER = {
    type: 3,
    value: "COUPLER"
  };
  IfcTendonAnchorTypeEnum.FIXED_END = {
    type: 3,
    value: "FIXED_END"
  };
  IfcTendonAnchorTypeEnum.TENSIONING_END = {
    type: 3,
    value: "TENSIONING_END"
  };
  IfcTendonAnchorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTendonAnchorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcTendonAnchorTypeEnum = IfcTendonAnchorTypeEnum;

  var IfcTendonConduitTypeEnum = function IfcTendonConduitTypeEnum() {
    _classCallCheck2(this, IfcTendonConduitTypeEnum);
  };

  IfcTendonConduitTypeEnum.COUPLER = {
    type: 3,
    value: "COUPLER"
  };
  IfcTendonConduitTypeEnum.DIABOLO = {
    type: 3,
    value: "DIABOLO"
  };
  IfcTendonConduitTypeEnum.DUCT = {
    type: 3,
    value: "DUCT"
  };
  IfcTendonConduitTypeEnum.GROUTING_DUCT = {
    type: 3,
    value: "GROUTING_DUCT"
  };
  IfcTendonConduitTypeEnum.TRUMPET = {
    type: 3,
    value: "TRUMPET"
  };
  IfcTendonConduitTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTendonConduitTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcTendonConduitTypeEnum = IfcTendonConduitTypeEnum;

  var IfcTendonTypeEnum = function IfcTendonTypeEnum() {
    _classCallCheck2(this, IfcTendonTypeEnum);
  };

  IfcTendonTypeEnum.BAR = {
    type: 3,
    value: "BAR"
  };
  IfcTendonTypeEnum.COATED = {
    type: 3,
    value: "COATED"
  };
  IfcTendonTypeEnum.STRAND = {
    type: 3,
    value: "STRAND"
  };
  IfcTendonTypeEnum.WIRE = {
    type: 3,
    value: "WIRE"
  };
  IfcTendonTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTendonTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcTendonTypeEnum = IfcTendonTypeEnum;

  var IfcTextPath = function IfcTextPath() {
    _classCallCheck2(this, IfcTextPath);
  };

  IfcTextPath.DOWN = {
    type: 3,
    value: "DOWN"
  };
  IfcTextPath.LEFT = {
    type: 3,
    value: "LEFT"
  };
  IfcTextPath.RIGHT = {
    type: 3,
    value: "RIGHT"
  };
  IfcTextPath.UP = {
    type: 3,
    value: "UP"
  };
  IFC4_32.IfcTextPath = IfcTextPath;

  var IfcTimeSeriesDataTypeEnum = function IfcTimeSeriesDataTypeEnum() {
    _classCallCheck2(this, IfcTimeSeriesDataTypeEnum);
  };

  IfcTimeSeriesDataTypeEnum.CONTINUOUS = {
    type: 3,
    value: "CONTINUOUS"
  };
  IfcTimeSeriesDataTypeEnum.DISCRETE = {
    type: 3,
    value: "DISCRETE"
  };
  IfcTimeSeriesDataTypeEnum.DISCRETEBINARY = {
    type: 3,
    value: "DISCRETEBINARY"
  };
  IfcTimeSeriesDataTypeEnum.PIECEWISEBINARY = {
    type: 3,
    value: "PIECEWISEBINARY"
  };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONSTANT = {
    type: 3,
    value: "PIECEWISECONSTANT"
  };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONTINUOUS = {
    type: 3,
    value: "PIECEWISECONTINUOUS"
  };
  IfcTimeSeriesDataTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;

  var IfcTrackElementTypeEnum = function IfcTrackElementTypeEnum() {
    _classCallCheck2(this, IfcTrackElementTypeEnum);
  };

  IfcTrackElementTypeEnum.BLOCKINGDEVICE = {
    type: 3,
    value: "BLOCKINGDEVICE"
  };
  IfcTrackElementTypeEnum.DERAILER = {
    type: 3,
    value: "DERAILER"
  };
  IfcTrackElementTypeEnum.FROG = {
    type: 3,
    value: "FROG"
  };
  IfcTrackElementTypeEnum.HALF_SET_OF_BLADES = {
    type: 3,
    value: "HALF_SET_OF_BLADES"
  };
  IfcTrackElementTypeEnum.SLEEPER = {
    type: 3,
    value: "SLEEPER"
  };
  IfcTrackElementTypeEnum.SPEEDREGULATOR = {
    type: 3,
    value: "SPEEDREGULATOR"
  };
  IfcTrackElementTypeEnum.TRACKENDOFALIGNMENT = {
    type: 3,
    value: "TRACKENDOFALIGNMENT"
  };
  IfcTrackElementTypeEnum.VEHICLESTOP = {
    type: 3,
    value: "VEHICLESTOP"
  };
  IfcTrackElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTrackElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcTrackElementTypeEnum = IfcTrackElementTypeEnum;

  var IfcTransformerTypeEnum = function IfcTransformerTypeEnum() {
    _classCallCheck2(this, IfcTransformerTypeEnum);
  };

  IfcTransformerTypeEnum.CHOPPER = {
    type: 3,
    value: "CHOPPER"
  };
  IfcTransformerTypeEnum.COMBINED = {
    type: 3,
    value: "COMBINED"
  };
  IfcTransformerTypeEnum.CURRENT = {
    type: 3,
    value: "CURRENT"
  };
  IfcTransformerTypeEnum.FREQUENCY = {
    type: 3,
    value: "FREQUENCY"
  };
  IfcTransformerTypeEnum.INVERTER = {
    type: 3,
    value: "INVERTER"
  };
  IfcTransformerTypeEnum.RECTIFIER = {
    type: 3,
    value: "RECTIFIER"
  };
  IfcTransformerTypeEnum.VOLTAGE = {
    type: 3,
    value: "VOLTAGE"
  };
  IfcTransformerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTransformerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcTransformerTypeEnum = IfcTransformerTypeEnum;

  var IfcTransitionCode = function IfcTransitionCode() {
    _classCallCheck2(this, IfcTransitionCode);
  };

  IfcTransitionCode.CONTINUOUS = {
    type: 3,
    value: "CONTINUOUS"
  };
  IfcTransitionCode.CONTSAMEGRADIENT = {
    type: 3,
    value: "CONTSAMEGRADIENT"
  };
  IfcTransitionCode.CONTSAMEGRADIENTSAMECURVATURE = {
    type: 3,
    value: "CONTSAMEGRADIENTSAMECURVATURE"
  };
  IfcTransitionCode.DISCONTINUOUS = {
    type: 3,
    value: "DISCONTINUOUS"
  };
  IFC4_32.IfcTransitionCode = IfcTransitionCode;

  var IfcTransportElementTypeEnum = function IfcTransportElementTypeEnum() {
    _classCallCheck2(this, IfcTransportElementTypeEnum);
  };

  IfcTransportElementTypeEnum.CRANEWAY = {
    type: 3,
    value: "CRANEWAY"
  };
  IfcTransportElementTypeEnum.ELEVATOR = {
    type: 3,
    value: "ELEVATOR"
  };
  IfcTransportElementTypeEnum.ESCALATOR = {
    type: 3,
    value: "ESCALATOR"
  };
  IfcTransportElementTypeEnum.HAULINGGEAR = {
    type: 3,
    value: "HAULINGGEAR"
  };
  IfcTransportElementTypeEnum.LIFTINGGEAR = {
    type: 3,
    value: "LIFTINGGEAR"
  };
  IfcTransportElementTypeEnum.MOVINGWALKWAY = {
    type: 3,
    value: "MOVINGWALKWAY"
  };
  IfcTransportElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTransportElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;

  var IfcTrimmingPreference = function IfcTrimmingPreference() {
    _classCallCheck2(this, IfcTrimmingPreference);
  };

  IfcTrimmingPreference.CARTESIAN = {
    type: 3,
    value: "CARTESIAN"
  };
  IfcTrimmingPreference.PARAMETER = {
    type: 3,
    value: "PARAMETER"
  };
  IfcTrimmingPreference.UNSPECIFIED = {
    type: 3,
    value: "UNSPECIFIED"
  };
  IFC4_32.IfcTrimmingPreference = IfcTrimmingPreference;

  var IfcTubeBundleTypeEnum = function IfcTubeBundleTypeEnum() {
    _classCallCheck2(this, IfcTubeBundleTypeEnum);
  };

  IfcTubeBundleTypeEnum.FINNED = {
    type: 3,
    value: "FINNED"
  };
  IfcTubeBundleTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTubeBundleTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;

  var IfcUnitEnum = function IfcUnitEnum() {
    _classCallCheck2(this, IfcUnitEnum);
  };

  IfcUnitEnum.ABSORBEDDOSEUNIT = {
    type: 3,
    value: "ABSORBEDDOSEUNIT"
  };
  IfcUnitEnum.AMOUNTOFSUBSTANCEUNIT = {
    type: 3,
    value: "AMOUNTOFSUBSTANCEUNIT"
  };
  IfcUnitEnum.AREAUNIT = {
    type: 3,
    value: "AREAUNIT"
  };
  IfcUnitEnum.DOSEEQUIVALENTUNIT = {
    type: 3,
    value: "DOSEEQUIVALENTUNIT"
  };
  IfcUnitEnum.ELECTRICCAPACITANCEUNIT = {
    type: 3,
    value: "ELECTRICCAPACITANCEUNIT"
  };
  IfcUnitEnum.ELECTRICCHARGEUNIT = {
    type: 3,
    value: "ELECTRICCHARGEUNIT"
  };
  IfcUnitEnum.ELECTRICCONDUCTANCEUNIT = {
    type: 3,
    value: "ELECTRICCONDUCTANCEUNIT"
  };
  IfcUnitEnum.ELECTRICCURRENTUNIT = {
    type: 3,
    value: "ELECTRICCURRENTUNIT"
  };
  IfcUnitEnum.ELECTRICRESISTANCEUNIT = {
    type: 3,
    value: "ELECTRICRESISTANCEUNIT"
  };
  IfcUnitEnum.ELECTRICVOLTAGEUNIT = {
    type: 3,
    value: "ELECTRICVOLTAGEUNIT"
  };
  IfcUnitEnum.ENERGYUNIT = {
    type: 3,
    value: "ENERGYUNIT"
  };
  IfcUnitEnum.FORCEUNIT = {
    type: 3,
    value: "FORCEUNIT"
  };
  IfcUnitEnum.FREQUENCYUNIT = {
    type: 3,
    value: "FREQUENCYUNIT"
  };
  IfcUnitEnum.ILLUMINANCEUNIT = {
    type: 3,
    value: "ILLUMINANCEUNIT"
  };
  IfcUnitEnum.INDUCTANCEUNIT = {
    type: 3,
    value: "INDUCTANCEUNIT"
  };
  IfcUnitEnum.LENGTHUNIT = {
    type: 3,
    value: "LENGTHUNIT"
  };
  IfcUnitEnum.LUMINOUSFLUXUNIT = {
    type: 3,
    value: "LUMINOUSFLUXUNIT"
  };
  IfcUnitEnum.LUMINOUSINTENSITYUNIT = {
    type: 3,
    value: "LUMINOUSINTENSITYUNIT"
  };
  IfcUnitEnum.MAGNETICFLUXDENSITYUNIT = {
    type: 3,
    value: "MAGNETICFLUXDENSITYUNIT"
  };
  IfcUnitEnum.MAGNETICFLUXUNIT = {
    type: 3,
    value: "MAGNETICFLUXUNIT"
  };
  IfcUnitEnum.MASSUNIT = {
    type: 3,
    value: "MASSUNIT"
  };
  IfcUnitEnum.PLANEANGLEUNIT = {
    type: 3,
    value: "PLANEANGLEUNIT"
  };
  IfcUnitEnum.POWERUNIT = {
    type: 3,
    value: "POWERUNIT"
  };
  IfcUnitEnum.PRESSUREUNIT = {
    type: 3,
    value: "PRESSUREUNIT"
  };
  IfcUnitEnum.RADIOACTIVITYUNIT = {
    type: 3,
    value: "RADIOACTIVITYUNIT"
  };
  IfcUnitEnum.SOLIDANGLEUNIT = {
    type: 3,
    value: "SOLIDANGLEUNIT"
  };
  IfcUnitEnum.THERMODYNAMICTEMPERATUREUNIT = {
    type: 3,
    value: "THERMODYNAMICTEMPERATUREUNIT"
  };
  IfcUnitEnum.TIMEUNIT = {
    type: 3,
    value: "TIMEUNIT"
  };
  IfcUnitEnum.VOLUMEUNIT = {
    type: 3,
    value: "VOLUMEUNIT"
  };
  IfcUnitEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC4_32.IfcUnitEnum = IfcUnitEnum;

  var IfcUnitaryControlElementTypeEnum = function IfcUnitaryControlElementTypeEnum() {
    _classCallCheck2(this, IfcUnitaryControlElementTypeEnum);
  };

  IfcUnitaryControlElementTypeEnum.ALARMPANEL = {
    type: 3,
    value: "ALARMPANEL"
  };
  IfcUnitaryControlElementTypeEnum.BASESTATIONCONTROLLER = {
    type: 3,
    value: "BASESTATIONCONTROLLER"
  };
  IfcUnitaryControlElementTypeEnum.COMBINED = {
    type: 3,
    value: "COMBINED"
  };
  IfcUnitaryControlElementTypeEnum.CONTROLPANEL = {
    type: 3,
    value: "CONTROLPANEL"
  };
  IfcUnitaryControlElementTypeEnum.GASDETECTIONPANEL = {
    type: 3,
    value: "GASDETECTIONPANEL"
  };
  IfcUnitaryControlElementTypeEnum.HUMIDISTAT = {
    type: 3,
    value: "HUMIDISTAT"
  };
  IfcUnitaryControlElementTypeEnum.INDICATORPANEL = {
    type: 3,
    value: "INDICATORPANEL"
  };
  IfcUnitaryControlElementTypeEnum.MIMICPANEL = {
    type: 3,
    value: "MIMICPANEL"
  };
  IfcUnitaryControlElementTypeEnum.THERMOSTAT = {
    type: 3,
    value: "THERMOSTAT"
  };
  IfcUnitaryControlElementTypeEnum.WEATHERSTATION = {
    type: 3,
    value: "WEATHERSTATION"
  };
  IfcUnitaryControlElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcUnitaryControlElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcUnitaryControlElementTypeEnum = IfcUnitaryControlElementTypeEnum;

  var IfcUnitaryEquipmentTypeEnum = function IfcUnitaryEquipmentTypeEnum() {
    _classCallCheck2(this, IfcUnitaryEquipmentTypeEnum);
  };

  IfcUnitaryEquipmentTypeEnum.AIRCONDITIONINGUNIT = {
    type: 3,
    value: "AIRCONDITIONINGUNIT"
  };
  IfcUnitaryEquipmentTypeEnum.AIRHANDLER = {
    type: 3,
    value: "AIRHANDLER"
  };
  IfcUnitaryEquipmentTypeEnum.DEHUMIDIFIER = {
    type: 3,
    value: "DEHUMIDIFIER"
  };
  IfcUnitaryEquipmentTypeEnum.ROOFTOPUNIT = {
    type: 3,
    value: "ROOFTOPUNIT"
  };
  IfcUnitaryEquipmentTypeEnum.SPLITSYSTEM = {
    type: 3,
    value: "SPLITSYSTEM"
  };
  IfcUnitaryEquipmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcUnitaryEquipmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;

  var IfcValveTypeEnum = function IfcValveTypeEnum() {
    _classCallCheck2(this, IfcValveTypeEnum);
  };

  IfcValveTypeEnum.AIRRELEASE = {
    type: 3,
    value: "AIRRELEASE"
  };
  IfcValveTypeEnum.ANTIVACUUM = {
    type: 3,
    value: "ANTIVACUUM"
  };
  IfcValveTypeEnum.CHANGEOVER = {
    type: 3,
    value: "CHANGEOVER"
  };
  IfcValveTypeEnum.CHECK = {
    type: 3,
    value: "CHECK"
  };
  IfcValveTypeEnum.COMMISSIONING = {
    type: 3,
    value: "COMMISSIONING"
  };
  IfcValveTypeEnum.DIVERTING = {
    type: 3,
    value: "DIVERTING"
  };
  IfcValveTypeEnum.DOUBLECHECK = {
    type: 3,
    value: "DOUBLECHECK"
  };
  IfcValveTypeEnum.DOUBLEREGULATING = {
    type: 3,
    value: "DOUBLEREGULATING"
  };
  IfcValveTypeEnum.DRAWOFFCOCK = {
    type: 3,
    value: "DRAWOFFCOCK"
  };
  IfcValveTypeEnum.FAUCET = {
    type: 3,
    value: "FAUCET"
  };
  IfcValveTypeEnum.FLUSHING = {
    type: 3,
    value: "FLUSHING"
  };
  IfcValveTypeEnum.GASCOCK = {
    type: 3,
    value: "GASCOCK"
  };
  IfcValveTypeEnum.GASTAP = {
    type: 3,
    value: "GASTAP"
  };
  IfcValveTypeEnum.ISOLATING = {
    type: 3,
    value: "ISOLATING"
  };
  IfcValveTypeEnum.MIXING = {
    type: 3,
    value: "MIXING"
  };
  IfcValveTypeEnum.PRESSUREREDUCING = {
    type: 3,
    value: "PRESSUREREDUCING"
  };
  IfcValveTypeEnum.PRESSURERELIEF = {
    type: 3,
    value: "PRESSURERELIEF"
  };
  IfcValveTypeEnum.REGULATING = {
    type: 3,
    value: "REGULATING"
  };
  IfcValveTypeEnum.SAFETYCUTOFF = {
    type: 3,
    value: "SAFETYCUTOFF"
  };
  IfcValveTypeEnum.STEAMTRAP = {
    type: 3,
    value: "STEAMTRAP"
  };
  IfcValveTypeEnum.STOPCOCK = {
    type: 3,
    value: "STOPCOCK"
  };
  IfcValveTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcValveTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcValveTypeEnum = IfcValveTypeEnum;

  var IfcVehicleTypeEnum = function IfcVehicleTypeEnum() {
    _classCallCheck2(this, IfcVehicleTypeEnum);
  };

  IfcVehicleTypeEnum.CARGO = {
    type: 3,
    value: "CARGO"
  };
  IfcVehicleTypeEnum.ROLLINGSTOCK = {
    type: 3,
    value: "ROLLINGSTOCK"
  };
  IfcVehicleTypeEnum.VEHICLE = {
    type: 3,
    value: "VEHICLE"
  };
  IfcVehicleTypeEnum.VEHICLEAIR = {
    type: 3,
    value: "VEHICLEAIR"
  };
  IfcVehicleTypeEnum.VEHICLEMARINE = {
    type: 3,
    value: "VEHICLEMARINE"
  };
  IfcVehicleTypeEnum.VEHICLETRACKED = {
    type: 3,
    value: "VEHICLETRACKED"
  };
  IfcVehicleTypeEnum.VEHICLEWHEELED = {
    type: 3,
    value: "VEHICLEWHEELED"
  };
  IfcVehicleTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcVehicleTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcVehicleTypeEnum = IfcVehicleTypeEnum;

  var IfcVibrationDamperTypeEnum = function IfcVibrationDamperTypeEnum() {
    _classCallCheck2(this, IfcVibrationDamperTypeEnum);
  };

  IfcVibrationDamperTypeEnum.AXIAL_YIELD = {
    type: 3,
    value: "AXIAL_YIELD"
  };
  IfcVibrationDamperTypeEnum.BENDING_YIELD = {
    type: 3,
    value: "BENDING_YIELD"
  };
  IfcVibrationDamperTypeEnum.FRICTION = {
    type: 3,
    value: "FRICTION"
  };
  IfcVibrationDamperTypeEnum.RUBBER = {
    type: 3,
    value: "RUBBER"
  };
  IfcVibrationDamperTypeEnum.SHEAR_YIELD = {
    type: 3,
    value: "SHEAR_YIELD"
  };
  IfcVibrationDamperTypeEnum.VISCOUS = {
    type: 3,
    value: "VISCOUS"
  };
  IfcVibrationDamperTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcVibrationDamperTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcVibrationDamperTypeEnum = IfcVibrationDamperTypeEnum;

  var IfcVibrationIsolatorTypeEnum = function IfcVibrationIsolatorTypeEnum() {
    _classCallCheck2(this, IfcVibrationIsolatorTypeEnum);
  };

  IfcVibrationIsolatorTypeEnum.BASE = {
    type: 3,
    value: "BASE"
  };
  IfcVibrationIsolatorTypeEnum.COMPRESSION = {
    type: 3,
    value: "COMPRESSION"
  };
  IfcVibrationIsolatorTypeEnum.SPRING = {
    type: 3,
    value: "SPRING"
  };
  IfcVibrationIsolatorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcVibrationIsolatorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;

  var IfcVirtualElementTypeEnum = function IfcVirtualElementTypeEnum() {
    _classCallCheck2(this, IfcVirtualElementTypeEnum);
  };

  IfcVirtualElementTypeEnum.BOUNDARY = {
    type: 3,
    value: "BOUNDARY"
  };
  IfcVirtualElementTypeEnum.CLEARANCE = {
    type: 3,
    value: "CLEARANCE"
  };
  IfcVirtualElementTypeEnum.PROVISIONFORVOID = {
    type: 3,
    value: "PROVISIONFORVOID"
  };
  IfcVirtualElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcVirtualElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcVirtualElementTypeEnum = IfcVirtualElementTypeEnum;

  var IfcVoidingFeatureTypeEnum = function IfcVoidingFeatureTypeEnum() {
    _classCallCheck2(this, IfcVoidingFeatureTypeEnum);
  };

  IfcVoidingFeatureTypeEnum.CHAMFER = {
    type: 3,
    value: "CHAMFER"
  };
  IfcVoidingFeatureTypeEnum.CUTOUT = {
    type: 3,
    value: "CUTOUT"
  };
  IfcVoidingFeatureTypeEnum.EDGE = {
    type: 3,
    value: "EDGE"
  };
  IfcVoidingFeatureTypeEnum.HOLE = {
    type: 3,
    value: "HOLE"
  };
  IfcVoidingFeatureTypeEnum.MITER = {
    type: 3,
    value: "MITER"
  };
  IfcVoidingFeatureTypeEnum.NOTCH = {
    type: 3,
    value: "NOTCH"
  };
  IfcVoidingFeatureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcVoidingFeatureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcVoidingFeatureTypeEnum = IfcVoidingFeatureTypeEnum;

  var IfcWallTypeEnum = function IfcWallTypeEnum() {
    _classCallCheck2(this, IfcWallTypeEnum);
  };

  IfcWallTypeEnum.ELEMENTEDWALL = {
    type: 3,
    value: "ELEMENTEDWALL"
  };
  IfcWallTypeEnum.MOVABLE = {
    type: 3,
    value: "MOVABLE"
  };
  IfcWallTypeEnum.PARAPET = {
    type: 3,
    value: "PARAPET"
  };
  IfcWallTypeEnum.PARTITIONING = {
    type: 3,
    value: "PARTITIONING"
  };
  IfcWallTypeEnum.PLUMBINGWALL = {
    type: 3,
    value: "PLUMBINGWALL"
  };
  IfcWallTypeEnum.POLYGONAL = {
    type: 3,
    value: "POLYGONAL"
  };
  IfcWallTypeEnum.RETAININGWALL = {
    type: 3,
    value: "RETAININGWALL"
  };
  IfcWallTypeEnum.SHEAR = {
    type: 3,
    value: "SHEAR"
  };
  IfcWallTypeEnum.SOLIDWALL = {
    type: 3,
    value: "SOLIDWALL"
  };
  IfcWallTypeEnum.STANDARD = {
    type: 3,
    value: "STANDARD"
  };
  IfcWallTypeEnum.WAVEWALL = {
    type: 3,
    value: "WAVEWALL"
  };
  IfcWallTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWallTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcWallTypeEnum = IfcWallTypeEnum;

  var IfcWasteTerminalTypeEnum = function IfcWasteTerminalTypeEnum() {
    _classCallCheck2(this, IfcWasteTerminalTypeEnum);
  };

  IfcWasteTerminalTypeEnum.FLOORTRAP = {
    type: 3,
    value: "FLOORTRAP"
  };
  IfcWasteTerminalTypeEnum.FLOORWASTE = {
    type: 3,
    value: "FLOORWASTE"
  };
  IfcWasteTerminalTypeEnum.GULLYSUMP = {
    type: 3,
    value: "GULLYSUMP"
  };
  IfcWasteTerminalTypeEnum.GULLYTRAP = {
    type: 3,
    value: "GULLYTRAP"
  };
  IfcWasteTerminalTypeEnum.ROOFDRAIN = {
    type: 3,
    value: "ROOFDRAIN"
  };
  IfcWasteTerminalTypeEnum.WASTEDISPOSALUNIT = {
    type: 3,
    value: "WASTEDISPOSALUNIT"
  };
  IfcWasteTerminalTypeEnum.WASTETRAP = {
    type: 3,
    value: "WASTETRAP"
  };
  IfcWasteTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWasteTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;

  var IfcWindowPanelOperationEnum = function IfcWindowPanelOperationEnum() {
    _classCallCheck2(this, IfcWindowPanelOperationEnum);
  };

  IfcWindowPanelOperationEnum.BOTTOMHUNG = {
    type: 3,
    value: "BOTTOMHUNG"
  };
  IfcWindowPanelOperationEnum.FIXEDCASEMENT = {
    type: 3,
    value: "FIXEDCASEMENT"
  };
  IfcWindowPanelOperationEnum.OTHEROPERATION = {
    type: 3,
    value: "OTHEROPERATION"
  };
  IfcWindowPanelOperationEnum.PIVOTHORIZONTAL = {
    type: 3,
    value: "PIVOTHORIZONTAL"
  };
  IfcWindowPanelOperationEnum.PIVOTVERTICAL = {
    type: 3,
    value: "PIVOTVERTICAL"
  };
  IfcWindowPanelOperationEnum.REMOVABLECASEMENT = {
    type: 3,
    value: "REMOVABLECASEMENT"
  };
  IfcWindowPanelOperationEnum.SIDEHUNGLEFTHAND = {
    type: 3,
    value: "SIDEHUNGLEFTHAND"
  };
  IfcWindowPanelOperationEnum.SIDEHUNGRIGHTHAND = {
    type: 3,
    value: "SIDEHUNGRIGHTHAND"
  };
  IfcWindowPanelOperationEnum.SLIDINGHORIZONTAL = {
    type: 3,
    value: "SLIDINGHORIZONTAL"
  };
  IfcWindowPanelOperationEnum.SLIDINGVERTICAL = {
    type: 3,
    value: "SLIDINGVERTICAL"
  };
  IfcWindowPanelOperationEnum.TILTANDTURNLEFTHAND = {
    type: 3,
    value: "TILTANDTURNLEFTHAND"
  };
  IfcWindowPanelOperationEnum.TILTANDTURNRIGHTHAND = {
    type: 3,
    value: "TILTANDTURNRIGHTHAND"
  };
  IfcWindowPanelOperationEnum.TOPHUNG = {
    type: 3,
    value: "TOPHUNG"
  };
  IfcWindowPanelOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;

  var IfcWindowPanelPositionEnum = function IfcWindowPanelPositionEnum() {
    _classCallCheck2(this, IfcWindowPanelPositionEnum);
  };

  IfcWindowPanelPositionEnum.BOTTOM = {
    type: 3,
    value: "BOTTOM"
  };
  IfcWindowPanelPositionEnum.LEFT = {
    type: 3,
    value: "LEFT"
  };
  IfcWindowPanelPositionEnum.MIDDLE = {
    type: 3,
    value: "MIDDLE"
  };
  IfcWindowPanelPositionEnum.RIGHT = {
    type: 3,
    value: "RIGHT"
  };
  IfcWindowPanelPositionEnum.TOP = {
    type: 3,
    value: "TOP"
  };
  IfcWindowPanelPositionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;

  var IfcWindowStyleConstructionEnum = function IfcWindowStyleConstructionEnum() {
    _classCallCheck2(this, IfcWindowStyleConstructionEnum);
  };

  IfcWindowStyleConstructionEnum.ALUMINIUM = {
    type: 3,
    value: "ALUMINIUM"
  };
  IfcWindowStyleConstructionEnum.ALUMINIUM_WOOD = {
    type: 3,
    value: "ALUMINIUM_WOOD"
  };
  IfcWindowStyleConstructionEnum.HIGH_GRADE_STEEL = {
    type: 3,
    value: "HIGH_GRADE_STEEL"
  };
  IfcWindowStyleConstructionEnum.OTHER_CONSTRUCTION = {
    type: 3,
    value: "OTHER_CONSTRUCTION"
  };
  IfcWindowStyleConstructionEnum.PLASTIC = {
    type: 3,
    value: "PLASTIC"
  };
  IfcWindowStyleConstructionEnum.STEEL = {
    type: 3,
    value: "STEEL"
  };
  IfcWindowStyleConstructionEnum.WOOD = {
    type: 3,
    value: "WOOD"
  };
  IfcWindowStyleConstructionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcWindowStyleConstructionEnum = IfcWindowStyleConstructionEnum;

  var IfcWindowStyleOperationEnum = function IfcWindowStyleOperationEnum() {
    _classCallCheck2(this, IfcWindowStyleOperationEnum);
  };

  IfcWindowStyleOperationEnum.DOUBLE_PANEL_HORIZONTAL = {
    type: 3,
    value: "DOUBLE_PANEL_HORIZONTAL"
  };
  IfcWindowStyleOperationEnum.DOUBLE_PANEL_VERTICAL = {
    type: 3,
    value: "DOUBLE_PANEL_VERTICAL"
  };
  IfcWindowStyleOperationEnum.SINGLE_PANEL = {
    type: 3,
    value: "SINGLE_PANEL"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_BOTTOM = {
    type: 3,
    value: "TRIPLE_PANEL_BOTTOM"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_HORIZONTAL = {
    type: 3,
    value: "TRIPLE_PANEL_HORIZONTAL"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_LEFT = {
    type: 3,
    value: "TRIPLE_PANEL_LEFT"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_RIGHT = {
    type: 3,
    value: "TRIPLE_PANEL_RIGHT"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_TOP = {
    type: 3,
    value: "TRIPLE_PANEL_TOP"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_VERTICAL = {
    type: 3,
    value: "TRIPLE_PANEL_VERTICAL"
  };
  IfcWindowStyleOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWindowStyleOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcWindowStyleOperationEnum = IfcWindowStyleOperationEnum;

  var IfcWindowTypeEnum = function IfcWindowTypeEnum() {
    _classCallCheck2(this, IfcWindowTypeEnum);
  };

  IfcWindowTypeEnum.LIGHTDOME = {
    type: 3,
    value: "LIGHTDOME"
  };
  IfcWindowTypeEnum.SKYLIGHT = {
    type: 3,
    value: "SKYLIGHT"
  };
  IfcWindowTypeEnum.WINDOW = {
    type: 3,
    value: "WINDOW"
  };
  IfcWindowTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWindowTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcWindowTypeEnum = IfcWindowTypeEnum;

  var IfcWindowTypePartitioningEnum = function IfcWindowTypePartitioningEnum() {
    _classCallCheck2(this, IfcWindowTypePartitioningEnum);
  };

  IfcWindowTypePartitioningEnum.DOUBLE_PANEL_HORIZONTAL = {
    type: 3,
    value: "DOUBLE_PANEL_HORIZONTAL"
  };
  IfcWindowTypePartitioningEnum.DOUBLE_PANEL_VERTICAL = {
    type: 3,
    value: "DOUBLE_PANEL_VERTICAL"
  };
  IfcWindowTypePartitioningEnum.SINGLE_PANEL = {
    type: 3,
    value: "SINGLE_PANEL"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_BOTTOM = {
    type: 3,
    value: "TRIPLE_PANEL_BOTTOM"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_HORIZONTAL = {
    type: 3,
    value: "TRIPLE_PANEL_HORIZONTAL"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_LEFT = {
    type: 3,
    value: "TRIPLE_PANEL_LEFT"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_RIGHT = {
    type: 3,
    value: "TRIPLE_PANEL_RIGHT"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_TOP = {
    type: 3,
    value: "TRIPLE_PANEL_TOP"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_VERTICAL = {
    type: 3,
    value: "TRIPLE_PANEL_VERTICAL"
  };
  IfcWindowTypePartitioningEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWindowTypePartitioningEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcWindowTypePartitioningEnum = IfcWindowTypePartitioningEnum;

  var IfcWorkCalendarTypeEnum = function IfcWorkCalendarTypeEnum() {
    _classCallCheck2(this, IfcWorkCalendarTypeEnum);
  };

  IfcWorkCalendarTypeEnum.FIRSTSHIFT = {
    type: 3,
    value: "FIRSTSHIFT"
  };
  IfcWorkCalendarTypeEnum.SECONDSHIFT = {
    type: 3,
    value: "SECONDSHIFT"
  };
  IfcWorkCalendarTypeEnum.THIRDSHIFT = {
    type: 3,
    value: "THIRDSHIFT"
  };
  IfcWorkCalendarTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWorkCalendarTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcWorkCalendarTypeEnum = IfcWorkCalendarTypeEnum;

  var IfcWorkPlanTypeEnum = function IfcWorkPlanTypeEnum() {
    _classCallCheck2(this, IfcWorkPlanTypeEnum);
  };

  IfcWorkPlanTypeEnum.ACTUAL = {
    type: 3,
    value: "ACTUAL"
  };
  IfcWorkPlanTypeEnum.BASELINE = {
    type: 3,
    value: "BASELINE"
  };
  IfcWorkPlanTypeEnum.PLANNED = {
    type: 3,
    value: "PLANNED"
  };
  IfcWorkPlanTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWorkPlanTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcWorkPlanTypeEnum = IfcWorkPlanTypeEnum;

  var IfcWorkScheduleTypeEnum = function IfcWorkScheduleTypeEnum() {
    _classCallCheck2(this, IfcWorkScheduleTypeEnum);
  };

  IfcWorkScheduleTypeEnum.ACTUAL = {
    type: 3,
    value: "ACTUAL"
  };
  IfcWorkScheduleTypeEnum.BASELINE = {
    type: 3,
    value: "BASELINE"
  };
  IfcWorkScheduleTypeEnum.PLANNED = {
    type: 3,
    value: "PLANNED"
  };
  IfcWorkScheduleTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWorkScheduleTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC4_32.IfcWorkScheduleTypeEnum = IfcWorkScheduleTypeEnum;

  var IfcActorRole = /*#__PURE__*/function (_IfcLineObject102) {
    _inherits(IfcActorRole, _IfcLineObject102);

    var _super745 = _createSuper(IfcActorRole);

    function IfcActorRole(expressID, Role, UserDefinedRole, Description) {
      var _this737;

      _classCallCheck2(this, IfcActorRole);

      _this737 = _super745.call(this, expressID);
      _this737.Role = Role;
      _this737.UserDefinedRole = UserDefinedRole;
      _this737.Description = Description;
      _this737.type = 3630933823;
      return _this737;
    }

    return IfcActorRole;
  }(IfcLineObject);

  IFC4_32.IfcActorRole = IfcActorRole;

  var IfcAddress = /*#__PURE__*/function (_IfcLineObject103) {
    _inherits(IfcAddress, _IfcLineObject103);

    var _super746 = _createSuper(IfcAddress);

    function IfcAddress(expressID, Purpose, Description, UserDefinedPurpose) {
      var _this738;

      _classCallCheck2(this, IfcAddress);

      _this738 = _super746.call(this, expressID);
      _this738.Purpose = Purpose;
      _this738.Description = Description;
      _this738.UserDefinedPurpose = UserDefinedPurpose;
      _this738.type = 618182010;
      return _this738;
    }

    return IfcAddress;
  }(IfcLineObject);

  IFC4_32.IfcAddress = IfcAddress;

  var IfcAlignmentParameterSegment = /*#__PURE__*/function (_IfcLineObject104) {
    _inherits(IfcAlignmentParameterSegment, _IfcLineObject104);

    var _super747 = _createSuper(IfcAlignmentParameterSegment);

    function IfcAlignmentParameterSegment(expressID, StartTag, EndTag) {
      var _this739;

      _classCallCheck2(this, IfcAlignmentParameterSegment);

      _this739 = _super747.call(this, expressID);
      _this739.StartTag = StartTag;
      _this739.EndTag = EndTag;
      _this739.type = 2879124712;
      return _this739;
    }

    return IfcAlignmentParameterSegment;
  }(IfcLineObject);

  IFC4_32.IfcAlignmentParameterSegment = IfcAlignmentParameterSegment;

  var IfcAlignmentVerticalSegment = /*#__PURE__*/function (_IfcAlignmentParamete) {
    _inherits(IfcAlignmentVerticalSegment, _IfcAlignmentParamete);

    var _super748 = _createSuper(IfcAlignmentVerticalSegment);

    function IfcAlignmentVerticalSegment(expressID, StartTag, EndTag, StartDistAlong, HorizontalLength, StartHeight, StartGradient, EndGradient, RadiusOfCurvature, PredefinedType) {
      var _this740;

      _classCallCheck2(this, IfcAlignmentVerticalSegment);

      _this740 = _super748.call(this, expressID, StartTag, EndTag);
      _this740.StartTag = StartTag;
      _this740.EndTag = EndTag;
      _this740.StartDistAlong = StartDistAlong;
      _this740.HorizontalLength = HorizontalLength;
      _this740.StartHeight = StartHeight;
      _this740.StartGradient = StartGradient;
      _this740.EndGradient = EndGradient;
      _this740.RadiusOfCurvature = RadiusOfCurvature;
      _this740.PredefinedType = PredefinedType;
      _this740.type = 3633395639;
      return _this740;
    }

    return IfcAlignmentVerticalSegment;
  }(IfcAlignmentParameterSegment);

  IFC4_32.IfcAlignmentVerticalSegment = IfcAlignmentVerticalSegment;

  var IfcApplication = /*#__PURE__*/function (_IfcLineObject105) {
    _inherits(IfcApplication, _IfcLineObject105);

    var _super749 = _createSuper(IfcApplication);

    function IfcApplication(expressID, ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier) {
      var _this741;

      _classCallCheck2(this, IfcApplication);

      _this741 = _super749.call(this, expressID);
      _this741.ApplicationDeveloper = ApplicationDeveloper;
      _this741.Version = Version;
      _this741.ApplicationFullName = ApplicationFullName;
      _this741.ApplicationIdentifier = ApplicationIdentifier;
      _this741.type = 639542469;
      return _this741;
    }

    return IfcApplication;
  }(IfcLineObject);

  IFC4_32.IfcApplication = IfcApplication;

  var IfcAppliedValue = /*#__PURE__*/function (_IfcLineObject106) {
    _inherits(IfcAppliedValue, _IfcLineObject106);

    var _super750 = _createSuper(IfcAppliedValue);

    function IfcAppliedValue(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      var _this742;

      _classCallCheck2(this, IfcAppliedValue);

      _this742 = _super750.call(this, expressID);
      _this742.Name = Name;
      _this742.Description = Description;
      _this742.AppliedValue = AppliedValue;
      _this742.UnitBasis = UnitBasis;
      _this742.ApplicableDate = ApplicableDate;
      _this742.FixedUntilDate = FixedUntilDate;
      _this742.Category = Category;
      _this742.Condition = Condition;
      _this742.ArithmeticOperator = ArithmeticOperator;
      _this742.Components = Components;
      _this742.type = 411424972;
      return _this742;
    }

    return IfcAppliedValue;
  }(IfcLineObject);

  IFC4_32.IfcAppliedValue = IfcAppliedValue;

  var IfcApproval = /*#__PURE__*/function (_IfcLineObject107) {
    _inherits(IfcApproval, _IfcLineObject107);

    var _super751 = _createSuper(IfcApproval);

    function IfcApproval(expressID, Identifier, Name, Description, TimeOfApproval, Status, Level, Qualifier, RequestingApproval, GivingApproval) {
      var _this743;

      _classCallCheck2(this, IfcApproval);

      _this743 = _super751.call(this, expressID);
      _this743.Identifier = Identifier;
      _this743.Name = Name;
      _this743.Description = Description;
      _this743.TimeOfApproval = TimeOfApproval;
      _this743.Status = Status;
      _this743.Level = Level;
      _this743.Qualifier = Qualifier;
      _this743.RequestingApproval = RequestingApproval;
      _this743.GivingApproval = GivingApproval;
      _this743.type = 130549933;
      return _this743;
    }

    return IfcApproval;
  }(IfcLineObject);

  IFC4_32.IfcApproval = IfcApproval;

  var IfcBoundaryCondition = /*#__PURE__*/function (_IfcLineObject108) {
    _inherits(IfcBoundaryCondition, _IfcLineObject108);

    var _super752 = _createSuper(IfcBoundaryCondition);

    function IfcBoundaryCondition(expressID, Name) {
      var _this744;

      _classCallCheck2(this, IfcBoundaryCondition);

      _this744 = _super752.call(this, expressID);
      _this744.Name = Name;
      _this744.type = 4037036970;
      return _this744;
    }

    return IfcBoundaryCondition;
  }(IfcLineObject);

  IFC4_32.IfcBoundaryCondition = IfcBoundaryCondition;

  var IfcBoundaryEdgeCondition = /*#__PURE__*/function (_IfcBoundaryCondition4) {
    _inherits(IfcBoundaryEdgeCondition, _IfcBoundaryCondition4);

    var _super753 = _createSuper(IfcBoundaryEdgeCondition);

    function IfcBoundaryEdgeCondition(expressID, Name, TranslationalStiffnessByLengthX, TranslationalStiffnessByLengthY, TranslationalStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ) {
      var _this745;

      _classCallCheck2(this, IfcBoundaryEdgeCondition);

      _this745 = _super753.call(this, expressID, Name);
      _this745.Name = Name;
      _this745.TranslationalStiffnessByLengthX = TranslationalStiffnessByLengthX;
      _this745.TranslationalStiffnessByLengthY = TranslationalStiffnessByLengthY;
      _this745.TranslationalStiffnessByLengthZ = TranslationalStiffnessByLengthZ;
      _this745.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
      _this745.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
      _this745.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
      _this745.type = 1560379544;
      return _this745;
    }

    return IfcBoundaryEdgeCondition;
  }(IfcBoundaryCondition);

  IFC4_32.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;

  var IfcBoundaryFaceCondition = /*#__PURE__*/function (_IfcBoundaryCondition5) {
    _inherits(IfcBoundaryFaceCondition, _IfcBoundaryCondition5);

    var _super754 = _createSuper(IfcBoundaryFaceCondition);

    function IfcBoundaryFaceCondition(expressID, Name, TranslationalStiffnessByAreaX, TranslationalStiffnessByAreaY, TranslationalStiffnessByAreaZ) {
      var _this746;

      _classCallCheck2(this, IfcBoundaryFaceCondition);

      _this746 = _super754.call(this, expressID, Name);
      _this746.Name = Name;
      _this746.TranslationalStiffnessByAreaX = TranslationalStiffnessByAreaX;
      _this746.TranslationalStiffnessByAreaY = TranslationalStiffnessByAreaY;
      _this746.TranslationalStiffnessByAreaZ = TranslationalStiffnessByAreaZ;
      _this746.type = 3367102660;
      return _this746;
    }

    return IfcBoundaryFaceCondition;
  }(IfcBoundaryCondition);

  IFC4_32.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;

  var IfcBoundaryNodeCondition = /*#__PURE__*/function (_IfcBoundaryCondition6) {
    _inherits(IfcBoundaryNodeCondition, _IfcBoundaryCondition6);

    var _super755 = _createSuper(IfcBoundaryNodeCondition);

    function IfcBoundaryNodeCondition(expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ) {
      var _this747;

      _classCallCheck2(this, IfcBoundaryNodeCondition);

      _this747 = _super755.call(this, expressID, Name);
      _this747.Name = Name;
      _this747.TranslationalStiffnessX = TranslationalStiffnessX;
      _this747.TranslationalStiffnessY = TranslationalStiffnessY;
      _this747.TranslationalStiffnessZ = TranslationalStiffnessZ;
      _this747.RotationalStiffnessX = RotationalStiffnessX;
      _this747.RotationalStiffnessY = RotationalStiffnessY;
      _this747.RotationalStiffnessZ = RotationalStiffnessZ;
      _this747.type = 1387855156;
      return _this747;
    }

    return IfcBoundaryNodeCondition;
  }(IfcBoundaryCondition);

  IFC4_32.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;

  var IfcBoundaryNodeConditionWarping = /*#__PURE__*/function (_IfcBoundaryNodeCondi2) {
    _inherits(IfcBoundaryNodeConditionWarping, _IfcBoundaryNodeCondi2);

    var _super756 = _createSuper(IfcBoundaryNodeConditionWarping);

    function IfcBoundaryNodeConditionWarping(expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness) {
      var _this748;

      _classCallCheck2(this, IfcBoundaryNodeConditionWarping);

      _this748 = _super756.call(this, expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
      _this748.Name = Name;
      _this748.TranslationalStiffnessX = TranslationalStiffnessX;
      _this748.TranslationalStiffnessY = TranslationalStiffnessY;
      _this748.TranslationalStiffnessZ = TranslationalStiffnessZ;
      _this748.RotationalStiffnessX = RotationalStiffnessX;
      _this748.RotationalStiffnessY = RotationalStiffnessY;
      _this748.RotationalStiffnessZ = RotationalStiffnessZ;
      _this748.WarpingStiffness = WarpingStiffness;
      _this748.type = 2069777674;
      return _this748;
    }

    return IfcBoundaryNodeConditionWarping;
  }(IfcBoundaryNodeCondition);

  IFC4_32.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;

  var IfcConnectionGeometry = /*#__PURE__*/function (_IfcLineObject109) {
    _inherits(IfcConnectionGeometry, _IfcLineObject109);

    var _super757 = _createSuper(IfcConnectionGeometry);

    function IfcConnectionGeometry(expressID) {
      var _this749;

      _classCallCheck2(this, IfcConnectionGeometry);

      _this749 = _super757.call(this, expressID);
      _this749.type = 2859738748;
      return _this749;
    }

    return IfcConnectionGeometry;
  }(IfcLineObject);

  IFC4_32.IfcConnectionGeometry = IfcConnectionGeometry;

  var IfcConnectionPointGeometry = /*#__PURE__*/function (_IfcConnectionGeometr5) {
    _inherits(IfcConnectionPointGeometry, _IfcConnectionGeometr5);

    var _super758 = _createSuper(IfcConnectionPointGeometry);

    function IfcConnectionPointGeometry(expressID, PointOnRelatingElement, PointOnRelatedElement) {
      var _this750;

      _classCallCheck2(this, IfcConnectionPointGeometry);

      _this750 = _super758.call(this, expressID);
      _this750.PointOnRelatingElement = PointOnRelatingElement;
      _this750.PointOnRelatedElement = PointOnRelatedElement;
      _this750.type = 2614616156;
      return _this750;
    }

    return IfcConnectionPointGeometry;
  }(IfcConnectionGeometry);

  IFC4_32.IfcConnectionPointGeometry = IfcConnectionPointGeometry;

  var IfcConnectionSurfaceGeometry = /*#__PURE__*/function (_IfcConnectionGeometr6) {
    _inherits(IfcConnectionSurfaceGeometry, _IfcConnectionGeometr6);

    var _super759 = _createSuper(IfcConnectionSurfaceGeometry);

    function IfcConnectionSurfaceGeometry(expressID, SurfaceOnRelatingElement, SurfaceOnRelatedElement) {
      var _this751;

      _classCallCheck2(this, IfcConnectionSurfaceGeometry);

      _this751 = _super759.call(this, expressID);
      _this751.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
      _this751.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
      _this751.type = 2732653382;
      return _this751;
    }

    return IfcConnectionSurfaceGeometry;
  }(IfcConnectionGeometry);

  IFC4_32.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;

  var IfcConnectionVolumeGeometry = /*#__PURE__*/function (_IfcConnectionGeometr7) {
    _inherits(IfcConnectionVolumeGeometry, _IfcConnectionGeometr7);

    var _super760 = _createSuper(IfcConnectionVolumeGeometry);

    function IfcConnectionVolumeGeometry(expressID, VolumeOnRelatingElement, VolumeOnRelatedElement) {
      var _this752;

      _classCallCheck2(this, IfcConnectionVolumeGeometry);

      _this752 = _super760.call(this, expressID);
      _this752.VolumeOnRelatingElement = VolumeOnRelatingElement;
      _this752.VolumeOnRelatedElement = VolumeOnRelatedElement;
      _this752.type = 775493141;
      return _this752;
    }

    return IfcConnectionVolumeGeometry;
  }(IfcConnectionGeometry);

  IFC4_32.IfcConnectionVolumeGeometry = IfcConnectionVolumeGeometry;

  var IfcConstraint = /*#__PURE__*/function (_IfcLineObject110) {
    _inherits(IfcConstraint, _IfcLineObject110);

    var _super761 = _createSuper(IfcConstraint);

    function IfcConstraint(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade) {
      var _this753;

      _classCallCheck2(this, IfcConstraint);

      _this753 = _super761.call(this, expressID);
      _this753.Name = Name;
      _this753.Description = Description;
      _this753.ConstraintGrade = ConstraintGrade;
      _this753.ConstraintSource = ConstraintSource;
      _this753.CreatingActor = CreatingActor;
      _this753.CreationTime = CreationTime;
      _this753.UserDefinedGrade = UserDefinedGrade;
      _this753.type = 1959218052;
      return _this753;
    }

    return IfcConstraint;
  }(IfcLineObject);

  IFC4_32.IfcConstraint = IfcConstraint;

  var IfcCoordinateOperation = /*#__PURE__*/function (_IfcLineObject111) {
    _inherits(IfcCoordinateOperation, _IfcLineObject111);

    var _super762 = _createSuper(IfcCoordinateOperation);

    function IfcCoordinateOperation(expressID, SourceCRS, TargetCRS) {
      var _this754;

      _classCallCheck2(this, IfcCoordinateOperation);

      _this754 = _super762.call(this, expressID);
      _this754.SourceCRS = SourceCRS;
      _this754.TargetCRS = TargetCRS;
      _this754.type = 1785450214;
      return _this754;
    }

    return IfcCoordinateOperation;
  }(IfcLineObject);

  IFC4_32.IfcCoordinateOperation = IfcCoordinateOperation;

  var IfcCoordinateReferenceSystem = /*#__PURE__*/function (_IfcLineObject112) {
    _inherits(IfcCoordinateReferenceSystem, _IfcLineObject112);

    var _super763 = _createSuper(IfcCoordinateReferenceSystem);

    function IfcCoordinateReferenceSystem(expressID, Name, Description, GeodeticDatum, VerticalDatum) {
      var _this755;

      _classCallCheck2(this, IfcCoordinateReferenceSystem);

      _this755 = _super763.call(this, expressID);
      _this755.Name = Name;
      _this755.Description = Description;
      _this755.GeodeticDatum = GeodeticDatum;
      _this755.VerticalDatum = VerticalDatum;
      _this755.type = 1466758467;
      return _this755;
    }

    return IfcCoordinateReferenceSystem;
  }(IfcLineObject);

  IFC4_32.IfcCoordinateReferenceSystem = IfcCoordinateReferenceSystem;

  var IfcCostValue = /*#__PURE__*/function (_IfcAppliedValue3) {
    _inherits(IfcCostValue, _IfcAppliedValue3);

    var _super764 = _createSuper(IfcCostValue);

    function IfcCostValue(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      var _this756;

      _classCallCheck2(this, IfcCostValue);

      _this756 = _super764.call(this, expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components);
      _this756.Name = Name;
      _this756.Description = Description;
      _this756.AppliedValue = AppliedValue;
      _this756.UnitBasis = UnitBasis;
      _this756.ApplicableDate = ApplicableDate;
      _this756.FixedUntilDate = FixedUntilDate;
      _this756.Category = Category;
      _this756.Condition = Condition;
      _this756.ArithmeticOperator = ArithmeticOperator;
      _this756.Components = Components;
      _this756.type = 602808272;
      return _this756;
    }

    return IfcCostValue;
  }(IfcAppliedValue);

  IFC4_32.IfcCostValue = IfcCostValue;

  var IfcDerivedUnit = /*#__PURE__*/function (_IfcLineObject113) {
    _inherits(IfcDerivedUnit, _IfcLineObject113);

    var _super765 = _createSuper(IfcDerivedUnit);

    function IfcDerivedUnit(expressID, Elements, UnitType, UserDefinedType, Name) {
      var _this757;

      _classCallCheck2(this, IfcDerivedUnit);

      _this757 = _super765.call(this, expressID);
      _this757.Elements = Elements;
      _this757.UnitType = UnitType;
      _this757.UserDefinedType = UserDefinedType;
      _this757.Name = Name;
      _this757.type = 1765591967;
      return _this757;
    }

    return IfcDerivedUnit;
  }(IfcLineObject);

  IFC4_32.IfcDerivedUnit = IfcDerivedUnit;

  var IfcDerivedUnitElement = /*#__PURE__*/function (_IfcLineObject114) {
    _inherits(IfcDerivedUnitElement, _IfcLineObject114);

    var _super766 = _createSuper(IfcDerivedUnitElement);

    function IfcDerivedUnitElement(expressID, Unit, Exponent) {
      var _this758;

      _classCallCheck2(this, IfcDerivedUnitElement);

      _this758 = _super766.call(this, expressID);
      _this758.Unit = Unit;
      _this758.Exponent = Exponent;
      _this758.type = 1045800335;
      return _this758;
    }

    return IfcDerivedUnitElement;
  }(IfcLineObject);

  IFC4_32.IfcDerivedUnitElement = IfcDerivedUnitElement;

  var IfcDimensionalExponents = /*#__PURE__*/function (_IfcLineObject115) {
    _inherits(IfcDimensionalExponents, _IfcLineObject115);

    var _super767 = _createSuper(IfcDimensionalExponents);

    function IfcDimensionalExponents(expressID, LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent) {
      var _this759;

      _classCallCheck2(this, IfcDimensionalExponents);

      _this759 = _super767.call(this, expressID);
      _this759.LengthExponent = LengthExponent;
      _this759.MassExponent = MassExponent;
      _this759.TimeExponent = TimeExponent;
      _this759.ElectricCurrentExponent = ElectricCurrentExponent;
      _this759.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
      _this759.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
      _this759.LuminousIntensityExponent = LuminousIntensityExponent;
      _this759.type = 2949456006;
      return _this759;
    }

    return IfcDimensionalExponents;
  }(IfcLineObject);

  IFC4_32.IfcDimensionalExponents = IfcDimensionalExponents;

  var IfcExternalInformation = /*#__PURE__*/function (_IfcLineObject116) {
    _inherits(IfcExternalInformation, _IfcLineObject116);

    var _super768 = _createSuper(IfcExternalInformation);

    function IfcExternalInformation(expressID) {
      var _this760;

      _classCallCheck2(this, IfcExternalInformation);

      _this760 = _super768.call(this, expressID);
      _this760.type = 4294318154;
      return _this760;
    }

    return IfcExternalInformation;
  }(IfcLineObject);

  IFC4_32.IfcExternalInformation = IfcExternalInformation;

  var IfcExternalReference = /*#__PURE__*/function (_IfcLineObject117) {
    _inherits(IfcExternalReference, _IfcLineObject117);

    var _super769 = _createSuper(IfcExternalReference);

    function IfcExternalReference(expressID, Location, Identification, Name) {
      var _this761;

      _classCallCheck2(this, IfcExternalReference);

      _this761 = _super769.call(this, expressID);
      _this761.Location = Location;
      _this761.Identification = Identification;
      _this761.Name = Name;
      _this761.type = 3200245327;
      return _this761;
    }

    return IfcExternalReference;
  }(IfcLineObject);

  IFC4_32.IfcExternalReference = IfcExternalReference;

  var IfcExternallyDefinedHatchStyle = /*#__PURE__*/function (_IfcExternalReference8) {
    _inherits(IfcExternallyDefinedHatchStyle, _IfcExternalReference8);

    var _super770 = _createSuper(IfcExternallyDefinedHatchStyle);

    function IfcExternallyDefinedHatchStyle(expressID, Location, Identification, Name) {
      var _this762;

      _classCallCheck2(this, IfcExternallyDefinedHatchStyle);

      _this762 = _super770.call(this, expressID, Location, Identification, Name);
      _this762.Location = Location;
      _this762.Identification = Identification;
      _this762.Name = Name;
      _this762.type = 2242383968;
      return _this762;
    }

    return IfcExternallyDefinedHatchStyle;
  }(IfcExternalReference);

  IFC4_32.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;

  var IfcExternallyDefinedSurfaceStyle = /*#__PURE__*/function (_IfcExternalReference9) {
    _inherits(IfcExternallyDefinedSurfaceStyle, _IfcExternalReference9);

    var _super771 = _createSuper(IfcExternallyDefinedSurfaceStyle);

    function IfcExternallyDefinedSurfaceStyle(expressID, Location, Identification, Name) {
      var _this763;

      _classCallCheck2(this, IfcExternallyDefinedSurfaceStyle);

      _this763 = _super771.call(this, expressID, Location, Identification, Name);
      _this763.Location = Location;
      _this763.Identification = Identification;
      _this763.Name = Name;
      _this763.type = 1040185647;
      return _this763;
    }

    return IfcExternallyDefinedSurfaceStyle;
  }(IfcExternalReference);

  IFC4_32.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;

  var IfcExternallyDefinedTextFont = /*#__PURE__*/function (_IfcExternalReference10) {
    _inherits(IfcExternallyDefinedTextFont, _IfcExternalReference10);

    var _super772 = _createSuper(IfcExternallyDefinedTextFont);

    function IfcExternallyDefinedTextFont(expressID, Location, Identification, Name) {
      var _this764;

      _classCallCheck2(this, IfcExternallyDefinedTextFont);

      _this764 = _super772.call(this, expressID, Location, Identification, Name);
      _this764.Location = Location;
      _this764.Identification = Identification;
      _this764.Name = Name;
      _this764.type = 3548104201;
      return _this764;
    }

    return IfcExternallyDefinedTextFont;
  }(IfcExternalReference);

  IFC4_32.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;

  var IfcGridAxis = /*#__PURE__*/function (_IfcLineObject118) {
    _inherits(IfcGridAxis, _IfcLineObject118);

    var _super773 = _createSuper(IfcGridAxis);

    function IfcGridAxis(expressID, AxisTag, AxisCurve, SameSense) {
      var _this765;

      _classCallCheck2(this, IfcGridAxis);

      _this765 = _super773.call(this, expressID);
      _this765.AxisTag = AxisTag;
      _this765.AxisCurve = AxisCurve;
      _this765.SameSense = SameSense;
      _this765.type = 852622518;
      return _this765;
    }

    return IfcGridAxis;
  }(IfcLineObject);

  IFC4_32.IfcGridAxis = IfcGridAxis;

  var IfcIrregularTimeSeriesValue = /*#__PURE__*/function (_IfcLineObject119) {
    _inherits(IfcIrregularTimeSeriesValue, _IfcLineObject119);

    var _super774 = _createSuper(IfcIrregularTimeSeriesValue);

    function IfcIrregularTimeSeriesValue(expressID, TimeStamp, ListValues) {
      var _this766;

      _classCallCheck2(this, IfcIrregularTimeSeriesValue);

      _this766 = _super774.call(this, expressID);
      _this766.TimeStamp = TimeStamp;
      _this766.ListValues = ListValues;
      _this766.type = 3020489413;
      return _this766;
    }

    return IfcIrregularTimeSeriesValue;
  }(IfcLineObject);

  IFC4_32.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;

  var IfcLibraryInformation = /*#__PURE__*/function (_IfcExternalInformati) {
    _inherits(IfcLibraryInformation, _IfcExternalInformati);

    var _super775 = _createSuper(IfcLibraryInformation);

    function IfcLibraryInformation(expressID, Name, Version, Publisher, VersionDate, Location, Description) {
      var _this767;

      _classCallCheck2(this, IfcLibraryInformation);

      _this767 = _super775.call(this, expressID);
      _this767.Name = Name;
      _this767.Version = Version;
      _this767.Publisher = Publisher;
      _this767.VersionDate = VersionDate;
      _this767.Location = Location;
      _this767.Description = Description;
      _this767.type = 2655187982;
      return _this767;
    }

    return IfcLibraryInformation;
  }(IfcExternalInformation);

  IFC4_32.IfcLibraryInformation = IfcLibraryInformation;

  var IfcLibraryReference = /*#__PURE__*/function (_IfcExternalReference11) {
    _inherits(IfcLibraryReference, _IfcExternalReference11);

    var _super776 = _createSuper(IfcLibraryReference);

    function IfcLibraryReference(expressID, Location, Identification, Name, Description, Language, ReferencedLibrary) {
      var _this768;

      _classCallCheck2(this, IfcLibraryReference);

      _this768 = _super776.call(this, expressID, Location, Identification, Name);
      _this768.Location = Location;
      _this768.Identification = Identification;
      _this768.Name = Name;
      _this768.Description = Description;
      _this768.Language = Language;
      _this768.ReferencedLibrary = ReferencedLibrary;
      _this768.type = 3452421091;
      return _this768;
    }

    return IfcLibraryReference;
  }(IfcExternalReference);

  IFC4_32.IfcLibraryReference = IfcLibraryReference;

  var IfcLightDistributionData = /*#__PURE__*/function (_IfcLineObject120) {
    _inherits(IfcLightDistributionData, _IfcLineObject120);

    var _super777 = _createSuper(IfcLightDistributionData);

    function IfcLightDistributionData(expressID, MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity) {
      var _this769;

      _classCallCheck2(this, IfcLightDistributionData);

      _this769 = _super777.call(this, expressID);
      _this769.MainPlaneAngle = MainPlaneAngle;
      _this769.SecondaryPlaneAngle = SecondaryPlaneAngle;
      _this769.LuminousIntensity = LuminousIntensity;
      _this769.type = 4162380809;
      return _this769;
    }

    return IfcLightDistributionData;
  }(IfcLineObject);

  IFC4_32.IfcLightDistributionData = IfcLightDistributionData;

  var IfcLightIntensityDistribution = /*#__PURE__*/function (_IfcLineObject121) {
    _inherits(IfcLightIntensityDistribution, _IfcLineObject121);

    var _super778 = _createSuper(IfcLightIntensityDistribution);

    function IfcLightIntensityDistribution(expressID, LightDistributionCurve, DistributionData) {
      var _this770;

      _classCallCheck2(this, IfcLightIntensityDistribution);

      _this770 = _super778.call(this, expressID);
      _this770.LightDistributionCurve = LightDistributionCurve;
      _this770.DistributionData = DistributionData;
      _this770.type = 1566485204;
      return _this770;
    }

    return IfcLightIntensityDistribution;
  }(IfcLineObject);

  IFC4_32.IfcLightIntensityDistribution = IfcLightIntensityDistribution;

  var IfcMapConversion = /*#__PURE__*/function (_IfcCoordinateOperati) {
    _inherits(IfcMapConversion, _IfcCoordinateOperati);

    var _super779 = _createSuper(IfcMapConversion);

    function IfcMapConversion(expressID, SourceCRS, TargetCRS, Eastings, Northings, OrthogonalHeight, XAxisAbscissa, XAxisOrdinate, Scale, ScaleY, ScaleZ) {
      var _this771;

      _classCallCheck2(this, IfcMapConversion);

      _this771 = _super779.call(this, expressID, SourceCRS, TargetCRS);
      _this771.SourceCRS = SourceCRS;
      _this771.TargetCRS = TargetCRS;
      _this771.Eastings = Eastings;
      _this771.Northings = Northings;
      _this771.OrthogonalHeight = OrthogonalHeight;
      _this771.XAxisAbscissa = XAxisAbscissa;
      _this771.XAxisOrdinate = XAxisOrdinate;
      _this771.Scale = Scale;
      _this771.ScaleY = ScaleY;
      _this771.ScaleZ = ScaleZ;
      _this771.type = 3057273783;
      return _this771;
    }

    return IfcMapConversion;
  }(IfcCoordinateOperation);

  IFC4_32.IfcMapConversion = IfcMapConversion;

  var IfcMaterialClassificationRelationship = /*#__PURE__*/function (_IfcLineObject122) {
    _inherits(IfcMaterialClassificationRelationship, _IfcLineObject122);

    var _super780 = _createSuper(IfcMaterialClassificationRelationship);

    function IfcMaterialClassificationRelationship(expressID, MaterialClassifications, ClassifiedMaterial) {
      var _this772;

      _classCallCheck2(this, IfcMaterialClassificationRelationship);

      _this772 = _super780.call(this, expressID);
      _this772.MaterialClassifications = MaterialClassifications;
      _this772.ClassifiedMaterial = ClassifiedMaterial;
      _this772.type = 1847130766;
      return _this772;
    }

    return IfcMaterialClassificationRelationship;
  }(IfcLineObject);

  IFC4_32.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;

  var IfcMaterialDefinition = /*#__PURE__*/function (_IfcLineObject123) {
    _inherits(IfcMaterialDefinition, _IfcLineObject123);

    var _super781 = _createSuper(IfcMaterialDefinition);

    function IfcMaterialDefinition(expressID) {
      var _this773;

      _classCallCheck2(this, IfcMaterialDefinition);

      _this773 = _super781.call(this, expressID);
      _this773.type = 760658860;
      return _this773;
    }

    return IfcMaterialDefinition;
  }(IfcLineObject);

  IFC4_32.IfcMaterialDefinition = IfcMaterialDefinition;

  var IfcMaterialLayer = /*#__PURE__*/function (_IfcMaterialDefinitio) {
    _inherits(IfcMaterialLayer, _IfcMaterialDefinitio);

    var _super782 = _createSuper(IfcMaterialLayer);

    function IfcMaterialLayer(expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority) {
      var _this774;

      _classCallCheck2(this, IfcMaterialLayer);

      _this774 = _super782.call(this, expressID);
      _this774.Material = Material;
      _this774.LayerThickness = LayerThickness;
      _this774.IsVentilated = IsVentilated;
      _this774.Name = Name;
      _this774.Description = Description;
      _this774.Category = Category;
      _this774.Priority = Priority;
      _this774.type = 248100487;
      return _this774;
    }

    return IfcMaterialLayer;
  }(IfcMaterialDefinition);

  IFC4_32.IfcMaterialLayer = IfcMaterialLayer;

  var IfcMaterialLayerSet = /*#__PURE__*/function (_IfcMaterialDefinitio2) {
    _inherits(IfcMaterialLayerSet, _IfcMaterialDefinitio2);

    var _super783 = _createSuper(IfcMaterialLayerSet);

    function IfcMaterialLayerSet(expressID, MaterialLayers, LayerSetName, Description) {
      var _this775;

      _classCallCheck2(this, IfcMaterialLayerSet);

      _this775 = _super783.call(this, expressID);
      _this775.MaterialLayers = MaterialLayers;
      _this775.LayerSetName = LayerSetName;
      _this775.Description = Description;
      _this775.type = 3303938423;
      return _this775;
    }

    return IfcMaterialLayerSet;
  }(IfcMaterialDefinition);

  IFC4_32.IfcMaterialLayerSet = IfcMaterialLayerSet;

  var IfcMaterialLayerWithOffsets = /*#__PURE__*/function (_IfcMaterialLayer) {
    _inherits(IfcMaterialLayerWithOffsets, _IfcMaterialLayer);

    var _super784 = _createSuper(IfcMaterialLayerWithOffsets);

    function IfcMaterialLayerWithOffsets(expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority, OffsetDirection, OffsetValues) {
      var _this776;

      _classCallCheck2(this, IfcMaterialLayerWithOffsets);

      _this776 = _super784.call(this, expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority);
      _this776.Material = Material;
      _this776.LayerThickness = LayerThickness;
      _this776.IsVentilated = IsVentilated;
      _this776.Name = Name;
      _this776.Description = Description;
      _this776.Category = Category;
      _this776.Priority = Priority;
      _this776.OffsetDirection = OffsetDirection;
      _this776.OffsetValues = OffsetValues;
      _this776.type = 1847252529;
      return _this776;
    }

    return IfcMaterialLayerWithOffsets;
  }(IfcMaterialLayer);

  IFC4_32.IfcMaterialLayerWithOffsets = IfcMaterialLayerWithOffsets;

  var IfcMaterialList = /*#__PURE__*/function (_IfcLineObject124) {
    _inherits(IfcMaterialList, _IfcLineObject124);

    var _super785 = _createSuper(IfcMaterialList);

    function IfcMaterialList(expressID, Materials) {
      var _this777;

      _classCallCheck2(this, IfcMaterialList);

      _this777 = _super785.call(this, expressID);
      _this777.Materials = Materials;
      _this777.type = 2199411900;
      return _this777;
    }

    return IfcMaterialList;
  }(IfcLineObject);

  IFC4_32.IfcMaterialList = IfcMaterialList;

  var IfcMaterialProfile = /*#__PURE__*/function (_IfcMaterialDefinitio3) {
    _inherits(IfcMaterialProfile, _IfcMaterialDefinitio3);

    var _super786 = _createSuper(IfcMaterialProfile);

    function IfcMaterialProfile(expressID, Name, Description, Material, Profile, Priority, Category) {
      var _this778;

      _classCallCheck2(this, IfcMaterialProfile);

      _this778 = _super786.call(this, expressID);
      _this778.Name = Name;
      _this778.Description = Description;
      _this778.Material = Material;
      _this778.Profile = Profile;
      _this778.Priority = Priority;
      _this778.Category = Category;
      _this778.type = 2235152071;
      return _this778;
    }

    return IfcMaterialProfile;
  }(IfcMaterialDefinition);

  IFC4_32.IfcMaterialProfile = IfcMaterialProfile;

  var IfcMaterialProfileSet = /*#__PURE__*/function (_IfcMaterialDefinitio4) {
    _inherits(IfcMaterialProfileSet, _IfcMaterialDefinitio4);

    var _super787 = _createSuper(IfcMaterialProfileSet);

    function IfcMaterialProfileSet(expressID, Name, Description, MaterialProfiles, CompositeProfile) {
      var _this779;

      _classCallCheck2(this, IfcMaterialProfileSet);

      _this779 = _super787.call(this, expressID);
      _this779.Name = Name;
      _this779.Description = Description;
      _this779.MaterialProfiles = MaterialProfiles;
      _this779.CompositeProfile = CompositeProfile;
      _this779.type = 164193824;
      return _this779;
    }

    return IfcMaterialProfileSet;
  }(IfcMaterialDefinition);

  IFC4_32.IfcMaterialProfileSet = IfcMaterialProfileSet;

  var IfcMaterialProfileWithOffsets = /*#__PURE__*/function (_IfcMaterialProfile) {
    _inherits(IfcMaterialProfileWithOffsets, _IfcMaterialProfile);

    var _super788 = _createSuper(IfcMaterialProfileWithOffsets);

    function IfcMaterialProfileWithOffsets(expressID, Name, Description, Material, Profile, Priority, Category, OffsetValues) {
      var _this780;

      _classCallCheck2(this, IfcMaterialProfileWithOffsets);

      _this780 = _super788.call(this, expressID, Name, Description, Material, Profile, Priority, Category);
      _this780.Name = Name;
      _this780.Description = Description;
      _this780.Material = Material;
      _this780.Profile = Profile;
      _this780.Priority = Priority;
      _this780.Category = Category;
      _this780.OffsetValues = OffsetValues;
      _this780.type = 552965576;
      return _this780;
    }

    return IfcMaterialProfileWithOffsets;
  }(IfcMaterialProfile);

  IFC4_32.IfcMaterialProfileWithOffsets = IfcMaterialProfileWithOffsets;

  var IfcMaterialUsageDefinition = /*#__PURE__*/function (_IfcLineObject125) {
    _inherits(IfcMaterialUsageDefinition, _IfcLineObject125);

    var _super789 = _createSuper(IfcMaterialUsageDefinition);

    function IfcMaterialUsageDefinition(expressID) {
      var _this781;

      _classCallCheck2(this, IfcMaterialUsageDefinition);

      _this781 = _super789.call(this, expressID);
      _this781.type = 1507914824;
      return _this781;
    }

    return IfcMaterialUsageDefinition;
  }(IfcLineObject);

  IFC4_32.IfcMaterialUsageDefinition = IfcMaterialUsageDefinition;

  var IfcMeasureWithUnit = /*#__PURE__*/function (_IfcLineObject126) {
    _inherits(IfcMeasureWithUnit, _IfcLineObject126);

    var _super790 = _createSuper(IfcMeasureWithUnit);

    function IfcMeasureWithUnit(expressID, ValueComponent, UnitComponent) {
      var _this782;

      _classCallCheck2(this, IfcMeasureWithUnit);

      _this782 = _super790.call(this, expressID);
      _this782.ValueComponent = ValueComponent;
      _this782.UnitComponent = UnitComponent;
      _this782.type = 2597039031;
      return _this782;
    }

    return IfcMeasureWithUnit;
  }(IfcLineObject);

  IFC4_32.IfcMeasureWithUnit = IfcMeasureWithUnit;

  var IfcMetric = /*#__PURE__*/function (_IfcConstraint3) {
    _inherits(IfcMetric, _IfcConstraint3);

    var _super791 = _createSuper(IfcMetric);

    function IfcMetric(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue, ReferencePath) {
      var _this783;

      _classCallCheck2(this, IfcMetric);

      _this783 = _super791.call(this, expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      _this783.Name = Name;
      _this783.Description = Description;
      _this783.ConstraintGrade = ConstraintGrade;
      _this783.ConstraintSource = ConstraintSource;
      _this783.CreatingActor = CreatingActor;
      _this783.CreationTime = CreationTime;
      _this783.UserDefinedGrade = UserDefinedGrade;
      _this783.Benchmark = Benchmark;
      _this783.ValueSource = ValueSource;
      _this783.DataValue = DataValue;
      _this783.ReferencePath = ReferencePath;
      _this783.type = 3368373690;
      return _this783;
    }

    return IfcMetric;
  }(IfcConstraint);

  IFC4_32.IfcMetric = IfcMetric;

  var IfcMonetaryUnit = /*#__PURE__*/function (_IfcLineObject127) {
    _inherits(IfcMonetaryUnit, _IfcLineObject127);

    var _super792 = _createSuper(IfcMonetaryUnit);

    function IfcMonetaryUnit(expressID, Currency) {
      var _this784;

      _classCallCheck2(this, IfcMonetaryUnit);

      _this784 = _super792.call(this, expressID);
      _this784.Currency = Currency;
      _this784.type = 2706619895;
      return _this784;
    }

    return IfcMonetaryUnit;
  }(IfcLineObject);

  IFC4_32.IfcMonetaryUnit = IfcMonetaryUnit;

  var IfcNamedUnit = /*#__PURE__*/function (_IfcLineObject128) {
    _inherits(IfcNamedUnit, _IfcLineObject128);

    var _super793 = _createSuper(IfcNamedUnit);

    function IfcNamedUnit(expressID, Dimensions, UnitType) {
      var _this785;

      _classCallCheck2(this, IfcNamedUnit);

      _this785 = _super793.call(this, expressID);
      _this785.Dimensions = Dimensions;
      _this785.UnitType = UnitType;
      _this785.type = 1918398963;
      return _this785;
    }

    return IfcNamedUnit;
  }(IfcLineObject);

  IFC4_32.IfcNamedUnit = IfcNamedUnit;

  var IfcObjectPlacement = /*#__PURE__*/function (_IfcLineObject129) {
    _inherits(IfcObjectPlacement, _IfcLineObject129);

    var _super794 = _createSuper(IfcObjectPlacement);

    function IfcObjectPlacement(expressID, PlacementRelTo) {
      var _this786;

      _classCallCheck2(this, IfcObjectPlacement);

      _this786 = _super794.call(this, expressID);
      _this786.PlacementRelTo = PlacementRelTo;
      _this786.type = 3701648758;
      return _this786;
    }

    return IfcObjectPlacement;
  }(IfcLineObject);

  IFC4_32.IfcObjectPlacement = IfcObjectPlacement;

  var IfcObjective = /*#__PURE__*/function (_IfcConstraint4) {
    _inherits(IfcObjective, _IfcConstraint4);

    var _super795 = _createSuper(IfcObjective);

    function IfcObjective(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, LogicalAggregator, ObjectiveQualifier, UserDefinedQualifier) {
      var _this787;

      _classCallCheck2(this, IfcObjective);

      _this787 = _super795.call(this, expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      _this787.Name = Name;
      _this787.Description = Description;
      _this787.ConstraintGrade = ConstraintGrade;
      _this787.ConstraintSource = ConstraintSource;
      _this787.CreatingActor = CreatingActor;
      _this787.CreationTime = CreationTime;
      _this787.UserDefinedGrade = UserDefinedGrade;
      _this787.BenchmarkValues = BenchmarkValues;
      _this787.LogicalAggregator = LogicalAggregator;
      _this787.ObjectiveQualifier = ObjectiveQualifier;
      _this787.UserDefinedQualifier = UserDefinedQualifier;
      _this787.type = 2251480897;
      return _this787;
    }

    return IfcObjective;
  }(IfcConstraint);

  IFC4_32.IfcObjective = IfcObjective;

  var IfcOrganization = /*#__PURE__*/function (_IfcLineObject130) {
    _inherits(IfcOrganization, _IfcLineObject130);

    var _super796 = _createSuper(IfcOrganization);

    function IfcOrganization(expressID, Identification, Name, Description, Roles, Addresses) {
      var _this788;

      _classCallCheck2(this, IfcOrganization);

      _this788 = _super796.call(this, expressID);
      _this788.Identification = Identification;
      _this788.Name = Name;
      _this788.Description = Description;
      _this788.Roles = Roles;
      _this788.Addresses = Addresses;
      _this788.type = 4251960020;
      return _this788;
    }

    return IfcOrganization;
  }(IfcLineObject);

  IFC4_32.IfcOrganization = IfcOrganization;

  var IfcOwnerHistory = /*#__PURE__*/function (_IfcLineObject131) {
    _inherits(IfcOwnerHistory, _IfcLineObject131);

    var _super797 = _createSuper(IfcOwnerHistory);

    function IfcOwnerHistory(expressID, OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate) {
      var _this789;

      _classCallCheck2(this, IfcOwnerHistory);

      _this789 = _super797.call(this, expressID);
      _this789.OwningUser = OwningUser;
      _this789.OwningApplication = OwningApplication;
      _this789.State = State;
      _this789.ChangeAction = ChangeAction;
      _this789.LastModifiedDate = LastModifiedDate;
      _this789.LastModifyingUser = LastModifyingUser;
      _this789.LastModifyingApplication = LastModifyingApplication;
      _this789.CreationDate = CreationDate;
      _this789.type = 1207048766;
      return _this789;
    }

    return IfcOwnerHistory;
  }(IfcLineObject);

  IFC4_32.IfcOwnerHistory = IfcOwnerHistory;

  var IfcPerson = /*#__PURE__*/function (_IfcLineObject132) {
    _inherits(IfcPerson, _IfcLineObject132);

    var _super798 = _createSuper(IfcPerson);

    function IfcPerson(expressID, Identification, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses) {
      var _this790;

      _classCallCheck2(this, IfcPerson);

      _this790 = _super798.call(this, expressID);
      _this790.Identification = Identification;
      _this790.FamilyName = FamilyName;
      _this790.GivenName = GivenName;
      _this790.MiddleNames = MiddleNames;
      _this790.PrefixTitles = PrefixTitles;
      _this790.SuffixTitles = SuffixTitles;
      _this790.Roles = Roles;
      _this790.Addresses = Addresses;
      _this790.type = 2077209135;
      return _this790;
    }

    return IfcPerson;
  }(IfcLineObject);

  IFC4_32.IfcPerson = IfcPerson;

  var IfcPersonAndOrganization = /*#__PURE__*/function (_IfcLineObject133) {
    _inherits(IfcPersonAndOrganization, _IfcLineObject133);

    var _super799 = _createSuper(IfcPersonAndOrganization);

    function IfcPersonAndOrganization(expressID, ThePerson, TheOrganization, Roles) {
      var _this791;

      _classCallCheck2(this, IfcPersonAndOrganization);

      _this791 = _super799.call(this, expressID);
      _this791.ThePerson = ThePerson;
      _this791.TheOrganization = TheOrganization;
      _this791.Roles = Roles;
      _this791.type = 101040310;
      return _this791;
    }

    return IfcPersonAndOrganization;
  }(IfcLineObject);

  IFC4_32.IfcPersonAndOrganization = IfcPersonAndOrganization;

  var IfcPhysicalQuantity = /*#__PURE__*/function (_IfcLineObject134) {
    _inherits(IfcPhysicalQuantity, _IfcLineObject134);

    var _super800 = _createSuper(IfcPhysicalQuantity);

    function IfcPhysicalQuantity(expressID, Name, Description) {
      var _this792;

      _classCallCheck2(this, IfcPhysicalQuantity);

      _this792 = _super800.call(this, expressID);
      _this792.Name = Name;
      _this792.Description = Description;
      _this792.type = 2483315170;
      return _this792;
    }

    return IfcPhysicalQuantity;
  }(IfcLineObject);

  IFC4_32.IfcPhysicalQuantity = IfcPhysicalQuantity;

  var IfcPhysicalSimpleQuantity = /*#__PURE__*/function (_IfcPhysicalQuantity3) {
    _inherits(IfcPhysicalSimpleQuantity, _IfcPhysicalQuantity3);

    var _super801 = _createSuper(IfcPhysicalSimpleQuantity);

    function IfcPhysicalSimpleQuantity(expressID, Name, Description, Unit) {
      var _this793;

      _classCallCheck2(this, IfcPhysicalSimpleQuantity);

      _this793 = _super801.call(this, expressID, Name, Description);
      _this793.Name = Name;
      _this793.Description = Description;
      _this793.Unit = Unit;
      _this793.type = 2226359599;
      return _this793;
    }

    return IfcPhysicalSimpleQuantity;
  }(IfcPhysicalQuantity);

  IFC4_32.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;

  var IfcPostalAddress = /*#__PURE__*/function (_IfcAddress3) {
    _inherits(IfcPostalAddress, _IfcAddress3);

    var _super802 = _createSuper(IfcPostalAddress);

    function IfcPostalAddress(expressID, Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country) {
      var _this794;

      _classCallCheck2(this, IfcPostalAddress);

      _this794 = _super802.call(this, expressID, Purpose, Description, UserDefinedPurpose);
      _this794.Purpose = Purpose;
      _this794.Description = Description;
      _this794.UserDefinedPurpose = UserDefinedPurpose;
      _this794.InternalLocation = InternalLocation;
      _this794.AddressLines = AddressLines;
      _this794.PostalBox = PostalBox;
      _this794.Town = Town;
      _this794.Region = Region;
      _this794.PostalCode = PostalCode;
      _this794.Country = Country;
      _this794.type = 3355820592;
      return _this794;
    }

    return IfcPostalAddress;
  }(IfcAddress);

  IFC4_32.IfcPostalAddress = IfcPostalAddress;

  var IfcPresentationItem = /*#__PURE__*/function (_IfcLineObject135) {
    _inherits(IfcPresentationItem, _IfcLineObject135);

    var _super803 = _createSuper(IfcPresentationItem);

    function IfcPresentationItem(expressID) {
      var _this795;

      _classCallCheck2(this, IfcPresentationItem);

      _this795 = _super803.call(this, expressID);
      _this795.type = 677532197;
      return _this795;
    }

    return IfcPresentationItem;
  }(IfcLineObject);

  IFC4_32.IfcPresentationItem = IfcPresentationItem;

  var IfcPresentationLayerAssignment = /*#__PURE__*/function (_IfcLineObject136) {
    _inherits(IfcPresentationLayerAssignment, _IfcLineObject136);

    var _super804 = _createSuper(IfcPresentationLayerAssignment);

    function IfcPresentationLayerAssignment(expressID, Name, Description, AssignedItems, Identifier) {
      var _this796;

      _classCallCheck2(this, IfcPresentationLayerAssignment);

      _this796 = _super804.call(this, expressID);
      _this796.Name = Name;
      _this796.Description = Description;
      _this796.AssignedItems = AssignedItems;
      _this796.Identifier = Identifier;
      _this796.type = 2022622350;
      return _this796;
    }

    return IfcPresentationLayerAssignment;
  }(IfcLineObject);

  IFC4_32.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;

  var IfcPresentationLayerWithStyle = /*#__PURE__*/function (_IfcPresentationLayer2) {
    _inherits(IfcPresentationLayerWithStyle, _IfcPresentationLayer2);

    var _super805 = _createSuper(IfcPresentationLayerWithStyle);

    function IfcPresentationLayerWithStyle(expressID, Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles) {
      var _this797;

      _classCallCheck2(this, IfcPresentationLayerWithStyle);

      _this797 = _super805.call(this, expressID, Name, Description, AssignedItems, Identifier);
      _this797.Name = Name;
      _this797.Description = Description;
      _this797.AssignedItems = AssignedItems;
      _this797.Identifier = Identifier;
      _this797.LayerOn = LayerOn;
      _this797.LayerFrozen = LayerFrozen;
      _this797.LayerBlocked = LayerBlocked;
      _this797.LayerStyles = LayerStyles;
      _this797.type = 1304840413;
      return _this797;
    }

    return IfcPresentationLayerWithStyle;
  }(IfcPresentationLayerAssignment);

  IFC4_32.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;

  var IfcPresentationStyle = /*#__PURE__*/function (_IfcLineObject137) {
    _inherits(IfcPresentationStyle, _IfcLineObject137);

    var _super806 = _createSuper(IfcPresentationStyle);

    function IfcPresentationStyle(expressID, Name) {
      var _this798;

      _classCallCheck2(this, IfcPresentationStyle);

      _this798 = _super806.call(this, expressID);
      _this798.Name = Name;
      _this798.type = 3119450353;
      return _this798;
    }

    return IfcPresentationStyle;
  }(IfcLineObject);

  IFC4_32.IfcPresentationStyle = IfcPresentationStyle;

  var IfcProductRepresentation = /*#__PURE__*/function (_IfcLineObject138) {
    _inherits(IfcProductRepresentation, _IfcLineObject138);

    var _super807 = _createSuper(IfcProductRepresentation);

    function IfcProductRepresentation(expressID, Name, Description, Representations) {
      var _this799;

      _classCallCheck2(this, IfcProductRepresentation);

      _this799 = _super807.call(this, expressID);
      _this799.Name = Name;
      _this799.Description = Description;
      _this799.Representations = Representations;
      _this799.type = 2095639259;
      return _this799;
    }

    return IfcProductRepresentation;
  }(IfcLineObject);

  IFC4_32.IfcProductRepresentation = IfcProductRepresentation;

  var IfcProfileDef = /*#__PURE__*/function (_IfcLineObject139) {
    _inherits(IfcProfileDef, _IfcLineObject139);

    var _super808 = _createSuper(IfcProfileDef);

    function IfcProfileDef(expressID, ProfileType, ProfileName) {
      var _this800;

      _classCallCheck2(this, IfcProfileDef);

      _this800 = _super808.call(this, expressID);
      _this800.ProfileType = ProfileType;
      _this800.ProfileName = ProfileName;
      _this800.type = 3958567839;
      return _this800;
    }

    return IfcProfileDef;
  }(IfcLineObject);

  IFC4_32.IfcProfileDef = IfcProfileDef;

  var IfcProjectedCRS = /*#__PURE__*/function (_IfcCoordinateReferen) {
    _inherits(IfcProjectedCRS, _IfcCoordinateReferen);

    var _super809 = _createSuper(IfcProjectedCRS);

    function IfcProjectedCRS(expressID, Name, Description, GeodeticDatum, VerticalDatum, MapProjection, MapZone, MapUnit) {
      var _this801;

      _classCallCheck2(this, IfcProjectedCRS);

      _this801 = _super809.call(this, expressID, Name, Description, GeodeticDatum, VerticalDatum);
      _this801.Name = Name;
      _this801.Description = Description;
      _this801.GeodeticDatum = GeodeticDatum;
      _this801.VerticalDatum = VerticalDatum;
      _this801.MapProjection = MapProjection;
      _this801.MapZone = MapZone;
      _this801.MapUnit = MapUnit;
      _this801.type = 3843373140;
      return _this801;
    }

    return IfcProjectedCRS;
  }(IfcCoordinateReferenceSystem);

  IFC4_32.IfcProjectedCRS = IfcProjectedCRS;

  var IfcPropertyAbstraction = /*#__PURE__*/function (_IfcLineObject140) {
    _inherits(IfcPropertyAbstraction, _IfcLineObject140);

    var _super810 = _createSuper(IfcPropertyAbstraction);

    function IfcPropertyAbstraction(expressID) {
      var _this802;

      _classCallCheck2(this, IfcPropertyAbstraction);

      _this802 = _super810.call(this, expressID);
      _this802.type = 986844984;
      return _this802;
    }

    return IfcPropertyAbstraction;
  }(IfcLineObject);

  IFC4_32.IfcPropertyAbstraction = IfcPropertyAbstraction;

  var IfcPropertyEnumeration = /*#__PURE__*/function (_IfcPropertyAbstracti) {
    _inherits(IfcPropertyEnumeration, _IfcPropertyAbstracti);

    var _super811 = _createSuper(IfcPropertyEnumeration);

    function IfcPropertyEnumeration(expressID, Name, EnumerationValues, Unit) {
      var _this803;

      _classCallCheck2(this, IfcPropertyEnumeration);

      _this803 = _super811.call(this, expressID);
      _this803.Name = Name;
      _this803.EnumerationValues = EnumerationValues;
      _this803.Unit = Unit;
      _this803.type = 3710013099;
      return _this803;
    }

    return IfcPropertyEnumeration;
  }(IfcPropertyAbstraction);

  IFC4_32.IfcPropertyEnumeration = IfcPropertyEnumeration;

  var IfcQuantityArea = /*#__PURE__*/function (_IfcPhysicalSimpleQua7) {
    _inherits(IfcQuantityArea, _IfcPhysicalSimpleQua7);

    var _super812 = _createSuper(IfcQuantityArea);

    function IfcQuantityArea(expressID, Name, Description, Unit, AreaValue, Formula) {
      var _this804;

      _classCallCheck2(this, IfcQuantityArea);

      _this804 = _super812.call(this, expressID, Name, Description, Unit);
      _this804.Name = Name;
      _this804.Description = Description;
      _this804.Unit = Unit;
      _this804.AreaValue = AreaValue;
      _this804.Formula = Formula;
      _this804.type = 2044713172;
      return _this804;
    }

    return IfcQuantityArea;
  }(IfcPhysicalSimpleQuantity);

  IFC4_32.IfcQuantityArea = IfcQuantityArea;

  var IfcQuantityCount = /*#__PURE__*/function (_IfcPhysicalSimpleQua8) {
    _inherits(IfcQuantityCount, _IfcPhysicalSimpleQua8);

    var _super813 = _createSuper(IfcQuantityCount);

    function IfcQuantityCount(expressID, Name, Description, Unit, CountValue, Formula) {
      var _this805;

      _classCallCheck2(this, IfcQuantityCount);

      _this805 = _super813.call(this, expressID, Name, Description, Unit);
      _this805.Name = Name;
      _this805.Description = Description;
      _this805.Unit = Unit;
      _this805.CountValue = CountValue;
      _this805.Formula = Formula;
      _this805.type = 2093928680;
      return _this805;
    }

    return IfcQuantityCount;
  }(IfcPhysicalSimpleQuantity);

  IFC4_32.IfcQuantityCount = IfcQuantityCount;

  var IfcQuantityLength = /*#__PURE__*/function (_IfcPhysicalSimpleQua9) {
    _inherits(IfcQuantityLength, _IfcPhysicalSimpleQua9);

    var _super814 = _createSuper(IfcQuantityLength);

    function IfcQuantityLength(expressID, Name, Description, Unit, LengthValue, Formula) {
      var _this806;

      _classCallCheck2(this, IfcQuantityLength);

      _this806 = _super814.call(this, expressID, Name, Description, Unit);
      _this806.Name = Name;
      _this806.Description = Description;
      _this806.Unit = Unit;
      _this806.LengthValue = LengthValue;
      _this806.Formula = Formula;
      _this806.type = 931644368;
      return _this806;
    }

    return IfcQuantityLength;
  }(IfcPhysicalSimpleQuantity);

  IFC4_32.IfcQuantityLength = IfcQuantityLength;

  var IfcQuantityNumber = /*#__PURE__*/function (_IfcPhysicalSimpleQua10) {
    _inherits(IfcQuantityNumber, _IfcPhysicalSimpleQua10);

    var _super815 = _createSuper(IfcQuantityNumber);

    function IfcQuantityNumber(expressID, Name, Description, Unit, NumberValue, Formula) {
      var _this807;

      _classCallCheck2(this, IfcQuantityNumber);

      _this807 = _super815.call(this, expressID, Name, Description, Unit);
      _this807.Name = Name;
      _this807.Description = Description;
      _this807.Unit = Unit;
      _this807.NumberValue = NumberValue;
      _this807.Formula = Formula;
      _this807.type = 2691318326;
      return _this807;
    }

    return IfcQuantityNumber;
  }(IfcPhysicalSimpleQuantity);

  IFC4_32.IfcQuantityNumber = IfcQuantityNumber;

  var IfcQuantityTime = /*#__PURE__*/function (_IfcPhysicalSimpleQua11) {
    _inherits(IfcQuantityTime, _IfcPhysicalSimpleQua11);

    var _super816 = _createSuper(IfcQuantityTime);

    function IfcQuantityTime(expressID, Name, Description, Unit, TimeValue, Formula) {
      var _this808;

      _classCallCheck2(this, IfcQuantityTime);

      _this808 = _super816.call(this, expressID, Name, Description, Unit);
      _this808.Name = Name;
      _this808.Description = Description;
      _this808.Unit = Unit;
      _this808.TimeValue = TimeValue;
      _this808.Formula = Formula;
      _this808.type = 3252649465;
      return _this808;
    }

    return IfcQuantityTime;
  }(IfcPhysicalSimpleQuantity);

  IFC4_32.IfcQuantityTime = IfcQuantityTime;

  var IfcQuantityVolume = /*#__PURE__*/function (_IfcPhysicalSimpleQua12) {
    _inherits(IfcQuantityVolume, _IfcPhysicalSimpleQua12);

    var _super817 = _createSuper(IfcQuantityVolume);

    function IfcQuantityVolume(expressID, Name, Description, Unit, VolumeValue, Formula) {
      var _this809;

      _classCallCheck2(this, IfcQuantityVolume);

      _this809 = _super817.call(this, expressID, Name, Description, Unit);
      _this809.Name = Name;
      _this809.Description = Description;
      _this809.Unit = Unit;
      _this809.VolumeValue = VolumeValue;
      _this809.Formula = Formula;
      _this809.type = 2405470396;
      return _this809;
    }

    return IfcQuantityVolume;
  }(IfcPhysicalSimpleQuantity);

  IFC4_32.IfcQuantityVolume = IfcQuantityVolume;

  var IfcQuantityWeight = /*#__PURE__*/function (_IfcPhysicalSimpleQua13) {
    _inherits(IfcQuantityWeight, _IfcPhysicalSimpleQua13);

    var _super818 = _createSuper(IfcQuantityWeight);

    function IfcQuantityWeight(expressID, Name, Description, Unit, WeightValue, Formula) {
      var _this810;

      _classCallCheck2(this, IfcQuantityWeight);

      _this810 = _super818.call(this, expressID, Name, Description, Unit);
      _this810.Name = Name;
      _this810.Description = Description;
      _this810.Unit = Unit;
      _this810.WeightValue = WeightValue;
      _this810.Formula = Formula;
      _this810.type = 825690147;
      return _this810;
    }

    return IfcQuantityWeight;
  }(IfcPhysicalSimpleQuantity);

  IFC4_32.IfcQuantityWeight = IfcQuantityWeight;

  var IfcRecurrencePattern = /*#__PURE__*/function (_IfcLineObject141) {
    _inherits(IfcRecurrencePattern, _IfcLineObject141);

    var _super819 = _createSuper(IfcRecurrencePattern);

    function IfcRecurrencePattern(expressID, RecurrenceType, DayComponent, WeekdayComponent, MonthComponent, Position, Interval, Occurrences, TimePeriods) {
      var _this811;

      _classCallCheck2(this, IfcRecurrencePattern);

      _this811 = _super819.call(this, expressID);
      _this811.RecurrenceType = RecurrenceType;
      _this811.DayComponent = DayComponent;
      _this811.WeekdayComponent = WeekdayComponent;
      _this811.MonthComponent = MonthComponent;
      _this811.Position = Position;
      _this811.Interval = Interval;
      _this811.Occurrences = Occurrences;
      _this811.TimePeriods = TimePeriods;
      _this811.type = 3915482550;
      return _this811;
    }

    return IfcRecurrencePattern;
  }(IfcLineObject);

  IFC4_32.IfcRecurrencePattern = IfcRecurrencePattern;

  var IfcReference = /*#__PURE__*/function (_IfcLineObject142) {
    _inherits(IfcReference, _IfcLineObject142);

    var _super820 = _createSuper(IfcReference);

    function IfcReference(expressID, TypeIdentifier, AttributeIdentifier, InstanceName, ListPositions, InnerReference) {
      var _this812;

      _classCallCheck2(this, IfcReference);

      _this812 = _super820.call(this, expressID);
      _this812.TypeIdentifier = TypeIdentifier;
      _this812.AttributeIdentifier = AttributeIdentifier;
      _this812.InstanceName = InstanceName;
      _this812.ListPositions = ListPositions;
      _this812.InnerReference = InnerReference;
      _this812.type = 2433181523;
      return _this812;
    }

    return IfcReference;
  }(IfcLineObject);

  IFC4_32.IfcReference = IfcReference;

  var IfcRepresentation = /*#__PURE__*/function (_IfcLineObject143) {
    _inherits(IfcRepresentation, _IfcLineObject143);

    var _super821 = _createSuper(IfcRepresentation);

    function IfcRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this813;

      _classCallCheck2(this, IfcRepresentation);

      _this813 = _super821.call(this, expressID);
      _this813.ContextOfItems = ContextOfItems;
      _this813.RepresentationIdentifier = RepresentationIdentifier;
      _this813.RepresentationType = RepresentationType;
      _this813.Items = Items;
      _this813.type = 1076942058;
      return _this813;
    }

    return IfcRepresentation;
  }(IfcLineObject);

  IFC4_32.IfcRepresentation = IfcRepresentation;

  var IfcRepresentationContext = /*#__PURE__*/function (_IfcLineObject144) {
    _inherits(IfcRepresentationContext, _IfcLineObject144);

    var _super822 = _createSuper(IfcRepresentationContext);

    function IfcRepresentationContext(expressID, ContextIdentifier, ContextType) {
      var _this814;

      _classCallCheck2(this, IfcRepresentationContext);

      _this814 = _super822.call(this, expressID);
      _this814.ContextIdentifier = ContextIdentifier;
      _this814.ContextType = ContextType;
      _this814.type = 3377609919;
      return _this814;
    }

    return IfcRepresentationContext;
  }(IfcLineObject);

  IFC4_32.IfcRepresentationContext = IfcRepresentationContext;

  var IfcRepresentationItem = /*#__PURE__*/function (_IfcLineObject145) {
    _inherits(IfcRepresentationItem, _IfcLineObject145);

    var _super823 = _createSuper(IfcRepresentationItem);

    function IfcRepresentationItem(expressID) {
      var _this815;

      _classCallCheck2(this, IfcRepresentationItem);

      _this815 = _super823.call(this, expressID);
      _this815.type = 3008791417;
      return _this815;
    }

    return IfcRepresentationItem;
  }(IfcLineObject);

  IFC4_32.IfcRepresentationItem = IfcRepresentationItem;

  var IfcRepresentationMap = /*#__PURE__*/function (_IfcLineObject146) {
    _inherits(IfcRepresentationMap, _IfcLineObject146);

    var _super824 = _createSuper(IfcRepresentationMap);

    function IfcRepresentationMap(expressID, MappingOrigin, MappedRepresentation) {
      var _this816;

      _classCallCheck2(this, IfcRepresentationMap);

      _this816 = _super824.call(this, expressID);
      _this816.MappingOrigin = MappingOrigin;
      _this816.MappedRepresentation = MappedRepresentation;
      _this816.type = 1660063152;
      return _this816;
    }

    return IfcRepresentationMap;
  }(IfcLineObject);

  IFC4_32.IfcRepresentationMap = IfcRepresentationMap;

  var IfcResourceLevelRelationship = /*#__PURE__*/function (_IfcLineObject147) {
    _inherits(IfcResourceLevelRelationship, _IfcLineObject147);

    var _super825 = _createSuper(IfcResourceLevelRelationship);

    function IfcResourceLevelRelationship(expressID, Name, Description) {
      var _this817;

      _classCallCheck2(this, IfcResourceLevelRelationship);

      _this817 = _super825.call(this, expressID);
      _this817.Name = Name;
      _this817.Description = Description;
      _this817.type = 2439245199;
      return _this817;
    }

    return IfcResourceLevelRelationship;
  }(IfcLineObject);

  IFC4_32.IfcResourceLevelRelationship = IfcResourceLevelRelationship;

  var IfcRoot = /*#__PURE__*/function (_IfcLineObject148) {
    _inherits(IfcRoot, _IfcLineObject148);

    var _super826 = _createSuper(IfcRoot);

    function IfcRoot(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this818;

      _classCallCheck2(this, IfcRoot);

      _this818 = _super826.call(this, expressID);
      _this818.GlobalId = GlobalId;
      _this818.OwnerHistory = OwnerHistory;
      _this818.Name = Name;
      _this818.Description = Description;
      _this818.type = 2341007311;
      return _this818;
    }

    return IfcRoot;
  }(IfcLineObject);

  IFC4_32.IfcRoot = IfcRoot;

  var IfcSIUnit = /*#__PURE__*/function (_IfcNamedUnit4) {
    _inherits(IfcSIUnit, _IfcNamedUnit4);

    var _super827 = _createSuper(IfcSIUnit);

    function IfcSIUnit(expressID, Dimensions, UnitType, Prefix, Name) {
      var _this819;

      _classCallCheck2(this, IfcSIUnit);

      _this819 = _super827.call(this, expressID, Dimensions, UnitType);
      _this819.Dimensions = Dimensions;
      _this819.UnitType = UnitType;
      _this819.Prefix = Prefix;
      _this819.Name = Name;
      _this819.type = 448429030;
      return _this819;
    }

    return IfcSIUnit;
  }(IfcNamedUnit);

  IFC4_32.IfcSIUnit = IfcSIUnit;

  var IfcSchedulingTime = /*#__PURE__*/function (_IfcLineObject149) {
    _inherits(IfcSchedulingTime, _IfcLineObject149);

    var _super828 = _createSuper(IfcSchedulingTime);

    function IfcSchedulingTime(expressID, Name, DataOrigin, UserDefinedDataOrigin) {
      var _this820;

      _classCallCheck2(this, IfcSchedulingTime);

      _this820 = _super828.call(this, expressID);
      _this820.Name = Name;
      _this820.DataOrigin = DataOrigin;
      _this820.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this820.type = 1054537805;
      return _this820;
    }

    return IfcSchedulingTime;
  }(IfcLineObject);

  IFC4_32.IfcSchedulingTime = IfcSchedulingTime;

  var IfcShapeAspect = /*#__PURE__*/function (_IfcLineObject150) {
    _inherits(IfcShapeAspect, _IfcLineObject150);

    var _super829 = _createSuper(IfcShapeAspect);

    function IfcShapeAspect(expressID, ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape) {
      var _this821;

      _classCallCheck2(this, IfcShapeAspect);

      _this821 = _super829.call(this, expressID);
      _this821.ShapeRepresentations = ShapeRepresentations;
      _this821.Name = Name;
      _this821.Description = Description;
      _this821.ProductDefinitional = ProductDefinitional;
      _this821.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
      _this821.type = 867548509;
      return _this821;
    }

    return IfcShapeAspect;
  }(IfcLineObject);

  IFC4_32.IfcShapeAspect = IfcShapeAspect;

  var IfcShapeModel = /*#__PURE__*/function (_IfcRepresentation3) {
    _inherits(IfcShapeModel, _IfcRepresentation3);

    var _super830 = _createSuper(IfcShapeModel);

    function IfcShapeModel(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this822;

      _classCallCheck2(this, IfcShapeModel);

      _this822 = _super830.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this822.ContextOfItems = ContextOfItems;
      _this822.RepresentationIdentifier = RepresentationIdentifier;
      _this822.RepresentationType = RepresentationType;
      _this822.Items = Items;
      _this822.type = 3982875396;
      return _this822;
    }

    return IfcShapeModel;
  }(IfcRepresentation);

  IFC4_32.IfcShapeModel = IfcShapeModel;

  var IfcShapeRepresentation = /*#__PURE__*/function (_IfcShapeModel3) {
    _inherits(IfcShapeRepresentation, _IfcShapeModel3);

    var _super831 = _createSuper(IfcShapeRepresentation);

    function IfcShapeRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this823;

      _classCallCheck2(this, IfcShapeRepresentation);

      _this823 = _super831.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this823.ContextOfItems = ContextOfItems;
      _this823.RepresentationIdentifier = RepresentationIdentifier;
      _this823.RepresentationType = RepresentationType;
      _this823.Items = Items;
      _this823.type = 4240577450;
      return _this823;
    }

    return IfcShapeRepresentation;
  }(IfcShapeModel);

  IFC4_32.IfcShapeRepresentation = IfcShapeRepresentation;

  var IfcStructuralConnectionCondition = /*#__PURE__*/function (_IfcLineObject151) {
    _inherits(IfcStructuralConnectionCondition, _IfcLineObject151);

    var _super832 = _createSuper(IfcStructuralConnectionCondition);

    function IfcStructuralConnectionCondition(expressID, Name) {
      var _this824;

      _classCallCheck2(this, IfcStructuralConnectionCondition);

      _this824 = _super832.call(this, expressID);
      _this824.Name = Name;
      _this824.type = 2273995522;
      return _this824;
    }

    return IfcStructuralConnectionCondition;
  }(IfcLineObject);

  IFC4_32.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;

  var IfcStructuralLoad = /*#__PURE__*/function (_IfcLineObject152) {
    _inherits(IfcStructuralLoad, _IfcLineObject152);

    var _super833 = _createSuper(IfcStructuralLoad);

    function IfcStructuralLoad(expressID, Name) {
      var _this825;

      _classCallCheck2(this, IfcStructuralLoad);

      _this825 = _super833.call(this, expressID);
      _this825.Name = Name;
      _this825.type = 2162789131;
      return _this825;
    }

    return IfcStructuralLoad;
  }(IfcLineObject);

  IFC4_32.IfcStructuralLoad = IfcStructuralLoad;

  var IfcStructuralLoadConfiguration = /*#__PURE__*/function (_IfcStructuralLoad2) {
    _inherits(IfcStructuralLoadConfiguration, _IfcStructuralLoad2);

    var _super834 = _createSuper(IfcStructuralLoadConfiguration);

    function IfcStructuralLoadConfiguration(expressID, Name, Values, Locations) {
      var _this826;

      _classCallCheck2(this, IfcStructuralLoadConfiguration);

      _this826 = _super834.call(this, expressID, Name);
      _this826.Name = Name;
      _this826.Values = Values;
      _this826.Locations = Locations;
      _this826.type = 3478079324;
      return _this826;
    }

    return IfcStructuralLoadConfiguration;
  }(IfcStructuralLoad);

  IFC4_32.IfcStructuralLoadConfiguration = IfcStructuralLoadConfiguration;

  var IfcStructuralLoadOrResult = /*#__PURE__*/function (_IfcStructuralLoad3) {
    _inherits(IfcStructuralLoadOrResult, _IfcStructuralLoad3);

    var _super835 = _createSuper(IfcStructuralLoadOrResult);

    function IfcStructuralLoadOrResult(expressID, Name) {
      var _this827;

      _classCallCheck2(this, IfcStructuralLoadOrResult);

      _this827 = _super835.call(this, expressID, Name);
      _this827.Name = Name;
      _this827.type = 609421318;
      return _this827;
    }

    return IfcStructuralLoadOrResult;
  }(IfcStructuralLoad);

  IFC4_32.IfcStructuralLoadOrResult = IfcStructuralLoadOrResult;

  var IfcStructuralLoadStatic = /*#__PURE__*/function (_IfcStructuralLoadOrR) {
    _inherits(IfcStructuralLoadStatic, _IfcStructuralLoadOrR);

    var _super836 = _createSuper(IfcStructuralLoadStatic);

    function IfcStructuralLoadStatic(expressID, Name) {
      var _this828;

      _classCallCheck2(this, IfcStructuralLoadStatic);

      _this828 = _super836.call(this, expressID, Name);
      _this828.Name = Name;
      _this828.type = 2525727697;
      return _this828;
    }

    return IfcStructuralLoadStatic;
  }(IfcStructuralLoadOrResult);

  IFC4_32.IfcStructuralLoadStatic = IfcStructuralLoadStatic;

  var IfcStructuralLoadTemperature = /*#__PURE__*/function (_IfcStructuralLoadSta6) {
    _inherits(IfcStructuralLoadTemperature, _IfcStructuralLoadSta6);

    var _super837 = _createSuper(IfcStructuralLoadTemperature);

    function IfcStructuralLoadTemperature(expressID, Name, DeltaTConstant, DeltaTY, DeltaTZ) {
      var _this829;

      _classCallCheck2(this, IfcStructuralLoadTemperature);

      _this829 = _super837.call(this, expressID, Name);
      _this829.Name = Name;
      _this829.DeltaTConstant = DeltaTConstant;
      _this829.DeltaTY = DeltaTY;
      _this829.DeltaTZ = DeltaTZ;
      _this829.type = 3408363356;
      return _this829;
    }

    return IfcStructuralLoadTemperature;
  }(IfcStructuralLoadStatic);

  IFC4_32.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;

  var IfcStyleModel = /*#__PURE__*/function (_IfcRepresentation4) {
    _inherits(IfcStyleModel, _IfcRepresentation4);

    var _super838 = _createSuper(IfcStyleModel);

    function IfcStyleModel(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this830;

      _classCallCheck2(this, IfcStyleModel);

      _this830 = _super838.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this830.ContextOfItems = ContextOfItems;
      _this830.RepresentationIdentifier = RepresentationIdentifier;
      _this830.RepresentationType = RepresentationType;
      _this830.Items = Items;
      _this830.type = 2830218821;
      return _this830;
    }

    return IfcStyleModel;
  }(IfcRepresentation);

  IFC4_32.IfcStyleModel = IfcStyleModel;

  var IfcStyledItem = /*#__PURE__*/function (_IfcRepresentationIte5) {
    _inherits(IfcStyledItem, _IfcRepresentationIte5);

    var _super839 = _createSuper(IfcStyledItem);

    function IfcStyledItem(expressID, Item, Styles, Name) {
      var _this831;

      _classCallCheck2(this, IfcStyledItem);

      _this831 = _super839.call(this, expressID);
      _this831.Item = Item;
      _this831.Styles = Styles;
      _this831.Name = Name;
      _this831.type = 3958052878;
      return _this831;
    }

    return IfcStyledItem;
  }(IfcRepresentationItem);

  IFC4_32.IfcStyledItem = IfcStyledItem;

  var IfcStyledRepresentation = /*#__PURE__*/function (_IfcStyleModel2) {
    _inherits(IfcStyledRepresentation, _IfcStyleModel2);

    var _super840 = _createSuper(IfcStyledRepresentation);

    function IfcStyledRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this832;

      _classCallCheck2(this, IfcStyledRepresentation);

      _this832 = _super840.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this832.ContextOfItems = ContextOfItems;
      _this832.RepresentationIdentifier = RepresentationIdentifier;
      _this832.RepresentationType = RepresentationType;
      _this832.Items = Items;
      _this832.type = 3049322572;
      return _this832;
    }

    return IfcStyledRepresentation;
  }(IfcStyleModel);

  IFC4_32.IfcStyledRepresentation = IfcStyledRepresentation;

  var IfcSurfaceReinforcementArea = /*#__PURE__*/function (_IfcStructuralLoadOrR2) {
    _inherits(IfcSurfaceReinforcementArea, _IfcStructuralLoadOrR2);

    var _super841 = _createSuper(IfcSurfaceReinforcementArea);

    function IfcSurfaceReinforcementArea(expressID, Name, SurfaceReinforcement1, SurfaceReinforcement2, ShearReinforcement) {
      var _this833;

      _classCallCheck2(this, IfcSurfaceReinforcementArea);

      _this833 = _super841.call(this, expressID, Name);
      _this833.Name = Name;
      _this833.SurfaceReinforcement1 = SurfaceReinforcement1;
      _this833.SurfaceReinforcement2 = SurfaceReinforcement2;
      _this833.ShearReinforcement = ShearReinforcement;
      _this833.type = 2934153892;
      return _this833;
    }

    return IfcSurfaceReinforcementArea;
  }(IfcStructuralLoadOrResult);

  IFC4_32.IfcSurfaceReinforcementArea = IfcSurfaceReinforcementArea;

  var IfcSurfaceStyle = /*#__PURE__*/function (_IfcPresentationStyle6) {
    _inherits(IfcSurfaceStyle, _IfcPresentationStyle6);

    var _super842 = _createSuper(IfcSurfaceStyle);

    function IfcSurfaceStyle(expressID, Name, Side, Styles) {
      var _this834;

      _classCallCheck2(this, IfcSurfaceStyle);

      _this834 = _super842.call(this, expressID, Name);
      _this834.Name = Name;
      _this834.Side = Side;
      _this834.Styles = Styles;
      _this834.type = 1300840506;
      return _this834;
    }

    return IfcSurfaceStyle;
  }(IfcPresentationStyle);

  IFC4_32.IfcSurfaceStyle = IfcSurfaceStyle;

  var IfcSurfaceStyleLighting = /*#__PURE__*/function (_IfcPresentationItem) {
    _inherits(IfcSurfaceStyleLighting, _IfcPresentationItem);

    var _super843 = _createSuper(IfcSurfaceStyleLighting);

    function IfcSurfaceStyleLighting(expressID, DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour) {
      var _this835;

      _classCallCheck2(this, IfcSurfaceStyleLighting);

      _this835 = _super843.call(this, expressID);
      _this835.DiffuseTransmissionColour = DiffuseTransmissionColour;
      _this835.DiffuseReflectionColour = DiffuseReflectionColour;
      _this835.TransmissionColour = TransmissionColour;
      _this835.ReflectanceColour = ReflectanceColour;
      _this835.type = 3303107099;
      return _this835;
    }

    return IfcSurfaceStyleLighting;
  }(IfcPresentationItem);

  IFC4_32.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;

  var IfcSurfaceStyleRefraction = /*#__PURE__*/function (_IfcPresentationItem2) {
    _inherits(IfcSurfaceStyleRefraction, _IfcPresentationItem2);

    var _super844 = _createSuper(IfcSurfaceStyleRefraction);

    function IfcSurfaceStyleRefraction(expressID, RefractionIndex, DispersionFactor) {
      var _this836;

      _classCallCheck2(this, IfcSurfaceStyleRefraction);

      _this836 = _super844.call(this, expressID);
      _this836.RefractionIndex = RefractionIndex;
      _this836.DispersionFactor = DispersionFactor;
      _this836.type = 1607154358;
      return _this836;
    }

    return IfcSurfaceStyleRefraction;
  }(IfcPresentationItem);

  IFC4_32.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;

  var IfcSurfaceStyleShading = /*#__PURE__*/function (_IfcPresentationItem3) {
    _inherits(IfcSurfaceStyleShading, _IfcPresentationItem3);

    var _super845 = _createSuper(IfcSurfaceStyleShading);

    function IfcSurfaceStyleShading(expressID, SurfaceColour, Transparency) {
      var _this837;

      _classCallCheck2(this, IfcSurfaceStyleShading);

      _this837 = _super845.call(this, expressID);
      _this837.SurfaceColour = SurfaceColour;
      _this837.Transparency = Transparency;
      _this837.type = 846575682;
      return _this837;
    }

    return IfcSurfaceStyleShading;
  }(IfcPresentationItem);

  IFC4_32.IfcSurfaceStyleShading = IfcSurfaceStyleShading;

  var IfcSurfaceStyleWithTextures = /*#__PURE__*/function (_IfcPresentationItem4) {
    _inherits(IfcSurfaceStyleWithTextures, _IfcPresentationItem4);

    var _super846 = _createSuper(IfcSurfaceStyleWithTextures);

    function IfcSurfaceStyleWithTextures(expressID, Textures) {
      var _this838;

      _classCallCheck2(this, IfcSurfaceStyleWithTextures);

      _this838 = _super846.call(this, expressID);
      _this838.Textures = Textures;
      _this838.type = 1351298697;
      return _this838;
    }

    return IfcSurfaceStyleWithTextures;
  }(IfcPresentationItem);

  IFC4_32.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;

  var IfcSurfaceTexture = /*#__PURE__*/function (_IfcPresentationItem5) {
    _inherits(IfcSurfaceTexture, _IfcPresentationItem5);

    var _super847 = _createSuper(IfcSurfaceTexture);

    function IfcSurfaceTexture(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter) {
      var _this839;

      _classCallCheck2(this, IfcSurfaceTexture);

      _this839 = _super847.call(this, expressID);
      _this839.RepeatS = RepeatS;
      _this839.RepeatT = RepeatT;
      _this839.Mode = Mode;
      _this839.TextureTransform = TextureTransform;
      _this839.Parameter = Parameter;
      _this839.type = 626085974;
      return _this839;
    }

    return IfcSurfaceTexture;
  }(IfcPresentationItem);

  IFC4_32.IfcSurfaceTexture = IfcSurfaceTexture;

  var IfcTable = /*#__PURE__*/function (_IfcLineObject153) {
    _inherits(IfcTable, _IfcLineObject153);

    var _super848 = _createSuper(IfcTable);

    function IfcTable(expressID, Name, Rows, Columns) {
      var _this840;

      _classCallCheck2(this, IfcTable);

      _this840 = _super848.call(this, expressID);
      _this840.Name = Name;
      _this840.Rows = Rows;
      _this840.Columns = Columns;
      _this840.type = 985171141;
      return _this840;
    }

    return IfcTable;
  }(IfcLineObject);

  IFC4_32.IfcTable = IfcTable;

  var IfcTableColumn = /*#__PURE__*/function (_IfcLineObject154) {
    _inherits(IfcTableColumn, _IfcLineObject154);

    var _super849 = _createSuper(IfcTableColumn);

    function IfcTableColumn(expressID, Identifier, Name, Description, Unit, ReferencePath) {
      var _this841;

      _classCallCheck2(this, IfcTableColumn);

      _this841 = _super849.call(this, expressID);
      _this841.Identifier = Identifier;
      _this841.Name = Name;
      _this841.Description = Description;
      _this841.Unit = Unit;
      _this841.ReferencePath = ReferencePath;
      _this841.type = 2043862942;
      return _this841;
    }

    return IfcTableColumn;
  }(IfcLineObject);

  IFC4_32.IfcTableColumn = IfcTableColumn;

  var IfcTableRow = /*#__PURE__*/function (_IfcLineObject155) {
    _inherits(IfcTableRow, _IfcLineObject155);

    var _super850 = _createSuper(IfcTableRow);

    function IfcTableRow(expressID, RowCells, IsHeading) {
      var _this842;

      _classCallCheck2(this, IfcTableRow);

      _this842 = _super850.call(this, expressID);
      _this842.RowCells = RowCells;
      _this842.IsHeading = IsHeading;
      _this842.type = 531007025;
      return _this842;
    }

    return IfcTableRow;
  }(IfcLineObject);

  IFC4_32.IfcTableRow = IfcTableRow;

  var IfcTaskTime = /*#__PURE__*/function (_IfcSchedulingTime) {
    _inherits(IfcTaskTime, _IfcSchedulingTime);

    var _super851 = _createSuper(IfcTaskTime);

    function IfcTaskTime(expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion) {
      var _this843;

      _classCallCheck2(this, IfcTaskTime);

      _this843 = _super851.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin);
      _this843.Name = Name;
      _this843.DataOrigin = DataOrigin;
      _this843.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this843.DurationType = DurationType;
      _this843.ScheduleDuration = ScheduleDuration;
      _this843.ScheduleStart = ScheduleStart;
      _this843.ScheduleFinish = ScheduleFinish;
      _this843.EarlyStart = EarlyStart;
      _this843.EarlyFinish = EarlyFinish;
      _this843.LateStart = LateStart;
      _this843.LateFinish = LateFinish;
      _this843.FreeFloat = FreeFloat;
      _this843.TotalFloat = TotalFloat;
      _this843.IsCritical = IsCritical;
      _this843.StatusTime = StatusTime;
      _this843.ActualDuration = ActualDuration;
      _this843.ActualStart = ActualStart;
      _this843.ActualFinish = ActualFinish;
      _this843.RemainingTime = RemainingTime;
      _this843.Completion = Completion;
      _this843.type = 1549132990;
      return _this843;
    }

    return IfcTaskTime;
  }(IfcSchedulingTime);

  IFC4_32.IfcTaskTime = IfcTaskTime;

  var IfcTaskTimeRecurring = /*#__PURE__*/function (_IfcTaskTime) {
    _inherits(IfcTaskTimeRecurring, _IfcTaskTime);

    var _super852 = _createSuper(IfcTaskTimeRecurring);

    function IfcTaskTimeRecurring(expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion, Recurrence) {
      var _this844;

      _classCallCheck2(this, IfcTaskTimeRecurring);

      _this844 = _super852.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion);
      _this844.Name = Name;
      _this844.DataOrigin = DataOrigin;
      _this844.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this844.DurationType = DurationType;
      _this844.ScheduleDuration = ScheduleDuration;
      _this844.ScheduleStart = ScheduleStart;
      _this844.ScheduleFinish = ScheduleFinish;
      _this844.EarlyStart = EarlyStart;
      _this844.EarlyFinish = EarlyFinish;
      _this844.LateStart = LateStart;
      _this844.LateFinish = LateFinish;
      _this844.FreeFloat = FreeFloat;
      _this844.TotalFloat = TotalFloat;
      _this844.IsCritical = IsCritical;
      _this844.StatusTime = StatusTime;
      _this844.ActualDuration = ActualDuration;
      _this844.ActualStart = ActualStart;
      _this844.ActualFinish = ActualFinish;
      _this844.RemainingTime = RemainingTime;
      _this844.Completion = Completion;
      _this844.Recurrence = Recurrence;
      _this844.type = 2771591690;
      return _this844;
    }

    return IfcTaskTimeRecurring;
  }(IfcTaskTime);

  IFC4_32.IfcTaskTimeRecurring = IfcTaskTimeRecurring;

  var IfcTelecomAddress = /*#__PURE__*/function (_IfcAddress4) {
    _inherits(IfcTelecomAddress, _IfcAddress4);

    var _super853 = _createSuper(IfcTelecomAddress);

    function IfcTelecomAddress(expressID, Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL, MessagingIDs) {
      var _this845;

      _classCallCheck2(this, IfcTelecomAddress);

      _this845 = _super853.call(this, expressID, Purpose, Description, UserDefinedPurpose);
      _this845.Purpose = Purpose;
      _this845.Description = Description;
      _this845.UserDefinedPurpose = UserDefinedPurpose;
      _this845.TelephoneNumbers = TelephoneNumbers;
      _this845.FacsimileNumbers = FacsimileNumbers;
      _this845.PagerNumber = PagerNumber;
      _this845.ElectronicMailAddresses = ElectronicMailAddresses;
      _this845.WWWHomePageURL = WWWHomePageURL;
      _this845.MessagingIDs = MessagingIDs;
      _this845.type = 912023232;
      return _this845;
    }

    return IfcTelecomAddress;
  }(IfcAddress);

  IFC4_32.IfcTelecomAddress = IfcTelecomAddress;

  var IfcTextStyle = /*#__PURE__*/function (_IfcPresentationStyle7) {
    _inherits(IfcTextStyle, _IfcPresentationStyle7);

    var _super854 = _createSuper(IfcTextStyle);

    function IfcTextStyle(expressID, Name, TextCharacterAppearance, TextStyle, TextFontStyle, ModelOrDraughting) {
      var _this846;

      _classCallCheck2(this, IfcTextStyle);

      _this846 = _super854.call(this, expressID, Name);
      _this846.Name = Name;
      _this846.TextCharacterAppearance = TextCharacterAppearance;
      _this846.TextStyle = TextStyle;
      _this846.TextFontStyle = TextFontStyle;
      _this846.ModelOrDraughting = ModelOrDraughting;
      _this846.type = 1447204868;
      return _this846;
    }

    return IfcTextStyle;
  }(IfcPresentationStyle);

  IFC4_32.IfcTextStyle = IfcTextStyle;

  var IfcTextStyleForDefinedFont = /*#__PURE__*/function (_IfcPresentationItem6) {
    _inherits(IfcTextStyleForDefinedFont, _IfcPresentationItem6);

    var _super855 = _createSuper(IfcTextStyleForDefinedFont);

    function IfcTextStyleForDefinedFont(expressID, Colour, BackgroundColour) {
      var _this847;

      _classCallCheck2(this, IfcTextStyleForDefinedFont);

      _this847 = _super855.call(this, expressID);
      _this847.Colour = Colour;
      _this847.BackgroundColour = BackgroundColour;
      _this847.type = 2636378356;
      return _this847;
    }

    return IfcTextStyleForDefinedFont;
  }(IfcPresentationItem);

  IFC4_32.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;

  var IfcTextStyleTextModel = /*#__PURE__*/function (_IfcPresentationItem7) {
    _inherits(IfcTextStyleTextModel, _IfcPresentationItem7);

    var _super856 = _createSuper(IfcTextStyleTextModel);

    function IfcTextStyleTextModel(expressID, TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight) {
      var _this848;

      _classCallCheck2(this, IfcTextStyleTextModel);

      _this848 = _super856.call(this, expressID);
      _this848.TextIndent = TextIndent;
      _this848.TextAlign = TextAlign;
      _this848.TextDecoration = TextDecoration;
      _this848.LetterSpacing = LetterSpacing;
      _this848.WordSpacing = WordSpacing;
      _this848.TextTransform = TextTransform;
      _this848.LineHeight = LineHeight;
      _this848.type = 1640371178;
      return _this848;
    }

    return IfcTextStyleTextModel;
  }(IfcPresentationItem);

  IFC4_32.IfcTextStyleTextModel = IfcTextStyleTextModel;

  var IfcTextureCoordinate = /*#__PURE__*/function (_IfcPresentationItem8) {
    _inherits(IfcTextureCoordinate, _IfcPresentationItem8);

    var _super857 = _createSuper(IfcTextureCoordinate);

    function IfcTextureCoordinate(expressID, Maps) {
      var _this849;

      _classCallCheck2(this, IfcTextureCoordinate);

      _this849 = _super857.call(this, expressID);
      _this849.Maps = Maps;
      _this849.type = 280115917;
      return _this849;
    }

    return IfcTextureCoordinate;
  }(IfcPresentationItem);

  IFC4_32.IfcTextureCoordinate = IfcTextureCoordinate;

  var IfcTextureCoordinateGenerator = /*#__PURE__*/function (_IfcTextureCoordinate3) {
    _inherits(IfcTextureCoordinateGenerator, _IfcTextureCoordinate3);

    var _super858 = _createSuper(IfcTextureCoordinateGenerator);

    function IfcTextureCoordinateGenerator(expressID, Maps, Mode, Parameter) {
      var _this850;

      _classCallCheck2(this, IfcTextureCoordinateGenerator);

      _this850 = _super858.call(this, expressID, Maps);
      _this850.Maps = Maps;
      _this850.Mode = Mode;
      _this850.Parameter = Parameter;
      _this850.type = 1742049831;
      return _this850;
    }

    return IfcTextureCoordinateGenerator;
  }(IfcTextureCoordinate);

  IFC4_32.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;

  var IfcTextureCoordinateIndices = /*#__PURE__*/function (_IfcLineObject156) {
    _inherits(IfcTextureCoordinateIndices, _IfcLineObject156);

    var _super859 = _createSuper(IfcTextureCoordinateIndices);

    function IfcTextureCoordinateIndices(expressID, TexCoordIndex, TexCoordsOf) {
      var _this851;

      _classCallCheck2(this, IfcTextureCoordinateIndices);

      _this851 = _super859.call(this, expressID);
      _this851.TexCoordIndex = TexCoordIndex;
      _this851.TexCoordsOf = TexCoordsOf;
      _this851.type = 222769930;
      return _this851;
    }

    return IfcTextureCoordinateIndices;
  }(IfcLineObject);

  IFC4_32.IfcTextureCoordinateIndices = IfcTextureCoordinateIndices;

  var IfcTextureCoordinateIndicesWithVoids = /*#__PURE__*/function (_IfcTextureCoordinate4) {
    _inherits(IfcTextureCoordinateIndicesWithVoids, _IfcTextureCoordinate4);

    var _super860 = _createSuper(IfcTextureCoordinateIndicesWithVoids);

    function IfcTextureCoordinateIndicesWithVoids(expressID, TexCoordIndex, TexCoordsOf, InnerTexCoordIndices) {
      var _this852;

      _classCallCheck2(this, IfcTextureCoordinateIndicesWithVoids);

      _this852 = _super860.call(this, expressID, TexCoordIndex, TexCoordsOf);
      _this852.TexCoordIndex = TexCoordIndex;
      _this852.TexCoordsOf = TexCoordsOf;
      _this852.InnerTexCoordIndices = InnerTexCoordIndices;
      _this852.type = 1010789467;
      return _this852;
    }

    return IfcTextureCoordinateIndicesWithVoids;
  }(IfcTextureCoordinateIndices);

  IFC4_32.IfcTextureCoordinateIndicesWithVoids = IfcTextureCoordinateIndicesWithVoids;

  var IfcTextureMap = /*#__PURE__*/function (_IfcTextureCoordinate5) {
    _inherits(IfcTextureMap, _IfcTextureCoordinate5);

    var _super861 = _createSuper(IfcTextureMap);

    function IfcTextureMap(expressID, Maps, Vertices, MappedTo) {
      var _this853;

      _classCallCheck2(this, IfcTextureMap);

      _this853 = _super861.call(this, expressID, Maps);
      _this853.Maps = Maps;
      _this853.Vertices = Vertices;
      _this853.MappedTo = MappedTo;
      _this853.type = 2552916305;
      return _this853;
    }

    return IfcTextureMap;
  }(IfcTextureCoordinate);

  IFC4_32.IfcTextureMap = IfcTextureMap;

  var IfcTextureVertex = /*#__PURE__*/function (_IfcPresentationItem9) {
    _inherits(IfcTextureVertex, _IfcPresentationItem9);

    var _super862 = _createSuper(IfcTextureVertex);

    function IfcTextureVertex(expressID, Coordinates) {
      var _this854;

      _classCallCheck2(this, IfcTextureVertex);

      _this854 = _super862.call(this, expressID);
      _this854.Coordinates = Coordinates;
      _this854.type = 1210645708;
      return _this854;
    }

    return IfcTextureVertex;
  }(IfcPresentationItem);

  IFC4_32.IfcTextureVertex = IfcTextureVertex;

  var IfcTextureVertexList = /*#__PURE__*/function (_IfcPresentationItem10) {
    _inherits(IfcTextureVertexList, _IfcPresentationItem10);

    var _super863 = _createSuper(IfcTextureVertexList);

    function IfcTextureVertexList(expressID, TexCoordsList) {
      var _this855;

      _classCallCheck2(this, IfcTextureVertexList);

      _this855 = _super863.call(this, expressID);
      _this855.TexCoordsList = TexCoordsList;
      _this855.type = 3611470254;
      return _this855;
    }

    return IfcTextureVertexList;
  }(IfcPresentationItem);

  IFC4_32.IfcTextureVertexList = IfcTextureVertexList;

  var IfcTimePeriod = /*#__PURE__*/function (_IfcLineObject157) {
    _inherits(IfcTimePeriod, _IfcLineObject157);

    var _super864 = _createSuper(IfcTimePeriod);

    function IfcTimePeriod(expressID, StartTime, EndTime) {
      var _this856;

      _classCallCheck2(this, IfcTimePeriod);

      _this856 = _super864.call(this, expressID);
      _this856.StartTime = StartTime;
      _this856.EndTime = EndTime;
      _this856.type = 1199560280;
      return _this856;
    }

    return IfcTimePeriod;
  }(IfcLineObject);

  IFC4_32.IfcTimePeriod = IfcTimePeriod;

  var IfcTimeSeries = /*#__PURE__*/function (_IfcLineObject158) {
    _inherits(IfcTimeSeries, _IfcLineObject158);

    var _super865 = _createSuper(IfcTimeSeries);

    function IfcTimeSeries(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit) {
      var _this857;

      _classCallCheck2(this, IfcTimeSeries);

      _this857 = _super865.call(this, expressID);
      _this857.Name = Name;
      _this857.Description = Description;
      _this857.StartTime = StartTime;
      _this857.EndTime = EndTime;
      _this857.TimeSeriesDataType = TimeSeriesDataType;
      _this857.DataOrigin = DataOrigin;
      _this857.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this857.Unit = Unit;
      _this857.type = 3101149627;
      return _this857;
    }

    return IfcTimeSeries;
  }(IfcLineObject);

  IFC4_32.IfcTimeSeries = IfcTimeSeries;

  var IfcTimeSeriesValue = /*#__PURE__*/function (_IfcLineObject159) {
    _inherits(IfcTimeSeriesValue, _IfcLineObject159);

    var _super866 = _createSuper(IfcTimeSeriesValue);

    function IfcTimeSeriesValue(expressID, ListValues) {
      var _this858;

      _classCallCheck2(this, IfcTimeSeriesValue);

      _this858 = _super866.call(this, expressID);
      _this858.ListValues = ListValues;
      _this858.type = 581633288;
      return _this858;
    }

    return IfcTimeSeriesValue;
  }(IfcLineObject);

  IFC4_32.IfcTimeSeriesValue = IfcTimeSeriesValue;

  var IfcTopologicalRepresentationItem = /*#__PURE__*/function (_IfcRepresentationIte6) {
    _inherits(IfcTopologicalRepresentationItem, _IfcRepresentationIte6);

    var _super867 = _createSuper(IfcTopologicalRepresentationItem);

    function IfcTopologicalRepresentationItem(expressID) {
      var _this859;

      _classCallCheck2(this, IfcTopologicalRepresentationItem);

      _this859 = _super867.call(this, expressID);
      _this859.type = 1377556343;
      return _this859;
    }

    return IfcTopologicalRepresentationItem;
  }(IfcRepresentationItem);

  IFC4_32.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;

  var IfcTopologyRepresentation = /*#__PURE__*/function (_IfcShapeModel4) {
    _inherits(IfcTopologyRepresentation, _IfcShapeModel4);

    var _super868 = _createSuper(IfcTopologyRepresentation);

    function IfcTopologyRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this860;

      _classCallCheck2(this, IfcTopologyRepresentation);

      _this860 = _super868.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this860.ContextOfItems = ContextOfItems;
      _this860.RepresentationIdentifier = RepresentationIdentifier;
      _this860.RepresentationType = RepresentationType;
      _this860.Items = Items;
      _this860.type = 1735638870;
      return _this860;
    }

    return IfcTopologyRepresentation;
  }(IfcShapeModel);

  IFC4_32.IfcTopologyRepresentation = IfcTopologyRepresentation;

  var IfcUnitAssignment = /*#__PURE__*/function (_IfcLineObject160) {
    _inherits(IfcUnitAssignment, _IfcLineObject160);

    var _super869 = _createSuper(IfcUnitAssignment);

    function IfcUnitAssignment(expressID, Units) {
      var _this861;

      _classCallCheck2(this, IfcUnitAssignment);

      _this861 = _super869.call(this, expressID);
      _this861.Units = Units;
      _this861.type = 180925521;
      return _this861;
    }

    return IfcUnitAssignment;
  }(IfcLineObject);

  IFC4_32.IfcUnitAssignment = IfcUnitAssignment;

  var IfcVertex = /*#__PURE__*/function (_IfcTopologicalRepres8) {
    _inherits(IfcVertex, _IfcTopologicalRepres8);

    var _super870 = _createSuper(IfcVertex);

    function IfcVertex(expressID) {
      var _this862;

      _classCallCheck2(this, IfcVertex);

      _this862 = _super870.call(this, expressID);
      _this862.type = 2799835756;
      return _this862;
    }

    return IfcVertex;
  }(IfcTopologicalRepresentationItem);

  IFC4_32.IfcVertex = IfcVertex;

  var IfcVertexPoint = /*#__PURE__*/function (_IfcVertex2) {
    _inherits(IfcVertexPoint, _IfcVertex2);

    var _super871 = _createSuper(IfcVertexPoint);

    function IfcVertexPoint(expressID, VertexGeometry) {
      var _this863;

      _classCallCheck2(this, IfcVertexPoint);

      _this863 = _super871.call(this, expressID);
      _this863.VertexGeometry = VertexGeometry;
      _this863.type = 1907098498;
      return _this863;
    }

    return IfcVertexPoint;
  }(IfcVertex);

  IFC4_32.IfcVertexPoint = IfcVertexPoint;

  var IfcVirtualGridIntersection = /*#__PURE__*/function (_IfcLineObject161) {
    _inherits(IfcVirtualGridIntersection, _IfcLineObject161);

    var _super872 = _createSuper(IfcVirtualGridIntersection);

    function IfcVirtualGridIntersection(expressID, IntersectingAxes, OffsetDistances) {
      var _this864;

      _classCallCheck2(this, IfcVirtualGridIntersection);

      _this864 = _super872.call(this, expressID);
      _this864.IntersectingAxes = IntersectingAxes;
      _this864.OffsetDistances = OffsetDistances;
      _this864.type = 891718957;
      return _this864;
    }

    return IfcVirtualGridIntersection;
  }(IfcLineObject);

  IFC4_32.IfcVirtualGridIntersection = IfcVirtualGridIntersection;

  var IfcWorkTime = /*#__PURE__*/function (_IfcSchedulingTime2) {
    _inherits(IfcWorkTime, _IfcSchedulingTime2);

    var _super873 = _createSuper(IfcWorkTime);

    function IfcWorkTime(expressID, Name, DataOrigin, UserDefinedDataOrigin, RecurrencePattern, StartDate, FinishDate) {
      var _this865;

      _classCallCheck2(this, IfcWorkTime);

      _this865 = _super873.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin);
      _this865.Name = Name;
      _this865.DataOrigin = DataOrigin;
      _this865.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this865.RecurrencePattern = RecurrencePattern;
      _this865.StartDate = StartDate;
      _this865.FinishDate = FinishDate;
      _this865.type = 1236880293;
      return _this865;
    }

    return IfcWorkTime;
  }(IfcSchedulingTime);

  IFC4_32.IfcWorkTime = IfcWorkTime;

  var IfcAlignmentCantSegment = /*#__PURE__*/function (_IfcAlignmentParamete2) {
    _inherits(IfcAlignmentCantSegment, _IfcAlignmentParamete2);

    var _super874 = _createSuper(IfcAlignmentCantSegment);

    function IfcAlignmentCantSegment(expressID, StartTag, EndTag, StartDistAlong, HorizontalLength, StartCantLeft, EndCantLeft, StartCantRight, EndCantRight, PredefinedType) {
      var _this866;

      _classCallCheck2(this, IfcAlignmentCantSegment);

      _this866 = _super874.call(this, expressID, StartTag, EndTag);
      _this866.StartTag = StartTag;
      _this866.EndTag = EndTag;
      _this866.StartDistAlong = StartDistAlong;
      _this866.HorizontalLength = HorizontalLength;
      _this866.StartCantLeft = StartCantLeft;
      _this866.EndCantLeft = EndCantLeft;
      _this866.StartCantRight = StartCantRight;
      _this866.EndCantRight = EndCantRight;
      _this866.PredefinedType = PredefinedType;
      _this866.type = 3752311538;
      return _this866;
    }

    return IfcAlignmentCantSegment;
  }(IfcAlignmentParameterSegment);

  IFC4_32.IfcAlignmentCantSegment = IfcAlignmentCantSegment;

  var IfcAlignmentHorizontalSegment = /*#__PURE__*/function (_IfcAlignmentParamete3) {
    _inherits(IfcAlignmentHorizontalSegment, _IfcAlignmentParamete3);

    var _super875 = _createSuper(IfcAlignmentHorizontalSegment);

    function IfcAlignmentHorizontalSegment(expressID, StartTag, EndTag, StartPoint, StartDirection, StartRadiusOfCurvature, EndRadiusOfCurvature, SegmentLength, GravityCenterLineHeight, PredefinedType) {
      var _this867;

      _classCallCheck2(this, IfcAlignmentHorizontalSegment);

      _this867 = _super875.call(this, expressID, StartTag, EndTag);
      _this867.StartTag = StartTag;
      _this867.EndTag = EndTag;
      _this867.StartPoint = StartPoint;
      _this867.StartDirection = StartDirection;
      _this867.StartRadiusOfCurvature = StartRadiusOfCurvature;
      _this867.EndRadiusOfCurvature = EndRadiusOfCurvature;
      _this867.SegmentLength = SegmentLength;
      _this867.GravityCenterLineHeight = GravityCenterLineHeight;
      _this867.PredefinedType = PredefinedType;
      _this867.type = 536804194;
      return _this867;
    }

    return IfcAlignmentHorizontalSegment;
  }(IfcAlignmentParameterSegment);

  IFC4_32.IfcAlignmentHorizontalSegment = IfcAlignmentHorizontalSegment;

  var IfcApprovalRelationship = /*#__PURE__*/function (_IfcResourceLevelRela) {
    _inherits(IfcApprovalRelationship, _IfcResourceLevelRela);

    var _super876 = _createSuper(IfcApprovalRelationship);

    function IfcApprovalRelationship(expressID, Name, Description, RelatingApproval, RelatedApprovals) {
      var _this868;

      _classCallCheck2(this, IfcApprovalRelationship);

      _this868 = _super876.call(this, expressID, Name, Description);
      _this868.Name = Name;
      _this868.Description = Description;
      _this868.RelatingApproval = RelatingApproval;
      _this868.RelatedApprovals = RelatedApprovals;
      _this868.type = 3869604511;
      return _this868;
    }

    return IfcApprovalRelationship;
  }(IfcResourceLevelRelationship);

  IFC4_32.IfcApprovalRelationship = IfcApprovalRelationship;

  var IfcArbitraryClosedProfileDef = /*#__PURE__*/function (_IfcProfileDef6) {
    _inherits(IfcArbitraryClosedProfileDef, _IfcProfileDef6);

    var _super877 = _createSuper(IfcArbitraryClosedProfileDef);

    function IfcArbitraryClosedProfileDef(expressID, ProfileType, ProfileName, OuterCurve) {
      var _this869;

      _classCallCheck2(this, IfcArbitraryClosedProfileDef);

      _this869 = _super877.call(this, expressID, ProfileType, ProfileName);
      _this869.ProfileType = ProfileType;
      _this869.ProfileName = ProfileName;
      _this869.OuterCurve = OuterCurve;
      _this869.type = 3798115385;
      return _this869;
    }

    return IfcArbitraryClosedProfileDef;
  }(IfcProfileDef);

  IFC4_32.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;

  var IfcArbitraryOpenProfileDef = /*#__PURE__*/function (_IfcProfileDef7) {
    _inherits(IfcArbitraryOpenProfileDef, _IfcProfileDef7);

    var _super878 = _createSuper(IfcArbitraryOpenProfileDef);

    function IfcArbitraryOpenProfileDef(expressID, ProfileType, ProfileName, Curve) {
      var _this870;

      _classCallCheck2(this, IfcArbitraryOpenProfileDef);

      _this870 = _super878.call(this, expressID, ProfileType, ProfileName);
      _this870.ProfileType = ProfileType;
      _this870.ProfileName = ProfileName;
      _this870.Curve = Curve;
      _this870.type = 1310608509;
      return _this870;
    }

    return IfcArbitraryOpenProfileDef;
  }(IfcProfileDef);

  IFC4_32.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;

  var IfcArbitraryProfileDefWithVoids = /*#__PURE__*/function (_IfcArbitraryClosedPr2) {
    _inherits(IfcArbitraryProfileDefWithVoids, _IfcArbitraryClosedPr2);

    var _super879 = _createSuper(IfcArbitraryProfileDefWithVoids);

    function IfcArbitraryProfileDefWithVoids(expressID, ProfileType, ProfileName, OuterCurve, InnerCurves) {
      var _this871;

      _classCallCheck2(this, IfcArbitraryProfileDefWithVoids);

      _this871 = _super879.call(this, expressID, ProfileType, ProfileName, OuterCurve);
      _this871.ProfileType = ProfileType;
      _this871.ProfileName = ProfileName;
      _this871.OuterCurve = OuterCurve;
      _this871.InnerCurves = InnerCurves;
      _this871.type = 2705031697;
      return _this871;
    }

    return IfcArbitraryProfileDefWithVoids;
  }(IfcArbitraryClosedProfileDef);

  IFC4_32.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;

  var IfcBlobTexture = /*#__PURE__*/function (_IfcSurfaceTexture4) {
    _inherits(IfcBlobTexture, _IfcSurfaceTexture4);

    var _super880 = _createSuper(IfcBlobTexture);

    function IfcBlobTexture(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, RasterFormat, RasterCode) {
      var _this872;

      _classCallCheck2(this, IfcBlobTexture);

      _this872 = _super880.call(this, expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      _this872.RepeatS = RepeatS;
      _this872.RepeatT = RepeatT;
      _this872.Mode = Mode;
      _this872.TextureTransform = TextureTransform;
      _this872.Parameter = Parameter;
      _this872.RasterFormat = RasterFormat;
      _this872.RasterCode = RasterCode;
      _this872.type = 616511568;
      return _this872;
    }

    return IfcBlobTexture;
  }(IfcSurfaceTexture);

  IFC4_32.IfcBlobTexture = IfcBlobTexture;

  var IfcCenterLineProfileDef = /*#__PURE__*/function (_IfcArbitraryOpenProf2) {
    _inherits(IfcCenterLineProfileDef, _IfcArbitraryOpenProf2);

    var _super881 = _createSuper(IfcCenterLineProfileDef);

    function IfcCenterLineProfileDef(expressID, ProfileType, ProfileName, Curve, Thickness) {
      var _this873;

      _classCallCheck2(this, IfcCenterLineProfileDef);

      _this873 = _super881.call(this, expressID, ProfileType, ProfileName, Curve);
      _this873.ProfileType = ProfileType;
      _this873.ProfileName = ProfileName;
      _this873.Curve = Curve;
      _this873.Thickness = Thickness;
      _this873.type = 3150382593;
      return _this873;
    }

    return IfcCenterLineProfileDef;
  }(IfcArbitraryOpenProfileDef);

  IFC4_32.IfcCenterLineProfileDef = IfcCenterLineProfileDef;

  var IfcClassification = /*#__PURE__*/function (_IfcExternalInformati2) {
    _inherits(IfcClassification, _IfcExternalInformati2);

    var _super882 = _createSuper(IfcClassification);

    function IfcClassification(expressID, Source, Edition, EditionDate, Name, Description, Specification, ReferenceTokens) {
      var _this874;

      _classCallCheck2(this, IfcClassification);

      _this874 = _super882.call(this, expressID);
      _this874.Source = Source;
      _this874.Edition = Edition;
      _this874.EditionDate = EditionDate;
      _this874.Name = Name;
      _this874.Description = Description;
      _this874.Specification = Specification;
      _this874.ReferenceTokens = ReferenceTokens;
      _this874.type = 747523909;
      return _this874;
    }

    return IfcClassification;
  }(IfcExternalInformation);

  IFC4_32.IfcClassification = IfcClassification;

  var IfcClassificationReference = /*#__PURE__*/function (_IfcExternalReference12) {
    _inherits(IfcClassificationReference, _IfcExternalReference12);

    var _super883 = _createSuper(IfcClassificationReference);

    function IfcClassificationReference(expressID, Location, Identification, Name, ReferencedSource, Description, Sort) {
      var _this875;

      _classCallCheck2(this, IfcClassificationReference);

      _this875 = _super883.call(this, expressID, Location, Identification, Name);
      _this875.Location = Location;
      _this875.Identification = Identification;
      _this875.Name = Name;
      _this875.ReferencedSource = ReferencedSource;
      _this875.Description = Description;
      _this875.Sort = Sort;
      _this875.type = 647927063;
      return _this875;
    }

    return IfcClassificationReference;
  }(IfcExternalReference);

  IFC4_32.IfcClassificationReference = IfcClassificationReference;

  var IfcColourRgbList = /*#__PURE__*/function (_IfcPresentationItem11) {
    _inherits(IfcColourRgbList, _IfcPresentationItem11);

    var _super884 = _createSuper(IfcColourRgbList);

    function IfcColourRgbList(expressID, ColourList) {
      var _this876;

      _classCallCheck2(this, IfcColourRgbList);

      _this876 = _super884.call(this, expressID);
      _this876.ColourList = ColourList;
      _this876.type = 3285139300;
      return _this876;
    }

    return IfcColourRgbList;
  }(IfcPresentationItem);

  IFC4_32.IfcColourRgbList = IfcColourRgbList;

  var IfcColourSpecification = /*#__PURE__*/function (_IfcPresentationItem12) {
    _inherits(IfcColourSpecification, _IfcPresentationItem12);

    var _super885 = _createSuper(IfcColourSpecification);

    function IfcColourSpecification(expressID, Name) {
      var _this877;

      _classCallCheck2(this, IfcColourSpecification);

      _this877 = _super885.call(this, expressID);
      _this877.Name = Name;
      _this877.type = 3264961684;
      return _this877;
    }

    return IfcColourSpecification;
  }(IfcPresentationItem);

  IFC4_32.IfcColourSpecification = IfcColourSpecification;

  var IfcCompositeProfileDef = /*#__PURE__*/function (_IfcProfileDef8) {
    _inherits(IfcCompositeProfileDef, _IfcProfileDef8);

    var _super886 = _createSuper(IfcCompositeProfileDef);

    function IfcCompositeProfileDef(expressID, ProfileType, ProfileName, Profiles, Label) {
      var _this878;

      _classCallCheck2(this, IfcCompositeProfileDef);

      _this878 = _super886.call(this, expressID, ProfileType, ProfileName);
      _this878.ProfileType = ProfileType;
      _this878.ProfileName = ProfileName;
      _this878.Profiles = Profiles;
      _this878.Label = Label;
      _this878.type = 1485152156;
      return _this878;
    }

    return IfcCompositeProfileDef;
  }(IfcProfileDef);

  IFC4_32.IfcCompositeProfileDef = IfcCompositeProfileDef;

  var IfcConnectedFaceSet = /*#__PURE__*/function (_IfcTopologicalRepres9) {
    _inherits(IfcConnectedFaceSet, _IfcTopologicalRepres9);

    var _super887 = _createSuper(IfcConnectedFaceSet);

    function IfcConnectedFaceSet(expressID, CfsFaces) {
      var _this879;

      _classCallCheck2(this, IfcConnectedFaceSet);

      _this879 = _super887.call(this, expressID);
      _this879.CfsFaces = CfsFaces;
      _this879.type = 370225590;
      return _this879;
    }

    return IfcConnectedFaceSet;
  }(IfcTopologicalRepresentationItem);

  IFC4_32.IfcConnectedFaceSet = IfcConnectedFaceSet;

  var IfcConnectionCurveGeometry = /*#__PURE__*/function (_IfcConnectionGeometr8) {
    _inherits(IfcConnectionCurveGeometry, _IfcConnectionGeometr8);

    var _super888 = _createSuper(IfcConnectionCurveGeometry);

    function IfcConnectionCurveGeometry(expressID, CurveOnRelatingElement, CurveOnRelatedElement) {
      var _this880;

      _classCallCheck2(this, IfcConnectionCurveGeometry);

      _this880 = _super888.call(this, expressID);
      _this880.CurveOnRelatingElement = CurveOnRelatingElement;
      _this880.CurveOnRelatedElement = CurveOnRelatedElement;
      _this880.type = 1981873012;
      return _this880;
    }

    return IfcConnectionCurveGeometry;
  }(IfcConnectionGeometry);

  IFC4_32.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;

  var IfcConnectionPointEccentricity = /*#__PURE__*/function (_IfcConnectionPointGe2) {
    _inherits(IfcConnectionPointEccentricity, _IfcConnectionPointGe2);

    var _super889 = _createSuper(IfcConnectionPointEccentricity);

    function IfcConnectionPointEccentricity(expressID, PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ) {
      var _this881;

      _classCallCheck2(this, IfcConnectionPointEccentricity);

      _this881 = _super889.call(this, expressID, PointOnRelatingElement, PointOnRelatedElement);
      _this881.PointOnRelatingElement = PointOnRelatingElement;
      _this881.PointOnRelatedElement = PointOnRelatedElement;
      _this881.EccentricityInX = EccentricityInX;
      _this881.EccentricityInY = EccentricityInY;
      _this881.EccentricityInZ = EccentricityInZ;
      _this881.type = 45288368;
      return _this881;
    }

    return IfcConnectionPointEccentricity;
  }(IfcConnectionPointGeometry);

  IFC4_32.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;

  var IfcContextDependentUnit = /*#__PURE__*/function (_IfcNamedUnit5) {
    _inherits(IfcContextDependentUnit, _IfcNamedUnit5);

    var _super890 = _createSuper(IfcContextDependentUnit);

    function IfcContextDependentUnit(expressID, Dimensions, UnitType, Name) {
      var _this882;

      _classCallCheck2(this, IfcContextDependentUnit);

      _this882 = _super890.call(this, expressID, Dimensions, UnitType);
      _this882.Dimensions = Dimensions;
      _this882.UnitType = UnitType;
      _this882.Name = Name;
      _this882.type = 3050246964;
      return _this882;
    }

    return IfcContextDependentUnit;
  }(IfcNamedUnit);

  IFC4_32.IfcContextDependentUnit = IfcContextDependentUnit;

  var IfcConversionBasedUnit = /*#__PURE__*/function (_IfcNamedUnit6) {
    _inherits(IfcConversionBasedUnit, _IfcNamedUnit6);

    var _super891 = _createSuper(IfcConversionBasedUnit);

    function IfcConversionBasedUnit(expressID, Dimensions, UnitType, Name, ConversionFactor) {
      var _this883;

      _classCallCheck2(this, IfcConversionBasedUnit);

      _this883 = _super891.call(this, expressID, Dimensions, UnitType);
      _this883.Dimensions = Dimensions;
      _this883.UnitType = UnitType;
      _this883.Name = Name;
      _this883.ConversionFactor = ConversionFactor;
      _this883.type = 2889183280;
      return _this883;
    }

    return IfcConversionBasedUnit;
  }(IfcNamedUnit);

  IFC4_32.IfcConversionBasedUnit = IfcConversionBasedUnit;

  var IfcConversionBasedUnitWithOffset = /*#__PURE__*/function (_IfcConversionBasedUn) {
    _inherits(IfcConversionBasedUnitWithOffset, _IfcConversionBasedUn);

    var _super892 = _createSuper(IfcConversionBasedUnitWithOffset);

    function IfcConversionBasedUnitWithOffset(expressID, Dimensions, UnitType, Name, ConversionFactor, ConversionOffset) {
      var _this884;

      _classCallCheck2(this, IfcConversionBasedUnitWithOffset);

      _this884 = _super892.call(this, expressID, Dimensions, UnitType, Name, ConversionFactor);
      _this884.Dimensions = Dimensions;
      _this884.UnitType = UnitType;
      _this884.Name = Name;
      _this884.ConversionFactor = ConversionFactor;
      _this884.ConversionOffset = ConversionOffset;
      _this884.type = 2713554722;
      return _this884;
    }

    return IfcConversionBasedUnitWithOffset;
  }(IfcConversionBasedUnit);

  IFC4_32.IfcConversionBasedUnitWithOffset = IfcConversionBasedUnitWithOffset;

  var IfcCurrencyRelationship = /*#__PURE__*/function (_IfcResourceLevelRela2) {
    _inherits(IfcCurrencyRelationship, _IfcResourceLevelRela2);

    var _super893 = _createSuper(IfcCurrencyRelationship);

    function IfcCurrencyRelationship(expressID, Name, Description, RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource) {
      var _this885;

      _classCallCheck2(this, IfcCurrencyRelationship);

      _this885 = _super893.call(this, expressID, Name, Description);
      _this885.Name = Name;
      _this885.Description = Description;
      _this885.RelatingMonetaryUnit = RelatingMonetaryUnit;
      _this885.RelatedMonetaryUnit = RelatedMonetaryUnit;
      _this885.ExchangeRate = ExchangeRate;
      _this885.RateDateTime = RateDateTime;
      _this885.RateSource = RateSource;
      _this885.type = 539742890;
      return _this885;
    }

    return IfcCurrencyRelationship;
  }(IfcResourceLevelRelationship);

  IFC4_32.IfcCurrencyRelationship = IfcCurrencyRelationship;

  var IfcCurveStyle = /*#__PURE__*/function (_IfcPresentationStyle8) {
    _inherits(IfcCurveStyle, _IfcPresentationStyle8);

    var _super894 = _createSuper(IfcCurveStyle);

    function IfcCurveStyle(expressID, Name, CurveFont, CurveWidth, CurveColour, ModelOrDraughting) {
      var _this886;

      _classCallCheck2(this, IfcCurveStyle);

      _this886 = _super894.call(this, expressID, Name);
      _this886.Name = Name;
      _this886.CurveFont = CurveFont;
      _this886.CurveWidth = CurveWidth;
      _this886.CurveColour = CurveColour;
      _this886.ModelOrDraughting = ModelOrDraughting;
      _this886.type = 3800577675;
      return _this886;
    }

    return IfcCurveStyle;
  }(IfcPresentationStyle);

  IFC4_32.IfcCurveStyle = IfcCurveStyle;

  var IfcCurveStyleFont = /*#__PURE__*/function (_IfcPresentationItem13) {
    _inherits(IfcCurveStyleFont, _IfcPresentationItem13);

    var _super895 = _createSuper(IfcCurveStyleFont);

    function IfcCurveStyleFont(expressID, Name, PatternList) {
      var _this887;

      _classCallCheck2(this, IfcCurveStyleFont);

      _this887 = _super895.call(this, expressID);
      _this887.Name = Name;
      _this887.PatternList = PatternList;
      _this887.type = 1105321065;
      return _this887;
    }

    return IfcCurveStyleFont;
  }(IfcPresentationItem);

  IFC4_32.IfcCurveStyleFont = IfcCurveStyleFont;

  var IfcCurveStyleFontAndScaling = /*#__PURE__*/function (_IfcPresentationItem14) {
    _inherits(IfcCurveStyleFontAndScaling, _IfcPresentationItem14);

    var _super896 = _createSuper(IfcCurveStyleFontAndScaling);

    function IfcCurveStyleFontAndScaling(expressID, Name, CurveStyleFont, CurveFontScaling) {
      var _this888;

      _classCallCheck2(this, IfcCurveStyleFontAndScaling);

      _this888 = _super896.call(this, expressID);
      _this888.Name = Name;
      _this888.CurveStyleFont = CurveStyleFont;
      _this888.CurveFontScaling = CurveFontScaling;
      _this888.type = 2367409068;
      return _this888;
    }

    return IfcCurveStyleFontAndScaling;
  }(IfcPresentationItem);

  IFC4_32.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;

  var IfcCurveStyleFontPattern = /*#__PURE__*/function (_IfcPresentationItem15) {
    _inherits(IfcCurveStyleFontPattern, _IfcPresentationItem15);

    var _super897 = _createSuper(IfcCurveStyleFontPattern);

    function IfcCurveStyleFontPattern(expressID, VisibleSegmentLength, InvisibleSegmentLength) {
      var _this889;

      _classCallCheck2(this, IfcCurveStyleFontPattern);

      _this889 = _super897.call(this, expressID);
      _this889.VisibleSegmentLength = VisibleSegmentLength;
      _this889.InvisibleSegmentLength = InvisibleSegmentLength;
      _this889.type = 3510044353;
      return _this889;
    }

    return IfcCurveStyleFontPattern;
  }(IfcPresentationItem);

  IFC4_32.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;

  var IfcDerivedProfileDef = /*#__PURE__*/function (_IfcProfileDef9) {
    _inherits(IfcDerivedProfileDef, _IfcProfileDef9);

    var _super898 = _createSuper(IfcDerivedProfileDef);

    function IfcDerivedProfileDef(expressID, ProfileType, ProfileName, ParentProfile, Operator, Label) {
      var _this890;

      _classCallCheck2(this, IfcDerivedProfileDef);

      _this890 = _super898.call(this, expressID, ProfileType, ProfileName);
      _this890.ProfileType = ProfileType;
      _this890.ProfileName = ProfileName;
      _this890.ParentProfile = ParentProfile;
      _this890.Operator = Operator;
      _this890.Label = Label;
      _this890.type = 3632507154;
      return _this890;
    }

    return IfcDerivedProfileDef;
  }(IfcProfileDef);

  IFC4_32.IfcDerivedProfileDef = IfcDerivedProfileDef;

  var IfcDocumentInformation = /*#__PURE__*/function (_IfcExternalInformati3) {
    _inherits(IfcDocumentInformation, _IfcExternalInformati3);

    var _super899 = _createSuper(IfcDocumentInformation);

    function IfcDocumentInformation(expressID, Identification, Name, Description, Location, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status) {
      var _this891;

      _classCallCheck2(this, IfcDocumentInformation);

      _this891 = _super899.call(this, expressID);
      _this891.Identification = Identification;
      _this891.Name = Name;
      _this891.Description = Description;
      _this891.Location = Location;
      _this891.Purpose = Purpose;
      _this891.IntendedUse = IntendedUse;
      _this891.Scope = Scope;
      _this891.Revision = Revision;
      _this891.DocumentOwner = DocumentOwner;
      _this891.Editors = Editors;
      _this891.CreationTime = CreationTime;
      _this891.LastRevisionTime = LastRevisionTime;
      _this891.ElectronicFormat = ElectronicFormat;
      _this891.ValidFrom = ValidFrom;
      _this891.ValidUntil = ValidUntil;
      _this891.Confidentiality = Confidentiality;
      _this891.Status = Status;
      _this891.type = 1154170062;
      return _this891;
    }

    return IfcDocumentInformation;
  }(IfcExternalInformation);

  IFC4_32.IfcDocumentInformation = IfcDocumentInformation;

  var IfcDocumentInformationRelationship = /*#__PURE__*/function (_IfcResourceLevelRela3) {
    _inherits(IfcDocumentInformationRelationship, _IfcResourceLevelRela3);

    var _super900 = _createSuper(IfcDocumentInformationRelationship);

    function IfcDocumentInformationRelationship(expressID, Name, Description, RelatingDocument, RelatedDocuments, RelationshipType) {
      var _this892;

      _classCallCheck2(this, IfcDocumentInformationRelationship);

      _this892 = _super900.call(this, expressID, Name, Description);
      _this892.Name = Name;
      _this892.Description = Description;
      _this892.RelatingDocument = RelatingDocument;
      _this892.RelatedDocuments = RelatedDocuments;
      _this892.RelationshipType = RelationshipType;
      _this892.type = 770865208;
      return _this892;
    }

    return IfcDocumentInformationRelationship;
  }(IfcResourceLevelRelationship);

  IFC4_32.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;

  var IfcDocumentReference = /*#__PURE__*/function (_IfcExternalReference13) {
    _inherits(IfcDocumentReference, _IfcExternalReference13);

    var _super901 = _createSuper(IfcDocumentReference);

    function IfcDocumentReference(expressID, Location, Identification, Name, Description, ReferencedDocument) {
      var _this893;

      _classCallCheck2(this, IfcDocumentReference);

      _this893 = _super901.call(this, expressID, Location, Identification, Name);
      _this893.Location = Location;
      _this893.Identification = Identification;
      _this893.Name = Name;
      _this893.Description = Description;
      _this893.ReferencedDocument = ReferencedDocument;
      _this893.type = 3732053477;
      return _this893;
    }

    return IfcDocumentReference;
  }(IfcExternalReference);

  IFC4_32.IfcDocumentReference = IfcDocumentReference;

  var IfcEdge = /*#__PURE__*/function (_IfcTopologicalRepres10) {
    _inherits(IfcEdge, _IfcTopologicalRepres10);

    var _super902 = _createSuper(IfcEdge);

    function IfcEdge(expressID, EdgeStart, EdgeEnd) {
      var _this894;

      _classCallCheck2(this, IfcEdge);

      _this894 = _super902.call(this, expressID);
      _this894.EdgeStart = EdgeStart;
      _this894.EdgeEnd = EdgeEnd;
      _this894.type = 3900360178;
      return _this894;
    }

    return IfcEdge;
  }(IfcTopologicalRepresentationItem);

  IFC4_32.IfcEdge = IfcEdge;

  var IfcEdgeCurve = /*#__PURE__*/function (_IfcEdge4) {
    _inherits(IfcEdgeCurve, _IfcEdge4);

    var _super903 = _createSuper(IfcEdgeCurve);

    function IfcEdgeCurve(expressID, EdgeStart, EdgeEnd, EdgeGeometry, SameSense) {
      var _this895;

      _classCallCheck2(this, IfcEdgeCurve);

      _this895 = _super903.call(this, expressID, EdgeStart, EdgeEnd);
      _this895.EdgeStart = EdgeStart;
      _this895.EdgeEnd = EdgeEnd;
      _this895.EdgeGeometry = EdgeGeometry;
      _this895.SameSense = SameSense;
      _this895.type = 476780140;
      return _this895;
    }

    return IfcEdgeCurve;
  }(IfcEdge);

  IFC4_32.IfcEdgeCurve = IfcEdgeCurve;

  var IfcEventTime = /*#__PURE__*/function (_IfcSchedulingTime3) {
    _inherits(IfcEventTime, _IfcSchedulingTime3);

    var _super904 = _createSuper(IfcEventTime);

    function IfcEventTime(expressID, Name, DataOrigin, UserDefinedDataOrigin, ActualDate, EarlyDate, LateDate, ScheduleDate) {
      var _this896;

      _classCallCheck2(this, IfcEventTime);

      _this896 = _super904.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin);
      _this896.Name = Name;
      _this896.DataOrigin = DataOrigin;
      _this896.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this896.ActualDate = ActualDate;
      _this896.EarlyDate = EarlyDate;
      _this896.LateDate = LateDate;
      _this896.ScheduleDate = ScheduleDate;
      _this896.type = 211053100;
      return _this896;
    }

    return IfcEventTime;
  }(IfcSchedulingTime);

  IFC4_32.IfcEventTime = IfcEventTime;

  var IfcExtendedProperties = /*#__PURE__*/function (_IfcPropertyAbstracti2) {
    _inherits(IfcExtendedProperties, _IfcPropertyAbstracti2);

    var _super905 = _createSuper(IfcExtendedProperties);

    function IfcExtendedProperties(expressID, Name, Description, Properties2) {
      var _this897;

      _classCallCheck2(this, IfcExtendedProperties);

      _this897 = _super905.call(this, expressID);
      _this897.Name = Name;
      _this897.Description = Description;
      _this897.Properties = Properties2;
      _this897.type = 297599258;
      return _this897;
    }

    return IfcExtendedProperties;
  }(IfcPropertyAbstraction);

  IFC4_32.IfcExtendedProperties = IfcExtendedProperties;

  var IfcExternalReferenceRelationship = /*#__PURE__*/function (_IfcResourceLevelRela4) {
    _inherits(IfcExternalReferenceRelationship, _IfcResourceLevelRela4);

    var _super906 = _createSuper(IfcExternalReferenceRelationship);

    function IfcExternalReferenceRelationship(expressID, Name, Description, RelatingReference, RelatedResourceObjects) {
      var _this898;

      _classCallCheck2(this, IfcExternalReferenceRelationship);

      _this898 = _super906.call(this, expressID, Name, Description);
      _this898.Name = Name;
      _this898.Description = Description;
      _this898.RelatingReference = RelatingReference;
      _this898.RelatedResourceObjects = RelatedResourceObjects;
      _this898.type = 1437805879;
      return _this898;
    }

    return IfcExternalReferenceRelationship;
  }(IfcResourceLevelRelationship);

  IFC4_32.IfcExternalReferenceRelationship = IfcExternalReferenceRelationship;

  var IfcFace = /*#__PURE__*/function (_IfcTopologicalRepres11) {
    _inherits(IfcFace, _IfcTopologicalRepres11);

    var _super907 = _createSuper(IfcFace);

    function IfcFace(expressID, Bounds) {
      var _this899;

      _classCallCheck2(this, IfcFace);

      _this899 = _super907.call(this, expressID);
      _this899.Bounds = Bounds;
      _this899.type = 2556980723;
      return _this899;
    }

    return IfcFace;
  }(IfcTopologicalRepresentationItem);

  IFC4_32.IfcFace = IfcFace;

  var IfcFaceBound = /*#__PURE__*/function (_IfcTopologicalRepres12) {
    _inherits(IfcFaceBound, _IfcTopologicalRepres12);

    var _super908 = _createSuper(IfcFaceBound);

    function IfcFaceBound(expressID, Bound, Orientation) {
      var _this900;

      _classCallCheck2(this, IfcFaceBound);

      _this900 = _super908.call(this, expressID);
      _this900.Bound = Bound;
      _this900.Orientation = Orientation;
      _this900.type = 1809719519;
      return _this900;
    }

    return IfcFaceBound;
  }(IfcTopologicalRepresentationItem);

  IFC4_32.IfcFaceBound = IfcFaceBound;

  var IfcFaceOuterBound = /*#__PURE__*/function (_IfcFaceBound2) {
    _inherits(IfcFaceOuterBound, _IfcFaceBound2);

    var _super909 = _createSuper(IfcFaceOuterBound);

    function IfcFaceOuterBound(expressID, Bound, Orientation) {
      var _this901;

      _classCallCheck2(this, IfcFaceOuterBound);

      _this901 = _super909.call(this, expressID, Bound, Orientation);
      _this901.Bound = Bound;
      _this901.Orientation = Orientation;
      _this901.type = 803316827;
      return _this901;
    }

    return IfcFaceOuterBound;
  }(IfcFaceBound);

  IFC4_32.IfcFaceOuterBound = IfcFaceOuterBound;

  var IfcFaceSurface = /*#__PURE__*/function (_IfcFace2) {
    _inherits(IfcFaceSurface, _IfcFace2);

    var _super910 = _createSuper(IfcFaceSurface);

    function IfcFaceSurface(expressID, Bounds, FaceSurface, SameSense) {
      var _this902;

      _classCallCheck2(this, IfcFaceSurface);

      _this902 = _super910.call(this, expressID, Bounds);
      _this902.Bounds = Bounds;
      _this902.FaceSurface = FaceSurface;
      _this902.SameSense = SameSense;
      _this902.type = 3008276851;
      return _this902;
    }

    return IfcFaceSurface;
  }(IfcFace);

  IFC4_32.IfcFaceSurface = IfcFaceSurface;

  var IfcFailureConnectionCondition = /*#__PURE__*/function (_IfcStructuralConnect6) {
    _inherits(IfcFailureConnectionCondition, _IfcStructuralConnect6);

    var _super911 = _createSuper(IfcFailureConnectionCondition);

    function IfcFailureConnectionCondition(expressID, Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ) {
      var _this903;

      _classCallCheck2(this, IfcFailureConnectionCondition);

      _this903 = _super911.call(this, expressID, Name);
      _this903.Name = Name;
      _this903.TensionFailureX = TensionFailureX;
      _this903.TensionFailureY = TensionFailureY;
      _this903.TensionFailureZ = TensionFailureZ;
      _this903.CompressionFailureX = CompressionFailureX;
      _this903.CompressionFailureY = CompressionFailureY;
      _this903.CompressionFailureZ = CompressionFailureZ;
      _this903.type = 4219587988;
      return _this903;
    }

    return IfcFailureConnectionCondition;
  }(IfcStructuralConnectionCondition);

  IFC4_32.IfcFailureConnectionCondition = IfcFailureConnectionCondition;

  var IfcFillAreaStyle = /*#__PURE__*/function (_IfcPresentationStyle9) {
    _inherits(IfcFillAreaStyle, _IfcPresentationStyle9);

    var _super912 = _createSuper(IfcFillAreaStyle);

    function IfcFillAreaStyle(expressID, Name, FillStyles, ModelOrDraughting) {
      var _this904;

      _classCallCheck2(this, IfcFillAreaStyle);

      _this904 = _super912.call(this, expressID, Name);
      _this904.Name = Name;
      _this904.FillStyles = FillStyles;
      _this904.ModelOrDraughting = ModelOrDraughting;
      _this904.type = 738692330;
      return _this904;
    }

    return IfcFillAreaStyle;
  }(IfcPresentationStyle);

  IFC4_32.IfcFillAreaStyle = IfcFillAreaStyle;

  var IfcGeometricRepresentationContext = /*#__PURE__*/function (_IfcRepresentationCon2) {
    _inherits(IfcGeometricRepresentationContext, _IfcRepresentationCon2);

    var _super913 = _createSuper(IfcGeometricRepresentationContext);

    function IfcGeometricRepresentationContext(expressID, ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth) {
      var _this905;

      _classCallCheck2(this, IfcGeometricRepresentationContext);

      _this905 = _super913.call(this, expressID, ContextIdentifier, ContextType);
      _this905.ContextIdentifier = ContextIdentifier;
      _this905.ContextType = ContextType;
      _this905.CoordinateSpaceDimension = CoordinateSpaceDimension;
      _this905.Precision = Precision;
      _this905.WorldCoordinateSystem = WorldCoordinateSystem;
      _this905.TrueNorth = TrueNorth;
      _this905.type = 3448662350;
      return _this905;
    }

    return IfcGeometricRepresentationContext;
  }(IfcRepresentationContext);

  IFC4_32.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;

  var IfcGeometricRepresentationItem = /*#__PURE__*/function (_IfcRepresentationIte7) {
    _inherits(IfcGeometricRepresentationItem, _IfcRepresentationIte7);

    var _super914 = _createSuper(IfcGeometricRepresentationItem);

    function IfcGeometricRepresentationItem(expressID) {
      var _this906;

      _classCallCheck2(this, IfcGeometricRepresentationItem);

      _this906 = _super914.call(this, expressID);
      _this906.type = 2453401579;
      return _this906;
    }

    return IfcGeometricRepresentationItem;
  }(IfcRepresentationItem);

  IFC4_32.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;

  var IfcGeometricRepresentationSubContext = /*#__PURE__*/function (_IfcGeometricRepresen30) {
    _inherits(IfcGeometricRepresentationSubContext, _IfcGeometricRepresen30);

    var _super915 = _createSuper(IfcGeometricRepresentationSubContext);

    function IfcGeometricRepresentationSubContext(expressID, ContextIdentifier, ContextType, WorldCoordinateSystem, ParentContext, TargetScale, TargetView, UserDefinedTargetView) {
      var _this907;

      _classCallCheck2(this, IfcGeometricRepresentationSubContext);

      _this907 = _super915.call(this, expressID, ContextIdentifier, ContextType, new IfcDimensionCount(0), null, WorldCoordinateSystem, null);
      _this907.ContextIdentifier = ContextIdentifier;
      _this907.ContextType = ContextType;
      _this907.WorldCoordinateSystem = WorldCoordinateSystem;
      _this907.ParentContext = ParentContext;
      _this907.TargetScale = TargetScale;
      _this907.TargetView = TargetView;
      _this907.UserDefinedTargetView = UserDefinedTargetView;
      _this907.type = 4142052618;
      return _this907;
    }

    return IfcGeometricRepresentationSubContext;
  }(IfcGeometricRepresentationContext);

  IFC4_32.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;

  var IfcGeometricSet = /*#__PURE__*/function (_IfcGeometricRepresen31) {
    _inherits(IfcGeometricSet, _IfcGeometricRepresen31);

    var _super916 = _createSuper(IfcGeometricSet);

    function IfcGeometricSet(expressID, Elements) {
      var _this908;

      _classCallCheck2(this, IfcGeometricSet);

      _this908 = _super916.call(this, expressID);
      _this908.Elements = Elements;
      _this908.type = 3590301190;
      return _this908;
    }

    return IfcGeometricSet;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcGeometricSet = IfcGeometricSet;

  var IfcGridPlacement = /*#__PURE__*/function (_IfcObjectPlacement3) {
    _inherits(IfcGridPlacement, _IfcObjectPlacement3);

    var _super917 = _createSuper(IfcGridPlacement);

    function IfcGridPlacement(expressID, PlacementRelTo, PlacementLocation, PlacementRefDirection) {
      var _this909;

      _classCallCheck2(this, IfcGridPlacement);

      _this909 = _super917.call(this, expressID, PlacementRelTo);
      _this909.PlacementRelTo = PlacementRelTo;
      _this909.PlacementLocation = PlacementLocation;
      _this909.PlacementRefDirection = PlacementRefDirection;
      _this909.type = 178086475;
      return _this909;
    }

    return IfcGridPlacement;
  }(IfcObjectPlacement);

  IFC4_32.IfcGridPlacement = IfcGridPlacement;

  var IfcHalfSpaceSolid = /*#__PURE__*/function (_IfcGeometricRepresen32) {
    _inherits(IfcHalfSpaceSolid, _IfcGeometricRepresen32);

    var _super918 = _createSuper(IfcHalfSpaceSolid);

    function IfcHalfSpaceSolid(expressID, BaseSurface, AgreementFlag) {
      var _this910;

      _classCallCheck2(this, IfcHalfSpaceSolid);

      _this910 = _super918.call(this, expressID);
      _this910.BaseSurface = BaseSurface;
      _this910.AgreementFlag = AgreementFlag;
      _this910.type = 812098782;
      return _this910;
    }

    return IfcHalfSpaceSolid;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcHalfSpaceSolid = IfcHalfSpaceSolid;

  var IfcImageTexture = /*#__PURE__*/function (_IfcSurfaceTexture5) {
    _inherits(IfcImageTexture, _IfcSurfaceTexture5);

    var _super919 = _createSuper(IfcImageTexture);

    function IfcImageTexture(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, URLReference) {
      var _this911;

      _classCallCheck2(this, IfcImageTexture);

      _this911 = _super919.call(this, expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      _this911.RepeatS = RepeatS;
      _this911.RepeatT = RepeatT;
      _this911.Mode = Mode;
      _this911.TextureTransform = TextureTransform;
      _this911.Parameter = Parameter;
      _this911.URLReference = URLReference;
      _this911.type = 3905492369;
      return _this911;
    }

    return IfcImageTexture;
  }(IfcSurfaceTexture);

  IFC4_32.IfcImageTexture = IfcImageTexture;

  var IfcIndexedColourMap = /*#__PURE__*/function (_IfcPresentationItem16) {
    _inherits(IfcIndexedColourMap, _IfcPresentationItem16);

    var _super920 = _createSuper(IfcIndexedColourMap);

    function IfcIndexedColourMap(expressID, MappedTo, Opacity, Colours, ColourIndex) {
      var _this912;

      _classCallCheck2(this, IfcIndexedColourMap);

      _this912 = _super920.call(this, expressID);
      _this912.MappedTo = MappedTo;
      _this912.Opacity = Opacity;
      _this912.Colours = Colours;
      _this912.ColourIndex = ColourIndex;
      _this912.type = 3570813810;
      return _this912;
    }

    return IfcIndexedColourMap;
  }(IfcPresentationItem);

  IFC4_32.IfcIndexedColourMap = IfcIndexedColourMap;

  var IfcIndexedTextureMap = /*#__PURE__*/function (_IfcTextureCoordinate6) {
    _inherits(IfcIndexedTextureMap, _IfcTextureCoordinate6);

    var _super921 = _createSuper(IfcIndexedTextureMap);

    function IfcIndexedTextureMap(expressID, Maps, MappedTo, TexCoords) {
      var _this913;

      _classCallCheck2(this, IfcIndexedTextureMap);

      _this913 = _super921.call(this, expressID, Maps);
      _this913.Maps = Maps;
      _this913.MappedTo = MappedTo;
      _this913.TexCoords = TexCoords;
      _this913.type = 1437953363;
      return _this913;
    }

    return IfcIndexedTextureMap;
  }(IfcTextureCoordinate);

  IFC4_32.IfcIndexedTextureMap = IfcIndexedTextureMap;

  var IfcIndexedTriangleTextureMap = /*#__PURE__*/function (_IfcIndexedTextureMap) {
    _inherits(IfcIndexedTriangleTextureMap, _IfcIndexedTextureMap);

    var _super922 = _createSuper(IfcIndexedTriangleTextureMap);

    function IfcIndexedTriangleTextureMap(expressID, Maps, MappedTo, TexCoords, TexCoordIndex) {
      var _this914;

      _classCallCheck2(this, IfcIndexedTriangleTextureMap);

      _this914 = _super922.call(this, expressID, Maps, MappedTo, TexCoords);
      _this914.Maps = Maps;
      _this914.MappedTo = MappedTo;
      _this914.TexCoords = TexCoords;
      _this914.TexCoordIndex = TexCoordIndex;
      _this914.type = 2133299955;
      return _this914;
    }

    return IfcIndexedTriangleTextureMap;
  }(IfcIndexedTextureMap);

  IFC4_32.IfcIndexedTriangleTextureMap = IfcIndexedTriangleTextureMap;

  var IfcIrregularTimeSeries = /*#__PURE__*/function (_IfcTimeSeries3) {
    _inherits(IfcIrregularTimeSeries, _IfcTimeSeries3);

    var _super923 = _createSuper(IfcIrregularTimeSeries);

    function IfcIrregularTimeSeries(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values) {
      var _this915;

      _classCallCheck2(this, IfcIrregularTimeSeries);

      _this915 = _super923.call(this, expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      _this915.Name = Name;
      _this915.Description = Description;
      _this915.StartTime = StartTime;
      _this915.EndTime = EndTime;
      _this915.TimeSeriesDataType = TimeSeriesDataType;
      _this915.DataOrigin = DataOrigin;
      _this915.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this915.Unit = Unit;
      _this915.Values = Values;
      _this915.type = 3741457305;
      return _this915;
    }

    return IfcIrregularTimeSeries;
  }(IfcTimeSeries);

  IFC4_32.IfcIrregularTimeSeries = IfcIrregularTimeSeries;

  var IfcLagTime = /*#__PURE__*/function (_IfcSchedulingTime4) {
    _inherits(IfcLagTime, _IfcSchedulingTime4);

    var _super924 = _createSuper(IfcLagTime);

    function IfcLagTime(expressID, Name, DataOrigin, UserDefinedDataOrigin, LagValue, DurationType) {
      var _this916;

      _classCallCheck2(this, IfcLagTime);

      _this916 = _super924.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin);
      _this916.Name = Name;
      _this916.DataOrigin = DataOrigin;
      _this916.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this916.LagValue = LagValue;
      _this916.DurationType = DurationType;
      _this916.type = 1585845231;
      return _this916;
    }

    return IfcLagTime;
  }(IfcSchedulingTime);

  IFC4_32.IfcLagTime = IfcLagTime;

  var IfcLightSource = /*#__PURE__*/function (_IfcGeometricRepresen33) {
    _inherits(IfcLightSource, _IfcGeometricRepresen33);

    var _super925 = _createSuper(IfcLightSource);

    function IfcLightSource(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      var _this917;

      _classCallCheck2(this, IfcLightSource);

      _this917 = _super925.call(this, expressID);
      _this917.Name = Name;
      _this917.LightColour = LightColour;
      _this917.AmbientIntensity = AmbientIntensity;
      _this917.Intensity = Intensity;
      _this917.type = 1402838566;
      return _this917;
    }

    return IfcLightSource;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcLightSource = IfcLightSource;

  var IfcLightSourceAmbient = /*#__PURE__*/function (_IfcLightSource5) {
    _inherits(IfcLightSourceAmbient, _IfcLightSource5);

    var _super926 = _createSuper(IfcLightSourceAmbient);

    function IfcLightSourceAmbient(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      var _this918;

      _classCallCheck2(this, IfcLightSourceAmbient);

      _this918 = _super926.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this918.Name = Name;
      _this918.LightColour = LightColour;
      _this918.AmbientIntensity = AmbientIntensity;
      _this918.Intensity = Intensity;
      _this918.type = 125510826;
      return _this918;
    }

    return IfcLightSourceAmbient;
  }(IfcLightSource);

  IFC4_32.IfcLightSourceAmbient = IfcLightSourceAmbient;

  var IfcLightSourceDirectional = /*#__PURE__*/function (_IfcLightSource6) {
    _inherits(IfcLightSourceDirectional, _IfcLightSource6);

    var _super927 = _createSuper(IfcLightSourceDirectional);

    function IfcLightSourceDirectional(expressID, Name, LightColour, AmbientIntensity, Intensity, Orientation) {
      var _this919;

      _classCallCheck2(this, IfcLightSourceDirectional);

      _this919 = _super927.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this919.Name = Name;
      _this919.LightColour = LightColour;
      _this919.AmbientIntensity = AmbientIntensity;
      _this919.Intensity = Intensity;
      _this919.Orientation = Orientation;
      _this919.type = 2604431987;
      return _this919;
    }

    return IfcLightSourceDirectional;
  }(IfcLightSource);

  IFC4_32.IfcLightSourceDirectional = IfcLightSourceDirectional;

  var IfcLightSourceGoniometric = /*#__PURE__*/function (_IfcLightSource7) {
    _inherits(IfcLightSourceGoniometric, _IfcLightSource7);

    var _super928 = _createSuper(IfcLightSourceGoniometric);

    function IfcLightSourceGoniometric(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource) {
      var _this920;

      _classCallCheck2(this, IfcLightSourceGoniometric);

      _this920 = _super928.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this920.Name = Name;
      _this920.LightColour = LightColour;
      _this920.AmbientIntensity = AmbientIntensity;
      _this920.Intensity = Intensity;
      _this920.Position = Position;
      _this920.ColourAppearance = ColourAppearance;
      _this920.ColourTemperature = ColourTemperature;
      _this920.LuminousFlux = LuminousFlux;
      _this920.LightEmissionSource = LightEmissionSource;
      _this920.LightDistributionDataSource = LightDistributionDataSource;
      _this920.type = 4266656042;
      return _this920;
    }

    return IfcLightSourceGoniometric;
  }(IfcLightSource);

  IFC4_32.IfcLightSourceGoniometric = IfcLightSourceGoniometric;

  var IfcLightSourcePositional = /*#__PURE__*/function (_IfcLightSource8) {
    _inherits(IfcLightSourcePositional, _IfcLightSource8);

    var _super929 = _createSuper(IfcLightSourcePositional);

    function IfcLightSourcePositional(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation) {
      var _this921;

      _classCallCheck2(this, IfcLightSourcePositional);

      _this921 = _super929.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this921.Name = Name;
      _this921.LightColour = LightColour;
      _this921.AmbientIntensity = AmbientIntensity;
      _this921.Intensity = Intensity;
      _this921.Position = Position;
      _this921.Radius = Radius;
      _this921.ConstantAttenuation = ConstantAttenuation;
      _this921.DistanceAttenuation = DistanceAttenuation;
      _this921.QuadricAttenuation = QuadricAttenuation;
      _this921.type = 1520743889;
      return _this921;
    }

    return IfcLightSourcePositional;
  }(IfcLightSource);

  IFC4_32.IfcLightSourcePositional = IfcLightSourcePositional;

  var IfcLightSourceSpot = /*#__PURE__*/function (_IfcLightSourcePositi2) {
    _inherits(IfcLightSourceSpot, _IfcLightSourcePositi2);

    var _super930 = _createSuper(IfcLightSourceSpot);

    function IfcLightSourceSpot(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle) {
      var _this922;

      _classCallCheck2(this, IfcLightSourceSpot);

      _this922 = _super930.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
      _this922.Name = Name;
      _this922.LightColour = LightColour;
      _this922.AmbientIntensity = AmbientIntensity;
      _this922.Intensity = Intensity;
      _this922.Position = Position;
      _this922.Radius = Radius;
      _this922.ConstantAttenuation = ConstantAttenuation;
      _this922.DistanceAttenuation = DistanceAttenuation;
      _this922.QuadricAttenuation = QuadricAttenuation;
      _this922.Orientation = Orientation;
      _this922.ConcentrationExponent = ConcentrationExponent;
      _this922.SpreadAngle = SpreadAngle;
      _this922.BeamWidthAngle = BeamWidthAngle;
      _this922.type = 3422422726;
      return _this922;
    }

    return IfcLightSourceSpot;
  }(IfcLightSourcePositional);

  IFC4_32.IfcLightSourceSpot = IfcLightSourceSpot;

  var IfcLinearPlacement = /*#__PURE__*/function (_IfcObjectPlacement4) {
    _inherits(IfcLinearPlacement, _IfcObjectPlacement4);

    var _super931 = _createSuper(IfcLinearPlacement);

    function IfcLinearPlacement(expressID, PlacementRelTo, RelativePlacement, CartesianPosition) {
      var _this923;

      _classCallCheck2(this, IfcLinearPlacement);

      _this923 = _super931.call(this, expressID, PlacementRelTo);
      _this923.PlacementRelTo = PlacementRelTo;
      _this923.RelativePlacement = RelativePlacement;
      _this923.CartesianPosition = CartesianPosition;
      _this923.type = 388784114;
      return _this923;
    }

    return IfcLinearPlacement;
  }(IfcObjectPlacement);

  IFC4_32.IfcLinearPlacement = IfcLinearPlacement;

  var IfcLocalPlacement = /*#__PURE__*/function (_IfcObjectPlacement5) {
    _inherits(IfcLocalPlacement, _IfcObjectPlacement5);

    var _super932 = _createSuper(IfcLocalPlacement);

    function IfcLocalPlacement(expressID, PlacementRelTo, RelativePlacement) {
      var _this924;

      _classCallCheck2(this, IfcLocalPlacement);

      _this924 = _super932.call(this, expressID, PlacementRelTo);
      _this924.PlacementRelTo = PlacementRelTo;
      _this924.RelativePlacement = RelativePlacement;
      _this924.type = 2624227202;
      return _this924;
    }

    return IfcLocalPlacement;
  }(IfcObjectPlacement);

  IFC4_32.IfcLocalPlacement = IfcLocalPlacement;

  var IfcLoop = /*#__PURE__*/function (_IfcTopologicalRepres13) {
    _inherits(IfcLoop, _IfcTopologicalRepres13);

    var _super933 = _createSuper(IfcLoop);

    function IfcLoop(expressID) {
      var _this925;

      _classCallCheck2(this, IfcLoop);

      _this925 = _super933.call(this, expressID);
      _this925.type = 1008929658;
      return _this925;
    }

    return IfcLoop;
  }(IfcTopologicalRepresentationItem);

  IFC4_32.IfcLoop = IfcLoop;

  var IfcMappedItem = /*#__PURE__*/function (_IfcRepresentationIte8) {
    _inherits(IfcMappedItem, _IfcRepresentationIte8);

    var _super934 = _createSuper(IfcMappedItem);

    function IfcMappedItem(expressID, MappingSource, MappingTarget) {
      var _this926;

      _classCallCheck2(this, IfcMappedItem);

      _this926 = _super934.call(this, expressID);
      _this926.MappingSource = MappingSource;
      _this926.MappingTarget = MappingTarget;
      _this926.type = 2347385850;
      return _this926;
    }

    return IfcMappedItem;
  }(IfcRepresentationItem);

  IFC4_32.IfcMappedItem = IfcMappedItem;

  var IfcMaterial = /*#__PURE__*/function (_IfcMaterialDefinitio5) {
    _inherits(IfcMaterial, _IfcMaterialDefinitio5);

    var _super935 = _createSuper(IfcMaterial);

    function IfcMaterial(expressID, Name, Description, Category) {
      var _this927;

      _classCallCheck2(this, IfcMaterial);

      _this927 = _super935.call(this, expressID);
      _this927.Name = Name;
      _this927.Description = Description;
      _this927.Category = Category;
      _this927.type = 1838606355;
      return _this927;
    }

    return IfcMaterial;
  }(IfcMaterialDefinition);

  IFC4_32.IfcMaterial = IfcMaterial;

  var IfcMaterialConstituent = /*#__PURE__*/function (_IfcMaterialDefinitio6) {
    _inherits(IfcMaterialConstituent, _IfcMaterialDefinitio6);

    var _super936 = _createSuper(IfcMaterialConstituent);

    function IfcMaterialConstituent(expressID, Name, Description, Material, Fraction, Category) {
      var _this928;

      _classCallCheck2(this, IfcMaterialConstituent);

      _this928 = _super936.call(this, expressID);
      _this928.Name = Name;
      _this928.Description = Description;
      _this928.Material = Material;
      _this928.Fraction = Fraction;
      _this928.Category = Category;
      _this928.type = 3708119e3;
      return _this928;
    }

    return IfcMaterialConstituent;
  }(IfcMaterialDefinition);

  IFC4_32.IfcMaterialConstituent = IfcMaterialConstituent;

  var IfcMaterialConstituentSet = /*#__PURE__*/function (_IfcMaterialDefinitio7) {
    _inherits(IfcMaterialConstituentSet, _IfcMaterialDefinitio7);

    var _super937 = _createSuper(IfcMaterialConstituentSet);

    function IfcMaterialConstituentSet(expressID, Name, Description, MaterialConstituents) {
      var _this929;

      _classCallCheck2(this, IfcMaterialConstituentSet);

      _this929 = _super937.call(this, expressID);
      _this929.Name = Name;
      _this929.Description = Description;
      _this929.MaterialConstituents = MaterialConstituents;
      _this929.type = 2852063980;
      return _this929;
    }

    return IfcMaterialConstituentSet;
  }(IfcMaterialDefinition);

  IFC4_32.IfcMaterialConstituentSet = IfcMaterialConstituentSet;

  var IfcMaterialDefinitionRepresentation = /*#__PURE__*/function (_IfcProductRepresenta3) {
    _inherits(IfcMaterialDefinitionRepresentation, _IfcProductRepresenta3);

    var _super938 = _createSuper(IfcMaterialDefinitionRepresentation);

    function IfcMaterialDefinitionRepresentation(expressID, Name, Description, Representations, RepresentedMaterial) {
      var _this930;

      _classCallCheck2(this, IfcMaterialDefinitionRepresentation);

      _this930 = _super938.call(this, expressID, Name, Description, Representations);
      _this930.Name = Name;
      _this930.Description = Description;
      _this930.Representations = Representations;
      _this930.RepresentedMaterial = RepresentedMaterial;
      _this930.type = 2022407955;
      return _this930;
    }

    return IfcMaterialDefinitionRepresentation;
  }(IfcProductRepresentation);

  IFC4_32.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;

  var IfcMaterialLayerSetUsage = /*#__PURE__*/function (_IfcMaterialUsageDefi) {
    _inherits(IfcMaterialLayerSetUsage, _IfcMaterialUsageDefi);

    var _super939 = _createSuper(IfcMaterialLayerSetUsage);

    function IfcMaterialLayerSetUsage(expressID, ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine, ReferenceExtent) {
      var _this931;

      _classCallCheck2(this, IfcMaterialLayerSetUsage);

      _this931 = _super939.call(this, expressID);
      _this931.ForLayerSet = ForLayerSet;
      _this931.LayerSetDirection = LayerSetDirection;
      _this931.DirectionSense = DirectionSense;
      _this931.OffsetFromReferenceLine = OffsetFromReferenceLine;
      _this931.ReferenceExtent = ReferenceExtent;
      _this931.type = 1303795690;
      return _this931;
    }

    return IfcMaterialLayerSetUsage;
  }(IfcMaterialUsageDefinition);

  IFC4_32.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;

  var IfcMaterialProfileSetUsage = /*#__PURE__*/function (_IfcMaterialUsageDefi2) {
    _inherits(IfcMaterialProfileSetUsage, _IfcMaterialUsageDefi2);

    var _super940 = _createSuper(IfcMaterialProfileSetUsage);

    function IfcMaterialProfileSetUsage(expressID, ForProfileSet, CardinalPoint, ReferenceExtent) {
      var _this932;

      _classCallCheck2(this, IfcMaterialProfileSetUsage);

      _this932 = _super940.call(this, expressID);
      _this932.ForProfileSet = ForProfileSet;
      _this932.CardinalPoint = CardinalPoint;
      _this932.ReferenceExtent = ReferenceExtent;
      _this932.type = 3079605661;
      return _this932;
    }

    return IfcMaterialProfileSetUsage;
  }(IfcMaterialUsageDefinition);

  IFC4_32.IfcMaterialProfileSetUsage = IfcMaterialProfileSetUsage;

  var IfcMaterialProfileSetUsageTapering = /*#__PURE__*/function (_IfcMaterialProfileSe) {
    _inherits(IfcMaterialProfileSetUsageTapering, _IfcMaterialProfileSe);

    var _super941 = _createSuper(IfcMaterialProfileSetUsageTapering);

    function IfcMaterialProfileSetUsageTapering(expressID, ForProfileSet, CardinalPoint, ReferenceExtent, ForProfileEndSet, CardinalEndPoint) {
      var _this933;

      _classCallCheck2(this, IfcMaterialProfileSetUsageTapering);

      _this933 = _super941.call(this, expressID, ForProfileSet, CardinalPoint, ReferenceExtent);
      _this933.ForProfileSet = ForProfileSet;
      _this933.CardinalPoint = CardinalPoint;
      _this933.ReferenceExtent = ReferenceExtent;
      _this933.ForProfileEndSet = ForProfileEndSet;
      _this933.CardinalEndPoint = CardinalEndPoint;
      _this933.type = 3404854881;
      return _this933;
    }

    return IfcMaterialProfileSetUsageTapering;
  }(IfcMaterialProfileSetUsage);

  IFC4_32.IfcMaterialProfileSetUsageTapering = IfcMaterialProfileSetUsageTapering;

  var IfcMaterialProperties = /*#__PURE__*/function (_IfcExtendedPropertie) {
    _inherits(IfcMaterialProperties, _IfcExtendedPropertie);

    var _super942 = _createSuper(IfcMaterialProperties);

    function IfcMaterialProperties(expressID, Name, Description, Properties2, Material) {
      var _this934;

      _classCallCheck2(this, IfcMaterialProperties);

      _this934 = _super942.call(this, expressID, Name, Description, Properties2);
      _this934.Name = Name;
      _this934.Description = Description;
      _this934.Properties = Properties2;
      _this934.Material = Material;
      _this934.type = 3265635763;
      return _this934;
    }

    return IfcMaterialProperties;
  }(IfcExtendedProperties);

  IFC4_32.IfcMaterialProperties = IfcMaterialProperties;

  var IfcMaterialRelationship = /*#__PURE__*/function (_IfcResourceLevelRela5) {
    _inherits(IfcMaterialRelationship, _IfcResourceLevelRela5);

    var _super943 = _createSuper(IfcMaterialRelationship);

    function IfcMaterialRelationship(expressID, Name, Description, RelatingMaterial, RelatedMaterials, MaterialExpression) {
      var _this935;

      _classCallCheck2(this, IfcMaterialRelationship);

      _this935 = _super943.call(this, expressID, Name, Description);
      _this935.Name = Name;
      _this935.Description = Description;
      _this935.RelatingMaterial = RelatingMaterial;
      _this935.RelatedMaterials = RelatedMaterials;
      _this935.MaterialExpression = MaterialExpression;
      _this935.type = 853536259;
      return _this935;
    }

    return IfcMaterialRelationship;
  }(IfcResourceLevelRelationship);

  IFC4_32.IfcMaterialRelationship = IfcMaterialRelationship;

  var IfcMirroredProfileDef = /*#__PURE__*/function (_IfcDerivedProfileDef) {
    _inherits(IfcMirroredProfileDef, _IfcDerivedProfileDef);

    var _super944 = _createSuper(IfcMirroredProfileDef);

    function IfcMirroredProfileDef(expressID, ProfileType, ProfileName, ParentProfile, Operator, Label) {
      var _this936;

      _classCallCheck2(this, IfcMirroredProfileDef);

      _this936 = _super944.call(this, expressID, ProfileType, ProfileName, ParentProfile, Operator, Label);
      _this936.ProfileType = ProfileType;
      _this936.ProfileName = ProfileName;
      _this936.ParentProfile = ParentProfile;
      _this936.Operator = Operator;
      _this936.Label = Label;
      _this936.type = 2998442950;
      return _this936;
    }

    return IfcMirroredProfileDef;
  }(IfcDerivedProfileDef);

  IFC4_32.IfcMirroredProfileDef = IfcMirroredProfileDef;

  var IfcObjectDefinition = /*#__PURE__*/function (_IfcRoot4) {
    _inherits(IfcObjectDefinition, _IfcRoot4);

    var _super945 = _createSuper(IfcObjectDefinition);

    function IfcObjectDefinition(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this937;

      _classCallCheck2(this, IfcObjectDefinition);

      _this937 = _super945.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this937.GlobalId = GlobalId;
      _this937.OwnerHistory = OwnerHistory;
      _this937.Name = Name;
      _this937.Description = Description;
      _this937.type = 219451334;
      return _this937;
    }

    return IfcObjectDefinition;
  }(IfcRoot);

  IFC4_32.IfcObjectDefinition = IfcObjectDefinition;

  var IfcOpenCrossProfileDef = /*#__PURE__*/function (_IfcProfileDef10) {
    _inherits(IfcOpenCrossProfileDef, _IfcProfileDef10);

    var _super946 = _createSuper(IfcOpenCrossProfileDef);

    function IfcOpenCrossProfileDef(expressID, ProfileType, ProfileName, HorizontalWidths, Widths, Slopes, Tags, OffsetPoint) {
      var _this938;

      _classCallCheck2(this, IfcOpenCrossProfileDef);

      _this938 = _super946.call(this, expressID, ProfileType, ProfileName);
      _this938.ProfileType = ProfileType;
      _this938.ProfileName = ProfileName;
      _this938.HorizontalWidths = HorizontalWidths;
      _this938.Widths = Widths;
      _this938.Slopes = Slopes;
      _this938.Tags = Tags;
      _this938.OffsetPoint = OffsetPoint;
      _this938.type = 182550632;
      return _this938;
    }

    return IfcOpenCrossProfileDef;
  }(IfcProfileDef);

  IFC4_32.IfcOpenCrossProfileDef = IfcOpenCrossProfileDef;

  var IfcOpenShell = /*#__PURE__*/function (_IfcConnectedFaceSet3) {
    _inherits(IfcOpenShell, _IfcConnectedFaceSet3);

    var _super947 = _createSuper(IfcOpenShell);

    function IfcOpenShell(expressID, CfsFaces) {
      var _this939;

      _classCallCheck2(this, IfcOpenShell);

      _this939 = _super947.call(this, expressID, CfsFaces);
      _this939.CfsFaces = CfsFaces;
      _this939.type = 2665983363;
      return _this939;
    }

    return IfcOpenShell;
  }(IfcConnectedFaceSet);

  IFC4_32.IfcOpenShell = IfcOpenShell;

  var IfcOrganizationRelationship = /*#__PURE__*/function (_IfcResourceLevelRela6) {
    _inherits(IfcOrganizationRelationship, _IfcResourceLevelRela6);

    var _super948 = _createSuper(IfcOrganizationRelationship);

    function IfcOrganizationRelationship(expressID, Name, Description, RelatingOrganization, RelatedOrganizations) {
      var _this940;

      _classCallCheck2(this, IfcOrganizationRelationship);

      _this940 = _super948.call(this, expressID, Name, Description);
      _this940.Name = Name;
      _this940.Description = Description;
      _this940.RelatingOrganization = RelatingOrganization;
      _this940.RelatedOrganizations = RelatedOrganizations;
      _this940.type = 1411181986;
      return _this940;
    }

    return IfcOrganizationRelationship;
  }(IfcResourceLevelRelationship);

  IFC4_32.IfcOrganizationRelationship = IfcOrganizationRelationship;

  var IfcOrientedEdge = /*#__PURE__*/function (_IfcEdge5) {
    _inherits(IfcOrientedEdge, _IfcEdge5);

    var _super949 = _createSuper(IfcOrientedEdge);

    function IfcOrientedEdge(expressID, EdgeStart, EdgeElement, Orientation) {
      var _this941;

      _classCallCheck2(this, IfcOrientedEdge);

      _this941 = _super949.call(this, expressID, EdgeStart, new Handle(0));
      _this941.EdgeStart = EdgeStart;
      _this941.EdgeElement = EdgeElement;
      _this941.Orientation = Orientation;
      _this941.type = 1029017970;
      return _this941;
    }

    return IfcOrientedEdge;
  }(IfcEdge);

  IFC4_32.IfcOrientedEdge = IfcOrientedEdge;

  var IfcParameterizedProfileDef = /*#__PURE__*/function (_IfcProfileDef11) {
    _inherits(IfcParameterizedProfileDef, _IfcProfileDef11);

    var _super950 = _createSuper(IfcParameterizedProfileDef);

    function IfcParameterizedProfileDef(expressID, ProfileType, ProfileName, Position) {
      var _this942;

      _classCallCheck2(this, IfcParameterizedProfileDef);

      _this942 = _super950.call(this, expressID, ProfileType, ProfileName);
      _this942.ProfileType = ProfileType;
      _this942.ProfileName = ProfileName;
      _this942.Position = Position;
      _this942.type = 2529465313;
      return _this942;
    }

    return IfcParameterizedProfileDef;
  }(IfcProfileDef);

  IFC4_32.IfcParameterizedProfileDef = IfcParameterizedProfileDef;

  var IfcPath = /*#__PURE__*/function (_IfcTopologicalRepres14) {
    _inherits(IfcPath, _IfcTopologicalRepres14);

    var _super951 = _createSuper(IfcPath);

    function IfcPath(expressID, EdgeList) {
      var _this943;

      _classCallCheck2(this, IfcPath);

      _this943 = _super951.call(this, expressID);
      _this943.EdgeList = EdgeList;
      _this943.type = 2519244187;
      return _this943;
    }

    return IfcPath;
  }(IfcTopologicalRepresentationItem);

  IFC4_32.IfcPath = IfcPath;

  var IfcPhysicalComplexQuantity = /*#__PURE__*/function (_IfcPhysicalQuantity4) {
    _inherits(IfcPhysicalComplexQuantity, _IfcPhysicalQuantity4);

    var _super952 = _createSuper(IfcPhysicalComplexQuantity);

    function IfcPhysicalComplexQuantity(expressID, Name, Description, HasQuantities, Discrimination, Quality, Usage) {
      var _this944;

      _classCallCheck2(this, IfcPhysicalComplexQuantity);

      _this944 = _super952.call(this, expressID, Name, Description);
      _this944.Name = Name;
      _this944.Description = Description;
      _this944.HasQuantities = HasQuantities;
      _this944.Discrimination = Discrimination;
      _this944.Quality = Quality;
      _this944.Usage = Usage;
      _this944.type = 3021840470;
      return _this944;
    }

    return IfcPhysicalComplexQuantity;
  }(IfcPhysicalQuantity);

  IFC4_32.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;

  var IfcPixelTexture = /*#__PURE__*/function (_IfcSurfaceTexture6) {
    _inherits(IfcPixelTexture, _IfcSurfaceTexture6);

    var _super953 = _createSuper(IfcPixelTexture);

    function IfcPixelTexture(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, Width, Height, ColourComponents, Pixel) {
      var _this945;

      _classCallCheck2(this, IfcPixelTexture);

      _this945 = _super953.call(this, expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      _this945.RepeatS = RepeatS;
      _this945.RepeatT = RepeatT;
      _this945.Mode = Mode;
      _this945.TextureTransform = TextureTransform;
      _this945.Parameter = Parameter;
      _this945.Width = Width;
      _this945.Height = Height;
      _this945.ColourComponents = ColourComponents;
      _this945.Pixel = Pixel;
      _this945.type = 597895409;
      return _this945;
    }

    return IfcPixelTexture;
  }(IfcSurfaceTexture);

  IFC4_32.IfcPixelTexture = IfcPixelTexture;

  var IfcPlacement = /*#__PURE__*/function (_IfcGeometricRepresen34) {
    _inherits(IfcPlacement, _IfcGeometricRepresen34);

    var _super954 = _createSuper(IfcPlacement);

    function IfcPlacement(expressID, Location) {
      var _this946;

      _classCallCheck2(this, IfcPlacement);

      _this946 = _super954.call(this, expressID);
      _this946.Location = Location;
      _this946.type = 2004835150;
      return _this946;
    }

    return IfcPlacement;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcPlacement = IfcPlacement;

  var IfcPlanarExtent = /*#__PURE__*/function (_IfcGeometricRepresen35) {
    _inherits(IfcPlanarExtent, _IfcGeometricRepresen35);

    var _super955 = _createSuper(IfcPlanarExtent);

    function IfcPlanarExtent(expressID, SizeInX, SizeInY) {
      var _this947;

      _classCallCheck2(this, IfcPlanarExtent);

      _this947 = _super955.call(this, expressID);
      _this947.SizeInX = SizeInX;
      _this947.SizeInY = SizeInY;
      _this947.type = 1663979128;
      return _this947;
    }

    return IfcPlanarExtent;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcPlanarExtent = IfcPlanarExtent;

  var IfcPoint = /*#__PURE__*/function (_IfcGeometricRepresen36) {
    _inherits(IfcPoint, _IfcGeometricRepresen36);

    var _super956 = _createSuper(IfcPoint);

    function IfcPoint(expressID) {
      var _this948;

      _classCallCheck2(this, IfcPoint);

      _this948 = _super956.call(this, expressID);
      _this948.type = 2067069095;
      return _this948;
    }

    return IfcPoint;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcPoint = IfcPoint;

  var IfcPointByDistanceExpression = /*#__PURE__*/function (_IfcPoint4) {
    _inherits(IfcPointByDistanceExpression, _IfcPoint4);

    var _super957 = _createSuper(IfcPointByDistanceExpression);

    function IfcPointByDistanceExpression(expressID, DistanceAlong, OffsetLateral, OffsetVertical, OffsetLongitudinal, BasisCurve) {
      var _this949;

      _classCallCheck2(this, IfcPointByDistanceExpression);

      _this949 = _super957.call(this, expressID);
      _this949.DistanceAlong = DistanceAlong;
      _this949.OffsetLateral = OffsetLateral;
      _this949.OffsetVertical = OffsetVertical;
      _this949.OffsetLongitudinal = OffsetLongitudinal;
      _this949.BasisCurve = BasisCurve;
      _this949.type = 2165702409;
      return _this949;
    }

    return IfcPointByDistanceExpression;
  }(IfcPoint);

  IFC4_32.IfcPointByDistanceExpression = IfcPointByDistanceExpression;

  var IfcPointOnCurve = /*#__PURE__*/function (_IfcPoint5) {
    _inherits(IfcPointOnCurve, _IfcPoint5);

    var _super958 = _createSuper(IfcPointOnCurve);

    function IfcPointOnCurve(expressID, BasisCurve, PointParameter) {
      var _this950;

      _classCallCheck2(this, IfcPointOnCurve);

      _this950 = _super958.call(this, expressID);
      _this950.BasisCurve = BasisCurve;
      _this950.PointParameter = PointParameter;
      _this950.type = 4022376103;
      return _this950;
    }

    return IfcPointOnCurve;
  }(IfcPoint);

  IFC4_32.IfcPointOnCurve = IfcPointOnCurve;

  var IfcPointOnSurface = /*#__PURE__*/function (_IfcPoint6) {
    _inherits(IfcPointOnSurface, _IfcPoint6);

    var _super959 = _createSuper(IfcPointOnSurface);

    function IfcPointOnSurface(expressID, BasisSurface, PointParameterU, PointParameterV) {
      var _this951;

      _classCallCheck2(this, IfcPointOnSurface);

      _this951 = _super959.call(this, expressID);
      _this951.BasisSurface = BasisSurface;
      _this951.PointParameterU = PointParameterU;
      _this951.PointParameterV = PointParameterV;
      _this951.type = 1423911732;
      return _this951;
    }

    return IfcPointOnSurface;
  }(IfcPoint);

  IFC4_32.IfcPointOnSurface = IfcPointOnSurface;

  var IfcPolyLoop = /*#__PURE__*/function (_IfcLoop4) {
    _inherits(IfcPolyLoop, _IfcLoop4);

    var _super960 = _createSuper(IfcPolyLoop);

    function IfcPolyLoop(expressID, Polygon) {
      var _this952;

      _classCallCheck2(this, IfcPolyLoop);

      _this952 = _super960.call(this, expressID);
      _this952.Polygon = Polygon;
      _this952.type = 2924175390;
      return _this952;
    }

    return IfcPolyLoop;
  }(IfcLoop);

  IFC4_32.IfcPolyLoop = IfcPolyLoop;

  var IfcPolygonalBoundedHalfSpace = /*#__PURE__*/function (_IfcHalfSpaceSolid3) {
    _inherits(IfcPolygonalBoundedHalfSpace, _IfcHalfSpaceSolid3);

    var _super961 = _createSuper(IfcPolygonalBoundedHalfSpace);

    function IfcPolygonalBoundedHalfSpace(expressID, BaseSurface, AgreementFlag, Position, PolygonalBoundary) {
      var _this953;

      _classCallCheck2(this, IfcPolygonalBoundedHalfSpace);

      _this953 = _super961.call(this, expressID, BaseSurface, AgreementFlag);
      _this953.BaseSurface = BaseSurface;
      _this953.AgreementFlag = AgreementFlag;
      _this953.Position = Position;
      _this953.PolygonalBoundary = PolygonalBoundary;
      _this953.type = 2775532180;
      return _this953;
    }

    return IfcPolygonalBoundedHalfSpace;
  }(IfcHalfSpaceSolid);

  IFC4_32.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;

  var IfcPreDefinedItem = /*#__PURE__*/function (_IfcPresentationItem17) {
    _inherits(IfcPreDefinedItem, _IfcPresentationItem17);

    var _super962 = _createSuper(IfcPreDefinedItem);

    function IfcPreDefinedItem(expressID, Name) {
      var _this954;

      _classCallCheck2(this, IfcPreDefinedItem);

      _this954 = _super962.call(this, expressID);
      _this954.Name = Name;
      _this954.type = 3727388367;
      return _this954;
    }

    return IfcPreDefinedItem;
  }(IfcPresentationItem);

  IFC4_32.IfcPreDefinedItem = IfcPreDefinedItem;

  var IfcPreDefinedProperties = /*#__PURE__*/function (_IfcPropertyAbstracti3) {
    _inherits(IfcPreDefinedProperties, _IfcPropertyAbstracti3);

    var _super963 = _createSuper(IfcPreDefinedProperties);

    function IfcPreDefinedProperties(expressID) {
      var _this955;

      _classCallCheck2(this, IfcPreDefinedProperties);

      _this955 = _super963.call(this, expressID);
      _this955.type = 3778827333;
      return _this955;
    }

    return IfcPreDefinedProperties;
  }(IfcPropertyAbstraction);

  IFC4_32.IfcPreDefinedProperties = IfcPreDefinedProperties;

  var IfcPreDefinedTextFont = /*#__PURE__*/function (_IfcPreDefinedItem5) {
    _inherits(IfcPreDefinedTextFont, _IfcPreDefinedItem5);

    var _super964 = _createSuper(IfcPreDefinedTextFont);

    function IfcPreDefinedTextFont(expressID, Name) {
      var _this956;

      _classCallCheck2(this, IfcPreDefinedTextFont);

      _this956 = _super964.call(this, expressID, Name);
      _this956.Name = Name;
      _this956.type = 1775413392;
      return _this956;
    }

    return IfcPreDefinedTextFont;
  }(IfcPreDefinedItem);

  IFC4_32.IfcPreDefinedTextFont = IfcPreDefinedTextFont;

  var IfcProductDefinitionShape = /*#__PURE__*/function (_IfcProductRepresenta4) {
    _inherits(IfcProductDefinitionShape, _IfcProductRepresenta4);

    var _super965 = _createSuper(IfcProductDefinitionShape);

    function IfcProductDefinitionShape(expressID, Name, Description, Representations) {
      var _this957;

      _classCallCheck2(this, IfcProductDefinitionShape);

      _this957 = _super965.call(this, expressID, Name, Description, Representations);
      _this957.Name = Name;
      _this957.Description = Description;
      _this957.Representations = Representations;
      _this957.type = 673634403;
      return _this957;
    }

    return IfcProductDefinitionShape;
  }(IfcProductRepresentation);

  IFC4_32.IfcProductDefinitionShape = IfcProductDefinitionShape;

  var IfcProfileProperties = /*#__PURE__*/function (_IfcExtendedPropertie2) {
    _inherits(IfcProfileProperties, _IfcExtendedPropertie2);

    var _super966 = _createSuper(IfcProfileProperties);

    function IfcProfileProperties(expressID, Name, Description, Properties2, ProfileDefinition) {
      var _this958;

      _classCallCheck2(this, IfcProfileProperties);

      _this958 = _super966.call(this, expressID, Name, Description, Properties2);
      _this958.Name = Name;
      _this958.Description = Description;
      _this958.Properties = Properties2;
      _this958.ProfileDefinition = ProfileDefinition;
      _this958.type = 2802850158;
      return _this958;
    }

    return IfcProfileProperties;
  }(IfcExtendedProperties);

  IFC4_32.IfcProfileProperties = IfcProfileProperties;

  var IfcProperty = /*#__PURE__*/function (_IfcPropertyAbstracti4) {
    _inherits(IfcProperty, _IfcPropertyAbstracti4);

    var _super967 = _createSuper(IfcProperty);

    function IfcProperty(expressID, Name, Specification) {
      var _this959;

      _classCallCheck2(this, IfcProperty);

      _this959 = _super967.call(this, expressID);
      _this959.Name = Name;
      _this959.Specification = Specification;
      _this959.type = 2598011224;
      return _this959;
    }

    return IfcProperty;
  }(IfcPropertyAbstraction);

  IFC4_32.IfcProperty = IfcProperty;

  var IfcPropertyDefinition = /*#__PURE__*/function (_IfcRoot5) {
    _inherits(IfcPropertyDefinition, _IfcRoot5);

    var _super968 = _createSuper(IfcPropertyDefinition);

    function IfcPropertyDefinition(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this960;

      _classCallCheck2(this, IfcPropertyDefinition);

      _this960 = _super968.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this960.GlobalId = GlobalId;
      _this960.OwnerHistory = OwnerHistory;
      _this960.Name = Name;
      _this960.Description = Description;
      _this960.type = 1680319473;
      return _this960;
    }

    return IfcPropertyDefinition;
  }(IfcRoot);

  IFC4_32.IfcPropertyDefinition = IfcPropertyDefinition;

  var IfcPropertyDependencyRelationship = /*#__PURE__*/function (_IfcResourceLevelRela7) {
    _inherits(IfcPropertyDependencyRelationship, _IfcResourceLevelRela7);

    var _super969 = _createSuper(IfcPropertyDependencyRelationship);

    function IfcPropertyDependencyRelationship(expressID, Name, Description, DependingProperty, DependantProperty, Expression) {
      var _this961;

      _classCallCheck2(this, IfcPropertyDependencyRelationship);

      _this961 = _super969.call(this, expressID, Name, Description);
      _this961.Name = Name;
      _this961.Description = Description;
      _this961.DependingProperty = DependingProperty;
      _this961.DependantProperty = DependantProperty;
      _this961.Expression = Expression;
      _this961.type = 148025276;
      return _this961;
    }

    return IfcPropertyDependencyRelationship;
  }(IfcResourceLevelRelationship);

  IFC4_32.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;

  var IfcPropertySetDefinition = /*#__PURE__*/function (_IfcPropertyDefinitio2) {
    _inherits(IfcPropertySetDefinition, _IfcPropertyDefinitio2);

    var _super970 = _createSuper(IfcPropertySetDefinition);

    function IfcPropertySetDefinition(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this962;

      _classCallCheck2(this, IfcPropertySetDefinition);

      _this962 = _super970.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this962.GlobalId = GlobalId;
      _this962.OwnerHistory = OwnerHistory;
      _this962.Name = Name;
      _this962.Description = Description;
      _this962.type = 3357820518;
      return _this962;
    }

    return IfcPropertySetDefinition;
  }(IfcPropertyDefinition);

  IFC4_32.IfcPropertySetDefinition = IfcPropertySetDefinition;

  var IfcPropertyTemplateDefinition = /*#__PURE__*/function (_IfcPropertyDefinitio3) {
    _inherits(IfcPropertyTemplateDefinition, _IfcPropertyDefinitio3);

    var _super971 = _createSuper(IfcPropertyTemplateDefinition);

    function IfcPropertyTemplateDefinition(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this963;

      _classCallCheck2(this, IfcPropertyTemplateDefinition);

      _this963 = _super971.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this963.GlobalId = GlobalId;
      _this963.OwnerHistory = OwnerHistory;
      _this963.Name = Name;
      _this963.Description = Description;
      _this963.type = 1482703590;
      return _this963;
    }

    return IfcPropertyTemplateDefinition;
  }(IfcPropertyDefinition);

  IFC4_32.IfcPropertyTemplateDefinition = IfcPropertyTemplateDefinition;

  var IfcQuantitySet = /*#__PURE__*/function (_IfcPropertySetDefini15) {
    _inherits(IfcQuantitySet, _IfcPropertySetDefini15);

    var _super972 = _createSuper(IfcQuantitySet);

    function IfcQuantitySet(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this964;

      _classCallCheck2(this, IfcQuantitySet);

      _this964 = _super972.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this964.GlobalId = GlobalId;
      _this964.OwnerHistory = OwnerHistory;
      _this964.Name = Name;
      _this964.Description = Description;
      _this964.type = 2090586900;
      return _this964;
    }

    return IfcQuantitySet;
  }(IfcPropertySetDefinition);

  IFC4_32.IfcQuantitySet = IfcQuantitySet;

  var IfcRectangleProfileDef = /*#__PURE__*/function (_IfcParameterizedProf13) {
    _inherits(IfcRectangleProfileDef, _IfcParameterizedProf13);

    var _super973 = _createSuper(IfcRectangleProfileDef);

    function IfcRectangleProfileDef(expressID, ProfileType, ProfileName, Position, XDim, YDim) {
      var _this965;

      _classCallCheck2(this, IfcRectangleProfileDef);

      _this965 = _super973.call(this, expressID, ProfileType, ProfileName, Position);
      _this965.ProfileType = ProfileType;
      _this965.ProfileName = ProfileName;
      _this965.Position = Position;
      _this965.XDim = XDim;
      _this965.YDim = YDim;
      _this965.type = 3615266464;
      return _this965;
    }

    return IfcRectangleProfileDef;
  }(IfcParameterizedProfileDef);

  IFC4_32.IfcRectangleProfileDef = IfcRectangleProfileDef;

  var IfcRegularTimeSeries = /*#__PURE__*/function (_IfcTimeSeries4) {
    _inherits(IfcRegularTimeSeries, _IfcTimeSeries4);

    var _super974 = _createSuper(IfcRegularTimeSeries);

    function IfcRegularTimeSeries(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values) {
      var _this966;

      _classCallCheck2(this, IfcRegularTimeSeries);

      _this966 = _super974.call(this, expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      _this966.Name = Name;
      _this966.Description = Description;
      _this966.StartTime = StartTime;
      _this966.EndTime = EndTime;
      _this966.TimeSeriesDataType = TimeSeriesDataType;
      _this966.DataOrigin = DataOrigin;
      _this966.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this966.Unit = Unit;
      _this966.TimeStep = TimeStep;
      _this966.Values = Values;
      _this966.type = 3413951693;
      return _this966;
    }

    return IfcRegularTimeSeries;
  }(IfcTimeSeries);

  IFC4_32.IfcRegularTimeSeries = IfcRegularTimeSeries;

  var IfcReinforcementBarProperties = /*#__PURE__*/function (_IfcPreDefinedPropert) {
    _inherits(IfcReinforcementBarProperties, _IfcPreDefinedPropert);

    var _super975 = _createSuper(IfcReinforcementBarProperties);

    function IfcReinforcementBarProperties(expressID, TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount) {
      var _this967;

      _classCallCheck2(this, IfcReinforcementBarProperties);

      _this967 = _super975.call(this, expressID);
      _this967.TotalCrossSectionArea = TotalCrossSectionArea;
      _this967.SteelGrade = SteelGrade;
      _this967.BarSurface = BarSurface;
      _this967.EffectiveDepth = EffectiveDepth;
      _this967.NominalBarDiameter = NominalBarDiameter;
      _this967.BarCount = BarCount;
      _this967.type = 1580146022;
      return _this967;
    }

    return IfcReinforcementBarProperties;
  }(IfcPreDefinedProperties);

  IFC4_32.IfcReinforcementBarProperties = IfcReinforcementBarProperties;

  var IfcRelationship = /*#__PURE__*/function (_IfcRoot6) {
    _inherits(IfcRelationship, _IfcRoot6);

    var _super976 = _createSuper(IfcRelationship);

    function IfcRelationship(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this968;

      _classCallCheck2(this, IfcRelationship);

      _this968 = _super976.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this968.GlobalId = GlobalId;
      _this968.OwnerHistory = OwnerHistory;
      _this968.Name = Name;
      _this968.Description = Description;
      _this968.type = 478536968;
      return _this968;
    }

    return IfcRelationship;
  }(IfcRoot);

  IFC4_32.IfcRelationship = IfcRelationship;

  var IfcResourceApprovalRelationship = /*#__PURE__*/function (_IfcResourceLevelRela8) {
    _inherits(IfcResourceApprovalRelationship, _IfcResourceLevelRela8);

    var _super977 = _createSuper(IfcResourceApprovalRelationship);

    function IfcResourceApprovalRelationship(expressID, Name, Description, RelatedResourceObjects, RelatingApproval) {
      var _this969;

      _classCallCheck2(this, IfcResourceApprovalRelationship);

      _this969 = _super977.call(this, expressID, Name, Description);
      _this969.Name = Name;
      _this969.Description = Description;
      _this969.RelatedResourceObjects = RelatedResourceObjects;
      _this969.RelatingApproval = RelatingApproval;
      _this969.type = 2943643501;
      return _this969;
    }

    return IfcResourceApprovalRelationship;
  }(IfcResourceLevelRelationship);

  IFC4_32.IfcResourceApprovalRelationship = IfcResourceApprovalRelationship;

  var IfcResourceConstraintRelationship = /*#__PURE__*/function (_IfcResourceLevelRela9) {
    _inherits(IfcResourceConstraintRelationship, _IfcResourceLevelRela9);

    var _super978 = _createSuper(IfcResourceConstraintRelationship);

    function IfcResourceConstraintRelationship(expressID, Name, Description, RelatingConstraint, RelatedResourceObjects) {
      var _this970;

      _classCallCheck2(this, IfcResourceConstraintRelationship);

      _this970 = _super978.call(this, expressID, Name, Description);
      _this970.Name = Name;
      _this970.Description = Description;
      _this970.RelatingConstraint = RelatingConstraint;
      _this970.RelatedResourceObjects = RelatedResourceObjects;
      _this970.type = 1608871552;
      return _this970;
    }

    return IfcResourceConstraintRelationship;
  }(IfcResourceLevelRelationship);

  IFC4_32.IfcResourceConstraintRelationship = IfcResourceConstraintRelationship;

  var IfcResourceTime = /*#__PURE__*/function (_IfcSchedulingTime5) {
    _inherits(IfcResourceTime, _IfcSchedulingTime5);

    var _super979 = _createSuper(IfcResourceTime);

    function IfcResourceTime(expressID, Name, DataOrigin, UserDefinedDataOrigin, ScheduleWork, ScheduleUsage, ScheduleStart, ScheduleFinish, ScheduleContour, LevelingDelay, IsOverAllocated, StatusTime, ActualWork, ActualUsage, ActualStart, ActualFinish, RemainingWork, RemainingUsage, Completion) {
      var _this971;

      _classCallCheck2(this, IfcResourceTime);

      _this971 = _super979.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin);
      _this971.Name = Name;
      _this971.DataOrigin = DataOrigin;
      _this971.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this971.ScheduleWork = ScheduleWork;
      _this971.ScheduleUsage = ScheduleUsage;
      _this971.ScheduleStart = ScheduleStart;
      _this971.ScheduleFinish = ScheduleFinish;
      _this971.ScheduleContour = ScheduleContour;
      _this971.LevelingDelay = LevelingDelay;
      _this971.IsOverAllocated = IsOverAllocated;
      _this971.StatusTime = StatusTime;
      _this971.ActualWork = ActualWork;
      _this971.ActualUsage = ActualUsage;
      _this971.ActualStart = ActualStart;
      _this971.ActualFinish = ActualFinish;
      _this971.RemainingWork = RemainingWork;
      _this971.RemainingUsage = RemainingUsage;
      _this971.Completion = Completion;
      _this971.type = 1042787934;
      return _this971;
    }

    return IfcResourceTime;
  }(IfcSchedulingTime);

  IFC4_32.IfcResourceTime = IfcResourceTime;

  var IfcRoundedRectangleProfileDef = /*#__PURE__*/function (_IfcRectangleProfileD3) {
    _inherits(IfcRoundedRectangleProfileDef, _IfcRectangleProfileD3);

    var _super980 = _createSuper(IfcRoundedRectangleProfileDef);

    function IfcRoundedRectangleProfileDef(expressID, ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius) {
      var _this972;

      _classCallCheck2(this, IfcRoundedRectangleProfileDef);

      _this972 = _super980.call(this, expressID, ProfileType, ProfileName, Position, XDim, YDim);
      _this972.ProfileType = ProfileType;
      _this972.ProfileName = ProfileName;
      _this972.Position = Position;
      _this972.XDim = XDim;
      _this972.YDim = YDim;
      _this972.RoundingRadius = RoundingRadius;
      _this972.type = 2778083089;
      return _this972;
    }

    return IfcRoundedRectangleProfileDef;
  }(IfcRectangleProfileDef);

  IFC4_32.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;

  var IfcSectionProperties = /*#__PURE__*/function (_IfcPreDefinedPropert2) {
    _inherits(IfcSectionProperties, _IfcPreDefinedPropert2);

    var _super981 = _createSuper(IfcSectionProperties);

    function IfcSectionProperties(expressID, SectionType, StartProfile, EndProfile) {
      var _this973;

      _classCallCheck2(this, IfcSectionProperties);

      _this973 = _super981.call(this, expressID);
      _this973.SectionType = SectionType;
      _this973.StartProfile = StartProfile;
      _this973.EndProfile = EndProfile;
      _this973.type = 2042790032;
      return _this973;
    }

    return IfcSectionProperties;
  }(IfcPreDefinedProperties);

  IFC4_32.IfcSectionProperties = IfcSectionProperties;

  var IfcSectionReinforcementProperties = /*#__PURE__*/function (_IfcPreDefinedPropert3) {
    _inherits(IfcSectionReinforcementProperties, _IfcPreDefinedPropert3);

    var _super982 = _createSuper(IfcSectionReinforcementProperties);

    function IfcSectionReinforcementProperties(expressID, LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions) {
      var _this974;

      _classCallCheck2(this, IfcSectionReinforcementProperties);

      _this974 = _super982.call(this, expressID);
      _this974.LongitudinalStartPosition = LongitudinalStartPosition;
      _this974.LongitudinalEndPosition = LongitudinalEndPosition;
      _this974.TransversePosition = TransversePosition;
      _this974.ReinforcementRole = ReinforcementRole;
      _this974.SectionDefinition = SectionDefinition;
      _this974.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
      _this974.type = 4165799628;
      return _this974;
    }

    return IfcSectionReinforcementProperties;
  }(IfcPreDefinedProperties);

  IFC4_32.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;

  var IfcSectionedSpine = /*#__PURE__*/function (_IfcGeometricRepresen37) {
    _inherits(IfcSectionedSpine, _IfcGeometricRepresen37);

    var _super983 = _createSuper(IfcSectionedSpine);

    function IfcSectionedSpine(expressID, SpineCurve, CrossSections, CrossSectionPositions) {
      var _this975;

      _classCallCheck2(this, IfcSectionedSpine);

      _this975 = _super983.call(this, expressID);
      _this975.SpineCurve = SpineCurve;
      _this975.CrossSections = CrossSections;
      _this975.CrossSectionPositions = CrossSectionPositions;
      _this975.type = 1509187699;
      return _this975;
    }

    return IfcSectionedSpine;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcSectionedSpine = IfcSectionedSpine;

  var IfcSegment = /*#__PURE__*/function (_IfcGeometricRepresen38) {
    _inherits(IfcSegment, _IfcGeometricRepresen38);

    var _super984 = _createSuper(IfcSegment);

    function IfcSegment(expressID, Transition) {
      var _this976;

      _classCallCheck2(this, IfcSegment);

      _this976 = _super984.call(this, expressID);
      _this976.Transition = Transition;
      _this976.type = 823603102;
      return _this976;
    }

    return IfcSegment;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcSegment = IfcSegment;

  var IfcShellBasedSurfaceModel = /*#__PURE__*/function (_IfcGeometricRepresen39) {
    _inherits(IfcShellBasedSurfaceModel, _IfcGeometricRepresen39);

    var _super985 = _createSuper(IfcShellBasedSurfaceModel);

    function IfcShellBasedSurfaceModel(expressID, SbsmBoundary) {
      var _this977;

      _classCallCheck2(this, IfcShellBasedSurfaceModel);

      _this977 = _super985.call(this, expressID);
      _this977.SbsmBoundary = SbsmBoundary;
      _this977.type = 4124623270;
      return _this977;
    }

    return IfcShellBasedSurfaceModel;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;

  var IfcSimpleProperty = /*#__PURE__*/function (_IfcProperty3) {
    _inherits(IfcSimpleProperty, _IfcProperty3);

    var _super986 = _createSuper(IfcSimpleProperty);

    function IfcSimpleProperty(expressID, Name, Specification) {
      var _this978;

      _classCallCheck2(this, IfcSimpleProperty);

      _this978 = _super986.call(this, expressID, Name, Specification);
      _this978.Name = Name;
      _this978.Specification = Specification;
      _this978.type = 3692461612;
      return _this978;
    }

    return IfcSimpleProperty;
  }(IfcProperty);

  IFC4_32.IfcSimpleProperty = IfcSimpleProperty;

  var IfcSlippageConnectionCondition = /*#__PURE__*/function (_IfcStructuralConnect7) {
    _inherits(IfcSlippageConnectionCondition, _IfcStructuralConnect7);

    var _super987 = _createSuper(IfcSlippageConnectionCondition);

    function IfcSlippageConnectionCondition(expressID, Name, SlippageX, SlippageY, SlippageZ) {
      var _this979;

      _classCallCheck2(this, IfcSlippageConnectionCondition);

      _this979 = _super987.call(this, expressID, Name);
      _this979.Name = Name;
      _this979.SlippageX = SlippageX;
      _this979.SlippageY = SlippageY;
      _this979.SlippageZ = SlippageZ;
      _this979.type = 2609359061;
      return _this979;
    }

    return IfcSlippageConnectionCondition;
  }(IfcStructuralConnectionCondition);

  IFC4_32.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;

  var IfcSolidModel = /*#__PURE__*/function (_IfcGeometricRepresen40) {
    _inherits(IfcSolidModel, _IfcGeometricRepresen40);

    var _super988 = _createSuper(IfcSolidModel);

    function IfcSolidModel(expressID) {
      var _this980;

      _classCallCheck2(this, IfcSolidModel);

      _this980 = _super988.call(this, expressID);
      _this980.type = 723233188;
      return _this980;
    }

    return IfcSolidModel;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcSolidModel = IfcSolidModel;

  var IfcStructuralLoadLinearForce = /*#__PURE__*/function (_IfcStructuralLoadSta7) {
    _inherits(IfcStructuralLoadLinearForce, _IfcStructuralLoadSta7);

    var _super989 = _createSuper(IfcStructuralLoadLinearForce);

    function IfcStructuralLoadLinearForce(expressID, Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ) {
      var _this981;

      _classCallCheck2(this, IfcStructuralLoadLinearForce);

      _this981 = _super989.call(this, expressID, Name);
      _this981.Name = Name;
      _this981.LinearForceX = LinearForceX;
      _this981.LinearForceY = LinearForceY;
      _this981.LinearForceZ = LinearForceZ;
      _this981.LinearMomentX = LinearMomentX;
      _this981.LinearMomentY = LinearMomentY;
      _this981.LinearMomentZ = LinearMomentZ;
      _this981.type = 1595516126;
      return _this981;
    }

    return IfcStructuralLoadLinearForce;
  }(IfcStructuralLoadStatic);

  IFC4_32.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;

  var IfcStructuralLoadPlanarForce = /*#__PURE__*/function (_IfcStructuralLoadSta8) {
    _inherits(IfcStructuralLoadPlanarForce, _IfcStructuralLoadSta8);

    var _super990 = _createSuper(IfcStructuralLoadPlanarForce);

    function IfcStructuralLoadPlanarForce(expressID, Name, PlanarForceX, PlanarForceY, PlanarForceZ) {
      var _this982;

      _classCallCheck2(this, IfcStructuralLoadPlanarForce);

      _this982 = _super990.call(this, expressID, Name);
      _this982.Name = Name;
      _this982.PlanarForceX = PlanarForceX;
      _this982.PlanarForceY = PlanarForceY;
      _this982.PlanarForceZ = PlanarForceZ;
      _this982.type = 2668620305;
      return _this982;
    }

    return IfcStructuralLoadPlanarForce;
  }(IfcStructuralLoadStatic);

  IFC4_32.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;

  var IfcStructuralLoadSingleDisplacement = /*#__PURE__*/function (_IfcStructuralLoadSta9) {
    _inherits(IfcStructuralLoadSingleDisplacement, _IfcStructuralLoadSta9);

    var _super991 = _createSuper(IfcStructuralLoadSingleDisplacement);

    function IfcStructuralLoadSingleDisplacement(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ) {
      var _this983;

      _classCallCheck2(this, IfcStructuralLoadSingleDisplacement);

      _this983 = _super991.call(this, expressID, Name);
      _this983.Name = Name;
      _this983.DisplacementX = DisplacementX;
      _this983.DisplacementY = DisplacementY;
      _this983.DisplacementZ = DisplacementZ;
      _this983.RotationalDisplacementRX = RotationalDisplacementRX;
      _this983.RotationalDisplacementRY = RotationalDisplacementRY;
      _this983.RotationalDisplacementRZ = RotationalDisplacementRZ;
      _this983.type = 2473145415;
      return _this983;
    }

    return IfcStructuralLoadSingleDisplacement;
  }(IfcStructuralLoadStatic);

  IFC4_32.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;

  var IfcStructuralLoadSingleDisplacementDistortion = /*#__PURE__*/function (_IfcStructuralLoadSin3) {
    _inherits(IfcStructuralLoadSingleDisplacementDistortion, _IfcStructuralLoadSin3);

    var _super992 = _createSuper(IfcStructuralLoadSingleDisplacementDistortion);

    function IfcStructuralLoadSingleDisplacementDistortion(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion) {
      var _this984;

      _classCallCheck2(this, IfcStructuralLoadSingleDisplacementDistortion);

      _this984 = _super992.call(this, expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
      _this984.Name = Name;
      _this984.DisplacementX = DisplacementX;
      _this984.DisplacementY = DisplacementY;
      _this984.DisplacementZ = DisplacementZ;
      _this984.RotationalDisplacementRX = RotationalDisplacementRX;
      _this984.RotationalDisplacementRY = RotationalDisplacementRY;
      _this984.RotationalDisplacementRZ = RotationalDisplacementRZ;
      _this984.Distortion = Distortion;
      _this984.type = 1973038258;
      return _this984;
    }

    return IfcStructuralLoadSingleDisplacementDistortion;
  }(IfcStructuralLoadSingleDisplacement);

  IFC4_32.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;

  var IfcStructuralLoadSingleForce = /*#__PURE__*/function (_IfcStructuralLoadSta10) {
    _inherits(IfcStructuralLoadSingleForce, _IfcStructuralLoadSta10);

    var _super993 = _createSuper(IfcStructuralLoadSingleForce);

    function IfcStructuralLoadSingleForce(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ) {
      var _this985;

      _classCallCheck2(this, IfcStructuralLoadSingleForce);

      _this985 = _super993.call(this, expressID, Name);
      _this985.Name = Name;
      _this985.ForceX = ForceX;
      _this985.ForceY = ForceY;
      _this985.ForceZ = ForceZ;
      _this985.MomentX = MomentX;
      _this985.MomentY = MomentY;
      _this985.MomentZ = MomentZ;
      _this985.type = 1597423693;
      return _this985;
    }

    return IfcStructuralLoadSingleForce;
  }(IfcStructuralLoadStatic);

  IFC4_32.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;

  var IfcStructuralLoadSingleForceWarping = /*#__PURE__*/function (_IfcStructuralLoadSin4) {
    _inherits(IfcStructuralLoadSingleForceWarping, _IfcStructuralLoadSin4);

    var _super994 = _createSuper(IfcStructuralLoadSingleForceWarping);

    function IfcStructuralLoadSingleForceWarping(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment) {
      var _this986;

      _classCallCheck2(this, IfcStructuralLoadSingleForceWarping);

      _this986 = _super994.call(this, expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
      _this986.Name = Name;
      _this986.ForceX = ForceX;
      _this986.ForceY = ForceY;
      _this986.ForceZ = ForceZ;
      _this986.MomentX = MomentX;
      _this986.MomentY = MomentY;
      _this986.MomentZ = MomentZ;
      _this986.WarpingMoment = WarpingMoment;
      _this986.type = 1190533807;
      return _this986;
    }

    return IfcStructuralLoadSingleForceWarping;
  }(IfcStructuralLoadSingleForce);

  IFC4_32.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;

  var IfcSubedge = /*#__PURE__*/function (_IfcEdge6) {
    _inherits(IfcSubedge, _IfcEdge6);

    var _super995 = _createSuper(IfcSubedge);

    function IfcSubedge(expressID, EdgeStart, EdgeEnd, ParentEdge) {
      var _this987;

      _classCallCheck2(this, IfcSubedge);

      _this987 = _super995.call(this, expressID, EdgeStart, EdgeEnd);
      _this987.EdgeStart = EdgeStart;
      _this987.EdgeEnd = EdgeEnd;
      _this987.ParentEdge = ParentEdge;
      _this987.type = 2233826070;
      return _this987;
    }

    return IfcSubedge;
  }(IfcEdge);

  IFC4_32.IfcSubedge = IfcSubedge;

  var IfcSurface = /*#__PURE__*/function (_IfcGeometricRepresen41) {
    _inherits(IfcSurface, _IfcGeometricRepresen41);

    var _super996 = _createSuper(IfcSurface);

    function IfcSurface(expressID) {
      var _this988;

      _classCallCheck2(this, IfcSurface);

      _this988 = _super996.call(this, expressID);
      _this988.type = 2513912981;
      return _this988;
    }

    return IfcSurface;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcSurface = IfcSurface;

  var IfcSurfaceStyleRendering = /*#__PURE__*/function (_IfcSurfaceStyleShadi2) {
    _inherits(IfcSurfaceStyleRendering, _IfcSurfaceStyleShadi2);

    var _super997 = _createSuper(IfcSurfaceStyleRendering);

    function IfcSurfaceStyleRendering(expressID, SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod) {
      var _this989;

      _classCallCheck2(this, IfcSurfaceStyleRendering);

      _this989 = _super997.call(this, expressID, SurfaceColour, Transparency);
      _this989.SurfaceColour = SurfaceColour;
      _this989.Transparency = Transparency;
      _this989.DiffuseColour = DiffuseColour;
      _this989.TransmissionColour = TransmissionColour;
      _this989.DiffuseTransmissionColour = DiffuseTransmissionColour;
      _this989.ReflectionColour = ReflectionColour;
      _this989.SpecularColour = SpecularColour;
      _this989.SpecularHighlight = SpecularHighlight;
      _this989.ReflectanceMethod = ReflectanceMethod;
      _this989.type = 1878645084;
      return _this989;
    }

    return IfcSurfaceStyleRendering;
  }(IfcSurfaceStyleShading);

  IFC4_32.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;

  var IfcSweptAreaSolid = /*#__PURE__*/function (_IfcSolidModel5) {
    _inherits(IfcSweptAreaSolid, _IfcSolidModel5);

    var _super998 = _createSuper(IfcSweptAreaSolid);

    function IfcSweptAreaSolid(expressID, SweptArea, Position) {
      var _this990;

      _classCallCheck2(this, IfcSweptAreaSolid);

      _this990 = _super998.call(this, expressID);
      _this990.SweptArea = SweptArea;
      _this990.Position = Position;
      _this990.type = 2247615214;
      return _this990;
    }

    return IfcSweptAreaSolid;
  }(IfcSolidModel);

  IFC4_32.IfcSweptAreaSolid = IfcSweptAreaSolid;

  var IfcSweptDiskSolid = /*#__PURE__*/function (_IfcSolidModel6) {
    _inherits(IfcSweptDiskSolid, _IfcSolidModel6);

    var _super999 = _createSuper(IfcSweptDiskSolid);

    function IfcSweptDiskSolid(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam) {
      var _this991;

      _classCallCheck2(this, IfcSweptDiskSolid);

      _this991 = _super999.call(this, expressID);
      _this991.Directrix = Directrix;
      _this991.Radius = Radius;
      _this991.InnerRadius = InnerRadius;
      _this991.StartParam = StartParam;
      _this991.EndParam = EndParam;
      _this991.type = 1260650574;
      return _this991;
    }

    return IfcSweptDiskSolid;
  }(IfcSolidModel);

  IFC4_32.IfcSweptDiskSolid = IfcSweptDiskSolid;

  var IfcSweptDiskSolidPolygonal = /*#__PURE__*/function (_IfcSweptDiskSolid) {
    _inherits(IfcSweptDiskSolidPolygonal, _IfcSweptDiskSolid);

    var _super1000 = _createSuper(IfcSweptDiskSolidPolygonal);

    function IfcSweptDiskSolidPolygonal(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam, FilletRadius) {
      var _this992;

      _classCallCheck2(this, IfcSweptDiskSolidPolygonal);

      _this992 = _super1000.call(this, expressID, Directrix, Radius, InnerRadius, StartParam, EndParam);
      _this992.Directrix = Directrix;
      _this992.Radius = Radius;
      _this992.InnerRadius = InnerRadius;
      _this992.StartParam = StartParam;
      _this992.EndParam = EndParam;
      _this992.FilletRadius = FilletRadius;
      _this992.type = 1096409881;
      return _this992;
    }

    return IfcSweptDiskSolidPolygonal;
  }(IfcSweptDiskSolid);

  IFC4_32.IfcSweptDiskSolidPolygonal = IfcSweptDiskSolidPolygonal;

  var IfcSweptSurface = /*#__PURE__*/function (_IfcSurface4) {
    _inherits(IfcSweptSurface, _IfcSurface4);

    var _super1001 = _createSuper(IfcSweptSurface);

    function IfcSweptSurface(expressID, SweptCurve, Position) {
      var _this993;

      _classCallCheck2(this, IfcSweptSurface);

      _this993 = _super1001.call(this, expressID);
      _this993.SweptCurve = SweptCurve;
      _this993.Position = Position;
      _this993.type = 230924584;
      return _this993;
    }

    return IfcSweptSurface;
  }(IfcSurface);

  IFC4_32.IfcSweptSurface = IfcSweptSurface;

  var IfcTShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf14) {
    _inherits(IfcTShapeProfileDef, _IfcParameterizedProf14);

    var _super1002 = _createSuper(IfcTShapeProfileDef);

    function IfcTShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope) {
      var _this994;

      _classCallCheck2(this, IfcTShapeProfileDef);

      _this994 = _super1002.call(this, expressID, ProfileType, ProfileName, Position);
      _this994.ProfileType = ProfileType;
      _this994.ProfileName = ProfileName;
      _this994.Position = Position;
      _this994.Depth = Depth;
      _this994.FlangeWidth = FlangeWidth;
      _this994.WebThickness = WebThickness;
      _this994.FlangeThickness = FlangeThickness;
      _this994.FilletRadius = FilletRadius;
      _this994.FlangeEdgeRadius = FlangeEdgeRadius;
      _this994.WebEdgeRadius = WebEdgeRadius;
      _this994.WebSlope = WebSlope;
      _this994.FlangeSlope = FlangeSlope;
      _this994.type = 3071757647;
      return _this994;
    }

    return IfcTShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC4_32.IfcTShapeProfileDef = IfcTShapeProfileDef;

  var IfcTessellatedItem = /*#__PURE__*/function (_IfcGeometricRepresen42) {
    _inherits(IfcTessellatedItem, _IfcGeometricRepresen42);

    var _super1003 = _createSuper(IfcTessellatedItem);

    function IfcTessellatedItem(expressID) {
      var _this995;

      _classCallCheck2(this, IfcTessellatedItem);

      _this995 = _super1003.call(this, expressID);
      _this995.type = 901063453;
      return _this995;
    }

    return IfcTessellatedItem;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcTessellatedItem = IfcTessellatedItem;

  var IfcTextLiteral = /*#__PURE__*/function (_IfcGeometricRepresen43) {
    _inherits(IfcTextLiteral, _IfcGeometricRepresen43);

    var _super1004 = _createSuper(IfcTextLiteral);

    function IfcTextLiteral(expressID, Literal, Placement, Path) {
      var _this996;

      _classCallCheck2(this, IfcTextLiteral);

      _this996 = _super1004.call(this, expressID);
      _this996.Literal = Literal;
      _this996.Placement = Placement;
      _this996.Path = Path;
      _this996.type = 4282788508;
      return _this996;
    }

    return IfcTextLiteral;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcTextLiteral = IfcTextLiteral;

  var IfcTextLiteralWithExtent = /*#__PURE__*/function (_IfcTextLiteral2) {
    _inherits(IfcTextLiteralWithExtent, _IfcTextLiteral2);

    var _super1005 = _createSuper(IfcTextLiteralWithExtent);

    function IfcTextLiteralWithExtent(expressID, Literal, Placement, Path, Extent, BoxAlignment) {
      var _this997;

      _classCallCheck2(this, IfcTextLiteralWithExtent);

      _this997 = _super1005.call(this, expressID, Literal, Placement, Path);
      _this997.Literal = Literal;
      _this997.Placement = Placement;
      _this997.Path = Path;
      _this997.Extent = Extent;
      _this997.BoxAlignment = BoxAlignment;
      _this997.type = 3124975700;
      return _this997;
    }

    return IfcTextLiteralWithExtent;
  }(IfcTextLiteral);

  IFC4_32.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;

  var IfcTextStyleFontModel = /*#__PURE__*/function (_IfcPreDefinedTextFon3) {
    _inherits(IfcTextStyleFontModel, _IfcPreDefinedTextFon3);

    var _super1006 = _createSuper(IfcTextStyleFontModel);

    function IfcTextStyleFontModel(expressID, Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize) {
      var _this998;

      _classCallCheck2(this, IfcTextStyleFontModel);

      _this998 = _super1006.call(this, expressID, Name);
      _this998.Name = Name;
      _this998.FontFamily = FontFamily;
      _this998.FontStyle = FontStyle;
      _this998.FontVariant = FontVariant;
      _this998.FontWeight = FontWeight;
      _this998.FontSize = FontSize;
      _this998.type = 1983826977;
      return _this998;
    }

    return IfcTextStyleFontModel;
  }(IfcPreDefinedTextFont);

  IFC4_32.IfcTextStyleFontModel = IfcTextStyleFontModel;

  var IfcTrapeziumProfileDef = /*#__PURE__*/function (_IfcParameterizedProf15) {
    _inherits(IfcTrapeziumProfileDef, _IfcParameterizedProf15);

    var _super1007 = _createSuper(IfcTrapeziumProfileDef);

    function IfcTrapeziumProfileDef(expressID, ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset) {
      var _this999;

      _classCallCheck2(this, IfcTrapeziumProfileDef);

      _this999 = _super1007.call(this, expressID, ProfileType, ProfileName, Position);
      _this999.ProfileType = ProfileType;
      _this999.ProfileName = ProfileName;
      _this999.Position = Position;
      _this999.BottomXDim = BottomXDim;
      _this999.TopXDim = TopXDim;
      _this999.YDim = YDim;
      _this999.TopXOffset = TopXOffset;
      _this999.type = 2715220739;
      return _this999;
    }

    return IfcTrapeziumProfileDef;
  }(IfcParameterizedProfileDef);

  IFC4_32.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;

  var IfcTypeObject = /*#__PURE__*/function (_IfcObjectDefinition3) {
    _inherits(IfcTypeObject, _IfcObjectDefinition3);

    var _super1008 = _createSuper(IfcTypeObject);

    function IfcTypeObject(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets) {
      var _this1000;

      _classCallCheck2(this, IfcTypeObject);

      _this1000 = _super1008.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1000.GlobalId = GlobalId;
      _this1000.OwnerHistory = OwnerHistory;
      _this1000.Name = Name;
      _this1000.Description = Description;
      _this1000.ApplicableOccurrence = ApplicableOccurrence;
      _this1000.HasPropertySets = HasPropertySets;
      _this1000.type = 1628702193;
      return _this1000;
    }

    return IfcTypeObject;
  }(IfcObjectDefinition);

  IFC4_32.IfcTypeObject = IfcTypeObject;

  var IfcTypeProcess = /*#__PURE__*/function (_IfcTypeObject2) {
    _inherits(IfcTypeProcess, _IfcTypeObject2);

    var _super1009 = _createSuper(IfcTypeProcess);

    function IfcTypeProcess(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType) {
      var _this1001;

      _classCallCheck2(this, IfcTypeProcess);

      _this1001 = _super1009.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      _this1001.GlobalId = GlobalId;
      _this1001.OwnerHistory = OwnerHistory;
      _this1001.Name = Name;
      _this1001.Description = Description;
      _this1001.ApplicableOccurrence = ApplicableOccurrence;
      _this1001.HasPropertySets = HasPropertySets;
      _this1001.Identification = Identification;
      _this1001.LongDescription = LongDescription;
      _this1001.ProcessType = ProcessType;
      _this1001.type = 3736923433;
      return _this1001;
    }

    return IfcTypeProcess;
  }(IfcTypeObject);

  IFC4_32.IfcTypeProcess = IfcTypeProcess;

  var IfcTypeProduct = /*#__PURE__*/function (_IfcTypeObject3) {
    _inherits(IfcTypeProduct, _IfcTypeObject3);

    var _super1010 = _createSuper(IfcTypeProduct);

    function IfcTypeProduct(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag) {
      var _this1002;

      _classCallCheck2(this, IfcTypeProduct);

      _this1002 = _super1010.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      _this1002.GlobalId = GlobalId;
      _this1002.OwnerHistory = OwnerHistory;
      _this1002.Name = Name;
      _this1002.Description = Description;
      _this1002.ApplicableOccurrence = ApplicableOccurrence;
      _this1002.HasPropertySets = HasPropertySets;
      _this1002.RepresentationMaps = RepresentationMaps;
      _this1002.Tag = Tag;
      _this1002.type = 2347495698;
      return _this1002;
    }

    return IfcTypeProduct;
  }(IfcTypeObject);

  IFC4_32.IfcTypeProduct = IfcTypeProduct;

  var IfcTypeResource = /*#__PURE__*/function (_IfcTypeObject4) {
    _inherits(IfcTypeResource, _IfcTypeObject4);

    var _super1011 = _createSuper(IfcTypeResource);

    function IfcTypeResource(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType) {
      var _this1003;

      _classCallCheck2(this, IfcTypeResource);

      _this1003 = _super1011.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      _this1003.GlobalId = GlobalId;
      _this1003.OwnerHistory = OwnerHistory;
      _this1003.Name = Name;
      _this1003.Description = Description;
      _this1003.ApplicableOccurrence = ApplicableOccurrence;
      _this1003.HasPropertySets = HasPropertySets;
      _this1003.Identification = Identification;
      _this1003.LongDescription = LongDescription;
      _this1003.ResourceType = ResourceType;
      _this1003.type = 3698973494;
      return _this1003;
    }

    return IfcTypeResource;
  }(IfcTypeObject);

  IFC4_32.IfcTypeResource = IfcTypeResource;

  var IfcUShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf16) {
    _inherits(IfcUShapeProfileDef, _IfcParameterizedProf16);

    var _super1012 = _createSuper(IfcUShapeProfileDef);

    function IfcUShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope) {
      var _this1004;

      _classCallCheck2(this, IfcUShapeProfileDef);

      _this1004 = _super1012.call(this, expressID, ProfileType, ProfileName, Position);
      _this1004.ProfileType = ProfileType;
      _this1004.ProfileName = ProfileName;
      _this1004.Position = Position;
      _this1004.Depth = Depth;
      _this1004.FlangeWidth = FlangeWidth;
      _this1004.WebThickness = WebThickness;
      _this1004.FlangeThickness = FlangeThickness;
      _this1004.FilletRadius = FilletRadius;
      _this1004.EdgeRadius = EdgeRadius;
      _this1004.FlangeSlope = FlangeSlope;
      _this1004.type = 427810014;
      return _this1004;
    }

    return IfcUShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC4_32.IfcUShapeProfileDef = IfcUShapeProfileDef;

  var IfcVector = /*#__PURE__*/function (_IfcGeometricRepresen44) {
    _inherits(IfcVector, _IfcGeometricRepresen44);

    var _super1013 = _createSuper(IfcVector);

    function IfcVector(expressID, Orientation, Magnitude) {
      var _this1005;

      _classCallCheck2(this, IfcVector);

      _this1005 = _super1013.call(this, expressID);
      _this1005.Orientation = Orientation;
      _this1005.Magnitude = Magnitude;
      _this1005.type = 1417489154;
      return _this1005;
    }

    return IfcVector;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcVector = IfcVector;

  var IfcVertexLoop = /*#__PURE__*/function (_IfcLoop5) {
    _inherits(IfcVertexLoop, _IfcLoop5);

    var _super1014 = _createSuper(IfcVertexLoop);

    function IfcVertexLoop(expressID, LoopVertex) {
      var _this1006;

      _classCallCheck2(this, IfcVertexLoop);

      _this1006 = _super1014.call(this, expressID);
      _this1006.LoopVertex = LoopVertex;
      _this1006.type = 2759199220;
      return _this1006;
    }

    return IfcVertexLoop;
  }(IfcLoop);

  IFC4_32.IfcVertexLoop = IfcVertexLoop;

  var IfcZShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf17) {
    _inherits(IfcZShapeProfileDef, _IfcParameterizedProf17);

    var _super1015 = _createSuper(IfcZShapeProfileDef);

    function IfcZShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius) {
      var _this1007;

      _classCallCheck2(this, IfcZShapeProfileDef);

      _this1007 = _super1015.call(this, expressID, ProfileType, ProfileName, Position);
      _this1007.ProfileType = ProfileType;
      _this1007.ProfileName = ProfileName;
      _this1007.Position = Position;
      _this1007.Depth = Depth;
      _this1007.FlangeWidth = FlangeWidth;
      _this1007.WebThickness = WebThickness;
      _this1007.FlangeThickness = FlangeThickness;
      _this1007.FilletRadius = FilletRadius;
      _this1007.EdgeRadius = EdgeRadius;
      _this1007.type = 2543172580;
      return _this1007;
    }

    return IfcZShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC4_32.IfcZShapeProfileDef = IfcZShapeProfileDef;

  var IfcAdvancedFace = /*#__PURE__*/function (_IfcFaceSurface) {
    _inherits(IfcAdvancedFace, _IfcFaceSurface);

    var _super1016 = _createSuper(IfcAdvancedFace);

    function IfcAdvancedFace(expressID, Bounds, FaceSurface, SameSense) {
      var _this1008;

      _classCallCheck2(this, IfcAdvancedFace);

      _this1008 = _super1016.call(this, expressID, Bounds, FaceSurface, SameSense);
      _this1008.Bounds = Bounds;
      _this1008.FaceSurface = FaceSurface;
      _this1008.SameSense = SameSense;
      _this1008.type = 3406155212;
      return _this1008;
    }

    return IfcAdvancedFace;
  }(IfcFaceSurface);

  IFC4_32.IfcAdvancedFace = IfcAdvancedFace;

  var IfcAnnotationFillArea = /*#__PURE__*/function (_IfcGeometricRepresen45) {
    _inherits(IfcAnnotationFillArea, _IfcGeometricRepresen45);

    var _super1017 = _createSuper(IfcAnnotationFillArea);

    function IfcAnnotationFillArea(expressID, OuterBoundary, InnerBoundaries) {
      var _this1009;

      _classCallCheck2(this, IfcAnnotationFillArea);

      _this1009 = _super1017.call(this, expressID);
      _this1009.OuterBoundary = OuterBoundary;
      _this1009.InnerBoundaries = InnerBoundaries;
      _this1009.type = 669184980;
      return _this1009;
    }

    return IfcAnnotationFillArea;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcAnnotationFillArea = IfcAnnotationFillArea;

  var IfcAsymmetricIShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf18) {
    _inherits(IfcAsymmetricIShapeProfileDef, _IfcParameterizedProf18);

    var _super1018 = _createSuper(IfcAsymmetricIShapeProfileDef);

    function IfcAsymmetricIShapeProfileDef(expressID, ProfileType, ProfileName, Position, BottomFlangeWidth, OverallDepth, WebThickness, BottomFlangeThickness, BottomFlangeFilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, BottomFlangeEdgeRadius, BottomFlangeSlope, TopFlangeEdgeRadius, TopFlangeSlope) {
      var _this1010;

      _classCallCheck2(this, IfcAsymmetricIShapeProfileDef);

      _this1010 = _super1018.call(this, expressID, ProfileType, ProfileName, Position);
      _this1010.ProfileType = ProfileType;
      _this1010.ProfileName = ProfileName;
      _this1010.Position = Position;
      _this1010.BottomFlangeWidth = BottomFlangeWidth;
      _this1010.OverallDepth = OverallDepth;
      _this1010.WebThickness = WebThickness;
      _this1010.BottomFlangeThickness = BottomFlangeThickness;
      _this1010.BottomFlangeFilletRadius = BottomFlangeFilletRadius;
      _this1010.TopFlangeWidth = TopFlangeWidth;
      _this1010.TopFlangeThickness = TopFlangeThickness;
      _this1010.TopFlangeFilletRadius = TopFlangeFilletRadius;
      _this1010.BottomFlangeEdgeRadius = BottomFlangeEdgeRadius;
      _this1010.BottomFlangeSlope = BottomFlangeSlope;
      _this1010.TopFlangeEdgeRadius = TopFlangeEdgeRadius;
      _this1010.TopFlangeSlope = TopFlangeSlope;
      _this1010.type = 3207858831;
      return _this1010;
    }

    return IfcAsymmetricIShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC4_32.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;

  var IfcAxis1Placement = /*#__PURE__*/function (_IfcPlacement4) {
    _inherits(IfcAxis1Placement, _IfcPlacement4);

    var _super1019 = _createSuper(IfcAxis1Placement);

    function IfcAxis1Placement(expressID, Location, Axis) {
      var _this1011;

      _classCallCheck2(this, IfcAxis1Placement);

      _this1011 = _super1019.call(this, expressID, Location);
      _this1011.Location = Location;
      _this1011.Axis = Axis;
      _this1011.type = 4261334040;
      return _this1011;
    }

    return IfcAxis1Placement;
  }(IfcPlacement);

  IFC4_32.IfcAxis1Placement = IfcAxis1Placement;

  var IfcAxis2Placement2D = /*#__PURE__*/function (_IfcPlacement5) {
    _inherits(IfcAxis2Placement2D, _IfcPlacement5);

    var _super1020 = _createSuper(IfcAxis2Placement2D);

    function IfcAxis2Placement2D(expressID, Location, RefDirection) {
      var _this1012;

      _classCallCheck2(this, IfcAxis2Placement2D);

      _this1012 = _super1020.call(this, expressID, Location);
      _this1012.Location = Location;
      _this1012.RefDirection = RefDirection;
      _this1012.type = 3125803723;
      return _this1012;
    }

    return IfcAxis2Placement2D;
  }(IfcPlacement);

  IFC4_32.IfcAxis2Placement2D = IfcAxis2Placement2D;

  var IfcAxis2Placement3D = /*#__PURE__*/function (_IfcPlacement6) {
    _inherits(IfcAxis2Placement3D, _IfcPlacement6);

    var _super1021 = _createSuper(IfcAxis2Placement3D);

    function IfcAxis2Placement3D(expressID, Location, Axis, RefDirection) {
      var _this1013;

      _classCallCheck2(this, IfcAxis2Placement3D);

      _this1013 = _super1021.call(this, expressID, Location);
      _this1013.Location = Location;
      _this1013.Axis = Axis;
      _this1013.RefDirection = RefDirection;
      _this1013.type = 2740243338;
      return _this1013;
    }

    return IfcAxis2Placement3D;
  }(IfcPlacement);

  IFC4_32.IfcAxis2Placement3D = IfcAxis2Placement3D;

  var IfcAxis2PlacementLinear = /*#__PURE__*/function (_IfcPlacement7) {
    _inherits(IfcAxis2PlacementLinear, _IfcPlacement7);

    var _super1022 = _createSuper(IfcAxis2PlacementLinear);

    function IfcAxis2PlacementLinear(expressID, Location, Axis, RefDirection) {
      var _this1014;

      _classCallCheck2(this, IfcAxis2PlacementLinear);

      _this1014 = _super1022.call(this, expressID, Location);
      _this1014.Location = Location;
      _this1014.Axis = Axis;
      _this1014.RefDirection = RefDirection;
      _this1014.type = 3425423356;
      return _this1014;
    }

    return IfcAxis2PlacementLinear;
  }(IfcPlacement);

  IFC4_32.IfcAxis2PlacementLinear = IfcAxis2PlacementLinear;

  var IfcBooleanResult = /*#__PURE__*/function (_IfcGeometricRepresen46) {
    _inherits(IfcBooleanResult, _IfcGeometricRepresen46);

    var _super1023 = _createSuper(IfcBooleanResult);

    function IfcBooleanResult(expressID, Operator, FirstOperand, SecondOperand) {
      var _this1015;

      _classCallCheck2(this, IfcBooleanResult);

      _this1015 = _super1023.call(this, expressID);
      _this1015.Operator = Operator;
      _this1015.FirstOperand = FirstOperand;
      _this1015.SecondOperand = SecondOperand;
      _this1015.type = 2736907675;
      return _this1015;
    }

    return IfcBooleanResult;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcBooleanResult = IfcBooleanResult;

  var IfcBoundedSurface = /*#__PURE__*/function (_IfcSurface5) {
    _inherits(IfcBoundedSurface, _IfcSurface5);

    var _super1024 = _createSuper(IfcBoundedSurface);

    function IfcBoundedSurface(expressID) {
      var _this1016;

      _classCallCheck2(this, IfcBoundedSurface);

      _this1016 = _super1024.call(this, expressID);
      _this1016.type = 4182860854;
      return _this1016;
    }

    return IfcBoundedSurface;
  }(IfcSurface);

  IFC4_32.IfcBoundedSurface = IfcBoundedSurface;

  var IfcBoundingBox = /*#__PURE__*/function (_IfcGeometricRepresen47) {
    _inherits(IfcBoundingBox, _IfcGeometricRepresen47);

    var _super1025 = _createSuper(IfcBoundingBox);

    function IfcBoundingBox(expressID, Corner, XDim, YDim, ZDim) {
      var _this1017;

      _classCallCheck2(this, IfcBoundingBox);

      _this1017 = _super1025.call(this, expressID);
      _this1017.Corner = Corner;
      _this1017.XDim = XDim;
      _this1017.YDim = YDim;
      _this1017.ZDim = ZDim;
      _this1017.type = 2581212453;
      return _this1017;
    }

    return IfcBoundingBox;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcBoundingBox = IfcBoundingBox;

  var IfcBoxedHalfSpace = /*#__PURE__*/function (_IfcHalfSpaceSolid4) {
    _inherits(IfcBoxedHalfSpace, _IfcHalfSpaceSolid4);

    var _super1026 = _createSuper(IfcBoxedHalfSpace);

    function IfcBoxedHalfSpace(expressID, BaseSurface, AgreementFlag, Enclosure) {
      var _this1018;

      _classCallCheck2(this, IfcBoxedHalfSpace);

      _this1018 = _super1026.call(this, expressID, BaseSurface, AgreementFlag);
      _this1018.BaseSurface = BaseSurface;
      _this1018.AgreementFlag = AgreementFlag;
      _this1018.Enclosure = Enclosure;
      _this1018.type = 2713105998;
      return _this1018;
    }

    return IfcBoxedHalfSpace;
  }(IfcHalfSpaceSolid);

  IFC4_32.IfcBoxedHalfSpace = IfcBoxedHalfSpace;

  var IfcCShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf19) {
    _inherits(IfcCShapeProfileDef, _IfcParameterizedProf19);

    var _super1027 = _createSuper(IfcCShapeProfileDef);

    function IfcCShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius) {
      var _this1019;

      _classCallCheck2(this, IfcCShapeProfileDef);

      _this1019 = _super1027.call(this, expressID, ProfileType, ProfileName, Position);
      _this1019.ProfileType = ProfileType;
      _this1019.ProfileName = ProfileName;
      _this1019.Position = Position;
      _this1019.Depth = Depth;
      _this1019.Width = Width;
      _this1019.WallThickness = WallThickness;
      _this1019.Girth = Girth;
      _this1019.InternalFilletRadius = InternalFilletRadius;
      _this1019.type = 2898889636;
      return _this1019;
    }

    return IfcCShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC4_32.IfcCShapeProfileDef = IfcCShapeProfileDef;

  var IfcCartesianPoint = /*#__PURE__*/function (_IfcPoint7) {
    _inherits(IfcCartesianPoint, _IfcPoint7);

    var _super1028 = _createSuper(IfcCartesianPoint);

    function IfcCartesianPoint(expressID, Coordinates) {
      var _this1020;

      _classCallCheck2(this, IfcCartesianPoint);

      _this1020 = _super1028.call(this, expressID);
      _this1020.Coordinates = Coordinates;
      _this1020.type = 1123145078;
      return _this1020;
    }

    return IfcCartesianPoint;
  }(IfcPoint);

  IFC4_32.IfcCartesianPoint = IfcCartesianPoint;

  var IfcCartesianPointList = /*#__PURE__*/function (_IfcGeometricRepresen48) {
    _inherits(IfcCartesianPointList, _IfcGeometricRepresen48);

    var _super1029 = _createSuper(IfcCartesianPointList);

    function IfcCartesianPointList(expressID) {
      var _this1021;

      _classCallCheck2(this, IfcCartesianPointList);

      _this1021 = _super1029.call(this, expressID);
      _this1021.type = 574549367;
      return _this1021;
    }

    return IfcCartesianPointList;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcCartesianPointList = IfcCartesianPointList;

  var IfcCartesianPointList2D = /*#__PURE__*/function (_IfcCartesianPointLis) {
    _inherits(IfcCartesianPointList2D, _IfcCartesianPointLis);

    var _super1030 = _createSuper(IfcCartesianPointList2D);

    function IfcCartesianPointList2D(expressID, CoordList, TagList) {
      var _this1022;

      _classCallCheck2(this, IfcCartesianPointList2D);

      _this1022 = _super1030.call(this, expressID);
      _this1022.CoordList = CoordList;
      _this1022.TagList = TagList;
      _this1022.type = 1675464909;
      return _this1022;
    }

    return IfcCartesianPointList2D;
  }(IfcCartesianPointList);

  IFC4_32.IfcCartesianPointList2D = IfcCartesianPointList2D;

  var IfcCartesianPointList3D = /*#__PURE__*/function (_IfcCartesianPointLis2) {
    _inherits(IfcCartesianPointList3D, _IfcCartesianPointLis2);

    var _super1031 = _createSuper(IfcCartesianPointList3D);

    function IfcCartesianPointList3D(expressID, CoordList, TagList) {
      var _this1023;

      _classCallCheck2(this, IfcCartesianPointList3D);

      _this1023 = _super1031.call(this, expressID);
      _this1023.CoordList = CoordList;
      _this1023.TagList = TagList;
      _this1023.type = 2059837836;
      return _this1023;
    }

    return IfcCartesianPointList3D;
  }(IfcCartesianPointList);

  IFC4_32.IfcCartesianPointList3D = IfcCartesianPointList3D;

  var IfcCartesianTransformationOperator = /*#__PURE__*/function (_IfcGeometricRepresen49) {
    _inherits(IfcCartesianTransformationOperator, _IfcGeometricRepresen49);

    var _super1032 = _createSuper(IfcCartesianTransformationOperator);

    function IfcCartesianTransformationOperator(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      var _this1024;

      _classCallCheck2(this, IfcCartesianTransformationOperator);

      _this1024 = _super1032.call(this, expressID);
      _this1024.Axis1 = Axis1;
      _this1024.Axis2 = Axis2;
      _this1024.LocalOrigin = LocalOrigin;
      _this1024.Scale = Scale;
      _this1024.type = 59481748;
      return _this1024;
    }

    return IfcCartesianTransformationOperator;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;

  var IfcCartesianTransformationOperator2D = /*#__PURE__*/function (_IfcCartesianTransfor5) {
    _inherits(IfcCartesianTransformationOperator2D, _IfcCartesianTransfor5);

    var _super1033 = _createSuper(IfcCartesianTransformationOperator2D);

    function IfcCartesianTransformationOperator2D(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      var _this1025;

      _classCallCheck2(this, IfcCartesianTransformationOperator2D);

      _this1025 = _super1033.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale);
      _this1025.Axis1 = Axis1;
      _this1025.Axis2 = Axis2;
      _this1025.LocalOrigin = LocalOrigin;
      _this1025.Scale = Scale;
      _this1025.type = 3749851601;
      return _this1025;
    }

    return IfcCartesianTransformationOperator2D;
  }(IfcCartesianTransformationOperator);

  IFC4_32.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;

  var IfcCartesianTransformationOperator2DnonUniform = /*#__PURE__*/function (_IfcCartesianTransfor6) {
    _inherits(IfcCartesianTransformationOperator2DnonUniform, _IfcCartesianTransfor6);

    var _super1034 = _createSuper(IfcCartesianTransformationOperator2DnonUniform);

    function IfcCartesianTransformationOperator2DnonUniform(expressID, Axis1, Axis2, LocalOrigin, Scale, Scale2) {
      var _this1026;

      _classCallCheck2(this, IfcCartesianTransformationOperator2DnonUniform);

      _this1026 = _super1034.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale);
      _this1026.Axis1 = Axis1;
      _this1026.Axis2 = Axis2;
      _this1026.LocalOrigin = LocalOrigin;
      _this1026.Scale = Scale;
      _this1026.Scale2 = Scale2;
      _this1026.type = 3486308946;
      return _this1026;
    }

    return IfcCartesianTransformationOperator2DnonUniform;
  }(IfcCartesianTransformationOperator2D);

  IFC4_32.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;

  var IfcCartesianTransformationOperator3D = /*#__PURE__*/function (_IfcCartesianTransfor7) {
    _inherits(IfcCartesianTransformationOperator3D, _IfcCartesianTransfor7);

    var _super1035 = _createSuper(IfcCartesianTransformationOperator3D);

    function IfcCartesianTransformationOperator3D(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3) {
      var _this1027;

      _classCallCheck2(this, IfcCartesianTransformationOperator3D);

      _this1027 = _super1035.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale);
      _this1027.Axis1 = Axis1;
      _this1027.Axis2 = Axis2;
      _this1027.LocalOrigin = LocalOrigin;
      _this1027.Scale = Scale;
      _this1027.Axis3 = Axis3;
      _this1027.type = 3331915920;
      return _this1027;
    }

    return IfcCartesianTransformationOperator3D;
  }(IfcCartesianTransformationOperator);

  IFC4_32.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;

  var IfcCartesianTransformationOperator3DnonUniform = /*#__PURE__*/function (_IfcCartesianTransfor8) {
    _inherits(IfcCartesianTransformationOperator3DnonUniform, _IfcCartesianTransfor8);

    var _super1036 = _createSuper(IfcCartesianTransformationOperator3DnonUniform);

    function IfcCartesianTransformationOperator3DnonUniform(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3) {
      var _this1028;

      _classCallCheck2(this, IfcCartesianTransformationOperator3DnonUniform);

      _this1028 = _super1036.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3);
      _this1028.Axis1 = Axis1;
      _this1028.Axis2 = Axis2;
      _this1028.LocalOrigin = LocalOrigin;
      _this1028.Scale = Scale;
      _this1028.Axis3 = Axis3;
      _this1028.Scale2 = Scale2;
      _this1028.Scale3 = Scale3;
      _this1028.type = 1416205885;
      return _this1028;
    }

    return IfcCartesianTransformationOperator3DnonUniform;
  }(IfcCartesianTransformationOperator3D);

  IFC4_32.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;

  var IfcCircleProfileDef = /*#__PURE__*/function (_IfcParameterizedProf20) {
    _inherits(IfcCircleProfileDef, _IfcParameterizedProf20);

    var _super1037 = _createSuper(IfcCircleProfileDef);

    function IfcCircleProfileDef(expressID, ProfileType, ProfileName, Position, Radius) {
      var _this1029;

      _classCallCheck2(this, IfcCircleProfileDef);

      _this1029 = _super1037.call(this, expressID, ProfileType, ProfileName, Position);
      _this1029.ProfileType = ProfileType;
      _this1029.ProfileName = ProfileName;
      _this1029.Position = Position;
      _this1029.Radius = Radius;
      _this1029.type = 1383045692;
      return _this1029;
    }

    return IfcCircleProfileDef;
  }(IfcParameterizedProfileDef);

  IFC4_32.IfcCircleProfileDef = IfcCircleProfileDef;

  var IfcClosedShell = /*#__PURE__*/function (_IfcConnectedFaceSet4) {
    _inherits(IfcClosedShell, _IfcConnectedFaceSet4);

    var _super1038 = _createSuper(IfcClosedShell);

    function IfcClosedShell(expressID, CfsFaces) {
      var _this1030;

      _classCallCheck2(this, IfcClosedShell);

      _this1030 = _super1038.call(this, expressID, CfsFaces);
      _this1030.CfsFaces = CfsFaces;
      _this1030.type = 2205249479;
      return _this1030;
    }

    return IfcClosedShell;
  }(IfcConnectedFaceSet);

  IFC4_32.IfcClosedShell = IfcClosedShell;

  var IfcColourRgb = /*#__PURE__*/function (_IfcColourSpecificati2) {
    _inherits(IfcColourRgb, _IfcColourSpecificati2);

    var _super1039 = _createSuper(IfcColourRgb);

    function IfcColourRgb(expressID, Name, Red, Green, Blue) {
      var _this1031;

      _classCallCheck2(this, IfcColourRgb);

      _this1031 = _super1039.call(this, expressID, Name);
      _this1031.Name = Name;
      _this1031.Red = Red;
      _this1031.Green = Green;
      _this1031.Blue = Blue;
      _this1031.type = 776857604;
      return _this1031;
    }

    return IfcColourRgb;
  }(IfcColourSpecification);

  IFC4_32.IfcColourRgb = IfcColourRgb;

  var IfcComplexProperty = /*#__PURE__*/function (_IfcProperty4) {
    _inherits(IfcComplexProperty, _IfcProperty4);

    var _super1040 = _createSuper(IfcComplexProperty);

    function IfcComplexProperty(expressID, Name, Specification, UsageName, HasProperties) {
      var _this1032;

      _classCallCheck2(this, IfcComplexProperty);

      _this1032 = _super1040.call(this, expressID, Name, Specification);
      _this1032.Name = Name;
      _this1032.Specification = Specification;
      _this1032.UsageName = UsageName;
      _this1032.HasProperties = HasProperties;
      _this1032.type = 2542286263;
      return _this1032;
    }

    return IfcComplexProperty;
  }(IfcProperty);

  IFC4_32.IfcComplexProperty = IfcComplexProperty;

  var IfcCompositeCurveSegment = /*#__PURE__*/function (_IfcSegment) {
    _inherits(IfcCompositeCurveSegment, _IfcSegment);

    var _super1041 = _createSuper(IfcCompositeCurveSegment);

    function IfcCompositeCurveSegment(expressID, Transition, SameSense, ParentCurve) {
      var _this1033;

      _classCallCheck2(this, IfcCompositeCurveSegment);

      _this1033 = _super1041.call(this, expressID, Transition);
      _this1033.Transition = Transition;
      _this1033.SameSense = SameSense;
      _this1033.ParentCurve = ParentCurve;
      _this1033.type = 2485617015;
      return _this1033;
    }

    return IfcCompositeCurveSegment;
  }(IfcSegment);

  IFC4_32.IfcCompositeCurveSegment = IfcCompositeCurveSegment;

  var IfcConstructionResourceType = /*#__PURE__*/function (_IfcTypeResource) {
    _inherits(IfcConstructionResourceType, _IfcTypeResource);

    var _super1042 = _createSuper(IfcConstructionResourceType);

    function IfcConstructionResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity) {
      var _this1034;

      _classCallCheck2(this, IfcConstructionResourceType);

      _this1034 = _super1042.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType);
      _this1034.GlobalId = GlobalId;
      _this1034.OwnerHistory = OwnerHistory;
      _this1034.Name = Name;
      _this1034.Description = Description;
      _this1034.ApplicableOccurrence = ApplicableOccurrence;
      _this1034.HasPropertySets = HasPropertySets;
      _this1034.Identification = Identification;
      _this1034.LongDescription = LongDescription;
      _this1034.ResourceType = ResourceType;
      _this1034.BaseCosts = BaseCosts;
      _this1034.BaseQuantity = BaseQuantity;
      _this1034.type = 2574617495;
      return _this1034;
    }

    return IfcConstructionResourceType;
  }(IfcTypeResource);

  IFC4_32.IfcConstructionResourceType = IfcConstructionResourceType;

  var IfcContext = /*#__PURE__*/function (_IfcObjectDefinition4) {
    _inherits(IfcContext, _IfcObjectDefinition4);

    var _super1043 = _createSuper(IfcContext);

    function IfcContext(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      var _this1035;

      _classCallCheck2(this, IfcContext);

      _this1035 = _super1043.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1035.GlobalId = GlobalId;
      _this1035.OwnerHistory = OwnerHistory;
      _this1035.Name = Name;
      _this1035.Description = Description;
      _this1035.ObjectType = ObjectType;
      _this1035.LongName = LongName;
      _this1035.Phase = Phase;
      _this1035.RepresentationContexts = RepresentationContexts;
      _this1035.UnitsInContext = UnitsInContext;
      _this1035.type = 3419103109;
      return _this1035;
    }

    return IfcContext;
  }(IfcObjectDefinition);

  IFC4_32.IfcContext = IfcContext;

  var IfcCrewResourceType = /*#__PURE__*/function (_IfcConstructionResou7) {
    _inherits(IfcCrewResourceType, _IfcConstructionResou7);

    var _super1044 = _createSuper(IfcCrewResourceType);

    function IfcCrewResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1036;

      _classCallCheck2(this, IfcCrewResourceType);

      _this1036 = _super1044.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this1036.GlobalId = GlobalId;
      _this1036.OwnerHistory = OwnerHistory;
      _this1036.Name = Name;
      _this1036.Description = Description;
      _this1036.ApplicableOccurrence = ApplicableOccurrence;
      _this1036.HasPropertySets = HasPropertySets;
      _this1036.Identification = Identification;
      _this1036.LongDescription = LongDescription;
      _this1036.ResourceType = ResourceType;
      _this1036.BaseCosts = BaseCosts;
      _this1036.BaseQuantity = BaseQuantity;
      _this1036.PredefinedType = PredefinedType;
      _this1036.type = 1815067380;
      return _this1036;
    }

    return IfcCrewResourceType;
  }(IfcConstructionResourceType);

  IFC4_32.IfcCrewResourceType = IfcCrewResourceType;

  var IfcCsgPrimitive3D = /*#__PURE__*/function (_IfcGeometricRepresen50) {
    _inherits(IfcCsgPrimitive3D, _IfcGeometricRepresen50);

    var _super1045 = _createSuper(IfcCsgPrimitive3D);

    function IfcCsgPrimitive3D(expressID, Position) {
      var _this1037;

      _classCallCheck2(this, IfcCsgPrimitive3D);

      _this1037 = _super1045.call(this, expressID);
      _this1037.Position = Position;
      _this1037.type = 2506170314;
      return _this1037;
    }

    return IfcCsgPrimitive3D;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcCsgPrimitive3D = IfcCsgPrimitive3D;

  var IfcCsgSolid = /*#__PURE__*/function (_IfcSolidModel7) {
    _inherits(IfcCsgSolid, _IfcSolidModel7);

    var _super1046 = _createSuper(IfcCsgSolid);

    function IfcCsgSolid(expressID, TreeRootExpression) {
      var _this1038;

      _classCallCheck2(this, IfcCsgSolid);

      _this1038 = _super1046.call(this, expressID);
      _this1038.TreeRootExpression = TreeRootExpression;
      _this1038.type = 2147822146;
      return _this1038;
    }

    return IfcCsgSolid;
  }(IfcSolidModel);

  IFC4_32.IfcCsgSolid = IfcCsgSolid;

  var IfcCurve = /*#__PURE__*/function (_IfcGeometricRepresen51) {
    _inherits(IfcCurve, _IfcGeometricRepresen51);

    var _super1047 = _createSuper(IfcCurve);

    function IfcCurve(expressID) {
      var _this1039;

      _classCallCheck2(this, IfcCurve);

      _this1039 = _super1047.call(this, expressID);
      _this1039.type = 2601014836;
      return _this1039;
    }

    return IfcCurve;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcCurve = IfcCurve;

  var IfcCurveBoundedPlane = /*#__PURE__*/function (_IfcBoundedSurface3) {
    _inherits(IfcCurveBoundedPlane, _IfcBoundedSurface3);

    var _super1048 = _createSuper(IfcCurveBoundedPlane);

    function IfcCurveBoundedPlane(expressID, BasisSurface, OuterBoundary, InnerBoundaries) {
      var _this1040;

      _classCallCheck2(this, IfcCurveBoundedPlane);

      _this1040 = _super1048.call(this, expressID);
      _this1040.BasisSurface = BasisSurface;
      _this1040.OuterBoundary = OuterBoundary;
      _this1040.InnerBoundaries = InnerBoundaries;
      _this1040.type = 2827736869;
      return _this1040;
    }

    return IfcCurveBoundedPlane;
  }(IfcBoundedSurface);

  IFC4_32.IfcCurveBoundedPlane = IfcCurveBoundedPlane;

  var IfcCurveBoundedSurface = /*#__PURE__*/function (_IfcBoundedSurface4) {
    _inherits(IfcCurveBoundedSurface, _IfcBoundedSurface4);

    var _super1049 = _createSuper(IfcCurveBoundedSurface);

    function IfcCurveBoundedSurface(expressID, BasisSurface, Boundaries, ImplicitOuter) {
      var _this1041;

      _classCallCheck2(this, IfcCurveBoundedSurface);

      _this1041 = _super1049.call(this, expressID);
      _this1041.BasisSurface = BasisSurface;
      _this1041.Boundaries = Boundaries;
      _this1041.ImplicitOuter = ImplicitOuter;
      _this1041.type = 2629017746;
      return _this1041;
    }

    return IfcCurveBoundedSurface;
  }(IfcBoundedSurface);

  IFC4_32.IfcCurveBoundedSurface = IfcCurveBoundedSurface;

  var IfcCurveSegment = /*#__PURE__*/function (_IfcSegment2) {
    _inherits(IfcCurveSegment, _IfcSegment2);

    var _super1050 = _createSuper(IfcCurveSegment);

    function IfcCurveSegment(expressID, Transition, Placement, SegmentStart, SegmentLength, ParentCurve) {
      var _this1042;

      _classCallCheck2(this, IfcCurveSegment);

      _this1042 = _super1050.call(this, expressID, Transition);
      _this1042.Transition = Transition;
      _this1042.Placement = Placement;
      _this1042.SegmentStart = SegmentStart;
      _this1042.SegmentLength = SegmentLength;
      _this1042.ParentCurve = ParentCurve;
      _this1042.type = 4212018352;
      return _this1042;
    }

    return IfcCurveSegment;
  }(IfcSegment);

  IFC4_32.IfcCurveSegment = IfcCurveSegment;

  var IfcDirection = /*#__PURE__*/function (_IfcGeometricRepresen52) {
    _inherits(IfcDirection, _IfcGeometricRepresen52);

    var _super1051 = _createSuper(IfcDirection);

    function IfcDirection(expressID, DirectionRatios) {
      var _this1043;

      _classCallCheck2(this, IfcDirection);

      _this1043 = _super1051.call(this, expressID);
      _this1043.DirectionRatios = DirectionRatios;
      _this1043.type = 32440307;
      return _this1043;
    }

    return IfcDirection;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcDirection = IfcDirection;

  var IfcDirectrixCurveSweptAreaSolid = /*#__PURE__*/function (_IfcSweptAreaSolid4) {
    _inherits(IfcDirectrixCurveSweptAreaSolid, _IfcSweptAreaSolid4);

    var _super1052 = _createSuper(IfcDirectrixCurveSweptAreaSolid);

    function IfcDirectrixCurveSweptAreaSolid(expressID, SweptArea, Position, Directrix, StartParam, EndParam) {
      var _this1044;

      _classCallCheck2(this, IfcDirectrixCurveSweptAreaSolid);

      _this1044 = _super1052.call(this, expressID, SweptArea, Position);
      _this1044.SweptArea = SweptArea;
      _this1044.Position = Position;
      _this1044.Directrix = Directrix;
      _this1044.StartParam = StartParam;
      _this1044.EndParam = EndParam;
      _this1044.type = 593015953;
      return _this1044;
    }

    return IfcDirectrixCurveSweptAreaSolid;
  }(IfcSweptAreaSolid);

  IFC4_32.IfcDirectrixCurveSweptAreaSolid = IfcDirectrixCurveSweptAreaSolid;

  var IfcEdgeLoop = /*#__PURE__*/function (_IfcLoop6) {
    _inherits(IfcEdgeLoop, _IfcLoop6);

    var _super1053 = _createSuper(IfcEdgeLoop);

    function IfcEdgeLoop(expressID, EdgeList) {
      var _this1045;

      _classCallCheck2(this, IfcEdgeLoop);

      _this1045 = _super1053.call(this, expressID);
      _this1045.EdgeList = EdgeList;
      _this1045.type = 1472233963;
      return _this1045;
    }

    return IfcEdgeLoop;
  }(IfcLoop);

  IFC4_32.IfcEdgeLoop = IfcEdgeLoop;

  var IfcElementQuantity = /*#__PURE__*/function (_IfcQuantitySet) {
    _inherits(IfcElementQuantity, _IfcQuantitySet);

    var _super1054 = _createSuper(IfcElementQuantity);

    function IfcElementQuantity(expressID, GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities) {
      var _this1046;

      _classCallCheck2(this, IfcElementQuantity);

      _this1046 = _super1054.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1046.GlobalId = GlobalId;
      _this1046.OwnerHistory = OwnerHistory;
      _this1046.Name = Name;
      _this1046.Description = Description;
      _this1046.MethodOfMeasurement = MethodOfMeasurement;
      _this1046.Quantities = Quantities;
      _this1046.type = 1883228015;
      return _this1046;
    }

    return IfcElementQuantity;
  }(IfcQuantitySet);

  IFC4_32.IfcElementQuantity = IfcElementQuantity;

  var IfcElementType = /*#__PURE__*/function (_IfcTypeProduct4) {
    _inherits(IfcElementType, _IfcTypeProduct4);

    var _super1055 = _createSuper(IfcElementType);

    function IfcElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1047;

      _classCallCheck2(this, IfcElementType);

      _this1047 = _super1055.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      _this1047.GlobalId = GlobalId;
      _this1047.OwnerHistory = OwnerHistory;
      _this1047.Name = Name;
      _this1047.Description = Description;
      _this1047.ApplicableOccurrence = ApplicableOccurrence;
      _this1047.HasPropertySets = HasPropertySets;
      _this1047.RepresentationMaps = RepresentationMaps;
      _this1047.Tag = Tag;
      _this1047.ElementType = ElementType;
      _this1047.type = 339256511;
      return _this1047;
    }

    return IfcElementType;
  }(IfcTypeProduct);

  IFC4_32.IfcElementType = IfcElementType;

  var IfcElementarySurface = /*#__PURE__*/function (_IfcSurface6) {
    _inherits(IfcElementarySurface, _IfcSurface6);

    var _super1056 = _createSuper(IfcElementarySurface);

    function IfcElementarySurface(expressID, Position) {
      var _this1048;

      _classCallCheck2(this, IfcElementarySurface);

      _this1048 = _super1056.call(this, expressID);
      _this1048.Position = Position;
      _this1048.type = 2777663545;
      return _this1048;
    }

    return IfcElementarySurface;
  }(IfcSurface);

  IFC4_32.IfcElementarySurface = IfcElementarySurface;

  var IfcEllipseProfileDef = /*#__PURE__*/function (_IfcParameterizedProf21) {
    _inherits(IfcEllipseProfileDef, _IfcParameterizedProf21);

    var _super1057 = _createSuper(IfcEllipseProfileDef);

    function IfcEllipseProfileDef(expressID, ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2) {
      var _this1049;

      _classCallCheck2(this, IfcEllipseProfileDef);

      _this1049 = _super1057.call(this, expressID, ProfileType, ProfileName, Position);
      _this1049.ProfileType = ProfileType;
      _this1049.ProfileName = ProfileName;
      _this1049.Position = Position;
      _this1049.SemiAxis1 = SemiAxis1;
      _this1049.SemiAxis2 = SemiAxis2;
      _this1049.type = 2835456948;
      return _this1049;
    }

    return IfcEllipseProfileDef;
  }(IfcParameterizedProfileDef);

  IFC4_32.IfcEllipseProfileDef = IfcEllipseProfileDef;

  var IfcEventType = /*#__PURE__*/function (_IfcTypeProcess) {
    _inherits(IfcEventType, _IfcTypeProcess);

    var _super1058 = _createSuper(IfcEventType);

    function IfcEventType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, EventTriggerType, UserDefinedEventTriggerType) {
      var _this1050;

      _classCallCheck2(this, IfcEventType);

      _this1050 = _super1058.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      _this1050.GlobalId = GlobalId;
      _this1050.OwnerHistory = OwnerHistory;
      _this1050.Name = Name;
      _this1050.Description = Description;
      _this1050.ApplicableOccurrence = ApplicableOccurrence;
      _this1050.HasPropertySets = HasPropertySets;
      _this1050.Identification = Identification;
      _this1050.LongDescription = LongDescription;
      _this1050.ProcessType = ProcessType;
      _this1050.PredefinedType = PredefinedType;
      _this1050.EventTriggerType = EventTriggerType;
      _this1050.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      _this1050.type = 4024345920;
      return _this1050;
    }

    return IfcEventType;
  }(IfcTypeProcess);

  IFC4_32.IfcEventType = IfcEventType;

  var IfcExtrudedAreaSolid = /*#__PURE__*/function (_IfcSweptAreaSolid5) {
    _inherits(IfcExtrudedAreaSolid, _IfcSweptAreaSolid5);

    var _super1059 = _createSuper(IfcExtrudedAreaSolid);

    function IfcExtrudedAreaSolid(expressID, SweptArea, Position, ExtrudedDirection, Depth) {
      var _this1051;

      _classCallCheck2(this, IfcExtrudedAreaSolid);

      _this1051 = _super1059.call(this, expressID, SweptArea, Position);
      _this1051.SweptArea = SweptArea;
      _this1051.Position = Position;
      _this1051.ExtrudedDirection = ExtrudedDirection;
      _this1051.Depth = Depth;
      _this1051.type = 477187591;
      return _this1051;
    }

    return IfcExtrudedAreaSolid;
  }(IfcSweptAreaSolid);

  IFC4_32.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;

  var IfcExtrudedAreaSolidTapered = /*#__PURE__*/function (_IfcExtrudedAreaSolid) {
    _inherits(IfcExtrudedAreaSolidTapered, _IfcExtrudedAreaSolid);

    var _super1060 = _createSuper(IfcExtrudedAreaSolidTapered);

    function IfcExtrudedAreaSolidTapered(expressID, SweptArea, Position, ExtrudedDirection, Depth, EndSweptArea) {
      var _this1052;

      _classCallCheck2(this, IfcExtrudedAreaSolidTapered);

      _this1052 = _super1060.call(this, expressID, SweptArea, Position, ExtrudedDirection, Depth);
      _this1052.SweptArea = SweptArea;
      _this1052.Position = Position;
      _this1052.ExtrudedDirection = ExtrudedDirection;
      _this1052.Depth = Depth;
      _this1052.EndSweptArea = EndSweptArea;
      _this1052.type = 2804161546;
      return _this1052;
    }

    return IfcExtrudedAreaSolidTapered;
  }(IfcExtrudedAreaSolid);

  IFC4_32.IfcExtrudedAreaSolidTapered = IfcExtrudedAreaSolidTapered;

  var IfcFaceBasedSurfaceModel = /*#__PURE__*/function (_IfcGeometricRepresen53) {
    _inherits(IfcFaceBasedSurfaceModel, _IfcGeometricRepresen53);

    var _super1061 = _createSuper(IfcFaceBasedSurfaceModel);

    function IfcFaceBasedSurfaceModel(expressID, FbsmFaces) {
      var _this1053;

      _classCallCheck2(this, IfcFaceBasedSurfaceModel);

      _this1053 = _super1061.call(this, expressID);
      _this1053.FbsmFaces = FbsmFaces;
      _this1053.type = 2047409740;
      return _this1053;
    }

    return IfcFaceBasedSurfaceModel;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;

  var IfcFillAreaStyleHatching = /*#__PURE__*/function (_IfcGeometricRepresen54) {
    _inherits(IfcFillAreaStyleHatching, _IfcGeometricRepresen54);

    var _super1062 = _createSuper(IfcFillAreaStyleHatching);

    function IfcFillAreaStyleHatching(expressID, HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle) {
      var _this1054;

      _classCallCheck2(this, IfcFillAreaStyleHatching);

      _this1054 = _super1062.call(this, expressID);
      _this1054.HatchLineAppearance = HatchLineAppearance;
      _this1054.StartOfNextHatchLine = StartOfNextHatchLine;
      _this1054.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
      _this1054.PatternStart = PatternStart;
      _this1054.HatchLineAngle = HatchLineAngle;
      _this1054.type = 374418227;
      return _this1054;
    }

    return IfcFillAreaStyleHatching;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;

  var IfcFillAreaStyleTiles = /*#__PURE__*/function (_IfcGeometricRepresen55) {
    _inherits(IfcFillAreaStyleTiles, _IfcGeometricRepresen55);

    var _super1063 = _createSuper(IfcFillAreaStyleTiles);

    function IfcFillAreaStyleTiles(expressID, TilingPattern, Tiles, TilingScale) {
      var _this1055;

      _classCallCheck2(this, IfcFillAreaStyleTiles);

      _this1055 = _super1063.call(this, expressID);
      _this1055.TilingPattern = TilingPattern;
      _this1055.Tiles = Tiles;
      _this1055.TilingScale = TilingScale;
      _this1055.type = 315944413;
      return _this1055;
    }

    return IfcFillAreaStyleTiles;
  }(IfcGeometricRepresentationItem);

  IFC4_32.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;

  var IfcFixedReferenceSweptAreaSolid = /*#__PURE__*/function (_IfcDirectrixCurveSwe) {
    _inherits(IfcFixedReferenceSweptAreaSolid, _IfcDirectrixCurveSwe);

    var _super1064 = _createSuper(IfcFixedReferenceSweptAreaSolid);

    function IfcFixedReferenceSweptAreaSolid(expressID, SweptArea, Position, Directrix, StartParam, EndParam, FixedReference) {
      var _this1056;

      _classCallCheck2(this, IfcFixedReferenceSweptAreaSolid);

      _this1056 = _super1064.call(this, expressID, SweptArea, Position, Directrix, StartParam, EndParam);
      _this1056.SweptArea = SweptArea;
      _this1056.Position = Position;
      _this1056.Directrix = Directrix;
      _this1056.StartParam = StartParam;
      _this1056.EndParam = EndParam;
      _this1056.FixedReference = FixedReference;
      _this1056.type = 2652556860;
      return _this1056;
    }

    return IfcFixedReferenceSweptAreaSolid;
  }(IfcDirectrixCurveSweptAreaSolid);

  IFC4_32.IfcFixedReferenceSweptAreaSolid = IfcFixedReferenceSweptAreaSolid;

  var IfcFurnishingElementType = /*#__PURE__*/function (_IfcElementType7) {
    _inherits(IfcFurnishingElementType, _IfcElementType7);

    var _super1065 = _createSuper(IfcFurnishingElementType);

    function IfcFurnishingElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1057;

      _classCallCheck2(this, IfcFurnishingElementType);

      _this1057 = _super1065.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1057.GlobalId = GlobalId;
      _this1057.OwnerHistory = OwnerHistory;
      _this1057.Name = Name;
      _this1057.Description = Description;
      _this1057.ApplicableOccurrence = ApplicableOccurrence;
      _this1057.HasPropertySets = HasPropertySets;
      _this1057.RepresentationMaps = RepresentationMaps;
      _this1057.Tag = Tag;
      _this1057.ElementType = ElementType;
      _this1057.type = 4238390223;
      return _this1057;
    }

    return IfcFurnishingElementType;
  }(IfcElementType);

  IFC4_32.IfcFurnishingElementType = IfcFurnishingElementType;

  var IfcFurnitureType = /*#__PURE__*/function (_IfcFurnishingElement3) {
    _inherits(IfcFurnitureType, _IfcFurnishingElement3);

    var _super1066 = _createSuper(IfcFurnitureType);

    function IfcFurnitureType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace, PredefinedType) {
      var _this1058;

      _classCallCheck2(this, IfcFurnitureType);

      _this1058 = _super1066.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1058.GlobalId = GlobalId;
      _this1058.OwnerHistory = OwnerHistory;
      _this1058.Name = Name;
      _this1058.Description = Description;
      _this1058.ApplicableOccurrence = ApplicableOccurrence;
      _this1058.HasPropertySets = HasPropertySets;
      _this1058.RepresentationMaps = RepresentationMaps;
      _this1058.Tag = Tag;
      _this1058.ElementType = ElementType;
      _this1058.AssemblyPlace = AssemblyPlace;
      _this1058.PredefinedType = PredefinedType;
      _this1058.type = 1268542332;
      return _this1058;
    }

    return IfcFurnitureType;
  }(IfcFurnishingElementType);

  IFC4_32.IfcFurnitureType = IfcFurnitureType;

  var IfcGeographicElementType = /*#__PURE__*/function (_IfcElementType8) {
    _inherits(IfcGeographicElementType, _IfcElementType8);

    var _super1067 = _createSuper(IfcGeographicElementType);

    function IfcGeographicElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1059;

      _classCallCheck2(this, IfcGeographicElementType);

      _this1059 = _super1067.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1059.GlobalId = GlobalId;
      _this1059.OwnerHistory = OwnerHistory;
      _this1059.Name = Name;
      _this1059.Description = Description;
      _this1059.ApplicableOccurrence = ApplicableOccurrence;
      _this1059.HasPropertySets = HasPropertySets;
      _this1059.RepresentationMaps = RepresentationMaps;
      _this1059.Tag = Tag;
      _this1059.ElementType = ElementType;
      _this1059.PredefinedType = PredefinedType;
      _this1059.type = 4095422895;
      return _this1059;
    }

    return IfcGeographicElementType;
  }(IfcElementType);

  IFC4_32.IfcGeographicElementType = IfcGeographicElementType;

  var IfcGeometricCurveSet = /*#__PURE__*/function (_IfcGeometricSet2) {
    _inherits(IfcGeometricCurveSet, _IfcGeometricSet2);

    var _super1068 = _createSuper(IfcGeometricCurveSet);

    function IfcGeometricCurveSet(expressID, Elements) {
      var _this1060;

      _classCallCheck2(this, IfcGeometricCurveSet);

      _this1060 = _super1068.call(this, expressID, Elements);
      _this1060.Elements = Elements;
      _this1060.type = 987898635;
      return _this1060;
    }

    return IfcGeometricCurveSet;
  }(IfcGeometricSet);

  IFC4_32.IfcGeometricCurveSet = IfcGeometricCurveSet;

  var IfcIShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf22) {
    _inherits(IfcIShapeProfileDef, _IfcParameterizedProf22);

    var _super1069 = _createSuper(IfcIShapeProfileDef);

    function IfcIShapeProfileDef(expressID, ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, FlangeSlope) {
      var _this1061;

      _classCallCheck2(this, IfcIShapeProfileDef);

      _this1061 = _super1069.call(this, expressID, ProfileType, ProfileName, Position);
      _this1061.ProfileType = ProfileType;
      _this1061.ProfileName = ProfileName;
      _this1061.Position = Position;
      _this1061.OverallWidth = OverallWidth;
      _this1061.OverallDepth = OverallDepth;
      _this1061.WebThickness = WebThickness;
      _this1061.FlangeThickness = FlangeThickness;
      _this1061.FilletRadius = FilletRadius;
      _this1061.FlangeEdgeRadius = FlangeEdgeRadius;
      _this1061.FlangeSlope = FlangeSlope;
      _this1061.type = 1484403080;
      return _this1061;
    }

    return IfcIShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC4_32.IfcIShapeProfileDef = IfcIShapeProfileDef;

  var IfcIndexedPolygonalFace = /*#__PURE__*/function (_IfcTessellatedItem) {
    _inherits(IfcIndexedPolygonalFace, _IfcTessellatedItem);

    var _super1070 = _createSuper(IfcIndexedPolygonalFace);

    function IfcIndexedPolygonalFace(expressID, CoordIndex) {
      var _this1062;

      _classCallCheck2(this, IfcIndexedPolygonalFace);

      _this1062 = _super1070.call(this, expressID);
      _this1062.CoordIndex = CoordIndex;
      _this1062.type = 178912537;
      return _this1062;
    }

    return IfcIndexedPolygonalFace;
  }(IfcTessellatedItem);

  IFC4_32.IfcIndexedPolygonalFace = IfcIndexedPolygonalFace;

  var IfcIndexedPolygonalFaceWithVoids = /*#__PURE__*/function (_IfcIndexedPolygonalF) {
    _inherits(IfcIndexedPolygonalFaceWithVoids, _IfcIndexedPolygonalF);

    var _super1071 = _createSuper(IfcIndexedPolygonalFaceWithVoids);

    function IfcIndexedPolygonalFaceWithVoids(expressID, CoordIndex, InnerCoordIndices) {
      var _this1063;

      _classCallCheck2(this, IfcIndexedPolygonalFaceWithVoids);

      _this1063 = _super1071.call(this, expressID, CoordIndex);
      _this1063.CoordIndex = CoordIndex;
      _this1063.InnerCoordIndices = InnerCoordIndices;
      _this1063.type = 2294589976;
      return _this1063;
    }

    return IfcIndexedPolygonalFaceWithVoids;
  }(IfcIndexedPolygonalFace);

  IFC4_32.IfcIndexedPolygonalFaceWithVoids = IfcIndexedPolygonalFaceWithVoids;

  var IfcIndexedPolygonalTextureMap = /*#__PURE__*/function (_IfcIndexedTextureMap2) {
    _inherits(IfcIndexedPolygonalTextureMap, _IfcIndexedTextureMap2);

    var _super1072 = _createSuper(IfcIndexedPolygonalTextureMap);

    function IfcIndexedPolygonalTextureMap(expressID, Maps, MappedTo, TexCoords, TexCoordIndices) {
      var _this1064;

      _classCallCheck2(this, IfcIndexedPolygonalTextureMap);

      _this1064 = _super1072.call(this, expressID, Maps, MappedTo, TexCoords);
      _this1064.Maps = Maps;
      _this1064.MappedTo = MappedTo;
      _this1064.TexCoords = TexCoords;
      _this1064.TexCoordIndices = TexCoordIndices;
      _this1064.type = 3465909080;
      return _this1064;
    }

    return IfcIndexedPolygonalTextureMap;
  }(IfcIndexedTextureMap);

  IFC4_32.IfcIndexedPolygonalTextureMap = IfcIndexedPolygonalTextureMap;

  var IfcLShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf23) {
    _inherits(IfcLShapeProfileDef, _IfcParameterizedProf23);

    var _super1073 = _createSuper(IfcLShapeProfileDef);

    function IfcLShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope) {
      var _this1065;

      _classCallCheck2(this, IfcLShapeProfileDef);

      _this1065 = _super1073.call(this, expressID, ProfileType, ProfileName, Position);
      _this1065.ProfileType = ProfileType;
      _this1065.ProfileName = ProfileName;
      _this1065.Position = Position;
      _this1065.Depth = Depth;
      _this1065.Width = Width;
      _this1065.Thickness = Thickness;
      _this1065.FilletRadius = FilletRadius;
      _this1065.EdgeRadius = EdgeRadius;
      _this1065.LegSlope = LegSlope;
      _this1065.type = 572779678;
      return _this1065;
    }

    return IfcLShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC4_32.IfcLShapeProfileDef = IfcLShapeProfileDef;

  var IfcLaborResourceType = /*#__PURE__*/function (_IfcConstructionResou8) {
    _inherits(IfcLaborResourceType, _IfcConstructionResou8);

    var _super1074 = _createSuper(IfcLaborResourceType);

    function IfcLaborResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1066;

      _classCallCheck2(this, IfcLaborResourceType);

      _this1066 = _super1074.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this1066.GlobalId = GlobalId;
      _this1066.OwnerHistory = OwnerHistory;
      _this1066.Name = Name;
      _this1066.Description = Description;
      _this1066.ApplicableOccurrence = ApplicableOccurrence;
      _this1066.HasPropertySets = HasPropertySets;
      _this1066.Identification = Identification;
      _this1066.LongDescription = LongDescription;
      _this1066.ResourceType = ResourceType;
      _this1066.BaseCosts = BaseCosts;
      _this1066.BaseQuantity = BaseQuantity;
      _this1066.PredefinedType = PredefinedType;
      _this1066.type = 428585644;
      return _this1066;
    }

    return IfcLaborResourceType;
  }(IfcConstructionResourceType);

  IFC4_32.IfcLaborResourceType = IfcLaborResourceType;

  var IfcLine = /*#__PURE__*/function (_IfcCurve6) {
    _inherits(IfcLine, _IfcCurve6);

    var _super1075 = _createSuper(IfcLine);

    function IfcLine(expressID, Pnt, Dir) {
      var _this1067;

      _classCallCheck2(this, IfcLine);

      _this1067 = _super1075.call(this, expressID);
      _this1067.Pnt = Pnt;
      _this1067.Dir = Dir;
      _this1067.type = 1281925730;
      return _this1067;
    }

    return IfcLine;
  }(IfcCurve);

  IFC4_32.IfcLine = IfcLine;

  var IfcManifoldSolidBrep = /*#__PURE__*/function (_IfcSolidModel8) {
    _inherits(IfcManifoldSolidBrep, _IfcSolidModel8);

    var _super1076 = _createSuper(IfcManifoldSolidBrep);

    function IfcManifoldSolidBrep(expressID, Outer) {
      var _this1068;

      _classCallCheck2(this, IfcManifoldSolidBrep);

      _this1068 = _super1076.call(this, expressID);
      _this1068.Outer = Outer;
      _this1068.type = 1425443689;
      return _this1068;
    }

    return IfcManifoldSolidBrep;
  }(IfcSolidModel);

  IFC4_32.IfcManifoldSolidBrep = IfcManifoldSolidBrep;

  var IfcObject = /*#__PURE__*/function (_IfcObjectDefinition5) {
    _inherits(IfcObject, _IfcObjectDefinition5);

    var _super1077 = _createSuper(IfcObject);

    function IfcObject(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this1069;

      _classCallCheck2(this, IfcObject);

      _this1069 = _super1077.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1069.GlobalId = GlobalId;
      _this1069.OwnerHistory = OwnerHistory;
      _this1069.Name = Name;
      _this1069.Description = Description;
      _this1069.ObjectType = ObjectType;
      _this1069.type = 3888040117;
      return _this1069;
    }

    return IfcObject;
  }(IfcObjectDefinition);

  IFC4_32.IfcObject = IfcObject;

  var IfcOffsetCurve = /*#__PURE__*/function (_IfcCurve7) {
    _inherits(IfcOffsetCurve, _IfcCurve7);

    var _super1078 = _createSuper(IfcOffsetCurve);

    function IfcOffsetCurve(expressID, BasisCurve) {
      var _this1070;

      _classCallCheck2(this, IfcOffsetCurve);

      _this1070 = _super1078.call(this, expressID);
      _this1070.BasisCurve = BasisCurve;
      _this1070.type = 590820931;
      return _this1070;
    }

    return IfcOffsetCurve;
  }(IfcCurve);

  IFC4_32.IfcOffsetCurve = IfcOffsetCurve;

  var IfcOffsetCurve2D = /*#__PURE__*/function (_IfcOffsetCurve) {
    _inherits(IfcOffsetCurve2D, _IfcOffsetCurve);

    var _super1079 = _createSuper(IfcOffsetCurve2D);

    function IfcOffsetCurve2D(expressID, BasisCurve, Distance, SelfIntersect) {
      var _this1071;

      _classCallCheck2(this, IfcOffsetCurve2D);

      _this1071 = _super1079.call(this, expressID, BasisCurve);
      _this1071.BasisCurve = BasisCurve;
      _this1071.Distance = Distance;
      _this1071.SelfIntersect = SelfIntersect;
      _this1071.type = 3388369263;
      return _this1071;
    }

    return IfcOffsetCurve2D;
  }(IfcOffsetCurve);

  IFC4_32.IfcOffsetCurve2D = IfcOffsetCurve2D;

  var IfcOffsetCurve3D = /*#__PURE__*/function (_IfcOffsetCurve2) {
    _inherits(IfcOffsetCurve3D, _IfcOffsetCurve2);

    var _super1080 = _createSuper(IfcOffsetCurve3D);

    function IfcOffsetCurve3D(expressID, BasisCurve, Distance, SelfIntersect, RefDirection) {
      var _this1072;

      _classCallCheck2(this, IfcOffsetCurve3D);

      _this1072 = _super1080.call(this, expressID, BasisCurve);
      _this1072.BasisCurve = BasisCurve;
      _this1072.Distance = Distance;
      _this1072.SelfIntersect = SelfIntersect;
      _this1072.RefDirection = RefDirection;
      _this1072.type = 3505215534;
      return _this1072;
    }

    return IfcOffsetCurve3D;
  }(IfcOffsetCurve);

  IFC4_32.IfcOffsetCurve3D = IfcOffsetCurve3D;

  var IfcOffsetCurveByDistances = /*#__PURE__*/function (_IfcOffsetCurve3) {
    _inherits(IfcOffsetCurveByDistances, _IfcOffsetCurve3);

    var _super1081 = _createSuper(IfcOffsetCurveByDistances);

    function IfcOffsetCurveByDistances(expressID, BasisCurve, OffsetValues, Tag) {
      var _this1073;

      _classCallCheck2(this, IfcOffsetCurveByDistances);

      _this1073 = _super1081.call(this, expressID, BasisCurve);
      _this1073.BasisCurve = BasisCurve;
      _this1073.OffsetValues = OffsetValues;
      _this1073.Tag = Tag;
      _this1073.type = 2485787929;
      return _this1073;
    }

    return IfcOffsetCurveByDistances;
  }(IfcOffsetCurve);

  IFC4_32.IfcOffsetCurveByDistances = IfcOffsetCurveByDistances;

  var IfcPcurve = /*#__PURE__*/function (_IfcCurve8) {
    _inherits(IfcPcurve, _IfcCurve8);

    var _super1082 = _createSuper(IfcPcurve);

    function IfcPcurve(expressID, BasisSurface, ReferenceCurve) {
      var _this1074;

      _classCallCheck2(this, IfcPcurve);

      _this1074 = _super1082.call(this, expressID);
      _this1074.BasisSurface = BasisSurface;
      _this1074.ReferenceCurve = ReferenceCurve;
      _this1074.type = 1682466193;
      return _this1074;
    }

    return IfcPcurve;
  }(IfcCurve);

  IFC4_32.IfcPcurve = IfcPcurve;

  var IfcPlanarBox = /*#__PURE__*/function (_IfcPlanarExtent2) {
    _inherits(IfcPlanarBox, _IfcPlanarExtent2);

    var _super1083 = _createSuper(IfcPlanarBox);

    function IfcPlanarBox(expressID, SizeInX, SizeInY, Placement) {
      var _this1075;

      _classCallCheck2(this, IfcPlanarBox);

      _this1075 = _super1083.call(this, expressID, SizeInX, SizeInY);
      _this1075.SizeInX = SizeInX;
      _this1075.SizeInY = SizeInY;
      _this1075.Placement = Placement;
      _this1075.type = 603570806;
      return _this1075;
    }

    return IfcPlanarBox;
  }(IfcPlanarExtent);

  IFC4_32.IfcPlanarBox = IfcPlanarBox;

  var IfcPlane = /*#__PURE__*/function (_IfcElementarySurface2) {
    _inherits(IfcPlane, _IfcElementarySurface2);

    var _super1084 = _createSuper(IfcPlane);

    function IfcPlane(expressID, Position) {
      var _this1076;

      _classCallCheck2(this, IfcPlane);

      _this1076 = _super1084.call(this, expressID, Position);
      _this1076.Position = Position;
      _this1076.type = 220341763;
      return _this1076;
    }

    return IfcPlane;
  }(IfcElementarySurface);

  IFC4_32.IfcPlane = IfcPlane;

  var IfcPolynomialCurve = /*#__PURE__*/function (_IfcCurve9) {
    _inherits(IfcPolynomialCurve, _IfcCurve9);

    var _super1085 = _createSuper(IfcPolynomialCurve);

    function IfcPolynomialCurve(expressID, Position, CoefficientsX, CoefficientsY, CoefficientsZ) {
      var _this1077;

      _classCallCheck2(this, IfcPolynomialCurve);

      _this1077 = _super1085.call(this, expressID);
      _this1077.Position = Position;
      _this1077.CoefficientsX = CoefficientsX;
      _this1077.CoefficientsY = CoefficientsY;
      _this1077.CoefficientsZ = CoefficientsZ;
      _this1077.type = 3381221214;
      return _this1077;
    }

    return IfcPolynomialCurve;
  }(IfcCurve);

  IFC4_32.IfcPolynomialCurve = IfcPolynomialCurve;

  var IfcPreDefinedColour = /*#__PURE__*/function (_IfcPreDefinedItem6) {
    _inherits(IfcPreDefinedColour, _IfcPreDefinedItem6);

    var _super1086 = _createSuper(IfcPreDefinedColour);

    function IfcPreDefinedColour(expressID, Name) {
      var _this1078;

      _classCallCheck2(this, IfcPreDefinedColour);

      _this1078 = _super1086.call(this, expressID, Name);
      _this1078.Name = Name;
      _this1078.type = 759155922;
      return _this1078;
    }

    return IfcPreDefinedColour;
  }(IfcPreDefinedItem);

  IFC4_32.IfcPreDefinedColour = IfcPreDefinedColour;

  var IfcPreDefinedCurveFont = /*#__PURE__*/function (_IfcPreDefinedItem7) {
    _inherits(IfcPreDefinedCurveFont, _IfcPreDefinedItem7);

    var _super1087 = _createSuper(IfcPreDefinedCurveFont);

    function IfcPreDefinedCurveFont(expressID, Name) {
      var _this1079;

      _classCallCheck2(this, IfcPreDefinedCurveFont);

      _this1079 = _super1087.call(this, expressID, Name);
      _this1079.Name = Name;
      _this1079.type = 2559016684;
      return _this1079;
    }

    return IfcPreDefinedCurveFont;
  }(IfcPreDefinedItem);

  IFC4_32.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;

  var IfcPreDefinedPropertySet = /*#__PURE__*/function (_IfcPropertySetDefini16) {
    _inherits(IfcPreDefinedPropertySet, _IfcPropertySetDefini16);

    var _super1088 = _createSuper(IfcPreDefinedPropertySet);

    function IfcPreDefinedPropertySet(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1080;

      _classCallCheck2(this, IfcPreDefinedPropertySet);

      _this1080 = _super1088.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1080.GlobalId = GlobalId;
      _this1080.OwnerHistory = OwnerHistory;
      _this1080.Name = Name;
      _this1080.Description = Description;
      _this1080.type = 3967405729;
      return _this1080;
    }

    return IfcPreDefinedPropertySet;
  }(IfcPropertySetDefinition);

  IFC4_32.IfcPreDefinedPropertySet = IfcPreDefinedPropertySet;

  var IfcProcedureType = /*#__PURE__*/function (_IfcTypeProcess2) {
    _inherits(IfcProcedureType, _IfcTypeProcess2);

    var _super1089 = _createSuper(IfcProcedureType);

    function IfcProcedureType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType) {
      var _this1081;

      _classCallCheck2(this, IfcProcedureType);

      _this1081 = _super1089.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      _this1081.GlobalId = GlobalId;
      _this1081.OwnerHistory = OwnerHistory;
      _this1081.Name = Name;
      _this1081.Description = Description;
      _this1081.ApplicableOccurrence = ApplicableOccurrence;
      _this1081.HasPropertySets = HasPropertySets;
      _this1081.Identification = Identification;
      _this1081.LongDescription = LongDescription;
      _this1081.ProcessType = ProcessType;
      _this1081.PredefinedType = PredefinedType;
      _this1081.type = 569719735;
      return _this1081;
    }

    return IfcProcedureType;
  }(IfcTypeProcess);

  IFC4_32.IfcProcedureType = IfcProcedureType;

  var IfcProcess = /*#__PURE__*/function (_IfcObject8) {
    _inherits(IfcProcess, _IfcObject8);

    var _super1090 = _createSuper(IfcProcess);

    function IfcProcess(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      var _this1082;

      _classCallCheck2(this, IfcProcess);

      _this1082 = _super1090.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1082.GlobalId = GlobalId;
      _this1082.OwnerHistory = OwnerHistory;
      _this1082.Name = Name;
      _this1082.Description = Description;
      _this1082.ObjectType = ObjectType;
      _this1082.Identification = Identification;
      _this1082.LongDescription = LongDescription;
      _this1082.type = 2945172077;
      return _this1082;
    }

    return IfcProcess;
  }(IfcObject);

  IFC4_32.IfcProcess = IfcProcess;

  var IfcProduct = /*#__PURE__*/function (_IfcObject9) {
    _inherits(IfcProduct, _IfcObject9);

    var _super1091 = _createSuper(IfcProduct);

    function IfcProduct(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this1083;

      _classCallCheck2(this, IfcProduct);

      _this1083 = _super1091.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1083.GlobalId = GlobalId;
      _this1083.OwnerHistory = OwnerHistory;
      _this1083.Name = Name;
      _this1083.Description = Description;
      _this1083.ObjectType = ObjectType;
      _this1083.ObjectPlacement = ObjectPlacement;
      _this1083.Representation = Representation;
      _this1083.type = 4208778838;
      return _this1083;
    }

    return IfcProduct;
  }(IfcObject);

  IFC4_32.IfcProduct = IfcProduct;

  var IfcProject = /*#__PURE__*/function (_IfcContext) {
    _inherits(IfcProject, _IfcContext);

    var _super1092 = _createSuper(IfcProject);

    function IfcProject(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      var _this1084;

      _classCallCheck2(this, IfcProject);

      _this1084 = _super1092.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      _this1084.GlobalId = GlobalId;
      _this1084.OwnerHistory = OwnerHistory;
      _this1084.Name = Name;
      _this1084.Description = Description;
      _this1084.ObjectType = ObjectType;
      _this1084.LongName = LongName;
      _this1084.Phase = Phase;
      _this1084.RepresentationContexts = RepresentationContexts;
      _this1084.UnitsInContext = UnitsInContext;
      _this1084.type = 103090709;
      return _this1084;
    }

    return IfcProject;
  }(IfcContext);

  IFC4_32.IfcProject = IfcProject;

  var IfcProjectLibrary = /*#__PURE__*/function (_IfcContext2) {
    _inherits(IfcProjectLibrary, _IfcContext2);

    var _super1093 = _createSuper(IfcProjectLibrary);

    function IfcProjectLibrary(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      var _this1085;

      _classCallCheck2(this, IfcProjectLibrary);

      _this1085 = _super1093.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      _this1085.GlobalId = GlobalId;
      _this1085.OwnerHistory = OwnerHistory;
      _this1085.Name = Name;
      _this1085.Description = Description;
      _this1085.ObjectType = ObjectType;
      _this1085.LongName = LongName;
      _this1085.Phase = Phase;
      _this1085.RepresentationContexts = RepresentationContexts;
      _this1085.UnitsInContext = UnitsInContext;
      _this1085.type = 653396225;
      return _this1085;
    }

    return IfcProjectLibrary;
  }(IfcContext);

  IFC4_32.IfcProjectLibrary = IfcProjectLibrary;

  var IfcPropertyBoundedValue = /*#__PURE__*/function (_IfcSimpleProperty7) {
    _inherits(IfcPropertyBoundedValue, _IfcSimpleProperty7);

    var _super1094 = _createSuper(IfcPropertyBoundedValue);

    function IfcPropertyBoundedValue(expressID, Name, Specification, UpperBoundValue, LowerBoundValue, Unit, SetPointValue) {
      var _this1086;

      _classCallCheck2(this, IfcPropertyBoundedValue);

      _this1086 = _super1094.call(this, expressID, Name, Specification);
      _this1086.Name = Name;
      _this1086.Specification = Specification;
      _this1086.UpperBoundValue = UpperBoundValue;
      _this1086.LowerBoundValue = LowerBoundValue;
      _this1086.Unit = Unit;
      _this1086.SetPointValue = SetPointValue;
      _this1086.type = 871118103;
      return _this1086;
    }

    return IfcPropertyBoundedValue;
  }(IfcSimpleProperty);

  IFC4_32.IfcPropertyBoundedValue = IfcPropertyBoundedValue;

  var IfcPropertyEnumeratedValue = /*#__PURE__*/function (_IfcSimpleProperty8) {
    _inherits(IfcPropertyEnumeratedValue, _IfcSimpleProperty8);

    var _super1095 = _createSuper(IfcPropertyEnumeratedValue);

    function IfcPropertyEnumeratedValue(expressID, Name, Specification, EnumerationValues, EnumerationReference) {
      var _this1087;

      _classCallCheck2(this, IfcPropertyEnumeratedValue);

      _this1087 = _super1095.call(this, expressID, Name, Specification);
      _this1087.Name = Name;
      _this1087.Specification = Specification;
      _this1087.EnumerationValues = EnumerationValues;
      _this1087.EnumerationReference = EnumerationReference;
      _this1087.type = 4166981789;
      return _this1087;
    }

    return IfcPropertyEnumeratedValue;
  }(IfcSimpleProperty);

  IFC4_32.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;

  var IfcPropertyListValue = /*#__PURE__*/function (_IfcSimpleProperty9) {
    _inherits(IfcPropertyListValue, _IfcSimpleProperty9);

    var _super1096 = _createSuper(IfcPropertyListValue);

    function IfcPropertyListValue(expressID, Name, Specification, ListValues, Unit) {
      var _this1088;

      _classCallCheck2(this, IfcPropertyListValue);

      _this1088 = _super1096.call(this, expressID, Name, Specification);
      _this1088.Name = Name;
      _this1088.Specification = Specification;
      _this1088.ListValues = ListValues;
      _this1088.Unit = Unit;
      _this1088.type = 2752243245;
      return _this1088;
    }

    return IfcPropertyListValue;
  }(IfcSimpleProperty);

  IFC4_32.IfcPropertyListValue = IfcPropertyListValue;

  var IfcPropertyReferenceValue = /*#__PURE__*/function (_IfcSimpleProperty10) {
    _inherits(IfcPropertyReferenceValue, _IfcSimpleProperty10);

    var _super1097 = _createSuper(IfcPropertyReferenceValue);

    function IfcPropertyReferenceValue(expressID, Name, Specification, UsageName, PropertyReference) {
      var _this1089;

      _classCallCheck2(this, IfcPropertyReferenceValue);

      _this1089 = _super1097.call(this, expressID, Name, Specification);
      _this1089.Name = Name;
      _this1089.Specification = Specification;
      _this1089.UsageName = UsageName;
      _this1089.PropertyReference = PropertyReference;
      _this1089.type = 941946838;
      return _this1089;
    }

    return IfcPropertyReferenceValue;
  }(IfcSimpleProperty);

  IFC4_32.IfcPropertyReferenceValue = IfcPropertyReferenceValue;

  var IfcPropertySet = /*#__PURE__*/function (_IfcPropertySetDefini17) {
    _inherits(IfcPropertySet, _IfcPropertySetDefini17);

    var _super1098 = _createSuper(IfcPropertySet);

    function IfcPropertySet(expressID, GlobalId, OwnerHistory, Name, Description, HasProperties) {
      var _this1090;

      _classCallCheck2(this, IfcPropertySet);

      _this1090 = _super1098.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1090.GlobalId = GlobalId;
      _this1090.OwnerHistory = OwnerHistory;
      _this1090.Name = Name;
      _this1090.Description = Description;
      _this1090.HasProperties = HasProperties;
      _this1090.type = 1451395588;
      return _this1090;
    }

    return IfcPropertySet;
  }(IfcPropertySetDefinition);

  IFC4_32.IfcPropertySet = IfcPropertySet;

  var IfcPropertySetTemplate = /*#__PURE__*/function (_IfcPropertyTemplateD) {
    _inherits(IfcPropertySetTemplate, _IfcPropertyTemplateD);

    var _super1099 = _createSuper(IfcPropertySetTemplate);

    function IfcPropertySetTemplate(expressID, GlobalId, OwnerHistory, Name, Description, TemplateType, ApplicableEntity, HasPropertyTemplates) {
      var _this1091;

      _classCallCheck2(this, IfcPropertySetTemplate);

      _this1091 = _super1099.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1091.GlobalId = GlobalId;
      _this1091.OwnerHistory = OwnerHistory;
      _this1091.Name = Name;
      _this1091.Description = Description;
      _this1091.TemplateType = TemplateType;
      _this1091.ApplicableEntity = ApplicableEntity;
      _this1091.HasPropertyTemplates = HasPropertyTemplates;
      _this1091.type = 492091185;
      return _this1091;
    }

    return IfcPropertySetTemplate;
  }(IfcPropertyTemplateDefinition);

  IFC4_32.IfcPropertySetTemplate = IfcPropertySetTemplate;

  var IfcPropertySingleValue = /*#__PURE__*/function (_IfcSimpleProperty11) {
    _inherits(IfcPropertySingleValue, _IfcSimpleProperty11);

    var _super1100 = _createSuper(IfcPropertySingleValue);

    function IfcPropertySingleValue(expressID, Name, Specification, NominalValue, Unit) {
      var _this1092;

      _classCallCheck2(this, IfcPropertySingleValue);

      _this1092 = _super1100.call(this, expressID, Name, Specification);
      _this1092.Name = Name;
      _this1092.Specification = Specification;
      _this1092.NominalValue = NominalValue;
      _this1092.Unit = Unit;
      _this1092.type = 3650150729;
      return _this1092;
    }

    return IfcPropertySingleValue;
  }(IfcSimpleProperty);

  IFC4_32.IfcPropertySingleValue = IfcPropertySingleValue;

  var IfcPropertyTableValue = /*#__PURE__*/function (_IfcSimpleProperty12) {
    _inherits(IfcPropertyTableValue, _IfcSimpleProperty12);

    var _super1101 = _createSuper(IfcPropertyTableValue);

    function IfcPropertyTableValue(expressID, Name, Specification, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit, CurveInterpolation) {
      var _this1093;

      _classCallCheck2(this, IfcPropertyTableValue);

      _this1093 = _super1101.call(this, expressID, Name, Specification);
      _this1093.Name = Name;
      _this1093.Specification = Specification;
      _this1093.DefiningValues = DefiningValues;
      _this1093.DefinedValues = DefinedValues;
      _this1093.Expression = Expression;
      _this1093.DefiningUnit = DefiningUnit;
      _this1093.DefinedUnit = DefinedUnit;
      _this1093.CurveInterpolation = CurveInterpolation;
      _this1093.type = 110355661;
      return _this1093;
    }

    return IfcPropertyTableValue;
  }(IfcSimpleProperty);

  IFC4_32.IfcPropertyTableValue = IfcPropertyTableValue;

  var IfcPropertyTemplate = /*#__PURE__*/function (_IfcPropertyTemplateD2) {
    _inherits(IfcPropertyTemplate, _IfcPropertyTemplateD2);

    var _super1102 = _createSuper(IfcPropertyTemplate);

    function IfcPropertyTemplate(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1094;

      _classCallCheck2(this, IfcPropertyTemplate);

      _this1094 = _super1102.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1094.GlobalId = GlobalId;
      _this1094.OwnerHistory = OwnerHistory;
      _this1094.Name = Name;
      _this1094.Description = Description;
      _this1094.type = 3521284610;
      return _this1094;
    }

    return IfcPropertyTemplate;
  }(IfcPropertyTemplateDefinition);

  IFC4_32.IfcPropertyTemplate = IfcPropertyTemplate;

  var IfcRectangleHollowProfileDef = /*#__PURE__*/function (_IfcRectangleProfileD4) {
    _inherits(IfcRectangleHollowProfileDef, _IfcRectangleProfileD4);

    var _super1103 = _createSuper(IfcRectangleHollowProfileDef);

    function IfcRectangleHollowProfileDef(expressID, ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius) {
      var _this1095;

      _classCallCheck2(this, IfcRectangleHollowProfileDef);

      _this1095 = _super1103.call(this, expressID, ProfileType, ProfileName, Position, XDim, YDim);
      _this1095.ProfileType = ProfileType;
      _this1095.ProfileName = ProfileName;
      _this1095.Position = Position;
      _this1095.XDim = XDim;
      _this1095.YDim = YDim;
      _this1095.WallThickness = WallThickness;
      _this1095.InnerFilletRadius = InnerFilletRadius;
      _this1095.OuterFilletRadius = OuterFilletRadius;
      _this1095.type = 2770003689;
      return _this1095;
    }

    return IfcRectangleHollowProfileDef;
  }(IfcRectangleProfileDef);

  IFC4_32.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;

  var IfcRectangularPyramid = /*#__PURE__*/function (_IfcCsgPrimitive3D6) {
    _inherits(IfcRectangularPyramid, _IfcCsgPrimitive3D6);

    var _super1104 = _createSuper(IfcRectangularPyramid);

    function IfcRectangularPyramid(expressID, Position, XLength, YLength, Height) {
      var _this1096;

      _classCallCheck2(this, IfcRectangularPyramid);

      _this1096 = _super1104.call(this, expressID, Position);
      _this1096.Position = Position;
      _this1096.XLength = XLength;
      _this1096.YLength = YLength;
      _this1096.Height = Height;
      _this1096.type = 2798486643;
      return _this1096;
    }

    return IfcRectangularPyramid;
  }(IfcCsgPrimitive3D);

  IFC4_32.IfcRectangularPyramid = IfcRectangularPyramid;

  var IfcRectangularTrimmedSurface = /*#__PURE__*/function (_IfcBoundedSurface5) {
    _inherits(IfcRectangularTrimmedSurface, _IfcBoundedSurface5);

    var _super1105 = _createSuper(IfcRectangularTrimmedSurface);

    function IfcRectangularTrimmedSurface(expressID, BasisSurface, U1, V1, U2, V2, Usense, Vsense) {
      var _this1097;

      _classCallCheck2(this, IfcRectangularTrimmedSurface);

      _this1097 = _super1105.call(this, expressID);
      _this1097.BasisSurface = BasisSurface;
      _this1097.U1 = U1;
      _this1097.V1 = V1;
      _this1097.U2 = U2;
      _this1097.V2 = V2;
      _this1097.Usense = Usense;
      _this1097.Vsense = Vsense;
      _this1097.type = 3454111270;
      return _this1097;
    }

    return IfcRectangularTrimmedSurface;
  }(IfcBoundedSurface);

  IFC4_32.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;

  var IfcReinforcementDefinitionProperties = /*#__PURE__*/function (_IfcPreDefinedPropert4) {
    _inherits(IfcReinforcementDefinitionProperties, _IfcPreDefinedPropert4);

    var _super1106 = _createSuper(IfcReinforcementDefinitionProperties);

    function IfcReinforcementDefinitionProperties(expressID, GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions) {
      var _this1098;

      _classCallCheck2(this, IfcReinforcementDefinitionProperties);

      _this1098 = _super1106.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1098.GlobalId = GlobalId;
      _this1098.OwnerHistory = OwnerHistory;
      _this1098.Name = Name;
      _this1098.Description = Description;
      _this1098.DefinitionType = DefinitionType;
      _this1098.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
      _this1098.type = 3765753017;
      return _this1098;
    }

    return IfcReinforcementDefinitionProperties;
  }(IfcPreDefinedPropertySet);

  IFC4_32.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;

  var IfcRelAssigns = /*#__PURE__*/function (_IfcRelationship6) {
    _inherits(IfcRelAssigns, _IfcRelationship6);

    var _super1107 = _createSuper(IfcRelAssigns);

    function IfcRelAssigns(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType) {
      var _this1099;

      _classCallCheck2(this, IfcRelAssigns);

      _this1099 = _super1107.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1099.GlobalId = GlobalId;
      _this1099.OwnerHistory = OwnerHistory;
      _this1099.Name = Name;
      _this1099.Description = Description;
      _this1099.RelatedObjects = RelatedObjects;
      _this1099.RelatedObjectsType = RelatedObjectsType;
      _this1099.type = 3939117080;
      return _this1099;
    }

    return IfcRelAssigns;
  }(IfcRelationship);

  IFC4_32.IfcRelAssigns = IfcRelAssigns;

  var IfcRelAssignsToActor = /*#__PURE__*/function (_IfcRelAssigns7) {
    _inherits(IfcRelAssignsToActor, _IfcRelAssigns7);

    var _super1108 = _createSuper(IfcRelAssignsToActor);

    function IfcRelAssignsToActor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      var _this1100;

      _classCallCheck2(this, IfcRelAssignsToActor);

      _this1100 = _super1108.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1100.GlobalId = GlobalId;
      _this1100.OwnerHistory = OwnerHistory;
      _this1100.Name = Name;
      _this1100.Description = Description;
      _this1100.RelatedObjects = RelatedObjects;
      _this1100.RelatedObjectsType = RelatedObjectsType;
      _this1100.RelatingActor = RelatingActor;
      _this1100.ActingRole = ActingRole;
      _this1100.type = 1683148259;
      return _this1100;
    }

    return IfcRelAssignsToActor;
  }(IfcRelAssigns);

  IFC4_32.IfcRelAssignsToActor = IfcRelAssignsToActor;

  var IfcRelAssignsToControl = /*#__PURE__*/function (_IfcRelAssigns8) {
    _inherits(IfcRelAssignsToControl, _IfcRelAssigns8);

    var _super1109 = _createSuper(IfcRelAssignsToControl);

    function IfcRelAssignsToControl(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      var _this1101;

      _classCallCheck2(this, IfcRelAssignsToControl);

      _this1101 = _super1109.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1101.GlobalId = GlobalId;
      _this1101.OwnerHistory = OwnerHistory;
      _this1101.Name = Name;
      _this1101.Description = Description;
      _this1101.RelatedObjects = RelatedObjects;
      _this1101.RelatedObjectsType = RelatedObjectsType;
      _this1101.RelatingControl = RelatingControl;
      _this1101.type = 2495723537;
      return _this1101;
    }

    return IfcRelAssignsToControl;
  }(IfcRelAssigns);

  IFC4_32.IfcRelAssignsToControl = IfcRelAssignsToControl;

  var IfcRelAssignsToGroup = /*#__PURE__*/function (_IfcRelAssigns9) {
    _inherits(IfcRelAssignsToGroup, _IfcRelAssigns9);

    var _super1110 = _createSuper(IfcRelAssignsToGroup);

    function IfcRelAssignsToGroup(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup) {
      var _this1102;

      _classCallCheck2(this, IfcRelAssignsToGroup);

      _this1102 = _super1110.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1102.GlobalId = GlobalId;
      _this1102.OwnerHistory = OwnerHistory;
      _this1102.Name = Name;
      _this1102.Description = Description;
      _this1102.RelatedObjects = RelatedObjects;
      _this1102.RelatedObjectsType = RelatedObjectsType;
      _this1102.RelatingGroup = RelatingGroup;
      _this1102.type = 1307041759;
      return _this1102;
    }

    return IfcRelAssignsToGroup;
  }(IfcRelAssigns);

  IFC4_32.IfcRelAssignsToGroup = IfcRelAssignsToGroup;

  var IfcRelAssignsToGroupByFactor = /*#__PURE__*/function (_IfcRelAssignsToGroup) {
    _inherits(IfcRelAssignsToGroupByFactor, _IfcRelAssignsToGroup);

    var _super1111 = _createSuper(IfcRelAssignsToGroupByFactor);

    function IfcRelAssignsToGroupByFactor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup, Factor) {
      var _this1103;

      _classCallCheck2(this, IfcRelAssignsToGroupByFactor);

      _this1103 = _super1111.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup);
      _this1103.GlobalId = GlobalId;
      _this1103.OwnerHistory = OwnerHistory;
      _this1103.Name = Name;
      _this1103.Description = Description;
      _this1103.RelatedObjects = RelatedObjects;
      _this1103.RelatedObjectsType = RelatedObjectsType;
      _this1103.RelatingGroup = RelatingGroup;
      _this1103.Factor = Factor;
      _this1103.type = 1027710054;
      return _this1103;
    }

    return IfcRelAssignsToGroupByFactor;
  }(IfcRelAssignsToGroup);

  IFC4_32.IfcRelAssignsToGroupByFactor = IfcRelAssignsToGroupByFactor;

  var IfcRelAssignsToProcess = /*#__PURE__*/function (_IfcRelAssigns10) {
    _inherits(IfcRelAssignsToProcess, _IfcRelAssigns10);

    var _super1112 = _createSuper(IfcRelAssignsToProcess);

    function IfcRelAssignsToProcess(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess) {
      var _this1104;

      _classCallCheck2(this, IfcRelAssignsToProcess);

      _this1104 = _super1112.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1104.GlobalId = GlobalId;
      _this1104.OwnerHistory = OwnerHistory;
      _this1104.Name = Name;
      _this1104.Description = Description;
      _this1104.RelatedObjects = RelatedObjects;
      _this1104.RelatedObjectsType = RelatedObjectsType;
      _this1104.RelatingProcess = RelatingProcess;
      _this1104.QuantityInProcess = QuantityInProcess;
      _this1104.type = 4278684876;
      return _this1104;
    }

    return IfcRelAssignsToProcess;
  }(IfcRelAssigns);

  IFC4_32.IfcRelAssignsToProcess = IfcRelAssignsToProcess;

  var IfcRelAssignsToProduct = /*#__PURE__*/function (_IfcRelAssigns11) {
    _inherits(IfcRelAssignsToProduct, _IfcRelAssigns11);

    var _super1113 = _createSuper(IfcRelAssignsToProduct);

    function IfcRelAssignsToProduct(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct) {
      var _this1105;

      _classCallCheck2(this, IfcRelAssignsToProduct);

      _this1105 = _super1113.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1105.GlobalId = GlobalId;
      _this1105.OwnerHistory = OwnerHistory;
      _this1105.Name = Name;
      _this1105.Description = Description;
      _this1105.RelatedObjects = RelatedObjects;
      _this1105.RelatedObjectsType = RelatedObjectsType;
      _this1105.RelatingProduct = RelatingProduct;
      _this1105.type = 2857406711;
      return _this1105;
    }

    return IfcRelAssignsToProduct;
  }(IfcRelAssigns);

  IFC4_32.IfcRelAssignsToProduct = IfcRelAssignsToProduct;

  var IfcRelAssignsToResource = /*#__PURE__*/function (_IfcRelAssigns12) {
    _inherits(IfcRelAssignsToResource, _IfcRelAssigns12);

    var _super1114 = _createSuper(IfcRelAssignsToResource);

    function IfcRelAssignsToResource(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource) {
      var _this1106;

      _classCallCheck2(this, IfcRelAssignsToResource);

      _this1106 = _super1114.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1106.GlobalId = GlobalId;
      _this1106.OwnerHistory = OwnerHistory;
      _this1106.Name = Name;
      _this1106.Description = Description;
      _this1106.RelatedObjects = RelatedObjects;
      _this1106.RelatedObjectsType = RelatedObjectsType;
      _this1106.RelatingResource = RelatingResource;
      _this1106.type = 205026976;
      return _this1106;
    }

    return IfcRelAssignsToResource;
  }(IfcRelAssigns);

  IFC4_32.IfcRelAssignsToResource = IfcRelAssignsToResource;

  var IfcRelAssociates = /*#__PURE__*/function (_IfcRelationship7) {
    _inherits(IfcRelAssociates, _IfcRelationship7);

    var _super1115 = _createSuper(IfcRelAssociates);

    function IfcRelAssociates(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      var _this1107;

      _classCallCheck2(this, IfcRelAssociates);

      _this1107 = _super1115.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1107.GlobalId = GlobalId;
      _this1107.OwnerHistory = OwnerHistory;
      _this1107.Name = Name;
      _this1107.Description = Description;
      _this1107.RelatedObjects = RelatedObjects;
      _this1107.type = 1865459582;
      return _this1107;
    }

    return IfcRelAssociates;
  }(IfcRelationship);

  IFC4_32.IfcRelAssociates = IfcRelAssociates;

  var IfcRelAssociatesApproval = /*#__PURE__*/function (_IfcRelAssociates9) {
    _inherits(IfcRelAssociatesApproval, _IfcRelAssociates9);

    var _super1116 = _createSuper(IfcRelAssociatesApproval);

    function IfcRelAssociatesApproval(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval) {
      var _this1108;

      _classCallCheck2(this, IfcRelAssociatesApproval);

      _this1108 = _super1116.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1108.GlobalId = GlobalId;
      _this1108.OwnerHistory = OwnerHistory;
      _this1108.Name = Name;
      _this1108.Description = Description;
      _this1108.RelatedObjects = RelatedObjects;
      _this1108.RelatingApproval = RelatingApproval;
      _this1108.type = 4095574036;
      return _this1108;
    }

    return IfcRelAssociatesApproval;
  }(IfcRelAssociates);

  IFC4_32.IfcRelAssociatesApproval = IfcRelAssociatesApproval;

  var IfcRelAssociatesClassification = /*#__PURE__*/function (_IfcRelAssociates10) {
    _inherits(IfcRelAssociatesClassification, _IfcRelAssociates10);

    var _super1117 = _createSuper(IfcRelAssociatesClassification);

    function IfcRelAssociatesClassification(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification) {
      var _this1109;

      _classCallCheck2(this, IfcRelAssociatesClassification);

      _this1109 = _super1117.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1109.GlobalId = GlobalId;
      _this1109.OwnerHistory = OwnerHistory;
      _this1109.Name = Name;
      _this1109.Description = Description;
      _this1109.RelatedObjects = RelatedObjects;
      _this1109.RelatingClassification = RelatingClassification;
      _this1109.type = 919958153;
      return _this1109;
    }

    return IfcRelAssociatesClassification;
  }(IfcRelAssociates);

  IFC4_32.IfcRelAssociatesClassification = IfcRelAssociatesClassification;

  var IfcRelAssociatesConstraint = /*#__PURE__*/function (_IfcRelAssociates11) {
    _inherits(IfcRelAssociatesConstraint, _IfcRelAssociates11);

    var _super1118 = _createSuper(IfcRelAssociatesConstraint);

    function IfcRelAssociatesConstraint(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint) {
      var _this1110;

      _classCallCheck2(this, IfcRelAssociatesConstraint);

      _this1110 = _super1118.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1110.GlobalId = GlobalId;
      _this1110.OwnerHistory = OwnerHistory;
      _this1110.Name = Name;
      _this1110.Description = Description;
      _this1110.RelatedObjects = RelatedObjects;
      _this1110.Intent = Intent;
      _this1110.RelatingConstraint = RelatingConstraint;
      _this1110.type = 2728634034;
      return _this1110;
    }

    return IfcRelAssociatesConstraint;
  }(IfcRelAssociates);

  IFC4_32.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;

  var IfcRelAssociatesDocument = /*#__PURE__*/function (_IfcRelAssociates12) {
    _inherits(IfcRelAssociatesDocument, _IfcRelAssociates12);

    var _super1119 = _createSuper(IfcRelAssociatesDocument);

    function IfcRelAssociatesDocument(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument) {
      var _this1111;

      _classCallCheck2(this, IfcRelAssociatesDocument);

      _this1111 = _super1119.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1111.GlobalId = GlobalId;
      _this1111.OwnerHistory = OwnerHistory;
      _this1111.Name = Name;
      _this1111.Description = Description;
      _this1111.RelatedObjects = RelatedObjects;
      _this1111.RelatingDocument = RelatingDocument;
      _this1111.type = 982818633;
      return _this1111;
    }

    return IfcRelAssociatesDocument;
  }(IfcRelAssociates);

  IFC4_32.IfcRelAssociatesDocument = IfcRelAssociatesDocument;

  var IfcRelAssociatesLibrary = /*#__PURE__*/function (_IfcRelAssociates13) {
    _inherits(IfcRelAssociatesLibrary, _IfcRelAssociates13);

    var _super1120 = _createSuper(IfcRelAssociatesLibrary);

    function IfcRelAssociatesLibrary(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary) {
      var _this1112;

      _classCallCheck2(this, IfcRelAssociatesLibrary);

      _this1112 = _super1120.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1112.GlobalId = GlobalId;
      _this1112.OwnerHistory = OwnerHistory;
      _this1112.Name = Name;
      _this1112.Description = Description;
      _this1112.RelatedObjects = RelatedObjects;
      _this1112.RelatingLibrary = RelatingLibrary;
      _this1112.type = 3840914261;
      return _this1112;
    }

    return IfcRelAssociatesLibrary;
  }(IfcRelAssociates);

  IFC4_32.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;

  var IfcRelAssociatesMaterial = /*#__PURE__*/function (_IfcRelAssociates14) {
    _inherits(IfcRelAssociatesMaterial, _IfcRelAssociates14);

    var _super1121 = _createSuper(IfcRelAssociatesMaterial);

    function IfcRelAssociatesMaterial(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial) {
      var _this1113;

      _classCallCheck2(this, IfcRelAssociatesMaterial);

      _this1113 = _super1121.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1113.GlobalId = GlobalId;
      _this1113.OwnerHistory = OwnerHistory;
      _this1113.Name = Name;
      _this1113.Description = Description;
      _this1113.RelatedObjects = RelatedObjects;
      _this1113.RelatingMaterial = RelatingMaterial;
      _this1113.type = 2655215786;
      return _this1113;
    }

    return IfcRelAssociatesMaterial;
  }(IfcRelAssociates);

  IFC4_32.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;

  var IfcRelAssociatesProfileDef = /*#__PURE__*/function (_IfcRelAssociates15) {
    _inherits(IfcRelAssociatesProfileDef, _IfcRelAssociates15);

    var _super1122 = _createSuper(IfcRelAssociatesProfileDef);

    function IfcRelAssociatesProfileDef(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingProfileDef) {
      var _this1114;

      _classCallCheck2(this, IfcRelAssociatesProfileDef);

      _this1114 = _super1122.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1114.GlobalId = GlobalId;
      _this1114.OwnerHistory = OwnerHistory;
      _this1114.Name = Name;
      _this1114.Description = Description;
      _this1114.RelatedObjects = RelatedObjects;
      _this1114.RelatingProfileDef = RelatingProfileDef;
      _this1114.type = 1033248425;
      return _this1114;
    }

    return IfcRelAssociatesProfileDef;
  }(IfcRelAssociates);

  IFC4_32.IfcRelAssociatesProfileDef = IfcRelAssociatesProfileDef;

  var IfcRelConnects = /*#__PURE__*/function (_IfcRelationship8) {
    _inherits(IfcRelConnects, _IfcRelationship8);

    var _super1123 = _createSuper(IfcRelConnects);

    function IfcRelConnects(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1115;

      _classCallCheck2(this, IfcRelConnects);

      _this1115 = _super1123.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1115.GlobalId = GlobalId;
      _this1115.OwnerHistory = OwnerHistory;
      _this1115.Name = Name;
      _this1115.Description = Description;
      _this1115.type = 826625072;
      return _this1115;
    }

    return IfcRelConnects;
  }(IfcRelationship);

  IFC4_32.IfcRelConnects = IfcRelConnects;

  var IfcRelConnectsElements = /*#__PURE__*/function (_IfcRelConnects19) {
    _inherits(IfcRelConnectsElements, _IfcRelConnects19);

    var _super1124 = _createSuper(IfcRelConnectsElements);

    function IfcRelConnectsElements(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement) {
      var _this1116;

      _classCallCheck2(this, IfcRelConnectsElements);

      _this1116 = _super1124.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1116.GlobalId = GlobalId;
      _this1116.OwnerHistory = OwnerHistory;
      _this1116.Name = Name;
      _this1116.Description = Description;
      _this1116.ConnectionGeometry = ConnectionGeometry;
      _this1116.RelatingElement = RelatingElement;
      _this1116.RelatedElement = RelatedElement;
      _this1116.type = 1204542856;
      return _this1116;
    }

    return IfcRelConnectsElements;
  }(IfcRelConnects);

  IFC4_32.IfcRelConnectsElements = IfcRelConnectsElements;

  var IfcRelConnectsPathElements = /*#__PURE__*/function (_IfcRelConnectsElemen3) {
    _inherits(IfcRelConnectsPathElements, _IfcRelConnectsElemen3);

    var _super1125 = _createSuper(IfcRelConnectsPathElements);

    function IfcRelConnectsPathElements(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType) {
      var _this1117;

      _classCallCheck2(this, IfcRelConnectsPathElements);

      _this1117 = _super1125.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      _this1117.GlobalId = GlobalId;
      _this1117.OwnerHistory = OwnerHistory;
      _this1117.Name = Name;
      _this1117.Description = Description;
      _this1117.ConnectionGeometry = ConnectionGeometry;
      _this1117.RelatingElement = RelatingElement;
      _this1117.RelatedElement = RelatedElement;
      _this1117.RelatingPriorities = RelatingPriorities;
      _this1117.RelatedPriorities = RelatedPriorities;
      _this1117.RelatedConnectionType = RelatedConnectionType;
      _this1117.RelatingConnectionType = RelatingConnectionType;
      _this1117.type = 3945020480;
      return _this1117;
    }

    return IfcRelConnectsPathElements;
  }(IfcRelConnectsElements);

  IFC4_32.IfcRelConnectsPathElements = IfcRelConnectsPathElements;

  var IfcRelConnectsPortToElement = /*#__PURE__*/function (_IfcRelConnects20) {
    _inherits(IfcRelConnectsPortToElement, _IfcRelConnects20);

    var _super1126 = _createSuper(IfcRelConnectsPortToElement);

    function IfcRelConnectsPortToElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement) {
      var _this1118;

      _classCallCheck2(this, IfcRelConnectsPortToElement);

      _this1118 = _super1126.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1118.GlobalId = GlobalId;
      _this1118.OwnerHistory = OwnerHistory;
      _this1118.Name = Name;
      _this1118.Description = Description;
      _this1118.RelatingPort = RelatingPort;
      _this1118.RelatedElement = RelatedElement;
      _this1118.type = 4201705270;
      return _this1118;
    }

    return IfcRelConnectsPortToElement;
  }(IfcRelConnects);

  IFC4_32.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;

  var IfcRelConnectsPorts = /*#__PURE__*/function (_IfcRelConnects21) {
    _inherits(IfcRelConnectsPorts, _IfcRelConnects21);

    var _super1127 = _createSuper(IfcRelConnectsPorts);

    function IfcRelConnectsPorts(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement) {
      var _this1119;

      _classCallCheck2(this, IfcRelConnectsPorts);

      _this1119 = _super1127.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1119.GlobalId = GlobalId;
      _this1119.OwnerHistory = OwnerHistory;
      _this1119.Name = Name;
      _this1119.Description = Description;
      _this1119.RelatingPort = RelatingPort;
      _this1119.RelatedPort = RelatedPort;
      _this1119.RealizingElement = RealizingElement;
      _this1119.type = 3190031847;
      return _this1119;
    }

    return IfcRelConnectsPorts;
  }(IfcRelConnects);

  IFC4_32.IfcRelConnectsPorts = IfcRelConnectsPorts;

  var IfcRelConnectsStructuralActivity = /*#__PURE__*/function (_IfcRelConnects22) {
    _inherits(IfcRelConnectsStructuralActivity, _IfcRelConnects22);

    var _super1128 = _createSuper(IfcRelConnectsStructuralActivity);

    function IfcRelConnectsStructuralActivity(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity) {
      var _this1120;

      _classCallCheck2(this, IfcRelConnectsStructuralActivity);

      _this1120 = _super1128.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1120.GlobalId = GlobalId;
      _this1120.OwnerHistory = OwnerHistory;
      _this1120.Name = Name;
      _this1120.Description = Description;
      _this1120.RelatingElement = RelatingElement;
      _this1120.RelatedStructuralActivity = RelatedStructuralActivity;
      _this1120.type = 2127690289;
      return _this1120;
    }

    return IfcRelConnectsStructuralActivity;
  }(IfcRelConnects);

  IFC4_32.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;

  var IfcRelConnectsStructuralMember = /*#__PURE__*/function (_IfcRelConnects23) {
    _inherits(IfcRelConnectsStructuralMember, _IfcRelConnects23);

    var _super1129 = _createSuper(IfcRelConnectsStructuralMember);

    function IfcRelConnectsStructuralMember(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem) {
      var _this1121;

      _classCallCheck2(this, IfcRelConnectsStructuralMember);

      _this1121 = _super1129.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1121.GlobalId = GlobalId;
      _this1121.OwnerHistory = OwnerHistory;
      _this1121.Name = Name;
      _this1121.Description = Description;
      _this1121.RelatingStructuralMember = RelatingStructuralMember;
      _this1121.RelatedStructuralConnection = RelatedStructuralConnection;
      _this1121.AppliedCondition = AppliedCondition;
      _this1121.AdditionalConditions = AdditionalConditions;
      _this1121.SupportedLength = SupportedLength;
      _this1121.ConditionCoordinateSystem = ConditionCoordinateSystem;
      _this1121.type = 1638771189;
      return _this1121;
    }

    return IfcRelConnectsStructuralMember;
  }(IfcRelConnects);

  IFC4_32.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;

  var IfcRelConnectsWithEccentricity = /*#__PURE__*/function (_IfcRelConnectsStruct2) {
    _inherits(IfcRelConnectsWithEccentricity, _IfcRelConnectsStruct2);

    var _super1130 = _createSuper(IfcRelConnectsWithEccentricity);

    function IfcRelConnectsWithEccentricity(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint) {
      var _this1122;

      _classCallCheck2(this, IfcRelConnectsWithEccentricity);

      _this1122 = _super1130.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
      _this1122.GlobalId = GlobalId;
      _this1122.OwnerHistory = OwnerHistory;
      _this1122.Name = Name;
      _this1122.Description = Description;
      _this1122.RelatingStructuralMember = RelatingStructuralMember;
      _this1122.RelatedStructuralConnection = RelatedStructuralConnection;
      _this1122.AppliedCondition = AppliedCondition;
      _this1122.AdditionalConditions = AdditionalConditions;
      _this1122.SupportedLength = SupportedLength;
      _this1122.ConditionCoordinateSystem = ConditionCoordinateSystem;
      _this1122.ConnectionConstraint = ConnectionConstraint;
      _this1122.type = 504942748;
      return _this1122;
    }

    return IfcRelConnectsWithEccentricity;
  }(IfcRelConnectsStructuralMember);

  IFC4_32.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;

  var IfcRelConnectsWithRealizingElements = /*#__PURE__*/function (_IfcRelConnectsElemen4) {
    _inherits(IfcRelConnectsWithRealizingElements, _IfcRelConnectsElemen4);

    var _super1131 = _createSuper(IfcRelConnectsWithRealizingElements);

    function IfcRelConnectsWithRealizingElements(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType) {
      var _this1123;

      _classCallCheck2(this, IfcRelConnectsWithRealizingElements);

      _this1123 = _super1131.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      _this1123.GlobalId = GlobalId;
      _this1123.OwnerHistory = OwnerHistory;
      _this1123.Name = Name;
      _this1123.Description = Description;
      _this1123.ConnectionGeometry = ConnectionGeometry;
      _this1123.RelatingElement = RelatingElement;
      _this1123.RelatedElement = RelatedElement;
      _this1123.RealizingElements = RealizingElements;
      _this1123.ConnectionType = ConnectionType;
      _this1123.type = 3678494232;
      return _this1123;
    }

    return IfcRelConnectsWithRealizingElements;
  }(IfcRelConnectsElements);

  IFC4_32.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;

  var IfcRelContainedInSpatialStructure = /*#__PURE__*/function (_IfcRelConnects24) {
    _inherits(IfcRelContainedInSpatialStructure, _IfcRelConnects24);

    var _super1132 = _createSuper(IfcRelContainedInSpatialStructure);

    function IfcRelContainedInSpatialStructure(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      var _this1124;

      _classCallCheck2(this, IfcRelContainedInSpatialStructure);

      _this1124 = _super1132.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1124.GlobalId = GlobalId;
      _this1124.OwnerHistory = OwnerHistory;
      _this1124.Name = Name;
      _this1124.Description = Description;
      _this1124.RelatedElements = RelatedElements;
      _this1124.RelatingStructure = RelatingStructure;
      _this1124.type = 3242617779;
      return _this1124;
    }

    return IfcRelContainedInSpatialStructure;
  }(IfcRelConnects);

  IFC4_32.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;

  var IfcRelCoversBldgElements = /*#__PURE__*/function (_IfcRelConnects25) {
    _inherits(IfcRelCoversBldgElements, _IfcRelConnects25);

    var _super1133 = _createSuper(IfcRelCoversBldgElements);

    function IfcRelCoversBldgElements(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings) {
      var _this1125;

      _classCallCheck2(this, IfcRelCoversBldgElements);

      _this1125 = _super1133.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1125.GlobalId = GlobalId;
      _this1125.OwnerHistory = OwnerHistory;
      _this1125.Name = Name;
      _this1125.Description = Description;
      _this1125.RelatingBuildingElement = RelatingBuildingElement;
      _this1125.RelatedCoverings = RelatedCoverings;
      _this1125.type = 886880790;
      return _this1125;
    }

    return IfcRelCoversBldgElements;
  }(IfcRelConnects);

  IFC4_32.IfcRelCoversBldgElements = IfcRelCoversBldgElements;

  var IfcRelCoversSpaces = /*#__PURE__*/function (_IfcRelConnects26) {
    _inherits(IfcRelCoversSpaces, _IfcRelConnects26);

    var _super1134 = _createSuper(IfcRelCoversSpaces);

    function IfcRelCoversSpaces(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedCoverings) {
      var _this1126;

      _classCallCheck2(this, IfcRelCoversSpaces);

      _this1126 = _super1134.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1126.GlobalId = GlobalId;
      _this1126.OwnerHistory = OwnerHistory;
      _this1126.Name = Name;
      _this1126.Description = Description;
      _this1126.RelatingSpace = RelatingSpace;
      _this1126.RelatedCoverings = RelatedCoverings;
      _this1126.type = 2802773753;
      return _this1126;
    }

    return IfcRelCoversSpaces;
  }(IfcRelConnects);

  IFC4_32.IfcRelCoversSpaces = IfcRelCoversSpaces;

  var IfcRelDeclares = /*#__PURE__*/function (_IfcRelationship9) {
    _inherits(IfcRelDeclares, _IfcRelationship9);

    var _super1135 = _createSuper(IfcRelDeclares);

    function IfcRelDeclares(expressID, GlobalId, OwnerHistory, Name, Description, RelatingContext, RelatedDefinitions) {
      var _this1127;

      _classCallCheck2(this, IfcRelDeclares);

      _this1127 = _super1135.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1127.GlobalId = GlobalId;
      _this1127.OwnerHistory = OwnerHistory;
      _this1127.Name = Name;
      _this1127.Description = Description;
      _this1127.RelatingContext = RelatingContext;
      _this1127.RelatedDefinitions = RelatedDefinitions;
      _this1127.type = 2565941209;
      return _this1127;
    }

    return IfcRelDeclares;
  }(IfcRelationship);

  IFC4_32.IfcRelDeclares = IfcRelDeclares;

  var IfcRelDecomposes = /*#__PURE__*/function (_IfcRelationship10) {
    _inherits(IfcRelDecomposes, _IfcRelationship10);

    var _super1136 = _createSuper(IfcRelDecomposes);

    function IfcRelDecomposes(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1128;

      _classCallCheck2(this, IfcRelDecomposes);

      _this1128 = _super1136.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1128.GlobalId = GlobalId;
      _this1128.OwnerHistory = OwnerHistory;
      _this1128.Name = Name;
      _this1128.Description = Description;
      _this1128.type = 2551354335;
      return _this1128;
    }

    return IfcRelDecomposes;
  }(IfcRelationship);

  IFC4_32.IfcRelDecomposes = IfcRelDecomposes;

  var IfcRelDefines = /*#__PURE__*/function (_IfcRelationship11) {
    _inherits(IfcRelDefines, _IfcRelationship11);

    var _super1137 = _createSuper(IfcRelDefines);

    function IfcRelDefines(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1129;

      _classCallCheck2(this, IfcRelDefines);

      _this1129 = _super1137.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1129.GlobalId = GlobalId;
      _this1129.OwnerHistory = OwnerHistory;
      _this1129.Name = Name;
      _this1129.Description = Description;
      _this1129.type = 693640335;
      return _this1129;
    }

    return IfcRelDefines;
  }(IfcRelationship);

  IFC4_32.IfcRelDefines = IfcRelDefines;

  var IfcRelDefinesByObject = /*#__PURE__*/function (_IfcRelDefines3) {
    _inherits(IfcRelDefinesByObject, _IfcRelDefines3);

    var _super1138 = _createSuper(IfcRelDefinesByObject);

    function IfcRelDefinesByObject(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingObject) {
      var _this1130;

      _classCallCheck2(this, IfcRelDefinesByObject);

      _this1130 = _super1138.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1130.GlobalId = GlobalId;
      _this1130.OwnerHistory = OwnerHistory;
      _this1130.Name = Name;
      _this1130.Description = Description;
      _this1130.RelatedObjects = RelatedObjects;
      _this1130.RelatingObject = RelatingObject;
      _this1130.type = 1462361463;
      return _this1130;
    }

    return IfcRelDefinesByObject;
  }(IfcRelDefines);

  IFC4_32.IfcRelDefinesByObject = IfcRelDefinesByObject;

  var IfcRelDefinesByProperties = /*#__PURE__*/function (_IfcRelDefines4) {
    _inherits(IfcRelDefinesByProperties, _IfcRelDefines4);

    var _super1139 = _createSuper(IfcRelDefinesByProperties);

    function IfcRelDefinesByProperties(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition) {
      var _this1131;

      _classCallCheck2(this, IfcRelDefinesByProperties);

      _this1131 = _super1139.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1131.GlobalId = GlobalId;
      _this1131.OwnerHistory = OwnerHistory;
      _this1131.Name = Name;
      _this1131.Description = Description;
      _this1131.RelatedObjects = RelatedObjects;
      _this1131.RelatingPropertyDefinition = RelatingPropertyDefinition;
      _this1131.type = 4186316022;
      return _this1131;
    }

    return IfcRelDefinesByProperties;
  }(IfcRelDefines);

  IFC4_32.IfcRelDefinesByProperties = IfcRelDefinesByProperties;

  var IfcRelDefinesByTemplate = /*#__PURE__*/function (_IfcRelDefines5) {
    _inherits(IfcRelDefinesByTemplate, _IfcRelDefines5);

    var _super1140 = _createSuper(IfcRelDefinesByTemplate);

    function IfcRelDefinesByTemplate(expressID, GlobalId, OwnerHistory, Name, Description, RelatedPropertySets, RelatingTemplate) {
      var _this1132;

      _classCallCheck2(this, IfcRelDefinesByTemplate);

      _this1132 = _super1140.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1132.GlobalId = GlobalId;
      _this1132.OwnerHistory = OwnerHistory;
      _this1132.Name = Name;
      _this1132.Description = Description;
      _this1132.RelatedPropertySets = RelatedPropertySets;
      _this1132.RelatingTemplate = RelatingTemplate;
      _this1132.type = 307848117;
      return _this1132;
    }

    return IfcRelDefinesByTemplate;
  }(IfcRelDefines);

  IFC4_32.IfcRelDefinesByTemplate = IfcRelDefinesByTemplate;

  var IfcRelDefinesByType = /*#__PURE__*/function (_IfcRelDefines6) {
    _inherits(IfcRelDefinesByType, _IfcRelDefines6);

    var _super1141 = _createSuper(IfcRelDefinesByType);

    function IfcRelDefinesByType(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType) {
      var _this1133;

      _classCallCheck2(this, IfcRelDefinesByType);

      _this1133 = _super1141.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1133.GlobalId = GlobalId;
      _this1133.OwnerHistory = OwnerHistory;
      _this1133.Name = Name;
      _this1133.Description = Description;
      _this1133.RelatedObjects = RelatedObjects;
      _this1133.RelatingType = RelatingType;
      _this1133.type = 781010003;
      return _this1133;
    }

    return IfcRelDefinesByType;
  }(IfcRelDefines);

  IFC4_32.IfcRelDefinesByType = IfcRelDefinesByType;

  var IfcRelFillsElement = /*#__PURE__*/function (_IfcRelConnects27) {
    _inherits(IfcRelFillsElement, _IfcRelConnects27);

    var _super1142 = _createSuper(IfcRelFillsElement);

    function IfcRelFillsElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement) {
      var _this1134;

      _classCallCheck2(this, IfcRelFillsElement);

      _this1134 = _super1142.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1134.GlobalId = GlobalId;
      _this1134.OwnerHistory = OwnerHistory;
      _this1134.Name = Name;
      _this1134.Description = Description;
      _this1134.RelatingOpeningElement = RelatingOpeningElement;
      _this1134.RelatedBuildingElement = RelatedBuildingElement;
      _this1134.type = 3940055652;
      return _this1134;
    }

    return IfcRelFillsElement;
  }(IfcRelConnects);

  IFC4_32.IfcRelFillsElement = IfcRelFillsElement;

  var IfcRelFlowControlElements = /*#__PURE__*/function (_IfcRelConnects28) {
    _inherits(IfcRelFlowControlElements, _IfcRelConnects28);

    var _super1143 = _createSuper(IfcRelFlowControlElements);

    function IfcRelFlowControlElements(expressID, GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement) {
      var _this1135;

      _classCallCheck2(this, IfcRelFlowControlElements);

      _this1135 = _super1143.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1135.GlobalId = GlobalId;
      _this1135.OwnerHistory = OwnerHistory;
      _this1135.Name = Name;
      _this1135.Description = Description;
      _this1135.RelatedControlElements = RelatedControlElements;
      _this1135.RelatingFlowElement = RelatingFlowElement;
      _this1135.type = 279856033;
      return _this1135;
    }

    return IfcRelFlowControlElements;
  }(IfcRelConnects);

  IFC4_32.IfcRelFlowControlElements = IfcRelFlowControlElements;

  var IfcRelInterferesElements = /*#__PURE__*/function (_IfcRelConnects29) {
    _inherits(IfcRelInterferesElements, _IfcRelConnects29);

    var _super1144 = _createSuper(IfcRelInterferesElements);

    function IfcRelInterferesElements(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedElement, InterferenceGeometry, InterferenceSpace, InterferenceType, ImpliedOrder) {
      var _this1136;

      _classCallCheck2(this, IfcRelInterferesElements);

      _this1136 = _super1144.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1136.GlobalId = GlobalId;
      _this1136.OwnerHistory = OwnerHistory;
      _this1136.Name = Name;
      _this1136.Description = Description;
      _this1136.RelatingElement = RelatingElement;
      _this1136.RelatedElement = RelatedElement;
      _this1136.InterferenceGeometry = InterferenceGeometry;
      _this1136.InterferenceSpace = InterferenceSpace;
      _this1136.InterferenceType = InterferenceType;
      _this1136.ImpliedOrder = ImpliedOrder;
      _this1136.type = 427948657;
      return _this1136;
    }

    return IfcRelInterferesElements;
  }(IfcRelConnects);

  IFC4_32.IfcRelInterferesElements = IfcRelInterferesElements;

  var IfcRelNests = /*#__PURE__*/function (_IfcRelDecomposes3) {
    _inherits(IfcRelNests, _IfcRelDecomposes3);

    var _super1145 = _createSuper(IfcRelNests);

    function IfcRelNests(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      var _this1137;

      _classCallCheck2(this, IfcRelNests);

      _this1137 = _super1145.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1137.GlobalId = GlobalId;
      _this1137.OwnerHistory = OwnerHistory;
      _this1137.Name = Name;
      _this1137.Description = Description;
      _this1137.RelatingObject = RelatingObject;
      _this1137.RelatedObjects = RelatedObjects;
      _this1137.type = 3268803585;
      return _this1137;
    }

    return IfcRelNests;
  }(IfcRelDecomposes);

  IFC4_32.IfcRelNests = IfcRelNests;

  var IfcRelPositions = /*#__PURE__*/function (_IfcRelConnects30) {
    _inherits(IfcRelPositions, _IfcRelConnects30);

    var _super1146 = _createSuper(IfcRelPositions);

    function IfcRelPositions(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPositioningElement, RelatedProducts) {
      var _this1138;

      _classCallCheck2(this, IfcRelPositions);

      _this1138 = _super1146.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1138.GlobalId = GlobalId;
      _this1138.OwnerHistory = OwnerHistory;
      _this1138.Name = Name;
      _this1138.Description = Description;
      _this1138.RelatingPositioningElement = RelatingPositioningElement;
      _this1138.RelatedProducts = RelatedProducts;
      _this1138.type = 1441486842;
      return _this1138;
    }

    return IfcRelPositions;
  }(IfcRelConnects);

  IFC4_32.IfcRelPositions = IfcRelPositions;

  var IfcRelProjectsElement = /*#__PURE__*/function (_IfcRelDecomposes4) {
    _inherits(IfcRelProjectsElement, _IfcRelDecomposes4);

    var _super1147 = _createSuper(IfcRelProjectsElement);

    function IfcRelProjectsElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement) {
      var _this1139;

      _classCallCheck2(this, IfcRelProjectsElement);

      _this1139 = _super1147.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1139.GlobalId = GlobalId;
      _this1139.OwnerHistory = OwnerHistory;
      _this1139.Name = Name;
      _this1139.Description = Description;
      _this1139.RelatingElement = RelatingElement;
      _this1139.RelatedFeatureElement = RelatedFeatureElement;
      _this1139.type = 750771296;
      return _this1139;
    }

    return IfcRelProjectsElement;
  }(IfcRelDecomposes);

  IFC4_32.IfcRelProjectsElement = IfcRelProjectsElement;

  var IfcRelReferencedInSpatialStructure = /*#__PURE__*/function (_IfcRelConnects31) {
    _inherits(IfcRelReferencedInSpatialStructure, _IfcRelConnects31);

    var _super1148 = _createSuper(IfcRelReferencedInSpatialStructure);

    function IfcRelReferencedInSpatialStructure(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      var _this1140;

      _classCallCheck2(this, IfcRelReferencedInSpatialStructure);

      _this1140 = _super1148.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1140.GlobalId = GlobalId;
      _this1140.OwnerHistory = OwnerHistory;
      _this1140.Name = Name;
      _this1140.Description = Description;
      _this1140.RelatedElements = RelatedElements;
      _this1140.RelatingStructure = RelatingStructure;
      _this1140.type = 1245217292;
      return _this1140;
    }

    return IfcRelReferencedInSpatialStructure;
  }(IfcRelConnects);

  IFC4_32.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;

  var IfcRelSequence = /*#__PURE__*/function (_IfcRelConnects32) {
    _inherits(IfcRelSequence, _IfcRelConnects32);

    var _super1149 = _createSuper(IfcRelSequence);

    function IfcRelSequence(expressID, GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType, UserDefinedSequenceType) {
      var _this1141;

      _classCallCheck2(this, IfcRelSequence);

      _this1141 = _super1149.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1141.GlobalId = GlobalId;
      _this1141.OwnerHistory = OwnerHistory;
      _this1141.Name = Name;
      _this1141.Description = Description;
      _this1141.RelatingProcess = RelatingProcess;
      _this1141.RelatedProcess = RelatedProcess;
      _this1141.TimeLag = TimeLag;
      _this1141.SequenceType = SequenceType;
      _this1141.UserDefinedSequenceType = UserDefinedSequenceType;
      _this1141.type = 4122056220;
      return _this1141;
    }

    return IfcRelSequence;
  }(IfcRelConnects);

  IFC4_32.IfcRelSequence = IfcRelSequence;

  var IfcRelServicesBuildings = /*#__PURE__*/function (_IfcRelConnects33) {
    _inherits(IfcRelServicesBuildings, _IfcRelConnects33);

    var _super1150 = _createSuper(IfcRelServicesBuildings);

    function IfcRelServicesBuildings(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings) {
      var _this1142;

      _classCallCheck2(this, IfcRelServicesBuildings);

      _this1142 = _super1150.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1142.GlobalId = GlobalId;
      _this1142.OwnerHistory = OwnerHistory;
      _this1142.Name = Name;
      _this1142.Description = Description;
      _this1142.RelatingSystem = RelatingSystem;
      _this1142.RelatedBuildings = RelatedBuildings;
      _this1142.type = 366585022;
      return _this1142;
    }

    return IfcRelServicesBuildings;
  }(IfcRelConnects);

  IFC4_32.IfcRelServicesBuildings = IfcRelServicesBuildings;

  var IfcRelSpaceBoundary = /*#__PURE__*/function (_IfcRelConnects34) {
    _inherits(IfcRelSpaceBoundary, _IfcRelConnects34);

    var _super1151 = _createSuper(IfcRelSpaceBoundary);

    function IfcRelSpaceBoundary(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary) {
      var _this1143;

      _classCallCheck2(this, IfcRelSpaceBoundary);

      _this1143 = _super1151.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1143.GlobalId = GlobalId;
      _this1143.OwnerHistory = OwnerHistory;
      _this1143.Name = Name;
      _this1143.Description = Description;
      _this1143.RelatingSpace = RelatingSpace;
      _this1143.RelatedBuildingElement = RelatedBuildingElement;
      _this1143.ConnectionGeometry = ConnectionGeometry;
      _this1143.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      _this1143.InternalOrExternalBoundary = InternalOrExternalBoundary;
      _this1143.type = 3451746338;
      return _this1143;
    }

    return IfcRelSpaceBoundary;
  }(IfcRelConnects);

  IFC4_32.IfcRelSpaceBoundary = IfcRelSpaceBoundary;

  var IfcRelSpaceBoundary1stLevel = /*#__PURE__*/function (_IfcRelSpaceBoundary) {
    _inherits(IfcRelSpaceBoundary1stLevel, _IfcRelSpaceBoundary);

    var _super1152 = _createSuper(IfcRelSpaceBoundary1stLevel);

    function IfcRelSpaceBoundary1stLevel(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary) {
      var _this1144;

      _classCallCheck2(this, IfcRelSpaceBoundary1stLevel);

      _this1144 = _super1152.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary);
      _this1144.GlobalId = GlobalId;
      _this1144.OwnerHistory = OwnerHistory;
      _this1144.Name = Name;
      _this1144.Description = Description;
      _this1144.RelatingSpace = RelatingSpace;
      _this1144.RelatedBuildingElement = RelatedBuildingElement;
      _this1144.ConnectionGeometry = ConnectionGeometry;
      _this1144.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      _this1144.InternalOrExternalBoundary = InternalOrExternalBoundary;
      _this1144.ParentBoundary = ParentBoundary;
      _this1144.type = 3523091289;
      return _this1144;
    }

    return IfcRelSpaceBoundary1stLevel;
  }(IfcRelSpaceBoundary);

  IFC4_32.IfcRelSpaceBoundary1stLevel = IfcRelSpaceBoundary1stLevel;

  var IfcRelSpaceBoundary2ndLevel = /*#__PURE__*/function (_IfcRelSpaceBoundary2) {
    _inherits(IfcRelSpaceBoundary2ndLevel, _IfcRelSpaceBoundary2);

    var _super1153 = _createSuper(IfcRelSpaceBoundary2ndLevel);

    function IfcRelSpaceBoundary2ndLevel(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary, CorrespondingBoundary) {
      var _this1145;

      _classCallCheck2(this, IfcRelSpaceBoundary2ndLevel);

      _this1145 = _super1153.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary);
      _this1145.GlobalId = GlobalId;
      _this1145.OwnerHistory = OwnerHistory;
      _this1145.Name = Name;
      _this1145.Description = Description;
      _this1145.RelatingSpace = RelatingSpace;
      _this1145.RelatedBuildingElement = RelatedBuildingElement;
      _this1145.ConnectionGeometry = ConnectionGeometry;
      _this1145.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      _this1145.InternalOrExternalBoundary = InternalOrExternalBoundary;
      _this1145.ParentBoundary = ParentBoundary;
      _this1145.CorrespondingBoundary = CorrespondingBoundary;
      _this1145.type = 1521410863;
      return _this1145;
    }

    return IfcRelSpaceBoundary2ndLevel;
  }(IfcRelSpaceBoundary1stLevel);

  IFC4_32.IfcRelSpaceBoundary2ndLevel = IfcRelSpaceBoundary2ndLevel;

  var IfcRelVoidsElement = /*#__PURE__*/function (_IfcRelDecomposes5) {
    _inherits(IfcRelVoidsElement, _IfcRelDecomposes5);

    var _super1154 = _createSuper(IfcRelVoidsElement);

    function IfcRelVoidsElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement) {
      var _this1146;

      _classCallCheck2(this, IfcRelVoidsElement);

      _this1146 = _super1154.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1146.GlobalId = GlobalId;
      _this1146.OwnerHistory = OwnerHistory;
      _this1146.Name = Name;
      _this1146.Description = Description;
      _this1146.RelatingBuildingElement = RelatingBuildingElement;
      _this1146.RelatedOpeningElement = RelatedOpeningElement;
      _this1146.type = 1401173127;
      return _this1146;
    }

    return IfcRelVoidsElement;
  }(IfcRelDecomposes);

  IFC4_32.IfcRelVoidsElement = IfcRelVoidsElement;

  var IfcReparametrisedCompositeCurveSegment = /*#__PURE__*/function (_IfcCompositeCurveSeg) {
    _inherits(IfcReparametrisedCompositeCurveSegment, _IfcCompositeCurveSeg);

    var _super1155 = _createSuper(IfcReparametrisedCompositeCurveSegment);

    function IfcReparametrisedCompositeCurveSegment(expressID, Transition, SameSense, ParentCurve, ParamLength) {
      var _this1147;

      _classCallCheck2(this, IfcReparametrisedCompositeCurveSegment);

      _this1147 = _super1155.call(this, expressID, Transition, SameSense, ParentCurve);
      _this1147.Transition = Transition;
      _this1147.SameSense = SameSense;
      _this1147.ParentCurve = ParentCurve;
      _this1147.ParamLength = ParamLength;
      _this1147.type = 816062949;
      return _this1147;
    }

    return IfcReparametrisedCompositeCurveSegment;
  }(IfcCompositeCurveSegment);

  IFC4_32.IfcReparametrisedCompositeCurveSegment = IfcReparametrisedCompositeCurveSegment;

  var IfcResource = /*#__PURE__*/function (_IfcObject10) {
    _inherits(IfcResource, _IfcObject10);

    var _super1156 = _createSuper(IfcResource);

    function IfcResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      var _this1148;

      _classCallCheck2(this, IfcResource);

      _this1148 = _super1156.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1148.GlobalId = GlobalId;
      _this1148.OwnerHistory = OwnerHistory;
      _this1148.Name = Name;
      _this1148.Description = Description;
      _this1148.ObjectType = ObjectType;
      _this1148.Identification = Identification;
      _this1148.LongDescription = LongDescription;
      _this1148.type = 2914609552;
      return _this1148;
    }

    return IfcResource;
  }(IfcObject);

  IFC4_32.IfcResource = IfcResource;

  var IfcRevolvedAreaSolid = /*#__PURE__*/function (_IfcSweptAreaSolid6) {
    _inherits(IfcRevolvedAreaSolid, _IfcSweptAreaSolid6);

    var _super1157 = _createSuper(IfcRevolvedAreaSolid);

    function IfcRevolvedAreaSolid(expressID, SweptArea, Position, Axis, Angle) {
      var _this1149;

      _classCallCheck2(this, IfcRevolvedAreaSolid);

      _this1149 = _super1157.call(this, expressID, SweptArea, Position);
      _this1149.SweptArea = SweptArea;
      _this1149.Position = Position;
      _this1149.Axis = Axis;
      _this1149.Angle = Angle;
      _this1149.type = 1856042241;
      return _this1149;
    }

    return IfcRevolvedAreaSolid;
  }(IfcSweptAreaSolid);

  IFC4_32.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;

  var IfcRevolvedAreaSolidTapered = /*#__PURE__*/function (_IfcRevolvedAreaSolid) {
    _inherits(IfcRevolvedAreaSolidTapered, _IfcRevolvedAreaSolid);

    var _super1158 = _createSuper(IfcRevolvedAreaSolidTapered);

    function IfcRevolvedAreaSolidTapered(expressID, SweptArea, Position, Axis, Angle, EndSweptArea) {
      var _this1150;

      _classCallCheck2(this, IfcRevolvedAreaSolidTapered);

      _this1150 = _super1158.call(this, expressID, SweptArea, Position, Axis, Angle);
      _this1150.SweptArea = SweptArea;
      _this1150.Position = Position;
      _this1150.Axis = Axis;
      _this1150.Angle = Angle;
      _this1150.EndSweptArea = EndSweptArea;
      _this1150.type = 3243963512;
      return _this1150;
    }

    return IfcRevolvedAreaSolidTapered;
  }(IfcRevolvedAreaSolid);

  IFC4_32.IfcRevolvedAreaSolidTapered = IfcRevolvedAreaSolidTapered;

  var IfcRightCircularCone = /*#__PURE__*/function (_IfcCsgPrimitive3D7) {
    _inherits(IfcRightCircularCone, _IfcCsgPrimitive3D7);

    var _super1159 = _createSuper(IfcRightCircularCone);

    function IfcRightCircularCone(expressID, Position, Height, BottomRadius) {
      var _this1151;

      _classCallCheck2(this, IfcRightCircularCone);

      _this1151 = _super1159.call(this, expressID, Position);
      _this1151.Position = Position;
      _this1151.Height = Height;
      _this1151.BottomRadius = BottomRadius;
      _this1151.type = 4158566097;
      return _this1151;
    }

    return IfcRightCircularCone;
  }(IfcCsgPrimitive3D);

  IFC4_32.IfcRightCircularCone = IfcRightCircularCone;

  var IfcRightCircularCylinder = /*#__PURE__*/function (_IfcCsgPrimitive3D8) {
    _inherits(IfcRightCircularCylinder, _IfcCsgPrimitive3D8);

    var _super1160 = _createSuper(IfcRightCircularCylinder);

    function IfcRightCircularCylinder(expressID, Position, Height, Radius) {
      var _this1152;

      _classCallCheck2(this, IfcRightCircularCylinder);

      _this1152 = _super1160.call(this, expressID, Position);
      _this1152.Position = Position;
      _this1152.Height = Height;
      _this1152.Radius = Radius;
      _this1152.type = 3626867408;
      return _this1152;
    }

    return IfcRightCircularCylinder;
  }(IfcCsgPrimitive3D);

  IFC4_32.IfcRightCircularCylinder = IfcRightCircularCylinder;

  var IfcSectionedSolid = /*#__PURE__*/function (_IfcSolidModel9) {
    _inherits(IfcSectionedSolid, _IfcSolidModel9);

    var _super1161 = _createSuper(IfcSectionedSolid);

    function IfcSectionedSolid(expressID, Directrix, CrossSections) {
      var _this1153;

      _classCallCheck2(this, IfcSectionedSolid);

      _this1153 = _super1161.call(this, expressID);
      _this1153.Directrix = Directrix;
      _this1153.CrossSections = CrossSections;
      _this1153.type = 1862484736;
      return _this1153;
    }

    return IfcSectionedSolid;
  }(IfcSolidModel);

  IFC4_32.IfcSectionedSolid = IfcSectionedSolid;

  var IfcSectionedSolidHorizontal = /*#__PURE__*/function (_IfcSectionedSolid) {
    _inherits(IfcSectionedSolidHorizontal, _IfcSectionedSolid);

    var _super1162 = _createSuper(IfcSectionedSolidHorizontal);

    function IfcSectionedSolidHorizontal(expressID, Directrix, CrossSections, CrossSectionPositions) {
      var _this1154;

      _classCallCheck2(this, IfcSectionedSolidHorizontal);

      _this1154 = _super1162.call(this, expressID, Directrix, CrossSections);
      _this1154.Directrix = Directrix;
      _this1154.CrossSections = CrossSections;
      _this1154.CrossSectionPositions = CrossSectionPositions;
      _this1154.type = 1290935644;
      return _this1154;
    }

    return IfcSectionedSolidHorizontal;
  }(IfcSectionedSolid);

  IFC4_32.IfcSectionedSolidHorizontal = IfcSectionedSolidHorizontal;

  var IfcSectionedSurface = /*#__PURE__*/function (_IfcSurface7) {
    _inherits(IfcSectionedSurface, _IfcSurface7);

    var _super1163 = _createSuper(IfcSectionedSurface);

    function IfcSectionedSurface(expressID, Directrix, CrossSectionPositions, CrossSections) {
      var _this1155;

      _classCallCheck2(this, IfcSectionedSurface);

      _this1155 = _super1163.call(this, expressID);
      _this1155.Directrix = Directrix;
      _this1155.CrossSectionPositions = CrossSectionPositions;
      _this1155.CrossSections = CrossSections;
      _this1155.type = 1356537516;
      return _this1155;
    }

    return IfcSectionedSurface;
  }(IfcSurface);

  IFC4_32.IfcSectionedSurface = IfcSectionedSurface;

  var IfcSimplePropertyTemplate = /*#__PURE__*/function (_IfcPropertyTemplate) {
    _inherits(IfcSimplePropertyTemplate, _IfcPropertyTemplate);

    var _super1164 = _createSuper(IfcSimplePropertyTemplate);

    function IfcSimplePropertyTemplate(expressID, GlobalId, OwnerHistory, Name, Description, TemplateType, PrimaryMeasureType, SecondaryMeasureType, Enumerators, PrimaryUnit, SecondaryUnit, Expression, AccessState) {
      var _this1156;

      _classCallCheck2(this, IfcSimplePropertyTemplate);

      _this1156 = _super1164.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1156.GlobalId = GlobalId;
      _this1156.OwnerHistory = OwnerHistory;
      _this1156.Name = Name;
      _this1156.Description = Description;
      _this1156.TemplateType = TemplateType;
      _this1156.PrimaryMeasureType = PrimaryMeasureType;
      _this1156.SecondaryMeasureType = SecondaryMeasureType;
      _this1156.Enumerators = Enumerators;
      _this1156.PrimaryUnit = PrimaryUnit;
      _this1156.SecondaryUnit = SecondaryUnit;
      _this1156.Expression = Expression;
      _this1156.AccessState = AccessState;
      _this1156.type = 3663146110;
      return _this1156;
    }

    return IfcSimplePropertyTemplate;
  }(IfcPropertyTemplate);

  IFC4_32.IfcSimplePropertyTemplate = IfcSimplePropertyTemplate;

  var IfcSpatialElement = /*#__PURE__*/function (_IfcProduct9) {
    _inherits(IfcSpatialElement, _IfcProduct9);

    var _super1165 = _createSuper(IfcSpatialElement);

    function IfcSpatialElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      var _this1157;

      _classCallCheck2(this, IfcSpatialElement);

      _this1157 = _super1165.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1157.GlobalId = GlobalId;
      _this1157.OwnerHistory = OwnerHistory;
      _this1157.Name = Name;
      _this1157.Description = Description;
      _this1157.ObjectType = ObjectType;
      _this1157.ObjectPlacement = ObjectPlacement;
      _this1157.Representation = Representation;
      _this1157.LongName = LongName;
      _this1157.type = 1412071761;
      return _this1157;
    }

    return IfcSpatialElement;
  }(IfcProduct);

  IFC4_32.IfcSpatialElement = IfcSpatialElement;

  var IfcSpatialElementType = /*#__PURE__*/function (_IfcTypeProduct5) {
    _inherits(IfcSpatialElementType, _IfcTypeProduct5);

    var _super1166 = _createSuper(IfcSpatialElementType);

    function IfcSpatialElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1158;

      _classCallCheck2(this, IfcSpatialElementType);

      _this1158 = _super1166.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      _this1158.GlobalId = GlobalId;
      _this1158.OwnerHistory = OwnerHistory;
      _this1158.Name = Name;
      _this1158.Description = Description;
      _this1158.ApplicableOccurrence = ApplicableOccurrence;
      _this1158.HasPropertySets = HasPropertySets;
      _this1158.RepresentationMaps = RepresentationMaps;
      _this1158.Tag = Tag;
      _this1158.ElementType = ElementType;
      _this1158.type = 710998568;
      return _this1158;
    }

    return IfcSpatialElementType;
  }(IfcTypeProduct);

  IFC4_32.IfcSpatialElementType = IfcSpatialElementType;

  var IfcSpatialStructureElement = /*#__PURE__*/function (_IfcSpatialElement) {
    _inherits(IfcSpatialStructureElement, _IfcSpatialElement);

    var _super1167 = _createSuper(IfcSpatialStructureElement);

    function IfcSpatialStructureElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      var _this1159;

      _classCallCheck2(this, IfcSpatialStructureElement);

      _this1159 = _super1167.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      _this1159.GlobalId = GlobalId;
      _this1159.OwnerHistory = OwnerHistory;
      _this1159.Name = Name;
      _this1159.Description = Description;
      _this1159.ObjectType = ObjectType;
      _this1159.ObjectPlacement = ObjectPlacement;
      _this1159.Representation = Representation;
      _this1159.LongName = LongName;
      _this1159.CompositionType = CompositionType;
      _this1159.type = 2706606064;
      return _this1159;
    }

    return IfcSpatialStructureElement;
  }(IfcSpatialElement);

  IFC4_32.IfcSpatialStructureElement = IfcSpatialStructureElement;

  var IfcSpatialStructureElementType = /*#__PURE__*/function (_IfcSpatialElementTyp) {
    _inherits(IfcSpatialStructureElementType, _IfcSpatialElementTyp);

    var _super1168 = _createSuper(IfcSpatialStructureElementType);

    function IfcSpatialStructureElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1160;

      _classCallCheck2(this, IfcSpatialStructureElementType);

      _this1160 = _super1168.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1160.GlobalId = GlobalId;
      _this1160.OwnerHistory = OwnerHistory;
      _this1160.Name = Name;
      _this1160.Description = Description;
      _this1160.ApplicableOccurrence = ApplicableOccurrence;
      _this1160.HasPropertySets = HasPropertySets;
      _this1160.RepresentationMaps = RepresentationMaps;
      _this1160.Tag = Tag;
      _this1160.ElementType = ElementType;
      _this1160.type = 3893378262;
      return _this1160;
    }

    return IfcSpatialStructureElementType;
  }(IfcSpatialElementType);

  IFC4_32.IfcSpatialStructureElementType = IfcSpatialStructureElementType;

  var IfcSpatialZone = /*#__PURE__*/function (_IfcSpatialElement2) {
    _inherits(IfcSpatialZone, _IfcSpatialElement2);

    var _super1169 = _createSuper(IfcSpatialZone);

    function IfcSpatialZone(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      var _this1161;

      _classCallCheck2(this, IfcSpatialZone);

      _this1161 = _super1169.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      _this1161.GlobalId = GlobalId;
      _this1161.OwnerHistory = OwnerHistory;
      _this1161.Name = Name;
      _this1161.Description = Description;
      _this1161.ObjectType = ObjectType;
      _this1161.ObjectPlacement = ObjectPlacement;
      _this1161.Representation = Representation;
      _this1161.LongName = LongName;
      _this1161.PredefinedType = PredefinedType;
      _this1161.type = 463610769;
      return _this1161;
    }

    return IfcSpatialZone;
  }(IfcSpatialElement);

  IFC4_32.IfcSpatialZone = IfcSpatialZone;

  var IfcSpatialZoneType = /*#__PURE__*/function (_IfcSpatialElementTyp2) {
    _inherits(IfcSpatialZoneType, _IfcSpatialElementTyp2);

    var _super1170 = _createSuper(IfcSpatialZoneType);

    function IfcSpatialZoneType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      var _this1162;

      _classCallCheck2(this, IfcSpatialZoneType);

      _this1162 = _super1170.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1162.GlobalId = GlobalId;
      _this1162.OwnerHistory = OwnerHistory;
      _this1162.Name = Name;
      _this1162.Description = Description;
      _this1162.ApplicableOccurrence = ApplicableOccurrence;
      _this1162.HasPropertySets = HasPropertySets;
      _this1162.RepresentationMaps = RepresentationMaps;
      _this1162.Tag = Tag;
      _this1162.ElementType = ElementType;
      _this1162.PredefinedType = PredefinedType;
      _this1162.LongName = LongName;
      _this1162.type = 2481509218;
      return _this1162;
    }

    return IfcSpatialZoneType;
  }(IfcSpatialElementType);

  IFC4_32.IfcSpatialZoneType = IfcSpatialZoneType;

  var IfcSphere = /*#__PURE__*/function (_IfcCsgPrimitive3D9) {
    _inherits(IfcSphere, _IfcCsgPrimitive3D9);

    var _super1171 = _createSuper(IfcSphere);

    function IfcSphere(expressID, Position, Radius) {
      var _this1163;

      _classCallCheck2(this, IfcSphere);

      _this1163 = _super1171.call(this, expressID, Position);
      _this1163.Position = Position;
      _this1163.Radius = Radius;
      _this1163.type = 451544542;
      return _this1163;
    }

    return IfcSphere;
  }(IfcCsgPrimitive3D);

  IFC4_32.IfcSphere = IfcSphere;

  var IfcSphericalSurface = /*#__PURE__*/function (_IfcElementarySurface3) {
    _inherits(IfcSphericalSurface, _IfcElementarySurface3);

    var _super1172 = _createSuper(IfcSphericalSurface);

    function IfcSphericalSurface(expressID, Position, Radius) {
      var _this1164;

      _classCallCheck2(this, IfcSphericalSurface);

      _this1164 = _super1172.call(this, expressID, Position);
      _this1164.Position = Position;
      _this1164.Radius = Radius;
      _this1164.type = 4015995234;
      return _this1164;
    }

    return IfcSphericalSurface;
  }(IfcElementarySurface);

  IFC4_32.IfcSphericalSurface = IfcSphericalSurface;

  var IfcSpiral = /*#__PURE__*/function (_IfcCurve10) {
    _inherits(IfcSpiral, _IfcCurve10);

    var _super1173 = _createSuper(IfcSpiral);

    function IfcSpiral(expressID, Position) {
      var _this1165;

      _classCallCheck2(this, IfcSpiral);

      _this1165 = _super1173.call(this, expressID);
      _this1165.Position = Position;
      _this1165.type = 2735484536;
      return _this1165;
    }

    return IfcSpiral;
  }(IfcCurve);

  IFC4_32.IfcSpiral = IfcSpiral;

  var IfcStructuralActivity = /*#__PURE__*/function (_IfcProduct10) {
    _inherits(IfcStructuralActivity, _IfcProduct10);

    var _super1174 = _createSuper(IfcStructuralActivity);

    function IfcStructuralActivity(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      var _this1166;

      _classCallCheck2(this, IfcStructuralActivity);

      _this1166 = _super1174.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1166.GlobalId = GlobalId;
      _this1166.OwnerHistory = OwnerHistory;
      _this1166.Name = Name;
      _this1166.Description = Description;
      _this1166.ObjectType = ObjectType;
      _this1166.ObjectPlacement = ObjectPlacement;
      _this1166.Representation = Representation;
      _this1166.AppliedLoad = AppliedLoad;
      _this1166.GlobalOrLocal = GlobalOrLocal;
      _this1166.type = 3544373492;
      return _this1166;
    }

    return IfcStructuralActivity;
  }(IfcProduct);

  IFC4_32.IfcStructuralActivity = IfcStructuralActivity;

  var IfcStructuralItem = /*#__PURE__*/function (_IfcProduct11) {
    _inherits(IfcStructuralItem, _IfcProduct11);

    var _super1175 = _createSuper(IfcStructuralItem);

    function IfcStructuralItem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this1167;

      _classCallCheck2(this, IfcStructuralItem);

      _this1167 = _super1175.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1167.GlobalId = GlobalId;
      _this1167.OwnerHistory = OwnerHistory;
      _this1167.Name = Name;
      _this1167.Description = Description;
      _this1167.ObjectType = ObjectType;
      _this1167.ObjectPlacement = ObjectPlacement;
      _this1167.Representation = Representation;
      _this1167.type = 3136571912;
      return _this1167;
    }

    return IfcStructuralItem;
  }(IfcProduct);

  IFC4_32.IfcStructuralItem = IfcStructuralItem;

  var IfcStructuralMember = /*#__PURE__*/function (_IfcStructuralItem3) {
    _inherits(IfcStructuralMember, _IfcStructuralItem3);

    var _super1176 = _createSuper(IfcStructuralMember);

    function IfcStructuralMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this1168;

      _classCallCheck2(this, IfcStructuralMember);

      _this1168 = _super1176.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1168.GlobalId = GlobalId;
      _this1168.OwnerHistory = OwnerHistory;
      _this1168.Name = Name;
      _this1168.Description = Description;
      _this1168.ObjectType = ObjectType;
      _this1168.ObjectPlacement = ObjectPlacement;
      _this1168.Representation = Representation;
      _this1168.type = 530289379;
      return _this1168;
    }

    return IfcStructuralMember;
  }(IfcStructuralItem);

  IFC4_32.IfcStructuralMember = IfcStructuralMember;

  var IfcStructuralReaction = /*#__PURE__*/function (_IfcStructuralActivit3) {
    _inherits(IfcStructuralReaction, _IfcStructuralActivit3);

    var _super1177 = _createSuper(IfcStructuralReaction);

    function IfcStructuralReaction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      var _this1169;

      _classCallCheck2(this, IfcStructuralReaction);

      _this1169 = _super1177.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this1169.GlobalId = GlobalId;
      _this1169.OwnerHistory = OwnerHistory;
      _this1169.Name = Name;
      _this1169.Description = Description;
      _this1169.ObjectType = ObjectType;
      _this1169.ObjectPlacement = ObjectPlacement;
      _this1169.Representation = Representation;
      _this1169.AppliedLoad = AppliedLoad;
      _this1169.GlobalOrLocal = GlobalOrLocal;
      _this1169.type = 3689010777;
      return _this1169;
    }

    return IfcStructuralReaction;
  }(IfcStructuralActivity);

  IFC4_32.IfcStructuralReaction = IfcStructuralReaction;

  var IfcStructuralSurfaceMember = /*#__PURE__*/function (_IfcStructuralMember3) {
    _inherits(IfcStructuralSurfaceMember, _IfcStructuralMember3);

    var _super1178 = _createSuper(IfcStructuralSurfaceMember);

    function IfcStructuralSurfaceMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      var _this1170;

      _classCallCheck2(this, IfcStructuralSurfaceMember);

      _this1170 = _super1178.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1170.GlobalId = GlobalId;
      _this1170.OwnerHistory = OwnerHistory;
      _this1170.Name = Name;
      _this1170.Description = Description;
      _this1170.ObjectType = ObjectType;
      _this1170.ObjectPlacement = ObjectPlacement;
      _this1170.Representation = Representation;
      _this1170.PredefinedType = PredefinedType;
      _this1170.Thickness = Thickness;
      _this1170.type = 3979015343;
      return _this1170;
    }

    return IfcStructuralSurfaceMember;
  }(IfcStructuralMember);

  IFC4_32.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;

  var IfcStructuralSurfaceMemberVarying = /*#__PURE__*/function (_IfcStructuralSurface2) {
    _inherits(IfcStructuralSurfaceMemberVarying, _IfcStructuralSurface2);

    var _super1179 = _createSuper(IfcStructuralSurfaceMemberVarying);

    function IfcStructuralSurfaceMemberVarying(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      var _this1171;

      _classCallCheck2(this, IfcStructuralSurfaceMemberVarying);

      _this1171 = _super1179.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
      _this1171.GlobalId = GlobalId;
      _this1171.OwnerHistory = OwnerHistory;
      _this1171.Name = Name;
      _this1171.Description = Description;
      _this1171.ObjectType = ObjectType;
      _this1171.ObjectPlacement = ObjectPlacement;
      _this1171.Representation = Representation;
      _this1171.PredefinedType = PredefinedType;
      _this1171.Thickness = Thickness;
      _this1171.type = 2218152070;
      return _this1171;
    }

    return IfcStructuralSurfaceMemberVarying;
  }(IfcStructuralSurfaceMember);

  IFC4_32.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;

  var IfcStructuralSurfaceReaction = /*#__PURE__*/function (_IfcStructuralReactio2) {
    _inherits(IfcStructuralSurfaceReaction, _IfcStructuralReactio2);

    var _super1180 = _createSuper(IfcStructuralSurfaceReaction);

    function IfcStructuralSurfaceReaction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      var _this1172;

      _classCallCheck2(this, IfcStructuralSurfaceReaction);

      _this1172 = _super1180.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this1172.GlobalId = GlobalId;
      _this1172.OwnerHistory = OwnerHistory;
      _this1172.Name = Name;
      _this1172.Description = Description;
      _this1172.ObjectType = ObjectType;
      _this1172.ObjectPlacement = ObjectPlacement;
      _this1172.Representation = Representation;
      _this1172.AppliedLoad = AppliedLoad;
      _this1172.GlobalOrLocal = GlobalOrLocal;
      _this1172.PredefinedType = PredefinedType;
      _this1172.type = 603775116;
      return _this1172;
    }

    return IfcStructuralSurfaceReaction;
  }(IfcStructuralReaction);

  IFC4_32.IfcStructuralSurfaceReaction = IfcStructuralSurfaceReaction;

  var IfcSubContractResourceType = /*#__PURE__*/function (_IfcConstructionResou9) {
    _inherits(IfcSubContractResourceType, _IfcConstructionResou9);

    var _super1181 = _createSuper(IfcSubContractResourceType);

    function IfcSubContractResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1173;

      _classCallCheck2(this, IfcSubContractResourceType);

      _this1173 = _super1181.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this1173.GlobalId = GlobalId;
      _this1173.OwnerHistory = OwnerHistory;
      _this1173.Name = Name;
      _this1173.Description = Description;
      _this1173.ApplicableOccurrence = ApplicableOccurrence;
      _this1173.HasPropertySets = HasPropertySets;
      _this1173.Identification = Identification;
      _this1173.LongDescription = LongDescription;
      _this1173.ResourceType = ResourceType;
      _this1173.BaseCosts = BaseCosts;
      _this1173.BaseQuantity = BaseQuantity;
      _this1173.PredefinedType = PredefinedType;
      _this1173.type = 4095615324;
      return _this1173;
    }

    return IfcSubContractResourceType;
  }(IfcConstructionResourceType);

  IFC4_32.IfcSubContractResourceType = IfcSubContractResourceType;

  var IfcSurfaceCurve = /*#__PURE__*/function (_IfcCurve11) {
    _inherits(IfcSurfaceCurve, _IfcCurve11);

    var _super1182 = _createSuper(IfcSurfaceCurve);

    function IfcSurfaceCurve(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      var _this1174;

      _classCallCheck2(this, IfcSurfaceCurve);

      _this1174 = _super1182.call(this, expressID);
      _this1174.Curve3D = Curve3D;
      _this1174.AssociatedGeometry = AssociatedGeometry;
      _this1174.MasterRepresentation = MasterRepresentation;
      _this1174.type = 699246055;
      return _this1174;
    }

    return IfcSurfaceCurve;
  }(IfcCurve);

  IFC4_32.IfcSurfaceCurve = IfcSurfaceCurve;

  var IfcSurfaceCurveSweptAreaSolid = /*#__PURE__*/function (_IfcDirectrixCurveSwe2) {
    _inherits(IfcSurfaceCurveSweptAreaSolid, _IfcDirectrixCurveSwe2);

    var _super1183 = _createSuper(IfcSurfaceCurveSweptAreaSolid);

    function IfcSurfaceCurveSweptAreaSolid(expressID, SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface) {
      var _this1175;

      _classCallCheck2(this, IfcSurfaceCurveSweptAreaSolid);

      _this1175 = _super1183.call(this, expressID, SweptArea, Position, Directrix, StartParam, EndParam);
      _this1175.SweptArea = SweptArea;
      _this1175.Position = Position;
      _this1175.Directrix = Directrix;
      _this1175.StartParam = StartParam;
      _this1175.EndParam = EndParam;
      _this1175.ReferenceSurface = ReferenceSurface;
      _this1175.type = 2028607225;
      return _this1175;
    }

    return IfcSurfaceCurveSweptAreaSolid;
  }(IfcDirectrixCurveSweptAreaSolid);

  IFC4_32.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;

  var IfcSurfaceOfLinearExtrusion = /*#__PURE__*/function (_IfcSweptSurface3) {
    _inherits(IfcSurfaceOfLinearExtrusion, _IfcSweptSurface3);

    var _super1184 = _createSuper(IfcSurfaceOfLinearExtrusion);

    function IfcSurfaceOfLinearExtrusion(expressID, SweptCurve, Position, ExtrudedDirection, Depth) {
      var _this1176;

      _classCallCheck2(this, IfcSurfaceOfLinearExtrusion);

      _this1176 = _super1184.call(this, expressID, SweptCurve, Position);
      _this1176.SweptCurve = SweptCurve;
      _this1176.Position = Position;
      _this1176.ExtrudedDirection = ExtrudedDirection;
      _this1176.Depth = Depth;
      _this1176.type = 2809605785;
      return _this1176;
    }

    return IfcSurfaceOfLinearExtrusion;
  }(IfcSweptSurface);

  IFC4_32.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;

  var IfcSurfaceOfRevolution = /*#__PURE__*/function (_IfcSweptSurface4) {
    _inherits(IfcSurfaceOfRevolution, _IfcSweptSurface4);

    var _super1185 = _createSuper(IfcSurfaceOfRevolution);

    function IfcSurfaceOfRevolution(expressID, SweptCurve, Position, AxisPosition) {
      var _this1177;

      _classCallCheck2(this, IfcSurfaceOfRevolution);

      _this1177 = _super1185.call(this, expressID, SweptCurve, Position);
      _this1177.SweptCurve = SweptCurve;
      _this1177.Position = Position;
      _this1177.AxisPosition = AxisPosition;
      _this1177.type = 4124788165;
      return _this1177;
    }

    return IfcSurfaceOfRevolution;
  }(IfcSweptSurface);

  IFC4_32.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;

  var IfcSystemFurnitureElementType = /*#__PURE__*/function (_IfcFurnishingElement4) {
    _inherits(IfcSystemFurnitureElementType, _IfcFurnishingElement4);

    var _super1186 = _createSuper(IfcSystemFurnitureElementType);

    function IfcSystemFurnitureElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1178;

      _classCallCheck2(this, IfcSystemFurnitureElementType);

      _this1178 = _super1186.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1178.GlobalId = GlobalId;
      _this1178.OwnerHistory = OwnerHistory;
      _this1178.Name = Name;
      _this1178.Description = Description;
      _this1178.ApplicableOccurrence = ApplicableOccurrence;
      _this1178.HasPropertySets = HasPropertySets;
      _this1178.RepresentationMaps = RepresentationMaps;
      _this1178.Tag = Tag;
      _this1178.ElementType = ElementType;
      _this1178.PredefinedType = PredefinedType;
      _this1178.type = 1580310250;
      return _this1178;
    }

    return IfcSystemFurnitureElementType;
  }(IfcFurnishingElementType);

  IFC4_32.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;

  var IfcTask = /*#__PURE__*/function (_IfcProcess3) {
    _inherits(IfcTask, _IfcProcess3);

    var _super1187 = _createSuper(IfcTask);

    function IfcTask(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Status, WorkMethod, IsMilestone, Priority, TaskTime, PredefinedType) {
      var _this1179;

      _classCallCheck2(this, IfcTask);

      _this1179 = _super1187.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      _this1179.GlobalId = GlobalId;
      _this1179.OwnerHistory = OwnerHistory;
      _this1179.Name = Name;
      _this1179.Description = Description;
      _this1179.ObjectType = ObjectType;
      _this1179.Identification = Identification;
      _this1179.LongDescription = LongDescription;
      _this1179.Status = Status;
      _this1179.WorkMethod = WorkMethod;
      _this1179.IsMilestone = IsMilestone;
      _this1179.Priority = Priority;
      _this1179.TaskTime = TaskTime;
      _this1179.PredefinedType = PredefinedType;
      _this1179.type = 3473067441;
      return _this1179;
    }

    return IfcTask;
  }(IfcProcess);

  IFC4_32.IfcTask = IfcTask;

  var IfcTaskType = /*#__PURE__*/function (_IfcTypeProcess3) {
    _inherits(IfcTaskType, _IfcTypeProcess3);

    var _super1188 = _createSuper(IfcTaskType);

    function IfcTaskType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, WorkMethod) {
      var _this1180;

      _classCallCheck2(this, IfcTaskType);

      _this1180 = _super1188.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      _this1180.GlobalId = GlobalId;
      _this1180.OwnerHistory = OwnerHistory;
      _this1180.Name = Name;
      _this1180.Description = Description;
      _this1180.ApplicableOccurrence = ApplicableOccurrence;
      _this1180.HasPropertySets = HasPropertySets;
      _this1180.Identification = Identification;
      _this1180.LongDescription = LongDescription;
      _this1180.ProcessType = ProcessType;
      _this1180.PredefinedType = PredefinedType;
      _this1180.WorkMethod = WorkMethod;
      _this1180.type = 3206491090;
      return _this1180;
    }

    return IfcTaskType;
  }(IfcTypeProcess);

  IFC4_32.IfcTaskType = IfcTaskType;

  var IfcTessellatedFaceSet = /*#__PURE__*/function (_IfcTessellatedItem2) {
    _inherits(IfcTessellatedFaceSet, _IfcTessellatedItem2);

    var _super1189 = _createSuper(IfcTessellatedFaceSet);

    function IfcTessellatedFaceSet(expressID, Coordinates, Closed) {
      var _this1181;

      _classCallCheck2(this, IfcTessellatedFaceSet);

      _this1181 = _super1189.call(this, expressID);
      _this1181.Coordinates = Coordinates;
      _this1181.Closed = Closed;
      _this1181.type = 2387106220;
      return _this1181;
    }

    return IfcTessellatedFaceSet;
  }(IfcTessellatedItem);

  IFC4_32.IfcTessellatedFaceSet = IfcTessellatedFaceSet;

  var IfcThirdOrderPolynomialSpiral = /*#__PURE__*/function (_IfcSpiral) {
    _inherits(IfcThirdOrderPolynomialSpiral, _IfcSpiral);

    var _super1190 = _createSuper(IfcThirdOrderPolynomialSpiral);

    function IfcThirdOrderPolynomialSpiral(expressID, Position, CubicTerm, QuadraticTerm, LinearTerm, ConstantTerm) {
      var _this1182;

      _classCallCheck2(this, IfcThirdOrderPolynomialSpiral);

      _this1182 = _super1190.call(this, expressID, Position);
      _this1182.Position = Position;
      _this1182.CubicTerm = CubicTerm;
      _this1182.QuadraticTerm = QuadraticTerm;
      _this1182.LinearTerm = LinearTerm;
      _this1182.ConstantTerm = ConstantTerm;
      _this1182.type = 782932809;
      return _this1182;
    }

    return IfcThirdOrderPolynomialSpiral;
  }(IfcSpiral);

  IFC4_32.IfcThirdOrderPolynomialSpiral = IfcThirdOrderPolynomialSpiral;

  var IfcToroidalSurface = /*#__PURE__*/function (_IfcElementarySurface4) {
    _inherits(IfcToroidalSurface, _IfcElementarySurface4);

    var _super1191 = _createSuper(IfcToroidalSurface);

    function IfcToroidalSurface(expressID, Position, MajorRadius, MinorRadius) {
      var _this1183;

      _classCallCheck2(this, IfcToroidalSurface);

      _this1183 = _super1191.call(this, expressID, Position);
      _this1183.Position = Position;
      _this1183.MajorRadius = MajorRadius;
      _this1183.MinorRadius = MinorRadius;
      _this1183.type = 1935646853;
      return _this1183;
    }

    return IfcToroidalSurface;
  }(IfcElementarySurface);

  IFC4_32.IfcToroidalSurface = IfcToroidalSurface;

  var IfcTransportationDeviceType = /*#__PURE__*/function (_IfcElementType9) {
    _inherits(IfcTransportationDeviceType, _IfcElementType9);

    var _super1192 = _createSuper(IfcTransportationDeviceType);

    function IfcTransportationDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1184;

      _classCallCheck2(this, IfcTransportationDeviceType);

      _this1184 = _super1192.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1184.GlobalId = GlobalId;
      _this1184.OwnerHistory = OwnerHistory;
      _this1184.Name = Name;
      _this1184.Description = Description;
      _this1184.ApplicableOccurrence = ApplicableOccurrence;
      _this1184.HasPropertySets = HasPropertySets;
      _this1184.RepresentationMaps = RepresentationMaps;
      _this1184.Tag = Tag;
      _this1184.ElementType = ElementType;
      _this1184.type = 3665877780;
      return _this1184;
    }

    return IfcTransportationDeviceType;
  }(IfcElementType);

  IFC4_32.IfcTransportationDeviceType = IfcTransportationDeviceType;

  var IfcTriangulatedFaceSet = /*#__PURE__*/function (_IfcTessellatedFaceSe) {
    _inherits(IfcTriangulatedFaceSet, _IfcTessellatedFaceSe);

    var _super1193 = _createSuper(IfcTriangulatedFaceSet);

    function IfcTriangulatedFaceSet(expressID, Coordinates, Closed, Normals, CoordIndex, PnIndex) {
      var _this1185;

      _classCallCheck2(this, IfcTriangulatedFaceSet);

      _this1185 = _super1193.call(this, expressID, Coordinates, Closed);
      _this1185.Coordinates = Coordinates;
      _this1185.Closed = Closed;
      _this1185.Normals = Normals;
      _this1185.CoordIndex = CoordIndex;
      _this1185.PnIndex = PnIndex;
      _this1185.type = 2916149573;
      return _this1185;
    }

    return IfcTriangulatedFaceSet;
  }(IfcTessellatedFaceSet);

  IFC4_32.IfcTriangulatedFaceSet = IfcTriangulatedFaceSet;

  var IfcTriangulatedIrregularNetwork = /*#__PURE__*/function (_IfcTriangulatedFaceS) {
    _inherits(IfcTriangulatedIrregularNetwork, _IfcTriangulatedFaceS);

    var _super1194 = _createSuper(IfcTriangulatedIrregularNetwork);

    function IfcTriangulatedIrregularNetwork(expressID, Coordinates, Closed, Normals, CoordIndex, PnIndex, Flags) {
      var _this1186;

      _classCallCheck2(this, IfcTriangulatedIrregularNetwork);

      _this1186 = _super1194.call(this, expressID, Coordinates, Closed, Normals, CoordIndex, PnIndex);
      _this1186.Coordinates = Coordinates;
      _this1186.Closed = Closed;
      _this1186.Normals = Normals;
      _this1186.CoordIndex = CoordIndex;
      _this1186.PnIndex = PnIndex;
      _this1186.Flags = Flags;
      _this1186.type = 1229763772;
      return _this1186;
    }

    return IfcTriangulatedIrregularNetwork;
  }(IfcTriangulatedFaceSet);

  IFC4_32.IfcTriangulatedIrregularNetwork = IfcTriangulatedIrregularNetwork;

  var IfcVehicleType = /*#__PURE__*/function (_IfcTransportationDev) {
    _inherits(IfcVehicleType, _IfcTransportationDev);

    var _super1195 = _createSuper(IfcVehicleType);

    function IfcVehicleType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1187;

      _classCallCheck2(this, IfcVehicleType);

      _this1187 = _super1195.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1187.GlobalId = GlobalId;
      _this1187.OwnerHistory = OwnerHistory;
      _this1187.Name = Name;
      _this1187.Description = Description;
      _this1187.ApplicableOccurrence = ApplicableOccurrence;
      _this1187.HasPropertySets = HasPropertySets;
      _this1187.RepresentationMaps = RepresentationMaps;
      _this1187.Tag = Tag;
      _this1187.ElementType = ElementType;
      _this1187.PredefinedType = PredefinedType;
      _this1187.type = 3651464721;
      return _this1187;
    }

    return IfcVehicleType;
  }(IfcTransportationDeviceType);

  IFC4_32.IfcVehicleType = IfcVehicleType;

  var IfcWindowLiningProperties = /*#__PURE__*/function (_IfcPreDefinedPropert5) {
    _inherits(IfcWindowLiningProperties, _IfcPreDefinedPropert5);

    var _super1196 = _createSuper(IfcWindowLiningProperties);

    function IfcWindowLiningProperties(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle, LiningOffset, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      var _this1188;

      _classCallCheck2(this, IfcWindowLiningProperties);

      _this1188 = _super1196.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1188.GlobalId = GlobalId;
      _this1188.OwnerHistory = OwnerHistory;
      _this1188.Name = Name;
      _this1188.Description = Description;
      _this1188.LiningDepth = LiningDepth;
      _this1188.LiningThickness = LiningThickness;
      _this1188.TransomThickness = TransomThickness;
      _this1188.MullionThickness = MullionThickness;
      _this1188.FirstTransomOffset = FirstTransomOffset;
      _this1188.SecondTransomOffset = SecondTransomOffset;
      _this1188.FirstMullionOffset = FirstMullionOffset;
      _this1188.SecondMullionOffset = SecondMullionOffset;
      _this1188.ShapeAspectStyle = ShapeAspectStyle;
      _this1188.LiningOffset = LiningOffset;
      _this1188.LiningToPanelOffsetX = LiningToPanelOffsetX;
      _this1188.LiningToPanelOffsetY = LiningToPanelOffsetY;
      _this1188.type = 336235671;
      return _this1188;
    }

    return IfcWindowLiningProperties;
  }(IfcPreDefinedPropertySet);

  IFC4_32.IfcWindowLiningProperties = IfcWindowLiningProperties;

  var IfcWindowPanelProperties = /*#__PURE__*/function (_IfcPreDefinedPropert6) {
    _inherits(IfcWindowPanelProperties, _IfcPreDefinedPropert6);

    var _super1197 = _createSuper(IfcWindowPanelProperties);

    function IfcWindowPanelProperties(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      var _this1189;

      _classCallCheck2(this, IfcWindowPanelProperties);

      _this1189 = _super1197.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1189.GlobalId = GlobalId;
      _this1189.OwnerHistory = OwnerHistory;
      _this1189.Name = Name;
      _this1189.Description = Description;
      _this1189.OperationType = OperationType;
      _this1189.PanelPosition = PanelPosition;
      _this1189.FrameDepth = FrameDepth;
      _this1189.FrameThickness = FrameThickness;
      _this1189.ShapeAspectStyle = ShapeAspectStyle;
      _this1189.type = 512836454;
      return _this1189;
    }

    return IfcWindowPanelProperties;
  }(IfcPreDefinedPropertySet);

  IFC4_32.IfcWindowPanelProperties = IfcWindowPanelProperties;

  var IfcActor = /*#__PURE__*/function (_IfcObject11) {
    _inherits(IfcActor, _IfcObject11);

    var _super1198 = _createSuper(IfcActor);

    function IfcActor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor) {
      var _this1190;

      _classCallCheck2(this, IfcActor);

      _this1190 = _super1198.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1190.GlobalId = GlobalId;
      _this1190.OwnerHistory = OwnerHistory;
      _this1190.Name = Name;
      _this1190.Description = Description;
      _this1190.ObjectType = ObjectType;
      _this1190.TheActor = TheActor;
      _this1190.type = 2296667514;
      return _this1190;
    }

    return IfcActor;
  }(IfcObject);

  IFC4_32.IfcActor = IfcActor;

  var IfcAdvancedBrep = /*#__PURE__*/function (_IfcManifoldSolidBrep3) {
    _inherits(IfcAdvancedBrep, _IfcManifoldSolidBrep3);

    var _super1199 = _createSuper(IfcAdvancedBrep);

    function IfcAdvancedBrep(expressID, Outer) {
      var _this1191;

      _classCallCheck2(this, IfcAdvancedBrep);

      _this1191 = _super1199.call(this, expressID, Outer);
      _this1191.Outer = Outer;
      _this1191.type = 1635779807;
      return _this1191;
    }

    return IfcAdvancedBrep;
  }(IfcManifoldSolidBrep);

  IFC4_32.IfcAdvancedBrep = IfcAdvancedBrep;

  var IfcAdvancedBrepWithVoids = /*#__PURE__*/function (_IfcAdvancedBrep) {
    _inherits(IfcAdvancedBrepWithVoids, _IfcAdvancedBrep);

    var _super1200 = _createSuper(IfcAdvancedBrepWithVoids);

    function IfcAdvancedBrepWithVoids(expressID, Outer, Voids) {
      var _this1192;

      _classCallCheck2(this, IfcAdvancedBrepWithVoids);

      _this1192 = _super1200.call(this, expressID, Outer);
      _this1192.Outer = Outer;
      _this1192.Voids = Voids;
      _this1192.type = 2603310189;
      return _this1192;
    }

    return IfcAdvancedBrepWithVoids;
  }(IfcAdvancedBrep);

  IFC4_32.IfcAdvancedBrepWithVoids = IfcAdvancedBrepWithVoids;

  var IfcAnnotation = /*#__PURE__*/function (_IfcProduct12) {
    _inherits(IfcAnnotation, _IfcProduct12);

    var _super1201 = _createSuper(IfcAnnotation);

    function IfcAnnotation(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      var _this1193;

      _classCallCheck2(this, IfcAnnotation);

      _this1193 = _super1201.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1193.GlobalId = GlobalId;
      _this1193.OwnerHistory = OwnerHistory;
      _this1193.Name = Name;
      _this1193.Description = Description;
      _this1193.ObjectType = ObjectType;
      _this1193.ObjectPlacement = ObjectPlacement;
      _this1193.Representation = Representation;
      _this1193.PredefinedType = PredefinedType;
      _this1193.type = 1674181508;
      return _this1193;
    }

    return IfcAnnotation;
  }(IfcProduct);

  IFC4_32.IfcAnnotation = IfcAnnotation;

  var IfcBSplineSurface = /*#__PURE__*/function (_IfcBoundedSurface6) {
    _inherits(IfcBSplineSurface, _IfcBoundedSurface6);

    var _super1202 = _createSuper(IfcBSplineSurface);

    function IfcBSplineSurface(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect) {
      var _this1194;

      _classCallCheck2(this, IfcBSplineSurface);

      _this1194 = _super1202.call(this, expressID);
      _this1194.UDegree = UDegree;
      _this1194.VDegree = VDegree;
      _this1194.ControlPointsList = ControlPointsList;
      _this1194.SurfaceForm = SurfaceForm;
      _this1194.UClosed = UClosed;
      _this1194.VClosed = VClosed;
      _this1194.SelfIntersect = SelfIntersect;
      _this1194.type = 2887950389;
      return _this1194;
    }

    return IfcBSplineSurface;
  }(IfcBoundedSurface);

  IFC4_32.IfcBSplineSurface = IfcBSplineSurface;

  var IfcBSplineSurfaceWithKnots = /*#__PURE__*/function (_IfcBSplineSurface) {
    _inherits(IfcBSplineSurfaceWithKnots, _IfcBSplineSurface);

    var _super1203 = _createSuper(IfcBSplineSurfaceWithKnots);

    function IfcBSplineSurfaceWithKnots(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec) {
      var _this1195;

      _classCallCheck2(this, IfcBSplineSurfaceWithKnots);

      _this1195 = _super1203.call(this, expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect);
      _this1195.UDegree = UDegree;
      _this1195.VDegree = VDegree;
      _this1195.ControlPointsList = ControlPointsList;
      _this1195.SurfaceForm = SurfaceForm;
      _this1195.UClosed = UClosed;
      _this1195.VClosed = VClosed;
      _this1195.SelfIntersect = SelfIntersect;
      _this1195.UMultiplicities = UMultiplicities;
      _this1195.VMultiplicities = VMultiplicities;
      _this1195.UKnots = UKnots;
      _this1195.VKnots = VKnots;
      _this1195.KnotSpec = KnotSpec;
      _this1195.type = 167062518;
      return _this1195;
    }

    return IfcBSplineSurfaceWithKnots;
  }(IfcBSplineSurface);

  IFC4_32.IfcBSplineSurfaceWithKnots = IfcBSplineSurfaceWithKnots;

  var IfcBlock = /*#__PURE__*/function (_IfcCsgPrimitive3D10) {
    _inherits(IfcBlock, _IfcCsgPrimitive3D10);

    var _super1204 = _createSuper(IfcBlock);

    function IfcBlock(expressID, Position, XLength, YLength, ZLength) {
      var _this1196;

      _classCallCheck2(this, IfcBlock);

      _this1196 = _super1204.call(this, expressID, Position);
      _this1196.Position = Position;
      _this1196.XLength = XLength;
      _this1196.YLength = YLength;
      _this1196.ZLength = ZLength;
      _this1196.type = 1334484129;
      return _this1196;
    }

    return IfcBlock;
  }(IfcCsgPrimitive3D);

  IFC4_32.IfcBlock = IfcBlock;

  var IfcBooleanClippingResult = /*#__PURE__*/function (_IfcBooleanResult2) {
    _inherits(IfcBooleanClippingResult, _IfcBooleanResult2);

    var _super1205 = _createSuper(IfcBooleanClippingResult);

    function IfcBooleanClippingResult(expressID, Operator, FirstOperand, SecondOperand) {
      var _this1197;

      _classCallCheck2(this, IfcBooleanClippingResult);

      _this1197 = _super1205.call(this, expressID, Operator, FirstOperand, SecondOperand);
      _this1197.Operator = Operator;
      _this1197.FirstOperand = FirstOperand;
      _this1197.SecondOperand = SecondOperand;
      _this1197.type = 3649129432;
      return _this1197;
    }

    return IfcBooleanClippingResult;
  }(IfcBooleanResult);

  IFC4_32.IfcBooleanClippingResult = IfcBooleanClippingResult;

  var IfcBoundedCurve = /*#__PURE__*/function (_IfcCurve12) {
    _inherits(IfcBoundedCurve, _IfcCurve12);

    var _super1206 = _createSuper(IfcBoundedCurve);

    function IfcBoundedCurve(expressID) {
      var _this1198;

      _classCallCheck2(this, IfcBoundedCurve);

      _this1198 = _super1206.call(this, expressID);
      _this1198.type = 1260505505;
      return _this1198;
    }

    return IfcBoundedCurve;
  }(IfcCurve);

  IFC4_32.IfcBoundedCurve = IfcBoundedCurve;

  var IfcBuildingStorey = /*#__PURE__*/function (_IfcSpatialStructureE6) {
    _inherits(IfcBuildingStorey, _IfcSpatialStructureE6);

    var _super1207 = _createSuper(IfcBuildingStorey);

    function IfcBuildingStorey(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation) {
      var _this1199;

      _classCallCheck2(this, IfcBuildingStorey);

      _this1199 = _super1207.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this1199.GlobalId = GlobalId;
      _this1199.OwnerHistory = OwnerHistory;
      _this1199.Name = Name;
      _this1199.Description = Description;
      _this1199.ObjectType = ObjectType;
      _this1199.ObjectPlacement = ObjectPlacement;
      _this1199.Representation = Representation;
      _this1199.LongName = LongName;
      _this1199.CompositionType = CompositionType;
      _this1199.Elevation = Elevation;
      _this1199.type = 3124254112;
      return _this1199;
    }

    return IfcBuildingStorey;
  }(IfcSpatialStructureElement);

  IFC4_32.IfcBuildingStorey = IfcBuildingStorey;

  var IfcBuiltElementType = /*#__PURE__*/function (_IfcElementType10) {
    _inherits(IfcBuiltElementType, _IfcElementType10);

    var _super1208 = _createSuper(IfcBuiltElementType);

    function IfcBuiltElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1200;

      _classCallCheck2(this, IfcBuiltElementType);

      _this1200 = _super1208.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1200.GlobalId = GlobalId;
      _this1200.OwnerHistory = OwnerHistory;
      _this1200.Name = Name;
      _this1200.Description = Description;
      _this1200.ApplicableOccurrence = ApplicableOccurrence;
      _this1200.HasPropertySets = HasPropertySets;
      _this1200.RepresentationMaps = RepresentationMaps;
      _this1200.Tag = Tag;
      _this1200.ElementType = ElementType;
      _this1200.type = 1626504194;
      return _this1200;
    }

    return IfcBuiltElementType;
  }(IfcElementType);

  IFC4_32.IfcBuiltElementType = IfcBuiltElementType;

  var IfcChimneyType = /*#__PURE__*/function (_IfcBuiltElementType) {
    _inherits(IfcChimneyType, _IfcBuiltElementType);

    var _super1209 = _createSuper(IfcChimneyType);

    function IfcChimneyType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1201;

      _classCallCheck2(this, IfcChimneyType);

      _this1201 = _super1209.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1201.GlobalId = GlobalId;
      _this1201.OwnerHistory = OwnerHistory;
      _this1201.Name = Name;
      _this1201.Description = Description;
      _this1201.ApplicableOccurrence = ApplicableOccurrence;
      _this1201.HasPropertySets = HasPropertySets;
      _this1201.RepresentationMaps = RepresentationMaps;
      _this1201.Tag = Tag;
      _this1201.ElementType = ElementType;
      _this1201.PredefinedType = PredefinedType;
      _this1201.type = 2197970202;
      return _this1201;
    }

    return IfcChimneyType;
  }(IfcBuiltElementType);

  IFC4_32.IfcChimneyType = IfcChimneyType;

  var IfcCircleHollowProfileDef = /*#__PURE__*/function (_IfcCircleProfileDef2) {
    _inherits(IfcCircleHollowProfileDef, _IfcCircleProfileDef2);

    var _super1210 = _createSuper(IfcCircleHollowProfileDef);

    function IfcCircleHollowProfileDef(expressID, ProfileType, ProfileName, Position, Radius, WallThickness) {
      var _this1202;

      _classCallCheck2(this, IfcCircleHollowProfileDef);

      _this1202 = _super1210.call(this, expressID, ProfileType, ProfileName, Position, Radius);
      _this1202.ProfileType = ProfileType;
      _this1202.ProfileName = ProfileName;
      _this1202.Position = Position;
      _this1202.Radius = Radius;
      _this1202.WallThickness = WallThickness;
      _this1202.type = 2937912522;
      return _this1202;
    }

    return IfcCircleHollowProfileDef;
  }(IfcCircleProfileDef);

  IFC4_32.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;

  var IfcCivilElementType = /*#__PURE__*/function (_IfcElementType11) {
    _inherits(IfcCivilElementType, _IfcElementType11);

    var _super1211 = _createSuper(IfcCivilElementType);

    function IfcCivilElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1203;

      _classCallCheck2(this, IfcCivilElementType);

      _this1203 = _super1211.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1203.GlobalId = GlobalId;
      _this1203.OwnerHistory = OwnerHistory;
      _this1203.Name = Name;
      _this1203.Description = Description;
      _this1203.ApplicableOccurrence = ApplicableOccurrence;
      _this1203.HasPropertySets = HasPropertySets;
      _this1203.RepresentationMaps = RepresentationMaps;
      _this1203.Tag = Tag;
      _this1203.ElementType = ElementType;
      _this1203.type = 3893394355;
      return _this1203;
    }

    return IfcCivilElementType;
  }(IfcElementType);

  IFC4_32.IfcCivilElementType = IfcCivilElementType;

  var IfcClothoid = /*#__PURE__*/function (_IfcSpiral2) {
    _inherits(IfcClothoid, _IfcSpiral2);

    var _super1212 = _createSuper(IfcClothoid);

    function IfcClothoid(expressID, Position, ClothoidConstant) {
      var _this1204;

      _classCallCheck2(this, IfcClothoid);

      _this1204 = _super1212.call(this, expressID, Position);
      _this1204.Position = Position;
      _this1204.ClothoidConstant = ClothoidConstant;
      _this1204.type = 3497074424;
      return _this1204;
    }

    return IfcClothoid;
  }(IfcSpiral);

  IFC4_32.IfcClothoid = IfcClothoid;

  var IfcColumnType = /*#__PURE__*/function (_IfcBuiltElementType2) {
    _inherits(IfcColumnType, _IfcBuiltElementType2);

    var _super1213 = _createSuper(IfcColumnType);

    function IfcColumnType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1205;

      _classCallCheck2(this, IfcColumnType);

      _this1205 = _super1213.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1205.GlobalId = GlobalId;
      _this1205.OwnerHistory = OwnerHistory;
      _this1205.Name = Name;
      _this1205.Description = Description;
      _this1205.ApplicableOccurrence = ApplicableOccurrence;
      _this1205.HasPropertySets = HasPropertySets;
      _this1205.RepresentationMaps = RepresentationMaps;
      _this1205.Tag = Tag;
      _this1205.ElementType = ElementType;
      _this1205.PredefinedType = PredefinedType;
      _this1205.type = 300633059;
      return _this1205;
    }

    return IfcColumnType;
  }(IfcBuiltElementType);

  IFC4_32.IfcColumnType = IfcColumnType;

  var IfcComplexPropertyTemplate = /*#__PURE__*/function (_IfcPropertyTemplate2) {
    _inherits(IfcComplexPropertyTemplate, _IfcPropertyTemplate2);

    var _super1214 = _createSuper(IfcComplexPropertyTemplate);

    function IfcComplexPropertyTemplate(expressID, GlobalId, OwnerHistory, Name, Description, UsageName, TemplateType, HasPropertyTemplates) {
      var _this1206;

      _classCallCheck2(this, IfcComplexPropertyTemplate);

      _this1206 = _super1214.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1206.GlobalId = GlobalId;
      _this1206.OwnerHistory = OwnerHistory;
      _this1206.Name = Name;
      _this1206.Description = Description;
      _this1206.UsageName = UsageName;
      _this1206.TemplateType = TemplateType;
      _this1206.HasPropertyTemplates = HasPropertyTemplates;
      _this1206.type = 3875453745;
      return _this1206;
    }

    return IfcComplexPropertyTemplate;
  }(IfcPropertyTemplate);

  IFC4_32.IfcComplexPropertyTemplate = IfcComplexPropertyTemplate;

  var IfcCompositeCurve = /*#__PURE__*/function (_IfcBoundedCurve5) {
    _inherits(IfcCompositeCurve, _IfcBoundedCurve5);

    var _super1215 = _createSuper(IfcCompositeCurve);

    function IfcCompositeCurve(expressID, Segments, SelfIntersect) {
      var _this1207;

      _classCallCheck2(this, IfcCompositeCurve);

      _this1207 = _super1215.call(this, expressID);
      _this1207.Segments = Segments;
      _this1207.SelfIntersect = SelfIntersect;
      _this1207.type = 3732776249;
      return _this1207;
    }

    return IfcCompositeCurve;
  }(IfcBoundedCurve);

  IFC4_32.IfcCompositeCurve = IfcCompositeCurve;

  var IfcCompositeCurveOnSurface = /*#__PURE__*/function (_IfcCompositeCurve2) {
    _inherits(IfcCompositeCurveOnSurface, _IfcCompositeCurve2);

    var _super1216 = _createSuper(IfcCompositeCurveOnSurface);

    function IfcCompositeCurveOnSurface(expressID, Segments, SelfIntersect) {
      var _this1208;

      _classCallCheck2(this, IfcCompositeCurveOnSurface);

      _this1208 = _super1216.call(this, expressID, Segments, SelfIntersect);
      _this1208.Segments = Segments;
      _this1208.SelfIntersect = SelfIntersect;
      _this1208.type = 15328376;
      return _this1208;
    }

    return IfcCompositeCurveOnSurface;
  }(IfcCompositeCurve);

  IFC4_32.IfcCompositeCurveOnSurface = IfcCompositeCurveOnSurface;

  var IfcConic = /*#__PURE__*/function (_IfcCurve13) {
    _inherits(IfcConic, _IfcCurve13);

    var _super1217 = _createSuper(IfcConic);

    function IfcConic(expressID, Position) {
      var _this1209;

      _classCallCheck2(this, IfcConic);

      _this1209 = _super1217.call(this, expressID);
      _this1209.Position = Position;
      _this1209.type = 2510884976;
      return _this1209;
    }

    return IfcConic;
  }(IfcCurve);

  IFC4_32.IfcConic = IfcConic;

  var IfcConstructionEquipmentResourceType = /*#__PURE__*/function (_IfcConstructionResou10) {
    _inherits(IfcConstructionEquipmentResourceType, _IfcConstructionResou10);

    var _super1218 = _createSuper(IfcConstructionEquipmentResourceType);

    function IfcConstructionEquipmentResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1210;

      _classCallCheck2(this, IfcConstructionEquipmentResourceType);

      _this1210 = _super1218.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this1210.GlobalId = GlobalId;
      _this1210.OwnerHistory = OwnerHistory;
      _this1210.Name = Name;
      _this1210.Description = Description;
      _this1210.ApplicableOccurrence = ApplicableOccurrence;
      _this1210.HasPropertySets = HasPropertySets;
      _this1210.Identification = Identification;
      _this1210.LongDescription = LongDescription;
      _this1210.ResourceType = ResourceType;
      _this1210.BaseCosts = BaseCosts;
      _this1210.BaseQuantity = BaseQuantity;
      _this1210.PredefinedType = PredefinedType;
      _this1210.type = 2185764099;
      return _this1210;
    }

    return IfcConstructionEquipmentResourceType;
  }(IfcConstructionResourceType);

  IFC4_32.IfcConstructionEquipmentResourceType = IfcConstructionEquipmentResourceType;

  var IfcConstructionMaterialResourceType = /*#__PURE__*/function (_IfcConstructionResou11) {
    _inherits(IfcConstructionMaterialResourceType, _IfcConstructionResou11);

    var _super1219 = _createSuper(IfcConstructionMaterialResourceType);

    function IfcConstructionMaterialResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1211;

      _classCallCheck2(this, IfcConstructionMaterialResourceType);

      _this1211 = _super1219.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this1211.GlobalId = GlobalId;
      _this1211.OwnerHistory = OwnerHistory;
      _this1211.Name = Name;
      _this1211.Description = Description;
      _this1211.ApplicableOccurrence = ApplicableOccurrence;
      _this1211.HasPropertySets = HasPropertySets;
      _this1211.Identification = Identification;
      _this1211.LongDescription = LongDescription;
      _this1211.ResourceType = ResourceType;
      _this1211.BaseCosts = BaseCosts;
      _this1211.BaseQuantity = BaseQuantity;
      _this1211.PredefinedType = PredefinedType;
      _this1211.type = 4105962743;
      return _this1211;
    }

    return IfcConstructionMaterialResourceType;
  }(IfcConstructionResourceType);

  IFC4_32.IfcConstructionMaterialResourceType = IfcConstructionMaterialResourceType;

  var IfcConstructionProductResourceType = /*#__PURE__*/function (_IfcConstructionResou12) {
    _inherits(IfcConstructionProductResourceType, _IfcConstructionResou12);

    var _super1220 = _createSuper(IfcConstructionProductResourceType);

    function IfcConstructionProductResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1212;

      _classCallCheck2(this, IfcConstructionProductResourceType);

      _this1212 = _super1220.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this1212.GlobalId = GlobalId;
      _this1212.OwnerHistory = OwnerHistory;
      _this1212.Name = Name;
      _this1212.Description = Description;
      _this1212.ApplicableOccurrence = ApplicableOccurrence;
      _this1212.HasPropertySets = HasPropertySets;
      _this1212.Identification = Identification;
      _this1212.LongDescription = LongDescription;
      _this1212.ResourceType = ResourceType;
      _this1212.BaseCosts = BaseCosts;
      _this1212.BaseQuantity = BaseQuantity;
      _this1212.PredefinedType = PredefinedType;
      _this1212.type = 1525564444;
      return _this1212;
    }

    return IfcConstructionProductResourceType;
  }(IfcConstructionResourceType);

  IFC4_32.IfcConstructionProductResourceType = IfcConstructionProductResourceType;

  var IfcConstructionResource = /*#__PURE__*/function (_IfcResource2) {
    _inherits(IfcConstructionResource, _IfcResource2);

    var _super1221 = _createSuper(IfcConstructionResource);

    function IfcConstructionResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity) {
      var _this1213;

      _classCallCheck2(this, IfcConstructionResource);

      _this1213 = _super1221.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      _this1213.GlobalId = GlobalId;
      _this1213.OwnerHistory = OwnerHistory;
      _this1213.Name = Name;
      _this1213.Description = Description;
      _this1213.ObjectType = ObjectType;
      _this1213.Identification = Identification;
      _this1213.LongDescription = LongDescription;
      _this1213.Usage = Usage;
      _this1213.BaseCosts = BaseCosts;
      _this1213.BaseQuantity = BaseQuantity;
      _this1213.type = 2559216714;
      return _this1213;
    }

    return IfcConstructionResource;
  }(IfcResource);

  IFC4_32.IfcConstructionResource = IfcConstructionResource;

  var IfcControl = /*#__PURE__*/function (_IfcObject12) {
    _inherits(IfcControl, _IfcObject12);

    var _super1222 = _createSuper(IfcControl);

    function IfcControl(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification) {
      var _this1214;

      _classCallCheck2(this, IfcControl);

      _this1214 = _super1222.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1214.GlobalId = GlobalId;
      _this1214.OwnerHistory = OwnerHistory;
      _this1214.Name = Name;
      _this1214.Description = Description;
      _this1214.ObjectType = ObjectType;
      _this1214.Identification = Identification;
      _this1214.type = 3293443760;
      return _this1214;
    }

    return IfcControl;
  }(IfcObject);

  IFC4_32.IfcControl = IfcControl;

  var IfcCosineSpiral = /*#__PURE__*/function (_IfcSpiral3) {
    _inherits(IfcCosineSpiral, _IfcSpiral3);

    var _super1223 = _createSuper(IfcCosineSpiral);

    function IfcCosineSpiral(expressID, Position, CosineTerm, ConstantTerm) {
      var _this1215;

      _classCallCheck2(this, IfcCosineSpiral);

      _this1215 = _super1223.call(this, expressID, Position);
      _this1215.Position = Position;
      _this1215.CosineTerm = CosineTerm;
      _this1215.ConstantTerm = ConstantTerm;
      _this1215.type = 2000195564;
      return _this1215;
    }

    return IfcCosineSpiral;
  }(IfcSpiral);

  IFC4_32.IfcCosineSpiral = IfcCosineSpiral;

  var IfcCostItem = /*#__PURE__*/function (_IfcControl16) {
    _inherits(IfcCostItem, _IfcControl16);

    var _super1224 = _createSuper(IfcCostItem);

    function IfcCostItem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, CostValues, CostQuantities) {
      var _this1216;

      _classCallCheck2(this, IfcCostItem);

      _this1216 = _super1224.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this1216.GlobalId = GlobalId;
      _this1216.OwnerHistory = OwnerHistory;
      _this1216.Name = Name;
      _this1216.Description = Description;
      _this1216.ObjectType = ObjectType;
      _this1216.Identification = Identification;
      _this1216.PredefinedType = PredefinedType;
      _this1216.CostValues = CostValues;
      _this1216.CostQuantities = CostQuantities;
      _this1216.type = 3895139033;
      return _this1216;
    }

    return IfcCostItem;
  }(IfcControl);

  IFC4_32.IfcCostItem = IfcCostItem;

  var IfcCostSchedule = /*#__PURE__*/function (_IfcControl17) {
    _inherits(IfcCostSchedule, _IfcControl17);

    var _super1225 = _createSuper(IfcCostSchedule);

    function IfcCostSchedule(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, SubmittedOn, UpdateDate) {
      var _this1217;

      _classCallCheck2(this, IfcCostSchedule);

      _this1217 = _super1225.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this1217.GlobalId = GlobalId;
      _this1217.OwnerHistory = OwnerHistory;
      _this1217.Name = Name;
      _this1217.Description = Description;
      _this1217.ObjectType = ObjectType;
      _this1217.Identification = Identification;
      _this1217.PredefinedType = PredefinedType;
      _this1217.Status = Status;
      _this1217.SubmittedOn = SubmittedOn;
      _this1217.UpdateDate = UpdateDate;
      _this1217.type = 1419761937;
      return _this1217;
    }

    return IfcCostSchedule;
  }(IfcControl);

  IFC4_32.IfcCostSchedule = IfcCostSchedule;

  var IfcCourseType = /*#__PURE__*/function (_IfcBuiltElementType3) {
    _inherits(IfcCourseType, _IfcBuiltElementType3);

    var _super1226 = _createSuper(IfcCourseType);

    function IfcCourseType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1218;

      _classCallCheck2(this, IfcCourseType);

      _this1218 = _super1226.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1218.GlobalId = GlobalId;
      _this1218.OwnerHistory = OwnerHistory;
      _this1218.Name = Name;
      _this1218.Description = Description;
      _this1218.ApplicableOccurrence = ApplicableOccurrence;
      _this1218.HasPropertySets = HasPropertySets;
      _this1218.RepresentationMaps = RepresentationMaps;
      _this1218.Tag = Tag;
      _this1218.ElementType = ElementType;
      _this1218.PredefinedType = PredefinedType;
      _this1218.type = 4189326743;
      return _this1218;
    }

    return IfcCourseType;
  }(IfcBuiltElementType);

  IFC4_32.IfcCourseType = IfcCourseType;

  var IfcCoveringType = /*#__PURE__*/function (_IfcBuiltElementType4) {
    _inherits(IfcCoveringType, _IfcBuiltElementType4);

    var _super1227 = _createSuper(IfcCoveringType);

    function IfcCoveringType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1219;

      _classCallCheck2(this, IfcCoveringType);

      _this1219 = _super1227.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1219.GlobalId = GlobalId;
      _this1219.OwnerHistory = OwnerHistory;
      _this1219.Name = Name;
      _this1219.Description = Description;
      _this1219.ApplicableOccurrence = ApplicableOccurrence;
      _this1219.HasPropertySets = HasPropertySets;
      _this1219.RepresentationMaps = RepresentationMaps;
      _this1219.Tag = Tag;
      _this1219.ElementType = ElementType;
      _this1219.PredefinedType = PredefinedType;
      _this1219.type = 1916426348;
      return _this1219;
    }

    return IfcCoveringType;
  }(IfcBuiltElementType);

  IFC4_32.IfcCoveringType = IfcCoveringType;

  var IfcCrewResource = /*#__PURE__*/function (_IfcConstructionResou13) {
    _inherits(IfcCrewResource, _IfcConstructionResou13);

    var _super1228 = _createSuper(IfcCrewResource);

    function IfcCrewResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1220;

      _classCallCheck2(this, IfcCrewResource);

      _this1220 = _super1228.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this1220.GlobalId = GlobalId;
      _this1220.OwnerHistory = OwnerHistory;
      _this1220.Name = Name;
      _this1220.Description = Description;
      _this1220.ObjectType = ObjectType;
      _this1220.Identification = Identification;
      _this1220.LongDescription = LongDescription;
      _this1220.Usage = Usage;
      _this1220.BaseCosts = BaseCosts;
      _this1220.BaseQuantity = BaseQuantity;
      _this1220.PredefinedType = PredefinedType;
      _this1220.type = 3295246426;
      return _this1220;
    }

    return IfcCrewResource;
  }(IfcConstructionResource);

  IFC4_32.IfcCrewResource = IfcCrewResource;

  var IfcCurtainWallType = /*#__PURE__*/function (_IfcBuiltElementType5) {
    _inherits(IfcCurtainWallType, _IfcBuiltElementType5);

    var _super1229 = _createSuper(IfcCurtainWallType);

    function IfcCurtainWallType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1221;

      _classCallCheck2(this, IfcCurtainWallType);

      _this1221 = _super1229.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1221.GlobalId = GlobalId;
      _this1221.OwnerHistory = OwnerHistory;
      _this1221.Name = Name;
      _this1221.Description = Description;
      _this1221.ApplicableOccurrence = ApplicableOccurrence;
      _this1221.HasPropertySets = HasPropertySets;
      _this1221.RepresentationMaps = RepresentationMaps;
      _this1221.Tag = Tag;
      _this1221.ElementType = ElementType;
      _this1221.PredefinedType = PredefinedType;
      _this1221.type = 1457835157;
      return _this1221;
    }

    return IfcCurtainWallType;
  }(IfcBuiltElementType);

  IFC4_32.IfcCurtainWallType = IfcCurtainWallType;

  var IfcCylindricalSurface = /*#__PURE__*/function (_IfcElementarySurface5) {
    _inherits(IfcCylindricalSurface, _IfcElementarySurface5);

    var _super1230 = _createSuper(IfcCylindricalSurface);

    function IfcCylindricalSurface(expressID, Position, Radius) {
      var _this1222;

      _classCallCheck2(this, IfcCylindricalSurface);

      _this1222 = _super1230.call(this, expressID, Position);
      _this1222.Position = Position;
      _this1222.Radius = Radius;
      _this1222.type = 1213902940;
      return _this1222;
    }

    return IfcCylindricalSurface;
  }(IfcElementarySurface);

  IFC4_32.IfcCylindricalSurface = IfcCylindricalSurface;

  var IfcDeepFoundationType = /*#__PURE__*/function (_IfcBuiltElementType6) {
    _inherits(IfcDeepFoundationType, _IfcBuiltElementType6);

    var _super1231 = _createSuper(IfcDeepFoundationType);

    function IfcDeepFoundationType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1223;

      _classCallCheck2(this, IfcDeepFoundationType);

      _this1223 = _super1231.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1223.GlobalId = GlobalId;
      _this1223.OwnerHistory = OwnerHistory;
      _this1223.Name = Name;
      _this1223.Description = Description;
      _this1223.ApplicableOccurrence = ApplicableOccurrence;
      _this1223.HasPropertySets = HasPropertySets;
      _this1223.RepresentationMaps = RepresentationMaps;
      _this1223.Tag = Tag;
      _this1223.ElementType = ElementType;
      _this1223.type = 1306400036;
      return _this1223;
    }

    return IfcDeepFoundationType;
  }(IfcBuiltElementType);

  IFC4_32.IfcDeepFoundationType = IfcDeepFoundationType;

  var IfcDirectrixDerivedReferenceSweptAreaSolid = /*#__PURE__*/function (_IfcFixedReferenceSwe) {
    _inherits(IfcDirectrixDerivedReferenceSweptAreaSolid, _IfcFixedReferenceSwe);

    var _super1232 = _createSuper(IfcDirectrixDerivedReferenceSweptAreaSolid);

    function IfcDirectrixDerivedReferenceSweptAreaSolid(expressID, SweptArea, Position, Directrix, StartParam, EndParam, FixedReference) {
      var _this1224;

      _classCallCheck2(this, IfcDirectrixDerivedReferenceSweptAreaSolid);

      _this1224 = _super1232.call(this, expressID, SweptArea, Position, Directrix, StartParam, EndParam, FixedReference);
      _this1224.SweptArea = SweptArea;
      _this1224.Position = Position;
      _this1224.Directrix = Directrix;
      _this1224.StartParam = StartParam;
      _this1224.EndParam = EndParam;
      _this1224.FixedReference = FixedReference;
      _this1224.type = 4234616927;
      return _this1224;
    }

    return IfcDirectrixDerivedReferenceSweptAreaSolid;
  }(IfcFixedReferenceSweptAreaSolid);

  IFC4_32.IfcDirectrixDerivedReferenceSweptAreaSolid = IfcDirectrixDerivedReferenceSweptAreaSolid;

  var IfcDistributionElementType = /*#__PURE__*/function (_IfcElementType12) {
    _inherits(IfcDistributionElementType, _IfcElementType12);

    var _super1233 = _createSuper(IfcDistributionElementType);

    function IfcDistributionElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1225;

      _classCallCheck2(this, IfcDistributionElementType);

      _this1225 = _super1233.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1225.GlobalId = GlobalId;
      _this1225.OwnerHistory = OwnerHistory;
      _this1225.Name = Name;
      _this1225.Description = Description;
      _this1225.ApplicableOccurrence = ApplicableOccurrence;
      _this1225.HasPropertySets = HasPropertySets;
      _this1225.RepresentationMaps = RepresentationMaps;
      _this1225.Tag = Tag;
      _this1225.ElementType = ElementType;
      _this1225.type = 3256556792;
      return _this1225;
    }

    return IfcDistributionElementType;
  }(IfcElementType);

  IFC4_32.IfcDistributionElementType = IfcDistributionElementType;

  var IfcDistributionFlowElementType = /*#__PURE__*/function (_IfcDistributionEleme5) {
    _inherits(IfcDistributionFlowElementType, _IfcDistributionEleme5);

    var _super1234 = _createSuper(IfcDistributionFlowElementType);

    function IfcDistributionFlowElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1226;

      _classCallCheck2(this, IfcDistributionFlowElementType);

      _this1226 = _super1234.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1226.GlobalId = GlobalId;
      _this1226.OwnerHistory = OwnerHistory;
      _this1226.Name = Name;
      _this1226.Description = Description;
      _this1226.ApplicableOccurrence = ApplicableOccurrence;
      _this1226.HasPropertySets = HasPropertySets;
      _this1226.RepresentationMaps = RepresentationMaps;
      _this1226.Tag = Tag;
      _this1226.ElementType = ElementType;
      _this1226.type = 3849074793;
      return _this1226;
    }

    return IfcDistributionFlowElementType;
  }(IfcDistributionElementType);

  IFC4_32.IfcDistributionFlowElementType = IfcDistributionFlowElementType;

  var IfcDoorLiningProperties = /*#__PURE__*/function (_IfcPreDefinedPropert7) {
    _inherits(IfcDoorLiningProperties, _IfcPreDefinedPropert7);

    var _super1235 = _createSuper(IfcDoorLiningProperties);

    function IfcDoorLiningProperties(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      var _this1227;

      _classCallCheck2(this, IfcDoorLiningProperties);

      _this1227 = _super1235.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1227.GlobalId = GlobalId;
      _this1227.OwnerHistory = OwnerHistory;
      _this1227.Name = Name;
      _this1227.Description = Description;
      _this1227.LiningDepth = LiningDepth;
      _this1227.LiningThickness = LiningThickness;
      _this1227.ThresholdDepth = ThresholdDepth;
      _this1227.ThresholdThickness = ThresholdThickness;
      _this1227.TransomThickness = TransomThickness;
      _this1227.TransomOffset = TransomOffset;
      _this1227.LiningOffset = LiningOffset;
      _this1227.ThresholdOffset = ThresholdOffset;
      _this1227.CasingThickness = CasingThickness;
      _this1227.CasingDepth = CasingDepth;
      _this1227.ShapeAspectStyle = ShapeAspectStyle;
      _this1227.LiningToPanelOffsetX = LiningToPanelOffsetX;
      _this1227.LiningToPanelOffsetY = LiningToPanelOffsetY;
      _this1227.type = 2963535650;
      return _this1227;
    }

    return IfcDoorLiningProperties;
  }(IfcPreDefinedPropertySet);

  IFC4_32.IfcDoorLiningProperties = IfcDoorLiningProperties;

  var IfcDoorPanelProperties = /*#__PURE__*/function (_IfcPreDefinedPropert8) {
    _inherits(IfcDoorPanelProperties, _IfcPreDefinedPropert8);

    var _super1236 = _createSuper(IfcDoorPanelProperties);

    function IfcDoorPanelProperties(expressID, GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle) {
      var _this1228;

      _classCallCheck2(this, IfcDoorPanelProperties);

      _this1228 = _super1236.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1228.GlobalId = GlobalId;
      _this1228.OwnerHistory = OwnerHistory;
      _this1228.Name = Name;
      _this1228.Description = Description;
      _this1228.PanelDepth = PanelDepth;
      _this1228.PanelOperation = PanelOperation;
      _this1228.PanelWidth = PanelWidth;
      _this1228.PanelPosition = PanelPosition;
      _this1228.ShapeAspectStyle = ShapeAspectStyle;
      _this1228.type = 1714330368;
      return _this1228;
    }

    return IfcDoorPanelProperties;
  }(IfcPreDefinedPropertySet);

  IFC4_32.IfcDoorPanelProperties = IfcDoorPanelProperties;

  var IfcDoorType = /*#__PURE__*/function (_IfcBuiltElementType7) {
    _inherits(IfcDoorType, _IfcBuiltElementType7);

    var _super1237 = _createSuper(IfcDoorType);

    function IfcDoorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, OperationType, ParameterTakesPrecedence, UserDefinedOperationType) {
      var _this1229;

      _classCallCheck2(this, IfcDoorType);

      _this1229 = _super1237.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1229.GlobalId = GlobalId;
      _this1229.OwnerHistory = OwnerHistory;
      _this1229.Name = Name;
      _this1229.Description = Description;
      _this1229.ApplicableOccurrence = ApplicableOccurrence;
      _this1229.HasPropertySets = HasPropertySets;
      _this1229.RepresentationMaps = RepresentationMaps;
      _this1229.Tag = Tag;
      _this1229.ElementType = ElementType;
      _this1229.PredefinedType = PredefinedType;
      _this1229.OperationType = OperationType;
      _this1229.ParameterTakesPrecedence = ParameterTakesPrecedence;
      _this1229.UserDefinedOperationType = UserDefinedOperationType;
      _this1229.type = 2323601079;
      return _this1229;
    }

    return IfcDoorType;
  }(IfcBuiltElementType);

  IFC4_32.IfcDoorType = IfcDoorType;

  var IfcDraughtingPreDefinedColour = /*#__PURE__*/function (_IfcPreDefinedColour2) {
    _inherits(IfcDraughtingPreDefinedColour, _IfcPreDefinedColour2);

    var _super1238 = _createSuper(IfcDraughtingPreDefinedColour);

    function IfcDraughtingPreDefinedColour(expressID, Name) {
      var _this1230;

      _classCallCheck2(this, IfcDraughtingPreDefinedColour);

      _this1230 = _super1238.call(this, expressID, Name);
      _this1230.Name = Name;
      _this1230.type = 445594917;
      return _this1230;
    }

    return IfcDraughtingPreDefinedColour;
  }(IfcPreDefinedColour);

  IFC4_32.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;

  var IfcDraughtingPreDefinedCurveFont = /*#__PURE__*/function (_IfcPreDefinedCurveFo2) {
    _inherits(IfcDraughtingPreDefinedCurveFont, _IfcPreDefinedCurveFo2);

    var _super1239 = _createSuper(IfcDraughtingPreDefinedCurveFont);

    function IfcDraughtingPreDefinedCurveFont(expressID, Name) {
      var _this1231;

      _classCallCheck2(this, IfcDraughtingPreDefinedCurveFont);

      _this1231 = _super1239.call(this, expressID, Name);
      _this1231.Name = Name;
      _this1231.type = 4006246654;
      return _this1231;
    }

    return IfcDraughtingPreDefinedCurveFont;
  }(IfcPreDefinedCurveFont);

  IFC4_32.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;

  var IfcElement = /*#__PURE__*/function (_IfcProduct13) {
    _inherits(IfcElement, _IfcProduct13);

    var _super1240 = _createSuper(IfcElement);

    function IfcElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1232;

      _classCallCheck2(this, IfcElement);

      _this1232 = _super1240.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1232.GlobalId = GlobalId;
      _this1232.OwnerHistory = OwnerHistory;
      _this1232.Name = Name;
      _this1232.Description = Description;
      _this1232.ObjectType = ObjectType;
      _this1232.ObjectPlacement = ObjectPlacement;
      _this1232.Representation = Representation;
      _this1232.Tag = Tag;
      _this1232.type = 1758889154;
      return _this1232;
    }

    return IfcElement;
  }(IfcProduct);

  IFC4_32.IfcElement = IfcElement;

  var IfcElementAssembly = /*#__PURE__*/function (_IfcElement11) {
    _inherits(IfcElementAssembly, _IfcElement11);

    var _super1241 = _createSuper(IfcElementAssembly);

    function IfcElementAssembly(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType) {
      var _this1233;

      _classCallCheck2(this, IfcElementAssembly);

      _this1233 = _super1241.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1233.GlobalId = GlobalId;
      _this1233.OwnerHistory = OwnerHistory;
      _this1233.Name = Name;
      _this1233.Description = Description;
      _this1233.ObjectType = ObjectType;
      _this1233.ObjectPlacement = ObjectPlacement;
      _this1233.Representation = Representation;
      _this1233.Tag = Tag;
      _this1233.AssemblyPlace = AssemblyPlace;
      _this1233.PredefinedType = PredefinedType;
      _this1233.type = 4123344466;
      return _this1233;
    }

    return IfcElementAssembly;
  }(IfcElement);

  IFC4_32.IfcElementAssembly = IfcElementAssembly;

  var IfcElementAssemblyType = /*#__PURE__*/function (_IfcElementType13) {
    _inherits(IfcElementAssemblyType, _IfcElementType13);

    var _super1242 = _createSuper(IfcElementAssemblyType);

    function IfcElementAssemblyType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1234;

      _classCallCheck2(this, IfcElementAssemblyType);

      _this1234 = _super1242.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1234.GlobalId = GlobalId;
      _this1234.OwnerHistory = OwnerHistory;
      _this1234.Name = Name;
      _this1234.Description = Description;
      _this1234.ApplicableOccurrence = ApplicableOccurrence;
      _this1234.HasPropertySets = HasPropertySets;
      _this1234.RepresentationMaps = RepresentationMaps;
      _this1234.Tag = Tag;
      _this1234.ElementType = ElementType;
      _this1234.PredefinedType = PredefinedType;
      _this1234.type = 2397081782;
      return _this1234;
    }

    return IfcElementAssemblyType;
  }(IfcElementType);

  IFC4_32.IfcElementAssemblyType = IfcElementAssemblyType;

  var IfcElementComponent = /*#__PURE__*/function (_IfcElement12) {
    _inherits(IfcElementComponent, _IfcElement12);

    var _super1243 = _createSuper(IfcElementComponent);

    function IfcElementComponent(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1235;

      _classCallCheck2(this, IfcElementComponent);

      _this1235 = _super1243.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1235.GlobalId = GlobalId;
      _this1235.OwnerHistory = OwnerHistory;
      _this1235.Name = Name;
      _this1235.Description = Description;
      _this1235.ObjectType = ObjectType;
      _this1235.ObjectPlacement = ObjectPlacement;
      _this1235.Representation = Representation;
      _this1235.Tag = Tag;
      _this1235.type = 1623761950;
      return _this1235;
    }

    return IfcElementComponent;
  }(IfcElement);

  IFC4_32.IfcElementComponent = IfcElementComponent;

  var IfcElementComponentType = /*#__PURE__*/function (_IfcElementType14) {
    _inherits(IfcElementComponentType, _IfcElementType14);

    var _super1244 = _createSuper(IfcElementComponentType);

    function IfcElementComponentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1236;

      _classCallCheck2(this, IfcElementComponentType);

      _this1236 = _super1244.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1236.GlobalId = GlobalId;
      _this1236.OwnerHistory = OwnerHistory;
      _this1236.Name = Name;
      _this1236.Description = Description;
      _this1236.ApplicableOccurrence = ApplicableOccurrence;
      _this1236.HasPropertySets = HasPropertySets;
      _this1236.RepresentationMaps = RepresentationMaps;
      _this1236.Tag = Tag;
      _this1236.ElementType = ElementType;
      _this1236.type = 2590856083;
      return _this1236;
    }

    return IfcElementComponentType;
  }(IfcElementType);

  IFC4_32.IfcElementComponentType = IfcElementComponentType;

  var IfcEllipse = /*#__PURE__*/function (_IfcConic3) {
    _inherits(IfcEllipse, _IfcConic3);

    var _super1245 = _createSuper(IfcEllipse);

    function IfcEllipse(expressID, Position, SemiAxis1, SemiAxis2) {
      var _this1237;

      _classCallCheck2(this, IfcEllipse);

      _this1237 = _super1245.call(this, expressID, Position);
      _this1237.Position = Position;
      _this1237.SemiAxis1 = SemiAxis1;
      _this1237.SemiAxis2 = SemiAxis2;
      _this1237.type = 1704287377;
      return _this1237;
    }

    return IfcEllipse;
  }(IfcConic);

  IFC4_32.IfcEllipse = IfcEllipse;

  var IfcEnergyConversionDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE19) {
    _inherits(IfcEnergyConversionDeviceType, _IfcDistributionFlowE19);

    var _super1246 = _createSuper(IfcEnergyConversionDeviceType);

    function IfcEnergyConversionDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1238;

      _classCallCheck2(this, IfcEnergyConversionDeviceType);

      _this1238 = _super1246.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1238.GlobalId = GlobalId;
      _this1238.OwnerHistory = OwnerHistory;
      _this1238.Name = Name;
      _this1238.Description = Description;
      _this1238.ApplicableOccurrence = ApplicableOccurrence;
      _this1238.HasPropertySets = HasPropertySets;
      _this1238.RepresentationMaps = RepresentationMaps;
      _this1238.Tag = Tag;
      _this1238.ElementType = ElementType;
      _this1238.type = 2107101300;
      return _this1238;
    }

    return IfcEnergyConversionDeviceType;
  }(IfcDistributionFlowElementType);

  IFC4_32.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;

  var IfcEngineType = /*#__PURE__*/function (_IfcEnergyConversionD19) {
    _inherits(IfcEngineType, _IfcEnergyConversionD19);

    var _super1247 = _createSuper(IfcEngineType);

    function IfcEngineType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1239;

      _classCallCheck2(this, IfcEngineType);

      _this1239 = _super1247.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1239.GlobalId = GlobalId;
      _this1239.OwnerHistory = OwnerHistory;
      _this1239.Name = Name;
      _this1239.Description = Description;
      _this1239.ApplicableOccurrence = ApplicableOccurrence;
      _this1239.HasPropertySets = HasPropertySets;
      _this1239.RepresentationMaps = RepresentationMaps;
      _this1239.Tag = Tag;
      _this1239.ElementType = ElementType;
      _this1239.PredefinedType = PredefinedType;
      _this1239.type = 132023988;
      return _this1239;
    }

    return IfcEngineType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcEngineType = IfcEngineType;

  var IfcEvaporativeCoolerType = /*#__PURE__*/function (_IfcEnergyConversionD20) {
    _inherits(IfcEvaporativeCoolerType, _IfcEnergyConversionD20);

    var _super1248 = _createSuper(IfcEvaporativeCoolerType);

    function IfcEvaporativeCoolerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1240;

      _classCallCheck2(this, IfcEvaporativeCoolerType);

      _this1240 = _super1248.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1240.GlobalId = GlobalId;
      _this1240.OwnerHistory = OwnerHistory;
      _this1240.Name = Name;
      _this1240.Description = Description;
      _this1240.ApplicableOccurrence = ApplicableOccurrence;
      _this1240.HasPropertySets = HasPropertySets;
      _this1240.RepresentationMaps = RepresentationMaps;
      _this1240.Tag = Tag;
      _this1240.ElementType = ElementType;
      _this1240.PredefinedType = PredefinedType;
      _this1240.type = 3174744832;
      return _this1240;
    }

    return IfcEvaporativeCoolerType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;

  var IfcEvaporatorType = /*#__PURE__*/function (_IfcEnergyConversionD21) {
    _inherits(IfcEvaporatorType, _IfcEnergyConversionD21);

    var _super1249 = _createSuper(IfcEvaporatorType);

    function IfcEvaporatorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1241;

      _classCallCheck2(this, IfcEvaporatorType);

      _this1241 = _super1249.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1241.GlobalId = GlobalId;
      _this1241.OwnerHistory = OwnerHistory;
      _this1241.Name = Name;
      _this1241.Description = Description;
      _this1241.ApplicableOccurrence = ApplicableOccurrence;
      _this1241.HasPropertySets = HasPropertySets;
      _this1241.RepresentationMaps = RepresentationMaps;
      _this1241.Tag = Tag;
      _this1241.ElementType = ElementType;
      _this1241.PredefinedType = PredefinedType;
      _this1241.type = 3390157468;
      return _this1241;
    }

    return IfcEvaporatorType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcEvaporatorType = IfcEvaporatorType;

  var IfcEvent = /*#__PURE__*/function (_IfcProcess4) {
    _inherits(IfcEvent, _IfcProcess4);

    var _super1250 = _createSuper(IfcEvent);

    function IfcEvent(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType, EventTriggerType, UserDefinedEventTriggerType, EventOccurenceTime) {
      var _this1242;

      _classCallCheck2(this, IfcEvent);

      _this1242 = _super1250.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      _this1242.GlobalId = GlobalId;
      _this1242.OwnerHistory = OwnerHistory;
      _this1242.Name = Name;
      _this1242.Description = Description;
      _this1242.ObjectType = ObjectType;
      _this1242.Identification = Identification;
      _this1242.LongDescription = LongDescription;
      _this1242.PredefinedType = PredefinedType;
      _this1242.EventTriggerType = EventTriggerType;
      _this1242.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      _this1242.EventOccurenceTime = EventOccurenceTime;
      _this1242.type = 4148101412;
      return _this1242;
    }

    return IfcEvent;
  }(IfcProcess);

  IFC4_32.IfcEvent = IfcEvent;

  var IfcExternalSpatialStructureElement = /*#__PURE__*/function (_IfcSpatialElement3) {
    _inherits(IfcExternalSpatialStructureElement, _IfcSpatialElement3);

    var _super1251 = _createSuper(IfcExternalSpatialStructureElement);

    function IfcExternalSpatialStructureElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      var _this1243;

      _classCallCheck2(this, IfcExternalSpatialStructureElement);

      _this1243 = _super1251.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      _this1243.GlobalId = GlobalId;
      _this1243.OwnerHistory = OwnerHistory;
      _this1243.Name = Name;
      _this1243.Description = Description;
      _this1243.ObjectType = ObjectType;
      _this1243.ObjectPlacement = ObjectPlacement;
      _this1243.Representation = Representation;
      _this1243.LongName = LongName;
      _this1243.type = 2853485674;
      return _this1243;
    }

    return IfcExternalSpatialStructureElement;
  }(IfcSpatialElement);

  IFC4_32.IfcExternalSpatialStructureElement = IfcExternalSpatialStructureElement;

  var IfcFacetedBrep = /*#__PURE__*/function (_IfcManifoldSolidBrep4) {
    _inherits(IfcFacetedBrep, _IfcManifoldSolidBrep4);

    var _super1252 = _createSuper(IfcFacetedBrep);

    function IfcFacetedBrep(expressID, Outer) {
      var _this1244;

      _classCallCheck2(this, IfcFacetedBrep);

      _this1244 = _super1252.call(this, expressID, Outer);
      _this1244.Outer = Outer;
      _this1244.type = 807026263;
      return _this1244;
    }

    return IfcFacetedBrep;
  }(IfcManifoldSolidBrep);

  IFC4_32.IfcFacetedBrep = IfcFacetedBrep;

  var IfcFacetedBrepWithVoids = /*#__PURE__*/function (_IfcFacetedBrep) {
    _inherits(IfcFacetedBrepWithVoids, _IfcFacetedBrep);

    var _super1253 = _createSuper(IfcFacetedBrepWithVoids);

    function IfcFacetedBrepWithVoids(expressID, Outer, Voids) {
      var _this1245;

      _classCallCheck2(this, IfcFacetedBrepWithVoids);

      _this1245 = _super1253.call(this, expressID, Outer);
      _this1245.Outer = Outer;
      _this1245.Voids = Voids;
      _this1245.type = 3737207727;
      return _this1245;
    }

    return IfcFacetedBrepWithVoids;
  }(IfcFacetedBrep);

  IFC4_32.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;

  var IfcFacility = /*#__PURE__*/function (_IfcSpatialStructureE7) {
    _inherits(IfcFacility, _IfcSpatialStructureE7);

    var _super1254 = _createSuper(IfcFacility);

    function IfcFacility(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      var _this1246;

      _classCallCheck2(this, IfcFacility);

      _this1246 = _super1254.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this1246.GlobalId = GlobalId;
      _this1246.OwnerHistory = OwnerHistory;
      _this1246.Name = Name;
      _this1246.Description = Description;
      _this1246.ObjectType = ObjectType;
      _this1246.ObjectPlacement = ObjectPlacement;
      _this1246.Representation = Representation;
      _this1246.LongName = LongName;
      _this1246.CompositionType = CompositionType;
      _this1246.type = 24185140;
      return _this1246;
    }

    return IfcFacility;
  }(IfcSpatialStructureElement);

  IFC4_32.IfcFacility = IfcFacility;

  var IfcFacilityPart = /*#__PURE__*/function (_IfcSpatialStructureE8) {
    _inherits(IfcFacilityPart, _IfcSpatialStructureE8);

    var _super1255 = _createSuper(IfcFacilityPart);

    function IfcFacilityPart(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType) {
      var _this1247;

      _classCallCheck2(this, IfcFacilityPart);

      _this1247 = _super1255.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this1247.GlobalId = GlobalId;
      _this1247.OwnerHistory = OwnerHistory;
      _this1247.Name = Name;
      _this1247.Description = Description;
      _this1247.ObjectType = ObjectType;
      _this1247.ObjectPlacement = ObjectPlacement;
      _this1247.Representation = Representation;
      _this1247.LongName = LongName;
      _this1247.CompositionType = CompositionType;
      _this1247.UsageType = UsageType;
      _this1247.type = 1310830890;
      return _this1247;
    }

    return IfcFacilityPart;
  }(IfcSpatialStructureElement);

  IFC4_32.IfcFacilityPart = IfcFacilityPart;

  var IfcFacilityPartCommon = /*#__PURE__*/function (_IfcFacilityPart) {
    _inherits(IfcFacilityPartCommon, _IfcFacilityPart);

    var _super1256 = _createSuper(IfcFacilityPartCommon);

    function IfcFacilityPartCommon(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      var _this1248;

      _classCallCheck2(this, IfcFacilityPartCommon);

      _this1248 = _super1256.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      _this1248.GlobalId = GlobalId;
      _this1248.OwnerHistory = OwnerHistory;
      _this1248.Name = Name;
      _this1248.Description = Description;
      _this1248.ObjectType = ObjectType;
      _this1248.ObjectPlacement = ObjectPlacement;
      _this1248.Representation = Representation;
      _this1248.LongName = LongName;
      _this1248.CompositionType = CompositionType;
      _this1248.UsageType = UsageType;
      _this1248.PredefinedType = PredefinedType;
      _this1248.type = 4228831410;
      return _this1248;
    }

    return IfcFacilityPartCommon;
  }(IfcFacilityPart);

  IFC4_32.IfcFacilityPartCommon = IfcFacilityPartCommon;

  var IfcFastener = /*#__PURE__*/function (_IfcElementComponent3) {
    _inherits(IfcFastener, _IfcElementComponent3);

    var _super1257 = _createSuper(IfcFastener);

    function IfcFastener(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1249;

      _classCallCheck2(this, IfcFastener);

      _this1249 = _super1257.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1249.GlobalId = GlobalId;
      _this1249.OwnerHistory = OwnerHistory;
      _this1249.Name = Name;
      _this1249.Description = Description;
      _this1249.ObjectType = ObjectType;
      _this1249.ObjectPlacement = ObjectPlacement;
      _this1249.Representation = Representation;
      _this1249.Tag = Tag;
      _this1249.PredefinedType = PredefinedType;
      _this1249.type = 647756555;
      return _this1249;
    }

    return IfcFastener;
  }(IfcElementComponent);

  IFC4_32.IfcFastener = IfcFastener;

  var IfcFastenerType = /*#__PURE__*/function (_IfcElementComponentT3) {
    _inherits(IfcFastenerType, _IfcElementComponentT3);

    var _super1258 = _createSuper(IfcFastenerType);

    function IfcFastenerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1250;

      _classCallCheck2(this, IfcFastenerType);

      _this1250 = _super1258.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1250.GlobalId = GlobalId;
      _this1250.OwnerHistory = OwnerHistory;
      _this1250.Name = Name;
      _this1250.Description = Description;
      _this1250.ApplicableOccurrence = ApplicableOccurrence;
      _this1250.HasPropertySets = HasPropertySets;
      _this1250.RepresentationMaps = RepresentationMaps;
      _this1250.Tag = Tag;
      _this1250.ElementType = ElementType;
      _this1250.PredefinedType = PredefinedType;
      _this1250.type = 2489546625;
      return _this1250;
    }

    return IfcFastenerType;
  }(IfcElementComponentType);

  IFC4_32.IfcFastenerType = IfcFastenerType;

  var IfcFeatureElement = /*#__PURE__*/function (_IfcElement13) {
    _inherits(IfcFeatureElement, _IfcElement13);

    var _super1259 = _createSuper(IfcFeatureElement);

    function IfcFeatureElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1251;

      _classCallCheck2(this, IfcFeatureElement);

      _this1251 = _super1259.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1251.GlobalId = GlobalId;
      _this1251.OwnerHistory = OwnerHistory;
      _this1251.Name = Name;
      _this1251.Description = Description;
      _this1251.ObjectType = ObjectType;
      _this1251.ObjectPlacement = ObjectPlacement;
      _this1251.Representation = Representation;
      _this1251.Tag = Tag;
      _this1251.type = 2827207264;
      return _this1251;
    }

    return IfcFeatureElement;
  }(IfcElement);

  IFC4_32.IfcFeatureElement = IfcFeatureElement;

  var IfcFeatureElementAddition = /*#__PURE__*/function (_IfcFeatureElement3) {
    _inherits(IfcFeatureElementAddition, _IfcFeatureElement3);

    var _super1260 = _createSuper(IfcFeatureElementAddition);

    function IfcFeatureElementAddition(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1252;

      _classCallCheck2(this, IfcFeatureElementAddition);

      _this1252 = _super1260.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1252.GlobalId = GlobalId;
      _this1252.OwnerHistory = OwnerHistory;
      _this1252.Name = Name;
      _this1252.Description = Description;
      _this1252.ObjectType = ObjectType;
      _this1252.ObjectPlacement = ObjectPlacement;
      _this1252.Representation = Representation;
      _this1252.Tag = Tag;
      _this1252.type = 2143335405;
      return _this1252;
    }

    return IfcFeatureElementAddition;
  }(IfcFeatureElement);

  IFC4_32.IfcFeatureElementAddition = IfcFeatureElementAddition;

  var IfcFeatureElementSubtraction = /*#__PURE__*/function (_IfcFeatureElement4) {
    _inherits(IfcFeatureElementSubtraction, _IfcFeatureElement4);

    var _super1261 = _createSuper(IfcFeatureElementSubtraction);

    function IfcFeatureElementSubtraction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1253;

      _classCallCheck2(this, IfcFeatureElementSubtraction);

      _this1253 = _super1261.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1253.GlobalId = GlobalId;
      _this1253.OwnerHistory = OwnerHistory;
      _this1253.Name = Name;
      _this1253.Description = Description;
      _this1253.ObjectType = ObjectType;
      _this1253.ObjectPlacement = ObjectPlacement;
      _this1253.Representation = Representation;
      _this1253.Tag = Tag;
      _this1253.type = 1287392070;
      return _this1253;
    }

    return IfcFeatureElementSubtraction;
  }(IfcFeatureElement);

  IFC4_32.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;

  var IfcFlowControllerType = /*#__PURE__*/function (_IfcDistributionFlowE20) {
    _inherits(IfcFlowControllerType, _IfcDistributionFlowE20);

    var _super1262 = _createSuper(IfcFlowControllerType);

    function IfcFlowControllerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1254;

      _classCallCheck2(this, IfcFlowControllerType);

      _this1254 = _super1262.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1254.GlobalId = GlobalId;
      _this1254.OwnerHistory = OwnerHistory;
      _this1254.Name = Name;
      _this1254.Description = Description;
      _this1254.ApplicableOccurrence = ApplicableOccurrence;
      _this1254.HasPropertySets = HasPropertySets;
      _this1254.RepresentationMaps = RepresentationMaps;
      _this1254.Tag = Tag;
      _this1254.ElementType = ElementType;
      _this1254.type = 3907093117;
      return _this1254;
    }

    return IfcFlowControllerType;
  }(IfcDistributionFlowElementType);

  IFC4_32.IfcFlowControllerType = IfcFlowControllerType;

  var IfcFlowFittingType = /*#__PURE__*/function (_IfcDistributionFlowE21) {
    _inherits(IfcFlowFittingType, _IfcDistributionFlowE21);

    var _super1263 = _createSuper(IfcFlowFittingType);

    function IfcFlowFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1255;

      _classCallCheck2(this, IfcFlowFittingType);

      _this1255 = _super1263.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1255.GlobalId = GlobalId;
      _this1255.OwnerHistory = OwnerHistory;
      _this1255.Name = Name;
      _this1255.Description = Description;
      _this1255.ApplicableOccurrence = ApplicableOccurrence;
      _this1255.HasPropertySets = HasPropertySets;
      _this1255.RepresentationMaps = RepresentationMaps;
      _this1255.Tag = Tag;
      _this1255.ElementType = ElementType;
      _this1255.type = 3198132628;
      return _this1255;
    }

    return IfcFlowFittingType;
  }(IfcDistributionFlowElementType);

  IFC4_32.IfcFlowFittingType = IfcFlowFittingType;

  var IfcFlowMeterType = /*#__PURE__*/function (_IfcFlowControllerTyp8) {
    _inherits(IfcFlowMeterType, _IfcFlowControllerTyp8);

    var _super1264 = _createSuper(IfcFlowMeterType);

    function IfcFlowMeterType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1256;

      _classCallCheck2(this, IfcFlowMeterType);

      _this1256 = _super1264.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1256.GlobalId = GlobalId;
      _this1256.OwnerHistory = OwnerHistory;
      _this1256.Name = Name;
      _this1256.Description = Description;
      _this1256.ApplicableOccurrence = ApplicableOccurrence;
      _this1256.HasPropertySets = HasPropertySets;
      _this1256.RepresentationMaps = RepresentationMaps;
      _this1256.Tag = Tag;
      _this1256.ElementType = ElementType;
      _this1256.PredefinedType = PredefinedType;
      _this1256.type = 3815607619;
      return _this1256;
    }

    return IfcFlowMeterType;
  }(IfcFlowControllerType);

  IFC4_32.IfcFlowMeterType = IfcFlowMeterType;

  var IfcFlowMovingDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE22) {
    _inherits(IfcFlowMovingDeviceType, _IfcDistributionFlowE22);

    var _super1265 = _createSuper(IfcFlowMovingDeviceType);

    function IfcFlowMovingDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1257;

      _classCallCheck2(this, IfcFlowMovingDeviceType);

      _this1257 = _super1265.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1257.GlobalId = GlobalId;
      _this1257.OwnerHistory = OwnerHistory;
      _this1257.Name = Name;
      _this1257.Description = Description;
      _this1257.ApplicableOccurrence = ApplicableOccurrence;
      _this1257.HasPropertySets = HasPropertySets;
      _this1257.RepresentationMaps = RepresentationMaps;
      _this1257.Tag = Tag;
      _this1257.ElementType = ElementType;
      _this1257.type = 1482959167;
      return _this1257;
    }

    return IfcFlowMovingDeviceType;
  }(IfcDistributionFlowElementType);

  IFC4_32.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;

  var IfcFlowSegmentType = /*#__PURE__*/function (_IfcDistributionFlowE23) {
    _inherits(IfcFlowSegmentType, _IfcDistributionFlowE23);

    var _super1266 = _createSuper(IfcFlowSegmentType);

    function IfcFlowSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1258;

      _classCallCheck2(this, IfcFlowSegmentType);

      _this1258 = _super1266.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1258.GlobalId = GlobalId;
      _this1258.OwnerHistory = OwnerHistory;
      _this1258.Name = Name;
      _this1258.Description = Description;
      _this1258.ApplicableOccurrence = ApplicableOccurrence;
      _this1258.HasPropertySets = HasPropertySets;
      _this1258.RepresentationMaps = RepresentationMaps;
      _this1258.Tag = Tag;
      _this1258.ElementType = ElementType;
      _this1258.type = 1834744321;
      return _this1258;
    }

    return IfcFlowSegmentType;
  }(IfcDistributionFlowElementType);

  IFC4_32.IfcFlowSegmentType = IfcFlowSegmentType;

  var IfcFlowStorageDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE24) {
    _inherits(IfcFlowStorageDeviceType, _IfcDistributionFlowE24);

    var _super1267 = _createSuper(IfcFlowStorageDeviceType);

    function IfcFlowStorageDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1259;

      _classCallCheck2(this, IfcFlowStorageDeviceType);

      _this1259 = _super1267.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1259.GlobalId = GlobalId;
      _this1259.OwnerHistory = OwnerHistory;
      _this1259.Name = Name;
      _this1259.Description = Description;
      _this1259.ApplicableOccurrence = ApplicableOccurrence;
      _this1259.HasPropertySets = HasPropertySets;
      _this1259.RepresentationMaps = RepresentationMaps;
      _this1259.Tag = Tag;
      _this1259.ElementType = ElementType;
      _this1259.type = 1339347760;
      return _this1259;
    }

    return IfcFlowStorageDeviceType;
  }(IfcDistributionFlowElementType);

  IFC4_32.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;

  var IfcFlowTerminalType = /*#__PURE__*/function (_IfcDistributionFlowE25) {
    _inherits(IfcFlowTerminalType, _IfcDistributionFlowE25);

    var _super1268 = _createSuper(IfcFlowTerminalType);

    function IfcFlowTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1260;

      _classCallCheck2(this, IfcFlowTerminalType);

      _this1260 = _super1268.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1260.GlobalId = GlobalId;
      _this1260.OwnerHistory = OwnerHistory;
      _this1260.Name = Name;
      _this1260.Description = Description;
      _this1260.ApplicableOccurrence = ApplicableOccurrence;
      _this1260.HasPropertySets = HasPropertySets;
      _this1260.RepresentationMaps = RepresentationMaps;
      _this1260.Tag = Tag;
      _this1260.ElementType = ElementType;
      _this1260.type = 2297155007;
      return _this1260;
    }

    return IfcFlowTerminalType;
  }(IfcDistributionFlowElementType);

  IFC4_32.IfcFlowTerminalType = IfcFlowTerminalType;

  var IfcFlowTreatmentDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE26) {
    _inherits(IfcFlowTreatmentDeviceType, _IfcDistributionFlowE26);

    var _super1269 = _createSuper(IfcFlowTreatmentDeviceType);

    function IfcFlowTreatmentDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1261;

      _classCallCheck2(this, IfcFlowTreatmentDeviceType);

      _this1261 = _super1269.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1261.GlobalId = GlobalId;
      _this1261.OwnerHistory = OwnerHistory;
      _this1261.Name = Name;
      _this1261.Description = Description;
      _this1261.ApplicableOccurrence = ApplicableOccurrence;
      _this1261.HasPropertySets = HasPropertySets;
      _this1261.RepresentationMaps = RepresentationMaps;
      _this1261.Tag = Tag;
      _this1261.ElementType = ElementType;
      _this1261.type = 3009222698;
      return _this1261;
    }

    return IfcFlowTreatmentDeviceType;
  }(IfcDistributionFlowElementType);

  IFC4_32.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;

  var IfcFootingType = /*#__PURE__*/function (_IfcBuiltElementType8) {
    _inherits(IfcFootingType, _IfcBuiltElementType8);

    var _super1270 = _createSuper(IfcFootingType);

    function IfcFootingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1262;

      _classCallCheck2(this, IfcFootingType);

      _this1262 = _super1270.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1262.GlobalId = GlobalId;
      _this1262.OwnerHistory = OwnerHistory;
      _this1262.Name = Name;
      _this1262.Description = Description;
      _this1262.ApplicableOccurrence = ApplicableOccurrence;
      _this1262.HasPropertySets = HasPropertySets;
      _this1262.RepresentationMaps = RepresentationMaps;
      _this1262.Tag = Tag;
      _this1262.ElementType = ElementType;
      _this1262.PredefinedType = PredefinedType;
      _this1262.type = 1893162501;
      return _this1262;
    }

    return IfcFootingType;
  }(IfcBuiltElementType);

  IFC4_32.IfcFootingType = IfcFootingType;

  var IfcFurnishingElement = /*#__PURE__*/function (_IfcElement14) {
    _inherits(IfcFurnishingElement, _IfcElement14);

    var _super1271 = _createSuper(IfcFurnishingElement);

    function IfcFurnishingElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1263;

      _classCallCheck2(this, IfcFurnishingElement);

      _this1263 = _super1271.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1263.GlobalId = GlobalId;
      _this1263.OwnerHistory = OwnerHistory;
      _this1263.Name = Name;
      _this1263.Description = Description;
      _this1263.ObjectType = ObjectType;
      _this1263.ObjectPlacement = ObjectPlacement;
      _this1263.Representation = Representation;
      _this1263.Tag = Tag;
      _this1263.type = 263784265;
      return _this1263;
    }

    return IfcFurnishingElement;
  }(IfcElement);

  IFC4_32.IfcFurnishingElement = IfcFurnishingElement;

  var IfcFurniture = /*#__PURE__*/function (_IfcFurnishingElement5) {
    _inherits(IfcFurniture, _IfcFurnishingElement5);

    var _super1272 = _createSuper(IfcFurniture);

    function IfcFurniture(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1264;

      _classCallCheck2(this, IfcFurniture);

      _this1264 = _super1272.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1264.GlobalId = GlobalId;
      _this1264.OwnerHistory = OwnerHistory;
      _this1264.Name = Name;
      _this1264.Description = Description;
      _this1264.ObjectType = ObjectType;
      _this1264.ObjectPlacement = ObjectPlacement;
      _this1264.Representation = Representation;
      _this1264.Tag = Tag;
      _this1264.PredefinedType = PredefinedType;
      _this1264.type = 1509553395;
      return _this1264;
    }

    return IfcFurniture;
  }(IfcFurnishingElement);

  IFC4_32.IfcFurniture = IfcFurniture;

  var IfcGeographicElement = /*#__PURE__*/function (_IfcElement15) {
    _inherits(IfcGeographicElement, _IfcElement15);

    var _super1273 = _createSuper(IfcGeographicElement);

    function IfcGeographicElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1265;

      _classCallCheck2(this, IfcGeographicElement);

      _this1265 = _super1273.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1265.GlobalId = GlobalId;
      _this1265.OwnerHistory = OwnerHistory;
      _this1265.Name = Name;
      _this1265.Description = Description;
      _this1265.ObjectType = ObjectType;
      _this1265.ObjectPlacement = ObjectPlacement;
      _this1265.Representation = Representation;
      _this1265.Tag = Tag;
      _this1265.PredefinedType = PredefinedType;
      _this1265.type = 3493046030;
      return _this1265;
    }

    return IfcGeographicElement;
  }(IfcElement);

  IFC4_32.IfcGeographicElement = IfcGeographicElement;

  var IfcGeotechnicalElement = /*#__PURE__*/function (_IfcElement16) {
    _inherits(IfcGeotechnicalElement, _IfcElement16);

    var _super1274 = _createSuper(IfcGeotechnicalElement);

    function IfcGeotechnicalElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1266;

      _classCallCheck2(this, IfcGeotechnicalElement);

      _this1266 = _super1274.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1266.GlobalId = GlobalId;
      _this1266.OwnerHistory = OwnerHistory;
      _this1266.Name = Name;
      _this1266.Description = Description;
      _this1266.ObjectType = ObjectType;
      _this1266.ObjectPlacement = ObjectPlacement;
      _this1266.Representation = Representation;
      _this1266.Tag = Tag;
      _this1266.type = 4230923436;
      return _this1266;
    }

    return IfcGeotechnicalElement;
  }(IfcElement);

  IFC4_32.IfcGeotechnicalElement = IfcGeotechnicalElement;

  var IfcGeotechnicalStratum = /*#__PURE__*/function (_IfcGeotechnicalEleme) {
    _inherits(IfcGeotechnicalStratum, _IfcGeotechnicalEleme);

    var _super1275 = _createSuper(IfcGeotechnicalStratum);

    function IfcGeotechnicalStratum(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1267;

      _classCallCheck2(this, IfcGeotechnicalStratum);

      _this1267 = _super1275.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1267.GlobalId = GlobalId;
      _this1267.OwnerHistory = OwnerHistory;
      _this1267.Name = Name;
      _this1267.Description = Description;
      _this1267.ObjectType = ObjectType;
      _this1267.ObjectPlacement = ObjectPlacement;
      _this1267.Representation = Representation;
      _this1267.Tag = Tag;
      _this1267.PredefinedType = PredefinedType;
      _this1267.type = 1594536857;
      return _this1267;
    }

    return IfcGeotechnicalStratum;
  }(IfcGeotechnicalElement);

  IFC4_32.IfcGeotechnicalStratum = IfcGeotechnicalStratum;

  var IfcGradientCurve = /*#__PURE__*/function (_IfcCompositeCurve3) {
    _inherits(IfcGradientCurve, _IfcCompositeCurve3);

    var _super1276 = _createSuper(IfcGradientCurve);

    function IfcGradientCurve(expressID, Segments, SelfIntersect, BaseCurve, EndPoint) {
      var _this1268;

      _classCallCheck2(this, IfcGradientCurve);

      _this1268 = _super1276.call(this, expressID, Segments, SelfIntersect);
      _this1268.Segments = Segments;
      _this1268.SelfIntersect = SelfIntersect;
      _this1268.BaseCurve = BaseCurve;
      _this1268.EndPoint = EndPoint;
      _this1268.type = 2898700619;
      return _this1268;
    }

    return IfcGradientCurve;
  }(IfcCompositeCurve);

  IFC4_32.IfcGradientCurve = IfcGradientCurve;

  var IfcGroup = /*#__PURE__*/function (_IfcObject13) {
    _inherits(IfcGroup, _IfcObject13);

    var _super1277 = _createSuper(IfcGroup);

    function IfcGroup(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this1269;

      _classCallCheck2(this, IfcGroup);

      _this1269 = _super1277.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1269.GlobalId = GlobalId;
      _this1269.OwnerHistory = OwnerHistory;
      _this1269.Name = Name;
      _this1269.Description = Description;
      _this1269.ObjectType = ObjectType;
      _this1269.type = 2706460486;
      return _this1269;
    }

    return IfcGroup;
  }(IfcObject);

  IFC4_32.IfcGroup = IfcGroup;

  var IfcHeatExchangerType = /*#__PURE__*/function (_IfcEnergyConversionD22) {
    _inherits(IfcHeatExchangerType, _IfcEnergyConversionD22);

    var _super1278 = _createSuper(IfcHeatExchangerType);

    function IfcHeatExchangerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1270;

      _classCallCheck2(this, IfcHeatExchangerType);

      _this1270 = _super1278.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1270.GlobalId = GlobalId;
      _this1270.OwnerHistory = OwnerHistory;
      _this1270.Name = Name;
      _this1270.Description = Description;
      _this1270.ApplicableOccurrence = ApplicableOccurrence;
      _this1270.HasPropertySets = HasPropertySets;
      _this1270.RepresentationMaps = RepresentationMaps;
      _this1270.Tag = Tag;
      _this1270.ElementType = ElementType;
      _this1270.PredefinedType = PredefinedType;
      _this1270.type = 1251058090;
      return _this1270;
    }

    return IfcHeatExchangerType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcHeatExchangerType = IfcHeatExchangerType;

  var IfcHumidifierType = /*#__PURE__*/function (_IfcEnergyConversionD23) {
    _inherits(IfcHumidifierType, _IfcEnergyConversionD23);

    var _super1279 = _createSuper(IfcHumidifierType);

    function IfcHumidifierType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1271;

      _classCallCheck2(this, IfcHumidifierType);

      _this1271 = _super1279.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1271.GlobalId = GlobalId;
      _this1271.OwnerHistory = OwnerHistory;
      _this1271.Name = Name;
      _this1271.Description = Description;
      _this1271.ApplicableOccurrence = ApplicableOccurrence;
      _this1271.HasPropertySets = HasPropertySets;
      _this1271.RepresentationMaps = RepresentationMaps;
      _this1271.Tag = Tag;
      _this1271.ElementType = ElementType;
      _this1271.PredefinedType = PredefinedType;
      _this1271.type = 1806887404;
      return _this1271;
    }

    return IfcHumidifierType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcHumidifierType = IfcHumidifierType;

  var IfcImpactProtectionDevice = /*#__PURE__*/function (_IfcElementComponent4) {
    _inherits(IfcImpactProtectionDevice, _IfcElementComponent4);

    var _super1280 = _createSuper(IfcImpactProtectionDevice);

    function IfcImpactProtectionDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1272;

      _classCallCheck2(this, IfcImpactProtectionDevice);

      _this1272 = _super1280.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1272.GlobalId = GlobalId;
      _this1272.OwnerHistory = OwnerHistory;
      _this1272.Name = Name;
      _this1272.Description = Description;
      _this1272.ObjectType = ObjectType;
      _this1272.ObjectPlacement = ObjectPlacement;
      _this1272.Representation = Representation;
      _this1272.Tag = Tag;
      _this1272.PredefinedType = PredefinedType;
      _this1272.type = 2568555532;
      return _this1272;
    }

    return IfcImpactProtectionDevice;
  }(IfcElementComponent);

  IFC4_32.IfcImpactProtectionDevice = IfcImpactProtectionDevice;

  var IfcImpactProtectionDeviceType = /*#__PURE__*/function (_IfcElementComponentT4) {
    _inherits(IfcImpactProtectionDeviceType, _IfcElementComponentT4);

    var _super1281 = _createSuper(IfcImpactProtectionDeviceType);

    function IfcImpactProtectionDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1273;

      _classCallCheck2(this, IfcImpactProtectionDeviceType);

      _this1273 = _super1281.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1273.GlobalId = GlobalId;
      _this1273.OwnerHistory = OwnerHistory;
      _this1273.Name = Name;
      _this1273.Description = Description;
      _this1273.ApplicableOccurrence = ApplicableOccurrence;
      _this1273.HasPropertySets = HasPropertySets;
      _this1273.RepresentationMaps = RepresentationMaps;
      _this1273.Tag = Tag;
      _this1273.ElementType = ElementType;
      _this1273.PredefinedType = PredefinedType;
      _this1273.type = 3948183225;
      return _this1273;
    }

    return IfcImpactProtectionDeviceType;
  }(IfcElementComponentType);

  IFC4_32.IfcImpactProtectionDeviceType = IfcImpactProtectionDeviceType;

  var IfcIndexedPolyCurve = /*#__PURE__*/function (_IfcBoundedCurve6) {
    _inherits(IfcIndexedPolyCurve, _IfcBoundedCurve6);

    var _super1282 = _createSuper(IfcIndexedPolyCurve);

    function IfcIndexedPolyCurve(expressID, Points, Segments, SelfIntersect) {
      var _this1274;

      _classCallCheck2(this, IfcIndexedPolyCurve);

      _this1274 = _super1282.call(this, expressID);
      _this1274.Points = Points;
      _this1274.Segments = Segments;
      _this1274.SelfIntersect = SelfIntersect;
      _this1274.type = 2571569899;
      return _this1274;
    }

    return IfcIndexedPolyCurve;
  }(IfcBoundedCurve);

  IFC4_32.IfcIndexedPolyCurve = IfcIndexedPolyCurve;

  var IfcInterceptorType = /*#__PURE__*/function (_IfcFlowTreatmentDevi3) {
    _inherits(IfcInterceptorType, _IfcFlowTreatmentDevi3);

    var _super1283 = _createSuper(IfcInterceptorType);

    function IfcInterceptorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1275;

      _classCallCheck2(this, IfcInterceptorType);

      _this1275 = _super1283.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1275.GlobalId = GlobalId;
      _this1275.OwnerHistory = OwnerHistory;
      _this1275.Name = Name;
      _this1275.Description = Description;
      _this1275.ApplicableOccurrence = ApplicableOccurrence;
      _this1275.HasPropertySets = HasPropertySets;
      _this1275.RepresentationMaps = RepresentationMaps;
      _this1275.Tag = Tag;
      _this1275.ElementType = ElementType;
      _this1275.PredefinedType = PredefinedType;
      _this1275.type = 3946677679;
      return _this1275;
    }

    return IfcInterceptorType;
  }(IfcFlowTreatmentDeviceType);

  IFC4_32.IfcInterceptorType = IfcInterceptorType;

  var IfcIntersectionCurve = /*#__PURE__*/function (_IfcSurfaceCurve) {
    _inherits(IfcIntersectionCurve, _IfcSurfaceCurve);

    var _super1284 = _createSuper(IfcIntersectionCurve);

    function IfcIntersectionCurve(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      var _this1276;

      _classCallCheck2(this, IfcIntersectionCurve);

      _this1276 = _super1284.call(this, expressID, Curve3D, AssociatedGeometry, MasterRepresentation);
      _this1276.Curve3D = Curve3D;
      _this1276.AssociatedGeometry = AssociatedGeometry;
      _this1276.MasterRepresentation = MasterRepresentation;
      _this1276.type = 3113134337;
      return _this1276;
    }

    return IfcIntersectionCurve;
  }(IfcSurfaceCurve);

  IFC4_32.IfcIntersectionCurve = IfcIntersectionCurve;

  var IfcInventory = /*#__PURE__*/function (_IfcGroup8) {
    _inherits(IfcInventory, _IfcGroup8);

    var _super1285 = _createSuper(IfcInventory);

    function IfcInventory(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue) {
      var _this1277;

      _classCallCheck2(this, IfcInventory);

      _this1277 = _super1285.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1277.GlobalId = GlobalId;
      _this1277.OwnerHistory = OwnerHistory;
      _this1277.Name = Name;
      _this1277.Description = Description;
      _this1277.ObjectType = ObjectType;
      _this1277.PredefinedType = PredefinedType;
      _this1277.Jurisdiction = Jurisdiction;
      _this1277.ResponsiblePersons = ResponsiblePersons;
      _this1277.LastUpdateDate = LastUpdateDate;
      _this1277.CurrentValue = CurrentValue;
      _this1277.OriginalValue = OriginalValue;
      _this1277.type = 2391368822;
      return _this1277;
    }

    return IfcInventory;
  }(IfcGroup);

  IFC4_32.IfcInventory = IfcInventory;

  var IfcJunctionBoxType = /*#__PURE__*/function (_IfcFlowFittingType5) {
    _inherits(IfcJunctionBoxType, _IfcFlowFittingType5);

    var _super1286 = _createSuper(IfcJunctionBoxType);

    function IfcJunctionBoxType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1278;

      _classCallCheck2(this, IfcJunctionBoxType);

      _this1278 = _super1286.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1278.GlobalId = GlobalId;
      _this1278.OwnerHistory = OwnerHistory;
      _this1278.Name = Name;
      _this1278.Description = Description;
      _this1278.ApplicableOccurrence = ApplicableOccurrence;
      _this1278.HasPropertySets = HasPropertySets;
      _this1278.RepresentationMaps = RepresentationMaps;
      _this1278.Tag = Tag;
      _this1278.ElementType = ElementType;
      _this1278.PredefinedType = PredefinedType;
      _this1278.type = 4288270099;
      return _this1278;
    }

    return IfcJunctionBoxType;
  }(IfcFlowFittingType);

  IFC4_32.IfcJunctionBoxType = IfcJunctionBoxType;

  var IfcKerbType = /*#__PURE__*/function (_IfcBuiltElementType9) {
    _inherits(IfcKerbType, _IfcBuiltElementType9);

    var _super1287 = _createSuper(IfcKerbType);

    function IfcKerbType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, Mountable) {
      var _this1279;

      _classCallCheck2(this, IfcKerbType);

      _this1279 = _super1287.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1279.GlobalId = GlobalId;
      _this1279.OwnerHistory = OwnerHistory;
      _this1279.Name = Name;
      _this1279.Description = Description;
      _this1279.ApplicableOccurrence = ApplicableOccurrence;
      _this1279.HasPropertySets = HasPropertySets;
      _this1279.RepresentationMaps = RepresentationMaps;
      _this1279.Tag = Tag;
      _this1279.ElementType = ElementType;
      _this1279.Mountable = Mountable;
      _this1279.type = 679976338;
      return _this1279;
    }

    return IfcKerbType;
  }(IfcBuiltElementType);

  IFC4_32.IfcKerbType = IfcKerbType;

  var IfcLaborResource = /*#__PURE__*/function (_IfcConstructionResou14) {
    _inherits(IfcLaborResource, _IfcConstructionResou14);

    var _super1288 = _createSuper(IfcLaborResource);

    function IfcLaborResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1280;

      _classCallCheck2(this, IfcLaborResource);

      _this1280 = _super1288.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this1280.GlobalId = GlobalId;
      _this1280.OwnerHistory = OwnerHistory;
      _this1280.Name = Name;
      _this1280.Description = Description;
      _this1280.ObjectType = ObjectType;
      _this1280.Identification = Identification;
      _this1280.LongDescription = LongDescription;
      _this1280.Usage = Usage;
      _this1280.BaseCosts = BaseCosts;
      _this1280.BaseQuantity = BaseQuantity;
      _this1280.PredefinedType = PredefinedType;
      _this1280.type = 3827777499;
      return _this1280;
    }

    return IfcLaborResource;
  }(IfcConstructionResource);

  IFC4_32.IfcLaborResource = IfcLaborResource;

  var IfcLampType = /*#__PURE__*/function (_IfcFlowTerminalType12) {
    _inherits(IfcLampType, _IfcFlowTerminalType12);

    var _super1289 = _createSuper(IfcLampType);

    function IfcLampType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1281;

      _classCallCheck2(this, IfcLampType);

      _this1281 = _super1289.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1281.GlobalId = GlobalId;
      _this1281.OwnerHistory = OwnerHistory;
      _this1281.Name = Name;
      _this1281.Description = Description;
      _this1281.ApplicableOccurrence = ApplicableOccurrence;
      _this1281.HasPropertySets = HasPropertySets;
      _this1281.RepresentationMaps = RepresentationMaps;
      _this1281.Tag = Tag;
      _this1281.ElementType = ElementType;
      _this1281.PredefinedType = PredefinedType;
      _this1281.type = 1051575348;
      return _this1281;
    }

    return IfcLampType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcLampType = IfcLampType;

  var IfcLightFixtureType = /*#__PURE__*/function (_IfcFlowTerminalType13) {
    _inherits(IfcLightFixtureType, _IfcFlowTerminalType13);

    var _super1290 = _createSuper(IfcLightFixtureType);

    function IfcLightFixtureType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1282;

      _classCallCheck2(this, IfcLightFixtureType);

      _this1282 = _super1290.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1282.GlobalId = GlobalId;
      _this1282.OwnerHistory = OwnerHistory;
      _this1282.Name = Name;
      _this1282.Description = Description;
      _this1282.ApplicableOccurrence = ApplicableOccurrence;
      _this1282.HasPropertySets = HasPropertySets;
      _this1282.RepresentationMaps = RepresentationMaps;
      _this1282.Tag = Tag;
      _this1282.ElementType = ElementType;
      _this1282.PredefinedType = PredefinedType;
      _this1282.type = 1161773419;
      return _this1282;
    }

    return IfcLightFixtureType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcLightFixtureType = IfcLightFixtureType;

  var IfcLinearElement = /*#__PURE__*/function (_IfcProduct14) {
    _inherits(IfcLinearElement, _IfcProduct14);

    var _super1291 = _createSuper(IfcLinearElement);

    function IfcLinearElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this1283;

      _classCallCheck2(this, IfcLinearElement);

      _this1283 = _super1291.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1283.GlobalId = GlobalId;
      _this1283.OwnerHistory = OwnerHistory;
      _this1283.Name = Name;
      _this1283.Description = Description;
      _this1283.ObjectType = ObjectType;
      _this1283.ObjectPlacement = ObjectPlacement;
      _this1283.Representation = Representation;
      _this1283.type = 2176059722;
      return _this1283;
    }

    return IfcLinearElement;
  }(IfcProduct);

  IFC4_32.IfcLinearElement = IfcLinearElement;

  var IfcLiquidTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType14) {
    _inherits(IfcLiquidTerminalType, _IfcFlowTerminalType14);

    var _super1292 = _createSuper(IfcLiquidTerminalType);

    function IfcLiquidTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1284;

      _classCallCheck2(this, IfcLiquidTerminalType);

      _this1284 = _super1292.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1284.GlobalId = GlobalId;
      _this1284.OwnerHistory = OwnerHistory;
      _this1284.Name = Name;
      _this1284.Description = Description;
      _this1284.ApplicableOccurrence = ApplicableOccurrence;
      _this1284.HasPropertySets = HasPropertySets;
      _this1284.RepresentationMaps = RepresentationMaps;
      _this1284.Tag = Tag;
      _this1284.ElementType = ElementType;
      _this1284.PredefinedType = PredefinedType;
      _this1284.type = 1770583370;
      return _this1284;
    }

    return IfcLiquidTerminalType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcLiquidTerminalType = IfcLiquidTerminalType;

  var IfcMarineFacility = /*#__PURE__*/function (_IfcFacility) {
    _inherits(IfcMarineFacility, _IfcFacility);

    var _super1293 = _createSuper(IfcMarineFacility);

    function IfcMarineFacility(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      var _this1285;

      _classCallCheck2(this, IfcMarineFacility);

      _this1285 = _super1293.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this1285.GlobalId = GlobalId;
      _this1285.OwnerHistory = OwnerHistory;
      _this1285.Name = Name;
      _this1285.Description = Description;
      _this1285.ObjectType = ObjectType;
      _this1285.ObjectPlacement = ObjectPlacement;
      _this1285.Representation = Representation;
      _this1285.LongName = LongName;
      _this1285.CompositionType = CompositionType;
      _this1285.PredefinedType = PredefinedType;
      _this1285.type = 525669439;
      return _this1285;
    }

    return IfcMarineFacility;
  }(IfcFacility);

  IFC4_32.IfcMarineFacility = IfcMarineFacility;

  var IfcMarinePart = /*#__PURE__*/function (_IfcFacilityPart2) {
    _inherits(IfcMarinePart, _IfcFacilityPart2);

    var _super1294 = _createSuper(IfcMarinePart);

    function IfcMarinePart(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      var _this1286;

      _classCallCheck2(this, IfcMarinePart);

      _this1286 = _super1294.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      _this1286.GlobalId = GlobalId;
      _this1286.OwnerHistory = OwnerHistory;
      _this1286.Name = Name;
      _this1286.Description = Description;
      _this1286.ObjectType = ObjectType;
      _this1286.ObjectPlacement = ObjectPlacement;
      _this1286.Representation = Representation;
      _this1286.LongName = LongName;
      _this1286.CompositionType = CompositionType;
      _this1286.UsageType = UsageType;
      _this1286.PredefinedType = PredefinedType;
      _this1286.type = 976884017;
      return _this1286;
    }

    return IfcMarinePart;
  }(IfcFacilityPart);

  IFC4_32.IfcMarinePart = IfcMarinePart;

  var IfcMechanicalFastener = /*#__PURE__*/function (_IfcElementComponent5) {
    _inherits(IfcMechanicalFastener, _IfcElementComponent5);

    var _super1295 = _createSuper(IfcMechanicalFastener);

    function IfcMechanicalFastener(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength, PredefinedType) {
      var _this1287;

      _classCallCheck2(this, IfcMechanicalFastener);

      _this1287 = _super1295.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1287.GlobalId = GlobalId;
      _this1287.OwnerHistory = OwnerHistory;
      _this1287.Name = Name;
      _this1287.Description = Description;
      _this1287.ObjectType = ObjectType;
      _this1287.ObjectPlacement = ObjectPlacement;
      _this1287.Representation = Representation;
      _this1287.Tag = Tag;
      _this1287.NominalDiameter = NominalDiameter;
      _this1287.NominalLength = NominalLength;
      _this1287.PredefinedType = PredefinedType;
      _this1287.type = 377706215;
      return _this1287;
    }

    return IfcMechanicalFastener;
  }(IfcElementComponent);

  IFC4_32.IfcMechanicalFastener = IfcMechanicalFastener;

  var IfcMechanicalFastenerType = /*#__PURE__*/function (_IfcElementComponentT5) {
    _inherits(IfcMechanicalFastenerType, _IfcElementComponentT5);

    var _super1296 = _createSuper(IfcMechanicalFastenerType);

    function IfcMechanicalFastenerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, NominalLength) {
      var _this1288;

      _classCallCheck2(this, IfcMechanicalFastenerType);

      _this1288 = _super1296.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1288.GlobalId = GlobalId;
      _this1288.OwnerHistory = OwnerHistory;
      _this1288.Name = Name;
      _this1288.Description = Description;
      _this1288.ApplicableOccurrence = ApplicableOccurrence;
      _this1288.HasPropertySets = HasPropertySets;
      _this1288.RepresentationMaps = RepresentationMaps;
      _this1288.Tag = Tag;
      _this1288.ElementType = ElementType;
      _this1288.PredefinedType = PredefinedType;
      _this1288.NominalDiameter = NominalDiameter;
      _this1288.NominalLength = NominalLength;
      _this1288.type = 2108223431;
      return _this1288;
    }

    return IfcMechanicalFastenerType;
  }(IfcElementComponentType);

  IFC4_32.IfcMechanicalFastenerType = IfcMechanicalFastenerType;

  var IfcMedicalDeviceType = /*#__PURE__*/function (_IfcFlowTerminalType15) {
    _inherits(IfcMedicalDeviceType, _IfcFlowTerminalType15);

    var _super1297 = _createSuper(IfcMedicalDeviceType);

    function IfcMedicalDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1289;

      _classCallCheck2(this, IfcMedicalDeviceType);

      _this1289 = _super1297.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1289.GlobalId = GlobalId;
      _this1289.OwnerHistory = OwnerHistory;
      _this1289.Name = Name;
      _this1289.Description = Description;
      _this1289.ApplicableOccurrence = ApplicableOccurrence;
      _this1289.HasPropertySets = HasPropertySets;
      _this1289.RepresentationMaps = RepresentationMaps;
      _this1289.Tag = Tag;
      _this1289.ElementType = ElementType;
      _this1289.PredefinedType = PredefinedType;
      _this1289.type = 1114901282;
      return _this1289;
    }

    return IfcMedicalDeviceType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcMedicalDeviceType = IfcMedicalDeviceType;

  var IfcMemberType = /*#__PURE__*/function (_IfcBuiltElementType10) {
    _inherits(IfcMemberType, _IfcBuiltElementType10);

    var _super1298 = _createSuper(IfcMemberType);

    function IfcMemberType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1290;

      _classCallCheck2(this, IfcMemberType);

      _this1290 = _super1298.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1290.GlobalId = GlobalId;
      _this1290.OwnerHistory = OwnerHistory;
      _this1290.Name = Name;
      _this1290.Description = Description;
      _this1290.ApplicableOccurrence = ApplicableOccurrence;
      _this1290.HasPropertySets = HasPropertySets;
      _this1290.RepresentationMaps = RepresentationMaps;
      _this1290.Tag = Tag;
      _this1290.ElementType = ElementType;
      _this1290.PredefinedType = PredefinedType;
      _this1290.type = 3181161470;
      return _this1290;
    }

    return IfcMemberType;
  }(IfcBuiltElementType);

  IFC4_32.IfcMemberType = IfcMemberType;

  var IfcMobileTelecommunicationsApplianceType = /*#__PURE__*/function (_IfcFlowTerminalType16) {
    _inherits(IfcMobileTelecommunicationsApplianceType, _IfcFlowTerminalType16);

    var _super1299 = _createSuper(IfcMobileTelecommunicationsApplianceType);

    function IfcMobileTelecommunicationsApplianceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1291;

      _classCallCheck2(this, IfcMobileTelecommunicationsApplianceType);

      _this1291 = _super1299.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1291.GlobalId = GlobalId;
      _this1291.OwnerHistory = OwnerHistory;
      _this1291.Name = Name;
      _this1291.Description = Description;
      _this1291.ApplicableOccurrence = ApplicableOccurrence;
      _this1291.HasPropertySets = HasPropertySets;
      _this1291.RepresentationMaps = RepresentationMaps;
      _this1291.Tag = Tag;
      _this1291.ElementType = ElementType;
      _this1291.PredefinedType = PredefinedType;
      _this1291.type = 1950438474;
      return _this1291;
    }

    return IfcMobileTelecommunicationsApplianceType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcMobileTelecommunicationsApplianceType = IfcMobileTelecommunicationsApplianceType;

  var IfcMooringDeviceType = /*#__PURE__*/function (_IfcBuiltElementType11) {
    _inherits(IfcMooringDeviceType, _IfcBuiltElementType11);

    var _super1300 = _createSuper(IfcMooringDeviceType);

    function IfcMooringDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1292;

      _classCallCheck2(this, IfcMooringDeviceType);

      _this1292 = _super1300.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1292.GlobalId = GlobalId;
      _this1292.OwnerHistory = OwnerHistory;
      _this1292.Name = Name;
      _this1292.Description = Description;
      _this1292.ApplicableOccurrence = ApplicableOccurrence;
      _this1292.HasPropertySets = HasPropertySets;
      _this1292.RepresentationMaps = RepresentationMaps;
      _this1292.Tag = Tag;
      _this1292.ElementType = ElementType;
      _this1292.PredefinedType = PredefinedType;
      _this1292.type = 710110818;
      return _this1292;
    }

    return IfcMooringDeviceType;
  }(IfcBuiltElementType);

  IFC4_32.IfcMooringDeviceType = IfcMooringDeviceType;

  var IfcMotorConnectionType = /*#__PURE__*/function (_IfcEnergyConversionD24) {
    _inherits(IfcMotorConnectionType, _IfcEnergyConversionD24);

    var _super1301 = _createSuper(IfcMotorConnectionType);

    function IfcMotorConnectionType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1293;

      _classCallCheck2(this, IfcMotorConnectionType);

      _this1293 = _super1301.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1293.GlobalId = GlobalId;
      _this1293.OwnerHistory = OwnerHistory;
      _this1293.Name = Name;
      _this1293.Description = Description;
      _this1293.ApplicableOccurrence = ApplicableOccurrence;
      _this1293.HasPropertySets = HasPropertySets;
      _this1293.RepresentationMaps = RepresentationMaps;
      _this1293.Tag = Tag;
      _this1293.ElementType = ElementType;
      _this1293.PredefinedType = PredefinedType;
      _this1293.type = 977012517;
      return _this1293;
    }

    return IfcMotorConnectionType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcMotorConnectionType = IfcMotorConnectionType;

  var IfcNavigationElementType = /*#__PURE__*/function (_IfcBuiltElementType12) {
    _inherits(IfcNavigationElementType, _IfcBuiltElementType12);

    var _super1302 = _createSuper(IfcNavigationElementType);

    function IfcNavigationElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1294;

      _classCallCheck2(this, IfcNavigationElementType);

      _this1294 = _super1302.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1294.GlobalId = GlobalId;
      _this1294.OwnerHistory = OwnerHistory;
      _this1294.Name = Name;
      _this1294.Description = Description;
      _this1294.ApplicableOccurrence = ApplicableOccurrence;
      _this1294.HasPropertySets = HasPropertySets;
      _this1294.RepresentationMaps = RepresentationMaps;
      _this1294.Tag = Tag;
      _this1294.ElementType = ElementType;
      _this1294.PredefinedType = PredefinedType;
      _this1294.type = 506776471;
      return _this1294;
    }

    return IfcNavigationElementType;
  }(IfcBuiltElementType);

  IFC4_32.IfcNavigationElementType = IfcNavigationElementType;

  var IfcOccupant = /*#__PURE__*/function (_IfcActor2) {
    _inherits(IfcOccupant, _IfcActor2);

    var _super1303 = _createSuper(IfcOccupant);

    function IfcOccupant(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType) {
      var _this1295;

      _classCallCheck2(this, IfcOccupant);

      _this1295 = _super1303.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
      _this1295.GlobalId = GlobalId;
      _this1295.OwnerHistory = OwnerHistory;
      _this1295.Name = Name;
      _this1295.Description = Description;
      _this1295.ObjectType = ObjectType;
      _this1295.TheActor = TheActor;
      _this1295.PredefinedType = PredefinedType;
      _this1295.type = 4143007308;
      return _this1295;
    }

    return IfcOccupant;
  }(IfcActor);

  IFC4_32.IfcOccupant = IfcOccupant;

  var IfcOpeningElement = /*#__PURE__*/function (_IfcFeatureElementSub3) {
    _inherits(IfcOpeningElement, _IfcFeatureElementSub3);

    var _super1304 = _createSuper(IfcOpeningElement);

    function IfcOpeningElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1296;

      _classCallCheck2(this, IfcOpeningElement);

      _this1296 = _super1304.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1296.GlobalId = GlobalId;
      _this1296.OwnerHistory = OwnerHistory;
      _this1296.Name = Name;
      _this1296.Description = Description;
      _this1296.ObjectType = ObjectType;
      _this1296.ObjectPlacement = ObjectPlacement;
      _this1296.Representation = Representation;
      _this1296.Tag = Tag;
      _this1296.PredefinedType = PredefinedType;
      _this1296.type = 3588315303;
      return _this1296;
    }

    return IfcOpeningElement;
  }(IfcFeatureElementSubtraction);

  IFC4_32.IfcOpeningElement = IfcOpeningElement;

  var IfcOutletType = /*#__PURE__*/function (_IfcFlowTerminalType17) {
    _inherits(IfcOutletType, _IfcFlowTerminalType17);

    var _super1305 = _createSuper(IfcOutletType);

    function IfcOutletType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1297;

      _classCallCheck2(this, IfcOutletType);

      _this1297 = _super1305.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1297.GlobalId = GlobalId;
      _this1297.OwnerHistory = OwnerHistory;
      _this1297.Name = Name;
      _this1297.Description = Description;
      _this1297.ApplicableOccurrence = ApplicableOccurrence;
      _this1297.HasPropertySets = HasPropertySets;
      _this1297.RepresentationMaps = RepresentationMaps;
      _this1297.Tag = Tag;
      _this1297.ElementType = ElementType;
      _this1297.PredefinedType = PredefinedType;
      _this1297.type = 2837617999;
      return _this1297;
    }

    return IfcOutletType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcOutletType = IfcOutletType;

  var IfcPavementType = /*#__PURE__*/function (_IfcBuiltElementType13) {
    _inherits(IfcPavementType, _IfcBuiltElementType13);

    var _super1306 = _createSuper(IfcPavementType);

    function IfcPavementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1298;

      _classCallCheck2(this, IfcPavementType);

      _this1298 = _super1306.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1298.GlobalId = GlobalId;
      _this1298.OwnerHistory = OwnerHistory;
      _this1298.Name = Name;
      _this1298.Description = Description;
      _this1298.ApplicableOccurrence = ApplicableOccurrence;
      _this1298.HasPropertySets = HasPropertySets;
      _this1298.RepresentationMaps = RepresentationMaps;
      _this1298.Tag = Tag;
      _this1298.ElementType = ElementType;
      _this1298.PredefinedType = PredefinedType;
      _this1298.type = 514975943;
      return _this1298;
    }

    return IfcPavementType;
  }(IfcBuiltElementType);

  IFC4_32.IfcPavementType = IfcPavementType;

  var IfcPerformanceHistory = /*#__PURE__*/function (_IfcControl18) {
    _inherits(IfcPerformanceHistory, _IfcControl18);

    var _super1307 = _createSuper(IfcPerformanceHistory);

    function IfcPerformanceHistory(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LifeCyclePhase, PredefinedType) {
      var _this1299;

      _classCallCheck2(this, IfcPerformanceHistory);

      _this1299 = _super1307.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this1299.GlobalId = GlobalId;
      _this1299.OwnerHistory = OwnerHistory;
      _this1299.Name = Name;
      _this1299.Description = Description;
      _this1299.ObjectType = ObjectType;
      _this1299.Identification = Identification;
      _this1299.LifeCyclePhase = LifeCyclePhase;
      _this1299.PredefinedType = PredefinedType;
      _this1299.type = 2382730787;
      return _this1299;
    }

    return IfcPerformanceHistory;
  }(IfcControl);

  IFC4_32.IfcPerformanceHistory = IfcPerformanceHistory;

  var IfcPermeableCoveringProperties = /*#__PURE__*/function (_IfcPreDefinedPropert9) {
    _inherits(IfcPermeableCoveringProperties, _IfcPreDefinedPropert9);

    var _super1308 = _createSuper(IfcPermeableCoveringProperties);

    function IfcPermeableCoveringProperties(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      var _this1300;

      _classCallCheck2(this, IfcPermeableCoveringProperties);

      _this1300 = _super1308.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1300.GlobalId = GlobalId;
      _this1300.OwnerHistory = OwnerHistory;
      _this1300.Name = Name;
      _this1300.Description = Description;
      _this1300.OperationType = OperationType;
      _this1300.PanelPosition = PanelPosition;
      _this1300.FrameDepth = FrameDepth;
      _this1300.FrameThickness = FrameThickness;
      _this1300.ShapeAspectStyle = ShapeAspectStyle;
      _this1300.type = 3566463478;
      return _this1300;
    }

    return IfcPermeableCoveringProperties;
  }(IfcPreDefinedPropertySet);

  IFC4_32.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;

  var IfcPermit = /*#__PURE__*/function (_IfcControl19) {
    _inherits(IfcPermit, _IfcControl19);

    var _super1309 = _createSuper(IfcPermit);

    function IfcPermit(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      var _this1301;

      _classCallCheck2(this, IfcPermit);

      _this1301 = _super1309.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this1301.GlobalId = GlobalId;
      _this1301.OwnerHistory = OwnerHistory;
      _this1301.Name = Name;
      _this1301.Description = Description;
      _this1301.ObjectType = ObjectType;
      _this1301.Identification = Identification;
      _this1301.PredefinedType = PredefinedType;
      _this1301.Status = Status;
      _this1301.LongDescription = LongDescription;
      _this1301.type = 3327091369;
      return _this1301;
    }

    return IfcPermit;
  }(IfcControl);

  IFC4_32.IfcPermit = IfcPermit;

  var IfcPileType = /*#__PURE__*/function (_IfcDeepFoundationTyp) {
    _inherits(IfcPileType, _IfcDeepFoundationTyp);

    var _super1310 = _createSuper(IfcPileType);

    function IfcPileType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1302;

      _classCallCheck2(this, IfcPileType);

      _this1302 = _super1310.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1302.GlobalId = GlobalId;
      _this1302.OwnerHistory = OwnerHistory;
      _this1302.Name = Name;
      _this1302.Description = Description;
      _this1302.ApplicableOccurrence = ApplicableOccurrence;
      _this1302.HasPropertySets = HasPropertySets;
      _this1302.RepresentationMaps = RepresentationMaps;
      _this1302.Tag = Tag;
      _this1302.ElementType = ElementType;
      _this1302.PredefinedType = PredefinedType;
      _this1302.type = 1158309216;
      return _this1302;
    }

    return IfcPileType;
  }(IfcDeepFoundationType);

  IFC4_32.IfcPileType = IfcPileType;

  var IfcPipeFittingType = /*#__PURE__*/function (_IfcFlowFittingType6) {
    _inherits(IfcPipeFittingType, _IfcFlowFittingType6);

    var _super1311 = _createSuper(IfcPipeFittingType);

    function IfcPipeFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1303;

      _classCallCheck2(this, IfcPipeFittingType);

      _this1303 = _super1311.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1303.GlobalId = GlobalId;
      _this1303.OwnerHistory = OwnerHistory;
      _this1303.Name = Name;
      _this1303.Description = Description;
      _this1303.ApplicableOccurrence = ApplicableOccurrence;
      _this1303.HasPropertySets = HasPropertySets;
      _this1303.RepresentationMaps = RepresentationMaps;
      _this1303.Tag = Tag;
      _this1303.ElementType = ElementType;
      _this1303.PredefinedType = PredefinedType;
      _this1303.type = 804291784;
      return _this1303;
    }

    return IfcPipeFittingType;
  }(IfcFlowFittingType);

  IFC4_32.IfcPipeFittingType = IfcPipeFittingType;

  var IfcPipeSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType5) {
    _inherits(IfcPipeSegmentType, _IfcFlowSegmentType5);

    var _super1312 = _createSuper(IfcPipeSegmentType);

    function IfcPipeSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1304;

      _classCallCheck2(this, IfcPipeSegmentType);

      _this1304 = _super1312.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1304.GlobalId = GlobalId;
      _this1304.OwnerHistory = OwnerHistory;
      _this1304.Name = Name;
      _this1304.Description = Description;
      _this1304.ApplicableOccurrence = ApplicableOccurrence;
      _this1304.HasPropertySets = HasPropertySets;
      _this1304.RepresentationMaps = RepresentationMaps;
      _this1304.Tag = Tag;
      _this1304.ElementType = ElementType;
      _this1304.PredefinedType = PredefinedType;
      _this1304.type = 4231323485;
      return _this1304;
    }

    return IfcPipeSegmentType;
  }(IfcFlowSegmentType);

  IFC4_32.IfcPipeSegmentType = IfcPipeSegmentType;

  var IfcPlateType = /*#__PURE__*/function (_IfcBuiltElementType14) {
    _inherits(IfcPlateType, _IfcBuiltElementType14);

    var _super1313 = _createSuper(IfcPlateType);

    function IfcPlateType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1305;

      _classCallCheck2(this, IfcPlateType);

      _this1305 = _super1313.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1305.GlobalId = GlobalId;
      _this1305.OwnerHistory = OwnerHistory;
      _this1305.Name = Name;
      _this1305.Description = Description;
      _this1305.ApplicableOccurrence = ApplicableOccurrence;
      _this1305.HasPropertySets = HasPropertySets;
      _this1305.RepresentationMaps = RepresentationMaps;
      _this1305.Tag = Tag;
      _this1305.ElementType = ElementType;
      _this1305.PredefinedType = PredefinedType;
      _this1305.type = 4017108033;
      return _this1305;
    }

    return IfcPlateType;
  }(IfcBuiltElementType);

  IFC4_32.IfcPlateType = IfcPlateType;

  var IfcPolygonalFaceSet = /*#__PURE__*/function (_IfcTessellatedFaceSe2) {
    _inherits(IfcPolygonalFaceSet, _IfcTessellatedFaceSe2);

    var _super1314 = _createSuper(IfcPolygonalFaceSet);

    function IfcPolygonalFaceSet(expressID, Coordinates, Closed, Faces, PnIndex) {
      var _this1306;

      _classCallCheck2(this, IfcPolygonalFaceSet);

      _this1306 = _super1314.call(this, expressID, Coordinates, Closed);
      _this1306.Coordinates = Coordinates;
      _this1306.Closed = Closed;
      _this1306.Faces = Faces;
      _this1306.PnIndex = PnIndex;
      _this1306.type = 2839578677;
      return _this1306;
    }

    return IfcPolygonalFaceSet;
  }(IfcTessellatedFaceSet);

  IFC4_32.IfcPolygonalFaceSet = IfcPolygonalFaceSet;

  var IfcPolyline = /*#__PURE__*/function (_IfcBoundedCurve7) {
    _inherits(IfcPolyline, _IfcBoundedCurve7);

    var _super1315 = _createSuper(IfcPolyline);

    function IfcPolyline(expressID, Points) {
      var _this1307;

      _classCallCheck2(this, IfcPolyline);

      _this1307 = _super1315.call(this, expressID);
      _this1307.Points = Points;
      _this1307.type = 3724593414;
      return _this1307;
    }

    return IfcPolyline;
  }(IfcBoundedCurve);

  IFC4_32.IfcPolyline = IfcPolyline;

  var IfcPort = /*#__PURE__*/function (_IfcProduct15) {
    _inherits(IfcPort, _IfcProduct15);

    var _super1316 = _createSuper(IfcPort);

    function IfcPort(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this1308;

      _classCallCheck2(this, IfcPort);

      _this1308 = _super1316.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1308.GlobalId = GlobalId;
      _this1308.OwnerHistory = OwnerHistory;
      _this1308.Name = Name;
      _this1308.Description = Description;
      _this1308.ObjectType = ObjectType;
      _this1308.ObjectPlacement = ObjectPlacement;
      _this1308.Representation = Representation;
      _this1308.type = 3740093272;
      return _this1308;
    }

    return IfcPort;
  }(IfcProduct);

  IFC4_32.IfcPort = IfcPort;

  var IfcPositioningElement = /*#__PURE__*/function (_IfcProduct16) {
    _inherits(IfcPositioningElement, _IfcProduct16);

    var _super1317 = _createSuper(IfcPositioningElement);

    function IfcPositioningElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this1309;

      _classCallCheck2(this, IfcPositioningElement);

      _this1309 = _super1317.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1309.GlobalId = GlobalId;
      _this1309.OwnerHistory = OwnerHistory;
      _this1309.Name = Name;
      _this1309.Description = Description;
      _this1309.ObjectType = ObjectType;
      _this1309.ObjectPlacement = ObjectPlacement;
      _this1309.Representation = Representation;
      _this1309.type = 1946335990;
      return _this1309;
    }

    return IfcPositioningElement;
  }(IfcProduct);

  IFC4_32.IfcPositioningElement = IfcPositioningElement;

  var IfcProcedure = /*#__PURE__*/function (_IfcProcess5) {
    _inherits(IfcProcedure, _IfcProcess5);

    var _super1318 = _createSuper(IfcProcedure);

    function IfcProcedure(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType) {
      var _this1310;

      _classCallCheck2(this, IfcProcedure);

      _this1310 = _super1318.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      _this1310.GlobalId = GlobalId;
      _this1310.OwnerHistory = OwnerHistory;
      _this1310.Name = Name;
      _this1310.Description = Description;
      _this1310.ObjectType = ObjectType;
      _this1310.Identification = Identification;
      _this1310.LongDescription = LongDescription;
      _this1310.PredefinedType = PredefinedType;
      _this1310.type = 2744685151;
      return _this1310;
    }

    return IfcProcedure;
  }(IfcProcess);

  IFC4_32.IfcProcedure = IfcProcedure;

  var IfcProjectOrder = /*#__PURE__*/function (_IfcControl20) {
    _inherits(IfcProjectOrder, _IfcControl20);

    var _super1319 = _createSuper(IfcProjectOrder);

    function IfcProjectOrder(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      var _this1311;

      _classCallCheck2(this, IfcProjectOrder);

      _this1311 = _super1319.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this1311.GlobalId = GlobalId;
      _this1311.OwnerHistory = OwnerHistory;
      _this1311.Name = Name;
      _this1311.Description = Description;
      _this1311.ObjectType = ObjectType;
      _this1311.Identification = Identification;
      _this1311.PredefinedType = PredefinedType;
      _this1311.Status = Status;
      _this1311.LongDescription = LongDescription;
      _this1311.type = 2904328755;
      return _this1311;
    }

    return IfcProjectOrder;
  }(IfcControl);

  IFC4_32.IfcProjectOrder = IfcProjectOrder;

  var IfcProjectionElement = /*#__PURE__*/function (_IfcFeatureElementAdd2) {
    _inherits(IfcProjectionElement, _IfcFeatureElementAdd2);

    var _super1320 = _createSuper(IfcProjectionElement);

    function IfcProjectionElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1312;

      _classCallCheck2(this, IfcProjectionElement);

      _this1312 = _super1320.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1312.GlobalId = GlobalId;
      _this1312.OwnerHistory = OwnerHistory;
      _this1312.Name = Name;
      _this1312.Description = Description;
      _this1312.ObjectType = ObjectType;
      _this1312.ObjectPlacement = ObjectPlacement;
      _this1312.Representation = Representation;
      _this1312.Tag = Tag;
      _this1312.PredefinedType = PredefinedType;
      _this1312.type = 3651124850;
      return _this1312;
    }

    return IfcProjectionElement;
  }(IfcFeatureElementAddition);

  IFC4_32.IfcProjectionElement = IfcProjectionElement;

  var IfcProtectiveDeviceType = /*#__PURE__*/function (_IfcFlowControllerTyp9) {
    _inherits(IfcProtectiveDeviceType, _IfcFlowControllerTyp9);

    var _super1321 = _createSuper(IfcProtectiveDeviceType);

    function IfcProtectiveDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1313;

      _classCallCheck2(this, IfcProtectiveDeviceType);

      _this1313 = _super1321.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1313.GlobalId = GlobalId;
      _this1313.OwnerHistory = OwnerHistory;
      _this1313.Name = Name;
      _this1313.Description = Description;
      _this1313.ApplicableOccurrence = ApplicableOccurrence;
      _this1313.HasPropertySets = HasPropertySets;
      _this1313.RepresentationMaps = RepresentationMaps;
      _this1313.Tag = Tag;
      _this1313.ElementType = ElementType;
      _this1313.PredefinedType = PredefinedType;
      _this1313.type = 1842657554;
      return _this1313;
    }

    return IfcProtectiveDeviceType;
  }(IfcFlowControllerType);

  IFC4_32.IfcProtectiveDeviceType = IfcProtectiveDeviceType;

  var IfcPumpType = /*#__PURE__*/function (_IfcFlowMovingDeviceT4) {
    _inherits(IfcPumpType, _IfcFlowMovingDeviceT4);

    var _super1322 = _createSuper(IfcPumpType);

    function IfcPumpType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1314;

      _classCallCheck2(this, IfcPumpType);

      _this1314 = _super1322.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1314.GlobalId = GlobalId;
      _this1314.OwnerHistory = OwnerHistory;
      _this1314.Name = Name;
      _this1314.Description = Description;
      _this1314.ApplicableOccurrence = ApplicableOccurrence;
      _this1314.HasPropertySets = HasPropertySets;
      _this1314.RepresentationMaps = RepresentationMaps;
      _this1314.Tag = Tag;
      _this1314.ElementType = ElementType;
      _this1314.PredefinedType = PredefinedType;
      _this1314.type = 2250791053;
      return _this1314;
    }

    return IfcPumpType;
  }(IfcFlowMovingDeviceType);

  IFC4_32.IfcPumpType = IfcPumpType;

  var IfcRailType = /*#__PURE__*/function (_IfcBuiltElementType15) {
    _inherits(IfcRailType, _IfcBuiltElementType15);

    var _super1323 = _createSuper(IfcRailType);

    function IfcRailType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1315;

      _classCallCheck2(this, IfcRailType);

      _this1315 = _super1323.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1315.GlobalId = GlobalId;
      _this1315.OwnerHistory = OwnerHistory;
      _this1315.Name = Name;
      _this1315.Description = Description;
      _this1315.ApplicableOccurrence = ApplicableOccurrence;
      _this1315.HasPropertySets = HasPropertySets;
      _this1315.RepresentationMaps = RepresentationMaps;
      _this1315.Tag = Tag;
      _this1315.ElementType = ElementType;
      _this1315.PredefinedType = PredefinedType;
      _this1315.type = 1763565496;
      return _this1315;
    }

    return IfcRailType;
  }(IfcBuiltElementType);

  IFC4_32.IfcRailType = IfcRailType;

  var IfcRailingType = /*#__PURE__*/function (_IfcBuiltElementType16) {
    _inherits(IfcRailingType, _IfcBuiltElementType16);

    var _super1324 = _createSuper(IfcRailingType);

    function IfcRailingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1316;

      _classCallCheck2(this, IfcRailingType);

      _this1316 = _super1324.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1316.GlobalId = GlobalId;
      _this1316.OwnerHistory = OwnerHistory;
      _this1316.Name = Name;
      _this1316.Description = Description;
      _this1316.ApplicableOccurrence = ApplicableOccurrence;
      _this1316.HasPropertySets = HasPropertySets;
      _this1316.RepresentationMaps = RepresentationMaps;
      _this1316.Tag = Tag;
      _this1316.ElementType = ElementType;
      _this1316.PredefinedType = PredefinedType;
      _this1316.type = 2893384427;
      return _this1316;
    }

    return IfcRailingType;
  }(IfcBuiltElementType);

  IFC4_32.IfcRailingType = IfcRailingType;

  var IfcRailway = /*#__PURE__*/function (_IfcFacility2) {
    _inherits(IfcRailway, _IfcFacility2);

    var _super1325 = _createSuper(IfcRailway);

    function IfcRailway(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      var _this1317;

      _classCallCheck2(this, IfcRailway);

      _this1317 = _super1325.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this1317.GlobalId = GlobalId;
      _this1317.OwnerHistory = OwnerHistory;
      _this1317.Name = Name;
      _this1317.Description = Description;
      _this1317.ObjectType = ObjectType;
      _this1317.ObjectPlacement = ObjectPlacement;
      _this1317.Representation = Representation;
      _this1317.LongName = LongName;
      _this1317.CompositionType = CompositionType;
      _this1317.PredefinedType = PredefinedType;
      _this1317.type = 3992365140;
      return _this1317;
    }

    return IfcRailway;
  }(IfcFacility);

  IFC4_32.IfcRailway = IfcRailway;

  var IfcRailwayPart = /*#__PURE__*/function (_IfcFacilityPart3) {
    _inherits(IfcRailwayPart, _IfcFacilityPart3);

    var _super1326 = _createSuper(IfcRailwayPart);

    function IfcRailwayPart(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      var _this1318;

      _classCallCheck2(this, IfcRailwayPart);

      _this1318 = _super1326.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      _this1318.GlobalId = GlobalId;
      _this1318.OwnerHistory = OwnerHistory;
      _this1318.Name = Name;
      _this1318.Description = Description;
      _this1318.ObjectType = ObjectType;
      _this1318.ObjectPlacement = ObjectPlacement;
      _this1318.Representation = Representation;
      _this1318.LongName = LongName;
      _this1318.CompositionType = CompositionType;
      _this1318.UsageType = UsageType;
      _this1318.PredefinedType = PredefinedType;
      _this1318.type = 1891881377;
      return _this1318;
    }

    return IfcRailwayPart;
  }(IfcFacilityPart);

  IFC4_32.IfcRailwayPart = IfcRailwayPart;

  var IfcRampFlightType = /*#__PURE__*/function (_IfcBuiltElementType17) {
    _inherits(IfcRampFlightType, _IfcBuiltElementType17);

    var _super1327 = _createSuper(IfcRampFlightType);

    function IfcRampFlightType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1319;

      _classCallCheck2(this, IfcRampFlightType);

      _this1319 = _super1327.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1319.GlobalId = GlobalId;
      _this1319.OwnerHistory = OwnerHistory;
      _this1319.Name = Name;
      _this1319.Description = Description;
      _this1319.ApplicableOccurrence = ApplicableOccurrence;
      _this1319.HasPropertySets = HasPropertySets;
      _this1319.RepresentationMaps = RepresentationMaps;
      _this1319.Tag = Tag;
      _this1319.ElementType = ElementType;
      _this1319.PredefinedType = PredefinedType;
      _this1319.type = 2324767716;
      return _this1319;
    }

    return IfcRampFlightType;
  }(IfcBuiltElementType);

  IFC4_32.IfcRampFlightType = IfcRampFlightType;

  var IfcRampType = /*#__PURE__*/function (_IfcBuiltElementType18) {
    _inherits(IfcRampType, _IfcBuiltElementType18);

    var _super1328 = _createSuper(IfcRampType);

    function IfcRampType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1320;

      _classCallCheck2(this, IfcRampType);

      _this1320 = _super1328.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1320.GlobalId = GlobalId;
      _this1320.OwnerHistory = OwnerHistory;
      _this1320.Name = Name;
      _this1320.Description = Description;
      _this1320.ApplicableOccurrence = ApplicableOccurrence;
      _this1320.HasPropertySets = HasPropertySets;
      _this1320.RepresentationMaps = RepresentationMaps;
      _this1320.Tag = Tag;
      _this1320.ElementType = ElementType;
      _this1320.PredefinedType = PredefinedType;
      _this1320.type = 1469900589;
      return _this1320;
    }

    return IfcRampType;
  }(IfcBuiltElementType);

  IFC4_32.IfcRampType = IfcRampType;

  var IfcRationalBSplineSurfaceWithKnots = /*#__PURE__*/function (_IfcBSplineSurfaceWit) {
    _inherits(IfcRationalBSplineSurfaceWithKnots, _IfcBSplineSurfaceWit);

    var _super1329 = _createSuper(IfcRationalBSplineSurfaceWithKnots);

    function IfcRationalBSplineSurfaceWithKnots(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec, WeightsData) {
      var _this1321;

      _classCallCheck2(this, IfcRationalBSplineSurfaceWithKnots);

      _this1321 = _super1329.call(this, expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec);
      _this1321.UDegree = UDegree;
      _this1321.VDegree = VDegree;
      _this1321.ControlPointsList = ControlPointsList;
      _this1321.SurfaceForm = SurfaceForm;
      _this1321.UClosed = UClosed;
      _this1321.VClosed = VClosed;
      _this1321.SelfIntersect = SelfIntersect;
      _this1321.UMultiplicities = UMultiplicities;
      _this1321.VMultiplicities = VMultiplicities;
      _this1321.UKnots = UKnots;
      _this1321.VKnots = VKnots;
      _this1321.KnotSpec = KnotSpec;
      _this1321.WeightsData = WeightsData;
      _this1321.type = 683857671;
      return _this1321;
    }

    return IfcRationalBSplineSurfaceWithKnots;
  }(IfcBSplineSurfaceWithKnots);

  IFC4_32.IfcRationalBSplineSurfaceWithKnots = IfcRationalBSplineSurfaceWithKnots;

  var IfcReferent = /*#__PURE__*/function (_IfcPositioningElemen) {
    _inherits(IfcReferent, _IfcPositioningElemen);

    var _super1330 = _createSuper(IfcReferent);

    function IfcReferent(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      var _this1322;

      _classCallCheck2(this, IfcReferent);

      _this1322 = _super1330.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1322.GlobalId = GlobalId;
      _this1322.OwnerHistory = OwnerHistory;
      _this1322.Name = Name;
      _this1322.Description = Description;
      _this1322.ObjectType = ObjectType;
      _this1322.ObjectPlacement = ObjectPlacement;
      _this1322.Representation = Representation;
      _this1322.PredefinedType = PredefinedType;
      _this1322.type = 4021432810;
      return _this1322;
    }

    return IfcReferent;
  }(IfcPositioningElement);

  IFC4_32.IfcReferent = IfcReferent;

  var IfcReinforcingElement = /*#__PURE__*/function (_IfcElementComponent6) {
    _inherits(IfcReinforcingElement, _IfcElementComponent6);

    var _super1331 = _createSuper(IfcReinforcingElement);

    function IfcReinforcingElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      var _this1323;

      _classCallCheck2(this, IfcReinforcingElement);

      _this1323 = _super1331.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1323.GlobalId = GlobalId;
      _this1323.OwnerHistory = OwnerHistory;
      _this1323.Name = Name;
      _this1323.Description = Description;
      _this1323.ObjectType = ObjectType;
      _this1323.ObjectPlacement = ObjectPlacement;
      _this1323.Representation = Representation;
      _this1323.Tag = Tag;
      _this1323.SteelGrade = SteelGrade;
      _this1323.type = 3027567501;
      return _this1323;
    }

    return IfcReinforcingElement;
  }(IfcElementComponent);

  IFC4_32.IfcReinforcingElement = IfcReinforcingElement;

  var IfcReinforcingElementType = /*#__PURE__*/function (_IfcElementComponentT6) {
    _inherits(IfcReinforcingElementType, _IfcElementComponentT6);

    var _super1332 = _createSuper(IfcReinforcingElementType);

    function IfcReinforcingElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1324;

      _classCallCheck2(this, IfcReinforcingElementType);

      _this1324 = _super1332.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1324.GlobalId = GlobalId;
      _this1324.OwnerHistory = OwnerHistory;
      _this1324.Name = Name;
      _this1324.Description = Description;
      _this1324.ApplicableOccurrence = ApplicableOccurrence;
      _this1324.HasPropertySets = HasPropertySets;
      _this1324.RepresentationMaps = RepresentationMaps;
      _this1324.Tag = Tag;
      _this1324.ElementType = ElementType;
      _this1324.type = 964333572;
      return _this1324;
    }

    return IfcReinforcingElementType;
  }(IfcElementComponentType);

  IFC4_32.IfcReinforcingElementType = IfcReinforcingElementType;

  var IfcReinforcingMesh = /*#__PURE__*/function (_IfcReinforcingElemen5) {
    _inherits(IfcReinforcingMesh, _IfcReinforcingElemen5);

    var _super1333 = _createSuper(IfcReinforcingMesh);

    function IfcReinforcingMesh(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, PredefinedType) {
      var _this1325;

      _classCallCheck2(this, IfcReinforcingMesh);

      _this1325 = _super1333.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this1325.GlobalId = GlobalId;
      _this1325.OwnerHistory = OwnerHistory;
      _this1325.Name = Name;
      _this1325.Description = Description;
      _this1325.ObjectType = ObjectType;
      _this1325.ObjectPlacement = ObjectPlacement;
      _this1325.Representation = Representation;
      _this1325.Tag = Tag;
      _this1325.SteelGrade = SteelGrade;
      _this1325.MeshLength = MeshLength;
      _this1325.MeshWidth = MeshWidth;
      _this1325.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      _this1325.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      _this1325.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      _this1325.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      _this1325.LongitudinalBarSpacing = LongitudinalBarSpacing;
      _this1325.TransverseBarSpacing = TransverseBarSpacing;
      _this1325.PredefinedType = PredefinedType;
      _this1325.type = 2320036040;
      return _this1325;
    }

    return IfcReinforcingMesh;
  }(IfcReinforcingElement);

  IFC4_32.IfcReinforcingMesh = IfcReinforcingMesh;

  var IfcReinforcingMeshType = /*#__PURE__*/function (_IfcReinforcingElemen6) {
    _inherits(IfcReinforcingMeshType, _IfcReinforcingElemen6);

    var _super1334 = _createSuper(IfcReinforcingMeshType);

    function IfcReinforcingMeshType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, BendingShapeCode, BendingParameters) {
      var _this1326;

      _classCallCheck2(this, IfcReinforcingMeshType);

      _this1326 = _super1334.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1326.GlobalId = GlobalId;
      _this1326.OwnerHistory = OwnerHistory;
      _this1326.Name = Name;
      _this1326.Description = Description;
      _this1326.ApplicableOccurrence = ApplicableOccurrence;
      _this1326.HasPropertySets = HasPropertySets;
      _this1326.RepresentationMaps = RepresentationMaps;
      _this1326.Tag = Tag;
      _this1326.ElementType = ElementType;
      _this1326.PredefinedType = PredefinedType;
      _this1326.MeshLength = MeshLength;
      _this1326.MeshWidth = MeshWidth;
      _this1326.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      _this1326.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      _this1326.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      _this1326.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      _this1326.LongitudinalBarSpacing = LongitudinalBarSpacing;
      _this1326.TransverseBarSpacing = TransverseBarSpacing;
      _this1326.BendingShapeCode = BendingShapeCode;
      _this1326.BendingParameters = BendingParameters;
      _this1326.type = 2310774935;
      return _this1326;
    }

    return IfcReinforcingMeshType;
  }(IfcReinforcingElementType);

  IFC4_32.IfcReinforcingMeshType = IfcReinforcingMeshType;

  var IfcRelAdheresToElement = /*#__PURE__*/function (_IfcRelDecomposes6) {
    _inherits(IfcRelAdheresToElement, _IfcRelDecomposes6);

    var _super1335 = _createSuper(IfcRelAdheresToElement);

    function IfcRelAdheresToElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedSurfaceFeatures) {
      var _this1327;

      _classCallCheck2(this, IfcRelAdheresToElement);

      _this1327 = _super1335.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1327.GlobalId = GlobalId;
      _this1327.OwnerHistory = OwnerHistory;
      _this1327.Name = Name;
      _this1327.Description = Description;
      _this1327.RelatingElement = RelatingElement;
      _this1327.RelatedSurfaceFeatures = RelatedSurfaceFeatures;
      _this1327.type = 3818125796;
      return _this1327;
    }

    return IfcRelAdheresToElement;
  }(IfcRelDecomposes);

  IFC4_32.IfcRelAdheresToElement = IfcRelAdheresToElement;

  var IfcRelAggregates = /*#__PURE__*/function (_IfcRelDecomposes7) {
    _inherits(IfcRelAggregates, _IfcRelDecomposes7);

    var _super1336 = _createSuper(IfcRelAggregates);

    function IfcRelAggregates(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      var _this1328;

      _classCallCheck2(this, IfcRelAggregates);

      _this1328 = _super1336.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1328.GlobalId = GlobalId;
      _this1328.OwnerHistory = OwnerHistory;
      _this1328.Name = Name;
      _this1328.Description = Description;
      _this1328.RelatingObject = RelatingObject;
      _this1328.RelatedObjects = RelatedObjects;
      _this1328.type = 160246688;
      return _this1328;
    }

    return IfcRelAggregates;
  }(IfcRelDecomposes);

  IFC4_32.IfcRelAggregates = IfcRelAggregates;

  var IfcRoad = /*#__PURE__*/function (_IfcFacility3) {
    _inherits(IfcRoad, _IfcFacility3);

    var _super1337 = _createSuper(IfcRoad);

    function IfcRoad(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      var _this1329;

      _classCallCheck2(this, IfcRoad);

      _this1329 = _super1337.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this1329.GlobalId = GlobalId;
      _this1329.OwnerHistory = OwnerHistory;
      _this1329.Name = Name;
      _this1329.Description = Description;
      _this1329.ObjectType = ObjectType;
      _this1329.ObjectPlacement = ObjectPlacement;
      _this1329.Representation = Representation;
      _this1329.LongName = LongName;
      _this1329.CompositionType = CompositionType;
      _this1329.PredefinedType = PredefinedType;
      _this1329.type = 146592293;
      return _this1329;
    }

    return IfcRoad;
  }(IfcFacility);

  IFC4_32.IfcRoad = IfcRoad;

  var IfcRoadPart = /*#__PURE__*/function (_IfcFacilityPart4) {
    _inherits(IfcRoadPart, _IfcFacilityPart4);

    var _super1338 = _createSuper(IfcRoadPart);

    function IfcRoadPart(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      var _this1330;

      _classCallCheck2(this, IfcRoadPart);

      _this1330 = _super1338.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      _this1330.GlobalId = GlobalId;
      _this1330.OwnerHistory = OwnerHistory;
      _this1330.Name = Name;
      _this1330.Description = Description;
      _this1330.ObjectType = ObjectType;
      _this1330.ObjectPlacement = ObjectPlacement;
      _this1330.Representation = Representation;
      _this1330.LongName = LongName;
      _this1330.CompositionType = CompositionType;
      _this1330.UsageType = UsageType;
      _this1330.PredefinedType = PredefinedType;
      _this1330.type = 550521510;
      return _this1330;
    }

    return IfcRoadPart;
  }(IfcFacilityPart);

  IFC4_32.IfcRoadPart = IfcRoadPart;

  var IfcRoofType = /*#__PURE__*/function (_IfcBuiltElementType19) {
    _inherits(IfcRoofType, _IfcBuiltElementType19);

    var _super1339 = _createSuper(IfcRoofType);

    function IfcRoofType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1331;

      _classCallCheck2(this, IfcRoofType);

      _this1331 = _super1339.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1331.GlobalId = GlobalId;
      _this1331.OwnerHistory = OwnerHistory;
      _this1331.Name = Name;
      _this1331.Description = Description;
      _this1331.ApplicableOccurrence = ApplicableOccurrence;
      _this1331.HasPropertySets = HasPropertySets;
      _this1331.RepresentationMaps = RepresentationMaps;
      _this1331.Tag = Tag;
      _this1331.ElementType = ElementType;
      _this1331.PredefinedType = PredefinedType;
      _this1331.type = 2781568857;
      return _this1331;
    }

    return IfcRoofType;
  }(IfcBuiltElementType);

  IFC4_32.IfcRoofType = IfcRoofType;

  var IfcSanitaryTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType18) {
    _inherits(IfcSanitaryTerminalType, _IfcFlowTerminalType18);

    var _super1340 = _createSuper(IfcSanitaryTerminalType);

    function IfcSanitaryTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1332;

      _classCallCheck2(this, IfcSanitaryTerminalType);

      _this1332 = _super1340.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1332.GlobalId = GlobalId;
      _this1332.OwnerHistory = OwnerHistory;
      _this1332.Name = Name;
      _this1332.Description = Description;
      _this1332.ApplicableOccurrence = ApplicableOccurrence;
      _this1332.HasPropertySets = HasPropertySets;
      _this1332.RepresentationMaps = RepresentationMaps;
      _this1332.Tag = Tag;
      _this1332.ElementType = ElementType;
      _this1332.PredefinedType = PredefinedType;
      _this1332.type = 1768891740;
      return _this1332;
    }

    return IfcSanitaryTerminalType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcSanitaryTerminalType = IfcSanitaryTerminalType;

  var IfcSeamCurve = /*#__PURE__*/function (_IfcSurfaceCurve2) {
    _inherits(IfcSeamCurve, _IfcSurfaceCurve2);

    var _super1341 = _createSuper(IfcSeamCurve);

    function IfcSeamCurve(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      var _this1333;

      _classCallCheck2(this, IfcSeamCurve);

      _this1333 = _super1341.call(this, expressID, Curve3D, AssociatedGeometry, MasterRepresentation);
      _this1333.Curve3D = Curve3D;
      _this1333.AssociatedGeometry = AssociatedGeometry;
      _this1333.MasterRepresentation = MasterRepresentation;
      _this1333.type = 2157484638;
      return _this1333;
    }

    return IfcSeamCurve;
  }(IfcSurfaceCurve);

  IFC4_32.IfcSeamCurve = IfcSeamCurve;

  var IfcSecondOrderPolynomialSpiral = /*#__PURE__*/function (_IfcSpiral4) {
    _inherits(IfcSecondOrderPolynomialSpiral, _IfcSpiral4);

    var _super1342 = _createSuper(IfcSecondOrderPolynomialSpiral);

    function IfcSecondOrderPolynomialSpiral(expressID, Position, QuadraticTerm, LinearTerm, ConstantTerm) {
      var _this1334;

      _classCallCheck2(this, IfcSecondOrderPolynomialSpiral);

      _this1334 = _super1342.call(this, expressID, Position);
      _this1334.Position = Position;
      _this1334.QuadraticTerm = QuadraticTerm;
      _this1334.LinearTerm = LinearTerm;
      _this1334.ConstantTerm = ConstantTerm;
      _this1334.type = 3649235739;
      return _this1334;
    }

    return IfcSecondOrderPolynomialSpiral;
  }(IfcSpiral);

  IFC4_32.IfcSecondOrderPolynomialSpiral = IfcSecondOrderPolynomialSpiral;

  var IfcSegmentedReferenceCurve = /*#__PURE__*/function (_IfcCompositeCurve4) {
    _inherits(IfcSegmentedReferenceCurve, _IfcCompositeCurve4);

    var _super1343 = _createSuper(IfcSegmentedReferenceCurve);

    function IfcSegmentedReferenceCurve(expressID, Segments, SelfIntersect, BaseCurve, EndPoint) {
      var _this1335;

      _classCallCheck2(this, IfcSegmentedReferenceCurve);

      _this1335 = _super1343.call(this, expressID, Segments, SelfIntersect);
      _this1335.Segments = Segments;
      _this1335.SelfIntersect = SelfIntersect;
      _this1335.BaseCurve = BaseCurve;
      _this1335.EndPoint = EndPoint;
      _this1335.type = 544395925;
      return _this1335;
    }

    return IfcSegmentedReferenceCurve;
  }(IfcCompositeCurve);

  IFC4_32.IfcSegmentedReferenceCurve = IfcSegmentedReferenceCurve;

  var IfcSeventhOrderPolynomialSpiral = /*#__PURE__*/function (_IfcSpiral5) {
    _inherits(IfcSeventhOrderPolynomialSpiral, _IfcSpiral5);

    var _super1344 = _createSuper(IfcSeventhOrderPolynomialSpiral);

    function IfcSeventhOrderPolynomialSpiral(expressID, Position, SepticTerm, SexticTerm, QuinticTerm, QuarticTerm, CubicTerm, QuadraticTerm, LinearTerm, ConstantTerm) {
      var _this1336;

      _classCallCheck2(this, IfcSeventhOrderPolynomialSpiral);

      _this1336 = _super1344.call(this, expressID, Position);
      _this1336.Position = Position;
      _this1336.SepticTerm = SepticTerm;
      _this1336.SexticTerm = SexticTerm;
      _this1336.QuinticTerm = QuinticTerm;
      _this1336.QuarticTerm = QuarticTerm;
      _this1336.CubicTerm = CubicTerm;
      _this1336.QuadraticTerm = QuadraticTerm;
      _this1336.LinearTerm = LinearTerm;
      _this1336.ConstantTerm = ConstantTerm;
      _this1336.type = 1027922057;
      return _this1336;
    }

    return IfcSeventhOrderPolynomialSpiral;
  }(IfcSpiral);

  IFC4_32.IfcSeventhOrderPolynomialSpiral = IfcSeventhOrderPolynomialSpiral;

  var IfcShadingDeviceType = /*#__PURE__*/function (_IfcBuiltElementType20) {
    _inherits(IfcShadingDeviceType, _IfcBuiltElementType20);

    var _super1345 = _createSuper(IfcShadingDeviceType);

    function IfcShadingDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1337;

      _classCallCheck2(this, IfcShadingDeviceType);

      _this1337 = _super1345.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1337.GlobalId = GlobalId;
      _this1337.OwnerHistory = OwnerHistory;
      _this1337.Name = Name;
      _this1337.Description = Description;
      _this1337.ApplicableOccurrence = ApplicableOccurrence;
      _this1337.HasPropertySets = HasPropertySets;
      _this1337.RepresentationMaps = RepresentationMaps;
      _this1337.Tag = Tag;
      _this1337.ElementType = ElementType;
      _this1337.PredefinedType = PredefinedType;
      _this1337.type = 4074543187;
      return _this1337;
    }

    return IfcShadingDeviceType;
  }(IfcBuiltElementType);

  IFC4_32.IfcShadingDeviceType = IfcShadingDeviceType;

  var IfcSign = /*#__PURE__*/function (_IfcElementComponent7) {
    _inherits(IfcSign, _IfcElementComponent7);

    var _super1346 = _createSuper(IfcSign);

    function IfcSign(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1338;

      _classCallCheck2(this, IfcSign);

      _this1338 = _super1346.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1338.GlobalId = GlobalId;
      _this1338.OwnerHistory = OwnerHistory;
      _this1338.Name = Name;
      _this1338.Description = Description;
      _this1338.ObjectType = ObjectType;
      _this1338.ObjectPlacement = ObjectPlacement;
      _this1338.Representation = Representation;
      _this1338.Tag = Tag;
      _this1338.PredefinedType = PredefinedType;
      _this1338.type = 33720170;
      return _this1338;
    }

    return IfcSign;
  }(IfcElementComponent);

  IFC4_32.IfcSign = IfcSign;

  var IfcSignType = /*#__PURE__*/function (_IfcElementComponentT7) {
    _inherits(IfcSignType, _IfcElementComponentT7);

    var _super1347 = _createSuper(IfcSignType);

    function IfcSignType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1339;

      _classCallCheck2(this, IfcSignType);

      _this1339 = _super1347.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1339.GlobalId = GlobalId;
      _this1339.OwnerHistory = OwnerHistory;
      _this1339.Name = Name;
      _this1339.Description = Description;
      _this1339.ApplicableOccurrence = ApplicableOccurrence;
      _this1339.HasPropertySets = HasPropertySets;
      _this1339.RepresentationMaps = RepresentationMaps;
      _this1339.Tag = Tag;
      _this1339.ElementType = ElementType;
      _this1339.PredefinedType = PredefinedType;
      _this1339.type = 3599934289;
      return _this1339;
    }

    return IfcSignType;
  }(IfcElementComponentType);

  IFC4_32.IfcSignType = IfcSignType;

  var IfcSignalType = /*#__PURE__*/function (_IfcFlowTerminalType19) {
    _inherits(IfcSignalType, _IfcFlowTerminalType19);

    var _super1348 = _createSuper(IfcSignalType);

    function IfcSignalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1340;

      _classCallCheck2(this, IfcSignalType);

      _this1340 = _super1348.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1340.GlobalId = GlobalId;
      _this1340.OwnerHistory = OwnerHistory;
      _this1340.Name = Name;
      _this1340.Description = Description;
      _this1340.ApplicableOccurrence = ApplicableOccurrence;
      _this1340.HasPropertySets = HasPropertySets;
      _this1340.RepresentationMaps = RepresentationMaps;
      _this1340.Tag = Tag;
      _this1340.ElementType = ElementType;
      _this1340.PredefinedType = PredefinedType;
      _this1340.type = 1894708472;
      return _this1340;
    }

    return IfcSignalType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcSignalType = IfcSignalType;

  var IfcSineSpiral = /*#__PURE__*/function (_IfcSpiral6) {
    _inherits(IfcSineSpiral, _IfcSpiral6);

    var _super1349 = _createSuper(IfcSineSpiral);

    function IfcSineSpiral(expressID, Position, SineTerm, LinearTerm, ConstantTerm) {
      var _this1341;

      _classCallCheck2(this, IfcSineSpiral);

      _this1341 = _super1349.call(this, expressID, Position);
      _this1341.Position = Position;
      _this1341.SineTerm = SineTerm;
      _this1341.LinearTerm = LinearTerm;
      _this1341.ConstantTerm = ConstantTerm;
      _this1341.type = 42703149;
      return _this1341;
    }

    return IfcSineSpiral;
  }(IfcSpiral);

  IFC4_32.IfcSineSpiral = IfcSineSpiral;

  var IfcSite = /*#__PURE__*/function (_IfcSpatialStructureE9) {
    _inherits(IfcSite, _IfcSpatialStructureE9);

    var _super1350 = _createSuper(IfcSite);

    function IfcSite(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress) {
      var _this1342;

      _classCallCheck2(this, IfcSite);

      _this1342 = _super1350.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this1342.GlobalId = GlobalId;
      _this1342.OwnerHistory = OwnerHistory;
      _this1342.Name = Name;
      _this1342.Description = Description;
      _this1342.ObjectType = ObjectType;
      _this1342.ObjectPlacement = ObjectPlacement;
      _this1342.Representation = Representation;
      _this1342.LongName = LongName;
      _this1342.CompositionType = CompositionType;
      _this1342.RefLatitude = RefLatitude;
      _this1342.RefLongitude = RefLongitude;
      _this1342.RefElevation = RefElevation;
      _this1342.LandTitleNumber = LandTitleNumber;
      _this1342.SiteAddress = SiteAddress;
      _this1342.type = 4097777520;
      return _this1342;
    }

    return IfcSite;
  }(IfcSpatialStructureElement);

  IFC4_32.IfcSite = IfcSite;

  var IfcSlabType = /*#__PURE__*/function (_IfcBuiltElementType21) {
    _inherits(IfcSlabType, _IfcBuiltElementType21);

    var _super1351 = _createSuper(IfcSlabType);

    function IfcSlabType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1343;

      _classCallCheck2(this, IfcSlabType);

      _this1343 = _super1351.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1343.GlobalId = GlobalId;
      _this1343.OwnerHistory = OwnerHistory;
      _this1343.Name = Name;
      _this1343.Description = Description;
      _this1343.ApplicableOccurrence = ApplicableOccurrence;
      _this1343.HasPropertySets = HasPropertySets;
      _this1343.RepresentationMaps = RepresentationMaps;
      _this1343.Tag = Tag;
      _this1343.ElementType = ElementType;
      _this1343.PredefinedType = PredefinedType;
      _this1343.type = 2533589738;
      return _this1343;
    }

    return IfcSlabType;
  }(IfcBuiltElementType);

  IFC4_32.IfcSlabType = IfcSlabType;

  var IfcSolarDeviceType = /*#__PURE__*/function (_IfcEnergyConversionD25) {
    _inherits(IfcSolarDeviceType, _IfcEnergyConversionD25);

    var _super1352 = _createSuper(IfcSolarDeviceType);

    function IfcSolarDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1344;

      _classCallCheck2(this, IfcSolarDeviceType);

      _this1344 = _super1352.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1344.GlobalId = GlobalId;
      _this1344.OwnerHistory = OwnerHistory;
      _this1344.Name = Name;
      _this1344.Description = Description;
      _this1344.ApplicableOccurrence = ApplicableOccurrence;
      _this1344.HasPropertySets = HasPropertySets;
      _this1344.RepresentationMaps = RepresentationMaps;
      _this1344.Tag = Tag;
      _this1344.ElementType = ElementType;
      _this1344.PredefinedType = PredefinedType;
      _this1344.type = 1072016465;
      return _this1344;
    }

    return IfcSolarDeviceType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcSolarDeviceType = IfcSolarDeviceType;

  var IfcSpace = /*#__PURE__*/function (_IfcSpatialStructureE10) {
    _inherits(IfcSpace, _IfcSpatialStructureE10);

    var _super1353 = _createSuper(IfcSpace);

    function IfcSpace(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType, ElevationWithFlooring) {
      var _this1345;

      _classCallCheck2(this, IfcSpace);

      _this1345 = _super1353.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this1345.GlobalId = GlobalId;
      _this1345.OwnerHistory = OwnerHistory;
      _this1345.Name = Name;
      _this1345.Description = Description;
      _this1345.ObjectType = ObjectType;
      _this1345.ObjectPlacement = ObjectPlacement;
      _this1345.Representation = Representation;
      _this1345.LongName = LongName;
      _this1345.CompositionType = CompositionType;
      _this1345.PredefinedType = PredefinedType;
      _this1345.ElevationWithFlooring = ElevationWithFlooring;
      _this1345.type = 3856911033;
      return _this1345;
    }

    return IfcSpace;
  }(IfcSpatialStructureElement);

  IFC4_32.IfcSpace = IfcSpace;

  var IfcSpaceHeaterType = /*#__PURE__*/function (_IfcFlowTerminalType20) {
    _inherits(IfcSpaceHeaterType, _IfcFlowTerminalType20);

    var _super1354 = _createSuper(IfcSpaceHeaterType);

    function IfcSpaceHeaterType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1346;

      _classCallCheck2(this, IfcSpaceHeaterType);

      _this1346 = _super1354.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1346.GlobalId = GlobalId;
      _this1346.OwnerHistory = OwnerHistory;
      _this1346.Name = Name;
      _this1346.Description = Description;
      _this1346.ApplicableOccurrence = ApplicableOccurrence;
      _this1346.HasPropertySets = HasPropertySets;
      _this1346.RepresentationMaps = RepresentationMaps;
      _this1346.Tag = Tag;
      _this1346.ElementType = ElementType;
      _this1346.PredefinedType = PredefinedType;
      _this1346.type = 1305183839;
      return _this1346;
    }

    return IfcSpaceHeaterType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcSpaceHeaterType = IfcSpaceHeaterType;

  var IfcSpaceType = /*#__PURE__*/function (_IfcSpatialStructureE11) {
    _inherits(IfcSpaceType, _IfcSpatialStructureE11);

    var _super1355 = _createSuper(IfcSpaceType);

    function IfcSpaceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      var _this1347;

      _classCallCheck2(this, IfcSpaceType);

      _this1347 = _super1355.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1347.GlobalId = GlobalId;
      _this1347.OwnerHistory = OwnerHistory;
      _this1347.Name = Name;
      _this1347.Description = Description;
      _this1347.ApplicableOccurrence = ApplicableOccurrence;
      _this1347.HasPropertySets = HasPropertySets;
      _this1347.RepresentationMaps = RepresentationMaps;
      _this1347.Tag = Tag;
      _this1347.ElementType = ElementType;
      _this1347.PredefinedType = PredefinedType;
      _this1347.LongName = LongName;
      _this1347.type = 3812236995;
      return _this1347;
    }

    return IfcSpaceType;
  }(IfcSpatialStructureElementType);

  IFC4_32.IfcSpaceType = IfcSpaceType;

  var IfcStackTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType21) {
    _inherits(IfcStackTerminalType, _IfcFlowTerminalType21);

    var _super1356 = _createSuper(IfcStackTerminalType);

    function IfcStackTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1348;

      _classCallCheck2(this, IfcStackTerminalType);

      _this1348 = _super1356.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1348.GlobalId = GlobalId;
      _this1348.OwnerHistory = OwnerHistory;
      _this1348.Name = Name;
      _this1348.Description = Description;
      _this1348.ApplicableOccurrence = ApplicableOccurrence;
      _this1348.HasPropertySets = HasPropertySets;
      _this1348.RepresentationMaps = RepresentationMaps;
      _this1348.Tag = Tag;
      _this1348.ElementType = ElementType;
      _this1348.PredefinedType = PredefinedType;
      _this1348.type = 3112655638;
      return _this1348;
    }

    return IfcStackTerminalType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcStackTerminalType = IfcStackTerminalType;

  var IfcStairFlightType = /*#__PURE__*/function (_IfcBuiltElementType22) {
    _inherits(IfcStairFlightType, _IfcBuiltElementType22);

    var _super1357 = _createSuper(IfcStairFlightType);

    function IfcStairFlightType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1349;

      _classCallCheck2(this, IfcStairFlightType);

      _this1349 = _super1357.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1349.GlobalId = GlobalId;
      _this1349.OwnerHistory = OwnerHistory;
      _this1349.Name = Name;
      _this1349.Description = Description;
      _this1349.ApplicableOccurrence = ApplicableOccurrence;
      _this1349.HasPropertySets = HasPropertySets;
      _this1349.RepresentationMaps = RepresentationMaps;
      _this1349.Tag = Tag;
      _this1349.ElementType = ElementType;
      _this1349.PredefinedType = PredefinedType;
      _this1349.type = 1039846685;
      return _this1349;
    }

    return IfcStairFlightType;
  }(IfcBuiltElementType);

  IFC4_32.IfcStairFlightType = IfcStairFlightType;

  var IfcStairType = /*#__PURE__*/function (_IfcBuiltElementType23) {
    _inherits(IfcStairType, _IfcBuiltElementType23);

    var _super1358 = _createSuper(IfcStairType);

    function IfcStairType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1350;

      _classCallCheck2(this, IfcStairType);

      _this1350 = _super1358.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1350.GlobalId = GlobalId;
      _this1350.OwnerHistory = OwnerHistory;
      _this1350.Name = Name;
      _this1350.Description = Description;
      _this1350.ApplicableOccurrence = ApplicableOccurrence;
      _this1350.HasPropertySets = HasPropertySets;
      _this1350.RepresentationMaps = RepresentationMaps;
      _this1350.Tag = Tag;
      _this1350.ElementType = ElementType;
      _this1350.PredefinedType = PredefinedType;
      _this1350.type = 338393293;
      return _this1350;
    }

    return IfcStairType;
  }(IfcBuiltElementType);

  IFC4_32.IfcStairType = IfcStairType;

  var IfcStructuralAction = /*#__PURE__*/function (_IfcStructuralActivit4) {
    _inherits(IfcStructuralAction, _IfcStructuralActivit4);

    var _super1359 = _createSuper(IfcStructuralAction);

    function IfcStructuralAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      var _this1351;

      _classCallCheck2(this, IfcStructuralAction);

      _this1351 = _super1359.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this1351.GlobalId = GlobalId;
      _this1351.OwnerHistory = OwnerHistory;
      _this1351.Name = Name;
      _this1351.Description = Description;
      _this1351.ObjectType = ObjectType;
      _this1351.ObjectPlacement = ObjectPlacement;
      _this1351.Representation = Representation;
      _this1351.AppliedLoad = AppliedLoad;
      _this1351.GlobalOrLocal = GlobalOrLocal;
      _this1351.DestabilizingLoad = DestabilizingLoad;
      _this1351.type = 682877961;
      return _this1351;
    }

    return IfcStructuralAction;
  }(IfcStructuralActivity);

  IFC4_32.IfcStructuralAction = IfcStructuralAction;

  var IfcStructuralConnection = /*#__PURE__*/function (_IfcStructuralItem4) {
    _inherits(IfcStructuralConnection, _IfcStructuralItem4);

    var _super1360 = _createSuper(IfcStructuralConnection);

    function IfcStructuralConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      var _this1352;

      _classCallCheck2(this, IfcStructuralConnection);

      _this1352 = _super1360.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1352.GlobalId = GlobalId;
      _this1352.OwnerHistory = OwnerHistory;
      _this1352.Name = Name;
      _this1352.Description = Description;
      _this1352.ObjectType = ObjectType;
      _this1352.ObjectPlacement = ObjectPlacement;
      _this1352.Representation = Representation;
      _this1352.AppliedCondition = AppliedCondition;
      _this1352.type = 1179482911;
      return _this1352;
    }

    return IfcStructuralConnection;
  }(IfcStructuralItem);

  IFC4_32.IfcStructuralConnection = IfcStructuralConnection;

  var IfcStructuralCurveAction = /*#__PURE__*/function (_IfcStructuralAction4) {
    _inherits(IfcStructuralCurveAction, _IfcStructuralAction4);

    var _super1361 = _createSuper(IfcStructuralCurveAction);

    function IfcStructuralCurveAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      var _this1353;

      _classCallCheck2(this, IfcStructuralCurveAction);

      _this1353 = _super1361.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      _this1353.GlobalId = GlobalId;
      _this1353.OwnerHistory = OwnerHistory;
      _this1353.Name = Name;
      _this1353.Description = Description;
      _this1353.ObjectType = ObjectType;
      _this1353.ObjectPlacement = ObjectPlacement;
      _this1353.Representation = Representation;
      _this1353.AppliedLoad = AppliedLoad;
      _this1353.GlobalOrLocal = GlobalOrLocal;
      _this1353.DestabilizingLoad = DestabilizingLoad;
      _this1353.ProjectedOrTrue = ProjectedOrTrue;
      _this1353.PredefinedType = PredefinedType;
      _this1353.type = 1004757350;
      return _this1353;
    }

    return IfcStructuralCurveAction;
  }(IfcStructuralAction);

  IFC4_32.IfcStructuralCurveAction = IfcStructuralCurveAction;

  var IfcStructuralCurveConnection = /*#__PURE__*/function (_IfcStructuralConnect8) {
    _inherits(IfcStructuralCurveConnection, _IfcStructuralConnect8);

    var _super1362 = _createSuper(IfcStructuralCurveConnection);

    function IfcStructuralCurveConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, AxisDirection) {
      var _this1354;

      _classCallCheck2(this, IfcStructuralCurveConnection);

      _this1354 = _super1362.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      _this1354.GlobalId = GlobalId;
      _this1354.OwnerHistory = OwnerHistory;
      _this1354.Name = Name;
      _this1354.Description = Description;
      _this1354.ObjectType = ObjectType;
      _this1354.ObjectPlacement = ObjectPlacement;
      _this1354.Representation = Representation;
      _this1354.AppliedCondition = AppliedCondition;
      _this1354.AxisDirection = AxisDirection;
      _this1354.type = 4243806635;
      return _this1354;
    }

    return IfcStructuralCurveConnection;
  }(IfcStructuralConnection);

  IFC4_32.IfcStructuralCurveConnection = IfcStructuralCurveConnection;

  var IfcStructuralCurveMember = /*#__PURE__*/function (_IfcStructuralMember4) {
    _inherits(IfcStructuralCurveMember, _IfcStructuralMember4);

    var _super1363 = _createSuper(IfcStructuralCurveMember);

    function IfcStructuralCurveMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      var _this1355;

      _classCallCheck2(this, IfcStructuralCurveMember);

      _this1355 = _super1363.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1355.GlobalId = GlobalId;
      _this1355.OwnerHistory = OwnerHistory;
      _this1355.Name = Name;
      _this1355.Description = Description;
      _this1355.ObjectType = ObjectType;
      _this1355.ObjectPlacement = ObjectPlacement;
      _this1355.Representation = Representation;
      _this1355.PredefinedType = PredefinedType;
      _this1355.Axis = Axis;
      _this1355.type = 214636428;
      return _this1355;
    }

    return IfcStructuralCurveMember;
  }(IfcStructuralMember);

  IFC4_32.IfcStructuralCurveMember = IfcStructuralCurveMember;

  var IfcStructuralCurveMemberVarying = /*#__PURE__*/function (_IfcStructuralCurveMe2) {
    _inherits(IfcStructuralCurveMemberVarying, _IfcStructuralCurveMe2);

    var _super1364 = _createSuper(IfcStructuralCurveMemberVarying);

    function IfcStructuralCurveMemberVarying(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      var _this1356;

      _classCallCheck2(this, IfcStructuralCurveMemberVarying);

      _this1356 = _super1364.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis);
      _this1356.GlobalId = GlobalId;
      _this1356.OwnerHistory = OwnerHistory;
      _this1356.Name = Name;
      _this1356.Description = Description;
      _this1356.ObjectType = ObjectType;
      _this1356.ObjectPlacement = ObjectPlacement;
      _this1356.Representation = Representation;
      _this1356.PredefinedType = PredefinedType;
      _this1356.Axis = Axis;
      _this1356.type = 2445595289;
      return _this1356;
    }

    return IfcStructuralCurveMemberVarying;
  }(IfcStructuralCurveMember);

  IFC4_32.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;

  var IfcStructuralCurveReaction = /*#__PURE__*/function (_IfcStructuralReactio3) {
    _inherits(IfcStructuralCurveReaction, _IfcStructuralReactio3);

    var _super1365 = _createSuper(IfcStructuralCurveReaction);

    function IfcStructuralCurveReaction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      var _this1357;

      _classCallCheck2(this, IfcStructuralCurveReaction);

      _this1357 = _super1365.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this1357.GlobalId = GlobalId;
      _this1357.OwnerHistory = OwnerHistory;
      _this1357.Name = Name;
      _this1357.Description = Description;
      _this1357.ObjectType = ObjectType;
      _this1357.ObjectPlacement = ObjectPlacement;
      _this1357.Representation = Representation;
      _this1357.AppliedLoad = AppliedLoad;
      _this1357.GlobalOrLocal = GlobalOrLocal;
      _this1357.PredefinedType = PredefinedType;
      _this1357.type = 2757150158;
      return _this1357;
    }

    return IfcStructuralCurveReaction;
  }(IfcStructuralReaction);

  IFC4_32.IfcStructuralCurveReaction = IfcStructuralCurveReaction;

  var IfcStructuralLinearAction = /*#__PURE__*/function (_IfcStructuralCurveAc) {
    _inherits(IfcStructuralLinearAction, _IfcStructuralCurveAc);

    var _super1366 = _createSuper(IfcStructuralLinearAction);

    function IfcStructuralLinearAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      var _this1358;

      _classCallCheck2(this, IfcStructuralLinearAction);

      _this1358 = _super1366.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      _this1358.GlobalId = GlobalId;
      _this1358.OwnerHistory = OwnerHistory;
      _this1358.Name = Name;
      _this1358.Description = Description;
      _this1358.ObjectType = ObjectType;
      _this1358.ObjectPlacement = ObjectPlacement;
      _this1358.Representation = Representation;
      _this1358.AppliedLoad = AppliedLoad;
      _this1358.GlobalOrLocal = GlobalOrLocal;
      _this1358.DestabilizingLoad = DestabilizingLoad;
      _this1358.ProjectedOrTrue = ProjectedOrTrue;
      _this1358.PredefinedType = PredefinedType;
      _this1358.type = 1807405624;
      return _this1358;
    }

    return IfcStructuralLinearAction;
  }(IfcStructuralCurveAction);

  IFC4_32.IfcStructuralLinearAction = IfcStructuralLinearAction;

  var IfcStructuralLoadGroup = /*#__PURE__*/function (_IfcGroup9) {
    _inherits(IfcStructuralLoadGroup, _IfcGroup9);

    var _super1367 = _createSuper(IfcStructuralLoadGroup);

    function IfcStructuralLoadGroup(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose) {
      var _this1359;

      _classCallCheck2(this, IfcStructuralLoadGroup);

      _this1359 = _super1367.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1359.GlobalId = GlobalId;
      _this1359.OwnerHistory = OwnerHistory;
      _this1359.Name = Name;
      _this1359.Description = Description;
      _this1359.ObjectType = ObjectType;
      _this1359.PredefinedType = PredefinedType;
      _this1359.ActionType = ActionType;
      _this1359.ActionSource = ActionSource;
      _this1359.Coefficient = Coefficient;
      _this1359.Purpose = Purpose;
      _this1359.type = 1252848954;
      return _this1359;
    }

    return IfcStructuralLoadGroup;
  }(IfcGroup);

  IFC4_32.IfcStructuralLoadGroup = IfcStructuralLoadGroup;

  var IfcStructuralPointAction = /*#__PURE__*/function (_IfcStructuralAction5) {
    _inherits(IfcStructuralPointAction, _IfcStructuralAction5);

    var _super1368 = _createSuper(IfcStructuralPointAction);

    function IfcStructuralPointAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      var _this1360;

      _classCallCheck2(this, IfcStructuralPointAction);

      _this1360 = _super1368.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      _this1360.GlobalId = GlobalId;
      _this1360.OwnerHistory = OwnerHistory;
      _this1360.Name = Name;
      _this1360.Description = Description;
      _this1360.ObjectType = ObjectType;
      _this1360.ObjectPlacement = ObjectPlacement;
      _this1360.Representation = Representation;
      _this1360.AppliedLoad = AppliedLoad;
      _this1360.GlobalOrLocal = GlobalOrLocal;
      _this1360.DestabilizingLoad = DestabilizingLoad;
      _this1360.type = 2082059205;
      return _this1360;
    }

    return IfcStructuralPointAction;
  }(IfcStructuralAction);

  IFC4_32.IfcStructuralPointAction = IfcStructuralPointAction;

  var IfcStructuralPointConnection = /*#__PURE__*/function (_IfcStructuralConnect9) {
    _inherits(IfcStructuralPointConnection, _IfcStructuralConnect9);

    var _super1369 = _createSuper(IfcStructuralPointConnection);

    function IfcStructuralPointConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, ConditionCoordinateSystem) {
      var _this1361;

      _classCallCheck2(this, IfcStructuralPointConnection);

      _this1361 = _super1369.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      _this1361.GlobalId = GlobalId;
      _this1361.OwnerHistory = OwnerHistory;
      _this1361.Name = Name;
      _this1361.Description = Description;
      _this1361.ObjectType = ObjectType;
      _this1361.ObjectPlacement = ObjectPlacement;
      _this1361.Representation = Representation;
      _this1361.AppliedCondition = AppliedCondition;
      _this1361.ConditionCoordinateSystem = ConditionCoordinateSystem;
      _this1361.type = 734778138;
      return _this1361;
    }

    return IfcStructuralPointConnection;
  }(IfcStructuralConnection);

  IFC4_32.IfcStructuralPointConnection = IfcStructuralPointConnection;

  var IfcStructuralPointReaction = /*#__PURE__*/function (_IfcStructuralReactio4) {
    _inherits(IfcStructuralPointReaction, _IfcStructuralReactio4);

    var _super1370 = _createSuper(IfcStructuralPointReaction);

    function IfcStructuralPointReaction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      var _this1362;

      _classCallCheck2(this, IfcStructuralPointReaction);

      _this1362 = _super1370.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this1362.GlobalId = GlobalId;
      _this1362.OwnerHistory = OwnerHistory;
      _this1362.Name = Name;
      _this1362.Description = Description;
      _this1362.ObjectType = ObjectType;
      _this1362.ObjectPlacement = ObjectPlacement;
      _this1362.Representation = Representation;
      _this1362.AppliedLoad = AppliedLoad;
      _this1362.GlobalOrLocal = GlobalOrLocal;
      _this1362.type = 1235345126;
      return _this1362;
    }

    return IfcStructuralPointReaction;
  }(IfcStructuralReaction);

  IFC4_32.IfcStructuralPointReaction = IfcStructuralPointReaction;

  var IfcStructuralResultGroup = /*#__PURE__*/function (_IfcGroup10) {
    _inherits(IfcStructuralResultGroup, _IfcGroup10);

    var _super1371 = _createSuper(IfcStructuralResultGroup);

    function IfcStructuralResultGroup(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear) {
      var _this1363;

      _classCallCheck2(this, IfcStructuralResultGroup);

      _this1363 = _super1371.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1363.GlobalId = GlobalId;
      _this1363.OwnerHistory = OwnerHistory;
      _this1363.Name = Name;
      _this1363.Description = Description;
      _this1363.ObjectType = ObjectType;
      _this1363.TheoryType = TheoryType;
      _this1363.ResultForLoadGroup = ResultForLoadGroup;
      _this1363.IsLinear = IsLinear;
      _this1363.type = 2986769608;
      return _this1363;
    }

    return IfcStructuralResultGroup;
  }(IfcGroup);

  IFC4_32.IfcStructuralResultGroup = IfcStructuralResultGroup;

  var IfcStructuralSurfaceAction = /*#__PURE__*/function (_IfcStructuralAction6) {
    _inherits(IfcStructuralSurfaceAction, _IfcStructuralAction6);

    var _super1372 = _createSuper(IfcStructuralSurfaceAction);

    function IfcStructuralSurfaceAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      var _this1364;

      _classCallCheck2(this, IfcStructuralSurfaceAction);

      _this1364 = _super1372.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      _this1364.GlobalId = GlobalId;
      _this1364.OwnerHistory = OwnerHistory;
      _this1364.Name = Name;
      _this1364.Description = Description;
      _this1364.ObjectType = ObjectType;
      _this1364.ObjectPlacement = ObjectPlacement;
      _this1364.Representation = Representation;
      _this1364.AppliedLoad = AppliedLoad;
      _this1364.GlobalOrLocal = GlobalOrLocal;
      _this1364.DestabilizingLoad = DestabilizingLoad;
      _this1364.ProjectedOrTrue = ProjectedOrTrue;
      _this1364.PredefinedType = PredefinedType;
      _this1364.type = 3657597509;
      return _this1364;
    }

    return IfcStructuralSurfaceAction;
  }(IfcStructuralAction);

  IFC4_32.IfcStructuralSurfaceAction = IfcStructuralSurfaceAction;

  var IfcStructuralSurfaceConnection = /*#__PURE__*/function (_IfcStructuralConnect10) {
    _inherits(IfcStructuralSurfaceConnection, _IfcStructuralConnect10);

    var _super1373 = _createSuper(IfcStructuralSurfaceConnection);

    function IfcStructuralSurfaceConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      var _this1365;

      _classCallCheck2(this, IfcStructuralSurfaceConnection);

      _this1365 = _super1373.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      _this1365.GlobalId = GlobalId;
      _this1365.OwnerHistory = OwnerHistory;
      _this1365.Name = Name;
      _this1365.Description = Description;
      _this1365.ObjectType = ObjectType;
      _this1365.ObjectPlacement = ObjectPlacement;
      _this1365.Representation = Representation;
      _this1365.AppliedCondition = AppliedCondition;
      _this1365.type = 1975003073;
      return _this1365;
    }

    return IfcStructuralSurfaceConnection;
  }(IfcStructuralConnection);

  IFC4_32.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;

  var IfcSubContractResource = /*#__PURE__*/function (_IfcConstructionResou15) {
    _inherits(IfcSubContractResource, _IfcConstructionResou15);

    var _super1374 = _createSuper(IfcSubContractResource);

    function IfcSubContractResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1366;

      _classCallCheck2(this, IfcSubContractResource);

      _this1366 = _super1374.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this1366.GlobalId = GlobalId;
      _this1366.OwnerHistory = OwnerHistory;
      _this1366.Name = Name;
      _this1366.Description = Description;
      _this1366.ObjectType = ObjectType;
      _this1366.Identification = Identification;
      _this1366.LongDescription = LongDescription;
      _this1366.Usage = Usage;
      _this1366.BaseCosts = BaseCosts;
      _this1366.BaseQuantity = BaseQuantity;
      _this1366.PredefinedType = PredefinedType;
      _this1366.type = 148013059;
      return _this1366;
    }

    return IfcSubContractResource;
  }(IfcConstructionResource);

  IFC4_32.IfcSubContractResource = IfcSubContractResource;

  var IfcSurfaceFeature = /*#__PURE__*/function (_IfcFeatureElement5) {
    _inherits(IfcSurfaceFeature, _IfcFeatureElement5);

    var _super1375 = _createSuper(IfcSurfaceFeature);

    function IfcSurfaceFeature(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1367;

      _classCallCheck2(this, IfcSurfaceFeature);

      _this1367 = _super1375.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1367.GlobalId = GlobalId;
      _this1367.OwnerHistory = OwnerHistory;
      _this1367.Name = Name;
      _this1367.Description = Description;
      _this1367.ObjectType = ObjectType;
      _this1367.ObjectPlacement = ObjectPlacement;
      _this1367.Representation = Representation;
      _this1367.Tag = Tag;
      _this1367.PredefinedType = PredefinedType;
      _this1367.type = 3101698114;
      return _this1367;
    }

    return IfcSurfaceFeature;
  }(IfcFeatureElement);

  IFC4_32.IfcSurfaceFeature = IfcSurfaceFeature;

  var IfcSwitchingDeviceType = /*#__PURE__*/function (_IfcFlowControllerTyp10) {
    _inherits(IfcSwitchingDeviceType, _IfcFlowControllerTyp10);

    var _super1376 = _createSuper(IfcSwitchingDeviceType);

    function IfcSwitchingDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1368;

      _classCallCheck2(this, IfcSwitchingDeviceType);

      _this1368 = _super1376.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1368.GlobalId = GlobalId;
      _this1368.OwnerHistory = OwnerHistory;
      _this1368.Name = Name;
      _this1368.Description = Description;
      _this1368.ApplicableOccurrence = ApplicableOccurrence;
      _this1368.HasPropertySets = HasPropertySets;
      _this1368.RepresentationMaps = RepresentationMaps;
      _this1368.Tag = Tag;
      _this1368.ElementType = ElementType;
      _this1368.PredefinedType = PredefinedType;
      _this1368.type = 2315554128;
      return _this1368;
    }

    return IfcSwitchingDeviceType;
  }(IfcFlowControllerType);

  IFC4_32.IfcSwitchingDeviceType = IfcSwitchingDeviceType;

  var IfcSystem = /*#__PURE__*/function (_IfcGroup11) {
    _inherits(IfcSystem, _IfcGroup11);

    var _super1377 = _createSuper(IfcSystem);

    function IfcSystem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this1369;

      _classCallCheck2(this, IfcSystem);

      _this1369 = _super1377.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1369.GlobalId = GlobalId;
      _this1369.OwnerHistory = OwnerHistory;
      _this1369.Name = Name;
      _this1369.Description = Description;
      _this1369.ObjectType = ObjectType;
      _this1369.type = 2254336722;
      return _this1369;
    }

    return IfcSystem;
  }(IfcGroup);

  IFC4_32.IfcSystem = IfcSystem;

  var IfcSystemFurnitureElement = /*#__PURE__*/function (_IfcFurnishingElement6) {
    _inherits(IfcSystemFurnitureElement, _IfcFurnishingElement6);

    var _super1378 = _createSuper(IfcSystemFurnitureElement);

    function IfcSystemFurnitureElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1370;

      _classCallCheck2(this, IfcSystemFurnitureElement);

      _this1370 = _super1378.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1370.GlobalId = GlobalId;
      _this1370.OwnerHistory = OwnerHistory;
      _this1370.Name = Name;
      _this1370.Description = Description;
      _this1370.ObjectType = ObjectType;
      _this1370.ObjectPlacement = ObjectPlacement;
      _this1370.Representation = Representation;
      _this1370.Tag = Tag;
      _this1370.PredefinedType = PredefinedType;
      _this1370.type = 413509423;
      return _this1370;
    }

    return IfcSystemFurnitureElement;
  }(IfcFurnishingElement);

  IFC4_32.IfcSystemFurnitureElement = IfcSystemFurnitureElement;

  var IfcTankType = /*#__PURE__*/function (_IfcFlowStorageDevice3) {
    _inherits(IfcTankType, _IfcFlowStorageDevice3);

    var _super1379 = _createSuper(IfcTankType);

    function IfcTankType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1371;

      _classCallCheck2(this, IfcTankType);

      _this1371 = _super1379.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1371.GlobalId = GlobalId;
      _this1371.OwnerHistory = OwnerHistory;
      _this1371.Name = Name;
      _this1371.Description = Description;
      _this1371.ApplicableOccurrence = ApplicableOccurrence;
      _this1371.HasPropertySets = HasPropertySets;
      _this1371.RepresentationMaps = RepresentationMaps;
      _this1371.Tag = Tag;
      _this1371.ElementType = ElementType;
      _this1371.PredefinedType = PredefinedType;
      _this1371.type = 5716631;
      return _this1371;
    }

    return IfcTankType;
  }(IfcFlowStorageDeviceType);

  IFC4_32.IfcTankType = IfcTankType;

  var IfcTendon = /*#__PURE__*/function (_IfcReinforcingElemen7) {
    _inherits(IfcTendon, _IfcReinforcingElemen7);

    var _super1380 = _createSuper(IfcTendon);

    function IfcTendon(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius) {
      var _this1372;

      _classCallCheck2(this, IfcTendon);

      _this1372 = _super1380.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this1372.GlobalId = GlobalId;
      _this1372.OwnerHistory = OwnerHistory;
      _this1372.Name = Name;
      _this1372.Description = Description;
      _this1372.ObjectType = ObjectType;
      _this1372.ObjectPlacement = ObjectPlacement;
      _this1372.Representation = Representation;
      _this1372.Tag = Tag;
      _this1372.SteelGrade = SteelGrade;
      _this1372.PredefinedType = PredefinedType;
      _this1372.NominalDiameter = NominalDiameter;
      _this1372.CrossSectionArea = CrossSectionArea;
      _this1372.TensionForce = TensionForce;
      _this1372.PreStress = PreStress;
      _this1372.FrictionCoefficient = FrictionCoefficient;
      _this1372.AnchorageSlip = AnchorageSlip;
      _this1372.MinCurvatureRadius = MinCurvatureRadius;
      _this1372.type = 3824725483;
      return _this1372;
    }

    return IfcTendon;
  }(IfcReinforcingElement);

  IFC4_32.IfcTendon = IfcTendon;

  var IfcTendonAnchor = /*#__PURE__*/function (_IfcReinforcingElemen8) {
    _inherits(IfcTendonAnchor, _IfcReinforcingElemen8);

    var _super1381 = _createSuper(IfcTendonAnchor);

    function IfcTendonAnchor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType) {
      var _this1373;

      _classCallCheck2(this, IfcTendonAnchor);

      _this1373 = _super1381.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this1373.GlobalId = GlobalId;
      _this1373.OwnerHistory = OwnerHistory;
      _this1373.Name = Name;
      _this1373.Description = Description;
      _this1373.ObjectType = ObjectType;
      _this1373.ObjectPlacement = ObjectPlacement;
      _this1373.Representation = Representation;
      _this1373.Tag = Tag;
      _this1373.SteelGrade = SteelGrade;
      _this1373.PredefinedType = PredefinedType;
      _this1373.type = 2347447852;
      return _this1373;
    }

    return IfcTendonAnchor;
  }(IfcReinforcingElement);

  IFC4_32.IfcTendonAnchor = IfcTendonAnchor;

  var IfcTendonAnchorType = /*#__PURE__*/function (_IfcReinforcingElemen9) {
    _inherits(IfcTendonAnchorType, _IfcReinforcingElemen9);

    var _super1382 = _createSuper(IfcTendonAnchorType);

    function IfcTendonAnchorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1374;

      _classCallCheck2(this, IfcTendonAnchorType);

      _this1374 = _super1382.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1374.GlobalId = GlobalId;
      _this1374.OwnerHistory = OwnerHistory;
      _this1374.Name = Name;
      _this1374.Description = Description;
      _this1374.ApplicableOccurrence = ApplicableOccurrence;
      _this1374.HasPropertySets = HasPropertySets;
      _this1374.RepresentationMaps = RepresentationMaps;
      _this1374.Tag = Tag;
      _this1374.ElementType = ElementType;
      _this1374.PredefinedType = PredefinedType;
      _this1374.type = 3081323446;
      return _this1374;
    }

    return IfcTendonAnchorType;
  }(IfcReinforcingElementType);

  IFC4_32.IfcTendonAnchorType = IfcTendonAnchorType;

  var IfcTendonConduit = /*#__PURE__*/function (_IfcReinforcingElemen10) {
    _inherits(IfcTendonConduit, _IfcReinforcingElemen10);

    var _super1383 = _createSuper(IfcTendonConduit);

    function IfcTendonConduit(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType) {
      var _this1375;

      _classCallCheck2(this, IfcTendonConduit);

      _this1375 = _super1383.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this1375.GlobalId = GlobalId;
      _this1375.OwnerHistory = OwnerHistory;
      _this1375.Name = Name;
      _this1375.Description = Description;
      _this1375.ObjectType = ObjectType;
      _this1375.ObjectPlacement = ObjectPlacement;
      _this1375.Representation = Representation;
      _this1375.Tag = Tag;
      _this1375.SteelGrade = SteelGrade;
      _this1375.PredefinedType = PredefinedType;
      _this1375.type = 3663046924;
      return _this1375;
    }

    return IfcTendonConduit;
  }(IfcReinforcingElement);

  IFC4_32.IfcTendonConduit = IfcTendonConduit;

  var IfcTendonConduitType = /*#__PURE__*/function (_IfcReinforcingElemen11) {
    _inherits(IfcTendonConduitType, _IfcReinforcingElemen11);

    var _super1384 = _createSuper(IfcTendonConduitType);

    function IfcTendonConduitType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1376;

      _classCallCheck2(this, IfcTendonConduitType);

      _this1376 = _super1384.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1376.GlobalId = GlobalId;
      _this1376.OwnerHistory = OwnerHistory;
      _this1376.Name = Name;
      _this1376.Description = Description;
      _this1376.ApplicableOccurrence = ApplicableOccurrence;
      _this1376.HasPropertySets = HasPropertySets;
      _this1376.RepresentationMaps = RepresentationMaps;
      _this1376.Tag = Tag;
      _this1376.ElementType = ElementType;
      _this1376.PredefinedType = PredefinedType;
      _this1376.type = 2281632017;
      return _this1376;
    }

    return IfcTendonConduitType;
  }(IfcReinforcingElementType);

  IFC4_32.IfcTendonConduitType = IfcTendonConduitType;

  var IfcTendonType = /*#__PURE__*/function (_IfcReinforcingElemen12) {
    _inherits(IfcTendonType, _IfcReinforcingElemen12);

    var _super1385 = _createSuper(IfcTendonType);

    function IfcTendonType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, SheathDiameter) {
      var _this1377;

      _classCallCheck2(this, IfcTendonType);

      _this1377 = _super1385.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1377.GlobalId = GlobalId;
      _this1377.OwnerHistory = OwnerHistory;
      _this1377.Name = Name;
      _this1377.Description = Description;
      _this1377.ApplicableOccurrence = ApplicableOccurrence;
      _this1377.HasPropertySets = HasPropertySets;
      _this1377.RepresentationMaps = RepresentationMaps;
      _this1377.Tag = Tag;
      _this1377.ElementType = ElementType;
      _this1377.PredefinedType = PredefinedType;
      _this1377.NominalDiameter = NominalDiameter;
      _this1377.CrossSectionArea = CrossSectionArea;
      _this1377.SheathDiameter = SheathDiameter;
      _this1377.type = 2415094496;
      return _this1377;
    }

    return IfcTendonType;
  }(IfcReinforcingElementType);

  IFC4_32.IfcTendonType = IfcTendonType;

  var IfcTrackElementType = /*#__PURE__*/function (_IfcBuiltElementType24) {
    _inherits(IfcTrackElementType, _IfcBuiltElementType24);

    var _super1386 = _createSuper(IfcTrackElementType);

    function IfcTrackElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1378;

      _classCallCheck2(this, IfcTrackElementType);

      _this1378 = _super1386.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1378.GlobalId = GlobalId;
      _this1378.OwnerHistory = OwnerHistory;
      _this1378.Name = Name;
      _this1378.Description = Description;
      _this1378.ApplicableOccurrence = ApplicableOccurrence;
      _this1378.HasPropertySets = HasPropertySets;
      _this1378.RepresentationMaps = RepresentationMaps;
      _this1378.Tag = Tag;
      _this1378.ElementType = ElementType;
      _this1378.PredefinedType = PredefinedType;
      _this1378.type = 618700268;
      return _this1378;
    }

    return IfcTrackElementType;
  }(IfcBuiltElementType);

  IFC4_32.IfcTrackElementType = IfcTrackElementType;

  var IfcTransformerType = /*#__PURE__*/function (_IfcEnergyConversionD26) {
    _inherits(IfcTransformerType, _IfcEnergyConversionD26);

    var _super1387 = _createSuper(IfcTransformerType);

    function IfcTransformerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1379;

      _classCallCheck2(this, IfcTransformerType);

      _this1379 = _super1387.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1379.GlobalId = GlobalId;
      _this1379.OwnerHistory = OwnerHistory;
      _this1379.Name = Name;
      _this1379.Description = Description;
      _this1379.ApplicableOccurrence = ApplicableOccurrence;
      _this1379.HasPropertySets = HasPropertySets;
      _this1379.RepresentationMaps = RepresentationMaps;
      _this1379.Tag = Tag;
      _this1379.ElementType = ElementType;
      _this1379.PredefinedType = PredefinedType;
      _this1379.type = 1692211062;
      return _this1379;
    }

    return IfcTransformerType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcTransformerType = IfcTransformerType;

  var IfcTransportElementType = /*#__PURE__*/function (_IfcTransportationDev2) {
    _inherits(IfcTransportElementType, _IfcTransportationDev2);

    var _super1388 = _createSuper(IfcTransportElementType);

    function IfcTransportElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1380;

      _classCallCheck2(this, IfcTransportElementType);

      _this1380 = _super1388.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1380.GlobalId = GlobalId;
      _this1380.OwnerHistory = OwnerHistory;
      _this1380.Name = Name;
      _this1380.Description = Description;
      _this1380.ApplicableOccurrence = ApplicableOccurrence;
      _this1380.HasPropertySets = HasPropertySets;
      _this1380.RepresentationMaps = RepresentationMaps;
      _this1380.Tag = Tag;
      _this1380.ElementType = ElementType;
      _this1380.PredefinedType = PredefinedType;
      _this1380.type = 2097647324;
      return _this1380;
    }

    return IfcTransportElementType;
  }(IfcTransportationDeviceType);

  IFC4_32.IfcTransportElementType = IfcTransportElementType;

  var IfcTransportationDevice = /*#__PURE__*/function (_IfcElement17) {
    _inherits(IfcTransportationDevice, _IfcElement17);

    var _super1389 = _createSuper(IfcTransportationDevice);

    function IfcTransportationDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1381;

      _classCallCheck2(this, IfcTransportationDevice);

      _this1381 = _super1389.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1381.GlobalId = GlobalId;
      _this1381.OwnerHistory = OwnerHistory;
      _this1381.Name = Name;
      _this1381.Description = Description;
      _this1381.ObjectType = ObjectType;
      _this1381.ObjectPlacement = ObjectPlacement;
      _this1381.Representation = Representation;
      _this1381.Tag = Tag;
      _this1381.type = 1953115116;
      return _this1381;
    }

    return IfcTransportationDevice;
  }(IfcElement);

  IFC4_32.IfcTransportationDevice = IfcTransportationDevice;

  var IfcTrimmedCurve = /*#__PURE__*/function (_IfcBoundedCurve8) {
    _inherits(IfcTrimmedCurve, _IfcBoundedCurve8);

    var _super1390 = _createSuper(IfcTrimmedCurve);

    function IfcTrimmedCurve(expressID, BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation) {
      var _this1382;

      _classCallCheck2(this, IfcTrimmedCurve);

      _this1382 = _super1390.call(this, expressID);
      _this1382.BasisCurve = BasisCurve;
      _this1382.Trim1 = Trim1;
      _this1382.Trim2 = Trim2;
      _this1382.SenseAgreement = SenseAgreement;
      _this1382.MasterRepresentation = MasterRepresentation;
      _this1382.type = 3593883385;
      return _this1382;
    }

    return IfcTrimmedCurve;
  }(IfcBoundedCurve);

  IFC4_32.IfcTrimmedCurve = IfcTrimmedCurve;

  var IfcTubeBundleType = /*#__PURE__*/function (_IfcEnergyConversionD27) {
    _inherits(IfcTubeBundleType, _IfcEnergyConversionD27);

    var _super1391 = _createSuper(IfcTubeBundleType);

    function IfcTubeBundleType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1383;

      _classCallCheck2(this, IfcTubeBundleType);

      _this1383 = _super1391.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1383.GlobalId = GlobalId;
      _this1383.OwnerHistory = OwnerHistory;
      _this1383.Name = Name;
      _this1383.Description = Description;
      _this1383.ApplicableOccurrence = ApplicableOccurrence;
      _this1383.HasPropertySets = HasPropertySets;
      _this1383.RepresentationMaps = RepresentationMaps;
      _this1383.Tag = Tag;
      _this1383.ElementType = ElementType;
      _this1383.PredefinedType = PredefinedType;
      _this1383.type = 1600972822;
      return _this1383;
    }

    return IfcTubeBundleType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcTubeBundleType = IfcTubeBundleType;

  var IfcUnitaryEquipmentType = /*#__PURE__*/function (_IfcEnergyConversionD28) {
    _inherits(IfcUnitaryEquipmentType, _IfcEnergyConversionD28);

    var _super1392 = _createSuper(IfcUnitaryEquipmentType);

    function IfcUnitaryEquipmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1384;

      _classCallCheck2(this, IfcUnitaryEquipmentType);

      _this1384 = _super1392.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1384.GlobalId = GlobalId;
      _this1384.OwnerHistory = OwnerHistory;
      _this1384.Name = Name;
      _this1384.Description = Description;
      _this1384.ApplicableOccurrence = ApplicableOccurrence;
      _this1384.HasPropertySets = HasPropertySets;
      _this1384.RepresentationMaps = RepresentationMaps;
      _this1384.Tag = Tag;
      _this1384.ElementType = ElementType;
      _this1384.PredefinedType = PredefinedType;
      _this1384.type = 1911125066;
      return _this1384;
    }

    return IfcUnitaryEquipmentType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;

  var IfcValveType = /*#__PURE__*/function (_IfcFlowControllerTyp11) {
    _inherits(IfcValveType, _IfcFlowControllerTyp11);

    var _super1393 = _createSuper(IfcValveType);

    function IfcValveType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1385;

      _classCallCheck2(this, IfcValveType);

      _this1385 = _super1393.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1385.GlobalId = GlobalId;
      _this1385.OwnerHistory = OwnerHistory;
      _this1385.Name = Name;
      _this1385.Description = Description;
      _this1385.ApplicableOccurrence = ApplicableOccurrence;
      _this1385.HasPropertySets = HasPropertySets;
      _this1385.RepresentationMaps = RepresentationMaps;
      _this1385.Tag = Tag;
      _this1385.ElementType = ElementType;
      _this1385.PredefinedType = PredefinedType;
      _this1385.type = 728799441;
      return _this1385;
    }

    return IfcValveType;
  }(IfcFlowControllerType);

  IFC4_32.IfcValveType = IfcValveType;

  var IfcVehicle = /*#__PURE__*/function (_IfcTransportationDev3) {
    _inherits(IfcVehicle, _IfcTransportationDev3);

    var _super1394 = _createSuper(IfcVehicle);

    function IfcVehicle(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1386;

      _classCallCheck2(this, IfcVehicle);

      _this1386 = _super1394.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1386.GlobalId = GlobalId;
      _this1386.OwnerHistory = OwnerHistory;
      _this1386.Name = Name;
      _this1386.Description = Description;
      _this1386.ObjectType = ObjectType;
      _this1386.ObjectPlacement = ObjectPlacement;
      _this1386.Representation = Representation;
      _this1386.Tag = Tag;
      _this1386.PredefinedType = PredefinedType;
      _this1386.type = 840318589;
      return _this1386;
    }

    return IfcVehicle;
  }(IfcTransportationDevice);

  IFC4_32.IfcVehicle = IfcVehicle;

  var IfcVibrationDamper = /*#__PURE__*/function (_IfcElementComponent8) {
    _inherits(IfcVibrationDamper, _IfcElementComponent8);

    var _super1395 = _createSuper(IfcVibrationDamper);

    function IfcVibrationDamper(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1387;

      _classCallCheck2(this, IfcVibrationDamper);

      _this1387 = _super1395.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1387.GlobalId = GlobalId;
      _this1387.OwnerHistory = OwnerHistory;
      _this1387.Name = Name;
      _this1387.Description = Description;
      _this1387.ObjectType = ObjectType;
      _this1387.ObjectPlacement = ObjectPlacement;
      _this1387.Representation = Representation;
      _this1387.Tag = Tag;
      _this1387.PredefinedType = PredefinedType;
      _this1387.type = 1530820697;
      return _this1387;
    }

    return IfcVibrationDamper;
  }(IfcElementComponent);

  IFC4_32.IfcVibrationDamper = IfcVibrationDamper;

  var IfcVibrationDamperType = /*#__PURE__*/function (_IfcElementComponentT8) {
    _inherits(IfcVibrationDamperType, _IfcElementComponentT8);

    var _super1396 = _createSuper(IfcVibrationDamperType);

    function IfcVibrationDamperType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1388;

      _classCallCheck2(this, IfcVibrationDamperType);

      _this1388 = _super1396.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1388.GlobalId = GlobalId;
      _this1388.OwnerHistory = OwnerHistory;
      _this1388.Name = Name;
      _this1388.Description = Description;
      _this1388.ApplicableOccurrence = ApplicableOccurrence;
      _this1388.HasPropertySets = HasPropertySets;
      _this1388.RepresentationMaps = RepresentationMaps;
      _this1388.Tag = Tag;
      _this1388.ElementType = ElementType;
      _this1388.PredefinedType = PredefinedType;
      _this1388.type = 3956297820;
      return _this1388;
    }

    return IfcVibrationDamperType;
  }(IfcElementComponentType);

  IFC4_32.IfcVibrationDamperType = IfcVibrationDamperType;

  var IfcVibrationIsolator = /*#__PURE__*/function (_IfcElementComponent9) {
    _inherits(IfcVibrationIsolator, _IfcElementComponent9);

    var _super1397 = _createSuper(IfcVibrationIsolator);

    function IfcVibrationIsolator(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1389;

      _classCallCheck2(this, IfcVibrationIsolator);

      _this1389 = _super1397.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1389.GlobalId = GlobalId;
      _this1389.OwnerHistory = OwnerHistory;
      _this1389.Name = Name;
      _this1389.Description = Description;
      _this1389.ObjectType = ObjectType;
      _this1389.ObjectPlacement = ObjectPlacement;
      _this1389.Representation = Representation;
      _this1389.Tag = Tag;
      _this1389.PredefinedType = PredefinedType;
      _this1389.type = 2391383451;
      return _this1389;
    }

    return IfcVibrationIsolator;
  }(IfcElementComponent);

  IFC4_32.IfcVibrationIsolator = IfcVibrationIsolator;

  var IfcVibrationIsolatorType = /*#__PURE__*/function (_IfcElementComponentT9) {
    _inherits(IfcVibrationIsolatorType, _IfcElementComponentT9);

    var _super1398 = _createSuper(IfcVibrationIsolatorType);

    function IfcVibrationIsolatorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1390;

      _classCallCheck2(this, IfcVibrationIsolatorType);

      _this1390 = _super1398.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1390.GlobalId = GlobalId;
      _this1390.OwnerHistory = OwnerHistory;
      _this1390.Name = Name;
      _this1390.Description = Description;
      _this1390.ApplicableOccurrence = ApplicableOccurrence;
      _this1390.HasPropertySets = HasPropertySets;
      _this1390.RepresentationMaps = RepresentationMaps;
      _this1390.Tag = Tag;
      _this1390.ElementType = ElementType;
      _this1390.PredefinedType = PredefinedType;
      _this1390.type = 3313531582;
      return _this1390;
    }

    return IfcVibrationIsolatorType;
  }(IfcElementComponentType);

  IFC4_32.IfcVibrationIsolatorType = IfcVibrationIsolatorType;

  var IfcVirtualElement = /*#__PURE__*/function (_IfcElement18) {
    _inherits(IfcVirtualElement, _IfcElement18);

    var _super1399 = _createSuper(IfcVirtualElement);

    function IfcVirtualElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1391;

      _classCallCheck2(this, IfcVirtualElement);

      _this1391 = _super1399.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1391.GlobalId = GlobalId;
      _this1391.OwnerHistory = OwnerHistory;
      _this1391.Name = Name;
      _this1391.Description = Description;
      _this1391.ObjectType = ObjectType;
      _this1391.ObjectPlacement = ObjectPlacement;
      _this1391.Representation = Representation;
      _this1391.Tag = Tag;
      _this1391.PredefinedType = PredefinedType;
      _this1391.type = 2769231204;
      return _this1391;
    }

    return IfcVirtualElement;
  }(IfcElement);

  IFC4_32.IfcVirtualElement = IfcVirtualElement;

  var IfcVoidingFeature = /*#__PURE__*/function (_IfcFeatureElementSub4) {
    _inherits(IfcVoidingFeature, _IfcFeatureElementSub4);

    var _super1400 = _createSuper(IfcVoidingFeature);

    function IfcVoidingFeature(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1392;

      _classCallCheck2(this, IfcVoidingFeature);

      _this1392 = _super1400.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1392.GlobalId = GlobalId;
      _this1392.OwnerHistory = OwnerHistory;
      _this1392.Name = Name;
      _this1392.Description = Description;
      _this1392.ObjectType = ObjectType;
      _this1392.ObjectPlacement = ObjectPlacement;
      _this1392.Representation = Representation;
      _this1392.Tag = Tag;
      _this1392.PredefinedType = PredefinedType;
      _this1392.type = 926996030;
      return _this1392;
    }

    return IfcVoidingFeature;
  }(IfcFeatureElementSubtraction);

  IFC4_32.IfcVoidingFeature = IfcVoidingFeature;

  var IfcWallType = /*#__PURE__*/function (_IfcBuiltElementType25) {
    _inherits(IfcWallType, _IfcBuiltElementType25);

    var _super1401 = _createSuper(IfcWallType);

    function IfcWallType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1393;

      _classCallCheck2(this, IfcWallType);

      _this1393 = _super1401.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1393.GlobalId = GlobalId;
      _this1393.OwnerHistory = OwnerHistory;
      _this1393.Name = Name;
      _this1393.Description = Description;
      _this1393.ApplicableOccurrence = ApplicableOccurrence;
      _this1393.HasPropertySets = HasPropertySets;
      _this1393.RepresentationMaps = RepresentationMaps;
      _this1393.Tag = Tag;
      _this1393.ElementType = ElementType;
      _this1393.PredefinedType = PredefinedType;
      _this1393.type = 1898987631;
      return _this1393;
    }

    return IfcWallType;
  }(IfcBuiltElementType);

  IFC4_32.IfcWallType = IfcWallType;

  var IfcWasteTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType22) {
    _inherits(IfcWasteTerminalType, _IfcFlowTerminalType22);

    var _super1402 = _createSuper(IfcWasteTerminalType);

    function IfcWasteTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1394;

      _classCallCheck2(this, IfcWasteTerminalType);

      _this1394 = _super1402.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1394.GlobalId = GlobalId;
      _this1394.OwnerHistory = OwnerHistory;
      _this1394.Name = Name;
      _this1394.Description = Description;
      _this1394.ApplicableOccurrence = ApplicableOccurrence;
      _this1394.HasPropertySets = HasPropertySets;
      _this1394.RepresentationMaps = RepresentationMaps;
      _this1394.Tag = Tag;
      _this1394.ElementType = ElementType;
      _this1394.PredefinedType = PredefinedType;
      _this1394.type = 1133259667;
      return _this1394;
    }

    return IfcWasteTerminalType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcWasteTerminalType = IfcWasteTerminalType;

  var IfcWindowType = /*#__PURE__*/function (_IfcBuiltElementType26) {
    _inherits(IfcWindowType, _IfcBuiltElementType26);

    var _super1403 = _createSuper(IfcWindowType);

    function IfcWindowType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, PartitioningType, ParameterTakesPrecedence, UserDefinedPartitioningType) {
      var _this1395;

      _classCallCheck2(this, IfcWindowType);

      _this1395 = _super1403.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1395.GlobalId = GlobalId;
      _this1395.OwnerHistory = OwnerHistory;
      _this1395.Name = Name;
      _this1395.Description = Description;
      _this1395.ApplicableOccurrence = ApplicableOccurrence;
      _this1395.HasPropertySets = HasPropertySets;
      _this1395.RepresentationMaps = RepresentationMaps;
      _this1395.Tag = Tag;
      _this1395.ElementType = ElementType;
      _this1395.PredefinedType = PredefinedType;
      _this1395.PartitioningType = PartitioningType;
      _this1395.ParameterTakesPrecedence = ParameterTakesPrecedence;
      _this1395.UserDefinedPartitioningType = UserDefinedPartitioningType;
      _this1395.type = 4009809668;
      return _this1395;
    }

    return IfcWindowType;
  }(IfcBuiltElementType);

  IFC4_32.IfcWindowType = IfcWindowType;

  var IfcWorkCalendar = /*#__PURE__*/function (_IfcControl21) {
    _inherits(IfcWorkCalendar, _IfcControl21);

    var _super1404 = _createSuper(IfcWorkCalendar);

    function IfcWorkCalendar(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, WorkingTimes, ExceptionTimes, PredefinedType) {
      var _this1396;

      _classCallCheck2(this, IfcWorkCalendar);

      _this1396 = _super1404.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this1396.GlobalId = GlobalId;
      _this1396.OwnerHistory = OwnerHistory;
      _this1396.Name = Name;
      _this1396.Description = Description;
      _this1396.ObjectType = ObjectType;
      _this1396.Identification = Identification;
      _this1396.WorkingTimes = WorkingTimes;
      _this1396.ExceptionTimes = ExceptionTimes;
      _this1396.PredefinedType = PredefinedType;
      _this1396.type = 4088093105;
      return _this1396;
    }

    return IfcWorkCalendar;
  }(IfcControl);

  IFC4_32.IfcWorkCalendar = IfcWorkCalendar;

  var IfcWorkControl = /*#__PURE__*/function (_IfcControl22) {
    _inherits(IfcWorkControl, _IfcControl22);

    var _super1405 = _createSuper(IfcWorkControl);

    function IfcWorkControl(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime) {
      var _this1397;

      _classCallCheck2(this, IfcWorkControl);

      _this1397 = _super1405.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this1397.GlobalId = GlobalId;
      _this1397.OwnerHistory = OwnerHistory;
      _this1397.Name = Name;
      _this1397.Description = Description;
      _this1397.ObjectType = ObjectType;
      _this1397.Identification = Identification;
      _this1397.CreationDate = CreationDate;
      _this1397.Creators = Creators;
      _this1397.Purpose = Purpose;
      _this1397.Duration = Duration;
      _this1397.TotalFloat = TotalFloat;
      _this1397.StartTime = StartTime;
      _this1397.FinishTime = FinishTime;
      _this1397.type = 1028945134;
      return _this1397;
    }

    return IfcWorkControl;
  }(IfcControl);

  IFC4_32.IfcWorkControl = IfcWorkControl;

  var IfcWorkPlan = /*#__PURE__*/function (_IfcWorkControl3) {
    _inherits(IfcWorkPlan, _IfcWorkControl3);

    var _super1406 = _createSuper(IfcWorkPlan);

    function IfcWorkPlan(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      var _this1398;

      _classCallCheck2(this, IfcWorkPlan);

      _this1398 = _super1406.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      _this1398.GlobalId = GlobalId;
      _this1398.OwnerHistory = OwnerHistory;
      _this1398.Name = Name;
      _this1398.Description = Description;
      _this1398.ObjectType = ObjectType;
      _this1398.Identification = Identification;
      _this1398.CreationDate = CreationDate;
      _this1398.Creators = Creators;
      _this1398.Purpose = Purpose;
      _this1398.Duration = Duration;
      _this1398.TotalFloat = TotalFloat;
      _this1398.StartTime = StartTime;
      _this1398.FinishTime = FinishTime;
      _this1398.PredefinedType = PredefinedType;
      _this1398.type = 4218914973;
      return _this1398;
    }

    return IfcWorkPlan;
  }(IfcWorkControl);

  IFC4_32.IfcWorkPlan = IfcWorkPlan;

  var IfcWorkSchedule = /*#__PURE__*/function (_IfcWorkControl4) {
    _inherits(IfcWorkSchedule, _IfcWorkControl4);

    var _super1407 = _createSuper(IfcWorkSchedule);

    function IfcWorkSchedule(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      var _this1399;

      _classCallCheck2(this, IfcWorkSchedule);

      _this1399 = _super1407.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      _this1399.GlobalId = GlobalId;
      _this1399.OwnerHistory = OwnerHistory;
      _this1399.Name = Name;
      _this1399.Description = Description;
      _this1399.ObjectType = ObjectType;
      _this1399.Identification = Identification;
      _this1399.CreationDate = CreationDate;
      _this1399.Creators = Creators;
      _this1399.Purpose = Purpose;
      _this1399.Duration = Duration;
      _this1399.TotalFloat = TotalFloat;
      _this1399.StartTime = StartTime;
      _this1399.FinishTime = FinishTime;
      _this1399.PredefinedType = PredefinedType;
      _this1399.type = 3342526732;
      return _this1399;
    }

    return IfcWorkSchedule;
  }(IfcWorkControl);

  IFC4_32.IfcWorkSchedule = IfcWorkSchedule;

  var IfcZone = /*#__PURE__*/function (_IfcSystem3) {
    _inherits(IfcZone, _IfcSystem3);

    var _super1408 = _createSuper(IfcZone);

    function IfcZone(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName) {
      var _this1400;

      _classCallCheck2(this, IfcZone);

      _this1400 = _super1408.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1400.GlobalId = GlobalId;
      _this1400.OwnerHistory = OwnerHistory;
      _this1400.Name = Name;
      _this1400.Description = Description;
      _this1400.ObjectType = ObjectType;
      _this1400.LongName = LongName;
      _this1400.type = 1033361043;
      return _this1400;
    }

    return IfcZone;
  }(IfcSystem);

  IFC4_32.IfcZone = IfcZone;

  var IfcActionRequest = /*#__PURE__*/function (_IfcControl23) {
    _inherits(IfcActionRequest, _IfcControl23);

    var _super1409 = _createSuper(IfcActionRequest);

    function IfcActionRequest(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      var _this1401;

      _classCallCheck2(this, IfcActionRequest);

      _this1401 = _super1409.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this1401.GlobalId = GlobalId;
      _this1401.OwnerHistory = OwnerHistory;
      _this1401.Name = Name;
      _this1401.Description = Description;
      _this1401.ObjectType = ObjectType;
      _this1401.Identification = Identification;
      _this1401.PredefinedType = PredefinedType;
      _this1401.Status = Status;
      _this1401.LongDescription = LongDescription;
      _this1401.type = 3821786052;
      return _this1401;
    }

    return IfcActionRequest;
  }(IfcControl);

  IFC4_32.IfcActionRequest = IfcActionRequest;

  var IfcAirTerminalBoxType = /*#__PURE__*/function (_IfcFlowControllerTyp12) {
    _inherits(IfcAirTerminalBoxType, _IfcFlowControllerTyp12);

    var _super1410 = _createSuper(IfcAirTerminalBoxType);

    function IfcAirTerminalBoxType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1402;

      _classCallCheck2(this, IfcAirTerminalBoxType);

      _this1402 = _super1410.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1402.GlobalId = GlobalId;
      _this1402.OwnerHistory = OwnerHistory;
      _this1402.Name = Name;
      _this1402.Description = Description;
      _this1402.ApplicableOccurrence = ApplicableOccurrence;
      _this1402.HasPropertySets = HasPropertySets;
      _this1402.RepresentationMaps = RepresentationMaps;
      _this1402.Tag = Tag;
      _this1402.ElementType = ElementType;
      _this1402.PredefinedType = PredefinedType;
      _this1402.type = 1411407467;
      return _this1402;
    }

    return IfcAirTerminalBoxType;
  }(IfcFlowControllerType);

  IFC4_32.IfcAirTerminalBoxType = IfcAirTerminalBoxType;

  var IfcAirTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType23) {
    _inherits(IfcAirTerminalType, _IfcFlowTerminalType23);

    var _super1411 = _createSuper(IfcAirTerminalType);

    function IfcAirTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1403;

      _classCallCheck2(this, IfcAirTerminalType);

      _this1403 = _super1411.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1403.GlobalId = GlobalId;
      _this1403.OwnerHistory = OwnerHistory;
      _this1403.Name = Name;
      _this1403.Description = Description;
      _this1403.ApplicableOccurrence = ApplicableOccurrence;
      _this1403.HasPropertySets = HasPropertySets;
      _this1403.RepresentationMaps = RepresentationMaps;
      _this1403.Tag = Tag;
      _this1403.ElementType = ElementType;
      _this1403.PredefinedType = PredefinedType;
      _this1403.type = 3352864051;
      return _this1403;
    }

    return IfcAirTerminalType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcAirTerminalType = IfcAirTerminalType;

  var IfcAirToAirHeatRecoveryType = /*#__PURE__*/function (_IfcEnergyConversionD29) {
    _inherits(IfcAirToAirHeatRecoveryType, _IfcEnergyConversionD29);

    var _super1412 = _createSuper(IfcAirToAirHeatRecoveryType);

    function IfcAirToAirHeatRecoveryType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1404;

      _classCallCheck2(this, IfcAirToAirHeatRecoveryType);

      _this1404 = _super1412.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1404.GlobalId = GlobalId;
      _this1404.OwnerHistory = OwnerHistory;
      _this1404.Name = Name;
      _this1404.Description = Description;
      _this1404.ApplicableOccurrence = ApplicableOccurrence;
      _this1404.HasPropertySets = HasPropertySets;
      _this1404.RepresentationMaps = RepresentationMaps;
      _this1404.Tag = Tag;
      _this1404.ElementType = ElementType;
      _this1404.PredefinedType = PredefinedType;
      _this1404.type = 1871374353;
      return _this1404;
    }

    return IfcAirToAirHeatRecoveryType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;

  var IfcAlignmentCant = /*#__PURE__*/function (_IfcLinearElement) {
    _inherits(IfcAlignmentCant, _IfcLinearElement);

    var _super1413 = _createSuper(IfcAlignmentCant);

    function IfcAlignmentCant(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, RailHeadDistance) {
      var _this1405;

      _classCallCheck2(this, IfcAlignmentCant);

      _this1405 = _super1413.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1405.GlobalId = GlobalId;
      _this1405.OwnerHistory = OwnerHistory;
      _this1405.Name = Name;
      _this1405.Description = Description;
      _this1405.ObjectType = ObjectType;
      _this1405.ObjectPlacement = ObjectPlacement;
      _this1405.Representation = Representation;
      _this1405.RailHeadDistance = RailHeadDistance;
      _this1405.type = 4266260250;
      return _this1405;
    }

    return IfcAlignmentCant;
  }(IfcLinearElement);

  IFC4_32.IfcAlignmentCant = IfcAlignmentCant;

  var IfcAlignmentHorizontal = /*#__PURE__*/function (_IfcLinearElement2) {
    _inherits(IfcAlignmentHorizontal, _IfcLinearElement2);

    var _super1414 = _createSuper(IfcAlignmentHorizontal);

    function IfcAlignmentHorizontal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this1406;

      _classCallCheck2(this, IfcAlignmentHorizontal);

      _this1406 = _super1414.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1406.GlobalId = GlobalId;
      _this1406.OwnerHistory = OwnerHistory;
      _this1406.Name = Name;
      _this1406.Description = Description;
      _this1406.ObjectType = ObjectType;
      _this1406.ObjectPlacement = ObjectPlacement;
      _this1406.Representation = Representation;
      _this1406.type = 1545765605;
      return _this1406;
    }

    return IfcAlignmentHorizontal;
  }(IfcLinearElement);

  IFC4_32.IfcAlignmentHorizontal = IfcAlignmentHorizontal;

  var IfcAlignmentSegment = /*#__PURE__*/function (_IfcLinearElement3) {
    _inherits(IfcAlignmentSegment, _IfcLinearElement3);

    var _super1415 = _createSuper(IfcAlignmentSegment);

    function IfcAlignmentSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, DesignParameters) {
      var _this1407;

      _classCallCheck2(this, IfcAlignmentSegment);

      _this1407 = _super1415.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1407.GlobalId = GlobalId;
      _this1407.OwnerHistory = OwnerHistory;
      _this1407.Name = Name;
      _this1407.Description = Description;
      _this1407.ObjectType = ObjectType;
      _this1407.ObjectPlacement = ObjectPlacement;
      _this1407.Representation = Representation;
      _this1407.DesignParameters = DesignParameters;
      _this1407.type = 317615605;
      return _this1407;
    }

    return IfcAlignmentSegment;
  }(IfcLinearElement);

  IFC4_32.IfcAlignmentSegment = IfcAlignmentSegment;

  var IfcAlignmentVertical = /*#__PURE__*/function (_IfcLinearElement4) {
    _inherits(IfcAlignmentVertical, _IfcLinearElement4);

    var _super1416 = _createSuper(IfcAlignmentVertical);

    function IfcAlignmentVertical(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this1408;

      _classCallCheck2(this, IfcAlignmentVertical);

      _this1408 = _super1416.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1408.GlobalId = GlobalId;
      _this1408.OwnerHistory = OwnerHistory;
      _this1408.Name = Name;
      _this1408.Description = Description;
      _this1408.ObjectType = ObjectType;
      _this1408.ObjectPlacement = ObjectPlacement;
      _this1408.Representation = Representation;
      _this1408.type = 1662888072;
      return _this1408;
    }

    return IfcAlignmentVertical;
  }(IfcLinearElement);

  IFC4_32.IfcAlignmentVertical = IfcAlignmentVertical;

  var IfcAsset = /*#__PURE__*/function (_IfcGroup12) {
    _inherits(IfcAsset, _IfcGroup12);

    var _super1417 = _createSuper(IfcAsset);

    function IfcAsset(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue) {
      var _this1409;

      _classCallCheck2(this, IfcAsset);

      _this1409 = _super1417.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1409.GlobalId = GlobalId;
      _this1409.OwnerHistory = OwnerHistory;
      _this1409.Name = Name;
      _this1409.Description = Description;
      _this1409.ObjectType = ObjectType;
      _this1409.Identification = Identification;
      _this1409.OriginalValue = OriginalValue;
      _this1409.CurrentValue = CurrentValue;
      _this1409.TotalReplacementCost = TotalReplacementCost;
      _this1409.Owner = Owner;
      _this1409.User = User;
      _this1409.ResponsiblePerson = ResponsiblePerson;
      _this1409.IncorporationDate = IncorporationDate;
      _this1409.DepreciatedValue = DepreciatedValue;
      _this1409.type = 3460190687;
      return _this1409;
    }

    return IfcAsset;
  }(IfcGroup);

  IFC4_32.IfcAsset = IfcAsset;

  var IfcAudioVisualApplianceType = /*#__PURE__*/function (_IfcFlowTerminalType24) {
    _inherits(IfcAudioVisualApplianceType, _IfcFlowTerminalType24);

    var _super1418 = _createSuper(IfcAudioVisualApplianceType);

    function IfcAudioVisualApplianceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1410;

      _classCallCheck2(this, IfcAudioVisualApplianceType);

      _this1410 = _super1418.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1410.GlobalId = GlobalId;
      _this1410.OwnerHistory = OwnerHistory;
      _this1410.Name = Name;
      _this1410.Description = Description;
      _this1410.ApplicableOccurrence = ApplicableOccurrence;
      _this1410.HasPropertySets = HasPropertySets;
      _this1410.RepresentationMaps = RepresentationMaps;
      _this1410.Tag = Tag;
      _this1410.ElementType = ElementType;
      _this1410.PredefinedType = PredefinedType;
      _this1410.type = 1532957894;
      return _this1410;
    }

    return IfcAudioVisualApplianceType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcAudioVisualApplianceType = IfcAudioVisualApplianceType;

  var IfcBSplineCurve = /*#__PURE__*/function (_IfcBoundedCurve9) {
    _inherits(IfcBSplineCurve, _IfcBoundedCurve9);

    var _super1419 = _createSuper(IfcBSplineCurve);

    function IfcBSplineCurve(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      var _this1411;

      _classCallCheck2(this, IfcBSplineCurve);

      _this1411 = _super1419.call(this, expressID);
      _this1411.Degree = Degree;
      _this1411.ControlPointsList = ControlPointsList;
      _this1411.CurveForm = CurveForm;
      _this1411.ClosedCurve = ClosedCurve;
      _this1411.SelfIntersect = SelfIntersect;
      _this1411.type = 1967976161;
      return _this1411;
    }

    return IfcBSplineCurve;
  }(IfcBoundedCurve);

  IFC4_32.IfcBSplineCurve = IfcBSplineCurve;

  var IfcBSplineCurveWithKnots = /*#__PURE__*/function (_IfcBSplineCurve2) {
    _inherits(IfcBSplineCurveWithKnots, _IfcBSplineCurve2);

    var _super1420 = _createSuper(IfcBSplineCurveWithKnots);

    function IfcBSplineCurveWithKnots(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec) {
      var _this1412;

      _classCallCheck2(this, IfcBSplineCurveWithKnots);

      _this1412 = _super1420.call(this, expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      _this1412.Degree = Degree;
      _this1412.ControlPointsList = ControlPointsList;
      _this1412.CurveForm = CurveForm;
      _this1412.ClosedCurve = ClosedCurve;
      _this1412.SelfIntersect = SelfIntersect;
      _this1412.KnotMultiplicities = KnotMultiplicities;
      _this1412.Knots = Knots;
      _this1412.KnotSpec = KnotSpec;
      _this1412.type = 2461110595;
      return _this1412;
    }

    return IfcBSplineCurveWithKnots;
  }(IfcBSplineCurve);

  IFC4_32.IfcBSplineCurveWithKnots = IfcBSplineCurveWithKnots;

  var IfcBeamType = /*#__PURE__*/function (_IfcBuiltElementType27) {
    _inherits(IfcBeamType, _IfcBuiltElementType27);

    var _super1421 = _createSuper(IfcBeamType);

    function IfcBeamType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1413;

      _classCallCheck2(this, IfcBeamType);

      _this1413 = _super1421.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1413.GlobalId = GlobalId;
      _this1413.OwnerHistory = OwnerHistory;
      _this1413.Name = Name;
      _this1413.Description = Description;
      _this1413.ApplicableOccurrence = ApplicableOccurrence;
      _this1413.HasPropertySets = HasPropertySets;
      _this1413.RepresentationMaps = RepresentationMaps;
      _this1413.Tag = Tag;
      _this1413.ElementType = ElementType;
      _this1413.PredefinedType = PredefinedType;
      _this1413.type = 819618141;
      return _this1413;
    }

    return IfcBeamType;
  }(IfcBuiltElementType);

  IFC4_32.IfcBeamType = IfcBeamType;

  var IfcBearingType = /*#__PURE__*/function (_IfcBuiltElementType28) {
    _inherits(IfcBearingType, _IfcBuiltElementType28);

    var _super1422 = _createSuper(IfcBearingType);

    function IfcBearingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1414;

      _classCallCheck2(this, IfcBearingType);

      _this1414 = _super1422.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1414.GlobalId = GlobalId;
      _this1414.OwnerHistory = OwnerHistory;
      _this1414.Name = Name;
      _this1414.Description = Description;
      _this1414.ApplicableOccurrence = ApplicableOccurrence;
      _this1414.HasPropertySets = HasPropertySets;
      _this1414.RepresentationMaps = RepresentationMaps;
      _this1414.Tag = Tag;
      _this1414.ElementType = ElementType;
      _this1414.PredefinedType = PredefinedType;
      _this1414.type = 3649138523;
      return _this1414;
    }

    return IfcBearingType;
  }(IfcBuiltElementType);

  IFC4_32.IfcBearingType = IfcBearingType;

  var IfcBoilerType = /*#__PURE__*/function (_IfcEnergyConversionD30) {
    _inherits(IfcBoilerType, _IfcEnergyConversionD30);

    var _super1423 = _createSuper(IfcBoilerType);

    function IfcBoilerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1415;

      _classCallCheck2(this, IfcBoilerType);

      _this1415 = _super1423.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1415.GlobalId = GlobalId;
      _this1415.OwnerHistory = OwnerHistory;
      _this1415.Name = Name;
      _this1415.Description = Description;
      _this1415.ApplicableOccurrence = ApplicableOccurrence;
      _this1415.HasPropertySets = HasPropertySets;
      _this1415.RepresentationMaps = RepresentationMaps;
      _this1415.Tag = Tag;
      _this1415.ElementType = ElementType;
      _this1415.PredefinedType = PredefinedType;
      _this1415.type = 231477066;
      return _this1415;
    }

    return IfcBoilerType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcBoilerType = IfcBoilerType;

  var IfcBoundaryCurve = /*#__PURE__*/function (_IfcCompositeCurveOnS) {
    _inherits(IfcBoundaryCurve, _IfcCompositeCurveOnS);

    var _super1424 = _createSuper(IfcBoundaryCurve);

    function IfcBoundaryCurve(expressID, Segments, SelfIntersect) {
      var _this1416;

      _classCallCheck2(this, IfcBoundaryCurve);

      _this1416 = _super1424.call(this, expressID, Segments, SelfIntersect);
      _this1416.Segments = Segments;
      _this1416.SelfIntersect = SelfIntersect;
      _this1416.type = 1136057603;
      return _this1416;
    }

    return IfcBoundaryCurve;
  }(IfcCompositeCurveOnSurface);

  IFC4_32.IfcBoundaryCurve = IfcBoundaryCurve;

  var IfcBridge = /*#__PURE__*/function (_IfcFacility4) {
    _inherits(IfcBridge, _IfcFacility4);

    var _super1425 = _createSuper(IfcBridge);

    function IfcBridge(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType) {
      var _this1417;

      _classCallCheck2(this, IfcBridge);

      _this1417 = _super1425.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this1417.GlobalId = GlobalId;
      _this1417.OwnerHistory = OwnerHistory;
      _this1417.Name = Name;
      _this1417.Description = Description;
      _this1417.ObjectType = ObjectType;
      _this1417.ObjectPlacement = ObjectPlacement;
      _this1417.Representation = Representation;
      _this1417.LongName = LongName;
      _this1417.CompositionType = CompositionType;
      _this1417.PredefinedType = PredefinedType;
      _this1417.type = 644574406;
      return _this1417;
    }

    return IfcBridge;
  }(IfcFacility);

  IFC4_32.IfcBridge = IfcBridge;

  var IfcBridgePart = /*#__PURE__*/function (_IfcFacilityPart5) {
    _inherits(IfcBridgePart, _IfcFacilityPart5);

    var _super1426 = _createSuper(IfcBridgePart);

    function IfcBridgePart(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType, PredefinedType) {
      var _this1418;

      _classCallCheck2(this, IfcBridgePart);

      _this1418 = _super1426.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, UsageType);
      _this1418.GlobalId = GlobalId;
      _this1418.OwnerHistory = OwnerHistory;
      _this1418.Name = Name;
      _this1418.Description = Description;
      _this1418.ObjectType = ObjectType;
      _this1418.ObjectPlacement = ObjectPlacement;
      _this1418.Representation = Representation;
      _this1418.LongName = LongName;
      _this1418.CompositionType = CompositionType;
      _this1418.UsageType = UsageType;
      _this1418.PredefinedType = PredefinedType;
      _this1418.type = 963979645;
      return _this1418;
    }

    return IfcBridgePart;
  }(IfcFacilityPart);

  IFC4_32.IfcBridgePart = IfcBridgePart;

  var IfcBuilding = /*#__PURE__*/function (_IfcFacility5) {
    _inherits(IfcBuilding, _IfcFacility5);

    var _super1427 = _createSuper(IfcBuilding);

    function IfcBuilding(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress) {
      var _this1419;

      _classCallCheck2(this, IfcBuilding);

      _this1419 = _super1427.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this1419.GlobalId = GlobalId;
      _this1419.OwnerHistory = OwnerHistory;
      _this1419.Name = Name;
      _this1419.Description = Description;
      _this1419.ObjectType = ObjectType;
      _this1419.ObjectPlacement = ObjectPlacement;
      _this1419.Representation = Representation;
      _this1419.LongName = LongName;
      _this1419.CompositionType = CompositionType;
      _this1419.ElevationOfRefHeight = ElevationOfRefHeight;
      _this1419.ElevationOfTerrain = ElevationOfTerrain;
      _this1419.BuildingAddress = BuildingAddress;
      _this1419.type = 4031249490;
      return _this1419;
    }

    return IfcBuilding;
  }(IfcFacility);

  IFC4_32.IfcBuilding = IfcBuilding;

  var IfcBuildingElementPart = /*#__PURE__*/function (_IfcElementComponent10) {
    _inherits(IfcBuildingElementPart, _IfcElementComponent10);

    var _super1428 = _createSuper(IfcBuildingElementPart);

    function IfcBuildingElementPart(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1420;

      _classCallCheck2(this, IfcBuildingElementPart);

      _this1420 = _super1428.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1420.GlobalId = GlobalId;
      _this1420.OwnerHistory = OwnerHistory;
      _this1420.Name = Name;
      _this1420.Description = Description;
      _this1420.ObjectType = ObjectType;
      _this1420.ObjectPlacement = ObjectPlacement;
      _this1420.Representation = Representation;
      _this1420.Tag = Tag;
      _this1420.PredefinedType = PredefinedType;
      _this1420.type = 2979338954;
      return _this1420;
    }

    return IfcBuildingElementPart;
  }(IfcElementComponent);

  IFC4_32.IfcBuildingElementPart = IfcBuildingElementPart;

  var IfcBuildingElementPartType = /*#__PURE__*/function (_IfcElementComponentT10) {
    _inherits(IfcBuildingElementPartType, _IfcElementComponentT10);

    var _super1429 = _createSuper(IfcBuildingElementPartType);

    function IfcBuildingElementPartType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1421;

      _classCallCheck2(this, IfcBuildingElementPartType);

      _this1421 = _super1429.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1421.GlobalId = GlobalId;
      _this1421.OwnerHistory = OwnerHistory;
      _this1421.Name = Name;
      _this1421.Description = Description;
      _this1421.ApplicableOccurrence = ApplicableOccurrence;
      _this1421.HasPropertySets = HasPropertySets;
      _this1421.RepresentationMaps = RepresentationMaps;
      _this1421.Tag = Tag;
      _this1421.ElementType = ElementType;
      _this1421.PredefinedType = PredefinedType;
      _this1421.type = 39481116;
      return _this1421;
    }

    return IfcBuildingElementPartType;
  }(IfcElementComponentType);

  IFC4_32.IfcBuildingElementPartType = IfcBuildingElementPartType;

  var IfcBuildingElementProxyType = /*#__PURE__*/function (_IfcBuiltElementType29) {
    _inherits(IfcBuildingElementProxyType, _IfcBuiltElementType29);

    var _super1430 = _createSuper(IfcBuildingElementProxyType);

    function IfcBuildingElementProxyType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1422;

      _classCallCheck2(this, IfcBuildingElementProxyType);

      _this1422 = _super1430.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1422.GlobalId = GlobalId;
      _this1422.OwnerHistory = OwnerHistory;
      _this1422.Name = Name;
      _this1422.Description = Description;
      _this1422.ApplicableOccurrence = ApplicableOccurrence;
      _this1422.HasPropertySets = HasPropertySets;
      _this1422.RepresentationMaps = RepresentationMaps;
      _this1422.Tag = Tag;
      _this1422.ElementType = ElementType;
      _this1422.PredefinedType = PredefinedType;
      _this1422.type = 1909888760;
      return _this1422;
    }

    return IfcBuildingElementProxyType;
  }(IfcBuiltElementType);

  IFC4_32.IfcBuildingElementProxyType = IfcBuildingElementProxyType;

  var IfcBuildingSystem = /*#__PURE__*/function (_IfcSystem4) {
    _inherits(IfcBuildingSystem, _IfcSystem4);

    var _super1431 = _createSuper(IfcBuildingSystem);

    function IfcBuildingSystem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName) {
      var _this1423;

      _classCallCheck2(this, IfcBuildingSystem);

      _this1423 = _super1431.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1423.GlobalId = GlobalId;
      _this1423.OwnerHistory = OwnerHistory;
      _this1423.Name = Name;
      _this1423.Description = Description;
      _this1423.ObjectType = ObjectType;
      _this1423.PredefinedType = PredefinedType;
      _this1423.LongName = LongName;
      _this1423.type = 1177604601;
      return _this1423;
    }

    return IfcBuildingSystem;
  }(IfcSystem);

  IFC4_32.IfcBuildingSystem = IfcBuildingSystem;

  var IfcBuiltElement = /*#__PURE__*/function (_IfcElement19) {
    _inherits(IfcBuiltElement, _IfcElement19);

    var _super1432 = _createSuper(IfcBuiltElement);

    function IfcBuiltElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1424;

      _classCallCheck2(this, IfcBuiltElement);

      _this1424 = _super1432.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1424.GlobalId = GlobalId;
      _this1424.OwnerHistory = OwnerHistory;
      _this1424.Name = Name;
      _this1424.Description = Description;
      _this1424.ObjectType = ObjectType;
      _this1424.ObjectPlacement = ObjectPlacement;
      _this1424.Representation = Representation;
      _this1424.Tag = Tag;
      _this1424.type = 1876633798;
      return _this1424;
    }

    return IfcBuiltElement;
  }(IfcElement);

  IFC4_32.IfcBuiltElement = IfcBuiltElement;

  var IfcBuiltSystem = /*#__PURE__*/function (_IfcSystem5) {
    _inherits(IfcBuiltSystem, _IfcSystem5);

    var _super1433 = _createSuper(IfcBuiltSystem);

    function IfcBuiltSystem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName) {
      var _this1425;

      _classCallCheck2(this, IfcBuiltSystem);

      _this1425 = _super1433.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1425.GlobalId = GlobalId;
      _this1425.OwnerHistory = OwnerHistory;
      _this1425.Name = Name;
      _this1425.Description = Description;
      _this1425.ObjectType = ObjectType;
      _this1425.PredefinedType = PredefinedType;
      _this1425.LongName = LongName;
      _this1425.type = 3862327254;
      return _this1425;
    }

    return IfcBuiltSystem;
  }(IfcSystem);

  IFC4_32.IfcBuiltSystem = IfcBuiltSystem;

  var IfcBurnerType = /*#__PURE__*/function (_IfcEnergyConversionD31) {
    _inherits(IfcBurnerType, _IfcEnergyConversionD31);

    var _super1434 = _createSuper(IfcBurnerType);

    function IfcBurnerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1426;

      _classCallCheck2(this, IfcBurnerType);

      _this1426 = _super1434.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1426.GlobalId = GlobalId;
      _this1426.OwnerHistory = OwnerHistory;
      _this1426.Name = Name;
      _this1426.Description = Description;
      _this1426.ApplicableOccurrence = ApplicableOccurrence;
      _this1426.HasPropertySets = HasPropertySets;
      _this1426.RepresentationMaps = RepresentationMaps;
      _this1426.Tag = Tag;
      _this1426.ElementType = ElementType;
      _this1426.PredefinedType = PredefinedType;
      _this1426.type = 2188180465;
      return _this1426;
    }

    return IfcBurnerType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcBurnerType = IfcBurnerType;

  var IfcCableCarrierFittingType = /*#__PURE__*/function (_IfcFlowFittingType7) {
    _inherits(IfcCableCarrierFittingType, _IfcFlowFittingType7);

    var _super1435 = _createSuper(IfcCableCarrierFittingType);

    function IfcCableCarrierFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1427;

      _classCallCheck2(this, IfcCableCarrierFittingType);

      _this1427 = _super1435.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1427.GlobalId = GlobalId;
      _this1427.OwnerHistory = OwnerHistory;
      _this1427.Name = Name;
      _this1427.Description = Description;
      _this1427.ApplicableOccurrence = ApplicableOccurrence;
      _this1427.HasPropertySets = HasPropertySets;
      _this1427.RepresentationMaps = RepresentationMaps;
      _this1427.Tag = Tag;
      _this1427.ElementType = ElementType;
      _this1427.PredefinedType = PredefinedType;
      _this1427.type = 395041908;
      return _this1427;
    }

    return IfcCableCarrierFittingType;
  }(IfcFlowFittingType);

  IFC4_32.IfcCableCarrierFittingType = IfcCableCarrierFittingType;

  var IfcCableCarrierSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType6) {
    _inherits(IfcCableCarrierSegmentType, _IfcFlowSegmentType6);

    var _super1436 = _createSuper(IfcCableCarrierSegmentType);

    function IfcCableCarrierSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1428;

      _classCallCheck2(this, IfcCableCarrierSegmentType);

      _this1428 = _super1436.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1428.GlobalId = GlobalId;
      _this1428.OwnerHistory = OwnerHistory;
      _this1428.Name = Name;
      _this1428.Description = Description;
      _this1428.ApplicableOccurrence = ApplicableOccurrence;
      _this1428.HasPropertySets = HasPropertySets;
      _this1428.RepresentationMaps = RepresentationMaps;
      _this1428.Tag = Tag;
      _this1428.ElementType = ElementType;
      _this1428.PredefinedType = PredefinedType;
      _this1428.type = 3293546465;
      return _this1428;
    }

    return IfcCableCarrierSegmentType;
  }(IfcFlowSegmentType);

  IFC4_32.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;

  var IfcCableFittingType = /*#__PURE__*/function (_IfcFlowFittingType8) {
    _inherits(IfcCableFittingType, _IfcFlowFittingType8);

    var _super1437 = _createSuper(IfcCableFittingType);

    function IfcCableFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1429;

      _classCallCheck2(this, IfcCableFittingType);

      _this1429 = _super1437.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1429.GlobalId = GlobalId;
      _this1429.OwnerHistory = OwnerHistory;
      _this1429.Name = Name;
      _this1429.Description = Description;
      _this1429.ApplicableOccurrence = ApplicableOccurrence;
      _this1429.HasPropertySets = HasPropertySets;
      _this1429.RepresentationMaps = RepresentationMaps;
      _this1429.Tag = Tag;
      _this1429.ElementType = ElementType;
      _this1429.PredefinedType = PredefinedType;
      _this1429.type = 2674252688;
      return _this1429;
    }

    return IfcCableFittingType;
  }(IfcFlowFittingType);

  IFC4_32.IfcCableFittingType = IfcCableFittingType;

  var IfcCableSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType7) {
    _inherits(IfcCableSegmentType, _IfcFlowSegmentType7);

    var _super1438 = _createSuper(IfcCableSegmentType);

    function IfcCableSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1430;

      _classCallCheck2(this, IfcCableSegmentType);

      _this1430 = _super1438.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1430.GlobalId = GlobalId;
      _this1430.OwnerHistory = OwnerHistory;
      _this1430.Name = Name;
      _this1430.Description = Description;
      _this1430.ApplicableOccurrence = ApplicableOccurrence;
      _this1430.HasPropertySets = HasPropertySets;
      _this1430.RepresentationMaps = RepresentationMaps;
      _this1430.Tag = Tag;
      _this1430.ElementType = ElementType;
      _this1430.PredefinedType = PredefinedType;
      _this1430.type = 1285652485;
      return _this1430;
    }

    return IfcCableSegmentType;
  }(IfcFlowSegmentType);

  IFC4_32.IfcCableSegmentType = IfcCableSegmentType;

  var IfcCaissonFoundationType = /*#__PURE__*/function (_IfcDeepFoundationTyp2) {
    _inherits(IfcCaissonFoundationType, _IfcDeepFoundationTyp2);

    var _super1439 = _createSuper(IfcCaissonFoundationType);

    function IfcCaissonFoundationType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1431;

      _classCallCheck2(this, IfcCaissonFoundationType);

      _this1431 = _super1439.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1431.GlobalId = GlobalId;
      _this1431.OwnerHistory = OwnerHistory;
      _this1431.Name = Name;
      _this1431.Description = Description;
      _this1431.ApplicableOccurrence = ApplicableOccurrence;
      _this1431.HasPropertySets = HasPropertySets;
      _this1431.RepresentationMaps = RepresentationMaps;
      _this1431.Tag = Tag;
      _this1431.ElementType = ElementType;
      _this1431.PredefinedType = PredefinedType;
      _this1431.type = 3203706013;
      return _this1431;
    }

    return IfcCaissonFoundationType;
  }(IfcDeepFoundationType);

  IFC4_32.IfcCaissonFoundationType = IfcCaissonFoundationType;

  var IfcChillerType = /*#__PURE__*/function (_IfcEnergyConversionD32) {
    _inherits(IfcChillerType, _IfcEnergyConversionD32);

    var _super1440 = _createSuper(IfcChillerType);

    function IfcChillerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1432;

      _classCallCheck2(this, IfcChillerType);

      _this1432 = _super1440.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1432.GlobalId = GlobalId;
      _this1432.OwnerHistory = OwnerHistory;
      _this1432.Name = Name;
      _this1432.Description = Description;
      _this1432.ApplicableOccurrence = ApplicableOccurrence;
      _this1432.HasPropertySets = HasPropertySets;
      _this1432.RepresentationMaps = RepresentationMaps;
      _this1432.Tag = Tag;
      _this1432.ElementType = ElementType;
      _this1432.PredefinedType = PredefinedType;
      _this1432.type = 2951183804;
      return _this1432;
    }

    return IfcChillerType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcChillerType = IfcChillerType;

  var IfcChimney = /*#__PURE__*/function (_IfcBuiltElement) {
    _inherits(IfcChimney, _IfcBuiltElement);

    var _super1441 = _createSuper(IfcChimney);

    function IfcChimney(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1433;

      _classCallCheck2(this, IfcChimney);

      _this1433 = _super1441.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1433.GlobalId = GlobalId;
      _this1433.OwnerHistory = OwnerHistory;
      _this1433.Name = Name;
      _this1433.Description = Description;
      _this1433.ObjectType = ObjectType;
      _this1433.ObjectPlacement = ObjectPlacement;
      _this1433.Representation = Representation;
      _this1433.Tag = Tag;
      _this1433.PredefinedType = PredefinedType;
      _this1433.type = 3296154744;
      return _this1433;
    }

    return IfcChimney;
  }(IfcBuiltElement);

  IFC4_32.IfcChimney = IfcChimney;

  var IfcCircle = /*#__PURE__*/function (_IfcConic4) {
    _inherits(IfcCircle, _IfcConic4);

    var _super1442 = _createSuper(IfcCircle);

    function IfcCircle(expressID, Position, Radius) {
      var _this1434;

      _classCallCheck2(this, IfcCircle);

      _this1434 = _super1442.call(this, expressID, Position);
      _this1434.Position = Position;
      _this1434.Radius = Radius;
      _this1434.type = 2611217952;
      return _this1434;
    }

    return IfcCircle;
  }(IfcConic);

  IFC4_32.IfcCircle = IfcCircle;

  var IfcCivilElement = /*#__PURE__*/function (_IfcElement20) {
    _inherits(IfcCivilElement, _IfcElement20);

    var _super1443 = _createSuper(IfcCivilElement);

    function IfcCivilElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1435;

      _classCallCheck2(this, IfcCivilElement);

      _this1435 = _super1443.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1435.GlobalId = GlobalId;
      _this1435.OwnerHistory = OwnerHistory;
      _this1435.Name = Name;
      _this1435.Description = Description;
      _this1435.ObjectType = ObjectType;
      _this1435.ObjectPlacement = ObjectPlacement;
      _this1435.Representation = Representation;
      _this1435.Tag = Tag;
      _this1435.type = 1677625105;
      return _this1435;
    }

    return IfcCivilElement;
  }(IfcElement);

  IFC4_32.IfcCivilElement = IfcCivilElement;

  var IfcCoilType = /*#__PURE__*/function (_IfcEnergyConversionD33) {
    _inherits(IfcCoilType, _IfcEnergyConversionD33);

    var _super1444 = _createSuper(IfcCoilType);

    function IfcCoilType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1436;

      _classCallCheck2(this, IfcCoilType);

      _this1436 = _super1444.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1436.GlobalId = GlobalId;
      _this1436.OwnerHistory = OwnerHistory;
      _this1436.Name = Name;
      _this1436.Description = Description;
      _this1436.ApplicableOccurrence = ApplicableOccurrence;
      _this1436.HasPropertySets = HasPropertySets;
      _this1436.RepresentationMaps = RepresentationMaps;
      _this1436.Tag = Tag;
      _this1436.ElementType = ElementType;
      _this1436.PredefinedType = PredefinedType;
      _this1436.type = 2301859152;
      return _this1436;
    }

    return IfcCoilType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcCoilType = IfcCoilType;

  var IfcColumn = /*#__PURE__*/function (_IfcBuiltElement2) {
    _inherits(IfcColumn, _IfcBuiltElement2);

    var _super1445 = _createSuper(IfcColumn);

    function IfcColumn(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1437;

      _classCallCheck2(this, IfcColumn);

      _this1437 = _super1445.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1437.GlobalId = GlobalId;
      _this1437.OwnerHistory = OwnerHistory;
      _this1437.Name = Name;
      _this1437.Description = Description;
      _this1437.ObjectType = ObjectType;
      _this1437.ObjectPlacement = ObjectPlacement;
      _this1437.Representation = Representation;
      _this1437.Tag = Tag;
      _this1437.PredefinedType = PredefinedType;
      _this1437.type = 843113511;
      return _this1437;
    }

    return IfcColumn;
  }(IfcBuiltElement);

  IFC4_32.IfcColumn = IfcColumn;

  var IfcCommunicationsApplianceType = /*#__PURE__*/function (_IfcFlowTerminalType25) {
    _inherits(IfcCommunicationsApplianceType, _IfcFlowTerminalType25);

    var _super1446 = _createSuper(IfcCommunicationsApplianceType);

    function IfcCommunicationsApplianceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1438;

      _classCallCheck2(this, IfcCommunicationsApplianceType);

      _this1438 = _super1446.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1438.GlobalId = GlobalId;
      _this1438.OwnerHistory = OwnerHistory;
      _this1438.Name = Name;
      _this1438.Description = Description;
      _this1438.ApplicableOccurrence = ApplicableOccurrence;
      _this1438.HasPropertySets = HasPropertySets;
      _this1438.RepresentationMaps = RepresentationMaps;
      _this1438.Tag = Tag;
      _this1438.ElementType = ElementType;
      _this1438.PredefinedType = PredefinedType;
      _this1438.type = 400855858;
      return _this1438;
    }

    return IfcCommunicationsApplianceType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcCommunicationsApplianceType = IfcCommunicationsApplianceType;

  var IfcCompressorType = /*#__PURE__*/function (_IfcFlowMovingDeviceT5) {
    _inherits(IfcCompressorType, _IfcFlowMovingDeviceT5);

    var _super1447 = _createSuper(IfcCompressorType);

    function IfcCompressorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1439;

      _classCallCheck2(this, IfcCompressorType);

      _this1439 = _super1447.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1439.GlobalId = GlobalId;
      _this1439.OwnerHistory = OwnerHistory;
      _this1439.Name = Name;
      _this1439.Description = Description;
      _this1439.ApplicableOccurrence = ApplicableOccurrence;
      _this1439.HasPropertySets = HasPropertySets;
      _this1439.RepresentationMaps = RepresentationMaps;
      _this1439.Tag = Tag;
      _this1439.ElementType = ElementType;
      _this1439.PredefinedType = PredefinedType;
      _this1439.type = 3850581409;
      return _this1439;
    }

    return IfcCompressorType;
  }(IfcFlowMovingDeviceType);

  IFC4_32.IfcCompressorType = IfcCompressorType;

  var IfcCondenserType = /*#__PURE__*/function (_IfcEnergyConversionD34) {
    _inherits(IfcCondenserType, _IfcEnergyConversionD34);

    var _super1448 = _createSuper(IfcCondenserType);

    function IfcCondenserType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1440;

      _classCallCheck2(this, IfcCondenserType);

      _this1440 = _super1448.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1440.GlobalId = GlobalId;
      _this1440.OwnerHistory = OwnerHistory;
      _this1440.Name = Name;
      _this1440.Description = Description;
      _this1440.ApplicableOccurrence = ApplicableOccurrence;
      _this1440.HasPropertySets = HasPropertySets;
      _this1440.RepresentationMaps = RepresentationMaps;
      _this1440.Tag = Tag;
      _this1440.ElementType = ElementType;
      _this1440.PredefinedType = PredefinedType;
      _this1440.type = 2816379211;
      return _this1440;
    }

    return IfcCondenserType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcCondenserType = IfcCondenserType;

  var IfcConstructionEquipmentResource = /*#__PURE__*/function (_IfcConstructionResou16) {
    _inherits(IfcConstructionEquipmentResource, _IfcConstructionResou16);

    var _super1449 = _createSuper(IfcConstructionEquipmentResource);

    function IfcConstructionEquipmentResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1441;

      _classCallCheck2(this, IfcConstructionEquipmentResource);

      _this1441 = _super1449.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this1441.GlobalId = GlobalId;
      _this1441.OwnerHistory = OwnerHistory;
      _this1441.Name = Name;
      _this1441.Description = Description;
      _this1441.ObjectType = ObjectType;
      _this1441.Identification = Identification;
      _this1441.LongDescription = LongDescription;
      _this1441.Usage = Usage;
      _this1441.BaseCosts = BaseCosts;
      _this1441.BaseQuantity = BaseQuantity;
      _this1441.PredefinedType = PredefinedType;
      _this1441.type = 3898045240;
      return _this1441;
    }

    return IfcConstructionEquipmentResource;
  }(IfcConstructionResource);

  IFC4_32.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;

  var IfcConstructionMaterialResource = /*#__PURE__*/function (_IfcConstructionResou17) {
    _inherits(IfcConstructionMaterialResource, _IfcConstructionResou17);

    var _super1450 = _createSuper(IfcConstructionMaterialResource);

    function IfcConstructionMaterialResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1442;

      _classCallCheck2(this, IfcConstructionMaterialResource);

      _this1442 = _super1450.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this1442.GlobalId = GlobalId;
      _this1442.OwnerHistory = OwnerHistory;
      _this1442.Name = Name;
      _this1442.Description = Description;
      _this1442.ObjectType = ObjectType;
      _this1442.Identification = Identification;
      _this1442.LongDescription = LongDescription;
      _this1442.Usage = Usage;
      _this1442.BaseCosts = BaseCosts;
      _this1442.BaseQuantity = BaseQuantity;
      _this1442.PredefinedType = PredefinedType;
      _this1442.type = 1060000209;
      return _this1442;
    }

    return IfcConstructionMaterialResource;
  }(IfcConstructionResource);

  IFC4_32.IfcConstructionMaterialResource = IfcConstructionMaterialResource;

  var IfcConstructionProductResource = /*#__PURE__*/function (_IfcConstructionResou18) {
    _inherits(IfcConstructionProductResource, _IfcConstructionResou18);

    var _super1451 = _createSuper(IfcConstructionProductResource);

    function IfcConstructionProductResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1443;

      _classCallCheck2(this, IfcConstructionProductResource);

      _this1443 = _super1451.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this1443.GlobalId = GlobalId;
      _this1443.OwnerHistory = OwnerHistory;
      _this1443.Name = Name;
      _this1443.Description = Description;
      _this1443.ObjectType = ObjectType;
      _this1443.Identification = Identification;
      _this1443.LongDescription = LongDescription;
      _this1443.Usage = Usage;
      _this1443.BaseCosts = BaseCosts;
      _this1443.BaseQuantity = BaseQuantity;
      _this1443.PredefinedType = PredefinedType;
      _this1443.type = 488727124;
      return _this1443;
    }

    return IfcConstructionProductResource;
  }(IfcConstructionResource);

  IFC4_32.IfcConstructionProductResource = IfcConstructionProductResource;

  var IfcConveyorSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType8) {
    _inherits(IfcConveyorSegmentType, _IfcFlowSegmentType8);

    var _super1452 = _createSuper(IfcConveyorSegmentType);

    function IfcConveyorSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1444;

      _classCallCheck2(this, IfcConveyorSegmentType);

      _this1444 = _super1452.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1444.GlobalId = GlobalId;
      _this1444.OwnerHistory = OwnerHistory;
      _this1444.Name = Name;
      _this1444.Description = Description;
      _this1444.ApplicableOccurrence = ApplicableOccurrence;
      _this1444.HasPropertySets = HasPropertySets;
      _this1444.RepresentationMaps = RepresentationMaps;
      _this1444.Tag = Tag;
      _this1444.ElementType = ElementType;
      _this1444.PredefinedType = PredefinedType;
      _this1444.type = 2940368186;
      return _this1444;
    }

    return IfcConveyorSegmentType;
  }(IfcFlowSegmentType);

  IFC4_32.IfcConveyorSegmentType = IfcConveyorSegmentType;

  var IfcCooledBeamType = /*#__PURE__*/function (_IfcEnergyConversionD35) {
    _inherits(IfcCooledBeamType, _IfcEnergyConversionD35);

    var _super1453 = _createSuper(IfcCooledBeamType);

    function IfcCooledBeamType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1445;

      _classCallCheck2(this, IfcCooledBeamType);

      _this1445 = _super1453.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1445.GlobalId = GlobalId;
      _this1445.OwnerHistory = OwnerHistory;
      _this1445.Name = Name;
      _this1445.Description = Description;
      _this1445.ApplicableOccurrence = ApplicableOccurrence;
      _this1445.HasPropertySets = HasPropertySets;
      _this1445.RepresentationMaps = RepresentationMaps;
      _this1445.Tag = Tag;
      _this1445.ElementType = ElementType;
      _this1445.PredefinedType = PredefinedType;
      _this1445.type = 335055490;
      return _this1445;
    }

    return IfcCooledBeamType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcCooledBeamType = IfcCooledBeamType;

  var IfcCoolingTowerType = /*#__PURE__*/function (_IfcEnergyConversionD36) {
    _inherits(IfcCoolingTowerType, _IfcEnergyConversionD36);

    var _super1454 = _createSuper(IfcCoolingTowerType);

    function IfcCoolingTowerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1446;

      _classCallCheck2(this, IfcCoolingTowerType);

      _this1446 = _super1454.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1446.GlobalId = GlobalId;
      _this1446.OwnerHistory = OwnerHistory;
      _this1446.Name = Name;
      _this1446.Description = Description;
      _this1446.ApplicableOccurrence = ApplicableOccurrence;
      _this1446.HasPropertySets = HasPropertySets;
      _this1446.RepresentationMaps = RepresentationMaps;
      _this1446.Tag = Tag;
      _this1446.ElementType = ElementType;
      _this1446.PredefinedType = PredefinedType;
      _this1446.type = 2954562838;
      return _this1446;
    }

    return IfcCoolingTowerType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcCoolingTowerType = IfcCoolingTowerType;

  var IfcCourse = /*#__PURE__*/function (_IfcBuiltElement3) {
    _inherits(IfcCourse, _IfcBuiltElement3);

    var _super1455 = _createSuper(IfcCourse);

    function IfcCourse(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1447;

      _classCallCheck2(this, IfcCourse);

      _this1447 = _super1455.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1447.GlobalId = GlobalId;
      _this1447.OwnerHistory = OwnerHistory;
      _this1447.Name = Name;
      _this1447.Description = Description;
      _this1447.ObjectType = ObjectType;
      _this1447.ObjectPlacement = ObjectPlacement;
      _this1447.Representation = Representation;
      _this1447.Tag = Tag;
      _this1447.PredefinedType = PredefinedType;
      _this1447.type = 1502416096;
      return _this1447;
    }

    return IfcCourse;
  }(IfcBuiltElement);

  IFC4_32.IfcCourse = IfcCourse;

  var IfcCovering = /*#__PURE__*/function (_IfcBuiltElement4) {
    _inherits(IfcCovering, _IfcBuiltElement4);

    var _super1456 = _createSuper(IfcCovering);

    function IfcCovering(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1448;

      _classCallCheck2(this, IfcCovering);

      _this1448 = _super1456.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1448.GlobalId = GlobalId;
      _this1448.OwnerHistory = OwnerHistory;
      _this1448.Name = Name;
      _this1448.Description = Description;
      _this1448.ObjectType = ObjectType;
      _this1448.ObjectPlacement = ObjectPlacement;
      _this1448.Representation = Representation;
      _this1448.Tag = Tag;
      _this1448.PredefinedType = PredefinedType;
      _this1448.type = 1973544240;
      return _this1448;
    }

    return IfcCovering;
  }(IfcBuiltElement);

  IFC4_32.IfcCovering = IfcCovering;

  var IfcCurtainWall = /*#__PURE__*/function (_IfcBuiltElement5) {
    _inherits(IfcCurtainWall, _IfcBuiltElement5);

    var _super1457 = _createSuper(IfcCurtainWall);

    function IfcCurtainWall(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1449;

      _classCallCheck2(this, IfcCurtainWall);

      _this1449 = _super1457.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1449.GlobalId = GlobalId;
      _this1449.OwnerHistory = OwnerHistory;
      _this1449.Name = Name;
      _this1449.Description = Description;
      _this1449.ObjectType = ObjectType;
      _this1449.ObjectPlacement = ObjectPlacement;
      _this1449.Representation = Representation;
      _this1449.Tag = Tag;
      _this1449.PredefinedType = PredefinedType;
      _this1449.type = 3495092785;
      return _this1449;
    }

    return IfcCurtainWall;
  }(IfcBuiltElement);

  IFC4_32.IfcCurtainWall = IfcCurtainWall;

  var IfcDamperType = /*#__PURE__*/function (_IfcFlowControllerTyp13) {
    _inherits(IfcDamperType, _IfcFlowControllerTyp13);

    var _super1458 = _createSuper(IfcDamperType);

    function IfcDamperType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1450;

      _classCallCheck2(this, IfcDamperType);

      _this1450 = _super1458.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1450.GlobalId = GlobalId;
      _this1450.OwnerHistory = OwnerHistory;
      _this1450.Name = Name;
      _this1450.Description = Description;
      _this1450.ApplicableOccurrence = ApplicableOccurrence;
      _this1450.HasPropertySets = HasPropertySets;
      _this1450.RepresentationMaps = RepresentationMaps;
      _this1450.Tag = Tag;
      _this1450.ElementType = ElementType;
      _this1450.PredefinedType = PredefinedType;
      _this1450.type = 3961806047;
      return _this1450;
    }

    return IfcDamperType;
  }(IfcFlowControllerType);

  IFC4_32.IfcDamperType = IfcDamperType;

  var IfcDeepFoundation = /*#__PURE__*/function (_IfcBuiltElement6) {
    _inherits(IfcDeepFoundation, _IfcBuiltElement6);

    var _super1459 = _createSuper(IfcDeepFoundation);

    function IfcDeepFoundation(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1451;

      _classCallCheck2(this, IfcDeepFoundation);

      _this1451 = _super1459.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1451.GlobalId = GlobalId;
      _this1451.OwnerHistory = OwnerHistory;
      _this1451.Name = Name;
      _this1451.Description = Description;
      _this1451.ObjectType = ObjectType;
      _this1451.ObjectPlacement = ObjectPlacement;
      _this1451.Representation = Representation;
      _this1451.Tag = Tag;
      _this1451.type = 3426335179;
      return _this1451;
    }

    return IfcDeepFoundation;
  }(IfcBuiltElement);

  IFC4_32.IfcDeepFoundation = IfcDeepFoundation;

  var IfcDiscreteAccessory = /*#__PURE__*/function (_IfcElementComponent11) {
    _inherits(IfcDiscreteAccessory, _IfcElementComponent11);

    var _super1460 = _createSuper(IfcDiscreteAccessory);

    function IfcDiscreteAccessory(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1452;

      _classCallCheck2(this, IfcDiscreteAccessory);

      _this1452 = _super1460.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1452.GlobalId = GlobalId;
      _this1452.OwnerHistory = OwnerHistory;
      _this1452.Name = Name;
      _this1452.Description = Description;
      _this1452.ObjectType = ObjectType;
      _this1452.ObjectPlacement = ObjectPlacement;
      _this1452.Representation = Representation;
      _this1452.Tag = Tag;
      _this1452.PredefinedType = PredefinedType;
      _this1452.type = 1335981549;
      return _this1452;
    }

    return IfcDiscreteAccessory;
  }(IfcElementComponent);

  IFC4_32.IfcDiscreteAccessory = IfcDiscreteAccessory;

  var IfcDiscreteAccessoryType = /*#__PURE__*/function (_IfcElementComponentT11) {
    _inherits(IfcDiscreteAccessoryType, _IfcElementComponentT11);

    var _super1461 = _createSuper(IfcDiscreteAccessoryType);

    function IfcDiscreteAccessoryType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1453;

      _classCallCheck2(this, IfcDiscreteAccessoryType);

      _this1453 = _super1461.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1453.GlobalId = GlobalId;
      _this1453.OwnerHistory = OwnerHistory;
      _this1453.Name = Name;
      _this1453.Description = Description;
      _this1453.ApplicableOccurrence = ApplicableOccurrence;
      _this1453.HasPropertySets = HasPropertySets;
      _this1453.RepresentationMaps = RepresentationMaps;
      _this1453.Tag = Tag;
      _this1453.ElementType = ElementType;
      _this1453.PredefinedType = PredefinedType;
      _this1453.type = 2635815018;
      return _this1453;
    }

    return IfcDiscreteAccessoryType;
  }(IfcElementComponentType);

  IFC4_32.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;

  var IfcDistributionBoardType = /*#__PURE__*/function (_IfcFlowControllerTyp14) {
    _inherits(IfcDistributionBoardType, _IfcFlowControllerTyp14);

    var _super1462 = _createSuper(IfcDistributionBoardType);

    function IfcDistributionBoardType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1454;

      _classCallCheck2(this, IfcDistributionBoardType);

      _this1454 = _super1462.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1454.GlobalId = GlobalId;
      _this1454.OwnerHistory = OwnerHistory;
      _this1454.Name = Name;
      _this1454.Description = Description;
      _this1454.ApplicableOccurrence = ApplicableOccurrence;
      _this1454.HasPropertySets = HasPropertySets;
      _this1454.RepresentationMaps = RepresentationMaps;
      _this1454.Tag = Tag;
      _this1454.ElementType = ElementType;
      _this1454.PredefinedType = PredefinedType;
      _this1454.type = 479945903;
      return _this1454;
    }

    return IfcDistributionBoardType;
  }(IfcFlowControllerType);

  IFC4_32.IfcDistributionBoardType = IfcDistributionBoardType;

  var IfcDistributionChamberElementType = /*#__PURE__*/function (_IfcDistributionFlowE27) {
    _inherits(IfcDistributionChamberElementType, _IfcDistributionFlowE27);

    var _super1463 = _createSuper(IfcDistributionChamberElementType);

    function IfcDistributionChamberElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1455;

      _classCallCheck2(this, IfcDistributionChamberElementType);

      _this1455 = _super1463.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1455.GlobalId = GlobalId;
      _this1455.OwnerHistory = OwnerHistory;
      _this1455.Name = Name;
      _this1455.Description = Description;
      _this1455.ApplicableOccurrence = ApplicableOccurrence;
      _this1455.HasPropertySets = HasPropertySets;
      _this1455.RepresentationMaps = RepresentationMaps;
      _this1455.Tag = Tag;
      _this1455.ElementType = ElementType;
      _this1455.PredefinedType = PredefinedType;
      _this1455.type = 1599208980;
      return _this1455;
    }

    return IfcDistributionChamberElementType;
  }(IfcDistributionFlowElementType);

  IFC4_32.IfcDistributionChamberElementType = IfcDistributionChamberElementType;

  var IfcDistributionControlElementType = /*#__PURE__*/function (_IfcDistributionEleme6) {
    _inherits(IfcDistributionControlElementType, _IfcDistributionEleme6);

    var _super1464 = _createSuper(IfcDistributionControlElementType);

    function IfcDistributionControlElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1456;

      _classCallCheck2(this, IfcDistributionControlElementType);

      _this1456 = _super1464.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1456.GlobalId = GlobalId;
      _this1456.OwnerHistory = OwnerHistory;
      _this1456.Name = Name;
      _this1456.Description = Description;
      _this1456.ApplicableOccurrence = ApplicableOccurrence;
      _this1456.HasPropertySets = HasPropertySets;
      _this1456.RepresentationMaps = RepresentationMaps;
      _this1456.Tag = Tag;
      _this1456.ElementType = ElementType;
      _this1456.type = 2063403501;
      return _this1456;
    }

    return IfcDistributionControlElementType;
  }(IfcDistributionElementType);

  IFC4_32.IfcDistributionControlElementType = IfcDistributionControlElementType;

  var IfcDistributionElement = /*#__PURE__*/function (_IfcElement21) {
    _inherits(IfcDistributionElement, _IfcElement21);

    var _super1465 = _createSuper(IfcDistributionElement);

    function IfcDistributionElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1457;

      _classCallCheck2(this, IfcDistributionElement);

      _this1457 = _super1465.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1457.GlobalId = GlobalId;
      _this1457.OwnerHistory = OwnerHistory;
      _this1457.Name = Name;
      _this1457.Description = Description;
      _this1457.ObjectType = ObjectType;
      _this1457.ObjectPlacement = ObjectPlacement;
      _this1457.Representation = Representation;
      _this1457.Tag = Tag;
      _this1457.type = 1945004755;
      return _this1457;
    }

    return IfcDistributionElement;
  }(IfcElement);

  IFC4_32.IfcDistributionElement = IfcDistributionElement;

  var IfcDistributionFlowElement = /*#__PURE__*/function (_IfcDistributionEleme7) {
    _inherits(IfcDistributionFlowElement, _IfcDistributionEleme7);

    var _super1466 = _createSuper(IfcDistributionFlowElement);

    function IfcDistributionFlowElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1458;

      _classCallCheck2(this, IfcDistributionFlowElement);

      _this1458 = _super1466.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1458.GlobalId = GlobalId;
      _this1458.OwnerHistory = OwnerHistory;
      _this1458.Name = Name;
      _this1458.Description = Description;
      _this1458.ObjectType = ObjectType;
      _this1458.ObjectPlacement = ObjectPlacement;
      _this1458.Representation = Representation;
      _this1458.Tag = Tag;
      _this1458.type = 3040386961;
      return _this1458;
    }

    return IfcDistributionFlowElement;
  }(IfcDistributionElement);

  IFC4_32.IfcDistributionFlowElement = IfcDistributionFlowElement;

  var IfcDistributionPort = /*#__PURE__*/function (_IfcPort2) {
    _inherits(IfcDistributionPort, _IfcPort2);

    var _super1467 = _createSuper(IfcDistributionPort);

    function IfcDistributionPort(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection, PredefinedType, SystemType) {
      var _this1459;

      _classCallCheck2(this, IfcDistributionPort);

      _this1459 = _super1467.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1459.GlobalId = GlobalId;
      _this1459.OwnerHistory = OwnerHistory;
      _this1459.Name = Name;
      _this1459.Description = Description;
      _this1459.ObjectType = ObjectType;
      _this1459.ObjectPlacement = ObjectPlacement;
      _this1459.Representation = Representation;
      _this1459.FlowDirection = FlowDirection;
      _this1459.PredefinedType = PredefinedType;
      _this1459.SystemType = SystemType;
      _this1459.type = 3041715199;
      return _this1459;
    }

    return IfcDistributionPort;
  }(IfcPort);

  IFC4_32.IfcDistributionPort = IfcDistributionPort;

  var IfcDistributionSystem = /*#__PURE__*/function (_IfcSystem6) {
    _inherits(IfcDistributionSystem, _IfcSystem6);

    var _super1468 = _createSuper(IfcDistributionSystem);

    function IfcDistributionSystem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      var _this1460;

      _classCallCheck2(this, IfcDistributionSystem);

      _this1460 = _super1468.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1460.GlobalId = GlobalId;
      _this1460.OwnerHistory = OwnerHistory;
      _this1460.Name = Name;
      _this1460.Description = Description;
      _this1460.ObjectType = ObjectType;
      _this1460.LongName = LongName;
      _this1460.PredefinedType = PredefinedType;
      _this1460.type = 3205830791;
      return _this1460;
    }

    return IfcDistributionSystem;
  }(IfcSystem);

  IFC4_32.IfcDistributionSystem = IfcDistributionSystem;

  var IfcDoor = /*#__PURE__*/function (_IfcBuiltElement7) {
    _inherits(IfcDoor, _IfcBuiltElement7);

    var _super1469 = _createSuper(IfcDoor);

    function IfcDoor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType) {
      var _this1461;

      _classCallCheck2(this, IfcDoor);

      _this1461 = _super1469.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1461.GlobalId = GlobalId;
      _this1461.OwnerHistory = OwnerHistory;
      _this1461.Name = Name;
      _this1461.Description = Description;
      _this1461.ObjectType = ObjectType;
      _this1461.ObjectPlacement = ObjectPlacement;
      _this1461.Representation = Representation;
      _this1461.Tag = Tag;
      _this1461.OverallHeight = OverallHeight;
      _this1461.OverallWidth = OverallWidth;
      _this1461.PredefinedType = PredefinedType;
      _this1461.OperationType = OperationType;
      _this1461.UserDefinedOperationType = UserDefinedOperationType;
      _this1461.type = 395920057;
      return _this1461;
    }

    return IfcDoor;
  }(IfcBuiltElement);

  IFC4_32.IfcDoor = IfcDoor;

  var IfcDuctFittingType = /*#__PURE__*/function (_IfcFlowFittingType9) {
    _inherits(IfcDuctFittingType, _IfcFlowFittingType9);

    var _super1470 = _createSuper(IfcDuctFittingType);

    function IfcDuctFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1462;

      _classCallCheck2(this, IfcDuctFittingType);

      _this1462 = _super1470.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1462.GlobalId = GlobalId;
      _this1462.OwnerHistory = OwnerHistory;
      _this1462.Name = Name;
      _this1462.Description = Description;
      _this1462.ApplicableOccurrence = ApplicableOccurrence;
      _this1462.HasPropertySets = HasPropertySets;
      _this1462.RepresentationMaps = RepresentationMaps;
      _this1462.Tag = Tag;
      _this1462.ElementType = ElementType;
      _this1462.PredefinedType = PredefinedType;
      _this1462.type = 869906466;
      return _this1462;
    }

    return IfcDuctFittingType;
  }(IfcFlowFittingType);

  IFC4_32.IfcDuctFittingType = IfcDuctFittingType;

  var IfcDuctSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType9) {
    _inherits(IfcDuctSegmentType, _IfcFlowSegmentType9);

    var _super1471 = _createSuper(IfcDuctSegmentType);

    function IfcDuctSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1463;

      _classCallCheck2(this, IfcDuctSegmentType);

      _this1463 = _super1471.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1463.GlobalId = GlobalId;
      _this1463.OwnerHistory = OwnerHistory;
      _this1463.Name = Name;
      _this1463.Description = Description;
      _this1463.ApplicableOccurrence = ApplicableOccurrence;
      _this1463.HasPropertySets = HasPropertySets;
      _this1463.RepresentationMaps = RepresentationMaps;
      _this1463.Tag = Tag;
      _this1463.ElementType = ElementType;
      _this1463.PredefinedType = PredefinedType;
      _this1463.type = 3760055223;
      return _this1463;
    }

    return IfcDuctSegmentType;
  }(IfcFlowSegmentType);

  IFC4_32.IfcDuctSegmentType = IfcDuctSegmentType;

  var IfcDuctSilencerType = /*#__PURE__*/function (_IfcFlowTreatmentDevi4) {
    _inherits(IfcDuctSilencerType, _IfcFlowTreatmentDevi4);

    var _super1472 = _createSuper(IfcDuctSilencerType);

    function IfcDuctSilencerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1464;

      _classCallCheck2(this, IfcDuctSilencerType);

      _this1464 = _super1472.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1464.GlobalId = GlobalId;
      _this1464.OwnerHistory = OwnerHistory;
      _this1464.Name = Name;
      _this1464.Description = Description;
      _this1464.ApplicableOccurrence = ApplicableOccurrence;
      _this1464.HasPropertySets = HasPropertySets;
      _this1464.RepresentationMaps = RepresentationMaps;
      _this1464.Tag = Tag;
      _this1464.ElementType = ElementType;
      _this1464.PredefinedType = PredefinedType;
      _this1464.type = 2030761528;
      return _this1464;
    }

    return IfcDuctSilencerType;
  }(IfcFlowTreatmentDeviceType);

  IFC4_32.IfcDuctSilencerType = IfcDuctSilencerType;

  var IfcEarthworksCut = /*#__PURE__*/function (_IfcFeatureElementSub5) {
    _inherits(IfcEarthworksCut, _IfcFeatureElementSub5);

    var _super1473 = _createSuper(IfcEarthworksCut);

    function IfcEarthworksCut(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1465;

      _classCallCheck2(this, IfcEarthworksCut);

      _this1465 = _super1473.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1465.GlobalId = GlobalId;
      _this1465.OwnerHistory = OwnerHistory;
      _this1465.Name = Name;
      _this1465.Description = Description;
      _this1465.ObjectType = ObjectType;
      _this1465.ObjectPlacement = ObjectPlacement;
      _this1465.Representation = Representation;
      _this1465.Tag = Tag;
      _this1465.PredefinedType = PredefinedType;
      _this1465.type = 3071239417;
      return _this1465;
    }

    return IfcEarthworksCut;
  }(IfcFeatureElementSubtraction);

  IFC4_32.IfcEarthworksCut = IfcEarthworksCut;

  var IfcEarthworksElement = /*#__PURE__*/function (_IfcBuiltElement8) {
    _inherits(IfcEarthworksElement, _IfcBuiltElement8);

    var _super1474 = _createSuper(IfcEarthworksElement);

    function IfcEarthworksElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1466;

      _classCallCheck2(this, IfcEarthworksElement);

      _this1466 = _super1474.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1466.GlobalId = GlobalId;
      _this1466.OwnerHistory = OwnerHistory;
      _this1466.Name = Name;
      _this1466.Description = Description;
      _this1466.ObjectType = ObjectType;
      _this1466.ObjectPlacement = ObjectPlacement;
      _this1466.Representation = Representation;
      _this1466.Tag = Tag;
      _this1466.type = 1077100507;
      return _this1466;
    }

    return IfcEarthworksElement;
  }(IfcBuiltElement);

  IFC4_32.IfcEarthworksElement = IfcEarthworksElement;

  var IfcEarthworksFill = /*#__PURE__*/function (_IfcEarthworksElement) {
    _inherits(IfcEarthworksFill, _IfcEarthworksElement);

    var _super1475 = _createSuper(IfcEarthworksFill);

    function IfcEarthworksFill(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1467;

      _classCallCheck2(this, IfcEarthworksFill);

      _this1467 = _super1475.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1467.GlobalId = GlobalId;
      _this1467.OwnerHistory = OwnerHistory;
      _this1467.Name = Name;
      _this1467.Description = Description;
      _this1467.ObjectType = ObjectType;
      _this1467.ObjectPlacement = ObjectPlacement;
      _this1467.Representation = Representation;
      _this1467.Tag = Tag;
      _this1467.PredefinedType = PredefinedType;
      _this1467.type = 3376911765;
      return _this1467;
    }

    return IfcEarthworksFill;
  }(IfcEarthworksElement);

  IFC4_32.IfcEarthworksFill = IfcEarthworksFill;

  var IfcElectricApplianceType = /*#__PURE__*/function (_IfcFlowTerminalType26) {
    _inherits(IfcElectricApplianceType, _IfcFlowTerminalType26);

    var _super1476 = _createSuper(IfcElectricApplianceType);

    function IfcElectricApplianceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1468;

      _classCallCheck2(this, IfcElectricApplianceType);

      _this1468 = _super1476.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1468.GlobalId = GlobalId;
      _this1468.OwnerHistory = OwnerHistory;
      _this1468.Name = Name;
      _this1468.Description = Description;
      _this1468.ApplicableOccurrence = ApplicableOccurrence;
      _this1468.HasPropertySets = HasPropertySets;
      _this1468.RepresentationMaps = RepresentationMaps;
      _this1468.Tag = Tag;
      _this1468.ElementType = ElementType;
      _this1468.PredefinedType = PredefinedType;
      _this1468.type = 663422040;
      return _this1468;
    }

    return IfcElectricApplianceType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcElectricApplianceType = IfcElectricApplianceType;

  var IfcElectricDistributionBoardType = /*#__PURE__*/function (_IfcFlowControllerTyp15) {
    _inherits(IfcElectricDistributionBoardType, _IfcFlowControllerTyp15);

    var _super1477 = _createSuper(IfcElectricDistributionBoardType);

    function IfcElectricDistributionBoardType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1469;

      _classCallCheck2(this, IfcElectricDistributionBoardType);

      _this1469 = _super1477.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1469.GlobalId = GlobalId;
      _this1469.OwnerHistory = OwnerHistory;
      _this1469.Name = Name;
      _this1469.Description = Description;
      _this1469.ApplicableOccurrence = ApplicableOccurrence;
      _this1469.HasPropertySets = HasPropertySets;
      _this1469.RepresentationMaps = RepresentationMaps;
      _this1469.Tag = Tag;
      _this1469.ElementType = ElementType;
      _this1469.PredefinedType = PredefinedType;
      _this1469.type = 2417008758;
      return _this1469;
    }

    return IfcElectricDistributionBoardType;
  }(IfcFlowControllerType);

  IFC4_32.IfcElectricDistributionBoardType = IfcElectricDistributionBoardType;

  var IfcElectricFlowStorageDeviceType = /*#__PURE__*/function (_IfcFlowStorageDevice4) {
    _inherits(IfcElectricFlowStorageDeviceType, _IfcFlowStorageDevice4);

    var _super1478 = _createSuper(IfcElectricFlowStorageDeviceType);

    function IfcElectricFlowStorageDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1470;

      _classCallCheck2(this, IfcElectricFlowStorageDeviceType);

      _this1470 = _super1478.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1470.GlobalId = GlobalId;
      _this1470.OwnerHistory = OwnerHistory;
      _this1470.Name = Name;
      _this1470.Description = Description;
      _this1470.ApplicableOccurrence = ApplicableOccurrence;
      _this1470.HasPropertySets = HasPropertySets;
      _this1470.RepresentationMaps = RepresentationMaps;
      _this1470.Tag = Tag;
      _this1470.ElementType = ElementType;
      _this1470.PredefinedType = PredefinedType;
      _this1470.type = 3277789161;
      return _this1470;
    }

    return IfcElectricFlowStorageDeviceType;
  }(IfcFlowStorageDeviceType);

  IFC4_32.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;

  var IfcElectricFlowTreatmentDeviceType = /*#__PURE__*/function (_IfcFlowTreatmentDevi5) {
    _inherits(IfcElectricFlowTreatmentDeviceType, _IfcFlowTreatmentDevi5);

    var _super1479 = _createSuper(IfcElectricFlowTreatmentDeviceType);

    function IfcElectricFlowTreatmentDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1471;

      _classCallCheck2(this, IfcElectricFlowTreatmentDeviceType);

      _this1471 = _super1479.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1471.GlobalId = GlobalId;
      _this1471.OwnerHistory = OwnerHistory;
      _this1471.Name = Name;
      _this1471.Description = Description;
      _this1471.ApplicableOccurrence = ApplicableOccurrence;
      _this1471.HasPropertySets = HasPropertySets;
      _this1471.RepresentationMaps = RepresentationMaps;
      _this1471.Tag = Tag;
      _this1471.ElementType = ElementType;
      _this1471.PredefinedType = PredefinedType;
      _this1471.type = 2142170206;
      return _this1471;
    }

    return IfcElectricFlowTreatmentDeviceType;
  }(IfcFlowTreatmentDeviceType);

  IFC4_32.IfcElectricFlowTreatmentDeviceType = IfcElectricFlowTreatmentDeviceType;

  var IfcElectricGeneratorType = /*#__PURE__*/function (_IfcEnergyConversionD37) {
    _inherits(IfcElectricGeneratorType, _IfcEnergyConversionD37);

    var _super1480 = _createSuper(IfcElectricGeneratorType);

    function IfcElectricGeneratorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1472;

      _classCallCheck2(this, IfcElectricGeneratorType);

      _this1472 = _super1480.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1472.GlobalId = GlobalId;
      _this1472.OwnerHistory = OwnerHistory;
      _this1472.Name = Name;
      _this1472.Description = Description;
      _this1472.ApplicableOccurrence = ApplicableOccurrence;
      _this1472.HasPropertySets = HasPropertySets;
      _this1472.RepresentationMaps = RepresentationMaps;
      _this1472.Tag = Tag;
      _this1472.ElementType = ElementType;
      _this1472.PredefinedType = PredefinedType;
      _this1472.type = 1534661035;
      return _this1472;
    }

    return IfcElectricGeneratorType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcElectricGeneratorType = IfcElectricGeneratorType;

  var IfcElectricMotorType = /*#__PURE__*/function (_IfcEnergyConversionD38) {
    _inherits(IfcElectricMotorType, _IfcEnergyConversionD38);

    var _super1481 = _createSuper(IfcElectricMotorType);

    function IfcElectricMotorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1473;

      _classCallCheck2(this, IfcElectricMotorType);

      _this1473 = _super1481.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1473.GlobalId = GlobalId;
      _this1473.OwnerHistory = OwnerHistory;
      _this1473.Name = Name;
      _this1473.Description = Description;
      _this1473.ApplicableOccurrence = ApplicableOccurrence;
      _this1473.HasPropertySets = HasPropertySets;
      _this1473.RepresentationMaps = RepresentationMaps;
      _this1473.Tag = Tag;
      _this1473.ElementType = ElementType;
      _this1473.PredefinedType = PredefinedType;
      _this1473.type = 1217240411;
      return _this1473;
    }

    return IfcElectricMotorType;
  }(IfcEnergyConversionDeviceType);

  IFC4_32.IfcElectricMotorType = IfcElectricMotorType;

  var IfcElectricTimeControlType = /*#__PURE__*/function (_IfcFlowControllerTyp16) {
    _inherits(IfcElectricTimeControlType, _IfcFlowControllerTyp16);

    var _super1482 = _createSuper(IfcElectricTimeControlType);

    function IfcElectricTimeControlType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1474;

      _classCallCheck2(this, IfcElectricTimeControlType);

      _this1474 = _super1482.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1474.GlobalId = GlobalId;
      _this1474.OwnerHistory = OwnerHistory;
      _this1474.Name = Name;
      _this1474.Description = Description;
      _this1474.ApplicableOccurrence = ApplicableOccurrence;
      _this1474.HasPropertySets = HasPropertySets;
      _this1474.RepresentationMaps = RepresentationMaps;
      _this1474.Tag = Tag;
      _this1474.ElementType = ElementType;
      _this1474.PredefinedType = PredefinedType;
      _this1474.type = 712377611;
      return _this1474;
    }

    return IfcElectricTimeControlType;
  }(IfcFlowControllerType);

  IFC4_32.IfcElectricTimeControlType = IfcElectricTimeControlType;

  var IfcEnergyConversionDevice = /*#__PURE__*/function (_IfcDistributionFlowE28) {
    _inherits(IfcEnergyConversionDevice, _IfcDistributionFlowE28);

    var _super1483 = _createSuper(IfcEnergyConversionDevice);

    function IfcEnergyConversionDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1475;

      _classCallCheck2(this, IfcEnergyConversionDevice);

      _this1475 = _super1483.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1475.GlobalId = GlobalId;
      _this1475.OwnerHistory = OwnerHistory;
      _this1475.Name = Name;
      _this1475.Description = Description;
      _this1475.ObjectType = ObjectType;
      _this1475.ObjectPlacement = ObjectPlacement;
      _this1475.Representation = Representation;
      _this1475.Tag = Tag;
      _this1475.type = 1658829314;
      return _this1475;
    }

    return IfcEnergyConversionDevice;
  }(IfcDistributionFlowElement);

  IFC4_32.IfcEnergyConversionDevice = IfcEnergyConversionDevice;

  var IfcEngine = /*#__PURE__*/function (_IfcEnergyConversionD39) {
    _inherits(IfcEngine, _IfcEnergyConversionD39);

    var _super1484 = _createSuper(IfcEngine);

    function IfcEngine(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1476;

      _classCallCheck2(this, IfcEngine);

      _this1476 = _super1484.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1476.GlobalId = GlobalId;
      _this1476.OwnerHistory = OwnerHistory;
      _this1476.Name = Name;
      _this1476.Description = Description;
      _this1476.ObjectType = ObjectType;
      _this1476.ObjectPlacement = ObjectPlacement;
      _this1476.Representation = Representation;
      _this1476.Tag = Tag;
      _this1476.PredefinedType = PredefinedType;
      _this1476.type = 2814081492;
      return _this1476;
    }

    return IfcEngine;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcEngine = IfcEngine;

  var IfcEvaporativeCooler = /*#__PURE__*/function (_IfcEnergyConversionD40) {
    _inherits(IfcEvaporativeCooler, _IfcEnergyConversionD40);

    var _super1485 = _createSuper(IfcEvaporativeCooler);

    function IfcEvaporativeCooler(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1477;

      _classCallCheck2(this, IfcEvaporativeCooler);

      _this1477 = _super1485.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1477.GlobalId = GlobalId;
      _this1477.OwnerHistory = OwnerHistory;
      _this1477.Name = Name;
      _this1477.Description = Description;
      _this1477.ObjectType = ObjectType;
      _this1477.ObjectPlacement = ObjectPlacement;
      _this1477.Representation = Representation;
      _this1477.Tag = Tag;
      _this1477.PredefinedType = PredefinedType;
      _this1477.type = 3747195512;
      return _this1477;
    }

    return IfcEvaporativeCooler;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcEvaporativeCooler = IfcEvaporativeCooler;

  var IfcEvaporator = /*#__PURE__*/function (_IfcEnergyConversionD41) {
    _inherits(IfcEvaporator, _IfcEnergyConversionD41);

    var _super1486 = _createSuper(IfcEvaporator);

    function IfcEvaporator(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1478;

      _classCallCheck2(this, IfcEvaporator);

      _this1478 = _super1486.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1478.GlobalId = GlobalId;
      _this1478.OwnerHistory = OwnerHistory;
      _this1478.Name = Name;
      _this1478.Description = Description;
      _this1478.ObjectType = ObjectType;
      _this1478.ObjectPlacement = ObjectPlacement;
      _this1478.Representation = Representation;
      _this1478.Tag = Tag;
      _this1478.PredefinedType = PredefinedType;
      _this1478.type = 484807127;
      return _this1478;
    }

    return IfcEvaporator;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcEvaporator = IfcEvaporator;

  var IfcExternalSpatialElement = /*#__PURE__*/function (_IfcExternalSpatialSt) {
    _inherits(IfcExternalSpatialElement, _IfcExternalSpatialSt);

    var _super1487 = _createSuper(IfcExternalSpatialElement);

    function IfcExternalSpatialElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      var _this1479;

      _classCallCheck2(this, IfcExternalSpatialElement);

      _this1479 = _super1487.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      _this1479.GlobalId = GlobalId;
      _this1479.OwnerHistory = OwnerHistory;
      _this1479.Name = Name;
      _this1479.Description = Description;
      _this1479.ObjectType = ObjectType;
      _this1479.ObjectPlacement = ObjectPlacement;
      _this1479.Representation = Representation;
      _this1479.LongName = LongName;
      _this1479.PredefinedType = PredefinedType;
      _this1479.type = 1209101575;
      return _this1479;
    }

    return IfcExternalSpatialElement;
  }(IfcExternalSpatialStructureElement);

  IFC4_32.IfcExternalSpatialElement = IfcExternalSpatialElement;

  var IfcFanType = /*#__PURE__*/function (_IfcFlowMovingDeviceT6) {
    _inherits(IfcFanType, _IfcFlowMovingDeviceT6);

    var _super1488 = _createSuper(IfcFanType);

    function IfcFanType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1480;

      _classCallCheck2(this, IfcFanType);

      _this1480 = _super1488.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1480.GlobalId = GlobalId;
      _this1480.OwnerHistory = OwnerHistory;
      _this1480.Name = Name;
      _this1480.Description = Description;
      _this1480.ApplicableOccurrence = ApplicableOccurrence;
      _this1480.HasPropertySets = HasPropertySets;
      _this1480.RepresentationMaps = RepresentationMaps;
      _this1480.Tag = Tag;
      _this1480.ElementType = ElementType;
      _this1480.PredefinedType = PredefinedType;
      _this1480.type = 346874300;
      return _this1480;
    }

    return IfcFanType;
  }(IfcFlowMovingDeviceType);

  IFC4_32.IfcFanType = IfcFanType;

  var IfcFilterType = /*#__PURE__*/function (_IfcFlowTreatmentDevi6) {
    _inherits(IfcFilterType, _IfcFlowTreatmentDevi6);

    var _super1489 = _createSuper(IfcFilterType);

    function IfcFilterType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1481;

      _classCallCheck2(this, IfcFilterType);

      _this1481 = _super1489.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1481.GlobalId = GlobalId;
      _this1481.OwnerHistory = OwnerHistory;
      _this1481.Name = Name;
      _this1481.Description = Description;
      _this1481.ApplicableOccurrence = ApplicableOccurrence;
      _this1481.HasPropertySets = HasPropertySets;
      _this1481.RepresentationMaps = RepresentationMaps;
      _this1481.Tag = Tag;
      _this1481.ElementType = ElementType;
      _this1481.PredefinedType = PredefinedType;
      _this1481.type = 1810631287;
      return _this1481;
    }

    return IfcFilterType;
  }(IfcFlowTreatmentDeviceType);

  IFC4_32.IfcFilterType = IfcFilterType;

  var IfcFireSuppressionTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType27) {
    _inherits(IfcFireSuppressionTerminalType, _IfcFlowTerminalType27);

    var _super1490 = _createSuper(IfcFireSuppressionTerminalType);

    function IfcFireSuppressionTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1482;

      _classCallCheck2(this, IfcFireSuppressionTerminalType);

      _this1482 = _super1490.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1482.GlobalId = GlobalId;
      _this1482.OwnerHistory = OwnerHistory;
      _this1482.Name = Name;
      _this1482.Description = Description;
      _this1482.ApplicableOccurrence = ApplicableOccurrence;
      _this1482.HasPropertySets = HasPropertySets;
      _this1482.RepresentationMaps = RepresentationMaps;
      _this1482.Tag = Tag;
      _this1482.ElementType = ElementType;
      _this1482.PredefinedType = PredefinedType;
      _this1482.type = 4222183408;
      return _this1482;
    }

    return IfcFireSuppressionTerminalType;
  }(IfcFlowTerminalType);

  IFC4_32.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;

  var IfcFlowController = /*#__PURE__*/function (_IfcDistributionFlowE29) {
    _inherits(IfcFlowController, _IfcDistributionFlowE29);

    var _super1491 = _createSuper(IfcFlowController);

    function IfcFlowController(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1483;

      _classCallCheck2(this, IfcFlowController);

      _this1483 = _super1491.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1483.GlobalId = GlobalId;
      _this1483.OwnerHistory = OwnerHistory;
      _this1483.Name = Name;
      _this1483.Description = Description;
      _this1483.ObjectType = ObjectType;
      _this1483.ObjectPlacement = ObjectPlacement;
      _this1483.Representation = Representation;
      _this1483.Tag = Tag;
      _this1483.type = 2058353004;
      return _this1483;
    }

    return IfcFlowController;
  }(IfcDistributionFlowElement);

  IFC4_32.IfcFlowController = IfcFlowController;

  var IfcFlowFitting = /*#__PURE__*/function (_IfcDistributionFlowE30) {
    _inherits(IfcFlowFitting, _IfcDistributionFlowE30);

    var _super1492 = _createSuper(IfcFlowFitting);

    function IfcFlowFitting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1484;

      _classCallCheck2(this, IfcFlowFitting);

      _this1484 = _super1492.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1484.GlobalId = GlobalId;
      _this1484.OwnerHistory = OwnerHistory;
      _this1484.Name = Name;
      _this1484.Description = Description;
      _this1484.ObjectType = ObjectType;
      _this1484.ObjectPlacement = ObjectPlacement;
      _this1484.Representation = Representation;
      _this1484.Tag = Tag;
      _this1484.type = 4278956645;
      return _this1484;
    }

    return IfcFlowFitting;
  }(IfcDistributionFlowElement);

  IFC4_32.IfcFlowFitting = IfcFlowFitting;

  var IfcFlowInstrumentType = /*#__PURE__*/function (_IfcDistributionContr6) {
    _inherits(IfcFlowInstrumentType, _IfcDistributionContr6);

    var _super1493 = _createSuper(IfcFlowInstrumentType);

    function IfcFlowInstrumentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1485;

      _classCallCheck2(this, IfcFlowInstrumentType);

      _this1485 = _super1493.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1485.GlobalId = GlobalId;
      _this1485.OwnerHistory = OwnerHistory;
      _this1485.Name = Name;
      _this1485.Description = Description;
      _this1485.ApplicableOccurrence = ApplicableOccurrence;
      _this1485.HasPropertySets = HasPropertySets;
      _this1485.RepresentationMaps = RepresentationMaps;
      _this1485.Tag = Tag;
      _this1485.ElementType = ElementType;
      _this1485.PredefinedType = PredefinedType;
      _this1485.type = 4037862832;
      return _this1485;
    }

    return IfcFlowInstrumentType;
  }(IfcDistributionControlElementType);

  IFC4_32.IfcFlowInstrumentType = IfcFlowInstrumentType;

  var IfcFlowMeter = /*#__PURE__*/function (_IfcFlowController2) {
    _inherits(IfcFlowMeter, _IfcFlowController2);

    var _super1494 = _createSuper(IfcFlowMeter);

    function IfcFlowMeter(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1486;

      _classCallCheck2(this, IfcFlowMeter);

      _this1486 = _super1494.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1486.GlobalId = GlobalId;
      _this1486.OwnerHistory = OwnerHistory;
      _this1486.Name = Name;
      _this1486.Description = Description;
      _this1486.ObjectType = ObjectType;
      _this1486.ObjectPlacement = ObjectPlacement;
      _this1486.Representation = Representation;
      _this1486.Tag = Tag;
      _this1486.PredefinedType = PredefinedType;
      _this1486.type = 2188021234;
      return _this1486;
    }

    return IfcFlowMeter;
  }(IfcFlowController);

  IFC4_32.IfcFlowMeter = IfcFlowMeter;

  var IfcFlowMovingDevice = /*#__PURE__*/function (_IfcDistributionFlowE31) {
    _inherits(IfcFlowMovingDevice, _IfcDistributionFlowE31);

    var _super1495 = _createSuper(IfcFlowMovingDevice);

    function IfcFlowMovingDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1487;

      _classCallCheck2(this, IfcFlowMovingDevice);

      _this1487 = _super1495.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1487.GlobalId = GlobalId;
      _this1487.OwnerHistory = OwnerHistory;
      _this1487.Name = Name;
      _this1487.Description = Description;
      _this1487.ObjectType = ObjectType;
      _this1487.ObjectPlacement = ObjectPlacement;
      _this1487.Representation = Representation;
      _this1487.Tag = Tag;
      _this1487.type = 3132237377;
      return _this1487;
    }

    return IfcFlowMovingDevice;
  }(IfcDistributionFlowElement);

  IFC4_32.IfcFlowMovingDevice = IfcFlowMovingDevice;

  var IfcFlowSegment = /*#__PURE__*/function (_IfcDistributionFlowE32) {
    _inherits(IfcFlowSegment, _IfcDistributionFlowE32);

    var _super1496 = _createSuper(IfcFlowSegment);

    function IfcFlowSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1488;

      _classCallCheck2(this, IfcFlowSegment);

      _this1488 = _super1496.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1488.GlobalId = GlobalId;
      _this1488.OwnerHistory = OwnerHistory;
      _this1488.Name = Name;
      _this1488.Description = Description;
      _this1488.ObjectType = ObjectType;
      _this1488.ObjectPlacement = ObjectPlacement;
      _this1488.Representation = Representation;
      _this1488.Tag = Tag;
      _this1488.type = 987401354;
      return _this1488;
    }

    return IfcFlowSegment;
  }(IfcDistributionFlowElement);

  IFC4_32.IfcFlowSegment = IfcFlowSegment;

  var IfcFlowStorageDevice = /*#__PURE__*/function (_IfcDistributionFlowE33) {
    _inherits(IfcFlowStorageDevice, _IfcDistributionFlowE33);

    var _super1497 = _createSuper(IfcFlowStorageDevice);

    function IfcFlowStorageDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1489;

      _classCallCheck2(this, IfcFlowStorageDevice);

      _this1489 = _super1497.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1489.GlobalId = GlobalId;
      _this1489.OwnerHistory = OwnerHistory;
      _this1489.Name = Name;
      _this1489.Description = Description;
      _this1489.ObjectType = ObjectType;
      _this1489.ObjectPlacement = ObjectPlacement;
      _this1489.Representation = Representation;
      _this1489.Tag = Tag;
      _this1489.type = 707683696;
      return _this1489;
    }

    return IfcFlowStorageDevice;
  }(IfcDistributionFlowElement);

  IFC4_32.IfcFlowStorageDevice = IfcFlowStorageDevice;

  var IfcFlowTerminal = /*#__PURE__*/function (_IfcDistributionFlowE34) {
    _inherits(IfcFlowTerminal, _IfcDistributionFlowE34);

    var _super1498 = _createSuper(IfcFlowTerminal);

    function IfcFlowTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1490;

      _classCallCheck2(this, IfcFlowTerminal);

      _this1490 = _super1498.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1490.GlobalId = GlobalId;
      _this1490.OwnerHistory = OwnerHistory;
      _this1490.Name = Name;
      _this1490.Description = Description;
      _this1490.ObjectType = ObjectType;
      _this1490.ObjectPlacement = ObjectPlacement;
      _this1490.Representation = Representation;
      _this1490.Tag = Tag;
      _this1490.type = 2223149337;
      return _this1490;
    }

    return IfcFlowTerminal;
  }(IfcDistributionFlowElement);

  IFC4_32.IfcFlowTerminal = IfcFlowTerminal;

  var IfcFlowTreatmentDevice = /*#__PURE__*/function (_IfcDistributionFlowE35) {
    _inherits(IfcFlowTreatmentDevice, _IfcDistributionFlowE35);

    var _super1499 = _createSuper(IfcFlowTreatmentDevice);

    function IfcFlowTreatmentDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1491;

      _classCallCheck2(this, IfcFlowTreatmentDevice);

      _this1491 = _super1499.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1491.GlobalId = GlobalId;
      _this1491.OwnerHistory = OwnerHistory;
      _this1491.Name = Name;
      _this1491.Description = Description;
      _this1491.ObjectType = ObjectType;
      _this1491.ObjectPlacement = ObjectPlacement;
      _this1491.Representation = Representation;
      _this1491.Tag = Tag;
      _this1491.type = 3508470533;
      return _this1491;
    }

    return IfcFlowTreatmentDevice;
  }(IfcDistributionFlowElement);

  IFC4_32.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;

  var IfcFooting = /*#__PURE__*/function (_IfcBuiltElement9) {
    _inherits(IfcFooting, _IfcBuiltElement9);

    var _super1500 = _createSuper(IfcFooting);

    function IfcFooting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1492;

      _classCallCheck2(this, IfcFooting);

      _this1492 = _super1500.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1492.GlobalId = GlobalId;
      _this1492.OwnerHistory = OwnerHistory;
      _this1492.Name = Name;
      _this1492.Description = Description;
      _this1492.ObjectType = ObjectType;
      _this1492.ObjectPlacement = ObjectPlacement;
      _this1492.Representation = Representation;
      _this1492.Tag = Tag;
      _this1492.PredefinedType = PredefinedType;
      _this1492.type = 900683007;
      return _this1492;
    }

    return IfcFooting;
  }(IfcBuiltElement);

  IFC4_32.IfcFooting = IfcFooting;

  var IfcGeotechnicalAssembly = /*#__PURE__*/function (_IfcGeotechnicalEleme2) {
    _inherits(IfcGeotechnicalAssembly, _IfcGeotechnicalEleme2);

    var _super1501 = _createSuper(IfcGeotechnicalAssembly);

    function IfcGeotechnicalAssembly(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1493;

      _classCallCheck2(this, IfcGeotechnicalAssembly);

      _this1493 = _super1501.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1493.GlobalId = GlobalId;
      _this1493.OwnerHistory = OwnerHistory;
      _this1493.Name = Name;
      _this1493.Description = Description;
      _this1493.ObjectType = ObjectType;
      _this1493.ObjectPlacement = ObjectPlacement;
      _this1493.Representation = Representation;
      _this1493.Tag = Tag;
      _this1493.type = 2713699986;
      return _this1493;
    }

    return IfcGeotechnicalAssembly;
  }(IfcGeotechnicalElement);

  IFC4_32.IfcGeotechnicalAssembly = IfcGeotechnicalAssembly;

  var IfcGrid = /*#__PURE__*/function (_IfcPositioningElemen2) {
    _inherits(IfcGrid, _IfcPositioningElemen2);

    var _super1502 = _createSuper(IfcGrid);

    function IfcGrid(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes, PredefinedType) {
      var _this1494;

      _classCallCheck2(this, IfcGrid);

      _this1494 = _super1502.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1494.GlobalId = GlobalId;
      _this1494.OwnerHistory = OwnerHistory;
      _this1494.Name = Name;
      _this1494.Description = Description;
      _this1494.ObjectType = ObjectType;
      _this1494.ObjectPlacement = ObjectPlacement;
      _this1494.Representation = Representation;
      _this1494.UAxes = UAxes;
      _this1494.VAxes = VAxes;
      _this1494.WAxes = WAxes;
      _this1494.PredefinedType = PredefinedType;
      _this1494.type = 3009204131;
      return _this1494;
    }

    return IfcGrid;
  }(IfcPositioningElement);

  IFC4_32.IfcGrid = IfcGrid;

  var IfcHeatExchanger = /*#__PURE__*/function (_IfcEnergyConversionD42) {
    _inherits(IfcHeatExchanger, _IfcEnergyConversionD42);

    var _super1503 = _createSuper(IfcHeatExchanger);

    function IfcHeatExchanger(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1495;

      _classCallCheck2(this, IfcHeatExchanger);

      _this1495 = _super1503.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1495.GlobalId = GlobalId;
      _this1495.OwnerHistory = OwnerHistory;
      _this1495.Name = Name;
      _this1495.Description = Description;
      _this1495.ObjectType = ObjectType;
      _this1495.ObjectPlacement = ObjectPlacement;
      _this1495.Representation = Representation;
      _this1495.Tag = Tag;
      _this1495.PredefinedType = PredefinedType;
      _this1495.type = 3319311131;
      return _this1495;
    }

    return IfcHeatExchanger;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcHeatExchanger = IfcHeatExchanger;

  var IfcHumidifier = /*#__PURE__*/function (_IfcEnergyConversionD43) {
    _inherits(IfcHumidifier, _IfcEnergyConversionD43);

    var _super1504 = _createSuper(IfcHumidifier);

    function IfcHumidifier(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1496;

      _classCallCheck2(this, IfcHumidifier);

      _this1496 = _super1504.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1496.GlobalId = GlobalId;
      _this1496.OwnerHistory = OwnerHistory;
      _this1496.Name = Name;
      _this1496.Description = Description;
      _this1496.ObjectType = ObjectType;
      _this1496.ObjectPlacement = ObjectPlacement;
      _this1496.Representation = Representation;
      _this1496.Tag = Tag;
      _this1496.PredefinedType = PredefinedType;
      _this1496.type = 2068733104;
      return _this1496;
    }

    return IfcHumidifier;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcHumidifier = IfcHumidifier;

  var IfcInterceptor = /*#__PURE__*/function (_IfcFlowTreatmentDevi7) {
    _inherits(IfcInterceptor, _IfcFlowTreatmentDevi7);

    var _super1505 = _createSuper(IfcInterceptor);

    function IfcInterceptor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1497;

      _classCallCheck2(this, IfcInterceptor);

      _this1497 = _super1505.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1497.GlobalId = GlobalId;
      _this1497.OwnerHistory = OwnerHistory;
      _this1497.Name = Name;
      _this1497.Description = Description;
      _this1497.ObjectType = ObjectType;
      _this1497.ObjectPlacement = ObjectPlacement;
      _this1497.Representation = Representation;
      _this1497.Tag = Tag;
      _this1497.PredefinedType = PredefinedType;
      _this1497.type = 4175244083;
      return _this1497;
    }

    return IfcInterceptor;
  }(IfcFlowTreatmentDevice);

  IFC4_32.IfcInterceptor = IfcInterceptor;

  var IfcJunctionBox = /*#__PURE__*/function (_IfcFlowFitting) {
    _inherits(IfcJunctionBox, _IfcFlowFitting);

    var _super1506 = _createSuper(IfcJunctionBox);

    function IfcJunctionBox(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1498;

      _classCallCheck2(this, IfcJunctionBox);

      _this1498 = _super1506.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1498.GlobalId = GlobalId;
      _this1498.OwnerHistory = OwnerHistory;
      _this1498.Name = Name;
      _this1498.Description = Description;
      _this1498.ObjectType = ObjectType;
      _this1498.ObjectPlacement = ObjectPlacement;
      _this1498.Representation = Representation;
      _this1498.Tag = Tag;
      _this1498.PredefinedType = PredefinedType;
      _this1498.type = 2176052936;
      return _this1498;
    }

    return IfcJunctionBox;
  }(IfcFlowFitting);

  IFC4_32.IfcJunctionBox = IfcJunctionBox;

  var IfcKerb = /*#__PURE__*/function (_IfcBuiltElement10) {
    _inherits(IfcKerb, _IfcBuiltElement10);

    var _super1507 = _createSuper(IfcKerb);

    function IfcKerb(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, Mountable) {
      var _this1499;

      _classCallCheck2(this, IfcKerb);

      _this1499 = _super1507.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1499.GlobalId = GlobalId;
      _this1499.OwnerHistory = OwnerHistory;
      _this1499.Name = Name;
      _this1499.Description = Description;
      _this1499.ObjectType = ObjectType;
      _this1499.ObjectPlacement = ObjectPlacement;
      _this1499.Representation = Representation;
      _this1499.Tag = Tag;
      _this1499.Mountable = Mountable;
      _this1499.type = 2696325953;
      return _this1499;
    }

    return IfcKerb;
  }(IfcBuiltElement);

  IFC4_32.IfcKerb = IfcKerb;

  var IfcLamp = /*#__PURE__*/function (_IfcFlowTerminal) {
    _inherits(IfcLamp, _IfcFlowTerminal);

    var _super1508 = _createSuper(IfcLamp);

    function IfcLamp(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1500;

      _classCallCheck2(this, IfcLamp);

      _this1500 = _super1508.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1500.GlobalId = GlobalId;
      _this1500.OwnerHistory = OwnerHistory;
      _this1500.Name = Name;
      _this1500.Description = Description;
      _this1500.ObjectType = ObjectType;
      _this1500.ObjectPlacement = ObjectPlacement;
      _this1500.Representation = Representation;
      _this1500.Tag = Tag;
      _this1500.PredefinedType = PredefinedType;
      _this1500.type = 76236018;
      return _this1500;
    }

    return IfcLamp;
  }(IfcFlowTerminal);

  IFC4_32.IfcLamp = IfcLamp;

  var IfcLightFixture = /*#__PURE__*/function (_IfcFlowTerminal2) {
    _inherits(IfcLightFixture, _IfcFlowTerminal2);

    var _super1509 = _createSuper(IfcLightFixture);

    function IfcLightFixture(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1501;

      _classCallCheck2(this, IfcLightFixture);

      _this1501 = _super1509.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1501.GlobalId = GlobalId;
      _this1501.OwnerHistory = OwnerHistory;
      _this1501.Name = Name;
      _this1501.Description = Description;
      _this1501.ObjectType = ObjectType;
      _this1501.ObjectPlacement = ObjectPlacement;
      _this1501.Representation = Representation;
      _this1501.Tag = Tag;
      _this1501.PredefinedType = PredefinedType;
      _this1501.type = 629592764;
      return _this1501;
    }

    return IfcLightFixture;
  }(IfcFlowTerminal);

  IFC4_32.IfcLightFixture = IfcLightFixture;

  var IfcLinearPositioningElement = /*#__PURE__*/function (_IfcPositioningElemen3) {
    _inherits(IfcLinearPositioningElement, _IfcPositioningElemen3);

    var _super1510 = _createSuper(IfcLinearPositioningElement);

    function IfcLinearPositioningElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this1502;

      _classCallCheck2(this, IfcLinearPositioningElement);

      _this1502 = _super1510.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1502.GlobalId = GlobalId;
      _this1502.OwnerHistory = OwnerHistory;
      _this1502.Name = Name;
      _this1502.Description = Description;
      _this1502.ObjectType = ObjectType;
      _this1502.ObjectPlacement = ObjectPlacement;
      _this1502.Representation = Representation;
      _this1502.type = 1154579445;
      return _this1502;
    }

    return IfcLinearPositioningElement;
  }(IfcPositioningElement);

  IFC4_32.IfcLinearPositioningElement = IfcLinearPositioningElement;

  var IfcLiquidTerminal = /*#__PURE__*/function (_IfcFlowTerminal3) {
    _inherits(IfcLiquidTerminal, _IfcFlowTerminal3);

    var _super1511 = _createSuper(IfcLiquidTerminal);

    function IfcLiquidTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1503;

      _classCallCheck2(this, IfcLiquidTerminal);

      _this1503 = _super1511.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1503.GlobalId = GlobalId;
      _this1503.OwnerHistory = OwnerHistory;
      _this1503.Name = Name;
      _this1503.Description = Description;
      _this1503.ObjectType = ObjectType;
      _this1503.ObjectPlacement = ObjectPlacement;
      _this1503.Representation = Representation;
      _this1503.Tag = Tag;
      _this1503.PredefinedType = PredefinedType;
      _this1503.type = 1638804497;
      return _this1503;
    }

    return IfcLiquidTerminal;
  }(IfcFlowTerminal);

  IFC4_32.IfcLiquidTerminal = IfcLiquidTerminal;

  var IfcMedicalDevice = /*#__PURE__*/function (_IfcFlowTerminal4) {
    _inherits(IfcMedicalDevice, _IfcFlowTerminal4);

    var _super1512 = _createSuper(IfcMedicalDevice);

    function IfcMedicalDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1504;

      _classCallCheck2(this, IfcMedicalDevice);

      _this1504 = _super1512.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1504.GlobalId = GlobalId;
      _this1504.OwnerHistory = OwnerHistory;
      _this1504.Name = Name;
      _this1504.Description = Description;
      _this1504.ObjectType = ObjectType;
      _this1504.ObjectPlacement = ObjectPlacement;
      _this1504.Representation = Representation;
      _this1504.Tag = Tag;
      _this1504.PredefinedType = PredefinedType;
      _this1504.type = 1437502449;
      return _this1504;
    }

    return IfcMedicalDevice;
  }(IfcFlowTerminal);

  IFC4_32.IfcMedicalDevice = IfcMedicalDevice;

  var IfcMember = /*#__PURE__*/function (_IfcBuiltElement11) {
    _inherits(IfcMember, _IfcBuiltElement11);

    var _super1513 = _createSuper(IfcMember);

    function IfcMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1505;

      _classCallCheck2(this, IfcMember);

      _this1505 = _super1513.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1505.GlobalId = GlobalId;
      _this1505.OwnerHistory = OwnerHistory;
      _this1505.Name = Name;
      _this1505.Description = Description;
      _this1505.ObjectType = ObjectType;
      _this1505.ObjectPlacement = ObjectPlacement;
      _this1505.Representation = Representation;
      _this1505.Tag = Tag;
      _this1505.PredefinedType = PredefinedType;
      _this1505.type = 1073191201;
      return _this1505;
    }

    return IfcMember;
  }(IfcBuiltElement);

  IFC4_32.IfcMember = IfcMember;

  var IfcMobileTelecommunicationsAppliance = /*#__PURE__*/function (_IfcFlowTerminal5) {
    _inherits(IfcMobileTelecommunicationsAppliance, _IfcFlowTerminal5);

    var _super1514 = _createSuper(IfcMobileTelecommunicationsAppliance);

    function IfcMobileTelecommunicationsAppliance(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1506;

      _classCallCheck2(this, IfcMobileTelecommunicationsAppliance);

      _this1506 = _super1514.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1506.GlobalId = GlobalId;
      _this1506.OwnerHistory = OwnerHistory;
      _this1506.Name = Name;
      _this1506.Description = Description;
      _this1506.ObjectType = ObjectType;
      _this1506.ObjectPlacement = ObjectPlacement;
      _this1506.Representation = Representation;
      _this1506.Tag = Tag;
      _this1506.PredefinedType = PredefinedType;
      _this1506.type = 2078563270;
      return _this1506;
    }

    return IfcMobileTelecommunicationsAppliance;
  }(IfcFlowTerminal);

  IFC4_32.IfcMobileTelecommunicationsAppliance = IfcMobileTelecommunicationsAppliance;

  var IfcMooringDevice = /*#__PURE__*/function (_IfcBuiltElement12) {
    _inherits(IfcMooringDevice, _IfcBuiltElement12);

    var _super1515 = _createSuper(IfcMooringDevice);

    function IfcMooringDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1507;

      _classCallCheck2(this, IfcMooringDevice);

      _this1507 = _super1515.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1507.GlobalId = GlobalId;
      _this1507.OwnerHistory = OwnerHistory;
      _this1507.Name = Name;
      _this1507.Description = Description;
      _this1507.ObjectType = ObjectType;
      _this1507.ObjectPlacement = ObjectPlacement;
      _this1507.Representation = Representation;
      _this1507.Tag = Tag;
      _this1507.PredefinedType = PredefinedType;
      _this1507.type = 234836483;
      return _this1507;
    }

    return IfcMooringDevice;
  }(IfcBuiltElement);

  IFC4_32.IfcMooringDevice = IfcMooringDevice;

  var IfcMotorConnection = /*#__PURE__*/function (_IfcEnergyConversionD44) {
    _inherits(IfcMotorConnection, _IfcEnergyConversionD44);

    var _super1516 = _createSuper(IfcMotorConnection);

    function IfcMotorConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1508;

      _classCallCheck2(this, IfcMotorConnection);

      _this1508 = _super1516.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1508.GlobalId = GlobalId;
      _this1508.OwnerHistory = OwnerHistory;
      _this1508.Name = Name;
      _this1508.Description = Description;
      _this1508.ObjectType = ObjectType;
      _this1508.ObjectPlacement = ObjectPlacement;
      _this1508.Representation = Representation;
      _this1508.Tag = Tag;
      _this1508.PredefinedType = PredefinedType;
      _this1508.type = 2474470126;
      return _this1508;
    }

    return IfcMotorConnection;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcMotorConnection = IfcMotorConnection;

  var IfcNavigationElement = /*#__PURE__*/function (_IfcBuiltElement13) {
    _inherits(IfcNavigationElement, _IfcBuiltElement13);

    var _super1517 = _createSuper(IfcNavigationElement);

    function IfcNavigationElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1509;

      _classCallCheck2(this, IfcNavigationElement);

      _this1509 = _super1517.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1509.GlobalId = GlobalId;
      _this1509.OwnerHistory = OwnerHistory;
      _this1509.Name = Name;
      _this1509.Description = Description;
      _this1509.ObjectType = ObjectType;
      _this1509.ObjectPlacement = ObjectPlacement;
      _this1509.Representation = Representation;
      _this1509.Tag = Tag;
      _this1509.PredefinedType = PredefinedType;
      _this1509.type = 2182337498;
      return _this1509;
    }

    return IfcNavigationElement;
  }(IfcBuiltElement);

  IFC4_32.IfcNavigationElement = IfcNavigationElement;

  var IfcOuterBoundaryCurve = /*#__PURE__*/function (_IfcBoundaryCurve) {
    _inherits(IfcOuterBoundaryCurve, _IfcBoundaryCurve);

    var _super1518 = _createSuper(IfcOuterBoundaryCurve);

    function IfcOuterBoundaryCurve(expressID, Segments, SelfIntersect) {
      var _this1510;

      _classCallCheck2(this, IfcOuterBoundaryCurve);

      _this1510 = _super1518.call(this, expressID, Segments, SelfIntersect);
      _this1510.Segments = Segments;
      _this1510.SelfIntersect = SelfIntersect;
      _this1510.type = 144952367;
      return _this1510;
    }

    return IfcOuterBoundaryCurve;
  }(IfcBoundaryCurve);

  IFC4_32.IfcOuterBoundaryCurve = IfcOuterBoundaryCurve;

  var IfcOutlet = /*#__PURE__*/function (_IfcFlowTerminal6) {
    _inherits(IfcOutlet, _IfcFlowTerminal6);

    var _super1519 = _createSuper(IfcOutlet);

    function IfcOutlet(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1511;

      _classCallCheck2(this, IfcOutlet);

      _this1511 = _super1519.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1511.GlobalId = GlobalId;
      _this1511.OwnerHistory = OwnerHistory;
      _this1511.Name = Name;
      _this1511.Description = Description;
      _this1511.ObjectType = ObjectType;
      _this1511.ObjectPlacement = ObjectPlacement;
      _this1511.Representation = Representation;
      _this1511.Tag = Tag;
      _this1511.PredefinedType = PredefinedType;
      _this1511.type = 3694346114;
      return _this1511;
    }

    return IfcOutlet;
  }(IfcFlowTerminal);

  IFC4_32.IfcOutlet = IfcOutlet;

  var IfcPavement = /*#__PURE__*/function (_IfcBuiltElement14) {
    _inherits(IfcPavement, _IfcBuiltElement14);

    var _super1520 = _createSuper(IfcPavement);

    function IfcPavement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1512;

      _classCallCheck2(this, IfcPavement);

      _this1512 = _super1520.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1512.GlobalId = GlobalId;
      _this1512.OwnerHistory = OwnerHistory;
      _this1512.Name = Name;
      _this1512.Description = Description;
      _this1512.ObjectType = ObjectType;
      _this1512.ObjectPlacement = ObjectPlacement;
      _this1512.Representation = Representation;
      _this1512.Tag = Tag;
      _this1512.PredefinedType = PredefinedType;
      _this1512.type = 1383356374;
      return _this1512;
    }

    return IfcPavement;
  }(IfcBuiltElement);

  IFC4_32.IfcPavement = IfcPavement;

  var IfcPile = /*#__PURE__*/function (_IfcDeepFoundation) {
    _inherits(IfcPile, _IfcDeepFoundation);

    var _super1521 = _createSuper(IfcPile);

    function IfcPile(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType) {
      var _this1513;

      _classCallCheck2(this, IfcPile);

      _this1513 = _super1521.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1513.GlobalId = GlobalId;
      _this1513.OwnerHistory = OwnerHistory;
      _this1513.Name = Name;
      _this1513.Description = Description;
      _this1513.ObjectType = ObjectType;
      _this1513.ObjectPlacement = ObjectPlacement;
      _this1513.Representation = Representation;
      _this1513.Tag = Tag;
      _this1513.PredefinedType = PredefinedType;
      _this1513.ConstructionType = ConstructionType;
      _this1513.type = 1687234759;
      return _this1513;
    }

    return IfcPile;
  }(IfcDeepFoundation);

  IFC4_32.IfcPile = IfcPile;

  var IfcPipeFitting = /*#__PURE__*/function (_IfcFlowFitting2) {
    _inherits(IfcPipeFitting, _IfcFlowFitting2);

    var _super1522 = _createSuper(IfcPipeFitting);

    function IfcPipeFitting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1514;

      _classCallCheck2(this, IfcPipeFitting);

      _this1514 = _super1522.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1514.GlobalId = GlobalId;
      _this1514.OwnerHistory = OwnerHistory;
      _this1514.Name = Name;
      _this1514.Description = Description;
      _this1514.ObjectType = ObjectType;
      _this1514.ObjectPlacement = ObjectPlacement;
      _this1514.Representation = Representation;
      _this1514.Tag = Tag;
      _this1514.PredefinedType = PredefinedType;
      _this1514.type = 310824031;
      return _this1514;
    }

    return IfcPipeFitting;
  }(IfcFlowFitting);

  IFC4_32.IfcPipeFitting = IfcPipeFitting;

  var IfcPipeSegment = /*#__PURE__*/function (_IfcFlowSegment) {
    _inherits(IfcPipeSegment, _IfcFlowSegment);

    var _super1523 = _createSuper(IfcPipeSegment);

    function IfcPipeSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1515;

      _classCallCheck2(this, IfcPipeSegment);

      _this1515 = _super1523.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1515.GlobalId = GlobalId;
      _this1515.OwnerHistory = OwnerHistory;
      _this1515.Name = Name;
      _this1515.Description = Description;
      _this1515.ObjectType = ObjectType;
      _this1515.ObjectPlacement = ObjectPlacement;
      _this1515.Representation = Representation;
      _this1515.Tag = Tag;
      _this1515.PredefinedType = PredefinedType;
      _this1515.type = 3612865200;
      return _this1515;
    }

    return IfcPipeSegment;
  }(IfcFlowSegment);

  IFC4_32.IfcPipeSegment = IfcPipeSegment;

  var IfcPlate = /*#__PURE__*/function (_IfcBuiltElement15) {
    _inherits(IfcPlate, _IfcBuiltElement15);

    var _super1524 = _createSuper(IfcPlate);

    function IfcPlate(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1516;

      _classCallCheck2(this, IfcPlate);

      _this1516 = _super1524.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1516.GlobalId = GlobalId;
      _this1516.OwnerHistory = OwnerHistory;
      _this1516.Name = Name;
      _this1516.Description = Description;
      _this1516.ObjectType = ObjectType;
      _this1516.ObjectPlacement = ObjectPlacement;
      _this1516.Representation = Representation;
      _this1516.Tag = Tag;
      _this1516.PredefinedType = PredefinedType;
      _this1516.type = 3171933400;
      return _this1516;
    }

    return IfcPlate;
  }(IfcBuiltElement);

  IFC4_32.IfcPlate = IfcPlate;

  var IfcProtectiveDevice = /*#__PURE__*/function (_IfcFlowController3) {
    _inherits(IfcProtectiveDevice, _IfcFlowController3);

    var _super1525 = _createSuper(IfcProtectiveDevice);

    function IfcProtectiveDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1517;

      _classCallCheck2(this, IfcProtectiveDevice);

      _this1517 = _super1525.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1517.GlobalId = GlobalId;
      _this1517.OwnerHistory = OwnerHistory;
      _this1517.Name = Name;
      _this1517.Description = Description;
      _this1517.ObjectType = ObjectType;
      _this1517.ObjectPlacement = ObjectPlacement;
      _this1517.Representation = Representation;
      _this1517.Tag = Tag;
      _this1517.PredefinedType = PredefinedType;
      _this1517.type = 738039164;
      return _this1517;
    }

    return IfcProtectiveDevice;
  }(IfcFlowController);

  IFC4_32.IfcProtectiveDevice = IfcProtectiveDevice;

  var IfcProtectiveDeviceTrippingUnitType = /*#__PURE__*/function (_IfcDistributionContr7) {
    _inherits(IfcProtectiveDeviceTrippingUnitType, _IfcDistributionContr7);

    var _super1526 = _createSuper(IfcProtectiveDeviceTrippingUnitType);

    function IfcProtectiveDeviceTrippingUnitType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1518;

      _classCallCheck2(this, IfcProtectiveDeviceTrippingUnitType);

      _this1518 = _super1526.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1518.GlobalId = GlobalId;
      _this1518.OwnerHistory = OwnerHistory;
      _this1518.Name = Name;
      _this1518.Description = Description;
      _this1518.ApplicableOccurrence = ApplicableOccurrence;
      _this1518.HasPropertySets = HasPropertySets;
      _this1518.RepresentationMaps = RepresentationMaps;
      _this1518.Tag = Tag;
      _this1518.ElementType = ElementType;
      _this1518.PredefinedType = PredefinedType;
      _this1518.type = 655969474;
      return _this1518;
    }

    return IfcProtectiveDeviceTrippingUnitType;
  }(IfcDistributionControlElementType);

  IFC4_32.IfcProtectiveDeviceTrippingUnitType = IfcProtectiveDeviceTrippingUnitType;

  var IfcPump = /*#__PURE__*/function (_IfcFlowMovingDevice) {
    _inherits(IfcPump, _IfcFlowMovingDevice);

    var _super1527 = _createSuper(IfcPump);

    function IfcPump(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1519;

      _classCallCheck2(this, IfcPump);

      _this1519 = _super1527.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1519.GlobalId = GlobalId;
      _this1519.OwnerHistory = OwnerHistory;
      _this1519.Name = Name;
      _this1519.Description = Description;
      _this1519.ObjectType = ObjectType;
      _this1519.ObjectPlacement = ObjectPlacement;
      _this1519.Representation = Representation;
      _this1519.Tag = Tag;
      _this1519.PredefinedType = PredefinedType;
      _this1519.type = 90941305;
      return _this1519;
    }

    return IfcPump;
  }(IfcFlowMovingDevice);

  IFC4_32.IfcPump = IfcPump;

  var IfcRail = /*#__PURE__*/function (_IfcBuiltElement16) {
    _inherits(IfcRail, _IfcBuiltElement16);

    var _super1528 = _createSuper(IfcRail);

    function IfcRail(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1520;

      _classCallCheck2(this, IfcRail);

      _this1520 = _super1528.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1520.GlobalId = GlobalId;
      _this1520.OwnerHistory = OwnerHistory;
      _this1520.Name = Name;
      _this1520.Description = Description;
      _this1520.ObjectType = ObjectType;
      _this1520.ObjectPlacement = ObjectPlacement;
      _this1520.Representation = Representation;
      _this1520.Tag = Tag;
      _this1520.PredefinedType = PredefinedType;
      _this1520.type = 3290496277;
      return _this1520;
    }

    return IfcRail;
  }(IfcBuiltElement);

  IFC4_32.IfcRail = IfcRail;

  var IfcRailing = /*#__PURE__*/function (_IfcBuiltElement17) {
    _inherits(IfcRailing, _IfcBuiltElement17);

    var _super1529 = _createSuper(IfcRailing);

    function IfcRailing(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1521;

      _classCallCheck2(this, IfcRailing);

      _this1521 = _super1529.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1521.GlobalId = GlobalId;
      _this1521.OwnerHistory = OwnerHistory;
      _this1521.Name = Name;
      _this1521.Description = Description;
      _this1521.ObjectType = ObjectType;
      _this1521.ObjectPlacement = ObjectPlacement;
      _this1521.Representation = Representation;
      _this1521.Tag = Tag;
      _this1521.PredefinedType = PredefinedType;
      _this1521.type = 2262370178;
      return _this1521;
    }

    return IfcRailing;
  }(IfcBuiltElement);

  IFC4_32.IfcRailing = IfcRailing;

  var IfcRamp = /*#__PURE__*/function (_IfcBuiltElement18) {
    _inherits(IfcRamp, _IfcBuiltElement18);

    var _super1530 = _createSuper(IfcRamp);

    function IfcRamp(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1522;

      _classCallCheck2(this, IfcRamp);

      _this1522 = _super1530.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1522.GlobalId = GlobalId;
      _this1522.OwnerHistory = OwnerHistory;
      _this1522.Name = Name;
      _this1522.Description = Description;
      _this1522.ObjectType = ObjectType;
      _this1522.ObjectPlacement = ObjectPlacement;
      _this1522.Representation = Representation;
      _this1522.Tag = Tag;
      _this1522.PredefinedType = PredefinedType;
      _this1522.type = 3024970846;
      return _this1522;
    }

    return IfcRamp;
  }(IfcBuiltElement);

  IFC4_32.IfcRamp = IfcRamp;

  var IfcRampFlight = /*#__PURE__*/function (_IfcBuiltElement19) {
    _inherits(IfcRampFlight, _IfcBuiltElement19);

    var _super1531 = _createSuper(IfcRampFlight);

    function IfcRampFlight(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1523;

      _classCallCheck2(this, IfcRampFlight);

      _this1523 = _super1531.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1523.GlobalId = GlobalId;
      _this1523.OwnerHistory = OwnerHistory;
      _this1523.Name = Name;
      _this1523.Description = Description;
      _this1523.ObjectType = ObjectType;
      _this1523.ObjectPlacement = ObjectPlacement;
      _this1523.Representation = Representation;
      _this1523.Tag = Tag;
      _this1523.PredefinedType = PredefinedType;
      _this1523.type = 3283111854;
      return _this1523;
    }

    return IfcRampFlight;
  }(IfcBuiltElement);

  IFC4_32.IfcRampFlight = IfcRampFlight;

  var IfcRationalBSplineCurveWithKnots = /*#__PURE__*/function (_IfcBSplineCurveWithK) {
    _inherits(IfcRationalBSplineCurveWithKnots, _IfcBSplineCurveWithK);

    var _super1532 = _createSuper(IfcRationalBSplineCurveWithKnots);

    function IfcRationalBSplineCurveWithKnots(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec, WeightsData) {
      var _this1524;

      _classCallCheck2(this, IfcRationalBSplineCurveWithKnots);

      _this1524 = _super1532.call(this, expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec);
      _this1524.Degree = Degree;
      _this1524.ControlPointsList = ControlPointsList;
      _this1524.CurveForm = CurveForm;
      _this1524.ClosedCurve = ClosedCurve;
      _this1524.SelfIntersect = SelfIntersect;
      _this1524.KnotMultiplicities = KnotMultiplicities;
      _this1524.Knots = Knots;
      _this1524.KnotSpec = KnotSpec;
      _this1524.WeightsData = WeightsData;
      _this1524.type = 1232101972;
      return _this1524;
    }

    return IfcRationalBSplineCurveWithKnots;
  }(IfcBSplineCurveWithKnots);

  IFC4_32.IfcRationalBSplineCurveWithKnots = IfcRationalBSplineCurveWithKnots;

  var IfcReinforcedSoil = /*#__PURE__*/function (_IfcEarthworksElement2) {
    _inherits(IfcReinforcedSoil, _IfcEarthworksElement2);

    var _super1533 = _createSuper(IfcReinforcedSoil);

    function IfcReinforcedSoil(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1525;

      _classCallCheck2(this, IfcReinforcedSoil);

      _this1525 = _super1533.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1525.GlobalId = GlobalId;
      _this1525.OwnerHistory = OwnerHistory;
      _this1525.Name = Name;
      _this1525.Description = Description;
      _this1525.ObjectType = ObjectType;
      _this1525.ObjectPlacement = ObjectPlacement;
      _this1525.Representation = Representation;
      _this1525.Tag = Tag;
      _this1525.PredefinedType = PredefinedType;
      _this1525.type = 3798194928;
      return _this1525;
    }

    return IfcReinforcedSoil;
  }(IfcEarthworksElement);

  IFC4_32.IfcReinforcedSoil = IfcReinforcedSoil;

  var IfcReinforcingBar = /*#__PURE__*/function (_IfcReinforcingElemen13) {
    _inherits(IfcReinforcingBar, _IfcReinforcingElemen13);

    var _super1534 = _createSuper(IfcReinforcingBar);

    function IfcReinforcingBar(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, PredefinedType, BarSurface) {
      var _this1526;

      _classCallCheck2(this, IfcReinforcingBar);

      _this1526 = _super1534.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this1526.GlobalId = GlobalId;
      _this1526.OwnerHistory = OwnerHistory;
      _this1526.Name = Name;
      _this1526.Description = Description;
      _this1526.ObjectType = ObjectType;
      _this1526.ObjectPlacement = ObjectPlacement;
      _this1526.Representation = Representation;
      _this1526.Tag = Tag;
      _this1526.SteelGrade = SteelGrade;
      _this1526.NominalDiameter = NominalDiameter;
      _this1526.CrossSectionArea = CrossSectionArea;
      _this1526.BarLength = BarLength;
      _this1526.PredefinedType = PredefinedType;
      _this1526.BarSurface = BarSurface;
      _this1526.type = 979691226;
      return _this1526;
    }

    return IfcReinforcingBar;
  }(IfcReinforcingElement);

  IFC4_32.IfcReinforcingBar = IfcReinforcingBar;

  var IfcReinforcingBarType = /*#__PURE__*/function (_IfcReinforcingElemen14) {
    _inherits(IfcReinforcingBarType, _IfcReinforcingElemen14);

    var _super1535 = _createSuper(IfcReinforcingBarType);

    function IfcReinforcingBarType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, BarLength, BarSurface, BendingShapeCode, BendingParameters) {
      var _this1527;

      _classCallCheck2(this, IfcReinforcingBarType);

      _this1527 = _super1535.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1527.GlobalId = GlobalId;
      _this1527.OwnerHistory = OwnerHistory;
      _this1527.Name = Name;
      _this1527.Description = Description;
      _this1527.ApplicableOccurrence = ApplicableOccurrence;
      _this1527.HasPropertySets = HasPropertySets;
      _this1527.RepresentationMaps = RepresentationMaps;
      _this1527.Tag = Tag;
      _this1527.ElementType = ElementType;
      _this1527.PredefinedType = PredefinedType;
      _this1527.NominalDiameter = NominalDiameter;
      _this1527.CrossSectionArea = CrossSectionArea;
      _this1527.BarLength = BarLength;
      _this1527.BarSurface = BarSurface;
      _this1527.BendingShapeCode = BendingShapeCode;
      _this1527.BendingParameters = BendingParameters;
      _this1527.type = 2572171363;
      return _this1527;
    }

    return IfcReinforcingBarType;
  }(IfcReinforcingElementType);

  IFC4_32.IfcReinforcingBarType = IfcReinforcingBarType;

  var IfcRoof = /*#__PURE__*/function (_IfcBuiltElement20) {
    _inherits(IfcRoof, _IfcBuiltElement20);

    var _super1536 = _createSuper(IfcRoof);

    function IfcRoof(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1528;

      _classCallCheck2(this, IfcRoof);

      _this1528 = _super1536.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1528.GlobalId = GlobalId;
      _this1528.OwnerHistory = OwnerHistory;
      _this1528.Name = Name;
      _this1528.Description = Description;
      _this1528.ObjectType = ObjectType;
      _this1528.ObjectPlacement = ObjectPlacement;
      _this1528.Representation = Representation;
      _this1528.Tag = Tag;
      _this1528.PredefinedType = PredefinedType;
      _this1528.type = 2016517767;
      return _this1528;
    }

    return IfcRoof;
  }(IfcBuiltElement);

  IFC4_32.IfcRoof = IfcRoof;

  var IfcSanitaryTerminal = /*#__PURE__*/function (_IfcFlowTerminal7) {
    _inherits(IfcSanitaryTerminal, _IfcFlowTerminal7);

    var _super1537 = _createSuper(IfcSanitaryTerminal);

    function IfcSanitaryTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1529;

      _classCallCheck2(this, IfcSanitaryTerminal);

      _this1529 = _super1537.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1529.GlobalId = GlobalId;
      _this1529.OwnerHistory = OwnerHistory;
      _this1529.Name = Name;
      _this1529.Description = Description;
      _this1529.ObjectType = ObjectType;
      _this1529.ObjectPlacement = ObjectPlacement;
      _this1529.Representation = Representation;
      _this1529.Tag = Tag;
      _this1529.PredefinedType = PredefinedType;
      _this1529.type = 3053780830;
      return _this1529;
    }

    return IfcSanitaryTerminal;
  }(IfcFlowTerminal);

  IFC4_32.IfcSanitaryTerminal = IfcSanitaryTerminal;

  var IfcSensorType = /*#__PURE__*/function (_IfcDistributionContr8) {
    _inherits(IfcSensorType, _IfcDistributionContr8);

    var _super1538 = _createSuper(IfcSensorType);

    function IfcSensorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1530;

      _classCallCheck2(this, IfcSensorType);

      _this1530 = _super1538.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1530.GlobalId = GlobalId;
      _this1530.OwnerHistory = OwnerHistory;
      _this1530.Name = Name;
      _this1530.Description = Description;
      _this1530.ApplicableOccurrence = ApplicableOccurrence;
      _this1530.HasPropertySets = HasPropertySets;
      _this1530.RepresentationMaps = RepresentationMaps;
      _this1530.Tag = Tag;
      _this1530.ElementType = ElementType;
      _this1530.PredefinedType = PredefinedType;
      _this1530.type = 1783015770;
      return _this1530;
    }

    return IfcSensorType;
  }(IfcDistributionControlElementType);

  IFC4_32.IfcSensorType = IfcSensorType;

  var IfcShadingDevice = /*#__PURE__*/function (_IfcBuiltElement21) {
    _inherits(IfcShadingDevice, _IfcBuiltElement21);

    var _super1539 = _createSuper(IfcShadingDevice);

    function IfcShadingDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1531;

      _classCallCheck2(this, IfcShadingDevice);

      _this1531 = _super1539.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1531.GlobalId = GlobalId;
      _this1531.OwnerHistory = OwnerHistory;
      _this1531.Name = Name;
      _this1531.Description = Description;
      _this1531.ObjectType = ObjectType;
      _this1531.ObjectPlacement = ObjectPlacement;
      _this1531.Representation = Representation;
      _this1531.Tag = Tag;
      _this1531.PredefinedType = PredefinedType;
      _this1531.type = 1329646415;
      return _this1531;
    }

    return IfcShadingDevice;
  }(IfcBuiltElement);

  IFC4_32.IfcShadingDevice = IfcShadingDevice;

  var IfcSignal = /*#__PURE__*/function (_IfcFlowTerminal8) {
    _inherits(IfcSignal, _IfcFlowTerminal8);

    var _super1540 = _createSuper(IfcSignal);

    function IfcSignal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1532;

      _classCallCheck2(this, IfcSignal);

      _this1532 = _super1540.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1532.GlobalId = GlobalId;
      _this1532.OwnerHistory = OwnerHistory;
      _this1532.Name = Name;
      _this1532.Description = Description;
      _this1532.ObjectType = ObjectType;
      _this1532.ObjectPlacement = ObjectPlacement;
      _this1532.Representation = Representation;
      _this1532.Tag = Tag;
      _this1532.PredefinedType = PredefinedType;
      _this1532.type = 991950508;
      return _this1532;
    }

    return IfcSignal;
  }(IfcFlowTerminal);

  IFC4_32.IfcSignal = IfcSignal;

  var IfcSlab = /*#__PURE__*/function (_IfcBuiltElement22) {
    _inherits(IfcSlab, _IfcBuiltElement22);

    var _super1541 = _createSuper(IfcSlab);

    function IfcSlab(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1533;

      _classCallCheck2(this, IfcSlab);

      _this1533 = _super1541.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1533.GlobalId = GlobalId;
      _this1533.OwnerHistory = OwnerHistory;
      _this1533.Name = Name;
      _this1533.Description = Description;
      _this1533.ObjectType = ObjectType;
      _this1533.ObjectPlacement = ObjectPlacement;
      _this1533.Representation = Representation;
      _this1533.Tag = Tag;
      _this1533.PredefinedType = PredefinedType;
      _this1533.type = 1529196076;
      return _this1533;
    }

    return IfcSlab;
  }(IfcBuiltElement);

  IFC4_32.IfcSlab = IfcSlab;

  var IfcSolarDevice = /*#__PURE__*/function (_IfcEnergyConversionD45) {
    _inherits(IfcSolarDevice, _IfcEnergyConversionD45);

    var _super1542 = _createSuper(IfcSolarDevice);

    function IfcSolarDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1534;

      _classCallCheck2(this, IfcSolarDevice);

      _this1534 = _super1542.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1534.GlobalId = GlobalId;
      _this1534.OwnerHistory = OwnerHistory;
      _this1534.Name = Name;
      _this1534.Description = Description;
      _this1534.ObjectType = ObjectType;
      _this1534.ObjectPlacement = ObjectPlacement;
      _this1534.Representation = Representation;
      _this1534.Tag = Tag;
      _this1534.PredefinedType = PredefinedType;
      _this1534.type = 3420628829;
      return _this1534;
    }

    return IfcSolarDevice;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcSolarDevice = IfcSolarDevice;

  var IfcSpaceHeater = /*#__PURE__*/function (_IfcFlowTerminal9) {
    _inherits(IfcSpaceHeater, _IfcFlowTerminal9);

    var _super1543 = _createSuper(IfcSpaceHeater);

    function IfcSpaceHeater(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1535;

      _classCallCheck2(this, IfcSpaceHeater);

      _this1535 = _super1543.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1535.GlobalId = GlobalId;
      _this1535.OwnerHistory = OwnerHistory;
      _this1535.Name = Name;
      _this1535.Description = Description;
      _this1535.ObjectType = ObjectType;
      _this1535.ObjectPlacement = ObjectPlacement;
      _this1535.Representation = Representation;
      _this1535.Tag = Tag;
      _this1535.PredefinedType = PredefinedType;
      _this1535.type = 1999602285;
      return _this1535;
    }

    return IfcSpaceHeater;
  }(IfcFlowTerminal);

  IFC4_32.IfcSpaceHeater = IfcSpaceHeater;

  var IfcStackTerminal = /*#__PURE__*/function (_IfcFlowTerminal10) {
    _inherits(IfcStackTerminal, _IfcFlowTerminal10);

    var _super1544 = _createSuper(IfcStackTerminal);

    function IfcStackTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1536;

      _classCallCheck2(this, IfcStackTerminal);

      _this1536 = _super1544.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1536.GlobalId = GlobalId;
      _this1536.OwnerHistory = OwnerHistory;
      _this1536.Name = Name;
      _this1536.Description = Description;
      _this1536.ObjectType = ObjectType;
      _this1536.ObjectPlacement = ObjectPlacement;
      _this1536.Representation = Representation;
      _this1536.Tag = Tag;
      _this1536.PredefinedType = PredefinedType;
      _this1536.type = 1404847402;
      return _this1536;
    }

    return IfcStackTerminal;
  }(IfcFlowTerminal);

  IFC4_32.IfcStackTerminal = IfcStackTerminal;

  var IfcStair = /*#__PURE__*/function (_IfcBuiltElement23) {
    _inherits(IfcStair, _IfcBuiltElement23);

    var _super1545 = _createSuper(IfcStair);

    function IfcStair(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1537;

      _classCallCheck2(this, IfcStair);

      _this1537 = _super1545.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1537.GlobalId = GlobalId;
      _this1537.OwnerHistory = OwnerHistory;
      _this1537.Name = Name;
      _this1537.Description = Description;
      _this1537.ObjectType = ObjectType;
      _this1537.ObjectPlacement = ObjectPlacement;
      _this1537.Representation = Representation;
      _this1537.Tag = Tag;
      _this1537.PredefinedType = PredefinedType;
      _this1537.type = 331165859;
      return _this1537;
    }

    return IfcStair;
  }(IfcBuiltElement);

  IFC4_32.IfcStair = IfcStair;

  var IfcStairFlight = /*#__PURE__*/function (_IfcBuiltElement24) {
    _inherits(IfcStairFlight, _IfcBuiltElement24);

    var _super1546 = _createSuper(IfcStairFlight);

    function IfcStairFlight(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRisers, NumberOfTreads, RiserHeight, TreadLength, PredefinedType) {
      var _this1538;

      _classCallCheck2(this, IfcStairFlight);

      _this1538 = _super1546.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1538.GlobalId = GlobalId;
      _this1538.OwnerHistory = OwnerHistory;
      _this1538.Name = Name;
      _this1538.Description = Description;
      _this1538.ObjectType = ObjectType;
      _this1538.ObjectPlacement = ObjectPlacement;
      _this1538.Representation = Representation;
      _this1538.Tag = Tag;
      _this1538.NumberOfRisers = NumberOfRisers;
      _this1538.NumberOfTreads = NumberOfTreads;
      _this1538.RiserHeight = RiserHeight;
      _this1538.TreadLength = TreadLength;
      _this1538.PredefinedType = PredefinedType;
      _this1538.type = 4252922144;
      return _this1538;
    }

    return IfcStairFlight;
  }(IfcBuiltElement);

  IFC4_32.IfcStairFlight = IfcStairFlight;

  var IfcStructuralAnalysisModel = /*#__PURE__*/function (_IfcSystem7) {
    _inherits(IfcStructuralAnalysisModel, _IfcSystem7);

    var _super1547 = _createSuper(IfcStructuralAnalysisModel);

    function IfcStructuralAnalysisModel(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults, SharedPlacement) {
      var _this1539;

      _classCallCheck2(this, IfcStructuralAnalysisModel);

      _this1539 = _super1547.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1539.GlobalId = GlobalId;
      _this1539.OwnerHistory = OwnerHistory;
      _this1539.Name = Name;
      _this1539.Description = Description;
      _this1539.ObjectType = ObjectType;
      _this1539.PredefinedType = PredefinedType;
      _this1539.OrientationOf2DPlane = OrientationOf2DPlane;
      _this1539.LoadedBy = LoadedBy;
      _this1539.HasResults = HasResults;
      _this1539.SharedPlacement = SharedPlacement;
      _this1539.type = 2515109513;
      return _this1539;
    }

    return IfcStructuralAnalysisModel;
  }(IfcSystem);

  IFC4_32.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;

  var IfcStructuralLoadCase = /*#__PURE__*/function (_IfcStructuralLoadGro) {
    _inherits(IfcStructuralLoadCase, _IfcStructuralLoadGro);

    var _super1548 = _createSuper(IfcStructuralLoadCase);

    function IfcStructuralLoadCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose, SelfWeightCoefficients) {
      var _this1540;

      _classCallCheck2(this, IfcStructuralLoadCase);

      _this1540 = _super1548.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose);
      _this1540.GlobalId = GlobalId;
      _this1540.OwnerHistory = OwnerHistory;
      _this1540.Name = Name;
      _this1540.Description = Description;
      _this1540.ObjectType = ObjectType;
      _this1540.PredefinedType = PredefinedType;
      _this1540.ActionType = ActionType;
      _this1540.ActionSource = ActionSource;
      _this1540.Coefficient = Coefficient;
      _this1540.Purpose = Purpose;
      _this1540.SelfWeightCoefficients = SelfWeightCoefficients;
      _this1540.type = 385403989;
      return _this1540;
    }

    return IfcStructuralLoadCase;
  }(IfcStructuralLoadGroup);

  IFC4_32.IfcStructuralLoadCase = IfcStructuralLoadCase;

  var IfcStructuralPlanarAction = /*#__PURE__*/function (_IfcStructuralSurface3) {
    _inherits(IfcStructuralPlanarAction, _IfcStructuralSurface3);

    var _super1549 = _createSuper(IfcStructuralPlanarAction);

    function IfcStructuralPlanarAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      var _this1541;

      _classCallCheck2(this, IfcStructuralPlanarAction);

      _this1541 = _super1549.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      _this1541.GlobalId = GlobalId;
      _this1541.OwnerHistory = OwnerHistory;
      _this1541.Name = Name;
      _this1541.Description = Description;
      _this1541.ObjectType = ObjectType;
      _this1541.ObjectPlacement = ObjectPlacement;
      _this1541.Representation = Representation;
      _this1541.AppliedLoad = AppliedLoad;
      _this1541.GlobalOrLocal = GlobalOrLocal;
      _this1541.DestabilizingLoad = DestabilizingLoad;
      _this1541.ProjectedOrTrue = ProjectedOrTrue;
      _this1541.PredefinedType = PredefinedType;
      _this1541.type = 1621171031;
      return _this1541;
    }

    return IfcStructuralPlanarAction;
  }(IfcStructuralSurfaceAction);

  IFC4_32.IfcStructuralPlanarAction = IfcStructuralPlanarAction;

  var IfcSwitchingDevice = /*#__PURE__*/function (_IfcFlowController4) {
    _inherits(IfcSwitchingDevice, _IfcFlowController4);

    var _super1550 = _createSuper(IfcSwitchingDevice);

    function IfcSwitchingDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1542;

      _classCallCheck2(this, IfcSwitchingDevice);

      _this1542 = _super1550.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1542.GlobalId = GlobalId;
      _this1542.OwnerHistory = OwnerHistory;
      _this1542.Name = Name;
      _this1542.Description = Description;
      _this1542.ObjectType = ObjectType;
      _this1542.ObjectPlacement = ObjectPlacement;
      _this1542.Representation = Representation;
      _this1542.Tag = Tag;
      _this1542.PredefinedType = PredefinedType;
      _this1542.type = 1162798199;
      return _this1542;
    }

    return IfcSwitchingDevice;
  }(IfcFlowController);

  IFC4_32.IfcSwitchingDevice = IfcSwitchingDevice;

  var IfcTank = /*#__PURE__*/function (_IfcFlowStorageDevice5) {
    _inherits(IfcTank, _IfcFlowStorageDevice5);

    var _super1551 = _createSuper(IfcTank);

    function IfcTank(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1543;

      _classCallCheck2(this, IfcTank);

      _this1543 = _super1551.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1543.GlobalId = GlobalId;
      _this1543.OwnerHistory = OwnerHistory;
      _this1543.Name = Name;
      _this1543.Description = Description;
      _this1543.ObjectType = ObjectType;
      _this1543.ObjectPlacement = ObjectPlacement;
      _this1543.Representation = Representation;
      _this1543.Tag = Tag;
      _this1543.PredefinedType = PredefinedType;
      _this1543.type = 812556717;
      return _this1543;
    }

    return IfcTank;
  }(IfcFlowStorageDevice);

  IFC4_32.IfcTank = IfcTank;

  var IfcTrackElement = /*#__PURE__*/function (_IfcBuiltElement25) {
    _inherits(IfcTrackElement, _IfcBuiltElement25);

    var _super1552 = _createSuper(IfcTrackElement);

    function IfcTrackElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1544;

      _classCallCheck2(this, IfcTrackElement);

      _this1544 = _super1552.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1544.GlobalId = GlobalId;
      _this1544.OwnerHistory = OwnerHistory;
      _this1544.Name = Name;
      _this1544.Description = Description;
      _this1544.ObjectType = ObjectType;
      _this1544.ObjectPlacement = ObjectPlacement;
      _this1544.Representation = Representation;
      _this1544.Tag = Tag;
      _this1544.PredefinedType = PredefinedType;
      _this1544.type = 3425753595;
      return _this1544;
    }

    return IfcTrackElement;
  }(IfcBuiltElement);

  IFC4_32.IfcTrackElement = IfcTrackElement;

  var IfcTransformer = /*#__PURE__*/function (_IfcEnergyConversionD46) {
    _inherits(IfcTransformer, _IfcEnergyConversionD46);

    var _super1553 = _createSuper(IfcTransformer);

    function IfcTransformer(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1545;

      _classCallCheck2(this, IfcTransformer);

      _this1545 = _super1553.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1545.GlobalId = GlobalId;
      _this1545.OwnerHistory = OwnerHistory;
      _this1545.Name = Name;
      _this1545.Description = Description;
      _this1545.ObjectType = ObjectType;
      _this1545.ObjectPlacement = ObjectPlacement;
      _this1545.Representation = Representation;
      _this1545.Tag = Tag;
      _this1545.PredefinedType = PredefinedType;
      _this1545.type = 3825984169;
      return _this1545;
    }

    return IfcTransformer;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcTransformer = IfcTransformer;

  var IfcTransportElement = /*#__PURE__*/function (_IfcTransportationDev4) {
    _inherits(IfcTransportElement, _IfcTransportationDev4);

    var _super1554 = _createSuper(IfcTransportElement);

    function IfcTransportElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1546;

      _classCallCheck2(this, IfcTransportElement);

      _this1546 = _super1554.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1546.GlobalId = GlobalId;
      _this1546.OwnerHistory = OwnerHistory;
      _this1546.Name = Name;
      _this1546.Description = Description;
      _this1546.ObjectType = ObjectType;
      _this1546.ObjectPlacement = ObjectPlacement;
      _this1546.Representation = Representation;
      _this1546.Tag = Tag;
      _this1546.PredefinedType = PredefinedType;
      _this1546.type = 1620046519;
      return _this1546;
    }

    return IfcTransportElement;
  }(IfcTransportationDevice);

  IFC4_32.IfcTransportElement = IfcTransportElement;

  var IfcTubeBundle = /*#__PURE__*/function (_IfcEnergyConversionD47) {
    _inherits(IfcTubeBundle, _IfcEnergyConversionD47);

    var _super1555 = _createSuper(IfcTubeBundle);

    function IfcTubeBundle(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1547;

      _classCallCheck2(this, IfcTubeBundle);

      _this1547 = _super1555.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1547.GlobalId = GlobalId;
      _this1547.OwnerHistory = OwnerHistory;
      _this1547.Name = Name;
      _this1547.Description = Description;
      _this1547.ObjectType = ObjectType;
      _this1547.ObjectPlacement = ObjectPlacement;
      _this1547.Representation = Representation;
      _this1547.Tag = Tag;
      _this1547.PredefinedType = PredefinedType;
      _this1547.type = 3026737570;
      return _this1547;
    }

    return IfcTubeBundle;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcTubeBundle = IfcTubeBundle;

  var IfcUnitaryControlElementType = /*#__PURE__*/function (_IfcDistributionContr9) {
    _inherits(IfcUnitaryControlElementType, _IfcDistributionContr9);

    var _super1556 = _createSuper(IfcUnitaryControlElementType);

    function IfcUnitaryControlElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1548;

      _classCallCheck2(this, IfcUnitaryControlElementType);

      _this1548 = _super1556.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1548.GlobalId = GlobalId;
      _this1548.OwnerHistory = OwnerHistory;
      _this1548.Name = Name;
      _this1548.Description = Description;
      _this1548.ApplicableOccurrence = ApplicableOccurrence;
      _this1548.HasPropertySets = HasPropertySets;
      _this1548.RepresentationMaps = RepresentationMaps;
      _this1548.Tag = Tag;
      _this1548.ElementType = ElementType;
      _this1548.PredefinedType = PredefinedType;
      _this1548.type = 3179687236;
      return _this1548;
    }

    return IfcUnitaryControlElementType;
  }(IfcDistributionControlElementType);

  IFC4_32.IfcUnitaryControlElementType = IfcUnitaryControlElementType;

  var IfcUnitaryEquipment = /*#__PURE__*/function (_IfcEnergyConversionD48) {
    _inherits(IfcUnitaryEquipment, _IfcEnergyConversionD48);

    var _super1557 = _createSuper(IfcUnitaryEquipment);

    function IfcUnitaryEquipment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1549;

      _classCallCheck2(this, IfcUnitaryEquipment);

      _this1549 = _super1557.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1549.GlobalId = GlobalId;
      _this1549.OwnerHistory = OwnerHistory;
      _this1549.Name = Name;
      _this1549.Description = Description;
      _this1549.ObjectType = ObjectType;
      _this1549.ObjectPlacement = ObjectPlacement;
      _this1549.Representation = Representation;
      _this1549.Tag = Tag;
      _this1549.PredefinedType = PredefinedType;
      _this1549.type = 4292641817;
      return _this1549;
    }

    return IfcUnitaryEquipment;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcUnitaryEquipment = IfcUnitaryEquipment;

  var IfcValve = /*#__PURE__*/function (_IfcFlowController5) {
    _inherits(IfcValve, _IfcFlowController5);

    var _super1558 = _createSuper(IfcValve);

    function IfcValve(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1550;

      _classCallCheck2(this, IfcValve);

      _this1550 = _super1558.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1550.GlobalId = GlobalId;
      _this1550.OwnerHistory = OwnerHistory;
      _this1550.Name = Name;
      _this1550.Description = Description;
      _this1550.ObjectType = ObjectType;
      _this1550.ObjectPlacement = ObjectPlacement;
      _this1550.Representation = Representation;
      _this1550.Tag = Tag;
      _this1550.PredefinedType = PredefinedType;
      _this1550.type = 4207607924;
      return _this1550;
    }

    return IfcValve;
  }(IfcFlowController);

  IFC4_32.IfcValve = IfcValve;

  var IfcWall = /*#__PURE__*/function (_IfcBuiltElement26) {
    _inherits(IfcWall, _IfcBuiltElement26);

    var _super1559 = _createSuper(IfcWall);

    function IfcWall(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1551;

      _classCallCheck2(this, IfcWall);

      _this1551 = _super1559.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1551.GlobalId = GlobalId;
      _this1551.OwnerHistory = OwnerHistory;
      _this1551.Name = Name;
      _this1551.Description = Description;
      _this1551.ObjectType = ObjectType;
      _this1551.ObjectPlacement = ObjectPlacement;
      _this1551.Representation = Representation;
      _this1551.Tag = Tag;
      _this1551.PredefinedType = PredefinedType;
      _this1551.type = 2391406946;
      return _this1551;
    }

    return IfcWall;
  }(IfcBuiltElement);

  IFC4_32.IfcWall = IfcWall;

  var IfcWallStandardCase = /*#__PURE__*/function (_IfcWall2) {
    _inherits(IfcWallStandardCase, _IfcWall2);

    var _super1560 = _createSuper(IfcWallStandardCase);

    function IfcWallStandardCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1552;

      _classCallCheck2(this, IfcWallStandardCase);

      _this1552 = _super1560.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      _this1552.GlobalId = GlobalId;
      _this1552.OwnerHistory = OwnerHistory;
      _this1552.Name = Name;
      _this1552.Description = Description;
      _this1552.ObjectType = ObjectType;
      _this1552.ObjectPlacement = ObjectPlacement;
      _this1552.Representation = Representation;
      _this1552.Tag = Tag;
      _this1552.PredefinedType = PredefinedType;
      _this1552.type = 3512223829;
      return _this1552;
    }

    return IfcWallStandardCase;
  }(IfcWall);

  IFC4_32.IfcWallStandardCase = IfcWallStandardCase;

  var IfcWasteTerminal = /*#__PURE__*/function (_IfcFlowTerminal11) {
    _inherits(IfcWasteTerminal, _IfcFlowTerminal11);

    var _super1561 = _createSuper(IfcWasteTerminal);

    function IfcWasteTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1553;

      _classCallCheck2(this, IfcWasteTerminal);

      _this1553 = _super1561.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1553.GlobalId = GlobalId;
      _this1553.OwnerHistory = OwnerHistory;
      _this1553.Name = Name;
      _this1553.Description = Description;
      _this1553.ObjectType = ObjectType;
      _this1553.ObjectPlacement = ObjectPlacement;
      _this1553.Representation = Representation;
      _this1553.Tag = Tag;
      _this1553.PredefinedType = PredefinedType;
      _this1553.type = 4237592921;
      return _this1553;
    }

    return IfcWasteTerminal;
  }(IfcFlowTerminal);

  IFC4_32.IfcWasteTerminal = IfcWasteTerminal;

  var IfcWindow = /*#__PURE__*/function (_IfcBuiltElement27) {
    _inherits(IfcWindow, _IfcBuiltElement27);

    var _super1562 = _createSuper(IfcWindow);

    function IfcWindow(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType) {
      var _this1554;

      _classCallCheck2(this, IfcWindow);

      _this1554 = _super1562.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1554.GlobalId = GlobalId;
      _this1554.OwnerHistory = OwnerHistory;
      _this1554.Name = Name;
      _this1554.Description = Description;
      _this1554.ObjectType = ObjectType;
      _this1554.ObjectPlacement = ObjectPlacement;
      _this1554.Representation = Representation;
      _this1554.Tag = Tag;
      _this1554.OverallHeight = OverallHeight;
      _this1554.OverallWidth = OverallWidth;
      _this1554.PredefinedType = PredefinedType;
      _this1554.PartitioningType = PartitioningType;
      _this1554.UserDefinedPartitioningType = UserDefinedPartitioningType;
      _this1554.type = 3304561284;
      return _this1554;
    }

    return IfcWindow;
  }(IfcBuiltElement);

  IFC4_32.IfcWindow = IfcWindow;

  var IfcActuatorType = /*#__PURE__*/function (_IfcDistributionContr10) {
    _inherits(IfcActuatorType, _IfcDistributionContr10);

    var _super1563 = _createSuper(IfcActuatorType);

    function IfcActuatorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1555;

      _classCallCheck2(this, IfcActuatorType);

      _this1555 = _super1563.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1555.GlobalId = GlobalId;
      _this1555.OwnerHistory = OwnerHistory;
      _this1555.Name = Name;
      _this1555.Description = Description;
      _this1555.ApplicableOccurrence = ApplicableOccurrence;
      _this1555.HasPropertySets = HasPropertySets;
      _this1555.RepresentationMaps = RepresentationMaps;
      _this1555.Tag = Tag;
      _this1555.ElementType = ElementType;
      _this1555.PredefinedType = PredefinedType;
      _this1555.type = 2874132201;
      return _this1555;
    }

    return IfcActuatorType;
  }(IfcDistributionControlElementType);

  IFC4_32.IfcActuatorType = IfcActuatorType;

  var IfcAirTerminal = /*#__PURE__*/function (_IfcFlowTerminal12) {
    _inherits(IfcAirTerminal, _IfcFlowTerminal12);

    var _super1564 = _createSuper(IfcAirTerminal);

    function IfcAirTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1556;

      _classCallCheck2(this, IfcAirTerminal);

      _this1556 = _super1564.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1556.GlobalId = GlobalId;
      _this1556.OwnerHistory = OwnerHistory;
      _this1556.Name = Name;
      _this1556.Description = Description;
      _this1556.ObjectType = ObjectType;
      _this1556.ObjectPlacement = ObjectPlacement;
      _this1556.Representation = Representation;
      _this1556.Tag = Tag;
      _this1556.PredefinedType = PredefinedType;
      _this1556.type = 1634111441;
      return _this1556;
    }

    return IfcAirTerminal;
  }(IfcFlowTerminal);

  IFC4_32.IfcAirTerminal = IfcAirTerminal;

  var IfcAirTerminalBox = /*#__PURE__*/function (_IfcFlowController6) {
    _inherits(IfcAirTerminalBox, _IfcFlowController6);

    var _super1565 = _createSuper(IfcAirTerminalBox);

    function IfcAirTerminalBox(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1557;

      _classCallCheck2(this, IfcAirTerminalBox);

      _this1557 = _super1565.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1557.GlobalId = GlobalId;
      _this1557.OwnerHistory = OwnerHistory;
      _this1557.Name = Name;
      _this1557.Description = Description;
      _this1557.ObjectType = ObjectType;
      _this1557.ObjectPlacement = ObjectPlacement;
      _this1557.Representation = Representation;
      _this1557.Tag = Tag;
      _this1557.PredefinedType = PredefinedType;
      _this1557.type = 177149247;
      return _this1557;
    }

    return IfcAirTerminalBox;
  }(IfcFlowController);

  IFC4_32.IfcAirTerminalBox = IfcAirTerminalBox;

  var IfcAirToAirHeatRecovery = /*#__PURE__*/function (_IfcEnergyConversionD49) {
    _inherits(IfcAirToAirHeatRecovery, _IfcEnergyConversionD49);

    var _super1566 = _createSuper(IfcAirToAirHeatRecovery);

    function IfcAirToAirHeatRecovery(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1558;

      _classCallCheck2(this, IfcAirToAirHeatRecovery);

      _this1558 = _super1566.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1558.GlobalId = GlobalId;
      _this1558.OwnerHistory = OwnerHistory;
      _this1558.Name = Name;
      _this1558.Description = Description;
      _this1558.ObjectType = ObjectType;
      _this1558.ObjectPlacement = ObjectPlacement;
      _this1558.Representation = Representation;
      _this1558.Tag = Tag;
      _this1558.PredefinedType = PredefinedType;
      _this1558.type = 2056796094;
      return _this1558;
    }

    return IfcAirToAirHeatRecovery;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcAirToAirHeatRecovery = IfcAirToAirHeatRecovery;

  var IfcAlarmType = /*#__PURE__*/function (_IfcDistributionContr11) {
    _inherits(IfcAlarmType, _IfcDistributionContr11);

    var _super1567 = _createSuper(IfcAlarmType);

    function IfcAlarmType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1559;

      _classCallCheck2(this, IfcAlarmType);

      _this1559 = _super1567.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1559.GlobalId = GlobalId;
      _this1559.OwnerHistory = OwnerHistory;
      _this1559.Name = Name;
      _this1559.Description = Description;
      _this1559.ApplicableOccurrence = ApplicableOccurrence;
      _this1559.HasPropertySets = HasPropertySets;
      _this1559.RepresentationMaps = RepresentationMaps;
      _this1559.Tag = Tag;
      _this1559.ElementType = ElementType;
      _this1559.PredefinedType = PredefinedType;
      _this1559.type = 3001207471;
      return _this1559;
    }

    return IfcAlarmType;
  }(IfcDistributionControlElementType);

  IFC4_32.IfcAlarmType = IfcAlarmType;

  var IfcAlignment = /*#__PURE__*/function (_IfcLinearPositioning) {
    _inherits(IfcAlignment, _IfcLinearPositioning);

    var _super1568 = _createSuper(IfcAlignment);

    function IfcAlignment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType) {
      var _this1560;

      _classCallCheck2(this, IfcAlignment);

      _this1560 = _super1568.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1560.GlobalId = GlobalId;
      _this1560.OwnerHistory = OwnerHistory;
      _this1560.Name = Name;
      _this1560.Description = Description;
      _this1560.ObjectType = ObjectType;
      _this1560.ObjectPlacement = ObjectPlacement;
      _this1560.Representation = Representation;
      _this1560.PredefinedType = PredefinedType;
      _this1560.type = 325726236;
      return _this1560;
    }

    return IfcAlignment;
  }(IfcLinearPositioningElement);

  IFC4_32.IfcAlignment = IfcAlignment;

  var IfcAudioVisualAppliance = /*#__PURE__*/function (_IfcFlowTerminal13) {
    _inherits(IfcAudioVisualAppliance, _IfcFlowTerminal13);

    var _super1569 = _createSuper(IfcAudioVisualAppliance);

    function IfcAudioVisualAppliance(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1561;

      _classCallCheck2(this, IfcAudioVisualAppliance);

      _this1561 = _super1569.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1561.GlobalId = GlobalId;
      _this1561.OwnerHistory = OwnerHistory;
      _this1561.Name = Name;
      _this1561.Description = Description;
      _this1561.ObjectType = ObjectType;
      _this1561.ObjectPlacement = ObjectPlacement;
      _this1561.Representation = Representation;
      _this1561.Tag = Tag;
      _this1561.PredefinedType = PredefinedType;
      _this1561.type = 277319702;
      return _this1561;
    }

    return IfcAudioVisualAppliance;
  }(IfcFlowTerminal);

  IFC4_32.IfcAudioVisualAppliance = IfcAudioVisualAppliance;

  var IfcBeam = /*#__PURE__*/function (_IfcBuiltElement28) {
    _inherits(IfcBeam, _IfcBuiltElement28);

    var _super1570 = _createSuper(IfcBeam);

    function IfcBeam(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1562;

      _classCallCheck2(this, IfcBeam);

      _this1562 = _super1570.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1562.GlobalId = GlobalId;
      _this1562.OwnerHistory = OwnerHistory;
      _this1562.Name = Name;
      _this1562.Description = Description;
      _this1562.ObjectType = ObjectType;
      _this1562.ObjectPlacement = ObjectPlacement;
      _this1562.Representation = Representation;
      _this1562.Tag = Tag;
      _this1562.PredefinedType = PredefinedType;
      _this1562.type = 753842376;
      return _this1562;
    }

    return IfcBeam;
  }(IfcBuiltElement);

  IFC4_32.IfcBeam = IfcBeam;

  var IfcBearing = /*#__PURE__*/function (_IfcBuiltElement29) {
    _inherits(IfcBearing, _IfcBuiltElement29);

    var _super1571 = _createSuper(IfcBearing);

    function IfcBearing(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1563;

      _classCallCheck2(this, IfcBearing);

      _this1563 = _super1571.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1563.GlobalId = GlobalId;
      _this1563.OwnerHistory = OwnerHistory;
      _this1563.Name = Name;
      _this1563.Description = Description;
      _this1563.ObjectType = ObjectType;
      _this1563.ObjectPlacement = ObjectPlacement;
      _this1563.Representation = Representation;
      _this1563.Tag = Tag;
      _this1563.PredefinedType = PredefinedType;
      _this1563.type = 4196446775;
      return _this1563;
    }

    return IfcBearing;
  }(IfcBuiltElement);

  IFC4_32.IfcBearing = IfcBearing;

  var IfcBoiler = /*#__PURE__*/function (_IfcEnergyConversionD50) {
    _inherits(IfcBoiler, _IfcEnergyConversionD50);

    var _super1572 = _createSuper(IfcBoiler);

    function IfcBoiler(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1564;

      _classCallCheck2(this, IfcBoiler);

      _this1564 = _super1572.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1564.GlobalId = GlobalId;
      _this1564.OwnerHistory = OwnerHistory;
      _this1564.Name = Name;
      _this1564.Description = Description;
      _this1564.ObjectType = ObjectType;
      _this1564.ObjectPlacement = ObjectPlacement;
      _this1564.Representation = Representation;
      _this1564.Tag = Tag;
      _this1564.PredefinedType = PredefinedType;
      _this1564.type = 32344328;
      return _this1564;
    }

    return IfcBoiler;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcBoiler = IfcBoiler;

  var IfcBorehole = /*#__PURE__*/function (_IfcGeotechnicalAssem) {
    _inherits(IfcBorehole, _IfcGeotechnicalAssem);

    var _super1573 = _createSuper(IfcBorehole);

    function IfcBorehole(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1565;

      _classCallCheck2(this, IfcBorehole);

      _this1565 = _super1573.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1565.GlobalId = GlobalId;
      _this1565.OwnerHistory = OwnerHistory;
      _this1565.Name = Name;
      _this1565.Description = Description;
      _this1565.ObjectType = ObjectType;
      _this1565.ObjectPlacement = ObjectPlacement;
      _this1565.Representation = Representation;
      _this1565.Tag = Tag;
      _this1565.type = 3314249567;
      return _this1565;
    }

    return IfcBorehole;
  }(IfcGeotechnicalAssembly);

  IFC4_32.IfcBorehole = IfcBorehole;

  var IfcBuildingElementProxy = /*#__PURE__*/function (_IfcBuiltElement30) {
    _inherits(IfcBuildingElementProxy, _IfcBuiltElement30);

    var _super1574 = _createSuper(IfcBuildingElementProxy);

    function IfcBuildingElementProxy(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1566;

      _classCallCheck2(this, IfcBuildingElementProxy);

      _this1566 = _super1574.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1566.GlobalId = GlobalId;
      _this1566.OwnerHistory = OwnerHistory;
      _this1566.Name = Name;
      _this1566.Description = Description;
      _this1566.ObjectType = ObjectType;
      _this1566.ObjectPlacement = ObjectPlacement;
      _this1566.Representation = Representation;
      _this1566.Tag = Tag;
      _this1566.PredefinedType = PredefinedType;
      _this1566.type = 1095909175;
      return _this1566;
    }

    return IfcBuildingElementProxy;
  }(IfcBuiltElement);

  IFC4_32.IfcBuildingElementProxy = IfcBuildingElementProxy;

  var IfcBurner = /*#__PURE__*/function (_IfcEnergyConversionD51) {
    _inherits(IfcBurner, _IfcEnergyConversionD51);

    var _super1575 = _createSuper(IfcBurner);

    function IfcBurner(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1567;

      _classCallCheck2(this, IfcBurner);

      _this1567 = _super1575.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1567.GlobalId = GlobalId;
      _this1567.OwnerHistory = OwnerHistory;
      _this1567.Name = Name;
      _this1567.Description = Description;
      _this1567.ObjectType = ObjectType;
      _this1567.ObjectPlacement = ObjectPlacement;
      _this1567.Representation = Representation;
      _this1567.Tag = Tag;
      _this1567.PredefinedType = PredefinedType;
      _this1567.type = 2938176219;
      return _this1567;
    }

    return IfcBurner;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcBurner = IfcBurner;

  var IfcCableCarrierFitting = /*#__PURE__*/function (_IfcFlowFitting3) {
    _inherits(IfcCableCarrierFitting, _IfcFlowFitting3);

    var _super1576 = _createSuper(IfcCableCarrierFitting);

    function IfcCableCarrierFitting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1568;

      _classCallCheck2(this, IfcCableCarrierFitting);

      _this1568 = _super1576.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1568.GlobalId = GlobalId;
      _this1568.OwnerHistory = OwnerHistory;
      _this1568.Name = Name;
      _this1568.Description = Description;
      _this1568.ObjectType = ObjectType;
      _this1568.ObjectPlacement = ObjectPlacement;
      _this1568.Representation = Representation;
      _this1568.Tag = Tag;
      _this1568.PredefinedType = PredefinedType;
      _this1568.type = 635142910;
      return _this1568;
    }

    return IfcCableCarrierFitting;
  }(IfcFlowFitting);

  IFC4_32.IfcCableCarrierFitting = IfcCableCarrierFitting;

  var IfcCableCarrierSegment = /*#__PURE__*/function (_IfcFlowSegment2) {
    _inherits(IfcCableCarrierSegment, _IfcFlowSegment2);

    var _super1577 = _createSuper(IfcCableCarrierSegment);

    function IfcCableCarrierSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1569;

      _classCallCheck2(this, IfcCableCarrierSegment);

      _this1569 = _super1577.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1569.GlobalId = GlobalId;
      _this1569.OwnerHistory = OwnerHistory;
      _this1569.Name = Name;
      _this1569.Description = Description;
      _this1569.ObjectType = ObjectType;
      _this1569.ObjectPlacement = ObjectPlacement;
      _this1569.Representation = Representation;
      _this1569.Tag = Tag;
      _this1569.PredefinedType = PredefinedType;
      _this1569.type = 3758799889;
      return _this1569;
    }

    return IfcCableCarrierSegment;
  }(IfcFlowSegment);

  IFC4_32.IfcCableCarrierSegment = IfcCableCarrierSegment;

  var IfcCableFitting = /*#__PURE__*/function (_IfcFlowFitting4) {
    _inherits(IfcCableFitting, _IfcFlowFitting4);

    var _super1578 = _createSuper(IfcCableFitting);

    function IfcCableFitting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1570;

      _classCallCheck2(this, IfcCableFitting);

      _this1570 = _super1578.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1570.GlobalId = GlobalId;
      _this1570.OwnerHistory = OwnerHistory;
      _this1570.Name = Name;
      _this1570.Description = Description;
      _this1570.ObjectType = ObjectType;
      _this1570.ObjectPlacement = ObjectPlacement;
      _this1570.Representation = Representation;
      _this1570.Tag = Tag;
      _this1570.PredefinedType = PredefinedType;
      _this1570.type = 1051757585;
      return _this1570;
    }

    return IfcCableFitting;
  }(IfcFlowFitting);

  IFC4_32.IfcCableFitting = IfcCableFitting;

  var IfcCableSegment = /*#__PURE__*/function (_IfcFlowSegment3) {
    _inherits(IfcCableSegment, _IfcFlowSegment3);

    var _super1579 = _createSuper(IfcCableSegment);

    function IfcCableSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1571;

      _classCallCheck2(this, IfcCableSegment);

      _this1571 = _super1579.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1571.GlobalId = GlobalId;
      _this1571.OwnerHistory = OwnerHistory;
      _this1571.Name = Name;
      _this1571.Description = Description;
      _this1571.ObjectType = ObjectType;
      _this1571.ObjectPlacement = ObjectPlacement;
      _this1571.Representation = Representation;
      _this1571.Tag = Tag;
      _this1571.PredefinedType = PredefinedType;
      _this1571.type = 4217484030;
      return _this1571;
    }

    return IfcCableSegment;
  }(IfcFlowSegment);

  IFC4_32.IfcCableSegment = IfcCableSegment;

  var IfcCaissonFoundation = /*#__PURE__*/function (_IfcDeepFoundation2) {
    _inherits(IfcCaissonFoundation, _IfcDeepFoundation2);

    var _super1580 = _createSuper(IfcCaissonFoundation);

    function IfcCaissonFoundation(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1572;

      _classCallCheck2(this, IfcCaissonFoundation);

      _this1572 = _super1580.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1572.GlobalId = GlobalId;
      _this1572.OwnerHistory = OwnerHistory;
      _this1572.Name = Name;
      _this1572.Description = Description;
      _this1572.ObjectType = ObjectType;
      _this1572.ObjectPlacement = ObjectPlacement;
      _this1572.Representation = Representation;
      _this1572.Tag = Tag;
      _this1572.PredefinedType = PredefinedType;
      _this1572.type = 3999819293;
      return _this1572;
    }

    return IfcCaissonFoundation;
  }(IfcDeepFoundation);

  IFC4_32.IfcCaissonFoundation = IfcCaissonFoundation;

  var IfcChiller = /*#__PURE__*/function (_IfcEnergyConversionD52) {
    _inherits(IfcChiller, _IfcEnergyConversionD52);

    var _super1581 = _createSuper(IfcChiller);

    function IfcChiller(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1573;

      _classCallCheck2(this, IfcChiller);

      _this1573 = _super1581.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1573.GlobalId = GlobalId;
      _this1573.OwnerHistory = OwnerHistory;
      _this1573.Name = Name;
      _this1573.Description = Description;
      _this1573.ObjectType = ObjectType;
      _this1573.ObjectPlacement = ObjectPlacement;
      _this1573.Representation = Representation;
      _this1573.Tag = Tag;
      _this1573.PredefinedType = PredefinedType;
      _this1573.type = 3902619387;
      return _this1573;
    }

    return IfcChiller;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcChiller = IfcChiller;

  var IfcCoil = /*#__PURE__*/function (_IfcEnergyConversionD53) {
    _inherits(IfcCoil, _IfcEnergyConversionD53);

    var _super1582 = _createSuper(IfcCoil);

    function IfcCoil(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1574;

      _classCallCheck2(this, IfcCoil);

      _this1574 = _super1582.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1574.GlobalId = GlobalId;
      _this1574.OwnerHistory = OwnerHistory;
      _this1574.Name = Name;
      _this1574.Description = Description;
      _this1574.ObjectType = ObjectType;
      _this1574.ObjectPlacement = ObjectPlacement;
      _this1574.Representation = Representation;
      _this1574.Tag = Tag;
      _this1574.PredefinedType = PredefinedType;
      _this1574.type = 639361253;
      return _this1574;
    }

    return IfcCoil;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcCoil = IfcCoil;

  var IfcCommunicationsAppliance = /*#__PURE__*/function (_IfcFlowTerminal14) {
    _inherits(IfcCommunicationsAppliance, _IfcFlowTerminal14);

    var _super1583 = _createSuper(IfcCommunicationsAppliance);

    function IfcCommunicationsAppliance(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1575;

      _classCallCheck2(this, IfcCommunicationsAppliance);

      _this1575 = _super1583.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1575.GlobalId = GlobalId;
      _this1575.OwnerHistory = OwnerHistory;
      _this1575.Name = Name;
      _this1575.Description = Description;
      _this1575.ObjectType = ObjectType;
      _this1575.ObjectPlacement = ObjectPlacement;
      _this1575.Representation = Representation;
      _this1575.Tag = Tag;
      _this1575.PredefinedType = PredefinedType;
      _this1575.type = 3221913625;
      return _this1575;
    }

    return IfcCommunicationsAppliance;
  }(IfcFlowTerminal);

  IFC4_32.IfcCommunicationsAppliance = IfcCommunicationsAppliance;

  var IfcCompressor = /*#__PURE__*/function (_IfcFlowMovingDevice2) {
    _inherits(IfcCompressor, _IfcFlowMovingDevice2);

    var _super1584 = _createSuper(IfcCompressor);

    function IfcCompressor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1576;

      _classCallCheck2(this, IfcCompressor);

      _this1576 = _super1584.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1576.GlobalId = GlobalId;
      _this1576.OwnerHistory = OwnerHistory;
      _this1576.Name = Name;
      _this1576.Description = Description;
      _this1576.ObjectType = ObjectType;
      _this1576.ObjectPlacement = ObjectPlacement;
      _this1576.Representation = Representation;
      _this1576.Tag = Tag;
      _this1576.PredefinedType = PredefinedType;
      _this1576.type = 3571504051;
      return _this1576;
    }

    return IfcCompressor;
  }(IfcFlowMovingDevice);

  IFC4_32.IfcCompressor = IfcCompressor;

  var IfcCondenser = /*#__PURE__*/function (_IfcEnergyConversionD54) {
    _inherits(IfcCondenser, _IfcEnergyConversionD54);

    var _super1585 = _createSuper(IfcCondenser);

    function IfcCondenser(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1577;

      _classCallCheck2(this, IfcCondenser);

      _this1577 = _super1585.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1577.GlobalId = GlobalId;
      _this1577.OwnerHistory = OwnerHistory;
      _this1577.Name = Name;
      _this1577.Description = Description;
      _this1577.ObjectType = ObjectType;
      _this1577.ObjectPlacement = ObjectPlacement;
      _this1577.Representation = Representation;
      _this1577.Tag = Tag;
      _this1577.PredefinedType = PredefinedType;
      _this1577.type = 2272882330;
      return _this1577;
    }

    return IfcCondenser;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcCondenser = IfcCondenser;

  var IfcControllerType = /*#__PURE__*/function (_IfcDistributionContr12) {
    _inherits(IfcControllerType, _IfcDistributionContr12);

    var _super1586 = _createSuper(IfcControllerType);

    function IfcControllerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1578;

      _classCallCheck2(this, IfcControllerType);

      _this1578 = _super1586.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1578.GlobalId = GlobalId;
      _this1578.OwnerHistory = OwnerHistory;
      _this1578.Name = Name;
      _this1578.Description = Description;
      _this1578.ApplicableOccurrence = ApplicableOccurrence;
      _this1578.HasPropertySets = HasPropertySets;
      _this1578.RepresentationMaps = RepresentationMaps;
      _this1578.Tag = Tag;
      _this1578.ElementType = ElementType;
      _this1578.PredefinedType = PredefinedType;
      _this1578.type = 578613899;
      return _this1578;
    }

    return IfcControllerType;
  }(IfcDistributionControlElementType);

  IFC4_32.IfcControllerType = IfcControllerType;

  var IfcConveyorSegment = /*#__PURE__*/function (_IfcFlowSegment4) {
    _inherits(IfcConveyorSegment, _IfcFlowSegment4);

    var _super1587 = _createSuper(IfcConveyorSegment);

    function IfcConveyorSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1579;

      _classCallCheck2(this, IfcConveyorSegment);

      _this1579 = _super1587.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1579.GlobalId = GlobalId;
      _this1579.OwnerHistory = OwnerHistory;
      _this1579.Name = Name;
      _this1579.Description = Description;
      _this1579.ObjectType = ObjectType;
      _this1579.ObjectPlacement = ObjectPlacement;
      _this1579.Representation = Representation;
      _this1579.Tag = Tag;
      _this1579.PredefinedType = PredefinedType;
      _this1579.type = 3460952963;
      return _this1579;
    }

    return IfcConveyorSegment;
  }(IfcFlowSegment);

  IFC4_32.IfcConveyorSegment = IfcConveyorSegment;

  var IfcCooledBeam = /*#__PURE__*/function (_IfcEnergyConversionD55) {
    _inherits(IfcCooledBeam, _IfcEnergyConversionD55);

    var _super1588 = _createSuper(IfcCooledBeam);

    function IfcCooledBeam(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1580;

      _classCallCheck2(this, IfcCooledBeam);

      _this1580 = _super1588.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1580.GlobalId = GlobalId;
      _this1580.OwnerHistory = OwnerHistory;
      _this1580.Name = Name;
      _this1580.Description = Description;
      _this1580.ObjectType = ObjectType;
      _this1580.ObjectPlacement = ObjectPlacement;
      _this1580.Representation = Representation;
      _this1580.Tag = Tag;
      _this1580.PredefinedType = PredefinedType;
      _this1580.type = 4136498852;
      return _this1580;
    }

    return IfcCooledBeam;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcCooledBeam = IfcCooledBeam;

  var IfcCoolingTower = /*#__PURE__*/function (_IfcEnergyConversionD56) {
    _inherits(IfcCoolingTower, _IfcEnergyConversionD56);

    var _super1589 = _createSuper(IfcCoolingTower);

    function IfcCoolingTower(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1581;

      _classCallCheck2(this, IfcCoolingTower);

      _this1581 = _super1589.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1581.GlobalId = GlobalId;
      _this1581.OwnerHistory = OwnerHistory;
      _this1581.Name = Name;
      _this1581.Description = Description;
      _this1581.ObjectType = ObjectType;
      _this1581.ObjectPlacement = ObjectPlacement;
      _this1581.Representation = Representation;
      _this1581.Tag = Tag;
      _this1581.PredefinedType = PredefinedType;
      _this1581.type = 3640358203;
      return _this1581;
    }

    return IfcCoolingTower;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcCoolingTower = IfcCoolingTower;

  var IfcDamper = /*#__PURE__*/function (_IfcFlowController7) {
    _inherits(IfcDamper, _IfcFlowController7);

    var _super1590 = _createSuper(IfcDamper);

    function IfcDamper(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1582;

      _classCallCheck2(this, IfcDamper);

      _this1582 = _super1590.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1582.GlobalId = GlobalId;
      _this1582.OwnerHistory = OwnerHistory;
      _this1582.Name = Name;
      _this1582.Description = Description;
      _this1582.ObjectType = ObjectType;
      _this1582.ObjectPlacement = ObjectPlacement;
      _this1582.Representation = Representation;
      _this1582.Tag = Tag;
      _this1582.PredefinedType = PredefinedType;
      _this1582.type = 4074379575;
      return _this1582;
    }

    return IfcDamper;
  }(IfcFlowController);

  IFC4_32.IfcDamper = IfcDamper;

  var IfcDistributionBoard = /*#__PURE__*/function (_IfcFlowController8) {
    _inherits(IfcDistributionBoard, _IfcFlowController8);

    var _super1591 = _createSuper(IfcDistributionBoard);

    function IfcDistributionBoard(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1583;

      _classCallCheck2(this, IfcDistributionBoard);

      _this1583 = _super1591.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1583.GlobalId = GlobalId;
      _this1583.OwnerHistory = OwnerHistory;
      _this1583.Name = Name;
      _this1583.Description = Description;
      _this1583.ObjectType = ObjectType;
      _this1583.ObjectPlacement = ObjectPlacement;
      _this1583.Representation = Representation;
      _this1583.Tag = Tag;
      _this1583.PredefinedType = PredefinedType;
      _this1583.type = 3693000487;
      return _this1583;
    }

    return IfcDistributionBoard;
  }(IfcFlowController);

  IFC4_32.IfcDistributionBoard = IfcDistributionBoard;

  var IfcDistributionChamberElement = /*#__PURE__*/function (_IfcDistributionFlowE36) {
    _inherits(IfcDistributionChamberElement, _IfcDistributionFlowE36);

    var _super1592 = _createSuper(IfcDistributionChamberElement);

    function IfcDistributionChamberElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1584;

      _classCallCheck2(this, IfcDistributionChamberElement);

      _this1584 = _super1592.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1584.GlobalId = GlobalId;
      _this1584.OwnerHistory = OwnerHistory;
      _this1584.Name = Name;
      _this1584.Description = Description;
      _this1584.ObjectType = ObjectType;
      _this1584.ObjectPlacement = ObjectPlacement;
      _this1584.Representation = Representation;
      _this1584.Tag = Tag;
      _this1584.PredefinedType = PredefinedType;
      _this1584.type = 1052013943;
      return _this1584;
    }

    return IfcDistributionChamberElement;
  }(IfcDistributionFlowElement);

  IFC4_32.IfcDistributionChamberElement = IfcDistributionChamberElement;

  var IfcDistributionCircuit = /*#__PURE__*/function (_IfcDistributionSyste) {
    _inherits(IfcDistributionCircuit, _IfcDistributionSyste);

    var _super1593 = _createSuper(IfcDistributionCircuit);

    function IfcDistributionCircuit(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      var _this1585;

      _classCallCheck2(this, IfcDistributionCircuit);

      _this1585 = _super1593.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType);
      _this1585.GlobalId = GlobalId;
      _this1585.OwnerHistory = OwnerHistory;
      _this1585.Name = Name;
      _this1585.Description = Description;
      _this1585.ObjectType = ObjectType;
      _this1585.LongName = LongName;
      _this1585.PredefinedType = PredefinedType;
      _this1585.type = 562808652;
      return _this1585;
    }

    return IfcDistributionCircuit;
  }(IfcDistributionSystem);

  IFC4_32.IfcDistributionCircuit = IfcDistributionCircuit;

  var IfcDistributionControlElement = /*#__PURE__*/function (_IfcDistributionEleme8) {
    _inherits(IfcDistributionControlElement, _IfcDistributionEleme8);

    var _super1594 = _createSuper(IfcDistributionControlElement);

    function IfcDistributionControlElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1586;

      _classCallCheck2(this, IfcDistributionControlElement);

      _this1586 = _super1594.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1586.GlobalId = GlobalId;
      _this1586.OwnerHistory = OwnerHistory;
      _this1586.Name = Name;
      _this1586.Description = Description;
      _this1586.ObjectType = ObjectType;
      _this1586.ObjectPlacement = ObjectPlacement;
      _this1586.Representation = Representation;
      _this1586.Tag = Tag;
      _this1586.type = 1062813311;
      return _this1586;
    }

    return IfcDistributionControlElement;
  }(IfcDistributionElement);

  IFC4_32.IfcDistributionControlElement = IfcDistributionControlElement;

  var IfcDuctFitting = /*#__PURE__*/function (_IfcFlowFitting5) {
    _inherits(IfcDuctFitting, _IfcFlowFitting5);

    var _super1595 = _createSuper(IfcDuctFitting);

    function IfcDuctFitting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1587;

      _classCallCheck2(this, IfcDuctFitting);

      _this1587 = _super1595.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1587.GlobalId = GlobalId;
      _this1587.OwnerHistory = OwnerHistory;
      _this1587.Name = Name;
      _this1587.Description = Description;
      _this1587.ObjectType = ObjectType;
      _this1587.ObjectPlacement = ObjectPlacement;
      _this1587.Representation = Representation;
      _this1587.Tag = Tag;
      _this1587.PredefinedType = PredefinedType;
      _this1587.type = 342316401;
      return _this1587;
    }

    return IfcDuctFitting;
  }(IfcFlowFitting);

  IFC4_32.IfcDuctFitting = IfcDuctFitting;

  var IfcDuctSegment = /*#__PURE__*/function (_IfcFlowSegment5) {
    _inherits(IfcDuctSegment, _IfcFlowSegment5);

    var _super1596 = _createSuper(IfcDuctSegment);

    function IfcDuctSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1588;

      _classCallCheck2(this, IfcDuctSegment);

      _this1588 = _super1596.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1588.GlobalId = GlobalId;
      _this1588.OwnerHistory = OwnerHistory;
      _this1588.Name = Name;
      _this1588.Description = Description;
      _this1588.ObjectType = ObjectType;
      _this1588.ObjectPlacement = ObjectPlacement;
      _this1588.Representation = Representation;
      _this1588.Tag = Tag;
      _this1588.PredefinedType = PredefinedType;
      _this1588.type = 3518393246;
      return _this1588;
    }

    return IfcDuctSegment;
  }(IfcFlowSegment);

  IFC4_32.IfcDuctSegment = IfcDuctSegment;

  var IfcDuctSilencer = /*#__PURE__*/function (_IfcFlowTreatmentDevi8) {
    _inherits(IfcDuctSilencer, _IfcFlowTreatmentDevi8);

    var _super1597 = _createSuper(IfcDuctSilencer);

    function IfcDuctSilencer(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1589;

      _classCallCheck2(this, IfcDuctSilencer);

      _this1589 = _super1597.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1589.GlobalId = GlobalId;
      _this1589.OwnerHistory = OwnerHistory;
      _this1589.Name = Name;
      _this1589.Description = Description;
      _this1589.ObjectType = ObjectType;
      _this1589.ObjectPlacement = ObjectPlacement;
      _this1589.Representation = Representation;
      _this1589.Tag = Tag;
      _this1589.PredefinedType = PredefinedType;
      _this1589.type = 1360408905;
      return _this1589;
    }

    return IfcDuctSilencer;
  }(IfcFlowTreatmentDevice);

  IFC4_32.IfcDuctSilencer = IfcDuctSilencer;

  var IfcElectricAppliance = /*#__PURE__*/function (_IfcFlowTerminal15) {
    _inherits(IfcElectricAppliance, _IfcFlowTerminal15);

    var _super1598 = _createSuper(IfcElectricAppliance);

    function IfcElectricAppliance(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1590;

      _classCallCheck2(this, IfcElectricAppliance);

      _this1590 = _super1598.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1590.GlobalId = GlobalId;
      _this1590.OwnerHistory = OwnerHistory;
      _this1590.Name = Name;
      _this1590.Description = Description;
      _this1590.ObjectType = ObjectType;
      _this1590.ObjectPlacement = ObjectPlacement;
      _this1590.Representation = Representation;
      _this1590.Tag = Tag;
      _this1590.PredefinedType = PredefinedType;
      _this1590.type = 1904799276;
      return _this1590;
    }

    return IfcElectricAppliance;
  }(IfcFlowTerminal);

  IFC4_32.IfcElectricAppliance = IfcElectricAppliance;

  var IfcElectricDistributionBoard = /*#__PURE__*/function (_IfcFlowController9) {
    _inherits(IfcElectricDistributionBoard, _IfcFlowController9);

    var _super1599 = _createSuper(IfcElectricDistributionBoard);

    function IfcElectricDistributionBoard(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1591;

      _classCallCheck2(this, IfcElectricDistributionBoard);

      _this1591 = _super1599.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1591.GlobalId = GlobalId;
      _this1591.OwnerHistory = OwnerHistory;
      _this1591.Name = Name;
      _this1591.Description = Description;
      _this1591.ObjectType = ObjectType;
      _this1591.ObjectPlacement = ObjectPlacement;
      _this1591.Representation = Representation;
      _this1591.Tag = Tag;
      _this1591.PredefinedType = PredefinedType;
      _this1591.type = 862014818;
      return _this1591;
    }

    return IfcElectricDistributionBoard;
  }(IfcFlowController);

  IFC4_32.IfcElectricDistributionBoard = IfcElectricDistributionBoard;

  var IfcElectricFlowStorageDevice = /*#__PURE__*/function (_IfcFlowStorageDevice6) {
    _inherits(IfcElectricFlowStorageDevice, _IfcFlowStorageDevice6);

    var _super1600 = _createSuper(IfcElectricFlowStorageDevice);

    function IfcElectricFlowStorageDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1592;

      _classCallCheck2(this, IfcElectricFlowStorageDevice);

      _this1592 = _super1600.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1592.GlobalId = GlobalId;
      _this1592.OwnerHistory = OwnerHistory;
      _this1592.Name = Name;
      _this1592.Description = Description;
      _this1592.ObjectType = ObjectType;
      _this1592.ObjectPlacement = ObjectPlacement;
      _this1592.Representation = Representation;
      _this1592.Tag = Tag;
      _this1592.PredefinedType = PredefinedType;
      _this1592.type = 3310460725;
      return _this1592;
    }

    return IfcElectricFlowStorageDevice;
  }(IfcFlowStorageDevice);

  IFC4_32.IfcElectricFlowStorageDevice = IfcElectricFlowStorageDevice;

  var IfcElectricFlowTreatmentDevice = /*#__PURE__*/function (_IfcFlowTreatmentDevi9) {
    _inherits(IfcElectricFlowTreatmentDevice, _IfcFlowTreatmentDevi9);

    var _super1601 = _createSuper(IfcElectricFlowTreatmentDevice);

    function IfcElectricFlowTreatmentDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1593;

      _classCallCheck2(this, IfcElectricFlowTreatmentDevice);

      _this1593 = _super1601.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1593.GlobalId = GlobalId;
      _this1593.OwnerHistory = OwnerHistory;
      _this1593.Name = Name;
      _this1593.Description = Description;
      _this1593.ObjectType = ObjectType;
      _this1593.ObjectPlacement = ObjectPlacement;
      _this1593.Representation = Representation;
      _this1593.Tag = Tag;
      _this1593.PredefinedType = PredefinedType;
      _this1593.type = 24726584;
      return _this1593;
    }

    return IfcElectricFlowTreatmentDevice;
  }(IfcFlowTreatmentDevice);

  IFC4_32.IfcElectricFlowTreatmentDevice = IfcElectricFlowTreatmentDevice;

  var IfcElectricGenerator = /*#__PURE__*/function (_IfcEnergyConversionD57) {
    _inherits(IfcElectricGenerator, _IfcEnergyConversionD57);

    var _super1602 = _createSuper(IfcElectricGenerator);

    function IfcElectricGenerator(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1594;

      _classCallCheck2(this, IfcElectricGenerator);

      _this1594 = _super1602.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1594.GlobalId = GlobalId;
      _this1594.OwnerHistory = OwnerHistory;
      _this1594.Name = Name;
      _this1594.Description = Description;
      _this1594.ObjectType = ObjectType;
      _this1594.ObjectPlacement = ObjectPlacement;
      _this1594.Representation = Representation;
      _this1594.Tag = Tag;
      _this1594.PredefinedType = PredefinedType;
      _this1594.type = 264262732;
      return _this1594;
    }

    return IfcElectricGenerator;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcElectricGenerator = IfcElectricGenerator;

  var IfcElectricMotor = /*#__PURE__*/function (_IfcEnergyConversionD58) {
    _inherits(IfcElectricMotor, _IfcEnergyConversionD58);

    var _super1603 = _createSuper(IfcElectricMotor);

    function IfcElectricMotor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1595;

      _classCallCheck2(this, IfcElectricMotor);

      _this1595 = _super1603.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1595.GlobalId = GlobalId;
      _this1595.OwnerHistory = OwnerHistory;
      _this1595.Name = Name;
      _this1595.Description = Description;
      _this1595.ObjectType = ObjectType;
      _this1595.ObjectPlacement = ObjectPlacement;
      _this1595.Representation = Representation;
      _this1595.Tag = Tag;
      _this1595.PredefinedType = PredefinedType;
      _this1595.type = 402227799;
      return _this1595;
    }

    return IfcElectricMotor;
  }(IfcEnergyConversionDevice);

  IFC4_32.IfcElectricMotor = IfcElectricMotor;

  var IfcElectricTimeControl = /*#__PURE__*/function (_IfcFlowController10) {
    _inherits(IfcElectricTimeControl, _IfcFlowController10);

    var _super1604 = _createSuper(IfcElectricTimeControl);

    function IfcElectricTimeControl(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1596;

      _classCallCheck2(this, IfcElectricTimeControl);

      _this1596 = _super1604.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1596.GlobalId = GlobalId;
      _this1596.OwnerHistory = OwnerHistory;
      _this1596.Name = Name;
      _this1596.Description = Description;
      _this1596.ObjectType = ObjectType;
      _this1596.ObjectPlacement = ObjectPlacement;
      _this1596.Representation = Representation;
      _this1596.Tag = Tag;
      _this1596.PredefinedType = PredefinedType;
      _this1596.type = 1003880860;
      return _this1596;
    }

    return IfcElectricTimeControl;
  }(IfcFlowController);

  IFC4_32.IfcElectricTimeControl = IfcElectricTimeControl;

  var IfcFan = /*#__PURE__*/function (_IfcFlowMovingDevice3) {
    _inherits(IfcFan, _IfcFlowMovingDevice3);

    var _super1605 = _createSuper(IfcFan);

    function IfcFan(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1597;

      _classCallCheck2(this, IfcFan);

      _this1597 = _super1605.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1597.GlobalId = GlobalId;
      _this1597.OwnerHistory = OwnerHistory;
      _this1597.Name = Name;
      _this1597.Description = Description;
      _this1597.ObjectType = ObjectType;
      _this1597.ObjectPlacement = ObjectPlacement;
      _this1597.Representation = Representation;
      _this1597.Tag = Tag;
      _this1597.PredefinedType = PredefinedType;
      _this1597.type = 3415622556;
      return _this1597;
    }

    return IfcFan;
  }(IfcFlowMovingDevice);

  IFC4_32.IfcFan = IfcFan;

  var IfcFilter = /*#__PURE__*/function (_IfcFlowTreatmentDevi10) {
    _inherits(IfcFilter, _IfcFlowTreatmentDevi10);

    var _super1606 = _createSuper(IfcFilter);

    function IfcFilter(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1598;

      _classCallCheck2(this, IfcFilter);

      _this1598 = _super1606.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1598.GlobalId = GlobalId;
      _this1598.OwnerHistory = OwnerHistory;
      _this1598.Name = Name;
      _this1598.Description = Description;
      _this1598.ObjectType = ObjectType;
      _this1598.ObjectPlacement = ObjectPlacement;
      _this1598.Representation = Representation;
      _this1598.Tag = Tag;
      _this1598.PredefinedType = PredefinedType;
      _this1598.type = 819412036;
      return _this1598;
    }

    return IfcFilter;
  }(IfcFlowTreatmentDevice);

  IFC4_32.IfcFilter = IfcFilter;

  var IfcFireSuppressionTerminal = /*#__PURE__*/function (_IfcFlowTerminal16) {
    _inherits(IfcFireSuppressionTerminal, _IfcFlowTerminal16);

    var _super1607 = _createSuper(IfcFireSuppressionTerminal);

    function IfcFireSuppressionTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1599;

      _classCallCheck2(this, IfcFireSuppressionTerminal);

      _this1599 = _super1607.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1599.GlobalId = GlobalId;
      _this1599.OwnerHistory = OwnerHistory;
      _this1599.Name = Name;
      _this1599.Description = Description;
      _this1599.ObjectType = ObjectType;
      _this1599.ObjectPlacement = ObjectPlacement;
      _this1599.Representation = Representation;
      _this1599.Tag = Tag;
      _this1599.PredefinedType = PredefinedType;
      _this1599.type = 1426591983;
      return _this1599;
    }

    return IfcFireSuppressionTerminal;
  }(IfcFlowTerminal);

  IFC4_32.IfcFireSuppressionTerminal = IfcFireSuppressionTerminal;

  var IfcFlowInstrument = /*#__PURE__*/function (_IfcDistributionContr13) {
    _inherits(IfcFlowInstrument, _IfcDistributionContr13);

    var _super1608 = _createSuper(IfcFlowInstrument);

    function IfcFlowInstrument(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1600;

      _classCallCheck2(this, IfcFlowInstrument);

      _this1600 = _super1608.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1600.GlobalId = GlobalId;
      _this1600.OwnerHistory = OwnerHistory;
      _this1600.Name = Name;
      _this1600.Description = Description;
      _this1600.ObjectType = ObjectType;
      _this1600.ObjectPlacement = ObjectPlacement;
      _this1600.Representation = Representation;
      _this1600.Tag = Tag;
      _this1600.PredefinedType = PredefinedType;
      _this1600.type = 182646315;
      return _this1600;
    }

    return IfcFlowInstrument;
  }(IfcDistributionControlElement);

  IFC4_32.IfcFlowInstrument = IfcFlowInstrument;

  var IfcGeomodel = /*#__PURE__*/function (_IfcGeotechnicalAssem2) {
    _inherits(IfcGeomodel, _IfcGeotechnicalAssem2);

    var _super1609 = _createSuper(IfcGeomodel);

    function IfcGeomodel(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1601;

      _classCallCheck2(this, IfcGeomodel);

      _this1601 = _super1609.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1601.GlobalId = GlobalId;
      _this1601.OwnerHistory = OwnerHistory;
      _this1601.Name = Name;
      _this1601.Description = Description;
      _this1601.ObjectType = ObjectType;
      _this1601.ObjectPlacement = ObjectPlacement;
      _this1601.Representation = Representation;
      _this1601.Tag = Tag;
      _this1601.type = 2680139844;
      return _this1601;
    }

    return IfcGeomodel;
  }(IfcGeotechnicalAssembly);

  IFC4_32.IfcGeomodel = IfcGeomodel;

  var IfcGeoslice = /*#__PURE__*/function (_IfcGeotechnicalAssem3) {
    _inherits(IfcGeoslice, _IfcGeotechnicalAssem3);

    var _super1610 = _createSuper(IfcGeoslice);

    function IfcGeoslice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this1602;

      _classCallCheck2(this, IfcGeoslice);

      _this1602 = _super1610.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1602.GlobalId = GlobalId;
      _this1602.OwnerHistory = OwnerHistory;
      _this1602.Name = Name;
      _this1602.Description = Description;
      _this1602.ObjectType = ObjectType;
      _this1602.ObjectPlacement = ObjectPlacement;
      _this1602.Representation = Representation;
      _this1602.Tag = Tag;
      _this1602.type = 1971632696;
      return _this1602;
    }

    return IfcGeoslice;
  }(IfcGeotechnicalAssembly);

  IFC4_32.IfcGeoslice = IfcGeoslice;

  var IfcProtectiveDeviceTrippingUnit = /*#__PURE__*/function (_IfcDistributionContr14) {
    _inherits(IfcProtectiveDeviceTrippingUnit, _IfcDistributionContr14);

    var _super1611 = _createSuper(IfcProtectiveDeviceTrippingUnit);

    function IfcProtectiveDeviceTrippingUnit(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1603;

      _classCallCheck2(this, IfcProtectiveDeviceTrippingUnit);

      _this1603 = _super1611.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1603.GlobalId = GlobalId;
      _this1603.OwnerHistory = OwnerHistory;
      _this1603.Name = Name;
      _this1603.Description = Description;
      _this1603.ObjectType = ObjectType;
      _this1603.ObjectPlacement = ObjectPlacement;
      _this1603.Representation = Representation;
      _this1603.Tag = Tag;
      _this1603.PredefinedType = PredefinedType;
      _this1603.type = 2295281155;
      return _this1603;
    }

    return IfcProtectiveDeviceTrippingUnit;
  }(IfcDistributionControlElement);

  IFC4_32.IfcProtectiveDeviceTrippingUnit = IfcProtectiveDeviceTrippingUnit;

  var IfcSensor = /*#__PURE__*/function (_IfcDistributionContr15) {
    _inherits(IfcSensor, _IfcDistributionContr15);

    var _super1612 = _createSuper(IfcSensor);

    function IfcSensor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1604;

      _classCallCheck2(this, IfcSensor);

      _this1604 = _super1612.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1604.GlobalId = GlobalId;
      _this1604.OwnerHistory = OwnerHistory;
      _this1604.Name = Name;
      _this1604.Description = Description;
      _this1604.ObjectType = ObjectType;
      _this1604.ObjectPlacement = ObjectPlacement;
      _this1604.Representation = Representation;
      _this1604.Tag = Tag;
      _this1604.PredefinedType = PredefinedType;
      _this1604.type = 4086658281;
      return _this1604;
    }

    return IfcSensor;
  }(IfcDistributionControlElement);

  IFC4_32.IfcSensor = IfcSensor;

  var IfcUnitaryControlElement = /*#__PURE__*/function (_IfcDistributionContr16) {
    _inherits(IfcUnitaryControlElement, _IfcDistributionContr16);

    var _super1613 = _createSuper(IfcUnitaryControlElement);

    function IfcUnitaryControlElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1605;

      _classCallCheck2(this, IfcUnitaryControlElement);

      _this1605 = _super1613.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1605.GlobalId = GlobalId;
      _this1605.OwnerHistory = OwnerHistory;
      _this1605.Name = Name;
      _this1605.Description = Description;
      _this1605.ObjectType = ObjectType;
      _this1605.ObjectPlacement = ObjectPlacement;
      _this1605.Representation = Representation;
      _this1605.Tag = Tag;
      _this1605.PredefinedType = PredefinedType;
      _this1605.type = 630975310;
      return _this1605;
    }

    return IfcUnitaryControlElement;
  }(IfcDistributionControlElement);

  IFC4_32.IfcUnitaryControlElement = IfcUnitaryControlElement;

  var IfcActuator = /*#__PURE__*/function (_IfcDistributionContr17) {
    _inherits(IfcActuator, _IfcDistributionContr17);

    var _super1614 = _createSuper(IfcActuator);

    function IfcActuator(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1606;

      _classCallCheck2(this, IfcActuator);

      _this1606 = _super1614.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1606.GlobalId = GlobalId;
      _this1606.OwnerHistory = OwnerHistory;
      _this1606.Name = Name;
      _this1606.Description = Description;
      _this1606.ObjectType = ObjectType;
      _this1606.ObjectPlacement = ObjectPlacement;
      _this1606.Representation = Representation;
      _this1606.Tag = Tag;
      _this1606.PredefinedType = PredefinedType;
      _this1606.type = 4288193352;
      return _this1606;
    }

    return IfcActuator;
  }(IfcDistributionControlElement);

  IFC4_32.IfcActuator = IfcActuator;

  var IfcAlarm = /*#__PURE__*/function (_IfcDistributionContr18) {
    _inherits(IfcAlarm, _IfcDistributionContr18);

    var _super1615 = _createSuper(IfcAlarm);

    function IfcAlarm(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1607;

      _classCallCheck2(this, IfcAlarm);

      _this1607 = _super1615.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1607.GlobalId = GlobalId;
      _this1607.OwnerHistory = OwnerHistory;
      _this1607.Name = Name;
      _this1607.Description = Description;
      _this1607.ObjectType = ObjectType;
      _this1607.ObjectPlacement = ObjectPlacement;
      _this1607.Representation = Representation;
      _this1607.Tag = Tag;
      _this1607.PredefinedType = PredefinedType;
      _this1607.type = 3087945054;
      return _this1607;
    }

    return IfcAlarm;
  }(IfcDistributionControlElement);

  IFC4_32.IfcAlarm = IfcAlarm;

  var IfcController = /*#__PURE__*/function (_IfcDistributionContr19) {
    _inherits(IfcController, _IfcDistributionContr19);

    var _super1616 = _createSuper(IfcController);

    function IfcController(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this1608;

      _classCallCheck2(this, IfcController);

      _this1608 = _super1616.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this1608.GlobalId = GlobalId;
      _this1608.OwnerHistory = OwnerHistory;
      _this1608.Name = Name;
      _this1608.Description = Description;
      _this1608.ObjectType = ObjectType;
      _this1608.ObjectPlacement = ObjectPlacement;
      _this1608.Representation = Representation;
      _this1608.Tag = Tag;
      _this1608.PredefinedType = PredefinedType;
      _this1608.type = 25142252;
      return _this1608;
    }

    return IfcController;
  }(IfcDistributionControlElement);

  IFC4_32.IfcController = IfcController;
})(IFC4_3 || (IFC4_3 = {}));

SchemaNames[3] = "IFC4";
FromRawLineData[3] = {
  3630933823: function _(id, v) {
    return new IFC4.IfcActorRole(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value));
  },
  618182010: function _(id, v) {
    return new IFC4.IfcAddress(id, v[0], !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value));
  },
  639542469: function _(id, v) {
    return new IFC4.IfcApplication(id, new Handle(v[0].value), new IFC4.IfcLabel(v[1].value), new IFC4.IfcLabel(v[2].value), new IFC4.IfcIdentifier(v[3].value));
  },
  411424972: function _(id, v) {
    return new IFC4.IfcAppliedValue(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4.IfcDate(v[4].value), !v[5] ? null : new IFC4.IfcDate(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }));
  },
  130549933: function _(id, v) {
    return new IFC4.IfcApproval(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), !v[3] ? null : new IFC4.IfcDateTime(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value));
  },
  4037036970: function _(id, v) {
    return new IFC4.IfcBoundaryCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value));
  },
  1560379544: function _(id, v) {
    return new IFC4.IfcBoundaryEdgeCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(3, v[1]), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : TypeInitialiser(3, v[3]), !v[4] ? null : TypeInitialiser(3, v[4]), !v[5] ? null : TypeInitialiser(3, v[5]), !v[6] ? null : TypeInitialiser(3, v[6]));
  },
  3367102660: function _(id, v) {
    return new IFC4.IfcBoundaryFaceCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(3, v[1]), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : TypeInitialiser(3, v[3]));
  },
  1387855156: function _(id, v) {
    return new IFC4.IfcBoundaryNodeCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(3, v[1]), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : TypeInitialiser(3, v[3]), !v[4] ? null : TypeInitialiser(3, v[4]), !v[5] ? null : TypeInitialiser(3, v[5]), !v[6] ? null : TypeInitialiser(3, v[6]));
  },
  2069777674: function _(id, v) {
    return new IFC4.IfcBoundaryNodeConditionWarping(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : TypeInitialiser(3, v[1]), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : TypeInitialiser(3, v[3]), !v[4] ? null : TypeInitialiser(3, v[4]), !v[5] ? null : TypeInitialiser(3, v[5]), !v[6] ? null : TypeInitialiser(3, v[6]), !v[7] ? null : TypeInitialiser(3, v[7]));
  },
  2859738748: function _(id, _104) {
    return new IFC4.IfcConnectionGeometry(id);
  },
  2614616156: function _(id, v) {
    return new IFC4.IfcConnectionPointGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  2732653382: function _(id, v) {
    return new IFC4.IfcConnectionSurfaceGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  775493141: function _(id, v) {
    return new IFC4.IfcConnectionVolumeGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  1959218052: function _(id, v) {
    return new IFC4.IfcConstraint(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value));
  },
  1785450214: function _(id, v) {
    return new IFC4.IfcCoordinateOperation(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  1466758467: function _(id, v) {
    return new IFC4.IfcCoordinateReferenceSystem(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new IFC4.IfcIdentifier(v[3].value));
  },
  602808272: function _(id, v) {
    return new IFC4.IfcCostValue(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4.IfcDate(v[4].value), !v[5] ? null : new IFC4.IfcDate(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1765591967: function _(id, v) {
    return new IFC4.IfcDerivedUnit(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value));
  },
  1045800335: function _(id, v) {
    return new IFC4.IfcDerivedUnitElement(id, new Handle(v[0].value), v[1].value);
  },
  2949456006: function _(id, v) {
    return new IFC4.IfcDimensionalExponents(id, v[0].value, v[1].value, v[2].value, v[3].value, v[4].value, v[5].value, v[6].value);
  },
  4294318154: function _(id, _105) {
    return new IFC4.IfcExternalInformation(id);
  },
  3200245327: function _(id, v) {
    return new IFC4.IfcExternalReference(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value));
  },
  2242383968: function _(id, v) {
    return new IFC4.IfcExternallyDefinedHatchStyle(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value));
  },
  1040185647: function _(id, v) {
    return new IFC4.IfcExternallyDefinedSurfaceStyle(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value));
  },
  3548104201: function _(id, v) {
    return new IFC4.IfcExternallyDefinedTextFont(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value));
  },
  852622518: function _(id, v) {
    return new IFC4.IfcGridAxis(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), new IFC4.IfcBoolean(v[2].value));
  },
  3020489413: function _(id, v) {
    return new IFC4.IfcIrregularTimeSeriesValue(id, new IFC4.IfcDateTime(v[0].value), v[1].map(function (p) {
      return TypeInitialiser(3, p);
    }));
  },
  2655187982: function _(id, v) {
    return new IFC4.IfcLibraryInformation(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new IFC4.IfcDateTime(v[3].value), !v[4] ? null : new IFC4.IfcURIReference(v[4].value), !v[5] ? null : new IFC4.IfcText(v[5].value));
  },
  3452421091: function _(id, v) {
    return new IFC4.IfcLibraryReference(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLanguageId(v[4].value), !v[5] ? null : new Handle(v[5].value));
  },
  4162380809: function _(id, v) {
    return new IFC4.IfcLightDistributionData(id, new IFC4.IfcPlaneAngleMeasure(v[0].value), v[1].map(function (p) {
      return new IFC4.IfcPlaneAngleMeasure(p.value);
    }), v[2].map(function (p) {
      return new IFC4.IfcLuminousIntensityDistributionMeasure(p.value);
    }));
  },
  1566485204: function _(id, v) {
    return new IFC4.IfcLightIntensityDistribution(id, v[0], v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3057273783: function _(id, v) {
    return new IFC4.IfcMapConversion(id, new Handle(v[0].value), new Handle(v[1].value), new IFC4.IfcLengthMeasure(v[2].value), new IFC4.IfcLengthMeasure(v[3].value), new IFC4.IfcLengthMeasure(v[4].value), !v[5] ? null : new IFC4.IfcReal(v[5].value), !v[6] ? null : new IFC4.IfcReal(v[6].value), !v[7] ? null : new IFC4.IfcReal(v[7].value));
  },
  1847130766: function _(id, v) {
    return new IFC4.IfcMaterialClassificationRelationship(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value));
  },
  760658860: function _(id, _106) {
    return new IFC4.IfcMaterialDefinition(id);
  },
  248100487: function _(id, v) {
    return new IFC4.IfcMaterialLayer(id, !v[0] ? null : new Handle(v[0].value), new IFC4.IfcNonNegativeLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLogical(v[2].value), !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcInteger(v[6].value));
  },
  3303938423: function _(id, v) {
    return new IFC4.IfcMaterialLayerSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value));
  },
  1847252529: function _(id, v) {
    return new IFC4.IfcMaterialLayerWithOffsets(id, !v[0] ? null : new Handle(v[0].value), new IFC4.IfcNonNegativeLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLogical(v[2].value), !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcInteger(v[6].value), v[7], new IFC4.IfcLengthMeasure(v[8].value));
  },
  2199411900: function _(id, v) {
    return new IFC4.IfcMaterialList(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2235152071: function _(id, v) {
    return new IFC4.IfcMaterialProfile(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcInteger(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value));
  },
  164193824: function _(id, v) {
    return new IFC4.IfcMaterialProfileSet(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : new Handle(v[3].value));
  },
  552965576: function _(id, v) {
    return new IFC4.IfcMaterialProfileWithOffsets(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcInteger(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), new IFC4.IfcLengthMeasure(v[6].value));
  },
  1507914824: function _(id, _107) {
    return new IFC4.IfcMaterialUsageDefinition(id);
  },
  2597039031: function _(id, v) {
    return new IFC4.IfcMeasureWithUnit(id, TypeInitialiser(3, v[0]), new Handle(v[1].value));
  },
  3368373690: function _(id, v) {
    return new IFC4.IfcMetric(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), v[7], !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value));
  },
  2706619895: function _(id, v) {
    return new IFC4.IfcMonetaryUnit(id, new IFC4.IfcLabel(v[0].value));
  },
  1918398963: function _(id, v) {
    return new IFC4.IfcNamedUnit(id, new Handle(v[0].value), v[1]);
  },
  3701648758: function _(id, _108) {
    return new IFC4.IfcObjectPlacement(id);
  },
  2251480897: function _(id, v) {
    return new IFC4.IfcObjective(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2], !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), v[8], v[9], !v[10] ? null : new IFC4.IfcLabel(v[10].value));
  },
  4251960020: function _(id, v) {
    return new IFC4.IfcOrganization(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new Handle(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1207048766: function _(id, v) {
    return new IFC4.IfcOwnerHistory(id, new Handle(v[0].value), new Handle(v[1].value), v[2], v[3], !v[4] ? null : new IFC4.IfcTimeStamp(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new IFC4.IfcTimeStamp(v[7].value));
  },
  2077209135: function _(id, v) {
    return new IFC4.IfcPerson(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new IFC4.IfcLabel(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new IFC4.IfcLabel(p.value);
    }), !v[5] ? null : v[5].map(function (p) {
      return new IFC4.IfcLabel(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }));
  },
  101040310: function _(id, v) {
    return new IFC4.IfcPersonAndOrganization(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2483315170: function _(id, v) {
    return new IFC4.IfcPhysicalQuantity(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value));
  },
  2226359599: function _(id, v) {
    return new IFC4.IfcPhysicalSimpleQuantity(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  3355820592: function _(id, v) {
    return new IFC4.IfcPostalAddress(id, v[0], !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcLabel(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new IFC4.IfcLabel(p.value);
    }), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcLabel(v[9].value));
  },
  677532197: function _(id, _109) {
    return new IFC4.IfcPresentationItem(id);
  },
  2022622350: function _(id, v) {
    return new IFC4.IfcPresentationLayerAssignment(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : new IFC4.IfcIdentifier(v[3].value));
  },
  1304840413: function _(id, v) {
    return new IFC4.IfcPresentationLayerWithStyle(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : new IFC4.IfcIdentifier(v[3].value), new IFC4.IfcLogical(v[4].value), new IFC4.IfcLogical(v[5].value), new IFC4.IfcLogical(v[6].value), v[7].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3119450353: function _(id, v) {
    return new IFC4.IfcPresentationStyle(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value));
  },
  2417041796: function _(id, v) {
    return new IFC4.IfcPresentationStyleAssignment(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2095639259: function _(id, v) {
    return new IFC4.IfcProductRepresentation(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3958567839: function _(id, v) {
    return new IFC4.IfcProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value));
  },
  3843373140: function _(id, v) {
    return new IFC4.IfcProjectedCRS(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new IFC4.IfcIdentifier(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  986844984: function _(id, _110) {
    return new IFC4.IfcPropertyAbstraction(id);
  },
  3710013099: function _(id, v) {
    return new IFC4.IfcPropertyEnumeration(id, new IFC4.IfcLabel(v[0].value), v[1].map(function (p) {
      return TypeInitialiser(3, p);
    }), !v[2] ? null : new Handle(v[2].value));
  },
  2044713172: function _(id, v) {
    return new IFC4.IfcQuantityArea(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcAreaMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  2093928680: function _(id, v) {
    return new IFC4.IfcQuantityCount(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcCountMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  931644368: function _(id, v) {
    return new IFC4.IfcQuantityLength(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  3252649465: function _(id, v) {
    return new IFC4.IfcQuantityTime(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcTimeMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  2405470396: function _(id, v) {
    return new IFC4.IfcQuantityVolume(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcVolumeMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  825690147: function _(id, v) {
    return new IFC4.IfcQuantityWeight(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcMassMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  3915482550: function _(id, v) {
    return new IFC4.IfcRecurrencePattern(id, v[0], !v[1] ? null : v[1].map(function (p) {
      return new IFC4.IfcDayInMonthNumber(p.value);
    }), !v[2] ? null : v[2].map(function (p) {
      return new IFC4.IfcDayInWeekNumber(p.value);
    }), !v[3] ? null : v[3].map(function (p) {
      return new IFC4.IfcMonthInYearNumber(p.value);
    }), !v[4] ? null : new IFC4.IfcInteger(v[4].value), !v[5] ? null : new IFC4.IfcInteger(v[5].value), !v[6] ? null : new IFC4.IfcInteger(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2433181523: function _(id, v) {
    return new IFC4.IfcReference(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new IFC4.IfcInteger(p.value);
    }), !v[4] ? null : new Handle(v[4].value));
  },
  1076942058: function _(id, v) {
    return new IFC4.IfcRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3377609919: function _(id, v) {
    return new IFC4.IfcRepresentationContext(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value));
  },
  3008791417: function _(id, _111) {
    return new IFC4.IfcRepresentationItem(id);
  },
  1660063152: function _(id, v) {
    return new IFC4.IfcRepresentationMap(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  2439245199: function _(id, v) {
    return new IFC4.IfcResourceLevelRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value));
  },
  2341007311: function _(id, v) {
    return new IFC4.IfcRoot(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  448429030: function _(id, v) {
    return new IFC4.IfcSIUnit(id, v[0], v[1], v[2]);
  },
  1054537805: function _(id, v) {
    return new IFC4.IfcSchedulingTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value));
  },
  867548509: function _(id, v) {
    return new IFC4.IfcShapeAspect(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), new IFC4.IfcLogical(v[3].value), !v[4] ? null : new Handle(v[4].value));
  },
  3982875396: function _(id, v) {
    return new IFC4.IfcShapeModel(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  4240577450: function _(id, v) {
    return new IFC4.IfcShapeRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2273995522: function _(id, v) {
    return new IFC4.IfcStructuralConnectionCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value));
  },
  2162789131: function _(id, v) {
    return new IFC4.IfcStructuralLoad(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value));
  },
  3478079324: function _(id, v) {
    return new IFC4.IfcStructuralLoadConfiguration(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : v[2].map(function (p) {
      return new IFC4.IfcLengthMeasure(p.value);
    }));
  },
  609421318: function _(id, v) {
    return new IFC4.IfcStructuralLoadOrResult(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value));
  },
  2525727697: function _(id, v) {
    return new IFC4.IfcStructuralLoadStatic(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value));
  },
  3408363356: function _(id, v) {
    return new IFC4.IfcStructuralLoadTemperature(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcThermodynamicTemperatureMeasure(v[1].value), !v[2] ? null : new IFC4.IfcThermodynamicTemperatureMeasure(v[2].value), !v[3] ? null : new IFC4.IfcThermodynamicTemperatureMeasure(v[3].value));
  },
  2830218821: function _(id, v) {
    return new IFC4.IfcStyleModel(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3958052878: function _(id, v) {
    return new IFC4.IfcStyledItem(id, !v[0] ? null : new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC4.IfcLabel(v[2].value));
  },
  3049322572: function _(id, v) {
    return new IFC4.IfcStyledRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2934153892: function _(id, v) {
    return new IFC4.IfcSurfaceReinforcementArea(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return new IFC4.IfcLengthMeasure(p.value);
    }), !v[2] ? null : v[2].map(function (p) {
      return new IFC4.IfcLengthMeasure(p.value);
    }), !v[3] ? null : new IFC4.IfcRatioMeasure(v[3].value));
  },
  1300840506: function _(id, v) {
    return new IFC4.IfcSurfaceStyle(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3303107099: function _(id, v) {
    return new IFC4.IfcSurfaceStyleLighting(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new Handle(v[3].value));
  },
  1607154358: function _(id, v) {
    return new IFC4.IfcSurfaceStyleRefraction(id, !v[0] ? null : new IFC4.IfcReal(v[0].value), !v[1] ? null : new IFC4.IfcReal(v[1].value));
  },
  846575682: function _(id, v) {
    return new IFC4.IfcSurfaceStyleShading(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcNormalisedRatioMeasure(v[1].value));
  },
  1351298697: function _(id, v) {
    return new IFC4.IfcSurfaceStyleWithTextures(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  626085974: function _(id, v) {
    return new IFC4.IfcSurfaceTexture(id, new IFC4.IfcBoolean(v[0].value), new IFC4.IfcBoolean(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new IFC4.IfcIdentifier(p.value);
    }));
  },
  985171141: function _(id, v) {
    return new IFC4.IfcTable(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2043862942: function _(id, v) {
    return new IFC4.IfcTableColumn(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value));
  },
  531007025: function _(id, v) {
    return new IFC4.IfcTableRow(id, !v[0] ? null : v[0].map(function (p) {
      return TypeInitialiser(3, p);
    }), !v[1] ? null : new IFC4.IfcBoolean(v[1].value));
  },
  1549132990: function _(id, v) {
    return new IFC4.IfcTaskTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3], !v[4] ? null : new IFC4.IfcDuration(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcDateTime(v[6].value), !v[7] ? null : new IFC4.IfcDateTime(v[7].value), !v[8] ? null : new IFC4.IfcDateTime(v[8].value), !v[9] ? null : new IFC4.IfcDateTime(v[9].value), !v[10] ? null : new IFC4.IfcDateTime(v[10].value), !v[11] ? null : new IFC4.IfcDuration(v[11].value), !v[12] ? null : new IFC4.IfcDuration(v[12].value), !v[13] ? null : new IFC4.IfcBoolean(v[13].value), !v[14] ? null : new IFC4.IfcDateTime(v[14].value), !v[15] ? null : new IFC4.IfcDuration(v[15].value), !v[16] ? null : new IFC4.IfcDateTime(v[16].value), !v[17] ? null : new IFC4.IfcDateTime(v[17].value), !v[18] ? null : new IFC4.IfcDuration(v[18].value), !v[19] ? null : new IFC4.IfcPositiveRatioMeasure(v[19].value));
  },
  2771591690: function _(id, v) {
    return new IFC4.IfcTaskTimeRecurring(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3], !v[4] ? null : new IFC4.IfcDuration(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcDateTime(v[6].value), !v[7] ? null : new IFC4.IfcDateTime(v[7].value), !v[8] ? null : new IFC4.IfcDateTime(v[8].value), !v[9] ? null : new IFC4.IfcDateTime(v[9].value), !v[10] ? null : new IFC4.IfcDateTime(v[10].value), !v[11] ? null : new IFC4.IfcDuration(v[11].value), !v[12] ? null : new IFC4.IfcDuration(v[12].value), !v[13] ? null : new IFC4.IfcBoolean(v[13].value), !v[14] ? null : new IFC4.IfcDateTime(v[14].value), !v[15] ? null : new IFC4.IfcDuration(v[15].value), !v[16] ? null : new IFC4.IfcDateTime(v[16].value), !v[17] ? null : new IFC4.IfcDateTime(v[17].value), !v[18] ? null : new IFC4.IfcDuration(v[18].value), !v[19] ? null : new IFC4.IfcPositiveRatioMeasure(v[19].value), new Handle(v[20].value));
  },
  912023232: function _(id, v) {
    return new IFC4.IfcTelecomAddress(id, v[0], !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new IFC4.IfcLabel(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new IFC4.IfcLabel(p.value);
    }), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : v[6].map(function (p) {
      return new IFC4.IfcLabel(p.value);
    }), !v[7] ? null : new IFC4.IfcURIReference(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new IFC4.IfcURIReference(p.value);
    }));
  },
  1447204868: function _(id, v) {
    return new IFC4.IfcTextStyle(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcBoolean(v[4].value));
  },
  2636378356: function _(id, v) {
    return new IFC4.IfcTextStyleForDefinedFont(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  1640371178: function _(id, v) {
    return new IFC4.IfcTextStyleTextModel(id, !v[0] ? null : TypeInitialiser(3, v[0]), !v[1] ? null : new IFC4.IfcTextAlignment(v[1].value), !v[2] ? null : new IFC4.IfcTextDecoration(v[2].value), !v[3] ? null : TypeInitialiser(3, v[3]), !v[4] ? null : TypeInitialiser(3, v[4]), !v[5] ? null : new IFC4.IfcTextTransformation(v[5].value), !v[6] ? null : TypeInitialiser(3, v[6]));
  },
  280115917: function _(id, v) {
    return new IFC4.IfcTextureCoordinate(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1742049831: function _(id, v) {
    return new IFC4.IfcTextureCoordinateGenerator(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4.IfcLabel(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return new IFC4.IfcReal(p.value);
    }));
  },
  2552916305: function _(id, v) {
    return new IFC4.IfcTextureMap(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[2].value));
  },
  1210645708: function _(id, v) {
    return new IFC4.IfcTextureVertex(id, v[0].map(function (p) {
      return new IFC4.IfcParameterValue(p.value);
    }));
  },
  3611470254: function _(id, v) {
    return new IFC4.IfcTextureVertexList(id, v[0].map(function (p) {
      return new IFC4.IfcParameterValue(p.value);
    }));
  },
  1199560280: function _(id, v) {
    return new IFC4.IfcTimePeriod(id, new IFC4.IfcTime(v[0].value), new IFC4.IfcTime(v[1].value));
  },
  3101149627: function _(id, v) {
    return new IFC4.IfcTimeSeries(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new IFC4.IfcDateTime(v[2].value), new IFC4.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  581633288: function _(id, v) {
    return new IFC4.IfcTimeSeriesValue(id, v[0].map(function (p) {
      return TypeInitialiser(3, p);
    }));
  },
  1377556343: function _(id, _112) {
    return new IFC4.IfcTopologicalRepresentationItem(id);
  },
  1735638870: function _(id, v) {
    return new IFC4.IfcTopologyRepresentation(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  180925521: function _(id, v) {
    return new IFC4.IfcUnitAssignment(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2799835756: function _(id, _113) {
    return new IFC4.IfcVertex(id);
  },
  1907098498: function _(id, v) {
    return new IFC4.IfcVertexPoint(id, new Handle(v[0].value));
  },
  891718957: function _(id, v) {
    return new IFC4.IfcVirtualGridIntersection(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1].map(function (p) {
      return new IFC4.IfcLengthMeasure(p.value);
    }));
  },
  1236880293: function _(id, v) {
    return new IFC4.IfcWorkTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4.IfcDate(v[4].value), !v[5] ? null : new IFC4.IfcDate(v[5].value));
  },
  3869604511: function _(id, v) {
    return new IFC4.IfcApprovalRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3798115385: function _(id, v) {
    return new IFC4.IfcArbitraryClosedProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value));
  },
  1310608509: function _(id, v) {
    return new IFC4.IfcArbitraryOpenProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value));
  },
  2705031697: function _(id, v) {
    return new IFC4.IfcArbitraryProfileDefWithVoids(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  616511568: function _(id, v) {
    return new IFC4.IfcBlobTexture(id, new IFC4.IfcBoolean(v[0].value), new IFC4.IfcBoolean(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new IFC4.IfcIdentifier(p.value);
    }), new IFC4.IfcIdentifier(v[5].value), new IFC4.IfcBinary(v[6].value));
  },
  3150382593: function _(id, v) {
    return new IFC4.IfcCenterLineProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value));
  },
  747523909: function _(id, v) {
    return new IFC4.IfcClassification(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcDate(v[2].value), new IFC4.IfcLabel(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new IFC4.IfcURIReference(v[5].value), !v[6] ? null : v[6].map(function (p) {
      return new IFC4.IfcIdentifier(p.value);
    }));
  },
  647927063: function _(id, v) {
    return new IFC4.IfcClassificationReference(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value));
  },
  3285139300: function _(id, v) {
    return new IFC4.IfcColourRgbList(id, v[0].map(function (p) {
      return new IFC4.IfcNormalisedRatioMeasure(p.value);
    }));
  },
  3264961684: function _(id, v) {
    return new IFC4.IfcColourSpecification(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value));
  },
  1485152156: function _(id, v) {
    return new IFC4.IfcCompositeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : new IFC4.IfcLabel(v[3].value));
  },
  370225590: function _(id, v) {
    return new IFC4.IfcConnectedFaceSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1981873012: function _(id, v) {
    return new IFC4.IfcConnectionCurveGeometry(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  45288368: function _(id, v) {
    return new IFC4.IfcConnectionPointEccentricity(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLengthMeasure(v[4].value));
  },
  3050246964: function _(id, v) {
    return new IFC4.IfcContextDependentUnit(id, new Handle(v[0].value), v[1], new IFC4.IfcLabel(v[2].value));
  },
  2889183280: function _(id, v) {
    return new IFC4.IfcConversionBasedUnit(id, new Handle(v[0].value), v[1], new IFC4.IfcLabel(v[2].value), new Handle(v[3].value));
  },
  2713554722: function _(id, v) {
    return new IFC4.IfcConversionBasedUnitWithOffset(id, new Handle(v[0].value), v[1], new IFC4.IfcLabel(v[2].value), new Handle(v[3].value), new IFC4.IfcReal(v[4].value));
  },
  539742890: function _(id, v) {
    return new IFC4.IfcCurrencyRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), new IFC4.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  3800577675: function _(id, v) {
    return new IFC4.IfcCurveStyle(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new IFC4.IfcBoolean(v[4].value));
  },
  1105321065: function _(id, v) {
    return new IFC4.IfcCurveStyleFont(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2367409068: function _(id, v) {
    return new IFC4.IfcCurveStyleFontAndScaling(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), new IFC4.IfcPositiveRatioMeasure(v[2].value));
  },
  3510044353: function _(id, v) {
    return new IFC4.IfcCurveStyleFontPattern(id, new IFC4.IfcLengthMeasure(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value));
  },
  3632507154: function _(id, v) {
    return new IFC4.IfcDerivedProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  1154170062: function _(id, v) {
    return new IFC4.IfcDocumentInformation(id, new IFC4.IfcIdentifier(v[0].value), new IFC4.IfcLabel(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), !v[3] ? null : new IFC4.IfcURIReference(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new IFC4.IfcText(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new IFC4.IfcDateTime(v[10].value), !v[11] ? null : new IFC4.IfcDateTime(v[11].value), !v[12] ? null : new IFC4.IfcIdentifier(v[12].value), !v[13] ? null : new IFC4.IfcDate(v[13].value), !v[14] ? null : new IFC4.IfcDate(v[14].value), v[15], v[16]);
  },
  770865208: function _(id, v) {
    return new IFC4.IfcDocumentInformationRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  3732053477: function _(id, v) {
    return new IFC4.IfcDocumentReference(id, !v[0] ? null : new IFC4.IfcURIReference(v[0].value), !v[1] ? null : new IFC4.IfcIdentifier(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value));
  },
  3900360178: function _(id, v) {
    return new IFC4.IfcEdge(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  476780140: function _(id, v) {
    return new IFC4.IfcEdgeCurve(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcBoolean(v[3].value));
  },
  211053100: function _(id, v) {
    return new IFC4.IfcEventTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcDateTime(v[3].value), !v[4] ? null : new IFC4.IfcDateTime(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcDateTime(v[6].value));
  },
  297599258: function _(id, v) {
    return new IFC4.IfcExtendedProperties(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1437805879: function _(id, v) {
    return new IFC4.IfcExternalReferenceRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2556980723: function _(id, v) {
    return new IFC4.IfcFace(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1809719519: function _(id, v) {
    return new IFC4.IfcFaceBound(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value));
  },
  803316827: function _(id, v) {
    return new IFC4.IfcFaceOuterBound(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value));
  },
  3008276851: function _(id, v) {
    return new IFC4.IfcFaceSurface(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value), new IFC4.IfcBoolean(v[2].value));
  },
  4219587988: function _(id, v) {
    return new IFC4.IfcFailureConnectionCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4.IfcForceMeasure(v[4].value), !v[5] ? null : new IFC4.IfcForceMeasure(v[5].value), !v[6] ? null : new IFC4.IfcForceMeasure(v[6].value));
  },
  738692330: function _(id, v) {
    return new IFC4.IfcFillAreaStyle(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), !v[2] ? null : new IFC4.IfcBoolean(v[2].value));
  },
  3448662350: function _(id, v) {
    return new IFC4.IfcGeometricRepresentationContext(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), new IFC4.IfcDimensionCount(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value));
  },
  2453401579: function _(id, _114) {
    return new IFC4.IfcGeometricRepresentationItem(id);
  },
  4142052618: function _(id, v) {
    return new IFC4.IfcGeometricRepresentationSubContext(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcPositiveRatioMeasure(v[3].value), v[4], !v[5] ? null : new IFC4.IfcLabel(v[5].value));
  },
  3590301190: function _(id, v) {
    return new IFC4.IfcGeometricSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  178086475: function _(id, v) {
    return new IFC4.IfcGridPlacement(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  812098782: function _(id, v) {
    return new IFC4.IfcHalfSpaceSolid(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value));
  },
  3905492369: function _(id, v) {
    return new IFC4.IfcImageTexture(id, new IFC4.IfcBoolean(v[0].value), new IFC4.IfcBoolean(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new IFC4.IfcIdentifier(p.value);
    }), new IFC4.IfcURIReference(v[5].value));
  },
  3570813810: function _(id, v) {
    return new IFC4.IfcIndexedColourMap(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcNormalisedRatioMeasure(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new IFC4.IfcPositiveInteger(p.value);
    }));
  },
  1437953363: function _(id, v) {
    return new IFC4.IfcIndexedTextureMap(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value), new Handle(v[2].value));
  },
  2133299955: function _(id, v) {
    return new IFC4.IfcIndexedTriangleTextureMap(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : v[3].map(function (p) {
      return new IFC4.IfcPositiveInteger(p.value);
    }));
  },
  3741457305: function _(id, v) {
    return new IFC4.IfcIrregularTimeSeries(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new IFC4.IfcDateTime(v[2].value), new IFC4.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), v[8].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1585845231: function _(id, v) {
    return new IFC4.IfcLagTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), TypeInitialiser(3, v[3]), v[4]);
  },
  1402838566: function _(id, v) {
    return new IFC4.IfcLightSource(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value));
  },
  125510826: function _(id, v) {
    return new IFC4.IfcLightSourceAmbient(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value));
  },
  2604431987: function _(id, v) {
    return new IFC4.IfcLightSourceDirectional(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value));
  },
  4266656042: function _(id, v) {
    return new IFC4.IfcLightSourceGoniometric(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), new IFC4.IfcThermodynamicTemperatureMeasure(v[6].value), new IFC4.IfcLuminousFluxMeasure(v[7].value), v[8], new Handle(v[9].value));
  },
  1520743889: function _(id, v) {
    return new IFC4.IfcLightSourcePositional(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcReal(v[6].value), new IFC4.IfcReal(v[7].value), new IFC4.IfcReal(v[8].value));
  },
  3422422726: function _(id, v) {
    return new IFC4.IfcLightSourceSpot(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new Handle(v[1].value), !v[2] ? null : new IFC4.IfcNormalisedRatioMeasure(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value), new Handle(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcReal(v[6].value), new IFC4.IfcReal(v[7].value), new IFC4.IfcReal(v[8].value), new Handle(v[9].value), !v[10] ? null : new IFC4.IfcReal(v[10].value), new IFC4.IfcPositivePlaneAngleMeasure(v[11].value), new IFC4.IfcPositivePlaneAngleMeasure(v[12].value));
  },
  2624227202: function _(id, v) {
    return new IFC4.IfcLocalPlacement(id, !v[0] ? null : new Handle(v[0].value), new Handle(v[1].value));
  },
  1008929658: function _(id, _115) {
    return new IFC4.IfcLoop(id);
  },
  2347385850: function _(id, v) {
    return new IFC4.IfcMappedItem(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  1838606355: function _(id, v) {
    return new IFC4.IfcMaterial(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value));
  },
  3708119e3: function _(id, v) {
    return new IFC4.IfcMaterialConstituent(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcNormalisedRatioMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  2852063980: function _(id, v) {
    return new IFC4.IfcMaterialConstituentSet(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2022407955: function _(id, v) {
    return new IFC4.IfcMaterialDefinitionRepresentation(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[3].value));
  },
  1303795690: function _(id, v) {
    return new IFC4.IfcMaterialLayerSetUsage(id, new Handle(v[0].value), v[1], v[2], new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value));
  },
  3079605661: function _(id, v) {
    return new IFC4.IfcMaterialProfileSetUsage(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcCardinalPointReference(v[1].value), !v[2] ? null : new IFC4.IfcPositiveLengthMeasure(v[2].value));
  },
  3404854881: function _(id, v) {
    return new IFC4.IfcMaterialProfileSetUsageTapering(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcCardinalPointReference(v[1].value), !v[2] ? null : new IFC4.IfcPositiveLengthMeasure(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcCardinalPointReference(v[4].value));
  },
  3265635763: function _(id, v) {
    return new IFC4.IfcMaterialProperties(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[3].value));
  },
  853536259: function _(id, v) {
    return new IFC4.IfcMaterialRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  2998442950: function _(id, v) {
    return new IFC4.IfcMirroredProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcLabel(v[3].value));
  },
  219451334: function _(id, v) {
    return new IFC4.IfcObjectDefinition(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  2665983363: function _(id, v) {
    return new IFC4.IfcOpenShell(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1411181986: function _(id, v) {
    return new IFC4.IfcOrganizationRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1029017970: function _(id, v) {
    return new IFC4.IfcOrientedEdge(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value));
  },
  2529465313: function _(id, v) {
    return new IFC4.IfcParameterizedProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  2519244187: function _(id, v) {
    return new IFC4.IfcPath(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3021840470: function _(id, v) {
    return new IFC4.IfcPhysicalComplexQuantity(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new IFC4.IfcLabel(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value));
  },
  597895409: function _(id, v) {
    return new IFC4.IfcPixelTexture(id, new IFC4.IfcBoolean(v[0].value), new IFC4.IfcBoolean(v[1].value), !v[2] ? null : new IFC4.IfcIdentifier(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : v[4].map(function (p) {
      return new IFC4.IfcIdentifier(p.value);
    }), new IFC4.IfcInteger(v[5].value), new IFC4.IfcInteger(v[6].value), new IFC4.IfcInteger(v[7].value), v[8].map(function (p) {
      return new IFC4.IfcBinary(p.value);
    }));
  },
  2004835150: function _(id, v) {
    return new IFC4.IfcPlacement(id, new Handle(v[0].value));
  },
  1663979128: function _(id, v) {
    return new IFC4.IfcPlanarExtent(id, new IFC4.IfcLengthMeasure(v[0].value), new IFC4.IfcLengthMeasure(v[1].value));
  },
  2067069095: function _(id, _116) {
    return new IFC4.IfcPoint(id);
  },
  4022376103: function _(id, v) {
    return new IFC4.IfcPointOnCurve(id, new Handle(v[0].value), new IFC4.IfcParameterValue(v[1].value));
  },
  1423911732: function _(id, v) {
    return new IFC4.IfcPointOnSurface(id, new Handle(v[0].value), new IFC4.IfcParameterValue(v[1].value), new IFC4.IfcParameterValue(v[2].value));
  },
  2924175390: function _(id, v) {
    return new IFC4.IfcPolyLoop(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2775532180: function _(id, v) {
    return new IFC4.IfcPolygonalBoundedHalfSpace(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value), new Handle(v[2].value), new Handle(v[3].value));
  },
  3727388367: function _(id, v) {
    return new IFC4.IfcPreDefinedItem(id, new IFC4.IfcLabel(v[0].value));
  },
  3778827333: function _(id, _117) {
    return new IFC4.IfcPreDefinedProperties(id);
  },
  1775413392: function _(id, v) {
    return new IFC4.IfcPreDefinedTextFont(id, new IFC4.IfcLabel(v[0].value));
  },
  673634403: function _(id, v) {
    return new IFC4.IfcProductDefinitionShape(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2802850158: function _(id, v) {
    return new IFC4.IfcProfileProperties(id, !v[0] ? null : new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[3].value));
  },
  2598011224: function _(id, v) {
    return new IFC4.IfcProperty(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value));
  },
  1680319473: function _(id, v) {
    return new IFC4.IfcPropertyDefinition(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  148025276: function _(id, v) {
    return new IFC4.IfcPropertyDependencyRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), new Handle(v[3].value), !v[4] ? null : new IFC4.IfcText(v[4].value));
  },
  3357820518: function _(id, v) {
    return new IFC4.IfcPropertySetDefinition(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  1482703590: function _(id, v) {
    return new IFC4.IfcPropertyTemplateDefinition(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  2090586900: function _(id, v) {
    return new IFC4.IfcQuantitySet(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  3615266464: function _(id, v) {
    return new IFC4.IfcRectangleProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value));
  },
  3413951693: function _(id, v) {
    return new IFC4.IfcRegularTimeSeries(id, new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new IFC4.IfcDateTime(v[2].value), new IFC4.IfcDateTime(v[3].value), v[4], v[5], !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), new IFC4.IfcTimeMeasure(v[8].value), v[9].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1580146022: function _(id, v) {
    return new IFC4.IfcReinforcementBarProperties(id, new IFC4.IfcAreaMeasure(v[0].value), new IFC4.IfcLabel(v[1].value), v[2], !v[3] ? null : new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4.IfcCountMeasure(v[5].value));
  },
  478536968: function _(id, v) {
    return new IFC4.IfcRelationship(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  2943643501: function _(id, v) {
    return new IFC4.IfcResourceApprovalRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[3].value));
  },
  1608871552: function _(id, v) {
    return new IFC4.IfcResourceConstraintRelationship(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new Handle(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1042787934: function _(id, v) {
    return new IFC4.IfcResourceTime(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), v[1], !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcDuration(v[3].value), !v[4] ? null : new IFC4.IfcPositiveRatioMeasure(v[4].value), !v[5] ? null : new IFC4.IfcDateTime(v[5].value), !v[6] ? null : new IFC4.IfcDateTime(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcDuration(v[8].value), !v[9] ? null : new IFC4.IfcBoolean(v[9].value), !v[10] ? null : new IFC4.IfcDateTime(v[10].value), !v[11] ? null : new IFC4.IfcDuration(v[11].value), !v[12] ? null : new IFC4.IfcPositiveRatioMeasure(v[12].value), !v[13] ? null : new IFC4.IfcDateTime(v[13].value), !v[14] ? null : new IFC4.IfcDateTime(v[14].value), !v[15] ? null : new IFC4.IfcDuration(v[15].value), !v[16] ? null : new IFC4.IfcPositiveRatioMeasure(v[16].value), !v[17] ? null : new IFC4.IfcPositiveRatioMeasure(v[17].value));
  },
  2778083089: function _(id, v) {
    return new IFC4.IfcRoundedRectangleProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value));
  },
  2042790032: function _(id, v) {
    return new IFC4.IfcSectionProperties(id, v[0], new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  4165799628: function _(id, v) {
    return new IFC4.IfcSectionReinforcementProperties(id, new IFC4.IfcLengthMeasure(v[0].value), new IFC4.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLengthMeasure(v[2].value), v[3], new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1509187699: function _(id, v) {
    return new IFC4.IfcSectionedSpine(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  4124623270: function _(id, v) {
    return new IFC4.IfcShellBasedSurfaceModel(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3692461612: function _(id, v) {
    return new IFC4.IfcSimpleProperty(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value));
  },
  2609359061: function _(id, v) {
    return new IFC4.IfcSlippageConnectionCondition(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcLengthMeasure(v[3].value));
  },
  723233188: function _(id, _118) {
    return new IFC4.IfcSolidModel(id);
  },
  1595516126: function _(id, v) {
    return new IFC4.IfcStructuralLoadLinearForce(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLinearForceMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLinearForceMeasure(v[2].value), !v[3] ? null : new IFC4.IfcLinearForceMeasure(v[3].value), !v[4] ? null : new IFC4.IfcLinearMomentMeasure(v[4].value), !v[5] ? null : new IFC4.IfcLinearMomentMeasure(v[5].value), !v[6] ? null : new IFC4.IfcLinearMomentMeasure(v[6].value));
  },
  2668620305: function _(id, v) {
    return new IFC4.IfcStructuralLoadPlanarForce(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcPlanarForceMeasure(v[1].value), !v[2] ? null : new IFC4.IfcPlanarForceMeasure(v[2].value), !v[3] ? null : new IFC4.IfcPlanarForceMeasure(v[3].value));
  },
  2473145415: function _(id, v) {
    return new IFC4.IfcStructuralLoadSingleDisplacement(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC4.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC4.IfcPlaneAngleMeasure(v[6].value));
  },
  1973038258: function _(id, v) {
    return new IFC4.IfcStructuralLoadSingleDisplacementDistortion(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcPlaneAngleMeasure(v[4].value), !v[5] ? null : new IFC4.IfcPlaneAngleMeasure(v[5].value), !v[6] ? null : new IFC4.IfcPlaneAngleMeasure(v[6].value), !v[7] ? null : new IFC4.IfcCurvatureMeasure(v[7].value));
  },
  1597423693: function _(id, v) {
    return new IFC4.IfcStructuralLoadSingleForce(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC4.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC4.IfcTorqueMeasure(v[6].value));
  },
  1190533807: function _(id, v) {
    return new IFC4.IfcStructuralLoadSingleForceWarping(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), !v[1] ? null : new IFC4.IfcForceMeasure(v[1].value), !v[2] ? null : new IFC4.IfcForceMeasure(v[2].value), !v[3] ? null : new IFC4.IfcForceMeasure(v[3].value), !v[4] ? null : new IFC4.IfcTorqueMeasure(v[4].value), !v[5] ? null : new IFC4.IfcTorqueMeasure(v[5].value), !v[6] ? null : new IFC4.IfcTorqueMeasure(v[6].value), !v[7] ? null : new IFC4.IfcWarpingMomentMeasure(v[7].value));
  },
  2233826070: function _(id, v) {
    return new IFC4.IfcSubedge(id, new Handle(v[0].value), new Handle(v[1].value), new Handle(v[2].value));
  },
  2513912981: function _(id, _119) {
    return new IFC4.IfcSurface(id);
  },
  1878645084: function _(id, v) {
    return new IFC4.IfcSurfaceStyleRendering(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcNormalisedRatioMeasure(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : TypeInitialiser(3, v[7]), v[8]);
  },
  2247615214: function _(id, v) {
    return new IFC4.IfcSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  1260650574: function _(id, v) {
    return new IFC4.IfcSweptDiskSolid(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcPositiveLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4.IfcParameterValue(v[4].value));
  },
  1096409881: function _(id, v) {
    return new IFC4.IfcSweptDiskSolidPolygonal(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), !v[2] ? null : new IFC4.IfcPositiveLengthMeasure(v[2].value), !v[3] ? null : new IFC4.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4.IfcParameterValue(v[4].value), !v[5] ? null : new IFC4.IfcPositiveLengthMeasure(v[5].value));
  },
  230924584: function _(id, v) {
    return new IFC4.IfcSweptSurface(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  3071757647: function _(id, v) {
    return new IFC4.IfcTShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPlaneAngleMeasure(v[11].value));
  },
  901063453: function _(id, _120) {
    return new IFC4.IfcTessellatedItem(id);
  },
  4282788508: function _(id, v) {
    return new IFC4.IfcTextLiteral(id, new IFC4.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2]);
  },
  3124975700: function _(id, v) {
    return new IFC4.IfcTextLiteralWithExtent(id, new IFC4.IfcPresentableText(v[0].value), new Handle(v[1].value), v[2], new Handle(v[3].value), new IFC4.IfcBoxAlignment(v[4].value));
  },
  1983826977: function _(id, v) {
    return new IFC4.IfcTextStyleFontModel(id, new IFC4.IfcLabel(v[0].value), v[1].map(function (p) {
      return new IFC4.IfcTextFontName(p.value);
    }), !v[2] ? null : new IFC4.IfcFontStyle(v[2].value), !v[3] ? null : new IFC4.IfcFontVariant(v[3].value), !v[4] ? null : new IFC4.IfcFontWeight(v[4].value), TypeInitialiser(3, v[5]));
  },
  2715220739: function _(id, v) {
    return new IFC4.IfcTrapeziumProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcLengthMeasure(v[6].value));
  },
  1628702193: function _(id, v) {
    return new IFC4.IfcTypeObject(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3736923433: function _(id, v) {
    return new IFC4.IfcTypeProcess(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  2347495698: function _(id, v) {
    return new IFC4.IfcTypeProduct(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value));
  },
  3698973494: function _(id, v) {
    return new IFC4.IfcTypeResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  427810014: function _(id, v) {
    return new IFC4.IfcUShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPlaneAngleMeasure(v[9].value));
  },
  1417489154: function _(id, v) {
    return new IFC4.IfcVector(id, new Handle(v[0].value), new IFC4.IfcLengthMeasure(v[1].value));
  },
  2759199220: function _(id, v) {
    return new IFC4.IfcVertexLoop(id, new Handle(v[0].value));
  },
  1299126871: function _(id, v) {
    return new IFC4.IfcWindowStyle(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], v[9], new IFC4.IfcBoolean(v[10].value), new IFC4.IfcBoolean(v[11].value));
  },
  2543172580: function _(id, v) {
    return new IFC4.IfcZShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[8].value));
  },
  3406155212: function _(id, v) {
    return new IFC4.IfcAdvancedFace(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[1].value), new IFC4.IfcBoolean(v[2].value));
  },
  669184980: function _(id, v) {
    return new IFC4.IfcAnnotationFillArea(id, new Handle(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3207858831: function _(id, v) {
    return new IFC4.IfcAsymmetricIShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPlaneAngleMeasure(v[12].value), !v[13] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[13].value), !v[14] ? null : new IFC4.IfcPlaneAngleMeasure(v[14].value));
  },
  4261334040: function _(id, v) {
    return new IFC4.IfcAxis1Placement(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  3125803723: function _(id, v) {
    return new IFC4.IfcAxis2Placement2D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value));
  },
  2740243338: function _(id, v) {
    return new IFC4.IfcAxis2Placement3D(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value));
  },
  2736907675: function _(id, v) {
    return new IFC4.IfcBooleanResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value));
  },
  4182860854: function _(id, _121) {
    return new IFC4.IfcBoundedSurface(id);
  },
  2581212453: function _(id, v) {
    return new IFC4.IfcBoundingBox(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value));
  },
  2713105998: function _(id, v) {
    return new IFC4.IfcBoxedHalfSpace(id, new Handle(v[0].value), new IFC4.IfcBoolean(v[1].value), new Handle(v[2].value));
  },
  2898889636: function _(id, v) {
    return new IFC4.IfcCShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value));
  },
  1123145078: function _(id, v) {
    return new IFC4.IfcCartesianPoint(id, v[0].map(function (p) {
      return new IFC4.IfcLengthMeasure(p.value);
    }));
  },
  574549367: function _(id, _122) {
    return new IFC4.IfcCartesianPointList(id);
  },
  1675464909: function _(id, v) {
    return new IFC4.IfcCartesianPointList2D(id, v[0].map(function (p) {
      return new IFC4.IfcLengthMeasure(p.value);
    }));
  },
  2059837836: function _(id, v) {
    return new IFC4.IfcCartesianPointList3D(id, v[0].map(function (p) {
      return new IFC4.IfcLengthMeasure(p.value);
    }));
  },
  59481748: function _(id, v) {
    return new IFC4.IfcCartesianTransformationOperator(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value));
  },
  3749851601: function _(id, v) {
    return new IFC4.IfcCartesianTransformationOperator2D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value));
  },
  3486308946: function _(id, v) {
    return new IFC4.IfcCartesianTransformationOperator2DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value), !v[4] ? null : new IFC4.IfcReal(v[4].value));
  },
  3331915920: function _(id, v) {
    return new IFC4.IfcCartesianTransformationOperator3D(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value), !v[4] ? null : new Handle(v[4].value));
  },
  1416205885: function _(id, v) {
    return new IFC4.IfcCartesianTransformationOperator3DnonUniform(id, !v[0] ? null : new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcReal(v[3].value), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : new IFC4.IfcReal(v[5].value), !v[6] ? null : new IFC4.IfcReal(v[6].value));
  },
  1383045692: function _(id, v) {
    return new IFC4.IfcCircleProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value));
  },
  2205249479: function _(id, v) {
    return new IFC4.IfcClosedShell(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  776857604: function _(id, v) {
    return new IFC4.IfcColourRgb(id, !v[0] ? null : new IFC4.IfcLabel(v[0].value), new IFC4.IfcNormalisedRatioMeasure(v[1].value), new IFC4.IfcNormalisedRatioMeasure(v[2].value), new IFC4.IfcNormalisedRatioMeasure(v[3].value));
  },
  2542286263: function _(id, v) {
    return new IFC4.IfcComplexProperty(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), new IFC4.IfcIdentifier(v[2].value), v[3].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2485617015: function _(id, v) {
    return new IFC4.IfcCompositeCurveSegment(id, v[0], new IFC4.IfcBoolean(v[1].value), new Handle(v[2].value));
  },
  2574617495: function _(id, v) {
    return new IFC4.IfcConstructionResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value));
  },
  3419103109: function _(id, v) {
    return new IFC4.IfcContext(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new Handle(v[8].value));
  },
  1815067380: function _(id, v) {
    return new IFC4.IfcCrewResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  2506170314: function _(id, v) {
    return new IFC4.IfcCsgPrimitive3D(id, new Handle(v[0].value));
  },
  2147822146: function _(id, v) {
    return new IFC4.IfcCsgSolid(id, new Handle(v[0].value));
  },
  2601014836: function _(id, _123) {
    return new IFC4.IfcCurve(id);
  },
  2827736869: function _(id, v) {
    return new IFC4.IfcCurveBoundedPlane(id, new Handle(v[0].value), new Handle(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2629017746: function _(id, v) {
    return new IFC4.IfcCurveBoundedSurface(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), new IFC4.IfcBoolean(v[2].value));
  },
  32440307: function _(id, v) {
    return new IFC4.IfcDirection(id, v[0].map(function (p) {
      return new IFC4.IfcReal(p.value);
    }));
  },
  526551008: function _(id, v) {
    return new IFC4.IfcDoorStyle(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], v[9], new IFC4.IfcBoolean(v[10].value), new IFC4.IfcBoolean(v[11].value));
  },
  1472233963: function _(id, v) {
    return new IFC4.IfcEdgeLoop(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1883228015: function _(id, v) {
    return new IFC4.IfcElementQuantity(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  339256511: function _(id, v) {
    return new IFC4.IfcElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  2777663545: function _(id, v) {
    return new IFC4.IfcElementarySurface(id, new Handle(v[0].value));
  },
  2835456948: function _(id, v) {
    return new IFC4.IfcEllipseProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value));
  },
  4024345920: function _(id, v) {
    return new IFC4.IfcEventType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4.IfcLabel(v[11].value));
  },
  477187591: function _(id, v) {
    return new IFC4.IfcExtrudedAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value));
  },
  2804161546: function _(id, v) {
    return new IFC4.IfcExtrudedAreaSolidTapered(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new Handle(v[4].value));
  },
  2047409740: function _(id, v) {
    return new IFC4.IfcFaceBasedSurfaceModel(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  374418227: function _(id, v) {
    return new IFC4.IfcFillAreaStyleHatching(id, new Handle(v[0].value), new Handle(v[1].value), !v[2] ? null : new Handle(v[2].value), !v[3] ? null : new Handle(v[3].value), new IFC4.IfcPlaneAngleMeasure(v[4].value));
  },
  315944413: function _(id, v) {
    return new IFC4.IfcFillAreaStyleTiles(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), v[1].map(function (p) {
      return new Handle(p.value);
    }), new IFC4.IfcPositiveRatioMeasure(v[2].value));
  },
  2652556860: function _(id, v) {
    return new IFC4.IfcFixedReferenceSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4.IfcParameterValue(v[4].value), new Handle(v[5].value));
  },
  4238390223: function _(id, v) {
    return new IFC4.IfcFurnishingElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  1268542332: function _(id, v) {
    return new IFC4.IfcFurnitureType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], v[10]);
  },
  4095422895: function _(id, v) {
    return new IFC4.IfcGeographicElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  987898635: function _(id, v) {
    return new IFC4.IfcGeometricCurveSet(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1484403080: function _(id, v) {
    return new IFC4.IfcIShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPlaneAngleMeasure(v[9].value));
  },
  178912537: function _(id, v) {
    return new IFC4.IfcIndexedPolygonalFace(id, v[0].map(function (p) {
      return new IFC4.IfcPositiveInteger(p.value);
    }));
  },
  2294589976: function _(id, v) {
    return new IFC4.IfcIndexedPolygonalFaceWithVoids(id, v[0].map(function (p) {
      return new IFC4.IfcPositiveInteger(p.value);
    }), v[1].map(function (p) {
      return new IFC4.IfcPositiveInteger(p.value);
    }));
  },
  572779678: function _(id, v) {
    return new IFC4.IfcLShapeProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcPlaneAngleMeasure(v[8].value));
  },
  428585644: function _(id, v) {
    return new IFC4.IfcLaborResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  1281925730: function _(id, v) {
    return new IFC4.IfcLine(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  1425443689: function _(id, v) {
    return new IFC4.IfcManifoldSolidBrep(id, new Handle(v[0].value));
  },
  3888040117: function _(id, v) {
    return new IFC4.IfcObject(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  3388369263: function _(id, v) {
    return new IFC4.IfcOffsetCurve2D(id, new Handle(v[0].value), new IFC4.IfcLengthMeasure(v[1].value), new IFC4.IfcLogical(v[2].value));
  },
  3505215534: function _(id, v) {
    return new IFC4.IfcOffsetCurve3D(id, new Handle(v[0].value), new IFC4.IfcLengthMeasure(v[1].value), new IFC4.IfcLogical(v[2].value), new Handle(v[3].value));
  },
  1682466193: function _(id, v) {
    return new IFC4.IfcPcurve(id, new Handle(v[0].value), new Handle(v[1].value));
  },
  603570806: function _(id, v) {
    return new IFC4.IfcPlanarBox(id, new IFC4.IfcLengthMeasure(v[0].value), new IFC4.IfcLengthMeasure(v[1].value), new Handle(v[2].value));
  },
  220341763: function _(id, v) {
    return new IFC4.IfcPlane(id, new Handle(v[0].value));
  },
  759155922: function _(id, v) {
    return new IFC4.IfcPreDefinedColour(id, new IFC4.IfcLabel(v[0].value));
  },
  2559016684: function _(id, v) {
    return new IFC4.IfcPreDefinedCurveFont(id, new IFC4.IfcLabel(v[0].value));
  },
  3967405729: function _(id, v) {
    return new IFC4.IfcPreDefinedPropertySet(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  569719735: function _(id, v) {
    return new IFC4.IfcProcedureType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2945172077: function _(id, v) {
    return new IFC4.IfcProcess(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value));
  },
  4208778838: function _(id, v) {
    return new IFC4.IfcProduct(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  103090709: function _(id, v) {
    return new IFC4.IfcProject(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new Handle(v[8].value));
  },
  653396225: function _(id, v) {
    return new IFC4.IfcProjectLibrary(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new Handle(v[8].value));
  },
  871118103: function _(id, v) {
    return new IFC4.IfcPropertyBoundedValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : TypeInitialiser(3, v[3]), !v[4] ? null : new Handle(v[4].value), !v[5] ? null : TypeInitialiser(3, v[5]));
  },
  4166981789: function _(id, v) {
    return new IFC4.IfcPropertyEnumeratedValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return TypeInitialiser(3, p);
    }), !v[3] ? null : new Handle(v[3].value));
  },
  2752243245: function _(id, v) {
    return new IFC4.IfcPropertyListValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return TypeInitialiser(3, p);
    }), !v[3] ? null : new Handle(v[3].value));
  },
  941946838: function _(id, v) {
    return new IFC4.IfcPropertyReferenceValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : new IFC4.IfcText(v[2].value), !v[3] ? null : new Handle(v[3].value));
  },
  1451395588: function _(id, v) {
    return new IFC4.IfcPropertySet(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }));
  },
  492091185: function _(id, v) {
    return new IFC4.IfcPropertySetTemplate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4], !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3650150729: function _(id, v) {
    return new IFC4.IfcPropertySingleValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : TypeInitialiser(3, v[2]), !v[3] ? null : new Handle(v[3].value));
  },
  110355661: function _(id, v) {
    return new IFC4.IfcPropertyTableValue(id, new IFC4.IfcIdentifier(v[0].value), !v[1] ? null : new IFC4.IfcText(v[1].value), !v[2] ? null : v[2].map(function (p) {
      return TypeInitialiser(3, p);
    }), !v[3] ? null : v[3].map(function (p) {
      return TypeInitialiser(3, p);
    }), !v[4] ? null : new IFC4.IfcText(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7]);
  },
  3521284610: function _(id, v) {
    return new IFC4.IfcPropertyTemplate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  3219374653: function _(id, v) {
    return new IFC4.IfcProxy(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  2770003689: function _(id, v) {
    return new IFC4.IfcRectangleHollowProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value), new IFC4.IfcPositiveLengthMeasure(v[5].value), !v[6] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value));
  },
  2798486643: function _(id, v) {
    return new IFC4.IfcRectangularPyramid(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value));
  },
  3454111270: function _(id, v) {
    return new IFC4.IfcRectangularTrimmedSurface(id, new Handle(v[0].value), new IFC4.IfcParameterValue(v[1].value), new IFC4.IfcParameterValue(v[2].value), new IFC4.IfcParameterValue(v[3].value), new IFC4.IfcParameterValue(v[4].value), new IFC4.IfcBoolean(v[5].value), new IFC4.IfcBoolean(v[6].value));
  },
  3765753017: function _(id, v) {
    return new IFC4.IfcReinforcementDefinitionProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3939117080: function _(id, v) {
    return new IFC4.IfcRelAssigns(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5]);
  },
  1683148259: function _(id, v) {
    return new IFC4.IfcRelAssignsToActor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  2495723537: function _(id, v) {
    return new IFC4.IfcRelAssignsToControl(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  1307041759: function _(id, v) {
    return new IFC4.IfcRelAssignsToGroup(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  1027710054: function _(id, v) {
    return new IFC4.IfcRelAssignsToGroupByFactor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value), new IFC4.IfcRatioMeasure(v[7].value));
  },
  4278684876: function _(id, v) {
    return new IFC4.IfcRelAssignsToProcess(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  2857406711: function _(id, v) {
    return new IFC4.IfcRelAssignsToProduct(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  205026976: function _(id, v) {
    return new IFC4.IfcRelAssignsToResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), v[5], new Handle(v[6].value));
  },
  1865459582: function _(id, v) {
    return new IFC4.IfcRelAssociates(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }));
  },
  4095574036: function _(id, v) {
    return new IFC4.IfcRelAssociatesApproval(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  919958153: function _(id, v) {
    return new IFC4.IfcRelAssociatesClassification(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  2728634034: function _(id, v) {
    return new IFC4.IfcRelAssociatesConstraint(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), !v[5] ? null : new IFC4.IfcLabel(v[5].value), new Handle(v[6].value));
  },
  982818633: function _(id, v) {
    return new IFC4.IfcRelAssociatesDocument(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  3840914261: function _(id, v) {
    return new IFC4.IfcRelAssociatesLibrary(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  2655215786: function _(id, v) {
    return new IFC4.IfcRelAssociatesMaterial(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  826625072: function _(id, v) {
    return new IFC4.IfcRelConnects(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  1204542856: function _(id, v) {
    return new IFC4.IfcRelConnectsElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value));
  },
  3945020480: function _(id, v) {
    return new IFC4.IfcRelConnectsPathElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map(function (p) {
      return new IFC4.IfcInteger(p.value);
    }), v[8].map(function (p) {
      return new IFC4.IfcInteger(p.value);
    }), v[9], v[10]);
  },
  4201705270: function _(id, v) {
    return new IFC4.IfcRelConnectsPortToElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  3190031847: function _(id, v) {
    return new IFC4.IfcRelConnectsPorts(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  2127690289: function _(id, v) {
    return new IFC4.IfcRelConnectsStructuralActivity(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  1638771189: function _(id, v) {
    return new IFC4.IfcRelConnectsStructuralMember(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC4.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value));
  },
  504942748: function _(id, v) {
    return new IFC4.IfcRelConnectsWithEccentricity(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new IFC4.IfcLengthMeasure(v[8].value), !v[9] ? null : new Handle(v[9].value), new Handle(v[10].value));
  },
  3678494232: function _(id, v) {
    return new IFC4.IfcRelConnectsWithRealizingElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new Handle(v[4].value), new Handle(v[5].value), new Handle(v[6].value), v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  3242617779: function _(id, v) {
    return new IFC4.IfcRelContainedInSpatialStructure(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  886880790: function _(id, v) {
    return new IFC4.IfcRelCoversBldgElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2802773753: function _(id, v) {
    return new IFC4.IfcRelCoversSpaces(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2565941209: function _(id, v) {
    return new IFC4.IfcRelDeclares(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2551354335: function _(id, v) {
    return new IFC4.IfcRelDecomposes(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  693640335: function _(id, v) {
    return new IFC4.IfcRelDefines(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value));
  },
  1462361463: function _(id, v) {
    return new IFC4.IfcRelDefinesByObject(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  4186316022: function _(id, v) {
    return new IFC4.IfcRelDefinesByProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  307848117: function _(id, v) {
    return new IFC4.IfcRelDefinesByTemplate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  781010003: function _(id, v) {
    return new IFC4.IfcRelDefinesByType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  3940055652: function _(id, v) {
    return new IFC4.IfcRelFillsElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  279856033: function _(id, v) {
    return new IFC4.IfcRelFlowControlElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  427948657: function _(id, v) {
    return new IFC4.IfcRelInterferesElements(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8].value);
  },
  3268803585: function _(id, v) {
    return new IFC4.IfcRelNests(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  750771296: function _(id, v) {
    return new IFC4.IfcRelProjectsElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  1245217292: function _(id, v) {
    return new IFC4.IfcRelReferencedInSpatialStructure(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4].map(function (p) {
      return new Handle(p.value);
    }), new Handle(v[5].value));
  },
  4122056220: function _(id, v) {
    return new IFC4.IfcRelSequence(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  366585022: function _(id, v) {
    return new IFC4.IfcRelServicesBuildings(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3451746338: function _(id, v) {
    return new IFC4.IfcRelSpaceBoundary(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8]);
  },
  3523091289: function _(id, v) {
    return new IFC4.IfcRelSpaceBoundary1stLevel(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], !v[9] ? null : new Handle(v[9].value));
  },
  1521410863: function _(id, v) {
    return new IFC4.IfcRelSpaceBoundary2ndLevel(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value));
  },
  1401173127: function _(id, v) {
    return new IFC4.IfcRelVoidsElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), new Handle(v[5].value));
  },
  816062949: function _(id, v) {
    return new IFC4.IfcReparametrisedCompositeCurveSegment(id, v[0], new IFC4.IfcBoolean(v[1].value), new Handle(v[2].value), new IFC4.IfcParameterValue(v[3].value));
  },
  2914609552: function _(id, v) {
    return new IFC4.IfcResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value));
  },
  1856042241: function _(id, v) {
    return new IFC4.IfcRevolvedAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcPlaneAngleMeasure(v[3].value));
  },
  3243963512: function _(id, v) {
    return new IFC4.IfcRevolvedAreaSolidTapered(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcPlaneAngleMeasure(v[3].value), new Handle(v[4].value));
  },
  4158566097: function _(id, v) {
    return new IFC4.IfcRightCircularCone(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value));
  },
  3626867408: function _(id, v) {
    return new IFC4.IfcRightCircularCylinder(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value));
  },
  3663146110: function _(id, v) {
    return new IFC4.IfcSimplePropertyTemplate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4], !v[5] ? null : new IFC4.IfcLabel(v[5].value), !v[6] ? null : new IFC4.IfcLabel(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new IFC4.IfcLabel(v[10].value), v[11]);
  },
  1412071761: function _(id, v) {
    return new IFC4.IfcSpatialElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value));
  },
  710998568: function _(id, v) {
    return new IFC4.IfcSpatialElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  2706606064: function _(id, v) {
    return new IFC4.IfcSpatialStructureElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8]);
  },
  3893378262: function _(id, v) {
    return new IFC4.IfcSpatialStructureElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  463610769: function _(id, v) {
    return new IFC4.IfcSpatialZone(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8]);
  },
  2481509218: function _(id, v) {
    return new IFC4.IfcSpatialZoneType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcLabel(v[10].value));
  },
  451544542: function _(id, v) {
    return new IFC4.IfcSphere(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value));
  },
  4015995234: function _(id, v) {
    return new IFC4.IfcSphericalSurface(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value));
  },
  3544373492: function _(id, v) {
    return new IFC4.IfcStructuralActivity(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]);
  },
  3136571912: function _(id, v) {
    return new IFC4.IfcStructuralItem(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  530289379: function _(id, v) {
    return new IFC4.IfcStructuralMember(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  3689010777: function _(id, v) {
    return new IFC4.IfcStructuralReaction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]);
  },
  3979015343: function _(id, v) {
    return new IFC4.IfcStructuralSurfaceMember(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value));
  },
  2218152070: function _(id, v) {
    return new IFC4.IfcStructuralSurfaceMemberVarying(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value));
  },
  603775116: function _(id, v) {
    return new IFC4.IfcStructuralSurfaceReaction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9]);
  },
  4095615324: function _(id, v) {
    return new IFC4.IfcSubContractResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  699246055: function _(id, v) {
    return new IFC4.IfcSurfaceCurve(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2]);
  },
  2028607225: function _(id, v) {
    return new IFC4.IfcSurfaceCurveSweptAreaSolid(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), !v[3] ? null : new IFC4.IfcParameterValue(v[3].value), !v[4] ? null : new IFC4.IfcParameterValue(v[4].value), new Handle(v[5].value));
  },
  2809605785: function _(id, v) {
    return new IFC4.IfcSurfaceOfLinearExtrusion(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value), new IFC4.IfcLengthMeasure(v[3].value));
  },
  4124788165: function _(id, v) {
    return new IFC4.IfcSurfaceOfRevolution(id, new Handle(v[0].value), !v[1] ? null : new Handle(v[1].value), new Handle(v[2].value));
  },
  1580310250: function _(id, v) {
    return new IFC4.IfcSystemFurnitureElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3473067441: function _(id, v) {
    return new IFC4.IfcTask(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), new IFC4.IfcBoolean(v[9].value), !v[10] ? null : new IFC4.IfcInteger(v[10].value), !v[11] ? null : new Handle(v[11].value), v[12]);
  },
  3206491090: function _(id, v) {
    return new IFC4.IfcTaskType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcLabel(v[10].value));
  },
  2387106220: function _(id, v) {
    return new IFC4.IfcTessellatedFaceSet(id, new Handle(v[0].value));
  },
  1935646853: function _(id, v) {
    return new IFC4.IfcToroidalSurface(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value));
  },
  2097647324: function _(id, v) {
    return new IFC4.IfcTransportElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2916149573: function _(id, v) {
    return new IFC4.IfcTriangulatedFaceSet(id, new Handle(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return new IFC4.IfcParameterValue(p.value);
    }), !v[2] ? null : new IFC4.IfcBoolean(v[2].value), v[3].map(function (p) {
      return new IFC4.IfcPositiveInteger(p.value);
    }), !v[4] ? null : v[4].map(function (p) {
      return new IFC4.IfcPositiveInteger(p.value);
    }));
  },
  336235671: function _(id, v) {
    return new IFC4.IfcWindowLiningProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[5].value), !v[6] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNormalisedRatioMeasure(v[8].value), !v[9] ? null : new IFC4.IfcNormalisedRatioMeasure(v[9].value), !v[10] ? null : new IFC4.IfcNormalisedRatioMeasure(v[10].value), !v[11] ? null : new IFC4.IfcNormalisedRatioMeasure(v[11].value), !v[12] ? null : new Handle(v[12].value), !v[13] ? null : new IFC4.IfcLengthMeasure(v[13].value), !v[14] ? null : new IFC4.IfcLengthMeasure(v[14].value), !v[15] ? null : new IFC4.IfcLengthMeasure(v[15].value));
  },
  512836454: function _(id, v) {
    return new IFC4.IfcWindowPanelProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value));
  },
  2296667514: function _(id, v) {
    return new IFC4.IfcActor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), new Handle(v[5].value));
  },
  1635779807: function _(id, v) {
    return new IFC4.IfcAdvancedBrep(id, new Handle(v[0].value));
  },
  2603310189: function _(id, v) {
    return new IFC4.IfcAdvancedBrepWithVoids(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1674181508: function _(id, v) {
    return new IFC4.IfcAnnotation(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  2887950389: function _(id, v) {
    return new IFC4.IfcBSplineSurface(id, new IFC4.IfcInteger(v[0].value), new IFC4.IfcInteger(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), v[3], new IFC4.IfcLogical(v[4].value), new IFC4.IfcLogical(v[5].value), new IFC4.IfcLogical(v[6].value));
  },
  167062518: function _(id, v) {
    return new IFC4.IfcBSplineSurfaceWithKnots(id, new IFC4.IfcInteger(v[0].value), new IFC4.IfcInteger(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), v[3], new IFC4.IfcLogical(v[4].value), new IFC4.IfcLogical(v[5].value), new IFC4.IfcLogical(v[6].value), v[7].map(function (p) {
      return new IFC4.IfcInteger(p.value);
    }), v[8].map(function (p) {
      return new IFC4.IfcInteger(p.value);
    }), v[9].map(function (p) {
      return new IFC4.IfcParameterValue(p.value);
    }), v[10].map(function (p) {
      return new IFC4.IfcParameterValue(p.value);
    }), v[11]);
  },
  1334484129: function _(id, v) {
    return new IFC4.IfcBlock(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value));
  },
  3649129432: function _(id, v) {
    return new IFC4.IfcBooleanClippingResult(id, v[0], new Handle(v[1].value), new Handle(v[2].value));
  },
  1260505505: function _(id, _124) {
    return new IFC4.IfcBoundedCurve(id);
  },
  4031249490: function _(id, v) {
    return new IFC4.IfcBuilding(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcLengthMeasure(v[10].value), !v[11] ? null : new Handle(v[11].value));
  },
  1950629157: function _(id, v) {
    return new IFC4.IfcBuildingElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  3124254112: function _(id, v) {
    return new IFC4.IfcBuildingStorey(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4.IfcLengthMeasure(v[9].value));
  },
  2197970202: function _(id, v) {
    return new IFC4.IfcChimneyType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2937912522: function _(id, v) {
    return new IFC4.IfcCircleHollowProfileDef(id, v[0], !v[1] ? null : new IFC4.IfcLabel(v[1].value), !v[2] ? null : new Handle(v[2].value), new IFC4.IfcPositiveLengthMeasure(v[3].value), new IFC4.IfcPositiveLengthMeasure(v[4].value));
  },
  3893394355: function _(id, v) {
    return new IFC4.IfcCivilElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  300633059: function _(id, v) {
    return new IFC4.IfcColumnType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3875453745: function _(id, v) {
    return new IFC4.IfcComplexPropertyTemplate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3732776249: function _(id, v) {
    return new IFC4.IfcCompositeCurve(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4.IfcLogical(v[1].value));
  },
  15328376: function _(id, v) {
    return new IFC4.IfcCompositeCurveOnSurface(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4.IfcLogical(v[1].value));
  },
  2510884976: function _(id, v) {
    return new IFC4.IfcConic(id, new Handle(v[0].value));
  },
  2185764099: function _(id, v) {
    return new IFC4.IfcConstructionEquipmentResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  4105962743: function _(id, v) {
    return new IFC4.IfcConstructionMaterialResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  1525564444: function _(id, v) {
    return new IFC4.IfcConstructionProductResourceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : new IFC4.IfcIdentifier(v[6].value), !v[7] ? null : new IFC4.IfcText(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), !v[10] ? null : new Handle(v[10].value), v[11]);
  },
  2559216714: function _(id, v) {
    return new IFC4.IfcConstructionResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value));
  },
  3293443760: function _(id, v) {
    return new IFC4.IfcControl(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value));
  },
  3895139033: function _(id, v) {
    return new IFC4.IfcCostItem(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6], !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }));
  },
  1419761937: function _(id, v) {
    return new IFC4.IfcCostSchedule(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcDateTime(v[8].value), !v[9] ? null : new IFC4.IfcDateTime(v[9].value));
  },
  1916426348: function _(id, v) {
    return new IFC4.IfcCoveringType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3295246426: function _(id, v) {
    return new IFC4.IfcCrewResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  1457835157: function _(id, v) {
    return new IFC4.IfcCurtainWallType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1213902940: function _(id, v) {
    return new IFC4.IfcCylindricalSurface(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value));
  },
  3256556792: function _(id, v) {
    return new IFC4.IfcDistributionElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  3849074793: function _(id, v) {
    return new IFC4.IfcDistributionFlowElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  2963535650: function _(id, v) {
    return new IFC4.IfcDoorLiningProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value), !v[5] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[5].value), !v[6] ? null : new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[7].value), !v[8] ? null : new IFC4.IfcNonNegativeLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new Handle(v[14].value), !v[15] ? null : new IFC4.IfcLengthMeasure(v[15].value), !v[16] ? null : new IFC4.IfcLengthMeasure(v[16].value));
  },
  1714330368: function _(id, v) {
    return new IFC4.IfcDoorPanelProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcPositiveLengthMeasure(v[4].value), v[5], !v[6] ? null : new IFC4.IfcNormalisedRatioMeasure(v[6].value), v[7], !v[8] ? null : new Handle(v[8].value));
  },
  2323601079: function _(id, v) {
    return new IFC4.IfcDoorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4.IfcBoolean(v[11].value), !v[12] ? null : new IFC4.IfcLabel(v[12].value));
  },
  445594917: function _(id, v) {
    return new IFC4.IfcDraughtingPreDefinedColour(id, new IFC4.IfcLabel(v[0].value));
  },
  4006246654: function _(id, v) {
    return new IFC4.IfcDraughtingPreDefinedCurveFont(id, new IFC4.IfcLabel(v[0].value));
  },
  1758889154: function _(id, v) {
    return new IFC4.IfcElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  4123344466: function _(id, v) {
    return new IFC4.IfcElementAssembly(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8], v[9]);
  },
  2397081782: function _(id, v) {
    return new IFC4.IfcElementAssemblyType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1623761950: function _(id, v) {
    return new IFC4.IfcElementComponent(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  2590856083: function _(id, v) {
    return new IFC4.IfcElementComponentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  1704287377: function _(id, v) {
    return new IFC4.IfcEllipse(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value), new IFC4.IfcPositiveLengthMeasure(v[2].value));
  },
  2107101300: function _(id, v) {
    return new IFC4.IfcEnergyConversionDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  132023988: function _(id, v) {
    return new IFC4.IfcEngineType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3174744832: function _(id, v) {
    return new IFC4.IfcEvaporativeCoolerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3390157468: function _(id, v) {
    return new IFC4.IfcEvaporatorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  4148101412: function _(id, v) {
    return new IFC4.IfcEvent(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), v[7], v[8], !v[9] ? null : new IFC4.IfcLabel(v[9].value), !v[10] ? null : new Handle(v[10].value));
  },
  2853485674: function _(id, v) {
    return new IFC4.IfcExternalSpatialStructureElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value));
  },
  807026263: function _(id, v) {
    return new IFC4.IfcFacetedBrep(id, new Handle(v[0].value));
  },
  3737207727: function _(id, v) {
    return new IFC4.IfcFacetedBrepWithVoids(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }));
  },
  647756555: function _(id, v) {
    return new IFC4.IfcFastener(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2489546625: function _(id, v) {
    return new IFC4.IfcFastenerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2827207264: function _(id, v) {
    return new IFC4.IfcFeatureElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  2143335405: function _(id, v) {
    return new IFC4.IfcFeatureElementAddition(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  1287392070: function _(id, v) {
    return new IFC4.IfcFeatureElementSubtraction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  3907093117: function _(id, v) {
    return new IFC4.IfcFlowControllerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  3198132628: function _(id, v) {
    return new IFC4.IfcFlowFittingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  3815607619: function _(id, v) {
    return new IFC4.IfcFlowMeterType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1482959167: function _(id, v) {
    return new IFC4.IfcFlowMovingDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  1834744321: function _(id, v) {
    return new IFC4.IfcFlowSegmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  1339347760: function _(id, v) {
    return new IFC4.IfcFlowStorageDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  2297155007: function _(id, v) {
    return new IFC4.IfcFlowTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  3009222698: function _(id, v) {
    return new IFC4.IfcFlowTreatmentDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  1893162501: function _(id, v) {
    return new IFC4.IfcFootingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  263784265: function _(id, v) {
    return new IFC4.IfcFurnishingElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  1509553395: function _(id, v) {
    return new IFC4.IfcFurniture(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3493046030: function _(id, v) {
    return new IFC4.IfcGeographicElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3009204131: function _(id, v) {
    return new IFC4.IfcGrid(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7].map(function (p) {
      return new Handle(p.value);
    }), v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : v[9].map(function (p) {
      return new Handle(p.value);
    }), v[10]);
  },
  2706460486: function _(id, v) {
    return new IFC4.IfcGroup(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  1251058090: function _(id, v) {
    return new IFC4.IfcHeatExchangerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1806887404: function _(id, v) {
    return new IFC4.IfcHumidifierType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2571569899: function _(id, v) {
    return new IFC4.IfcIndexedPolyCurve(id, new Handle(v[0].value), !v[1] ? null : v[1].map(function (p) {
      return TypeInitialiser(3, p);
    }), !v[2] ? null : new IFC4.IfcBoolean(v[2].value));
  },
  3946677679: function _(id, v) {
    return new IFC4.IfcInterceptorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3113134337: function _(id, v) {
    return new IFC4.IfcIntersectionCurve(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2]);
  },
  2391368822: function _(id, v) {
    return new IFC4.IfcInventory(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC4.IfcDate(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value));
  },
  4288270099: function _(id, v) {
    return new IFC4.IfcJunctionBoxType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3827777499: function _(id, v) {
    return new IFC4.IfcLaborResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  1051575348: function _(id, v) {
    return new IFC4.IfcLampType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1161773419: function _(id, v) {
    return new IFC4.IfcLightFixtureType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  377706215: function _(id, v) {
    return new IFC4.IfcMechanicalFastener(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), v[10]);
  },
  2108223431: function _(id, v) {
    return new IFC4.IfcMechanicalFastenerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPositiveLengthMeasure(v[11].value));
  },
  1114901282: function _(id, v) {
    return new IFC4.IfcMedicalDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3181161470: function _(id, v) {
    return new IFC4.IfcMemberType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  977012517: function _(id, v) {
    return new IFC4.IfcMotorConnectionType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  4143007308: function _(id, v) {
    return new IFC4.IfcOccupant(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), new Handle(v[5].value), v[6]);
  },
  3588315303: function _(id, v) {
    return new IFC4.IfcOpeningElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3079942009: function _(id, v) {
    return new IFC4.IfcOpeningStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2837617999: function _(id, v) {
    return new IFC4.IfcOutletType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2382730787: function _(id, v) {
    return new IFC4.IfcPerformanceHistory(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), new IFC4.IfcLabel(v[6].value), v[7]);
  },
  3566463478: function _(id, v) {
    return new IFC4.IfcPermeableCoveringProperties(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), v[4], v[5], !v[6] ? null : new IFC4.IfcPositiveLengthMeasure(v[6].value), !v[7] ? null : new IFC4.IfcPositiveLengthMeasure(v[7].value), !v[8] ? null : new Handle(v[8].value));
  },
  3327091369: function _(id, v) {
    return new IFC4.IfcPermit(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcText(v[8].value));
  },
  1158309216: function _(id, v) {
    return new IFC4.IfcPileType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  804291784: function _(id, v) {
    return new IFC4.IfcPipeFittingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  4231323485: function _(id, v) {
    return new IFC4.IfcPipeSegmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  4017108033: function _(id, v) {
    return new IFC4.IfcPlateType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2839578677: function _(id, v) {
    return new IFC4.IfcPolygonalFaceSet(id, new Handle(v[0].value), !v[1] ? null : new IFC4.IfcBoolean(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), !v[3] ? null : v[3].map(function (p) {
      return new IFC4.IfcPositiveInteger(p.value);
    }));
  },
  3724593414: function _(id, v) {
    return new IFC4.IfcPolyline(id, v[0].map(function (p) {
      return new Handle(p.value);
    }));
  },
  3740093272: function _(id, v) {
    return new IFC4.IfcPort(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value));
  },
  2744685151: function _(id, v) {
    return new IFC4.IfcProcedure(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), v[7]);
  },
  2904328755: function _(id, v) {
    return new IFC4.IfcProjectOrder(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcText(v[8].value));
  },
  3651124850: function _(id, v) {
    return new IFC4.IfcProjectionElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1842657554: function _(id, v) {
    return new IFC4.IfcProtectiveDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2250791053: function _(id, v) {
    return new IFC4.IfcPumpType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2893384427: function _(id, v) {
    return new IFC4.IfcRailingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2324767716: function _(id, v) {
    return new IFC4.IfcRampFlightType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1469900589: function _(id, v) {
    return new IFC4.IfcRampType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  683857671: function _(id, v) {
    return new IFC4.IfcRationalBSplineSurfaceWithKnots(id, new IFC4.IfcInteger(v[0].value), new IFC4.IfcInteger(v[1].value), v[2].map(function (p) {
      return new Handle(p.value);
    }), v[3], new IFC4.IfcLogical(v[4].value), new IFC4.IfcLogical(v[5].value), new IFC4.IfcLogical(v[6].value), v[7].map(function (p) {
      return new IFC4.IfcInteger(p.value);
    }), v[8].map(function (p) {
      return new IFC4.IfcInteger(p.value);
    }), v[9].map(function (p) {
      return new IFC4.IfcParameterValue(p.value);
    }), v[10].map(function (p) {
      return new IFC4.IfcParameterValue(p.value);
    }), v[11], v[12].map(function (p) {
      return new IFC4.IfcReal(p.value);
    }));
  },
  3027567501: function _(id, v) {
    return new IFC4.IfcReinforcingElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  964333572: function _(id, v) {
    return new IFC4.IfcReinforcingElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  2320036040: function _(id, v) {
    return new IFC4.IfcReinforcingMesh(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPositiveLengthMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4.IfcAreaMeasure(v[13].value), !v[14] ? null : new IFC4.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC4.IfcPositiveLengthMeasure(v[15].value), !v[16] ? null : new IFC4.IfcPositiveLengthMeasure(v[16].value), v[17]);
  },
  2310774935: function _(id, v) {
    return new IFC4.IfcReinforcingMeshType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPositiveLengthMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPositiveLengthMeasure(v[12].value), !v[13] ? null : new IFC4.IfcPositiveLengthMeasure(v[13].value), !v[14] ? null : new IFC4.IfcAreaMeasure(v[14].value), !v[15] ? null : new IFC4.IfcAreaMeasure(v[15].value), !v[16] ? null : new IFC4.IfcPositiveLengthMeasure(v[16].value), !v[17] ? null : new IFC4.IfcPositiveLengthMeasure(v[17].value), !v[18] ? null : new IFC4.IfcLabel(v[18].value), !v[19] ? null : v[19].map(function (p) {
      return TypeInitialiser(3, p);
    }));
  },
  160246688: function _(id, v) {
    return new IFC4.IfcRelAggregates(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), new Handle(v[4].value), v[5].map(function (p) {
      return new Handle(p.value);
    }));
  },
  2781568857: function _(id, v) {
    return new IFC4.IfcRoofType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1768891740: function _(id, v) {
    return new IFC4.IfcSanitaryTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2157484638: function _(id, v) {
    return new IFC4.IfcSeamCurve(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2]);
  },
  4074543187: function _(id, v) {
    return new IFC4.IfcShadingDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  4097777520: function _(id, v) {
    return new IFC4.IfcSite(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], !v[9] ? null : new IFC4.IfcCompoundPlaneAngleMeasure(v[9].value), !v[10] ? null : new IFC4.IfcCompoundPlaneAngleMeasure(v[10].value), !v[11] ? null : new IFC4.IfcLengthMeasure(v[11].value), !v[12] ? null : new IFC4.IfcLabel(v[12].value), !v[13] ? null : new Handle(v[13].value));
  },
  2533589738: function _(id, v) {
    return new IFC4.IfcSlabType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1072016465: function _(id, v) {
    return new IFC4.IfcSolarDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3856911033: function _(id, v) {
    return new IFC4.IfcSpace(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8], v[9], !v[10] ? null : new IFC4.IfcLengthMeasure(v[10].value));
  },
  1305183839: function _(id, v) {
    return new IFC4.IfcSpaceHeaterType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3812236995: function _(id, v) {
    return new IFC4.IfcSpaceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcLabel(v[10].value));
  },
  3112655638: function _(id, v) {
    return new IFC4.IfcStackTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1039846685: function _(id, v) {
    return new IFC4.IfcStairFlightType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  338393293: function _(id, v) {
    return new IFC4.IfcStairType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  682877961: function _(id, v) {
    return new IFC4.IfcStructuralAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value));
  },
  1179482911: function _(id, v) {
    return new IFC4.IfcStructuralConnection(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  1004757350: function _(id, v) {
    return new IFC4.IfcStructuralCurveAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value), v[10], v[11]);
  },
  4243806635: function _(id, v) {
    return new IFC4.IfcStructuralCurveConnection(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), new Handle(v[8].value));
  },
  214636428: function _(id, v) {
    return new IFC4.IfcStructuralCurveMember(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], new Handle(v[8].value));
  },
  2445595289: function _(id, v) {
    return new IFC4.IfcStructuralCurveMemberVarying(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], new Handle(v[8].value));
  },
  2757150158: function _(id, v) {
    return new IFC4.IfcStructuralCurveReaction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], v[9]);
  },
  1807405624: function _(id, v) {
    return new IFC4.IfcStructuralLinearAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value), v[10], v[11]);
  },
  1252848954: function _(id, v) {
    return new IFC4.IfcStructuralLoadGroup(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], v[6], v[7], !v[8] ? null : new IFC4.IfcRatioMeasure(v[8].value), !v[9] ? null : new IFC4.IfcLabel(v[9].value));
  },
  2082059205: function _(id, v) {
    return new IFC4.IfcStructuralPointAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value));
  },
  734778138: function _(id, v) {
    return new IFC4.IfcStructuralPointConnection(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value));
  },
  1235345126: function _(id, v) {
    return new IFC4.IfcStructuralPointReaction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8]);
  },
  2986769608: function _(id, v) {
    return new IFC4.IfcStructuralResultGroup(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), new IFC4.IfcBoolean(v[7].value));
  },
  3657597509: function _(id, v) {
    return new IFC4.IfcStructuralSurfaceAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value), v[10], v[11]);
  },
  1975003073: function _(id, v) {
    return new IFC4.IfcStructuralSurfaceConnection(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value));
  },
  148013059: function _(id, v) {
    return new IFC4.IfcSubContractResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  3101698114: function _(id, v) {
    return new IFC4.IfcSurfaceFeature(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2315554128: function _(id, v) {
    return new IFC4.IfcSwitchingDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2254336722: function _(id, v) {
    return new IFC4.IfcSystem(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value));
  },
  413509423: function _(id, v) {
    return new IFC4.IfcSystemFurnitureElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  5716631: function _(id, v) {
    return new IFC4.IfcTankType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3824725483: function _(id, v) {
    return new IFC4.IfcTendon(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4.IfcForceMeasure(v[12].value), !v[13] ? null : new IFC4.IfcPressureMeasure(v[13].value), !v[14] ? null : new IFC4.IfcNormalisedRatioMeasure(v[14].value), !v[15] ? null : new IFC4.IfcPositiveLengthMeasure(v[15].value), !v[16] ? null : new IFC4.IfcPositiveLengthMeasure(v[16].value));
  },
  2347447852: function _(id, v) {
    return new IFC4.IfcTendonAnchor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3081323446: function _(id, v) {
    return new IFC4.IfcTendonAnchorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2415094496: function _(id, v) {
    return new IFC4.IfcTendonType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPositiveLengthMeasure(v[12].value));
  },
  1692211062: function _(id, v) {
    return new IFC4.IfcTransformerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1620046519: function _(id, v) {
    return new IFC4.IfcTransportElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3593883385: function _(id, v) {
    return new IFC4.IfcTrimmedCurve(id, new Handle(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2].map(function (p) {
      return new Handle(p.value);
    }), new IFC4.IfcBoolean(v[3].value), v[4]);
  },
  1600972822: function _(id, v) {
    return new IFC4.IfcTubeBundleType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1911125066: function _(id, v) {
    return new IFC4.IfcUnitaryEquipmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  728799441: function _(id, v) {
    return new IFC4.IfcValveType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2391383451: function _(id, v) {
    return new IFC4.IfcVibrationIsolator(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3313531582: function _(id, v) {
    return new IFC4.IfcVibrationIsolatorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2769231204: function _(id, v) {
    return new IFC4.IfcVirtualElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  926996030: function _(id, v) {
    return new IFC4.IfcVoidingFeature(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1898987631: function _(id, v) {
    return new IFC4.IfcWallType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1133259667: function _(id, v) {
    return new IFC4.IfcWasteTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  4009809668: function _(id, v) {
    return new IFC4.IfcWindowType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], v[10], !v[11] ? null : new IFC4.IfcBoolean(v[11].value), !v[12] ? null : new IFC4.IfcLabel(v[12].value));
  },
  4088093105: function _(id, v) {
    return new IFC4.IfcWorkCalendar(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), v[8]);
  },
  1028945134: function _(id, v) {
    return new IFC4.IfcWorkControl(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), new IFC4.IfcDateTime(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcDuration(v[9].value), !v[10] ? null : new IFC4.IfcDuration(v[10].value), new IFC4.IfcDateTime(v[11].value), !v[12] ? null : new IFC4.IfcDateTime(v[12].value));
  },
  4218914973: function _(id, v) {
    return new IFC4.IfcWorkPlan(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), new IFC4.IfcDateTime(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcDuration(v[9].value), !v[10] ? null : new IFC4.IfcDuration(v[10].value), new IFC4.IfcDateTime(v[11].value), !v[12] ? null : new IFC4.IfcDateTime(v[12].value), v[13]);
  },
  3342526732: function _(id, v) {
    return new IFC4.IfcWorkSchedule(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), new IFC4.IfcDateTime(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcDuration(v[9].value), !v[10] ? null : new IFC4.IfcDuration(v[10].value), new IFC4.IfcDateTime(v[11].value), !v[12] ? null : new IFC4.IfcDateTime(v[12].value), v[13]);
  },
  1033361043: function _(id, v) {
    return new IFC4.IfcZone(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value));
  },
  3821786052: function _(id, v) {
    return new IFC4.IfcActionRequest(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), v[6], !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcText(v[8].value));
  },
  1411407467: function _(id, v) {
    return new IFC4.IfcAirTerminalBoxType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3352864051: function _(id, v) {
    return new IFC4.IfcAirTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1871374353: function _(id, v) {
    return new IFC4.IfcAirToAirHeatRecoveryType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3460190687: function _(id, v) {
    return new IFC4.IfcAsset(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : new Handle(v[8].value), !v[9] ? null : new Handle(v[9].value), !v[10] ? null : new Handle(v[10].value), !v[11] ? null : new Handle(v[11].value), !v[12] ? null : new IFC4.IfcDate(v[12].value), !v[13] ? null : new Handle(v[13].value));
  },
  1532957894: function _(id, v) {
    return new IFC4.IfcAudioVisualApplianceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1967976161: function _(id, v) {
    return new IFC4.IfcBSplineCurve(id, new IFC4.IfcInteger(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2], new IFC4.IfcLogical(v[3].value), new IFC4.IfcLogical(v[4].value));
  },
  2461110595: function _(id, v) {
    return new IFC4.IfcBSplineCurveWithKnots(id, new IFC4.IfcInteger(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2], new IFC4.IfcLogical(v[3].value), new IFC4.IfcLogical(v[4].value), v[5].map(function (p) {
      return new IFC4.IfcInteger(p.value);
    }), v[6].map(function (p) {
      return new IFC4.IfcParameterValue(p.value);
    }), v[7]);
  },
  819618141: function _(id, v) {
    return new IFC4.IfcBeamType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  231477066: function _(id, v) {
    return new IFC4.IfcBoilerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1136057603: function _(id, v) {
    return new IFC4.IfcBoundaryCurve(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4.IfcLogical(v[1].value));
  },
  3299480353: function _(id, v) {
    return new IFC4.IfcBuildingElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  2979338954: function _(id, v) {
    return new IFC4.IfcBuildingElementPart(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  39481116: function _(id, v) {
    return new IFC4.IfcBuildingElementPartType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1095909175: function _(id, v) {
    return new IFC4.IfcBuildingElementProxy(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1909888760: function _(id, v) {
    return new IFC4.IfcBuildingElementProxyType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1177604601: function _(id, v) {
    return new IFC4.IfcBuildingSystem(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], !v[6] ? null : new IFC4.IfcLabel(v[6].value));
  },
  2188180465: function _(id, v) {
    return new IFC4.IfcBurnerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  395041908: function _(id, v) {
    return new IFC4.IfcCableCarrierFittingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3293546465: function _(id, v) {
    return new IFC4.IfcCableCarrierSegmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2674252688: function _(id, v) {
    return new IFC4.IfcCableFittingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1285652485: function _(id, v) {
    return new IFC4.IfcCableSegmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2951183804: function _(id, v) {
    return new IFC4.IfcChillerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3296154744: function _(id, v) {
    return new IFC4.IfcChimney(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2611217952: function _(id, v) {
    return new IFC4.IfcCircle(id, new Handle(v[0].value), new IFC4.IfcPositiveLengthMeasure(v[1].value));
  },
  1677625105: function _(id, v) {
    return new IFC4.IfcCivilElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  2301859152: function _(id, v) {
    return new IFC4.IfcCoilType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  843113511: function _(id, v) {
    return new IFC4.IfcColumn(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  905975707: function _(id, v) {
    return new IFC4.IfcColumnStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  400855858: function _(id, v) {
    return new IFC4.IfcCommunicationsApplianceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3850581409: function _(id, v) {
    return new IFC4.IfcCompressorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2816379211: function _(id, v) {
    return new IFC4.IfcCondenserType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3898045240: function _(id, v) {
    return new IFC4.IfcConstructionEquipmentResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  1060000209: function _(id, v) {
    return new IFC4.IfcConstructionMaterialResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  488727124: function _(id, v) {
    return new IFC4.IfcConstructionProductResource(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcIdentifier(v[5].value), !v[6] ? null : new IFC4.IfcText(v[6].value), !v[7] ? null : new Handle(v[7].value), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value), v[10]);
  },
  335055490: function _(id, v) {
    return new IFC4.IfcCooledBeamType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2954562838: function _(id, v) {
    return new IFC4.IfcCoolingTowerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1973544240: function _(id, v) {
    return new IFC4.IfcCovering(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3495092785: function _(id, v) {
    return new IFC4.IfcCurtainWall(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3961806047: function _(id, v) {
    return new IFC4.IfcDamperType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1335981549: function _(id, v) {
    return new IFC4.IfcDiscreteAccessory(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2635815018: function _(id, v) {
    return new IFC4.IfcDiscreteAccessoryType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1599208980: function _(id, v) {
    return new IFC4.IfcDistributionChamberElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2063403501: function _(id, v) {
    return new IFC4.IfcDistributionControlElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value));
  },
  1945004755: function _(id, v) {
    return new IFC4.IfcDistributionElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  3040386961: function _(id, v) {
    return new IFC4.IfcDistributionFlowElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  3041715199: function _(id, v) {
    return new IFC4.IfcDistributionPort(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), v[7], v[8], v[9]);
  },
  3205830791: function _(id, v) {
    return new IFC4.IfcDistributionSystem(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), v[6]);
  },
  395920057: function _(id, v) {
    return new IFC4.IfcDoor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4.IfcLabel(v[12].value));
  },
  3242481149: function _(id, v) {
    return new IFC4.IfcDoorStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4.IfcLabel(v[12].value));
  },
  869906466: function _(id, v) {
    return new IFC4.IfcDuctFittingType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3760055223: function _(id, v) {
    return new IFC4.IfcDuctSegmentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2030761528: function _(id, v) {
    return new IFC4.IfcDuctSilencerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  663422040: function _(id, v) {
    return new IFC4.IfcElectricApplianceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2417008758: function _(id, v) {
    return new IFC4.IfcElectricDistributionBoardType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  3277789161: function _(id, v) {
    return new IFC4.IfcElectricFlowStorageDeviceType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1534661035: function _(id, v) {
    return new IFC4.IfcElectricGeneratorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1217240411: function _(id, v) {
    return new IFC4.IfcElectricMotorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  712377611: function _(id, v) {
    return new IFC4.IfcElectricTimeControlType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1658829314: function _(id, v) {
    return new IFC4.IfcEnergyConversionDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  2814081492: function _(id, v) {
    return new IFC4.IfcEngine(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3747195512: function _(id, v) {
    return new IFC4.IfcEvaporativeCooler(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  484807127: function _(id, v) {
    return new IFC4.IfcEvaporator(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1209101575: function _(id, v) {
    return new IFC4.IfcExternalSpatialElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcLabel(v[7].value), v[8]);
  },
  346874300: function _(id, v) {
    return new IFC4.IfcFanType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1810631287: function _(id, v) {
    return new IFC4.IfcFilterType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  4222183408: function _(id, v) {
    return new IFC4.IfcFireSuppressionTerminalType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2058353004: function _(id, v) {
    return new IFC4.IfcFlowController(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  4278956645: function _(id, v) {
    return new IFC4.IfcFlowFitting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  4037862832: function _(id, v) {
    return new IFC4.IfcFlowInstrumentType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  2188021234: function _(id, v) {
    return new IFC4.IfcFlowMeter(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3132237377: function _(id, v) {
    return new IFC4.IfcFlowMovingDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  987401354: function _(id, v) {
    return new IFC4.IfcFlowSegment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  707683696: function _(id, v) {
    return new IFC4.IfcFlowStorageDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  2223149337: function _(id, v) {
    return new IFC4.IfcFlowTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  3508470533: function _(id, v) {
    return new IFC4.IfcFlowTreatmentDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  900683007: function _(id, v) {
    return new IFC4.IfcFooting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3319311131: function _(id, v) {
    return new IFC4.IfcHeatExchanger(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2068733104: function _(id, v) {
    return new IFC4.IfcHumidifier(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  4175244083: function _(id, v) {
    return new IFC4.IfcInterceptor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2176052936: function _(id, v) {
    return new IFC4.IfcJunctionBox(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  76236018: function _(id, v) {
    return new IFC4.IfcLamp(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  629592764: function _(id, v) {
    return new IFC4.IfcLightFixture(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1437502449: function _(id, v) {
    return new IFC4.IfcMedicalDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1073191201: function _(id, v) {
    return new IFC4.IfcMember(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1911478936: function _(id, v) {
    return new IFC4.IfcMemberStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2474470126: function _(id, v) {
    return new IFC4.IfcMotorConnection(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  144952367: function _(id, v) {
    return new IFC4.IfcOuterBoundaryCurve(id, v[0].map(function (p) {
      return new Handle(p.value);
    }), new IFC4.IfcLogical(v[1].value));
  },
  3694346114: function _(id, v) {
    return new IFC4.IfcOutlet(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1687234759: function _(id, v) {
    return new IFC4.IfcPile(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8], v[9]);
  },
  310824031: function _(id, v) {
    return new IFC4.IfcPipeFitting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3612865200: function _(id, v) {
    return new IFC4.IfcPipeSegment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3171933400: function _(id, v) {
    return new IFC4.IfcPlate(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1156407060: function _(id, v) {
    return new IFC4.IfcPlateStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  738039164: function _(id, v) {
    return new IFC4.IfcProtectiveDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  655969474: function _(id, v) {
    return new IFC4.IfcProtectiveDeviceTrippingUnitType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  90941305: function _(id, v) {
    return new IFC4.IfcPump(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2262370178: function _(id, v) {
    return new IFC4.IfcRailing(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3024970846: function _(id, v) {
    return new IFC4.IfcRamp(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3283111854: function _(id, v) {
    return new IFC4.IfcRampFlight(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1232101972: function _(id, v) {
    return new IFC4.IfcRationalBSplineCurveWithKnots(id, new IFC4.IfcInteger(v[0].value), v[1].map(function (p) {
      return new Handle(p.value);
    }), v[2], new IFC4.IfcLogical(v[3].value), new IFC4.IfcLogical(v[4].value), v[5].map(function (p) {
      return new IFC4.IfcInteger(p.value);
    }), v[6].map(function (p) {
      return new IFC4.IfcParameterValue(p.value);
    }), v[7], v[8].map(function (p) {
      return new IFC4.IfcReal(p.value);
    }));
  },
  979691226: function _(id, v) {
    return new IFC4.IfcReinforcingBar(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), !v[10] ? null : new IFC4.IfcAreaMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPositiveLengthMeasure(v[11].value), v[12], v[13]);
  },
  2572171363: function _(id, v) {
    return new IFC4.IfcReinforcingBarType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9], !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcAreaMeasure(v[11].value), !v[12] ? null : new IFC4.IfcPositiveLengthMeasure(v[12].value), v[13], !v[14] ? null : new IFC4.IfcLabel(v[14].value), !v[15] ? null : v[15].map(function (p) {
      return TypeInitialiser(3, p);
    }));
  },
  2016517767: function _(id, v) {
    return new IFC4.IfcRoof(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3053780830: function _(id, v) {
    return new IFC4.IfcSanitaryTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1783015770: function _(id, v) {
    return new IFC4.IfcSensorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1329646415: function _(id, v) {
    return new IFC4.IfcShadingDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1529196076: function _(id, v) {
    return new IFC4.IfcSlab(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3127900445: function _(id, v) {
    return new IFC4.IfcSlabElementedCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3027962421: function _(id, v) {
    return new IFC4.IfcSlabStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3420628829: function _(id, v) {
    return new IFC4.IfcSolarDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1999602285: function _(id, v) {
    return new IFC4.IfcSpaceHeater(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1404847402: function _(id, v) {
    return new IFC4.IfcStackTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  331165859: function _(id, v) {
    return new IFC4.IfcStair(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  4252922144: function _(id, v) {
    return new IFC4.IfcStairFlight(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcInteger(v[8].value), !v[9] ? null : new IFC4.IfcInteger(v[9].value), !v[10] ? null : new IFC4.IfcPositiveLengthMeasure(v[10].value), !v[11] ? null : new IFC4.IfcPositiveLengthMeasure(v[11].value), v[12]);
  },
  2515109513: function _(id, v) {
    return new IFC4.IfcStructuralAnalysisModel(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], !v[6] ? null : new Handle(v[6].value), !v[7] ? null : v[7].map(function (p) {
      return new Handle(p.value);
    }), !v[8] ? null : v[8].map(function (p) {
      return new Handle(p.value);
    }), !v[9] ? null : new Handle(v[9].value));
  },
  385403989: function _(id, v) {
    return new IFC4.IfcStructuralLoadCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), v[5], v[6], v[7], !v[8] ? null : new IFC4.IfcRatioMeasure(v[8].value), !v[9] ? null : new IFC4.IfcLabel(v[9].value), !v[10] ? null : v[10].map(function (p) {
      return new IFC4.IfcRatioMeasure(p.value);
    }));
  },
  1621171031: function _(id, v) {
    return new IFC4.IfcStructuralPlanarAction(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), new Handle(v[7].value), v[8], !v[9] ? null : new IFC4.IfcBoolean(v[9].value), v[10], v[11]);
  },
  1162798199: function _(id, v) {
    return new IFC4.IfcSwitchingDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  812556717: function _(id, v) {
    return new IFC4.IfcTank(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3825984169: function _(id, v) {
    return new IFC4.IfcTransformer(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3026737570: function _(id, v) {
    return new IFC4.IfcTubeBundle(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3179687236: function _(id, v) {
    return new IFC4.IfcUnitaryControlElementType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  4292641817: function _(id, v) {
    return new IFC4.IfcUnitaryEquipment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  4207607924: function _(id, v) {
    return new IFC4.IfcValve(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2391406946: function _(id, v) {
    return new IFC4.IfcWall(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  4156078855: function _(id, v) {
    return new IFC4.IfcWallElementedCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3512223829: function _(id, v) {
    return new IFC4.IfcWallStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  4237592921: function _(id, v) {
    return new IFC4.IfcWasteTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3304561284: function _(id, v) {
    return new IFC4.IfcWindow(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4.IfcLabel(v[12].value));
  },
  486154966: function _(id, v) {
    return new IFC4.IfcWindowStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), !v[8] ? null : new IFC4.IfcPositiveLengthMeasure(v[8].value), !v[9] ? null : new IFC4.IfcPositiveLengthMeasure(v[9].value), v[10], v[11], !v[12] ? null : new IFC4.IfcLabel(v[12].value));
  },
  2874132201: function _(id, v) {
    return new IFC4.IfcActuatorType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  1634111441: function _(id, v) {
    return new IFC4.IfcAirTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  177149247: function _(id, v) {
    return new IFC4.IfcAirTerminalBox(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2056796094: function _(id, v) {
    return new IFC4.IfcAirToAirHeatRecovery(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3001207471: function _(id, v) {
    return new IFC4.IfcAlarmType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  277319702: function _(id, v) {
    return new IFC4.IfcAudioVisualAppliance(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  753842376: function _(id, v) {
    return new IFC4.IfcBeam(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2906023776: function _(id, v) {
    return new IFC4.IfcBeamStandardCase(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  32344328: function _(id, v) {
    return new IFC4.IfcBoiler(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2938176219: function _(id, v) {
    return new IFC4.IfcBurner(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  635142910: function _(id, v) {
    return new IFC4.IfcCableCarrierFitting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3758799889: function _(id, v) {
    return new IFC4.IfcCableCarrierSegment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1051757585: function _(id, v) {
    return new IFC4.IfcCableFitting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  4217484030: function _(id, v) {
    return new IFC4.IfcCableSegment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3902619387: function _(id, v) {
    return new IFC4.IfcChiller(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  639361253: function _(id, v) {
    return new IFC4.IfcCoil(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3221913625: function _(id, v) {
    return new IFC4.IfcCommunicationsAppliance(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3571504051: function _(id, v) {
    return new IFC4.IfcCompressor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2272882330: function _(id, v) {
    return new IFC4.IfcCondenser(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  578613899: function _(id, v) {
    return new IFC4.IfcControllerType(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcIdentifier(v[4].value), !v[5] ? null : v[5].map(function (p) {
      return new Handle(p.value);
    }), !v[6] ? null : v[6].map(function (p) {
      return new Handle(p.value);
    }), !v[7] ? null : new IFC4.IfcLabel(v[7].value), !v[8] ? null : new IFC4.IfcLabel(v[8].value), v[9]);
  },
  4136498852: function _(id, v) {
    return new IFC4.IfcCooledBeam(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3640358203: function _(id, v) {
    return new IFC4.IfcCoolingTower(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  4074379575: function _(id, v) {
    return new IFC4.IfcDamper(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1052013943: function _(id, v) {
    return new IFC4.IfcDistributionChamberElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  562808652: function _(id, v) {
    return new IFC4.IfcDistributionCircuit(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new IFC4.IfcLabel(v[5].value), v[6]);
  },
  1062813311: function _(id, v) {
    return new IFC4.IfcDistributionControlElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value));
  },
  342316401: function _(id, v) {
    return new IFC4.IfcDuctFitting(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3518393246: function _(id, v) {
    return new IFC4.IfcDuctSegment(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1360408905: function _(id, v) {
    return new IFC4.IfcDuctSilencer(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1904799276: function _(id, v) {
    return new IFC4.IfcElectricAppliance(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  862014818: function _(id, v) {
    return new IFC4.IfcElectricDistributionBoard(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3310460725: function _(id, v) {
    return new IFC4.IfcElectricFlowStorageDevice(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  264262732: function _(id, v) {
    return new IFC4.IfcElectricGenerator(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  402227799: function _(id, v) {
    return new IFC4.IfcElectricMotor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1003880860: function _(id, v) {
    return new IFC4.IfcElectricTimeControl(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3415622556: function _(id, v) {
    return new IFC4.IfcFan(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  819412036: function _(id, v) {
    return new IFC4.IfcFilter(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  1426591983: function _(id, v) {
    return new IFC4.IfcFireSuppressionTerminal(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  182646315: function _(id, v) {
    return new IFC4.IfcFlowInstrument(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  2295281155: function _(id, v) {
    return new IFC4.IfcProtectiveDeviceTrippingUnit(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  4086658281: function _(id, v) {
    return new IFC4.IfcSensor(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  630975310: function _(id, v) {
    return new IFC4.IfcUnitaryControlElement(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  4288193352: function _(id, v) {
    return new IFC4.IfcActuator(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  3087945054: function _(id, v) {
    return new IFC4.IfcAlarm(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  },
  25142252: function _(id, v) {
    return new IFC4.IfcController(id, new IFC4.IfcGloballyUniqueId(v[0].value), !v[1] ? null : new Handle(v[1].value), !v[2] ? null : new IFC4.IfcLabel(v[2].value), !v[3] ? null : new IFC4.IfcText(v[3].value), !v[4] ? null : new IFC4.IfcLabel(v[4].value), !v[5] ? null : new Handle(v[5].value), !v[6] ? null : new Handle(v[6].value), !v[7] ? null : new IFC4.IfcIdentifier(v[7].value), v[8]);
  }
};
InheritanceDef[3] = {
  618182010: [IFCTELECOMADDRESS, IFCPOSTALADDRESS],
  411424972: [IFCCOSTVALUE],
  4037036970: [IFCBOUNDARYNODECONDITIONWARPING, IFCBOUNDARYNODECONDITION, IFCBOUNDARYFACECONDITION, IFCBOUNDARYEDGECONDITION],
  1387855156: [IFCBOUNDARYNODECONDITIONWARPING],
  2859738748: [IFCCONNECTIONCURVEGEOMETRY, IFCCONNECTIONVOLUMEGEOMETRY, IFCCONNECTIONSURFACEGEOMETRY, IFCCONNECTIONPOINTECCENTRICITY, IFCCONNECTIONPOINTGEOMETRY],
  2614616156: [IFCCONNECTIONPOINTECCENTRICITY],
  1959218052: [IFCOBJECTIVE, IFCMETRIC],
  1785450214: [IFCMAPCONVERSION],
  1466758467: [IFCPROJECTEDCRS],
  4294318154: [IFCDOCUMENTINFORMATION, IFCCLASSIFICATION, IFCLIBRARYINFORMATION],
  3200245327: [IFCDOCUMENTREFERENCE, IFCCLASSIFICATIONREFERENCE, IFCLIBRARYREFERENCE, IFCEXTERNALLYDEFINEDTEXTFONT, IFCEXTERNALLYDEFINEDSURFACESTYLE, IFCEXTERNALLYDEFINEDHATCHSTYLE],
  760658860: [IFCMATERIALCONSTITUENTSET, IFCMATERIALCONSTITUENT, IFCMATERIAL, IFCMATERIALPROFILESET, IFCMATERIALPROFILEWITHOFFSETS, IFCMATERIALPROFILE, IFCMATERIALLAYERSET, IFCMATERIALLAYERWITHOFFSETS, IFCMATERIALLAYER],
  248100487: [IFCMATERIALLAYERWITHOFFSETS],
  2235152071: [IFCMATERIALPROFILEWITHOFFSETS],
  1507914824: [IFCMATERIALPROFILESETUSAGETAPERING, IFCMATERIALPROFILESETUSAGE, IFCMATERIALLAYERSETUSAGE],
  1918398963: [IFCCONVERSIONBASEDUNITWITHOFFSET, IFCCONVERSIONBASEDUNIT, IFCCONTEXTDEPENDENTUNIT, IFCSIUNIT],
  3701648758: [IFCLOCALPLACEMENT, IFCGRIDPLACEMENT],
  2483315170: [IFCPHYSICALCOMPLEXQUANTITY, IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA, IFCPHYSICALSIMPLEQUANTITY],
  2226359599: [IFCQUANTITYWEIGHT, IFCQUANTITYVOLUME, IFCQUANTITYTIME, IFCQUANTITYLENGTH, IFCQUANTITYCOUNT, IFCQUANTITYAREA],
  677532197: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT, IFCPREDEFINEDITEM, IFCINDEXEDCOLOURMAP, IFCCURVESTYLEFONTPATTERN, IFCCURVESTYLEFONTANDSCALING, IFCCURVESTYLEFONT, IFCCOLOURRGB, IFCCOLOURSPECIFICATION, IFCCOLOURRGBLIST, IFCTEXTUREVERTEXLIST, IFCTEXTUREVERTEX, IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR, IFCTEXTURECOORDINATE, IFCTEXTSTYLETEXTMODEL, IFCTEXTSTYLEFORDEFINEDFONT, IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE, IFCSURFACETEXTURE, IFCSURFACESTYLEWITHTEXTURES, IFCSURFACESTYLERENDERING, IFCSURFACESTYLESHADING, IFCSURFACESTYLEREFRACTION, IFCSURFACESTYLELIGHTING],
  2022622350: [IFCPRESENTATIONLAYERWITHSTYLE],
  3119450353: [IFCFILLAREASTYLE, IFCCURVESTYLE, IFCTEXTSTYLE, IFCSURFACESTYLE],
  2095639259: [IFCPRODUCTDEFINITIONSHAPE, IFCMATERIALDEFINITIONREPRESENTATION],
  3958567839: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF, IFCPARAMETERIZEDPROFILEDEF, IFCMIRROREDPROFILEDEF, IFCDERIVEDPROFILEDEF, IFCCOMPOSITEPROFILEDEF, IFCCENTERLINEPROFILEDEF, IFCARBITRARYOPENPROFILEDEF, IFCARBITRARYPROFILEDEFWITHVOIDS, IFCARBITRARYCLOSEDPROFILEDEF],
  986844984: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY, IFCPROPERTY, IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES, IFCPREDEFINEDPROPERTIES, IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES, IFCEXTENDEDPROPERTIES, IFCPROPERTYENUMERATION],
  1076942058: [IFCSTYLEDREPRESENTATION, IFCSTYLEMODEL, IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION, IFCSHAPEMODEL],
  3377609919: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT, IFCGEOMETRICREPRESENTATIONCONTEXT],
  3008791417: [IFCMAPPEDITEM, IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET, IFCGEOMETRICREPRESENTATIONITEM, IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX, IFCTOPOLOGICALREPRESENTATIONITEM, IFCSTYLEDITEM],
  2439245199: [IFCRESOURCECONSTRAINTRELATIONSHIP, IFCRESOURCEAPPROVALRELATIONSHIP, IFCPROPERTYDEPENDENCYRELATIONSHIP, IFCORGANIZATIONRELATIONSHIP, IFCMATERIALRELATIONSHIP, IFCEXTERNALREFERENCERELATIONSHIP, IFCDOCUMENTINFORMATIONRELATIONSHIP, IFCCURRENCYRELATIONSHIP, IFCAPPROVALRELATIONSHIP],
  2341007311: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS, IFCRELATIONSHIP, IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION, IFCPROPERTYDEFINITION, IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT, IFCOBJECTDEFINITION],
  1054537805: [IFCRESOURCETIME, IFCLAGTIME, IFCEVENTTIME, IFCWORKTIME, IFCTASKTIMERECURRING, IFCTASKTIME],
  3982875396: [IFCTOPOLOGYREPRESENTATION, IFCSHAPEREPRESENTATION],
  2273995522: [IFCSLIPPAGECONNECTIONCONDITION, IFCFAILURECONNECTIONCONDITION],
  2162789131: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC, IFCSTRUCTURALLOADORRESULT, IFCSTRUCTURALLOADCONFIGURATION],
  609421318: [IFCSURFACEREINFORCEMENTAREA, IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE, IFCSTRUCTURALLOADSTATIC],
  2525727697: [IFCSTRUCTURALLOADSINGLEFORCEWARPING, IFCSTRUCTURALLOADSINGLEFORCE, IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION, IFCSTRUCTURALLOADSINGLEDISPLACEMENT, IFCSTRUCTURALLOADPLANARFORCE, IFCSTRUCTURALLOADLINEARFORCE, IFCSTRUCTURALLOADTEMPERATURE],
  2830218821: [IFCSTYLEDREPRESENTATION],
  846575682: [IFCSURFACESTYLERENDERING],
  626085974: [IFCPIXELTEXTURE, IFCIMAGETEXTURE, IFCBLOBTEXTURE],
  1549132990: [IFCTASKTIMERECURRING],
  280115917: [IFCINDEXEDTRIANGLETEXTUREMAP, IFCINDEXEDTEXTUREMAP, IFCTEXTUREMAP, IFCTEXTURECOORDINATEGENERATOR],
  3101149627: [IFCREGULARTIMESERIES, IFCIRREGULARTIMESERIES],
  1377556343: [IFCPATH, IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP, IFCLOOP, IFCFACEOUTERBOUND, IFCFACEBOUND, IFCADVANCEDFACE, IFCFACESURFACE, IFCFACE, IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE, IFCEDGE, IFCCLOSEDSHELL, IFCOPENSHELL, IFCCONNECTEDFACESET, IFCVERTEXPOINT, IFCVERTEX],
  2799835756: [IFCVERTEXPOINT],
  3798115385: [IFCARBITRARYPROFILEDEFWITHVOIDS],
  1310608509: [IFCCENTERLINEPROFILEDEF],
  3264961684: [IFCCOLOURRGB],
  370225590: [IFCCLOSEDSHELL, IFCOPENSHELL],
  2889183280: [IFCCONVERSIONBASEDUNITWITHOFFSET],
  3632507154: [IFCMIRROREDPROFILEDEF],
  3900360178: [IFCSUBEDGE, IFCORIENTEDEDGE, IFCEDGECURVE],
  297599258: [IFCPROFILEPROPERTIES, IFCMATERIALPROPERTIES],
  2556980723: [IFCADVANCEDFACE, IFCFACESURFACE],
  1809719519: [IFCFACEOUTERBOUND],
  3008276851: [IFCADVANCEDFACE],
  3448662350: [IFCGEOMETRICREPRESENTATIONSUBCONTEXT],
  2453401579: [IFCFILLAREASTYLETILES, IFCFILLAREASTYLEHATCHING, IFCFACEBASEDSURFACEMODEL, IFCDIRECTION, IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE, IFCCURVE, IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID, IFCCSGPRIMITIVE3D, IFCREPARAMETRISEDCOMPOSITECURVESEGMENT, IFCCOMPOSITECURVESEGMENT, IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D, IFCCARTESIANTRANSFORMATIONOPERATOR, IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D, IFCCARTESIANPOINTLIST, IFCBOUNDINGBOX, IFCBOOLEANCLIPPINGRESULT, IFCBOOLEANRESULT, IFCANNOTATIONFILLAREA, IFCVECTOR, IFCTEXTLITERALWITHEXTENT, IFCTEXTLITERAL, IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE, IFCTESSELLATEDITEM, IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE, IFCSURFACE, IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID, IFCSOLIDMODEL, IFCSHELLBASEDSURFACEMODEL, IFCSECTIONEDSPINE, IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE, IFCPOINT, IFCPLANARBOX, IFCPLANAREXTENT, IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT, IFCPLACEMENT, IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT, IFCLIGHTSOURCE, IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE, IFCHALFSPACESOLID, IFCGEOMETRICCURVESET, IFCGEOMETRICSET],
  3590301190: [IFCGEOMETRICCURVESET],
  812098782: [IFCBOXEDHALFSPACE, IFCPOLYGONALBOUNDEDHALFSPACE],
  1437953363: [IFCINDEXEDTRIANGLETEXTUREMAP],
  1402838566: [IFCLIGHTSOURCESPOT, IFCLIGHTSOURCEPOSITIONAL, IFCLIGHTSOURCEGONIOMETRIC, IFCLIGHTSOURCEDIRECTIONAL, IFCLIGHTSOURCEAMBIENT],
  1520743889: [IFCLIGHTSOURCESPOT],
  1008929658: [IFCEDGELOOP, IFCVERTEXLOOP, IFCPOLYLOOP],
  3079605661: [IFCMATERIALPROFILESETUSAGETAPERING],
  219451334: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS, IFCOBJECT, IFCPROJECTLIBRARY, IFCPROJECT, IFCCONTEXT, IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS, IFCTYPEOBJECT],
  2529465313: [IFCLSHAPEPROFILEDEF, IFCISHAPEPROFILEDEF, IFCELLIPSEPROFILEDEF, IFCCIRCLEHOLLOWPROFILEDEF, IFCCIRCLEPROFILEDEF, IFCCSHAPEPROFILEDEF, IFCASYMMETRICISHAPEPROFILEDEF, IFCZSHAPEPROFILEDEF, IFCUSHAPEPROFILEDEF, IFCTRAPEZIUMPROFILEDEF, IFCTSHAPEPROFILEDEF, IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF, IFCRECTANGLEPROFILEDEF],
  2004835150: [IFCAXIS2PLACEMENT3D, IFCAXIS2PLACEMENT2D, IFCAXIS1PLACEMENT],
  1663979128: [IFCPLANARBOX],
  2067069095: [IFCCARTESIANPOINT, IFCPOINTONSURFACE, IFCPOINTONCURVE],
  3727388367: [IFCDRAUGHTINGPREDEFINEDCURVEFONT, IFCPREDEFINEDCURVEFONT, IFCDRAUGHTINGPREDEFINEDCOLOUR, IFCPREDEFINEDCOLOUR, IFCTEXTSTYLEFONTMODEL, IFCPREDEFINEDTEXTFONT],
  3778827333: [IFCSECTIONREINFORCEMENTPROPERTIES, IFCSECTIONPROPERTIES, IFCREINFORCEMENTBARPROPERTIES],
  1775413392: [IFCTEXTSTYLEFONTMODEL],
  2598011224: [IFCCOMPLEXPROPERTY, IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE, IFCSIMPLEPROPERTY],
  1680319473: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE, IFCPROPERTYTEMPLATEDEFINITION, IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET, IFCPROPERTYSETDEFINITION],
  3357820518: [IFCPROPERTYSET, IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES, IFCPREDEFINEDPROPERTYSET, IFCELEMENTQUANTITY, IFCQUANTITYSET],
  1482703590: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE, IFCPROPERTYTEMPLATE, IFCPROPERTYSETTEMPLATE],
  2090586900: [IFCELEMENTQUANTITY],
  3615266464: [IFCRECTANGLEHOLLOWPROFILEDEF, IFCROUNDEDRECTANGLEPROFILEDEF],
  478536968: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT, IFCRELDEFINES, IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS, IFCRELDECOMPOSES, IFCRELDECLARES, IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS, IFCRELCONNECTS, IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL, IFCRELASSOCIATES, IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR, IFCRELASSIGNS],
  3692461612: [IFCPROPERTYTABLEVALUE, IFCPROPERTYSINGLEVALUE, IFCPROPERTYREFERENCEVALUE, IFCPROPERTYLISTVALUE, IFCPROPERTYENUMERATEDVALUE, IFCPROPERTYBOUNDEDVALUE],
  723233188: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP, IFCMANIFOLDSOLIDBREP, IFCCSGSOLID, IFCSWEPTDISKSOLIDPOLYGONAL, IFCSWEPTDISKSOLID, IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID, IFCSWEPTAREASOLID],
  2473145415: [IFCSTRUCTURALLOADSINGLEDISPLACEMENTDISTORTION],
  1597423693: [IFCSTRUCTURALLOADSINGLEFORCEWARPING],
  2513912981: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE, IFCELEMENTARYSURFACE, IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE, IFCBOUNDEDSURFACE, IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION, IFCSWEPTSURFACE],
  2247615214: [IFCSURFACECURVESWEPTAREASOLID, IFCREVOLVEDAREASOLIDTAPERED, IFCREVOLVEDAREASOLID, IFCFIXEDREFERENCESWEPTAREASOLID, IFCEXTRUDEDAREASOLIDTAPERED, IFCEXTRUDEDAREASOLID],
  1260650574: [IFCSWEPTDISKSOLIDPOLYGONAL],
  230924584: [IFCSURFACEOFREVOLUTION, IFCSURFACEOFLINEAREXTRUSION],
  901063453: [IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET, IFCTESSELLATEDFACESET, IFCINDEXEDPOLYGONALFACEWITHVOIDS, IFCINDEXEDPOLYGONALFACE],
  4282788508: [IFCTEXTLITERALWITHEXTENT],
  1628702193: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE, IFCTYPERESOURCE, IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE, IFCTYPEPRODUCT, IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE, IFCTYPEPROCESS],
  3736923433: [IFCTASKTYPE, IFCPROCEDURETYPE, IFCEVENTTYPE],
  2347495698: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE, IFCSPATIALELEMENTTYPE, IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE, IFCELEMENTTYPE, IFCDOORSTYLE, IFCWINDOWSTYLE],
  3698973494: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE, IFCCONSTRUCTIONRESOURCETYPE],
  2736907675: [IFCBOOLEANCLIPPINGRESULT],
  4182860854: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACE, IFCRECTANGULARTRIMMEDSURFACE, IFCCURVEBOUNDEDSURFACE, IFCCURVEBOUNDEDPLANE],
  574549367: [IFCCARTESIANPOINTLIST3D, IFCCARTESIANPOINTLIST2D],
  59481748: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR3D, IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM, IFCCARTESIANTRANSFORMATIONOPERATOR2D],
  3749851601: [IFCCARTESIANTRANSFORMATIONOPERATOR2DNONUNIFORM],
  3331915920: [IFCCARTESIANTRANSFORMATIONOPERATOR3DNONUNIFORM],
  1383045692: [IFCCIRCLEHOLLOWPROFILEDEF],
  2485617015: [IFCREPARAMETRISEDCOMPOSITECURVESEGMENT],
  2574617495: [IFCCONSTRUCTIONPRODUCTRESOURCETYPE, IFCCONSTRUCTIONMATERIALRESOURCETYPE, IFCCONSTRUCTIONEQUIPMENTRESOURCETYPE, IFCSUBCONTRACTRESOURCETYPE, IFCLABORRESOURCETYPE, IFCCREWRESOURCETYPE],
  3419103109: [IFCPROJECTLIBRARY, IFCPROJECT],
  2506170314: [IFCBLOCK, IFCSPHERE, IFCRIGHTCIRCULARCYLINDER, IFCRIGHTCIRCULARCONE, IFCRECTANGULARPYRAMID],
  2601014836: [IFCCIRCLE, IFCELLIPSE, IFCCONIC, IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE, IFCBOUNDEDCURVE, IFCSEAMCURVE, IFCINTERSECTIONCURVE, IFCSURFACECURVE, IFCPCURVE, IFCOFFSETCURVE3D, IFCOFFSETCURVE2D, IFCLINE],
  339256511: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE, IFCELEMENTCOMPONENTTYPE, IFCELEMENTASSEMBLYTYPE, IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE, IFCDISTRIBUTIONELEMENTTYPE, IFCCIVILELEMENTTYPE, IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE, IFCBUILDINGELEMENTTYPE, IFCTRANSPORTELEMENTTYPE, IFCGEOGRAPHICELEMENTTYPE, IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE, IFCFURNISHINGELEMENTTYPE],
  2777663545: [IFCCYLINDRICALSURFACE, IFCTOROIDALSURFACE, IFCSPHERICALSURFACE, IFCPLANE],
  477187591: [IFCEXTRUDEDAREASOLIDTAPERED],
  4238390223: [IFCSYSTEMFURNITUREELEMENTTYPE, IFCFURNITURETYPE],
  178912537: [IFCINDEXEDPOLYGONALFACEWITHVOIDS],
  1425443689: [IFCFACETEDBREPWITHVOIDS, IFCFACETEDBREP, IFCADVANCEDBREPWITHVOIDS, IFCADVANCEDBREP],
  3888040117: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY, IFCGROUP, IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM, IFCCONTROL, IFCOCCUPANT, IFCACTOR, IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE, IFCRESOURCE, IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY, IFCPRODUCT, IFCPROCEDURE, IFCEVENT, IFCTASK, IFCPROCESS],
  759155922: [IFCDRAUGHTINGPREDEFINEDCOLOUR],
  2559016684: [IFCDRAUGHTINGPREDEFINEDCURVEFONT],
  3967405729: [IFCPERMEABLECOVERINGPROPERTIES, IFCDOORPANELPROPERTIES, IFCDOORLININGPROPERTIES, IFCWINDOWPANELPROPERTIES, IFCWINDOWLININGPROPERTIES, IFCREINFORCEMENTDEFINITIONPROPERTIES],
  2945172077: [IFCPROCEDURE, IFCEVENT, IFCTASK],
  4208778838: [IFCDISTRIBUTIONPORT, IFCPORT, IFCGRID, IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY, IFCELEMENT, IFCANNOTATION, IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER, IFCSTRUCTURALITEM, IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION, IFCSTRUCTURALACTIVITY, IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT, IFCSPATIALELEMENT, IFCPROXY],
  3521284610: [IFCCOMPLEXPROPERTYTEMPLATE, IFCSIMPLEPROPERTYTEMPLATE],
  3939117080: [IFCRELASSIGNSTORESOURCE, IFCRELASSIGNSTOPRODUCT, IFCRELASSIGNSTOPROCESS, IFCRELASSIGNSTOGROUPBYFACTOR, IFCRELASSIGNSTOGROUP, IFCRELASSIGNSTOCONTROL, IFCRELASSIGNSTOACTOR],
  1307041759: [IFCRELASSIGNSTOGROUPBYFACTOR],
  1865459582: [IFCRELASSOCIATESMATERIAL, IFCRELASSOCIATESLIBRARY, IFCRELASSOCIATESDOCUMENT, IFCRELASSOCIATESCONSTRAINT, IFCRELASSOCIATESCLASSIFICATION, IFCRELASSOCIATESAPPROVAL],
  826625072: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL, IFCRELSPACEBOUNDARY, IFCRELSERVICESBUILDINGS, IFCRELSEQUENCE, IFCRELREFERENCEDINSPATIALSTRUCTURE, IFCRELINTERFERESELEMENTS, IFCRELFLOWCONTROLELEMENTS, IFCRELFILLSELEMENT, IFCRELCOVERSSPACES, IFCRELCOVERSBLDGELEMENTS, IFCRELCONTAINEDINSPATIALSTRUCTURE, IFCRELCONNECTSWITHECCENTRICITY, IFCRELCONNECTSSTRUCTURALMEMBER, IFCRELCONNECTSSTRUCTURALACTIVITY, IFCRELCONNECTSPORTS, IFCRELCONNECTSPORTTOELEMENT, IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS, IFCRELCONNECTSELEMENTS],
  1204542856: [IFCRELCONNECTSWITHREALIZINGELEMENTS, IFCRELCONNECTSPATHELEMENTS],
  1638771189: [IFCRELCONNECTSWITHECCENTRICITY],
  2551354335: [IFCRELAGGREGATES, IFCRELVOIDSELEMENT, IFCRELPROJECTSELEMENT, IFCRELNESTS],
  693640335: [IFCRELDEFINESBYTYPE, IFCRELDEFINESBYTEMPLATE, IFCRELDEFINESBYPROPERTIES, IFCRELDEFINESBYOBJECT],
  3451746338: [IFCRELSPACEBOUNDARY2NDLEVEL, IFCRELSPACEBOUNDARY1STLEVEL],
  3523091289: [IFCRELSPACEBOUNDARY2NDLEVEL],
  2914609552: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE, IFCCONSTRUCTIONRESOURCE],
  1856042241: [IFCREVOLVEDAREASOLIDTAPERED],
  1412071761: [IFCEXTERNALSPATIALELEMENT, IFCEXTERNALSPATIALSTRUCTUREELEMENT, IFCSPATIALZONE, IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING, IFCSPATIALSTRUCTUREELEMENT],
  710998568: [IFCSPATIALZONETYPE, IFCSPACETYPE, IFCSPATIALSTRUCTUREELEMENTTYPE],
  2706606064: [IFCSPACE, IFCSITE, IFCBUILDINGSTOREY, IFCBUILDING],
  3893378262: [IFCSPACETYPE],
  3544373492: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION, IFCSTRUCTURALACTION, IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION, IFCSTRUCTURALREACTION],
  3136571912: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION, IFCSTRUCTURALCONNECTION, IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER, IFCSTRUCTURALMEMBER],
  530289379: [IFCSTRUCTURALCURVEMEMBERVARYING, IFCSTRUCTURALCURVEMEMBER, IFCSTRUCTURALSURFACEMEMBERVARYING, IFCSTRUCTURALSURFACEMEMBER],
  3689010777: [IFCSTRUCTURALPOINTREACTION, IFCSTRUCTURALCURVEREACTION, IFCSTRUCTURALSURFACEREACTION],
  3979015343: [IFCSTRUCTURALSURFACEMEMBERVARYING],
  699246055: [IFCSEAMCURVE, IFCINTERSECTIONCURVE],
  2387106220: [IFCPOLYGONALFACESET, IFCTRIANGULATEDFACESET],
  2296667514: [IFCOCCUPANT],
  1635779807: [IFCADVANCEDBREPWITHVOIDS],
  2887950389: [IFCRATIONALBSPLINESURFACEWITHKNOTS, IFCBSPLINESURFACEWITHKNOTS],
  167062518: [IFCRATIONALBSPLINESURFACEWITHKNOTS],
  1260505505: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS, IFCBSPLINECURVE, IFCTRIMMEDCURVE, IFCPOLYLINE, IFCINDEXEDPOLYCURVE, IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE, IFCCOMPOSITECURVE],
  1950629157: [IFCBUILDINGELEMENTPROXYTYPE, IFCBEAMTYPE, IFCWINDOWTYPE, IFCWALLTYPE, IFCSTAIRTYPE, IFCSTAIRFLIGHTTYPE, IFCSLABTYPE, IFCSHADINGDEVICETYPE, IFCROOFTYPE, IFCRAMPTYPE, IFCRAMPFLIGHTTYPE, IFCRAILINGTYPE, IFCPLATETYPE, IFCPILETYPE, IFCMEMBERTYPE, IFCFOOTINGTYPE, IFCDOORTYPE, IFCCURTAINWALLTYPE, IFCCOVERINGTYPE, IFCCOLUMNTYPE, IFCCHIMNEYTYPE],
  3732776249: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE, IFCCOMPOSITECURVEONSURFACE],
  15328376: [IFCOUTERBOUNDARYCURVE, IFCBOUNDARYCURVE],
  2510884976: [IFCCIRCLE, IFCELLIPSE],
  2559216714: [IFCCONSTRUCTIONPRODUCTRESOURCE, IFCCONSTRUCTIONMATERIALRESOURCE, IFCCONSTRUCTIONEQUIPMENTRESOURCE, IFCSUBCONTRACTRESOURCE, IFCLABORRESOURCE, IFCCREWRESOURCE],
  3293443760: [IFCACTIONREQUEST, IFCWORKSCHEDULE, IFCWORKPLAN, IFCWORKCONTROL, IFCWORKCALENDAR, IFCPROJECTORDER, IFCPERMIT, IFCPERFORMANCEHISTORY, IFCCOSTSCHEDULE, IFCCOSTITEM],
  3256556792: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE, IFCDISTRIBUTIONCONTROLELEMENTTYPE, IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE, IFCDISTRIBUTIONFLOWELEMENTTYPE],
  3849074793: [IFCDISTRIBUTIONCHAMBERELEMENTTYPE, IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE, IFCFLOWTREATMENTDEVICETYPE, IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE, IFCFLOWTERMINALTYPE, IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE, IFCFLOWSTORAGEDEVICETYPE, IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE, IFCFLOWSEGMENTTYPE, IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE, IFCFLOWMOVINGDEVICETYPE, IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE, IFCFLOWFITTINGTYPE, IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE, IFCFLOWCONTROLLERTYPE, IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE, IFCENERGYCONVERSIONDEVICETYPE],
  1758889154: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT, IFCDISTRIBUTIONELEMENT, IFCCIVILELEMENT, IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY, IFCBUILDINGELEMENT, IFCVIRTUALELEMENT, IFCTRANSPORTELEMENT, IFCGEOGRAPHICELEMENT, IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE, IFCFURNISHINGELEMENT, IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION, IFCFEATUREELEMENT, IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER, IFCELEMENTCOMPONENT, IFCELEMENTASSEMBLY],
  1623761950: [IFCDISCRETEACCESSORY, IFCBUILDINGELEMENTPART, IFCVIBRATIONISOLATOR, IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH, IFCREINFORCINGELEMENT, IFCMECHANICALFASTENER, IFCFASTENER],
  2590856083: [IFCDISCRETEACCESSORYTYPE, IFCBUILDINGELEMENTPARTTYPE, IFCVIBRATIONISOLATORTYPE, IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE, IFCREINFORCINGELEMENTTYPE, IFCMECHANICALFASTENERTYPE, IFCFASTENERTYPE],
  2107101300: [IFCELECTRICMOTORTYPE, IFCELECTRICGENERATORTYPE, IFCCOOLINGTOWERTYPE, IFCCOOLEDBEAMTYPE, IFCCONDENSERTYPE, IFCCOILTYPE, IFCCHILLERTYPE, IFCBURNERTYPE, IFCBOILERTYPE, IFCAIRTOAIRHEATRECOVERYTYPE, IFCUNITARYEQUIPMENTTYPE, IFCTUBEBUNDLETYPE, IFCTRANSFORMERTYPE, IFCSOLARDEVICETYPE, IFCMOTORCONNECTIONTYPE, IFCHUMIDIFIERTYPE, IFCHEATEXCHANGERTYPE, IFCEVAPORATORTYPE, IFCEVAPORATIVECOOLERTYPE, IFCENGINETYPE],
  2853485674: [IFCEXTERNALSPATIALELEMENT],
  807026263: [IFCFACETEDBREPWITHVOIDS],
  2827207264: [IFCSURFACEFEATURE, IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT, IFCFEATUREELEMENTSUBTRACTION, IFCPROJECTIONELEMENT, IFCFEATUREELEMENTADDITION],
  2143335405: [IFCPROJECTIONELEMENT],
  1287392070: [IFCVOIDINGFEATURE, IFCOPENINGSTANDARDCASE, IFCOPENINGELEMENT],
  3907093117: [IFCELECTRICTIMECONTROLTYPE, IFCELECTRICDISTRIBUTIONBOARDTYPE, IFCDAMPERTYPE, IFCAIRTERMINALBOXTYPE, IFCVALVETYPE, IFCSWITCHINGDEVICETYPE, IFCPROTECTIVEDEVICETYPE, IFCFLOWMETERTYPE],
  3198132628: [IFCDUCTFITTINGTYPE, IFCCABLEFITTINGTYPE, IFCCABLECARRIERFITTINGTYPE, IFCPIPEFITTINGTYPE, IFCJUNCTIONBOXTYPE],
  1482959167: [IFCFANTYPE, IFCCOMPRESSORTYPE, IFCPUMPTYPE],
  1834744321: [IFCDUCTSEGMENTTYPE, IFCCABLESEGMENTTYPE, IFCCABLECARRIERSEGMENTTYPE, IFCPIPESEGMENTTYPE],
  1339347760: [IFCELECTRICFLOWSTORAGEDEVICETYPE, IFCTANKTYPE],
  2297155007: [IFCFIRESUPPRESSIONTERMINALTYPE, IFCELECTRICAPPLIANCETYPE, IFCCOMMUNICATIONSAPPLIANCETYPE, IFCAUDIOVISUALAPPLIANCETYPE, IFCAIRTERMINALTYPE, IFCWASTETERMINALTYPE, IFCSTACKTERMINALTYPE, IFCSPACEHEATERTYPE, IFCSANITARYTERMINALTYPE, IFCOUTLETTYPE, IFCMEDICALDEVICETYPE, IFCLIGHTFIXTURETYPE, IFCLAMPTYPE],
  3009222698: [IFCFILTERTYPE, IFCDUCTSILENCERTYPE, IFCINTERCEPTORTYPE],
  263784265: [IFCSYSTEMFURNITUREELEMENT, IFCFURNITURE],
  2706460486: [IFCASSET, IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE, IFCSYSTEM, IFCSTRUCTURALRESULTGROUP, IFCSTRUCTURALLOADCASE, IFCSTRUCTURALLOADGROUP, IFCINVENTORY],
  3588315303: [IFCOPENINGSTANDARDCASE],
  3740093272: [IFCDISTRIBUTIONPORT],
  3027567501: [IFCREINFORCINGBAR, IFCTENDONANCHOR, IFCTENDON, IFCREINFORCINGMESH],
  964333572: [IFCREINFORCINGBARTYPE, IFCTENDONTYPE, IFCTENDONANCHORTYPE, IFCREINFORCINGMESHTYPE],
  682877961: [IFCSTRUCTURALPLANARACTION, IFCSTRUCTURALSURFACEACTION, IFCSTRUCTURALPOINTACTION, IFCSTRUCTURALLINEARACTION, IFCSTRUCTURALCURVEACTION],
  1179482911: [IFCSTRUCTURALSURFACECONNECTION, IFCSTRUCTURALPOINTCONNECTION, IFCSTRUCTURALCURVECONNECTION],
  1004757350: [IFCSTRUCTURALLINEARACTION],
  214636428: [IFCSTRUCTURALCURVEMEMBERVARYING],
  1252848954: [IFCSTRUCTURALLOADCASE],
  3657597509: [IFCSTRUCTURALPLANARACTION],
  2254336722: [IFCSTRUCTURALANALYSISMODEL, IFCDISTRIBUTIONCIRCUIT, IFCDISTRIBUTIONSYSTEM, IFCBUILDINGSYSTEM, IFCZONE],
  1028945134: [IFCWORKSCHEDULE, IFCWORKPLAN],
  1967976161: [IFCRATIONALBSPLINECURVEWITHKNOTS, IFCBSPLINECURVEWITHKNOTS],
  2461110595: [IFCRATIONALBSPLINECURVEWITHKNOTS],
  1136057603: [IFCOUTERBOUNDARYCURVE],
  3299480353: [IFCBEAMSTANDARDCASE, IFCBEAM, IFCWINDOWSTANDARDCASE, IFCWINDOW, IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE, IFCWALL, IFCSTAIRFLIGHT, IFCSTAIR, IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE, IFCSLAB, IFCSHADINGDEVICE, IFCROOF, IFCRAMPFLIGHT, IFCRAMP, IFCRAILING, IFCPLATESTANDARDCASE, IFCPLATE, IFCPILE, IFCMEMBERSTANDARDCASE, IFCMEMBER, IFCFOOTING, IFCDOORSTANDARDCASE, IFCDOOR, IFCCURTAINWALL, IFCCOVERING, IFCCOLUMNSTANDARDCASE, IFCCOLUMN, IFCCHIMNEY, IFCBUILDINGELEMENTPROXY],
  843113511: [IFCCOLUMNSTANDARDCASE],
  2063403501: [IFCCONTROLLERTYPE, IFCALARMTYPE, IFCACTUATORTYPE, IFCUNITARYCONTROLELEMENTTYPE, IFCSENSORTYPE, IFCPROTECTIVEDEVICETRIPPINGUNITTYPE, IFCFLOWINSTRUMENTTYPE],
  1945004755: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT, IFCDISTRIBUTIONCONTROLELEMENT, IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE, IFCDISTRIBUTIONFLOWELEMENT],
  3040386961: [IFCDISTRIBUTIONCHAMBERELEMENT, IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR, IFCFLOWTREATMENTDEVICE, IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP, IFCFLOWTERMINAL, IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK, IFCFLOWSTORAGEDEVICE, IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT, IFCFLOWSEGMENT, IFCFAN, IFCCOMPRESSOR, IFCPUMP, IFCFLOWMOVINGDEVICE, IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX, IFCFLOWFITTING, IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER, IFCFLOWCONTROLLER, IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE, IFCENERGYCONVERSIONDEVICE],
  3205830791: [IFCDISTRIBUTIONCIRCUIT],
  395920057: [IFCDOORSTANDARDCASE],
  1658829314: [IFCELECTRICMOTOR, IFCELECTRICGENERATOR, IFCCOOLINGTOWER, IFCCOOLEDBEAM, IFCCONDENSER, IFCCOIL, IFCCHILLER, IFCBURNER, IFCBOILER, IFCAIRTOAIRHEATRECOVERY, IFCUNITARYEQUIPMENT, IFCTUBEBUNDLE, IFCTRANSFORMER, IFCSOLARDEVICE, IFCMOTORCONNECTION, IFCHUMIDIFIER, IFCHEATEXCHANGER, IFCEVAPORATOR, IFCEVAPORATIVECOOLER, IFCENGINE],
  2058353004: [IFCELECTRICTIMECONTROL, IFCELECTRICDISTRIBUTIONBOARD, IFCDAMPER, IFCAIRTERMINALBOX, IFCVALVE, IFCSWITCHINGDEVICE, IFCPROTECTIVEDEVICE, IFCFLOWMETER],
  4278956645: [IFCDUCTFITTING, IFCCABLEFITTING, IFCCABLECARRIERFITTING, IFCPIPEFITTING, IFCJUNCTIONBOX],
  3132237377: [IFCFAN, IFCCOMPRESSOR, IFCPUMP],
  987401354: [IFCDUCTSEGMENT, IFCCABLESEGMENT, IFCCABLECARRIERSEGMENT, IFCPIPESEGMENT],
  707683696: [IFCELECTRICFLOWSTORAGEDEVICE, IFCTANK],
  2223149337: [IFCFIRESUPPRESSIONTERMINAL, IFCELECTRICAPPLIANCE, IFCCOMMUNICATIONSAPPLIANCE, IFCAUDIOVISUALAPPLIANCE, IFCAIRTERMINAL, IFCWASTETERMINAL, IFCSTACKTERMINAL, IFCSPACEHEATER, IFCSANITARYTERMINAL, IFCOUTLET, IFCMEDICALDEVICE, IFCLIGHTFIXTURE, IFCLAMP],
  3508470533: [IFCFILTER, IFCDUCTSILENCER, IFCINTERCEPTOR],
  1073191201: [IFCMEMBERSTANDARDCASE],
  3171933400: [IFCPLATESTANDARDCASE],
  1529196076: [IFCSLABSTANDARDCASE, IFCSLABELEMENTEDCASE],
  2391406946: [IFCWALLSTANDARDCASE, IFCWALLELEMENTEDCASE],
  3304561284: [IFCWINDOWSTANDARDCASE],
  753842376: [IFCBEAMSTANDARDCASE],
  1062813311: [IFCCONTROLLER, IFCALARM, IFCACTUATOR, IFCUNITARYCONTROLELEMENT, IFCSENSOR, IFCPROTECTIVEDEVICETRIPPINGUNIT, IFCFLOWINSTRUMENT]
};
InversePropertyDef[3] = {
  3630933823: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  618182010: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  411424972: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  130549933: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["ApprovedObjects", IFCRELASSOCIATESAPPROVAL, 5, true], ["ApprovedResources", IFCRESOURCEAPPROVALRELATIONSHIP, 3, true], ["IsRelatedWith", IFCAPPROVALRELATIONSHIP, 3, true], ["Relates", IFCAPPROVALRELATIONSHIP, 2, true]],
  1959218052: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  1466758467: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  602808272: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3200245327: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  2242383968: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  1040185647: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  3548104201: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true]],
  852622518: [["PartOfW", IFCGRID, 9, true], ["PartOfV", IFCGRID, 8, true], ["PartOfU", IFCGRID, 7, true], ["HasIntersections", IFCVIRTUALGRIDINTERSECTION, 0, true]],
  2655187982: [["LibraryInfoForObjects", IFCRELASSOCIATESLIBRARY, 5, true], ["HasLibraryReferences", IFCLIBRARYREFERENCE, 5, true]],
  3452421091: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["LibraryRefForObjects", IFCRELASSOCIATESLIBRARY, 5, true]],
  760658860: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  248100487: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  3303938423: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1847252529: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialLayerSet", IFCMATERIALLAYERSET, 0, false]],
  2235152071: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  164193824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  552965576: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialProfileSet", IFCMATERIALPROFILESET, 2, false]],
  1507914824: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3368373690: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  3701648758: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  2251480897: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PropertiesForConstraint", IFCRESOURCECONSTRAINTRELATIONSHIP, 2, true]],
  4251960020: [["IsRelatedBy", IFCORGANIZATIONRELATIONSHIP, 3, true], ["Relates", IFCORGANIZATIONRELATIONSHIP, 2, true], ["Engages", IFCPERSONANDORGANIZATION, 1, true]],
  2077209135: [["EngagedIn", IFCPERSONANDORGANIZATION, 0, true]],
  2483315170: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2226359599: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3355820592: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  3958567839: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3843373140: [["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  986844984: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3710013099: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2044713172: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2093928680: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  931644368: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  3252649465: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  2405470396: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  825690147: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  1076942058: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3377609919: [["RepresentationsInContext", IFCREPRESENTATION, 0, true]],
  3008791417: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1660063152: [["HasShapeAspects", IFCSHAPEASPECT, 4, true], ["MapUsage", IFCMAPPEDITEM, 0, true]],
  3982875396: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  4240577450: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2830218821: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  3958052878: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3049322572: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true]],
  626085974: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  912023232: [["OfPerson", IFCPERSON, 7, true], ["OfOrganization", IFCORGANIZATION, 4, true]],
  3101149627: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1377556343: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1735638870: [["RepresentationMap", IFCREPRESENTATIONMAP, 1, true], ["LayerAssignments", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["OfProductRepresentation", IFCPRODUCTREPRESENTATION, 2, true], ["OfShapeAspect", IFCSHAPEASPECT, 0, true]],
  2799835756: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1907098498: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3798115385: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1310608509: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2705031697: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  616511568: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3150382593: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  747523909: [["ClassificationForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  647927063: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["ClassificationRefForObjects", IFCRELASSOCIATESCLASSIFICATION, 5, true], ["HasReferences", IFCCLASSIFICATIONREFERENCE, 3, true]],
  1485152156: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  370225590: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3050246964: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2889183280: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2713554722: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  3632507154: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1154170062: [["DocumentInfoForObjects", IFCRELASSOCIATESDOCUMENT, 5, true], ["HasDocumentReferences", IFCDOCUMENTREFERENCE, 4, true], ["IsPointedTo", IFCDOCUMENTINFORMATIONRELATIONSHIP, 3, true], ["IsPointer", IFCDOCUMENTINFORMATIONRELATIONSHIP, 2, true]],
  3732053477: [["ExternalReferenceForResources", IFCEXTERNALREFERENCERELATIONSHIP, 2, true], ["DocumentRefForObjects", IFCRELASSOCIATESDOCUMENT, 5, true]],
  3900360178: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  476780140: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  297599258: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2556980723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  1809719519: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  803316827: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3008276851: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  3448662350: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  2453401579: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4142052618: [["RepresentationsInContext", IFCREPRESENTATION, 0, true], ["HasSubContexts", IFCGEOMETRICREPRESENTATIONSUBCONTEXT, 6, true], ["HasCoordinateOperation", IFCCOORDINATEOPERATION, 0, true]],
  3590301190: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  178086475: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  812098782: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3905492369: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  3741457305: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1402838566: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  125510826: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2604431987: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4266656042: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1520743889: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3422422726: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2624227202: [["PlacesObject", IFCPRODUCT, 5, true], ["ReferencedByPlacements", IFCLOCALPLACEMENT, 0, true]],
  1008929658: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2347385850: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1838606355: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["HasRepresentation", IFCMATERIALDEFINITIONREPRESENTATION, 3, true], ["IsRelatedWith", IFCMATERIALRELATIONSHIP, 3, true], ["RelatesTo", IFCMATERIALRELATIONSHIP, 2, true]],
  3708119e3: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true], ["ToMaterialConstituentSet", IFCMATERIALCONSTITUENTSET, 2, false]],
  2852063980: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true], ["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCMATERIALPROPERTIES, 3, true]],
  1303795690: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3079605661: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3404854881: [["AssociatedTo", IFCRELASSOCIATESMATERIAL, 5, true]],
  3265635763: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2998442950: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  219451334: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2665983363: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1029017970: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2529465313: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2519244187: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3021840470: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfComplex", IFCPHYSICALCOMPLEXQUANTITY, 2, true]],
  597895409: [["IsMappedBy", IFCTEXTURECOORDINATE, 0, true], ["UsedInStyles", IFCSURFACESTYLEWITHTEXTURES, 0, true]],
  2004835150: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1663979128: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2067069095: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4022376103: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1423911732: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2924175390: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2775532180: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3778827333: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  673634403: [["ShapeOfProduct", IFCPRODUCT, 6, true], ["HasShapeAspects", IFCSHAPEASPECT, 4, true]],
  2802850158: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2598011224: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1680319473: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  3357820518: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1482703590: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true]],
  2090586900: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3615266464: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3413951693: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1580146022: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  2778083089: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2042790032: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  4165799628: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true]],
  1509187699: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124623270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3692461612: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  723233188: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2233826070: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2513912981: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2247615214: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260650574: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1096409881: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  230924584: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3071757647: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  901063453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4282788508: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3124975700: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2715220739: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1628702193: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true]],
  3736923433: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2347495698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3698973494: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  427810014: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1417489154: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2759199220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1299126871: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2543172580: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3406155212: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasTextureMaps", IFCTEXTUREMAP, 2, true]],
  669184980: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3207858831: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4261334040: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3125803723: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2740243338: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2736907675: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4182860854: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2581212453: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2713105998: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2898889636: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  1123145078: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  574549367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1675464909: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2059837836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  59481748: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3749851601: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3486308946: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3331915920: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1416205885: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1383045692: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2205249479: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2542286263: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2485617015: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2574617495: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3419103109: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  1815067380: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2506170314: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2147822146: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2601014836: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2827736869: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2629017746: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  32440307: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  526551008: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1472233963: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1883228015: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  339256511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2777663545: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2835456948: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  4024345920: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  477187591: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2804161546: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2047409740: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  374418227: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  315944413: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2652556860: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4238390223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1268542332: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4095422895: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  987898635: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1484403080: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  178912537: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true]],
  2294589976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["ToFaceSet", IFCPOLYGONALFACESET, 2, true]],
  572779678: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  428585644: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1281925730: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1425443689: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3888040117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true]],
  3388369263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3505215534: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1682466193: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  603570806: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  220341763: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3967405729: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  569719735: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2945172077: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  4208778838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  103090709: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  653396225: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Declares", IFCRELDECLARES, 4, true]],
  871118103: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  4166981789: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  2752243245: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  941946838: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  1451395588: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  492091185: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Defines", IFCRELDEFINESBYTEMPLATE, 5, true]],
  3650150729: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  110355661: [["HasExternalReferences", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["PartOfPset", IFCPROPERTYSET, 4, true], ["PropertyForDependance", IFCPROPERTYDEPENDENCYRELATIONSHIP, 2, true], ["PropertyDependsOn", IFCPROPERTYDEPENDENCYRELATIONSHIP, 3, true], ["PartOfComplex", IFCCOMPLEXPROPERTY, 3, true], ["HasConstraints", IFCRESOURCECONSTRAINTRELATIONSHIP, 3, true], ["HasApprovals", IFCRESOURCEAPPROVALRELATIONSHIP, 2, true]],
  3521284610: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  3219374653: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2770003689: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  2798486643: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3454111270: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3765753017: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3523091289: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true]],
  1521410863: [["InnerBoundaries", IFCRELSPACEBOUNDARY1STLEVEL, 9, true], ["Corresponds", IFCRELSPACEBOUNDARY2NDLEVEL, 10, true]],
  816062949: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["UsingCurves", IFCCOMPOSITECURVE, 0, true]],
  2914609552: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1856042241: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3243963512: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4158566097: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3626867408: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3663146110: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  1412071761: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  710998568: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2706606064: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  3893378262: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  463610769: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  2481509218: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  451544542: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4015995234: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3544373492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3136571912: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true]],
  530289379: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  3689010777: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  3979015343: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2218152070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  603775116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4095615324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  699246055: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2028607225: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2809605785: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4124788165: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1580310250: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3473067441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  3206491090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2387106220: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  1935646853: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2097647324: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2916149573: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  336235671: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  512836454: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2296667514: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  1635779807: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2603310189: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1674181508: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2887950389: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  167062518: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1334484129: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3649129432: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1260505505: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4031249490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  1950629157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3124254112: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  2197970202: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2937912522: [["HasExternalReference", IFCEXTERNALREFERENCERELATIONSHIP, 3, true], ["HasProperties", IFCPROFILEPROPERTIES, 3, true]],
  3893394355: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  300633059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3875453745: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["PartOfComplexTemplate", IFCCOMPLEXPROPERTYTEMPLATE, 6, true], ["PartOfPsetTemplate", IFCPROPERTYSETTEMPLATE, 6, true]],
  3732776249: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  15328376: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2510884976: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2185764099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  4105962743: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1525564444: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  2559216714: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3293443760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3895139033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1419761937: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1916426348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3295246426: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1457835157: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1213902940: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3256556792: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3849074793: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2963535650: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  1714330368: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  2323601079: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1758889154: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4123344466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2397081782: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1623761950: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2590856083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1704287377: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2107101300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  132023988: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3174744832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3390157468: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4148101412: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2853485674: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  807026263: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3737207727: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  647756555: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2489546625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2827207264: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2143335405: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1287392070: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  3907093117: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3198132628: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3815607619: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1482959167: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1834744321: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1339347760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2297155007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3009222698: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1893162501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  263784265: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1509553395: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3493046030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3009204131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true]],
  2706460486: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true]],
  1251058090: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1806887404: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2571569899: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3946677679: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3113134337: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2391368822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true]],
  4288270099: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3827777499: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1051575348: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1161773419: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  377706215: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2108223431: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1114901282: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3181161470: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  977012517: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4143007308: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsActingUpon", IFCRELASSIGNSTOACTOR, 6, true]],
  3588315303: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  3079942009: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false], ["HasFillings", IFCRELFILLSELEMENT, 4, true]],
  2837617999: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2382730787: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3566463478: [["HasContext", IFCRELDECLARES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["DefinesType", IFCTYPEOBJECT, 5, true], ["IsDefinedBy", IFCRELDEFINESBYTEMPLATE, 4, true], ["DefinesOccurrence", IFCRELDEFINESBYPROPERTIES, 5, true]],
  3327091369: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1158309216: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  804291784: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4231323485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4017108033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2839578677: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true], ["HasColours", IFCINDEXEDCOLOURMAP, 0, true], ["HasTextures", IFCINDEXEDTEXTUREMAP, 1, true]],
  3724593414: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3740093272: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  2744685151: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsPredecessorTo", IFCRELSEQUENCE, 4, true], ["IsSuccessorFrom", IFCRELSEQUENCE, 5, true], ["OperatesOn", IFCRELASSIGNSTOPROCESS, 6, true]],
  2904328755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3651124850: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["ProjectsElements", IFCRELPROJECTSELEMENT, 5, false]],
  1842657554: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2250791053: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2893384427: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2324767716: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1469900589: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  683857671: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3027567501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  964333572: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2320036040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2310774935: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2781568857: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1768891740: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2157484638: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  4074543187: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4097777520: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true]],
  2533589738: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1072016465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3856911033: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["HasCoverings", IFCRELCOVERSSPACES, 4, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  1305183839: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3812236995: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3112655638: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1039846685: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  338393293: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  682877961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1179482911: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1004757350: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  4243806635: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  214636428: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2445595289: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectedBy", IFCRELCONNECTSSTRUCTURALMEMBER, 4, true]],
  2757150158: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1807405624: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1252848954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  2082059205: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  734778138: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  1235345126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  2986769608: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ResultGroupFor", IFCSTRUCTURALANALYSISMODEL, 8, true]],
  3657597509: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1975003073: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedStructuralActivity", IFCRELCONNECTSSTRUCTURALACTIVITY, 4, true], ["ConnectsStructuralMembers", IFCRELCONNECTSSTRUCTURALMEMBER, 5, true]],
  148013059: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  3101698114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2315554128: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2254336722: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  413509423: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  5716631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3824725483: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2347447852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3081323446: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2415094496: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1692211062: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1620046519: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3593883385: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1600972822: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1911125066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  728799441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2391383451: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3313531582: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2769231204: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  926996030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["VoidsElements", IFCRELVOIDSELEMENT, 5, false]],
  1898987631: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1133259667: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4009809668: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4088093105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1028945134: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  4218914973: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  3342526732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1033361043: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  3821786052: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["Controls", IFCRELASSIGNSTOCONTROL, 6, true]],
  1411407467: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3352864051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1871374353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3460190687: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true]],
  1532957894: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1967976161: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  2461110595: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  819618141: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  231477066: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1136057603: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3299480353: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2979338954: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  39481116: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1095909175: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1909888760: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1177604601: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  2188180465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  395041908: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3293546465: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2674252688: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1285652485: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2951183804: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3296154744: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2611217952: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  1677625105: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2301859152: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  843113511: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  905975707: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  400855858: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3850581409: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2816379211: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3898045240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  1060000209: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  488727124: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ResourceOf", IFCRELASSIGNSTORESOURCE, 6, true]],
  335055490: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2954562838: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1973544240: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["CoversSpaces", IFCRELCOVERSSPACES, 5, true], ["CoversElements", IFCRELCOVERSBLDGELEMENTS, 5, true]],
  3495092785: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3961806047: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1335981549: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2635815018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1599208980: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2063403501: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1945004755: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true]],
  3040386961: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3041715199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainedIn", IFCRELCONNECTSPORTTOELEMENT, 4, true], ["ConnectedFrom", IFCRELCONNECTSPORTS, 5, true], ["ConnectedTo", IFCRELCONNECTSPORTS, 4, true]],
  3205830791: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  395920057: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3242481149: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  869906466: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3760055223: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2030761528: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  663422040: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2417008758: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  3277789161: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1534661035: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1217240411: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  712377611: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1658829314: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2814081492: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3747195512: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  484807127: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1209101575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["ContainsElements", IFCRELCONTAINEDINSPATIALSTRUCTURE, 5, true], ["ServicedBySystems", IFCRELSERVICESBUILDINGS, 5, true], ["ReferencesElements", IFCRELREFERENCEDINSPATIALSTRUCTURE, 5, true], ["BoundedBy", IFCRELSPACEBOUNDARY, 4, true]],
  346874300: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1810631287: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4222183408: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2058353004: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4278956645: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4037862832: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2188021234: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3132237377: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  987401354: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  707683696: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2223149337: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3508470533: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  900683007: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3319311131: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2068733104: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4175244083: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2176052936: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  76236018: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  629592764: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1437502449: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1073191201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1911478936: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2474470126: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  144952367: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  3694346114: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1687234759: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  310824031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3612865200: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3171933400: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1156407060: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  738039164: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  655969474: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  90941305: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2262370178: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3024970846: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3283111854: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1232101972: [["LayerAssignment", IFCPRESENTATIONLAYERASSIGNMENT, 2, true], ["StyledByItem", IFCSTYLEDITEM, 0, true]],
  979691226: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2572171363: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  2016517767: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3053780830: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1783015770: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1329646415: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  1529196076: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3127900445: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3027962421: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3420628829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1999602285: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1404847402: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  331165859: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4252922144: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2515109513: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  385403989: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["SourceOfResultGroup", IFCSTRUCTURALRESULTGROUP, 6, true], ["LoadGroupFor", IFCSTRUCTURALANALYSISMODEL, 7, true]],
  1621171031: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["AssignedToStructuralItem", IFCRELCONNECTSSTRUCTURALACTIVITY, 5, true]],
  1162798199: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  812556717: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3825984169: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3026737570: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3179687236: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4292641817: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4207607924: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2391406946: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4156078855: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  3512223829: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  4237592921: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3304561284: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  486154966: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2874132201: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  1634111441: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  177149247: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2056796094: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3001207471: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  277319702: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  753842376: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  2906023776: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true]],
  32344328: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2938176219: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  635142910: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3758799889: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1051757585: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4217484030: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3902619387: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  639361253: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3221913625: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3571504051: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  2272882330: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  578613899: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["Types", IFCRELDEFINESBYTYPE, 5, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true]],
  4136498852: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3640358203: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  4074379575: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1052013943: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  562808652: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["IsGroupedBy", IFCRELASSIGNSTOGROUP, 6, true], ["ServicesBuildings", IFCRELSERVICESBUILDINGS, 4, true]],
  1062813311: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  342316401: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3518393246: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1360408905: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1904799276: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  862014818: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3310460725: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  264262732: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  402227799: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1003880860: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  3415622556: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  819412036: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  1426591983: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["HasControlElements", IFCRELFLOWCONTROLELEMENTS, 5, true]],
  182646315: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  2295281155: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4086658281: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  630975310: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  4288193352: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  3087945054: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]],
  25142252: [["HasAssignments", IFCRELASSIGNS, 4, true], ["Nests", IFCRELNESTS, 5, true], ["IsNestedBy", IFCRELNESTS, 4, true], ["HasContext", IFCRELDECLARES, 5, true], ["IsDecomposedBy", IFCRELAGGREGATES, 4, true], ["Decomposes", IFCRELAGGREGATES, 5, true], ["HasAssociations", IFCRELASSOCIATES, 4, true], ["IsDeclaredBy", IFCRELDEFINESBYOBJECT, 4, true], ["Declares", IFCRELDEFINESBYOBJECT, 5, true], ["IsTypedBy", IFCRELDEFINESBYTYPE, 4, true], ["IsDefinedBy", IFCRELDEFINESBYPROPERTIES, 4, true], ["ReferencedBy", IFCRELASSIGNSTOPRODUCT, 6, true], ["FillsVoids", IFCRELFILLSELEMENT, 5, true], ["ConnectedTo", IFCRELCONNECTSELEMENTS, 5, true], ["IsInterferedByElements", IFCRELINTERFERESELEMENTS, 5, true], ["InterferesElements", IFCRELINTERFERESELEMENTS, 4, true], ["HasProjections", IFCRELPROJECTSELEMENT, 4, true], ["ReferencedInStructures", IFCRELREFERENCEDINSPATIALSTRUCTURE, 4, true], ["HasOpenings", IFCRELVOIDSELEMENT, 4, true], ["IsConnectionRealization", IFCRELCONNECTSWITHREALIZINGELEMENTS, 7, true], ["ProvidesBoundaries", IFCRELSPACEBOUNDARY, 5, true], ["ConnectedFrom", IFCRELCONNECTSELEMENTS, 6, true], ["ContainedInStructure", IFCRELCONTAINEDINSPATIALSTRUCTURE, 4, true], ["HasCoverings", IFCRELCOVERSBLDGELEMENTS, 4, true], ["HasPorts", IFCRELCONNECTSPORTTOELEMENT, 5, true], ["AssignedToFlowElement", IFCRELFLOWCONTROLELEMENTS, 4, true]]
};
Constructors[3] = {
  3630933823: function _(ID, a) {
    return new IFC4.IfcActorRole(ID, a[0], a[1], a[2]);
  },
  618182010: function _(ID, a) {
    return new IFC4.IfcAddress(ID, a[0], a[1], a[2]);
  },
  639542469: function _(ID, a) {
    return new IFC4.IfcApplication(ID, a[0], a[1], a[2], a[3]);
  },
  411424972: function _(ID, a) {
    return new IFC4.IfcAppliedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  130549933: function _(ID, a) {
    return new IFC4.IfcApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4037036970: function _(ID, a) {
    return new IFC4.IfcBoundaryCondition(ID, a[0]);
  },
  1560379544: function _(ID, a) {
    return new IFC4.IfcBoundaryEdgeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3367102660: function _(ID, a) {
    return new IFC4.IfcBoundaryFaceCondition(ID, a[0], a[1], a[2], a[3]);
  },
  1387855156: function _(ID, a) {
    return new IFC4.IfcBoundaryNodeCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2069777674: function _(ID, a) {
    return new IFC4.IfcBoundaryNodeConditionWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2859738748: function _(ID, _125) {
    return new IFC4.IfcConnectionGeometry(ID);
  },
  2614616156: function _(ID, a) {
    return new IFC4.IfcConnectionPointGeometry(ID, a[0], a[1]);
  },
  2732653382: function _(ID, a) {
    return new IFC4.IfcConnectionSurfaceGeometry(ID, a[0], a[1]);
  },
  775493141: function _(ID, a) {
    return new IFC4.IfcConnectionVolumeGeometry(ID, a[0], a[1]);
  },
  1959218052: function _(ID, a) {
    return new IFC4.IfcConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1785450214: function _(ID, a) {
    return new IFC4.IfcCoordinateOperation(ID, a[0], a[1]);
  },
  1466758467: function _(ID, a) {
    return new IFC4.IfcCoordinateReferenceSystem(ID, a[0], a[1], a[2], a[3]);
  },
  602808272: function _(ID, a) {
    return new IFC4.IfcCostValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1765591967: function _(ID, a) {
    return new IFC4.IfcDerivedUnit(ID, a[0], a[1], a[2]);
  },
  1045800335: function _(ID, a) {
    return new IFC4.IfcDerivedUnitElement(ID, a[0], a[1]);
  },
  2949456006: function _(ID, a) {
    return new IFC4.IfcDimensionalExponents(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  4294318154: function _(ID, _126) {
    return new IFC4.IfcExternalInformation(ID);
  },
  3200245327: function _(ID, a) {
    return new IFC4.IfcExternalReference(ID, a[0], a[1], a[2]);
  },
  2242383968: function _(ID, a) {
    return new IFC4.IfcExternallyDefinedHatchStyle(ID, a[0], a[1], a[2]);
  },
  1040185647: function _(ID, a) {
    return new IFC4.IfcExternallyDefinedSurfaceStyle(ID, a[0], a[1], a[2]);
  },
  3548104201: function _(ID, a) {
    return new IFC4.IfcExternallyDefinedTextFont(ID, a[0], a[1], a[2]);
  },
  852622518: function _(ID, a) {
    return new IFC4.IfcGridAxis(ID, a[0], a[1], a[2]);
  },
  3020489413: function _(ID, a) {
    return new IFC4.IfcIrregularTimeSeriesValue(ID, a[0], a[1]);
  },
  2655187982: function _(ID, a) {
    return new IFC4.IfcLibraryInformation(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3452421091: function _(ID, a) {
    return new IFC4.IfcLibraryReference(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4162380809: function _(ID, a) {
    return new IFC4.IfcLightDistributionData(ID, a[0], a[1], a[2]);
  },
  1566485204: function _(ID, a) {
    return new IFC4.IfcLightIntensityDistribution(ID, a[0], a[1]);
  },
  3057273783: function _(ID, a) {
    return new IFC4.IfcMapConversion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1847130766: function _(ID, a) {
    return new IFC4.IfcMaterialClassificationRelationship(ID, a[0], a[1]);
  },
  760658860: function _(ID, _127) {
    return new IFC4.IfcMaterialDefinition(ID);
  },
  248100487: function _(ID, a) {
    return new IFC4.IfcMaterialLayer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3303938423: function _(ID, a) {
    return new IFC4.IfcMaterialLayerSet(ID, a[0], a[1], a[2]);
  },
  1847252529: function _(ID, a) {
    return new IFC4.IfcMaterialLayerWithOffsets(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2199411900: function _(ID, a) {
    return new IFC4.IfcMaterialList(ID, a[0]);
  },
  2235152071: function _(ID, a) {
    return new IFC4.IfcMaterialProfile(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  164193824: function _(ID, a) {
    return new IFC4.IfcMaterialProfileSet(ID, a[0], a[1], a[2], a[3]);
  },
  552965576: function _(ID, a) {
    return new IFC4.IfcMaterialProfileWithOffsets(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1507914824: function _(ID, _128) {
    return new IFC4.IfcMaterialUsageDefinition(ID);
  },
  2597039031: function _(ID, a) {
    return new IFC4.IfcMeasureWithUnit(ID, a[0], a[1]);
  },
  3368373690: function _(ID, a) {
    return new IFC4.IfcMetric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2706619895: function _(ID, a) {
    return new IFC4.IfcMonetaryUnit(ID, a[0]);
  },
  1918398963: function _(ID, a) {
    return new IFC4.IfcNamedUnit(ID, a[0], a[1]);
  },
  3701648758: function _(ID, _129) {
    return new IFC4.IfcObjectPlacement(ID);
  },
  2251480897: function _(ID, a) {
    return new IFC4.IfcObjective(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4251960020: function _(ID, a) {
    return new IFC4.IfcOrganization(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1207048766: function _(ID, a) {
    return new IFC4.IfcOwnerHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2077209135: function _(ID, a) {
    return new IFC4.IfcPerson(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  101040310: function _(ID, a) {
    return new IFC4.IfcPersonAndOrganization(ID, a[0], a[1], a[2]);
  },
  2483315170: function _(ID, a) {
    return new IFC4.IfcPhysicalQuantity(ID, a[0], a[1]);
  },
  2226359599: function _(ID, a) {
    return new IFC4.IfcPhysicalSimpleQuantity(ID, a[0], a[1], a[2]);
  },
  3355820592: function _(ID, a) {
    return new IFC4.IfcPostalAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  677532197: function _(ID, _130) {
    return new IFC4.IfcPresentationItem(ID);
  },
  2022622350: function _(ID, a) {
    return new IFC4.IfcPresentationLayerAssignment(ID, a[0], a[1], a[2], a[3]);
  },
  1304840413: function _(ID, a) {
    return new IFC4.IfcPresentationLayerWithStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3119450353: function _(ID, a) {
    return new IFC4.IfcPresentationStyle(ID, a[0]);
  },
  2417041796: function _(ID, a) {
    return new IFC4.IfcPresentationStyleAssignment(ID, a[0]);
  },
  2095639259: function _(ID, a) {
    return new IFC4.IfcProductRepresentation(ID, a[0], a[1], a[2]);
  },
  3958567839: function _(ID, a) {
    return new IFC4.IfcProfileDef(ID, a[0], a[1]);
  },
  3843373140: function _(ID, a) {
    return new IFC4.IfcProjectedCRS(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  986844984: function _(ID, _131) {
    return new IFC4.IfcPropertyAbstraction(ID);
  },
  3710013099: function _(ID, a) {
    return new IFC4.IfcPropertyEnumeration(ID, a[0], a[1], a[2]);
  },
  2044713172: function _(ID, a) {
    return new IFC4.IfcQuantityArea(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2093928680: function _(ID, a) {
    return new IFC4.IfcQuantityCount(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  931644368: function _(ID, a) {
    return new IFC4.IfcQuantityLength(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3252649465: function _(ID, a) {
    return new IFC4.IfcQuantityTime(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2405470396: function _(ID, a) {
    return new IFC4.IfcQuantityVolume(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  825690147: function _(ID, a) {
    return new IFC4.IfcQuantityWeight(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3915482550: function _(ID, a) {
    return new IFC4.IfcRecurrencePattern(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2433181523: function _(ID, a) {
    return new IFC4.IfcReference(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1076942058: function _(ID, a) {
    return new IFC4.IfcRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  3377609919: function _(ID, a) {
    return new IFC4.IfcRepresentationContext(ID, a[0], a[1]);
  },
  3008791417: function _(ID, _132) {
    return new IFC4.IfcRepresentationItem(ID);
  },
  1660063152: function _(ID, a) {
    return new IFC4.IfcRepresentationMap(ID, a[0], a[1]);
  },
  2439245199: function _(ID, a) {
    return new IFC4.IfcResourceLevelRelationship(ID, a[0], a[1]);
  },
  2341007311: function _(ID, a) {
    return new IFC4.IfcRoot(ID, a[0], a[1], a[2], a[3]);
  },
  448429030: function _(ID, a) {
    return new IFC4.IfcSIUnit(ID, a[0], a[1], a[2]);
  },
  1054537805: function _(ID, a) {
    return new IFC4.IfcSchedulingTime(ID, a[0], a[1], a[2]);
  },
  867548509: function _(ID, a) {
    return new IFC4.IfcShapeAspect(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3982875396: function _(ID, a) {
    return new IFC4.IfcShapeModel(ID, a[0], a[1], a[2], a[3]);
  },
  4240577450: function _(ID, a) {
    return new IFC4.IfcShapeRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  2273995522: function _(ID, a) {
    return new IFC4.IfcStructuralConnectionCondition(ID, a[0]);
  },
  2162789131: function _(ID, a) {
    return new IFC4.IfcStructuralLoad(ID, a[0]);
  },
  3478079324: function _(ID, a) {
    return new IFC4.IfcStructuralLoadConfiguration(ID, a[0], a[1], a[2]);
  },
  609421318: function _(ID, a) {
    return new IFC4.IfcStructuralLoadOrResult(ID, a[0]);
  },
  2525727697: function _(ID, a) {
    return new IFC4.IfcStructuralLoadStatic(ID, a[0]);
  },
  3408363356: function _(ID, a) {
    return new IFC4.IfcStructuralLoadTemperature(ID, a[0], a[1], a[2], a[3]);
  },
  2830218821: function _(ID, a) {
    return new IFC4.IfcStyleModel(ID, a[0], a[1], a[2], a[3]);
  },
  3958052878: function _(ID, a) {
    return new IFC4.IfcStyledItem(ID, a[0], a[1], a[2]);
  },
  3049322572: function _(ID, a) {
    return new IFC4.IfcStyledRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  2934153892: function _(ID, a) {
    return new IFC4.IfcSurfaceReinforcementArea(ID, a[0], a[1], a[2], a[3]);
  },
  1300840506: function _(ID, a) {
    return new IFC4.IfcSurfaceStyle(ID, a[0], a[1], a[2]);
  },
  3303107099: function _(ID, a) {
    return new IFC4.IfcSurfaceStyleLighting(ID, a[0], a[1], a[2], a[3]);
  },
  1607154358: function _(ID, a) {
    return new IFC4.IfcSurfaceStyleRefraction(ID, a[0], a[1]);
  },
  846575682: function _(ID, a) {
    return new IFC4.IfcSurfaceStyleShading(ID, a[0], a[1]);
  },
  1351298697: function _(ID, a) {
    return new IFC4.IfcSurfaceStyleWithTextures(ID, a[0]);
  },
  626085974: function _(ID, a) {
    return new IFC4.IfcSurfaceTexture(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  985171141: function _(ID, a) {
    return new IFC4.IfcTable(ID, a[0], a[1], a[2]);
  },
  2043862942: function _(ID, a) {
    return new IFC4.IfcTableColumn(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  531007025: function _(ID, a) {
    return new IFC4.IfcTableRow(ID, a[0], a[1]);
  },
  1549132990: function _(ID, a) {
    return new IFC4.IfcTaskTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]);
  },
  2771591690: function _(ID, a) {
    return new IFC4.IfcTaskTimeRecurring(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19], a[20]);
  },
  912023232: function _(ID, a) {
    return new IFC4.IfcTelecomAddress(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1447204868: function _(ID, a) {
    return new IFC4.IfcTextStyle(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2636378356: function _(ID, a) {
    return new IFC4.IfcTextStyleForDefinedFont(ID, a[0], a[1]);
  },
  1640371178: function _(ID, a) {
    return new IFC4.IfcTextStyleTextModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  280115917: function _(ID, a) {
    return new IFC4.IfcTextureCoordinate(ID, a[0]);
  },
  1742049831: function _(ID, a) {
    return new IFC4.IfcTextureCoordinateGenerator(ID, a[0], a[1], a[2]);
  },
  2552916305: function _(ID, a) {
    return new IFC4.IfcTextureMap(ID, a[0], a[1], a[2]);
  },
  1210645708: function _(ID, a) {
    return new IFC4.IfcTextureVertex(ID, a[0]);
  },
  3611470254: function _(ID, a) {
    return new IFC4.IfcTextureVertexList(ID, a[0]);
  },
  1199560280: function _(ID, a) {
    return new IFC4.IfcTimePeriod(ID, a[0], a[1]);
  },
  3101149627: function _(ID, a) {
    return new IFC4.IfcTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  581633288: function _(ID, a) {
    return new IFC4.IfcTimeSeriesValue(ID, a[0]);
  },
  1377556343: function _(ID, _133) {
    return new IFC4.IfcTopologicalRepresentationItem(ID);
  },
  1735638870: function _(ID, a) {
    return new IFC4.IfcTopologyRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  180925521: function _(ID, a) {
    return new IFC4.IfcUnitAssignment(ID, a[0]);
  },
  2799835756: function _(ID, _134) {
    return new IFC4.IfcVertex(ID);
  },
  1907098498: function _(ID, a) {
    return new IFC4.IfcVertexPoint(ID, a[0]);
  },
  891718957: function _(ID, a) {
    return new IFC4.IfcVirtualGridIntersection(ID, a[0], a[1]);
  },
  1236880293: function _(ID, a) {
    return new IFC4.IfcWorkTime(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3869604511: function _(ID, a) {
    return new IFC4.IfcApprovalRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  3798115385: function _(ID, a) {
    return new IFC4.IfcArbitraryClosedProfileDef(ID, a[0], a[1], a[2]);
  },
  1310608509: function _(ID, a) {
    return new IFC4.IfcArbitraryOpenProfileDef(ID, a[0], a[1], a[2]);
  },
  2705031697: function _(ID, a) {
    return new IFC4.IfcArbitraryProfileDefWithVoids(ID, a[0], a[1], a[2], a[3]);
  },
  616511568: function _(ID, a) {
    return new IFC4.IfcBlobTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3150382593: function _(ID, a) {
    return new IFC4.IfcCenterLineProfileDef(ID, a[0], a[1], a[2], a[3]);
  },
  747523909: function _(ID, a) {
    return new IFC4.IfcClassification(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  647927063: function _(ID, a) {
    return new IFC4.IfcClassificationReference(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3285139300: function _(ID, a) {
    return new IFC4.IfcColourRgbList(ID, a[0]);
  },
  3264961684: function _(ID, a) {
    return new IFC4.IfcColourSpecification(ID, a[0]);
  },
  1485152156: function _(ID, a) {
    return new IFC4.IfcCompositeProfileDef(ID, a[0], a[1], a[2], a[3]);
  },
  370225590: function _(ID, a) {
    return new IFC4.IfcConnectedFaceSet(ID, a[0]);
  },
  1981873012: function _(ID, a) {
    return new IFC4.IfcConnectionCurveGeometry(ID, a[0], a[1]);
  },
  45288368: function _(ID, a) {
    return new IFC4.IfcConnectionPointEccentricity(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3050246964: function _(ID, a) {
    return new IFC4.IfcContextDependentUnit(ID, a[0], a[1], a[2]);
  },
  2889183280: function _(ID, a) {
    return new IFC4.IfcConversionBasedUnit(ID, a[0], a[1], a[2], a[3]);
  },
  2713554722: function _(ID, a) {
    return new IFC4.IfcConversionBasedUnitWithOffset(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  539742890: function _(ID, a) {
    return new IFC4.IfcCurrencyRelationship(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3800577675: function _(ID, a) {
    return new IFC4.IfcCurveStyle(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1105321065: function _(ID, a) {
    return new IFC4.IfcCurveStyleFont(ID, a[0], a[1]);
  },
  2367409068: function _(ID, a) {
    return new IFC4.IfcCurveStyleFontAndScaling(ID, a[0], a[1], a[2]);
  },
  3510044353: function _(ID, a) {
    return new IFC4.IfcCurveStyleFontPattern(ID, a[0], a[1]);
  },
  3632507154: function _(ID, a) {
    return new IFC4.IfcDerivedProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1154170062: function _(ID, a) {
    return new IFC4.IfcDocumentInformation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]);
  },
  770865208: function _(ID, a) {
    return new IFC4.IfcDocumentInformationRelationship(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3732053477: function _(ID, a) {
    return new IFC4.IfcDocumentReference(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3900360178: function _(ID, a) {
    return new IFC4.IfcEdge(ID, a[0], a[1]);
  },
  476780140: function _(ID, a) {
    return new IFC4.IfcEdgeCurve(ID, a[0], a[1], a[2], a[3]);
  },
  211053100: function _(ID, a) {
    return new IFC4.IfcEventTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  297599258: function _(ID, a) {
    return new IFC4.IfcExtendedProperties(ID, a[0], a[1], a[2]);
  },
  1437805879: function _(ID, a) {
    return new IFC4.IfcExternalReferenceRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  2556980723: function _(ID, a) {
    return new IFC4.IfcFace(ID, a[0]);
  },
  1809719519: function _(ID, a) {
    return new IFC4.IfcFaceBound(ID, a[0], a[1]);
  },
  803316827: function _(ID, a) {
    return new IFC4.IfcFaceOuterBound(ID, a[0], a[1]);
  },
  3008276851: function _(ID, a) {
    return new IFC4.IfcFaceSurface(ID, a[0], a[1], a[2]);
  },
  4219587988: function _(ID, a) {
    return new IFC4.IfcFailureConnectionCondition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  738692330: function _(ID, a) {
    return new IFC4.IfcFillAreaStyle(ID, a[0], a[1], a[2]);
  },
  3448662350: function _(ID, a) {
    return new IFC4.IfcGeometricRepresentationContext(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2453401579: function _(ID, _135) {
    return new IFC4.IfcGeometricRepresentationItem(ID);
  },
  4142052618: function _(ID, a) {
    return new IFC4.IfcGeometricRepresentationSubContext(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3590301190: function _(ID, a) {
    return new IFC4.IfcGeometricSet(ID, a[0]);
  },
  178086475: function _(ID, a) {
    return new IFC4.IfcGridPlacement(ID, a[0], a[1]);
  },
  812098782: function _(ID, a) {
    return new IFC4.IfcHalfSpaceSolid(ID, a[0], a[1]);
  },
  3905492369: function _(ID, a) {
    return new IFC4.IfcImageTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3570813810: function _(ID, a) {
    return new IFC4.IfcIndexedColourMap(ID, a[0], a[1], a[2], a[3]);
  },
  1437953363: function _(ID, a) {
    return new IFC4.IfcIndexedTextureMap(ID, a[0], a[1], a[2]);
  },
  2133299955: function _(ID, a) {
    return new IFC4.IfcIndexedTriangleTextureMap(ID, a[0], a[1], a[2], a[3]);
  },
  3741457305: function _(ID, a) {
    return new IFC4.IfcIrregularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1585845231: function _(ID, a) {
    return new IFC4.IfcLagTime(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1402838566: function _(ID, a) {
    return new IFC4.IfcLightSource(ID, a[0], a[1], a[2], a[3]);
  },
  125510826: function _(ID, a) {
    return new IFC4.IfcLightSourceAmbient(ID, a[0], a[1], a[2], a[3]);
  },
  2604431987: function _(ID, a) {
    return new IFC4.IfcLightSourceDirectional(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4266656042: function _(ID, a) {
    return new IFC4.IfcLightSourceGoniometric(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1520743889: function _(ID, a) {
    return new IFC4.IfcLightSourcePositional(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3422422726: function _(ID, a) {
    return new IFC4.IfcLightSourceSpot(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  2624227202: function _(ID, a) {
    return new IFC4.IfcLocalPlacement(ID, a[0], a[1]);
  },
  1008929658: function _(ID, _136) {
    return new IFC4.IfcLoop(ID);
  },
  2347385850: function _(ID, a) {
    return new IFC4.IfcMappedItem(ID, a[0], a[1]);
  },
  1838606355: function _(ID, a) {
    return new IFC4.IfcMaterial(ID, a[0], a[1], a[2]);
  },
  3708119e3: function _(ID, a) {
    return new IFC4.IfcMaterialConstituent(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2852063980: function _(ID, a) {
    return new IFC4.IfcMaterialConstituentSet(ID, a[0], a[1], a[2]);
  },
  2022407955: function _(ID, a) {
    return new IFC4.IfcMaterialDefinitionRepresentation(ID, a[0], a[1], a[2], a[3]);
  },
  1303795690: function _(ID, a) {
    return new IFC4.IfcMaterialLayerSetUsage(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3079605661: function _(ID, a) {
    return new IFC4.IfcMaterialProfileSetUsage(ID, a[0], a[1], a[2]);
  },
  3404854881: function _(ID, a) {
    return new IFC4.IfcMaterialProfileSetUsageTapering(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3265635763: function _(ID, a) {
    return new IFC4.IfcMaterialProperties(ID, a[0], a[1], a[2], a[3]);
  },
  853536259: function _(ID, a) {
    return new IFC4.IfcMaterialRelationship(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2998442950: function _(ID, a) {
    return new IFC4.IfcMirroredProfileDef(ID, a[0], a[1], a[2], a[3]);
  },
  219451334: function _(ID, a) {
    return new IFC4.IfcObjectDefinition(ID, a[0], a[1], a[2], a[3]);
  },
  2665983363: function _(ID, a) {
    return new IFC4.IfcOpenShell(ID, a[0]);
  },
  1411181986: function _(ID, a) {
    return new IFC4.IfcOrganizationRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  1029017970: function _(ID, a) {
    return new IFC4.IfcOrientedEdge(ID, a[0], a[1]);
  },
  2529465313: function _(ID, a) {
    return new IFC4.IfcParameterizedProfileDef(ID, a[0], a[1], a[2]);
  },
  2519244187: function _(ID, a) {
    return new IFC4.IfcPath(ID, a[0]);
  },
  3021840470: function _(ID, a) {
    return new IFC4.IfcPhysicalComplexQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  597895409: function _(ID, a) {
    return new IFC4.IfcPixelTexture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2004835150: function _(ID, a) {
    return new IFC4.IfcPlacement(ID, a[0]);
  },
  1663979128: function _(ID, a) {
    return new IFC4.IfcPlanarExtent(ID, a[0], a[1]);
  },
  2067069095: function _(ID, _137) {
    return new IFC4.IfcPoint(ID);
  },
  4022376103: function _(ID, a) {
    return new IFC4.IfcPointOnCurve(ID, a[0], a[1]);
  },
  1423911732: function _(ID, a) {
    return new IFC4.IfcPointOnSurface(ID, a[0], a[1], a[2]);
  },
  2924175390: function _(ID, a) {
    return new IFC4.IfcPolyLoop(ID, a[0]);
  },
  2775532180: function _(ID, a) {
    return new IFC4.IfcPolygonalBoundedHalfSpace(ID, a[0], a[1], a[2], a[3]);
  },
  3727388367: function _(ID, a) {
    return new IFC4.IfcPreDefinedItem(ID, a[0]);
  },
  3778827333: function _(ID, _138) {
    return new IFC4.IfcPreDefinedProperties(ID);
  },
  1775413392: function _(ID, a) {
    return new IFC4.IfcPreDefinedTextFont(ID, a[0]);
  },
  673634403: function _(ID, a) {
    return new IFC4.IfcProductDefinitionShape(ID, a[0], a[1], a[2]);
  },
  2802850158: function _(ID, a) {
    return new IFC4.IfcProfileProperties(ID, a[0], a[1], a[2], a[3]);
  },
  2598011224: function _(ID, a) {
    return new IFC4.IfcProperty(ID, a[0], a[1]);
  },
  1680319473: function _(ID, a) {
    return new IFC4.IfcPropertyDefinition(ID, a[0], a[1], a[2], a[3]);
  },
  148025276: function _(ID, a) {
    return new IFC4.IfcPropertyDependencyRelationship(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3357820518: function _(ID, a) {
    return new IFC4.IfcPropertySetDefinition(ID, a[0], a[1], a[2], a[3]);
  },
  1482703590: function _(ID, a) {
    return new IFC4.IfcPropertyTemplateDefinition(ID, a[0], a[1], a[2], a[3]);
  },
  2090586900: function _(ID, a) {
    return new IFC4.IfcQuantitySet(ID, a[0], a[1], a[2], a[3]);
  },
  3615266464: function _(ID, a) {
    return new IFC4.IfcRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3413951693: function _(ID, a) {
    return new IFC4.IfcRegularTimeSeries(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1580146022: function _(ID, a) {
    return new IFC4.IfcReinforcementBarProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  478536968: function _(ID, a) {
    return new IFC4.IfcRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  2943643501: function _(ID, a) {
    return new IFC4.IfcResourceApprovalRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  1608871552: function _(ID, a) {
    return new IFC4.IfcResourceConstraintRelationship(ID, a[0], a[1], a[2], a[3]);
  },
  1042787934: function _(ID, a) {
    return new IFC4.IfcResourceTime(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]);
  },
  2778083089: function _(ID, a) {
    return new IFC4.IfcRoundedRectangleProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2042790032: function _(ID, a) {
    return new IFC4.IfcSectionProperties(ID, a[0], a[1], a[2]);
  },
  4165799628: function _(ID, a) {
    return new IFC4.IfcSectionReinforcementProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1509187699: function _(ID, a) {
    return new IFC4.IfcSectionedSpine(ID, a[0], a[1], a[2]);
  },
  4124623270: function _(ID, a) {
    return new IFC4.IfcShellBasedSurfaceModel(ID, a[0]);
  },
  3692461612: function _(ID, a) {
    return new IFC4.IfcSimpleProperty(ID, a[0], a[1]);
  },
  2609359061: function _(ID, a) {
    return new IFC4.IfcSlippageConnectionCondition(ID, a[0], a[1], a[2], a[3]);
  },
  723233188: function _(ID, _139) {
    return new IFC4.IfcSolidModel(ID);
  },
  1595516126: function _(ID, a) {
    return new IFC4.IfcStructuralLoadLinearForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2668620305: function _(ID, a) {
    return new IFC4.IfcStructuralLoadPlanarForce(ID, a[0], a[1], a[2], a[3]);
  },
  2473145415: function _(ID, a) {
    return new IFC4.IfcStructuralLoadSingleDisplacement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1973038258: function _(ID, a) {
    return new IFC4.IfcStructuralLoadSingleDisplacementDistortion(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1597423693: function _(ID, a) {
    return new IFC4.IfcStructuralLoadSingleForce(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1190533807: function _(ID, a) {
    return new IFC4.IfcStructuralLoadSingleForceWarping(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2233826070: function _(ID, a) {
    return new IFC4.IfcSubedge(ID, a[0], a[1], a[2]);
  },
  2513912981: function _(ID, _140) {
    return new IFC4.IfcSurface(ID);
  },
  1878645084: function _(ID, a) {
    return new IFC4.IfcSurfaceStyleRendering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2247615214: function _(ID, a) {
    return new IFC4.IfcSweptAreaSolid(ID, a[0], a[1]);
  },
  1260650574: function _(ID, a) {
    return new IFC4.IfcSweptDiskSolid(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1096409881: function _(ID, a) {
    return new IFC4.IfcSweptDiskSolidPolygonal(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  230924584: function _(ID, a) {
    return new IFC4.IfcSweptSurface(ID, a[0], a[1]);
  },
  3071757647: function _(ID, a) {
    return new IFC4.IfcTShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  901063453: function _(ID, _141) {
    return new IFC4.IfcTessellatedItem(ID);
  },
  4282788508: function _(ID, a) {
    return new IFC4.IfcTextLiteral(ID, a[0], a[1], a[2]);
  },
  3124975700: function _(ID, a) {
    return new IFC4.IfcTextLiteralWithExtent(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1983826977: function _(ID, a) {
    return new IFC4.IfcTextStyleFontModel(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2715220739: function _(ID, a) {
    return new IFC4.IfcTrapeziumProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1628702193: function _(ID, a) {
    return new IFC4.IfcTypeObject(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3736923433: function _(ID, a) {
    return new IFC4.IfcTypeProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2347495698: function _(ID, a) {
    return new IFC4.IfcTypeProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3698973494: function _(ID, a) {
    return new IFC4.IfcTypeResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  427810014: function _(ID, a) {
    return new IFC4.IfcUShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1417489154: function _(ID, a) {
    return new IFC4.IfcVector(ID, a[0], a[1]);
  },
  2759199220: function _(ID, a) {
    return new IFC4.IfcVertexLoop(ID, a[0]);
  },
  1299126871: function _(ID, a) {
    return new IFC4.IfcWindowStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  2543172580: function _(ID, a) {
    return new IFC4.IfcZShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3406155212: function _(ID, a) {
    return new IFC4.IfcAdvancedFace(ID, a[0], a[1], a[2]);
  },
  669184980: function _(ID, a) {
    return new IFC4.IfcAnnotationFillArea(ID, a[0], a[1]);
  },
  3207858831: function _(ID, a) {
    return new IFC4.IfcAsymmetricIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14]);
  },
  4261334040: function _(ID, a) {
    return new IFC4.IfcAxis1Placement(ID, a[0], a[1]);
  },
  3125803723: function _(ID, a) {
    return new IFC4.IfcAxis2Placement2D(ID, a[0], a[1]);
  },
  2740243338: function _(ID, a) {
    return new IFC4.IfcAxis2Placement3D(ID, a[0], a[1], a[2]);
  },
  2736907675: function _(ID, a) {
    return new IFC4.IfcBooleanResult(ID, a[0], a[1], a[2]);
  },
  4182860854: function _(ID, _142) {
    return new IFC4.IfcBoundedSurface(ID);
  },
  2581212453: function _(ID, a) {
    return new IFC4.IfcBoundingBox(ID, a[0], a[1], a[2], a[3]);
  },
  2713105998: function _(ID, a) {
    return new IFC4.IfcBoxedHalfSpace(ID, a[0], a[1], a[2]);
  },
  2898889636: function _(ID, a) {
    return new IFC4.IfcCShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1123145078: function _(ID, a) {
    return new IFC4.IfcCartesianPoint(ID, a[0]);
  },
  574549367: function _(ID, _143) {
    return new IFC4.IfcCartesianPointList(ID);
  },
  1675464909: function _(ID, a) {
    return new IFC4.IfcCartesianPointList2D(ID, a[0]);
  },
  2059837836: function _(ID, a) {
    return new IFC4.IfcCartesianPointList3D(ID, a[0]);
  },
  59481748: function _(ID, a) {
    return new IFC4.IfcCartesianTransformationOperator(ID, a[0], a[1], a[2], a[3]);
  },
  3749851601: function _(ID, a) {
    return new IFC4.IfcCartesianTransformationOperator2D(ID, a[0], a[1], a[2], a[3]);
  },
  3486308946: function _(ID, a) {
    return new IFC4.IfcCartesianTransformationOperator2DnonUniform(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3331915920: function _(ID, a) {
    return new IFC4.IfcCartesianTransformationOperator3D(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1416205885: function _(ID, a) {
    return new IFC4.IfcCartesianTransformationOperator3DnonUniform(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1383045692: function _(ID, a) {
    return new IFC4.IfcCircleProfileDef(ID, a[0], a[1], a[2], a[3]);
  },
  2205249479: function _(ID, a) {
    return new IFC4.IfcClosedShell(ID, a[0]);
  },
  776857604: function _(ID, a) {
    return new IFC4.IfcColourRgb(ID, a[0], a[1], a[2], a[3]);
  },
  2542286263: function _(ID, a) {
    return new IFC4.IfcComplexProperty(ID, a[0], a[1], a[2], a[3]);
  },
  2485617015: function _(ID, a) {
    return new IFC4.IfcCompositeCurveSegment(ID, a[0], a[1], a[2]);
  },
  2574617495: function _(ID, a) {
    return new IFC4.IfcConstructionResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  3419103109: function _(ID, a) {
    return new IFC4.IfcContext(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1815067380: function _(ID, a) {
    return new IFC4.IfcCrewResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  2506170314: function _(ID, a) {
    return new IFC4.IfcCsgPrimitive3D(ID, a[0]);
  },
  2147822146: function _(ID, a) {
    return new IFC4.IfcCsgSolid(ID, a[0]);
  },
  2601014836: function _(ID, _144) {
    return new IFC4.IfcCurve(ID);
  },
  2827736869: function _(ID, a) {
    return new IFC4.IfcCurveBoundedPlane(ID, a[0], a[1], a[2]);
  },
  2629017746: function _(ID, a) {
    return new IFC4.IfcCurveBoundedSurface(ID, a[0], a[1], a[2]);
  },
  32440307: function _(ID, a) {
    return new IFC4.IfcDirection(ID, a[0]);
  },
  526551008: function _(ID, a) {
    return new IFC4.IfcDoorStyle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1472233963: function _(ID, a) {
    return new IFC4.IfcEdgeLoop(ID, a[0]);
  },
  1883228015: function _(ID, a) {
    return new IFC4.IfcElementQuantity(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  339256511: function _(ID, a) {
    return new IFC4.IfcElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2777663545: function _(ID, a) {
    return new IFC4.IfcElementarySurface(ID, a[0]);
  },
  2835456948: function _(ID, a) {
    return new IFC4.IfcEllipseProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4024345920: function _(ID, a) {
    return new IFC4.IfcEventType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  477187591: function _(ID, a) {
    return new IFC4.IfcExtrudedAreaSolid(ID, a[0], a[1], a[2], a[3]);
  },
  2804161546: function _(ID, a) {
    return new IFC4.IfcExtrudedAreaSolidTapered(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2047409740: function _(ID, a) {
    return new IFC4.IfcFaceBasedSurfaceModel(ID, a[0]);
  },
  374418227: function _(ID, a) {
    return new IFC4.IfcFillAreaStyleHatching(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  315944413: function _(ID, a) {
    return new IFC4.IfcFillAreaStyleTiles(ID, a[0], a[1], a[2]);
  },
  2652556860: function _(ID, a) {
    return new IFC4.IfcFixedReferenceSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4238390223: function _(ID, a) {
    return new IFC4.IfcFurnishingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1268542332: function _(ID, a) {
    return new IFC4.IfcFurnitureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4095422895: function _(ID, a) {
    return new IFC4.IfcGeographicElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  987898635: function _(ID, a) {
    return new IFC4.IfcGeometricCurveSet(ID, a[0]);
  },
  1484403080: function _(ID, a) {
    return new IFC4.IfcIShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  178912537: function _(ID, a) {
    return new IFC4.IfcIndexedPolygonalFace(ID, a[0]);
  },
  2294589976: function _(ID, a) {
    return new IFC4.IfcIndexedPolygonalFaceWithVoids(ID, a[0], a[1]);
  },
  572779678: function _(ID, a) {
    return new IFC4.IfcLShapeProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  428585644: function _(ID, a) {
    return new IFC4.IfcLaborResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1281925730: function _(ID, a) {
    return new IFC4.IfcLine(ID, a[0], a[1]);
  },
  1425443689: function _(ID, a) {
    return new IFC4.IfcManifoldSolidBrep(ID, a[0]);
  },
  3888040117: function _(ID, a) {
    return new IFC4.IfcObject(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3388369263: function _(ID, a) {
    return new IFC4.IfcOffsetCurve2D(ID, a[0], a[1], a[2]);
  },
  3505215534: function _(ID, a) {
    return new IFC4.IfcOffsetCurve3D(ID, a[0], a[1], a[2], a[3]);
  },
  1682466193: function _(ID, a) {
    return new IFC4.IfcPcurve(ID, a[0], a[1]);
  },
  603570806: function _(ID, a) {
    return new IFC4.IfcPlanarBox(ID, a[0], a[1], a[2]);
  },
  220341763: function _(ID, a) {
    return new IFC4.IfcPlane(ID, a[0]);
  },
  759155922: function _(ID, a) {
    return new IFC4.IfcPreDefinedColour(ID, a[0]);
  },
  2559016684: function _(ID, a) {
    return new IFC4.IfcPreDefinedCurveFont(ID, a[0]);
  },
  3967405729: function _(ID, a) {
    return new IFC4.IfcPreDefinedPropertySet(ID, a[0], a[1], a[2], a[3]);
  },
  569719735: function _(ID, a) {
    return new IFC4.IfcProcedureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2945172077: function _(ID, a) {
    return new IFC4.IfcProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  4208778838: function _(ID, a) {
    return new IFC4.IfcProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  103090709: function _(ID, a) {
    return new IFC4.IfcProject(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  653396225: function _(ID, a) {
    return new IFC4.IfcProjectLibrary(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  871118103: function _(ID, a) {
    return new IFC4.IfcPropertyBoundedValue(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4166981789: function _(ID, a) {
    return new IFC4.IfcPropertyEnumeratedValue(ID, a[0], a[1], a[2], a[3]);
  },
  2752243245: function _(ID, a) {
    return new IFC4.IfcPropertyListValue(ID, a[0], a[1], a[2], a[3]);
  },
  941946838: function _(ID, a) {
    return new IFC4.IfcPropertyReferenceValue(ID, a[0], a[1], a[2], a[3]);
  },
  1451395588: function _(ID, a) {
    return new IFC4.IfcPropertySet(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  492091185: function _(ID, a) {
    return new IFC4.IfcPropertySetTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3650150729: function _(ID, a) {
    return new IFC4.IfcPropertySingleValue(ID, a[0], a[1], a[2], a[3]);
  },
  110355661: function _(ID, a) {
    return new IFC4.IfcPropertyTableValue(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3521284610: function _(ID, a) {
    return new IFC4.IfcPropertyTemplate(ID, a[0], a[1], a[2], a[3]);
  },
  3219374653: function _(ID, a) {
    return new IFC4.IfcProxy(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2770003689: function _(ID, a) {
    return new IFC4.IfcRectangleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2798486643: function _(ID, a) {
    return new IFC4.IfcRectangularPyramid(ID, a[0], a[1], a[2], a[3]);
  },
  3454111270: function _(ID, a) {
    return new IFC4.IfcRectangularTrimmedSurface(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3765753017: function _(ID, a) {
    return new IFC4.IfcReinforcementDefinitionProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3939117080: function _(ID, a) {
    return new IFC4.IfcRelAssigns(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1683148259: function _(ID, a) {
    return new IFC4.IfcRelAssignsToActor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2495723537: function _(ID, a) {
    return new IFC4.IfcRelAssignsToControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1307041759: function _(ID, a) {
    return new IFC4.IfcRelAssignsToGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1027710054: function _(ID, a) {
    return new IFC4.IfcRelAssignsToGroupByFactor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4278684876: function _(ID, a) {
    return new IFC4.IfcRelAssignsToProcess(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2857406711: function _(ID, a) {
    return new IFC4.IfcRelAssignsToProduct(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  205026976: function _(ID, a) {
    return new IFC4.IfcRelAssignsToResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1865459582: function _(ID, a) {
    return new IFC4.IfcRelAssociates(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4095574036: function _(ID, a) {
    return new IFC4.IfcRelAssociatesApproval(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  919958153: function _(ID, a) {
    return new IFC4.IfcRelAssociatesClassification(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2728634034: function _(ID, a) {
    return new IFC4.IfcRelAssociatesConstraint(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  982818633: function _(ID, a) {
    return new IFC4.IfcRelAssociatesDocument(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3840914261: function _(ID, a) {
    return new IFC4.IfcRelAssociatesLibrary(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2655215786: function _(ID, a) {
    return new IFC4.IfcRelAssociatesMaterial(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  826625072: function _(ID, a) {
    return new IFC4.IfcRelConnects(ID, a[0], a[1], a[2], a[3]);
  },
  1204542856: function _(ID, a) {
    return new IFC4.IfcRelConnectsElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3945020480: function _(ID, a) {
    return new IFC4.IfcRelConnectsPathElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4201705270: function _(ID, a) {
    return new IFC4.IfcRelConnectsPortToElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3190031847: function _(ID, a) {
    return new IFC4.IfcRelConnectsPorts(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2127690289: function _(ID, a) {
    return new IFC4.IfcRelConnectsStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1638771189: function _(ID, a) {
    return new IFC4.IfcRelConnectsStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  504942748: function _(ID, a) {
    return new IFC4.IfcRelConnectsWithEccentricity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  3678494232: function _(ID, a) {
    return new IFC4.IfcRelConnectsWithRealizingElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3242617779: function _(ID, a) {
    return new IFC4.IfcRelContainedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  886880790: function _(ID, a) {
    return new IFC4.IfcRelCoversBldgElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2802773753: function _(ID, a) {
    return new IFC4.IfcRelCoversSpaces(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2565941209: function _(ID, a) {
    return new IFC4.IfcRelDeclares(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2551354335: function _(ID, a) {
    return new IFC4.IfcRelDecomposes(ID, a[0], a[1], a[2], a[3]);
  },
  693640335: function _(ID, a) {
    return new IFC4.IfcRelDefines(ID, a[0], a[1], a[2], a[3]);
  },
  1462361463: function _(ID, a) {
    return new IFC4.IfcRelDefinesByObject(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4186316022: function _(ID, a) {
    return new IFC4.IfcRelDefinesByProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  307848117: function _(ID, a) {
    return new IFC4.IfcRelDefinesByTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  781010003: function _(ID, a) {
    return new IFC4.IfcRelDefinesByType(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3940055652: function _(ID, a) {
    return new IFC4.IfcRelFillsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  279856033: function _(ID, a) {
    return new IFC4.IfcRelFlowControlElements(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  427948657: function _(ID, a) {
    return new IFC4.IfcRelInterferesElements(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3268803585: function _(ID, a) {
    return new IFC4.IfcRelNests(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  750771296: function _(ID, a) {
    return new IFC4.IfcRelProjectsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1245217292: function _(ID, a) {
    return new IFC4.IfcRelReferencedInSpatialStructure(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  4122056220: function _(ID, a) {
    return new IFC4.IfcRelSequence(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  366585022: function _(ID, a) {
    return new IFC4.IfcRelServicesBuildings(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3451746338: function _(ID, a) {
    return new IFC4.IfcRelSpaceBoundary(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3523091289: function _(ID, a) {
    return new IFC4.IfcRelSpaceBoundary1stLevel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1521410863: function _(ID, a) {
    return new IFC4.IfcRelSpaceBoundary2ndLevel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1401173127: function _(ID, a) {
    return new IFC4.IfcRelVoidsElement(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  816062949: function _(ID, a) {
    return new IFC4.IfcReparametrisedCompositeCurveSegment(ID, a[0], a[1], a[2], a[3]);
  },
  2914609552: function _(ID, a) {
    return new IFC4.IfcResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1856042241: function _(ID, a) {
    return new IFC4.IfcRevolvedAreaSolid(ID, a[0], a[1], a[2], a[3]);
  },
  3243963512: function _(ID, a) {
    return new IFC4.IfcRevolvedAreaSolidTapered(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  4158566097: function _(ID, a) {
    return new IFC4.IfcRightCircularCone(ID, a[0], a[1], a[2]);
  },
  3626867408: function _(ID, a) {
    return new IFC4.IfcRightCircularCylinder(ID, a[0], a[1], a[2]);
  },
  3663146110: function _(ID, a) {
    return new IFC4.IfcSimplePropertyTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1412071761: function _(ID, a) {
    return new IFC4.IfcSpatialElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  710998568: function _(ID, a) {
    return new IFC4.IfcSpatialElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2706606064: function _(ID, a) {
    return new IFC4.IfcSpatialStructureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3893378262: function _(ID, a) {
    return new IFC4.IfcSpatialStructureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  463610769: function _(ID, a) {
    return new IFC4.IfcSpatialZone(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2481509218: function _(ID, a) {
    return new IFC4.IfcSpatialZoneType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  451544542: function _(ID, a) {
    return new IFC4.IfcSphere(ID, a[0], a[1]);
  },
  4015995234: function _(ID, a) {
    return new IFC4.IfcSphericalSurface(ID, a[0], a[1]);
  },
  3544373492: function _(ID, a) {
    return new IFC4.IfcStructuralActivity(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3136571912: function _(ID, a) {
    return new IFC4.IfcStructuralItem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  530289379: function _(ID, a) {
    return new IFC4.IfcStructuralMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3689010777: function _(ID, a) {
    return new IFC4.IfcStructuralReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3979015343: function _(ID, a) {
    return new IFC4.IfcStructuralSurfaceMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2218152070: function _(ID, a) {
    return new IFC4.IfcStructuralSurfaceMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  603775116: function _(ID, a) {
    return new IFC4.IfcStructuralSurfaceReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4095615324: function _(ID, a) {
    return new IFC4.IfcSubContractResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  699246055: function _(ID, a) {
    return new IFC4.IfcSurfaceCurve(ID, a[0], a[1], a[2]);
  },
  2028607225: function _(ID, a) {
    return new IFC4.IfcSurfaceCurveSweptAreaSolid(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2809605785: function _(ID, a) {
    return new IFC4.IfcSurfaceOfLinearExtrusion(ID, a[0], a[1], a[2], a[3]);
  },
  4124788165: function _(ID, a) {
    return new IFC4.IfcSurfaceOfRevolution(ID, a[0], a[1], a[2]);
  },
  1580310250: function _(ID, a) {
    return new IFC4.IfcSystemFurnitureElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3473067441: function _(ID, a) {
    return new IFC4.IfcTask(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  3206491090: function _(ID, a) {
    return new IFC4.IfcTaskType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2387106220: function _(ID, a) {
    return new IFC4.IfcTessellatedFaceSet(ID, a[0]);
  },
  1935646853: function _(ID, a) {
    return new IFC4.IfcToroidalSurface(ID, a[0], a[1], a[2]);
  },
  2097647324: function _(ID, a) {
    return new IFC4.IfcTransportElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2916149573: function _(ID, a) {
    return new IFC4.IfcTriangulatedFaceSet(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  336235671: function _(ID, a) {
    return new IFC4.IfcWindowLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
  },
  512836454: function _(ID, a) {
    return new IFC4.IfcWindowPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2296667514: function _(ID, a) {
    return new IFC4.IfcActor(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  1635779807: function _(ID, a) {
    return new IFC4.IfcAdvancedBrep(ID, a[0]);
  },
  2603310189: function _(ID, a) {
    return new IFC4.IfcAdvancedBrepWithVoids(ID, a[0], a[1]);
  },
  1674181508: function _(ID, a) {
    return new IFC4.IfcAnnotation(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2887950389: function _(ID, a) {
    return new IFC4.IfcBSplineSurface(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  167062518: function _(ID, a) {
    return new IFC4.IfcBSplineSurfaceWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1334484129: function _(ID, a) {
    return new IFC4.IfcBlock(ID, a[0], a[1], a[2], a[3]);
  },
  3649129432: function _(ID, a) {
    return new IFC4.IfcBooleanClippingResult(ID, a[0], a[1], a[2]);
  },
  1260505505: function _(ID, _145) {
    return new IFC4.IfcBoundedCurve(ID);
  },
  4031249490: function _(ID, a) {
    return new IFC4.IfcBuilding(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1950629157: function _(ID, a) {
    return new IFC4.IfcBuildingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3124254112: function _(ID, a) {
    return new IFC4.IfcBuildingStorey(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2197970202: function _(ID, a) {
    return new IFC4.IfcChimneyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2937912522: function _(ID, a) {
    return new IFC4.IfcCircleHollowProfileDef(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  3893394355: function _(ID, a) {
    return new IFC4.IfcCivilElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  300633059: function _(ID, a) {
    return new IFC4.IfcColumnType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3875453745: function _(ID, a) {
    return new IFC4.IfcComplexPropertyTemplate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3732776249: function _(ID, a) {
    return new IFC4.IfcCompositeCurve(ID, a[0], a[1]);
  },
  15328376: function _(ID, a) {
    return new IFC4.IfcCompositeCurveOnSurface(ID, a[0], a[1]);
  },
  2510884976: function _(ID, a) {
    return new IFC4.IfcConic(ID, a[0]);
  },
  2185764099: function _(ID, a) {
    return new IFC4.IfcConstructionEquipmentResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  4105962743: function _(ID, a) {
    return new IFC4.IfcConstructionMaterialResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1525564444: function _(ID, a) {
    return new IFC4.IfcConstructionProductResourceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  2559216714: function _(ID, a) {
    return new IFC4.IfcConstructionResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3293443760: function _(ID, a) {
    return new IFC4.IfcControl(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3895139033: function _(ID, a) {
    return new IFC4.IfcCostItem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1419761937: function _(ID, a) {
    return new IFC4.IfcCostSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1916426348: function _(ID, a) {
    return new IFC4.IfcCoveringType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3295246426: function _(ID, a) {
    return new IFC4.IfcCrewResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1457835157: function _(ID, a) {
    return new IFC4.IfcCurtainWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1213902940: function _(ID, a) {
    return new IFC4.IfcCylindricalSurface(ID, a[0], a[1]);
  },
  3256556792: function _(ID, a) {
    return new IFC4.IfcDistributionElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3849074793: function _(ID, a) {
    return new IFC4.IfcDistributionFlowElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2963535650: function _(ID, a) {
    return new IFC4.IfcDoorLiningProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]);
  },
  1714330368: function _(ID, a) {
    return new IFC4.IfcDoorPanelProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2323601079: function _(ID, a) {
    return new IFC4.IfcDoorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  445594917: function _(ID, a) {
    return new IFC4.IfcDraughtingPreDefinedColour(ID, a[0]);
  },
  4006246654: function _(ID, a) {
    return new IFC4.IfcDraughtingPreDefinedCurveFont(ID, a[0]);
  },
  1758889154: function _(ID, a) {
    return new IFC4.IfcElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4123344466: function _(ID, a) {
    return new IFC4.IfcElementAssembly(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2397081782: function _(ID, a) {
    return new IFC4.IfcElementAssemblyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1623761950: function _(ID, a) {
    return new IFC4.IfcElementComponent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2590856083: function _(ID, a) {
    return new IFC4.IfcElementComponentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1704287377: function _(ID, a) {
    return new IFC4.IfcEllipse(ID, a[0], a[1], a[2]);
  },
  2107101300: function _(ID, a) {
    return new IFC4.IfcEnergyConversionDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  132023988: function _(ID, a) {
    return new IFC4.IfcEngineType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3174744832: function _(ID, a) {
    return new IFC4.IfcEvaporativeCoolerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3390157468: function _(ID, a) {
    return new IFC4.IfcEvaporatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4148101412: function _(ID, a) {
    return new IFC4.IfcEvent(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2853485674: function _(ID, a) {
    return new IFC4.IfcExternalSpatialStructureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  807026263: function _(ID, a) {
    return new IFC4.IfcFacetedBrep(ID, a[0]);
  },
  3737207727: function _(ID, a) {
    return new IFC4.IfcFacetedBrepWithVoids(ID, a[0], a[1]);
  },
  647756555: function _(ID, a) {
    return new IFC4.IfcFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2489546625: function _(ID, a) {
    return new IFC4.IfcFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2827207264: function _(ID, a) {
    return new IFC4.IfcFeatureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2143335405: function _(ID, a) {
    return new IFC4.IfcFeatureElementAddition(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1287392070: function _(ID, a) {
    return new IFC4.IfcFeatureElementSubtraction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3907093117: function _(ID, a) {
    return new IFC4.IfcFlowControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3198132628: function _(ID, a) {
    return new IFC4.IfcFlowFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3815607619: function _(ID, a) {
    return new IFC4.IfcFlowMeterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1482959167: function _(ID, a) {
    return new IFC4.IfcFlowMovingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1834744321: function _(ID, a) {
    return new IFC4.IfcFlowSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1339347760: function _(ID, a) {
    return new IFC4.IfcFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2297155007: function _(ID, a) {
    return new IFC4.IfcFlowTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3009222698: function _(ID, a) {
    return new IFC4.IfcFlowTreatmentDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1893162501: function _(ID, a) {
    return new IFC4.IfcFootingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  263784265: function _(ID, a) {
    return new IFC4.IfcFurnishingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1509553395: function _(ID, a) {
    return new IFC4.IfcFurniture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3493046030: function _(ID, a) {
    return new IFC4.IfcGeographicElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3009204131: function _(ID, a) {
    return new IFC4.IfcGrid(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2706460486: function _(ID, a) {
    return new IFC4.IfcGroup(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1251058090: function _(ID, a) {
    return new IFC4.IfcHeatExchangerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1806887404: function _(ID, a) {
    return new IFC4.IfcHumidifierType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2571569899: function _(ID, a) {
    return new IFC4.IfcIndexedPolyCurve(ID, a[0], a[1], a[2]);
  },
  3946677679: function _(ID, a) {
    return new IFC4.IfcInterceptorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3113134337: function _(ID, a) {
    return new IFC4.IfcIntersectionCurve(ID, a[0], a[1], a[2]);
  },
  2391368822: function _(ID, a) {
    return new IFC4.IfcInventory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  4288270099: function _(ID, a) {
    return new IFC4.IfcJunctionBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3827777499: function _(ID, a) {
    return new IFC4.IfcLaborResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1051575348: function _(ID, a) {
    return new IFC4.IfcLampType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1161773419: function _(ID, a) {
    return new IFC4.IfcLightFixtureType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  377706215: function _(ID, a) {
    return new IFC4.IfcMechanicalFastener(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  2108223431: function _(ID, a) {
    return new IFC4.IfcMechanicalFastenerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1114901282: function _(ID, a) {
    return new IFC4.IfcMedicalDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3181161470: function _(ID, a) {
    return new IFC4.IfcMemberType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  977012517: function _(ID, a) {
    return new IFC4.IfcMotorConnectionType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4143007308: function _(ID, a) {
    return new IFC4.IfcOccupant(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  3588315303: function _(ID, a) {
    return new IFC4.IfcOpeningElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3079942009: function _(ID, a) {
    return new IFC4.IfcOpeningStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2837617999: function _(ID, a) {
    return new IFC4.IfcOutletType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2382730787: function _(ID, a) {
    return new IFC4.IfcPerformanceHistory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3566463478: function _(ID, a) {
    return new IFC4.IfcPermeableCoveringProperties(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3327091369: function _(ID, a) {
    return new IFC4.IfcPermit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1158309216: function _(ID, a) {
    return new IFC4.IfcPileType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  804291784: function _(ID, a) {
    return new IFC4.IfcPipeFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4231323485: function _(ID, a) {
    return new IFC4.IfcPipeSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4017108033: function _(ID, a) {
    return new IFC4.IfcPlateType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2839578677: function _(ID, a) {
    return new IFC4.IfcPolygonalFaceSet(ID, a[0], a[1], a[2], a[3]);
  },
  3724593414: function _(ID, a) {
    return new IFC4.IfcPolyline(ID, a[0]);
  },
  3740093272: function _(ID, a) {
    return new IFC4.IfcPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2744685151: function _(ID, a) {
    return new IFC4.IfcProcedure(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2904328755: function _(ID, a) {
    return new IFC4.IfcProjectOrder(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3651124850: function _(ID, a) {
    return new IFC4.IfcProjectionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1842657554: function _(ID, a) {
    return new IFC4.IfcProtectiveDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2250791053: function _(ID, a) {
    return new IFC4.IfcPumpType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2893384427: function _(ID, a) {
    return new IFC4.IfcRailingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2324767716: function _(ID, a) {
    return new IFC4.IfcRampFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1469900589: function _(ID, a) {
    return new IFC4.IfcRampType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  683857671: function _(ID, a) {
    return new IFC4.IfcRationalBSplineSurfaceWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  3027567501: function _(ID, a) {
    return new IFC4.IfcReinforcingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  964333572: function _(ID, a) {
    return new IFC4.IfcReinforcingElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2320036040: function _(ID, a) {
    return new IFC4.IfcReinforcingMesh(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17]);
  },
  2310774935: function _(ID, a) {
    return new IFC4.IfcReinforcingMeshType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16], a[17], a[18], a[19]);
  },
  160246688: function _(ID, a) {
    return new IFC4.IfcRelAggregates(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  2781568857: function _(ID, a) {
    return new IFC4.IfcRoofType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1768891740: function _(ID, a) {
    return new IFC4.IfcSanitaryTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2157484638: function _(ID, a) {
    return new IFC4.IfcSeamCurve(ID, a[0], a[1], a[2]);
  },
  4074543187: function _(ID, a) {
    return new IFC4.IfcShadingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4097777520: function _(ID, a) {
    return new IFC4.IfcSite(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  2533589738: function _(ID, a) {
    return new IFC4.IfcSlabType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1072016465: function _(ID, a) {
    return new IFC4.IfcSolarDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3856911033: function _(ID, a) {
    return new IFC4.IfcSpace(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1305183839: function _(ID, a) {
    return new IFC4.IfcSpaceHeaterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3812236995: function _(ID, a) {
    return new IFC4.IfcSpaceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  3112655638: function _(ID, a) {
    return new IFC4.IfcStackTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1039846685: function _(ID, a) {
    return new IFC4.IfcStairFlightType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  338393293: function _(ID, a) {
    return new IFC4.IfcStairType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  682877961: function _(ID, a) {
    return new IFC4.IfcStructuralAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1179482911: function _(ID, a) {
    return new IFC4.IfcStructuralConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  1004757350: function _(ID, a) {
    return new IFC4.IfcStructuralCurveAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  4243806635: function _(ID, a) {
    return new IFC4.IfcStructuralCurveConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  214636428: function _(ID, a) {
    return new IFC4.IfcStructuralCurveMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2445595289: function _(ID, a) {
    return new IFC4.IfcStructuralCurveMemberVarying(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2757150158: function _(ID, a) {
    return new IFC4.IfcStructuralCurveReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1807405624: function _(ID, a) {
    return new IFC4.IfcStructuralLinearAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1252848954: function _(ID, a) {
    return new IFC4.IfcStructuralLoadGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2082059205: function _(ID, a) {
    return new IFC4.IfcStructuralPointAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  734778138: function _(ID, a) {
    return new IFC4.IfcStructuralPointConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1235345126: function _(ID, a) {
    return new IFC4.IfcStructuralPointReaction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2986769608: function _(ID, a) {
    return new IFC4.IfcStructuralResultGroup(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3657597509: function _(ID, a) {
    return new IFC4.IfcStructuralSurfaceAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1975003073: function _(ID, a) {
    return new IFC4.IfcStructuralSurfaceConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  148013059: function _(ID, a) {
    return new IFC4.IfcSubContractResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  3101698114: function _(ID, a) {
    return new IFC4.IfcSurfaceFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2315554128: function _(ID, a) {
    return new IFC4.IfcSwitchingDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2254336722: function _(ID, a) {
    return new IFC4.IfcSystem(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  413509423: function _(ID, a) {
    return new IFC4.IfcSystemFurnitureElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  5716631: function _(ID, a) {
    return new IFC4.IfcTankType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3824725483: function _(ID, a) {
    return new IFC4.IfcTendon(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15], a[16]);
  },
  2347447852: function _(ID, a) {
    return new IFC4.IfcTendonAnchor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3081323446: function _(ID, a) {
    return new IFC4.IfcTendonAnchorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2415094496: function _(ID, a) {
    return new IFC4.IfcTendonType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  1692211062: function _(ID, a) {
    return new IFC4.IfcTransformerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1620046519: function _(ID, a) {
    return new IFC4.IfcTransportElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3593883385: function _(ID, a) {
    return new IFC4.IfcTrimmedCurve(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  1600972822: function _(ID, a) {
    return new IFC4.IfcTubeBundleType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1911125066: function _(ID, a) {
    return new IFC4.IfcUnitaryEquipmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  728799441: function _(ID, a) {
    return new IFC4.IfcValveType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2391383451: function _(ID, a) {
    return new IFC4.IfcVibrationIsolator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3313531582: function _(ID, a) {
    return new IFC4.IfcVibrationIsolatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2769231204: function _(ID, a) {
    return new IFC4.IfcVirtualElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  926996030: function _(ID, a) {
    return new IFC4.IfcVoidingFeature(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1898987631: function _(ID, a) {
    return new IFC4.IfcWallType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1133259667: function _(ID, a) {
    return new IFC4.IfcWasteTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4009809668: function _(ID, a) {
    return new IFC4.IfcWindowType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  4088093105: function _(ID, a) {
    return new IFC4.IfcWorkCalendar(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1028945134: function _(ID, a) {
    return new IFC4.IfcWorkControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  4218914973: function _(ID, a) {
    return new IFC4.IfcWorkPlan(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  3342526732: function _(ID, a) {
    return new IFC4.IfcWorkSchedule(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  1033361043: function _(ID, a) {
    return new IFC4.IfcZone(ID, a[0], a[1], a[2], a[3], a[4], a[5]);
  },
  3821786052: function _(ID, a) {
    return new IFC4.IfcActionRequest(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1411407467: function _(ID, a) {
    return new IFC4.IfcAirTerminalBoxType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3352864051: function _(ID, a) {
    return new IFC4.IfcAirTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1871374353: function _(ID, a) {
    return new IFC4.IfcAirToAirHeatRecoveryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3460190687: function _(ID, a) {
    return new IFC4.IfcAsset(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  1532957894: function _(ID, a) {
    return new IFC4.IfcAudioVisualApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1967976161: function _(ID, a) {
    return new IFC4.IfcBSplineCurve(ID, a[0], a[1], a[2], a[3], a[4]);
  },
  2461110595: function _(ID, a) {
    return new IFC4.IfcBSplineCurveWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  819618141: function _(ID, a) {
    return new IFC4.IfcBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  231477066: function _(ID, a) {
    return new IFC4.IfcBoilerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1136057603: function _(ID, a) {
    return new IFC4.IfcBoundaryCurve(ID, a[0], a[1]);
  },
  3299480353: function _(ID, a) {
    return new IFC4.IfcBuildingElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2979338954: function _(ID, a) {
    return new IFC4.IfcBuildingElementPart(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  39481116: function _(ID, a) {
    return new IFC4.IfcBuildingElementPartType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1095909175: function _(ID, a) {
    return new IFC4.IfcBuildingElementProxy(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1909888760: function _(ID, a) {
    return new IFC4.IfcBuildingElementProxyType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1177604601: function _(ID, a) {
    return new IFC4.IfcBuildingSystem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  2188180465: function _(ID, a) {
    return new IFC4.IfcBurnerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  395041908: function _(ID, a) {
    return new IFC4.IfcCableCarrierFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3293546465: function _(ID, a) {
    return new IFC4.IfcCableCarrierSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2674252688: function _(ID, a) {
    return new IFC4.IfcCableFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1285652485: function _(ID, a) {
    return new IFC4.IfcCableSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2951183804: function _(ID, a) {
    return new IFC4.IfcChillerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3296154744: function _(ID, a) {
    return new IFC4.IfcChimney(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2611217952: function _(ID, a) {
    return new IFC4.IfcCircle(ID, a[0], a[1]);
  },
  1677625105: function _(ID, a) {
    return new IFC4.IfcCivilElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2301859152: function _(ID, a) {
    return new IFC4.IfcCoilType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  843113511: function _(ID, a) {
    return new IFC4.IfcColumn(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  905975707: function _(ID, a) {
    return new IFC4.IfcColumnStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  400855858: function _(ID, a) {
    return new IFC4.IfcCommunicationsApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3850581409: function _(ID, a) {
    return new IFC4.IfcCompressorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2816379211: function _(ID, a) {
    return new IFC4.IfcCondenserType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3898045240: function _(ID, a) {
    return new IFC4.IfcConstructionEquipmentResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1060000209: function _(ID, a) {
    return new IFC4.IfcConstructionMaterialResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  488727124: function _(ID, a) {
    return new IFC4.IfcConstructionProductResource(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  335055490: function _(ID, a) {
    return new IFC4.IfcCooledBeamType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2954562838: function _(ID, a) {
    return new IFC4.IfcCoolingTowerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1973544240: function _(ID, a) {
    return new IFC4.IfcCovering(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3495092785: function _(ID, a) {
    return new IFC4.IfcCurtainWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3961806047: function _(ID, a) {
    return new IFC4.IfcDamperType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1335981549: function _(ID, a) {
    return new IFC4.IfcDiscreteAccessory(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2635815018: function _(ID, a) {
    return new IFC4.IfcDiscreteAccessoryType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1599208980: function _(ID, a) {
    return new IFC4.IfcDistributionChamberElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2063403501: function _(ID, a) {
    return new IFC4.IfcDistributionControlElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1945004755: function _(ID, a) {
    return new IFC4.IfcDistributionElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3040386961: function _(ID, a) {
    return new IFC4.IfcDistributionFlowElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3041715199: function _(ID, a) {
    return new IFC4.IfcDistributionPort(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3205830791: function _(ID, a) {
    return new IFC4.IfcDistributionSystem(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  395920057: function _(ID, a) {
    return new IFC4.IfcDoor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  3242481149: function _(ID, a) {
    return new IFC4.IfcDoorStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  869906466: function _(ID, a) {
    return new IFC4.IfcDuctFittingType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3760055223: function _(ID, a) {
    return new IFC4.IfcDuctSegmentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2030761528: function _(ID, a) {
    return new IFC4.IfcDuctSilencerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  663422040: function _(ID, a) {
    return new IFC4.IfcElectricApplianceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2417008758: function _(ID, a) {
    return new IFC4.IfcElectricDistributionBoardType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  3277789161: function _(ID, a) {
    return new IFC4.IfcElectricFlowStorageDeviceType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1534661035: function _(ID, a) {
    return new IFC4.IfcElectricGeneratorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1217240411: function _(ID, a) {
    return new IFC4.IfcElectricMotorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  712377611: function _(ID, a) {
    return new IFC4.IfcElectricTimeControlType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1658829314: function _(ID, a) {
    return new IFC4.IfcEnergyConversionDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2814081492: function _(ID, a) {
    return new IFC4.IfcEngine(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3747195512: function _(ID, a) {
    return new IFC4.IfcEvaporativeCooler(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  484807127: function _(ID, a) {
    return new IFC4.IfcEvaporator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1209101575: function _(ID, a) {
    return new IFC4.IfcExternalSpatialElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  346874300: function _(ID, a) {
    return new IFC4.IfcFanType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1810631287: function _(ID, a) {
    return new IFC4.IfcFilterType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4222183408: function _(ID, a) {
    return new IFC4.IfcFireSuppressionTerminalType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2058353004: function _(ID, a) {
    return new IFC4.IfcFlowController(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4278956645: function _(ID, a) {
    return new IFC4.IfcFlowFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  4037862832: function _(ID, a) {
    return new IFC4.IfcFlowInstrumentType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  2188021234: function _(ID, a) {
    return new IFC4.IfcFlowMeter(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3132237377: function _(ID, a) {
    return new IFC4.IfcFlowMovingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  987401354: function _(ID, a) {
    return new IFC4.IfcFlowSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  707683696: function _(ID, a) {
    return new IFC4.IfcFlowStorageDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  2223149337: function _(ID, a) {
    return new IFC4.IfcFlowTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  3508470533: function _(ID, a) {
    return new IFC4.IfcFlowTreatmentDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  900683007: function _(ID, a) {
    return new IFC4.IfcFooting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3319311131: function _(ID, a) {
    return new IFC4.IfcHeatExchanger(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2068733104: function _(ID, a) {
    return new IFC4.IfcHumidifier(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4175244083: function _(ID, a) {
    return new IFC4.IfcInterceptor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2176052936: function _(ID, a) {
    return new IFC4.IfcJunctionBox(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  76236018: function _(ID, a) {
    return new IFC4.IfcLamp(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  629592764: function _(ID, a) {
    return new IFC4.IfcLightFixture(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1437502449: function _(ID, a) {
    return new IFC4.IfcMedicalDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1073191201: function _(ID, a) {
    return new IFC4.IfcMember(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1911478936: function _(ID, a) {
    return new IFC4.IfcMemberStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2474470126: function _(ID, a) {
    return new IFC4.IfcMotorConnection(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  144952367: function _(ID, a) {
    return new IFC4.IfcOuterBoundaryCurve(ID, a[0], a[1]);
  },
  3694346114: function _(ID, a) {
    return new IFC4.IfcOutlet(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1687234759: function _(ID, a) {
    return new IFC4.IfcPile(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  310824031: function _(ID, a) {
    return new IFC4.IfcPipeFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3612865200: function _(ID, a) {
    return new IFC4.IfcPipeSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3171933400: function _(ID, a) {
    return new IFC4.IfcPlate(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1156407060: function _(ID, a) {
    return new IFC4.IfcPlateStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  738039164: function _(ID, a) {
    return new IFC4.IfcProtectiveDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  655969474: function _(ID, a) {
    return new IFC4.IfcProtectiveDeviceTrippingUnitType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  90941305: function _(ID, a) {
    return new IFC4.IfcPump(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2262370178: function _(ID, a) {
    return new IFC4.IfcRailing(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3024970846: function _(ID, a) {
    return new IFC4.IfcRamp(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3283111854: function _(ID, a) {
    return new IFC4.IfcRampFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1232101972: function _(ID, a) {
    return new IFC4.IfcRationalBSplineCurveWithKnots(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  979691226: function _(ID, a) {
    return new IFC4.IfcReinforcingBar(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13]);
  },
  2572171363: function _(ID, a) {
    return new IFC4.IfcReinforcingBarType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
  },
  2016517767: function _(ID, a) {
    return new IFC4.IfcRoof(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3053780830: function _(ID, a) {
    return new IFC4.IfcSanitaryTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1783015770: function _(ID, a) {
    return new IFC4.IfcSensorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1329646415: function _(ID, a) {
    return new IFC4.IfcShadingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1529196076: function _(ID, a) {
    return new IFC4.IfcSlab(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3127900445: function _(ID, a) {
    return new IFC4.IfcSlabElementedCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3027962421: function _(ID, a) {
    return new IFC4.IfcSlabStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3420628829: function _(ID, a) {
    return new IFC4.IfcSolarDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1999602285: function _(ID, a) {
    return new IFC4.IfcSpaceHeater(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1404847402: function _(ID, a) {
    return new IFC4.IfcStackTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  331165859: function _(ID, a) {
    return new IFC4.IfcStair(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4252922144: function _(ID, a) {
    return new IFC4.IfcStairFlight(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  2515109513: function _(ID, a) {
    return new IFC4.IfcStructuralAnalysisModel(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  385403989: function _(ID, a) {
    return new IFC4.IfcStructuralLoadCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10]);
  },
  1621171031: function _(ID, a) {
    return new IFC4.IfcStructuralPlanarAction(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11]);
  },
  1162798199: function _(ID, a) {
    return new IFC4.IfcSwitchingDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  812556717: function _(ID, a) {
    return new IFC4.IfcTank(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3825984169: function _(ID, a) {
    return new IFC4.IfcTransformer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3026737570: function _(ID, a) {
    return new IFC4.IfcTubeBundle(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3179687236: function _(ID, a) {
    return new IFC4.IfcUnitaryControlElementType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4292641817: function _(ID, a) {
    return new IFC4.IfcUnitaryEquipment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4207607924: function _(ID, a) {
    return new IFC4.IfcValve(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2391406946: function _(ID, a) {
    return new IFC4.IfcWall(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4156078855: function _(ID, a) {
    return new IFC4.IfcWallElementedCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3512223829: function _(ID, a) {
    return new IFC4.IfcWallStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4237592921: function _(ID, a) {
    return new IFC4.IfcWasteTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3304561284: function _(ID, a) {
    return new IFC4.IfcWindow(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  486154966: function _(ID, a) {
    return new IFC4.IfcWindowStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12]);
  },
  2874132201: function _(ID, a) {
    return new IFC4.IfcActuatorType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  1634111441: function _(ID, a) {
    return new IFC4.IfcAirTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  177149247: function _(ID, a) {
    return new IFC4.IfcAirTerminalBox(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2056796094: function _(ID, a) {
    return new IFC4.IfcAirToAirHeatRecovery(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3001207471: function _(ID, a) {
    return new IFC4.IfcAlarmType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  277319702: function _(ID, a) {
    return new IFC4.IfcAudioVisualAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  753842376: function _(ID, a) {
    return new IFC4.IfcBeam(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2906023776: function _(ID, a) {
    return new IFC4.IfcBeamStandardCase(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  32344328: function _(ID, a) {
    return new IFC4.IfcBoiler(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2938176219: function _(ID, a) {
    return new IFC4.IfcBurner(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  635142910: function _(ID, a) {
    return new IFC4.IfcCableCarrierFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3758799889: function _(ID, a) {
    return new IFC4.IfcCableCarrierSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1051757585: function _(ID, a) {
    return new IFC4.IfcCableFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4217484030: function _(ID, a) {
    return new IFC4.IfcCableSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3902619387: function _(ID, a) {
    return new IFC4.IfcChiller(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  639361253: function _(ID, a) {
    return new IFC4.IfcCoil(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3221913625: function _(ID, a) {
    return new IFC4.IfcCommunicationsAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3571504051: function _(ID, a) {
    return new IFC4.IfcCompressor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2272882330: function _(ID, a) {
    return new IFC4.IfcCondenser(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  578613899: function _(ID, a) {
    return new IFC4.IfcControllerType(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9]);
  },
  4136498852: function _(ID, a) {
    return new IFC4.IfcCooledBeam(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3640358203: function _(ID, a) {
    return new IFC4.IfcCoolingTower(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4074379575: function _(ID, a) {
    return new IFC4.IfcDamper(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1052013943: function _(ID, a) {
    return new IFC4.IfcDistributionChamberElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  562808652: function _(ID, a) {
    return new IFC4.IfcDistributionCircuit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6]);
  },
  1062813311: function _(ID, a) {
    return new IFC4.IfcDistributionControlElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7]);
  },
  342316401: function _(ID, a) {
    return new IFC4.IfcDuctFitting(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3518393246: function _(ID, a) {
    return new IFC4.IfcDuctSegment(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1360408905: function _(ID, a) {
    return new IFC4.IfcDuctSilencer(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1904799276: function _(ID, a) {
    return new IFC4.IfcElectricAppliance(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  862014818: function _(ID, a) {
    return new IFC4.IfcElectricDistributionBoard(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3310460725: function _(ID, a) {
    return new IFC4.IfcElectricFlowStorageDevice(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  264262732: function _(ID, a) {
    return new IFC4.IfcElectricGenerator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  402227799: function _(ID, a) {
    return new IFC4.IfcElectricMotor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1003880860: function _(ID, a) {
    return new IFC4.IfcElectricTimeControl(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3415622556: function _(ID, a) {
    return new IFC4.IfcFan(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  819412036: function _(ID, a) {
    return new IFC4.IfcFilter(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  1426591983: function _(ID, a) {
    return new IFC4.IfcFireSuppressionTerminal(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  182646315: function _(ID, a) {
    return new IFC4.IfcFlowInstrument(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  2295281155: function _(ID, a) {
    return new IFC4.IfcProtectiveDeviceTrippingUnit(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4086658281: function _(ID, a) {
    return new IFC4.IfcSensor(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  630975310: function _(ID, a) {
    return new IFC4.IfcUnitaryControlElement(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  4288193352: function _(ID, a) {
    return new IFC4.IfcActuator(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  3087945054: function _(ID, a) {
    return new IFC4.IfcAlarm(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  },
  25142252: function _(ID, a) {
    return new IFC4.IfcController(ID, a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
  }
};
ToRawLineData[3] = {
  3630933823: function _(i) {
    return [i.Role, i.UserDefinedRole, i.Description];
  },
  618182010: function _(i) {
    return [i.Purpose, i.Description, i.UserDefinedPurpose];
  },
  639542469: function _(i) {
    return [i.ApplicationDeveloper, i.Version, i.ApplicationFullName, i.ApplicationIdentifier];
  },
  411424972: function _(i) {
    return [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components];
  },
  130549933: function _(i) {
    return [i.Identifier, i.Name, i.Description, i.TimeOfApproval, i.Status, i.Level, i.Qualifier, i.RequestingApproval, i.GivingApproval];
  },
  4037036970: function _(i) {
    return [i.Name];
  },
  1560379544: function _(i) {
    return [i.Name, !i.TranslationalStiffnessByLengthX ? null : Labelise(i.TranslationalStiffnessByLengthX), !i.TranslationalStiffnessByLengthY ? null : Labelise(i.TranslationalStiffnessByLengthY), !i.TranslationalStiffnessByLengthZ ? null : Labelise(i.TranslationalStiffnessByLengthZ), !i.RotationalStiffnessByLengthX ? null : Labelise(i.RotationalStiffnessByLengthX), !i.RotationalStiffnessByLengthY ? null : Labelise(i.RotationalStiffnessByLengthY), !i.RotationalStiffnessByLengthZ ? null : Labelise(i.RotationalStiffnessByLengthZ)];
  },
  3367102660: function _(i) {
    return [i.Name, !i.TranslationalStiffnessByAreaX ? null : Labelise(i.TranslationalStiffnessByAreaX), !i.TranslationalStiffnessByAreaY ? null : Labelise(i.TranslationalStiffnessByAreaY), !i.TranslationalStiffnessByAreaZ ? null : Labelise(i.TranslationalStiffnessByAreaZ)];
  },
  1387855156: function _(i) {
    return [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ)];
  },
  2069777674: function _(i) {
    return [i.Name, !i.TranslationalStiffnessX ? null : Labelise(i.TranslationalStiffnessX), !i.TranslationalStiffnessY ? null : Labelise(i.TranslationalStiffnessY), !i.TranslationalStiffnessZ ? null : Labelise(i.TranslationalStiffnessZ), !i.RotationalStiffnessX ? null : Labelise(i.RotationalStiffnessX), !i.RotationalStiffnessY ? null : Labelise(i.RotationalStiffnessY), !i.RotationalStiffnessZ ? null : Labelise(i.RotationalStiffnessZ), !i.WarpingStiffness ? null : Labelise(i.WarpingStiffness)];
  },
  2859738748: function _(_146) {
    return [];
  },
  2614616156: function _(i) {
    return [i.PointOnRelatingElement, i.PointOnRelatedElement];
  },
  2732653382: function _(i) {
    return [i.SurfaceOnRelatingElement, i.SurfaceOnRelatedElement];
  },
  775493141: function _(i) {
    return [i.VolumeOnRelatingElement, i.VolumeOnRelatedElement];
  },
  1959218052: function _(i) {
    return [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade];
  },
  1785450214: function _(i) {
    return [i.SourceCRS, i.TargetCRS];
  },
  1466758467: function _(i) {
    return [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum];
  },
  602808272: function _(i) {
    return [i.Name, i.Description, i.AppliedValue, i.UnitBasis, i.ApplicableDate, i.FixedUntilDate, i.Category, i.Condition, i.ArithmeticOperator, i.Components];
  },
  1765591967: function _(i) {
    return [i.Elements, i.UnitType, i.UserDefinedType];
  },
  1045800335: function _(i) {
    return [i.Unit, i.Exponent];
  },
  2949456006: function _(i) {
    return [i.LengthExponent, i.MassExponent, i.TimeExponent, i.ElectricCurrentExponent, i.ThermodynamicTemperatureExponent, i.AmountOfSubstanceExponent, i.LuminousIntensityExponent];
  },
  4294318154: function _(_147) {
    return [];
  },
  3200245327: function _(i) {
    return [i.Location, i.Identification, i.Name];
  },
  2242383968: function _(i) {
    return [i.Location, i.Identification, i.Name];
  },
  1040185647: function _(i) {
    return [i.Location, i.Identification, i.Name];
  },
  3548104201: function _(i) {
    return [i.Location, i.Identification, i.Name];
  },
  852622518: function _(i) {
    return [i.AxisTag, i.AxisCurve, i.SameSense];
  },
  3020489413: function _(i) {
    return [i.TimeStamp, i.ListValues.map(function (p) {
      return Labelise(p);
    })];
  },
  2655187982: function _(i) {
    return [i.Name, i.Version, i.Publisher, i.VersionDate, i.Location, i.Description];
  },
  3452421091: function _(i) {
    return [i.Location, i.Identification, i.Name, i.Description, i.Language, i.ReferencedLibrary];
  },
  4162380809: function _(i) {
    return [i.MainPlaneAngle, i.SecondaryPlaneAngle, i.LuminousIntensity];
  },
  1566485204: function _(i) {
    return [i.LightDistributionCurve, i.DistributionData];
  },
  3057273783: function _(i) {
    return [i.SourceCRS, i.TargetCRS, i.Eastings, i.Northings, i.OrthogonalHeight, i.XAxisAbscissa, i.XAxisOrdinate, i.Scale];
  },
  1847130766: function _(i) {
    return [i.MaterialClassifications, i.ClassifiedMaterial];
  },
  760658860: function _(_148) {
    return [];
  },
  248100487: function _(i) {
    return [i.Material, i.LayerThickness, i.IsVentilated, i.Name, i.Description, i.Category, i.Priority];
  },
  3303938423: function _(i) {
    return [i.MaterialLayers, i.LayerSetName, i.Description];
  },
  1847252529: function _(i) {
    return [i.Material, i.LayerThickness, i.IsVentilated, i.Name, i.Description, i.Category, i.Priority, i.OffsetDirection, i.OffsetValues];
  },
  2199411900: function _(i) {
    return [i.Materials];
  },
  2235152071: function _(i) {
    return [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category];
  },
  164193824: function _(i) {
    return [i.Name, i.Description, i.MaterialProfiles, i.CompositeProfile];
  },
  552965576: function _(i) {
    return [i.Name, i.Description, i.Material, i.Profile, i.Priority, i.Category, i.OffsetValues];
  },
  1507914824: function _(_149) {
    return [];
  },
  2597039031: function _(i) {
    return [Labelise(i.ValueComponent), i.UnitComponent];
  },
  3368373690: function _(i) {
    return [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.Benchmark, i.ValueSource, i.DataValue, i.ReferencePath];
  },
  2706619895: function _(i) {
    return [i.Currency];
  },
  1918398963: function _(i) {
    return [i.Dimensions, i.UnitType];
  },
  3701648758: function _(_150) {
    return [];
  },
  2251480897: function _(i) {
    return [i.Name, i.Description, i.ConstraintGrade, i.ConstraintSource, i.CreatingActor, i.CreationTime, i.UserDefinedGrade, i.BenchmarkValues, i.LogicalAggregator, i.ObjectiveQualifier, i.UserDefinedQualifier];
  },
  4251960020: function _(i) {
    return [i.Identification, i.Name, i.Description, i.Roles, i.Addresses];
  },
  1207048766: function _(i) {
    return [i.OwningUser, i.OwningApplication, i.State, i.ChangeAction, i.LastModifiedDate, i.LastModifyingUser, i.LastModifyingApplication, i.CreationDate];
  },
  2077209135: function _(i) {
    return [i.Identification, i.FamilyName, i.GivenName, i.MiddleNames, i.PrefixTitles, i.SuffixTitles, i.Roles, i.Addresses];
  },
  101040310: function _(i) {
    return [i.ThePerson, i.TheOrganization, i.Roles];
  },
  2483315170: function _(i) {
    return [i.Name, i.Description];
  },
  2226359599: function _(i) {
    return [i.Name, i.Description, i.Unit];
  },
  3355820592: function _(i) {
    return [i.Purpose, i.Description, i.UserDefinedPurpose, i.InternalLocation, i.AddressLines, i.PostalBox, i.Town, i.Region, i.PostalCode, i.Country];
  },
  677532197: function _(_151) {
    return [];
  },
  2022622350: function _(i) {
    return [i.Name, i.Description, i.AssignedItems, i.Identifier];
  },
  1304840413: function _(i) {
    return [i.Name, i.Description, i.AssignedItems, i.Identifier, i.LayerOn, i.LayerFrozen, i.LayerBlocked, i.LayerStyles];
  },
  3119450353: function _(i) {
    return [i.Name];
  },
  2417041796: function _(i) {
    return [i.Styles];
  },
  2095639259: function _(i) {
    return [i.Name, i.Description, i.Representations];
  },
  3958567839: function _(i) {
    return [i.ProfileType, i.ProfileName];
  },
  3843373140: function _(i) {
    return [i.Name, i.Description, i.GeodeticDatum, i.VerticalDatum, i.MapProjection, i.MapZone, i.MapUnit];
  },
  986844984: function _(_152) {
    return [];
  },
  3710013099: function _(i) {
    return [i.Name, i.EnumerationValues.map(function (p) {
      return Labelise(p);
    }), i.Unit];
  },
  2044713172: function _(i) {
    return [i.Name, i.Description, i.Unit, i.AreaValue, i.Formula];
  },
  2093928680: function _(i) {
    return [i.Name, i.Description, i.Unit, i.CountValue, i.Formula];
  },
  931644368: function _(i) {
    return [i.Name, i.Description, i.Unit, i.LengthValue, i.Formula];
  },
  3252649465: function _(i) {
    return [i.Name, i.Description, i.Unit, i.TimeValue, i.Formula];
  },
  2405470396: function _(i) {
    return [i.Name, i.Description, i.Unit, i.VolumeValue, i.Formula];
  },
  825690147: function _(i) {
    return [i.Name, i.Description, i.Unit, i.WeightValue, i.Formula];
  },
  3915482550: function _(i) {
    return [i.RecurrenceType, i.DayComponent, i.WeekdayComponent, i.MonthComponent, i.Position, i.Interval, i.Occurrences, i.TimePeriods];
  },
  2433181523: function _(i) {
    return [i.TypeIdentifier, i.AttributeIdentifier, i.InstanceName, i.ListPositions, i.InnerReference];
  },
  1076942058: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  3377609919: function _(i) {
    return [i.ContextIdentifier, i.ContextType];
  },
  3008791417: function _(_153) {
    return [];
  },
  1660063152: function _(i) {
    return [i.MappingOrigin, i.MappedRepresentation];
  },
  2439245199: function _(i) {
    return [i.Name, i.Description];
  },
  2341007311: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  448429030: function _(i) {
    return [i.Dimensions, i.UnitType, i.Prefix, i.Name];
  },
  1054537805: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin];
  },
  867548509: function _(i) {
    return [i.ShapeRepresentations, i.Name, i.Description, i.ProductDefinitional, i.PartOfProductDefinitionShape];
  },
  3982875396: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  4240577450: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  2273995522: function _(i) {
    return [i.Name];
  },
  2162789131: function _(i) {
    return [i.Name];
  },
  3478079324: function _(i) {
    return [i.Name, i.Values, i.Locations];
  },
  609421318: function _(i) {
    return [i.Name];
  },
  2525727697: function _(i) {
    return [i.Name];
  },
  3408363356: function _(i) {
    return [i.Name, i.DeltaTConstant, i.DeltaTY, i.DeltaTZ];
  },
  2830218821: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  3958052878: function _(i) {
    return [i.Item, i.Styles, i.Name];
  },
  3049322572: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  2934153892: function _(i) {
    return [i.Name, i.SurfaceReinforcement1, i.SurfaceReinforcement2, i.ShearReinforcement];
  },
  1300840506: function _(i) {
    return [i.Name, i.Side, i.Styles];
  },
  3303107099: function _(i) {
    return [i.DiffuseTransmissionColour, i.DiffuseReflectionColour, i.TransmissionColour, i.ReflectanceColour];
  },
  1607154358: function _(i) {
    return [i.RefractionIndex, i.DispersionFactor];
  },
  846575682: function _(i) {
    return [i.SurfaceColour, i.Transparency];
  },
  1351298697: function _(i) {
    return [i.Textures];
  },
  626085974: function _(i) {
    return [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter];
  },
  985171141: function _(i) {
    return [i.Name, i.Rows, i.Columns];
  },
  2043862942: function _(i) {
    return [i.Identifier, i.Name, i.Description, i.Unit, i.ReferencePath];
  },
  531007025: function _(i) {
    return [!i.RowCells ? null : i.RowCells.map(function (p) {
      return Labelise(p);
    }), i.IsHeading];
  },
  1549132990: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion];
  },
  2771591690: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.DurationType, i.ScheduleDuration, i.ScheduleStart, i.ScheduleFinish, i.EarlyStart, i.EarlyFinish, i.LateStart, i.LateFinish, i.FreeFloat, i.TotalFloat, i.IsCritical, i.StatusTime, i.ActualDuration, i.ActualStart, i.ActualFinish, i.RemainingTime, i.Completion, i.Recurrence];
  },
  912023232: function _(i) {
    return [i.Purpose, i.Description, i.UserDefinedPurpose, i.TelephoneNumbers, i.FacsimileNumbers, i.PagerNumber, i.ElectronicMailAddresses, i.WWWHomePageURL, i.MessagingIDs];
  },
  1447204868: function _(i) {
    return [i.Name, i.TextCharacterAppearance, i.TextStyle, i.TextFontStyle, i.ModelOrDraughting];
  },
  2636378356: function _(i) {
    return [i.Colour, i.BackgroundColour];
  },
  1640371178: function _(i) {
    return [!i.TextIndent ? null : Labelise(i.TextIndent), i.TextAlign, i.TextDecoration, !i.LetterSpacing ? null : Labelise(i.LetterSpacing), !i.WordSpacing ? null : Labelise(i.WordSpacing), i.TextTransform, !i.LineHeight ? null : Labelise(i.LineHeight)];
  },
  280115917: function _(i) {
    return [i.Maps];
  },
  1742049831: function _(i) {
    return [i.Maps, i.Mode, i.Parameter];
  },
  2552916305: function _(i) {
    return [i.Maps, i.Vertices, i.MappedTo];
  },
  1210645708: function _(i) {
    return [i.Coordinates];
  },
  3611470254: function _(i) {
    return [i.TexCoordsList];
  },
  1199560280: function _(i) {
    return [i.StartTime, i.EndTime];
  },
  3101149627: function _(i) {
    return [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit];
  },
  581633288: function _(i) {
    return [i.ListValues.map(function (p) {
      return Labelise(p);
    })];
  },
  1377556343: function _(_154) {
    return [];
  },
  1735638870: function _(i) {
    return [i.ContextOfItems, i.RepresentationIdentifier, i.RepresentationType, i.Items];
  },
  180925521: function _(i) {
    return [i.Units];
  },
  2799835756: function _(_155) {
    return [];
  },
  1907098498: function _(i) {
    return [i.VertexGeometry];
  },
  891718957: function _(i) {
    return [i.IntersectingAxes, i.OffsetDistances];
  },
  1236880293: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.RecurrencePattern, i.Start, i.Finish];
  },
  3869604511: function _(i) {
    return [i.Name, i.Description, i.RelatingApproval, i.RelatedApprovals];
  },
  3798115385: function _(i) {
    return [i.ProfileType, i.ProfileName, i.OuterCurve];
  },
  1310608509: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Curve];
  },
  2705031697: function _(i) {
    return [i.ProfileType, i.ProfileName, i.OuterCurve, i.InnerCurves];
  },
  616511568: function _(i) {
    return [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.RasterFormat, i.RasterCode];
  },
  3150382593: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Curve, i.Thickness];
  },
  747523909: function _(i) {
    return [i.Source, i.Edition, i.EditionDate, i.Name, i.Description, i.Location, i.ReferenceTokens];
  },
  647927063: function _(i) {
    return [i.Location, i.Identification, i.Name, i.ReferencedSource, i.Description, i.Sort];
  },
  3285139300: function _(i) {
    return [i.ColourList];
  },
  3264961684: function _(i) {
    return [i.Name];
  },
  1485152156: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Profiles, i.Label];
  },
  370225590: function _(i) {
    return [i.CfsFaces];
  },
  1981873012: function _(i) {
    return [i.CurveOnRelatingElement, i.CurveOnRelatedElement];
  },
  45288368: function _(i) {
    return [i.PointOnRelatingElement, i.PointOnRelatedElement, i.EccentricityInX, i.EccentricityInY, i.EccentricityInZ];
  },
  3050246964: function _(i) {
    return [i.Dimensions, i.UnitType, i.Name];
  },
  2889183280: function _(i) {
    return [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor];
  },
  2713554722: function _(i) {
    return [i.Dimensions, i.UnitType, i.Name, i.ConversionFactor, i.ConversionOffset];
  },
  539742890: function _(i) {
    return [i.Name, i.Description, i.RelatingMonetaryUnit, i.RelatedMonetaryUnit, i.ExchangeRate, i.RateDateTime, i.RateSource];
  },
  3800577675: function _(i) {
    return [i.Name, i.CurveFont, !i.CurveWidth ? null : Labelise(i.CurveWidth), i.CurveColour, i.ModelOrDraughting];
  },
  1105321065: function _(i) {
    return [i.Name, i.PatternList];
  },
  2367409068: function _(i) {
    return [i.Name, i.CurveFont, i.CurveFontScaling];
  },
  3510044353: function _(i) {
    return [i.VisibleSegmentLength, i.InvisibleSegmentLength];
  },
  3632507154: function _(i) {
    return [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label];
  },
  1154170062: function _(i) {
    return [i.Identification, i.Name, i.Description, i.Location, i.Purpose, i.IntendedUse, i.Scope, i.Revision, i.DocumentOwner, i.Editors, i.CreationTime, i.LastRevisionTime, i.ElectronicFormat, i.ValidFrom, i.ValidUntil, i.Confidentiality, i.Status];
  },
  770865208: function _(i) {
    return [i.Name, i.Description, i.RelatingDocument, i.RelatedDocuments, i.RelationshipType];
  },
  3732053477: function _(i) {
    return [i.Location, i.Identification, i.Name, i.Description, i.ReferencedDocument];
  },
  3900360178: function _(i) {
    return [i.EdgeStart, i.EdgeEnd];
  },
  476780140: function _(i) {
    return [i.EdgeStart, i.EdgeEnd, i.EdgeGeometry, i.SameSense];
  },
  211053100: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ActualDate, i.EarlyDate, i.LateDate, i.ScheduleDate];
  },
  297599258: function _(i) {
    return [i.Name, i.Description, i.Properties];
  },
  1437805879: function _(i) {
    return [i.Name, i.Description, i.RelatingReference, i.RelatedResourceObjects];
  },
  2556980723: function _(i) {
    return [i.Bounds];
  },
  1809719519: function _(i) {
    return [i.Bound, i.Orientation];
  },
  803316827: function _(i) {
    return [i.Bound, i.Orientation];
  },
  3008276851: function _(i) {
    return [i.Bounds, i.FaceSurface, i.SameSense];
  },
  4219587988: function _(i) {
    return [i.Name, i.TensionFailureX, i.TensionFailureY, i.TensionFailureZ, i.CompressionFailureX, i.CompressionFailureY, i.CompressionFailureZ];
  },
  738692330: function _(i) {
    return [i.Name, i.FillStyles, i.ModelorDraughting];
  },
  3448662350: function _(i) {
    return [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth];
  },
  2453401579: function _(_156) {
    return [];
  },
  4142052618: function _(i) {
    return [i.ContextIdentifier, i.ContextType, i.CoordinateSpaceDimension, i.Precision, i.WorldCoordinateSystem, i.TrueNorth, i.ParentContext, i.TargetScale, i.TargetView, i.UserDefinedTargetView];
  },
  3590301190: function _(i) {
    return [i.Elements];
  },
  178086475: function _(i) {
    return [i.PlacementLocation, i.PlacementRefDirection];
  },
  812098782: function _(i) {
    return [i.BaseSurface, i.AgreementFlag];
  },
  3905492369: function _(i) {
    return [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.URLReference];
  },
  3570813810: function _(i) {
    return [i.MappedTo, i.Opacity, i.Colours, i.ColourIndex];
  },
  1437953363: function _(i) {
    return [i.Maps, i.MappedTo, i.TexCoords];
  },
  2133299955: function _(i) {
    return [i.Maps, i.MappedTo, i.TexCoords, i.TexCoordIndex];
  },
  3741457305: function _(i) {
    return [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.Values];
  },
  1585845231: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, Labelise(i.LagValue), i.DurationType];
  },
  1402838566: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity];
  },
  125510826: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity];
  },
  2604431987: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Orientation];
  },
  4266656042: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.ColourAppearance, i.ColourTemperature, i.LuminousFlux, i.LightEmissionSource, i.LightDistributionDataSource];
  },
  1520743889: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation];
  },
  3422422726: function _(i) {
    return [i.Name, i.LightColour, i.AmbientIntensity, i.Intensity, i.Position, i.Radius, i.ConstantAttenuation, i.DistanceAttenuation, i.QuadricAttenuation, i.Orientation, i.ConcentrationExponent, i.SpreadAngle, i.BeamWidthAngle];
  },
  2624227202: function _(i) {
    return [i.PlacementRelTo, i.RelativePlacement];
  },
  1008929658: function _(_157) {
    return [];
  },
  2347385850: function _(i) {
    return [i.MappingSource, i.MappingTarget];
  },
  1838606355: function _(i) {
    return [i.Name, i.Description, i.Category];
  },
  3708119e3: function _(i) {
    return [i.Name, i.Description, i.Material, i.Fraction, i.Category];
  },
  2852063980: function _(i) {
    return [i.Name, i.Description, i.MaterialConstituents];
  },
  2022407955: function _(i) {
    return [i.Name, i.Description, i.Representations, i.RepresentedMaterial];
  },
  1303795690: function _(i) {
    return [i.ForLayerSet, i.LayerSetDirection, i.DirectionSense, i.OffsetFromReferenceLine, i.ReferenceExtent];
  },
  3079605661: function _(i) {
    return [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent];
  },
  3404854881: function _(i) {
    return [i.ForProfileSet, i.CardinalPoint, i.ReferenceExtent, i.ForProfileEndSet, i.CardinalEndPoint];
  },
  3265635763: function _(i) {
    return [i.Name, i.Description, i.Properties, i.Material];
  },
  853536259: function _(i) {
    return [i.Name, i.Description, i.RelatingMaterial, i.RelatedMaterials, i.Expression];
  },
  2998442950: function _(i) {
    return [i.ProfileType, i.ProfileName, i.ParentProfile, i.Operator, i.Label];
  },
  219451334: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  2665983363: function _(i) {
    return [i.CfsFaces];
  },
  1411181986: function _(i) {
    return [i.Name, i.Description, i.RelatingOrganization, i.RelatedOrganizations];
  },
  1029017970: function _(i) {
    return [i.EdgeStart, i.EdgeEnd, i.EdgeElement, i.Orientation];
  },
  2529465313: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position];
  },
  2519244187: function _(i) {
    return [i.EdgeList];
  },
  3021840470: function _(i) {
    return [i.Name, i.Description, i.HasQuantities, i.Discrimination, i.Quality, i.Usage];
  },
  597895409: function _(i) {
    return [i.RepeatS, i.RepeatT, i.Mode, i.TextureTransform, i.Parameter, i.Width, i.Height, i.ColourComponents, i.Pixel];
  },
  2004835150: function _(i) {
    return [i.Location];
  },
  1663979128: function _(i) {
    return [i.SizeInX, i.SizeInY];
  },
  2067069095: function _(_158) {
    return [];
  },
  4022376103: function _(i) {
    return [i.BasisCurve, i.PointParameter];
  },
  1423911732: function _(i) {
    return [i.BasisSurface, i.PointParameterU, i.PointParameterV];
  },
  2924175390: function _(i) {
    return [i.Polygon];
  },
  2775532180: function _(i) {
    return [i.BaseSurface, i.AgreementFlag, i.Position, i.PolygonalBoundary];
  },
  3727388367: function _(i) {
    return [i.Name];
  },
  3778827333: function _(_159) {
    return [];
  },
  1775413392: function _(i) {
    return [i.Name];
  },
  673634403: function _(i) {
    return [i.Name, i.Description, i.Representations];
  },
  2802850158: function _(i) {
    return [i.Name, i.Description, i.Properties, i.ProfileDefinition];
  },
  2598011224: function _(i) {
    return [i.Name, i.Description];
  },
  1680319473: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  148025276: function _(i) {
    return [i.Name, i.Description, i.DependingProperty, i.DependantProperty, i.Expression];
  },
  3357820518: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  1482703590: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  2090586900: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  3615266464: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim];
  },
  3413951693: function _(i) {
    return [i.Name, i.Description, i.StartTime, i.EndTime, i.TimeSeriesDataType, i.DataOrigin, i.UserDefinedDataOrigin, i.Unit, i.TimeStep, i.Values];
  },
  1580146022: function _(i) {
    return [i.TotalCrossSectionArea, i.SteelGrade, i.BarSurface, i.EffectiveDepth, i.NominalBarDiameter, i.BarCount];
  },
  478536968: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  2943643501: function _(i) {
    return [i.Name, i.Description, i.RelatedResourceObjects, i.RelatingApproval];
  },
  1608871552: function _(i) {
    return [i.Name, i.Description, i.RelatingConstraint, i.RelatedResourceObjects];
  },
  1042787934: function _(i) {
    return [i.Name, i.DataOrigin, i.UserDefinedDataOrigin, i.ScheduleWork, i.ScheduleUsage, i.ScheduleStart, i.ScheduleFinish, i.ScheduleContour, i.LevelingDelay, i.IsOverAllocated, i.StatusTime, i.ActualWork, i.ActualUsage, i.ActualStart, i.ActualFinish, i.RemainingWork, i.RemainingUsage, i.Completion];
  },
  2778083089: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.RoundingRadius];
  },
  2042790032: function _(i) {
    return [i.SectionType, i.StartProfile, i.EndProfile];
  },
  4165799628: function _(i) {
    return [i.LongitudinalStartPosition, i.LongitudinalEndPosition, i.TransversePosition, i.ReinforcementRole, i.SectionDefinition, i.CrossSectionReinforcementDefinitions];
  },
  1509187699: function _(i) {
    return [i.SpineCurve, i.CrossSections, i.CrossSectionPositions];
  },
  4124623270: function _(i) {
    return [i.SbsmBoundary];
  },
  3692461612: function _(i) {
    return [i.Name, i.Description];
  },
  2609359061: function _(i) {
    return [i.Name, i.SlippageX, i.SlippageY, i.SlippageZ];
  },
  723233188: function _(_160) {
    return [];
  },
  1595516126: function _(i) {
    return [i.Name, i.LinearForceX, i.LinearForceY, i.LinearForceZ, i.LinearMomentX, i.LinearMomentY, i.LinearMomentZ];
  },
  2668620305: function _(i) {
    return [i.Name, i.PlanarForceX, i.PlanarForceY, i.PlanarForceZ];
  },
  2473145415: function _(i) {
    return [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ];
  },
  1973038258: function _(i) {
    return [i.Name, i.DisplacementX, i.DisplacementY, i.DisplacementZ, i.RotationalDisplacementRX, i.RotationalDisplacementRY, i.RotationalDisplacementRZ, i.Distortion];
  },
  1597423693: function _(i) {
    return [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ];
  },
  1190533807: function _(i) {
    return [i.Name, i.ForceX, i.ForceY, i.ForceZ, i.MomentX, i.MomentY, i.MomentZ, i.WarpingMoment];
  },
  2233826070: function _(i) {
    return [i.EdgeStart, i.EdgeEnd, i.ParentEdge];
  },
  2513912981: function _(_161) {
    return [];
  },
  1878645084: function _(i) {
    return [i.SurfaceColour, i.Transparency, i.DiffuseColour, i.TransmissionColour, i.DiffuseTransmissionColour, i.ReflectionColour, i.SpecularColour, !i.SpecularHighlight ? null : Labelise(i.SpecularHighlight), i.ReflectanceMethod];
  },
  2247615214: function _(i) {
    return [i.SweptArea, i.Position];
  },
  1260650574: function _(i) {
    return [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam];
  },
  1096409881: function _(i) {
    return [i.Directrix, i.Radius, i.InnerRadius, i.StartParam, i.EndParam, i.FilletRadius];
  },
  230924584: function _(i) {
    return [i.SweptCurve, i.Position];
  },
  3071757647: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.WebEdgeRadius, i.WebSlope, i.FlangeSlope];
  },
  901063453: function _(_162) {
    return [];
  },
  4282788508: function _(i) {
    return [i.Literal, i.Placement, i.Path];
  },
  3124975700: function _(i) {
    return [i.Literal, i.Placement, i.Path, i.Extent, i.BoxAlignment];
  },
  1983826977: function _(i) {
    return [i.Name, i.FontFamily, i.FontStyle, i.FontVariant, i.FontWeight, Labelise(i.FontSize)];
  },
  2715220739: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.BottomXDim, i.TopXDim, i.YDim, i.TopXOffset];
  },
  1628702193: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets];
  },
  3736923433: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType];
  },
  2347495698: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag];
  },
  3698973494: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType];
  },
  427810014: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius, i.FlangeSlope];
  },
  1417489154: function _(i) {
    return [i.Orientation, i.Magnitude];
  },
  2759199220: function _(i) {
    return [i.LoopVertex];
  },
  1299126871: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ConstructionType, i.OperationType, i.ParameterTakesPrecedence, i.Sizeable];
  },
  2543172580: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.FlangeWidth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.EdgeRadius];
  },
  3406155212: function _(i) {
    return [i.Bounds, i.FaceSurface, i.SameSense];
  },
  669184980: function _(i) {
    return [i.OuterBoundary, i.InnerBoundaries];
  },
  3207858831: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.BottomFlangeWidth, i.OverallDepth, i.WebThickness, i.BottomFlangeThickness, i.BottomFlangeFilletRadius, i.TopFlangeWidth, i.TopFlangeThickness, i.TopFlangeFilletRadius, i.BottomFlangeEdgeRadius, i.BottomFlangeSlope, i.TopFlangeEdgeRadius, i.TopFlangeSlope];
  },
  4261334040: function _(i) {
    return [i.Location, i.Axis];
  },
  3125803723: function _(i) {
    return [i.Location, i.RefDirection];
  },
  2740243338: function _(i) {
    return [i.Location, i.Axis, i.RefDirection];
  },
  2736907675: function _(i) {
    return [i.Operator, i.FirstOperand, i.SecondOperand];
  },
  4182860854: function _(_163) {
    return [];
  },
  2581212453: function _(i) {
    return [i.Corner, i.XDim, i.YDim, i.ZDim];
  },
  2713105998: function _(i) {
    return [i.BaseSurface, i.AgreementFlag, i.Enclosure];
  },
  2898889636: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.WallThickness, i.Girth, i.InternalFilletRadius];
  },
  1123145078: function _(i) {
    return [i.Coordinates];
  },
  574549367: function _(_164) {
    return [];
  },
  1675464909: function _(i) {
    return [i.CoordList];
  },
  2059837836: function _(i) {
    return [i.CoordList];
  },
  59481748: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale];
  },
  3749851601: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale];
  },
  3486308946: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Scale2];
  },
  3331915920: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3];
  },
  1416205885: function _(i) {
    return [i.Axis1, i.Axis2, i.LocalOrigin, i.Scale, i.Axis3, i.Scale2, i.Scale3];
  },
  1383045692: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Radius];
  },
  2205249479: function _(i) {
    return [i.CfsFaces];
  },
  776857604: function _(i) {
    return [i.Name, i.Red, i.Green, i.Blue];
  },
  2542286263: function _(i) {
    return [i.Name, i.Description, i.UsageName, i.HasProperties];
  },
  2485617015: function _(i) {
    return [i.Transition, i.SameSense, i.ParentCurve];
  },
  2574617495: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity];
  },
  3419103109: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext];
  },
  1815067380: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  2506170314: function _(i) {
    return [i.Position];
  },
  2147822146: function _(i) {
    return [i.TreeRootExpression];
  },
  2601014836: function _(_165) {
    return [];
  },
  2827736869: function _(i) {
    return [i.BasisSurface, i.OuterBoundary, i.InnerBoundaries];
  },
  2629017746: function _(i) {
    return [i.BasisSurface, i.Boundaries, i.ImplicitOuter];
  },
  32440307: function _(i) {
    return [i.DirectionRatios];
  },
  526551008: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.OperationType, i.ConstructionType, i.ParameterTakesPrecedence, i.Sizeable];
  },
  1472233963: function _(i) {
    return [i.EdgeList];
  },
  1883228015: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.MethodOfMeasurement, i.Quantities];
  },
  339256511: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2777663545: function _(i) {
    return [i.Position];
  },
  2835456948: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.SemiAxis1, i.SemiAxis2];
  },
  4024345920: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType];
  },
  477187591: function _(i) {
    return [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth];
  },
  2804161546: function _(i) {
    return [i.SweptArea, i.Position, i.ExtrudedDirection, i.Depth, i.EndSweptArea];
  },
  2047409740: function _(i) {
    return [i.FbsmFaces];
  },
  374418227: function _(i) {
    return [i.HatchLineAppearance, i.StartOfNextHatchLine, i.PointOfReferenceHatchLine, i.PatternStart, i.HatchLineAngle];
  },
  315944413: function _(i) {
    return [i.TilingPattern, i.Tiles, i.TilingScale];
  },
  2652556860: function _(i) {
    return [i.SweptArea, i.Position, i.Directrix, i.StartParam, i.EndParam, i.FixedReference];
  },
  4238390223: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1268542332: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.AssemblyPlace, i.PredefinedType];
  },
  4095422895: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  987898635: function _(i) {
    return [i.Elements];
  },
  1484403080: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.OverallWidth, i.OverallDepth, i.WebThickness, i.FlangeThickness, i.FilletRadius, i.FlangeEdgeRadius, i.FlangeSlope];
  },
  178912537: function _(i) {
    return [i.CoordIndex];
  },
  2294589976: function _(i) {
    return [i.CoordIndex, i.InnerCoordIndices];
  },
  572779678: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Depth, i.Width, i.Thickness, i.FilletRadius, i.EdgeRadius, i.LegSlope];
  },
  428585644: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  1281925730: function _(i) {
    return [i.Pnt, i.Dir];
  },
  1425443689: function _(i) {
    return [i.Outer];
  },
  3888040117: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  3388369263: function _(i) {
    return [i.BasisCurve, i.Distance, i.SelfIntersect];
  },
  3505215534: function _(i) {
    return [i.BasisCurve, i.Distance, i.SelfIntersect, i.RefDirection];
  },
  1682466193: function _(i) {
    return [i.BasisSurface, i.ReferenceCurve];
  },
  603570806: function _(i) {
    return [i.SizeInX, i.SizeInY, i.Placement];
  },
  220341763: function _(i) {
    return [i.Position];
  },
  759155922: function _(i) {
    return [i.Name];
  },
  2559016684: function _(i) {
    return [i.Name];
  },
  3967405729: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  569719735: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType];
  },
  2945172077: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription];
  },
  4208778838: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  103090709: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext];
  },
  653396225: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.Phase, i.RepresentationContexts, i.UnitsInContext];
  },
  871118103: function _(i) {
    return [i.Name, i.Description, !i.UpperBoundValue ? null : Labelise(i.UpperBoundValue), !i.LowerBoundValue ? null : Labelise(i.LowerBoundValue), i.Unit, !i.SetPointValue ? null : Labelise(i.SetPointValue)];
  },
  4166981789: function _(i) {
    return [i.Name, i.Description, !i.EnumerationValues ? null : i.EnumerationValues.map(function (p) {
      return Labelise(p);
    }), i.EnumerationReference];
  },
  2752243245: function _(i) {
    return [i.Name, i.Description, !i.ListValues ? null : i.ListValues.map(function (p) {
      return Labelise(p);
    }), i.Unit];
  },
  941946838: function _(i) {
    return [i.Name, i.Description, i.UsageName, i.PropertyReference];
  },
  1451395588: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.HasProperties];
  },
  492091185: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.ApplicableEntity, i.HasPropertyTemplates];
  },
  3650150729: function _(i) {
    return [i.Name, i.Description, !i.NominalValue ? null : Labelise(i.NominalValue), i.Unit];
  },
  110355661: function _(i) {
    return [i.Name, i.Description, !i.DefiningValues ? null : i.DefiningValues.map(function (p) {
      return Labelise(p);
    }), !i.DefinedValues ? null : i.DefinedValues.map(function (p) {
      return Labelise(p);
    }), i.Expression, i.DefiningUnit, i.DefinedUnit, i.CurveInterpolation];
  },
  3521284610: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  3219374653: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.ProxyType, i.Tag];
  },
  2770003689: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.XDim, i.YDim, i.WallThickness, i.InnerFilletRadius, i.OuterFilletRadius];
  },
  2798486643: function _(i) {
    return [i.Position, i.XLength, i.YLength, i.Height];
  },
  3454111270: function _(i) {
    return [i.BasisSurface, i.U1, i.V1, i.U2, i.V2, i.Usense, i.Vsense];
  },
  3765753017: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.DefinitionType, i.ReinforcementSectionDefinitions];
  },
  3939117080: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType];
  },
  1683148259: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingActor, i.ActingRole];
  },
  2495723537: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingControl];
  },
  1307041759: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup];
  },
  1027710054: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingGroup, i.Factor];
  },
  4278684876: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProcess, i.QuantityInProcess];
  },
  2857406711: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingProduct];
  },
  205026976: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatedObjectsType, i.RelatingResource];
  },
  1865459582: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects];
  },
  4095574036: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingApproval];
  },
  919958153: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingClassification];
  },
  2728634034: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.Intent, i.RelatingConstraint];
  },
  982818633: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingDocument];
  },
  3840914261: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingLibrary];
  },
  2655215786: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingMaterial];
  },
  826625072: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  1204542856: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement];
  },
  3945020480: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RelatingPriorities, i.RelatedPriorities, i.RelatedConnectionType, i.RelatingConnectionType];
  },
  4201705270: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedElement];
  },
  3190031847: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingPort, i.RelatedPort, i.RealizingElement];
  },
  2127690289: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedStructuralActivity];
  },
  1638771189: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem];
  },
  504942748: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingStructuralMember, i.RelatedStructuralConnection, i.AppliedCondition, i.AdditionalConditions, i.SupportedLength, i.ConditionCoordinateSystem, i.ConnectionConstraint];
  },
  3678494232: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ConnectionGeometry, i.RelatingElement, i.RelatedElement, i.RealizingElements, i.ConnectionType];
  },
  3242617779: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure];
  },
  886880790: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedCoverings];
  },
  2802773753: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedCoverings];
  },
  2565941209: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingContext, i.RelatedDefinitions];
  },
  2551354335: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  693640335: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description];
  },
  1462361463: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingObject];
  },
  4186316022: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingPropertyDefinition];
  },
  307848117: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedPropertySets, i.RelatingTemplate];
  },
  781010003: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedObjects, i.RelatingType];
  },
  3940055652: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingOpeningElement, i.RelatedBuildingElement];
  },
  279856033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedControlElements, i.RelatingFlowElement];
  },
  427948657: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedElement, i.InterferenceGeometry, i.InterferenceType, i.ImpliedOrder];
  },
  3268803585: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects];
  },
  750771296: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingElement, i.RelatedFeatureElement];
  },
  1245217292: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatedElements, i.RelatingStructure];
  },
  4122056220: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingProcess, i.RelatedProcess, i.TimeLag, i.SequenceType, i.UserDefinedSequenceType];
  },
  366585022: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSystem, i.RelatedBuildings];
  },
  3451746338: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary];
  },
  3523091289: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary];
  },
  1521410863: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingSpace, i.RelatedBuildingElement, i.ConnectionGeometry, i.PhysicalOrVirtualBoundary, i.InternalOrExternalBoundary, i.ParentBoundary, i.CorrespondingBoundary];
  },
  1401173127: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingBuildingElement, i.RelatedOpeningElement];
  },
  816062949: function _(i) {
    return [i.Transition, i.SameSense, i.ParentCurve, i.ParamLength];
  },
  2914609552: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription];
  },
  1856042241: function _(i) {
    return [i.SweptArea, i.Position, i.Axis, i.Angle];
  },
  3243963512: function _(i) {
    return [i.SweptArea, i.Position, i.Axis, i.Angle, i.EndSweptArea];
  },
  4158566097: function _(i) {
    return [i.Position, i.Height, i.BottomRadius];
  },
  3626867408: function _(i) {
    return [i.Position, i.Height, i.Radius];
  },
  3663146110: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.TemplateType, i.PrimaryMeasureType, i.SecondaryMeasureType, i.Enumerators, i.PrimaryUnit, i.SecondaryUnit, i.Expression, i.AccessState];
  },
  1412071761: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName];
  },
  710998568: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2706606064: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType];
  },
  3893378262: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  463610769: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType];
  },
  2481509218: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName];
  },
  451544542: function _(i) {
    return [i.Position, i.Radius];
  },
  4015995234: function _(i) {
    return [i.Position, i.Radius];
  },
  3544373492: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal];
  },
  3136571912: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  530289379: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  3689010777: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal];
  },
  3979015343: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness];
  },
  2218152070: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Thickness];
  },
  603775116: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType];
  },
  4095615324: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  699246055: function _(i) {
    return [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation];
  },
  2028607225: function _(i) {
    return [i.SweptArea, i.Position, i.Directrix, i.StartParam, i.EndParam, i.ReferenceSurface];
  },
  2809605785: function _(i) {
    return [i.SweptCurve, i.Position, i.ExtrudedDirection, i.Depth];
  },
  4124788165: function _(i) {
    return [i.SweptCurve, i.Position, i.AxisPosition];
  },
  1580310250: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3473067441: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Status, i.WorkMethod, i.IsMilestone, i.Priority, i.TaskTime, i.PredefinedType];
  },
  3206491090: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ProcessType, i.PredefinedType, i.WorkMethod];
  },
  2387106220: function _(i) {
    return [i.Coordinates];
  },
  1935646853: function _(i) {
    return [i.Position, i.MajorRadius, i.MinorRadius];
  },
  2097647324: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2916149573: function _(i) {
    return [i.Coordinates, i.Normals, i.Closed, i.CoordIndex, i.PnIndex];
  },
  336235671: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.TransomThickness, i.MullionThickness, i.FirstTransomOffset, i.SecondTransomOffset, i.FirstMullionOffset, i.SecondMullionOffset, i.ShapeAspectStyle, i.LiningOffset, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY];
  },
  512836454: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle];
  },
  2296667514: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor];
  },
  1635779807: function _(i) {
    return [i.Outer];
  },
  2603310189: function _(i) {
    return [i.Outer, i.Voids];
  },
  1674181508: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  2887950389: function _(i) {
    return [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect];
  },
  167062518: function _(i) {
    return [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec];
  },
  1334484129: function _(i) {
    return [i.Position, i.XLength, i.YLength, i.ZLength];
  },
  3649129432: function _(i) {
    return [i.Operator, i.FirstOperand, i.SecondOperand];
  },
  1260505505: function _(_166) {
    return [];
  },
  4031249490: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.ElevationOfRefHeight, i.ElevationOfTerrain, i.BuildingAddress];
  },
  1950629157: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3124254112: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.Elevation];
  },
  2197970202: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2937912522: function _(i) {
    return [i.ProfileType, i.ProfileName, i.Position, i.Radius, i.WallThickness];
  },
  3893394355: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  300633059: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3875453745: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.UsageName, i.TemplateType, i.HasPropertyTemplates];
  },
  3732776249: function _(i) {
    return [i.Segments, i.SelfIntersect];
  },
  15328376: function _(i) {
    return [i.Segments, i.SelfIntersect];
  },
  2510884976: function _(i) {
    return [i.Position];
  },
  2185764099: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  4105962743: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  1525564444: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.Identification, i.LongDescription, i.ResourceType, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  2559216714: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity];
  },
  3293443760: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification];
  },
  3895139033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.CostValues, i.CostQuantities];
  },
  1419761937: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.SubmittedOn, i.UpdateDate];
  },
  1916426348: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3295246426: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  1457835157: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1213902940: function _(i) {
    return [i.Position, i.Radius];
  },
  3256556792: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3849074793: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2963535650: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.LiningDepth, i.LiningThickness, i.ThresholdDepth, i.ThresholdThickness, i.TransomThickness, i.TransomOffset, i.LiningOffset, i.ThresholdOffset, i.CasingThickness, i.CasingDepth, i.ShapeAspectStyle, i.LiningToPanelOffsetX, i.LiningToPanelOffsetY];
  },
  1714330368: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.PanelDepth, i.PanelOperation, i.PanelWidth, i.PanelPosition, i.ShapeAspectStyle];
  },
  2323601079: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.OperationType, i.ParameterTakesPrecedence, i.UserDefinedOperationType];
  },
  445594917: function _(i) {
    return [i.Name];
  },
  4006246654: function _(i) {
    return [i.Name];
  },
  1758889154: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  4123344466: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.AssemblyPlace, i.PredefinedType];
  },
  2397081782: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1623761950: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2590856083: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1704287377: function _(i) {
    return [i.Position, i.SemiAxis1, i.SemiAxis2];
  },
  2107101300: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  132023988: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3174744832: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3390157468: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4148101412: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType, i.EventTriggerType, i.UserDefinedEventTriggerType, i.EventOccurenceTime];
  },
  2853485674: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName];
  },
  807026263: function _(i) {
    return [i.Outer];
  },
  3737207727: function _(i) {
    return [i.Outer, i.Voids];
  },
  647756555: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2489546625: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2827207264: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2143335405: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1287392070: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3907093117: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3198132628: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3815607619: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1482959167: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1834744321: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1339347760: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2297155007: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  3009222698: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1893162501: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  263784265: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  1509553395: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3493046030: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3009204131: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.UAxes, i.VAxes, i.WAxes, i.PredefinedType];
  },
  2706460486: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  1251058090: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1806887404: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2571569899: function _(i) {
    return [i.Points, !i.Segments ? null : i.Segments.map(function (p) {
      return Labelise(p);
    }), i.SelfIntersect];
  },
  3946677679: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3113134337: function _(i) {
    return [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation];
  },
  2391368822: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.Jurisdiction, i.ResponsiblePersons, i.LastUpdateDate, i.CurrentValue, i.OriginalValue];
  },
  4288270099: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3827777499: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  1051575348: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1161773419: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  377706215: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NominalDiameter, i.NominalLength, i.PredefinedType];
  },
  2108223431: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.NominalLength];
  },
  1114901282: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3181161470: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  977012517: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4143007308: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheActor, i.PredefinedType];
  },
  3588315303: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3079942009: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2837617999: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2382730787: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LifeCyclePhase, i.PredefinedType];
  },
  3566463478: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.OperationType, i.PanelPosition, i.FrameDepth, i.FrameThickness, i.ShapeAspectStyle];
  },
  3327091369: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription];
  },
  1158309216: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  804291784: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4231323485: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4017108033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2839578677: function _(i) {
    return [i.Coordinates, i.Closed, i.Faces, i.PnIndex];
  },
  3724593414: function _(i) {
    return [i.Points];
  },
  3740093272: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation];
  },
  2744685151: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.PredefinedType];
  },
  2904328755: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription];
  },
  3651124850: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1842657554: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2250791053: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2893384427: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2324767716: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1469900589: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  683857671: function _(i) {
    return [i.UDegree, i.VDegree, i.ControlPointsList, i.SurfaceForm, i.UClosed, i.VClosed, i.SelfIntersect, i.UMultiplicities, i.VMultiplicities, i.UKnots, i.VKnots, i.KnotSpec, i.WeightsData];
  },
  3027567501: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade];
  },
  964333572: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  2320036040: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.PredefinedType];
  },
  2310774935: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.MeshLength, i.MeshWidth, i.LongitudinalBarNominalDiameter, i.TransverseBarNominalDiameter, i.LongitudinalBarCrossSectionArea, i.TransverseBarCrossSectionArea, i.LongitudinalBarSpacing, i.TransverseBarSpacing, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map(function (p) {
      return Labelise(p);
    })];
  },
  160246688: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.RelatingObject, i.RelatedObjects];
  },
  2781568857: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1768891740: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2157484638: function _(i) {
    return [i.Curve3D, i.AssociatedGeometry, i.MasterRepresentation];
  },
  4074543187: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4097777520: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.RefLatitude, i.RefLongitude, i.RefElevation, i.LandTitleNumber, i.SiteAddress];
  },
  2533589738: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1072016465: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3856911033: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.CompositionType, i.PredefinedType, i.ElevationWithFlooring];
  },
  1305183839: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3812236995: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.LongName];
  },
  3112655638: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1039846685: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  338393293: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  682877961: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad];
  },
  1179482911: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition];
  },
  1004757350: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType];
  },
  4243806635: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.Axis];
  },
  214636428: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis];
  },
  2445595289: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.PredefinedType, i.Axis];
  },
  2757150158: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.PredefinedType];
  },
  1807405624: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType];
  },
  1252848954: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose];
  },
  2082059205: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad];
  },
  734778138: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition, i.ConditionCoordinateSystem];
  },
  1235345126: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal];
  },
  2986769608: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.TheoryType, i.ResultForLoadGroup, i.IsLinear];
  },
  3657597509: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType];
  },
  1975003073: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedCondition];
  },
  148013059: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  3101698114: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2315554128: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2254336722: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType];
  },
  413509423: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  5716631: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3824725483: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.TensionForce, i.PreStress, i.FrictionCoefficient, i.AnchorageSlip, i.MinCurvatureRadius];
  },
  2347447852: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.PredefinedType];
  },
  3081323446: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2415094496: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.SheathDiameter];
  },
  1692211062: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1620046519: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3593883385: function _(i) {
    return [i.BasisCurve, i.Trim1, i.Trim2, i.SenseAgreement, i.MasterRepresentation];
  },
  1600972822: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1911125066: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  728799441: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2391383451: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3313531582: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2769231204: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  926996030: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1898987631: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1133259667: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4009809668: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.PartitioningType, i.ParameterTakesPrecedence, i.UserDefinedPartitioningType];
  },
  4088093105: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.WorkingTimes, i.ExceptionTimes, i.PredefinedType];
  },
  1028945134: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime];
  },
  4218914973: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType];
  },
  3342526732: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.CreationDate, i.Creators, i.Purpose, i.Duration, i.TotalFloat, i.StartTime, i.FinishTime, i.PredefinedType];
  },
  1033361043: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName];
  },
  3821786052: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.PredefinedType, i.Status, i.LongDescription];
  },
  1411407467: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3352864051: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1871374353: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3460190687: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.OriginalValue, i.CurrentValue, i.TotalReplacementCost, i.Owner, i.User, i.ResponsiblePerson, i.IncorporationDate, i.DepreciatedValue];
  },
  1532957894: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1967976161: function _(i) {
    return [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect];
  },
  2461110595: function _(i) {
    return [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect, i.KnotMultiplicities, i.Knots, i.KnotSpec];
  },
  819618141: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  231477066: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1136057603: function _(i) {
    return [i.Segments, i.SelfIntersect];
  },
  3299480353: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2979338954: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  39481116: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1095909175: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1909888760: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1177604601: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.LongName];
  },
  2188180465: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  395041908: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3293546465: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2674252688: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1285652485: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2951183804: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3296154744: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2611217952: function _(i) {
    return [i.Position, i.Radius];
  },
  1677625105: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2301859152: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  843113511: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  905975707: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  400855858: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3850581409: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2816379211: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3898045240: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  1060000209: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  488727124: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.Identification, i.LongDescription, i.Usage, i.BaseCosts, i.BaseQuantity, i.PredefinedType];
  },
  335055490: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2954562838: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1973544240: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3495092785: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3961806047: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1335981549: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2635815018: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1599208980: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2063403501: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType];
  },
  1945004755: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3040386961: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3041715199: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.FlowDirection, i.PredefinedType, i.SystemType];
  },
  3205830791: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType];
  },
  395920057: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.OperationType, i.UserDefinedOperationType];
  },
  3242481149: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.OperationType, i.UserDefinedOperationType];
  },
  869906466: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3760055223: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2030761528: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  663422040: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2417008758: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  3277789161: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1534661035: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1217240411: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  712377611: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1658829314: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2814081492: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3747195512: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  484807127: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1209101575: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.LongName, i.PredefinedType];
  },
  346874300: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1810631287: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4222183408: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2058353004: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  4278956645: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  4037862832: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  2188021234: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3132237377: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  987401354: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  707683696: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  2223149337: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  3508470533: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  900683007: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3319311131: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2068733104: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4175244083: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2176052936: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  76236018: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  629592764: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1437502449: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1073191201: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1911478936: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2474470126: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  144952367: function _(i) {
    return [i.Segments, i.SelfIntersect];
  },
  3694346114: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1687234759: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType, i.ConstructionType];
  },
  310824031: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3612865200: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3171933400: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1156407060: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  738039164: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  655969474: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  90941305: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2262370178: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3024970846: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3283111854: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1232101972: function _(i) {
    return [i.Degree, i.ControlPointsList, i.CurveForm, i.ClosedCurve, i.SelfIntersect, i.KnotMultiplicities, i.Knots, i.KnotSpec, i.WeightsData];
  },
  979691226: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.SteelGrade, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.PredefinedType, i.BarSurface];
  },
  2572171363: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType, i.NominalDiameter, i.CrossSectionArea, i.BarLength, i.BarSurface, i.BendingShapeCode, !i.BendingParameters ? null : i.BendingParameters.map(function (p) {
      return Labelise(p);
    })];
  },
  2016517767: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3053780830: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1783015770: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1329646415: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1529196076: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3127900445: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3027962421: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3420628829: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1999602285: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1404847402: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  331165859: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4252922144: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.NumberOfRisers, i.NumberOfTreads, i.RiserHeight, i.TreadLength, i.PredefinedType];
  },
  2515109513: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.OrientationOf2DPlane, i.LoadedBy, i.HasResults, i.SharedPlacement];
  },
  385403989: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.PredefinedType, i.ActionType, i.ActionSource, i.Coefficient, i.Purpose, i.SelfWeightCoefficients];
  },
  1621171031: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.AppliedLoad, i.GlobalOrLocal, i.DestabilizingLoad, i.ProjectedOrTrue, i.PredefinedType];
  },
  1162798199: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  812556717: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3825984169: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3026737570: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3179687236: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4292641817: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4207607924: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2391406946: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4156078855: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3512223829: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4237592921: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3304561284: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.PartitioningType, i.UserDefinedPartitioningType];
  },
  486154966: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.OverallHeight, i.OverallWidth, i.PredefinedType, i.PartitioningType, i.UserDefinedPartitioningType];
  },
  2874132201: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  1634111441: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  177149247: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2056796094: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3001207471: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  277319702: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  753842376: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2906023776: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  32344328: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2938176219: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  635142910: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3758799889: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1051757585: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4217484030: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3902619387: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  639361253: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3221913625: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3571504051: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2272882330: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  578613899: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ApplicableOccurrence, i.HasPropertySets, i.RepresentationMaps, i.Tag, i.ElementType, i.PredefinedType];
  },
  4136498852: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3640358203: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4074379575: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1052013943: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  562808652: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.LongName, i.PredefinedType];
  },
  1062813311: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag];
  },
  342316401: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3518393246: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1360408905: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1904799276: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  862014818: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3310460725: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  264262732: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  402227799: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1003880860: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3415622556: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  819412036: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  1426591983: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  182646315: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  2295281155: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4086658281: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  630975310: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  4288193352: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  3087945054: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  },
  25142252: function _(i) {
    return [i.GlobalId, i.OwnerHistory, i.Name, i.Description, i.ObjectType, i.ObjectPlacement, i.Representation, i.Tag, i.PredefinedType];
  }
};
TypeInitialisers[3] = {
  3699917729: function _(v) {
    return new IFC4.IfcAbsorbedDoseMeasure(v);
  },
  4182062534: function _(v) {
    return new IFC4.IfcAccelerationMeasure(v);
  },
  360377573: function _(v) {
    return new IFC4.IfcAmountOfSubstanceMeasure(v);
  },
  632304761: function _(v) {
    return new IFC4.IfcAngularVelocityMeasure(v);
  },
  3683503648: function _(v) {
    return new IFC4.IfcArcIndex(v);
  },
  1500781891: function _(v) {
    return new IFC4.IfcAreaDensityMeasure(v);
  },
  2650437152: function _(v) {
    return new IFC4.IfcAreaMeasure(v);
  },
  2314439260: function _(v) {
    return new IFC4.IfcBinary(v);
  },
  2735952531: function _(v) {
    return new IFC4.IfcBoolean(v);
  },
  1867003952: function _(v) {
    return new IFC4.IfcBoxAlignment(v);
  },
  1683019596: function _(v) {
    return new IFC4.IfcCardinalPointReference(v);
  },
  2991860651: function _(v) {
    return new IFC4.IfcComplexNumber(v);
  },
  3812528620: function _(v) {
    return new IFC4.IfcCompoundPlaneAngleMeasure(v);
  },
  3238673880: function _(v) {
    return new IFC4.IfcContextDependentMeasure(v);
  },
  1778710042: function _(v) {
    return new IFC4.IfcCountMeasure(v);
  },
  94842927: function _(v) {
    return new IFC4.IfcCurvatureMeasure(v);
  },
  937566702: function _(v) {
    return new IFC4.IfcDate(v);
  },
  2195413836: function _(v) {
    return new IFC4.IfcDateTime(v);
  },
  86635668: function _(v) {
    return new IFC4.IfcDayInMonthNumber(v);
  },
  3701338814: function _(v) {
    return new IFC4.IfcDayInWeekNumber(v);
  },
  1514641115: function _(v) {
    return new IFC4.IfcDescriptiveMeasure(v);
  },
  4134073009: function _(v) {
    return new IFC4.IfcDimensionCount(v);
  },
  524656162: function _(v) {
    return new IFC4.IfcDoseEquivalentMeasure(v);
  },
  2541165894: function _(v) {
    return new IFC4.IfcDuration(v);
  },
  69416015: function _(v) {
    return new IFC4.IfcDynamicViscosityMeasure(v);
  },
  1827137117: function _(v) {
    return new IFC4.IfcElectricCapacitanceMeasure(v);
  },
  3818826038: function _(v) {
    return new IFC4.IfcElectricChargeMeasure(v);
  },
  2093906313: function _(v) {
    return new IFC4.IfcElectricConductanceMeasure(v);
  },
  3790457270: function _(v) {
    return new IFC4.IfcElectricCurrentMeasure(v);
  },
  2951915441: function _(v) {
    return new IFC4.IfcElectricResistanceMeasure(v);
  },
  2506197118: function _(v) {
    return new IFC4.IfcElectricVoltageMeasure(v);
  },
  2078135608: function _(v) {
    return new IFC4.IfcEnergyMeasure(v);
  },
  1102727119: function _(v) {
    return new IFC4.IfcFontStyle(v);
  },
  2715512545: function _(v) {
    return new IFC4.IfcFontVariant(v);
  },
  2590844177: function _(v) {
    return new IFC4.IfcFontWeight(v);
  },
  1361398929: function _(v) {
    return new IFC4.IfcForceMeasure(v);
  },
  3044325142: function _(v) {
    return new IFC4.IfcFrequencyMeasure(v);
  },
  3064340077: function _(v) {
    return new IFC4.IfcGloballyUniqueId(v);
  },
  3113092358: function _(v) {
    return new IFC4.IfcHeatFluxDensityMeasure(v);
  },
  1158859006: function _(v) {
    return new IFC4.IfcHeatingValueMeasure(v);
  },
  983778844: function _(v) {
    return new IFC4.IfcIdentifier(v);
  },
  3358199106: function _(v) {
    return new IFC4.IfcIlluminanceMeasure(v);
  },
  2679005408: function _(v) {
    return new IFC4.IfcInductanceMeasure(v);
  },
  1939436016: function _(v) {
    return new IFC4.IfcInteger(v);
  },
  3809634241: function _(v) {
    return new IFC4.IfcIntegerCountRateMeasure(v);
  },
  3686016028: function _(v) {
    return new IFC4.IfcIonConcentrationMeasure(v);
  },
  3192672207: function _(v) {
    return new IFC4.IfcIsothermalMoistureCapacityMeasure(v);
  },
  2054016361: function _(v) {
    return new IFC4.IfcKinematicViscosityMeasure(v);
  },
  3258342251: function _(v) {
    return new IFC4.IfcLabel(v);
  },
  1275358634: function _(v) {
    return new IFC4.IfcLanguageId(v);
  },
  1243674935: function _(v) {
    return new IFC4.IfcLengthMeasure(v);
  },
  1774176899: function _(v) {
    return new IFC4.IfcLineIndex(v);
  },
  191860431: function _(v) {
    return new IFC4.IfcLinearForceMeasure(v);
  },
  2128979029: function _(v) {
    return new IFC4.IfcLinearMomentMeasure(v);
  },
  1307019551: function _(v) {
    return new IFC4.IfcLinearStiffnessMeasure(v);
  },
  3086160713: function _(v) {
    return new IFC4.IfcLinearVelocityMeasure(v);
  },
  503418787: function _(v) {
    return new IFC4.IfcLogical(v);
  },
  2095003142: function _(v) {
    return new IFC4.IfcLuminousFluxMeasure(v);
  },
  2755797622: function _(v) {
    return new IFC4.IfcLuminousIntensityDistributionMeasure(v);
  },
  151039812: function _(v) {
    return new IFC4.IfcLuminousIntensityMeasure(v);
  },
  286949696: function _(v) {
    return new IFC4.IfcMagneticFluxDensityMeasure(v);
  },
  2486716878: function _(v) {
    return new IFC4.IfcMagneticFluxMeasure(v);
  },
  1477762836: function _(v) {
    return new IFC4.IfcMassDensityMeasure(v);
  },
  4017473158: function _(v) {
    return new IFC4.IfcMassFlowRateMeasure(v);
  },
  3124614049: function _(v) {
    return new IFC4.IfcMassMeasure(v);
  },
  3531705166: function _(v) {
    return new IFC4.IfcMassPerLengthMeasure(v);
  },
  3341486342: function _(v) {
    return new IFC4.IfcModulusOfElasticityMeasure(v);
  },
  2173214787: function _(v) {
    return new IFC4.IfcModulusOfLinearSubgradeReactionMeasure(v);
  },
  1052454078: function _(v) {
    return new IFC4.IfcModulusOfRotationalSubgradeReactionMeasure(v);
  },
  1753493141: function _(v) {
    return new IFC4.IfcModulusOfSubgradeReactionMeasure(v);
  },
  3177669450: function _(v) {
    return new IFC4.IfcMoistureDiffusivityMeasure(v);
  },
  1648970520: function _(v) {
    return new IFC4.IfcMolecularWeightMeasure(v);
  },
  3114022597: function _(v) {
    return new IFC4.IfcMomentOfInertiaMeasure(v);
  },
  2615040989: function _(v) {
    return new IFC4.IfcMonetaryMeasure(v);
  },
  765770214: function _(v) {
    return new IFC4.IfcMonthInYearNumber(v);
  },
  525895558: function _(v) {
    return new IFC4.IfcNonNegativeLengthMeasure(v);
  },
  2095195183: function _(v) {
    return new IFC4.IfcNormalisedRatioMeasure(v);
  },
  2395907400: function _(v) {
    return new IFC4.IfcNumericMeasure(v);
  },
  929793134: function _(v) {
    return new IFC4.IfcPHMeasure(v);
  },
  2260317790: function _(v) {
    return new IFC4.IfcParameterValue(v);
  },
  2642773653: function _(v) {
    return new IFC4.IfcPlanarForceMeasure(v);
  },
  4042175685: function _(v) {
    return new IFC4.IfcPlaneAngleMeasure(v);
  },
  1790229001: function _(v) {
    return new IFC4.IfcPositiveInteger(v);
  },
  2815919920: function _(v) {
    return new IFC4.IfcPositiveLengthMeasure(v);
  },
  3054510233: function _(v) {
    return new IFC4.IfcPositivePlaneAngleMeasure(v);
  },
  1245737093: function _(v) {
    return new IFC4.IfcPositiveRatioMeasure(v);
  },
  1364037233: function _(v) {
    return new IFC4.IfcPowerMeasure(v);
  },
  2169031380: function _(v) {
    return new IFC4.IfcPresentableText(v);
  },
  3665567075: function _(v) {
    return new IFC4.IfcPressureMeasure(v);
  },
  2798247006: function _(v) {
    return new IFC4.IfcPropertySetDefinitionSet(v);
  },
  3972513137: function _(v) {
    return new IFC4.IfcRadioActivityMeasure(v);
  },
  96294661: function _(v) {
    return new IFC4.IfcRatioMeasure(v);
  },
  200335297: function _(v) {
    return new IFC4.IfcReal(v);
  },
  2133746277: function _(v) {
    return new IFC4.IfcRotationalFrequencyMeasure(v);
  },
  1755127002: function _(v) {
    return new IFC4.IfcRotationalMassMeasure(v);
  },
  3211557302: function _(v) {
    return new IFC4.IfcRotationalStiffnessMeasure(v);
  },
  3467162246: function _(v) {
    return new IFC4.IfcSectionModulusMeasure(v);
  },
  2190458107: function _(v) {
    return new IFC4.IfcSectionalAreaIntegralMeasure(v);
  },
  408310005: function _(v) {
    return new IFC4.IfcShearModulusMeasure(v);
  },
  3471399674: function _(v) {
    return new IFC4.IfcSolidAngleMeasure(v);
  },
  4157543285: function _(v) {
    return new IFC4.IfcSoundPowerLevelMeasure(v);
  },
  846465480: function _(v) {
    return new IFC4.IfcSoundPowerMeasure(v);
  },
  3457685358: function _(v) {
    return new IFC4.IfcSoundPressureLevelMeasure(v);
  },
  993287707: function _(v) {
    return new IFC4.IfcSoundPressureMeasure(v);
  },
  3477203348: function _(v) {
    return new IFC4.IfcSpecificHeatCapacityMeasure(v);
  },
  2757832317: function _(v) {
    return new IFC4.IfcSpecularExponent(v);
  },
  361837227: function _(v) {
    return new IFC4.IfcSpecularRoughness(v);
  },
  58845555: function _(v) {
    return new IFC4.IfcTemperatureGradientMeasure(v);
  },
  1209108979: function _(v) {
    return new IFC4.IfcTemperatureRateOfChangeMeasure(v);
  },
  2801250643: function _(v) {
    return new IFC4.IfcText(v);
  },
  1460886941: function _(v) {
    return new IFC4.IfcTextAlignment(v);
  },
  3490877962: function _(v) {
    return new IFC4.IfcTextDecoration(v);
  },
  603696268: function _(v) {
    return new IFC4.IfcTextFontName(v);
  },
  296282323: function _(v) {
    return new IFC4.IfcTextTransformation(v);
  },
  232962298: function _(v) {
    return new IFC4.IfcThermalAdmittanceMeasure(v);
  },
  2645777649: function _(v) {
    return new IFC4.IfcThermalConductivityMeasure(v);
  },
  2281867870: function _(v) {
    return new IFC4.IfcThermalExpansionCoefficientMeasure(v);
  },
  857959152: function _(v) {
    return new IFC4.IfcThermalResistanceMeasure(v);
  },
  2016195849: function _(v) {
    return new IFC4.IfcThermalTransmittanceMeasure(v);
  },
  743184107: function _(v) {
    return new IFC4.IfcThermodynamicTemperatureMeasure(v);
  },
  4075327185: function _(v) {
    return new IFC4.IfcTime(v);
  },
  2726807636: function _(v) {
    return new IFC4.IfcTimeMeasure(v);
  },
  2591213694: function _(v) {
    return new IFC4.IfcTimeStamp(v);
  },
  1278329552: function _(v) {
    return new IFC4.IfcTorqueMeasure(v);
  },
  950732822: function _(v) {
    return new IFC4.IfcURIReference(v);
  },
  3345633955: function _(v) {
    return new IFC4.IfcVaporPermeabilityMeasure(v);
  },
  3458127941: function _(v) {
    return new IFC4.IfcVolumeMeasure(v);
  },
  2593997549: function _(v) {
    return new IFC4.IfcVolumetricFlowRateMeasure(v);
  },
  51269191: function _(v) {
    return new IFC4.IfcWarpingConstantMeasure(v);
  },
  1718600412: function _(v) {
    return new IFC4.IfcWarpingMomentMeasure(v);
  }
};
var IFC4;

(function (IFC42) {
  var IfcAbsorbedDoseMeasure = function IfcAbsorbedDoseMeasure(value) {
    _classCallCheck2(this, IfcAbsorbedDoseMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcAbsorbedDoseMeasure = IfcAbsorbedDoseMeasure;

  var IfcAccelerationMeasure = function IfcAccelerationMeasure(value) {
    _classCallCheck2(this, IfcAccelerationMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcAccelerationMeasure = IfcAccelerationMeasure;

  var IfcAmountOfSubstanceMeasure = function IfcAmountOfSubstanceMeasure(value) {
    _classCallCheck2(this, IfcAmountOfSubstanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcAmountOfSubstanceMeasure = IfcAmountOfSubstanceMeasure;

  var IfcAngularVelocityMeasure = function IfcAngularVelocityMeasure(value) {
    _classCallCheck2(this, IfcAngularVelocityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcAngularVelocityMeasure = IfcAngularVelocityMeasure;

  var IfcArcIndex = function IfcArcIndex(value) {
    _classCallCheck2(this, IfcArcIndex);

    this.value = value;
  };

  IFC42.IfcArcIndex = IfcArcIndex;

  var IfcAreaDensityMeasure = function IfcAreaDensityMeasure(value) {
    _classCallCheck2(this, IfcAreaDensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcAreaDensityMeasure = IfcAreaDensityMeasure;

  var IfcAreaMeasure = function IfcAreaMeasure(value) {
    _classCallCheck2(this, IfcAreaMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcAreaMeasure = IfcAreaMeasure;

  var IfcBinary = function IfcBinary(value) {
    _classCallCheck2(this, IfcBinary);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcBinary = IfcBinary;

  var IfcBoolean = function IfcBoolean(value) {
    _classCallCheck2(this, IfcBoolean);

    this.value = value;
    this.type = 3;
  };

  IFC42.IfcBoolean = IfcBoolean;

  var IfcBoxAlignment = function IfcBoxAlignment(value) {
    _classCallCheck2(this, IfcBoxAlignment);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcBoxAlignment = IfcBoxAlignment;

  var IfcCardinalPointReference = function IfcCardinalPointReference(value) {
    _classCallCheck2(this, IfcCardinalPointReference);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcCardinalPointReference = IfcCardinalPointReference;

  var IfcComplexNumber = function IfcComplexNumber(value) {
    _classCallCheck2(this, IfcComplexNumber);

    this.value = value;
  };

  IFC42.IfcComplexNumber = IfcComplexNumber;

  var IfcCompoundPlaneAngleMeasure = function IfcCompoundPlaneAngleMeasure(value) {
    _classCallCheck2(this, IfcCompoundPlaneAngleMeasure);

    this.value = value;
  };

  IFC42.IfcCompoundPlaneAngleMeasure = IfcCompoundPlaneAngleMeasure;

  var IfcContextDependentMeasure = function IfcContextDependentMeasure(value) {
    _classCallCheck2(this, IfcContextDependentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcContextDependentMeasure = IfcContextDependentMeasure;

  var IfcCountMeasure = function IfcCountMeasure(value) {
    _classCallCheck2(this, IfcCountMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcCountMeasure = IfcCountMeasure;

  var IfcCurvatureMeasure = function IfcCurvatureMeasure(value) {
    _classCallCheck2(this, IfcCurvatureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcCurvatureMeasure = IfcCurvatureMeasure;

  var IfcDate = function IfcDate(value) {
    _classCallCheck2(this, IfcDate);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcDate = IfcDate;

  var IfcDateTime = function IfcDateTime(value) {
    _classCallCheck2(this, IfcDateTime);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcDateTime = IfcDateTime;

  var IfcDayInMonthNumber = function IfcDayInMonthNumber(value) {
    _classCallCheck2(this, IfcDayInMonthNumber);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcDayInMonthNumber = IfcDayInMonthNumber;

  var IfcDayInWeekNumber = function IfcDayInWeekNumber(value) {
    _classCallCheck2(this, IfcDayInWeekNumber);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcDayInWeekNumber = IfcDayInWeekNumber;

  var IfcDescriptiveMeasure = function IfcDescriptiveMeasure(value) {
    _classCallCheck2(this, IfcDescriptiveMeasure);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcDescriptiveMeasure = IfcDescriptiveMeasure;

  var IfcDimensionCount = function IfcDimensionCount(value) {
    _classCallCheck2(this, IfcDimensionCount);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcDimensionCount = IfcDimensionCount;

  var IfcDoseEquivalentMeasure = function IfcDoseEquivalentMeasure(value) {
    _classCallCheck2(this, IfcDoseEquivalentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcDoseEquivalentMeasure = IfcDoseEquivalentMeasure;

  var IfcDuration = function IfcDuration(value) {
    _classCallCheck2(this, IfcDuration);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcDuration = IfcDuration;

  var IfcDynamicViscosityMeasure = function IfcDynamicViscosityMeasure(value) {
    _classCallCheck2(this, IfcDynamicViscosityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcDynamicViscosityMeasure = IfcDynamicViscosityMeasure;

  var IfcElectricCapacitanceMeasure = function IfcElectricCapacitanceMeasure(value) {
    _classCallCheck2(this, IfcElectricCapacitanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcElectricCapacitanceMeasure = IfcElectricCapacitanceMeasure;

  var IfcElectricChargeMeasure = function IfcElectricChargeMeasure(value) {
    _classCallCheck2(this, IfcElectricChargeMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcElectricChargeMeasure = IfcElectricChargeMeasure;

  var IfcElectricConductanceMeasure = function IfcElectricConductanceMeasure(value) {
    _classCallCheck2(this, IfcElectricConductanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcElectricConductanceMeasure = IfcElectricConductanceMeasure;

  var IfcElectricCurrentMeasure = function IfcElectricCurrentMeasure(value) {
    _classCallCheck2(this, IfcElectricCurrentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcElectricCurrentMeasure = IfcElectricCurrentMeasure;

  var IfcElectricResistanceMeasure = function IfcElectricResistanceMeasure(value) {
    _classCallCheck2(this, IfcElectricResistanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcElectricResistanceMeasure = IfcElectricResistanceMeasure;

  var IfcElectricVoltageMeasure = function IfcElectricVoltageMeasure(value) {
    _classCallCheck2(this, IfcElectricVoltageMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcElectricVoltageMeasure = IfcElectricVoltageMeasure;

  var IfcEnergyMeasure = function IfcEnergyMeasure(value) {
    _classCallCheck2(this, IfcEnergyMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcEnergyMeasure = IfcEnergyMeasure;

  var IfcFontStyle = function IfcFontStyle(value) {
    _classCallCheck2(this, IfcFontStyle);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcFontStyle = IfcFontStyle;

  var IfcFontVariant = function IfcFontVariant(value) {
    _classCallCheck2(this, IfcFontVariant);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcFontVariant = IfcFontVariant;

  var IfcFontWeight = function IfcFontWeight(value) {
    _classCallCheck2(this, IfcFontWeight);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcFontWeight = IfcFontWeight;

  var IfcForceMeasure = function IfcForceMeasure(value) {
    _classCallCheck2(this, IfcForceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcForceMeasure = IfcForceMeasure;

  var IfcFrequencyMeasure = function IfcFrequencyMeasure(value) {
    _classCallCheck2(this, IfcFrequencyMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcFrequencyMeasure = IfcFrequencyMeasure;

  var IfcGloballyUniqueId = function IfcGloballyUniqueId(value) {
    _classCallCheck2(this, IfcGloballyUniqueId);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcGloballyUniqueId = IfcGloballyUniqueId;

  var IfcHeatFluxDensityMeasure = function IfcHeatFluxDensityMeasure(value) {
    _classCallCheck2(this, IfcHeatFluxDensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcHeatFluxDensityMeasure = IfcHeatFluxDensityMeasure;

  var IfcHeatingValueMeasure = function IfcHeatingValueMeasure(value) {
    _classCallCheck2(this, IfcHeatingValueMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcHeatingValueMeasure = IfcHeatingValueMeasure;

  var IfcIdentifier = function IfcIdentifier(value) {
    _classCallCheck2(this, IfcIdentifier);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcIdentifier = IfcIdentifier;

  var IfcIlluminanceMeasure = function IfcIlluminanceMeasure(value) {
    _classCallCheck2(this, IfcIlluminanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcIlluminanceMeasure = IfcIlluminanceMeasure;

  var IfcInductanceMeasure = function IfcInductanceMeasure(value) {
    _classCallCheck2(this, IfcInductanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcInductanceMeasure = IfcInductanceMeasure;

  var IfcInteger = function IfcInteger(value) {
    _classCallCheck2(this, IfcInteger);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcInteger = IfcInteger;

  var IfcIntegerCountRateMeasure = function IfcIntegerCountRateMeasure(value) {
    _classCallCheck2(this, IfcIntegerCountRateMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcIntegerCountRateMeasure = IfcIntegerCountRateMeasure;

  var IfcIonConcentrationMeasure = function IfcIonConcentrationMeasure(value) {
    _classCallCheck2(this, IfcIonConcentrationMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcIonConcentrationMeasure = IfcIonConcentrationMeasure;

  var IfcIsothermalMoistureCapacityMeasure = function IfcIsothermalMoistureCapacityMeasure(value) {
    _classCallCheck2(this, IfcIsothermalMoistureCapacityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcIsothermalMoistureCapacityMeasure = IfcIsothermalMoistureCapacityMeasure;

  var IfcKinematicViscosityMeasure = function IfcKinematicViscosityMeasure(value) {
    _classCallCheck2(this, IfcKinematicViscosityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcKinematicViscosityMeasure = IfcKinematicViscosityMeasure;

  var IfcLabel = function IfcLabel(value) {
    _classCallCheck2(this, IfcLabel);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcLabel = IfcLabel;

  var IfcLanguageId = function IfcLanguageId(value) {
    _classCallCheck2(this, IfcLanguageId);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcLanguageId = IfcLanguageId;

  var IfcLengthMeasure = function IfcLengthMeasure(value) {
    _classCallCheck2(this, IfcLengthMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcLengthMeasure = IfcLengthMeasure;

  var IfcLineIndex = function IfcLineIndex(value) {
    _classCallCheck2(this, IfcLineIndex);

    this.value = value;
  };

  IFC42.IfcLineIndex = IfcLineIndex;

  var IfcLinearForceMeasure = function IfcLinearForceMeasure(value) {
    _classCallCheck2(this, IfcLinearForceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcLinearForceMeasure = IfcLinearForceMeasure;

  var IfcLinearMomentMeasure = function IfcLinearMomentMeasure(value) {
    _classCallCheck2(this, IfcLinearMomentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcLinearMomentMeasure = IfcLinearMomentMeasure;

  var IfcLinearStiffnessMeasure = function IfcLinearStiffnessMeasure(value) {
    _classCallCheck2(this, IfcLinearStiffnessMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcLinearStiffnessMeasure = IfcLinearStiffnessMeasure;

  var IfcLinearVelocityMeasure = function IfcLinearVelocityMeasure(value) {
    _classCallCheck2(this, IfcLinearVelocityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcLinearVelocityMeasure = IfcLinearVelocityMeasure;

  var IfcLogical = function IfcLogical(value) {
    _classCallCheck2(this, IfcLogical);

    this.value = value;
    this.type = 3;
  };

  IFC42.IfcLogical = IfcLogical;

  var IfcLuminousFluxMeasure = function IfcLuminousFluxMeasure(value) {
    _classCallCheck2(this, IfcLuminousFluxMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcLuminousFluxMeasure = IfcLuminousFluxMeasure;

  var IfcLuminousIntensityDistributionMeasure = function IfcLuminousIntensityDistributionMeasure(value) {
    _classCallCheck2(this, IfcLuminousIntensityDistributionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcLuminousIntensityDistributionMeasure = IfcLuminousIntensityDistributionMeasure;

  var IfcLuminousIntensityMeasure = function IfcLuminousIntensityMeasure(value) {
    _classCallCheck2(this, IfcLuminousIntensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcLuminousIntensityMeasure = IfcLuminousIntensityMeasure;

  var IfcMagneticFluxDensityMeasure = function IfcMagneticFluxDensityMeasure(value) {
    _classCallCheck2(this, IfcMagneticFluxDensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcMagneticFluxDensityMeasure = IfcMagneticFluxDensityMeasure;

  var IfcMagneticFluxMeasure = function IfcMagneticFluxMeasure(value) {
    _classCallCheck2(this, IfcMagneticFluxMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcMagneticFluxMeasure = IfcMagneticFluxMeasure;

  var IfcMassDensityMeasure = function IfcMassDensityMeasure(value) {
    _classCallCheck2(this, IfcMassDensityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcMassDensityMeasure = IfcMassDensityMeasure;

  var IfcMassFlowRateMeasure = function IfcMassFlowRateMeasure(value) {
    _classCallCheck2(this, IfcMassFlowRateMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcMassFlowRateMeasure = IfcMassFlowRateMeasure;

  var IfcMassMeasure = function IfcMassMeasure(value) {
    _classCallCheck2(this, IfcMassMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcMassMeasure = IfcMassMeasure;

  var IfcMassPerLengthMeasure = function IfcMassPerLengthMeasure(value) {
    _classCallCheck2(this, IfcMassPerLengthMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcMassPerLengthMeasure = IfcMassPerLengthMeasure;

  var IfcModulusOfElasticityMeasure = function IfcModulusOfElasticityMeasure(value) {
    _classCallCheck2(this, IfcModulusOfElasticityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcModulusOfElasticityMeasure = IfcModulusOfElasticityMeasure;

  var IfcModulusOfLinearSubgradeReactionMeasure = function IfcModulusOfLinearSubgradeReactionMeasure(value) {
    _classCallCheck2(this, IfcModulusOfLinearSubgradeReactionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcModulusOfLinearSubgradeReactionMeasure = IfcModulusOfLinearSubgradeReactionMeasure;

  var IfcModulusOfRotationalSubgradeReactionMeasure = function IfcModulusOfRotationalSubgradeReactionMeasure(value) {
    _classCallCheck2(this, IfcModulusOfRotationalSubgradeReactionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcModulusOfRotationalSubgradeReactionMeasure = IfcModulusOfRotationalSubgradeReactionMeasure;

  var IfcModulusOfSubgradeReactionMeasure = function IfcModulusOfSubgradeReactionMeasure(value) {
    _classCallCheck2(this, IfcModulusOfSubgradeReactionMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcModulusOfSubgradeReactionMeasure = IfcModulusOfSubgradeReactionMeasure;

  var IfcMoistureDiffusivityMeasure = function IfcMoistureDiffusivityMeasure(value) {
    _classCallCheck2(this, IfcMoistureDiffusivityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcMoistureDiffusivityMeasure = IfcMoistureDiffusivityMeasure;

  var IfcMolecularWeightMeasure = function IfcMolecularWeightMeasure(value) {
    _classCallCheck2(this, IfcMolecularWeightMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcMolecularWeightMeasure = IfcMolecularWeightMeasure;

  var IfcMomentOfInertiaMeasure = function IfcMomentOfInertiaMeasure(value) {
    _classCallCheck2(this, IfcMomentOfInertiaMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcMomentOfInertiaMeasure = IfcMomentOfInertiaMeasure;

  var IfcMonetaryMeasure = function IfcMonetaryMeasure(value) {
    _classCallCheck2(this, IfcMonetaryMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcMonetaryMeasure = IfcMonetaryMeasure;

  var IfcMonthInYearNumber = function IfcMonthInYearNumber(value) {
    _classCallCheck2(this, IfcMonthInYearNumber);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcMonthInYearNumber = IfcMonthInYearNumber;

  var IfcNonNegativeLengthMeasure = function IfcNonNegativeLengthMeasure(value) {
    _classCallCheck2(this, IfcNonNegativeLengthMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcNonNegativeLengthMeasure = IfcNonNegativeLengthMeasure;

  var IfcNormalisedRatioMeasure = function IfcNormalisedRatioMeasure(value) {
    _classCallCheck2(this, IfcNormalisedRatioMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcNormalisedRatioMeasure = IfcNormalisedRatioMeasure;

  var IfcNumericMeasure = function IfcNumericMeasure(value) {
    _classCallCheck2(this, IfcNumericMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcNumericMeasure = IfcNumericMeasure;

  var IfcPHMeasure = function IfcPHMeasure(value) {
    _classCallCheck2(this, IfcPHMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcPHMeasure = IfcPHMeasure;

  var IfcParameterValue = function IfcParameterValue(value) {
    _classCallCheck2(this, IfcParameterValue);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcParameterValue = IfcParameterValue;

  var IfcPlanarForceMeasure = function IfcPlanarForceMeasure(value) {
    _classCallCheck2(this, IfcPlanarForceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcPlanarForceMeasure = IfcPlanarForceMeasure;

  var IfcPlaneAngleMeasure = function IfcPlaneAngleMeasure(value) {
    _classCallCheck2(this, IfcPlaneAngleMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcPlaneAngleMeasure = IfcPlaneAngleMeasure;

  var IfcPositiveInteger = function IfcPositiveInteger(value) {
    _classCallCheck2(this, IfcPositiveInteger);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcPositiveInteger = IfcPositiveInteger;

  var IfcPositiveLengthMeasure = function IfcPositiveLengthMeasure(value) {
    _classCallCheck2(this, IfcPositiveLengthMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcPositiveLengthMeasure = IfcPositiveLengthMeasure;

  var IfcPositivePlaneAngleMeasure = function IfcPositivePlaneAngleMeasure(value) {
    _classCallCheck2(this, IfcPositivePlaneAngleMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcPositivePlaneAngleMeasure = IfcPositivePlaneAngleMeasure;

  var IfcPositiveRatioMeasure = function IfcPositiveRatioMeasure(value) {
    _classCallCheck2(this, IfcPositiveRatioMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcPositiveRatioMeasure = IfcPositiveRatioMeasure;

  var IfcPowerMeasure = function IfcPowerMeasure(value) {
    _classCallCheck2(this, IfcPowerMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcPowerMeasure = IfcPowerMeasure;

  var IfcPresentableText = function IfcPresentableText(value) {
    _classCallCheck2(this, IfcPresentableText);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcPresentableText = IfcPresentableText;

  var IfcPressureMeasure = function IfcPressureMeasure(value) {
    _classCallCheck2(this, IfcPressureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcPressureMeasure = IfcPressureMeasure;

  var IfcPropertySetDefinitionSet = function IfcPropertySetDefinitionSet(value) {
    _classCallCheck2(this, IfcPropertySetDefinitionSet);

    this.value = value;
  };

  IFC42.IfcPropertySetDefinitionSet = IfcPropertySetDefinitionSet;

  var IfcRadioActivityMeasure = function IfcRadioActivityMeasure(value) {
    _classCallCheck2(this, IfcRadioActivityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcRadioActivityMeasure = IfcRadioActivityMeasure;

  var IfcRatioMeasure = function IfcRatioMeasure(value) {
    _classCallCheck2(this, IfcRatioMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcRatioMeasure = IfcRatioMeasure;

  var IfcReal = function IfcReal(value) {
    _classCallCheck2(this, IfcReal);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcReal = IfcReal;

  var IfcRotationalFrequencyMeasure = function IfcRotationalFrequencyMeasure(value) {
    _classCallCheck2(this, IfcRotationalFrequencyMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcRotationalFrequencyMeasure = IfcRotationalFrequencyMeasure;

  var IfcRotationalMassMeasure = function IfcRotationalMassMeasure(value) {
    _classCallCheck2(this, IfcRotationalMassMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcRotationalMassMeasure = IfcRotationalMassMeasure;

  var IfcRotationalStiffnessMeasure = function IfcRotationalStiffnessMeasure(value) {
    _classCallCheck2(this, IfcRotationalStiffnessMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcRotationalStiffnessMeasure = IfcRotationalStiffnessMeasure;

  var IfcSectionModulusMeasure = function IfcSectionModulusMeasure(value) {
    _classCallCheck2(this, IfcSectionModulusMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcSectionModulusMeasure = IfcSectionModulusMeasure;

  var IfcSectionalAreaIntegralMeasure = function IfcSectionalAreaIntegralMeasure(value) {
    _classCallCheck2(this, IfcSectionalAreaIntegralMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcSectionalAreaIntegralMeasure = IfcSectionalAreaIntegralMeasure;

  var IfcShearModulusMeasure = function IfcShearModulusMeasure(value) {
    _classCallCheck2(this, IfcShearModulusMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcShearModulusMeasure = IfcShearModulusMeasure;

  var IfcSolidAngleMeasure = function IfcSolidAngleMeasure(value) {
    _classCallCheck2(this, IfcSolidAngleMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcSolidAngleMeasure = IfcSolidAngleMeasure;

  var IfcSoundPowerLevelMeasure = function IfcSoundPowerLevelMeasure(value) {
    _classCallCheck2(this, IfcSoundPowerLevelMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcSoundPowerLevelMeasure = IfcSoundPowerLevelMeasure;

  var IfcSoundPowerMeasure = function IfcSoundPowerMeasure(value) {
    _classCallCheck2(this, IfcSoundPowerMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcSoundPowerMeasure = IfcSoundPowerMeasure;

  var IfcSoundPressureLevelMeasure = function IfcSoundPressureLevelMeasure(value) {
    _classCallCheck2(this, IfcSoundPressureLevelMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcSoundPressureLevelMeasure = IfcSoundPressureLevelMeasure;

  var IfcSoundPressureMeasure = function IfcSoundPressureMeasure(value) {
    _classCallCheck2(this, IfcSoundPressureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcSoundPressureMeasure = IfcSoundPressureMeasure;

  var IfcSpecificHeatCapacityMeasure = function IfcSpecificHeatCapacityMeasure(value) {
    _classCallCheck2(this, IfcSpecificHeatCapacityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcSpecificHeatCapacityMeasure = IfcSpecificHeatCapacityMeasure;

  var IfcSpecularExponent = function IfcSpecularExponent(value) {
    _classCallCheck2(this, IfcSpecularExponent);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcSpecularExponent = IfcSpecularExponent;

  var IfcSpecularRoughness = function IfcSpecularRoughness(value) {
    _classCallCheck2(this, IfcSpecularRoughness);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcSpecularRoughness = IfcSpecularRoughness;

  var IfcTemperatureGradientMeasure = function IfcTemperatureGradientMeasure(value) {
    _classCallCheck2(this, IfcTemperatureGradientMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcTemperatureGradientMeasure = IfcTemperatureGradientMeasure;

  var IfcTemperatureRateOfChangeMeasure = function IfcTemperatureRateOfChangeMeasure(value) {
    _classCallCheck2(this, IfcTemperatureRateOfChangeMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcTemperatureRateOfChangeMeasure = IfcTemperatureRateOfChangeMeasure;

  var IfcText = function IfcText(value) {
    _classCallCheck2(this, IfcText);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcText = IfcText;

  var IfcTextAlignment = function IfcTextAlignment(value) {
    _classCallCheck2(this, IfcTextAlignment);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcTextAlignment = IfcTextAlignment;

  var IfcTextDecoration = function IfcTextDecoration(value) {
    _classCallCheck2(this, IfcTextDecoration);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcTextDecoration = IfcTextDecoration;

  var IfcTextFontName = function IfcTextFontName(value) {
    _classCallCheck2(this, IfcTextFontName);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcTextFontName = IfcTextFontName;

  var IfcTextTransformation = function IfcTextTransformation(value) {
    _classCallCheck2(this, IfcTextTransformation);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcTextTransformation = IfcTextTransformation;

  var IfcThermalAdmittanceMeasure = function IfcThermalAdmittanceMeasure(value) {
    _classCallCheck2(this, IfcThermalAdmittanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcThermalAdmittanceMeasure = IfcThermalAdmittanceMeasure;

  var IfcThermalConductivityMeasure = function IfcThermalConductivityMeasure(value) {
    _classCallCheck2(this, IfcThermalConductivityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcThermalConductivityMeasure = IfcThermalConductivityMeasure;

  var IfcThermalExpansionCoefficientMeasure = function IfcThermalExpansionCoefficientMeasure(value) {
    _classCallCheck2(this, IfcThermalExpansionCoefficientMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcThermalExpansionCoefficientMeasure = IfcThermalExpansionCoefficientMeasure;

  var IfcThermalResistanceMeasure = function IfcThermalResistanceMeasure(value) {
    _classCallCheck2(this, IfcThermalResistanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcThermalResistanceMeasure = IfcThermalResistanceMeasure;

  var IfcThermalTransmittanceMeasure = function IfcThermalTransmittanceMeasure(value) {
    _classCallCheck2(this, IfcThermalTransmittanceMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcThermalTransmittanceMeasure = IfcThermalTransmittanceMeasure;

  var IfcThermodynamicTemperatureMeasure = function IfcThermodynamicTemperatureMeasure(value) {
    _classCallCheck2(this, IfcThermodynamicTemperatureMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcThermodynamicTemperatureMeasure = IfcThermodynamicTemperatureMeasure;

  var IfcTime = function IfcTime(value) {
    _classCallCheck2(this, IfcTime);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcTime = IfcTime;

  var IfcTimeMeasure = function IfcTimeMeasure(value) {
    _classCallCheck2(this, IfcTimeMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcTimeMeasure = IfcTimeMeasure;

  var IfcTimeStamp = function IfcTimeStamp(value) {
    _classCallCheck2(this, IfcTimeStamp);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcTimeStamp = IfcTimeStamp;

  var IfcTorqueMeasure = function IfcTorqueMeasure(value) {
    _classCallCheck2(this, IfcTorqueMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcTorqueMeasure = IfcTorqueMeasure;

  var IfcURIReference = function IfcURIReference(value) {
    _classCallCheck2(this, IfcURIReference);

    this.value = value;
    this.type = 1;
  };

  IFC42.IfcURIReference = IfcURIReference;

  var IfcVaporPermeabilityMeasure = function IfcVaporPermeabilityMeasure(value) {
    _classCallCheck2(this, IfcVaporPermeabilityMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcVaporPermeabilityMeasure = IfcVaporPermeabilityMeasure;

  var IfcVolumeMeasure = function IfcVolumeMeasure(value) {
    _classCallCheck2(this, IfcVolumeMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcVolumeMeasure = IfcVolumeMeasure;

  var IfcVolumetricFlowRateMeasure = function IfcVolumetricFlowRateMeasure(value) {
    _classCallCheck2(this, IfcVolumetricFlowRateMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcVolumetricFlowRateMeasure = IfcVolumetricFlowRateMeasure;

  var IfcWarpingConstantMeasure = function IfcWarpingConstantMeasure(value) {
    _classCallCheck2(this, IfcWarpingConstantMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcWarpingConstantMeasure = IfcWarpingConstantMeasure;

  var IfcWarpingMomentMeasure = function IfcWarpingMomentMeasure(value) {
    _classCallCheck2(this, IfcWarpingMomentMeasure);

    this.value = value;
    this.type = 4;
  };

  IFC42.IfcWarpingMomentMeasure = IfcWarpingMomentMeasure;

  var IfcActionRequestTypeEnum = function IfcActionRequestTypeEnum() {
    _classCallCheck2(this, IfcActionRequestTypeEnum);
  };

  IfcActionRequestTypeEnum.EMAIL = {
    type: 3,
    value: "EMAIL"
  };
  IfcActionRequestTypeEnum.FAX = {
    type: 3,
    value: "FAX"
  };
  IfcActionRequestTypeEnum.PHONE = {
    type: 3,
    value: "PHONE"
  };
  IfcActionRequestTypeEnum.POST = {
    type: 3,
    value: "POST"
  };
  IfcActionRequestTypeEnum.VERBAL = {
    type: 3,
    value: "VERBAL"
  };
  IfcActionRequestTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcActionRequestTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcActionRequestTypeEnum = IfcActionRequestTypeEnum;

  var IfcActionSourceTypeEnum = function IfcActionSourceTypeEnum() {
    _classCallCheck2(this, IfcActionSourceTypeEnum);
  };

  IfcActionSourceTypeEnum.DEAD_LOAD_G = {
    type: 3,
    value: "DEAD_LOAD_G"
  };
  IfcActionSourceTypeEnum.COMPLETION_G1 = {
    type: 3,
    value: "COMPLETION_G1"
  };
  IfcActionSourceTypeEnum.LIVE_LOAD_Q = {
    type: 3,
    value: "LIVE_LOAD_Q"
  };
  IfcActionSourceTypeEnum.SNOW_S = {
    type: 3,
    value: "SNOW_S"
  };
  IfcActionSourceTypeEnum.WIND_W = {
    type: 3,
    value: "WIND_W"
  };
  IfcActionSourceTypeEnum.PRESTRESSING_P = {
    type: 3,
    value: "PRESTRESSING_P"
  };
  IfcActionSourceTypeEnum.SETTLEMENT_U = {
    type: 3,
    value: "SETTLEMENT_U"
  };
  IfcActionSourceTypeEnum.TEMPERATURE_T = {
    type: 3,
    value: "TEMPERATURE_T"
  };
  IfcActionSourceTypeEnum.EARTHQUAKE_E = {
    type: 3,
    value: "EARTHQUAKE_E"
  };
  IfcActionSourceTypeEnum.FIRE = {
    type: 3,
    value: "FIRE"
  };
  IfcActionSourceTypeEnum.IMPULSE = {
    type: 3,
    value: "IMPULSE"
  };
  IfcActionSourceTypeEnum.IMPACT = {
    type: 3,
    value: "IMPACT"
  };
  IfcActionSourceTypeEnum.TRANSPORT = {
    type: 3,
    value: "TRANSPORT"
  };
  IfcActionSourceTypeEnum.ERECTION = {
    type: 3,
    value: "ERECTION"
  };
  IfcActionSourceTypeEnum.PROPPING = {
    type: 3,
    value: "PROPPING"
  };
  IfcActionSourceTypeEnum.SYSTEM_IMPERFECTION = {
    type: 3,
    value: "SYSTEM_IMPERFECTION"
  };
  IfcActionSourceTypeEnum.SHRINKAGE = {
    type: 3,
    value: "SHRINKAGE"
  };
  IfcActionSourceTypeEnum.CREEP = {
    type: 3,
    value: "CREEP"
  };
  IfcActionSourceTypeEnum.LACK_OF_FIT = {
    type: 3,
    value: "LACK_OF_FIT"
  };
  IfcActionSourceTypeEnum.BUOYANCY = {
    type: 3,
    value: "BUOYANCY"
  };
  IfcActionSourceTypeEnum.ICE = {
    type: 3,
    value: "ICE"
  };
  IfcActionSourceTypeEnum.CURRENT = {
    type: 3,
    value: "CURRENT"
  };
  IfcActionSourceTypeEnum.WAVE = {
    type: 3,
    value: "WAVE"
  };
  IfcActionSourceTypeEnum.RAIN = {
    type: 3,
    value: "RAIN"
  };
  IfcActionSourceTypeEnum.BRAKES = {
    type: 3,
    value: "BRAKES"
  };
  IfcActionSourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcActionSourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcActionSourceTypeEnum = IfcActionSourceTypeEnum;

  var IfcActionTypeEnum = function IfcActionTypeEnum() {
    _classCallCheck2(this, IfcActionTypeEnum);
  };

  IfcActionTypeEnum.PERMANENT_G = {
    type: 3,
    value: "PERMANENT_G"
  };
  IfcActionTypeEnum.VARIABLE_Q = {
    type: 3,
    value: "VARIABLE_Q"
  };
  IfcActionTypeEnum.EXTRAORDINARY_A = {
    type: 3,
    value: "EXTRAORDINARY_A"
  };
  IfcActionTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcActionTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcActionTypeEnum = IfcActionTypeEnum;

  var IfcActuatorTypeEnum = function IfcActuatorTypeEnum() {
    _classCallCheck2(this, IfcActuatorTypeEnum);
  };

  IfcActuatorTypeEnum.ELECTRICACTUATOR = {
    type: 3,
    value: "ELECTRICACTUATOR"
  };
  IfcActuatorTypeEnum.HANDOPERATEDACTUATOR = {
    type: 3,
    value: "HANDOPERATEDACTUATOR"
  };
  IfcActuatorTypeEnum.HYDRAULICACTUATOR = {
    type: 3,
    value: "HYDRAULICACTUATOR"
  };
  IfcActuatorTypeEnum.PNEUMATICACTUATOR = {
    type: 3,
    value: "PNEUMATICACTUATOR"
  };
  IfcActuatorTypeEnum.THERMOSTATICACTUATOR = {
    type: 3,
    value: "THERMOSTATICACTUATOR"
  };
  IfcActuatorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcActuatorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcActuatorTypeEnum = IfcActuatorTypeEnum;

  var IfcAddressTypeEnum = function IfcAddressTypeEnum() {
    _classCallCheck2(this, IfcAddressTypeEnum);
  };

  IfcAddressTypeEnum.OFFICE = {
    type: 3,
    value: "OFFICE"
  };
  IfcAddressTypeEnum.SITE = {
    type: 3,
    value: "SITE"
  };
  IfcAddressTypeEnum.HOME = {
    type: 3,
    value: "HOME"
  };
  IfcAddressTypeEnum.DISTRIBUTIONPOINT = {
    type: 3,
    value: "DISTRIBUTIONPOINT"
  };
  IfcAddressTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC42.IfcAddressTypeEnum = IfcAddressTypeEnum;

  var IfcAirTerminalBoxTypeEnum = function IfcAirTerminalBoxTypeEnum() {
    _classCallCheck2(this, IfcAirTerminalBoxTypeEnum);
  };

  IfcAirTerminalBoxTypeEnum.CONSTANTFLOW = {
    type: 3,
    value: "CONSTANTFLOW"
  };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREDEPENDANT = {
    type: 3,
    value: "VARIABLEFLOWPRESSUREDEPENDANT"
  };
  IfcAirTerminalBoxTypeEnum.VARIABLEFLOWPRESSUREINDEPENDANT = {
    type: 3,
    value: "VARIABLEFLOWPRESSUREINDEPENDANT"
  };
  IfcAirTerminalBoxTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAirTerminalBoxTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcAirTerminalBoxTypeEnum = IfcAirTerminalBoxTypeEnum;

  var IfcAirTerminalTypeEnum = function IfcAirTerminalTypeEnum() {
    _classCallCheck2(this, IfcAirTerminalTypeEnum);
  };

  IfcAirTerminalTypeEnum.DIFFUSER = {
    type: 3,
    value: "DIFFUSER"
  };
  IfcAirTerminalTypeEnum.GRILLE = {
    type: 3,
    value: "GRILLE"
  };
  IfcAirTerminalTypeEnum.LOUVRE = {
    type: 3,
    value: "LOUVRE"
  };
  IfcAirTerminalTypeEnum.REGISTER = {
    type: 3,
    value: "REGISTER"
  };
  IfcAirTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAirTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcAirTerminalTypeEnum = IfcAirTerminalTypeEnum;

  var IfcAirToAirHeatRecoveryTypeEnum = function IfcAirToAirHeatRecoveryTypeEnum() {
    _classCallCheck2(this, IfcAirToAirHeatRecoveryTypeEnum);
  };

  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECOUNTERFLOWEXCHANGER = {
    type: 3,
    value: "FIXEDPLATECOUNTERFLOWEXCHANGER"
  };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATECROSSFLOWEXCHANGER = {
    type: 3,
    value: "FIXEDPLATECROSSFLOWEXCHANGER"
  };
  IfcAirToAirHeatRecoveryTypeEnum.FIXEDPLATEPARALLELFLOWEXCHANGER = {
    type: 3,
    value: "FIXEDPLATEPARALLELFLOWEXCHANGER"
  };
  IfcAirToAirHeatRecoveryTypeEnum.ROTARYWHEEL = {
    type: 3,
    value: "ROTARYWHEEL"
  };
  IfcAirToAirHeatRecoveryTypeEnum.RUNAROUNDCOILLOOP = {
    type: 3,
    value: "RUNAROUNDCOILLOOP"
  };
  IfcAirToAirHeatRecoveryTypeEnum.HEATPIPE = {
    type: 3,
    value: "HEATPIPE"
  };
  IfcAirToAirHeatRecoveryTypeEnum.TWINTOWERENTHALPYRECOVERYLOOPS = {
    type: 3,
    value: "TWINTOWERENTHALPYRECOVERYLOOPS"
  };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONSEALEDTUBEHEATEXCHANGERS = {
    type: 3,
    value: "THERMOSIPHONSEALEDTUBEHEATEXCHANGERS"
  };
  IfcAirToAirHeatRecoveryTypeEnum.THERMOSIPHONCOILTYPEHEATEXCHANGERS = {
    type: 3,
    value: "THERMOSIPHONCOILTYPEHEATEXCHANGERS"
  };
  IfcAirToAirHeatRecoveryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAirToAirHeatRecoveryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcAirToAirHeatRecoveryTypeEnum = IfcAirToAirHeatRecoveryTypeEnum;

  var IfcAlarmTypeEnum = function IfcAlarmTypeEnum() {
    _classCallCheck2(this, IfcAlarmTypeEnum);
  };

  IfcAlarmTypeEnum.BELL = {
    type: 3,
    value: "BELL"
  };
  IfcAlarmTypeEnum.BREAKGLASSBUTTON = {
    type: 3,
    value: "BREAKGLASSBUTTON"
  };
  IfcAlarmTypeEnum.LIGHT = {
    type: 3,
    value: "LIGHT"
  };
  IfcAlarmTypeEnum.MANUALPULLBOX = {
    type: 3,
    value: "MANUALPULLBOX"
  };
  IfcAlarmTypeEnum.SIREN = {
    type: 3,
    value: "SIREN"
  };
  IfcAlarmTypeEnum.WHISTLE = {
    type: 3,
    value: "WHISTLE"
  };
  IfcAlarmTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAlarmTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcAlarmTypeEnum = IfcAlarmTypeEnum;

  var IfcAnalysisModelTypeEnum = function IfcAnalysisModelTypeEnum() {
    _classCallCheck2(this, IfcAnalysisModelTypeEnum);
  };

  IfcAnalysisModelTypeEnum.IN_PLANE_LOADING_2D = {
    type: 3,
    value: "IN_PLANE_LOADING_2D"
  };
  IfcAnalysisModelTypeEnum.OUT_PLANE_LOADING_2D = {
    type: 3,
    value: "OUT_PLANE_LOADING_2D"
  };
  IfcAnalysisModelTypeEnum.LOADING_3D = {
    type: 3,
    value: "LOADING_3D"
  };
  IfcAnalysisModelTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAnalysisModelTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcAnalysisModelTypeEnum = IfcAnalysisModelTypeEnum;

  var IfcAnalysisTheoryTypeEnum = function IfcAnalysisTheoryTypeEnum() {
    _classCallCheck2(this, IfcAnalysisTheoryTypeEnum);
  };

  IfcAnalysisTheoryTypeEnum.FIRST_ORDER_THEORY = {
    type: 3,
    value: "FIRST_ORDER_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.SECOND_ORDER_THEORY = {
    type: 3,
    value: "SECOND_ORDER_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.THIRD_ORDER_THEORY = {
    type: 3,
    value: "THIRD_ORDER_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.FULL_NONLINEAR_THEORY = {
    type: 3,
    value: "FULL_NONLINEAR_THEORY"
  };
  IfcAnalysisTheoryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAnalysisTheoryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcAnalysisTheoryTypeEnum = IfcAnalysisTheoryTypeEnum;

  var IfcArithmeticOperatorEnum = function IfcArithmeticOperatorEnum() {
    _classCallCheck2(this, IfcArithmeticOperatorEnum);
  };

  IfcArithmeticOperatorEnum.ADD = {
    type: 3,
    value: "ADD"
  };
  IfcArithmeticOperatorEnum.DIVIDE = {
    type: 3,
    value: "DIVIDE"
  };
  IfcArithmeticOperatorEnum.MULTIPLY = {
    type: 3,
    value: "MULTIPLY"
  };
  IfcArithmeticOperatorEnum.SUBTRACT = {
    type: 3,
    value: "SUBTRACT"
  };
  IFC42.IfcArithmeticOperatorEnum = IfcArithmeticOperatorEnum;

  var IfcAssemblyPlaceEnum = function IfcAssemblyPlaceEnum() {
    _classCallCheck2(this, IfcAssemblyPlaceEnum);
  };

  IfcAssemblyPlaceEnum.SITE = {
    type: 3,
    value: "SITE"
  };
  IfcAssemblyPlaceEnum.FACTORY = {
    type: 3,
    value: "FACTORY"
  };
  IfcAssemblyPlaceEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcAssemblyPlaceEnum = IfcAssemblyPlaceEnum;

  var IfcAudioVisualApplianceTypeEnum = function IfcAudioVisualApplianceTypeEnum() {
    _classCallCheck2(this, IfcAudioVisualApplianceTypeEnum);
  };

  IfcAudioVisualApplianceTypeEnum.AMPLIFIER = {
    type: 3,
    value: "AMPLIFIER"
  };
  IfcAudioVisualApplianceTypeEnum.CAMERA = {
    type: 3,
    value: "CAMERA"
  };
  IfcAudioVisualApplianceTypeEnum.DISPLAY = {
    type: 3,
    value: "DISPLAY"
  };
  IfcAudioVisualApplianceTypeEnum.MICROPHONE = {
    type: 3,
    value: "MICROPHONE"
  };
  IfcAudioVisualApplianceTypeEnum.PLAYER = {
    type: 3,
    value: "PLAYER"
  };
  IfcAudioVisualApplianceTypeEnum.PROJECTOR = {
    type: 3,
    value: "PROJECTOR"
  };
  IfcAudioVisualApplianceTypeEnum.RECEIVER = {
    type: 3,
    value: "RECEIVER"
  };
  IfcAudioVisualApplianceTypeEnum.SPEAKER = {
    type: 3,
    value: "SPEAKER"
  };
  IfcAudioVisualApplianceTypeEnum.SWITCHER = {
    type: 3,
    value: "SWITCHER"
  };
  IfcAudioVisualApplianceTypeEnum.TELEPHONE = {
    type: 3,
    value: "TELEPHONE"
  };
  IfcAudioVisualApplianceTypeEnum.TUNER = {
    type: 3,
    value: "TUNER"
  };
  IfcAudioVisualApplianceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcAudioVisualApplianceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcAudioVisualApplianceTypeEnum = IfcAudioVisualApplianceTypeEnum;

  var IfcBSplineCurveForm = function IfcBSplineCurveForm() {
    _classCallCheck2(this, IfcBSplineCurveForm);
  };

  IfcBSplineCurveForm.POLYLINE_FORM = {
    type: 3,
    value: "POLYLINE_FORM"
  };
  IfcBSplineCurveForm.CIRCULAR_ARC = {
    type: 3,
    value: "CIRCULAR_ARC"
  };
  IfcBSplineCurveForm.ELLIPTIC_ARC = {
    type: 3,
    value: "ELLIPTIC_ARC"
  };
  IfcBSplineCurveForm.PARABOLIC_ARC = {
    type: 3,
    value: "PARABOLIC_ARC"
  };
  IfcBSplineCurveForm.HYPERBOLIC_ARC = {
    type: 3,
    value: "HYPERBOLIC_ARC"
  };
  IfcBSplineCurveForm.UNSPECIFIED = {
    type: 3,
    value: "UNSPECIFIED"
  };
  IFC42.IfcBSplineCurveForm = IfcBSplineCurveForm;

  var IfcBSplineSurfaceForm = function IfcBSplineSurfaceForm() {
    _classCallCheck2(this, IfcBSplineSurfaceForm);
  };

  IfcBSplineSurfaceForm.PLANE_SURF = {
    type: 3,
    value: "PLANE_SURF"
  };
  IfcBSplineSurfaceForm.CYLINDRICAL_SURF = {
    type: 3,
    value: "CYLINDRICAL_SURF"
  };
  IfcBSplineSurfaceForm.CONICAL_SURF = {
    type: 3,
    value: "CONICAL_SURF"
  };
  IfcBSplineSurfaceForm.SPHERICAL_SURF = {
    type: 3,
    value: "SPHERICAL_SURF"
  };
  IfcBSplineSurfaceForm.TOROIDAL_SURF = {
    type: 3,
    value: "TOROIDAL_SURF"
  };
  IfcBSplineSurfaceForm.SURF_OF_REVOLUTION = {
    type: 3,
    value: "SURF_OF_REVOLUTION"
  };
  IfcBSplineSurfaceForm.RULED_SURF = {
    type: 3,
    value: "RULED_SURF"
  };
  IfcBSplineSurfaceForm.GENERALISED_CONE = {
    type: 3,
    value: "GENERALISED_CONE"
  };
  IfcBSplineSurfaceForm.QUADRIC_SURF = {
    type: 3,
    value: "QUADRIC_SURF"
  };
  IfcBSplineSurfaceForm.SURF_OF_LINEAR_EXTRUSION = {
    type: 3,
    value: "SURF_OF_LINEAR_EXTRUSION"
  };
  IfcBSplineSurfaceForm.UNSPECIFIED = {
    type: 3,
    value: "UNSPECIFIED"
  };
  IFC42.IfcBSplineSurfaceForm = IfcBSplineSurfaceForm;

  var IfcBeamTypeEnum = function IfcBeamTypeEnum() {
    _classCallCheck2(this, IfcBeamTypeEnum);
  };

  IfcBeamTypeEnum.BEAM = {
    type: 3,
    value: "BEAM"
  };
  IfcBeamTypeEnum.JOIST = {
    type: 3,
    value: "JOIST"
  };
  IfcBeamTypeEnum.HOLLOWCORE = {
    type: 3,
    value: "HOLLOWCORE"
  };
  IfcBeamTypeEnum.LINTEL = {
    type: 3,
    value: "LINTEL"
  };
  IfcBeamTypeEnum.SPANDREL = {
    type: 3,
    value: "SPANDREL"
  };
  IfcBeamTypeEnum.T_BEAM = {
    type: 3,
    value: "T_BEAM"
  };
  IfcBeamTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBeamTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcBeamTypeEnum = IfcBeamTypeEnum;

  var IfcBenchmarkEnum = function IfcBenchmarkEnum() {
    _classCallCheck2(this, IfcBenchmarkEnum);
  };

  IfcBenchmarkEnum.GREATERTHAN = {
    type: 3,
    value: "GREATERTHAN"
  };
  IfcBenchmarkEnum.GREATERTHANOREQUALTO = {
    type: 3,
    value: "GREATERTHANOREQUALTO"
  };
  IfcBenchmarkEnum.LESSTHAN = {
    type: 3,
    value: "LESSTHAN"
  };
  IfcBenchmarkEnum.LESSTHANOREQUALTO = {
    type: 3,
    value: "LESSTHANOREQUALTO"
  };
  IfcBenchmarkEnum.EQUALTO = {
    type: 3,
    value: "EQUALTO"
  };
  IfcBenchmarkEnum.NOTEQUALTO = {
    type: 3,
    value: "NOTEQUALTO"
  };
  IfcBenchmarkEnum.INCLUDES = {
    type: 3,
    value: "INCLUDES"
  };
  IfcBenchmarkEnum.NOTINCLUDES = {
    type: 3,
    value: "NOTINCLUDES"
  };
  IfcBenchmarkEnum.INCLUDEDIN = {
    type: 3,
    value: "INCLUDEDIN"
  };
  IfcBenchmarkEnum.NOTINCLUDEDIN = {
    type: 3,
    value: "NOTINCLUDEDIN"
  };
  IFC42.IfcBenchmarkEnum = IfcBenchmarkEnum;

  var IfcBoilerTypeEnum = function IfcBoilerTypeEnum() {
    _classCallCheck2(this, IfcBoilerTypeEnum);
  };

  IfcBoilerTypeEnum.WATER = {
    type: 3,
    value: "WATER"
  };
  IfcBoilerTypeEnum.STEAM = {
    type: 3,
    value: "STEAM"
  };
  IfcBoilerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBoilerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcBoilerTypeEnum = IfcBoilerTypeEnum;

  var IfcBooleanOperator = function IfcBooleanOperator() {
    _classCallCheck2(this, IfcBooleanOperator);
  };

  IfcBooleanOperator.UNION = {
    type: 3,
    value: "UNION"
  };
  IfcBooleanOperator.INTERSECTION = {
    type: 3,
    value: "INTERSECTION"
  };
  IfcBooleanOperator.DIFFERENCE = {
    type: 3,
    value: "DIFFERENCE"
  };
  IFC42.IfcBooleanOperator = IfcBooleanOperator;

  var IfcBuildingElementPartTypeEnum = function IfcBuildingElementPartTypeEnum() {
    _classCallCheck2(this, IfcBuildingElementPartTypeEnum);
  };

  IfcBuildingElementPartTypeEnum.INSULATION = {
    type: 3,
    value: "INSULATION"
  };
  IfcBuildingElementPartTypeEnum.PRECASTPANEL = {
    type: 3,
    value: "PRECASTPANEL"
  };
  IfcBuildingElementPartTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBuildingElementPartTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcBuildingElementPartTypeEnum = IfcBuildingElementPartTypeEnum;

  var IfcBuildingElementProxyTypeEnum = function IfcBuildingElementProxyTypeEnum() {
    _classCallCheck2(this, IfcBuildingElementProxyTypeEnum);
  };

  IfcBuildingElementProxyTypeEnum.COMPLEX = {
    type: 3,
    value: "COMPLEX"
  };
  IfcBuildingElementProxyTypeEnum.ELEMENT = {
    type: 3,
    value: "ELEMENT"
  };
  IfcBuildingElementProxyTypeEnum.PARTIAL = {
    type: 3,
    value: "PARTIAL"
  };
  IfcBuildingElementProxyTypeEnum.PROVISIONFORVOID = {
    type: 3,
    value: "PROVISIONFORVOID"
  };
  IfcBuildingElementProxyTypeEnum.PROVISIONFORSPACE = {
    type: 3,
    value: "PROVISIONFORSPACE"
  };
  IfcBuildingElementProxyTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBuildingElementProxyTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcBuildingElementProxyTypeEnum = IfcBuildingElementProxyTypeEnum;

  var IfcBuildingSystemTypeEnum = function IfcBuildingSystemTypeEnum() {
    _classCallCheck2(this, IfcBuildingSystemTypeEnum);
  };

  IfcBuildingSystemTypeEnum.FENESTRATION = {
    type: 3,
    value: "FENESTRATION"
  };
  IfcBuildingSystemTypeEnum.FOUNDATION = {
    type: 3,
    value: "FOUNDATION"
  };
  IfcBuildingSystemTypeEnum.LOADBEARING = {
    type: 3,
    value: "LOADBEARING"
  };
  IfcBuildingSystemTypeEnum.OUTERSHELL = {
    type: 3,
    value: "OUTERSHELL"
  };
  IfcBuildingSystemTypeEnum.SHADING = {
    type: 3,
    value: "SHADING"
  };
  IfcBuildingSystemTypeEnum.TRANSPORT = {
    type: 3,
    value: "TRANSPORT"
  };
  IfcBuildingSystemTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBuildingSystemTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcBuildingSystemTypeEnum = IfcBuildingSystemTypeEnum;

  var IfcBurnerTypeEnum = function IfcBurnerTypeEnum() {
    _classCallCheck2(this, IfcBurnerTypeEnum);
  };

  IfcBurnerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcBurnerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcBurnerTypeEnum = IfcBurnerTypeEnum;

  var IfcCableCarrierFittingTypeEnum = function IfcCableCarrierFittingTypeEnum() {
    _classCallCheck2(this, IfcCableCarrierFittingTypeEnum);
  };

  IfcCableCarrierFittingTypeEnum.BEND = {
    type: 3,
    value: "BEND"
  };
  IfcCableCarrierFittingTypeEnum.CROSS = {
    type: 3,
    value: "CROSS"
  };
  IfcCableCarrierFittingTypeEnum.REDUCER = {
    type: 3,
    value: "REDUCER"
  };
  IfcCableCarrierFittingTypeEnum.TEE = {
    type: 3,
    value: "TEE"
  };
  IfcCableCarrierFittingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCableCarrierFittingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCableCarrierFittingTypeEnum = IfcCableCarrierFittingTypeEnum;

  var IfcCableCarrierSegmentTypeEnum = function IfcCableCarrierSegmentTypeEnum() {
    _classCallCheck2(this, IfcCableCarrierSegmentTypeEnum);
  };

  IfcCableCarrierSegmentTypeEnum.CABLELADDERSEGMENT = {
    type: 3,
    value: "CABLELADDERSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.CABLETRAYSEGMENT = {
    type: 3,
    value: "CABLETRAYSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.CABLETRUNKINGSEGMENT = {
    type: 3,
    value: "CABLETRUNKINGSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.CONDUITSEGMENT = {
    type: 3,
    value: "CONDUITSEGMENT"
  };
  IfcCableCarrierSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCableCarrierSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCableCarrierSegmentTypeEnum = IfcCableCarrierSegmentTypeEnum;

  var IfcCableFittingTypeEnum = function IfcCableFittingTypeEnum() {
    _classCallCheck2(this, IfcCableFittingTypeEnum);
  };

  IfcCableFittingTypeEnum.CONNECTOR = {
    type: 3,
    value: "CONNECTOR"
  };
  IfcCableFittingTypeEnum.ENTRY = {
    type: 3,
    value: "ENTRY"
  };
  IfcCableFittingTypeEnum.EXIT = {
    type: 3,
    value: "EXIT"
  };
  IfcCableFittingTypeEnum.JUNCTION = {
    type: 3,
    value: "JUNCTION"
  };
  IfcCableFittingTypeEnum.TRANSITION = {
    type: 3,
    value: "TRANSITION"
  };
  IfcCableFittingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCableFittingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCableFittingTypeEnum = IfcCableFittingTypeEnum;

  var IfcCableSegmentTypeEnum = function IfcCableSegmentTypeEnum() {
    _classCallCheck2(this, IfcCableSegmentTypeEnum);
  };

  IfcCableSegmentTypeEnum.BUSBARSEGMENT = {
    type: 3,
    value: "BUSBARSEGMENT"
  };
  IfcCableSegmentTypeEnum.CABLESEGMENT = {
    type: 3,
    value: "CABLESEGMENT"
  };
  IfcCableSegmentTypeEnum.CONDUCTORSEGMENT = {
    type: 3,
    value: "CONDUCTORSEGMENT"
  };
  IfcCableSegmentTypeEnum.CORESEGMENT = {
    type: 3,
    value: "CORESEGMENT"
  };
  IfcCableSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCableSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCableSegmentTypeEnum = IfcCableSegmentTypeEnum;

  var IfcChangeActionEnum = function IfcChangeActionEnum() {
    _classCallCheck2(this, IfcChangeActionEnum);
  };

  IfcChangeActionEnum.NOCHANGE = {
    type: 3,
    value: "NOCHANGE"
  };
  IfcChangeActionEnum.MODIFIED = {
    type: 3,
    value: "MODIFIED"
  };
  IfcChangeActionEnum.ADDED = {
    type: 3,
    value: "ADDED"
  };
  IfcChangeActionEnum.DELETED = {
    type: 3,
    value: "DELETED"
  };
  IfcChangeActionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcChangeActionEnum = IfcChangeActionEnum;

  var IfcChillerTypeEnum = function IfcChillerTypeEnum() {
    _classCallCheck2(this, IfcChillerTypeEnum);
  };

  IfcChillerTypeEnum.AIRCOOLED = {
    type: 3,
    value: "AIRCOOLED"
  };
  IfcChillerTypeEnum.WATERCOOLED = {
    type: 3,
    value: "WATERCOOLED"
  };
  IfcChillerTypeEnum.HEATRECOVERY = {
    type: 3,
    value: "HEATRECOVERY"
  };
  IfcChillerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcChillerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcChillerTypeEnum = IfcChillerTypeEnum;

  var IfcChimneyTypeEnum = function IfcChimneyTypeEnum() {
    _classCallCheck2(this, IfcChimneyTypeEnum);
  };

  IfcChimneyTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcChimneyTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcChimneyTypeEnum = IfcChimneyTypeEnum;

  var IfcCoilTypeEnum = function IfcCoilTypeEnum() {
    _classCallCheck2(this, IfcCoilTypeEnum);
  };

  IfcCoilTypeEnum.DXCOOLINGCOIL = {
    type: 3,
    value: "DXCOOLINGCOIL"
  };
  IfcCoilTypeEnum.ELECTRICHEATINGCOIL = {
    type: 3,
    value: "ELECTRICHEATINGCOIL"
  };
  IfcCoilTypeEnum.GASHEATINGCOIL = {
    type: 3,
    value: "GASHEATINGCOIL"
  };
  IfcCoilTypeEnum.HYDRONICCOIL = {
    type: 3,
    value: "HYDRONICCOIL"
  };
  IfcCoilTypeEnum.STEAMHEATINGCOIL = {
    type: 3,
    value: "STEAMHEATINGCOIL"
  };
  IfcCoilTypeEnum.WATERCOOLINGCOIL = {
    type: 3,
    value: "WATERCOOLINGCOIL"
  };
  IfcCoilTypeEnum.WATERHEATINGCOIL = {
    type: 3,
    value: "WATERHEATINGCOIL"
  };
  IfcCoilTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCoilTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCoilTypeEnum = IfcCoilTypeEnum;

  var IfcColumnTypeEnum = function IfcColumnTypeEnum() {
    _classCallCheck2(this, IfcColumnTypeEnum);
  };

  IfcColumnTypeEnum.COLUMN = {
    type: 3,
    value: "COLUMN"
  };
  IfcColumnTypeEnum.PILASTER = {
    type: 3,
    value: "PILASTER"
  };
  IfcColumnTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcColumnTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcColumnTypeEnum = IfcColumnTypeEnum;

  var IfcCommunicationsApplianceTypeEnum = function IfcCommunicationsApplianceTypeEnum() {
    _classCallCheck2(this, IfcCommunicationsApplianceTypeEnum);
  };

  IfcCommunicationsApplianceTypeEnum.ANTENNA = {
    type: 3,
    value: "ANTENNA"
  };
  IfcCommunicationsApplianceTypeEnum.COMPUTER = {
    type: 3,
    value: "COMPUTER"
  };
  IfcCommunicationsApplianceTypeEnum.FAX = {
    type: 3,
    value: "FAX"
  };
  IfcCommunicationsApplianceTypeEnum.GATEWAY = {
    type: 3,
    value: "GATEWAY"
  };
  IfcCommunicationsApplianceTypeEnum.MODEM = {
    type: 3,
    value: "MODEM"
  };
  IfcCommunicationsApplianceTypeEnum.NETWORKAPPLIANCE = {
    type: 3,
    value: "NETWORKAPPLIANCE"
  };
  IfcCommunicationsApplianceTypeEnum.NETWORKBRIDGE = {
    type: 3,
    value: "NETWORKBRIDGE"
  };
  IfcCommunicationsApplianceTypeEnum.NETWORKHUB = {
    type: 3,
    value: "NETWORKHUB"
  };
  IfcCommunicationsApplianceTypeEnum.PRINTER = {
    type: 3,
    value: "PRINTER"
  };
  IfcCommunicationsApplianceTypeEnum.REPEATER = {
    type: 3,
    value: "REPEATER"
  };
  IfcCommunicationsApplianceTypeEnum.ROUTER = {
    type: 3,
    value: "ROUTER"
  };
  IfcCommunicationsApplianceTypeEnum.SCANNER = {
    type: 3,
    value: "SCANNER"
  };
  IfcCommunicationsApplianceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCommunicationsApplianceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCommunicationsApplianceTypeEnum = IfcCommunicationsApplianceTypeEnum;

  var IfcComplexPropertyTemplateTypeEnum = function IfcComplexPropertyTemplateTypeEnum() {
    _classCallCheck2(this, IfcComplexPropertyTemplateTypeEnum);
  };

  IfcComplexPropertyTemplateTypeEnum.P_COMPLEX = {
    type: 3,
    value: "P_COMPLEX"
  };
  IfcComplexPropertyTemplateTypeEnum.Q_COMPLEX = {
    type: 3,
    value: "Q_COMPLEX"
  };
  IFC42.IfcComplexPropertyTemplateTypeEnum = IfcComplexPropertyTemplateTypeEnum;

  var IfcCompressorTypeEnum = function IfcCompressorTypeEnum() {
    _classCallCheck2(this, IfcCompressorTypeEnum);
  };

  IfcCompressorTypeEnum.DYNAMIC = {
    type: 3,
    value: "DYNAMIC"
  };
  IfcCompressorTypeEnum.RECIPROCATING = {
    type: 3,
    value: "RECIPROCATING"
  };
  IfcCompressorTypeEnum.ROTARY = {
    type: 3,
    value: "ROTARY"
  };
  IfcCompressorTypeEnum.SCROLL = {
    type: 3,
    value: "SCROLL"
  };
  IfcCompressorTypeEnum.TROCHOIDAL = {
    type: 3,
    value: "TROCHOIDAL"
  };
  IfcCompressorTypeEnum.SINGLESTAGE = {
    type: 3,
    value: "SINGLESTAGE"
  };
  IfcCompressorTypeEnum.BOOSTER = {
    type: 3,
    value: "BOOSTER"
  };
  IfcCompressorTypeEnum.OPENTYPE = {
    type: 3,
    value: "OPENTYPE"
  };
  IfcCompressorTypeEnum.HERMETIC = {
    type: 3,
    value: "HERMETIC"
  };
  IfcCompressorTypeEnum.SEMIHERMETIC = {
    type: 3,
    value: "SEMIHERMETIC"
  };
  IfcCompressorTypeEnum.WELDEDSHELLHERMETIC = {
    type: 3,
    value: "WELDEDSHELLHERMETIC"
  };
  IfcCompressorTypeEnum.ROLLINGPISTON = {
    type: 3,
    value: "ROLLINGPISTON"
  };
  IfcCompressorTypeEnum.ROTARYVANE = {
    type: 3,
    value: "ROTARYVANE"
  };
  IfcCompressorTypeEnum.SINGLESCREW = {
    type: 3,
    value: "SINGLESCREW"
  };
  IfcCompressorTypeEnum.TWINSCREW = {
    type: 3,
    value: "TWINSCREW"
  };
  IfcCompressorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCompressorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCompressorTypeEnum = IfcCompressorTypeEnum;

  var IfcCondenserTypeEnum = function IfcCondenserTypeEnum() {
    _classCallCheck2(this, IfcCondenserTypeEnum);
  };

  IfcCondenserTypeEnum.AIRCOOLED = {
    type: 3,
    value: "AIRCOOLED"
  };
  IfcCondenserTypeEnum.EVAPORATIVECOOLED = {
    type: 3,
    value: "EVAPORATIVECOOLED"
  };
  IfcCondenserTypeEnum.WATERCOOLED = {
    type: 3,
    value: "WATERCOOLED"
  };
  IfcCondenserTypeEnum.WATERCOOLEDBRAZEDPLATE = {
    type: 3,
    value: "WATERCOOLEDBRAZEDPLATE"
  };
  IfcCondenserTypeEnum.WATERCOOLEDSHELLCOIL = {
    type: 3,
    value: "WATERCOOLEDSHELLCOIL"
  };
  IfcCondenserTypeEnum.WATERCOOLEDSHELLTUBE = {
    type: 3,
    value: "WATERCOOLEDSHELLTUBE"
  };
  IfcCondenserTypeEnum.WATERCOOLEDTUBEINTUBE = {
    type: 3,
    value: "WATERCOOLEDTUBEINTUBE"
  };
  IfcCondenserTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCondenserTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCondenserTypeEnum = IfcCondenserTypeEnum;

  var IfcConnectionTypeEnum = function IfcConnectionTypeEnum() {
    _classCallCheck2(this, IfcConnectionTypeEnum);
  };

  IfcConnectionTypeEnum.ATPATH = {
    type: 3,
    value: "ATPATH"
  };
  IfcConnectionTypeEnum.ATSTART = {
    type: 3,
    value: "ATSTART"
  };
  IfcConnectionTypeEnum.ATEND = {
    type: 3,
    value: "ATEND"
  };
  IfcConnectionTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcConnectionTypeEnum = IfcConnectionTypeEnum;

  var IfcConstraintEnum = function IfcConstraintEnum() {
    _classCallCheck2(this, IfcConstraintEnum);
  };

  IfcConstraintEnum.HARD = {
    type: 3,
    value: "HARD"
  };
  IfcConstraintEnum.SOFT = {
    type: 3,
    value: "SOFT"
  };
  IfcConstraintEnum.ADVISORY = {
    type: 3,
    value: "ADVISORY"
  };
  IfcConstraintEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcConstraintEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcConstraintEnum = IfcConstraintEnum;

  var IfcConstructionEquipmentResourceTypeEnum = function IfcConstructionEquipmentResourceTypeEnum() {
    _classCallCheck2(this, IfcConstructionEquipmentResourceTypeEnum);
  };

  IfcConstructionEquipmentResourceTypeEnum.DEMOLISHING = {
    type: 3,
    value: "DEMOLISHING"
  };
  IfcConstructionEquipmentResourceTypeEnum.EARTHMOVING = {
    type: 3,
    value: "EARTHMOVING"
  };
  IfcConstructionEquipmentResourceTypeEnum.ERECTING = {
    type: 3,
    value: "ERECTING"
  };
  IfcConstructionEquipmentResourceTypeEnum.HEATING = {
    type: 3,
    value: "HEATING"
  };
  IfcConstructionEquipmentResourceTypeEnum.LIGHTING = {
    type: 3,
    value: "LIGHTING"
  };
  IfcConstructionEquipmentResourceTypeEnum.PAVING = {
    type: 3,
    value: "PAVING"
  };
  IfcConstructionEquipmentResourceTypeEnum.PUMPING = {
    type: 3,
    value: "PUMPING"
  };
  IfcConstructionEquipmentResourceTypeEnum.TRANSPORTING = {
    type: 3,
    value: "TRANSPORTING"
  };
  IfcConstructionEquipmentResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcConstructionEquipmentResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcConstructionEquipmentResourceTypeEnum = IfcConstructionEquipmentResourceTypeEnum;

  var IfcConstructionMaterialResourceTypeEnum = function IfcConstructionMaterialResourceTypeEnum() {
    _classCallCheck2(this, IfcConstructionMaterialResourceTypeEnum);
  };

  IfcConstructionMaterialResourceTypeEnum.AGGREGATES = {
    type: 3,
    value: "AGGREGATES"
  };
  IfcConstructionMaterialResourceTypeEnum.CONCRETE = {
    type: 3,
    value: "CONCRETE"
  };
  IfcConstructionMaterialResourceTypeEnum.DRYWALL = {
    type: 3,
    value: "DRYWALL"
  };
  IfcConstructionMaterialResourceTypeEnum.FUEL = {
    type: 3,
    value: "FUEL"
  };
  IfcConstructionMaterialResourceTypeEnum.GYPSUM = {
    type: 3,
    value: "GYPSUM"
  };
  IfcConstructionMaterialResourceTypeEnum.MASONRY = {
    type: 3,
    value: "MASONRY"
  };
  IfcConstructionMaterialResourceTypeEnum.METAL = {
    type: 3,
    value: "METAL"
  };
  IfcConstructionMaterialResourceTypeEnum.PLASTIC = {
    type: 3,
    value: "PLASTIC"
  };
  IfcConstructionMaterialResourceTypeEnum.WOOD = {
    type: 3,
    value: "WOOD"
  };
  IfcConstructionMaterialResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IfcConstructionMaterialResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC42.IfcConstructionMaterialResourceTypeEnum = IfcConstructionMaterialResourceTypeEnum;

  var IfcConstructionProductResourceTypeEnum = function IfcConstructionProductResourceTypeEnum() {
    _classCallCheck2(this, IfcConstructionProductResourceTypeEnum);
  };

  IfcConstructionProductResourceTypeEnum.ASSEMBLY = {
    type: 3,
    value: "ASSEMBLY"
  };
  IfcConstructionProductResourceTypeEnum.FORMWORK = {
    type: 3,
    value: "FORMWORK"
  };
  IfcConstructionProductResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcConstructionProductResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcConstructionProductResourceTypeEnum = IfcConstructionProductResourceTypeEnum;

  var IfcControllerTypeEnum = function IfcControllerTypeEnum() {
    _classCallCheck2(this, IfcControllerTypeEnum);
  };

  IfcControllerTypeEnum.FLOATING = {
    type: 3,
    value: "FLOATING"
  };
  IfcControllerTypeEnum.PROGRAMMABLE = {
    type: 3,
    value: "PROGRAMMABLE"
  };
  IfcControllerTypeEnum.PROPORTIONAL = {
    type: 3,
    value: "PROPORTIONAL"
  };
  IfcControllerTypeEnum.MULTIPOSITION = {
    type: 3,
    value: "MULTIPOSITION"
  };
  IfcControllerTypeEnum.TWOPOSITION = {
    type: 3,
    value: "TWOPOSITION"
  };
  IfcControllerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcControllerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcControllerTypeEnum = IfcControllerTypeEnum;

  var IfcCooledBeamTypeEnum = function IfcCooledBeamTypeEnum() {
    _classCallCheck2(this, IfcCooledBeamTypeEnum);
  };

  IfcCooledBeamTypeEnum.ACTIVE = {
    type: 3,
    value: "ACTIVE"
  };
  IfcCooledBeamTypeEnum.PASSIVE = {
    type: 3,
    value: "PASSIVE"
  };
  IfcCooledBeamTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCooledBeamTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCooledBeamTypeEnum = IfcCooledBeamTypeEnum;

  var IfcCoolingTowerTypeEnum = function IfcCoolingTowerTypeEnum() {
    _classCallCheck2(this, IfcCoolingTowerTypeEnum);
  };

  IfcCoolingTowerTypeEnum.NATURALDRAFT = {
    type: 3,
    value: "NATURALDRAFT"
  };
  IfcCoolingTowerTypeEnum.MECHANICALINDUCEDDRAFT = {
    type: 3,
    value: "MECHANICALINDUCEDDRAFT"
  };
  IfcCoolingTowerTypeEnum.MECHANICALFORCEDDRAFT = {
    type: 3,
    value: "MECHANICALFORCEDDRAFT"
  };
  IfcCoolingTowerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCoolingTowerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCoolingTowerTypeEnum = IfcCoolingTowerTypeEnum;

  var IfcCostItemTypeEnum = function IfcCostItemTypeEnum() {
    _classCallCheck2(this, IfcCostItemTypeEnum);
  };

  IfcCostItemTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCostItemTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCostItemTypeEnum = IfcCostItemTypeEnum;

  var IfcCostScheduleTypeEnum = function IfcCostScheduleTypeEnum() {
    _classCallCheck2(this, IfcCostScheduleTypeEnum);
  };

  IfcCostScheduleTypeEnum.BUDGET = {
    type: 3,
    value: "BUDGET"
  };
  IfcCostScheduleTypeEnum.COSTPLAN = {
    type: 3,
    value: "COSTPLAN"
  };
  IfcCostScheduleTypeEnum.ESTIMATE = {
    type: 3,
    value: "ESTIMATE"
  };
  IfcCostScheduleTypeEnum.TENDER = {
    type: 3,
    value: "TENDER"
  };
  IfcCostScheduleTypeEnum.PRICEDBILLOFQUANTITIES = {
    type: 3,
    value: "PRICEDBILLOFQUANTITIES"
  };
  IfcCostScheduleTypeEnum.UNPRICEDBILLOFQUANTITIES = {
    type: 3,
    value: "UNPRICEDBILLOFQUANTITIES"
  };
  IfcCostScheduleTypeEnum.SCHEDULEOFRATES = {
    type: 3,
    value: "SCHEDULEOFRATES"
  };
  IfcCostScheduleTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCostScheduleTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCostScheduleTypeEnum = IfcCostScheduleTypeEnum;

  var IfcCoveringTypeEnum = function IfcCoveringTypeEnum() {
    _classCallCheck2(this, IfcCoveringTypeEnum);
  };

  IfcCoveringTypeEnum.CEILING = {
    type: 3,
    value: "CEILING"
  };
  IfcCoveringTypeEnum.FLOORING = {
    type: 3,
    value: "FLOORING"
  };
  IfcCoveringTypeEnum.CLADDING = {
    type: 3,
    value: "CLADDING"
  };
  IfcCoveringTypeEnum.ROOFING = {
    type: 3,
    value: "ROOFING"
  };
  IfcCoveringTypeEnum.MOLDING = {
    type: 3,
    value: "MOLDING"
  };
  IfcCoveringTypeEnum.SKIRTINGBOARD = {
    type: 3,
    value: "SKIRTINGBOARD"
  };
  IfcCoveringTypeEnum.INSULATION = {
    type: 3,
    value: "INSULATION"
  };
  IfcCoveringTypeEnum.MEMBRANE = {
    type: 3,
    value: "MEMBRANE"
  };
  IfcCoveringTypeEnum.SLEEVING = {
    type: 3,
    value: "SLEEVING"
  };
  IfcCoveringTypeEnum.WRAPPING = {
    type: 3,
    value: "WRAPPING"
  };
  IfcCoveringTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCoveringTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCoveringTypeEnum = IfcCoveringTypeEnum;

  var IfcCrewResourceTypeEnum = function IfcCrewResourceTypeEnum() {
    _classCallCheck2(this, IfcCrewResourceTypeEnum);
  };

  IfcCrewResourceTypeEnum.OFFICE = {
    type: 3,
    value: "OFFICE"
  };
  IfcCrewResourceTypeEnum.SITE = {
    type: 3,
    value: "SITE"
  };
  IfcCrewResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCrewResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCrewResourceTypeEnum = IfcCrewResourceTypeEnum;

  var IfcCurtainWallTypeEnum = function IfcCurtainWallTypeEnum() {
    _classCallCheck2(this, IfcCurtainWallTypeEnum);
  };

  IfcCurtainWallTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcCurtainWallTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCurtainWallTypeEnum = IfcCurtainWallTypeEnum;

  var IfcCurveInterpolationEnum = function IfcCurveInterpolationEnum() {
    _classCallCheck2(this, IfcCurveInterpolationEnum);
  };

  IfcCurveInterpolationEnum.LINEAR = {
    type: 3,
    value: "LINEAR"
  };
  IfcCurveInterpolationEnum.LOG_LINEAR = {
    type: 3,
    value: "LOG_LINEAR"
  };
  IfcCurveInterpolationEnum.LOG_LOG = {
    type: 3,
    value: "LOG_LOG"
  };
  IfcCurveInterpolationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcCurveInterpolationEnum = IfcCurveInterpolationEnum;

  var IfcDamperTypeEnum = function IfcDamperTypeEnum() {
    _classCallCheck2(this, IfcDamperTypeEnum);
  };

  IfcDamperTypeEnum.BACKDRAFTDAMPER = {
    type: 3,
    value: "BACKDRAFTDAMPER"
  };
  IfcDamperTypeEnum.BALANCINGDAMPER = {
    type: 3,
    value: "BALANCINGDAMPER"
  };
  IfcDamperTypeEnum.BLASTDAMPER = {
    type: 3,
    value: "BLASTDAMPER"
  };
  IfcDamperTypeEnum.CONTROLDAMPER = {
    type: 3,
    value: "CONTROLDAMPER"
  };
  IfcDamperTypeEnum.FIREDAMPER = {
    type: 3,
    value: "FIREDAMPER"
  };
  IfcDamperTypeEnum.FIRESMOKEDAMPER = {
    type: 3,
    value: "FIRESMOKEDAMPER"
  };
  IfcDamperTypeEnum.FUMEHOODEXHAUST = {
    type: 3,
    value: "FUMEHOODEXHAUST"
  };
  IfcDamperTypeEnum.GRAVITYDAMPER = {
    type: 3,
    value: "GRAVITYDAMPER"
  };
  IfcDamperTypeEnum.GRAVITYRELIEFDAMPER = {
    type: 3,
    value: "GRAVITYRELIEFDAMPER"
  };
  IfcDamperTypeEnum.RELIEFDAMPER = {
    type: 3,
    value: "RELIEFDAMPER"
  };
  IfcDamperTypeEnum.SMOKEDAMPER = {
    type: 3,
    value: "SMOKEDAMPER"
  };
  IfcDamperTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDamperTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDamperTypeEnum = IfcDamperTypeEnum;

  var IfcDataOriginEnum = function IfcDataOriginEnum() {
    _classCallCheck2(this, IfcDataOriginEnum);
  };

  IfcDataOriginEnum.MEASURED = {
    type: 3,
    value: "MEASURED"
  };
  IfcDataOriginEnum.PREDICTED = {
    type: 3,
    value: "PREDICTED"
  };
  IfcDataOriginEnum.SIMULATED = {
    type: 3,
    value: "SIMULATED"
  };
  IfcDataOriginEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDataOriginEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDataOriginEnum = IfcDataOriginEnum;

  var IfcDerivedUnitEnum = function IfcDerivedUnitEnum() {
    _classCallCheck2(this, IfcDerivedUnitEnum);
  };

  IfcDerivedUnitEnum.ANGULARVELOCITYUNIT = {
    type: 3,
    value: "ANGULARVELOCITYUNIT"
  };
  IfcDerivedUnitEnum.AREADENSITYUNIT = {
    type: 3,
    value: "AREADENSITYUNIT"
  };
  IfcDerivedUnitEnum.COMPOUNDPLANEANGLEUNIT = {
    type: 3,
    value: "COMPOUNDPLANEANGLEUNIT"
  };
  IfcDerivedUnitEnum.DYNAMICVISCOSITYUNIT = {
    type: 3,
    value: "DYNAMICVISCOSITYUNIT"
  };
  IfcDerivedUnitEnum.HEATFLUXDENSITYUNIT = {
    type: 3,
    value: "HEATFLUXDENSITYUNIT"
  };
  IfcDerivedUnitEnum.INTEGERCOUNTRATEUNIT = {
    type: 3,
    value: "INTEGERCOUNTRATEUNIT"
  };
  IfcDerivedUnitEnum.ISOTHERMALMOISTURECAPACITYUNIT = {
    type: 3,
    value: "ISOTHERMALMOISTURECAPACITYUNIT"
  };
  IfcDerivedUnitEnum.KINEMATICVISCOSITYUNIT = {
    type: 3,
    value: "KINEMATICVISCOSITYUNIT"
  };
  IfcDerivedUnitEnum.LINEARVELOCITYUNIT = {
    type: 3,
    value: "LINEARVELOCITYUNIT"
  };
  IfcDerivedUnitEnum.MASSDENSITYUNIT = {
    type: 3,
    value: "MASSDENSITYUNIT"
  };
  IfcDerivedUnitEnum.MASSFLOWRATEUNIT = {
    type: 3,
    value: "MASSFLOWRATEUNIT"
  };
  IfcDerivedUnitEnum.MOISTUREDIFFUSIVITYUNIT = {
    type: 3,
    value: "MOISTUREDIFFUSIVITYUNIT"
  };
  IfcDerivedUnitEnum.MOLECULARWEIGHTUNIT = {
    type: 3,
    value: "MOLECULARWEIGHTUNIT"
  };
  IfcDerivedUnitEnum.SPECIFICHEATCAPACITYUNIT = {
    type: 3,
    value: "SPECIFICHEATCAPACITYUNIT"
  };
  IfcDerivedUnitEnum.THERMALADMITTANCEUNIT = {
    type: 3,
    value: "THERMALADMITTANCEUNIT"
  };
  IfcDerivedUnitEnum.THERMALCONDUCTANCEUNIT = {
    type: 3,
    value: "THERMALCONDUCTANCEUNIT"
  };
  IfcDerivedUnitEnum.THERMALRESISTANCEUNIT = {
    type: 3,
    value: "THERMALRESISTANCEUNIT"
  };
  IfcDerivedUnitEnum.THERMALTRANSMITTANCEUNIT = {
    type: 3,
    value: "THERMALTRANSMITTANCEUNIT"
  };
  IfcDerivedUnitEnum.VAPORPERMEABILITYUNIT = {
    type: 3,
    value: "VAPORPERMEABILITYUNIT"
  };
  IfcDerivedUnitEnum.VOLUMETRICFLOWRATEUNIT = {
    type: 3,
    value: "VOLUMETRICFLOWRATEUNIT"
  };
  IfcDerivedUnitEnum.ROTATIONALFREQUENCYUNIT = {
    type: 3,
    value: "ROTATIONALFREQUENCYUNIT"
  };
  IfcDerivedUnitEnum.TORQUEUNIT = {
    type: 3,
    value: "TORQUEUNIT"
  };
  IfcDerivedUnitEnum.MOMENTOFINERTIAUNIT = {
    type: 3,
    value: "MOMENTOFINERTIAUNIT"
  };
  IfcDerivedUnitEnum.LINEARMOMENTUNIT = {
    type: 3,
    value: "LINEARMOMENTUNIT"
  };
  IfcDerivedUnitEnum.LINEARFORCEUNIT = {
    type: 3,
    value: "LINEARFORCEUNIT"
  };
  IfcDerivedUnitEnum.PLANARFORCEUNIT = {
    type: 3,
    value: "PLANARFORCEUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFELASTICITYUNIT = {
    type: 3,
    value: "MODULUSOFELASTICITYUNIT"
  };
  IfcDerivedUnitEnum.SHEARMODULUSUNIT = {
    type: 3,
    value: "SHEARMODULUSUNIT"
  };
  IfcDerivedUnitEnum.LINEARSTIFFNESSUNIT = {
    type: 3,
    value: "LINEARSTIFFNESSUNIT"
  };
  IfcDerivedUnitEnum.ROTATIONALSTIFFNESSUNIT = {
    type: 3,
    value: "ROTATIONALSTIFFNESSUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFSUBGRADEREACTIONUNIT = {
    type: 3,
    value: "MODULUSOFSUBGRADEREACTIONUNIT"
  };
  IfcDerivedUnitEnum.ACCELERATIONUNIT = {
    type: 3,
    value: "ACCELERATIONUNIT"
  };
  IfcDerivedUnitEnum.CURVATUREUNIT = {
    type: 3,
    value: "CURVATUREUNIT"
  };
  IfcDerivedUnitEnum.HEATINGVALUEUNIT = {
    type: 3,
    value: "HEATINGVALUEUNIT"
  };
  IfcDerivedUnitEnum.IONCONCENTRATIONUNIT = {
    type: 3,
    value: "IONCONCENTRATIONUNIT"
  };
  IfcDerivedUnitEnum.LUMINOUSINTENSITYDISTRIBUTIONUNIT = {
    type: 3,
    value: "LUMINOUSINTENSITYDISTRIBUTIONUNIT"
  };
  IfcDerivedUnitEnum.MASSPERLENGTHUNIT = {
    type: 3,
    value: "MASSPERLENGTHUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFLINEARSUBGRADEREACTIONUNIT = {
    type: 3,
    value: "MODULUSOFLINEARSUBGRADEREACTIONUNIT"
  };
  IfcDerivedUnitEnum.MODULUSOFROTATIONALSUBGRADEREACTIONUNIT = {
    type: 3,
    value: "MODULUSOFROTATIONALSUBGRADEREACTIONUNIT"
  };
  IfcDerivedUnitEnum.PHUNIT = {
    type: 3,
    value: "PHUNIT"
  };
  IfcDerivedUnitEnum.ROTATIONALMASSUNIT = {
    type: 3,
    value: "ROTATIONALMASSUNIT"
  };
  IfcDerivedUnitEnum.SECTIONAREAINTEGRALUNIT = {
    type: 3,
    value: "SECTIONAREAINTEGRALUNIT"
  };
  IfcDerivedUnitEnum.SECTIONMODULUSUNIT = {
    type: 3,
    value: "SECTIONMODULUSUNIT"
  };
  IfcDerivedUnitEnum.SOUNDPOWERLEVELUNIT = {
    type: 3,
    value: "SOUNDPOWERLEVELUNIT"
  };
  IfcDerivedUnitEnum.SOUNDPOWERUNIT = {
    type: 3,
    value: "SOUNDPOWERUNIT"
  };
  IfcDerivedUnitEnum.SOUNDPRESSURELEVELUNIT = {
    type: 3,
    value: "SOUNDPRESSURELEVELUNIT"
  };
  IfcDerivedUnitEnum.SOUNDPRESSUREUNIT = {
    type: 3,
    value: "SOUNDPRESSUREUNIT"
  };
  IfcDerivedUnitEnum.TEMPERATUREGRADIENTUNIT = {
    type: 3,
    value: "TEMPERATUREGRADIENTUNIT"
  };
  IfcDerivedUnitEnum.TEMPERATURERATEOFCHANGEUNIT = {
    type: 3,
    value: "TEMPERATURERATEOFCHANGEUNIT"
  };
  IfcDerivedUnitEnum.THERMALEXPANSIONCOEFFICIENTUNIT = {
    type: 3,
    value: "THERMALEXPANSIONCOEFFICIENTUNIT"
  };
  IfcDerivedUnitEnum.WARPINGCONSTANTUNIT = {
    type: 3,
    value: "WARPINGCONSTANTUNIT"
  };
  IfcDerivedUnitEnum.WARPINGMOMENTUNIT = {
    type: 3,
    value: "WARPINGMOMENTUNIT"
  };
  IfcDerivedUnitEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC42.IfcDerivedUnitEnum = IfcDerivedUnitEnum;

  var IfcDirectionSenseEnum = function IfcDirectionSenseEnum() {
    _classCallCheck2(this, IfcDirectionSenseEnum);
  };

  IfcDirectionSenseEnum.POSITIVE = {
    type: 3,
    value: "POSITIVE"
  };
  IfcDirectionSenseEnum.NEGATIVE = {
    type: 3,
    value: "NEGATIVE"
  };
  IFC42.IfcDirectionSenseEnum = IfcDirectionSenseEnum;

  var IfcDiscreteAccessoryTypeEnum = function IfcDiscreteAccessoryTypeEnum() {
    _classCallCheck2(this, IfcDiscreteAccessoryTypeEnum);
  };

  IfcDiscreteAccessoryTypeEnum.ANCHORPLATE = {
    type: 3,
    value: "ANCHORPLATE"
  };
  IfcDiscreteAccessoryTypeEnum.BRACKET = {
    type: 3,
    value: "BRACKET"
  };
  IfcDiscreteAccessoryTypeEnum.SHOE = {
    type: 3,
    value: "SHOE"
  };
  IfcDiscreteAccessoryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDiscreteAccessoryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDiscreteAccessoryTypeEnum = IfcDiscreteAccessoryTypeEnum;

  var IfcDistributionChamberElementTypeEnum = function IfcDistributionChamberElementTypeEnum() {
    _classCallCheck2(this, IfcDistributionChamberElementTypeEnum);
  };

  IfcDistributionChamberElementTypeEnum.FORMEDDUCT = {
    type: 3,
    value: "FORMEDDUCT"
  };
  IfcDistributionChamberElementTypeEnum.INSPECTIONCHAMBER = {
    type: 3,
    value: "INSPECTIONCHAMBER"
  };
  IfcDistributionChamberElementTypeEnum.INSPECTIONPIT = {
    type: 3,
    value: "INSPECTIONPIT"
  };
  IfcDistributionChamberElementTypeEnum.MANHOLE = {
    type: 3,
    value: "MANHOLE"
  };
  IfcDistributionChamberElementTypeEnum.METERCHAMBER = {
    type: 3,
    value: "METERCHAMBER"
  };
  IfcDistributionChamberElementTypeEnum.SUMP = {
    type: 3,
    value: "SUMP"
  };
  IfcDistributionChamberElementTypeEnum.TRENCH = {
    type: 3,
    value: "TRENCH"
  };
  IfcDistributionChamberElementTypeEnum.VALVECHAMBER = {
    type: 3,
    value: "VALVECHAMBER"
  };
  IfcDistributionChamberElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDistributionChamberElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDistributionChamberElementTypeEnum = IfcDistributionChamberElementTypeEnum;

  var IfcDistributionPortTypeEnum = function IfcDistributionPortTypeEnum() {
    _classCallCheck2(this, IfcDistributionPortTypeEnum);
  };

  IfcDistributionPortTypeEnum.CABLE = {
    type: 3,
    value: "CABLE"
  };
  IfcDistributionPortTypeEnum.CABLECARRIER = {
    type: 3,
    value: "CABLECARRIER"
  };
  IfcDistributionPortTypeEnum.DUCT = {
    type: 3,
    value: "DUCT"
  };
  IfcDistributionPortTypeEnum.PIPE = {
    type: 3,
    value: "PIPE"
  };
  IfcDistributionPortTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDistributionPortTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDistributionPortTypeEnum = IfcDistributionPortTypeEnum;

  var IfcDistributionSystemEnum = function IfcDistributionSystemEnum() {
    _classCallCheck2(this, IfcDistributionSystemEnum);
  };

  IfcDistributionSystemEnum.AIRCONDITIONING = {
    type: 3,
    value: "AIRCONDITIONING"
  };
  IfcDistributionSystemEnum.AUDIOVISUAL = {
    type: 3,
    value: "AUDIOVISUAL"
  };
  IfcDistributionSystemEnum.CHEMICAL = {
    type: 3,
    value: "CHEMICAL"
  };
  IfcDistributionSystemEnum.CHILLEDWATER = {
    type: 3,
    value: "CHILLEDWATER"
  };
  IfcDistributionSystemEnum.COMMUNICATION = {
    type: 3,
    value: "COMMUNICATION"
  };
  IfcDistributionSystemEnum.COMPRESSEDAIR = {
    type: 3,
    value: "COMPRESSEDAIR"
  };
  IfcDistributionSystemEnum.CONDENSERWATER = {
    type: 3,
    value: "CONDENSERWATER"
  };
  IfcDistributionSystemEnum.CONTROL = {
    type: 3,
    value: "CONTROL"
  };
  IfcDistributionSystemEnum.CONVEYING = {
    type: 3,
    value: "CONVEYING"
  };
  IfcDistributionSystemEnum.DATA = {
    type: 3,
    value: "DATA"
  };
  IfcDistributionSystemEnum.DISPOSAL = {
    type: 3,
    value: "DISPOSAL"
  };
  IfcDistributionSystemEnum.DOMESTICCOLDWATER = {
    type: 3,
    value: "DOMESTICCOLDWATER"
  };
  IfcDistributionSystemEnum.DOMESTICHOTWATER = {
    type: 3,
    value: "DOMESTICHOTWATER"
  };
  IfcDistributionSystemEnum.DRAINAGE = {
    type: 3,
    value: "DRAINAGE"
  };
  IfcDistributionSystemEnum.EARTHING = {
    type: 3,
    value: "EARTHING"
  };
  IfcDistributionSystemEnum.ELECTRICAL = {
    type: 3,
    value: "ELECTRICAL"
  };
  IfcDistributionSystemEnum.ELECTROACOUSTIC = {
    type: 3,
    value: "ELECTROACOUSTIC"
  };
  IfcDistributionSystemEnum.EXHAUST = {
    type: 3,
    value: "EXHAUST"
  };
  IfcDistributionSystemEnum.FIREPROTECTION = {
    type: 3,
    value: "FIREPROTECTION"
  };
  IfcDistributionSystemEnum.FUEL = {
    type: 3,
    value: "FUEL"
  };
  IfcDistributionSystemEnum.GAS = {
    type: 3,
    value: "GAS"
  };
  IfcDistributionSystemEnum.HAZARDOUS = {
    type: 3,
    value: "HAZARDOUS"
  };
  IfcDistributionSystemEnum.HEATING = {
    type: 3,
    value: "HEATING"
  };
  IfcDistributionSystemEnum.LIGHTING = {
    type: 3,
    value: "LIGHTING"
  };
  IfcDistributionSystemEnum.LIGHTNINGPROTECTION = {
    type: 3,
    value: "LIGHTNINGPROTECTION"
  };
  IfcDistributionSystemEnum.MUNICIPALSOLIDWASTE = {
    type: 3,
    value: "MUNICIPALSOLIDWASTE"
  };
  IfcDistributionSystemEnum.OIL = {
    type: 3,
    value: "OIL"
  };
  IfcDistributionSystemEnum.OPERATIONAL = {
    type: 3,
    value: "OPERATIONAL"
  };
  IfcDistributionSystemEnum.POWERGENERATION = {
    type: 3,
    value: "POWERGENERATION"
  };
  IfcDistributionSystemEnum.RAINWATER = {
    type: 3,
    value: "RAINWATER"
  };
  IfcDistributionSystemEnum.REFRIGERATION = {
    type: 3,
    value: "REFRIGERATION"
  };
  IfcDistributionSystemEnum.SECURITY = {
    type: 3,
    value: "SECURITY"
  };
  IfcDistributionSystemEnum.SEWAGE = {
    type: 3,
    value: "SEWAGE"
  };
  IfcDistributionSystemEnum.SIGNAL = {
    type: 3,
    value: "SIGNAL"
  };
  IfcDistributionSystemEnum.STORMWATER = {
    type: 3,
    value: "STORMWATER"
  };
  IfcDistributionSystemEnum.TELEPHONE = {
    type: 3,
    value: "TELEPHONE"
  };
  IfcDistributionSystemEnum.TV = {
    type: 3,
    value: "TV"
  };
  IfcDistributionSystemEnum.VACUUM = {
    type: 3,
    value: "VACUUM"
  };
  IfcDistributionSystemEnum.VENT = {
    type: 3,
    value: "VENT"
  };
  IfcDistributionSystemEnum.VENTILATION = {
    type: 3,
    value: "VENTILATION"
  };
  IfcDistributionSystemEnum.WASTEWATER = {
    type: 3,
    value: "WASTEWATER"
  };
  IfcDistributionSystemEnum.WATERSUPPLY = {
    type: 3,
    value: "WATERSUPPLY"
  };
  IfcDistributionSystemEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDistributionSystemEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDistributionSystemEnum = IfcDistributionSystemEnum;

  var IfcDocumentConfidentialityEnum = function IfcDocumentConfidentialityEnum() {
    _classCallCheck2(this, IfcDocumentConfidentialityEnum);
  };

  IfcDocumentConfidentialityEnum.PUBLIC = {
    type: 3,
    value: "PUBLIC"
  };
  IfcDocumentConfidentialityEnum.RESTRICTED = {
    type: 3,
    value: "RESTRICTED"
  };
  IfcDocumentConfidentialityEnum.CONFIDENTIAL = {
    type: 3,
    value: "CONFIDENTIAL"
  };
  IfcDocumentConfidentialityEnum.PERSONAL = {
    type: 3,
    value: "PERSONAL"
  };
  IfcDocumentConfidentialityEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDocumentConfidentialityEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDocumentConfidentialityEnum = IfcDocumentConfidentialityEnum;

  var IfcDocumentStatusEnum = function IfcDocumentStatusEnum() {
    _classCallCheck2(this, IfcDocumentStatusEnum);
  };

  IfcDocumentStatusEnum.DRAFT = {
    type: 3,
    value: "DRAFT"
  };
  IfcDocumentStatusEnum.FINALDRAFT = {
    type: 3,
    value: "FINALDRAFT"
  };
  IfcDocumentStatusEnum.FINAL = {
    type: 3,
    value: "FINAL"
  };
  IfcDocumentStatusEnum.REVISION = {
    type: 3,
    value: "REVISION"
  };
  IfcDocumentStatusEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDocumentStatusEnum = IfcDocumentStatusEnum;

  var IfcDoorPanelOperationEnum = function IfcDoorPanelOperationEnum() {
    _classCallCheck2(this, IfcDoorPanelOperationEnum);
  };

  IfcDoorPanelOperationEnum.SWINGING = {
    type: 3,
    value: "SWINGING"
  };
  IfcDoorPanelOperationEnum.DOUBLE_ACTING = {
    type: 3,
    value: "DOUBLE_ACTING"
  };
  IfcDoorPanelOperationEnum.SLIDING = {
    type: 3,
    value: "SLIDING"
  };
  IfcDoorPanelOperationEnum.FOLDING = {
    type: 3,
    value: "FOLDING"
  };
  IfcDoorPanelOperationEnum.REVOLVING = {
    type: 3,
    value: "REVOLVING"
  };
  IfcDoorPanelOperationEnum.ROLLINGUP = {
    type: 3,
    value: "ROLLINGUP"
  };
  IfcDoorPanelOperationEnum.FIXEDPANEL = {
    type: 3,
    value: "FIXEDPANEL"
  };
  IfcDoorPanelOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorPanelOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDoorPanelOperationEnum = IfcDoorPanelOperationEnum;

  var IfcDoorPanelPositionEnum = function IfcDoorPanelPositionEnum() {
    _classCallCheck2(this, IfcDoorPanelPositionEnum);
  };

  IfcDoorPanelPositionEnum.LEFT = {
    type: 3,
    value: "LEFT"
  };
  IfcDoorPanelPositionEnum.MIDDLE = {
    type: 3,
    value: "MIDDLE"
  };
  IfcDoorPanelPositionEnum.RIGHT = {
    type: 3,
    value: "RIGHT"
  };
  IfcDoorPanelPositionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDoorPanelPositionEnum = IfcDoorPanelPositionEnum;

  var IfcDoorStyleConstructionEnum = function IfcDoorStyleConstructionEnum() {
    _classCallCheck2(this, IfcDoorStyleConstructionEnum);
  };

  IfcDoorStyleConstructionEnum.ALUMINIUM = {
    type: 3,
    value: "ALUMINIUM"
  };
  IfcDoorStyleConstructionEnum.HIGH_GRADE_STEEL = {
    type: 3,
    value: "HIGH_GRADE_STEEL"
  };
  IfcDoorStyleConstructionEnum.STEEL = {
    type: 3,
    value: "STEEL"
  };
  IfcDoorStyleConstructionEnum.WOOD = {
    type: 3,
    value: "WOOD"
  };
  IfcDoorStyleConstructionEnum.ALUMINIUM_WOOD = {
    type: 3,
    value: "ALUMINIUM_WOOD"
  };
  IfcDoorStyleConstructionEnum.ALUMINIUM_PLASTIC = {
    type: 3,
    value: "ALUMINIUM_PLASTIC"
  };
  IfcDoorStyleConstructionEnum.PLASTIC = {
    type: 3,
    value: "PLASTIC"
  };
  IfcDoorStyleConstructionEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorStyleConstructionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDoorStyleConstructionEnum = IfcDoorStyleConstructionEnum;

  var IfcDoorStyleOperationEnum = function IfcDoorStyleOperationEnum() {
    _classCallCheck2(this, IfcDoorStyleOperationEnum);
  };

  IfcDoorStyleOperationEnum.SINGLE_SWING_LEFT = {
    type: 3,
    value: "SINGLE_SWING_LEFT"
  };
  IfcDoorStyleOperationEnum.SINGLE_SWING_RIGHT = {
    type: 3,
    value: "SINGLE_SWING_RIGHT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_LEFT = {
    type: 3,
    value: "DOUBLE_SWING_LEFT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_SWING_RIGHT = {
    type: 3,
    value: "DOUBLE_SWING_RIGHT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_DOUBLE_SWING = {
    type: 3,
    value: "DOUBLE_DOOR_DOUBLE_SWING"
  };
  IfcDoorStyleOperationEnum.SLIDING_TO_LEFT = {
    type: 3,
    value: "SLIDING_TO_LEFT"
  };
  IfcDoorStyleOperationEnum.SLIDING_TO_RIGHT = {
    type: 3,
    value: "SLIDING_TO_RIGHT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_SLIDING = {
    type: 3,
    value: "DOUBLE_DOOR_SLIDING"
  };
  IfcDoorStyleOperationEnum.FOLDING_TO_LEFT = {
    type: 3,
    value: "FOLDING_TO_LEFT"
  };
  IfcDoorStyleOperationEnum.FOLDING_TO_RIGHT = {
    type: 3,
    value: "FOLDING_TO_RIGHT"
  };
  IfcDoorStyleOperationEnum.DOUBLE_DOOR_FOLDING = {
    type: 3,
    value: "DOUBLE_DOOR_FOLDING"
  };
  IfcDoorStyleOperationEnum.REVOLVING = {
    type: 3,
    value: "REVOLVING"
  };
  IfcDoorStyleOperationEnum.ROLLINGUP = {
    type: 3,
    value: "ROLLINGUP"
  };
  IfcDoorStyleOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorStyleOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDoorStyleOperationEnum = IfcDoorStyleOperationEnum;

  var IfcDoorTypeEnum = function IfcDoorTypeEnum() {
    _classCallCheck2(this, IfcDoorTypeEnum);
  };

  IfcDoorTypeEnum.DOOR = {
    type: 3,
    value: "DOOR"
  };
  IfcDoorTypeEnum.GATE = {
    type: 3,
    value: "GATE"
  };
  IfcDoorTypeEnum.TRAPDOOR = {
    type: 3,
    value: "TRAPDOOR"
  };
  IfcDoorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDoorTypeEnum = IfcDoorTypeEnum;

  var IfcDoorTypeOperationEnum = function IfcDoorTypeOperationEnum() {
    _classCallCheck2(this, IfcDoorTypeOperationEnum);
  };

  IfcDoorTypeOperationEnum.SINGLE_SWING_LEFT = {
    type: 3,
    value: "SINGLE_SWING_LEFT"
  };
  IfcDoorTypeOperationEnum.SINGLE_SWING_RIGHT = {
    type: 3,
    value: "SINGLE_SWING_RIGHT"
  };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_SINGLE_SWING = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING"
  };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_LEFT"
  };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT = {
    type: 3,
    value: "DOUBLE_DOOR_SINGLE_SWING_OPPOSITE_RIGHT"
  };
  IfcDoorTypeOperationEnum.DOUBLE_SWING_LEFT = {
    type: 3,
    value: "DOUBLE_SWING_LEFT"
  };
  IfcDoorTypeOperationEnum.DOUBLE_SWING_RIGHT = {
    type: 3,
    value: "DOUBLE_SWING_RIGHT"
  };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_DOUBLE_SWING = {
    type: 3,
    value: "DOUBLE_DOOR_DOUBLE_SWING"
  };
  IfcDoorTypeOperationEnum.SLIDING_TO_LEFT = {
    type: 3,
    value: "SLIDING_TO_LEFT"
  };
  IfcDoorTypeOperationEnum.SLIDING_TO_RIGHT = {
    type: 3,
    value: "SLIDING_TO_RIGHT"
  };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_SLIDING = {
    type: 3,
    value: "DOUBLE_DOOR_SLIDING"
  };
  IfcDoorTypeOperationEnum.FOLDING_TO_LEFT = {
    type: 3,
    value: "FOLDING_TO_LEFT"
  };
  IfcDoorTypeOperationEnum.FOLDING_TO_RIGHT = {
    type: 3,
    value: "FOLDING_TO_RIGHT"
  };
  IfcDoorTypeOperationEnum.DOUBLE_DOOR_FOLDING = {
    type: 3,
    value: "DOUBLE_DOOR_FOLDING"
  };
  IfcDoorTypeOperationEnum.REVOLVING = {
    type: 3,
    value: "REVOLVING"
  };
  IfcDoorTypeOperationEnum.ROLLINGUP = {
    type: 3,
    value: "ROLLINGUP"
  };
  IfcDoorTypeOperationEnum.SWING_FIXED_LEFT = {
    type: 3,
    value: "SWING_FIXED_LEFT"
  };
  IfcDoorTypeOperationEnum.SWING_FIXED_RIGHT = {
    type: 3,
    value: "SWING_FIXED_RIGHT"
  };
  IfcDoorTypeOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDoorTypeOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDoorTypeOperationEnum = IfcDoorTypeOperationEnum;

  var IfcDuctFittingTypeEnum = function IfcDuctFittingTypeEnum() {
    _classCallCheck2(this, IfcDuctFittingTypeEnum);
  };

  IfcDuctFittingTypeEnum.BEND = {
    type: 3,
    value: "BEND"
  };
  IfcDuctFittingTypeEnum.CONNECTOR = {
    type: 3,
    value: "CONNECTOR"
  };
  IfcDuctFittingTypeEnum.ENTRY = {
    type: 3,
    value: "ENTRY"
  };
  IfcDuctFittingTypeEnum.EXIT = {
    type: 3,
    value: "EXIT"
  };
  IfcDuctFittingTypeEnum.JUNCTION = {
    type: 3,
    value: "JUNCTION"
  };
  IfcDuctFittingTypeEnum.OBSTRUCTION = {
    type: 3,
    value: "OBSTRUCTION"
  };
  IfcDuctFittingTypeEnum.TRANSITION = {
    type: 3,
    value: "TRANSITION"
  };
  IfcDuctFittingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDuctFittingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDuctFittingTypeEnum = IfcDuctFittingTypeEnum;

  var IfcDuctSegmentTypeEnum = function IfcDuctSegmentTypeEnum() {
    _classCallCheck2(this, IfcDuctSegmentTypeEnum);
  };

  IfcDuctSegmentTypeEnum.RIGIDSEGMENT = {
    type: 3,
    value: "RIGIDSEGMENT"
  };
  IfcDuctSegmentTypeEnum.FLEXIBLESEGMENT = {
    type: 3,
    value: "FLEXIBLESEGMENT"
  };
  IfcDuctSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDuctSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDuctSegmentTypeEnum = IfcDuctSegmentTypeEnum;

  var IfcDuctSilencerTypeEnum = function IfcDuctSilencerTypeEnum() {
    _classCallCheck2(this, IfcDuctSilencerTypeEnum);
  };

  IfcDuctSilencerTypeEnum.FLATOVAL = {
    type: 3,
    value: "FLATOVAL"
  };
  IfcDuctSilencerTypeEnum.RECTANGULAR = {
    type: 3,
    value: "RECTANGULAR"
  };
  IfcDuctSilencerTypeEnum.ROUND = {
    type: 3,
    value: "ROUND"
  };
  IfcDuctSilencerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcDuctSilencerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcDuctSilencerTypeEnum = IfcDuctSilencerTypeEnum;

  var IfcElectricApplianceTypeEnum = function IfcElectricApplianceTypeEnum() {
    _classCallCheck2(this, IfcElectricApplianceTypeEnum);
  };

  IfcElectricApplianceTypeEnum.DISHWASHER = {
    type: 3,
    value: "DISHWASHER"
  };
  IfcElectricApplianceTypeEnum.ELECTRICCOOKER = {
    type: 3,
    value: "ELECTRICCOOKER"
  };
  IfcElectricApplianceTypeEnum.FREESTANDINGELECTRICHEATER = {
    type: 3,
    value: "FREESTANDINGELECTRICHEATER"
  };
  IfcElectricApplianceTypeEnum.FREESTANDINGFAN = {
    type: 3,
    value: "FREESTANDINGFAN"
  };
  IfcElectricApplianceTypeEnum.FREESTANDINGWATERHEATER = {
    type: 3,
    value: "FREESTANDINGWATERHEATER"
  };
  IfcElectricApplianceTypeEnum.FREESTANDINGWATERCOOLER = {
    type: 3,
    value: "FREESTANDINGWATERCOOLER"
  };
  IfcElectricApplianceTypeEnum.FREEZER = {
    type: 3,
    value: "FREEZER"
  };
  IfcElectricApplianceTypeEnum.FRIDGE_FREEZER = {
    type: 3,
    value: "FRIDGE_FREEZER"
  };
  IfcElectricApplianceTypeEnum.HANDDRYER = {
    type: 3,
    value: "HANDDRYER"
  };
  IfcElectricApplianceTypeEnum.KITCHENMACHINE = {
    type: 3,
    value: "KITCHENMACHINE"
  };
  IfcElectricApplianceTypeEnum.MICROWAVE = {
    type: 3,
    value: "MICROWAVE"
  };
  IfcElectricApplianceTypeEnum.PHOTOCOPIER = {
    type: 3,
    value: "PHOTOCOPIER"
  };
  IfcElectricApplianceTypeEnum.REFRIGERATOR = {
    type: 3,
    value: "REFRIGERATOR"
  };
  IfcElectricApplianceTypeEnum.TUMBLEDRYER = {
    type: 3,
    value: "TUMBLEDRYER"
  };
  IfcElectricApplianceTypeEnum.VENDINGMACHINE = {
    type: 3,
    value: "VENDINGMACHINE"
  };
  IfcElectricApplianceTypeEnum.WASHINGMACHINE = {
    type: 3,
    value: "WASHINGMACHINE"
  };
  IfcElectricApplianceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricApplianceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcElectricApplianceTypeEnum = IfcElectricApplianceTypeEnum;

  var IfcElectricDistributionBoardTypeEnum = function IfcElectricDistributionBoardTypeEnum() {
    _classCallCheck2(this, IfcElectricDistributionBoardTypeEnum);
  };

  IfcElectricDistributionBoardTypeEnum.CONSUMERUNIT = {
    type: 3,
    value: "CONSUMERUNIT"
  };
  IfcElectricDistributionBoardTypeEnum.DISTRIBUTIONBOARD = {
    type: 3,
    value: "DISTRIBUTIONBOARD"
  };
  IfcElectricDistributionBoardTypeEnum.MOTORCONTROLCENTRE = {
    type: 3,
    value: "MOTORCONTROLCENTRE"
  };
  IfcElectricDistributionBoardTypeEnum.SWITCHBOARD = {
    type: 3,
    value: "SWITCHBOARD"
  };
  IfcElectricDistributionBoardTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricDistributionBoardTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcElectricDistributionBoardTypeEnum = IfcElectricDistributionBoardTypeEnum;

  var IfcElectricFlowStorageDeviceTypeEnum = function IfcElectricFlowStorageDeviceTypeEnum() {
    _classCallCheck2(this, IfcElectricFlowStorageDeviceTypeEnum);
  };

  IfcElectricFlowStorageDeviceTypeEnum.BATTERY = {
    type: 3,
    value: "BATTERY"
  };
  IfcElectricFlowStorageDeviceTypeEnum.CAPACITORBANK = {
    type: 3,
    value: "CAPACITORBANK"
  };
  IfcElectricFlowStorageDeviceTypeEnum.HARMONICFILTER = {
    type: 3,
    value: "HARMONICFILTER"
  };
  IfcElectricFlowStorageDeviceTypeEnum.INDUCTORBANK = {
    type: 3,
    value: "INDUCTORBANK"
  };
  IfcElectricFlowStorageDeviceTypeEnum.UPS = {
    type: 3,
    value: "UPS"
  };
  IfcElectricFlowStorageDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricFlowStorageDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcElectricFlowStorageDeviceTypeEnum = IfcElectricFlowStorageDeviceTypeEnum;

  var IfcElectricGeneratorTypeEnum = function IfcElectricGeneratorTypeEnum() {
    _classCallCheck2(this, IfcElectricGeneratorTypeEnum);
  };

  IfcElectricGeneratorTypeEnum.CHP = {
    type: 3,
    value: "CHP"
  };
  IfcElectricGeneratorTypeEnum.ENGINEGENERATOR = {
    type: 3,
    value: "ENGINEGENERATOR"
  };
  IfcElectricGeneratorTypeEnum.STANDALONE = {
    type: 3,
    value: "STANDALONE"
  };
  IfcElectricGeneratorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricGeneratorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcElectricGeneratorTypeEnum = IfcElectricGeneratorTypeEnum;

  var IfcElectricMotorTypeEnum = function IfcElectricMotorTypeEnum() {
    _classCallCheck2(this, IfcElectricMotorTypeEnum);
  };

  IfcElectricMotorTypeEnum.DC = {
    type: 3,
    value: "DC"
  };
  IfcElectricMotorTypeEnum.INDUCTION = {
    type: 3,
    value: "INDUCTION"
  };
  IfcElectricMotorTypeEnum.POLYPHASE = {
    type: 3,
    value: "POLYPHASE"
  };
  IfcElectricMotorTypeEnum.RELUCTANCESYNCHRONOUS = {
    type: 3,
    value: "RELUCTANCESYNCHRONOUS"
  };
  IfcElectricMotorTypeEnum.SYNCHRONOUS = {
    type: 3,
    value: "SYNCHRONOUS"
  };
  IfcElectricMotorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricMotorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcElectricMotorTypeEnum = IfcElectricMotorTypeEnum;

  var IfcElectricTimeControlTypeEnum = function IfcElectricTimeControlTypeEnum() {
    _classCallCheck2(this, IfcElectricTimeControlTypeEnum);
  };

  IfcElectricTimeControlTypeEnum.TIMECLOCK = {
    type: 3,
    value: "TIMECLOCK"
  };
  IfcElectricTimeControlTypeEnum.TIMEDELAY = {
    type: 3,
    value: "TIMEDELAY"
  };
  IfcElectricTimeControlTypeEnum.RELAY = {
    type: 3,
    value: "RELAY"
  };
  IfcElectricTimeControlTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElectricTimeControlTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcElectricTimeControlTypeEnum = IfcElectricTimeControlTypeEnum;

  var IfcElementAssemblyTypeEnum = function IfcElementAssemblyTypeEnum() {
    _classCallCheck2(this, IfcElementAssemblyTypeEnum);
  };

  IfcElementAssemblyTypeEnum.ACCESSORY_ASSEMBLY = {
    type: 3,
    value: "ACCESSORY_ASSEMBLY"
  };
  IfcElementAssemblyTypeEnum.ARCH = {
    type: 3,
    value: "ARCH"
  };
  IfcElementAssemblyTypeEnum.BEAM_GRID = {
    type: 3,
    value: "BEAM_GRID"
  };
  IfcElementAssemblyTypeEnum.BRACED_FRAME = {
    type: 3,
    value: "BRACED_FRAME"
  };
  IfcElementAssemblyTypeEnum.GIRDER = {
    type: 3,
    value: "GIRDER"
  };
  IfcElementAssemblyTypeEnum.REINFORCEMENT_UNIT = {
    type: 3,
    value: "REINFORCEMENT_UNIT"
  };
  IfcElementAssemblyTypeEnum.RIGID_FRAME = {
    type: 3,
    value: "RIGID_FRAME"
  };
  IfcElementAssemblyTypeEnum.SLAB_FIELD = {
    type: 3,
    value: "SLAB_FIELD"
  };
  IfcElementAssemblyTypeEnum.TRUSS = {
    type: 3,
    value: "TRUSS"
  };
  IfcElementAssemblyTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcElementAssemblyTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcElementAssemblyTypeEnum = IfcElementAssemblyTypeEnum;

  var IfcElementCompositionEnum = function IfcElementCompositionEnum() {
    _classCallCheck2(this, IfcElementCompositionEnum);
  };

  IfcElementCompositionEnum.COMPLEX = {
    type: 3,
    value: "COMPLEX"
  };
  IfcElementCompositionEnum.ELEMENT = {
    type: 3,
    value: "ELEMENT"
  };
  IfcElementCompositionEnum.PARTIAL = {
    type: 3,
    value: "PARTIAL"
  };
  IFC42.IfcElementCompositionEnum = IfcElementCompositionEnum;

  var IfcEngineTypeEnum = function IfcEngineTypeEnum() {
    _classCallCheck2(this, IfcEngineTypeEnum);
  };

  IfcEngineTypeEnum.EXTERNALCOMBUSTION = {
    type: 3,
    value: "EXTERNALCOMBUSTION"
  };
  IfcEngineTypeEnum.INTERNALCOMBUSTION = {
    type: 3,
    value: "INTERNALCOMBUSTION"
  };
  IfcEngineTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEngineTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcEngineTypeEnum = IfcEngineTypeEnum;

  var IfcEvaporativeCoolerTypeEnum = function IfcEvaporativeCoolerTypeEnum() {
    _classCallCheck2(this, IfcEvaporativeCoolerTypeEnum);
  };

  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVERANDOMMEDIAAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVERIGIDMEDIAAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVESLINGERSPACKAGEDAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER = {
    type: 3,
    value: "DIRECTEVAPORATIVEPACKAGEDROTARYAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.DIRECTEVAPORATIVEAIRWASHER = {
    type: 3,
    value: "DIRECTEVAPORATIVEAIRWASHER"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEPACKAGEAIRCOOLER = {
    type: 3,
    value: "INDIRECTEVAPORATIVEPACKAGEAIRCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVEWETCOIL = {
    type: 3,
    value: "INDIRECTEVAPORATIVEWETCOIL"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER = {
    type: 3,
    value: "INDIRECTEVAPORATIVECOOLINGTOWERORCOILCOOLER"
  };
  IfcEvaporativeCoolerTypeEnum.INDIRECTDIRECTCOMBINATION = {
    type: 3,
    value: "INDIRECTDIRECTCOMBINATION"
  };
  IfcEvaporativeCoolerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEvaporativeCoolerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcEvaporativeCoolerTypeEnum = IfcEvaporativeCoolerTypeEnum;

  var IfcEvaporatorTypeEnum = function IfcEvaporatorTypeEnum() {
    _classCallCheck2(this, IfcEvaporatorTypeEnum);
  };

  IfcEvaporatorTypeEnum.DIRECTEXPANSION = {
    type: 3,
    value: "DIRECTEXPANSION"
  };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONSHELLANDTUBE = {
    type: 3,
    value: "DIRECTEXPANSIONSHELLANDTUBE"
  };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONTUBEINTUBE = {
    type: 3,
    value: "DIRECTEXPANSIONTUBEINTUBE"
  };
  IfcEvaporatorTypeEnum.DIRECTEXPANSIONBRAZEDPLATE = {
    type: 3,
    value: "DIRECTEXPANSIONBRAZEDPLATE"
  };
  IfcEvaporatorTypeEnum.FLOODEDSHELLANDTUBE = {
    type: 3,
    value: "FLOODEDSHELLANDTUBE"
  };
  IfcEvaporatorTypeEnum.SHELLANDCOIL = {
    type: 3,
    value: "SHELLANDCOIL"
  };
  IfcEvaporatorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEvaporatorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcEvaporatorTypeEnum = IfcEvaporatorTypeEnum;

  var IfcEventTriggerTypeEnum = function IfcEventTriggerTypeEnum() {
    _classCallCheck2(this, IfcEventTriggerTypeEnum);
  };

  IfcEventTriggerTypeEnum.EVENTRULE = {
    type: 3,
    value: "EVENTRULE"
  };
  IfcEventTriggerTypeEnum.EVENTMESSAGE = {
    type: 3,
    value: "EVENTMESSAGE"
  };
  IfcEventTriggerTypeEnum.EVENTTIME = {
    type: 3,
    value: "EVENTTIME"
  };
  IfcEventTriggerTypeEnum.EVENTCOMPLEX = {
    type: 3,
    value: "EVENTCOMPLEX"
  };
  IfcEventTriggerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEventTriggerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcEventTriggerTypeEnum = IfcEventTriggerTypeEnum;

  var IfcEventTypeEnum = function IfcEventTypeEnum() {
    _classCallCheck2(this, IfcEventTypeEnum);
  };

  IfcEventTypeEnum.STARTEVENT = {
    type: 3,
    value: "STARTEVENT"
  };
  IfcEventTypeEnum.ENDEVENT = {
    type: 3,
    value: "ENDEVENT"
  };
  IfcEventTypeEnum.INTERMEDIATEEVENT = {
    type: 3,
    value: "INTERMEDIATEEVENT"
  };
  IfcEventTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcEventTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcEventTypeEnum = IfcEventTypeEnum;

  var IfcExternalSpatialElementTypeEnum = function IfcExternalSpatialElementTypeEnum() {
    _classCallCheck2(this, IfcExternalSpatialElementTypeEnum);
  };

  IfcExternalSpatialElementTypeEnum.EXTERNAL = {
    type: 3,
    value: "EXTERNAL"
  };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_EARTH = {
    type: 3,
    value: "EXTERNAL_EARTH"
  };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_WATER = {
    type: 3,
    value: "EXTERNAL_WATER"
  };
  IfcExternalSpatialElementTypeEnum.EXTERNAL_FIRE = {
    type: 3,
    value: "EXTERNAL_FIRE"
  };
  IfcExternalSpatialElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcExternalSpatialElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcExternalSpatialElementTypeEnum = IfcExternalSpatialElementTypeEnum;

  var IfcFanTypeEnum = function IfcFanTypeEnum() {
    _classCallCheck2(this, IfcFanTypeEnum);
  };

  IfcFanTypeEnum.CENTRIFUGALFORWARDCURVED = {
    type: 3,
    value: "CENTRIFUGALFORWARDCURVED"
  };
  IfcFanTypeEnum.CENTRIFUGALRADIAL = {
    type: 3,
    value: "CENTRIFUGALRADIAL"
  };
  IfcFanTypeEnum.CENTRIFUGALBACKWARDINCLINEDCURVED = {
    type: 3,
    value: "CENTRIFUGALBACKWARDINCLINEDCURVED"
  };
  IfcFanTypeEnum.CENTRIFUGALAIRFOIL = {
    type: 3,
    value: "CENTRIFUGALAIRFOIL"
  };
  IfcFanTypeEnum.TUBEAXIAL = {
    type: 3,
    value: "TUBEAXIAL"
  };
  IfcFanTypeEnum.VANEAXIAL = {
    type: 3,
    value: "VANEAXIAL"
  };
  IfcFanTypeEnum.PROPELLORAXIAL = {
    type: 3,
    value: "PROPELLORAXIAL"
  };
  IfcFanTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFanTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcFanTypeEnum = IfcFanTypeEnum;

  var IfcFastenerTypeEnum = function IfcFastenerTypeEnum() {
    _classCallCheck2(this, IfcFastenerTypeEnum);
  };

  IfcFastenerTypeEnum.GLUE = {
    type: 3,
    value: "GLUE"
  };
  IfcFastenerTypeEnum.MORTAR = {
    type: 3,
    value: "MORTAR"
  };
  IfcFastenerTypeEnum.WELD = {
    type: 3,
    value: "WELD"
  };
  IfcFastenerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFastenerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcFastenerTypeEnum = IfcFastenerTypeEnum;

  var IfcFilterTypeEnum = function IfcFilterTypeEnum() {
    _classCallCheck2(this, IfcFilterTypeEnum);
  };

  IfcFilterTypeEnum.AIRPARTICLEFILTER = {
    type: 3,
    value: "AIRPARTICLEFILTER"
  };
  IfcFilterTypeEnum.COMPRESSEDAIRFILTER = {
    type: 3,
    value: "COMPRESSEDAIRFILTER"
  };
  IfcFilterTypeEnum.ODORFILTER = {
    type: 3,
    value: "ODORFILTER"
  };
  IfcFilterTypeEnum.OILFILTER = {
    type: 3,
    value: "OILFILTER"
  };
  IfcFilterTypeEnum.STRAINER = {
    type: 3,
    value: "STRAINER"
  };
  IfcFilterTypeEnum.WATERFILTER = {
    type: 3,
    value: "WATERFILTER"
  };
  IfcFilterTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFilterTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcFilterTypeEnum = IfcFilterTypeEnum;

  var IfcFireSuppressionTerminalTypeEnum = function IfcFireSuppressionTerminalTypeEnum() {
    _classCallCheck2(this, IfcFireSuppressionTerminalTypeEnum);
  };

  IfcFireSuppressionTerminalTypeEnum.BREECHINGINLET = {
    type: 3,
    value: "BREECHINGINLET"
  };
  IfcFireSuppressionTerminalTypeEnum.FIREHYDRANT = {
    type: 3,
    value: "FIREHYDRANT"
  };
  IfcFireSuppressionTerminalTypeEnum.HOSEREEL = {
    type: 3,
    value: "HOSEREEL"
  };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLER = {
    type: 3,
    value: "SPRINKLER"
  };
  IfcFireSuppressionTerminalTypeEnum.SPRINKLERDEFLECTOR = {
    type: 3,
    value: "SPRINKLERDEFLECTOR"
  };
  IfcFireSuppressionTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFireSuppressionTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcFireSuppressionTerminalTypeEnum = IfcFireSuppressionTerminalTypeEnum;

  var IfcFlowDirectionEnum = function IfcFlowDirectionEnum() {
    _classCallCheck2(this, IfcFlowDirectionEnum);
  };

  IfcFlowDirectionEnum.SOURCE = {
    type: 3,
    value: "SOURCE"
  };
  IfcFlowDirectionEnum.SINK = {
    type: 3,
    value: "SINK"
  };
  IfcFlowDirectionEnum.SOURCEANDSINK = {
    type: 3,
    value: "SOURCEANDSINK"
  };
  IfcFlowDirectionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcFlowDirectionEnum = IfcFlowDirectionEnum;

  var IfcFlowInstrumentTypeEnum = function IfcFlowInstrumentTypeEnum() {
    _classCallCheck2(this, IfcFlowInstrumentTypeEnum);
  };

  IfcFlowInstrumentTypeEnum.PRESSUREGAUGE = {
    type: 3,
    value: "PRESSUREGAUGE"
  };
  IfcFlowInstrumentTypeEnum.THERMOMETER = {
    type: 3,
    value: "THERMOMETER"
  };
  IfcFlowInstrumentTypeEnum.AMMETER = {
    type: 3,
    value: "AMMETER"
  };
  IfcFlowInstrumentTypeEnum.FREQUENCYMETER = {
    type: 3,
    value: "FREQUENCYMETER"
  };
  IfcFlowInstrumentTypeEnum.POWERFACTORMETER = {
    type: 3,
    value: "POWERFACTORMETER"
  };
  IfcFlowInstrumentTypeEnum.PHASEANGLEMETER = {
    type: 3,
    value: "PHASEANGLEMETER"
  };
  IfcFlowInstrumentTypeEnum.VOLTMETER_PEAK = {
    type: 3,
    value: "VOLTMETER_PEAK"
  };
  IfcFlowInstrumentTypeEnum.VOLTMETER_RMS = {
    type: 3,
    value: "VOLTMETER_RMS"
  };
  IfcFlowInstrumentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFlowInstrumentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcFlowInstrumentTypeEnum = IfcFlowInstrumentTypeEnum;

  var IfcFlowMeterTypeEnum = function IfcFlowMeterTypeEnum() {
    _classCallCheck2(this, IfcFlowMeterTypeEnum);
  };

  IfcFlowMeterTypeEnum.ENERGYMETER = {
    type: 3,
    value: "ENERGYMETER"
  };
  IfcFlowMeterTypeEnum.GASMETER = {
    type: 3,
    value: "GASMETER"
  };
  IfcFlowMeterTypeEnum.OILMETER = {
    type: 3,
    value: "OILMETER"
  };
  IfcFlowMeterTypeEnum.WATERMETER = {
    type: 3,
    value: "WATERMETER"
  };
  IfcFlowMeterTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFlowMeterTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcFlowMeterTypeEnum = IfcFlowMeterTypeEnum;

  var IfcFootingTypeEnum = function IfcFootingTypeEnum() {
    _classCallCheck2(this, IfcFootingTypeEnum);
  };

  IfcFootingTypeEnum.CAISSON_FOUNDATION = {
    type: 3,
    value: "CAISSON_FOUNDATION"
  };
  IfcFootingTypeEnum.FOOTING_BEAM = {
    type: 3,
    value: "FOOTING_BEAM"
  };
  IfcFootingTypeEnum.PAD_FOOTING = {
    type: 3,
    value: "PAD_FOOTING"
  };
  IfcFootingTypeEnum.PILE_CAP = {
    type: 3,
    value: "PILE_CAP"
  };
  IfcFootingTypeEnum.STRIP_FOOTING = {
    type: 3,
    value: "STRIP_FOOTING"
  };
  IfcFootingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFootingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcFootingTypeEnum = IfcFootingTypeEnum;

  var IfcFurnitureTypeEnum = function IfcFurnitureTypeEnum() {
    _classCallCheck2(this, IfcFurnitureTypeEnum);
  };

  IfcFurnitureTypeEnum.CHAIR = {
    type: 3,
    value: "CHAIR"
  };
  IfcFurnitureTypeEnum.TABLE = {
    type: 3,
    value: "TABLE"
  };
  IfcFurnitureTypeEnum.DESK = {
    type: 3,
    value: "DESK"
  };
  IfcFurnitureTypeEnum.BED = {
    type: 3,
    value: "BED"
  };
  IfcFurnitureTypeEnum.FILECABINET = {
    type: 3,
    value: "FILECABINET"
  };
  IfcFurnitureTypeEnum.SHELF = {
    type: 3,
    value: "SHELF"
  };
  IfcFurnitureTypeEnum.SOFA = {
    type: 3,
    value: "SOFA"
  };
  IfcFurnitureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcFurnitureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcFurnitureTypeEnum = IfcFurnitureTypeEnum;

  var IfcGeographicElementTypeEnum = function IfcGeographicElementTypeEnum() {
    _classCallCheck2(this, IfcGeographicElementTypeEnum);
  };

  IfcGeographicElementTypeEnum.TERRAIN = {
    type: 3,
    value: "TERRAIN"
  };
  IfcGeographicElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcGeographicElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcGeographicElementTypeEnum = IfcGeographicElementTypeEnum;

  var IfcGeometricProjectionEnum = function IfcGeometricProjectionEnum() {
    _classCallCheck2(this, IfcGeometricProjectionEnum);
  };

  IfcGeometricProjectionEnum.GRAPH_VIEW = {
    type: 3,
    value: "GRAPH_VIEW"
  };
  IfcGeometricProjectionEnum.SKETCH_VIEW = {
    type: 3,
    value: "SKETCH_VIEW"
  };
  IfcGeometricProjectionEnum.MODEL_VIEW = {
    type: 3,
    value: "MODEL_VIEW"
  };
  IfcGeometricProjectionEnum.PLAN_VIEW = {
    type: 3,
    value: "PLAN_VIEW"
  };
  IfcGeometricProjectionEnum.REFLECTED_PLAN_VIEW = {
    type: 3,
    value: "REFLECTED_PLAN_VIEW"
  };
  IfcGeometricProjectionEnum.SECTION_VIEW = {
    type: 3,
    value: "SECTION_VIEW"
  };
  IfcGeometricProjectionEnum.ELEVATION_VIEW = {
    type: 3,
    value: "ELEVATION_VIEW"
  };
  IfcGeometricProjectionEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcGeometricProjectionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcGeometricProjectionEnum = IfcGeometricProjectionEnum;

  var IfcGlobalOrLocalEnum = function IfcGlobalOrLocalEnum() {
    _classCallCheck2(this, IfcGlobalOrLocalEnum);
  };

  IfcGlobalOrLocalEnum.GLOBAL_COORDS = {
    type: 3,
    value: "GLOBAL_COORDS"
  };
  IfcGlobalOrLocalEnum.LOCAL_COORDS = {
    type: 3,
    value: "LOCAL_COORDS"
  };
  IFC42.IfcGlobalOrLocalEnum = IfcGlobalOrLocalEnum;

  var IfcGridTypeEnum = function IfcGridTypeEnum() {
    _classCallCheck2(this, IfcGridTypeEnum);
  };

  IfcGridTypeEnum.RECTANGULAR = {
    type: 3,
    value: "RECTANGULAR"
  };
  IfcGridTypeEnum.RADIAL = {
    type: 3,
    value: "RADIAL"
  };
  IfcGridTypeEnum.TRIANGULAR = {
    type: 3,
    value: "TRIANGULAR"
  };
  IfcGridTypeEnum.IRREGULAR = {
    type: 3,
    value: "IRREGULAR"
  };
  IfcGridTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcGridTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcGridTypeEnum = IfcGridTypeEnum;

  var IfcHeatExchangerTypeEnum = function IfcHeatExchangerTypeEnum() {
    _classCallCheck2(this, IfcHeatExchangerTypeEnum);
  };

  IfcHeatExchangerTypeEnum.PLATE = {
    type: 3,
    value: "PLATE"
  };
  IfcHeatExchangerTypeEnum.SHELLANDTUBE = {
    type: 3,
    value: "SHELLANDTUBE"
  };
  IfcHeatExchangerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcHeatExchangerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcHeatExchangerTypeEnum = IfcHeatExchangerTypeEnum;

  var IfcHumidifierTypeEnum = function IfcHumidifierTypeEnum() {
    _classCallCheck2(this, IfcHumidifierTypeEnum);
  };

  IfcHumidifierTypeEnum.STEAMINJECTION = {
    type: 3,
    value: "STEAMINJECTION"
  };
  IfcHumidifierTypeEnum.ADIABATICAIRWASHER = {
    type: 3,
    value: "ADIABATICAIRWASHER"
  };
  IfcHumidifierTypeEnum.ADIABATICPAN = {
    type: 3,
    value: "ADIABATICPAN"
  };
  IfcHumidifierTypeEnum.ADIABATICWETTEDELEMENT = {
    type: 3,
    value: "ADIABATICWETTEDELEMENT"
  };
  IfcHumidifierTypeEnum.ADIABATICATOMIZING = {
    type: 3,
    value: "ADIABATICATOMIZING"
  };
  IfcHumidifierTypeEnum.ADIABATICULTRASONIC = {
    type: 3,
    value: "ADIABATICULTRASONIC"
  };
  IfcHumidifierTypeEnum.ADIABATICRIGIDMEDIA = {
    type: 3,
    value: "ADIABATICRIGIDMEDIA"
  };
  IfcHumidifierTypeEnum.ADIABATICCOMPRESSEDAIRNOZZLE = {
    type: 3,
    value: "ADIABATICCOMPRESSEDAIRNOZZLE"
  };
  IfcHumidifierTypeEnum.ASSISTEDELECTRIC = {
    type: 3,
    value: "ASSISTEDELECTRIC"
  };
  IfcHumidifierTypeEnum.ASSISTEDNATURALGAS = {
    type: 3,
    value: "ASSISTEDNATURALGAS"
  };
  IfcHumidifierTypeEnum.ASSISTEDPROPANE = {
    type: 3,
    value: "ASSISTEDPROPANE"
  };
  IfcHumidifierTypeEnum.ASSISTEDBUTANE = {
    type: 3,
    value: "ASSISTEDBUTANE"
  };
  IfcHumidifierTypeEnum.ASSISTEDSTEAM = {
    type: 3,
    value: "ASSISTEDSTEAM"
  };
  IfcHumidifierTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcHumidifierTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcHumidifierTypeEnum = IfcHumidifierTypeEnum;

  var IfcInterceptorTypeEnum = function IfcInterceptorTypeEnum() {
    _classCallCheck2(this, IfcInterceptorTypeEnum);
  };

  IfcInterceptorTypeEnum.CYCLONIC = {
    type: 3,
    value: "CYCLONIC"
  };
  IfcInterceptorTypeEnum.GREASE = {
    type: 3,
    value: "GREASE"
  };
  IfcInterceptorTypeEnum.OIL = {
    type: 3,
    value: "OIL"
  };
  IfcInterceptorTypeEnum.PETROL = {
    type: 3,
    value: "PETROL"
  };
  IfcInterceptorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcInterceptorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcInterceptorTypeEnum = IfcInterceptorTypeEnum;

  var IfcInternalOrExternalEnum = function IfcInternalOrExternalEnum() {
    _classCallCheck2(this, IfcInternalOrExternalEnum);
  };

  IfcInternalOrExternalEnum.INTERNAL = {
    type: 3,
    value: "INTERNAL"
  };
  IfcInternalOrExternalEnum.EXTERNAL = {
    type: 3,
    value: "EXTERNAL"
  };
  IfcInternalOrExternalEnum.EXTERNAL_EARTH = {
    type: 3,
    value: "EXTERNAL_EARTH"
  };
  IfcInternalOrExternalEnum.EXTERNAL_WATER = {
    type: 3,
    value: "EXTERNAL_WATER"
  };
  IfcInternalOrExternalEnum.EXTERNAL_FIRE = {
    type: 3,
    value: "EXTERNAL_FIRE"
  };
  IfcInternalOrExternalEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcInternalOrExternalEnum = IfcInternalOrExternalEnum;

  var IfcInventoryTypeEnum = function IfcInventoryTypeEnum() {
    _classCallCheck2(this, IfcInventoryTypeEnum);
  };

  IfcInventoryTypeEnum.ASSETINVENTORY = {
    type: 3,
    value: "ASSETINVENTORY"
  };
  IfcInventoryTypeEnum.SPACEINVENTORY = {
    type: 3,
    value: "SPACEINVENTORY"
  };
  IfcInventoryTypeEnum.FURNITUREINVENTORY = {
    type: 3,
    value: "FURNITUREINVENTORY"
  };
  IfcInventoryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcInventoryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcInventoryTypeEnum = IfcInventoryTypeEnum;

  var IfcJunctionBoxTypeEnum = function IfcJunctionBoxTypeEnum() {
    _classCallCheck2(this, IfcJunctionBoxTypeEnum);
  };

  IfcJunctionBoxTypeEnum.DATA = {
    type: 3,
    value: "DATA"
  };
  IfcJunctionBoxTypeEnum.POWER = {
    type: 3,
    value: "POWER"
  };
  IfcJunctionBoxTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcJunctionBoxTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcJunctionBoxTypeEnum = IfcJunctionBoxTypeEnum;

  var IfcKnotType = function IfcKnotType() {
    _classCallCheck2(this, IfcKnotType);
  };

  IfcKnotType.UNIFORM_KNOTS = {
    type: 3,
    value: "UNIFORM_KNOTS"
  };
  IfcKnotType.QUASI_UNIFORM_KNOTS = {
    type: 3,
    value: "QUASI_UNIFORM_KNOTS"
  };
  IfcKnotType.PIECEWISE_BEZIER_KNOTS = {
    type: 3,
    value: "PIECEWISE_BEZIER_KNOTS"
  };
  IfcKnotType.UNSPECIFIED = {
    type: 3,
    value: "UNSPECIFIED"
  };
  IFC42.IfcKnotType = IfcKnotType;

  var IfcLaborResourceTypeEnum = function IfcLaborResourceTypeEnum() {
    _classCallCheck2(this, IfcLaborResourceTypeEnum);
  };

  IfcLaborResourceTypeEnum.ADMINISTRATION = {
    type: 3,
    value: "ADMINISTRATION"
  };
  IfcLaborResourceTypeEnum.CARPENTRY = {
    type: 3,
    value: "CARPENTRY"
  };
  IfcLaborResourceTypeEnum.CLEANING = {
    type: 3,
    value: "CLEANING"
  };
  IfcLaborResourceTypeEnum.CONCRETE = {
    type: 3,
    value: "CONCRETE"
  };
  IfcLaborResourceTypeEnum.DRYWALL = {
    type: 3,
    value: "DRYWALL"
  };
  IfcLaborResourceTypeEnum.ELECTRIC = {
    type: 3,
    value: "ELECTRIC"
  };
  IfcLaborResourceTypeEnum.FINISHING = {
    type: 3,
    value: "FINISHING"
  };
  IfcLaborResourceTypeEnum.FLOORING = {
    type: 3,
    value: "FLOORING"
  };
  IfcLaborResourceTypeEnum.GENERAL = {
    type: 3,
    value: "GENERAL"
  };
  IfcLaborResourceTypeEnum.HVAC = {
    type: 3,
    value: "HVAC"
  };
  IfcLaborResourceTypeEnum.LANDSCAPING = {
    type: 3,
    value: "LANDSCAPING"
  };
  IfcLaborResourceTypeEnum.MASONRY = {
    type: 3,
    value: "MASONRY"
  };
  IfcLaborResourceTypeEnum.PAINTING = {
    type: 3,
    value: "PAINTING"
  };
  IfcLaborResourceTypeEnum.PAVING = {
    type: 3,
    value: "PAVING"
  };
  IfcLaborResourceTypeEnum.PLUMBING = {
    type: 3,
    value: "PLUMBING"
  };
  IfcLaborResourceTypeEnum.ROOFING = {
    type: 3,
    value: "ROOFING"
  };
  IfcLaborResourceTypeEnum.SITEGRADING = {
    type: 3,
    value: "SITEGRADING"
  };
  IfcLaborResourceTypeEnum.STEELWORK = {
    type: 3,
    value: "STEELWORK"
  };
  IfcLaborResourceTypeEnum.SURVEYING = {
    type: 3,
    value: "SURVEYING"
  };
  IfcLaborResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLaborResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcLaborResourceTypeEnum = IfcLaborResourceTypeEnum;

  var IfcLampTypeEnum = function IfcLampTypeEnum() {
    _classCallCheck2(this, IfcLampTypeEnum);
  };

  IfcLampTypeEnum.COMPACTFLUORESCENT = {
    type: 3,
    value: "COMPACTFLUORESCENT"
  };
  IfcLampTypeEnum.FLUORESCENT = {
    type: 3,
    value: "FLUORESCENT"
  };
  IfcLampTypeEnum.HALOGEN = {
    type: 3,
    value: "HALOGEN"
  };
  IfcLampTypeEnum.HIGHPRESSUREMERCURY = {
    type: 3,
    value: "HIGHPRESSUREMERCURY"
  };
  IfcLampTypeEnum.HIGHPRESSURESODIUM = {
    type: 3,
    value: "HIGHPRESSURESODIUM"
  };
  IfcLampTypeEnum.LED = {
    type: 3,
    value: "LED"
  };
  IfcLampTypeEnum.METALHALIDE = {
    type: 3,
    value: "METALHALIDE"
  };
  IfcLampTypeEnum.OLED = {
    type: 3,
    value: "OLED"
  };
  IfcLampTypeEnum.TUNGSTENFILAMENT = {
    type: 3,
    value: "TUNGSTENFILAMENT"
  };
  IfcLampTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLampTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcLampTypeEnum = IfcLampTypeEnum;

  var IfcLayerSetDirectionEnum = function IfcLayerSetDirectionEnum() {
    _classCallCheck2(this, IfcLayerSetDirectionEnum);
  };

  IfcLayerSetDirectionEnum.AXIS1 = {
    type: 3,
    value: "AXIS1"
  };
  IfcLayerSetDirectionEnum.AXIS2 = {
    type: 3,
    value: "AXIS2"
  };
  IfcLayerSetDirectionEnum.AXIS3 = {
    type: 3,
    value: "AXIS3"
  };
  IFC42.IfcLayerSetDirectionEnum = IfcLayerSetDirectionEnum;

  var IfcLightDistributionCurveEnum = function IfcLightDistributionCurveEnum() {
    _classCallCheck2(this, IfcLightDistributionCurveEnum);
  };

  IfcLightDistributionCurveEnum.TYPE_A = {
    type: 3,
    value: "TYPE_A"
  };
  IfcLightDistributionCurveEnum.TYPE_B = {
    type: 3,
    value: "TYPE_B"
  };
  IfcLightDistributionCurveEnum.TYPE_C = {
    type: 3,
    value: "TYPE_C"
  };
  IfcLightDistributionCurveEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcLightDistributionCurveEnum = IfcLightDistributionCurveEnum;

  var IfcLightEmissionSourceEnum = function IfcLightEmissionSourceEnum() {
    _classCallCheck2(this, IfcLightEmissionSourceEnum);
  };

  IfcLightEmissionSourceEnum.COMPACTFLUORESCENT = {
    type: 3,
    value: "COMPACTFLUORESCENT"
  };
  IfcLightEmissionSourceEnum.FLUORESCENT = {
    type: 3,
    value: "FLUORESCENT"
  };
  IfcLightEmissionSourceEnum.HIGHPRESSUREMERCURY = {
    type: 3,
    value: "HIGHPRESSUREMERCURY"
  };
  IfcLightEmissionSourceEnum.HIGHPRESSURESODIUM = {
    type: 3,
    value: "HIGHPRESSURESODIUM"
  };
  IfcLightEmissionSourceEnum.LIGHTEMITTINGDIODE = {
    type: 3,
    value: "LIGHTEMITTINGDIODE"
  };
  IfcLightEmissionSourceEnum.LOWPRESSURESODIUM = {
    type: 3,
    value: "LOWPRESSURESODIUM"
  };
  IfcLightEmissionSourceEnum.LOWVOLTAGEHALOGEN = {
    type: 3,
    value: "LOWVOLTAGEHALOGEN"
  };
  IfcLightEmissionSourceEnum.MAINVOLTAGEHALOGEN = {
    type: 3,
    value: "MAINVOLTAGEHALOGEN"
  };
  IfcLightEmissionSourceEnum.METALHALIDE = {
    type: 3,
    value: "METALHALIDE"
  };
  IfcLightEmissionSourceEnum.TUNGSTENFILAMENT = {
    type: 3,
    value: "TUNGSTENFILAMENT"
  };
  IfcLightEmissionSourceEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcLightEmissionSourceEnum = IfcLightEmissionSourceEnum;

  var IfcLightFixtureTypeEnum = function IfcLightFixtureTypeEnum() {
    _classCallCheck2(this, IfcLightFixtureTypeEnum);
  };

  IfcLightFixtureTypeEnum.POINTSOURCE = {
    type: 3,
    value: "POINTSOURCE"
  };
  IfcLightFixtureTypeEnum.DIRECTIONSOURCE = {
    type: 3,
    value: "DIRECTIONSOURCE"
  };
  IfcLightFixtureTypeEnum.SECURITYLIGHTING = {
    type: 3,
    value: "SECURITYLIGHTING"
  };
  IfcLightFixtureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLightFixtureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcLightFixtureTypeEnum = IfcLightFixtureTypeEnum;

  var IfcLoadGroupTypeEnum = function IfcLoadGroupTypeEnum() {
    _classCallCheck2(this, IfcLoadGroupTypeEnum);
  };

  IfcLoadGroupTypeEnum.LOAD_GROUP = {
    type: 3,
    value: "LOAD_GROUP"
  };
  IfcLoadGroupTypeEnum.LOAD_CASE = {
    type: 3,
    value: "LOAD_CASE"
  };
  IfcLoadGroupTypeEnum.LOAD_COMBINATION = {
    type: 3,
    value: "LOAD_COMBINATION"
  };
  IfcLoadGroupTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcLoadGroupTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcLoadGroupTypeEnum = IfcLoadGroupTypeEnum;

  var IfcLogicalOperatorEnum = function IfcLogicalOperatorEnum() {
    _classCallCheck2(this, IfcLogicalOperatorEnum);
  };

  IfcLogicalOperatorEnum.LOGICALAND = {
    type: 3,
    value: "LOGICALAND"
  };
  IfcLogicalOperatorEnum.LOGICALOR = {
    type: 3,
    value: "LOGICALOR"
  };
  IfcLogicalOperatorEnum.LOGICALXOR = {
    type: 3,
    value: "LOGICALXOR"
  };
  IfcLogicalOperatorEnum.LOGICALNOTAND = {
    type: 3,
    value: "LOGICALNOTAND"
  };
  IfcLogicalOperatorEnum.LOGICALNOTOR = {
    type: 3,
    value: "LOGICALNOTOR"
  };
  IFC42.IfcLogicalOperatorEnum = IfcLogicalOperatorEnum;

  var IfcMechanicalFastenerTypeEnum = function IfcMechanicalFastenerTypeEnum() {
    _classCallCheck2(this, IfcMechanicalFastenerTypeEnum);
  };

  IfcMechanicalFastenerTypeEnum.ANCHORBOLT = {
    type: 3,
    value: "ANCHORBOLT"
  };
  IfcMechanicalFastenerTypeEnum.BOLT = {
    type: 3,
    value: "BOLT"
  };
  IfcMechanicalFastenerTypeEnum.DOWEL = {
    type: 3,
    value: "DOWEL"
  };
  IfcMechanicalFastenerTypeEnum.NAIL = {
    type: 3,
    value: "NAIL"
  };
  IfcMechanicalFastenerTypeEnum.NAILPLATE = {
    type: 3,
    value: "NAILPLATE"
  };
  IfcMechanicalFastenerTypeEnum.RIVET = {
    type: 3,
    value: "RIVET"
  };
  IfcMechanicalFastenerTypeEnum.SCREW = {
    type: 3,
    value: "SCREW"
  };
  IfcMechanicalFastenerTypeEnum.SHEARCONNECTOR = {
    type: 3,
    value: "SHEARCONNECTOR"
  };
  IfcMechanicalFastenerTypeEnum.STAPLE = {
    type: 3,
    value: "STAPLE"
  };
  IfcMechanicalFastenerTypeEnum.STUDSHEARCONNECTOR = {
    type: 3,
    value: "STUDSHEARCONNECTOR"
  };
  IfcMechanicalFastenerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMechanicalFastenerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcMechanicalFastenerTypeEnum = IfcMechanicalFastenerTypeEnum;

  var IfcMedicalDeviceTypeEnum = function IfcMedicalDeviceTypeEnum() {
    _classCallCheck2(this, IfcMedicalDeviceTypeEnum);
  };

  IfcMedicalDeviceTypeEnum.AIRSTATION = {
    type: 3,
    value: "AIRSTATION"
  };
  IfcMedicalDeviceTypeEnum.FEEDAIRUNIT = {
    type: 3,
    value: "FEEDAIRUNIT"
  };
  IfcMedicalDeviceTypeEnum.OXYGENGENERATOR = {
    type: 3,
    value: "OXYGENGENERATOR"
  };
  IfcMedicalDeviceTypeEnum.OXYGENPLANT = {
    type: 3,
    value: "OXYGENPLANT"
  };
  IfcMedicalDeviceTypeEnum.VACUUMSTATION = {
    type: 3,
    value: "VACUUMSTATION"
  };
  IfcMedicalDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMedicalDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcMedicalDeviceTypeEnum = IfcMedicalDeviceTypeEnum;

  var IfcMemberTypeEnum = function IfcMemberTypeEnum() {
    _classCallCheck2(this, IfcMemberTypeEnum);
  };

  IfcMemberTypeEnum.BRACE = {
    type: 3,
    value: "BRACE"
  };
  IfcMemberTypeEnum.CHORD = {
    type: 3,
    value: "CHORD"
  };
  IfcMemberTypeEnum.COLLAR = {
    type: 3,
    value: "COLLAR"
  };
  IfcMemberTypeEnum.MEMBER = {
    type: 3,
    value: "MEMBER"
  };
  IfcMemberTypeEnum.MULLION = {
    type: 3,
    value: "MULLION"
  };
  IfcMemberTypeEnum.PLATE = {
    type: 3,
    value: "PLATE"
  };
  IfcMemberTypeEnum.POST = {
    type: 3,
    value: "POST"
  };
  IfcMemberTypeEnum.PURLIN = {
    type: 3,
    value: "PURLIN"
  };
  IfcMemberTypeEnum.RAFTER = {
    type: 3,
    value: "RAFTER"
  };
  IfcMemberTypeEnum.STRINGER = {
    type: 3,
    value: "STRINGER"
  };
  IfcMemberTypeEnum.STRUT = {
    type: 3,
    value: "STRUT"
  };
  IfcMemberTypeEnum.STUD = {
    type: 3,
    value: "STUD"
  };
  IfcMemberTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMemberTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcMemberTypeEnum = IfcMemberTypeEnum;

  var IfcMotorConnectionTypeEnum = function IfcMotorConnectionTypeEnum() {
    _classCallCheck2(this, IfcMotorConnectionTypeEnum);
  };

  IfcMotorConnectionTypeEnum.BELTDRIVE = {
    type: 3,
    value: "BELTDRIVE"
  };
  IfcMotorConnectionTypeEnum.COUPLING = {
    type: 3,
    value: "COUPLING"
  };
  IfcMotorConnectionTypeEnum.DIRECTDRIVE = {
    type: 3,
    value: "DIRECTDRIVE"
  };
  IfcMotorConnectionTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcMotorConnectionTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcMotorConnectionTypeEnum = IfcMotorConnectionTypeEnum;

  var IfcNullStyle = function IfcNullStyle() {
    _classCallCheck2(this, IfcNullStyle);
  };

  IfcNullStyle.NULL = {
    type: 3,
    value: "NULL"
  };
  IFC42.IfcNullStyle = IfcNullStyle;

  var IfcObjectTypeEnum = function IfcObjectTypeEnum() {
    _classCallCheck2(this, IfcObjectTypeEnum);
  };

  IfcObjectTypeEnum.PRODUCT = {
    type: 3,
    value: "PRODUCT"
  };
  IfcObjectTypeEnum.PROCESS = {
    type: 3,
    value: "PROCESS"
  };
  IfcObjectTypeEnum.CONTROL = {
    type: 3,
    value: "CONTROL"
  };
  IfcObjectTypeEnum.RESOURCE = {
    type: 3,
    value: "RESOURCE"
  };
  IfcObjectTypeEnum.ACTOR = {
    type: 3,
    value: "ACTOR"
  };
  IfcObjectTypeEnum.GROUP = {
    type: 3,
    value: "GROUP"
  };
  IfcObjectTypeEnum.PROJECT = {
    type: 3,
    value: "PROJECT"
  };
  IfcObjectTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcObjectTypeEnum = IfcObjectTypeEnum;

  var IfcObjectiveEnum = function IfcObjectiveEnum() {
    _classCallCheck2(this, IfcObjectiveEnum);
  };

  IfcObjectiveEnum.CODECOMPLIANCE = {
    type: 3,
    value: "CODECOMPLIANCE"
  };
  IfcObjectiveEnum.CODEWAIVER = {
    type: 3,
    value: "CODEWAIVER"
  };
  IfcObjectiveEnum.DESIGNINTENT = {
    type: 3,
    value: "DESIGNINTENT"
  };
  IfcObjectiveEnum.EXTERNAL = {
    type: 3,
    value: "EXTERNAL"
  };
  IfcObjectiveEnum.HEALTHANDSAFETY = {
    type: 3,
    value: "HEALTHANDSAFETY"
  };
  IfcObjectiveEnum.MERGECONFLICT = {
    type: 3,
    value: "MERGECONFLICT"
  };
  IfcObjectiveEnum.MODELVIEW = {
    type: 3,
    value: "MODELVIEW"
  };
  IfcObjectiveEnum.PARAMETER = {
    type: 3,
    value: "PARAMETER"
  };
  IfcObjectiveEnum.REQUIREMENT = {
    type: 3,
    value: "REQUIREMENT"
  };
  IfcObjectiveEnum.SPECIFICATION = {
    type: 3,
    value: "SPECIFICATION"
  };
  IfcObjectiveEnum.TRIGGERCONDITION = {
    type: 3,
    value: "TRIGGERCONDITION"
  };
  IfcObjectiveEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcObjectiveEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcObjectiveEnum = IfcObjectiveEnum;

  var IfcOccupantTypeEnum = function IfcOccupantTypeEnum() {
    _classCallCheck2(this, IfcOccupantTypeEnum);
  };

  IfcOccupantTypeEnum.ASSIGNEE = {
    type: 3,
    value: "ASSIGNEE"
  };
  IfcOccupantTypeEnum.ASSIGNOR = {
    type: 3,
    value: "ASSIGNOR"
  };
  IfcOccupantTypeEnum.LESSEE = {
    type: 3,
    value: "LESSEE"
  };
  IfcOccupantTypeEnum.LESSOR = {
    type: 3,
    value: "LESSOR"
  };
  IfcOccupantTypeEnum.LETTINGAGENT = {
    type: 3,
    value: "LETTINGAGENT"
  };
  IfcOccupantTypeEnum.OWNER = {
    type: 3,
    value: "OWNER"
  };
  IfcOccupantTypeEnum.TENANT = {
    type: 3,
    value: "TENANT"
  };
  IfcOccupantTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcOccupantTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcOccupantTypeEnum = IfcOccupantTypeEnum;

  var IfcOpeningElementTypeEnum = function IfcOpeningElementTypeEnum() {
    _classCallCheck2(this, IfcOpeningElementTypeEnum);
  };

  IfcOpeningElementTypeEnum.OPENING = {
    type: 3,
    value: "OPENING"
  };
  IfcOpeningElementTypeEnum.RECESS = {
    type: 3,
    value: "RECESS"
  };
  IfcOpeningElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcOpeningElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcOpeningElementTypeEnum = IfcOpeningElementTypeEnum;

  var IfcOutletTypeEnum = function IfcOutletTypeEnum() {
    _classCallCheck2(this, IfcOutletTypeEnum);
  };

  IfcOutletTypeEnum.AUDIOVISUALOUTLET = {
    type: 3,
    value: "AUDIOVISUALOUTLET"
  };
  IfcOutletTypeEnum.COMMUNICATIONSOUTLET = {
    type: 3,
    value: "COMMUNICATIONSOUTLET"
  };
  IfcOutletTypeEnum.POWEROUTLET = {
    type: 3,
    value: "POWEROUTLET"
  };
  IfcOutletTypeEnum.DATAOUTLET = {
    type: 3,
    value: "DATAOUTLET"
  };
  IfcOutletTypeEnum.TELEPHONEOUTLET = {
    type: 3,
    value: "TELEPHONEOUTLET"
  };
  IfcOutletTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcOutletTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcOutletTypeEnum = IfcOutletTypeEnum;

  var IfcPerformanceHistoryTypeEnum = function IfcPerformanceHistoryTypeEnum() {
    _classCallCheck2(this, IfcPerformanceHistoryTypeEnum);
  };

  IfcPerformanceHistoryTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPerformanceHistoryTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcPerformanceHistoryTypeEnum = IfcPerformanceHistoryTypeEnum;

  var IfcPermeableCoveringOperationEnum = function IfcPermeableCoveringOperationEnum() {
    _classCallCheck2(this, IfcPermeableCoveringOperationEnum);
  };

  IfcPermeableCoveringOperationEnum.GRILL = {
    type: 3,
    value: "GRILL"
  };
  IfcPermeableCoveringOperationEnum.LOUVER = {
    type: 3,
    value: "LOUVER"
  };
  IfcPermeableCoveringOperationEnum.SCREEN = {
    type: 3,
    value: "SCREEN"
  };
  IfcPermeableCoveringOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPermeableCoveringOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcPermeableCoveringOperationEnum = IfcPermeableCoveringOperationEnum;

  var IfcPermitTypeEnum = function IfcPermitTypeEnum() {
    _classCallCheck2(this, IfcPermitTypeEnum);
  };

  IfcPermitTypeEnum.ACCESS = {
    type: 3,
    value: "ACCESS"
  };
  IfcPermitTypeEnum.BUILDING = {
    type: 3,
    value: "BUILDING"
  };
  IfcPermitTypeEnum.WORK = {
    type: 3,
    value: "WORK"
  };
  IfcPermitTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPermitTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcPermitTypeEnum = IfcPermitTypeEnum;

  var IfcPhysicalOrVirtualEnum = function IfcPhysicalOrVirtualEnum() {
    _classCallCheck2(this, IfcPhysicalOrVirtualEnum);
  };

  IfcPhysicalOrVirtualEnum.PHYSICAL = {
    type: 3,
    value: "PHYSICAL"
  };
  IfcPhysicalOrVirtualEnum.VIRTUAL = {
    type: 3,
    value: "VIRTUAL"
  };
  IfcPhysicalOrVirtualEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcPhysicalOrVirtualEnum = IfcPhysicalOrVirtualEnum;

  var IfcPileConstructionEnum = function IfcPileConstructionEnum() {
    _classCallCheck2(this, IfcPileConstructionEnum);
  };

  IfcPileConstructionEnum.CAST_IN_PLACE = {
    type: 3,
    value: "CAST_IN_PLACE"
  };
  IfcPileConstructionEnum.COMPOSITE = {
    type: 3,
    value: "COMPOSITE"
  };
  IfcPileConstructionEnum.PRECAST_CONCRETE = {
    type: 3,
    value: "PRECAST_CONCRETE"
  };
  IfcPileConstructionEnum.PREFAB_STEEL = {
    type: 3,
    value: "PREFAB_STEEL"
  };
  IfcPileConstructionEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPileConstructionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcPileConstructionEnum = IfcPileConstructionEnum;

  var IfcPileTypeEnum = function IfcPileTypeEnum() {
    _classCallCheck2(this, IfcPileTypeEnum);
  };

  IfcPileTypeEnum.BORED = {
    type: 3,
    value: "BORED"
  };
  IfcPileTypeEnum.DRIVEN = {
    type: 3,
    value: "DRIVEN"
  };
  IfcPileTypeEnum.JETGROUTING = {
    type: 3,
    value: "JETGROUTING"
  };
  IfcPileTypeEnum.COHESION = {
    type: 3,
    value: "COHESION"
  };
  IfcPileTypeEnum.FRICTION = {
    type: 3,
    value: "FRICTION"
  };
  IfcPileTypeEnum.SUPPORT = {
    type: 3,
    value: "SUPPORT"
  };
  IfcPileTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPileTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcPileTypeEnum = IfcPileTypeEnum;

  var IfcPipeFittingTypeEnum = function IfcPipeFittingTypeEnum() {
    _classCallCheck2(this, IfcPipeFittingTypeEnum);
  };

  IfcPipeFittingTypeEnum.BEND = {
    type: 3,
    value: "BEND"
  };
  IfcPipeFittingTypeEnum.CONNECTOR = {
    type: 3,
    value: "CONNECTOR"
  };
  IfcPipeFittingTypeEnum.ENTRY = {
    type: 3,
    value: "ENTRY"
  };
  IfcPipeFittingTypeEnum.EXIT = {
    type: 3,
    value: "EXIT"
  };
  IfcPipeFittingTypeEnum.JUNCTION = {
    type: 3,
    value: "JUNCTION"
  };
  IfcPipeFittingTypeEnum.OBSTRUCTION = {
    type: 3,
    value: "OBSTRUCTION"
  };
  IfcPipeFittingTypeEnum.TRANSITION = {
    type: 3,
    value: "TRANSITION"
  };
  IfcPipeFittingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPipeFittingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcPipeFittingTypeEnum = IfcPipeFittingTypeEnum;

  var IfcPipeSegmentTypeEnum = function IfcPipeSegmentTypeEnum() {
    _classCallCheck2(this, IfcPipeSegmentTypeEnum);
  };

  IfcPipeSegmentTypeEnum.CULVERT = {
    type: 3,
    value: "CULVERT"
  };
  IfcPipeSegmentTypeEnum.FLEXIBLESEGMENT = {
    type: 3,
    value: "FLEXIBLESEGMENT"
  };
  IfcPipeSegmentTypeEnum.RIGIDSEGMENT = {
    type: 3,
    value: "RIGIDSEGMENT"
  };
  IfcPipeSegmentTypeEnum.GUTTER = {
    type: 3,
    value: "GUTTER"
  };
  IfcPipeSegmentTypeEnum.SPOOL = {
    type: 3,
    value: "SPOOL"
  };
  IfcPipeSegmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPipeSegmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcPipeSegmentTypeEnum = IfcPipeSegmentTypeEnum;

  var IfcPlateTypeEnum = function IfcPlateTypeEnum() {
    _classCallCheck2(this, IfcPlateTypeEnum);
  };

  IfcPlateTypeEnum.CURTAIN_PANEL = {
    type: 3,
    value: "CURTAIN_PANEL"
  };
  IfcPlateTypeEnum.SHEET = {
    type: 3,
    value: "SHEET"
  };
  IfcPlateTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPlateTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcPlateTypeEnum = IfcPlateTypeEnum;

  var IfcPreferredSurfaceCurveRepresentation = function IfcPreferredSurfaceCurveRepresentation() {
    _classCallCheck2(this, IfcPreferredSurfaceCurveRepresentation);
  };

  IfcPreferredSurfaceCurveRepresentation.CURVE3D = {
    type: 3,
    value: "CURVE3D"
  };
  IfcPreferredSurfaceCurveRepresentation.PCURVE_S1 = {
    type: 3,
    value: "PCURVE_S1"
  };
  IfcPreferredSurfaceCurveRepresentation.PCURVE_S2 = {
    type: 3,
    value: "PCURVE_S2"
  };
  IFC42.IfcPreferredSurfaceCurveRepresentation = IfcPreferredSurfaceCurveRepresentation;

  var IfcProcedureTypeEnum = function IfcProcedureTypeEnum() {
    _classCallCheck2(this, IfcProcedureTypeEnum);
  };

  IfcProcedureTypeEnum.ADVICE_CAUTION = {
    type: 3,
    value: "ADVICE_CAUTION"
  };
  IfcProcedureTypeEnum.ADVICE_NOTE = {
    type: 3,
    value: "ADVICE_NOTE"
  };
  IfcProcedureTypeEnum.ADVICE_WARNING = {
    type: 3,
    value: "ADVICE_WARNING"
  };
  IfcProcedureTypeEnum.CALIBRATION = {
    type: 3,
    value: "CALIBRATION"
  };
  IfcProcedureTypeEnum.DIAGNOSTIC = {
    type: 3,
    value: "DIAGNOSTIC"
  };
  IfcProcedureTypeEnum.SHUTDOWN = {
    type: 3,
    value: "SHUTDOWN"
  };
  IfcProcedureTypeEnum.STARTUP = {
    type: 3,
    value: "STARTUP"
  };
  IfcProcedureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProcedureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcProcedureTypeEnum = IfcProcedureTypeEnum;

  var IfcProfileTypeEnum = function IfcProfileTypeEnum() {
    _classCallCheck2(this, IfcProfileTypeEnum);
  };

  IfcProfileTypeEnum.CURVE = {
    type: 3,
    value: "CURVE"
  };
  IfcProfileTypeEnum.AREA = {
    type: 3,
    value: "AREA"
  };
  IFC42.IfcProfileTypeEnum = IfcProfileTypeEnum;

  var IfcProjectOrderTypeEnum = function IfcProjectOrderTypeEnum() {
    _classCallCheck2(this, IfcProjectOrderTypeEnum);
  };

  IfcProjectOrderTypeEnum.CHANGEORDER = {
    type: 3,
    value: "CHANGEORDER"
  };
  IfcProjectOrderTypeEnum.MAINTENANCEWORKORDER = {
    type: 3,
    value: "MAINTENANCEWORKORDER"
  };
  IfcProjectOrderTypeEnum.MOVEORDER = {
    type: 3,
    value: "MOVEORDER"
  };
  IfcProjectOrderTypeEnum.PURCHASEORDER = {
    type: 3,
    value: "PURCHASEORDER"
  };
  IfcProjectOrderTypeEnum.WORKORDER = {
    type: 3,
    value: "WORKORDER"
  };
  IfcProjectOrderTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProjectOrderTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcProjectOrderTypeEnum = IfcProjectOrderTypeEnum;

  var IfcProjectedOrTrueLengthEnum = function IfcProjectedOrTrueLengthEnum() {
    _classCallCheck2(this, IfcProjectedOrTrueLengthEnum);
  };

  IfcProjectedOrTrueLengthEnum.PROJECTED_LENGTH = {
    type: 3,
    value: "PROJECTED_LENGTH"
  };
  IfcProjectedOrTrueLengthEnum.TRUE_LENGTH = {
    type: 3,
    value: "TRUE_LENGTH"
  };
  IFC42.IfcProjectedOrTrueLengthEnum = IfcProjectedOrTrueLengthEnum;

  var IfcProjectionElementTypeEnum = function IfcProjectionElementTypeEnum() {
    _classCallCheck2(this, IfcProjectionElementTypeEnum);
  };

  IfcProjectionElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProjectionElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcProjectionElementTypeEnum = IfcProjectionElementTypeEnum;

  var IfcPropertySetTemplateTypeEnum = function IfcPropertySetTemplateTypeEnum() {
    _classCallCheck2(this, IfcPropertySetTemplateTypeEnum);
  };

  IfcPropertySetTemplateTypeEnum.PSET_TYPEDRIVENONLY = {
    type: 3,
    value: "PSET_TYPEDRIVENONLY"
  };
  IfcPropertySetTemplateTypeEnum.PSET_TYPEDRIVENOVERRIDE = {
    type: 3,
    value: "PSET_TYPEDRIVENOVERRIDE"
  };
  IfcPropertySetTemplateTypeEnum.PSET_OCCURRENCEDRIVEN = {
    type: 3,
    value: "PSET_OCCURRENCEDRIVEN"
  };
  IfcPropertySetTemplateTypeEnum.PSET_PERFORMANCEDRIVEN = {
    type: 3,
    value: "PSET_PERFORMANCEDRIVEN"
  };
  IfcPropertySetTemplateTypeEnum.QTO_TYPEDRIVENONLY = {
    type: 3,
    value: "QTO_TYPEDRIVENONLY"
  };
  IfcPropertySetTemplateTypeEnum.QTO_TYPEDRIVENOVERRIDE = {
    type: 3,
    value: "QTO_TYPEDRIVENOVERRIDE"
  };
  IfcPropertySetTemplateTypeEnum.QTO_OCCURRENCEDRIVEN = {
    type: 3,
    value: "QTO_OCCURRENCEDRIVEN"
  };
  IfcPropertySetTemplateTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcPropertySetTemplateTypeEnum = IfcPropertySetTemplateTypeEnum;

  var IfcProtectiveDeviceTrippingUnitTypeEnum = function IfcProtectiveDeviceTrippingUnitTypeEnum() {
    _classCallCheck2(this, IfcProtectiveDeviceTrippingUnitTypeEnum);
  };

  IfcProtectiveDeviceTrippingUnitTypeEnum.ELECTRONIC = {
    type: 3,
    value: "ELECTRONIC"
  };
  IfcProtectiveDeviceTrippingUnitTypeEnum.ELECTROMAGNETIC = {
    type: 3,
    value: "ELECTROMAGNETIC"
  };
  IfcProtectiveDeviceTrippingUnitTypeEnum.RESIDUALCURRENT = {
    type: 3,
    value: "RESIDUALCURRENT"
  };
  IfcProtectiveDeviceTrippingUnitTypeEnum.THERMAL = {
    type: 3,
    value: "THERMAL"
  };
  IfcProtectiveDeviceTrippingUnitTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProtectiveDeviceTrippingUnitTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcProtectiveDeviceTrippingUnitTypeEnum = IfcProtectiveDeviceTrippingUnitTypeEnum;

  var IfcProtectiveDeviceTypeEnum = function IfcProtectiveDeviceTypeEnum() {
    _classCallCheck2(this, IfcProtectiveDeviceTypeEnum);
  };

  IfcProtectiveDeviceTypeEnum.CIRCUITBREAKER = {
    type: 3,
    value: "CIRCUITBREAKER"
  };
  IfcProtectiveDeviceTypeEnum.EARTHLEAKAGECIRCUITBREAKER = {
    type: 3,
    value: "EARTHLEAKAGECIRCUITBREAKER"
  };
  IfcProtectiveDeviceTypeEnum.EARTHINGSWITCH = {
    type: 3,
    value: "EARTHINGSWITCH"
  };
  IfcProtectiveDeviceTypeEnum.FUSEDISCONNECTOR = {
    type: 3,
    value: "FUSEDISCONNECTOR"
  };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTCIRCUITBREAKER = {
    type: 3,
    value: "RESIDUALCURRENTCIRCUITBREAKER"
  };
  IfcProtectiveDeviceTypeEnum.RESIDUALCURRENTSWITCH = {
    type: 3,
    value: "RESIDUALCURRENTSWITCH"
  };
  IfcProtectiveDeviceTypeEnum.VARISTOR = {
    type: 3,
    value: "VARISTOR"
  };
  IfcProtectiveDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcProtectiveDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcProtectiveDeviceTypeEnum = IfcProtectiveDeviceTypeEnum;

  var IfcPumpTypeEnum = function IfcPumpTypeEnum() {
    _classCallCheck2(this, IfcPumpTypeEnum);
  };

  IfcPumpTypeEnum.CIRCULATOR = {
    type: 3,
    value: "CIRCULATOR"
  };
  IfcPumpTypeEnum.ENDSUCTION = {
    type: 3,
    value: "ENDSUCTION"
  };
  IfcPumpTypeEnum.SPLITCASE = {
    type: 3,
    value: "SPLITCASE"
  };
  IfcPumpTypeEnum.SUBMERSIBLEPUMP = {
    type: 3,
    value: "SUBMERSIBLEPUMP"
  };
  IfcPumpTypeEnum.SUMPPUMP = {
    type: 3,
    value: "SUMPPUMP"
  };
  IfcPumpTypeEnum.VERTICALINLINE = {
    type: 3,
    value: "VERTICALINLINE"
  };
  IfcPumpTypeEnum.VERTICALTURBINE = {
    type: 3,
    value: "VERTICALTURBINE"
  };
  IfcPumpTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcPumpTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcPumpTypeEnum = IfcPumpTypeEnum;

  var IfcRailingTypeEnum = function IfcRailingTypeEnum() {
    _classCallCheck2(this, IfcRailingTypeEnum);
  };

  IfcRailingTypeEnum.HANDRAIL = {
    type: 3,
    value: "HANDRAIL"
  };
  IfcRailingTypeEnum.GUARDRAIL = {
    type: 3,
    value: "GUARDRAIL"
  };
  IfcRailingTypeEnum.BALUSTRADE = {
    type: 3,
    value: "BALUSTRADE"
  };
  IfcRailingTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRailingTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcRailingTypeEnum = IfcRailingTypeEnum;

  var IfcRampFlightTypeEnum = function IfcRampFlightTypeEnum() {
    _classCallCheck2(this, IfcRampFlightTypeEnum);
  };

  IfcRampFlightTypeEnum.STRAIGHT = {
    type: 3,
    value: "STRAIGHT"
  };
  IfcRampFlightTypeEnum.SPIRAL = {
    type: 3,
    value: "SPIRAL"
  };
  IfcRampFlightTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRampFlightTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcRampFlightTypeEnum = IfcRampFlightTypeEnum;

  var IfcRampTypeEnum = function IfcRampTypeEnum() {
    _classCallCheck2(this, IfcRampTypeEnum);
  };

  IfcRampTypeEnum.STRAIGHT_RUN_RAMP = {
    type: 3,
    value: "STRAIGHT_RUN_RAMP"
  };
  IfcRampTypeEnum.TWO_STRAIGHT_RUN_RAMP = {
    type: 3,
    value: "TWO_STRAIGHT_RUN_RAMP"
  };
  IfcRampTypeEnum.QUARTER_TURN_RAMP = {
    type: 3,
    value: "QUARTER_TURN_RAMP"
  };
  IfcRampTypeEnum.TWO_QUARTER_TURN_RAMP = {
    type: 3,
    value: "TWO_QUARTER_TURN_RAMP"
  };
  IfcRampTypeEnum.HALF_TURN_RAMP = {
    type: 3,
    value: "HALF_TURN_RAMP"
  };
  IfcRampTypeEnum.SPIRAL_RAMP = {
    type: 3,
    value: "SPIRAL_RAMP"
  };
  IfcRampTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRampTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcRampTypeEnum = IfcRampTypeEnum;

  var IfcRecurrenceTypeEnum = function IfcRecurrenceTypeEnum() {
    _classCallCheck2(this, IfcRecurrenceTypeEnum);
  };

  IfcRecurrenceTypeEnum.DAILY = {
    type: 3,
    value: "DAILY"
  };
  IfcRecurrenceTypeEnum.WEEKLY = {
    type: 3,
    value: "WEEKLY"
  };
  IfcRecurrenceTypeEnum.MONTHLY_BY_DAY_OF_MONTH = {
    type: 3,
    value: "MONTHLY_BY_DAY_OF_MONTH"
  };
  IfcRecurrenceTypeEnum.MONTHLY_BY_POSITION = {
    type: 3,
    value: "MONTHLY_BY_POSITION"
  };
  IfcRecurrenceTypeEnum.BY_DAY_COUNT = {
    type: 3,
    value: "BY_DAY_COUNT"
  };
  IfcRecurrenceTypeEnum.BY_WEEKDAY_COUNT = {
    type: 3,
    value: "BY_WEEKDAY_COUNT"
  };
  IfcRecurrenceTypeEnum.YEARLY_BY_DAY_OF_MONTH = {
    type: 3,
    value: "YEARLY_BY_DAY_OF_MONTH"
  };
  IfcRecurrenceTypeEnum.YEARLY_BY_POSITION = {
    type: 3,
    value: "YEARLY_BY_POSITION"
  };
  IFC42.IfcRecurrenceTypeEnum = IfcRecurrenceTypeEnum;

  var IfcReflectanceMethodEnum = function IfcReflectanceMethodEnum() {
    _classCallCheck2(this, IfcReflectanceMethodEnum);
  };

  IfcReflectanceMethodEnum.BLINN = {
    type: 3,
    value: "BLINN"
  };
  IfcReflectanceMethodEnum.FLAT = {
    type: 3,
    value: "FLAT"
  };
  IfcReflectanceMethodEnum.GLASS = {
    type: 3,
    value: "GLASS"
  };
  IfcReflectanceMethodEnum.MATT = {
    type: 3,
    value: "MATT"
  };
  IfcReflectanceMethodEnum.METAL = {
    type: 3,
    value: "METAL"
  };
  IfcReflectanceMethodEnum.MIRROR = {
    type: 3,
    value: "MIRROR"
  };
  IfcReflectanceMethodEnum.PHONG = {
    type: 3,
    value: "PHONG"
  };
  IfcReflectanceMethodEnum.PLASTIC = {
    type: 3,
    value: "PLASTIC"
  };
  IfcReflectanceMethodEnum.STRAUSS = {
    type: 3,
    value: "STRAUSS"
  };
  IfcReflectanceMethodEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcReflectanceMethodEnum = IfcReflectanceMethodEnum;

  var IfcReinforcingBarRoleEnum = function IfcReinforcingBarRoleEnum() {
    _classCallCheck2(this, IfcReinforcingBarRoleEnum);
  };

  IfcReinforcingBarRoleEnum.MAIN = {
    type: 3,
    value: "MAIN"
  };
  IfcReinforcingBarRoleEnum.SHEAR = {
    type: 3,
    value: "SHEAR"
  };
  IfcReinforcingBarRoleEnum.LIGATURE = {
    type: 3,
    value: "LIGATURE"
  };
  IfcReinforcingBarRoleEnum.STUD = {
    type: 3,
    value: "STUD"
  };
  IfcReinforcingBarRoleEnum.PUNCHING = {
    type: 3,
    value: "PUNCHING"
  };
  IfcReinforcingBarRoleEnum.EDGE = {
    type: 3,
    value: "EDGE"
  };
  IfcReinforcingBarRoleEnum.RING = {
    type: 3,
    value: "RING"
  };
  IfcReinforcingBarRoleEnum.ANCHORING = {
    type: 3,
    value: "ANCHORING"
  };
  IfcReinforcingBarRoleEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcReinforcingBarRoleEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcReinforcingBarRoleEnum = IfcReinforcingBarRoleEnum;

  var IfcReinforcingBarSurfaceEnum = function IfcReinforcingBarSurfaceEnum() {
    _classCallCheck2(this, IfcReinforcingBarSurfaceEnum);
  };

  IfcReinforcingBarSurfaceEnum.PLAIN = {
    type: 3,
    value: "PLAIN"
  };
  IfcReinforcingBarSurfaceEnum.TEXTURED = {
    type: 3,
    value: "TEXTURED"
  };
  IFC42.IfcReinforcingBarSurfaceEnum = IfcReinforcingBarSurfaceEnum;

  var IfcReinforcingBarTypeEnum = function IfcReinforcingBarTypeEnum() {
    _classCallCheck2(this, IfcReinforcingBarTypeEnum);
  };

  IfcReinforcingBarTypeEnum.ANCHORING = {
    type: 3,
    value: "ANCHORING"
  };
  IfcReinforcingBarTypeEnum.EDGE = {
    type: 3,
    value: "EDGE"
  };
  IfcReinforcingBarTypeEnum.LIGATURE = {
    type: 3,
    value: "LIGATURE"
  };
  IfcReinforcingBarTypeEnum.MAIN = {
    type: 3,
    value: "MAIN"
  };
  IfcReinforcingBarTypeEnum.PUNCHING = {
    type: 3,
    value: "PUNCHING"
  };
  IfcReinforcingBarTypeEnum.RING = {
    type: 3,
    value: "RING"
  };
  IfcReinforcingBarTypeEnum.SHEAR = {
    type: 3,
    value: "SHEAR"
  };
  IfcReinforcingBarTypeEnum.STUD = {
    type: 3,
    value: "STUD"
  };
  IfcReinforcingBarTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcReinforcingBarTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcReinforcingBarTypeEnum = IfcReinforcingBarTypeEnum;

  var IfcReinforcingMeshTypeEnum = function IfcReinforcingMeshTypeEnum() {
    _classCallCheck2(this, IfcReinforcingMeshTypeEnum);
  };

  IfcReinforcingMeshTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcReinforcingMeshTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcReinforcingMeshTypeEnum = IfcReinforcingMeshTypeEnum;

  var IfcRoleEnum = function IfcRoleEnum() {
    _classCallCheck2(this, IfcRoleEnum);
  };

  IfcRoleEnum.SUPPLIER = {
    type: 3,
    value: "SUPPLIER"
  };
  IfcRoleEnum.MANUFACTURER = {
    type: 3,
    value: "MANUFACTURER"
  };
  IfcRoleEnum.CONTRACTOR = {
    type: 3,
    value: "CONTRACTOR"
  };
  IfcRoleEnum.SUBCONTRACTOR = {
    type: 3,
    value: "SUBCONTRACTOR"
  };
  IfcRoleEnum.ARCHITECT = {
    type: 3,
    value: "ARCHITECT"
  };
  IfcRoleEnum.STRUCTURALENGINEER = {
    type: 3,
    value: "STRUCTURALENGINEER"
  };
  IfcRoleEnum.COSTENGINEER = {
    type: 3,
    value: "COSTENGINEER"
  };
  IfcRoleEnum.CLIENT = {
    type: 3,
    value: "CLIENT"
  };
  IfcRoleEnum.BUILDINGOWNER = {
    type: 3,
    value: "BUILDINGOWNER"
  };
  IfcRoleEnum.BUILDINGOPERATOR = {
    type: 3,
    value: "BUILDINGOPERATOR"
  };
  IfcRoleEnum.MECHANICALENGINEER = {
    type: 3,
    value: "MECHANICALENGINEER"
  };
  IfcRoleEnum.ELECTRICALENGINEER = {
    type: 3,
    value: "ELECTRICALENGINEER"
  };
  IfcRoleEnum.PROJECTMANAGER = {
    type: 3,
    value: "PROJECTMANAGER"
  };
  IfcRoleEnum.FACILITIESMANAGER = {
    type: 3,
    value: "FACILITIESMANAGER"
  };
  IfcRoleEnum.CIVILENGINEER = {
    type: 3,
    value: "CIVILENGINEER"
  };
  IfcRoleEnum.COMMISSIONINGENGINEER = {
    type: 3,
    value: "COMMISSIONINGENGINEER"
  };
  IfcRoleEnum.ENGINEER = {
    type: 3,
    value: "ENGINEER"
  };
  IfcRoleEnum.OWNER = {
    type: 3,
    value: "OWNER"
  };
  IfcRoleEnum.CONSULTANT = {
    type: 3,
    value: "CONSULTANT"
  };
  IfcRoleEnum.CONSTRUCTIONMANAGER = {
    type: 3,
    value: "CONSTRUCTIONMANAGER"
  };
  IfcRoleEnum.FIELDCONSTRUCTIONMANAGER = {
    type: 3,
    value: "FIELDCONSTRUCTIONMANAGER"
  };
  IfcRoleEnum.RESELLER = {
    type: 3,
    value: "RESELLER"
  };
  IfcRoleEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC42.IfcRoleEnum = IfcRoleEnum;

  var IfcRoofTypeEnum = function IfcRoofTypeEnum() {
    _classCallCheck2(this, IfcRoofTypeEnum);
  };

  IfcRoofTypeEnum.FLAT_ROOF = {
    type: 3,
    value: "FLAT_ROOF"
  };
  IfcRoofTypeEnum.SHED_ROOF = {
    type: 3,
    value: "SHED_ROOF"
  };
  IfcRoofTypeEnum.GABLE_ROOF = {
    type: 3,
    value: "GABLE_ROOF"
  };
  IfcRoofTypeEnum.HIP_ROOF = {
    type: 3,
    value: "HIP_ROOF"
  };
  IfcRoofTypeEnum.HIPPED_GABLE_ROOF = {
    type: 3,
    value: "HIPPED_GABLE_ROOF"
  };
  IfcRoofTypeEnum.GAMBREL_ROOF = {
    type: 3,
    value: "GAMBREL_ROOF"
  };
  IfcRoofTypeEnum.MANSARD_ROOF = {
    type: 3,
    value: "MANSARD_ROOF"
  };
  IfcRoofTypeEnum.BARREL_ROOF = {
    type: 3,
    value: "BARREL_ROOF"
  };
  IfcRoofTypeEnum.RAINBOW_ROOF = {
    type: 3,
    value: "RAINBOW_ROOF"
  };
  IfcRoofTypeEnum.BUTTERFLY_ROOF = {
    type: 3,
    value: "BUTTERFLY_ROOF"
  };
  IfcRoofTypeEnum.PAVILION_ROOF = {
    type: 3,
    value: "PAVILION_ROOF"
  };
  IfcRoofTypeEnum.DOME_ROOF = {
    type: 3,
    value: "DOME_ROOF"
  };
  IfcRoofTypeEnum.FREEFORM = {
    type: 3,
    value: "FREEFORM"
  };
  IfcRoofTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcRoofTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcRoofTypeEnum = IfcRoofTypeEnum;

  var IfcSIPrefix = function IfcSIPrefix() {
    _classCallCheck2(this, IfcSIPrefix);
  };

  IfcSIPrefix.EXA = {
    type: 3,
    value: "EXA"
  };
  IfcSIPrefix.PETA = {
    type: 3,
    value: "PETA"
  };
  IfcSIPrefix.TERA = {
    type: 3,
    value: "TERA"
  };
  IfcSIPrefix.GIGA = {
    type: 3,
    value: "GIGA"
  };
  IfcSIPrefix.MEGA = {
    type: 3,
    value: "MEGA"
  };
  IfcSIPrefix.KILO = {
    type: 3,
    value: "KILO"
  };
  IfcSIPrefix.HECTO = {
    type: 3,
    value: "HECTO"
  };
  IfcSIPrefix.DECA = {
    type: 3,
    value: "DECA"
  };
  IfcSIPrefix.DECI = {
    type: 3,
    value: "DECI"
  };
  IfcSIPrefix.CENTI = {
    type: 3,
    value: "CENTI"
  };
  IfcSIPrefix.MILLI = {
    type: 3,
    value: "MILLI"
  };
  IfcSIPrefix.MICRO = {
    type: 3,
    value: "MICRO"
  };
  IfcSIPrefix.NANO = {
    type: 3,
    value: "NANO"
  };
  IfcSIPrefix.PICO = {
    type: 3,
    value: "PICO"
  };
  IfcSIPrefix.FEMTO = {
    type: 3,
    value: "FEMTO"
  };
  IfcSIPrefix.ATTO = {
    type: 3,
    value: "ATTO"
  };
  IFC42.IfcSIPrefix = IfcSIPrefix;

  var IfcSIUnitName = function IfcSIUnitName() {
    _classCallCheck2(this, IfcSIUnitName);
  };

  IfcSIUnitName.AMPERE = {
    type: 3,
    value: "AMPERE"
  };
  IfcSIUnitName.BECQUEREL = {
    type: 3,
    value: "BECQUEREL"
  };
  IfcSIUnitName.CANDELA = {
    type: 3,
    value: "CANDELA"
  };
  IfcSIUnitName.COULOMB = {
    type: 3,
    value: "COULOMB"
  };
  IfcSIUnitName.CUBIC_METRE = {
    type: 3,
    value: "CUBIC_METRE"
  };
  IfcSIUnitName.DEGREE_CELSIUS = {
    type: 3,
    value: "DEGREE_CELSIUS"
  };
  IfcSIUnitName.FARAD = {
    type: 3,
    value: "FARAD"
  };
  IfcSIUnitName.GRAM = {
    type: 3,
    value: "GRAM"
  };
  IfcSIUnitName.GRAY = {
    type: 3,
    value: "GRAY"
  };
  IfcSIUnitName.HENRY = {
    type: 3,
    value: "HENRY"
  };
  IfcSIUnitName.HERTZ = {
    type: 3,
    value: "HERTZ"
  };
  IfcSIUnitName.JOULE = {
    type: 3,
    value: "JOULE"
  };
  IfcSIUnitName.KELVIN = {
    type: 3,
    value: "KELVIN"
  };
  IfcSIUnitName.LUMEN = {
    type: 3,
    value: "LUMEN"
  };
  IfcSIUnitName.LUX = {
    type: 3,
    value: "LUX"
  };
  IfcSIUnitName.METRE = {
    type: 3,
    value: "METRE"
  };
  IfcSIUnitName.MOLE = {
    type: 3,
    value: "MOLE"
  };
  IfcSIUnitName.NEWTON = {
    type: 3,
    value: "NEWTON"
  };
  IfcSIUnitName.OHM = {
    type: 3,
    value: "OHM"
  };
  IfcSIUnitName.PASCAL = {
    type: 3,
    value: "PASCAL"
  };
  IfcSIUnitName.RADIAN = {
    type: 3,
    value: "RADIAN"
  };
  IfcSIUnitName.SECOND = {
    type: 3,
    value: "SECOND"
  };
  IfcSIUnitName.SIEMENS = {
    type: 3,
    value: "SIEMENS"
  };
  IfcSIUnitName.SIEVERT = {
    type: 3,
    value: "SIEVERT"
  };
  IfcSIUnitName.SQUARE_METRE = {
    type: 3,
    value: "SQUARE_METRE"
  };
  IfcSIUnitName.STERADIAN = {
    type: 3,
    value: "STERADIAN"
  };
  IfcSIUnitName.TESLA = {
    type: 3,
    value: "TESLA"
  };
  IfcSIUnitName.VOLT = {
    type: 3,
    value: "VOLT"
  };
  IfcSIUnitName.WATT = {
    type: 3,
    value: "WATT"
  };
  IfcSIUnitName.WEBER = {
    type: 3,
    value: "WEBER"
  };
  IFC42.IfcSIUnitName = IfcSIUnitName;

  var IfcSanitaryTerminalTypeEnum = function IfcSanitaryTerminalTypeEnum() {
    _classCallCheck2(this, IfcSanitaryTerminalTypeEnum);
  };

  IfcSanitaryTerminalTypeEnum.BATH = {
    type: 3,
    value: "BATH"
  };
  IfcSanitaryTerminalTypeEnum.BIDET = {
    type: 3,
    value: "BIDET"
  };
  IfcSanitaryTerminalTypeEnum.CISTERN = {
    type: 3,
    value: "CISTERN"
  };
  IfcSanitaryTerminalTypeEnum.SHOWER = {
    type: 3,
    value: "SHOWER"
  };
  IfcSanitaryTerminalTypeEnum.SINK = {
    type: 3,
    value: "SINK"
  };
  IfcSanitaryTerminalTypeEnum.SANITARYFOUNTAIN = {
    type: 3,
    value: "SANITARYFOUNTAIN"
  };
  IfcSanitaryTerminalTypeEnum.TOILETPAN = {
    type: 3,
    value: "TOILETPAN"
  };
  IfcSanitaryTerminalTypeEnum.URINAL = {
    type: 3,
    value: "URINAL"
  };
  IfcSanitaryTerminalTypeEnum.WASHHANDBASIN = {
    type: 3,
    value: "WASHHANDBASIN"
  };
  IfcSanitaryTerminalTypeEnum.WCSEAT = {
    type: 3,
    value: "WCSEAT"
  };
  IfcSanitaryTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSanitaryTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSanitaryTerminalTypeEnum = IfcSanitaryTerminalTypeEnum;

  var IfcSectionTypeEnum = function IfcSectionTypeEnum() {
    _classCallCheck2(this, IfcSectionTypeEnum);
  };

  IfcSectionTypeEnum.UNIFORM = {
    type: 3,
    value: "UNIFORM"
  };
  IfcSectionTypeEnum.TAPERED = {
    type: 3,
    value: "TAPERED"
  };
  IFC42.IfcSectionTypeEnum = IfcSectionTypeEnum;

  var IfcSensorTypeEnum = function IfcSensorTypeEnum() {
    _classCallCheck2(this, IfcSensorTypeEnum);
  };

  IfcSensorTypeEnum.COSENSOR = {
    type: 3,
    value: "COSENSOR"
  };
  IfcSensorTypeEnum.CO2SENSOR = {
    type: 3,
    value: "CO2SENSOR"
  };
  IfcSensorTypeEnum.CONDUCTANCESENSOR = {
    type: 3,
    value: "CONDUCTANCESENSOR"
  };
  IfcSensorTypeEnum.CONTACTSENSOR = {
    type: 3,
    value: "CONTACTSENSOR"
  };
  IfcSensorTypeEnum.FIRESENSOR = {
    type: 3,
    value: "FIRESENSOR"
  };
  IfcSensorTypeEnum.FLOWSENSOR = {
    type: 3,
    value: "FLOWSENSOR"
  };
  IfcSensorTypeEnum.FROSTSENSOR = {
    type: 3,
    value: "FROSTSENSOR"
  };
  IfcSensorTypeEnum.GASSENSOR = {
    type: 3,
    value: "GASSENSOR"
  };
  IfcSensorTypeEnum.HEATSENSOR = {
    type: 3,
    value: "HEATSENSOR"
  };
  IfcSensorTypeEnum.HUMIDITYSENSOR = {
    type: 3,
    value: "HUMIDITYSENSOR"
  };
  IfcSensorTypeEnum.IDENTIFIERSENSOR = {
    type: 3,
    value: "IDENTIFIERSENSOR"
  };
  IfcSensorTypeEnum.IONCONCENTRATIONSENSOR = {
    type: 3,
    value: "IONCONCENTRATIONSENSOR"
  };
  IfcSensorTypeEnum.LEVELSENSOR = {
    type: 3,
    value: "LEVELSENSOR"
  };
  IfcSensorTypeEnum.LIGHTSENSOR = {
    type: 3,
    value: "LIGHTSENSOR"
  };
  IfcSensorTypeEnum.MOISTURESENSOR = {
    type: 3,
    value: "MOISTURESENSOR"
  };
  IfcSensorTypeEnum.MOVEMENTSENSOR = {
    type: 3,
    value: "MOVEMENTSENSOR"
  };
  IfcSensorTypeEnum.PHSENSOR = {
    type: 3,
    value: "PHSENSOR"
  };
  IfcSensorTypeEnum.PRESSURESENSOR = {
    type: 3,
    value: "PRESSURESENSOR"
  };
  IfcSensorTypeEnum.RADIATIONSENSOR = {
    type: 3,
    value: "RADIATIONSENSOR"
  };
  IfcSensorTypeEnum.RADIOACTIVITYSENSOR = {
    type: 3,
    value: "RADIOACTIVITYSENSOR"
  };
  IfcSensorTypeEnum.SMOKESENSOR = {
    type: 3,
    value: "SMOKESENSOR"
  };
  IfcSensorTypeEnum.SOUNDSENSOR = {
    type: 3,
    value: "SOUNDSENSOR"
  };
  IfcSensorTypeEnum.TEMPERATURESENSOR = {
    type: 3,
    value: "TEMPERATURESENSOR"
  };
  IfcSensorTypeEnum.WINDSENSOR = {
    type: 3,
    value: "WINDSENSOR"
  };
  IfcSensorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSensorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSensorTypeEnum = IfcSensorTypeEnum;

  var IfcSequenceEnum = function IfcSequenceEnum() {
    _classCallCheck2(this, IfcSequenceEnum);
  };

  IfcSequenceEnum.START_START = {
    type: 3,
    value: "START_START"
  };
  IfcSequenceEnum.START_FINISH = {
    type: 3,
    value: "START_FINISH"
  };
  IfcSequenceEnum.FINISH_START = {
    type: 3,
    value: "FINISH_START"
  };
  IfcSequenceEnum.FINISH_FINISH = {
    type: 3,
    value: "FINISH_FINISH"
  };
  IfcSequenceEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSequenceEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSequenceEnum = IfcSequenceEnum;

  var IfcShadingDeviceTypeEnum = function IfcShadingDeviceTypeEnum() {
    _classCallCheck2(this, IfcShadingDeviceTypeEnum);
  };

  IfcShadingDeviceTypeEnum.JALOUSIE = {
    type: 3,
    value: "JALOUSIE"
  };
  IfcShadingDeviceTypeEnum.SHUTTER = {
    type: 3,
    value: "SHUTTER"
  };
  IfcShadingDeviceTypeEnum.AWNING = {
    type: 3,
    value: "AWNING"
  };
  IfcShadingDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcShadingDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcShadingDeviceTypeEnum = IfcShadingDeviceTypeEnum;

  var IfcSimplePropertyTemplateTypeEnum = function IfcSimplePropertyTemplateTypeEnum() {
    _classCallCheck2(this, IfcSimplePropertyTemplateTypeEnum);
  };

  IfcSimplePropertyTemplateTypeEnum.P_SINGLEVALUE = {
    type: 3,
    value: "P_SINGLEVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.P_ENUMERATEDVALUE = {
    type: 3,
    value: "P_ENUMERATEDVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.P_BOUNDEDVALUE = {
    type: 3,
    value: "P_BOUNDEDVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.P_LISTVALUE = {
    type: 3,
    value: "P_LISTVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.P_TABLEVALUE = {
    type: 3,
    value: "P_TABLEVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.P_REFERENCEVALUE = {
    type: 3,
    value: "P_REFERENCEVALUE"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_LENGTH = {
    type: 3,
    value: "Q_LENGTH"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_AREA = {
    type: 3,
    value: "Q_AREA"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_VOLUME = {
    type: 3,
    value: "Q_VOLUME"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_COUNT = {
    type: 3,
    value: "Q_COUNT"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_WEIGHT = {
    type: 3,
    value: "Q_WEIGHT"
  };
  IfcSimplePropertyTemplateTypeEnum.Q_TIME = {
    type: 3,
    value: "Q_TIME"
  };
  IFC42.IfcSimplePropertyTemplateTypeEnum = IfcSimplePropertyTemplateTypeEnum;

  var IfcSlabTypeEnum = function IfcSlabTypeEnum() {
    _classCallCheck2(this, IfcSlabTypeEnum);
  };

  IfcSlabTypeEnum.FLOOR = {
    type: 3,
    value: "FLOOR"
  };
  IfcSlabTypeEnum.ROOF = {
    type: 3,
    value: "ROOF"
  };
  IfcSlabTypeEnum.LANDING = {
    type: 3,
    value: "LANDING"
  };
  IfcSlabTypeEnum.BASESLAB = {
    type: 3,
    value: "BASESLAB"
  };
  IfcSlabTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSlabTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSlabTypeEnum = IfcSlabTypeEnum;

  var IfcSolarDeviceTypeEnum = function IfcSolarDeviceTypeEnum() {
    _classCallCheck2(this, IfcSolarDeviceTypeEnum);
  };

  IfcSolarDeviceTypeEnum.SOLARCOLLECTOR = {
    type: 3,
    value: "SOLARCOLLECTOR"
  };
  IfcSolarDeviceTypeEnum.SOLARPANEL = {
    type: 3,
    value: "SOLARPANEL"
  };
  IfcSolarDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSolarDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSolarDeviceTypeEnum = IfcSolarDeviceTypeEnum;

  var IfcSpaceHeaterTypeEnum = function IfcSpaceHeaterTypeEnum() {
    _classCallCheck2(this, IfcSpaceHeaterTypeEnum);
  };

  IfcSpaceHeaterTypeEnum.CONVECTOR = {
    type: 3,
    value: "CONVECTOR"
  };
  IfcSpaceHeaterTypeEnum.RADIATOR = {
    type: 3,
    value: "RADIATOR"
  };
  IfcSpaceHeaterTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSpaceHeaterTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSpaceHeaterTypeEnum = IfcSpaceHeaterTypeEnum;

  var IfcSpaceTypeEnum = function IfcSpaceTypeEnum() {
    _classCallCheck2(this, IfcSpaceTypeEnum);
  };

  IfcSpaceTypeEnum.SPACE = {
    type: 3,
    value: "SPACE"
  };
  IfcSpaceTypeEnum.PARKING = {
    type: 3,
    value: "PARKING"
  };
  IfcSpaceTypeEnum.GFA = {
    type: 3,
    value: "GFA"
  };
  IfcSpaceTypeEnum.INTERNAL = {
    type: 3,
    value: "INTERNAL"
  };
  IfcSpaceTypeEnum.EXTERNAL = {
    type: 3,
    value: "EXTERNAL"
  };
  IfcSpaceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSpaceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSpaceTypeEnum = IfcSpaceTypeEnum;

  var IfcSpatialZoneTypeEnum = function IfcSpatialZoneTypeEnum() {
    _classCallCheck2(this, IfcSpatialZoneTypeEnum);
  };

  IfcSpatialZoneTypeEnum.CONSTRUCTION = {
    type: 3,
    value: "CONSTRUCTION"
  };
  IfcSpatialZoneTypeEnum.FIRESAFETY = {
    type: 3,
    value: "FIRESAFETY"
  };
  IfcSpatialZoneTypeEnum.LIGHTING = {
    type: 3,
    value: "LIGHTING"
  };
  IfcSpatialZoneTypeEnum.OCCUPANCY = {
    type: 3,
    value: "OCCUPANCY"
  };
  IfcSpatialZoneTypeEnum.SECURITY = {
    type: 3,
    value: "SECURITY"
  };
  IfcSpatialZoneTypeEnum.THERMAL = {
    type: 3,
    value: "THERMAL"
  };
  IfcSpatialZoneTypeEnum.TRANSPORT = {
    type: 3,
    value: "TRANSPORT"
  };
  IfcSpatialZoneTypeEnum.VENTILATION = {
    type: 3,
    value: "VENTILATION"
  };
  IfcSpatialZoneTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSpatialZoneTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSpatialZoneTypeEnum = IfcSpatialZoneTypeEnum;

  var IfcStackTerminalTypeEnum = function IfcStackTerminalTypeEnum() {
    _classCallCheck2(this, IfcStackTerminalTypeEnum);
  };

  IfcStackTerminalTypeEnum.BIRDCAGE = {
    type: 3,
    value: "BIRDCAGE"
  };
  IfcStackTerminalTypeEnum.COWL = {
    type: 3,
    value: "COWL"
  };
  IfcStackTerminalTypeEnum.RAINWATERHOPPER = {
    type: 3,
    value: "RAINWATERHOPPER"
  };
  IfcStackTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStackTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcStackTerminalTypeEnum = IfcStackTerminalTypeEnum;

  var IfcStairFlightTypeEnum = function IfcStairFlightTypeEnum() {
    _classCallCheck2(this, IfcStairFlightTypeEnum);
  };

  IfcStairFlightTypeEnum.STRAIGHT = {
    type: 3,
    value: "STRAIGHT"
  };
  IfcStairFlightTypeEnum.WINDER = {
    type: 3,
    value: "WINDER"
  };
  IfcStairFlightTypeEnum.SPIRAL = {
    type: 3,
    value: "SPIRAL"
  };
  IfcStairFlightTypeEnum.CURVED = {
    type: 3,
    value: "CURVED"
  };
  IfcStairFlightTypeEnum.FREEFORM = {
    type: 3,
    value: "FREEFORM"
  };
  IfcStairFlightTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStairFlightTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcStairFlightTypeEnum = IfcStairFlightTypeEnum;

  var IfcStairTypeEnum = function IfcStairTypeEnum() {
    _classCallCheck2(this, IfcStairTypeEnum);
  };

  IfcStairTypeEnum.STRAIGHT_RUN_STAIR = {
    type: 3,
    value: "STRAIGHT_RUN_STAIR"
  };
  IfcStairTypeEnum.TWO_STRAIGHT_RUN_STAIR = {
    type: 3,
    value: "TWO_STRAIGHT_RUN_STAIR"
  };
  IfcStairTypeEnum.QUARTER_WINDING_STAIR = {
    type: 3,
    value: "QUARTER_WINDING_STAIR"
  };
  IfcStairTypeEnum.QUARTER_TURN_STAIR = {
    type: 3,
    value: "QUARTER_TURN_STAIR"
  };
  IfcStairTypeEnum.HALF_WINDING_STAIR = {
    type: 3,
    value: "HALF_WINDING_STAIR"
  };
  IfcStairTypeEnum.HALF_TURN_STAIR = {
    type: 3,
    value: "HALF_TURN_STAIR"
  };
  IfcStairTypeEnum.TWO_QUARTER_WINDING_STAIR = {
    type: 3,
    value: "TWO_QUARTER_WINDING_STAIR"
  };
  IfcStairTypeEnum.TWO_QUARTER_TURN_STAIR = {
    type: 3,
    value: "TWO_QUARTER_TURN_STAIR"
  };
  IfcStairTypeEnum.THREE_QUARTER_WINDING_STAIR = {
    type: 3,
    value: "THREE_QUARTER_WINDING_STAIR"
  };
  IfcStairTypeEnum.THREE_QUARTER_TURN_STAIR = {
    type: 3,
    value: "THREE_QUARTER_TURN_STAIR"
  };
  IfcStairTypeEnum.SPIRAL_STAIR = {
    type: 3,
    value: "SPIRAL_STAIR"
  };
  IfcStairTypeEnum.DOUBLE_RETURN_STAIR = {
    type: 3,
    value: "DOUBLE_RETURN_STAIR"
  };
  IfcStairTypeEnum.CURVED_RUN_STAIR = {
    type: 3,
    value: "CURVED_RUN_STAIR"
  };
  IfcStairTypeEnum.TWO_CURVED_RUN_STAIR = {
    type: 3,
    value: "TWO_CURVED_RUN_STAIR"
  };
  IfcStairTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStairTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcStairTypeEnum = IfcStairTypeEnum;

  var IfcStateEnum = function IfcStateEnum() {
    _classCallCheck2(this, IfcStateEnum);
  };

  IfcStateEnum.READWRITE = {
    type: 3,
    value: "READWRITE"
  };
  IfcStateEnum.READONLY = {
    type: 3,
    value: "READONLY"
  };
  IfcStateEnum.LOCKED = {
    type: 3,
    value: "LOCKED"
  };
  IfcStateEnum.READWRITELOCKED = {
    type: 3,
    value: "READWRITELOCKED"
  };
  IfcStateEnum.READONLYLOCKED = {
    type: 3,
    value: "READONLYLOCKED"
  };
  IFC42.IfcStateEnum = IfcStateEnum;

  var IfcStructuralCurveActivityTypeEnum = function IfcStructuralCurveActivityTypeEnum() {
    _classCallCheck2(this, IfcStructuralCurveActivityTypeEnum);
  };

  IfcStructuralCurveActivityTypeEnum.CONST = {
    type: 3,
    value: "CONST"
  };
  IfcStructuralCurveActivityTypeEnum.LINEAR = {
    type: 3,
    value: "LINEAR"
  };
  IfcStructuralCurveActivityTypeEnum.POLYGONAL = {
    type: 3,
    value: "POLYGONAL"
  };
  IfcStructuralCurveActivityTypeEnum.EQUIDISTANT = {
    type: 3,
    value: "EQUIDISTANT"
  };
  IfcStructuralCurveActivityTypeEnum.SINUS = {
    type: 3,
    value: "SINUS"
  };
  IfcStructuralCurveActivityTypeEnum.PARABOLA = {
    type: 3,
    value: "PARABOLA"
  };
  IfcStructuralCurveActivityTypeEnum.DISCRETE = {
    type: 3,
    value: "DISCRETE"
  };
  IfcStructuralCurveActivityTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStructuralCurveActivityTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcStructuralCurveActivityTypeEnum = IfcStructuralCurveActivityTypeEnum;

  var IfcStructuralCurveMemberTypeEnum = function IfcStructuralCurveMemberTypeEnum() {
    _classCallCheck2(this, IfcStructuralCurveMemberTypeEnum);
  };

  IfcStructuralCurveMemberTypeEnum.RIGID_JOINED_MEMBER = {
    type: 3,
    value: "RIGID_JOINED_MEMBER"
  };
  IfcStructuralCurveMemberTypeEnum.PIN_JOINED_MEMBER = {
    type: 3,
    value: "PIN_JOINED_MEMBER"
  };
  IfcStructuralCurveMemberTypeEnum.CABLE = {
    type: 3,
    value: "CABLE"
  };
  IfcStructuralCurveMemberTypeEnum.TENSION_MEMBER = {
    type: 3,
    value: "TENSION_MEMBER"
  };
  IfcStructuralCurveMemberTypeEnum.COMPRESSION_MEMBER = {
    type: 3,
    value: "COMPRESSION_MEMBER"
  };
  IfcStructuralCurveMemberTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStructuralCurveMemberTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcStructuralCurveMemberTypeEnum = IfcStructuralCurveMemberTypeEnum;

  var IfcStructuralSurfaceActivityTypeEnum = function IfcStructuralSurfaceActivityTypeEnum() {
    _classCallCheck2(this, IfcStructuralSurfaceActivityTypeEnum);
  };

  IfcStructuralSurfaceActivityTypeEnum.CONST = {
    type: 3,
    value: "CONST"
  };
  IfcStructuralSurfaceActivityTypeEnum.BILINEAR = {
    type: 3,
    value: "BILINEAR"
  };
  IfcStructuralSurfaceActivityTypeEnum.DISCRETE = {
    type: 3,
    value: "DISCRETE"
  };
  IfcStructuralSurfaceActivityTypeEnum.ISOCONTOUR = {
    type: 3,
    value: "ISOCONTOUR"
  };
  IfcStructuralSurfaceActivityTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStructuralSurfaceActivityTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcStructuralSurfaceActivityTypeEnum = IfcStructuralSurfaceActivityTypeEnum;

  var IfcStructuralSurfaceMemberTypeEnum = function IfcStructuralSurfaceMemberTypeEnum() {
    _classCallCheck2(this, IfcStructuralSurfaceMemberTypeEnum);
  };

  IfcStructuralSurfaceMemberTypeEnum.BENDING_ELEMENT = {
    type: 3,
    value: "BENDING_ELEMENT"
  };
  IfcStructuralSurfaceMemberTypeEnum.MEMBRANE_ELEMENT = {
    type: 3,
    value: "MEMBRANE_ELEMENT"
  };
  IfcStructuralSurfaceMemberTypeEnum.SHELL = {
    type: 3,
    value: "SHELL"
  };
  IfcStructuralSurfaceMemberTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcStructuralSurfaceMemberTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcStructuralSurfaceMemberTypeEnum = IfcStructuralSurfaceMemberTypeEnum;

  var IfcSubContractResourceTypeEnum = function IfcSubContractResourceTypeEnum() {
    _classCallCheck2(this, IfcSubContractResourceTypeEnum);
  };

  IfcSubContractResourceTypeEnum.PURCHASE = {
    type: 3,
    value: "PURCHASE"
  };
  IfcSubContractResourceTypeEnum.WORK = {
    type: 3,
    value: "WORK"
  };
  IfcSubContractResourceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSubContractResourceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSubContractResourceTypeEnum = IfcSubContractResourceTypeEnum;

  var IfcSurfaceFeatureTypeEnum = function IfcSurfaceFeatureTypeEnum() {
    _classCallCheck2(this, IfcSurfaceFeatureTypeEnum);
  };

  IfcSurfaceFeatureTypeEnum.MARK = {
    type: 3,
    value: "MARK"
  };
  IfcSurfaceFeatureTypeEnum.TAG = {
    type: 3,
    value: "TAG"
  };
  IfcSurfaceFeatureTypeEnum.TREATMENT = {
    type: 3,
    value: "TREATMENT"
  };
  IfcSurfaceFeatureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSurfaceFeatureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSurfaceFeatureTypeEnum = IfcSurfaceFeatureTypeEnum;

  var IfcSurfaceSide = function IfcSurfaceSide() {
    _classCallCheck2(this, IfcSurfaceSide);
  };

  IfcSurfaceSide.POSITIVE = {
    type: 3,
    value: "POSITIVE"
  };
  IfcSurfaceSide.NEGATIVE = {
    type: 3,
    value: "NEGATIVE"
  };
  IfcSurfaceSide.BOTH = {
    type: 3,
    value: "BOTH"
  };
  IFC42.IfcSurfaceSide = IfcSurfaceSide;

  var IfcSwitchingDeviceTypeEnum = function IfcSwitchingDeviceTypeEnum() {
    _classCallCheck2(this, IfcSwitchingDeviceTypeEnum);
  };

  IfcSwitchingDeviceTypeEnum.CONTACTOR = {
    type: 3,
    value: "CONTACTOR"
  };
  IfcSwitchingDeviceTypeEnum.DIMMERSWITCH = {
    type: 3,
    value: "DIMMERSWITCH"
  };
  IfcSwitchingDeviceTypeEnum.EMERGENCYSTOP = {
    type: 3,
    value: "EMERGENCYSTOP"
  };
  IfcSwitchingDeviceTypeEnum.KEYPAD = {
    type: 3,
    value: "KEYPAD"
  };
  IfcSwitchingDeviceTypeEnum.MOMENTARYSWITCH = {
    type: 3,
    value: "MOMENTARYSWITCH"
  };
  IfcSwitchingDeviceTypeEnum.SELECTORSWITCH = {
    type: 3,
    value: "SELECTORSWITCH"
  };
  IfcSwitchingDeviceTypeEnum.STARTER = {
    type: 3,
    value: "STARTER"
  };
  IfcSwitchingDeviceTypeEnum.SWITCHDISCONNECTOR = {
    type: 3,
    value: "SWITCHDISCONNECTOR"
  };
  IfcSwitchingDeviceTypeEnum.TOGGLESWITCH = {
    type: 3,
    value: "TOGGLESWITCH"
  };
  IfcSwitchingDeviceTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSwitchingDeviceTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSwitchingDeviceTypeEnum = IfcSwitchingDeviceTypeEnum;

  var IfcSystemFurnitureElementTypeEnum = function IfcSystemFurnitureElementTypeEnum() {
    _classCallCheck2(this, IfcSystemFurnitureElementTypeEnum);
  };

  IfcSystemFurnitureElementTypeEnum.PANEL = {
    type: 3,
    value: "PANEL"
  };
  IfcSystemFurnitureElementTypeEnum.WORKSURFACE = {
    type: 3,
    value: "WORKSURFACE"
  };
  IfcSystemFurnitureElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcSystemFurnitureElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcSystemFurnitureElementTypeEnum = IfcSystemFurnitureElementTypeEnum;

  var IfcTankTypeEnum = function IfcTankTypeEnum() {
    _classCallCheck2(this, IfcTankTypeEnum);
  };

  IfcTankTypeEnum.BASIN = {
    type: 3,
    value: "BASIN"
  };
  IfcTankTypeEnum.BREAKPRESSURE = {
    type: 3,
    value: "BREAKPRESSURE"
  };
  IfcTankTypeEnum.EXPANSION = {
    type: 3,
    value: "EXPANSION"
  };
  IfcTankTypeEnum.FEEDANDEXPANSION = {
    type: 3,
    value: "FEEDANDEXPANSION"
  };
  IfcTankTypeEnum.PRESSUREVESSEL = {
    type: 3,
    value: "PRESSUREVESSEL"
  };
  IfcTankTypeEnum.STORAGE = {
    type: 3,
    value: "STORAGE"
  };
  IfcTankTypeEnum.VESSEL = {
    type: 3,
    value: "VESSEL"
  };
  IfcTankTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTankTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcTankTypeEnum = IfcTankTypeEnum;

  var IfcTaskDurationEnum = function IfcTaskDurationEnum() {
    _classCallCheck2(this, IfcTaskDurationEnum);
  };

  IfcTaskDurationEnum.ELAPSEDTIME = {
    type: 3,
    value: "ELAPSEDTIME"
  };
  IfcTaskDurationEnum.WORKTIME = {
    type: 3,
    value: "WORKTIME"
  };
  IfcTaskDurationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcTaskDurationEnum = IfcTaskDurationEnum;

  var IfcTaskTypeEnum = function IfcTaskTypeEnum() {
    _classCallCheck2(this, IfcTaskTypeEnum);
  };

  IfcTaskTypeEnum.ATTENDANCE = {
    type: 3,
    value: "ATTENDANCE"
  };
  IfcTaskTypeEnum.CONSTRUCTION = {
    type: 3,
    value: "CONSTRUCTION"
  };
  IfcTaskTypeEnum.DEMOLITION = {
    type: 3,
    value: "DEMOLITION"
  };
  IfcTaskTypeEnum.DISMANTLE = {
    type: 3,
    value: "DISMANTLE"
  };
  IfcTaskTypeEnum.DISPOSAL = {
    type: 3,
    value: "DISPOSAL"
  };
  IfcTaskTypeEnum.INSTALLATION = {
    type: 3,
    value: "INSTALLATION"
  };
  IfcTaskTypeEnum.LOGISTIC = {
    type: 3,
    value: "LOGISTIC"
  };
  IfcTaskTypeEnum.MAINTENANCE = {
    type: 3,
    value: "MAINTENANCE"
  };
  IfcTaskTypeEnum.MOVE = {
    type: 3,
    value: "MOVE"
  };
  IfcTaskTypeEnum.OPERATION = {
    type: 3,
    value: "OPERATION"
  };
  IfcTaskTypeEnum.REMOVAL = {
    type: 3,
    value: "REMOVAL"
  };
  IfcTaskTypeEnum.RENOVATION = {
    type: 3,
    value: "RENOVATION"
  };
  IfcTaskTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTaskTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcTaskTypeEnum = IfcTaskTypeEnum;

  var IfcTendonAnchorTypeEnum = function IfcTendonAnchorTypeEnum() {
    _classCallCheck2(this, IfcTendonAnchorTypeEnum);
  };

  IfcTendonAnchorTypeEnum.COUPLER = {
    type: 3,
    value: "COUPLER"
  };
  IfcTendonAnchorTypeEnum.FIXED_END = {
    type: 3,
    value: "FIXED_END"
  };
  IfcTendonAnchorTypeEnum.TENSIONING_END = {
    type: 3,
    value: "TENSIONING_END"
  };
  IfcTendonAnchorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTendonAnchorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcTendonAnchorTypeEnum = IfcTendonAnchorTypeEnum;

  var IfcTendonTypeEnum = function IfcTendonTypeEnum() {
    _classCallCheck2(this, IfcTendonTypeEnum);
  };

  IfcTendonTypeEnum.BAR = {
    type: 3,
    value: "BAR"
  };
  IfcTendonTypeEnum.COATED = {
    type: 3,
    value: "COATED"
  };
  IfcTendonTypeEnum.STRAND = {
    type: 3,
    value: "STRAND"
  };
  IfcTendonTypeEnum.WIRE = {
    type: 3,
    value: "WIRE"
  };
  IfcTendonTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTendonTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcTendonTypeEnum = IfcTendonTypeEnum;

  var IfcTextPath = function IfcTextPath() {
    _classCallCheck2(this, IfcTextPath);
  };

  IfcTextPath.LEFT = {
    type: 3,
    value: "LEFT"
  };
  IfcTextPath.RIGHT = {
    type: 3,
    value: "RIGHT"
  };
  IfcTextPath.UP = {
    type: 3,
    value: "UP"
  };
  IfcTextPath.DOWN = {
    type: 3,
    value: "DOWN"
  };
  IFC42.IfcTextPath = IfcTextPath;

  var IfcTimeSeriesDataTypeEnum = function IfcTimeSeriesDataTypeEnum() {
    _classCallCheck2(this, IfcTimeSeriesDataTypeEnum);
  };

  IfcTimeSeriesDataTypeEnum.CONTINUOUS = {
    type: 3,
    value: "CONTINUOUS"
  };
  IfcTimeSeriesDataTypeEnum.DISCRETE = {
    type: 3,
    value: "DISCRETE"
  };
  IfcTimeSeriesDataTypeEnum.DISCRETEBINARY = {
    type: 3,
    value: "DISCRETEBINARY"
  };
  IfcTimeSeriesDataTypeEnum.PIECEWISEBINARY = {
    type: 3,
    value: "PIECEWISEBINARY"
  };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONSTANT = {
    type: 3,
    value: "PIECEWISECONSTANT"
  };
  IfcTimeSeriesDataTypeEnum.PIECEWISECONTINUOUS = {
    type: 3,
    value: "PIECEWISECONTINUOUS"
  };
  IfcTimeSeriesDataTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcTimeSeriesDataTypeEnum = IfcTimeSeriesDataTypeEnum;

  var IfcTransformerTypeEnum = function IfcTransformerTypeEnum() {
    _classCallCheck2(this, IfcTransformerTypeEnum);
  };

  IfcTransformerTypeEnum.CURRENT = {
    type: 3,
    value: "CURRENT"
  };
  IfcTransformerTypeEnum.FREQUENCY = {
    type: 3,
    value: "FREQUENCY"
  };
  IfcTransformerTypeEnum.INVERTER = {
    type: 3,
    value: "INVERTER"
  };
  IfcTransformerTypeEnum.RECTIFIER = {
    type: 3,
    value: "RECTIFIER"
  };
  IfcTransformerTypeEnum.VOLTAGE = {
    type: 3,
    value: "VOLTAGE"
  };
  IfcTransformerTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTransformerTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcTransformerTypeEnum = IfcTransformerTypeEnum;

  var IfcTransitionCode = function IfcTransitionCode() {
    _classCallCheck2(this, IfcTransitionCode);
  };

  IfcTransitionCode.DISCONTINUOUS = {
    type: 3,
    value: "DISCONTINUOUS"
  };
  IfcTransitionCode.CONTINUOUS = {
    type: 3,
    value: "CONTINUOUS"
  };
  IfcTransitionCode.CONTSAMEGRADIENT = {
    type: 3,
    value: "CONTSAMEGRADIENT"
  };
  IfcTransitionCode.CONTSAMEGRADIENTSAMECURVATURE = {
    type: 3,
    value: "CONTSAMEGRADIENTSAMECURVATURE"
  };
  IFC42.IfcTransitionCode = IfcTransitionCode;

  var IfcTransportElementTypeEnum = function IfcTransportElementTypeEnum() {
    _classCallCheck2(this, IfcTransportElementTypeEnum);
  };

  IfcTransportElementTypeEnum.ELEVATOR = {
    type: 3,
    value: "ELEVATOR"
  };
  IfcTransportElementTypeEnum.ESCALATOR = {
    type: 3,
    value: "ESCALATOR"
  };
  IfcTransportElementTypeEnum.MOVINGWALKWAY = {
    type: 3,
    value: "MOVINGWALKWAY"
  };
  IfcTransportElementTypeEnum.CRANEWAY = {
    type: 3,
    value: "CRANEWAY"
  };
  IfcTransportElementTypeEnum.LIFTINGGEAR = {
    type: 3,
    value: "LIFTINGGEAR"
  };
  IfcTransportElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTransportElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcTransportElementTypeEnum = IfcTransportElementTypeEnum;

  var IfcTrimmingPreference = function IfcTrimmingPreference() {
    _classCallCheck2(this, IfcTrimmingPreference);
  };

  IfcTrimmingPreference.CARTESIAN = {
    type: 3,
    value: "CARTESIAN"
  };
  IfcTrimmingPreference.PARAMETER = {
    type: 3,
    value: "PARAMETER"
  };
  IfcTrimmingPreference.UNSPECIFIED = {
    type: 3,
    value: "UNSPECIFIED"
  };
  IFC42.IfcTrimmingPreference = IfcTrimmingPreference;

  var IfcTubeBundleTypeEnum = function IfcTubeBundleTypeEnum() {
    _classCallCheck2(this, IfcTubeBundleTypeEnum);
  };

  IfcTubeBundleTypeEnum.FINNED = {
    type: 3,
    value: "FINNED"
  };
  IfcTubeBundleTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcTubeBundleTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcTubeBundleTypeEnum = IfcTubeBundleTypeEnum;

  var IfcUnitEnum = function IfcUnitEnum() {
    _classCallCheck2(this, IfcUnitEnum);
  };

  IfcUnitEnum.ABSORBEDDOSEUNIT = {
    type: 3,
    value: "ABSORBEDDOSEUNIT"
  };
  IfcUnitEnum.AMOUNTOFSUBSTANCEUNIT = {
    type: 3,
    value: "AMOUNTOFSUBSTANCEUNIT"
  };
  IfcUnitEnum.AREAUNIT = {
    type: 3,
    value: "AREAUNIT"
  };
  IfcUnitEnum.DOSEEQUIVALENTUNIT = {
    type: 3,
    value: "DOSEEQUIVALENTUNIT"
  };
  IfcUnitEnum.ELECTRICCAPACITANCEUNIT = {
    type: 3,
    value: "ELECTRICCAPACITANCEUNIT"
  };
  IfcUnitEnum.ELECTRICCHARGEUNIT = {
    type: 3,
    value: "ELECTRICCHARGEUNIT"
  };
  IfcUnitEnum.ELECTRICCONDUCTANCEUNIT = {
    type: 3,
    value: "ELECTRICCONDUCTANCEUNIT"
  };
  IfcUnitEnum.ELECTRICCURRENTUNIT = {
    type: 3,
    value: "ELECTRICCURRENTUNIT"
  };
  IfcUnitEnum.ELECTRICRESISTANCEUNIT = {
    type: 3,
    value: "ELECTRICRESISTANCEUNIT"
  };
  IfcUnitEnum.ELECTRICVOLTAGEUNIT = {
    type: 3,
    value: "ELECTRICVOLTAGEUNIT"
  };
  IfcUnitEnum.ENERGYUNIT = {
    type: 3,
    value: "ENERGYUNIT"
  };
  IfcUnitEnum.FORCEUNIT = {
    type: 3,
    value: "FORCEUNIT"
  };
  IfcUnitEnum.FREQUENCYUNIT = {
    type: 3,
    value: "FREQUENCYUNIT"
  };
  IfcUnitEnum.ILLUMINANCEUNIT = {
    type: 3,
    value: "ILLUMINANCEUNIT"
  };
  IfcUnitEnum.INDUCTANCEUNIT = {
    type: 3,
    value: "INDUCTANCEUNIT"
  };
  IfcUnitEnum.LENGTHUNIT = {
    type: 3,
    value: "LENGTHUNIT"
  };
  IfcUnitEnum.LUMINOUSFLUXUNIT = {
    type: 3,
    value: "LUMINOUSFLUXUNIT"
  };
  IfcUnitEnum.LUMINOUSINTENSITYUNIT = {
    type: 3,
    value: "LUMINOUSINTENSITYUNIT"
  };
  IfcUnitEnum.MAGNETICFLUXDENSITYUNIT = {
    type: 3,
    value: "MAGNETICFLUXDENSITYUNIT"
  };
  IfcUnitEnum.MAGNETICFLUXUNIT = {
    type: 3,
    value: "MAGNETICFLUXUNIT"
  };
  IfcUnitEnum.MASSUNIT = {
    type: 3,
    value: "MASSUNIT"
  };
  IfcUnitEnum.PLANEANGLEUNIT = {
    type: 3,
    value: "PLANEANGLEUNIT"
  };
  IfcUnitEnum.POWERUNIT = {
    type: 3,
    value: "POWERUNIT"
  };
  IfcUnitEnum.PRESSUREUNIT = {
    type: 3,
    value: "PRESSUREUNIT"
  };
  IfcUnitEnum.RADIOACTIVITYUNIT = {
    type: 3,
    value: "RADIOACTIVITYUNIT"
  };
  IfcUnitEnum.SOLIDANGLEUNIT = {
    type: 3,
    value: "SOLIDANGLEUNIT"
  };
  IfcUnitEnum.THERMODYNAMICTEMPERATUREUNIT = {
    type: 3,
    value: "THERMODYNAMICTEMPERATUREUNIT"
  };
  IfcUnitEnum.TIMEUNIT = {
    type: 3,
    value: "TIMEUNIT"
  };
  IfcUnitEnum.VOLUMEUNIT = {
    type: 3,
    value: "VOLUMEUNIT"
  };
  IfcUnitEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IFC42.IfcUnitEnum = IfcUnitEnum;

  var IfcUnitaryControlElementTypeEnum = function IfcUnitaryControlElementTypeEnum() {
    _classCallCheck2(this, IfcUnitaryControlElementTypeEnum);
  };

  IfcUnitaryControlElementTypeEnum.ALARMPANEL = {
    type: 3,
    value: "ALARMPANEL"
  };
  IfcUnitaryControlElementTypeEnum.CONTROLPANEL = {
    type: 3,
    value: "CONTROLPANEL"
  };
  IfcUnitaryControlElementTypeEnum.GASDETECTIONPANEL = {
    type: 3,
    value: "GASDETECTIONPANEL"
  };
  IfcUnitaryControlElementTypeEnum.INDICATORPANEL = {
    type: 3,
    value: "INDICATORPANEL"
  };
  IfcUnitaryControlElementTypeEnum.MIMICPANEL = {
    type: 3,
    value: "MIMICPANEL"
  };
  IfcUnitaryControlElementTypeEnum.HUMIDISTAT = {
    type: 3,
    value: "HUMIDISTAT"
  };
  IfcUnitaryControlElementTypeEnum.THERMOSTAT = {
    type: 3,
    value: "THERMOSTAT"
  };
  IfcUnitaryControlElementTypeEnum.WEATHERSTATION = {
    type: 3,
    value: "WEATHERSTATION"
  };
  IfcUnitaryControlElementTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcUnitaryControlElementTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcUnitaryControlElementTypeEnum = IfcUnitaryControlElementTypeEnum;

  var IfcUnitaryEquipmentTypeEnum = function IfcUnitaryEquipmentTypeEnum() {
    _classCallCheck2(this, IfcUnitaryEquipmentTypeEnum);
  };

  IfcUnitaryEquipmentTypeEnum.AIRHANDLER = {
    type: 3,
    value: "AIRHANDLER"
  };
  IfcUnitaryEquipmentTypeEnum.AIRCONDITIONINGUNIT = {
    type: 3,
    value: "AIRCONDITIONINGUNIT"
  };
  IfcUnitaryEquipmentTypeEnum.DEHUMIDIFIER = {
    type: 3,
    value: "DEHUMIDIFIER"
  };
  IfcUnitaryEquipmentTypeEnum.SPLITSYSTEM = {
    type: 3,
    value: "SPLITSYSTEM"
  };
  IfcUnitaryEquipmentTypeEnum.ROOFTOPUNIT = {
    type: 3,
    value: "ROOFTOPUNIT"
  };
  IfcUnitaryEquipmentTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcUnitaryEquipmentTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcUnitaryEquipmentTypeEnum = IfcUnitaryEquipmentTypeEnum;

  var IfcValveTypeEnum = function IfcValveTypeEnum() {
    _classCallCheck2(this, IfcValveTypeEnum);
  };

  IfcValveTypeEnum.AIRRELEASE = {
    type: 3,
    value: "AIRRELEASE"
  };
  IfcValveTypeEnum.ANTIVACUUM = {
    type: 3,
    value: "ANTIVACUUM"
  };
  IfcValveTypeEnum.CHANGEOVER = {
    type: 3,
    value: "CHANGEOVER"
  };
  IfcValveTypeEnum.CHECK = {
    type: 3,
    value: "CHECK"
  };
  IfcValveTypeEnum.COMMISSIONING = {
    type: 3,
    value: "COMMISSIONING"
  };
  IfcValveTypeEnum.DIVERTING = {
    type: 3,
    value: "DIVERTING"
  };
  IfcValveTypeEnum.DRAWOFFCOCK = {
    type: 3,
    value: "DRAWOFFCOCK"
  };
  IfcValveTypeEnum.DOUBLECHECK = {
    type: 3,
    value: "DOUBLECHECK"
  };
  IfcValveTypeEnum.DOUBLEREGULATING = {
    type: 3,
    value: "DOUBLEREGULATING"
  };
  IfcValveTypeEnum.FAUCET = {
    type: 3,
    value: "FAUCET"
  };
  IfcValveTypeEnum.FLUSHING = {
    type: 3,
    value: "FLUSHING"
  };
  IfcValveTypeEnum.GASCOCK = {
    type: 3,
    value: "GASCOCK"
  };
  IfcValveTypeEnum.GASTAP = {
    type: 3,
    value: "GASTAP"
  };
  IfcValveTypeEnum.ISOLATING = {
    type: 3,
    value: "ISOLATING"
  };
  IfcValveTypeEnum.MIXING = {
    type: 3,
    value: "MIXING"
  };
  IfcValveTypeEnum.PRESSUREREDUCING = {
    type: 3,
    value: "PRESSUREREDUCING"
  };
  IfcValveTypeEnum.PRESSURERELIEF = {
    type: 3,
    value: "PRESSURERELIEF"
  };
  IfcValveTypeEnum.REGULATING = {
    type: 3,
    value: "REGULATING"
  };
  IfcValveTypeEnum.SAFETYCUTOFF = {
    type: 3,
    value: "SAFETYCUTOFF"
  };
  IfcValveTypeEnum.STEAMTRAP = {
    type: 3,
    value: "STEAMTRAP"
  };
  IfcValveTypeEnum.STOPCOCK = {
    type: 3,
    value: "STOPCOCK"
  };
  IfcValveTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcValveTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcValveTypeEnum = IfcValveTypeEnum;

  var IfcVibrationIsolatorTypeEnum = function IfcVibrationIsolatorTypeEnum() {
    _classCallCheck2(this, IfcVibrationIsolatorTypeEnum);
  };

  IfcVibrationIsolatorTypeEnum.COMPRESSION = {
    type: 3,
    value: "COMPRESSION"
  };
  IfcVibrationIsolatorTypeEnum.SPRING = {
    type: 3,
    value: "SPRING"
  };
  IfcVibrationIsolatorTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcVibrationIsolatorTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcVibrationIsolatorTypeEnum = IfcVibrationIsolatorTypeEnum;

  var IfcVoidingFeatureTypeEnum = function IfcVoidingFeatureTypeEnum() {
    _classCallCheck2(this, IfcVoidingFeatureTypeEnum);
  };

  IfcVoidingFeatureTypeEnum.CUTOUT = {
    type: 3,
    value: "CUTOUT"
  };
  IfcVoidingFeatureTypeEnum.NOTCH = {
    type: 3,
    value: "NOTCH"
  };
  IfcVoidingFeatureTypeEnum.HOLE = {
    type: 3,
    value: "HOLE"
  };
  IfcVoidingFeatureTypeEnum.MITER = {
    type: 3,
    value: "MITER"
  };
  IfcVoidingFeatureTypeEnum.CHAMFER = {
    type: 3,
    value: "CHAMFER"
  };
  IfcVoidingFeatureTypeEnum.EDGE = {
    type: 3,
    value: "EDGE"
  };
  IfcVoidingFeatureTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcVoidingFeatureTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcVoidingFeatureTypeEnum = IfcVoidingFeatureTypeEnum;

  var IfcWallTypeEnum = function IfcWallTypeEnum() {
    _classCallCheck2(this, IfcWallTypeEnum);
  };

  IfcWallTypeEnum.MOVABLE = {
    type: 3,
    value: "MOVABLE"
  };
  IfcWallTypeEnum.PARAPET = {
    type: 3,
    value: "PARAPET"
  };
  IfcWallTypeEnum.PARTITIONING = {
    type: 3,
    value: "PARTITIONING"
  };
  IfcWallTypeEnum.PLUMBINGWALL = {
    type: 3,
    value: "PLUMBINGWALL"
  };
  IfcWallTypeEnum.SHEAR = {
    type: 3,
    value: "SHEAR"
  };
  IfcWallTypeEnum.SOLIDWALL = {
    type: 3,
    value: "SOLIDWALL"
  };
  IfcWallTypeEnum.STANDARD = {
    type: 3,
    value: "STANDARD"
  };
  IfcWallTypeEnum.POLYGONAL = {
    type: 3,
    value: "POLYGONAL"
  };
  IfcWallTypeEnum.ELEMENTEDWALL = {
    type: 3,
    value: "ELEMENTEDWALL"
  };
  IfcWallTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWallTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcWallTypeEnum = IfcWallTypeEnum;

  var IfcWasteTerminalTypeEnum = function IfcWasteTerminalTypeEnum() {
    _classCallCheck2(this, IfcWasteTerminalTypeEnum);
  };

  IfcWasteTerminalTypeEnum.FLOORTRAP = {
    type: 3,
    value: "FLOORTRAP"
  };
  IfcWasteTerminalTypeEnum.FLOORWASTE = {
    type: 3,
    value: "FLOORWASTE"
  };
  IfcWasteTerminalTypeEnum.GULLYSUMP = {
    type: 3,
    value: "GULLYSUMP"
  };
  IfcWasteTerminalTypeEnum.GULLYTRAP = {
    type: 3,
    value: "GULLYTRAP"
  };
  IfcWasteTerminalTypeEnum.ROOFDRAIN = {
    type: 3,
    value: "ROOFDRAIN"
  };
  IfcWasteTerminalTypeEnum.WASTEDISPOSALUNIT = {
    type: 3,
    value: "WASTEDISPOSALUNIT"
  };
  IfcWasteTerminalTypeEnum.WASTETRAP = {
    type: 3,
    value: "WASTETRAP"
  };
  IfcWasteTerminalTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWasteTerminalTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcWasteTerminalTypeEnum = IfcWasteTerminalTypeEnum;

  var IfcWindowPanelOperationEnum = function IfcWindowPanelOperationEnum() {
    _classCallCheck2(this, IfcWindowPanelOperationEnum);
  };

  IfcWindowPanelOperationEnum.SIDEHUNGRIGHTHAND = {
    type: 3,
    value: "SIDEHUNGRIGHTHAND"
  };
  IfcWindowPanelOperationEnum.SIDEHUNGLEFTHAND = {
    type: 3,
    value: "SIDEHUNGLEFTHAND"
  };
  IfcWindowPanelOperationEnum.TILTANDTURNRIGHTHAND = {
    type: 3,
    value: "TILTANDTURNRIGHTHAND"
  };
  IfcWindowPanelOperationEnum.TILTANDTURNLEFTHAND = {
    type: 3,
    value: "TILTANDTURNLEFTHAND"
  };
  IfcWindowPanelOperationEnum.TOPHUNG = {
    type: 3,
    value: "TOPHUNG"
  };
  IfcWindowPanelOperationEnum.BOTTOMHUNG = {
    type: 3,
    value: "BOTTOMHUNG"
  };
  IfcWindowPanelOperationEnum.PIVOTHORIZONTAL = {
    type: 3,
    value: "PIVOTHORIZONTAL"
  };
  IfcWindowPanelOperationEnum.PIVOTVERTICAL = {
    type: 3,
    value: "PIVOTVERTICAL"
  };
  IfcWindowPanelOperationEnum.SLIDINGHORIZONTAL = {
    type: 3,
    value: "SLIDINGHORIZONTAL"
  };
  IfcWindowPanelOperationEnum.SLIDINGVERTICAL = {
    type: 3,
    value: "SLIDINGVERTICAL"
  };
  IfcWindowPanelOperationEnum.REMOVABLECASEMENT = {
    type: 3,
    value: "REMOVABLECASEMENT"
  };
  IfcWindowPanelOperationEnum.FIXEDCASEMENT = {
    type: 3,
    value: "FIXEDCASEMENT"
  };
  IfcWindowPanelOperationEnum.OTHEROPERATION = {
    type: 3,
    value: "OTHEROPERATION"
  };
  IfcWindowPanelOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcWindowPanelOperationEnum = IfcWindowPanelOperationEnum;

  var IfcWindowPanelPositionEnum = function IfcWindowPanelPositionEnum() {
    _classCallCheck2(this, IfcWindowPanelPositionEnum);
  };

  IfcWindowPanelPositionEnum.LEFT = {
    type: 3,
    value: "LEFT"
  };
  IfcWindowPanelPositionEnum.MIDDLE = {
    type: 3,
    value: "MIDDLE"
  };
  IfcWindowPanelPositionEnum.RIGHT = {
    type: 3,
    value: "RIGHT"
  };
  IfcWindowPanelPositionEnum.BOTTOM = {
    type: 3,
    value: "BOTTOM"
  };
  IfcWindowPanelPositionEnum.TOP = {
    type: 3,
    value: "TOP"
  };
  IfcWindowPanelPositionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcWindowPanelPositionEnum = IfcWindowPanelPositionEnum;

  var IfcWindowStyleConstructionEnum = function IfcWindowStyleConstructionEnum() {
    _classCallCheck2(this, IfcWindowStyleConstructionEnum);
  };

  IfcWindowStyleConstructionEnum.ALUMINIUM = {
    type: 3,
    value: "ALUMINIUM"
  };
  IfcWindowStyleConstructionEnum.HIGH_GRADE_STEEL = {
    type: 3,
    value: "HIGH_GRADE_STEEL"
  };
  IfcWindowStyleConstructionEnum.STEEL = {
    type: 3,
    value: "STEEL"
  };
  IfcWindowStyleConstructionEnum.WOOD = {
    type: 3,
    value: "WOOD"
  };
  IfcWindowStyleConstructionEnum.ALUMINIUM_WOOD = {
    type: 3,
    value: "ALUMINIUM_WOOD"
  };
  IfcWindowStyleConstructionEnum.PLASTIC = {
    type: 3,
    value: "PLASTIC"
  };
  IfcWindowStyleConstructionEnum.OTHER_CONSTRUCTION = {
    type: 3,
    value: "OTHER_CONSTRUCTION"
  };
  IfcWindowStyleConstructionEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcWindowStyleConstructionEnum = IfcWindowStyleConstructionEnum;

  var IfcWindowStyleOperationEnum = function IfcWindowStyleOperationEnum() {
    _classCallCheck2(this, IfcWindowStyleOperationEnum);
  };

  IfcWindowStyleOperationEnum.SINGLE_PANEL = {
    type: 3,
    value: "SINGLE_PANEL"
  };
  IfcWindowStyleOperationEnum.DOUBLE_PANEL_VERTICAL = {
    type: 3,
    value: "DOUBLE_PANEL_VERTICAL"
  };
  IfcWindowStyleOperationEnum.DOUBLE_PANEL_HORIZONTAL = {
    type: 3,
    value: "DOUBLE_PANEL_HORIZONTAL"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_VERTICAL = {
    type: 3,
    value: "TRIPLE_PANEL_VERTICAL"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_BOTTOM = {
    type: 3,
    value: "TRIPLE_PANEL_BOTTOM"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_TOP = {
    type: 3,
    value: "TRIPLE_PANEL_TOP"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_LEFT = {
    type: 3,
    value: "TRIPLE_PANEL_LEFT"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_RIGHT = {
    type: 3,
    value: "TRIPLE_PANEL_RIGHT"
  };
  IfcWindowStyleOperationEnum.TRIPLE_PANEL_HORIZONTAL = {
    type: 3,
    value: "TRIPLE_PANEL_HORIZONTAL"
  };
  IfcWindowStyleOperationEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWindowStyleOperationEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcWindowStyleOperationEnum = IfcWindowStyleOperationEnum;

  var IfcWindowTypeEnum = function IfcWindowTypeEnum() {
    _classCallCheck2(this, IfcWindowTypeEnum);
  };

  IfcWindowTypeEnum.WINDOW = {
    type: 3,
    value: "WINDOW"
  };
  IfcWindowTypeEnum.SKYLIGHT = {
    type: 3,
    value: "SKYLIGHT"
  };
  IfcWindowTypeEnum.LIGHTDOME = {
    type: 3,
    value: "LIGHTDOME"
  };
  IfcWindowTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWindowTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcWindowTypeEnum = IfcWindowTypeEnum;

  var IfcWindowTypePartitioningEnum = function IfcWindowTypePartitioningEnum() {
    _classCallCheck2(this, IfcWindowTypePartitioningEnum);
  };

  IfcWindowTypePartitioningEnum.SINGLE_PANEL = {
    type: 3,
    value: "SINGLE_PANEL"
  };
  IfcWindowTypePartitioningEnum.DOUBLE_PANEL_VERTICAL = {
    type: 3,
    value: "DOUBLE_PANEL_VERTICAL"
  };
  IfcWindowTypePartitioningEnum.DOUBLE_PANEL_HORIZONTAL = {
    type: 3,
    value: "DOUBLE_PANEL_HORIZONTAL"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_VERTICAL = {
    type: 3,
    value: "TRIPLE_PANEL_VERTICAL"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_BOTTOM = {
    type: 3,
    value: "TRIPLE_PANEL_BOTTOM"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_TOP = {
    type: 3,
    value: "TRIPLE_PANEL_TOP"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_LEFT = {
    type: 3,
    value: "TRIPLE_PANEL_LEFT"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_RIGHT = {
    type: 3,
    value: "TRIPLE_PANEL_RIGHT"
  };
  IfcWindowTypePartitioningEnum.TRIPLE_PANEL_HORIZONTAL = {
    type: 3,
    value: "TRIPLE_PANEL_HORIZONTAL"
  };
  IfcWindowTypePartitioningEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWindowTypePartitioningEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcWindowTypePartitioningEnum = IfcWindowTypePartitioningEnum;

  var IfcWorkCalendarTypeEnum = function IfcWorkCalendarTypeEnum() {
    _classCallCheck2(this, IfcWorkCalendarTypeEnum);
  };

  IfcWorkCalendarTypeEnum.FIRSTSHIFT = {
    type: 3,
    value: "FIRSTSHIFT"
  };
  IfcWorkCalendarTypeEnum.SECONDSHIFT = {
    type: 3,
    value: "SECONDSHIFT"
  };
  IfcWorkCalendarTypeEnum.THIRDSHIFT = {
    type: 3,
    value: "THIRDSHIFT"
  };
  IfcWorkCalendarTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWorkCalendarTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcWorkCalendarTypeEnum = IfcWorkCalendarTypeEnum;

  var IfcWorkPlanTypeEnum = function IfcWorkPlanTypeEnum() {
    _classCallCheck2(this, IfcWorkPlanTypeEnum);
  };

  IfcWorkPlanTypeEnum.ACTUAL = {
    type: 3,
    value: "ACTUAL"
  };
  IfcWorkPlanTypeEnum.BASELINE = {
    type: 3,
    value: "BASELINE"
  };
  IfcWorkPlanTypeEnum.PLANNED = {
    type: 3,
    value: "PLANNED"
  };
  IfcWorkPlanTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWorkPlanTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcWorkPlanTypeEnum = IfcWorkPlanTypeEnum;

  var IfcWorkScheduleTypeEnum = function IfcWorkScheduleTypeEnum() {
    _classCallCheck2(this, IfcWorkScheduleTypeEnum);
  };

  IfcWorkScheduleTypeEnum.ACTUAL = {
    type: 3,
    value: "ACTUAL"
  };
  IfcWorkScheduleTypeEnum.BASELINE = {
    type: 3,
    value: "BASELINE"
  };
  IfcWorkScheduleTypeEnum.PLANNED = {
    type: 3,
    value: "PLANNED"
  };
  IfcWorkScheduleTypeEnum.USERDEFINED = {
    type: 3,
    value: "USERDEFINED"
  };
  IfcWorkScheduleTypeEnum.NOTDEFINED = {
    type: 3,
    value: "NOTDEFINED"
  };
  IFC42.IfcWorkScheduleTypeEnum = IfcWorkScheduleTypeEnum;

  var IfcActorRole = /*#__PURE__*/function (_IfcLineObject162) {
    _inherits(IfcActorRole, _IfcLineObject162);

    var _super1617 = _createSuper(IfcActorRole);

    function IfcActorRole(expressID, Role, UserDefinedRole, Description) {
      var _this1609;

      _classCallCheck2(this, IfcActorRole);

      _this1609 = _super1617.call(this, expressID);
      _this1609.Role = Role;
      _this1609.UserDefinedRole = UserDefinedRole;
      _this1609.Description = Description;
      _this1609.type = 3630933823;
      return _this1609;
    }

    return IfcActorRole;
  }(IfcLineObject);

  IFC42.IfcActorRole = IfcActorRole;

  var IfcAddress = /*#__PURE__*/function (_IfcLineObject163) {
    _inherits(IfcAddress, _IfcLineObject163);

    var _super1618 = _createSuper(IfcAddress);

    function IfcAddress(expressID, Purpose, Description, UserDefinedPurpose) {
      var _this1610;

      _classCallCheck2(this, IfcAddress);

      _this1610 = _super1618.call(this, expressID);
      _this1610.Purpose = Purpose;
      _this1610.Description = Description;
      _this1610.UserDefinedPurpose = UserDefinedPurpose;
      _this1610.type = 618182010;
      return _this1610;
    }

    return IfcAddress;
  }(IfcLineObject);

  IFC42.IfcAddress = IfcAddress;

  var IfcApplication = /*#__PURE__*/function (_IfcLineObject164) {
    _inherits(IfcApplication, _IfcLineObject164);

    var _super1619 = _createSuper(IfcApplication);

    function IfcApplication(expressID, ApplicationDeveloper, Version, ApplicationFullName, ApplicationIdentifier) {
      var _this1611;

      _classCallCheck2(this, IfcApplication);

      _this1611 = _super1619.call(this, expressID);
      _this1611.ApplicationDeveloper = ApplicationDeveloper;
      _this1611.Version = Version;
      _this1611.ApplicationFullName = ApplicationFullName;
      _this1611.ApplicationIdentifier = ApplicationIdentifier;
      _this1611.type = 639542469;
      return _this1611;
    }

    return IfcApplication;
  }(IfcLineObject);

  IFC42.IfcApplication = IfcApplication;

  var IfcAppliedValue = /*#__PURE__*/function (_IfcLineObject165) {
    _inherits(IfcAppliedValue, _IfcLineObject165);

    var _super1620 = _createSuper(IfcAppliedValue);

    function IfcAppliedValue(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      var _this1612;

      _classCallCheck2(this, IfcAppliedValue);

      _this1612 = _super1620.call(this, expressID);
      _this1612.Name = Name;
      _this1612.Description = Description;
      _this1612.AppliedValue = AppliedValue;
      _this1612.UnitBasis = UnitBasis;
      _this1612.ApplicableDate = ApplicableDate;
      _this1612.FixedUntilDate = FixedUntilDate;
      _this1612.Category = Category;
      _this1612.Condition = Condition;
      _this1612.ArithmeticOperator = ArithmeticOperator;
      _this1612.Components = Components;
      _this1612.type = 411424972;
      return _this1612;
    }

    return IfcAppliedValue;
  }(IfcLineObject);

  IFC42.IfcAppliedValue = IfcAppliedValue;

  var IfcApproval = /*#__PURE__*/function (_IfcLineObject166) {
    _inherits(IfcApproval, _IfcLineObject166);

    var _super1621 = _createSuper(IfcApproval);

    function IfcApproval(expressID, Identifier, Name, Description, TimeOfApproval, Status, Level, Qualifier, RequestingApproval, GivingApproval) {
      var _this1613;

      _classCallCheck2(this, IfcApproval);

      _this1613 = _super1621.call(this, expressID);
      _this1613.Identifier = Identifier;
      _this1613.Name = Name;
      _this1613.Description = Description;
      _this1613.TimeOfApproval = TimeOfApproval;
      _this1613.Status = Status;
      _this1613.Level = Level;
      _this1613.Qualifier = Qualifier;
      _this1613.RequestingApproval = RequestingApproval;
      _this1613.GivingApproval = GivingApproval;
      _this1613.type = 130549933;
      return _this1613;
    }

    return IfcApproval;
  }(IfcLineObject);

  IFC42.IfcApproval = IfcApproval;

  var IfcBoundaryCondition = /*#__PURE__*/function (_IfcLineObject167) {
    _inherits(IfcBoundaryCondition, _IfcLineObject167);

    var _super1622 = _createSuper(IfcBoundaryCondition);

    function IfcBoundaryCondition(expressID, Name) {
      var _this1614;

      _classCallCheck2(this, IfcBoundaryCondition);

      _this1614 = _super1622.call(this, expressID);
      _this1614.Name = Name;
      _this1614.type = 4037036970;
      return _this1614;
    }

    return IfcBoundaryCondition;
  }(IfcLineObject);

  IFC42.IfcBoundaryCondition = IfcBoundaryCondition;

  var IfcBoundaryEdgeCondition = /*#__PURE__*/function (_IfcBoundaryCondition7) {
    _inherits(IfcBoundaryEdgeCondition, _IfcBoundaryCondition7);

    var _super1623 = _createSuper(IfcBoundaryEdgeCondition);

    function IfcBoundaryEdgeCondition(expressID, Name, TranslationalStiffnessByLengthX, TranslationalStiffnessByLengthY, TranslationalStiffnessByLengthZ, RotationalStiffnessByLengthX, RotationalStiffnessByLengthY, RotationalStiffnessByLengthZ) {
      var _this1615;

      _classCallCheck2(this, IfcBoundaryEdgeCondition);

      _this1615 = _super1623.call(this, expressID, Name);
      _this1615.Name = Name;
      _this1615.TranslationalStiffnessByLengthX = TranslationalStiffnessByLengthX;
      _this1615.TranslationalStiffnessByLengthY = TranslationalStiffnessByLengthY;
      _this1615.TranslationalStiffnessByLengthZ = TranslationalStiffnessByLengthZ;
      _this1615.RotationalStiffnessByLengthX = RotationalStiffnessByLengthX;
      _this1615.RotationalStiffnessByLengthY = RotationalStiffnessByLengthY;
      _this1615.RotationalStiffnessByLengthZ = RotationalStiffnessByLengthZ;
      _this1615.type = 1560379544;
      return _this1615;
    }

    return IfcBoundaryEdgeCondition;
  }(IfcBoundaryCondition);

  IFC42.IfcBoundaryEdgeCondition = IfcBoundaryEdgeCondition;

  var IfcBoundaryFaceCondition = /*#__PURE__*/function (_IfcBoundaryCondition8) {
    _inherits(IfcBoundaryFaceCondition, _IfcBoundaryCondition8);

    var _super1624 = _createSuper(IfcBoundaryFaceCondition);

    function IfcBoundaryFaceCondition(expressID, Name, TranslationalStiffnessByAreaX, TranslationalStiffnessByAreaY, TranslationalStiffnessByAreaZ) {
      var _this1616;

      _classCallCheck2(this, IfcBoundaryFaceCondition);

      _this1616 = _super1624.call(this, expressID, Name);
      _this1616.Name = Name;
      _this1616.TranslationalStiffnessByAreaX = TranslationalStiffnessByAreaX;
      _this1616.TranslationalStiffnessByAreaY = TranslationalStiffnessByAreaY;
      _this1616.TranslationalStiffnessByAreaZ = TranslationalStiffnessByAreaZ;
      _this1616.type = 3367102660;
      return _this1616;
    }

    return IfcBoundaryFaceCondition;
  }(IfcBoundaryCondition);

  IFC42.IfcBoundaryFaceCondition = IfcBoundaryFaceCondition;

  var IfcBoundaryNodeCondition = /*#__PURE__*/function (_IfcBoundaryCondition9) {
    _inherits(IfcBoundaryNodeCondition, _IfcBoundaryCondition9);

    var _super1625 = _createSuper(IfcBoundaryNodeCondition);

    function IfcBoundaryNodeCondition(expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ) {
      var _this1617;

      _classCallCheck2(this, IfcBoundaryNodeCondition);

      _this1617 = _super1625.call(this, expressID, Name);
      _this1617.Name = Name;
      _this1617.TranslationalStiffnessX = TranslationalStiffnessX;
      _this1617.TranslationalStiffnessY = TranslationalStiffnessY;
      _this1617.TranslationalStiffnessZ = TranslationalStiffnessZ;
      _this1617.RotationalStiffnessX = RotationalStiffnessX;
      _this1617.RotationalStiffnessY = RotationalStiffnessY;
      _this1617.RotationalStiffnessZ = RotationalStiffnessZ;
      _this1617.type = 1387855156;
      return _this1617;
    }

    return IfcBoundaryNodeCondition;
  }(IfcBoundaryCondition);

  IFC42.IfcBoundaryNodeCondition = IfcBoundaryNodeCondition;

  var IfcBoundaryNodeConditionWarping = /*#__PURE__*/function (_IfcBoundaryNodeCondi3) {
    _inherits(IfcBoundaryNodeConditionWarping, _IfcBoundaryNodeCondi3);

    var _super1626 = _createSuper(IfcBoundaryNodeConditionWarping);

    function IfcBoundaryNodeConditionWarping(expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ, WarpingStiffness) {
      var _this1618;

      _classCallCheck2(this, IfcBoundaryNodeConditionWarping);

      _this1618 = _super1626.call(this, expressID, Name, TranslationalStiffnessX, TranslationalStiffnessY, TranslationalStiffnessZ, RotationalStiffnessX, RotationalStiffnessY, RotationalStiffnessZ);
      _this1618.Name = Name;
      _this1618.TranslationalStiffnessX = TranslationalStiffnessX;
      _this1618.TranslationalStiffnessY = TranslationalStiffnessY;
      _this1618.TranslationalStiffnessZ = TranslationalStiffnessZ;
      _this1618.RotationalStiffnessX = RotationalStiffnessX;
      _this1618.RotationalStiffnessY = RotationalStiffnessY;
      _this1618.RotationalStiffnessZ = RotationalStiffnessZ;
      _this1618.WarpingStiffness = WarpingStiffness;
      _this1618.type = 2069777674;
      return _this1618;
    }

    return IfcBoundaryNodeConditionWarping;
  }(IfcBoundaryNodeCondition);

  IFC42.IfcBoundaryNodeConditionWarping = IfcBoundaryNodeConditionWarping;

  var IfcConnectionGeometry = /*#__PURE__*/function (_IfcLineObject168) {
    _inherits(IfcConnectionGeometry, _IfcLineObject168);

    var _super1627 = _createSuper(IfcConnectionGeometry);

    function IfcConnectionGeometry(expressID) {
      var _this1619;

      _classCallCheck2(this, IfcConnectionGeometry);

      _this1619 = _super1627.call(this, expressID);
      _this1619.type = 2859738748;
      return _this1619;
    }

    return IfcConnectionGeometry;
  }(IfcLineObject);

  IFC42.IfcConnectionGeometry = IfcConnectionGeometry;

  var IfcConnectionPointGeometry = /*#__PURE__*/function (_IfcConnectionGeometr9) {
    _inherits(IfcConnectionPointGeometry, _IfcConnectionGeometr9);

    var _super1628 = _createSuper(IfcConnectionPointGeometry);

    function IfcConnectionPointGeometry(expressID, PointOnRelatingElement, PointOnRelatedElement) {
      var _this1620;

      _classCallCheck2(this, IfcConnectionPointGeometry);

      _this1620 = _super1628.call(this, expressID);
      _this1620.PointOnRelatingElement = PointOnRelatingElement;
      _this1620.PointOnRelatedElement = PointOnRelatedElement;
      _this1620.type = 2614616156;
      return _this1620;
    }

    return IfcConnectionPointGeometry;
  }(IfcConnectionGeometry);

  IFC42.IfcConnectionPointGeometry = IfcConnectionPointGeometry;

  var IfcConnectionSurfaceGeometry = /*#__PURE__*/function (_IfcConnectionGeometr10) {
    _inherits(IfcConnectionSurfaceGeometry, _IfcConnectionGeometr10);

    var _super1629 = _createSuper(IfcConnectionSurfaceGeometry);

    function IfcConnectionSurfaceGeometry(expressID, SurfaceOnRelatingElement, SurfaceOnRelatedElement) {
      var _this1621;

      _classCallCheck2(this, IfcConnectionSurfaceGeometry);

      _this1621 = _super1629.call(this, expressID);
      _this1621.SurfaceOnRelatingElement = SurfaceOnRelatingElement;
      _this1621.SurfaceOnRelatedElement = SurfaceOnRelatedElement;
      _this1621.type = 2732653382;
      return _this1621;
    }

    return IfcConnectionSurfaceGeometry;
  }(IfcConnectionGeometry);

  IFC42.IfcConnectionSurfaceGeometry = IfcConnectionSurfaceGeometry;

  var IfcConnectionVolumeGeometry = /*#__PURE__*/function (_IfcConnectionGeometr11) {
    _inherits(IfcConnectionVolumeGeometry, _IfcConnectionGeometr11);

    var _super1630 = _createSuper(IfcConnectionVolumeGeometry);

    function IfcConnectionVolumeGeometry(expressID, VolumeOnRelatingElement, VolumeOnRelatedElement) {
      var _this1622;

      _classCallCheck2(this, IfcConnectionVolumeGeometry);

      _this1622 = _super1630.call(this, expressID);
      _this1622.VolumeOnRelatingElement = VolumeOnRelatingElement;
      _this1622.VolumeOnRelatedElement = VolumeOnRelatedElement;
      _this1622.type = 775493141;
      return _this1622;
    }

    return IfcConnectionVolumeGeometry;
  }(IfcConnectionGeometry);

  IFC42.IfcConnectionVolumeGeometry = IfcConnectionVolumeGeometry;

  var IfcConstraint = /*#__PURE__*/function (_IfcLineObject169) {
    _inherits(IfcConstraint, _IfcLineObject169);

    var _super1631 = _createSuper(IfcConstraint);

    function IfcConstraint(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade) {
      var _this1623;

      _classCallCheck2(this, IfcConstraint);

      _this1623 = _super1631.call(this, expressID);
      _this1623.Name = Name;
      _this1623.Description = Description;
      _this1623.ConstraintGrade = ConstraintGrade;
      _this1623.ConstraintSource = ConstraintSource;
      _this1623.CreatingActor = CreatingActor;
      _this1623.CreationTime = CreationTime;
      _this1623.UserDefinedGrade = UserDefinedGrade;
      _this1623.type = 1959218052;
      return _this1623;
    }

    return IfcConstraint;
  }(IfcLineObject);

  IFC42.IfcConstraint = IfcConstraint;

  var IfcCoordinateOperation = /*#__PURE__*/function (_IfcLineObject170) {
    _inherits(IfcCoordinateOperation, _IfcLineObject170);

    var _super1632 = _createSuper(IfcCoordinateOperation);

    function IfcCoordinateOperation(expressID, SourceCRS, TargetCRS) {
      var _this1624;

      _classCallCheck2(this, IfcCoordinateOperation);

      _this1624 = _super1632.call(this, expressID);
      _this1624.SourceCRS = SourceCRS;
      _this1624.TargetCRS = TargetCRS;
      _this1624.type = 1785450214;
      return _this1624;
    }

    return IfcCoordinateOperation;
  }(IfcLineObject);

  IFC42.IfcCoordinateOperation = IfcCoordinateOperation;

  var IfcCoordinateReferenceSystem = /*#__PURE__*/function (_IfcLineObject171) {
    _inherits(IfcCoordinateReferenceSystem, _IfcLineObject171);

    var _super1633 = _createSuper(IfcCoordinateReferenceSystem);

    function IfcCoordinateReferenceSystem(expressID, Name, Description, GeodeticDatum, VerticalDatum) {
      var _this1625;

      _classCallCheck2(this, IfcCoordinateReferenceSystem);

      _this1625 = _super1633.call(this, expressID);
      _this1625.Name = Name;
      _this1625.Description = Description;
      _this1625.GeodeticDatum = GeodeticDatum;
      _this1625.VerticalDatum = VerticalDatum;
      _this1625.type = 1466758467;
      return _this1625;
    }

    return IfcCoordinateReferenceSystem;
  }(IfcLineObject);

  IFC42.IfcCoordinateReferenceSystem = IfcCoordinateReferenceSystem;

  var IfcCostValue = /*#__PURE__*/function (_IfcAppliedValue4) {
    _inherits(IfcCostValue, _IfcAppliedValue4);

    var _super1634 = _createSuper(IfcCostValue);

    function IfcCostValue(expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components) {
      var _this1626;

      _classCallCheck2(this, IfcCostValue);

      _this1626 = _super1634.call(this, expressID, Name, Description, AppliedValue, UnitBasis, ApplicableDate, FixedUntilDate, Category, Condition, ArithmeticOperator, Components);
      _this1626.Name = Name;
      _this1626.Description = Description;
      _this1626.AppliedValue = AppliedValue;
      _this1626.UnitBasis = UnitBasis;
      _this1626.ApplicableDate = ApplicableDate;
      _this1626.FixedUntilDate = FixedUntilDate;
      _this1626.Category = Category;
      _this1626.Condition = Condition;
      _this1626.ArithmeticOperator = ArithmeticOperator;
      _this1626.Components = Components;
      _this1626.type = 602808272;
      return _this1626;
    }

    return IfcCostValue;
  }(IfcAppliedValue);

  IFC42.IfcCostValue = IfcCostValue;

  var IfcDerivedUnit = /*#__PURE__*/function (_IfcLineObject172) {
    _inherits(IfcDerivedUnit, _IfcLineObject172);

    var _super1635 = _createSuper(IfcDerivedUnit);

    function IfcDerivedUnit(expressID, Elements, UnitType, UserDefinedType) {
      var _this1627;

      _classCallCheck2(this, IfcDerivedUnit);

      _this1627 = _super1635.call(this, expressID);
      _this1627.Elements = Elements;
      _this1627.UnitType = UnitType;
      _this1627.UserDefinedType = UserDefinedType;
      _this1627.type = 1765591967;
      return _this1627;
    }

    return IfcDerivedUnit;
  }(IfcLineObject);

  IFC42.IfcDerivedUnit = IfcDerivedUnit;

  var IfcDerivedUnitElement = /*#__PURE__*/function (_IfcLineObject173) {
    _inherits(IfcDerivedUnitElement, _IfcLineObject173);

    var _super1636 = _createSuper(IfcDerivedUnitElement);

    function IfcDerivedUnitElement(expressID, Unit, Exponent) {
      var _this1628;

      _classCallCheck2(this, IfcDerivedUnitElement);

      _this1628 = _super1636.call(this, expressID);
      _this1628.Unit = Unit;
      _this1628.Exponent = Exponent;
      _this1628.type = 1045800335;
      return _this1628;
    }

    return IfcDerivedUnitElement;
  }(IfcLineObject);

  IFC42.IfcDerivedUnitElement = IfcDerivedUnitElement;

  var IfcDimensionalExponents = /*#__PURE__*/function (_IfcLineObject174) {
    _inherits(IfcDimensionalExponents, _IfcLineObject174);

    var _super1637 = _createSuper(IfcDimensionalExponents);

    function IfcDimensionalExponents(expressID, LengthExponent, MassExponent, TimeExponent, ElectricCurrentExponent, ThermodynamicTemperatureExponent, AmountOfSubstanceExponent, LuminousIntensityExponent) {
      var _this1629;

      _classCallCheck2(this, IfcDimensionalExponents);

      _this1629 = _super1637.call(this, expressID);
      _this1629.LengthExponent = LengthExponent;
      _this1629.MassExponent = MassExponent;
      _this1629.TimeExponent = TimeExponent;
      _this1629.ElectricCurrentExponent = ElectricCurrentExponent;
      _this1629.ThermodynamicTemperatureExponent = ThermodynamicTemperatureExponent;
      _this1629.AmountOfSubstanceExponent = AmountOfSubstanceExponent;
      _this1629.LuminousIntensityExponent = LuminousIntensityExponent;
      _this1629.type = 2949456006;
      return _this1629;
    }

    return IfcDimensionalExponents;
  }(IfcLineObject);

  IFC42.IfcDimensionalExponents = IfcDimensionalExponents;

  var IfcExternalInformation = /*#__PURE__*/function (_IfcLineObject175) {
    _inherits(IfcExternalInformation, _IfcLineObject175);

    var _super1638 = _createSuper(IfcExternalInformation);

    function IfcExternalInformation(expressID) {
      var _this1630;

      _classCallCheck2(this, IfcExternalInformation);

      _this1630 = _super1638.call(this, expressID);
      _this1630.type = 4294318154;
      return _this1630;
    }

    return IfcExternalInformation;
  }(IfcLineObject);

  IFC42.IfcExternalInformation = IfcExternalInformation;

  var IfcExternalReference = /*#__PURE__*/function (_IfcLineObject176) {
    _inherits(IfcExternalReference, _IfcLineObject176);

    var _super1639 = _createSuper(IfcExternalReference);

    function IfcExternalReference(expressID, Location, Identification, Name) {
      var _this1631;

      _classCallCheck2(this, IfcExternalReference);

      _this1631 = _super1639.call(this, expressID);
      _this1631.Location = Location;
      _this1631.Identification = Identification;
      _this1631.Name = Name;
      _this1631.type = 3200245327;
      return _this1631;
    }

    return IfcExternalReference;
  }(IfcLineObject);

  IFC42.IfcExternalReference = IfcExternalReference;

  var IfcExternallyDefinedHatchStyle = /*#__PURE__*/function (_IfcExternalReference14) {
    _inherits(IfcExternallyDefinedHatchStyle, _IfcExternalReference14);

    var _super1640 = _createSuper(IfcExternallyDefinedHatchStyle);

    function IfcExternallyDefinedHatchStyle(expressID, Location, Identification, Name) {
      var _this1632;

      _classCallCheck2(this, IfcExternallyDefinedHatchStyle);

      _this1632 = _super1640.call(this, expressID, Location, Identification, Name);
      _this1632.Location = Location;
      _this1632.Identification = Identification;
      _this1632.Name = Name;
      _this1632.type = 2242383968;
      return _this1632;
    }

    return IfcExternallyDefinedHatchStyle;
  }(IfcExternalReference);

  IFC42.IfcExternallyDefinedHatchStyle = IfcExternallyDefinedHatchStyle;

  var IfcExternallyDefinedSurfaceStyle = /*#__PURE__*/function (_IfcExternalReference15) {
    _inherits(IfcExternallyDefinedSurfaceStyle, _IfcExternalReference15);

    var _super1641 = _createSuper(IfcExternallyDefinedSurfaceStyle);

    function IfcExternallyDefinedSurfaceStyle(expressID, Location, Identification, Name) {
      var _this1633;

      _classCallCheck2(this, IfcExternallyDefinedSurfaceStyle);

      _this1633 = _super1641.call(this, expressID, Location, Identification, Name);
      _this1633.Location = Location;
      _this1633.Identification = Identification;
      _this1633.Name = Name;
      _this1633.type = 1040185647;
      return _this1633;
    }

    return IfcExternallyDefinedSurfaceStyle;
  }(IfcExternalReference);

  IFC42.IfcExternallyDefinedSurfaceStyle = IfcExternallyDefinedSurfaceStyle;

  var IfcExternallyDefinedTextFont = /*#__PURE__*/function (_IfcExternalReference16) {
    _inherits(IfcExternallyDefinedTextFont, _IfcExternalReference16);

    var _super1642 = _createSuper(IfcExternallyDefinedTextFont);

    function IfcExternallyDefinedTextFont(expressID, Location, Identification, Name) {
      var _this1634;

      _classCallCheck2(this, IfcExternallyDefinedTextFont);

      _this1634 = _super1642.call(this, expressID, Location, Identification, Name);
      _this1634.Location = Location;
      _this1634.Identification = Identification;
      _this1634.Name = Name;
      _this1634.type = 3548104201;
      return _this1634;
    }

    return IfcExternallyDefinedTextFont;
  }(IfcExternalReference);

  IFC42.IfcExternallyDefinedTextFont = IfcExternallyDefinedTextFont;

  var IfcGridAxis = /*#__PURE__*/function (_IfcLineObject177) {
    _inherits(IfcGridAxis, _IfcLineObject177);

    var _super1643 = _createSuper(IfcGridAxis);

    function IfcGridAxis(expressID, AxisTag, AxisCurve, SameSense) {
      var _this1635;

      _classCallCheck2(this, IfcGridAxis);

      _this1635 = _super1643.call(this, expressID);
      _this1635.AxisTag = AxisTag;
      _this1635.AxisCurve = AxisCurve;
      _this1635.SameSense = SameSense;
      _this1635.type = 852622518;
      return _this1635;
    }

    return IfcGridAxis;
  }(IfcLineObject);

  IFC42.IfcGridAxis = IfcGridAxis;

  var IfcIrregularTimeSeriesValue = /*#__PURE__*/function (_IfcLineObject178) {
    _inherits(IfcIrregularTimeSeriesValue, _IfcLineObject178);

    var _super1644 = _createSuper(IfcIrregularTimeSeriesValue);

    function IfcIrregularTimeSeriesValue(expressID, TimeStamp, ListValues) {
      var _this1636;

      _classCallCheck2(this, IfcIrregularTimeSeriesValue);

      _this1636 = _super1644.call(this, expressID);
      _this1636.TimeStamp = TimeStamp;
      _this1636.ListValues = ListValues;
      _this1636.type = 3020489413;
      return _this1636;
    }

    return IfcIrregularTimeSeriesValue;
  }(IfcLineObject);

  IFC42.IfcIrregularTimeSeriesValue = IfcIrregularTimeSeriesValue;

  var IfcLibraryInformation = /*#__PURE__*/function (_IfcExternalInformati4) {
    _inherits(IfcLibraryInformation, _IfcExternalInformati4);

    var _super1645 = _createSuper(IfcLibraryInformation);

    function IfcLibraryInformation(expressID, Name, Version, Publisher, VersionDate, Location, Description) {
      var _this1637;

      _classCallCheck2(this, IfcLibraryInformation);

      _this1637 = _super1645.call(this, expressID);
      _this1637.Name = Name;
      _this1637.Version = Version;
      _this1637.Publisher = Publisher;
      _this1637.VersionDate = VersionDate;
      _this1637.Location = Location;
      _this1637.Description = Description;
      _this1637.type = 2655187982;
      return _this1637;
    }

    return IfcLibraryInformation;
  }(IfcExternalInformation);

  IFC42.IfcLibraryInformation = IfcLibraryInformation;

  var IfcLibraryReference = /*#__PURE__*/function (_IfcExternalReference17) {
    _inherits(IfcLibraryReference, _IfcExternalReference17);

    var _super1646 = _createSuper(IfcLibraryReference);

    function IfcLibraryReference(expressID, Location, Identification, Name, Description, Language, ReferencedLibrary) {
      var _this1638;

      _classCallCheck2(this, IfcLibraryReference);

      _this1638 = _super1646.call(this, expressID, Location, Identification, Name);
      _this1638.Location = Location;
      _this1638.Identification = Identification;
      _this1638.Name = Name;
      _this1638.Description = Description;
      _this1638.Language = Language;
      _this1638.ReferencedLibrary = ReferencedLibrary;
      _this1638.type = 3452421091;
      return _this1638;
    }

    return IfcLibraryReference;
  }(IfcExternalReference);

  IFC42.IfcLibraryReference = IfcLibraryReference;

  var IfcLightDistributionData = /*#__PURE__*/function (_IfcLineObject179) {
    _inherits(IfcLightDistributionData, _IfcLineObject179);

    var _super1647 = _createSuper(IfcLightDistributionData);

    function IfcLightDistributionData(expressID, MainPlaneAngle, SecondaryPlaneAngle, LuminousIntensity) {
      var _this1639;

      _classCallCheck2(this, IfcLightDistributionData);

      _this1639 = _super1647.call(this, expressID);
      _this1639.MainPlaneAngle = MainPlaneAngle;
      _this1639.SecondaryPlaneAngle = SecondaryPlaneAngle;
      _this1639.LuminousIntensity = LuminousIntensity;
      _this1639.type = 4162380809;
      return _this1639;
    }

    return IfcLightDistributionData;
  }(IfcLineObject);

  IFC42.IfcLightDistributionData = IfcLightDistributionData;

  var IfcLightIntensityDistribution = /*#__PURE__*/function (_IfcLineObject180) {
    _inherits(IfcLightIntensityDistribution, _IfcLineObject180);

    var _super1648 = _createSuper(IfcLightIntensityDistribution);

    function IfcLightIntensityDistribution(expressID, LightDistributionCurve, DistributionData) {
      var _this1640;

      _classCallCheck2(this, IfcLightIntensityDistribution);

      _this1640 = _super1648.call(this, expressID);
      _this1640.LightDistributionCurve = LightDistributionCurve;
      _this1640.DistributionData = DistributionData;
      _this1640.type = 1566485204;
      return _this1640;
    }

    return IfcLightIntensityDistribution;
  }(IfcLineObject);

  IFC42.IfcLightIntensityDistribution = IfcLightIntensityDistribution;

  var IfcMapConversion = /*#__PURE__*/function (_IfcCoordinateOperati2) {
    _inherits(IfcMapConversion, _IfcCoordinateOperati2);

    var _super1649 = _createSuper(IfcMapConversion);

    function IfcMapConversion(expressID, SourceCRS, TargetCRS, Eastings, Northings, OrthogonalHeight, XAxisAbscissa, XAxisOrdinate, Scale) {
      var _this1641;

      _classCallCheck2(this, IfcMapConversion);

      _this1641 = _super1649.call(this, expressID, SourceCRS, TargetCRS);
      _this1641.SourceCRS = SourceCRS;
      _this1641.TargetCRS = TargetCRS;
      _this1641.Eastings = Eastings;
      _this1641.Northings = Northings;
      _this1641.OrthogonalHeight = OrthogonalHeight;
      _this1641.XAxisAbscissa = XAxisAbscissa;
      _this1641.XAxisOrdinate = XAxisOrdinate;
      _this1641.Scale = Scale;
      _this1641.type = 3057273783;
      return _this1641;
    }

    return IfcMapConversion;
  }(IfcCoordinateOperation);

  IFC42.IfcMapConversion = IfcMapConversion;

  var IfcMaterialClassificationRelationship = /*#__PURE__*/function (_IfcLineObject181) {
    _inherits(IfcMaterialClassificationRelationship, _IfcLineObject181);

    var _super1650 = _createSuper(IfcMaterialClassificationRelationship);

    function IfcMaterialClassificationRelationship(expressID, MaterialClassifications, ClassifiedMaterial) {
      var _this1642;

      _classCallCheck2(this, IfcMaterialClassificationRelationship);

      _this1642 = _super1650.call(this, expressID);
      _this1642.MaterialClassifications = MaterialClassifications;
      _this1642.ClassifiedMaterial = ClassifiedMaterial;
      _this1642.type = 1847130766;
      return _this1642;
    }

    return IfcMaterialClassificationRelationship;
  }(IfcLineObject);

  IFC42.IfcMaterialClassificationRelationship = IfcMaterialClassificationRelationship;

  var IfcMaterialDefinition = /*#__PURE__*/function (_IfcLineObject182) {
    _inherits(IfcMaterialDefinition, _IfcLineObject182);

    var _super1651 = _createSuper(IfcMaterialDefinition);

    function IfcMaterialDefinition(expressID) {
      var _this1643;

      _classCallCheck2(this, IfcMaterialDefinition);

      _this1643 = _super1651.call(this, expressID);
      _this1643.type = 760658860;
      return _this1643;
    }

    return IfcMaterialDefinition;
  }(IfcLineObject);

  IFC42.IfcMaterialDefinition = IfcMaterialDefinition;

  var IfcMaterialLayer = /*#__PURE__*/function (_IfcMaterialDefinitio8) {
    _inherits(IfcMaterialLayer, _IfcMaterialDefinitio8);

    var _super1652 = _createSuper(IfcMaterialLayer);

    function IfcMaterialLayer(expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority) {
      var _this1644;

      _classCallCheck2(this, IfcMaterialLayer);

      _this1644 = _super1652.call(this, expressID);
      _this1644.Material = Material;
      _this1644.LayerThickness = LayerThickness;
      _this1644.IsVentilated = IsVentilated;
      _this1644.Name = Name;
      _this1644.Description = Description;
      _this1644.Category = Category;
      _this1644.Priority = Priority;
      _this1644.type = 248100487;
      return _this1644;
    }

    return IfcMaterialLayer;
  }(IfcMaterialDefinition);

  IFC42.IfcMaterialLayer = IfcMaterialLayer;

  var IfcMaterialLayerSet = /*#__PURE__*/function (_IfcMaterialDefinitio9) {
    _inherits(IfcMaterialLayerSet, _IfcMaterialDefinitio9);

    var _super1653 = _createSuper(IfcMaterialLayerSet);

    function IfcMaterialLayerSet(expressID, MaterialLayers, LayerSetName, Description) {
      var _this1645;

      _classCallCheck2(this, IfcMaterialLayerSet);

      _this1645 = _super1653.call(this, expressID);
      _this1645.MaterialLayers = MaterialLayers;
      _this1645.LayerSetName = LayerSetName;
      _this1645.Description = Description;
      _this1645.type = 3303938423;
      return _this1645;
    }

    return IfcMaterialLayerSet;
  }(IfcMaterialDefinition);

  IFC42.IfcMaterialLayerSet = IfcMaterialLayerSet;

  var IfcMaterialLayerWithOffsets = /*#__PURE__*/function (_IfcMaterialLayer2) {
    _inherits(IfcMaterialLayerWithOffsets, _IfcMaterialLayer2);

    var _super1654 = _createSuper(IfcMaterialLayerWithOffsets);

    function IfcMaterialLayerWithOffsets(expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority, OffsetDirection, OffsetValues) {
      var _this1646;

      _classCallCheck2(this, IfcMaterialLayerWithOffsets);

      _this1646 = _super1654.call(this, expressID, Material, LayerThickness, IsVentilated, Name, Description, Category, Priority);
      _this1646.Material = Material;
      _this1646.LayerThickness = LayerThickness;
      _this1646.IsVentilated = IsVentilated;
      _this1646.Name = Name;
      _this1646.Description = Description;
      _this1646.Category = Category;
      _this1646.Priority = Priority;
      _this1646.OffsetDirection = OffsetDirection;
      _this1646.OffsetValues = OffsetValues;
      _this1646.type = 1847252529;
      return _this1646;
    }

    return IfcMaterialLayerWithOffsets;
  }(IfcMaterialLayer);

  IFC42.IfcMaterialLayerWithOffsets = IfcMaterialLayerWithOffsets;

  var IfcMaterialList = /*#__PURE__*/function (_IfcLineObject183) {
    _inherits(IfcMaterialList, _IfcLineObject183);

    var _super1655 = _createSuper(IfcMaterialList);

    function IfcMaterialList(expressID, Materials) {
      var _this1647;

      _classCallCheck2(this, IfcMaterialList);

      _this1647 = _super1655.call(this, expressID);
      _this1647.Materials = Materials;
      _this1647.type = 2199411900;
      return _this1647;
    }

    return IfcMaterialList;
  }(IfcLineObject);

  IFC42.IfcMaterialList = IfcMaterialList;

  var IfcMaterialProfile = /*#__PURE__*/function (_IfcMaterialDefinitio10) {
    _inherits(IfcMaterialProfile, _IfcMaterialDefinitio10);

    var _super1656 = _createSuper(IfcMaterialProfile);

    function IfcMaterialProfile(expressID, Name, Description, Material, Profile, Priority, Category) {
      var _this1648;

      _classCallCheck2(this, IfcMaterialProfile);

      _this1648 = _super1656.call(this, expressID);
      _this1648.Name = Name;
      _this1648.Description = Description;
      _this1648.Material = Material;
      _this1648.Profile = Profile;
      _this1648.Priority = Priority;
      _this1648.Category = Category;
      _this1648.type = 2235152071;
      return _this1648;
    }

    return IfcMaterialProfile;
  }(IfcMaterialDefinition);

  IFC42.IfcMaterialProfile = IfcMaterialProfile;

  var IfcMaterialProfileSet = /*#__PURE__*/function (_IfcMaterialDefinitio11) {
    _inherits(IfcMaterialProfileSet, _IfcMaterialDefinitio11);

    var _super1657 = _createSuper(IfcMaterialProfileSet);

    function IfcMaterialProfileSet(expressID, Name, Description, MaterialProfiles, CompositeProfile) {
      var _this1649;

      _classCallCheck2(this, IfcMaterialProfileSet);

      _this1649 = _super1657.call(this, expressID);
      _this1649.Name = Name;
      _this1649.Description = Description;
      _this1649.MaterialProfiles = MaterialProfiles;
      _this1649.CompositeProfile = CompositeProfile;
      _this1649.type = 164193824;
      return _this1649;
    }

    return IfcMaterialProfileSet;
  }(IfcMaterialDefinition);

  IFC42.IfcMaterialProfileSet = IfcMaterialProfileSet;

  var IfcMaterialProfileWithOffsets = /*#__PURE__*/function (_IfcMaterialProfile2) {
    _inherits(IfcMaterialProfileWithOffsets, _IfcMaterialProfile2);

    var _super1658 = _createSuper(IfcMaterialProfileWithOffsets);

    function IfcMaterialProfileWithOffsets(expressID, Name, Description, Material, Profile, Priority, Category, OffsetValues) {
      var _this1650;

      _classCallCheck2(this, IfcMaterialProfileWithOffsets);

      _this1650 = _super1658.call(this, expressID, Name, Description, Material, Profile, Priority, Category);
      _this1650.Name = Name;
      _this1650.Description = Description;
      _this1650.Material = Material;
      _this1650.Profile = Profile;
      _this1650.Priority = Priority;
      _this1650.Category = Category;
      _this1650.OffsetValues = OffsetValues;
      _this1650.type = 552965576;
      return _this1650;
    }

    return IfcMaterialProfileWithOffsets;
  }(IfcMaterialProfile);

  IFC42.IfcMaterialProfileWithOffsets = IfcMaterialProfileWithOffsets;

  var IfcMaterialUsageDefinition = /*#__PURE__*/function (_IfcLineObject184) {
    _inherits(IfcMaterialUsageDefinition, _IfcLineObject184);

    var _super1659 = _createSuper(IfcMaterialUsageDefinition);

    function IfcMaterialUsageDefinition(expressID) {
      var _this1651;

      _classCallCheck2(this, IfcMaterialUsageDefinition);

      _this1651 = _super1659.call(this, expressID);
      _this1651.type = 1507914824;
      return _this1651;
    }

    return IfcMaterialUsageDefinition;
  }(IfcLineObject);

  IFC42.IfcMaterialUsageDefinition = IfcMaterialUsageDefinition;

  var IfcMeasureWithUnit = /*#__PURE__*/function (_IfcLineObject185) {
    _inherits(IfcMeasureWithUnit, _IfcLineObject185);

    var _super1660 = _createSuper(IfcMeasureWithUnit);

    function IfcMeasureWithUnit(expressID, ValueComponent, UnitComponent) {
      var _this1652;

      _classCallCheck2(this, IfcMeasureWithUnit);

      _this1652 = _super1660.call(this, expressID);
      _this1652.ValueComponent = ValueComponent;
      _this1652.UnitComponent = UnitComponent;
      _this1652.type = 2597039031;
      return _this1652;
    }

    return IfcMeasureWithUnit;
  }(IfcLineObject);

  IFC42.IfcMeasureWithUnit = IfcMeasureWithUnit;

  var IfcMetric = /*#__PURE__*/function (_IfcConstraint5) {
    _inherits(IfcMetric, _IfcConstraint5);

    var _super1661 = _createSuper(IfcMetric);

    function IfcMetric(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, Benchmark, ValueSource, DataValue, ReferencePath) {
      var _this1653;

      _classCallCheck2(this, IfcMetric);

      _this1653 = _super1661.call(this, expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      _this1653.Name = Name;
      _this1653.Description = Description;
      _this1653.ConstraintGrade = ConstraintGrade;
      _this1653.ConstraintSource = ConstraintSource;
      _this1653.CreatingActor = CreatingActor;
      _this1653.CreationTime = CreationTime;
      _this1653.UserDefinedGrade = UserDefinedGrade;
      _this1653.Benchmark = Benchmark;
      _this1653.ValueSource = ValueSource;
      _this1653.DataValue = DataValue;
      _this1653.ReferencePath = ReferencePath;
      _this1653.type = 3368373690;
      return _this1653;
    }

    return IfcMetric;
  }(IfcConstraint);

  IFC42.IfcMetric = IfcMetric;

  var IfcMonetaryUnit = /*#__PURE__*/function (_IfcLineObject186) {
    _inherits(IfcMonetaryUnit, _IfcLineObject186);

    var _super1662 = _createSuper(IfcMonetaryUnit);

    function IfcMonetaryUnit(expressID, Currency) {
      var _this1654;

      _classCallCheck2(this, IfcMonetaryUnit);

      _this1654 = _super1662.call(this, expressID);
      _this1654.Currency = Currency;
      _this1654.type = 2706619895;
      return _this1654;
    }

    return IfcMonetaryUnit;
  }(IfcLineObject);

  IFC42.IfcMonetaryUnit = IfcMonetaryUnit;

  var IfcNamedUnit = /*#__PURE__*/function (_IfcLineObject187) {
    _inherits(IfcNamedUnit, _IfcLineObject187);

    var _super1663 = _createSuper(IfcNamedUnit);

    function IfcNamedUnit(expressID, Dimensions, UnitType) {
      var _this1655;

      _classCallCheck2(this, IfcNamedUnit);

      _this1655 = _super1663.call(this, expressID);
      _this1655.Dimensions = Dimensions;
      _this1655.UnitType = UnitType;
      _this1655.type = 1918398963;
      return _this1655;
    }

    return IfcNamedUnit;
  }(IfcLineObject);

  IFC42.IfcNamedUnit = IfcNamedUnit;

  var IfcObjectPlacement = /*#__PURE__*/function (_IfcLineObject188) {
    _inherits(IfcObjectPlacement, _IfcLineObject188);

    var _super1664 = _createSuper(IfcObjectPlacement);

    function IfcObjectPlacement(expressID) {
      var _this1656;

      _classCallCheck2(this, IfcObjectPlacement);

      _this1656 = _super1664.call(this, expressID);
      _this1656.type = 3701648758;
      return _this1656;
    }

    return IfcObjectPlacement;
  }(IfcLineObject);

  IFC42.IfcObjectPlacement = IfcObjectPlacement;

  var IfcObjective = /*#__PURE__*/function (_IfcConstraint6) {
    _inherits(IfcObjective, _IfcConstraint6);

    var _super1665 = _createSuper(IfcObjective);

    function IfcObjective(expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade, BenchmarkValues, LogicalAggregator, ObjectiveQualifier, UserDefinedQualifier) {
      var _this1657;

      _classCallCheck2(this, IfcObjective);

      _this1657 = _super1665.call(this, expressID, Name, Description, ConstraintGrade, ConstraintSource, CreatingActor, CreationTime, UserDefinedGrade);
      _this1657.Name = Name;
      _this1657.Description = Description;
      _this1657.ConstraintGrade = ConstraintGrade;
      _this1657.ConstraintSource = ConstraintSource;
      _this1657.CreatingActor = CreatingActor;
      _this1657.CreationTime = CreationTime;
      _this1657.UserDefinedGrade = UserDefinedGrade;
      _this1657.BenchmarkValues = BenchmarkValues;
      _this1657.LogicalAggregator = LogicalAggregator;
      _this1657.ObjectiveQualifier = ObjectiveQualifier;
      _this1657.UserDefinedQualifier = UserDefinedQualifier;
      _this1657.type = 2251480897;
      return _this1657;
    }

    return IfcObjective;
  }(IfcConstraint);

  IFC42.IfcObjective = IfcObjective;

  var IfcOrganization = /*#__PURE__*/function (_IfcLineObject189) {
    _inherits(IfcOrganization, _IfcLineObject189);

    var _super1666 = _createSuper(IfcOrganization);

    function IfcOrganization(expressID, Identification, Name, Description, Roles, Addresses) {
      var _this1658;

      _classCallCheck2(this, IfcOrganization);

      _this1658 = _super1666.call(this, expressID);
      _this1658.Identification = Identification;
      _this1658.Name = Name;
      _this1658.Description = Description;
      _this1658.Roles = Roles;
      _this1658.Addresses = Addresses;
      _this1658.type = 4251960020;
      return _this1658;
    }

    return IfcOrganization;
  }(IfcLineObject);

  IFC42.IfcOrganization = IfcOrganization;

  var IfcOwnerHistory = /*#__PURE__*/function (_IfcLineObject190) {
    _inherits(IfcOwnerHistory, _IfcLineObject190);

    var _super1667 = _createSuper(IfcOwnerHistory);

    function IfcOwnerHistory(expressID, OwningUser, OwningApplication, State, ChangeAction, LastModifiedDate, LastModifyingUser, LastModifyingApplication, CreationDate) {
      var _this1659;

      _classCallCheck2(this, IfcOwnerHistory);

      _this1659 = _super1667.call(this, expressID);
      _this1659.OwningUser = OwningUser;
      _this1659.OwningApplication = OwningApplication;
      _this1659.State = State;
      _this1659.ChangeAction = ChangeAction;
      _this1659.LastModifiedDate = LastModifiedDate;
      _this1659.LastModifyingUser = LastModifyingUser;
      _this1659.LastModifyingApplication = LastModifyingApplication;
      _this1659.CreationDate = CreationDate;
      _this1659.type = 1207048766;
      return _this1659;
    }

    return IfcOwnerHistory;
  }(IfcLineObject);

  IFC42.IfcOwnerHistory = IfcOwnerHistory;

  var IfcPerson = /*#__PURE__*/function (_IfcLineObject191) {
    _inherits(IfcPerson, _IfcLineObject191);

    var _super1668 = _createSuper(IfcPerson);

    function IfcPerson(expressID, Identification, FamilyName, GivenName, MiddleNames, PrefixTitles, SuffixTitles, Roles, Addresses) {
      var _this1660;

      _classCallCheck2(this, IfcPerson);

      _this1660 = _super1668.call(this, expressID);
      _this1660.Identification = Identification;
      _this1660.FamilyName = FamilyName;
      _this1660.GivenName = GivenName;
      _this1660.MiddleNames = MiddleNames;
      _this1660.PrefixTitles = PrefixTitles;
      _this1660.SuffixTitles = SuffixTitles;
      _this1660.Roles = Roles;
      _this1660.Addresses = Addresses;
      _this1660.type = 2077209135;
      return _this1660;
    }

    return IfcPerson;
  }(IfcLineObject);

  IFC42.IfcPerson = IfcPerson;

  var IfcPersonAndOrganization = /*#__PURE__*/function (_IfcLineObject192) {
    _inherits(IfcPersonAndOrganization, _IfcLineObject192);

    var _super1669 = _createSuper(IfcPersonAndOrganization);

    function IfcPersonAndOrganization(expressID, ThePerson, TheOrganization, Roles) {
      var _this1661;

      _classCallCheck2(this, IfcPersonAndOrganization);

      _this1661 = _super1669.call(this, expressID);
      _this1661.ThePerson = ThePerson;
      _this1661.TheOrganization = TheOrganization;
      _this1661.Roles = Roles;
      _this1661.type = 101040310;
      return _this1661;
    }

    return IfcPersonAndOrganization;
  }(IfcLineObject);

  IFC42.IfcPersonAndOrganization = IfcPersonAndOrganization;

  var IfcPhysicalQuantity = /*#__PURE__*/function (_IfcLineObject193) {
    _inherits(IfcPhysicalQuantity, _IfcLineObject193);

    var _super1670 = _createSuper(IfcPhysicalQuantity);

    function IfcPhysicalQuantity(expressID, Name, Description) {
      var _this1662;

      _classCallCheck2(this, IfcPhysicalQuantity);

      _this1662 = _super1670.call(this, expressID);
      _this1662.Name = Name;
      _this1662.Description = Description;
      _this1662.type = 2483315170;
      return _this1662;
    }

    return IfcPhysicalQuantity;
  }(IfcLineObject);

  IFC42.IfcPhysicalQuantity = IfcPhysicalQuantity;

  var IfcPhysicalSimpleQuantity = /*#__PURE__*/function (_IfcPhysicalQuantity5) {
    _inherits(IfcPhysicalSimpleQuantity, _IfcPhysicalQuantity5);

    var _super1671 = _createSuper(IfcPhysicalSimpleQuantity);

    function IfcPhysicalSimpleQuantity(expressID, Name, Description, Unit) {
      var _this1663;

      _classCallCheck2(this, IfcPhysicalSimpleQuantity);

      _this1663 = _super1671.call(this, expressID, Name, Description);
      _this1663.Name = Name;
      _this1663.Description = Description;
      _this1663.Unit = Unit;
      _this1663.type = 2226359599;
      return _this1663;
    }

    return IfcPhysicalSimpleQuantity;
  }(IfcPhysicalQuantity);

  IFC42.IfcPhysicalSimpleQuantity = IfcPhysicalSimpleQuantity;

  var IfcPostalAddress = /*#__PURE__*/function (_IfcAddress5) {
    _inherits(IfcPostalAddress, _IfcAddress5);

    var _super1672 = _createSuper(IfcPostalAddress);

    function IfcPostalAddress(expressID, Purpose, Description, UserDefinedPurpose, InternalLocation, AddressLines, PostalBox, Town, Region, PostalCode, Country) {
      var _this1664;

      _classCallCheck2(this, IfcPostalAddress);

      _this1664 = _super1672.call(this, expressID, Purpose, Description, UserDefinedPurpose);
      _this1664.Purpose = Purpose;
      _this1664.Description = Description;
      _this1664.UserDefinedPurpose = UserDefinedPurpose;
      _this1664.InternalLocation = InternalLocation;
      _this1664.AddressLines = AddressLines;
      _this1664.PostalBox = PostalBox;
      _this1664.Town = Town;
      _this1664.Region = Region;
      _this1664.PostalCode = PostalCode;
      _this1664.Country = Country;
      _this1664.type = 3355820592;
      return _this1664;
    }

    return IfcPostalAddress;
  }(IfcAddress);

  IFC42.IfcPostalAddress = IfcPostalAddress;

  var IfcPresentationItem = /*#__PURE__*/function (_IfcLineObject194) {
    _inherits(IfcPresentationItem, _IfcLineObject194);

    var _super1673 = _createSuper(IfcPresentationItem);

    function IfcPresentationItem(expressID) {
      var _this1665;

      _classCallCheck2(this, IfcPresentationItem);

      _this1665 = _super1673.call(this, expressID);
      _this1665.type = 677532197;
      return _this1665;
    }

    return IfcPresentationItem;
  }(IfcLineObject);

  IFC42.IfcPresentationItem = IfcPresentationItem;

  var IfcPresentationLayerAssignment = /*#__PURE__*/function (_IfcLineObject195) {
    _inherits(IfcPresentationLayerAssignment, _IfcLineObject195);

    var _super1674 = _createSuper(IfcPresentationLayerAssignment);

    function IfcPresentationLayerAssignment(expressID, Name, Description, AssignedItems, Identifier) {
      var _this1666;

      _classCallCheck2(this, IfcPresentationLayerAssignment);

      _this1666 = _super1674.call(this, expressID);
      _this1666.Name = Name;
      _this1666.Description = Description;
      _this1666.AssignedItems = AssignedItems;
      _this1666.Identifier = Identifier;
      _this1666.type = 2022622350;
      return _this1666;
    }

    return IfcPresentationLayerAssignment;
  }(IfcLineObject);

  IFC42.IfcPresentationLayerAssignment = IfcPresentationLayerAssignment;

  var IfcPresentationLayerWithStyle = /*#__PURE__*/function (_IfcPresentationLayer3) {
    _inherits(IfcPresentationLayerWithStyle, _IfcPresentationLayer3);

    var _super1675 = _createSuper(IfcPresentationLayerWithStyle);

    function IfcPresentationLayerWithStyle(expressID, Name, Description, AssignedItems, Identifier, LayerOn, LayerFrozen, LayerBlocked, LayerStyles) {
      var _this1667;

      _classCallCheck2(this, IfcPresentationLayerWithStyle);

      _this1667 = _super1675.call(this, expressID, Name, Description, AssignedItems, Identifier);
      _this1667.Name = Name;
      _this1667.Description = Description;
      _this1667.AssignedItems = AssignedItems;
      _this1667.Identifier = Identifier;
      _this1667.LayerOn = LayerOn;
      _this1667.LayerFrozen = LayerFrozen;
      _this1667.LayerBlocked = LayerBlocked;
      _this1667.LayerStyles = LayerStyles;
      _this1667.type = 1304840413;
      return _this1667;
    }

    return IfcPresentationLayerWithStyle;
  }(IfcPresentationLayerAssignment);

  IFC42.IfcPresentationLayerWithStyle = IfcPresentationLayerWithStyle;

  var IfcPresentationStyle = /*#__PURE__*/function (_IfcLineObject196) {
    _inherits(IfcPresentationStyle, _IfcLineObject196);

    var _super1676 = _createSuper(IfcPresentationStyle);

    function IfcPresentationStyle(expressID, Name) {
      var _this1668;

      _classCallCheck2(this, IfcPresentationStyle);

      _this1668 = _super1676.call(this, expressID);
      _this1668.Name = Name;
      _this1668.type = 3119450353;
      return _this1668;
    }

    return IfcPresentationStyle;
  }(IfcLineObject);

  IFC42.IfcPresentationStyle = IfcPresentationStyle;

  var IfcPresentationStyleAssignment = /*#__PURE__*/function (_IfcLineObject197) {
    _inherits(IfcPresentationStyleAssignment, _IfcLineObject197);

    var _super1677 = _createSuper(IfcPresentationStyleAssignment);

    function IfcPresentationStyleAssignment(expressID, Styles) {
      var _this1669;

      _classCallCheck2(this, IfcPresentationStyleAssignment);

      _this1669 = _super1677.call(this, expressID);
      _this1669.Styles = Styles;
      _this1669.type = 2417041796;
      return _this1669;
    }

    return IfcPresentationStyleAssignment;
  }(IfcLineObject);

  IFC42.IfcPresentationStyleAssignment = IfcPresentationStyleAssignment;

  var IfcProductRepresentation = /*#__PURE__*/function (_IfcLineObject198) {
    _inherits(IfcProductRepresentation, _IfcLineObject198);

    var _super1678 = _createSuper(IfcProductRepresentation);

    function IfcProductRepresentation(expressID, Name, Description, Representations) {
      var _this1670;

      _classCallCheck2(this, IfcProductRepresentation);

      _this1670 = _super1678.call(this, expressID);
      _this1670.Name = Name;
      _this1670.Description = Description;
      _this1670.Representations = Representations;
      _this1670.type = 2095639259;
      return _this1670;
    }

    return IfcProductRepresentation;
  }(IfcLineObject);

  IFC42.IfcProductRepresentation = IfcProductRepresentation;

  var IfcProfileDef = /*#__PURE__*/function (_IfcLineObject199) {
    _inherits(IfcProfileDef, _IfcLineObject199);

    var _super1679 = _createSuper(IfcProfileDef);

    function IfcProfileDef(expressID, ProfileType, ProfileName) {
      var _this1671;

      _classCallCheck2(this, IfcProfileDef);

      _this1671 = _super1679.call(this, expressID);
      _this1671.ProfileType = ProfileType;
      _this1671.ProfileName = ProfileName;
      _this1671.type = 3958567839;
      return _this1671;
    }

    return IfcProfileDef;
  }(IfcLineObject);

  IFC42.IfcProfileDef = IfcProfileDef;

  var IfcProjectedCRS = /*#__PURE__*/function (_IfcCoordinateReferen2) {
    _inherits(IfcProjectedCRS, _IfcCoordinateReferen2);

    var _super1680 = _createSuper(IfcProjectedCRS);

    function IfcProjectedCRS(expressID, Name, Description, GeodeticDatum, VerticalDatum, MapProjection, MapZone, MapUnit) {
      var _this1672;

      _classCallCheck2(this, IfcProjectedCRS);

      _this1672 = _super1680.call(this, expressID, Name, Description, GeodeticDatum, VerticalDatum);
      _this1672.Name = Name;
      _this1672.Description = Description;
      _this1672.GeodeticDatum = GeodeticDatum;
      _this1672.VerticalDatum = VerticalDatum;
      _this1672.MapProjection = MapProjection;
      _this1672.MapZone = MapZone;
      _this1672.MapUnit = MapUnit;
      _this1672.type = 3843373140;
      return _this1672;
    }

    return IfcProjectedCRS;
  }(IfcCoordinateReferenceSystem);

  IFC42.IfcProjectedCRS = IfcProjectedCRS;

  var IfcPropertyAbstraction = /*#__PURE__*/function (_IfcLineObject200) {
    _inherits(IfcPropertyAbstraction, _IfcLineObject200);

    var _super1681 = _createSuper(IfcPropertyAbstraction);

    function IfcPropertyAbstraction(expressID) {
      var _this1673;

      _classCallCheck2(this, IfcPropertyAbstraction);

      _this1673 = _super1681.call(this, expressID);
      _this1673.type = 986844984;
      return _this1673;
    }

    return IfcPropertyAbstraction;
  }(IfcLineObject);

  IFC42.IfcPropertyAbstraction = IfcPropertyAbstraction;

  var IfcPropertyEnumeration = /*#__PURE__*/function (_IfcPropertyAbstracti5) {
    _inherits(IfcPropertyEnumeration, _IfcPropertyAbstracti5);

    var _super1682 = _createSuper(IfcPropertyEnumeration);

    function IfcPropertyEnumeration(expressID, Name, EnumerationValues, Unit) {
      var _this1674;

      _classCallCheck2(this, IfcPropertyEnumeration);

      _this1674 = _super1682.call(this, expressID);
      _this1674.Name = Name;
      _this1674.EnumerationValues = EnumerationValues;
      _this1674.Unit = Unit;
      _this1674.type = 3710013099;
      return _this1674;
    }

    return IfcPropertyEnumeration;
  }(IfcPropertyAbstraction);

  IFC42.IfcPropertyEnumeration = IfcPropertyEnumeration;

  var IfcQuantityArea = /*#__PURE__*/function (_IfcPhysicalSimpleQua14) {
    _inherits(IfcQuantityArea, _IfcPhysicalSimpleQua14);

    var _super1683 = _createSuper(IfcQuantityArea);

    function IfcQuantityArea(expressID, Name, Description, Unit, AreaValue, Formula) {
      var _this1675;

      _classCallCheck2(this, IfcQuantityArea);

      _this1675 = _super1683.call(this, expressID, Name, Description, Unit);
      _this1675.Name = Name;
      _this1675.Description = Description;
      _this1675.Unit = Unit;
      _this1675.AreaValue = AreaValue;
      _this1675.Formula = Formula;
      _this1675.type = 2044713172;
      return _this1675;
    }

    return IfcQuantityArea;
  }(IfcPhysicalSimpleQuantity);

  IFC42.IfcQuantityArea = IfcQuantityArea;

  var IfcQuantityCount = /*#__PURE__*/function (_IfcPhysicalSimpleQua15) {
    _inherits(IfcQuantityCount, _IfcPhysicalSimpleQua15);

    var _super1684 = _createSuper(IfcQuantityCount);

    function IfcQuantityCount(expressID, Name, Description, Unit, CountValue, Formula) {
      var _this1676;

      _classCallCheck2(this, IfcQuantityCount);

      _this1676 = _super1684.call(this, expressID, Name, Description, Unit);
      _this1676.Name = Name;
      _this1676.Description = Description;
      _this1676.Unit = Unit;
      _this1676.CountValue = CountValue;
      _this1676.Formula = Formula;
      _this1676.type = 2093928680;
      return _this1676;
    }

    return IfcQuantityCount;
  }(IfcPhysicalSimpleQuantity);

  IFC42.IfcQuantityCount = IfcQuantityCount;

  var IfcQuantityLength = /*#__PURE__*/function (_IfcPhysicalSimpleQua16) {
    _inherits(IfcQuantityLength, _IfcPhysicalSimpleQua16);

    var _super1685 = _createSuper(IfcQuantityLength);

    function IfcQuantityLength(expressID, Name, Description, Unit, LengthValue, Formula) {
      var _this1677;

      _classCallCheck2(this, IfcQuantityLength);

      _this1677 = _super1685.call(this, expressID, Name, Description, Unit);
      _this1677.Name = Name;
      _this1677.Description = Description;
      _this1677.Unit = Unit;
      _this1677.LengthValue = LengthValue;
      _this1677.Formula = Formula;
      _this1677.type = 931644368;
      return _this1677;
    }

    return IfcQuantityLength;
  }(IfcPhysicalSimpleQuantity);

  IFC42.IfcQuantityLength = IfcQuantityLength;

  var IfcQuantityTime = /*#__PURE__*/function (_IfcPhysicalSimpleQua17) {
    _inherits(IfcQuantityTime, _IfcPhysicalSimpleQua17);

    var _super1686 = _createSuper(IfcQuantityTime);

    function IfcQuantityTime(expressID, Name, Description, Unit, TimeValue, Formula) {
      var _this1678;

      _classCallCheck2(this, IfcQuantityTime);

      _this1678 = _super1686.call(this, expressID, Name, Description, Unit);
      _this1678.Name = Name;
      _this1678.Description = Description;
      _this1678.Unit = Unit;
      _this1678.TimeValue = TimeValue;
      _this1678.Formula = Formula;
      _this1678.type = 3252649465;
      return _this1678;
    }

    return IfcQuantityTime;
  }(IfcPhysicalSimpleQuantity);

  IFC42.IfcQuantityTime = IfcQuantityTime;

  var IfcQuantityVolume = /*#__PURE__*/function (_IfcPhysicalSimpleQua18) {
    _inherits(IfcQuantityVolume, _IfcPhysicalSimpleQua18);

    var _super1687 = _createSuper(IfcQuantityVolume);

    function IfcQuantityVolume(expressID, Name, Description, Unit, VolumeValue, Formula) {
      var _this1679;

      _classCallCheck2(this, IfcQuantityVolume);

      _this1679 = _super1687.call(this, expressID, Name, Description, Unit);
      _this1679.Name = Name;
      _this1679.Description = Description;
      _this1679.Unit = Unit;
      _this1679.VolumeValue = VolumeValue;
      _this1679.Formula = Formula;
      _this1679.type = 2405470396;
      return _this1679;
    }

    return IfcQuantityVolume;
  }(IfcPhysicalSimpleQuantity);

  IFC42.IfcQuantityVolume = IfcQuantityVolume;

  var IfcQuantityWeight = /*#__PURE__*/function (_IfcPhysicalSimpleQua19) {
    _inherits(IfcQuantityWeight, _IfcPhysicalSimpleQua19);

    var _super1688 = _createSuper(IfcQuantityWeight);

    function IfcQuantityWeight(expressID, Name, Description, Unit, WeightValue, Formula) {
      var _this1680;

      _classCallCheck2(this, IfcQuantityWeight);

      _this1680 = _super1688.call(this, expressID, Name, Description, Unit);
      _this1680.Name = Name;
      _this1680.Description = Description;
      _this1680.Unit = Unit;
      _this1680.WeightValue = WeightValue;
      _this1680.Formula = Formula;
      _this1680.type = 825690147;
      return _this1680;
    }

    return IfcQuantityWeight;
  }(IfcPhysicalSimpleQuantity);

  IFC42.IfcQuantityWeight = IfcQuantityWeight;

  var IfcRecurrencePattern = /*#__PURE__*/function (_IfcLineObject201) {
    _inherits(IfcRecurrencePattern, _IfcLineObject201);

    var _super1689 = _createSuper(IfcRecurrencePattern);

    function IfcRecurrencePattern(expressID, RecurrenceType, DayComponent, WeekdayComponent, MonthComponent, Position, Interval, Occurrences, TimePeriods) {
      var _this1681;

      _classCallCheck2(this, IfcRecurrencePattern);

      _this1681 = _super1689.call(this, expressID);
      _this1681.RecurrenceType = RecurrenceType;
      _this1681.DayComponent = DayComponent;
      _this1681.WeekdayComponent = WeekdayComponent;
      _this1681.MonthComponent = MonthComponent;
      _this1681.Position = Position;
      _this1681.Interval = Interval;
      _this1681.Occurrences = Occurrences;
      _this1681.TimePeriods = TimePeriods;
      _this1681.type = 3915482550;
      return _this1681;
    }

    return IfcRecurrencePattern;
  }(IfcLineObject);

  IFC42.IfcRecurrencePattern = IfcRecurrencePattern;

  var IfcReference = /*#__PURE__*/function (_IfcLineObject202) {
    _inherits(IfcReference, _IfcLineObject202);

    var _super1690 = _createSuper(IfcReference);

    function IfcReference(expressID, TypeIdentifier, AttributeIdentifier, InstanceName, ListPositions, InnerReference) {
      var _this1682;

      _classCallCheck2(this, IfcReference);

      _this1682 = _super1690.call(this, expressID);
      _this1682.TypeIdentifier = TypeIdentifier;
      _this1682.AttributeIdentifier = AttributeIdentifier;
      _this1682.InstanceName = InstanceName;
      _this1682.ListPositions = ListPositions;
      _this1682.InnerReference = InnerReference;
      _this1682.type = 2433181523;
      return _this1682;
    }

    return IfcReference;
  }(IfcLineObject);

  IFC42.IfcReference = IfcReference;

  var IfcRepresentation = /*#__PURE__*/function (_IfcLineObject203) {
    _inherits(IfcRepresentation, _IfcLineObject203);

    var _super1691 = _createSuper(IfcRepresentation);

    function IfcRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this1683;

      _classCallCheck2(this, IfcRepresentation);

      _this1683 = _super1691.call(this, expressID);
      _this1683.ContextOfItems = ContextOfItems;
      _this1683.RepresentationIdentifier = RepresentationIdentifier;
      _this1683.RepresentationType = RepresentationType;
      _this1683.Items = Items;
      _this1683.type = 1076942058;
      return _this1683;
    }

    return IfcRepresentation;
  }(IfcLineObject);

  IFC42.IfcRepresentation = IfcRepresentation;

  var IfcRepresentationContext = /*#__PURE__*/function (_IfcLineObject204) {
    _inherits(IfcRepresentationContext, _IfcLineObject204);

    var _super1692 = _createSuper(IfcRepresentationContext);

    function IfcRepresentationContext(expressID, ContextIdentifier, ContextType) {
      var _this1684;

      _classCallCheck2(this, IfcRepresentationContext);

      _this1684 = _super1692.call(this, expressID);
      _this1684.ContextIdentifier = ContextIdentifier;
      _this1684.ContextType = ContextType;
      _this1684.type = 3377609919;
      return _this1684;
    }

    return IfcRepresentationContext;
  }(IfcLineObject);

  IFC42.IfcRepresentationContext = IfcRepresentationContext;

  var IfcRepresentationItem = /*#__PURE__*/function (_IfcLineObject205) {
    _inherits(IfcRepresentationItem, _IfcLineObject205);

    var _super1693 = _createSuper(IfcRepresentationItem);

    function IfcRepresentationItem(expressID) {
      var _this1685;

      _classCallCheck2(this, IfcRepresentationItem);

      _this1685 = _super1693.call(this, expressID);
      _this1685.type = 3008791417;
      return _this1685;
    }

    return IfcRepresentationItem;
  }(IfcLineObject);

  IFC42.IfcRepresentationItem = IfcRepresentationItem;

  var IfcRepresentationMap = /*#__PURE__*/function (_IfcLineObject206) {
    _inherits(IfcRepresentationMap, _IfcLineObject206);

    var _super1694 = _createSuper(IfcRepresentationMap);

    function IfcRepresentationMap(expressID, MappingOrigin, MappedRepresentation) {
      var _this1686;

      _classCallCheck2(this, IfcRepresentationMap);

      _this1686 = _super1694.call(this, expressID);
      _this1686.MappingOrigin = MappingOrigin;
      _this1686.MappedRepresentation = MappedRepresentation;
      _this1686.type = 1660063152;
      return _this1686;
    }

    return IfcRepresentationMap;
  }(IfcLineObject);

  IFC42.IfcRepresentationMap = IfcRepresentationMap;

  var IfcResourceLevelRelationship = /*#__PURE__*/function (_IfcLineObject207) {
    _inherits(IfcResourceLevelRelationship, _IfcLineObject207);

    var _super1695 = _createSuper(IfcResourceLevelRelationship);

    function IfcResourceLevelRelationship(expressID, Name, Description) {
      var _this1687;

      _classCallCheck2(this, IfcResourceLevelRelationship);

      _this1687 = _super1695.call(this, expressID);
      _this1687.Name = Name;
      _this1687.Description = Description;
      _this1687.type = 2439245199;
      return _this1687;
    }

    return IfcResourceLevelRelationship;
  }(IfcLineObject);

  IFC42.IfcResourceLevelRelationship = IfcResourceLevelRelationship;

  var IfcRoot = /*#__PURE__*/function (_IfcLineObject208) {
    _inherits(IfcRoot, _IfcLineObject208);

    var _super1696 = _createSuper(IfcRoot);

    function IfcRoot(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1688;

      _classCallCheck2(this, IfcRoot);

      _this1688 = _super1696.call(this, expressID);
      _this1688.GlobalId = GlobalId;
      _this1688.OwnerHistory = OwnerHistory;
      _this1688.Name = Name;
      _this1688.Description = Description;
      _this1688.type = 2341007311;
      return _this1688;
    }

    return IfcRoot;
  }(IfcLineObject);

  IFC42.IfcRoot = IfcRoot;

  var IfcSIUnit = /*#__PURE__*/function (_IfcNamedUnit7) {
    _inherits(IfcSIUnit, _IfcNamedUnit7);

    var _super1697 = _createSuper(IfcSIUnit);

    function IfcSIUnit(expressID, UnitType, Prefix, Name) {
      var _this1689;

      _classCallCheck2(this, IfcSIUnit);

      _this1689 = _super1697.call(this, expressID, new Handle(0), UnitType);
      _this1689.UnitType = UnitType;
      _this1689.Prefix = Prefix;
      _this1689.Name = Name;
      _this1689.type = 448429030;
      return _this1689;
    }

    return IfcSIUnit;
  }(IfcNamedUnit);

  IFC42.IfcSIUnit = IfcSIUnit;

  var IfcSchedulingTime = /*#__PURE__*/function (_IfcLineObject209) {
    _inherits(IfcSchedulingTime, _IfcLineObject209);

    var _super1698 = _createSuper(IfcSchedulingTime);

    function IfcSchedulingTime(expressID, Name, DataOrigin, UserDefinedDataOrigin) {
      var _this1690;

      _classCallCheck2(this, IfcSchedulingTime);

      _this1690 = _super1698.call(this, expressID);
      _this1690.Name = Name;
      _this1690.DataOrigin = DataOrigin;
      _this1690.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this1690.type = 1054537805;
      return _this1690;
    }

    return IfcSchedulingTime;
  }(IfcLineObject);

  IFC42.IfcSchedulingTime = IfcSchedulingTime;

  var IfcShapeAspect = /*#__PURE__*/function (_IfcLineObject210) {
    _inherits(IfcShapeAspect, _IfcLineObject210);

    var _super1699 = _createSuper(IfcShapeAspect);

    function IfcShapeAspect(expressID, ShapeRepresentations, Name, Description, ProductDefinitional, PartOfProductDefinitionShape) {
      var _this1691;

      _classCallCheck2(this, IfcShapeAspect);

      _this1691 = _super1699.call(this, expressID);
      _this1691.ShapeRepresentations = ShapeRepresentations;
      _this1691.Name = Name;
      _this1691.Description = Description;
      _this1691.ProductDefinitional = ProductDefinitional;
      _this1691.PartOfProductDefinitionShape = PartOfProductDefinitionShape;
      _this1691.type = 867548509;
      return _this1691;
    }

    return IfcShapeAspect;
  }(IfcLineObject);

  IFC42.IfcShapeAspect = IfcShapeAspect;

  var IfcShapeModel = /*#__PURE__*/function (_IfcRepresentation5) {
    _inherits(IfcShapeModel, _IfcRepresentation5);

    var _super1700 = _createSuper(IfcShapeModel);

    function IfcShapeModel(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this1692;

      _classCallCheck2(this, IfcShapeModel);

      _this1692 = _super1700.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this1692.ContextOfItems = ContextOfItems;
      _this1692.RepresentationIdentifier = RepresentationIdentifier;
      _this1692.RepresentationType = RepresentationType;
      _this1692.Items = Items;
      _this1692.type = 3982875396;
      return _this1692;
    }

    return IfcShapeModel;
  }(IfcRepresentation);

  IFC42.IfcShapeModel = IfcShapeModel;

  var IfcShapeRepresentation = /*#__PURE__*/function (_IfcShapeModel5) {
    _inherits(IfcShapeRepresentation, _IfcShapeModel5);

    var _super1701 = _createSuper(IfcShapeRepresentation);

    function IfcShapeRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this1693;

      _classCallCheck2(this, IfcShapeRepresentation);

      _this1693 = _super1701.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this1693.ContextOfItems = ContextOfItems;
      _this1693.RepresentationIdentifier = RepresentationIdentifier;
      _this1693.RepresentationType = RepresentationType;
      _this1693.Items = Items;
      _this1693.type = 4240577450;
      return _this1693;
    }

    return IfcShapeRepresentation;
  }(IfcShapeModel);

  IFC42.IfcShapeRepresentation = IfcShapeRepresentation;

  var IfcStructuralConnectionCondition = /*#__PURE__*/function (_IfcLineObject211) {
    _inherits(IfcStructuralConnectionCondition, _IfcLineObject211);

    var _super1702 = _createSuper(IfcStructuralConnectionCondition);

    function IfcStructuralConnectionCondition(expressID, Name) {
      var _this1694;

      _classCallCheck2(this, IfcStructuralConnectionCondition);

      _this1694 = _super1702.call(this, expressID);
      _this1694.Name = Name;
      _this1694.type = 2273995522;
      return _this1694;
    }

    return IfcStructuralConnectionCondition;
  }(IfcLineObject);

  IFC42.IfcStructuralConnectionCondition = IfcStructuralConnectionCondition;

  var IfcStructuralLoad = /*#__PURE__*/function (_IfcLineObject212) {
    _inherits(IfcStructuralLoad, _IfcLineObject212);

    var _super1703 = _createSuper(IfcStructuralLoad);

    function IfcStructuralLoad(expressID, Name) {
      var _this1695;

      _classCallCheck2(this, IfcStructuralLoad);

      _this1695 = _super1703.call(this, expressID);
      _this1695.Name = Name;
      _this1695.type = 2162789131;
      return _this1695;
    }

    return IfcStructuralLoad;
  }(IfcLineObject);

  IFC42.IfcStructuralLoad = IfcStructuralLoad;

  var IfcStructuralLoadConfiguration = /*#__PURE__*/function (_IfcStructuralLoad4) {
    _inherits(IfcStructuralLoadConfiguration, _IfcStructuralLoad4);

    var _super1704 = _createSuper(IfcStructuralLoadConfiguration);

    function IfcStructuralLoadConfiguration(expressID, Name, Values, Locations) {
      var _this1696;

      _classCallCheck2(this, IfcStructuralLoadConfiguration);

      _this1696 = _super1704.call(this, expressID, Name);
      _this1696.Name = Name;
      _this1696.Values = Values;
      _this1696.Locations = Locations;
      _this1696.type = 3478079324;
      return _this1696;
    }

    return IfcStructuralLoadConfiguration;
  }(IfcStructuralLoad);

  IFC42.IfcStructuralLoadConfiguration = IfcStructuralLoadConfiguration;

  var IfcStructuralLoadOrResult = /*#__PURE__*/function (_IfcStructuralLoad5) {
    _inherits(IfcStructuralLoadOrResult, _IfcStructuralLoad5);

    var _super1705 = _createSuper(IfcStructuralLoadOrResult);

    function IfcStructuralLoadOrResult(expressID, Name) {
      var _this1697;

      _classCallCheck2(this, IfcStructuralLoadOrResult);

      _this1697 = _super1705.call(this, expressID, Name);
      _this1697.Name = Name;
      _this1697.type = 609421318;
      return _this1697;
    }

    return IfcStructuralLoadOrResult;
  }(IfcStructuralLoad);

  IFC42.IfcStructuralLoadOrResult = IfcStructuralLoadOrResult;

  var IfcStructuralLoadStatic = /*#__PURE__*/function (_IfcStructuralLoadOrR3) {
    _inherits(IfcStructuralLoadStatic, _IfcStructuralLoadOrR3);

    var _super1706 = _createSuper(IfcStructuralLoadStatic);

    function IfcStructuralLoadStatic(expressID, Name) {
      var _this1698;

      _classCallCheck2(this, IfcStructuralLoadStatic);

      _this1698 = _super1706.call(this, expressID, Name);
      _this1698.Name = Name;
      _this1698.type = 2525727697;
      return _this1698;
    }

    return IfcStructuralLoadStatic;
  }(IfcStructuralLoadOrResult);

  IFC42.IfcStructuralLoadStatic = IfcStructuralLoadStatic;

  var IfcStructuralLoadTemperature = /*#__PURE__*/function (_IfcStructuralLoadSta11) {
    _inherits(IfcStructuralLoadTemperature, _IfcStructuralLoadSta11);

    var _super1707 = _createSuper(IfcStructuralLoadTemperature);

    function IfcStructuralLoadTemperature(expressID, Name, DeltaTConstant, DeltaTY, DeltaTZ) {
      var _this1699;

      _classCallCheck2(this, IfcStructuralLoadTemperature);

      _this1699 = _super1707.call(this, expressID, Name);
      _this1699.Name = Name;
      _this1699.DeltaTConstant = DeltaTConstant;
      _this1699.DeltaTY = DeltaTY;
      _this1699.DeltaTZ = DeltaTZ;
      _this1699.type = 3408363356;
      return _this1699;
    }

    return IfcStructuralLoadTemperature;
  }(IfcStructuralLoadStatic);

  IFC42.IfcStructuralLoadTemperature = IfcStructuralLoadTemperature;

  var IfcStyleModel = /*#__PURE__*/function (_IfcRepresentation6) {
    _inherits(IfcStyleModel, _IfcRepresentation6);

    var _super1708 = _createSuper(IfcStyleModel);

    function IfcStyleModel(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this1700;

      _classCallCheck2(this, IfcStyleModel);

      _this1700 = _super1708.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this1700.ContextOfItems = ContextOfItems;
      _this1700.RepresentationIdentifier = RepresentationIdentifier;
      _this1700.RepresentationType = RepresentationType;
      _this1700.Items = Items;
      _this1700.type = 2830218821;
      return _this1700;
    }

    return IfcStyleModel;
  }(IfcRepresentation);

  IFC42.IfcStyleModel = IfcStyleModel;

  var IfcStyledItem = /*#__PURE__*/function (_IfcRepresentationIte9) {
    _inherits(IfcStyledItem, _IfcRepresentationIte9);

    var _super1709 = _createSuper(IfcStyledItem);

    function IfcStyledItem(expressID, Item, Styles, Name) {
      var _this1701;

      _classCallCheck2(this, IfcStyledItem);

      _this1701 = _super1709.call(this, expressID);
      _this1701.Item = Item;
      _this1701.Styles = Styles;
      _this1701.Name = Name;
      _this1701.type = 3958052878;
      return _this1701;
    }

    return IfcStyledItem;
  }(IfcRepresentationItem);

  IFC42.IfcStyledItem = IfcStyledItem;

  var IfcStyledRepresentation = /*#__PURE__*/function (_IfcStyleModel3) {
    _inherits(IfcStyledRepresentation, _IfcStyleModel3);

    var _super1710 = _createSuper(IfcStyledRepresentation);

    function IfcStyledRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this1702;

      _classCallCheck2(this, IfcStyledRepresentation);

      _this1702 = _super1710.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this1702.ContextOfItems = ContextOfItems;
      _this1702.RepresentationIdentifier = RepresentationIdentifier;
      _this1702.RepresentationType = RepresentationType;
      _this1702.Items = Items;
      _this1702.type = 3049322572;
      return _this1702;
    }

    return IfcStyledRepresentation;
  }(IfcStyleModel);

  IFC42.IfcStyledRepresentation = IfcStyledRepresentation;

  var IfcSurfaceReinforcementArea = /*#__PURE__*/function (_IfcStructuralLoadOrR4) {
    _inherits(IfcSurfaceReinforcementArea, _IfcStructuralLoadOrR4);

    var _super1711 = _createSuper(IfcSurfaceReinforcementArea);

    function IfcSurfaceReinforcementArea(expressID, Name, SurfaceReinforcement1, SurfaceReinforcement2, ShearReinforcement) {
      var _this1703;

      _classCallCheck2(this, IfcSurfaceReinforcementArea);

      _this1703 = _super1711.call(this, expressID, Name);
      _this1703.Name = Name;
      _this1703.SurfaceReinforcement1 = SurfaceReinforcement1;
      _this1703.SurfaceReinforcement2 = SurfaceReinforcement2;
      _this1703.ShearReinforcement = ShearReinforcement;
      _this1703.type = 2934153892;
      return _this1703;
    }

    return IfcSurfaceReinforcementArea;
  }(IfcStructuralLoadOrResult);

  IFC42.IfcSurfaceReinforcementArea = IfcSurfaceReinforcementArea;

  var IfcSurfaceStyle = /*#__PURE__*/function (_IfcPresentationStyle10) {
    _inherits(IfcSurfaceStyle, _IfcPresentationStyle10);

    var _super1712 = _createSuper(IfcSurfaceStyle);

    function IfcSurfaceStyle(expressID, Name, Side, Styles) {
      var _this1704;

      _classCallCheck2(this, IfcSurfaceStyle);

      _this1704 = _super1712.call(this, expressID, Name);
      _this1704.Name = Name;
      _this1704.Side = Side;
      _this1704.Styles = Styles;
      _this1704.type = 1300840506;
      return _this1704;
    }

    return IfcSurfaceStyle;
  }(IfcPresentationStyle);

  IFC42.IfcSurfaceStyle = IfcSurfaceStyle;

  var IfcSurfaceStyleLighting = /*#__PURE__*/function (_IfcPresentationItem18) {
    _inherits(IfcSurfaceStyleLighting, _IfcPresentationItem18);

    var _super1713 = _createSuper(IfcSurfaceStyleLighting);

    function IfcSurfaceStyleLighting(expressID, DiffuseTransmissionColour, DiffuseReflectionColour, TransmissionColour, ReflectanceColour) {
      var _this1705;

      _classCallCheck2(this, IfcSurfaceStyleLighting);

      _this1705 = _super1713.call(this, expressID);
      _this1705.DiffuseTransmissionColour = DiffuseTransmissionColour;
      _this1705.DiffuseReflectionColour = DiffuseReflectionColour;
      _this1705.TransmissionColour = TransmissionColour;
      _this1705.ReflectanceColour = ReflectanceColour;
      _this1705.type = 3303107099;
      return _this1705;
    }

    return IfcSurfaceStyleLighting;
  }(IfcPresentationItem);

  IFC42.IfcSurfaceStyleLighting = IfcSurfaceStyleLighting;

  var IfcSurfaceStyleRefraction = /*#__PURE__*/function (_IfcPresentationItem19) {
    _inherits(IfcSurfaceStyleRefraction, _IfcPresentationItem19);

    var _super1714 = _createSuper(IfcSurfaceStyleRefraction);

    function IfcSurfaceStyleRefraction(expressID, RefractionIndex, DispersionFactor) {
      var _this1706;

      _classCallCheck2(this, IfcSurfaceStyleRefraction);

      _this1706 = _super1714.call(this, expressID);
      _this1706.RefractionIndex = RefractionIndex;
      _this1706.DispersionFactor = DispersionFactor;
      _this1706.type = 1607154358;
      return _this1706;
    }

    return IfcSurfaceStyleRefraction;
  }(IfcPresentationItem);

  IFC42.IfcSurfaceStyleRefraction = IfcSurfaceStyleRefraction;

  var IfcSurfaceStyleShading = /*#__PURE__*/function (_IfcPresentationItem20) {
    _inherits(IfcSurfaceStyleShading, _IfcPresentationItem20);

    var _super1715 = _createSuper(IfcSurfaceStyleShading);

    function IfcSurfaceStyleShading(expressID, SurfaceColour, Transparency) {
      var _this1707;

      _classCallCheck2(this, IfcSurfaceStyleShading);

      _this1707 = _super1715.call(this, expressID);
      _this1707.SurfaceColour = SurfaceColour;
      _this1707.Transparency = Transparency;
      _this1707.type = 846575682;
      return _this1707;
    }

    return IfcSurfaceStyleShading;
  }(IfcPresentationItem);

  IFC42.IfcSurfaceStyleShading = IfcSurfaceStyleShading;

  var IfcSurfaceStyleWithTextures = /*#__PURE__*/function (_IfcPresentationItem21) {
    _inherits(IfcSurfaceStyleWithTextures, _IfcPresentationItem21);

    var _super1716 = _createSuper(IfcSurfaceStyleWithTextures);

    function IfcSurfaceStyleWithTextures(expressID, Textures) {
      var _this1708;

      _classCallCheck2(this, IfcSurfaceStyleWithTextures);

      _this1708 = _super1716.call(this, expressID);
      _this1708.Textures = Textures;
      _this1708.type = 1351298697;
      return _this1708;
    }

    return IfcSurfaceStyleWithTextures;
  }(IfcPresentationItem);

  IFC42.IfcSurfaceStyleWithTextures = IfcSurfaceStyleWithTextures;

  var IfcSurfaceTexture = /*#__PURE__*/function (_IfcPresentationItem22) {
    _inherits(IfcSurfaceTexture, _IfcPresentationItem22);

    var _super1717 = _createSuper(IfcSurfaceTexture);

    function IfcSurfaceTexture(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter) {
      var _this1709;

      _classCallCheck2(this, IfcSurfaceTexture);

      _this1709 = _super1717.call(this, expressID);
      _this1709.RepeatS = RepeatS;
      _this1709.RepeatT = RepeatT;
      _this1709.Mode = Mode;
      _this1709.TextureTransform = TextureTransform;
      _this1709.Parameter = Parameter;
      _this1709.type = 626085974;
      return _this1709;
    }

    return IfcSurfaceTexture;
  }(IfcPresentationItem);

  IFC42.IfcSurfaceTexture = IfcSurfaceTexture;

  var IfcTable = /*#__PURE__*/function (_IfcLineObject213) {
    _inherits(IfcTable, _IfcLineObject213);

    var _super1718 = _createSuper(IfcTable);

    function IfcTable(expressID, Name, Rows, Columns) {
      var _this1710;

      _classCallCheck2(this, IfcTable);

      _this1710 = _super1718.call(this, expressID);
      _this1710.Name = Name;
      _this1710.Rows = Rows;
      _this1710.Columns = Columns;
      _this1710.type = 985171141;
      return _this1710;
    }

    return IfcTable;
  }(IfcLineObject);

  IFC42.IfcTable = IfcTable;

  var IfcTableColumn = /*#__PURE__*/function (_IfcLineObject214) {
    _inherits(IfcTableColumn, _IfcLineObject214);

    var _super1719 = _createSuper(IfcTableColumn);

    function IfcTableColumn(expressID, Identifier, Name, Description, Unit, ReferencePath) {
      var _this1711;

      _classCallCheck2(this, IfcTableColumn);

      _this1711 = _super1719.call(this, expressID);
      _this1711.Identifier = Identifier;
      _this1711.Name = Name;
      _this1711.Description = Description;
      _this1711.Unit = Unit;
      _this1711.ReferencePath = ReferencePath;
      _this1711.type = 2043862942;
      return _this1711;
    }

    return IfcTableColumn;
  }(IfcLineObject);

  IFC42.IfcTableColumn = IfcTableColumn;

  var IfcTableRow = /*#__PURE__*/function (_IfcLineObject215) {
    _inherits(IfcTableRow, _IfcLineObject215);

    var _super1720 = _createSuper(IfcTableRow);

    function IfcTableRow(expressID, RowCells, IsHeading) {
      var _this1712;

      _classCallCheck2(this, IfcTableRow);

      _this1712 = _super1720.call(this, expressID);
      _this1712.RowCells = RowCells;
      _this1712.IsHeading = IsHeading;
      _this1712.type = 531007025;
      return _this1712;
    }

    return IfcTableRow;
  }(IfcLineObject);

  IFC42.IfcTableRow = IfcTableRow;

  var IfcTaskTime = /*#__PURE__*/function (_IfcSchedulingTime6) {
    _inherits(IfcTaskTime, _IfcSchedulingTime6);

    var _super1721 = _createSuper(IfcTaskTime);

    function IfcTaskTime(expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion) {
      var _this1713;

      _classCallCheck2(this, IfcTaskTime);

      _this1713 = _super1721.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin);
      _this1713.Name = Name;
      _this1713.DataOrigin = DataOrigin;
      _this1713.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this1713.DurationType = DurationType;
      _this1713.ScheduleDuration = ScheduleDuration;
      _this1713.ScheduleStart = ScheduleStart;
      _this1713.ScheduleFinish = ScheduleFinish;
      _this1713.EarlyStart = EarlyStart;
      _this1713.EarlyFinish = EarlyFinish;
      _this1713.LateStart = LateStart;
      _this1713.LateFinish = LateFinish;
      _this1713.FreeFloat = FreeFloat;
      _this1713.TotalFloat = TotalFloat;
      _this1713.IsCritical = IsCritical;
      _this1713.StatusTime = StatusTime;
      _this1713.ActualDuration = ActualDuration;
      _this1713.ActualStart = ActualStart;
      _this1713.ActualFinish = ActualFinish;
      _this1713.RemainingTime = RemainingTime;
      _this1713.Completion = Completion;
      _this1713.type = 1549132990;
      return _this1713;
    }

    return IfcTaskTime;
  }(IfcSchedulingTime);

  IFC42.IfcTaskTime = IfcTaskTime;

  var IfcTaskTimeRecurring = /*#__PURE__*/function (_IfcTaskTime2) {
    _inherits(IfcTaskTimeRecurring, _IfcTaskTime2);

    var _super1722 = _createSuper(IfcTaskTimeRecurring);

    function IfcTaskTimeRecurring(expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion, Recurrence) {
      var _this1714;

      _classCallCheck2(this, IfcTaskTimeRecurring);

      _this1714 = _super1722.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin, DurationType, ScheduleDuration, ScheduleStart, ScheduleFinish, EarlyStart, EarlyFinish, LateStart, LateFinish, FreeFloat, TotalFloat, IsCritical, StatusTime, ActualDuration, ActualStart, ActualFinish, RemainingTime, Completion);
      _this1714.Name = Name;
      _this1714.DataOrigin = DataOrigin;
      _this1714.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this1714.DurationType = DurationType;
      _this1714.ScheduleDuration = ScheduleDuration;
      _this1714.ScheduleStart = ScheduleStart;
      _this1714.ScheduleFinish = ScheduleFinish;
      _this1714.EarlyStart = EarlyStart;
      _this1714.EarlyFinish = EarlyFinish;
      _this1714.LateStart = LateStart;
      _this1714.LateFinish = LateFinish;
      _this1714.FreeFloat = FreeFloat;
      _this1714.TotalFloat = TotalFloat;
      _this1714.IsCritical = IsCritical;
      _this1714.StatusTime = StatusTime;
      _this1714.ActualDuration = ActualDuration;
      _this1714.ActualStart = ActualStart;
      _this1714.ActualFinish = ActualFinish;
      _this1714.RemainingTime = RemainingTime;
      _this1714.Completion = Completion;
      _this1714.Recurrence = Recurrence;
      _this1714.type = 2771591690;
      return _this1714;
    }

    return IfcTaskTimeRecurring;
  }(IfcTaskTime);

  IFC42.IfcTaskTimeRecurring = IfcTaskTimeRecurring;

  var IfcTelecomAddress = /*#__PURE__*/function (_IfcAddress6) {
    _inherits(IfcTelecomAddress, _IfcAddress6);

    var _super1723 = _createSuper(IfcTelecomAddress);

    function IfcTelecomAddress(expressID, Purpose, Description, UserDefinedPurpose, TelephoneNumbers, FacsimileNumbers, PagerNumber, ElectronicMailAddresses, WWWHomePageURL, MessagingIDs) {
      var _this1715;

      _classCallCheck2(this, IfcTelecomAddress);

      _this1715 = _super1723.call(this, expressID, Purpose, Description, UserDefinedPurpose);
      _this1715.Purpose = Purpose;
      _this1715.Description = Description;
      _this1715.UserDefinedPurpose = UserDefinedPurpose;
      _this1715.TelephoneNumbers = TelephoneNumbers;
      _this1715.FacsimileNumbers = FacsimileNumbers;
      _this1715.PagerNumber = PagerNumber;
      _this1715.ElectronicMailAddresses = ElectronicMailAddresses;
      _this1715.WWWHomePageURL = WWWHomePageURL;
      _this1715.MessagingIDs = MessagingIDs;
      _this1715.type = 912023232;
      return _this1715;
    }

    return IfcTelecomAddress;
  }(IfcAddress);

  IFC42.IfcTelecomAddress = IfcTelecomAddress;

  var IfcTextStyle = /*#__PURE__*/function (_IfcPresentationStyle11) {
    _inherits(IfcTextStyle, _IfcPresentationStyle11);

    var _super1724 = _createSuper(IfcTextStyle);

    function IfcTextStyle(expressID, Name, TextCharacterAppearance, TextStyle, TextFontStyle, ModelOrDraughting) {
      var _this1716;

      _classCallCheck2(this, IfcTextStyle);

      _this1716 = _super1724.call(this, expressID, Name);
      _this1716.Name = Name;
      _this1716.TextCharacterAppearance = TextCharacterAppearance;
      _this1716.TextStyle = TextStyle;
      _this1716.TextFontStyle = TextFontStyle;
      _this1716.ModelOrDraughting = ModelOrDraughting;
      _this1716.type = 1447204868;
      return _this1716;
    }

    return IfcTextStyle;
  }(IfcPresentationStyle);

  IFC42.IfcTextStyle = IfcTextStyle;

  var IfcTextStyleForDefinedFont = /*#__PURE__*/function (_IfcPresentationItem23) {
    _inherits(IfcTextStyleForDefinedFont, _IfcPresentationItem23);

    var _super1725 = _createSuper(IfcTextStyleForDefinedFont);

    function IfcTextStyleForDefinedFont(expressID, Colour, BackgroundColour) {
      var _this1717;

      _classCallCheck2(this, IfcTextStyleForDefinedFont);

      _this1717 = _super1725.call(this, expressID);
      _this1717.Colour = Colour;
      _this1717.BackgroundColour = BackgroundColour;
      _this1717.type = 2636378356;
      return _this1717;
    }

    return IfcTextStyleForDefinedFont;
  }(IfcPresentationItem);

  IFC42.IfcTextStyleForDefinedFont = IfcTextStyleForDefinedFont;

  var IfcTextStyleTextModel = /*#__PURE__*/function (_IfcPresentationItem24) {
    _inherits(IfcTextStyleTextModel, _IfcPresentationItem24);

    var _super1726 = _createSuper(IfcTextStyleTextModel);

    function IfcTextStyleTextModel(expressID, TextIndent, TextAlign, TextDecoration, LetterSpacing, WordSpacing, TextTransform, LineHeight) {
      var _this1718;

      _classCallCheck2(this, IfcTextStyleTextModel);

      _this1718 = _super1726.call(this, expressID);
      _this1718.TextIndent = TextIndent;
      _this1718.TextAlign = TextAlign;
      _this1718.TextDecoration = TextDecoration;
      _this1718.LetterSpacing = LetterSpacing;
      _this1718.WordSpacing = WordSpacing;
      _this1718.TextTransform = TextTransform;
      _this1718.LineHeight = LineHeight;
      _this1718.type = 1640371178;
      return _this1718;
    }

    return IfcTextStyleTextModel;
  }(IfcPresentationItem);

  IFC42.IfcTextStyleTextModel = IfcTextStyleTextModel;

  var IfcTextureCoordinate = /*#__PURE__*/function (_IfcPresentationItem25) {
    _inherits(IfcTextureCoordinate, _IfcPresentationItem25);

    var _super1727 = _createSuper(IfcTextureCoordinate);

    function IfcTextureCoordinate(expressID, Maps) {
      var _this1719;

      _classCallCheck2(this, IfcTextureCoordinate);

      _this1719 = _super1727.call(this, expressID);
      _this1719.Maps = Maps;
      _this1719.type = 280115917;
      return _this1719;
    }

    return IfcTextureCoordinate;
  }(IfcPresentationItem);

  IFC42.IfcTextureCoordinate = IfcTextureCoordinate;

  var IfcTextureCoordinateGenerator = /*#__PURE__*/function (_IfcTextureCoordinate7) {
    _inherits(IfcTextureCoordinateGenerator, _IfcTextureCoordinate7);

    var _super1728 = _createSuper(IfcTextureCoordinateGenerator);

    function IfcTextureCoordinateGenerator(expressID, Maps, Mode, Parameter) {
      var _this1720;

      _classCallCheck2(this, IfcTextureCoordinateGenerator);

      _this1720 = _super1728.call(this, expressID, Maps);
      _this1720.Maps = Maps;
      _this1720.Mode = Mode;
      _this1720.Parameter = Parameter;
      _this1720.type = 1742049831;
      return _this1720;
    }

    return IfcTextureCoordinateGenerator;
  }(IfcTextureCoordinate);

  IFC42.IfcTextureCoordinateGenerator = IfcTextureCoordinateGenerator;

  var IfcTextureMap = /*#__PURE__*/function (_IfcTextureCoordinate8) {
    _inherits(IfcTextureMap, _IfcTextureCoordinate8);

    var _super1729 = _createSuper(IfcTextureMap);

    function IfcTextureMap(expressID, Maps, Vertices, MappedTo) {
      var _this1721;

      _classCallCheck2(this, IfcTextureMap);

      _this1721 = _super1729.call(this, expressID, Maps);
      _this1721.Maps = Maps;
      _this1721.Vertices = Vertices;
      _this1721.MappedTo = MappedTo;
      _this1721.type = 2552916305;
      return _this1721;
    }

    return IfcTextureMap;
  }(IfcTextureCoordinate);

  IFC42.IfcTextureMap = IfcTextureMap;

  var IfcTextureVertex = /*#__PURE__*/function (_IfcPresentationItem26) {
    _inherits(IfcTextureVertex, _IfcPresentationItem26);

    var _super1730 = _createSuper(IfcTextureVertex);

    function IfcTextureVertex(expressID, Coordinates) {
      var _this1722;

      _classCallCheck2(this, IfcTextureVertex);

      _this1722 = _super1730.call(this, expressID);
      _this1722.Coordinates = Coordinates;
      _this1722.type = 1210645708;
      return _this1722;
    }

    return IfcTextureVertex;
  }(IfcPresentationItem);

  IFC42.IfcTextureVertex = IfcTextureVertex;

  var IfcTextureVertexList = /*#__PURE__*/function (_IfcPresentationItem27) {
    _inherits(IfcTextureVertexList, _IfcPresentationItem27);

    var _super1731 = _createSuper(IfcTextureVertexList);

    function IfcTextureVertexList(expressID, TexCoordsList) {
      var _this1723;

      _classCallCheck2(this, IfcTextureVertexList);

      _this1723 = _super1731.call(this, expressID);
      _this1723.TexCoordsList = TexCoordsList;
      _this1723.type = 3611470254;
      return _this1723;
    }

    return IfcTextureVertexList;
  }(IfcPresentationItem);

  IFC42.IfcTextureVertexList = IfcTextureVertexList;

  var IfcTimePeriod = /*#__PURE__*/function (_IfcLineObject216) {
    _inherits(IfcTimePeriod, _IfcLineObject216);

    var _super1732 = _createSuper(IfcTimePeriod);

    function IfcTimePeriod(expressID, StartTime, EndTime) {
      var _this1724;

      _classCallCheck2(this, IfcTimePeriod);

      _this1724 = _super1732.call(this, expressID);
      _this1724.StartTime = StartTime;
      _this1724.EndTime = EndTime;
      _this1724.type = 1199560280;
      return _this1724;
    }

    return IfcTimePeriod;
  }(IfcLineObject);

  IFC42.IfcTimePeriod = IfcTimePeriod;

  var IfcTimeSeries = /*#__PURE__*/function (_IfcLineObject217) {
    _inherits(IfcTimeSeries, _IfcLineObject217);

    var _super1733 = _createSuper(IfcTimeSeries);

    function IfcTimeSeries(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit) {
      var _this1725;

      _classCallCheck2(this, IfcTimeSeries);

      _this1725 = _super1733.call(this, expressID);
      _this1725.Name = Name;
      _this1725.Description = Description;
      _this1725.StartTime = StartTime;
      _this1725.EndTime = EndTime;
      _this1725.TimeSeriesDataType = TimeSeriesDataType;
      _this1725.DataOrigin = DataOrigin;
      _this1725.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this1725.Unit = Unit;
      _this1725.type = 3101149627;
      return _this1725;
    }

    return IfcTimeSeries;
  }(IfcLineObject);

  IFC42.IfcTimeSeries = IfcTimeSeries;

  var IfcTimeSeriesValue = /*#__PURE__*/function (_IfcLineObject218) {
    _inherits(IfcTimeSeriesValue, _IfcLineObject218);

    var _super1734 = _createSuper(IfcTimeSeriesValue);

    function IfcTimeSeriesValue(expressID, ListValues) {
      var _this1726;

      _classCallCheck2(this, IfcTimeSeriesValue);

      _this1726 = _super1734.call(this, expressID);
      _this1726.ListValues = ListValues;
      _this1726.type = 581633288;
      return _this1726;
    }

    return IfcTimeSeriesValue;
  }(IfcLineObject);

  IFC42.IfcTimeSeriesValue = IfcTimeSeriesValue;

  var IfcTopologicalRepresentationItem = /*#__PURE__*/function (_IfcRepresentationIte10) {
    _inherits(IfcTopologicalRepresentationItem, _IfcRepresentationIte10);

    var _super1735 = _createSuper(IfcTopologicalRepresentationItem);

    function IfcTopologicalRepresentationItem(expressID) {
      var _this1727;

      _classCallCheck2(this, IfcTopologicalRepresentationItem);

      _this1727 = _super1735.call(this, expressID);
      _this1727.type = 1377556343;
      return _this1727;
    }

    return IfcTopologicalRepresentationItem;
  }(IfcRepresentationItem);

  IFC42.IfcTopologicalRepresentationItem = IfcTopologicalRepresentationItem;

  var IfcTopologyRepresentation = /*#__PURE__*/function (_IfcShapeModel6) {
    _inherits(IfcTopologyRepresentation, _IfcShapeModel6);

    var _super1736 = _createSuper(IfcTopologyRepresentation);

    function IfcTopologyRepresentation(expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items) {
      var _this1728;

      _classCallCheck2(this, IfcTopologyRepresentation);

      _this1728 = _super1736.call(this, expressID, ContextOfItems, RepresentationIdentifier, RepresentationType, Items);
      _this1728.ContextOfItems = ContextOfItems;
      _this1728.RepresentationIdentifier = RepresentationIdentifier;
      _this1728.RepresentationType = RepresentationType;
      _this1728.Items = Items;
      _this1728.type = 1735638870;
      return _this1728;
    }

    return IfcTopologyRepresentation;
  }(IfcShapeModel);

  IFC42.IfcTopologyRepresentation = IfcTopologyRepresentation;

  var IfcUnitAssignment = /*#__PURE__*/function (_IfcLineObject219) {
    _inherits(IfcUnitAssignment, _IfcLineObject219);

    var _super1737 = _createSuper(IfcUnitAssignment);

    function IfcUnitAssignment(expressID, Units) {
      var _this1729;

      _classCallCheck2(this, IfcUnitAssignment);

      _this1729 = _super1737.call(this, expressID);
      _this1729.Units = Units;
      _this1729.type = 180925521;
      return _this1729;
    }

    return IfcUnitAssignment;
  }(IfcLineObject);

  IFC42.IfcUnitAssignment = IfcUnitAssignment;

  var IfcVertex = /*#__PURE__*/function (_IfcTopologicalRepres15) {
    _inherits(IfcVertex, _IfcTopologicalRepres15);

    var _super1738 = _createSuper(IfcVertex);

    function IfcVertex(expressID) {
      var _this1730;

      _classCallCheck2(this, IfcVertex);

      _this1730 = _super1738.call(this, expressID);
      _this1730.type = 2799835756;
      return _this1730;
    }

    return IfcVertex;
  }(IfcTopologicalRepresentationItem);

  IFC42.IfcVertex = IfcVertex;

  var IfcVertexPoint = /*#__PURE__*/function (_IfcVertex3) {
    _inherits(IfcVertexPoint, _IfcVertex3);

    var _super1739 = _createSuper(IfcVertexPoint);

    function IfcVertexPoint(expressID, VertexGeometry) {
      var _this1731;

      _classCallCheck2(this, IfcVertexPoint);

      _this1731 = _super1739.call(this, expressID);
      _this1731.VertexGeometry = VertexGeometry;
      _this1731.type = 1907098498;
      return _this1731;
    }

    return IfcVertexPoint;
  }(IfcVertex);

  IFC42.IfcVertexPoint = IfcVertexPoint;

  var IfcVirtualGridIntersection = /*#__PURE__*/function (_IfcLineObject220) {
    _inherits(IfcVirtualGridIntersection, _IfcLineObject220);

    var _super1740 = _createSuper(IfcVirtualGridIntersection);

    function IfcVirtualGridIntersection(expressID, IntersectingAxes, OffsetDistances) {
      var _this1732;

      _classCallCheck2(this, IfcVirtualGridIntersection);

      _this1732 = _super1740.call(this, expressID);
      _this1732.IntersectingAxes = IntersectingAxes;
      _this1732.OffsetDistances = OffsetDistances;
      _this1732.type = 891718957;
      return _this1732;
    }

    return IfcVirtualGridIntersection;
  }(IfcLineObject);

  IFC42.IfcVirtualGridIntersection = IfcVirtualGridIntersection;

  var IfcWorkTime = /*#__PURE__*/function (_IfcSchedulingTime7) {
    _inherits(IfcWorkTime, _IfcSchedulingTime7);

    var _super1741 = _createSuper(IfcWorkTime);

    function IfcWorkTime(expressID, Name, DataOrigin, UserDefinedDataOrigin, RecurrencePattern, Start, Finish) {
      var _this1733;

      _classCallCheck2(this, IfcWorkTime);

      _this1733 = _super1741.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin);
      _this1733.Name = Name;
      _this1733.DataOrigin = DataOrigin;
      _this1733.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this1733.RecurrencePattern = RecurrencePattern;
      _this1733.Start = Start;
      _this1733.Finish = Finish;
      _this1733.type = 1236880293;
      return _this1733;
    }

    return IfcWorkTime;
  }(IfcSchedulingTime);

  IFC42.IfcWorkTime = IfcWorkTime;

  var IfcApprovalRelationship = /*#__PURE__*/function (_IfcResourceLevelRela10) {
    _inherits(IfcApprovalRelationship, _IfcResourceLevelRela10);

    var _super1742 = _createSuper(IfcApprovalRelationship);

    function IfcApprovalRelationship(expressID, Name, Description, RelatingApproval, RelatedApprovals) {
      var _this1734;

      _classCallCheck2(this, IfcApprovalRelationship);

      _this1734 = _super1742.call(this, expressID, Name, Description);
      _this1734.Name = Name;
      _this1734.Description = Description;
      _this1734.RelatingApproval = RelatingApproval;
      _this1734.RelatedApprovals = RelatedApprovals;
      _this1734.type = 3869604511;
      return _this1734;
    }

    return IfcApprovalRelationship;
  }(IfcResourceLevelRelationship);

  IFC42.IfcApprovalRelationship = IfcApprovalRelationship;

  var IfcArbitraryClosedProfileDef = /*#__PURE__*/function (_IfcProfileDef12) {
    _inherits(IfcArbitraryClosedProfileDef, _IfcProfileDef12);

    var _super1743 = _createSuper(IfcArbitraryClosedProfileDef);

    function IfcArbitraryClosedProfileDef(expressID, ProfileType, ProfileName, OuterCurve) {
      var _this1735;

      _classCallCheck2(this, IfcArbitraryClosedProfileDef);

      _this1735 = _super1743.call(this, expressID, ProfileType, ProfileName);
      _this1735.ProfileType = ProfileType;
      _this1735.ProfileName = ProfileName;
      _this1735.OuterCurve = OuterCurve;
      _this1735.type = 3798115385;
      return _this1735;
    }

    return IfcArbitraryClosedProfileDef;
  }(IfcProfileDef);

  IFC42.IfcArbitraryClosedProfileDef = IfcArbitraryClosedProfileDef;

  var IfcArbitraryOpenProfileDef = /*#__PURE__*/function (_IfcProfileDef13) {
    _inherits(IfcArbitraryOpenProfileDef, _IfcProfileDef13);

    var _super1744 = _createSuper(IfcArbitraryOpenProfileDef);

    function IfcArbitraryOpenProfileDef(expressID, ProfileType, ProfileName, Curve) {
      var _this1736;

      _classCallCheck2(this, IfcArbitraryOpenProfileDef);

      _this1736 = _super1744.call(this, expressID, ProfileType, ProfileName);
      _this1736.ProfileType = ProfileType;
      _this1736.ProfileName = ProfileName;
      _this1736.Curve = Curve;
      _this1736.type = 1310608509;
      return _this1736;
    }

    return IfcArbitraryOpenProfileDef;
  }(IfcProfileDef);

  IFC42.IfcArbitraryOpenProfileDef = IfcArbitraryOpenProfileDef;

  var IfcArbitraryProfileDefWithVoids = /*#__PURE__*/function (_IfcArbitraryClosedPr3) {
    _inherits(IfcArbitraryProfileDefWithVoids, _IfcArbitraryClosedPr3);

    var _super1745 = _createSuper(IfcArbitraryProfileDefWithVoids);

    function IfcArbitraryProfileDefWithVoids(expressID, ProfileType, ProfileName, OuterCurve, InnerCurves) {
      var _this1737;

      _classCallCheck2(this, IfcArbitraryProfileDefWithVoids);

      _this1737 = _super1745.call(this, expressID, ProfileType, ProfileName, OuterCurve);
      _this1737.ProfileType = ProfileType;
      _this1737.ProfileName = ProfileName;
      _this1737.OuterCurve = OuterCurve;
      _this1737.InnerCurves = InnerCurves;
      _this1737.type = 2705031697;
      return _this1737;
    }

    return IfcArbitraryProfileDefWithVoids;
  }(IfcArbitraryClosedProfileDef);

  IFC42.IfcArbitraryProfileDefWithVoids = IfcArbitraryProfileDefWithVoids;

  var IfcBlobTexture = /*#__PURE__*/function (_IfcSurfaceTexture7) {
    _inherits(IfcBlobTexture, _IfcSurfaceTexture7);

    var _super1746 = _createSuper(IfcBlobTexture);

    function IfcBlobTexture(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, RasterFormat, RasterCode) {
      var _this1738;

      _classCallCheck2(this, IfcBlobTexture);

      _this1738 = _super1746.call(this, expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      _this1738.RepeatS = RepeatS;
      _this1738.RepeatT = RepeatT;
      _this1738.Mode = Mode;
      _this1738.TextureTransform = TextureTransform;
      _this1738.Parameter = Parameter;
      _this1738.RasterFormat = RasterFormat;
      _this1738.RasterCode = RasterCode;
      _this1738.type = 616511568;
      return _this1738;
    }

    return IfcBlobTexture;
  }(IfcSurfaceTexture);

  IFC42.IfcBlobTexture = IfcBlobTexture;

  var IfcCenterLineProfileDef = /*#__PURE__*/function (_IfcArbitraryOpenProf3) {
    _inherits(IfcCenterLineProfileDef, _IfcArbitraryOpenProf3);

    var _super1747 = _createSuper(IfcCenterLineProfileDef);

    function IfcCenterLineProfileDef(expressID, ProfileType, ProfileName, Curve, Thickness) {
      var _this1739;

      _classCallCheck2(this, IfcCenterLineProfileDef);

      _this1739 = _super1747.call(this, expressID, ProfileType, ProfileName, Curve);
      _this1739.ProfileType = ProfileType;
      _this1739.ProfileName = ProfileName;
      _this1739.Curve = Curve;
      _this1739.Thickness = Thickness;
      _this1739.type = 3150382593;
      return _this1739;
    }

    return IfcCenterLineProfileDef;
  }(IfcArbitraryOpenProfileDef);

  IFC42.IfcCenterLineProfileDef = IfcCenterLineProfileDef;

  var IfcClassification = /*#__PURE__*/function (_IfcExternalInformati5) {
    _inherits(IfcClassification, _IfcExternalInformati5);

    var _super1748 = _createSuper(IfcClassification);

    function IfcClassification(expressID, Source, Edition, EditionDate, Name, Description, Location, ReferenceTokens) {
      var _this1740;

      _classCallCheck2(this, IfcClassification);

      _this1740 = _super1748.call(this, expressID);
      _this1740.Source = Source;
      _this1740.Edition = Edition;
      _this1740.EditionDate = EditionDate;
      _this1740.Name = Name;
      _this1740.Description = Description;
      _this1740.Location = Location;
      _this1740.ReferenceTokens = ReferenceTokens;
      _this1740.type = 747523909;
      return _this1740;
    }

    return IfcClassification;
  }(IfcExternalInformation);

  IFC42.IfcClassification = IfcClassification;

  var IfcClassificationReference = /*#__PURE__*/function (_IfcExternalReference18) {
    _inherits(IfcClassificationReference, _IfcExternalReference18);

    var _super1749 = _createSuper(IfcClassificationReference);

    function IfcClassificationReference(expressID, Location, Identification, Name, ReferencedSource, Description, Sort) {
      var _this1741;

      _classCallCheck2(this, IfcClassificationReference);

      _this1741 = _super1749.call(this, expressID, Location, Identification, Name);
      _this1741.Location = Location;
      _this1741.Identification = Identification;
      _this1741.Name = Name;
      _this1741.ReferencedSource = ReferencedSource;
      _this1741.Description = Description;
      _this1741.Sort = Sort;
      _this1741.type = 647927063;
      return _this1741;
    }

    return IfcClassificationReference;
  }(IfcExternalReference);

  IFC42.IfcClassificationReference = IfcClassificationReference;

  var IfcColourRgbList = /*#__PURE__*/function (_IfcPresentationItem28) {
    _inherits(IfcColourRgbList, _IfcPresentationItem28);

    var _super1750 = _createSuper(IfcColourRgbList);

    function IfcColourRgbList(expressID, ColourList) {
      var _this1742;

      _classCallCheck2(this, IfcColourRgbList);

      _this1742 = _super1750.call(this, expressID);
      _this1742.ColourList = ColourList;
      _this1742.type = 3285139300;
      return _this1742;
    }

    return IfcColourRgbList;
  }(IfcPresentationItem);

  IFC42.IfcColourRgbList = IfcColourRgbList;

  var IfcColourSpecification = /*#__PURE__*/function (_IfcPresentationItem29) {
    _inherits(IfcColourSpecification, _IfcPresentationItem29);

    var _super1751 = _createSuper(IfcColourSpecification);

    function IfcColourSpecification(expressID, Name) {
      var _this1743;

      _classCallCheck2(this, IfcColourSpecification);

      _this1743 = _super1751.call(this, expressID);
      _this1743.Name = Name;
      _this1743.type = 3264961684;
      return _this1743;
    }

    return IfcColourSpecification;
  }(IfcPresentationItem);

  IFC42.IfcColourSpecification = IfcColourSpecification;

  var IfcCompositeProfileDef = /*#__PURE__*/function (_IfcProfileDef14) {
    _inherits(IfcCompositeProfileDef, _IfcProfileDef14);

    var _super1752 = _createSuper(IfcCompositeProfileDef);

    function IfcCompositeProfileDef(expressID, ProfileType, ProfileName, Profiles, Label) {
      var _this1744;

      _classCallCheck2(this, IfcCompositeProfileDef);

      _this1744 = _super1752.call(this, expressID, ProfileType, ProfileName);
      _this1744.ProfileType = ProfileType;
      _this1744.ProfileName = ProfileName;
      _this1744.Profiles = Profiles;
      _this1744.Label = Label;
      _this1744.type = 1485152156;
      return _this1744;
    }

    return IfcCompositeProfileDef;
  }(IfcProfileDef);

  IFC42.IfcCompositeProfileDef = IfcCompositeProfileDef;

  var IfcConnectedFaceSet = /*#__PURE__*/function (_IfcTopologicalRepres16) {
    _inherits(IfcConnectedFaceSet, _IfcTopologicalRepres16);

    var _super1753 = _createSuper(IfcConnectedFaceSet);

    function IfcConnectedFaceSet(expressID, CfsFaces) {
      var _this1745;

      _classCallCheck2(this, IfcConnectedFaceSet);

      _this1745 = _super1753.call(this, expressID);
      _this1745.CfsFaces = CfsFaces;
      _this1745.type = 370225590;
      return _this1745;
    }

    return IfcConnectedFaceSet;
  }(IfcTopologicalRepresentationItem);

  IFC42.IfcConnectedFaceSet = IfcConnectedFaceSet;

  var IfcConnectionCurveGeometry = /*#__PURE__*/function (_IfcConnectionGeometr12) {
    _inherits(IfcConnectionCurveGeometry, _IfcConnectionGeometr12);

    var _super1754 = _createSuper(IfcConnectionCurveGeometry);

    function IfcConnectionCurveGeometry(expressID, CurveOnRelatingElement, CurveOnRelatedElement) {
      var _this1746;

      _classCallCheck2(this, IfcConnectionCurveGeometry);

      _this1746 = _super1754.call(this, expressID);
      _this1746.CurveOnRelatingElement = CurveOnRelatingElement;
      _this1746.CurveOnRelatedElement = CurveOnRelatedElement;
      _this1746.type = 1981873012;
      return _this1746;
    }

    return IfcConnectionCurveGeometry;
  }(IfcConnectionGeometry);

  IFC42.IfcConnectionCurveGeometry = IfcConnectionCurveGeometry;

  var IfcConnectionPointEccentricity = /*#__PURE__*/function (_IfcConnectionPointGe3) {
    _inherits(IfcConnectionPointEccentricity, _IfcConnectionPointGe3);

    var _super1755 = _createSuper(IfcConnectionPointEccentricity);

    function IfcConnectionPointEccentricity(expressID, PointOnRelatingElement, PointOnRelatedElement, EccentricityInX, EccentricityInY, EccentricityInZ) {
      var _this1747;

      _classCallCheck2(this, IfcConnectionPointEccentricity);

      _this1747 = _super1755.call(this, expressID, PointOnRelatingElement, PointOnRelatedElement);
      _this1747.PointOnRelatingElement = PointOnRelatingElement;
      _this1747.PointOnRelatedElement = PointOnRelatedElement;
      _this1747.EccentricityInX = EccentricityInX;
      _this1747.EccentricityInY = EccentricityInY;
      _this1747.EccentricityInZ = EccentricityInZ;
      _this1747.type = 45288368;
      return _this1747;
    }

    return IfcConnectionPointEccentricity;
  }(IfcConnectionPointGeometry);

  IFC42.IfcConnectionPointEccentricity = IfcConnectionPointEccentricity;

  var IfcContextDependentUnit = /*#__PURE__*/function (_IfcNamedUnit8) {
    _inherits(IfcContextDependentUnit, _IfcNamedUnit8);

    var _super1756 = _createSuper(IfcContextDependentUnit);

    function IfcContextDependentUnit(expressID, Dimensions, UnitType, Name) {
      var _this1748;

      _classCallCheck2(this, IfcContextDependentUnit);

      _this1748 = _super1756.call(this, expressID, Dimensions, UnitType);
      _this1748.Dimensions = Dimensions;
      _this1748.UnitType = UnitType;
      _this1748.Name = Name;
      _this1748.type = 3050246964;
      return _this1748;
    }

    return IfcContextDependentUnit;
  }(IfcNamedUnit);

  IFC42.IfcContextDependentUnit = IfcContextDependentUnit;

  var IfcConversionBasedUnit = /*#__PURE__*/function (_IfcNamedUnit9) {
    _inherits(IfcConversionBasedUnit, _IfcNamedUnit9);

    var _super1757 = _createSuper(IfcConversionBasedUnit);

    function IfcConversionBasedUnit(expressID, Dimensions, UnitType, Name, ConversionFactor) {
      var _this1749;

      _classCallCheck2(this, IfcConversionBasedUnit);

      _this1749 = _super1757.call(this, expressID, Dimensions, UnitType);
      _this1749.Dimensions = Dimensions;
      _this1749.UnitType = UnitType;
      _this1749.Name = Name;
      _this1749.ConversionFactor = ConversionFactor;
      _this1749.type = 2889183280;
      return _this1749;
    }

    return IfcConversionBasedUnit;
  }(IfcNamedUnit);

  IFC42.IfcConversionBasedUnit = IfcConversionBasedUnit;

  var IfcConversionBasedUnitWithOffset = /*#__PURE__*/function (_IfcConversionBasedUn2) {
    _inherits(IfcConversionBasedUnitWithOffset, _IfcConversionBasedUn2);

    var _super1758 = _createSuper(IfcConversionBasedUnitWithOffset);

    function IfcConversionBasedUnitWithOffset(expressID, Dimensions, UnitType, Name, ConversionFactor, ConversionOffset) {
      var _this1750;

      _classCallCheck2(this, IfcConversionBasedUnitWithOffset);

      _this1750 = _super1758.call(this, expressID, Dimensions, UnitType, Name, ConversionFactor);
      _this1750.Dimensions = Dimensions;
      _this1750.UnitType = UnitType;
      _this1750.Name = Name;
      _this1750.ConversionFactor = ConversionFactor;
      _this1750.ConversionOffset = ConversionOffset;
      _this1750.type = 2713554722;
      return _this1750;
    }

    return IfcConversionBasedUnitWithOffset;
  }(IfcConversionBasedUnit);

  IFC42.IfcConversionBasedUnitWithOffset = IfcConversionBasedUnitWithOffset;

  var IfcCurrencyRelationship = /*#__PURE__*/function (_IfcResourceLevelRela11) {
    _inherits(IfcCurrencyRelationship, _IfcResourceLevelRela11);

    var _super1759 = _createSuper(IfcCurrencyRelationship);

    function IfcCurrencyRelationship(expressID, Name, Description, RelatingMonetaryUnit, RelatedMonetaryUnit, ExchangeRate, RateDateTime, RateSource) {
      var _this1751;

      _classCallCheck2(this, IfcCurrencyRelationship);

      _this1751 = _super1759.call(this, expressID, Name, Description);
      _this1751.Name = Name;
      _this1751.Description = Description;
      _this1751.RelatingMonetaryUnit = RelatingMonetaryUnit;
      _this1751.RelatedMonetaryUnit = RelatedMonetaryUnit;
      _this1751.ExchangeRate = ExchangeRate;
      _this1751.RateDateTime = RateDateTime;
      _this1751.RateSource = RateSource;
      _this1751.type = 539742890;
      return _this1751;
    }

    return IfcCurrencyRelationship;
  }(IfcResourceLevelRelationship);

  IFC42.IfcCurrencyRelationship = IfcCurrencyRelationship;

  var IfcCurveStyle = /*#__PURE__*/function (_IfcPresentationStyle12) {
    _inherits(IfcCurveStyle, _IfcPresentationStyle12);

    var _super1760 = _createSuper(IfcCurveStyle);

    function IfcCurveStyle(expressID, Name, CurveFont, CurveWidth, CurveColour, ModelOrDraughting) {
      var _this1752;

      _classCallCheck2(this, IfcCurveStyle);

      _this1752 = _super1760.call(this, expressID, Name);
      _this1752.Name = Name;
      _this1752.CurveFont = CurveFont;
      _this1752.CurveWidth = CurveWidth;
      _this1752.CurveColour = CurveColour;
      _this1752.ModelOrDraughting = ModelOrDraughting;
      _this1752.type = 3800577675;
      return _this1752;
    }

    return IfcCurveStyle;
  }(IfcPresentationStyle);

  IFC42.IfcCurveStyle = IfcCurveStyle;

  var IfcCurveStyleFont = /*#__PURE__*/function (_IfcPresentationItem30) {
    _inherits(IfcCurveStyleFont, _IfcPresentationItem30);

    var _super1761 = _createSuper(IfcCurveStyleFont);

    function IfcCurveStyleFont(expressID, Name, PatternList) {
      var _this1753;

      _classCallCheck2(this, IfcCurveStyleFont);

      _this1753 = _super1761.call(this, expressID);
      _this1753.Name = Name;
      _this1753.PatternList = PatternList;
      _this1753.type = 1105321065;
      return _this1753;
    }

    return IfcCurveStyleFont;
  }(IfcPresentationItem);

  IFC42.IfcCurveStyleFont = IfcCurveStyleFont;

  var IfcCurveStyleFontAndScaling = /*#__PURE__*/function (_IfcPresentationItem31) {
    _inherits(IfcCurveStyleFontAndScaling, _IfcPresentationItem31);

    var _super1762 = _createSuper(IfcCurveStyleFontAndScaling);

    function IfcCurveStyleFontAndScaling(expressID, Name, CurveFont, CurveFontScaling) {
      var _this1754;

      _classCallCheck2(this, IfcCurveStyleFontAndScaling);

      _this1754 = _super1762.call(this, expressID);
      _this1754.Name = Name;
      _this1754.CurveFont = CurveFont;
      _this1754.CurveFontScaling = CurveFontScaling;
      _this1754.type = 2367409068;
      return _this1754;
    }

    return IfcCurveStyleFontAndScaling;
  }(IfcPresentationItem);

  IFC42.IfcCurveStyleFontAndScaling = IfcCurveStyleFontAndScaling;

  var IfcCurveStyleFontPattern = /*#__PURE__*/function (_IfcPresentationItem32) {
    _inherits(IfcCurveStyleFontPattern, _IfcPresentationItem32);

    var _super1763 = _createSuper(IfcCurveStyleFontPattern);

    function IfcCurveStyleFontPattern(expressID, VisibleSegmentLength, InvisibleSegmentLength) {
      var _this1755;

      _classCallCheck2(this, IfcCurveStyleFontPattern);

      _this1755 = _super1763.call(this, expressID);
      _this1755.VisibleSegmentLength = VisibleSegmentLength;
      _this1755.InvisibleSegmentLength = InvisibleSegmentLength;
      _this1755.type = 3510044353;
      return _this1755;
    }

    return IfcCurveStyleFontPattern;
  }(IfcPresentationItem);

  IFC42.IfcCurveStyleFontPattern = IfcCurveStyleFontPattern;

  var IfcDerivedProfileDef = /*#__PURE__*/function (_IfcProfileDef15) {
    _inherits(IfcDerivedProfileDef, _IfcProfileDef15);

    var _super1764 = _createSuper(IfcDerivedProfileDef);

    function IfcDerivedProfileDef(expressID, ProfileType, ProfileName, ParentProfile, Operator, Label) {
      var _this1756;

      _classCallCheck2(this, IfcDerivedProfileDef);

      _this1756 = _super1764.call(this, expressID, ProfileType, ProfileName);
      _this1756.ProfileType = ProfileType;
      _this1756.ProfileName = ProfileName;
      _this1756.ParentProfile = ParentProfile;
      _this1756.Operator = Operator;
      _this1756.Label = Label;
      _this1756.type = 3632507154;
      return _this1756;
    }

    return IfcDerivedProfileDef;
  }(IfcProfileDef);

  IFC42.IfcDerivedProfileDef = IfcDerivedProfileDef;

  var IfcDocumentInformation = /*#__PURE__*/function (_IfcExternalInformati6) {
    _inherits(IfcDocumentInformation, _IfcExternalInformati6);

    var _super1765 = _createSuper(IfcDocumentInformation);

    function IfcDocumentInformation(expressID, Identification, Name, Description, Location, Purpose, IntendedUse, Scope, Revision, DocumentOwner, Editors, CreationTime, LastRevisionTime, ElectronicFormat, ValidFrom, ValidUntil, Confidentiality, Status) {
      var _this1757;

      _classCallCheck2(this, IfcDocumentInformation);

      _this1757 = _super1765.call(this, expressID);
      _this1757.Identification = Identification;
      _this1757.Name = Name;
      _this1757.Description = Description;
      _this1757.Location = Location;
      _this1757.Purpose = Purpose;
      _this1757.IntendedUse = IntendedUse;
      _this1757.Scope = Scope;
      _this1757.Revision = Revision;
      _this1757.DocumentOwner = DocumentOwner;
      _this1757.Editors = Editors;
      _this1757.CreationTime = CreationTime;
      _this1757.LastRevisionTime = LastRevisionTime;
      _this1757.ElectronicFormat = ElectronicFormat;
      _this1757.ValidFrom = ValidFrom;
      _this1757.ValidUntil = ValidUntil;
      _this1757.Confidentiality = Confidentiality;
      _this1757.Status = Status;
      _this1757.type = 1154170062;
      return _this1757;
    }

    return IfcDocumentInformation;
  }(IfcExternalInformation);

  IFC42.IfcDocumentInformation = IfcDocumentInformation;

  var IfcDocumentInformationRelationship = /*#__PURE__*/function (_IfcResourceLevelRela12) {
    _inherits(IfcDocumentInformationRelationship, _IfcResourceLevelRela12);

    var _super1766 = _createSuper(IfcDocumentInformationRelationship);

    function IfcDocumentInformationRelationship(expressID, Name, Description, RelatingDocument, RelatedDocuments, RelationshipType) {
      var _this1758;

      _classCallCheck2(this, IfcDocumentInformationRelationship);

      _this1758 = _super1766.call(this, expressID, Name, Description);
      _this1758.Name = Name;
      _this1758.Description = Description;
      _this1758.RelatingDocument = RelatingDocument;
      _this1758.RelatedDocuments = RelatedDocuments;
      _this1758.RelationshipType = RelationshipType;
      _this1758.type = 770865208;
      return _this1758;
    }

    return IfcDocumentInformationRelationship;
  }(IfcResourceLevelRelationship);

  IFC42.IfcDocumentInformationRelationship = IfcDocumentInformationRelationship;

  var IfcDocumentReference = /*#__PURE__*/function (_IfcExternalReference19) {
    _inherits(IfcDocumentReference, _IfcExternalReference19);

    var _super1767 = _createSuper(IfcDocumentReference);

    function IfcDocumentReference(expressID, Location, Identification, Name, Description, ReferencedDocument) {
      var _this1759;

      _classCallCheck2(this, IfcDocumentReference);

      _this1759 = _super1767.call(this, expressID, Location, Identification, Name);
      _this1759.Location = Location;
      _this1759.Identification = Identification;
      _this1759.Name = Name;
      _this1759.Description = Description;
      _this1759.ReferencedDocument = ReferencedDocument;
      _this1759.type = 3732053477;
      return _this1759;
    }

    return IfcDocumentReference;
  }(IfcExternalReference);

  IFC42.IfcDocumentReference = IfcDocumentReference;

  var IfcEdge = /*#__PURE__*/function (_IfcTopologicalRepres17) {
    _inherits(IfcEdge, _IfcTopologicalRepres17);

    var _super1768 = _createSuper(IfcEdge);

    function IfcEdge(expressID, EdgeStart, EdgeEnd) {
      var _this1760;

      _classCallCheck2(this, IfcEdge);

      _this1760 = _super1768.call(this, expressID);
      _this1760.EdgeStart = EdgeStart;
      _this1760.EdgeEnd = EdgeEnd;
      _this1760.type = 3900360178;
      return _this1760;
    }

    return IfcEdge;
  }(IfcTopologicalRepresentationItem);

  IFC42.IfcEdge = IfcEdge;

  var IfcEdgeCurve = /*#__PURE__*/function (_IfcEdge7) {
    _inherits(IfcEdgeCurve, _IfcEdge7);

    var _super1769 = _createSuper(IfcEdgeCurve);

    function IfcEdgeCurve(expressID, EdgeStart, EdgeEnd, EdgeGeometry, SameSense) {
      var _this1761;

      _classCallCheck2(this, IfcEdgeCurve);

      _this1761 = _super1769.call(this, expressID, EdgeStart, EdgeEnd);
      _this1761.EdgeStart = EdgeStart;
      _this1761.EdgeEnd = EdgeEnd;
      _this1761.EdgeGeometry = EdgeGeometry;
      _this1761.SameSense = SameSense;
      _this1761.type = 476780140;
      return _this1761;
    }

    return IfcEdgeCurve;
  }(IfcEdge);

  IFC42.IfcEdgeCurve = IfcEdgeCurve;

  var IfcEventTime = /*#__PURE__*/function (_IfcSchedulingTime8) {
    _inherits(IfcEventTime, _IfcSchedulingTime8);

    var _super1770 = _createSuper(IfcEventTime);

    function IfcEventTime(expressID, Name, DataOrigin, UserDefinedDataOrigin, ActualDate, EarlyDate, LateDate, ScheduleDate) {
      var _this1762;

      _classCallCheck2(this, IfcEventTime);

      _this1762 = _super1770.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin);
      _this1762.Name = Name;
      _this1762.DataOrigin = DataOrigin;
      _this1762.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this1762.ActualDate = ActualDate;
      _this1762.EarlyDate = EarlyDate;
      _this1762.LateDate = LateDate;
      _this1762.ScheduleDate = ScheduleDate;
      _this1762.type = 211053100;
      return _this1762;
    }

    return IfcEventTime;
  }(IfcSchedulingTime);

  IFC42.IfcEventTime = IfcEventTime;

  var IfcExtendedProperties = /*#__PURE__*/function (_IfcPropertyAbstracti6) {
    _inherits(IfcExtendedProperties, _IfcPropertyAbstracti6);

    var _super1771 = _createSuper(IfcExtendedProperties);

    function IfcExtendedProperties(expressID, Name, Description, Properties2) {
      var _this1763;

      _classCallCheck2(this, IfcExtendedProperties);

      _this1763 = _super1771.call(this, expressID);
      _this1763.Name = Name;
      _this1763.Description = Description;
      _this1763.Properties = Properties2;
      _this1763.type = 297599258;
      return _this1763;
    }

    return IfcExtendedProperties;
  }(IfcPropertyAbstraction);

  IFC42.IfcExtendedProperties = IfcExtendedProperties;

  var IfcExternalReferenceRelationship = /*#__PURE__*/function (_IfcResourceLevelRela13) {
    _inherits(IfcExternalReferenceRelationship, _IfcResourceLevelRela13);

    var _super1772 = _createSuper(IfcExternalReferenceRelationship);

    function IfcExternalReferenceRelationship(expressID, Name, Description, RelatingReference, RelatedResourceObjects) {
      var _this1764;

      _classCallCheck2(this, IfcExternalReferenceRelationship);

      _this1764 = _super1772.call(this, expressID, Name, Description);
      _this1764.Name = Name;
      _this1764.Description = Description;
      _this1764.RelatingReference = RelatingReference;
      _this1764.RelatedResourceObjects = RelatedResourceObjects;
      _this1764.type = 1437805879;
      return _this1764;
    }

    return IfcExternalReferenceRelationship;
  }(IfcResourceLevelRelationship);

  IFC42.IfcExternalReferenceRelationship = IfcExternalReferenceRelationship;

  var IfcFace = /*#__PURE__*/function (_IfcTopologicalRepres18) {
    _inherits(IfcFace, _IfcTopologicalRepres18);

    var _super1773 = _createSuper(IfcFace);

    function IfcFace(expressID, Bounds) {
      var _this1765;

      _classCallCheck2(this, IfcFace);

      _this1765 = _super1773.call(this, expressID);
      _this1765.Bounds = Bounds;
      _this1765.type = 2556980723;
      return _this1765;
    }

    return IfcFace;
  }(IfcTopologicalRepresentationItem);

  IFC42.IfcFace = IfcFace;

  var IfcFaceBound = /*#__PURE__*/function (_IfcTopologicalRepres19) {
    _inherits(IfcFaceBound, _IfcTopologicalRepres19);

    var _super1774 = _createSuper(IfcFaceBound);

    function IfcFaceBound(expressID, Bound, Orientation) {
      var _this1766;

      _classCallCheck2(this, IfcFaceBound);

      _this1766 = _super1774.call(this, expressID);
      _this1766.Bound = Bound;
      _this1766.Orientation = Orientation;
      _this1766.type = 1809719519;
      return _this1766;
    }

    return IfcFaceBound;
  }(IfcTopologicalRepresentationItem);

  IFC42.IfcFaceBound = IfcFaceBound;

  var IfcFaceOuterBound = /*#__PURE__*/function (_IfcFaceBound3) {
    _inherits(IfcFaceOuterBound, _IfcFaceBound3);

    var _super1775 = _createSuper(IfcFaceOuterBound);

    function IfcFaceOuterBound(expressID, Bound, Orientation) {
      var _this1767;

      _classCallCheck2(this, IfcFaceOuterBound);

      _this1767 = _super1775.call(this, expressID, Bound, Orientation);
      _this1767.Bound = Bound;
      _this1767.Orientation = Orientation;
      _this1767.type = 803316827;
      return _this1767;
    }

    return IfcFaceOuterBound;
  }(IfcFaceBound);

  IFC42.IfcFaceOuterBound = IfcFaceOuterBound;

  var IfcFaceSurface = /*#__PURE__*/function (_IfcFace3) {
    _inherits(IfcFaceSurface, _IfcFace3);

    var _super1776 = _createSuper(IfcFaceSurface);

    function IfcFaceSurface(expressID, Bounds, FaceSurface, SameSense) {
      var _this1768;

      _classCallCheck2(this, IfcFaceSurface);

      _this1768 = _super1776.call(this, expressID, Bounds);
      _this1768.Bounds = Bounds;
      _this1768.FaceSurface = FaceSurface;
      _this1768.SameSense = SameSense;
      _this1768.type = 3008276851;
      return _this1768;
    }

    return IfcFaceSurface;
  }(IfcFace);

  IFC42.IfcFaceSurface = IfcFaceSurface;

  var IfcFailureConnectionCondition = /*#__PURE__*/function (_IfcStructuralConnect11) {
    _inherits(IfcFailureConnectionCondition, _IfcStructuralConnect11);

    var _super1777 = _createSuper(IfcFailureConnectionCondition);

    function IfcFailureConnectionCondition(expressID, Name, TensionFailureX, TensionFailureY, TensionFailureZ, CompressionFailureX, CompressionFailureY, CompressionFailureZ) {
      var _this1769;

      _classCallCheck2(this, IfcFailureConnectionCondition);

      _this1769 = _super1777.call(this, expressID, Name);
      _this1769.Name = Name;
      _this1769.TensionFailureX = TensionFailureX;
      _this1769.TensionFailureY = TensionFailureY;
      _this1769.TensionFailureZ = TensionFailureZ;
      _this1769.CompressionFailureX = CompressionFailureX;
      _this1769.CompressionFailureY = CompressionFailureY;
      _this1769.CompressionFailureZ = CompressionFailureZ;
      _this1769.type = 4219587988;
      return _this1769;
    }

    return IfcFailureConnectionCondition;
  }(IfcStructuralConnectionCondition);

  IFC42.IfcFailureConnectionCondition = IfcFailureConnectionCondition;

  var IfcFillAreaStyle = /*#__PURE__*/function (_IfcPresentationStyle13) {
    _inherits(IfcFillAreaStyle, _IfcPresentationStyle13);

    var _super1778 = _createSuper(IfcFillAreaStyle);

    function IfcFillAreaStyle(expressID, Name, FillStyles, ModelorDraughting) {
      var _this1770;

      _classCallCheck2(this, IfcFillAreaStyle);

      _this1770 = _super1778.call(this, expressID, Name);
      _this1770.Name = Name;
      _this1770.FillStyles = FillStyles;
      _this1770.ModelorDraughting = ModelorDraughting;
      _this1770.type = 738692330;
      return _this1770;
    }

    return IfcFillAreaStyle;
  }(IfcPresentationStyle);

  IFC42.IfcFillAreaStyle = IfcFillAreaStyle;

  var IfcGeometricRepresentationContext = /*#__PURE__*/function (_IfcRepresentationCon3) {
    _inherits(IfcGeometricRepresentationContext, _IfcRepresentationCon3);

    var _super1779 = _createSuper(IfcGeometricRepresentationContext);

    function IfcGeometricRepresentationContext(expressID, ContextIdentifier, ContextType, CoordinateSpaceDimension, Precision, WorldCoordinateSystem, TrueNorth) {
      var _this1771;

      _classCallCheck2(this, IfcGeometricRepresentationContext);

      _this1771 = _super1779.call(this, expressID, ContextIdentifier, ContextType);
      _this1771.ContextIdentifier = ContextIdentifier;
      _this1771.ContextType = ContextType;
      _this1771.CoordinateSpaceDimension = CoordinateSpaceDimension;
      _this1771.Precision = Precision;
      _this1771.WorldCoordinateSystem = WorldCoordinateSystem;
      _this1771.TrueNorth = TrueNorth;
      _this1771.type = 3448662350;
      return _this1771;
    }

    return IfcGeometricRepresentationContext;
  }(IfcRepresentationContext);

  IFC42.IfcGeometricRepresentationContext = IfcGeometricRepresentationContext;

  var IfcGeometricRepresentationItem = /*#__PURE__*/function (_IfcRepresentationIte11) {
    _inherits(IfcGeometricRepresentationItem, _IfcRepresentationIte11);

    var _super1780 = _createSuper(IfcGeometricRepresentationItem);

    function IfcGeometricRepresentationItem(expressID) {
      var _this1772;

      _classCallCheck2(this, IfcGeometricRepresentationItem);

      _this1772 = _super1780.call(this, expressID);
      _this1772.type = 2453401579;
      return _this1772;
    }

    return IfcGeometricRepresentationItem;
  }(IfcRepresentationItem);

  IFC42.IfcGeometricRepresentationItem = IfcGeometricRepresentationItem;

  var IfcGeometricRepresentationSubContext = /*#__PURE__*/function (_IfcGeometricRepresen56) {
    _inherits(IfcGeometricRepresentationSubContext, _IfcGeometricRepresen56);

    var _super1781 = _createSuper(IfcGeometricRepresentationSubContext);

    function IfcGeometricRepresentationSubContext(expressID, ContextIdentifier, ContextType, ParentContext, TargetScale, TargetView, UserDefinedTargetView) {
      var _this1773;

      _classCallCheck2(this, IfcGeometricRepresentationSubContext);

      _this1773 = _super1781.call(this, expressID, ContextIdentifier, ContextType, new IfcDimensionCount(0), null, new Handle(0), null);
      _this1773.ContextIdentifier = ContextIdentifier;
      _this1773.ContextType = ContextType;
      _this1773.ParentContext = ParentContext;
      _this1773.TargetScale = TargetScale;
      _this1773.TargetView = TargetView;
      _this1773.UserDefinedTargetView = UserDefinedTargetView;
      _this1773.type = 4142052618;
      return _this1773;
    }

    return IfcGeometricRepresentationSubContext;
  }(IfcGeometricRepresentationContext);

  IFC42.IfcGeometricRepresentationSubContext = IfcGeometricRepresentationSubContext;

  var IfcGeometricSet = /*#__PURE__*/function (_IfcGeometricRepresen57) {
    _inherits(IfcGeometricSet, _IfcGeometricRepresen57);

    var _super1782 = _createSuper(IfcGeometricSet);

    function IfcGeometricSet(expressID, Elements) {
      var _this1774;

      _classCallCheck2(this, IfcGeometricSet);

      _this1774 = _super1782.call(this, expressID);
      _this1774.Elements = Elements;
      _this1774.type = 3590301190;
      return _this1774;
    }

    return IfcGeometricSet;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcGeometricSet = IfcGeometricSet;

  var IfcGridPlacement = /*#__PURE__*/function (_IfcObjectPlacement6) {
    _inherits(IfcGridPlacement, _IfcObjectPlacement6);

    var _super1783 = _createSuper(IfcGridPlacement);

    function IfcGridPlacement(expressID, PlacementLocation, PlacementRefDirection) {
      var _this1775;

      _classCallCheck2(this, IfcGridPlacement);

      _this1775 = _super1783.call(this, expressID);
      _this1775.PlacementLocation = PlacementLocation;
      _this1775.PlacementRefDirection = PlacementRefDirection;
      _this1775.type = 178086475;
      return _this1775;
    }

    return IfcGridPlacement;
  }(IfcObjectPlacement);

  IFC42.IfcGridPlacement = IfcGridPlacement;

  var IfcHalfSpaceSolid = /*#__PURE__*/function (_IfcGeometricRepresen58) {
    _inherits(IfcHalfSpaceSolid, _IfcGeometricRepresen58);

    var _super1784 = _createSuper(IfcHalfSpaceSolid);

    function IfcHalfSpaceSolid(expressID, BaseSurface, AgreementFlag) {
      var _this1776;

      _classCallCheck2(this, IfcHalfSpaceSolid);

      _this1776 = _super1784.call(this, expressID);
      _this1776.BaseSurface = BaseSurface;
      _this1776.AgreementFlag = AgreementFlag;
      _this1776.type = 812098782;
      return _this1776;
    }

    return IfcHalfSpaceSolid;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcHalfSpaceSolid = IfcHalfSpaceSolid;

  var IfcImageTexture = /*#__PURE__*/function (_IfcSurfaceTexture8) {
    _inherits(IfcImageTexture, _IfcSurfaceTexture8);

    var _super1785 = _createSuper(IfcImageTexture);

    function IfcImageTexture(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, URLReference) {
      var _this1777;

      _classCallCheck2(this, IfcImageTexture);

      _this1777 = _super1785.call(this, expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      _this1777.RepeatS = RepeatS;
      _this1777.RepeatT = RepeatT;
      _this1777.Mode = Mode;
      _this1777.TextureTransform = TextureTransform;
      _this1777.Parameter = Parameter;
      _this1777.URLReference = URLReference;
      _this1777.type = 3905492369;
      return _this1777;
    }

    return IfcImageTexture;
  }(IfcSurfaceTexture);

  IFC42.IfcImageTexture = IfcImageTexture;

  var IfcIndexedColourMap = /*#__PURE__*/function (_IfcPresentationItem33) {
    _inherits(IfcIndexedColourMap, _IfcPresentationItem33);

    var _super1786 = _createSuper(IfcIndexedColourMap);

    function IfcIndexedColourMap(expressID, MappedTo, Opacity, Colours, ColourIndex) {
      var _this1778;

      _classCallCheck2(this, IfcIndexedColourMap);

      _this1778 = _super1786.call(this, expressID);
      _this1778.MappedTo = MappedTo;
      _this1778.Opacity = Opacity;
      _this1778.Colours = Colours;
      _this1778.ColourIndex = ColourIndex;
      _this1778.type = 3570813810;
      return _this1778;
    }

    return IfcIndexedColourMap;
  }(IfcPresentationItem);

  IFC42.IfcIndexedColourMap = IfcIndexedColourMap;

  var IfcIndexedTextureMap = /*#__PURE__*/function (_IfcTextureCoordinate9) {
    _inherits(IfcIndexedTextureMap, _IfcTextureCoordinate9);

    var _super1787 = _createSuper(IfcIndexedTextureMap);

    function IfcIndexedTextureMap(expressID, Maps, MappedTo, TexCoords) {
      var _this1779;

      _classCallCheck2(this, IfcIndexedTextureMap);

      _this1779 = _super1787.call(this, expressID, Maps);
      _this1779.Maps = Maps;
      _this1779.MappedTo = MappedTo;
      _this1779.TexCoords = TexCoords;
      _this1779.type = 1437953363;
      return _this1779;
    }

    return IfcIndexedTextureMap;
  }(IfcTextureCoordinate);

  IFC42.IfcIndexedTextureMap = IfcIndexedTextureMap;

  var IfcIndexedTriangleTextureMap = /*#__PURE__*/function (_IfcIndexedTextureMap3) {
    _inherits(IfcIndexedTriangleTextureMap, _IfcIndexedTextureMap3);

    var _super1788 = _createSuper(IfcIndexedTriangleTextureMap);

    function IfcIndexedTriangleTextureMap(expressID, Maps, MappedTo, TexCoords, TexCoordIndex) {
      var _this1780;

      _classCallCheck2(this, IfcIndexedTriangleTextureMap);

      _this1780 = _super1788.call(this, expressID, Maps, MappedTo, TexCoords);
      _this1780.Maps = Maps;
      _this1780.MappedTo = MappedTo;
      _this1780.TexCoords = TexCoords;
      _this1780.TexCoordIndex = TexCoordIndex;
      _this1780.type = 2133299955;
      return _this1780;
    }

    return IfcIndexedTriangleTextureMap;
  }(IfcIndexedTextureMap);

  IFC42.IfcIndexedTriangleTextureMap = IfcIndexedTriangleTextureMap;

  var IfcIrregularTimeSeries = /*#__PURE__*/function (_IfcTimeSeries5) {
    _inherits(IfcIrregularTimeSeries, _IfcTimeSeries5);

    var _super1789 = _createSuper(IfcIrregularTimeSeries);

    function IfcIrregularTimeSeries(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, Values) {
      var _this1781;

      _classCallCheck2(this, IfcIrregularTimeSeries);

      _this1781 = _super1789.call(this, expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      _this1781.Name = Name;
      _this1781.Description = Description;
      _this1781.StartTime = StartTime;
      _this1781.EndTime = EndTime;
      _this1781.TimeSeriesDataType = TimeSeriesDataType;
      _this1781.DataOrigin = DataOrigin;
      _this1781.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this1781.Unit = Unit;
      _this1781.Values = Values;
      _this1781.type = 3741457305;
      return _this1781;
    }

    return IfcIrregularTimeSeries;
  }(IfcTimeSeries);

  IFC42.IfcIrregularTimeSeries = IfcIrregularTimeSeries;

  var IfcLagTime = /*#__PURE__*/function (_IfcSchedulingTime9) {
    _inherits(IfcLagTime, _IfcSchedulingTime9);

    var _super1790 = _createSuper(IfcLagTime);

    function IfcLagTime(expressID, Name, DataOrigin, UserDefinedDataOrigin, LagValue, DurationType) {
      var _this1782;

      _classCallCheck2(this, IfcLagTime);

      _this1782 = _super1790.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin);
      _this1782.Name = Name;
      _this1782.DataOrigin = DataOrigin;
      _this1782.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this1782.LagValue = LagValue;
      _this1782.DurationType = DurationType;
      _this1782.type = 1585845231;
      return _this1782;
    }

    return IfcLagTime;
  }(IfcSchedulingTime);

  IFC42.IfcLagTime = IfcLagTime;

  var IfcLightSource = /*#__PURE__*/function (_IfcGeometricRepresen59) {
    _inherits(IfcLightSource, _IfcGeometricRepresen59);

    var _super1791 = _createSuper(IfcLightSource);

    function IfcLightSource(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      var _this1783;

      _classCallCheck2(this, IfcLightSource);

      _this1783 = _super1791.call(this, expressID);
      _this1783.Name = Name;
      _this1783.LightColour = LightColour;
      _this1783.AmbientIntensity = AmbientIntensity;
      _this1783.Intensity = Intensity;
      _this1783.type = 1402838566;
      return _this1783;
    }

    return IfcLightSource;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcLightSource = IfcLightSource;

  var IfcLightSourceAmbient = /*#__PURE__*/function (_IfcLightSource9) {
    _inherits(IfcLightSourceAmbient, _IfcLightSource9);

    var _super1792 = _createSuper(IfcLightSourceAmbient);

    function IfcLightSourceAmbient(expressID, Name, LightColour, AmbientIntensity, Intensity) {
      var _this1784;

      _classCallCheck2(this, IfcLightSourceAmbient);

      _this1784 = _super1792.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this1784.Name = Name;
      _this1784.LightColour = LightColour;
      _this1784.AmbientIntensity = AmbientIntensity;
      _this1784.Intensity = Intensity;
      _this1784.type = 125510826;
      return _this1784;
    }

    return IfcLightSourceAmbient;
  }(IfcLightSource);

  IFC42.IfcLightSourceAmbient = IfcLightSourceAmbient;

  var IfcLightSourceDirectional = /*#__PURE__*/function (_IfcLightSource10) {
    _inherits(IfcLightSourceDirectional, _IfcLightSource10);

    var _super1793 = _createSuper(IfcLightSourceDirectional);

    function IfcLightSourceDirectional(expressID, Name, LightColour, AmbientIntensity, Intensity, Orientation) {
      var _this1785;

      _classCallCheck2(this, IfcLightSourceDirectional);

      _this1785 = _super1793.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this1785.Name = Name;
      _this1785.LightColour = LightColour;
      _this1785.AmbientIntensity = AmbientIntensity;
      _this1785.Intensity = Intensity;
      _this1785.Orientation = Orientation;
      _this1785.type = 2604431987;
      return _this1785;
    }

    return IfcLightSourceDirectional;
  }(IfcLightSource);

  IFC42.IfcLightSourceDirectional = IfcLightSourceDirectional;

  var IfcLightSourceGoniometric = /*#__PURE__*/function (_IfcLightSource11) {
    _inherits(IfcLightSourceGoniometric, _IfcLightSource11);

    var _super1794 = _createSuper(IfcLightSourceGoniometric);

    function IfcLightSourceGoniometric(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, ColourAppearance, ColourTemperature, LuminousFlux, LightEmissionSource, LightDistributionDataSource) {
      var _this1786;

      _classCallCheck2(this, IfcLightSourceGoniometric);

      _this1786 = _super1794.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this1786.Name = Name;
      _this1786.LightColour = LightColour;
      _this1786.AmbientIntensity = AmbientIntensity;
      _this1786.Intensity = Intensity;
      _this1786.Position = Position;
      _this1786.ColourAppearance = ColourAppearance;
      _this1786.ColourTemperature = ColourTemperature;
      _this1786.LuminousFlux = LuminousFlux;
      _this1786.LightEmissionSource = LightEmissionSource;
      _this1786.LightDistributionDataSource = LightDistributionDataSource;
      _this1786.type = 4266656042;
      return _this1786;
    }

    return IfcLightSourceGoniometric;
  }(IfcLightSource);

  IFC42.IfcLightSourceGoniometric = IfcLightSourceGoniometric;

  var IfcLightSourcePositional = /*#__PURE__*/function (_IfcLightSource12) {
    _inherits(IfcLightSourcePositional, _IfcLightSource12);

    var _super1795 = _createSuper(IfcLightSourcePositional);

    function IfcLightSourcePositional(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation) {
      var _this1787;

      _classCallCheck2(this, IfcLightSourcePositional);

      _this1787 = _super1795.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity);
      _this1787.Name = Name;
      _this1787.LightColour = LightColour;
      _this1787.AmbientIntensity = AmbientIntensity;
      _this1787.Intensity = Intensity;
      _this1787.Position = Position;
      _this1787.Radius = Radius;
      _this1787.ConstantAttenuation = ConstantAttenuation;
      _this1787.DistanceAttenuation = DistanceAttenuation;
      _this1787.QuadricAttenuation = QuadricAttenuation;
      _this1787.type = 1520743889;
      return _this1787;
    }

    return IfcLightSourcePositional;
  }(IfcLightSource);

  IFC42.IfcLightSourcePositional = IfcLightSourcePositional;

  var IfcLightSourceSpot = /*#__PURE__*/function (_IfcLightSourcePositi3) {
    _inherits(IfcLightSourceSpot, _IfcLightSourcePositi3);

    var _super1796 = _createSuper(IfcLightSourceSpot);

    function IfcLightSourceSpot(expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation, Orientation, ConcentrationExponent, SpreadAngle, BeamWidthAngle) {
      var _this1788;

      _classCallCheck2(this, IfcLightSourceSpot);

      _this1788 = _super1796.call(this, expressID, Name, LightColour, AmbientIntensity, Intensity, Position, Radius, ConstantAttenuation, DistanceAttenuation, QuadricAttenuation);
      _this1788.Name = Name;
      _this1788.LightColour = LightColour;
      _this1788.AmbientIntensity = AmbientIntensity;
      _this1788.Intensity = Intensity;
      _this1788.Position = Position;
      _this1788.Radius = Radius;
      _this1788.ConstantAttenuation = ConstantAttenuation;
      _this1788.DistanceAttenuation = DistanceAttenuation;
      _this1788.QuadricAttenuation = QuadricAttenuation;
      _this1788.Orientation = Orientation;
      _this1788.ConcentrationExponent = ConcentrationExponent;
      _this1788.SpreadAngle = SpreadAngle;
      _this1788.BeamWidthAngle = BeamWidthAngle;
      _this1788.type = 3422422726;
      return _this1788;
    }

    return IfcLightSourceSpot;
  }(IfcLightSourcePositional);

  IFC42.IfcLightSourceSpot = IfcLightSourceSpot;

  var IfcLocalPlacement = /*#__PURE__*/function (_IfcObjectPlacement7) {
    _inherits(IfcLocalPlacement, _IfcObjectPlacement7);

    var _super1797 = _createSuper(IfcLocalPlacement);

    function IfcLocalPlacement(expressID, PlacementRelTo, RelativePlacement) {
      var _this1789;

      _classCallCheck2(this, IfcLocalPlacement);

      _this1789 = _super1797.call(this, expressID);
      _this1789.PlacementRelTo = PlacementRelTo;
      _this1789.RelativePlacement = RelativePlacement;
      _this1789.type = 2624227202;
      return _this1789;
    }

    return IfcLocalPlacement;
  }(IfcObjectPlacement);

  IFC42.IfcLocalPlacement = IfcLocalPlacement;

  var IfcLoop = /*#__PURE__*/function (_IfcTopologicalRepres20) {
    _inherits(IfcLoop, _IfcTopologicalRepres20);

    var _super1798 = _createSuper(IfcLoop);

    function IfcLoop(expressID) {
      var _this1790;

      _classCallCheck2(this, IfcLoop);

      _this1790 = _super1798.call(this, expressID);
      _this1790.type = 1008929658;
      return _this1790;
    }

    return IfcLoop;
  }(IfcTopologicalRepresentationItem);

  IFC42.IfcLoop = IfcLoop;

  var IfcMappedItem = /*#__PURE__*/function (_IfcRepresentationIte12) {
    _inherits(IfcMappedItem, _IfcRepresentationIte12);

    var _super1799 = _createSuper(IfcMappedItem);

    function IfcMappedItem(expressID, MappingSource, MappingTarget) {
      var _this1791;

      _classCallCheck2(this, IfcMappedItem);

      _this1791 = _super1799.call(this, expressID);
      _this1791.MappingSource = MappingSource;
      _this1791.MappingTarget = MappingTarget;
      _this1791.type = 2347385850;
      return _this1791;
    }

    return IfcMappedItem;
  }(IfcRepresentationItem);

  IFC42.IfcMappedItem = IfcMappedItem;

  var IfcMaterial = /*#__PURE__*/function (_IfcMaterialDefinitio12) {
    _inherits(IfcMaterial, _IfcMaterialDefinitio12);

    var _super1800 = _createSuper(IfcMaterial);

    function IfcMaterial(expressID, Name, Description, Category) {
      var _this1792;

      _classCallCheck2(this, IfcMaterial);

      _this1792 = _super1800.call(this, expressID);
      _this1792.Name = Name;
      _this1792.Description = Description;
      _this1792.Category = Category;
      _this1792.type = 1838606355;
      return _this1792;
    }

    return IfcMaterial;
  }(IfcMaterialDefinition);

  IFC42.IfcMaterial = IfcMaterial;

  var IfcMaterialConstituent = /*#__PURE__*/function (_IfcMaterialDefinitio13) {
    _inherits(IfcMaterialConstituent, _IfcMaterialDefinitio13);

    var _super1801 = _createSuper(IfcMaterialConstituent);

    function IfcMaterialConstituent(expressID, Name, Description, Material, Fraction, Category) {
      var _this1793;

      _classCallCheck2(this, IfcMaterialConstituent);

      _this1793 = _super1801.call(this, expressID);
      _this1793.Name = Name;
      _this1793.Description = Description;
      _this1793.Material = Material;
      _this1793.Fraction = Fraction;
      _this1793.Category = Category;
      _this1793.type = 3708119e3;
      return _this1793;
    }

    return IfcMaterialConstituent;
  }(IfcMaterialDefinition);

  IFC42.IfcMaterialConstituent = IfcMaterialConstituent;

  var IfcMaterialConstituentSet = /*#__PURE__*/function (_IfcMaterialDefinitio14) {
    _inherits(IfcMaterialConstituentSet, _IfcMaterialDefinitio14);

    var _super1802 = _createSuper(IfcMaterialConstituentSet);

    function IfcMaterialConstituentSet(expressID, Name, Description, MaterialConstituents) {
      var _this1794;

      _classCallCheck2(this, IfcMaterialConstituentSet);

      _this1794 = _super1802.call(this, expressID);
      _this1794.Name = Name;
      _this1794.Description = Description;
      _this1794.MaterialConstituents = MaterialConstituents;
      _this1794.type = 2852063980;
      return _this1794;
    }

    return IfcMaterialConstituentSet;
  }(IfcMaterialDefinition);

  IFC42.IfcMaterialConstituentSet = IfcMaterialConstituentSet;

  var IfcMaterialDefinitionRepresentation = /*#__PURE__*/function (_IfcProductRepresenta5) {
    _inherits(IfcMaterialDefinitionRepresentation, _IfcProductRepresenta5);

    var _super1803 = _createSuper(IfcMaterialDefinitionRepresentation);

    function IfcMaterialDefinitionRepresentation(expressID, Name, Description, Representations, RepresentedMaterial) {
      var _this1795;

      _classCallCheck2(this, IfcMaterialDefinitionRepresentation);

      _this1795 = _super1803.call(this, expressID, Name, Description, Representations);
      _this1795.Name = Name;
      _this1795.Description = Description;
      _this1795.Representations = Representations;
      _this1795.RepresentedMaterial = RepresentedMaterial;
      _this1795.type = 2022407955;
      return _this1795;
    }

    return IfcMaterialDefinitionRepresentation;
  }(IfcProductRepresentation);

  IFC42.IfcMaterialDefinitionRepresentation = IfcMaterialDefinitionRepresentation;

  var IfcMaterialLayerSetUsage = /*#__PURE__*/function (_IfcMaterialUsageDefi3) {
    _inherits(IfcMaterialLayerSetUsage, _IfcMaterialUsageDefi3);

    var _super1804 = _createSuper(IfcMaterialLayerSetUsage);

    function IfcMaterialLayerSetUsage(expressID, ForLayerSet, LayerSetDirection, DirectionSense, OffsetFromReferenceLine, ReferenceExtent) {
      var _this1796;

      _classCallCheck2(this, IfcMaterialLayerSetUsage);

      _this1796 = _super1804.call(this, expressID);
      _this1796.ForLayerSet = ForLayerSet;
      _this1796.LayerSetDirection = LayerSetDirection;
      _this1796.DirectionSense = DirectionSense;
      _this1796.OffsetFromReferenceLine = OffsetFromReferenceLine;
      _this1796.ReferenceExtent = ReferenceExtent;
      _this1796.type = 1303795690;
      return _this1796;
    }

    return IfcMaterialLayerSetUsage;
  }(IfcMaterialUsageDefinition);

  IFC42.IfcMaterialLayerSetUsage = IfcMaterialLayerSetUsage;

  var IfcMaterialProfileSetUsage = /*#__PURE__*/function (_IfcMaterialUsageDefi4) {
    _inherits(IfcMaterialProfileSetUsage, _IfcMaterialUsageDefi4);

    var _super1805 = _createSuper(IfcMaterialProfileSetUsage);

    function IfcMaterialProfileSetUsage(expressID, ForProfileSet, CardinalPoint, ReferenceExtent) {
      var _this1797;

      _classCallCheck2(this, IfcMaterialProfileSetUsage);

      _this1797 = _super1805.call(this, expressID);
      _this1797.ForProfileSet = ForProfileSet;
      _this1797.CardinalPoint = CardinalPoint;
      _this1797.ReferenceExtent = ReferenceExtent;
      _this1797.type = 3079605661;
      return _this1797;
    }

    return IfcMaterialProfileSetUsage;
  }(IfcMaterialUsageDefinition);

  IFC42.IfcMaterialProfileSetUsage = IfcMaterialProfileSetUsage;

  var IfcMaterialProfileSetUsageTapering = /*#__PURE__*/function (_IfcMaterialProfileSe2) {
    _inherits(IfcMaterialProfileSetUsageTapering, _IfcMaterialProfileSe2);

    var _super1806 = _createSuper(IfcMaterialProfileSetUsageTapering);

    function IfcMaterialProfileSetUsageTapering(expressID, ForProfileSet, CardinalPoint, ReferenceExtent, ForProfileEndSet, CardinalEndPoint) {
      var _this1798;

      _classCallCheck2(this, IfcMaterialProfileSetUsageTapering);

      _this1798 = _super1806.call(this, expressID, ForProfileSet, CardinalPoint, ReferenceExtent);
      _this1798.ForProfileSet = ForProfileSet;
      _this1798.CardinalPoint = CardinalPoint;
      _this1798.ReferenceExtent = ReferenceExtent;
      _this1798.ForProfileEndSet = ForProfileEndSet;
      _this1798.CardinalEndPoint = CardinalEndPoint;
      _this1798.type = 3404854881;
      return _this1798;
    }

    return IfcMaterialProfileSetUsageTapering;
  }(IfcMaterialProfileSetUsage);

  IFC42.IfcMaterialProfileSetUsageTapering = IfcMaterialProfileSetUsageTapering;

  var IfcMaterialProperties = /*#__PURE__*/function (_IfcExtendedPropertie3) {
    _inherits(IfcMaterialProperties, _IfcExtendedPropertie3);

    var _super1807 = _createSuper(IfcMaterialProperties);

    function IfcMaterialProperties(expressID, Name, Description, Properties2, Material) {
      var _this1799;

      _classCallCheck2(this, IfcMaterialProperties);

      _this1799 = _super1807.call(this, expressID, Name, Description, Properties2);
      _this1799.Name = Name;
      _this1799.Description = Description;
      _this1799.Properties = Properties2;
      _this1799.Material = Material;
      _this1799.type = 3265635763;
      return _this1799;
    }

    return IfcMaterialProperties;
  }(IfcExtendedProperties);

  IFC42.IfcMaterialProperties = IfcMaterialProperties;

  var IfcMaterialRelationship = /*#__PURE__*/function (_IfcResourceLevelRela14) {
    _inherits(IfcMaterialRelationship, _IfcResourceLevelRela14);

    var _super1808 = _createSuper(IfcMaterialRelationship);

    function IfcMaterialRelationship(expressID, Name, Description, RelatingMaterial, RelatedMaterials, Expression) {
      var _this1800;

      _classCallCheck2(this, IfcMaterialRelationship);

      _this1800 = _super1808.call(this, expressID, Name, Description);
      _this1800.Name = Name;
      _this1800.Description = Description;
      _this1800.RelatingMaterial = RelatingMaterial;
      _this1800.RelatedMaterials = RelatedMaterials;
      _this1800.Expression = Expression;
      _this1800.type = 853536259;
      return _this1800;
    }

    return IfcMaterialRelationship;
  }(IfcResourceLevelRelationship);

  IFC42.IfcMaterialRelationship = IfcMaterialRelationship;

  var IfcMirroredProfileDef = /*#__PURE__*/function (_IfcDerivedProfileDef2) {
    _inherits(IfcMirroredProfileDef, _IfcDerivedProfileDef2);

    var _super1809 = _createSuper(IfcMirroredProfileDef);

    function IfcMirroredProfileDef(expressID, ProfileType, ProfileName, ParentProfile, Label) {
      var _this1801;

      _classCallCheck2(this, IfcMirroredProfileDef);

      _this1801 = _super1809.call(this, expressID, ProfileType, ProfileName, ParentProfile, new Handle(0), Label);
      _this1801.ProfileType = ProfileType;
      _this1801.ProfileName = ProfileName;
      _this1801.ParentProfile = ParentProfile;
      _this1801.Label = Label;
      _this1801.type = 2998442950;
      return _this1801;
    }

    return IfcMirroredProfileDef;
  }(IfcDerivedProfileDef);

  IFC42.IfcMirroredProfileDef = IfcMirroredProfileDef;

  var IfcObjectDefinition = /*#__PURE__*/function (_IfcRoot7) {
    _inherits(IfcObjectDefinition, _IfcRoot7);

    var _super1810 = _createSuper(IfcObjectDefinition);

    function IfcObjectDefinition(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1802;

      _classCallCheck2(this, IfcObjectDefinition);

      _this1802 = _super1810.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1802.GlobalId = GlobalId;
      _this1802.OwnerHistory = OwnerHistory;
      _this1802.Name = Name;
      _this1802.Description = Description;
      _this1802.type = 219451334;
      return _this1802;
    }

    return IfcObjectDefinition;
  }(IfcRoot);

  IFC42.IfcObjectDefinition = IfcObjectDefinition;

  var IfcOpenShell = /*#__PURE__*/function (_IfcConnectedFaceSet5) {
    _inherits(IfcOpenShell, _IfcConnectedFaceSet5);

    var _super1811 = _createSuper(IfcOpenShell);

    function IfcOpenShell(expressID, CfsFaces) {
      var _this1803;

      _classCallCheck2(this, IfcOpenShell);

      _this1803 = _super1811.call(this, expressID, CfsFaces);
      _this1803.CfsFaces = CfsFaces;
      _this1803.type = 2665983363;
      return _this1803;
    }

    return IfcOpenShell;
  }(IfcConnectedFaceSet);

  IFC42.IfcOpenShell = IfcOpenShell;

  var IfcOrganizationRelationship = /*#__PURE__*/function (_IfcResourceLevelRela15) {
    _inherits(IfcOrganizationRelationship, _IfcResourceLevelRela15);

    var _super1812 = _createSuper(IfcOrganizationRelationship);

    function IfcOrganizationRelationship(expressID, Name, Description, RelatingOrganization, RelatedOrganizations) {
      var _this1804;

      _classCallCheck2(this, IfcOrganizationRelationship);

      _this1804 = _super1812.call(this, expressID, Name, Description);
      _this1804.Name = Name;
      _this1804.Description = Description;
      _this1804.RelatingOrganization = RelatingOrganization;
      _this1804.RelatedOrganizations = RelatedOrganizations;
      _this1804.type = 1411181986;
      return _this1804;
    }

    return IfcOrganizationRelationship;
  }(IfcResourceLevelRelationship);

  IFC42.IfcOrganizationRelationship = IfcOrganizationRelationship;

  var IfcOrientedEdge = /*#__PURE__*/function (_IfcEdge8) {
    _inherits(IfcOrientedEdge, _IfcEdge8);

    var _super1813 = _createSuper(IfcOrientedEdge);

    function IfcOrientedEdge(expressID, EdgeElement, Orientation) {
      var _this1805;

      _classCallCheck2(this, IfcOrientedEdge);

      _this1805 = _super1813.call(this, expressID, new Handle(0), new Handle(0));
      _this1805.EdgeElement = EdgeElement;
      _this1805.Orientation = Orientation;
      _this1805.type = 1029017970;
      return _this1805;
    }

    return IfcOrientedEdge;
  }(IfcEdge);

  IFC42.IfcOrientedEdge = IfcOrientedEdge;

  var IfcParameterizedProfileDef = /*#__PURE__*/function (_IfcProfileDef16) {
    _inherits(IfcParameterizedProfileDef, _IfcProfileDef16);

    var _super1814 = _createSuper(IfcParameterizedProfileDef);

    function IfcParameterizedProfileDef(expressID, ProfileType, ProfileName, Position) {
      var _this1806;

      _classCallCheck2(this, IfcParameterizedProfileDef);

      _this1806 = _super1814.call(this, expressID, ProfileType, ProfileName);
      _this1806.ProfileType = ProfileType;
      _this1806.ProfileName = ProfileName;
      _this1806.Position = Position;
      _this1806.type = 2529465313;
      return _this1806;
    }

    return IfcParameterizedProfileDef;
  }(IfcProfileDef);

  IFC42.IfcParameterizedProfileDef = IfcParameterizedProfileDef;

  var IfcPath = /*#__PURE__*/function (_IfcTopologicalRepres21) {
    _inherits(IfcPath, _IfcTopologicalRepres21);

    var _super1815 = _createSuper(IfcPath);

    function IfcPath(expressID, EdgeList) {
      var _this1807;

      _classCallCheck2(this, IfcPath);

      _this1807 = _super1815.call(this, expressID);
      _this1807.EdgeList = EdgeList;
      _this1807.type = 2519244187;
      return _this1807;
    }

    return IfcPath;
  }(IfcTopologicalRepresentationItem);

  IFC42.IfcPath = IfcPath;

  var IfcPhysicalComplexQuantity = /*#__PURE__*/function (_IfcPhysicalQuantity6) {
    _inherits(IfcPhysicalComplexQuantity, _IfcPhysicalQuantity6);

    var _super1816 = _createSuper(IfcPhysicalComplexQuantity);

    function IfcPhysicalComplexQuantity(expressID, Name, Description, HasQuantities, Discrimination, Quality, Usage) {
      var _this1808;

      _classCallCheck2(this, IfcPhysicalComplexQuantity);

      _this1808 = _super1816.call(this, expressID, Name, Description);
      _this1808.Name = Name;
      _this1808.Description = Description;
      _this1808.HasQuantities = HasQuantities;
      _this1808.Discrimination = Discrimination;
      _this1808.Quality = Quality;
      _this1808.Usage = Usage;
      _this1808.type = 3021840470;
      return _this1808;
    }

    return IfcPhysicalComplexQuantity;
  }(IfcPhysicalQuantity);

  IFC42.IfcPhysicalComplexQuantity = IfcPhysicalComplexQuantity;

  var IfcPixelTexture = /*#__PURE__*/function (_IfcSurfaceTexture9) {
    _inherits(IfcPixelTexture, _IfcSurfaceTexture9);

    var _super1817 = _createSuper(IfcPixelTexture);

    function IfcPixelTexture(expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter, Width, Height, ColourComponents, Pixel) {
      var _this1809;

      _classCallCheck2(this, IfcPixelTexture);

      _this1809 = _super1817.call(this, expressID, RepeatS, RepeatT, Mode, TextureTransform, Parameter);
      _this1809.RepeatS = RepeatS;
      _this1809.RepeatT = RepeatT;
      _this1809.Mode = Mode;
      _this1809.TextureTransform = TextureTransform;
      _this1809.Parameter = Parameter;
      _this1809.Width = Width;
      _this1809.Height = Height;
      _this1809.ColourComponents = ColourComponents;
      _this1809.Pixel = Pixel;
      _this1809.type = 597895409;
      return _this1809;
    }

    return IfcPixelTexture;
  }(IfcSurfaceTexture);

  IFC42.IfcPixelTexture = IfcPixelTexture;

  var IfcPlacement = /*#__PURE__*/function (_IfcGeometricRepresen60) {
    _inherits(IfcPlacement, _IfcGeometricRepresen60);

    var _super1818 = _createSuper(IfcPlacement);

    function IfcPlacement(expressID, Location) {
      var _this1810;

      _classCallCheck2(this, IfcPlacement);

      _this1810 = _super1818.call(this, expressID);
      _this1810.Location = Location;
      _this1810.type = 2004835150;
      return _this1810;
    }

    return IfcPlacement;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcPlacement = IfcPlacement;

  var IfcPlanarExtent = /*#__PURE__*/function (_IfcGeometricRepresen61) {
    _inherits(IfcPlanarExtent, _IfcGeometricRepresen61);

    var _super1819 = _createSuper(IfcPlanarExtent);

    function IfcPlanarExtent(expressID, SizeInX, SizeInY) {
      var _this1811;

      _classCallCheck2(this, IfcPlanarExtent);

      _this1811 = _super1819.call(this, expressID);
      _this1811.SizeInX = SizeInX;
      _this1811.SizeInY = SizeInY;
      _this1811.type = 1663979128;
      return _this1811;
    }

    return IfcPlanarExtent;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcPlanarExtent = IfcPlanarExtent;

  var IfcPoint = /*#__PURE__*/function (_IfcGeometricRepresen62) {
    _inherits(IfcPoint, _IfcGeometricRepresen62);

    var _super1820 = _createSuper(IfcPoint);

    function IfcPoint(expressID) {
      var _this1812;

      _classCallCheck2(this, IfcPoint);

      _this1812 = _super1820.call(this, expressID);
      _this1812.type = 2067069095;
      return _this1812;
    }

    return IfcPoint;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcPoint = IfcPoint;

  var IfcPointOnCurve = /*#__PURE__*/function (_IfcPoint8) {
    _inherits(IfcPointOnCurve, _IfcPoint8);

    var _super1821 = _createSuper(IfcPointOnCurve);

    function IfcPointOnCurve(expressID, BasisCurve, PointParameter) {
      var _this1813;

      _classCallCheck2(this, IfcPointOnCurve);

      _this1813 = _super1821.call(this, expressID);
      _this1813.BasisCurve = BasisCurve;
      _this1813.PointParameter = PointParameter;
      _this1813.type = 4022376103;
      return _this1813;
    }

    return IfcPointOnCurve;
  }(IfcPoint);

  IFC42.IfcPointOnCurve = IfcPointOnCurve;

  var IfcPointOnSurface = /*#__PURE__*/function (_IfcPoint9) {
    _inherits(IfcPointOnSurface, _IfcPoint9);

    var _super1822 = _createSuper(IfcPointOnSurface);

    function IfcPointOnSurface(expressID, BasisSurface, PointParameterU, PointParameterV) {
      var _this1814;

      _classCallCheck2(this, IfcPointOnSurface);

      _this1814 = _super1822.call(this, expressID);
      _this1814.BasisSurface = BasisSurface;
      _this1814.PointParameterU = PointParameterU;
      _this1814.PointParameterV = PointParameterV;
      _this1814.type = 1423911732;
      return _this1814;
    }

    return IfcPointOnSurface;
  }(IfcPoint);

  IFC42.IfcPointOnSurface = IfcPointOnSurface;

  var IfcPolyLoop = /*#__PURE__*/function (_IfcLoop7) {
    _inherits(IfcPolyLoop, _IfcLoop7);

    var _super1823 = _createSuper(IfcPolyLoop);

    function IfcPolyLoop(expressID, Polygon) {
      var _this1815;

      _classCallCheck2(this, IfcPolyLoop);

      _this1815 = _super1823.call(this, expressID);
      _this1815.Polygon = Polygon;
      _this1815.type = 2924175390;
      return _this1815;
    }

    return IfcPolyLoop;
  }(IfcLoop);

  IFC42.IfcPolyLoop = IfcPolyLoop;

  var IfcPolygonalBoundedHalfSpace = /*#__PURE__*/function (_IfcHalfSpaceSolid5) {
    _inherits(IfcPolygonalBoundedHalfSpace, _IfcHalfSpaceSolid5);

    var _super1824 = _createSuper(IfcPolygonalBoundedHalfSpace);

    function IfcPolygonalBoundedHalfSpace(expressID, BaseSurface, AgreementFlag, Position, PolygonalBoundary) {
      var _this1816;

      _classCallCheck2(this, IfcPolygonalBoundedHalfSpace);

      _this1816 = _super1824.call(this, expressID, BaseSurface, AgreementFlag);
      _this1816.BaseSurface = BaseSurface;
      _this1816.AgreementFlag = AgreementFlag;
      _this1816.Position = Position;
      _this1816.PolygonalBoundary = PolygonalBoundary;
      _this1816.type = 2775532180;
      return _this1816;
    }

    return IfcPolygonalBoundedHalfSpace;
  }(IfcHalfSpaceSolid);

  IFC42.IfcPolygonalBoundedHalfSpace = IfcPolygonalBoundedHalfSpace;

  var IfcPreDefinedItem = /*#__PURE__*/function (_IfcPresentationItem34) {
    _inherits(IfcPreDefinedItem, _IfcPresentationItem34);

    var _super1825 = _createSuper(IfcPreDefinedItem);

    function IfcPreDefinedItem(expressID, Name) {
      var _this1817;

      _classCallCheck2(this, IfcPreDefinedItem);

      _this1817 = _super1825.call(this, expressID);
      _this1817.Name = Name;
      _this1817.type = 3727388367;
      return _this1817;
    }

    return IfcPreDefinedItem;
  }(IfcPresentationItem);

  IFC42.IfcPreDefinedItem = IfcPreDefinedItem;

  var IfcPreDefinedProperties = /*#__PURE__*/function (_IfcPropertyAbstracti7) {
    _inherits(IfcPreDefinedProperties, _IfcPropertyAbstracti7);

    var _super1826 = _createSuper(IfcPreDefinedProperties);

    function IfcPreDefinedProperties(expressID) {
      var _this1818;

      _classCallCheck2(this, IfcPreDefinedProperties);

      _this1818 = _super1826.call(this, expressID);
      _this1818.type = 3778827333;
      return _this1818;
    }

    return IfcPreDefinedProperties;
  }(IfcPropertyAbstraction);

  IFC42.IfcPreDefinedProperties = IfcPreDefinedProperties;

  var IfcPreDefinedTextFont = /*#__PURE__*/function (_IfcPreDefinedItem8) {
    _inherits(IfcPreDefinedTextFont, _IfcPreDefinedItem8);

    var _super1827 = _createSuper(IfcPreDefinedTextFont);

    function IfcPreDefinedTextFont(expressID, Name) {
      var _this1819;

      _classCallCheck2(this, IfcPreDefinedTextFont);

      _this1819 = _super1827.call(this, expressID, Name);
      _this1819.Name = Name;
      _this1819.type = 1775413392;
      return _this1819;
    }

    return IfcPreDefinedTextFont;
  }(IfcPreDefinedItem);

  IFC42.IfcPreDefinedTextFont = IfcPreDefinedTextFont;

  var IfcProductDefinitionShape = /*#__PURE__*/function (_IfcProductRepresenta6) {
    _inherits(IfcProductDefinitionShape, _IfcProductRepresenta6);

    var _super1828 = _createSuper(IfcProductDefinitionShape);

    function IfcProductDefinitionShape(expressID, Name, Description, Representations) {
      var _this1820;

      _classCallCheck2(this, IfcProductDefinitionShape);

      _this1820 = _super1828.call(this, expressID, Name, Description, Representations);
      _this1820.Name = Name;
      _this1820.Description = Description;
      _this1820.Representations = Representations;
      _this1820.type = 673634403;
      return _this1820;
    }

    return IfcProductDefinitionShape;
  }(IfcProductRepresentation);

  IFC42.IfcProductDefinitionShape = IfcProductDefinitionShape;

  var IfcProfileProperties = /*#__PURE__*/function (_IfcExtendedPropertie4) {
    _inherits(IfcProfileProperties, _IfcExtendedPropertie4);

    var _super1829 = _createSuper(IfcProfileProperties);

    function IfcProfileProperties(expressID, Name, Description, Properties2, ProfileDefinition) {
      var _this1821;

      _classCallCheck2(this, IfcProfileProperties);

      _this1821 = _super1829.call(this, expressID, Name, Description, Properties2);
      _this1821.Name = Name;
      _this1821.Description = Description;
      _this1821.Properties = Properties2;
      _this1821.ProfileDefinition = ProfileDefinition;
      _this1821.type = 2802850158;
      return _this1821;
    }

    return IfcProfileProperties;
  }(IfcExtendedProperties);

  IFC42.IfcProfileProperties = IfcProfileProperties;

  var IfcProperty = /*#__PURE__*/function (_IfcPropertyAbstracti8) {
    _inherits(IfcProperty, _IfcPropertyAbstracti8);

    var _super1830 = _createSuper(IfcProperty);

    function IfcProperty(expressID, Name, Description) {
      var _this1822;

      _classCallCheck2(this, IfcProperty);

      _this1822 = _super1830.call(this, expressID);
      _this1822.Name = Name;
      _this1822.Description = Description;
      _this1822.type = 2598011224;
      return _this1822;
    }

    return IfcProperty;
  }(IfcPropertyAbstraction);

  IFC42.IfcProperty = IfcProperty;

  var IfcPropertyDefinition = /*#__PURE__*/function (_IfcRoot8) {
    _inherits(IfcPropertyDefinition, _IfcRoot8);

    var _super1831 = _createSuper(IfcPropertyDefinition);

    function IfcPropertyDefinition(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1823;

      _classCallCheck2(this, IfcPropertyDefinition);

      _this1823 = _super1831.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1823.GlobalId = GlobalId;
      _this1823.OwnerHistory = OwnerHistory;
      _this1823.Name = Name;
      _this1823.Description = Description;
      _this1823.type = 1680319473;
      return _this1823;
    }

    return IfcPropertyDefinition;
  }(IfcRoot);

  IFC42.IfcPropertyDefinition = IfcPropertyDefinition;

  var IfcPropertyDependencyRelationship = /*#__PURE__*/function (_IfcResourceLevelRela16) {
    _inherits(IfcPropertyDependencyRelationship, _IfcResourceLevelRela16);

    var _super1832 = _createSuper(IfcPropertyDependencyRelationship);

    function IfcPropertyDependencyRelationship(expressID, Name, Description, DependingProperty, DependantProperty, Expression) {
      var _this1824;

      _classCallCheck2(this, IfcPropertyDependencyRelationship);

      _this1824 = _super1832.call(this, expressID, Name, Description);
      _this1824.Name = Name;
      _this1824.Description = Description;
      _this1824.DependingProperty = DependingProperty;
      _this1824.DependantProperty = DependantProperty;
      _this1824.Expression = Expression;
      _this1824.type = 148025276;
      return _this1824;
    }

    return IfcPropertyDependencyRelationship;
  }(IfcResourceLevelRelationship);

  IFC42.IfcPropertyDependencyRelationship = IfcPropertyDependencyRelationship;

  var IfcPropertySetDefinition = /*#__PURE__*/function (_IfcPropertyDefinitio4) {
    _inherits(IfcPropertySetDefinition, _IfcPropertyDefinitio4);

    var _super1833 = _createSuper(IfcPropertySetDefinition);

    function IfcPropertySetDefinition(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1825;

      _classCallCheck2(this, IfcPropertySetDefinition);

      _this1825 = _super1833.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1825.GlobalId = GlobalId;
      _this1825.OwnerHistory = OwnerHistory;
      _this1825.Name = Name;
      _this1825.Description = Description;
      _this1825.type = 3357820518;
      return _this1825;
    }

    return IfcPropertySetDefinition;
  }(IfcPropertyDefinition);

  IFC42.IfcPropertySetDefinition = IfcPropertySetDefinition;

  var IfcPropertyTemplateDefinition = /*#__PURE__*/function (_IfcPropertyDefinitio5) {
    _inherits(IfcPropertyTemplateDefinition, _IfcPropertyDefinitio5);

    var _super1834 = _createSuper(IfcPropertyTemplateDefinition);

    function IfcPropertyTemplateDefinition(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1826;

      _classCallCheck2(this, IfcPropertyTemplateDefinition);

      _this1826 = _super1834.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1826.GlobalId = GlobalId;
      _this1826.OwnerHistory = OwnerHistory;
      _this1826.Name = Name;
      _this1826.Description = Description;
      _this1826.type = 1482703590;
      return _this1826;
    }

    return IfcPropertyTemplateDefinition;
  }(IfcPropertyDefinition);

  IFC42.IfcPropertyTemplateDefinition = IfcPropertyTemplateDefinition;

  var IfcQuantitySet = /*#__PURE__*/function (_IfcPropertySetDefini18) {
    _inherits(IfcQuantitySet, _IfcPropertySetDefini18);

    var _super1835 = _createSuper(IfcQuantitySet);

    function IfcQuantitySet(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1827;

      _classCallCheck2(this, IfcQuantitySet);

      _this1827 = _super1835.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1827.GlobalId = GlobalId;
      _this1827.OwnerHistory = OwnerHistory;
      _this1827.Name = Name;
      _this1827.Description = Description;
      _this1827.type = 2090586900;
      return _this1827;
    }

    return IfcQuantitySet;
  }(IfcPropertySetDefinition);

  IFC42.IfcQuantitySet = IfcQuantitySet;

  var IfcRectangleProfileDef = /*#__PURE__*/function (_IfcParameterizedProf24) {
    _inherits(IfcRectangleProfileDef, _IfcParameterizedProf24);

    var _super1836 = _createSuper(IfcRectangleProfileDef);

    function IfcRectangleProfileDef(expressID, ProfileType, ProfileName, Position, XDim, YDim) {
      var _this1828;

      _classCallCheck2(this, IfcRectangleProfileDef);

      _this1828 = _super1836.call(this, expressID, ProfileType, ProfileName, Position);
      _this1828.ProfileType = ProfileType;
      _this1828.ProfileName = ProfileName;
      _this1828.Position = Position;
      _this1828.XDim = XDim;
      _this1828.YDim = YDim;
      _this1828.type = 3615266464;
      return _this1828;
    }

    return IfcRectangleProfileDef;
  }(IfcParameterizedProfileDef);

  IFC42.IfcRectangleProfileDef = IfcRectangleProfileDef;

  var IfcRegularTimeSeries = /*#__PURE__*/function (_IfcTimeSeries6) {
    _inherits(IfcRegularTimeSeries, _IfcTimeSeries6);

    var _super1837 = _createSuper(IfcRegularTimeSeries);

    function IfcRegularTimeSeries(expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit, TimeStep, Values) {
      var _this1829;

      _classCallCheck2(this, IfcRegularTimeSeries);

      _this1829 = _super1837.call(this, expressID, Name, Description, StartTime, EndTime, TimeSeriesDataType, DataOrigin, UserDefinedDataOrigin, Unit);
      _this1829.Name = Name;
      _this1829.Description = Description;
      _this1829.StartTime = StartTime;
      _this1829.EndTime = EndTime;
      _this1829.TimeSeriesDataType = TimeSeriesDataType;
      _this1829.DataOrigin = DataOrigin;
      _this1829.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this1829.Unit = Unit;
      _this1829.TimeStep = TimeStep;
      _this1829.Values = Values;
      _this1829.type = 3413951693;
      return _this1829;
    }

    return IfcRegularTimeSeries;
  }(IfcTimeSeries);

  IFC42.IfcRegularTimeSeries = IfcRegularTimeSeries;

  var IfcReinforcementBarProperties = /*#__PURE__*/function (_IfcPreDefinedPropert10) {
    _inherits(IfcReinforcementBarProperties, _IfcPreDefinedPropert10);

    var _super1838 = _createSuper(IfcReinforcementBarProperties);

    function IfcReinforcementBarProperties(expressID, TotalCrossSectionArea, SteelGrade, BarSurface, EffectiveDepth, NominalBarDiameter, BarCount) {
      var _this1830;

      _classCallCheck2(this, IfcReinforcementBarProperties);

      _this1830 = _super1838.call(this, expressID);
      _this1830.TotalCrossSectionArea = TotalCrossSectionArea;
      _this1830.SteelGrade = SteelGrade;
      _this1830.BarSurface = BarSurface;
      _this1830.EffectiveDepth = EffectiveDepth;
      _this1830.NominalBarDiameter = NominalBarDiameter;
      _this1830.BarCount = BarCount;
      _this1830.type = 1580146022;
      return _this1830;
    }

    return IfcReinforcementBarProperties;
  }(IfcPreDefinedProperties);

  IFC42.IfcReinforcementBarProperties = IfcReinforcementBarProperties;

  var IfcRelationship = /*#__PURE__*/function (_IfcRoot9) {
    _inherits(IfcRelationship, _IfcRoot9);

    var _super1839 = _createSuper(IfcRelationship);

    function IfcRelationship(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1831;

      _classCallCheck2(this, IfcRelationship);

      _this1831 = _super1839.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1831.GlobalId = GlobalId;
      _this1831.OwnerHistory = OwnerHistory;
      _this1831.Name = Name;
      _this1831.Description = Description;
      _this1831.type = 478536968;
      return _this1831;
    }

    return IfcRelationship;
  }(IfcRoot);

  IFC42.IfcRelationship = IfcRelationship;

  var IfcResourceApprovalRelationship = /*#__PURE__*/function (_IfcResourceLevelRela17) {
    _inherits(IfcResourceApprovalRelationship, _IfcResourceLevelRela17);

    var _super1840 = _createSuper(IfcResourceApprovalRelationship);

    function IfcResourceApprovalRelationship(expressID, Name, Description, RelatedResourceObjects, RelatingApproval) {
      var _this1832;

      _classCallCheck2(this, IfcResourceApprovalRelationship);

      _this1832 = _super1840.call(this, expressID, Name, Description);
      _this1832.Name = Name;
      _this1832.Description = Description;
      _this1832.RelatedResourceObjects = RelatedResourceObjects;
      _this1832.RelatingApproval = RelatingApproval;
      _this1832.type = 2943643501;
      return _this1832;
    }

    return IfcResourceApprovalRelationship;
  }(IfcResourceLevelRelationship);

  IFC42.IfcResourceApprovalRelationship = IfcResourceApprovalRelationship;

  var IfcResourceConstraintRelationship = /*#__PURE__*/function (_IfcResourceLevelRela18) {
    _inherits(IfcResourceConstraintRelationship, _IfcResourceLevelRela18);

    var _super1841 = _createSuper(IfcResourceConstraintRelationship);

    function IfcResourceConstraintRelationship(expressID, Name, Description, RelatingConstraint, RelatedResourceObjects) {
      var _this1833;

      _classCallCheck2(this, IfcResourceConstraintRelationship);

      _this1833 = _super1841.call(this, expressID, Name, Description);
      _this1833.Name = Name;
      _this1833.Description = Description;
      _this1833.RelatingConstraint = RelatingConstraint;
      _this1833.RelatedResourceObjects = RelatedResourceObjects;
      _this1833.type = 1608871552;
      return _this1833;
    }

    return IfcResourceConstraintRelationship;
  }(IfcResourceLevelRelationship);

  IFC42.IfcResourceConstraintRelationship = IfcResourceConstraintRelationship;

  var IfcResourceTime = /*#__PURE__*/function (_IfcSchedulingTime10) {
    _inherits(IfcResourceTime, _IfcSchedulingTime10);

    var _super1842 = _createSuper(IfcResourceTime);

    function IfcResourceTime(expressID, Name, DataOrigin, UserDefinedDataOrigin, ScheduleWork, ScheduleUsage, ScheduleStart, ScheduleFinish, ScheduleContour, LevelingDelay, IsOverAllocated, StatusTime, ActualWork, ActualUsage, ActualStart, ActualFinish, RemainingWork, RemainingUsage, Completion) {
      var _this1834;

      _classCallCheck2(this, IfcResourceTime);

      _this1834 = _super1842.call(this, expressID, Name, DataOrigin, UserDefinedDataOrigin);
      _this1834.Name = Name;
      _this1834.DataOrigin = DataOrigin;
      _this1834.UserDefinedDataOrigin = UserDefinedDataOrigin;
      _this1834.ScheduleWork = ScheduleWork;
      _this1834.ScheduleUsage = ScheduleUsage;
      _this1834.ScheduleStart = ScheduleStart;
      _this1834.ScheduleFinish = ScheduleFinish;
      _this1834.ScheduleContour = ScheduleContour;
      _this1834.LevelingDelay = LevelingDelay;
      _this1834.IsOverAllocated = IsOverAllocated;
      _this1834.StatusTime = StatusTime;
      _this1834.ActualWork = ActualWork;
      _this1834.ActualUsage = ActualUsage;
      _this1834.ActualStart = ActualStart;
      _this1834.ActualFinish = ActualFinish;
      _this1834.RemainingWork = RemainingWork;
      _this1834.RemainingUsage = RemainingUsage;
      _this1834.Completion = Completion;
      _this1834.type = 1042787934;
      return _this1834;
    }

    return IfcResourceTime;
  }(IfcSchedulingTime);

  IFC42.IfcResourceTime = IfcResourceTime;

  var IfcRoundedRectangleProfileDef = /*#__PURE__*/function (_IfcRectangleProfileD5) {
    _inherits(IfcRoundedRectangleProfileDef, _IfcRectangleProfileD5);

    var _super1843 = _createSuper(IfcRoundedRectangleProfileDef);

    function IfcRoundedRectangleProfileDef(expressID, ProfileType, ProfileName, Position, XDim, YDim, RoundingRadius) {
      var _this1835;

      _classCallCheck2(this, IfcRoundedRectangleProfileDef);

      _this1835 = _super1843.call(this, expressID, ProfileType, ProfileName, Position, XDim, YDim);
      _this1835.ProfileType = ProfileType;
      _this1835.ProfileName = ProfileName;
      _this1835.Position = Position;
      _this1835.XDim = XDim;
      _this1835.YDim = YDim;
      _this1835.RoundingRadius = RoundingRadius;
      _this1835.type = 2778083089;
      return _this1835;
    }

    return IfcRoundedRectangleProfileDef;
  }(IfcRectangleProfileDef);

  IFC42.IfcRoundedRectangleProfileDef = IfcRoundedRectangleProfileDef;

  var IfcSectionProperties = /*#__PURE__*/function (_IfcPreDefinedPropert11) {
    _inherits(IfcSectionProperties, _IfcPreDefinedPropert11);

    var _super1844 = _createSuper(IfcSectionProperties);

    function IfcSectionProperties(expressID, SectionType, StartProfile, EndProfile) {
      var _this1836;

      _classCallCheck2(this, IfcSectionProperties);

      _this1836 = _super1844.call(this, expressID);
      _this1836.SectionType = SectionType;
      _this1836.StartProfile = StartProfile;
      _this1836.EndProfile = EndProfile;
      _this1836.type = 2042790032;
      return _this1836;
    }

    return IfcSectionProperties;
  }(IfcPreDefinedProperties);

  IFC42.IfcSectionProperties = IfcSectionProperties;

  var IfcSectionReinforcementProperties = /*#__PURE__*/function (_IfcPreDefinedPropert12) {
    _inherits(IfcSectionReinforcementProperties, _IfcPreDefinedPropert12);

    var _super1845 = _createSuper(IfcSectionReinforcementProperties);

    function IfcSectionReinforcementProperties(expressID, LongitudinalStartPosition, LongitudinalEndPosition, TransversePosition, ReinforcementRole, SectionDefinition, CrossSectionReinforcementDefinitions) {
      var _this1837;

      _classCallCheck2(this, IfcSectionReinforcementProperties);

      _this1837 = _super1845.call(this, expressID);
      _this1837.LongitudinalStartPosition = LongitudinalStartPosition;
      _this1837.LongitudinalEndPosition = LongitudinalEndPosition;
      _this1837.TransversePosition = TransversePosition;
      _this1837.ReinforcementRole = ReinforcementRole;
      _this1837.SectionDefinition = SectionDefinition;
      _this1837.CrossSectionReinforcementDefinitions = CrossSectionReinforcementDefinitions;
      _this1837.type = 4165799628;
      return _this1837;
    }

    return IfcSectionReinforcementProperties;
  }(IfcPreDefinedProperties);

  IFC42.IfcSectionReinforcementProperties = IfcSectionReinforcementProperties;

  var IfcSectionedSpine = /*#__PURE__*/function (_IfcGeometricRepresen63) {
    _inherits(IfcSectionedSpine, _IfcGeometricRepresen63);

    var _super1846 = _createSuper(IfcSectionedSpine);

    function IfcSectionedSpine(expressID, SpineCurve, CrossSections, CrossSectionPositions) {
      var _this1838;

      _classCallCheck2(this, IfcSectionedSpine);

      _this1838 = _super1846.call(this, expressID);
      _this1838.SpineCurve = SpineCurve;
      _this1838.CrossSections = CrossSections;
      _this1838.CrossSectionPositions = CrossSectionPositions;
      _this1838.type = 1509187699;
      return _this1838;
    }

    return IfcSectionedSpine;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcSectionedSpine = IfcSectionedSpine;

  var IfcShellBasedSurfaceModel = /*#__PURE__*/function (_IfcGeometricRepresen64) {
    _inherits(IfcShellBasedSurfaceModel, _IfcGeometricRepresen64);

    var _super1847 = _createSuper(IfcShellBasedSurfaceModel);

    function IfcShellBasedSurfaceModel(expressID, SbsmBoundary) {
      var _this1839;

      _classCallCheck2(this, IfcShellBasedSurfaceModel);

      _this1839 = _super1847.call(this, expressID);
      _this1839.SbsmBoundary = SbsmBoundary;
      _this1839.type = 4124623270;
      return _this1839;
    }

    return IfcShellBasedSurfaceModel;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcShellBasedSurfaceModel = IfcShellBasedSurfaceModel;

  var IfcSimpleProperty = /*#__PURE__*/function (_IfcProperty5) {
    _inherits(IfcSimpleProperty, _IfcProperty5);

    var _super1848 = _createSuper(IfcSimpleProperty);

    function IfcSimpleProperty(expressID, Name, Description) {
      var _this1840;

      _classCallCheck2(this, IfcSimpleProperty);

      _this1840 = _super1848.call(this, expressID, Name, Description);
      _this1840.Name = Name;
      _this1840.Description = Description;
      _this1840.type = 3692461612;
      return _this1840;
    }

    return IfcSimpleProperty;
  }(IfcProperty);

  IFC42.IfcSimpleProperty = IfcSimpleProperty;

  var IfcSlippageConnectionCondition = /*#__PURE__*/function (_IfcStructuralConnect12) {
    _inherits(IfcSlippageConnectionCondition, _IfcStructuralConnect12);

    var _super1849 = _createSuper(IfcSlippageConnectionCondition);

    function IfcSlippageConnectionCondition(expressID, Name, SlippageX, SlippageY, SlippageZ) {
      var _this1841;

      _classCallCheck2(this, IfcSlippageConnectionCondition);

      _this1841 = _super1849.call(this, expressID, Name);
      _this1841.Name = Name;
      _this1841.SlippageX = SlippageX;
      _this1841.SlippageY = SlippageY;
      _this1841.SlippageZ = SlippageZ;
      _this1841.type = 2609359061;
      return _this1841;
    }

    return IfcSlippageConnectionCondition;
  }(IfcStructuralConnectionCondition);

  IFC42.IfcSlippageConnectionCondition = IfcSlippageConnectionCondition;

  var IfcSolidModel = /*#__PURE__*/function (_IfcGeometricRepresen65) {
    _inherits(IfcSolidModel, _IfcGeometricRepresen65);

    var _super1850 = _createSuper(IfcSolidModel);

    function IfcSolidModel(expressID) {
      var _this1842;

      _classCallCheck2(this, IfcSolidModel);

      _this1842 = _super1850.call(this, expressID);
      _this1842.type = 723233188;
      return _this1842;
    }

    return IfcSolidModel;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcSolidModel = IfcSolidModel;

  var IfcStructuralLoadLinearForce = /*#__PURE__*/function (_IfcStructuralLoadSta12) {
    _inherits(IfcStructuralLoadLinearForce, _IfcStructuralLoadSta12);

    var _super1851 = _createSuper(IfcStructuralLoadLinearForce);

    function IfcStructuralLoadLinearForce(expressID, Name, LinearForceX, LinearForceY, LinearForceZ, LinearMomentX, LinearMomentY, LinearMomentZ) {
      var _this1843;

      _classCallCheck2(this, IfcStructuralLoadLinearForce);

      _this1843 = _super1851.call(this, expressID, Name);
      _this1843.Name = Name;
      _this1843.LinearForceX = LinearForceX;
      _this1843.LinearForceY = LinearForceY;
      _this1843.LinearForceZ = LinearForceZ;
      _this1843.LinearMomentX = LinearMomentX;
      _this1843.LinearMomentY = LinearMomentY;
      _this1843.LinearMomentZ = LinearMomentZ;
      _this1843.type = 1595516126;
      return _this1843;
    }

    return IfcStructuralLoadLinearForce;
  }(IfcStructuralLoadStatic);

  IFC42.IfcStructuralLoadLinearForce = IfcStructuralLoadLinearForce;

  var IfcStructuralLoadPlanarForce = /*#__PURE__*/function (_IfcStructuralLoadSta13) {
    _inherits(IfcStructuralLoadPlanarForce, _IfcStructuralLoadSta13);

    var _super1852 = _createSuper(IfcStructuralLoadPlanarForce);

    function IfcStructuralLoadPlanarForce(expressID, Name, PlanarForceX, PlanarForceY, PlanarForceZ) {
      var _this1844;

      _classCallCheck2(this, IfcStructuralLoadPlanarForce);

      _this1844 = _super1852.call(this, expressID, Name);
      _this1844.Name = Name;
      _this1844.PlanarForceX = PlanarForceX;
      _this1844.PlanarForceY = PlanarForceY;
      _this1844.PlanarForceZ = PlanarForceZ;
      _this1844.type = 2668620305;
      return _this1844;
    }

    return IfcStructuralLoadPlanarForce;
  }(IfcStructuralLoadStatic);

  IFC42.IfcStructuralLoadPlanarForce = IfcStructuralLoadPlanarForce;

  var IfcStructuralLoadSingleDisplacement = /*#__PURE__*/function (_IfcStructuralLoadSta14) {
    _inherits(IfcStructuralLoadSingleDisplacement, _IfcStructuralLoadSta14);

    var _super1853 = _createSuper(IfcStructuralLoadSingleDisplacement);

    function IfcStructuralLoadSingleDisplacement(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ) {
      var _this1845;

      _classCallCheck2(this, IfcStructuralLoadSingleDisplacement);

      _this1845 = _super1853.call(this, expressID, Name);
      _this1845.Name = Name;
      _this1845.DisplacementX = DisplacementX;
      _this1845.DisplacementY = DisplacementY;
      _this1845.DisplacementZ = DisplacementZ;
      _this1845.RotationalDisplacementRX = RotationalDisplacementRX;
      _this1845.RotationalDisplacementRY = RotationalDisplacementRY;
      _this1845.RotationalDisplacementRZ = RotationalDisplacementRZ;
      _this1845.type = 2473145415;
      return _this1845;
    }

    return IfcStructuralLoadSingleDisplacement;
  }(IfcStructuralLoadStatic);

  IFC42.IfcStructuralLoadSingleDisplacement = IfcStructuralLoadSingleDisplacement;

  var IfcStructuralLoadSingleDisplacementDistortion = /*#__PURE__*/function (_IfcStructuralLoadSin5) {
    _inherits(IfcStructuralLoadSingleDisplacementDistortion, _IfcStructuralLoadSin5);

    var _super1854 = _createSuper(IfcStructuralLoadSingleDisplacementDistortion);

    function IfcStructuralLoadSingleDisplacementDistortion(expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ, Distortion) {
      var _this1846;

      _classCallCheck2(this, IfcStructuralLoadSingleDisplacementDistortion);

      _this1846 = _super1854.call(this, expressID, Name, DisplacementX, DisplacementY, DisplacementZ, RotationalDisplacementRX, RotationalDisplacementRY, RotationalDisplacementRZ);
      _this1846.Name = Name;
      _this1846.DisplacementX = DisplacementX;
      _this1846.DisplacementY = DisplacementY;
      _this1846.DisplacementZ = DisplacementZ;
      _this1846.RotationalDisplacementRX = RotationalDisplacementRX;
      _this1846.RotationalDisplacementRY = RotationalDisplacementRY;
      _this1846.RotationalDisplacementRZ = RotationalDisplacementRZ;
      _this1846.Distortion = Distortion;
      _this1846.type = 1973038258;
      return _this1846;
    }

    return IfcStructuralLoadSingleDisplacementDistortion;
  }(IfcStructuralLoadSingleDisplacement);

  IFC42.IfcStructuralLoadSingleDisplacementDistortion = IfcStructuralLoadSingleDisplacementDistortion;

  var IfcStructuralLoadSingleForce = /*#__PURE__*/function (_IfcStructuralLoadSta15) {
    _inherits(IfcStructuralLoadSingleForce, _IfcStructuralLoadSta15);

    var _super1855 = _createSuper(IfcStructuralLoadSingleForce);

    function IfcStructuralLoadSingleForce(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ) {
      var _this1847;

      _classCallCheck2(this, IfcStructuralLoadSingleForce);

      _this1847 = _super1855.call(this, expressID, Name);
      _this1847.Name = Name;
      _this1847.ForceX = ForceX;
      _this1847.ForceY = ForceY;
      _this1847.ForceZ = ForceZ;
      _this1847.MomentX = MomentX;
      _this1847.MomentY = MomentY;
      _this1847.MomentZ = MomentZ;
      _this1847.type = 1597423693;
      return _this1847;
    }

    return IfcStructuralLoadSingleForce;
  }(IfcStructuralLoadStatic);

  IFC42.IfcStructuralLoadSingleForce = IfcStructuralLoadSingleForce;

  var IfcStructuralLoadSingleForceWarping = /*#__PURE__*/function (_IfcStructuralLoadSin6) {
    _inherits(IfcStructuralLoadSingleForceWarping, _IfcStructuralLoadSin6);

    var _super1856 = _createSuper(IfcStructuralLoadSingleForceWarping);

    function IfcStructuralLoadSingleForceWarping(expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ, WarpingMoment) {
      var _this1848;

      _classCallCheck2(this, IfcStructuralLoadSingleForceWarping);

      _this1848 = _super1856.call(this, expressID, Name, ForceX, ForceY, ForceZ, MomentX, MomentY, MomentZ);
      _this1848.Name = Name;
      _this1848.ForceX = ForceX;
      _this1848.ForceY = ForceY;
      _this1848.ForceZ = ForceZ;
      _this1848.MomentX = MomentX;
      _this1848.MomentY = MomentY;
      _this1848.MomentZ = MomentZ;
      _this1848.WarpingMoment = WarpingMoment;
      _this1848.type = 1190533807;
      return _this1848;
    }

    return IfcStructuralLoadSingleForceWarping;
  }(IfcStructuralLoadSingleForce);

  IFC42.IfcStructuralLoadSingleForceWarping = IfcStructuralLoadSingleForceWarping;

  var IfcSubedge = /*#__PURE__*/function (_IfcEdge9) {
    _inherits(IfcSubedge, _IfcEdge9);

    var _super1857 = _createSuper(IfcSubedge);

    function IfcSubedge(expressID, EdgeStart, EdgeEnd, ParentEdge) {
      var _this1849;

      _classCallCheck2(this, IfcSubedge);

      _this1849 = _super1857.call(this, expressID, EdgeStart, EdgeEnd);
      _this1849.EdgeStart = EdgeStart;
      _this1849.EdgeEnd = EdgeEnd;
      _this1849.ParentEdge = ParentEdge;
      _this1849.type = 2233826070;
      return _this1849;
    }

    return IfcSubedge;
  }(IfcEdge);

  IFC42.IfcSubedge = IfcSubedge;

  var IfcSurface = /*#__PURE__*/function (_IfcGeometricRepresen66) {
    _inherits(IfcSurface, _IfcGeometricRepresen66);

    var _super1858 = _createSuper(IfcSurface);

    function IfcSurface(expressID) {
      var _this1850;

      _classCallCheck2(this, IfcSurface);

      _this1850 = _super1858.call(this, expressID);
      _this1850.type = 2513912981;
      return _this1850;
    }

    return IfcSurface;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcSurface = IfcSurface;

  var IfcSurfaceStyleRendering = /*#__PURE__*/function (_IfcSurfaceStyleShadi3) {
    _inherits(IfcSurfaceStyleRendering, _IfcSurfaceStyleShadi3);

    var _super1859 = _createSuper(IfcSurfaceStyleRendering);

    function IfcSurfaceStyleRendering(expressID, SurfaceColour, Transparency, DiffuseColour, TransmissionColour, DiffuseTransmissionColour, ReflectionColour, SpecularColour, SpecularHighlight, ReflectanceMethod) {
      var _this1851;

      _classCallCheck2(this, IfcSurfaceStyleRendering);

      _this1851 = _super1859.call(this, expressID, SurfaceColour, Transparency);
      _this1851.SurfaceColour = SurfaceColour;
      _this1851.Transparency = Transparency;
      _this1851.DiffuseColour = DiffuseColour;
      _this1851.TransmissionColour = TransmissionColour;
      _this1851.DiffuseTransmissionColour = DiffuseTransmissionColour;
      _this1851.ReflectionColour = ReflectionColour;
      _this1851.SpecularColour = SpecularColour;
      _this1851.SpecularHighlight = SpecularHighlight;
      _this1851.ReflectanceMethod = ReflectanceMethod;
      _this1851.type = 1878645084;
      return _this1851;
    }

    return IfcSurfaceStyleRendering;
  }(IfcSurfaceStyleShading);

  IFC42.IfcSurfaceStyleRendering = IfcSurfaceStyleRendering;

  var IfcSweptAreaSolid = /*#__PURE__*/function (_IfcSolidModel10) {
    _inherits(IfcSweptAreaSolid, _IfcSolidModel10);

    var _super1860 = _createSuper(IfcSweptAreaSolid);

    function IfcSweptAreaSolid(expressID, SweptArea, Position) {
      var _this1852;

      _classCallCheck2(this, IfcSweptAreaSolid);

      _this1852 = _super1860.call(this, expressID);
      _this1852.SweptArea = SweptArea;
      _this1852.Position = Position;
      _this1852.type = 2247615214;
      return _this1852;
    }

    return IfcSweptAreaSolid;
  }(IfcSolidModel);

  IFC42.IfcSweptAreaSolid = IfcSweptAreaSolid;

  var IfcSweptDiskSolid = /*#__PURE__*/function (_IfcSolidModel11) {
    _inherits(IfcSweptDiskSolid, _IfcSolidModel11);

    var _super1861 = _createSuper(IfcSweptDiskSolid);

    function IfcSweptDiskSolid(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam) {
      var _this1853;

      _classCallCheck2(this, IfcSweptDiskSolid);

      _this1853 = _super1861.call(this, expressID);
      _this1853.Directrix = Directrix;
      _this1853.Radius = Radius;
      _this1853.InnerRadius = InnerRadius;
      _this1853.StartParam = StartParam;
      _this1853.EndParam = EndParam;
      _this1853.type = 1260650574;
      return _this1853;
    }

    return IfcSweptDiskSolid;
  }(IfcSolidModel);

  IFC42.IfcSweptDiskSolid = IfcSweptDiskSolid;

  var IfcSweptDiskSolidPolygonal = /*#__PURE__*/function (_IfcSweptDiskSolid2) {
    _inherits(IfcSweptDiskSolidPolygonal, _IfcSweptDiskSolid2);

    var _super1862 = _createSuper(IfcSweptDiskSolidPolygonal);

    function IfcSweptDiskSolidPolygonal(expressID, Directrix, Radius, InnerRadius, StartParam, EndParam, FilletRadius) {
      var _this1854;

      _classCallCheck2(this, IfcSweptDiskSolidPolygonal);

      _this1854 = _super1862.call(this, expressID, Directrix, Radius, InnerRadius, StartParam, EndParam);
      _this1854.Directrix = Directrix;
      _this1854.Radius = Radius;
      _this1854.InnerRadius = InnerRadius;
      _this1854.StartParam = StartParam;
      _this1854.EndParam = EndParam;
      _this1854.FilletRadius = FilletRadius;
      _this1854.type = 1096409881;
      return _this1854;
    }

    return IfcSweptDiskSolidPolygonal;
  }(IfcSweptDiskSolid);

  IFC42.IfcSweptDiskSolidPolygonal = IfcSweptDiskSolidPolygonal;

  var IfcSweptSurface = /*#__PURE__*/function (_IfcSurface8) {
    _inherits(IfcSweptSurface, _IfcSurface8);

    var _super1863 = _createSuper(IfcSweptSurface);

    function IfcSweptSurface(expressID, SweptCurve, Position) {
      var _this1855;

      _classCallCheck2(this, IfcSweptSurface);

      _this1855 = _super1863.call(this, expressID);
      _this1855.SweptCurve = SweptCurve;
      _this1855.Position = Position;
      _this1855.type = 230924584;
      return _this1855;
    }

    return IfcSweptSurface;
  }(IfcSurface);

  IFC42.IfcSweptSurface = IfcSweptSurface;

  var IfcTShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf25) {
    _inherits(IfcTShapeProfileDef, _IfcParameterizedProf25);

    var _super1864 = _createSuper(IfcTShapeProfileDef);

    function IfcTShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, WebEdgeRadius, WebSlope, FlangeSlope) {
      var _this1856;

      _classCallCheck2(this, IfcTShapeProfileDef);

      _this1856 = _super1864.call(this, expressID, ProfileType, ProfileName, Position);
      _this1856.ProfileType = ProfileType;
      _this1856.ProfileName = ProfileName;
      _this1856.Position = Position;
      _this1856.Depth = Depth;
      _this1856.FlangeWidth = FlangeWidth;
      _this1856.WebThickness = WebThickness;
      _this1856.FlangeThickness = FlangeThickness;
      _this1856.FilletRadius = FilletRadius;
      _this1856.FlangeEdgeRadius = FlangeEdgeRadius;
      _this1856.WebEdgeRadius = WebEdgeRadius;
      _this1856.WebSlope = WebSlope;
      _this1856.FlangeSlope = FlangeSlope;
      _this1856.type = 3071757647;
      return _this1856;
    }

    return IfcTShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC42.IfcTShapeProfileDef = IfcTShapeProfileDef;

  var IfcTessellatedItem = /*#__PURE__*/function (_IfcGeometricRepresen67) {
    _inherits(IfcTessellatedItem, _IfcGeometricRepresen67);

    var _super1865 = _createSuper(IfcTessellatedItem);

    function IfcTessellatedItem(expressID) {
      var _this1857;

      _classCallCheck2(this, IfcTessellatedItem);

      _this1857 = _super1865.call(this, expressID);
      _this1857.type = 901063453;
      return _this1857;
    }

    return IfcTessellatedItem;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcTessellatedItem = IfcTessellatedItem;

  var IfcTextLiteral = /*#__PURE__*/function (_IfcGeometricRepresen68) {
    _inherits(IfcTextLiteral, _IfcGeometricRepresen68);

    var _super1866 = _createSuper(IfcTextLiteral);

    function IfcTextLiteral(expressID, Literal, Placement, Path) {
      var _this1858;

      _classCallCheck2(this, IfcTextLiteral);

      _this1858 = _super1866.call(this, expressID);
      _this1858.Literal = Literal;
      _this1858.Placement = Placement;
      _this1858.Path = Path;
      _this1858.type = 4282788508;
      return _this1858;
    }

    return IfcTextLiteral;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcTextLiteral = IfcTextLiteral;

  var IfcTextLiteralWithExtent = /*#__PURE__*/function (_IfcTextLiteral3) {
    _inherits(IfcTextLiteralWithExtent, _IfcTextLiteral3);

    var _super1867 = _createSuper(IfcTextLiteralWithExtent);

    function IfcTextLiteralWithExtent(expressID, Literal, Placement, Path, Extent, BoxAlignment) {
      var _this1859;

      _classCallCheck2(this, IfcTextLiteralWithExtent);

      _this1859 = _super1867.call(this, expressID, Literal, Placement, Path);
      _this1859.Literal = Literal;
      _this1859.Placement = Placement;
      _this1859.Path = Path;
      _this1859.Extent = Extent;
      _this1859.BoxAlignment = BoxAlignment;
      _this1859.type = 3124975700;
      return _this1859;
    }

    return IfcTextLiteralWithExtent;
  }(IfcTextLiteral);

  IFC42.IfcTextLiteralWithExtent = IfcTextLiteralWithExtent;

  var IfcTextStyleFontModel = /*#__PURE__*/function (_IfcPreDefinedTextFon4) {
    _inherits(IfcTextStyleFontModel, _IfcPreDefinedTextFon4);

    var _super1868 = _createSuper(IfcTextStyleFontModel);

    function IfcTextStyleFontModel(expressID, Name, FontFamily, FontStyle, FontVariant, FontWeight, FontSize) {
      var _this1860;

      _classCallCheck2(this, IfcTextStyleFontModel);

      _this1860 = _super1868.call(this, expressID, Name);
      _this1860.Name = Name;
      _this1860.FontFamily = FontFamily;
      _this1860.FontStyle = FontStyle;
      _this1860.FontVariant = FontVariant;
      _this1860.FontWeight = FontWeight;
      _this1860.FontSize = FontSize;
      _this1860.type = 1983826977;
      return _this1860;
    }

    return IfcTextStyleFontModel;
  }(IfcPreDefinedTextFont);

  IFC42.IfcTextStyleFontModel = IfcTextStyleFontModel;

  var IfcTrapeziumProfileDef = /*#__PURE__*/function (_IfcParameterizedProf26) {
    _inherits(IfcTrapeziumProfileDef, _IfcParameterizedProf26);

    var _super1869 = _createSuper(IfcTrapeziumProfileDef);

    function IfcTrapeziumProfileDef(expressID, ProfileType, ProfileName, Position, BottomXDim, TopXDim, YDim, TopXOffset) {
      var _this1861;

      _classCallCheck2(this, IfcTrapeziumProfileDef);

      _this1861 = _super1869.call(this, expressID, ProfileType, ProfileName, Position);
      _this1861.ProfileType = ProfileType;
      _this1861.ProfileName = ProfileName;
      _this1861.Position = Position;
      _this1861.BottomXDim = BottomXDim;
      _this1861.TopXDim = TopXDim;
      _this1861.YDim = YDim;
      _this1861.TopXOffset = TopXOffset;
      _this1861.type = 2715220739;
      return _this1861;
    }

    return IfcTrapeziumProfileDef;
  }(IfcParameterizedProfileDef);

  IFC42.IfcTrapeziumProfileDef = IfcTrapeziumProfileDef;

  var IfcTypeObject = /*#__PURE__*/function (_IfcObjectDefinition6) {
    _inherits(IfcTypeObject, _IfcObjectDefinition6);

    var _super1870 = _createSuper(IfcTypeObject);

    function IfcTypeObject(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets) {
      var _this1862;

      _classCallCheck2(this, IfcTypeObject);

      _this1862 = _super1870.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1862.GlobalId = GlobalId;
      _this1862.OwnerHistory = OwnerHistory;
      _this1862.Name = Name;
      _this1862.Description = Description;
      _this1862.ApplicableOccurrence = ApplicableOccurrence;
      _this1862.HasPropertySets = HasPropertySets;
      _this1862.type = 1628702193;
      return _this1862;
    }

    return IfcTypeObject;
  }(IfcObjectDefinition);

  IFC42.IfcTypeObject = IfcTypeObject;

  var IfcTypeProcess = /*#__PURE__*/function (_IfcTypeObject5) {
    _inherits(IfcTypeProcess, _IfcTypeObject5);

    var _super1871 = _createSuper(IfcTypeProcess);

    function IfcTypeProcess(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType) {
      var _this1863;

      _classCallCheck2(this, IfcTypeProcess);

      _this1863 = _super1871.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      _this1863.GlobalId = GlobalId;
      _this1863.OwnerHistory = OwnerHistory;
      _this1863.Name = Name;
      _this1863.Description = Description;
      _this1863.ApplicableOccurrence = ApplicableOccurrence;
      _this1863.HasPropertySets = HasPropertySets;
      _this1863.Identification = Identification;
      _this1863.LongDescription = LongDescription;
      _this1863.ProcessType = ProcessType;
      _this1863.type = 3736923433;
      return _this1863;
    }

    return IfcTypeProcess;
  }(IfcTypeObject);

  IFC42.IfcTypeProcess = IfcTypeProcess;

  var IfcTypeProduct = /*#__PURE__*/function (_IfcTypeObject6) {
    _inherits(IfcTypeProduct, _IfcTypeObject6);

    var _super1872 = _createSuper(IfcTypeProduct);

    function IfcTypeProduct(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag) {
      var _this1864;

      _classCallCheck2(this, IfcTypeProduct);

      _this1864 = _super1872.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      _this1864.GlobalId = GlobalId;
      _this1864.OwnerHistory = OwnerHistory;
      _this1864.Name = Name;
      _this1864.Description = Description;
      _this1864.ApplicableOccurrence = ApplicableOccurrence;
      _this1864.HasPropertySets = HasPropertySets;
      _this1864.RepresentationMaps = RepresentationMaps;
      _this1864.Tag = Tag;
      _this1864.type = 2347495698;
      return _this1864;
    }

    return IfcTypeProduct;
  }(IfcTypeObject);

  IFC42.IfcTypeProduct = IfcTypeProduct;

  var IfcTypeResource = /*#__PURE__*/function (_IfcTypeObject7) {
    _inherits(IfcTypeResource, _IfcTypeObject7);

    var _super1873 = _createSuper(IfcTypeResource);

    function IfcTypeResource(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType) {
      var _this1865;

      _classCallCheck2(this, IfcTypeResource);

      _this1865 = _super1873.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets);
      _this1865.GlobalId = GlobalId;
      _this1865.OwnerHistory = OwnerHistory;
      _this1865.Name = Name;
      _this1865.Description = Description;
      _this1865.ApplicableOccurrence = ApplicableOccurrence;
      _this1865.HasPropertySets = HasPropertySets;
      _this1865.Identification = Identification;
      _this1865.LongDescription = LongDescription;
      _this1865.ResourceType = ResourceType;
      _this1865.type = 3698973494;
      return _this1865;
    }

    return IfcTypeResource;
  }(IfcTypeObject);

  IFC42.IfcTypeResource = IfcTypeResource;

  var IfcUShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf27) {
    _inherits(IfcUShapeProfileDef, _IfcParameterizedProf27);

    var _super1874 = _createSuper(IfcUShapeProfileDef);

    function IfcUShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius, FlangeSlope) {
      var _this1866;

      _classCallCheck2(this, IfcUShapeProfileDef);

      _this1866 = _super1874.call(this, expressID, ProfileType, ProfileName, Position);
      _this1866.ProfileType = ProfileType;
      _this1866.ProfileName = ProfileName;
      _this1866.Position = Position;
      _this1866.Depth = Depth;
      _this1866.FlangeWidth = FlangeWidth;
      _this1866.WebThickness = WebThickness;
      _this1866.FlangeThickness = FlangeThickness;
      _this1866.FilletRadius = FilletRadius;
      _this1866.EdgeRadius = EdgeRadius;
      _this1866.FlangeSlope = FlangeSlope;
      _this1866.type = 427810014;
      return _this1866;
    }

    return IfcUShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC42.IfcUShapeProfileDef = IfcUShapeProfileDef;

  var IfcVector = /*#__PURE__*/function (_IfcGeometricRepresen69) {
    _inherits(IfcVector, _IfcGeometricRepresen69);

    var _super1875 = _createSuper(IfcVector);

    function IfcVector(expressID, Orientation, Magnitude) {
      var _this1867;

      _classCallCheck2(this, IfcVector);

      _this1867 = _super1875.call(this, expressID);
      _this1867.Orientation = Orientation;
      _this1867.Magnitude = Magnitude;
      _this1867.type = 1417489154;
      return _this1867;
    }

    return IfcVector;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcVector = IfcVector;

  var IfcVertexLoop = /*#__PURE__*/function (_IfcLoop8) {
    _inherits(IfcVertexLoop, _IfcLoop8);

    var _super1876 = _createSuper(IfcVertexLoop);

    function IfcVertexLoop(expressID, LoopVertex) {
      var _this1868;

      _classCallCheck2(this, IfcVertexLoop);

      _this1868 = _super1876.call(this, expressID);
      _this1868.LoopVertex = LoopVertex;
      _this1868.type = 2759199220;
      return _this1868;
    }

    return IfcVertexLoop;
  }(IfcLoop);

  IFC42.IfcVertexLoop = IfcVertexLoop;

  var IfcWindowStyle = /*#__PURE__*/function (_IfcTypeProduct6) {
    _inherits(IfcWindowStyle, _IfcTypeProduct6);

    var _super1877 = _createSuper(IfcWindowStyle);

    function IfcWindowStyle(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ConstructionType, OperationType, ParameterTakesPrecedence, Sizeable) {
      var _this1869;

      _classCallCheck2(this, IfcWindowStyle);

      _this1869 = _super1877.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      _this1869.GlobalId = GlobalId;
      _this1869.OwnerHistory = OwnerHistory;
      _this1869.Name = Name;
      _this1869.Description = Description;
      _this1869.ApplicableOccurrence = ApplicableOccurrence;
      _this1869.HasPropertySets = HasPropertySets;
      _this1869.RepresentationMaps = RepresentationMaps;
      _this1869.Tag = Tag;
      _this1869.ConstructionType = ConstructionType;
      _this1869.OperationType = OperationType;
      _this1869.ParameterTakesPrecedence = ParameterTakesPrecedence;
      _this1869.Sizeable = Sizeable;
      _this1869.type = 1299126871;
      return _this1869;
    }

    return IfcWindowStyle;
  }(IfcTypeProduct);

  IFC42.IfcWindowStyle = IfcWindowStyle;

  var IfcZShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf28) {
    _inherits(IfcZShapeProfileDef, _IfcParameterizedProf28);

    var _super1878 = _createSuper(IfcZShapeProfileDef);

    function IfcZShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, FlangeWidth, WebThickness, FlangeThickness, FilletRadius, EdgeRadius) {
      var _this1870;

      _classCallCheck2(this, IfcZShapeProfileDef);

      _this1870 = _super1878.call(this, expressID, ProfileType, ProfileName, Position);
      _this1870.ProfileType = ProfileType;
      _this1870.ProfileName = ProfileName;
      _this1870.Position = Position;
      _this1870.Depth = Depth;
      _this1870.FlangeWidth = FlangeWidth;
      _this1870.WebThickness = WebThickness;
      _this1870.FlangeThickness = FlangeThickness;
      _this1870.FilletRadius = FilletRadius;
      _this1870.EdgeRadius = EdgeRadius;
      _this1870.type = 2543172580;
      return _this1870;
    }

    return IfcZShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC42.IfcZShapeProfileDef = IfcZShapeProfileDef;

  var IfcAdvancedFace = /*#__PURE__*/function (_IfcFaceSurface2) {
    _inherits(IfcAdvancedFace, _IfcFaceSurface2);

    var _super1879 = _createSuper(IfcAdvancedFace);

    function IfcAdvancedFace(expressID, Bounds, FaceSurface, SameSense) {
      var _this1871;

      _classCallCheck2(this, IfcAdvancedFace);

      _this1871 = _super1879.call(this, expressID, Bounds, FaceSurface, SameSense);
      _this1871.Bounds = Bounds;
      _this1871.FaceSurface = FaceSurface;
      _this1871.SameSense = SameSense;
      _this1871.type = 3406155212;
      return _this1871;
    }

    return IfcAdvancedFace;
  }(IfcFaceSurface);

  IFC42.IfcAdvancedFace = IfcAdvancedFace;

  var IfcAnnotationFillArea = /*#__PURE__*/function (_IfcGeometricRepresen70) {
    _inherits(IfcAnnotationFillArea, _IfcGeometricRepresen70);

    var _super1880 = _createSuper(IfcAnnotationFillArea);

    function IfcAnnotationFillArea(expressID, OuterBoundary, InnerBoundaries) {
      var _this1872;

      _classCallCheck2(this, IfcAnnotationFillArea);

      _this1872 = _super1880.call(this, expressID);
      _this1872.OuterBoundary = OuterBoundary;
      _this1872.InnerBoundaries = InnerBoundaries;
      _this1872.type = 669184980;
      return _this1872;
    }

    return IfcAnnotationFillArea;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcAnnotationFillArea = IfcAnnotationFillArea;

  var IfcAsymmetricIShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf29) {
    _inherits(IfcAsymmetricIShapeProfileDef, _IfcParameterizedProf29);

    var _super1881 = _createSuper(IfcAsymmetricIShapeProfileDef);

    function IfcAsymmetricIShapeProfileDef(expressID, ProfileType, ProfileName, Position, BottomFlangeWidth, OverallDepth, WebThickness, BottomFlangeThickness, BottomFlangeFilletRadius, TopFlangeWidth, TopFlangeThickness, TopFlangeFilletRadius, BottomFlangeEdgeRadius, BottomFlangeSlope, TopFlangeEdgeRadius, TopFlangeSlope) {
      var _this1873;

      _classCallCheck2(this, IfcAsymmetricIShapeProfileDef);

      _this1873 = _super1881.call(this, expressID, ProfileType, ProfileName, Position);
      _this1873.ProfileType = ProfileType;
      _this1873.ProfileName = ProfileName;
      _this1873.Position = Position;
      _this1873.BottomFlangeWidth = BottomFlangeWidth;
      _this1873.OverallDepth = OverallDepth;
      _this1873.WebThickness = WebThickness;
      _this1873.BottomFlangeThickness = BottomFlangeThickness;
      _this1873.BottomFlangeFilletRadius = BottomFlangeFilletRadius;
      _this1873.TopFlangeWidth = TopFlangeWidth;
      _this1873.TopFlangeThickness = TopFlangeThickness;
      _this1873.TopFlangeFilletRadius = TopFlangeFilletRadius;
      _this1873.BottomFlangeEdgeRadius = BottomFlangeEdgeRadius;
      _this1873.BottomFlangeSlope = BottomFlangeSlope;
      _this1873.TopFlangeEdgeRadius = TopFlangeEdgeRadius;
      _this1873.TopFlangeSlope = TopFlangeSlope;
      _this1873.type = 3207858831;
      return _this1873;
    }

    return IfcAsymmetricIShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC42.IfcAsymmetricIShapeProfileDef = IfcAsymmetricIShapeProfileDef;

  var IfcAxis1Placement = /*#__PURE__*/function (_IfcPlacement8) {
    _inherits(IfcAxis1Placement, _IfcPlacement8);

    var _super1882 = _createSuper(IfcAxis1Placement);

    function IfcAxis1Placement(expressID, Location, Axis) {
      var _this1874;

      _classCallCheck2(this, IfcAxis1Placement);

      _this1874 = _super1882.call(this, expressID, Location);
      _this1874.Location = Location;
      _this1874.Axis = Axis;
      _this1874.type = 4261334040;
      return _this1874;
    }

    return IfcAxis1Placement;
  }(IfcPlacement);

  IFC42.IfcAxis1Placement = IfcAxis1Placement;

  var IfcAxis2Placement2D = /*#__PURE__*/function (_IfcPlacement9) {
    _inherits(IfcAxis2Placement2D, _IfcPlacement9);

    var _super1883 = _createSuper(IfcAxis2Placement2D);

    function IfcAxis2Placement2D(expressID, Location, RefDirection) {
      var _this1875;

      _classCallCheck2(this, IfcAxis2Placement2D);

      _this1875 = _super1883.call(this, expressID, Location);
      _this1875.Location = Location;
      _this1875.RefDirection = RefDirection;
      _this1875.type = 3125803723;
      return _this1875;
    }

    return IfcAxis2Placement2D;
  }(IfcPlacement);

  IFC42.IfcAxis2Placement2D = IfcAxis2Placement2D;

  var IfcAxis2Placement3D = /*#__PURE__*/function (_IfcPlacement10) {
    _inherits(IfcAxis2Placement3D, _IfcPlacement10);

    var _super1884 = _createSuper(IfcAxis2Placement3D);

    function IfcAxis2Placement3D(expressID, Location, Axis, RefDirection) {
      var _this1876;

      _classCallCheck2(this, IfcAxis2Placement3D);

      _this1876 = _super1884.call(this, expressID, Location);
      _this1876.Location = Location;
      _this1876.Axis = Axis;
      _this1876.RefDirection = RefDirection;
      _this1876.type = 2740243338;
      return _this1876;
    }

    return IfcAxis2Placement3D;
  }(IfcPlacement);

  IFC42.IfcAxis2Placement3D = IfcAxis2Placement3D;

  var IfcBooleanResult = /*#__PURE__*/function (_IfcGeometricRepresen71) {
    _inherits(IfcBooleanResult, _IfcGeometricRepresen71);

    var _super1885 = _createSuper(IfcBooleanResult);

    function IfcBooleanResult(expressID, Operator, FirstOperand, SecondOperand) {
      var _this1877;

      _classCallCheck2(this, IfcBooleanResult);

      _this1877 = _super1885.call(this, expressID);
      _this1877.Operator = Operator;
      _this1877.FirstOperand = FirstOperand;
      _this1877.SecondOperand = SecondOperand;
      _this1877.type = 2736907675;
      return _this1877;
    }

    return IfcBooleanResult;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcBooleanResult = IfcBooleanResult;

  var IfcBoundedSurface = /*#__PURE__*/function (_IfcSurface9) {
    _inherits(IfcBoundedSurface, _IfcSurface9);

    var _super1886 = _createSuper(IfcBoundedSurface);

    function IfcBoundedSurface(expressID) {
      var _this1878;

      _classCallCheck2(this, IfcBoundedSurface);

      _this1878 = _super1886.call(this, expressID);
      _this1878.type = 4182860854;
      return _this1878;
    }

    return IfcBoundedSurface;
  }(IfcSurface);

  IFC42.IfcBoundedSurface = IfcBoundedSurface;

  var IfcBoundingBox = /*#__PURE__*/function (_IfcGeometricRepresen72) {
    _inherits(IfcBoundingBox, _IfcGeometricRepresen72);

    var _super1887 = _createSuper(IfcBoundingBox);

    function IfcBoundingBox(expressID, Corner, XDim, YDim, ZDim) {
      var _this1879;

      _classCallCheck2(this, IfcBoundingBox);

      _this1879 = _super1887.call(this, expressID);
      _this1879.Corner = Corner;
      _this1879.XDim = XDim;
      _this1879.YDim = YDim;
      _this1879.ZDim = ZDim;
      _this1879.type = 2581212453;
      return _this1879;
    }

    return IfcBoundingBox;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcBoundingBox = IfcBoundingBox;

  var IfcBoxedHalfSpace = /*#__PURE__*/function (_IfcHalfSpaceSolid6) {
    _inherits(IfcBoxedHalfSpace, _IfcHalfSpaceSolid6);

    var _super1888 = _createSuper(IfcBoxedHalfSpace);

    function IfcBoxedHalfSpace(expressID, BaseSurface, AgreementFlag, Enclosure) {
      var _this1880;

      _classCallCheck2(this, IfcBoxedHalfSpace);

      _this1880 = _super1888.call(this, expressID, BaseSurface, AgreementFlag);
      _this1880.BaseSurface = BaseSurface;
      _this1880.AgreementFlag = AgreementFlag;
      _this1880.Enclosure = Enclosure;
      _this1880.type = 2713105998;
      return _this1880;
    }

    return IfcBoxedHalfSpace;
  }(IfcHalfSpaceSolid);

  IFC42.IfcBoxedHalfSpace = IfcBoxedHalfSpace;

  var IfcCShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf30) {
    _inherits(IfcCShapeProfileDef, _IfcParameterizedProf30);

    var _super1889 = _createSuper(IfcCShapeProfileDef);

    function IfcCShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, Width, WallThickness, Girth, InternalFilletRadius) {
      var _this1881;

      _classCallCheck2(this, IfcCShapeProfileDef);

      _this1881 = _super1889.call(this, expressID, ProfileType, ProfileName, Position);
      _this1881.ProfileType = ProfileType;
      _this1881.ProfileName = ProfileName;
      _this1881.Position = Position;
      _this1881.Depth = Depth;
      _this1881.Width = Width;
      _this1881.WallThickness = WallThickness;
      _this1881.Girth = Girth;
      _this1881.InternalFilletRadius = InternalFilletRadius;
      _this1881.type = 2898889636;
      return _this1881;
    }

    return IfcCShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC42.IfcCShapeProfileDef = IfcCShapeProfileDef;

  var IfcCartesianPoint = /*#__PURE__*/function (_IfcPoint10) {
    _inherits(IfcCartesianPoint, _IfcPoint10);

    var _super1890 = _createSuper(IfcCartesianPoint);

    function IfcCartesianPoint(expressID, Coordinates) {
      var _this1882;

      _classCallCheck2(this, IfcCartesianPoint);

      _this1882 = _super1890.call(this, expressID);
      _this1882.Coordinates = Coordinates;
      _this1882.type = 1123145078;
      return _this1882;
    }

    return IfcCartesianPoint;
  }(IfcPoint);

  IFC42.IfcCartesianPoint = IfcCartesianPoint;

  var IfcCartesianPointList = /*#__PURE__*/function (_IfcGeometricRepresen73) {
    _inherits(IfcCartesianPointList, _IfcGeometricRepresen73);

    var _super1891 = _createSuper(IfcCartesianPointList);

    function IfcCartesianPointList(expressID) {
      var _this1883;

      _classCallCheck2(this, IfcCartesianPointList);

      _this1883 = _super1891.call(this, expressID);
      _this1883.type = 574549367;
      return _this1883;
    }

    return IfcCartesianPointList;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcCartesianPointList = IfcCartesianPointList;

  var IfcCartesianPointList2D = /*#__PURE__*/function (_IfcCartesianPointLis3) {
    _inherits(IfcCartesianPointList2D, _IfcCartesianPointLis3);

    var _super1892 = _createSuper(IfcCartesianPointList2D);

    function IfcCartesianPointList2D(expressID, CoordList) {
      var _this1884;

      _classCallCheck2(this, IfcCartesianPointList2D);

      _this1884 = _super1892.call(this, expressID);
      _this1884.CoordList = CoordList;
      _this1884.type = 1675464909;
      return _this1884;
    }

    return IfcCartesianPointList2D;
  }(IfcCartesianPointList);

  IFC42.IfcCartesianPointList2D = IfcCartesianPointList2D;

  var IfcCartesianPointList3D = /*#__PURE__*/function (_IfcCartesianPointLis4) {
    _inherits(IfcCartesianPointList3D, _IfcCartesianPointLis4);

    var _super1893 = _createSuper(IfcCartesianPointList3D);

    function IfcCartesianPointList3D(expressID, CoordList) {
      var _this1885;

      _classCallCheck2(this, IfcCartesianPointList3D);

      _this1885 = _super1893.call(this, expressID);
      _this1885.CoordList = CoordList;
      _this1885.type = 2059837836;
      return _this1885;
    }

    return IfcCartesianPointList3D;
  }(IfcCartesianPointList);

  IFC42.IfcCartesianPointList3D = IfcCartesianPointList3D;

  var IfcCartesianTransformationOperator = /*#__PURE__*/function (_IfcGeometricRepresen74) {
    _inherits(IfcCartesianTransformationOperator, _IfcGeometricRepresen74);

    var _super1894 = _createSuper(IfcCartesianTransformationOperator);

    function IfcCartesianTransformationOperator(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      var _this1886;

      _classCallCheck2(this, IfcCartesianTransformationOperator);

      _this1886 = _super1894.call(this, expressID);
      _this1886.Axis1 = Axis1;
      _this1886.Axis2 = Axis2;
      _this1886.LocalOrigin = LocalOrigin;
      _this1886.Scale = Scale;
      _this1886.type = 59481748;
      return _this1886;
    }

    return IfcCartesianTransformationOperator;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcCartesianTransformationOperator = IfcCartesianTransformationOperator;

  var IfcCartesianTransformationOperator2D = /*#__PURE__*/function (_IfcCartesianTransfor9) {
    _inherits(IfcCartesianTransformationOperator2D, _IfcCartesianTransfor9);

    var _super1895 = _createSuper(IfcCartesianTransformationOperator2D);

    function IfcCartesianTransformationOperator2D(expressID, Axis1, Axis2, LocalOrigin, Scale) {
      var _this1887;

      _classCallCheck2(this, IfcCartesianTransformationOperator2D);

      _this1887 = _super1895.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale);
      _this1887.Axis1 = Axis1;
      _this1887.Axis2 = Axis2;
      _this1887.LocalOrigin = LocalOrigin;
      _this1887.Scale = Scale;
      _this1887.type = 3749851601;
      return _this1887;
    }

    return IfcCartesianTransformationOperator2D;
  }(IfcCartesianTransformationOperator);

  IFC42.IfcCartesianTransformationOperator2D = IfcCartesianTransformationOperator2D;

  var IfcCartesianTransformationOperator2DnonUniform = /*#__PURE__*/function (_IfcCartesianTransfor10) {
    _inherits(IfcCartesianTransformationOperator2DnonUniform, _IfcCartesianTransfor10);

    var _super1896 = _createSuper(IfcCartesianTransformationOperator2DnonUniform);

    function IfcCartesianTransformationOperator2DnonUniform(expressID, Axis1, Axis2, LocalOrigin, Scale, Scale2) {
      var _this1888;

      _classCallCheck2(this, IfcCartesianTransformationOperator2DnonUniform);

      _this1888 = _super1896.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale);
      _this1888.Axis1 = Axis1;
      _this1888.Axis2 = Axis2;
      _this1888.LocalOrigin = LocalOrigin;
      _this1888.Scale = Scale;
      _this1888.Scale2 = Scale2;
      _this1888.type = 3486308946;
      return _this1888;
    }

    return IfcCartesianTransformationOperator2DnonUniform;
  }(IfcCartesianTransformationOperator2D);

  IFC42.IfcCartesianTransformationOperator2DnonUniform = IfcCartesianTransformationOperator2DnonUniform;

  var IfcCartesianTransformationOperator3D = /*#__PURE__*/function (_IfcCartesianTransfor11) {
    _inherits(IfcCartesianTransformationOperator3D, _IfcCartesianTransfor11);

    var _super1897 = _createSuper(IfcCartesianTransformationOperator3D);

    function IfcCartesianTransformationOperator3D(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3) {
      var _this1889;

      _classCallCheck2(this, IfcCartesianTransformationOperator3D);

      _this1889 = _super1897.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale);
      _this1889.Axis1 = Axis1;
      _this1889.Axis2 = Axis2;
      _this1889.LocalOrigin = LocalOrigin;
      _this1889.Scale = Scale;
      _this1889.Axis3 = Axis3;
      _this1889.type = 3331915920;
      return _this1889;
    }

    return IfcCartesianTransformationOperator3D;
  }(IfcCartesianTransformationOperator);

  IFC42.IfcCartesianTransformationOperator3D = IfcCartesianTransformationOperator3D;

  var IfcCartesianTransformationOperator3DnonUniform = /*#__PURE__*/function (_IfcCartesianTransfor12) {
    _inherits(IfcCartesianTransformationOperator3DnonUniform, _IfcCartesianTransfor12);

    var _super1898 = _createSuper(IfcCartesianTransformationOperator3DnonUniform);

    function IfcCartesianTransformationOperator3DnonUniform(expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3, Scale2, Scale3) {
      var _this1890;

      _classCallCheck2(this, IfcCartesianTransformationOperator3DnonUniform);

      _this1890 = _super1898.call(this, expressID, Axis1, Axis2, LocalOrigin, Scale, Axis3);
      _this1890.Axis1 = Axis1;
      _this1890.Axis2 = Axis2;
      _this1890.LocalOrigin = LocalOrigin;
      _this1890.Scale = Scale;
      _this1890.Axis3 = Axis3;
      _this1890.Scale2 = Scale2;
      _this1890.Scale3 = Scale3;
      _this1890.type = 1416205885;
      return _this1890;
    }

    return IfcCartesianTransformationOperator3DnonUniform;
  }(IfcCartesianTransformationOperator3D);

  IFC42.IfcCartesianTransformationOperator3DnonUniform = IfcCartesianTransformationOperator3DnonUniform;

  var IfcCircleProfileDef = /*#__PURE__*/function (_IfcParameterizedProf31) {
    _inherits(IfcCircleProfileDef, _IfcParameterizedProf31);

    var _super1899 = _createSuper(IfcCircleProfileDef);

    function IfcCircleProfileDef(expressID, ProfileType, ProfileName, Position, Radius) {
      var _this1891;

      _classCallCheck2(this, IfcCircleProfileDef);

      _this1891 = _super1899.call(this, expressID, ProfileType, ProfileName, Position);
      _this1891.ProfileType = ProfileType;
      _this1891.ProfileName = ProfileName;
      _this1891.Position = Position;
      _this1891.Radius = Radius;
      _this1891.type = 1383045692;
      return _this1891;
    }

    return IfcCircleProfileDef;
  }(IfcParameterizedProfileDef);

  IFC42.IfcCircleProfileDef = IfcCircleProfileDef;

  var IfcClosedShell = /*#__PURE__*/function (_IfcConnectedFaceSet6) {
    _inherits(IfcClosedShell, _IfcConnectedFaceSet6);

    var _super1900 = _createSuper(IfcClosedShell);

    function IfcClosedShell(expressID, CfsFaces) {
      var _this1892;

      _classCallCheck2(this, IfcClosedShell);

      _this1892 = _super1900.call(this, expressID, CfsFaces);
      _this1892.CfsFaces = CfsFaces;
      _this1892.type = 2205249479;
      return _this1892;
    }

    return IfcClosedShell;
  }(IfcConnectedFaceSet);

  IFC42.IfcClosedShell = IfcClosedShell;

  var IfcColourRgb = /*#__PURE__*/function (_IfcColourSpecificati3) {
    _inherits(IfcColourRgb, _IfcColourSpecificati3);

    var _super1901 = _createSuper(IfcColourRgb);

    function IfcColourRgb(expressID, Name, Red, Green, Blue) {
      var _this1893;

      _classCallCheck2(this, IfcColourRgb);

      _this1893 = _super1901.call(this, expressID, Name);
      _this1893.Name = Name;
      _this1893.Red = Red;
      _this1893.Green = Green;
      _this1893.Blue = Blue;
      _this1893.type = 776857604;
      return _this1893;
    }

    return IfcColourRgb;
  }(IfcColourSpecification);

  IFC42.IfcColourRgb = IfcColourRgb;

  var IfcComplexProperty = /*#__PURE__*/function (_IfcProperty6) {
    _inherits(IfcComplexProperty, _IfcProperty6);

    var _super1902 = _createSuper(IfcComplexProperty);

    function IfcComplexProperty(expressID, Name, Description, UsageName, HasProperties) {
      var _this1894;

      _classCallCheck2(this, IfcComplexProperty);

      _this1894 = _super1902.call(this, expressID, Name, Description);
      _this1894.Name = Name;
      _this1894.Description = Description;
      _this1894.UsageName = UsageName;
      _this1894.HasProperties = HasProperties;
      _this1894.type = 2542286263;
      return _this1894;
    }

    return IfcComplexProperty;
  }(IfcProperty);

  IFC42.IfcComplexProperty = IfcComplexProperty;

  var IfcCompositeCurveSegment = /*#__PURE__*/function (_IfcGeometricRepresen75) {
    _inherits(IfcCompositeCurveSegment, _IfcGeometricRepresen75);

    var _super1903 = _createSuper(IfcCompositeCurveSegment);

    function IfcCompositeCurveSegment(expressID, Transition, SameSense, ParentCurve) {
      var _this1895;

      _classCallCheck2(this, IfcCompositeCurveSegment);

      _this1895 = _super1903.call(this, expressID);
      _this1895.Transition = Transition;
      _this1895.SameSense = SameSense;
      _this1895.ParentCurve = ParentCurve;
      _this1895.type = 2485617015;
      return _this1895;
    }

    return IfcCompositeCurveSegment;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcCompositeCurveSegment = IfcCompositeCurveSegment;

  var IfcConstructionResourceType = /*#__PURE__*/function (_IfcTypeResource2) {
    _inherits(IfcConstructionResourceType, _IfcTypeResource2);

    var _super1904 = _createSuper(IfcConstructionResourceType);

    function IfcConstructionResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity) {
      var _this1896;

      _classCallCheck2(this, IfcConstructionResourceType);

      _this1896 = _super1904.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType);
      _this1896.GlobalId = GlobalId;
      _this1896.OwnerHistory = OwnerHistory;
      _this1896.Name = Name;
      _this1896.Description = Description;
      _this1896.ApplicableOccurrence = ApplicableOccurrence;
      _this1896.HasPropertySets = HasPropertySets;
      _this1896.Identification = Identification;
      _this1896.LongDescription = LongDescription;
      _this1896.ResourceType = ResourceType;
      _this1896.BaseCosts = BaseCosts;
      _this1896.BaseQuantity = BaseQuantity;
      _this1896.type = 2574617495;
      return _this1896;
    }

    return IfcConstructionResourceType;
  }(IfcTypeResource);

  IFC42.IfcConstructionResourceType = IfcConstructionResourceType;

  var IfcContext = /*#__PURE__*/function (_IfcObjectDefinition7) {
    _inherits(IfcContext, _IfcObjectDefinition7);

    var _super1905 = _createSuper(IfcContext);

    function IfcContext(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      var _this1897;

      _classCallCheck2(this, IfcContext);

      _this1897 = _super1905.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1897.GlobalId = GlobalId;
      _this1897.OwnerHistory = OwnerHistory;
      _this1897.Name = Name;
      _this1897.Description = Description;
      _this1897.ObjectType = ObjectType;
      _this1897.LongName = LongName;
      _this1897.Phase = Phase;
      _this1897.RepresentationContexts = RepresentationContexts;
      _this1897.UnitsInContext = UnitsInContext;
      _this1897.type = 3419103109;
      return _this1897;
    }

    return IfcContext;
  }(IfcObjectDefinition);

  IFC42.IfcContext = IfcContext;

  var IfcCrewResourceType = /*#__PURE__*/function (_IfcConstructionResou19) {
    _inherits(IfcCrewResourceType, _IfcConstructionResou19);

    var _super1906 = _createSuper(IfcCrewResourceType);

    function IfcCrewResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1898;

      _classCallCheck2(this, IfcCrewResourceType);

      _this1898 = _super1906.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this1898.GlobalId = GlobalId;
      _this1898.OwnerHistory = OwnerHistory;
      _this1898.Name = Name;
      _this1898.Description = Description;
      _this1898.ApplicableOccurrence = ApplicableOccurrence;
      _this1898.HasPropertySets = HasPropertySets;
      _this1898.Identification = Identification;
      _this1898.LongDescription = LongDescription;
      _this1898.ResourceType = ResourceType;
      _this1898.BaseCosts = BaseCosts;
      _this1898.BaseQuantity = BaseQuantity;
      _this1898.PredefinedType = PredefinedType;
      _this1898.type = 1815067380;
      return _this1898;
    }

    return IfcCrewResourceType;
  }(IfcConstructionResourceType);

  IFC42.IfcCrewResourceType = IfcCrewResourceType;

  var IfcCsgPrimitive3D = /*#__PURE__*/function (_IfcGeometricRepresen76) {
    _inherits(IfcCsgPrimitive3D, _IfcGeometricRepresen76);

    var _super1907 = _createSuper(IfcCsgPrimitive3D);

    function IfcCsgPrimitive3D(expressID, Position) {
      var _this1899;

      _classCallCheck2(this, IfcCsgPrimitive3D);

      _this1899 = _super1907.call(this, expressID);
      _this1899.Position = Position;
      _this1899.type = 2506170314;
      return _this1899;
    }

    return IfcCsgPrimitive3D;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcCsgPrimitive3D = IfcCsgPrimitive3D;

  var IfcCsgSolid = /*#__PURE__*/function (_IfcSolidModel12) {
    _inherits(IfcCsgSolid, _IfcSolidModel12);

    var _super1908 = _createSuper(IfcCsgSolid);

    function IfcCsgSolid(expressID, TreeRootExpression) {
      var _this1900;

      _classCallCheck2(this, IfcCsgSolid);

      _this1900 = _super1908.call(this, expressID);
      _this1900.TreeRootExpression = TreeRootExpression;
      _this1900.type = 2147822146;
      return _this1900;
    }

    return IfcCsgSolid;
  }(IfcSolidModel);

  IFC42.IfcCsgSolid = IfcCsgSolid;

  var IfcCurve = /*#__PURE__*/function (_IfcGeometricRepresen77) {
    _inherits(IfcCurve, _IfcGeometricRepresen77);

    var _super1909 = _createSuper(IfcCurve);

    function IfcCurve(expressID) {
      var _this1901;

      _classCallCheck2(this, IfcCurve);

      _this1901 = _super1909.call(this, expressID);
      _this1901.type = 2601014836;
      return _this1901;
    }

    return IfcCurve;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcCurve = IfcCurve;

  var IfcCurveBoundedPlane = /*#__PURE__*/function (_IfcBoundedSurface7) {
    _inherits(IfcCurveBoundedPlane, _IfcBoundedSurface7);

    var _super1910 = _createSuper(IfcCurveBoundedPlane);

    function IfcCurveBoundedPlane(expressID, BasisSurface, OuterBoundary, InnerBoundaries) {
      var _this1902;

      _classCallCheck2(this, IfcCurveBoundedPlane);

      _this1902 = _super1910.call(this, expressID);
      _this1902.BasisSurface = BasisSurface;
      _this1902.OuterBoundary = OuterBoundary;
      _this1902.InnerBoundaries = InnerBoundaries;
      _this1902.type = 2827736869;
      return _this1902;
    }

    return IfcCurveBoundedPlane;
  }(IfcBoundedSurface);

  IFC42.IfcCurveBoundedPlane = IfcCurveBoundedPlane;

  var IfcCurveBoundedSurface = /*#__PURE__*/function (_IfcBoundedSurface8) {
    _inherits(IfcCurveBoundedSurface, _IfcBoundedSurface8);

    var _super1911 = _createSuper(IfcCurveBoundedSurface);

    function IfcCurveBoundedSurface(expressID, BasisSurface, Boundaries, ImplicitOuter) {
      var _this1903;

      _classCallCheck2(this, IfcCurveBoundedSurface);

      _this1903 = _super1911.call(this, expressID);
      _this1903.BasisSurface = BasisSurface;
      _this1903.Boundaries = Boundaries;
      _this1903.ImplicitOuter = ImplicitOuter;
      _this1903.type = 2629017746;
      return _this1903;
    }

    return IfcCurveBoundedSurface;
  }(IfcBoundedSurface);

  IFC42.IfcCurveBoundedSurface = IfcCurveBoundedSurface;

  var IfcDirection = /*#__PURE__*/function (_IfcGeometricRepresen78) {
    _inherits(IfcDirection, _IfcGeometricRepresen78);

    var _super1912 = _createSuper(IfcDirection);

    function IfcDirection(expressID, DirectionRatios) {
      var _this1904;

      _classCallCheck2(this, IfcDirection);

      _this1904 = _super1912.call(this, expressID);
      _this1904.DirectionRatios = DirectionRatios;
      _this1904.type = 32440307;
      return _this1904;
    }

    return IfcDirection;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcDirection = IfcDirection;

  var IfcDoorStyle = /*#__PURE__*/function (_IfcTypeProduct7) {
    _inherits(IfcDoorStyle, _IfcTypeProduct7);

    var _super1913 = _createSuper(IfcDoorStyle);

    function IfcDoorStyle(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, OperationType, ConstructionType, ParameterTakesPrecedence, Sizeable) {
      var _this1905;

      _classCallCheck2(this, IfcDoorStyle);

      _this1905 = _super1913.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      _this1905.GlobalId = GlobalId;
      _this1905.OwnerHistory = OwnerHistory;
      _this1905.Name = Name;
      _this1905.Description = Description;
      _this1905.ApplicableOccurrence = ApplicableOccurrence;
      _this1905.HasPropertySets = HasPropertySets;
      _this1905.RepresentationMaps = RepresentationMaps;
      _this1905.Tag = Tag;
      _this1905.OperationType = OperationType;
      _this1905.ConstructionType = ConstructionType;
      _this1905.ParameterTakesPrecedence = ParameterTakesPrecedence;
      _this1905.Sizeable = Sizeable;
      _this1905.type = 526551008;
      return _this1905;
    }

    return IfcDoorStyle;
  }(IfcTypeProduct);

  IFC42.IfcDoorStyle = IfcDoorStyle;

  var IfcEdgeLoop = /*#__PURE__*/function (_IfcLoop9) {
    _inherits(IfcEdgeLoop, _IfcLoop9);

    var _super1914 = _createSuper(IfcEdgeLoop);

    function IfcEdgeLoop(expressID, EdgeList) {
      var _this1906;

      _classCallCheck2(this, IfcEdgeLoop);

      _this1906 = _super1914.call(this, expressID);
      _this1906.EdgeList = EdgeList;
      _this1906.type = 1472233963;
      return _this1906;
    }

    return IfcEdgeLoop;
  }(IfcLoop);

  IFC42.IfcEdgeLoop = IfcEdgeLoop;

  var IfcElementQuantity = /*#__PURE__*/function (_IfcQuantitySet2) {
    _inherits(IfcElementQuantity, _IfcQuantitySet2);

    var _super1915 = _createSuper(IfcElementQuantity);

    function IfcElementQuantity(expressID, GlobalId, OwnerHistory, Name, Description, MethodOfMeasurement, Quantities) {
      var _this1907;

      _classCallCheck2(this, IfcElementQuantity);

      _this1907 = _super1915.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1907.GlobalId = GlobalId;
      _this1907.OwnerHistory = OwnerHistory;
      _this1907.Name = Name;
      _this1907.Description = Description;
      _this1907.MethodOfMeasurement = MethodOfMeasurement;
      _this1907.Quantities = Quantities;
      _this1907.type = 1883228015;
      return _this1907;
    }

    return IfcElementQuantity;
  }(IfcQuantitySet);

  IFC42.IfcElementQuantity = IfcElementQuantity;

  var IfcElementType = /*#__PURE__*/function (_IfcTypeProduct8) {
    _inherits(IfcElementType, _IfcTypeProduct8);

    var _super1916 = _createSuper(IfcElementType);

    function IfcElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1908;

      _classCallCheck2(this, IfcElementType);

      _this1908 = _super1916.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      _this1908.GlobalId = GlobalId;
      _this1908.OwnerHistory = OwnerHistory;
      _this1908.Name = Name;
      _this1908.Description = Description;
      _this1908.ApplicableOccurrence = ApplicableOccurrence;
      _this1908.HasPropertySets = HasPropertySets;
      _this1908.RepresentationMaps = RepresentationMaps;
      _this1908.Tag = Tag;
      _this1908.ElementType = ElementType;
      _this1908.type = 339256511;
      return _this1908;
    }

    return IfcElementType;
  }(IfcTypeProduct);

  IFC42.IfcElementType = IfcElementType;

  var IfcElementarySurface = /*#__PURE__*/function (_IfcSurface10) {
    _inherits(IfcElementarySurface, _IfcSurface10);

    var _super1917 = _createSuper(IfcElementarySurface);

    function IfcElementarySurface(expressID, Position) {
      var _this1909;

      _classCallCheck2(this, IfcElementarySurface);

      _this1909 = _super1917.call(this, expressID);
      _this1909.Position = Position;
      _this1909.type = 2777663545;
      return _this1909;
    }

    return IfcElementarySurface;
  }(IfcSurface);

  IFC42.IfcElementarySurface = IfcElementarySurface;

  var IfcEllipseProfileDef = /*#__PURE__*/function (_IfcParameterizedProf32) {
    _inherits(IfcEllipseProfileDef, _IfcParameterizedProf32);

    var _super1918 = _createSuper(IfcEllipseProfileDef);

    function IfcEllipseProfileDef(expressID, ProfileType, ProfileName, Position, SemiAxis1, SemiAxis2) {
      var _this1910;

      _classCallCheck2(this, IfcEllipseProfileDef);

      _this1910 = _super1918.call(this, expressID, ProfileType, ProfileName, Position);
      _this1910.ProfileType = ProfileType;
      _this1910.ProfileName = ProfileName;
      _this1910.Position = Position;
      _this1910.SemiAxis1 = SemiAxis1;
      _this1910.SemiAxis2 = SemiAxis2;
      _this1910.type = 2835456948;
      return _this1910;
    }

    return IfcEllipseProfileDef;
  }(IfcParameterizedProfileDef);

  IFC42.IfcEllipseProfileDef = IfcEllipseProfileDef;

  var IfcEventType = /*#__PURE__*/function (_IfcTypeProcess4) {
    _inherits(IfcEventType, _IfcTypeProcess4);

    var _super1919 = _createSuper(IfcEventType);

    function IfcEventType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, EventTriggerType, UserDefinedEventTriggerType) {
      var _this1911;

      _classCallCheck2(this, IfcEventType);

      _this1911 = _super1919.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      _this1911.GlobalId = GlobalId;
      _this1911.OwnerHistory = OwnerHistory;
      _this1911.Name = Name;
      _this1911.Description = Description;
      _this1911.ApplicableOccurrence = ApplicableOccurrence;
      _this1911.HasPropertySets = HasPropertySets;
      _this1911.Identification = Identification;
      _this1911.LongDescription = LongDescription;
      _this1911.ProcessType = ProcessType;
      _this1911.PredefinedType = PredefinedType;
      _this1911.EventTriggerType = EventTriggerType;
      _this1911.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      _this1911.type = 4024345920;
      return _this1911;
    }

    return IfcEventType;
  }(IfcTypeProcess);

  IFC42.IfcEventType = IfcEventType;

  var IfcExtrudedAreaSolid = /*#__PURE__*/function (_IfcSweptAreaSolid7) {
    _inherits(IfcExtrudedAreaSolid, _IfcSweptAreaSolid7);

    var _super1920 = _createSuper(IfcExtrudedAreaSolid);

    function IfcExtrudedAreaSolid(expressID, SweptArea, Position, ExtrudedDirection, Depth) {
      var _this1912;

      _classCallCheck2(this, IfcExtrudedAreaSolid);

      _this1912 = _super1920.call(this, expressID, SweptArea, Position);
      _this1912.SweptArea = SweptArea;
      _this1912.Position = Position;
      _this1912.ExtrudedDirection = ExtrudedDirection;
      _this1912.Depth = Depth;
      _this1912.type = 477187591;
      return _this1912;
    }

    return IfcExtrudedAreaSolid;
  }(IfcSweptAreaSolid);

  IFC42.IfcExtrudedAreaSolid = IfcExtrudedAreaSolid;

  var IfcExtrudedAreaSolidTapered = /*#__PURE__*/function (_IfcExtrudedAreaSolid2) {
    _inherits(IfcExtrudedAreaSolidTapered, _IfcExtrudedAreaSolid2);

    var _super1921 = _createSuper(IfcExtrudedAreaSolidTapered);

    function IfcExtrudedAreaSolidTapered(expressID, SweptArea, Position, ExtrudedDirection, Depth, EndSweptArea) {
      var _this1913;

      _classCallCheck2(this, IfcExtrudedAreaSolidTapered);

      _this1913 = _super1921.call(this, expressID, SweptArea, Position, ExtrudedDirection, Depth);
      _this1913.SweptArea = SweptArea;
      _this1913.Position = Position;
      _this1913.ExtrudedDirection = ExtrudedDirection;
      _this1913.Depth = Depth;
      _this1913.EndSweptArea = EndSweptArea;
      _this1913.type = 2804161546;
      return _this1913;
    }

    return IfcExtrudedAreaSolidTapered;
  }(IfcExtrudedAreaSolid);

  IFC42.IfcExtrudedAreaSolidTapered = IfcExtrudedAreaSolidTapered;

  var IfcFaceBasedSurfaceModel = /*#__PURE__*/function (_IfcGeometricRepresen79) {
    _inherits(IfcFaceBasedSurfaceModel, _IfcGeometricRepresen79);

    var _super1922 = _createSuper(IfcFaceBasedSurfaceModel);

    function IfcFaceBasedSurfaceModel(expressID, FbsmFaces) {
      var _this1914;

      _classCallCheck2(this, IfcFaceBasedSurfaceModel);

      _this1914 = _super1922.call(this, expressID);
      _this1914.FbsmFaces = FbsmFaces;
      _this1914.type = 2047409740;
      return _this1914;
    }

    return IfcFaceBasedSurfaceModel;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcFaceBasedSurfaceModel = IfcFaceBasedSurfaceModel;

  var IfcFillAreaStyleHatching = /*#__PURE__*/function (_IfcGeometricRepresen80) {
    _inherits(IfcFillAreaStyleHatching, _IfcGeometricRepresen80);

    var _super1923 = _createSuper(IfcFillAreaStyleHatching);

    function IfcFillAreaStyleHatching(expressID, HatchLineAppearance, StartOfNextHatchLine, PointOfReferenceHatchLine, PatternStart, HatchLineAngle) {
      var _this1915;

      _classCallCheck2(this, IfcFillAreaStyleHatching);

      _this1915 = _super1923.call(this, expressID);
      _this1915.HatchLineAppearance = HatchLineAppearance;
      _this1915.StartOfNextHatchLine = StartOfNextHatchLine;
      _this1915.PointOfReferenceHatchLine = PointOfReferenceHatchLine;
      _this1915.PatternStart = PatternStart;
      _this1915.HatchLineAngle = HatchLineAngle;
      _this1915.type = 374418227;
      return _this1915;
    }

    return IfcFillAreaStyleHatching;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcFillAreaStyleHatching = IfcFillAreaStyleHatching;

  var IfcFillAreaStyleTiles = /*#__PURE__*/function (_IfcGeometricRepresen81) {
    _inherits(IfcFillAreaStyleTiles, _IfcGeometricRepresen81);

    var _super1924 = _createSuper(IfcFillAreaStyleTiles);

    function IfcFillAreaStyleTiles(expressID, TilingPattern, Tiles, TilingScale) {
      var _this1916;

      _classCallCheck2(this, IfcFillAreaStyleTiles);

      _this1916 = _super1924.call(this, expressID);
      _this1916.TilingPattern = TilingPattern;
      _this1916.Tiles = Tiles;
      _this1916.TilingScale = TilingScale;
      _this1916.type = 315944413;
      return _this1916;
    }

    return IfcFillAreaStyleTiles;
  }(IfcGeometricRepresentationItem);

  IFC42.IfcFillAreaStyleTiles = IfcFillAreaStyleTiles;

  var IfcFixedReferenceSweptAreaSolid = /*#__PURE__*/function (_IfcSweptAreaSolid8) {
    _inherits(IfcFixedReferenceSweptAreaSolid, _IfcSweptAreaSolid8);

    var _super1925 = _createSuper(IfcFixedReferenceSweptAreaSolid);

    function IfcFixedReferenceSweptAreaSolid(expressID, SweptArea, Position, Directrix, StartParam, EndParam, FixedReference) {
      var _this1917;

      _classCallCheck2(this, IfcFixedReferenceSweptAreaSolid);

      _this1917 = _super1925.call(this, expressID, SweptArea, Position);
      _this1917.SweptArea = SweptArea;
      _this1917.Position = Position;
      _this1917.Directrix = Directrix;
      _this1917.StartParam = StartParam;
      _this1917.EndParam = EndParam;
      _this1917.FixedReference = FixedReference;
      _this1917.type = 2652556860;
      return _this1917;
    }

    return IfcFixedReferenceSweptAreaSolid;
  }(IfcSweptAreaSolid);

  IFC42.IfcFixedReferenceSweptAreaSolid = IfcFixedReferenceSweptAreaSolid;

  var IfcFurnishingElementType = /*#__PURE__*/function (_IfcElementType15) {
    _inherits(IfcFurnishingElementType, _IfcElementType15);

    var _super1926 = _createSuper(IfcFurnishingElementType);

    function IfcFurnishingElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this1918;

      _classCallCheck2(this, IfcFurnishingElementType);

      _this1918 = _super1926.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1918.GlobalId = GlobalId;
      _this1918.OwnerHistory = OwnerHistory;
      _this1918.Name = Name;
      _this1918.Description = Description;
      _this1918.ApplicableOccurrence = ApplicableOccurrence;
      _this1918.HasPropertySets = HasPropertySets;
      _this1918.RepresentationMaps = RepresentationMaps;
      _this1918.Tag = Tag;
      _this1918.ElementType = ElementType;
      _this1918.type = 4238390223;
      return _this1918;
    }

    return IfcFurnishingElementType;
  }(IfcElementType);

  IFC42.IfcFurnishingElementType = IfcFurnishingElementType;

  var IfcFurnitureType = /*#__PURE__*/function (_IfcFurnishingElement7) {
    _inherits(IfcFurnitureType, _IfcFurnishingElement7);

    var _super1927 = _createSuper(IfcFurnitureType);

    function IfcFurnitureType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, AssemblyPlace, PredefinedType) {
      var _this1919;

      _classCallCheck2(this, IfcFurnitureType);

      _this1919 = _super1927.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1919.GlobalId = GlobalId;
      _this1919.OwnerHistory = OwnerHistory;
      _this1919.Name = Name;
      _this1919.Description = Description;
      _this1919.ApplicableOccurrence = ApplicableOccurrence;
      _this1919.HasPropertySets = HasPropertySets;
      _this1919.RepresentationMaps = RepresentationMaps;
      _this1919.Tag = Tag;
      _this1919.ElementType = ElementType;
      _this1919.AssemblyPlace = AssemblyPlace;
      _this1919.PredefinedType = PredefinedType;
      _this1919.type = 1268542332;
      return _this1919;
    }

    return IfcFurnitureType;
  }(IfcFurnishingElementType);

  IFC42.IfcFurnitureType = IfcFurnitureType;

  var IfcGeographicElementType = /*#__PURE__*/function (_IfcElementType16) {
    _inherits(IfcGeographicElementType, _IfcElementType16);

    var _super1928 = _createSuper(IfcGeographicElementType);

    function IfcGeographicElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this1920;

      _classCallCheck2(this, IfcGeographicElementType);

      _this1920 = _super1928.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this1920.GlobalId = GlobalId;
      _this1920.OwnerHistory = OwnerHistory;
      _this1920.Name = Name;
      _this1920.Description = Description;
      _this1920.ApplicableOccurrence = ApplicableOccurrence;
      _this1920.HasPropertySets = HasPropertySets;
      _this1920.RepresentationMaps = RepresentationMaps;
      _this1920.Tag = Tag;
      _this1920.ElementType = ElementType;
      _this1920.PredefinedType = PredefinedType;
      _this1920.type = 4095422895;
      return _this1920;
    }

    return IfcGeographicElementType;
  }(IfcElementType);

  IFC42.IfcGeographicElementType = IfcGeographicElementType;

  var IfcGeometricCurveSet = /*#__PURE__*/function (_IfcGeometricSet3) {
    _inherits(IfcGeometricCurveSet, _IfcGeometricSet3);

    var _super1929 = _createSuper(IfcGeometricCurveSet);

    function IfcGeometricCurveSet(expressID, Elements) {
      var _this1921;

      _classCallCheck2(this, IfcGeometricCurveSet);

      _this1921 = _super1929.call(this, expressID, Elements);
      _this1921.Elements = Elements;
      _this1921.type = 987898635;
      return _this1921;
    }

    return IfcGeometricCurveSet;
  }(IfcGeometricSet);

  IFC42.IfcGeometricCurveSet = IfcGeometricCurveSet;

  var IfcIShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf33) {
    _inherits(IfcIShapeProfileDef, _IfcParameterizedProf33);

    var _super1930 = _createSuper(IfcIShapeProfileDef);

    function IfcIShapeProfileDef(expressID, ProfileType, ProfileName, Position, OverallWidth, OverallDepth, WebThickness, FlangeThickness, FilletRadius, FlangeEdgeRadius, FlangeSlope) {
      var _this1922;

      _classCallCheck2(this, IfcIShapeProfileDef);

      _this1922 = _super1930.call(this, expressID, ProfileType, ProfileName, Position);
      _this1922.ProfileType = ProfileType;
      _this1922.ProfileName = ProfileName;
      _this1922.Position = Position;
      _this1922.OverallWidth = OverallWidth;
      _this1922.OverallDepth = OverallDepth;
      _this1922.WebThickness = WebThickness;
      _this1922.FlangeThickness = FlangeThickness;
      _this1922.FilletRadius = FilletRadius;
      _this1922.FlangeEdgeRadius = FlangeEdgeRadius;
      _this1922.FlangeSlope = FlangeSlope;
      _this1922.type = 1484403080;
      return _this1922;
    }

    return IfcIShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC42.IfcIShapeProfileDef = IfcIShapeProfileDef;

  var IfcIndexedPolygonalFace = /*#__PURE__*/function (_IfcTessellatedItem3) {
    _inherits(IfcIndexedPolygonalFace, _IfcTessellatedItem3);

    var _super1931 = _createSuper(IfcIndexedPolygonalFace);

    function IfcIndexedPolygonalFace(expressID, CoordIndex) {
      var _this1923;

      _classCallCheck2(this, IfcIndexedPolygonalFace);

      _this1923 = _super1931.call(this, expressID);
      _this1923.CoordIndex = CoordIndex;
      _this1923.type = 178912537;
      return _this1923;
    }

    return IfcIndexedPolygonalFace;
  }(IfcTessellatedItem);

  IFC42.IfcIndexedPolygonalFace = IfcIndexedPolygonalFace;

  var IfcIndexedPolygonalFaceWithVoids = /*#__PURE__*/function (_IfcIndexedPolygonalF2) {
    _inherits(IfcIndexedPolygonalFaceWithVoids, _IfcIndexedPolygonalF2);

    var _super1932 = _createSuper(IfcIndexedPolygonalFaceWithVoids);

    function IfcIndexedPolygonalFaceWithVoids(expressID, CoordIndex, InnerCoordIndices) {
      var _this1924;

      _classCallCheck2(this, IfcIndexedPolygonalFaceWithVoids);

      _this1924 = _super1932.call(this, expressID, CoordIndex);
      _this1924.CoordIndex = CoordIndex;
      _this1924.InnerCoordIndices = InnerCoordIndices;
      _this1924.type = 2294589976;
      return _this1924;
    }

    return IfcIndexedPolygonalFaceWithVoids;
  }(IfcIndexedPolygonalFace);

  IFC42.IfcIndexedPolygonalFaceWithVoids = IfcIndexedPolygonalFaceWithVoids;

  var IfcLShapeProfileDef = /*#__PURE__*/function (_IfcParameterizedProf34) {
    _inherits(IfcLShapeProfileDef, _IfcParameterizedProf34);

    var _super1933 = _createSuper(IfcLShapeProfileDef);

    function IfcLShapeProfileDef(expressID, ProfileType, ProfileName, Position, Depth, Width, Thickness, FilletRadius, EdgeRadius, LegSlope) {
      var _this1925;

      _classCallCheck2(this, IfcLShapeProfileDef);

      _this1925 = _super1933.call(this, expressID, ProfileType, ProfileName, Position);
      _this1925.ProfileType = ProfileType;
      _this1925.ProfileName = ProfileName;
      _this1925.Position = Position;
      _this1925.Depth = Depth;
      _this1925.Width = Width;
      _this1925.Thickness = Thickness;
      _this1925.FilletRadius = FilletRadius;
      _this1925.EdgeRadius = EdgeRadius;
      _this1925.LegSlope = LegSlope;
      _this1925.type = 572779678;
      return _this1925;
    }

    return IfcLShapeProfileDef;
  }(IfcParameterizedProfileDef);

  IFC42.IfcLShapeProfileDef = IfcLShapeProfileDef;

  var IfcLaborResourceType = /*#__PURE__*/function (_IfcConstructionResou20) {
    _inherits(IfcLaborResourceType, _IfcConstructionResou20);

    var _super1934 = _createSuper(IfcLaborResourceType);

    function IfcLaborResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this1926;

      _classCallCheck2(this, IfcLaborResourceType);

      _this1926 = _super1934.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this1926.GlobalId = GlobalId;
      _this1926.OwnerHistory = OwnerHistory;
      _this1926.Name = Name;
      _this1926.Description = Description;
      _this1926.ApplicableOccurrence = ApplicableOccurrence;
      _this1926.HasPropertySets = HasPropertySets;
      _this1926.Identification = Identification;
      _this1926.LongDescription = LongDescription;
      _this1926.ResourceType = ResourceType;
      _this1926.BaseCosts = BaseCosts;
      _this1926.BaseQuantity = BaseQuantity;
      _this1926.PredefinedType = PredefinedType;
      _this1926.type = 428585644;
      return _this1926;
    }

    return IfcLaborResourceType;
  }(IfcConstructionResourceType);

  IFC42.IfcLaborResourceType = IfcLaborResourceType;

  var IfcLine = /*#__PURE__*/function (_IfcCurve14) {
    _inherits(IfcLine, _IfcCurve14);

    var _super1935 = _createSuper(IfcLine);

    function IfcLine(expressID, Pnt, Dir) {
      var _this1927;

      _classCallCheck2(this, IfcLine);

      _this1927 = _super1935.call(this, expressID);
      _this1927.Pnt = Pnt;
      _this1927.Dir = Dir;
      _this1927.type = 1281925730;
      return _this1927;
    }

    return IfcLine;
  }(IfcCurve);

  IFC42.IfcLine = IfcLine;

  var IfcManifoldSolidBrep = /*#__PURE__*/function (_IfcSolidModel13) {
    _inherits(IfcManifoldSolidBrep, _IfcSolidModel13);

    var _super1936 = _createSuper(IfcManifoldSolidBrep);

    function IfcManifoldSolidBrep(expressID, Outer) {
      var _this1928;

      _classCallCheck2(this, IfcManifoldSolidBrep);

      _this1928 = _super1936.call(this, expressID);
      _this1928.Outer = Outer;
      _this1928.type = 1425443689;
      return _this1928;
    }

    return IfcManifoldSolidBrep;
  }(IfcSolidModel);

  IFC42.IfcManifoldSolidBrep = IfcManifoldSolidBrep;

  var IfcObject = /*#__PURE__*/function (_IfcObjectDefinition8) {
    _inherits(IfcObject, _IfcObjectDefinition8);

    var _super1937 = _createSuper(IfcObject);

    function IfcObject(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this1929;

      _classCallCheck2(this, IfcObject);

      _this1929 = _super1937.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1929.GlobalId = GlobalId;
      _this1929.OwnerHistory = OwnerHistory;
      _this1929.Name = Name;
      _this1929.Description = Description;
      _this1929.ObjectType = ObjectType;
      _this1929.type = 3888040117;
      return _this1929;
    }

    return IfcObject;
  }(IfcObjectDefinition);

  IFC42.IfcObject = IfcObject;

  var IfcOffsetCurve2D = /*#__PURE__*/function (_IfcCurve15) {
    _inherits(IfcOffsetCurve2D, _IfcCurve15);

    var _super1938 = _createSuper(IfcOffsetCurve2D);

    function IfcOffsetCurve2D(expressID, BasisCurve, Distance, SelfIntersect) {
      var _this1930;

      _classCallCheck2(this, IfcOffsetCurve2D);

      _this1930 = _super1938.call(this, expressID);
      _this1930.BasisCurve = BasisCurve;
      _this1930.Distance = Distance;
      _this1930.SelfIntersect = SelfIntersect;
      _this1930.type = 3388369263;
      return _this1930;
    }

    return IfcOffsetCurve2D;
  }(IfcCurve);

  IFC42.IfcOffsetCurve2D = IfcOffsetCurve2D;

  var IfcOffsetCurve3D = /*#__PURE__*/function (_IfcCurve16) {
    _inherits(IfcOffsetCurve3D, _IfcCurve16);

    var _super1939 = _createSuper(IfcOffsetCurve3D);

    function IfcOffsetCurve3D(expressID, BasisCurve, Distance, SelfIntersect, RefDirection) {
      var _this1931;

      _classCallCheck2(this, IfcOffsetCurve3D);

      _this1931 = _super1939.call(this, expressID);
      _this1931.BasisCurve = BasisCurve;
      _this1931.Distance = Distance;
      _this1931.SelfIntersect = SelfIntersect;
      _this1931.RefDirection = RefDirection;
      _this1931.type = 3505215534;
      return _this1931;
    }

    return IfcOffsetCurve3D;
  }(IfcCurve);

  IFC42.IfcOffsetCurve3D = IfcOffsetCurve3D;

  var IfcPcurve = /*#__PURE__*/function (_IfcCurve17) {
    _inherits(IfcPcurve, _IfcCurve17);

    var _super1940 = _createSuper(IfcPcurve);

    function IfcPcurve(expressID, BasisSurface, ReferenceCurve) {
      var _this1932;

      _classCallCheck2(this, IfcPcurve);

      _this1932 = _super1940.call(this, expressID);
      _this1932.BasisSurface = BasisSurface;
      _this1932.ReferenceCurve = ReferenceCurve;
      _this1932.type = 1682466193;
      return _this1932;
    }

    return IfcPcurve;
  }(IfcCurve);

  IFC42.IfcPcurve = IfcPcurve;

  var IfcPlanarBox = /*#__PURE__*/function (_IfcPlanarExtent3) {
    _inherits(IfcPlanarBox, _IfcPlanarExtent3);

    var _super1941 = _createSuper(IfcPlanarBox);

    function IfcPlanarBox(expressID, SizeInX, SizeInY, Placement) {
      var _this1933;

      _classCallCheck2(this, IfcPlanarBox);

      _this1933 = _super1941.call(this, expressID, SizeInX, SizeInY);
      _this1933.SizeInX = SizeInX;
      _this1933.SizeInY = SizeInY;
      _this1933.Placement = Placement;
      _this1933.type = 603570806;
      return _this1933;
    }

    return IfcPlanarBox;
  }(IfcPlanarExtent);

  IFC42.IfcPlanarBox = IfcPlanarBox;

  var IfcPlane = /*#__PURE__*/function (_IfcElementarySurface6) {
    _inherits(IfcPlane, _IfcElementarySurface6);

    var _super1942 = _createSuper(IfcPlane);

    function IfcPlane(expressID, Position) {
      var _this1934;

      _classCallCheck2(this, IfcPlane);

      _this1934 = _super1942.call(this, expressID, Position);
      _this1934.Position = Position;
      _this1934.type = 220341763;
      return _this1934;
    }

    return IfcPlane;
  }(IfcElementarySurface);

  IFC42.IfcPlane = IfcPlane;

  var IfcPreDefinedColour = /*#__PURE__*/function (_IfcPreDefinedItem9) {
    _inherits(IfcPreDefinedColour, _IfcPreDefinedItem9);

    var _super1943 = _createSuper(IfcPreDefinedColour);

    function IfcPreDefinedColour(expressID, Name) {
      var _this1935;

      _classCallCheck2(this, IfcPreDefinedColour);

      _this1935 = _super1943.call(this, expressID, Name);
      _this1935.Name = Name;
      _this1935.type = 759155922;
      return _this1935;
    }

    return IfcPreDefinedColour;
  }(IfcPreDefinedItem);

  IFC42.IfcPreDefinedColour = IfcPreDefinedColour;

  var IfcPreDefinedCurveFont = /*#__PURE__*/function (_IfcPreDefinedItem10) {
    _inherits(IfcPreDefinedCurveFont, _IfcPreDefinedItem10);

    var _super1944 = _createSuper(IfcPreDefinedCurveFont);

    function IfcPreDefinedCurveFont(expressID, Name) {
      var _this1936;

      _classCallCheck2(this, IfcPreDefinedCurveFont);

      _this1936 = _super1944.call(this, expressID, Name);
      _this1936.Name = Name;
      _this1936.type = 2559016684;
      return _this1936;
    }

    return IfcPreDefinedCurveFont;
  }(IfcPreDefinedItem);

  IFC42.IfcPreDefinedCurveFont = IfcPreDefinedCurveFont;

  var IfcPreDefinedPropertySet = /*#__PURE__*/function (_IfcPropertySetDefini19) {
    _inherits(IfcPreDefinedPropertySet, _IfcPropertySetDefini19);

    var _super1945 = _createSuper(IfcPreDefinedPropertySet);

    function IfcPreDefinedPropertySet(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1937;

      _classCallCheck2(this, IfcPreDefinedPropertySet);

      _this1937 = _super1945.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1937.GlobalId = GlobalId;
      _this1937.OwnerHistory = OwnerHistory;
      _this1937.Name = Name;
      _this1937.Description = Description;
      _this1937.type = 3967405729;
      return _this1937;
    }

    return IfcPreDefinedPropertySet;
  }(IfcPropertySetDefinition);

  IFC42.IfcPreDefinedPropertySet = IfcPreDefinedPropertySet;

  var IfcProcedureType = /*#__PURE__*/function (_IfcTypeProcess5) {
    _inherits(IfcProcedureType, _IfcTypeProcess5);

    var _super1946 = _createSuper(IfcProcedureType);

    function IfcProcedureType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType) {
      var _this1938;

      _classCallCheck2(this, IfcProcedureType);

      _this1938 = _super1946.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      _this1938.GlobalId = GlobalId;
      _this1938.OwnerHistory = OwnerHistory;
      _this1938.Name = Name;
      _this1938.Description = Description;
      _this1938.ApplicableOccurrence = ApplicableOccurrence;
      _this1938.HasPropertySets = HasPropertySets;
      _this1938.Identification = Identification;
      _this1938.LongDescription = LongDescription;
      _this1938.ProcessType = ProcessType;
      _this1938.PredefinedType = PredefinedType;
      _this1938.type = 569719735;
      return _this1938;
    }

    return IfcProcedureType;
  }(IfcTypeProcess);

  IFC42.IfcProcedureType = IfcProcedureType;

  var IfcProcess = /*#__PURE__*/function (_IfcObject14) {
    _inherits(IfcProcess, _IfcObject14);

    var _super1947 = _createSuper(IfcProcess);

    function IfcProcess(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      var _this1939;

      _classCallCheck2(this, IfcProcess);

      _this1939 = _super1947.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1939.GlobalId = GlobalId;
      _this1939.OwnerHistory = OwnerHistory;
      _this1939.Name = Name;
      _this1939.Description = Description;
      _this1939.ObjectType = ObjectType;
      _this1939.Identification = Identification;
      _this1939.LongDescription = LongDescription;
      _this1939.type = 2945172077;
      return _this1939;
    }

    return IfcProcess;
  }(IfcObject);

  IFC42.IfcProcess = IfcProcess;

  var IfcProduct = /*#__PURE__*/function (_IfcObject15) {
    _inherits(IfcProduct, _IfcObject15);

    var _super1948 = _createSuper(IfcProduct);

    function IfcProduct(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this1940;

      _classCallCheck2(this, IfcProduct);

      _this1940 = _super1948.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this1940.GlobalId = GlobalId;
      _this1940.OwnerHistory = OwnerHistory;
      _this1940.Name = Name;
      _this1940.Description = Description;
      _this1940.ObjectType = ObjectType;
      _this1940.ObjectPlacement = ObjectPlacement;
      _this1940.Representation = Representation;
      _this1940.type = 4208778838;
      return _this1940;
    }

    return IfcProduct;
  }(IfcObject);

  IFC42.IfcProduct = IfcProduct;

  var IfcProject = /*#__PURE__*/function (_IfcContext3) {
    _inherits(IfcProject, _IfcContext3);

    var _super1949 = _createSuper(IfcProject);

    function IfcProject(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      var _this1941;

      _classCallCheck2(this, IfcProject);

      _this1941 = _super1949.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      _this1941.GlobalId = GlobalId;
      _this1941.OwnerHistory = OwnerHistory;
      _this1941.Name = Name;
      _this1941.Description = Description;
      _this1941.ObjectType = ObjectType;
      _this1941.LongName = LongName;
      _this1941.Phase = Phase;
      _this1941.RepresentationContexts = RepresentationContexts;
      _this1941.UnitsInContext = UnitsInContext;
      _this1941.type = 103090709;
      return _this1941;
    }

    return IfcProject;
  }(IfcContext);

  IFC42.IfcProject = IfcProject;

  var IfcProjectLibrary = /*#__PURE__*/function (_IfcContext4) {
    _inherits(IfcProjectLibrary, _IfcContext4);

    var _super1950 = _createSuper(IfcProjectLibrary);

    function IfcProjectLibrary(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext) {
      var _this1942;

      _classCallCheck2(this, IfcProjectLibrary);

      _this1942 = _super1950.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, Phase, RepresentationContexts, UnitsInContext);
      _this1942.GlobalId = GlobalId;
      _this1942.OwnerHistory = OwnerHistory;
      _this1942.Name = Name;
      _this1942.Description = Description;
      _this1942.ObjectType = ObjectType;
      _this1942.LongName = LongName;
      _this1942.Phase = Phase;
      _this1942.RepresentationContexts = RepresentationContexts;
      _this1942.UnitsInContext = UnitsInContext;
      _this1942.type = 653396225;
      return _this1942;
    }

    return IfcProjectLibrary;
  }(IfcContext);

  IFC42.IfcProjectLibrary = IfcProjectLibrary;

  var IfcPropertyBoundedValue = /*#__PURE__*/function (_IfcSimpleProperty13) {
    _inherits(IfcPropertyBoundedValue, _IfcSimpleProperty13);

    var _super1951 = _createSuper(IfcPropertyBoundedValue);

    function IfcPropertyBoundedValue(expressID, Name, Description, UpperBoundValue, LowerBoundValue, Unit, SetPointValue) {
      var _this1943;

      _classCallCheck2(this, IfcPropertyBoundedValue);

      _this1943 = _super1951.call(this, expressID, Name, Description);
      _this1943.Name = Name;
      _this1943.Description = Description;
      _this1943.UpperBoundValue = UpperBoundValue;
      _this1943.LowerBoundValue = LowerBoundValue;
      _this1943.Unit = Unit;
      _this1943.SetPointValue = SetPointValue;
      _this1943.type = 871118103;
      return _this1943;
    }

    return IfcPropertyBoundedValue;
  }(IfcSimpleProperty);

  IFC42.IfcPropertyBoundedValue = IfcPropertyBoundedValue;

  var IfcPropertyEnumeratedValue = /*#__PURE__*/function (_IfcSimpleProperty14) {
    _inherits(IfcPropertyEnumeratedValue, _IfcSimpleProperty14);

    var _super1952 = _createSuper(IfcPropertyEnumeratedValue);

    function IfcPropertyEnumeratedValue(expressID, Name, Description, EnumerationValues, EnumerationReference) {
      var _this1944;

      _classCallCheck2(this, IfcPropertyEnumeratedValue);

      _this1944 = _super1952.call(this, expressID, Name, Description);
      _this1944.Name = Name;
      _this1944.Description = Description;
      _this1944.EnumerationValues = EnumerationValues;
      _this1944.EnumerationReference = EnumerationReference;
      _this1944.type = 4166981789;
      return _this1944;
    }

    return IfcPropertyEnumeratedValue;
  }(IfcSimpleProperty);

  IFC42.IfcPropertyEnumeratedValue = IfcPropertyEnumeratedValue;

  var IfcPropertyListValue = /*#__PURE__*/function (_IfcSimpleProperty15) {
    _inherits(IfcPropertyListValue, _IfcSimpleProperty15);

    var _super1953 = _createSuper(IfcPropertyListValue);

    function IfcPropertyListValue(expressID, Name, Description, ListValues, Unit) {
      var _this1945;

      _classCallCheck2(this, IfcPropertyListValue);

      _this1945 = _super1953.call(this, expressID, Name, Description);
      _this1945.Name = Name;
      _this1945.Description = Description;
      _this1945.ListValues = ListValues;
      _this1945.Unit = Unit;
      _this1945.type = 2752243245;
      return _this1945;
    }

    return IfcPropertyListValue;
  }(IfcSimpleProperty);

  IFC42.IfcPropertyListValue = IfcPropertyListValue;

  var IfcPropertyReferenceValue = /*#__PURE__*/function (_IfcSimpleProperty16) {
    _inherits(IfcPropertyReferenceValue, _IfcSimpleProperty16);

    var _super1954 = _createSuper(IfcPropertyReferenceValue);

    function IfcPropertyReferenceValue(expressID, Name, Description, UsageName, PropertyReference) {
      var _this1946;

      _classCallCheck2(this, IfcPropertyReferenceValue);

      _this1946 = _super1954.call(this, expressID, Name, Description);
      _this1946.Name = Name;
      _this1946.Description = Description;
      _this1946.UsageName = UsageName;
      _this1946.PropertyReference = PropertyReference;
      _this1946.type = 941946838;
      return _this1946;
    }

    return IfcPropertyReferenceValue;
  }(IfcSimpleProperty);

  IFC42.IfcPropertyReferenceValue = IfcPropertyReferenceValue;

  var IfcPropertySet = /*#__PURE__*/function (_IfcPropertySetDefini20) {
    _inherits(IfcPropertySet, _IfcPropertySetDefini20);

    var _super1955 = _createSuper(IfcPropertySet);

    function IfcPropertySet(expressID, GlobalId, OwnerHistory, Name, Description, HasProperties) {
      var _this1947;

      _classCallCheck2(this, IfcPropertySet);

      _this1947 = _super1955.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1947.GlobalId = GlobalId;
      _this1947.OwnerHistory = OwnerHistory;
      _this1947.Name = Name;
      _this1947.Description = Description;
      _this1947.HasProperties = HasProperties;
      _this1947.type = 1451395588;
      return _this1947;
    }

    return IfcPropertySet;
  }(IfcPropertySetDefinition);

  IFC42.IfcPropertySet = IfcPropertySet;

  var IfcPropertySetTemplate = /*#__PURE__*/function (_IfcPropertyTemplateD3) {
    _inherits(IfcPropertySetTemplate, _IfcPropertyTemplateD3);

    var _super1956 = _createSuper(IfcPropertySetTemplate);

    function IfcPropertySetTemplate(expressID, GlobalId, OwnerHistory, Name, Description, TemplateType, ApplicableEntity, HasPropertyTemplates) {
      var _this1948;

      _classCallCheck2(this, IfcPropertySetTemplate);

      _this1948 = _super1956.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1948.GlobalId = GlobalId;
      _this1948.OwnerHistory = OwnerHistory;
      _this1948.Name = Name;
      _this1948.Description = Description;
      _this1948.TemplateType = TemplateType;
      _this1948.ApplicableEntity = ApplicableEntity;
      _this1948.HasPropertyTemplates = HasPropertyTemplates;
      _this1948.type = 492091185;
      return _this1948;
    }

    return IfcPropertySetTemplate;
  }(IfcPropertyTemplateDefinition);

  IFC42.IfcPropertySetTemplate = IfcPropertySetTemplate;

  var IfcPropertySingleValue = /*#__PURE__*/function (_IfcSimpleProperty17) {
    _inherits(IfcPropertySingleValue, _IfcSimpleProperty17);

    var _super1957 = _createSuper(IfcPropertySingleValue);

    function IfcPropertySingleValue(expressID, Name, Description, NominalValue, Unit) {
      var _this1949;

      _classCallCheck2(this, IfcPropertySingleValue);

      _this1949 = _super1957.call(this, expressID, Name, Description);
      _this1949.Name = Name;
      _this1949.Description = Description;
      _this1949.NominalValue = NominalValue;
      _this1949.Unit = Unit;
      _this1949.type = 3650150729;
      return _this1949;
    }

    return IfcPropertySingleValue;
  }(IfcSimpleProperty);

  IFC42.IfcPropertySingleValue = IfcPropertySingleValue;

  var IfcPropertyTableValue = /*#__PURE__*/function (_IfcSimpleProperty18) {
    _inherits(IfcPropertyTableValue, _IfcSimpleProperty18);

    var _super1958 = _createSuper(IfcPropertyTableValue);

    function IfcPropertyTableValue(expressID, Name, Description, DefiningValues, DefinedValues, Expression, DefiningUnit, DefinedUnit, CurveInterpolation) {
      var _this1950;

      _classCallCheck2(this, IfcPropertyTableValue);

      _this1950 = _super1958.call(this, expressID, Name, Description);
      _this1950.Name = Name;
      _this1950.Description = Description;
      _this1950.DefiningValues = DefiningValues;
      _this1950.DefinedValues = DefinedValues;
      _this1950.Expression = Expression;
      _this1950.DefiningUnit = DefiningUnit;
      _this1950.DefinedUnit = DefinedUnit;
      _this1950.CurveInterpolation = CurveInterpolation;
      _this1950.type = 110355661;
      return _this1950;
    }

    return IfcPropertyTableValue;
  }(IfcSimpleProperty);

  IFC42.IfcPropertyTableValue = IfcPropertyTableValue;

  var IfcPropertyTemplate = /*#__PURE__*/function (_IfcPropertyTemplateD4) {
    _inherits(IfcPropertyTemplate, _IfcPropertyTemplateD4);

    var _super1959 = _createSuper(IfcPropertyTemplate);

    function IfcPropertyTemplate(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1951;

      _classCallCheck2(this, IfcPropertyTemplate);

      _this1951 = _super1959.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1951.GlobalId = GlobalId;
      _this1951.OwnerHistory = OwnerHistory;
      _this1951.Name = Name;
      _this1951.Description = Description;
      _this1951.type = 3521284610;
      return _this1951;
    }

    return IfcPropertyTemplate;
  }(IfcPropertyTemplateDefinition);

  IFC42.IfcPropertyTemplate = IfcPropertyTemplate;

  var IfcProxy = /*#__PURE__*/function (_IfcProduct17) {
    _inherits(IfcProxy, _IfcProduct17);

    var _super1960 = _createSuper(IfcProxy);

    function IfcProxy(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, ProxyType, Tag) {
      var _this1952;

      _classCallCheck2(this, IfcProxy);

      _this1952 = _super1960.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this1952.GlobalId = GlobalId;
      _this1952.OwnerHistory = OwnerHistory;
      _this1952.Name = Name;
      _this1952.Description = Description;
      _this1952.ObjectType = ObjectType;
      _this1952.ObjectPlacement = ObjectPlacement;
      _this1952.Representation = Representation;
      _this1952.ProxyType = ProxyType;
      _this1952.Tag = Tag;
      _this1952.type = 3219374653;
      return _this1952;
    }

    return IfcProxy;
  }(IfcProduct);

  IFC42.IfcProxy = IfcProxy;

  var IfcRectangleHollowProfileDef = /*#__PURE__*/function (_IfcRectangleProfileD6) {
    _inherits(IfcRectangleHollowProfileDef, _IfcRectangleProfileD6);

    var _super1961 = _createSuper(IfcRectangleHollowProfileDef);

    function IfcRectangleHollowProfileDef(expressID, ProfileType, ProfileName, Position, XDim, YDim, WallThickness, InnerFilletRadius, OuterFilletRadius) {
      var _this1953;

      _classCallCheck2(this, IfcRectangleHollowProfileDef);

      _this1953 = _super1961.call(this, expressID, ProfileType, ProfileName, Position, XDim, YDim);
      _this1953.ProfileType = ProfileType;
      _this1953.ProfileName = ProfileName;
      _this1953.Position = Position;
      _this1953.XDim = XDim;
      _this1953.YDim = YDim;
      _this1953.WallThickness = WallThickness;
      _this1953.InnerFilletRadius = InnerFilletRadius;
      _this1953.OuterFilletRadius = OuterFilletRadius;
      _this1953.type = 2770003689;
      return _this1953;
    }

    return IfcRectangleHollowProfileDef;
  }(IfcRectangleProfileDef);

  IFC42.IfcRectangleHollowProfileDef = IfcRectangleHollowProfileDef;

  var IfcRectangularPyramid = /*#__PURE__*/function (_IfcCsgPrimitive3D11) {
    _inherits(IfcRectangularPyramid, _IfcCsgPrimitive3D11);

    var _super1962 = _createSuper(IfcRectangularPyramid);

    function IfcRectangularPyramid(expressID, Position, XLength, YLength, Height) {
      var _this1954;

      _classCallCheck2(this, IfcRectangularPyramid);

      _this1954 = _super1962.call(this, expressID, Position);
      _this1954.Position = Position;
      _this1954.XLength = XLength;
      _this1954.YLength = YLength;
      _this1954.Height = Height;
      _this1954.type = 2798486643;
      return _this1954;
    }

    return IfcRectangularPyramid;
  }(IfcCsgPrimitive3D);

  IFC42.IfcRectangularPyramid = IfcRectangularPyramid;

  var IfcRectangularTrimmedSurface = /*#__PURE__*/function (_IfcBoundedSurface9) {
    _inherits(IfcRectangularTrimmedSurface, _IfcBoundedSurface9);

    var _super1963 = _createSuper(IfcRectangularTrimmedSurface);

    function IfcRectangularTrimmedSurface(expressID, BasisSurface, U1, V1, U2, V2, Usense, Vsense) {
      var _this1955;

      _classCallCheck2(this, IfcRectangularTrimmedSurface);

      _this1955 = _super1963.call(this, expressID);
      _this1955.BasisSurface = BasisSurface;
      _this1955.U1 = U1;
      _this1955.V1 = V1;
      _this1955.U2 = U2;
      _this1955.V2 = V2;
      _this1955.Usense = Usense;
      _this1955.Vsense = Vsense;
      _this1955.type = 3454111270;
      return _this1955;
    }

    return IfcRectangularTrimmedSurface;
  }(IfcBoundedSurface);

  IFC42.IfcRectangularTrimmedSurface = IfcRectangularTrimmedSurface;

  var IfcReinforcementDefinitionProperties = /*#__PURE__*/function (_IfcPreDefinedPropert13) {
    _inherits(IfcReinforcementDefinitionProperties, _IfcPreDefinedPropert13);

    var _super1964 = _createSuper(IfcReinforcementDefinitionProperties);

    function IfcReinforcementDefinitionProperties(expressID, GlobalId, OwnerHistory, Name, Description, DefinitionType, ReinforcementSectionDefinitions) {
      var _this1956;

      _classCallCheck2(this, IfcReinforcementDefinitionProperties);

      _this1956 = _super1964.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1956.GlobalId = GlobalId;
      _this1956.OwnerHistory = OwnerHistory;
      _this1956.Name = Name;
      _this1956.Description = Description;
      _this1956.DefinitionType = DefinitionType;
      _this1956.ReinforcementSectionDefinitions = ReinforcementSectionDefinitions;
      _this1956.type = 3765753017;
      return _this1956;
    }

    return IfcReinforcementDefinitionProperties;
  }(IfcPreDefinedPropertySet);

  IFC42.IfcReinforcementDefinitionProperties = IfcReinforcementDefinitionProperties;

  var IfcRelAssigns = /*#__PURE__*/function (_IfcRelationship12) {
    _inherits(IfcRelAssigns, _IfcRelationship12);

    var _super1965 = _createSuper(IfcRelAssigns);

    function IfcRelAssigns(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType) {
      var _this1957;

      _classCallCheck2(this, IfcRelAssigns);

      _this1957 = _super1965.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1957.GlobalId = GlobalId;
      _this1957.OwnerHistory = OwnerHistory;
      _this1957.Name = Name;
      _this1957.Description = Description;
      _this1957.RelatedObjects = RelatedObjects;
      _this1957.RelatedObjectsType = RelatedObjectsType;
      _this1957.type = 3939117080;
      return _this1957;
    }

    return IfcRelAssigns;
  }(IfcRelationship);

  IFC42.IfcRelAssigns = IfcRelAssigns;

  var IfcRelAssignsToActor = /*#__PURE__*/function (_IfcRelAssigns13) {
    _inherits(IfcRelAssignsToActor, _IfcRelAssigns13);

    var _super1966 = _createSuper(IfcRelAssignsToActor);

    function IfcRelAssignsToActor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingActor, ActingRole) {
      var _this1958;

      _classCallCheck2(this, IfcRelAssignsToActor);

      _this1958 = _super1966.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1958.GlobalId = GlobalId;
      _this1958.OwnerHistory = OwnerHistory;
      _this1958.Name = Name;
      _this1958.Description = Description;
      _this1958.RelatedObjects = RelatedObjects;
      _this1958.RelatedObjectsType = RelatedObjectsType;
      _this1958.RelatingActor = RelatingActor;
      _this1958.ActingRole = ActingRole;
      _this1958.type = 1683148259;
      return _this1958;
    }

    return IfcRelAssignsToActor;
  }(IfcRelAssigns);

  IFC42.IfcRelAssignsToActor = IfcRelAssignsToActor;

  var IfcRelAssignsToControl = /*#__PURE__*/function (_IfcRelAssigns14) {
    _inherits(IfcRelAssignsToControl, _IfcRelAssigns14);

    var _super1967 = _createSuper(IfcRelAssignsToControl);

    function IfcRelAssignsToControl(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingControl) {
      var _this1959;

      _classCallCheck2(this, IfcRelAssignsToControl);

      _this1959 = _super1967.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1959.GlobalId = GlobalId;
      _this1959.OwnerHistory = OwnerHistory;
      _this1959.Name = Name;
      _this1959.Description = Description;
      _this1959.RelatedObjects = RelatedObjects;
      _this1959.RelatedObjectsType = RelatedObjectsType;
      _this1959.RelatingControl = RelatingControl;
      _this1959.type = 2495723537;
      return _this1959;
    }

    return IfcRelAssignsToControl;
  }(IfcRelAssigns);

  IFC42.IfcRelAssignsToControl = IfcRelAssignsToControl;

  var IfcRelAssignsToGroup = /*#__PURE__*/function (_IfcRelAssigns15) {
    _inherits(IfcRelAssignsToGroup, _IfcRelAssigns15);

    var _super1968 = _createSuper(IfcRelAssignsToGroup);

    function IfcRelAssignsToGroup(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup) {
      var _this1960;

      _classCallCheck2(this, IfcRelAssignsToGroup);

      _this1960 = _super1968.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1960.GlobalId = GlobalId;
      _this1960.OwnerHistory = OwnerHistory;
      _this1960.Name = Name;
      _this1960.Description = Description;
      _this1960.RelatedObjects = RelatedObjects;
      _this1960.RelatedObjectsType = RelatedObjectsType;
      _this1960.RelatingGroup = RelatingGroup;
      _this1960.type = 1307041759;
      return _this1960;
    }

    return IfcRelAssignsToGroup;
  }(IfcRelAssigns);

  IFC42.IfcRelAssignsToGroup = IfcRelAssignsToGroup;

  var IfcRelAssignsToGroupByFactor = /*#__PURE__*/function (_IfcRelAssignsToGroup2) {
    _inherits(IfcRelAssignsToGroupByFactor, _IfcRelAssignsToGroup2);

    var _super1969 = _createSuper(IfcRelAssignsToGroupByFactor);

    function IfcRelAssignsToGroupByFactor(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup, Factor) {
      var _this1961;

      _classCallCheck2(this, IfcRelAssignsToGroupByFactor);

      _this1961 = _super1969.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingGroup);
      _this1961.GlobalId = GlobalId;
      _this1961.OwnerHistory = OwnerHistory;
      _this1961.Name = Name;
      _this1961.Description = Description;
      _this1961.RelatedObjects = RelatedObjects;
      _this1961.RelatedObjectsType = RelatedObjectsType;
      _this1961.RelatingGroup = RelatingGroup;
      _this1961.Factor = Factor;
      _this1961.type = 1027710054;
      return _this1961;
    }

    return IfcRelAssignsToGroupByFactor;
  }(IfcRelAssignsToGroup);

  IFC42.IfcRelAssignsToGroupByFactor = IfcRelAssignsToGroupByFactor;

  var IfcRelAssignsToProcess = /*#__PURE__*/function (_IfcRelAssigns16) {
    _inherits(IfcRelAssignsToProcess, _IfcRelAssigns16);

    var _super1970 = _createSuper(IfcRelAssignsToProcess);

    function IfcRelAssignsToProcess(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProcess, QuantityInProcess) {
      var _this1962;

      _classCallCheck2(this, IfcRelAssignsToProcess);

      _this1962 = _super1970.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1962.GlobalId = GlobalId;
      _this1962.OwnerHistory = OwnerHistory;
      _this1962.Name = Name;
      _this1962.Description = Description;
      _this1962.RelatedObjects = RelatedObjects;
      _this1962.RelatedObjectsType = RelatedObjectsType;
      _this1962.RelatingProcess = RelatingProcess;
      _this1962.QuantityInProcess = QuantityInProcess;
      _this1962.type = 4278684876;
      return _this1962;
    }

    return IfcRelAssignsToProcess;
  }(IfcRelAssigns);

  IFC42.IfcRelAssignsToProcess = IfcRelAssignsToProcess;

  var IfcRelAssignsToProduct = /*#__PURE__*/function (_IfcRelAssigns17) {
    _inherits(IfcRelAssignsToProduct, _IfcRelAssigns17);

    var _super1971 = _createSuper(IfcRelAssignsToProduct);

    function IfcRelAssignsToProduct(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingProduct) {
      var _this1963;

      _classCallCheck2(this, IfcRelAssignsToProduct);

      _this1963 = _super1971.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1963.GlobalId = GlobalId;
      _this1963.OwnerHistory = OwnerHistory;
      _this1963.Name = Name;
      _this1963.Description = Description;
      _this1963.RelatedObjects = RelatedObjects;
      _this1963.RelatedObjectsType = RelatedObjectsType;
      _this1963.RelatingProduct = RelatingProduct;
      _this1963.type = 2857406711;
      return _this1963;
    }

    return IfcRelAssignsToProduct;
  }(IfcRelAssigns);

  IFC42.IfcRelAssignsToProduct = IfcRelAssignsToProduct;

  var IfcRelAssignsToResource = /*#__PURE__*/function (_IfcRelAssigns18) {
    _inherits(IfcRelAssignsToResource, _IfcRelAssigns18);

    var _super1972 = _createSuper(IfcRelAssignsToResource);

    function IfcRelAssignsToResource(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType, RelatingResource) {
      var _this1964;

      _classCallCheck2(this, IfcRelAssignsToResource);

      _this1964 = _super1972.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatedObjectsType);
      _this1964.GlobalId = GlobalId;
      _this1964.OwnerHistory = OwnerHistory;
      _this1964.Name = Name;
      _this1964.Description = Description;
      _this1964.RelatedObjects = RelatedObjects;
      _this1964.RelatedObjectsType = RelatedObjectsType;
      _this1964.RelatingResource = RelatingResource;
      _this1964.type = 205026976;
      return _this1964;
    }

    return IfcRelAssignsToResource;
  }(IfcRelAssigns);

  IFC42.IfcRelAssignsToResource = IfcRelAssignsToResource;

  var IfcRelAssociates = /*#__PURE__*/function (_IfcRelationship13) {
    _inherits(IfcRelAssociates, _IfcRelationship13);

    var _super1973 = _createSuper(IfcRelAssociates);

    function IfcRelAssociates(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects) {
      var _this1965;

      _classCallCheck2(this, IfcRelAssociates);

      _this1965 = _super1973.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1965.GlobalId = GlobalId;
      _this1965.OwnerHistory = OwnerHistory;
      _this1965.Name = Name;
      _this1965.Description = Description;
      _this1965.RelatedObjects = RelatedObjects;
      _this1965.type = 1865459582;
      return _this1965;
    }

    return IfcRelAssociates;
  }(IfcRelationship);

  IFC42.IfcRelAssociates = IfcRelAssociates;

  var IfcRelAssociatesApproval = /*#__PURE__*/function (_IfcRelAssociates16) {
    _inherits(IfcRelAssociatesApproval, _IfcRelAssociates16);

    var _super1974 = _createSuper(IfcRelAssociatesApproval);

    function IfcRelAssociatesApproval(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingApproval) {
      var _this1966;

      _classCallCheck2(this, IfcRelAssociatesApproval);

      _this1966 = _super1974.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1966.GlobalId = GlobalId;
      _this1966.OwnerHistory = OwnerHistory;
      _this1966.Name = Name;
      _this1966.Description = Description;
      _this1966.RelatedObjects = RelatedObjects;
      _this1966.RelatingApproval = RelatingApproval;
      _this1966.type = 4095574036;
      return _this1966;
    }

    return IfcRelAssociatesApproval;
  }(IfcRelAssociates);

  IFC42.IfcRelAssociatesApproval = IfcRelAssociatesApproval;

  var IfcRelAssociatesClassification = /*#__PURE__*/function (_IfcRelAssociates17) {
    _inherits(IfcRelAssociatesClassification, _IfcRelAssociates17);

    var _super1975 = _createSuper(IfcRelAssociatesClassification);

    function IfcRelAssociatesClassification(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingClassification) {
      var _this1967;

      _classCallCheck2(this, IfcRelAssociatesClassification);

      _this1967 = _super1975.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1967.GlobalId = GlobalId;
      _this1967.OwnerHistory = OwnerHistory;
      _this1967.Name = Name;
      _this1967.Description = Description;
      _this1967.RelatedObjects = RelatedObjects;
      _this1967.RelatingClassification = RelatingClassification;
      _this1967.type = 919958153;
      return _this1967;
    }

    return IfcRelAssociatesClassification;
  }(IfcRelAssociates);

  IFC42.IfcRelAssociatesClassification = IfcRelAssociatesClassification;

  var IfcRelAssociatesConstraint = /*#__PURE__*/function (_IfcRelAssociates18) {
    _inherits(IfcRelAssociatesConstraint, _IfcRelAssociates18);

    var _super1976 = _createSuper(IfcRelAssociatesConstraint);

    function IfcRelAssociatesConstraint(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, Intent, RelatingConstraint) {
      var _this1968;

      _classCallCheck2(this, IfcRelAssociatesConstraint);

      _this1968 = _super1976.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1968.GlobalId = GlobalId;
      _this1968.OwnerHistory = OwnerHistory;
      _this1968.Name = Name;
      _this1968.Description = Description;
      _this1968.RelatedObjects = RelatedObjects;
      _this1968.Intent = Intent;
      _this1968.RelatingConstraint = RelatingConstraint;
      _this1968.type = 2728634034;
      return _this1968;
    }

    return IfcRelAssociatesConstraint;
  }(IfcRelAssociates);

  IFC42.IfcRelAssociatesConstraint = IfcRelAssociatesConstraint;

  var IfcRelAssociatesDocument = /*#__PURE__*/function (_IfcRelAssociates19) {
    _inherits(IfcRelAssociatesDocument, _IfcRelAssociates19);

    var _super1977 = _createSuper(IfcRelAssociatesDocument);

    function IfcRelAssociatesDocument(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingDocument) {
      var _this1969;

      _classCallCheck2(this, IfcRelAssociatesDocument);

      _this1969 = _super1977.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1969.GlobalId = GlobalId;
      _this1969.OwnerHistory = OwnerHistory;
      _this1969.Name = Name;
      _this1969.Description = Description;
      _this1969.RelatedObjects = RelatedObjects;
      _this1969.RelatingDocument = RelatingDocument;
      _this1969.type = 982818633;
      return _this1969;
    }

    return IfcRelAssociatesDocument;
  }(IfcRelAssociates);

  IFC42.IfcRelAssociatesDocument = IfcRelAssociatesDocument;

  var IfcRelAssociatesLibrary = /*#__PURE__*/function (_IfcRelAssociates20) {
    _inherits(IfcRelAssociatesLibrary, _IfcRelAssociates20);

    var _super1978 = _createSuper(IfcRelAssociatesLibrary);

    function IfcRelAssociatesLibrary(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingLibrary) {
      var _this1970;

      _classCallCheck2(this, IfcRelAssociatesLibrary);

      _this1970 = _super1978.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1970.GlobalId = GlobalId;
      _this1970.OwnerHistory = OwnerHistory;
      _this1970.Name = Name;
      _this1970.Description = Description;
      _this1970.RelatedObjects = RelatedObjects;
      _this1970.RelatingLibrary = RelatingLibrary;
      _this1970.type = 3840914261;
      return _this1970;
    }

    return IfcRelAssociatesLibrary;
  }(IfcRelAssociates);

  IFC42.IfcRelAssociatesLibrary = IfcRelAssociatesLibrary;

  var IfcRelAssociatesMaterial = /*#__PURE__*/function (_IfcRelAssociates21) {
    _inherits(IfcRelAssociatesMaterial, _IfcRelAssociates21);

    var _super1979 = _createSuper(IfcRelAssociatesMaterial);

    function IfcRelAssociatesMaterial(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingMaterial) {
      var _this1971;

      _classCallCheck2(this, IfcRelAssociatesMaterial);

      _this1971 = _super1979.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects);
      _this1971.GlobalId = GlobalId;
      _this1971.OwnerHistory = OwnerHistory;
      _this1971.Name = Name;
      _this1971.Description = Description;
      _this1971.RelatedObjects = RelatedObjects;
      _this1971.RelatingMaterial = RelatingMaterial;
      _this1971.type = 2655215786;
      return _this1971;
    }

    return IfcRelAssociatesMaterial;
  }(IfcRelAssociates);

  IFC42.IfcRelAssociatesMaterial = IfcRelAssociatesMaterial;

  var IfcRelConnects = /*#__PURE__*/function (_IfcRelationship14) {
    _inherits(IfcRelConnects, _IfcRelationship14);

    var _super1980 = _createSuper(IfcRelConnects);

    function IfcRelConnects(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1972;

      _classCallCheck2(this, IfcRelConnects);

      _this1972 = _super1980.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1972.GlobalId = GlobalId;
      _this1972.OwnerHistory = OwnerHistory;
      _this1972.Name = Name;
      _this1972.Description = Description;
      _this1972.type = 826625072;
      return _this1972;
    }

    return IfcRelConnects;
  }(IfcRelationship);

  IFC42.IfcRelConnects = IfcRelConnects;

  var IfcRelConnectsElements = /*#__PURE__*/function (_IfcRelConnects35) {
    _inherits(IfcRelConnectsElements, _IfcRelConnects35);

    var _super1981 = _createSuper(IfcRelConnectsElements);

    function IfcRelConnectsElements(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement) {
      var _this1973;

      _classCallCheck2(this, IfcRelConnectsElements);

      _this1973 = _super1981.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1973.GlobalId = GlobalId;
      _this1973.OwnerHistory = OwnerHistory;
      _this1973.Name = Name;
      _this1973.Description = Description;
      _this1973.ConnectionGeometry = ConnectionGeometry;
      _this1973.RelatingElement = RelatingElement;
      _this1973.RelatedElement = RelatedElement;
      _this1973.type = 1204542856;
      return _this1973;
    }

    return IfcRelConnectsElements;
  }(IfcRelConnects);

  IFC42.IfcRelConnectsElements = IfcRelConnectsElements;

  var IfcRelConnectsPathElements = /*#__PURE__*/function (_IfcRelConnectsElemen5) {
    _inherits(IfcRelConnectsPathElements, _IfcRelConnectsElemen5);

    var _super1982 = _createSuper(IfcRelConnectsPathElements);

    function IfcRelConnectsPathElements(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RelatingPriorities, RelatedPriorities, RelatedConnectionType, RelatingConnectionType) {
      var _this1974;

      _classCallCheck2(this, IfcRelConnectsPathElements);

      _this1974 = _super1982.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      _this1974.GlobalId = GlobalId;
      _this1974.OwnerHistory = OwnerHistory;
      _this1974.Name = Name;
      _this1974.Description = Description;
      _this1974.ConnectionGeometry = ConnectionGeometry;
      _this1974.RelatingElement = RelatingElement;
      _this1974.RelatedElement = RelatedElement;
      _this1974.RelatingPriorities = RelatingPriorities;
      _this1974.RelatedPriorities = RelatedPriorities;
      _this1974.RelatedConnectionType = RelatedConnectionType;
      _this1974.RelatingConnectionType = RelatingConnectionType;
      _this1974.type = 3945020480;
      return _this1974;
    }

    return IfcRelConnectsPathElements;
  }(IfcRelConnectsElements);

  IFC42.IfcRelConnectsPathElements = IfcRelConnectsPathElements;

  var IfcRelConnectsPortToElement = /*#__PURE__*/function (_IfcRelConnects36) {
    _inherits(IfcRelConnectsPortToElement, _IfcRelConnects36);

    var _super1983 = _createSuper(IfcRelConnectsPortToElement);

    function IfcRelConnectsPortToElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedElement) {
      var _this1975;

      _classCallCheck2(this, IfcRelConnectsPortToElement);

      _this1975 = _super1983.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1975.GlobalId = GlobalId;
      _this1975.OwnerHistory = OwnerHistory;
      _this1975.Name = Name;
      _this1975.Description = Description;
      _this1975.RelatingPort = RelatingPort;
      _this1975.RelatedElement = RelatedElement;
      _this1975.type = 4201705270;
      return _this1975;
    }

    return IfcRelConnectsPortToElement;
  }(IfcRelConnects);

  IFC42.IfcRelConnectsPortToElement = IfcRelConnectsPortToElement;

  var IfcRelConnectsPorts = /*#__PURE__*/function (_IfcRelConnects37) {
    _inherits(IfcRelConnectsPorts, _IfcRelConnects37);

    var _super1984 = _createSuper(IfcRelConnectsPorts);

    function IfcRelConnectsPorts(expressID, GlobalId, OwnerHistory, Name, Description, RelatingPort, RelatedPort, RealizingElement) {
      var _this1976;

      _classCallCheck2(this, IfcRelConnectsPorts);

      _this1976 = _super1984.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1976.GlobalId = GlobalId;
      _this1976.OwnerHistory = OwnerHistory;
      _this1976.Name = Name;
      _this1976.Description = Description;
      _this1976.RelatingPort = RelatingPort;
      _this1976.RelatedPort = RelatedPort;
      _this1976.RealizingElement = RealizingElement;
      _this1976.type = 3190031847;
      return _this1976;
    }

    return IfcRelConnectsPorts;
  }(IfcRelConnects);

  IFC42.IfcRelConnectsPorts = IfcRelConnectsPorts;

  var IfcRelConnectsStructuralActivity = /*#__PURE__*/function (_IfcRelConnects38) {
    _inherits(IfcRelConnectsStructuralActivity, _IfcRelConnects38);

    var _super1985 = _createSuper(IfcRelConnectsStructuralActivity);

    function IfcRelConnectsStructuralActivity(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedStructuralActivity) {
      var _this1977;

      _classCallCheck2(this, IfcRelConnectsStructuralActivity);

      _this1977 = _super1985.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1977.GlobalId = GlobalId;
      _this1977.OwnerHistory = OwnerHistory;
      _this1977.Name = Name;
      _this1977.Description = Description;
      _this1977.RelatingElement = RelatingElement;
      _this1977.RelatedStructuralActivity = RelatedStructuralActivity;
      _this1977.type = 2127690289;
      return _this1977;
    }

    return IfcRelConnectsStructuralActivity;
  }(IfcRelConnects);

  IFC42.IfcRelConnectsStructuralActivity = IfcRelConnectsStructuralActivity;

  var IfcRelConnectsStructuralMember = /*#__PURE__*/function (_IfcRelConnects39) {
    _inherits(IfcRelConnectsStructuralMember, _IfcRelConnects39);

    var _super1986 = _createSuper(IfcRelConnectsStructuralMember);

    function IfcRelConnectsStructuralMember(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem) {
      var _this1978;

      _classCallCheck2(this, IfcRelConnectsStructuralMember);

      _this1978 = _super1986.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1978.GlobalId = GlobalId;
      _this1978.OwnerHistory = OwnerHistory;
      _this1978.Name = Name;
      _this1978.Description = Description;
      _this1978.RelatingStructuralMember = RelatingStructuralMember;
      _this1978.RelatedStructuralConnection = RelatedStructuralConnection;
      _this1978.AppliedCondition = AppliedCondition;
      _this1978.AdditionalConditions = AdditionalConditions;
      _this1978.SupportedLength = SupportedLength;
      _this1978.ConditionCoordinateSystem = ConditionCoordinateSystem;
      _this1978.type = 1638771189;
      return _this1978;
    }

    return IfcRelConnectsStructuralMember;
  }(IfcRelConnects);

  IFC42.IfcRelConnectsStructuralMember = IfcRelConnectsStructuralMember;

  var IfcRelConnectsWithEccentricity = /*#__PURE__*/function (_IfcRelConnectsStruct3) {
    _inherits(IfcRelConnectsWithEccentricity, _IfcRelConnectsStruct3);

    var _super1987 = _createSuper(IfcRelConnectsWithEccentricity);

    function IfcRelConnectsWithEccentricity(expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem, ConnectionConstraint) {
      var _this1979;

      _classCallCheck2(this, IfcRelConnectsWithEccentricity);

      _this1979 = _super1987.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatingStructuralMember, RelatedStructuralConnection, AppliedCondition, AdditionalConditions, SupportedLength, ConditionCoordinateSystem);
      _this1979.GlobalId = GlobalId;
      _this1979.OwnerHistory = OwnerHistory;
      _this1979.Name = Name;
      _this1979.Description = Description;
      _this1979.RelatingStructuralMember = RelatingStructuralMember;
      _this1979.RelatedStructuralConnection = RelatedStructuralConnection;
      _this1979.AppliedCondition = AppliedCondition;
      _this1979.AdditionalConditions = AdditionalConditions;
      _this1979.SupportedLength = SupportedLength;
      _this1979.ConditionCoordinateSystem = ConditionCoordinateSystem;
      _this1979.ConnectionConstraint = ConnectionConstraint;
      _this1979.type = 504942748;
      return _this1979;
    }

    return IfcRelConnectsWithEccentricity;
  }(IfcRelConnectsStructuralMember);

  IFC42.IfcRelConnectsWithEccentricity = IfcRelConnectsWithEccentricity;

  var IfcRelConnectsWithRealizingElements = /*#__PURE__*/function (_IfcRelConnectsElemen6) {
    _inherits(IfcRelConnectsWithRealizingElements, _IfcRelConnectsElemen6);

    var _super1988 = _createSuper(IfcRelConnectsWithRealizingElements);

    function IfcRelConnectsWithRealizingElements(expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement, RealizingElements, ConnectionType) {
      var _this1980;

      _classCallCheck2(this, IfcRelConnectsWithRealizingElements);

      _this1980 = _super1988.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ConnectionGeometry, RelatingElement, RelatedElement);
      _this1980.GlobalId = GlobalId;
      _this1980.OwnerHistory = OwnerHistory;
      _this1980.Name = Name;
      _this1980.Description = Description;
      _this1980.ConnectionGeometry = ConnectionGeometry;
      _this1980.RelatingElement = RelatingElement;
      _this1980.RelatedElement = RelatedElement;
      _this1980.RealizingElements = RealizingElements;
      _this1980.ConnectionType = ConnectionType;
      _this1980.type = 3678494232;
      return _this1980;
    }

    return IfcRelConnectsWithRealizingElements;
  }(IfcRelConnectsElements);

  IFC42.IfcRelConnectsWithRealizingElements = IfcRelConnectsWithRealizingElements;

  var IfcRelContainedInSpatialStructure = /*#__PURE__*/function (_IfcRelConnects40) {
    _inherits(IfcRelContainedInSpatialStructure, _IfcRelConnects40);

    var _super1989 = _createSuper(IfcRelContainedInSpatialStructure);

    function IfcRelContainedInSpatialStructure(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      var _this1981;

      _classCallCheck2(this, IfcRelContainedInSpatialStructure);

      _this1981 = _super1989.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1981.GlobalId = GlobalId;
      _this1981.OwnerHistory = OwnerHistory;
      _this1981.Name = Name;
      _this1981.Description = Description;
      _this1981.RelatedElements = RelatedElements;
      _this1981.RelatingStructure = RelatingStructure;
      _this1981.type = 3242617779;
      return _this1981;
    }

    return IfcRelContainedInSpatialStructure;
  }(IfcRelConnects);

  IFC42.IfcRelContainedInSpatialStructure = IfcRelContainedInSpatialStructure;

  var IfcRelCoversBldgElements = /*#__PURE__*/function (_IfcRelConnects41) {
    _inherits(IfcRelCoversBldgElements, _IfcRelConnects41);

    var _super1990 = _createSuper(IfcRelCoversBldgElements);

    function IfcRelCoversBldgElements(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedCoverings) {
      var _this1982;

      _classCallCheck2(this, IfcRelCoversBldgElements);

      _this1982 = _super1990.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1982.GlobalId = GlobalId;
      _this1982.OwnerHistory = OwnerHistory;
      _this1982.Name = Name;
      _this1982.Description = Description;
      _this1982.RelatingBuildingElement = RelatingBuildingElement;
      _this1982.RelatedCoverings = RelatedCoverings;
      _this1982.type = 886880790;
      return _this1982;
    }

    return IfcRelCoversBldgElements;
  }(IfcRelConnects);

  IFC42.IfcRelCoversBldgElements = IfcRelCoversBldgElements;

  var IfcRelCoversSpaces = /*#__PURE__*/function (_IfcRelConnects42) {
    _inherits(IfcRelCoversSpaces, _IfcRelConnects42);

    var _super1991 = _createSuper(IfcRelCoversSpaces);

    function IfcRelCoversSpaces(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedCoverings) {
      var _this1983;

      _classCallCheck2(this, IfcRelCoversSpaces);

      _this1983 = _super1991.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1983.GlobalId = GlobalId;
      _this1983.OwnerHistory = OwnerHistory;
      _this1983.Name = Name;
      _this1983.Description = Description;
      _this1983.RelatingSpace = RelatingSpace;
      _this1983.RelatedCoverings = RelatedCoverings;
      _this1983.type = 2802773753;
      return _this1983;
    }

    return IfcRelCoversSpaces;
  }(IfcRelConnects);

  IFC42.IfcRelCoversSpaces = IfcRelCoversSpaces;

  var IfcRelDeclares = /*#__PURE__*/function (_IfcRelationship15) {
    _inherits(IfcRelDeclares, _IfcRelationship15);

    var _super1992 = _createSuper(IfcRelDeclares);

    function IfcRelDeclares(expressID, GlobalId, OwnerHistory, Name, Description, RelatingContext, RelatedDefinitions) {
      var _this1984;

      _classCallCheck2(this, IfcRelDeclares);

      _this1984 = _super1992.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1984.GlobalId = GlobalId;
      _this1984.OwnerHistory = OwnerHistory;
      _this1984.Name = Name;
      _this1984.Description = Description;
      _this1984.RelatingContext = RelatingContext;
      _this1984.RelatedDefinitions = RelatedDefinitions;
      _this1984.type = 2565941209;
      return _this1984;
    }

    return IfcRelDeclares;
  }(IfcRelationship);

  IFC42.IfcRelDeclares = IfcRelDeclares;

  var IfcRelDecomposes = /*#__PURE__*/function (_IfcRelationship16) {
    _inherits(IfcRelDecomposes, _IfcRelationship16);

    var _super1993 = _createSuper(IfcRelDecomposes);

    function IfcRelDecomposes(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1985;

      _classCallCheck2(this, IfcRelDecomposes);

      _this1985 = _super1993.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1985.GlobalId = GlobalId;
      _this1985.OwnerHistory = OwnerHistory;
      _this1985.Name = Name;
      _this1985.Description = Description;
      _this1985.type = 2551354335;
      return _this1985;
    }

    return IfcRelDecomposes;
  }(IfcRelationship);

  IFC42.IfcRelDecomposes = IfcRelDecomposes;

  var IfcRelDefines = /*#__PURE__*/function (_IfcRelationship17) {
    _inherits(IfcRelDefines, _IfcRelationship17);

    var _super1994 = _createSuper(IfcRelDefines);

    function IfcRelDefines(expressID, GlobalId, OwnerHistory, Name, Description) {
      var _this1986;

      _classCallCheck2(this, IfcRelDefines);

      _this1986 = _super1994.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1986.GlobalId = GlobalId;
      _this1986.OwnerHistory = OwnerHistory;
      _this1986.Name = Name;
      _this1986.Description = Description;
      _this1986.type = 693640335;
      return _this1986;
    }

    return IfcRelDefines;
  }(IfcRelationship);

  IFC42.IfcRelDefines = IfcRelDefines;

  var IfcRelDefinesByObject = /*#__PURE__*/function (_IfcRelDefines7) {
    _inherits(IfcRelDefinesByObject, _IfcRelDefines7);

    var _super1995 = _createSuper(IfcRelDefinesByObject);

    function IfcRelDefinesByObject(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingObject) {
      var _this1987;

      _classCallCheck2(this, IfcRelDefinesByObject);

      _this1987 = _super1995.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1987.GlobalId = GlobalId;
      _this1987.OwnerHistory = OwnerHistory;
      _this1987.Name = Name;
      _this1987.Description = Description;
      _this1987.RelatedObjects = RelatedObjects;
      _this1987.RelatingObject = RelatingObject;
      _this1987.type = 1462361463;
      return _this1987;
    }

    return IfcRelDefinesByObject;
  }(IfcRelDefines);

  IFC42.IfcRelDefinesByObject = IfcRelDefinesByObject;

  var IfcRelDefinesByProperties = /*#__PURE__*/function (_IfcRelDefines8) {
    _inherits(IfcRelDefinesByProperties, _IfcRelDefines8);

    var _super1996 = _createSuper(IfcRelDefinesByProperties);

    function IfcRelDefinesByProperties(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingPropertyDefinition) {
      var _this1988;

      _classCallCheck2(this, IfcRelDefinesByProperties);

      _this1988 = _super1996.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1988.GlobalId = GlobalId;
      _this1988.OwnerHistory = OwnerHistory;
      _this1988.Name = Name;
      _this1988.Description = Description;
      _this1988.RelatedObjects = RelatedObjects;
      _this1988.RelatingPropertyDefinition = RelatingPropertyDefinition;
      _this1988.type = 4186316022;
      return _this1988;
    }

    return IfcRelDefinesByProperties;
  }(IfcRelDefines);

  IFC42.IfcRelDefinesByProperties = IfcRelDefinesByProperties;

  var IfcRelDefinesByTemplate = /*#__PURE__*/function (_IfcRelDefines9) {
    _inherits(IfcRelDefinesByTemplate, _IfcRelDefines9);

    var _super1997 = _createSuper(IfcRelDefinesByTemplate);

    function IfcRelDefinesByTemplate(expressID, GlobalId, OwnerHistory, Name, Description, RelatedPropertySets, RelatingTemplate) {
      var _this1989;

      _classCallCheck2(this, IfcRelDefinesByTemplate);

      _this1989 = _super1997.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1989.GlobalId = GlobalId;
      _this1989.OwnerHistory = OwnerHistory;
      _this1989.Name = Name;
      _this1989.Description = Description;
      _this1989.RelatedPropertySets = RelatedPropertySets;
      _this1989.RelatingTemplate = RelatingTemplate;
      _this1989.type = 307848117;
      return _this1989;
    }

    return IfcRelDefinesByTemplate;
  }(IfcRelDefines);

  IFC42.IfcRelDefinesByTemplate = IfcRelDefinesByTemplate;

  var IfcRelDefinesByType = /*#__PURE__*/function (_IfcRelDefines10) {
    _inherits(IfcRelDefinesByType, _IfcRelDefines10);

    var _super1998 = _createSuper(IfcRelDefinesByType);

    function IfcRelDefinesByType(expressID, GlobalId, OwnerHistory, Name, Description, RelatedObjects, RelatingType) {
      var _this1990;

      _classCallCheck2(this, IfcRelDefinesByType);

      _this1990 = _super1998.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1990.GlobalId = GlobalId;
      _this1990.OwnerHistory = OwnerHistory;
      _this1990.Name = Name;
      _this1990.Description = Description;
      _this1990.RelatedObjects = RelatedObjects;
      _this1990.RelatingType = RelatingType;
      _this1990.type = 781010003;
      return _this1990;
    }

    return IfcRelDefinesByType;
  }(IfcRelDefines);

  IFC42.IfcRelDefinesByType = IfcRelDefinesByType;

  var IfcRelFillsElement = /*#__PURE__*/function (_IfcRelConnects43) {
    _inherits(IfcRelFillsElement, _IfcRelConnects43);

    var _super1999 = _createSuper(IfcRelFillsElement);

    function IfcRelFillsElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingOpeningElement, RelatedBuildingElement) {
      var _this1991;

      _classCallCheck2(this, IfcRelFillsElement);

      _this1991 = _super1999.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1991.GlobalId = GlobalId;
      _this1991.OwnerHistory = OwnerHistory;
      _this1991.Name = Name;
      _this1991.Description = Description;
      _this1991.RelatingOpeningElement = RelatingOpeningElement;
      _this1991.RelatedBuildingElement = RelatedBuildingElement;
      _this1991.type = 3940055652;
      return _this1991;
    }

    return IfcRelFillsElement;
  }(IfcRelConnects);

  IFC42.IfcRelFillsElement = IfcRelFillsElement;

  var IfcRelFlowControlElements = /*#__PURE__*/function (_IfcRelConnects44) {
    _inherits(IfcRelFlowControlElements, _IfcRelConnects44);

    var _super2000 = _createSuper(IfcRelFlowControlElements);

    function IfcRelFlowControlElements(expressID, GlobalId, OwnerHistory, Name, Description, RelatedControlElements, RelatingFlowElement) {
      var _this1992;

      _classCallCheck2(this, IfcRelFlowControlElements);

      _this1992 = _super2000.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1992.GlobalId = GlobalId;
      _this1992.OwnerHistory = OwnerHistory;
      _this1992.Name = Name;
      _this1992.Description = Description;
      _this1992.RelatedControlElements = RelatedControlElements;
      _this1992.RelatingFlowElement = RelatingFlowElement;
      _this1992.type = 279856033;
      return _this1992;
    }

    return IfcRelFlowControlElements;
  }(IfcRelConnects);

  IFC42.IfcRelFlowControlElements = IfcRelFlowControlElements;

  var IfcRelInterferesElements = /*#__PURE__*/function (_IfcRelConnects45) {
    _inherits(IfcRelInterferesElements, _IfcRelConnects45);

    var _super2001 = _createSuper(IfcRelInterferesElements);

    function IfcRelInterferesElements(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedElement, InterferenceGeometry, InterferenceType, ImpliedOrder) {
      var _this1993;

      _classCallCheck2(this, IfcRelInterferesElements);

      _this1993 = _super2001.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1993.GlobalId = GlobalId;
      _this1993.OwnerHistory = OwnerHistory;
      _this1993.Name = Name;
      _this1993.Description = Description;
      _this1993.RelatingElement = RelatingElement;
      _this1993.RelatedElement = RelatedElement;
      _this1993.InterferenceGeometry = InterferenceGeometry;
      _this1993.InterferenceType = InterferenceType;
      _this1993.ImpliedOrder = ImpliedOrder;
      _this1993.type = 427948657;
      return _this1993;
    }

    return IfcRelInterferesElements;
  }(IfcRelConnects);

  IFC42.IfcRelInterferesElements = IfcRelInterferesElements;

  var IfcRelNests = /*#__PURE__*/function (_IfcRelDecomposes8) {
    _inherits(IfcRelNests, _IfcRelDecomposes8);

    var _super2002 = _createSuper(IfcRelNests);

    function IfcRelNests(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      var _this1994;

      _classCallCheck2(this, IfcRelNests);

      _this1994 = _super2002.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1994.GlobalId = GlobalId;
      _this1994.OwnerHistory = OwnerHistory;
      _this1994.Name = Name;
      _this1994.Description = Description;
      _this1994.RelatingObject = RelatingObject;
      _this1994.RelatedObjects = RelatedObjects;
      _this1994.type = 3268803585;
      return _this1994;
    }

    return IfcRelNests;
  }(IfcRelDecomposes);

  IFC42.IfcRelNests = IfcRelNests;

  var IfcRelProjectsElement = /*#__PURE__*/function (_IfcRelDecomposes9) {
    _inherits(IfcRelProjectsElement, _IfcRelDecomposes9);

    var _super2003 = _createSuper(IfcRelProjectsElement);

    function IfcRelProjectsElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingElement, RelatedFeatureElement) {
      var _this1995;

      _classCallCheck2(this, IfcRelProjectsElement);

      _this1995 = _super2003.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1995.GlobalId = GlobalId;
      _this1995.OwnerHistory = OwnerHistory;
      _this1995.Name = Name;
      _this1995.Description = Description;
      _this1995.RelatingElement = RelatingElement;
      _this1995.RelatedFeatureElement = RelatedFeatureElement;
      _this1995.type = 750771296;
      return _this1995;
    }

    return IfcRelProjectsElement;
  }(IfcRelDecomposes);

  IFC42.IfcRelProjectsElement = IfcRelProjectsElement;

  var IfcRelReferencedInSpatialStructure = /*#__PURE__*/function (_IfcRelConnects46) {
    _inherits(IfcRelReferencedInSpatialStructure, _IfcRelConnects46);

    var _super2004 = _createSuper(IfcRelReferencedInSpatialStructure);

    function IfcRelReferencedInSpatialStructure(expressID, GlobalId, OwnerHistory, Name, Description, RelatedElements, RelatingStructure) {
      var _this1996;

      _classCallCheck2(this, IfcRelReferencedInSpatialStructure);

      _this1996 = _super2004.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1996.GlobalId = GlobalId;
      _this1996.OwnerHistory = OwnerHistory;
      _this1996.Name = Name;
      _this1996.Description = Description;
      _this1996.RelatedElements = RelatedElements;
      _this1996.RelatingStructure = RelatingStructure;
      _this1996.type = 1245217292;
      return _this1996;
    }

    return IfcRelReferencedInSpatialStructure;
  }(IfcRelConnects);

  IFC42.IfcRelReferencedInSpatialStructure = IfcRelReferencedInSpatialStructure;

  var IfcRelSequence = /*#__PURE__*/function (_IfcRelConnects47) {
    _inherits(IfcRelSequence, _IfcRelConnects47);

    var _super2005 = _createSuper(IfcRelSequence);

    function IfcRelSequence(expressID, GlobalId, OwnerHistory, Name, Description, RelatingProcess, RelatedProcess, TimeLag, SequenceType, UserDefinedSequenceType) {
      var _this1997;

      _classCallCheck2(this, IfcRelSequence);

      _this1997 = _super2005.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1997.GlobalId = GlobalId;
      _this1997.OwnerHistory = OwnerHistory;
      _this1997.Name = Name;
      _this1997.Description = Description;
      _this1997.RelatingProcess = RelatingProcess;
      _this1997.RelatedProcess = RelatedProcess;
      _this1997.TimeLag = TimeLag;
      _this1997.SequenceType = SequenceType;
      _this1997.UserDefinedSequenceType = UserDefinedSequenceType;
      _this1997.type = 4122056220;
      return _this1997;
    }

    return IfcRelSequence;
  }(IfcRelConnects);

  IFC42.IfcRelSequence = IfcRelSequence;

  var IfcRelServicesBuildings = /*#__PURE__*/function (_IfcRelConnects48) {
    _inherits(IfcRelServicesBuildings, _IfcRelConnects48);

    var _super2006 = _createSuper(IfcRelServicesBuildings);

    function IfcRelServicesBuildings(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSystem, RelatedBuildings) {
      var _this1998;

      _classCallCheck2(this, IfcRelServicesBuildings);

      _this1998 = _super2006.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1998.GlobalId = GlobalId;
      _this1998.OwnerHistory = OwnerHistory;
      _this1998.Name = Name;
      _this1998.Description = Description;
      _this1998.RelatingSystem = RelatingSystem;
      _this1998.RelatedBuildings = RelatedBuildings;
      _this1998.type = 366585022;
      return _this1998;
    }

    return IfcRelServicesBuildings;
  }(IfcRelConnects);

  IFC42.IfcRelServicesBuildings = IfcRelServicesBuildings;

  var IfcRelSpaceBoundary = /*#__PURE__*/function (_IfcRelConnects49) {
    _inherits(IfcRelSpaceBoundary, _IfcRelConnects49);

    var _super2007 = _createSuper(IfcRelSpaceBoundary);

    function IfcRelSpaceBoundary(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary) {
      var _this1999;

      _classCallCheck2(this, IfcRelSpaceBoundary);

      _this1999 = _super2007.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this1999.GlobalId = GlobalId;
      _this1999.OwnerHistory = OwnerHistory;
      _this1999.Name = Name;
      _this1999.Description = Description;
      _this1999.RelatingSpace = RelatingSpace;
      _this1999.RelatedBuildingElement = RelatedBuildingElement;
      _this1999.ConnectionGeometry = ConnectionGeometry;
      _this1999.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      _this1999.InternalOrExternalBoundary = InternalOrExternalBoundary;
      _this1999.type = 3451746338;
      return _this1999;
    }

    return IfcRelSpaceBoundary;
  }(IfcRelConnects);

  IFC42.IfcRelSpaceBoundary = IfcRelSpaceBoundary;

  var IfcRelSpaceBoundary1stLevel = /*#__PURE__*/function (_IfcRelSpaceBoundary3) {
    _inherits(IfcRelSpaceBoundary1stLevel, _IfcRelSpaceBoundary3);

    var _super2008 = _createSuper(IfcRelSpaceBoundary1stLevel);

    function IfcRelSpaceBoundary1stLevel(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary) {
      var _this2000;

      _classCallCheck2(this, IfcRelSpaceBoundary1stLevel);

      _this2000 = _super2008.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary);
      _this2000.GlobalId = GlobalId;
      _this2000.OwnerHistory = OwnerHistory;
      _this2000.Name = Name;
      _this2000.Description = Description;
      _this2000.RelatingSpace = RelatingSpace;
      _this2000.RelatedBuildingElement = RelatedBuildingElement;
      _this2000.ConnectionGeometry = ConnectionGeometry;
      _this2000.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      _this2000.InternalOrExternalBoundary = InternalOrExternalBoundary;
      _this2000.ParentBoundary = ParentBoundary;
      _this2000.type = 3523091289;
      return _this2000;
    }

    return IfcRelSpaceBoundary1stLevel;
  }(IfcRelSpaceBoundary);

  IFC42.IfcRelSpaceBoundary1stLevel = IfcRelSpaceBoundary1stLevel;

  var IfcRelSpaceBoundary2ndLevel = /*#__PURE__*/function (_IfcRelSpaceBoundary4) {
    _inherits(IfcRelSpaceBoundary2ndLevel, _IfcRelSpaceBoundary4);

    var _super2009 = _createSuper(IfcRelSpaceBoundary2ndLevel);

    function IfcRelSpaceBoundary2ndLevel(expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary, CorrespondingBoundary) {
      var _this2001;

      _classCallCheck2(this, IfcRelSpaceBoundary2ndLevel);

      _this2001 = _super2009.call(this, expressID, GlobalId, OwnerHistory, Name, Description, RelatingSpace, RelatedBuildingElement, ConnectionGeometry, PhysicalOrVirtualBoundary, InternalOrExternalBoundary, ParentBoundary);
      _this2001.GlobalId = GlobalId;
      _this2001.OwnerHistory = OwnerHistory;
      _this2001.Name = Name;
      _this2001.Description = Description;
      _this2001.RelatingSpace = RelatingSpace;
      _this2001.RelatedBuildingElement = RelatedBuildingElement;
      _this2001.ConnectionGeometry = ConnectionGeometry;
      _this2001.PhysicalOrVirtualBoundary = PhysicalOrVirtualBoundary;
      _this2001.InternalOrExternalBoundary = InternalOrExternalBoundary;
      _this2001.ParentBoundary = ParentBoundary;
      _this2001.CorrespondingBoundary = CorrespondingBoundary;
      _this2001.type = 1521410863;
      return _this2001;
    }

    return IfcRelSpaceBoundary2ndLevel;
  }(IfcRelSpaceBoundary1stLevel);

  IFC42.IfcRelSpaceBoundary2ndLevel = IfcRelSpaceBoundary2ndLevel;

  var IfcRelVoidsElement = /*#__PURE__*/function (_IfcRelDecomposes10) {
    _inherits(IfcRelVoidsElement, _IfcRelDecomposes10);

    var _super2010 = _createSuper(IfcRelVoidsElement);

    function IfcRelVoidsElement(expressID, GlobalId, OwnerHistory, Name, Description, RelatingBuildingElement, RelatedOpeningElement) {
      var _this2002;

      _classCallCheck2(this, IfcRelVoidsElement);

      _this2002 = _super2010.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this2002.GlobalId = GlobalId;
      _this2002.OwnerHistory = OwnerHistory;
      _this2002.Name = Name;
      _this2002.Description = Description;
      _this2002.RelatingBuildingElement = RelatingBuildingElement;
      _this2002.RelatedOpeningElement = RelatedOpeningElement;
      _this2002.type = 1401173127;
      return _this2002;
    }

    return IfcRelVoidsElement;
  }(IfcRelDecomposes);

  IFC42.IfcRelVoidsElement = IfcRelVoidsElement;

  var IfcReparametrisedCompositeCurveSegment = /*#__PURE__*/function (_IfcCompositeCurveSeg2) {
    _inherits(IfcReparametrisedCompositeCurveSegment, _IfcCompositeCurveSeg2);

    var _super2011 = _createSuper(IfcReparametrisedCompositeCurveSegment);

    function IfcReparametrisedCompositeCurveSegment(expressID, Transition, SameSense, ParentCurve, ParamLength) {
      var _this2003;

      _classCallCheck2(this, IfcReparametrisedCompositeCurveSegment);

      _this2003 = _super2011.call(this, expressID, Transition, SameSense, ParentCurve);
      _this2003.Transition = Transition;
      _this2003.SameSense = SameSense;
      _this2003.ParentCurve = ParentCurve;
      _this2003.ParamLength = ParamLength;
      _this2003.type = 816062949;
      return _this2003;
    }

    return IfcReparametrisedCompositeCurveSegment;
  }(IfcCompositeCurveSegment);

  IFC42.IfcReparametrisedCompositeCurveSegment = IfcReparametrisedCompositeCurveSegment;

  var IfcResource = /*#__PURE__*/function (_IfcObject16) {
    _inherits(IfcResource, _IfcObject16);

    var _super2012 = _createSuper(IfcResource);

    function IfcResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription) {
      var _this2004;

      _classCallCheck2(this, IfcResource);

      _this2004 = _super2012.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2004.GlobalId = GlobalId;
      _this2004.OwnerHistory = OwnerHistory;
      _this2004.Name = Name;
      _this2004.Description = Description;
      _this2004.ObjectType = ObjectType;
      _this2004.Identification = Identification;
      _this2004.LongDescription = LongDescription;
      _this2004.type = 2914609552;
      return _this2004;
    }

    return IfcResource;
  }(IfcObject);

  IFC42.IfcResource = IfcResource;

  var IfcRevolvedAreaSolid = /*#__PURE__*/function (_IfcSweptAreaSolid9) {
    _inherits(IfcRevolvedAreaSolid, _IfcSweptAreaSolid9);

    var _super2013 = _createSuper(IfcRevolvedAreaSolid);

    function IfcRevolvedAreaSolid(expressID, SweptArea, Position, Axis, Angle) {
      var _this2005;

      _classCallCheck2(this, IfcRevolvedAreaSolid);

      _this2005 = _super2013.call(this, expressID, SweptArea, Position);
      _this2005.SweptArea = SweptArea;
      _this2005.Position = Position;
      _this2005.Axis = Axis;
      _this2005.Angle = Angle;
      _this2005.type = 1856042241;
      return _this2005;
    }

    return IfcRevolvedAreaSolid;
  }(IfcSweptAreaSolid);

  IFC42.IfcRevolvedAreaSolid = IfcRevolvedAreaSolid;

  var IfcRevolvedAreaSolidTapered = /*#__PURE__*/function (_IfcRevolvedAreaSolid2) {
    _inherits(IfcRevolvedAreaSolidTapered, _IfcRevolvedAreaSolid2);

    var _super2014 = _createSuper(IfcRevolvedAreaSolidTapered);

    function IfcRevolvedAreaSolidTapered(expressID, SweptArea, Position, Axis, Angle, EndSweptArea) {
      var _this2006;

      _classCallCheck2(this, IfcRevolvedAreaSolidTapered);

      _this2006 = _super2014.call(this, expressID, SweptArea, Position, Axis, Angle);
      _this2006.SweptArea = SweptArea;
      _this2006.Position = Position;
      _this2006.Axis = Axis;
      _this2006.Angle = Angle;
      _this2006.EndSweptArea = EndSweptArea;
      _this2006.type = 3243963512;
      return _this2006;
    }

    return IfcRevolvedAreaSolidTapered;
  }(IfcRevolvedAreaSolid);

  IFC42.IfcRevolvedAreaSolidTapered = IfcRevolvedAreaSolidTapered;

  var IfcRightCircularCone = /*#__PURE__*/function (_IfcCsgPrimitive3D12) {
    _inherits(IfcRightCircularCone, _IfcCsgPrimitive3D12);

    var _super2015 = _createSuper(IfcRightCircularCone);

    function IfcRightCircularCone(expressID, Position, Height, BottomRadius) {
      var _this2007;

      _classCallCheck2(this, IfcRightCircularCone);

      _this2007 = _super2015.call(this, expressID, Position);
      _this2007.Position = Position;
      _this2007.Height = Height;
      _this2007.BottomRadius = BottomRadius;
      _this2007.type = 4158566097;
      return _this2007;
    }

    return IfcRightCircularCone;
  }(IfcCsgPrimitive3D);

  IFC42.IfcRightCircularCone = IfcRightCircularCone;

  var IfcRightCircularCylinder = /*#__PURE__*/function (_IfcCsgPrimitive3D13) {
    _inherits(IfcRightCircularCylinder, _IfcCsgPrimitive3D13);

    var _super2016 = _createSuper(IfcRightCircularCylinder);

    function IfcRightCircularCylinder(expressID, Position, Height, Radius) {
      var _this2008;

      _classCallCheck2(this, IfcRightCircularCylinder);

      _this2008 = _super2016.call(this, expressID, Position);
      _this2008.Position = Position;
      _this2008.Height = Height;
      _this2008.Radius = Radius;
      _this2008.type = 3626867408;
      return _this2008;
    }

    return IfcRightCircularCylinder;
  }(IfcCsgPrimitive3D);

  IFC42.IfcRightCircularCylinder = IfcRightCircularCylinder;

  var IfcSimplePropertyTemplate = /*#__PURE__*/function (_IfcPropertyTemplate3) {
    _inherits(IfcSimplePropertyTemplate, _IfcPropertyTemplate3);

    var _super2017 = _createSuper(IfcSimplePropertyTemplate);

    function IfcSimplePropertyTemplate(expressID, GlobalId, OwnerHistory, Name, Description, TemplateType, PrimaryMeasureType, SecondaryMeasureType, Enumerators, PrimaryUnit, SecondaryUnit, Expression, AccessState) {
      var _this2009;

      _classCallCheck2(this, IfcSimplePropertyTemplate);

      _this2009 = _super2017.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this2009.GlobalId = GlobalId;
      _this2009.OwnerHistory = OwnerHistory;
      _this2009.Name = Name;
      _this2009.Description = Description;
      _this2009.TemplateType = TemplateType;
      _this2009.PrimaryMeasureType = PrimaryMeasureType;
      _this2009.SecondaryMeasureType = SecondaryMeasureType;
      _this2009.Enumerators = Enumerators;
      _this2009.PrimaryUnit = PrimaryUnit;
      _this2009.SecondaryUnit = SecondaryUnit;
      _this2009.Expression = Expression;
      _this2009.AccessState = AccessState;
      _this2009.type = 3663146110;
      return _this2009;
    }

    return IfcSimplePropertyTemplate;
  }(IfcPropertyTemplate);

  IFC42.IfcSimplePropertyTemplate = IfcSimplePropertyTemplate;

  var IfcSpatialElement = /*#__PURE__*/function (_IfcProduct18) {
    _inherits(IfcSpatialElement, _IfcProduct18);

    var _super2018 = _createSuper(IfcSpatialElement);

    function IfcSpatialElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      var _this2010;

      _classCallCheck2(this, IfcSpatialElement);

      _this2010 = _super2018.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2010.GlobalId = GlobalId;
      _this2010.OwnerHistory = OwnerHistory;
      _this2010.Name = Name;
      _this2010.Description = Description;
      _this2010.ObjectType = ObjectType;
      _this2010.ObjectPlacement = ObjectPlacement;
      _this2010.Representation = Representation;
      _this2010.LongName = LongName;
      _this2010.type = 1412071761;
      return _this2010;
    }

    return IfcSpatialElement;
  }(IfcProduct);

  IFC42.IfcSpatialElement = IfcSpatialElement;

  var IfcSpatialElementType = /*#__PURE__*/function (_IfcTypeProduct9) {
    _inherits(IfcSpatialElementType, _IfcTypeProduct9);

    var _super2019 = _createSuper(IfcSpatialElementType);

    function IfcSpatialElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2011;

      _classCallCheck2(this, IfcSpatialElementType);

      _this2011 = _super2019.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag);
      _this2011.GlobalId = GlobalId;
      _this2011.OwnerHistory = OwnerHistory;
      _this2011.Name = Name;
      _this2011.Description = Description;
      _this2011.ApplicableOccurrence = ApplicableOccurrence;
      _this2011.HasPropertySets = HasPropertySets;
      _this2011.RepresentationMaps = RepresentationMaps;
      _this2011.Tag = Tag;
      _this2011.ElementType = ElementType;
      _this2011.type = 710998568;
      return _this2011;
    }

    return IfcSpatialElementType;
  }(IfcTypeProduct);

  IFC42.IfcSpatialElementType = IfcSpatialElementType;

  var IfcSpatialStructureElement = /*#__PURE__*/function (_IfcSpatialElement4) {
    _inherits(IfcSpatialStructureElement, _IfcSpatialElement4);

    var _super2020 = _createSuper(IfcSpatialStructureElement);

    function IfcSpatialStructureElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType) {
      var _this2012;

      _classCallCheck2(this, IfcSpatialStructureElement);

      _this2012 = _super2020.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      _this2012.GlobalId = GlobalId;
      _this2012.OwnerHistory = OwnerHistory;
      _this2012.Name = Name;
      _this2012.Description = Description;
      _this2012.ObjectType = ObjectType;
      _this2012.ObjectPlacement = ObjectPlacement;
      _this2012.Representation = Representation;
      _this2012.LongName = LongName;
      _this2012.CompositionType = CompositionType;
      _this2012.type = 2706606064;
      return _this2012;
    }

    return IfcSpatialStructureElement;
  }(IfcSpatialElement);

  IFC42.IfcSpatialStructureElement = IfcSpatialStructureElement;

  var IfcSpatialStructureElementType = /*#__PURE__*/function (_IfcSpatialElementTyp3) {
    _inherits(IfcSpatialStructureElementType, _IfcSpatialElementTyp3);

    var _super2021 = _createSuper(IfcSpatialStructureElementType);

    function IfcSpatialStructureElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2013;

      _classCallCheck2(this, IfcSpatialStructureElementType);

      _this2013 = _super2021.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2013.GlobalId = GlobalId;
      _this2013.OwnerHistory = OwnerHistory;
      _this2013.Name = Name;
      _this2013.Description = Description;
      _this2013.ApplicableOccurrence = ApplicableOccurrence;
      _this2013.HasPropertySets = HasPropertySets;
      _this2013.RepresentationMaps = RepresentationMaps;
      _this2013.Tag = Tag;
      _this2013.ElementType = ElementType;
      _this2013.type = 3893378262;
      return _this2013;
    }

    return IfcSpatialStructureElementType;
  }(IfcSpatialElementType);

  IFC42.IfcSpatialStructureElementType = IfcSpatialStructureElementType;

  var IfcSpatialZone = /*#__PURE__*/function (_IfcSpatialElement5) {
    _inherits(IfcSpatialZone, _IfcSpatialElement5);

    var _super2022 = _createSuper(IfcSpatialZone);

    function IfcSpatialZone(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      var _this2014;

      _classCallCheck2(this, IfcSpatialZone);

      _this2014 = _super2022.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      _this2014.GlobalId = GlobalId;
      _this2014.OwnerHistory = OwnerHistory;
      _this2014.Name = Name;
      _this2014.Description = Description;
      _this2014.ObjectType = ObjectType;
      _this2014.ObjectPlacement = ObjectPlacement;
      _this2014.Representation = Representation;
      _this2014.LongName = LongName;
      _this2014.PredefinedType = PredefinedType;
      _this2014.type = 463610769;
      return _this2014;
    }

    return IfcSpatialZone;
  }(IfcSpatialElement);

  IFC42.IfcSpatialZone = IfcSpatialZone;

  var IfcSpatialZoneType = /*#__PURE__*/function (_IfcSpatialElementTyp4) {
    _inherits(IfcSpatialZoneType, _IfcSpatialElementTyp4);

    var _super2023 = _createSuper(IfcSpatialZoneType);

    function IfcSpatialZoneType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      var _this2015;

      _classCallCheck2(this, IfcSpatialZoneType);

      _this2015 = _super2023.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2015.GlobalId = GlobalId;
      _this2015.OwnerHistory = OwnerHistory;
      _this2015.Name = Name;
      _this2015.Description = Description;
      _this2015.ApplicableOccurrence = ApplicableOccurrence;
      _this2015.HasPropertySets = HasPropertySets;
      _this2015.RepresentationMaps = RepresentationMaps;
      _this2015.Tag = Tag;
      _this2015.ElementType = ElementType;
      _this2015.PredefinedType = PredefinedType;
      _this2015.LongName = LongName;
      _this2015.type = 2481509218;
      return _this2015;
    }

    return IfcSpatialZoneType;
  }(IfcSpatialElementType);

  IFC42.IfcSpatialZoneType = IfcSpatialZoneType;

  var IfcSphere = /*#__PURE__*/function (_IfcCsgPrimitive3D14) {
    _inherits(IfcSphere, _IfcCsgPrimitive3D14);

    var _super2024 = _createSuper(IfcSphere);

    function IfcSphere(expressID, Position, Radius) {
      var _this2016;

      _classCallCheck2(this, IfcSphere);

      _this2016 = _super2024.call(this, expressID, Position);
      _this2016.Position = Position;
      _this2016.Radius = Radius;
      _this2016.type = 451544542;
      return _this2016;
    }

    return IfcSphere;
  }(IfcCsgPrimitive3D);

  IFC42.IfcSphere = IfcSphere;

  var IfcSphericalSurface = /*#__PURE__*/function (_IfcElementarySurface7) {
    _inherits(IfcSphericalSurface, _IfcElementarySurface7);

    var _super2025 = _createSuper(IfcSphericalSurface);

    function IfcSphericalSurface(expressID, Position, Radius) {
      var _this2017;

      _classCallCheck2(this, IfcSphericalSurface);

      _this2017 = _super2025.call(this, expressID, Position);
      _this2017.Position = Position;
      _this2017.Radius = Radius;
      _this2017.type = 4015995234;
      return _this2017;
    }

    return IfcSphericalSurface;
  }(IfcElementarySurface);

  IFC42.IfcSphericalSurface = IfcSphericalSurface;

  var IfcStructuralActivity = /*#__PURE__*/function (_IfcProduct19) {
    _inherits(IfcStructuralActivity, _IfcProduct19);

    var _super2026 = _createSuper(IfcStructuralActivity);

    function IfcStructuralActivity(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      var _this2018;

      _classCallCheck2(this, IfcStructuralActivity);

      _this2018 = _super2026.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2018.GlobalId = GlobalId;
      _this2018.OwnerHistory = OwnerHistory;
      _this2018.Name = Name;
      _this2018.Description = Description;
      _this2018.ObjectType = ObjectType;
      _this2018.ObjectPlacement = ObjectPlacement;
      _this2018.Representation = Representation;
      _this2018.AppliedLoad = AppliedLoad;
      _this2018.GlobalOrLocal = GlobalOrLocal;
      _this2018.type = 3544373492;
      return _this2018;
    }

    return IfcStructuralActivity;
  }(IfcProduct);

  IFC42.IfcStructuralActivity = IfcStructuralActivity;

  var IfcStructuralItem = /*#__PURE__*/function (_IfcProduct20) {
    _inherits(IfcStructuralItem, _IfcProduct20);

    var _super2027 = _createSuper(IfcStructuralItem);

    function IfcStructuralItem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this2019;

      _classCallCheck2(this, IfcStructuralItem);

      _this2019 = _super2027.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2019.GlobalId = GlobalId;
      _this2019.OwnerHistory = OwnerHistory;
      _this2019.Name = Name;
      _this2019.Description = Description;
      _this2019.ObjectType = ObjectType;
      _this2019.ObjectPlacement = ObjectPlacement;
      _this2019.Representation = Representation;
      _this2019.type = 3136571912;
      return _this2019;
    }

    return IfcStructuralItem;
  }(IfcProduct);

  IFC42.IfcStructuralItem = IfcStructuralItem;

  var IfcStructuralMember = /*#__PURE__*/function (_IfcStructuralItem5) {
    _inherits(IfcStructuralMember, _IfcStructuralItem5);

    var _super2028 = _createSuper(IfcStructuralMember);

    function IfcStructuralMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this2020;

      _classCallCheck2(this, IfcStructuralMember);

      _this2020 = _super2028.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2020.GlobalId = GlobalId;
      _this2020.OwnerHistory = OwnerHistory;
      _this2020.Name = Name;
      _this2020.Description = Description;
      _this2020.ObjectType = ObjectType;
      _this2020.ObjectPlacement = ObjectPlacement;
      _this2020.Representation = Representation;
      _this2020.type = 530289379;
      return _this2020;
    }

    return IfcStructuralMember;
  }(IfcStructuralItem);

  IFC42.IfcStructuralMember = IfcStructuralMember;

  var IfcStructuralReaction = /*#__PURE__*/function (_IfcStructuralActivit5) {
    _inherits(IfcStructuralReaction, _IfcStructuralActivit5);

    var _super2029 = _createSuper(IfcStructuralReaction);

    function IfcStructuralReaction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      var _this2021;

      _classCallCheck2(this, IfcStructuralReaction);

      _this2021 = _super2029.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this2021.GlobalId = GlobalId;
      _this2021.OwnerHistory = OwnerHistory;
      _this2021.Name = Name;
      _this2021.Description = Description;
      _this2021.ObjectType = ObjectType;
      _this2021.ObjectPlacement = ObjectPlacement;
      _this2021.Representation = Representation;
      _this2021.AppliedLoad = AppliedLoad;
      _this2021.GlobalOrLocal = GlobalOrLocal;
      _this2021.type = 3689010777;
      return _this2021;
    }

    return IfcStructuralReaction;
  }(IfcStructuralActivity);

  IFC42.IfcStructuralReaction = IfcStructuralReaction;

  var IfcStructuralSurfaceMember = /*#__PURE__*/function (_IfcStructuralMember5) {
    _inherits(IfcStructuralSurfaceMember, _IfcStructuralMember5);

    var _super2030 = _createSuper(IfcStructuralSurfaceMember);

    function IfcStructuralSurfaceMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      var _this2022;

      _classCallCheck2(this, IfcStructuralSurfaceMember);

      _this2022 = _super2030.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2022.GlobalId = GlobalId;
      _this2022.OwnerHistory = OwnerHistory;
      _this2022.Name = Name;
      _this2022.Description = Description;
      _this2022.ObjectType = ObjectType;
      _this2022.ObjectPlacement = ObjectPlacement;
      _this2022.Representation = Representation;
      _this2022.PredefinedType = PredefinedType;
      _this2022.Thickness = Thickness;
      _this2022.type = 3979015343;
      return _this2022;
    }

    return IfcStructuralSurfaceMember;
  }(IfcStructuralMember);

  IFC42.IfcStructuralSurfaceMember = IfcStructuralSurfaceMember;

  var IfcStructuralSurfaceMemberVarying = /*#__PURE__*/function (_IfcStructuralSurface4) {
    _inherits(IfcStructuralSurfaceMemberVarying, _IfcStructuralSurface4);

    var _super2031 = _createSuper(IfcStructuralSurfaceMemberVarying);

    function IfcStructuralSurfaceMemberVarying(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness) {
      var _this2023;

      _classCallCheck2(this, IfcStructuralSurfaceMemberVarying);

      _this2023 = _super2031.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Thickness);
      _this2023.GlobalId = GlobalId;
      _this2023.OwnerHistory = OwnerHistory;
      _this2023.Name = Name;
      _this2023.Description = Description;
      _this2023.ObjectType = ObjectType;
      _this2023.ObjectPlacement = ObjectPlacement;
      _this2023.Representation = Representation;
      _this2023.PredefinedType = PredefinedType;
      _this2023.Thickness = Thickness;
      _this2023.type = 2218152070;
      return _this2023;
    }

    return IfcStructuralSurfaceMemberVarying;
  }(IfcStructuralSurfaceMember);

  IFC42.IfcStructuralSurfaceMemberVarying = IfcStructuralSurfaceMemberVarying;

  var IfcStructuralSurfaceReaction = /*#__PURE__*/function (_IfcStructuralReactio5) {
    _inherits(IfcStructuralSurfaceReaction, _IfcStructuralReactio5);

    var _super2032 = _createSuper(IfcStructuralSurfaceReaction);

    function IfcStructuralSurfaceReaction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      var _this2024;

      _classCallCheck2(this, IfcStructuralSurfaceReaction);

      _this2024 = _super2032.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this2024.GlobalId = GlobalId;
      _this2024.OwnerHistory = OwnerHistory;
      _this2024.Name = Name;
      _this2024.Description = Description;
      _this2024.ObjectType = ObjectType;
      _this2024.ObjectPlacement = ObjectPlacement;
      _this2024.Representation = Representation;
      _this2024.AppliedLoad = AppliedLoad;
      _this2024.GlobalOrLocal = GlobalOrLocal;
      _this2024.PredefinedType = PredefinedType;
      _this2024.type = 603775116;
      return _this2024;
    }

    return IfcStructuralSurfaceReaction;
  }(IfcStructuralReaction);

  IFC42.IfcStructuralSurfaceReaction = IfcStructuralSurfaceReaction;

  var IfcSubContractResourceType = /*#__PURE__*/function (_IfcConstructionResou21) {
    _inherits(IfcSubContractResourceType, _IfcConstructionResou21);

    var _super2033 = _createSuper(IfcSubContractResourceType);

    function IfcSubContractResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this2025;

      _classCallCheck2(this, IfcSubContractResourceType);

      _this2025 = _super2033.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this2025.GlobalId = GlobalId;
      _this2025.OwnerHistory = OwnerHistory;
      _this2025.Name = Name;
      _this2025.Description = Description;
      _this2025.ApplicableOccurrence = ApplicableOccurrence;
      _this2025.HasPropertySets = HasPropertySets;
      _this2025.Identification = Identification;
      _this2025.LongDescription = LongDescription;
      _this2025.ResourceType = ResourceType;
      _this2025.BaseCosts = BaseCosts;
      _this2025.BaseQuantity = BaseQuantity;
      _this2025.PredefinedType = PredefinedType;
      _this2025.type = 4095615324;
      return _this2025;
    }

    return IfcSubContractResourceType;
  }(IfcConstructionResourceType);

  IFC42.IfcSubContractResourceType = IfcSubContractResourceType;

  var IfcSurfaceCurve = /*#__PURE__*/function (_IfcCurve18) {
    _inherits(IfcSurfaceCurve, _IfcCurve18);

    var _super2034 = _createSuper(IfcSurfaceCurve);

    function IfcSurfaceCurve(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      var _this2026;

      _classCallCheck2(this, IfcSurfaceCurve);

      _this2026 = _super2034.call(this, expressID);
      _this2026.Curve3D = Curve3D;
      _this2026.AssociatedGeometry = AssociatedGeometry;
      _this2026.MasterRepresentation = MasterRepresentation;
      _this2026.type = 699246055;
      return _this2026;
    }

    return IfcSurfaceCurve;
  }(IfcCurve);

  IFC42.IfcSurfaceCurve = IfcSurfaceCurve;

  var IfcSurfaceCurveSweptAreaSolid = /*#__PURE__*/function (_IfcSweptAreaSolid10) {
    _inherits(IfcSurfaceCurveSweptAreaSolid, _IfcSweptAreaSolid10);

    var _super2035 = _createSuper(IfcSurfaceCurveSweptAreaSolid);

    function IfcSurfaceCurveSweptAreaSolid(expressID, SweptArea, Position, Directrix, StartParam, EndParam, ReferenceSurface) {
      var _this2027;

      _classCallCheck2(this, IfcSurfaceCurveSweptAreaSolid);

      _this2027 = _super2035.call(this, expressID, SweptArea, Position);
      _this2027.SweptArea = SweptArea;
      _this2027.Position = Position;
      _this2027.Directrix = Directrix;
      _this2027.StartParam = StartParam;
      _this2027.EndParam = EndParam;
      _this2027.ReferenceSurface = ReferenceSurface;
      _this2027.type = 2028607225;
      return _this2027;
    }

    return IfcSurfaceCurveSweptAreaSolid;
  }(IfcSweptAreaSolid);

  IFC42.IfcSurfaceCurveSweptAreaSolid = IfcSurfaceCurveSweptAreaSolid;

  var IfcSurfaceOfLinearExtrusion = /*#__PURE__*/function (_IfcSweptSurface5) {
    _inherits(IfcSurfaceOfLinearExtrusion, _IfcSweptSurface5);

    var _super2036 = _createSuper(IfcSurfaceOfLinearExtrusion);

    function IfcSurfaceOfLinearExtrusion(expressID, SweptCurve, Position, ExtrudedDirection, Depth) {
      var _this2028;

      _classCallCheck2(this, IfcSurfaceOfLinearExtrusion);

      _this2028 = _super2036.call(this, expressID, SweptCurve, Position);
      _this2028.SweptCurve = SweptCurve;
      _this2028.Position = Position;
      _this2028.ExtrudedDirection = ExtrudedDirection;
      _this2028.Depth = Depth;
      _this2028.type = 2809605785;
      return _this2028;
    }

    return IfcSurfaceOfLinearExtrusion;
  }(IfcSweptSurface);

  IFC42.IfcSurfaceOfLinearExtrusion = IfcSurfaceOfLinearExtrusion;

  var IfcSurfaceOfRevolution = /*#__PURE__*/function (_IfcSweptSurface6) {
    _inherits(IfcSurfaceOfRevolution, _IfcSweptSurface6);

    var _super2037 = _createSuper(IfcSurfaceOfRevolution);

    function IfcSurfaceOfRevolution(expressID, SweptCurve, Position, AxisPosition) {
      var _this2029;

      _classCallCheck2(this, IfcSurfaceOfRevolution);

      _this2029 = _super2037.call(this, expressID, SweptCurve, Position);
      _this2029.SweptCurve = SweptCurve;
      _this2029.Position = Position;
      _this2029.AxisPosition = AxisPosition;
      _this2029.type = 4124788165;
      return _this2029;
    }

    return IfcSurfaceOfRevolution;
  }(IfcSweptSurface);

  IFC42.IfcSurfaceOfRevolution = IfcSurfaceOfRevolution;

  var IfcSystemFurnitureElementType = /*#__PURE__*/function (_IfcFurnishingElement8) {
    _inherits(IfcSystemFurnitureElementType, _IfcFurnishingElement8);

    var _super2038 = _createSuper(IfcSystemFurnitureElementType);

    function IfcSystemFurnitureElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2030;

      _classCallCheck2(this, IfcSystemFurnitureElementType);

      _this2030 = _super2038.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2030.GlobalId = GlobalId;
      _this2030.OwnerHistory = OwnerHistory;
      _this2030.Name = Name;
      _this2030.Description = Description;
      _this2030.ApplicableOccurrence = ApplicableOccurrence;
      _this2030.HasPropertySets = HasPropertySets;
      _this2030.RepresentationMaps = RepresentationMaps;
      _this2030.Tag = Tag;
      _this2030.ElementType = ElementType;
      _this2030.PredefinedType = PredefinedType;
      _this2030.type = 1580310250;
      return _this2030;
    }

    return IfcSystemFurnitureElementType;
  }(IfcFurnishingElementType);

  IFC42.IfcSystemFurnitureElementType = IfcSystemFurnitureElementType;

  var IfcTask = /*#__PURE__*/function (_IfcProcess6) {
    _inherits(IfcTask, _IfcProcess6);

    var _super2039 = _createSuper(IfcTask);

    function IfcTask(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Status, WorkMethod, IsMilestone, Priority, TaskTime, PredefinedType) {
      var _this2031;

      _classCallCheck2(this, IfcTask);

      _this2031 = _super2039.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      _this2031.GlobalId = GlobalId;
      _this2031.OwnerHistory = OwnerHistory;
      _this2031.Name = Name;
      _this2031.Description = Description;
      _this2031.ObjectType = ObjectType;
      _this2031.Identification = Identification;
      _this2031.LongDescription = LongDescription;
      _this2031.Status = Status;
      _this2031.WorkMethod = WorkMethod;
      _this2031.IsMilestone = IsMilestone;
      _this2031.Priority = Priority;
      _this2031.TaskTime = TaskTime;
      _this2031.PredefinedType = PredefinedType;
      _this2031.type = 3473067441;
      return _this2031;
    }

    return IfcTask;
  }(IfcProcess);

  IFC42.IfcTask = IfcTask;

  var IfcTaskType = /*#__PURE__*/function (_IfcTypeProcess6) {
    _inherits(IfcTaskType, _IfcTypeProcess6);

    var _super2040 = _createSuper(IfcTaskType);

    function IfcTaskType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType, PredefinedType, WorkMethod) {
      var _this2032;

      _classCallCheck2(this, IfcTaskType);

      _this2032 = _super2040.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ProcessType);
      _this2032.GlobalId = GlobalId;
      _this2032.OwnerHistory = OwnerHistory;
      _this2032.Name = Name;
      _this2032.Description = Description;
      _this2032.ApplicableOccurrence = ApplicableOccurrence;
      _this2032.HasPropertySets = HasPropertySets;
      _this2032.Identification = Identification;
      _this2032.LongDescription = LongDescription;
      _this2032.ProcessType = ProcessType;
      _this2032.PredefinedType = PredefinedType;
      _this2032.WorkMethod = WorkMethod;
      _this2032.type = 3206491090;
      return _this2032;
    }

    return IfcTaskType;
  }(IfcTypeProcess);

  IFC42.IfcTaskType = IfcTaskType;

  var IfcTessellatedFaceSet = /*#__PURE__*/function (_IfcTessellatedItem4) {
    _inherits(IfcTessellatedFaceSet, _IfcTessellatedItem4);

    var _super2041 = _createSuper(IfcTessellatedFaceSet);

    function IfcTessellatedFaceSet(expressID, Coordinates) {
      var _this2033;

      _classCallCheck2(this, IfcTessellatedFaceSet);

      _this2033 = _super2041.call(this, expressID);
      _this2033.Coordinates = Coordinates;
      _this2033.type = 2387106220;
      return _this2033;
    }

    return IfcTessellatedFaceSet;
  }(IfcTessellatedItem);

  IFC42.IfcTessellatedFaceSet = IfcTessellatedFaceSet;

  var IfcToroidalSurface = /*#__PURE__*/function (_IfcElementarySurface8) {
    _inherits(IfcToroidalSurface, _IfcElementarySurface8);

    var _super2042 = _createSuper(IfcToroidalSurface);

    function IfcToroidalSurface(expressID, Position, MajorRadius, MinorRadius) {
      var _this2034;

      _classCallCheck2(this, IfcToroidalSurface);

      _this2034 = _super2042.call(this, expressID, Position);
      _this2034.Position = Position;
      _this2034.MajorRadius = MajorRadius;
      _this2034.MinorRadius = MinorRadius;
      _this2034.type = 1935646853;
      return _this2034;
    }

    return IfcToroidalSurface;
  }(IfcElementarySurface);

  IFC42.IfcToroidalSurface = IfcToroidalSurface;

  var IfcTransportElementType = /*#__PURE__*/function (_IfcElementType17) {
    _inherits(IfcTransportElementType, _IfcElementType17);

    var _super2043 = _createSuper(IfcTransportElementType);

    function IfcTransportElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2035;

      _classCallCheck2(this, IfcTransportElementType);

      _this2035 = _super2043.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2035.GlobalId = GlobalId;
      _this2035.OwnerHistory = OwnerHistory;
      _this2035.Name = Name;
      _this2035.Description = Description;
      _this2035.ApplicableOccurrence = ApplicableOccurrence;
      _this2035.HasPropertySets = HasPropertySets;
      _this2035.RepresentationMaps = RepresentationMaps;
      _this2035.Tag = Tag;
      _this2035.ElementType = ElementType;
      _this2035.PredefinedType = PredefinedType;
      _this2035.type = 2097647324;
      return _this2035;
    }

    return IfcTransportElementType;
  }(IfcElementType);

  IFC42.IfcTransportElementType = IfcTransportElementType;

  var IfcTriangulatedFaceSet = /*#__PURE__*/function (_IfcTessellatedFaceSe3) {
    _inherits(IfcTriangulatedFaceSet, _IfcTessellatedFaceSe3);

    var _super2044 = _createSuper(IfcTriangulatedFaceSet);

    function IfcTriangulatedFaceSet(expressID, Coordinates, Normals, Closed, CoordIndex, PnIndex) {
      var _this2036;

      _classCallCheck2(this, IfcTriangulatedFaceSet);

      _this2036 = _super2044.call(this, expressID, Coordinates);
      _this2036.Coordinates = Coordinates;
      _this2036.Normals = Normals;
      _this2036.Closed = Closed;
      _this2036.CoordIndex = CoordIndex;
      _this2036.PnIndex = PnIndex;
      _this2036.type = 2916149573;
      return _this2036;
    }

    return IfcTriangulatedFaceSet;
  }(IfcTessellatedFaceSet);

  IFC42.IfcTriangulatedFaceSet = IfcTriangulatedFaceSet;

  var IfcWindowLiningProperties = /*#__PURE__*/function (_IfcPreDefinedPropert14) {
    _inherits(IfcWindowLiningProperties, _IfcPreDefinedPropert14);

    var _super2045 = _createSuper(IfcWindowLiningProperties);

    function IfcWindowLiningProperties(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, TransomThickness, MullionThickness, FirstTransomOffset, SecondTransomOffset, FirstMullionOffset, SecondMullionOffset, ShapeAspectStyle, LiningOffset, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      var _this2037;

      _classCallCheck2(this, IfcWindowLiningProperties);

      _this2037 = _super2045.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this2037.GlobalId = GlobalId;
      _this2037.OwnerHistory = OwnerHistory;
      _this2037.Name = Name;
      _this2037.Description = Description;
      _this2037.LiningDepth = LiningDepth;
      _this2037.LiningThickness = LiningThickness;
      _this2037.TransomThickness = TransomThickness;
      _this2037.MullionThickness = MullionThickness;
      _this2037.FirstTransomOffset = FirstTransomOffset;
      _this2037.SecondTransomOffset = SecondTransomOffset;
      _this2037.FirstMullionOffset = FirstMullionOffset;
      _this2037.SecondMullionOffset = SecondMullionOffset;
      _this2037.ShapeAspectStyle = ShapeAspectStyle;
      _this2037.LiningOffset = LiningOffset;
      _this2037.LiningToPanelOffsetX = LiningToPanelOffsetX;
      _this2037.LiningToPanelOffsetY = LiningToPanelOffsetY;
      _this2037.type = 336235671;
      return _this2037;
    }

    return IfcWindowLiningProperties;
  }(IfcPreDefinedPropertySet);

  IFC42.IfcWindowLiningProperties = IfcWindowLiningProperties;

  var IfcWindowPanelProperties = /*#__PURE__*/function (_IfcPreDefinedPropert15) {
    _inherits(IfcWindowPanelProperties, _IfcPreDefinedPropert15);

    var _super2046 = _createSuper(IfcWindowPanelProperties);

    function IfcWindowPanelProperties(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      var _this2038;

      _classCallCheck2(this, IfcWindowPanelProperties);

      _this2038 = _super2046.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this2038.GlobalId = GlobalId;
      _this2038.OwnerHistory = OwnerHistory;
      _this2038.Name = Name;
      _this2038.Description = Description;
      _this2038.OperationType = OperationType;
      _this2038.PanelPosition = PanelPosition;
      _this2038.FrameDepth = FrameDepth;
      _this2038.FrameThickness = FrameThickness;
      _this2038.ShapeAspectStyle = ShapeAspectStyle;
      _this2038.type = 512836454;
      return _this2038;
    }

    return IfcWindowPanelProperties;
  }(IfcPreDefinedPropertySet);

  IFC42.IfcWindowPanelProperties = IfcWindowPanelProperties;

  var IfcActor = /*#__PURE__*/function (_IfcObject17) {
    _inherits(IfcActor, _IfcObject17);

    var _super2047 = _createSuper(IfcActor);

    function IfcActor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor) {
      var _this2039;

      _classCallCheck2(this, IfcActor);

      _this2039 = _super2047.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2039.GlobalId = GlobalId;
      _this2039.OwnerHistory = OwnerHistory;
      _this2039.Name = Name;
      _this2039.Description = Description;
      _this2039.ObjectType = ObjectType;
      _this2039.TheActor = TheActor;
      _this2039.type = 2296667514;
      return _this2039;
    }

    return IfcActor;
  }(IfcObject);

  IFC42.IfcActor = IfcActor;

  var IfcAdvancedBrep = /*#__PURE__*/function (_IfcManifoldSolidBrep5) {
    _inherits(IfcAdvancedBrep, _IfcManifoldSolidBrep5);

    var _super2048 = _createSuper(IfcAdvancedBrep);

    function IfcAdvancedBrep(expressID, Outer) {
      var _this2040;

      _classCallCheck2(this, IfcAdvancedBrep);

      _this2040 = _super2048.call(this, expressID, Outer);
      _this2040.Outer = Outer;
      _this2040.type = 1635779807;
      return _this2040;
    }

    return IfcAdvancedBrep;
  }(IfcManifoldSolidBrep);

  IFC42.IfcAdvancedBrep = IfcAdvancedBrep;

  var IfcAdvancedBrepWithVoids = /*#__PURE__*/function (_IfcAdvancedBrep2) {
    _inherits(IfcAdvancedBrepWithVoids, _IfcAdvancedBrep2);

    var _super2049 = _createSuper(IfcAdvancedBrepWithVoids);

    function IfcAdvancedBrepWithVoids(expressID, Outer, Voids) {
      var _this2041;

      _classCallCheck2(this, IfcAdvancedBrepWithVoids);

      _this2041 = _super2049.call(this, expressID, Outer);
      _this2041.Outer = Outer;
      _this2041.Voids = Voids;
      _this2041.type = 2603310189;
      return _this2041;
    }

    return IfcAdvancedBrepWithVoids;
  }(IfcAdvancedBrep);

  IFC42.IfcAdvancedBrepWithVoids = IfcAdvancedBrepWithVoids;

  var IfcAnnotation = /*#__PURE__*/function (_IfcProduct21) {
    _inherits(IfcAnnotation, _IfcProduct21);

    var _super2050 = _createSuper(IfcAnnotation);

    function IfcAnnotation(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this2042;

      _classCallCheck2(this, IfcAnnotation);

      _this2042 = _super2050.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2042.GlobalId = GlobalId;
      _this2042.OwnerHistory = OwnerHistory;
      _this2042.Name = Name;
      _this2042.Description = Description;
      _this2042.ObjectType = ObjectType;
      _this2042.ObjectPlacement = ObjectPlacement;
      _this2042.Representation = Representation;
      _this2042.type = 1674181508;
      return _this2042;
    }

    return IfcAnnotation;
  }(IfcProduct);

  IFC42.IfcAnnotation = IfcAnnotation;

  var IfcBSplineSurface = /*#__PURE__*/function (_IfcBoundedSurface10) {
    _inherits(IfcBSplineSurface, _IfcBoundedSurface10);

    var _super2051 = _createSuper(IfcBSplineSurface);

    function IfcBSplineSurface(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect) {
      var _this2043;

      _classCallCheck2(this, IfcBSplineSurface);

      _this2043 = _super2051.call(this, expressID);
      _this2043.UDegree = UDegree;
      _this2043.VDegree = VDegree;
      _this2043.ControlPointsList = ControlPointsList;
      _this2043.SurfaceForm = SurfaceForm;
      _this2043.UClosed = UClosed;
      _this2043.VClosed = VClosed;
      _this2043.SelfIntersect = SelfIntersect;
      _this2043.type = 2887950389;
      return _this2043;
    }

    return IfcBSplineSurface;
  }(IfcBoundedSurface);

  IFC42.IfcBSplineSurface = IfcBSplineSurface;

  var IfcBSplineSurfaceWithKnots = /*#__PURE__*/function (_IfcBSplineSurface2) {
    _inherits(IfcBSplineSurfaceWithKnots, _IfcBSplineSurface2);

    var _super2052 = _createSuper(IfcBSplineSurfaceWithKnots);

    function IfcBSplineSurfaceWithKnots(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec) {
      var _this2044;

      _classCallCheck2(this, IfcBSplineSurfaceWithKnots);

      _this2044 = _super2052.call(this, expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect);
      _this2044.UDegree = UDegree;
      _this2044.VDegree = VDegree;
      _this2044.ControlPointsList = ControlPointsList;
      _this2044.SurfaceForm = SurfaceForm;
      _this2044.UClosed = UClosed;
      _this2044.VClosed = VClosed;
      _this2044.SelfIntersect = SelfIntersect;
      _this2044.UMultiplicities = UMultiplicities;
      _this2044.VMultiplicities = VMultiplicities;
      _this2044.UKnots = UKnots;
      _this2044.VKnots = VKnots;
      _this2044.KnotSpec = KnotSpec;
      _this2044.type = 167062518;
      return _this2044;
    }

    return IfcBSplineSurfaceWithKnots;
  }(IfcBSplineSurface);

  IFC42.IfcBSplineSurfaceWithKnots = IfcBSplineSurfaceWithKnots;

  var IfcBlock = /*#__PURE__*/function (_IfcCsgPrimitive3D15) {
    _inherits(IfcBlock, _IfcCsgPrimitive3D15);

    var _super2053 = _createSuper(IfcBlock);

    function IfcBlock(expressID, Position, XLength, YLength, ZLength) {
      var _this2045;

      _classCallCheck2(this, IfcBlock);

      _this2045 = _super2053.call(this, expressID, Position);
      _this2045.Position = Position;
      _this2045.XLength = XLength;
      _this2045.YLength = YLength;
      _this2045.ZLength = ZLength;
      _this2045.type = 1334484129;
      return _this2045;
    }

    return IfcBlock;
  }(IfcCsgPrimitive3D);

  IFC42.IfcBlock = IfcBlock;

  var IfcBooleanClippingResult = /*#__PURE__*/function (_IfcBooleanResult3) {
    _inherits(IfcBooleanClippingResult, _IfcBooleanResult3);

    var _super2054 = _createSuper(IfcBooleanClippingResult);

    function IfcBooleanClippingResult(expressID, Operator, FirstOperand, SecondOperand) {
      var _this2046;

      _classCallCheck2(this, IfcBooleanClippingResult);

      _this2046 = _super2054.call(this, expressID, Operator, FirstOperand, SecondOperand);
      _this2046.Operator = Operator;
      _this2046.FirstOperand = FirstOperand;
      _this2046.SecondOperand = SecondOperand;
      _this2046.type = 3649129432;
      return _this2046;
    }

    return IfcBooleanClippingResult;
  }(IfcBooleanResult);

  IFC42.IfcBooleanClippingResult = IfcBooleanClippingResult;

  var IfcBoundedCurve = /*#__PURE__*/function (_IfcCurve19) {
    _inherits(IfcBoundedCurve, _IfcCurve19);

    var _super2055 = _createSuper(IfcBoundedCurve);

    function IfcBoundedCurve(expressID) {
      var _this2047;

      _classCallCheck2(this, IfcBoundedCurve);

      _this2047 = _super2055.call(this, expressID);
      _this2047.type = 1260505505;
      return _this2047;
    }

    return IfcBoundedCurve;
  }(IfcCurve);

  IFC42.IfcBoundedCurve = IfcBoundedCurve;

  var IfcBuilding = /*#__PURE__*/function (_IfcSpatialStructureE12) {
    _inherits(IfcBuilding, _IfcSpatialStructureE12);

    var _super2056 = _createSuper(IfcBuilding);

    function IfcBuilding(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, ElevationOfRefHeight, ElevationOfTerrain, BuildingAddress) {
      var _this2048;

      _classCallCheck2(this, IfcBuilding);

      _this2048 = _super2056.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this2048.GlobalId = GlobalId;
      _this2048.OwnerHistory = OwnerHistory;
      _this2048.Name = Name;
      _this2048.Description = Description;
      _this2048.ObjectType = ObjectType;
      _this2048.ObjectPlacement = ObjectPlacement;
      _this2048.Representation = Representation;
      _this2048.LongName = LongName;
      _this2048.CompositionType = CompositionType;
      _this2048.ElevationOfRefHeight = ElevationOfRefHeight;
      _this2048.ElevationOfTerrain = ElevationOfTerrain;
      _this2048.BuildingAddress = BuildingAddress;
      _this2048.type = 4031249490;
      return _this2048;
    }

    return IfcBuilding;
  }(IfcSpatialStructureElement);

  IFC42.IfcBuilding = IfcBuilding;

  var IfcBuildingElementType = /*#__PURE__*/function (_IfcElementType18) {
    _inherits(IfcBuildingElementType, _IfcElementType18);

    var _super2057 = _createSuper(IfcBuildingElementType);

    function IfcBuildingElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2049;

      _classCallCheck2(this, IfcBuildingElementType);

      _this2049 = _super2057.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2049.GlobalId = GlobalId;
      _this2049.OwnerHistory = OwnerHistory;
      _this2049.Name = Name;
      _this2049.Description = Description;
      _this2049.ApplicableOccurrence = ApplicableOccurrence;
      _this2049.HasPropertySets = HasPropertySets;
      _this2049.RepresentationMaps = RepresentationMaps;
      _this2049.Tag = Tag;
      _this2049.ElementType = ElementType;
      _this2049.type = 1950629157;
      return _this2049;
    }

    return IfcBuildingElementType;
  }(IfcElementType);

  IFC42.IfcBuildingElementType = IfcBuildingElementType;

  var IfcBuildingStorey = /*#__PURE__*/function (_IfcSpatialStructureE13) {
    _inherits(IfcBuildingStorey, _IfcSpatialStructureE13);

    var _super2058 = _createSuper(IfcBuildingStorey);

    function IfcBuildingStorey(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, Elevation) {
      var _this2050;

      _classCallCheck2(this, IfcBuildingStorey);

      _this2050 = _super2058.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this2050.GlobalId = GlobalId;
      _this2050.OwnerHistory = OwnerHistory;
      _this2050.Name = Name;
      _this2050.Description = Description;
      _this2050.ObjectType = ObjectType;
      _this2050.ObjectPlacement = ObjectPlacement;
      _this2050.Representation = Representation;
      _this2050.LongName = LongName;
      _this2050.CompositionType = CompositionType;
      _this2050.Elevation = Elevation;
      _this2050.type = 3124254112;
      return _this2050;
    }

    return IfcBuildingStorey;
  }(IfcSpatialStructureElement);

  IFC42.IfcBuildingStorey = IfcBuildingStorey;

  var IfcChimneyType = /*#__PURE__*/function (_IfcBuildingElementTy13) {
    _inherits(IfcChimneyType, _IfcBuildingElementTy13);

    var _super2059 = _createSuper(IfcChimneyType);

    function IfcChimneyType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2051;

      _classCallCheck2(this, IfcChimneyType);

      _this2051 = _super2059.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2051.GlobalId = GlobalId;
      _this2051.OwnerHistory = OwnerHistory;
      _this2051.Name = Name;
      _this2051.Description = Description;
      _this2051.ApplicableOccurrence = ApplicableOccurrence;
      _this2051.HasPropertySets = HasPropertySets;
      _this2051.RepresentationMaps = RepresentationMaps;
      _this2051.Tag = Tag;
      _this2051.ElementType = ElementType;
      _this2051.PredefinedType = PredefinedType;
      _this2051.type = 2197970202;
      return _this2051;
    }

    return IfcChimneyType;
  }(IfcBuildingElementType);

  IFC42.IfcChimneyType = IfcChimneyType;

  var IfcCircleHollowProfileDef = /*#__PURE__*/function (_IfcCircleProfileDef3) {
    _inherits(IfcCircleHollowProfileDef, _IfcCircleProfileDef3);

    var _super2060 = _createSuper(IfcCircleHollowProfileDef);

    function IfcCircleHollowProfileDef(expressID, ProfileType, ProfileName, Position, Radius, WallThickness) {
      var _this2052;

      _classCallCheck2(this, IfcCircleHollowProfileDef);

      _this2052 = _super2060.call(this, expressID, ProfileType, ProfileName, Position, Radius);
      _this2052.ProfileType = ProfileType;
      _this2052.ProfileName = ProfileName;
      _this2052.Position = Position;
      _this2052.Radius = Radius;
      _this2052.WallThickness = WallThickness;
      _this2052.type = 2937912522;
      return _this2052;
    }

    return IfcCircleHollowProfileDef;
  }(IfcCircleProfileDef);

  IFC42.IfcCircleHollowProfileDef = IfcCircleHollowProfileDef;

  var IfcCivilElementType = /*#__PURE__*/function (_IfcElementType19) {
    _inherits(IfcCivilElementType, _IfcElementType19);

    var _super2061 = _createSuper(IfcCivilElementType);

    function IfcCivilElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2053;

      _classCallCheck2(this, IfcCivilElementType);

      _this2053 = _super2061.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2053.GlobalId = GlobalId;
      _this2053.OwnerHistory = OwnerHistory;
      _this2053.Name = Name;
      _this2053.Description = Description;
      _this2053.ApplicableOccurrence = ApplicableOccurrence;
      _this2053.HasPropertySets = HasPropertySets;
      _this2053.RepresentationMaps = RepresentationMaps;
      _this2053.Tag = Tag;
      _this2053.ElementType = ElementType;
      _this2053.type = 3893394355;
      return _this2053;
    }

    return IfcCivilElementType;
  }(IfcElementType);

  IFC42.IfcCivilElementType = IfcCivilElementType;

  var IfcColumnType = /*#__PURE__*/function (_IfcBuildingElementTy14) {
    _inherits(IfcColumnType, _IfcBuildingElementTy14);

    var _super2062 = _createSuper(IfcColumnType);

    function IfcColumnType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2054;

      _classCallCheck2(this, IfcColumnType);

      _this2054 = _super2062.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2054.GlobalId = GlobalId;
      _this2054.OwnerHistory = OwnerHistory;
      _this2054.Name = Name;
      _this2054.Description = Description;
      _this2054.ApplicableOccurrence = ApplicableOccurrence;
      _this2054.HasPropertySets = HasPropertySets;
      _this2054.RepresentationMaps = RepresentationMaps;
      _this2054.Tag = Tag;
      _this2054.ElementType = ElementType;
      _this2054.PredefinedType = PredefinedType;
      _this2054.type = 300633059;
      return _this2054;
    }

    return IfcColumnType;
  }(IfcBuildingElementType);

  IFC42.IfcColumnType = IfcColumnType;

  var IfcComplexPropertyTemplate = /*#__PURE__*/function (_IfcPropertyTemplate4) {
    _inherits(IfcComplexPropertyTemplate, _IfcPropertyTemplate4);

    var _super2063 = _createSuper(IfcComplexPropertyTemplate);

    function IfcComplexPropertyTemplate(expressID, GlobalId, OwnerHistory, Name, Description, UsageName, TemplateType, HasPropertyTemplates) {
      var _this2055;

      _classCallCheck2(this, IfcComplexPropertyTemplate);

      _this2055 = _super2063.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this2055.GlobalId = GlobalId;
      _this2055.OwnerHistory = OwnerHistory;
      _this2055.Name = Name;
      _this2055.Description = Description;
      _this2055.UsageName = UsageName;
      _this2055.TemplateType = TemplateType;
      _this2055.HasPropertyTemplates = HasPropertyTemplates;
      _this2055.type = 3875453745;
      return _this2055;
    }

    return IfcComplexPropertyTemplate;
  }(IfcPropertyTemplate);

  IFC42.IfcComplexPropertyTemplate = IfcComplexPropertyTemplate;

  var IfcCompositeCurve = /*#__PURE__*/function (_IfcBoundedCurve10) {
    _inherits(IfcCompositeCurve, _IfcBoundedCurve10);

    var _super2064 = _createSuper(IfcCompositeCurve);

    function IfcCompositeCurve(expressID, Segments, SelfIntersect) {
      var _this2056;

      _classCallCheck2(this, IfcCompositeCurve);

      _this2056 = _super2064.call(this, expressID);
      _this2056.Segments = Segments;
      _this2056.SelfIntersect = SelfIntersect;
      _this2056.type = 3732776249;
      return _this2056;
    }

    return IfcCompositeCurve;
  }(IfcBoundedCurve);

  IFC42.IfcCompositeCurve = IfcCompositeCurve;

  var IfcCompositeCurveOnSurface = /*#__PURE__*/function (_IfcCompositeCurve5) {
    _inherits(IfcCompositeCurveOnSurface, _IfcCompositeCurve5);

    var _super2065 = _createSuper(IfcCompositeCurveOnSurface);

    function IfcCompositeCurveOnSurface(expressID, Segments, SelfIntersect) {
      var _this2057;

      _classCallCheck2(this, IfcCompositeCurveOnSurface);

      _this2057 = _super2065.call(this, expressID, Segments, SelfIntersect);
      _this2057.Segments = Segments;
      _this2057.SelfIntersect = SelfIntersect;
      _this2057.type = 15328376;
      return _this2057;
    }

    return IfcCompositeCurveOnSurface;
  }(IfcCompositeCurve);

  IFC42.IfcCompositeCurveOnSurface = IfcCompositeCurveOnSurface;

  var IfcConic = /*#__PURE__*/function (_IfcCurve20) {
    _inherits(IfcConic, _IfcCurve20);

    var _super2066 = _createSuper(IfcConic);

    function IfcConic(expressID, Position) {
      var _this2058;

      _classCallCheck2(this, IfcConic);

      _this2058 = _super2066.call(this, expressID);
      _this2058.Position = Position;
      _this2058.type = 2510884976;
      return _this2058;
    }

    return IfcConic;
  }(IfcCurve);

  IFC42.IfcConic = IfcConic;

  var IfcConstructionEquipmentResourceType = /*#__PURE__*/function (_IfcConstructionResou22) {
    _inherits(IfcConstructionEquipmentResourceType, _IfcConstructionResou22);

    var _super2067 = _createSuper(IfcConstructionEquipmentResourceType);

    function IfcConstructionEquipmentResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this2059;

      _classCallCheck2(this, IfcConstructionEquipmentResourceType);

      _this2059 = _super2067.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this2059.GlobalId = GlobalId;
      _this2059.OwnerHistory = OwnerHistory;
      _this2059.Name = Name;
      _this2059.Description = Description;
      _this2059.ApplicableOccurrence = ApplicableOccurrence;
      _this2059.HasPropertySets = HasPropertySets;
      _this2059.Identification = Identification;
      _this2059.LongDescription = LongDescription;
      _this2059.ResourceType = ResourceType;
      _this2059.BaseCosts = BaseCosts;
      _this2059.BaseQuantity = BaseQuantity;
      _this2059.PredefinedType = PredefinedType;
      _this2059.type = 2185764099;
      return _this2059;
    }

    return IfcConstructionEquipmentResourceType;
  }(IfcConstructionResourceType);

  IFC42.IfcConstructionEquipmentResourceType = IfcConstructionEquipmentResourceType;

  var IfcConstructionMaterialResourceType = /*#__PURE__*/function (_IfcConstructionResou23) {
    _inherits(IfcConstructionMaterialResourceType, _IfcConstructionResou23);

    var _super2068 = _createSuper(IfcConstructionMaterialResourceType);

    function IfcConstructionMaterialResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this2060;

      _classCallCheck2(this, IfcConstructionMaterialResourceType);

      _this2060 = _super2068.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this2060.GlobalId = GlobalId;
      _this2060.OwnerHistory = OwnerHistory;
      _this2060.Name = Name;
      _this2060.Description = Description;
      _this2060.ApplicableOccurrence = ApplicableOccurrence;
      _this2060.HasPropertySets = HasPropertySets;
      _this2060.Identification = Identification;
      _this2060.LongDescription = LongDescription;
      _this2060.ResourceType = ResourceType;
      _this2060.BaseCosts = BaseCosts;
      _this2060.BaseQuantity = BaseQuantity;
      _this2060.PredefinedType = PredefinedType;
      _this2060.type = 4105962743;
      return _this2060;
    }

    return IfcConstructionMaterialResourceType;
  }(IfcConstructionResourceType);

  IFC42.IfcConstructionMaterialResourceType = IfcConstructionMaterialResourceType;

  var IfcConstructionProductResourceType = /*#__PURE__*/function (_IfcConstructionResou24) {
    _inherits(IfcConstructionProductResourceType, _IfcConstructionResou24);

    var _super2069 = _createSuper(IfcConstructionProductResourceType);

    function IfcConstructionProductResourceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity, PredefinedType) {
      var _this2061;

      _classCallCheck2(this, IfcConstructionProductResourceType);

      _this2061 = _super2069.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, Identification, LongDescription, ResourceType, BaseCosts, BaseQuantity);
      _this2061.GlobalId = GlobalId;
      _this2061.OwnerHistory = OwnerHistory;
      _this2061.Name = Name;
      _this2061.Description = Description;
      _this2061.ApplicableOccurrence = ApplicableOccurrence;
      _this2061.HasPropertySets = HasPropertySets;
      _this2061.Identification = Identification;
      _this2061.LongDescription = LongDescription;
      _this2061.ResourceType = ResourceType;
      _this2061.BaseCosts = BaseCosts;
      _this2061.BaseQuantity = BaseQuantity;
      _this2061.PredefinedType = PredefinedType;
      _this2061.type = 1525564444;
      return _this2061;
    }

    return IfcConstructionProductResourceType;
  }(IfcConstructionResourceType);

  IFC42.IfcConstructionProductResourceType = IfcConstructionProductResourceType;

  var IfcConstructionResource = /*#__PURE__*/function (_IfcResource3) {
    _inherits(IfcConstructionResource, _IfcResource3);

    var _super2070 = _createSuper(IfcConstructionResource);

    function IfcConstructionResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity) {
      var _this2062;

      _classCallCheck2(this, IfcConstructionResource);

      _this2062 = _super2070.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      _this2062.GlobalId = GlobalId;
      _this2062.OwnerHistory = OwnerHistory;
      _this2062.Name = Name;
      _this2062.Description = Description;
      _this2062.ObjectType = ObjectType;
      _this2062.Identification = Identification;
      _this2062.LongDescription = LongDescription;
      _this2062.Usage = Usage;
      _this2062.BaseCosts = BaseCosts;
      _this2062.BaseQuantity = BaseQuantity;
      _this2062.type = 2559216714;
      return _this2062;
    }

    return IfcConstructionResource;
  }(IfcResource);

  IFC42.IfcConstructionResource = IfcConstructionResource;

  var IfcControl = /*#__PURE__*/function (_IfcObject18) {
    _inherits(IfcControl, _IfcObject18);

    var _super2071 = _createSuper(IfcControl);

    function IfcControl(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification) {
      var _this2063;

      _classCallCheck2(this, IfcControl);

      _this2063 = _super2071.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2063.GlobalId = GlobalId;
      _this2063.OwnerHistory = OwnerHistory;
      _this2063.Name = Name;
      _this2063.Description = Description;
      _this2063.ObjectType = ObjectType;
      _this2063.Identification = Identification;
      _this2063.type = 3293443760;
      return _this2063;
    }

    return IfcControl;
  }(IfcObject);

  IFC42.IfcControl = IfcControl;

  var IfcCostItem = /*#__PURE__*/function (_IfcControl24) {
    _inherits(IfcCostItem, _IfcControl24);

    var _super2072 = _createSuper(IfcCostItem);

    function IfcCostItem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, CostValues, CostQuantities) {
      var _this2064;

      _classCallCheck2(this, IfcCostItem);

      _this2064 = _super2072.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this2064.GlobalId = GlobalId;
      _this2064.OwnerHistory = OwnerHistory;
      _this2064.Name = Name;
      _this2064.Description = Description;
      _this2064.ObjectType = ObjectType;
      _this2064.Identification = Identification;
      _this2064.PredefinedType = PredefinedType;
      _this2064.CostValues = CostValues;
      _this2064.CostQuantities = CostQuantities;
      _this2064.type = 3895139033;
      return _this2064;
    }

    return IfcCostItem;
  }(IfcControl);

  IFC42.IfcCostItem = IfcCostItem;

  var IfcCostSchedule = /*#__PURE__*/function (_IfcControl25) {
    _inherits(IfcCostSchedule, _IfcControl25);

    var _super2073 = _createSuper(IfcCostSchedule);

    function IfcCostSchedule(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, SubmittedOn, UpdateDate) {
      var _this2065;

      _classCallCheck2(this, IfcCostSchedule);

      _this2065 = _super2073.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this2065.GlobalId = GlobalId;
      _this2065.OwnerHistory = OwnerHistory;
      _this2065.Name = Name;
      _this2065.Description = Description;
      _this2065.ObjectType = ObjectType;
      _this2065.Identification = Identification;
      _this2065.PredefinedType = PredefinedType;
      _this2065.Status = Status;
      _this2065.SubmittedOn = SubmittedOn;
      _this2065.UpdateDate = UpdateDate;
      _this2065.type = 1419761937;
      return _this2065;
    }

    return IfcCostSchedule;
  }(IfcControl);

  IFC42.IfcCostSchedule = IfcCostSchedule;

  var IfcCoveringType = /*#__PURE__*/function (_IfcBuildingElementTy15) {
    _inherits(IfcCoveringType, _IfcBuildingElementTy15);

    var _super2074 = _createSuper(IfcCoveringType);

    function IfcCoveringType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2066;

      _classCallCheck2(this, IfcCoveringType);

      _this2066 = _super2074.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2066.GlobalId = GlobalId;
      _this2066.OwnerHistory = OwnerHistory;
      _this2066.Name = Name;
      _this2066.Description = Description;
      _this2066.ApplicableOccurrence = ApplicableOccurrence;
      _this2066.HasPropertySets = HasPropertySets;
      _this2066.RepresentationMaps = RepresentationMaps;
      _this2066.Tag = Tag;
      _this2066.ElementType = ElementType;
      _this2066.PredefinedType = PredefinedType;
      _this2066.type = 1916426348;
      return _this2066;
    }

    return IfcCoveringType;
  }(IfcBuildingElementType);

  IFC42.IfcCoveringType = IfcCoveringType;

  var IfcCrewResource = /*#__PURE__*/function (_IfcConstructionResou25) {
    _inherits(IfcCrewResource, _IfcConstructionResou25);

    var _super2075 = _createSuper(IfcCrewResource);

    function IfcCrewResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this2067;

      _classCallCheck2(this, IfcCrewResource);

      _this2067 = _super2075.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this2067.GlobalId = GlobalId;
      _this2067.OwnerHistory = OwnerHistory;
      _this2067.Name = Name;
      _this2067.Description = Description;
      _this2067.ObjectType = ObjectType;
      _this2067.Identification = Identification;
      _this2067.LongDescription = LongDescription;
      _this2067.Usage = Usage;
      _this2067.BaseCosts = BaseCosts;
      _this2067.BaseQuantity = BaseQuantity;
      _this2067.PredefinedType = PredefinedType;
      _this2067.type = 3295246426;
      return _this2067;
    }

    return IfcCrewResource;
  }(IfcConstructionResource);

  IFC42.IfcCrewResource = IfcCrewResource;

  var IfcCurtainWallType = /*#__PURE__*/function (_IfcBuildingElementTy16) {
    _inherits(IfcCurtainWallType, _IfcBuildingElementTy16);

    var _super2076 = _createSuper(IfcCurtainWallType);

    function IfcCurtainWallType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2068;

      _classCallCheck2(this, IfcCurtainWallType);

      _this2068 = _super2076.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2068.GlobalId = GlobalId;
      _this2068.OwnerHistory = OwnerHistory;
      _this2068.Name = Name;
      _this2068.Description = Description;
      _this2068.ApplicableOccurrence = ApplicableOccurrence;
      _this2068.HasPropertySets = HasPropertySets;
      _this2068.RepresentationMaps = RepresentationMaps;
      _this2068.Tag = Tag;
      _this2068.ElementType = ElementType;
      _this2068.PredefinedType = PredefinedType;
      _this2068.type = 1457835157;
      return _this2068;
    }

    return IfcCurtainWallType;
  }(IfcBuildingElementType);

  IFC42.IfcCurtainWallType = IfcCurtainWallType;

  var IfcCylindricalSurface = /*#__PURE__*/function (_IfcElementarySurface9) {
    _inherits(IfcCylindricalSurface, _IfcElementarySurface9);

    var _super2077 = _createSuper(IfcCylindricalSurface);

    function IfcCylindricalSurface(expressID, Position, Radius) {
      var _this2069;

      _classCallCheck2(this, IfcCylindricalSurface);

      _this2069 = _super2077.call(this, expressID, Position);
      _this2069.Position = Position;
      _this2069.Radius = Radius;
      _this2069.type = 1213902940;
      return _this2069;
    }

    return IfcCylindricalSurface;
  }(IfcElementarySurface);

  IFC42.IfcCylindricalSurface = IfcCylindricalSurface;

  var IfcDistributionElementType = /*#__PURE__*/function (_IfcElementType20) {
    _inherits(IfcDistributionElementType, _IfcElementType20);

    var _super2078 = _createSuper(IfcDistributionElementType);

    function IfcDistributionElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2070;

      _classCallCheck2(this, IfcDistributionElementType);

      _this2070 = _super2078.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2070.GlobalId = GlobalId;
      _this2070.OwnerHistory = OwnerHistory;
      _this2070.Name = Name;
      _this2070.Description = Description;
      _this2070.ApplicableOccurrence = ApplicableOccurrence;
      _this2070.HasPropertySets = HasPropertySets;
      _this2070.RepresentationMaps = RepresentationMaps;
      _this2070.Tag = Tag;
      _this2070.ElementType = ElementType;
      _this2070.type = 3256556792;
      return _this2070;
    }

    return IfcDistributionElementType;
  }(IfcElementType);

  IFC42.IfcDistributionElementType = IfcDistributionElementType;

  var IfcDistributionFlowElementType = /*#__PURE__*/function (_IfcDistributionEleme9) {
    _inherits(IfcDistributionFlowElementType, _IfcDistributionEleme9);

    var _super2079 = _createSuper(IfcDistributionFlowElementType);

    function IfcDistributionFlowElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2071;

      _classCallCheck2(this, IfcDistributionFlowElementType);

      _this2071 = _super2079.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2071.GlobalId = GlobalId;
      _this2071.OwnerHistory = OwnerHistory;
      _this2071.Name = Name;
      _this2071.Description = Description;
      _this2071.ApplicableOccurrence = ApplicableOccurrence;
      _this2071.HasPropertySets = HasPropertySets;
      _this2071.RepresentationMaps = RepresentationMaps;
      _this2071.Tag = Tag;
      _this2071.ElementType = ElementType;
      _this2071.type = 3849074793;
      return _this2071;
    }

    return IfcDistributionFlowElementType;
  }(IfcDistributionElementType);

  IFC42.IfcDistributionFlowElementType = IfcDistributionFlowElementType;

  var IfcDoorLiningProperties = /*#__PURE__*/function (_IfcPreDefinedPropert16) {
    _inherits(IfcDoorLiningProperties, _IfcPreDefinedPropert16);

    var _super2080 = _createSuper(IfcDoorLiningProperties);

    function IfcDoorLiningProperties(expressID, GlobalId, OwnerHistory, Name, Description, LiningDepth, LiningThickness, ThresholdDepth, ThresholdThickness, TransomThickness, TransomOffset, LiningOffset, ThresholdOffset, CasingThickness, CasingDepth, ShapeAspectStyle, LiningToPanelOffsetX, LiningToPanelOffsetY) {
      var _this2072;

      _classCallCheck2(this, IfcDoorLiningProperties);

      _this2072 = _super2080.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this2072.GlobalId = GlobalId;
      _this2072.OwnerHistory = OwnerHistory;
      _this2072.Name = Name;
      _this2072.Description = Description;
      _this2072.LiningDepth = LiningDepth;
      _this2072.LiningThickness = LiningThickness;
      _this2072.ThresholdDepth = ThresholdDepth;
      _this2072.ThresholdThickness = ThresholdThickness;
      _this2072.TransomThickness = TransomThickness;
      _this2072.TransomOffset = TransomOffset;
      _this2072.LiningOffset = LiningOffset;
      _this2072.ThresholdOffset = ThresholdOffset;
      _this2072.CasingThickness = CasingThickness;
      _this2072.CasingDepth = CasingDepth;
      _this2072.ShapeAspectStyle = ShapeAspectStyle;
      _this2072.LiningToPanelOffsetX = LiningToPanelOffsetX;
      _this2072.LiningToPanelOffsetY = LiningToPanelOffsetY;
      _this2072.type = 2963535650;
      return _this2072;
    }

    return IfcDoorLiningProperties;
  }(IfcPreDefinedPropertySet);

  IFC42.IfcDoorLiningProperties = IfcDoorLiningProperties;

  var IfcDoorPanelProperties = /*#__PURE__*/function (_IfcPreDefinedPropert17) {
    _inherits(IfcDoorPanelProperties, _IfcPreDefinedPropert17);

    var _super2081 = _createSuper(IfcDoorPanelProperties);

    function IfcDoorPanelProperties(expressID, GlobalId, OwnerHistory, Name, Description, PanelDepth, PanelOperation, PanelWidth, PanelPosition, ShapeAspectStyle) {
      var _this2073;

      _classCallCheck2(this, IfcDoorPanelProperties);

      _this2073 = _super2081.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this2073.GlobalId = GlobalId;
      _this2073.OwnerHistory = OwnerHistory;
      _this2073.Name = Name;
      _this2073.Description = Description;
      _this2073.PanelDepth = PanelDepth;
      _this2073.PanelOperation = PanelOperation;
      _this2073.PanelWidth = PanelWidth;
      _this2073.PanelPosition = PanelPosition;
      _this2073.ShapeAspectStyle = ShapeAspectStyle;
      _this2073.type = 1714330368;
      return _this2073;
    }

    return IfcDoorPanelProperties;
  }(IfcPreDefinedPropertySet);

  IFC42.IfcDoorPanelProperties = IfcDoorPanelProperties;

  var IfcDoorType = /*#__PURE__*/function (_IfcBuildingElementTy17) {
    _inherits(IfcDoorType, _IfcBuildingElementTy17);

    var _super2082 = _createSuper(IfcDoorType);

    function IfcDoorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, OperationType, ParameterTakesPrecedence, UserDefinedOperationType) {
      var _this2074;

      _classCallCheck2(this, IfcDoorType);

      _this2074 = _super2082.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2074.GlobalId = GlobalId;
      _this2074.OwnerHistory = OwnerHistory;
      _this2074.Name = Name;
      _this2074.Description = Description;
      _this2074.ApplicableOccurrence = ApplicableOccurrence;
      _this2074.HasPropertySets = HasPropertySets;
      _this2074.RepresentationMaps = RepresentationMaps;
      _this2074.Tag = Tag;
      _this2074.ElementType = ElementType;
      _this2074.PredefinedType = PredefinedType;
      _this2074.OperationType = OperationType;
      _this2074.ParameterTakesPrecedence = ParameterTakesPrecedence;
      _this2074.UserDefinedOperationType = UserDefinedOperationType;
      _this2074.type = 2323601079;
      return _this2074;
    }

    return IfcDoorType;
  }(IfcBuildingElementType);

  IFC42.IfcDoorType = IfcDoorType;

  var IfcDraughtingPreDefinedColour = /*#__PURE__*/function (_IfcPreDefinedColour3) {
    _inherits(IfcDraughtingPreDefinedColour, _IfcPreDefinedColour3);

    var _super2083 = _createSuper(IfcDraughtingPreDefinedColour);

    function IfcDraughtingPreDefinedColour(expressID, Name) {
      var _this2075;

      _classCallCheck2(this, IfcDraughtingPreDefinedColour);

      _this2075 = _super2083.call(this, expressID, Name);
      _this2075.Name = Name;
      _this2075.type = 445594917;
      return _this2075;
    }

    return IfcDraughtingPreDefinedColour;
  }(IfcPreDefinedColour);

  IFC42.IfcDraughtingPreDefinedColour = IfcDraughtingPreDefinedColour;

  var IfcDraughtingPreDefinedCurveFont = /*#__PURE__*/function (_IfcPreDefinedCurveFo3) {
    _inherits(IfcDraughtingPreDefinedCurveFont, _IfcPreDefinedCurveFo3);

    var _super2084 = _createSuper(IfcDraughtingPreDefinedCurveFont);

    function IfcDraughtingPreDefinedCurveFont(expressID, Name) {
      var _this2076;

      _classCallCheck2(this, IfcDraughtingPreDefinedCurveFont);

      _this2076 = _super2084.call(this, expressID, Name);
      _this2076.Name = Name;
      _this2076.type = 4006246654;
      return _this2076;
    }

    return IfcDraughtingPreDefinedCurveFont;
  }(IfcPreDefinedCurveFont);

  IFC42.IfcDraughtingPreDefinedCurveFont = IfcDraughtingPreDefinedCurveFont;

  var IfcElement = /*#__PURE__*/function (_IfcProduct22) {
    _inherits(IfcElement, _IfcProduct22);

    var _super2085 = _createSuper(IfcElement);

    function IfcElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2077;

      _classCallCheck2(this, IfcElement);

      _this2077 = _super2085.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2077.GlobalId = GlobalId;
      _this2077.OwnerHistory = OwnerHistory;
      _this2077.Name = Name;
      _this2077.Description = Description;
      _this2077.ObjectType = ObjectType;
      _this2077.ObjectPlacement = ObjectPlacement;
      _this2077.Representation = Representation;
      _this2077.Tag = Tag;
      _this2077.type = 1758889154;
      return _this2077;
    }

    return IfcElement;
  }(IfcProduct);

  IFC42.IfcElement = IfcElement;

  var IfcElementAssembly = /*#__PURE__*/function (_IfcElement22) {
    _inherits(IfcElementAssembly, _IfcElement22);

    var _super2086 = _createSuper(IfcElementAssembly);

    function IfcElementAssembly(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, AssemblyPlace, PredefinedType) {
      var _this2078;

      _classCallCheck2(this, IfcElementAssembly);

      _this2078 = _super2086.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2078.GlobalId = GlobalId;
      _this2078.OwnerHistory = OwnerHistory;
      _this2078.Name = Name;
      _this2078.Description = Description;
      _this2078.ObjectType = ObjectType;
      _this2078.ObjectPlacement = ObjectPlacement;
      _this2078.Representation = Representation;
      _this2078.Tag = Tag;
      _this2078.AssemblyPlace = AssemblyPlace;
      _this2078.PredefinedType = PredefinedType;
      _this2078.type = 4123344466;
      return _this2078;
    }

    return IfcElementAssembly;
  }(IfcElement);

  IFC42.IfcElementAssembly = IfcElementAssembly;

  var IfcElementAssemblyType = /*#__PURE__*/function (_IfcElementType21) {
    _inherits(IfcElementAssemblyType, _IfcElementType21);

    var _super2087 = _createSuper(IfcElementAssemblyType);

    function IfcElementAssemblyType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2079;

      _classCallCheck2(this, IfcElementAssemblyType);

      _this2079 = _super2087.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2079.GlobalId = GlobalId;
      _this2079.OwnerHistory = OwnerHistory;
      _this2079.Name = Name;
      _this2079.Description = Description;
      _this2079.ApplicableOccurrence = ApplicableOccurrence;
      _this2079.HasPropertySets = HasPropertySets;
      _this2079.RepresentationMaps = RepresentationMaps;
      _this2079.Tag = Tag;
      _this2079.ElementType = ElementType;
      _this2079.PredefinedType = PredefinedType;
      _this2079.type = 2397081782;
      return _this2079;
    }

    return IfcElementAssemblyType;
  }(IfcElementType);

  IFC42.IfcElementAssemblyType = IfcElementAssemblyType;

  var IfcElementComponent = /*#__PURE__*/function (_IfcElement23) {
    _inherits(IfcElementComponent, _IfcElement23);

    var _super2088 = _createSuper(IfcElementComponent);

    function IfcElementComponent(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2080;

      _classCallCheck2(this, IfcElementComponent);

      _this2080 = _super2088.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2080.GlobalId = GlobalId;
      _this2080.OwnerHistory = OwnerHistory;
      _this2080.Name = Name;
      _this2080.Description = Description;
      _this2080.ObjectType = ObjectType;
      _this2080.ObjectPlacement = ObjectPlacement;
      _this2080.Representation = Representation;
      _this2080.Tag = Tag;
      _this2080.type = 1623761950;
      return _this2080;
    }

    return IfcElementComponent;
  }(IfcElement);

  IFC42.IfcElementComponent = IfcElementComponent;

  var IfcElementComponentType = /*#__PURE__*/function (_IfcElementType22) {
    _inherits(IfcElementComponentType, _IfcElementType22);

    var _super2089 = _createSuper(IfcElementComponentType);

    function IfcElementComponentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2081;

      _classCallCheck2(this, IfcElementComponentType);

      _this2081 = _super2089.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2081.GlobalId = GlobalId;
      _this2081.OwnerHistory = OwnerHistory;
      _this2081.Name = Name;
      _this2081.Description = Description;
      _this2081.ApplicableOccurrence = ApplicableOccurrence;
      _this2081.HasPropertySets = HasPropertySets;
      _this2081.RepresentationMaps = RepresentationMaps;
      _this2081.Tag = Tag;
      _this2081.ElementType = ElementType;
      _this2081.type = 2590856083;
      return _this2081;
    }

    return IfcElementComponentType;
  }(IfcElementType);

  IFC42.IfcElementComponentType = IfcElementComponentType;

  var IfcEllipse = /*#__PURE__*/function (_IfcConic5) {
    _inherits(IfcEllipse, _IfcConic5);

    var _super2090 = _createSuper(IfcEllipse);

    function IfcEllipse(expressID, Position, SemiAxis1, SemiAxis2) {
      var _this2082;

      _classCallCheck2(this, IfcEllipse);

      _this2082 = _super2090.call(this, expressID, Position);
      _this2082.Position = Position;
      _this2082.SemiAxis1 = SemiAxis1;
      _this2082.SemiAxis2 = SemiAxis2;
      _this2082.type = 1704287377;
      return _this2082;
    }

    return IfcEllipse;
  }(IfcConic);

  IFC42.IfcEllipse = IfcEllipse;

  var IfcEnergyConversionDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE37) {
    _inherits(IfcEnergyConversionDeviceType, _IfcDistributionFlowE37);

    var _super2091 = _createSuper(IfcEnergyConversionDeviceType);

    function IfcEnergyConversionDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2083;

      _classCallCheck2(this, IfcEnergyConversionDeviceType);

      _this2083 = _super2091.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2083.GlobalId = GlobalId;
      _this2083.OwnerHistory = OwnerHistory;
      _this2083.Name = Name;
      _this2083.Description = Description;
      _this2083.ApplicableOccurrence = ApplicableOccurrence;
      _this2083.HasPropertySets = HasPropertySets;
      _this2083.RepresentationMaps = RepresentationMaps;
      _this2083.Tag = Tag;
      _this2083.ElementType = ElementType;
      _this2083.type = 2107101300;
      return _this2083;
    }

    return IfcEnergyConversionDeviceType;
  }(IfcDistributionFlowElementType);

  IFC42.IfcEnergyConversionDeviceType = IfcEnergyConversionDeviceType;

  var IfcEngineType = /*#__PURE__*/function (_IfcEnergyConversionD59) {
    _inherits(IfcEngineType, _IfcEnergyConversionD59);

    var _super2092 = _createSuper(IfcEngineType);

    function IfcEngineType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2084;

      _classCallCheck2(this, IfcEngineType);

      _this2084 = _super2092.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2084.GlobalId = GlobalId;
      _this2084.OwnerHistory = OwnerHistory;
      _this2084.Name = Name;
      _this2084.Description = Description;
      _this2084.ApplicableOccurrence = ApplicableOccurrence;
      _this2084.HasPropertySets = HasPropertySets;
      _this2084.RepresentationMaps = RepresentationMaps;
      _this2084.Tag = Tag;
      _this2084.ElementType = ElementType;
      _this2084.PredefinedType = PredefinedType;
      _this2084.type = 132023988;
      return _this2084;
    }

    return IfcEngineType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcEngineType = IfcEngineType;

  var IfcEvaporativeCoolerType = /*#__PURE__*/function (_IfcEnergyConversionD60) {
    _inherits(IfcEvaporativeCoolerType, _IfcEnergyConversionD60);

    var _super2093 = _createSuper(IfcEvaporativeCoolerType);

    function IfcEvaporativeCoolerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2085;

      _classCallCheck2(this, IfcEvaporativeCoolerType);

      _this2085 = _super2093.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2085.GlobalId = GlobalId;
      _this2085.OwnerHistory = OwnerHistory;
      _this2085.Name = Name;
      _this2085.Description = Description;
      _this2085.ApplicableOccurrence = ApplicableOccurrence;
      _this2085.HasPropertySets = HasPropertySets;
      _this2085.RepresentationMaps = RepresentationMaps;
      _this2085.Tag = Tag;
      _this2085.ElementType = ElementType;
      _this2085.PredefinedType = PredefinedType;
      _this2085.type = 3174744832;
      return _this2085;
    }

    return IfcEvaporativeCoolerType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcEvaporativeCoolerType = IfcEvaporativeCoolerType;

  var IfcEvaporatorType = /*#__PURE__*/function (_IfcEnergyConversionD61) {
    _inherits(IfcEvaporatorType, _IfcEnergyConversionD61);

    var _super2094 = _createSuper(IfcEvaporatorType);

    function IfcEvaporatorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2086;

      _classCallCheck2(this, IfcEvaporatorType);

      _this2086 = _super2094.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2086.GlobalId = GlobalId;
      _this2086.OwnerHistory = OwnerHistory;
      _this2086.Name = Name;
      _this2086.Description = Description;
      _this2086.ApplicableOccurrence = ApplicableOccurrence;
      _this2086.HasPropertySets = HasPropertySets;
      _this2086.RepresentationMaps = RepresentationMaps;
      _this2086.Tag = Tag;
      _this2086.ElementType = ElementType;
      _this2086.PredefinedType = PredefinedType;
      _this2086.type = 3390157468;
      return _this2086;
    }

    return IfcEvaporatorType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcEvaporatorType = IfcEvaporatorType;

  var IfcEvent = /*#__PURE__*/function (_IfcProcess7) {
    _inherits(IfcEvent, _IfcProcess7);

    var _super2095 = _createSuper(IfcEvent);

    function IfcEvent(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType, EventTriggerType, UserDefinedEventTriggerType, EventOccurenceTime) {
      var _this2087;

      _classCallCheck2(this, IfcEvent);

      _this2087 = _super2095.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      _this2087.GlobalId = GlobalId;
      _this2087.OwnerHistory = OwnerHistory;
      _this2087.Name = Name;
      _this2087.Description = Description;
      _this2087.ObjectType = ObjectType;
      _this2087.Identification = Identification;
      _this2087.LongDescription = LongDescription;
      _this2087.PredefinedType = PredefinedType;
      _this2087.EventTriggerType = EventTriggerType;
      _this2087.UserDefinedEventTriggerType = UserDefinedEventTriggerType;
      _this2087.EventOccurenceTime = EventOccurenceTime;
      _this2087.type = 4148101412;
      return _this2087;
    }

    return IfcEvent;
  }(IfcProcess);

  IFC42.IfcEvent = IfcEvent;

  var IfcExternalSpatialStructureElement = /*#__PURE__*/function (_IfcSpatialElement6) {
    _inherits(IfcExternalSpatialStructureElement, _IfcSpatialElement6);

    var _super2096 = _createSuper(IfcExternalSpatialStructureElement);

    function IfcExternalSpatialStructureElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName) {
      var _this2088;

      _classCallCheck2(this, IfcExternalSpatialStructureElement);

      _this2088 = _super2096.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      _this2088.GlobalId = GlobalId;
      _this2088.OwnerHistory = OwnerHistory;
      _this2088.Name = Name;
      _this2088.Description = Description;
      _this2088.ObjectType = ObjectType;
      _this2088.ObjectPlacement = ObjectPlacement;
      _this2088.Representation = Representation;
      _this2088.LongName = LongName;
      _this2088.type = 2853485674;
      return _this2088;
    }

    return IfcExternalSpatialStructureElement;
  }(IfcSpatialElement);

  IFC42.IfcExternalSpatialStructureElement = IfcExternalSpatialStructureElement;

  var IfcFacetedBrep = /*#__PURE__*/function (_IfcManifoldSolidBrep6) {
    _inherits(IfcFacetedBrep, _IfcManifoldSolidBrep6);

    var _super2097 = _createSuper(IfcFacetedBrep);

    function IfcFacetedBrep(expressID, Outer) {
      var _this2089;

      _classCallCheck2(this, IfcFacetedBrep);

      _this2089 = _super2097.call(this, expressID, Outer);
      _this2089.Outer = Outer;
      _this2089.type = 807026263;
      return _this2089;
    }

    return IfcFacetedBrep;
  }(IfcManifoldSolidBrep);

  IFC42.IfcFacetedBrep = IfcFacetedBrep;

  var IfcFacetedBrepWithVoids = /*#__PURE__*/function (_IfcFacetedBrep2) {
    _inherits(IfcFacetedBrepWithVoids, _IfcFacetedBrep2);

    var _super2098 = _createSuper(IfcFacetedBrepWithVoids);

    function IfcFacetedBrepWithVoids(expressID, Outer, Voids) {
      var _this2090;

      _classCallCheck2(this, IfcFacetedBrepWithVoids);

      _this2090 = _super2098.call(this, expressID, Outer);
      _this2090.Outer = Outer;
      _this2090.Voids = Voids;
      _this2090.type = 3737207727;
      return _this2090;
    }

    return IfcFacetedBrepWithVoids;
  }(IfcFacetedBrep);

  IFC42.IfcFacetedBrepWithVoids = IfcFacetedBrepWithVoids;

  var IfcFastener = /*#__PURE__*/function (_IfcElementComponent12) {
    _inherits(IfcFastener, _IfcElementComponent12);

    var _super2099 = _createSuper(IfcFastener);

    function IfcFastener(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2091;

      _classCallCheck2(this, IfcFastener);

      _this2091 = _super2099.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2091.GlobalId = GlobalId;
      _this2091.OwnerHistory = OwnerHistory;
      _this2091.Name = Name;
      _this2091.Description = Description;
      _this2091.ObjectType = ObjectType;
      _this2091.ObjectPlacement = ObjectPlacement;
      _this2091.Representation = Representation;
      _this2091.Tag = Tag;
      _this2091.PredefinedType = PredefinedType;
      _this2091.type = 647756555;
      return _this2091;
    }

    return IfcFastener;
  }(IfcElementComponent);

  IFC42.IfcFastener = IfcFastener;

  var IfcFastenerType = /*#__PURE__*/function (_IfcElementComponentT12) {
    _inherits(IfcFastenerType, _IfcElementComponentT12);

    var _super2100 = _createSuper(IfcFastenerType);

    function IfcFastenerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2092;

      _classCallCheck2(this, IfcFastenerType);

      _this2092 = _super2100.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2092.GlobalId = GlobalId;
      _this2092.OwnerHistory = OwnerHistory;
      _this2092.Name = Name;
      _this2092.Description = Description;
      _this2092.ApplicableOccurrence = ApplicableOccurrence;
      _this2092.HasPropertySets = HasPropertySets;
      _this2092.RepresentationMaps = RepresentationMaps;
      _this2092.Tag = Tag;
      _this2092.ElementType = ElementType;
      _this2092.PredefinedType = PredefinedType;
      _this2092.type = 2489546625;
      return _this2092;
    }

    return IfcFastenerType;
  }(IfcElementComponentType);

  IFC42.IfcFastenerType = IfcFastenerType;

  var IfcFeatureElement = /*#__PURE__*/function (_IfcElement24) {
    _inherits(IfcFeatureElement, _IfcElement24);

    var _super2101 = _createSuper(IfcFeatureElement);

    function IfcFeatureElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2093;

      _classCallCheck2(this, IfcFeatureElement);

      _this2093 = _super2101.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2093.GlobalId = GlobalId;
      _this2093.OwnerHistory = OwnerHistory;
      _this2093.Name = Name;
      _this2093.Description = Description;
      _this2093.ObjectType = ObjectType;
      _this2093.ObjectPlacement = ObjectPlacement;
      _this2093.Representation = Representation;
      _this2093.Tag = Tag;
      _this2093.type = 2827207264;
      return _this2093;
    }

    return IfcFeatureElement;
  }(IfcElement);

  IFC42.IfcFeatureElement = IfcFeatureElement;

  var IfcFeatureElementAddition = /*#__PURE__*/function (_IfcFeatureElement6) {
    _inherits(IfcFeatureElementAddition, _IfcFeatureElement6);

    var _super2102 = _createSuper(IfcFeatureElementAddition);

    function IfcFeatureElementAddition(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2094;

      _classCallCheck2(this, IfcFeatureElementAddition);

      _this2094 = _super2102.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2094.GlobalId = GlobalId;
      _this2094.OwnerHistory = OwnerHistory;
      _this2094.Name = Name;
      _this2094.Description = Description;
      _this2094.ObjectType = ObjectType;
      _this2094.ObjectPlacement = ObjectPlacement;
      _this2094.Representation = Representation;
      _this2094.Tag = Tag;
      _this2094.type = 2143335405;
      return _this2094;
    }

    return IfcFeatureElementAddition;
  }(IfcFeatureElement);

  IFC42.IfcFeatureElementAddition = IfcFeatureElementAddition;

  var IfcFeatureElementSubtraction = /*#__PURE__*/function (_IfcFeatureElement7) {
    _inherits(IfcFeatureElementSubtraction, _IfcFeatureElement7);

    var _super2103 = _createSuper(IfcFeatureElementSubtraction);

    function IfcFeatureElementSubtraction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2095;

      _classCallCheck2(this, IfcFeatureElementSubtraction);

      _this2095 = _super2103.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2095.GlobalId = GlobalId;
      _this2095.OwnerHistory = OwnerHistory;
      _this2095.Name = Name;
      _this2095.Description = Description;
      _this2095.ObjectType = ObjectType;
      _this2095.ObjectPlacement = ObjectPlacement;
      _this2095.Representation = Representation;
      _this2095.Tag = Tag;
      _this2095.type = 1287392070;
      return _this2095;
    }

    return IfcFeatureElementSubtraction;
  }(IfcFeatureElement);

  IFC42.IfcFeatureElementSubtraction = IfcFeatureElementSubtraction;

  var IfcFlowControllerType = /*#__PURE__*/function (_IfcDistributionFlowE38) {
    _inherits(IfcFlowControllerType, _IfcDistributionFlowE38);

    var _super2104 = _createSuper(IfcFlowControllerType);

    function IfcFlowControllerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2096;

      _classCallCheck2(this, IfcFlowControllerType);

      _this2096 = _super2104.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2096.GlobalId = GlobalId;
      _this2096.OwnerHistory = OwnerHistory;
      _this2096.Name = Name;
      _this2096.Description = Description;
      _this2096.ApplicableOccurrence = ApplicableOccurrence;
      _this2096.HasPropertySets = HasPropertySets;
      _this2096.RepresentationMaps = RepresentationMaps;
      _this2096.Tag = Tag;
      _this2096.ElementType = ElementType;
      _this2096.type = 3907093117;
      return _this2096;
    }

    return IfcFlowControllerType;
  }(IfcDistributionFlowElementType);

  IFC42.IfcFlowControllerType = IfcFlowControllerType;

  var IfcFlowFittingType = /*#__PURE__*/function (_IfcDistributionFlowE39) {
    _inherits(IfcFlowFittingType, _IfcDistributionFlowE39);

    var _super2105 = _createSuper(IfcFlowFittingType);

    function IfcFlowFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2097;

      _classCallCheck2(this, IfcFlowFittingType);

      _this2097 = _super2105.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2097.GlobalId = GlobalId;
      _this2097.OwnerHistory = OwnerHistory;
      _this2097.Name = Name;
      _this2097.Description = Description;
      _this2097.ApplicableOccurrence = ApplicableOccurrence;
      _this2097.HasPropertySets = HasPropertySets;
      _this2097.RepresentationMaps = RepresentationMaps;
      _this2097.Tag = Tag;
      _this2097.ElementType = ElementType;
      _this2097.type = 3198132628;
      return _this2097;
    }

    return IfcFlowFittingType;
  }(IfcDistributionFlowElementType);

  IFC42.IfcFlowFittingType = IfcFlowFittingType;

  var IfcFlowMeterType = /*#__PURE__*/function (_IfcFlowControllerTyp17) {
    _inherits(IfcFlowMeterType, _IfcFlowControllerTyp17);

    var _super2106 = _createSuper(IfcFlowMeterType);

    function IfcFlowMeterType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2098;

      _classCallCheck2(this, IfcFlowMeterType);

      _this2098 = _super2106.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2098.GlobalId = GlobalId;
      _this2098.OwnerHistory = OwnerHistory;
      _this2098.Name = Name;
      _this2098.Description = Description;
      _this2098.ApplicableOccurrence = ApplicableOccurrence;
      _this2098.HasPropertySets = HasPropertySets;
      _this2098.RepresentationMaps = RepresentationMaps;
      _this2098.Tag = Tag;
      _this2098.ElementType = ElementType;
      _this2098.PredefinedType = PredefinedType;
      _this2098.type = 3815607619;
      return _this2098;
    }

    return IfcFlowMeterType;
  }(IfcFlowControllerType);

  IFC42.IfcFlowMeterType = IfcFlowMeterType;

  var IfcFlowMovingDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE40) {
    _inherits(IfcFlowMovingDeviceType, _IfcDistributionFlowE40);

    var _super2107 = _createSuper(IfcFlowMovingDeviceType);

    function IfcFlowMovingDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2099;

      _classCallCheck2(this, IfcFlowMovingDeviceType);

      _this2099 = _super2107.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2099.GlobalId = GlobalId;
      _this2099.OwnerHistory = OwnerHistory;
      _this2099.Name = Name;
      _this2099.Description = Description;
      _this2099.ApplicableOccurrence = ApplicableOccurrence;
      _this2099.HasPropertySets = HasPropertySets;
      _this2099.RepresentationMaps = RepresentationMaps;
      _this2099.Tag = Tag;
      _this2099.ElementType = ElementType;
      _this2099.type = 1482959167;
      return _this2099;
    }

    return IfcFlowMovingDeviceType;
  }(IfcDistributionFlowElementType);

  IFC42.IfcFlowMovingDeviceType = IfcFlowMovingDeviceType;

  var IfcFlowSegmentType = /*#__PURE__*/function (_IfcDistributionFlowE41) {
    _inherits(IfcFlowSegmentType, _IfcDistributionFlowE41);

    var _super2108 = _createSuper(IfcFlowSegmentType);

    function IfcFlowSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2100;

      _classCallCheck2(this, IfcFlowSegmentType);

      _this2100 = _super2108.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2100.GlobalId = GlobalId;
      _this2100.OwnerHistory = OwnerHistory;
      _this2100.Name = Name;
      _this2100.Description = Description;
      _this2100.ApplicableOccurrence = ApplicableOccurrence;
      _this2100.HasPropertySets = HasPropertySets;
      _this2100.RepresentationMaps = RepresentationMaps;
      _this2100.Tag = Tag;
      _this2100.ElementType = ElementType;
      _this2100.type = 1834744321;
      return _this2100;
    }

    return IfcFlowSegmentType;
  }(IfcDistributionFlowElementType);

  IFC42.IfcFlowSegmentType = IfcFlowSegmentType;

  var IfcFlowStorageDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE42) {
    _inherits(IfcFlowStorageDeviceType, _IfcDistributionFlowE42);

    var _super2109 = _createSuper(IfcFlowStorageDeviceType);

    function IfcFlowStorageDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2101;

      _classCallCheck2(this, IfcFlowStorageDeviceType);

      _this2101 = _super2109.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2101.GlobalId = GlobalId;
      _this2101.OwnerHistory = OwnerHistory;
      _this2101.Name = Name;
      _this2101.Description = Description;
      _this2101.ApplicableOccurrence = ApplicableOccurrence;
      _this2101.HasPropertySets = HasPropertySets;
      _this2101.RepresentationMaps = RepresentationMaps;
      _this2101.Tag = Tag;
      _this2101.ElementType = ElementType;
      _this2101.type = 1339347760;
      return _this2101;
    }

    return IfcFlowStorageDeviceType;
  }(IfcDistributionFlowElementType);

  IFC42.IfcFlowStorageDeviceType = IfcFlowStorageDeviceType;

  var IfcFlowTerminalType = /*#__PURE__*/function (_IfcDistributionFlowE43) {
    _inherits(IfcFlowTerminalType, _IfcDistributionFlowE43);

    var _super2110 = _createSuper(IfcFlowTerminalType);

    function IfcFlowTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2102;

      _classCallCheck2(this, IfcFlowTerminalType);

      _this2102 = _super2110.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2102.GlobalId = GlobalId;
      _this2102.OwnerHistory = OwnerHistory;
      _this2102.Name = Name;
      _this2102.Description = Description;
      _this2102.ApplicableOccurrence = ApplicableOccurrence;
      _this2102.HasPropertySets = HasPropertySets;
      _this2102.RepresentationMaps = RepresentationMaps;
      _this2102.Tag = Tag;
      _this2102.ElementType = ElementType;
      _this2102.type = 2297155007;
      return _this2102;
    }

    return IfcFlowTerminalType;
  }(IfcDistributionFlowElementType);

  IFC42.IfcFlowTerminalType = IfcFlowTerminalType;

  var IfcFlowTreatmentDeviceType = /*#__PURE__*/function (_IfcDistributionFlowE44) {
    _inherits(IfcFlowTreatmentDeviceType, _IfcDistributionFlowE44);

    var _super2111 = _createSuper(IfcFlowTreatmentDeviceType);

    function IfcFlowTreatmentDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2103;

      _classCallCheck2(this, IfcFlowTreatmentDeviceType);

      _this2103 = _super2111.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2103.GlobalId = GlobalId;
      _this2103.OwnerHistory = OwnerHistory;
      _this2103.Name = Name;
      _this2103.Description = Description;
      _this2103.ApplicableOccurrence = ApplicableOccurrence;
      _this2103.HasPropertySets = HasPropertySets;
      _this2103.RepresentationMaps = RepresentationMaps;
      _this2103.Tag = Tag;
      _this2103.ElementType = ElementType;
      _this2103.type = 3009222698;
      return _this2103;
    }

    return IfcFlowTreatmentDeviceType;
  }(IfcDistributionFlowElementType);

  IFC42.IfcFlowTreatmentDeviceType = IfcFlowTreatmentDeviceType;

  var IfcFootingType = /*#__PURE__*/function (_IfcBuildingElementTy18) {
    _inherits(IfcFootingType, _IfcBuildingElementTy18);

    var _super2112 = _createSuper(IfcFootingType);

    function IfcFootingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2104;

      _classCallCheck2(this, IfcFootingType);

      _this2104 = _super2112.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2104.GlobalId = GlobalId;
      _this2104.OwnerHistory = OwnerHistory;
      _this2104.Name = Name;
      _this2104.Description = Description;
      _this2104.ApplicableOccurrence = ApplicableOccurrence;
      _this2104.HasPropertySets = HasPropertySets;
      _this2104.RepresentationMaps = RepresentationMaps;
      _this2104.Tag = Tag;
      _this2104.ElementType = ElementType;
      _this2104.PredefinedType = PredefinedType;
      _this2104.type = 1893162501;
      return _this2104;
    }

    return IfcFootingType;
  }(IfcBuildingElementType);

  IFC42.IfcFootingType = IfcFootingType;

  var IfcFurnishingElement = /*#__PURE__*/function (_IfcElement25) {
    _inherits(IfcFurnishingElement, _IfcElement25);

    var _super2113 = _createSuper(IfcFurnishingElement);

    function IfcFurnishingElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2105;

      _classCallCheck2(this, IfcFurnishingElement);

      _this2105 = _super2113.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2105.GlobalId = GlobalId;
      _this2105.OwnerHistory = OwnerHistory;
      _this2105.Name = Name;
      _this2105.Description = Description;
      _this2105.ObjectType = ObjectType;
      _this2105.ObjectPlacement = ObjectPlacement;
      _this2105.Representation = Representation;
      _this2105.Tag = Tag;
      _this2105.type = 263784265;
      return _this2105;
    }

    return IfcFurnishingElement;
  }(IfcElement);

  IFC42.IfcFurnishingElement = IfcFurnishingElement;

  var IfcFurniture = /*#__PURE__*/function (_IfcFurnishingElement9) {
    _inherits(IfcFurniture, _IfcFurnishingElement9);

    var _super2114 = _createSuper(IfcFurniture);

    function IfcFurniture(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2106;

      _classCallCheck2(this, IfcFurniture);

      _this2106 = _super2114.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2106.GlobalId = GlobalId;
      _this2106.OwnerHistory = OwnerHistory;
      _this2106.Name = Name;
      _this2106.Description = Description;
      _this2106.ObjectType = ObjectType;
      _this2106.ObjectPlacement = ObjectPlacement;
      _this2106.Representation = Representation;
      _this2106.Tag = Tag;
      _this2106.PredefinedType = PredefinedType;
      _this2106.type = 1509553395;
      return _this2106;
    }

    return IfcFurniture;
  }(IfcFurnishingElement);

  IFC42.IfcFurniture = IfcFurniture;

  var IfcGeographicElement = /*#__PURE__*/function (_IfcElement26) {
    _inherits(IfcGeographicElement, _IfcElement26);

    var _super2115 = _createSuper(IfcGeographicElement);

    function IfcGeographicElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2107;

      _classCallCheck2(this, IfcGeographicElement);

      _this2107 = _super2115.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2107.GlobalId = GlobalId;
      _this2107.OwnerHistory = OwnerHistory;
      _this2107.Name = Name;
      _this2107.Description = Description;
      _this2107.ObjectType = ObjectType;
      _this2107.ObjectPlacement = ObjectPlacement;
      _this2107.Representation = Representation;
      _this2107.Tag = Tag;
      _this2107.PredefinedType = PredefinedType;
      _this2107.type = 3493046030;
      return _this2107;
    }

    return IfcGeographicElement;
  }(IfcElement);

  IFC42.IfcGeographicElement = IfcGeographicElement;

  var IfcGrid = /*#__PURE__*/function (_IfcProduct23) {
    _inherits(IfcGrid, _IfcProduct23);

    var _super2116 = _createSuper(IfcGrid);

    function IfcGrid(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, UAxes, VAxes, WAxes, PredefinedType) {
      var _this2108;

      _classCallCheck2(this, IfcGrid);

      _this2108 = _super2116.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2108.GlobalId = GlobalId;
      _this2108.OwnerHistory = OwnerHistory;
      _this2108.Name = Name;
      _this2108.Description = Description;
      _this2108.ObjectType = ObjectType;
      _this2108.ObjectPlacement = ObjectPlacement;
      _this2108.Representation = Representation;
      _this2108.UAxes = UAxes;
      _this2108.VAxes = VAxes;
      _this2108.WAxes = WAxes;
      _this2108.PredefinedType = PredefinedType;
      _this2108.type = 3009204131;
      return _this2108;
    }

    return IfcGrid;
  }(IfcProduct);

  IFC42.IfcGrid = IfcGrid;

  var IfcGroup = /*#__PURE__*/function (_IfcObject19) {
    _inherits(IfcGroup, _IfcObject19);

    var _super2117 = _createSuper(IfcGroup);

    function IfcGroup(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this2109;

      _classCallCheck2(this, IfcGroup);

      _this2109 = _super2117.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2109.GlobalId = GlobalId;
      _this2109.OwnerHistory = OwnerHistory;
      _this2109.Name = Name;
      _this2109.Description = Description;
      _this2109.ObjectType = ObjectType;
      _this2109.type = 2706460486;
      return _this2109;
    }

    return IfcGroup;
  }(IfcObject);

  IFC42.IfcGroup = IfcGroup;

  var IfcHeatExchangerType = /*#__PURE__*/function (_IfcEnergyConversionD62) {
    _inherits(IfcHeatExchangerType, _IfcEnergyConversionD62);

    var _super2118 = _createSuper(IfcHeatExchangerType);

    function IfcHeatExchangerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2110;

      _classCallCheck2(this, IfcHeatExchangerType);

      _this2110 = _super2118.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2110.GlobalId = GlobalId;
      _this2110.OwnerHistory = OwnerHistory;
      _this2110.Name = Name;
      _this2110.Description = Description;
      _this2110.ApplicableOccurrence = ApplicableOccurrence;
      _this2110.HasPropertySets = HasPropertySets;
      _this2110.RepresentationMaps = RepresentationMaps;
      _this2110.Tag = Tag;
      _this2110.ElementType = ElementType;
      _this2110.PredefinedType = PredefinedType;
      _this2110.type = 1251058090;
      return _this2110;
    }

    return IfcHeatExchangerType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcHeatExchangerType = IfcHeatExchangerType;

  var IfcHumidifierType = /*#__PURE__*/function (_IfcEnergyConversionD63) {
    _inherits(IfcHumidifierType, _IfcEnergyConversionD63);

    var _super2119 = _createSuper(IfcHumidifierType);

    function IfcHumidifierType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2111;

      _classCallCheck2(this, IfcHumidifierType);

      _this2111 = _super2119.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2111.GlobalId = GlobalId;
      _this2111.OwnerHistory = OwnerHistory;
      _this2111.Name = Name;
      _this2111.Description = Description;
      _this2111.ApplicableOccurrence = ApplicableOccurrence;
      _this2111.HasPropertySets = HasPropertySets;
      _this2111.RepresentationMaps = RepresentationMaps;
      _this2111.Tag = Tag;
      _this2111.ElementType = ElementType;
      _this2111.PredefinedType = PredefinedType;
      _this2111.type = 1806887404;
      return _this2111;
    }

    return IfcHumidifierType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcHumidifierType = IfcHumidifierType;

  var IfcIndexedPolyCurve = /*#__PURE__*/function (_IfcBoundedCurve11) {
    _inherits(IfcIndexedPolyCurve, _IfcBoundedCurve11);

    var _super2120 = _createSuper(IfcIndexedPolyCurve);

    function IfcIndexedPolyCurve(expressID, Points, Segments, SelfIntersect) {
      var _this2112;

      _classCallCheck2(this, IfcIndexedPolyCurve);

      _this2112 = _super2120.call(this, expressID);
      _this2112.Points = Points;
      _this2112.Segments = Segments;
      _this2112.SelfIntersect = SelfIntersect;
      _this2112.type = 2571569899;
      return _this2112;
    }

    return IfcIndexedPolyCurve;
  }(IfcBoundedCurve);

  IFC42.IfcIndexedPolyCurve = IfcIndexedPolyCurve;

  var IfcInterceptorType = /*#__PURE__*/function (_IfcFlowTreatmentDevi11) {
    _inherits(IfcInterceptorType, _IfcFlowTreatmentDevi11);

    var _super2121 = _createSuper(IfcInterceptorType);

    function IfcInterceptorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2113;

      _classCallCheck2(this, IfcInterceptorType);

      _this2113 = _super2121.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2113.GlobalId = GlobalId;
      _this2113.OwnerHistory = OwnerHistory;
      _this2113.Name = Name;
      _this2113.Description = Description;
      _this2113.ApplicableOccurrence = ApplicableOccurrence;
      _this2113.HasPropertySets = HasPropertySets;
      _this2113.RepresentationMaps = RepresentationMaps;
      _this2113.Tag = Tag;
      _this2113.ElementType = ElementType;
      _this2113.PredefinedType = PredefinedType;
      _this2113.type = 3946677679;
      return _this2113;
    }

    return IfcInterceptorType;
  }(IfcFlowTreatmentDeviceType);

  IFC42.IfcInterceptorType = IfcInterceptorType;

  var IfcIntersectionCurve = /*#__PURE__*/function (_IfcSurfaceCurve3) {
    _inherits(IfcIntersectionCurve, _IfcSurfaceCurve3);

    var _super2122 = _createSuper(IfcIntersectionCurve);

    function IfcIntersectionCurve(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      var _this2114;

      _classCallCheck2(this, IfcIntersectionCurve);

      _this2114 = _super2122.call(this, expressID, Curve3D, AssociatedGeometry, MasterRepresentation);
      _this2114.Curve3D = Curve3D;
      _this2114.AssociatedGeometry = AssociatedGeometry;
      _this2114.MasterRepresentation = MasterRepresentation;
      _this2114.type = 3113134337;
      return _this2114;
    }

    return IfcIntersectionCurve;
  }(IfcSurfaceCurve);

  IFC42.IfcIntersectionCurve = IfcIntersectionCurve;

  var IfcInventory = /*#__PURE__*/function (_IfcGroup13) {
    _inherits(IfcInventory, _IfcGroup13);

    var _super2123 = _createSuper(IfcInventory);

    function IfcInventory(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, Jurisdiction, ResponsiblePersons, LastUpdateDate, CurrentValue, OriginalValue) {
      var _this2115;

      _classCallCheck2(this, IfcInventory);

      _this2115 = _super2123.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2115.GlobalId = GlobalId;
      _this2115.OwnerHistory = OwnerHistory;
      _this2115.Name = Name;
      _this2115.Description = Description;
      _this2115.ObjectType = ObjectType;
      _this2115.PredefinedType = PredefinedType;
      _this2115.Jurisdiction = Jurisdiction;
      _this2115.ResponsiblePersons = ResponsiblePersons;
      _this2115.LastUpdateDate = LastUpdateDate;
      _this2115.CurrentValue = CurrentValue;
      _this2115.OriginalValue = OriginalValue;
      _this2115.type = 2391368822;
      return _this2115;
    }

    return IfcInventory;
  }(IfcGroup);

  IFC42.IfcInventory = IfcInventory;

  var IfcJunctionBoxType = /*#__PURE__*/function (_IfcFlowFittingType10) {
    _inherits(IfcJunctionBoxType, _IfcFlowFittingType10);

    var _super2124 = _createSuper(IfcJunctionBoxType);

    function IfcJunctionBoxType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2116;

      _classCallCheck2(this, IfcJunctionBoxType);

      _this2116 = _super2124.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2116.GlobalId = GlobalId;
      _this2116.OwnerHistory = OwnerHistory;
      _this2116.Name = Name;
      _this2116.Description = Description;
      _this2116.ApplicableOccurrence = ApplicableOccurrence;
      _this2116.HasPropertySets = HasPropertySets;
      _this2116.RepresentationMaps = RepresentationMaps;
      _this2116.Tag = Tag;
      _this2116.ElementType = ElementType;
      _this2116.PredefinedType = PredefinedType;
      _this2116.type = 4288270099;
      return _this2116;
    }

    return IfcJunctionBoxType;
  }(IfcFlowFittingType);

  IFC42.IfcJunctionBoxType = IfcJunctionBoxType;

  var IfcLaborResource = /*#__PURE__*/function (_IfcConstructionResou26) {
    _inherits(IfcLaborResource, _IfcConstructionResou26);

    var _super2125 = _createSuper(IfcLaborResource);

    function IfcLaborResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this2117;

      _classCallCheck2(this, IfcLaborResource);

      _this2117 = _super2125.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this2117.GlobalId = GlobalId;
      _this2117.OwnerHistory = OwnerHistory;
      _this2117.Name = Name;
      _this2117.Description = Description;
      _this2117.ObjectType = ObjectType;
      _this2117.Identification = Identification;
      _this2117.LongDescription = LongDescription;
      _this2117.Usage = Usage;
      _this2117.BaseCosts = BaseCosts;
      _this2117.BaseQuantity = BaseQuantity;
      _this2117.PredefinedType = PredefinedType;
      _this2117.type = 3827777499;
      return _this2117;
    }

    return IfcLaborResource;
  }(IfcConstructionResource);

  IFC42.IfcLaborResource = IfcLaborResource;

  var IfcLampType = /*#__PURE__*/function (_IfcFlowTerminalType28) {
    _inherits(IfcLampType, _IfcFlowTerminalType28);

    var _super2126 = _createSuper(IfcLampType);

    function IfcLampType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2118;

      _classCallCheck2(this, IfcLampType);

      _this2118 = _super2126.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2118.GlobalId = GlobalId;
      _this2118.OwnerHistory = OwnerHistory;
      _this2118.Name = Name;
      _this2118.Description = Description;
      _this2118.ApplicableOccurrence = ApplicableOccurrence;
      _this2118.HasPropertySets = HasPropertySets;
      _this2118.RepresentationMaps = RepresentationMaps;
      _this2118.Tag = Tag;
      _this2118.ElementType = ElementType;
      _this2118.PredefinedType = PredefinedType;
      _this2118.type = 1051575348;
      return _this2118;
    }

    return IfcLampType;
  }(IfcFlowTerminalType);

  IFC42.IfcLampType = IfcLampType;

  var IfcLightFixtureType = /*#__PURE__*/function (_IfcFlowTerminalType29) {
    _inherits(IfcLightFixtureType, _IfcFlowTerminalType29);

    var _super2127 = _createSuper(IfcLightFixtureType);

    function IfcLightFixtureType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2119;

      _classCallCheck2(this, IfcLightFixtureType);

      _this2119 = _super2127.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2119.GlobalId = GlobalId;
      _this2119.OwnerHistory = OwnerHistory;
      _this2119.Name = Name;
      _this2119.Description = Description;
      _this2119.ApplicableOccurrence = ApplicableOccurrence;
      _this2119.HasPropertySets = HasPropertySets;
      _this2119.RepresentationMaps = RepresentationMaps;
      _this2119.Tag = Tag;
      _this2119.ElementType = ElementType;
      _this2119.PredefinedType = PredefinedType;
      _this2119.type = 1161773419;
      return _this2119;
    }

    return IfcLightFixtureType;
  }(IfcFlowTerminalType);

  IFC42.IfcLightFixtureType = IfcLightFixtureType;

  var IfcMechanicalFastener = /*#__PURE__*/function (_IfcElementComponent13) {
    _inherits(IfcMechanicalFastener, _IfcElementComponent13);

    var _super2128 = _createSuper(IfcMechanicalFastener);

    function IfcMechanicalFastener(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NominalDiameter, NominalLength, PredefinedType) {
      var _this2120;

      _classCallCheck2(this, IfcMechanicalFastener);

      _this2120 = _super2128.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2120.GlobalId = GlobalId;
      _this2120.OwnerHistory = OwnerHistory;
      _this2120.Name = Name;
      _this2120.Description = Description;
      _this2120.ObjectType = ObjectType;
      _this2120.ObjectPlacement = ObjectPlacement;
      _this2120.Representation = Representation;
      _this2120.Tag = Tag;
      _this2120.NominalDiameter = NominalDiameter;
      _this2120.NominalLength = NominalLength;
      _this2120.PredefinedType = PredefinedType;
      _this2120.type = 377706215;
      return _this2120;
    }

    return IfcMechanicalFastener;
  }(IfcElementComponent);

  IFC42.IfcMechanicalFastener = IfcMechanicalFastener;

  var IfcMechanicalFastenerType = /*#__PURE__*/function (_IfcElementComponentT13) {
    _inherits(IfcMechanicalFastenerType, _IfcElementComponentT13);

    var _super2129 = _createSuper(IfcMechanicalFastenerType);

    function IfcMechanicalFastenerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, NominalLength) {
      var _this2121;

      _classCallCheck2(this, IfcMechanicalFastenerType);

      _this2121 = _super2129.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2121.GlobalId = GlobalId;
      _this2121.OwnerHistory = OwnerHistory;
      _this2121.Name = Name;
      _this2121.Description = Description;
      _this2121.ApplicableOccurrence = ApplicableOccurrence;
      _this2121.HasPropertySets = HasPropertySets;
      _this2121.RepresentationMaps = RepresentationMaps;
      _this2121.Tag = Tag;
      _this2121.ElementType = ElementType;
      _this2121.PredefinedType = PredefinedType;
      _this2121.NominalDiameter = NominalDiameter;
      _this2121.NominalLength = NominalLength;
      _this2121.type = 2108223431;
      return _this2121;
    }

    return IfcMechanicalFastenerType;
  }(IfcElementComponentType);

  IFC42.IfcMechanicalFastenerType = IfcMechanicalFastenerType;

  var IfcMedicalDeviceType = /*#__PURE__*/function (_IfcFlowTerminalType30) {
    _inherits(IfcMedicalDeviceType, _IfcFlowTerminalType30);

    var _super2130 = _createSuper(IfcMedicalDeviceType);

    function IfcMedicalDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2122;

      _classCallCheck2(this, IfcMedicalDeviceType);

      _this2122 = _super2130.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2122.GlobalId = GlobalId;
      _this2122.OwnerHistory = OwnerHistory;
      _this2122.Name = Name;
      _this2122.Description = Description;
      _this2122.ApplicableOccurrence = ApplicableOccurrence;
      _this2122.HasPropertySets = HasPropertySets;
      _this2122.RepresentationMaps = RepresentationMaps;
      _this2122.Tag = Tag;
      _this2122.ElementType = ElementType;
      _this2122.PredefinedType = PredefinedType;
      _this2122.type = 1114901282;
      return _this2122;
    }

    return IfcMedicalDeviceType;
  }(IfcFlowTerminalType);

  IFC42.IfcMedicalDeviceType = IfcMedicalDeviceType;

  var IfcMemberType = /*#__PURE__*/function (_IfcBuildingElementTy19) {
    _inherits(IfcMemberType, _IfcBuildingElementTy19);

    var _super2131 = _createSuper(IfcMemberType);

    function IfcMemberType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2123;

      _classCallCheck2(this, IfcMemberType);

      _this2123 = _super2131.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2123.GlobalId = GlobalId;
      _this2123.OwnerHistory = OwnerHistory;
      _this2123.Name = Name;
      _this2123.Description = Description;
      _this2123.ApplicableOccurrence = ApplicableOccurrence;
      _this2123.HasPropertySets = HasPropertySets;
      _this2123.RepresentationMaps = RepresentationMaps;
      _this2123.Tag = Tag;
      _this2123.ElementType = ElementType;
      _this2123.PredefinedType = PredefinedType;
      _this2123.type = 3181161470;
      return _this2123;
    }

    return IfcMemberType;
  }(IfcBuildingElementType);

  IFC42.IfcMemberType = IfcMemberType;

  var IfcMotorConnectionType = /*#__PURE__*/function (_IfcEnergyConversionD64) {
    _inherits(IfcMotorConnectionType, _IfcEnergyConversionD64);

    var _super2132 = _createSuper(IfcMotorConnectionType);

    function IfcMotorConnectionType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2124;

      _classCallCheck2(this, IfcMotorConnectionType);

      _this2124 = _super2132.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2124.GlobalId = GlobalId;
      _this2124.OwnerHistory = OwnerHistory;
      _this2124.Name = Name;
      _this2124.Description = Description;
      _this2124.ApplicableOccurrence = ApplicableOccurrence;
      _this2124.HasPropertySets = HasPropertySets;
      _this2124.RepresentationMaps = RepresentationMaps;
      _this2124.Tag = Tag;
      _this2124.ElementType = ElementType;
      _this2124.PredefinedType = PredefinedType;
      _this2124.type = 977012517;
      return _this2124;
    }

    return IfcMotorConnectionType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcMotorConnectionType = IfcMotorConnectionType;

  var IfcOccupant = /*#__PURE__*/function (_IfcActor3) {
    _inherits(IfcOccupant, _IfcActor3);

    var _super2133 = _createSuper(IfcOccupant);

    function IfcOccupant(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor, PredefinedType) {
      var _this2125;

      _classCallCheck2(this, IfcOccupant);

      _this2125 = _super2133.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheActor);
      _this2125.GlobalId = GlobalId;
      _this2125.OwnerHistory = OwnerHistory;
      _this2125.Name = Name;
      _this2125.Description = Description;
      _this2125.ObjectType = ObjectType;
      _this2125.TheActor = TheActor;
      _this2125.PredefinedType = PredefinedType;
      _this2125.type = 4143007308;
      return _this2125;
    }

    return IfcOccupant;
  }(IfcActor);

  IFC42.IfcOccupant = IfcOccupant;

  var IfcOpeningElement = /*#__PURE__*/function (_IfcFeatureElementSub6) {
    _inherits(IfcOpeningElement, _IfcFeatureElementSub6);

    var _super2134 = _createSuper(IfcOpeningElement);

    function IfcOpeningElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2126;

      _classCallCheck2(this, IfcOpeningElement);

      _this2126 = _super2134.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2126.GlobalId = GlobalId;
      _this2126.OwnerHistory = OwnerHistory;
      _this2126.Name = Name;
      _this2126.Description = Description;
      _this2126.ObjectType = ObjectType;
      _this2126.ObjectPlacement = ObjectPlacement;
      _this2126.Representation = Representation;
      _this2126.Tag = Tag;
      _this2126.PredefinedType = PredefinedType;
      _this2126.type = 3588315303;
      return _this2126;
    }

    return IfcOpeningElement;
  }(IfcFeatureElementSubtraction);

  IFC42.IfcOpeningElement = IfcOpeningElement;

  var IfcOpeningStandardCase = /*#__PURE__*/function (_IfcOpeningElement) {
    _inherits(IfcOpeningStandardCase, _IfcOpeningElement);

    var _super2135 = _createSuper(IfcOpeningStandardCase);

    function IfcOpeningStandardCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2127;

      _classCallCheck2(this, IfcOpeningStandardCase);

      _this2127 = _super2135.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      _this2127.GlobalId = GlobalId;
      _this2127.OwnerHistory = OwnerHistory;
      _this2127.Name = Name;
      _this2127.Description = Description;
      _this2127.ObjectType = ObjectType;
      _this2127.ObjectPlacement = ObjectPlacement;
      _this2127.Representation = Representation;
      _this2127.Tag = Tag;
      _this2127.PredefinedType = PredefinedType;
      _this2127.type = 3079942009;
      return _this2127;
    }

    return IfcOpeningStandardCase;
  }(IfcOpeningElement);

  IFC42.IfcOpeningStandardCase = IfcOpeningStandardCase;

  var IfcOutletType = /*#__PURE__*/function (_IfcFlowTerminalType31) {
    _inherits(IfcOutletType, _IfcFlowTerminalType31);

    var _super2136 = _createSuper(IfcOutletType);

    function IfcOutletType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2128;

      _classCallCheck2(this, IfcOutletType);

      _this2128 = _super2136.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2128.GlobalId = GlobalId;
      _this2128.OwnerHistory = OwnerHistory;
      _this2128.Name = Name;
      _this2128.Description = Description;
      _this2128.ApplicableOccurrence = ApplicableOccurrence;
      _this2128.HasPropertySets = HasPropertySets;
      _this2128.RepresentationMaps = RepresentationMaps;
      _this2128.Tag = Tag;
      _this2128.ElementType = ElementType;
      _this2128.PredefinedType = PredefinedType;
      _this2128.type = 2837617999;
      return _this2128;
    }

    return IfcOutletType;
  }(IfcFlowTerminalType);

  IFC42.IfcOutletType = IfcOutletType;

  var IfcPerformanceHistory = /*#__PURE__*/function (_IfcControl26) {
    _inherits(IfcPerformanceHistory, _IfcControl26);

    var _super2137 = _createSuper(IfcPerformanceHistory);

    function IfcPerformanceHistory(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LifeCyclePhase, PredefinedType) {
      var _this2129;

      _classCallCheck2(this, IfcPerformanceHistory);

      _this2129 = _super2137.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this2129.GlobalId = GlobalId;
      _this2129.OwnerHistory = OwnerHistory;
      _this2129.Name = Name;
      _this2129.Description = Description;
      _this2129.ObjectType = ObjectType;
      _this2129.Identification = Identification;
      _this2129.LifeCyclePhase = LifeCyclePhase;
      _this2129.PredefinedType = PredefinedType;
      _this2129.type = 2382730787;
      return _this2129;
    }

    return IfcPerformanceHistory;
  }(IfcControl);

  IFC42.IfcPerformanceHistory = IfcPerformanceHistory;

  var IfcPermeableCoveringProperties = /*#__PURE__*/function (_IfcPreDefinedPropert18) {
    _inherits(IfcPermeableCoveringProperties, _IfcPreDefinedPropert18);

    var _super2138 = _createSuper(IfcPermeableCoveringProperties);

    function IfcPermeableCoveringProperties(expressID, GlobalId, OwnerHistory, Name, Description, OperationType, PanelPosition, FrameDepth, FrameThickness, ShapeAspectStyle) {
      var _this2130;

      _classCallCheck2(this, IfcPermeableCoveringProperties);

      _this2130 = _super2138.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this2130.GlobalId = GlobalId;
      _this2130.OwnerHistory = OwnerHistory;
      _this2130.Name = Name;
      _this2130.Description = Description;
      _this2130.OperationType = OperationType;
      _this2130.PanelPosition = PanelPosition;
      _this2130.FrameDepth = FrameDepth;
      _this2130.FrameThickness = FrameThickness;
      _this2130.ShapeAspectStyle = ShapeAspectStyle;
      _this2130.type = 3566463478;
      return _this2130;
    }

    return IfcPermeableCoveringProperties;
  }(IfcPreDefinedPropertySet);

  IFC42.IfcPermeableCoveringProperties = IfcPermeableCoveringProperties;

  var IfcPermit = /*#__PURE__*/function (_IfcControl27) {
    _inherits(IfcPermit, _IfcControl27);

    var _super2139 = _createSuper(IfcPermit);

    function IfcPermit(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      var _this2131;

      _classCallCheck2(this, IfcPermit);

      _this2131 = _super2139.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this2131.GlobalId = GlobalId;
      _this2131.OwnerHistory = OwnerHistory;
      _this2131.Name = Name;
      _this2131.Description = Description;
      _this2131.ObjectType = ObjectType;
      _this2131.Identification = Identification;
      _this2131.PredefinedType = PredefinedType;
      _this2131.Status = Status;
      _this2131.LongDescription = LongDescription;
      _this2131.type = 3327091369;
      return _this2131;
    }

    return IfcPermit;
  }(IfcControl);

  IFC42.IfcPermit = IfcPermit;

  var IfcPileType = /*#__PURE__*/function (_IfcBuildingElementTy20) {
    _inherits(IfcPileType, _IfcBuildingElementTy20);

    var _super2140 = _createSuper(IfcPileType);

    function IfcPileType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2132;

      _classCallCheck2(this, IfcPileType);

      _this2132 = _super2140.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2132.GlobalId = GlobalId;
      _this2132.OwnerHistory = OwnerHistory;
      _this2132.Name = Name;
      _this2132.Description = Description;
      _this2132.ApplicableOccurrence = ApplicableOccurrence;
      _this2132.HasPropertySets = HasPropertySets;
      _this2132.RepresentationMaps = RepresentationMaps;
      _this2132.Tag = Tag;
      _this2132.ElementType = ElementType;
      _this2132.PredefinedType = PredefinedType;
      _this2132.type = 1158309216;
      return _this2132;
    }

    return IfcPileType;
  }(IfcBuildingElementType);

  IFC42.IfcPileType = IfcPileType;

  var IfcPipeFittingType = /*#__PURE__*/function (_IfcFlowFittingType11) {
    _inherits(IfcPipeFittingType, _IfcFlowFittingType11);

    var _super2141 = _createSuper(IfcPipeFittingType);

    function IfcPipeFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2133;

      _classCallCheck2(this, IfcPipeFittingType);

      _this2133 = _super2141.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2133.GlobalId = GlobalId;
      _this2133.OwnerHistory = OwnerHistory;
      _this2133.Name = Name;
      _this2133.Description = Description;
      _this2133.ApplicableOccurrence = ApplicableOccurrence;
      _this2133.HasPropertySets = HasPropertySets;
      _this2133.RepresentationMaps = RepresentationMaps;
      _this2133.Tag = Tag;
      _this2133.ElementType = ElementType;
      _this2133.PredefinedType = PredefinedType;
      _this2133.type = 804291784;
      return _this2133;
    }

    return IfcPipeFittingType;
  }(IfcFlowFittingType);

  IFC42.IfcPipeFittingType = IfcPipeFittingType;

  var IfcPipeSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType10) {
    _inherits(IfcPipeSegmentType, _IfcFlowSegmentType10);

    var _super2142 = _createSuper(IfcPipeSegmentType);

    function IfcPipeSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2134;

      _classCallCheck2(this, IfcPipeSegmentType);

      _this2134 = _super2142.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2134.GlobalId = GlobalId;
      _this2134.OwnerHistory = OwnerHistory;
      _this2134.Name = Name;
      _this2134.Description = Description;
      _this2134.ApplicableOccurrence = ApplicableOccurrence;
      _this2134.HasPropertySets = HasPropertySets;
      _this2134.RepresentationMaps = RepresentationMaps;
      _this2134.Tag = Tag;
      _this2134.ElementType = ElementType;
      _this2134.PredefinedType = PredefinedType;
      _this2134.type = 4231323485;
      return _this2134;
    }

    return IfcPipeSegmentType;
  }(IfcFlowSegmentType);

  IFC42.IfcPipeSegmentType = IfcPipeSegmentType;

  var IfcPlateType = /*#__PURE__*/function (_IfcBuildingElementTy21) {
    _inherits(IfcPlateType, _IfcBuildingElementTy21);

    var _super2143 = _createSuper(IfcPlateType);

    function IfcPlateType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2135;

      _classCallCheck2(this, IfcPlateType);

      _this2135 = _super2143.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2135.GlobalId = GlobalId;
      _this2135.OwnerHistory = OwnerHistory;
      _this2135.Name = Name;
      _this2135.Description = Description;
      _this2135.ApplicableOccurrence = ApplicableOccurrence;
      _this2135.HasPropertySets = HasPropertySets;
      _this2135.RepresentationMaps = RepresentationMaps;
      _this2135.Tag = Tag;
      _this2135.ElementType = ElementType;
      _this2135.PredefinedType = PredefinedType;
      _this2135.type = 4017108033;
      return _this2135;
    }

    return IfcPlateType;
  }(IfcBuildingElementType);

  IFC42.IfcPlateType = IfcPlateType;

  var IfcPolygonalFaceSet = /*#__PURE__*/function (_IfcTessellatedFaceSe4) {
    _inherits(IfcPolygonalFaceSet, _IfcTessellatedFaceSe4);

    var _super2144 = _createSuper(IfcPolygonalFaceSet);

    function IfcPolygonalFaceSet(expressID, Coordinates, Closed, Faces, PnIndex) {
      var _this2136;

      _classCallCheck2(this, IfcPolygonalFaceSet);

      _this2136 = _super2144.call(this, expressID, Coordinates);
      _this2136.Coordinates = Coordinates;
      _this2136.Closed = Closed;
      _this2136.Faces = Faces;
      _this2136.PnIndex = PnIndex;
      _this2136.type = 2839578677;
      return _this2136;
    }

    return IfcPolygonalFaceSet;
  }(IfcTessellatedFaceSet);

  IFC42.IfcPolygonalFaceSet = IfcPolygonalFaceSet;

  var IfcPolyline = /*#__PURE__*/function (_IfcBoundedCurve12) {
    _inherits(IfcPolyline, _IfcBoundedCurve12);

    var _super2145 = _createSuper(IfcPolyline);

    function IfcPolyline(expressID, Points) {
      var _this2137;

      _classCallCheck2(this, IfcPolyline);

      _this2137 = _super2145.call(this, expressID);
      _this2137.Points = Points;
      _this2137.type = 3724593414;
      return _this2137;
    }

    return IfcPolyline;
  }(IfcBoundedCurve);

  IFC42.IfcPolyline = IfcPolyline;

  var IfcPort = /*#__PURE__*/function (_IfcProduct24) {
    _inherits(IfcPort, _IfcProduct24);

    var _super2146 = _createSuper(IfcPort);

    function IfcPort(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation) {
      var _this2138;

      _classCallCheck2(this, IfcPort);

      _this2138 = _super2146.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2138.GlobalId = GlobalId;
      _this2138.OwnerHistory = OwnerHistory;
      _this2138.Name = Name;
      _this2138.Description = Description;
      _this2138.ObjectType = ObjectType;
      _this2138.ObjectPlacement = ObjectPlacement;
      _this2138.Representation = Representation;
      _this2138.type = 3740093272;
      return _this2138;
    }

    return IfcPort;
  }(IfcProduct);

  IFC42.IfcPort = IfcPort;

  var IfcProcedure = /*#__PURE__*/function (_IfcProcess8) {
    _inherits(IfcProcedure, _IfcProcess8);

    var _super2147 = _createSuper(IfcProcedure);

    function IfcProcedure(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, PredefinedType) {
      var _this2139;

      _classCallCheck2(this, IfcProcedure);

      _this2139 = _super2147.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription);
      _this2139.GlobalId = GlobalId;
      _this2139.OwnerHistory = OwnerHistory;
      _this2139.Name = Name;
      _this2139.Description = Description;
      _this2139.ObjectType = ObjectType;
      _this2139.Identification = Identification;
      _this2139.LongDescription = LongDescription;
      _this2139.PredefinedType = PredefinedType;
      _this2139.type = 2744685151;
      return _this2139;
    }

    return IfcProcedure;
  }(IfcProcess);

  IFC42.IfcProcedure = IfcProcedure;

  var IfcProjectOrder = /*#__PURE__*/function (_IfcControl28) {
    _inherits(IfcProjectOrder, _IfcControl28);

    var _super2148 = _createSuper(IfcProjectOrder);

    function IfcProjectOrder(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      var _this2140;

      _classCallCheck2(this, IfcProjectOrder);

      _this2140 = _super2148.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this2140.GlobalId = GlobalId;
      _this2140.OwnerHistory = OwnerHistory;
      _this2140.Name = Name;
      _this2140.Description = Description;
      _this2140.ObjectType = ObjectType;
      _this2140.Identification = Identification;
      _this2140.PredefinedType = PredefinedType;
      _this2140.Status = Status;
      _this2140.LongDescription = LongDescription;
      _this2140.type = 2904328755;
      return _this2140;
    }

    return IfcProjectOrder;
  }(IfcControl);

  IFC42.IfcProjectOrder = IfcProjectOrder;

  var IfcProjectionElement = /*#__PURE__*/function (_IfcFeatureElementAdd3) {
    _inherits(IfcProjectionElement, _IfcFeatureElementAdd3);

    var _super2149 = _createSuper(IfcProjectionElement);

    function IfcProjectionElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2141;

      _classCallCheck2(this, IfcProjectionElement);

      _this2141 = _super2149.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2141.GlobalId = GlobalId;
      _this2141.OwnerHistory = OwnerHistory;
      _this2141.Name = Name;
      _this2141.Description = Description;
      _this2141.ObjectType = ObjectType;
      _this2141.ObjectPlacement = ObjectPlacement;
      _this2141.Representation = Representation;
      _this2141.Tag = Tag;
      _this2141.PredefinedType = PredefinedType;
      _this2141.type = 3651124850;
      return _this2141;
    }

    return IfcProjectionElement;
  }(IfcFeatureElementAddition);

  IFC42.IfcProjectionElement = IfcProjectionElement;

  var IfcProtectiveDeviceType = /*#__PURE__*/function (_IfcFlowControllerTyp18) {
    _inherits(IfcProtectiveDeviceType, _IfcFlowControllerTyp18);

    var _super2150 = _createSuper(IfcProtectiveDeviceType);

    function IfcProtectiveDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2142;

      _classCallCheck2(this, IfcProtectiveDeviceType);

      _this2142 = _super2150.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2142.GlobalId = GlobalId;
      _this2142.OwnerHistory = OwnerHistory;
      _this2142.Name = Name;
      _this2142.Description = Description;
      _this2142.ApplicableOccurrence = ApplicableOccurrence;
      _this2142.HasPropertySets = HasPropertySets;
      _this2142.RepresentationMaps = RepresentationMaps;
      _this2142.Tag = Tag;
      _this2142.ElementType = ElementType;
      _this2142.PredefinedType = PredefinedType;
      _this2142.type = 1842657554;
      return _this2142;
    }

    return IfcProtectiveDeviceType;
  }(IfcFlowControllerType);

  IFC42.IfcProtectiveDeviceType = IfcProtectiveDeviceType;

  var IfcPumpType = /*#__PURE__*/function (_IfcFlowMovingDeviceT7) {
    _inherits(IfcPumpType, _IfcFlowMovingDeviceT7);

    var _super2151 = _createSuper(IfcPumpType);

    function IfcPumpType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2143;

      _classCallCheck2(this, IfcPumpType);

      _this2143 = _super2151.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2143.GlobalId = GlobalId;
      _this2143.OwnerHistory = OwnerHistory;
      _this2143.Name = Name;
      _this2143.Description = Description;
      _this2143.ApplicableOccurrence = ApplicableOccurrence;
      _this2143.HasPropertySets = HasPropertySets;
      _this2143.RepresentationMaps = RepresentationMaps;
      _this2143.Tag = Tag;
      _this2143.ElementType = ElementType;
      _this2143.PredefinedType = PredefinedType;
      _this2143.type = 2250791053;
      return _this2143;
    }

    return IfcPumpType;
  }(IfcFlowMovingDeviceType);

  IFC42.IfcPumpType = IfcPumpType;

  var IfcRailingType = /*#__PURE__*/function (_IfcBuildingElementTy22) {
    _inherits(IfcRailingType, _IfcBuildingElementTy22);

    var _super2152 = _createSuper(IfcRailingType);

    function IfcRailingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2144;

      _classCallCheck2(this, IfcRailingType);

      _this2144 = _super2152.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2144.GlobalId = GlobalId;
      _this2144.OwnerHistory = OwnerHistory;
      _this2144.Name = Name;
      _this2144.Description = Description;
      _this2144.ApplicableOccurrence = ApplicableOccurrence;
      _this2144.HasPropertySets = HasPropertySets;
      _this2144.RepresentationMaps = RepresentationMaps;
      _this2144.Tag = Tag;
      _this2144.ElementType = ElementType;
      _this2144.PredefinedType = PredefinedType;
      _this2144.type = 2893384427;
      return _this2144;
    }

    return IfcRailingType;
  }(IfcBuildingElementType);

  IFC42.IfcRailingType = IfcRailingType;

  var IfcRampFlightType = /*#__PURE__*/function (_IfcBuildingElementTy23) {
    _inherits(IfcRampFlightType, _IfcBuildingElementTy23);

    var _super2153 = _createSuper(IfcRampFlightType);

    function IfcRampFlightType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2145;

      _classCallCheck2(this, IfcRampFlightType);

      _this2145 = _super2153.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2145.GlobalId = GlobalId;
      _this2145.OwnerHistory = OwnerHistory;
      _this2145.Name = Name;
      _this2145.Description = Description;
      _this2145.ApplicableOccurrence = ApplicableOccurrence;
      _this2145.HasPropertySets = HasPropertySets;
      _this2145.RepresentationMaps = RepresentationMaps;
      _this2145.Tag = Tag;
      _this2145.ElementType = ElementType;
      _this2145.PredefinedType = PredefinedType;
      _this2145.type = 2324767716;
      return _this2145;
    }

    return IfcRampFlightType;
  }(IfcBuildingElementType);

  IFC42.IfcRampFlightType = IfcRampFlightType;

  var IfcRampType = /*#__PURE__*/function (_IfcBuildingElementTy24) {
    _inherits(IfcRampType, _IfcBuildingElementTy24);

    var _super2154 = _createSuper(IfcRampType);

    function IfcRampType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2146;

      _classCallCheck2(this, IfcRampType);

      _this2146 = _super2154.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2146.GlobalId = GlobalId;
      _this2146.OwnerHistory = OwnerHistory;
      _this2146.Name = Name;
      _this2146.Description = Description;
      _this2146.ApplicableOccurrence = ApplicableOccurrence;
      _this2146.HasPropertySets = HasPropertySets;
      _this2146.RepresentationMaps = RepresentationMaps;
      _this2146.Tag = Tag;
      _this2146.ElementType = ElementType;
      _this2146.PredefinedType = PredefinedType;
      _this2146.type = 1469900589;
      return _this2146;
    }

    return IfcRampType;
  }(IfcBuildingElementType);

  IFC42.IfcRampType = IfcRampType;

  var IfcRationalBSplineSurfaceWithKnots = /*#__PURE__*/function (_IfcBSplineSurfaceWit2) {
    _inherits(IfcRationalBSplineSurfaceWithKnots, _IfcBSplineSurfaceWit2);

    var _super2155 = _createSuper(IfcRationalBSplineSurfaceWithKnots);

    function IfcRationalBSplineSurfaceWithKnots(expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec, WeightsData) {
      var _this2147;

      _classCallCheck2(this, IfcRationalBSplineSurfaceWithKnots);

      _this2147 = _super2155.call(this, expressID, UDegree, VDegree, ControlPointsList, SurfaceForm, UClosed, VClosed, SelfIntersect, UMultiplicities, VMultiplicities, UKnots, VKnots, KnotSpec);
      _this2147.UDegree = UDegree;
      _this2147.VDegree = VDegree;
      _this2147.ControlPointsList = ControlPointsList;
      _this2147.SurfaceForm = SurfaceForm;
      _this2147.UClosed = UClosed;
      _this2147.VClosed = VClosed;
      _this2147.SelfIntersect = SelfIntersect;
      _this2147.UMultiplicities = UMultiplicities;
      _this2147.VMultiplicities = VMultiplicities;
      _this2147.UKnots = UKnots;
      _this2147.VKnots = VKnots;
      _this2147.KnotSpec = KnotSpec;
      _this2147.WeightsData = WeightsData;
      _this2147.type = 683857671;
      return _this2147;
    }

    return IfcRationalBSplineSurfaceWithKnots;
  }(IfcBSplineSurfaceWithKnots);

  IFC42.IfcRationalBSplineSurfaceWithKnots = IfcRationalBSplineSurfaceWithKnots;

  var IfcReinforcingElement = /*#__PURE__*/function (_IfcElementComponent14) {
    _inherits(IfcReinforcingElement, _IfcElementComponent14);

    var _super2156 = _createSuper(IfcReinforcingElement);

    function IfcReinforcingElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade) {
      var _this2148;

      _classCallCheck2(this, IfcReinforcingElement);

      _this2148 = _super2156.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2148.GlobalId = GlobalId;
      _this2148.OwnerHistory = OwnerHistory;
      _this2148.Name = Name;
      _this2148.Description = Description;
      _this2148.ObjectType = ObjectType;
      _this2148.ObjectPlacement = ObjectPlacement;
      _this2148.Representation = Representation;
      _this2148.Tag = Tag;
      _this2148.SteelGrade = SteelGrade;
      _this2148.type = 3027567501;
      return _this2148;
    }

    return IfcReinforcingElement;
  }(IfcElementComponent);

  IFC42.IfcReinforcingElement = IfcReinforcingElement;

  var IfcReinforcingElementType = /*#__PURE__*/function (_IfcElementComponentT14) {
    _inherits(IfcReinforcingElementType, _IfcElementComponentT14);

    var _super2157 = _createSuper(IfcReinforcingElementType);

    function IfcReinforcingElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2149;

      _classCallCheck2(this, IfcReinforcingElementType);

      _this2149 = _super2157.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2149.GlobalId = GlobalId;
      _this2149.OwnerHistory = OwnerHistory;
      _this2149.Name = Name;
      _this2149.Description = Description;
      _this2149.ApplicableOccurrence = ApplicableOccurrence;
      _this2149.HasPropertySets = HasPropertySets;
      _this2149.RepresentationMaps = RepresentationMaps;
      _this2149.Tag = Tag;
      _this2149.ElementType = ElementType;
      _this2149.type = 964333572;
      return _this2149;
    }

    return IfcReinforcingElementType;
  }(IfcElementComponentType);

  IFC42.IfcReinforcingElementType = IfcReinforcingElementType;

  var IfcReinforcingMesh = /*#__PURE__*/function (_IfcReinforcingElemen15) {
    _inherits(IfcReinforcingMesh, _IfcReinforcingElemen15);

    var _super2158 = _createSuper(IfcReinforcingMesh);

    function IfcReinforcingMesh(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, PredefinedType) {
      var _this2150;

      _classCallCheck2(this, IfcReinforcingMesh);

      _this2150 = _super2158.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this2150.GlobalId = GlobalId;
      _this2150.OwnerHistory = OwnerHistory;
      _this2150.Name = Name;
      _this2150.Description = Description;
      _this2150.ObjectType = ObjectType;
      _this2150.ObjectPlacement = ObjectPlacement;
      _this2150.Representation = Representation;
      _this2150.Tag = Tag;
      _this2150.SteelGrade = SteelGrade;
      _this2150.MeshLength = MeshLength;
      _this2150.MeshWidth = MeshWidth;
      _this2150.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      _this2150.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      _this2150.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      _this2150.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      _this2150.LongitudinalBarSpacing = LongitudinalBarSpacing;
      _this2150.TransverseBarSpacing = TransverseBarSpacing;
      _this2150.PredefinedType = PredefinedType;
      _this2150.type = 2320036040;
      return _this2150;
    }

    return IfcReinforcingMesh;
  }(IfcReinforcingElement);

  IFC42.IfcReinforcingMesh = IfcReinforcingMesh;

  var IfcReinforcingMeshType = /*#__PURE__*/function (_IfcReinforcingElemen16) {
    _inherits(IfcReinforcingMeshType, _IfcReinforcingElemen16);

    var _super2159 = _createSuper(IfcReinforcingMeshType);

    function IfcReinforcingMeshType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, MeshLength, MeshWidth, LongitudinalBarNominalDiameter, TransverseBarNominalDiameter, LongitudinalBarCrossSectionArea, TransverseBarCrossSectionArea, LongitudinalBarSpacing, TransverseBarSpacing, BendingShapeCode, BendingParameters) {
      var _this2151;

      _classCallCheck2(this, IfcReinforcingMeshType);

      _this2151 = _super2159.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2151.GlobalId = GlobalId;
      _this2151.OwnerHistory = OwnerHistory;
      _this2151.Name = Name;
      _this2151.Description = Description;
      _this2151.ApplicableOccurrence = ApplicableOccurrence;
      _this2151.HasPropertySets = HasPropertySets;
      _this2151.RepresentationMaps = RepresentationMaps;
      _this2151.Tag = Tag;
      _this2151.ElementType = ElementType;
      _this2151.PredefinedType = PredefinedType;
      _this2151.MeshLength = MeshLength;
      _this2151.MeshWidth = MeshWidth;
      _this2151.LongitudinalBarNominalDiameter = LongitudinalBarNominalDiameter;
      _this2151.TransverseBarNominalDiameter = TransverseBarNominalDiameter;
      _this2151.LongitudinalBarCrossSectionArea = LongitudinalBarCrossSectionArea;
      _this2151.TransverseBarCrossSectionArea = TransverseBarCrossSectionArea;
      _this2151.LongitudinalBarSpacing = LongitudinalBarSpacing;
      _this2151.TransverseBarSpacing = TransverseBarSpacing;
      _this2151.BendingShapeCode = BendingShapeCode;
      _this2151.BendingParameters = BendingParameters;
      _this2151.type = 2310774935;
      return _this2151;
    }

    return IfcReinforcingMeshType;
  }(IfcReinforcingElementType);

  IFC42.IfcReinforcingMeshType = IfcReinforcingMeshType;

  var IfcRelAggregates = /*#__PURE__*/function (_IfcRelDecomposes11) {
    _inherits(IfcRelAggregates, _IfcRelDecomposes11);

    var _super2160 = _createSuper(IfcRelAggregates);

    function IfcRelAggregates(expressID, GlobalId, OwnerHistory, Name, Description, RelatingObject, RelatedObjects) {
      var _this2152;

      _classCallCheck2(this, IfcRelAggregates);

      _this2152 = _super2160.call(this, expressID, GlobalId, OwnerHistory, Name, Description);
      _this2152.GlobalId = GlobalId;
      _this2152.OwnerHistory = OwnerHistory;
      _this2152.Name = Name;
      _this2152.Description = Description;
      _this2152.RelatingObject = RelatingObject;
      _this2152.RelatedObjects = RelatedObjects;
      _this2152.type = 160246688;
      return _this2152;
    }

    return IfcRelAggregates;
  }(IfcRelDecomposes);

  IFC42.IfcRelAggregates = IfcRelAggregates;

  var IfcRoofType = /*#__PURE__*/function (_IfcBuildingElementTy25) {
    _inherits(IfcRoofType, _IfcBuildingElementTy25);

    var _super2161 = _createSuper(IfcRoofType);

    function IfcRoofType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2153;

      _classCallCheck2(this, IfcRoofType);

      _this2153 = _super2161.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2153.GlobalId = GlobalId;
      _this2153.OwnerHistory = OwnerHistory;
      _this2153.Name = Name;
      _this2153.Description = Description;
      _this2153.ApplicableOccurrence = ApplicableOccurrence;
      _this2153.HasPropertySets = HasPropertySets;
      _this2153.RepresentationMaps = RepresentationMaps;
      _this2153.Tag = Tag;
      _this2153.ElementType = ElementType;
      _this2153.PredefinedType = PredefinedType;
      _this2153.type = 2781568857;
      return _this2153;
    }

    return IfcRoofType;
  }(IfcBuildingElementType);

  IFC42.IfcRoofType = IfcRoofType;

  var IfcSanitaryTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType32) {
    _inherits(IfcSanitaryTerminalType, _IfcFlowTerminalType32);

    var _super2162 = _createSuper(IfcSanitaryTerminalType);

    function IfcSanitaryTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2154;

      _classCallCheck2(this, IfcSanitaryTerminalType);

      _this2154 = _super2162.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2154.GlobalId = GlobalId;
      _this2154.OwnerHistory = OwnerHistory;
      _this2154.Name = Name;
      _this2154.Description = Description;
      _this2154.ApplicableOccurrence = ApplicableOccurrence;
      _this2154.HasPropertySets = HasPropertySets;
      _this2154.RepresentationMaps = RepresentationMaps;
      _this2154.Tag = Tag;
      _this2154.ElementType = ElementType;
      _this2154.PredefinedType = PredefinedType;
      _this2154.type = 1768891740;
      return _this2154;
    }

    return IfcSanitaryTerminalType;
  }(IfcFlowTerminalType);

  IFC42.IfcSanitaryTerminalType = IfcSanitaryTerminalType;

  var IfcSeamCurve = /*#__PURE__*/function (_IfcSurfaceCurve4) {
    _inherits(IfcSeamCurve, _IfcSurfaceCurve4);

    var _super2163 = _createSuper(IfcSeamCurve);

    function IfcSeamCurve(expressID, Curve3D, AssociatedGeometry, MasterRepresentation) {
      var _this2155;

      _classCallCheck2(this, IfcSeamCurve);

      _this2155 = _super2163.call(this, expressID, Curve3D, AssociatedGeometry, MasterRepresentation);
      _this2155.Curve3D = Curve3D;
      _this2155.AssociatedGeometry = AssociatedGeometry;
      _this2155.MasterRepresentation = MasterRepresentation;
      _this2155.type = 2157484638;
      return _this2155;
    }

    return IfcSeamCurve;
  }(IfcSurfaceCurve);

  IFC42.IfcSeamCurve = IfcSeamCurve;

  var IfcShadingDeviceType = /*#__PURE__*/function (_IfcBuildingElementTy26) {
    _inherits(IfcShadingDeviceType, _IfcBuildingElementTy26);

    var _super2164 = _createSuper(IfcShadingDeviceType);

    function IfcShadingDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2156;

      _classCallCheck2(this, IfcShadingDeviceType);

      _this2156 = _super2164.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2156.GlobalId = GlobalId;
      _this2156.OwnerHistory = OwnerHistory;
      _this2156.Name = Name;
      _this2156.Description = Description;
      _this2156.ApplicableOccurrence = ApplicableOccurrence;
      _this2156.HasPropertySets = HasPropertySets;
      _this2156.RepresentationMaps = RepresentationMaps;
      _this2156.Tag = Tag;
      _this2156.ElementType = ElementType;
      _this2156.PredefinedType = PredefinedType;
      _this2156.type = 4074543187;
      return _this2156;
    }

    return IfcShadingDeviceType;
  }(IfcBuildingElementType);

  IFC42.IfcShadingDeviceType = IfcShadingDeviceType;

  var IfcSite = /*#__PURE__*/function (_IfcSpatialStructureE14) {
    _inherits(IfcSite, _IfcSpatialStructureE14);

    var _super2165 = _createSuper(IfcSite);

    function IfcSite(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, RefLatitude, RefLongitude, RefElevation, LandTitleNumber, SiteAddress) {
      var _this2157;

      _classCallCheck2(this, IfcSite);

      _this2157 = _super2165.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this2157.GlobalId = GlobalId;
      _this2157.OwnerHistory = OwnerHistory;
      _this2157.Name = Name;
      _this2157.Description = Description;
      _this2157.ObjectType = ObjectType;
      _this2157.ObjectPlacement = ObjectPlacement;
      _this2157.Representation = Representation;
      _this2157.LongName = LongName;
      _this2157.CompositionType = CompositionType;
      _this2157.RefLatitude = RefLatitude;
      _this2157.RefLongitude = RefLongitude;
      _this2157.RefElevation = RefElevation;
      _this2157.LandTitleNumber = LandTitleNumber;
      _this2157.SiteAddress = SiteAddress;
      _this2157.type = 4097777520;
      return _this2157;
    }

    return IfcSite;
  }(IfcSpatialStructureElement);

  IFC42.IfcSite = IfcSite;

  var IfcSlabType = /*#__PURE__*/function (_IfcBuildingElementTy27) {
    _inherits(IfcSlabType, _IfcBuildingElementTy27);

    var _super2166 = _createSuper(IfcSlabType);

    function IfcSlabType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2158;

      _classCallCheck2(this, IfcSlabType);

      _this2158 = _super2166.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2158.GlobalId = GlobalId;
      _this2158.OwnerHistory = OwnerHistory;
      _this2158.Name = Name;
      _this2158.Description = Description;
      _this2158.ApplicableOccurrence = ApplicableOccurrence;
      _this2158.HasPropertySets = HasPropertySets;
      _this2158.RepresentationMaps = RepresentationMaps;
      _this2158.Tag = Tag;
      _this2158.ElementType = ElementType;
      _this2158.PredefinedType = PredefinedType;
      _this2158.type = 2533589738;
      return _this2158;
    }

    return IfcSlabType;
  }(IfcBuildingElementType);

  IFC42.IfcSlabType = IfcSlabType;

  var IfcSolarDeviceType = /*#__PURE__*/function (_IfcEnergyConversionD65) {
    _inherits(IfcSolarDeviceType, _IfcEnergyConversionD65);

    var _super2167 = _createSuper(IfcSolarDeviceType);

    function IfcSolarDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2159;

      _classCallCheck2(this, IfcSolarDeviceType);

      _this2159 = _super2167.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2159.GlobalId = GlobalId;
      _this2159.OwnerHistory = OwnerHistory;
      _this2159.Name = Name;
      _this2159.Description = Description;
      _this2159.ApplicableOccurrence = ApplicableOccurrence;
      _this2159.HasPropertySets = HasPropertySets;
      _this2159.RepresentationMaps = RepresentationMaps;
      _this2159.Tag = Tag;
      _this2159.ElementType = ElementType;
      _this2159.PredefinedType = PredefinedType;
      _this2159.type = 1072016465;
      return _this2159;
    }

    return IfcSolarDeviceType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcSolarDeviceType = IfcSolarDeviceType;

  var IfcSpace = /*#__PURE__*/function (_IfcSpatialStructureE15) {
    _inherits(IfcSpace, _IfcSpatialStructureE15);

    var _super2168 = _createSuper(IfcSpace);

    function IfcSpace(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType, PredefinedType, ElevationWithFlooring) {
      var _this2160;

      _classCallCheck2(this, IfcSpace);

      _this2160 = _super2168.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, CompositionType);
      _this2160.GlobalId = GlobalId;
      _this2160.OwnerHistory = OwnerHistory;
      _this2160.Name = Name;
      _this2160.Description = Description;
      _this2160.ObjectType = ObjectType;
      _this2160.ObjectPlacement = ObjectPlacement;
      _this2160.Representation = Representation;
      _this2160.LongName = LongName;
      _this2160.CompositionType = CompositionType;
      _this2160.PredefinedType = PredefinedType;
      _this2160.ElevationWithFlooring = ElevationWithFlooring;
      _this2160.type = 3856911033;
      return _this2160;
    }

    return IfcSpace;
  }(IfcSpatialStructureElement);

  IFC42.IfcSpace = IfcSpace;

  var IfcSpaceHeaterType = /*#__PURE__*/function (_IfcFlowTerminalType33) {
    _inherits(IfcSpaceHeaterType, _IfcFlowTerminalType33);

    var _super2169 = _createSuper(IfcSpaceHeaterType);

    function IfcSpaceHeaterType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2161;

      _classCallCheck2(this, IfcSpaceHeaterType);

      _this2161 = _super2169.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2161.GlobalId = GlobalId;
      _this2161.OwnerHistory = OwnerHistory;
      _this2161.Name = Name;
      _this2161.Description = Description;
      _this2161.ApplicableOccurrence = ApplicableOccurrence;
      _this2161.HasPropertySets = HasPropertySets;
      _this2161.RepresentationMaps = RepresentationMaps;
      _this2161.Tag = Tag;
      _this2161.ElementType = ElementType;
      _this2161.PredefinedType = PredefinedType;
      _this2161.type = 1305183839;
      return _this2161;
    }

    return IfcSpaceHeaterType;
  }(IfcFlowTerminalType);

  IFC42.IfcSpaceHeaterType = IfcSpaceHeaterType;

  var IfcSpaceType = /*#__PURE__*/function (_IfcSpatialStructureE16) {
    _inherits(IfcSpaceType, _IfcSpatialStructureE16);

    var _super2170 = _createSuper(IfcSpaceType);

    function IfcSpaceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, LongName) {
      var _this2162;

      _classCallCheck2(this, IfcSpaceType);

      _this2162 = _super2170.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2162.GlobalId = GlobalId;
      _this2162.OwnerHistory = OwnerHistory;
      _this2162.Name = Name;
      _this2162.Description = Description;
      _this2162.ApplicableOccurrence = ApplicableOccurrence;
      _this2162.HasPropertySets = HasPropertySets;
      _this2162.RepresentationMaps = RepresentationMaps;
      _this2162.Tag = Tag;
      _this2162.ElementType = ElementType;
      _this2162.PredefinedType = PredefinedType;
      _this2162.LongName = LongName;
      _this2162.type = 3812236995;
      return _this2162;
    }

    return IfcSpaceType;
  }(IfcSpatialStructureElementType);

  IFC42.IfcSpaceType = IfcSpaceType;

  var IfcStackTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType34) {
    _inherits(IfcStackTerminalType, _IfcFlowTerminalType34);

    var _super2171 = _createSuper(IfcStackTerminalType);

    function IfcStackTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2163;

      _classCallCheck2(this, IfcStackTerminalType);

      _this2163 = _super2171.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2163.GlobalId = GlobalId;
      _this2163.OwnerHistory = OwnerHistory;
      _this2163.Name = Name;
      _this2163.Description = Description;
      _this2163.ApplicableOccurrence = ApplicableOccurrence;
      _this2163.HasPropertySets = HasPropertySets;
      _this2163.RepresentationMaps = RepresentationMaps;
      _this2163.Tag = Tag;
      _this2163.ElementType = ElementType;
      _this2163.PredefinedType = PredefinedType;
      _this2163.type = 3112655638;
      return _this2163;
    }

    return IfcStackTerminalType;
  }(IfcFlowTerminalType);

  IFC42.IfcStackTerminalType = IfcStackTerminalType;

  var IfcStairFlightType = /*#__PURE__*/function (_IfcBuildingElementTy28) {
    _inherits(IfcStairFlightType, _IfcBuildingElementTy28);

    var _super2172 = _createSuper(IfcStairFlightType);

    function IfcStairFlightType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2164;

      _classCallCheck2(this, IfcStairFlightType);

      _this2164 = _super2172.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2164.GlobalId = GlobalId;
      _this2164.OwnerHistory = OwnerHistory;
      _this2164.Name = Name;
      _this2164.Description = Description;
      _this2164.ApplicableOccurrence = ApplicableOccurrence;
      _this2164.HasPropertySets = HasPropertySets;
      _this2164.RepresentationMaps = RepresentationMaps;
      _this2164.Tag = Tag;
      _this2164.ElementType = ElementType;
      _this2164.PredefinedType = PredefinedType;
      _this2164.type = 1039846685;
      return _this2164;
    }

    return IfcStairFlightType;
  }(IfcBuildingElementType);

  IFC42.IfcStairFlightType = IfcStairFlightType;

  var IfcStairType = /*#__PURE__*/function (_IfcBuildingElementTy29) {
    _inherits(IfcStairType, _IfcBuildingElementTy29);

    var _super2173 = _createSuper(IfcStairType);

    function IfcStairType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2165;

      _classCallCheck2(this, IfcStairType);

      _this2165 = _super2173.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2165.GlobalId = GlobalId;
      _this2165.OwnerHistory = OwnerHistory;
      _this2165.Name = Name;
      _this2165.Description = Description;
      _this2165.ApplicableOccurrence = ApplicableOccurrence;
      _this2165.HasPropertySets = HasPropertySets;
      _this2165.RepresentationMaps = RepresentationMaps;
      _this2165.Tag = Tag;
      _this2165.ElementType = ElementType;
      _this2165.PredefinedType = PredefinedType;
      _this2165.type = 338393293;
      return _this2165;
    }

    return IfcStairType;
  }(IfcBuildingElementType);

  IFC42.IfcStairType = IfcStairType;

  var IfcStructuralAction = /*#__PURE__*/function (_IfcStructuralActivit6) {
    _inherits(IfcStructuralAction, _IfcStructuralActivit6);

    var _super2174 = _createSuper(IfcStructuralAction);

    function IfcStructuralAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      var _this2166;

      _classCallCheck2(this, IfcStructuralAction);

      _this2166 = _super2174.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this2166.GlobalId = GlobalId;
      _this2166.OwnerHistory = OwnerHistory;
      _this2166.Name = Name;
      _this2166.Description = Description;
      _this2166.ObjectType = ObjectType;
      _this2166.ObjectPlacement = ObjectPlacement;
      _this2166.Representation = Representation;
      _this2166.AppliedLoad = AppliedLoad;
      _this2166.GlobalOrLocal = GlobalOrLocal;
      _this2166.DestabilizingLoad = DestabilizingLoad;
      _this2166.type = 682877961;
      return _this2166;
    }

    return IfcStructuralAction;
  }(IfcStructuralActivity);

  IFC42.IfcStructuralAction = IfcStructuralAction;

  var IfcStructuralConnection = /*#__PURE__*/function (_IfcStructuralItem6) {
    _inherits(IfcStructuralConnection, _IfcStructuralItem6);

    var _super2175 = _createSuper(IfcStructuralConnection);

    function IfcStructuralConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      var _this2167;

      _classCallCheck2(this, IfcStructuralConnection);

      _this2167 = _super2175.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2167.GlobalId = GlobalId;
      _this2167.OwnerHistory = OwnerHistory;
      _this2167.Name = Name;
      _this2167.Description = Description;
      _this2167.ObjectType = ObjectType;
      _this2167.ObjectPlacement = ObjectPlacement;
      _this2167.Representation = Representation;
      _this2167.AppliedCondition = AppliedCondition;
      _this2167.type = 1179482911;
      return _this2167;
    }

    return IfcStructuralConnection;
  }(IfcStructuralItem);

  IFC42.IfcStructuralConnection = IfcStructuralConnection;

  var IfcStructuralCurveAction = /*#__PURE__*/function (_IfcStructuralAction7) {
    _inherits(IfcStructuralCurveAction, _IfcStructuralAction7);

    var _super2176 = _createSuper(IfcStructuralCurveAction);

    function IfcStructuralCurveAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      var _this2168;

      _classCallCheck2(this, IfcStructuralCurveAction);

      _this2168 = _super2176.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      _this2168.GlobalId = GlobalId;
      _this2168.OwnerHistory = OwnerHistory;
      _this2168.Name = Name;
      _this2168.Description = Description;
      _this2168.ObjectType = ObjectType;
      _this2168.ObjectPlacement = ObjectPlacement;
      _this2168.Representation = Representation;
      _this2168.AppliedLoad = AppliedLoad;
      _this2168.GlobalOrLocal = GlobalOrLocal;
      _this2168.DestabilizingLoad = DestabilizingLoad;
      _this2168.ProjectedOrTrue = ProjectedOrTrue;
      _this2168.PredefinedType = PredefinedType;
      _this2168.type = 1004757350;
      return _this2168;
    }

    return IfcStructuralCurveAction;
  }(IfcStructuralAction);

  IFC42.IfcStructuralCurveAction = IfcStructuralCurveAction;

  var IfcStructuralCurveConnection = /*#__PURE__*/function (_IfcStructuralConnect13) {
    _inherits(IfcStructuralCurveConnection, _IfcStructuralConnect13);

    var _super2177 = _createSuper(IfcStructuralCurveConnection);

    function IfcStructuralCurveConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, Axis) {
      var _this2169;

      _classCallCheck2(this, IfcStructuralCurveConnection);

      _this2169 = _super2177.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      _this2169.GlobalId = GlobalId;
      _this2169.OwnerHistory = OwnerHistory;
      _this2169.Name = Name;
      _this2169.Description = Description;
      _this2169.ObjectType = ObjectType;
      _this2169.ObjectPlacement = ObjectPlacement;
      _this2169.Representation = Representation;
      _this2169.AppliedCondition = AppliedCondition;
      _this2169.Axis = Axis;
      _this2169.type = 4243806635;
      return _this2169;
    }

    return IfcStructuralCurveConnection;
  }(IfcStructuralConnection);

  IFC42.IfcStructuralCurveConnection = IfcStructuralCurveConnection;

  var IfcStructuralCurveMember = /*#__PURE__*/function (_IfcStructuralMember6) {
    _inherits(IfcStructuralCurveMember, _IfcStructuralMember6);

    var _super2178 = _createSuper(IfcStructuralCurveMember);

    function IfcStructuralCurveMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      var _this2170;

      _classCallCheck2(this, IfcStructuralCurveMember);

      _this2170 = _super2178.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2170.GlobalId = GlobalId;
      _this2170.OwnerHistory = OwnerHistory;
      _this2170.Name = Name;
      _this2170.Description = Description;
      _this2170.ObjectType = ObjectType;
      _this2170.ObjectPlacement = ObjectPlacement;
      _this2170.Representation = Representation;
      _this2170.PredefinedType = PredefinedType;
      _this2170.Axis = Axis;
      _this2170.type = 214636428;
      return _this2170;
    }

    return IfcStructuralCurveMember;
  }(IfcStructuralMember);

  IFC42.IfcStructuralCurveMember = IfcStructuralCurveMember;

  var IfcStructuralCurveMemberVarying = /*#__PURE__*/function (_IfcStructuralCurveMe3) {
    _inherits(IfcStructuralCurveMemberVarying, _IfcStructuralCurveMe3);

    var _super2179 = _createSuper(IfcStructuralCurveMemberVarying);

    function IfcStructuralCurveMemberVarying(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis) {
      var _this2171;

      _classCallCheck2(this, IfcStructuralCurveMemberVarying);

      _this2171 = _super2179.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, PredefinedType, Axis);
      _this2171.GlobalId = GlobalId;
      _this2171.OwnerHistory = OwnerHistory;
      _this2171.Name = Name;
      _this2171.Description = Description;
      _this2171.ObjectType = ObjectType;
      _this2171.ObjectPlacement = ObjectPlacement;
      _this2171.Representation = Representation;
      _this2171.PredefinedType = PredefinedType;
      _this2171.Axis = Axis;
      _this2171.type = 2445595289;
      return _this2171;
    }

    return IfcStructuralCurveMemberVarying;
  }(IfcStructuralCurveMember);

  IFC42.IfcStructuralCurveMemberVarying = IfcStructuralCurveMemberVarying;

  var IfcStructuralCurveReaction = /*#__PURE__*/function (_IfcStructuralReactio6) {
    _inherits(IfcStructuralCurveReaction, _IfcStructuralReactio6);

    var _super2180 = _createSuper(IfcStructuralCurveReaction);

    function IfcStructuralCurveReaction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, PredefinedType) {
      var _this2172;

      _classCallCheck2(this, IfcStructuralCurveReaction);

      _this2172 = _super2180.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this2172.GlobalId = GlobalId;
      _this2172.OwnerHistory = OwnerHistory;
      _this2172.Name = Name;
      _this2172.Description = Description;
      _this2172.ObjectType = ObjectType;
      _this2172.ObjectPlacement = ObjectPlacement;
      _this2172.Representation = Representation;
      _this2172.AppliedLoad = AppliedLoad;
      _this2172.GlobalOrLocal = GlobalOrLocal;
      _this2172.PredefinedType = PredefinedType;
      _this2172.type = 2757150158;
      return _this2172;
    }

    return IfcStructuralCurveReaction;
  }(IfcStructuralReaction);

  IFC42.IfcStructuralCurveReaction = IfcStructuralCurveReaction;

  var IfcStructuralLinearAction = /*#__PURE__*/function (_IfcStructuralCurveAc2) {
    _inherits(IfcStructuralLinearAction, _IfcStructuralCurveAc2);

    var _super2181 = _createSuper(IfcStructuralLinearAction);

    function IfcStructuralLinearAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      var _this2173;

      _classCallCheck2(this, IfcStructuralLinearAction);

      _this2173 = _super2181.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      _this2173.GlobalId = GlobalId;
      _this2173.OwnerHistory = OwnerHistory;
      _this2173.Name = Name;
      _this2173.Description = Description;
      _this2173.ObjectType = ObjectType;
      _this2173.ObjectPlacement = ObjectPlacement;
      _this2173.Representation = Representation;
      _this2173.AppliedLoad = AppliedLoad;
      _this2173.GlobalOrLocal = GlobalOrLocal;
      _this2173.DestabilizingLoad = DestabilizingLoad;
      _this2173.ProjectedOrTrue = ProjectedOrTrue;
      _this2173.PredefinedType = PredefinedType;
      _this2173.type = 1807405624;
      return _this2173;
    }

    return IfcStructuralLinearAction;
  }(IfcStructuralCurveAction);

  IFC42.IfcStructuralLinearAction = IfcStructuralLinearAction;

  var IfcStructuralLoadGroup = /*#__PURE__*/function (_IfcGroup14) {
    _inherits(IfcStructuralLoadGroup, _IfcGroup14);

    var _super2182 = _createSuper(IfcStructuralLoadGroup);

    function IfcStructuralLoadGroup(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose) {
      var _this2174;

      _classCallCheck2(this, IfcStructuralLoadGroup);

      _this2174 = _super2182.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2174.GlobalId = GlobalId;
      _this2174.OwnerHistory = OwnerHistory;
      _this2174.Name = Name;
      _this2174.Description = Description;
      _this2174.ObjectType = ObjectType;
      _this2174.PredefinedType = PredefinedType;
      _this2174.ActionType = ActionType;
      _this2174.ActionSource = ActionSource;
      _this2174.Coefficient = Coefficient;
      _this2174.Purpose = Purpose;
      _this2174.type = 1252848954;
      return _this2174;
    }

    return IfcStructuralLoadGroup;
  }(IfcGroup);

  IFC42.IfcStructuralLoadGroup = IfcStructuralLoadGroup;

  var IfcStructuralPointAction = /*#__PURE__*/function (_IfcStructuralAction8) {
    _inherits(IfcStructuralPointAction, _IfcStructuralAction8);

    var _super2183 = _createSuper(IfcStructuralPointAction);

    function IfcStructuralPointAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad) {
      var _this2175;

      _classCallCheck2(this, IfcStructuralPointAction);

      _this2175 = _super2183.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      _this2175.GlobalId = GlobalId;
      _this2175.OwnerHistory = OwnerHistory;
      _this2175.Name = Name;
      _this2175.Description = Description;
      _this2175.ObjectType = ObjectType;
      _this2175.ObjectPlacement = ObjectPlacement;
      _this2175.Representation = Representation;
      _this2175.AppliedLoad = AppliedLoad;
      _this2175.GlobalOrLocal = GlobalOrLocal;
      _this2175.DestabilizingLoad = DestabilizingLoad;
      _this2175.type = 2082059205;
      return _this2175;
    }

    return IfcStructuralPointAction;
  }(IfcStructuralAction);

  IFC42.IfcStructuralPointAction = IfcStructuralPointAction;

  var IfcStructuralPointConnection = /*#__PURE__*/function (_IfcStructuralConnect14) {
    _inherits(IfcStructuralPointConnection, _IfcStructuralConnect14);

    var _super2184 = _createSuper(IfcStructuralPointConnection);

    function IfcStructuralPointConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition, ConditionCoordinateSystem) {
      var _this2176;

      _classCallCheck2(this, IfcStructuralPointConnection);

      _this2176 = _super2184.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      _this2176.GlobalId = GlobalId;
      _this2176.OwnerHistory = OwnerHistory;
      _this2176.Name = Name;
      _this2176.Description = Description;
      _this2176.ObjectType = ObjectType;
      _this2176.ObjectPlacement = ObjectPlacement;
      _this2176.Representation = Representation;
      _this2176.AppliedCondition = AppliedCondition;
      _this2176.ConditionCoordinateSystem = ConditionCoordinateSystem;
      _this2176.type = 734778138;
      return _this2176;
    }

    return IfcStructuralPointConnection;
  }(IfcStructuralConnection);

  IFC42.IfcStructuralPointConnection = IfcStructuralPointConnection;

  var IfcStructuralPointReaction = /*#__PURE__*/function (_IfcStructuralReactio7) {
    _inherits(IfcStructuralPointReaction, _IfcStructuralReactio7);

    var _super2185 = _createSuper(IfcStructuralPointReaction);

    function IfcStructuralPointReaction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal) {
      var _this2177;

      _classCallCheck2(this, IfcStructuralPointReaction);

      _this2177 = _super2185.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal);
      _this2177.GlobalId = GlobalId;
      _this2177.OwnerHistory = OwnerHistory;
      _this2177.Name = Name;
      _this2177.Description = Description;
      _this2177.ObjectType = ObjectType;
      _this2177.ObjectPlacement = ObjectPlacement;
      _this2177.Representation = Representation;
      _this2177.AppliedLoad = AppliedLoad;
      _this2177.GlobalOrLocal = GlobalOrLocal;
      _this2177.type = 1235345126;
      return _this2177;
    }

    return IfcStructuralPointReaction;
  }(IfcStructuralReaction);

  IFC42.IfcStructuralPointReaction = IfcStructuralPointReaction;

  var IfcStructuralResultGroup = /*#__PURE__*/function (_IfcGroup15) {
    _inherits(IfcStructuralResultGroup, _IfcGroup15);

    var _super2186 = _createSuper(IfcStructuralResultGroup);

    function IfcStructuralResultGroup(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, TheoryType, ResultForLoadGroup, IsLinear) {
      var _this2178;

      _classCallCheck2(this, IfcStructuralResultGroup);

      _this2178 = _super2186.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2178.GlobalId = GlobalId;
      _this2178.OwnerHistory = OwnerHistory;
      _this2178.Name = Name;
      _this2178.Description = Description;
      _this2178.ObjectType = ObjectType;
      _this2178.TheoryType = TheoryType;
      _this2178.ResultForLoadGroup = ResultForLoadGroup;
      _this2178.IsLinear = IsLinear;
      _this2178.type = 2986769608;
      return _this2178;
    }

    return IfcStructuralResultGroup;
  }(IfcGroup);

  IFC42.IfcStructuralResultGroup = IfcStructuralResultGroup;

  var IfcStructuralSurfaceAction = /*#__PURE__*/function (_IfcStructuralAction9) {
    _inherits(IfcStructuralSurfaceAction, _IfcStructuralAction9);

    var _super2187 = _createSuper(IfcStructuralSurfaceAction);

    function IfcStructuralSurfaceAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      var _this2179;

      _classCallCheck2(this, IfcStructuralSurfaceAction);

      _this2179 = _super2187.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad);
      _this2179.GlobalId = GlobalId;
      _this2179.OwnerHistory = OwnerHistory;
      _this2179.Name = Name;
      _this2179.Description = Description;
      _this2179.ObjectType = ObjectType;
      _this2179.ObjectPlacement = ObjectPlacement;
      _this2179.Representation = Representation;
      _this2179.AppliedLoad = AppliedLoad;
      _this2179.GlobalOrLocal = GlobalOrLocal;
      _this2179.DestabilizingLoad = DestabilizingLoad;
      _this2179.ProjectedOrTrue = ProjectedOrTrue;
      _this2179.PredefinedType = PredefinedType;
      _this2179.type = 3657597509;
      return _this2179;
    }

    return IfcStructuralSurfaceAction;
  }(IfcStructuralAction);

  IFC42.IfcStructuralSurfaceAction = IfcStructuralSurfaceAction;

  var IfcStructuralSurfaceConnection = /*#__PURE__*/function (_IfcStructuralConnect15) {
    _inherits(IfcStructuralSurfaceConnection, _IfcStructuralConnect15);

    var _super2188 = _createSuper(IfcStructuralSurfaceConnection);

    function IfcStructuralSurfaceConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition) {
      var _this2180;

      _classCallCheck2(this, IfcStructuralSurfaceConnection);

      _this2180 = _super2188.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedCondition);
      _this2180.GlobalId = GlobalId;
      _this2180.OwnerHistory = OwnerHistory;
      _this2180.Name = Name;
      _this2180.Description = Description;
      _this2180.ObjectType = ObjectType;
      _this2180.ObjectPlacement = ObjectPlacement;
      _this2180.Representation = Representation;
      _this2180.AppliedCondition = AppliedCondition;
      _this2180.type = 1975003073;
      return _this2180;
    }

    return IfcStructuralSurfaceConnection;
  }(IfcStructuralConnection);

  IFC42.IfcStructuralSurfaceConnection = IfcStructuralSurfaceConnection;

  var IfcSubContractResource = /*#__PURE__*/function (_IfcConstructionResou27) {
    _inherits(IfcSubContractResource, _IfcConstructionResou27);

    var _super2189 = _createSuper(IfcSubContractResource);

    function IfcSubContractResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this2181;

      _classCallCheck2(this, IfcSubContractResource);

      _this2181 = _super2189.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this2181.GlobalId = GlobalId;
      _this2181.OwnerHistory = OwnerHistory;
      _this2181.Name = Name;
      _this2181.Description = Description;
      _this2181.ObjectType = ObjectType;
      _this2181.Identification = Identification;
      _this2181.LongDescription = LongDescription;
      _this2181.Usage = Usage;
      _this2181.BaseCosts = BaseCosts;
      _this2181.BaseQuantity = BaseQuantity;
      _this2181.PredefinedType = PredefinedType;
      _this2181.type = 148013059;
      return _this2181;
    }

    return IfcSubContractResource;
  }(IfcConstructionResource);

  IFC42.IfcSubContractResource = IfcSubContractResource;

  var IfcSurfaceFeature = /*#__PURE__*/function (_IfcFeatureElement8) {
    _inherits(IfcSurfaceFeature, _IfcFeatureElement8);

    var _super2190 = _createSuper(IfcSurfaceFeature);

    function IfcSurfaceFeature(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2182;

      _classCallCheck2(this, IfcSurfaceFeature);

      _this2182 = _super2190.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2182.GlobalId = GlobalId;
      _this2182.OwnerHistory = OwnerHistory;
      _this2182.Name = Name;
      _this2182.Description = Description;
      _this2182.ObjectType = ObjectType;
      _this2182.ObjectPlacement = ObjectPlacement;
      _this2182.Representation = Representation;
      _this2182.Tag = Tag;
      _this2182.PredefinedType = PredefinedType;
      _this2182.type = 3101698114;
      return _this2182;
    }

    return IfcSurfaceFeature;
  }(IfcFeatureElement);

  IFC42.IfcSurfaceFeature = IfcSurfaceFeature;

  var IfcSwitchingDeviceType = /*#__PURE__*/function (_IfcFlowControllerTyp19) {
    _inherits(IfcSwitchingDeviceType, _IfcFlowControllerTyp19);

    var _super2191 = _createSuper(IfcSwitchingDeviceType);

    function IfcSwitchingDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2183;

      _classCallCheck2(this, IfcSwitchingDeviceType);

      _this2183 = _super2191.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2183.GlobalId = GlobalId;
      _this2183.OwnerHistory = OwnerHistory;
      _this2183.Name = Name;
      _this2183.Description = Description;
      _this2183.ApplicableOccurrence = ApplicableOccurrence;
      _this2183.HasPropertySets = HasPropertySets;
      _this2183.RepresentationMaps = RepresentationMaps;
      _this2183.Tag = Tag;
      _this2183.ElementType = ElementType;
      _this2183.PredefinedType = PredefinedType;
      _this2183.type = 2315554128;
      return _this2183;
    }

    return IfcSwitchingDeviceType;
  }(IfcFlowControllerType);

  IFC42.IfcSwitchingDeviceType = IfcSwitchingDeviceType;

  var IfcSystem = /*#__PURE__*/function (_IfcGroup16) {
    _inherits(IfcSystem, _IfcGroup16);

    var _super2192 = _createSuper(IfcSystem);

    function IfcSystem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType) {
      var _this2184;

      _classCallCheck2(this, IfcSystem);

      _this2184 = _super2192.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2184.GlobalId = GlobalId;
      _this2184.OwnerHistory = OwnerHistory;
      _this2184.Name = Name;
      _this2184.Description = Description;
      _this2184.ObjectType = ObjectType;
      _this2184.type = 2254336722;
      return _this2184;
    }

    return IfcSystem;
  }(IfcGroup);

  IFC42.IfcSystem = IfcSystem;

  var IfcSystemFurnitureElement = /*#__PURE__*/function (_IfcFurnishingElement10) {
    _inherits(IfcSystemFurnitureElement, _IfcFurnishingElement10);

    var _super2193 = _createSuper(IfcSystemFurnitureElement);

    function IfcSystemFurnitureElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2185;

      _classCallCheck2(this, IfcSystemFurnitureElement);

      _this2185 = _super2193.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2185.GlobalId = GlobalId;
      _this2185.OwnerHistory = OwnerHistory;
      _this2185.Name = Name;
      _this2185.Description = Description;
      _this2185.ObjectType = ObjectType;
      _this2185.ObjectPlacement = ObjectPlacement;
      _this2185.Representation = Representation;
      _this2185.Tag = Tag;
      _this2185.PredefinedType = PredefinedType;
      _this2185.type = 413509423;
      return _this2185;
    }

    return IfcSystemFurnitureElement;
  }(IfcFurnishingElement);

  IFC42.IfcSystemFurnitureElement = IfcSystemFurnitureElement;

  var IfcTankType = /*#__PURE__*/function (_IfcFlowStorageDevice7) {
    _inherits(IfcTankType, _IfcFlowStorageDevice7);

    var _super2194 = _createSuper(IfcTankType);

    function IfcTankType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2186;

      _classCallCheck2(this, IfcTankType);

      _this2186 = _super2194.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2186.GlobalId = GlobalId;
      _this2186.OwnerHistory = OwnerHistory;
      _this2186.Name = Name;
      _this2186.Description = Description;
      _this2186.ApplicableOccurrence = ApplicableOccurrence;
      _this2186.HasPropertySets = HasPropertySets;
      _this2186.RepresentationMaps = RepresentationMaps;
      _this2186.Tag = Tag;
      _this2186.ElementType = ElementType;
      _this2186.PredefinedType = PredefinedType;
      _this2186.type = 5716631;
      return _this2186;
    }

    return IfcTankType;
  }(IfcFlowStorageDeviceType);

  IFC42.IfcTankType = IfcTankType;

  var IfcTendon = /*#__PURE__*/function (_IfcReinforcingElemen17) {
    _inherits(IfcTendon, _IfcReinforcingElemen17);

    var _super2195 = _createSuper(IfcTendon);

    function IfcTendon(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType, NominalDiameter, CrossSectionArea, TensionForce, PreStress, FrictionCoefficient, AnchorageSlip, MinCurvatureRadius) {
      var _this2187;

      _classCallCheck2(this, IfcTendon);

      _this2187 = _super2195.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this2187.GlobalId = GlobalId;
      _this2187.OwnerHistory = OwnerHistory;
      _this2187.Name = Name;
      _this2187.Description = Description;
      _this2187.ObjectType = ObjectType;
      _this2187.ObjectPlacement = ObjectPlacement;
      _this2187.Representation = Representation;
      _this2187.Tag = Tag;
      _this2187.SteelGrade = SteelGrade;
      _this2187.PredefinedType = PredefinedType;
      _this2187.NominalDiameter = NominalDiameter;
      _this2187.CrossSectionArea = CrossSectionArea;
      _this2187.TensionForce = TensionForce;
      _this2187.PreStress = PreStress;
      _this2187.FrictionCoefficient = FrictionCoefficient;
      _this2187.AnchorageSlip = AnchorageSlip;
      _this2187.MinCurvatureRadius = MinCurvatureRadius;
      _this2187.type = 3824725483;
      return _this2187;
    }

    return IfcTendon;
  }(IfcReinforcingElement);

  IFC42.IfcTendon = IfcTendon;

  var IfcTendonAnchor = /*#__PURE__*/function (_IfcReinforcingElemen18) {
    _inherits(IfcTendonAnchor, _IfcReinforcingElemen18);

    var _super2196 = _createSuper(IfcTendonAnchor);

    function IfcTendonAnchor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, PredefinedType) {
      var _this2188;

      _classCallCheck2(this, IfcTendonAnchor);

      _this2188 = _super2196.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this2188.GlobalId = GlobalId;
      _this2188.OwnerHistory = OwnerHistory;
      _this2188.Name = Name;
      _this2188.Description = Description;
      _this2188.ObjectType = ObjectType;
      _this2188.ObjectPlacement = ObjectPlacement;
      _this2188.Representation = Representation;
      _this2188.Tag = Tag;
      _this2188.SteelGrade = SteelGrade;
      _this2188.PredefinedType = PredefinedType;
      _this2188.type = 2347447852;
      return _this2188;
    }

    return IfcTendonAnchor;
  }(IfcReinforcingElement);

  IFC42.IfcTendonAnchor = IfcTendonAnchor;

  var IfcTendonAnchorType = /*#__PURE__*/function (_IfcReinforcingElemen19) {
    _inherits(IfcTendonAnchorType, _IfcReinforcingElemen19);

    var _super2197 = _createSuper(IfcTendonAnchorType);

    function IfcTendonAnchorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2189;

      _classCallCheck2(this, IfcTendonAnchorType);

      _this2189 = _super2197.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2189.GlobalId = GlobalId;
      _this2189.OwnerHistory = OwnerHistory;
      _this2189.Name = Name;
      _this2189.Description = Description;
      _this2189.ApplicableOccurrence = ApplicableOccurrence;
      _this2189.HasPropertySets = HasPropertySets;
      _this2189.RepresentationMaps = RepresentationMaps;
      _this2189.Tag = Tag;
      _this2189.ElementType = ElementType;
      _this2189.PredefinedType = PredefinedType;
      _this2189.type = 3081323446;
      return _this2189;
    }

    return IfcTendonAnchorType;
  }(IfcReinforcingElementType);

  IFC42.IfcTendonAnchorType = IfcTendonAnchorType;

  var IfcTendonType = /*#__PURE__*/function (_IfcReinforcingElemen20) {
    _inherits(IfcTendonType, _IfcReinforcingElemen20);

    var _super2198 = _createSuper(IfcTendonType);

    function IfcTendonType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, SheathDiameter) {
      var _this2190;

      _classCallCheck2(this, IfcTendonType);

      _this2190 = _super2198.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2190.GlobalId = GlobalId;
      _this2190.OwnerHistory = OwnerHistory;
      _this2190.Name = Name;
      _this2190.Description = Description;
      _this2190.ApplicableOccurrence = ApplicableOccurrence;
      _this2190.HasPropertySets = HasPropertySets;
      _this2190.RepresentationMaps = RepresentationMaps;
      _this2190.Tag = Tag;
      _this2190.ElementType = ElementType;
      _this2190.PredefinedType = PredefinedType;
      _this2190.NominalDiameter = NominalDiameter;
      _this2190.CrossSectionArea = CrossSectionArea;
      _this2190.SheathDiameter = SheathDiameter;
      _this2190.type = 2415094496;
      return _this2190;
    }

    return IfcTendonType;
  }(IfcReinforcingElementType);

  IFC42.IfcTendonType = IfcTendonType;

  var IfcTransformerType = /*#__PURE__*/function (_IfcEnergyConversionD66) {
    _inherits(IfcTransformerType, _IfcEnergyConversionD66);

    var _super2199 = _createSuper(IfcTransformerType);

    function IfcTransformerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2191;

      _classCallCheck2(this, IfcTransformerType);

      _this2191 = _super2199.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2191.GlobalId = GlobalId;
      _this2191.OwnerHistory = OwnerHistory;
      _this2191.Name = Name;
      _this2191.Description = Description;
      _this2191.ApplicableOccurrence = ApplicableOccurrence;
      _this2191.HasPropertySets = HasPropertySets;
      _this2191.RepresentationMaps = RepresentationMaps;
      _this2191.Tag = Tag;
      _this2191.ElementType = ElementType;
      _this2191.PredefinedType = PredefinedType;
      _this2191.type = 1692211062;
      return _this2191;
    }

    return IfcTransformerType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcTransformerType = IfcTransformerType;

  var IfcTransportElement = /*#__PURE__*/function (_IfcElement27) {
    _inherits(IfcTransportElement, _IfcElement27);

    var _super2200 = _createSuper(IfcTransportElement);

    function IfcTransportElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2192;

      _classCallCheck2(this, IfcTransportElement);

      _this2192 = _super2200.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2192.GlobalId = GlobalId;
      _this2192.OwnerHistory = OwnerHistory;
      _this2192.Name = Name;
      _this2192.Description = Description;
      _this2192.ObjectType = ObjectType;
      _this2192.ObjectPlacement = ObjectPlacement;
      _this2192.Representation = Representation;
      _this2192.Tag = Tag;
      _this2192.PredefinedType = PredefinedType;
      _this2192.type = 1620046519;
      return _this2192;
    }

    return IfcTransportElement;
  }(IfcElement);

  IFC42.IfcTransportElement = IfcTransportElement;

  var IfcTrimmedCurve = /*#__PURE__*/function (_IfcBoundedCurve13) {
    _inherits(IfcTrimmedCurve, _IfcBoundedCurve13);

    var _super2201 = _createSuper(IfcTrimmedCurve);

    function IfcTrimmedCurve(expressID, BasisCurve, Trim1, Trim2, SenseAgreement, MasterRepresentation) {
      var _this2193;

      _classCallCheck2(this, IfcTrimmedCurve);

      _this2193 = _super2201.call(this, expressID);
      _this2193.BasisCurve = BasisCurve;
      _this2193.Trim1 = Trim1;
      _this2193.Trim2 = Trim2;
      _this2193.SenseAgreement = SenseAgreement;
      _this2193.MasterRepresentation = MasterRepresentation;
      _this2193.type = 3593883385;
      return _this2193;
    }

    return IfcTrimmedCurve;
  }(IfcBoundedCurve);

  IFC42.IfcTrimmedCurve = IfcTrimmedCurve;

  var IfcTubeBundleType = /*#__PURE__*/function (_IfcEnergyConversionD67) {
    _inherits(IfcTubeBundleType, _IfcEnergyConversionD67);

    var _super2202 = _createSuper(IfcTubeBundleType);

    function IfcTubeBundleType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2194;

      _classCallCheck2(this, IfcTubeBundleType);

      _this2194 = _super2202.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2194.GlobalId = GlobalId;
      _this2194.OwnerHistory = OwnerHistory;
      _this2194.Name = Name;
      _this2194.Description = Description;
      _this2194.ApplicableOccurrence = ApplicableOccurrence;
      _this2194.HasPropertySets = HasPropertySets;
      _this2194.RepresentationMaps = RepresentationMaps;
      _this2194.Tag = Tag;
      _this2194.ElementType = ElementType;
      _this2194.PredefinedType = PredefinedType;
      _this2194.type = 1600972822;
      return _this2194;
    }

    return IfcTubeBundleType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcTubeBundleType = IfcTubeBundleType;

  var IfcUnitaryEquipmentType = /*#__PURE__*/function (_IfcEnergyConversionD68) {
    _inherits(IfcUnitaryEquipmentType, _IfcEnergyConversionD68);

    var _super2203 = _createSuper(IfcUnitaryEquipmentType);

    function IfcUnitaryEquipmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2195;

      _classCallCheck2(this, IfcUnitaryEquipmentType);

      _this2195 = _super2203.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2195.GlobalId = GlobalId;
      _this2195.OwnerHistory = OwnerHistory;
      _this2195.Name = Name;
      _this2195.Description = Description;
      _this2195.ApplicableOccurrence = ApplicableOccurrence;
      _this2195.HasPropertySets = HasPropertySets;
      _this2195.RepresentationMaps = RepresentationMaps;
      _this2195.Tag = Tag;
      _this2195.ElementType = ElementType;
      _this2195.PredefinedType = PredefinedType;
      _this2195.type = 1911125066;
      return _this2195;
    }

    return IfcUnitaryEquipmentType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcUnitaryEquipmentType = IfcUnitaryEquipmentType;

  var IfcValveType = /*#__PURE__*/function (_IfcFlowControllerTyp20) {
    _inherits(IfcValveType, _IfcFlowControllerTyp20);

    var _super2204 = _createSuper(IfcValveType);

    function IfcValveType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2196;

      _classCallCheck2(this, IfcValveType);

      _this2196 = _super2204.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2196.GlobalId = GlobalId;
      _this2196.OwnerHistory = OwnerHistory;
      _this2196.Name = Name;
      _this2196.Description = Description;
      _this2196.ApplicableOccurrence = ApplicableOccurrence;
      _this2196.HasPropertySets = HasPropertySets;
      _this2196.RepresentationMaps = RepresentationMaps;
      _this2196.Tag = Tag;
      _this2196.ElementType = ElementType;
      _this2196.PredefinedType = PredefinedType;
      _this2196.type = 728799441;
      return _this2196;
    }

    return IfcValveType;
  }(IfcFlowControllerType);

  IFC42.IfcValveType = IfcValveType;

  var IfcVibrationIsolator = /*#__PURE__*/function (_IfcElementComponent15) {
    _inherits(IfcVibrationIsolator, _IfcElementComponent15);

    var _super2205 = _createSuper(IfcVibrationIsolator);

    function IfcVibrationIsolator(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2197;

      _classCallCheck2(this, IfcVibrationIsolator);

      _this2197 = _super2205.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2197.GlobalId = GlobalId;
      _this2197.OwnerHistory = OwnerHistory;
      _this2197.Name = Name;
      _this2197.Description = Description;
      _this2197.ObjectType = ObjectType;
      _this2197.ObjectPlacement = ObjectPlacement;
      _this2197.Representation = Representation;
      _this2197.Tag = Tag;
      _this2197.PredefinedType = PredefinedType;
      _this2197.type = 2391383451;
      return _this2197;
    }

    return IfcVibrationIsolator;
  }(IfcElementComponent);

  IFC42.IfcVibrationIsolator = IfcVibrationIsolator;

  var IfcVibrationIsolatorType = /*#__PURE__*/function (_IfcElementComponentT15) {
    _inherits(IfcVibrationIsolatorType, _IfcElementComponentT15);

    var _super2206 = _createSuper(IfcVibrationIsolatorType);

    function IfcVibrationIsolatorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2198;

      _classCallCheck2(this, IfcVibrationIsolatorType);

      _this2198 = _super2206.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2198.GlobalId = GlobalId;
      _this2198.OwnerHistory = OwnerHistory;
      _this2198.Name = Name;
      _this2198.Description = Description;
      _this2198.ApplicableOccurrence = ApplicableOccurrence;
      _this2198.HasPropertySets = HasPropertySets;
      _this2198.RepresentationMaps = RepresentationMaps;
      _this2198.Tag = Tag;
      _this2198.ElementType = ElementType;
      _this2198.PredefinedType = PredefinedType;
      _this2198.type = 3313531582;
      return _this2198;
    }

    return IfcVibrationIsolatorType;
  }(IfcElementComponentType);

  IFC42.IfcVibrationIsolatorType = IfcVibrationIsolatorType;

  var IfcVirtualElement = /*#__PURE__*/function (_IfcElement28) {
    _inherits(IfcVirtualElement, _IfcElement28);

    var _super2207 = _createSuper(IfcVirtualElement);

    function IfcVirtualElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2199;

      _classCallCheck2(this, IfcVirtualElement);

      _this2199 = _super2207.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2199.GlobalId = GlobalId;
      _this2199.OwnerHistory = OwnerHistory;
      _this2199.Name = Name;
      _this2199.Description = Description;
      _this2199.ObjectType = ObjectType;
      _this2199.ObjectPlacement = ObjectPlacement;
      _this2199.Representation = Representation;
      _this2199.Tag = Tag;
      _this2199.type = 2769231204;
      return _this2199;
    }

    return IfcVirtualElement;
  }(IfcElement);

  IFC42.IfcVirtualElement = IfcVirtualElement;

  var IfcVoidingFeature = /*#__PURE__*/function (_IfcFeatureElementSub7) {
    _inherits(IfcVoidingFeature, _IfcFeatureElementSub7);

    var _super2208 = _createSuper(IfcVoidingFeature);

    function IfcVoidingFeature(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2200;

      _classCallCheck2(this, IfcVoidingFeature);

      _this2200 = _super2208.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2200.GlobalId = GlobalId;
      _this2200.OwnerHistory = OwnerHistory;
      _this2200.Name = Name;
      _this2200.Description = Description;
      _this2200.ObjectType = ObjectType;
      _this2200.ObjectPlacement = ObjectPlacement;
      _this2200.Representation = Representation;
      _this2200.Tag = Tag;
      _this2200.PredefinedType = PredefinedType;
      _this2200.type = 926996030;
      return _this2200;
    }

    return IfcVoidingFeature;
  }(IfcFeatureElementSubtraction);

  IFC42.IfcVoidingFeature = IfcVoidingFeature;

  var IfcWallType = /*#__PURE__*/function (_IfcBuildingElementTy30) {
    _inherits(IfcWallType, _IfcBuildingElementTy30);

    var _super2209 = _createSuper(IfcWallType);

    function IfcWallType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2201;

      _classCallCheck2(this, IfcWallType);

      _this2201 = _super2209.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2201.GlobalId = GlobalId;
      _this2201.OwnerHistory = OwnerHistory;
      _this2201.Name = Name;
      _this2201.Description = Description;
      _this2201.ApplicableOccurrence = ApplicableOccurrence;
      _this2201.HasPropertySets = HasPropertySets;
      _this2201.RepresentationMaps = RepresentationMaps;
      _this2201.Tag = Tag;
      _this2201.ElementType = ElementType;
      _this2201.PredefinedType = PredefinedType;
      _this2201.type = 1898987631;
      return _this2201;
    }

    return IfcWallType;
  }(IfcBuildingElementType);

  IFC42.IfcWallType = IfcWallType;

  var IfcWasteTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType35) {
    _inherits(IfcWasteTerminalType, _IfcFlowTerminalType35);

    var _super2210 = _createSuper(IfcWasteTerminalType);

    function IfcWasteTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2202;

      _classCallCheck2(this, IfcWasteTerminalType);

      _this2202 = _super2210.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2202.GlobalId = GlobalId;
      _this2202.OwnerHistory = OwnerHistory;
      _this2202.Name = Name;
      _this2202.Description = Description;
      _this2202.ApplicableOccurrence = ApplicableOccurrence;
      _this2202.HasPropertySets = HasPropertySets;
      _this2202.RepresentationMaps = RepresentationMaps;
      _this2202.Tag = Tag;
      _this2202.ElementType = ElementType;
      _this2202.PredefinedType = PredefinedType;
      _this2202.type = 1133259667;
      return _this2202;
    }

    return IfcWasteTerminalType;
  }(IfcFlowTerminalType);

  IFC42.IfcWasteTerminalType = IfcWasteTerminalType;

  var IfcWindowType = /*#__PURE__*/function (_IfcBuildingElementTy31) {
    _inherits(IfcWindowType, _IfcBuildingElementTy31);

    var _super2211 = _createSuper(IfcWindowType);

    function IfcWindowType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, PartitioningType, ParameterTakesPrecedence, UserDefinedPartitioningType) {
      var _this2203;

      _classCallCheck2(this, IfcWindowType);

      _this2203 = _super2211.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2203.GlobalId = GlobalId;
      _this2203.OwnerHistory = OwnerHistory;
      _this2203.Name = Name;
      _this2203.Description = Description;
      _this2203.ApplicableOccurrence = ApplicableOccurrence;
      _this2203.HasPropertySets = HasPropertySets;
      _this2203.RepresentationMaps = RepresentationMaps;
      _this2203.Tag = Tag;
      _this2203.ElementType = ElementType;
      _this2203.PredefinedType = PredefinedType;
      _this2203.PartitioningType = PartitioningType;
      _this2203.ParameterTakesPrecedence = ParameterTakesPrecedence;
      _this2203.UserDefinedPartitioningType = UserDefinedPartitioningType;
      _this2203.type = 4009809668;
      return _this2203;
    }

    return IfcWindowType;
  }(IfcBuildingElementType);

  IFC42.IfcWindowType = IfcWindowType;

  var IfcWorkCalendar = /*#__PURE__*/function (_IfcControl29) {
    _inherits(IfcWorkCalendar, _IfcControl29);

    var _super2212 = _createSuper(IfcWorkCalendar);

    function IfcWorkCalendar(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, WorkingTimes, ExceptionTimes, PredefinedType) {
      var _this2204;

      _classCallCheck2(this, IfcWorkCalendar);

      _this2204 = _super2212.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this2204.GlobalId = GlobalId;
      _this2204.OwnerHistory = OwnerHistory;
      _this2204.Name = Name;
      _this2204.Description = Description;
      _this2204.ObjectType = ObjectType;
      _this2204.Identification = Identification;
      _this2204.WorkingTimes = WorkingTimes;
      _this2204.ExceptionTimes = ExceptionTimes;
      _this2204.PredefinedType = PredefinedType;
      _this2204.type = 4088093105;
      return _this2204;
    }

    return IfcWorkCalendar;
  }(IfcControl);

  IFC42.IfcWorkCalendar = IfcWorkCalendar;

  var IfcWorkControl = /*#__PURE__*/function (_IfcControl30) {
    _inherits(IfcWorkControl, _IfcControl30);

    var _super2213 = _createSuper(IfcWorkControl);

    function IfcWorkControl(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime) {
      var _this2205;

      _classCallCheck2(this, IfcWorkControl);

      _this2205 = _super2213.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this2205.GlobalId = GlobalId;
      _this2205.OwnerHistory = OwnerHistory;
      _this2205.Name = Name;
      _this2205.Description = Description;
      _this2205.ObjectType = ObjectType;
      _this2205.Identification = Identification;
      _this2205.CreationDate = CreationDate;
      _this2205.Creators = Creators;
      _this2205.Purpose = Purpose;
      _this2205.Duration = Duration;
      _this2205.TotalFloat = TotalFloat;
      _this2205.StartTime = StartTime;
      _this2205.FinishTime = FinishTime;
      _this2205.type = 1028945134;
      return _this2205;
    }

    return IfcWorkControl;
  }(IfcControl);

  IFC42.IfcWorkControl = IfcWorkControl;

  var IfcWorkPlan = /*#__PURE__*/function (_IfcWorkControl5) {
    _inherits(IfcWorkPlan, _IfcWorkControl5);

    var _super2214 = _createSuper(IfcWorkPlan);

    function IfcWorkPlan(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      var _this2206;

      _classCallCheck2(this, IfcWorkPlan);

      _this2206 = _super2214.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      _this2206.GlobalId = GlobalId;
      _this2206.OwnerHistory = OwnerHistory;
      _this2206.Name = Name;
      _this2206.Description = Description;
      _this2206.ObjectType = ObjectType;
      _this2206.Identification = Identification;
      _this2206.CreationDate = CreationDate;
      _this2206.Creators = Creators;
      _this2206.Purpose = Purpose;
      _this2206.Duration = Duration;
      _this2206.TotalFloat = TotalFloat;
      _this2206.StartTime = StartTime;
      _this2206.FinishTime = FinishTime;
      _this2206.PredefinedType = PredefinedType;
      _this2206.type = 4218914973;
      return _this2206;
    }

    return IfcWorkPlan;
  }(IfcWorkControl);

  IFC42.IfcWorkPlan = IfcWorkPlan;

  var IfcWorkSchedule = /*#__PURE__*/function (_IfcWorkControl6) {
    _inherits(IfcWorkSchedule, _IfcWorkControl6);

    var _super2215 = _createSuper(IfcWorkSchedule);

    function IfcWorkSchedule(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime, PredefinedType) {
      var _this2207;

      _classCallCheck2(this, IfcWorkSchedule);

      _this2207 = _super2215.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, CreationDate, Creators, Purpose, Duration, TotalFloat, StartTime, FinishTime);
      _this2207.GlobalId = GlobalId;
      _this2207.OwnerHistory = OwnerHistory;
      _this2207.Name = Name;
      _this2207.Description = Description;
      _this2207.ObjectType = ObjectType;
      _this2207.Identification = Identification;
      _this2207.CreationDate = CreationDate;
      _this2207.Creators = Creators;
      _this2207.Purpose = Purpose;
      _this2207.Duration = Duration;
      _this2207.TotalFloat = TotalFloat;
      _this2207.StartTime = StartTime;
      _this2207.FinishTime = FinishTime;
      _this2207.PredefinedType = PredefinedType;
      _this2207.type = 3342526732;
      return _this2207;
    }

    return IfcWorkSchedule;
  }(IfcWorkControl);

  IFC42.IfcWorkSchedule = IfcWorkSchedule;

  var IfcZone = /*#__PURE__*/function (_IfcSystem8) {
    _inherits(IfcZone, _IfcSystem8);

    var _super2216 = _createSuper(IfcZone);

    function IfcZone(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName) {
      var _this2208;

      _classCallCheck2(this, IfcZone);

      _this2208 = _super2216.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2208.GlobalId = GlobalId;
      _this2208.OwnerHistory = OwnerHistory;
      _this2208.Name = Name;
      _this2208.Description = Description;
      _this2208.ObjectType = ObjectType;
      _this2208.LongName = LongName;
      _this2208.type = 1033361043;
      return _this2208;
    }

    return IfcZone;
  }(IfcSystem);

  IFC42.IfcZone = IfcZone;

  var IfcActionRequest = /*#__PURE__*/function (_IfcControl31) {
    _inherits(IfcActionRequest, _IfcControl31);

    var _super2217 = _createSuper(IfcActionRequest);

    function IfcActionRequest(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, PredefinedType, Status, LongDescription) {
      var _this2209;

      _classCallCheck2(this, IfcActionRequest);

      _this2209 = _super2217.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification);
      _this2209.GlobalId = GlobalId;
      _this2209.OwnerHistory = OwnerHistory;
      _this2209.Name = Name;
      _this2209.Description = Description;
      _this2209.ObjectType = ObjectType;
      _this2209.Identification = Identification;
      _this2209.PredefinedType = PredefinedType;
      _this2209.Status = Status;
      _this2209.LongDescription = LongDescription;
      _this2209.type = 3821786052;
      return _this2209;
    }

    return IfcActionRequest;
  }(IfcControl);

  IFC42.IfcActionRequest = IfcActionRequest;

  var IfcAirTerminalBoxType = /*#__PURE__*/function (_IfcFlowControllerTyp21) {
    _inherits(IfcAirTerminalBoxType, _IfcFlowControllerTyp21);

    var _super2218 = _createSuper(IfcAirTerminalBoxType);

    function IfcAirTerminalBoxType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2210;

      _classCallCheck2(this, IfcAirTerminalBoxType);

      _this2210 = _super2218.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2210.GlobalId = GlobalId;
      _this2210.OwnerHistory = OwnerHistory;
      _this2210.Name = Name;
      _this2210.Description = Description;
      _this2210.ApplicableOccurrence = ApplicableOccurrence;
      _this2210.HasPropertySets = HasPropertySets;
      _this2210.RepresentationMaps = RepresentationMaps;
      _this2210.Tag = Tag;
      _this2210.ElementType = ElementType;
      _this2210.PredefinedType = PredefinedType;
      _this2210.type = 1411407467;
      return _this2210;
    }

    return IfcAirTerminalBoxType;
  }(IfcFlowControllerType);

  IFC42.IfcAirTerminalBoxType = IfcAirTerminalBoxType;

  var IfcAirTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType36) {
    _inherits(IfcAirTerminalType, _IfcFlowTerminalType36);

    var _super2219 = _createSuper(IfcAirTerminalType);

    function IfcAirTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2211;

      _classCallCheck2(this, IfcAirTerminalType);

      _this2211 = _super2219.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2211.GlobalId = GlobalId;
      _this2211.OwnerHistory = OwnerHistory;
      _this2211.Name = Name;
      _this2211.Description = Description;
      _this2211.ApplicableOccurrence = ApplicableOccurrence;
      _this2211.HasPropertySets = HasPropertySets;
      _this2211.RepresentationMaps = RepresentationMaps;
      _this2211.Tag = Tag;
      _this2211.ElementType = ElementType;
      _this2211.PredefinedType = PredefinedType;
      _this2211.type = 3352864051;
      return _this2211;
    }

    return IfcAirTerminalType;
  }(IfcFlowTerminalType);

  IFC42.IfcAirTerminalType = IfcAirTerminalType;

  var IfcAirToAirHeatRecoveryType = /*#__PURE__*/function (_IfcEnergyConversionD69) {
    _inherits(IfcAirToAirHeatRecoveryType, _IfcEnergyConversionD69);

    var _super2220 = _createSuper(IfcAirToAirHeatRecoveryType);

    function IfcAirToAirHeatRecoveryType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2212;

      _classCallCheck2(this, IfcAirToAirHeatRecoveryType);

      _this2212 = _super2220.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2212.GlobalId = GlobalId;
      _this2212.OwnerHistory = OwnerHistory;
      _this2212.Name = Name;
      _this2212.Description = Description;
      _this2212.ApplicableOccurrence = ApplicableOccurrence;
      _this2212.HasPropertySets = HasPropertySets;
      _this2212.RepresentationMaps = RepresentationMaps;
      _this2212.Tag = Tag;
      _this2212.ElementType = ElementType;
      _this2212.PredefinedType = PredefinedType;
      _this2212.type = 1871374353;
      return _this2212;
    }

    return IfcAirToAirHeatRecoveryType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcAirToAirHeatRecoveryType = IfcAirToAirHeatRecoveryType;

  var IfcAsset = /*#__PURE__*/function (_IfcGroup17) {
    _inherits(IfcAsset, _IfcGroup17);

    var _super2221 = _createSuper(IfcAsset);

    function IfcAsset(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, OriginalValue, CurrentValue, TotalReplacementCost, Owner, User, ResponsiblePerson, IncorporationDate, DepreciatedValue) {
      var _this2213;

      _classCallCheck2(this, IfcAsset);

      _this2213 = _super2221.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2213.GlobalId = GlobalId;
      _this2213.OwnerHistory = OwnerHistory;
      _this2213.Name = Name;
      _this2213.Description = Description;
      _this2213.ObjectType = ObjectType;
      _this2213.Identification = Identification;
      _this2213.OriginalValue = OriginalValue;
      _this2213.CurrentValue = CurrentValue;
      _this2213.TotalReplacementCost = TotalReplacementCost;
      _this2213.Owner = Owner;
      _this2213.User = User;
      _this2213.ResponsiblePerson = ResponsiblePerson;
      _this2213.IncorporationDate = IncorporationDate;
      _this2213.DepreciatedValue = DepreciatedValue;
      _this2213.type = 3460190687;
      return _this2213;
    }

    return IfcAsset;
  }(IfcGroup);

  IFC42.IfcAsset = IfcAsset;

  var IfcAudioVisualApplianceType = /*#__PURE__*/function (_IfcFlowTerminalType37) {
    _inherits(IfcAudioVisualApplianceType, _IfcFlowTerminalType37);

    var _super2222 = _createSuper(IfcAudioVisualApplianceType);

    function IfcAudioVisualApplianceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2214;

      _classCallCheck2(this, IfcAudioVisualApplianceType);

      _this2214 = _super2222.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2214.GlobalId = GlobalId;
      _this2214.OwnerHistory = OwnerHistory;
      _this2214.Name = Name;
      _this2214.Description = Description;
      _this2214.ApplicableOccurrence = ApplicableOccurrence;
      _this2214.HasPropertySets = HasPropertySets;
      _this2214.RepresentationMaps = RepresentationMaps;
      _this2214.Tag = Tag;
      _this2214.ElementType = ElementType;
      _this2214.PredefinedType = PredefinedType;
      _this2214.type = 1532957894;
      return _this2214;
    }

    return IfcAudioVisualApplianceType;
  }(IfcFlowTerminalType);

  IFC42.IfcAudioVisualApplianceType = IfcAudioVisualApplianceType;

  var IfcBSplineCurve = /*#__PURE__*/function (_IfcBoundedCurve14) {
    _inherits(IfcBSplineCurve, _IfcBoundedCurve14);

    var _super2223 = _createSuper(IfcBSplineCurve);

    function IfcBSplineCurve(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect) {
      var _this2215;

      _classCallCheck2(this, IfcBSplineCurve);

      _this2215 = _super2223.call(this, expressID);
      _this2215.Degree = Degree;
      _this2215.ControlPointsList = ControlPointsList;
      _this2215.CurveForm = CurveForm;
      _this2215.ClosedCurve = ClosedCurve;
      _this2215.SelfIntersect = SelfIntersect;
      _this2215.type = 1967976161;
      return _this2215;
    }

    return IfcBSplineCurve;
  }(IfcBoundedCurve);

  IFC42.IfcBSplineCurve = IfcBSplineCurve;

  var IfcBSplineCurveWithKnots = /*#__PURE__*/function (_IfcBSplineCurve3) {
    _inherits(IfcBSplineCurveWithKnots, _IfcBSplineCurve3);

    var _super2224 = _createSuper(IfcBSplineCurveWithKnots);

    function IfcBSplineCurveWithKnots(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec) {
      var _this2216;

      _classCallCheck2(this, IfcBSplineCurveWithKnots);

      _this2216 = _super2224.call(this, expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect);
      _this2216.Degree = Degree;
      _this2216.ControlPointsList = ControlPointsList;
      _this2216.CurveForm = CurveForm;
      _this2216.ClosedCurve = ClosedCurve;
      _this2216.SelfIntersect = SelfIntersect;
      _this2216.KnotMultiplicities = KnotMultiplicities;
      _this2216.Knots = Knots;
      _this2216.KnotSpec = KnotSpec;
      _this2216.type = 2461110595;
      return _this2216;
    }

    return IfcBSplineCurveWithKnots;
  }(IfcBSplineCurve);

  IFC42.IfcBSplineCurveWithKnots = IfcBSplineCurveWithKnots;

  var IfcBeamType = /*#__PURE__*/function (_IfcBuildingElementTy32) {
    _inherits(IfcBeamType, _IfcBuildingElementTy32);

    var _super2225 = _createSuper(IfcBeamType);

    function IfcBeamType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2217;

      _classCallCheck2(this, IfcBeamType);

      _this2217 = _super2225.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2217.GlobalId = GlobalId;
      _this2217.OwnerHistory = OwnerHistory;
      _this2217.Name = Name;
      _this2217.Description = Description;
      _this2217.ApplicableOccurrence = ApplicableOccurrence;
      _this2217.HasPropertySets = HasPropertySets;
      _this2217.RepresentationMaps = RepresentationMaps;
      _this2217.Tag = Tag;
      _this2217.ElementType = ElementType;
      _this2217.PredefinedType = PredefinedType;
      _this2217.type = 819618141;
      return _this2217;
    }

    return IfcBeamType;
  }(IfcBuildingElementType);

  IFC42.IfcBeamType = IfcBeamType;

  var IfcBoilerType = /*#__PURE__*/function (_IfcEnergyConversionD70) {
    _inherits(IfcBoilerType, _IfcEnergyConversionD70);

    var _super2226 = _createSuper(IfcBoilerType);

    function IfcBoilerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2218;

      _classCallCheck2(this, IfcBoilerType);

      _this2218 = _super2226.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2218.GlobalId = GlobalId;
      _this2218.OwnerHistory = OwnerHistory;
      _this2218.Name = Name;
      _this2218.Description = Description;
      _this2218.ApplicableOccurrence = ApplicableOccurrence;
      _this2218.HasPropertySets = HasPropertySets;
      _this2218.RepresentationMaps = RepresentationMaps;
      _this2218.Tag = Tag;
      _this2218.ElementType = ElementType;
      _this2218.PredefinedType = PredefinedType;
      _this2218.type = 231477066;
      return _this2218;
    }

    return IfcBoilerType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcBoilerType = IfcBoilerType;

  var IfcBoundaryCurve = /*#__PURE__*/function (_IfcCompositeCurveOnS2) {
    _inherits(IfcBoundaryCurve, _IfcCompositeCurveOnS2);

    var _super2227 = _createSuper(IfcBoundaryCurve);

    function IfcBoundaryCurve(expressID, Segments, SelfIntersect) {
      var _this2219;

      _classCallCheck2(this, IfcBoundaryCurve);

      _this2219 = _super2227.call(this, expressID, Segments, SelfIntersect);
      _this2219.Segments = Segments;
      _this2219.SelfIntersect = SelfIntersect;
      _this2219.type = 1136057603;
      return _this2219;
    }

    return IfcBoundaryCurve;
  }(IfcCompositeCurveOnSurface);

  IFC42.IfcBoundaryCurve = IfcBoundaryCurve;

  var IfcBuildingElement = /*#__PURE__*/function (_IfcElement29) {
    _inherits(IfcBuildingElement, _IfcElement29);

    var _super2228 = _createSuper(IfcBuildingElement);

    function IfcBuildingElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2220;

      _classCallCheck2(this, IfcBuildingElement);

      _this2220 = _super2228.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2220.GlobalId = GlobalId;
      _this2220.OwnerHistory = OwnerHistory;
      _this2220.Name = Name;
      _this2220.Description = Description;
      _this2220.ObjectType = ObjectType;
      _this2220.ObjectPlacement = ObjectPlacement;
      _this2220.Representation = Representation;
      _this2220.Tag = Tag;
      _this2220.type = 3299480353;
      return _this2220;
    }

    return IfcBuildingElement;
  }(IfcElement);

  IFC42.IfcBuildingElement = IfcBuildingElement;

  var IfcBuildingElementPart = /*#__PURE__*/function (_IfcElementComponent16) {
    _inherits(IfcBuildingElementPart, _IfcElementComponent16);

    var _super2229 = _createSuper(IfcBuildingElementPart);

    function IfcBuildingElementPart(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2221;

      _classCallCheck2(this, IfcBuildingElementPart);

      _this2221 = _super2229.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2221.GlobalId = GlobalId;
      _this2221.OwnerHistory = OwnerHistory;
      _this2221.Name = Name;
      _this2221.Description = Description;
      _this2221.ObjectType = ObjectType;
      _this2221.ObjectPlacement = ObjectPlacement;
      _this2221.Representation = Representation;
      _this2221.Tag = Tag;
      _this2221.PredefinedType = PredefinedType;
      _this2221.type = 2979338954;
      return _this2221;
    }

    return IfcBuildingElementPart;
  }(IfcElementComponent);

  IFC42.IfcBuildingElementPart = IfcBuildingElementPart;

  var IfcBuildingElementPartType = /*#__PURE__*/function (_IfcElementComponentT16) {
    _inherits(IfcBuildingElementPartType, _IfcElementComponentT16);

    var _super2230 = _createSuper(IfcBuildingElementPartType);

    function IfcBuildingElementPartType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2222;

      _classCallCheck2(this, IfcBuildingElementPartType);

      _this2222 = _super2230.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2222.GlobalId = GlobalId;
      _this2222.OwnerHistory = OwnerHistory;
      _this2222.Name = Name;
      _this2222.Description = Description;
      _this2222.ApplicableOccurrence = ApplicableOccurrence;
      _this2222.HasPropertySets = HasPropertySets;
      _this2222.RepresentationMaps = RepresentationMaps;
      _this2222.Tag = Tag;
      _this2222.ElementType = ElementType;
      _this2222.PredefinedType = PredefinedType;
      _this2222.type = 39481116;
      return _this2222;
    }

    return IfcBuildingElementPartType;
  }(IfcElementComponentType);

  IFC42.IfcBuildingElementPartType = IfcBuildingElementPartType;

  var IfcBuildingElementProxy = /*#__PURE__*/function (_IfcBuildingElement21) {
    _inherits(IfcBuildingElementProxy, _IfcBuildingElement21);

    var _super2231 = _createSuper(IfcBuildingElementProxy);

    function IfcBuildingElementProxy(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2223;

      _classCallCheck2(this, IfcBuildingElementProxy);

      _this2223 = _super2231.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2223.GlobalId = GlobalId;
      _this2223.OwnerHistory = OwnerHistory;
      _this2223.Name = Name;
      _this2223.Description = Description;
      _this2223.ObjectType = ObjectType;
      _this2223.ObjectPlacement = ObjectPlacement;
      _this2223.Representation = Representation;
      _this2223.Tag = Tag;
      _this2223.PredefinedType = PredefinedType;
      _this2223.type = 1095909175;
      return _this2223;
    }

    return IfcBuildingElementProxy;
  }(IfcBuildingElement);

  IFC42.IfcBuildingElementProxy = IfcBuildingElementProxy;

  var IfcBuildingElementProxyType = /*#__PURE__*/function (_IfcBuildingElementTy33) {
    _inherits(IfcBuildingElementProxyType, _IfcBuildingElementTy33);

    var _super2232 = _createSuper(IfcBuildingElementProxyType);

    function IfcBuildingElementProxyType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2224;

      _classCallCheck2(this, IfcBuildingElementProxyType);

      _this2224 = _super2232.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2224.GlobalId = GlobalId;
      _this2224.OwnerHistory = OwnerHistory;
      _this2224.Name = Name;
      _this2224.Description = Description;
      _this2224.ApplicableOccurrence = ApplicableOccurrence;
      _this2224.HasPropertySets = HasPropertySets;
      _this2224.RepresentationMaps = RepresentationMaps;
      _this2224.Tag = Tag;
      _this2224.ElementType = ElementType;
      _this2224.PredefinedType = PredefinedType;
      _this2224.type = 1909888760;
      return _this2224;
    }

    return IfcBuildingElementProxyType;
  }(IfcBuildingElementType);

  IFC42.IfcBuildingElementProxyType = IfcBuildingElementProxyType;

  var IfcBuildingSystem = /*#__PURE__*/function (_IfcSystem9) {
    _inherits(IfcBuildingSystem, _IfcSystem9);

    var _super2233 = _createSuper(IfcBuildingSystem);

    function IfcBuildingSystem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, LongName) {
      var _this2225;

      _classCallCheck2(this, IfcBuildingSystem);

      _this2225 = _super2233.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2225.GlobalId = GlobalId;
      _this2225.OwnerHistory = OwnerHistory;
      _this2225.Name = Name;
      _this2225.Description = Description;
      _this2225.ObjectType = ObjectType;
      _this2225.PredefinedType = PredefinedType;
      _this2225.LongName = LongName;
      _this2225.type = 1177604601;
      return _this2225;
    }

    return IfcBuildingSystem;
  }(IfcSystem);

  IFC42.IfcBuildingSystem = IfcBuildingSystem;

  var IfcBurnerType = /*#__PURE__*/function (_IfcEnergyConversionD71) {
    _inherits(IfcBurnerType, _IfcEnergyConversionD71);

    var _super2234 = _createSuper(IfcBurnerType);

    function IfcBurnerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2226;

      _classCallCheck2(this, IfcBurnerType);

      _this2226 = _super2234.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2226.GlobalId = GlobalId;
      _this2226.OwnerHistory = OwnerHistory;
      _this2226.Name = Name;
      _this2226.Description = Description;
      _this2226.ApplicableOccurrence = ApplicableOccurrence;
      _this2226.HasPropertySets = HasPropertySets;
      _this2226.RepresentationMaps = RepresentationMaps;
      _this2226.Tag = Tag;
      _this2226.ElementType = ElementType;
      _this2226.PredefinedType = PredefinedType;
      _this2226.type = 2188180465;
      return _this2226;
    }

    return IfcBurnerType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcBurnerType = IfcBurnerType;

  var IfcCableCarrierFittingType = /*#__PURE__*/function (_IfcFlowFittingType12) {
    _inherits(IfcCableCarrierFittingType, _IfcFlowFittingType12);

    var _super2235 = _createSuper(IfcCableCarrierFittingType);

    function IfcCableCarrierFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2227;

      _classCallCheck2(this, IfcCableCarrierFittingType);

      _this2227 = _super2235.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2227.GlobalId = GlobalId;
      _this2227.OwnerHistory = OwnerHistory;
      _this2227.Name = Name;
      _this2227.Description = Description;
      _this2227.ApplicableOccurrence = ApplicableOccurrence;
      _this2227.HasPropertySets = HasPropertySets;
      _this2227.RepresentationMaps = RepresentationMaps;
      _this2227.Tag = Tag;
      _this2227.ElementType = ElementType;
      _this2227.PredefinedType = PredefinedType;
      _this2227.type = 395041908;
      return _this2227;
    }

    return IfcCableCarrierFittingType;
  }(IfcFlowFittingType);

  IFC42.IfcCableCarrierFittingType = IfcCableCarrierFittingType;

  var IfcCableCarrierSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType11) {
    _inherits(IfcCableCarrierSegmentType, _IfcFlowSegmentType11);

    var _super2236 = _createSuper(IfcCableCarrierSegmentType);

    function IfcCableCarrierSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2228;

      _classCallCheck2(this, IfcCableCarrierSegmentType);

      _this2228 = _super2236.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2228.GlobalId = GlobalId;
      _this2228.OwnerHistory = OwnerHistory;
      _this2228.Name = Name;
      _this2228.Description = Description;
      _this2228.ApplicableOccurrence = ApplicableOccurrence;
      _this2228.HasPropertySets = HasPropertySets;
      _this2228.RepresentationMaps = RepresentationMaps;
      _this2228.Tag = Tag;
      _this2228.ElementType = ElementType;
      _this2228.PredefinedType = PredefinedType;
      _this2228.type = 3293546465;
      return _this2228;
    }

    return IfcCableCarrierSegmentType;
  }(IfcFlowSegmentType);

  IFC42.IfcCableCarrierSegmentType = IfcCableCarrierSegmentType;

  var IfcCableFittingType = /*#__PURE__*/function (_IfcFlowFittingType13) {
    _inherits(IfcCableFittingType, _IfcFlowFittingType13);

    var _super2237 = _createSuper(IfcCableFittingType);

    function IfcCableFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2229;

      _classCallCheck2(this, IfcCableFittingType);

      _this2229 = _super2237.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2229.GlobalId = GlobalId;
      _this2229.OwnerHistory = OwnerHistory;
      _this2229.Name = Name;
      _this2229.Description = Description;
      _this2229.ApplicableOccurrence = ApplicableOccurrence;
      _this2229.HasPropertySets = HasPropertySets;
      _this2229.RepresentationMaps = RepresentationMaps;
      _this2229.Tag = Tag;
      _this2229.ElementType = ElementType;
      _this2229.PredefinedType = PredefinedType;
      _this2229.type = 2674252688;
      return _this2229;
    }

    return IfcCableFittingType;
  }(IfcFlowFittingType);

  IFC42.IfcCableFittingType = IfcCableFittingType;

  var IfcCableSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType12) {
    _inherits(IfcCableSegmentType, _IfcFlowSegmentType12);

    var _super2238 = _createSuper(IfcCableSegmentType);

    function IfcCableSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2230;

      _classCallCheck2(this, IfcCableSegmentType);

      _this2230 = _super2238.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2230.GlobalId = GlobalId;
      _this2230.OwnerHistory = OwnerHistory;
      _this2230.Name = Name;
      _this2230.Description = Description;
      _this2230.ApplicableOccurrence = ApplicableOccurrence;
      _this2230.HasPropertySets = HasPropertySets;
      _this2230.RepresentationMaps = RepresentationMaps;
      _this2230.Tag = Tag;
      _this2230.ElementType = ElementType;
      _this2230.PredefinedType = PredefinedType;
      _this2230.type = 1285652485;
      return _this2230;
    }

    return IfcCableSegmentType;
  }(IfcFlowSegmentType);

  IFC42.IfcCableSegmentType = IfcCableSegmentType;

  var IfcChillerType = /*#__PURE__*/function (_IfcEnergyConversionD72) {
    _inherits(IfcChillerType, _IfcEnergyConversionD72);

    var _super2239 = _createSuper(IfcChillerType);

    function IfcChillerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2231;

      _classCallCheck2(this, IfcChillerType);

      _this2231 = _super2239.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2231.GlobalId = GlobalId;
      _this2231.OwnerHistory = OwnerHistory;
      _this2231.Name = Name;
      _this2231.Description = Description;
      _this2231.ApplicableOccurrence = ApplicableOccurrence;
      _this2231.HasPropertySets = HasPropertySets;
      _this2231.RepresentationMaps = RepresentationMaps;
      _this2231.Tag = Tag;
      _this2231.ElementType = ElementType;
      _this2231.PredefinedType = PredefinedType;
      _this2231.type = 2951183804;
      return _this2231;
    }

    return IfcChillerType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcChillerType = IfcChillerType;

  var IfcChimney = /*#__PURE__*/function (_IfcBuildingElement22) {
    _inherits(IfcChimney, _IfcBuildingElement22);

    var _super2240 = _createSuper(IfcChimney);

    function IfcChimney(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2232;

      _classCallCheck2(this, IfcChimney);

      _this2232 = _super2240.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2232.GlobalId = GlobalId;
      _this2232.OwnerHistory = OwnerHistory;
      _this2232.Name = Name;
      _this2232.Description = Description;
      _this2232.ObjectType = ObjectType;
      _this2232.ObjectPlacement = ObjectPlacement;
      _this2232.Representation = Representation;
      _this2232.Tag = Tag;
      _this2232.PredefinedType = PredefinedType;
      _this2232.type = 3296154744;
      return _this2232;
    }

    return IfcChimney;
  }(IfcBuildingElement);

  IFC42.IfcChimney = IfcChimney;

  var IfcCircle = /*#__PURE__*/function (_IfcConic6) {
    _inherits(IfcCircle, _IfcConic6);

    var _super2241 = _createSuper(IfcCircle);

    function IfcCircle(expressID, Position, Radius) {
      var _this2233;

      _classCallCheck2(this, IfcCircle);

      _this2233 = _super2241.call(this, expressID, Position);
      _this2233.Position = Position;
      _this2233.Radius = Radius;
      _this2233.type = 2611217952;
      return _this2233;
    }

    return IfcCircle;
  }(IfcConic);

  IFC42.IfcCircle = IfcCircle;

  var IfcCivilElement = /*#__PURE__*/function (_IfcElement30) {
    _inherits(IfcCivilElement, _IfcElement30);

    var _super2242 = _createSuper(IfcCivilElement);

    function IfcCivilElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2234;

      _classCallCheck2(this, IfcCivilElement);

      _this2234 = _super2242.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2234.GlobalId = GlobalId;
      _this2234.OwnerHistory = OwnerHistory;
      _this2234.Name = Name;
      _this2234.Description = Description;
      _this2234.ObjectType = ObjectType;
      _this2234.ObjectPlacement = ObjectPlacement;
      _this2234.Representation = Representation;
      _this2234.Tag = Tag;
      _this2234.type = 1677625105;
      return _this2234;
    }

    return IfcCivilElement;
  }(IfcElement);

  IFC42.IfcCivilElement = IfcCivilElement;

  var IfcCoilType = /*#__PURE__*/function (_IfcEnergyConversionD73) {
    _inherits(IfcCoilType, _IfcEnergyConversionD73);

    var _super2243 = _createSuper(IfcCoilType);

    function IfcCoilType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2235;

      _classCallCheck2(this, IfcCoilType);

      _this2235 = _super2243.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2235.GlobalId = GlobalId;
      _this2235.OwnerHistory = OwnerHistory;
      _this2235.Name = Name;
      _this2235.Description = Description;
      _this2235.ApplicableOccurrence = ApplicableOccurrence;
      _this2235.HasPropertySets = HasPropertySets;
      _this2235.RepresentationMaps = RepresentationMaps;
      _this2235.Tag = Tag;
      _this2235.ElementType = ElementType;
      _this2235.PredefinedType = PredefinedType;
      _this2235.type = 2301859152;
      return _this2235;
    }

    return IfcCoilType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcCoilType = IfcCoilType;

  var IfcColumn = /*#__PURE__*/function (_IfcBuildingElement23) {
    _inherits(IfcColumn, _IfcBuildingElement23);

    var _super2244 = _createSuper(IfcColumn);

    function IfcColumn(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2236;

      _classCallCheck2(this, IfcColumn);

      _this2236 = _super2244.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2236.GlobalId = GlobalId;
      _this2236.OwnerHistory = OwnerHistory;
      _this2236.Name = Name;
      _this2236.Description = Description;
      _this2236.ObjectType = ObjectType;
      _this2236.ObjectPlacement = ObjectPlacement;
      _this2236.Representation = Representation;
      _this2236.Tag = Tag;
      _this2236.PredefinedType = PredefinedType;
      _this2236.type = 843113511;
      return _this2236;
    }

    return IfcColumn;
  }(IfcBuildingElement);

  IFC42.IfcColumn = IfcColumn;

  var IfcColumnStandardCase = /*#__PURE__*/function (_IfcColumn) {
    _inherits(IfcColumnStandardCase, _IfcColumn);

    var _super2245 = _createSuper(IfcColumnStandardCase);

    function IfcColumnStandardCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2237;

      _classCallCheck2(this, IfcColumnStandardCase);

      _this2237 = _super2245.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      _this2237.GlobalId = GlobalId;
      _this2237.OwnerHistory = OwnerHistory;
      _this2237.Name = Name;
      _this2237.Description = Description;
      _this2237.ObjectType = ObjectType;
      _this2237.ObjectPlacement = ObjectPlacement;
      _this2237.Representation = Representation;
      _this2237.Tag = Tag;
      _this2237.PredefinedType = PredefinedType;
      _this2237.type = 905975707;
      return _this2237;
    }

    return IfcColumnStandardCase;
  }(IfcColumn);

  IFC42.IfcColumnStandardCase = IfcColumnStandardCase;

  var IfcCommunicationsApplianceType = /*#__PURE__*/function (_IfcFlowTerminalType38) {
    _inherits(IfcCommunicationsApplianceType, _IfcFlowTerminalType38);

    var _super2246 = _createSuper(IfcCommunicationsApplianceType);

    function IfcCommunicationsApplianceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2238;

      _classCallCheck2(this, IfcCommunicationsApplianceType);

      _this2238 = _super2246.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2238.GlobalId = GlobalId;
      _this2238.OwnerHistory = OwnerHistory;
      _this2238.Name = Name;
      _this2238.Description = Description;
      _this2238.ApplicableOccurrence = ApplicableOccurrence;
      _this2238.HasPropertySets = HasPropertySets;
      _this2238.RepresentationMaps = RepresentationMaps;
      _this2238.Tag = Tag;
      _this2238.ElementType = ElementType;
      _this2238.PredefinedType = PredefinedType;
      _this2238.type = 400855858;
      return _this2238;
    }

    return IfcCommunicationsApplianceType;
  }(IfcFlowTerminalType);

  IFC42.IfcCommunicationsApplianceType = IfcCommunicationsApplianceType;

  var IfcCompressorType = /*#__PURE__*/function (_IfcFlowMovingDeviceT8) {
    _inherits(IfcCompressorType, _IfcFlowMovingDeviceT8);

    var _super2247 = _createSuper(IfcCompressorType);

    function IfcCompressorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2239;

      _classCallCheck2(this, IfcCompressorType);

      _this2239 = _super2247.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2239.GlobalId = GlobalId;
      _this2239.OwnerHistory = OwnerHistory;
      _this2239.Name = Name;
      _this2239.Description = Description;
      _this2239.ApplicableOccurrence = ApplicableOccurrence;
      _this2239.HasPropertySets = HasPropertySets;
      _this2239.RepresentationMaps = RepresentationMaps;
      _this2239.Tag = Tag;
      _this2239.ElementType = ElementType;
      _this2239.PredefinedType = PredefinedType;
      _this2239.type = 3850581409;
      return _this2239;
    }

    return IfcCompressorType;
  }(IfcFlowMovingDeviceType);

  IFC42.IfcCompressorType = IfcCompressorType;

  var IfcCondenserType = /*#__PURE__*/function (_IfcEnergyConversionD74) {
    _inherits(IfcCondenserType, _IfcEnergyConversionD74);

    var _super2248 = _createSuper(IfcCondenserType);

    function IfcCondenserType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2240;

      _classCallCheck2(this, IfcCondenserType);

      _this2240 = _super2248.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2240.GlobalId = GlobalId;
      _this2240.OwnerHistory = OwnerHistory;
      _this2240.Name = Name;
      _this2240.Description = Description;
      _this2240.ApplicableOccurrence = ApplicableOccurrence;
      _this2240.HasPropertySets = HasPropertySets;
      _this2240.RepresentationMaps = RepresentationMaps;
      _this2240.Tag = Tag;
      _this2240.ElementType = ElementType;
      _this2240.PredefinedType = PredefinedType;
      _this2240.type = 2816379211;
      return _this2240;
    }

    return IfcCondenserType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcCondenserType = IfcCondenserType;

  var IfcConstructionEquipmentResource = /*#__PURE__*/function (_IfcConstructionResou28) {
    _inherits(IfcConstructionEquipmentResource, _IfcConstructionResou28);

    var _super2249 = _createSuper(IfcConstructionEquipmentResource);

    function IfcConstructionEquipmentResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this2241;

      _classCallCheck2(this, IfcConstructionEquipmentResource);

      _this2241 = _super2249.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this2241.GlobalId = GlobalId;
      _this2241.OwnerHistory = OwnerHistory;
      _this2241.Name = Name;
      _this2241.Description = Description;
      _this2241.ObjectType = ObjectType;
      _this2241.Identification = Identification;
      _this2241.LongDescription = LongDescription;
      _this2241.Usage = Usage;
      _this2241.BaseCosts = BaseCosts;
      _this2241.BaseQuantity = BaseQuantity;
      _this2241.PredefinedType = PredefinedType;
      _this2241.type = 3898045240;
      return _this2241;
    }

    return IfcConstructionEquipmentResource;
  }(IfcConstructionResource);

  IFC42.IfcConstructionEquipmentResource = IfcConstructionEquipmentResource;

  var IfcConstructionMaterialResource = /*#__PURE__*/function (_IfcConstructionResou29) {
    _inherits(IfcConstructionMaterialResource, _IfcConstructionResou29);

    var _super2250 = _createSuper(IfcConstructionMaterialResource);

    function IfcConstructionMaterialResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this2242;

      _classCallCheck2(this, IfcConstructionMaterialResource);

      _this2242 = _super2250.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this2242.GlobalId = GlobalId;
      _this2242.OwnerHistory = OwnerHistory;
      _this2242.Name = Name;
      _this2242.Description = Description;
      _this2242.ObjectType = ObjectType;
      _this2242.Identification = Identification;
      _this2242.LongDescription = LongDescription;
      _this2242.Usage = Usage;
      _this2242.BaseCosts = BaseCosts;
      _this2242.BaseQuantity = BaseQuantity;
      _this2242.PredefinedType = PredefinedType;
      _this2242.type = 1060000209;
      return _this2242;
    }

    return IfcConstructionMaterialResource;
  }(IfcConstructionResource);

  IFC42.IfcConstructionMaterialResource = IfcConstructionMaterialResource;

  var IfcConstructionProductResource = /*#__PURE__*/function (_IfcConstructionResou30) {
    _inherits(IfcConstructionProductResource, _IfcConstructionResou30);

    var _super2251 = _createSuper(IfcConstructionProductResource);

    function IfcConstructionProductResource(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity, PredefinedType) {
      var _this2243;

      _classCallCheck2(this, IfcConstructionProductResource);

      _this2243 = _super2251.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, Identification, LongDescription, Usage, BaseCosts, BaseQuantity);
      _this2243.GlobalId = GlobalId;
      _this2243.OwnerHistory = OwnerHistory;
      _this2243.Name = Name;
      _this2243.Description = Description;
      _this2243.ObjectType = ObjectType;
      _this2243.Identification = Identification;
      _this2243.LongDescription = LongDescription;
      _this2243.Usage = Usage;
      _this2243.BaseCosts = BaseCosts;
      _this2243.BaseQuantity = BaseQuantity;
      _this2243.PredefinedType = PredefinedType;
      _this2243.type = 488727124;
      return _this2243;
    }

    return IfcConstructionProductResource;
  }(IfcConstructionResource);

  IFC42.IfcConstructionProductResource = IfcConstructionProductResource;

  var IfcCooledBeamType = /*#__PURE__*/function (_IfcEnergyConversionD75) {
    _inherits(IfcCooledBeamType, _IfcEnergyConversionD75);

    var _super2252 = _createSuper(IfcCooledBeamType);

    function IfcCooledBeamType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2244;

      _classCallCheck2(this, IfcCooledBeamType);

      _this2244 = _super2252.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2244.GlobalId = GlobalId;
      _this2244.OwnerHistory = OwnerHistory;
      _this2244.Name = Name;
      _this2244.Description = Description;
      _this2244.ApplicableOccurrence = ApplicableOccurrence;
      _this2244.HasPropertySets = HasPropertySets;
      _this2244.RepresentationMaps = RepresentationMaps;
      _this2244.Tag = Tag;
      _this2244.ElementType = ElementType;
      _this2244.PredefinedType = PredefinedType;
      _this2244.type = 335055490;
      return _this2244;
    }

    return IfcCooledBeamType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcCooledBeamType = IfcCooledBeamType;

  var IfcCoolingTowerType = /*#__PURE__*/function (_IfcEnergyConversionD76) {
    _inherits(IfcCoolingTowerType, _IfcEnergyConversionD76);

    var _super2253 = _createSuper(IfcCoolingTowerType);

    function IfcCoolingTowerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2245;

      _classCallCheck2(this, IfcCoolingTowerType);

      _this2245 = _super2253.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2245.GlobalId = GlobalId;
      _this2245.OwnerHistory = OwnerHistory;
      _this2245.Name = Name;
      _this2245.Description = Description;
      _this2245.ApplicableOccurrence = ApplicableOccurrence;
      _this2245.HasPropertySets = HasPropertySets;
      _this2245.RepresentationMaps = RepresentationMaps;
      _this2245.Tag = Tag;
      _this2245.ElementType = ElementType;
      _this2245.PredefinedType = PredefinedType;
      _this2245.type = 2954562838;
      return _this2245;
    }

    return IfcCoolingTowerType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcCoolingTowerType = IfcCoolingTowerType;

  var IfcCovering = /*#__PURE__*/function (_IfcBuildingElement24) {
    _inherits(IfcCovering, _IfcBuildingElement24);

    var _super2254 = _createSuper(IfcCovering);

    function IfcCovering(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2246;

      _classCallCheck2(this, IfcCovering);

      _this2246 = _super2254.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2246.GlobalId = GlobalId;
      _this2246.OwnerHistory = OwnerHistory;
      _this2246.Name = Name;
      _this2246.Description = Description;
      _this2246.ObjectType = ObjectType;
      _this2246.ObjectPlacement = ObjectPlacement;
      _this2246.Representation = Representation;
      _this2246.Tag = Tag;
      _this2246.PredefinedType = PredefinedType;
      _this2246.type = 1973544240;
      return _this2246;
    }

    return IfcCovering;
  }(IfcBuildingElement);

  IFC42.IfcCovering = IfcCovering;

  var IfcCurtainWall = /*#__PURE__*/function (_IfcBuildingElement25) {
    _inherits(IfcCurtainWall, _IfcBuildingElement25);

    var _super2255 = _createSuper(IfcCurtainWall);

    function IfcCurtainWall(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2247;

      _classCallCheck2(this, IfcCurtainWall);

      _this2247 = _super2255.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2247.GlobalId = GlobalId;
      _this2247.OwnerHistory = OwnerHistory;
      _this2247.Name = Name;
      _this2247.Description = Description;
      _this2247.ObjectType = ObjectType;
      _this2247.ObjectPlacement = ObjectPlacement;
      _this2247.Representation = Representation;
      _this2247.Tag = Tag;
      _this2247.PredefinedType = PredefinedType;
      _this2247.type = 3495092785;
      return _this2247;
    }

    return IfcCurtainWall;
  }(IfcBuildingElement);

  IFC42.IfcCurtainWall = IfcCurtainWall;

  var IfcDamperType = /*#__PURE__*/function (_IfcFlowControllerTyp22) {
    _inherits(IfcDamperType, _IfcFlowControllerTyp22);

    var _super2256 = _createSuper(IfcDamperType);

    function IfcDamperType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2248;

      _classCallCheck2(this, IfcDamperType);

      _this2248 = _super2256.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2248.GlobalId = GlobalId;
      _this2248.OwnerHistory = OwnerHistory;
      _this2248.Name = Name;
      _this2248.Description = Description;
      _this2248.ApplicableOccurrence = ApplicableOccurrence;
      _this2248.HasPropertySets = HasPropertySets;
      _this2248.RepresentationMaps = RepresentationMaps;
      _this2248.Tag = Tag;
      _this2248.ElementType = ElementType;
      _this2248.PredefinedType = PredefinedType;
      _this2248.type = 3961806047;
      return _this2248;
    }

    return IfcDamperType;
  }(IfcFlowControllerType);

  IFC42.IfcDamperType = IfcDamperType;

  var IfcDiscreteAccessory = /*#__PURE__*/function (_IfcElementComponent17) {
    _inherits(IfcDiscreteAccessory, _IfcElementComponent17);

    var _super2257 = _createSuper(IfcDiscreteAccessory);

    function IfcDiscreteAccessory(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2249;

      _classCallCheck2(this, IfcDiscreteAccessory);

      _this2249 = _super2257.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2249.GlobalId = GlobalId;
      _this2249.OwnerHistory = OwnerHistory;
      _this2249.Name = Name;
      _this2249.Description = Description;
      _this2249.ObjectType = ObjectType;
      _this2249.ObjectPlacement = ObjectPlacement;
      _this2249.Representation = Representation;
      _this2249.Tag = Tag;
      _this2249.PredefinedType = PredefinedType;
      _this2249.type = 1335981549;
      return _this2249;
    }

    return IfcDiscreteAccessory;
  }(IfcElementComponent);

  IFC42.IfcDiscreteAccessory = IfcDiscreteAccessory;

  var IfcDiscreteAccessoryType = /*#__PURE__*/function (_IfcElementComponentT17) {
    _inherits(IfcDiscreteAccessoryType, _IfcElementComponentT17);

    var _super2258 = _createSuper(IfcDiscreteAccessoryType);

    function IfcDiscreteAccessoryType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2250;

      _classCallCheck2(this, IfcDiscreteAccessoryType);

      _this2250 = _super2258.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2250.GlobalId = GlobalId;
      _this2250.OwnerHistory = OwnerHistory;
      _this2250.Name = Name;
      _this2250.Description = Description;
      _this2250.ApplicableOccurrence = ApplicableOccurrence;
      _this2250.HasPropertySets = HasPropertySets;
      _this2250.RepresentationMaps = RepresentationMaps;
      _this2250.Tag = Tag;
      _this2250.ElementType = ElementType;
      _this2250.PredefinedType = PredefinedType;
      _this2250.type = 2635815018;
      return _this2250;
    }

    return IfcDiscreteAccessoryType;
  }(IfcElementComponentType);

  IFC42.IfcDiscreteAccessoryType = IfcDiscreteAccessoryType;

  var IfcDistributionChamberElementType = /*#__PURE__*/function (_IfcDistributionFlowE45) {
    _inherits(IfcDistributionChamberElementType, _IfcDistributionFlowE45);

    var _super2259 = _createSuper(IfcDistributionChamberElementType);

    function IfcDistributionChamberElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2251;

      _classCallCheck2(this, IfcDistributionChamberElementType);

      _this2251 = _super2259.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2251.GlobalId = GlobalId;
      _this2251.OwnerHistory = OwnerHistory;
      _this2251.Name = Name;
      _this2251.Description = Description;
      _this2251.ApplicableOccurrence = ApplicableOccurrence;
      _this2251.HasPropertySets = HasPropertySets;
      _this2251.RepresentationMaps = RepresentationMaps;
      _this2251.Tag = Tag;
      _this2251.ElementType = ElementType;
      _this2251.PredefinedType = PredefinedType;
      _this2251.type = 1599208980;
      return _this2251;
    }

    return IfcDistributionChamberElementType;
  }(IfcDistributionFlowElementType);

  IFC42.IfcDistributionChamberElementType = IfcDistributionChamberElementType;

  var IfcDistributionControlElementType = /*#__PURE__*/function (_IfcDistributionEleme10) {
    _inherits(IfcDistributionControlElementType, _IfcDistributionEleme10);

    var _super2260 = _createSuper(IfcDistributionControlElementType);

    function IfcDistributionControlElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType) {
      var _this2252;

      _classCallCheck2(this, IfcDistributionControlElementType);

      _this2252 = _super2260.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2252.GlobalId = GlobalId;
      _this2252.OwnerHistory = OwnerHistory;
      _this2252.Name = Name;
      _this2252.Description = Description;
      _this2252.ApplicableOccurrence = ApplicableOccurrence;
      _this2252.HasPropertySets = HasPropertySets;
      _this2252.RepresentationMaps = RepresentationMaps;
      _this2252.Tag = Tag;
      _this2252.ElementType = ElementType;
      _this2252.type = 2063403501;
      return _this2252;
    }

    return IfcDistributionControlElementType;
  }(IfcDistributionElementType);

  IFC42.IfcDistributionControlElementType = IfcDistributionControlElementType;

  var IfcDistributionElement = /*#__PURE__*/function (_IfcElement31) {
    _inherits(IfcDistributionElement, _IfcElement31);

    var _super2261 = _createSuper(IfcDistributionElement);

    function IfcDistributionElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2253;

      _classCallCheck2(this, IfcDistributionElement);

      _this2253 = _super2261.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2253.GlobalId = GlobalId;
      _this2253.OwnerHistory = OwnerHistory;
      _this2253.Name = Name;
      _this2253.Description = Description;
      _this2253.ObjectType = ObjectType;
      _this2253.ObjectPlacement = ObjectPlacement;
      _this2253.Representation = Representation;
      _this2253.Tag = Tag;
      _this2253.type = 1945004755;
      return _this2253;
    }

    return IfcDistributionElement;
  }(IfcElement);

  IFC42.IfcDistributionElement = IfcDistributionElement;

  var IfcDistributionFlowElement = /*#__PURE__*/function (_IfcDistributionEleme11) {
    _inherits(IfcDistributionFlowElement, _IfcDistributionEleme11);

    var _super2262 = _createSuper(IfcDistributionFlowElement);

    function IfcDistributionFlowElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2254;

      _classCallCheck2(this, IfcDistributionFlowElement);

      _this2254 = _super2262.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2254.GlobalId = GlobalId;
      _this2254.OwnerHistory = OwnerHistory;
      _this2254.Name = Name;
      _this2254.Description = Description;
      _this2254.ObjectType = ObjectType;
      _this2254.ObjectPlacement = ObjectPlacement;
      _this2254.Representation = Representation;
      _this2254.Tag = Tag;
      _this2254.type = 3040386961;
      return _this2254;
    }

    return IfcDistributionFlowElement;
  }(IfcDistributionElement);

  IFC42.IfcDistributionFlowElement = IfcDistributionFlowElement;

  var IfcDistributionPort = /*#__PURE__*/function (_IfcPort3) {
    _inherits(IfcDistributionPort, _IfcPort3);

    var _super2263 = _createSuper(IfcDistributionPort);

    function IfcDistributionPort(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, FlowDirection, PredefinedType, SystemType) {
      var _this2255;

      _classCallCheck2(this, IfcDistributionPort);

      _this2255 = _super2263.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation);
      _this2255.GlobalId = GlobalId;
      _this2255.OwnerHistory = OwnerHistory;
      _this2255.Name = Name;
      _this2255.Description = Description;
      _this2255.ObjectType = ObjectType;
      _this2255.ObjectPlacement = ObjectPlacement;
      _this2255.Representation = Representation;
      _this2255.FlowDirection = FlowDirection;
      _this2255.PredefinedType = PredefinedType;
      _this2255.SystemType = SystemType;
      _this2255.type = 3041715199;
      return _this2255;
    }

    return IfcDistributionPort;
  }(IfcPort);

  IFC42.IfcDistributionPort = IfcDistributionPort;

  var IfcDistributionSystem = /*#__PURE__*/function (_IfcSystem10) {
    _inherits(IfcDistributionSystem, _IfcSystem10);

    var _super2264 = _createSuper(IfcDistributionSystem);

    function IfcDistributionSystem(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      var _this2256;

      _classCallCheck2(this, IfcDistributionSystem);

      _this2256 = _super2264.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2256.GlobalId = GlobalId;
      _this2256.OwnerHistory = OwnerHistory;
      _this2256.Name = Name;
      _this2256.Description = Description;
      _this2256.ObjectType = ObjectType;
      _this2256.LongName = LongName;
      _this2256.PredefinedType = PredefinedType;
      _this2256.type = 3205830791;
      return _this2256;
    }

    return IfcDistributionSystem;
  }(IfcSystem);

  IFC42.IfcDistributionSystem = IfcDistributionSystem;

  var IfcDoor = /*#__PURE__*/function (_IfcBuildingElement26) {
    _inherits(IfcDoor, _IfcBuildingElement26);

    var _super2265 = _createSuper(IfcDoor);

    function IfcDoor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType) {
      var _this2257;

      _classCallCheck2(this, IfcDoor);

      _this2257 = _super2265.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2257.GlobalId = GlobalId;
      _this2257.OwnerHistory = OwnerHistory;
      _this2257.Name = Name;
      _this2257.Description = Description;
      _this2257.ObjectType = ObjectType;
      _this2257.ObjectPlacement = ObjectPlacement;
      _this2257.Representation = Representation;
      _this2257.Tag = Tag;
      _this2257.OverallHeight = OverallHeight;
      _this2257.OverallWidth = OverallWidth;
      _this2257.PredefinedType = PredefinedType;
      _this2257.OperationType = OperationType;
      _this2257.UserDefinedOperationType = UserDefinedOperationType;
      _this2257.type = 395920057;
      return _this2257;
    }

    return IfcDoor;
  }(IfcBuildingElement);

  IFC42.IfcDoor = IfcDoor;

  var IfcDoorStandardCase = /*#__PURE__*/function (_IfcDoor) {
    _inherits(IfcDoorStandardCase, _IfcDoor);

    var _super2266 = _createSuper(IfcDoorStandardCase);

    function IfcDoorStandardCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType) {
      var _this2258;

      _classCallCheck2(this, IfcDoorStandardCase);

      _this2258 = _super2266.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, OperationType, UserDefinedOperationType);
      _this2258.GlobalId = GlobalId;
      _this2258.OwnerHistory = OwnerHistory;
      _this2258.Name = Name;
      _this2258.Description = Description;
      _this2258.ObjectType = ObjectType;
      _this2258.ObjectPlacement = ObjectPlacement;
      _this2258.Representation = Representation;
      _this2258.Tag = Tag;
      _this2258.OverallHeight = OverallHeight;
      _this2258.OverallWidth = OverallWidth;
      _this2258.PredefinedType = PredefinedType;
      _this2258.OperationType = OperationType;
      _this2258.UserDefinedOperationType = UserDefinedOperationType;
      _this2258.type = 3242481149;
      return _this2258;
    }

    return IfcDoorStandardCase;
  }(IfcDoor);

  IFC42.IfcDoorStandardCase = IfcDoorStandardCase;

  var IfcDuctFittingType = /*#__PURE__*/function (_IfcFlowFittingType14) {
    _inherits(IfcDuctFittingType, _IfcFlowFittingType14);

    var _super2267 = _createSuper(IfcDuctFittingType);

    function IfcDuctFittingType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2259;

      _classCallCheck2(this, IfcDuctFittingType);

      _this2259 = _super2267.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2259.GlobalId = GlobalId;
      _this2259.OwnerHistory = OwnerHistory;
      _this2259.Name = Name;
      _this2259.Description = Description;
      _this2259.ApplicableOccurrence = ApplicableOccurrence;
      _this2259.HasPropertySets = HasPropertySets;
      _this2259.RepresentationMaps = RepresentationMaps;
      _this2259.Tag = Tag;
      _this2259.ElementType = ElementType;
      _this2259.PredefinedType = PredefinedType;
      _this2259.type = 869906466;
      return _this2259;
    }

    return IfcDuctFittingType;
  }(IfcFlowFittingType);

  IFC42.IfcDuctFittingType = IfcDuctFittingType;

  var IfcDuctSegmentType = /*#__PURE__*/function (_IfcFlowSegmentType13) {
    _inherits(IfcDuctSegmentType, _IfcFlowSegmentType13);

    var _super2268 = _createSuper(IfcDuctSegmentType);

    function IfcDuctSegmentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2260;

      _classCallCheck2(this, IfcDuctSegmentType);

      _this2260 = _super2268.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2260.GlobalId = GlobalId;
      _this2260.OwnerHistory = OwnerHistory;
      _this2260.Name = Name;
      _this2260.Description = Description;
      _this2260.ApplicableOccurrence = ApplicableOccurrence;
      _this2260.HasPropertySets = HasPropertySets;
      _this2260.RepresentationMaps = RepresentationMaps;
      _this2260.Tag = Tag;
      _this2260.ElementType = ElementType;
      _this2260.PredefinedType = PredefinedType;
      _this2260.type = 3760055223;
      return _this2260;
    }

    return IfcDuctSegmentType;
  }(IfcFlowSegmentType);

  IFC42.IfcDuctSegmentType = IfcDuctSegmentType;

  var IfcDuctSilencerType = /*#__PURE__*/function (_IfcFlowTreatmentDevi12) {
    _inherits(IfcDuctSilencerType, _IfcFlowTreatmentDevi12);

    var _super2269 = _createSuper(IfcDuctSilencerType);

    function IfcDuctSilencerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2261;

      _classCallCheck2(this, IfcDuctSilencerType);

      _this2261 = _super2269.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2261.GlobalId = GlobalId;
      _this2261.OwnerHistory = OwnerHistory;
      _this2261.Name = Name;
      _this2261.Description = Description;
      _this2261.ApplicableOccurrence = ApplicableOccurrence;
      _this2261.HasPropertySets = HasPropertySets;
      _this2261.RepresentationMaps = RepresentationMaps;
      _this2261.Tag = Tag;
      _this2261.ElementType = ElementType;
      _this2261.PredefinedType = PredefinedType;
      _this2261.type = 2030761528;
      return _this2261;
    }

    return IfcDuctSilencerType;
  }(IfcFlowTreatmentDeviceType);

  IFC42.IfcDuctSilencerType = IfcDuctSilencerType;

  var IfcElectricApplianceType = /*#__PURE__*/function (_IfcFlowTerminalType39) {
    _inherits(IfcElectricApplianceType, _IfcFlowTerminalType39);

    var _super2270 = _createSuper(IfcElectricApplianceType);

    function IfcElectricApplianceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2262;

      _classCallCheck2(this, IfcElectricApplianceType);

      _this2262 = _super2270.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2262.GlobalId = GlobalId;
      _this2262.OwnerHistory = OwnerHistory;
      _this2262.Name = Name;
      _this2262.Description = Description;
      _this2262.ApplicableOccurrence = ApplicableOccurrence;
      _this2262.HasPropertySets = HasPropertySets;
      _this2262.RepresentationMaps = RepresentationMaps;
      _this2262.Tag = Tag;
      _this2262.ElementType = ElementType;
      _this2262.PredefinedType = PredefinedType;
      _this2262.type = 663422040;
      return _this2262;
    }

    return IfcElectricApplianceType;
  }(IfcFlowTerminalType);

  IFC42.IfcElectricApplianceType = IfcElectricApplianceType;

  var IfcElectricDistributionBoardType = /*#__PURE__*/function (_IfcFlowControllerTyp23) {
    _inherits(IfcElectricDistributionBoardType, _IfcFlowControllerTyp23);

    var _super2271 = _createSuper(IfcElectricDistributionBoardType);

    function IfcElectricDistributionBoardType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2263;

      _classCallCheck2(this, IfcElectricDistributionBoardType);

      _this2263 = _super2271.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2263.GlobalId = GlobalId;
      _this2263.OwnerHistory = OwnerHistory;
      _this2263.Name = Name;
      _this2263.Description = Description;
      _this2263.ApplicableOccurrence = ApplicableOccurrence;
      _this2263.HasPropertySets = HasPropertySets;
      _this2263.RepresentationMaps = RepresentationMaps;
      _this2263.Tag = Tag;
      _this2263.ElementType = ElementType;
      _this2263.PredefinedType = PredefinedType;
      _this2263.type = 2417008758;
      return _this2263;
    }

    return IfcElectricDistributionBoardType;
  }(IfcFlowControllerType);

  IFC42.IfcElectricDistributionBoardType = IfcElectricDistributionBoardType;

  var IfcElectricFlowStorageDeviceType = /*#__PURE__*/function (_IfcFlowStorageDevice8) {
    _inherits(IfcElectricFlowStorageDeviceType, _IfcFlowStorageDevice8);

    var _super2272 = _createSuper(IfcElectricFlowStorageDeviceType);

    function IfcElectricFlowStorageDeviceType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2264;

      _classCallCheck2(this, IfcElectricFlowStorageDeviceType);

      _this2264 = _super2272.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2264.GlobalId = GlobalId;
      _this2264.OwnerHistory = OwnerHistory;
      _this2264.Name = Name;
      _this2264.Description = Description;
      _this2264.ApplicableOccurrence = ApplicableOccurrence;
      _this2264.HasPropertySets = HasPropertySets;
      _this2264.RepresentationMaps = RepresentationMaps;
      _this2264.Tag = Tag;
      _this2264.ElementType = ElementType;
      _this2264.PredefinedType = PredefinedType;
      _this2264.type = 3277789161;
      return _this2264;
    }

    return IfcElectricFlowStorageDeviceType;
  }(IfcFlowStorageDeviceType);

  IFC42.IfcElectricFlowStorageDeviceType = IfcElectricFlowStorageDeviceType;

  var IfcElectricGeneratorType = /*#__PURE__*/function (_IfcEnergyConversionD77) {
    _inherits(IfcElectricGeneratorType, _IfcEnergyConversionD77);

    var _super2273 = _createSuper(IfcElectricGeneratorType);

    function IfcElectricGeneratorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2265;

      _classCallCheck2(this, IfcElectricGeneratorType);

      _this2265 = _super2273.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2265.GlobalId = GlobalId;
      _this2265.OwnerHistory = OwnerHistory;
      _this2265.Name = Name;
      _this2265.Description = Description;
      _this2265.ApplicableOccurrence = ApplicableOccurrence;
      _this2265.HasPropertySets = HasPropertySets;
      _this2265.RepresentationMaps = RepresentationMaps;
      _this2265.Tag = Tag;
      _this2265.ElementType = ElementType;
      _this2265.PredefinedType = PredefinedType;
      _this2265.type = 1534661035;
      return _this2265;
    }

    return IfcElectricGeneratorType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcElectricGeneratorType = IfcElectricGeneratorType;

  var IfcElectricMotorType = /*#__PURE__*/function (_IfcEnergyConversionD78) {
    _inherits(IfcElectricMotorType, _IfcEnergyConversionD78);

    var _super2274 = _createSuper(IfcElectricMotorType);

    function IfcElectricMotorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2266;

      _classCallCheck2(this, IfcElectricMotorType);

      _this2266 = _super2274.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2266.GlobalId = GlobalId;
      _this2266.OwnerHistory = OwnerHistory;
      _this2266.Name = Name;
      _this2266.Description = Description;
      _this2266.ApplicableOccurrence = ApplicableOccurrence;
      _this2266.HasPropertySets = HasPropertySets;
      _this2266.RepresentationMaps = RepresentationMaps;
      _this2266.Tag = Tag;
      _this2266.ElementType = ElementType;
      _this2266.PredefinedType = PredefinedType;
      _this2266.type = 1217240411;
      return _this2266;
    }

    return IfcElectricMotorType;
  }(IfcEnergyConversionDeviceType);

  IFC42.IfcElectricMotorType = IfcElectricMotorType;

  var IfcElectricTimeControlType = /*#__PURE__*/function (_IfcFlowControllerTyp24) {
    _inherits(IfcElectricTimeControlType, _IfcFlowControllerTyp24);

    var _super2275 = _createSuper(IfcElectricTimeControlType);

    function IfcElectricTimeControlType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2267;

      _classCallCheck2(this, IfcElectricTimeControlType);

      _this2267 = _super2275.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2267.GlobalId = GlobalId;
      _this2267.OwnerHistory = OwnerHistory;
      _this2267.Name = Name;
      _this2267.Description = Description;
      _this2267.ApplicableOccurrence = ApplicableOccurrence;
      _this2267.HasPropertySets = HasPropertySets;
      _this2267.RepresentationMaps = RepresentationMaps;
      _this2267.Tag = Tag;
      _this2267.ElementType = ElementType;
      _this2267.PredefinedType = PredefinedType;
      _this2267.type = 712377611;
      return _this2267;
    }

    return IfcElectricTimeControlType;
  }(IfcFlowControllerType);

  IFC42.IfcElectricTimeControlType = IfcElectricTimeControlType;

  var IfcEnergyConversionDevice = /*#__PURE__*/function (_IfcDistributionFlowE46) {
    _inherits(IfcEnergyConversionDevice, _IfcDistributionFlowE46);

    var _super2276 = _createSuper(IfcEnergyConversionDevice);

    function IfcEnergyConversionDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2268;

      _classCallCheck2(this, IfcEnergyConversionDevice);

      _this2268 = _super2276.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2268.GlobalId = GlobalId;
      _this2268.OwnerHistory = OwnerHistory;
      _this2268.Name = Name;
      _this2268.Description = Description;
      _this2268.ObjectType = ObjectType;
      _this2268.ObjectPlacement = ObjectPlacement;
      _this2268.Representation = Representation;
      _this2268.Tag = Tag;
      _this2268.type = 1658829314;
      return _this2268;
    }

    return IfcEnergyConversionDevice;
  }(IfcDistributionFlowElement);

  IFC42.IfcEnergyConversionDevice = IfcEnergyConversionDevice;

  var IfcEngine = /*#__PURE__*/function (_IfcEnergyConversionD79) {
    _inherits(IfcEngine, _IfcEnergyConversionD79);

    var _super2277 = _createSuper(IfcEngine);

    function IfcEngine(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2269;

      _classCallCheck2(this, IfcEngine);

      _this2269 = _super2277.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2269.GlobalId = GlobalId;
      _this2269.OwnerHistory = OwnerHistory;
      _this2269.Name = Name;
      _this2269.Description = Description;
      _this2269.ObjectType = ObjectType;
      _this2269.ObjectPlacement = ObjectPlacement;
      _this2269.Representation = Representation;
      _this2269.Tag = Tag;
      _this2269.PredefinedType = PredefinedType;
      _this2269.type = 2814081492;
      return _this2269;
    }

    return IfcEngine;
  }(IfcEnergyConversionDevice);

  IFC42.IfcEngine = IfcEngine;

  var IfcEvaporativeCooler = /*#__PURE__*/function (_IfcEnergyConversionD80) {
    _inherits(IfcEvaporativeCooler, _IfcEnergyConversionD80);

    var _super2278 = _createSuper(IfcEvaporativeCooler);

    function IfcEvaporativeCooler(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2270;

      _classCallCheck2(this, IfcEvaporativeCooler);

      _this2270 = _super2278.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2270.GlobalId = GlobalId;
      _this2270.OwnerHistory = OwnerHistory;
      _this2270.Name = Name;
      _this2270.Description = Description;
      _this2270.ObjectType = ObjectType;
      _this2270.ObjectPlacement = ObjectPlacement;
      _this2270.Representation = Representation;
      _this2270.Tag = Tag;
      _this2270.PredefinedType = PredefinedType;
      _this2270.type = 3747195512;
      return _this2270;
    }

    return IfcEvaporativeCooler;
  }(IfcEnergyConversionDevice);

  IFC42.IfcEvaporativeCooler = IfcEvaporativeCooler;

  var IfcEvaporator = /*#__PURE__*/function (_IfcEnergyConversionD81) {
    _inherits(IfcEvaporator, _IfcEnergyConversionD81);

    var _super2279 = _createSuper(IfcEvaporator);

    function IfcEvaporator(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2271;

      _classCallCheck2(this, IfcEvaporator);

      _this2271 = _super2279.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2271.GlobalId = GlobalId;
      _this2271.OwnerHistory = OwnerHistory;
      _this2271.Name = Name;
      _this2271.Description = Description;
      _this2271.ObjectType = ObjectType;
      _this2271.ObjectPlacement = ObjectPlacement;
      _this2271.Representation = Representation;
      _this2271.Tag = Tag;
      _this2271.PredefinedType = PredefinedType;
      _this2271.type = 484807127;
      return _this2271;
    }

    return IfcEvaporator;
  }(IfcEnergyConversionDevice);

  IFC42.IfcEvaporator = IfcEvaporator;

  var IfcExternalSpatialElement = /*#__PURE__*/function (_IfcExternalSpatialSt2) {
    _inherits(IfcExternalSpatialElement, _IfcExternalSpatialSt2);

    var _super2280 = _createSuper(IfcExternalSpatialElement);

    function IfcExternalSpatialElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName, PredefinedType) {
      var _this2272;

      _classCallCheck2(this, IfcExternalSpatialElement);

      _this2272 = _super2280.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, LongName);
      _this2272.GlobalId = GlobalId;
      _this2272.OwnerHistory = OwnerHistory;
      _this2272.Name = Name;
      _this2272.Description = Description;
      _this2272.ObjectType = ObjectType;
      _this2272.ObjectPlacement = ObjectPlacement;
      _this2272.Representation = Representation;
      _this2272.LongName = LongName;
      _this2272.PredefinedType = PredefinedType;
      _this2272.type = 1209101575;
      return _this2272;
    }

    return IfcExternalSpatialElement;
  }(IfcExternalSpatialStructureElement);

  IFC42.IfcExternalSpatialElement = IfcExternalSpatialElement;

  var IfcFanType = /*#__PURE__*/function (_IfcFlowMovingDeviceT9) {
    _inherits(IfcFanType, _IfcFlowMovingDeviceT9);

    var _super2281 = _createSuper(IfcFanType);

    function IfcFanType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2273;

      _classCallCheck2(this, IfcFanType);

      _this2273 = _super2281.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2273.GlobalId = GlobalId;
      _this2273.OwnerHistory = OwnerHistory;
      _this2273.Name = Name;
      _this2273.Description = Description;
      _this2273.ApplicableOccurrence = ApplicableOccurrence;
      _this2273.HasPropertySets = HasPropertySets;
      _this2273.RepresentationMaps = RepresentationMaps;
      _this2273.Tag = Tag;
      _this2273.ElementType = ElementType;
      _this2273.PredefinedType = PredefinedType;
      _this2273.type = 346874300;
      return _this2273;
    }

    return IfcFanType;
  }(IfcFlowMovingDeviceType);

  IFC42.IfcFanType = IfcFanType;

  var IfcFilterType = /*#__PURE__*/function (_IfcFlowTreatmentDevi13) {
    _inherits(IfcFilterType, _IfcFlowTreatmentDevi13);

    var _super2282 = _createSuper(IfcFilterType);

    function IfcFilterType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2274;

      _classCallCheck2(this, IfcFilterType);

      _this2274 = _super2282.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2274.GlobalId = GlobalId;
      _this2274.OwnerHistory = OwnerHistory;
      _this2274.Name = Name;
      _this2274.Description = Description;
      _this2274.ApplicableOccurrence = ApplicableOccurrence;
      _this2274.HasPropertySets = HasPropertySets;
      _this2274.RepresentationMaps = RepresentationMaps;
      _this2274.Tag = Tag;
      _this2274.ElementType = ElementType;
      _this2274.PredefinedType = PredefinedType;
      _this2274.type = 1810631287;
      return _this2274;
    }

    return IfcFilterType;
  }(IfcFlowTreatmentDeviceType);

  IFC42.IfcFilterType = IfcFilterType;

  var IfcFireSuppressionTerminalType = /*#__PURE__*/function (_IfcFlowTerminalType40) {
    _inherits(IfcFireSuppressionTerminalType, _IfcFlowTerminalType40);

    var _super2283 = _createSuper(IfcFireSuppressionTerminalType);

    function IfcFireSuppressionTerminalType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2275;

      _classCallCheck2(this, IfcFireSuppressionTerminalType);

      _this2275 = _super2283.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2275.GlobalId = GlobalId;
      _this2275.OwnerHistory = OwnerHistory;
      _this2275.Name = Name;
      _this2275.Description = Description;
      _this2275.ApplicableOccurrence = ApplicableOccurrence;
      _this2275.HasPropertySets = HasPropertySets;
      _this2275.RepresentationMaps = RepresentationMaps;
      _this2275.Tag = Tag;
      _this2275.ElementType = ElementType;
      _this2275.PredefinedType = PredefinedType;
      _this2275.type = 4222183408;
      return _this2275;
    }

    return IfcFireSuppressionTerminalType;
  }(IfcFlowTerminalType);

  IFC42.IfcFireSuppressionTerminalType = IfcFireSuppressionTerminalType;

  var IfcFlowController = /*#__PURE__*/function (_IfcDistributionFlowE47) {
    _inherits(IfcFlowController, _IfcDistributionFlowE47);

    var _super2284 = _createSuper(IfcFlowController);

    function IfcFlowController(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2276;

      _classCallCheck2(this, IfcFlowController);

      _this2276 = _super2284.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2276.GlobalId = GlobalId;
      _this2276.OwnerHistory = OwnerHistory;
      _this2276.Name = Name;
      _this2276.Description = Description;
      _this2276.ObjectType = ObjectType;
      _this2276.ObjectPlacement = ObjectPlacement;
      _this2276.Representation = Representation;
      _this2276.Tag = Tag;
      _this2276.type = 2058353004;
      return _this2276;
    }

    return IfcFlowController;
  }(IfcDistributionFlowElement);

  IFC42.IfcFlowController = IfcFlowController;

  var IfcFlowFitting = /*#__PURE__*/function (_IfcDistributionFlowE48) {
    _inherits(IfcFlowFitting, _IfcDistributionFlowE48);

    var _super2285 = _createSuper(IfcFlowFitting);

    function IfcFlowFitting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2277;

      _classCallCheck2(this, IfcFlowFitting);

      _this2277 = _super2285.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2277.GlobalId = GlobalId;
      _this2277.OwnerHistory = OwnerHistory;
      _this2277.Name = Name;
      _this2277.Description = Description;
      _this2277.ObjectType = ObjectType;
      _this2277.ObjectPlacement = ObjectPlacement;
      _this2277.Representation = Representation;
      _this2277.Tag = Tag;
      _this2277.type = 4278956645;
      return _this2277;
    }

    return IfcFlowFitting;
  }(IfcDistributionFlowElement);

  IFC42.IfcFlowFitting = IfcFlowFitting;

  var IfcFlowInstrumentType = /*#__PURE__*/function (_IfcDistributionContr20) {
    _inherits(IfcFlowInstrumentType, _IfcDistributionContr20);

    var _super2286 = _createSuper(IfcFlowInstrumentType);

    function IfcFlowInstrumentType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2278;

      _classCallCheck2(this, IfcFlowInstrumentType);

      _this2278 = _super2286.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2278.GlobalId = GlobalId;
      _this2278.OwnerHistory = OwnerHistory;
      _this2278.Name = Name;
      _this2278.Description = Description;
      _this2278.ApplicableOccurrence = ApplicableOccurrence;
      _this2278.HasPropertySets = HasPropertySets;
      _this2278.RepresentationMaps = RepresentationMaps;
      _this2278.Tag = Tag;
      _this2278.ElementType = ElementType;
      _this2278.PredefinedType = PredefinedType;
      _this2278.type = 4037862832;
      return _this2278;
    }

    return IfcFlowInstrumentType;
  }(IfcDistributionControlElementType);

  IFC42.IfcFlowInstrumentType = IfcFlowInstrumentType;

  var IfcFlowMeter = /*#__PURE__*/function (_IfcFlowController11) {
    _inherits(IfcFlowMeter, _IfcFlowController11);

    var _super2287 = _createSuper(IfcFlowMeter);

    function IfcFlowMeter(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2279;

      _classCallCheck2(this, IfcFlowMeter);

      _this2279 = _super2287.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2279.GlobalId = GlobalId;
      _this2279.OwnerHistory = OwnerHistory;
      _this2279.Name = Name;
      _this2279.Description = Description;
      _this2279.ObjectType = ObjectType;
      _this2279.ObjectPlacement = ObjectPlacement;
      _this2279.Representation = Representation;
      _this2279.Tag = Tag;
      _this2279.PredefinedType = PredefinedType;
      _this2279.type = 2188021234;
      return _this2279;
    }

    return IfcFlowMeter;
  }(IfcFlowController);

  IFC42.IfcFlowMeter = IfcFlowMeter;

  var IfcFlowMovingDevice = /*#__PURE__*/function (_IfcDistributionFlowE49) {
    _inherits(IfcFlowMovingDevice, _IfcDistributionFlowE49);

    var _super2288 = _createSuper(IfcFlowMovingDevice);

    function IfcFlowMovingDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2280;

      _classCallCheck2(this, IfcFlowMovingDevice);

      _this2280 = _super2288.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2280.GlobalId = GlobalId;
      _this2280.OwnerHistory = OwnerHistory;
      _this2280.Name = Name;
      _this2280.Description = Description;
      _this2280.ObjectType = ObjectType;
      _this2280.ObjectPlacement = ObjectPlacement;
      _this2280.Representation = Representation;
      _this2280.Tag = Tag;
      _this2280.type = 3132237377;
      return _this2280;
    }

    return IfcFlowMovingDevice;
  }(IfcDistributionFlowElement);

  IFC42.IfcFlowMovingDevice = IfcFlowMovingDevice;

  var IfcFlowSegment = /*#__PURE__*/function (_IfcDistributionFlowE50) {
    _inherits(IfcFlowSegment, _IfcDistributionFlowE50);

    var _super2289 = _createSuper(IfcFlowSegment);

    function IfcFlowSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2281;

      _classCallCheck2(this, IfcFlowSegment);

      _this2281 = _super2289.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2281.GlobalId = GlobalId;
      _this2281.OwnerHistory = OwnerHistory;
      _this2281.Name = Name;
      _this2281.Description = Description;
      _this2281.ObjectType = ObjectType;
      _this2281.ObjectPlacement = ObjectPlacement;
      _this2281.Representation = Representation;
      _this2281.Tag = Tag;
      _this2281.type = 987401354;
      return _this2281;
    }

    return IfcFlowSegment;
  }(IfcDistributionFlowElement);

  IFC42.IfcFlowSegment = IfcFlowSegment;

  var IfcFlowStorageDevice = /*#__PURE__*/function (_IfcDistributionFlowE51) {
    _inherits(IfcFlowStorageDevice, _IfcDistributionFlowE51);

    var _super2290 = _createSuper(IfcFlowStorageDevice);

    function IfcFlowStorageDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2282;

      _classCallCheck2(this, IfcFlowStorageDevice);

      _this2282 = _super2290.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2282.GlobalId = GlobalId;
      _this2282.OwnerHistory = OwnerHistory;
      _this2282.Name = Name;
      _this2282.Description = Description;
      _this2282.ObjectType = ObjectType;
      _this2282.ObjectPlacement = ObjectPlacement;
      _this2282.Representation = Representation;
      _this2282.Tag = Tag;
      _this2282.type = 707683696;
      return _this2282;
    }

    return IfcFlowStorageDevice;
  }(IfcDistributionFlowElement);

  IFC42.IfcFlowStorageDevice = IfcFlowStorageDevice;

  var IfcFlowTerminal = /*#__PURE__*/function (_IfcDistributionFlowE52) {
    _inherits(IfcFlowTerminal, _IfcDistributionFlowE52);

    var _super2291 = _createSuper(IfcFlowTerminal);

    function IfcFlowTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2283;

      _classCallCheck2(this, IfcFlowTerminal);

      _this2283 = _super2291.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2283.GlobalId = GlobalId;
      _this2283.OwnerHistory = OwnerHistory;
      _this2283.Name = Name;
      _this2283.Description = Description;
      _this2283.ObjectType = ObjectType;
      _this2283.ObjectPlacement = ObjectPlacement;
      _this2283.Representation = Representation;
      _this2283.Tag = Tag;
      _this2283.type = 2223149337;
      return _this2283;
    }

    return IfcFlowTerminal;
  }(IfcDistributionFlowElement);

  IFC42.IfcFlowTerminal = IfcFlowTerminal;

  var IfcFlowTreatmentDevice = /*#__PURE__*/function (_IfcDistributionFlowE53) {
    _inherits(IfcFlowTreatmentDevice, _IfcDistributionFlowE53);

    var _super2292 = _createSuper(IfcFlowTreatmentDevice);

    function IfcFlowTreatmentDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2284;

      _classCallCheck2(this, IfcFlowTreatmentDevice);

      _this2284 = _super2292.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2284.GlobalId = GlobalId;
      _this2284.OwnerHistory = OwnerHistory;
      _this2284.Name = Name;
      _this2284.Description = Description;
      _this2284.ObjectType = ObjectType;
      _this2284.ObjectPlacement = ObjectPlacement;
      _this2284.Representation = Representation;
      _this2284.Tag = Tag;
      _this2284.type = 3508470533;
      return _this2284;
    }

    return IfcFlowTreatmentDevice;
  }(IfcDistributionFlowElement);

  IFC42.IfcFlowTreatmentDevice = IfcFlowTreatmentDevice;

  var IfcFooting = /*#__PURE__*/function (_IfcBuildingElement27) {
    _inherits(IfcFooting, _IfcBuildingElement27);

    var _super2293 = _createSuper(IfcFooting);

    function IfcFooting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2285;

      _classCallCheck2(this, IfcFooting);

      _this2285 = _super2293.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2285.GlobalId = GlobalId;
      _this2285.OwnerHistory = OwnerHistory;
      _this2285.Name = Name;
      _this2285.Description = Description;
      _this2285.ObjectType = ObjectType;
      _this2285.ObjectPlacement = ObjectPlacement;
      _this2285.Representation = Representation;
      _this2285.Tag = Tag;
      _this2285.PredefinedType = PredefinedType;
      _this2285.type = 900683007;
      return _this2285;
    }

    return IfcFooting;
  }(IfcBuildingElement);

  IFC42.IfcFooting = IfcFooting;

  var IfcHeatExchanger = /*#__PURE__*/function (_IfcEnergyConversionD82) {
    _inherits(IfcHeatExchanger, _IfcEnergyConversionD82);

    var _super2294 = _createSuper(IfcHeatExchanger);

    function IfcHeatExchanger(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2286;

      _classCallCheck2(this, IfcHeatExchanger);

      _this2286 = _super2294.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2286.GlobalId = GlobalId;
      _this2286.OwnerHistory = OwnerHistory;
      _this2286.Name = Name;
      _this2286.Description = Description;
      _this2286.ObjectType = ObjectType;
      _this2286.ObjectPlacement = ObjectPlacement;
      _this2286.Representation = Representation;
      _this2286.Tag = Tag;
      _this2286.PredefinedType = PredefinedType;
      _this2286.type = 3319311131;
      return _this2286;
    }

    return IfcHeatExchanger;
  }(IfcEnergyConversionDevice);

  IFC42.IfcHeatExchanger = IfcHeatExchanger;

  var IfcHumidifier = /*#__PURE__*/function (_IfcEnergyConversionD83) {
    _inherits(IfcHumidifier, _IfcEnergyConversionD83);

    var _super2295 = _createSuper(IfcHumidifier);

    function IfcHumidifier(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2287;

      _classCallCheck2(this, IfcHumidifier);

      _this2287 = _super2295.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2287.GlobalId = GlobalId;
      _this2287.OwnerHistory = OwnerHistory;
      _this2287.Name = Name;
      _this2287.Description = Description;
      _this2287.ObjectType = ObjectType;
      _this2287.ObjectPlacement = ObjectPlacement;
      _this2287.Representation = Representation;
      _this2287.Tag = Tag;
      _this2287.PredefinedType = PredefinedType;
      _this2287.type = 2068733104;
      return _this2287;
    }

    return IfcHumidifier;
  }(IfcEnergyConversionDevice);

  IFC42.IfcHumidifier = IfcHumidifier;

  var IfcInterceptor = /*#__PURE__*/function (_IfcFlowTreatmentDevi14) {
    _inherits(IfcInterceptor, _IfcFlowTreatmentDevi14);

    var _super2296 = _createSuper(IfcInterceptor);

    function IfcInterceptor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2288;

      _classCallCheck2(this, IfcInterceptor);

      _this2288 = _super2296.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2288.GlobalId = GlobalId;
      _this2288.OwnerHistory = OwnerHistory;
      _this2288.Name = Name;
      _this2288.Description = Description;
      _this2288.ObjectType = ObjectType;
      _this2288.ObjectPlacement = ObjectPlacement;
      _this2288.Representation = Representation;
      _this2288.Tag = Tag;
      _this2288.PredefinedType = PredefinedType;
      _this2288.type = 4175244083;
      return _this2288;
    }

    return IfcInterceptor;
  }(IfcFlowTreatmentDevice);

  IFC42.IfcInterceptor = IfcInterceptor;

  var IfcJunctionBox = /*#__PURE__*/function (_IfcFlowFitting6) {
    _inherits(IfcJunctionBox, _IfcFlowFitting6);

    var _super2297 = _createSuper(IfcJunctionBox);

    function IfcJunctionBox(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2289;

      _classCallCheck2(this, IfcJunctionBox);

      _this2289 = _super2297.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2289.GlobalId = GlobalId;
      _this2289.OwnerHistory = OwnerHistory;
      _this2289.Name = Name;
      _this2289.Description = Description;
      _this2289.ObjectType = ObjectType;
      _this2289.ObjectPlacement = ObjectPlacement;
      _this2289.Representation = Representation;
      _this2289.Tag = Tag;
      _this2289.PredefinedType = PredefinedType;
      _this2289.type = 2176052936;
      return _this2289;
    }

    return IfcJunctionBox;
  }(IfcFlowFitting);

  IFC42.IfcJunctionBox = IfcJunctionBox;

  var IfcLamp = /*#__PURE__*/function (_IfcFlowTerminal17) {
    _inherits(IfcLamp, _IfcFlowTerminal17);

    var _super2298 = _createSuper(IfcLamp);

    function IfcLamp(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2290;

      _classCallCheck2(this, IfcLamp);

      _this2290 = _super2298.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2290.GlobalId = GlobalId;
      _this2290.OwnerHistory = OwnerHistory;
      _this2290.Name = Name;
      _this2290.Description = Description;
      _this2290.ObjectType = ObjectType;
      _this2290.ObjectPlacement = ObjectPlacement;
      _this2290.Representation = Representation;
      _this2290.Tag = Tag;
      _this2290.PredefinedType = PredefinedType;
      _this2290.type = 76236018;
      return _this2290;
    }

    return IfcLamp;
  }(IfcFlowTerminal);

  IFC42.IfcLamp = IfcLamp;

  var IfcLightFixture = /*#__PURE__*/function (_IfcFlowTerminal18) {
    _inherits(IfcLightFixture, _IfcFlowTerminal18);

    var _super2299 = _createSuper(IfcLightFixture);

    function IfcLightFixture(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2291;

      _classCallCheck2(this, IfcLightFixture);

      _this2291 = _super2299.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2291.GlobalId = GlobalId;
      _this2291.OwnerHistory = OwnerHistory;
      _this2291.Name = Name;
      _this2291.Description = Description;
      _this2291.ObjectType = ObjectType;
      _this2291.ObjectPlacement = ObjectPlacement;
      _this2291.Representation = Representation;
      _this2291.Tag = Tag;
      _this2291.PredefinedType = PredefinedType;
      _this2291.type = 629592764;
      return _this2291;
    }

    return IfcLightFixture;
  }(IfcFlowTerminal);

  IFC42.IfcLightFixture = IfcLightFixture;

  var IfcMedicalDevice = /*#__PURE__*/function (_IfcFlowTerminal19) {
    _inherits(IfcMedicalDevice, _IfcFlowTerminal19);

    var _super2300 = _createSuper(IfcMedicalDevice);

    function IfcMedicalDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2292;

      _classCallCheck2(this, IfcMedicalDevice);

      _this2292 = _super2300.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2292.GlobalId = GlobalId;
      _this2292.OwnerHistory = OwnerHistory;
      _this2292.Name = Name;
      _this2292.Description = Description;
      _this2292.ObjectType = ObjectType;
      _this2292.ObjectPlacement = ObjectPlacement;
      _this2292.Representation = Representation;
      _this2292.Tag = Tag;
      _this2292.PredefinedType = PredefinedType;
      _this2292.type = 1437502449;
      return _this2292;
    }

    return IfcMedicalDevice;
  }(IfcFlowTerminal);

  IFC42.IfcMedicalDevice = IfcMedicalDevice;

  var IfcMember = /*#__PURE__*/function (_IfcBuildingElement28) {
    _inherits(IfcMember, _IfcBuildingElement28);

    var _super2301 = _createSuper(IfcMember);

    function IfcMember(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2293;

      _classCallCheck2(this, IfcMember);

      _this2293 = _super2301.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2293.GlobalId = GlobalId;
      _this2293.OwnerHistory = OwnerHistory;
      _this2293.Name = Name;
      _this2293.Description = Description;
      _this2293.ObjectType = ObjectType;
      _this2293.ObjectPlacement = ObjectPlacement;
      _this2293.Representation = Representation;
      _this2293.Tag = Tag;
      _this2293.PredefinedType = PredefinedType;
      _this2293.type = 1073191201;
      return _this2293;
    }

    return IfcMember;
  }(IfcBuildingElement);

  IFC42.IfcMember = IfcMember;

  var IfcMemberStandardCase = /*#__PURE__*/function (_IfcMember) {
    _inherits(IfcMemberStandardCase, _IfcMember);

    var _super2302 = _createSuper(IfcMemberStandardCase);

    function IfcMemberStandardCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2294;

      _classCallCheck2(this, IfcMemberStandardCase);

      _this2294 = _super2302.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      _this2294.GlobalId = GlobalId;
      _this2294.OwnerHistory = OwnerHistory;
      _this2294.Name = Name;
      _this2294.Description = Description;
      _this2294.ObjectType = ObjectType;
      _this2294.ObjectPlacement = ObjectPlacement;
      _this2294.Representation = Representation;
      _this2294.Tag = Tag;
      _this2294.PredefinedType = PredefinedType;
      _this2294.type = 1911478936;
      return _this2294;
    }

    return IfcMemberStandardCase;
  }(IfcMember);

  IFC42.IfcMemberStandardCase = IfcMemberStandardCase;

  var IfcMotorConnection = /*#__PURE__*/function (_IfcEnergyConversionD84) {
    _inherits(IfcMotorConnection, _IfcEnergyConversionD84);

    var _super2303 = _createSuper(IfcMotorConnection);

    function IfcMotorConnection(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2295;

      _classCallCheck2(this, IfcMotorConnection);

      _this2295 = _super2303.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2295.GlobalId = GlobalId;
      _this2295.OwnerHistory = OwnerHistory;
      _this2295.Name = Name;
      _this2295.Description = Description;
      _this2295.ObjectType = ObjectType;
      _this2295.ObjectPlacement = ObjectPlacement;
      _this2295.Representation = Representation;
      _this2295.Tag = Tag;
      _this2295.PredefinedType = PredefinedType;
      _this2295.type = 2474470126;
      return _this2295;
    }

    return IfcMotorConnection;
  }(IfcEnergyConversionDevice);

  IFC42.IfcMotorConnection = IfcMotorConnection;

  var IfcOuterBoundaryCurve = /*#__PURE__*/function (_IfcBoundaryCurve2) {
    _inherits(IfcOuterBoundaryCurve, _IfcBoundaryCurve2);

    var _super2304 = _createSuper(IfcOuterBoundaryCurve);

    function IfcOuterBoundaryCurve(expressID, Segments, SelfIntersect) {
      var _this2296;

      _classCallCheck2(this, IfcOuterBoundaryCurve);

      _this2296 = _super2304.call(this, expressID, Segments, SelfIntersect);
      _this2296.Segments = Segments;
      _this2296.SelfIntersect = SelfIntersect;
      _this2296.type = 144952367;
      return _this2296;
    }

    return IfcOuterBoundaryCurve;
  }(IfcBoundaryCurve);

  IFC42.IfcOuterBoundaryCurve = IfcOuterBoundaryCurve;

  var IfcOutlet = /*#__PURE__*/function (_IfcFlowTerminal20) {
    _inherits(IfcOutlet, _IfcFlowTerminal20);

    var _super2305 = _createSuper(IfcOutlet);

    function IfcOutlet(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2297;

      _classCallCheck2(this, IfcOutlet);

      _this2297 = _super2305.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2297.GlobalId = GlobalId;
      _this2297.OwnerHistory = OwnerHistory;
      _this2297.Name = Name;
      _this2297.Description = Description;
      _this2297.ObjectType = ObjectType;
      _this2297.ObjectPlacement = ObjectPlacement;
      _this2297.Representation = Representation;
      _this2297.Tag = Tag;
      _this2297.PredefinedType = PredefinedType;
      _this2297.type = 3694346114;
      return _this2297;
    }

    return IfcOutlet;
  }(IfcFlowTerminal);

  IFC42.IfcOutlet = IfcOutlet;

  var IfcPile = /*#__PURE__*/function (_IfcBuildingElement29) {
    _inherits(IfcPile, _IfcBuildingElement29);

    var _super2306 = _createSuper(IfcPile);

    function IfcPile(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType, ConstructionType) {
      var _this2298;

      _classCallCheck2(this, IfcPile);

      _this2298 = _super2306.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2298.GlobalId = GlobalId;
      _this2298.OwnerHistory = OwnerHistory;
      _this2298.Name = Name;
      _this2298.Description = Description;
      _this2298.ObjectType = ObjectType;
      _this2298.ObjectPlacement = ObjectPlacement;
      _this2298.Representation = Representation;
      _this2298.Tag = Tag;
      _this2298.PredefinedType = PredefinedType;
      _this2298.ConstructionType = ConstructionType;
      _this2298.type = 1687234759;
      return _this2298;
    }

    return IfcPile;
  }(IfcBuildingElement);

  IFC42.IfcPile = IfcPile;

  var IfcPipeFitting = /*#__PURE__*/function (_IfcFlowFitting7) {
    _inherits(IfcPipeFitting, _IfcFlowFitting7);

    var _super2307 = _createSuper(IfcPipeFitting);

    function IfcPipeFitting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2299;

      _classCallCheck2(this, IfcPipeFitting);

      _this2299 = _super2307.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2299.GlobalId = GlobalId;
      _this2299.OwnerHistory = OwnerHistory;
      _this2299.Name = Name;
      _this2299.Description = Description;
      _this2299.ObjectType = ObjectType;
      _this2299.ObjectPlacement = ObjectPlacement;
      _this2299.Representation = Representation;
      _this2299.Tag = Tag;
      _this2299.PredefinedType = PredefinedType;
      _this2299.type = 310824031;
      return _this2299;
    }

    return IfcPipeFitting;
  }(IfcFlowFitting);

  IFC42.IfcPipeFitting = IfcPipeFitting;

  var IfcPipeSegment = /*#__PURE__*/function (_IfcFlowSegment6) {
    _inherits(IfcPipeSegment, _IfcFlowSegment6);

    var _super2308 = _createSuper(IfcPipeSegment);

    function IfcPipeSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2300;

      _classCallCheck2(this, IfcPipeSegment);

      _this2300 = _super2308.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2300.GlobalId = GlobalId;
      _this2300.OwnerHistory = OwnerHistory;
      _this2300.Name = Name;
      _this2300.Description = Description;
      _this2300.ObjectType = ObjectType;
      _this2300.ObjectPlacement = ObjectPlacement;
      _this2300.Representation = Representation;
      _this2300.Tag = Tag;
      _this2300.PredefinedType = PredefinedType;
      _this2300.type = 3612865200;
      return _this2300;
    }

    return IfcPipeSegment;
  }(IfcFlowSegment);

  IFC42.IfcPipeSegment = IfcPipeSegment;

  var IfcPlate = /*#__PURE__*/function (_IfcBuildingElement30) {
    _inherits(IfcPlate, _IfcBuildingElement30);

    var _super2309 = _createSuper(IfcPlate);

    function IfcPlate(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2301;

      _classCallCheck2(this, IfcPlate);

      _this2301 = _super2309.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2301.GlobalId = GlobalId;
      _this2301.OwnerHistory = OwnerHistory;
      _this2301.Name = Name;
      _this2301.Description = Description;
      _this2301.ObjectType = ObjectType;
      _this2301.ObjectPlacement = ObjectPlacement;
      _this2301.Representation = Representation;
      _this2301.Tag = Tag;
      _this2301.PredefinedType = PredefinedType;
      _this2301.type = 3171933400;
      return _this2301;
    }

    return IfcPlate;
  }(IfcBuildingElement);

  IFC42.IfcPlate = IfcPlate;

  var IfcPlateStandardCase = /*#__PURE__*/function (_IfcPlate) {
    _inherits(IfcPlateStandardCase, _IfcPlate);

    var _super2310 = _createSuper(IfcPlateStandardCase);

    function IfcPlateStandardCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2302;

      _classCallCheck2(this, IfcPlateStandardCase);

      _this2302 = _super2310.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      _this2302.GlobalId = GlobalId;
      _this2302.OwnerHistory = OwnerHistory;
      _this2302.Name = Name;
      _this2302.Description = Description;
      _this2302.ObjectType = ObjectType;
      _this2302.ObjectPlacement = ObjectPlacement;
      _this2302.Representation = Representation;
      _this2302.Tag = Tag;
      _this2302.PredefinedType = PredefinedType;
      _this2302.type = 1156407060;
      return _this2302;
    }

    return IfcPlateStandardCase;
  }(IfcPlate);

  IFC42.IfcPlateStandardCase = IfcPlateStandardCase;

  var IfcProtectiveDevice = /*#__PURE__*/function (_IfcFlowController12) {
    _inherits(IfcProtectiveDevice, _IfcFlowController12);

    var _super2311 = _createSuper(IfcProtectiveDevice);

    function IfcProtectiveDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2303;

      _classCallCheck2(this, IfcProtectiveDevice);

      _this2303 = _super2311.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2303.GlobalId = GlobalId;
      _this2303.OwnerHistory = OwnerHistory;
      _this2303.Name = Name;
      _this2303.Description = Description;
      _this2303.ObjectType = ObjectType;
      _this2303.ObjectPlacement = ObjectPlacement;
      _this2303.Representation = Representation;
      _this2303.Tag = Tag;
      _this2303.PredefinedType = PredefinedType;
      _this2303.type = 738039164;
      return _this2303;
    }

    return IfcProtectiveDevice;
  }(IfcFlowController);

  IFC42.IfcProtectiveDevice = IfcProtectiveDevice;

  var IfcProtectiveDeviceTrippingUnitType = /*#__PURE__*/function (_IfcDistributionContr21) {
    _inherits(IfcProtectiveDeviceTrippingUnitType, _IfcDistributionContr21);

    var _super2312 = _createSuper(IfcProtectiveDeviceTrippingUnitType);

    function IfcProtectiveDeviceTrippingUnitType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2304;

      _classCallCheck2(this, IfcProtectiveDeviceTrippingUnitType);

      _this2304 = _super2312.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2304.GlobalId = GlobalId;
      _this2304.OwnerHistory = OwnerHistory;
      _this2304.Name = Name;
      _this2304.Description = Description;
      _this2304.ApplicableOccurrence = ApplicableOccurrence;
      _this2304.HasPropertySets = HasPropertySets;
      _this2304.RepresentationMaps = RepresentationMaps;
      _this2304.Tag = Tag;
      _this2304.ElementType = ElementType;
      _this2304.PredefinedType = PredefinedType;
      _this2304.type = 655969474;
      return _this2304;
    }

    return IfcProtectiveDeviceTrippingUnitType;
  }(IfcDistributionControlElementType);

  IFC42.IfcProtectiveDeviceTrippingUnitType = IfcProtectiveDeviceTrippingUnitType;

  var IfcPump = /*#__PURE__*/function (_IfcFlowMovingDevice4) {
    _inherits(IfcPump, _IfcFlowMovingDevice4);

    var _super2313 = _createSuper(IfcPump);

    function IfcPump(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2305;

      _classCallCheck2(this, IfcPump);

      _this2305 = _super2313.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2305.GlobalId = GlobalId;
      _this2305.OwnerHistory = OwnerHistory;
      _this2305.Name = Name;
      _this2305.Description = Description;
      _this2305.ObjectType = ObjectType;
      _this2305.ObjectPlacement = ObjectPlacement;
      _this2305.Representation = Representation;
      _this2305.Tag = Tag;
      _this2305.PredefinedType = PredefinedType;
      _this2305.type = 90941305;
      return _this2305;
    }

    return IfcPump;
  }(IfcFlowMovingDevice);

  IFC42.IfcPump = IfcPump;

  var IfcRailing = /*#__PURE__*/function (_IfcBuildingElement31) {
    _inherits(IfcRailing, _IfcBuildingElement31);

    var _super2314 = _createSuper(IfcRailing);

    function IfcRailing(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2306;

      _classCallCheck2(this, IfcRailing);

      _this2306 = _super2314.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2306.GlobalId = GlobalId;
      _this2306.OwnerHistory = OwnerHistory;
      _this2306.Name = Name;
      _this2306.Description = Description;
      _this2306.ObjectType = ObjectType;
      _this2306.ObjectPlacement = ObjectPlacement;
      _this2306.Representation = Representation;
      _this2306.Tag = Tag;
      _this2306.PredefinedType = PredefinedType;
      _this2306.type = 2262370178;
      return _this2306;
    }

    return IfcRailing;
  }(IfcBuildingElement);

  IFC42.IfcRailing = IfcRailing;

  var IfcRamp = /*#__PURE__*/function (_IfcBuildingElement32) {
    _inherits(IfcRamp, _IfcBuildingElement32);

    var _super2315 = _createSuper(IfcRamp);

    function IfcRamp(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2307;

      _classCallCheck2(this, IfcRamp);

      _this2307 = _super2315.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2307.GlobalId = GlobalId;
      _this2307.OwnerHistory = OwnerHistory;
      _this2307.Name = Name;
      _this2307.Description = Description;
      _this2307.ObjectType = ObjectType;
      _this2307.ObjectPlacement = ObjectPlacement;
      _this2307.Representation = Representation;
      _this2307.Tag = Tag;
      _this2307.PredefinedType = PredefinedType;
      _this2307.type = 3024970846;
      return _this2307;
    }

    return IfcRamp;
  }(IfcBuildingElement);

  IFC42.IfcRamp = IfcRamp;

  var IfcRampFlight = /*#__PURE__*/function (_IfcBuildingElement33) {
    _inherits(IfcRampFlight, _IfcBuildingElement33);

    var _super2316 = _createSuper(IfcRampFlight);

    function IfcRampFlight(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2308;

      _classCallCheck2(this, IfcRampFlight);

      _this2308 = _super2316.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2308.GlobalId = GlobalId;
      _this2308.OwnerHistory = OwnerHistory;
      _this2308.Name = Name;
      _this2308.Description = Description;
      _this2308.ObjectType = ObjectType;
      _this2308.ObjectPlacement = ObjectPlacement;
      _this2308.Representation = Representation;
      _this2308.Tag = Tag;
      _this2308.PredefinedType = PredefinedType;
      _this2308.type = 3283111854;
      return _this2308;
    }

    return IfcRampFlight;
  }(IfcBuildingElement);

  IFC42.IfcRampFlight = IfcRampFlight;

  var IfcRationalBSplineCurveWithKnots = /*#__PURE__*/function (_IfcBSplineCurveWithK2) {
    _inherits(IfcRationalBSplineCurveWithKnots, _IfcBSplineCurveWithK2);

    var _super2317 = _createSuper(IfcRationalBSplineCurveWithKnots);

    function IfcRationalBSplineCurveWithKnots(expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec, WeightsData) {
      var _this2309;

      _classCallCheck2(this, IfcRationalBSplineCurveWithKnots);

      _this2309 = _super2317.call(this, expressID, Degree, ControlPointsList, CurveForm, ClosedCurve, SelfIntersect, KnotMultiplicities, Knots, KnotSpec);
      _this2309.Degree = Degree;
      _this2309.ControlPointsList = ControlPointsList;
      _this2309.CurveForm = CurveForm;
      _this2309.ClosedCurve = ClosedCurve;
      _this2309.SelfIntersect = SelfIntersect;
      _this2309.KnotMultiplicities = KnotMultiplicities;
      _this2309.Knots = Knots;
      _this2309.KnotSpec = KnotSpec;
      _this2309.WeightsData = WeightsData;
      _this2309.type = 1232101972;
      return _this2309;
    }

    return IfcRationalBSplineCurveWithKnots;
  }(IfcBSplineCurveWithKnots);

  IFC42.IfcRationalBSplineCurveWithKnots = IfcRationalBSplineCurveWithKnots;

  var IfcReinforcingBar = /*#__PURE__*/function (_IfcReinforcingElemen21) {
    _inherits(IfcReinforcingBar, _IfcReinforcingElemen21);

    var _super2318 = _createSuper(IfcReinforcingBar);

    function IfcReinforcingBar(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade, NominalDiameter, CrossSectionArea, BarLength, PredefinedType, BarSurface) {
      var _this2310;

      _classCallCheck2(this, IfcReinforcingBar);

      _this2310 = _super2318.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, SteelGrade);
      _this2310.GlobalId = GlobalId;
      _this2310.OwnerHistory = OwnerHistory;
      _this2310.Name = Name;
      _this2310.Description = Description;
      _this2310.ObjectType = ObjectType;
      _this2310.ObjectPlacement = ObjectPlacement;
      _this2310.Representation = Representation;
      _this2310.Tag = Tag;
      _this2310.SteelGrade = SteelGrade;
      _this2310.NominalDiameter = NominalDiameter;
      _this2310.CrossSectionArea = CrossSectionArea;
      _this2310.BarLength = BarLength;
      _this2310.PredefinedType = PredefinedType;
      _this2310.BarSurface = BarSurface;
      _this2310.type = 979691226;
      return _this2310;
    }

    return IfcReinforcingBar;
  }(IfcReinforcingElement);

  IFC42.IfcReinforcingBar = IfcReinforcingBar;

  var IfcReinforcingBarType = /*#__PURE__*/function (_IfcReinforcingElemen22) {
    _inherits(IfcReinforcingBarType, _IfcReinforcingElemen22);

    var _super2319 = _createSuper(IfcReinforcingBarType);

    function IfcReinforcingBarType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType, NominalDiameter, CrossSectionArea, BarLength, BarSurface, BendingShapeCode, BendingParameters) {
      var _this2311;

      _classCallCheck2(this, IfcReinforcingBarType);

      _this2311 = _super2319.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2311.GlobalId = GlobalId;
      _this2311.OwnerHistory = OwnerHistory;
      _this2311.Name = Name;
      _this2311.Description = Description;
      _this2311.ApplicableOccurrence = ApplicableOccurrence;
      _this2311.HasPropertySets = HasPropertySets;
      _this2311.RepresentationMaps = RepresentationMaps;
      _this2311.Tag = Tag;
      _this2311.ElementType = ElementType;
      _this2311.PredefinedType = PredefinedType;
      _this2311.NominalDiameter = NominalDiameter;
      _this2311.CrossSectionArea = CrossSectionArea;
      _this2311.BarLength = BarLength;
      _this2311.BarSurface = BarSurface;
      _this2311.BendingShapeCode = BendingShapeCode;
      _this2311.BendingParameters = BendingParameters;
      _this2311.type = 2572171363;
      return _this2311;
    }

    return IfcReinforcingBarType;
  }(IfcReinforcingElementType);

  IFC42.IfcReinforcingBarType = IfcReinforcingBarType;

  var IfcRoof = /*#__PURE__*/function (_IfcBuildingElement34) {
    _inherits(IfcRoof, _IfcBuildingElement34);

    var _super2320 = _createSuper(IfcRoof);

    function IfcRoof(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2312;

      _classCallCheck2(this, IfcRoof);

      _this2312 = _super2320.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2312.GlobalId = GlobalId;
      _this2312.OwnerHistory = OwnerHistory;
      _this2312.Name = Name;
      _this2312.Description = Description;
      _this2312.ObjectType = ObjectType;
      _this2312.ObjectPlacement = ObjectPlacement;
      _this2312.Representation = Representation;
      _this2312.Tag = Tag;
      _this2312.PredefinedType = PredefinedType;
      _this2312.type = 2016517767;
      return _this2312;
    }

    return IfcRoof;
  }(IfcBuildingElement);

  IFC42.IfcRoof = IfcRoof;

  var IfcSanitaryTerminal = /*#__PURE__*/function (_IfcFlowTerminal21) {
    _inherits(IfcSanitaryTerminal, _IfcFlowTerminal21);

    var _super2321 = _createSuper(IfcSanitaryTerminal);

    function IfcSanitaryTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2313;

      _classCallCheck2(this, IfcSanitaryTerminal);

      _this2313 = _super2321.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2313.GlobalId = GlobalId;
      _this2313.OwnerHistory = OwnerHistory;
      _this2313.Name = Name;
      _this2313.Description = Description;
      _this2313.ObjectType = ObjectType;
      _this2313.ObjectPlacement = ObjectPlacement;
      _this2313.Representation = Representation;
      _this2313.Tag = Tag;
      _this2313.PredefinedType = PredefinedType;
      _this2313.type = 3053780830;
      return _this2313;
    }

    return IfcSanitaryTerminal;
  }(IfcFlowTerminal);

  IFC42.IfcSanitaryTerminal = IfcSanitaryTerminal;

  var IfcSensorType = /*#__PURE__*/function (_IfcDistributionContr22) {
    _inherits(IfcSensorType, _IfcDistributionContr22);

    var _super2322 = _createSuper(IfcSensorType);

    function IfcSensorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2314;

      _classCallCheck2(this, IfcSensorType);

      _this2314 = _super2322.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2314.GlobalId = GlobalId;
      _this2314.OwnerHistory = OwnerHistory;
      _this2314.Name = Name;
      _this2314.Description = Description;
      _this2314.ApplicableOccurrence = ApplicableOccurrence;
      _this2314.HasPropertySets = HasPropertySets;
      _this2314.RepresentationMaps = RepresentationMaps;
      _this2314.Tag = Tag;
      _this2314.ElementType = ElementType;
      _this2314.PredefinedType = PredefinedType;
      _this2314.type = 1783015770;
      return _this2314;
    }

    return IfcSensorType;
  }(IfcDistributionControlElementType);

  IFC42.IfcSensorType = IfcSensorType;

  var IfcShadingDevice = /*#__PURE__*/function (_IfcBuildingElement35) {
    _inherits(IfcShadingDevice, _IfcBuildingElement35);

    var _super2323 = _createSuper(IfcShadingDevice);

    function IfcShadingDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2315;

      _classCallCheck2(this, IfcShadingDevice);

      _this2315 = _super2323.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2315.GlobalId = GlobalId;
      _this2315.OwnerHistory = OwnerHistory;
      _this2315.Name = Name;
      _this2315.Description = Description;
      _this2315.ObjectType = ObjectType;
      _this2315.ObjectPlacement = ObjectPlacement;
      _this2315.Representation = Representation;
      _this2315.Tag = Tag;
      _this2315.PredefinedType = PredefinedType;
      _this2315.type = 1329646415;
      return _this2315;
    }

    return IfcShadingDevice;
  }(IfcBuildingElement);

  IFC42.IfcShadingDevice = IfcShadingDevice;

  var IfcSlab = /*#__PURE__*/function (_IfcBuildingElement36) {
    _inherits(IfcSlab, _IfcBuildingElement36);

    var _super2324 = _createSuper(IfcSlab);

    function IfcSlab(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2316;

      _classCallCheck2(this, IfcSlab);

      _this2316 = _super2324.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2316.GlobalId = GlobalId;
      _this2316.OwnerHistory = OwnerHistory;
      _this2316.Name = Name;
      _this2316.Description = Description;
      _this2316.ObjectType = ObjectType;
      _this2316.ObjectPlacement = ObjectPlacement;
      _this2316.Representation = Representation;
      _this2316.Tag = Tag;
      _this2316.PredefinedType = PredefinedType;
      _this2316.type = 1529196076;
      return _this2316;
    }

    return IfcSlab;
  }(IfcBuildingElement);

  IFC42.IfcSlab = IfcSlab;

  var IfcSlabElementedCase = /*#__PURE__*/function (_IfcSlab) {
    _inherits(IfcSlabElementedCase, _IfcSlab);

    var _super2325 = _createSuper(IfcSlabElementedCase);

    function IfcSlabElementedCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2317;

      _classCallCheck2(this, IfcSlabElementedCase);

      _this2317 = _super2325.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      _this2317.GlobalId = GlobalId;
      _this2317.OwnerHistory = OwnerHistory;
      _this2317.Name = Name;
      _this2317.Description = Description;
      _this2317.ObjectType = ObjectType;
      _this2317.ObjectPlacement = ObjectPlacement;
      _this2317.Representation = Representation;
      _this2317.Tag = Tag;
      _this2317.PredefinedType = PredefinedType;
      _this2317.type = 3127900445;
      return _this2317;
    }

    return IfcSlabElementedCase;
  }(IfcSlab);

  IFC42.IfcSlabElementedCase = IfcSlabElementedCase;

  var IfcSlabStandardCase = /*#__PURE__*/function (_IfcSlab2) {
    _inherits(IfcSlabStandardCase, _IfcSlab2);

    var _super2326 = _createSuper(IfcSlabStandardCase);

    function IfcSlabStandardCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2318;

      _classCallCheck2(this, IfcSlabStandardCase);

      _this2318 = _super2326.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      _this2318.GlobalId = GlobalId;
      _this2318.OwnerHistory = OwnerHistory;
      _this2318.Name = Name;
      _this2318.Description = Description;
      _this2318.ObjectType = ObjectType;
      _this2318.ObjectPlacement = ObjectPlacement;
      _this2318.Representation = Representation;
      _this2318.Tag = Tag;
      _this2318.PredefinedType = PredefinedType;
      _this2318.type = 3027962421;
      return _this2318;
    }

    return IfcSlabStandardCase;
  }(IfcSlab);

  IFC42.IfcSlabStandardCase = IfcSlabStandardCase;

  var IfcSolarDevice = /*#__PURE__*/function (_IfcEnergyConversionD85) {
    _inherits(IfcSolarDevice, _IfcEnergyConversionD85);

    var _super2327 = _createSuper(IfcSolarDevice);

    function IfcSolarDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2319;

      _classCallCheck2(this, IfcSolarDevice);

      _this2319 = _super2327.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2319.GlobalId = GlobalId;
      _this2319.OwnerHistory = OwnerHistory;
      _this2319.Name = Name;
      _this2319.Description = Description;
      _this2319.ObjectType = ObjectType;
      _this2319.ObjectPlacement = ObjectPlacement;
      _this2319.Representation = Representation;
      _this2319.Tag = Tag;
      _this2319.PredefinedType = PredefinedType;
      _this2319.type = 3420628829;
      return _this2319;
    }

    return IfcSolarDevice;
  }(IfcEnergyConversionDevice);

  IFC42.IfcSolarDevice = IfcSolarDevice;

  var IfcSpaceHeater = /*#__PURE__*/function (_IfcFlowTerminal22) {
    _inherits(IfcSpaceHeater, _IfcFlowTerminal22);

    var _super2328 = _createSuper(IfcSpaceHeater);

    function IfcSpaceHeater(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2320;

      _classCallCheck2(this, IfcSpaceHeater);

      _this2320 = _super2328.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2320.GlobalId = GlobalId;
      _this2320.OwnerHistory = OwnerHistory;
      _this2320.Name = Name;
      _this2320.Description = Description;
      _this2320.ObjectType = ObjectType;
      _this2320.ObjectPlacement = ObjectPlacement;
      _this2320.Representation = Representation;
      _this2320.Tag = Tag;
      _this2320.PredefinedType = PredefinedType;
      _this2320.type = 1999602285;
      return _this2320;
    }

    return IfcSpaceHeater;
  }(IfcFlowTerminal);

  IFC42.IfcSpaceHeater = IfcSpaceHeater;

  var IfcStackTerminal = /*#__PURE__*/function (_IfcFlowTerminal23) {
    _inherits(IfcStackTerminal, _IfcFlowTerminal23);

    var _super2329 = _createSuper(IfcStackTerminal);

    function IfcStackTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2321;

      _classCallCheck2(this, IfcStackTerminal);

      _this2321 = _super2329.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2321.GlobalId = GlobalId;
      _this2321.OwnerHistory = OwnerHistory;
      _this2321.Name = Name;
      _this2321.Description = Description;
      _this2321.ObjectType = ObjectType;
      _this2321.ObjectPlacement = ObjectPlacement;
      _this2321.Representation = Representation;
      _this2321.Tag = Tag;
      _this2321.PredefinedType = PredefinedType;
      _this2321.type = 1404847402;
      return _this2321;
    }

    return IfcStackTerminal;
  }(IfcFlowTerminal);

  IFC42.IfcStackTerminal = IfcStackTerminal;

  var IfcStair = /*#__PURE__*/function (_IfcBuildingElement37) {
    _inherits(IfcStair, _IfcBuildingElement37);

    var _super2330 = _createSuper(IfcStair);

    function IfcStair(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2322;

      _classCallCheck2(this, IfcStair);

      _this2322 = _super2330.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2322.GlobalId = GlobalId;
      _this2322.OwnerHistory = OwnerHistory;
      _this2322.Name = Name;
      _this2322.Description = Description;
      _this2322.ObjectType = ObjectType;
      _this2322.ObjectPlacement = ObjectPlacement;
      _this2322.Representation = Representation;
      _this2322.Tag = Tag;
      _this2322.PredefinedType = PredefinedType;
      _this2322.type = 331165859;
      return _this2322;
    }

    return IfcStair;
  }(IfcBuildingElement);

  IFC42.IfcStair = IfcStair;

  var IfcStairFlight = /*#__PURE__*/function (_IfcBuildingElement38) {
    _inherits(IfcStairFlight, _IfcBuildingElement38);

    var _super2331 = _createSuper(IfcStairFlight);

    function IfcStairFlight(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, NumberOfRisers, NumberOfTreads, RiserHeight, TreadLength, PredefinedType) {
      var _this2323;

      _classCallCheck2(this, IfcStairFlight);

      _this2323 = _super2331.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2323.GlobalId = GlobalId;
      _this2323.OwnerHistory = OwnerHistory;
      _this2323.Name = Name;
      _this2323.Description = Description;
      _this2323.ObjectType = ObjectType;
      _this2323.ObjectPlacement = ObjectPlacement;
      _this2323.Representation = Representation;
      _this2323.Tag = Tag;
      _this2323.NumberOfRisers = NumberOfRisers;
      _this2323.NumberOfTreads = NumberOfTreads;
      _this2323.RiserHeight = RiserHeight;
      _this2323.TreadLength = TreadLength;
      _this2323.PredefinedType = PredefinedType;
      _this2323.type = 4252922144;
      return _this2323;
    }

    return IfcStairFlight;
  }(IfcBuildingElement);

  IFC42.IfcStairFlight = IfcStairFlight;

  var IfcStructuralAnalysisModel = /*#__PURE__*/function (_IfcSystem11) {
    _inherits(IfcStructuralAnalysisModel, _IfcSystem11);

    var _super2332 = _createSuper(IfcStructuralAnalysisModel);

    function IfcStructuralAnalysisModel(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, OrientationOf2DPlane, LoadedBy, HasResults, SharedPlacement) {
      var _this2324;

      _classCallCheck2(this, IfcStructuralAnalysisModel);

      _this2324 = _super2332.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType);
      _this2324.GlobalId = GlobalId;
      _this2324.OwnerHistory = OwnerHistory;
      _this2324.Name = Name;
      _this2324.Description = Description;
      _this2324.ObjectType = ObjectType;
      _this2324.PredefinedType = PredefinedType;
      _this2324.OrientationOf2DPlane = OrientationOf2DPlane;
      _this2324.LoadedBy = LoadedBy;
      _this2324.HasResults = HasResults;
      _this2324.SharedPlacement = SharedPlacement;
      _this2324.type = 2515109513;
      return _this2324;
    }

    return IfcStructuralAnalysisModel;
  }(IfcSystem);

  IFC42.IfcStructuralAnalysisModel = IfcStructuralAnalysisModel;

  var IfcStructuralLoadCase = /*#__PURE__*/function (_IfcStructuralLoadGro2) {
    _inherits(IfcStructuralLoadCase, _IfcStructuralLoadGro2);

    var _super2333 = _createSuper(IfcStructuralLoadCase);

    function IfcStructuralLoadCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose, SelfWeightCoefficients) {
      var _this2325;

      _classCallCheck2(this, IfcStructuralLoadCase);

      _this2325 = _super2333.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, PredefinedType, ActionType, ActionSource, Coefficient, Purpose);
      _this2325.GlobalId = GlobalId;
      _this2325.OwnerHistory = OwnerHistory;
      _this2325.Name = Name;
      _this2325.Description = Description;
      _this2325.ObjectType = ObjectType;
      _this2325.PredefinedType = PredefinedType;
      _this2325.ActionType = ActionType;
      _this2325.ActionSource = ActionSource;
      _this2325.Coefficient = Coefficient;
      _this2325.Purpose = Purpose;
      _this2325.SelfWeightCoefficients = SelfWeightCoefficients;
      _this2325.type = 385403989;
      return _this2325;
    }

    return IfcStructuralLoadCase;
  }(IfcStructuralLoadGroup);

  IFC42.IfcStructuralLoadCase = IfcStructuralLoadCase;

  var IfcStructuralPlanarAction = /*#__PURE__*/function (_IfcStructuralSurface5) {
    _inherits(IfcStructuralPlanarAction, _IfcStructuralSurface5);

    var _super2334 = _createSuper(IfcStructuralPlanarAction);

    function IfcStructuralPlanarAction(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType) {
      var _this2326;

      _classCallCheck2(this, IfcStructuralPlanarAction);

      _this2326 = _super2334.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, AppliedLoad, GlobalOrLocal, DestabilizingLoad, ProjectedOrTrue, PredefinedType);
      _this2326.GlobalId = GlobalId;
      _this2326.OwnerHistory = OwnerHistory;
      _this2326.Name = Name;
      _this2326.Description = Description;
      _this2326.ObjectType = ObjectType;
      _this2326.ObjectPlacement = ObjectPlacement;
      _this2326.Representation = Representation;
      _this2326.AppliedLoad = AppliedLoad;
      _this2326.GlobalOrLocal = GlobalOrLocal;
      _this2326.DestabilizingLoad = DestabilizingLoad;
      _this2326.ProjectedOrTrue = ProjectedOrTrue;
      _this2326.PredefinedType = PredefinedType;
      _this2326.type = 1621171031;
      return _this2326;
    }

    return IfcStructuralPlanarAction;
  }(IfcStructuralSurfaceAction);

  IFC42.IfcStructuralPlanarAction = IfcStructuralPlanarAction;

  var IfcSwitchingDevice = /*#__PURE__*/function (_IfcFlowController13) {
    _inherits(IfcSwitchingDevice, _IfcFlowController13);

    var _super2335 = _createSuper(IfcSwitchingDevice);

    function IfcSwitchingDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2327;

      _classCallCheck2(this, IfcSwitchingDevice);

      _this2327 = _super2335.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2327.GlobalId = GlobalId;
      _this2327.OwnerHistory = OwnerHistory;
      _this2327.Name = Name;
      _this2327.Description = Description;
      _this2327.ObjectType = ObjectType;
      _this2327.ObjectPlacement = ObjectPlacement;
      _this2327.Representation = Representation;
      _this2327.Tag = Tag;
      _this2327.PredefinedType = PredefinedType;
      _this2327.type = 1162798199;
      return _this2327;
    }

    return IfcSwitchingDevice;
  }(IfcFlowController);

  IFC42.IfcSwitchingDevice = IfcSwitchingDevice;

  var IfcTank = /*#__PURE__*/function (_IfcFlowStorageDevice9) {
    _inherits(IfcTank, _IfcFlowStorageDevice9);

    var _super2336 = _createSuper(IfcTank);

    function IfcTank(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2328;

      _classCallCheck2(this, IfcTank);

      _this2328 = _super2336.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2328.GlobalId = GlobalId;
      _this2328.OwnerHistory = OwnerHistory;
      _this2328.Name = Name;
      _this2328.Description = Description;
      _this2328.ObjectType = ObjectType;
      _this2328.ObjectPlacement = ObjectPlacement;
      _this2328.Representation = Representation;
      _this2328.Tag = Tag;
      _this2328.PredefinedType = PredefinedType;
      _this2328.type = 812556717;
      return _this2328;
    }

    return IfcTank;
  }(IfcFlowStorageDevice);

  IFC42.IfcTank = IfcTank;

  var IfcTransformer = /*#__PURE__*/function (_IfcEnergyConversionD86) {
    _inherits(IfcTransformer, _IfcEnergyConversionD86);

    var _super2337 = _createSuper(IfcTransformer);

    function IfcTransformer(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2329;

      _classCallCheck2(this, IfcTransformer);

      _this2329 = _super2337.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2329.GlobalId = GlobalId;
      _this2329.OwnerHistory = OwnerHistory;
      _this2329.Name = Name;
      _this2329.Description = Description;
      _this2329.ObjectType = ObjectType;
      _this2329.ObjectPlacement = ObjectPlacement;
      _this2329.Representation = Representation;
      _this2329.Tag = Tag;
      _this2329.PredefinedType = PredefinedType;
      _this2329.type = 3825984169;
      return _this2329;
    }

    return IfcTransformer;
  }(IfcEnergyConversionDevice);

  IFC42.IfcTransformer = IfcTransformer;

  var IfcTubeBundle = /*#__PURE__*/function (_IfcEnergyConversionD87) {
    _inherits(IfcTubeBundle, _IfcEnergyConversionD87);

    var _super2338 = _createSuper(IfcTubeBundle);

    function IfcTubeBundle(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2330;

      _classCallCheck2(this, IfcTubeBundle);

      _this2330 = _super2338.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2330.GlobalId = GlobalId;
      _this2330.OwnerHistory = OwnerHistory;
      _this2330.Name = Name;
      _this2330.Description = Description;
      _this2330.ObjectType = ObjectType;
      _this2330.ObjectPlacement = ObjectPlacement;
      _this2330.Representation = Representation;
      _this2330.Tag = Tag;
      _this2330.PredefinedType = PredefinedType;
      _this2330.type = 3026737570;
      return _this2330;
    }

    return IfcTubeBundle;
  }(IfcEnergyConversionDevice);

  IFC42.IfcTubeBundle = IfcTubeBundle;

  var IfcUnitaryControlElementType = /*#__PURE__*/function (_IfcDistributionContr23) {
    _inherits(IfcUnitaryControlElementType, _IfcDistributionContr23);

    var _super2339 = _createSuper(IfcUnitaryControlElementType);

    function IfcUnitaryControlElementType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2331;

      _classCallCheck2(this, IfcUnitaryControlElementType);

      _this2331 = _super2339.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2331.GlobalId = GlobalId;
      _this2331.OwnerHistory = OwnerHistory;
      _this2331.Name = Name;
      _this2331.Description = Description;
      _this2331.ApplicableOccurrence = ApplicableOccurrence;
      _this2331.HasPropertySets = HasPropertySets;
      _this2331.RepresentationMaps = RepresentationMaps;
      _this2331.Tag = Tag;
      _this2331.ElementType = ElementType;
      _this2331.PredefinedType = PredefinedType;
      _this2331.type = 3179687236;
      return _this2331;
    }

    return IfcUnitaryControlElementType;
  }(IfcDistributionControlElementType);

  IFC42.IfcUnitaryControlElementType = IfcUnitaryControlElementType;

  var IfcUnitaryEquipment = /*#__PURE__*/function (_IfcEnergyConversionD88) {
    _inherits(IfcUnitaryEquipment, _IfcEnergyConversionD88);

    var _super2340 = _createSuper(IfcUnitaryEquipment);

    function IfcUnitaryEquipment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2332;

      _classCallCheck2(this, IfcUnitaryEquipment);

      _this2332 = _super2340.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2332.GlobalId = GlobalId;
      _this2332.OwnerHistory = OwnerHistory;
      _this2332.Name = Name;
      _this2332.Description = Description;
      _this2332.ObjectType = ObjectType;
      _this2332.ObjectPlacement = ObjectPlacement;
      _this2332.Representation = Representation;
      _this2332.Tag = Tag;
      _this2332.PredefinedType = PredefinedType;
      _this2332.type = 4292641817;
      return _this2332;
    }

    return IfcUnitaryEquipment;
  }(IfcEnergyConversionDevice);

  IFC42.IfcUnitaryEquipment = IfcUnitaryEquipment;

  var IfcValve = /*#__PURE__*/function (_IfcFlowController14) {
    _inherits(IfcValve, _IfcFlowController14);

    var _super2341 = _createSuper(IfcValve);

    function IfcValve(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2333;

      _classCallCheck2(this, IfcValve);

      _this2333 = _super2341.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2333.GlobalId = GlobalId;
      _this2333.OwnerHistory = OwnerHistory;
      _this2333.Name = Name;
      _this2333.Description = Description;
      _this2333.ObjectType = ObjectType;
      _this2333.ObjectPlacement = ObjectPlacement;
      _this2333.Representation = Representation;
      _this2333.Tag = Tag;
      _this2333.PredefinedType = PredefinedType;
      _this2333.type = 4207607924;
      return _this2333;
    }

    return IfcValve;
  }(IfcFlowController);

  IFC42.IfcValve = IfcValve;

  var IfcWall = /*#__PURE__*/function (_IfcBuildingElement39) {
    _inherits(IfcWall, _IfcBuildingElement39);

    var _super2342 = _createSuper(IfcWall);

    function IfcWall(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2334;

      _classCallCheck2(this, IfcWall);

      _this2334 = _super2342.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2334.GlobalId = GlobalId;
      _this2334.OwnerHistory = OwnerHistory;
      _this2334.Name = Name;
      _this2334.Description = Description;
      _this2334.ObjectType = ObjectType;
      _this2334.ObjectPlacement = ObjectPlacement;
      _this2334.Representation = Representation;
      _this2334.Tag = Tag;
      _this2334.PredefinedType = PredefinedType;
      _this2334.type = 2391406946;
      return _this2334;
    }

    return IfcWall;
  }(IfcBuildingElement);

  IFC42.IfcWall = IfcWall;

  var IfcWallElementedCase = /*#__PURE__*/function (_IfcWall3) {
    _inherits(IfcWallElementedCase, _IfcWall3);

    var _super2343 = _createSuper(IfcWallElementedCase);

    function IfcWallElementedCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2335;

      _classCallCheck2(this, IfcWallElementedCase);

      _this2335 = _super2343.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      _this2335.GlobalId = GlobalId;
      _this2335.OwnerHistory = OwnerHistory;
      _this2335.Name = Name;
      _this2335.Description = Description;
      _this2335.ObjectType = ObjectType;
      _this2335.ObjectPlacement = ObjectPlacement;
      _this2335.Representation = Representation;
      _this2335.Tag = Tag;
      _this2335.PredefinedType = PredefinedType;
      _this2335.type = 4156078855;
      return _this2335;
    }

    return IfcWallElementedCase;
  }(IfcWall);

  IFC42.IfcWallElementedCase = IfcWallElementedCase;

  var IfcWallStandardCase = /*#__PURE__*/function (_IfcWall4) {
    _inherits(IfcWallStandardCase, _IfcWall4);

    var _super2344 = _createSuper(IfcWallStandardCase);

    function IfcWallStandardCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2336;

      _classCallCheck2(this, IfcWallStandardCase);

      _this2336 = _super2344.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      _this2336.GlobalId = GlobalId;
      _this2336.OwnerHistory = OwnerHistory;
      _this2336.Name = Name;
      _this2336.Description = Description;
      _this2336.ObjectType = ObjectType;
      _this2336.ObjectPlacement = ObjectPlacement;
      _this2336.Representation = Representation;
      _this2336.Tag = Tag;
      _this2336.PredefinedType = PredefinedType;
      _this2336.type = 3512223829;
      return _this2336;
    }

    return IfcWallStandardCase;
  }(IfcWall);

  IFC42.IfcWallStandardCase = IfcWallStandardCase;

  var IfcWasteTerminal = /*#__PURE__*/function (_IfcFlowTerminal24) {
    _inherits(IfcWasteTerminal, _IfcFlowTerminal24);

    var _super2345 = _createSuper(IfcWasteTerminal);

    function IfcWasteTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2337;

      _classCallCheck2(this, IfcWasteTerminal);

      _this2337 = _super2345.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2337.GlobalId = GlobalId;
      _this2337.OwnerHistory = OwnerHistory;
      _this2337.Name = Name;
      _this2337.Description = Description;
      _this2337.ObjectType = ObjectType;
      _this2337.ObjectPlacement = ObjectPlacement;
      _this2337.Representation = Representation;
      _this2337.Tag = Tag;
      _this2337.PredefinedType = PredefinedType;
      _this2337.type = 4237592921;
      return _this2337;
    }

    return IfcWasteTerminal;
  }(IfcFlowTerminal);

  IFC42.IfcWasteTerminal = IfcWasteTerminal;

  var IfcWindow = /*#__PURE__*/function (_IfcBuildingElement40) {
    _inherits(IfcWindow, _IfcBuildingElement40);

    var _super2346 = _createSuper(IfcWindow);

    function IfcWindow(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType) {
      var _this2338;

      _classCallCheck2(this, IfcWindow);

      _this2338 = _super2346.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2338.GlobalId = GlobalId;
      _this2338.OwnerHistory = OwnerHistory;
      _this2338.Name = Name;
      _this2338.Description = Description;
      _this2338.ObjectType = ObjectType;
      _this2338.ObjectPlacement = ObjectPlacement;
      _this2338.Representation = Representation;
      _this2338.Tag = Tag;
      _this2338.OverallHeight = OverallHeight;
      _this2338.OverallWidth = OverallWidth;
      _this2338.PredefinedType = PredefinedType;
      _this2338.PartitioningType = PartitioningType;
      _this2338.UserDefinedPartitioningType = UserDefinedPartitioningType;
      _this2338.type = 3304561284;
      return _this2338;
    }

    return IfcWindow;
  }(IfcBuildingElement);

  IFC42.IfcWindow = IfcWindow;

  var IfcWindowStandardCase = /*#__PURE__*/function (_IfcWindow) {
    _inherits(IfcWindowStandardCase, _IfcWindow);

    var _super2347 = _createSuper(IfcWindowStandardCase);

    function IfcWindowStandardCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType) {
      var _this2339;

      _classCallCheck2(this, IfcWindowStandardCase);

      _this2339 = _super2347.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, OverallHeight, OverallWidth, PredefinedType, PartitioningType, UserDefinedPartitioningType);
      _this2339.GlobalId = GlobalId;
      _this2339.OwnerHistory = OwnerHistory;
      _this2339.Name = Name;
      _this2339.Description = Description;
      _this2339.ObjectType = ObjectType;
      _this2339.ObjectPlacement = ObjectPlacement;
      _this2339.Representation = Representation;
      _this2339.Tag = Tag;
      _this2339.OverallHeight = OverallHeight;
      _this2339.OverallWidth = OverallWidth;
      _this2339.PredefinedType = PredefinedType;
      _this2339.PartitioningType = PartitioningType;
      _this2339.UserDefinedPartitioningType = UserDefinedPartitioningType;
      _this2339.type = 486154966;
      return _this2339;
    }

    return IfcWindowStandardCase;
  }(IfcWindow);

  IFC42.IfcWindowStandardCase = IfcWindowStandardCase;

  var IfcActuatorType = /*#__PURE__*/function (_IfcDistributionContr24) {
    _inherits(IfcActuatorType, _IfcDistributionContr24);

    var _super2348 = _createSuper(IfcActuatorType);

    function IfcActuatorType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2340;

      _classCallCheck2(this, IfcActuatorType);

      _this2340 = _super2348.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2340.GlobalId = GlobalId;
      _this2340.OwnerHistory = OwnerHistory;
      _this2340.Name = Name;
      _this2340.Description = Description;
      _this2340.ApplicableOccurrence = ApplicableOccurrence;
      _this2340.HasPropertySets = HasPropertySets;
      _this2340.RepresentationMaps = RepresentationMaps;
      _this2340.Tag = Tag;
      _this2340.ElementType = ElementType;
      _this2340.PredefinedType = PredefinedType;
      _this2340.type = 2874132201;
      return _this2340;
    }

    return IfcActuatorType;
  }(IfcDistributionControlElementType);

  IFC42.IfcActuatorType = IfcActuatorType;

  var IfcAirTerminal = /*#__PURE__*/function (_IfcFlowTerminal25) {
    _inherits(IfcAirTerminal, _IfcFlowTerminal25);

    var _super2349 = _createSuper(IfcAirTerminal);

    function IfcAirTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2341;

      _classCallCheck2(this, IfcAirTerminal);

      _this2341 = _super2349.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2341.GlobalId = GlobalId;
      _this2341.OwnerHistory = OwnerHistory;
      _this2341.Name = Name;
      _this2341.Description = Description;
      _this2341.ObjectType = ObjectType;
      _this2341.ObjectPlacement = ObjectPlacement;
      _this2341.Representation = Representation;
      _this2341.Tag = Tag;
      _this2341.PredefinedType = PredefinedType;
      _this2341.type = 1634111441;
      return _this2341;
    }

    return IfcAirTerminal;
  }(IfcFlowTerminal);

  IFC42.IfcAirTerminal = IfcAirTerminal;

  var IfcAirTerminalBox = /*#__PURE__*/function (_IfcFlowController15) {
    _inherits(IfcAirTerminalBox, _IfcFlowController15);

    var _super2350 = _createSuper(IfcAirTerminalBox);

    function IfcAirTerminalBox(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2342;

      _classCallCheck2(this, IfcAirTerminalBox);

      _this2342 = _super2350.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2342.GlobalId = GlobalId;
      _this2342.OwnerHistory = OwnerHistory;
      _this2342.Name = Name;
      _this2342.Description = Description;
      _this2342.ObjectType = ObjectType;
      _this2342.ObjectPlacement = ObjectPlacement;
      _this2342.Representation = Representation;
      _this2342.Tag = Tag;
      _this2342.PredefinedType = PredefinedType;
      _this2342.type = 177149247;
      return _this2342;
    }

    return IfcAirTerminalBox;
  }(IfcFlowController);

  IFC42.IfcAirTerminalBox = IfcAirTerminalBox;

  var IfcAirToAirHeatRecovery = /*#__PURE__*/function (_IfcEnergyConversionD89) {
    _inherits(IfcAirToAirHeatRecovery, _IfcEnergyConversionD89);

    var _super2351 = _createSuper(IfcAirToAirHeatRecovery);

    function IfcAirToAirHeatRecovery(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2343;

      _classCallCheck2(this, IfcAirToAirHeatRecovery);

      _this2343 = _super2351.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2343.GlobalId = GlobalId;
      _this2343.OwnerHistory = OwnerHistory;
      _this2343.Name = Name;
      _this2343.Description = Description;
      _this2343.ObjectType = ObjectType;
      _this2343.ObjectPlacement = ObjectPlacement;
      _this2343.Representation = Representation;
      _this2343.Tag = Tag;
      _this2343.PredefinedType = PredefinedType;
      _this2343.type = 2056796094;
      return _this2343;
    }

    return IfcAirToAirHeatRecovery;
  }(IfcEnergyConversionDevice);

  IFC42.IfcAirToAirHeatRecovery = IfcAirToAirHeatRecovery;

  var IfcAlarmType = /*#__PURE__*/function (_IfcDistributionContr25) {
    _inherits(IfcAlarmType, _IfcDistributionContr25);

    var _super2352 = _createSuper(IfcAlarmType);

    function IfcAlarmType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2344;

      _classCallCheck2(this, IfcAlarmType);

      _this2344 = _super2352.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2344.GlobalId = GlobalId;
      _this2344.OwnerHistory = OwnerHistory;
      _this2344.Name = Name;
      _this2344.Description = Description;
      _this2344.ApplicableOccurrence = ApplicableOccurrence;
      _this2344.HasPropertySets = HasPropertySets;
      _this2344.RepresentationMaps = RepresentationMaps;
      _this2344.Tag = Tag;
      _this2344.ElementType = ElementType;
      _this2344.PredefinedType = PredefinedType;
      _this2344.type = 3001207471;
      return _this2344;
    }

    return IfcAlarmType;
  }(IfcDistributionControlElementType);

  IFC42.IfcAlarmType = IfcAlarmType;

  var IfcAudioVisualAppliance = /*#__PURE__*/function (_IfcFlowTerminal26) {
    _inherits(IfcAudioVisualAppliance, _IfcFlowTerminal26);

    var _super2353 = _createSuper(IfcAudioVisualAppliance);

    function IfcAudioVisualAppliance(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2345;

      _classCallCheck2(this, IfcAudioVisualAppliance);

      _this2345 = _super2353.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2345.GlobalId = GlobalId;
      _this2345.OwnerHistory = OwnerHistory;
      _this2345.Name = Name;
      _this2345.Description = Description;
      _this2345.ObjectType = ObjectType;
      _this2345.ObjectPlacement = ObjectPlacement;
      _this2345.Representation = Representation;
      _this2345.Tag = Tag;
      _this2345.PredefinedType = PredefinedType;
      _this2345.type = 277319702;
      return _this2345;
    }

    return IfcAudioVisualAppliance;
  }(IfcFlowTerminal);

  IFC42.IfcAudioVisualAppliance = IfcAudioVisualAppliance;

  var IfcBeam = /*#__PURE__*/function (_IfcBuildingElement41) {
    _inherits(IfcBeam, _IfcBuildingElement41);

    var _super2354 = _createSuper(IfcBeam);

    function IfcBeam(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2346;

      _classCallCheck2(this, IfcBeam);

      _this2346 = _super2354.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2346.GlobalId = GlobalId;
      _this2346.OwnerHistory = OwnerHistory;
      _this2346.Name = Name;
      _this2346.Description = Description;
      _this2346.ObjectType = ObjectType;
      _this2346.ObjectPlacement = ObjectPlacement;
      _this2346.Representation = Representation;
      _this2346.Tag = Tag;
      _this2346.PredefinedType = PredefinedType;
      _this2346.type = 753842376;
      return _this2346;
    }

    return IfcBeam;
  }(IfcBuildingElement);

  IFC42.IfcBeam = IfcBeam;

  var IfcBeamStandardCase = /*#__PURE__*/function (_IfcBeam) {
    _inherits(IfcBeamStandardCase, _IfcBeam);

    var _super2355 = _createSuper(IfcBeamStandardCase);

    function IfcBeamStandardCase(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2347;

      _classCallCheck2(this, IfcBeamStandardCase);

      _this2347 = _super2355.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType);
      _this2347.GlobalId = GlobalId;
      _this2347.OwnerHistory = OwnerHistory;
      _this2347.Name = Name;
      _this2347.Description = Description;
      _this2347.ObjectType = ObjectType;
      _this2347.ObjectPlacement = ObjectPlacement;
      _this2347.Representation = Representation;
      _this2347.Tag = Tag;
      _this2347.PredefinedType = PredefinedType;
      _this2347.type = 2906023776;
      return _this2347;
    }

    return IfcBeamStandardCase;
  }(IfcBeam);

  IFC42.IfcBeamStandardCase = IfcBeamStandardCase;

  var IfcBoiler = /*#__PURE__*/function (_IfcEnergyConversionD90) {
    _inherits(IfcBoiler, _IfcEnergyConversionD90);

    var _super2356 = _createSuper(IfcBoiler);

    function IfcBoiler(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2348;

      _classCallCheck2(this, IfcBoiler);

      _this2348 = _super2356.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2348.GlobalId = GlobalId;
      _this2348.OwnerHistory = OwnerHistory;
      _this2348.Name = Name;
      _this2348.Description = Description;
      _this2348.ObjectType = ObjectType;
      _this2348.ObjectPlacement = ObjectPlacement;
      _this2348.Representation = Representation;
      _this2348.Tag = Tag;
      _this2348.PredefinedType = PredefinedType;
      _this2348.type = 32344328;
      return _this2348;
    }

    return IfcBoiler;
  }(IfcEnergyConversionDevice);

  IFC42.IfcBoiler = IfcBoiler;

  var IfcBurner = /*#__PURE__*/function (_IfcEnergyConversionD91) {
    _inherits(IfcBurner, _IfcEnergyConversionD91);

    var _super2357 = _createSuper(IfcBurner);

    function IfcBurner(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2349;

      _classCallCheck2(this, IfcBurner);

      _this2349 = _super2357.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2349.GlobalId = GlobalId;
      _this2349.OwnerHistory = OwnerHistory;
      _this2349.Name = Name;
      _this2349.Description = Description;
      _this2349.ObjectType = ObjectType;
      _this2349.ObjectPlacement = ObjectPlacement;
      _this2349.Representation = Representation;
      _this2349.Tag = Tag;
      _this2349.PredefinedType = PredefinedType;
      _this2349.type = 2938176219;
      return _this2349;
    }

    return IfcBurner;
  }(IfcEnergyConversionDevice);

  IFC42.IfcBurner = IfcBurner;

  var IfcCableCarrierFitting = /*#__PURE__*/function (_IfcFlowFitting8) {
    _inherits(IfcCableCarrierFitting, _IfcFlowFitting8);

    var _super2358 = _createSuper(IfcCableCarrierFitting);

    function IfcCableCarrierFitting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2350;

      _classCallCheck2(this, IfcCableCarrierFitting);

      _this2350 = _super2358.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2350.GlobalId = GlobalId;
      _this2350.OwnerHistory = OwnerHistory;
      _this2350.Name = Name;
      _this2350.Description = Description;
      _this2350.ObjectType = ObjectType;
      _this2350.ObjectPlacement = ObjectPlacement;
      _this2350.Representation = Representation;
      _this2350.Tag = Tag;
      _this2350.PredefinedType = PredefinedType;
      _this2350.type = 635142910;
      return _this2350;
    }

    return IfcCableCarrierFitting;
  }(IfcFlowFitting);

  IFC42.IfcCableCarrierFitting = IfcCableCarrierFitting;

  var IfcCableCarrierSegment = /*#__PURE__*/function (_IfcFlowSegment7) {
    _inherits(IfcCableCarrierSegment, _IfcFlowSegment7);

    var _super2359 = _createSuper(IfcCableCarrierSegment);

    function IfcCableCarrierSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2351;

      _classCallCheck2(this, IfcCableCarrierSegment);

      _this2351 = _super2359.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2351.GlobalId = GlobalId;
      _this2351.OwnerHistory = OwnerHistory;
      _this2351.Name = Name;
      _this2351.Description = Description;
      _this2351.ObjectType = ObjectType;
      _this2351.ObjectPlacement = ObjectPlacement;
      _this2351.Representation = Representation;
      _this2351.Tag = Tag;
      _this2351.PredefinedType = PredefinedType;
      _this2351.type = 3758799889;
      return _this2351;
    }

    return IfcCableCarrierSegment;
  }(IfcFlowSegment);

  IFC42.IfcCableCarrierSegment = IfcCableCarrierSegment;

  var IfcCableFitting = /*#__PURE__*/function (_IfcFlowFitting9) {
    _inherits(IfcCableFitting, _IfcFlowFitting9);

    var _super2360 = _createSuper(IfcCableFitting);

    function IfcCableFitting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2352;

      _classCallCheck2(this, IfcCableFitting);

      _this2352 = _super2360.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2352.GlobalId = GlobalId;
      _this2352.OwnerHistory = OwnerHistory;
      _this2352.Name = Name;
      _this2352.Description = Description;
      _this2352.ObjectType = ObjectType;
      _this2352.ObjectPlacement = ObjectPlacement;
      _this2352.Representation = Representation;
      _this2352.Tag = Tag;
      _this2352.PredefinedType = PredefinedType;
      _this2352.type = 1051757585;
      return _this2352;
    }

    return IfcCableFitting;
  }(IfcFlowFitting);

  IFC42.IfcCableFitting = IfcCableFitting;

  var IfcCableSegment = /*#__PURE__*/function (_IfcFlowSegment8) {
    _inherits(IfcCableSegment, _IfcFlowSegment8);

    var _super2361 = _createSuper(IfcCableSegment);

    function IfcCableSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2353;

      _classCallCheck2(this, IfcCableSegment);

      _this2353 = _super2361.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2353.GlobalId = GlobalId;
      _this2353.OwnerHistory = OwnerHistory;
      _this2353.Name = Name;
      _this2353.Description = Description;
      _this2353.ObjectType = ObjectType;
      _this2353.ObjectPlacement = ObjectPlacement;
      _this2353.Representation = Representation;
      _this2353.Tag = Tag;
      _this2353.PredefinedType = PredefinedType;
      _this2353.type = 4217484030;
      return _this2353;
    }

    return IfcCableSegment;
  }(IfcFlowSegment);

  IFC42.IfcCableSegment = IfcCableSegment;

  var IfcChiller = /*#__PURE__*/function (_IfcEnergyConversionD92) {
    _inherits(IfcChiller, _IfcEnergyConversionD92);

    var _super2362 = _createSuper(IfcChiller);

    function IfcChiller(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2354;

      _classCallCheck2(this, IfcChiller);

      _this2354 = _super2362.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2354.GlobalId = GlobalId;
      _this2354.OwnerHistory = OwnerHistory;
      _this2354.Name = Name;
      _this2354.Description = Description;
      _this2354.ObjectType = ObjectType;
      _this2354.ObjectPlacement = ObjectPlacement;
      _this2354.Representation = Representation;
      _this2354.Tag = Tag;
      _this2354.PredefinedType = PredefinedType;
      _this2354.type = 3902619387;
      return _this2354;
    }

    return IfcChiller;
  }(IfcEnergyConversionDevice);

  IFC42.IfcChiller = IfcChiller;

  var IfcCoil = /*#__PURE__*/function (_IfcEnergyConversionD93) {
    _inherits(IfcCoil, _IfcEnergyConversionD93);

    var _super2363 = _createSuper(IfcCoil);

    function IfcCoil(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2355;

      _classCallCheck2(this, IfcCoil);

      _this2355 = _super2363.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2355.GlobalId = GlobalId;
      _this2355.OwnerHistory = OwnerHistory;
      _this2355.Name = Name;
      _this2355.Description = Description;
      _this2355.ObjectType = ObjectType;
      _this2355.ObjectPlacement = ObjectPlacement;
      _this2355.Representation = Representation;
      _this2355.Tag = Tag;
      _this2355.PredefinedType = PredefinedType;
      _this2355.type = 639361253;
      return _this2355;
    }

    return IfcCoil;
  }(IfcEnergyConversionDevice);

  IFC42.IfcCoil = IfcCoil;

  var IfcCommunicationsAppliance = /*#__PURE__*/function (_IfcFlowTerminal27) {
    _inherits(IfcCommunicationsAppliance, _IfcFlowTerminal27);

    var _super2364 = _createSuper(IfcCommunicationsAppliance);

    function IfcCommunicationsAppliance(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2356;

      _classCallCheck2(this, IfcCommunicationsAppliance);

      _this2356 = _super2364.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2356.GlobalId = GlobalId;
      _this2356.OwnerHistory = OwnerHistory;
      _this2356.Name = Name;
      _this2356.Description = Description;
      _this2356.ObjectType = ObjectType;
      _this2356.ObjectPlacement = ObjectPlacement;
      _this2356.Representation = Representation;
      _this2356.Tag = Tag;
      _this2356.PredefinedType = PredefinedType;
      _this2356.type = 3221913625;
      return _this2356;
    }

    return IfcCommunicationsAppliance;
  }(IfcFlowTerminal);

  IFC42.IfcCommunicationsAppliance = IfcCommunicationsAppliance;

  var IfcCompressor = /*#__PURE__*/function (_IfcFlowMovingDevice5) {
    _inherits(IfcCompressor, _IfcFlowMovingDevice5);

    var _super2365 = _createSuper(IfcCompressor);

    function IfcCompressor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2357;

      _classCallCheck2(this, IfcCompressor);

      _this2357 = _super2365.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2357.GlobalId = GlobalId;
      _this2357.OwnerHistory = OwnerHistory;
      _this2357.Name = Name;
      _this2357.Description = Description;
      _this2357.ObjectType = ObjectType;
      _this2357.ObjectPlacement = ObjectPlacement;
      _this2357.Representation = Representation;
      _this2357.Tag = Tag;
      _this2357.PredefinedType = PredefinedType;
      _this2357.type = 3571504051;
      return _this2357;
    }

    return IfcCompressor;
  }(IfcFlowMovingDevice);

  IFC42.IfcCompressor = IfcCompressor;

  var IfcCondenser = /*#__PURE__*/function (_IfcEnergyConversionD94) {
    _inherits(IfcCondenser, _IfcEnergyConversionD94);

    var _super2366 = _createSuper(IfcCondenser);

    function IfcCondenser(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2358;

      _classCallCheck2(this, IfcCondenser);

      _this2358 = _super2366.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2358.GlobalId = GlobalId;
      _this2358.OwnerHistory = OwnerHistory;
      _this2358.Name = Name;
      _this2358.Description = Description;
      _this2358.ObjectType = ObjectType;
      _this2358.ObjectPlacement = ObjectPlacement;
      _this2358.Representation = Representation;
      _this2358.Tag = Tag;
      _this2358.PredefinedType = PredefinedType;
      _this2358.type = 2272882330;
      return _this2358;
    }

    return IfcCondenser;
  }(IfcEnergyConversionDevice);

  IFC42.IfcCondenser = IfcCondenser;

  var IfcControllerType = /*#__PURE__*/function (_IfcDistributionContr26) {
    _inherits(IfcControllerType, _IfcDistributionContr26);

    var _super2367 = _createSuper(IfcControllerType);

    function IfcControllerType(expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType, PredefinedType) {
      var _this2359;

      _classCallCheck2(this, IfcControllerType);

      _this2359 = _super2367.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ApplicableOccurrence, HasPropertySets, RepresentationMaps, Tag, ElementType);
      _this2359.GlobalId = GlobalId;
      _this2359.OwnerHistory = OwnerHistory;
      _this2359.Name = Name;
      _this2359.Description = Description;
      _this2359.ApplicableOccurrence = ApplicableOccurrence;
      _this2359.HasPropertySets = HasPropertySets;
      _this2359.RepresentationMaps = RepresentationMaps;
      _this2359.Tag = Tag;
      _this2359.ElementType = ElementType;
      _this2359.PredefinedType = PredefinedType;
      _this2359.type = 578613899;
      return _this2359;
    }

    return IfcControllerType;
  }(IfcDistributionControlElementType);

  IFC42.IfcControllerType = IfcControllerType;

  var IfcCooledBeam = /*#__PURE__*/function (_IfcEnergyConversionD95) {
    _inherits(IfcCooledBeam, _IfcEnergyConversionD95);

    var _super2368 = _createSuper(IfcCooledBeam);

    function IfcCooledBeam(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2360;

      _classCallCheck2(this, IfcCooledBeam);

      _this2360 = _super2368.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2360.GlobalId = GlobalId;
      _this2360.OwnerHistory = OwnerHistory;
      _this2360.Name = Name;
      _this2360.Description = Description;
      _this2360.ObjectType = ObjectType;
      _this2360.ObjectPlacement = ObjectPlacement;
      _this2360.Representation = Representation;
      _this2360.Tag = Tag;
      _this2360.PredefinedType = PredefinedType;
      _this2360.type = 4136498852;
      return _this2360;
    }

    return IfcCooledBeam;
  }(IfcEnergyConversionDevice);

  IFC42.IfcCooledBeam = IfcCooledBeam;

  var IfcCoolingTower = /*#__PURE__*/function (_IfcEnergyConversionD96) {
    _inherits(IfcCoolingTower, _IfcEnergyConversionD96);

    var _super2369 = _createSuper(IfcCoolingTower);

    function IfcCoolingTower(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2361;

      _classCallCheck2(this, IfcCoolingTower);

      _this2361 = _super2369.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2361.GlobalId = GlobalId;
      _this2361.OwnerHistory = OwnerHistory;
      _this2361.Name = Name;
      _this2361.Description = Description;
      _this2361.ObjectType = ObjectType;
      _this2361.ObjectPlacement = ObjectPlacement;
      _this2361.Representation = Representation;
      _this2361.Tag = Tag;
      _this2361.PredefinedType = PredefinedType;
      _this2361.type = 3640358203;
      return _this2361;
    }

    return IfcCoolingTower;
  }(IfcEnergyConversionDevice);

  IFC42.IfcCoolingTower = IfcCoolingTower;

  var IfcDamper = /*#__PURE__*/function (_IfcFlowController16) {
    _inherits(IfcDamper, _IfcFlowController16);

    var _super2370 = _createSuper(IfcDamper);

    function IfcDamper(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2362;

      _classCallCheck2(this, IfcDamper);

      _this2362 = _super2370.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2362.GlobalId = GlobalId;
      _this2362.OwnerHistory = OwnerHistory;
      _this2362.Name = Name;
      _this2362.Description = Description;
      _this2362.ObjectType = ObjectType;
      _this2362.ObjectPlacement = ObjectPlacement;
      _this2362.Representation = Representation;
      _this2362.Tag = Tag;
      _this2362.PredefinedType = PredefinedType;
      _this2362.type = 4074379575;
      return _this2362;
    }

    return IfcDamper;
  }(IfcFlowController);

  IFC42.IfcDamper = IfcDamper;

  var IfcDistributionChamberElement = /*#__PURE__*/function (_IfcDistributionFlowE54) {
    _inherits(IfcDistributionChamberElement, _IfcDistributionFlowE54);

    var _super2371 = _createSuper(IfcDistributionChamberElement);

    function IfcDistributionChamberElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2363;

      _classCallCheck2(this, IfcDistributionChamberElement);

      _this2363 = _super2371.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2363.GlobalId = GlobalId;
      _this2363.OwnerHistory = OwnerHistory;
      _this2363.Name = Name;
      _this2363.Description = Description;
      _this2363.ObjectType = ObjectType;
      _this2363.ObjectPlacement = ObjectPlacement;
      _this2363.Representation = Representation;
      _this2363.Tag = Tag;
      _this2363.PredefinedType = PredefinedType;
      _this2363.type = 1052013943;
      return _this2363;
    }

    return IfcDistributionChamberElement;
  }(IfcDistributionFlowElement);

  IFC42.IfcDistributionChamberElement = IfcDistributionChamberElement;

  var IfcDistributionCircuit = /*#__PURE__*/function (_IfcDistributionSyste2) {
    _inherits(IfcDistributionCircuit, _IfcDistributionSyste2);

    var _super2372 = _createSuper(IfcDistributionCircuit);

    function IfcDistributionCircuit(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType) {
      var _this2364;

      _classCallCheck2(this, IfcDistributionCircuit);

      _this2364 = _super2372.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, LongName, PredefinedType);
      _this2364.GlobalId = GlobalId;
      _this2364.OwnerHistory = OwnerHistory;
      _this2364.Name = Name;
      _this2364.Description = Description;
      _this2364.ObjectType = ObjectType;
      _this2364.LongName = LongName;
      _this2364.PredefinedType = PredefinedType;
      _this2364.type = 562808652;
      return _this2364;
    }

    return IfcDistributionCircuit;
  }(IfcDistributionSystem);

  IFC42.IfcDistributionCircuit = IfcDistributionCircuit;

  var IfcDistributionControlElement = /*#__PURE__*/function (_IfcDistributionEleme12) {
    _inherits(IfcDistributionControlElement, _IfcDistributionEleme12);

    var _super2373 = _createSuper(IfcDistributionControlElement);

    function IfcDistributionControlElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag) {
      var _this2365;

      _classCallCheck2(this, IfcDistributionControlElement);

      _this2365 = _super2373.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2365.GlobalId = GlobalId;
      _this2365.OwnerHistory = OwnerHistory;
      _this2365.Name = Name;
      _this2365.Description = Description;
      _this2365.ObjectType = ObjectType;
      _this2365.ObjectPlacement = ObjectPlacement;
      _this2365.Representation = Representation;
      _this2365.Tag = Tag;
      _this2365.type = 1062813311;
      return _this2365;
    }

    return IfcDistributionControlElement;
  }(IfcDistributionElement);

  IFC42.IfcDistributionControlElement = IfcDistributionControlElement;

  var IfcDuctFitting = /*#__PURE__*/function (_IfcFlowFitting10) {
    _inherits(IfcDuctFitting, _IfcFlowFitting10);

    var _super2374 = _createSuper(IfcDuctFitting);

    function IfcDuctFitting(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2366;

      _classCallCheck2(this, IfcDuctFitting);

      _this2366 = _super2374.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2366.GlobalId = GlobalId;
      _this2366.OwnerHistory = OwnerHistory;
      _this2366.Name = Name;
      _this2366.Description = Description;
      _this2366.ObjectType = ObjectType;
      _this2366.ObjectPlacement = ObjectPlacement;
      _this2366.Representation = Representation;
      _this2366.Tag = Tag;
      _this2366.PredefinedType = PredefinedType;
      _this2366.type = 342316401;
      return _this2366;
    }

    return IfcDuctFitting;
  }(IfcFlowFitting);

  IFC42.IfcDuctFitting = IfcDuctFitting;

  var IfcDuctSegment = /*#__PURE__*/function (_IfcFlowSegment9) {
    _inherits(IfcDuctSegment, _IfcFlowSegment9);

    var _super2375 = _createSuper(IfcDuctSegment);

    function IfcDuctSegment(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2367;

      _classCallCheck2(this, IfcDuctSegment);

      _this2367 = _super2375.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2367.GlobalId = GlobalId;
      _this2367.OwnerHistory = OwnerHistory;
      _this2367.Name = Name;
      _this2367.Description = Description;
      _this2367.ObjectType = ObjectType;
      _this2367.ObjectPlacement = ObjectPlacement;
      _this2367.Representation = Representation;
      _this2367.Tag = Tag;
      _this2367.PredefinedType = PredefinedType;
      _this2367.type = 3518393246;
      return _this2367;
    }

    return IfcDuctSegment;
  }(IfcFlowSegment);

  IFC42.IfcDuctSegment = IfcDuctSegment;

  var IfcDuctSilencer = /*#__PURE__*/function (_IfcFlowTreatmentDevi15) {
    _inherits(IfcDuctSilencer, _IfcFlowTreatmentDevi15);

    var _super2376 = _createSuper(IfcDuctSilencer);

    function IfcDuctSilencer(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2368;

      _classCallCheck2(this, IfcDuctSilencer);

      _this2368 = _super2376.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2368.GlobalId = GlobalId;
      _this2368.OwnerHistory = OwnerHistory;
      _this2368.Name = Name;
      _this2368.Description = Description;
      _this2368.ObjectType = ObjectType;
      _this2368.ObjectPlacement = ObjectPlacement;
      _this2368.Representation = Representation;
      _this2368.Tag = Tag;
      _this2368.PredefinedType = PredefinedType;
      _this2368.type = 1360408905;
      return _this2368;
    }

    return IfcDuctSilencer;
  }(IfcFlowTreatmentDevice);

  IFC42.IfcDuctSilencer = IfcDuctSilencer;

  var IfcElectricAppliance = /*#__PURE__*/function (_IfcFlowTerminal28) {
    _inherits(IfcElectricAppliance, _IfcFlowTerminal28);

    var _super2377 = _createSuper(IfcElectricAppliance);

    function IfcElectricAppliance(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2369;

      _classCallCheck2(this, IfcElectricAppliance);

      _this2369 = _super2377.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2369.GlobalId = GlobalId;
      _this2369.OwnerHistory = OwnerHistory;
      _this2369.Name = Name;
      _this2369.Description = Description;
      _this2369.ObjectType = ObjectType;
      _this2369.ObjectPlacement = ObjectPlacement;
      _this2369.Representation = Representation;
      _this2369.Tag = Tag;
      _this2369.PredefinedType = PredefinedType;
      _this2369.type = 1904799276;
      return _this2369;
    }

    return IfcElectricAppliance;
  }(IfcFlowTerminal);

  IFC42.IfcElectricAppliance = IfcElectricAppliance;

  var IfcElectricDistributionBoard = /*#__PURE__*/function (_IfcFlowController17) {
    _inherits(IfcElectricDistributionBoard, _IfcFlowController17);

    var _super2378 = _createSuper(IfcElectricDistributionBoard);

    function IfcElectricDistributionBoard(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2370;

      _classCallCheck2(this, IfcElectricDistributionBoard);

      _this2370 = _super2378.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2370.GlobalId = GlobalId;
      _this2370.OwnerHistory = OwnerHistory;
      _this2370.Name = Name;
      _this2370.Description = Description;
      _this2370.ObjectType = ObjectType;
      _this2370.ObjectPlacement = ObjectPlacement;
      _this2370.Representation = Representation;
      _this2370.Tag = Tag;
      _this2370.PredefinedType = PredefinedType;
      _this2370.type = 862014818;
      return _this2370;
    }

    return IfcElectricDistributionBoard;
  }(IfcFlowController);

  IFC42.IfcElectricDistributionBoard = IfcElectricDistributionBoard;

  var IfcElectricFlowStorageDevice = /*#__PURE__*/function (_IfcFlowStorageDevice10) {
    _inherits(IfcElectricFlowStorageDevice, _IfcFlowStorageDevice10);

    var _super2379 = _createSuper(IfcElectricFlowStorageDevice);

    function IfcElectricFlowStorageDevice(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2371;

      _classCallCheck2(this, IfcElectricFlowStorageDevice);

      _this2371 = _super2379.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2371.GlobalId = GlobalId;
      _this2371.OwnerHistory = OwnerHistory;
      _this2371.Name = Name;
      _this2371.Description = Description;
      _this2371.ObjectType = ObjectType;
      _this2371.ObjectPlacement = ObjectPlacement;
      _this2371.Representation = Representation;
      _this2371.Tag = Tag;
      _this2371.PredefinedType = PredefinedType;
      _this2371.type = 3310460725;
      return _this2371;
    }

    return IfcElectricFlowStorageDevice;
  }(IfcFlowStorageDevice);

  IFC42.IfcElectricFlowStorageDevice = IfcElectricFlowStorageDevice;

  var IfcElectricGenerator = /*#__PURE__*/function (_IfcEnergyConversionD97) {
    _inherits(IfcElectricGenerator, _IfcEnergyConversionD97);

    var _super2380 = _createSuper(IfcElectricGenerator);

    function IfcElectricGenerator(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2372;

      _classCallCheck2(this, IfcElectricGenerator);

      _this2372 = _super2380.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2372.GlobalId = GlobalId;
      _this2372.OwnerHistory = OwnerHistory;
      _this2372.Name = Name;
      _this2372.Description = Description;
      _this2372.ObjectType = ObjectType;
      _this2372.ObjectPlacement = ObjectPlacement;
      _this2372.Representation = Representation;
      _this2372.Tag = Tag;
      _this2372.PredefinedType = PredefinedType;
      _this2372.type = 264262732;
      return _this2372;
    }

    return IfcElectricGenerator;
  }(IfcEnergyConversionDevice);

  IFC42.IfcElectricGenerator = IfcElectricGenerator;

  var IfcElectricMotor = /*#__PURE__*/function (_IfcEnergyConversionD98) {
    _inherits(IfcElectricMotor, _IfcEnergyConversionD98);

    var _super2381 = _createSuper(IfcElectricMotor);

    function IfcElectricMotor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2373;

      _classCallCheck2(this, IfcElectricMotor);

      _this2373 = _super2381.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2373.GlobalId = GlobalId;
      _this2373.OwnerHistory = OwnerHistory;
      _this2373.Name = Name;
      _this2373.Description = Description;
      _this2373.ObjectType = ObjectType;
      _this2373.ObjectPlacement = ObjectPlacement;
      _this2373.Representation = Representation;
      _this2373.Tag = Tag;
      _this2373.PredefinedType = PredefinedType;
      _this2373.type = 402227799;
      return _this2373;
    }

    return IfcElectricMotor;
  }(IfcEnergyConversionDevice);

  IFC42.IfcElectricMotor = IfcElectricMotor;

  var IfcElectricTimeControl = /*#__PURE__*/function (_IfcFlowController18) {
    _inherits(IfcElectricTimeControl, _IfcFlowController18);

    var _super2382 = _createSuper(IfcElectricTimeControl);

    function IfcElectricTimeControl(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2374;

      _classCallCheck2(this, IfcElectricTimeControl);

      _this2374 = _super2382.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2374.GlobalId = GlobalId;
      _this2374.OwnerHistory = OwnerHistory;
      _this2374.Name = Name;
      _this2374.Description = Description;
      _this2374.ObjectType = ObjectType;
      _this2374.ObjectPlacement = ObjectPlacement;
      _this2374.Representation = Representation;
      _this2374.Tag = Tag;
      _this2374.PredefinedType = PredefinedType;
      _this2374.type = 1003880860;
      return _this2374;
    }

    return IfcElectricTimeControl;
  }(IfcFlowController);

  IFC42.IfcElectricTimeControl = IfcElectricTimeControl;

  var IfcFan = /*#__PURE__*/function (_IfcFlowMovingDevice6) {
    _inherits(IfcFan, _IfcFlowMovingDevice6);

    var _super2383 = _createSuper(IfcFan);

    function IfcFan(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2375;

      _classCallCheck2(this, IfcFan);

      _this2375 = _super2383.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2375.GlobalId = GlobalId;
      _this2375.OwnerHistory = OwnerHistory;
      _this2375.Name = Name;
      _this2375.Description = Description;
      _this2375.ObjectType = ObjectType;
      _this2375.ObjectPlacement = ObjectPlacement;
      _this2375.Representation = Representation;
      _this2375.Tag = Tag;
      _this2375.PredefinedType = PredefinedType;
      _this2375.type = 3415622556;
      return _this2375;
    }

    return IfcFan;
  }(IfcFlowMovingDevice);

  IFC42.IfcFan = IfcFan;

  var IfcFilter = /*#__PURE__*/function (_IfcFlowTreatmentDevi16) {
    _inherits(IfcFilter, _IfcFlowTreatmentDevi16);

    var _super2384 = _createSuper(IfcFilter);

    function IfcFilter(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2376;

      _classCallCheck2(this, IfcFilter);

      _this2376 = _super2384.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2376.GlobalId = GlobalId;
      _this2376.OwnerHistory = OwnerHistory;
      _this2376.Name = Name;
      _this2376.Description = Description;
      _this2376.ObjectType = ObjectType;
      _this2376.ObjectPlacement = ObjectPlacement;
      _this2376.Representation = Representation;
      _this2376.Tag = Tag;
      _this2376.PredefinedType = PredefinedType;
      _this2376.type = 819412036;
      return _this2376;
    }

    return IfcFilter;
  }(IfcFlowTreatmentDevice);

  IFC42.IfcFilter = IfcFilter;

  var IfcFireSuppressionTerminal = /*#__PURE__*/function (_IfcFlowTerminal29) {
    _inherits(IfcFireSuppressionTerminal, _IfcFlowTerminal29);

    var _super2385 = _createSuper(IfcFireSuppressionTerminal);

    function IfcFireSuppressionTerminal(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2377;

      _classCallCheck2(this, IfcFireSuppressionTerminal);

      _this2377 = _super2385.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2377.GlobalId = GlobalId;
      _this2377.OwnerHistory = OwnerHistory;
      _this2377.Name = Name;
      _this2377.Description = Description;
      _this2377.ObjectType = ObjectType;
      _this2377.ObjectPlacement = ObjectPlacement;
      _this2377.Representation = Representation;
      _this2377.Tag = Tag;
      _this2377.PredefinedType = PredefinedType;
      _this2377.type = 1426591983;
      return _this2377;
    }

    return IfcFireSuppressionTerminal;
  }(IfcFlowTerminal);

  IFC42.IfcFireSuppressionTerminal = IfcFireSuppressionTerminal;

  var IfcFlowInstrument = /*#__PURE__*/function (_IfcDistributionContr27) {
    _inherits(IfcFlowInstrument, _IfcDistributionContr27);

    var _super2386 = _createSuper(IfcFlowInstrument);

    function IfcFlowInstrument(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2378;

      _classCallCheck2(this, IfcFlowInstrument);

      _this2378 = _super2386.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2378.GlobalId = GlobalId;
      _this2378.OwnerHistory = OwnerHistory;
      _this2378.Name = Name;
      _this2378.Description = Description;
      _this2378.ObjectType = ObjectType;
      _this2378.ObjectPlacement = ObjectPlacement;
      _this2378.Representation = Representation;
      _this2378.Tag = Tag;
      _this2378.PredefinedType = PredefinedType;
      _this2378.type = 182646315;
      return _this2378;
    }

    return IfcFlowInstrument;
  }(IfcDistributionControlElement);

  IFC42.IfcFlowInstrument = IfcFlowInstrument;

  var IfcProtectiveDeviceTrippingUnit = /*#__PURE__*/function (_IfcDistributionContr28) {
    _inherits(IfcProtectiveDeviceTrippingUnit, _IfcDistributionContr28);

    var _super2387 = _createSuper(IfcProtectiveDeviceTrippingUnit);

    function IfcProtectiveDeviceTrippingUnit(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2379;

      _classCallCheck2(this, IfcProtectiveDeviceTrippingUnit);

      _this2379 = _super2387.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2379.GlobalId = GlobalId;
      _this2379.OwnerHistory = OwnerHistory;
      _this2379.Name = Name;
      _this2379.Description = Description;
      _this2379.ObjectType = ObjectType;
      _this2379.ObjectPlacement = ObjectPlacement;
      _this2379.Representation = Representation;
      _this2379.Tag = Tag;
      _this2379.PredefinedType = PredefinedType;
      _this2379.type = 2295281155;
      return _this2379;
    }

    return IfcProtectiveDeviceTrippingUnit;
  }(IfcDistributionControlElement);

  IFC42.IfcProtectiveDeviceTrippingUnit = IfcProtectiveDeviceTrippingUnit;

  var IfcSensor = /*#__PURE__*/function (_IfcDistributionContr29) {
    _inherits(IfcSensor, _IfcDistributionContr29);

    var _super2388 = _createSuper(IfcSensor);

    function IfcSensor(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2380;

      _classCallCheck2(this, IfcSensor);

      _this2380 = _super2388.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2380.GlobalId = GlobalId;
      _this2380.OwnerHistory = OwnerHistory;
      _this2380.Name = Name;
      _this2380.Description = Description;
      _this2380.ObjectType = ObjectType;
      _this2380.ObjectPlacement = ObjectPlacement;
      _this2380.Representation = Representation;
      _this2380.Tag = Tag;
      _this2380.PredefinedType = PredefinedType;
      _this2380.type = 4086658281;
      return _this2380;
    }

    return IfcSensor;
  }(IfcDistributionControlElement);

  IFC42.IfcSensor = IfcSensor;

  var IfcUnitaryControlElement = /*#__PURE__*/function (_IfcDistributionContr30) {
    _inherits(IfcUnitaryControlElement, _IfcDistributionContr30);

    var _super2389 = _createSuper(IfcUnitaryControlElement);

    function IfcUnitaryControlElement(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2381;

      _classCallCheck2(this, IfcUnitaryControlElement);

      _this2381 = _super2389.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2381.GlobalId = GlobalId;
      _this2381.OwnerHistory = OwnerHistory;
      _this2381.Name = Name;
      _this2381.Description = Description;
      _this2381.ObjectType = ObjectType;
      _this2381.ObjectPlacement = ObjectPlacement;
      _this2381.Representation = Representation;
      _this2381.Tag = Tag;
      _this2381.PredefinedType = PredefinedType;
      _this2381.type = 630975310;
      return _this2381;
    }

    return IfcUnitaryControlElement;
  }(IfcDistributionControlElement);

  IFC42.IfcUnitaryControlElement = IfcUnitaryControlElement;

  var IfcActuator = /*#__PURE__*/function (_IfcDistributionContr31) {
    _inherits(IfcActuator, _IfcDistributionContr31);

    var _super2390 = _createSuper(IfcActuator);

    function IfcActuator(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2382;

      _classCallCheck2(this, IfcActuator);

      _this2382 = _super2390.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2382.GlobalId = GlobalId;
      _this2382.OwnerHistory = OwnerHistory;
      _this2382.Name = Name;
      _this2382.Description = Description;
      _this2382.ObjectType = ObjectType;
      _this2382.ObjectPlacement = ObjectPlacement;
      _this2382.Representation = Representation;
      _this2382.Tag = Tag;
      _this2382.PredefinedType = PredefinedType;
      _this2382.type = 4288193352;
      return _this2382;
    }

    return IfcActuator;
  }(IfcDistributionControlElement);

  IFC42.IfcActuator = IfcActuator;

  var IfcAlarm = /*#__PURE__*/function (_IfcDistributionContr32) {
    _inherits(IfcAlarm, _IfcDistributionContr32);

    var _super2391 = _createSuper(IfcAlarm);

    function IfcAlarm(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2383;

      _classCallCheck2(this, IfcAlarm);

      _this2383 = _super2391.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2383.GlobalId = GlobalId;
      _this2383.OwnerHistory = OwnerHistory;
      _this2383.Name = Name;
      _this2383.Description = Description;
      _this2383.ObjectType = ObjectType;
      _this2383.ObjectPlacement = ObjectPlacement;
      _this2383.Representation = Representation;
      _this2383.Tag = Tag;
      _this2383.PredefinedType = PredefinedType;
      _this2383.type = 3087945054;
      return _this2383;
    }

    return IfcAlarm;
  }(IfcDistributionControlElement);

  IFC42.IfcAlarm = IfcAlarm;

  var IfcController = /*#__PURE__*/function (_IfcDistributionContr33) {
    _inherits(IfcController, _IfcDistributionContr33);

    var _super2392 = _createSuper(IfcController);

    function IfcController(expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag, PredefinedType) {
      var _this2384;

      _classCallCheck2(this, IfcController);

      _this2384 = _super2392.call(this, expressID, GlobalId, OwnerHistory, Name, Description, ObjectType, ObjectPlacement, Representation, Tag);
      _this2384.GlobalId = GlobalId;
      _this2384.OwnerHistory = OwnerHistory;
      _this2384.Name = Name;
      _this2384.Description = Description;
      _this2384.ObjectType = ObjectType;
      _this2384.ObjectPlacement = ObjectPlacement;
      _this2384.Representation = Representation;
      _this2384.Tag = Tag;
      _this2384.PredefinedType = PredefinedType;
      _this2384.type = 25142252;
      return _this2384;
    }

    return IfcController;
  }(IfcDistributionControlElement);

  IFC42.IfcController = IfcController;
})(IFC4 || (IFC4 = {})); // dist/helpers/properties.ts


var PropsNames = {
  aggregates: {
    name: IFCRELAGGREGATES,
    relating: "RelatingObject",
    related: "RelatedObjects",
    key: "children"
  },
  spatial: {
    name: IFCRELCONTAINEDINSPATIALSTRUCTURE,
    relating: "RelatingStructure",
    related: "RelatedElements",
    key: "children"
  },
  psets: {
    name: IFCRELDEFINESBYPROPERTIES,
    relating: "RelatingPropertyDefinition",
    related: "RelatedObjects",
    key: "IsDefinedBy"
  },
  materials: {
    name: IFCRELASSOCIATESMATERIAL,
    relating: "RelatingMaterial",
    related: "RelatedObjects",
    key: "HasAssociations"
  },
  type: {
    name: IFCRELDEFINESBYTYPE,
    relating: "RelatingType",
    related: "RelatedObjects",
    key: "IsDefinedBy"
  }
};

var Properties = /*#__PURE__*/function () {
  function Properties(api) {
    _classCallCheck2(this, Properties);

    this.api = api;
  }

  _createClass2(Properties, [{
    key: "getItemProperties",
    value: function getItemProperties(modelID, id) {
      var recursive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var inverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", this.api.GetLine(modelID, id, recursive, inverse));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "getPropertySets",
    value: function getPropertySets(modelID) {
      var elementID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var recursive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.getRelatedProperties(modelID, elementID, PropsNames.psets, recursive);

              case 2:
                return _context14.abrupt("return", _context14.sent);

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "setPropertySets",
    value: function setPropertySets(modelID, elementID, psetID) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", this.setItemProperties(modelID, elementID, psetID, PropsNames.psets));

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "getTypeProperties",
    value: function getTypeProperties(modelID, elementID) {
      var recursive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!(this.api.GetModelSchema(modelID) == "IFX2X3")) {
                  _context16.next = 6;
                  break;
                }

                _context16.next = 3;
                return this.getRelatedProperties(modelID, elementID, PropsNames.type, recursive);

              case 3:
                return _context16.abrupt("return", _context16.sent);

              case 6:
                _context16.next = 8;
                return this.getRelatedProperties(modelID, elementID, __spreadProps(__spreadValues({}, PropsNames.type), {
                  key: "IsTypedBy"
                }), recursive);

              case 8:
                return _context16.abrupt("return", _context16.sent);

              case 9:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getMaterialsProperties",
    value: function getMaterialsProperties(modelID) {
      var elementID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var recursive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.getRelatedProperties(modelID, elementID, PropsNames.materials, recursive);

              case 2:
                return _context17.abrupt("return", _context17.sent);

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "setMaterialsProperties",
    value: function setMaterialsProperties(modelID, elementID, materialID) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this.setItemProperties(modelID, elementID, materialID, PropsNames.materials));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee7, this);
      }));
    }
  }, {
    key: "getSpatialStructure",
    value: function getSpatialStructure(modelID) {
      var includeProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var chunks, allLines, projectID, project;
        return _regeneratorRuntime.wrap(function _callee8$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return this.getSpatialTreeChunks(modelID);

              case 2:
                chunks = _context19.sent;
                _context19.next = 5;
                return this.api.GetLineIDsWithType(modelID, IFCPROJECT);

              case 5:
                allLines = _context19.sent;
                projectID = allLines.get(0);
                project = Properties.newIfcProject(projectID);
                _context19.next = 10;
                return this.getSpatialNode(modelID, project, chunks, includeProperties);

              case 10:
                return _context19.abrupt("return", project);

              case 11:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }, {
    key: "getRelatedProperties",
    value: function getRelatedProperties(modelID, elementID, propsName) {
      var recursive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var result, rels, vec, _i345, _i346, propSetIds, x;

        return _regeneratorRuntime.wrap(function _callee9$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                result = [];
                rels = null;

                if (!(elementID !== 0)) {
                  _context20.next = 8;
                  break;
                }

                _context20.next = 5;
                return this.api.GetLine(modelID, elementID, false, true)[propsName.key];

              case 5:
                rels = _context20.sent;
                _context20.next = 11;
                break;

              case 8:
                vec = this.api.GetLineIDsWithType(modelID, propsName.name);
                rels = [];

                for (_i345 = 0; _i345 < vec.size(); ++_i345) {
                  rels.push({
                    value: vec.get(_i345)
                  });
                }

              case 11:
                if (!(rels == null)) {
                  _context20.next = 13;
                  break;
                }

                return _context20.abrupt("return", result);

              case 13:
                if (!Array.isArray(rels)) rels = [rels];
                _i346 = 0;

              case 15:
                if (!(_i346 < rels.length)) {
                  _context20.next = 35;
                  break;
                }

                _context20.next = 18;
                return this.api.GetLine(modelID, rels[_i346].value, false, false)[propsName.relating];

              case 18:
                propSetIds = _context20.sent;

                if (!(propSetIds == null)) {
                  _context20.next = 21;
                  break;
                }

                return _context20.abrupt("continue", 32);

              case 21:
                if (!Array.isArray(propSetIds)) propSetIds = [propSetIds];
                x = 0;

              case 23:
                if (!(x < propSetIds.length)) {
                  _context20.next = 32;
                  break;
                }

                _context20.t0 = result;
                _context20.next = 27;
                return this.api.GetLine(modelID, propSetIds[x].value, recursive);

              case 27:
                _context20.t1 = _context20.sent;

                _context20.t0.push.call(_context20.t0, _context20.t1);

              case 29:
                x++;
                _context20.next = 23;
                break;

              case 32:
                _i346++;
                _context20.next = 15;
                break;

              case 35:
                return _context20.abrupt("return", result);

              case 36:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "getChunks",
    value: function getChunks(modelID, chunks, propNames) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var relation, _i347, rel;

        return _regeneratorRuntime.wrap(function _callee10$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.api.GetLineIDsWithType(modelID, propNames.name, true);

              case 2:
                relation = _context21.sent;
                _i347 = 0;

              case 4:
                if (!(_i347 < relation.size())) {
                  _context21.next = 12;
                  break;
                }

                _context21.next = 7;
                return this.api.GetLine(modelID, relation.get(_i347), false);

              case 7:
                rel = _context21.sent;
                this.saveChunk(chunks, propNames, rel);

              case 9:
                _i347++;
                _context21.next = 4;
                break;

              case 12:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "getSpatialNode",
    value: function getSpatialNode(modelID, node, treeChunks, includeProperties) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return this.getChildren(modelID, node, treeChunks, PropsNames.aggregates, includeProperties);

              case 2:
                _context22.next = 4;
                return this.getChildren(modelID, node, treeChunks, PropsNames.spatial, includeProperties);

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee11, this);
      }));
    }
  }, {
    key: "getChildren",
    value: function getChildren(modelID, node, treeChunks, propNames, includeProperties) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var children, prop, nodes, _i348, child, node2, properties;

        return _regeneratorRuntime.wrap(function _callee12$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                children = treeChunks[node.expressID];

                if (!(children == void 0)) {
                  _context23.next = 3;
                  break;
                }

                return _context23.abrupt("return");

              case 3:
                prop = propNames.key;
                nodes = [];
                _i348 = 0;

              case 6:
                if (!(_i348 < children.length)) {
                  _context23.next = 20;
                  break;
                }

                child = children[_i348];
                node2 = this.newNode(child, this.api.GetLineType(modelID, child));

                if (!includeProperties) {
                  _context23.next = 14;
                  break;
                }

                _context23.next = 12;
                return this.getItemProperties(modelID, node2.expressID);

              case 12:
                properties = _context23.sent;
                node2 = __spreadValues(__spreadValues({}, properties), node2);

              case 14:
                _context23.next = 16;
                return this.getSpatialNode(modelID, node2, treeChunks, includeProperties);

              case 16:
                nodes.push(node2);

              case 17:
                _i348++;
                _context23.next = 6;
                break;

              case 20:
                node[prop] = nodes;

              case 21:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee12, this);
      }));
    }
  }, {
    key: "newNode",
    value: function newNode(id, type) {
      return {
        expressID: id,
        type: this.api.GetNameFromTypeCode(type),
        children: []
      };
    }
  }, {
    key: "getSpatialTreeChunks",
    value: function getSpatialTreeChunks(modelID) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var treeChunks;
        return _regeneratorRuntime.wrap(function _callee13$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                treeChunks = {};
                _context24.next = 3;
                return this.getChunks(modelID, treeChunks, PropsNames.aggregates);

              case 3:
                _context24.next = 5;
                return this.getChunks(modelID, treeChunks, PropsNames.spatial);

              case 5:
                return _context24.abrupt("return", treeChunks);

              case 6:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee13, this);
      }));
    }
  }, {
    key: "saveChunk",
    value: function saveChunk(chunks, propNames, rel) {
      var relating = rel[propNames.relating].value;
      var related = rel[propNames.related].map(function (r) {
        return r.value;
      });

      if (chunks[relating] == void 0) {
        chunks[relating] = related;
      } else {
        chunks[relating] = chunks[relating].concat(related);
      }
    }
  }, {
    key: "setItemProperties",
    value: function setItemProperties(modelID, elementID, propID, propsName) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var _this2385 = this;

        var foundRel, rels, elements, _iterator13, _step13, elID, element, relations, _i349, rel, _loop2, _i350, _elements;

        return _regeneratorRuntime.wrap(function _callee14$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!Array.isArray(elementID)) elementID = [elementID];
                if (!Array.isArray(propID)) propID = [propID];
                foundRel = 0;
                rels = [];
                elements = [];
                _iterator13 = _createForOfIteratorHelper(elementID);
                _context25.prev = 6;

                _iterator13.s();

              case 8:
                if ((_step13 = _iterator13.n()).done) {
                  _context25.next = 18;
                  break;
                }

                elID = _step13.value;
                _context25.next = 12;
                return this.api.GetLine(modelID, elID, false, true);

              case 12:
                element = _context25.sent;

                if (element[propsName.key]) {
                  _context25.next = 15;
                  break;
                }

                return _context25.abrupt("continue", 16);

              case 15:
                elements.push(element);

              case 16:
                _context25.next = 8;
                break;

              case 18:
                _context25.next = 23;
                break;

              case 20:
                _context25.prev = 20;
                _context25.t0 = _context25["catch"](6);

                _iterator13.e(_context25.t0);

              case 23:
                _context25.prev = 23;

                _iterator13.f();

                return _context25.finish(23);

              case 26:
                if (!(elements.length < 1)) {
                  _context25.next = 28;
                  break;
                }

                return _context25.abrupt("return", false);

              case 28:
                relations = this.api.GetLineIDsWithType(modelID, propsName.name);
                _i349 = 0;

              case 30:
                if (!(_i349 < relations.size())) {
                  _context25.next = 40;
                  break;
                }

                _context25.next = 33;
                return this.api.GetLine(modelID, relations.get(_i349));

              case 33:
                rel = _context25.sent;

                if (propID.includes(Number(rel[propsName.relating].value))) {
                  rels.push(rel);
                  foundRel++;
                }

                if (!(foundRel == propID.length)) {
                  _context25.next = 37;
                  break;
                }

                return _context25.abrupt("break", 40);

              case 37:
                ++_i349;
                _context25.next = 30;
                break;

              case 40:
                _loop2 = function _loop2() {
                  var element = _elements[_i350];

                  var _iterator14 = _createForOfIteratorHelper(rels),
                      _step14;

                  try {
                    var _loop3 = function _loop3() {
                      var rel = _step14.value;
                      if (!element[propsName.key].some(function (e) {
                        return e.value === rel.expressID;
                      })) element[propsName.key].push({
                        type: 5,
                        value: rel.expressID
                      });

                      if (!rel[propsName.related].some(function (e) {
                        return e.value === element.expressID;
                      })) {
                        rel[propsName.related].push({
                          type: 5,
                          value: element.expressID
                        });

                        _this2385.api.WriteLine(modelID, rel);
                      }
                    };

                    for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
                      _loop3();
                    }
                  } catch (err) {
                    _iterator14.e(err);
                  } finally {
                    _iterator14.f();
                  }

                  _this2385.api.WriteLine(modelID, element);
                };

                for (_i350 = 0, _elements = elements; _i350 < _elements.length; _i350++) {
                  _loop2();
                }

                return _context25.abrupt("return", true);

              case 43:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee14, this, [[6, 20, 23, 26]]);
      }));
    }
  }], [{
    key: "newIfcProject",
    value: function newIfcProject(id) {
      return {
        expressID: id,
        type: "IFCPROJECT",
        children: []
      };
    }
  }]);

  return Properties;
}(); // dist/helpers/log.ts


var LogLevel;

(function (LogLevel2) {
  LogLevel2[LogLevel2["LOG_LEVEL_DEBUG"] = 0] = "LOG_LEVEL_DEBUG";
  LogLevel2[LogLevel2["LOG_LEVEL_INFO"] = 1] = "LOG_LEVEL_INFO";
  LogLevel2[LogLevel2["LOG_LEVEL_WARN"] = 2] = "LOG_LEVEL_WARN";
  LogLevel2[LogLevel2["LOG_LEVEL_ERROR"] = 3] = "LOG_LEVEL_ERROR";
  LogLevel2[LogLevel2["LOG_LEVEL_OFF"] = 4] = "LOG_LEVEL_OFF";
})(LogLevel || (LogLevel = {}));

var Log = /*#__PURE__*/function () {
  function Log() {
    _classCallCheck2(this, Log);
  }

  _createClass2(Log, null, [{
    key: "setLogLevel",
    value: function setLogLevel(level) {
      this.logLevel = level;
    }
  }, {
    key: "log",
    value: function log(msg) {
      if (this.logLevel <= 3) {
        var _console;

        for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key8 = 1; _key8 < _len6; _key8++) {
          args[_key8 - 1] = arguments[_key8];
        }

        (_console = console).log.apply(_console, [msg].concat(args));
      }
    }
  }, {
    key: "debug",
    value: function debug(msg) {
      if (this.logLevel <= 0) {
        var _console2;

        for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key9 = 1; _key9 < _len7; _key9++) {
          args[_key9 - 1] = arguments[_key9];
        }

        (_console2 = console).trace.apply(_console2, ["DEBUG: ", msg].concat(args));
      }
    }
  }, {
    key: "info",
    value: function info(msg) {
      if (this.logLevel <= 1) {
        var _console3;

        for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key10 = 1; _key10 < _len8; _key10++) {
          args[_key10 - 1] = arguments[_key10];
        }

        (_console3 = console).info.apply(_console3, ["INFO: ", msg].concat(args));
      }
    }
  }, {
    key: "warn",
    value: function warn(msg) {
      if (this.logLevel <= 2) {
        var _console4;

        for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key11 = 1; _key11 < _len9; _key11++) {
          args[_key11 - 1] = arguments[_key11];
        }

        (_console4 = console).warn.apply(_console4, ["WARN: ", msg].concat(args));
      }
    }
  }, {
    key: "error",
    value: function error(msg) {
      if (this.logLevel <= 3) {
        var _console5;

        for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key12 = 1; _key12 < _len10; _key12++) {
          args[_key12 - 1] = arguments[_key12];
        }

        (_console5 = console).error.apply(_console5, ["ERROR: ", msg].concat(args));
      }
    }
  }]);

  return Log;
}();

Log.logLevel = 1; // dist/web-ifc-api.ts

var WebIFCWasm;

if (typeof self !== "undefined" && self.crossOriginIsolated) {
  try {
    WebIFCWasm = require_web_ifc_mt();
  } catch (ex) {
    WebIFCWasm = require_web_ifc();
  }
} else {
  WebIFCWasm = require_web_ifc();
}

var STRING = 1;

var IfcAPI2 = /*#__PURE__*/function () {
  function IfcAPI2() {
    _classCallCheck2(this, IfcAPI2);

    this.wasmModule = void 0;
    this.wasmPath = "";
    this.isWasmPathAbsolute = false;
    this.modelSchemaList = [];
    this.ifcGuidMap = new Map();
    this.properties = new Properties(this);
  }

  _createClass2(IfcAPI2, [{
    key: "Init",
    value: function Init(customLocateFileHandler) {
      return __async(this, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var _this2386 = this;

        var locateFileHandler;
        return _regeneratorRuntime.wrap(function _callee15$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                if (!WebIFCWasm) {
                  _context26.next = 7;
                  break;
                }

                locateFileHandler = function locateFileHandler(path, prefix) {
                  if (path.endsWith(".wasm")) {
                    if (_this2386.isWasmPathAbsolute) {
                      return _this2386.wasmPath + path;
                    }

                    return prefix + _this2386.wasmPath + path;
                  }

                  return prefix + path;
                };

                _context26.next = 4;
                return WebIFCWasm({
                  noInitialRun: true,
                  locateFile: customLocateFileHandler || locateFileHandler
                });

              case 4:
                this.wasmModule = _context26.sent;
                _context26.next = 8;
                break;

              case 7:
                Log.error("Could not find wasm module at './web-ifc' from web-ifc-api.ts");

              case 8:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "OpenModels",
    value: function OpenModels(dataSets, settings) {
      var s = __spreadValues({
        MEMORY_LIMIT: 3221225472
      }, settings);

      s.MEMORY_LIMIT = s.MEMORY_LIMIT / dataSets.length;
      var modelIDs = [];

      var _iterator15 = _createForOfIteratorHelper(dataSets),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var dataSet = _step15.value;
          modelIDs.push(this.OpenModel(dataSet, s));
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }

      return modelIDs;
    }
  }, {
    key: "OpenModel",
    value: function OpenModel(data, settings) {
      var _this2387 = this;

      var s = __spreadValues({
        COORDINATE_TO_ORIGIN: false,
        USE_FAST_BOOLS: true,
        CIRCLE_SEGMENTS_LOW: 5,
        CIRCLE_SEGMENTS_MEDIUM: 8,
        CIRCLE_SEGMENTS_HIGH: 12,
        BOOL_ABORT_THRESHOLD: 1e4,
        TAPE_SIZE: 67108864,
        MEMORY_LIMIT: 3221225472
      }, settings);

      var result = this.wasmModule.OpenModel(s, function (destPtr, offsetInSrc, destSize) {
        var srcSize = Math.min(data.byteLength - offsetInSrc, destSize);

        var dest = _this2387.wasmModule.HEAPU8.subarray(destPtr, destPtr + srcSize);

        var src = data.subarray(offsetInSrc, offsetInSrc + srcSize);
        dest.set(src);
        return srcSize;
      });
      this.modelSchemaList[result] = SchemaNames.indexOf(this.GetHeaderLine(result, FILE_SCHEMA).arguments[0][0].value);
      Log.info("Parsing Model using " + this.GetHeaderLine(result, FILE_SCHEMA).arguments[0][0].value + " Schema");
      return result;
    }
  }, {
    key: "GetModelSchema",
    value: function GetModelSchema(modelID) {
      return SchemaNames[this.modelSchemaList[modelID]];
    }
  }, {
    key: "CreateModel",
    value: function CreateModel(model, settings) {
      var _a, _b, _c;

      var s = __spreadValues({
        COORDINATE_TO_ORIGIN: false,
        USE_FAST_BOOLS: true,
        CIRCLE_SEGMENTS_LOW: 5,
        CIRCLE_SEGMENTS_MEDIUM: 8,
        CIRCLE_SEGMENTS_HIGH: 12,
        BOOL_ABORT_THRESHOLD: 1e4,
        TAPE_SIZE: 67108864,
        MEMORY_LIMIT: 3221225472
      }, settings);

      var result = this.wasmModule.CreateModel(s);
      this.modelSchemaList[result] = SchemaNames.indexOf(model.schema);
      var modelName = model.name || "web-ifc-model-" + result + ".ifc";
      var timestamp = new Date().toISOString().slice(0, 19);
      var description = ((_a = model.description) == null ? void 0 : _a.map(function (d) {
        return {
          type: STRING,
          value: d
        };
      })) || [{
        type: STRING,
        value: "ViewDefinition [CoordinationView]"
      }];
      var authors = ((_b = model.authors) == null ? void 0 : _b.map(function (a) {
        return {
          type: STRING,
          value: a
        };
      })) || [null];
      var orgs = ((_c = model.organizations) == null ? void 0 : _c.map(function (o) {
        return {
          type: STRING,
          value: o
        };
      })) || [null];
      var auth = model.authorization ? {
        type: STRING,
        value: model.authorization
      } : null;
      this.wasmModule.WriteHeaderLine(result, FILE_DESCRIPTION, [description, {
        type: STRING,
        value: "2;1"
      }]);
      this.wasmModule.WriteHeaderLine(result, FILE_NAME, [{
        type: STRING,
        value: modelName
      }, {
        type: STRING,
        value: timestamp
      }, authors, orgs, {
        type: STRING,
        value: "ifcjs/web-ifc-api"
      }, {
        type: STRING,
        value: "ifcjs/web-ifc-api"
      }, auth]);
      this.wasmModule.WriteHeaderLine(result, FILE_SCHEMA, [[{
        type: STRING,
        value: model.schema
      }]]);
      return result;
    }
  }, {
    key: "SaveModel",
    value: function SaveModel(modelID) {
      var _this2388 = this;

      var modelSize = this.wasmModule.GetModelSize(modelID);
      var headerBytes = 512;
      var dataBuffer = new Uint8Array(modelSize + headerBytes);
      var size = 0;
      this.wasmModule.SaveModel(modelID, function (srcPtr, srcSize) {
        var src = _this2388.wasmModule.HEAPU8.subarray(srcPtr, srcPtr + srcSize);

        size = srcSize;
        dataBuffer.set(src, 0);
      });
      var newBuffer = new Uint8Array(size);
      newBuffer.set(dataBuffer.subarray(0, size), 0);
      return newBuffer;
    }
  }, {
    key: "ExportFileAsIFC",
    value: function ExportFileAsIFC(modelID) {
      Log.warn("ExportFileAsIFC is deprecated, use SaveModel instead");
      return this.SaveModel(modelID);
    }
  }, {
    key: "GetGeometry",
    value: function GetGeometry(modelID, geometryExpressID) {
      return this.wasmModule.GetGeometry(modelID, geometryExpressID);
    }
  }, {
    key: "GetHeaderLine",
    value: function GetHeaderLine(modelID, headerType) {
      return this.wasmModule.GetHeaderLine(modelID, headerType);
    }
  }, {
    key: "GetAllTypesOfModel",
    value: function GetAllTypesOfModel(modelID) {
      var typesNames = [];
      var elements = Object.keys(FromRawLineData[this.modelSchemaList[modelID]]).map(function (e) {
        return parseInt(e);
      });

      for (var _i351 = 0; _i351 < elements.length; _i351++) {
        var lines = this.GetLineIDsWithType(modelID, elements[_i351]);
        if (lines.size() > 0) typesNames.push({
          typeID: elements[_i351],
          typeName: this.wasmModule.GetNameFromTypeCode(elements[_i351])
        });
      }

      return typesNames;
    }
  }, {
    key: "GetLine",
    value: function GetLine(modelID, expressID) {
      var flatten = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var inverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var expressCheck = this.wasmModule.ValidateExpressID(modelID, expressID);

      if (!expressCheck) {
        return;
      }

      var rawLineData = this.GetRawLineData(modelID, expressID);
      var lineData = FromRawLineData[this.modelSchemaList[modelID]][rawLineData.type](rawLineData.ID, rawLineData.arguments);

      if (flatten) {
        this.FlattenLine(modelID, lineData);
      }

      var inverseData = InversePropertyDef[this.modelSchemaList[modelID]][rawLineData.type];

      if (inverse && inverseData != null) {
        var _iterator16 = _createForOfIteratorHelper(inverseData),
            _step16;

        try {
          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
            var inverseProp = _step16.value;
            if (!inverseProp[3]) lineData[inverseProp[0]] = null;else lineData[inverseProp[0]] = [];
            var targetTypes = [inverseProp[1]];

            if (typeof InheritanceDef[this.modelSchemaList[modelID]][inverseProp[1]] != "undefined") {
              targetTypes = targetTypes.concat(InheritanceDef[this.modelSchemaList[modelID]][inverseProp[1]]);
            }

            var inverseIDs = this.wasmModule.GetInversePropertyForItem(modelID, expressID, targetTypes, inverseProp[2], inverseProp[3]);

            if (!inverseProp[3] && inverseIDs.size() > 0) {
              if (!flatten) lineData[inverseProp[0]] = {
                type: 5,
                value: inverseIDs.get(0)
              };else lineData[inverseProp[0]] = this.GetLine(modelID, inverseIDs.get(0));
            } else {
              for (var x = 0; x < inverseIDs.size(); x++) {
                if (!flatten) lineData[inverseProp[0]].push({
                  type: 5,
                  value: inverseIDs.get(x)
                });else lineData[inverseProp[0]].push(this.GetLine(modelID, inverseIDs.get(x)));
              }
            }
          }
        } catch (err) {
          _iterator16.e(err);
        } finally {
          _iterator16.f();
        }
      }

      return lineData;
    }
  }, {
    key: "GetNextExpressID",
    value: function GetNextExpressID(modelID, expressID) {
      return this.wasmModule.GetNextExpressID(modelID, expressID);
    }
  }, {
    key: "GetAndClearErrors",
    value: function GetAndClearErrors(modelID) {
      return this.wasmModule.GetAndClearErrors(modelID);
    }
  }, {
    key: "CreateIfcEntity",
    value: function CreateIfcEntity(modelID, type) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 2 ? _len11 - 2 : 0), _key13 = 2; _key13 < _len11; _key13++) {
        args[_key13 - 2] = arguments[_key13];
      }

      return Constructors[this.modelSchemaList[modelID]][type](-1, args);
    }
  }, {
    key: "CreateIfcType",
    value: function CreateIfcType(modelID, type, value) {
      return TypeInitialisers[this.modelSchemaList[modelID]][type](value);
    }
  }, {
    key: "GetNameFromTypeCode",
    value: function GetNameFromTypeCode(type) {
      return this.wasmModule.GetNameFromTypeCode(type);
    }
  }, {
    key: "GetTypeCodeFromName",
    value: function GetTypeCodeFromName(modelID, typeName) {
      return this.wasmModule.GetTypeCodeFromName(modelID, typeName);
    }
  }, {
    key: "IsIfcElement",
    value: function IsIfcElement(type) {
      return this.wasmModule.IsIfcElement(type);
    }
  }, {
    key: "GetIfcEntityList",
    value: function GetIfcEntityList(modelID) {
      return Object.keys(FromRawLineData[this.modelSchemaList[modelID]]).map(function (x) {
        return parseInt(x);
      });
    }
  }, {
    key: "WriteLine",
    value: function WriteLine(modelID, lineObject) {
      var property;

      for (property in lineObject) {
        var lineProperty = lineObject[property];

        if (lineProperty && lineProperty.expressID !== void 0) {
          this.WriteLine(modelID, lineProperty);
          lineObject[property] = new Handle(lineProperty.expressID);
        } else if (Array.isArray(lineProperty) && lineProperty.length > 0) {
          for (var _i352 = 0; _i352 < lineProperty.length; _i352++) {
            if (lineProperty[_i352].expressID !== void 0) {
              this.WriteLine(modelID, lineProperty[_i352]);
              lineObject[property][_i352] = new Handle(lineProperty[_i352].expressID);
            }
          }
        }
      }

      if (lineObject.expressID === void 0 || lineObject.expressID < 0) {
        lineObject.expressID = this.GetMaxExpressID(modelID) + 1;
      }

      var rawLineData = {
        ID: lineObject.expressID,
        type: lineObject.type,
        arguments: ToRawLineData[this.modelSchemaList[modelID]][lineObject.type](lineObject)
      };
      this.WriteRawLineData(modelID, rawLineData);
    }
  }, {
    key: "FlattenLine",
    value: function FlattenLine(modelID, line) {
      var _this2389 = this;

      Object.keys(line).forEach(function (propertyName) {
        var property = line[propertyName];

        if (property && property.type === 5) {
          if (property.value) line[propertyName] = _this2389.GetLine(modelID, property.value, true);
        } else if (Array.isArray(property) && property.length > 0 && property[0].type === 5) {
          for (var _i353 = 0; _i353 < property.length; _i353++) {
            if (property[_i353].value) line[propertyName][_i353] = _this2389.GetLine(modelID, property[_i353].value, true);
          }
        }
      });
    }
  }, {
    key: "GetRawLineData",
    value: function GetRawLineData(modelID, expressID) {
      return this.wasmModule.GetLine(modelID, expressID);
    }
  }, {
    key: "WriteRawLineData",
    value: function WriteRawLineData(modelID, data) {
      this.wasmModule.WriteLine(modelID, data.ID, data.type, data.arguments);
    }
  }, {
    key: "GetLineIDsWithType",
    value: function GetLineIDsWithType(modelID, type) {
      var includeInherited = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var types = [];
      types.push(type);

      if (includeInherited && typeof InheritanceDef[this.modelSchemaList[modelID]][type] != "undefined") {
        types = types.concat(InheritanceDef[this.modelSchemaList[modelID]][type]);
      }

      return this.wasmModule.GetLineIDsWithType(modelID, types);
    }
  }, {
    key: "GetAllLines",
    value: function GetAllLines(modelID) {
      return this.wasmModule.GetAllLines(modelID);
    }
  }, {
    key: "SetGeometryTransformation",
    value: function SetGeometryTransformation(modelID, transformationMatrix) {
      if (transformationMatrix.length != 16) {
        throw new Error("invalid matrix size: ".concat(transformationMatrix.length));
      }

      this.wasmModule.SetGeometryTransformation(modelID, transformationMatrix);
    }
  }, {
    key: "GetCoordinationMatrix",
    value: function GetCoordinationMatrix(modelID) {
      return this.wasmModule.GetCoordinationMatrix(modelID);
    }
  }, {
    key: "GetVertexArray",
    value: function GetVertexArray(ptr, size) {
      return this.getSubArray(this.wasmModule.HEAPF32, ptr, size);
    }
  }, {
    key: "GetIndexArray",
    value: function GetIndexArray(ptr, size) {
      return this.getSubArray(this.wasmModule.HEAPU32, ptr, size);
    }
  }, {
    key: "getSubArray",
    value: function getSubArray(heap, startPtr, sizeBytes) {
      return heap.subarray(startPtr / 4, startPtr / 4 + sizeBytes).slice(0);
    }
  }, {
    key: "CloseModel",
    value: function CloseModel(modelID) {
      this.ifcGuidMap.delete(modelID);
      this.wasmModule.CloseModel(modelID);
    }
  }, {
    key: "StreamAllMeshes",
    value: function StreamAllMeshes(modelID, meshCallback) {
      this.wasmModule.StreamAllMeshes(modelID, meshCallback);
    }
  }, {
    key: "StreamAllMeshesWithTypes",
    value: function StreamAllMeshesWithTypes(modelID, types, meshCallback) {
      this.wasmModule.StreamAllMeshesWithTypes(modelID, types, meshCallback);
    }
  }, {
    key: "IsModelOpen",
    value: function IsModelOpen(modelID) {
      return this.wasmModule.IsModelOpen(modelID);
    }
  }, {
    key: "LoadAllGeometry",
    value: function LoadAllGeometry(modelID) {
      return this.wasmModule.LoadAllGeometry(modelID);
    }
  }, {
    key: "GetFlatMesh",
    value: function GetFlatMesh(modelID, expressID) {
      return this.wasmModule.GetFlatMesh(modelID, expressID);
    }
  }, {
    key: "GetMaxExpressID",
    value: function GetMaxExpressID(modelID) {
      return this.wasmModule.GetMaxExpressID(modelID);
    }
  }, {
    key: "IncrementMaxExpressID",
    value: function IncrementMaxExpressID(modelID, incrementSize) {
      Log.warn("IncrementMaxExpressID is deprecated, use GetNextExpressID or GetMaxExpressID instead");
      return this.wasmModule.GetMaxExpressID(modelID) + incrementSize;
    }
  }, {
    key: "GetLineType",
    value: function GetLineType(modelID, expressID) {
      return this.wasmModule.GetLineType(modelID, expressID);
    }
  }, {
    key: "CreateIfcGuidToExpressIdMapping",
    value: function CreateIfcGuidToExpressIdMapping(modelID) {
      var map = new Map();
      var entities = this.GetIfcEntityList(modelID);

      var _iterator17 = _createForOfIteratorHelper(entities),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var typeId = _step17.value;
          var lines = this.GetLineIDsWithType(modelID, typeId);
          var size = lines.size();

          for (var y = 0; y < size; y++) {
            var expressID = lines.get(y);
            var info = this.GetLine(modelID, expressID);

            if (info.GlobalId == null) {
              continue;
            }

            var globalID = info.GlobalId.value;
            map.set(expressID, globalID);
            map.set(globalID, expressID);
          }
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }

      this.ifcGuidMap.set(modelID, map);
    }
  }, {
    key: "SetWasmPath",
    value: function SetWasmPath(path) {
      var absolute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.wasmPath = path;
      this.isWasmPathAbsolute = absolute;
    }
  }, {
    key: "SetLogLevel",
    value: function SetLogLevel(level) {
      Log.setLogLevel(level);
      this.wasmModule.SetLogLevel(level);
    }
  }]);

  return IfcAPI2;
}();
/**
 * @param  {Array<BufferGeometry>} geometries
 * @param  {Boolean} useGroups
 * @return {BufferGeometry}
 */


function mergeBufferGeometries(geometries) {
  var useGroups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isIndexed = geometries[0].index !== null;
  var attributesUsed = new Set(Object.keys(geometries[0].attributes));
  var morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
  var attributes = {};
  var morphAttributes = {};
  var morphTargetsRelative = geometries[0].morphTargetsRelative;
  var mergedGeometry = new BufferGeometry();
  var offset = 0;

  for (var _i354 = 0; _i354 < geometries.length; ++_i354) {
    var geometry = geometries[_i354];
    var attributesCount = 0; // ensure that all geometries are indexed, or none

    if (isIndexed !== (geometry.index !== null)) {
      console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + _i354 + '. All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.');
      return null;
    } // gather attributes, exit early if they're different


    for (var name in geometry.attributes) {
      if (!attributesUsed.has(name)) {
        console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + _i354 + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
        return null;
      }

      if (attributes[name] === undefined) attributes[name] = [];
      attributes[name].push(geometry.attributes[name]);
      attributesCount++;
    } // ensure geometries have the same number of attributes


    if (attributesCount !== attributesUsed.size) {
      console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + _i354 + '. Make sure all geometries have the same number of attributes.');
      return null;
    } // gather morph attributes, exit early if they're different


    if (morphTargetsRelative !== geometry.morphTargetsRelative) {
      console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + _i354 + '. .morphTargetsRelative must be consistent throughout all geometries.');
      return null;
    }

    for (var _name4 in geometry.morphAttributes) {
      if (!morphAttributesUsed.has(_name4)) {
        console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + _i354 + '.  .morphAttributes must be consistent throughout all geometries.');
        return null;
      }

      if (morphAttributes[_name4] === undefined) morphAttributes[_name4] = [];

      morphAttributes[_name4].push(geometry.morphAttributes[_name4]);
    } // gather .userData


    mergedGeometry.userData.mergedUserData = mergedGeometry.userData.mergedUserData || [];
    mergedGeometry.userData.mergedUserData.push(geometry.userData);

    if (useGroups) {
      var count = void 0;

      if (isIndexed) {
        count = geometry.index.count;
      } else if (geometry.attributes.position !== undefined) {
        count = geometry.attributes.position.count;
      } else {
        console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index ' + _i354 + '. The geometry must have either an index or a position attribute');
        return null;
      }

      mergedGeometry.addGroup(offset, count, _i354);
      offset += count;
    }
  } // merge indices


  if (isIndexed) {
    var indexOffset = 0;
    var mergedIndex = [];

    for (var _i355 = 0; _i355 < geometries.length; ++_i355) {
      var _index18 = geometries[_i355].index;

      for (var j = 0; j < _index18.count; ++j) {
        mergedIndex.push(_index18.getX(j) + indexOffset);
      }

      indexOffset += geometries[_i355].attributes.position.count;
    }

    mergedGeometry.setIndex(mergedIndex);
  } // merge attributes


  for (var _name5 in attributes) {
    var mergedAttribute = mergeBufferAttributes(attributes[_name5]);

    if (!mergedAttribute) {
      console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the ' + _name5 + ' attribute.');
      return null;
    }

    mergedGeometry.setAttribute(_name5, mergedAttribute);
  } // merge morph attributes


  for (var _name6 in morphAttributes) {
    var numMorphTargets = morphAttributes[_name6][0].length;
    if (numMorphTargets === 0) break;
    mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
    mergedGeometry.morphAttributes[_name6] = [];

    for (var _i356 = 0; _i356 < numMorphTargets; ++_i356) {
      var morphAttributesToMerge = [];

      for (var _j19 = 0; _j19 < morphAttributes[_name6].length; ++_j19) {
        morphAttributesToMerge.push(morphAttributes[_name6][_j19][_i356]);
      }

      var mergedMorphAttribute = mergeBufferAttributes(morphAttributesToMerge);

      if (!mergedMorphAttribute) {
        console.error('THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the ' + _name6 + ' morphAttribute.');
        return null;
      }

      mergedGeometry.morphAttributes[_name6].push(mergedMorphAttribute);
    }
  }

  return mergedGeometry;
}
/**
 * @param {Array<BufferAttribute>} attributes
 * @return {BufferAttribute}
 */


function mergeBufferAttributes(attributes) {
  var TypedArray;
  var itemSize;
  var normalized;
  var arrayLength = 0;

  for (var _i357 = 0; _i357 < attributes.length; ++_i357) {
    var attribute = attributes[_i357];

    if (attribute.isInterleavedBufferAttribute) {
      console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. InterleavedBufferAttributes are not supported.');
      return null;
    }

    if (TypedArray === undefined) TypedArray = attribute.array.constructor;

    if (TypedArray !== attribute.array.constructor) {
      console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.');
      return null;
    }

    if (itemSize === undefined) itemSize = attribute.itemSize;

    if (itemSize !== attribute.itemSize) {
      console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.');
      return null;
    }

    if (normalized === undefined) normalized = attribute.normalized;

    if (normalized !== attribute.normalized) {
      console.error('THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.');
      return null;
    }

    arrayLength += attribute.array.length;
  }

  var array = new TypedArray(arrayLength);
  var offset = 0;

  for (var _i358 = 0; _i358 < attributes.length; ++_i358) {
    array.set(attributes[_i358].array, offset);
    offset += attributes[_i358].array.length;
  }

  return new BufferAttribute(array, itemSize, normalized);
}

var nullIfcManagerErrorMessage = 'IfcManager is null!';

var IFCModel = /*#__PURE__*/function (_Mesh2) {
  _inherits(IFCModel, _Mesh2);

  var _super2393 = _createSuper(IFCModel);

  function IFCModel() {
    var _this2390;

    _classCallCheck2(this, IFCModel);

    _this2390 = _super2393.apply(this, arguments);
    _this2390.modelID = IFCModel.modelIdCounter++;
    _this2390.ifcManager = null;
    _this2390.mesh = _assertThisInitialized(_this2390);
    return _this2390;
  }

  _createClass2(IFCModel, [{
    key: "setIFCManager",
    value: function setIFCManager(manager) {
      this.ifcManager = manager;
    }
  }, {
    key: "setWasmPath",
    value: function setWasmPath(path) {
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);
      this.ifcManager.setWasmPath(path);
    }
  }, {
    key: "close",
    value: function close(scene) {
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);
      this.ifcManager.close(this.modelID, scene);
    }
  }, {
    key: "getExpressId",
    value: function getExpressId(geometry, faceIndex) {
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);
      return this.ifcManager.getExpressId(geometry, faceIndex);
    }
  }, {
    key: "getAllItemsOfType",
    value: function getAllItemsOfType(type, verbose) {
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);
      return this.ifcManager.getAllItemsOfType(this.modelID, type, verbose);
    }
  }, {
    key: "getItemProperties",
    value: function getItemProperties(id) {
      var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);
      return this.ifcManager.getItemProperties(this.modelID, id, recursive);
    }
  }, {
    key: "getPropertySets",
    value: function getPropertySets(id) {
      var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);
      return this.ifcManager.getPropertySets(this.modelID, id, recursive);
    }
  }, {
    key: "getTypeProperties",
    value: function getTypeProperties(id) {
      var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);
      return this.ifcManager.getTypeProperties(this.modelID, id, recursive);
    }
  }, {
    key: "getIfcType",
    value: function getIfcType(id) {
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);
      return this.ifcManager.getIfcType(this.modelID, id);
    }
  }, {
    key: "getSpatialStructure",
    value: function getSpatialStructure() {
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);
      return this.ifcManager.getSpatialStructure(this.modelID);
    }
  }, {
    key: "getSubset",
    value: function getSubset(material) {
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);
      return this.ifcManager.getSubset(this.modelID, material);
    }
  }, {
    key: "removeSubset",
    value: function removeSubset(material, customID) {
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);
      this.ifcManager.removeSubset(this.modelID, material, customID);
    }
  }, {
    key: "createSubset",
    value: function createSubset(config) {
      if (this.ifcManager === null) throw new Error(nullIfcManagerErrorMessage);

      var modelConfig = _objectSpread(_objectSpread({}, config), {}, {
        modelID: this.modelID
      });

      return this.ifcManager.createSubset(modelConfig);
    }
  }], [{
    key: "dispose",
    value: function dispose() {
      IFCModel.modelIdCounter = 0;
    }
  }]);

  return IFCModel;
}(Mesh);

IFCModel.modelIdCounter = 0;

var IFCParser = /*#__PURE__*/function () {
  function IFCParser(state, BVH) {
    var _this$optionalCategor;

    _classCallCheck2(this, IFCParser);

    this.state = state;
    this.BVH = BVH;
    this.loadedModels = 0;
    this.optionalCategories = (_this$optionalCategor = {}, _defineProperty(_this$optionalCategor, IFCSPACE, true), _defineProperty(_this$optionalCategor, IFCOPENINGELEMENT, false), _this$optionalCategor);
    this.geometriesByMaterials = {};
    this.loadingState = {
      total: 0,
      current: 0,
      step: 0.1
    };
    this.currentWebIfcID = -1;
    this.currentModelID = -1;
  }

  _createClass2(IFCParser, [{
    key: "setupOptionalCategories",
    value: function () {
      var _setupOptionalCategories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(config) {
        return _regeneratorRuntime.wrap(function _callee16$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                this.optionalCategories = config;

              case 1:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee16, this);
      }));

      function setupOptionalCategories(_x7) {
        return _setupOptionalCategories.apply(this, arguments);
      }

      return setupOptionalCategories;
    }()
  }, {
    key: "parse",
    value: function () {
      var _parse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(buffer, coordinationMatrix) {
        return _regeneratorRuntime.wrap(function _callee17$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                if (!(this.state.api.wasmModule === undefined)) {
                  _context28.next = 3;
                  break;
                }

                _context28.next = 3;
                return this.state.api.Init();

              case 3:
                _context28.next = 5;
                return this.newIfcModel(buffer);

              case 5:
                this.loadedModels++;

                if (!coordinationMatrix) {
                  _context28.next = 9;
                  break;
                }

                _context28.next = 9;
                return this.state.api.SetGeometryTransformation(this.currentWebIfcID, coordinationMatrix);

              case 9:
                return _context28.abrupt("return", this.loadAllGeometry(this.currentWebIfcID));

              case 10:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee17, this);
      }));

      function parse(_x8, _x9) {
        return _parse.apply(this, arguments);
      }

      return parse;
    }()
  }, {
    key: "getAndClearErrors",
    value: function getAndClearErrors(_modelId) {}
  }, {
    key: "notifyProgress",
    value: function notifyProgress(loaded, total) {
      if (this.state.onProgress) this.state.onProgress({
        loaded: loaded,
        total: total
      });
    }
  }, {
    key: "newIfcModel",
    value: function () {
      var _newIfcModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(buffer) {
        var data;
        return _regeneratorRuntime.wrap(function _callee18$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                data = new Uint8Array(buffer);
                _context29.next = 3;
                return this.state.api.OpenModel(data, this.state.webIfcSettings);

              case 3:
                this.currentWebIfcID = _context29.sent;
                this.currentModelID = this.state.useJSON ? this.loadedModels : this.currentWebIfcID;
                this.state.models[this.currentModelID] = {
                  modelID: this.currentModelID,
                  mesh: {},
                  types: {},
                  jsonData: {}
                };

              case 6:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee18, this);
      }));

      function newIfcModel(_x10) {
        return _newIfcModel.apply(this, arguments);
      }

      return newIfcModel;
    }()
  }, {
    key: "loadAllGeometry",
    value: function () {
      var _loadAllGeometry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(modelID) {
        var _this2391 = this;

        var geometries, materials, combinedGeometry, model;
        return _regeneratorRuntime.wrap(function _callee19$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                this.addOptionalCategories(modelID);
                _context30.next = 3;
                return this.initializeLoadingState(modelID);

              case 3:
                this.state.api.StreamAllMeshes(modelID, function (mesh) {
                  _this2391.updateLoadingState();

                  _this2391.streamMesh(modelID, mesh);
                });
                this.notifyLoadingEnded();
                geometries = [];
                materials = [];
                Object.keys(this.geometriesByMaterials).forEach(function (key) {
                  var geometriesByMaterial = _this2391.geometriesByMaterials[key].geometries;
                  var merged = mergeBufferGeometries(geometriesByMaterial);
                  materials.push(_this2391.geometriesByMaterials[key].material);
                  geometries.push(merged);
                });
                combinedGeometry = mergeBufferGeometries(geometries, true);
                this.cleanUpGeometryMemory(geometries);
                if (this.BVH) this.BVH.applyThreeMeshBVH(combinedGeometry);
                model = new IFCModel(combinedGeometry, materials);
                this.state.models[this.currentModelID].mesh = model;
                return _context30.abrupt("return", model);

              case 14:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee19, this);
      }));

      function loadAllGeometry(_x11) {
        return _loadAllGeometry.apply(this, arguments);
      }

      return loadAllGeometry;
    }()
  }, {
    key: "initializeLoadingState",
    value: function () {
      var _initializeLoadingState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(modelID) {
        var shapes;
        return _regeneratorRuntime.wrap(function _callee20$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.state.api.GetLineIDsWithType(modelID, IFCPRODUCTDEFINITIONSHAPE);

              case 2:
                shapes = _context31.sent;
                this.loadingState.total = shapes.size();
                this.loadingState.current = 0;
                this.loadingState.step = 0.1;

              case 6:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee20, this);
      }));

      function initializeLoadingState(_x12) {
        return _initializeLoadingState.apply(this, arguments);
      }

      return initializeLoadingState;
    }()
  }, {
    key: "notifyLoadingEnded",
    value: function notifyLoadingEnded() {
      this.notifyProgress(this.loadingState.total, this.loadingState.total);
    }
  }, {
    key: "updateLoadingState",
    value: function updateLoadingState() {
      var realCurrentItem = Math.min(this.loadingState.current++, this.loadingState.total);

      if (realCurrentItem / this.loadingState.total >= this.loadingState.step) {
        var currentProgress = Math.ceil(this.loadingState.total * this.loadingState.step);
        this.notifyProgress(currentProgress, this.loadingState.total);
        this.loadingState.step += 0.1;
      }
    }
  }, {
    key: "addOptionalCategories",
    value: function addOptionalCategories(modelID) {
      var _this2392 = this;

      var optionalTypes = [];

      for (var key in this.optionalCategories) {
        if (this.optionalCategories.hasOwnProperty(key)) {
          var category = parseInt(key);
          if (this.optionalCategories[category]) optionalTypes.push(category);
        }
      }

      this.state.api.StreamAllMeshesWithTypes(this.currentWebIfcID, optionalTypes, function (mesh) {
        _this2392.streamMesh(modelID, mesh);
      });
    }
  }, {
    key: "streamMesh",
    value: function streamMesh(modelID, mesh) {
      var placedGeometries = mesh.geometries;
      var size = placedGeometries.size();

      for (var _i359 = 0; _i359 < size; _i359++) {
        var placedGeometry = placedGeometries.get(_i359);
        var itemMesh = this.getPlacedGeometry(modelID, mesh.expressID, placedGeometry);
        var geom = itemMesh.geometry.applyMatrix4(itemMesh.matrix);
        this.storeGeometryByMaterial(placedGeometry.color, geom);
      }
    }
  }, {
    key: "getPlacedGeometry",
    value: function getPlacedGeometry(modelID, expressID, placedGeometry) {
      var geometry = this.getBufferGeometry(modelID, expressID, placedGeometry);
      var mesh = new Mesh(geometry);
      mesh.matrix = this.getMeshMatrix(placedGeometry.flatTransformation);
      mesh.matrixAutoUpdate = false;
      return mesh;
    }
  }, {
    key: "getBufferGeometry",
    value: function getBufferGeometry(modelID, expressID, placedGeometry) {
      var geometry = this.state.api.GetGeometry(modelID, placedGeometry.geometryExpressID);
      var verts = this.state.api.GetVertexArray(geometry.GetVertexData(), geometry.GetVertexDataSize());
      var indices = this.state.api.GetIndexArray(geometry.GetIndexData(), geometry.GetIndexDataSize());
      var buffer = this.ifcGeometryToBuffer(expressID, verts, indices);
      geometry.delete();
      return buffer;
    }
  }, {
    key: "storeGeometryByMaterial",
    value: function storeGeometryByMaterial(color, geometry) {
      var colID = "".concat(color.x).concat(color.y).concat(color.z).concat(color.w);

      if (this.geometriesByMaterials[colID]) {
        this.geometriesByMaterials[colID].geometries.push(geometry);
        return;
      }

      var col = new Color().setRGB(color.x, color.y, color.z, 'srgb');
      var material = new MeshLambertMaterial({
        color: col,
        side: DoubleSide
      });
      material.transparent = color.w !== 1;
      if (material.transparent) material.opacity = color.w;
      this.geometriesByMaterials[colID] = {
        material: material,
        geometries: [geometry]
      };
    }
  }, {
    key: "getMeshMatrix",
    value: function getMeshMatrix(matrix) {
      var mat = new Matrix4();
      mat.fromArray(matrix);
      return mat;
    }
  }, {
    key: "ifcGeometryToBuffer",
    value: function ifcGeometryToBuffer(expressID, vertexData, indexData) {
      var geometry = new BufferGeometry();
      var posFloats = new Float32Array(vertexData.length / 2);
      var normFloats = new Float32Array(vertexData.length / 2);
      var idAttribute = new Uint32Array(vertexData.length / 6);

      for (var _i360 = 0; _i360 < vertexData.length; _i360 += 6) {
        posFloats[_i360 / 2] = vertexData[_i360];
        posFloats[_i360 / 2 + 1] = vertexData[_i360 + 1];
        posFloats[_i360 / 2 + 2] = vertexData[_i360 + 2];
        normFloats[_i360 / 2] = vertexData[_i360 + 3];
        normFloats[_i360 / 2 + 1] = vertexData[_i360 + 4];
        normFloats[_i360 / 2 + 2] = vertexData[_i360 + 5];
        idAttribute[_i360 / 6] = expressID;
      }

      geometry.setAttribute('position', new BufferAttribute(posFloats, 3));
      geometry.setAttribute('normal', new BufferAttribute(normFloats, 3));
      geometry.setAttribute('expressID', new BufferAttribute(idAttribute, 1));
      geometry.setIndex(new BufferAttribute(indexData, 1));
      return geometry;
    }
  }, {
    key: "cleanUpGeometryMemory",
    value: function cleanUpGeometryMemory(geometries) {
      var _this2393 = this;

      geometries.forEach(function (geometry) {
        return geometry.dispose();
      });
      Object.keys(this.geometriesByMaterials).forEach(function (materialID) {
        var geometriesByMaterial = _this2393.geometriesByMaterials[materialID];
        geometriesByMaterial.geometries.forEach(function (geometry) {
          return geometry.dispose();
        });
        geometriesByMaterial.geometries = [];
        geometriesByMaterial.material = null;
      });
      this.geometriesByMaterials = {};
    }
  }]);

  return IFCParser;
}();

var ItemsMap = /*#__PURE__*/function () {
  function ItemsMap(state) {
    _classCallCheck2(this, ItemsMap);

    this.state = state;
    this.map = {};
  }

  _createClass2(ItemsMap, [{
    key: "generateGeometryIndexMap",
    value: function generateGeometryIndexMap(modelID) {
      if (this.map[modelID]) return;
      var geometry = this.getGeometry(modelID);
      var items = this.newItemsMap(modelID, geometry);

      var _iterator18 = _createForOfIteratorHelper(geometry.groups),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var group = _step18.value;
          this.fillItemsWithGroupInfo(group, geometry, items);
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
    }
  }, {
    key: "getSubsetID",
    value: function getSubsetID(modelID, material) {
      var customID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'DEFAULT';
      var baseID = modelID;
      var materialID = material ? material.uuid : 'DEFAULT';
      return "".concat(baseID, " - ").concat(materialID, " - ").concat(customID);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      Object.values(this.map).forEach(function (model) {
        model.indexCache = null;
        model.map = null;
      });
      this.map = null;
    }
  }, {
    key: "getGeometry",
    value: function getGeometry(modelID) {
      var geometry = this.state.models[modelID].mesh.geometry;
      if (!geometry) throw new Error('Model without geometry.');
      if (!geometry.index) throw new Error('Geometry must be indexed');
      return geometry;
    }
  }, {
    key: "newItemsMap",
    value: function newItemsMap(modelID, geometry) {
      var startIndices = geometry.index.array;
      this.map[modelID] = {
        indexCache: startIndices.slice(0, geometry.index.array.length),
        map: new Map()
      };
      return this.map[modelID];
    }
  }, {
    key: "fillItemsWithGroupInfo",
    value: function fillItemsWithGroupInfo(group, geometry, items) {
      var prevExpressID = -1;
      var materialIndex = group.materialIndex;
      var materialStart = group.start;
      var materialEnd = materialStart + group.count - 1;
      var objectStart = -1;
      var objectEnd = -1;

      for (var _i361 = materialStart; _i361 <= materialEnd; _i361++) {
        var _index19 = geometry.index.array[_i361];
        var bufferAttr = geometry.attributes.expressID;
        var expressID = bufferAttr.array[_index19];

        if (prevExpressID === -1) {
          prevExpressID = expressID;
          objectStart = _i361;
        }

        var isEndOfMaterial = _i361 === materialEnd;

        if (isEndOfMaterial) {
          var _store = this.getMaterialStore(items.map, expressID, materialIndex);

          _store.push(objectStart, materialEnd);

          break;
        }

        if (prevExpressID === expressID) continue;
        var store = this.getMaterialStore(items.map, prevExpressID, materialIndex);
        objectEnd = _i361 - 1;
        store.push(objectStart, objectEnd);
        prevExpressID = expressID;
        objectStart = _i361;
      }
    }
  }, {
    key: "getMaterialStore",
    value: function getMaterialStore(map, id, matIndex) {
      if (map.get(id) === undefined) {
        map.set(id, {});
      }

      var storedIfcItem = map.get(id);
      if (storedIfcItem === undefined) throw new Error('Geometry map generation error');

      if (storedIfcItem[matIndex] === undefined) {
        storedIfcItem[matIndex] = [];
      }

      return storedIfcItem[matIndex];
    }
  }]);

  return ItemsMap;
}();

var SubsetUtils = /*#__PURE__*/function () {
  function SubsetUtils() {
    _classCallCheck2(this, SubsetUtils);
  }

  _createClass2(SubsetUtils, null, [{
    key: "getAllIndicesOfGroup",
    value: function getAllIndicesOfGroup(modelID, ids, materialIndex, items) {
      var flatten = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var indicesByGroup = [];

      var _iterator19 = _createForOfIteratorHelper(ids),
          _step19;

      try {
        for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
          var expressID = _step19.value;
          var entry = items.map.get(expressID);
          if (!entry) continue;
          var _value5 = entry[materialIndex];
          if (!_value5) continue;
          SubsetUtils.getIndexChunk(_value5, indicesByGroup, materialIndex, items, flatten);
        }
      } catch (err) {
        _iterator19.e(err);
      } finally {
        _iterator19.f();
      }

      return indicesByGroup;
    }
  }, {
    key: "getIndexChunk",
    value: function getIndexChunk(value, indicesByGroup, materialIndex, items, flatten) {
      var pairs = value.length / 2;

      for (var pair = 0; pair < pairs; pair++) {
        var pairIndex = pair * 2;
        var start = value[pairIndex];
        var end = value[pairIndex + 1];

        for (var j = start; j <= end; j++) {
          if (flatten) indicesByGroup.push(items.indexCache[j]);else {
            if (!indicesByGroup[materialIndex]) indicesByGroup[materialIndex] = [];
            indicesByGroup[materialIndex].push(items.indexCache[j]);
          }
        }
      }
    }
  }]);

  return SubsetUtils;
}();

var SubsetCreator = /*#__PURE__*/function () {
  function SubsetCreator(state, items, subsets, BVH) {
    _classCallCheck2(this, SubsetCreator);

    this.state = state;
    this.items = items;
    this.subsets = subsets;
    this.BVH = BVH;
    this.tempIndex = [];
  }

  _createClass2(SubsetCreator, [{
    key: "createSubset",
    value: function createSubset(config, subsetID) {
      var _this2394 = this;

      if (!this.items.map[config.modelID]) this.items.generateGeometryIndexMap(config.modelID);
      if (!this.subsets[subsetID]) this.initializeSubset(config, subsetID);
      this.filterIndices(config, subsetID);
      this.constructSubsetByMaterial(config, subsetID);
      config.ids.forEach(function (id) {
        return _this2394.subsets[subsetID].ids.add(id);
      });
      this.subsets[subsetID].mesh.geometry.setIndex(this.tempIndex);
      this.tempIndex.length = 0;
      var subset = this.subsets[subsetID].mesh;
      if (config.applyBVH) this.BVH.applyThreeMeshBVH(subset.geometry);
      if (config.scene) config.scene.add(subset);
      return this.subsets[subsetID].mesh;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.tempIndex = [];
    }
  }, {
    key: "initializeSubset",
    value: function initializeSubset(config, subsetID) {
      var model = this.state.models[config.modelID].mesh;
      var subsetGeom = new BufferGeometry();
      this.initializeSubsetAttributes(subsetGeom, model);
      if (!config.material) this.initializeSubsetGroups(subsetGeom, model);
      var mesh = new Mesh(subsetGeom, config.material || model.material);
      mesh.modelID = config.modelID;
      var bvh = Boolean(config.applyBVH);
      this.subsets[subsetID] = {
        ids: new Set(),
        mesh: mesh,
        bvh: bvh
      };
      model.add(mesh);
    }
  }, {
    key: "initializeSubsetAttributes",
    value: function initializeSubsetAttributes(subsetGeom, model) {
      subsetGeom.setAttribute('position', model.geometry.attributes.position);
      subsetGeom.setAttribute('normal', model.geometry.attributes.normal);
      subsetGeom.setAttribute('expressID', model.geometry.attributes.expressID);
      subsetGeom.setIndex([]);
    }
  }, {
    key: "initializeSubsetGroups",
    value: function initializeSubsetGroups(subsetGeom, model) {
      subsetGeom.groups = JSON.parse(JSON.stringify(model.geometry.groups));
      this.resetGroups(subsetGeom);
    }
  }, {
    key: "filterIndices",
    value: function filterIndices(config, subsetID) {
      var geometry = this.subsets[subsetID].mesh.geometry;

      if (config.removePrevious) {
        geometry.setIndex([]);
        this.resetGroups(geometry);
        return;
      }

      var previousIndices = geometry.index.array;
      var previousIDs = this.subsets[subsetID].ids;
      config.ids = config.ids.filter(function (id) {
        return !previousIDs.has(id);
      });
      this.tempIndex = Array.from(previousIndices);
    }
  }, {
    key: "constructSubsetByMaterial",
    value: function constructSubsetByMaterial(config, subsetID) {
      var model = this.state.models[config.modelID].mesh;
      var newIndices = {
        count: 0
      };

      for (var _i362 = 0; _i362 < model.geometry.groups.length; _i362++) {
        this.insertNewIndices(config, subsetID, _i362, newIndices);
      }
    }
  }, {
    key: "insertNewIndices",
    value: function insertNewIndices(config, subsetID, materialIndex, newIndices) {
      var _this2395 = this;

      var items = this.items.map[config.modelID];
      var indicesOfOneMaterial = SubsetUtils.getAllIndicesOfGroup(config.modelID, config.ids, materialIndex, items);

      if (!config.material) {
        this.insertIndicesAtGroup(subsetID, indicesOfOneMaterial, materialIndex, newIndices);
      } else {
        indicesOfOneMaterial.forEach(function (index) {
          return _this2395.tempIndex.push(index);
        });
      }
    }
  }, {
    key: "insertIndicesAtGroup",
    value: function insertIndicesAtGroup(subsetID, indicesByGroup, index, newIndices) {
      var currentGroup = this.getCurrentGroup(subsetID, index);
      currentGroup.start += newIndices.count;
      var newIndicesPosition = currentGroup.start + currentGroup.count;
      newIndices.count += indicesByGroup.length;

      if (indicesByGroup.length > 0) {
        var position = newIndicesPosition;
        var start = this.tempIndex.slice(0, position);
        var end = this.tempIndex.slice(position);
        this.tempIndex = Array.prototype.concat.apply([], [start, indicesByGroup, end]);
        currentGroup.count += indicesByGroup.length;
      }
    }
  }, {
    key: "getCurrentGroup",
    value: function getCurrentGroup(subsetID, groupIndex) {
      var geometry = this.subsets[subsetID].mesh.geometry;
      return geometry.groups[groupIndex];
    }
  }, {
    key: "resetGroups",
    value: function resetGroups(geometry) {
      geometry.groups.forEach(function (group) {
        group.start = 0;
        group.count = 0;
      });
    }
  }]);

  return SubsetCreator;
}();

var SubsetManager = /*#__PURE__*/function () {
  function SubsetManager(state, BVH) {
    _classCallCheck2(this, SubsetManager);

    this.subsets = {};
    this.state = state;
    this.items = new ItemsMap(state);
    this.BVH = BVH;
    this.subsetCreator = new SubsetCreator(state, this.items, this.subsets, this.BVH);
  }

  _createClass2(SubsetManager, [{
    key: "getAllSubsets",
    value: function getAllSubsets() {
      return this.subsets;
    }
  }, {
    key: "getSubset",
    value: function getSubset(modelID, material, customId) {
      var subsetID = this.getSubsetID(modelID, material, customId);
      return this.subsets[subsetID].mesh;
    }
  }, {
    key: "removeSubset",
    value: function removeSubset(modelID, material, customID) {
      var subsetID = this.getSubsetID(modelID, material, customID);
      var subset = this.subsets[subsetID];
      if (!subset) return;
      if (subset.mesh.parent) subset.mesh.removeFromParent();
      subset.mesh.geometry.attributes = {};
      subset.mesh.geometry.index = null;
      subset.mesh.geometry.dispose();
      subset.mesh.geometry = null;
      delete this.subsets[subsetID];
    }
  }, {
    key: "createSubset",
    value: function createSubset(config) {
      var subsetID = this.getSubsetID(config.modelID, config.material, config.customID);
      return this.subsetCreator.createSubset(config, subsetID);
    }
  }, {
    key: "removeFromSubset",
    value: function removeFromSubset(modelID, ids, customID, material) {
      var subsetID = this.getSubsetID(modelID, material, customID);
      if (!this.subsets[subsetID]) return;
      var previousIDs = this.subsets[subsetID].ids;
      ids.forEach(function (id) {
        if (previousIDs.has(id)) previousIDs.delete(id);
      });
      return this.createSubset({
        modelID: modelID,
        removePrevious: true,
        material: material,
        customID: customID,
        applyBVH: this.subsets[subsetID].bvh,
        ids: Array.from(previousIDs),
        scene: this.subsets[subsetID].mesh.parent
      });
    }
  }, {
    key: "clearSubset",
    value: function clearSubset(modelID, customID, material) {
      var subsetID = this.getSubsetID(modelID, material, customID);
      if (!this.subsets[subsetID]) return;
      this.subsets[subsetID].ids.clear();
      var subset = this.getSubset(modelID, material, customID);
      subset.geometry.setIndex([]);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.items.dispose();
      this.subsetCreator.dispose();
      Object.values(this.subsets).forEach(function (subset) {
        subset.ids = null;
        subset.mesh.removeFromParent();
        var mats = subset.mesh.material;
        if (Array.isArray(mats)) mats.forEach(function (mat) {
          return mat.dispose();
        });else mats.dispose();
        subset.mesh.geometry.index = null;
        subset.mesh.geometry.dispose();
        var geom = subset.mesh.geometry;
        if (geom.disposeBoundsTree) geom.disposeBoundsTree();
        subset.mesh = null;
      });
      this.subsets = null;
    }
  }, {
    key: "getSubsetID",
    value: function getSubsetID(modelID, material) {
      var customID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'DEFAULT';
      var baseID = modelID;
      var materialID = material ? material.uuid : 'DEFAULT';
      return "".concat(baseID, " - ").concat(materialID, " - ").concat(customID);
    }
  }]);

  return SubsetManager;
}();

var IdAttrName = 'expressID';
var PropsNames$1 = {
  aggregates: {
    name: IFCRELAGGREGATES,
    relating: 'RelatingObject',
    related: 'RelatedObjects',
    key: 'children'
  },
  spatial: {
    name: IFCRELCONTAINEDINSPATIALSTRUCTURE,
    relating: 'RelatingStructure',
    related: 'RelatedElements',
    key: 'children'
  },
  psets: {
    name: IFCRELDEFINESBYPROPERTIES,
    relating: 'RelatingPropertyDefinition',
    related: 'RelatedObjects',
    key: 'hasPsets'
  },
  materials: {
    name: IFCRELASSOCIATESMATERIAL,
    relating: 'RelatingMaterial',
    related: 'RelatedObjects',
    key: 'hasMaterial'
  },
  type: {
    name: IFCRELDEFINESBYTYPE,
    relating: 'RelatingType',
    related: 'RelatedObjects',
    key: 'hasType'
  }
};

var BasePropertyManager = /*#__PURE__*/function () {
  function BasePropertyManager(state) {
    _classCallCheck2(this, BasePropertyManager);

    this.state = state;
  }

  _createClass2(BasePropertyManager, [{
    key: "getPropertySets",
    value: function () {
      var _getPropertySets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(modelID, elementID) {
        var recursive,
            _args31 = arguments;
        return _regeneratorRuntime.wrap(function _callee21$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                recursive = _args31.length > 2 && _args31[2] !== undefined ? _args31[2] : false;
                _context32.next = 3;
                return this.getProperty(modelID, elementID, recursive, PropsNames$1.psets);

              case 3:
                return _context32.abrupt("return", _context32.sent);

              case 4:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee21, this);
      }));

      function getPropertySets(_x13, _x14) {
        return _getPropertySets.apply(this, arguments);
      }

      return getPropertySets;
    }()
  }, {
    key: "getTypeProperties",
    value: function () {
      var _getTypeProperties = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(modelID, elementID) {
        var recursive,
            _args32 = arguments;
        return _regeneratorRuntime.wrap(function _callee22$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                recursive = _args32.length > 2 && _args32[2] !== undefined ? _args32[2] : false;
                _context33.next = 3;
                return this.getProperty(modelID, elementID, recursive, PropsNames$1.type);

              case 3:
                return _context33.abrupt("return", _context33.sent);

              case 4:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee22, this);
      }));

      function getTypeProperties(_x15, _x16) {
        return _getTypeProperties.apply(this, arguments);
      }

      return getTypeProperties;
    }()
  }, {
    key: "getMaterialsProperties",
    value: function () {
      var _getMaterialsProperties = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(modelID, elementID) {
        var recursive,
            _args33 = arguments;
        return _regeneratorRuntime.wrap(function _callee23$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                recursive = _args33.length > 2 && _args33[2] !== undefined ? _args33[2] : false;
                _context34.next = 3;
                return this.getProperty(modelID, elementID, recursive, PropsNames$1.materials);

              case 3:
                return _context34.abrupt("return", _context34.sent);

              case 4:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee23, this);
      }));

      function getMaterialsProperties(_x17, _x18) {
        return _getMaterialsProperties.apply(this, arguments);
      }

      return getMaterialsProperties;
    }()
  }, {
    key: "getSpatialNode",
    value: function () {
      var _getSpatialNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(modelID, node, treeChunks, includeProperties) {
        return _regeneratorRuntime.wrap(function _callee24$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return this.getChildren(modelID, node, treeChunks, PropsNames$1.aggregates, includeProperties);

              case 2:
                _context35.next = 4;
                return this.getChildren(modelID, node, treeChunks, PropsNames$1.spatial, includeProperties);

              case 4:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee24, this);
      }));

      function getSpatialNode(_x19, _x20, _x21, _x22) {
        return _getSpatialNode.apply(this, arguments);
      }

      return getSpatialNode;
    }()
  }, {
    key: "getChildren",
    value: function () {
      var _getChildren = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(modelID, node, treeChunks, propNames, includeProperties) {
        var children, prop, nodes, _i363, child, _node, properties;

        return _regeneratorRuntime.wrap(function _callee25$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                children = treeChunks[node.expressID];

                if (!(children == undefined)) {
                  _context36.next = 3;
                  break;
                }

                return _context36.abrupt("return");

              case 3:
                prop = propNames.key;
                nodes = [];
                _i363 = 0;

              case 6:
                if (!(_i363 < children.length)) {
                  _context36.next = 20;
                  break;
                }

                child = children[_i363];
                _node = this.newNode(modelID, child);

                if (!includeProperties) {
                  _context36.next = 14;
                  break;
                }

                _context36.next = 12;
                return this.getItemProperties(modelID, _node.expressID);

              case 12:
                properties = _context36.sent;
                _node = _objectSpread(_objectSpread({}, properties), _node);

              case 14:
                _context36.next = 16;
                return this.getSpatialNode(modelID, _node, treeChunks, includeProperties);

              case 16:
                nodes.push(_node);

              case 17:
                _i363++;
                _context36.next = 6;
                break;

              case 20:
                node[prop] = nodes;

              case 21:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee25, this);
      }));

      function getChildren(_x23, _x24, _x25, _x26, _x27) {
        return _getChildren.apply(this, arguments);
      }

      return getChildren;
    }()
  }, {
    key: "newNode",
    value: function newNode(modelID, id) {
      var typeName = this.getNodeType(modelID, id);
      return {
        expressID: id,
        type: typeName,
        children: []
      };
    }
  }, {
    key: "getSpatialTreeChunks",
    value: function () {
      var _getSpatialTreeChunks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(modelID) {
        var treeChunks;
        return _regeneratorRuntime.wrap(function _callee26$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                treeChunks = {};
                _context37.next = 3;
                return this.getChunks(modelID, treeChunks, PropsNames$1.aggregates);

              case 3:
                _context37.next = 5;
                return this.getChunks(modelID, treeChunks, PropsNames$1.spatial);

              case 5:
                return _context37.abrupt("return", treeChunks);

              case 6:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee26, this);
      }));

      function getSpatialTreeChunks(_x28) {
        return _getSpatialTreeChunks.apply(this, arguments);
      }

      return getSpatialTreeChunks;
    }()
  }, {
    key: "saveChunk",
    value: function saveChunk(chunks, propNames, rel) {
      var relating = rel[propNames.relating].value;
      var related = rel[propNames.related].map(function (r) {
        return r.value;
      });

      if (chunks[relating] == undefined) {
        chunks[relating] = related;
      } else {
        chunks[relating] = chunks[relating].concat(related);
      }
    }
  }, {
    key: "getRelated",
    value: function getRelated(rel, propNames, IDs) {
      var element = rel[propNames.relating];

      if (!element) {
        return console.warn("The object with ID ".concat(rel.expressID, " has a broken reference."));
      }

      if (!Array.isArray(element)) IDs.push(element.value);else element.forEach(function (ele) {
        return IDs.push(ele.value);
      });
    }
  }, {
    key: "getProperty",
    value: function () {
      var _getProperty = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(modelID, elementID) {
        var recursive,
            propName,
            _args37 = arguments;
        return _regeneratorRuntime.wrap(function _callee27$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                recursive = _args37.length > 2 && _args37[2] !== undefined ? _args37[2] : false;
                propName = _args37.length > 3 ? _args37[3] : undefined;

              case 2:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee27);
      }));

      function getProperty(_x29, _x30) {
        return _getProperty.apply(this, arguments);
      }

      return getProperty;
    }()
  }, {
    key: "getChunks",
    value: function () {
      var _getChunks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(modelID, chunks, propNames) {
        return _regeneratorRuntime.wrap(function _callee28$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee28);
      }));

      function getChunks(_x31, _x32, _x33) {
        return _getChunks.apply(this, arguments);
      }

      return getChunks;
    }()
  }, {
    key: "getItemProperties",
    value: function () {
      var _getItemProperties = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(modelID, expressID) {
        var recursive,
            _args39 = arguments;
        return _regeneratorRuntime.wrap(function _callee29$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                recursive = _args39.length > 2 && _args39[2] !== undefined ? _args39[2] : false;

              case 1:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee29);
      }));

      function getItemProperties(_x34, _x35) {
        return _getItemProperties.apply(this, arguments);
      }

      return getItemProperties;
    }()
  }, {
    key: "getNodeType",
    value: function getNodeType(modelID, id) {}
  }], [{
    key: "isRelated",
    value: function isRelated(id, rel, propNames) {
      var relatedItems = rel[propNames.related];

      if (Array.isArray(relatedItems)) {
        var values = relatedItems.map(function (item) {
          return item.value;
        });
        return values.includes(id);
      }

      return relatedItems.value === id;
    }
  }, {
    key: "newIfcProject",
    value: function newIfcProject(id) {
      return {
        expressID: id,
        type: 'IFCPROJECT',
        children: []
      };
    }
  }]);

  return BasePropertyManager;
}();

var WebIfcPropertyManager = /*#__PURE__*/function (_BasePropertyManager) {
  _inherits(WebIfcPropertyManager, _BasePropertyManager);

  var _super2394 = _createSuper(WebIfcPropertyManager);

  function WebIfcPropertyManager() {
    _classCallCheck2(this, WebIfcPropertyManager);

    return _super2394.apply(this, arguments);
  }

  _createClass2(WebIfcPropertyManager, [{
    key: "getItemProperties",
    value: function () {
      var _getItemProperties2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(modelID, id) {
        var recursive,
            _args40 = arguments;
        return _regeneratorRuntime.wrap(function _callee30$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                recursive = _args40.length > 2 && _args40[2] !== undefined ? _args40[2] : false;
                return _context41.abrupt("return", this.state.api.GetLine(modelID, id, recursive));

              case 2:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee30, this);
      }));

      function getItemProperties(_x36, _x37) {
        return _getItemProperties2.apply(this, arguments);
      }

      return getItemProperties;
    }()
  }, {
    key: "getHeaderLine",
    value: function () {
      var _getHeaderLine = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(modelID, headerType) {
        return _regeneratorRuntime.wrap(function _callee31$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                return _context42.abrupt("return", this.state.api.GetHeaderLine(modelID, headerType));

              case 1:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee31, this);
      }));

      function getHeaderLine(_x38, _x39) {
        return _getHeaderLine.apply(this, arguments);
      }

      return getHeaderLine;
    }()
  }, {
    key: "getSpatialStructure",
    value: function () {
      var _getSpatialStructure = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(modelID, includeProperties) {
        var chunks, allLines, projectID, project;
        return _regeneratorRuntime.wrap(function _callee32$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                _context43.next = 2;
                return this.getSpatialTreeChunks(modelID);

              case 2:
                chunks = _context43.sent;
                _context43.next = 5;
                return this.state.api.GetLineIDsWithType(modelID, IFCPROJECT);

              case 5:
                allLines = _context43.sent;
                projectID = allLines.get(0);
                project = WebIfcPropertyManager.newIfcProject(projectID);
                _context43.next = 10;
                return this.getSpatialNode(modelID, project, chunks, includeProperties);

              case 10:
                return _context43.abrupt("return", project);

              case 11:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee32, this);
      }));

      function getSpatialStructure(_x40, _x41) {
        return _getSpatialStructure.apply(this, arguments);
      }

      return getSpatialStructure;
    }()
  }, {
    key: "getAllItemsOfType",
    value: function () {
      var _getAllItemsOfType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(modelID, type, verbose) {
        var items, lines, _i364, result, _i365;

        return _regeneratorRuntime.wrap(function _callee33$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                items = [];
                _context44.next = 3;
                return this.state.api.GetLineIDsWithType(modelID, type);

              case 3:
                lines = _context44.sent;

                for (_i364 = 0; _i364 < lines.size(); _i364++) {
                  items.push(lines.get(_i364));
                }

                if (verbose) {
                  _context44.next = 7;
                  break;
                }

                return _context44.abrupt("return", items);

              case 7:
                result = [];
                _i365 = 0;

              case 9:
                if (!(_i365 < items.length)) {
                  _context44.next = 18;
                  break;
                }

                _context44.t0 = result;
                _context44.next = 13;
                return this.state.api.GetLine(modelID, items[_i365]);

              case 13:
                _context44.t1 = _context44.sent;

                _context44.t0.push.call(_context44.t0, _context44.t1);

              case 15:
                _i365++;
                _context44.next = 9;
                break;

              case 18:
                return _context44.abrupt("return", result);

              case 19:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee33, this);
      }));

      function getAllItemsOfType(_x42, _x43, _x44) {
        return _getAllItemsOfType.apply(this, arguments);
      }

      return getAllItemsOfType;
    }()
  }, {
    key: "getProperty",
    value: function () {
      var _getProperty2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(modelID, elementID) {
        var recursive,
            propName,
            propSetIds,
            result,
            _i366,
            _args44 = arguments;

        return _regeneratorRuntime.wrap(function _callee34$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                recursive = _args44.length > 2 && _args44[2] !== undefined ? _args44[2] : false;
                propName = _args44.length > 3 ? _args44[3] : undefined;
                _context45.next = 4;
                return this.getAllRelatedItemsOfType(modelID, elementID, propName);

              case 4:
                propSetIds = _context45.sent;
                result = [];
                _i366 = 0;

              case 7:
                if (!(_i366 < propSetIds.length)) {
                  _context45.next = 16;
                  break;
                }

                _context45.t0 = result;
                _context45.next = 11;
                return this.state.api.GetLine(modelID, propSetIds[_i366], recursive);

              case 11:
                _context45.t1 = _context45.sent;

                _context45.t0.push.call(_context45.t0, _context45.t1);

              case 13:
                _i366++;
                _context45.next = 7;
                break;

              case 16:
                return _context45.abrupt("return", result);

              case 17:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee34, this);
      }));

      function getProperty(_x45, _x46) {
        return _getProperty2.apply(this, arguments);
      }

      return getProperty;
    }()
  }, {
    key: "getNodeType",
    value: function getNodeType(modelID, id) {
      var typeID = this.state.models[modelID].types[id];
      return this.state.api.GetNameFromTypeCode(typeID);
    }
  }, {
    key: "getChunks",
    value: function () {
      var _getChunks2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(modelID, chunks, propNames) {
        var relation, _i367, rel;

        return _regeneratorRuntime.wrap(function _callee35$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.next = 2;
                return this.state.api.GetLineIDsWithType(modelID, propNames.name);

              case 2:
                relation = _context46.sent;
                _i367 = 0;

              case 4:
                if (!(_i367 < relation.size())) {
                  _context46.next = 12;
                  break;
                }

                _context46.next = 7;
                return this.state.api.GetLine(modelID, relation.get(_i367), false);

              case 7:
                rel = _context46.sent;
                this.saveChunk(chunks, propNames, rel);

              case 9:
                _i367++;
                _context46.next = 4;
                break;

              case 12:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee35, this);
      }));

      function getChunks(_x47, _x48, _x49) {
        return _getChunks2.apply(this, arguments);
      }

      return getChunks;
    }()
  }, {
    key: "getAllRelatedItemsOfType",
    value: function () {
      var _getAllRelatedItemsOfType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(modelID, id, propNames) {
        var lines, IDs, _i368, rel, isRelated;

        return _regeneratorRuntime.wrap(function _callee36$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                _context47.next = 2;
                return this.state.api.GetLineIDsWithType(modelID, propNames.name);

              case 2:
                lines = _context47.sent;
                IDs = [];
                _i368 = 0;

              case 5:
                if (!(_i368 < lines.size())) {
                  _context47.next = 14;
                  break;
                }

                _context47.next = 8;
                return this.state.api.GetLine(modelID, lines.get(_i368));

              case 8:
                rel = _context47.sent;
                isRelated = BasePropertyManager.isRelated(id, rel, propNames);
                if (isRelated) this.getRelated(rel, propNames, IDs);

              case 11:
                _i368++;
                _context47.next = 5;
                break;

              case 14:
                return _context47.abrupt("return", IDs);

              case 15:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee36, this);
      }));

      function getAllRelatedItemsOfType(_x50, _x51, _x52) {
        return _getAllRelatedItemsOfType.apply(this, arguments);
      }

      return getAllRelatedItemsOfType;
    }()
  }]);

  return WebIfcPropertyManager;
}(BasePropertyManager);

var JSONPropertyManager = /*#__PURE__*/function (_BasePropertyManager2) {
  _inherits(JSONPropertyManager, _BasePropertyManager2);

  var _super2395 = _createSuper(JSONPropertyManager);

  function JSONPropertyManager() {
    _classCallCheck2(this, JSONPropertyManager);

    return _super2395.apply(this, arguments);
  }

  _createClass2(JSONPropertyManager, [{
    key: "getItemProperties",
    value: function () {
      var _getItemProperties3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(modelID, id) {
        var recursive,
            _args47 = arguments;
        return _regeneratorRuntime.wrap(function _callee37$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                recursive = _args47.length > 2 && _args47[2] !== undefined ? _args47[2] : false;
                return _context48.abrupt("return", _objectSpread({}, this.state.models[modelID].jsonData[id]));

              case 2:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee37, this);
      }));

      function getItemProperties(_x53, _x54) {
        return _getItemProperties3.apply(this, arguments);
      }

      return getItemProperties;
    }()
  }, {
    key: "getHeaderLine",
    value: function () {
      var _getHeaderLine2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(modelID) {
        return _regeneratorRuntime.wrap(function _callee38$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                return _context49.abrupt("return", {});

              case 1:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee38);
      }));

      function getHeaderLine(_x55) {
        return _getHeaderLine2.apply(this, arguments);
      }

      return getHeaderLine;
    }()
  }, {
    key: "getSpatialStructure",
    value: function () {
      var _getSpatialStructure2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(modelID, includeProperties) {
        var chunks, projectsIDs, projectID, project;
        return _regeneratorRuntime.wrap(function _callee39$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _context50.next = 2;
                return this.getSpatialTreeChunks(modelID);

              case 2:
                chunks = _context50.sent;
                _context50.next = 5;
                return this.getAllItemsOfType(modelID, IFCPROJECT, false);

              case 5:
                projectsIDs = _context50.sent;
                projectID = projectsIDs[0];
                project = JSONPropertyManager.newIfcProject(projectID);
                _context50.next = 10;
                return this.getSpatialNode(modelID, project, chunks, includeProperties);

              case 10:
                return _context50.abrupt("return", _objectSpread({}, project));

              case 11:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee39, this);
      }));

      function getSpatialStructure(_x56, _x57) {
        return _getSpatialStructure2.apply(this, arguments);
      }

      return getSpatialStructure;
    }()
  }, {
    key: "getAllItemsOfType",
    value: function () {
      var _getAllItemsOfType2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(modelID, type, verbose) {
        var data, typeName;
        return _regeneratorRuntime.wrap(function _callee40$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                data = this.state.models[modelID].jsonData;
                _context51.next = 3;
                return this.state.api.GetNameFromTypeCode(type);

              case 3:
                typeName = _context51.sent;

                if (typeName) {
                  _context51.next = 6;
                  break;
                }

                throw new Error("Type not found: ".concat(type));

              case 6:
                return _context51.abrupt("return", this.filterItemsByType(data, typeName, verbose));

              case 7:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee40, this);
      }));

      function getAllItemsOfType(_x58, _x59, _x60) {
        return _getAllItemsOfType2.apply(this, arguments);
      }

      return getAllItemsOfType;
    }()
  }, {
    key: "getProperty",
    value: function () {
      var _getProperty3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(modelID, elementID) {
        var _this2396 = this;

        var recursive,
            propName,
            resultIDs,
            result,
            _args51 = arguments;
        return _regeneratorRuntime.wrap(function _callee41$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                recursive = _args51.length > 2 && _args51[2] !== undefined ? _args51[2] : false;
                propName = _args51.length > 3 ? _args51[3] : undefined;
                _context52.next = 4;
                return this.getAllRelatedItemsOfType(modelID, elementID, propName);

              case 4:
                resultIDs = _context52.sent;
                result = this.getItemsByID(modelID, resultIDs);

                if (recursive) {
                  result.forEach(function (result) {
                    return _this2396.getReferencesRecursively(modelID, result);
                  });
                }

                return _context52.abrupt("return", result);

              case 8:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee41, this);
      }));

      function getProperty(_x61, _x62) {
        return _getProperty3.apply(this, arguments);
      }

      return getProperty;
    }()
  }, {
    key: "getNodeType",
    value: function getNodeType(modelID, id) {
      return this.state.models[modelID].jsonData[id].type;
    }
  }, {
    key: "getChunks",
    value: function () {
      var _getChunks3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(modelID, chunks, propNames) {
        var _this2397 = this;

        var relation;
        return _regeneratorRuntime.wrap(function _callee42$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                _context53.next = 2;
                return this.getAllItemsOfType(modelID, propNames.name, true);

              case 2:
                relation = _context53.sent;
                relation.forEach(function (rel) {
                  _this2397.saveChunk(chunks, propNames, rel);
                });

              case 4:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee42, this);
      }));

      function getChunks(_x63, _x64, _x65) {
        return _getChunks3.apply(this, arguments);
      }

      return getChunks;
    }()
  }, {
    key: "filterItemsByType",
    value: function filterItemsByType(data, typeName, verbose) {
      var result = [];
      Object.keys(data).forEach(function (key) {
        var numKey = parseInt(key);

        if (data[numKey].type.toUpperCase() === typeName) {
          result.push(verbose ? _objectSpread({}, data[numKey]) : numKey);
        }
      });
      return result;
    }
  }, {
    key: "getAllRelatedItemsOfType",
    value: function () {
      var _getAllRelatedItemsOfType2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(modelID, id, propNames) {
        var _this2398 = this;

        var lines, IDs;
        return _regeneratorRuntime.wrap(function _callee43$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                _context54.next = 2;
                return this.getAllItemsOfType(modelID, propNames.name, true);

              case 2:
                lines = _context54.sent;
                IDs = [];
                lines.forEach(function (line) {
                  var isRelated = JSONPropertyManager.isRelated(id, line, propNames);
                  if (isRelated) _this2398.getRelated(line, propNames, IDs);
                });
                return _context54.abrupt("return", IDs);

              case 6:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee43, this);
      }));

      function getAllRelatedItemsOfType(_x66, _x67, _x68) {
        return _getAllRelatedItemsOfType2.apply(this, arguments);
      }

      return getAllRelatedItemsOfType;
    }()
  }, {
    key: "getItemsByID",
    value: function getItemsByID(modelID, ids) {
      var data = this.state.models[modelID].jsonData;
      var result = [];
      ids.forEach(function (id) {
        return result.push(_objectSpread({}, data[id]));
      });
      return result;
    }
  }, {
    key: "getReferencesRecursively",
    value: function getReferencesRecursively(modelID, jsonObject) {
      if (jsonObject == undefined) return;
      var keys = Object.keys(jsonObject);

      for (var _i369 = 0; _i369 < keys.length; _i369++) {
        var key = keys[_i369];
        this.getJSONItem(modelID, jsonObject, key);
      }
    }
  }, {
    key: "getJSONItem",
    value: function getJSONItem(modelID, jsonObject, key) {
      if (Array.isArray(jsonObject[key])) {
        return this.getMultipleJSONItems(modelID, jsonObject, key);
      }

      if (jsonObject[key] && jsonObject[key].type === 5) {
        jsonObject[key] = this.getItemsByID(modelID, [jsonObject[key].value])[0];
        this.getReferencesRecursively(modelID, jsonObject[key]);
      }
    }
  }, {
    key: "getMultipleJSONItems",
    value: function getMultipleJSONItems(modelID, jsonObject, key) {
      var _this2399 = this;

      jsonObject[key] = jsonObject[key].map(function (item) {
        if (item.type === 5) {
          item = _this2399.getItemsByID(modelID, [item.value])[0];

          _this2399.getReferencesRecursively(modelID, item);
        }

        return item;
      });
    }
  }]);

  return JSONPropertyManager;
}(BasePropertyManager);

var geometryTypes = new Set([1123145078, 574549367, 1675464909, 2059837836, 3798115385, 32440307, 3125803723, 3207858831, 2740243338, 2624227202, 4240577450, 3615266464, 3724593414, 220341763, 477187591, 1878645084, 1300840506, 3303107099, 1607154358, 1878645084, 846575682, 1351298697, 2417041796, 3049322572, 3331915920, 1416205885, 776857604, 3285139300, 3958052878, 2827736869, 2732653382, 673634403, 3448662350, 4142052618, 2924175390, 803316827, 2556980723, 1809719519, 2205249479, 807026263, 3737207727, 1660063152, 2347385850, 3940055652, 2705031697, 3732776249, 2485617015, 2611217952, 1704287377, 2937912522, 2770003689, 1281925730, 1484403080, 3448662350, 4142052618, 3800577675, 4006246654, 3590301190, 1383045692, 2775532180, 2047409740, 370225590, 3593883385, 2665983363, 4124623270, 812098782, 3649129432, 987898635, 1105321065, 3510044353, 1635779807, 2603310189, 3406155212, 1310608509, 4261334040, 2736907675, 3649129432, 1136057603, 1260505505, 4182860854, 2713105998, 2898889636, 59481748, 3749851601, 3486308946, 3150382593, 1062206242, 3264961684, 15328376, 1485152156, 370225590, 1981873012, 2859738748, 45288368, 2614616156, 2732653382, 775493141, 2147822146, 2601014836, 2629017746, 1186437898, 2367409068, 1213902940, 3632507154, 3900360178, 476780140, 1472233963, 2804161546, 3008276851, 738692330, 374418227, 315944413, 3905492369, 3570813810, 2571569899, 178912537, 2294589976, 1437953363, 2133299955, 572779678, 3092502836, 388784114, 2624227202, 1425443689, 3057273783, 2347385850, 1682466193, 2519244187, 2839578677, 3958567839, 2513912981, 2830218821, 427810014]);

var PropertySerializer = /*#__PURE__*/function () {
  function PropertySerializer(webIfc) {
    _classCallCheck2(this, PropertySerializer);

    this.webIfc = webIfc;
  }

  _createClass2(PropertySerializer, [{
    key: "dispose",
    value: function dispose() {
      this.webIfc = null;
    }
  }, {
    key: "serializeAllProperties",
    value: function () {
      var _serializeAllProperties = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(modelID, maxSize, event) {
        var blobs;
        return _regeneratorRuntime.wrap(function _callee44$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                blobs = [];
                _context55.next = 3;
                return this.getPropertiesAsBlobs(modelID, blobs, maxSize, event);

              case 3:
                return _context55.abrupt("return", blobs);

              case 4:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee44, this);
      }));

      function serializeAllProperties(_x69, _x70, _x71) {
        return _serializeAllProperties.apply(this, arguments);
      }

      return serializeAllProperties;
    }()
  }, {
    key: "getPropertiesAsBlobs",
    value: function () {
      var _getPropertiesAsBlobs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(modelID, blobs, maxSize, event) {
        var geometriesIDs, properties, allLinesIDs, linesCount, lastEvent, counter, _i370, id;

        return _regeneratorRuntime.wrap(function _callee45$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                _context56.next = 2;
                return this.getAllGeometriesIDs(modelID);

              case 2:
                geometriesIDs = _context56.sent;
                _context56.next = 5;
                return this.initializePropertiesObject(modelID);

              case 5:
                properties = _context56.sent;
                _context56.next = 8;
                return this.webIfc.GetAllLines(modelID);

              case 8:
                allLinesIDs = _context56.sent;
                linesCount = allLinesIDs.size();
                lastEvent = 0.1;
                counter = 0;
                _i370 = 0;

              case 13:
                if (!(_i370 < linesCount)) {
                  _context56.next = 24;
                  break;
                }

                id = allLinesIDs.get(_i370);

                if (geometriesIDs.has(id)) {
                  _context56.next = 19;
                  break;
                }

                _context56.next = 18;
                return this.getItemProperty(modelID, id, properties);

              case 18:
                counter++;

              case 19:
                if (maxSize && counter > maxSize) {
                  blobs.push(new Blob([JSON.stringify(properties)], {
                    type: 'application/json'
                  }));
                  properties = {};
                  counter = 0;
                }

                if (event && _i370 / linesCount > lastEvent) {
                  event(_i370, linesCount);
                  lastEvent += 0.1;
                }

              case 21:
                _i370++;
                _context56.next = 13;
                break;

              case 24:
                blobs.push(new Blob([JSON.stringify(properties)], {
                  type: 'application/json'
                }));

              case 25:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee45, this);
      }));

      function getPropertiesAsBlobs(_x72, _x73, _x74, _x75) {
        return _getPropertiesAsBlobs.apply(this, arguments);
      }

      return getPropertiesAsBlobs;
    }()
  }, {
    key: "getItemProperty",
    value: function () {
      var _getItemProperty = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(modelID, id, properties) {
        var props;
        return _regeneratorRuntime.wrap(function _callee46$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                _context57.prev = 0;
                _context57.next = 3;
                return this.webIfc.GetLine(modelID, id);

              case 3:
                props = _context57.sent;

                if (props.type) {
                  props.type = this.webIfc.GetNameFromTypeCode(props.type);
                }

                this.formatItemProperties(props);
                properties[id] = props;
                _context57.next = 12;
                break;

              case 9:
                _context57.prev = 9;
                _context57.t0 = _context57["catch"](0);
                console.log("There was a problem getting the properties of the item with ID ".concat(id));

              case 12:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee46, this, [[0, 9]]);
      }));

      function getItemProperty(_x76, _x77, _x78) {
        return _getItemProperty.apply(this, arguments);
      }

      return getItemProperty;
    }()
  }, {
    key: "formatItemProperties",
    value: function formatItemProperties(props) {
      Object.keys(props).forEach(function (key) {
        var value = props[key];
        if (value && value.value !== undefined) props[key] = value.value;else if (Array.isArray(value)) props[key] = value.map(function (item) {
          if (item && item.value) return item.value;
          return item;
        });
      });
    }
  }, {
    key: "initializePropertiesObject",
    value: function () {
      var _initializePropertiesObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(modelID) {
        return _regeneratorRuntime.wrap(function _callee47$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.next = 2;
                return this.webIfc.GetCoordinationMatrix(modelID);

              case 2:
                _context58.t0 = _context58.sent;
                _context58.next = 5;
                return this.getBuildingHeight(modelID);

              case 5:
                _context58.t1 = _context58.sent;
                return _context58.abrupt("return", {
                  coordinationMatrix: _context58.t0,
                  globalHeight: _context58.t1
                });

              case 7:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee47, this);
      }));

      function initializePropertiesObject(_x79) {
        return _initializePropertiesObject.apply(this, arguments);
      }

      return initializePropertiesObject;
    }()
  }, {
    key: "getBuildingHeight",
    value: function () {
      var _getBuildingHeight = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(modelID) {
        var building, placement, siteReference, transform;
        return _regeneratorRuntime.wrap(function _callee48$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.next = 2;
                return this.getBuilding(modelID);

              case 2:
                building = _context59.sent;
                siteReference = building.ObjectPlacement.PlacementRelTo;
                if (siteReference) placement = siteReference.RelativePlacement.Location;else placement = building.ObjectPlacement.RelativePlacement.Location;
                transform = placement.Coordinates.map(function (coord) {
                  return coord.value;
                });
                return _context59.abrupt("return", transform[2]);

              case 7:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee48, this);
      }));

      function getBuildingHeight(_x80) {
        return _getBuildingHeight.apply(this, arguments);
      }

      return getBuildingHeight;
    }()
  }, {
    key: "getBuilding",
    value: function () {
      var _getBuilding = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(modelID) {
        var allBuildingsIDs, buildingID;
        return _regeneratorRuntime.wrap(function _callee49$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.next = 2;
                return this.webIfc.GetLineIDsWithType(modelID, IFCBUILDING);

              case 2:
                allBuildingsIDs = _context60.sent;
                buildingID = allBuildingsIDs.get(0);
                return _context60.abrupt("return", this.webIfc.GetLine(modelID, buildingID, true));

              case 5:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee49, this);
      }));

      function getBuilding(_x81) {
        return _getBuilding.apply(this, arguments);
      }

      return getBuilding;
    }()
  }, {
    key: "getAllGeometriesIDs",
    value: function () {
      var _getAllGeometriesIDs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(modelID) {
        var geometriesIDs, geomTypesArray, _i371, category, ids, idsSize, j;

        return _regeneratorRuntime.wrap(function _callee50$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                geometriesIDs = new Set();
                geomTypesArray = Array.from(geometryTypes);
                _i371 = 0;

              case 3:
                if (!(_i371 < geomTypesArray.length)) {
                  _context61.next = 13;
                  break;
                }

                category = geomTypesArray[_i371];
                _context61.next = 7;
                return this.webIfc.GetLineIDsWithType(modelID, category);

              case 7:
                ids = _context61.sent;
                idsSize = ids.size();

                for (j = 0; j < idsSize; j++) {
                  geometriesIDs.add(ids.get(j));
                }

              case 10:
                _i371++;
                _context61.next = 3;
                break;

              case 13:
                return _context61.abrupt("return", geometriesIDs);

              case 14:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee50, this);
      }));

      function getAllGeometriesIDs(_x82) {
        return _getAllGeometriesIDs.apply(this, arguments);
      }

      return getAllGeometriesIDs;
    }()
  }]);

  return PropertySerializer;
}();

var PropertyManager = /*#__PURE__*/function () {
  function PropertyManager(state) {
    _classCallCheck2(this, PropertyManager);

    this.state = state;
    this.webIfcProps = new WebIfcPropertyManager(state);
    this.jsonProps = new JSONPropertyManager(state);
    this.currentProps = this.webIfcProps;
    this.serializer = new PropertySerializer(this.state.api);
  }

  _createClass2(PropertyManager, [{
    key: "getExpressId",
    value: function getExpressId(geometry, faceIndex) {
      if (!geometry.index) throw new Error('Geometry does not have index information.');
      var geoIndex = geometry.index.array;
      var bufferAttr = geometry.attributes[IdAttrName];
      return bufferAttr.getX(geoIndex[3 * faceIndex]);
    }
  }, {
    key: "getHeaderLine",
    value: function () {
      var _getHeaderLine3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(modelID, headerType) {
        return _regeneratorRuntime.wrap(function _callee51$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                this.updateCurrentProps();
                return _context62.abrupt("return", this.currentProps.getHeaderLine(modelID, headerType));

              case 2:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee51, this);
      }));

      function getHeaderLine(_x83, _x84) {
        return _getHeaderLine3.apply(this, arguments);
      }

      return getHeaderLine;
    }()
  }, {
    key: "getItemProperties",
    value: function () {
      var _getItemProperties4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(modelID, elementID) {
        var recursive,
            _args62 = arguments;
        return _regeneratorRuntime.wrap(function _callee52$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                recursive = _args62.length > 2 && _args62[2] !== undefined ? _args62[2] : false;
                this.updateCurrentProps();
                return _context63.abrupt("return", this.currentProps.getItemProperties(modelID, elementID, recursive));

              case 3:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee52, this);
      }));

      function getItemProperties(_x85, _x86) {
        return _getItemProperties4.apply(this, arguments);
      }

      return getItemProperties;
    }()
  }, {
    key: "getAllItemsOfType",
    value: function () {
      var _getAllItemsOfType3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(modelID, type, verbose) {
        return _regeneratorRuntime.wrap(function _callee53$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                this.updateCurrentProps();
                return _context64.abrupt("return", this.currentProps.getAllItemsOfType(modelID, type, verbose));

              case 2:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee53, this);
      }));

      function getAllItemsOfType(_x87, _x88, _x89) {
        return _getAllItemsOfType3.apply(this, arguments);
      }

      return getAllItemsOfType;
    }()
  }, {
    key: "getPropertySets",
    value: function () {
      var _getPropertySets2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(modelID, elementID) {
        var recursive,
            _args64 = arguments;
        return _regeneratorRuntime.wrap(function _callee54$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                recursive = _args64.length > 2 && _args64[2] !== undefined ? _args64[2] : false;
                this.updateCurrentProps();
                return _context65.abrupt("return", this.currentProps.getPropertySets(modelID, elementID, recursive));

              case 3:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee54, this);
      }));

      function getPropertySets(_x90, _x91) {
        return _getPropertySets2.apply(this, arguments);
      }

      return getPropertySets;
    }()
  }, {
    key: "getTypeProperties",
    value: function () {
      var _getTypeProperties2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(modelID, elementID) {
        var recursive,
            _args65 = arguments;
        return _regeneratorRuntime.wrap(function _callee55$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                recursive = _args65.length > 2 && _args65[2] !== undefined ? _args65[2] : false;
                this.updateCurrentProps();
                return _context66.abrupt("return", this.currentProps.getTypeProperties(modelID, elementID, recursive));

              case 3:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee55, this);
      }));

      function getTypeProperties(_x92, _x93) {
        return _getTypeProperties2.apply(this, arguments);
      }

      return getTypeProperties;
    }()
  }, {
    key: "getMaterialsProperties",
    value: function () {
      var _getMaterialsProperties2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(modelID, elementID) {
        var recursive,
            _args66 = arguments;
        return _regeneratorRuntime.wrap(function _callee56$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                recursive = _args66.length > 2 && _args66[2] !== undefined ? _args66[2] : false;
                this.updateCurrentProps();
                return _context67.abrupt("return", this.currentProps.getMaterialsProperties(modelID, elementID, recursive));

              case 3:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee56, this);
      }));

      function getMaterialsProperties(_x94, _x95) {
        return _getMaterialsProperties2.apply(this, arguments);
      }

      return getMaterialsProperties;
    }()
  }, {
    key: "getSpatialStructure",
    value: function () {
      var _getSpatialStructure3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(modelID, includeProperties) {
        return _regeneratorRuntime.wrap(function _callee57$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                this.updateCurrentProps();

                if (!this.state.useJSON && includeProperties) {
                  console.warn('Including properties in getSpatialStructure with the JSON workflow disabled can lead to poor performance.');
                }

                _context68.next = 4;
                return this.currentProps.getSpatialStructure(modelID, includeProperties);

              case 4:
                return _context68.abrupt("return", _context68.sent);

              case 5:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee57, this);
      }));

      function getSpatialStructure(_x96, _x97) {
        return _getSpatialStructure3.apply(this, arguments);
      }

      return getSpatialStructure;
    }()
  }, {
    key: "updateCurrentProps",
    value: function updateCurrentProps() {
      this.currentProps = this.state.useJSON ? this.jsonProps : this.webIfcProps;
    }
  }]);

  return PropertyManager;
}();

var TypeManager = /*#__PURE__*/function () {
  function TypeManager(state) {
    _classCallCheck2(this, TypeManager);

    this.state = state;
    this.state = state;
  }

  _createClass2(TypeManager, [{
    key: "getAllTypes",
    value: function () {
      var _getAllTypes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(worker) {
        var modelID, types;
        return _regeneratorRuntime.wrap(function _callee58$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                _context69.t0 = _regeneratorRuntime.keys(this.state.models);

              case 1:
                if ((_context69.t1 = _context69.t0()).done) {
                  _context69.next = 10;
                  break;
                }

                modelID = _context69.t1.value;

                if (!this.state.models.hasOwnProperty(modelID)) {
                  _context69.next = 8;
                  break;
                }

                types = this.state.models[modelID].types;

                if (!(Object.keys(types).length == 0)) {
                  _context69.next = 8;
                  break;
                }

                _context69.next = 8;
                return this.getAllTypesOfModel(parseInt(modelID), worker);

              case 8:
                _context69.next = 1;
                break;

              case 10:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee58, this);
      }));

      function getAllTypes(_x98) {
        return _getAllTypes.apply(this, arguments);
      }

      return getAllTypes;
    }()
  }, {
    key: "getAllTypesOfModel",
    value: function () {
      var _getAllTypesOfModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(modelID, worker) {
        var result, elements, _i372, element, lines, size, _i373;

        return _regeneratorRuntime.wrap(function _callee59$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                result = {};
                _context70.next = 3;
                return this.state.api.GetIfcEntityList(modelID);

              case 3:
                elements = _context70.sent;
                _i372 = 0;

              case 5:
                if (!(_i372 < elements.length)) {
                  _context70.next = 15;
                  break;
                }

                element = elements[_i372];
                _context70.next = 9;
                return this.state.api.GetLineIDsWithType(modelID, element);

              case 9:
                lines = _context70.sent;
                size = lines.size();

                for (_i373 = 0; _i373 < size; _i373++) {
                  result[lines.get(_i373)] = element;
                }

              case 12:
                _i372++;
                _context70.next = 5;
                break;

              case 15:
                if (!(this.state.worker.active && worker)) {
                  _context70.next = 18;
                  break;
                }

                _context70.next = 18;
                return worker.workerState.updateModelStateTypes(modelID, result);

              case 18:
                this.state.models[modelID].types = result;

              case 19:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee59, this);
      }));

      function getAllTypesOfModel(_x99, _x100) {
        return _getAllTypesOfModel.apply(this, arguments);
      }

      return getAllTypesOfModel;
    }()
  }]);

  return TypeManager;
}();

var BvhManager = /*#__PURE__*/function () {
  function BvhManager() {
    _classCallCheck2(this, BvhManager);
  }

  _createClass2(BvhManager, [{
    key: "initializeMeshBVH",
    value: function initializeMeshBVH(computeBoundsTree, disposeBoundsTree, acceleratedRaycast) {
      this.computeBoundsTree = computeBoundsTree;
      this.disposeBoundsTree = disposeBoundsTree;
      this.acceleratedRaycast = acceleratedRaycast;
      this.setupThreeMeshBVH();
    }
  }, {
    key: "applyThreeMeshBVH",
    value: function applyThreeMeshBVH(geometry) {
      if (this.computeBoundsTree) geometry.computeBoundsTree();
    }
  }, {
    key: "setupThreeMeshBVH",
    value: function setupThreeMeshBVH() {
      if (!this.computeBoundsTree || !this.disposeBoundsTree || !this.acceleratedRaycast) return;
      BufferGeometry.prototype.computeBoundsTree = this.computeBoundsTree;
      BufferGeometry.prototype.disposeBoundsTree = this.disposeBoundsTree;
      Mesh.prototype.raycast = this.acceleratedRaycast;
    }
  }]);

  return BvhManager;
}();

var WorkerActions;

(function (WorkerActions) {
  WorkerActions['updateStateUseJson'] = 'updateStateUseJson';
  WorkerActions['updateStateWebIfcSettings'] = 'updateStateWebIfcSettings';
  WorkerActions['updateModelStateTypes'] = 'updateModelStateTypes';
  WorkerActions['updateModelStateJsonData'] = 'updateModelStateJsonData';
  WorkerActions['loadJsonDataFromWorker'] = 'loadJsonDataFromWorker';
  WorkerActions['dispose'] = 'dispose';
  WorkerActions['Close'] = 'Close';
  WorkerActions['DisposeWebIfc'] = 'DisposeWebIfc';
  WorkerActions['Init'] = 'Init';
  WorkerActions['OpenModel'] = 'OpenModel';
  WorkerActions['CreateModel'] = 'CreateModel';
  WorkerActions['ExportFileAsIFC'] = 'ExportFileAsIFC';
  WorkerActions['GetGeometry'] = 'GetGeometry';
  WorkerActions['GetLine'] = 'GetLine';
  WorkerActions['GetAndClearErrors'] = 'GetAndClearErrors';
  WorkerActions['WriteLine'] = 'WriteLine';
  WorkerActions['FlattenLine'] = 'FlattenLine';
  WorkerActions['GetRawLineData'] = 'GetRawLineData';
  WorkerActions['WriteRawLineData'] = 'WriteRawLineData';
  WorkerActions['GetLineIDsWithType'] = 'GetLineIDsWithType';
  WorkerActions['GetAllLines'] = 'GetAllLines';
  WorkerActions['SetGeometryTransformation'] = 'SetGeometryTransformation';
  WorkerActions['GetCoordinationMatrix'] = 'GetCoordinationMatrix';
  WorkerActions['GetVertexArray'] = 'GetVertexArray';
  WorkerActions['GetIndexArray'] = 'GetIndexArray';
  WorkerActions['getSubArray'] = 'getSubArray';
  WorkerActions['CloseModel'] = 'CloseModel';
  WorkerActions['StreamAllMeshes'] = 'StreamAllMeshes';
  WorkerActions['StreamAllMeshesWithTypes'] = 'StreamAllMeshesWithTypes';
  WorkerActions['IsModelOpen'] = 'IsModelOpen';
  WorkerActions['LoadAllGeometry'] = 'LoadAllGeometry';
  WorkerActions['GetFlatMesh'] = 'GetFlatMesh';
  WorkerActions['SetWasmPath'] = 'SetWasmPath';
  WorkerActions['GetNameFromTypeCode'] = 'GetNameFromTypeCode';
  WorkerActions['GetIfcEntityList'] = 'GetIfcEntityList';
  WorkerActions['GetTypeCodeFromName'] = 'GetTypeCodeFromName';
  WorkerActions['parse'] = 'parse';
  WorkerActions['setupOptionalCategories'] = 'setupOptionalCategories';
  WorkerActions['getExpressId'] = 'getExpressId';
  WorkerActions['initializeProperties'] = 'initializeProperties';
  WorkerActions['getAllItemsOfType'] = 'getAllItemsOfType';
  WorkerActions['getItemProperties'] = 'getItemProperties';
  WorkerActions['getMaterialsProperties'] = 'getMaterialsProperties';
  WorkerActions['getPropertySets'] = 'getPropertySets';
  WorkerActions['getSpatialStructure'] = 'getSpatialStructure';
  WorkerActions['getTypeProperties'] = 'getTypeProperties';
  WorkerActions['getHeaderLine'] = 'getHeaderLine';
})(WorkerActions || (WorkerActions = {}));

var WorkerAPIs;

(function (WorkerAPIs) {
  WorkerAPIs['workerState'] = 'workerState';
  WorkerAPIs['webIfc'] = 'webIfc';
  WorkerAPIs['properties'] = 'properties';
  WorkerAPIs['parser'] = 'parser';
})(WorkerAPIs || (WorkerAPIs = {}));

var Vector$2 = /*#__PURE__*/function () {
  function Vector$2(vector) {
    var _this2400 = this;

    _classCallCheck2(this, Vector$2);

    this._data = {};
    this._size = vector.size;
    var keys = Object.keys(vector).filter(function (key) {
      return key.indexOf('size') === -1;
    }).map(function (key) {
      return parseInt(key);
    });
    keys.forEach(function (key) {
      return _this2400._data[key] = vector[key];
    });
  }

  _createClass2(Vector$2, [{
    key: "size",
    value: function size() {
      return this._size;
    }
  }, {
    key: "get",
    value: function get(index) {
      return this._data[index];
    }
  }]);

  return Vector$2;
}();

var IfcGeometry = /*#__PURE__*/function () {
  function IfcGeometry(vector) {
    _classCallCheck2(this, IfcGeometry);

    this._GetVertexData = vector.GetVertexData;
    this._GetVertexDataSize = vector.GetVertexDataSize;
    this._GetIndexData = vector.GetIndexData;
    this._GetIndexDataSize = vector.GetIndexDataSize;
  }

  _createClass2(IfcGeometry, [{
    key: "GetVertexData",
    value: function GetVertexData() {
      return this._GetVertexData;
    }
  }, {
    key: "GetVertexDataSize",
    value: function GetVertexDataSize() {
      return this._GetVertexDataSize;
    }
  }, {
    key: "GetIndexData",
    value: function GetIndexData() {
      return this._GetIndexData;
    }
  }, {
    key: "GetIndexDataSize",
    value: function GetIndexDataSize() {
      return this._GetIndexDataSize;
    }
  }]);

  return IfcGeometry;
}();

var FlatMesh = function FlatMesh(serializer, flatMesh) {
  _classCallCheck2(this, FlatMesh);

  this.expressID = flatMesh.expressID;
  this.geometries = serializer.reconstructVector(flatMesh.geometries);
};

var FlatMeshVector = /*#__PURE__*/function () {
  function FlatMeshVector(serializer, vector) {
    var _this2401 = this;

    _classCallCheck2(this, FlatMeshVector);

    this._data = {};
    this._size = vector.size;
    var keys = Object.keys(vector).filter(function (key) {
      return key.indexOf('size') === -1;
    }).map(function (key) {
      return parseInt(key);
    });
    keys.forEach(function (key) {
      return _this2401._data[key] = serializer.reconstructFlatMesh(vector[key]);
    });
  }

  _createClass2(FlatMeshVector, [{
    key: "size",
    value: function size() {
      return this._size;
    }
  }, {
    key: "get",
    value: function get(index) {
      return this._data[index];
    }
  }]);

  return FlatMeshVector;
}();

var SerializedMaterial = function SerializedMaterial(material) {
  _classCallCheck2(this, SerializedMaterial);

  this.color = [material.color.r, material.color.g, material.color.b];
  this.opacity = material.opacity;
  this.transparent = material.transparent;
};

var MaterialReconstructor = /*#__PURE__*/function () {
  function MaterialReconstructor() {
    _classCallCheck2(this, MaterialReconstructor);
  }

  _createClass2(MaterialReconstructor, null, [{
    key: "new",
    value: function _new(material) {
      return new MeshLambertMaterial({
        color: new Color(material.color[0], material.color[1], material.color[2]),
        opacity: material.opacity,
        transparent: material.transparent,
        side: DoubleSide
      });
    }
  }]);

  return MaterialReconstructor;
}();

var SerializedGeometry = function SerializedGeometry(geometry) {
  _classCallCheck2(this, SerializedGeometry);

  var _a, _b, _c, _d;

  this.position = ((_a = geometry.attributes.position) === null || _a === void 0 ? void 0 : _a.array) || [];
  this.normal = ((_b = geometry.attributes.normal) === null || _b === void 0 ? void 0 : _b.array) || [];
  this.expressID = ((_c = geometry.attributes.expressID) === null || _c === void 0 ? void 0 : _c.array) || [];
  this.index = ((_d = geometry.index) === null || _d === void 0 ? void 0 : _d.array) || [];
  this.groups = geometry.groups;
};

var GeometryReconstructor = /*#__PURE__*/function () {
  function GeometryReconstructor() {
    _classCallCheck2(this, GeometryReconstructor);
  }

  _createClass2(GeometryReconstructor, null, [{
    key: "new",
    value: function _new(serialized) {
      var geom = new BufferGeometry();
      GeometryReconstructor.set(geom, 'expressID', new Uint32Array(serialized.expressID), 1);
      GeometryReconstructor.set(geom, 'position', new Float32Array(serialized.position), 3);
      GeometryReconstructor.set(geom, 'normal', new Float32Array(serialized.normal), 3);
      geom.setIndex(Array.from(serialized.index));
      geom.groups = serialized.groups;
      return geom;
    }
  }, {
    key: "set",
    value: function set(geom, name, data, size) {
      if (data.length > 0) {
        geom.setAttribute(name, new BufferAttribute(data, size));
      }
    }
  }]);

  return GeometryReconstructor;
}();

var SerializedMesh = function SerializedMesh(model) {
  var _this2402 = this;

  _classCallCheck2(this, SerializedMesh);

  this.materials = [];
  this.modelID = model.modelID;
  this.geometry = new SerializedGeometry(model.geometry);

  if (Array.isArray(model.material)) {
    model.material.forEach(function (mat) {
      _this2402.materials.push(new SerializedMaterial(mat));
    });
  } else {
    this.materials.push(new SerializedMaterial(model.material));
  }
};

var MeshReconstructor = /*#__PURE__*/function () {
  function MeshReconstructor() {
    _classCallCheck2(this, MeshReconstructor);
  }

  _createClass2(MeshReconstructor, null, [{
    key: "new",
    value: function _new(serialized) {
      var model = new IFCModel();
      model.modelID = serialized.modelID;
      model.geometry = GeometryReconstructor.new(serialized.geometry);
      MeshReconstructor.getMaterials(serialized, model);
      return model;
    }
  }, {
    key: "getMaterials",
    value: function getMaterials(serialized, model) {
      model.material = [];
      var mats = model.material;
      serialized.materials.forEach(function (mat) {
        mats.push(MaterialReconstructor.new(mat));
      });
    }
  }]);

  return MeshReconstructor;
}();

var Serializer = /*#__PURE__*/function () {
  function Serializer() {
    _classCallCheck2(this, Serializer);
  }

  _createClass2(Serializer, [{
    key: "serializeVector",
    value: function serializeVector(vector) {
      var size = vector.size();
      var serialized = {
        size: size
      };

      for (var _i374 = 0; _i374 < size; _i374++) {
        serialized[_i374] = vector.get(_i374);
      }

      return serialized;
    }
  }, {
    key: "reconstructVector",
    value: function reconstructVector(vector) {
      return new Vector$2(vector);
    }
  }, {
    key: "serializeIfcGeometry",
    value: function serializeIfcGeometry(geometry) {
      var GetVertexData = geometry.GetVertexData();
      var GetVertexDataSize = geometry.GetVertexDataSize();
      var GetIndexData = geometry.GetIndexData();
      var GetIndexDataSize = geometry.GetIndexDataSize();
      return {
        GetVertexData: GetVertexData,
        GetVertexDataSize: GetVertexDataSize,
        GetIndexData: GetIndexData,
        GetIndexDataSize: GetIndexDataSize
      };
    }
  }, {
    key: "reconstructIfcGeometry",
    value: function reconstructIfcGeometry(geometry) {
      return new IfcGeometry(geometry);
    }
  }, {
    key: "serializeFlatMesh",
    value: function serializeFlatMesh(flatMesh) {
      return {
        expressID: flatMesh.expressID,
        geometries: this.serializeVector(flatMesh.geometries)
      };
    }
  }, {
    key: "reconstructFlatMesh",
    value: function reconstructFlatMesh(flatMesh) {
      return new FlatMesh(this, flatMesh);
    }
  }, {
    key: "serializeFlatMeshVector",
    value: function serializeFlatMeshVector(vector) {
      var size = vector.size();
      var serialized = {
        size: size
      };

      for (var _i375 = 0; _i375 < size; _i375++) {
        var flatMesh = vector.get(_i375);
        serialized[_i375] = this.serializeFlatMesh(flatMesh);
      }

      return serialized;
    }
  }, {
    key: "reconstructFlatMeshVector",
    value: function reconstructFlatMeshVector(vector) {
      return new FlatMeshVector(this, vector);
    }
  }, {
    key: "serializeIfcModel",
    value: function serializeIfcModel(model) {
      return new SerializedMesh(model);
    }
  }, {
    key: "reconstructIfcModel",
    value: function reconstructIfcModel(model) {
      return MeshReconstructor.new(model);
    }
  }]);

  return Serializer;
}();

var PropertyHandler = /*#__PURE__*/function () {
  function PropertyHandler(handler) {
    _classCallCheck2(this, PropertyHandler);

    this.handler = handler;
    this.API = WorkerAPIs.properties;
  }

  _createClass2(PropertyHandler, [{
    key: "getExpressId",
    value: function getExpressId(geometry, faceIndex) {
      if (!geometry.index) throw new Error('Geometry does not have index information.');
      var geoIndex = geometry.index.array;
      var bufferAttr = geometry.attributes[IdAttrName];
      return bufferAttr.getX(geoIndex[3 * faceIndex]);
    }
  }, {
    key: "getHeaderLine",
    value: function getHeaderLine(modelID, headerType) {
      return this.handler.request(this.API, WorkerActions.getHeaderLine, {
        modelID: modelID,
        headerType: headerType
      });
    }
  }, {
    key: "getAllItemsOfType",
    value: function getAllItemsOfType(modelID, type, verbose) {
      return this.handler.request(this.API, WorkerActions.getAllItemsOfType, {
        modelID: modelID,
        type: type,
        verbose: verbose
      });
    }
  }, {
    key: "getItemProperties",
    value: function getItemProperties(modelID, elementID, recursive) {
      return this.handler.request(this.API, WorkerActions.getItemProperties, {
        modelID: modelID,
        elementID: elementID,
        recursive: recursive
      });
    }
  }, {
    key: "getMaterialsProperties",
    value: function getMaterialsProperties(modelID, elementID, recursive) {
      return this.handler.request(this.API, WorkerActions.getMaterialsProperties, {
        modelID: modelID,
        elementID: elementID,
        recursive: recursive
      });
    }
  }, {
    key: "getPropertySets",
    value: function getPropertySets(modelID, elementID, recursive) {
      return this.handler.request(this.API, WorkerActions.getPropertySets, {
        modelID: modelID,
        elementID: elementID,
        recursive: recursive
      });
    }
  }, {
    key: "getTypeProperties",
    value: function getTypeProperties(modelID, elementID, recursive) {
      return this.handler.request(this.API, WorkerActions.getTypeProperties, {
        modelID: modelID,
        elementID: elementID,
        recursive: recursive
      });
    }
  }, {
    key: "getSpatialStructure",
    value: function getSpatialStructure(modelID, includeProperties) {
      return this.handler.request(this.API, WorkerActions.getSpatialStructure, {
        modelID: modelID,
        includeProperties: includeProperties
      });
    }
  }]);

  return PropertyHandler;
}();

var WebIfcHandler = /*#__PURE__*/function () {
  function WebIfcHandler(handler, serializer) {
    _classCallCheck2(this, WebIfcHandler);

    this.handler = handler;
    this.serializer = serializer;
    this.API = WorkerAPIs.webIfc;
  }

  _createClass2(WebIfcHandler, [{
    key: "Init",
    value: function () {
      var _Init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60() {
        return _regeneratorRuntime.wrap(function _callee60$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                this.wasmModule = true;
                return _context71.abrupt("return", this.handler.request(this.API, WorkerActions.Init));

              case 2:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee60, this);
      }));

      function Init() {
        return _Init.apply(this, arguments);
      }

      return Init;
    }()
  }, {
    key: "OpenModel",
    value: function () {
      var _OpenModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(data, settings) {
        return _regeneratorRuntime.wrap(function _callee61$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                return _context72.abrupt("return", this.handler.request(this.API, WorkerActions.OpenModel, {
                  data: data,
                  settings: settings
                }));

              case 1:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee61, this);
      }));

      function OpenModel(_x101, _x102) {
        return _OpenModel.apply(this, arguments);
      }

      return OpenModel;
    }()
  }, {
    key: "CreateModel",
    value: function () {
      var _CreateModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(model, settings) {
        return _regeneratorRuntime.wrap(function _callee62$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                return _context73.abrupt("return", this.handler.request(this.API, WorkerActions.CreateModel, {
                  model: model,
                  settings: settings
                }));

              case 1:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee62, this);
      }));

      function CreateModel(_x103, _x104) {
        return _CreateModel.apply(this, arguments);
      }

      return CreateModel;
    }()
  }, {
    key: "ExportFileAsIFC",
    value: function () {
      var _ExportFileAsIFC = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(modelID) {
        return _regeneratorRuntime.wrap(function _callee63$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                return _context74.abrupt("return", this.handler.request(this.API, WorkerActions.ExportFileAsIFC, {
                  modelID: modelID
                }));

              case 1:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee63, this);
      }));

      function ExportFileAsIFC(_x105) {
        return _ExportFileAsIFC.apply(this, arguments);
      }

      return ExportFileAsIFC;
    }()
  }, {
    key: "GetHeaderLine",
    value: function () {
      var _GetHeaderLine = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(modelID, headerType) {
        return _regeneratorRuntime.wrap(function _callee64$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                return _context75.abrupt("return", this.handler.request(this.API, WorkerActions.getHeaderLine, {
                  modelID: modelID,
                  headerType: headerType
                }));

              case 1:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee64, this);
      }));

      function GetHeaderLine(_x106, _x107) {
        return _GetHeaderLine.apply(this, arguments);
      }

      return GetHeaderLine;
    }()
  }, {
    key: "GetGeometry",
    value: function () {
      var _GetGeometry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(modelID, geometryExpressID) {
        var _this2403 = this;

        return _regeneratorRuntime.wrap(function _callee65$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                this.handler.serializeHandlers[this.handler.requestID] = function (geom) {
                  return _this2403.serializer.reconstructIfcGeometry(geom);
                };

                return _context76.abrupt("return", this.handler.request(this.API, WorkerActions.GetGeometry, {
                  modelID: modelID,
                  geometryExpressID: geometryExpressID
                }));

              case 2:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee65, this);
      }));

      function GetGeometry(_x108, _x109) {
        return _GetGeometry.apply(this, arguments);
      }

      return GetGeometry;
    }()
  }, {
    key: "GetLine",
    value: function () {
      var _GetLine = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(modelID, expressID, flatten) {
        return _regeneratorRuntime.wrap(function _callee66$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                return _context77.abrupt("return", this.handler.request(this.API, WorkerActions.GetLine, {
                  modelID: modelID,
                  expressID: expressID,
                  flatten: flatten
                }));

              case 1:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee66, this);
      }));

      function GetLine(_x110, _x111, _x112) {
        return _GetLine.apply(this, arguments);
      }

      return GetLine;
    }()
  }, {
    key: "GetAndClearErrors",
    value: function () {
      var _GetAndClearErrors = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(modelID) {
        var _this2404 = this;

        return _regeneratorRuntime.wrap(function _callee67$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                this.handler.serializeHandlers[this.handler.requestID] = function (vector) {
                  return _this2404.serializer.reconstructVector(vector);
                };

                return _context78.abrupt("return", this.handler.request(this.API, WorkerActions.GetAndClearErrors, {
                  modelID: modelID
                }));

              case 2:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee67, this);
      }));

      function GetAndClearErrors(_x113) {
        return _GetAndClearErrors.apply(this, arguments);
      }

      return GetAndClearErrors;
    }()
  }, {
    key: "GetNameFromTypeCode",
    value: function () {
      var _GetNameFromTypeCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(type) {
        return _regeneratorRuntime.wrap(function _callee68$(_context79) {
          while (1) {
            switch (_context79.prev = _context79.next) {
              case 0:
                return _context79.abrupt("return", this.handler.request(this.API, WorkerActions.GetNameFromTypeCode, {
                  type: type
                }));

              case 1:
              case "end":
                return _context79.stop();
            }
          }
        }, _callee68, this);
      }));

      function GetNameFromTypeCode(_x114) {
        return _GetNameFromTypeCode.apply(this, arguments);
      }

      return GetNameFromTypeCode;
    }()
  }, {
    key: "GetIfcEntityList",
    value: function () {
      var _GetIfcEntityList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(modelID) {
        return _regeneratorRuntime.wrap(function _callee69$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                return _context80.abrupt("return", this.handler.request(this.API, WorkerActions.GetIfcEntityList, {
                  modelID: modelID
                }));

              case 1:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee69, this);
      }));

      function GetIfcEntityList(_x115) {
        return _GetIfcEntityList.apply(this, arguments);
      }

      return GetIfcEntityList;
    }()
  }, {
    key: "GetTypeCodeFromName",
    value: function () {
      var _GetTypeCodeFromName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(modelID, typeName) {
        return _regeneratorRuntime.wrap(function _callee70$(_context81) {
          while (1) {
            switch (_context81.prev = _context81.next) {
              case 0:
                return _context81.abrupt("return", this.handler.request(this.API, WorkerActions.GetTypeCodeFromName, {
                  modelID: modelID,
                  typeName: typeName
                }));

              case 1:
              case "end":
                return _context81.stop();
            }
          }
        }, _callee70, this);
      }));

      function GetTypeCodeFromName(_x116, _x117) {
        return _GetTypeCodeFromName.apply(this, arguments);
      }

      return GetTypeCodeFromName;
    }()
  }, {
    key: "WriteLine",
    value: function () {
      var _WriteLine = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(modelID, lineObject) {
        return _regeneratorRuntime.wrap(function _callee71$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                return _context82.abrupt("return", this.handler.request(this.API, WorkerActions.WriteLine, {
                  modelID: modelID,
                  lineObject: lineObject
                }));

              case 1:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee71, this);
      }));

      function WriteLine(_x118, _x119) {
        return _WriteLine.apply(this, arguments);
      }

      return WriteLine;
    }()
  }, {
    key: "FlattenLine",
    value: function () {
      var _FlattenLine = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(modelID, line) {
        return _regeneratorRuntime.wrap(function _callee72$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                return _context83.abrupt("return", this.handler.request(this.API, WorkerActions.FlattenLine, {
                  modelID: modelID,
                  line: line
                }));

              case 1:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee72, this);
      }));

      function FlattenLine(_x120, _x121) {
        return _FlattenLine.apply(this, arguments);
      }

      return FlattenLine;
    }()
  }, {
    key: "GetRawLineData",
    value: function () {
      var _GetRawLineData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(modelID, expressID) {
        return _regeneratorRuntime.wrap(function _callee73$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                return _context84.abrupt("return", this.handler.request(this.API, WorkerActions.GetRawLineData, {
                  modelID: modelID,
                  expressID: expressID
                }));

              case 1:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee73, this);
      }));

      function GetRawLineData(_x122, _x123) {
        return _GetRawLineData.apply(this, arguments);
      }

      return GetRawLineData;
    }()
  }, {
    key: "WriteRawLineData",
    value: function () {
      var _WriteRawLineData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(modelID, data) {
        return _regeneratorRuntime.wrap(function _callee74$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                return _context85.abrupt("return", this.handler.request(this.API, WorkerActions.WriteRawLineData, {
                  modelID: modelID,
                  data: data
                }));

              case 1:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee74, this);
      }));

      function WriteRawLineData(_x124, _x125) {
        return _WriteRawLineData.apply(this, arguments);
      }

      return WriteRawLineData;
    }()
  }, {
    key: "GetLineIDsWithType",
    value: function () {
      var _GetLineIDsWithType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(modelID, type) {
        var _this2405 = this;

        return _regeneratorRuntime.wrap(function _callee75$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                this.handler.serializeHandlers[this.handler.requestID] = function (vector) {
                  return _this2405.serializer.reconstructVector(vector);
                };

                return _context86.abrupt("return", this.handler.request(this.API, WorkerActions.GetLineIDsWithType, {
                  modelID: modelID,
                  type: type
                }));

              case 2:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee75, this);
      }));

      function GetLineIDsWithType(_x126, _x127) {
        return _GetLineIDsWithType.apply(this, arguments);
      }

      return GetLineIDsWithType;
    }()
  }, {
    key: "GetAllLines",
    value: function () {
      var _GetAllLines = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(modelID) {
        var _this2406 = this;

        return _regeneratorRuntime.wrap(function _callee76$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                this.handler.serializeHandlers[this.handler.requestID] = function (vector) {
                  return _this2406.serializer.reconstructVector(vector);
                };

                return _context87.abrupt("return", this.handler.request(this.API, WorkerActions.GetAllLines, {
                  modelID: modelID
                }));

              case 2:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee76, this);
      }));

      function GetAllLines(_x128) {
        return _GetAllLines.apply(this, arguments);
      }

      return GetAllLines;
    }()
  }, {
    key: "SetGeometryTransformation",
    value: function () {
      var _SetGeometryTransformation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77(modelID, transformationMatrix) {
        return _regeneratorRuntime.wrap(function _callee77$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                return _context88.abrupt("return", this.handler.request(this.API, WorkerActions.SetGeometryTransformation, {
                  modelID: modelID,
                  transformationMatrix: transformationMatrix
                }));

              case 1:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee77, this);
      }));

      function SetGeometryTransformation(_x129, _x130) {
        return _SetGeometryTransformation.apply(this, arguments);
      }

      return SetGeometryTransformation;
    }()
  }, {
    key: "GetCoordinationMatrix",
    value: function () {
      var _GetCoordinationMatrix = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78(modelID) {
        return _regeneratorRuntime.wrap(function _callee78$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                return _context89.abrupt("return", this.handler.request(this.API, WorkerActions.GetCoordinationMatrix, {
                  modelID: modelID
                }));

              case 1:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee78, this);
      }));

      function GetCoordinationMatrix(_x131) {
        return _GetCoordinationMatrix.apply(this, arguments);
      }

      return GetCoordinationMatrix;
    }()
  }, {
    key: "GetVertexArray",
    value: function () {
      var _GetVertexArray = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79(ptr, size) {
        return _regeneratorRuntime.wrap(function _callee79$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                return _context90.abrupt("return", this.handler.request(this.API, WorkerActions.GetVertexArray, {
                  ptr: ptr,
                  size: size
                }));

              case 1:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee79, this);
      }));

      function GetVertexArray(_x132, _x133) {
        return _GetVertexArray.apply(this, arguments);
      }

      return GetVertexArray;
    }()
  }, {
    key: "GetIndexArray",
    value: function () {
      var _GetIndexArray = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80(ptr, size) {
        return _regeneratorRuntime.wrap(function _callee80$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                return _context91.abrupt("return", this.handler.request(this.API, WorkerActions.GetIndexArray, {
                  ptr: ptr,
                  size: size
                }));

              case 1:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee80, this);
      }));

      function GetIndexArray(_x134, _x135) {
        return _GetIndexArray.apply(this, arguments);
      }

      return GetIndexArray;
    }()
  }, {
    key: "getSubArray",
    value: function () {
      var _getSubArray = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee81(heap, startPtr, sizeBytes) {
        return _regeneratorRuntime.wrap(function _callee81$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                return _context92.abrupt("return", this.handler.request(this.API, WorkerActions.getSubArray, {
                  heap: heap,
                  startPtr: startPtr,
                  sizeBytes: sizeBytes
                }));

              case 1:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee81, this);
      }));

      function getSubArray(_x136, _x137, _x138) {
        return _getSubArray.apply(this, arguments);
      }

      return getSubArray;
    }()
  }, {
    key: "CloseModel",
    value: function () {
      var _CloseModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee82(modelID) {
        return _regeneratorRuntime.wrap(function _callee82$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                return _context93.abrupt("return", this.handler.request(this.API, WorkerActions.CloseModel, {
                  modelID: modelID
                }));

              case 1:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee82, this);
      }));

      function CloseModel(_x139) {
        return _CloseModel.apply(this, arguments);
      }

      return CloseModel;
    }()
  }, {
    key: "StreamAllMeshes",
    value: function () {
      var _StreamAllMeshes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee83(modelID, meshCallback) {
        return _regeneratorRuntime.wrap(function _callee83$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                this.handler.callbackHandlers[this.handler.requestID] = {
                  action: meshCallback,
                  serializer: this.serializer.reconstructFlatMesh
                };
                return _context94.abrupt("return", this.handler.request(this.API, WorkerActions.StreamAllMeshes, {
                  modelID: modelID
                }));

              case 2:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee83, this);
      }));

      function StreamAllMeshes(_x140, _x141) {
        return _StreamAllMeshes.apply(this, arguments);
      }

      return StreamAllMeshes;
    }()
  }, {
    key: "StreamAllMeshesWithTypes",
    value: function () {
      var _StreamAllMeshesWithTypes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee84(modelID, types, meshCallback) {
        return _regeneratorRuntime.wrap(function _callee84$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                this.handler.callbackHandlers[this.handler.requestID] = {
                  action: meshCallback,
                  serializer: this.serializer.reconstructFlatMesh
                };
                return _context95.abrupt("return", this.handler.request(this.API, WorkerActions.StreamAllMeshesWithTypes, {
                  modelID: modelID,
                  types: types
                }));

              case 2:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee84, this);
      }));

      function StreamAllMeshesWithTypes(_x142, _x143, _x144) {
        return _StreamAllMeshesWithTypes.apply(this, arguments);
      }

      return StreamAllMeshesWithTypes;
    }()
  }, {
    key: "IsModelOpen",
    value: function () {
      var _IsModelOpen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee85(modelID) {
        return _regeneratorRuntime.wrap(function _callee85$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                return _context96.abrupt("return", this.handler.request(this.API, WorkerActions.IsModelOpen, {
                  modelID: modelID
                }));

              case 1:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee85, this);
      }));

      function IsModelOpen(_x145) {
        return _IsModelOpen.apply(this, arguments);
      }

      return IsModelOpen;
    }()
  }, {
    key: "LoadAllGeometry",
    value: function () {
      var _LoadAllGeometry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee86(modelID) {
        var _this2407 = this;

        return _regeneratorRuntime.wrap(function _callee86$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                this.handler.serializeHandlers[this.handler.requestID] = function (vector) {
                  return _this2407.serializer.reconstructFlatMeshVector(vector);
                };

                return _context97.abrupt("return", this.handler.request(this.API, WorkerActions.LoadAllGeometry, {
                  modelID: modelID
                }));

              case 2:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee86, this);
      }));

      function LoadAllGeometry(_x146) {
        return _LoadAllGeometry.apply(this, arguments);
      }

      return LoadAllGeometry;
    }()
  }, {
    key: "GetFlatMesh",
    value: function () {
      var _GetFlatMesh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee87(modelID, expressID) {
        var _this2408 = this;

        return _regeneratorRuntime.wrap(function _callee87$(_context98) {
          while (1) {
            switch (_context98.prev = _context98.next) {
              case 0:
                this.handler.serializeHandlers[this.handler.requestID] = function (flatMesh) {
                  return _this2408.serializer.reconstructFlatMesh(flatMesh);
                };

                return _context98.abrupt("return", this.handler.request(this.API, WorkerActions.GetFlatMesh, {
                  modelID: modelID,
                  expressID: expressID
                }));

              case 2:
              case "end":
                return _context98.stop();
            }
          }
        }, _callee87, this);
      }));

      function GetFlatMesh(_x147, _x148) {
        return _GetFlatMesh.apply(this, arguments);
      }

      return GetFlatMesh;
    }()
  }, {
    key: "SetWasmPath",
    value: function () {
      var _SetWasmPath = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee88(path) {
        return _regeneratorRuntime.wrap(function _callee88$(_context99) {
          while (1) {
            switch (_context99.prev = _context99.next) {
              case 0:
                return _context99.abrupt("return", this.handler.request(this.API, WorkerActions.SetWasmPath, {
                  path: path
                }));

              case 1:
              case "end":
                return _context99.stop();
            }
          }
        }, _callee88, this);
      }));

      function SetWasmPath(_x149) {
        return _SetWasmPath.apply(this, arguments);
      }

      return SetWasmPath;
    }()
  }]);

  return WebIfcHandler;
}();

var WorkerStateHandler = /*#__PURE__*/function () {
  function WorkerStateHandler(handler) {
    _classCallCheck2(this, WorkerStateHandler);

    this.handler = handler;
    this.API = WorkerAPIs.workerState;
    this.state = this.handler.state;
  }

  _createClass2(WorkerStateHandler, [{
    key: "updateStateUseJson",
    value: function () {
      var _updateStateUseJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee89() {
        var useJson;
        return _regeneratorRuntime.wrap(function _callee89$(_context100) {
          while (1) {
            switch (_context100.prev = _context100.next) {
              case 0:
                useJson = this.state.useJSON;
                return _context100.abrupt("return", this.handler.request(this.API, WorkerActions.updateStateUseJson, {
                  useJson: useJson
                }));

              case 2:
              case "end":
                return _context100.stop();
            }
          }
        }, _callee89, this);
      }));

      function updateStateUseJson() {
        return _updateStateUseJson.apply(this, arguments);
      }

      return updateStateUseJson;
    }()
  }, {
    key: "updateStateWebIfcSettings",
    value: function () {
      var _updateStateWebIfcSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee90() {
        var webIfcSettings;
        return _regeneratorRuntime.wrap(function _callee90$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                webIfcSettings = this.state.webIfcSettings;
                return _context101.abrupt("return", this.handler.request(this.API, WorkerActions.updateStateWebIfcSettings, {
                  webIfcSettings: webIfcSettings
                }));

              case 2:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee90, this);
      }));

      function updateStateWebIfcSettings() {
        return _updateStateWebIfcSettings.apply(this, arguments);
      }

      return updateStateWebIfcSettings;
    }()
  }, {
    key: "updateModelStateTypes",
    value: function () {
      var _updateModelStateTypes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee91(modelID, types) {
        return _regeneratorRuntime.wrap(function _callee91$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                return _context102.abrupt("return", this.handler.request(this.API, WorkerActions.updateModelStateTypes, {
                  modelID: modelID,
                  types: types
                }));

              case 1:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee91, this);
      }));

      function updateModelStateTypes(_x150, _x151) {
        return _updateModelStateTypes.apply(this, arguments);
      }

      return updateModelStateTypes;
    }()
  }, {
    key: "updateModelStateJsonData",
    value: function () {
      var _updateModelStateJsonData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee92(modelID, jsonData) {
        return _regeneratorRuntime.wrap(function _callee92$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                return _context103.abrupt("return", this.handler.request(this.API, WorkerActions.updateModelStateJsonData, {
                  modelID: modelID,
                  jsonData: jsonData
                }));

              case 1:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee92, this);
      }));

      function updateModelStateJsonData(_x152, _x153) {
        return _updateModelStateJsonData.apply(this, arguments);
      }

      return updateModelStateJsonData;
    }()
  }, {
    key: "loadJsonDataFromWorker",
    value: function () {
      var _loadJsonDataFromWorker = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee93(modelID, path) {
        return _regeneratorRuntime.wrap(function _callee93$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                return _context104.abrupt("return", this.handler.request(this.API, WorkerActions.loadJsonDataFromWorker, {
                  modelID: modelID,
                  path: path
                }));

              case 1:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee93, this);
      }));

      function loadJsonDataFromWorker(_x154, _x155) {
        return _loadJsonDataFromWorker.apply(this, arguments);
      }

      return loadJsonDataFromWorker;
    }()
  }]);

  return WorkerStateHandler;
}();

var DBOperation;

(function (DBOperation) {
  DBOperation[DBOperation['transferIfcModel'] = 0] = 'transferIfcModel';
  DBOperation[DBOperation['transferIndividualItems'] = 1] = 'transferIndividualItems';
})(DBOperation || (DBOperation = {}));

var IndexedDatabase = /*#__PURE__*/function () {
  function IndexedDatabase() {
    _classCallCheck2(this, IndexedDatabase);
  }

  _createClass2(IndexedDatabase, [{
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee94(item, id) {
        var _this2409 = this;

        var open;
        return _regeneratorRuntime.wrap(function _callee94$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                open = IndexedDatabase.openOrCreateDB(id);
                this.createSchema(open, id);
                return _context105.abrupt("return", new Promise(function (resolve, reject) {
                  open.onsuccess = function () {
                    return _this2409.saveItem(item, open, id, resolve);
                  };
                }));

              case 3:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee94, this);
      }));

      function save(_x156, _x157) {
        return _save.apply(this, arguments);
      }

      return save;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee95(id) {
        var _this2410 = this;

        var open;
        return _regeneratorRuntime.wrap(function _callee95$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                open = IndexedDatabase.openOrCreateDB(id);
                return _context106.abrupt("return", new Promise(function (resolve, reject) {
                  open.onsuccess = function () {
                    return _this2410.loadItem(open, id, resolve);
                  };
                }));

              case 2:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee95);
      }));

      function load(_x158) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "createSchema",
    value: function createSchema(open, id) {
      open.onupgradeneeded = function () {
        var db = open.result;
        db.createObjectStore(id.toString(), {
          keyPath: 'id'
        });
      };
    }
  }, {
    key: "saveItem",
    value: function saveItem(item, open, id, resolve) {
      var _IndexedDatabase$getD = IndexedDatabase.getDBItems(open, id),
          db = _IndexedDatabase$getD.db,
          tx = _IndexedDatabase$getD.tx,
          store = _IndexedDatabase$getD.store;

      item.id = id;
      store.put(item);

      tx.oncomplete = function () {
        return IndexedDatabase.closeDB(db, tx, resolve);
      };
    }
  }, {
    key: "loadItem",
    value: function loadItem(open, id, resolve) {
      var _IndexedDatabase$getD2 = IndexedDatabase.getDBItems(open, id),
          db = _IndexedDatabase$getD2.db,
          tx = _IndexedDatabase$getD2.tx,
          store = _IndexedDatabase$getD2.store;

      var item = store.get(id);

      var callback = function callback() {
        delete item.result.id;
        resolve(item.result);
      };

      tx.oncomplete = function () {
        return IndexedDatabase.closeDB(db, tx, callback);
      };
    }
  }], [{
    key: "getDBItems",
    value: function getDBItems(open, id) {
      var db = open.result;
      var tx = db.transaction(id.toString(), 'readwrite');
      var store = tx.objectStore(id.toString());
      return {
        db: db,
        tx: tx,
        store: store
      };
    }
  }, {
    key: "openOrCreateDB",
    value: function openOrCreateDB(id) {
      return indexedDB.open(id.toString(), 1);
    }
  }, {
    key: "closeDB",
    value: function closeDB(db, tx, resolve) {
      db.close();
      resolve('success');
    }
  }]);

  return IndexedDatabase;
}();

var ParserHandler = /*#__PURE__*/function () {
  function ParserHandler(handler, serializer, BVH, IDB) {
    var _this$optionalCategor2;

    _classCallCheck2(this, ParserHandler);

    this.handler = handler;
    this.serializer = serializer;
    this.BVH = BVH;
    this.IDB = IDB;
    this.optionalCategories = (_this$optionalCategor2 = {}, _defineProperty(_this$optionalCategor2, IFCSPACE, true), _defineProperty(_this$optionalCategor2, IFCOPENINGELEMENT, false), _this$optionalCategor2);
    this.API = WorkerAPIs.parser;
  }

  _createClass2(ParserHandler, [{
    key: "setupOptionalCategories",
    value: function () {
      var _setupOptionalCategories2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee96(config) {
        return _regeneratorRuntime.wrap(function _callee96$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                this.optionalCategories = config;
                return _context107.abrupt("return", this.handler.request(this.API, WorkerActions.setupOptionalCategories, {
                  config: config
                }));

              case 2:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee96, this);
      }));

      function setupOptionalCategories(_x159) {
        return _setupOptionalCategories2.apply(this, arguments);
      }

      return setupOptionalCategories;
    }()
  }, {
    key: "parse",
    value: function () {
      var _parse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee98(buffer, coordinationMatrix) {
        var _this2411 = this;

        return _regeneratorRuntime.wrap(function _callee98$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                this.handler.onprogressHandlers[this.handler.requestID] = function (progress) {
                  if (_this2411.handler.state.onProgress) _this2411.handler.state.onProgress(progress);
                };

                this.handler.serializeHandlers[this.handler.requestID] = /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee97(result) {
                    return _regeneratorRuntime.wrap(function _callee97$(_context108) {
                      while (1) {
                        switch (_context108.prev = _context108.next) {
                          case 0:
                            _this2411.updateState(result.modelID);

                            return _context108.abrupt("return", _this2411.getModel());

                          case 2:
                          case "end":
                            return _context108.stop();
                        }
                      }
                    }, _callee97);
                  }));

                  return function (_x162) {
                    return _ref3.apply(this, arguments);
                  };
                }();

                return _context109.abrupt("return", this.handler.request(this.API, WorkerActions.parse, {
                  buffer: buffer,
                  coordinationMatrix: coordinationMatrix
                }));

              case 3:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee98, this);
      }));

      function parse(_x160, _x161) {
        return _parse2.apply(this, arguments);
      }

      return parse;
    }()
  }, {
    key: "getAndClearErrors",
    value: function getAndClearErrors(_modelId) {}
  }, {
    key: "updateState",
    value: function updateState(modelID) {
      this.handler.state.models[modelID] = {
        modelID: modelID,
        mesh: {},
        types: {},
        jsonData: {}
      };
    }
  }, {
    key: "getModel",
    value: function () {
      var _getModel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee99() {
        var serializedModel, model;
        return _regeneratorRuntime.wrap(function _callee99$(_context110) {
          while (1) {
            switch (_context110.prev = _context110.next) {
              case 0:
                _context110.next = 2;
                return this.IDB.load(DBOperation.transferIfcModel);

              case 2:
                serializedModel = _context110.sent;
                model = this.serializer.reconstructIfcModel(serializedModel);
                this.BVH.applyThreeMeshBVH(model.geometry);
                this.handler.state.models[model.modelID].mesh = model;
                return _context110.abrupt("return", model);

              case 7:
              case "end":
                return _context110.stop();
            }
          }
        }, _callee99, this);
      }));

      function getModel() {
        return _getModel.apply(this, arguments);
      }

      return getModel;
    }()
  }]);

  return ParserHandler;
}();

var IFCWorkerHandler = /*#__PURE__*/function () {
  function IFCWorkerHandler(state, BVH) {
    var _this2412 = this;

    _classCallCheck2(this, IFCWorkerHandler);

    this.state = state;
    this.BVH = BVH;
    this.requestID = 0;
    this.rejectHandlers = {};
    this.resolveHandlers = {};
    this.serializeHandlers = {};
    this.callbackHandlers = {};
    this.onprogressHandlers = {};
    this.serializer = new Serializer();
    this.IDB = new IndexedDatabase();
    this.workerPath = this.state.worker.path;
    this.ifcWorker = new Worker(this.workerPath);

    this.ifcWorker.onmessage = function (data) {
      return _this2412.handleResponse(data);
    };

    this.properties = new PropertyHandler(this);
    this.parser = new ParserHandler(this, this.serializer, this.BVH, this.IDB);
    this.webIfc = new WebIfcHandler(this, this.serializer);
    this.workerState = new WorkerStateHandler(this);
  }

  _createClass2(IFCWorkerHandler, [{
    key: "request",
    value: function request(worker, action, args) {
      var _this2413 = this;

      var data = {
        worker: worker,
        action: action,
        args: args,
        id: this.requestID,
        result: undefined,
        onProgress: false
      };
      return new Promise(function (resolve, reject) {
        _this2413.resolveHandlers[_this2413.requestID] = resolve;
        _this2413.rejectHandlers[_this2413.requestID] = reject;
        _this2413.requestID++;

        _this2413.ifcWorker.postMessage(data);
      });
    }
  }, {
    key: "terminate",
    value: function () {
      var _terminate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee100() {
        return _regeneratorRuntime.wrap(function _callee100$(_context111) {
          while (1) {
            switch (_context111.prev = _context111.next) {
              case 0:
                _context111.next = 2;
                return this.request(WorkerAPIs.workerState, WorkerActions.dispose);

              case 2:
                _context111.next = 4;
                return this.request(WorkerAPIs.webIfc, WorkerActions.DisposeWebIfc);

              case 4:
                this.ifcWorker.terminate();

              case 5:
              case "end":
                return _context111.stop();
            }
          }
        }, _callee100, this);
      }));

      function terminate() {
        return _terminate.apply(this, arguments);
      }

      return terminate;
    }()
  }, {
    key: "Close",
    value: function () {
      var _Close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee101() {
        return _regeneratorRuntime.wrap(function _callee101$(_context112) {
          while (1) {
            switch (_context112.prev = _context112.next) {
              case 0:
                _context112.next = 2;
                return this.request(WorkerAPIs.webIfc, WorkerActions.Close);

              case 2:
              case "end":
                return _context112.stop();
            }
          }
        }, _callee101, this);
      }));

      function Close() {
        return _Close.apply(this, arguments);
      }

      return Close;
    }()
  }, {
    key: "handleResponse",
    value: function handleResponse(event) {
      var data = event.data;

      if (data.onProgress) {
        this.resolveOnProgress(data);
        return;
      }

      this.callHandlers(data);
      delete this.resolveHandlers[data.id];
      delete this.rejectHandlers[data.id];
      delete this.onprogressHandlers[data.id];
    }
  }, {
    key: "callHandlers",
    value: function callHandlers(data) {
      try {
        this.resolveSerializations(data);
        this.resolveCallbacks(data);
        this.resolveHandlers[data.id](data.result);
      } catch (error) {
        this.rejectHandlers[data.id](error);
      }
    }
  }, {
    key: "resolveOnProgress",
    value: function resolveOnProgress(data) {
      if (this.onprogressHandlers[data.id]) {
        data.result = this.onprogressHandlers[data.id](data.result);
      }
    }
  }, {
    key: "resolveSerializations",
    value: function resolveSerializations(data) {
      if (this.serializeHandlers[data.id]) {
        data.result = this.serializeHandlers[data.id](data.result);
        delete this.serializeHandlers[data.id];
      }
    }
  }, {
    key: "resolveCallbacks",
    value: function resolveCallbacks(data) {
      if (this.callbackHandlers[data.id]) {
        var callbackParameter = data.result;

        if (this.callbackHandlers[data.id].serializer) {
          callbackParameter = this.callbackHandlers[data.id].serializer(data.result);
        }

        this.callbackHandlers[data.id].action(callbackParameter);
      }
    }
  }]);

  return IFCWorkerHandler;
}();

var MemoryCleaner = /*#__PURE__*/function () {
  function MemoryCleaner(state) {
    _classCallCheck2(this, MemoryCleaner);

    this.state = state;
  }

  _createClass2(MemoryCleaner, [{
    key: "dispose",
    value: function () {
      var _dispose2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee102() {
        var _this2414 = this;

        return _regeneratorRuntime.wrap(function _callee102$(_context113) {
          while (1) {
            switch (_context113.prev = _context113.next) {
              case 0:
                Object.keys(this.state.models).forEach(function (modelID) {
                  var model = _this2414.state.models[parseInt(modelID, 10)];

                  model.mesh.removeFromParent();
                  var geom = model.mesh.geometry;
                  if (geom.disposeBoundsTree) geom.disposeBoundsTree();
                  geom.dispose();
                  if (!Array.isArray(model.mesh.material)) model.mesh.material.dispose();else model.mesh.material.forEach(function (mat) {
                    return mat.dispose();
                  });
                  model.mesh = null;
                  model.types = null;
                  model.jsonData = null;
                });
                this.state.api = null;
                this.state.models = null;

              case 3:
              case "end":
                return _context113.stop();
            }
          }
        }, _callee102, this);
      }));

      function dispose() {
        return _dispose2.apply(this, arguments);
      }

      return dispose;
    }()
  }]);

  return MemoryCleaner;
}();

var IFCUtils = /*#__PURE__*/function () {
  function IFCUtils(state) {
    _classCallCheck2(this, IFCUtils);

    this.state = state;
    this.map = {};
  }

  _createClass2(IFCUtils, [{
    key: "isA",
    value: function isA(entity, entity_class) {
      var test = false;

      if (entity_class) {
        if (this.state.api.GetNameFromTypeCode(entity.type) === entity_class.toUpperCase()) {
          test = true;
        }

        return test;
      } else {
        return this.state.api.GetNameFromTypeCode(entity.type);
      }
    }
  }, {
    key: "byId",
    value: function () {
      var _byId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee103(modelID, id) {
        return _regeneratorRuntime.wrap(function _callee103$(_context114) {
          while (1) {
            switch (_context114.prev = _context114.next) {
              case 0:
                return _context114.abrupt("return", this.state.api.GetLine(modelID, id));

              case 1:
              case "end":
                return _context114.stop();
            }
          }
        }, _callee103, this);
      }));

      function byId(_x163, _x164) {
        return _byId.apply(this, arguments);
      }

      return byId;
    }()
  }, {
    key: "idsByType",
    value: function () {
      var _idsByType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee104(modelID, entity_class) {
        var entities_ids;
        return _regeneratorRuntime.wrap(function _callee104$(_context115) {
          while (1) {
            switch (_context115.prev = _context115.next) {
              case 0:
                _context115.next = 2;
                return this.state.api.GetLineIDsWithType(modelID, Number(this.state.api.GetTypeCodeFromName(modelID, entity_class.toUpperCase())));

              case 2:
                entities_ids = _context115.sent;
                return _context115.abrupt("return", entities_ids);

              case 4:
              case "end":
                return _context115.stop();
            }
          }
        }, _callee104, this);
      }));

      function idsByType(_x165, _x166) {
        return _idsByType.apply(this, arguments);
      }

      return idsByType;
    }()
  }, {
    key: "byType",
    value: function () {
      var _byType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee105(modelID, entity_class) {
        var entities_ids, items, _i376, entity;

        return _regeneratorRuntime.wrap(function _callee105$(_context116) {
          while (1) {
            switch (_context116.prev = _context116.next) {
              case 0:
                _context116.next = 2;
                return this.idsByType(modelID, entity_class);

              case 2:
                entities_ids = _context116.sent;

                if (!(entities_ids !== null)) {
                  _context116.next = 15;
                  break;
                }

                items = [];
                _i376 = 0;

              case 6:
                if (!(_i376 < entities_ids.size())) {
                  _context116.next = 14;
                  break;
                }

                _context116.next = 9;
                return this.byId(modelID, entities_ids.get(_i376));

              case 9:
                entity = _context116.sent;
                items.push(entity);

              case 11:
                _i376++;
                _context116.next = 6;
                break;

              case 14:
                return _context116.abrupt("return", items);

              case 15:
              case "end":
                return _context116.stop();
            }
          }
        }, _callee105, this);
      }));

      function byType(_x167, _x168) {
        return _byType.apply(this, arguments);
      }

      return byType;
    }()
  }]);

  return IFCUtils;
}();

var Data = /*#__PURE__*/function () {
  function Data(state) {
    _classCallCheck2(this, Data);

    this.state = state;
    this.isLoaded = false;
    this.workPlans = {};
    this.workSchedules = {};
    this.workCalendars = {};
    this.workTimes = {};
    this.recurrencePatterns = {};
    this.timePeriods = {};
    this.tasks = {};
    this.taskTimes = {};
    this.lagTimes = {};
    this.sequences = {};
    this.utils = new IFCUtils(this.state);
  }

  _createClass2(Data, [{
    key: "load",
    value: function () {
      var _load2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee106(modelID) {
        return _regeneratorRuntime.wrap(function _callee106$(_context117) {
          while (1) {
            switch (_context117.prev = _context117.next) {
              case 0:
                _context117.next = 2;
                return this.loadTasks(modelID);

              case 2:
                _context117.next = 4;
                return this.loadWorkSchedules(modelID);

              case 4:
                _context117.next = 6;
                return this.loadWorkCalendars(modelID);

              case 6:
                _context117.next = 8;
                return this.loadWorkTimes(modelID);

              case 8:
                _context117.next = 10;
                return this.loadTimePeriods(modelID);

              case 10:
                this.isLoaded = true;

              case 11:
              case "end":
                return _context117.stop();
            }
          }
        }, _callee106, this);
      }));

      function load(_x169) {
        return _load2.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "loadWorkSchedules",
    value: function () {
      var _loadWorkSchedules = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee107(modelID) {
        var workSchedules, _i377, workSchedule;

        return _regeneratorRuntime.wrap(function _callee107$(_context118) {
          while (1) {
            switch (_context118.prev = _context118.next) {
              case 0:
                _context118.next = 2;
                return this.utils.byType(modelID, 'IfcWorkSchedule');

              case 2:
                workSchedules = _context118.sent;

                for (_i377 = 0; _i377 < workSchedules.length; _i377++) {
                  workSchedule = workSchedules[_i377];
                  this.workSchedules[workSchedule.expressID] = {
                    Id: workSchedule.expressID,
                    Name: workSchedule.Name.value,
                    Description: workSchedule.Description ? workSchedule.Description.value : '',
                    Creators: [],
                    CreationDate: workSchedule.CreationDate ? workSchedule.CreationDate.value : '',
                    StartTime: workSchedule.StartTime ? workSchedule.StartTime.value : '',
                    FinishTime: workSchedule.FinishTime ? workSchedule.FinishTime.value : '',
                    TotalFloat: workSchedule.TotalFloat ? workSchedule.TotalFloat.value : '',
                    RelatedObjects: []
                  };
                }

                this.loadWorkScheduleRelatedObjects(modelID);

              case 5:
              case "end":
                return _context118.stop();
            }
          }
        }, _callee107, this);
      }));

      function loadWorkSchedules(_x170) {
        return _loadWorkSchedules.apply(this, arguments);
      }

      return loadWorkSchedules;
    }()
  }, {
    key: "loadWorkScheduleRelatedObjects",
    value: function () {
      var _loadWorkScheduleRelatedObjects = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee108(modelID) {
        var relsControls, _i378, relControls, relatingControl, relatedObjects, objectIndex;

        return _regeneratorRuntime.wrap(function _callee108$(_context119) {
          while (1) {
            switch (_context119.prev = _context119.next) {
              case 0:
                _context119.next = 2;
                return this.utils.byType(modelID, 'IfcRelAssignsToControl');

              case 2:
                relsControls = _context119.sent;
                _i378 = 0;

              case 4:
                if (!(_i378 < relsControls.length)) {
                  _context119.next = 14;
                  break;
                }

                relControls = relsControls[_i378];
                _context119.next = 8;
                return this.utils.byId(modelID, relControls.RelatingControl.value);

              case 8:
                relatingControl = _context119.sent;
                relatedObjects = relControls.RelatedObjects;

                if (this.utils.isA(relatingControl, 'IfcWorkSchedule')) {
                  for (objectIndex = 0; objectIndex < relatedObjects.length; objectIndex++) {
                    this.workSchedules[relatingControl.expressID]['RelatedObjects'].push(relatedObjects[objectIndex].value);
                  }
                }

              case 11:
                _i378++;
                _context119.next = 4;
                break;

              case 14:
              case "end":
                return _context119.stop();
            }
          }
        }, _callee108, this);
      }));

      function loadWorkScheduleRelatedObjects(_x171) {
        return _loadWorkScheduleRelatedObjects.apply(this, arguments);
      }

      return loadWorkScheduleRelatedObjects;
    }()
  }, {
    key: "loadTasks",
    value: function () {
      var _loadTasks = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee109(modelID) {
        var tasks, _i379, task;

        return _regeneratorRuntime.wrap(function _callee109$(_context120) {
          while (1) {
            switch (_context120.prev = _context120.next) {
              case 0:
                _context120.next = 2;
                return this.utils.byType(modelID, 'IfcTask');

              case 2:
                tasks = _context120.sent;
                _i379 = 0;

              case 4:
                if (!(_i379 < tasks.length)) {
                  _context120.next = 33;
                  break;
                }

                task = tasks[_i379];
                _context120.t0 = task.expressID;
                _context120.t1 = task.Name ? task.Name.value : '';
                _context120.t2 = task.PredefinedType ? task.PredefinedType.value : '';

                if (!task.TaskTime) {
                  _context120.next = 15;
                  break;
                }

                _context120.next = 12;
                return this.utils.byId(modelID, task.TaskTime.value);

              case 12:
                _context120.t3 = _context120.sent;
                _context120.next = 16;
                break;

              case 15:
                _context120.t3 = '';

              case 16:
                _context120.t4 = _context120.t3;
                _context120.t5 = task.Identification ? task.Identification.value : '';
                _context120.t6 = task.IsMilestone ? task.IsMilestone.value : '';
                _context120.t7 = [];
                _context120.t8 = [];
                _context120.t9 = [];
                _context120.t10 = [];
                _context120.t11 = [];
                _context120.t12 = [];
                _context120.t13 = [];
                _context120.t14 = [];
                _context120.t15 = [];
                _context120.t16 = [];
                this.tasks[task.expressID] = {
                  Id: _context120.t0,
                  Name: _context120.t1,
                  PredefinedType: _context120.t2,
                  TaskTime: _context120.t4,
                  Identification: _context120.t5,
                  IsMilestone: _context120.t6,
                  IsPredecessorTo: _context120.t7,
                  IsSucessorFrom: _context120.t8,
                  Inputs: _context120.t9,
                  Resources: _context120.t10,
                  Outputs: _context120.t11,
                  Controls: _context120.t12,
                  Nests: _context120.t13,
                  IsNestedBy: _context120.t14,
                  OperatesOn: _context120.t15,
                  HasAssignmentsWorkCalendars: _context120.t16
                };

              case 30:
                _i379++;
                _context120.next = 4;
                break;

              case 33:
                _context120.next = 35;
                return this.loadTaskSequence(modelID);

              case 35:
                _context120.next = 37;
                return this.loadTaskOutputs(modelID);

              case 37:
                _context120.next = 39;
                return this.loadTaskNesting(modelID);

              case 39:
                _context120.next = 41;
                return this.loadTaskOperations(modelID);

              case 41:
                _context120.next = 43;
                return this.loadAssignementsWorkCalendar(modelID);

              case 43:
              case "end":
                return _context120.stop();
            }
          }
        }, _callee109, this);
      }));

      function loadTasks(_x172) {
        return _loadTasks.apply(this, arguments);
      }

      return loadTasks;
    }()
  }, {
    key: "loadTaskSequence",
    value: function () {
      var _loadTaskSequence = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee110(modelID) {
        var relsSequence, _i380, relSequenceId, relSequence, related_process, relatingProcess;

        return _regeneratorRuntime.wrap(function _callee110$(_context121) {
          while (1) {
            switch (_context121.prev = _context121.next) {
              case 0:
                _context121.next = 2;
                return this.utils.idsByType(modelID, 'IfcRelSequence');

              case 2:
                relsSequence = _context121.sent;
                _i380 = 0;

              case 4:
                if (!(_i380 < relsSequence.size())) {
                  _context121.next = 17;
                  break;
                }

                relSequenceId = relsSequence.get(_i380);

                if (!(relSequenceId !== 0)) {
                  _context121.next = 14;
                  break;
                }

                _context121.next = 9;
                return this.utils.byId(modelID, relSequenceId);

              case 9:
                relSequence = _context121.sent;
                related_process = relSequence.RelatedProcess.value;
                relatingProcess = relSequence.RelatingProcess.value;
                this.tasks[relatingProcess]['IsPredecessorTo'].push(relSequence.expressID);
                this.tasks[related_process]['IsSucessorFrom'].push(relSequence.expressID);

              case 14:
                _i380++;
                _context121.next = 4;
                break;

              case 17:
              case "end":
                return _context121.stop();
            }
          }
        }, _callee110, this);
      }));

      function loadTaskSequence(_x173) {
        return _loadTaskSequence.apply(this, arguments);
      }

      return loadTaskSequence;
    }()
  }, {
    key: "loadTaskOutputs",
    value: function () {
      var _loadTaskOutputs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee111(modelID) {
        var rels_assigns_to_product, _i381, relAssignsToProduct, relatedObject, relatingProduct;

        return _regeneratorRuntime.wrap(function _callee111$(_context122) {
          while (1) {
            switch (_context122.prev = _context122.next) {
              case 0:
                _context122.next = 2;
                return this.utils.byType(modelID, 'IfcRelAssignsToProduct');

              case 2:
                rels_assigns_to_product = _context122.sent;
                _i381 = 0;

              case 4:
                if (!(_i381 < rels_assigns_to_product.length)) {
                  _context122.next = 17;
                  break;
                }

                relAssignsToProduct = rels_assigns_to_product[_i381];
                _context122.next = 8;
                return this.utils.byId(modelID, relAssignsToProduct.RelatedObjects[0].value);

              case 8:
                relatedObject = _context122.sent;

                if (!this.utils.isA(relatedObject, 'IfcTask')) {
                  _context122.next = 14;
                  break;
                }

                _context122.next = 12;
                return this.utils.byId(modelID, relAssignsToProduct.RelatingProduct.value);

              case 12:
                relatingProduct = _context122.sent;
                this.tasks[relatedObject.expressID]['Outputs'].push(relatingProduct.expressID);

              case 14:
                _i381++;
                _context122.next = 4;
                break;

              case 17:
              case "end":
                return _context122.stop();
            }
          }
        }, _callee111, this);
      }));

      function loadTaskOutputs(_x174) {
        return _loadTaskOutputs.apply(this, arguments);
      }

      return loadTaskOutputs;
    }()
  }, {
    key: "loadTaskNesting",
    value: function () {
      var _loadTaskNesting = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee112(modelID) {
        var rels_nests, _i382, relNests, relating_object, relatedObjects, object_index;

        return _regeneratorRuntime.wrap(function _callee112$(_context123) {
          while (1) {
            switch (_context123.prev = _context123.next) {
              case 0:
                _context123.next = 2;
                return this.utils.byType(modelID, 'IfcRelNests');

              case 2:
                rels_nests = _context123.sent;
                _i382 = 0;

              case 4:
                if (!(_i382 < rels_nests.length)) {
                  _context123.next = 13;
                  break;
                }

                relNests = rels_nests[_i382];
                _context123.next = 8;
                return this.utils.byId(modelID, relNests.RelatingObject.value);

              case 8:
                relating_object = _context123.sent;

                if (this.utils.isA(relating_object, 'IfcTask')) {
                  relatedObjects = relNests.RelatedObjects;

                  for (object_index = 0; object_index < relatedObjects.length; object_index++) {
                    this.tasks[relating_object.expressID]['IsNestedBy'].push(relatedObjects[object_index].value);
                    this.tasks[relatedObjects[object_index].value]['Nests'].push(relating_object.expressID);
                  }
                }

              case 10:
                _i382++;
                _context123.next = 4;
                break;

              case 13:
              case "end":
                return _context123.stop();
            }
          }
        }, _callee112, this);
      }));

      function loadTaskNesting(_x175) {
        return _loadTaskNesting.apply(this, arguments);
      }

      return loadTaskNesting;
    }()
  }, {
    key: "loadTaskOperations",
    value: function () {
      var _loadTaskOperations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee113(modelID) {
        var relsAssignsToProcess, _i383, relAssignToProcess, relatingProcess, relatedObjects, object_index;

        return _regeneratorRuntime.wrap(function _callee113$(_context124) {
          while (1) {
            switch (_context124.prev = _context124.next) {
              case 0:
                _context124.next = 2;
                return this.utils.byType(modelID, 'IfcRelAssignsToProcess');

              case 2:
                relsAssignsToProcess = _context124.sent;
                _i383 = 0;

              case 4:
                if (!(_i383 < relsAssignsToProcess.length)) {
                  _context124.next = 13;
                  break;
                }

                relAssignToProcess = relsAssignsToProcess[_i383];
                _context124.next = 8;
                return this.utils.byId(modelID, relAssignToProcess.RelatingProcess.value);

              case 8:
                relatingProcess = _context124.sent;

                if (this.utils.isA(relatingProcess, 'IfcTask')) {
                  relatedObjects = relAssignToProcess.RelatedObjects;

                  for (object_index = 0; object_index < relatedObjects.length; object_index++) {
                    this.tasks[relatingProcess.expressID]['OperatesOn'].push(relatedObjects[object_index].value);
                  }
                }

              case 10:
                _i383++;
                _context124.next = 4;
                break;

              case 13:
              case "end":
                return _context124.stop();
            }
          }
        }, _callee113, this);
      }));

      function loadTaskOperations(_x176) {
        return _loadTaskOperations.apply(this, arguments);
      }

      return loadTaskOperations;
    }()
  }, {
    key: "loadAssignementsWorkCalendar",
    value: function () {
      var _loadAssignementsWorkCalendar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee114(modelID) {
        var relsAssignsToControl, _i384, relAssignsToControl, relatingControl, relatedObjects, object_index;

        return _regeneratorRuntime.wrap(function _callee114$(_context125) {
          while (1) {
            switch (_context125.prev = _context125.next) {
              case 0:
                _context125.next = 2;
                return this.utils.byType(modelID, 'IfcRelAssignsToControl');

              case 2:
                relsAssignsToControl = _context125.sent;
                _i384 = 0;

              case 4:
                if (!(_i384 < relsAssignsToControl.length)) {
                  _context125.next = 13;
                  break;
                }

                relAssignsToControl = relsAssignsToControl[_i384];
                _context125.next = 8;
                return this.utils.byId(modelID, relAssignsToControl.RelatingControl.value);

              case 8:
                relatingControl = _context125.sent;

                if (this.utils.isA(relatingControl, 'IfcWorkCalendar')) {
                  relatedObjects = relAssignsToControl.RelatedObjects;

                  for (object_index = 0; object_index < relatedObjects.length; object_index++) {
                    this.tasks[relatedObjects[object_index].value]['HasAssignmentsWorkCalendars'].push(relatingControl.expressID);
                  }
                }

              case 10:
                _i384++;
                _context125.next = 4;
                break;

              case 13:
              case "end":
                return _context125.stop();
            }
          }
        }, _callee114, this);
      }));

      function loadAssignementsWorkCalendar(_x177) {
        return _loadAssignementsWorkCalendar.apply(this, arguments);
      }

      return loadAssignementsWorkCalendar;
    }()
  }, {
    key: "loadWorkCalendars",
    value: function () {
      var _loadWorkCalendars = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee115(modelID) {
        var workCalendars, _i385, workCalendar, workCalenderData;

        return _regeneratorRuntime.wrap(function _callee115$(_context126) {
          while (1) {
            switch (_context126.prev = _context126.next) {
              case 0:
                _context126.next = 2;
                return this.utils.byType(modelID, 'IfcWorkCalendar');

              case 2:
                workCalendars = _context126.sent;

                for (_i385 = 0; _i385 < workCalendars.length; _i385++) {
                  workCalendar = workCalendars[_i385];
                  workCalenderData = {
                    Id: workCalendar.expressID,
                    Name: workCalendar.Name ? workCalendar.Name.value : '',
                    Description: workCalendar.Description ? workCalendar.Description.value : '',
                    WorkingTimes: workCalendar.WorkingTimes ? workCalendar.WorkingTimes : [],
                    ExceptionTimes: workCalendar.ExceptionTimes ? workCalendar.ExceptionTimes : []
                  };
                  this.workCalendars[workCalendar.expressID] = workCalenderData;
                }

              case 4:
              case "end":
                return _context126.stop();
            }
          }
        }, _callee115, this);
      }));

      function loadWorkCalendars(_x178) {
        return _loadWorkCalendars.apply(this, arguments);
      }

      return loadWorkCalendars;
    }()
  }, {
    key: "loadWorkTimes",
    value: function () {
      var _loadWorkTimes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee116(modelID) {
        var workTimes, _i386, workTime, workTimeData;

        return _regeneratorRuntime.wrap(function _callee116$(_context127) {
          while (1) {
            switch (_context127.prev = _context127.next) {
              case 0:
                _context127.next = 2;
                return this.utils.byType(modelID, 'IfcWorkTime');

              case 2:
                workTimes = _context127.sent;
                _i386 = 0;

              case 4:
                if (!(_i386 < workTimes.length)) {
                  _context127.next = 22;
                  break;
                }

                workTime = workTimes[_i386];
                _context127.t0 = workTime.Name ? workTime.Name.value : '';

                if (!workTime.RecurrencePattern) {
                  _context127.next = 13;
                  break;
                }

                _context127.next = 10;
                return this.utils.byId(modelID, workTime.RecurrencePattern.value);

              case 10:
                _context127.t1 = _context127.sent;
                _context127.next = 14;
                break;

              case 13:
                _context127.t1 = '';

              case 14:
                _context127.t2 = _context127.t1;
                _context127.t3 = workTime.Start ? new Date(workTime.Start.value) : '';
                _context127.t4 = workTime.Finish ? new Date(workTime.Finish.value) : '';
                workTimeData = {
                  Name: _context127.t0,
                  RecurrencePattern: _context127.t2,
                  Start: _context127.t3,
                  Finish: _context127.t4
                };
                this.workTimes[workTime.expressID] = workTimeData;

              case 19:
                _i386++;
                _context127.next = 4;
                break;

              case 22:
              case "end":
                return _context127.stop();
            }
          }
        }, _callee116, this);
      }));

      function loadWorkTimes(_x179) {
        return _loadWorkTimes.apply(this, arguments);
      }

      return loadWorkTimes;
    }()
  }, {
    key: "loadTimePeriods",
    value: function () {
      var _loadTimePeriods = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee117(modelID) {
        var timePeriods, _i387, timePeriod, workTimeData;

        return _regeneratorRuntime.wrap(function _callee117$(_context128) {
          while (1) {
            switch (_context128.prev = _context128.next) {
              case 0:
                _context128.next = 2;
                return this.utils.byType(modelID, 'IfcTimePeriod');

              case 2:
                timePeriods = _context128.sent;

                for (_i387 = 0; _i387 < timePeriods.length; _i387++) {
                  timePeriod = timePeriods[_i387];
                  workTimeData = {
                    StartTime: timePeriod.StartTime ? new Date(timePeriod.StartTime.value) : '',
                    EndTime: timePeriod.EndTime ? new Date(timePeriod.EndTime.value) : ''
                  };
                  this.timePeriods[timePeriod.expressID] = workTimeData;
                }

              case 4:
              case "end":
                return _context128.stop();
            }
          }
        }, _callee117, this);
      }));

      function loadTimePeriods(_x180) {
        return _loadTimePeriods.apply(this, arguments);
      }

      return loadTimePeriods;
    }()
  }]);

  return Data;
}();

var IFCManager = /*#__PURE__*/function () {
  function IFCManager() {
    _classCallCheck2(this, IFCManager);

    this.state = {
      models: [],
      api: new IfcAPI2(),
      useJSON: false,
      worker: {
        active: false,
        path: ''
      }
    };
    this.BVH = new BvhManager();
    this.parser = new IFCParser(this.state, this.BVH);
    this.subsets = new SubsetManager(this.state, this.BVH);
    this.utils = new IFCUtils(this.state);
    this.sequenceData = new Data(this.state);
    this.properties = new PropertyManager(this.state);
    this.types = new TypeManager(this.state);
    this.useFragments = false;
    this.cleaner = new MemoryCleaner(this.state);
  }

  _createClass2(IFCManager, [{
    key: "ifcAPI",
    get: function get() {
      return this.state.api;
    }
  }, {
    key: "parse",
    value: function () {
      var _parse3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee118(buffer) {
        var _a, model;

        return _regeneratorRuntime.wrap(function _callee118$(_context129) {
          while (1) {
            switch (_context129.prev = _context129.next) {
              case 0:
                _context129.next = 2;
                return this.parser.parse(buffer, (_a = this.state.coordinationMatrix) === null || _a === void 0 ? void 0 : _a.toArray());

              case 2:
                model = _context129.sent;
                model.setIFCManager(this);
                _context129.prev = 4;
                _context129.next = 7;
                return this.types.getAllTypes(this.worker);

              case 7:
                _context129.next = 12;
                break;

              case 9:
                _context129.prev = 9;
                _context129.t0 = _context129["catch"](4);
                console.log('Could not get all types of model.');

              case 12:
                return _context129.abrupt("return", model);

              case 13:
              case "end":
                return _context129.stop();
            }
          }
        }, _callee118, this, [[4, 9]]);
      }));

      function parse(_x181) {
        return _parse3.apply(this, arguments);
      }

      return parse;
    }()
  }, {
    key: "setWasmPath",
    value: function () {
      var _setWasmPath = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee119(path) {
        return _regeneratorRuntime.wrap(function _callee119$(_context130) {
          while (1) {
            switch (_context130.prev = _context130.next) {
              case 0:
                this.state.api.SetWasmPath(path);
                this.state.wasmPath = path;

              case 2:
              case "end":
                return _context130.stop();
            }
          }
        }, _callee119, this);
      }));

      function setWasmPath(_x182) {
        return _setWasmPath.apply(this, arguments);
      }

      return setWasmPath;
    }()
  }, {
    key: "setupThreeMeshBVH",
    value: function setupThreeMeshBVH(computeBoundsTree, disposeBoundsTree, acceleratedRaycast) {
      this.BVH.initializeMeshBVH(computeBoundsTree, disposeBoundsTree, acceleratedRaycast);
    }
  }, {
    key: "setOnProgress",
    value: function setOnProgress(onProgress) {
      this.state.onProgress = onProgress;
    }
  }, {
    key: "setupCoordinationMatrix",
    value: function setupCoordinationMatrix(matrix) {
      this.state.coordinationMatrix = matrix;
    }
  }, {
    key: "clearCoordinationMatrix",
    value: function clearCoordinationMatrix() {
      delete this.state.coordinationMatrix;
    }
  }, {
    key: "applyWebIfcConfig",
    value: function () {
      var _applyWebIfcConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee120(settings) {
        return _regeneratorRuntime.wrap(function _callee120$(_context131) {
          while (1) {
            switch (_context131.prev = _context131.next) {
              case 0:
                this.state.webIfcSettings = settings;

                if (!(this.state.worker.active && this.worker)) {
                  _context131.next = 4;
                  break;
                }

                _context131.next = 4;
                return this.worker.workerState.updateStateWebIfcSettings();

              case 4:
              case "end":
                return _context131.stop();
            }
          }
        }, _callee120, this);
      }));

      function applyWebIfcConfig(_x183) {
        return _applyWebIfcConfig.apply(this, arguments);
      }

      return applyWebIfcConfig;
    }()
  }, {
    key: "useWebWorkers",
    value: function () {
      var _useWebWorkers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee121(active, path) {
        var wasm;
        return _regeneratorRuntime.wrap(function _callee121$(_context132) {
          while (1) {
            switch (_context132.prev = _context132.next) {
              case 0:
                if (!(this.state.worker.active === active)) {
                  _context132.next = 2;
                  break;
                }

                return _context132.abrupt("return");

              case 2:
                this.state.api = null;

                if (!active) {
                  _context132.next = 16;
                  break;
                }

                if (path) {
                  _context132.next = 6;
                  break;
                }

                throw new Error('You must provide a path to the web worker.');

              case 6:
                this.state.worker.active = active;
                this.state.worker.path = path;
                _context132.next = 10;
                return this.initializeWorkers();

              case 10:
                wasm = this.state.wasmPath;

                if (!wasm) {
                  _context132.next = 14;
                  break;
                }

                _context132.next = 14;
                return this.setWasmPath(wasm);

              case 14:
                _context132.next = 17;
                break;

              case 16:
                this.state.api = new IfcAPI2();

              case 17:
              case "end":
                return _context132.stop();
            }
          }
        }, _callee121, this);
      }));

      function useWebWorkers(_x184, _x185) {
        return _useWebWorkers.apply(this, arguments);
      }

      return useWebWorkers;
    }()
  }, {
    key: "useJSONData",
    value: function () {
      var _useJSONData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee122() {
        var useJSON,
            _a,
            _args132 = arguments;

        return _regeneratorRuntime.wrap(function _callee122$(_context133) {
          while (1) {
            switch (_context133.prev = _context133.next) {
              case 0:
                useJSON = _args132.length > 0 && _args132[0] !== undefined ? _args132[0] : true;
                this.state.useJSON = useJSON;

                if (!useJSON) {
                  _context133.next = 5;
                  break;
                }

                _context133.next = 5;
                return (_a = this.worker) === null || _a === void 0 ? void 0 : _a.workerState.updateStateUseJson();

              case 5:
              case "end":
                return _context133.stop();
            }
          }
        }, _callee122, this);
      }));

      function useJSONData() {
        return _useJSONData.apply(this, arguments);
      }

      return useJSONData;
    }()
  }, {
    key: "addModelJSONData",
    value: function () {
      var _addModelJSONData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee123(modelID, data) {
        var _a, model;

        return _regeneratorRuntime.wrap(function _callee123$(_context134) {
          while (1) {
            switch (_context134.prev = _context134.next) {
              case 0:
                model = this.state.models[modelID];

                if (model) {
                  _context134.next = 3;
                  break;
                }

                throw new Error('The specified model for the JSON data does not exist');

              case 3:
                if (!this.state.worker.active) {
                  _context134.next = 8;
                  break;
                }

                _context134.next = 6;
                return (_a = this.worker) === null || _a === void 0 ? void 0 : _a.workerState.updateModelStateJsonData(modelID, data);

              case 6:
                _context134.next = 9;
                break;

              case 8:
                model.jsonData = data;

              case 9:
              case "end":
                return _context134.stop();
            }
          }
        }, _callee123, this);
      }));

      function addModelJSONData(_x186, _x187) {
        return _addModelJSONData.apply(this, arguments);
      }

      return addModelJSONData;
    }()
  }, {
    key: "loadJsonDataFromWorker",
    value: function () {
      var _loadJsonDataFromWorker2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee124(modelID, path) {
        var _a;

        return _regeneratorRuntime.wrap(function _callee124$(_context135) {
          while (1) {
            switch (_context135.prev = _context135.next) {
              case 0:
                if (!this.state.worker.active) {
                  _context135.next = 3;
                  break;
                }

                _context135.next = 3;
                return (_a = this.worker) === null || _a === void 0 ? void 0 : _a.workerState.loadJsonDataFromWorker(modelID, path);

              case 3:
              case "end":
                return _context135.stop();
            }
          }
        }, _callee124, this);
      }));

      function loadJsonDataFromWorker(_x188, _x189) {
        return _loadJsonDataFromWorker2.apply(this, arguments);
      }

      return loadJsonDataFromWorker;
    }()
  }, {
    key: "close",
    value: function close(modelID, scene) {
      try {
        this.state.api.CloseModel(modelID);
        var mesh = this.state.models[modelID].mesh;
        var geometry = mesh.geometry,
            material = mesh.material;
        if (scene) scene.remove(mesh);
        geometry === null || geometry === void 0 ? void 0 : geometry.dispose();
        Array.isArray(material) ? material.forEach(function (m) {
          return m.dispose();
        }) : material === null || material === void 0 ? void 0 : material.dispose();
        delete this.state.models[modelID];
      } catch (e) {
        console.warn("Close IFCModel ".concat(modelID, " failed"));
      }
    }
  }, {
    key: "getExpressId",
    value: function getExpressId(geometry, faceIndex) {
      return this.properties.getExpressId(geometry, faceIndex);
    }
  }, {
    key: "getAllItemsOfType",
    value: function getAllItemsOfType(modelID, type, verbose) {
      return this.properties.getAllItemsOfType(modelID, type, verbose);
    }
  }, {
    key: "getItemProperties",
    value: function getItemProperties(modelID, id) {
      var recursive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return this.properties.getItemProperties(modelID, id, recursive);
    }
  }, {
    key: "getPropertySets",
    value: function getPropertySets(modelID, id) {
      var recursive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return this.properties.getPropertySets(modelID, id, recursive);
    }
  }, {
    key: "getTypeProperties",
    value: function getTypeProperties(modelID, id) {
      var recursive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return this.properties.getTypeProperties(modelID, id, recursive);
    }
  }, {
    key: "getMaterialsProperties",
    value: function getMaterialsProperties(modelID, id) {
      var recursive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return this.properties.getMaterialsProperties(modelID, id, recursive);
    }
  }, {
    key: "getIfcType",
    value: function getIfcType(modelID, id) {
      var typeID = this.state.models[modelID].types[id];
      return this.state.api.GetNameFromTypeCode(typeID);
    }
  }, {
    key: "getSpatialStructure",
    value: function getSpatialStructure(modelID, includeProperties) {
      return this.properties.getSpatialStructure(modelID, includeProperties);
    }
  }, {
    key: "getSubset",
    value: function getSubset(modelID, material, customId) {
      return this.subsets.getSubset(modelID, material, customId);
    }
  }, {
    key: "removeSubset",
    value: function removeSubset(modelID, material, customID) {
      this.subsets.removeSubset(modelID, material, customID);
    }
  }, {
    key: "createSubset",
    value: function createSubset(config) {
      return this.subsets.createSubset(config);
    }
  }, {
    key: "removeFromSubset",
    value: function removeFromSubset(modelID, ids, customID, material) {
      return this.subsets.removeFromSubset(modelID, ids, customID, material);
    }
  }, {
    key: "clearSubset",
    value: function clearSubset(modelID, customID, material) {
      return this.subsets.clearSubset(modelID, customID, material);
    }
  }, {
    key: "isA",
    value: function () {
      var _isA = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee125(entity, entity_class) {
        return _regeneratorRuntime.wrap(function _callee125$(_context136) {
          while (1) {
            switch (_context136.prev = _context136.next) {
              case 0:
                return _context136.abrupt("return", this.utils.isA(entity, entity_class));

              case 1:
              case "end":
                return _context136.stop();
            }
          }
        }, _callee125, this);
      }));

      function isA(_x190, _x191) {
        return _isA.apply(this, arguments);
      }

      return isA;
    }()
  }, {
    key: "getSequenceData",
    value: function () {
      var _getSequenceData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee126(modelID) {
        return _regeneratorRuntime.wrap(function _callee126$(_context137) {
          while (1) {
            switch (_context137.prev = _context137.next) {
              case 0:
                _context137.next = 2;
                return this.sequenceData.load(modelID);

              case 2:
                return _context137.abrupt("return", this.sequenceData);

              case 3:
              case "end":
                return _context137.stop();
            }
          }
        }, _callee126, this);
      }));

      function getSequenceData(_x192) {
        return _getSequenceData.apply(this, arguments);
      }

      return getSequenceData;
    }()
  }, {
    key: "byType",
    value: function () {
      var _byType2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee127(modelID, entityClass) {
        return _regeneratorRuntime.wrap(function _callee127$(_context138) {
          while (1) {
            switch (_context138.prev = _context138.next) {
              case 0:
                return _context138.abrupt("return", this.utils.byType(modelID, entityClass));

              case 1:
              case "end":
                return _context138.stop();
            }
          }
        }, _callee127, this);
      }));

      function byType(_x193, _x194) {
        return _byType2.apply(this, arguments);
      }

      return byType;
    }()
  }, {
    key: "byId",
    value: function () {
      var _byId2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee128(modelID, id) {
        return _regeneratorRuntime.wrap(function _callee128$(_context139) {
          while (1) {
            switch (_context139.prev = _context139.next) {
              case 0:
                return _context139.abrupt("return", this.utils.byId(modelID, id));

              case 1:
              case "end":
                return _context139.stop();
            }
          }
        }, _callee128, this);
      }));

      function byId(_x195, _x196) {
        return _byId2.apply(this, arguments);
      }

      return byId;
    }()
  }, {
    key: "idsByType",
    value: function () {
      var _idsByType2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee129(modelID, entityClass) {
        return _regeneratorRuntime.wrap(function _callee129$(_context140) {
          while (1) {
            switch (_context140.prev = _context140.next) {
              case 0:
                return _context140.abrupt("return", this.utils.idsByType(modelID, entityClass));

              case 1:
              case "end":
                return _context140.stop();
            }
          }
        }, _callee129, this);
      }));

      function idsByType(_x197, _x198) {
        return _idsByType2.apply(this, arguments);
      }

      return idsByType;
    }()
  }, {
    key: "dispose",
    value: function () {
      var _dispose3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee130() {
        return _regeneratorRuntime.wrap(function _callee130$(_context141) {
          while (1) {
            switch (_context141.prev = _context141.next) {
              case 0:
                IFCModel.dispose();
                _context141.next = 3;
                return this.cleaner.dispose();

              case 3:
                this.subsets.dispose();

                if (!(this.worker && this.state.worker.active)) {
                  _context141.next = 7;
                  break;
                }

                _context141.next = 7;
                return this.worker.terminate();

              case 7:
                this.state = null;

              case 8:
              case "end":
                return _context141.stop();
            }
          }
        }, _callee130, this);
      }));

      function dispose() {
        return _dispose3.apply(this, arguments);
      }

      return dispose;
    }()
  }, {
    key: "disposeMemory",
    value: function () {
      var _disposeMemory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee131() {
        var _a;

        return _regeneratorRuntime.wrap(function _callee131$(_context142) {
          while (1) {
            switch (_context142.prev = _context142.next) {
              case 0:
                if (!this.state.worker.active) {
                  _context142.next = 5;
                  break;
                }

                _context142.next = 3;
                return (_a = this.worker) === null || _a === void 0 ? void 0 : _a.Close();

              case 3:
                _context142.next = 8;
                break;

              case 5:
                this.state.api.Close();
                this.state.api = null;
                this.state.api = new IfcAPI2();

              case 8:
              case "end":
                return _context142.stop();
            }
          }
        }, _callee131, this);
      }));

      function disposeMemory() {
        return _disposeMemory.apply(this, arguments);
      }

      return disposeMemory;
    }()
  }, {
    key: "getAndClearErrors",
    value: function getAndClearErrors(modelID) {
      return this.parser.getAndClearErrors(modelID);
    }
  }, {
    key: "initializeWorkers",
    value: function () {
      var _initializeWorkers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee132() {
        return _regeneratorRuntime.wrap(function _callee132$(_context143) {
          while (1) {
            switch (_context143.prev = _context143.next) {
              case 0:
                this.worker = new IFCWorkerHandler(this.state, this.BVH);
                this.state.api = this.worker.webIfc;
                this.properties = this.worker.properties;
                _context143.next = 5;
                return this.worker.parser.setupOptionalCategories(this.parser.optionalCategories);

              case 5:
                this.parser = this.worker.parser;
                _context143.next = 8;
                return this.worker.workerState.updateStateUseJson();

              case 8:
                _context143.next = 10;
                return this.worker.workerState.updateStateWebIfcSettings();

              case 10:
              case "end":
                return _context143.stop();
            }
          }
        }, _callee132, this);
      }));

      function initializeWorkers() {
        return _initializeWorkers.apply(this, arguments);
      }

      return initializeWorkers;
    }()
  }]);

  return IFCManager;
}();

var IFCLoader = /*#__PURE__*/function (_Loader6) {
  _inherits(IFCLoader, _Loader6);

  var _super2396 = _createSuper(IFCLoader);

  function IFCLoader(manager) {
    var _this2415;

    _classCallCheck2(this, IFCLoader);

    _this2415 = _super2396.call(this, manager);
    _this2415.ifcManager = new IFCManager();
    return _this2415;
  }

  _createClass2(IFCLoader, [{
    key: "load",
    value: function load(url, onLoad, onProgress, onError) {
      var scope = this;
      var loader = new FileLoader(scope.manager);
      this.onProgress = onProgress;
      loader.setPath(scope.path);
      loader.setResponseType('arraybuffer');
      loader.setRequestHeader(scope.requestHeader);
      loader.setWithCredentials(scope.withCredentials);
      loader.load(url, /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee133(buffer) {
          return _regeneratorRuntime.wrap(function _callee133$(_context144) {
            while (1) {
              switch (_context144.prev = _context144.next) {
                case 0:
                  _context144.prev = 0;

                  if (!(typeof buffer == 'string')) {
                    _context144.next = 3;
                    break;
                  }

                  throw new Error('IFC files must be given as a buffer!');

                case 3:
                  _context144.t0 = onLoad;
                  _context144.next = 6;
                  return scope.parse(buffer);

                case 6:
                  _context144.t1 = _context144.sent;
                  (0, _context144.t0)(_context144.t1);
                  _context144.next = 14;
                  break;

                case 10:
                  _context144.prev = 10;
                  _context144.t2 = _context144["catch"](0);

                  if (onError) {
                    onError(_context144.t2);
                  } else {
                    console.error(_context144.t2);
                  }

                  scope.manager.itemError(url);

                case 14:
                case "end":
                  return _context144.stop();
              }
            }
          }, _callee133, null, [[0, 10]]);
        }));

        return function (_x199) {
          return _ref4.apply(this, arguments);
        };
      }(), onProgress, onError);
    }
  }, {
    key: "parse",
    value: function parse(buffer) {
      return this.ifcManager.parse(buffer);
    }
  }]);

  return IFCLoader;
}(Loader);

var flattenJSON = function flattenJSON(obj, res, accumulatedKey) {
  if (obj === void 0) {
    obj = {};
  }

  if (res === void 0) {
    res = {};
  }

  if (accumulatedKey === void 0) {
    accumulatedKey = '';
  }

  if (obj) {
    var keys = Object.keys(obj);
    keys.forEach(function (key) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      var value = obj[key];

      if (typeof value !== 'object') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        res[accumulatedKey + key] = value;
      } else {
        flattenJSON(value, res, "" + accumulatedKey + key + ".");
      }
    });
  }

  return res;
};

var CRB_USAGE_PARAMETER_NAME = 'crb_ch_use';
/**
 * The goal of this class is to read the provided IFC file.
 * The model read from the file consists of multiple 3D objects
 * that we will call primitives.
 * For each primitive we retrieve the necessary information, such as:
 * - express ID
 * - geometry (meshes, triangles etc.)
 * - properties (item properties, property sets and type properties)
 *
 * Additionally, we also compute real projected area and
 * floor area for each primitive.
 *
 * This class also extract the floors structure of the model.
 * This structure will be useful for some calculations later.
 */

var IfcHandler =
/** @class */
function () {
  function IfcHandler() {
    var _this = this;
    /**
     * Extract the usage of a primitive from its properties.
     * Parameter with name CRB_USAGE_PARAMETER_NAME stores the usage information.
     *
     * @param properties The properties of the primitive
     */


    this.extractUsage = function (properties) {
      _this.logFUnction('Extract usage if parameter is provided');

      return getPropertyValueByParameter(properties, {
        name: CRB_USAGE_PARAMETER_NAME
      });
    };

    this.loader = null;
    this.manager = null;
    this.modelIds = [];

    this.logFUnction = function () {
      return 0;
    };
  }

  IfcHandler.prototype.dispose = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.modelIds.forEach(function (model) {
              return _this.manager.close(model);
            });
            this.modelIds.length = 0;
            return [4
            /*yield*/
            , this.manager.dispose()];

          case 1:
            _a.sent();

            this.loader = null;
            this.manager = null;
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  IfcHandler.prototype.setup = function (args) {
    return __awaiter(this, void 0, void 0, function () {
      var ifcLoader;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            ifcLoader = new IFCLoader();
            return [4
            /*yield*/
            , ifcLoader.ifcManager.setWasmPath('../../../../')];

          case 1:
            _a.sent();

            this.loader = ifcLoader;
            this.manager = ifcLoader.ifcManager;
            this.setupThreeMeshBVH();

            if (args) {
              if (Object.keys(args).includes('logger') && typeof args['logger'] === 'function') {
                this.logFUnction = args['logger'];
              }
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  IfcHandler.prototype.setupThreeMeshBVH = function () {
    this.manager.setupThreeMeshBVH(computeBoundsTree, disposeBoundsTree, acceleratedRaycast);
  };

  IfcHandler.prototype.loadAndExtractModel = function (fileBuffer, models, messages) {
    return __awaiter(this, void 0, void 0, function () {
      var ifcModel, error_1, msg, msg;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(typeof fileBuffer === 'string')) return [3
            /*break*/
            , 6];
            _a.label = 1;

          case 1:
            _a.trys.push([1, 4,, 5]);

            this.logFUnction('Loading model');
            return [4
            /*yield*/
            , this.loader.loadAsync(fileBuffer)];

          case 2:
            ifcModel = _a.sent();
            return [4
            /*yield*/
            , this.extractIfcModel(ifcModel, models, messages)];

          case 3:
            _a.sent();

            return [3
            /*break*/
            , 5];

          case 4:
            error_1 = _a.sent();
            console.error(error_1);
            msg = {
              type: 'error',
              message: "IFCHandler failed while loading the file: " + error_1
            };
            messages.push(msg);
            return [3
            /*break*/
            , 5];

          case 5:
            return [3
            /*break*/
            , 7];

          case 6:
            msg = {
              type: 'error',
              message: 'Input file has no string content'
            };
            messages.push(msg);
            throw new Error('File content is not a string');

          case 7:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  IfcHandler.prototype.extractIfcModel = function (ifcModel, models, messages) {
    return __awaiter(this, void 0, void 0, function () {
      var msg, modelID, modelMesh, floors, primitives, ifcBuildingModel;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!ifcModel.isMesh) return [3
            /*break*/
            , 3];
            modelID = ifcModel.modelID;
            this.modelIds.push(modelID);
            this.logFUnction('Model loaded with ID ', modelID);
            modelMesh = ifcModel;
            return [4
            /*yield*/
            , this.extractFloors(modelID)];

          case 1:
            floors = _a.sent();
            return [4
            /*yield*/
            , this.extractData(modelID, modelMesh, floors)];

          case 2:
            primitives = _a.sent();
            this.logFUnction("Extracted " + primitives.length + " primitives");
            ifcBuildingModel = {
              id: modelID,
              mesh: modelMesh,
              primitives: primitives,
              floors: floors
            };
            models.push(ifcBuildingModel);
            msg = {
              type: 'info',
              message: 'IFCHandler loaded file successfully'
            };
            return [3
            /*break*/
            , 4];

          case 3:
            msg = {
              type: 'warning',
              message: 'IFCHandler loaded file successfully but model was not a mesh'
            };
            _a.label = 4;

          case 4:
            messages.push(msg);
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  IfcHandler.prototype.extractData = function (modelId, modelMesh, floors) {
    return __awaiter(this, void 0, void 0, function () {
      var expressIds, primitiveProperties, primitiveFloors, primitiveGeometries, geometryHandler, primitiveExtraGeometries, primitives;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.logFUnction('Extract Data');
            expressIds = this.extractExpressIDs(modelMesh);
            return [4
            /*yield*/
            , this.extractProperties(modelId, expressIds)];

          case 1:
            primitiveProperties = _a.sent();
            return [4
            /*yield*/
            , this.assignFloorToExpressIDs(floors, expressIds)];

          case 2:
            primitiveFloors = _a.sent();
            return [4
            /*yield*/
            , this.extractGeometry(modelId, expressIds)];

          case 3:
            primitiveGeometries = _a.sent();
            geometryHandler = new GeometryHandler(this.logFUnction);
            primitiveExtraGeometries = geometryHandler.computeExtraGeometry(primitiveGeometries);
            primitives = expressIds.map(function (id) {
              return {
                expressId: id,
                geometry: {
                  mesh: primitiveGeometries.get(id),
                  boundingBox: new Box3(),
                  triangles: primitiveExtraGeometries.get(id).triangles,
                  quantities: {
                    realProjectedArea: primitiveExtraGeometries.get(id).realProjectedArea,
                    floorArea: primitiveExtraGeometries.get(id).floorArea,
                    volume: -1,
                    centerOfMass: new Vector3()
                  }
                },
                properties: primitiveProperties.get(id),
                crbCode: DEFAULT_CRB_CODE,
                crbClass: DEFAULT_CRB_CLASS,
                floor: primitiveFloors.get(id)
              };
            });
            return [2
            /*return*/
            , primitives];
        }
      });
    });
  };

  IfcHandler.prototype.extractExpressIDs = function (modelMesh) {
    this.logFUnction('Extract ExpressIDs');
    var meshGeometryAttributes = modelMesh.geometry.attributes;
    var expressIdObj = meshGeometryAttributes.expressID;
    var expressIdList = Array.from(expressIdObj.array);

    var uniqueExpressIDs = __spread(new Set(expressIdList));

    return uniqueExpressIDs;
  };

  IfcHandler.prototype.extractProperties = function (modelId, expressIDs) {
    return __awaiter(this, void 0, void 0, function () {
      var propertiesMap, expressIDs_1, expressIDs_1_1, id, ip, ps, tp, allProps, usage, properties, e_1_1;

      var e_1, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.logFUnction('Extract Properties');
            propertiesMap = new Map();
            _b.label = 1;

          case 1:
            _b.trys.push([1, 8, 9, 10]);

            expressIDs_1 = __values(expressIDs), expressIDs_1_1 = expressIDs_1.next();
            _b.label = 2;

          case 2:
            if (!!expressIDs_1_1.done) return [3
            /*break*/
            , 7];
            id = expressIDs_1_1.value;
            console.log("Properties for ExpressID " + id);
            return [4
            /*yield*/
            , this.getItemProperties(modelId, id)];

          case 3:
            ip = _b.sent();
            return [4
            /*yield*/
            , this.getPropertySets(modelId, id)];

          case 4:
            ps = _b.sent();
            return [4
            /*yield*/
            , this.getTypeProperties(modelId, id)];

          case 5:
            tp = _b.sent();
            allProps = {
              itemProps: ip,
              propSets: ps,
              typeProps: tp
            };
            usage = this.extractUsage(allProps);
            properties = usage && usage !== '' ? _assign(_assign({}, allProps), {
              usage: usage
            }) : allProps;
            propertiesMap.set(id, properties);
            this.logFUnction("Item props: " + JSON.stringify(properties.itemProps));
            this.logFUnction("Type props: " + JSON.stringify(properties.typeProps));
            this.logFUnction("Property sets: " + JSON.stringify(properties.propSets));
            if (properties.usage) this.logFUnction("Usage: " + properties.usage);
            _b.label = 6;

          case 6:
            expressIDs_1_1 = expressIDs_1.next();
            return [3
            /*break*/
            , 2];

          case 7:
            return [3
            /*break*/
            , 10];

          case 8:
            e_1_1 = _b.sent();
            e_1 = {
              error: e_1_1
            };
            return [3
            /*break*/
            , 10];

          case 9:
            try {
              if (expressIDs_1_1 && !expressIDs_1_1.done && (_a = expressIDs_1.return)) _a.call(expressIDs_1);
            } finally {
              if (e_1) throw e_1.error;
            }

            return [7
            /*endfinally*/
            ];

          case 10:
            return [2
            /*return*/
            , propertiesMap];
        }
      });
    });
  };

  IfcHandler.prototype.getItemProperties = function (modelId, expressId) {
    return __awaiter(this, void 0, void 0, function () {
      var ip;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.manager.getItemProperties(modelId, expressId, true)];

          case 1:
            ip = _a.sent();
            return [2
            /*return*/
            , flattenJSON(ip)];
        }
      });
    });
  };

  IfcHandler.prototype.getTypeProperties = function (modelId, expressId) {
    return __awaiter(this, void 0, void 0, function () {
      var tp;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.manager.getTypeProperties(modelId, expressId, true)];

          case 1:
            tp = _a.sent();
            return [2
            /*return*/
            , flattenJSON(tp)];
        }
      });
    });
  };

  IfcHandler.prototype.getPropertySets = function (modelId, expressId) {
    return __awaiter(this, void 0, void 0, function () {
      var ps;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.manager.getPropertySets(modelId, expressId, true)];

          case 1:
            ps = _a.sent();
            return [2
            /*return*/
            , flattenJSON(ps)];
        }
      });
    });
  };
  /**
   * Function to extract the floors present in the ifc model.
   *
   * @param modelID ID of the model loaded from the ifc file
   */


  IfcHandler.prototype.extractFloors = function (modelID) {
    return __awaiter(this, void 0, void 0, function () {
      var modelFloors, floors, tree, ifcSite, ifcBuilding, ifcStoreys, ifcStoreys_1, ifcStoreys_1_1, f, modelFloors_1, modelFloors_1_1, floor, _a, e_2_1, e_3_1;

      var e_3, _b, e_2, _c;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            this.logFUnction('Extract Floors');
            modelFloors = [];
            return [4
            /*yield*/
            , this.manager.getAllItemsOfType(modelID, IFCBUILDINGSTOREY, true)];

          case 1:
            floors = _d.sent();
            floors.forEach(function (f) {
              var name = f.Name.value;
              var elevation = f.Elevation.value;
              var floorType;

              if (elevation < 0) {
                floorType = 'UNDER_GROUND';
              } else if (elevation === 0) {
                floorType = 'GROUND';
              } else if (elevation > 0) {
                floorType = 'ABOVE_GROUND';
              }

              var floor = {
                id: f.expressID,
                floorType: floorType,
                floorNumber: -9999,
                uses: [{
                  usage: '',
                  percentageArea: -9999,
                  useful: false
                }],
                name: name,
                childrenExpressIDs: [-9999],
                elevation: elevation
              };
              modelFloors.push(floor);
            });
            return [4
            /*yield*/
            , this.manager.getSpatialStructure(modelID)];

          case 2:
            tree = _d.sent();
            ifcSite = tree.children[0];
            ifcBuilding = ifcSite.children[0];
            ifcStoreys = ifcBuilding.children;
            _d.label = 3;

          case 3:
            _d.trys.push([3, 14, 15, 16]);

            ifcStoreys_1 = __values(ifcStoreys), ifcStoreys_1_1 = ifcStoreys_1.next();
            _d.label = 4;

          case 4:
            if (!!ifcStoreys_1_1.done) return [3
            /*break*/
            , 13];
            f = ifcStoreys_1_1.value;
            _d.label = 5;

          case 5:
            _d.trys.push([5, 10, 11, 12]);

            modelFloors_1 = (e_2 = void 0, __values(modelFloors)), modelFloors_1_1 = modelFloors_1.next();
            _d.label = 6;

          case 6:
            if (!!modelFloors_1_1.done) return [3
            /*break*/
            , 9];
            floor = modelFloors_1_1.value;

            if (f.expressID !== floor.id) {
              return [3
              /*break*/
              , 8];
            }

            _a = floor;
            return [4
            /*yield*/
            , this.getChildrenExpressIDsFromBuildingStorey(f)];

          case 7:
            _a.childrenExpressIDs = _d.sent();
            _d.label = 8;

          case 8:
            modelFloors_1_1 = modelFloors_1.next();
            return [3
            /*break*/
            , 6];

          case 9:
            return [3
            /*break*/
            , 12];

          case 10:
            e_2_1 = _d.sent();
            e_2 = {
              error: e_2_1
            };
            return [3
            /*break*/
            , 12];

          case 11:
            try {
              if (modelFloors_1_1 && !modelFloors_1_1.done && (_c = modelFloors_1.return)) _c.call(modelFloors_1);
            } finally {
              if (e_2) throw e_2.error;
            }

            return [7
            /*endfinally*/
            ];

          case 12:
            ifcStoreys_1_1 = ifcStoreys_1.next();
            return [3
            /*break*/
            , 4];

          case 13:
            return [3
            /*break*/
            , 16];

          case 14:
            e_3_1 = _d.sent();
            e_3 = {
              error: e_3_1
            };
            return [3
            /*break*/
            , 16];

          case 15:
            try {
              if (ifcStoreys_1_1 && !ifcStoreys_1_1.done && (_b = ifcStoreys_1.return)) _b.call(ifcStoreys_1);
            } finally {
              if (e_3) throw e_3.error;
            }

            return [7
            /*endfinally*/
            ];

          case 16:
            this.standardizeFloors(modelFloors);
            this.logFUnction(modelFloors.map(function (f) {
              return "" + f.floorType + f.floorNumber + "\t";
            }));
            return [2
            /*return*/
            , modelFloors];
        }
      });
    });
  };
  /**
   * Updates the list of floors by providing a standardized index for each floor:
   * the ground floor (EG) is set at 0, the underground floors (UG) and the overground
   * floors (OG) are marked by positive numbers. E.g. a 4-storey
   * building (including one underground parking) will be indexed as follows:
   * UG1 = 1
   * EG = 0
   * OG1 = 1
   * OG2 = 2
   * In order to generate the index we also make sure that EG is defined.
   * In fact, EG might be missing when no BuildingStorey in the IFC
   * has elevation === 0. In this case the EG is defined as the first
   * storey over the ground, i.e. the floor with minimum elevation among
   * the ABOVE_GROUND floors.
   *
   * @param floors The list of floor-objects to update with the index
   */


  IfcHandler.prototype.standardizeFloors = function (floors) {
    // Define EG if missing
    var egFloor = floors.find(function (f) {
      return f.floorType === 'GROUND';
    });

    if (!egFloor) {
      var ogFloors = floors.filter(function (f) {
        return f.floorType === 'ABOVE_GROUND';
      });
      var firstOGFloor = ogFloors.reduce(function (f, currentMinOGFloor) {
        if (f.elevation < currentMinOGFloor.elevation) {
          currentMinOGFloor = f;
        }

        return currentMinOGFloor;
      });
      firstOGFloor.floorType = 'GROUND';
      egFloor = firstOGFloor;
    } // Sort by elevation in ascending order


    floors.sort(function (a, b) {
      return a.elevation - b.elevation;
    }); // Build new floors index

    var egIndex = floors.indexOf(egFloor);
    floors.forEach(function (f, floorIdx) {
      f.floorNumber = Math.abs(floorIdx - egIndex);
    });
    return floors;
  };

  IfcHandler.prototype.getChildrenExpressIDsFromBuildingStorey = function (ifcBuildingStorey) {
    return __awaiter(this, void 0, void 0, function () {
      var childrenExpresssIDs;
      return __generator(this, function (_a) {
        childrenExpresssIDs = []; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore

        ifcBuildingStorey.children.forEach(function (child) {
          childrenExpresssIDs.push(child.expressID);
        });
        return [2
        /*return*/
        , childrenExpresssIDs];
      });
    });
  };
  /**
   * We can define to which floor a specific primitive belongs
   * by checking if the express ID of that primitive is a child
   * of the floor object, we extract earlier.
   *
   * @param floors     The floor structure of the IFC model we extracted earlier
   * @param expressIDs The express IDs for the primitives we want to map to their floor
   */


  IfcHandler.prototype.assignFloorToExpressIDs = function (floors, expressIDs) {
    var e_4, _a;

    var _this = this;

    this.logFUnction('Assign primitives to floor');
    var floorsMap = new Map();

    var _loop_1 = function _loop_1(id) {
      floors.forEach(function (f) {
        var isInFloor = f.childrenExpressIDs.includes(id);

        if (isInFloor) {
          _this.logFUnction("Primitive " + id + " is in floor " + f.name);

          floorsMap.set(id, f);
        }
      });
    };

    try {
      for (var expressIDs_2 = __values(expressIDs), expressIDs_2_1 = expressIDs_2.next(); !expressIDs_2_1.done; expressIDs_2_1 = expressIDs_2.next()) {
        var id = expressIDs_2_1.value;

        _loop_1(id);
      }
    } catch (e_4_1) {
      e_4 = {
        error: e_4_1
      };
    } finally {
      try {
        if (expressIDs_2_1 && !expressIDs_2_1.done && (_a = expressIDs_2.return)) _a.call(expressIDs_2);
      } finally {
        if (e_4) throw e_4.error;
      }
    }

    return floorsMap;
  };
  /**
   * Extract the mesh of a given primitive.
   *
   * @param modelID     The ID of the IFC model
   * @param expressIDs  The express IDs of the primitives we are extracting the mesh from
   */


  IfcHandler.prototype.extractGeometry = function (modelID, expressIDs) {
    return __awaiter(this, void 0, void 0, function () {
      var meshesMap, _loop_2, this_1, expressIDs_3, expressIDs_3_1, id, e_5_1;

      var e_5, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.logFUnction('Extract Geometry');
            meshesMap = new Map();

            _loop_2 = function _loop_2(id) {
              var customId;
              return __generator(this, function (_a) {
                switch (_a.label) {
                  case 0:
                    customId = "tmp-subset-" + id;
                    return [4
                    /*yield*/
                    , this_1.getMeshByExpressID(modelID, id, customId).then(function (mesh) {
                      meshesMap.set(id, mesh);
                    })];

                  case 1:
                    _a.sent();

                    return [2
                    /*return*/
                    ];
                }
              });
            };

            this_1 = this;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 6, 7, 8]);

            expressIDs_3 = __values(expressIDs), expressIDs_3_1 = expressIDs_3.next();
            _b.label = 2;

          case 2:
            if (!!expressIDs_3_1.done) return [3
            /*break*/
            , 5];
            id = expressIDs_3_1.value;
            return [5
            /*yield**/
            , _loop_2(id)];

          case 3:
            _b.sent();

            _b.label = 4;

          case 4:
            expressIDs_3_1 = expressIDs_3.next();
            return [3
            /*break*/
            , 2];

          case 5:
            return [3
            /*break*/
            , 8];

          case 6:
            e_5_1 = _b.sent();
            e_5 = {
              error: e_5_1
            };
            return [3
            /*break*/
            , 8];

          case 7:
            try {
              if (expressIDs_3_1 && !expressIDs_3_1.done && (_a = expressIDs_3.return)) _a.call(expressIDs_3);
            } finally {
              if (e_5) throw e_5.error;
            }

            return [7
            /*endfinally*/
            ];

          case 8:
            return [2
            /*return*/
            , meshesMap];
        }
      });
    });
  };

  IfcHandler.prototype.getMeshByExpressID = function (modelID, expressID, customID) {
    return __awaiter(this, void 0, void 0, function () {
      var subset, subsetMesh;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.manager.createSubset({
              modelID: modelID,
              ids: [expressID],
              removePrevious: true,
              customID: customID
            })];

          case 1:
            subset = _a.sent();
            subsetMesh = subset;
            subsetMesh.visible = true;
            subsetMesh.receiveShadow = true;
            subsetMesh.castShadow = true;
            return [2
            /*return*/
            , subsetMesh];
        }
      });
    });
  };

  return IfcHandler;
}();
/**
 * This function moves a given mesh from its location to the center of the
 * Coordinate Reference System (CRS), i.e. (0,0,0). Additionally,
 * we adjust the camera and retarget the controls, so that the mesh is in its sight.
 * For that we need the bounding box (BB) of the mesh.
 *
 * @param mesh      The mesh to move
 * @param camera    The camera in the scene
 * @param controls  The controls of the scene
 */


var moveMeshToCRSCenter = function moveMeshToCRSCenter(mesh, recenterModel, camera, controls) {
  if (recenterModel === void 0) {
    recenterModel = false;
  }

  if (recenterModel) {
    // Translate mesh to center of CRS
    mesh.geometry.center();
  }

  pointCameraToModel(mesh, camera, controls);
};

var pointCameraToModel = function pointCameraToModel(mesh, camera, controls) {
  // Compute the mesh bounding box
  var geometryHandler = new GeometryHandler();
  var bb = geometryHandler.getMeshBoundingSphere(mesh); // Get size and center of the BB

  var center = bb.center;
  var size = bb.radius; // Reposition the camera and reset the controls

  camera.position.x = -1 * size;
  camera.position.y = size;
  camera.position.z = size;
  camera.lookAt(center);
  controls.target.set(center.x, center.y, center.z);
};

var getMaterialByClass = function getMaterialByClass(mainClass) {
  switch (mainClass) {
    case CRB_CLASS.GRUNDSTUCK:
      return new MeshBasicMaterial({
        color: ColorPalette.TERRAIN,
        transparent: true,
        opacity: 0.5
      });

    case CRB_CLASS.INNENRAUME:
      return new MeshBasicMaterial({
        color: ColorPalette.INNENRAUME,
        transparent: true,
        opacity: 0.5
      });

    case CRB_CLASS.AUSSENFLACHEN:
      return new MeshBasicMaterial({
        color: ColorPalette.AUSSENFLACHEN,
        transparent: true,
        opacity: 0.5
      });

    case CRB_CLASS.VOLUMEN:
      return new MeshBasicMaterial({
        color: ColorPalette.VOLUMEN,
        transparent: true,
        opacity: 0.5
      });

    case CRB_CLASS.SONDERNUTZUNG:
      return new MeshBasicMaterial({
        color: ColorPalette.SONDERNUTZUNG,
        transparent: true,
        opacity: 0.5
      });

    default:
      return new MeshBasicMaterial({
        color: ColorPalette.GESCHOSSE,
        transparent: true,
        opacity: 0.7
      });
  }
};

var Stats = function Stats() {
  var mode = 0;
  var container = document.createElement('div');
  container.style.cssText = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000';
  container.addEventListener('click', function (event) {
    event.preventDefault();
    showPanel(++mode % container.children.length);
  }, false); //

  function addPanel(panel) {
    container.appendChild(panel.dom);
    return panel;
  }

  function showPanel(id) {
    for (var i = 0; i < container.children.length; i++) {
      container.children[i].style.display = i === id ? 'block' : 'none';
    }

    mode = id;
  } //


  var beginTime = (performance || Date).now(),
      prevTime = beginTime,
      frames = 0;
  var fpsPanel = addPanel(new Stats.Panel('FPS', '#0ff', '#002'));
  var msPanel = addPanel(new Stats.Panel('MS', '#0f0', '#020'));

  if (self.performance && self.performance.memory) {
    var memPanel = addPanel(new Stats.Panel('MB', '#f08', '#201'));
  }

  showPanel(0);
  return {
    REVISION: 16,
    dom: container,
    addPanel: addPanel,
    showPanel: showPanel,
    begin: function begin() {
      beginTime = (performance || Date).now();
    },
    end: function end() {
      frames++;
      var time = (performance || Date).now();
      msPanel.update(time - beginTime, 200);

      if (time >= prevTime + 1000) {
        fpsPanel.update(frames * 1000 / (time - prevTime), 100);
        prevTime = time;
        frames = 0;

        if (memPanel) {
          var memory = performance.memory;
          memPanel.update(memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576);
        }
      }

      return time;
    },
    update: function update() {
      beginTime = this.end();
    },
    // Backwards Compatibility
    domElement: container,
    setMode: showPanel
  };
};

Stats.Panel = function (name, fg, bg) {
  var min = Infinity,
      max = 0,
      round = Math.round;
  var PR = round(window.devicePixelRatio || 1);
  var WIDTH = 80 * PR,
      HEIGHT = 48 * PR,
      TEXT_X = 3 * PR,
      TEXT_Y = 2 * PR,
      GRAPH_X = 3 * PR,
      GRAPH_Y = 15 * PR,
      GRAPH_WIDTH = 74 * PR,
      GRAPH_HEIGHT = 30 * PR;
  var canvas = document.createElement('canvas');
  canvas.width = WIDTH;
  canvas.height = HEIGHT;
  canvas.style.cssText = 'width:80px;height:48px';
  var context = canvas.getContext('2d');
  context.font = 'bold ' + 9 * PR + 'px Helvetica,Arial,sans-serif';
  context.textBaseline = 'top';
  context.fillStyle = bg;
  context.fillRect(0, 0, WIDTH, HEIGHT);
  context.fillStyle = fg;
  context.fillText(name, TEXT_X, TEXT_Y);
  context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);
  context.fillStyle = bg;
  context.globalAlpha = 0.9;
  context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);
  return {
    dom: canvas,
    update: function update(value, maxValue) {
      min = Math.min(min, value);
      max = Math.max(max, value);
      context.fillStyle = bg;
      context.globalAlpha = 1;
      context.fillRect(0, 0, WIDTH, GRAPH_Y);
      context.fillStyle = fg;
      context.fillText(round(value) + ' ' + name + ' (' + round(min) + '-' + round(max) + ')', TEXT_X, TEXT_Y);
      context.drawImage(canvas, GRAPH_X + PR, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT, GRAPH_X, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT);
      context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT);
      context.fillStyle = bg;
      context.globalAlpha = 0.9;
      context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, round((1 - value / maxValue) * GRAPH_HEIGHT));
    }
  };
};

var RenderingSystem =
/** @class */
function () {
  function RenderingSystem(args) {
    this.scene = undefined;
    this.camera = undefined;
    this.renderer = undefined;
    this.dimensions = undefined;
    this.canvasId = undefined;
    this.clock = undefined;
    this.stats = undefined;
    this.controls = undefined;
    this.ambientLight = undefined;

    if (args && Object.keys(args).includes('logger') && typeof args['logger'] === 'function') {
      this.logFUnction = args['logger'];
    } else {
      this.logFUnction = function (arg) {
        return console.log("" + arg);
      };
    }
  }

  RenderingSystem.prototype.initialize = function (_a) {
    var _this = this;

    var _b;

    var canvasId = _a.canvasId,
        backgroundColor = _a.backgroundColor;
    this.scene = new Scene();
    this.setBackgroundColor(backgroundColor); // Setup renderer for a canvas that must already exist in the DOM

    this.canvasId = canvasId;
    var canvas = document.getElementById(canvasId);
    this.renderer = new WebGLRenderer({
      canvas: canvas,
      // Anti-aliasing smooths out the edges
      antialias: true
    });
    this.setViewerDimensions();
    this.renderer.setSize(this.dimensions.width, this.dimensions.height);
    this.renderer.setPixelRatio(window.devicePixelRatio); // Add canvas to its parent in DOM

    (_b = canvas.parentElement) === null || _b === void 0 ? void 0 : _b.appendChild(this.renderer.domElement);
    this.setViewerDimensions();
    this.camera = new PerspectiveCamera(45, this.dimensions.width / this.dimensions.height, 0.1, 1500);
    this.camera.lookAt(0, 0, 0);
    this.camera.up = new Vector3(0, 1, 0);
    this.clock = new Clock();
    this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.controls.panSpeed = 0.5;
    this.stats = Stats(); // Setup lighting

    this.ambientLight = new AmbientLight(0xffffff, 0.5);
    this.ambientLight.castShadow = true;
    this.scene.add(this.ambientLight);
    this.objectsToRender = [];
    this.groupsToRender = [];
    this.isDebugMode = false; // Adjust size

    window.addEventListener('resize', function () {
      return _this.onWindowResize();
    }, false);
    this.initializeDebugModeScene();
  };

  RenderingSystem.prototype.initializeDebugModeScene = function () {
    // Add coordinate system axes
    var axesHelper = new AxesHelper(200);
    axesHelper.visible = false;
    var axesToRender = {
      id: DEBUG_MODEL_ID_PREFIX + "axesHelper",
      mesh: axesHelper
    };
    this.scene.add(axesHelper);
    this.objectsToRender.push(axesToRender); // Add grid

    var size = 200;
    var divisions = 100;
    var gridHelper = new GridHelper(size, divisions);
    gridHelper.visible = false;
    var gridToRender = {
      id: DEBUG_MODEL_ID_PREFIX + "gridHelper",
      mesh: gridHelper
    };
    this.scene.add(gridHelper);
    this.objectsToRender.push(gridToRender);
  };

  RenderingSystem.prototype.cleanupSceneObjects = function () {
    var _this = this;

    this.objectsToRender.forEach(function (obj) {
      return _this.deleteDrawableObject(obj);
    });
    this.groupsToRender.forEach(function (g) {
      return _this.deleteDrawableGroup(g);
    });
    this.scene.traverse(function (obj) {
      return _this.delete3DObject(obj);
    });
    this.objectsToRender = [];
    this.groupsToRender = [];
    this.scene.children = [];
  };

  RenderingSystem.prototype.delete3DObject = function (object) {
    object.traverse(function (child) {
      if (child instanceof Material) {
        child.dispose();
      }

      if (child instanceof Geometry) {
        child.dispose();
      }
    });
  };

  RenderingSystem.prototype.deleteDrawableObject = function (object) {
    var objMesh = object.mesh;

    if (objMesh instanceof Mesh) {
      objMesh.geometry.dispose();

      if (objMesh.material instanceof Array) {
        objMesh.material.forEach(function (m) {
          return m.dispose();
        });
      } else {
        objMesh.material.dispose();
      }
    }

    this.scene.remove(objMesh);
  };

  RenderingSystem.prototype.deleteDrawableGroup = function (drawableGoup) {
    var _this = this;

    drawableGoup.group.traverse(function (obj) {
      return _this.delete3DObject(obj);
    });
    this.scene.remove(drawableGoup.group);
  };

  RenderingSystem.prototype.clear = function () {
    this.disposeRenderer();
    this.disposeScene();
    this.camera.clear();
    this.camera.updateMatrix();
    this.clock.stop();
    this.controls.reset();
    this.controls.update();
    this.controls.dispose();
    this.stats.end();
  };

  RenderingSystem.prototype.disposeRenderer = function () {
    this.renderer.dispose();
    this.stopAnimation();
  };

  RenderingSystem.prototype.disposeScene = function () {
    this.cleanupSceneObjects();
    this.scene.clear();
  };

  RenderingSystem.prototype.stopAnimation = function () {
    window.cancelAnimationFrame(this.animationId);
  };

  RenderingSystem.prototype.animate = function () {
    this.animationId = window.requestAnimationFrame(this.animate.bind(this));
    this.clock.start();
    this.render();
    this.update();
  };

  RenderingSystem.prototype.render = function () {
    this.renderer.render(this.scene, this.camera);
  };

  RenderingSystem.prototype.update = function () {
    this.stats.update();
    this.controls.update();
    this.objectsToRender.filter(function (obj) {
      return obj.mesh.visible;
    }).forEach(function (visibleObj) {
      if (visibleObj.update) visibleObj.update();
    });
  };

  RenderingSystem.prototype.addDrawableObject = function (object) {
    this.objectsToRender.push(object);
    if (object.initialize) object.initialize();
    this.scene.add(object.mesh);
  };

  RenderingSystem.prototype.addDrawableGroup = function (drawableGroup) {
    this.groupsToRender.push(drawableGroup);
    this.scene.add(drawableGroup.group);
  };

  RenderingSystem.prototype.setBackgroundColor = function (color) {
    this.scene.background = new Color(color !== null && color !== void 0 ? color : 0);
  };

  RenderingSystem.prototype.onWindowResize = function () {
    this.setViewerDimensions();
    this.camera.aspect = this.dimensions.width / this.dimensions.height;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(this.dimensions.width, this.dimensions.height);
  };

  RenderingSystem.prototype.setViewerDimensions = function () {
    var div_dev = document.getElementById('root');
    var div_prod = document.getElementsByClassName('building-plan-wrapper')[0];
    var domElement;

    if (div_prod !== undefined && div_prod != null) {
      domElement = div_prod;
    } else {
      domElement = div_dev;
    }

    if (domElement !== undefined && domElement !== null) {
      var clientSize = domElement.getBoundingClientRect();
      this.dimensions = new Vector2(clientSize.width, clientSize.height);
    }
  };

  RenderingSystem.prototype.activateDebugModeScene = function () {
    this.isDebugMode = true; // Show statistics

    document.body.appendChild(this.stats.dom); // Show debug elements (coordinate system axes etc.)

    this.objectsToRender.filter(function (obj) {
      return obj.id.includes(DEBUG_MODEL_ID_PREFIX);
    }).forEach(function (debugObj) {
      return debugObj.mesh.visible = true;
    });
  };

  RenderingSystem.prototype.deactivateDebugModeScene = function () {
    this.isDebugMode = false; // Remove statistics

    if (this.stats.dom.parentElement === document.body) {
      document.body.removeChild(this.stats.dom);
    } // Hide debug elements (coordinate system axes etc.)


    this.objectsToRender.filter(function (obj) {
      return obj.id.includes(DEBUG_MODEL_ID_PREFIX);
    }).forEach(function (debugObj) {
      return debugObj.mesh.visible = false;
    });
  };

  RenderingSystem.prototype.printSceneInfo = function () {
    console.log("Amount of objects in the scene: \t" + this.objectsToRender.length);
    console.log("[ID - visibility - position] of objects in the scene: " + this.objectsToRender.map(function (obj) {
      return "\n\t[" + obj.id + " - " + (obj.mesh.visible ? 'visible' : 'hidden') + " - " + JSON.stringify(obj.mesh.position) + "]";
    }));
    console.log("Amount of groups in the scene: \t" + this.groupsToRender.length);
    console.log("[ID - visibility - position] of objects in the scene: " + this.groupsToRender.map(function (g) {
      return "\n\t[" + g.id + " - " + (g.group.visible ? 'visible' : 'hidden') + " - " + JSON.stringify(g.group.position) + "]";
    }));
  };
  /**
   * Render all objects in the scene.
   * Debug elements stay showed or hidden.
   */


  RenderingSystem.prototype.renderAll = function () {
    var _this = this;

    this.objectsToRender.forEach(function (obj) {
      obj.mesh.visible = obj.id.includes(DEBUG_MODEL_ID_PREFIX) ? _this.isDebugMode : true;
    });
    this.groupsToRender.forEach(function (g) {
      g.group.visible = true;
    });
  };

  RenderingSystem.prototype.hideAll = function () {
    var _this = this;

    this.objectsToRender.forEach(function (obj) {
      obj.mesh.visible = obj.id.includes(DEBUG_MODEL_ID_PREFIX) ? _this.isDebugMode : false;
    });
    this.groupsToRender.forEach(function (g) {
      g.group.visible = false;
    });
  }; // For drawable objects only (i.e. not groups)


  RenderingSystem.prototype.showWireframe = function () {
    this.objectsToRender.forEach(function (obj) {
      var materials = obj.materials;

      if (materials) {
        if (!materials.wireframe) {
          materials.wireframe = new MeshBasicMaterial({
            color: ColorPalette.PURPLE,
            wireframe: true
          });
        }

        var meshObj = obj.mesh;
        meshObj.material = materials.wireframe;
      }
    });
  }; // For drawable objects only (i.e. not groups)


  RenderingSystem.prototype.showDefaultMaterial = function () {
    this.objectsToRender.forEach(function (obj) {
      var materials = obj.materials;

      if (materials) {
        var meshObj = obj.mesh;
        meshObj.material = materials.default;
      }
    });
  };

  RenderingSystem.prototype.drawTriangle = function (triangle, material) {
    var vertices = new Float32Array([triangle.a.x, triangle.a.y, triangle.a.z, triangle.b.x, triangle.b.y, triangle.b.z, triangle.c.x, triangle.c.y, triangle.c.z]);
    var indices = [0, 1, 2];
    var geometry = new BufferGeometry();
    geometry.setAttribute('position', new BufferAttribute(vertices, 3));
    geometry.setIndex(indices);
    geometry.computeVertexNormals();
    var meshMaterial = material !== null && material !== void 0 ? material : new MeshBasicMaterial({
      color: ColorPalette.GREEN
    });
    var mesh = new Mesh(geometry, meshMaterial);
    this.scene.add(mesh);
  };

  RenderingSystem.prototype.drawTriangleWireframe = function (triangle, material) {
    if (material) {
      material.setValues({
        wireframe: true
      });
    }

    var wireframeMaterial = material !== null && material !== void 0 ? material : new MeshBasicMaterial({
      color: ColorPalette.PURPLE,
      wireframe: true
    });
    this.drawTriangle(triangle, wireframeMaterial);
  };

  RenderingSystem.prototype.drawTriangleNormal = function (triangle, material) {
    var normal = new Vector3();
    triangle.getNormal(normal);
    var midpoint = new Vector3();
    triangle.getMidpoint(midpoint);
    var points = [midpoint, normal.add(midpoint)];
    var geometry = new BufferGeometry().setFromPoints(points);
    var lineMaterial = material !== null && material !== void 0 ? material : new LineBasicMaterial({
      color: ColorPalette.BLUE
    });
    var line = new Line(geometry, lineMaterial);
    this.scene.add(line);
  };

  RenderingSystem.prototype.drawPolygon = function (coordinates2D, rotate, material) {
    if (rotate === void 0) {
      rotate = false;
    }

    var flatCoordinates3D = [];
    coordinates2D.forEach(function (vertexCoordinates) {
      if (vertexCoordinates.length === 2) {
        flatCoordinates3D.push(vertexCoordinates[0]);
        flatCoordinates3D.push(0);
        flatCoordinates3D.push(vertexCoordinates[1]);
      }
    });
    var vertices = new Float32Array(flatCoordinates3D);
    var geometry = new BufferGeometry();
    geometry.setAttribute('position', new BufferAttribute(vertices, 3));
    geometry.computeVertexNormals();
    var meshMaterial = material !== null && material !== void 0 ? material : new LineBasicMaterial({
      color: ColorPalette.ORANGE
    });
    var mesh = new Mesh(geometry, meshMaterial);
    mesh.translateX(5);
    rotate && mesh.rotateOnAxis(new Vector3(0, 0, 1), Math.PI);
    this.scene.add(mesh);
  };

  return RenderingSystem;
}();
/**
 * This is an extension of the base rendering system to handle
 * the visualisation of building models (from ifc files).
 * Its main functionality is to render the primitives for
 * the following categories:
 * 1. Terrain (Grundstück)
 * 2. Building footprint (Gebäudegrundstückfläche)
 * 3. Geschosse
 * 4. Innenraumen
 * 5. Aussenflachen
 * 6. Volumen
 *
 * Additionally, helper functions are provided to
 * show / hide specific 3D objects for debug purposes.
 */


var RenderingSystemForBuildingModels =
/** @class */
function (_super) {
  __extends(RenderingSystemForBuildingModels, _super);

  function RenderingSystemForBuildingModels() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RenderingSystemForBuildingModels.prototype.addBuildingModel = function (model, recenterModel, materials, initializeObject, updateObject) {
    if (recenterModel === void 0) {
      recenterModel = false;
    }

    var modelToRender = {
      id: "" + BUILDING_MODEL_ID_PREFIX + model.id,
      mesh: model,
      materials: materials,
      initialize: initializeObject,
      update: updateObject
    };
    model.material = materials.default;
    moveMeshToCRSCenter(model, recenterModel, this.camera, this.controls);
    this.addDrawableObject(modelToRender);
  };

  RenderingSystemForBuildingModels.prototype.addPrimitiveModel = function (model, materials, initializeObject, updateObject) {
    var modelToRender = {
      id: "" + PRIMITIVES_ID_PREFIX + model.expressId,
      mesh: model.geometry.mesh,
      materials: materials,
      initialize: initializeObject,
      update: updateObject,
      triangles: model.geometry.triangles,
      crbClass: model.crbClass.class
    };
    model.geometry.mesh.material = materials.default;
    moveMeshToCRSCenter(model.geometry.mesh, false, this.camera, this.controls);
    this.addDrawableObject(modelToRender);
  };

  RenderingSystemForBuildingModels.prototype.addHelperPrimitiveModel = function (model, materials, initializeObject, updateObject) {
    if (!model) return;
    var modelToRender = {
      id: "" + HELPER_PRIMITIVES_ID_PREFIX + model.id,
      mesh: model.mesh,
      materials: materials,
      initialize: initializeObject,
      update: updateObject
    };
    model.mesh.material = materials.default;
    moveMeshToCRSCenter(model.mesh, false, this.camera, this.controls);
    this.addDrawableObject(modelToRender);
  };

  RenderingSystemForBuildingModels.prototype.addCRBClassGroup = function (id, meshesWithMaterial) {
    if (meshesWithMaterial.length < 1) return;
    var group = new Group();
    meshesWithMaterial.forEach(function (p) {
      var mesh = new Mesh(p.primitiveMesh.geometry, p.material);
      var lineContour = new LineSegments(new EdgesGeometry(p.primitiveMesh.geometry), new LineBasicMaterial({
        color: ColorPalette.CONTOUR_LINE
      }));

      if (p.yTranslate) {
        mesh.translateY(p.yTranslate);
        lineContour.translateY(p.yTranslate);
      }

      group.add(lineContour, mesh);
    });
    var groupToRender = {
      id: "" + GROUP_ID_PREFIX + id,
      group: group
    };
    this.addDrawableGroup(groupToRender);
  };

  RenderingSystemForBuildingModels.prototype.renderIfcData = function (data) {
    this.logFUnction("Rendering " + data.models.length + " models");
    this.analysisResult = data.analysis;

    if (data.models.length === 0) {
      console.warn('No models to render');
      return;
    }
    /**
     * Render primitives for following CRB main classes:
     *      - Geschosse
     *      - Innenaraumen
     *      - Aussenflächen
     *      - Volumen
     *      - Sondernutzung
     */


    var geschosseMaterial = getMaterialByClass(CRB_CLASS.GESCHOSSE);
    var innenraumeMaterial = getMaterialByClass(CRB_CLASS.INNENRAUME);
    var aussenflacheMaterial = getMaterialByClass(CRB_CLASS.AUSSENFLACHEN);
    var volumenMaterial = getMaterialByClass(CRB_CLASS.VOLUMEN);
    var sondernutzungMaterial = getMaterialByClass(CRB_CLASS.SONDERNUTZUNG);
    this.addCRBClassGroup(getClassAsString(CRB_CLASS.GESCHOSSE), data.analysis.geschosse.primitives.map(function (primitive) {
      return {
        primitiveMesh: primitive.mesh,
        material: geschosseMaterial
      };
    }));
    this.addCRBClassGroup(getClassAsString(CRB_CLASS.INNENRAUME), data.analysis.innenraumen.primitives.map(function (primitive) {
      return {
        primitiveMesh: primitive.mesh,
        material: innenraumeMaterial
      };
    }));
    this.addCRBClassGroup(getClassAsString(CRB_CLASS.AUSSENFLACHEN), data.analysis.aussenflachen.primitives.map(function (primitive) {
      return {
        primitiveMesh: primitive.mesh,
        material: aussenflacheMaterial
      };
    }));
    this.addCRBClassGroup(getClassAsString(CRB_CLASS.VOLUMEN), data.analysis.volumen.primitives.map(function (primitive) {
      return {
        primitiveMesh: primitive.mesh,
        material: volumenMaterial
      };
    }));
    this.addCRBClassGroup(getClassAsString(CRB_CLASS.SONDERNUTZUNG), data.analysis.sondernutzung.primitives.map(function (primitive) {
      return {
        primitiveMesh: primitive.mesh,
        material: sondernutzungMaterial
      };
    }));
    /**
     * Render helper primitives:
     *      - Terrain (PVG)
     *      - Terrain surface (PTS)
     *      - Building footprint (PGGF)
     */

    var terrainPrimitives = [{
      primitiveMesh: data.analysis.helperPrimitives.PVG.mesh,
      material: getMaterialByClass(CRB_CLASS.GRUNDSTUCK)
    }, {
      primitiveMesh: data.analysis.helperPrimitives.PTS.mesh,
      material: TERRAIN_SURFACE_MATERIAL,
      yTranslate: 0.05
    }];
    this.addCRBClassGroup(getClassAsString(CRB_CLASS.GRUNDSTUCK), terrainPrimitives);
    var footprintPrimitive = [{
      primitiveMesh: data.analysis.helperPrimitives.PGGF.mesh,
      material: BUILDING_FOOTPRINT_MATERIAL,
      yTranslate: -0.05
    }];
    this.addCRBClassGroup(GROUP_ID_BUILDING_FOOTPRINT, footprintPrimitive);
    pointCameraToModel(data.analysis.helperPrimitives.PVG.mesh, this.camera, this.controls);
  };

  RenderingSystemForBuildingModels.prototype.showGroup = function (id) {
    var groupToShow = this.groupsToRender.filter(function (g) {
      return g.id === id;
    });
    if (groupToShow.length < 1) return;
    groupToShow[0].group.visible = true;
  };

  RenderingSystemForBuildingModels.prototype.hideGroup = function (id) {
    var groupToShow = this.groupsToRender.filter(function (g) {
      return g.id === id;
    });
    if (groupToShow.length < 1) return;
    groupToShow[0].group.visible = false;
  };
  /**
   * Render only primitive objects in the scene.
   * Debug elements stay showed or hidden
   */


  RenderingSystemForBuildingModels.prototype.renderPrimitivesOnly = function () {
    var _this = this;

    this.objectsToRender.forEach(function (obj) {
      obj.mesh.visible = obj.id.includes(DEBUG_MODEL_ID_PREFIX) ? _this.isDebugMode : obj.id.includes(PRIMITIVES_ID_PREFIX);
    });
  };

  RenderingSystemForBuildingModels.prototype.drawTriangles = function (triangles) {
    var _this = this;

    triangles && triangles.forEach(function (t) {
      _this.drawTriangle(t);

      _this.drawTriangleWireframe(t);

      _this.drawTriangleNormal(t);
    });
  };

  RenderingSystemForBuildingModels.prototype.showFloorMaterial = function () {
    this.objectsToRender.forEach(function (obj) {
      if (obj.id.includes(PRIMITIVES_ID_PREFIX)) {
        var materials = obj.materials;

        if (materials) {
          var meshObj = obj.mesh;
          meshObj.material = materials.floor;
        }
      }
    });
  };

  RenderingSystemForBuildingModels.prototype.drawHelperPrimitives = function (data) {
    var _a = data.helperPrimitives,
        PVG = _a.PVG,
        PTS = _a.PTS,
        BP = _a.BP,
        PGGF = _a.PGGF,
        BPU = _a.BPU;
    var materialsPVG = {
      default: new MeshBasicMaterial({
        color: ColorPalette.TERRAIN,
        transparent: true,
        opacity: 0.5
      })
    };
    var materialsPTS = {
      default: new MeshBasicMaterial({
        color: ColorPalette.GREEN
      })
    };
    var materialsBP = {
      default: new MeshBasicMaterial({
        color: ColorPalette.INNENRAUME,
        transparent: true,
        opacity: 0.5
      })
    };
    var materialsPGGF = {
      default: new MeshBasicMaterial({
        color: ColorPalette.AUSSENFLACHEN
      })
    };
    var materialsBPU = {
      default: new MeshBasicMaterial({
        color: ColorPalette.PURPLE
      })
    };

    if (PVG) {
      this.addHelperPrimitiveModel(PVG, materialsPVG);
      PVG.mesh.translateX(-100);
    }

    if (PTS) {
      this.addHelperPrimitiveModel(PTS, materialsPTS);
      PTS.mesh.translateX(-100);
    }

    if (BP) {
      this.addHelperPrimitiveModel(BP, materialsBP);
      BP.mesh.translateX(-100);
    }

    if (PGGF) {
      this.addHelperPrimitiveModel(PGGF, materialsPGGF);
      PGGF.mesh.translateX(-100);
    }

    if (BPU) {
      this.addHelperPrimitiveModel(BPU, materialsBPU);
      BPU.mesh.translateX(-100);
    }
  };

  return RenderingSystemForBuildingModels;
}(RenderingSystem);

var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};

var initRenderingSystem = function initRenderingSystem(id, logFunction) {
  if (logFunction === void 0) {
    logFunction = function logFunction(arg) {
      return console.log(arg);
    };
  }

  logFunction('Init rendering system');
  var renderingSystem = new RenderingSystemForBuildingModels({
    logger: logFunction
  });
  renderingSystem.initialize({
    canvasId: id,
    backgroundColor: ColorPalette.BACKGROUND
  });
  renderingSystem.animate();
  return renderingSystem;
};

var loadAnalyzeAndRenderIFCData = function loadAnalyzeAndRenderIFCData(ifcHandler, renderingSystem, loadingFunction, logFunction) {
  if (logFunction === void 0) {
    logFunction = function logFunction(arg) {
      return console.log(arg);
    };
  }

  return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          logFunction('Start IFC workflow core');
          return [4
          /*yield*/
          , loadingFunction(ifcHandler, renderingSystem)];

        case 1:
          result = _a.sent();

          if (result.models.length > 0) {
            logFunction('Render data');
            renderingSystem.renderIfcData(result);
          }

          return [2
          /*return*/
          , result];
      }
    });
  });
};

function useInitBuildingViewer(id, file, currentRenderingSystemRef, loadingFunction, deliverFunction, logFunction) {
  var _this = this;

  if (logFunction === void 0) {
    logFunction = function logFunction(arg) {
      return console.log(arg);
    };
  }

  var fileSrc = file.src;
  var previousFileSrc = usePrevious(fileSrc);
  useEffect(function () {
    var performCoreAnalysis = function performCoreAnalysis() {
      return __awaiter(_this, void 0, void 0, function () {
        var renderingSystem, ifcHandler, result;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              renderingSystem = initRenderingSystem(id, logFunction);
              currentRenderingSystemRef.current = renderingSystem;
              logFunction('Init IFC handler');
              ifcHandler = new IfcHandler();
              return [4
              /*yield*/
              , ifcHandler.setup({
                logger: logFunction,
                renderingSystem: renderingSystem
              })];

            case 1:
              _a.sent();

              return [4
              /*yield*/
              , loadAnalyzeAndRenderIFCData(ifcHandler, renderingSystem, loadingFunction, logFunction)];

            case 2:
              result = _a.sent();
              logFunction('Return calculations on callback');
              deliverFunction(result.calculations);
              logFunction('End IFC workflow');
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    if (previousFileSrc !== fileSrc) {
      logFunction("Input file has changed, new file " + file.name + " with length: " + fileSrc.length);
      performCoreAnalysis();
    }
  }, [currentRenderingSystemRef, deliverFunction, file.extension, file.name, fileSrc, id, loadingFunction, logFunction, previousFileSrc]);
}
/**
 * This hook maps callbacks to a keyboard shortcut.
 * Currently, it combines the provided keycode with Ctrl + Alt.
 * See values for keyCode here
 * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode#value_of_keycode
 *
 * @param keyCode   The code of the keyboard key to combine with Ctrl + Alt
 * @param callback  The function executed once the shortcut (Ctrl + Alt + key) is pressed
 */


function useKeyboardShortcut(keyCode, callback) {
  var callbackRef = useRef(callback);
  useEffect(function () {
    callbackRef.current = callback;
  }, [callback]);
  useEffect(function () {
    function handleKeyPress(e) {
      if (e.ctrlKey && e.altKey && e.code === keyCode) {
        callbackRef.current();
      }
    }

    document.addEventListener('keydown', handleKeyPress);
    return function () {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyCode]);
}

function useToggleDebugMode(isDebugMode, renderingSystem) {
  useEffect(function () {
    if (renderingSystem) {
      isDebugMode ? renderingSystem.activateDebugModeScene() : renderingSystem.deactivateDebugModeScene();
    }
  }, [isDebugMode, renderingSystem]);
}

var LOG_WRAPPER = '-------------\n';

function wrappedLog(logStrValue, logObjValue) {
  logObjValue ? console.log("" + LOG_WRAPPER + logStrValue + "\n" + LOG_WRAPPER, logObjValue) : console.log("" + LOG_WRAPPER + logStrValue + "\n" + LOG_WRAPPER);
}

var useVerboseLogger = function useVerboseLogger() {
  var isVerbose = useContext(IfcComponentContext).isVerbose;
  var loggerCallback = useCallback(function (logStrValue, logObjValue) {
    if (isVerbose) wrappedLog(logStrValue, logObjValue);
  }, [isVerbose]);
  return loggerCallback;
};

function Toggle(_a) {
  var id = _a.id,
      label = _a.label,
      onChange = _a.onChange;
  return React.createElement("div", {
    className: "toggle-button"
  }, React.createElement("input", {
    type: "checkbox",
    id: id,
    className: "toggle-input",
    onChange: onChange,
    defaultChecked: true
  }), React.createElement("label", {
    htmlFor: id,
    className: "toggle-label"
  }, React.createElement("span", {
    className: "label-text"
  }, label)));
}
/**
 * Viewer lifecycle:
 *      1. Before scene initialization the canvas element must be added to the HTML DOM
 *      2. At this point the rendering system can be initialized (scene, camera etc.)
 *      3. Eventually the scene is animated
 *
 * @param canvasId  The ID of the canvas HTML element to which the ThreeJS scene will be bound
 * @param className CSS classes
 */


function Viewer(_a) {
  var canvasId = _a.canvasId,
      className = _a.className;
  return React.createElement("canvas", {
    id: canvasId,
    className: className
  });
}

var cleanup = function cleanup(ref, currentRenderingSystemRef) {
  return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (!(ref.current && currentRenderingSystemRef.current)) return [3
          /*break*/
          , 2];
          console.info('Cleanup IFC Building Plan component');
          return [4
          /*yield*/
          , ref.current.dispose()];

        case 1:
          _a.sent();

          currentRenderingSystemRef.current.clear();
          _a.label = 2;

        case 2:
          return [2
          /*return*/
          ];
      }
    });
  });
};
/**
 * This component receives an IFC file that must be loaded, analysed and rendered.
 * The result of the analysis are calculations that are returned to the parent
 * component via callback.
 * The lifecycle of the component is as follows:
 * 1. IFC file is uploaded in ancestor component
 * 2. BuildingViewer component is created and receives the new file as property
 * 3. The hook useInitBuildingViewer is executed to start the core functions
 *      - init rendering system
 *      - init ifc loader
 *      - read file
 *      - analyse file content to produce calculations
 *      - render content
 *
 * When a new file is uploaded, the lifecycle continues:
 * 4. The Component must unmount
 * 6. Cleanup
 *      - clear ifc loader
 *      - clear rendering system
 * 7. The component is completely destroyed
 *
 * The component also provides some user-interaction features by means of
 * toggle buttons. There is one toggle to show / hide the primitives
 * for each of the following categories:
 * 1. Terrain (Grundstück)
 * 2. Building footprint (Gebäudegrundstückfläche)
 * 3. Geschosse
 * 4. Innenraumen
 * 5. Aussenflachen
 * 6. Volumen
 *
 * If a category contains no primitives, then the corresponding toggle
 * button is not displayed in the UI.
 *
 * @param file The IFC file to analyse
 * @param onCalculated The callback function to return the analysis' results
 */


function BuildingViewer(_a) {
  var _this = this;

  var file = _a.file,
      onCalculated = _a.onCalculated;
  /*
   * We need to keep a reference to the ifcHandler and the renderingSystem,
   * so that we can clean them up properly once the BuildingViewer component is unmounted
   */

  var ifcHandlerRef = useRef();
  var renderingSystemRef = useRef();

  var _b = __read(useState(false), 2),
      displayToggles = _b[0],
      setDisplayToggles = _b[1];

  var _c = __read(useState(true), 2),
      displayTerrainToggle = _c[0],
      setDisplayTerrainToggle = _c[1];

  var _d = __read(useState(true), 2),
      displayPGGFToggle = _d[0],
      setDisplayPGGFToggle = _d[1];

  var _e = __read(useState(true), 2),
      displayGeschosseToggle = _e[0],
      setDisplayGeschosseToggle = _e[1];

  var _f = __read(useState(true), 2),
      displayInnenraumenToggle = _f[0],
      setDisplayInnenraumenToggle = _f[1];

  var _g = __read(useState(true), 2),
      displayAussenflachenToggle = _g[0],
      setDisplayAussenflachenToggle = _g[1];

  var _h = __read(useState(true), 2),
      displayVolumenToggle = _h[0],
      setDisplayVolumenToggle = _h[1];

  var _j = __read(useState(true), 2),
      displaySondernutzungToggle = _j[0],
      setDisplaySondernutzungToggle = _j[1];

  var _k = useContext(IfcComponentContext),
      isDebugMode = _k.isDebugMode,
      isVerbose = _k.isVerbose;

  var verboseLog = useVerboseLogger();
  useToggleDebugMode(isDebugMode, renderingSystemRef.current);
  useCleanupComponent(function () {
    return __awaiter(_this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , cleanup(ifcHandlerRef, renderingSystemRef)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];
        }
      });
    });
  }); // Enable shortcut to print current scene data

  useKeyboardShortcut('KeyS', function () {
    renderingSystemRef.current.printSceneInfo();
  });
  /**
   * Function that reads and analyses the IFC file.
   * The final result contains data for rendering and the calculations
   * to return to the host component
   *
   * @param ifcHandler The IFC loader object
   */

  function readAndAnalyzeFile(ifcHandler) {
    return __awaiter(this, void 0, void 0, function () {
      var models, geometryHandler, analyzer, messages, result, calculations, hasTerrain, hasPGGF, hasGeschosse, hasInnenraumen, hasAussenflachen, hasVolumen, hasSondernutzungen, completeResult, result;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            verboseLog("Loading IFC File: " + file.name);
            if (!ifcHandlerRef.current) return [3
            /*break*/
            , 2];
            verboseLog('Dispose current IFCHandler');
            return [4
            /*yield*/
            , ifcHandlerRef.current.dispose()];

          case 1:
            _a.sent();

            _a.label = 2;

          case 2:
            models = [];
            geometryHandler = new GeometryHandler(verboseLog);
            analyzer = new CRBAnalyzer(geometryHandler, verboseLog);
            messages = [];
            _a.label = 3;

          case 3:
            _a.trys.push([3, 5,, 6]);

            return [4
            /*yield*/
            , ifcHandler.loadAndExtractModel(file.src, models, messages)];

          case 4:
            _a.sent();

            ifcHandlerRef.current = ifcHandler; // Analyze data

            verboseLog('Data extracted, starting analysis');
            analyzer.analyzeData(models);
            result = analyzer.getAnalyzedData();
            calculations = analyzer.getCalculations();

            if (result !== null) {
              hasTerrain = result.grundstuck.primitives.length > 0;
              setDisplayTerrainToggle(hasTerrain);
              hasPGGF = result.helperPrimitives.PGGF.triangles.length > 0;
              setDisplayPGGFToggle(hasPGGF);
              hasGeschosse = result.geschosse.primitives.length > 0;
              setDisplayGeschosseToggle(hasGeschosse);
              hasInnenraumen = result.innenraumen.primitives.length > 0;
              setDisplayInnenraumenToggle(hasInnenraumen);
              hasAussenflachen = result.aussenflachen.primitives.length > 0;
              setDisplayAussenflachenToggle(hasAussenflachen);
              hasVolumen = result.volumen.primitives.length > 0;
              setDisplayVolumenToggle(hasVolumen);
              hasSondernutzungen = result.sondernutzung.primitives.length > 0;
              setDisplaySondernutzungToggle(hasSondernutzungen);

              if (isVerbose) {
                analyzer.printClassificationArrays();
                analyzer.printCalculations();
                analyzer.printFloorMeasurements();
                analyzer.printUsageMeasurements();
              }
            } else {
              verboseLog('Analysis provided no result!');
            }

            verboseLog('Analysis completed');
            completeResult = {
              models: models,
              analysis: result,
              calculations: calculations
            };
            return [2
            /*return*/
            , completeResult];

          case 5:
            _a.sent();

            result = {
              models: [],
              analysis: null,
              calculations: {
                quantities: [],
                floorsCalculations: [],
                floorAreas: [],
                messages: messages,
                usageCalculations: []
              }
            };
            return [2
            /*return*/
            , result];

          case 6:
            return [2
            /*return*/
            ];
        }
      });
    });
  }
  /**
   * Function to return the calculations to the host component
   */


  var deliverCalculations = useCallback(function (calculations) {
    return onCalculated(calculations);
  }, [onCalculated]);
  /**
   * Hook that listens to file changes from parent component.
   * After each file change the core functionality to handle the
   * new file is started. The hook is ensured to be executed only
   * once when a different file is uploaded by comparing the new
   * file with the previous uploaded file.
   */

  useInitBuildingViewer(IFC_CANVAS_ID, file, renderingSystemRef, readAndAnalyzeFile, deliverCalculations, verboseLog);

  var handleMenuButton = function handleMenuButton() {
    var buttonEl = document.getElementById(MENU_BUTTON_ID);
    buttonEl.classList.toggle('menu-open');
    setDisplayToggles(function (prev) {
      return !prev;
    });
  };

  var handleToggleCategory = function handleToggleCategory(showGroup, groupName) {
    var groupID = "" + GROUP_ID_PREFIX + groupName;
    showGroup ? renderingSystemRef.current.showGroup(groupID) : renderingSystemRef.current.hideGroup(groupID);
  };

  return React.createElement("div", {
    className: "ifc-viewer container"
  }, React.createElement("div", {
    className: "action-bar"
  }, React.createElement("button", {
    id: MENU_BUTTON_ID,
    className: "menu-button",
    onClick: handleMenuButton
  }), displayToggles && React.createElement("div", null, displayTerrainToggle && React.createElement(Toggle, {
    id: "terrain",
    label: TOGGLE_TERRAIN_LABEL,
    onChange: function onChange(event) {
      return handleToggleCategory(event.target.checked, getClassAsString(CRB_CLASS.GRUNDSTUCK));
    }
  }), displayPGGFToggle && React.createElement(Toggle, {
    id: "pggf",
    label: TOGGLE_BUILDING_FOOTPRINT_LABEL,
    onChange: function onChange(event) {
      return handleToggleCategory(event.target.checked, GROUP_ID_BUILDING_FOOTPRINT);
    }
  }), displayGeschosseToggle && React.createElement(Toggle, {
    id: "geschosse",
    label: TOGGLE_GESCHOSSE_LABEL,
    onChange: function onChange(event) {
      return handleToggleCategory(event.target.checked, getClassAsString(CRB_CLASS.GESCHOSSE));
    }
  }), displayInnenraumenToggle && React.createElement(Toggle, {
    id: "innenraume",
    label: TOGGLE_INNENRAUME_LABEL,
    onChange: function onChange(event) {
      return handleToggleCategory(event.target.checked, getClassAsString(CRB_CLASS.INNENRAUME));
    }
  }), displayAussenflachenToggle && React.createElement(Toggle, {
    id: "aussenflachen",
    label: TOGGLE_AUSSENFLACHEN_LABEL,
    onChange: function onChange(event) {
      return handleToggleCategory(event.target.checked, getClassAsString(CRB_CLASS.AUSSENFLACHEN));
    }
  }), displayVolumenToggle && React.createElement(Toggle, {
    id: "volumen",
    label: TOGGLE_VOLUMEN_LABEL,
    onChange: function onChange(event) {
      return handleToggleCategory(event.target.checked, getClassAsString(CRB_CLASS.VOLUMEN));
    }
  }), displaySondernutzungToggle && React.createElement(Toggle, {
    id: "sondernutzung",
    label: TOGGLE_SONDERNUTZUNG_LABEL,
    onChange: function onChange(event) {
      return handleToggleCategory(event.target.checked, getClassAsString(CRB_CLASS.SONDERNUTZUNG));
    }
  }))), React.createElement(Viewer, {
    canvasId: IFC_CANVAS_ID,
    className: "canvas"
  }));
}

var css_248z$1 = ".building-plan {\n  width: 100%;\n  height: 100%;\n}\n\n.ifc-viewer .container {\n  position: relative;\n}\n\n.ifc-viewer .action-bar {\n  position: absolute;\n  padding-block: 1.25rem;\n  padding-inline: 1rem;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n}\n.ifc-viewer .menu-button {\n  border: none;\n  background-color: transparent;\n  height: 1rem;\n  cursor: pointer;\n}\n.ifc-viewer button.menu-button:before,\n.ifc-viewer button.menu-button:after {\n  content: \"\";\n  display: block;\n  width: 1rem;\n  height: 1px;\n  border: none;\n  background-color: #616161;\n  transition: all 0.3s ease;\n}\n.ifc-viewer button.menu-button:before {\n  transform: translateY(0.2rem);\n}\n.ifc-viewer button.menu-button:after {\n  transform: translateY(-0.2rem);\n}\n.ifc-viewer button.menu-button.menu-open:before {\n  transform: translate(0, 0.05rem) rotate(-45deg);\n}\n.ifc-viewer button.menu-button.menu-open:after {\n  transform: translate(0, -0.05rem) rotate(45deg);\n}\n.ifc-viewer .canvas {\n  position: absolute;\n  z-index: 1;\n}\n\n.toggle-button {\n  display: flex;\n  align-items: center;\n  margin-block: 1.5rem;\n}\n\n.toggle-input {\n  display: none;\n}\n\n.toggle-label {\n  display: flex;\n  align-items: center;\n  width: 40px;\n  height: 20px;\n  background-color: #ccc;\n  border-radius: 1.5rem;\n  cursor: pointer;\n  position: relative;\n}\n.toggle-label .label-text {\n  padding-left: 3rem;\n  padding-block: 1rem;\n}\n\n.disabled {\n  color: #ccc;\n}\n\n.toggle-label:before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 1rem;\n  height: 1rem;\n  background-color: white;\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n}\n\n.toggle-input:checked + .toggle-label {\n  background-color: #91bdb8;\n}\n\n.toggle-input:checked + .toggle-label:before {\n  transform: translateX(20px);\n}";
styleInject(css_248z$1);

function BuildingPlanIfc(_a) {
  var file = _a.file,
      onCalculated = _a.onCalculated,
      _b = _a.isVerbose,
      isVerbose = _b === void 0 ? false : _b;

  var _c = __read(useState(_assign(_assign({}, DEFAULT_CONTEXT), {
    isVerbose: isVerbose
  })), 2),
      context = _c[0],
      setContext = _c[1]; // Enable shortcut to activate/deactivate debug mode


  useKeyboardShortcut('KeyD', function () {
    setContext(_assign(_assign({}, context), {
      isDebugMode: !context.isDebugMode
    }));
  });
  return React.createElement(IfcComponentContext.Provider, {
    value: context
  }, React.createElement("div", {
    id: "building-plan",
    className: "building-plan"
  }, React.createElement(BuildingViewer, {
    file: file,
    onCalculated: onCalculated
  })));
}

var SUPPORTED_FORMATS;

(function (SUPPORTED_FORMATS) {
  SUPPORTED_FORMATS["DXF"] = "dxf";
  SUPPORTED_FORMATS["IFC"] = "ifc";
})(SUPPORTED_FORMATS || (SUPPORTED_FORMATS = {}));
/**
 * Calculates the updates and returns it.
 *
 * @param projectData The input data
 * @returns The updated data
 */


function doCalculations(projectData) {
  var space = projectData.width * projectData.depth;
  var volume = space * 5;
  return {
    totalFloorSpace: space,
    totalVolume: volume
  };
}

export { AUSSENFLACHEN_CLASS, BUILDING_FOOTPRINT_MATERIAL, BUILDING_MODEL_ID_PREFIX, BuildingPlanDxf, BuildingPlanIfc, CRB_CLASS, CRB_CLASSES_BY_DE_CODES, CRB_CODE, CRB_CODE_DE, CRB_DE_CODE_BY_CODES, ColorPalette, DEBUG_MODEL_ID_PREFIX, DEFAULT_CONTEXT, DEFAULT_CRB_CLASS, DEFAULT_CRB_CODE, GESCHOSSE_CLASS, GROUP_ID_BUILDING_FOOTPRINT, GROUP_ID_PREFIX, GRUNDSTUCK_CLASS, HELPER_PRIMITIVES_ID_PREFIX, IFC_CANVAS_ID, INNENRAUME_CLASS, IfcComponentContext, MENU_BUTTON_ID, PRIMITIVES_ID_PREFIX, SONDERNUTZUNG_CLASS, SUPPORTED_FORMATS, TERRAIN_SURFACE_MATERIAL, TOGGLE_AUSSENFLACHEN_LABEL, TOGGLE_BUILDING_FOOTPRINT_LABEL, TOGGLE_GESCHOSSE_LABEL, TOGGLE_INNENRAUME_LABEL, TOGGLE_SONDERNUTZUNG_LABEL, TOGGLE_TERRAIN_LABEL, TOGGLE_VOLUMEN_LABEL, VOLUMEN_CLASS, doCalculations, getClassAsString, getCodeAsString, getDeCodeAsString };